(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 6003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "APP_SOCIAL_URL": function() { return /* binding */ APP_SOCIAL_URL; },
/* harmony export */   "COOKIES": function() { return /* binding */ COOKIES; },
/* harmony export */   "DEVICE_ID_BRIDGE_STATE": function() { return /* binding */ DEVICE_ID_BRIDGE_STATE; },
/* harmony export */   "DEVICE_MODEL_TYPE": function() { return /* binding */ DEVICE_MODEL_TYPE; },
/* harmony export */   "DOMAIN": function() { return /* binding */ DOMAIN; },
/* harmony export */   "GET_SLT_TOKEN_URL": function() { return /* binding */ GET_SLT_TOKEN_URL; },
/* harmony export */   "LOB_CATEGORY": function() { return /* binding */ LOB_CATEGORY; },
/* harmony export */   "PARTNER": function() { return /* binding */ PARTNER; },
/* harmony export */   "PARTNER_URLS": function() { return /* binding */ PARTNER_URLS; },
/* harmony export */   "PLATFORM": function() { return /* binding */ PLATFORM; },
/* harmony export */   "QUERY_PARAM_KEYS": function() { return /* binding */ QUERY_PARAM_KEYS; },
/* harmony export */   "SESSION_STORAGE_KEYS": function() { return /* binding */ SESSION_STORAGE_KEYS; },
/* harmony export */   "SOURCE": function() { return /* binding */ SOURCE; },
/* harmony export */   "SUB_DOMAIN": function() { return /* binding */ SUB_DOMAIN; },
/* harmony export */   "States": function() { return /* binding */ States; },
/* harmony export */   "URL_PATTERNS": function() { return /* binding */ URL_PATTERNS; },
/* harmony export */   "VALIDATION_MESSAGES": function() { return /* binding */ VALIDATION_MESSAGES; },
/* harmony export */   "camelToSnakeCase": function() { return /* binding */ camelToSnakeCase; },
/* harmony export */   "createSmartNavigator": function() { return /* binding */ createSmartNavigator; },
/* harmony export */   "deepCopy": function() { return /* binding */ deepCopy; },
/* harmony export */   "deleteLocalStorage": function() { return /* binding */ deleteLocalStorage; },
/* harmony export */   "disableEncrytionInWeb": function() { return /* binding */ disableEncrytionInWeb; },
/* harmony export */   "extractVariableValues": function() { return /* binding */ extractVariableValues; },
/* harmony export */   "extractVariables": function() { return /* binding */ extractVariables; },
/* harmony export */   "fetchWithTimeout": function() { return /* binding */ fetchWithTimeout; },
/* harmony export */   "floorWithoutDecimal": function() { return /* binding */ floorWithoutDecimal; },
/* harmony export */   "formatRateForDisplay": function() { return /* binding */ formatRateForDisplay; },
/* harmony export */   "generateUUID": function() { return /* binding */ generateUUID; },
/* harmony export */   "getCookie": function() { return /* binding */ getCookie; },
/* harmony export */   "getDefaultHeaders": function() { return /* binding */ getDefaultHeaders; },
/* harmony export */   "getDeviceId": function() { return /* binding */ getDeviceId; },
/* harmony export */   "getDeviceIdStatus": function() { return /* binding */ getDeviceIdStatus; },
/* harmony export */   "getDeviceIdWeb": function() { return /* binding */ getDeviceIdWeb; },
/* harmony export */   "getDeviceModelType": function() { return /* binding */ getDeviceModelType; },
/* harmony export */   "getDeviceType": function() { return /* binding */ getDeviceType; },
/* harmony export */   "getDeviceTypeV2": function() { return /* binding */ getDeviceTypeV2; },
/* harmony export */   "getHomeUrlByHostname": function() { return /* binding */ getHomeUrlByHostname; },
/* harmony export */   "getHostName": function() { return /* binding */ getHostName; },
/* harmony export */   "getJourneyIdFromCookie": function() { return /* binding */ getJourneyIdFromCookie; },
/* harmony export */   "getLastUrlSegment": function() { return /* binding */ getLastUrlSegment; },
/* harmony export */   "getLocalStorage": function() { return /* binding */ getLocalStorage; },
/* harmony export */   "getPageName": function() { return /* binding */ getPageName; },
/* harmony export */   "getPageUrl": function() { return /* binding */ getPageUrl; },
/* harmony export */   "getPartner": function() { return /* binding */ getPartner; },
/* harmony export */   "getPlatform": function() { return /* binding */ getPlatform; },
/* harmony export */   "getProductTypeFromPath": function() { return /* binding */ getProductTypeFromPath; },
/* harmony export */   "getSessionPiiDataOpts": function() { return /* binding */ getSessionPiiDataOpts; },
/* harmony export */   "getSessionStorageItem": function() { return /* binding */ getSessionStorageItem; },
/* harmony export */   "getUtilOptions": function() { return /* binding */ getUtilOptions; },
/* harmony export */   "getUtmParamsFromCookies": function() { return /* binding */ getUtmParamsFromCookies; },
/* harmony export */   "getVisitorId": function() { return /* binding */ getVisitorId; },
/* harmony export */   "hasCamelCaseKeys": function() { return /* binding */ hasCamelCaseKeys; },
/* harmony export */   "hasSnakeCaseKeys": function() { return /* binding */ hasSnakeCaseKeys; },
/* harmony export */   "hydrateVars": function() { return /* binding */ hydrateVars; },
/* harmony export */   "isApp": function() { return /* binding */ isApp; },
/* harmony export */   "isArray": function() { return /* binding */ isArray; },
/* harmony export */   "isEmptyObject": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "isHostGI": function() { return /* binding */ isHostGI; },
/* harmony export */   "isHostMMT": function() { return /* binding */ isHostMMT; },
/* harmony export */   "isMobile": function() { return /* binding */ isMobile; },
/* harmony export */   "isNull": function() { return /* binding */ isNull; },
/* harmony export */   "isNullOrEmptyValue": function() { return /* binding */ isNullOrEmptyValue; },
/* harmony export */   "isNullOrUndefined": function() { return /* binding */ isNullOrUndefined; },
/* harmony export */   "isObject": function() { return /* binding */ isObject; },
/* harmony export */   "isOnServer": function() { return /* binding */ isOnServer; },
/* harmony export */   "isPartnerHost": function() { return /* binding */ isPartnerHost; },
/* harmony export */   "isUndefined": function() { return /* binding */ isUndefined; },
/* harmony export */   "loadGTM": function() { return /* binding */ loadGTM; },
/* harmony export */   "mergeObjects": function() { return /* binding */ mergeObjects; },
/* harmony export */   "parseSeoUrl": function() { return /* binding */ parseSeoUrl; },
/* harmony export */   "redirectTo": function() { return /* binding */ redirectTo; },
/* harmony export */   "redirectWithDeferredTime": function() { return /* binding */ redirectWithDeferredTime; },
/* harmony export */   "regenerateTokenOnExpiry": function() { return /* binding */ regenerateTokenOnExpiry; },
/* harmony export */   "removeCookie": function() { return /* binding */ removeCookie; },
/* harmony export */   "removeEmptyKeys": function() { return /* binding */ removeEmptyKeys; },
/* harmony export */   "removeNullableField": function() { return /* binding */ removeNullableField; },
/* harmony export */   "removeSessionStorageItem": function() { return /* binding */ removeSessionStorageItem; },
/* harmony export */   "reviewPageViewEvent": function() { return /* binding */ reviewPageViewEvent; },
/* harmony export */   "roundAndIndianFormat": function() { return /* binding */ roundAndIndianFormat; },
/* harmony export */   "roundWithoutDecimal": function() { return /* binding */ roundWithoutDecimal; },
/* harmony export */   "setCookie": function() { return /* binding */ setCookie; },
/* harmony export */   "setJourneyIdCookie": function() { return /* binding */ setJourneyIdCookie; },
/* harmony export */   "setLocalStorage": function() { return /* binding */ setLocalStorage; },
/* harmony export */   "setSeoUtmParamsInSessionStorage": function() { return /* binding */ setSeoUtmParamsInSessionStorage; },
/* harmony export */   "setSessionPiiDataOpts": function() { return /* binding */ setSessionPiiDataOpts; },
/* harmony export */   "setSessionStorageItem": function() { return /* binding */ setSessionStorageItem; },
/* harmony export */   "setUtmParamsInUrl": function() { return /* binding */ setUtmParamsInUrl; },
/* harmony export */   "snakeToCamelCase": function() { return /* binding */ snakeToCamelCase; },
/* harmony export */   "toIndianLocaleFormat": function() { return /* binding */ toIndianLocaleFormat; },
/* harmony export */   "toLocaleStringINRFormat": function() { return /* binding */ toLocaleStringINRFormat; },
/* harmony export */   "transformToCamelCase": function() { return /* binding */ transformToCamelCase; },
/* harmony export */   "transformToSnakeCase": function() { return /* binding */ transformToSnakeCase; }
/* harmony export */ });
/* harmony import */ var _tm_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4178);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8131);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(156);
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8456);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8277);
/* harmony import */ var MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4__);
// libs/core-utils/src/lib/utils/authUtils/index.ts

async function regenerateTokenOnExpiry() {
  try {
    await (0,_tm_auth__WEBPACK_IMPORTED_MODULE_0__.loginIfPartnerLoggedin)();
    const isNowLoggedIn = await (0,_tm_auth__WEBPACK_IMPORTED_MODULE_0__.isUserLoggedin)();
    if (isNowLoggedIn) {
      console.log("Token regenerated successfully");
      return true;
    } else {
      console.warn("Token regeneration failed - user still not logged in");
      return false;
    }
  } catch (error) {
    console.error("Error during token regeneration:", error);
    return false;
  }
}

// libs/core-utils/src/lib/utils/fetchApi/index.ts
var getUpdatedAuthHeaders = () => {
  const updatedHeaders = {};
  if (typeof document !== "undefined") {
    const cookies = document.cookie.split(";").reduce(
      (acc, cookie) => {
        const [key, value] = cookie.trim().split("=");
        if (key && value) {
          acc[key] = decodeURIComponent(value);
        }
        return acc;
      },
      {}
    );
    if (cookies["mmt-auth"]) {
      updatedHeaders["mmt-auth"] = cookies["mmt-auth"];
    }
    if (cookies["x-tm-auth"]) {
      updatedHeaders["x-tm-auth"] = cookies["x-tm-auth"];
    }
  }
  return updatedHeaders;
};
var fetchWithTimeout = async (url, options, timeout = 1e4) => {
  const controller = new AbortController();
  const { signal } = controller;
  const fetchWithRetry = async (retry, updateAuthHeaders = false) => {
    let fetchOptions = retry ? { ...options, signal, headers: { ...options.headers, retry: "1" } } : { ...options, signal };
    if (updateAuthHeaders) {
      const updatedAuthHeaders = getUpdatedAuthHeaders();
      fetchOptions = {
        ...fetchOptions,
        headers: { ...fetchOptions.headers, ...updatedAuthHeaders }
      };
    }
    const fetchPromise = fetch(url, fetchOptions);
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    try {
      const response2 = await fetchPromise;
      clearTimeout(timeoutId);
      return response2;
    } catch (error) {
      clearTimeout(timeoutId);
      if (error instanceof Error && error.name === "AbortError") {
        throw new Error("failed to fetch");
      }
      throw error;
    }
  };
  const handleTokenExpiryAndRetry = async (response2, context) => {
    try {
      const responseClone = response2.clone();
      const data = await responseClone.json();
      if (data?.apiData?.user?.is_tm_auth_expired === true) {
        console.log(
          `Token expired detected in ${context} response, regenerating...`
        );
        const tokenRegenerated = await regenerateTokenOnExpiry();
        if (tokenRegenerated) {
          console.log("Token regenerated, retrying original request...");
          const newResponse = await fetchWithRetry(true, true);
          return newResponse;
        } else {
          console.warn("Token regeneration failed");
          return response2;
        }
      }
      return response2;
    } catch (error) {
      console.debug(
        `Could not parse ${context} response for token expiry check:`,
        error
      );
      return response2;
    }
  };
  let response = await fetchWithRetry(false);
  if (!response.ok) {
    const responseClone = response.clone();
    const data = await responseClone.json();
    if (data?.apiData?.user?.is_tm_auth_expired) {
      response = await handleTokenExpiryAndRetry(
        response,
        response.ok ? "successful" : "failed"
      );
    } else {
      response = await fetchWithRetry(true);
    }
  } else {
    response = await handleTokenExpiryAndRetry(
      response,
      response.ok ? "successful" : "failed"
    );
  }
  return response;
};

// libs/core-utils/src/lib/constants/partner.ts
var PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown"
};

// libs/core-utils/src/lib/utils/hostUtils/index.ts
function isOnServer() {
  if (typeof window === "undefined") {
    return true;
  }
  return false;
}
function isHostMMT() {
  if (isOnServer()) {
    return null;
  }
  if (window?.location?.hostname?.includes("makemytrip")) {
    return true;
  }
  return false;
}
function isHostGI() {
  if (isOnServer()) {
    return null;
  }
  if (window?.location?.hostname?.includes("goibibo")) {
    return true;
  }
  return false;
}
function getHostName() {
  if (isOnServer()) {
    return null;
  }
  return window.location.hostname;
}
var isPartnerHost = (partner) => {
  const hostname = getHostName() || "";
  return hostname.includes(partner);
};
function getPartner() {
  if (isOnServer()) {
    return "";
  }
  if (isHostMMT()) {
    return PARTNER.MMT;
  } else if (isHostGI()) {
    return PARTNER.GI;
  } else {
    return PARTNER.MMT;
  }
}

// libs/core-utils/src/lib/constants/index.ts
var PLATFORM = /* @__PURE__ */ ((PLATFORM2) => {
  PLATFORM2["PWA"] = "pwa";
  PLATFORM2["DESKTOP"] = "desktop";
  PLATFORM2["APP"] = "app";
  return PLATFORM2;
})(PLATFORM || {});
var DEVICE_MODEL_TYPE = /* @__PURE__ */ ((DEVICE_MODEL_TYPE2) => {
  DEVICE_MODEL_TYPE2["APP"] = "App";
  DEVICE_MODEL_TYPE2["WEB"] = "Web";
  return DEVICE_MODEL_TYPE2;
})(DEVICE_MODEL_TYPE || {});
var SOURCE = {
  TRIPMONEY: "tripmoney",
  MAKEMYTRIP: "makemytrip",
  GOIBIBO: "goibibo",
  LOCALHOST: "localhost",
  FOREX_EXPERT: "forexexpert"
};
var COOKIES = {
  MMT_AUTH_KEY: "mmt-auth",
  TM_AUTH_KEY: "x-tm-auth",
  MMT_LOGIN_REDIRECT_KEY: "loginActionDetails",
  TM_MMT_AUTH_KEY: "tm-mmt-auth",
  GI_AUTH_KEY: "OAUTH-GOIBIBO",
  TM_GI_AUTH_KEY: "tm-gi-auth",
  INR_SESSION_COOKIE: "is-initial-landing",
  MMT_DEVICE_ID: "dvid",
  GI_DEVICE_ID: "__gi_vid",
  MMT_FOREX_COOKIE: "mmt_forex",
  CURRENCY_DEEPLOGIN_ALLOWED: "currency_deeplogin_allowed",
  PDT_JOURNEY_ID: "x-jo-id",
  CROSS_SELL_FLOW: "cross_sell_flow",
  CROSS_SELL_NUDGE_SHOWN: "cross_sell_nudge_shown",
  FOREX_AGENT_AUTH_KEY: typeof window !== "undefined" && window?.location?.hostname?.includes("makemytrip") ? "mmt-auth-afftmfxmmtforexexp" : "mmt-auth-afftmfxgiforexexp",
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign"
};
var SUB_DOMAIN = {
  MAKEMYTRIP: ".makemytrip.com",
  GOIBIBO: ".goibibo.com",
  TRIPMONEY: ".tripmoney.com",
  LOCALHOST: "localhost"
};
var DOMAIN = {
  MAKEMYTRIP: "www.makemytrip.com"
};
var SESSION_STORAGE_KEYS = {
  USER_LOCATION_SESSION_KEY: "user_location",
  REQUEST_ID: "request_id",
  IS_FALLBACK_CITY_MODE: "is_fallback_city_mode",
  ITINERARY_ID: "itinerary_id",
  TICKET_ID: "ticket_id",
  FOREX_EXPERIMENTS: "forex_experiments",
  SOURCE_REACT_NATIVE: "rn"
};
var QUERY_PARAM_KEYS = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  USER_LOCATION: "user_location"
};
var getSessionPiiDataOpts = { isPiiData: true, shouldParseJson: true };
var setSessionPiiDataOpts = {
  isPiiData: true,
  shouldStringifyJson: true
};
var DEVICE_ID_BRIDGE_STATE = {
  AVAILABLE: "AVAILABLE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  NON_FUNCTIONAL: "NON_FUNCTIONAL"
};
var LOB_CATEGORY = {
  PC: "PC",
  CN: "CN"
};
var URL_PATTERNS = {
  PRODUCT_TYPE_REGEX: /\/forex\/(pc|cn)\//i
};
var PARTNER_URLS = {
  MMT: {
    FOREX_HOME: "https://www.makemytrip.com/forex"
  },
  GOIBIBO: {
    FOREX_HOME: "https://tripmoney.goibibo.com/partners/gi/forex/listing"
  }
};
var States = /* @__PURE__ */ ((States2) => {
  States2["PRELOADING"] = "PRELOADING";
  States2["LOADING"] = "LOADING";
  States2["SUCCESS"] = "SUCCESS";
  States2["FAILURE"] = "FAILURE";
  return States2;
})(States || {});

// libs/core-utils/src/lib/utils/mmt-ui-utils/cookieUtils.ts


// libs/core-utils/src/lib/utils/mmt-ui-utils/clientStorageUtils.ts



// libs/core-utils/src/lib/utils/deviceUtils/deviceDetection.ts
var isMobile = function() {
  let check = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      a
    ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|acer|aos|aiko|airn|alav|alca|alco|amoi|anex|anny|anyw|aptu|arch|argo|aste|asus|attw|audi|aurm|aur|avan|beck|bell|bnq|bilb|bird|blac|blaz|brew|bumb|bwn|bwu|c55|capi|ccwa|cdm|cell|chtm|cldc|cmd|comp|cond|craw|dait|dall|dang|dbte|dcs|devi|dica|dmob|doc|dopo|ds12|dsd|el49|elai|eml2|emul|eric|erk0|esl8|ez40|ezos|ezwa|ezze|fetc|fly|g1 u|g560|gene|gf5|gmo|gow|good|grad|grun|haie|hcit|hdm|hdp|hdt|hei|hipt|hita|hpi|hip|hsc|htc|htp|hua|htc|i20|igo|ima|i230|iac|iac|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|jat|java|jbro|jemu|jigs|kddi|keji|kgt|klon|kpt|kwc|kyoc|leno|lexi|lg g|lgk|lgl|lgu|lg50|lg54|libw|lynx|m1w|m3ga|m50|mate|maiu|maxo|mc01|mc21|mca|mcr|merc|meri|mio8|mioa|mits|mmef|mo01|mo02|mobi|mode|modo|mot|mov|mozz|mt50|mtp1|mv|mwbp|mywa|n100|n101|n102|n202|n203|n300|n302|n500|n502|n505|n700|n701|n710|nec|nem|neon|netf|new|nokia|nzph|o2im|opti|opwv|oran|owg1|p800|pana|pand|pant|pdxg|pg13|pg1|pg2|pg3|pg4|pg5|pg6|pg7|pg8|pgc|phil|pire|play|pluc|pn2|pock|port|pose|prox|psio|ptg|qaa|qc07|qc12|qc21|qc32|qc60|qc2|qc3|qc4|qc5|qc6|qc7|qi|qtek|r380|r600|raks|rim9|rove|rozo|s55|sage|sama|samm|sams|sany|sava|sc01|sch|scoo|scp|sdk|sec|sec0|sec1|sec47|secm|send|seri|sgh|shar|siem|sk0|sl45|slid|smal|smar|smb3|smitt|smtt|soft|sony|sp01|sph|spv|spv|sy01|symb|t218|t250|t600|t610|t618|tagt|talk|tcl|tdg|teli|telm|tim|tmo|topl|tosh|ts70|tsm|tsm3|tsm5|tx9|upb|upg1|upsi|utst|v400|v750|veri|virg|vite|vk40|vk50|vk51|vk52|vk53|vkv|vm40|voda|vulc|vx52|vx53|vx60|vx61|vx70|vx80|vx81|vx83|vx85|vx98|w3c|webc|whit|wig|winc|winw|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
      a ? a.substr(0, 4) : null
    ))
      check = true;
  })(
    !isOnServer() ? navigator.userAgent || navigator.vendor || window.opera : null
  );
  return check;
};
var getDeviceType = () => {
  if (isOnServer())
    return null;
  return isMobile() ? "App" /* APP */ : "Web" /* WEB */;
};
var getDeviceTypeV2 = () => {
  if (isOnServer())
    return null;
  if (window?.mmt_android_bridge || window?.app_bridge) {
    return "App" /* APP */;
  }
  return "Web" /* WEB */;
};
function getPlatform() {
  if (isOnServer())
    return null;
  const deviceType = getDeviceTypeV2();
  if (deviceType === "Web" /* WEB */) {
    if (isMobile()) {
      return "pwa" /* PWA */;
    }
    return "desktop" /* DESKTOP */;
  }
  return "app" /* APP */;
}
var isApp = () => {
  if (isOnServer()) {
    return false;
  }
  return window?.app_bridge || window?.webkit?.messageHandlers?.login ? true : false;
};

// libs/core-utils/src/lib/utils/urlUtils/index.ts
function getProductTypeFromPath() {
  if (isOnServer()) {
    return null;
  }
  const urlPath = window.location.pathname;
  const match = urlPath.match(URL_PATTERNS.PRODUCT_TYPE_REGEX);
  if (match) {
    const productCode = match[1].toUpperCase();
    if (Object.values(LOB_CATEGORY)?.includes(productCode)) {
      return productCode;
    }
  }
  return null;
}
function createSmartNavigator(router) {
  return (url) => {
    if (isOnServer()) {
      return;
    }
    if (router) {
      router.push(url);
      return;
    }
    console.warn("Next.js Router not available, using window.location");
    window.location.href = url;
  };
}
function getPageName() {
  if (isOnServer())
    return "";
  const pathname = window.location.pathname;
  function findValidSegment(segments) {
    if (segments.length === 0) {
      return "";
    }
    const lastSegment = segments[segments.length - 1];
    if (/^[a-zA-Z-]+$/.test(lastSegment)) {
      return lastSegment;
    } else {
      segments.pop();
      return findValidSegment(segments);
    }
  }
  try {
    const pathSegments = pathname.split("/").filter((segment) => segment !== "");
    return findValidSegment(pathSegments);
  } catch (e) {
    console.error(e?.message);
  }
  return window.location.pathname;
}
function getPageUrl() {
  if (isOnServer()) {
    return null;
  }
  return window.location.href;
}
var getUtmParamsFromCookies = () => {
  const utm_medium = getCookie(COOKIES.UTM_MEDIUM, false, { path: "/" });
  const utm_source = getCookie(COOKIES.UTM_SOURCE, false, { path: "/" });
  const utm_campaign = getCookie(COOKIES.UTM_CAMPAIGN, false, { path: "/" });
  return { utm_medium, utm_source, utm_campaign };
};
var setUtmParamsInUrl = (url) => {
  const { utm_medium, utm_source, utm_campaign } = getUtmParamsFromCookies();
  const urlObj = new URL(url);
  if (utm_medium)
    urlObj.searchParams.append(QUERY_PARAM_KEYS.UTM_MEDIUM, utm_medium);
  if (utm_source)
    urlObj.searchParams.append(QUERY_PARAM_KEYS.UTM_SOURCE, utm_source);
  if (utm_campaign)
    urlObj.searchParams.append(QUERY_PARAM_KEYS.UTM_CAMPAIGN, utm_campaign);
  return urlObj.toString();
};
function getHomeUrlByHostname() {
  if (isOnServer()) {
    return "/";
  }
  const hostname = window.location.hostname;
  if (hostname.includes("makemytrip.com")) {
    return PARTNER_URLS.MMT.FOREX_HOME;
  } else if (hostname.includes("goibibo.com")) {
    return PARTNER_URLS.GOIBIBO.FOREX_HOME;
  }
  return "/";
}
function getLastUrlSegment(pathname) {
  const currentPath = pathname || (typeof window !== "undefined" ? window.location.pathname : "");
  if (!currentPath)
    return "";
  const pathSegments = currentPath.split("/").filter((segment) => segment.length > 0);
  return pathSegments.at(-1) || "";
}

// libs/core-utils/src/lib/utils/mmt-ui-utils/clientStorageUtils.ts
function disableEncrytionInWeb() {
  return getDeviceType() === "Web" /* WEB */ && isHostMMT();
}
function getUtilOptions(options) {
  return disableEncrytionInWeb() ? { ...options, isPiiData: false } : options;
}
var { ES, N_ES } = MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.itemType;
function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
}
function setLocalStorage(key, value, isEssential = false, options = {
  shouldStringifyJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  (0,MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.setItem)(key, value, transformedOptions, itemTypeValue);
}
function getLocalStorage(key, isEssential = false, options = {
  shouldParseJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  return (0,MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.getItem)(key, transformedOptions, itemTypeValue);
}
function deleteLocalStorage(key) {
  (0,MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.removeItem)(key);
}
function setSessionStorageItem(key, value, isEssential = false, options = {
  shouldStringifyJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__.setItemBySession)(key, value, transformedOptions, itemTypeValue);
}
function getSessionStorageItem(key, isEssential = false, options = {
  shouldParseJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  return (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__.getItemBySession)(key, transformedOptions, itemTypeValue);
}
function removeSessionStorageItem(key) {
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__.removeItemBySession)(key);
}
function setSeoUtmParamsInSessionStorage(utm_source, utm_medium) {
  if (utm_source) {
    setSessionStorageItem("utm_source", utm_source, false);
  }
  if (utm_medium) {
    setSessionStorageItem("utm_medium", utm_medium, false);
  }
  const lastSegment = getLastUrlSegment();
  if (lastSegment) {
    setSessionStorageItem("utm_campaign", lastSegment, false);
  }
}

// libs/core-utils/src/lib/utils/mmt-ui-utils/cookieUtils.ts
var { ES: ES2, N_ES: N_ES2 } = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.itemType;
function getEssentialItemType2(isEssential) {
  return isEssential ? ES2 : N_ES2;
}
function setCookie(name, value, isEssential = false, options) {
  options = getUtilOptions(options);
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.setCookie)(name, value, options, getEssentialItemType2(isEssential));
}
function getCookie(name, isEssential = false, options = {}) {
  options = getUtilOptions(options);
  return (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.getCookie)(name, options, getEssentialItemType2(isEssential));
}
function removeCookie(name, options = {}) {
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.removeCookie)(name, options);
}

// libs/core-utils/src/lib/utils/mmt-ui-utils/visitorIdUtils.ts

var { getVisitorId } = (MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4___default());

// libs/core-utils/src/lib/utils/deviceUtils/index.ts
var getDeviceIdWeb = (partner) => {
  switch (partner) {
    case PARTNER.MMT:
      return getCookie(COOKIES.MMT_DEVICE_ID, true) || getVisitorId();
    case PARTNER.GI:
      return getCookie(COOKIES.GI_DEVICE_ID, true) || null;
    default:
      return null;
  }
};
var getDeviceModelType = () => {
  if (isOnServer())
    return null;
  if (window?.mmt_android_bridge || window?.app_bridge) {
    return "App" /* APP */;
  }
  return "Web" /* WEB */;
};
var getDeviceIdApp = () => {
  if (isOnServer()) {
    return null;
  }
  return window?.app_bridge?.deviceId?.() || null;
};
var getDeviceId = (partner) => {
  if (isOnServer()) {
    return null;
  }
  const deviceType = getDeviceTypeV2();
  if (deviceType === "Web" /* WEB */) {
    return getDeviceIdWeb(partner);
  } else if (deviceType === "App" /* APP */) {
    return getDeviceIdApp();
  }
  return null;
};
var getDeviceIdStatus = () => {
  if (isOnServer()) {
    return null;
  }
  if (isApp()) {
    if (window?.app_bridge?.deviceId) {
      if (window?.app_bridge?.deviceId?.()) {
        return DEVICE_ID_BRIDGE_STATE.AVAILABLE;
      } else {
        return DEVICE_ID_BRIDGE_STATE.NON_FUNCTIONAL;
      }
    } else {
      return DEVICE_ID_BRIDGE_STATE.NOT_AVAILABLE;
    }
  }
  return null;
};

// libs/core-utils/src/lib/utils/objectUtils/index.ts
function removeNullableField(obj) {
  let result = null;
  for (const [key, value] of Object.entries(obj)) {
    if (value != null) {
      if (!result)
        result = {};
      result[key] = value;
    }
  }
  return result;
}
function removeEmptyKeys(obj) {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value) {
      result[key] = value;
    }
  }
  return result;
}
function isObject(val) {
  const toStr = Object.prototype.toString;
  return toStr.call(val) === "[object Object]";
}
function isNull(val) {
  return val === null;
}
function isUndefined(val) {
  return val === void 0;
}
function isNullOrUndefined(val) {
  return isNull(val) || isUndefined(val);
}
function isEmptyObject(val) {
  if (!isObject(val)) {
    return false;
  }
  return Object.keys(val).length === 0;
}
function isNullOrEmptyValue(val) {
  return isNull(val) || isUndefined(val) || isEmptyObject(val) || Number.isNaN(val) || val === "";
}
function mergeObjects(obj1, obj2) {
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    return obj1.map((item, index) => {
      if (index < obj2.length) {
        return mergeObjects(item, obj2[index]);
      }
      return item;
    }).concat(obj2.slice(obj1.length));
  } else if (isObject(obj1) && isObject(obj2)) {
    const result = { ...obj1 };
    for (const key in obj2) {
      if (Object.prototype.hasOwnProperty.call(obj2, key)) {
        const val1 = result[key];
        const val2 = obj2[key];
        if (isObject(val1) && isObject(val2)) {
          result[key] = mergeObjects(val1, val2);
        } else if (Array.isArray(val1) && Array.isArray(val2)) {
          result[key] = mergeObjects(val1, val2);
        } else {
          result[key] = val2;
        }
      }
    }
    return result;
  } else {
    return obj2;
  }
}
function hydrateVars(input, overrideVars = {}) {
  if (Array.isArray(input)) {
    return input.map((item) => hydrateVars(item, overrideVars));
  } else if (typeof input === "object" && input !== null) {
    const hydratedObject = {};
    for (const key in input) {
      if (key === "vars" && typeof input[key] === "object") {
        for (const varKey in input[key]) {
          const varValue = overrideVars[varKey] || input[key][varKey];
          for (const innerKey in hydratedObject) {
            if (typeof hydratedObject[innerKey] === "string") {
              hydratedObject[innerKey] = hydratedObject[innerKey].replace(
                `{{${varKey}}}`,
                varValue
              );
            }
          }
        }
      } else {
        hydratedObject[key] = hydrateVars(input[key], overrideVars);
      }
    }
    return hydratedObject;
  } else if (typeof input === "string") {
    return input.replace(
      /\{\{([^}]+)\}\}/g,
      (match, p1) => overrideVars && p1.trim() in overrideVars ? String(overrideVars[p1.trim()]) : match
    );
  }
  return input;
}
function deepCopy(value, seen = /* @__PURE__ */ new WeakMap()) {
  if (value === null || typeof value !== "object") {
    return value;
  }
  if (seen.has(value)) {
    return seen.get(value);
  }
  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  if (value instanceof RegExp) {
    return new RegExp(value.source, value.flags);
  }
  if (value instanceof Map) {
    const copy2 = /* @__PURE__ */ new Map();
    seen.set(value, copy2);
    value.forEach((val, key) => {
      copy2.set(deepCopy(key, seen), deepCopy(val, seen));
    });
    return copy2;
  }
  if (value instanceof Set) {
    const copy2 = /* @__PURE__ */ new Set();
    seen.set(value, copy2);
    value.forEach((val) => {
      copy2.add(deepCopy(val, seen));
    });
    return copy2;
  }
  if (Array.isArray(value)) {
    const copy2 = [];
    seen.set(value, copy2);
    value.forEach((item, index) => {
      copy2[index] = deepCopy(item, seen);
    });
    return copy2;
  }
  const copy = {};
  seen.set(value, copy);
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      copy[key] = deepCopy(value[key], seen);
    }
  }
  return copy;
}
function snakeToCamelCase(str) {
  return str.replace(/(_\w)/g, (matches) => matches[1].toUpperCase());
}
function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
function transformToCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => transformToCamelCase(item));
  }
  if (obj !== null && typeof obj === "object") {
    const newObj = {};
    for (const key in obj) {
      const camelKey = snakeToCamelCase(key);
      newObj[camelKey] = transformToCamelCase(obj[key]);
    }
    return newObj;
  }
  return obj;
}
function transformToSnakeCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => transformToSnakeCase(item));
  }
  if (obj !== null && typeof obj === "object") {
    const newObj = {};
    for (const key in obj) {
      const snakeKey = camelToSnakeCase(key);
      newObj[snakeKey] = transformToSnakeCase(obj[key]);
    }
    return newObj;
  }
  return obj;
}
function hasSnakeCaseKeys(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return false;
  }
  for (const key in obj) {
    if (key.includes("_")) {
      return true;
    }
    if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
      if (hasSnakeCaseKeys(obj[key])) {
        return true;
      }
    }
  }
  return false;
}
function hasCamelCaseKeys(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return false;
  }
  for (const key in obj) {
    if (/[A-Z]/.test(key)) {
      return true;
    }
    if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
      if (hasCamelCaseKeys(obj[key])) {
        return true;
      }
    }
  }
  return false;
}
function extractVariableValues(variables) {
  if (!variables || typeof variables !== "object") {
    return {};
  }
  const result = {};
  for (const [key, variable] of Object.entries(variables)) {
    if (variable && typeof variable === "object" && "value" in variable) {
      result[key] = variable.value;
    }
  }
  return result;
}
function extractVariables(variables) {
  return extractVariableValues(variables);
}

// libs/core-utils/src/lib/utils/currencyUtils/index.ts
var toLocaleStringINRFormat = (currency, maximumFractionDigits = 2, minimumFractionDigits = 2) => {
  if (currency) {
    return Number(currency).toLocaleString("en-IN", {
      minimumFractionDigits: minimumFractionDigits > maximumFractionDigits ? 2 : minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits == 0 ? 0 : maximumFractionDigits > 2 ? maximumFractionDigits : 2
    });
  }
  return "0";
};
var formatRateForDisplay = (rate) => {
  const numericRate = Number(rate);
  if (isNaN(numericRate))
    return "";
  return numericRate > 1 ? numericRate.toFixed(2) : numericRate.toFixed(4);
};
var roundWithoutDecimal = (value) => {
  return Math.round(value);
};
var floorWithoutDecimal = (value) => {
  return Math.floor(value);
};
var toIndianLocaleFormat = (value) => {
  return new Intl.NumberFormat("en-IN").format(value);
};
var roundAndIndianFormat = (value) => {
  return toIndianLocaleFormat(roundWithoutDecimal(value));
};
var generateUUID = () => {
  let d = (/* @__PURE__ */ new Date()).getTime();
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    d += performance.now();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : r & 3 | 8).toString(16);
  });
};
var cityToPincodeMapping = {
  vijaywada: "509132",
  vadodara: "390001",
  thane: "400614",
  surat: "394101",
  ranchi: "829205",
  pune: "410301",
  patna: "800001",
  panvel: "410206",
  panchkula: "133301",
  "greater noida": "201308",
  "navi mumbai": "400702",
  mumbai: "400001",
  mohali: "140103",
  mangalore: "574141",
  ludhiana: "141001",
  lucknow: "226001",
  kozhikode: "673001",
  kolkata: "700001",
  kochi: "686667",
  kanpur: "208001",
  jalandhar: "144001",
  jhansi: "226010",
  jabalpur: "482001",
  hyderabad: "500001",
  guwahati: "781001",
  gurgaon: "122001",
  ghaziabad: "201001",
  faridabad: "121001",
  delhi: "110001",
  cuttack: "752120",
  coimbatore: "641001",
  chennai: "600001",
  chandigarh: "160001",
  bhubaneswar: "751001",
  bhopal: "462001",
  bareilly: "281001",
  bangalore: "560001",
  amritsar: "743001",
  ahmedabad: "380001",
  dehradun: "248199",
  indore: "453001",
  agra: "282001",
  visakhpatnam: "133002",
  rajkot: "380005",
  anand: "387310",
  raipur: "493116",
  jodhpur: "342001",
  karnal: "132001",
  madurai: "625501",
  mysore: "570016",
  nagpur: "440001",
  nasik: "422001",
  nawanshahar: "144514",
  thiruvananthapuram: "695001",
  udaipur: "307025",
  varanasi: "221001",
  aurangal: "506355",
  amaravati: "431151",
  goa: "403503",
  salem: "385102",
  patiala: "147001",
  shimla: "174001",
  jammu: "181152",
  kapurthala: "144001",
  hissar: "335129",
  kota: "324001",
  budaun: "283151",
  rudrapur: "324801"
};
var currencyNameToCodeMapping = {
  // Existing mappings
  "us-dollar": "USD",
  euro: "EUR",
  "canadian-dollar": "CAD",
  pound: "GBP",
  "australian-dollar": "AUD",
  dirham: "AED",
  "uae-dirham": "AED",
  // Alternative key for dirham
  "sri-lankan-rupee": "LKR",
  "south-african-rand": "ZAR",
  "thai-baht": "THB",
  "singapore-dollar": "SGD",
  "swiss-franc": "CHF",
  "hong-kong-dollar": "HKD",
  "saudi-riyal": "SAR",
  "saudi-arabian-riyal": "SAR",
  // Alternative key for saudi-riyal
  "norwegian-krone": "NOK",
  "japanese-yen": "JPY",
  "new-zealand-dollar": "NZD",
  "malaysian-ringgit": "MYR",
  "bahraini-dinar": "BHD",
  "russian-ruble": "RUB",
  "danish-krone": "DKK",
  "indonesian-rupiah": "IDR",
  "philippine-peso": "PHP",
  "vietnamese-dong": "VND",
  "mauritian-rupee": "MUR",
  "bangladeshi-taka": "BDT",
  "polish-zloty": "PLN",
  "korean-won": "KRW",
  "south-korean-won": "KRW",
  // Alternative key for korean-won
  // Additional currencies with proper mappings
  "kuwaiti-dinar": "KWD",
  "omani-rial": "OMR",
  "swedish-krona": "SEK",
  "maldivian-rufiyaa": "MVR",
  "macanese-pataca": "MOP",
  "qatari-riyal": "QAR",
  "turkish-lira": "TRY",
  "chinese-yuan-renminbi": "CNY",
  "egyptian-pound": "EGP",
  "brazilian-real": "BRL",
  "israeli-new-shekel": "ILS",
  "azerbaijani-manat": "AZN",
  "kenyan-shilling": "KES",
  "czech-koruna": "CZK",
  "georgian-lari": "GEL",
  // Currencies with USD fallback (no proper mapping available)
  "indian-rupee": "USD",
  // No mapping found - using USD
  "jordanian-dinar": "USD",
  // No mapping found - using USD
  "pakistani-rupee": "USD",
  // No mapping found - using USD
  "iranian-rial": "USD",
  // No mapping found - using USD
  "nepalese-rupee": "USD",
  // No mapping found - using USD
  "ukrainian-hryvnia": "USD",
  // No mapping found - using USD
  "iraqi-dinar": "USD",
  // No mapping found - using USD
  "mexican-peso": "USD",
  // No mapping found - using USD
  "fiji-dollar": "USD",
  // No mapping found - using USD
  "venezuelan-bolivar": "USD",
  // No mapping found - using USD
  "afghan-afghani": "USD",
  // No mapping found - using USD
  "brunei-dollar": "USD",
  // No mapping found - using USD
  "hungarian-forint": "USD",
  // No mapping found - using USD
  "new-taiwan-dollar": "USD",
  // No mapping found - using USD
  naira: "USD",
  // No mapping found - using USD
  "argentine-peso": "USD",
  // No mapping found - using USD
  "colombian-peso": "USD",
  // No mapping found - using USD
  "chilean-peso": "USD",
  // No mapping found - using USD
  "moroccan-dirham": "USD",
  // No mapping found - using USD
  "bulgarian-lev": "USD",
  // No mapping found - using USD
  "croatian-kuna": "USD",
  // No mapping found - using USD
  "east-caribbean-dollar": "USD",
  // No mapping found - using USD
  "ghana-cedi": "USD",
  // No mapping found - using USD
  "serbian-dinar": "USD",
  // No mapping found - using USD
  "ugandan-shilling": "USD",
  // No mapping found - using USD
  "zambian-kwacha": "USD",
  // No mapping found - using USD
  "belarusian-ruble": "USD",
  // No mapping found - using USD
  "bhutanese-ngultrum": "USD",
  // No mapping found - using USD
  "jamaican-dollar": "USD",
  // No mapping found - using USD
  "kazakhstani-tenge": "USD",
  // No mapping found - using USD
  "lebanese-pound": "USD",
  // No mapping found - using USD
  "romanian-leu": "USD",
  // No mapping found - using USD
  "angolan-kwanza": "USD",
  // No mapping found - using USD
  "bahamian-dollar": "USD",
  // No mapping found - using USD
  "cambodian-riel": "USD",
  // No mapping found - using USD
  "libyan-dinar": "USD",
  // No mapping found - using USD
  "tanzania-shilling": "USD",
  // No mapping found - using USD
  "algerian-dinar": "USD",
  // No mapping found - using USD
  "ethopian-birr": "USD",
  // No mapping found - using USD
  "myanmar-kyat": "USD",
  // No mapping found - using USD
  "dominican-peso": "USD",
  // No mapping found - using USD
  "yemeni-rial": "USD",
  // No mapping found - using USD
  "costa-rican-colon": "USD",
  // No mapping found - using USD
  "uruguayan-peso": "USD",
  // No mapping found - using USD
  "bolivian-boliviano": "USD",
  // No mapping found - using USD
  "guatemalan-quetzal": "USD",
  // No mapping found - using USD
  "honduran-lempira": "USD",
  // No mapping found - using USD
  "nuevo-sol": "USD"
  // No mapping found - using USD
};
var currencyCodeMapping = {
  pln: "PLN",
  // Polish Zloty
  krw: "KRW",
  // Korean Won
  idr: "IDR",
  // Indonesian Rupiah
  php: "PHP",
  // Philippine Peso
  vnd: "VND",
  // Vietnam Dong
  jpy: "JPY",
  // Japanese Yen
  nok: "NOK",
  // Norwegian Krone
  rub: "RUB",
  // Russian Ruble
  nzd: "NZD",
  // New Zealand Dollar
  mur: "MUR",
  // Mauritius Rupee
  thb: "THB",
  // Thai Baht
  aed: "AED",
  // UAE Dirham
  lkr: "LKR",
  // Sri Lankan Rupee
  myr: "MYR",
  // Malaysian Ringgit
  sgd: "SGD",
  // Singapore Dollar
  chf: "CHF",
  // Swiss Franc
  kwd: "KWD",
  // Kuwaiti Dinar
  eur: "EUR",
  // Euro
  zar: "ZAR",
  // South African Rand
  cad: "CAD",
  // Canadian Dollar
  hkd: "HKD",
  // Hong Kong Dollar
  sar: "SAR",
  // Saudi Riyal
  gbp: "GBP",
  // British Pound
  bdt: "BDT",
  // Bangladesh Taka
  bhd: "BHD",
  // Bahraini Dinar
  aud: "AUD",
  // Australian Dollar
  dkk: "DKK"
  // Danish Krone
};
function parseSeoUrl(pathname) {
  if (!pathname) {
    if (typeof window !== "undefined") {
      pathname = window.location.pathname;
    } else {
      return null;
    }
  }
  const cityExchangeMatch = pathname.match(
    /\/tripmoney\/currency-exchange-in-([^/]+)$/
  );
  if (cityExchangeMatch && cityExchangeMatch[1]) {
    const cityName = cityExchangeMatch[1].toLowerCase();
    const pincode = cityToPincodeMapping[cityName] || null;
    return {
      currencyCode: "USD",
      pincode
    };
  }
  const cityAirportExchangeMatch = pathname.match(
    /\/tripmoney\/currency-exchange-in-([^/]+)\/airport$/
  );
  if (cityAirportExchangeMatch && cityAirportExchangeMatch[1]) {
    const cityName = cityAirportExchangeMatch[1].toLowerCase();
    const pincode = cityToPincodeMapping[cityName] || null;
    return {
      currencyCode: "USD",
      pincode
    };
  }
  const cityAreaExchangeMatch = pathname.match(
    /\/tripmoney\/currency-exchange-in-([^/]+)\/([^/]+)$/
  );
  if (cityAreaExchangeMatch && cityAreaExchangeMatch[1]) {
    const cityName = cityAreaExchangeMatch[1].toLowerCase();
    const pincode = cityToPincodeMapping[cityName] || null;
    return {
      currencyCode: "USD",
      pincode
    };
  }
  const currencyRateMatch = pathname.match(/\/tripmoney\/currency\/(.+)-rate$/);
  if (currencyRateMatch && currencyRateMatch[1]) {
    const currencyName = currencyRateMatch[1];
    return {
      currencyCode: currencyNameToCodeMapping[currencyName] || "USD",
      pincode: null
    };
  }
  const currencyMatch = pathname.match(/\/tripmoney\/currency\/([^/]+)$/);
  if (currencyMatch && currencyMatch[1]) {
    const currencyName = currencyMatch[1];
    return {
      currencyCode: currencyNameToCodeMapping[currencyName] || "USD",
      pincode: null
    };
  }
  const converterWithAmountMatch = pathname.match(
    /\/tripmoney\/currency-converter\/([^-]+)-to-inr\/\d+-[^/]+$/
  );
  if (converterWithAmountMatch && converterWithAmountMatch[1]) {
    const currencyCode = converterWithAmountMatch[1].toLowerCase();
    return {
      currencyCode: currencyCodeMapping[currencyCode] || "USD",
      pincode: null
    };
  }
  const converterMatch = pathname.match(
    /\/tripmoney\/currency-converter\/([^-]+)-to-inr$/
  );
  if (converterMatch && converterMatch[1]) {
    const currencyCode = converterMatch[1].toLowerCase();
    return {
      currencyCode: currencyCodeMapping[currencyCode] || "USD",
      pincode: null
    };
  }
  return {
    currencyCode: "USD",
    pincode: null
  };
}

// libs/core-utils/src/lib/utils/headerUtils/index.ts
function getPdtBaseUrl() {
  return "https://pdt.makemytrip.com/dts/s/da/n";
}
function shouldIncludeExternalHeaders(url) {
  if (!url) {
    return false;
  }
  return url?.includes("/pdt") || url?.includes(APP_SOCIAL_URL(getPartner())) || url?.includes(GET_SLT_TOKEN_URL(getPartner())) || url?.includes(getPdtBaseUrl()) ? false : true;
}
function getDefaultHeaders(url) {
  const partner = isHostMMT() ? PARTNER.MMT : PARTNER.GI;
  const headers = {
    partner: getPartner() || "mmt",
    credentials: "include",
    org: getPartner() || "mmt",
    os: "Chrome",
    //'Android',
    // platform: getPlatform(), //'app', //commenting this as it is not required and also not whitelsited at Kong getting CORS error,
    "Content-Type": "application/json",
    deviceid: getDeviceId(partner) || "",
    "mmt-auth": getCookie(COOKIES.MMT_AUTH_KEY, true) || ""
  };
  if (shouldIncludeExternalHeaders(url)) {
    return headers;
  } else if (isPartnerHost(SOURCE.FOREX_EXPERT)) {
    headers["x-agent-auth"] = getCookie(COOKIES.FOREX_AGENT_AUTH_KEY, true) || "";
    headers["x-ticket-id"] = getSessionStorageItem("ticket_id", true) || "";
  } else {
    headers["x-tm-auth"] = getCookie(COOKIES.TM_AUTH_KEY, true) || "";
    headers[COOKIES.PDT_JOURNEY_ID] = getJourneyIdFromCookie(getPartner());
  }
  return headers;
}
var APP_SOCIAL_URL = (partner) => {
  const hostname = isHostMMT() ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return `${hostname}/ext/TripMoney/Forex/appSocialLogin`;
};
var GET_SLT_TOKEN_URL = (partner) => {
  const hostname = isHostMMT() ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return `${hostname}/ext/web/pwa/jwt/loginToken`;
};
function getJourneyIdFromCookie(partner) {
  if (partner === PARTNER.MMT) {
    return getCookie(COOKIES.PDT_JOURNEY_ID, true, {
      domain: `${SUB_DOMAIN.MAKEMYTRIP}`,
      path: "/"
    });
  } else if (partner === PARTNER.GI) {
    return getCookie(COOKIES.PDT_JOURNEY_ID, true, {
      domain: `${SUB_DOMAIN.GOIBIBO}`,
      path: "/"
    });
  }
  return void 0;
}
function setJourneyIdCookie({
  partner,
  journeyId
}) {
  const journeyIdCookie = getJourneyIdFromCookie(partner);
  if (!journeyIdCookie && journeyId) {
    const currentDate = /* @__PURE__ */ new Date();
    const expirationTime = new Date(currentDate.getTime() + 60 * 60 * 1e3);
    if (partner === PARTNER.MMT) {
      setCookie(COOKIES.PDT_JOURNEY_ID, journeyId, true, {
        expires: expirationTime.toUTCString(),
        domain: SUB_DOMAIN.MAKEMYTRIP,
        path: "/"
      });
    } else if (partner === PARTNER.GI) {
      setCookie(COOKIES.PDT_JOURNEY_ID, journeyId, true, {
        expires: expirationTime.toUTCString(),
        domain: SUB_DOMAIN.GOIBIBO,
        path: "/"
      });
    }
  }
}

// libs/core-utils/src/lib/utils/navigationUtils/index.ts
var redirectTo = (url, transformUrl) => {
  const transformedUrl = transformUrl(url);
  window.location.href = transformedUrl;
};
var redirectWithDeferredTime = (redirectFn, deferTime) => {
  if (deferTime) {
    const timerId = setTimeout(() => {
      redirectFn();
      clearTimeout(timerId);
    }, deferTime);
  } else {
    redirectFn();
  }
};

// libs/core-utils/src/validationMessages.ts
var VALIDATION_MESSAGES = {
  MOBILE: {
    REQUIRED: "Mobile number is required",
    INVALID: "Please enter a valid 10-digit mobile number"
  },
  EMAIL: {
    REQUIRED: "Email is required",
    INVALID: "Please enter a valid email address"
  },
  PAN: {
    REQUIRED: "PAN number is required",
    INVALID: "Please enter a valid PAN number"
  },
  FULL_NAME: {
    REQUIRED: "Full name is required"
  },
  ADDRESS: {
    REQUIRED: "Delivery address is required"
  }
};

// libs/core-utils/src/lib/utils/arrayUtils/index.ts
function isArray(value) {
  return Array.isArray(value);
}

// libs/core-utils/src/lib/utils/scriptLoadutils/index.ts
var getGtmScript = (gtmId) => {
  return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${gtmId}');
    `;
};
var loadGTM = () => {
  if (isHostMMT() && typeof window !== "undefined" && !window?.["dataLayer"]) {
    const script = document.createElement("script");
    script.innerHTML = getGtmScript("GTM-NWV3K7C");
    script.defer = true;
    document.head.appendChild(script);
  }
};
function gtmDataLayerPush(data) {
  if (window?.dataLayer) {
    const eventData = {
      ...data
    };
    window.dataLayer.push(eventData);
  } else {
    console.warn("GTM dataLayer is not available");
  }
}
function reviewPageViewEvent(data) {
  gtmDataLayerPush(data);
}



/***/ }),

/***/ 8496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  module.exports = __webpack_require__(3205)
} else {}

/***/ }),

/***/ 1983:
/***/ (function(module) {

"use strict";
var ae=Object.defineProperty;var be=Object.getOwnPropertyDescriptor;var Te=Object.getOwnPropertyNames;var Ae=Object.prototype.hasOwnProperty;var Ie=(e,t)=>{for(var r in t)ae(e,r,{get:t[r],enumerable:!0})},De=(e,t,r,n)=>{if(t&&typeof t=="object"||typeof t=="function")for(let i of Te(t))!Ae.call(e,i)&&i!==r&&ae(e,i,{get:()=>t[i],enumerable:!(n=be(t,i))||n.enumerable});return e};var Oe=e=>De(ae({},"__esModule",{value:!0}),e);var Be={};Ie(Be,{Immer:()=>J,applyPatches:()=>Ce,castDraft:()=>Ke,castImmutable:()=>ke,createDraft:()=>ve,current:()=>ne,enableMapSet:()=>ge,enablePatches:()=>xe,finishDraft:()=>Re,freeze:()=>k,immerable:()=>N,isDraft:()=>O,isDraftable:()=>A,nothing:()=>C,original:()=>pe,produce:()=>Fe,produceWithPatches:()=>Ne,setAutoFreeze:()=>je,setUseStrictShallowCopy:()=>ze});module.exports=Oe(Be);var C=Symbol.for("immer-nothing"),N=Symbol.for("immer-draftable"),u=Symbol.for("immer-state");function h(e,...t){throw new Error(`[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`)}var j=Object.getPrototypeOf;function O(e){return!!e&&!!e[u]}function A(e){return e?le(e)||Array.isArray(e)||!!e[N]||!!e.constructor?.[N]||z(e)||K(e):!1}var Me=Object.prototype.constructor.toString();function le(e){if(!e||typeof e!="object")return!1;let t=j(e);if(t===null)return!0;let r=Object.hasOwnProperty.call(t,"constructor")&&t.constructor;return r===Object?!0:typeof r=="function"&&Function.toString.call(r)===Me}function pe(e){return O(e)||h(15,e),e[u].t}function _(e,t){v(e)===0?Reflect.ownKeys(e).forEach(r=>{t(r,e[r],e)}):e.forEach((r,n)=>t(n,r,e))}function v(e){let t=e[u];return t?t.o:Array.isArray(e)?1:z(e)?2:K(e)?3:0}function R(e,t){return v(e)===2?e.has(t):Object.prototype.hasOwnProperty.call(e,t)}function Q(e,t){return v(e)===2?e.get(t):e[t]}function Y(e,t,r){let n=v(e);n===2?e.set(t,r):n===3?e.add(r):e[t]=r}function de(e,t){return e===t?e!==0||1/e===1/t:e!==e&&t!==t}function z(e){return e instanceof Map}function K(e){return e instanceof Set}function T(e){return e.e||e.t}function L(e,t){if(z(e))return new Map(e);if(K(e))return new Set(e);if(Array.isArray(e))return Array.prototype.slice.call(e);let r=le(e);if(t===!0||t==="class_only"&&!r){let n=Object.getOwnPropertyDescriptors(e);delete n[u];let i=Reflect.ownKeys(n);for(let f=0;f<i.length;f++){let l=i[f],c=n[l];c.writable===!1&&(c.writable=!0,c.configurable=!0),(c.get||c.set)&&(n[l]={configurable:!0,writable:!0,enumerable:c.enumerable,value:e[l]})}return Object.create(j(e),n)}else{let n=j(e);if(n!==null&&r)return{...e};let i=Object.create(n);return Object.assign(i,e)}}function k(e,t=!1){return $(e)||O(e)||!A(e)||(v(e)>1&&Object.defineProperties(e,{set:{value:X},add:{value:X},clear:{value:X},delete:{value:X}}),Object.freeze(e),t&&Object.values(e).forEach(r=>k(r,!0))),e}function X(){h(2)}function $(e){return Object.isFrozen(e)}var oe={};function w(e){let t=oe[e];return t||h(0,e),t}function Z(e,t){oe[e]||(oe[e]=t)}var U;function B(){return U}function _e(e,t){return{a:[],i:e,p:t,P:!0,d:0}}function ie(e,t){t&&(w("Patches"),e.f=[],e.h=[],e.b=t)}function V(e){ee(e),e.a.forEach(we),e.a=null}function ee(e){e===U&&(U=e.i)}function se(e){return U=_e(U,e)}function we(e){let t=e[u];t.o===0||t.o===1?t.x():t.m=!0}function ce(e,t){t.d=t.a.length;let r=t.a[0];return e!==void 0&&e!==r?(r[u].s&&(V(t),h(4)),A(e)&&(e=te(t,e),t.i||re(t,e)),t.f&&w("Patches").T(r[u].t,e,t.f,t.h)):e=te(t,r,[]),V(t),t.f&&t.b(t.f,t.h),e!==C?e:void 0}function te(e,t,r){if($(t))return t;let n=t[u];if(!n)return _(t,(i,f)=>he(e,n,t,i,f,r)),t;if(n.n!==e)return t;if(!n.s)return re(e,n.t,!0),n.t;if(!n.c){n.c=!0,n.n.d--;let i=n.e,f=i,l=!1;n.o===3&&(f=new Set(i),i.clear(),l=!0),_(f,(c,b)=>he(e,n,i,c,b,r,l)),re(e,i,!1),r&&e.f&&w("Patches").g(n,r,e.f,e.h)}return n.e}function he(e,t,r,n,i,f,l){if(O(i)){let c=f&&t&&t.o!==3&&!R(t.r,n)?f.concat(n):void 0,b=te(e,i,c);if(Y(r,n,b),O(b))e.P=!1;else return}else l&&r.add(i);if(A(i)&&!$(i)){if(!e.p.y&&e.d<1)return;te(e,i),(!t||!t.n.i)&&typeof n!="symbol"&&(z(r)?r.has(n):Object.prototype.propertyIsEnumerable.call(r,n))&&re(e,i)}}function re(e,t,r=!1){!e.i&&e.p.y&&e.P&&k(t,r)}function me(e,t){let r=Array.isArray(e),n={o:r?1:0,n:t?t.n:B(),s:!1,c:!1,r:{},i:t,t:e,u:null,e:null,x:null,l:!1},i=n,f=ye;r&&(i=[n],f=q);let{revoke:l,proxy:c}=Proxy.revocable(i,f);return n.u=c,n.x=l,c}var ye={get(e,t){if(t===u)return e;let r=T(e);if(!R(r,t))return Ee(e,r,t);let n=r[t];return e.c||!A(n)?n:n===fe(e.t,t)?(ue(e),e.e[t]=W(n,e)):n},has(e,t){return t in T(e)},ownKeys(e){return Reflect.ownKeys(T(e))},set(e,t,r){let n=Se(T(e),t);if(n?.set)return n.set.call(e.u,r),!0;if(!e.s){let i=fe(T(e),t),f=i?.[u];if(f&&f.t===r)return e.e[t]=r,e.r[t]=!1,!0;if(de(r,i)&&(r!==void 0||R(e.t,t)))return!0;ue(e),E(e)}return e.e[t]===r&&(r!==void 0||t in e.e)||Number.isNaN(r)&&Number.isNaN(e.e[t])||(e.e[t]=r,e.r[t]=!0),!0},deleteProperty(e,t){return fe(e.t,t)!==void 0||t in e.t?(e.r[t]=!1,ue(e),E(e)):delete e.r[t],e.e&&delete e.e[t],!0},getOwnPropertyDescriptor(e,t){let r=T(e),n=Reflect.getOwnPropertyDescriptor(r,t);return n&&{writable:!0,configurable:e.o!==1||t!=="length",enumerable:n.enumerable,value:r[t]}},defineProperty(){h(11)},getPrototypeOf(e){return j(e.t)},setPrototypeOf(){h(12)}},q={};_(ye,(e,t)=>{q[e]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)}});q.deleteProperty=function(e,t){return q.set.call(this,e,t,void 0)};q.set=function(e,t,r){return ye.set.call(this,e[0],t,r,e[0])};function fe(e,t){let r=e[u];return(r?T(r):e)[t]}function Ee(e,t,r){let n=Se(t,r);return n?"value"in n?n.value:n.get?.call(e.u):void 0}function Se(e,t){if(!(t in e))return;let r=j(e);for(;r;){let n=Object.getOwnPropertyDescriptor(r,t);if(n)return n;r=j(r)}}function E(e){e.s||(e.s=!0,e.i&&E(e.i))}function ue(e){e.e||(e.e=L(e.t,e.n.p.S))}var J=class{constructor(t){this.y=!0;this.S=!1;this.produce=(t,r,n)=>{if(typeof t=="function"&&typeof r!="function"){let f=r;r=t;let l=this;return function(b=f,...a){return l.produce(b,o=>r.call(this,o,...a))}}typeof r!="function"&&h(6),n!==void 0&&typeof n!="function"&&h(7);let i;if(A(t)){let f=se(this),l=W(t,void 0),c=!0;try{i=r(l),c=!1}finally{c?V(f):ee(f)}return ie(f,n),ce(i,f)}else if(!t||typeof t!="object"){if(i=r(t),i===void 0&&(i=t),i===C&&(i=void 0),this.y&&k(i,!0),n){let f=[],l=[];w("Patches").T(t,i,f,l),n(f,l)}return i}else h(1,t)};this.produceWithPatches=(t,r)=>{if(typeof t=="function")return(l,...c)=>this.produceWithPatches(l,b=>t(b,...c));let n,i;return[this.produce(t,r,(l,c)=>{n=l,i=c}),n,i]};typeof t?.autoFreeze=="boolean"&&this.setAutoFreeze(t.autoFreeze),typeof t?.useStrictShallowCopy=="boolean"&&this.setUseStrictShallowCopy(t.useStrictShallowCopy)}createDraft(t){A(t)||h(8),O(t)&&(t=ne(t));let r=se(this),n=W(t,void 0);return n[u].l=!0,ee(r),n}finishDraft(t,r){let n=t&&t[u];(!n||!n.l)&&h(9);let{n:i}=n;return ie(i,r),ce(void 0,i)}setAutoFreeze(t){this.y=t}setUseStrictShallowCopy(t){this.S=t}applyPatches(t,r){let n;for(n=r.length-1;n>=0;n--){let f=r[n];if(f.path.length===0&&f.op==="replace"){t=f.value;break}}n>-1&&(r=r.slice(n+1));let i=w("Patches").A;return O(t)?i(t,r):this.produce(t,f=>i(f,r))}};function W(e,t){let r=z(e)?w("MapSet").I(e,t):K(e)?w("MapSet").D(e,t):me(e,t);return(t?t.n:B()).a.push(r),r}function ne(e){return O(e)||h(10,e),Pe(e)}function Pe(e){if(!A(e)||$(e))return e;let t=e[u],r;if(t){if(!t.s)return t.t;t.c=!0,r=L(e,t.n.p.S)}else r=L(e,!0);return _(r,(n,i)=>{Y(r,n,Pe(i))}),t&&(t.c=!1),r}function xe(){let t="replace",r="add",n="remove";function i(s,S,m,x){switch(s.o){case 0:case 2:return l(s,S,m,x);case 1:return f(s,S,m,x);case 3:return c(s,S,m,x)}}function f(s,S,m,x){let{t:I,r:P}=s,g=s.e;g.length<I.length&&([I,g]=[g,I],[m,x]=[x,m]);for(let y=0;y<I.length;y++)if(P[y]&&g[y]!==I[y]){let d=S.concat([y]);m.push({op:t,path:d,value:p(g[y])}),x.push({op:t,path:d,value:p(I[y])})}for(let y=I.length;y<g.length;y++){let d=S.concat([y]);m.push({op:r,path:d,value:p(g[y])})}for(let y=g.length-1;I.length<=y;--y){let d=S.concat([y]);x.push({op:n,path:d})}}function l(s,S,m,x){let{t:I,e:P}=s;_(s.r,(g,y)=>{let d=Q(I,g),H=Q(P,g),F=y?R(I,g)?t:r:n;if(d===H&&F===t)return;let D=S.concat(g);m.push(F===n?{op:F,path:D}:{op:F,path:D,value:H}),x.push(F===r?{op:n,path:D}:F===n?{op:r,path:D,value:p(d)}:{op:t,path:D,value:p(d)})})}function c(s,S,m,x){let{t:I,e:P}=s,g=0;I.forEach(y=>{if(!P.has(y)){let d=S.concat([g]);m.push({op:n,path:d,value:y}),x.unshift({op:r,path:d,value:y})}g++}),g=0,P.forEach(y=>{if(!I.has(y)){let d=S.concat([g]);m.push({op:r,path:d,value:y}),x.unshift({op:n,path:d,value:y})}g++})}function b(s,S,m,x){m.push({op:t,path:[],value:S===C?void 0:S}),x.push({op:t,path:[],value:s})}function a(s,S){return S.forEach(m=>{let{path:x,op:I}=m,P=s;for(let H=0;H<x.length-1;H++){let F=v(P),D=x[H];typeof D!="string"&&typeof D!="number"&&(D=""+D),(F===0||F===1)&&(D==="__proto__"||D==="constructor")&&h(16+3),typeof P=="function"&&D==="prototype"&&h(16+3),P=Q(P,D),typeof P!="object"&&h(16+2,x.join("/"))}let g=v(P),y=o(m.value),d=x[x.length-1];switch(I){case t:switch(g){case 2:return P.set(d,y);case 3:h(16);default:return P[d]=y}case r:switch(g){case 1:return d==="-"?P.push(y):P.splice(d,0,y);case 2:return P.set(d,y);case 3:return P.add(y);default:return P[d]=y}case n:switch(g){case 1:return P.splice(d,1);case 2:return P.delete(d);case 3:return P.delete(m.value);default:return delete P[d]}default:h(16+1,I)}}),s}function o(s){if(!A(s))return s;if(Array.isArray(s))return s.map(o);if(z(s))return new Map(Array.from(s.entries()).map(([m,x])=>[m,o(x)]));if(K(s))return new Set(Array.from(s).map(o));let S=Object.create(j(s));for(let m in s)S[m]=o(s[m]);return R(s,N)&&(S[N]=s[N]),S}function p(s){return O(s)?o(s):s}Z("Patches",{A:a,g:i,T:b})}function ge(){class e extends Map{constructor(a,o){super();this[u]={o:2,i:o,n:o?o.n:B(),s:!1,c:!1,e:void 0,r:void 0,t:a,u:this,l:!1,m:!1}}get size(){return T(this[u]).size}has(a){return T(this[u]).has(a)}set(a,o){let p=this[u];return l(p),(!T(p).has(a)||T(p).get(a)!==o)&&(r(p),E(p),p.r.set(a,!0),p.e.set(a,o),p.r.set(a,!0)),this}delete(a){if(!this.has(a))return!1;let o=this[u];return l(o),r(o),E(o),o.t.has(a)?o.r.set(a,!1):o.r.delete(a),o.e.delete(a),!0}clear(){let a=this[u];l(a),T(a).size&&(r(a),E(a),a.r=new Map,_(a.t,o=>{a.r.set(o,!1)}),a.e.clear())}forEach(a,o){let p=this[u];T(p).forEach((s,S,m)=>{a.call(o,this.get(S),S,this)})}get(a){let o=this[u];l(o);let p=T(o).get(a);if(o.c||!A(p)||p!==o.t.get(a))return p;let s=W(p,o);return r(o),o.e.set(a,s),s}keys(){return T(this[u]).keys()}values(){let a=this.keys();return{[Symbol.iterator]:()=>this.values(),next:()=>{let o=a.next();return o.done?o:{done:!1,value:this.get(o.value)}}}}entries(){let a=this.keys();return{[Symbol.iterator]:()=>this.entries(),next:()=>{let o=a.next();if(o.done)return o;let p=this.get(o.value);return{done:!1,value:[o.value,p]}}}}[(u,Symbol.iterator)](){return this.entries()}}function t(c,b){return new e(c,b)}function r(c){c.e||(c.r=new Map,c.e=new Map(c.t))}class n extends Set{constructor(a,o){super();this[u]={o:3,i:o,n:o?o.n:B(),s:!1,c:!1,e:void 0,t:a,u:this,a:new Map,m:!1,l:!1}}get size(){return T(this[u]).size}has(a){let o=this[u];return l(o),o.e?!!(o.e.has(a)||o.a.has(a)&&o.e.has(o.a.get(a))):o.t.has(a)}add(a){let o=this[u];return l(o),this.has(a)||(f(o),E(o),o.e.add(a)),this}delete(a){if(!this.has(a))return!1;let o=this[u];return l(o),f(o),E(o),o.e.delete(a)||(o.a.has(a)?o.e.delete(o.a.get(a)):!1)}clear(){let a=this[u];l(a),T(a).size&&(f(a),E(a),a.e.clear())}values(){let a=this[u];return l(a),f(a),a.e.values()}entries(){let a=this[u];return l(a),f(a),a.e.entries()}keys(){return this.values()}[(u,Symbol.iterator)](){return this.values()}forEach(a,o){let p=this.values(),s=p.next();for(;!s.done;)a.call(o,s.value,s.value,this),s=p.next()}}function i(c,b){return new n(c,b)}function f(c){c.e||(c.e=new Set,c.t.forEach(b=>{if(A(b)){let a=W(b,c);c.a.set(b,a),c.e.add(a)}else c.e.add(b)}))}function l(c){c.m&&h(3,JSON.stringify(T(c)))}Z("MapSet",{I:t,D:i})}var M=new J,Fe=M.produce,Ne=M.produceWithPatches.bind(M),je=M.setAutoFreeze.bind(M),ze=M.setUseStrictShallowCopy.bind(M),Ce=M.applyPatches.bind(M),ve=M.createDraft.bind(M),Re=M.finishDraft.bind(M);function Ke(e){return e}function ke(e){return e}0&&(0);
//# sourceMappingURL=immer.cjs.production.js.map

/***/ }),

/***/ 7476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";



if (true) {
  module.exports = __webpack_require__(1983)
} else {}

/***/ }),

/***/ 3157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AssistanceBot": function() { return /* binding */ AssistanceBot; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var _forex_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _lib_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5618);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);
/* harmony import */ var _forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);







function _tagged_template_literal$1(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject$1() {
    var data = _tagged_template_literal$1([
        "\n  position: fixed;\n  bottom: ",
        ";\n  right: ",
        ";\n  z-index: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject$1 = function _templateObject() {
        return data;
    };
    return data;
}
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject$1(), function(param) {
    var bottom = param.bottom;
    return bottom;
}, function(param) {
    var right = param.right;
    return right;
}, function(param) {
    var zIndex = param.zIndex;
    return zIndex;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
var MyraIcon$1 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var iconUrl = param.iconUrl, _param_bottom = param.bottom, bottom = _param_bottom === void 0 ? '30px' : _param_bottom, _param_right = param.right, right = _param_right === void 0 ? '30px' : _param_right, _param_size = param.size, size = _param_size === void 0 ? '60px' : _param_size, _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? 12 : _param_zIndex, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
        ref: ref,
        bottom: bottom,
        right: right,
        size: size,
        zIndex: zIndex,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_3__.Image, {
            src: iconUrl,
            width: size,
            height: size,
            showCursorPointer: true,
            alt: "Myra Assistant"
        })
    });
});

var DEFAULT_ICON_URL$1 = 'https://imgak.mmtcdn.com/flights/assets/media/mobile/listing/3X/myra_new_gif.webp?v=2';
// Spacing and sizing constants
var CHAT_WINDOW_OFFSET = 20;
var DEFAULT_ICON_SIZE = '60';
var DEFAULT_GAP = '30px';
// Z-index constants
var DEFAULT_Z_INDEX = 12;
// Position constants
var DEFAULT_BOTTOM = '30px';
var DEFAULT_RIGHT = '30px';
var CHAT_WINDOW_BOTTOM = '100px';
// Chat window dimensions
var CHAT_WINDOW_WIDTH = '360px';
var CHAT_WINDOW_HEIGHT = '700px';
var CHAT_WINDOW_BORDER_RADIUS = '12px';
var DEFAULT_STYLES$1 = {
    bottom: DEFAULT_BOTTOM,
    right: DEFAULT_RIGHT,
    iconSize: DEFAULT_ICON_SIZE,
    zIndex: DEFAULT_Z_INDEX,
    chatWindowStyle: {
        width: CHAT_WINDOW_WIDTH,
        height: CHAT_WINDOW_HEIGHT,
        borderRadius: CHAT_WINDOW_BORDER_RADIUS,
        boxShadow: 'none',
        position: 'fixed',
        bottom: CHAT_WINDOW_BOTTOM
    }
};

var getAdjustedPosition = function(basePosition, offset) {
    if (!offset) return basePosition;
    var gap = offset.gap || DEFAULT_GAP;
    return offset.position === 'left' ? "calc(".concat(offset.width, " + ").concat(gap, ")") : "calc(".concat(basePosition, " + ").concat(offset.width, " + ").concat(gap, ")");
};
var calculateBottomPosition = function(iconY) {
    return "".concat(window.innerHeight - iconY + CHAT_WINDOW_OFFSET, "px");
};
var calculateHorizontalPosition = function(iconX, windowWidth, iconSize, offsetFromElement) {
    var isRightAligned = iconX > windowWidth / 2;
    if (isRightAligned) {
        var basePosition = "".concat(windowWidth - (iconX + iconSize), "px");
        return {
            right: getAdjustedPosition(basePosition, offsetFromElement)
        };
    }
    return {
        left: "".concat(iconX, "px")
    };
};
var getIconPosition = function(element) {
    return {
        x: element.getBoundingClientRect().left + window.scrollX,
        y: element.getBoundingClientRect().top + window.scrollY
    };
};

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var MyraFrame$1 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.lazy)(function() {
    return __webpack_require__.e(/* import() */ 9258).then(__webpack_require__.bind(__webpack_require__, 9258));
});
var DesktopAssistanceBot = function(param) {
    var chatUrl = param.chatUrl, handleMyraMinimized = param.handleMyraMinimized, handleMyraExpand = param.handleMyraExpand, onMessage = param.onMessage, _param_style = param.style, style = _param_style === void 0 ? {} : _param_style, _param_disableBodyScrollOnExpand = param.disableBodyScrollOnExpand, disableBodyScrollOnExpand = _param_disableBodyScrollOnExpand === void 0 ? true : _param_disableBodyScrollOnExpand;
    var _useState = _sliced_to_array$1((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), 2), showChatBot = _useState[0], setShowChatBot = _useState[1];
    var _useState1 = _sliced_to_array$1((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), 2), myraMinimized = _useState1[0], setMyraMinimized = _useState1[1];
    var _useState2 = _sliced_to_array$1((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), 2), iconPosition = _useState2[0], setIconPosition = _useState2[1];
    var iconRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var mergedStyles = _object_spread_props$2(_object_spread$2({}, DEFAULT_STYLES$1, style), {
        right: getAdjustedPosition(style.right || DEFAULT_STYLES$1.right, style.offsetFromElement),
        chatWindowStyle: _object_spread_props$2(_object_spread$2({}, DEFAULT_STYLES$1.chatWindowStyle, style.chatWindowStyle), {
            position: 'fixed'
        })
    });
    var onMyraMinimized = function(min) {
        setMyraMinimized(min);
        if (showChatBot) {
            setShowChatBot(false);
        }
        handleMyraMinimized === null || handleMyraMinimized === void 0 ? void 0 : handleMyraMinimized(min);
    };
    var handleIconClick = function() {
        if (iconRef.current) {
            setIconPosition(getIconPosition(iconRef.current));
        }
        setMyraMinimized(false);
        setShowChatBot(true);
        handleMyraExpand === null || handleMyraExpand === void 0 ? void 0 : handleMyraExpand();
    };
    var getChatWindowPosition = function() {
        if (!iconPosition) return {};
        var windowWidth = window.innerWidth;
        var iconSize = parseInt(mergedStyles.iconSize || DEFAULT_ICON_SIZE);
        return _object_spread$2({
            position: 'fixed',
            bottom: calculateBottomPosition(iconPosition.y)
        }, calculateHorizontalPosition(iconPosition.x, windowWidth, iconSize, style.offsetFromElement));
    };
    var chatPosition = showChatBot ? getChatWindowPosition() : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraIcon$1, {
                ref: iconRef,
                iconUrl: (style === null || style === void 0 ? void 0 : style.iconUrl) || DEFAULT_ICON_URL$1,
                bottom: mergedStyles.bottom,
                right: mergedStyles.right,
                size: mergedStyles.iconSize,
                zIndex: mergedStyles.zIndex,
                onClick: handleIconClick
            }),
            showChatBot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraFrame$1, {
                    myraAppLink: chatUrl,
                    myraMinimized: myraMinimized,
                    setMyraMinimized: onMyraMinimized,
                    onMessage: onMessage,
                    style: _object_spread$2({}, mergedStyles.chatWindowStyle, chatPosition),
                    disableBodyScrollOnExpand: disableBodyScrollOnExpand
                })
            })
        ]
    });
};

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  bottom: ",
        ";\n  right: ",
        ";\n  z-index: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledMyraIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_lib_design_system__WEBPACK_IMPORTED_MODULE_3__.Image)(_templateObject(), function(props) {
    return props.bottom || '20px';
}, function(props) {
    return props.right || '20px';
}, function(props) {
    return props.zIndex || 12;
}, function(props) {
    return props.size || '48px';
}, function(props) {
    return props.size || '48px';
});

var MyraIcon = function(param) {
    var iconUrl = param.iconUrl, bottom = param.bottom, right = param.right, size = param.size, zIndex = param.zIndex, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledMyraIcon, {
        src: iconUrl,
        alt: "Myra Assistant",
        bottom: bottom,
        right: right,
        size: size,
        zIndex: zIndex,
        onClick: onClick
    });
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var MyraFrame = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.lazy)(function() {
    return __webpack_require__.e(/* import() */ 9258).then(__webpack_require__.bind(__webpack_require__, 9258));
});
var DEFAULT_ICON_URL = 'https://imgak.mmtcdn.com/flights/assets/media/mobile/listing/3X/myra_new_gif.webp?v=2';
var DEFAULT_STYLES = {
    bottom: '20px',
    right: '20px',
    iconSize: '48px',
    zIndex: 12,
    chatWindowStyle: {
        width: '100%',
        height: '100vh',
        borderRadius: '0',
        boxShadow: 'none'
    }
};
var MobileAssistanceBot = function(param) {
    var chatUrl = param.chatUrl, handleMyraMinimized = param.handleMyraMinimized, handleMyraExpand = param.handleMyraExpand, onMessage = param.onMessage, _param_style = param.style, style = _param_style === void 0 ? {} : _param_style, _param_disableBodyScrollOnExpand = param.disableBodyScrollOnExpand, disableBodyScrollOnExpand = _param_disableBodyScrollOnExpand === void 0 ? true : _param_disableBodyScrollOnExpand;
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), 2), showChatBot = _useState[0], setShowChatBot = _useState[1];
    var _useState1 = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), 2), myraMinimized = _useState1[0], setMyraMinimized = _useState1[1];
    var mergedStyles = _object_spread_props$1(_object_spread$1({}, DEFAULT_STYLES, style), {
        chatWindowStyle: _object_spread$1({}, DEFAULT_STYLES.chatWindowStyle, style.chatWindowStyle)
    });
    var onMyraMinimized = function(min) {
        setMyraMinimized(min);
        handleMyraMinimized === null || handleMyraMinimized === void 0 ? void 0 : handleMyraMinimized(min);
    };
    var handleIconClick = function() {
        setMyraMinimized(false);
        setShowChatBot(true);
        handleMyraExpand === null || handleMyraExpand === void 0 ? void 0 : handleMyraExpand();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraIcon, {
                iconUrl: style.iconUrl || DEFAULT_ICON_URL,
                bottom: mergedStyles.bottom,
                right: mergedStyles.right,
                size: mergedStyles.iconSize,
                zIndex: mergedStyles.zIndex,
                onClick: handleIconClick
            }),
            showChatBot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraFrame, {
                    myraAppLink: chatUrl,
                    myraMinimized: myraMinimized,
                    setMyraMinimized: onMyraMinimized,
                    onMessage: onMessage,
                    right: mergedStyles.right,
                    style: mergedStyles.chatWindowStyle,
                    disableBodyScrollOnExpand: disableBodyScrollOnExpand
                })
            })
        ]
    });
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var AssistanceBot = function(props) {
    var platform = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_1__.getPlatform)();
    props.userData; props.commonPdtData; var myraIconShownPdtData = props.myraIconShownPdtData, myraChatWindowOpenPdtData = props.myraChatWindowOpenPdtData, myraChatWindowClosedPdtData = props.myraChatWindowClosedPdtData, myraIconClickedPdtData = props.myraIconClickedPdtData;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // Fire PDT event when icon is shown
        if (myraIconShownPdtData) {
            // pdtLogger.sendPdtData(myraIconShownPdtData);
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraIconShownPdtData
            });
        }
    }, [
        myraIconShownPdtData
    ]);
    var handleMyraIconClick = function() {
        var _props_handleMyraExpand;
        // Fire PDT event when icon is clicked (bot opened)
        if (myraIconClickedPdtData) {
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraIconClickedPdtData
            });
        }
        if (myraChatWindowOpenPdtData) {
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraChatWindowOpenPdtData
            });
        }
        (_props_handleMyraExpand = props.handleMyraExpand) === null || _props_handleMyraExpand === void 0 ? void 0 : _props_handleMyraExpand.call(props);
    };
    var handleMyraMinimized = function(minimized) {
        var _props_handleMyraMinimized;
        // Fire PDT event when bot is closed
        if (minimized && myraChatWindowClosedPdtData) {
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraChatWindowClosedPdtData
            });
        }
        (_props_handleMyraMinimized = props.handleMyraMinimized) === null || _props_handleMyraMinimized === void 0 ? void 0 : _props_handleMyraMinimized.call(props, minimized);
    };
    if (platform === _forex_core_utils__WEBPACK_IMPORTED_MODULE_1__.PLATFORM.DESKTOP) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopAssistanceBot, _object_spread_props(_object_spread({}, props), {
            handleMyraExpand: handleMyraIconClick,
            handleMyraMinimized: handleMyraMinimized
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileAssistanceBot, _object_spread_props(_object_spread({}, props), {
        handleMyraExpand: handleMyraIconClick,
        handleMyraMinimized: handleMyraMinimized
    }));
};




/***/ }),

/***/ 5697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "COOKIES": function() { return /* binding */ COOKIES; },
  "EVENT_TYPES": function() { return /* binding */ EVENT_TYPES; },
  "LOB": function() { return /* binding */ LOB; },
  "cleanupPdtTracking": function() { return /* binding */ cleanupPdtTracking; },
  "extractPdtTrackingParams": function() { return /* binding */ extractPdtTrackingParams; },
  "generateRequestId": function() { return /* binding */ generateRequestId; },
  "getBookingDetails": function() { return /* binding */ getBookingDetails; },
  "getBookingInfo": function() { return /* binding */ getBookingInfo; },
  "getCampaignDetails": function() { return /* binding */ getCampaignDetails; },
  "getCommonPdtDataV2": function() { return /* binding */ getCommonPdtDataV2; },
  "getComponentsPdt": function() { return /* binding */ getComponentsPdt; },
  "getDeliveryDetails": function() { return /* binding */ getDeliveryDetails; },
  "getDeliveryDetailsPdtSchema": function() { return /* binding */ getDeliveryDetailsPdtSchema; },
  "getDeviceContext": function() { return /* binding */ getDeviceContext; },
  "getErrorDetailsItem": function() { return /* binding */ getErrorDetailsItem; },
  "getEventDetails": function() { return /* binding */ getEventDetails; },
  "getEventTrackingContext": function() { return /* binding */ getEventTrackingContext; },
  "getExperimentDetails": function() { return /* binding */ getExperimentDetails; },
  "getLobCategory": function() { return /* binding */ getLobCategory; },
  "getPageContext": function() { return /* binding */ getPageContext; },
  "getPageDetails": function() { return /* binding */ getPageDetails; },
  "getPdtDataObjV2": function() { return /* binding */ getPdtDataObjV2; },
  "getPdtHeaders": function() { return /* binding */ getPdtHeaders; },
  "getPdtLoggerMethodsV2": function() { return /* binding */ getPdtLoggerMethodsV2; },
  "getPdtUpcomingTripSchema": function() { return /* binding */ getPdtUpcomingTripSchema; },
  "getRequestIdHeaders": function() { return /* binding */ getRequestIdHeaders; },
  "getTmUserDetails": function() { return /* binding */ getTmUserDetails; },
  "getUserContext": function() { return /* binding */ getUserContext; },
  "getVendorErrorDetails": function() { return /* binding */ getVendorErrorDetails; },
  "initPdtTracking": function() { return /* binding */ initPdtTracking; },
  "initSessionStorageUserInfo": function() { return /* binding */ initSessionStorageUserInfo; },
  "sendPdtErrorEvent": function() { return /* binding */ sendPdtErrorEvent; },
  "setPageContextHeaders": function() { return /* binding */ setPageContextHeaders; },
  "setPageContextHeadersV2": function() { return /* binding */ setPageContextHeadersV2; },
  "setPdtLocationDetectedSchema": function() { return /* binding */ setPdtLocationDetectedSchema; },
  "shortenHeader": function() { return /* binding */ shortenHeader; },
  "trackComponentEvent": function() { return /* binding */ trackComponentEvent; },
  "trackEvent": function() { return /* binding */ trackEvent; },
  "updateEventName": function() { return /* binding */ updateEventName; },
  "updatePdtDataDescription": function() { return /* binding */ updatePdtDataDescription; }
});

// EXTERNAL MODULE: ../../node_modules/@forex/core-utils/index.js
var core_utils = __webpack_require__(6003);
// EXTERNAL MODULE: ../../node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(6353);
;// CONCATENATED MODULE: ../../node_modules/@forex/pdt-utils/node_modules/@mmt/event-logger/dist/index.mjs
var x;(function(n){n.assertEqual=s=>s;function e(s){}n.assertIs=e;function t(s){throw new Error}n.assertNever=t,n.arrayToEnum=s=>{let a={};for(let i of s)a[i]=i;return a},n.getValidEnumValues=s=>{let a=n.objectKeys(s).filter(o=>typeof s[s[o]]!="number"),i={};for(let o of a)i[o]=s[o];return n.objectValues(i)},n.objectValues=s=>n.objectKeys(s).map(function(a){return s[a]}),n.objectKeys=typeof Object.keys=="function"?s=>Object.keys(s):s=>{let a=[];for(let i in s)Object.prototype.hasOwnProperty.call(s,i)&&a.push(i);return a},n.find=(s,a)=>{for(let i of s)if(a(i))return i},n.isInteger=typeof Number.isInteger=="function"?s=>Number.isInteger(s):s=>typeof s=="number"&&isFinite(s)&&Math.floor(s)===s;function r(s,a=" | "){return s.map(i=>typeof i=="string"?`'${i}'`:i).join(a)}n.joinValues=r,n.jsonStringifyReplacer=(s,a)=>typeof a=="bigint"?a.toString():a})(x||(x={}));var tt;(function(n){n.mergeShapes=(e,t)=>({...e,...t})})(tt||(tt={}));var f=x.arrayToEnum(["string","nan","number","integer","float","boolean","date","bigint","symbol","function","undefined","null","array","object","unknown","promise","void","never","map","set"]),U=n=>{switch(typeof n){case"undefined":return f.undefined;case"string":return f.string;case"number":return isNaN(n)?f.nan:f.number;case"boolean":return f.boolean;case"function":return f.function;case"bigint":return f.bigint;case"symbol":return f.symbol;case"object":return Array.isArray(n)?f.array:n===null?f.null:n.then&&typeof n.then=="function"&&n.catch&&typeof n.catch=="function"?f.promise:typeof Map<"u"&&n instanceof Map?f.map:typeof Set<"u"&&n instanceof Set?f.set:typeof Date<"u"&&n instanceof Date?f.date:f.object;default:return f.unknown}},d=x.arrayToEnum(["invalid_type","invalid_literal","custom","invalid_union","invalid_union_discriminator","invalid_enum_value","unrecognized_keys","invalid_arguments","invalid_return_type","invalid_date","invalid_string","too_small","too_big","invalid_intersection_types","not_multiple_of","not_finite"]),gn=n=>JSON.stringify(n,null,2).replace(/"([^"]+)":/g,"$1:"),E=class n extends Error{get errors(){return this.issues}constructor(e){super(),this.issues=[],this.addIssue=r=>{this.issues=[...this.issues,r]},this.addIssues=(r=[])=>{this.issues=[...this.issues,...r]};let t=new.target.prototype;Object.setPrototypeOf?Object.setPrototypeOf(this,t):this.__proto__=t,this.name="ZodError",this.issues=e}format(e){let t=e||function(a){return a.message},r={_errors:[]},s=a=>{for(let i of a.issues)if(i.code==="invalid_union")i.unionErrors.map(s);else if(i.code==="invalid_return_type")s(i.returnTypeError);else if(i.code==="invalid_arguments")s(i.argumentsError);else if(i.path.length===0)r._errors.push(t(i));else{let o=r,u=0;for(;u<i.path.length;){let c=i.path[u];u===i.path.length-1?(o[c]=o[c]||{_errors:[]},o[c]._errors.push(t(i))):o[c]=o[c]||{_errors:[]},o=o[c],u++}}};return s(this),r}static assert(e){if(!(e instanceof n))throw new Error(`Not a ZodError: ${e}`)}toString(){return this.message}get message(){return JSON.stringify(this.issues,x.jsonStringifyReplacer,2)}get isEmpty(){return this.issues.length===0}flatten(e=t=>t.message){let t={},r=[];for(let s of this.issues)s.path.length>0?(t[s.path[0]]=t[s.path[0]]||[],t[s.path[0]].push(e(s))):r.push(e(s));return{formErrors:r,fieldErrors:t}}get formErrors(){return this.flatten()}};E.create=n=>new E(n);var he=(n,e)=>{let t;switch(n.code){case d.invalid_type:n.received===f.undefined?t="Required":t=`Expected ${n.expected}, received ${n.received}`;break;case d.invalid_literal:t=`Invalid literal value, expected ${JSON.stringify(n.expected,x.jsonStringifyReplacer)}`;break;case d.unrecognized_keys:t=`Unrecognized key(s) in object: ${x.joinValues(n.keys,", ")}`;break;case d.invalid_union:t="Invalid input";break;case d.invalid_union_discriminator:t=`Invalid discriminator value. Expected ${x.joinValues(n.options)}`;break;case d.invalid_enum_value:t=`Invalid enum value. Expected ${x.joinValues(n.options)}, received '${n.received}'`;break;case d.invalid_arguments:t="Invalid function arguments";break;case d.invalid_return_type:t="Invalid function return type";break;case d.invalid_date:t="Invalid date";break;case d.invalid_string:typeof n.validation=="object"?"includes"in n.validation?(t=`Invalid input: must include "${n.validation.includes}"`,typeof n.validation.position=="number"&&(t=`${t} at one or more positions greater than or equal to ${n.validation.position}`)):"startsWith"in n.validation?t=`Invalid input: must start with "${n.validation.startsWith}"`:"endsWith"in n.validation?t=`Invalid input: must end with "${n.validation.endsWith}"`:x.assertNever(n.validation):n.validation!=="regex"?t=`Invalid ${n.validation}`:t="Invalid";break;case d.too_small:n.type==="array"?t=`Array must contain ${n.exact?"exactly":n.inclusive?"at least":"more than"} ${n.minimum} element(s)`:n.type==="string"?t=`String must contain ${n.exact?"exactly":n.inclusive?"at least":"over"} ${n.minimum} character(s)`:n.type==="number"?t=`Number must be ${n.exact?"exactly equal to ":n.inclusive?"greater than or equal to ":"greater than "}${n.minimum}`:n.type==="date"?t=`Date must be ${n.exact?"exactly equal to ":n.inclusive?"greater than or equal to ":"greater than "}${new Date(Number(n.minimum))}`:t="Invalid input";break;case d.too_big:n.type==="array"?t=`Array must contain ${n.exact?"exactly":n.inclusive?"at most":"less than"} ${n.maximum} element(s)`:n.type==="string"?t=`String must contain ${n.exact?"exactly":n.inclusive?"at most":"under"} ${n.maximum} character(s)`:n.type==="number"?t=`Number must be ${n.exact?"exactly":n.inclusive?"less than or equal to":"less than"} ${n.maximum}`:n.type==="bigint"?t=`BigInt must be ${n.exact?"exactly":n.inclusive?"less than or equal to":"less than"} ${n.maximum}`:n.type==="date"?t=`Date must be ${n.exact?"exactly":n.inclusive?"smaller than or equal to":"smaller than"} ${new Date(Number(n.maximum))}`:t="Invalid input";break;case d.custom:t="Invalid input";break;case d.invalid_intersection_types:t="Intersection results could not be merged";break;case d.not_multiple_of:t=`Number must be a multiple of ${n.multipleOf}`;break;case d.not_finite:t="Number must be finite";break;default:t=e.defaultError,x.assertNever(n)}return{message:t}},yt=he;function yn(n){yt=n}function Ue(){return yt}var Ze=n=>{let{data:e,path:t,errorMaps:r,issueData:s}=n,a=[...t,...s.path||[]],i={...s,path:a};if(s.message!==void 0)return{...s,path:a,message:s.message};let o="",u=r.filter(c=>!!c).slice().reverse();for(let c of u)o=c(i,{data:e,defaultError:o}).message;return{...s,path:a,message:o}},vn=[];function l(n,e){let t=Ue(),r=Ze({issueData:e,data:n.data,path:n.path,errorMaps:[n.common.contextualErrorMap,n.schemaErrorMap,t,t===he?void 0:he].filter(s=>!!s)});n.common.issues.push(r)}var k=class n{constructor(){this.value="valid"}dirty(){this.value==="valid"&&(this.value="dirty")}abort(){this.value!=="aborted"&&(this.value="aborted")}static mergeArray(e,t){let r=[];for(let s of t){if(s.status==="aborted")return g;s.status==="dirty"&&e.dirty(),r.push(s.value)}return{status:e.value,value:r}}static async mergeObjectAsync(e,t){let r=[];for(let s of t){let a=await s.key,i=await s.value;r.push({key:a,value:i})}return n.mergeObjectSync(e,r)}static mergeObjectSync(e,t){let r={};for(let s of t){let{key:a,value:i}=s;if(a.status==="aborted"||i.status==="aborted")return g;a.status==="dirty"&&e.dirty(),i.status==="dirty"&&e.dirty(),a.value!=="__proto__"&&(typeof i.value<"u"||s.alwaysSet)&&(r[a.value]=i.value)}return{status:e.value,value:r}}},g=Object.freeze({status:"aborted"}),me=n=>({status:"dirty",value:n}),S=n=>({status:"valid",value:n}),nt=n=>n.status==="aborted",rt=n=>n.status==="dirty",J=n=>n.status==="valid",Ee=n=>typeof Promise<"u"&&n instanceof Promise;function Le(n,e,t,r){if(t==="a"&&!r)throw new TypeError("Private accessor was defined without a getter");if(typeof e=="function"?n!==e||!r:!e.has(n))throw new TypeError("Cannot read private member from an object whose class did not declare it");return t==="m"?r:t==="a"?r.call(n):r?r.value:e.get(n)}function vt(n,e,t,r,s){if(r==="m")throw new TypeError("Private method is not writable");if(r==="a"&&!s)throw new TypeError("Private accessor was defined without a setter");if(typeof e=="function"?n!==e||!s:!e.has(n))throw new TypeError("Cannot write private member to an object whose class did not declare it");return r==="a"?s.call(n,t):s?s.value=t:e.set(n,t),t}var m;(function(n){n.errToObj=e=>typeof e=="string"?{message:e}:e||{},n.toString=e=>typeof e=="string"?e:e?.message})(m||(m={}));var Se,Te,O=class{constructor(e,t,r,s){this._cachedPath=[],this.parent=e,this.data=t,this._path=r,this._key=s}get path(){return this._cachedPath.length||(this._key instanceof Array?this._cachedPath.push(...this._path,...this._key):this._cachedPath.push(...this._path,this._key)),this._cachedPath}},mt=(n,e)=>{if(J(e))return{success:!0,data:e.value};if(!n.common.issues.length)throw new Error("Validation failed but no issues detected.");return{success:!1,get error(){if(this._error)return this._error;let t=new E(n.common.issues);return this._error=t,this._error}}};function v(n){if(!n)return{};let{errorMap:e,invalid_type_error:t,required_error:r,description:s}=n;if(e&&(t||r))throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);return e?{errorMap:e,description:s}:{errorMap:(i,o)=>{var u,c;let{message:p}=n;return i.code==="invalid_enum_value"?{message:p??o.defaultError}:typeof o.data>"u"?{message:(u=p??r)!==null&&u!==void 0?u:o.defaultError}:i.code!=="invalid_type"?{message:o.defaultError}:{message:(c=p??t)!==null&&c!==void 0?c:o.defaultError}},description:s}}var _=class{get description(){return this._def.description}_getType(e){return U(e.data)}_getOrReturnCtx(e,t){return t||{common:e.parent.common,data:e.data,parsedType:U(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}_processInputParams(e){return{status:new k,ctx:{common:e.parent.common,data:e.data,parsedType:U(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}}_parseSync(e){let t=this._parse(e);if(Ee(t))throw new Error("Synchronous parse encountered promise.");return t}_parseAsync(e){let t=this._parse(e);return Promise.resolve(t)}parse(e,t){let r=this.safeParse(e,t);if(r.success)return r.data;throw r.error}safeParse(e,t){var r;let s={common:{issues:[],async:(r=t?.async)!==null&&r!==void 0?r:!1,contextualErrorMap:t?.errorMap},path:t?.path||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)},a=this._parseSync({data:e,path:s.path,parent:s});return mt(s,a)}"~validate"(e){var t,r;let s={common:{issues:[],async:!!this["~standard"].async},path:[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)};if(!this["~standard"].async)try{let a=this._parseSync({data:e,path:[],parent:s});return J(a)?{value:a.value}:{issues:s.common.issues}}catch(a){!((r=(t=a?.message)===null||t===void 0?void 0:t.toLowerCase())===null||r===void 0)&&r.includes("encountered")&&(this["~standard"].async=!0),s.common={issues:[],async:!0}}return this._parseAsync({data:e,path:[],parent:s}).then(a=>J(a)?{value:a.value}:{issues:s.common.issues})}async parseAsync(e,t){let r=await this.safeParseAsync(e,t);if(r.success)return r.data;throw r.error}async safeParseAsync(e,t){let r={common:{issues:[],contextualErrorMap:t?.errorMap,async:!0},path:t?.path||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)},s=this._parse({data:e,path:r.path,parent:r}),a=await(Ee(s)?s:Promise.resolve(s));return mt(r,a)}refine(e,t){let r=s=>typeof t=="string"||typeof t>"u"?{message:t}:typeof t=="function"?t(s):t;return this._refinement((s,a)=>{let i=e(s),o=()=>a.addIssue({code:d.custom,...r(s)});return typeof Promise<"u"&&i instanceof Promise?i.then(u=>u?!0:(o(),!1)):i?!0:(o(),!1)})}refinement(e,t){return this._refinement((r,s)=>e(r)?!0:(s.addIssue(typeof t=="function"?t(r,s):t),!1))}_refinement(e){return new C({schema:this,typeName:h.ZodEffects,effect:{type:"refinement",refinement:e}})}superRefine(e){return this._refinement(e)}constructor(e){this.spa=this.safeParseAsync,this._def=e,this.parse=this.parse.bind(this),this.safeParse=this.safeParse.bind(this),this.parseAsync=this.parseAsync.bind(this),this.safeParseAsync=this.safeParseAsync.bind(this),this.spa=this.spa.bind(this),this.refine=this.refine.bind(this),this.refinement=this.refinement.bind(this),this.superRefine=this.superRefine.bind(this),this.optional=this.optional.bind(this),this.nullable=this.nullable.bind(this),this.nullish=this.nullish.bind(this),this.array=this.array.bind(this),this.promise=this.promise.bind(this),this.or=this.or.bind(this),this.and=this.and.bind(this),this.transform=this.transform.bind(this),this.brand=this.brand.bind(this),this.default=this.default.bind(this),this.catch=this.catch.bind(this),this.describe=this.describe.bind(this),this.pipe=this.pipe.bind(this),this.readonly=this.readonly.bind(this),this.isNullable=this.isNullable.bind(this),this.isOptional=this.isOptional.bind(this),this["~standard"]={version:1,vendor:"zod",validate:t=>this["~validate"](t)}}optional(){return A.create(this,this._def)}nullable(){return j.create(this,this._def)}nullish(){return this.nullable().optional()}array(){return L.create(this)}promise(){return F.create(this,this._def)}or(e){return X.create([this,e],this._def)}and(e){return ee.create(this,e,this._def)}transform(e){return new C({...v(this._def),schema:this,typeName:h.ZodEffects,effect:{type:"transform",transform:e}})}default(e){let t=typeof e=="function"?e:()=>e;return new ae({...v(this._def),innerType:this,defaultValue:t,typeName:h.ZodDefault})}brand(){return new Ce({typeName:h.ZodBranded,type:this,...v(this._def)})}catch(e){let t=typeof e=="function"?e:()=>e;return new ie({...v(this._def),innerType:this,catchValue:t,typeName:h.ZodCatch})}describe(e){let t=this.constructor;return new t({...this._def,description:e})}pipe(e){return Ie.create(this,e)}readonly(){return oe.create(this)}isOptional(){return this.safeParse(void 0).success}isNullable(){return this.safeParse(null).success}},_n=/^c[^\s-]{8,}$/i,xn=/^[0-9a-z]+$/,bn=/^[0-9A-HJKMNP-TV-Z]{26}$/i,wn=/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i,kn=/^[a-z0-9_-]{21}$/i,Sn=/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/,Tn=/^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/,En=/^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i,Cn="^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$",et,In=/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,An=/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,On=/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/,Pn=/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,Rn=/^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,Dn=/^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,_t="((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))",Nn=new RegExp(`^${_t}$`);function xt(n){let e="[0-5]\\d";n.precision?e=`${e}\\.\\d{${n.precision}}`:n.precision==null&&(e=`${e}(\\.\\d+)?`);let t=n.precision?"+":"?";return`([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`}function jn(n){return new RegExp(`^${xt(n)}$`)}function bt(n){let e=`${_t}T${xt(n)}`,t=[];return t.push(n.local?"Z?":"Z"),n.offset&&t.push("([+-]\\d{2}:?\\d{2})"),e=`${e}(${t.join("|")})`,new RegExp(`^${e}$`)}function Mn(n,e){return!!((e==="v4"||!e)&&In.test(n)||(e==="v6"||!e)&&On.test(n))}function Vn(n,e){if(!Sn.test(n))return!1;try{let[t]=n.split("."),r=t.replace(/-/g,"+").replace(/_/g,"/").padEnd(t.length+(4-t.length%4)%4,"="),s=JSON.parse(atob(r));return!(typeof s!="object"||s===null||!s.typ||!s.alg||e&&s.alg!==e)}catch{return!1}}function Un(n,e){return!!((e==="v4"||!e)&&An.test(n)||(e==="v6"||!e)&&Pn.test(n))}var B=class n extends _{_parse(e){if(this._def.coerce&&(e.data=String(e.data)),this._getType(e)!==f.string){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.string,received:a.parsedType}),g}let r=new k,s;for(let a of this._def.checks)if(a.kind==="min")e.data.length<a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_small,minimum:a.value,type:"string",inclusive:!0,exact:!1,message:a.message}),r.dirty());else if(a.kind==="max")e.data.length>a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_big,maximum:a.value,type:"string",inclusive:!0,exact:!1,message:a.message}),r.dirty());else if(a.kind==="length"){let i=e.data.length>a.value,o=e.data.length<a.value;(i||o)&&(s=this._getOrReturnCtx(e,s),i?l(s,{code:d.too_big,maximum:a.value,type:"string",inclusive:!0,exact:!0,message:a.message}):o&&l(s,{code:d.too_small,minimum:a.value,type:"string",inclusive:!0,exact:!0,message:a.message}),r.dirty())}else if(a.kind==="email")En.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"email",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="emoji")et||(et=new RegExp(Cn,"u")),et.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"emoji",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="uuid")wn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"uuid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="nanoid")kn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"nanoid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="cuid")_n.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cuid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="cuid2")xn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cuid2",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="ulid")bn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"ulid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="url")try{new URL(e.data)}catch{s=this._getOrReturnCtx(e,s),l(s,{validation:"url",code:d.invalid_string,message:a.message}),r.dirty()}else a.kind==="regex"?(a.regex.lastIndex=0,a.regex.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"regex",code:d.invalid_string,message:a.message}),r.dirty())):a.kind==="trim"?e.data=e.data.trim():a.kind==="includes"?e.data.includes(a.value,a.position)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{includes:a.value,position:a.position},message:a.message}),r.dirty()):a.kind==="toLowerCase"?e.data=e.data.toLowerCase():a.kind==="toUpperCase"?e.data=e.data.toUpperCase():a.kind==="startsWith"?e.data.startsWith(a.value)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{startsWith:a.value},message:a.message}),r.dirty()):a.kind==="endsWith"?e.data.endsWith(a.value)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{endsWith:a.value},message:a.message}),r.dirty()):a.kind==="datetime"?bt(a).test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"datetime",message:a.message}),r.dirty()):a.kind==="date"?Nn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"date",message:a.message}),r.dirty()):a.kind==="time"?jn(a).test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"time",message:a.message}),r.dirty()):a.kind==="duration"?Tn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"duration",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="ip"?Mn(e.data,a.version)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"ip",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="jwt"?Vn(e.data,a.alg)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"jwt",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="cidr"?Un(e.data,a.version)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cidr",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="base64"?Rn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"base64",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="base64url"?Dn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"base64url",code:d.invalid_string,message:a.message}),r.dirty()):x.assertNever(a);return{status:r.value,value:e.data}}_regex(e,t,r){return this.refinement(s=>e.test(s),{validation:t,code:d.invalid_string,...m.errToObj(r)})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}email(e){return this._addCheck({kind:"email",...m.errToObj(e)})}url(e){return this._addCheck({kind:"url",...m.errToObj(e)})}emoji(e){return this._addCheck({kind:"emoji",...m.errToObj(e)})}uuid(e){return this._addCheck({kind:"uuid",...m.errToObj(e)})}nanoid(e){return this._addCheck({kind:"nanoid",...m.errToObj(e)})}cuid(e){return this._addCheck({kind:"cuid",...m.errToObj(e)})}cuid2(e){return this._addCheck({kind:"cuid2",...m.errToObj(e)})}ulid(e){return this._addCheck({kind:"ulid",...m.errToObj(e)})}base64(e){return this._addCheck({kind:"base64",...m.errToObj(e)})}base64url(e){return this._addCheck({kind:"base64url",...m.errToObj(e)})}jwt(e){return this._addCheck({kind:"jwt",...m.errToObj(e)})}ip(e){return this._addCheck({kind:"ip",...m.errToObj(e)})}cidr(e){return this._addCheck({kind:"cidr",...m.errToObj(e)})}datetime(e){var t,r;return typeof e=="string"?this._addCheck({kind:"datetime",precision:null,offset:!1,local:!1,message:e}):this._addCheck({kind:"datetime",precision:typeof e?.precision>"u"?null:e?.precision,offset:(t=e?.offset)!==null&&t!==void 0?t:!1,local:(r=e?.local)!==null&&r!==void 0?r:!1,...m.errToObj(e?.message)})}date(e){return this._addCheck({kind:"date",message:e})}time(e){return typeof e=="string"?this._addCheck({kind:"time",precision:null,message:e}):this._addCheck({kind:"time",precision:typeof e?.precision>"u"?null:e?.precision,...m.errToObj(e?.message)})}duration(e){return this._addCheck({kind:"duration",...m.errToObj(e)})}regex(e,t){return this._addCheck({kind:"regex",regex:e,...m.errToObj(t)})}includes(e,t){return this._addCheck({kind:"includes",value:e,position:t?.position,...m.errToObj(t?.message)})}startsWith(e,t){return this._addCheck({kind:"startsWith",value:e,...m.errToObj(t)})}endsWith(e,t){return this._addCheck({kind:"endsWith",value:e,...m.errToObj(t)})}min(e,t){return this._addCheck({kind:"min",value:e,...m.errToObj(t)})}max(e,t){return this._addCheck({kind:"max",value:e,...m.errToObj(t)})}length(e,t){return this._addCheck({kind:"length",value:e,...m.errToObj(t)})}nonempty(e){return this.min(1,m.errToObj(e))}trim(){return new n({...this._def,checks:[...this._def.checks,{kind:"trim"}]})}toLowerCase(){return new n({...this._def,checks:[...this._def.checks,{kind:"toLowerCase"}]})}toUpperCase(){return new n({...this._def,checks:[...this._def.checks,{kind:"toUpperCase"}]})}get isDatetime(){return!!this._def.checks.find(e=>e.kind==="datetime")}get isDate(){return!!this._def.checks.find(e=>e.kind==="date")}get isTime(){return!!this._def.checks.find(e=>e.kind==="time")}get isDuration(){return!!this._def.checks.find(e=>e.kind==="duration")}get isEmail(){return!!this._def.checks.find(e=>e.kind==="email")}get isURL(){return!!this._def.checks.find(e=>e.kind==="url")}get isEmoji(){return!!this._def.checks.find(e=>e.kind==="emoji")}get isUUID(){return!!this._def.checks.find(e=>e.kind==="uuid")}get isNANOID(){return!!this._def.checks.find(e=>e.kind==="nanoid")}get isCUID(){return!!this._def.checks.find(e=>e.kind==="cuid")}get isCUID2(){return!!this._def.checks.find(e=>e.kind==="cuid2")}get isULID(){return!!this._def.checks.find(e=>e.kind==="ulid")}get isIP(){return!!this._def.checks.find(e=>e.kind==="ip")}get isCIDR(){return!!this._def.checks.find(e=>e.kind==="cidr")}get isBase64(){return!!this._def.checks.find(e=>e.kind==="base64")}get isBase64url(){return!!this._def.checks.find(e=>e.kind==="base64url")}get minLength(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxLength(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}};B.create=n=>{var e;return new B({checks:[],typeName:h.ZodString,coerce:(e=n?.coerce)!==null&&e!==void 0?e:!1,...v(n)})};function Zn(n,e){let t=(n.toString().split(".")[1]||"").length,r=(e.toString().split(".")[1]||"").length,s=t>r?t:r,a=parseInt(n.toFixed(s).replace(".","")),i=parseInt(e.toFixed(s).replace(".",""));return a%i/Math.pow(10,s)}var W=class n extends _{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte,this.step=this.multipleOf}_parse(e){if(this._def.coerce&&(e.data=Number(e.data)),this._getType(e)!==f.number){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.number,received:a.parsedType}),g}let r,s=new k;for(let a of this._def.checks)a.kind==="int"?x.isInteger(e.data)||(r=this._getOrReturnCtx(e,r),l(r,{code:d.invalid_type,expected:"integer",received:"float",message:a.message}),s.dirty()):a.kind==="min"?(a.inclusive?e.data<a.value:e.data<=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_small,minimum:a.value,type:"number",inclusive:a.inclusive,exact:!1,message:a.message}),s.dirty()):a.kind==="max"?(a.inclusive?e.data>a.value:e.data>=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_big,maximum:a.value,type:"number",inclusive:a.inclusive,exact:!1,message:a.message}),s.dirty()):a.kind==="multipleOf"?Zn(e.data,a.value)!==0&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_multiple_of,multipleOf:a.value,message:a.message}),s.dirty()):a.kind==="finite"?Number.isFinite(e.data)||(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_finite,message:a.message}),s.dirty()):x.assertNever(a);return{status:s.value,value:e.data}}gte(e,t){return this.setLimit("min",e,!0,m.toString(t))}gt(e,t){return this.setLimit("min",e,!1,m.toString(t))}lte(e,t){return this.setLimit("max",e,!0,m.toString(t))}lt(e,t){return this.setLimit("max",e,!1,m.toString(t))}setLimit(e,t,r,s){return new n({...this._def,checks:[...this._def.checks,{kind:e,value:t,inclusive:r,message:m.toString(s)}]})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}int(e){return this._addCheck({kind:"int",message:m.toString(e)})}positive(e){return this._addCheck({kind:"min",value:0,inclusive:!1,message:m.toString(e)})}negative(e){return this._addCheck({kind:"max",value:0,inclusive:!1,message:m.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:0,inclusive:!0,message:m.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:0,inclusive:!0,message:m.toString(e)})}multipleOf(e,t){return this._addCheck({kind:"multipleOf",value:e,message:m.toString(t)})}finite(e){return this._addCheck({kind:"finite",message:m.toString(e)})}safe(e){return this._addCheck({kind:"min",inclusive:!0,value:Number.MIN_SAFE_INTEGER,message:m.toString(e)})._addCheck({kind:"max",inclusive:!0,value:Number.MAX_SAFE_INTEGER,message:m.toString(e)})}get minValue(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxValue(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}get isInt(){return!!this._def.checks.find(e=>e.kind==="int"||e.kind==="multipleOf"&&x.isInteger(e.value))}get isFinite(){let e=null,t=null;for(let r of this._def.checks){if(r.kind==="finite"||r.kind==="int"||r.kind==="multipleOf")return!0;r.kind==="min"?(t===null||r.value>t)&&(t=r.value):r.kind==="max"&&(e===null||r.value<e)&&(e=r.value)}return Number.isFinite(t)&&Number.isFinite(e)}};W.create=n=>new W({checks:[],typeName:h.ZodNumber,coerce:n?.coerce||!1,...v(n)});var H=class n extends _{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte}_parse(e){if(this._def.coerce)try{e.data=BigInt(e.data)}catch{return this._getInvalidInput(e)}if(this._getType(e)!==f.bigint)return this._getInvalidInput(e);let r,s=new k;for(let a of this._def.checks)a.kind==="min"?(a.inclusive?e.data<a.value:e.data<=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_small,type:"bigint",minimum:a.value,inclusive:a.inclusive,message:a.message}),s.dirty()):a.kind==="max"?(a.inclusive?e.data>a.value:e.data>=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_big,type:"bigint",maximum:a.value,inclusive:a.inclusive,message:a.message}),s.dirty()):a.kind==="multipleOf"?e.data%a.value!==BigInt(0)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_multiple_of,multipleOf:a.value,message:a.message}),s.dirty()):x.assertNever(a);return{status:s.value,value:e.data}}_getInvalidInput(e){let t=this._getOrReturnCtx(e);return l(t,{code:d.invalid_type,expected:f.bigint,received:t.parsedType}),g}gte(e,t){return this.setLimit("min",e,!0,m.toString(t))}gt(e,t){return this.setLimit("min",e,!1,m.toString(t))}lte(e,t){return this.setLimit("max",e,!0,m.toString(t))}lt(e,t){return this.setLimit("max",e,!1,m.toString(t))}setLimit(e,t,r,s){return new n({...this._def,checks:[...this._def.checks,{kind:e,value:t,inclusive:r,message:m.toString(s)}]})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}positive(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!1,message:m.toString(e)})}negative(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!1,message:m.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!0,message:m.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!0,message:m.toString(e)})}multipleOf(e,t){return this._addCheck({kind:"multipleOf",value:e,message:m.toString(t)})}get minValue(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxValue(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}};H.create=n=>{var e;return new H({checks:[],typeName:h.ZodBigInt,coerce:(e=n?.coerce)!==null&&e!==void 0?e:!1,...v(n)})};var G=class extends _{_parse(e){if(this._def.coerce&&(e.data=!!e.data),this._getType(e)!==f.boolean){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.boolean,received:r.parsedType}),g}return S(e.data)}};G.create=n=>new G({typeName:h.ZodBoolean,coerce:n?.coerce||!1,...v(n)});var Q=class n extends _{_parse(e){if(this._def.coerce&&(e.data=new Date(e.data)),this._getType(e)!==f.date){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.date,received:a.parsedType}),g}if(isNaN(e.data.getTime())){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_date}),g}let r=new k,s;for(let a of this._def.checks)a.kind==="min"?e.data.getTime()<a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_small,message:a.message,inclusive:!0,exact:!1,minimum:a.value,type:"date"}),r.dirty()):a.kind==="max"?e.data.getTime()>a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_big,message:a.message,inclusive:!0,exact:!1,maximum:a.value,type:"date"}),r.dirty()):x.assertNever(a);return{status:r.value,value:new Date(e.data.getTime())}}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}min(e,t){return this._addCheck({kind:"min",value:e.getTime(),message:m.toString(t)})}max(e,t){return this._addCheck({kind:"max",value:e.getTime(),message:m.toString(t)})}get minDate(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e!=null?new Date(e):null}get maxDate(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e!=null?new Date(e):null}};Q.create=n=>new Q({checks:[],coerce:n?.coerce||!1,typeName:h.ZodDate,...v(n)});var ge=class extends _{_parse(e){if(this._getType(e)!==f.symbol){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.symbol,received:r.parsedType}),g}return S(e.data)}};ge.create=n=>new ge({typeName:h.ZodSymbol,...v(n)});var Y=class extends _{_parse(e){if(this._getType(e)!==f.undefined){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.undefined,received:r.parsedType}),g}return S(e.data)}};Y.create=n=>new Y({typeName:h.ZodUndefined,...v(n)});var K=class extends _{_parse(e){if(this._getType(e)!==f.null){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.null,received:r.parsedType}),g}return S(e.data)}};K.create=n=>new K({typeName:h.ZodNull,...v(n)});var z=class extends _{constructor(){super(...arguments),this._any=!0}_parse(e){return S(e.data)}};z.create=n=>new z({typeName:h.ZodAny,...v(n)});var Z=class extends _{constructor(){super(...arguments),this._unknown=!0}_parse(e){return S(e.data)}};Z.create=n=>new Z({typeName:h.ZodUnknown,...v(n)});var R=class extends _{_parse(e){let t=this._getOrReturnCtx(e);return l(t,{code:d.invalid_type,expected:f.never,received:t.parsedType}),g}};R.create=n=>new R({typeName:h.ZodNever,...v(n)});var ye=class extends _{_parse(e){if(this._getType(e)!==f.undefined){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.void,received:r.parsedType}),g}return S(e.data)}};ye.create=n=>new ye({typeName:h.ZodVoid,...v(n)});var L=class n extends _{_parse(e){let{ctx:t,status:r}=this._processInputParams(e),s=this._def;if(t.parsedType!==f.array)return l(t,{code:d.invalid_type,expected:f.array,received:t.parsedType}),g;if(s.exactLength!==null){let i=t.data.length>s.exactLength.value,o=t.data.length<s.exactLength.value;(i||o)&&(l(t,{code:i?d.too_big:d.too_small,minimum:o?s.exactLength.value:void 0,maximum:i?s.exactLength.value:void 0,type:"array",inclusive:!0,exact:!0,message:s.exactLength.message}),r.dirty())}if(s.minLength!==null&&t.data.length<s.minLength.value&&(l(t,{code:d.too_small,minimum:s.minLength.value,type:"array",inclusive:!0,exact:!1,message:s.minLength.message}),r.dirty()),s.maxLength!==null&&t.data.length>s.maxLength.value&&(l(t,{code:d.too_big,maximum:s.maxLength.value,type:"array",inclusive:!0,exact:!1,message:s.maxLength.message}),r.dirty()),t.common.async)return Promise.all([...t.data].map((i,o)=>s.type._parseAsync(new O(t,i,t.path,o)))).then(i=>k.mergeArray(r,i));let a=[...t.data].map((i,o)=>s.type._parseSync(new O(t,i,t.path,o)));return k.mergeArray(r,a)}get element(){return this._def.type}min(e,t){return new n({...this._def,minLength:{value:e,message:m.toString(t)}})}max(e,t){return new n({...this._def,maxLength:{value:e,message:m.toString(t)}})}length(e,t){return new n({...this._def,exactLength:{value:e,message:m.toString(t)}})}nonempty(e){return this.min(1,e)}};L.create=(n,e)=>new L({type:n,minLength:null,maxLength:null,exactLength:null,typeName:h.ZodArray,...v(e)});function pe(n){if(n instanceof T){let e={};for(let t in n.shape){let r=n.shape[t];e[t]=A.create(pe(r))}return new T({...n._def,shape:()=>e})}else return n instanceof L?new L({...n._def,type:pe(n.element)}):n instanceof A?A.create(pe(n.unwrap())):n instanceof j?j.create(pe(n.unwrap())):n instanceof N?N.create(n.items.map(e=>pe(e))):n}var T=class n extends _{constructor(){super(...arguments),this._cached=null,this.nonstrict=this.passthrough,this.augment=this.extend}_getCached(){if(this._cached!==null)return this._cached;let e=this._def.shape(),t=x.objectKeys(e);return this._cached={shape:e,keys:t}}_parse(e){if(this._getType(e)!==f.object){let c=this._getOrReturnCtx(e);return l(c,{code:d.invalid_type,expected:f.object,received:c.parsedType}),g}let{status:r,ctx:s}=this._processInputParams(e),{shape:a,keys:i}=this._getCached(),o=[];if(!(this._def.catchall instanceof R&&this._def.unknownKeys==="strip"))for(let c in s.data)i.includes(c)||o.push(c);let u=[];for(let c of i){let p=a[c],b=s.data[c];u.push({key:{status:"valid",value:c},value:p._parse(new O(s,b,s.path,c)),alwaysSet:c in s.data})}if(this._def.catchall instanceof R){let c=this._def.unknownKeys;if(c==="passthrough")for(let p of o)u.push({key:{status:"valid",value:p},value:{status:"valid",value:s.data[p]}});else if(c==="strict")o.length>0&&(l(s,{code:d.unrecognized_keys,keys:o}),r.dirty());else if(c!=="strip")throw new Error("Internal ZodObject error: invalid unknownKeys value.")}else{let c=this._def.catchall;for(let p of o){let b=s.data[p];u.push({key:{status:"valid",value:p},value:c._parse(new O(s,b,s.path,p)),alwaysSet:p in s.data})}}return s.common.async?Promise.resolve().then(async()=>{let c=[];for(let p of u){let b=await p.key,I=await p.value;c.push({key:b,value:I,alwaysSet:p.alwaysSet})}return c}).then(c=>k.mergeObjectSync(r,c)):k.mergeObjectSync(r,u)}get shape(){return this._def.shape()}strict(e){return m.errToObj,new n({...this._def,unknownKeys:"strict",...e!==void 0?{errorMap:(t,r)=>{var s,a,i,o;let u=(i=(a=(s=this._def).errorMap)===null||a===void 0?void 0:a.call(s,t,r).message)!==null&&i!==void 0?i:r.defaultError;return t.code==="unrecognized_keys"?{message:(o=m.errToObj(e).message)!==null&&o!==void 0?o:u}:{message:u}}}:{}})}strip(){return new n({...this._def,unknownKeys:"strip"})}passthrough(){return new n({...this._def,unknownKeys:"passthrough"})}extend(e){return new n({...this._def,shape:()=>({...this._def.shape(),...e})})}merge(e){return new n({unknownKeys:e._def.unknownKeys,catchall:e._def.catchall,shape:()=>({...this._def.shape(),...e._def.shape()}),typeName:h.ZodObject})}setKey(e,t){return this.augment({[e]:t})}catchall(e){return new n({...this._def,catchall:e})}pick(e){let t={};return x.objectKeys(e).forEach(r=>{e[r]&&this.shape[r]&&(t[r]=this.shape[r])}),new n({...this._def,shape:()=>t})}omit(e){let t={};return x.objectKeys(this.shape).forEach(r=>{e[r]||(t[r]=this.shape[r])}),new n({...this._def,shape:()=>t})}deepPartial(){return pe(this)}partial(e){let t={};return x.objectKeys(this.shape).forEach(r=>{let s=this.shape[r];e&&!e[r]?t[r]=s:t[r]=s.optional()}),new n({...this._def,shape:()=>t})}required(e){let t={};return x.objectKeys(this.shape).forEach(r=>{if(e&&!e[r])t[r]=this.shape[r];else{let a=this.shape[r];for(;a instanceof A;)a=a._def.innerType;t[r]=a}}),new n({...this._def,shape:()=>t})}keyof(){return wt(x.objectKeys(this.shape))}};T.create=(n,e)=>new T({shape:()=>n,unknownKeys:"strip",catchall:R.create(),typeName:h.ZodObject,...v(e)});T.strictCreate=(n,e)=>new T({shape:()=>n,unknownKeys:"strict",catchall:R.create(),typeName:h.ZodObject,...v(e)});T.lazycreate=(n,e)=>new T({shape:n,unknownKeys:"strip",catchall:R.create(),typeName:h.ZodObject,...v(e)});var X=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=this._def.options;function s(a){for(let o of a)if(o.result.status==="valid")return o.result;for(let o of a)if(o.result.status==="dirty")return t.common.issues.push(...o.ctx.common.issues),o.result;let i=a.map(o=>new E(o.ctx.common.issues));return l(t,{code:d.invalid_union,unionErrors:i}),g}if(t.common.async)return Promise.all(r.map(async a=>{let i={...t,common:{...t.common,issues:[]},parent:null};return{result:await a._parseAsync({data:t.data,path:t.path,parent:i}),ctx:i}})).then(s);{let a,i=[];for(let u of r){let c={...t,common:{...t.common,issues:[]},parent:null},p=u._parseSync({data:t.data,path:t.path,parent:c});if(p.status==="valid")return p;p.status==="dirty"&&!a&&(a={result:p,ctx:c}),c.common.issues.length&&i.push(c.common.issues)}if(a)return t.common.issues.push(...a.ctx.common.issues),a.result;let o=i.map(u=>new E(u));return l(t,{code:d.invalid_union,unionErrors:o}),g}}get options(){return this._def.options}};X.create=(n,e)=>new X({options:n,typeName:h.ZodUnion,...v(e)});var V=n=>n instanceof te?V(n.schema):n instanceof C?V(n.innerType()):n instanceof ne?[n.value]:n instanceof re?n.options:n instanceof se?x.objectValues(n.enum):n instanceof ae?V(n._def.innerType):n instanceof Y?[void 0]:n instanceof K?[null]:n instanceof A?[void 0,...V(n.unwrap())]:n instanceof j?[null,...V(n.unwrap())]:n instanceof Ce||n instanceof oe?V(n.unwrap()):n instanceof ie?V(n._def.innerType):[],$e=class n extends _{_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.object)return l(t,{code:d.invalid_type,expected:f.object,received:t.parsedType}),g;let r=this.discriminator,s=t.data[r],a=this.optionsMap.get(s);return a?t.common.async?a._parseAsync({data:t.data,path:t.path,parent:t}):a._parseSync({data:t.data,path:t.path,parent:t}):(l(t,{code:d.invalid_union_discriminator,options:Array.from(this.optionsMap.keys()),path:[r]}),g)}get discriminator(){return this._def.discriminator}get options(){return this._def.options}get optionsMap(){return this._def.optionsMap}static create(e,t,r){let s=new Map;for(let a of t){let i=V(a.shape[e]);if(!i.length)throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);for(let o of i){if(s.has(o))throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);s.set(o,a)}}return new n({typeName:h.ZodDiscriminatedUnion,discriminator:e,options:t,optionsMap:s,...v(r)})}};function st(n,e){let t=U(n),r=U(e);if(n===e)return{valid:!0,data:n};if(t===f.object&&r===f.object){let s=x.objectKeys(e),a=x.objectKeys(n).filter(o=>s.indexOf(o)!==-1),i={...n,...e};for(let o of a){let u=st(n[o],e[o]);if(!u.valid)return{valid:!1};i[o]=u.data}return{valid:!0,data:i}}else if(t===f.array&&r===f.array){if(n.length!==e.length)return{valid:!1};let s=[];for(let a=0;a<n.length;a++){let i=n[a],o=e[a],u=st(i,o);if(!u.valid)return{valid:!1};s.push(u.data)}return{valid:!0,data:s}}else return t===f.date&&r===f.date&&+n==+e?{valid:!0,data:n}:{valid:!1}}var ee=class extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e),s=(a,i)=>{if(nt(a)||nt(i))return g;let o=st(a.value,i.value);return o.valid?((rt(a)||rt(i))&&t.dirty(),{status:t.value,value:o.data}):(l(r,{code:d.invalid_intersection_types}),g)};return r.common.async?Promise.all([this._def.left._parseAsync({data:r.data,path:r.path,parent:r}),this._def.right._parseAsync({data:r.data,path:r.path,parent:r})]).then(([a,i])=>s(a,i)):s(this._def.left._parseSync({data:r.data,path:r.path,parent:r}),this._def.right._parseSync({data:r.data,path:r.path,parent:r}))}};ee.create=(n,e,t)=>new ee({left:n,right:e,typeName:h.ZodIntersection,...v(t)});var N=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.array)return l(r,{code:d.invalid_type,expected:f.array,received:r.parsedType}),g;if(r.data.length<this._def.items.length)return l(r,{code:d.too_small,minimum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),g;!this._def.rest&&r.data.length>this._def.items.length&&(l(r,{code:d.too_big,maximum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),t.dirty());let a=[...r.data].map((i,o)=>{let u=this._def.items[o]||this._def.rest;return u?u._parse(new O(r,i,r.path,o)):null}).filter(i=>!!i);return r.common.async?Promise.all(a).then(i=>k.mergeArray(t,i)):k.mergeArray(t,a)}get items(){return this._def.items}rest(e){return new n({...this._def,rest:e})}};N.create=(n,e)=>{if(!Array.isArray(n))throw new Error("You must pass an array of schemas to z.tuple([ ... ])");return new N({items:n,typeName:h.ZodTuple,rest:null,...v(e)})};var Be=class n extends _{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.object)return l(r,{code:d.invalid_type,expected:f.object,received:r.parsedType}),g;let s=[],a=this._def.keyType,i=this._def.valueType;for(let o in r.data)s.push({key:a._parse(new O(r,o,r.path,o)),value:i._parse(new O(r,r.data[o],r.path,o)),alwaysSet:o in r.data});return r.common.async?k.mergeObjectAsync(t,s):k.mergeObjectSync(t,s)}get element(){return this._def.valueType}static create(e,t,r){return t instanceof _?new n({keyType:e,valueType:t,typeName:h.ZodRecord,...v(r)}):new n({keyType:B.create(),valueType:e,typeName:h.ZodRecord,...v(t)})}},ve=class extends _{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.map)return l(r,{code:d.invalid_type,expected:f.map,received:r.parsedType}),g;let s=this._def.keyType,a=this._def.valueType,i=[...r.data.entries()].map(([o,u],c)=>({key:s._parse(new O(r,o,r.path,[c,"key"])),value:a._parse(new O(r,u,r.path,[c,"value"]))}));if(r.common.async){let o=new Map;return Promise.resolve().then(async()=>{for(let u of i){let c=await u.key,p=await u.value;if(c.status==="aborted"||p.status==="aborted")return g;(c.status==="dirty"||p.status==="dirty")&&t.dirty(),o.set(c.value,p.value)}return{status:t.value,value:o}})}else{let o=new Map;for(let u of i){let c=u.key,p=u.value;if(c.status==="aborted"||p.status==="aborted")return g;(c.status==="dirty"||p.status==="dirty")&&t.dirty(),o.set(c.value,p.value)}return{status:t.value,value:o}}}};ve.create=(n,e,t)=>new ve({valueType:e,keyType:n,typeName:h.ZodMap,...v(t)});var _e=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.set)return l(r,{code:d.invalid_type,expected:f.set,received:r.parsedType}),g;let s=this._def;s.minSize!==null&&r.data.size<s.minSize.value&&(l(r,{code:d.too_small,minimum:s.minSize.value,type:"set",inclusive:!0,exact:!1,message:s.minSize.message}),t.dirty()),s.maxSize!==null&&r.data.size>s.maxSize.value&&(l(r,{code:d.too_big,maximum:s.maxSize.value,type:"set",inclusive:!0,exact:!1,message:s.maxSize.message}),t.dirty());let a=this._def.valueType;function i(u){let c=new Set;for(let p of u){if(p.status==="aborted")return g;p.status==="dirty"&&t.dirty(),c.add(p.value)}return{status:t.value,value:c}}let o=[...r.data.values()].map((u,c)=>a._parse(new O(r,u,r.path,c)));return r.common.async?Promise.all(o).then(u=>i(u)):i(o)}min(e,t){return new n({...this._def,minSize:{value:e,message:m.toString(t)}})}max(e,t){return new n({...this._def,maxSize:{value:e,message:m.toString(t)}})}size(e,t){return this.min(e,t).max(e,t)}nonempty(e){return this.min(1,e)}};_e.create=(n,e)=>new _e({valueType:n,minSize:null,maxSize:null,typeName:h.ZodSet,...v(e)});var ze=class n extends _{constructor(){super(...arguments),this.validate=this.implement}_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.function)return l(t,{code:d.invalid_type,expected:f.function,received:t.parsedType}),g;function r(o,u){return Ze({data:o,path:t.path,errorMaps:[t.common.contextualErrorMap,t.schemaErrorMap,Ue(),he].filter(c=>!!c),issueData:{code:d.invalid_arguments,argumentsError:u}})}function s(o,u){return Ze({data:o,path:t.path,errorMaps:[t.common.contextualErrorMap,t.schemaErrorMap,Ue(),he].filter(c=>!!c),issueData:{code:d.invalid_return_type,returnTypeError:u}})}let a={errorMap:t.common.contextualErrorMap},i=t.data;if(this._def.returns instanceof F){let o=this;return S(async function(...u){let c=new E([]),p=await o._def.args.parseAsync(u,a).catch(D=>{throw c.addIssue(r(u,D)),c}),b=await Reflect.apply(i,this,p);return await o._def.returns._def.type.parseAsync(b,a).catch(D=>{throw c.addIssue(s(b,D)),c})})}else{let o=this;return S(function(...u){let c=o._def.args.safeParse(u,a);if(!c.success)throw new E([r(u,c.error)]);let p=Reflect.apply(i,this,c.data),b=o._def.returns.safeParse(p,a);if(!b.success)throw new E([s(p,b.error)]);return b.data})}}parameters(){return this._def.args}returnType(){return this._def.returns}args(...e){return new n({...this._def,args:N.create(e).rest(Z.create())})}returns(e){return new n({...this._def,returns:e})}implement(e){return this.parse(e)}strictImplement(e){return this.parse(e)}static create(e,t,r){return new n({args:e||N.create([]).rest(Z.create()),returns:t||Z.create(),typeName:h.ZodFunction,...v(r)})}},te=class extends _{get schema(){return this._def.getter()}_parse(e){let{ctx:t}=this._processInputParams(e);return this._def.getter()._parse({data:t.data,path:t.path,parent:t})}};te.create=(n,e)=>new te({getter:n,typeName:h.ZodLazy,...v(e)});var ne=class extends _{_parse(e){if(e.data!==this._def.value){let t=this._getOrReturnCtx(e);return l(t,{received:t.data,code:d.invalid_literal,expected:this._def.value}),g}return{status:"valid",value:e.data}}get value(){return this._def.value}};ne.create=(n,e)=>new ne({value:n,typeName:h.ZodLiteral,...v(e)});function wt(n,e){return new re({values:n,typeName:h.ZodEnum,...v(e)})}var re=class n extends _{constructor(){super(...arguments),Se.set(this,void 0)}_parse(e){if(typeof e.data!="string"){let t=this._getOrReturnCtx(e),r=this._def.values;return l(t,{expected:x.joinValues(r),received:t.parsedType,code:d.invalid_type}),g}if(Le(this,Se,"f")||vt(this,Se,new Set(this._def.values),"f"),!Le(this,Se,"f").has(e.data)){let t=this._getOrReturnCtx(e),r=this._def.values;return l(t,{received:t.data,code:d.invalid_enum_value,options:r}),g}return S(e.data)}get options(){return this._def.values}get enum(){let e={};for(let t of this._def.values)e[t]=t;return e}get Values(){let e={};for(let t of this._def.values)e[t]=t;return e}get Enum(){let e={};for(let t of this._def.values)e[t]=t;return e}extract(e,t=this._def){return n.create(e,{...this._def,...t})}exclude(e,t=this._def){return n.create(this.options.filter(r=>!e.includes(r)),{...this._def,...t})}};Se=new WeakMap;re.create=wt;var se=class extends _{constructor(){super(...arguments),Te.set(this,void 0)}_parse(e){let t=x.getValidEnumValues(this._def.values),r=this._getOrReturnCtx(e);if(r.parsedType!==f.string&&r.parsedType!==f.number){let s=x.objectValues(t);return l(r,{expected:x.joinValues(s),received:r.parsedType,code:d.invalid_type}),g}if(Le(this,Te,"f")||vt(this,Te,new Set(x.getValidEnumValues(this._def.values)),"f"),!Le(this,Te,"f").has(e.data)){let s=x.objectValues(t);return l(r,{received:r.data,code:d.invalid_enum_value,options:s}),g}return S(e.data)}get enum(){return this._def.values}};Te=new WeakMap;se.create=(n,e)=>new se({values:n,typeName:h.ZodNativeEnum,...v(e)});var F=class extends _{unwrap(){return this._def.type}_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.promise&&t.common.async===!1)return l(t,{code:d.invalid_type,expected:f.promise,received:t.parsedType}),g;let r=t.parsedType===f.promise?t.data:Promise.resolve(t.data);return S(r.then(s=>this._def.type.parseAsync(s,{path:t.path,errorMap:t.common.contextualErrorMap})))}};F.create=(n,e)=>new F({type:n,typeName:h.ZodPromise,...v(e)});var C=class extends _{innerType(){return this._def.schema}sourceType(){return this._def.schema._def.typeName===h.ZodEffects?this._def.schema.sourceType():this._def.schema}_parse(e){let{status:t,ctx:r}=this._processInputParams(e),s=this._def.effect||null,a={addIssue:i=>{l(r,i),i.fatal?t.abort():t.dirty()},get path(){return r.path}};if(a.addIssue=a.addIssue.bind(a),s.type==="preprocess"){let i=s.transform(r.data,a);if(r.common.async)return Promise.resolve(i).then(async o=>{if(t.value==="aborted")return g;let u=await this._def.schema._parseAsync({data:o,path:r.path,parent:r});return u.status==="aborted"?g:u.status==="dirty"||t.value==="dirty"?me(u.value):u});{if(t.value==="aborted")return g;let o=this._def.schema._parseSync({data:i,path:r.path,parent:r});return o.status==="aborted"?g:o.status==="dirty"||t.value==="dirty"?me(o.value):o}}if(s.type==="refinement"){let i=o=>{let u=s.refinement(o,a);if(r.common.async)return Promise.resolve(u);if(u instanceof Promise)throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");return o};if(r.common.async===!1){let o=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});return o.status==="aborted"?g:(o.status==="dirty"&&t.dirty(),i(o.value),{status:t.value,value:o.value})}else return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then(o=>o.status==="aborted"?g:(o.status==="dirty"&&t.dirty(),i(o.value).then(()=>({status:t.value,value:o.value}))))}if(s.type==="transform")if(r.common.async===!1){let i=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});if(!J(i))return i;let o=s.transform(i.value,a);if(o instanceof Promise)throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");return{status:t.value,value:o}}else return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then(i=>J(i)?Promise.resolve(s.transform(i.value,a)).then(o=>({status:t.value,value:o})):i);x.assertNever(s)}};C.create=(n,e,t)=>new C({schema:n,typeName:h.ZodEffects,effect:e,...v(t)});C.createWithPreprocess=(n,e,t)=>new C({schema:e,effect:{type:"preprocess",transform:n},typeName:h.ZodEffects,...v(t)});var A=class extends _{_parse(e){return this._getType(e)===f.undefined?S(void 0):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}};A.create=(n,e)=>new A({innerType:n,typeName:h.ZodOptional,...v(e)});var j=class extends _{_parse(e){return this._getType(e)===f.null?S(null):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}};j.create=(n,e)=>new j({innerType:n,typeName:h.ZodNullable,...v(e)});var ae=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=t.data;return t.parsedType===f.undefined&&(r=this._def.defaultValue()),this._def.innerType._parse({data:r,path:t.path,parent:t})}removeDefault(){return this._def.innerType}};ae.create=(n,e)=>new ae({innerType:n,typeName:h.ZodDefault,defaultValue:typeof e.default=="function"?e.default:()=>e.default,...v(e)});var ie=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r={...t,common:{...t.common,issues:[]}},s=this._def.innerType._parse({data:r.data,path:r.path,parent:{...r}});return Ee(s)?s.then(a=>({status:"valid",value:a.status==="valid"?a.value:this._def.catchValue({get error(){return new E(r.common.issues)},input:r.data})})):{status:"valid",value:s.status==="valid"?s.value:this._def.catchValue({get error(){return new E(r.common.issues)},input:r.data})}}removeCatch(){return this._def.innerType}};ie.create=(n,e)=>new ie({innerType:n,typeName:h.ZodCatch,catchValue:typeof e.catch=="function"?e.catch:()=>e.catch,...v(e)});var xe=class extends _{_parse(e){if(this._getType(e)!==f.nan){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.nan,received:r.parsedType}),g}return{status:"valid",value:e.data}}};xe.create=n=>new xe({typeName:h.ZodNaN,...v(n)});var Ln=Symbol("zod_brand"),Ce=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=t.data;return this._def.type._parse({data:r,path:t.path,parent:t})}unwrap(){return this._def.type}},Ie=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.common.async)return(async()=>{let a=await this._def.in._parseAsync({data:r.data,path:r.path,parent:r});return a.status==="aborted"?g:a.status==="dirty"?(t.dirty(),me(a.value)):this._def.out._parseAsync({data:a.value,path:r.path,parent:r})})();{let s=this._def.in._parseSync({data:r.data,path:r.path,parent:r});return s.status==="aborted"?g:s.status==="dirty"?(t.dirty(),{status:"dirty",value:s.value}):this._def.out._parseSync({data:s.value,path:r.path,parent:r})}}static create(e,t){return new n({in:e,out:t,typeName:h.ZodPipeline})}},oe=class extends _{_parse(e){let t=this._def.innerType._parse(e),r=s=>(J(s)&&(s.value=Object.freeze(s.value)),s);return Ee(t)?t.then(s=>r(s)):r(t)}unwrap(){return this._def.innerType}};oe.create=(n,e)=>new oe({innerType:n,typeName:h.ZodReadonly,...v(e)});function ht(n,e){let t=typeof n=="function"?n(e):typeof n=="string"?{message:n}:n;return typeof t=="string"?{message:t}:t}function kt(n,e={},t){return n?z.create().superRefine((r,s)=>{var a,i;let o=n(r);if(o instanceof Promise)return o.then(u=>{var c,p;if(!u){let b=ht(e,r),I=(p=(c=b.fatal)!==null&&c!==void 0?c:t)!==null&&p!==void 0?p:!0;s.addIssue({code:"custom",...b,fatal:I})}});if(!o){let u=ht(e,r),c=(i=(a=u.fatal)!==null&&a!==void 0?a:t)!==null&&i!==void 0?i:!0;s.addIssue({code:"custom",...u,fatal:c})}}):z.create()}var $n={object:T.lazycreate},h;(function(n){n.ZodString="ZodString",n.ZodNumber="ZodNumber",n.ZodNaN="ZodNaN",n.ZodBigInt="ZodBigInt",n.ZodBoolean="ZodBoolean",n.ZodDate="ZodDate",n.ZodSymbol="ZodSymbol",n.ZodUndefined="ZodUndefined",n.ZodNull="ZodNull",n.ZodAny="ZodAny",n.ZodUnknown="ZodUnknown",n.ZodNever="ZodNever",n.ZodVoid="ZodVoid",n.ZodArray="ZodArray",n.ZodObject="ZodObject",n.ZodUnion="ZodUnion",n.ZodDiscriminatedUnion="ZodDiscriminatedUnion",n.ZodIntersection="ZodIntersection",n.ZodTuple="ZodTuple",n.ZodRecord="ZodRecord",n.ZodMap="ZodMap",n.ZodSet="ZodSet",n.ZodFunction="ZodFunction",n.ZodLazy="ZodLazy",n.ZodLiteral="ZodLiteral",n.ZodEnum="ZodEnum",n.ZodEffects="ZodEffects",n.ZodNativeEnum="ZodNativeEnum",n.ZodOptional="ZodOptional",n.ZodNullable="ZodNullable",n.ZodDefault="ZodDefault",n.ZodCatch="ZodCatch",n.ZodPromise="ZodPromise",n.ZodBranded="ZodBranded",n.ZodPipeline="ZodPipeline",n.ZodReadonly="ZodReadonly"})(h||(h={}));var Bn=(n,e={message:`Input not instance of ${n.name}`})=>kt(t=>t instanceof n,e),St=B.create,Tt=W.create,zn=xe.create,Fn=H.create,Et=G.create,qn=Q.create,Jn=ge.create,Wn=Y.create,Hn=K.create,Gn=z.create,Qn=Z.create,Yn=R.create,Kn=ye.create,Xn=L.create,er=T.create,tr=T.strictCreate,nr=X.create,rr=$e.create,sr=ee.create,ar=N.create,ir=Be.create,or=ve.create,cr=_e.create,dr=ze.create,ur=te.create,lr=ne.create,fr=re.create,pr=se.create,mr=F.create,gt=C.create,hr=A.create,gr=j.create,yr=C.createWithPreprocess,vr=Ie.create,_r=()=>St().optional(),xr=()=>Tt().optional(),br=()=>Et().optional(),wr={string:n=>B.create({...n,coerce:!0}),number:n=>W.create({...n,coerce:!0}),boolean:n=>G.create({...n,coerce:!0}),bigint:n=>H.create({...n,coerce:!0}),date:n=>Q.create({...n,coerce:!0})},kr=g,y=Object.freeze({__proto__:null,defaultErrorMap:he,setErrorMap:yn,getErrorMap:Ue,makeIssue:Ze,EMPTY_PATH:vn,addIssueToContext:l,ParseStatus:k,INVALID:g,DIRTY:me,OK:S,isAborted:nt,isDirty:rt,isValid:J,isAsync:Ee,get util(){return x},get objectUtil(){return tt},ZodParsedType:f,getParsedType:U,ZodType:_,datetimeRegex:bt,ZodString:B,ZodNumber:W,ZodBigInt:H,ZodBoolean:G,ZodDate:Q,ZodSymbol:ge,ZodUndefined:Y,ZodNull:K,ZodAny:z,ZodUnknown:Z,ZodNever:R,ZodVoid:ye,ZodArray:L,ZodObject:T,ZodUnion:X,ZodDiscriminatedUnion:$e,ZodIntersection:ee,ZodTuple:N,ZodRecord:Be,ZodMap:ve,ZodSet:_e,ZodFunction:ze,ZodLazy:te,ZodLiteral:ne,ZodEnum:re,ZodNativeEnum:se,ZodPromise:F,ZodEffects:C,ZodTransformer:C,ZodOptional:A,ZodNullable:j,ZodDefault:ae,ZodCatch:ie,ZodNaN:xe,BRAND:Ln,ZodBranded:Ce,ZodPipeline:Ie,ZodReadonly:oe,custom:kt,Schema:_,ZodSchema:_,late:$n,get ZodFirstPartyTypeKind(){return h},coerce:wr,any:Gn,array:Xn,bigint:Fn,boolean:Et,date:qn,discriminatedUnion:rr,effect:gt,enum:fr,function:dr,instanceof:Bn,intersection:sr,lazy:ur,literal:lr,map:or,nan:zn,nativeEnum:pr,never:Yn,null:Hn,nullable:gr,number:Tt,object:er,oboolean:br,onumber:xr,optional:hr,ostring:_r,pipeline:vr,preprocess:yr,promise:mr,record:ir,set:cr,strictObject:tr,string:St,symbol:Jn,transformer:gt,tuple:ar,undefined:Wn,union:nr,unknown:Qn,void:Kn,NEVER:kr,ZodIssueCode:d,quotelessJson:gn,ZodError:E});function Ct(){let n="",e="abcdefghijklmnopqrstuvwxyz0123456789";for(let t=0;t<36;t++)Math.random()>.8&&t!==0&&t!==35&&n[t-1]!=="-"?n+="-":n+=e.charAt(Math.floor(Math.random()*e.length));return n}var Sr=()=>{let n=new Date().getTime();return typeof performance<"u"&&typeof performance.now=="function"&&(n+=performance.now()),"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,e=>{let t=(n+Math.random()*16)%16|0;return n=Math.floor(n/16),(e==="x"?t:t&3|8).toString(16)})},Ae=()=>{try{let n=Sr();return n||Ct()}catch(n){console.error(n)}return Ct()},It=()=>Ae(),At=()=>Ae(),Ot=()=>Ae();var ce={GI:"GI",MMT:"MMT"};var at=class n{constructor(){this.settings={}}static getInstance(){return n.instance||(n.instance=new n,Object.freeze(n.instance)),n.instance}setSetting(e,t){this.settings[e]=t}getSetting(e){return this.settings[e]}},q=at.getInstance();function Rt(){return typeof window<"u"}function de(n){let e={};for(let t in n)if(Object.prototype.hasOwnProperty.call(n,t)){let r=n[t];r!=null&&r!=="NA"&&r!==""&&(typeof r!="object"||Object.keys(r).length>0)&&(!Array.isArray(r)||r.length>0)&&(e[t]=r)}return e}function w(n,e){let t=n.split("; ");for(let r=0;r<t.length;r++){let s=t[r];if(s.indexOf(e+"=")===0)return s.substring(e.length+1)}return null}function Dt(n,e){try{let t="",r=0;if(!e)throw new Error("Key is empty");for(let s=0;s<n.length;s+=1){let a=n.charCodeAt(s),i=e.charCodeAt(r),o=a^i;t+=String.fromCharCode(o),r=(r+1)%e.length}return t}catch(t){return console.error("An error occurred during the decryption process:",t),null}}function it(){let n=sessionStorage.getItem("userInfo");if(!n)return console.log("userInfo is not found in sessionStorage"),null;let e=new RegExp("^enct-"),t=n.replace(e,""),r=Dt(t,"awefewfuihewfhewfuhiebc");if(!r)return console.error("Decryption failed"),null;try{return JSON.parse(r)}catch(s){return console.error("Error parsing JSON:",s),null}}function Tr(n){let e=localStorage.getItem("userInfo");if(!e)return console.log("userInfo is not found in localStorage"),null;if(!n)return JSON.parse(e);let t=new RegExp("^enct-"),r=e.replace(t,""),s=Dt(r,"awefewfuihewfhewfuhiebc");if(!s)return console.error("Decryption failed"),null;try{return JSON.parse(s)}catch(a){return console.error("Error parsing JSON:",a),null}}function Nt(){let n="marketingCloudVisitorID",e=window?.s?.marketingCloudVisitorID,t=localStorage.getItem(n),r=w(document?.cookie,"s_ecid");return r?decodeURI(r)?.split("|")[1]:e?(e!=t&&localStorage.setItem(n,e),e):t||"NA"}function Fe(){return it()||Tr()}function Oe(n){if(!n)return null;let{uuid:e="",profile_type:t="PERSONAL"}=n;return t&&e?`${e}/${t.toUpperCase()}`:null}function Er(n){let t=window.location.search.substring(1).split("&");for(let r=0;r<t.length;r++){let s=t[r].split("="),a=decodeURIComponent(s[0]),i=decodeURIComponent(s[1]);if(a===n)return i}}function ot(){let n=Er("cmp");return n?{campaign_key:n}:null}function Pe(n){let t=(typeof window<"u"?n||window.location.hostname:"")?.split(".")?.slice(-2)?.join(".");return/^https?:\/\//i.test(n)||(n=`https://${n}`),n?.replace(/:\/\/[^/]+/,`://pdt.${t}`)}function jt(n,e){let t=e||(typeof window<"u"?window.location.hostname:""),r={};return Mt(t)&&(r={"entity-name":t&&t.includes(".global")?"global":"india"}),{...n,...r}}var Cr={in:"inr",ae:"aed",sa:"sar"};function Ir(){return(typeof window<"u"?window.location.hostname:"").includes("goibibo")}function Mt(n){return(n||(typeof window<"u"?window.location.hostname:"")).includes("makemytrip")}function Ar(){return{entity:"india",currency:"inr",region:"in",user_language:"eng",organisation:"gi"}}function Pt(){let n=typeof window<"u"?window.location.hostname:"",e=n&&n.includes(".global")?"global":"india",t=Re(),{region:r,userCountry:s,language:a,userCurrency:i,currency:o}=t;return{entity:e,currency:o,region:r,user_currency:i,user_country:s,user_language:a,organisation:"mmt"}}function Vt(){return Mt()?Pt():Ir()?Ar():Pt()}function Re(){let n=w(document?.cookie,"cc")?.toLowerCase()||"in",e=w(document?.cookie,"ccde")?.toLowerCase()||"in",t=w(document?.cookie,"isWorldwide"),r=w(document?.cookie,"lang")?.toLowerCase()||"eng",s=w(document?.cookie,"userCurrency")?.toLowerCase()||"",a=t?parseInt(t):0;return{currency:e?Cr[e]:"",isWorldwide:a,language:r,region:e,userCountry:n,userCurrency:s}}var $={b2b:"business",b2c:"personal",myPartner:"cta"};function De(){let n=w(document?.cookie,"myBusinessSubscription");return $[n]||$.b2c}function Ut(n){return n===ce.GI}function ct(){return w(document?.cookie,"track")!=="true"}function Zt(){return w(document?.cookie,"ptrack")!=="true"}function Or(n){if(!n||typeof n!="string")return{};let e={};return n.split("|").forEach(r=>{let[s,a]=r.split(":");s&&a!==void 0&&(e[s.trim()]=a.trim())}),e}function Lt(){let n=De(),e=Fe();if(n===$.myPartner)return{user_role:e?.userCorpData?.agentRole,org_id:e?.userCorpData?.agencyUUID};if(n===$.b2b){let t=localStorage.getItem("myBizOrgContext")||"";if(!t)return{};let r=Or(t);return{org_id:e?.userCorpData?.organizationId,org_type:e?.userCorpData?.orgType,verification_status:e?.userCorpData?.employeeStatus,user_role:e?.userCorpData?.employeeType,...r}}return{}}var $t="3.0.5";var P="NA",Ne=n=>{let{screen:e,navigator:t}=n,r=Re(),{userCountry:s,isWorldwide:a,region:i}=r,o=a?s:i,u="",c=P,p=P;e&&e.width&&(c=e.width?`${e.width}`:P,p=e.height?`${e.height}`:P,u+=`${c}*${p}`);let b=w(document.cookie,"dvid")||w(document.cookie,"__gi_vid")||P,I=P;"connection"in n.navigator&&typeof n.navigator.connection=="object"&&n.navigator.connection&&"effectiveType"in n.navigator.connection&&typeof n.navigator.connection.effectiveType=="string"&&(I=n.navigator.connection.effectiveType);let{browser:D,os:ke,device:M}=ua_parser(t.userAgent),le;switch(M.type?.toLowerCase()){case"mobile":case"tablet":le="pwa";break;default:le="desktop";break}return{deviceId:b,os:ke.name?.toLowerCase()||P,osVersion:ke.version||P,browser:D.name||P,version:$t||P,userAgent:t.userAgent,screenSize:u,screenWidth:c,screenHeight:p,networkType:I,platform:le,model:M.model||P,manufacturer:M.vendor||P,acquired_country:o}};var zt="session_info";async function qe(n,e){await e.setItem(zt,JSON.stringify(n))}async function Dr(n){let e=await n.getItem(zt);return e?JSON.parse(e):null}var Bt={inActiveThresholdInMins:30,expiryInMins:120};function Nr(n){if(!n)return!1;let e=Date.now(),t=(e-n.createdAt)/6e4>Bt.expiryInMins,r=(e-n.lastUsed)/6e4>Bt.inActiveThresholdInMins;return!t&&!r}async function jr(n){let e=Date.now(),t={createdAt:e,lastUsed:e,id:Ot(),isSynced:!1,retry:0};return await qe(t,n),setTimeout(async()=>{await je(!0,void 0,n)},0),t}async function ue(n){let e=await Dr(n);return Nr(e)?e:jr(n)}var be=class{constructor(e){this.storage=e}async getCurrentSessionId(){return(await ue(this.storage)).id}async updateLastUsed(){let e=await ue(this.storage);await qe({...e,lastUsed:Date.now()},this.storage)}async lastUsed(){return(await ue(this.storage)).lastUsed}async updateSyncStatus(){let e=await ue(this.storage);await qe({...e,isSynced:!e?.isSynced},this.storage)}async getSyncStatus(){return(await ue(this.storage)).isSynced}async getRetryStatus(){return(await ue(this.storage)).retry}async updateRetryStatus(){let e=await ue(this.storage);await qe({...e,retry:e?.retry+1},this.storage)}};var Mr="https://pdt.makemytrip.com",Vr="/fs/w",Ur={"Content-Type":"application/json","Request-Data-Encoding":"json"},Zr="NA",Lr="mmt_session_aero_store";async function $r({userId:n,sessionManager:e,deviceDetails:t}){let r=typeof sessionStorage<"u"?it():null,s=n;if(r!==null&&typeof r=="object"){let{uuid:u,profileType:c}=r,p=Oe({uuid:u,profile_type:c});s=n||p}let a=t?.device_id||w(document.cookie,"dvid")||Zr,i=t?.platform||Ne(window)?.platform,o=await e.getCurrentSessionId();return JSON.stringify([{uuidPT:s,deviceId:a,value:{session_id:o},column:i==="pwa"?"pwa":"desktop",datasetName:Lr}])}var je=async(n,e,t)=>{if(!n)return"success";let r=t||dt(),s=e||new be(r),a=await s.getSyncStatus(),i=await s.getRetryStatus(),o=q.getSetting("userIdPt"),u=q.getSetting("deviceContext");if(a||i>6)return"success";try{let c=`${Pe(Mr)}${Vr}`,p=await $r({userId:o,sessionManager:s,deviceDetails:u}),b=await fetch(c,{method:"POST",body:p,headers:Ur,keepalive:!0});if(!b.ok)throw new Error(`HTTP error! status: ${b.status}`);return await s.updateSyncStatus(),"success"}catch(c){return console.log("Failed to sync session ID to PDT DB:",c),s.updateRetryStatus(),"failure"}};var Ft=200,ut="error",Me="page-rendered",qt=y.enum(["mmt","gi"]),Jt=y.enum(["india","global"]),Wt=y.enum(["in","ae","sa"]),Ht=y.enum(["inr","usd","aed","sar"]),Gt=y.enum(["eng","hin","tam","ara"]),Qt=y.enum(["personal","business","cta","affiliates"]),Yt=y.enum(["desktop","pwa","mobile"]),Kt=y.enum(["android","ios","mac os","windows","linux","blackberry","symbian","nokia","webos","unix","samsung","other"]),Xt=y.enum(["landing","funnel","template","promo"]),en=y.enum(["landing","listing","detail","review","payment","thankyou"]),tn=y.enum(["common","flights","hotels","bus","rails","cabs","holidays","travelinsurance","forex","giftcards","visa","w2g","acme","how2go","travelcard","hostapp","postsales"]),nn=y.enum(["common","df","if","dh","ih","bus","rails","dom_acabs","dom_ocabs","dom_hrcabs","intl_acabs","intl_ocabs","intl_hrcabs","domhld","intlhld","travelinsurance","forex","pc","cn","nc","giftcards","e-visa","sticker-visa","w2g","dom_acme","intl_acme","how2go","travelcard","hostapp"]),rn=y.enum([Me,ut,"search-clicked","sort_by-clicked","filter-applied","filter_all-cleared","content_card_filter-clicked","content_header-filter-clicked","map_filter-clicked","product_card_filter-clicked","popup-rendered","login-succeeded","user-logged-out","signup-completed","chat-interacted","send-quote","price-change"]);var Br=y.object({webPageDetails:y.object({name:y.string().min(1,{message:"webPageDetails.name cannot be empty"}),pageViews:y.object({value:y.number()}),isErrorPage:y.boolean().optional()})}),zr=y.object({webInteraction:y.object({name:y.string().nullable(),type:y.string().nullable().optional(),url:y.string().nullable().optional(),linkClicks:y.object({value:y.number()})})}),sn=n=>y.object({event:y.string(),web:n===Me?Br:zr}).passthrough();var an=y.object({entity_info:y.object({organisation:qt,entity:Jt,region:Wt,currency:Ht,user_language:Gt}),user_context:y.object({profile_type:Qt}),device_context:y.object({platform:Yt,os:Kt}),page_context:y.object({page_type:Xt,funnel_step:en,page_name:y.string().min(1,{message:"page_name cannot be empty"}),lob:tn,lob_category:nn}),event_detail:y.object({event_type:y.string().min(1,{message:"event_type cannot be empty"}),event_name:y.string().min(1,{message:"event_name cannot be empty"})})}),Je=n=>n.issues.map(e=>({path:e.path.join("."),message:e.message,code:e.code}));var We=class{constructor(e,t){let r=this.createAdobeSchema(e,t);this.validateAdobeSchema(r),this.adobeSchema=r,this.pushToADL()}createAdobeSchema(e,t){let r=`xdm_${e.event_detail.event_name}`,s;return e.event_detail.event_name===Me?(s={webPageDetails:{name:e.page_context.page_name||window.location.pathname,pageViews:{value:1}}},e?.error_details_list?.length&&(s.webPageDetails.isErrorPage=!0)):(r=rn.safeParse(e.event_detail.event_name).success?e.event_detail.event_type===ut?"xdm_error":`xdm_${e.event_detail.event_name}`:"xdm_cta_click",s={webInteraction:{name:e.event_detail.event_name,type:"other",url:t?.destinationUrl||"",linkClicks:{value:1}}}),{event:r,web:s,_makemytrip:e}}validateAdobeSchema(e){try{sn(e._makemytrip.event_detail.event_name).parse(e)}catch(t){if(t instanceof y.ZodError){let r=Je(t);throw new Error(`Adobe Analytics Schema validation failed: ${JSON.stringify(r,null,2)}`)}throw t}}pushToADL(){window.adobeDataLayer||(window.adobeDataLayer=[]);let e=this.adobeSchema;try{e.event==="xdm_cta_click"?setTimeout(()=>{window.adobeDataLayer?.push(e)},Ft):window.adobeDataLayer.push(e)}catch(t){let r=t instanceof Error?t.message:"Unknown error";throw new Error(`Failed to push to Adobe Data Layer: ${r}`)}}};var He=class{constructor(e){this.validators=[];this.newCorrelationId=()=>Promise.resolve(It());this.newRequestId=()=>Promise.resolve(At());this.getSessionId=()=>Promise.resolve(this.sessionManager.getCurrentSessionId());this.setOptOutStatus=e=>this.optInStateManager.updateOptInStatus(e);this.getOptOutStatus=()=>this.optInStateManager.readOptInStatus();this.track=async(e,t)=>{let r=await this.enrichBaseEventArg(e,t);for await(let s of this.validators)await s.assertValidSchema(r,t);this.jobQueue.pushEvent(r),this.sessionManager.updateLastUsed()};this.pushToPDT=async(e,t)=>{if(ct()||Zt())return;let r=t?.lob||"",s=await this.enrichAndValidateBaseEvent(e,t);for await(let a of this.validators)await a.assertValidSchema(s,r);this.jobQueue.pushEvent(s),this.sessionManager.updateLastUsed()};this.pushToAdobeDataLayer=async(e,t)=>{if(ct())return;let r=await this.enrichAndValidateBaseEvent(e,t);new We(r,t)};this.pushToAll=async(e,t)=>{await Promise.all([this.pushToPDT(e),this.pushToAdobeDataLayer(e,t)])};this.flushEvents=()=>{this.jobQueue.flushNow("terminal")};this.stopAutoFlush=()=>{this.flushEvents(),this.jobQueue.shutdown()};this.onAppVisibilityChange=e=>{e==="hidden"&&this.flushEvents()};this.enrichBaseEventArg=async(e,t)=>{let r=await this.getSessionId(),s=await this.newRequestId(),a=this.runtimeContextProvider?.getDeviceContext(),i=this.runtimeContextProvider?.getUserContext(this.org),o=this.runtimeContextProvider?.getUserDetailsContextExtended?.(),u=this.runtimeContextProvider?.getDeviceDetailsContextExtended?.(),c=this.sdkRuntimeProvider?.getDeviceContext(),p=this.sdkRuntimeProvider?.getUserContext(this.org),b=this.sdkRuntimeProvider?.getEventTrackingContext?.(),I=ot();if(q.setSetting("deviceContext",a),i?.uuid&&i?.profile_type){let fe=Oe({uuid:i?.uuid,profile_type:i?.profile_type});q.setSetting("userIdPt",fe)}let D=await this.sessionManager.getRetryStatus();!await this.sessionManager.getSyncStatus()&&D>0&&D<6&&setTimeout(async()=>{await je(!0,this.sessionManager,void 0)},10);let M=Object.freeze({...e,event_detail:{event_id:s,event_timestamp:Date.now(),device_details_extended:{...u},user_details_extended:{...o},...e.event_detail},event_tracking_context:{...b,...e.event_tracking_context,session_id:r},user_context:{...p,...i,...e?.user_context},device_context:{...c,...a,...e?.device_context},campaign_details:e.campaign_details||I}),le=this.validators.map(fe=>fe.assertValidSchema(M,t));return await Promise.all(le),M};this.enrichUpdatedBaseEventArg=async(e,t)=>{let r=await this.getSessionId(),s=await this.newRequestId(),a=this.runtimeContextProvider?.getDeviceContext(),i=this.runtimeContextProvider?.getUserContext(this.org),o=this.runtimeContextProvider?.getUserDetailsContextExtended?.(),u=this.runtimeContextProvider?.getDeviceDetailsContextExtended?.(),c=this.sdkRuntimeProvider?.getDeviceContext(),p=this.sdkRuntimeProvider?.getUserContext(this.org),b=this.sdkRuntimeProvider?.getEventTrackingContext?.(),I=ot(),D=Vt(),ke=this.sdkRuntimeProvider?.getUserIdentities?.(this.org);if(q.setSetting("deviceContext",a),i?.uuid&&i?.profile_type){let Xe=Oe({uuid:i?.uuid,profile_type:i?.profile_type});q.setSetting("userIdPt",Xe)}let M=await this.sessionManager.getRetryStatus();!await this.sessionManager.getSyncStatus()&&M>0&&M<6&&setTimeout(async()=>{await je(!0,this.sessionManager,void 0)},10);let fe=De(),pn=fe===$.myPartner||fe===$.b2b,mn=Object.freeze({...e,identities:{...ke,...e?.identities},event_detail:{event_id:s,event_timestamp:Date.now(),device_details_extended:{...u},user_details_extended:{...o},...e?.event_detail},event_tracking_context:{...b,...e?.event_tracking_context,session_id:r},user_context:{...p,...i,...e?.user_context},device_context:{...c,...a,...e?.device_context},campaign_details:e?.campaign_details||I,entity_info:D,...pn&&{organization_context:Lt()}}),pt=de(mn),hn=this.validators.map(Xe=>Xe.assertValidSchema(pt,t));return await Promise.all(hn),pt};let{sessionManager:t,optInStateManager:r,runtimeContextProvider:s,jobQueue:a,sdkRuntimeProvider:i,org:o}=e;this.runtimeContextProvider=s,this.sdkRuntimeProvider=i,this.sessionManager=t,this.optInStateManager=r,this.jobQueue=a,this.jobQueue.start(),this.org=o||ce.MMT}addValidator(e){this.validators.push(e)}setRuntimeContextProvider(e){this.runtimeContextProvider=e}async enrichAndValidateBaseEvent(e,t){let r=t?.lob||"",s=await this.enrichUpdatedBaseEventArg(e,r);try{an.parse(s)}catch(a){if(a instanceof y.ZodError){let i=Je(a);throw console.error("Event Schema:",s),new Error(`Schema Validation Failed: ${JSON.stringify(i,null,2)}`)}throw a}return s}};var on="analytics_opt_in",Ge=class{constructor(e){this.storage=e}async readOptInStatus(){let e=await this.storage.getItem(on);return Promise.resolve(e!==null&&JSON.parse(e))}async updateOptInStatus(e){await this.storage.setItem(on,`${e}`)}};var cn="https://pdt.makemytrip.com",dn="/dts/s/da/n",un={"Content-Type":"application/json","Request-Data-Encoding":"json","Accept-Encoding":"gzip"},Fr={PDT_HOST:cn,SEND_EVENT_ENDPOINT:dn,PDT_REQ_HEADERS:un},Ve=class{constructor(e){this._host=e?.host||cn,this._sendEndpoint=`${Pe(this._host)}${e?.sendEndpoint||dn}`,this._baseHeaders=jt(e?.baseHeaders||un,Pe(this._host))}async sendEvents(e,t,r){if(r)return r({events:e,priority:t,headers:this._baseHeaders,endpoint:this._sendEndpoint});let s=JSON.stringify(e);return await fetch(this._sendEndpoint,{method:"POST",body:s,headers:this._baseHeaders,keepalive:!0}),Promise.resolve("success")}};var Qe=class{getItem(e){return localStorage.getItem(e)}setItem(e,t){localStorage.setItem(e,String(t))}};var we="NA";function qr(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch{return we}}function lt(){if(!Rt())throw new Error("only browser environment not supported")}var ft={getDeviceContext(){lt();let{os:n,osVersion:e,networkType:t,version:r,browser:s,platform:a,deviceId:i,model:o,manufacturer:u,userAgent:c,acquired_country:p}=Ne(window),b=qr();return de({app_ver:r,vendor_id:s,device_id:i,os:n,os_version:e,network_type:t,platform:a,time_zone:b,model:o,manufacturer:u,user_agent:c,acquired_country:p})},getUserContext(n){lt();let e=w(document.cookie,"mmt-auth")||w(document.cookie,"OAUTH-GOIBIBO"),t=w(document.cookie,"gitokenid")||void 0,r=Fe(),s=Nt();if(Ut(n)){let a={uuid:t,profile_type:$.b2c,is_logged_in:!!e,marketing_cloud_id:s,login_channel:ce.GI,login_type:"OTP"};return de(a)}else{let a={},i=localStorage.getItem("walletInfo");if(i){let p=JSON.parse(i),b=p?.loyaltyData||{};b?.status&&(a.loyalty_status=b.status),b?.program&&(a.loyalty_type=b.program),b?.currentTier?.name&&(a.loyalty_level=b.currentTier.name),p?.multiCurrencyDetails?.totalWalletAmount&&(a.wallet_bal=p.multiCurrencyDetails.totalWalletAmount)}let o=localStorage.getItem("channel");o&&(a.login_channel=o);let u=localStorage.getItem("loginType");u&&(a.login_type=u);let c={uuid:r?.uuid,profile_type:De(),is_logged_in:!!e,marketing_cloud_id:s,login_channel:a.login_channel,login_type:a.login_type,nationality:r?.nationality,loyalty_status:a.loyalty_status,loyalty_type:a.loyalty_type,loyalty_level:a.loyalty_level,wallet_bal:a.wallet_bal};return de(c)}},getEventTrackingContext(){lt();let n=Re(),{region:e,currency:t,userCurrency:r,language:s}=n;return de({template_id:0,topic_name:we,env:we,timezone:we,session_id:we,funnel_source:we,session_visit_number:0,region:e,user_preferred_currency:r,domain_country:e,domain_language:s,domain_currency:t})},getUserIdentities(n){let e=Fe(),t,r;if(n===ce.GI&&e&&(t=e?.value?.mHash,r=e?.value?.eHash),Array.isArray(e?.loginInfoList)){let a=e.loginInfoList.find(o=>o.loginType==="MOBILE"&&o.commId),i=e.loginInfoList.find(o=>o.loginType==="EMAIL"&&o.commId);a&&(t=a.commId),i&&(r=i.commId)}let s={};return t&&(s.phone_number_hash=t),r&&(s.email_address_hash=r),Object.keys(s).length?s:null}};var Ye=class{constructor(){this._store={}}getItem(e){return this._store[e]||null}setItem(e,t){this._store[e]=String(t)}};var Jr=60*1e3,Ke=class n{constructor(e,t,r){this.jobs=[];this._timer=-1;this.networkClient=e,this.storage=t,this.config=r,this.restoreState()}start(){this._timer===-1&&(this._timer=setInterval(()=>this.execute(),this.config.autoFlushIntervalInMs))}shutdown(){clearInterval(this._timer),this._timer=-1}flushNow(e="normal"){this.execute(e)}saveState(){this.storage.setItem("@events/job-queue",JSON.stringify(this.jobs))}restoreState(){let e=this.storage.getItem("@events/job-queue");e&&(this.jobs=JSON.parse(e),this.jobs=this.jobs.map(t=>({...t,status:"pending"})))}static findLast(e,t){for(let r=e.length-1;r>=0;r--){let s=e[r];if(t(s,r))return s}}pushEvent(e){let t=n.findLast(this.jobs,r=>r.status==="pending"&&r.events.length<this.config.maxBatchSize);(!t||t.events.length>=this.config.maxBatchSize)&&(t={events:[],status:"pending",id:Ae(),retryCount:0},this.jobs.push(t)),t.events.push(e),this.saveState()}execute(e="normal"){let t=this.jobs.filter(r=>r.status==="pending");for(let r of t)this.updateJobStatus(r,"running"),this.networkClient.sendEvents(r.events,e,null).then(s=>{s==="success"?this.updateJobStatus(r,"done"):s==="failed"&&this.updateJobStatus(r,"failed")})}updateJobStatus(e,t){let r=this.jobs.map(s=>{if(s.id!==e.id)return s;switch(t){case"done":return{...s,status:"done"};case"running":return{...s,start:Date.now(),status:"running"};case"failed":return{...s,status:s.retryCount<2?"pending":"done",retryCount:s.retryCount+1};default:return s}});r=r.filter(s=>s.status!=="done").filter(s=>!(s.status==="running"&&Date.now()-(s.start||0)>Jr)),this.jobs=r,this.saveState()}};function Wr(n){let e=dt(),t=n.networkClient||new Ve,r=n.runtimeContextProvider,s=new Ge(e),a=new be(e),i={assertSchema:!1,autoFlushIntervalInMs:5e3,maxBatchSize:5},o=new He({optInStateManager:s,sessionManager:a,runtimeContextProvider:r,sdkRuntimeProvider:ft,jobQueue:new Ke(t,e,i),...n});return typeof window<"u"&&document.addEventListener("visibilitychange",()=>{document.visibilityState==="hidden"&&o.onAppVisibilityChange("hidden")}),o}function dt(){return(()=>{try{if(typeof window?.localStorage<"u")return!0}catch{}return!1})()?new Qe:new Ye}var Hr={development:"https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-cc2440d362e4-development.min.js",production:"https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-4aefa0b9df82.min.js"},ln=n=>Hr.development,Gr=(n="development")=>`<script src="${ln(n)}" async></script>`,Qr=(n="development")=>ln(n);var Yr={development:"https://assets.adobedtm.com/79483c2c7c00/c269e98139c1/launch-197ba8a65d9c-development.min.js",production:"https://assets.adobedtm.com/79483c2c7c00/c269e98139c1/launch-adcfac9ffc6d.min.js"},fn=n=>Yr.development,Kr=(n="development")=>`<script src="${fn(n)}" async></script>`,Xr=(n="development")=>fn(n);
//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(6364);
// EXTERNAL MODULE: ../../node_modules/MMT-UI/getPIIData/client/index.js
var client = __webpack_require__(5328);
;// CONCATENATED MODULE: ../../node_modules/@forex/pdt-utils/index.esm.js





const LOB = {
    FOREX: 'forex'
};
const shortenHeader = {
    lob: 'lob',
    lob_category: 'lc',
    lob_funnel: 'lf',
    page_name: 'pn',
    prev_page_name: 'ppn',
    funnel_step: 'fs',
    pg_time_interval: 'pti',
    navigation: 'nav',
    utm_source: 'us',
    utm_medium: 'um',
    utm_campaign: 'uc',
    cmp: 'cmp',
    requestId: 'rq-id'
};
const COOKIES = {
    MMT_AUTH_KEY: 'mmt-auth',
    TM_AUTH_KEY: 'x-tm-auth',
    MMT_LOGIN_REDIRECT_KEY: 'loginActionDetails',
    TM_MMT_AUTH_KEY: 'tm-mmt-auth',
    GI_AUTH_KEY: 'OAUTH-GOIBIBO',
    TM_GI_AUTH_KEY: 'tm-gi-auth',
    MMT_DEVICE_ID: 'dvid',
    GI_DEVICE_ID: '__gi_vid',
    MMT_FOREX_COOKIE: 'mmt_forex',
    CURRENCY_DEEPLOGIN_ALLOWED: 'currency_deeplogin_allowed',
    PDT_JOURNEY_ID: 'x-jo-id'
};
const EVENT_TYPES = {
    CLICKED: 'CLICKED',
    RENDERED: 'RENDERED'
};

const setPdtLocationDetectedSchema = (locationSource, permissionDetails, delivery_details)=>{
    const { latitude, longitude, pincode, city } = delivery_details || {};
    return {
        latitude: latitude ? `${latitude}` : null,
        longitude: longitude ? `${longitude}` : null,
        location_source: locationSource || null,
        pincode: pincode ? `${pincode}` : null,
        city: city ? `${delivery_details == null ? void 0 : delivery_details.city}` : null,
        location_permission: permissionDetails || null
    };
};
function getDeliveryDetailsPdtSchema({ deliveryDetails }) {
    const { pincode, city, latitude, longitude } = deliveryDetails || {};
    return {
        pincode: pincode != null ? pincode : null,
        city: city ? `${city}` : '',
        location_permission_given: latitude && longitude ? true : false
    };
}
function getVendorErrorDetails({ error_code, error_type, error_source, vendor_error_code, vendor_error_message, error_message_shown, api_url }) {
    const vendorErrorObj = {
        error_code: error_code ? `${error_code}` : 'NO_CODE_FOUND',
        error_type: error_type || null,
        error_source: error_source || null,
        vendor_error_code: vendor_error_code || null,
        vendor_error_message: vendor_error_message || null,
        error_message_shown: error_message_shown || 'Unknown error',
        api_url: api_url || null
    };
    return (0,core_utils.removeNullableField)(vendorErrorObj);
}
function getDeliveryDetails({ eta, pincode, city, is_deliverable, is_prefetched, location_permission_given, deliverable, city_code, locus_city_code, state, state_code, is_valid, is_card_deliverable, is_currency_deliverable, fallback_to_city }) {
    return {
        eta: eta || '',
        pincode: pincode || 0,
        city: city || '',
        is_deliverable: is_deliverable || '',
        is_prefetched: is_prefetched || false,
        location_permission_given: location_permission_given || false,
        deliverable: deliverable || '',
        city_code: city_code || '',
        locus_city_code: locus_city_code || '',
        state: state || '',
        state_code: state_code || '',
        is_valid: is_valid || false,
        is_card_deliverable: is_card_deliverable || false,
        is_currency_deliverable: is_currency_deliverable || false,
        fallback_to_city: fallback_to_city !== undefined ? fallback_to_city : null
    };
}
function getBookingInfo({ amount_details, booking_date, booking_id, booking_parent_id, countries, coupon_details, currency, delivery_city_code, delivery_city_name, document_upload_status, from_date_time, is_coupon_applied, is_partial_amount_paid, is_payment_possible, is_tcs_applied, order_items, order_type_code, payment_status, status, status_description, tm_order_id, to_date_time, trip_purpose, trip_type }) {
    const bookingInfo = {
        amount_details: amount_details || null,
        booking_date: booking_date || null,
        booking_id: booking_id || null,
        booking_parent_id: booking_parent_id || null,
        countries: countries || null,
        coupon_details: coupon_details || null,
        currency: currency || null,
        delivery_city_code: delivery_city_code || null,
        delivery_city_name: delivery_city_name || null,
        document_upload_status: document_upload_status || null,
        from_date_time: from_date_time || null,
        is_coupon_applied: is_coupon_applied || null,
        is_partial_amount_paid: is_partial_amount_paid || null,
        is_payment_possible: is_payment_possible || null,
        is_tcs_applied: is_tcs_applied || null,
        order_items: order_items || null,
        order_type_code: order_type_code || null,
        payment_status: payment_status || null,
        status: status || null,
        status_description: status_description || null,
        tm_order_id: tm_order_id || null,
        to_date_time: to_date_time || null,
        trip_purpose: trip_purpose || null,
        trip_type: trip_type || null
    };
    return (0,core_utils.removeNullableField)(bookingInfo);
}
function getBookingDetails({ status, created_at, is_coupon_applied, is_partial_amount_paid, parent_order_id, is_tcs_applied, status_description, document_upload_status, payment_details }) {
    return {
        status: status || null,
        created_at: created_at || null,
        is_coupon_applied: is_coupon_applied || null,
        is_partial_amount_paid: is_partial_amount_paid || null,
        parent_order_id: parent_order_id || null,
        is_tcs_applied: is_tcs_applied || null,
        status_description: status_description || null,
        document_upload_status: document_upload_status || null,
        payment_details: payment_details || null
    };
}
function getTmUserDetails({ tm_uuid, partner, vendor_user_id, vendor_id, multi_cx_card_cust, currency_cust, travel_card_cust, is_pan_verified }) {
    const userObj = {
        tm_uuid: tm_uuid || null,
        partner: partner || null,
        vendor_user_id: vendor_user_id || null,
        vendor_id: vendor_id || null,
        multi_cx_card_cust: multi_cx_card_cust || null,
        currency_cust: currency_cust || null,
        travel_card_cust: travel_card_cust || null,
        is_pan_verified: is_pan_verified || null
    };
    return (0,core_utils.removeNullableField)(userObj);
}
function getComponentsPdt({ id, content_details, component_type, share_details, bridge_status }) {
    const componentObj = {
        id: id || null,
        content_details: content_details || null,
        component_type: component_type || null,
        share_details: share_details || null,
        bridge_status: bridge_status || null
    };
    return (0,core_utils.removeNullableField)(componentObj);
}
function getEventDetails({ page_details, delivery_details, response_time, vendor_error_details, event_name, event_type = '', event_value, booking_info, components, event_id = '', event_timestamp, user_details, webhook_details, document_details, flow = null, upcoming_trip }) {
    const obj = {
        page_details: page_details || null,
        delivery_details: delivery_details || null,
        response_time: response_time || null,
        vendor_error_details: vendor_error_details || null,
        event_name: event_name || 'NA',
        event_type: event_type || 'NA',
        event_value: event_value || null,
        booking_info: booking_info ? getBookingInfo(booking_info) : null,
        components: components || null,
        event_id: event_id || null,
        event_timestamp: event_timestamp || new Date().getTime(),
        user_details: user_details || null,
        webhook_details: webhook_details || null,
        document_details: document_details || null,
        flow,
        upcoming_trip: upcoming_trip ? getUpcomingTrip(upcoming_trip) : null
    };
    return (0,core_utils.removeNullableField)(obj);
}
function getUpcomingTrip({ trip_details, intl_travel }) {
    const upcomingTrip = {
        intl_travel,
        trip_details: getTripDetails(trip_details)
    };
    return (0,core_utils.removeNullableField)(upcomingTrip);
}
function getPdtUpcomingTripSchema(upcomingTrip) {
    var _upcomingTripCountries_;
    const { trip_details: upcomingTripCountries, intl_travel = null, start_date = null, end_date = null } = upcomingTrip || {};
    return {
        intl_travel,
        trip_details: [
            {
                country_code: upcomingTripCountries == null ? void 0 : (_upcomingTripCountries_ = upcomingTripCountries[0]) == null ? void 0 : _upcomingTripCountries_.country_code,
                start_date,
                end_date
            }
        ]
    };
}
function getTripDetails(trip_details) {
    const tripDetails = (trip_details != null ? trip_details : []).map((tripDetail)=>{
        return (0,core_utils.removeNullableField)({
            dependent_lob: tripDetail.dependent_lob,
            country_code: tripDetail.country_code,
            currency_code: tripDetail.currency_code,
            start_date: tripDetail.start_date,
            end_date: tripDetail.end_date,
            no_of_travellers: tripDetail.no_of_travellers,
            opportunity_type: tripDetail.opportunity_type
        });
    }).filter((tripDetail)=>tripDetail);
    return tripDetails.length ? tripDetails : null;
}
function getPageDetails({ segment_key = null, documentscanfailed = null, secondary_page_name = null, auto_suggest = null, is_pan_autofilled, is_mobile_prefilled, Is_email_prefilled }) {
    const pageDetailsObj = {
        segment_key: segment_key || null,
        documentscanfailed: documentscanfailed || null,
        secondary_page_name: secondary_page_name || null,
        auto_suggest: auto_suggest || null,
        is_pan_autofilled: is_pan_autofilled,
        is_mobile_prefilled: is_mobile_prefilled,
        Is_email_prefilled: Is_email_prefilled
    };
    return (0,core_utils.removeNullableField)(pageDetailsObj);
}
function getPageContext({ lob, lob_category, lob_funnel, page_name, prev_page_name, subpage_name, funnel_step, pg_time_interval, navigation, page_url, page_type }) {
    const pageContextObj = {
        lob: lob || LOB.FOREX,
        lob_category: lob_category || null,
        lob_funnel: lob_funnel || null,
        page_name: page_name || null,
        prev_page_name: prev_page_name || null,
        subpage_name: subpage_name || null,
        funnel_step: funnel_step || null,
        pg_time_interval: pg_time_interval != null ? pg_time_interval : null,
        navigation: navigation || null,
        page_url: page_url || null,
        page_type: page_type || null
    };
    return (0,core_utils.removeNullableField)(pageContextObj);
}
function getEventTrackingContext({ template_id, topic_name, env, session_id, request_id, journey_id, bu, organisation, funnel_source, funnel_entry, traffic_source, domain_country, domain_currency, domain_language, affiliate_id, timestamp, funnel_medium, funnel_campaign, cmp }) {
    const obj = {
        template_id,
        topic_name,
        env,
        session_id: session_id || null,
        request_id: request_id || null,
        journey_id: journey_id || null,
        bu: bu || null,
        organisation: organisation || null,
        funnel_source: funnel_source || null,
        funnel_entry: funnel_entry || null,
        traffic_source: traffic_source || null,
        domain_country: domain_country || null,
        domain_currency: domain_currency || null,
        domain_language: domain_language || null,
        affiliate_id: affiliate_id || null,
        timestamp,
        funnel_medium: funnel_medium || null,
        funnel_campaign: funnel_campaign || null,
        cmp: cmp || null
    };
    return (0,core_utils.removeNullableField)(obj);
}
function getErrorDetailsItem({ code, message, severity, source }) {
    return {
        code,
        message,
        severity: severity || null,
        source: source || null
    };
}
function getUserContext({ uuid, is_logged_in, marketing_cloud_id, login_channel, profile_type, wallet_bal, login_type, loyalty_status, loyalty_type, loyalty_level, user_segment_list, login_required }) {
    const obj = {
        uuid: uuid || null,
        is_logged_in,
        marketing_cloud_id: marketing_cloud_id || null,
        login_channel: login_channel || null,
        profile_type: profile_type || null,
        wallet_bal: wallet_bal || null,
        login_type: login_type || null,
        loyalty_status: loyalty_status || null,
        loyalty_type: loyalty_type || null,
        loyalty_level: loyalty_level || null,
        user_segment_list: user_segment_list || null,
        login_required: login_required || null
    };
    return (0,core_utils.removeNullableField)(obj);
}
function getDeviceContext({ device_id, ip_addr, network_type, os_version, user_agent, timezone, platform, country, region, city, lat, long, app_ver, build_ver, os, visitor_id, advertiser_id, vendor_id, device_token }) {
    const obj = {
        device_id: device_id || null,
        ip_addr: ip_addr || null,
        network_type: network_type || null,
        os_version: os_version || '',
        user_agent: user_agent || null,
        timezone: timezone || null,
        platform: platform || 'NA',
        country: country || null,
        region: region || null,
        city: city || null,
        lat: lat || null,
        long: long || null,
        app_ver: app_ver || '',
        build_ver: build_ver || null,
        os: os || '',
        visitor_id: visitor_id || null,
        advertiser_id: advertiser_id || null,
        vendor_id: vendor_id || null,
        device_token: device_token || null
    };
    return (0,core_utils.removeNullableField)(obj);
}
function getExperimentDetails({ valid_exp_list, variant_keys, honoured_exp_list }) {
    return {
        valid_exp_list: valid_exp_list || [],
        variant_keys: variant_keys || '',
        honoured_exp_list: honoured_exp_list || []
    };
}
function getCampaignDetails({ campaign_name, campaign_key }) {
    return {
        campaign_name: campaign_name || '',
        campaign_key: campaign_key || ''
    };
}
function getPdtDataObjV2({ page_context, event_tracking_context, error_details_list, user_context, device_context, experiment_details, campaign_details, tracking_info, event_detail, traveller_info, addon_details, search_context }) {
    return {
        page_context,
        event_tracking_context,
        error_details_list: error_details_list || null,
        user_context,
        device_context,
        experiment_details: experiment_details || null,
        campaign_details: campaign_details || null,
        tracking_info: tracking_info || null,
        event_detail,
        traveller_info: traveller_info || null,
        addon_details: addon_details || null,
        search_context: search_context || null
    };
}

function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

function getDeviceOS() {
    const deviceType = (0,core_utils.getDeviceType)();
    return deviceType === core_utils.DEVICE_MODEL_TYPE.WEB ? 'webos' : deviceType || '';
}
function getDeviceSpecificInfo() {
    const deviceType = (0,core_utils.getDeviceType)();
    const deviceInfo = {
        os: getDeviceOS(),
        type: !(0,core_utils.isMobile)() ? 'Desktop' : deviceType || ''
    };
    return (0,core_utils.removeEmptyKeys)(deviceInfo);
}
function getUtmPdtObj() {
    const utmParams = (0,core_utils.getUtmParamsFromCookies)();
    return (0,core_utils.removeEmptyKeys)(utmParams);
}

const getCommonPdtDataV2 = ({ userId, puid, partner, lobFunnelType, funnelStep, subpage_name })=>{
    if ((0,core_utils.isOnServer)()) return {};
    const { os, user_agent, os_version } = getDeviceSpecificInfo();
    return {
        event_tracking_context: getEventTrackingContext(_extends({}, getUtmPdtObj(), {
            template_id: 167187,
            topic_name: 'tripmoney_forex_b2c_pdt_client_logging',
            timestamp: new Date().getTime(),
            env: 'prod',
            journey_id: (0,core_utils.getCookie)(core_utils.COOKIES.PDT_JOURNEY_ID, true)
        })),
        event_detail: getEventDetails({
            event_type: 'action',
            event_name: 'NA',
            event_timestamp: new Date().getTime(),
            user_details: getTmUserDetails({
                tm_uuid: `${userId != null ? userId : 'NA'}`,
                partner
            }),
            components: getComponentsPdt({
                //  not required
                bridge_status: (0,core_utils.getDeviceIdStatus)()
            })
        }),
        user_context: getUserContext({
            // TODO - ask if nullable
            uuid: `${puid != null ? puid : 'NA'}`,
            is_logged_in: userId ? true : false
        }),
        device_context: getDeviceContext({
            os,
            os_version,
            user_agent,
            app_ver: 'NA',
            platform: (0,core_utils.getPlatform)() || 'NA',
            // TODO - ask if nullable
            device_id: (0,core_utils.getDeviceId)(partner) || 'NA'
        }),
        page_context: getPageContext({
            // some from server and some from client
            page_name: (0,core_utils.getPageName)(),
            lob: 'forex',
            lob_funnel: lobFunnelType,
            lob_category: getLobCategory(),
            page_url: (0,core_utils.getPageUrl)(),
            funnel_step: funnelStep,
            subpage_name: subpage_name
        })
    };
};
function getLobCategory() {
    if ((0,core_utils.isOnServer)()) {
        return 'NA';
    }
    const url = window.location.pathname;
    /**
   * DO NOT CHANGE ORDER OF IF BLOCKS
   * /onboarding regex matches with both card and currency funnel
   */ if (/\/currency/i.test(url)) {
        return core_utils.LOB_CATEGORY.CN;
    } else if (/\/onboarding/i.test(url)) {
        return core_utils.LOB_CATEGORY.PC;
    } else if (/\/reload\//i.test(url)) {
        // for reload funnel
        return core_utils.LOB_CATEGORY.PC;
    } else {
        return '';
    }
}

function getShortHeaders(page_context) {
    const result = {};
    for (const [key, value] of Object.entries(page_context)){
        result['x-' + (shortenHeader[key] || key)] = value;
    }
    return result;
}
function getPdtHeaders({ lobFunnelType }) {
    const partner = 'mmt';
    let { page_context } = getCommonPdtDataV2({
        partner,
        lobFunnelType
    });
    page_context = (0,core_utils.removeEmptyKeys)(page_context);
    page_context = getShortHeaders(page_context);
    const headers = {
        'page-context': page_context
    };
    // const journeyId = getCookie(COOKIES.PDT_JOURNEY_ID, true);
    // if (journeyId) {
    //   headers['x-jo-id'] = journeyId;
    // }
    return headers;
}
function setPdtHeaders(pdtHeader, headers) {
    for (const [headerKey, headerValue] of Object.entries(pdtHeader)){
        if (typeof headerValue === 'object') {
            setPdtHeaders(headerValue, headers);
        } else {
            headers.set(headerKey, headerValue);
        }
    }
}
function setPageContextHeaders(headers, lobFunnelType) {
    try {
        const pdtHeader = getPdtHeaders({
            lobFunnelType
        });
        setPdtHeaders(pdtHeader, headers);
    } catch (e) {
        console.error(e == null ? void 0 : e.message);
    }
}
function setPdtHeadersV2(pdtHeader, headers) {
    for (const [headerKey, headerValue] of Object.entries(pdtHeader)){
        if (typeof headerValue === 'object') {
            setPdtHeadersV2(headerValue, headers);
        } else {
            headers[headerKey] = headerValue;
        }
    }
}
function setPageContextHeadersV2(headers, lobFunnelType) {
    const pdtHeader = getPdtHeaders({
        lobFunnelType
    });
    setPdtHeadersV2(pdtHeader, headers);
    return headers;
}
function updateEventName(eventDetail, pdtEvents) {
    const eventName = (eventDetail == null ? void 0 : eventDetail.event_name) || '';
    if (eventName) {
        eventDetail.event_name = pdtEvents[eventName] || eventName;
    }
}
function getRequestIdHeaders(reqId) {
    const headers = {};
    headers[`x-rq-id`] = reqId || '';
    return headers;
}

let PdtSchemaUpdater = class PdtSchemaUpdater {
    mergeDeviceContext(deviceContext) {
        var _this_data;
        this.data = _extends({}, this.data, {
            device_context: _extends({}, (_this_data = this.data) == null ? void 0 : _this_data.device_context, deviceContext)
        });
        return this;
    }
    mergeEventDetailsData(eventDetail) {
        var _this_data, _this_data_event_detail, _this_data1, _this_data_event_detail1, _this_data2;
        this.data = _extends({}, this.data, {
            event_detail: _extends({}, (0,core_utils.mergeObjects)((_this_data = this.data) == null ? void 0 : _this_data.event_detail, eventDetail), {
                event_name: eventDetail.event_name || ((_this_data1 = this.data) == null ? void 0 : (_this_data_event_detail = _this_data1.event_detail) == null ? void 0 : _this_data_event_detail.event_name),
                event_type: eventDetail.event_type || ((_this_data2 = this.data) == null ? void 0 : (_this_data_event_detail1 = _this_data2.event_detail) == null ? void 0 : _this_data_event_detail1.event_type)
            })
        });
        return this;
    }
    mergePageContextData(pageContextData) {
        var _this_data, _this_data_page_context;
        this.data = _extends({}, this.data, {
            page_context: _extends({}, (0,core_utils.mergeObjects)((_this_data = this.data) == null ? void 0 : _this_data.page_context, pageContextData || {}), {
                funnel_step: pageContextData == null ? void 0 : pageContextData.funnel_step,
                lob: (pageContextData == null ? void 0 : pageContextData.lob) || ((_this_data_page_context = this.data.page_context) == null ? void 0 : _this_data_page_context.lob) || ''
            })
        });
        return this;
    }
    mergeEventTrackingContext(eventTrackingContext) {
        var _this_data, _this_data_event_tracking_context, _this_data1;
        var _eventTrackingContext_timestamp, _ref;
        this.data = _extends({}, this.data, {
            event_tracking_context: _extends({}, (_this_data = this.data) == null ? void 0 : _this_data.event_tracking_context, eventTrackingContext, {
                timestamp: (_ref = (_eventTrackingContext_timestamp = eventTrackingContext == null ? void 0 : eventTrackingContext.timestamp) != null ? _eventTrackingContext_timestamp : (_this_data1 = this.data) == null ? void 0 : (_this_data_event_tracking_context = _this_data1.event_tracking_context) == null ? void 0 : _this_data_event_tracking_context.timestamp) != null ? _ref : Date.now()
            })
        });
        return this;
    }
    mergeAdobeAnalytics(adobeAnalytics) {
        var _this_data;
        this.data = _extends({}, this.data, {
            adobe_analytics: _extends({}, (_this_data = this.data) == null ? void 0 : _this_data.adobe_analytics, adobeAnalytics)
        });
        return this;
    }
    getSchema() {
        return this.data;
    }
    constructor(commonPdtData){
        this.data = commonPdtData || {};
    }
};

/// <reference path="./types/mmt-event-logger.d.ts" />
//@typescript-eslint/ban-ts-comment
const AnalyticsSdk = Wr({});
function generateRequestId() {
    return (0,v4/* default */.Z)();
}
const getPdtLoggerMethodsV2 = ({ lobFunnelType, userId, puid, pdtEvents, funnelStep, subpage_name })=>{
    const partner = 'mmt';
    const sendPdtDataV2 = async ({ event_detail, page_context, event_tracking_context, device_context, shouldFlushEvents = false, adobe_analytics })=>{
        try {
            const commonPdtData = getCommonPdtDataV2({
                partner,
                userId,
                puid,
                lobFunnelType,
                funnelStep,
                subpage_name
            });
            const pdtSchemaUpdater = new PdtSchemaUpdater(commonPdtData);
            AnalyticsSdk.setRuntimeContextProvider({
                getUserContext: ()=>{
                    return commonPdtData.user_context;
                },
                getDeviceContext: ()=>{
                    return commonPdtData.device_context;
                }
            });
            const data = pdtSchemaUpdater.mergeEventDetailsData(event_detail || {}).mergePageContextData(page_context).mergeDeviceContext(device_context).mergeEventTrackingContext(_extends({}, event_tracking_context)).mergeAdobeAnalytics(adobe_analytics).getSchema();
            updateEventName((data == null ? void 0 : data.event_detail) || {}, pdtEvents);
            await AnalyticsSdk.track(data, LOB.FOREX);
            await AnalyticsSdk.pushToAdobeDataLayer(data);
            if (shouldFlushEvents) {
                AnalyticsSdk.flushEvents();
            }
        } catch (e) {
            console.error('sendPdtDataV2: ', e);
        }
    };
    return {
        sendPdtDataV2
    };
};
function sendPdtErrorEvent({ appErrorReducer, sendPdtDataV2 }) {
    try {
        var _appErrorReducer_pdtInfo, _appErrorReducer_pdtInfo1;
        const errorMessage = (appErrorReducer == null ? void 0 : (_appErrorReducer_pdtInfo = appErrorReducer.pdtInfo) == null ? void 0 : _appErrorReducer_pdtInfo.errorDescription) || (appErrorReducer == null ? void 0 : appErrorReducer.errorTitle) || (appErrorReducer == null ? void 0 : appErrorReducer.errorDescription) || (appErrorReducer == null ? void 0 : appErrorReducer.message);
        if (!errorMessage && !(appErrorReducer == null ? void 0 : appErrorReducer.apiUrl)) return;
        sendPdtDataV2({
            event_detail: getEventDetails({
                event_name: 'NA',
                vendor_error_details: getVendorErrorDetails({
                    error_code: (appErrorReducer == null ? void 0 : (_appErrorReducer_pdtInfo1 = appErrorReducer.pdtInfo) == null ? void 0 : _appErrorReducer_pdtInfo1.code) || (appErrorReducer == null ? void 0 : appErrorReducer.code) || 'NO_CODE_FOUND',
                    error_message_shown: errorMessage,
                    api_url: appErrorReducer == null ? void 0 : appErrorReducer.apiUrl
                })
            })
        });
    } catch (e) {
        console.error('sendPdtErrorEvent fn ', e);
    }
}

let PdtCache = class PdtCache {
    static getInstance() {
        if (!PdtCache.instance) {
            PdtCache.instance = new PdtCache();
        }
        return PdtCache.instance;
    }
    set(key, data) {
        this.cache.set(key, data);
    }
    get(key) {
        return this.cache.get(key);
    }
    clear() {
        this.cache.clear();
    }
    has(key) {
        return this.cache.has(key);
    }
    constructor(){
        this.cache = new Map();
    }
};
const pdtCache = PdtCache.getInstance();

const mergePdtData = (base, override)=>{
    return (0,core_utils.mergeObjects)(base, override);
};
const addRequestId = (data, reqId)=>{
    const result = (0,core_utils.deepCopy)(data);
    const requestId = reqId || generateRequestId();
    result.event_tracking_context = _extends({}, result.event_tracking_context, {
        request_id: requestId
    });
    return result;
};
const extractUserData = (apiResponse, state)=>{
    var _state_userData, _apiResponse_apiData_user, _apiResponse_apiData, _state_userData1, _apiResponse_apiData_user1, _apiResponse_apiData1;
    return {
        userId: (state == null ? void 0 : (_state_userData = state.userData) == null ? void 0 : _state_userData.userId) || (apiResponse == null ? void 0 : (_apiResponse_apiData = apiResponse.apiData) == null ? void 0 : (_apiResponse_apiData_user = _apiResponse_apiData.user) == null ? void 0 : _apiResponse_apiData_user['x-tm-user-id']),
        puid: (state == null ? void 0 : (_state_userData1 = state.userData) == null ? void 0 : _state_userData1.puid) || (apiResponse == null ? void 0 : (_apiResponse_apiData1 = apiResponse.apiData) == null ? void 0 : (_apiResponse_apiData_user1 = _apiResponse_apiData1.user) == null ? void 0 : _apiResponse_apiData_user1['x-puid'])
    };
};
const getFunnelEntry = ()=>{
    const utmParams = getAllUtmWithStorage();
    const funnelSource = utmParams == null ? void 0 : utmParams.utm_source;
    const funnelCampaign = utmParams == null ? void 0 : utmParams.utm_campaign;
    const funnelMedium = utmParams == null ? void 0 : utmParams.utm_medium;
    if (!funnelSource && !funnelCampaign && !funnelMedium) {
        return null;
    }
    return `${funnelSource}|${funnelMedium}|${funnelCampaign}`;
};
const getAllUtmWithStorage = ()=>{
    const defaultResult = {
        utm_source: null,
        utm_campaign: null,
        utm_medium: null
    };
    if ((0,core_utils.isOnServer)()) return defaultResult;
    const utmParams = [
        core_utils.QUERY_PARAM_KEYS.UTM_SOURCE,
        core_utils.QUERY_PARAM_KEYS.UTM_CAMPAIGN,
        core_utils.QUERY_PARAM_KEYS.UTM_MEDIUM
    ];
    const getFromStorage = (param)=>(0,core_utils.getSessionStorageItem)(param);
    try {
        const urlObj = new URL(window.location.href);
        return Object.fromEntries(utmParams.map((param)=>{
            const urlValue = urlObj.searchParams.get(param);
            if (urlValue) {
                (0,core_utils.setSessionStorageItem)(param, urlValue);
                return [
                    param,
                    urlValue
                ];
            }
            return [
                param,
                getFromStorage(param)
            ];
        }));
    } catch (e) {
        return Object.fromEntries(utmParams.map((param)=>[
                param,
                getFromStorage(param)
            ]));
    }
};
const addUtmFunnelEntry = (data, utmSource)=>{
    const result = (0,core_utils.deepCopy)(data);
    result.event_tracking_context = _extends({}, result.event_tracking_context, {
        funnel_entry: getFunnelEntry()
    });
    return result;
};
const getUtmParameter = (parameterName, url)=>{
    const targetUrl = (typeof window !== 'undefined' ? window.location.href : '');
    if (!targetUrl) return null;
    try {
        const urlObj = new URL(targetUrl);
        return urlObj.searchParams.get(parameterName);
    } catch (error) {
        return null;
    }
};
const getUtmSource = (url)=>{
    return getUtmParameter('utm_source');
};
const replacePipeWithComma = (data)=>{
    var _data_event_detail_components_content_details, _data_event_detail_components, _data_event_detail;
    data == null ? void 0 : (_data_event_detail = data.event_detail) == null ? void 0 : (_data_event_detail_components = _data_event_detail.components) == null ? void 0 : (_data_event_detail_components_content_details = _data_event_detail_components.content_details) == null ? void 0 : _data_event_detail_components_content_details.forEach((item)=>{
        if (typeof item.description === 'string') {
            item.description = item.description.replace(/\|/g, ',');
        }
    });
    return data;
};
const transformComponentData = (components)=>{
    const contentDetails = components == null ? void 0 : components.content_details;
    if (!contentDetails || contentDetails.length === 0) {
        return '';
    }
    const transformedItems = contentDetails.filter((content)=>content !== null).map((content)=>{
        const values = [];
        var _content_id;
        values.push((_content_id = content == null ? void 0 : content.id) != null ? _content_id : '');
        var _content_type;
        values.push((_content_type = content == null ? void 0 : content.type) != null ? _content_type : '');
        values.push('');
        values.push('');
        var _content_description;
        values.push((_content_description = content == null ? void 0 : content.description) != null ? _content_description : '');
        return values.join(':');
    });
    return transformedItems.join(' | ');
};
const transformUpcomingTrip = (upcomingTrip)=>{
    const tripDetails = upcomingTrip == null ? void 0 : upcomingTrip.trip_details;
    if (!(tripDetails == null ? void 0 : tripDetails.length) || !(0,core_utils.isArray)(tripDetails)) {
        return '';
    }
    // Transform only the first trip detail
    const firstTrip = tripDetails[0];
    if (!firstTrip) {
        return '';
    }
    const values = [];
    if (firstTrip == null ? void 0 : firstTrip.intent) values.push(`${firstTrip.intent}`);
    if (firstTrip == null ? void 0 : firstTrip.dependent_lob) values.push(`${firstTrip.dependent_lob}`);
    if (firstTrip == null ? void 0 : firstTrip.country_code) values.push(`${firstTrip.country_code}`);
    if (firstTrip == null ? void 0 : firstTrip.rtt) values.push(`${firstTrip.rtt}`);
    if (firstTrip == null ? void 0 : firstTrip.opportunity_type) values.push(`${firstTrip.opportunity_type}`);
    return values.join(':');
};

// Global state to track page exit setup
let isPageExitSetup = false;
let pageExitSent = false;
const setupPageExit = (sendPdtDataV2)=>{
    // If page exit is already setup, don't setup again
    if (isPageExitSetup) {
        return;
    }
    const handlePageExit = async ()=>{
        // Prevent multiple executions
        if (pageExitSent) {
            return;
        }
        try {
            const metadata = pdtCache.get('metadata');
            const pageExitData = pdtCache.get('pageExit');
            if (metadata && pageExitData) {
                const mergedData = mergePdtData(metadata, pageExitData);
                let finalData = addRequestId(mergedData);
                const utmSource = getUtmSource();
                if (utmSource) {
                    finalData = addUtmFunnelEntry(finalData, utmSource);
                }
                try {
                    await sendPdtDataV2(_extends({}, finalData, {
                        shouldFlushEvents: true
                    }));
                    // Only mark as sent after successful sending
                    pageExitSent = true;
                } catch (error) {
                    console.error('Failed to send page exit data:', error);
                // Don't set pageExitSent flag if sending failed
                }
            }
        } catch (error) {
            console.error('Error in page exit handler:', error);
        }
    };
    if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', handlePageExit);
        window.addEventListener('pagehide', handlePageExit);
        // Mark as setup to prevent future setups
        isPageExitSetup = true;
    }
};

/// <reference path="../types/mmt-ui.d.ts" />
const initSessionStorageUserInfo = async ()=>{
    try {
        return await (0,client.getUserInfoPIIClient)();
    } catch (e) {
        console.warn('Failed to get user info (user may not be logged in):', e);
        return null;
    }
};
/**
 * Initializes PDT tracking with the given extracted parameters
 * @param config Configuration object containing extracted analytics data, user info and lobFunnelType
 */ const initPdtTracking = async ({ analytics, requestId, userId, puid, lobFunnelType, isSeo })=>{
    try {
        var _analytics_pageExit_analytics, _analytics_pageExit, _analytics_pageLoad_analytics, _analytics_pageLoad, _finalData_event_detail, _finalData_event_detail1;
        if (userId) {
            pdtCache.set('userId', userId);
        }
        if (puid) {
            pdtCache.set('puid', puid);
        }
        // Cache metadata for later use
        if (analytics == null ? void 0 : analytics.pdtData) {
            pdtCache.set('metadata', analytics.pdtData);
        }
        if (analytics == null ? void 0 : (_analytics_pageExit = analytics.pageExit) == null ? void 0 : (_analytics_pageExit_analytics = _analytics_pageExit.analytics) == null ? void 0 : _analytics_pageExit_analytics.pdtData) {
            pdtCache.set('pageExit', analytics.pageExit.analytics.pdtData);
        }
        pdtCache.set('lobFunnelType', {
            event_detail: {
                event_type: lobFunnelType
            }
        });
        if (isSeo) {
            const subpageName = (0,core_utils.getLastUrlSegment)();
            pdtCache.set('subpage_name', subpageName);
        }
        const { sendPdtDataV2 } = getPdtLoggerMethodsV2({
            userId: userId || undefined,
            puid: puid || undefined,
            lobFunnelType,
            pdtEvents: {},
            subpage_name: pdtCache.get('subpage_name')
        });
        //Send page load event
        let pageLoadData = mergePdtData((analytics == null ? void 0 : analytics.pdtData) || {}, (analytics == null ? void 0 : (_analytics_pageLoad = analytics.pageLoad) == null ? void 0 : (_analytics_pageLoad_analytics = _analytics_pageLoad.analytics) == null ? void 0 : _analytics_pageLoad_analytics.pdtData) || {});
        pageLoadData = addUtmFunnelEntry(pageLoadData);
        const finalData = addRequestId(pageLoadData, requestId);
        replacePipeWithComma(finalData);
        const components_l1 = transformComponentData((_finalData_event_detail = finalData.event_detail) == null ? void 0 : _finalData_event_detail.components);
        const upcoming_trip_c50 = transformUpcomingTrip((_finalData_event_detail1 = finalData.event_detail) == null ? void 0 : _finalData_event_detail1.upcoming_trip);
        finalData.adobe_analytics = {
            components_l1,
            upcoming_trip_c50
        };
        await sendPdtDataV2(finalData);
        // Setup page exit tracking
        setupPageExit(sendPdtDataV2);
    } catch (error) {
        console.error('PDT initialization failed:', error);
        throw error;
    }
};
/**
 * Tracks a PDT event with the given event data and state
 * @param config Configuration object containing event data and state
 */ const trackEvent = async ({ eventData, requestId })=>{
    try {
        var _cachedLobFunnelType_event_detail, _finalData_event_detail, _finalData_event_detail1;
        if (!eventData) {
            return;
        }
        const metadata = pdtCache.get('metadata');
        const cachedLobFunnelType = pdtCache.get('lobFunnelType');
        if (!metadata) {
            console.warn('PDT not initialized');
            return;
        }
        const userId = pdtCache.get('userId');
        const puid = pdtCache.get('puid');
        const { sendPdtDataV2 } = getPdtLoggerMethodsV2({
            userId: userId || undefined,
            puid: puid || undefined,
            lobFunnelType: (cachedLobFunnelType == null ? void 0 : (_cachedLobFunnelType_event_detail = cachedLobFunnelType.event_detail) == null ? void 0 : _cachedLobFunnelType_event_detail.event_type) || 'Listing',
            pdtEvents: {},
            subpage_name: pdtCache.get('subpage_name')
        });
        const mergedData = mergePdtData(metadata, eventData);
        let finalData;
        if (requestId) {
            finalData = addRequestId(mergedData, requestId);
        } else {
            finalData = mergedData;
        }
        finalData = addUtmFunnelEntry(finalData);
        replacePipeWithComma(finalData);
        const components_l1 = transformComponentData((_finalData_event_detail = finalData.event_detail) == null ? void 0 : _finalData_event_detail.components);
        const upcoming_trip_c50 = transformUpcomingTrip((_finalData_event_detail1 = finalData.event_detail) == null ? void 0 : _finalData_event_detail1.upcoming_trip);
        finalData.adobe_analytics = {
            components_l1,
            upcoming_trip_c50
        };
        await sendPdtDataV2(finalData);
    } catch (error) {
        console.error('PDT event tracking failed:', error);
        throw error;
    }
};
/**
 * Convenience function for tracking component events
 * @param eventData PDT event data
 * @param state PDT state
 */ const trackComponentEvent = (eventData, state)=>{
    if (eventData) {
        trackEvent({
            eventData}).catch((error)=>{
            console.error('Component event tracking failed:', error);
        });
    }
};
/**
 * Updates the description in the first content detail of PDT data immutably.
 *
 * @param originalPdtData - The original PDT data object.
 * @param newDescription - The new description value to set.
 * @returns A new PDT data object with the updated description.
 */ function updatePdtDataDescription(originalPdtData, newDescription) {
    var _originalPdtData_event_detail, _originalPdtData_event_detail_components_content_details, _originalPdtData_event_detail_components, _originalPdtData_event_detail1;
    if (!originalPdtData) {
        return originalPdtData;
    }
    return _extends({}, originalPdtData, {
        event_detail: _extends({}, originalPdtData.event_detail, {
            components: _extends({}, (_originalPdtData_event_detail = originalPdtData.event_detail) == null ? void 0 : _originalPdtData_event_detail.components, {
                content_details: (_originalPdtData_event_detail1 = originalPdtData.event_detail) == null ? void 0 : (_originalPdtData_event_detail_components = _originalPdtData_event_detail1.components) == null ? void 0 : (_originalPdtData_event_detail_components_content_details = _originalPdtData_event_detail_components.content_details) == null ? void 0 : _originalPdtData_event_detail_components_content_details.map((detail, index)=>index === 0 ? _extends({}, detail, {
                        description: newDescription
                    }) : detail)
            })
        })
    });
}
/**
 * Cleans up PDT tracking by clearing the cache
 */ const cleanupPdtTracking = ()=>{
    pdtCache.clear();
};
/**
 * Helper function to extract parameters from legacy apiResponse and state objects
 * @param apiResponse Legacy API response object
 * @param state Legacy state object
 * @param lobFunnelType LOB funnel type
 * @returns Extracted parameters for initPdtTracking
 */ const extractPdtTrackingParams = (apiResponse, state, lobFunnelType, isSeo)=>{
    const { userId, puid } = extractUserData(apiResponse, state);
    const subpageName = (0,core_utils.getLastUrlSegment)();
    return {
        analytics: (apiResponse == null ? void 0 : apiResponse.analytics) || {
            pdtData: undefined,
            pageLoad: undefined,
            pageExit: undefined
        },
        requestId: apiResponse == null ? void 0 : apiResponse.requestId,
        userId,
        puid,
        lobFunnelType,
        isSeo,
        subpage_name: subpageName
    };
};




/***/ }),

/***/ 6401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AnalyticsPluginAdobe; }
/* harmony export */ });
/* harmony import */ var _growth_object_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7106);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var config = {
  adobeDataLayer: []
};

var formatPageName = function formatPageName(_ref) {
  var pageName = _ref.pageName,
      section = _ref.section,
      lob = _ref.lob;
  return section + ":" + lob + ":" + pageName.toLowerCase();
};

var AnalyticsPluginAdobe = function AnalyticsPluginAdobe(pluginConfig, debug) {
  var name = 'analytics-adobe-omniture';

  var configs = _extends({}, pluginConfig);

  var init = function init() {
    var _window$top;

    if (window.top && !window.top.adobeDataLayer) {
      window.top.adobeDataLayer = [];
    }

    config.adobeDataLayer = (_window$top = window.top) == null ? void 0 : _window$top.adobeDataLayer; // return the created window dataLayer. Helps in testing

    return config.adobeDataLayer;
  };

  var track = function track(_ref2) {
    var payload = _ref2.payload;

    if (typeof config.adobeDataLayer !== 'undefined') {
      var formattedPayload = (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepClone */ .I8)(_extends({}, configs));
      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(payload.eventProperties, formattedPayload);

      if (debug) {
        console.log('track payload ', _extends({
          event: payload.event
        }, formattedPayload));
      } // since ctaclick all the parameters are mandatory i.e. why adding check here


      if (payload.event === 'ctaClick') {
        formattedPayload.cta = {
          name: formattedPayload.cta.name || undefined,
          destination: formattedPayload.cta.destination || undefined,
          type: formattedPayload.cta.type || undefined,
          componentName: formattedPayload.cta.componentName || undefined
        };
      } // don't push the event if adobe script is not present


      if (config.adobeDataLayer) config.adobeDataLayer.push(_extends({
        event: payload.event
      }, formattedPayload));
      return formattedPayload;
    }

    return {};
  };

  var pageView = function pageView(pageName, properties) {
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _ref3 = properties || {},
          _ref3$eventProperties = _ref3.eventProperties,
          eventProperties = _ref3$eventProperties === void 0 ? {} : _ref3$eventProperties;

      var formattedPayload = _extends({}, pluginConfig);

      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(eventProperties, formattedPayload); // updating the global config data with every pageView Data

      configs = _extends({}, formattedPayload);
      formattedPayload.page.pageInfo.pageName = formattedPayload != null && formattedPayload.doNotFormatPageName ? pageName.toLowerCase() : formatPageName({
        section: formattedPayload.page.pageInfo.section,
        lob: pluginConfig.page.pageInfo.lob,
        pageName: pageName
      });
      var payload = {
        event: 'Page_View',
        eventProperties: formattedPayload
      };
      track({
        payload: payload
      });
      return formattedPayload;
    }

    return {};
  };

  return {
    name: name,
    configs: configs,
    init: init,
    track: track,
    pageView: pageView
  };
};




/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdtAnalytics; }
});

// EXTERNAL MODULE: ../../node_modules/@growth/location/dist/growth-location.esm.js
var growth_location_esm = __webpack_require__(810);
// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
;// CONCATENATED MODULE: ../../node_modules/@growth/pdt-schema/schema/dist/growth-pdt-schema-schema.esm.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var growth_pdt_schema_schema_esm_CreateWebCommonSchema = function CreateWebCommonSchema(properties) {
  var _navigator, _navigator$connection;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  var event_details = properties.event_details,
      device = properties.device;
  this.values = {
    context: _extends({
      client_timestamp: Date.now(),
      server_timestamp: Date.now(),
      client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      template_id: '26029',
      topic_name: 'gi_growth_web_logging'
    }, properties == null ? void 0 : properties.context),
    event_details: _extends({
      page_uri: (event_details == null ? void 0 : event_details.page_uri) || window.location.href,
      canonical_host: (event_details == null ? void 0 : event_details.canonical_host) || window.location.origin,
      canonical_url: (event_details == null ? void 0 : event_details.canonical_url) || window.location.pathname,
      page_referrer: (event_details == null ? void 0 : event_details.page_referrer) || document.referrer,
      utm_campaign: (event_details == null ? void 0 : event_details.utm_campaign) || (0,growth_location_esm/* getQueryParam */.Ph)('utm_campaign'),
      utm_medium: (event_details == null ? void 0 : event_details.utm_medium) || (0,growth_location_esm/* getQueryParam */.Ph)('utm_medium'),
      utm_source: (event_details == null ? void 0 : event_details.utm_source) || (0,growth_location_esm/* getQueryParam */.Ph)('utm_source')
    }, properties.event_details),
    user: properties.user,
    device: _extends({
      user_agent: navigator.userAgent,
      network_type: ((_navigator = navigator) == null ? void 0 : (_navigator$connection = _navigator.connection) == null ? void 0 : _navigator$connection.effectiveType) || '',
      visitor_id: (device == null ? void 0 : device.visitor_id) || (0,growth_visitor_id_browser_esm/* getVisitorIdBrowser */.MI)(),
      screen_height: (device == null ? void 0 : device.screen_height) || String(window.screen.height),
      screen_width: (device == null ? void 0 : device.screen_width) || String(window.screen.width)
    }, properties == null ? void 0 : properties.device)
  };
};



// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
;// CONCATENATED MODULE: ../../node_modules/@growth/pdt-track/dist/growth-pdt-track.esm.js



var isEmptyObject = function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0;
};
var DEFAULT_CONFIG = {
  debug: false
};
var PDT_URL = 'https://pdt.goibibo.com/dts/s/da/n';

var sendToPdt = function sendToPdt(_ref) {
  var url = _ref.url,
      analyticsData = _ref.analyticsData,
      debug = _ref.debug,
      customHeaders = _ref.customHeaders;
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };

  var _ref2 = customHeaders || {},
      dvid = _ref2.dvid,
      gaid = _ref2.gaid;

  if (dvid) headers.dvid = dvid;
  if (gaid) headers.gaid = gaid;
  if (debug) headers['X-DEBUG'] = true;
  return fetch(url, {
    method: 'POST',
    headers: headers,
    credentials: 'omit',
    body: JSON.stringify(analyticsData),
    // @ts-ignore-start
    priority: 'low',
    keepalive: true
  });
};

var pdtTrack = function pdtTrack(eventDetails, configs) {
  if (configs === void 0) {
    configs = DEFAULT_CONFIG;
  }

  if (isEmptyObject(eventDetails)) {
    throw new TypeError("Vaidation error on pdt.track; eventDetails parameter must have event key; eventDetails: " + eventDetails);
  }

  var _configs = configs,
      debug = _configs.debug;
  var allEventDetails = new CreateWebCommonSchema(eventDetails).values;
  /*
    * NOTE: we are not doing any validation on this package, since we want to keep this package size small.
    * For validation and more feature use analytics-plugin-pdt
    *
    * Log final events before sending to pdt
    */

  if (debug) console.log('@growth/pdt-track', allEventDetails);
  var dvid = getItem('__gi_vid');
  var gaid = getItem('_gid');
  return sendToPdt({
    url: PDT_URL,
    analyticsData: [allEventDetails],
    debug: configs.debug,
    customHeaders: {
      dvid: dvid,
      gaid: gaid
    }
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js



function growth_analytics_plugin_pdt_esm_extends() {
  growth_analytics_plugin_pdt_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return growth_analytics_plugin_pdt_esm_extends.apply(this, arguments);
}

var defaultConfig = {
  debug: false,
  pdtUrl: 'https://pdt.goibibo.com/dts/s/da/n',
  validator: function validator(obj) {
    return [];
  },
  batchDelay: 100,
  loadEventBatch: true,
  batchRegex: /(load|growth_non_int)/
};

function pdtAnalytics(pluginConfig) {
  if (pluginConfig === void 0) {
    pluginConfig = {};
  }

  var configs = growth_analytics_plugin_pdt_esm_extends({}, defaultConfig, pluginConfig);

  var loadEventsQueue = [];
  var loadEventScheduled;

  var doTrack = function doTrack(_ref) {
    var payload = _ref.payload;
    var event = payload.event,
        _payload$eventPropert = payload.eventProperties,
        eventProperties = _payload$eventPropert === void 0 ? {} : _payload$eventPropert,
        globalProperties = payload.globalProperties,
        options = payload.options;
    var debug = configs.debug,
        batchDelay = configs.batchDelay,
        loadEventBatch = configs.loadEventBatch,
        batchRegex = configs.batchRegex;
    var commonPayload = {
      context: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.context, eventProperties == null ? void 0 : eventProperties.context),
      device: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.device, eventProperties == null ? void 0 : eventProperties.device),
      event_details: growth_analytics_plugin_pdt_esm_extends({
        event: event
      }, eventProperties.event_details),
      user: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.user, eventProperties == null ? void 0 : eventProperties.user)
    };
    var pdtEvent = new growth_pdt_schema_schema_esm_CreateWebCommonSchema(commonPayload).values; // validation of schema

    if (debug && typeof configs.validator === 'function') {
      var invalidKeys = configs.validator(pdtEvent);

      if (invalidKeys.length) {
        console.error("pdt.track() schema validation failed: Sending event properties {" + invalidKeys + "} which are not a part of schema");
        return;
      }
    }

    var send = function send(events) {
      return sendToPdt({
        url: configs.pdtUrl,
        analyticsData: events,
        customHeaders: options == null ? void 0 : options.pdtApiHeaders,
        debug: debug
      });
    };
    /** Send load events in a bulk to avoid concurrent api calls */


    var isALoadEvent = function isALoadEvent(e) {
      return e.toLowerCase().match(batchRegex);
    };

    if (loadEventBatch && isALoadEvent(event)) {
      // keep the load event in an array
      loadEventsQueue.push(pdtEvent); // send the all load events in a batch after a certain delay

      if (!loadEventScheduled) {
        var scheduleSend = function scheduleSend() {
          if (debug) {
            console.log('LoadEvents Queue', loadEventsQueue.length);
          }

          send(loadEventsQueue); // !!! Important clear the array after events are sents

          loadEventsQueue = []; // reset the schedule

          loadEventScheduled = undefined;
        };

        loadEventScheduled = setTimeout(scheduleSend, batchDelay);
      }

      return;
    }

    send([pdtEvent]);
  };

  return {
    name: 'pdt-analytics-plugin',
    configs: configs,
    init: function init() {
      return configs;
    },
    track: function track(_ref2) {
      var payload = _ref2.payload;
      return doTrack({
        payload: payload
      });
    }
  };
}




/***/ }),

/***/ 1225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uH": function() { return /* binding */ defaultTheme; }
/* harmony export */ });
/* unused harmony exports breakPoints, buildTheme, colors, font, misc, spacing, useTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/
// Type - Family and Weight
var fwRegular = {
  fontWeight: 400
};
var fwMedium = {
  fontWeight: 500
};
var fwSemiBold = {
  fontWeight: 600
};
var fwBold = {
  fontWeight: 700
};
var fs32 = {
  fontSize: '32px'
};
var fs24 = {
  fontSize: '24px'
};
var fs18 = {
  fontSize: '18px'
};
var fs16 = {
  fontSize: '16px'
};
var fs14 = {
  fontSize: '14px'
};
var fs12 = {
  fontSize: '12px'
};
var lhAuto = {
  lineHeight: 'auto'
}; //  Font Headings

var xLarge = _extends({}, fwBold, fs32, lhAuto);

var Large = _extends({}, fwBold, fs24, lhAuto);

var Small = _extends({}, fwSemiBold, fs18, lhAuto);

var Base = _extends({}, fwSemiBold, fs16, lhAuto); // Font Labels


var LargeW1 = _extends({}, fwRegular, fs18, lhAuto);

var LargeW2 = _extends({}, fwMedium, fs18, lhAuto);

var LargeW3 = _extends({}, fwSemiBold, fs18, lhAuto);

var MediumW1 = _extends({}, fwRegular, fs16, lhAuto);

var MediumW2 = _extends({}, fwMedium, fs16, lhAuto);

var MediumW3 = _extends({}, fwSemiBold, fs16, lhAuto);

var BaseW1 = _extends({}, fwRegular, fs14, lhAuto);

var BaseW2 = _extends({}, fwMedium, fs14, lhAuto);

var BaseW3 = _extends({}, fwSemiBold, fs14, lhAuto);

var SmallW1 = _extends({}, fwRegular, fs12, lhAuto);

var SmallW2 = _extends({}, fwMedium, fs12, lhAuto);

var SmallW3 = _extends({}, fwSemiBold, fs12, lhAuto);

var giFontStandard = {
  xLarge: xLarge,
  Large: Large,
  Small: Small,
  Base: Base,
  LargeW1: LargeW1,
  LargeW2: LargeW2,
  LargeW3: LargeW3,
  MediumW1: MediumW1,
  MediumW2: MediumW2,
  MediumW3: MediumW3,
  BaseW1: BaseW1,
  BaseW2: BaseW2,
  BaseW3: BaseW3,
  SmallW1: SmallW1,
  SmallW2: SmallW2,
  SmallW3: SmallW3
};

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: _extends({}, giFontStandard)
};

var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }

  return _extends({}, fontThemeProperties);
};

var defaultSpacingThemeProperties = {
  unit: 1
};
function buildSpacing(spacingThemeProperties) {
  if (spacingThemeProperties === void 0) {
    spacingThemeProperties = defaultSpacingThemeProperties;
  }

  return {
    nospacing: 0,
    xxsmall: spacingThemeProperties.unit * 0.1 + "rem",
    // 1px | 0.1rem
    xsmall: spacingThemeProperties.unit * 0.2 + "rem",
    // 2px | 0.2rem
    small: spacingThemeProperties.unit * 0.5 + "rem",
    // 5px | 0.5rem
    base: spacingThemeProperties.unit + "rem",
    // 10px | 1rem
    large: spacingThemeProperties.unit * 1.5 + "rem",
    // 15px | 1.5rem
    xlarge: spacingThemeProperties.unit * 2 + "rem",
    // 20px | 2rem
    xxlarge: spacingThemeProperties.unit * 2.5 + "rem",
    // 25px | 2.5rem
    custom: function custom(multiplier // 3px 4px 6px 7px 8px | 0.3rem 0.4rem etc...
    ) {
      return spacingThemeProperties.unit * (multiplier * 0.1) + "rem";
    }
  };
}

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px

  }
};
function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }

  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem
      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px

    },
    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}
/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */

var defaultTheme = buildTheme();
/**
 * to check if theme exists on caller, else return defaultTheme
 */

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}




/***/ }),

/***/ 7263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tt": function() { return /* binding */ EXISTING_USER_STATUS_CODE; },
  "Wp": function() { return /* binding */ INVALID_OTP_CODE; },
  "XP": function() { return /* binding */ LOGIN_SUCCESS; },
  "Zb": function() { return /* binding */ MOBILE_NUMBER_MAX_LENGTH; },
  "vw": function() { return /* binding */ TRUECALLER_DEEPLINK_DATA; },
  "ti": function() { return /* binding */ clearSendOtpStore; },
  "H": function() { return /* binding */ clearUserTokens; },
  "hM": function() { return /* binding */ fetchLogoutUser; },
  "eR": function() { return /* binding */ getTruecallerDeepLink; },
  "P_": function() { return /* binding */ getUuidFromCookie; },
  "Ju": function() { return /* binding */ isEmailValid; },
  "gR": function() { return /* binding */ isMobileEncoded; },
  "Pz": function() { return /* binding */ isNameValid; },
  "Xv": function() { return /* binding */ isNumberValid; },
  "Tq": function() { return /* binding */ isUserTokenPresent; },
  "lq": function() { return /* binding */ useLoginUserStore; },
  "dt": function() { return /* binding */ usePrefillLoginDetails; },
  "Oz": function() { return /* binding */ useProfileStore; },
  "IR": function() { return /* binding */ useProfileUpdateStore; },
  "Y6": function() { return /* binding */ useSendOtpStore; },
  "W3": function() { return /* binding */ useSignupViaOTPStore; },
  "AJ": function() { return /* binding */ useTruecallerLoginStore; }
});

// UNUSED EXPORTS: ALPHABET_REGEX, BILLING_CATEGORY, EMAIL_REGEX, INVALID_AUTH_TOKEN_CODE, NEW_USER_STATUS_CODE, deleteSessionId, fetchCreateUser, fetchLoginJwtToken, fetchLoginUser, fetchMultipleLogins, fetchProfileDetails, fetchProfileUpdate, fetchRequestEmailVerification, fetchSendDeleteOTP, fetchSendOTP, fetchSignupViaOTP, fetchTruecallerLogin, fetchUpdateProfilePic, fetchVerifyEmail, getAuthToken, getEncryptedUuid, getEssentialHeader, logoutSpecificDevice, mobileValidation, profileViewQuery, setUserTokenAndUuid, useLoginEncryptedJwtToken, useUploadProfileImageStore

// EXTERNAL MODULE: ../../node_modules/@growth/fetch-request/dist/growth-fetch-request.esm.js
var growth_fetch_request_esm = __webpack_require__(6963);
// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
// EXTERNAL MODULE: ../../node_modules/@growth/user-agents/dist/growth-user-agents.esm.js
var growth_user_agents_esm = __webpack_require__(6253);
// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
// EXTERNAL MODULE: ../../node_modules/@growth/object-utils/dist/growth-object-utils.esm.js
var growth_object_utils_esm = __webpack_require__(7106);
// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(1917);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
;// CONCATENATED MODULE: ../../node_modules/@growth/dom-utils/dist/growth-dom-utils.esm.js
var isEnterEvent = function isEnterEvent(event) {
  var keyCode = event.key;
  return keyCode === 'Enter';
};

var isArrowDownKey = function isArrowDownKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowDown';
};

var isArrowUpKey = function isArrowUpKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowUp';
};

var isArrowLeftKey = function isArrowLeftKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowLeft';
};

var isArrowRightKey = function isArrowRightKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowRight';
};

var addScript = function addScript(scriptURl, opts) {
  if (typeof window !== 'undefined') {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptURl;
    script.async = opts.async || false;
    script.onload = opts.onload || null;
    var position = document.querySelector(opts.position || 'body');

    if (position) {
      position.append(script);
    }
  }
};

// this method add delay in resolving the promise
var promiseDelay = function promiseDelay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};



// EXTERNAL MODULE: ../../node_modules/@growth/date-utils/dist/growth-date-utils.esm.js + 1 modules
var growth_date_utils_esm = __webpack_require__(7862);
;// CONCATENATED MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js











var HOST = "//userservice.goibibo.com";
var PATHS = {
  dweb: "ext/web/desktop",
  mweb: "ext/web/pwa"
};

var getApiUrls = function getApiUrls(p) {
  var config = {
    USER_DETAILS: HOST + "/" + PATHS[p] + "/user/details",
    LOGOUT: HOST + "/" + PATHS[p] + "/user/logout",
    MOBILE_DETAILS: HOST + "/" + PATHS[p] + "/send/token/OTP_IS_REG",
    LOGIN: HOST + "/" + PATHS[p] + "/login",
    SIGN_UP: HOST + "/" + PATHS[p] + "/verify/token/SIGNUP_OTP",
    CREATE_NEW_USER: HOST + "/" + PATHS[p] + "/user/create/false",
    UPDATE_PROFILE: HOST + "/" + PATHS[p] + "/user/update",
    GET_EMAIL_TOKEN: HOST + "/" + PATHS[p] + "/send/token/EMAIL",
    VERIFY_EMAIL: HOST + "/" + PATHS[p] + "/verify/token/EMAIL",
    UPDATE_PROFILE_PIC: HOST + "/" + PATHS[p] + "/user/upload/imageclass/displaypic",
    REDIRECT_TO_APP: HOST + "/" + PATHS[p] + "/UserService/send/token/LINK",
    DELETE_OTP: HOST + "/" + PATHS[p] + "/send/token/OTP_DELETE",
    SOCIAL_LOGIN: HOST + "/" + PATHS[p] + "/appSocialLogin",
    JWT_TOKEN: HOST + "/" + PATHS[p] + "/jwt/loginToken",
    LOGOUT_DEVICE: HOST + "/" + PATHS[p] + "/user/logout",
    MULTIPLE_LOGINS: HOST + "/" + PATHS[p] + "/user/activeSessions",
    PREFILL_DETAILS: HOST + "/" + PATHS[p] + "/prefill/login/details"
  };
  return config;
};

var GI_TOKEN_NAME = 'OAUTH-GOIBIBO';
var GA_TOKEN = 'gapauthtoken';
var GI_UUID = 'gitokenid';
var GI_SESSIONID = 'sessionid';

var clearUserTokens = function clearUserTokens() {
  (0,growth_cookies_esm/* removeItem */.cl)(GI_TOKEN_NAME, '/', 'goibibo.com');
  (0,growth_cookies_esm/* removeItem */.cl)(GA_TOKEN, '/', 'goibibo.com');
  (0,growth_cookies_esm/* removeItem */.cl)(GI_UUID, '/', 'goibibo.com');
};

var getAuthToken = function getAuthToken() {
  return (0,growth_cookies_esm/* getItem */.rV)('OAUTH-GOIBIBO');
};

var isUserTokenPresent = function isUserTokenPresent() {
  var authToken = getAuthToken();
  return !!authToken;
};

var getEncryptedUuid = function getEncryptedUuid() {
  return getItem('gapauthtoken');
};

var getUuidFromCookie = function getUuidFromCookie() {
  return (0,growth_cookies_esm/* getItem */.rV)('gitokenid');
};

var setUserTokenAndUuid = function setUserTokenAndUuid(_ref) {
  var _window;

  var authToken = _ref.authToken,
      uuid = _ref.uuid;
  (0,growth_cookies_esm/* setItem */.LS)(GI_TOKEN_NAME, authToken, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,growth_cookies_esm/* setItem */.LS)(GA_TOKEN, (_window = window) == null ? void 0 : _window.btoa(uuid), {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,growth_cookies_esm/* setItem */.LS)(GI_UUID, uuid, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
};

var deleteSessionId = function deleteSessionId() {
  return removeItem(GI_SESSIONID, '/', 'goibibo.com');
};

var API_AUTH = {
  MWEB: 'h4nhc9jcgpAGIjp',
  DWEB: 'jkO7Ivpwsh4KaQ9',
  HCS: 'cmVzdDoxMjM0NTY='
};

var getUserIdentifierHeader = function getUserIdentifierHeader(_ref) {
  var _getBrowserDetails;

  var platform = _ref.platform;
  return JSON.stringify({
    type: 'auth',
    deviceId: (0,growth_visitor_id_browser_esm/* getVisitorIdBrowser */.MI)() || 'deviceId',
    os: platform === 'mweb' ? 'pwa' : 'desktop',
    osVersion: 'osVersion',
    appVersion: 'appVersion',
    imie: 'imie',
    ipAddress: 'ipAddress',
    timeZone: '+5.30 GMT',
    value: getAuthToken() || '',
    deviceOrBrowserInfo: ((_getBrowserDetails = (0,growth_user_agents_esm/* getBrowserDetails */.hf)()) == null ? void 0 : _getBrowserDetails.browserName) || ''
  });
};

var getEssentialHeader = function getEssentialHeader(_ref2) {
  var platform = _ref2.platform;
  return {
    Authorization: API_AUTH[platform.toUpperCase()],
    'User-Identifier': getUserIdentifierHeader({
      platform: platform
    }),
    'X-request-tracker': (0,growth_visitor_id_browser_esm/* generateVid */.im)(),
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
};

var profileViewQuery = {
  query: [[{
    name: 'extendedUser',
    keys: ['profileId', 'uuid', 'primaryEmailId', 'userType', 'profileType', 'loginInfoList', 'personalDetails']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'personalDetails',
    keys: ['gender', 'dateOfBirth']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'userImages',
    keys: ['fileUrl', 'imageClass'],
    filters: [{
      name: 'imageClass',
      type: 'string',
      value: 'displaypic'
    }]
  }], [{
    name: 'extendedUser'
  }, {
    name: 'profileCompletionDetails',
    keys: ['ctaDetails', 'completionScore', 'title', 'subText', 'component']
  }], [{
    name: 'loginInfoList',
    keys: ['loginId', 'loginType', 'primary', 'status', 'countryCode', 'verified']
  }], [{
    name: 'miscFields',
    keys: ['altEmailId']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'addressDetails',
    keys: ['addressId', 'city', 'name', 'category', 'houseNo', 'street', 'state', 'country', 'postalCode', 'landMark', 'status', 'lastUpdated', 'address1']
  }]]
};
var BILLING_CATEGORY = 'BILLING';

var fetchProfileDetails = function fetchProfileDetails(_ref) {
  var platform = _ref.platform;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).USER_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: profileViewQuery,
    credentials: 'omit'
  }).post();
};

var generateProfileUpdateQuery = function generateProfileUpdateQuery(profileFields) {
  var firstName = profileFields.firstName,
      lastName = profileFields.lastName,
      dob = profileFields.dob,
      gender = profileFields.gender,
      email = profileFields.email,
      addressDetails = profileFields.addressDetails;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        personalDetails: {
          gender: gender,
          name: {
            firstName: firstName,
            lastName: lastName
          },
          dateOfBirth: dob
        },
        miscFields: {
          altEmailId: email
        },
        addressDetails: addressDetails
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,growth_object_utils_esm/* removeEmptyValues */.ks)(q);
};

var generateUserCreateQuery = function generateUserCreateQuery(fields) {
  var mobileNumber = fields.mobileNumber,
      fullName = fields.fullName,
      email = fields.email,
      _fields$countryCode = fields.countryCode,
      countryCode = _fields$countryCode === void 0 ? '91' : _fields$countryCode;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        profileType: 'PERSONAL',
        personalDetails: {
          name: {
            firstName: fullName
          }
        },
        miscFields: {
          altEmailId: email
        },
        loginInfoList: [{
          loginId: mobileNumber,
          countryCode: countryCode,
          loginType: 'MOBILE'
        }]
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,growth_object_utils_esm/* removeEmptyValues */.ks)(q);
};

var fetchProfileUpdate = function fetchProfileUpdate(_ref) {
  var platform = _ref.platform,
      data = _ref.data;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).UPDATE_PROFILE, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: generateProfileUpdateQuery(data),
    credentials: 'omit'
  }).post();
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var fetchUpdateProfilePic = function fetchUpdateProfilePic(_ref) {
  var platform = _ref.platform,
      file = _ref.file;
  var formData = new FormData();
  formData.append('file', file);
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).UPDATE_PROFILE_PIC, {
    headers: _extends({}, getEssentialHeader({
      platform: platform
    })),
    body: formData,
    credentials: 'omit'
  }).post();
};

var fetchSendOTP = function fetchSendOTP(_ref) {
  var platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      loginType = _ref.loginType,
      isEncoded = _ref.isEncoded;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).MOBILE_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: mobileNumber,
      countryCode: '91',
      channel: [loginType],
      type: 6,
      isEncoded: isEncoded,
      appHashKey: platform === 'mweb' ? "@" + (0,growth_ssr_utils_esm/* getBaseHostName */.l_)() + " #" : ''
    },
    credentials: 'include'
  }).post();
};

var fetchCreateUser = function fetchCreateUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      transactionId = _ref.transactionId,
      mobileNumber = _ref.mobileNumber,
      fullName = _ref.fullName,
      email = _ref.email,
      countryCode = _ref.countryCode;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).CREATE_NEW_USER + "?guest=false&trxId=" + transactionId, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: generateUserCreateQuery({
      mobileNumber: mobileNumber,
      fullName: fullName,
      email: email,
      countryCode: countryCode
    })
  }).post();
};

var fetchLoginUser = function fetchLoginUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      passwordType = _ref.passwordType,
      password = _ref.password,
      isEncoded = _ref.isEncoded,
      encodedLoginId = _ref.encodedLoginId;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).LOGIN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      mobileNumber: isEncoded ? encodedLoginId : mobileNumber,
      countryCode: '91',
      password: password,
      type: 'MOBILE',
      passwordType: passwordType,
      isEncoded: isEncoded,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchSignupViaOTP = function fetchSignupViaOTP(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? 91 : _ref$countryCode,
      password = _ref.password;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).SIGN_UP, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'include',
    body: {
      mobileNumber: mobileNumber,
      countryCode: countryCode,
      type: '6',
      token: password
    }
  }).post();
};

var fetchLogoutUser = function fetchLogoutUser(_ref) {
  var platform = _ref.platform;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).LOGOUT, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit'
  })["delete"]().then(function (res) {
    if (res != null && res.success) {
      clearUserTokens();
    }

    return res;
  })["catch"](function (e) {
    return e;
  });
};

var fetchSendDeleteOTP = function fetchSendDeleteOTP(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).DELETE_OTP, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '16',
      channel: ['MOBILE']
    },
    credentials: 'include'
  }).post();
};

var TRUECALLER_DEEPLINK_DATA = {
  partnerKey: 'YDO2j919392e8b6fa4a059b697fd280503e67',
  partnerName: 'Goibibo',
  lang: 'en',
  privacyUrl: 'https://www.goibibo.com/info/privacy-policy/',
  termsUrl: 'https://www.goibibo.com/info/user-agreement/',
  loginPrefix: 'getstarted',
  loginSuffix: 'signin',
  btnShape: 'rect',
  skipOption: 'manualdetails',
  ctaPrefix: 'use',
  ctaColor: '%23ff6d38',
  ctaTextColor: '%23ffffff',
  PollingDefaultTimeout: 1000,
  PollingIntervalTimeout: {
    "default": 1000,
    stage1: 1500,
    stage2: 2500
  },
  PollingTimeoutCountSessionKey: 'truecaller_timer_count',
  PollingThreshold: 25,
  pollingHitStage: {
    stage1: 8,
    stage2: 15
  },
  skipCtaTruecallerActivate: 5,
  PollingState: {
    pending: 'PROCESSING',
    complete: 'SUCCESS',
    skipped: 'TRUE_CALLER_LOGIN_SKIPPED',
    error: 'error'
  }
};
var getTruecallerDeepLink = function getTruecallerDeepLink(reqId, deepLinkData) {
  return "truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=" + reqId + "&partnerKey=" + deepLinkData.partnerKey + "&partnerName=" + deepLinkData.partnerName + "&lang=" + deepLinkData.lang + "&skipOption=" + deepLinkData.skipOption + "&btnShape=" + deepLinkData.btnShape + "&loginPrefix=" + deepLinkData.loginPrefix + "&loginSuffix=" + deepLinkData.loginSuffix + "&ctaPrefix=" + deepLinkData.ctaPrefix + "&ctaColor=" + deepLinkData.ctaColor + "&ctaTextColor=" + deepLinkData.ctaTextColor + "&privacyUrl=" + deepLinkData.privacyUrl + "&termsUrl=" + deepLinkData.termsUrl;
};

var INVALID_AUTH_TOKEN_CODE = 5405;
var EXISTING_USER_STATUS_CODE = 4200;
var NEW_USER_STATUS_CODE = 4404;
var INVALID_OTP_CODE = 403;

// used on mweb and dweb both for login success event
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';

var fetchTruecallerLogin = function fetchTruecallerLogin(opts) {
  var platform = opts.platform,
      requestId = opts.requestId;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + getApiUrls(platform).SOCIAL_LOGIN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      accType: 'TRUE_CALLER',
      requestId: requestId,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchVerifyEmail = function fetchVerifyEmail(_ref) {
  var platform = _ref.platform,
      token = _ref.token;
  return fetchRequest(getApiUrls(platform).VERIFY_EMAIL, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '2',
      token: token
    },
    credentials: 'omit'
  }).post();
};

var fetchRequestEmailVerification = function fetchRequestEmailVerification(_ref) {
  var platform = _ref.platform,
      email = _ref.email;
  return fetchRequest(getApiUrls(platform).GET_EMAIL_TOKEN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: email,
      type: '2',
      channel: ['EMAIL']
    },
    credentials: 'omit'
  }).post();
};

var fetchLoginJwtToken = function fetchLoginJwtToken(_ref) {
  var platform = _ref.platform,
      client = _ref.client;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).JWT_TOKEN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      client: client
    }
  }).post();
};

var fetchMultipleLogins = function fetchMultipleLogins(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).MULTIPLE_LOGINS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit'
  }).post();
};

var logoutSpecificDevice = function logoutSpecificDevice(_ref) {
  var platform = _ref.platform,
      id = _ref.id;
  return fetchRequest(getApiUrls(platform).LOGOUT_DEVICE, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    query: "id=" + id
  })["delete"]();
};

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchFun$7 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, extendedUser, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchProfileUpdate({
              platform: platform,
              data: data
            });

          case 3:
            res = _context.sent;
            _context.next = 6;
            return promiseDelay(1000);

          case 6:
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            value = extendedUser;
            return _context.abrupt("return", value);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileUpdateStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$7.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess,
        onError: opts == null ? void 0 : opts.onError
      });
    }
  });
});

var fetchFun$6 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _userImages$;

    var platform, res, _ref3, extendedUser, personalDetails, miscFields, userImages, uuid, profileId, profileType, profileCompletionDetails, loginInfoList, addressDetails, _ref4, gender, name, firstName, lastName, middleName, _ref5, _ref5$altEmailId, altEmailId, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform;
            _context.next = 3;
            return fetchProfileDetails({
              platform: platform
            });

          case 3:
            res = _context.sent;
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            personalDetails = extendedUser.personalDetails, miscFields = extendedUser.miscFields, userImages = extendedUser.userImages, uuid = extendedUser.uuid, profileId = extendedUser.profileId, profileType = extendedUser.profileType, profileCompletionDetails = extendedUser.profileCompletionDetails, loginInfoList = extendedUser.loginInfoList, addressDetails = extendedUser.addressDetails;
            _ref4 = personalDetails || {}, gender = _ref4.gender, name = _ref4.name;
            firstName = name.firstName, lastName = name.lastName, middleName = name.middleName;
            _ref5 = miscFields || {}, _ref5$altEmailId = _ref5.altEmailId, altEmailId = _ref5$altEmailId === void 0 ? '' : _ref5$altEmailId;
            value = {
              firstName: !firstName && !middleName && !lastName ? 'TRAVELLER' : firstName,
              middleName: middleName,
              lastName: lastName,
              mobileNumber: '',
              mobileVerified: '',
              email: '',
              emailVerified: '',
              gender: gender,

              /* API gives epoc -> convert it to yyyy-mm-dd */
              dob: personalDetails.dateOfBirth ? (0,growth_date_utils_esm/* epocToDate */.Ow)(personalDetails.dateOfBirth) : undefined,
              profileImage: userImages == null ? void 0 : (_userImages$ = userImages[0]) == null ? void 0 : _userImages$.fileUrl,
              uuid: uuid,
              profileId: profileId,
              profileType: profileType,
              countryCode: '',
              isLoggedIn: !!uuid,
              profileCompletionDetails: (profileCompletionDetails == null ? void 0 : profileCompletionDetails[0]) || {},
              addressDetails: addressDetails
            };
            loginInfoList.forEach(function (item) {
              if ((item == null ? void 0 : item.loginType) === 'MOBILE') {
                var _item$countryCode;

                value.mobileVerified = item == null ? void 0 : item.verified;
                value.countryCode = item == null ? void 0 : item.countryCode;
                value.mobileNumber = item.loginId.slice(item == null ? void 0 : (_item$countryCode = item.countryCode) == null ? void 0 : _item$countryCode.length);
              }

              if (item.loginType === 'EMAIL') {
                value.emailVerified = item.verified;
                value.email = item.loginId;
              }
            });

            if (!value.email) {
              value.email = altEmailId;
            }

            return _context.abrupt("return", value);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileStore = (0,esm/* create */.Ue)()(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$6.bind(null, opts),
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message,
            status: err == null ? void 0 : err.status
          });
        }
      });
    }
  });
});

var fetchFun$5 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, file, res, _ref3, data, success, message;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, file = _ref.file;
            _context.next = 3;
            return fetchUpdateProfilePic({
              platform: platform,
              file: file
            });

          case 3:
            res = _context.sent;
            _ref3 = res || {}, data = _ref3.data, success = _ref3.success, message = _ref3.message;

            if (success) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              error: true,
              errorMsg: message
            });

          case 7:
            return _context.abrupt("return", {
              error: false,
              uploadedImage: data
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useUploadProfileImageStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {
      uploadedImage: '',
      successMsg: '',
      error: false,
      errorMsg: ''
    },
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$5.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var loginWithMobileErrors = {
  typeErrorMsg: 'Alphabets and Special Characters are not allowed',
  notAValidMobileNumber: 'Please enter a valid mobile number',
  lengthErrorMsg: 'Please enter a 10 digit mobile number'
};
var MOBILE_NUMBER_REGEX = /^[6-9]\d{9}$/;
var MOBILE_NUMBER_MAX_LENGTH = 10;
var mobileValidation = function mobileValidation(phone) {
  if (phone) {
    if (Number.isNaN(Number(phone))) {
      return {
        valid: false,
        errorMsg: loginWithMobileErrors.typeErrorMsg
      };
    }

    if (typeof phone === 'string') {
      if (phone.length !== MOBILE_NUMBER_MAX_LENGTH) {
        return {
          valid: false,
          errorMsg: loginWithMobileErrors.lengthErrorMsg
        };
      }
    }

    if (MOBILE_NUMBER_REGEX.test(phone)) {
      return {
        valid: true,
        errorMsg: ''
      };
    }
  }

  return {
    valid: false,
    errorMsg: loginWithMobileErrors.notAValidMobileNumber
  };
};
var isMobileEncoded = function isMobileEncoded(mobileNumber, encodedMobileNumber) {
  if (mobileNumber.includes('**') && encodedMobileNumber === mobileNumber) return true;
  return false;
};

var fetchFun$4 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchSendOTP(_extends({
              platform: platform
            }, data, {
              mobileNumber: data.isEncoded ? data.encodedLoginId : data.mobileNumber
            }));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", _extends({}, res, {
              mobileNumber: data.mobileNumber,
              isMobileNumberEncoded: data.isEncoded || false
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var intialState = {
  validation: {
    isValidMobile: false,
    message: ''
  },
  error: {
    errorMsg: '',
    errorDetails: null
  }
};
var useSendOtpStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: _extends({}, intialState),
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$4.bind(null, opts),
        onSuccess: function onSuccess(res) {
          if (res.success) {
            if (opts.onSuccess) opts.onSuccess(res);
          } else {
            set(function (s) {
              return {
                error: true,
                data: _extends({}, s.data, {
                  error: {
                    errorMsg: res.message
                  }
                })
              };
            });
            if (opts.onError) opts.onError();
          }
        },
        onError: function onError(err) {
          set(function (s) {
            return {
              error: true,
              data: _extends({}, s.data, {
                error: {
                  errorMsg: 'Some error occurred, please try again.',
                  errorDetails: err
                }
              })
            };
          });
          if (opts.onError) opts.onError();
        }
      });
    },
    checkValid: function checkValid(mobileNumber, isMobileNumberEncoded) {
      var validDetails = _extends({}, intialState.validation);

      if (isMobileNumberEncoded) {
        validDetails.isValidMobile = true;
      } else {
        var data = mobileValidation(mobileNumber);
        validDetails.isValidMobile = data.valid;
        validDetails.message = data.errorMsg;
      }

      set({
        data: {
          validation: validDetails
        }
      });
      return validDetails.isValidMobile;
    }
  });
});

var clearSendOtpStore = function clearSendOtpStore() {
  return useSendOtpStore.setState({
    data: _extends({}, intialState),
    error: false
  });
};

var fetchFun$3 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _resData$profileLogin;

    var platform, data, res, _ref3, resData, code, message, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchLoginUser(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, code = _ref3.code, message = _ref3.message;
            /* Error case */

            if (!code) {
              _context.next = 7;
              break;
            }

            throw {
              code: code,
              message: message
            };

          case 7:
            profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
            authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
            _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

            if (authToken && uuid) {
              setUserTokenAndUuid({
                authToken: authToken,
                uuid: uuid
              });
            }

            return _context.abrupt("return", res);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginUserStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$3.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun$2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _res$data, trxID;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchSignupViaOTP(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;

            if (!res.success) {
              _context.next = 7;
              break;
            }

            trxID = (_res$data = res.data) == null ? void 0 : _res$data.trxId;
            return _context.abrupt("return", {
              transactionId: trxID
            });

          case 7:
            if (!res.code) {
              _context.next = 9;
              break;
            }

            throw _extends({}, res);

          case 9:
            return _context.abrupt("return", {});

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useSignupViaOTPStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$2.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res.trxID);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    },
    createUser: function createUser(opts) {
      return fetchCreateUser(opts);
    }
  });
});

var fetchFun$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, resData, message, _resData$profileLogin, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchTruecallerLogin(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, _ref3.code, message = _ref3.message;

            if (message === 'SUCCESS') {
              profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
              authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
              _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

              if (authToken && uuid) {
                setUserTokenAndUuid({
                  authToken: authToken,
                  uuid: uuid
                });
              }
            }

            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useTruecallerLoginStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$1.bind(null, opts),
        onSuccess: function onSuccess(details) {
          return opts == null ? void 0 : opts.onSuccess(details);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, client;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, client = _ref.client;
            return _context.abrupt("return", fetchLoginJwtToken({
              platform: platform,
              client: client
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginEncryptedJwtToken = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun.bind(null, opts),
        onError: opts.onError,
        onSuccess: opts.onSuccess
      });
    }
  });
});

var fetchPrefillLoginDetails = function fetchPrefillLoginDetails(_ref) {
  var platform = _ref.platform,
      controller = _ref.controller;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).PREFILL_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      retryCount: 1
    },
    credentials: 'omit',
    controller: controller
  }).post();
};

var _fetchFun = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, controller, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, controller = _ref.controller;
            _context.next = 3;
            return fetchPrefillLoginDetails({
              platform: platform,
              controller: controller
            });

          case 3:
            res = _context.sent;
            return _context.abrupt("return", {
              encodedMobileNumber: res == null ? void 0 : res.loginId,
              countryCode: res == null ? void 0 : res.countryCode,
              encLoginId: res == null ? void 0 : res.encLoginId
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var usePrefillLoginDetails = (0,esm/* create */.Ue)(function (set) {
  var controller = typeof AbortController === 'function' ? new AbortController() : undefined;
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    controller: controller,
    userInputMobileNumber: null,
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: function fetchFun() {
          return _fetchFun(_extends({}, opts, {
            controller: controller
          }));
        }
      });
    },
    setUserInputMobileNumber: function setUserInputMobileNumber(mobileNumber) {
      return set({
        userInputMobileNumber: mobileNumber
      });
    }
  });
});

var EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

var isEmailValid = function isEmailValid(emailId) {
  if (emailId) return EMAIL_REGEX.test(emailId);
  return false;
};

var ALPHABET_REGEX = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/;

var isNameValid = function isNameValid(fullName) {
  if (fullName) return ALPHABET_REGEX.test(fullName);
  return false;
};

var NUMREGEX = /^[0-9]+$/;
var isNumberValid = function isNumberValid(num) {
  if (num) return NUMREGEX.test(num);
  return false;
};




/***/ }),

/***/ 8132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bW": function() { return /* binding */ getAuthToken; },
/* harmony export */   "zv": function() { return /* binding */ getEncryptedUuid; }
/* harmony export */ });
/* unused harmony exports doLogOut, isExistingUser, isUserTokenPresent */
/* harmony import */ var _growth_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2048);


function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getAuthToken = function getAuthToken() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)('OAUTH-GOIBIBO');
}; // TODO: Make it isomorphic


var isUserTokenPresent = function isUserTokenPresent() {
  var authToken = getAuthToken();
  return !!authToken;
};
/**
	if existing user:
	response = { SSK : "RS01F" }

	if new user:
	response = { SSK : "RS02F" }
*/


var isExistingUser = function isExistingUser(k) {
  return k === "RS01F";
};

var doLogOut = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var endpointUrl, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpointUrl = '/logoutuser/';
            _context.prev = 1;
            _context.next = 4;
            return fetch("" + endpointUrl);

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw Error(response.statusText);

          case 7:
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Promise.reject(new Error('Unsuccessful attempt to logout.')));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function doLogOut() {
    return _ref.apply(this, arguments);
  };
}()));

var getEncryptedUuid = function getEncryptedUuid() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)('gapauthtoken');
};




/***/ }),

/***/ 2927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ docSessionStorage; },
/* harmony export */   "U": function() { return /* binding */ docLocalStorage; }
/* harmony export */ });
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


var BROWSER_STORAGE_TYPE = {
  LOCAL_STORAGE: _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK ? window.localStorage : '',
  SESSION_STORAGE: _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK ? window.sessionStorage : ''
};
var makeExpireTime = function makeExpireTime(sec) {
  if (sec === void 0) {
    sec = 0;
  }
  // take ttl in sec to keep the api same across all other cache utils
  var d = new Date();
  d.setSeconds(d.getSeconds() + sec);
  return d.getTime();
};
var isTimeExpired = function isTimeExpired(time) {
  return new Date().getTime() - time >= 0;
};
function storageAvailable(type) {
  var storage;
  try {
    storage = type;
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}
var storage = function storage(backed) {
  return {
    setItem: function setItem(key, value, expiryTime) {
      if (!storageAvailable(backed)) return null;
      if (value === undefined) {
        backed.removeItem(key);
      } else {
        var storageValue = {
          value: value
        };
        if (expiryTime) {
          storageValue.timeStamp = makeExpireTime(expiryTime);
        }
        backed.setItem(key, JSON.stringify(storageValue));
      }
      return value;
    },
    getItem: function getItem(key) {
      if (!storageAvailable(backed)) return null;
      var value; // undefined
      var str = backed.getItem(key);
      if (str) {
        try {
          var _JSON$parse = JSON.parse(str),
            respValue = _JSON$parse.value,
            timeStamp = _JSON$parse.timeStamp;
          if (timeStamp && isTimeExpired(timeStamp)) {
            backed.removeItem(key);
          } else {
            value = respValue;
          }
        } catch (e) {
          // console.log(`Error parsing storage ['${ key }']`);
          backed.removeItem(key);
        }
      }
      return value;
    },
    removeItem: function removeItem(key) {
      if (!storageAvailable(backed)) return null;
      return backed.removeItem(key);
    }
  };
};
var getLocalStorage = function getLocalStorage() {
  return storage(BROWSER_STORAGE_TYPE.LOCAL_STORAGE);
};
var getSessionStorage = function getSessionStorage() {
  return storage(BROWSER_STORAGE_TYPE.SESSION_STORAGE);
};
var docLocalStorage = getLocalStorage();
var docSessionStorage = getSessionStorage();




/***/ }),

/***/ 4162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ao": function() { return /* binding */ createConfigStore; },
  "a_": function() { return /* binding */ setData; }
});

// UNUSED EXPORTS: getConfigStoreDataClient

// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-calls/dist/pokus-dynamic-config-19800874.esm.js
function pokus_dynamic_config_19800874_esm_extends() {
  pokus_dynamic_config_19800874_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return pokus_dynamic_config_19800874_esm_extends.apply(this, arguments);
}

var pokus_dynamic_config_19800874_esm_generatePokusAssignVariantBodyRequest = function generatePokusAssignVariantBodyRequest(_ref) {
  var lob = _ref.lob,
    isMobile = _ref.isMobile,
    deviceId = _ref.deviceId,
    _ref$extraOptions = _ref.extraOptions,
    extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var request = {
    lob: lob,
    user: pokus_dynamic_config_19800874_esm_extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: pokus_dynamic_config_19800874_esm_extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes)
  };
  return {
    request: request
  };
};

var pokus_dynamic_config_19800874_esm_generateSkywalkerBodyRequest = function generateSkywalkerBodyRequest(_ref) {
  var extraReqBody = _ref.extraReqBody;
  var request = pokus_dynamic_config_19800874_esm_extends({
    brand: 'gi',
    user: {
      loginChannel: 'GI'
    }
  }, extraReqBody);
  return request;
};

/**
 *
 * @docs http://confluence.mmt.com/pages/viewpage.action?pageId=823704867
 */

var pokus_dynamic_config_19800874_esm_generatePokusDynamicConfigBodyRequest = function generatePokusDynamicConfigBodyRequest(_ref) {
  var lob = _ref.lob,
    isMobile = _ref.isMobile,
    deviceId = _ref.deviceId,
    _ref$extraOptions = _ref.extraOptions,
    extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var configDevice = isMobile ? 'PWA' : 'DESKTOP';
  var request = {
    lob: lob,
    user: pokus_dynamic_config_19800874_esm_extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: pokus_dynamic_config_19800874_esm_extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes),
    scope: pokus_dynamic_config_19800874_esm_extends({
      lob: lob,
      deviceOS: configDevice,
      tags: []
    }, extraOptions.scope)
  };
  var propertiesToAssign = ['productFeatureConfigKeys', 'features', 'applicationProperties', 'experimentIds'];
  propertiesToAssign.forEach(function (property) {
    if (extraOptions[property]) {
      request[property] = extraOptions[property];
    }
  });
  return request;
};



// EXTERNAL MODULE: ../../node_modules/@growth/fetch-request/dist/growth-fetch-request.esm.js
var growth_fetch_request_esm = __webpack_require__(6963);
;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-configs/dist/index-530eda38.esm.js
var hosts = {
  goibibo: '//www.goibibo.com',
  pokus: '//pokus.goibibo.com',
  recommendEarnUrl: '//influencer.goibibo.com',
  skywalker: '//mapi.goibibo.com',
  voyagerX: '//voyagerx.goibibo.com',
  voyager: '//voyager.goibibo.com',
  recentSearchPush: '//pdt.goibibo.com',
  gdpr: '//consentmgmt.makemytrip.com',
  appBannerUrl: "//userservice.goibibo.com",
  userGeoLocation: '//mapi.goibibo.com',
  configStore: '//configstore.goibibo.com',
  argus: '//www.goibibo.com',
  loyaltyUserInfo: '//membership-service.goibibo.com',
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: '//www.goibibo.com',
  amigoSyncUp: '//mitra.goibibo.com'
};

var PP = 'pp';
var LOCAL = 'local';
var PROD_PP = 'prodpp';
var PROD = 'prod';
var envs = [PROD, PP, PROD_PP, LOCAL];

var index_530eda38_esm_filterConfigForEnv = function filterConfigForEnv(configs, env) {
  if (env === void 0) {
    env = 'prod';
  }
  var normalizeEnvVar = function normalizeEnvVar(v) {
    var validEnvVar = function validEnvVar(ve) {
      return envs.includes(ve);
    };
    if (!validEnvVar(v)) {
      throw new Error("getConfig:normalizeEnvVar:validEnvVar error, " + v + " is not a valid env");
    }

    // pp & local will get the local hosts.
    // prodpp & prod will get the prod hosts.
    var e = [PP, LOCAL].includes(env) ? LOCAL : PROD;
    return e.toLowerCase();
  };
  var BuildEnv = normalizeEnvVar(env);
  return configs[BuildEnv];
};
var index_530eda38_esm_getConfigValueFromEnv = function getConfigValueFromEnv(key) {
  if (typeof GROWTH_API_CONFIG !== 'undefined') {
    var value = GROWTH_API_CONFIG[key];
    if (value) return value;
  }
  return hosts[key];
};

var index_530eda38_esm_endpoints = {
  appBannerUrlGuest: '/ext/web/pwa/send/token/DEEP_LINK',
  appBannerUrlLoggedIn: '/ext/web/pwa/send/token/LINK',
  pokusAssignVariant: '/experiment/assignVariant',
  userWidget: "/common/userwidget/?random=+" + Math.random(),
  // random to avoid browser cache
  recommendEarnUrl: "/recEarn/infl/details",
  skywalkerV1: '/empeiria/api/v1',
  dsdVoyager: '/api/v1/hotels_search/find_node_by_name',
  appContext: '/api/v2/utils/get_context/',
  recentSearchPush: '/fs/w',
  gdpr: '/ext/hcs/cmp/userconsents/get',
  userGdpr: '/ext/hcs/cmp/userconsents/save',
  userGeoLocation: '/locus/web/v2/graphQl',
  voyagerPagemake: '/pagemaker',
  argus: '/argus/pwa/login_details/save',
  configStore: '/get/configKey',
  getRecentSearch: '/empeiria/api/v1/recentSearchResponseByLob',
  loyaltyUserInfo: '/loyalty/userInfo',
  gocashBalance: '/gocash/v2/get_balance/',
  bookingSummary: '/tripsbackend/v2/bookingsummary',
  pokusImpressionAndHonour: '/measurement/impressionAndHonourConditions',
  pokusDynamicConfigs: '/measurement/getDynamicConfigs',
  amigoGetSyncUp: '/v1/say_thanks/get_privacy_data',
  amigoSetSyncUp: '/v1/say_thanks/post_privacy_data',
  amigoSetSyncUpStatus: '/api/v1/user/status/optin'
};



;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-configs/dist/growth-api-configs.esm.js



/** Will reverse proxy/mock all local & pp api via moxy */
var moxy = 'https://newprodpp.goibibo.com/moxy';
var growth_api_configs_esm_hosts = {
  goibibo: '//www.goibibo.com',
  pokus: moxy,
  recommendEarnUrl: moxy,
  skywalker: moxy,
  voyagerX: moxy,
  voyager: moxy,
  recentSearchPush: moxy,
  gdpr: moxy,
  appBannerUrl: moxy,
  userGeoLocation: moxy,
  configStore: '//configstore.goibibo.com',
  argus: moxy,
  loyaltyUserInfo: moxy,
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: moxy,
  amigoSyncUp: moxy
};

/**
 * Default index gives the client side api configs
 * eg:
 * import getConfig from '@growth/api-configs'
 */
var configs = {
  local: growth_api_configs_esm_hosts,
  prod: hosts
};
var getConfig = function getConfig(env) {
  var c = filterConfigForEnv(configs, env);
  return c;
};



// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 1 modules
var growth_auth_helpers_esm = __webpack_require__(7263);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-utils/dist/growth-auth-utils.esm.js
var growth_auth_utils_esm = __webpack_require__(8132);
;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-calls/dist/growth-api-calls.esm.js







var fetchAppOpenUrl = function fetchAppOpenUrl(opts) {
  var isLoggedIn = !!getAuthToken();
  var apiPayload = (opts == null ? void 0 : opts.apiPayload) || {};
  var vid = getVisitorIdBrowser();
  var payload = {
    /*
     * keep the timeout small for this api,
     */
    body: {
      type: '18',
      "deepLink": {
        "data": {
          "c": apiPayload == null ? void 0 : apiPayload.campaign,
          "pid": "mweb2app",
          "deep_link_value": apiPayload == null ? void 0 : apiPayload.tagid,
          "af_web_dp": "https://www.goibibo.com/",
          "af_android_url": "https://play.google.com/store/apps/details?id=com.goibibo",
          "af_ios_url": "https://apps.apple.com/in/app/goibibo-hotel-flight-train/id631927169",
          "deep_link_sub1": _extends({}, apiPayload == null ? void 0 : apiPayload.godata, {
            login_req: (apiPayload == null ? void 0 : apiPayload.loginReq) || false,
            "referral_flow": (apiPayload == null ? void 0 : apiPayload.referral_flow) || false,
            "traffic_source": (apiPayload == null ? void 0 : apiPayload.trafficSource) || undefined,
            "~campaign": apiPayload == null ? void 0 : apiPayload.campaign,
            web_vid: vid
          }),
          "brand_domain": "app.goibibo.com"
        }
      }
    },
    credentials: 'omit',
    headers: getEssentialHeader({
      platform: 'mweb'
    })
  };
  var appBannerHost = getConfigValueFromEnv('appBannerUrl');
  var appBannerEndpoint = isLoggedIn ? endpoints.appBannerUrlLoggedIn : endpoints.appBannerUrlGuest;
  return fetchRequest("" + appBannerHost + appBannerEndpoint, payload).post();
};

var fetchPokusAssignVariantData = function fetchPokusAssignVariantData(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob || 'COMMON';
  var _generatePokusAssignV = generatePokusAssignVariantBodyRequest({
      isMobile: pokusOptions.isMobile,
      lob: lobName,
      deviceId: deviceId,
      extraOptions: pokusOptions
    }),
    request = _generatePokusAssignV.request;
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {};
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusAssignVariant, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post().then(function (res) {
    var _res$perLobMap;
    return (_res$perLobMap = res.perLobMap) == null ? void 0 : _res$perLobMap[lobName].metadataValues;
  });
};

var fetchUserDetails = function fetchUserDetails(_ref) {
  var timeout = _ref.timeout;
  var host = getConfigValueFromEnv('goibibo');
  return fetchRequest("" + host + endpoints.userWidget, {
    timeout: timeout
  }).post();
};

var fetchRecommendEarnDetails = function fetchRecommendEarnDetails(details) {
  var recommendEarnUrl = getConfigValueFromEnv('recommendEarnUrl');
  var token = getAuthToken$1();
  var headers = {
    auth: token,
    os: details == null ? void 0 : details.flavour
  };
  return fetchRequest("" + recommendEarnUrl + endpoints.recommendEarnUrl, {
    headers: headers,
    body: {
      hotelId: details.hotelId,
      source: details.source
    },
    credentials: 'omit'
  }).post();
};

var fetchSkywalkerClientData = function fetchSkywalkerClientData(skywalkerOptions, extraHeaders) {
  if (extraHeaders === void 0) {
    extraHeaders = {};
  }
  var endpointPath = skywalkerOptions.endpointPath,
    extraReqBody = skywalkerOptions.extraReqBody;
  var request = generateSkywalkerBodyRequest({
    extraReqBody: extraReqBody
  });
  var skywalkerUrl = getConfigValueFromEnv('skywalker');
  var headers = {
    brand: 'gi',
    deviceid: String
  };
  if (isUserTokenPresent()) {
    headers.auth = getAuthToken$1();
  }
  var dvid = getVisitorIdBrowser();
  if (dvid) {
    headers.deviceid = dvid;
  }
  return fetchRequest("" + skywalkerUrl + endpoints.skywalkerV1 + endpointPath, {
    body: request,
    credentials: 'omit',
    query: 'language=eng&currency=inr&region=in&brand=GI',
    headers: _extends({}, headers, extraHeaders)
  }).post();
};

var fetchAutoSuggetDailyStealDeal = function fetchAutoSuggetDailyStealDeal(userLocation) {
  var dsdVoyagerUrl = getConfigValueFromEnv('voyagerX');
  var userSelectedLocation = userLocation.userVal;
  return fetchRequest("" + dsdVoyagerUrl + endpoints.dsdVoyager, {
    credentials: 'omit',
    query: "search_query=" + userSelectedLocation + "&limit=10&include_t=[\"voy.city\"]"
  }).post();
};

var fetchPushRecentSearch = function fetchPushRecentSearch(searchCollection) {
  var url = getConfigValueFromEnv('recentSearchPush');
  var token = getAuthToken$1();
  var deviceid = getVisitorIdBrowser();
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };
  if (token) headers['oauth-goibibo'] = token;
  if (deviceid) headers.deviceid = deviceid;
  return fetchRequest("" + url + endpoints.recentSearchPush, {
    headers: headers,
    body: JSON.stringify(searchCollection),
    credentials: 'omit',
    extraOptions: {
      keepalive: true
    }
  }).post();
};

var fetchAppContext = function fetchAppContext(link) {
  var url = getConfigValueFromEnv('voyager') || prod.voyager;
  var raw = "url=" + (link || '');
  return fetchRequest("" + url + endpoints.appContext, {
    body: raw,
    credentials: 'omit'
  }).post();
};

var fetchGdprData = function fetchGdprData() {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.gdpr, {
    headers: headers,
    body: {
      org: 'GI',
      consent_id: 1,
      profile_type: 0,
      show_meta: true
    },
    credentials: 'omit'
  }).post();
};

var pushUserGdprData = function pushUserGdprData(gdpConsents) {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.userGdpr, {
    headers: headers,
    body: {
      org: 'GI',
      author: 'USER',
      consents: [_extends({
        status_active: true
      }, gdpConsents)]
    },
    credentials: 'omit'
  }).post();
};

var fetchUserGeoLocation = function fetchUserGeoLocation(_ref) {
  _ref.timeout;
  var host = getConfigValueFromEnv('userGeoLocation');
  return fetchRequest("" + host + endpoints.userGeoLocation, {
    body: "{ locationHierarchy(lat:,lng:) { country { id name centre } state { id name centre } city { id name centre postal_code } area { id name primary_area centre postal_code } } }",
    headers: {
      'Api-key': 'GROWTH-MMTGROWTH-71815232081313207181523208'
    }
  }).post();
};

var fetchConfigStoreData = function fetchConfigStoreData(opts) {
  var fetchOpts = opts.fetchOpts;
  var headers = fetchOpts.headers,
    timeout = fetchOpts.timeout;
  var host = index_530eda38_esm_getConfigValueFromEnv('configStore');
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + host + index_530eda38_esm_endpoints.configStore, {
    headers: pokus_dynamic_config_19800874_esm_extends({
      authorization: 'Tect685j8xMpLJF'
    }, headers),
    body: {
      isAbKey: opts.isAbKey,
      lobList: opts.lobList,
      cfgKeyList: opts.cfgKeyList
      /**
       * below three options helps on more granular query on bacnkend
       * these keys are not part of v1(present) api. Keep it commented
       * */
      // status: string,
      // submodule: string,
      // pgname: string,
    },

    credentials: 'omit',
    timeout: timeout
  }).post();
};

var fetchArgusFingerPrinting = function fetchArgusFingerPrinting(_ref) {
  var asyToken = _ref.asyToken,
    additionalData = _ref.additionalData;
  var url = getConfigValueFromEnv('argus');
  var token = getAuthToken();
  var headers = {
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
  if (token) headers['oauth-goibibo'] = token;
  fetchRequest("" + url + endpoints.argus, {
    headers: _extends({
      Authorization: 'P0s6jZGIkwMrnS2',
      'X-Request-Tracker': generateVid()
    }, headers),
    credentials: 'omit',
    body: {
      asyToken: asyToken,
      additionalData: additionalData
    }
  }).post();
};

var fetchRecentSearch = function fetchRecentSearch(_ref) {
  var lob = _ref.lob,
    strategy = _ref.strategy;
  var url = getConfigValueFromEnv('skywalker');
  return fetchRequest("" + url + endpoints.getRecentSearch + "?lob=" + lob + "&strategy=" + strategy, {
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      user: {
        profile_type: 'PERSONAL',
        uuid: getUuidFromCookie(),
        device_id: getVisitorIdBrowser(),
        domain: {
          country: 'in',
          language: 'eng',
          currency: 'inr'
        }
      }
    })
  }).post();
};

var fetchLoyaltyUserInfo = function fetchLoyaltyUserInfo() {
  var token = getAuthToken$1();
  var headers = {
    "currency": "Rs",
    "language": "eng",
    "org": "GI",
    "Profile-Type": "PERSONAL",
    "region": "in",
    "Authorization": "7NP82fpV0TsA9JrK"
  };
  if (token) headers.Auth = token;
  var bodyData = {
    "lob": "ALL",
    "tier": true,
    "benefit": false,
    "programDetails": false,
    "cards": false,
    "programDetailsTierBenefit": false,
    "source": "PWA",
    "pageType": "PERSONALIZATION"
  };
  return fetchRequest("https://membership-service.goibibo.com/loyalty/userInfo", {
    headers: headers,
    body: bodyData,
    credentials: 'omit'
  }).post();
};

var fetchGoCashBalance = function fetchGoCashBalance() {
  var url = getConfigValueFromEnv('gocashBalance');
  var headers = {
    'oauth-goibibo': getAuthToken$1()
  };
  return fetchRequest("" + url + endpoints.gocashBalance, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

/** List of all bookings */
var fetchBookingSummary = function fetchBookingSummary() {
  var url = getConfigValueFromEnv('bookingSummary');
  var headers = {
    auth: getAuthToken$1()
  };
  return fetchRequest("" + url + endpoints.bookingSummary, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

var fetchPokusImpressionAndHonourDetails = function fetchPokusImpressionAndHonourDetails(opts) {
  var _ref = opts || {},
    analyticsNode = _ref.analyticsNode;
  var host = getConfigValueFromEnv('pokus');
  return fetchRequest("" + host + endpoints.pokusImpressionAndHonour, {
    body: {
      analyticsNode: analyticsNode
    },
    credentials: 'omit'
  }).post();
};

var fetchPokusDynamicConfigs = function fetchPokusDynamicConfigs(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob;
  var request = generatePokusDynamicConfigBodyRequest({
    isMobile: pokusOptions.isMobile,
    lob: lobName,
    deviceId: deviceId,
    extraOptions: pokusOptions
  });
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {
    region: 'IN',
    language: 'EN'
  };
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusDynamicConfigs, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post();
};

var fetchAmigoSyncUpContacts = function fetchAmigoSyncUpContacts(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken()
  };
  return fetchRequest("" + url + endpoints.amigoGetSyncUp, {
    headers: headers,
    credentials: 'omit',
    query: "bookingId=" + bookingId + "&Lob=" + lob + "&context=TYP"
  }).get();
};

var pushAmigoSyncUpChoice = function pushAmigoSyncUpChoice(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob,
    isConsentGiven = _ref.isConsentGiven,
    reasonId = _ref.reasonId,
    reason = _ref.reason;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken(),
    'Content-Type': 'application/json'
  };
  return fetchRequest("" + url + endpoints.amigoSetSyncUp, {
    headers: headers,
    credentials: 'omit',
    body: {
      bookingId: bookingId,
      Lob: lob,
      isConsentGiven: isConsentGiven,
      reasonId: reasonId,
      reason: reason
    }
  }).post();
};



;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/dist/xhr-c6cf95cd.esm.js


function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var formatConfigResp = function formatConfigResp(configKeys) {
  var lobsKey = Object.keys(configKeys);
  var configs = lobsKey.reduce == null ? void 0 : lobsKey.reduce(function (acc, l) {
    var _configKeys$l$reduce, _configKeys$l;
    acc[l] = (_configKeys$l$reduce = (_configKeys$l = configKeys[l]).reduce) == null ? void 0 : _configKeys$l$reduce.call(_configKeys$l, function (kk, k) {
      var cloneKK = Object(kk);
      cloneKK[k.cfgKey] = k.value;
      return cloneKK;
    }, {});
    return acc;
  }, {});
  return configs;
};
var getConfigStoreData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, fetchOpts, initData, lobList, keyList, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lobs = opts.lobs, keys = opts.keys, fetchOpts = opts.fetchOpts, initData = opts.initData;
          /**
           * Return the initData if present, this helps to use the data passed in
           * SSR and avoid the api calls on client again.
           * */
          if (!initData) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", Promise.resolve(initData));
        case 3:
          lobList = typeof lobs === 'string' ? [lobs] : lobs;
          keyList = typeof keys === 'string' ? [keys] : keys;
          _context.next = 7;
          return fetchConfigStoreData({
            lobList: lobList,
            cfgKeyList: keyList,
            fetchOpts: {
              timeout: fetchOpts.timeout
            }
          });
        case 7:
          data = _context.sent;
          return _context.abrupt("return", formatConfigResp(data == null ? void 0 : data.configKeys));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConfigStoreData(_x) {
    return _ref.apply(this, arguments);
  };
}();



// EXTERNAL MODULE: ../../node_modules/@growth/browser-storage/dist/growth-browser-storage.esm.js
var growth_browser_storage_esm = __webpack_require__(2927);
;// CONCATENATED MODULE: ../../node_modules/@growth/browser-storage/indexDB/dist/growth-browser-storage-indexDB.esm.js
function growth_browser_storage_indexDB_esm_regeneratorRuntime() {
  growth_browser_storage_indexDB_esm_regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function growth_browser_storage_indexDB_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/*
 https://dev.to/alexeagleson/how-to-use-indexeddb-to-store-data-for-your-web-application-in-the-browser-1o90#browsing-your-database
*/
var requestIndexDB = function requestIndexDB(name, ver) {
  if (!name || !ver) {
    throw new Error('name or ver argument is missing for requestIndexDB');
  }
  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  return new Promise(function (resolve, reject) {
    if (!indexedDB) {
      reject(new Error('IndexedDB could not be found in this browser.'));
    }
    var request = indexedDB.open(name, ver);
    resolve(request);
  });
};
var bootstrapDB = /*#__PURE__*/function () {
  var _ref = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee(opts) {
    var dbName, dbVer, objectName, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, keyPath = opts.keyPath;
          _context.prev = 1;
          _context.next = 4;
          return requestIndexDB(dbName, dbVer);
        case 4:
          request = _context.sent;
          request.onupgradeneeded = function () {
            var db = request.result;
            var store = db.createObjectStore(objectName, {
              keyPath: keyPath || 'id'
            });
            store.createIndex('expire', 'expire');
          };
          return _context.abrupt("return", request);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", Promise.reject(new Error()));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return function bootstrapDB(_x) {
    return _ref.apply(this, arguments);
  };
}();
var addNewObject = /*#__PURE__*/function () {
  var _ref2 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee2(opts) {
    var dbName, dbVer, objectName, data, expire, keyPath, id, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, data = opts.data, expire = opts.expire, keyPath = opts.keyPath, id = opts.id;
          _context2.next = 3;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName,
            keyPath: keyPath
          });
        case 3:
          request = _context2.sent;
          request.onsuccess = function () {
            var db = request.result;
            var transaction = db.transaction(objectName, 'readwrite');
            var store = transaction.objectStore(objectName);
            var expireTS;
            if (expire && typeof (expire == null ? void 0 : expire.getMonth) === 'function') {
              expireTS = new Date(expire).getTime(); // EPOC
            } else {
              var defaultExpMin = 15;
              expireTS = new Date(new Date().getTime() + defaultExpMin * 60000).getTime(); // EPOC
            }

            store.put({
              expire: expireTS,
              id: id,
              value: data
            });
            transaction.oncomplete = function () {
              db.close();
            };
          };
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function addNewObject(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var removeExpiredObjects = function removeExpiredObjects(_ref3) {
  var db = _ref3.db,
    objectName = _ref3.objectName;
  return new Promise(function (resolve, reject) {
    var transaction = db.transaction([objectName], 'readwrite');
    var objectStore = transaction.objectStore(objectName);
    var expirationIndex = objectStore.index('expire');
    var now = new Date().getTime();
    var request = expirationIndex.openCursor(IDBKeyRange.upperBound(now));
    var deletePromises = [];
    request.onsuccess = function (event) {
      var cursor = event.target.result;
      if (cursor) {
        var deleteRequest = objectStore["delete"](cursor.primaryKey);
        deletePromises.push(new Promise(function (resolveDelete, rejectDelete) {
          // console.log('deleting idb', cursor.primaryKey);
          deleteRequest.onsuccess = resolveDelete;
          deleteRequest.onerror = rejectDelete;
        }));
        cursor["continue"]();
      } else {
        // delete all
        Promise.all(deletePromises).then(function () {
          return resolve('deleted');
        })["catch"](reject);
      }
    };
    request.onerror = reject;
  });
};
var getAllObjects = /*#__PURE__*/function () {
  var _ref4 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee4(opts) {
    var dbName, dbVer, objectName, id, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, id = opts.id, keyPath = opts.keyPath;
          if (id) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", Promise.reject(Error("Argument id is missing for getAllObjects() call")));
        case 3:
          _context4.next = 5;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName,
            keyPath: keyPath
          });
        case 5:
          request = _context4.sent;
          return _context4.abrupt("return", new Promise(function (resolve, reject) {
            request.onsuccess = /*#__PURE__*/growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee3() {
              var db, transaction, store, records;
              return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    db = request.result; // let's delete all expired records
                    _context3.next = 3;
                    return removeExpiredObjects({
                      db: db,
                      objectName: objectName
                    });
                  case 3:
                    transaction = db.transaction(objectName, 'readonly');
                    store = transaction.objectStore(objectName); // get a record
                    records = store.getAll(id);
                    records.onsuccess = function () {
                      var _records$result;
                      resolve((_records$result = records.result) == null || (_records$result = _records$result[0]) == null ? void 0 : _records$result.value);
                    };
                    request.onerror = function () {
                      reject(records.result);
                    };
                    transaction.oncomplete = function () {
                      db.close();
                    };
                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
          }));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getAllObjects(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var deleteObject = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee5(opts) {
    var dbName, dbVer, objectName, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, keyPath = opts.keyPath;
          _context5.next = 3;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName
          });
        case 3:
          request = _context5.sent;
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            request.onsuccess = function () {
              var db = request.result;
              var transaction = db.transaction(objectName, 'readwrite');
              var store = transaction.objectStore(objectName);
              store["delete"](keyPath);
              transaction.oncomplete = function () {
                db.close();
                resolve('delete');
              };
              transaction.onerror = function (e) {
                db.close();
                reject(e);
              };
            };
          }));
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function deleteObject(_x4) {
    return _ref6.apply(this, arguments);
  };
}()));



;// CONCATENATED MODULE: ../../node_modules/@growth/browser-caching/dist/growth-browser-caching.esm.js



function growth_browser_caching_esm_regeneratorRuntime() {
  growth_browser_caching_esm_regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function growth_browser_caching_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var SESSION_STORE = 'sessionStorage';
var LOCAL_STORE = 'localStorage';
var INDEX_DB = 'indexDb';
var INDEX_DB_DETAILS = {
  objectName: 'with-cache',
  keyPath: 'id',
  dbName: 'grow-with-fetch-cache',
  dbVer: 1
};
var withBrowserStorageCaching = /*#__PURE__*/function () {
  var _ref = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee3(opts) {
    var key, asyncMethod, _opts$ttl, ttl, type, _opts$cacheResponseKe, cacheResponseKeys, ignoreCache, revalidate, getLocalStore, isLocalStore, getItem, setItem, cache, res, saveResp;
    return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          key = opts.key, asyncMethod = opts.asyncMethod, _opts$ttl = opts.ttl, ttl = _opts$ttl === void 0 ? 0 : _opts$ttl, type = opts.type, _opts$cacheResponseKe = opts.cacheResponseKeys, cacheResponseKeys = _opts$cacheResponseKe === void 0 ? [] : _opts$cacheResponseKe, ignoreCache = opts.ignoreCache, revalidate = opts.revalidate; // ignore the caching if ignoreCache is true
          if (!ignoreCache) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", asyncMethod());
        case 3:
          if (key) {
            _context3.next = 5;
            break;
          }
          throw new Error('withBrowserStorageCaching: For browser caching key name is mandatory');
        case 5:
          getLocalStore = function getLocalStore() {
            return type === SESSION_STORE ? growth_browser_storage_esm/* docSessionStorage */.F : growth_browser_storage_esm/* docLocalStorage */.U;
          };
          isLocalStore = function isLocalStore(_type) {
            return _type === LOCAL_STORE || _type === SESSION_STORE || _type === undefined;
          };
          getItem = /*#__PURE__*/function () {
            var _ref2 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee() {
              var store, value, dbName, dbVer, objectName, keyPath, record;
              return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!isLocalStore(opts.type)) {
                      _context.next = 4;
                      break;
                    }
                    store = getLocalStore();
                    value = store.getItem(key);
                    return _context.abrupt("return", value);
                  case 4:
                    if (!(opts.type === INDEX_DB)) {
                      _context.next = 10;
                      break;
                    }
                    dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                    _context.next = 8;
                    return getAllObjects({
                      dbName: dbName,
                      dbVer: dbVer,
                      objectName: objectName,
                      id: key,
                      keyPath: keyPath
                    });
                  case 8:
                    record = _context.sent;
                    return _context.abrupt("return", record);
                  case 10:
                    return _context.abrupt("return", undefined);
                  case 11:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function getItem() {
              return _ref2.apply(this, arguments);
            };
          }();
          setItem = /*#__PURE__*/function () {
            var _ref3 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee2(value) {
              var store, dbName, dbVer, objectName, keyPath, res;
              return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!isLocalStore(type)) {
                      _context2.next = 3;
                      break;
                    }
                    store = getLocalStore();
                    return _context2.abrupt("return", store.setItem(key, value, ttl));
                  case 3:
                    if (!(opts.type === INDEX_DB)) {
                      _context2.next = 9;
                      break;
                    }
                    dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                    _context2.next = 7;
                    return addNewObject({
                      dbName: dbName,
                      dbVer: dbVer,
                      objectName: objectName,
                      keyPath: keyPath,
                      id: key,
                      data: value
                    });
                  case 7:
                    res = _context2.sent;
                    return _context2.abrupt("return", res);
                  case 9:
                    return _context2.abrupt("return", undefined);
                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function setItem(_x2) {
              return _ref3.apply(this, arguments);
            };
          }(); // return from cache if exist and revalidate is not true
          _context3.next = 11;
          return getItem();
        case 11:
          cache = _context3.sent;
          if (!(cache && !revalidate)) {
            _context3.next = 14;
            break;
          }
          return _context3.abrupt("return", cache);
        case 14:
          if (!(typeof asyncMethod === 'function')) {
            _context3.next = 20;
            break;
          }
          _context3.next = 17;
          return asyncMethod();
        case 17:
          res = _context3.sent;
          // keep only few keys in cache instead of whole response.
          if (typeof res === 'object' && cacheResponseKeys.length) {
            saveResp = {};
            cacheResponseKeys.forEach(function (item) {
              saveResp[item] = res == null ? void 0 : res[item];
            });
            setItem(saveResp);
          } else {
            setItem(res);
          }
          return _context3.abrupt("return", res);
        case 20:
          throw new Error('withBrowserStorageCaching: the second parameter should be async method');
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function withBrowserStorageCaching(_x) {
    return _ref.apply(this, arguments);
  };
}();



;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js






function growth_config_store_browser_esm_extends() {
  growth_config_store_browser_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return growth_config_store_browser_esm_extends.apply(this, arguments);
}

var getConfigStoreDataClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, cacheOpts, fetchOpts, initData, cacheKey, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lobs = opts.lobs, keys = opts.keys, cacheOpts = opts.cacheOpts, fetchOpts = opts.fetchOpts, initData = opts.initData;
          cacheKey = function cacheKey() {
            // merge the lob and keys to make a cachekey
            var l = typeof lobs === 'string' ? [lobs] : lobs;
            var k = typeof keys === 'string' ? [keys] : keys;
            var ckey = l.join('-') + "-" + k.join('-');
            return ckey.toLowerCase();
          };
          _context.next = 4;
          return withBrowserStorageCaching({
            key: cacheKey(),
            asyncMethod: function asyncMethod() {
              return getConfigStoreData({
                lobs: lobs,
                keys: keys,
                fetchOpts: {
                  timeout: (fetchOpts == null ? void 0 : fetchOpts.timeout) || 2000
                },
                initData: initData
              });
            },
            ttl: (cacheOpts == null ? void 0 : cacheOpts.ttl) || 15 /* minutes */,
            ignoreCache: cacheOpts == null ? void 0 : cacheOpts.ignoreCache,
            revalidate: cacheOpts == null ? void 0 : cacheOpts.revalidate,
            type: 'indexDb'
          });
        case 4:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConfigStoreDataClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

var createConfigStore = function createConfigStore() {
  return (0,esm/* create */.Ue)()(function (set) {
    return growth_config_store_browser_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
      fetch: function fetch(opts) {
        return (0,growth_store_helpers_esm/* fetchSetter */.x)({
          set: set,
          fetchFun: function fetchFun() {
            return getConfigStoreDataClient({
              lobs: opts.lobs,
              keys: opts.keys,
              cacheOpts: opts == null ? void 0 : opts.cacheOpts,
              initData: opts == null ? void 0 : opts.initData
            });
          },
          onSuccess: opts == null ? void 0 : opts.onSuccess
        });
      }
    });
  });
};
var setData = function setData(store, value) {
  return store.setState(function (s) {
    return {
      data: growth_config_store_browser_esm_extends({}, s.data, value),
      loaded: true
    };
  });
};




/***/ }),

/***/ 2048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
/* unused harmony export keys */
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


/* eslint-disable no-useless-escape */

/**
 * This function well help to get, set, remove and itrate over
 * the cookies the cookies.
 * @methods
 *  getItem
 *  setItem
 *  removeItem
 *  hasItem
 *  keys
 */

var error = function error(x) {
  console.error(new TypeError("key is required for @growth/cookies " + x));
};

var getItem = function getItem(key) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return null;

  if (!key) {
    error('get');
    return null;
  }

  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" +
  /* eslint-disable-next-line no-useless-escape */
  encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + "\\s*\\=\\s*([^;]*).*$)|^.*$"), '$1')) || null;
};
/* eslint-disable-next-line max-params */


var setItem = function setItem(key, value, options) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return false;

  var _ref = options || {},
      expires = _ref.expires,
      path = _ref.path,
      domain = _ref.domain,
      secure = _ref.secure;

  if (!key) {
    error('set');
    return false;
  }

  var sMaxAge = expires ? "; max-age=" + expires : '';
  document.cookie = encodeURIComponent(key) + "=" + value + sMaxAge + (domain ? "; domain=" + domain : '') + (path ? "; path=" + path : '') + (secure ? '; secure' : '');
  return true;
};

var removeItem = function removeItem(key, path, domain) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return false;

  if (!getItem(key)) {
    error('remove');
    return false;
  }

  document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : '') + (path ? "; path=" + path : '');
  return true;
};

var keys = function keys() {
  if (!isOnClient) return [];
  var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);

  for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx += 1) {
    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
  }

  return aKeys;
};




/***/ }),

/***/ 3509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useHasMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * READ THIS! IF YOU ARE A REACT DEVELOPER YOU SHOULD
 *  https://joshwcomeau.com/react/the-perils-of-rehydration
 */

function useHasMounted() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      hasMounted = _useState[0],
      setHasMounted = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
}




/***/ }),

/***/ 7862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ow": function() { return /* binding */ epocToDate; },
  "Zz": function() { return /* binding */ isDateExpired; }
});

// UNUSED EXPORTS: addDays, dateToEPOC, daysInMonth, formatDate, formatDateString, formatDayString, getDateFormat, getTimeZone, getYearsAgoDate, getYearsAgoDateFromNow

;// CONCATENATED MODULE: ../../node_modules/fecha/lib/fecha.js
var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigitsOptional = "\\d\\d?";
var twoDigits = "\\d\\d";
var threeDigits = "\\d{3}";
var fourDigits = "\\d{4}";
var word = "[^\\s]+";
var literal = /\[([^]*?)\]/gm;
function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
}
var monthUpdate = function (arrName) { return function (v, i18n) {
    var lowerCaseArr = i18n[arrName].map(function (v) { return v.toLowerCase(); });
    var index = lowerCaseArr.indexOf(v.toLowerCase());
    if (index > -1) {
        return index;
    }
    return null;
}; };
function fecha_assign(origObj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var obj = args_1[_a];
        for (var key in obj) {
            // @ts-ignore ex
            origObj[key] = obj[key];
        }
    }
    return origObj;
}
var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
var defaultI18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ["am", "pm"],
    DoFn: function (dayOfMonth) {
        return (dayOfMonth +
            ["th", "st", "nd", "rd"][dayOfMonth % 10 > 3
                ? 0
                : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10]);
    }
};
var globalI18n = fecha_assign({}, defaultI18n);
var setGlobalDateI18n = function (i18n) {
    return (globalI18n = fecha_assign(globalI18n, i18n));
};
var regexEscape = function (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
};
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    val = String(val);
    while (val.length < len) {
        val = "0" + val;
    }
    return val;
};
var formatFlags = {
    D: function (dateObj) { return String(dateObj.getDate()); },
    DD: function (dateObj) { return pad(dateObj.getDate()); },
    Do: function (dateObj, i18n) {
        return i18n.DoFn(dateObj.getDate());
    },
    d: function (dateObj) { return String(dateObj.getDay()); },
    dd: function (dateObj) { return pad(dateObj.getDay()); },
    ddd: function (dateObj, i18n) {
        return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function (dateObj, i18n) {
        return i18n.dayNames[dateObj.getDay()];
    },
    M: function (dateObj) { return String(dateObj.getMonth() + 1); },
    MM: function (dateObj) { return pad(dateObj.getMonth() + 1); },
    MMM: function (dateObj, i18n) {
        return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function (dateObj, i18n) {
        return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function (dateObj) {
        return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    YYYY: function (dateObj) { return pad(dateObj.getFullYear(), 4); },
    h: function (dateObj) { return String(dateObj.getHours() % 12 || 12); },
    hh: function (dateObj) { return pad(dateObj.getHours() % 12 || 12); },
    H: function (dateObj) { return String(dateObj.getHours()); },
    HH: function (dateObj) { return pad(dateObj.getHours()); },
    m: function (dateObj) { return String(dateObj.getMinutes()); },
    mm: function (dateObj) { return pad(dateObj.getMinutes()); },
    s: function (dateObj) { return String(dateObj.getSeconds()); },
    ss: function (dateObj) { return pad(dateObj.getSeconds()); },
    S: function (dateObj) {
        return String(Math.round(dateObj.getMilliseconds() / 100));
    },
    SS: function (dateObj) {
        return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function (dateObj) { return pad(dateObj.getMilliseconds(), 3); },
    a: function (dateObj, i18n) {
        return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function (dateObj, i18n) {
        return dateObj.getHours() < 12
            ? i18n.amPm[0].toUpperCase()
            : i18n.amPm[1].toUpperCase();
    },
    ZZ: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4));
    },
    Z: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60), 2) +
            ":" +
            pad(Math.abs(offset) % 60, 2));
    }
};
var monthParse = function (v) { return +v - 1; };
var emptyDigits = [null, twoDigitsOptional];
var emptyWord = [null, word];
var amPm = [
    "isPm",
    word,
    function (v, i18n) {
        var val = v.toLowerCase();
        if (val === i18n.amPm[0]) {
            return 0;
        }
        else if (val === i18n.amPm[1]) {
            return 1;
        }
        return null;
    }
];
var timezoneOffset = [
    "timezoneOffset",
    "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?",
    function (v) {
        var parts = (v + "").match(/([+-]|\d\d)/gi);
        if (parts) {
            var minutes = +parts[1] * 60 + parseInt(parts[2], 10);
            return parts[0] === "+" ? minutes : -minutes;
        }
        return 0;
    }
];
var parseFlags = {
    D: ["day", twoDigitsOptional],
    DD: ["day", twoDigits],
    Do: ["day", twoDigitsOptional + word, function (v) { return parseInt(v, 10); }],
    M: ["month", twoDigitsOptional, monthParse],
    MM: ["month", twoDigits, monthParse],
    YY: [
        "year",
        twoDigits,
        function (v) {
            var now = new Date();
            var cent = +("" + now.getFullYear()).substr(0, 2);
            return +("" + (+v > 68 ? cent - 1 : cent) + v);
        }
    ],
    h: ["hour", twoDigitsOptional, undefined, "isPm"],
    hh: ["hour", twoDigits, undefined, "isPm"],
    H: ["hour", twoDigitsOptional],
    HH: ["hour", twoDigits],
    m: ["minute", twoDigitsOptional],
    mm: ["minute", twoDigits],
    s: ["second", twoDigitsOptional],
    ss: ["second", twoDigits],
    YYYY: ["year", fourDigits],
    S: ["millisecond", "\\d", function (v) { return +v * 100; }],
    SS: ["millisecond", twoDigits, function (v) { return +v * 10; }],
    SSS: ["millisecond", threeDigits],
    d: emptyDigits,
    dd: emptyDigits,
    ddd: emptyWord,
    dddd: emptyWord,
    MMM: ["month", word, monthUpdate("monthNamesShort")],
    MMMM: ["month", word, monthUpdate("monthNames")],
    a: amPm,
    A: amPm,
    ZZ: timezoneOffset,
    Z: timezoneOffset
};
// Some common format strings
var globalMasks = {
    default: "ddd MMM DD YYYY HH:mm:ss",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YYYY",
    longDate: "MMMM D, YYYY",
    fullDate: "dddd, MMMM D, YYYY",
    isoDate: "YYYY-MM-DD",
    isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
    shortTime: "HH:mm",
    mediumTime: "HH:mm:ss",
    longTime: "HH:mm:ss.SSS"
};
var setGlobalDateMasks = function (masks) { return fecha_assign(globalMasks, masks); };
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 * @returns {string} Formatted date string
 */
var fecha_format = function (dateObj, mask, i18n) {
    if (mask === void 0) { mask = globalMasks["default"]; }
    if (i18n === void 0) { i18n = {}; }
    if (typeof dateObj === "number") {
        dateObj = new Date(dateObj);
    }
    if (Object.prototype.toString.call(dateObj) !== "[object Date]" ||
        isNaN(dateObj.getTime())) {
        throw new Error("Invalid Date pass to format");
    }
    mask = globalMasks[mask] || mask;
    var literals = [];
    // Make literals inactive by replacing them with @@@
    mask = mask.replace(literal, function ($0, $1) {
        literals.push($1);
        return "@@@";
    });
    var combinedI18nSettings = fecha_assign(fecha_assign({}, globalI18n), i18n);
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
        return formatFlags[$0](dateObj, combinedI18nSettings);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () { return literals.shift(); });
};
/**
 * Parse a date string into a Javascript Date object /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @param {i18n} I18nSettingsOptional Full or subset of I18N settings
 * @returns {Date|null} Returns Date object. Returns null what date string is invalid or doesn't match format
 */
function parse(dateStr, format, i18n) {
    if (i18n === void 0) { i18n = {}; }
    if (typeof format !== "string") {
        throw new Error("Invalid format in fecha parse");
    }
    // Check to see if the format is actually a mask
    format = globalMasks[format] || format;
    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
        return null;
    }
    // Default to the beginning of the year.
    var today = new Date();
    var dateInfo = {
        year: today.getFullYear(),
        month: 0,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        isPm: null,
        timezoneOffset: null
    };
    var parseInfo = [];
    var literals = [];
    // Replace all the literals with @@@. Hopefully a string that won't exist in the format
    var newFormat = format.replace(literal, function ($0, $1) {
        literals.push(regexEscape($1));
        return "@@@";
    });
    var specifiedFields = {};
    var requiredFields = {};
    // Change every token that we find into the correct regex
    newFormat = regexEscape(newFormat).replace(token, function ($0) {
        var info = parseFlags[$0];
        var field = info[0], regex = info[1], requiredField = info[3];
        // Check if the person has specified the same field twice. This will lead to confusing results.
        if (specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " specified twice in format");
        }
        specifiedFields[field] = true;
        // Check if there are any required fields. For instance, 12 hour time requires AM/PM specified
        if (requiredField) {
            requiredFields[requiredField] = true;
        }
        parseInfo.push(info);
        return "(" + regex + ")";
    });
    // Check all the required fields are present
    Object.keys(requiredFields).forEach(function (field) {
        if (!specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " is required in specified format");
        }
    });
    // Add back all the literals after
    newFormat = newFormat.replace(/@@@/g, function () { return literals.shift(); });
    // Check if the date string matches the format. If it doesn't return null
    var matches = dateStr.match(new RegExp(newFormat, "i"));
    if (!matches) {
        return null;
    }
    var combinedI18nSettings = fecha_assign(fecha_assign({}, globalI18n), i18n);
    // For each match, call the parser function for that date part
    for (var i = 1; i < matches.length; i++) {
        var _a = parseInfo[i - 1], field = _a[0], parser = _a[2];
        var value = parser
            ? parser(matches[i], combinedI18nSettings)
            : +matches[i];
        // If the parser can't make sense of the value, return null
        if (value == null) {
            return null;
        }
        dateInfo[field] = value;
    }
    if (dateInfo.isPm === 1 && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
    }
    else if (dateInfo.isPm === 0 && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
    }
    var dateTZ;
    if (dateInfo.timezoneOffset == null) {
        dateTZ = new Date(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute, dateInfo.second, dateInfo.millisecond);
        var validateFields = [
            ["month", "getMonth"],
            ["day", "getDate"],
            ["hour", "getHours"],
            ["minute", "getMinutes"],
            ["second", "getSeconds"]
        ];
        for (var i = 0, len = validateFields.length; i < len; i++) {
            // Check to make sure the date field is within the allowed range. Javascript dates allows values
            // outside the allowed range. If the values don't match the value was invalid
            if (specifiedFields[validateFields[i][0]] &&
                dateInfo[validateFields[i][0]] !== dateTZ[validateFields[i][1]]()) {
                return null;
            }
        }
    }
    else {
        dateTZ = new Date(Date.UTC(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute - dateInfo.timezoneOffset, dateInfo.second, dateInfo.millisecond));
        // We can't validate dates in another timezone unfortunately. Do a basic check instead
        if (dateInfo.month > 11 ||
            dateInfo.month < 0 ||
            dateInfo.day > 31 ||
            dateInfo.day < 1 ||
            dateInfo.hour > 23 ||
            dateInfo.hour < 0 ||
            dateInfo.minute > 59 ||
            dateInfo.minute < 0 ||
            dateInfo.second > 59 ||
            dateInfo.second < 0) {
            return null;
        }
    }
    // Don't allow invalid dates
    return dateTZ;
}
var fecha = {
    format: fecha_format,
    parse: parse,
    defaultI18n: defaultI18n,
    setGlobalDateI18n: setGlobalDateI18n,
    setGlobalDateMasks: setGlobalDateMasks
};

/* harmony default export */ var lib_fecha = ((/* unused pure expression or super */ null && (fecha)));

//# sourceMappingURL=fecha.js.map

;// CONCATENATED MODULE: ../../node_modules/@growth/date-utils/dist/growth-date-utils.esm.js


var getDateFormat = function getDateFormat(opts) {
  var date = opts.date,
      f = opts.format,
      _opts$seperator = opts.seperator,
      seperator = _opts$seperator === void 0 ? '/' : _opts$seperator;
  var currentDate = new Date();

  if (date && !Number.isNaN(new Date(date).getTime())) {
    currentDate = new Date(date);
  }

  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();

  switch (f) {
    case 'dd mm yyyy':
      return day + seperator + month + seperator + year;

    case 'mm dd yyyy':
      return month + seperator + day + seperator + year;

    case 'YYYY mm dd':
      return year + seperator + month + seperator + day;

    default:
      return year + seperator + month + seperator + day;
  }
};

var dateToEPOC = function dateToEPOC(date) {
  var epoc = new Date(date).valueOf();
  return epoc; // unix timestamp
};

var epocToDate = function epocToDate(epoc) {
  var d = getDateFormat({
    date: epoc
  });
  return d;
};

var getYearsAgoDateFromNow = function getYearsAgoDateFromNow(age) {
  if (age === void 0) {
    age = 0;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  return new Date(year + "/" + month + "/" + day);
};

var getYearsAgoDate = function getYearsAgoDate(age, month, day) {
  if (age === void 0) {
    age = 0;
  }

  if (month === void 0) {
    month = 0;
  }

  if (day === void 0) {
    day = 1;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var newMonth = month + 1 < 10 ? "0" + (month + 1) : month + 1;
  var newDay = day < 10 ? "0" + day : day;
  return new Date(year + "/" + newMonth + "/" + newDay);
};

var isDateExpired = function isDateExpired(_ref) {
  var now = _ref.now,
      expire = _ref.expire;
  return now > expire;
};

var formatDate = function formatDate(date, formatStr) {
  if (formatStr === void 0) {
    formatStr = "D MMM'YY dddd";
  }

  return format(date, formatStr);
};

var formatDateString = function formatDateString(date) {
  return date && formatDate(date).split(' ').slice(0, 2).join(' ');
};

var formatDayString = function formatDayString(date) {
  return date && formatDate(date).split(' ').slice(2).join('');
};

var addDays = function addDays(date, days) {
  var currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate;
};

var daysInMonth = function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};

var getTimeZone = function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};




/***/ }),

/***/ 3767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ headingSizes; },
/* harmony export */   "iH": function() { return /* binding */ textSizes; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports Box, Heading, breakPoints, buildTheme, colors, defaultTheme, font, misc, spacing, useTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/
// Type - Family and Weight
var fwRegular = '400';
var fwMedium = '500';
var fwSemiBold = '600';
var fwBold = '700';
var fs32 = '32px';
var fs24 = '24px';
var fs22 = '22px';
var fs18 = '18px';
var fs16 = '16px';
var fs14 = '14px';
var fs12 = '12px';
var lhAuto = 'normal'; //  Lable

var textSizes = {
  LargeW1: {
    'font-weight': fwRegular,
    'font-size': fs18,
    'line-height': lhAuto
  },
  LargeW2: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwMedium
  },
  LargeW3: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwRegular
  },
  MediumW2: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwMedium
  },
  MediumW3: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  },
  BaseW1: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwRegular
  },
  BaseW2: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwMedium
  },
  BaseW3: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwSemiBold
  },
  SmallW1: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwRegular
  },
  SmallW2: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwMedium
  },
  SmallW3: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwSemiBold
  }
}; //  Lable

var headingSizes = {
  xLarge: {
    'font-weight': fwBold,
    'font-size': fs32,
    'line-height': lhAuto
  },
  Large: {
    'line-height': lhAuto,
    'font-size': fs24,
    'font-weight': fwBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs22,
    'font-weight': fwSemiBold
  },
  Small: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  Base: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  }
};

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: {
    label: _extends({}, textSizes),
    heading: _extends({}, headingSizes)
  }
};

var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }

  return _extends({}, fontThemeProperties);
};

// https://www.figma.com/file/pZZHuwNbapoBxoxGJFSyZJ/GI-Foundations?type=design&node-id=25-2&t=pZslRhH1ZwNtrFHa-0
var spacing$1 = {
  '0': 0,
  '2': '2px',
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '20': '20px',
  '24': '24px',
  '28': '28px',
  '32': '32px',
  '40': '40px',
  '48': '48px',
  '56': '56px',
  '64': '64px'
};

var buildSpacing = function buildSpacing() {
  return spacing$1;
};

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px

  }
};
function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }

  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem
      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px

    },
    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}
/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */

var defaultTheme = buildTheme();
/**
 * to check if theme exists on caller, else return defaultTheme
 */

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}

var Box = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div(function (_ref) {
  var _ref$mr = _ref.mr,
      mr = _ref$mr === void 0 ? '' : _ref$mr,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? '' : _ref$mt,
      _ref$ml = _ref.ml,
      ml = _ref$ml === void 0 ? '' : _ref$ml,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? '' : _ref$mb,
      _ref$my = _ref.my,
      my = _ref$my === void 0 ? '' : _ref$my,
      _ref$mx = _ref.mx,
      mx = _ref$mx === void 0 ? '' : _ref$mx,
      _ref$pt = _ref.pt,
      pt = _ref$pt === void 0 ? '' : _ref$pt,
      _ref$pr = _ref.pr,
      pr = _ref$pr === void 0 ? '' : _ref$pr,
      _ref$pb = _ref.pb,
      pb = _ref$pb === void 0 ? '' : _ref$pb,
      _ref$pl = _ref.pl,
      pl = _ref$pl === void 0 ? '' : _ref$pl,
      _ref$py = _ref.py,
      py = _ref$py === void 0 ? '' : _ref$py,
      _ref$px = _ref.px,
      px = _ref$px === void 0 ? '' : _ref$px;
  return "\n\tmargin-right: " + (spacing$1[mr || mx] || '') + ";\n\tmargin-left: " + (spacing$1[ml || mx] || '') + ";\n\tmargin-top: " + (spacing$1[mt || my] || '') + ";\n\tmargin-bottom: " + (spacing$1[mb || my] || '') + ";\n\tpadding-right: " + (spacing$1[pr || px] || '') + ";\n\tpadding-left: " + (spacing$1[pl || px] || '') + ";\n\tpadding-top: " + (spacing$1[pt || py] || '') + ";\n\tpadding-bottom: " + (spacing$1[pb || py] || '') + ";\n";
});

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$1;
var Text = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].p(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return textSizes[size || 'BaseW1'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});

var _templateObject;
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].h2(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return headingSizes[size || 'Large'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});




/***/ }),

/***/ 3377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DomEventEmitter; }
/* harmony export */ });
var DomEventEmitter = function () {
  return {
    on: function on(eventName, listener) {
      return document.addEventListener(eventName, listener);
    },
    off: function off(eventName, listener) {
      return document.removeEventListener(eventName, listener);
    },
    emit: function emit(eventName, opts) {
      var event = new CustomEvent(eventName, {
        detail: opts,
        cancelable: true
      });
      return document.dispatchEvent(event);
    }
  };
}();




/***/ }),

/***/ 6963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ fetchRequest; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function assertPath(path) {
  var type = typeof path;

  if (type !== 'string') {
    throw new TypeError("The path should be a string, instead received a " + type);
  }
}

var parseResponse = function parseResponse(res) {
  // If a body response exists, parse anx extract the possible properties
  var response = res.json();

  try {
    if (res.status >= 200 && res.status < 300) {
      return Promise.resolve(response);
    }

    if (res.status >= 400 && res.status < 599) {
      return response.then(function (data) {
        var errorResponse = {
          response: data,
          status: res.status,
          statusText: res.statusText
        };
        return Promise.reject(errorResponse);
      });
    }
  } catch (_unused) {
    return response.then(function (data) {
      var errorResponse = {
        response: data,
        status: res.status,
        statusText: res.statusText
      };
      return Promise.reject(errorResponse);
    });
  }

  return Promise.resolve(response);
  /* Add any custom logic related to how you want to handle the response
   *
   * In case success is false,
   * trigger a new expection to capture later on request call site
   */
  // throw new Error(JSON.stringify({response,status:res.status,statusText: res.statusText}));
  // Otherwise, simply resolve the received data
};

var fetchRequest = function fetchRequest(path, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$headers = _options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      _options$query = _options.query,
      query = _options$query === void 0 ? null : _options$query,
      _options$method = _options.method,
      method = _options$method === void 0 ? 'GET' : _options$method,
      _options$timeout = _options.timeout,
      timeout = _options$timeout === void 0 ? null : _options$timeout,
      _options$credentials = _options.credentials,
      credentials = _options$credentials === void 0 ? 'include' : _options$credentials,
      _options$extraOptions = _options.extraOptions,
      extraOptions = _options$extraOptions === void 0 ? {} : _options$extraOptions;
  var _options2 = options,
      body = _options2.body;
  assertPath(path);

  if (body && typeof body === 'object' && !(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers['content-type'] = 'application/json';
  }

  var genericHeaders = {};

  var reqOptions = _extends({
    method: method,
    headers: _extends({}, genericHeaders, headers),
    credentials: credentials
  }, extraOptions, {
    body: body
  });

  var queryString = '';

  if (query) {
    // Convert to encoded string and prepend with ?
    queryString = new URLSearchParams(query).toString();
    queryString = queryString && "?" + queryString;
  }

  var controller;
  var requestTimeout;

  if (timeout) {
    controller = new AbortController();
    requestTimeout = setTimeout(function () {
      return controller.abort();
    }, timeout);
  }

  function makeFetchRequest(requestMethod) {
    var config = _extends({}, reqOptions, {
      method: requestMethod
    });

    if (timeout && controller) {
      config.signal = controller.signal;
    }

    return fetch("" + path + queryString, config).then(function (res) {
      if (timeout && requestTimeout) {
        clearTimeout(requestTimeout);
      }

      return parseResponse(res);
    });
  }

  return {
    get: function get() {
      return makeFetchRequest('GET');
    },
    post: function post() {
      return makeFetchRequest('POST');
    },
    "delete": function _delete() {
      return makeFetchRequest('DELETE');
    }
  };
};




/***/ }),

/***/ 3858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CONFIG_KEY_DWEB_AUTH": function() { return /* binding */ CONFIG_KEY_DWEB_AUTH; },
  "default": function() { return /* binding */ Container; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(2390);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../node_modules/@growth/app-theme/dist/growth-app-theme.esm.js
var growth_app_theme_esm = __webpack_require__(1225);
// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(2019);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js
var growth_analytics_plugin_adobe_esm = __webpack_require__(6401);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(2532);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 1 modules
var growth_auth_helpers_esm = __webpack_require__(7263);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(3377);
// EXTERNAL MODULE: ../../node_modules/@growth/pdt-push/dist/growth-pdt-push.esm.js
var growth_pdt_push_esm = __webpack_require__(3488);
// EXTERNAL MODULE: ../../node_modules/@growth/design-system/dist/growth-design-system.esm.js
var growth_design_system_esm = __webpack_require__(3767);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/react-otp-input/lib/index.js
var lib = __webpack_require__(4607);
// EXTERNAL MODULE: ../../node_modules/@growth/loader/dist/growth-loader.esm.js + 1 modules
var growth_loader_esm = __webpack_require__(305);
// EXTERNAL MODULE: ../../node_modules/@growth/tooltip/dist/growth-tooltip.esm.js
var growth_tooltip_esm = __webpack_require__(7792);
// EXTERNAL MODULE: ../../node_modules/@growth/date-utils/dist/growth-date-utils.esm.js + 1 modules
var growth_date_utils_esm = __webpack_require__(7862);
// EXTERNAL MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 7 modules
var growth_config_store_browser_esm = __webpack_require__(4162);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/@growth/toast/dist/growth-toast.esm.js





function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2;
var ToastWrapper = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: fixed;\n\tleft: 50%;\n\tbottom: 70px;\n\tbackground-color: #2a2d31;\n\tcolor: #fff;\n\tmax-height: 80px;\n\ttext-align: center;\n\toverflow: auto;\n\tborder-radius: 8px;\n\ttransform: translateX(-50%);\n\tpadding: 10px 12px;\n\tanimation: slideUp 0.3s ease-in-out forwards;\n\tbox-shadow: 0px 4px 4px rgb(0 0 0 / 9%);\n\tz-index: 1040;\n\n\t@keyframes slideUp {\n\t\tfrom {\n\t\t\tbottom: -100px;\n\t\t\topacity: 0;\n\t\t}\n\n\t\tto {\n\t\t\tbottom: 80px;\n\t\t\topacity: 1;\n\t\t}\n\t}\n"])));
var ToastMessage = styled_components_browser_esm["default"].p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #fff;\n\ttext-align: center;\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);

var Toast = function Toast(props) {
  var message = props.message,
      onClose = props.onClose,
      _props$style = props.style,
      style = _props$style === void 0 ? null : _props$style,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? 2500 : _props$autoHideDurati,
      close = props.close,
      children = props.children;
  (0,react.useEffect)(function () {
    var closeTimmer = setTimeout(function () {
      if (close) close(false);
      if (onClose) onClose();
    }, autoHideDuration);
    return function () {
      if (closeTimmer) clearTimeout(closeTimmer);
    };
  }, [autoHideDuration, close, onClose]);
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/react.createElement(ToastWrapper, {
    style: style
  }, /*#__PURE__*/(0,react.isValidElement)(children) ? children : /*#__PURE__*/react.createElement(ToastMessage, null, message)), document.body);
};

Toast.defaultProps = {
  autoHideDuration: 2500,
  onClose: function onClose() {},
  children: undefined,
  style: undefined
};

var useToast = function useToast() {
  var _useState = useState({}),
      toastData = _useState[0],
      setShowToast = _useState[1];

  var closeToast = function closeToast() {
    setShowToast({
      show: false,
      message: '',
      close: closeToast
    });
  };

  var showToast = function showToast(_ref) {
    var message = _ref.message,
        autoHideDuration = _ref.autoHideDuration;
    setShowToast({
      show: true,
      message: message,
      autoHideDuration: autoHideDuration,
      close: closeToast
    });
  };

  var ToastComponent = function ToastComponent() {
    var _toastData$message = toastData.message,
        message = _toastData$message === void 0 ? '' : _toastData$message,
        show = toastData.show,
        autoHideDuration = toastData.autoHideDuration,
        close = toastData.close;
    return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(Toast, {
      message: message,
      autoHideDuration: autoHideDuration,
      close: close
    }));
  };

  return {
    ToastComponent: ToastComponent,
    showToast: showToast
  };
};



;// CONCATENATED MODULE: ../../node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js



















function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var initOmnitureAnalytics = function initOmnitureAnalytics(_ref) {
  var _window$adobeDataLaye, _window$adobeDataLaye2;
  var adobeInstance = _ref.adobeInstance,
    lobName = _ref.lobName,
    debug = _ref.debug;
  var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null || _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
  var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null || _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
  adobeInstance.initialize({
    plugin: (0,growth_analytics_plugin_adobe_esm/* default */.Z)({
      page: {
        pageInfo: _extends({}, pageInfo, {
          lob: lobName
        })
      },
      account: {
        accountInfo: _extends({}, accountInfo, {
          website: 'goibibo'
        })
      }
    }, debug || false),
    debug: debug || false
  });
};

var initAnalytics = function initAnalytics(_ref) {
  var lobName = _ref.lobName,
    debug = _ref.debug;
  var adobeInstance = new growth_web_analytics_esm/* default */.Z();
  initOmnitureAnalytics({
    adobeInstance: adobeInstance,
    lobName: lobName,
    debug: debug
  });
  return {
    adobeInstance: adobeInstance
  };
};

function growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject$a;
var AuthContainer$1 = styled_components_browser_esm["default"].div(_templateObject$a || (_templateObject$a = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"])));

var _templateObject$9, _templateObject2$7;
var AuthVerificationFlowSection = styled_components_browser_esm["default"].div(_templateObject$9 || (_templateObject$9 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 400px;\n    height: ", ";\n    border-radius: 12px;\n    overflow: hidden;\n    flex-shrink: 0;\n    box-shadow: -5px 0 9px 0 rgba(0, 0, 0, 0.2);\n    background-color: #fff;\n    padding: 50px 50px 30px 50px;\n  position: relative;\n"])), function (props) {
  return props != null && props.height ? props.height : '456px';
});
var AuthVerificationFlowCloseIcon = styled_components_browser_esm["default"].span(_templateObject2$7 || (_templateObject2$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n"])));

var _templateObject$8, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3, _templateObject7$1;
var MobileContainer = styled_components_browser_esm["default"].div(_templateObject$8 || (_templateObject$8 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100%;\n\tposition: relative;\n"])));
var MobileHeading = styled_components_browser_esm["default"].h3(_templateObject2$6 || (_templateObject2$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1);
var MobileInputWrapper = styled_components_browser_esm["default"].div(_templateObject3$5 || (_templateObject3$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 56px;\n\tborder-radius: 4px;\n\tborder: solid 2px #016eff;\n\tposition: relative;\n\tdisplay: flex;\n\t", "\n\t.loginCont__input {\n\t\tbackground: #fff;\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\t", "\n\t\tcolor: #4f525a;\n\t\tpadding-left: 5px;\n\t\tborder-radius: 0 4px 4px 0;\n\t}\n\n\t.loginCont__code {\n\t\tbackground: #fff;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #c2c2c2;\n\t\tdisplay: inline-flex;\n\t\tpadding: 0 5px 0 20px;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t}\n\n\t.loginCont__label {\n\t\tdisplay: inline-flex;\n\t\tposition: absolute;\n\t\tleft: 11px;\n\t\ttop: -11px;\n\t\tbackground-color: #fff;\n\t\tpadding: 3px 8px;\n\t\t", "\n\t\tcolor: #016eff;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\tline-height: 20px !important;\n\t\topacity: 1;\n\t\tfont-weight: 600 !important;\n\t}\n"])), function (props) {
  if (props.error) {
    return "\n    border-color: rgb(229, 52, 66);\n    .loginCont__label{\n    \tcolor: rgb(229, 52, 66) !important;\n    }\n   \n    ";
  }
  if (props.valid) {
    return "\n    border-color: #00962d;\n    .loginCont__label{\n    \tcolor: #00962d !important;\n    }\n   \n    ";
  }
  return null;
}, growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var LoginSubmitButton = styled_components_browser_esm["default"].button(_templateObject4$5 || (_templateObject4$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 13px 118px 13px 116px;\n\tmargin-top: 22px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", "\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var LoginTermsAndCondition = styled_components_browser_esm["default"].p(_templateObject5$4 || (_templateObject5$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var InputMessageIcon = styled_components_browser_esm["default"].span(_templateObject6$3 || (_templateObject6$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tright: 20px;\n\ttop: 17px;\n"])));
var MessageText = styled_components_browser_esm["default"].p(_templateObject7$1 || (_templateObject7$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\n\t", "\n"])), function (props) {
  if (props.error) {
    return "color: rgb(229, 52, 66);\n\t\t\t margin-top: 10px;\n\t\t\t";
  }
  if (props.success) {
    return "\n            color: #00962d;\n            \n             margin-top: 10px;\n            ";
  }
  if (props.loading) {
    return "\n\t\t\t margin-top: 10px;\n\t\t\t ";
  }
  return '';
});

var LOGIN_WITH_MOBILE = {
  heading: 'Login/Signup',
  subHeading: '',
  submitButton: 'Continue',
  label: 'Enter your Mobile Number',
  termsPolicy: 'By proceeding, you agree to GoIbibo’s <a href="https://www.goibibo.com/info/privacy/" target="_blank">Privacy Policy</a>, <a href="https://www.goibibo.com/info/user-agreement/" target="_blank">User Agreement</a> and <a href="https://www.goibibo.com/info/terms-of-services/" target="_blank">Terms of Service</a>'
};

var InputWrapper = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    _ref$inputName = _ref.inputName,
    inputName = _ref$inputName === void 0 ? 'text' : _ref$inputName,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    maxlength = _ref.maxlength,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
    inputPrefix = _ref.inputPrefix,
    onChange = _ref.onChange,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    inputClassName = _ref.inputClassName,
    placeholder = _ref.placeholder,
    inputVal = _ref.inputVal,
    _ref$inputDisabled = _ref.inputDisabled,
    inputDisabled = _ref$inputDisabled === void 0 ? false : _ref$inputDisabled,
    onInputClick = _ref.onInputClick;
  var onChangeHandler = function onChangeHandler(e) {
    if (onChange) onChange(e);
  };
  return /*#__PURE__*/react.createElement(MobileInputWrapper, {
    error: isError,
    valid: isValid
  }, /*#__PURE__*/react.createElement("span", {
    className: "loginCont__label"
  }, label), inputPrefix && /*#__PURE__*/react.createElement("span", {
    className: "loginCont__code"
  }, inputPrefix), /*#__PURE__*/react.createElement("input", {
    ref: ref,
    className: inputClassName,
    onChange: onChangeHandler,
    type: inputType,
    maxLength: maxlength,
    name: inputName,
    onClick: onInputClick,
    autoFocus: autoFocus,
    placeholder: placeholder,
    value: inputVal,
    disabled: inputDisabled
  }), (isError || isValid) && /*#__PURE__*/react.createElement(InputMessageIcon, {
    className: "logSprite " + (isError ? 'icInfoPink' : 'icSuccessSmall')
  }));
});
InputWrapper.displayName = 'InputWrapper';

var MobileForm = function MobileForm(_ref) {
  var _data$validation, _data$validation2, _data$validation3, _data$validation4, _data$validation5, _data$validation6;
  var onFormSubmit = _ref.onFormSubmit,
    prefillMobileNumber = _ref.prefillMobileNumber,
    isMobileNumberDisabled = _ref.isMobileNumberDisabled,
    skipMobileScreen = _ref.skipMobileScreen;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state;
    }),
    fetch = _useSendOtpStore.fetch,
    data = _useSendOtpStore.data,
    checkValid = _useSendOtpStore.checkValid,
    loading = _useSendOtpStore.loading,
    error = _useSendOtpStore.error;
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data,
        prefillfetch: s.fetch,
        prefillDetailsloaded: s.loaded,
        prefillLoading: s.loading,
        prefillError: s.error,
        controller: s.controller,
        setUserInputMobileNumber: s.setUserInputMobileNumber,
        userInputMobileNumber: s.userInputMobileNumber
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData,
    prefillfetch = _usePrefillLoginDetai.prefillfetch,
    prefillDetailsloaded = _usePrefillLoginDetai.prefillDetailsloaded,
    prefillError = _usePrefillLoginDetai.prefillError,
    controller = _usePrefillLoginDetai.controller,
    prefillLoading = _usePrefillLoginDetai.prefillLoading,
    setUserInputMobileNumber = _usePrefillLoginDetai.setUserInputMobileNumber,
    userInputMobileNumber = _usePrefillLoginDetai.userInputMobileNumber;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(true),
    buttonDisabled = _useState[0],
    setButtonDisabled = _useState[1];
  var inputRef = (0,react.useRef)(undefined);
  var onOtpSendSuccess = function onOtpSendSuccess() {
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Success',
        type: "itemSuccess",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (onFormSubmit) onFormSubmit();
  };
  var handleFormSubmit = function handleFormSubmit(e) {
    if (e) e.preventDefault();
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_get_otp", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow"
      }
    });
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Clicked',
        type: "cardClick",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (!loading) {
      var _inputRef$current;
      var mobileNumber = ((_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.value) || '';
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      var isValid = checkValid(mobileNumber, isMobileNumberEncoded);
      if (isValid) {
        setUserInputMobileNumber(mobileNumber);
        fetch({
          platform: 'dweb',
          data: {
            mobileNumber: mobileNumber,
            loginType: 'mobile',
            encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
            isEncoded: isMobileNumberEncoded || undefined
          },
          onSuccess: onOtpSendSuccess
        });
      }
    }
  };
  (0,react.useEffect)(function () {
    if (!prefillMobileNumber && !userInputMobileNumber) {
      prefillfetch({
        platform: 'dweb'
      });
    }
  }, [prefillMobileNumber, userInputMobileNumber]);
  (0,react.useEffect)(function () {
    if (inputRef.current) {
      var prefillMobileNumberViaApi = prefillDetailsloaded && !prefillError ? prefillData == null ? void 0 : prefillData.encodedMobileNumber : null;
      var mobile = prefillMobileNumber || userInputMobileNumber || prefillMobileNumberViaApi;
      if (mobile) {
        inputRef.current.value = mobile;
        setButtonDisabled(false);
      }
      if (prefillMobileNumber && skipMobileScreen) {
        handleFormSubmit();
      }
    }
  }, [prefillMobileNumber, skipMobileScreen, prefillDetailsloaded, prefillError, prefillData, userInputMobileNumber]);

  /**
   *
   * @param e synthetic event
   * auto submit when user enters 10 digit
   */
  var handleInputChange = function handleInputChange(e) {
    var _inputRef$current2;
    setButtonDisabled(true);
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    if (((_inputRef$current2 = inputRef.current) == null || (_inputRef$current2 = _inputRef$current2.value) == null ? void 0 : _inputRef$current2.length) === growth_auth_helpers_esm/* MOBILE_NUMBER_MAX_LENGTH */.Zb) {
      setButtonDisabled(false);
      handleFormSubmit(e);
    }
  };
  var subText = function subText(_ref2) {
    var waiting = _ref2.loading,
      failure = _ref2.error,
      validationMessage = _ref2.validationMessage;
    if (waiting) {
      return 'Sending OTP...';
    }
    if (!waiting && failure) {
      var _data$error;
      return (_data$error = data.error) == null ? void 0 : _data$error.errorMsg;
    }
    if (validationMessage) {
      return validationMessage;
    }
    return '';
  };
  var handleInputClick = function handleInputClick() {
    var _inputRef$current3;
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_entry_mobile", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow|mobileInput"
      }
    });
    if (prefillLoading) {
      controller == null || controller.abort();
    }
    if ((0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(inputRef == null || (_inputRef$current3 = inputRef.current) == null ? void 0 : _inputRef$current3.value, prefillData == null ? void 0 : prefillData.encodedMobileNumber)) {
      inputRef.current.value = '';
      setButtonDisabled(true);
    }
  };
  return /*#__PURE__*/react.createElement("form", {
    onSubmit: handleFormSubmit,
    autoComplete: "on"
  }, /*#__PURE__*/react.createElement(InputWrapper, {
    label: LOGIN_WITH_MOBILE.label,
    maxlength: 10,
    onInputClick: handleInputClick,
    inputPrefix: "+91 -",
    onChange: handleInputChange,
    isError: error || ((_data$validation = data.validation) == null ? void 0 : _data$validation.message),
    isValid: (_data$validation2 = data.validation) == null ? void 0 : _data$validation2.isValidMobile,
    ref: inputRef,
    inputName: "phone",
    inputType: "text",
    inputClassName: "loginCont__input",
    inputDisabled: loading || !((_data$validation3 = data.validation) != null && _data$validation3.message) && isMobileNumberDisabled
  }), /*#__PURE__*/react.createElement(MessageText, {
    success: ((_data$validation4 = data.validation) == null ? void 0 : _data$validation4.isValidMobile) && !loading,
    error: !loading && error || ((_data$validation5 = data.validation) == null ? void 0 : _data$validation5.message),
    loading: loading
  }, subText({
    loading: loading,
    error: error,
    validationMessage: (_data$validation6 = data.validation) == null ? void 0 : _data$validation6.message
  })), /*#__PURE__*/react.createElement(LoginSubmitButton, {
    className: " " + (buttonDisabled ? 'disabled' : ''),
    type: "submit"
  }, LOGIN_WITH_MOBILE.submitButton));
};

var AUTH_FLOW_STEPS = {
  STEP_MOBILE: 'mobile',
  STEP_OTP: 'otp',
  STEP_PASSWORD: 'pwd',
  STEP_POST_AUTH: 'postlogin',
  LOADER: 'loader'
};

var useAuthFlow = (0,esm/* create */.Ue)(function (set) {
  return {
    activeAuthFlow: AUTH_FLOW_STEPS.STEP_MOBILE,
    setActiveAuthFlow: function setActiveAuthFlow(type) {
      return set({
        activeAuthFlow: type
      });
    }
  };
});

var LoginWithMobile = function LoginWithMobile(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
    isMobileNumberDisabled = _ref.isMobileNumberDisabled,
    skipMobileScreen = _ref.skipMobileScreen;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var setActiveAuthFlow = useAuthFlow(function (state) {
    return state.setActiveAuthFlow;
  });
  var onFormSubmit = function onFormSubmit() {
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_OTP);
  };
  var termsAndConditionClick = function termsAndConditionClick() {
    adobe.track('ctaClick', {
      cta: {
        name: "Login_TNC",
        type: "itemClick",
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };
  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, LOGIN_WITH_MOBILE.heading), /*#__PURE__*/react.createElement(MobileForm, {
    prefillMobileNumber: prefillMobileNumber,
    onFormSubmit: onFormSubmit,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen
  })), /*#__PURE__*/react.createElement(LoginTermsAndCondition, {
    onClick: termsAndConditionClick,
    "data-id": "terms-condition",
    dangerouslySetInnerHTML: {
      __html: LOGIN_WITH_MOBILE.termsPolicy
    }
  }));
};

var Heading = 'Verify OTP';
var SubHeading$1 = 'Enter 4 digit OTP sent to';
var RESEND_OTP = {
  label: "Didn't get the OTP?",
  timerHeading: 'Resend OTP in'
};
var OTP_TYPE = {
  sms: 'mobile',
  whatsApp: 'whatsapp'
};
var VERIFY_OTP_MSG = {
  verified: 'OTP verified',
  verifying: 'Verifying OTP...',
  invalidOtp: 'Please enter a valid OTP'
};
var TERMS_CONDITION = 'I agree to receive critical messages such as OTP, booking details on WhatsApp.';

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$2;
var SubHeading = styled_components_browser_esm["default"].div(_templateObject$7 || (_templateObject$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-bottom: 30px;\n\tmargin-top: -22px;\n\t", "\n\tspan {\n\t\t", "\n\t}\n\t.icEdit {\n\t\tmargin-left: 3px;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW1 */.iH.BaseW1, growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var OtpWrapper = styled_components_browser_esm["default"].div(_templateObject2$5 || (_templateObject2$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t.verifyOtpCont__otpFiled {\n\t\theight: 56px;\n\t\tborder-radius: 4px;\n\t\tborder: 2px solid rgb(1, 110, 255);\n\t\tcolor: rgb(79, 82, 90);\n\t\toutline: 0px;\n\t\twidth: 60px !important;\n\t\ttext-align: center;\n\t\tpadding: 0;\n\t\t", "\n\t}\n\t&.otpError .verifyOtpCont__otpFiled {\n\t\tborder-color: rgb(229, 52, 66);\n\t}\n\t.verifyOtpCont__message {\n\t\tmin-height: 50px;\n\t}\n\t.verifyOtpCont__otpCont {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OtpErrorContainer = styled_components_browser_esm["default"].div(_templateObject3$4 || (_templateObject3$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 8px;\n\t.errorIcon {\n\t\tmargin-right: 10px;\n\t}\n\t.errorMessage {\n\t\tcolor: rgb(229, 52, 66);\n\t\t", "\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimerContainer = styled_components_browser_esm["default"].div(_templateObject4$4 || (_templateObject4$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 10px;\n\t.gi-resend-timer {\n\t\tmargin-left: 5px;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimer = styled_components_browser_esm["default"].span(_templateObject5$3 || (_templateObject5$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var ResendSmsTypeContainer = styled_components_browser_esm["default"].div(_templateObject6$2 || (_templateObject6$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\t&.disableInfo {\n\t\topacity: 0.3;\n\t\tpointer-events: none;\n\t}\n\t.otpScreen__social {\n\t\tdisplay: flex;\n\t}\n\t.otpScreen__social > li {\n\t\twidth: 94px;\n\t\tmargin: 0 0 0 10px;\n\t\tpadding: 4px 14px 5px 8px;\n\t\tborder-radius: 2px;\n\t\tborder: solid 1px #cecece;\n\t\tbackground-color: #fff;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t}\n\t.otpScreen__social > li .gi-tooltip {\n\t\tdisplay: none;\n\t}\n\t.otpScreen__social > li:hover .gi-tooltip {\n\t\tdisplay: block;\n\t}\n"])));

var OtpInputWrapper = function OtpInputWrapper(_ref) {
  var mobileNumber = _ref.mobileNumber,
    onOtpSuccess = _ref.onOtpSuccess,
    isExistingUser = _ref.isExistingUser;
  var verifyNewUser = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (state) {
    return state.fetch;
  });
  var fetchLoginDetails = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (state) {
    return state.fetch;
  });
  var otpData = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return state.data;
  });
  var _useState = (0,react.useState)(''),
    otp = _useState[0],
    setOtp = _useState[1];
  var _useState2 = (0,react.useState)(false),
    otpVerifying = _useState2[0],
    setOtpVerifying = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    otpError = _useState3[0],
    setOtpError = _useState3[1];
  var _useState4 = (0,react.useState)(''),
    otpErrorMsg = _useState4[0],
    setOtpErrorMsg = _useState4[1];
  (0,react.useEffect)(function () {
    /**
     * this check if otp is invalid then bring focus to 4th input field
     */
    if (otpError && !otpVerifying) {
      var otpList = document.querySelectorAll('input.verifyOtpCont__otpFiled') || [];
      if (otpList[3]) {
        otpList[3].focus();
      }
    }
  }, [otpError, otpVerifying]);
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData;
  var onOtpVerificationSuccess = function onOtpVerificationSuccess(details) {
    setOtpVerifying(false);
    if (onOtpSuccess) onOtpSuccess(details);
  };
  var onOtpVerificationError = function onOtpVerificationError(_ref2) {
    var code = _ref2.code;
    setOtpVerifying(false);
    if (code && code === growth_auth_helpers_esm/* INVALID_OTP_CODE */.Wp) {
      setOtpError(true);
      setOtpErrorMsg('Please enter a valid OTP');
    } else {
      setOtpError(true);
      setOtpErrorMsg('Some error occurred, please try again.');
    }
  };
  var resetErrorState = function resetErrorState() {
    setOtpError(false);
    setOtpErrorMsg('');
  };
  var submitOtp = function submitOtp(value) {
    setOtpVerifying(true);
    resetErrorState();
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_verify_otp_auto", {
      event_detail: {
        event_type: "click_event",
        event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
      }
    });
    if (isExistingUser) {
      fetchLoginDetails({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          passwordType: 'OTP',
          password: value,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: otpData.isMobileNumberEncoded || undefined
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    } else {
      verifyNewUser({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          passwordType: 'OTP',
          password: value
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    }
  };
  var handleOtpChange = function handleOtpChange(value) {
    setOtpVerifying(false);
    setOtp(value);
    if (value.length === 4) {
      submitOtp(value);
    }
  };
  return /*#__PURE__*/react.createElement(OtpWrapper, {
    className: otpError ? 'otpError' : ''
  }, /*#__PURE__*/react.createElement(lib/* default */.Z, {
    value: otp,
    onChange: handleOtpChange,
    numInputs: 4,
    separator: /*#__PURE__*/react.createElement("span", null, "\xA0"),
    containerStyle: "verifyOtpCont__otpCont",
    inputStyle: otpVerifying ? 'verifyOtpCont__otpFiled disabled' : 'verifyOtpCont__otpFiled',
    isInputNum: true,
    shouldAutoFocus: true,
    isDisabled: otpVerifying
  }), /*#__PURE__*/react.createElement("div", {
    className: "verifyOtpCont__message"
  }, otpVerifying && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, {
    theme: "blue"
  }), /*#__PURE__*/react.createElement("p", {
    className: "gr-append-left10 robotoRegular gr-font12"
  }, VERIFY_OTP_MSG.verifying)), otpError && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icInfoPink errorIcon"
  }), /*#__PURE__*/react.createElement("p", {
    className: "errorMessage"
  }, otpErrorMsg))));
};

var OTP_RESEND_TIME = 30;
var CONFIG_KEY_DWEB_AUTH = 'growth-dweb-header-config';

var tooltipStyle = {
  width: '250px',
  top: 32
};
var tooltipStyle2 = {
  width: '250px',
  top: 32,
  right: 14
};
var ResendOtp = function ResendOtp(_ref) {
  var isExistingUser = _ref.isExistingUser;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return {
        resendOtpApi: state.fetch,
        apiLoading: state.loading,
        mobileNumber: state.data.mobileNumber
      };
    }, shallow/* shallow */.X),
    resendOtpApi = _useSendOtpStore.resendOtpApi,
    mobileNumber = _useSendOtpStore.mobileNumber,
    apiLoading = _useSendOtpStore.apiLoading;
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData;
  var _useState = (0,react.useState)(OTP_RESEND_TIME),
    resendTimer = _useState[0],
    setResendTimer = _useState[1];
  var _useState2 = (0,react.useState)(true),
    isTimerActive = _useState2[0],
    setIsTimerActive = _useState2[1];
  (0,react.useEffect)(function () {
    var timerInterval;
    if (isTimerActive) {
      if (resendTimer === 0) {
        clearInterval(timerInterval);
        setIsTimerActive(false);
      }
      timerInterval = setInterval(function () {
        setResendTimer(function (timer) {
          return timer - 1;
        });
      }, 1000);
    }
    return function () {
      clearInterval(timerInterval);
    };
  }, [isTimerActive, resendTimer]);
  var resendOtp = function resendOtp(type) {
    if (!apiLoading) {
      (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_resend_otp|" + type, {
        event_detail: {
          event_type: "click_event|onboarding_click",
          event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
        }
      });
      adobe.track('ctaClick', {
        cta: {
          name: "resend_otp",
          type: "cardClick|method:" + type + "|flow:" + (isExistingUser ? 'login' : 'signup'),
          componentName: 'GI_USER_ONBOARDING'
        }
      });
      setResendTimer(OTP_RESEND_TIME);
      setIsTimerActive(true);
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      resendOtpApi({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          loginType: type,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: isMobileNumberEncoded || undefined
        }
      });
    }
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ResendOtpTimerContainer, null, RESEND_OTP.label, ' ', resendTimer ? /*#__PURE__*/react.createElement("span", null, RESEND_OTP.timerHeading, /*#__PURE__*/react.createElement(ResendOtpTimer, {
    className: "gi-resend-timer"
  }, resendTimer < 10 ? "00:0" + resendTimer : "00:" + resendTimer)) : null), /*#__PURE__*/react.createElement(ResendSmsTypeContainer, {
    className: "" + (resendTimer ? 'disableInfo' : '')
  }, /*#__PURE__*/react.createElement(ResendOtpTimer, null, "Resend via :"), /*#__PURE__*/react.createElement("ul", {
    className: "otpScreen__social"
  }, /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.whatsApp);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icWhatsapp gr-append-right5"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "WhatsApp"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle,
    notchPosition: "middle"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please ensure that you have entered your WhatsApp number for OTP"))), /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.sms);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSms gr-appendRight10"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "SMS"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle2,
    notchPosition: "right"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please don\u2019t share your OTP with anyone"))))));
};

var LoginWithOtp = function LoginWithOtp(_ref) {
  var isMobileNumberDisabled = _ref.isMobileNumberDisabled;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state.data;
    }),
    mobileNumber = _useSendOtpStore.mobileNumber,
    data = _useSendOtpStore.data;
  var _useAuthFlow = useAuthFlow(function (state) {
      return state;
    }),
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'OTP_Screen_Loaded',
        type: "itemLoaded|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_otp", {
      event_detail: {
        event_type: "load_event|onboarding_click",
        event_value: "onboarding_flow|" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup')
      }
    });
  }, []);
  var onEditMobile = function onEditMobile() {
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    adobe.track('ctaClick', {
      cta: {
        name: "Edit_Phone_Number",
        destination: 'Login_Popup_Load',
        type: "itemClick|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };
  var onOtpSuccess = function onOtpSuccess() {
    adobe.track('User_Login', {
      account: {
        accountInfo: {
          flow: "" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup')
        }
      },
      cta: {
        type: 'manual',
        name: "Onboarding_" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'Login' : 'Signup') + "_Success",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_POST_AUTH);
  };
  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, Heading), /*#__PURE__*/react.createElement(SubHeading, null, SubHeading$1, /*#__PURE__*/react.createElement("span", null, " ", mobileNumber), !isMobileNumberDisabled && /*#__PURE__*/react.createElement("span", {
    className: "logSprite icEdit",
    onClick: onEditMobile,
    role: "presentation"
  })), /*#__PURE__*/react.createElement(OtpInputWrapper, {
    mobileNumber: mobileNumber,
    onOtpSuccess: onOtpSuccess,
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  }), /*#__PURE__*/react.createElement(ResendOtp, {
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  })), /*#__PURE__*/react.createElement(LoginTermsAndCondition, null, TERMS_CONDITION));
};

var _templateObject$6, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$1, _templateObject7;
var PostAuthContainer = styled_components_browser_esm["default"].div(_templateObject$6 || (_templateObject$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tjustify-content: flex-start;\n\tmargin: -31px -37px -18px -37px !important;\n\theight: 486px;\n\tinput.loginCont__input {\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #4f525a;\n\t\tborder-radius: 4px;\n\t\tpadding: 0 20px;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\tline-height: 20px !important;\n\t\topacity: 1;\n\t\tfont-weight: 600 !important;\n\t}\n"])));
var PostAuthHeader = styled_components_browser_esm["default"].div(_templateObject2$4 || (_templateObject2$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground-color: #e5f2ff;\n\tcolor: #2d67b2;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 24px 16px;\n\tborder-radius: 10px;\n\tspan {\n\t\tmargin-right: 20px;\n\t}\n\n\t.successMsg__title {\n\t\tfont-size: 22px;\n\t\tline-height: 27px;\n\t\tcolor: #00962d;\n\n\t\tfont-weight: 500;\n\t}\n\n\t.successMsg__subTitle {\n\t\tfont-size: 18px;\n\t\tline-height: 27px;\n\t\tcolor: #4f525a;\n\n\t\tfont-weight: 500;\n\t}\n"])));
var postAuthForms = styled_components_browser_esm["default"].div(_templateObject3$3 || (_templateObject3$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin: 30px 27px 15px 37px;\n\twidth: 300px;\n\t.gi-marginBottom25 {\n\t\tmargin-bottom: 25px;\n\t}\n"])));
var postAuthFormHeading = styled_components_browser_esm["default"].p(_templateObject4$3 || (_templateObject4$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 13px;\n\tmargin-bottom: 20px;\n\tline-height: 18px !important;\n"])));
var PostAuthSubmitButton = styled_components_browser_esm["default"].button(_templateObject5$2 || (_templateObject5$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 13px 118px 13px 116px;\n\tmargin-top: 22px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])));
var SkipUpdate = styled_components_browser_esm["default"].div(_templateObject6$1 || (_templateObject6$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\ttext-align: center;\n\tmargin-top: 30px;\n\n\tbutton {\n\t\tcolor: #008cff !important;\n\t\tcursor: pointer;\n\t\tborder: 0;\n\t\tbackground-color: transparent;\n\t\ttext-decoration: none;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t}\n"])));
var ErrorMsg = styled_components_browser_esm["default"].p(_templateObject7 || (_templateObject7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 10px !important;\n\n\tcolor: #e53442;\n"])));

var SIGNUP_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'Account created successfully'
};
var LOGIN_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'You have successfully logged in'
};
var DO_IT_LATER = {
  title: 'I’ll do it later'
};
var VALIDATION_MSG = {
  email: {
    invalid: "Enter a valid email"
  },
  name: {
    invalid: "Please enter valid name using only alphabets"
  }
};

var UpdateDetailsForm = function UpdateDetailsForm(_ref) {
  var firstName = _ref.firstName,
    primaryEmailId = _ref.primaryEmailId,
    handleUserUpdate = _ref.handleUserUpdate,
    handleDoItLaterClick = _ref.handleDoItLaterClick,
    apiFailureMsg = _ref.apiFailureMsg,
    isExistingUser = _ref.isExistingUser;
  var _useState = (0,react.useState)(false),
    isFormValid = _useState[0],
    setIsFormValid = _useState[1];
  var _useState2 = (0,react.useState)(''),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    email = _useState3[0],
    setEmail = _useState3[1];
  var _useState4 = (0,react.useState)(false),
    isError = _useState4[0],
    setIsError = _useState4[1];
  var _useState5 = (0,react.useState)(''),
    errorMsg = _useState5[0],
    setErrorMsg = _useState5[1];
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  (0,react.useEffect)(function () {
    setErrorMsg(apiFailureMsg);
    setIsError(!!apiFailureMsg);
  }, [apiFailureMsg]);
  var handleNameChange = function handleNameChange(e) {
    setName(e.target.value);
  };
  var handleEmailChange = function handleEmailChange(e) {
    setEmail(e.target.value);
  };
  var validateProfileUpdate = function validateProfileUpdate(_ref2) {
    var _ref2$fullName = _ref2.fullName,
      fullName = _ref2$fullName === void 0 ? '' : _ref2$fullName,
      _ref2$inputEmail = _ref2.inputEmail,
      inputEmail = _ref2$inputEmail === void 0 ? '' : _ref2$inputEmail;
    if (fullName && email) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    if (!fullName && inputEmail) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
    }
    if (!inputEmail && fullName) {
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    return {
      isValid: true,
      errorMessage: ''
    };
  };
  var onUserUpdate = function onUserUpdate() {
    var _validateProfileUpdat = validateProfileUpdate({
        fullName: name,
        inputEmail: email
      }),
      isValid = _validateProfileUpdat.isValid,
      errorMessage = _validateProfileUpdat.errorMessage;
    if (isValid) {
      if (handleUserUpdate) handleUserUpdate({
        fullName: name,
        email: email
      });
    } else {
      setErrorMsg(errorMessage);
      setIsError(true);
    }
  };
  var onSkipClick = function onSkipClick() {
    if (handleDoItLaterClick) handleDoItLaterClick();
  };
  (0,react.useEffect)(function () {
    if (name || email) {
      setIsFormValid(true);
    } else {
      setIsError(false);
      setErrorMsg('');
    }
  }, [name, email]);
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Profile_Update_Screen_Loaded',
        type: "itemLoaded|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  }, []);
  return /*#__PURE__*/react.createElement(postAuthForms, null, /*#__PURE__*/react.createElement(postAuthFormHeading, null, "Just one more thing."), /*#__PURE__*/react.createElement("div", {
    className: "gi-marginBottom25"
  }, !firstName ? /*#__PURE__*/react.createElement(InputWrapper, {
    type: "text",
    name: "name",
    label: "What do we call you?",
    placeholder: "Enter your full name",
    inputClassName: "loginCont__input",
    inputVal: name,
    onChange: handleNameChange
  }) : null), !primaryEmailId ? /*#__PURE__*/react.createElement(InputWrapper, {
    type: "email",
    name: "Email",
    label: "What's your email id?",
    placeholder: "Enter your email address",
    inputClassName: "loginCont__input",
    inputVal: email,
    onChange: handleEmailChange
  }) : null, isError && /*#__PURE__*/react.createElement(ErrorMsg, null, errorMsg, " "), /*#__PURE__*/react.createElement(PostAuthSubmitButton, {
    type: "button",
    className: !isFormValid ? 'disabled' : '',
    onClick: onUserUpdate
  }, "Lets Go"), /*#__PURE__*/react.createElement(SkipUpdate, null, /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: onSkipClick || null
  }, DO_IT_LATER.title)));
};

var CloseIcon = function CloseIcon(_ref) {
  var closeAuth = _ref.closeAuth;
  return /*#__PURE__*/react.createElement(AuthVerificationFlowCloseIcon, {
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icClose",
    onClick: closeAuth,
    role: "presentation"
  }));
};

var UpdateProfile = function UpdateProfile(props) {
  var _userDetails$data;
  var closeAndLogin = props.closeAndLogin,
    onProfileComplete = props.onProfileComplete,
    onLoginComplete = props.onLoginComplete;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(''),
    apiFailureMsg = _useState[0],
    setApiFailureMsg = _useState[1];
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state.data;
    }),
    mobileNumber = _useSendOtpStore.mobileNumber,
    data = _useSendOtpStore.data;
  var _useLoginUserStore = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (s) {
      return {
        userDetails: s.data,
        fetchLoginDetails: s.fetch
      };
    }, shallow/* shallow */.X),
    userDetails = _useLoginUserStore.userDetails,
    fetchLoginDetails = _useLoginUserStore.fetchLoginDetails;
  var _useSignupViaOTPStore = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (s) {
      var _s$data;
      return {
        transactionId: (_s$data = s.data) == null ? void 0 : _s$data.transactionId,
        createNewUser: s.createUser
      };
    }, shallow/* shallow */.X),
    transactionId = _useSignupViaOTPStore.transactionId,
    createNewUser = _useSignupViaOTPStore.createNewUser;
  var updateUserDetails = (0,growth_auth_helpers_esm/* useProfileUpdateStore */.IR)(function (s) {
    return s.fetch;
  });
  var profileDetails = (userDetails == null || (_userDetails$data = userDetails.data) == null || (_userDetails$data = _userDetails$data.profileLoginResponse) == null ? void 0 : _userDetails$data[0]) || {};
  var _ref = profileDetails.userDetails || {},
    _ref$extendedUser = _ref.extendedUser,
    extendedUser = _ref$extendedUser === void 0 ? {} : _ref$extendedUser;
  var _extendedUser$persona = extendedUser.personalDetails,
    personalDetails = _extendedUser$persona === void 0 ? {} : _extendedUser$persona,
    _extendedUser$loginIn = extendedUser.loginInfoList,
    loginInfoList = _extendedUser$loginIn === void 0 ? [] : _extendedUser$loginIn,
    _extendedUser$miscFie = extendedUser.miscFields,
    miscFields = _extendedUser$miscFie === void 0 ? {} : _extendedUser$miscFie;
  var _personalDetails$name = personalDetails.name,
    name = _personalDetails$name === void 0 ? {} : _personalDetails$name;
  var isExistingUser = data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt;
  var primaryEmailId = '';
  loginInfoList.forEach(function (item) {
    if (item.loginType === 'EMAIL') {
      primaryEmailId = item.loginId;
    }
  });
  if (!primaryEmailId) {
    primaryEmailId = miscFields == null ? void 0 : miscFields.altEmailId;
  }
  var onLoginSuccess = function onLoginSuccess() {
    // adding timeout as api take some time to remove cache and update user details
    if (onLoginComplete) onLoginComplete(userDetails);
  };
  var onLoginError = function onLoginError() {
    setApiFailureMsg('Something went wrong, please try again.');
  };
  var onUserUpdate = function onUserUpdate(_ref2) {
    var fullName = _ref2.fullName,
      email = _ref2.email;
    setApiFailureMsg('');
    adobe.track('Profile_Completion');
    if (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt) {
      var details = {
        mobileNumber: mobileNumber
      };
      if (fullName) details.firstName = fullName;
      if (email) details.email = email;
      updateUserDetails({
        data: details,
        platform: 'dweb',
        onSuccess: onLoginSuccess,
        onError: onLoginError
      });
    } else if (!isExistingUser) {
      createNewUser({
        platform: 'dweb',
        fullName: fullName,
        email: email,
        mobileNumber: mobileNumber,
        transactionId: transactionId
      }).then(function (res) {
        var _res$result;
        if (res != null && (_res$result = res.result) != null && _res$result.success) {
          fetchLoginDetails({
            platform: 'dweb',
            data: {
              mobileNumber: mobileNumber,
              passwordType: 'TRANSITION_ID',
              password: transactionId
            },
            onSuccess: onLoginSuccess,
            onError: onLoginError
          });
        }
      })["catch"](function () {
        return onLoginError();
      });
    }
  };
  var handleDoItLaterClick = function handleDoItLaterClick() {
    adobe.track('ctaClick', {
      cta: {
        name: 'skip-profile-update',
        type: "itemClick|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (isExistingUser) {
      if (closeAndLogin) closeAndLogin();
    } else {
      onUserUpdate({
        fullName: '',
        email: ''
      });
    }
  };
  (0,react.useEffect)(function () {
    if (isExistingUser) {
      if (name.firstName && primaryEmailId) {
        onProfileComplete();
      }
    }
  }, [isExistingUser, name, primaryEmailId]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: handleDoItLaterClick
  }), /*#__PURE__*/react.createElement(PostAuthContainer, null, /*#__PURE__*/react.createElement(PostAuthHeader, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, LOGIN_SUCCESS_TOAST.title), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, isExistingUser ? LOGIN_SUCCESS_TOAST.subTitle : SIGNUP_SUCCESS_TOAST.subTitle))), /*#__PURE__*/react.createElement(UpdateDetailsForm, {
    apiFailureMsg: apiFailureMsg,
    firstName: name.firstName,
    primaryEmailId: primaryEmailId,
    handleUserUpdate: onUserUpdate,
    handleDoItLaterClick: handleDoItLaterClick,
    isExistingUser: isExistingUser
  })));
};

/** Create a new configStore instance for dweb-auth */
var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$1;
var AuthOfferStyle = styled_components_browser_esm["default"].div(_templateObject$5 || (_templateObject$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 343px;\n\theight: 432px;\n\tbackground-color: rgb(255, 255, 255);\n\tborder-radius: 20px 0px 0px 20px;\n\tflex-shrink: 0;\n\toverflow: hidden;\n\tpadding: 22px 20px 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\t", "\n\tcursor: ", ";\n"])), function (_ref) {
  var bg = _ref.bg;
  return !bg ? "background:linear-gradient(\n\t\t197.24deg,\n\t\trgb(194, 212, 255) 16.45%,\n\t\trgb(251, 241, 255) 39.26%,\n\t\trgb(234, 243, 243) 59.99%\n\t);\n\tbackground-size:0% 0% / cover;" : "background: #fff url(" + bg + ") top left no-repeat;\n\tbackground-size: cover;";
}, function (_ref2) {
  var clickable = _ref2.clickable;
  return clickable ? 'pointer' : 'auto';
});
var offerBannerHeading = styled_components_browser_esm["default"].h3(_templateObject2$3 || (_templateObject2$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n\tcolor: rgb(20, 24, 35);\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var offerBannerSubHeading = styled_components_browser_esm["default"].p(_templateObject3$2 || (_templateObject3$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4f525a;\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var smooth = (0,styled_components_browser_esm.keyframes)(_templateObject4$2 || (_templateObject4$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose([" {\n\tfrom {\n\t  opacity: 0;\n\t}\n  \n\tto {\n\t  opacity: 2;\n\t}\n  }"])));
var Smooth = styled_components_browser_esm["default"].div(_templateObject5$1 || (_templateObject5$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tanimation: ", ";\n"])), smooth);

var _templateObject$4, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6;
var BenefitsContainer = styled_components_browser_esm["default"].ul(_templateObject$4 || (_templateObject$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-top: 15px;\n\tmargin-left: -6px;\n"])));
var BenefitsList = styled_components_browser_esm["default"].li(_templateObject2$2 || (_templateObject2$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 20px;\n\n\t.benefitsList_item_wrapper {\n\t\tflex: 1;\n\t}\n\t.benefitsList_item_IconWrapper {\n\t\twidth: 52px;\n\t\theight: 52px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t\tmargin-right: 20px;\n\t\tmargin-top: -12px;\n\t}\n\n\t.benefitsList_item_IconWrapper.giftIcon {\n\t\tmargin-top: -24px;\n\t}\n\n\t.icGoCash {\n\t\twidth: 73px;\n\t\theight: 44px;\n\t\tbackground: url(https://gos3.ibcdn.com/go-cash-icon-1674207238.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGoTribe {\n\t\twidth: 52px;\n\t\theight: 15px;\n\t\tbackground: url(https://gos3.ibcdn.com/gotribe-logo-1674203779.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGiftBlue {\n\t\twidth: 37px;\n\t\theight: 42px;\n\t\tbackground: url(https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n"])));
var BenifitsImage = styled_components_browser_esm["default"].div(_templateObject3$1 || (_templateObject3$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 52px;\n\theight: 52px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tmargin-right: 20px;\n\tbackground: url(", ");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n\tmargin-top: -10px;\n"])), function (props) {
  return props.imgUrl;
});
var BenefitsContainerHeading = styled_components_browser_esm["default"].div(_templateObject4$1 || (_templateObject4$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\tmargin-bottom: 6px;\n"])), growth_design_system_esm/* headingSizes.Small */.$G.Small);
var BenefitsContainerSubHeading = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\t&.lastChild {\n\t\tborder-bottom: none;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var BenifitsDivider = styled_components_browser_esm["default"].div(_templateObject6 || (_templateObject6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tborder-bottom: 1px solid #cdcdcd;\n\tmargin-top: 20px;\n"])));

var OfferBenefits = function OfferBenefits(props) {
  var _props$benefitsList = props.benefitsList,
    benefitsList = _props$benefitsList === void 0 ? [] : _props$benefitsList;
  return /*#__PURE__*/react.createElement(BenefitsContainer, null, benefitsList.map(function (benefit) {
    return /*#__PURE__*/react.createElement(BenefitsList, {
      key: benefit.id
    }, /*#__PURE__*/react.createElement(BenifitsImage, {
      imgUrl: benefit.imgUrl
    }), /*#__PURE__*/react.createElement("div", {
      className: "benefitsList_item_wrapper"
    }, /*#__PURE__*/react.createElement(BenefitsContainerHeading, null, benefit.heading, " "), /*#__PURE__*/react.createElement(BenefitsContainerSubHeading, null, benefit.subHeading, " "), /*#__PURE__*/react.createElement(BenifitsDivider, null)));
  }));
};

var _templateObject$3, _templateObject2$1, _templateObject3, _templateObject4;
var OfferBanner$1 = styled_components_browser_esm["default"].div(_templateObject$3 || (_templateObject$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground: rgb(255, 255, 255);\n\tbox-shadow: rgba(0, 0, 0, 0.08) 2px 4px 8px;\n\tborder-radius: 2px;\n\tpadding: 10px 20px;\n\tborder-left: 6px solid rgb(28, 114, 226);\n\twidth: 303px;\n"])));
var OfferBannerHeading = styled_components_browser_esm["default"].p(_templateObject2$1 || (_templateObject2$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(79, 82, 90);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OfferBannerSubHeading = styled_components_browser_esm["default"].p(_templateObject3 || (_templateObject3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(101, 102, 104);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var OfferBannerCouponCode = styled_components_browser_esm["default"].p(_templateObject4 || (_templateObject4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(28, 114, 226);\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);

var OfferBanner = function OfferBanner(props) {
  var heading = props.heading,
    subHeading = props.subHeading,
    couponCode = props.couponCode;
  return /*#__PURE__*/react.createElement(OfferBanner$1, null, /*#__PURE__*/react.createElement(OfferBannerHeading, null, heading), /*#__PURE__*/react.createElement(OfferBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBannerCouponCode, null, couponCode));
};

var _templateObject$2, growth_gi_dweb_auth_esm_templateObject2;
var Wrap = styled_components_browser_esm["default"].div(_templateObject$2 || (_templateObject$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"])));
var Bg = styled_components_browser_esm["default"].div(growth_gi_dweb_auth_esm_templateObject2 || (growth_gi_dweb_auth_esm_templateObject2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 44px;\n\twidth: 44px;\n\tjustify-content: center;\n\talign-items: center;\n\tdisplay: flex;\n\tbox-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);\n\tborder-radius: 50px;\n"])));
var Loader = function Loader() {
  return /*#__PURE__*/react.createElement(Wrap, null, /*#__PURE__*/react.createElement(Bg, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, null)));
};

var DEFAULT_CONFIG = {
  loginPopover: {
    signUp: {
      ctaText: 'Login/Sign Up',
      coupon: 'Use Coupon : WELCOME'
    }
  },
  loginCtaLabels: [{
    text: 'LOGIN / SIGNUP',
    id: 'text_1'
  }, {
    text: 'Exclusive Offers',
    id: 'text_2'
  }, {
    text: 'Earn goCash',
    id: 'text_3'
  }, {
    text: 'Manage Your Trips',
    id: 'text_4'
  }, {
    text: 'LOGIN / SIGNUP',
    id: 'text_5'
  }],
  bookingOffers: {
    growth: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    flights: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    hotels: {
      title: 'FLAT 25% OFF* ',
      subTitle: 'on your first Hotel booking'
    },
    bus: {
      title: 'FLAT 10% OFF*',
      subTitle: 'on your first Bus booking'
    },
    cabs: {
      title: 'Upto 10% OFF*',
      subTitle: 'on your first Cab booking'
    },
    trains: {
      title: 'Zero service fees',
      subTitle: 'on your first Train booking'
    }
  },
  loginDialog: {
    heading: 'Unlock these benefits',
    subHeading: '',
    salesOffers: {},
    benefits: [{
      id: 1,
      heading: 'Earn goCash',
      subHeading: '100 on Sign Up & Cashback on Bookings',
      imgUrl: 'https://gos3.ibcdn.com/go-cash-icon-1674207238.png'
    }, {
      id: 2,
      heading: 'Loyalty Benefits',
      subHeading: 'Extra Discounts, Free Seat Selection etc.',
      imgUrl: 'https://gos3.ibcdn.com/gotribe-logo-1674203779.png'
    }, {
      id: 3,
      heading: 'Exclusive Offers',
      subHeading: 'Daily Steal Deals & Special Discounts',
      imgUrl: 'https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png'
    }]
  }
};

var AuthOfferBanner = function AuthOfferBanner(props) {
  var _D4, _D5, _D6, _D7;
  var lobName = props.lobName,
    showBanner = props.showBanner;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _ref = useConfigStore(),
    data = _ref.data,
    loading = _ref.loading,
    error = _ref.error,
    loaded = _ref.loaded;
  var configData = function configData() {
    var _data$COMMON;
    var d = data == null || (_data$COMMON = data.COMMON) == null || (_data$COMMON = _data$COMMON[CONFIG_KEY_DWEB_AUTH]) == null ? void 0 : _data$COMMON.data;
    if (loaded && !error && d) {
      return d;
    }
    return DEFAULT_CONFIG;
  };
  var _ref2 = configData(),
    loginDialog = _ref2.loginDialog,
    bookingOffers = _ref2.bookingOffers;
  var _ref3 = loginDialog || {},
    benefits = _ref3.benefits,
    salesOffers = _ref3.salesOffers,
    heading = _ref3.heading,
    subHeading = _ref3.subHeading;
  var D;
  if (showBanner && (salesOffers || bookingOffers)) {
    D = {
      salesOffers: salesOffers == null ? void 0 : salesOffers[lobName],
      bookingOffers: bookingOffers == null ? void 0 : bookingOffers[lobName]
    };
  }
  var hasSalesOffersExpired = function hasSalesOffersExpired() {
    var _D, _D2;
    if ((_D = D) != null && (_D = _D.salesOffers) != null && _D.imgUrl && (_D2 = D) != null && (_D2 = _D2.salesOffers) != null && _D2.expiry) {
      // expire date format: MM/DD/YYYY
      return (0,growth_date_utils_esm/* isDateExpired */.Zz)({
        now: new Date().getTime(),
        expire: new Date(D.salesOffers.expiry).getTime()
      });
    }
    return true;
  };
  var shouldShowSalesImage = !hasSalesOffersExpired();
  var handleSalesImageClick = function handleSalesImageClick() {
    var _D3;
    adobe.track('ctaClick', {
      cta: {
        name: "Sale_Banner_Clicked",
        type: 'itemClick',
        componentName: "GI_USER_ONBOARDING"
      }
    });
    if (shouldShowSalesImage && (_D3 = D) != null && (_D3 = _D3.salesOffers) != null && _D3.ctaUrl) {
      window.open(D.salesOffers.ctaUrl, '_blank');
    }
  };
  (0,react.useEffect)(function () {
    if (loaded) {
      if (shouldShowSalesImage) {
        // send event when sales has to be display
        adobe.track('ctaClick', {
          cta: {
            name: 'Sale_Banner_loaded',
            type: "itemLoaded",
            componentName: "GI_USER_ONBOARDING"
          }
        });
      }
      (0,growth_pdt_push_esm/* pdtPush */.g)("login_leaflet_load", {
        event_detail: {
          event_type: "load_event|onboarding_click",
          event_value: "" + (shouldShowSalesImage ? "sale_flow" : "onboarding_flow")
        }
      });
    }
  }, [loaded, shouldShowSalesImage]);
  if (!showBanner) {
    return null;
  }
  return /*#__PURE__*/react.createElement(AuthOfferStyle, {
    className: "gr-home",
    "data-id": "auth-offer-banner",
    bg: shouldShowSalesImage ? (_D4 = D) == null || (_D4 = _D4.salesOffers) == null ? void 0 : _D4.imgUrl : '',
    onClick: handleSalesImageClick,
    clickable: !!shouldShowSalesImage
  }, loading ? /*#__PURE__*/react.createElement(Loader, null) : /*#__PURE__*/react.createElement(Smooth, null, heading && !shouldShowSalesImage && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(offerBannerHeading, {
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/react.createElement(offerBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBenefits, {
    benefitsList: benefits
  })), /*#__PURE__*/react.createElement(OfferBanner, {
    heading: (_D5 = D) == null || (_D5 = _D5.bookingOffers) == null ? void 0 : _D5.title,
    subHeading: (_D6 = D) == null || (_D6 = _D6.bookingOffers) == null ? void 0 : _D6.subTitle,
    couponCode: (_D7 = D) == null || (_D7 = _D7.bookingOffers) == null ? void 0 : _D7.coupon
  }))));
};

var _templateObject$1;
var ToastContainer = styled_components_browser_esm["default"].div(_templateObject$1 || (_templateObject$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\ttext-align: left;\n\n\t.icSuccessBig {\n\t\tmargin-right: 40px;\n\t}\n\n\t.successMsg__title {\n\t\t", "\n\t\tcolor: #00962d;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.successMsg__subTitle {\n\t\t", "\n\t\tcolor: #4f525a;\n\t}\n\n\t.closeIcon {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tright: 20px;\n\t\ttop: 20px;\n\t}\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1, growth_design_system_esm/* textSizes.LargeW2 */.iH.LargeW2);

var ProfileCompletedToast = function ProfileCompletedToast(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Toast, {
    style: {
      'width': '600px',
      'background': '#fff',
      'padding': '30px 40px',
      'alignItems': 'center',
      'borderRadius': '10px',
      'maxHeight': 'unset',
      'zIndex': ' 1025'
    },
    autoHideDuration: 3000,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(ToastContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, "Congratulations"), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, "You have successfully logged in")), /*#__PURE__*/react.createElement("span", {
    className: " closeIcon logSprite icClose"
  }))));
};

var AuthVerificationFlow = function AuthVerificationFlow(props) {
  var _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
    onClose = props.onClose,
    screenName = props.screenName,
    lobName = props.lobName,
    onLoginSuccess = props.onLoginSuccess,
    prefillMobileNumber = props.prefillMobileNumber,
    isMobileNumberDisabled = props.isMobileNumberDisabled,
    skipMobileScreen = props.skipMobileScreen;
  var _useAuthFlow = useAuthFlow(function (state) {
      return {
        activeAuthFlow: state.activeAuthFlow,
        setActiveAuthFlow: state.setActiveAuthFlow
      };
    }, shallow/* shallow */.X),
    activeAuthFlow = _useAuthFlow.activeAuthFlow,
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(false),
    showSuccessToast = _useState[0],
    setShowSuccessToast = _useState[1];
  (0,react.useEffect)(function () {
    if (screenName) setActiveAuthFlow(screenName);
  }, [screenName]);
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Login_Popup_Load',
        type: "itemLoaded",
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_load", {
      event_detail: {
        event_type: "load_event|onboarding_click",
        event_Value: "onboarding_flow|" + lobName
      }
    });
  }, []);
  var closeAuth = function closeAuth() {
    adobe.track('ctaClick', {
      cta: {
        name: "Close Modal",
        type: "itemClick|flow:" + activeAuthFlow,
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_close", {
      event_detail: {
        event_type: "click_event",
        event_Value: "onboarding_flow|flow:" + activeAuthFlow
      }
    });
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    if (onClose) onClose();
  };
  var onProfileComplete = function onProfileComplete() {
    setShowSuccessToast(true);
    if (onLoginSuccess) onLoginSuccess();
  };
  var closeAndLogin = function closeAndLogin() {
    var _window$GI;
    /** works on older header, gi-happy-header */
    /** @deprecated */
    if ((_window$GI = window.GI) != null && _window$GI.HeaderEvent) {
      window.GI.HeaderEvent.trigger('LOGIN_SUCCESS');
    }
    growth_dom_event_emitter_esm/* default.emit */.Z.emit(growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP);
    if (onLoginSuccess) onLoginSuccess();
    if (onClose) onClose();
  };
  var onLoginComplete = function onLoginComplete() {
    closeAndLogin();
  };
  if (showSuccessToast) {
    return /*#__PURE__*/react.createElement(ProfileCompletedToast, {
      onClose: onLoginComplete
    });
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(AuthOfferBanner, {
    lobName: lobName,
    showBanner: activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH
  }), /*#__PURE__*/react.createElement(AuthVerificationFlowSection, {
    height: activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH ? '486px' : undefined,
    "data-id": "auth-flow-section"
  }, showCloseButton && activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH ? /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: closeAuth
  }) : null, activeAuthFlow === AUTH_FLOW_STEPS.STEP_MOBILE && /*#__PURE__*/react.createElement(LoginWithMobile, {
    prefillMobileNumber: prefillMobileNumber,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_OTP && /*#__PURE__*/react.createElement(LoginWithOtp, {
    isMobileNumberDisabled: isMobileNumberDisabled
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH && /*#__PURE__*/react.createElement(UpdateProfile, {
    closeAndLogin: closeAndLogin,
    onProfileComplete: onProfileComplete,
    onLoginComplete: onLoginComplete
  })));
};

var AuthContainer = function AuthContainer(props) {
  var configData = props.configData;

  /** Memorize b/c we don't want to call the setData again if there in no change in configData */
  (0,react.useMemo)(function () {
    if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
  }, [configData]);
  var _useConfigStore = useConfigStore(function (s) {
      return {
        fetchConfigStore: s.fetch
      };
    }, shallow/* shallow */.X),
    fetchConfigStore = _useConfigStore.fetchConfigStore;
  (0,react.useEffect)(function () {
    fetchConfigStore({
      keys: CONFIG_KEY_DWEB_AUTH,
      lobs: 'COMMON',
      initData: configData
    });
  }, []);
  return /*#__PURE__*/react.createElement(AuthContainer$1, {
    "data-id": "auth-container"
  }, /*#__PURE__*/react.createElement(AuthVerificationFlow, props));
};

var growth_gi_dweb_auth_esm_templateObject;
var CommonSpriteStyle = (0,styled_components_browser_esm.createGlobalStyle)(growth_gi_dweb_auth_esm_templateObject || (growth_gi_dweb_auth_esm_templateObject = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\n  .logSprite {\n    background: url(https://gos3.ibcdn.com/happy-sprite-1608708553.png) no-repeat;\n    display: inline-block;\n    background-size: 300px 300px;\n    font-size: 0;\n    flex-shrink: 0;\n  }\n\n  .logSprite.icGift {\n    width: 42px;\n    height: 42px;\n    background-position: -10px -9px;\n  }\n\n  .logSprite.icClose {\n    width: 16px;\n    height: 16px;\n    background-position: -180px -8px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSuccessBig {\n    width: 41px;\n    height: 40px;\n    background-position: -60px -11px;\n  }\n\n  .logSprite.icSuccessSmall {\n    width: 19px;\n    height: 18px;\n    background-position: -132px -33px;\n  }\n\n  .logSprite.icShowPassword {\n    width: 17px;\n    height: 15px;\n    background-position: -105px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSms {\n    width: 13px;\n    height: 12px;\n    background-position: -110px -39px;\n  }\n\n  .logSprite.icWhatsapp {\n    width: 13px;\n    height: 12px;\n    background-position: -157px -11px;\n  }\n\n  .logSprite.icInfoPink {\n    width: 18px;\n    height: 19px;\n    background-position: -131px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icEdit {\n    width: 17px;\n    height: 17px;\n    background-position: -157px -34px;\n    cursor: pointer;\n  }\n\n  .logSprite.icOrangeTick {\n    width: 23px;\n    height: 23px;\n    background-position: -179px -29px;\n    cursor: pointer;\n  }\n\n  .ldrShimmer {\n    animation-duration: 1.5s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: shimmer;\n    animation-timing-function: linear;\n    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n    background-size: 800px 104px;\n    position: relative;\n  }\n\n\n\n"])));

var Container = function Container(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    onClose = _ref.onClose,
    lobName = _ref.lobName,
    onLoginSuccess = _ref.onLoginSuccess,
    _ref$debug = _ref.debug,
    debug = _ref$debug === void 0 ? false : _ref$debug,
    _ref$isMobileNumberDi = _ref.isMobileNumberDisabled,
    isMobileNumberDisabled = _ref$isMobileNumberDi === void 0 ? false : _ref$isMobileNumberDi,
    _ref$skipMobileScreen = _ref.skipMobileScreen,
    skipMobileScreen = _ref$skipMobileScreen === void 0 ? false : _ref$skipMobileScreen,
    configData = _ref.configData;
  var _useState = (0,react.useState)(false),
    isOnClient = _useState[0],
    setIsOnClient = _useState[1];
  (0,react.useEffect)(function () {
    setIsOnClient(true);
  }, []);
  if (isOnClient) {
    var _initAnalytics = initAnalytics({
        lobName: lobName,
        debug: debug
      }),
      adobeInstance = _initAnalytics.adobeInstance;
    return /*#__PURE__*/react.createElement(styled_components_browser_esm.ThemeProvider, {
      theme: growth_app_theme_esm/* defaultTheme */.uH
    }, /*#__PURE__*/react.createElement(CommonSpriteStyle, null), /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(AuthContainer, {
      lobName: lobName,
      onLoginSuccess: onLoginSuccess,
      onClose: onClose,
      showCloseButton: showCloseButton,
      prefillMobileNumber: prefillMobileNumber,
      isMobileNumberDisabled: isMobileNumberDisabled,
      skipMobileScreen: skipMobileScreen,
      configData: configData
    })));
  }
  return null;
};




/***/ }),

/***/ 305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ CircularLoader; }
});

// UNUSED EXPORTS: FullPageLoaderMweb

;// CONCATENATED MODULE: ../../node_modules/@growth/loader/dist/taggedTemplateLiteralLoose-8a80a17d.esm.js
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../node_modules/@growth/loader/dist/growth-loader.esm.js




var _templateObject$1, _templateObject2$1;
var Loader = styled_components_browser_esm["default"].div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  width: 60px;\n  margin: 0 auto;\n  border-radius: 10px;\n  position: relative;\n  background: #d1e5ff;\n  height: 4px;\n  top: ", ";\n"])), function (props) {
  return props.top ? props.top : '12px';
});
var LoaderBar = styled_components_browser_esm["default"].div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  border-radius: 10px;\n  top: 0;\n  right: 100%;\n  bottom: 0;\n  left: 0;\n  background: #2276e3;\n  width: 0;\n  animation: borealisBar 1s linear infinite;\n\n  @keyframes borealisBar {\n    0% {\n      left: 0%;\n      right: 100%;\n      width: 0%;\n    }\n    10% {\n      left: 0%;\n      right: 54%;\n      width: 46%;\n    }\n    90% {\n      right: 54%;\n      width: 15%;\n    }\n    100% {\n      left: 100%;\n      right: 0%;\n      width: 0%;\n    }\n  }\n"])));

var FullPageLoaderMweb = function FullPageLoaderMweb(_ref) {
  var top = _ref.top;
  return /*#__PURE__*/react.createElement(Loader, {
    top: top
  }, /*#__PURE__*/react.createElement(LoaderBar, null));
};

FullPageLoaderMweb.defaultProps = {
  top: '200px'
};

var _templateObject, _templateObject2;
var LoaderWrap = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n"])));
var Spinner = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 22px;\n\theight: 22px;\n\tborder: solid 3px transparent;\n\tborder-top-color: #2276e3;\n\tborder-left-color: #2276e3;\n\tborder-right-color: #2276e3;\n\tborder-radius: 34px;\n\tanimation: loading-spinner 700ms linear infinite;\n\n\t@keyframes loading-spinner {\n\t\t0% {\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n"])));

var CircularLoader = function CircularLoader() {
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LoaderWrap, null, /*#__PURE__*/react.createElement(Spinner, null, "\xA0")));
};




/***/ }),

/***/ 810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ getQueryParam; }
/* harmony export */ });
/* unused harmony exports getAllQueryStrings, getLocationPathName, isMatchesCurrentHost, navigateWindowBack */
var getAllQueryStrings = function getAllQueryStrings() {
  var searchParams = new URLSearchParams(window.location.search);
  return searchParams;
};

var getQueryParam = function getQueryParam(param) {
  if (!param) {
    console.warn('Missing argument param for getQueryParam');
    return null;
  }

  var searchParams = getAllQueryStrings();
  if (searchParams && searchParams.get) return searchParams.get(param);
  return null;
};

var getLocationPathName = function getLocationPathName() {
  return window.location.pathname;
};

var isMatchesCurrentHost = function isMatchesCurrentHost(url, whileListedHost) {
  var currentHost = window.location.hostname;

  try {
    var matchHost = new URL(url).hostname;
    var isMatchHostWhitelisted = whileListedHost == null ? void 0 : whileListedHost.some(function (item) {
      return typeof item === 'string' ? item === matchHost : item.test(matchHost);
    });
    if (isMatchHostWhitelisted) return true;
    return currentHost === matchHost;
  } catch (_unused) {
    return false;
  }
};

var navigateWindowBack = function navigateWindowBack(opts) {
  var _ref = opts || {},
      beforeNavigate = _ref.beforeNavigate;

  var _document = document,
      referrer = _document.referrer;
  beforeNavigate == null ? void 0 : beforeNavigate();

  if (referrer && isMatchesCurrentHost(referrer)) {
    window.location.href = referrer;
  } else {
    window.location.href = '/';
  }
};




/***/ }),

/***/ 7106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I8": function() { return /* binding */ deepClone; },
/* harmony export */   "RH": function() { return /* binding */ deepMerge; },
/* harmony export */   "ks": function() { return /* binding */ removeEmptyValues; }
/* harmony export */ });
/* unused harmony exports isEmptyObject, safeParse, safeStringify */
/**
 *
 * @param obj
 *
 * return boolean
 *
 * this method check if object is empty or not
 */
var isEmptyObject = function isEmptyObject(obj) {
  if (obj) {
    return Object.keys(obj).length === 0;
  }

  return true;
};
/**
 *
 * @param obj1
 * @param originalPayload
 *
 * this function will update the original payload
 */


var deepMerge = function deepMerge(obj1, originalPayload) {
  if (isEmptyObject(obj1)) {
    return originalPayload || {};
  }

  var recurse = function recurse(obj, current) {
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      var newKey = current;

      if (newKey[key] && typeof newKey[key] === 'object') {
        recurse(value, newKey[key]); // it's a nested object, so do it again
      } else {
        newKey[key] = value; // it's not an object, so set the property
      }
    });
  };

  (function (obj) {
    return recurse(obj, originalPayload);
  })(obj1);

  return originalPayload;
};

function removeEmptyValues(obj) {
  var newObj = Array.isArray(obj) ? [] : {};
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      var value = removeEmptyValues(obj[key]);

      if (Object.keys(value).length !== 0 || Array.isArray(value) && value.length !== 0) {
        newObj[key] = value;
      }
    } else if (obj[key] !== '' && obj[key] !== null && obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}

var safeStringify = function safeStringify(o) {
  try {
    return JSON.stringify(o);
  } catch (e) {
    return '';
  }
};

var safeParse = function safeParse(s) {
  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
};

var deepClone = function deepClone(data) {
  if (typeof structuredClone === 'function') {
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
    try {
      return structuredClone(data);
    } catch (e) {
      return null;
    }
  }

  return safeParse(JSON.stringify(data));
};




/***/ }),

/***/ 3488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ pdtPush; }
/* harmony export */ });
/* unused harmony export pdtUpdate */
/* harmony import */ var _growth_location__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(810);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var pdtPush = function pdtPush(eventName, details) {
  if (details === void 0) {
    details = {};
  }

  window.pdtLayer = window.pdtLayer || [];
  var optsNew = {
    campaign_details: {
      campaign_name: (0,_growth_location__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)('utm_campaign') + "|" + (0,_growth_location__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)('utm_medium') + "|" + (0,_growth_location__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)('utm_source'),
      campaign_key: "utm_campaign|utm_medium|utm_source"
    }
  };
  window.pdtLayer.push(_extends({}, details, {
    event_detail: _extends({
      event_name: eventName,
      event_timestamp: Date.now()
    }, details.event_detail),
    campaign_details: _extends({}, details.campaign_details, optsNew.campaign_details)
  }));
};

var pdtUpdate = function pdtUpdate(opts) {
  var _window$__PdtInstance;

  if (opts) (_window$__PdtInstance = window.__PdtInstance__) == null ? void 0 : _window$__PdtInstance.update(opts);
};




/***/ }),

/***/ 1917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BK": function() { return /* binding */ isOnClient; },
/* harmony export */   "l_": function() { return /* binding */ getBaseHostName; }
/* harmony export */ });
/* unused harmony exports getHostPathName, getOriginUrl */
var globalAny = __webpack_require__.g;
/** Usage: Whether rendering is on client side or not */

var isOnClient = function f() {
  return typeof window !== 'undefined';
}();

var getBaseHostName = function getBaseHostName(hostname) {
  var host;
  host = '';

  if (isOnClient) {
    host = window.location.hostname;
  } else if (hostname) {
    host = hostname;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    host = globalAny == null ? void 0 : globalAny.hostname;
  }

  return host;
};

var getOriginUrl = function getOriginUrl() {
  var origin = '';

  if (isOnClient) {
    origin = window.location.origin;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    origin = globalAny == null ? void 0 : globalAny.origin;
  }

  return origin;
};

var getHostPathName = function getHostPathName() {
  var pathname = '';

  if (isOnClient) {
    pathname = window.location.pathname;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    pathname = globalAny == null ? void 0 : globalAny.pathname;
  }

  return pathname;
};




/***/ }),

/***/ 6880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DEFAULT_STATE; },
/* harmony export */   "x": function() { return /* binding */ fetchSetter; }
/* harmony export */ });
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchSetter = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var set, fetchFun, onError, onSuccess, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            set = _ref.set, fetchFun = _ref.fetchFun, onError = _ref.onError, onSuccess = _ref.onSuccess;
            set({
              loading: true
            });
            _context.prev = 2;
            _context.next = 5;
            return fetchFun();

          case 5:
            res = _context.sent;
            set(function (state) {
              return {
                data: _extends({}, state.data, res),
                loaded: true,
                loading: false,
                error: false
              };
            });
            onSuccess == null ? void 0 : onSuccess(res);
            return _context.abrupt("return", res);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            set({
              loaded: true,
              loading: false,
              error: _context.t0
            });
            onError == null ? void 0 : onError(_context.t0);

          case 15:
            return _context.abrupt("return", {});

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function fetchSetter(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var DEFAULT_STATE = {
  data: {},
  loading: false,
  loaded: false,
  error: null
};




/***/ }),

/***/ 7792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ToolTip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);



function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;
var Tooltip = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    padding: 10px;\n    border-radius: 6px;\n    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);\n    background-color: #fff;\n    position: absolute;\n    border: 1px solid #efefef;\n\n  .left::after,\n  .left::before {\n    bottom: 100%;\n    left: 20%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .left::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .left::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n  .right::after,\n  .right::before {\n    bottom: 100%;\n    left: 80%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .right::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .right::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n  .middle::after,\n  .middle::before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .middle::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .middle::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n"])));

var ToolTip = function ToolTip(props) {
  var customClass = props.customClass,
      notchPosition = props.notchPosition,
      customStyle = props.customStyle,
      children = props.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tooltip, {
    className: (customClass || '') + " " + (notchPosition || ''),
    style: customStyle
  }, children);
};




/***/ }),

/***/ 2390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nx": function() { return /* binding */ AnalyticsContextProvider; },
/* harmony export */   "z$": function() { return /* binding */ useAnalytics; }
/* harmony export */ });
/* unused harmony export analyticsState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var analyticsState = {
  ga: {
    initialize: function initialize() {},
    setUserVars: function setUserVars() {},
    track: function track() {}
  },
  pdt: {
    initialize: function initialize() {},
    setUserVars: function setUserVars() {},
    track: function track() {}
  },
  adobe: {
    initialize: function initialize() {
      return console.log('Adobe initialize is not available');
    },
    track: function track() {
      return console.log('Adobe track is not initialized');
    },
    pageView: function pageView() {
      return console.log('Adobe pageView is not initialized');
    }
  },
  analyticsTrackAll: function analyticsTrackAll() {}
};
var AnalyticsContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(analyticsState);

var AnalyticsContextProvider = function AnalyticsContextProvider(props) {
  var children = props.children,
      gaInstance = props.gaInstance,
      pdtInstance = props.pdtInstance,
      adobeInstance = props.adobeInstance;

  var analyticsTrackAll = function analyticsTrackAll(eventName, obj) {
    if (gaInstance) gaInstance.track(eventName, obj);
    if (pdtInstance) pdtInstance.track(eventName, obj);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AnalyticsContext.Provider, {
    value: {
      ga: gaInstance,
      pdt: pdtInstance,
      adobe: adobeInstance || analyticsState.adobe,
      analyticsTrackAll: analyticsTrackAll
    }
  }, children);
};

var useAnalytics = function useAnalytics() {
  var state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AnalyticsContext);
  return _extends({}, state);
};




/***/ }),

/***/ 6253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ isAndroidClient; },
/* harmony export */   "hf": function() { return /* binding */ getBrowserDetails; },
/* harmony export */   "qF": function() { return /* binding */ isIOSSafariBrowser; }
/* harmony export */ });
/* unused harmony exports ClientNames, getClientOS, getDeviceType, isIOSClient, isLightHouseAgent, isMobileDevice */
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


/* eslint-disable prefer-destructuring */
var ClientNames;

(function (ClientNames) {
  ClientNames["ANDROID"] = "android";
  ClientNames["IOS"] = "ios";
  ClientNames["SAFARI"] = "safari";
  ClientNames["LIGHTHOUSE"] = "lighthouse";
  ClientNames["OTHER"] = "other";
  ClientNames["LINUX"] = "linux";
  ClientNames["MAC"] = "mac";
  ClientNames["WINDOWS"] = "windows";
})(ClientNames || (ClientNames = {}));

var getClientOS = function getClientOS(userAgent) {
  /* const clientStrings = [
  		{ s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
  		{ s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
  		{ s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
  		{ s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
  		{ s: 'Windows Vista', r: /Windows NT 6.0/ },
  		{ s: 'Windows Server 2003', r: /Windows NT 5.2/ },
  		{ s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
  		{ s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
  		{ s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
  		{ s: 'Windows 98', r: /(Windows 98|Win98)/ },
  		{ s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
  		{ s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
  		{ s: 'Windows CE', r: /Windows CE/ },
  		{ s: 'Windows 3.11', r: /Win16/ },
  		{ s: 'Android', r: /Android/ },
  		{ s: 'Open BSD', r: /OpenBSD/ },
  		{ s: 'Sun OS', r: /SunOS/ },
  		{ s: 'Linux', r: /(Linux|X11)/ },
  		{ s: 'iOS', r: /(iPhone|iPad|iPod)/ },
  		{ s: 'Mac OS X', r: /Mac OS X/ },
  		{ s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
  		{ s: 'QNX', r: /QNX/ },
  		{ s: 'UNIX', r: /UNIX/ },
  		{ s: 'BeOS', r: /BeOS/ },
  		{ s: 'OS/2', r: /OS\/2/ },
  		{ s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
  	];
  */
  var ua = userAgent || '';
  if (_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK && !ua) ua = window.navigator.userAgent || window.navigator.vendor; // add more if requires
  // ...

  if (/Android/.test(ua)) return ClientNames.ANDROID;
  if (/(iPhone|iPad|iPod)/.test(ua)) return ClientNames.IOS;
  if (/iPhone|iPad|iPod/.test(ua) && /Safari/.test(ua)) return ClientNames.SAFARI;
  if (/Linux/i.test(ua)) return ClientNames.LINUX;
  if (/Mac/i.test(ua)) return ClientNames.MAC;
  if (/Windows/i.test(ua)) return ClientNames.WINDOWS;
  return ClientNames.OTHER;
};

var isIOSClient = function isIOSClient(userAgent) {
  return getClientOS(userAgent) === ClientNames.IOS;
};

var isAndroidClient = function isAndroidClient(userAgent) {
  return getClientOS(userAgent) === ClientNames.ANDROID;
};

var isIOSSafariBrowser = function isIOSSafariBrowser(userAgent) {
  return getClientOS(userAgent) === ClientNames.SAFARI;
};

var isLightHouseAgent = function isLightHouseAgent(userAgent) {
  var ua = userAgent;
  if (isOnClient && !userAgent) ua = window.navigator.userAgent || window.navigator.vendor;

  if (typeof ua === 'string') {
    return /Chrome-Lighthouse/.test(ua);
  }

  return false;
};

var getDeviceType = function getDeviceType() {
  if (isIOSClient()) return ClientNames.IOS;
  if (isAndroidClient()) return ClientNames.ANDROID;
  return ClientNames.OTHER;
};

var getBrowserDetails = function getBrowserDetails() {
  var _navigator = navigator,
      userAgent = _navigator.userAgent;
  var browserName;
  var browserVersion;

  if (/opera|opr/i.test(userAgent)) {
    // Opera browser
    browserName = 'Opera';
    var operaVersion = userAgent.match(/(?:opera|opr)[\s/](\d+(\.\d+)?)/i);

    if (operaVersion) {
      browserVersion = operaVersion[1];
    }
  } else if (/edge|edg/i.test(userAgent)) {
    // Microsoft Edge browser
    browserName = 'Microsoft Edge';
    var edgeVersion = userAgent.match(/(?:edge|edg)\/(\d+(\.\d+)?)/i);

    if (edgeVersion) {
      browserVersion = edgeVersion[1];
    }
  } else if (/chrome|crios/i.test(userAgent)) {
    // Chrome browser
    browserName = 'Chrome';
    var chromeVersion = userAgent.match(/(?:chrome|crios)\/(\d+(\.\d+)?)/i);

    if (chromeVersion) {
      browserVersion = chromeVersion[1];
    }
  } else if (/safari/i.test(userAgent)) {
    // Safari browser
    browserName = 'Safari';
    var safariVersion = userAgent.match(/version\/(\d+(\.\d+)?)/i);

    if (safariVersion) {
      browserVersion = safariVersion[1];
    }
  } else if (/firefox|fxios/i.test(userAgent)) {
    // Firefox browser
    browserName = 'Firefox';
    var firefoxVersion = userAgent.match(/(?:firefox|fxios)\/(\d+(\.\d+)?)/i);

    if (firefoxVersion) {
      browserVersion = firefoxVersion[1];
    }
  } else if (/msie|trident/i.test(userAgent)) {
    // Internet Explorer browser
    browserName = 'Internet Explorer';
    var ieVersion = userAgent.match(/(?:msie |rv:)(\d+(\.\d+)?)/i);

    if (ieVersion) {
      browserVersion = ieVersion[1];
    }
  } else {
    browserName = 'Unknown';
    browserVersion = 'Unknown';
  }

  return {
    browserName: browserName,
    browserVersion: browserVersion
  };
};

var isMobileDevice = function isMobileDevice(userAgent) {
  return /Mobi/i.test(userAgent || window.navigator.userAgent);
};




/***/ }),

/***/ 6939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "im": function() { return /* reexport */ helper_bc63c3dd_esm_generateVid; },
  "MI": function() { return /* binding */ getVisitorIdBrowser; }
});

// UNUSED EXPORTS: config, visitorIdBrowser

// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
;// CONCATENATED MODULE: ../../node_modules/@growth/visitor-id/dist/helper-bc63c3dd.esm.js
// constant
var helper_bc63c3dd_esm_C = {
  CookieName: '__gi_vid',
  MaxAgeDay: 365,
  // 1 year
  Domain: '.goibibo.com'
}; // vid generator function

var helper_bc63c3dd_esm_generateVid = function generateVid() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    /* eslint-disable-next-line no-bitwise */
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    /* eslint-disable-next-line no-bitwise */

    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js




function visitorIdBrowser(options) {
  var opts = options || {}; // if vid cookie is present

  if (getItem(C.CookieName)) {
    if (opts.debug) console.info('DEBUG visitorIdBrowser: visitorId cookie is already present in browser');
    return true;
  } // if vid is not present in cookie


  var vid = generateVid();
  setItem(C.CookieName, vid, {
    expires: C.MaxAgeDay * 24 * 60 * 60,
    path: "/",
    domain: C.Domain,
    secure: true
  });
  if (opts.debug) console.info('DEBUG visitorIdBrowser: new visitorId cookie has been set to browser');
  return true;
}

var getVisitorIdBrowser = function getVisitorIdBrowser() {
  var vid = (0,growth_cookies_esm/* getItem */.rV)(helper_bc63c3dd_esm_C.CookieName);
  return vid || undefined;
};




/***/ }),

/***/ 2019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebAnalytics; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var WebAnalytics = /*#__PURE__*/function () {
  function WebAnalytics() {}

  var _proto = WebAnalytics.prototype;

  // ! a not null assertion
  _proto.initialize = function initialize(O) {
    this.plugin = O.plugin;
    this.eventNames = O.eventNames;
    this.globalProperties = O.globalProperties;
    this.debug = O.debug;
    this.globalVars = _extends({}, O.globalProperties);
    this.plugin.init();
  };

  _proto.setUserVars = function setUserVars(globalVars) {
    this.globalVars = _extends({}, this.globalVars, globalVars);
    return this.globalVars;
  };

  _proto.track = function track(eventName, properties) {
    try {
      if (!eventName || typeof eventName !== 'string') {
        throw new TypeError('eventName is missing or invalid in webAnalytics().track()');
      }

      if (this.eventNames && !this.eventNames.has(eventName)) {
        throw new TypeError("unknown track webAalyticsEventName \"" + eventName + "\"");
      }

      if (this.debug) {
        /* eslint-disable-next-line no-console */
        console.log("webAnalytics " + this.plugin.name, 'track', {
          event: eventName,
          eventProperties: properties,
          globalProperties: this.globalVars
        });
      }

      var payload = {
        event: eventName,
        eventProperties: properties,
        globalProperties: this.globalVars
      };
      return this.plugin.track({
        payload: payload
      });
    } catch (e) {
      if (this.debug) console.log(e);
      return e;
    }
  };

  _proto.pageView = function pageView(pageName, properties) {
    if (!this.plugin.pageView) {
      throw new Error(this.plugin.name + " plugin does not support pageView property");
    }

    if (!pageName) {
      throw new Error('pageName is mandatory to send page view event');
    }

    var payload = {
      eventProperties: _extends({}, properties),
      globalProperties: this.globalVars
    };

    if (this.debug) {
      /* eslint-disable-next-line no-console */
      console.log("webAnalytics " + this.plugin.name, 'page', _extends({}, payload));
    }

    if (this.plugin.pageView) this.plugin.pageView(pageName, payload);
  };

  return WebAnalytics;
}();




/***/ }),

/***/ 9984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADDRESS_LINE_MAX_LENGTH": function() { return /* binding */ ADDRESS_LINE_MAX_LENGTH; },
/* harmony export */   "ADDRESS_LINE_MIN_LENGTH": function() { return /* binding */ ADDRESS_LINE_MIN_LENGTH; },
/* harmony export */   "AuthContainer": function() { return /* binding */ AuthContainer; },
/* harmony export */   "BFF_BASE_URL": function() { return /* binding */ BFF_BASE_URL; },
/* harmony export */   "BREAKPOINTS": function() { return /* binding */ BREAKPOINTS; },
/* harmony export */   "CN_ADD_CURRENCY_PAGE_PATH": function() { return /* binding */ CN_ADD_CURRENCY_PAGE_PATH; },
/* harmony export */   "CN_ADD_TRAVEL_DETAILS_PAGE_PATH": function() { return /* binding */ CN_ADD_TRAVEL_DETAILS_PAGE_PATH; },
/* harmony export */   "CouponDetailsBottomSheet": function() { return /* binding */ CouponDetailsBottomSheet; },
/* harmony export */   "DEFAULT_CITY_CODE": function() { return /* binding */ DEFAULT_CITY_CODE; },
/* harmony export */   "DEFAULT_CURRENCY_CODE": function() { return /* binding */ DEFAULT_CURRENCY_CODE; },
/* harmony export */   "DEVICE": function() { return /* binding */ DEVICE; },
/* harmony export */   "DeliveryPersuasion": function() { return /* binding */ DeliveryPersuasion; },
/* harmony export */   "ERROR_MSGS": function() { return /* binding */ ERROR_MSGS; },
/* harmony export */   "FALLBACK_CURRENCY": function() { return /* binding */ FALLBACK_CURRENCY; },
/* harmony export */   "FormValidation": function() { return /* binding */ FormValidation; },
/* harmony export */   "HEADERS": function() { return /* binding */ HEADERS; },
/* harmony export */   "LOCATION_DETECTION_SOURCE": function() { return /* binding */ LOCATION_DETECTION_SOURCE; },
/* harmony export */   "PAYMENT_MODE": function() { return /* binding */ PAYMENT_MODE; },
/* harmony export */   "PC_ADD_CURRENCY_PAGE_PATH": function() { return /* binding */ PC_ADD_CURRENCY_PAGE_PATH; },
/* harmony export */   "PC_ADD_TRAVEL_DETAILS_PAGE_PATH": function() { return /* binding */ PC_ADD_TRAVEL_DETAILS_PAGE_PATH; },
/* harmony export */   "PERSUASION_TYPE": function() { return /* binding */ PERSUASION_TYPE; },
/* harmony export */   "PRODUCT_TYPE": function() { return /* binding */ PRODUCT_TYPE; },
/* harmony export */   "PROGRAM_FLOW_TYPE": function() { return /* binding */ PROGRAM_FLOW_TYPE; },
/* harmony export */   "QUERY_PARAM_KEYS": function() { return /* binding */ QUERY_PARAM_KEYS; },
/* harmony export */   "REDIRECTION_DEFER_TIME": function() { return /* binding */ REDIRECTION_DEFER_TIME; },
/* harmony export */   "REDIRECTION_SOURCE": function() { return /* binding */ REDIRECTION_SOURCE; },
/* harmony export */   "RTVars": function() { return /* binding */ RTVars; },
/* harmony export */   "SESSION_STORAGE_KEYS": function() { return /* binding */ SESSION_STORAGE_KEYS; },
/* harmony export */   "SelectCurrencyModal": function() { return /* binding */ SelectCurrencyModal; },
/* harmony export */   "TOAST_MESSAGES": function() { return /* binding */ TOAST_MESSAGES; },
/* harmony export */   "TOAST_RIGHT_TEXT": function() { return /* binding */ TOAST_RIGHT_TEXT; },
/* harmony export */   "calculateForexTaxes": function() { return /* binding */ calculateForexTaxes; },
/* harmony export */   "countryData": function() { return /* binding */ countryData; },
/* harmony export */   "deviceType": function() { return /* binding */ deviceType; },
/* harmony export */   "getServiceCharge": function() { return /* binding */ getServiceCharge; },
/* harmony export */   "getServiceChargeRange": function() { return /* binding */ getServiceChargeRange; },
/* harmony export */   "getTotalCurrencyValue": function() { return /* binding */ getTotalCurrencyValue; },
/* harmony export */   "getTotalPayabaleAmount": function() { return /* binding */ getTotalPayabaleAmount; },
/* harmony export */   "getTotalTaxes": function() { return /* binding */ getTotalTaxes; },
/* harmony export */   "getTransformedLocationDataFromSessionStorage": function() { return /* binding */ getTransformedLocationDataFromSessionStorage; },
/* harmony export */   "setTransformedLocationDataToSessionStorage": function() { return /* binding */ setTransformedLocationDataToSessionStorage; },
/* harmony export */   "useAuthentication": function() { return /* binding */ useAuthentication; },
/* harmony export */   "useDevice": function() { return /* binding */ useDevice; },
/* harmony export */   "useGeoLocation": function() { return /* binding */ useGeoLocation; },
/* harmony export */   "useOutsideClick": function() { return /* binding */ useOutsideClick; }
/* harmony export */ });
/* harmony import */ var _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4178);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);
/* harmony import */ var _lib_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5618);
/* harmony import */ var _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8772);
/* harmony import */ var _forex_pdt_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* provided dependency */ var process = __webpack_require__(4406);









const BREAKPOINTS = {
  MOBILE: 768,
  DESKTOP: 769
};
const DEVICE = {
  MOBILE: 'sm',
  DESKTOP: 'lg'
};
const HEADERS = {
  REQUEST_ID: 'request-id'
};
var LOCATION_DETECTION_SOURCE;
(function (LOCATION_DETECTION_SOURCE) {
  LOCATION_DETECTION_SOURCE["COORDINATES"] = "LATLNG";
  LOCATION_DETECTION_SOURCE["PINCODE"] = "PINCODE";
  LOCATION_DETECTION_SOURCE["CITY_FALLBACK"] = "CITY_FALLBACK";
})(LOCATION_DETECTION_SOURCE || (LOCATION_DETECTION_SOURCE = {}));
const ADDRESS_LINE_MAX_LENGTH = 150;
const ADDRESS_LINE_MIN_LENGTH = 5;
const ERROR_MSGS = {
  UNABLE_TO_FETCH_LOC: 'We are unable to fetch your location at the moment. Please allow lcoation permission from device settings or enter pincode manually to proceed.',
  FAILED_TO_FETCH_LOC: 'We failed to fetch your location. Please try again in some time.',
  GEOLOCATION_NOT_SUPPORTED: 'Geolocation not supported',
  FETCH_ERROR: 'Failed to fetch',
  REQUIRED_FIELD: '*Required Field',
  CURRENCY_UNAVAILABLE: 'Selected currency is unavailable right now. Sorry for the trouble. Please try again later',
  VALID_PINCODE_ERROR: 'Enter a valid 6 digit pincode',
  MAX_AMOUNT_ERROR: 'Max amount exceeded',
  GEOLOCATION_PERMISSION_DENIED: 'We are unable to fetch your location. Please allow location permission from browser and system settings or enter pincode manually to proceed.',
  GEOLOCATION_PERMISSION_POPUP_OPENED: 'We are unable to fetch your location. Please allow location permission from browser and system settings or enter pincode manually to proceed.',
  GEOLOCATION_POSITION_UNAVAILABLE: 'We failed to fetch your location. Please enter pincode manually to proceed.',
  GEOLOCATION_TIMEOUT: 'We failed to fetch your location. Please try again.'
};
const TOAST_RIGHT_TEXT = {
  OKAY: 'OKAY'
};
const TOAST_MESSAGES = {
  RATE_UPDATE: 'Updating Rates...',
  LOCATION_UPDATE: 'Updating Location...',
  CURRENCY_UPDATE: 'Updating Currency...',
  LOCATION_NOT_SERVICEABLE: 'Your location is currently not serviceable, please try another location pincode to proceed.',
  CURRENCY_NOT_SERVICEABLE: 'The selected currency is currently unavailable at your location. Alternatively, you can proceed with {{FALLBACK_CURRENCY}} or try another pin code.​',
  CURRENCY_ALREADY_ADDED: 'Currency is already added.',
  SELECTED_CURRENCY_NOT_AVAILABLE: 'Selected Currency is not available right now. Please try again later. Sorry for the trouble.',
  MAX_CURRENCY_LIMIT: 'You have reached the maximum limit of 5 currencies. Please remove one currency to add a new one.',
  MAX_COUNTRY_LIMIT: 'You can select a maximum of 5 countries',
  MIN_ORDER_AMOUNT_ERROR: minOrderAmount => `Please add min ₹${minOrderAmount} to apply this offer`,
  ADDRESS_LENGTH_ERROR: `Address length should be greater than ${ADDRESS_LINE_MIN_LENGTH} and less than ${ADDRESS_LINE_MAX_LENGTH} characters`,
  ADD_AT_LEAST_ONE_CURRENCY: 'Please add at least one currency to proceed.',
  ALREADY_ADDED_CURRENCY: 'Selected currency is not unavailable. You can add USD/EUR and convert it to your local currency at your destination.'
};
const PC_ADD_CURRENCY_PAGE_PATH = `/pc/funnel/add-currency`;
const CN_ADD_CURRENCY_PAGE_PATH = `/cn/funnel/add-currency`;
const PC_ADD_TRAVEL_DETAILS_PAGE_PATH = `/pc/funnel/add-traveller`;
const CN_ADD_TRAVEL_DETAILS_PAGE_PATH = `/cn/funnel/add-traveller`;
const DEFAULT_CURRENCY_CODE = 'USD';
const DEFAULT_CITY_CODE = 'DEL';
var RTVars;
(function (RTVars) {
  RTVars["CURRENCY_CODE"] = "VARS_CURRENCY_CODE";
  RTVars["RECOM_AMOUNT"] = "VARS_RECOMMENDED_AMOUNT";
  RTVars["MIN_AMOUNT"] = "VARS_FROM_CURRENCY";
  RTVars["SEARCHED_CURRENCY"] = "VARS_SEARCHED_CURRENCY";
  RTVars["SUGGESTED_CURRENCY"] = "VARS_SUGGESTED_CURRENCY";
  RTVars["NER_RATE"] = "VARS_NER_RATE";
  RTVars["NER_AMOUNT"] = "VARS_NER_AMOUNT";
  RTVars["CASHBACK"] = "VARS_CASHBACK";
  RTVars["CURR_QTY"] = "VARS_CURR_QTY";
  RTVars["UPTO"] = "VARS_OPERATOR";
  RTVars["NER"] = "VARS_NER";
  RTVars["QTY"] = "VARS_QTY";
  RTVars["SAVINGS"] = "VARS_SAVINGS";
  RTVars["CURRENCY_AMT"] = "VARS_CURRENCY_AMT";
  RTVars["INR_VALUE"] = "VARS_INR_VALUE";
  RTVars["COST"] = "VARS_COST";
  RTVars["VARS_MAX_CASHBACK"] = "VARS_MAX_CASHBACK";
  RTVars["VARS_CASHBACK_AMOUNT"] = "VARS_CASHBACK_AMOUNT";
  RTVars["VARS_NER_EFFECTIVE_PRICE"] = "VARS_NER_EFFECTIVE_PRICE";
  RTVars["CURRENCY_NAME"] = "VARS_CURR_NAME";
  RTVars["RECOMMENDED_CURRENCY_NAME"] = "VARS_RECOMMENDED_CURR_NAME";
  RTVars["RECOMMENDED_CURRENCY_RATE"] = "VARS_RECOMMENDED_CURR_RATE";
  RTVars["RECOMMENDED_CURRENCY_CODE"] = "VARS_RECOMMENDED_CURR_CODE";
  RTVars["VARS_NET_PRICE"] = "VARS_NET_PRICE";
})(RTVars || (RTVars = {}));
var PRODUCT_TYPE;
(function (PRODUCT_TYPE) {
  PRODUCT_TYPE["CARD"] = "PC";
  PRODUCT_TYPE["CURRENCY"] = "CN";
})(PRODUCT_TYPE || (PRODUCT_TYPE = {}));
const REDIRECTION_SOURCE = {
  ADD_CURRENCY_DEEP_LOGIN: 'ADD_CURRENCY_DEEP_LOGIN',
  LISTING_BUY_NOW: 'LISTING_BUY_NOW',
  LISTING_RESUME_ORDER: 'LISTING_RESUME_ORDER'
};
var PAYMENT_MODE;
(function (PAYMENT_MODE) {
  PAYMENT_MODE["POD"] = "POD";
  PAYMENT_MODE["FULL"] = "FULL";
})(PAYMENT_MODE || (PAYMENT_MODE = {}));
var PROGRAM_FLOW_TYPE;
(function (PROGRAM_FLOW_TYPE) {
  PROGRAM_FLOW_TYPE["CURRENCY"] = "currency_flow";
  PROGRAM_FLOW_TYPE["CARD"] = "card_flow";
  PROGRAM_FLOW_TYPE["FREE_CARD"] = "free_card_flow";
})(PROGRAM_FLOW_TYPE || (PROGRAM_FLOW_TYPE = {}));
const PERSUASION_TYPE = {
  UNAVAILABLE_PRODUCT_PC: 'UNAVAILABLE_PRODUCT_PC',
  UNSUPPORTED_PRODUCT_PC: 'UNSUPPORTED_PRODUCT_PC',
  UNSUPPORTED_PRODUCT_WITH_FWD_ACTION_PC: 'UNSUPPORTED_PRODUCT_WITH_FWD_ACTION_PC'
};
const FALLBACK_CURRENCY = {
  USD: 'USD',
  EUR: 'EUR'
};
const SESSION_STORAGE_KEYS = {
  USER_LOCATION_SESSION_KEY: 'user_location',
  REQUEST_ID: 'request_id',
  IS_FALLBACK_CITY_MODE: 'is_fallback_city_mode',
  ITINERARY_ID: 'itinerary_id',
  TICKET_ID: 'ticket_id',
  FOREX_EXPERIMENTS: 'forex_experiments',
  SOURCE_REACT_NATIVE: 'rn',
  CITY: 'city',
  CITY_CODE: 'cityCode',
  PINCODE: 'pincode',
  FUNNEL_FORM_DATA: 'funnel_form_data'
};
const QUERY_PARAM_KEYS = {
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  USER_LOCATION: 'user_location'
};
const BFF_BASE_URL = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.isHostMMT)() ? 'https://forex-gw.makemytrip.com/bff' // 'http://localhost:3333/bff'
: 'https://forex-gw.goibibo.com/bff'; // 'http://localhost:3333/bff'
const countryData = {
  success: true,
  data: [{
    id: 'POPULAR_COUNTRY',
    title: [{
      type: 'text',
      typography: 'labelBaseW3',
      text: 'Popular Countries',
      color: '#000000'
    }],
    list: [{
      countryName: 'United States',
      countryCode: 'USA',
      isDisabled: false
    }, {
      countryName: 'United Arab Emirates',
      countryCode: 'ARE',
      isDisabled: false
    }, {
      countryName: 'Thailand',
      countryCode: 'THA',
      isDisabled: false
    }, {
      countryName: 'Singapore',
      countryCode: 'SGP',
      isDisabled: false
    }, {
      countryName: 'France',
      countryCode: 'FRA',
      isDisabled: false
    }]
  }, {
    id: 'ALL_COUNTRY',
    title: [{
      type: 'text',
      typography: 'labelBaseW3',
      text: 'All Countries',
      color: '#000000'
    }],
    list: [{
      countryName: 'Afghanistan',
      countryCode: 'AFG',
      isDisabled: false
    }, {
      countryName: 'Albania',
      countryCode: 'ALB',
      isDisabled: false
    }, {
      countryName: 'Algeria',
      countryCode: 'DZA',
      isDisabled: false
    }, {
      countryName: 'Angola',
      countryCode: 'AGO',
      isDisabled: false
    }, {
      countryName: 'Antigua and Barbuda',
      countryCode: 'ATG',
      isDisabled: false
    }, {
      countryName: 'Argentina',
      countryCode: 'ARG',
      isDisabled: false
    }, {
      countryName: 'Armenia',
      countryCode: 'ARM',
      isDisabled: false
    }, {
      countryName: 'Aruba',
      countryCode: 'ABW',
      isDisabled: false
    }, {
      countryName: 'Australia',
      countryCode: 'AUS',
      isDisabled: false
    }, {
      countryName: 'Austria',
      countryCode: 'AUT',
      isDisabled: false
    }, {
      countryName: 'Azerbaijan',
      countryCode: 'AZE',
      isDisabled: false
    }, {
      countryName: 'Bahamas',
      countryCode: 'BHS',
      isDisabled: false
    }, {
      countryName: 'Bahrain',
      countryCode: 'BHR',
      isDisabled: false
    }, {
      countryName: 'Bangladesh',
      countryCode: 'BGD',
      isDisabled: false
    }, {
      countryName: 'Barbados',
      countryCode: 'BRB',
      isDisabled: false
    }, {
      countryName: 'Belgium',
      countryCode: 'BEL',
      isDisabled: false
    }, {
      countryName: 'Belize',
      countryCode: 'BLZ',
      isDisabled: false
    }, {
      countryName: 'Benin',
      countryCode: 'BEN',
      isDisabled: false
    }, {
      countryName: 'Bermuda',
      countryCode: 'BMU',
      isDisabled: false
    }, {
      countryName: 'Bolivia',
      countryCode: 'BOL',
      isDisabled: false
    }, {
      countryName: 'Botswana',
      countryCode: 'BWA',
      isDisabled: false
    }, {
      countryName: 'Brazil',
      countryCode: 'BRA',
      isDisabled: false
    }, {
      countryName: 'Bulgaria',
      countryCode: 'BGR',
      isDisabled: false
    }, {
      countryName: 'Burkina Faso',
      countryCode: 'BFA',
      isDisabled: false
    }, {
      countryName: 'Burundi',
      countryCode: 'BDI',
      isDisabled: false
    }, {
      countryName: 'Canada',
      countryCode: 'CAN',
      isDisabled: false
    }, {
      countryName: 'Cape Verde',
      countryCode: 'CPV',
      isDisabled: false
    }, {
      countryName: 'Chad',
      countryCode: 'TCD',
      isDisabled: false
    }, {
      countryName: 'Chile',
      countryCode: 'CHL',
      isDisabled: false
    }, {
      countryName: 'China',
      countryCode: 'CHN',
      isDisabled: false
    }, {
      countryName: 'Colombia',
      countryCode: 'COL',
      isDisabled: false
    }, {
      countryName: 'Comoros',
      countryCode: 'COM',
      isDisabled: false
    }, {
      countryName: 'Costa Rica',
      countryCode: 'CRI',
      isDisabled: false
    }, {
      countryName: 'Croatia',
      countryCode: 'HRV',
      isDisabled: false
    }, {
      countryName: 'Cyprus',
      countryCode: 'CYP',
      isDisabled: false
    }, {
      countryName: 'Czech Republic',
      countryCode: 'CZE',
      isDisabled: false
    }, {
      countryName: 'Denmark',
      countryCode: 'DNK',
      isDisabled: false
    }, {
      countryName: 'Djibouti',
      countryCode: 'DJI',
      isDisabled: false
    }, {
      countryName: 'Dominica',
      countryCode: 'DMA',
      isDisabled: false
    }, {
      countryName: 'Dominican Republic',
      countryCode: 'DOM',
      isDisabled: false
    }, {
      countryName: 'East Timor',
      countryCode: 'TLS',
      isDisabled: false
    }, {
      countryName: 'Ecuador',
      countryCode: 'ECU',
      isDisabled: false
    }, {
      countryName: 'Egypt',
      countryCode: 'EGY',
      isDisabled: false
    }, {
      countryName: 'El Salvador',
      countryCode: 'SLV',
      isDisabled: false
    }, {
      countryName: 'Equatorial Guinea',
      countryCode: 'GNQ',
      isDisabled: false
    }, {
      countryName: 'Eritrea',
      countryCode: 'ERI',
      isDisabled: false
    }, {
      countryName: 'Estonia',
      countryCode: 'EST',
      isDisabled: false
    }, {
      countryName: 'Ethiopia',
      countryCode: 'ETH',
      isDisabled: false
    }, {
      countryName: 'Fiji',
      countryCode: 'FJI',
      isDisabled: false
    }, {
      countryName: 'Finland',
      countryCode: 'FIN',
      isDisabled: false
    }, {
      countryName: 'Gabon',
      countryCode: 'GAB',
      isDisabled: false
    }, {
      countryName: 'Gambia',
      countryCode: 'GMB',
      isDisabled: false
    }, {
      countryName: 'Georgia',
      countryCode: 'GEO',
      isDisabled: false
    }, {
      countryName: 'Germany',
      countryCode: 'DEU',
      isDisabled: false
    }, {
      countryName: 'Ghana',
      countryCode: 'GHA',
      isDisabled: false
    }, {
      countryName: 'Greece',
      countryCode: 'GRC',
      isDisabled: false
    }, {
      countryName: 'Grenada',
      countryCode: 'GRD',
      isDisabled: false
    }, {
      countryName: 'Guatemala',
      countryCode: 'GTM',
      isDisabled: false
    }, {
      countryName: 'Guinea',
      countryCode: 'GIN',
      isDisabled: false
    }, {
      countryName: 'Guyana',
      countryCode: 'GUY',
      isDisabled: false
    }, {
      countryName: 'Haiti',
      countryCode: 'HTI',
      isDisabled: false
    }, {
      countryName: 'Honduras',
      countryCode: 'HND',
      isDisabled: false
    }, {
      countryName: 'Hong Kong',
      countryCode: 'HKG',
      isDisabled: false
    }, {
      countryName: 'Hungary',
      countryCode: 'HUN',
      isDisabled: false
    }, {
      countryName: 'Iceland',
      countryCode: 'ISL',
      isDisabled: false
    }, {
      countryName: 'Indonesia',
      countryCode: 'IDN',
      isDisabled: false
    }, {
      countryName: 'Ireland',
      countryCode: 'IRL',
      isDisabled: false
    }, {
      countryName: 'Israel',
      countryCode: 'ISR',
      isDisabled: false
    }, {
      countryName: 'Italy',
      countryCode: 'ITA',
      isDisabled: false
    }, {
      countryName: 'Jamaica',
      countryCode: 'JAM',
      isDisabled: false
    }, {
      countryName: 'Japan',
      countryCode: 'JPN',
      isDisabled: false
    }, {
      countryName: 'Jordan',
      countryCode: 'JOR',
      isDisabled: false
    }, {
      countryName: 'Kazakhstan',
      countryCode: 'KAZ',
      isDisabled: false
    }, {
      countryName: 'Kenya',
      countryCode: 'KEN',
      isDisabled: false
    }, {
      countryName: 'Kiribati',
      countryCode: 'KIR',
      isDisabled: false
    }, {
      countryName: 'Kuwait',
      countryCode: 'KWT',
      isDisabled: false
    }, {
      countryName: 'Laos',
      countryCode: 'LAO',
      isDisabled: false
    }, {
      countryName: 'Latvia',
      countryCode: 'LVA',
      isDisabled: false
    }, {
      countryName: 'Lebanon',
      countryCode: 'LBN',
      isDisabled: false
    }, {
      countryName: 'Lesotho',
      countryCode: 'LSO',
      isDisabled: false
    }, {
      countryName: 'Liberia',
      countryCode: 'LBR',
      isDisabled: false
    }, {
      countryName: 'Libya',
      countryCode: 'LBY',
      isDisabled: false
    }, {
      countryName: 'Lithuania',
      countryCode: 'LTU',
      isDisabled: false
    }, {
      countryName: 'Luxembourg',
      countryCode: 'LUX',
      isDisabled: false
    }, {
      countryName: 'Macau',
      countryCode: 'MAC',
      isDisabled: false
    }, {
      countryName: 'Macedonia',
      countryCode: 'MKD',
      isDisabled: false
    }, {
      countryName: 'Madagascar',
      countryCode: 'MDG',
      isDisabled: false
    }, {
      countryName: 'Malawi',
      countryCode: 'MWI',
      isDisabled: false
    }, {
      countryName: 'Malaysia',
      countryCode: 'MYS',
      isDisabled: false
    }, {
      countryName: 'Maldives',
      countryCode: 'MDV',
      isDisabled: false
    }, {
      countryName: 'Mali',
      countryCode: 'MLI',
      isDisabled: false
    }, {
      countryName: 'Malta',
      countryCode: 'MLT',
      isDisabled: false
    }, {
      countryName: 'Marshall Islands',
      countryCode: 'MHL',
      isDisabled: false
    }, {
      countryName: 'Mauritania',
      countryCode: 'MRT',
      isDisabled: false
    }, {
      countryName: 'Mauritius',
      countryCode: 'MUS',
      isDisabled: false
    }, {
      countryName: 'Mexico',
      countryCode: 'MEX',
      isDisabled: false
    }, {
      countryName: 'Micronesia',
      countryCode: 'FSM',
      isDisabled: false
    }, {
      countryName: 'Moldova',
      countryCode: 'MDA',
      isDisabled: false
    }, {
      countryName: 'Monaco',
      countryCode: 'MCO',
      isDisabled: false
    }, {
      countryName: 'Mongolia',
      countryCode: 'MNG',
      isDisabled: false
    }, {
      countryName: 'Montenegro',
      countryCode: 'MNE',
      isDisabled: false
    }, {
      countryName: 'Montserrat',
      countryCode: 'MSR',
      isDisabled: false
    }, {
      countryName: 'Morocco',
      countryCode: 'MAR',
      isDisabled: false
    }, {
      countryName: 'Mozambique',
      countryCode: 'MOZ',
      isDisabled: false
    }, {
      countryName: 'Myanmar',
      countryCode: 'MMR',
      isDisabled: false
    }, {
      countryName: 'Namibia',
      countryCode: 'NAM',
      isDisabled: false
    }, {
      countryName: 'Nauru',
      countryCode: 'NRU',
      isDisabled: false
    }, {
      countryName: 'Netherlands',
      countryCode: 'NLD',
      isDisabled: false
    }, {
      countryName: 'New Zealand',
      countryCode: 'NZL',
      isDisabled: false
    }, {
      countryName: 'Nicaragua',
      countryCode: 'NIC',
      isDisabled: false
    }, {
      countryName: 'Niger',
      countryCode: 'NER',
      isDisabled: false
    }, {
      countryName: 'Nigeria',
      countryCode: 'NGA',
      isDisabled: false
    }, {
      countryName: 'Norway',
      countryCode: 'NOR',
      isDisabled: false
    }, {
      countryName: 'Oman',
      countryCode: 'OMN',
      isDisabled: false
    }, {
      countryName: 'Pakistan',
      countryCode: 'PAK',
      isDisabled: false
    }, {
      countryName: 'Palau',
      countryCode: 'PLW',
      isDisabled: false
    }, {
      countryName: 'Panama',
      countryCode: 'PAN',
      isDisabled: false
    }, {
      countryName: 'Papua New Guinea',
      countryCode: 'PNG',
      isDisabled: false
    }, {
      countryName: 'Paraguay',
      countryCode: 'PRY',
      isDisabled: false
    }, {
      countryName: 'Peru',
      countryCode: 'PER',
      isDisabled: false
    }, {
      countryName: 'Philippines',
      countryCode: 'PHL',
      isDisabled: false
    }, {
      countryName: 'Poland',
      countryCode: 'POL',
      isDisabled: false
    }, {
      countryName: 'Portugal',
      countryCode: 'PRT',
      isDisabled: false
    }, {
      countryName: 'Qatar',
      countryCode: 'QAT',
      isDisabled: false
    }, {
      countryName: 'Romania',
      countryCode: 'ROU',
      isDisabled: false
    }, {
      countryName: 'Russia',
      countryCode: 'RUS',
      isDisabled: false
    }, {
      countryName: 'Rwanda',
      countryCode: 'RWA',
      isDisabled: false
    }, {
      countryName: 'Saint Kitts and Nevis',
      countryCode: 'KNA',
      isDisabled: false
    }, {
      countryName: 'Saint Lucia',
      countryCode: 'LCA',
      isDisabled: false
    }, {
      countryName: 'Saint Vincent and the Grenadines',
      countryCode: 'VCT',
      isDisabled: false
    }, {
      countryName: 'Samoa',
      countryCode: 'WSM',
      isDisabled: false
    }, {
      countryName: 'Saudi Arabia',
      countryCode: 'SAU',
      isDisabled: false
    }, {
      countryName: 'Senegal',
      countryCode: 'SEN',
      isDisabled: false
    }, {
      countryName: 'Serbia',
      countryCode: 'SRB',
      isDisabled: false
    }, {
      countryName: 'Seychelles',
      countryCode: 'SYC',
      isDisabled: false
    }, {
      countryName: 'Sierra Leone',
      countryCode: 'SLE',
      isDisabled: false
    }, {
      countryName: 'Slovakia',
      countryCode: 'SVK',
      isDisabled: false
    }, {
      countryName: 'Slovenia',
      countryCode: 'SVN',
      isDisabled: false
    }, {
      countryName: 'Solomon Islands',
      countryCode: 'SLB',
      isDisabled: false
    }, {
      countryName: 'Somalia',
      countryCode: 'SOM',
      isDisabled: false
    }, {
      countryName: 'South Africa',
      countryCode: 'ZAF',
      isDisabled: false
    }, {
      countryName: 'South Korea',
      countryCode: 'KOR',
      isDisabled: false
    }, {
      countryName: 'Spain',
      countryCode: 'ESP',
      isDisabled: false
    }, {
      countryName: 'Sri Lanka',
      countryCode: 'LKA',
      isDisabled: false
    }, {
      countryName: 'Suriname',
      countryCode: 'SUR',
      isDisabled: false
    }, {
      countryName: 'Sweden',
      countryCode: 'SWE',
      isDisabled: false
    }, {
      countryName: 'Switzerland',
      countryCode: 'CHE',
      isDisabled: false
    }, {
      countryName: 'Taiwan',
      countryCode: 'TWN',
      isDisabled: false
    }, {
      countryName: 'Tajikistan',
      countryCode: 'TJK',
      isDisabled: false
    }, {
      countryName: 'Tanzania',
      countryCode: 'TZA',
      isDisabled: false
    }, {
      countryName: 'Togo',
      countryCode: 'TGO',
      isDisabled: false
    }, {
      countryName: 'Tonga',
      countryCode: 'TON',
      isDisabled: false
    }, {
      countryName: 'Tunisia',
      countryCode: 'TUN',
      isDisabled: false
    }, {
      countryName: 'Turkey',
      countryCode: 'TUR',
      isDisabled: false
    }, {
      countryName: 'Turkmenistan',
      countryCode: 'TKM',
      isDisabled: false
    }, {
      countryName: 'Tuvalu',
      countryCode: 'TUV',
      isDisabled: false
    }, {
      countryName: 'Uganda',
      countryCode: 'UGA',
      isDisabled: false
    }, {
      countryName: 'Ukraine',
      countryCode: 'UKR',
      isDisabled: false
    }, {
      countryName: 'United Kingdom',
      countryCode: 'GBR',
      isDisabled: false
    }, {
      countryName: 'Uruguay',
      countryCode: 'URY',
      isDisabled: false
    }, {
      countryName: 'Uzbekistan',
      countryCode: 'UZB',
      isDisabled: false
    }, {
      countryName: 'Vanuatu',
      countryCode: 'VUT',
      isDisabled: false
    }, {
      countryName: 'Venezuela',
      countryCode: 'VEN',
      isDisabled: false
    }, {
      countryName: 'Vietnam',
      countryCode: 'VNM',
      isDisabled: false
    }, {
      countryName: 'Yemen',
      countryCode: 'YEM',
      isDisabled: false
    }, {
      countryName: 'Zambia',
      countryCode: 'ZMB',
      isDisabled: false
    }]
  }]
};
const REDIRECTION_DEFER_TIME = 300;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var fails$o = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$n = fails$o;

var functionBindNative = !fails$n(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$m = FunctionPrototype$2.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND$3 && FunctionPrototype$2.bind.bind(call$m, call$m);

var functionUncurryThis = NATIVE_BIND$3 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$m.apply(fn, arguments);
  };
};

var uncurryThis$g = functionUncurryThis;

var toString$9 = uncurryThis$g({}.toString);
var stringSlice$3 = uncurryThis$g(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$3(toString$9(it), 8, -1);
};

var uncurryThis$f = functionUncurryThis;
var fails$m = fails$o;
var classof$8 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$f(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$m(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$3 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$2 = isNullOrUndefined$3;

var $TypeError$i = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (isNullOrUndefined$2(it)) throw new $TypeError$i("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$6 = function (it) {
  return IndexedObject$2(requireObjectCoercible$5(it));
};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var sharedStore = {exports: {}};

var globalThis$k = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$8 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$8(globalThis$k, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$k[key] = value;
  } return value;
};

var globalThis$j = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$j[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.43.0',
  mode: 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.43.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$4 = requireObjectCoercible$6;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return $Object$3(requireObjectCoercible$4(argument));
};

var uncurryThis$e = functionUncurryThis;
var toObject$5 = toObject$6;

var hasOwnProperty = uncurryThis$e({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$5(it), key);
};

var uncurryThis$d = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$8 = uncurryThis$d(1.1.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$8(++id + postfix, 36);
};

var globalThis$i = globalThis_1;

var navigator$1 = globalThis$i.navigator;
var userAgent$2 = navigator$1 && navigator$1.userAgent;

var environmentUserAgent = userAgent$2 ? String(userAgent$2) : '';

var globalThis$h = globalThis_1;
var userAgent$1 = environmentUserAgent;

var process$1 = globalThis$h.process;
var Deno$1 = globalThis$h.Deno;
var versions = process$1 && process$1.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$1) {
  match = userAgent$1.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$1.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = environmentV8Version;
var fails$l = fails$o;
var globalThis$g = globalThis_1;

var $String$5 = globalThis$g.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$l(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var globalThis$f = globalThis_1;
var shared$3 = shared$4;
var hasOwn$c = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Symbol$1 = globalThis$f.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$h = function (name) {
  if (!hasOwn$c(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$c(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$i = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$h = isCallable$i;

var isObject$c = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$h(it);
};

var isObject$b = isObject$c;

var $String$4 = String;
var $TypeError$h = TypeError;

// `Assert: Type(argument) is Object`
var anObject$k = function (argument) {
  if (isObject$b(argument)) return argument;
  throw new $TypeError$h($String$4(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$k = fails$o;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$k(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var DESCRIPTORS$f = descriptors;
var fails$j = fails$o;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$f && fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var objectDefineProperty = {};

var globalThis$e = globalThis_1;
var isObject$a = isObject$c;

var document$1 = globalThis$e.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$a(document$1) && isObject$a(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$e = descriptors;
var fails$i = fails$o;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$e && !fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var NATIVE_BIND$2 = functionBindNative;

var call$l = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = NATIVE_BIND$2 ? call$l.bind(call$l) : function () {
  return call$l.apply(call$l, arguments);
};

var globalThis$d = globalThis_1;
var isCallable$g = isCallable$i;

var aFunction = function (argument) {
  return isCallable$g(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$d[namespace]) : globalThis$d[namespace] && globalThis$d[namespace][method];
};

var uncurryThis$c = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$c({}.isPrototypeOf);

var getBuiltIn$3 = getBuiltIn$4;
var isCallable$f = isCallable$i;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$3('Symbol');
  return isCallable$f($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$2(it));
};

var $String$3 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$e = isCallable$i;
var tryToString$3 = tryToString$4;

var $TypeError$g = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$b = function (argument) {
  if (isCallable$e(argument)) return argument;
  throw new $TypeError$g(tryToString$3(argument) + ' is not a function');
};

var aCallable$a = aCallable$b;
var isNullOrUndefined$1 = isNullOrUndefined$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$5 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$1(func) ? undefined : aCallable$a(func);
};

var call$k = functionCall;
var isCallable$d = isCallable$i;
var isObject$9 = isObject$c;

var $TypeError$f = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$d(fn = input.toString) && !isObject$9(val = call$k(fn, input))) return val;
  if (isCallable$d(fn = input.valueOf) && !isObject$9(val = call$k(fn, input))) return val;
  if (pref !== 'string' && isCallable$d(fn = input.toString) && !isObject$9(val = call$k(fn, input))) return val;
  throw new $TypeError$f("Can't convert object to primitive value");
};

var call$j = functionCall;
var isObject$8 = isObject$c;
var isSymbol$1 = isSymbol$2;
var getMethod$4 = getMethod$5;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$g = wellKnownSymbol$h;

var $TypeError$e = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$g('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$8(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$4(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$j(exoticToPrim, input, pref);
    if (!isObject$8(result) || isSymbol$1(result)) return result;
    throw new $TypeError$e("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$d = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$j = anObject$k;
var toPropertyKey$1 = toPropertyKey$2;

var $TypeError$d = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$d ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$j(O);
  P = toPropertyKey$1(P);
  anObject$j(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$j(O);
  P = toPropertyKey$1(P);
  anObject$j(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$d('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$3 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$2(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  var len = toIntegerOrInfinity$1(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$6 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$5 = toIndexedObject$6;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$5 = lengthOfArrayLike$6;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$5($this);
    var length = lengthOfArrayLike$5(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var hiddenKeys$4 = {};

var uncurryThis$b = functionUncurryThis;
var hasOwn$b = hasOwnProperty_1;
var toIndexedObject$4 = toIndexedObject$6;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push = uncurryThis$b([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$4(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$b(hiddenKeys$3, key) && hasOwn$b(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$b(O, key = names[i++])) {
    ~indexOf$1(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$c = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$4 = objectDefineProperty;
var anObject$i = anObject$k;
var toIndexedObject$3 = toIndexedObject$6;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$c && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$i(O);
  var props = toIndexedObject$3(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$4.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$2 = getBuiltIn$4;

var html$1 = getBuiltIn$2('document', 'documentElement');

var shared$2 = shared$4;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */
var anObject$h = anObject$k;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$h(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$f = wellKnownSymbol$h;
var create$4 = objectCreate;
var defineProperty$7 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$f('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$7(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$4(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var globalThis$c = globalThis_1;
var isCallable$c = isCallable$i;

var WeakMap$1 = globalThis$c.WeakMap;

var weakMapBasicDetection = isCallable$c(WeakMap$1) && /native code/.test(String(WeakMap$1));

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$b = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;

var createNonEnumerableProperty$7 = DESCRIPTORS$b ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$b = globalThis_1;
var isObject$7 = isObject$c;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$7;
var hasOwn$a = hasOwnProperty_1;
var shared$1 = sharedStoreExports;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis$b.TypeError;
var WeakMap = globalThis$b.WeakMap;
var set, get$1, has;

var enforce = function (it) {
  return has(it) ? get$1(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$7(it) || (state = get$1(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store$1 = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store$1.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$a(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$6(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return hasOwn$a(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$a(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get$1,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$a = descriptors;
var call$i = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;
var toIndexedObject$2 = toIndexedObject$6;
var toPropertyKey = toPropertyKey$2;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$a ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$2(!call$i(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$9 = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$9 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$9 || (DESCRIPTORS$9 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$a = functionUncurryThis;
var isCallable$b = isCallable$i;
var store = sharedStoreExports;

var functionToString = uncurryThis$a(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$b(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store.inspectSource;

var uncurryThis$9 = functionUncurryThis;
var fails$h = fails$o;
var isCallable$a = isCallable$i;
var hasOwn$7 = hasOwnProperty_1;
var DESCRIPTORS$8 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$2 = internalState;

var enforceInternalState$1 = InternalStateModule$2.enforce;
var getInternalState$3 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;
var stringSlice$2 = uncurryThis$9(''.slice);
var replace$3 = uncurryThis$9(''.replace);
var join = uncurryThis$9([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$8 && !fails$h(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$2($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$3($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$8) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$8) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$1(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$a(this) && getInternalState$3(this).source || inspectSource(this);
}, 'toString');

var makeBuiltInExports = makeBuiltIn$3.exports;

var isCallable$9 = isCallable$i;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$7 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$9(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var uncurryThis$8 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$g = anObject$k;

var concat$1 = uncurryThis$8([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$g(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$6 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$6(target, key) && !(exceptions && hasOwn$6(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$g = fails$o;
var isCallable$8 = isCallable$i;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$8(detection) ? fails$g(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var globalThis$a = globalThis_1;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$7;
var defineBuiltIn$6 = defineBuiltIn$7;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$a;
  } else if (STATIC) {
    target = globalThis$a[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$a[TARGET] && globalThis$a[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$5(sourceProperty, 'sham', true);
    }
    defineBuiltIn$6(target, key, sourceProperty, options);
  }
};

var fails$f = fails$o;

var correctPrototypeGetter = !fails$f(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$5 = hasOwnProperty_1;
var isCallable$7 = isCallable$i;
var toObject$4 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$4(O);
  if (hasOwn$5(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$7(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$e = fails$o;
var isCallable$6 = isCallable$i;
var isObject$6 = isObject$c;
var getPrototypeOf$3 = objectGetPrototypeOf;
var defineBuiltIn$5 = defineBuiltIn$7;
var wellKnownSymbol$e = wellKnownSymbol$h;

var ITERATOR$5 = wellKnownSymbol$e('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$3(getPrototypeOf$3(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$6(IteratorPrototype$4) || fails$e(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$6(IteratorPrototype$4[ITERATOR$5])) {
  defineBuiltIn$5(IteratorPrototype$4, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$5 = objectDefineProperty.f;
var hasOwn$4 = hasOwnProperty_1;
var wellKnownSymbol$d = wellKnownSymbol$h;

var TO_STRING_TAG$4 = wellKnownSymbol$d('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$4(target, TO_STRING_TAG$4)) {
    defineProperty$5(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var create$3 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$3(IteratorPrototype$3, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$7 = functionUncurryThis;
var aCallable$9 = aCallable$b;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$7(aCallable$9(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$5 = isObject$c;

var isPossiblePrototype$1 = function (argument) {
  return isObject$5(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$c = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$c("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$4 = isObject$c;
var requireObjectCoercible$3 = requireObjectCoercible$6;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$3(O);
    aPossiblePrototype(proto);
    if (!isObject$4(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$i = _export;
var call$h = functionCall;
var FunctionName = functionName;
var isCallable$5 = isCallable$i;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf$2 = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$7;
var defineBuiltIn$4 = defineBuiltIn$7;
var wellKnownSymbol$c = wellKnownSymbol$h;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype$2 = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$c('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$2(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$2(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable$5(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$4(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$4(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$h(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$4(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$i({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$4(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject$1 = toIndexedObject$6;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$4 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;
var DESCRIPTORS$7 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$2 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$1(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$7 && values.name !== 'values') try {
  defineProperty$4(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$9 = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$7;
var setToStringTag = setToStringTag$3;
var wellKnownSymbol$b = wellKnownSymbol$h;

var ITERATOR$3 = wellKnownSymbol$b('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty$3(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$3(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$9[COLLECTION_NAME] && globalThis$9[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var isCallable$4 = isCallable$i;
var isObject$3 = isObject$c;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$4(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$3(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var isObject$2 = isObject$c;
var classof$7 = classofRaw$2;
var wellKnownSymbol$a = wellKnownSymbol$h;

var MATCH$2 = wellKnownSymbol$a('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$2(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$7(it) === 'RegExp');
};

var wellKnownSymbol$9 = wellKnownSymbol$h;

var TO_STRING_TAG$3 = wellKnownSymbol$9('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$3 = isCallable$i;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$8 = wellKnownSymbol$h;

var TO_STRING_TAG$2 = wellKnownSymbol$8('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$6 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$3(O.callee) ? 'Arguments' : result;
};

var classof$5 = classof$6;

var $String = String;

var toString$7 = function (argument) {
  if (classof$5(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var globalThis$8 = globalThis_1;
var fails$d = fails$o;

// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp$1 = globalThis$8.RegExp;

var FLAGS_GETTER_IS_CORRECT = !fails$d(function () {
  var INDICES_SUPPORT = true;
  try {
    RegExp$1('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {};
  // modern V8 bug
  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, { get: function () {
      calls += chr;
      return true;
    } });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };

  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]);

  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  var result = Object.getOwnPropertyDescriptor(RegExp$1.prototype, 'flags').get.call(O);

  return result !== expected || calls !== expected;
});

var regexpFlagsDetection = { correct: FLAGS_GETTER_IS_CORRECT };

var anObject$f = anObject$k;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$f(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$g = functionCall;
var hasOwn$3 = hasOwnProperty_1;
var isPrototypeOf$3 = objectIsPrototypeOf;
var regExpFlagsDetection = regexpFlagsDetection;
var regExpFlagsGetterImplementation = regexpFlags$1;

var RegExpPrototype$4 = RegExp.prototype;

var regexpGetFlags = regExpFlagsDetection.correct ? function (it) {
  return it.flags;
} : function (it) {
  return (!regExpFlagsDetection.correct && isPrototypeOf$3(RegExpPrototype$4, it) && !hasOwn$3(it, 'flags'))
    ? call$g(regExpFlagsGetterImplementation, it)
    : it.flags;
};

var fails$c = fails$o;
var globalThis$7 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis$7.RegExp;

var UNSUPPORTED_Y$2 = fails$c(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$2 || fails$c(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$c(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var defineProperty$3 = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty$3(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var makeBuiltIn = makeBuiltInExports;
var defineProperty$2 = objectDefineProperty;

var defineBuiltInAccessor$3 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$2.f(target, name, descriptor);
};

var getBuiltIn = getBuiltIn$4;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$3;
var wellKnownSymbol$7 = wellKnownSymbol$h;
var DESCRIPTORS$6 = descriptors;

var SPECIES$1 = wellKnownSymbol$7('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$6 && Constructor && !Constructor[SPECIES$1]) {
    defineBuiltInAccessor$2(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var fails$b = fails$o;
var globalThis$6 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis$6.RegExp;

var regexpUnsupportedDotAll = fails$b(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$a = fails$o;
var globalThis$5 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis$5.RegExp;

var regexpUnsupportedNcg = fails$a(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

var DESCRIPTORS$5 = descriptors;
var globalThis$4 = globalThis_1;
var uncurryThis$6 = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$7;
var create$2 = objectCreate;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var isPrototypeOf$2 = objectIsPrototypeOf;
var isRegExp$1 = isRegexp;
var toString$6 = toString$7;
var getRegExpFlags$1 = regexpGetFlags;
var stickyHelpers$1 = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$1;
var defineBuiltIn$3 = defineBuiltIn$7;
var fails$9 = fails$o;
var hasOwn$2 = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$1;
var wellKnownSymbol$6 = wellKnownSymbol$h;
var UNSUPPORTED_DOT_ALL$2 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var MATCH$1 = wellKnownSymbol$6('match');
var NativeRegExp = globalThis$4.RegExp;
var RegExpPrototype$3 = NativeRegExp.prototype;
var SyntaxError = globalThis$4.SyntaxError;
var exec$1 = uncurryThis$6(RegExpPrototype$3.exec);
var charAt$1 = uncurryThis$6(''.charAt);
var replace$2 = uncurryThis$6(''.replace);
var stringIndexOf$1 = uncurryThis$6(''.indexOf);
var stringSlice$1 = uncurryThis$6(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers$1.MISSED_STICKY;
var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$5 &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL$2 || UNSUPPORTED_NCG$1 || fails$9(function () {
    re2[MATCH$1] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$1(string, index);
    if (chr === '\\') {
      result += chr + charAt$1(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = create$2(null);
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$1(string, index);
    if (chr === '\\') {
      chr += charAt$1(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        result += chr;
        // ignore non-capturing groups
        if (stringSlice$1(string, index + 1, index + 3) === '?:') {
          continue;
        }
        if (exec$1(IS_NCG, stringSlice$1(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn$2(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$2(RegExpPrototype$3, this);
    var patternIsRegExp = isRegExp$1(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf$2(RegExpPrototype$3, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags$1(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$6(pattern);
    flags = flags === undefined ? '' : toString$6(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL$2 && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$2(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$1) flags = replace$2(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG$1) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$3, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty$2(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames$1(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype$3.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$3;
  defineBuiltIn$3(globalThis$4, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var DESCRIPTORS$4 = descriptors;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var classof$4 = classofRaw$2;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$3;
var getInternalState$1 = internalState.get;

var RegExpPrototype$2 = RegExp.prototype;
var $TypeError$b = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS$4 && UNSUPPORTED_DOT_ALL$1) {
  defineBuiltInAccessor$1(RegExpPrototype$2, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype$2) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof$4(this) === 'RegExp') {
        return !!getInternalState$1(this).dotAll;
      }
      throw new $TypeError$b('Incompatible receiver, RegExp required');
    }
  });
}

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$f = functionCall;
var uncurryThis$5 = functionUncurryThis;
var toString$5 = toString$7;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create$1 = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis$5(''.charAt);
var indexOf = uncurryThis$5(''.indexOf);
var replace$1 = uncurryThis$5(''.replace);
var stringSlice = uncurryThis$5(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$f(nativeExec, re1, 'a');
  call$f(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$5(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$f(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$f(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$1(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$f(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$f(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$1(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$h = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$h({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var $$g = _export;
var call$e = functionCall;
var isCallable$2 = isCallable$i;
var anObject$e = anObject$k;
var toString$4 = toString$7;

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$$g({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject$e(this);
    var string = toString$4(S);
    var exec = R.exec;
    if (!isCallable$2(exec)) return call$e(nativeTest, R, string);
    var result = call$e(exec, R, string);
    if (result === null) return false;
    anObject$e(result);
    return true;
  }
});

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$2 = defineBuiltIn$7;
var anObject$d = anObject$k;
var $toString = toString$7;
var fails$8 = fails$o;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$8(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$2(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$d(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

class FormValidation {
  // Method to check if a value contains only digits
  static isDigitsOnly(value) {
    return /^\d*$/.test(value);
  }
  // Method to validate Indian pincode
  static validIndianPincode(value) {
    return /^\d{6}$/.test(value);
  }
  static isValidInrAmount(value) {
    return value <= 25000000;
  }
  // Method to check if input length is greater than a specified length and contains only numbers
  static isInValidPincode(value, length) {
    const regex = new RegExp(`^\\d{${length + 1},}$`);
    return regex.test(value);
  }
}

var aCallable$8 = aCallable$b;
var toObject$3 = toObject$6;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$4 = lengthOfArrayLike$6;

var $TypeError$a = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject$3(that);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$4(O);
    aCallable$8(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError$a(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$a(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false)};

var fails$7 = fails$o;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$7(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

/* global Bun, Deno -- detection */
var globalThis$3 = globalThis_1;
var userAgent = environmentUserAgent;
var classof$3 = classofRaw$2;

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

var environment = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis$3.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis$3.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof$3(globalThis$3.process) === 'process') return 'NODE';
  if (globalThis$3.window && globalThis$3.document) return 'BROWSER';
  return 'REST';
})();

var ENVIRONMENT = environment;

var environmentIsNode = ENVIRONMENT === 'NODE';

var $$f = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = environmentV8Version;
var IS_NODE = environmentIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$5 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$f({ target: 'Array', proto: true, forced: FORCED$5 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var isPrototypeOf$1 = objectIsPrototypeOf;

var $TypeError$9 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$1(Prototype, it)) return it;
  throw new $TypeError$9('Incorrect invocation');
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$4;

var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$3) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

var $$e = _export;
var globalThis$2 = globalThis_1;
var anInstance = anInstance$1;
var anObject$c = anObject$k;
var isCallable$1 = isCallable$i;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltInAccessor = defineBuiltInAccessor$3;
var createProperty = createProperty$1;
var fails$6 = fails$o;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$5 = wellKnownSymbol$h;
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS$2 = descriptors;

var CONSTRUCTOR = 'constructor';
var ITERATOR$2 = 'Iterator';
var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');

var $TypeError$8 = TypeError;
var NativeIterator = globalThis$2[ITERATOR$2];

// FF56- have non-standard global helper `Iterator`
var FORCED$4 = !isCallable$1(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype$1
  // FF44- non-standard `Iterator` passes previous tests
  || !fails$6(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype$1);
  if (getPrototypeOf$1(this) === IteratorPrototype$1) throw new $TypeError$8('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS$2) {
    defineBuiltInAccessor(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$c(this);
        if (this === IteratorPrototype$1) throw new $TypeError$8("You can't redefine this property");
        if (hasOwn$1(this, key)) this[key] = replacement;
        else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};

if (!hasOwn$1(IteratorPrototype$1, TO_STRING_TAG$1)) defineIteratorPrototypeAccessor(TO_STRING_TAG$1, ITERATOR$2);

if (FORCED$4 || !hasOwn$1(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$$e({ global: true, constructor: true, forced: FORCED$4 }, {
  Iterator: IteratorConstructor
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$6 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var defineBuiltIn$1 = defineBuiltIn$7;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$1(target, key, src[key], options);
  return target;
};

var call$d = functionCall;
var anObject$b = anObject$k;
var getMethod$3 = getMethod$5;

var iteratorClose$a = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$b(iterator);
  try {
    innerResult = getMethod$3(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$d(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$b(innerResult);
  return value;
};

var iteratorClose$9 = iteratorClose$a;

var iteratorCloseAll$1 = function (iters, kind, value) {
  for (var i = iters.length - 1; i >= 0; i--) {
    if (iters[i] === undefined) continue;
    try {
      value = iteratorClose$9(iters[i].iterator, kind, value);
    } catch (error) {
      kind = 'throw';
      value = error;
    }
  }
  if (kind === 'throw') throw value;
  return value;
};

var call$c = functionCall;
var create = objectCreate;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$7;
var defineBuiltIns = defineBuiltIns$1;
var wellKnownSymbol$4 = wellKnownSymbol$h;
var InternalStateModule = internalState;
var getMethod$2 = getMethod$5;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var createIterResultObject = createIterResultObject$2;
var iteratorClose$8 = iteratorClose$a;
var iteratorCloseAll = iteratorCloseAll$1;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var NORMAL = 'normal';
var THROW = 'throw';
var setInternalState = InternalStateModule.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns(create(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod$2(iterator, 'return');
        return returnMethod ? call$c(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$8(state.inner.iterator, NORMAL);
      } catch (error) {
        return iteratorClose$8(iterator, THROW, error);
      }
      if (state.openIters) try {
        iteratorCloseAll(state.openIters, NORMAL);
      } catch (error) {
        return iteratorClose$8(iterator, THROW, error);
      }
      if (iterator) iteratorClose$8(iterator, NORMAL);
      return createIterResultObject(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty$1(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');

var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};

var anObject$a = anObject$k;
var iteratorClose$7 = iteratorClose$a;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$2 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$a(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$7(iterator, 'throw', error);
  }
};

// Should throw an error on invalid iterator
// https://issues.chromium.org/issues/336839115
var iteratorHelperThrowsOnInvalidIterator$2 = function (methodName, argument) {
  // eslint-disable-next-line es/no-iterator -- required for testing
  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
  if (method) try {
    method.call({ next: null }, argument).next();
  } catch (error) {
    return true;
  }
};

var globalThis$1 = globalThis_1;

// https://github.com/tc39/ecma262/pull/3467
var iteratorHelperWithoutClosingOnEarlyError$6 = function (METHOD_NAME, ExpectedError) {
  var Iterator = globalThis$1.Iterator;
  var IteratorPrototype = Iterator && Iterator.prototype;
  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];

  var CLOSED = false;

  if (method) try {
    method.call({
      next: function () { return { done: true }; },
      'return': function () { CLOSED = true; }
    }, -1);
  } catch (error) {
    // https://bugs.webkit.org/show_bug.cgi?id=291195
    if (!(error instanceof ExpectedError)) CLOSED = false;
  }

  if (!CLOSED) return method;
};

var $$d = _export;
var call$b = functionCall;
var aCallable$7 = aCallable$b;
var anObject$9 = anObject$k;
var getIteratorDirect$5 = getIteratorDirect$6;
var createIteratorProxy$1 = iteratorCreateProxy;
var callWithSafeIterationClosing$1 = callWithSafeIterationClosing$2;
var iteratorClose$6 = iteratorClose$a;
var iteratorHelperThrowsOnInvalidIterator$1 = iteratorHelperThrowsOnInvalidIterator$2;
var iteratorHelperWithoutClosingOnEarlyError$5 = iteratorHelperWithoutClosingOnEarlyError$6;

var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator$1('filter', function () { /* empty */ });
var filterWithoutClosingOnEarlyError = !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR
  && iteratorHelperWithoutClosingOnEarlyError$5('filter', TypeError);

var FORCED$3 = FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;

var IteratorProxy$1 = createIteratorProxy$1(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject$9(call$b(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing$1(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
$$d({ target: 'Iterator', proto: true, real: true, forced: FORCED$3 }, {
  filter: function filter(predicate) {
    anObject$9(this);
    try {
      aCallable$7(predicate);
    } catch (error) {
      iteratorClose$6(this, 'throw', error);
    }

    if (filterWithoutClosingOnEarlyError) return call$b(filterWithoutClosingOnEarlyError, this, predicate);

    return new IteratorProxy$1(getIteratorDirect$5(this), {
      predicate: predicate
    });
  }
});

var $$c = _export;
var call$a = functionCall;
var aCallable$6 = aCallable$b;
var anObject$8 = anObject$k;
var getIteratorDirect$4 = getIteratorDirect$6;
var createIteratorProxy = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$2;
var iteratorClose$5 = iteratorClose$a;
var iteratorHelperThrowsOnInvalidIterator = iteratorHelperThrowsOnInvalidIterator$2;
var iteratorHelperWithoutClosingOnEarlyError$4 = iteratorHelperWithoutClosingOnEarlyError$6;

var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('map', function () { /* empty */ });
var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR
  && iteratorHelperWithoutClosingOnEarlyError$4('map', TypeError);

var FORCED$2 = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var result = anObject$8(call$a(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
$$c({ target: 'Iterator', proto: true, real: true, forced: FORCED$2 }, {
  map: function map(mapper) {
    anObject$8(this);
    try {
      aCallable$6(mapper);
    } catch (error) {
      iteratorClose$5(this, 'throw', error);
    }

    if (mapWithoutClosingOnEarlyError) return call$a(mapWithoutClosingOnEarlyError, this, mapper);

    return new IteratorProxy(getIteratorDirect$4(this), {
      mapper: mapper
    });
  }
});

var classofRaw = classofRaw$2;
var uncurryThis$4 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$4(fn);
};

var uncurryThis$3 = functionUncurryThisClause;
var aCallable$5 = aCallable$b;
var NATIVE_BIND$1 = functionBindNative;

var bind$1 = uncurryThis$3(uncurryThis$3.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$5(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$1(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$3 = wellKnownSymbol$h;
var Iterators$1 = iterators;

var ITERATOR$1 = wellKnownSymbol$3('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$1] === it);
};

var classof$2 = classof$6;
var getMethod$1 = getMethod$5;
var isNullOrUndefined = isNullOrUndefined$3;
var Iterators = iterators;
var wellKnownSymbol$2 = wellKnownSymbol$h;

var ITERATOR = wellKnownSymbol$2('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof$2(it)];
};

var call$9 = functionCall;
var aCallable$4 = aCallable$b;
var anObject$7 = anObject$k;
var tryToString$2 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$7 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$4(iteratorMethod)) return anObject$7(call$9(iteratorMethod, argument));
  throw new $TypeError$7(tryToString$2(argument) + ' is not iterable');
};

var bind = functionBindContext;
var call$8 = functionCall;
var anObject$6 = anObject$k;
var tryToString$1 = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$6;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose$4 = iteratorClose$a;

var $TypeError$6 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$4 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$4(iterator, 'normal');
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$6(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$6(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$3(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$8(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$4(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$7 = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$7.bind(apply$1) : function () {
  return call$7.apply(apply$1, arguments);
});

var $$b = _export;
var iterate$3 = iterate$4;
var aCallable$3 = aCallable$b;
var anObject$5 = anObject$k;
var getIteratorDirect$3 = getIteratorDirect$6;
var iteratorClose$3 = iteratorClose$a;
var iteratorHelperWithoutClosingOnEarlyError$3 = iteratorHelperWithoutClosingOnEarlyError$6;
var apply = functionApply;
var fails$5 = fails$o;

var $TypeError$5 = TypeError;

// https://bugs.webkit.org/show_bug.cgi?id=291651
var FAILS_ON_INITIAL_UNDEFINED = fails$5(function () {
  // eslint-disable-next-line es/no-iterator-prototype-reduce, es/no-array-prototype-keys, array-callback-return -- required for testing
  [].keys().reduce(function () { /* empty */ }, undefined);
});

var reduceWithoutClosingOnEarlyError = !FAILS_ON_INITIAL_UNDEFINED && iteratorHelperWithoutClosingOnEarlyError$3('reduce', $TypeError$5);

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
$$b({ target: 'Iterator', proto: true, real: true, forced: FAILS_ON_INITIAL_UNDEFINED || reduceWithoutClosingOnEarlyError }, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject$5(this);
    try {
      aCallable$3(reducer);
    } catch (error) {
      iteratorClose$3(this, 'throw', error);
    }

    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    if (reduceWithoutClosingOnEarlyError) {
      return apply(reduceWithoutClosingOnEarlyError, this, noInitial ? [reducer] : [reducer, accumulator]);
    }
    var record = getIteratorDirect$3(this);
    var counter = 0;
    iterate$3(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, { IS_RECORD: true });
    if (noInitial) throw new $TypeError$5('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});

// ENUM for charge types
var CHARGE_TYPE;
(function (CHARGE_TYPE) {
  CHARGE_TYPE["SERVICE_CHARGE"] = "service_charge";
  CHARGE_TYPE["TCS"] = "tcs";
  CHARGE_TYPE["DISCOUNT"] = "discount";
})(CHARGE_TYPE || (CHARGE_TYPE = {}));
const getTotalCurrencyValue = (currenciesData = []) => {
  const initialVal = 0;
  if (!currenciesData || currenciesData.length === 0) {
    return initialVal;
  }
  const sum = currenciesData.reduce((accumalator, currentValue) => accumalator + Number(currentValue === null || currentValue === void 0 ? void 0 : currentValue.amount) * Number(currentValue === null || currentValue === void 0 ? void 0 : currentValue.rate), initialVal);
  return sum;
};
// GST Calculation
const calculateForexTaxes = amount => {
  if (amount <= 25000) {
    return 45;
  } else if (amount > 25000 && amount <= 100000) {
    return amount * (0.18 / 100);
  } else if (amount > 100000 && amount <= 1000000) {
    return 180 + (amount - 100000) * (0.09 / 100);
  } else {
    return 990 + (amount - 1000000) * (0.018 / 100);
  }
};
const getServiceCharge = (range, amount) => {
  let charge = 0;
  if ((range === null || range === void 0 ? void 0 : range.length) && amount !== undefined && amount !== null) {
    range.map(chargeItem => {
      const {
        minimum_amount,
        maximum_amount,
        absolute
      } = chargeItem || {};
      if (amount >= minimum_amount && (amount < maximum_amount || maximum_amount === -1) && absolute !== null) {
        charge = absolute !== null && absolute !== void 0 ? absolute : 0;
      }
    });
  }
  return charge;
};
const getServiceChargeRange = charges => {
  var _a;
  const data = charges === null || charges === void 0 ? void 0 : charges.filter(chargeType => {
    if ((chargeType === null || chargeType === void 0 ? void 0 : chargeType.type) === CHARGE_TYPE.SERVICE_CHARGE) {
      return true;
    } else {
      return false;
    }
  });
  return (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.range;
};
const getTotalTaxes = (totalCurrencyValue, charges) => {
  if (totalCurrencyValue === 0) return 0;
  const gstCharge = calculateForexTaxes(totalCurrencyValue);
  const serviceCharge = getServiceCharge(getServiceChargeRange(charges), totalCurrencyValue + gstCharge);
  return gstCharge + serviceCharge;
};
const getTotalPayabaleAmount = (currenciesData, charges) => {
  const totalCurrencyValue = getTotalCurrencyValue(currenciesData);
  const totalTaxes = getTotalTaxes(totalCurrencyValue, charges);
  return totalCurrencyValue + totalTaxes;
};

const deviceType = {
  mobile: `(max-width: ${BREAKPOINTS.MOBILE}px)`,
  desktop: `(min-width: ${BREAKPOINTS.DESKTOP}px)`
};

const useDevice = defaultDevice => {
  const [breakpoint, setBreakpoint] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultDevice || null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    // Don't run client-side detection if default device type is available
    if (defaultDevice) return;
    if (breakpoint) return;
    if (typeof window === 'undefined') return;
    const handleResize = () => {
      if (window.matchMedia(deviceType.mobile).matches) {
        setBreakpoint(DEVICE.MOBILE);
      } else {
        setBreakpoint(DEVICE.DESKTOP);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint, defaultDevice]);
  // Prioritize default device type if available
  if (defaultDevice) {
    console.log('useDevice: Using default device type:', defaultDevice);
    return defaultDevice;
  }
  // Log client-side detection for debugging
  if (breakpoint) {
    console.log('useDevice: Using client-side device type:', breakpoint);
  }
  // Return client-detected device type or null
  return breakpoint;
};

const useOutsideClick = (ref, callback, showState) => {
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    if (showState) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showState, ref, callback]);
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * useAuthentication - A custom hook for handling authentication logic
 *
 * This hook provides authentication functionality that can be used
 * independently of the AuthContainer component.
 *
 * Features:
 * - Checks if user is logged in
 * - Handles partner login flow
 * - Provides loading and error states
 * - Reusable across different components
 *
 * @returns {Object} Authentication utilities
 * @returns {Function} authenticate - Function to trigger authentication
 * @returns {boolean} isAuthenticating - Loading state during authentication
 * @returns {any} authError - Error object if authentication fails
 * @returns {Function} clearAuthError - Function to clear authentication error
 *
 * @example
 * ```tsx
 * const { authenticate, isAuthenticating, authError } = useAuthentication();
 *
 * const handleLogin = async () => {
 *   const success = await authenticate();
 *   if (success) {
 *     console.log('User authenticated successfully');
 *   }
 * };
 * ```
 */
const useAuthentication = () => {
  const [isAuthenticating, setIsAuthenticating] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const [authError, setAuthError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  const authenticate = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
      setIsAuthenticating(true);
      setAuthError(null);
      // Check if user is logged in
      const isLoggedIn = yield (0,_tm_auth__WEBPACK_IMPORTED_MODULE_2__.isUserLoggedin)();
      if (!isLoggedIn) {
        // If not logged in, check login with partner
        const isPartnerLogin = yield (0,_tm_auth__WEBPACK_IMPORTED_MODULE_2__.isPartnerLoggedIn)();
        if (isPartnerLogin) {
          // If logged in with partner, call loginIfPartnerLoggedin method
          yield (0,_tm_auth__WEBPACK_IMPORTED_MODULE_2__.loginIfPartnerLoggedin)();
        } else {
          // Otherwise call loginToPartner method
          yield (0,_tm_auth__WEBPACK_IMPORTED_MODULE_2__.loginToPartner)();
        }
        return false;
      }
      return true;
    } catch (error) {
      console.error('Authentication error:', error);
      setAuthError(error);
      return false;
    } finally {
      setIsAuthenticating(false);
    }
  });
  return {
    authenticate,
    isAuthenticating,
    authError,
    clearAuthError: () => setAuthError(null)
  };
};

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min$1.ContextConsumer=h;reactIs_production_min$1.ContextProvider=g;reactIs_production_min$1.Element=b;reactIs_production_min$1.ForwardRef=l;reactIs_production_min$1.Fragment=d;reactIs_production_min$1.Lazy=q;reactIs_production_min$1.Memo=p;reactIs_production_min$1.Portal=c;reactIs_production_min$1.Profiler=f;reactIs_production_min$1.StrictMode=e;reactIs_production_min$1.Suspense=m;
	reactIs_production_min$1.SuspenseList=n;reactIs_production_min$1.isAsyncMode=function(){return  false};reactIs_production_min$1.isConcurrentMode=function(){return  false};reactIs_production_min$1.isContextConsumer=function(a){return v(a)===h};reactIs_production_min$1.isContextProvider=function(a){return v(a)===g};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min$1.isForwardRef=function(a){return v(a)===l};reactIs_production_min$1.isFragment=function(a){return v(a)===d};reactIs_production_min$1.isLazy=function(a){return v(a)===q};reactIs_production_min$1.isMemo=function(a){return v(a)===p};
	reactIs_production_min$1.isPortal=function(a){return v(a)===c};reactIs_production_min$1.isProfiler=function(a){return v(a)===f};reactIs_production_min$1.isStrictMode=function(a){return v(a)===e};reactIs_production_min$1.isSuspense=function(a){return v(a)===m};reactIs_production_min$1.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?true:false};reactIs_production_min$1.typeOf=v;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;

	if (false) {}
	return reactIs_development$1;
}

if (true) {
  reactIs$2.exports = requireReactIs_production_min$1();
} else {}

var reactIsExports$1 = reactIs$2.exports;

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (true === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case false:
        case true:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (false) {}
	return reactIs_development;
}

if (true) {
  reactIs$1.exports = requireReactIs_production_min();
} else {}

var reactIsExports = reactIs$1.exports;

var reactIs = reactIsExports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var f = /*@__PURE__*/getDefaultExportFromCjs(hoistNonReactStatics_cjs);

function m(){return (m=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}var y=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},v=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!reactIsExports$1.typeOf(t)},g=Object.freeze([]),S=Object.freeze({});function w(e){return "function"==typeof e}function E(e){return  false||e.displayName||e.name||"Component"}function b(e){return e&&"string"==typeof e.styledComponentId}var _="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="undefined"!=typeof window&&"HTMLElement"in window,C=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P= false?0:{};function O(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t);})),e}function R(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw  true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var D=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&R(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++);},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n);}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),j=new Map,T=new Map,x=1,k=function(e){if(j.has(e))return j.get(e);for(;T.has(x);)x++;var t=x++;return  false&&0,j.set(e,t),T.set(t,e),t},V=function(e){return T.get(e)},z=function(e,t){t>=x&&(x=t+1),j.set(e,t),T.set(t,e);},B="style["+_+'][data-styled-version="5.3.11"]',M=new RegExp("^"+_+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),G=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r);},L=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(M);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),G(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0;}else r.push(i);}}},F=function(){return  true?__webpack_require__.nc:0},Y=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(_))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(_,"active"),r.setAttribute("data-styled-version","5.3.11");var i=F();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},q=function(){function e(e){var t=this.element=Y(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}R(17);}(t),this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return  false}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),H=function(){function e(e){var t=this.element=Y(e);this.nodes=t.childNodes,this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,true}return  false},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),$$a=function(){function e(e){this.rules=[],this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,true)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--;},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),W=A,U={isServer:!A,useCSSOMInjection:!C},J=function(){function e(e,t,n){ void 0===e&&(e=S),void 0===t&&(t={}),this.options=m({},U,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&A&&W&&(W=false,function(e){for(var t=document.querySelectorAll(B),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(_)&&(L(e,o),o.parentNode&&o.parentNode.removeChild(o));}}(this));}e.registerId=function(e){return k(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=true),new e(m({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new $$a(o):r?new q(o):new H(o),new D(e)));var e,t,n,r,o;},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(k(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(k(e),n);},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},t.clearRules=function(e){this.getTag().clearGroup(k(e)),this.clearNames(e);},t.clearTag=function(){this.tag=void 0;},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=V(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=_+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",");})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n';}}}return r}(this)},e}(),X=/(a)(d)/gi,Z=function(e){return String.fromCharCode(e+(e>25?39:97))};function K(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Z(t%52)+n;return (Z(t%52)+n).replace(X,"$1-$2")}var Q=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ee=function(e){return Q(5381,e)};function te(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(w(n)&&!b(n))return  false}return  true}var ne=ee("5.3.11"),re=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&te(e),this.componentId=t,this.baseHash=Q(ne,t),this.baseStyle=n,J.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else {var s=be(this.rules,e,t,n).join(""),i=K(Q(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a);}o.push(i),this.staticRulesId=i;}else {for(var c=this.rules.length,u=Q(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=be(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=Q(u,f+d),l+=f;}}if(l){var m=K(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y);}o.push(m);}}return o.join(" ")},e}(),oe=/^\s*\/\/.*$/gm,se=[":","[",".","#"];function ie(e){var t,n,r,o,s=S,i=s.options,a=void 0===i?S:i,c=s.plugins,u=void 0===c?g:c,l=new stylis_min(a),h=[],p=function(e){function t(t){if(t)try{e(t+"}");}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case  -2:r.split("/*|*/}").forEach(t);}}}((function(e){h.push(e);})),f=function(e,r,s){return 0===r&&-1!==se.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){ void 0===a&&(a="&");var c=e.replace(oe,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f));},p,function(e){if(-2===e){var t=h;return h=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||R(15),Q(e,t.name)}),5381).toString():"",m}var ae=react__WEBPACK_IMPORTED_MODULE_1__.createContext();ae.Consumer;var ue=react__WEBPACK_IMPORTED_MODULE_1__.createContext(),le=(ue.Consumer,new J),de=ie();function he(){return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ae)||le}function pe(){return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ue)||de}var me=function(){function e(e,t){var n=this;this.inject=function(e,t){ void 0===t&&(t=de);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"));},this.toString=function(){return R(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t;}return e.prototype.getName=function(e){return void 0===e&&(e=de),this.name+e.hash},e}(),ye=/([A-Z])/,ve=/([A-Z])/g,ge=/^ms-/,Se=function(e){return "-"+e.toLowerCase()};function we(e){return ye.test(e)?e.replace(ve,Se).replace(ge,"-ms-"):e}var Ee=function(e){return null==e||false===e||""===e};function be(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=be(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(Ee(e))return "";if(b(e))return "."+e.styledComponentId;if(w(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return  false&&0,be(u,n,r,o)}var l;return e instanceof me?r?(e.inject(r,o),e.getName(o)):e:v(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!Ee(t[i])&&(Array.isArray(t[i])&&t[i].isCss||w(t[i])?s.push(we(i)+":",t[i],";"):v(t[i])?s.push.apply(s,e(t[i],i)):s.push(we(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitlessKeys||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var _e=function(e){return Array.isArray(e)&&(e.isCss=true),e};function Ne(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return w(e)||v(e)?_e(be(y(g,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:_e(be(y(e,n)))}var Ae=/invalid hook call/i,Ce=new Set,Ie=function(e,t){if(false){ var o, n, r; }},Pe=function(e,t,n){return void 0===n&&(n=S),e.theme!==n.theme&&e.theme||t||n.theme},Oe=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,Re=/(^-|-$)/g;function De(e){return e.replace(Oe,"-").replace(Re,"")}var je=function(e){return K(ee(e)>>>0)};function Te(e){return "string"==typeof e&&( true||0)}var xe=function(e){return "function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},ke=function(e){return "__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Ve(e,t,n){var r=e[n];xe(t)&&xe(r)?ze(r,t):e[n]=t;}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(xe(i))for(var a in i)ke(a)&&Ve(e,i[a],a);}return e}var Be=react__WEBPACK_IMPORTED_MODULE_1__.createContext();Be.Consumer;var Le={};function Fe(e,t,n){var o=b(e),i=!Te(e),a=t.attrs,c=void 0===a?g:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":De(e);Le[n]=(Le[n]||0)+1;var r=n+"-"+je("5.3.11"+n+Le[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,y=void 0===h?function(e){return Te(e)?"styled."+e:"Styled("+E(e)+")"}(e):h,v=t.displayName&&t.componentId?De(t.displayName)+"-"+t.componentId:t.componentId||d,_=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new re(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,f=function(e,t,n){ void 0===e&&(e=S);var r=m({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in w(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t];})),[r,o]}(Pe(t,(0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be),a)||S,t,o),y=f[0],v=f[1],g=function(e,t,n,r){var o=he(),s=pe(),i=t?e.generateAndInjectStyles(S,o,s):e.generateAndInjectStyles(n,o,s);return  false&&0,i}(i,r,y, false?0:void 0),E=n,b=v.$as||t.$as||v.as||t.as||h,_=Te(b),N=v!==t?m({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,isPropValid,b):!_||isPropValid(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=m({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=E,(0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(b,A)}(A,e,t,I)};return P.displayName=y,(A=react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(P)).attrs=_,A.componentStyle=C,A.displayName=y,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):g,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return {};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(Te(e)?e:De(E(e)));return Fe(e,m({},o,{attrs:_,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t;}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return "."+A.styledComponentId}}),i&&f(A,e,{attrs:true,componentStyle:true,displayName:true,foldedComponentIds:true,shouldForwardProp:true,styledComponentId:true,target:true,withComponent:true}),A}var Ye=function(e){return function e(t,r,o){if(void 0===o&&(o=S),!reactIsExports$1.isValidElementType(r))return R(1,String(r));var s=function(){return t(r,o,Ne.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,m({},o,{},n))},s.attrs=function(n){return e(t,r,m({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Fe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){Ye[e]=Ye(e);}));function $e(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ne.apply(void 0,[e].concat(n)).join(""),s=je(o);return new me(s,o)} false&&0, false&&(0);

const deliveryPersIconAnimation = /*#__PURE__*/$e(["0%{right:-24px;opacity:0;}20%{right:-24px;opacity:1;}70%{right:-24px;opacity:1;}100%{right:0;opacity:1;}"]);
const deliveryPersDescAnimation = /*#__PURE__*/$e(["from{opacity:0;}to{opacity:1;}"]);
const DeliveryPersCont = /*#__PURE__*/Ye.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersCont",
  componentId: "ichu7d-0"
})(["display:flex;align-items:center;margin:", ";position:relative;z-index:1;"], ({
  margin
}) => margin || '0');
const DeliveryPersDesc = /*#__PURE__*/Ye.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersDesc",
  componentId: "ichu7d-1"
})(["flex:1;opacity:0;animation:", " 1s ease-in-out forwards;animation-delay:5.5s;@media ", "{display:flex;column-gap:6px;animation-delay:0s;}"], deliveryPersDescAnimation, deviceType.desktop);
const DeliveryPersIcon = /*#__PURE__*/Ye(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Image).withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersIcon",
  componentId: "ichu7d-3"
})(["display:flex;align-items:center;position:relative;right:-24px;opacity:0;animation:", " 1s ease-in-out forwards;animation-delay:0s;"], deliveryPersIconAnimation);
const DeliveryPersTitle = /*#__PURE__*/Ye(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText).withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersTitle",
  componentId: "ichu7d-4"
})(["display:flex;align-items:center;"]);
const DeliveryPersSubTitleWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersSubTitleWrapper",
  componentId: "ichu7d-5"
})(["position:relative;z-index:100;display:flex;align-items:center;gap:4px;"]);
const DeliveryPersSubTitle = /*#__PURE__*/Ye(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText).withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersSubTitle",
  componentId: "ichu7d-6"
})(["display:flex;align-items:center;"]);
const InfoIconWrap = /*#__PURE__*/Ye.div.withConfig({
  displayName: "DeliveryPersuasionstyles__InfoIconWrap",
  componentId: "ichu7d-7"
})(["position:relative;"]);
const TooltipContainer = /*#__PURE__*/Ye(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.ToolTip).withConfig({
  displayName: "DeliveryPersuasionstyles__TooltipContainer",
  componentId: "ichu7d-8"
})(["left:-22px;top:22px;display:flex;gap:16px;z-index:100;"]);
const CloseIcon = /*#__PURE__*/Ye(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Image).withConfig({
  displayName: "DeliveryPersuasionstyles__CloseIcon",
  componentId: "ichu7d-9"
})(["align-self:center;cursor:pointer;"]);

const DeliveryPersuasion = ({
  data: componentData,
  margin,
  bottomSheets,
  onPincodeClick
}) => {
  var _a, _b, _c, _d, _e;
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  const {
    nodeId = 'delivery-persuasion',
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const [showBottomsheet, setShowBottomsheet] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const device = useDevice();
  const handleTooltip = () => {
    var _a, _b;
    (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_6__.trackEvent)({
      eventData: (_b = (_a = data === null || data === void 0 ? void 0 : data.cta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
    setShowTooltip(!showTooltip);
  };
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  useOutsideClick(tooltipRef, () => setShowTooltip(false), showTooltip);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(DeliveryPersCont, {
      id: nodeId,
      margin: margin,
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(DeliveryPersIcon, {
        src: (_a = data === null || data === void 0 ? void 0 : data.icon) === null || _a === void 0 ? void 0 : _a.url,
        alt: (_b = data === null || data === void 0 ? void 0 : data.icon) === null || _b === void 0 ? void 0 : _b.type,
        width: "32px",
        height: "32px"
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(DeliveryPersDesc, {
        children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(DeliveryPersTitle, {
          text: data === null || data === void 0 ? void 0 : data.title,
          color: theme.colors.highEmphasis,
          typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1,
          onClick: onPincodeClick,
          numberOfLines: 1
        }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(DeliveryPersSubTitleWrapper, {
          children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(DeliveryPersSubTitle, {
            text: data === null || data === void 0 ? void 0 : data.subtitle,
            color: theme.colors.mediumEmphasis,
            typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1
          }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(InfoIconWrap, {
            children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Image, {
              src: (_d = (_c = data === null || data === void 0 ? void 0 : data.toolTip) === null || _c === void 0 ? void 0 : _c.icon) === null || _d === void 0 ? void 0 : _d.url,
              height: "16px",
              width: "16px",
              onClick: handleTooltip,
              showCursorPointer: true
            }), showTooltip && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              ref: tooltipRef,
              children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(TooltipContainer, {
                width: "320px",
                arrowDirection: "up",
                arrowPosition: device === DEVICE.MOBILE ? '140px' : '30px',
                children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
                  text: (_e = data === null || data === void 0 ? void 0 : data.toolTip) === null || _e === void 0 ? void 0 : _e.text,
                  typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
                  color: theme.colors.white
                }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CloseIcon, {
                  src: `https://tripmoneycmsimgak.mmtcdn.com/img/Close_ef36e1a467.png`,
                  width: "24px",
                  height: "24px",
                  onClick: () => setShowTooltip(false)
                })]
              })
            })]
          })]
        })]
      })]
    })
  });
};

/**
 * AuthContainer - A reusable authentication component
 *
 * This component provides authentication UI components (MMTLogin, modals)
 * and can be used across different parts of the application.
 *
 * Features:
 * - Handles MMT Login component
 * - Provides Email Login, App Update, and Login Error modals
 * - Optional PDT event logging
 *
 * @example
 * ```tsx
 * <AuthContainer
 *   enablePdtLogging={true}
 * />
 * ```
 */
const AuthContainer = ({
  enablePdtLogging: _enablePdtLogging = false
}) => {
  const firePdtEvent = ctaLabel => {
    if (_enablePdtLogging) {
      // Basic PDT event logging - can be enhanced based on available utilities
      console.log('PDT Event:', ctaLabel);
    }
  };
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_auth__WEBPACK_IMPORTED_MODULE_2__.MMTLogin, {}), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_auth__WEBPACK_IMPORTED_MODULE_2__.EmailLoginModal, {
      onOpen: () => {
        firePdtEvent('EMAIL_LOGIN_POP_UP_OPEN');
      },
      onClose: () => {
        firePdtEvent('EMAIL_LOGIN_POP_UP_OK_CLICK');
      }
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_auth__WEBPACK_IMPORTED_MODULE_2__.AppUpdateModal, {
      onOpen: () => {
        firePdtEvent('UPDATE_APP_POP_UP_OPEN');
      },
      onClose: () => {
        firePdtEvent('UPDATE_APP_POP_UP_OK_CLICK');
      }
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_auth__WEBPACK_IMPORTED_MODULE_2__.LoginErrorModal, {
      onOpen: () => {
        firePdtEvent('LOGIN_ERROR_POP_UP_OPEN');
      },
      onClose: () => {
        firePdtEvent('LOGIN_ERROR_POP_UP_OK_CLICK');
      }
    })]
  });
};

const CouponDetailsWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CouponDetailsWrapper",
  componentId: "sc-1iqbbwf-0"
})([""]);
const CouponListWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CouponListWrapper",
  componentId: "sc-1iqbbwf-1"
})(["display:flex;flex-direction:column;margin:8px 0px 0px;gap:8px;"]);
const CouponItemWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CouponItemWrapper",
  componentId: "sc-1iqbbwf-2"
})(["display:flex;flex-direction:column;padding:12px;gap:4px;border-radius:", ";border:1px solid ", ";"], ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.cardBorder);
const InfoSectionWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__InfoSectionWrapper",
  componentId: "sc-1iqbbwf-3"
})(["margin:24px 0px 0px;&:first-child{margin-top:0px;}"]);
const InfoList = /*#__PURE__*/Ye.ul.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__InfoList",
  componentId: "sc-1iqbbwf-4"
})(["display:flex;flex-direction:column;gap:8px;margin-top:12px;"]);
const InfoItem = /*#__PURE__*/Ye.li.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__InfoItem",
  componentId: "sc-1iqbbwf-5"
})(["position:relative;padding-left:10px;::before{content:'';position:absolute;left:0;top:6px;width:4px;height:4px;border-radius:50%;background-color:", ";}"], ({
  theme
}) => theme.colors.cardBorder);
const OfferSlabTable = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__OfferSlabTable",
  componentId: "sc-1iqbbwf-6"
})(["border-radius:", ";border:1px solid ", ";overflow:hidden;margin:8px 0px 0px;"], ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.cardBorder);
const Table = /*#__PURE__*/Ye.table.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__Table",
  componentId: "sc-1iqbbwf-7"
})(["border-collapse:collapse;width:100%;th{border-bottom:1px solid ", ";padding:12px;background:", ";}td{padding:10px;}tbody tr:not(:last-child) td{border-bottom:1px solid ", ";}thead tr th:not(:last-child){border-right:1px solid ", ";}tbody tr td:not(:last-child){border-right:1px solid ", ";}"], ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.cardBorder);
const CashBackAppliedWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CashBackAppliedWrapper",
  componentId: "sc-1iqbbwf-8"
})(["display:flex;flex-direction:column;gap:8px;border:1px solid #d8d8d8;border-radius:", ";padding:12px;", ""], ({
  theme
}) => theme.borderRadius.br8, ({
  applied
}) => applied && `
    border: none;
    padding: 12px;
    background: #E6FFF9;
  `);
const CouponTitleWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CouponTitleWrapper",
  componentId: "sc-1iqbbwf-9"
})(["display:flex;justify-content:space-between;align-items:center;gap:8px;"]);

const CouponItem = ({
  coupon
}) => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CouponItemWrapper, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.title,
      color: theme.colors.highEmphasis,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW3
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.label,
      color: theme.colors.lowEmphasis,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.subLabel,
      color: theme.colors.lowEmphasis,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1
    })]
  });
};

const CouponList = ({
  couponList
}) => {
  const [isExpanded, setIsExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  if (!(couponList === null || couponList === void 0 ? void 0 : couponList.length)) {
    return null;
  }
  const toggleShowMore = () => {
    setIsExpanded(prev => !prev);
  };
  const displayedCoupons = isExpanded ? couponList : couponList.slice(0, 1);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CouponListWrapper, {
    children: [displayedCoupons === null || displayedCoupons === void 0 ? void 0 : displayedCoupons.map((coupon, index) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CouponItem, {
      coupon: coupon
    }, index.toString())), couponList.length > 1 ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Anchor, {
      color: theme.colors.primaryAccent,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW2,
      onClick: toggleShowMore,
      margin: "8px 0px  0px",
      children: isExpanded ? 'Show less' : `+ ${couponList.length - 1} More Coupon`
    }) : null]
  });
};

const InfoSection = ({
  data
}) => {
  var _a;
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  if (!data) {
    return null;
  }
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(InfoSectionWrapper, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
      text: data === null || data === void 0 ? void 0 : data.title,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.lowEmphasis
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(InfoList, {
      children: (_a = data === null || data === void 0 ? void 0 : data.list) === null || _a === void 0 ? void 0 : _a.map((item, index) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(InfoItem, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
          text: item,
          color: theme.colors.mediumEmphasis,
          typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1
        })
      }, index.toString()))
    })]
  });
};

const OfferSlabs = ({
  data
}) => {
  var _a, _b, _c, _d;
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  if (!data) {
    return null;
  }
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(InfoSectionWrapper, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
      text: data === null || data === void 0 ? void 0 : data.title,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.lowEmphasis
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(OfferSlabTable, {
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Table, {
        border: 0,
        width: "100%",
        cellPadding: "",
        cellSpacing: "0",
        children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("thead", {
          children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("tr", {
            children: (_a = data === null || data === void 0 ? void 0 : data.offerList) === null || _a === void 0 ? void 0 : _a.map(offer => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("th", {
              children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
                text: offer === null || offer === void 0 ? void 0 : offer.title,
                color: theme.colors.mediumEmphasis,
                typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW2
              })
            }, offer.id))
          })
        }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("tbody", {
          children: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.offerList) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.list) === null || _d === void 0 ? void 0 : _d.map((_, rowIndex) => {
            var _a;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("tr", {
              children: (_a = data === null || data === void 0 ? void 0 : data.offerList) === null || _a === void 0 ? void 0 : _a.map(offer => {
                var _a;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("td", {
                  align: "center",
                  children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
                    text: (_a = offer === null || offer === void 0 ? void 0 : offer.list) === null || _a === void 0 ? void 0 : _a[rowIndex],
                    color: theme.colors.mediumEmphasis,
                    typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1
                  })
                }, offer.id);
              })
            }, rowIndex);
          })
        })]
      })
    })]
  });
};

const CashBackApplied = ({
  coupon
}) => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CashBackAppliedWrapper, {
    applied: false,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CouponTitleWrapper, {
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        text: coupon === null || coupon === void 0 ? void 0 : coupon.title,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.mediumEmphasis,
        margin: "0 0 8px"
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        text: coupon === null || coupon === void 0 ? void 0 : coupon.cta,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW3,
        color: theme.colors.mediumEmphasis,
        margin: "0 0 8px"
      })]
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.offerText,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.mediumEmphasis,
      margin: "0 0 8px"
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.validity,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.lowEmphasis,
      margin: "0 0 8px"
    })]
  });
};

const CouponDetailsBottomSheet = ({
  data,
  onModalClose
}) => {
  const device = useDevice();
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Modal, {
    modalType: device === DEVICE.DESKTOP ? 'centered' : 'bottomSheet',
    onModalClose: onModalClose,
    heading: data === null || data === void 0 ? void 0 : data.title,
    modalMaxHeight: device === DEVICE.MOBILE ? 'calc(100vh - 200px)' : '371px',
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CouponDetailsWrapper, {
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.label,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.mediumEmphasis,
        margin: "0 0 8px"
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CashBackApplied, {
        coupon: data === null || data === void 0 ? void 0 : data.coupon
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CouponList, {
        couponList: data === null || data === void 0 ? void 0 : data.couponList
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(OfferSlabs, {
        data: data === null || data === void 0 ? void 0 : data.offerSlabs
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(InfoSection, {
        data: data === null || data === void 0 ? void 0 : data.howToApply
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(InfoSection, {
        data: data === null || data === void 0 ? void 0 : data.tnc
      })]
    })
  });
};

var lengthOfArrayLike$2 = lengthOfArrayLike$6;
var toIntegerOrInfinity = toIntegerOrInfinity$3;

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
var arrayWith$1 = function (O, C, index, value) {
  var len = lengthOfArrayLike$2(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};

var $$9 = _export;
var arrayWith = arrayWith$1;
var toIndexedObject = toIndexedObject$6;

var $Array = Array;

// Firefox bug
var INCORRECT_EXCEPTION_ON_COERCION_FAIL = (function () {
  try {
    // eslint-disable-next-line es/no-array-prototype-with, no-throw-literal -- needed for testing
    []['with']({ valueOf: function () { throw 4; } }, null);
  } catch (error) {
    return error !== 4;
  }
})();

// `Array.prototype.with` method
// https://tc39.es/ecma262/#sec-array.prototype.with
$$9({ target: 'Array', proto: true, forced: INCORRECT_EXCEPTION_ON_COERCION_FAIL }, {
  'with': function (index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
});

var $$8 = _export;
var call$6 = functionCall;
var iterate$2 = iterate$4;
var aCallable$2 = aCallable$b;
var anObject$4 = anObject$k;
var getIteratorDirect$2 = getIteratorDirect$6;
var iteratorClose$2 = iteratorClose$a;
var iteratorHelperWithoutClosingOnEarlyError$2 = iteratorHelperWithoutClosingOnEarlyError$6;

var findWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$2('find', TypeError);

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
$$8({ target: 'Iterator', proto: true, real: true, forced: findWithoutClosingOnEarlyError }, {
  find: function find(predicate) {
    anObject$4(this);
    try {
      aCallable$2(predicate);
    } catch (error) {
      iteratorClose$2(this, 'throw', error);
    }

    if (findWithoutClosingOnEarlyError) return call$6(findWithoutClosingOnEarlyError, this, predicate);

    var record = getIteratorDirect$2(this);
    var counter = 0;
    return iterate$2(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, { IS_RECORD: true, INTERRUPTED: true }).result;
  }
});

var $$7 = _export;
var call$5 = functionCall;
var iterate$1 = iterate$4;
var aCallable$1 = aCallable$b;
var anObject$3 = anObject$k;
var getIteratorDirect$1 = getIteratorDirect$6;
var iteratorClose$1 = iteratorClose$a;
var iteratorHelperWithoutClosingOnEarlyError$1 = iteratorHelperWithoutClosingOnEarlyError$6;

var someWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$1('some', TypeError);

// `Iterator.prototype.some` method
// https://tc39.es/ecma262/#sec-iterator.prototype.some
$$7({ target: 'Iterator', proto: true, real: true, forced: someWithoutClosingOnEarlyError }, {
  some: function some(predicate) {
    anObject$3(this);
    try {
      aCallable$1(predicate);
    } catch (error) {
      iteratorClose$1(this, 'throw', error);
    }

    if (someWithoutClosingOnEarlyError) return call$5(someWithoutClosingOnEarlyError, this, predicate);

    var record = getIteratorDirect$1(this);
    var counter = 0;
    return iterate$1(record, function (value, stop) {
      if (predicate(value, counter++)) return stop();
    }, { IS_RECORD: true, INTERRUPTED: true }).stopped;
  }
});

var DESCRIPTORS$1 = descriptors;
var uncurryThis$2 = functionUncurryThis;
var call$4 = functionCall;
var fails$4 = fails$o;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$6;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis$2([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$4(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call$4(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$6 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$6({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$1 = functionUncurryThis;
var requireObjectCoercible$2 = requireObjectCoercible$6;
var toString$3 = toString$7;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$1(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$3(requireObjectCoercible$2($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$3 = fails$o;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$3(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$5 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$5({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var withSelector = {exports: {}};

var useSyncExternalStoreWithSelector_production = {};

/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreWithSelector_production;

function requireUseSyncExternalStoreWithSelector_production () {
	if (hasRequiredUseSyncExternalStoreWithSelector_production) return useSyncExternalStoreWithSelector_production;
	hasRequiredUseSyncExternalStoreWithSelector_production = 1;
	var React = react__WEBPACK_IMPORTED_MODULE_1__;
	function is(x, y) {
	  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
	}
	var objectIs = "function" === typeof Object.is ? Object.is : is,
	  useSyncExternalStore = React.useSyncExternalStore,
	  useRef = React.useRef,
	  useEffect = React.useEffect,
	  useMemo = React.useMemo,
	  useDebugValue = React.useDebugValue;
	useSyncExternalStoreWithSelector_production.useSyncExternalStoreWithSelector = function (
	  subscribe,
	  getSnapshot,
	  getServerSnapshot,
	  selector,
	  isEqual
	) {
	  var instRef = useRef(null);
	  if (null === instRef.current) {
	    var inst = { hasValue: false, value: null };
	    instRef.current = inst;
	  } else inst = instRef.current;
	  instRef = useMemo(
	    function () {
	      function memoizedSelector(nextSnapshot) {
	        if (!hasMemo) {
	          hasMemo = true;
	          memoizedSnapshot = nextSnapshot;
	          nextSnapshot = selector(nextSnapshot);
	          if (void 0 !== isEqual && inst.hasValue) {
	            var currentSelection = inst.value;
	            if (isEqual(currentSelection, nextSnapshot))
	              return (memoizedSelection = currentSelection);
	          }
	          return (memoizedSelection = nextSnapshot);
	        }
	        currentSelection = memoizedSelection;
	        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
	        var nextSelection = selector(nextSnapshot);
	        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
	          return (memoizedSnapshot = nextSnapshot), currentSelection;
	        memoizedSnapshot = nextSnapshot;
	        return (memoizedSelection = nextSelection);
	      }
	      var hasMemo = false,
	        memoizedSnapshot,
	        memoizedSelection,
	        maybeGetServerSnapshot =
	          void 0 === getServerSnapshot ? null : getServerSnapshot;
	      return [
	        function () {
	          return memoizedSelector(getSnapshot());
	        },
	        null === maybeGetServerSnapshot
	          ? void 0
	          : function () {
	              return memoizedSelector(maybeGetServerSnapshot());
	            }
	      ];
	    },
	    [getSnapshot, getServerSnapshot, selector, isEqual]
	  );
	  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
	  useEffect(
	    function () {
	      inst.hasValue = true;
	      inst.value = value;
	    },
	    [value]
	  );
	  useDebugValue(value);
	  return value;
	};
	return useSyncExternalStoreWithSelector_production;
}

var useSyncExternalStoreWithSelector_development = {};

/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreWithSelector_development;

function requireUseSyncExternalStoreWithSelector_development () {
	if (hasRequiredUseSyncExternalStoreWithSelector_development) return useSyncExternalStoreWithSelector_development;
	hasRequiredUseSyncExternalStoreWithSelector_development = 1;
	 false &&
	  0;
	return useSyncExternalStoreWithSelector_development;
}

if (true) {
  withSelector.exports = requireUseSyncExternalStoreWithSelector_production();
} else {}

var withSelectorExports = withSelector.exports;

// src/utils/react.ts

// src/components/Context.ts
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function getContext() {
  if (!react__WEBPACK_IMPORTED_MODULE_1__.createContext) return {};
  const contextMap = gT[ContextKey] ??= /* @__PURE__ */ new Map();
  let realContext = contextMap.get(react__WEBPACK_IMPORTED_MODULE_1__.createContext);
  if (!realContext) {
    realContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext(
      null
    );
    if (false) {}
    contextMap.set(react__WEBPACK_IMPORTED_MODULE_1__.createContext, realContext);
  }
  return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();

// src/hooks/useReduxContext.ts
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext2() {
    const contextValue = react__WEBPACK_IMPORTED_MODULE_1__.useContext(context);
    if (false) {}
    return contextValue;
  };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();

// src/hooks/useStore.ts
function createStoreHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : (
    // @ts-ignore
    createReduxContextHook(context)
  );
  const useStore2 = () => {
    const { store } = useReduxContext2();
    return store;
  };
  Object.assign(useStore2, {
    withTypes: () => useStore2
  });
  return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();

// src/hooks/useDispatch.ts
function createDispatchHook(context = ReactReduxContext) {
  const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
  const useDispatch2 = () => {
    const store = useStore2();
    return store.dispatch;
  };
  Object.assign(useDispatch2, {
    withTypes: () => useDispatch2
  });
  return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b) => a === b;
function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
  const useSelector2 = (selector, equalityFnOrOptions = {}) => {
    const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? { equalityFn: equalityFnOrOptions } : equalityFnOrOptions;
    if (false) {}
    const reduxContext = useReduxContext2();
    const { store, subscription, getServerState } = reduxContext;
    const firstRun = react__WEBPACK_IMPORTED_MODULE_1__.useRef(true);
    const wrappedSelector = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
      {
        [selector.name](state) {
          const selected = selector(state);
          if (false) {}
          return selected;
        }
      }[selector.name],
      [selector]
    );
    const selectedState = withSelectorExports.useSyncExternalStoreWithSelector(
      subscription.addNestedSub,
      store.getState,
      getServerState || store.getState,
      wrappedSelector,
      equalityFn
    );
    react__WEBPACK_IMPORTED_MODULE_1__.useDebugValue(selectedState);
    return selectedState;
  };
  Object.assign(useSelector2, {
    withTypes: () => useSelector2
  });
  return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();

const SelectCurrencyWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SelectCurrencyWrapper",
  componentId: "mp1wbz-0"
})(["background:", ";"], ({
  theme
}) => theme.colors.white);
const SelectCurrencyHeader = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SelectCurrencyHeader",
  componentId: "mp1wbz-1"
})(["height:70px;display:flex;flex-direction:column;"]);
const Scroller = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__Scroller",
  componentId: "mp1wbz-2"
})(["overflow-y:scroll;height:379px;margin-top:16px;@media ", "{height:calc(100vh - 200px);padding:0;}"], deviceType.mobile);
const CurrencyListHeader = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__CurrencyListHeader",
  componentId: "mp1wbz-3"
})(["display:flex;flex-direction:row;padding:12px 8px;background:", ";justify-content:space-between;align-items:flex-start;border-bottom:1px solid ", ";padding:12px 0px;"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.colors.borderBottomGreyColor);
const CountryList = /*#__PURE__*/Ye.ul.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__CountryList",
  componentId: "mp1wbz-4"
})(["li{display:flex;cursor:pointer;padding:16px 0px;border-bottom:1px solid ", ";@media ", "{&:hover{background-color:", ";border-radius:", ";}}}li .highlight{background-color:", ";}"], ({
  theme
}) => theme.colors.borderBottomGreyColor, deviceType.desktop, ({
  theme
}) => theme.colors.bodyBg, ({
  theme
}) => theme.borderRadius.br2, ({
  theme
}) => theme.colors.bgLight);
const CurrencyDetailsWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__CurrencyDetailsWrapper",
  componentId: "mp1wbz-5"
})(["display:flex;flex-direction:row;gap:10px;cursor:pointer;justify-content:space-between;align-items:flex-start;flex:1;"]);
const LeftLabelWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__LeftLabelWrapper",
  componentId: "mp1wbz-6"
})(["gap:0px;display:flex;flex-direction:row;align-items:center;cursor:pointer;"]);
const SubLabel = /*#__PURE__*/Ye.p.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SubLabel",
  componentId: "mp1wbz-7"
})(["", ""], props => {
  const {
    theme,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1,
    color,
    textAlign
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.getTypographyStyles)(typography, theme.partner);
  return Ne(["", " ", " font-family:", ";color:", ";text-align:", ";"], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, color || theme.colors.mediumW3, textAlign);
});
const Span = /*#__PURE__*/Ye.span.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__Span",
  componentId: "mp1wbz-8"
})(["", ""], props => {
  const {
    theme,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1,
    color
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.getTypographyStyles)(typography, theme.partner);
  return Ne(["", " ", " font-family:", ";color:", ";"], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, color || theme.colors.mediumW3);
});
const TagContainer = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__TagContainer",
  componentId: "mp1wbz-9"
})(["max-width:200px;word-break:break-word;"]);
const SelectCurrencyWebCont = /*#__PURE__*/Ye.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SelectCurrencyWebCont",
  componentId: "mp1wbz-11"
})(["background:", ";max-height:390px;border-radius:4px;"], ({
  theme
}) => theme.colors.white);
const HighlightText = /*#__PURE__*/Ye.span.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__HighlightText",
  componentId: "mp1wbz-12"
})(["background-color:", ";padding:2px 4px;border-radius:4px;font-weight:600;"], ({
  theme
}) => theme.colors.bgLight);

var $$4 = _export;
var $includes = arrayIncludes.includes;
var fails$2 = fails$o;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$2(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$4({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var classof$1 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof$1(argument) === 'Array';
};

var DESCRIPTORS = descriptors;
var isArray$1 = isArray$2;

var $TypeError$4 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray$1(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError$4('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$3 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$2 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$3('Maximum allowed index exceeded');
  return it;
};

var $$3 = _export;
var toObject$1 = toObject$6;
var lengthOfArrayLike$1 = lengthOfArrayLike$6;
var setArrayLength$1 = arraySetLength;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
var fails$1 = fails$o;

var INCORRECT_TO_LENGTH = fails$1(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength$1 = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED$1 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength$1();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$3({ target: 'Array', proto: true, arity: 1, forced: FORCED$1 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike$1(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger$1(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength$1(O, len);
    return len;
  }
});

var tryToString = tryToString$4;

var $TypeError$2 = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw new $TypeError$2('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var $$2 = _export;
var toObject = toObject$6;
var lengthOfArrayLike = lengthOfArrayLike$6;
var setArrayLength = arraySetLength;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$$2({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return setArrayLength(O, len + argCount);
  }
});

var $$1 = _export;
var call$3 = functionCall;
var iterate = iterate$4;
var aCallable = aCallable$b;
var anObject$2 = anObject$k;
var getIteratorDirect = getIteratorDirect$6;
var iteratorClose = iteratorClose$a;
var iteratorHelperWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$6;

var forEachWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('forEach', TypeError);

// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
$$1({ target: 'Iterator', proto: true, real: true, forced: forEachWithoutClosingOnEarlyError }, {
  forEach: function forEach(fn) {
    anObject$2(this);
    try {
      aCallable(fn);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }

    if (forEachWithoutClosingOnEarlyError) return call$3(forEachWithoutClosingOnEarlyError, this, fn);

    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function (value) {
      fn(value, counter++);
    }, { IS_RECORD: true });
  }
});

var isRegExp = isRegexp;

var $TypeError$1 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$1("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$h;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $ = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var toString$2 = toString$7;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$2(requireObjectCoercible$1(this)),
      toString$2(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$2 = functionCall;
var defineBuiltIn = defineBuiltIn$7;
var regexpExec$1 = regexpExec$2;
var fails = fails$o;
var wellKnownSymbol = wellKnownSymbol$h;
var createNonEnumerableProperty = createNonEnumerableProperty$7;

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$2(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$2(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call$1 = functionCall;
var anObject$1 = anObject$k;
var isCallable = isCallable$i;
var classof = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call$1(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call$1(regexpExec, R, S);
  throw new $TypeError('RegExp#exec called on incompatible receiver');
};

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$k;
var isObject$1 = isObject$c;
var requireObjectCoercible = requireObjectCoercible$6;
var sameValue = sameValue$1;
var toString$1 = toString$7;
var getMethod = getMethod$5;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isObject$1(regexp) ? getMethod(regexp, SEARCH) : undefined;
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$1(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString$1(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

function isArray(value) {
  return !Array.isArray
    ? getTag(value) === '[object Array]'
    : Array.isArray(value)
}
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value
  }
  let result = value + '';
  return result == '0' && 1 / value == -Infinity ? '-0' : result
}

function toString(value) {
  return value == null ? '' : baseToString(value)
}

function isString(value) {
  return typeof value === 'string'
}

function isNumber(value) {
  return typeof value === 'number'
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag(value) == '[object Boolean]')
  )
}

function isObject(value) {
  return typeof value === 'object'
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return isObject(value) && value !== null
}

function isDefined(value) {
  return value !== undefined && value !== null
}

function isBlank(value) {
  return !value.trim().length
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null
    ? value === undefined
      ? '[object Undefined]'
      : '[object Null]'
    : Object.prototype.toString.call(value)
}

const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
  `Invalid value for key ${key}`;

const PATTERN_LENGTH_TOO_LARGE = (max) =>
  `Pattern length exceeds max of ${max}.`;

const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;

const INVALID_KEY_WEIGHT_VALUE = (key) =>
  `Property 'weight' in key '${key}' must be a positive integer`;

const hasOwn = Object.prototype.hasOwnProperty;

class KeyStore {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};

    let totalWeight = 0;

    keys.forEach((key) => {
      let obj = createKey(key);

      this._keys.push(obj);
      this._keyMap[obj.id] = obj;

      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId]
  }
  keys() {
    return this._keys
  }
  toJSON() {
    return JSON.stringify(this._keys)
  }
}

function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;

  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'))
    }

    const name = key.name;
    src = name;

    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name))
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }

  return { path, id, weight, src, getFn }
}

function createKeyPath(key) {
  return isArray(key) ? key : key.split('.')
}

function createKeyId(key) {
  return isArray(key) ? key.join('.') : key
}

function get(obj, path) {
  let list = [];
  let arr = false;

  const deepGet = (obj, path, index) => {
    if (!isDefined(obj)) {
      return
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      let key = path[index];

      const value = obj[key];

      if (!isDefined(value)) {
        return
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (
        index === path.length - 1 &&
        (isString(value) || isNumber(value) || isBoolean(value))
      ) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);

  return arr ? list : list[0]
}

const MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};

const BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) =>
    a.score === b.score ? (a.idx < b.idx ? -1 : 1) : a.score < b.score ? -1 : 1
};

const FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};

const AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};

const SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
  const cache = new Map();
  const m = Math.pow(10, mantissa);

  return {
    get(value) {
      const numTokens = value.match(SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens)
      }

      // Default function is 1/sqrt(x), weight makes that variable
      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      const n = parseFloat(Math.round(norm * m) / m);

      cache.set(numTokens, n);

      return n
    },
    clear() {
      cache.clear();
    }
  }
}

class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;

    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return
    }

    this.isCreated = true;

    // List is Array<String>
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      // List is Array<Object>
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }

    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();

    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);

    // Change ref index of every subsquent doc
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]]
  }
  size() {
    return this.records.length
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return
    }

    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };

    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };

    // Iterate over every key (i.e, path), and fetch the value at that key
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);

      if (!isDefined(value)) {
        return
      }

      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];

        while (stack.length) {
          const { nestedArrIndex, value } = stack.pop();

          if (!isDefined(value)) {
            continue
          }

          if (isString(value) && !isBlank(value)) {
            let subRecord = {
              v: value,
              i: nestedArrIndex,
              n: this.norm.get(value)
            };

            subRecords.push(subRecord);
          } else if (isArray(value)) {
            value.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else ;
        }
        record.$[keyIndex] = subRecords;
      } else if (isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };

        record.$[keyIndex] = subRecord;
      }
    });

    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    }
  }
}

function createIndex(
  keys,
  docs,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex
}

function parseIndex(
  data,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex
}

function computeScore$1(
  pattern,
  {
    errors = 0,
    currentLocation = 0,
    expectedLocation = 0,
    distance = Config.distance,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  const accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy
  }

  const proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy
  }

  return accuracy + proximity / distance
}

function convertMaskToIndices(
  matchmask = [],
  minMatchCharLength = Config.minMatchCharLength
) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;

  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices
}

// Machine word size
const MAX_BITS = 32;

function search(
  text,
  pattern,
  patternAlphabet,
  {
    location = Config.location,
    distance = Config.distance,
    threshold = Config.threshold,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    includeMatches = Config.includeMatches,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS))
  }

  const patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  const textLen = text.length;
  // Handle the case when location > text.length
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  let currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  let bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  const matchMask = computeMatches ? Array(textLen) : [];

  let index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });

    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;

  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;

  const mask = 1 << (patternLen - 1);

  for (let i = 0; i < patternLen; i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    let binMin = 0;
    let binMid = binMax;

    while (binMin < binMid) {
      const score = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });

      if (score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches
      ? textLen
      : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    let bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << i) - 1;

    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (i) {
        bitArr[j] |=
          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });

    if (score > currentThreshold) {
      break
    }

    lastBitArr = bitArr;
  }

  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result
}

function createPatternAlphabet(pattern) {
  let mask = {};

  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
  }

  return mask
}

class BitapSearch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();

    this.chunks = [];

    if (!this.pattern.length) {
      return
    }

    const addChunk = (pattern, startIndex) => {
      this.chunks.push({
        pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex
      });
    };

    const len = this.pattern.length;

    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  searchIn(text) {
    const { isCaseSensitive, includeMatches } = this.options;

    if (!isCaseSensitive) {
      text = text.toLowerCase();
    }

    // Exact match
    if (this.pattern === text) {
      let result = {
        isMatch: true,
        score: 0
      };

      if (includeMatches) {
        result.indices = [[0, text.length - 1]];
      }

      return result
    }

    // Otherwise, use Bitap algorithm
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;

    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;

    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search(text, pattern, alphabet, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });

      if (isMatch) {
        hasMatches = true;
      }

      totalScore += score;

      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });

    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };

    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }

    return result
  }
}

class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex)
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex)
  }
  search(/*text*/) {}
}

function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null
}

// Token: 'file

class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'exact'
  }
  static get multiRegex() {
    return /^="(.*)"$/
  }
  static get singleRegex() {
    return /^=(.*)$/
  }
  search(text) {
    const isMatch = text === this.pattern;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !fire

class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"$/
  }
  static get singleRegex() {
    return /^!(.*)$/
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: ^file

class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'prefix-exact'
  }
  static get multiRegex() {
    return /^\^"(.*)"$/
  }
  static get singleRegex() {
    return /^\^(.*)$/
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !^fire

class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-prefix-exact'
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/
  }
  static get singleRegex() {
    return /^!\^(.*)$/
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: .file$

class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'suffix-exact'
  }
  static get multiRegex() {
    return /^"(.*)"\$$/
  }
  static get singleRegex() {
    return /^(.*)\$$/
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    }
  }
}

// Token: !.file$

class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-suffix-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/
  }
  static get singleRegex() {
    return /^!(.*)\$$/
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

class FuzzyMatch extends BaseMatch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return 'fuzzy'
  }
  static get multiRegex() {
    return /^"(.*)"$/
  }
  static get singleRegex() {
    return /^(.*)$/
  }
  search(text) {
    return this._bitapSearch.searchIn(text)
  }
}

// Token: 'file

class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'include'
  }
  static get multiRegex() {
    return /^'"(.*)"$/
  }
  static get singleRegex() {
    return /^'(.*)$/
  }
  search(text) {
    let location = 0;
    let index;

    const indices = [];
    const patternLen = this.pattern.length;

    // Get all exact matches
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }

    const isMatch = !!indices.length;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    }
  }
}

// ❗Order is important. DO NOT CHANGE.
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];

const searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item
      .trim()
      .split(SPACE_RE)
      .filter((item) => item && !!item.trim());

    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break
        }
      }
    }

    return results
  })
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
class ExtendedSearch {
  constructor(
    pattern,
    {
      isCaseSensitive = Config.isCaseSensitive,
      includeMatches = Config.includeMatches,
      minMatchCharLength = Config.minMatchCharLength,
      ignoreLocation = Config.ignoreLocation,
      findAllMatches = Config.findAllMatches,
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance
    } = {}
  ) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }

  static condition(_, options) {
    return options.useExtendedSearch
  }

  searchIn(text) {
    const query = this.query;

    if (!query) {
      return {
        isMatch: false,
        score: 1
      }
    }

    const { includeMatches, isCaseSensitive } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();

    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;

    // ORs
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers = query[i];

      // Reset indices
      allIndices.length = 0;
      numMatches = 0;

      // ANDs
      for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
        const searcher = searchers[j];
        const { isMatch, indices, score } = searcher.search(text);

        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break
        }
      }

      // OR condition, so if TRUE, return
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };

        if (includeMatches) {
          result.indices = allIndices;
        }

        return result
      }
    }

    // Nothing was matched
    return {
      isMatch: false,
      score: 1
    }
  }
}

const registeredSearchers = [];

function register(...args) {
  registeredSearchers.push(...args);
}

function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options)
    }
  }

  return new BitapSearch(pattern, options)
}

const LogicalOperator = {
  AND: '$and',
  OR: '$or'
};

const KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

const isExpression = (query) =>
  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

const isPath = (query) => !!query[KeyType.PATH];

const isLeaf = (query) =>
  !isArray(query) && isObject(query) && !isExpression(query);

const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options, { auto = true } = {}) {
  const next = (query) => {
    let keys = Object.keys(query);

    const isQueryPath = isPath(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query))
    }

    if (isLeaf(query)) {
      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

      const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key))
      }

      const obj = {
        keyId: createKeyId(key),
        pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj
    }

    let node = {
      children: [],
      operator: keys[0]
    };

    keys.forEach((key) => {
      const value = query[key];

      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });

    return node
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query)
}

// Practical scoring function
function computeScore(
  results,
  { ignoreFieldNorm = Config.ignoreFieldNorm }
) {
  results.forEach((result) => {
    let totalScore = 1;

    result.matches.forEach(({ key, norm, score }) => {
      const weight = key ? key.weight : null;

      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
      );
    });

    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return
  }

  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return
    }

    const { indices, value } = match;

    let obj = {
      indices,
      value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format(
  results,
  docs,
  {
    includeMatches = Config.includeMatches,
    includeScore = Config.includeScore
  } = {}
) {
  const transformers = [];

  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);

  return results.map((result) => {
    const { idx } = result;

    const data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }

    return data
  })
}

class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };

    if (
      this.options.useExtendedSearch &&
      false
    ) {}

    this._keyStore = new KeyStore(this.options.keys);

    this.setCollection(docs, index);
  }

  setCollection(docs, index) {
    this._docs = docs;

    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE)
    }

    this._myIndex =
      index ||
      createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
  }

  add(doc) {
    if (!isDefined(doc)) {
      return
    }

    this._docs.push(doc);
    this._myIndex.add(doc);
  }

  remove(predicate = (/* doc, idx */) => false) {
    const results = [];

    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;

        results.push(doc);
      }
    }

    return results
  }

  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }

  getIndex() {
    return this._myIndex
  }

  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;

    let results = isString(query)
      ? isString(this._docs[0])
        ? this._searchStringList(query)
        : this._searchObjectList(query)
      : this._searchLogical(query);

    computeScore(results, { ignoreFieldNorm });

    if (shouldSort) {
      results.sort(sortFn);
    }

    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }

    return format(results, this._docs, {
      includeMatches,
      includeScore
    })
  }

  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];

    // Iterate over every string in the index
    records.forEach(({ v: text, i: idx, n: norm }) => {
      if (!isDefined(text)) {
        return
      }

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm, indices }]
        });
      }
    });

    return results
  }

  _searchLogical(query) {

    const expression = parse(query, this.options);

    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;

        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });

        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ]
        }

        return []
      }

      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return []
        }
      }
      return res
    };

    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];

    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);

        if (expResults.length) {
          // Dedupe when adding
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });

    return results
  }

  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys, records } = this._myIndex;
    const results = [];

    // List is Array<Object>
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return
      }

      let matches = [];

      // Iterate over every key (i.e, path), and fetch the value at that key
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });

      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });

    return results
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return []
    }

    let matches = [];

    if (isArray(value)) {
      value.forEach(({ v: text, i: idx, n: norm }) => {
        if (!isDefined(text)) {
          return
        }

        const { isMatch, score, indices } = searcher.searchIn(text);

        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm } = value;

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        matches.push({ score, key, value: text, norm, indices });
      }
    }

    return matches
  }
}

Fuse.version = '7.0.0';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;

{
  Fuse.parseQuery = parse;
}

{
  register(ExtendedSearch);
}

const searchCurrency = (query, popularCurrencyList, otherCurrencyList, allCurrencies) => {
  const associatedCurrencyResult = [];
  const searchedPopular = popularCurrencyList.filter(currItem => {
    var _a, _b, _c, _d, _e;
    if (query.length > 3) {
      let associateFound = false;
      (_a = currItem.associatedCurrencies) === null || _a === void 0 ? void 0 : _a.map(associateCurrItem => {
        var _a, _b, _c;
        if ((_a = associateCurrItem.country) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_b = associateCurrItem.currencyCode) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_c = associateCurrItem.currencyName) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        return false;
      });
      if (associateFound) {
        return true;
      }
    }
    if (currItem.leftLabel.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if ((_b = currItem.currencyCode) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if ((_c = currItem.homeCountryCode) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    let found = false;
    (_d = currItem.supportedCities) === null || _d === void 0 ? void 0 : _d.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
      return found;
    });
    (_e = currItem.supportedCountries) === null || _e === void 0 ? void 0 : _e.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
      return found;
    });
    return found;
  });
  const searchedOthers = otherCurrencyList.filter(currItem => {
    var _a, _b, _c, _d, _e;
    if (query.length > 3) {
      let associateFound = false;
      (_a = currItem.associatedCurrencies) === null || _a === void 0 ? void 0 : _a.map(associateCurrItem => {
        var _a, _b, _c;
        if ((_a = associateCurrItem.country) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_b = associateCurrItem.currencyCode) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_c = associateCurrItem.currencyName) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        return false;
      });
      if (associateFound) {
        return true;
      }
    }
    if (currItem.leftLabel.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if ((_b = currItem.currencyCode) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if ((_c = currItem.homeCountryCode) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    let found = false;
    (_d = currItem.supportedCities) === null || _d === void 0 ? void 0 : _d.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
      return found;
    });
    (_e = currItem.supportedCountries) === null || _e === void 0 ? void 0 : _e.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
      return found;
    });
    return found;
  });
  const fuzzyPopular = [];
  const fuzzyOthers = [];
  if (searchedPopular.length === 0 && searchedOthers.length === 0) {
    const options = {
      keys: ['associatedCurrencies', 'supportedCities', 'supportedCountries', 'currencyCode', 'leftLabel']
    };
    const fuse = new Fuse(allCurrencies, options);
    const fuzzyResults = fuse.search(query).slice(0, 3).map(item => item.item);
    fuzzyPopular.push(...fuzzyResults.filter(item => {
      var _a;
      return (_a = item === null || item === void 0 ? void 0 : item.isPopular) !== null && _a !== void 0 ? _a : false;
    }));
    fuzzyOthers.push(...fuzzyResults.filter(item => {
      return !(item === null || item === void 0 ? void 0 : item.isPopular);
    }));
  }
  return [searchedPopular, searchedOthers, fuzzyPopular, fuzzyOthers, associatedCurrencyResult];
};

const CurrencySuggestionWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CurrencySuggestionstyle__CurrencySuggestionWrapper",
  componentId: "ybnwk1-0"
})(["border:1px solid ", ";border-radius:", ";margin:12px 0px;margin-bottom:60px;"], ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.borderRadius.br8);
const USDInfo = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CurrencySuggestionstyle__USDInfo",
  componentId: "ybnwk1-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;background:", ";padding:12px;border-radius:8px 8px 0px 0px;margin:0px 0px 16px;"], ({
  theme
}) => theme.colors.screenBg);
const WhyInfoWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CurrencySuggestionstyle__WhyInfoWrapper",
  componentId: "ybnwk1-2"
})(["padding:0px 12px 12px;margin:2px 0px 0px;"]);
const LabelBar = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CurrencySuggestionstyle__LabelBar",
  componentId: "ybnwk1-3"
})(["width:2px;height:8px;border-radius:2px;background:#084373;"]);
const FeatureWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CurrencySuggestionstyle__FeatureWrapper",
  componentId: "ybnwk1-4"
})(["margin:6px 0px 0px;"]);
const InnerWrapper = /*#__PURE__*/Ye.div.withConfig({
  displayName: "CurrencySuggestionstyle__InnerWrapper",
  componentId: "ybnwk1-5"
})(["flex-direction:row;align-items:center;gap:10px;padding:0;display:flex;"]);

const CurrencySuggestion = ({
  recommendedCurrencyInfo
}) => {
  var _a, _b;
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CurrencySuggestionWrapper, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(USDInfo, {
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        text: recommendedCurrencyInfo === null || recommendedCurrencyInfo === void 0 ? void 0 : recommendedCurrencyInfo.title,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.highEmphasis
      })
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(WhyInfoWrapper, {
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        text: recommendedCurrencyInfo === null || recommendedCurrencyInfo === void 0 ? void 0 : recommendedCurrencyInfo.label,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1,
        color: theme.colors.lowEmphasis
      }), (_b = (_a = recommendedCurrencyInfo === null || recommendedCurrencyInfo === void 0 ? void 0 : recommendedCurrencyInfo.featList) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, (item, index) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FeatureWrapper, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(InnerWrapper, {
          children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LabelBar, {}), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
            color: theme.colors.highEmphasis,
            typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1,
            text: item
          })]
        })
      }, index.toString()))]
    })]
  });
};

// Toast utility for common-ui to avoid circular dependencies
const createToastAction = dispatch => ({
  showToast: message => {
    dispatch({
      type: 'toastData/showToastMessage',
      payload: {
        message,
        showCrossIcon: true,
        duration: 5000
      }
    });
  },
  hideToast: () => {
    dispatch({
      type: 'toastData/hideToastMessage'
    });
  }
});

const SelectCurrency = ({
  value,
  onChange,
  currencyItemHandler,
  currencyData,
  showHighlighter: _showHighlighter = true,
  isFetchingRate,
  notFoundText,
  data,
  rates
}) => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Be);
  const device = useDevice();
  const dispatch = useDispatch();
  const toastActions = createToastAction(dispatch);
  const cards = useSelector(state => {
    var _a;
    return ((_a = state.order) === null || _a === void 0 ? void 0 : _a.cards) || [];
  });
  // Memoize currency list
  const currencyList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => currencyData ? Object.entries(currencyData).map(([key, item]) => Object.assign(Object.assign({}, item), {
    id: key
  })) : [], [currencyData]);
  // Separate popular and other currencies
  const {
    popularCurrencies,
    allCurrencies
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    const popular = currencyList.filter(item => item.isPopular);
    const others = currencyList.filter(item => !item.isPopular);
    return {
      popularCurrencies: popular,
      allCurrencies: others
    };
  }, [currencyList]);
  // Search state
  const [searchedPopular, setSearchedPopular] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(popularCurrencies);
  const [searchedOthers, setSearchedOthers] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(allCurrencies);
  const [fuzzyPopular, setFuzzyPopular] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  const [fuzzyOthers, setFuzzyOthers] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  const [associatedCurrency, setAssociatedCurrency] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  const [showSuggestion, setShowSuggestion] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const [suggestionVisible, setSuggestionVisible] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  // Handle search
  const handleSearch = event => {
    const searchValue = event.target.value;
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (!searchValue.trim()) {
      setSearchedPopular(popularCurrencies);
      setSearchedOthers(allCurrencies);
      setFuzzyPopular([]);
      setFuzzyOthers([]);
      setAssociatedCurrency([]);
      setShowSuggestion(false);
      setSuggestionVisible(false);
      return;
    }
    const [popular, others, fuzzyPop, fuzzyOth, associated] = searchCurrency(searchValue.trim(), popularCurrencies, allCurrencies, currencyList);
    setAssociatedCurrency(associated);
    setSearchedPopular(popular);
    if (others.length === 0 && popular.length === 0) {
      setSuggestionVisible(true);
      setShowSuggestion(true);
      setSearchedPopular(fuzzyPop.length === 0 ? popularCurrencies.slice(0, 1) : fuzzyPop);
    } else {
      setSuggestionVisible(associated.length > 0);
    }
    setSearchedOthers(others.length > 0 ? others : fuzzyOth);
    setFuzzyPopular(fuzzyPop);
    setFuzzyOthers(fuzzyOth);
  };
  // Render search highlighter
  const searchQueryHighlighter = (ele, nameToSearch) => {
    const searchTerm = (value === null || value === void 0 ? void 0 : value.trim().toLowerCase()) || '';
    const text = ele[nameToSearch] || '';
    if (!searchTerm || !text) {
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TagContainer, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SubLabel, {
          typography: nameToSearch === 'rightLabel' ? _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1 : _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
          color: nameToSearch === 'rightLabel' ? theme.colors.mediumEmphasis : theme.colors.highEmphasis,
          textAlign: nameToSearch === 'rightLabel' ? 'right' : 'left',
          children: text
        })
      });
    }
    const index = text.toLowerCase().indexOf(searchTerm);
    if (index === -1) {
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TagContainer, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SubLabel, {
          typography: nameToSearch === 'rightLabel' ? _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1 : _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
          color: nameToSearch === 'rightLabel' ? theme.colors.mediumEmphasis : theme.colors.highEmphasis,
          textAlign: nameToSearch === 'rightLabel' ? 'right' : 'left',
          children: text
        })
      });
    }
    const beforeMatch = text.substring(0, index);
    const match = text.substring(index, index + searchTerm.length);
    const afterMatch = text.substring(index + searchTerm.length);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TagContainer, {
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(SubLabel, {
        typography: nameToSearch === 'rightLabel' ? _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1 : _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW1,
        color: nameToSearch === 'rightLabel' ? theme.colors.mediumEmphasis : theme.colors.highEmphasis,
        textAlign: nameToSearch === 'rightLabel' ? 'right' : 'left',
        children: [beforeMatch, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HighlightText, {
          children: match
        }), afterMatch]
      })
    });
  };
  const handleCurrencyClick = (item, idx) => {
    const selectedCurrency = rates ? Object.values(rates).find(curr => curr.currencyCode === item.currencyCode) : undefined;
    const recommendedCurrencyCode = selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.recommendedCurrencyCode;
    const isCurrencyUnavailable = selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.VARS_CURR_RATE;
    if (recommendedCurrencyCode && !isCurrencyUnavailable) {
      const isDuplicate = cards.some(card => card.currency === recommendedCurrencyCode);
      if (isDuplicate) {
        toastActions.showToast(TOAST_MESSAGES.ALREADY_ADDED_CURRENCY);
        return;
      }
    }
    currencyItemHandler === null || currencyItemHandler === void 0 ? void 0 : currencyItemHandler(item, item.id, idx);
  };
  // Render a single currency row
  const renderCurrencyRow = (item, idx) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("li", {
    onClick: e => {
      e.stopPropagation();
      handleCurrencyClick(item, idx);
    },
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.RadioButton, {
      inputId: idx.toString(),
      isChecked: !!item.isChecked,
      inputIndex: idx,
      showLabel: false
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CurrencyDetailsWrapper, {
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(LeftLabelWrapper, {
        children: [searchQueryHighlighter(item, 'leftLabel'), item.isChecked && isFetchingRate && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Spinner, {
          spinnerWidth: 20
        })]
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Span, {
        children: searchQueryHighlighter(item, 'rightLabel')
      })]
    })]
  }, item.id);
  // Render a currency list section
  const renderCurrencyList = (currencies, title) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [title && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(CurrencyListHeader, {
      id: "currency-section-id",
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        text: title,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW3,
        color: theme.colors.highEmphasis
      }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        text: 'Countries',
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.smallW3,
        color: theme.colors.highEmphasis
      })]
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CountryList, {
      id: "country-list-wpr-id",
      children: currencies.map(renderCurrencyRow)
    })]
  });
  // Render currency suggestion
  const renderUncommonCurrency = () => {
    var _a, _b, _c, _d;
    if (associatedCurrency.length >= 1) {
      const currName = (_b = (_a = associatedCurrency[0]) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.leftLabel;
      const withName = (_d = (_c = associatedCurrency[0]) === null || _c === void 0 ? void 0 : _c.with) === null || _d === void 0 ? void 0 : _d.currencyName;
      const vars = {
        [RTVars.SEARCHED_CURRENCY]: withName !== null && withName !== void 0 ? withName : '',
        [RTVars.SUGGESTED_CURRENCY]: currName !== null && currName !== void 0 ? currName : ''
      };
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CurrencySuggestion, {
        recommendedCurrencyInfo: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.hydrateVars)(data === null || data === void 0 ? void 0 : data.currencyUnavailableSection, vars)
      });
    } else if (showSuggestion) {
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CurrencySuggestion, {
        recommendedCurrencyInfo: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.hydrateVars)(data === null || data === void 0 ? void 0 : data.suggestionSection, {})
      });
    }
    return null;
  };
  const handleFocus = () => {
    var _a, _b, _c;
    (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_6__.trackEvent)({
      eventData: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.tracking) === null || _a === void 0 ? void 0 : _a.currencySearched) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.pdtData
    });
  };
  // Main render
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(SelectCurrencyWrapper, {
    children: [device === DEVICE.MOBILE && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectCurrencyHeader, {
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FloatingTextField, {
        value: value,
        labelTxt: "Search Currency",
        onChange: handleSearch,
        inputId: "select-currency-dropdown"
      })
    }), device === DEVICE.DESKTOP && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FloatingTextField, {
      value: value,
      onChange: handleSearch,
      onFocus: handleFocus,
      labelTxt: "Search Currency/Country"
    }), currencyData && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Scroller, {
      children: currencyList.length === 0 ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_5__.TYPOGRAPHY_KEYS.baseW1,
        text: notFoundText || 'No currency found',
        color: theme.colors.mediumEmphasis,
        margin: "0 0 16px"
      }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [searchedPopular.length > 0 && renderCurrencyList(searchedPopular, 'Popular Currencies'), searchedOthers.length > 0 && renderCurrencyList(searchedOthers, 'All Currencies'), searchedPopular.length === 0 && searchedOthers.length === 0 && (fuzzyPopular.length > 0 || fuzzyOthers.length > 0) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
          children: [fuzzyPopular.length > 0 && renderCurrencyList(fuzzyPopular, 'Popular Currencies'), fuzzyOthers.length > 0 && renderCurrencyList(fuzzyOthers, 'All Currencies')]
        }), suggestionVisible && renderUncommonCurrency()]
      })
    })]
  });
};

const SelectCurrencyBottomSheet = ({
  onModalClose,
  data,
  value,
  onChange,
  currencyItemHandler,
  currencyData,
  isFetchingRate,
  notFoundText,
  rates
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Modal, {
    modalType: 'fullPage',
    onModalClose: onModalClose,
    heading: (data === null || data === void 0 ? void 0 : data.title) || 'Select Currency',
    backBtn: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Image, {
      src: 'https://tripmoneycmsimgak.mmtcdn.com/img/Close_c959c0738b.png'
    }),
    "data-testid": "CURRENCY_SEARCH_BOTTOMSHEET",
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectCurrency, {
      value: value,
      onChange: onChange,
      showHighlighter: true,
      currencyItemHandler: currencyItemHandler,
      isFetchingRate: isFetchingRate,
      currencyData: currencyData,
      notFoundText: notFoundText,
      data: data,
      rates: rates
    })
  });
};

const SelectCurrencyDweb = ({
  onModalClose,
  data,
  value,
  onChange,
  currencyItemHandler,
  currencyData,
  isFetchingRate,
  notFoundText,
  rates
}) => {
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var _a;
    (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_6__.trackEvent)({
      eventData: (_a = data === null || data === void 0 ? void 0 : data.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
    return () => {
      var _a, _b, _c;
      (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_6__.trackEvent)({
        eventData: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.tracking) === null || _a === void 0 ? void 0 : _a.bottomSheetDismissed) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.pdtData
      });
    };
  }, []);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_4__.Modal, {
    heading: data === null || data === void 0 ? void 0 : data.title,
    onModalClose: onModalClose,
    "data-testid": "CURRENCY_SEARCH_BOTTOMSHEET",
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectCurrencyWebCont, {
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectCurrency, {
        value: value,
        onChange: onChange,
        showHighlighter: true,
        currencyItemHandler: currencyItemHandler,
        isFetchingRate: isFetchingRate,
        currencyData: currencyData,
        notFoundText: notFoundText,
        data: data,
        rates: rates
      })
    })
  });
};

const SelectCurrencyModal = ({
  onModalClose,
  data,
  currencyData,
  isFetchingRate,
  notFoundText,
  currencyItemHandler,
  onChange,
  inputValue,
  rates
}) => {
  const device = useDevice();
  return device === DEVICE.MOBILE ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectCurrencyBottomSheet, {
    isFetchingRate: isFetchingRate,
    value: inputValue,
    onChange: onChange,
    currencyData: currencyData,
    notFoundText: notFoundText,
    onModalClose: onModalClose,
    currencyItemHandler: (ele, id, index) => currencyItemHandler === null || currencyItemHandler === void 0 ? void 0 : currencyItemHandler(ele, id, index),
    data: data
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectCurrencyDweb, {
    isFetchingRate: isFetchingRate,
    value: inputValue,
    onChange: e => {
      onChange === null || onChange === void 0 ? void 0 : onChange(e);
    },
    currencyData: currencyData,
    notFoundText: notFoundText,
    onModalClose: onModalClose,
    currencyItemHandler: (ele, id, index) => currencyItemHandler === null || currencyItemHandler === void 0 ? void 0 : currencyItemHandler(ele, id, index),
    data: data,
    rates: rates
  });
};

const useDefaultLocationTimer = ({
  initialTime: _initialTime = 0,
  interval: _interval = 1000
}) => {
  const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const timeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(_initialTime);
  const startTimer = callback => {
    if (timerRef.current === null) {
      timerRef.current = setInterval(() => {
        console.log('time:', timeRef.current);
        if (timeRef.current > 0) {
          timeRef.current -= _interval;
        } else {
          callback();
          resetTimer();
        }
      }, _interval);
    }
  };
  const resetTimer = () => {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    timeRef.current = _initialTime;
  };
  return {
    startTimer,
    resetTimer
  };
};

const initialLocation = {
  latitude: null,
  longitude: null
};
const initialState = {
  location: initialLocation,
  error: null,
  isError: false,
  isLoading: false,
  isSuccess: false
};
const LOCATION_FETCH_LOADING = 'LOCATION_FETCH_LOADING';
const LOCATION_FETCH_SUCCESS = 'LOCATION_FETCH_SUCCESS';
const LOCATION_FETCH_ERROR = 'LOCATION_FETCH_ERROR';
const RESET_LOCATION_STATE = 'RESET_LOCATION_STATE';
const reducer = (state, {
  type,
  payload
}) => {
  switch (type) {
    case LOCATION_FETCH_LOADING:
      return Object.assign(Object.assign({}, initialState), {
        isLoading: true
      });
    case LOCATION_FETCH_SUCCESS:
      return Object.assign(Object.assign({}, initialState), {
        location: payload,
        isSuccess: true
      });
    case LOCATION_FETCH_ERROR:
      return Object.assign(Object.assign({}, initialState), {
        isError: true,
        error: payload
      });
    case RESET_LOCATION_STATE:
      return initialState;
    default:
      return state;
  }
};
const useGeoLocation = () => {
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, initialState);
  // const { sendPdtListingError } = useListingPdtLogger();
  // const { sendPdtListingErrorV2 } = useListingPdtLoggerV2();
  const {
    startTimer,
    resetTimer
  } = useDefaultLocationTimer({
    initialTime: 10 * 1000,
    interval: 1000
  });
  const setUserLocationWeb = (onSuccess, onError) => {
    if (navigator.permissions) {
      dispatch({
        type: LOCATION_FETCH_LOADING
      });
      navigator.geolocation.getCurrentPosition(position => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        resetTimer();
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(latitude, longitude);
        dispatch({
          type: LOCATION_FETCH_SUCCESS,
          payload: {
            latitude,
            longitude
          }
        });
      }, error => {
        let msg = '';
        if (error.code === 1) {
          msg = ERROR_MSGS.GEOLOCATION_PERMISSION_DENIED;
        } else if (error.code === 2) {
          msg = ERROR_MSGS.GEOLOCATION_POSITION_UNAVAILABLE;
        } else if (error.code === 3) {
          msg = ERROR_MSGS.GEOLOCATION_TIMEOUT;
        }
        resetTimer();
        onError === null || onError === void 0 ? void 0 : onError({
          message: msg
        });
        dispatch({
          type: LOCATION_FETCH_ERROR,
          payload: {
            message: msg
          }
        });
      }, {
        timeout: 10000
      });
    } else {
      resetTimer();
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: {
          message: ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED
        }
      });
      ({
        errorDescription: ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED
      });
      // sendPdtListingError(error);
      // sendPdtListingErrorV2(error);
      console.error(ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED);
    }
  };
  const setUserLocation = (onSuccess, onError) => {
    startTimer(() => {
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: {
          message: ERROR_MSGS.GEOLOCATION_PERMISSION_POPUP_OPENED
        }
      });
    });
    setUserLocationWeb(onSuccess, onError);
  };
  const setUserLocationIfPermittedDesktop = (onSuccess, onError) => {
    if (navigator.permissions) {
      navigator.permissions.query({
        name: 'geolocation'
      }).then(function (permissionStatus) {
        if (permissionStatus.state === 'granted') {
          setUserLocationWeb(onSuccess, onError);
        } else {
          // Permission not granted, do not request location
          resetTimer();
          onError === null || onError === void 0 ? void 0 : onError(permissionStatus.state);
          dispatch({
            type: LOCATION_FETCH_ERROR,
            payload: {
              message: ERROR_MSGS.GEOLOCATION_PERMISSION_DENIED
            }
          });
          console.error('Permission not granted', permissionStatus.state);
        }
      });
    } else {
      // Geolocation not supported
      resetTimer();
      onError === null || onError === void 0 ? void 0 : onError(ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED);
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: {
          message: ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED
        }
      });
      console.log(ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED);
    }
  };
  const setUserLocationIfPermitted = (onSuccess, onError) => {
    startTimer(() => {
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: {
          message: ERROR_MSGS.GEOLOCATION_PERMISSION_POPUP_OPENED
        }
      });
    });
    setUserLocationIfPermittedDesktop(onSuccess, onError);
  };
  const resetGeoLocationState = () => {
    dispatch({
      type: RESET_LOCATION_STATE
    });
  };
  return Object.assign(Object.assign({}, state), {
    setUserLocation,
    setUserLocationIfPermitted,
    resetGeoLocationState
  });
};

/**
 * Transformer method that gets location data from session storage,
 * checks if it exists and has snake_case keys, then converts them to camelCase
 * @param params - Parameters object or just the key string for backward compatibility
 * @returns The location data with camelCase keys if transformation was needed, otherwise original data
 */
const getTransformedLocationDataFromSessionStorage = params => {
  var _a, _b;
  // Handle both object and string parameter formats for backward compatibility
  let key;
  let isEssential = false;
  let options = {
    shouldParseJson: true
  };
  if (typeof params === 'string') {
    // Legacy format: just the key string
    key = params;
  } else {
    // New format: object with key, isEssential, and options
    key = params.key;
    isEssential = (_a = params.isEssential) !== null && _a !== void 0 ? _a : false;
    options = (_b = params.options) !== null && _b !== void 0 ? _b : {
      shouldParseJson: true
    };
  }
  const locationData = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getSessionStorageItem)(key, isEssential, options);
  // Check if locationData exists
  if (!locationData) {
    return locationData;
  }
  // Check if any key exists in snake_case
  if ((0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.hasSnakeCaseKeys)(locationData)) {
    // Convert snake_case keys to camelCase
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.transformToCamelCase)(locationData);
  }
  // Return original data if no snake_case keys found
  return locationData;
};
/**
 * Method that stores location data in session storage after converting camelCase keys to snake_case
 * @param params - Parameters object containing data to store and storage options
 */
const setTransformedLocationDataToSessionStorage = params => {
  var _a, _b;
  // Extract parameters with defaults
  const key = params.key;
  const value = params.value;
  const isEssential = 'isEssential' in params ? (_a = params.isEssential) !== null && _a !== void 0 ? _a : false : false;
  const options = 'options' in params ? (_b = params.options) !== null && _b !== void 0 ? _b : {
    shouldStringifyJson: true
  } : {
    shouldStringifyJson: true
  };
  // Check if value exists
  if (!value) {
    (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.setSessionStorageItem)(key, value, isEssential, options);
    return;
  }
  // Check if any key exists in camelCase
  if ((0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.hasCamelCaseKeys)(value)) {
    // Convert camelCase keys to snake_case before storing
    const transformedValue = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.transformToSnakeCase)(value);
    (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.setSessionStorageItem)(key, transformedValue, isEssential, options);
  } else {
    // Store original data if no camelCase keys found
    (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.setSessionStorageItem)(key, value, isEssential, options);
  }
};




/***/ }),

/***/ 5618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Anchor": function() { return /* binding */ Anchor; },
/* harmony export */   "AnchorTagStyle": function() { return /* binding */ AnchorTagStyle; },
/* harmony export */   "BottomRightTextContainer": function() { return /* binding */ BottomRightTextContainer; },
/* harmony export */   "Button": function() { return /* binding */ Button; },
/* harmony export */   "Checkbox": function() { return /* binding */ Checkbox; },
/* harmony export */   "Container": function() { return /* binding */ Container; },
/* harmony export */   "DesignSystem": function() { return /* binding */ DesignSystem; },
/* harmony export */   "Dropdown": function() { return /* binding */ Dropdown; },
/* harmony export */   "ErrorStateText": function() { return /* binding */ ErrorStateText; },
/* harmony export */   "FloatingTextField": function() { return /* binding */ FloatingTextField; },
/* harmony export */   "FormattedText": function() { return /* binding */ FormattedText; },
/* harmony export */   "GlobalStyles": function() { return /* binding */ GlobalStyles; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H1Style": function() { return /* binding */ H1Style; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H2Style": function() { return /* binding */ H2Style; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H3Style": function() { return /* binding */ H3Style; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "H4Style": function() { return /* binding */ H4Style; },
/* harmony export */   "H5": function() { return /* binding */ H5; },
/* harmony export */   "H5Style": function() { return /* binding */ H5Style; },
/* harmony export */   "HeaderWrapper": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "Heading": function() { return /* binding */ Heading; },
/* harmony export */   "IconContainer": function() { return /* binding */ IconContainer; },
/* harmony export */   "Image": function() { return /* binding */ Image; },
/* harmony export */   "ImageTagStyle": function() { return /* binding */ ImageTagStyle; },
/* harmony export */   "InputStyle": function() { return /* binding */ InputStyle; },
/* harmony export */   "InputWpr": function() { return /* binding */ InputWpr; },
/* harmony export */   "InputWrap": function() { return /* binding */ InputWrap; },
/* harmony export */   "LabelWrapper": function() { return /* binding */ LabelWrapper; },
/* harmony export */   "Modal": function() { return /* binding */ Modal; },
/* harmony export */   "ModalBackdrop": function() { return /* binding */ ModalBackdrop; },
/* harmony export */   "ModalWrapper": function() { return /* binding */ ModalWrapper; },
/* harmony export */   "ParaStyle": function() { return /* binding */ ParaStyle; },
/* harmony export */   "ParaTag": function() { return /* binding */ ParaTag; },
/* harmony export */   "RadioButton": function() { return /* binding */ RadioButton; },
/* harmony export */   "RadioButtonStyle": function() { return /* binding */ RadioButtonStyle; },
/* harmony export */   "RightTextContainer": function() { return /* binding */ RightTextContainer; },
/* harmony export */   "ScrollContainer": function() { return /* binding */ ScrollContainer; },
/* harmony export */   "ScrollContainerFullPage": function() { return /* binding */ ScrollContainerFullPage; },
/* harmony export */   "SearchInput": function() { return /* binding */ SearchInput; },
/* harmony export */   "Shimmer": function() { return /* binding */ Shimmer; },
/* harmony export */   "SlickArrow": function() { return /* binding */ SlickArrow; },
/* harmony export */   "Slider": function() { return /* binding */ Slider; },
/* harmony export */   "SnackBar": function() { return /* binding */ SnackBar; },
/* harmony export */   "SpanStyle": function() { return /* binding */ SpanStyle; },
/* harmony export */   "Spinner": function() { return /* binding */ Spinner; },
/* harmony export */   "SpinnerCont": function() { return /* binding */ SpinnerCont; },
/* harmony export */   "StyledButton": function() { return /* binding */ StyledButton; },
/* harmony export */   "SubHeading": function() { return /* binding */ SubHeading; },
/* harmony export */   "Switch": function() { return /* binding */ Switch; },
/* harmony export */   "SwitchContainer": function() { return /* binding */ SwitchContainer; },
/* harmony export */   "SwitchInput": function() { return /* binding */ SwitchInput; },
/* harmony export */   "Toast": function() { return /* binding */ Toast; },
/* harmony export */   "ToolTip": function() { return /* binding */ ToolTip; },
/* harmony export */   "ToolTipCont": function() { return /* binding */ ToolTipCont; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5505);
/* harmony import */ var _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8772);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





const StyledDesignSystem = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "design-system__StyledDesignSystem",
  componentId: "sc-8b4jxl-0"
})(["color:pink;"]);
function DesignSystem() {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDesignSystem, {
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
      children: ["Welcome to DesignSystem! ", _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.GI]
    })
  });
}

const ImageTagStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].img.withConfig({
  displayName: "Imagestyle__ImageTagStyle",
  componentId: "xwa4kr-0"
})(["flex-shrink:0;", " ", " ", " ", " object-fit:contain;"], props => props.width && `width: ${props.width};`, props => props.height && `height: ${props.height};`, props => props.showCursorPointer && ` cursor: pointer;`, props => props.margin && `margin: ${props.margin};`);

const Image = ({
  src,
  width,
  alt: _alt = 'image-tag',
  height,
  showCursorPointer: _showCursorPointer = false,
  id,
  onClick,
  className,
  margin
}) => {
  if (!src) return null;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTagStyle, {
    src: src,
    width: width,
    height: height,
    showCursorPointer: _showCursorPointer,
    alt: _alt,
    id: id,
    onClick: onClick,
    loading: "lazy",
    className: className,
    margin: margin
  });
};

const H1Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h1.withConfig({
  displayName: "H1style__H1Style",
  componentId: "sc-1llksyg-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT32, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H1 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H1Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H1Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H2Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h2.withConfig({
  displayName: "H2style__H2Style",
  componentId: "xuqcvw-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT24, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H2 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H2Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H2Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H3Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h3.withConfig({
  displayName: "H3style__H3Style",
  componentId: "zg5cb1-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT22, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H3 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H3Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H3Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H4Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h4.withConfig({
  displayName: "H4style__H4Style",
  componentId: "sc-153qf2g-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT18, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H4 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H4Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H4Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H5Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h5.withConfig({
  displayName: "H5style__H5Style",
  componentId: "qfcp3t-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT16, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H5 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H5Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H5Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

let _ = t => t,
  _t;
const GlobalStyles = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.createGlobalStyle)(_t || (_t = _` 
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  background: ${0};
  color: ${0};
  font-size: ${0};
  line-height: ${0};
  font-family: ${0};
  font-weight: ${0};
}

*::-webkit-scrollbar {
  display: none;
}

*,
html {
  box-sizing: border-box;
  scroll-behavior: smooth;
}
*, *:before, *:after {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
}
img {
  max-width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  color: ${0};
  text-decoration: none;
  cursor: pointer;
}
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}
code {
  font-family: ${0};
}

input, textarea, button {font-family: inherit; border: none; outline: none;}

@font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXiWtFCc.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  
    @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwiPGQ3q5d0.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFV0U1dYPFkZVO.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

@font-face {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-NYiFV0U1dYPFkZVO.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-4I-FV0U1dYPFkZVO.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
`), props => props.theme.colors.bodyBg, props => props.theme.colors.highEmphasis, props => props.theme.fontSize.font14, props => props.theme.lineHeight.lh16, props => props.theme.fontFamily, props => props.theme.fontWeight.regular, props => props.theme.colors.primaryAccent, props => props.theme.fontFamily);

const AnchorTagStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].a.withConfig({
  displayName: "Anchorstyle__AnchorTagStyle",
  componentId: "sc-1kebx5m-0"
})(["", ""], props => {
  const {
    theme,
    margin,
    color,
    textUnderline,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW2
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["display:inline-block;", " ", " font-family:", ";color:", ";", " ", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, color || props.theme.colors.primaryAccent, margin && `margin: ${margin};`, textUnderline && ` text-decoration-line: ${textUnderline};`);
});

const Anchor = ({
  children,
  color,
  onClick,
  href,
  margin,
  onMouseEnter,
  onMouseLeave,
  target,
  id,
  textUnderline,
  typography,
  className
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnchorTagStyle, {
    typography: typography,
    color: color,
    onClick: onClick,
    href: href,
    margin: margin,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    target: target,
    id: id,
    textUnderline: textUnderline,
    className: className,
    children: children
  });
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$d = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$c = fails$d;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$c(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$b = fails$d;

var functionBindNative = !fails$b(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$9 = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = NATIVE_BIND$1 ? call$9.bind(call$9) : function () {
  return call$9.apply(call$9, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$8 = FunctionPrototype$1.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$8, call$8);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$8.apply(fn, arguments);
  };
};

var uncurryThis$c = functionUncurryThis;

var toString$4 = uncurryThis$c({}.toString);
var stringSlice$1 = uncurryThis$c(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$4(it), 8, -1);
};

var uncurryThis$b = functionUncurryThis;
var fails$a = fails$d;
var classof$2 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$b(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$2(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$8 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$4 = function (it) {
  if (isNullOrUndefined$1(it)) throw new $TypeError$8("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$3 = requireObjectCoercible$4;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$3(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$f = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$e = isCallable$f;

var isObject$8 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it);
};

var globalThis$f = globalThis_1;
var isCallable$d = isCallable$f;

var aFunction = function (argument) {
  return isCallable$d(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$f[namespace]) : globalThis$f[namespace] && globalThis$f[namespace][method];
};

var uncurryThis$a = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$a({}.isPrototypeOf);

var globalThis$e = globalThis_1;

var navigator = globalThis$e.navigator;
var userAgent$1 = navigator && navigator.userAgent;

var environmentUserAgent = userAgent$1 ? String(userAgent$1) : '';

var globalThis$d = globalThis_1;
var userAgent = environmentUserAgent;

var process = globalThis$d.process;
var Deno = globalThis$d.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = environmentV8Version;
var fails$9 = fails$d;
var globalThis$c = globalThis_1;

var $String$5 = globalThis$c.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$3;
var isCallable$c = isCallable$f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$c($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$b = isCallable$f;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$b(argument)) return argument;
  throw new $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$2(func);
};

var call$7 = functionCall;
var isCallable$a = isCallable$f;
var isObject$7 = isObject$8;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$7(val = call$7(fn, input))) return val;
  if (isCallable$a(fn = input.valueOf) && !isObject$7(val = call$7(fn, input))) return val;
  if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$7(val = call$7(fn, input))) return val;
  throw new $TypeError$6("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var globalThis$b = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(globalThis$b, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$b[key] = value;
  } return value;
};

var globalThis$a = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$a[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.43.0',
  mode: 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.43.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$3 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$2 = requireObjectCoercible$4;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return $Object$2(requireObjectCoercible$2(argument));
};

var uncurryThis$9 = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$9({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$8 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$3 = uncurryThis$8(1.1.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$3(++id + postfix, 36);
};

var globalThis$9 = globalThis_1;
var shared$2 = shared$3;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = globalThis$9.Symbol;
var WellKnownSymbolsStore = shared$2('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$a = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$9(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$6 = functionCall;
var isObject$6 = isObject$8;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$9 = wellKnownSymbol$a;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$9('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$6(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$6(exoticToPrim, input, pref);
    if (!isObject$6(result) || isSymbol$1(result)) return result;
    throw new $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var globalThis$8 = globalThis_1;
var isObject$5 = isObject$8;

var document$1 = globalThis$8.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$5(document$1) && isObject$5(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$b = descriptors;
var fails$8 = fails$d;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$b && !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$a = descriptors;
var call$5 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$a ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$3(!call$5(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$9 = descriptors;
var fails$7 = fails$d;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$9 && fails$7(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$4 = isObject$8;

var $String$3 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$8 = function (argument) {
  if (isObject$4(argument)) return argument;
  throw new $TypeError$4($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$8 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$7 = anObject$8;
var toPropertyKey = toPropertyKey$2;

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$8 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$3('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$7 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;

var createNonEnumerableProperty$5 = DESCRIPTORS$7 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$6 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$6 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$6 || (DESCRIPTORS$6 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$7 = functionUncurryThis;
var isCallable$9 = isCallable$f;
var store$1 = sharedStoreExports;

var functionToString = uncurryThis$7(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$9(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var globalThis$7 = globalThis_1;
var isCallable$8 = isCallable$f;

var WeakMap$1 = globalThis$7.WeakMap;

var weakMapBasicDetection = isCallable$8(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$6 = globalThis_1;
var isObject$3 = isObject$8;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$6 = hasOwnProperty_1;
var shared = sharedStoreExports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis$6.TypeError;
var WeakMap = globalThis$6.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$3(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$6 = functionUncurryThis;
var fails$6 = fails$d;
var isCallable$7 = isCallable$f;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$5 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$1 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice = uncurryThis$6(''.slice);
var replace$1 = uncurryThis$6(''.replace);
var join = uncurryThis$6([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$5 && !fails$6(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$1($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$5) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$5) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$7(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var makeBuiltInExports = makeBuiltIn$3.exports;

var isCallable$6 = isCallable$f;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$4 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$6(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$5 = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$5([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$3;
var uncurryThis$4 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$6 = anObject$8;

var concat$1 = uncurryThis$4([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$6(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$5 = fails$d;
var isCallable$5 = isCallable$f;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$5(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var globalThis$5 = globalThis_1;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$3 = defineBuiltIn$4;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$5;
  } else if (STATIC) {
    target = globalThis$5[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$5[TARGET] && globalThis$5[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$3(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$4 = descriptors;
var uncurryThis$3 = functionUncurryThis;
var call$4 = functionCall;
var fails$4 = fails$d;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat = uncurryThis$3([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$4(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || call$4(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$4 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$4({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const baseButtonStyles = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["display:inline-flex;align-items:center;justify-content:center;padding:12px 24px;margin:", ";width:100%;border-radius:", ";cursor:pointer;background:", ";border:", ";", ""], ({
  margin: _margin = '0px'
}) => _margin, ({
  theme
}) => theme.borderRadius.br8, ({
  variant,
  theme
}) => variant === 'contained' ? theme.gradientColors.buttonBgColor : 'transparent', ({
  variant,
  theme
}) => variant === 'outlined' ? `1px solid ${theme.colors.primaryAccent}` : 'none', ({
  isDisabled,
  variant,
  theme
}) => isDisabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["background:", ";border-color:", ";pointer-events:none;cursor:default;"], variant === 'contained' ? `${theme.colors.disabledBg}` : 'transparent', theme.colors.disabled));
const StyledButton = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].button.withConfig({
  displayName: "Buttonstyles__StyledButton",
  componentId: "xq2e5g-0"
})(["", ""], baseButtonStyles);
const IconWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Buttonstyles__IconWrapper",
  componentId: "xq2e5g-1"
})(["display:inline-flex;align-items:center;justify-content:center;margin:", ";"], ({
  position
}) => position === 'left' ? '0 4px 0 0' : '0 0 0 4px');
const LabelWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Buttonstyles__LabelWrapper",
  componentId: "xq2e5g-2"
})(["", ""], ({
  theme,
  variant,
  typography: _typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW3,
  isDisabled
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_typography, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-family: ${theme.fontFamily};
      color: ${variant === 'contained' ? theme.colors.white : theme.colors.primaryAccent};
      ${isDisabled ? `color: ${theme.colors.disabled};` : ''}
    `;
});

const Button = _a => {
  var {
      id,
      variant = 'contained',
      disabled = false,
      onClick,
      startIcon,
      endIcon,
      margin,
      leftImageWidth = '24px',
      rightImageWidth = '24px',
      label,
      className,
      typography
    } = _a,
    restProps = __rest(_a, ["id", "variant", "disabled", "onClick", "startIcon", "endIcon", "margin", "leftImageWidth", "rightImageWidth", "label", "className", "typography"]);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButton, Object.assign({
    id: id,
    variant: variant,
    isDisabled: disabled,
    onClick: onClick,
    margin: margin,
    className: className
  }, restProps, {
    children: [startIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
      position: "left",
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
        src: startIcon,
        width: leftImageWidth
      })
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LabelWrapper, {
      variant: variant,
      isDisabled: disabled,
      typography: typography,
      children: label
    }), endIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
      position: "right",
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
        src: endIcon,
        width: rightImageWidth
      })
    })]
  }));
};

const RadioButtonStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "RadioButtonstyle__RadioButtonStyle",
  componentId: "bcndwf-0"
})(["display:block;margin:", ";", " [type='radio']:checked,[type='radio']:not(:checked){position:absolute;left:-9999px;}[type='radio']:checked + label,[type='radio']:not(:checked) + label{position:relative;padding-left:28px;cursor:pointer;display:inline-block;color:", ";width:100%;", " ", "}[type='radio']:checked + label:before,[type='radio']:not(:checked) + label:before{content:'';position:absolute;left:0;top:2px;width:18px;height:18px;border:1px solid ", ";border-radius:100%;background:", ";", "}[type='radio']:checked + label:before{border:", ";}[type='radio']:checked + label:after,[type='radio']:not(:checked) + label:after{content:'';width:12px;height:12px;background:", ";position:absolute;top:5px;left:3px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;", "}[type='radio']:not(:checked) + label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}[type='radio']:checked + label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}"], ({
  margin
}) => margin, ({
  showLabel
}) => showLabel && `
        width: 100%;
`, ({
  theme
}) => theme.colors.mediumEmphasis, ({
  theme,
  typography: _typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  showLabel
}) => !showLabel && `
        margin-top:-17px
`, ({
  disabled,
  theme
}) => disabled ? theme.colors.lowEmphasis : theme.colors.lowEmphasis, ({
  theme
}) => theme.colors.white, ({
  showLabel
}) => !showLabel && `
        margin-top:-17px
`, ({
  theme
}) => `1px solid ${theme.colors.primaryAccent}`, ({
  theme
}) => theme.colors.primaryAccent, p => !p.showLabel && `
        margin-top:-17px
`);

const RadioButton = ({
  children,
  isChecked,
  onClick,
  inputIndex,
  inputId,
  showLabel: _showLabel = true,
  id,
  disabled: _disabled = false,
  margin,
  typography
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RadioButtonStyle, {
    onClick: onClick ? () => onClick(inputIndex) : undefined,
    showLabel: _showLabel,
    id: id,
    disabled: _disabled,
    margin: margin,
    typography: typography,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
      type: "radio",
      checked: isChecked,
      id: inputId,
      disabled: !_showLabel
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
      htmlFor: inputId,
      children: children
    })]
  });
};

var objectDefineProperties = {};

var DESCRIPTORS$3 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$5 = anObject$8;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$5(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$3;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$4 = anObject$8;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$4(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$8 = wellKnownSymbol$a;
var create$2 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$8('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$3 = fails$d;

var correctPrototypeGetter = !fails$3(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$2 = hasOwnProperty_1;
var isCallable$4 = isCallable$f;
var toObject = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$2 = fails$d;
var isCallable$3 = isCallable$f;
var isObject$2 = isObject$8;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$4;
var wellKnownSymbol$7 = wellKnownSymbol$a;

var ITERATOR$4 = wellKnownSymbol$7('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$2(IteratorPrototype$4) || fails$2(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$4].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$3(IteratorPrototype$4[ITERATOR$4])) {
  defineBuiltIn$2(IteratorPrototype$4, ITERATOR$4, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$6 = wellKnownSymbol$a;

var TO_STRING_TAG$4 = wellKnownSymbol$6('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$4)) {
    defineProperty$2(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$2 = setToStringTag$3;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$3, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$2 = functionUncurryThis;
var aCallable$1 = aCallable$3;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$2(aCallable$1(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$1 = isObject$8;

var isPossiblePrototype$1 = function (argument) {
  return isObject$1(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$2 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$2("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject = isObject$8;
var requireObjectCoercible$1 = requireObjectCoercible$4;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$1(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$3 = _export;
var call$3 = functionCall;
var FunctionName = functionName;
var isCallable$2 = isCallable$f;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$1 = defineBuiltIn$4;
var wellKnownSymbol$5 = wellKnownSymbol$a;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype$2 = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$5('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable$2(CurrentIteratorPrototype[ITERATOR$3])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$3, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$3(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$3({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$4 = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var setToStringTag = setToStringTag$3;
var wellKnownSymbol$4 = wellKnownSymbol$a;

var ITERATOR$2 = wellKnownSymbol$4('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$4[COLLECTION_NAME] && globalThis$4[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const getArrowStyles = (arrowDirection, bgColor, theme, arrowPosition) => {
  const arrowColor = bgColor ? bgColor : theme.colors.positive;
  const position = arrowPosition ? arrowPosition : '50%';
  switch (arrowDirection) {
    case 'up':
      return `
          ::after {
              bottom: 100%;
              left: ${position};
              border-bottom-color: ${arrowColor};
              margin-left: -8px;
          }
        `;
    case 'down':
      return `
          ::after {
              top: 100%;
              left: ${position};
              border-top-color: ${arrowColor};
              margin-left: -8px;
          }
        `;
    case 'right':
      return `
          ::after {
              left: 100%;
              top: ${position};
              border-left-color: ${arrowColor};
              margin-top: -8px;
          }
        `;
    case 'left':
      return `
          ::after {
              right: 100%;
              top: ${position};
              border-right-color: ${arrowColor};
              margin-top: -8px;
          }
        `;
    default:
      return '';
  }
};
const ToolTipCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "ToolTipstyles__ToolTipCont",
  componentId: "mfvufu-0"
})(["width:", ";background-color:", ";padding:8px;border-radius:", ";position:absolute;::after{bottom:100%;border:solid transparent;content:'';height:0;width:0;position:absolute;pointer-events:none;border-color:rgba(0,87,86,0);border-width:8px;}", ""], props => props.width ? props.width : '400px', props => props.bgColor ? props.bgColor : props.theme.colors.positive, props => props.theme.borderRadius.br8, props => getArrowStyles(props.arrowDirection, props.bgColor, props.theme, props.arrowPosition));

const ToolTip = ({
  width,
  children,
  bgColor,
  arrowDirection: _arrowDirection = 'down',
  arrowPosition,
  style,
  id,
  className,
  autoDismiss: _autoDismiss = false,
  dismissDuration: _dismissDuration = 3000,
  // default 3 seconds
  'data-testid': dataTestId
}) => {
  const [isVisible, setIsVisible] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    let timer = null;
    if (_autoDismiss) {
      timer = setTimeout(() => {
        setIsVisible(false);
      }, _dismissDuration);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [_autoDismiss, _dismissDuration]);
  if (!isVisible) return null;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ToolTipCont, {
    width: width,
    arrowDirection: _arrowDirection,
    arrowPosition: arrowPosition,
    bgColor: bgColor,
    style: style,
    id: id,
    className: className,
    "data-testid": dataTestId,
    children: children
  });
};

const BREAKPOINTS = {
  MOBILE: 768
};

const deviceType = {
  mobile: `(max-width: ${BREAKPOINTS.MOBILE}px)`
};

const modalAnim = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["from{bottom:-600px;}to{bottom:0;}"]);
const fullModalAnim = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["from{top:100vh;}to{top:0;}"]);
const ModalWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ModalWrapper",
  componentId: "qs43y7-0"
})(["overflow:hidden;width:", ";background-color:", ";border-radius:", ";position:fixed;z-index:15;padding:20px 30px 30px 30px;@media ", "{padding:20px 20px 30px 20px;}", " ", " ", ""], ({
  modalWidth
}) => modalWidth ? `${modalWidth}px` : '420px', ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br12, deviceType.mobile, ({
  modalType
}) => modalType === 'centered' && `
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    `, ({
  modalType,
  stickToTop,
  theme
}) => modalType === 'bottomSheet' && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["left:0;width:100%;border-radius:", " ", " 0 0;animation:", " 0.6s;max-height:calc(100vh);", ""], theme.borderRadius.br20, theme.borderRadius.br20, modalAnim, stickToTop ? 'top: 0; height: 100%;' : 'bottom: 0;'), ({
  modalType
}) => modalType === 'fullPage' && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["left:0;top:0;width:100%;height:100%;border-radius:0;animation:", " 0.8s;"], fullModalAnim));
const Container = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__Container",
  componentId: "qs43y7-1"
})(["display:flex;flex-direction:row;align-items:center;margin:0px 0px 24px 0px;"]);
const BackButtonWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Modalstyle__BackButtonWrapper",
  componentId: "qs43y7-2"
})([""]);
const HeaderWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__HeaderWrapper",
  componentId: "qs43y7-3"
})(["display:flex;flex-direction:column;margin:", ";flex:1;"], ({
  hasBackBtn
}) => hasBackBtn ? '0px 0px 0px 20px' : '0px');
const Heading = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "Modalstyle__Heading",
  componentId: "qs43y7-4"
})(["", ""], props => {
  const {
    color,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.medium,
    theme
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
     font-family: ${theme.fontFamily};
      color: ${color || theme.colors.highEmphasis};
    `;
});
const SubHeading = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "Modalstyle__SubHeading",
  componentId: "qs43y7-5"
})(["", ""], props => {
  const {
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1,
    color,
    theme
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
     font-family: ${theme.fontFamily};
      color: ${color || theme.colors.lowEmphasis};
      margin-top: 4px;
    `;
});
const CloseButtonWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Modalstyle__CloseButtonWrapper",
  componentId: "qs43y7-6"
})(["margin-left:auto;cursor:pointer;"]);
const ScrollContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ScrollContainer",
  componentId: "qs43y7-7"
})(["overflow-y:scroll;max-height:", ";@media ", "{max-height:", ";}"], props => props.modalMaxHeight ? `${props.modalMaxHeight}` : 'calc(100vh - 204px)', deviceType.mobile, props => props.modalMaxHeight ? `${props.modalMaxHeight}` : 'calc(100vh - 300px)');
const ScrollContainerFullPage = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ScrollContainerFullPage",
  componentId: "qs43y7-8"
})(["overflow-y:scroll;max-height:calc(100vh - 100px);"]);
const ModalBackdrop = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ModalBackdrop",
  componentId: "qs43y7-9"
})(["width:100%;height:100%;background-color:", ";position:fixed;left:0;top:0;z-index:13;"], ({
  theme
}) => theme.colors.overlay);

const Modal = ({
  modalId,
  backBtnId,
  closeBtnId,
  modalType: _modalType = 'centered',
  modalWidth,
  stickToTop,
  backBtn,
  onModalClose,
  heading,
  headingStyles,
  children,
  subHeading,
  subHeadingStyles,
  headingComp,
  modalMaxHeight,
  closeButton: _closeButton = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
    src: 'https://tripmoneycmsimgak.mmtcdn.com/img/Close_d8b254dd9a.png',
    height: "32px",
    width: "32px"
  }),
  className,
  showCloseButton: _showCloseButton = true,
  'data-testid': dataTestId
}) => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalWrapper, {
      id: modalId,
      modalType: _modalType,
      modalWidth: modalWidth,
      stickToTop: stickToTop,
      className: className,
      "data-testid": dataTestId,
      children: [_modalType === 'fullPage' ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [backBtn && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackButtonWrapper, {
          id: backBtnId,
          onClick: onModalClose,
          children: backBtn
        }), (heading || subHeading) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
          hasBackBtn: !!backBtn,
          children: [heading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
            color: (headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.color) || theme.colors.mediumEmphasis,
            dangerouslySetInnerHTML: {
              __html: heading
            },
            typography: (headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.typography) || _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW2
          }), subHeading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubHeading, {
            typography: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.typography,
            color: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.color,
            dangerouslySetInnerHTML: {
              __html: subHeading
            }
          })]
        }), headingComp && headingComp]
      }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [backBtn && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackButtonWrapper, {
          id: backBtnId,
          onClick: onModalClose,
          children: backBtn
        }), (heading || subHeading) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
          hasBackBtn: !!backBtn,
          children: [heading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
            color: headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.color,
            dangerouslySetInnerHTML: {
              __html: heading
            },
            typography: headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.typography
          }), subHeading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubHeading, {
            typography: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.typography,
            color: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.color,
            dangerouslySetInnerHTML: {
              __html: subHeading
            }
          })]
        }), _showCloseButton && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseButtonWrapper, {
          id: closeBtnId,
          onClick: onModalClose,
          children: _closeButton
        }), headingComp && headingComp]
      }), _modalType === 'fullPage' ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollContainerFullPage, {
        children: children
      }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollContainer, {
        modalMaxHeight: modalMaxHeight,
        children: children
      })]
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalBackdrop, {
      onClick: onModalClose
    })]
  });
};

const CheckboxWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].label.withConfig({
  displayName: "Checkboxstyles__CheckboxWrapper",
  componentId: "sc-1oh74xo-0"
})(["display:flex;align-items:center;cursor:pointer;font-family:", ";margin:", ";width:max-content;"], ({
  theme
}) => theme.fontFamily, ({
  margin: _margin = '0px'
}) => _margin);
const StyledCheckbox = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "Checkboxstyles__StyledCheckbox",
  componentId: "sc-1oh74xo-1"
})(["width:18px;height:18px;background:", ";border:1px solid ", ";border-radius:", ";position:relative;appearance:none;&::before{content:'';display:", ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:12px;height:12px;background-image:url('https://tripmoneycmsimgak.mmtcdn.com/img/tick_1753282273.png');background-size:contain;background-repeat:no-repeat;}&:disabled{border-color:", ";}"], ({
  theme,
  checked
}) => checked ? theme.colors.primaryAccent : theme.colors.white, ({
  checked,
  theme
}) => !checked ? theme.colors.lowEmphasis : 'unset', ({
  theme
}) => theme.borderRadius.br4, ({
  checked
}) => checked ? 'block' : 'none', ({
  theme
}) => theme.colors.disabled);
const Label = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Checkboxstyles__Label",
  componentId: "sc-1oh74xo-2"
})(["", ""], ({
  theme,
  typography: _typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW1,
  fontColor
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_typography, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
       margin-left: 8px;
      color: ${fontColor || theme.colors.highEmphasis};
    `;
});

const Checkbox = ({
  id,
  label,
  checked,
  onChange,
  disabled,
  margin,
  typography,
  className,
  fontColor
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CheckboxWrapper, {
    className: className,
    id: id,
    margin: margin,
    disabled: disabled,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCheckbox, {
      checked: checked,
      onChange: onChange,
      disabled: disabled
    }), label && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
      fontColor: fontColor,
      typography: typography,
      children: label
    })]
  });
};

const SwitchContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].label.withConfig({
  displayName: "Switchstyles__SwitchContainer",
  componentId: "sc-1fgbbu5-0"
})(["position:relative;display:inline-block;width:52px;height:32px;margin:", ";cursor:", ";opacity:", ";"], ({
  margin: _margin = '0px'
}) => _margin, ({
  disabled
}) => disabled ? 'default' : 'pointer', ({
  theme,
  disabled,
  checked
}) => checked && disabled || theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.GI && disabled ? 0.6 : 1);
const SwitchInput = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
  displayName: "Switchstyles__SwitchInput",
  componentId: "sc-1fgbbu5-1"
})(["opacity:0;width:0;height:0;"]);
const Slider = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Switchstyles__Slider",
  componentId: "sc-1fgbbu5-2"
})(["position:absolute;top:0;left:0;right:0;bottom:0;border-radius:35px;background-color:", ";border:", ";transition:background-color 0.4s ease;&::before{position:absolute;content:'';width:24px;height:24px;top:", ";left:", ";border-radius:50%;background-color:", ";transition:left 0.4s ease;}"], ({
  checked,
  disabled,
  theme
}) => {
  if (disabled) {
    return checked ? theme.colors.primaryAccent : theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.screenBg : theme.colors.disabledBg;
  }
  return checked ? theme.colors.primaryAccent : theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.lightBlue : theme.colors.disabledBg;
}, ({
  checked,
  theme
}) => !checked && theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? `2px solid ${theme.colors.disabledBg}` : 'none', ({
  checked,
  theme
}) => !checked && theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? '2px' : '4px', ({
  checked
}) => checked ? '24px' : '4px', ({
  checked,
  disabled,
  theme
}) => {
  if (checked) return theme.colors.white;
  if (disabled) return theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.disabledBg : theme.colors.white;
  return theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.disabled : theme.colors.white;
});

const Switch = ({
  id,
  checked,
  onChange,
  disabled: _disabled = false,
  margin
}) => {
  const handleChange = () => {
    if (onChange) {
      onChange(!checked);
    }
  };
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SwitchContainer, {
    id: id,
    disabled: _disabled,
    margin: margin,
    checked: checked,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwitchInput, {
      type: "checkbox",
      checked: checked,
      onChange: handleChange,
      disabled: _disabled
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Slider, {
      checked: checked,
      disabled: _disabled
    })]
  });
};

var wellKnownSymbol$3 = wellKnownSymbol$a;

var TO_STRING_TAG$3 = wellKnownSymbol$3('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$f;
var classofRaw = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$a;

var TO_STRING_TAG$2 = wellKnownSymbol$2('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString$2 = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$1 = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$4;
var toString$1 = toString$2;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$1(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var globalThis$3 = globalThis_1;
var fails$1 = fails$d;
var uncurryThis = functionUncurryThis;
var toString = toString$2;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = globalThis$3.parseInt;
var Symbol$1 = globalThis$3.Symbol;
var ITERATOR$1 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED$2 = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$1 && !fails$1(function () { $parseInt$1(Object(ITERATOR$1)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$2 ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt$1(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$2 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$2({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

var isPrototypeOf = objectIsPrototypeOf;

var $TypeError$1 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$1('Incorrect invocation');
};

var makeBuiltIn = makeBuiltInExports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$1 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var DESCRIPTORS$1 = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$4;

var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$1) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

var $$1 = _export;
var globalThis$2 = globalThis_1;
var anInstance = anInstance$1;
var anObject$3 = anObject$8;
var isCallable = isCallable$f;
var getPrototypeOf = objectGetPrototypeOf;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var createProperty = createProperty$1;
var fails = fails$d;
var hasOwn = hasOwnProperty_1;
var wellKnownSymbol$1 = wellKnownSymbol$a;
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS = descriptors;

var CONSTRUCTOR = 'constructor';
var ITERATOR = 'Iterator';
var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');

var $TypeError = TypeError;
var NativeIterator = globalThis$2[ITERATOR];

// FF56- have non-standard global helper `Iterator`
var FORCED$1 = !isCallable(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype$1
  // FF44- non-standard `Iterator` passes previous tests
  || !fails(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype$1);
  if (getPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS) {
    defineBuiltInAccessor(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$3(this);
        if (this === IteratorPrototype$1) throw new $TypeError("You can't redefine this property");
        if (hasOwn(this, key)) this[key] = replacement;
        else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};

if (!hasOwn(IteratorPrototype$1, TO_STRING_TAG$1)) defineIteratorPrototypeAccessor(TO_STRING_TAG$1, ITERATOR);

if (FORCED$1 || !hasOwn(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$$1({ global: true, constructor: true, forced: FORCED$1 }, {
  Iterator: IteratorConstructor
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$1 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var defineBuiltIn = defineBuiltIn$4;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

var call$2 = functionCall;
var anObject$2 = anObject$8;
var getMethod$1 = getMethod$3;

var iteratorClose$4 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$2(iterator);
  try {
    innerResult = getMethod$1(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$2(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$2(innerResult);
  return value;
};

var iteratorClose$3 = iteratorClose$4;

var iteratorCloseAll$1 = function (iters, kind, value) {
  for (var i = iters.length - 1; i >= 0; i--) {
    if (iters[i] === undefined) continue;
    try {
      value = iteratorClose$3(iters[i].iterator, kind, value);
    } catch (error) {
      kind = 'throw';
      value = error;
    }
  }
  if (kind === 'throw') throw value;
  return value;
};

var call$1 = functionCall;
var create = objectCreate;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var defineBuiltIns = defineBuiltIns$1;
var wellKnownSymbol = wellKnownSymbol$a;
var InternalStateModule = internalState;
var getMethod = getMethod$3;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var createIterResultObject = createIterResultObject$2;
var iteratorClose$2 = iteratorClose$4;
var iteratorCloseAll = iteratorCloseAll$1;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var NORMAL = 'normal';
var THROW = 'throw';
var setInternalState = InternalStateModule.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns(create(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod(iterator, 'return');
        return returnMethod ? call$1(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$2(state.inner.iterator, NORMAL);
      } catch (error) {
        return iteratorClose$2(iterator, THROW, error);
      }
      if (state.openIters) try {
        iteratorCloseAll(state.openIters, NORMAL);
      } catch (error) {
        return iteratorClose$2(iterator, THROW, error);
      }
      if (iterator) iteratorClose$2(iterator, NORMAL);
      return createIterResultObject(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');

var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};

var anObject$1 = anObject$8;
var iteratorClose$1 = iteratorClose$4;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$1(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, 'throw', error);
  }
};

// Should throw an error on invalid iterator
// https://issues.chromium.org/issues/336839115
var iteratorHelperThrowsOnInvalidIterator$1 = function (methodName, argument) {
  // eslint-disable-next-line es/no-iterator -- required for testing
  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
  if (method) try {
    method.call({ next: null }, argument).next();
  } catch (error) {
    return true;
  }
};

var globalThis$1 = globalThis_1;

// https://github.com/tc39/ecma262/pull/3467
var iteratorHelperWithoutClosingOnEarlyError$1 = function (METHOD_NAME, ExpectedError) {
  var Iterator = globalThis$1.Iterator;
  var IteratorPrototype = Iterator && Iterator.prototype;
  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];

  var CLOSED = false;

  if (method) try {
    method.call({
      next: function () { return { done: true }; },
      'return': function () { CLOSED = true; }
    }, -1);
  } catch (error) {
    // https://bugs.webkit.org/show_bug.cgi?id=291195
    if (!(error instanceof ExpectedError)) CLOSED = false;
  }

  if (!CLOSED) return method;
};

var $ = _export;
var call = functionCall;
var aCallable = aCallable$3;
var anObject = anObject$8;
var getIteratorDirect = getIteratorDirect$1;
var createIteratorProxy = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var iteratorClose = iteratorClose$4;
var iteratorHelperThrowsOnInvalidIterator = iteratorHelperThrowsOnInvalidIterator$1;
var iteratorHelperWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$1;

var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('map', function () { /* empty */ });
var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR
  && iteratorHelperWithoutClosingOnEarlyError('map', TypeError);

var FORCED = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var result = anObject(call(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
$({ target: 'Iterator', proto: true, real: true, forced: FORCED }, {
  map: function map(mapper) {
    anObject(this);
    try {
      aCallable(mapper);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }

    if (mapWithoutClosingOnEarlyError) return call(mapWithoutClosingOnEarlyError, this, mapper);

    return new IteratorProxy(getIteratorDirect(this), {
      mapper: mapper
    });
  }
});

const ParaStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "FormattedTextstyles__ParaStyle",
  componentId: "sc-1vtotqd-0"
})(["", ""], props => {
  const {
    theme,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1,
    color,
    gradient,
    numberOfLines,
    margin
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  // Gradient text styles - use CSS gradient string from BFF
  const gradientStyles = gradient ? `
      background: ${gradient};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    ` : `
      color: ${color || theme.colors.highEmphasis};
    `;
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
      font-family: ${theme.fontFamily};
      ${gradientStyles}
      ${margin && `margin: ${margin};`}
      ${numberOfLines && `
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: ${numberOfLines};
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: nowrap;
      `}
    `;
});
const SpanStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "FormattedTextstyles__SpanStyle",
  componentId: "sc-1vtotqd-1"
})(["", ""], props => {
  const {
    theme,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1,
    color,
    gradient,
    cursor,
    underline
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  // Gradient text styles - use CSS gradient string from BFF
  const gradientStyles = gradient ? `
      background: ${gradient};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    ` : `
      color: ${color || theme.colors.highEmphasis};
    `;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " ", " font-family:", ";", " ", " pointer-events:", ";text-decoration:", ";"], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, gradientStyles, cursor && `cursor: ${cursor};`, cursor === 'pointer' ? 'auto' : 'none', underline ? 'underline' : 'none');
});

const FormattedText = ({
  numberOfLines,
  text,
  onClick,
  color,
  gradient,
  typography,
  margin,
  className,
  isDisabled,
  isbreakAllowed
}) => {
  if (!text || Array.isArray(text) && !text.length) return null;
  // Helper for text item click
  const getTextItemOnClick = textItem => {
    if (isDisabled) return undefined;
    if ((textItem === null || textItem === void 0 ? void 0 : textItem.clickable) && onClick) {
      return event => onClick(textItem, event);
    }
    return undefined;
  };
  // Helper for icon item click
  const getIconItemOnClick = iconItem => {
    if (isDisabled) return undefined;
    if ((iconItem === null || iconItem === void 0 ? void 0 : iconItem.clickable) && onClick) {
      return () => onClick(iconItem);
    }
    return undefined;
  };
  const getTextItemCursor = textItem => isDisabled ? 'inherit' : (textItem === null || textItem === void 0 ? void 0 : textItem.clickable) ? 'pointer' : 'inherit';
  const renderTextItem = (item, index, isbreakAllowed = true) => {
    if (!item) return null;
    if (item.type === 'text' && item.text) {
      const textItem = item;
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpanStyle, {
          typography: textItem.typography || typography,
          color: textItem.color,
          gradient: textItem.gradient,
          onClick: getTextItemOnClick(textItem),
          cursor: getTextItemCursor(textItem),
          underline: textItem === null || textItem === void 0 ? void 0 : textItem.underline,
          children: textItem.text
        }), isbreakAllowed && '\u00A0']
      }, index);
    }
    if (item.type === 'icon' && item.iconUrl) {
      const iconItem = item;
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: iconItem.iconUrl,
          width: iconItem.iconSize || '24px',
          height: iconItem.iconSize || '24px',
          onClick: getIconItemOnClick(iconItem),
          showCursorPointer: isDisabled ? false : iconItem === null || iconItem === void 0 ? void 0 : iconItem.clickable
        }), "\u00A0"]
      }, index);
    }
    return null;
  };
  const isTextItem = obj => obj && obj.type === 'text';
  const isIconItem = obj => obj && obj.type === 'icon';
  const getTextType = text => {
    if (typeof text === 'string') return 'string';
    if (Array.isArray(text)) return 'array';
    if (isTextItem(text) || isIconItem(text)) return 'item';
    return 'unknown';
  };
  const renderTextContent = ({
    isbreakAllowed
  }) => {
    switch (getTextType(text)) {
      case 'string':
        return text;
      case 'array':
        return text.map((item, index) => renderTextItem(item, index, isbreakAllowed));
      case 'item':
        return renderTextItem(text, 0);
      default:
        return null;
    }
  };
  // For the main ParaStyle
  const paraStyleOnClick = typeof text === 'string' && !isDisabled ? onClick : undefined;
  const paraStyleCursor = isDisabled ? {
    cursor: 'not-allowed'
  } : undefined;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParaStyle, {
    color: color,
    gradient: gradient,
    typography: typography,
    margin: margin,
    numberOfLines: numberOfLines,
    onClick: paraStyleOnClick,
    className: className,
    style: paraStyleCursor,
    children: renderTextContent({
      isbreakAllowed: isbreakAllowed !== null && isbreakAllowed !== void 0 ? isbreakAllowed : true
    })
  });
};

const InputWrap = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "FloatingTextFieldstyles__InputWrap",
  componentId: "unethj-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";flex-shrink:0;label{font-family:", ";", " color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:", ";top:50%;transform-origin:left;transform:translateY(-50%);text-transform:uppercase;pointer-events:none;", " ", " ", "}"], ({
  margin
}) => margin, ({
  theme
}) => theme.fontFamily, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW2, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  theme
}) => theme.colors.mediumEmphasis, ({
  leftIcon
}) => leftIcon ? '44px' : '10px', ({
  errorState,
  theme
}) => errorState && `
        color: ${theme.colors.error}; 
      `, ({
  placeholder,
  theme
}) => placeholder && `
        color: ${theme.colors.disabled}; 
        transform: translateY(-20px) scale(0.8);
      `, ({
  disableState,
  theme
}) => disableState && `
      pointer-events: none;
      color: ${theme.colors.disabled}; 
    `);
const InputStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
  displayName: "FloatingTextFieldstyles__InputStyle",
  componentId: "unethj-1"
})(["background:", ";border:", ";border-radius:", ";width:100%;padding:", ";", " &::placeholder{color:", ";}&:focus + label{color:", ";background:", ";transform:translateY(-20px) scale(0.8);left:", ";", "}&:valid + label{color:", ";left:", ";background:", ";transform:translateY(-20px) scale(0.8);", " ", " ", " ", "}", " ", " &:focus{outline:none;border:", ";background:", ";}&:valid{outline:none;background:", ";border:", ";", "}::-webkit-inner-spin-button,::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}"], ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => `1px solid ${theme.colors.cardBorder}`, ({
  theme
}) => theme.borderRadius.br8, ({
  leftIcon,
  rightIcon,
  rightEndText,
  paddingRight,
  paddingLeft
}) => leftIcon && rightIcon ? `20px ${paddingRight} 8px ${paddingLeft}` : leftIcon && rightEndText ? `20px ${paddingRight} 8px 44px` : rightEndText ? `20px ${paddingRight} 8px 12px` : leftIcon ? `20px 12px 8px ${paddingLeft}` : rightIcon ? `20px ${paddingRight || '44px'} 8px 12px` : '20px 10px 8px', ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW3, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
    `;
}, ({
  theme
}) => theme.colors.disabled, ({
  theme
}) => theme.colors.primaryAccent, ({
  theme
}) => theme.colors.lightBlue, ({
  leftIcon
}) => leftIcon ? '12px' : '10px', ({
  errorState,
  theme
}) => errorState && `color: ${theme.colors.error};
       background: ${theme.colors.errorBg};`, ({
  theme
}) => theme.colors.lowEmphasis, ({
  leftIcon
}) => leftIcon ? '12px' : '10px', ({
  theme
}) => theme.colors.screenBg, ({
  isActive,
  theme
}) => isActive && `
      color: ${theme.colors.primaryAccent};
      background: ${theme.colors.lightBlue};
    `, ({
  placeholder,
  theme
}) => placeholder && `
    color: ${theme.colors.primaryAccent}; 
    background: ${theme.colors.lightBlue};
    `, ({
  errorState,
  theme
}) => errorState && `color: ${theme.colors.error}; background: ${theme.colors.errorBg};`, ({
  disableState,
  theme
}) => disableState && `color: ${theme.colors.disabled}; background: ${theme.colors.screenBg};`, ({
  disableState,
  theme
}) => disableState && `
    pointer-events: none;
    color: ${theme.colors.disabled}; 
    background: ${theme.colors.white}; 
  `, ({
  errorState,
  theme
}) => errorState && `
   border: 1px solid ${theme.colors.error} !important;
    background: ${theme.colors.errorBg} !important;
  `, ({
  theme
}) => `1px solid ${theme.colors.primaryAccent}`, ({
  theme
}) => theme.colors.lightBlue, ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => `1px solid ${theme.colors.cardBorder}`, ({
  isActive,
  theme
}) => isActive && `
      border: 1px solid ${theme.colors.primaryAccent};
      background: ${theme.colors.lightBlue};
    `);
const BottomRightTextContainer = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "FloatingTextFieldstyles__BottomRightTextContainer",
  componentId: "unethj-2"
})(["position:absolute;bottom:27px;right:10px;"]);
const RightTextContainer = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "FloatingTextFieldstyles__RightTextContainer",
  componentId: "unethj-3"
})(["position:absolute;right:0;top:12px;display:flex;"]);
const InputWpr = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "FloatingTextFieldstyles__InputWpr",
  componentId: "unethj-4"
})(["position:relative;width:", ";"], ({
  width
}) => width);
const IconContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "FloatingTextFieldstyles__IconContainer",
  componentId: "unethj-5"
})(["position:absolute;top:", ";display:block;", " transform:translateY(-50%);transition:all 0.3s ease-in-out;cursor:pointer;"], ({
  isFocus,
  value
}) => isFocus || value ? '65%' : '50%', ({
  direction
}) => direction === 'left' ? 'left: 12px;' : 'right: 12px;');
const ErrorStateText = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "FloatingTextFieldstyles__ErrorStateText",
  componentId: "unethj-6"
})(["color:", ";"], ({
  theme
}) => theme.colors.error);
const ParaTag = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "FloatingTextFieldstyles__ParaTag",
  componentId: "unethj-7"
})(["margin:", ";color:", ";", ""], ({
  margin
}) => margin || '0', ({
  color
}) => color, ({
  theme,
  errorStateText
}) => {
  const typography = errorStateText ? _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1 : _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
});

const FloatingTextField = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(({
  placeholderTxt,
  labelTxt,
  disableState,
  margin,
  errorState,
  value,
  onChange,
  rightEndText,
  rightEndTextColor,
  maxLength,
  onFocus,
  onBlur,
  inputMode,
  onRightIconClick,
  onLeftIconClick,
  inputWprId,
  inputId,
  rightIcon,
  leftIcon,
  errorStateText,
  leftIconStyle: _leftIconStyle = {
    height: '24px',
    width: '24px'
  },
  rightIconStyle: _rightIconStyle = {
    height: '24px',
    width: '24px'
  },
  autoFocus,
  className,
  verifiedText,
  bottomRightText,
  inputContainerWidth
}, ref) => {
  const [isFocus, setIsFocus] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const [rightEndTextWidth, setRightEndTextWidth] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  const rightEndTextRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  const bottomRightTextMargin = bottomRightText ? '27px' : '12px ';
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (rightEndTextRef.current) {
      const width = rightEndTextRef.current.offsetWidth;
      setRightEndTextWidth(width);
    }
  }, [rightEndText]);
  const handleFocus = event => {
    setIsFocus(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };
  const handleBlur = event => {
    setIsFocus(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWrap, {
    disableState: disableState,
    margin: margin,
    placeholder: placeholderTxt,
    id: inputWprId,
    errorState: errorState,
    leftIcon: leftIcon,
    className: className,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWpr, {
      width: inputContainerWidth,
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputStyle, {
        ref: ref,
        id: inputId,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        isActive: isFocus,
        inputMode: inputMode,
        onChange: onChange,
        value: value,
        errorState: errorState,
        onBlur: handleBlur,
        disableState: disableState,
        onFocus: handleFocus,
        autoFocus: autoFocus,
        placeholder: placeholderTxt,
        spellCheck: false,
        maxLength: maxLength,
        required: true,
        rightEndText: rightEndText,
        paddingRight: rightEndTextWidth ? `${rightEndTextWidth + 10}px` : rightIcon && (_rightIconStyle === null || _rightIconStyle === void 0 ? void 0 : _rightIconStyle.width) ? `${parseInt(_rightIconStyle.width, 10) + 20}px` : '84px',
        paddingLeft: leftIcon && (_leftIconStyle === null || _leftIconStyle === void 0 ? void 0 : _leftIconStyle.width) ? `${parseInt(_leftIconStyle.width, 10) + 20}px` : '44px'
      }), labelTxt && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: inputId,
        children: labelTxt
      }), rightEndText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightTextContainer, {
        text: rightEndText,
        color: rightEndTextColor,
        margin: `12px 8px ${bottomRightTextMargin} 16px`,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1
      }), bottomRightText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BottomRightTextContainer, {
        text: bottomRightText,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2,
        color: theme.colors.mediumEmphasis,
        margin: "4px 0px 0px 12px"
      }), leftIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
        isFocus: isFocus,
        direction: "left",
        onClick: onLeftIconClick,
        value: value,
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: leftIcon,
          height: _leftIconStyle.height,
          width: _leftIconStyle.width
        })
      }), rightIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
        rightEndText: rightEndText,
        direction: "right",
        onClick: onRightIconClick,
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: rightIcon,
          height: _rightIconStyle.height,
          width: _rightIconStyle.width
        })
      })]
    }), errorStateText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ErrorStateText, {
      text: errorStateText,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.error,
      margin: "4px 0px 0px 0px"
    })
    // TODO : Check if this change doesnt affect lisitng page
    // <ParaTag
    //   margin="4px 0px 0px 12px"
    //   errorStateText={errorStateText}
    //   color={theme.colors.error}
    // >
    //   {errorStateText}
    // </ParaTag>
    , verifiedText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormattedText, {
      text: verifiedText,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.mediumEmphasis,
      margin: "4px 0px 0px 0px"
    })]
  });
});

const DropdownInputWrap = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownInputWrap",
  componentId: "sc-164spb4-0"
})(["font-family:", ";position:relative;display:flex;flex-direction:row;margin:", ";width:100%;border:1px solid ", ";border-radius:", ";background:", ";", " ", " ", " label{font-family:", ";", " color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:", ";top:50%;transform-origin:left;transform:translateY(-50%);text-transform:uppercase;pointer-events:none;", " ", " ", " ", "}"], ({
  theme
}) => theme.fontFamily, ({
  margin
}) => margin, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.screenBg, ({
  isFocused,
  errorState,
  theme
}) => isFocused && !errorState && `
    background: ${theme.colors.lightBlue};
     border-color: ${theme.colors.primaryAccent};
   `, ({
  errorState,
  theme
}) => errorState && `
      border-color: ${theme.colors.error}; 
      background: ${theme.colors.errorBg}; 
      `, ({
  disableState,
  value,
  theme
}) => disableState && `
    pointer-events: none;
    background: ${value ? theme.colors.screenBg : theme.colors.white}; 
  `, ({
  theme
}) => theme.fontFamily, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW2, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  theme
}) => theme.colors.mediumEmphasis, ({
  leftIcon,
  paddingLeft
}) => leftIcon ? paddingLeft : '12px', ({
  errorState,
  theme
}) => errorState && `
        color: ${theme.colors.error}; 
      `, ({
  placeholder,
  value,
  theme
}) => placeholder && !value && `
      
        color: ${theme.colors.disabled}; 
        transform: translateY(-20px) scale(0.8);
      `, ({
  value,
  leftIcon,
  theme
}) => value && `
        transform: translateY(-20px) scale(0.8);
         left:  ${leftIcon && '12px'};
         top:${leftIcon && '43%'}
      `, ({
  disableState,
  theme
}) => disableState && `
      pointer-events: none;
      color: ${theme.colors.disabled}; 
     
    `);
const DropdownInputStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownInputStyle",
  componentId: "sc-164spb4-1"
})(["display:inline-block;outline:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;user-select:text;color:", ";", " padding:", ";width:100%;", " ", ""], ({
  theme
}) => theme.colors.highEmphasis, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW3, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  leftIcon,
  rightIcon,
  rightEndText,
  paddingRight,
  paddingLeft,
  value,
  placeholder
}) => {
  const topPadding = '24px';
  const innerPadding = value || placeholder ? '8px' : '24px';
  const defaultLeftPadding = '12px';
  const defaultRightPadding = '12px';
  if (leftIcon && rightIcon) {
    return `${topPadding} ${paddingRight} ${innerPadding} ${paddingLeft}`;
  }
  if (leftIcon && rightEndText) {
    return `${topPadding} ${paddingRight} ${innerPadding} 44px`;
  }
  if (rightEndText) {
    return `${topPadding} ${paddingRight} ${innerPadding} ${defaultRightPadding}`;
  }
  if (leftIcon) {
    return `${topPadding} 4px ${innerPadding} ${paddingLeft}`;
  }
  if (rightIcon) {
    return `${topPadding} ${paddingRight || '44px'} ${innerPadding} ${defaultLeftPadding}`;
  }
  return `${topPadding} 4px ${innerPadding} ${defaultLeftPadding}`;
}, ({
  disableState,
  theme
}) => disableState && `color: ${theme.colors.disabled};
   `, ({
  placeholder,
  value,
  theme
}) => placeholder && !value && `color: ${theme.colors.disabled};
   `);
const DropdownRightTextContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownRightTextContainer",
  componentId: "sc-164spb4-2"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);text-align:right;"]);
const DropdownInputWpr = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownInputWpr",
  componentId: "sc-164spb4-3"
})([""]);
const DropdownIconContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownIconContainer",
  componentId: "sc-164spb4-4"
})(["position:absolute;top:", ";display:block;", " transform:translateY(-50%);transition:all 0.3s ease-in-out;cursor:pointer;"], ({
  value
}) => value ? '65%' : '50%', ({
  direction
}) => direction === 'left' ? 'left: 12px;' : 'right: 12px;');
const DropdownParaTag = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "Dropdownstyles__DropdownParaTag",
  componentId: "sc-164spb4-5"
})(["margin:", ";color:", ";", " max-width:", ";top:", ";position:", ";"], ({
  margin
}) => margin || '0', ({
  color
}) => color, ({
  theme,
  rightEndText
}) => {
  const typography = rightEndText ? _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2 : _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  maxWidth
}) => maxWidth, ({
  errorState
}) => errorState && '100%', ({
  errorState
}) => errorState && 'absolute');
const AdjacentTextSpan = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Dropdownstyles__AdjacentTextSpan",
  componentId: "sc-164spb4-6"
})(["color:", ";position:absolute;", " top:66%;transform:translateY(-50%);", ""], ({
  theme,
  disableState,
  placeholder,
  value
}) => disableState || placeholder && !value ? theme.colors.disabled : theme.colors.mediumEmphasis, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  disableState,
  theme
}) => disableState && `
      pointer-events: none;
      color: ${theme.colors.disabled}; 
     
    `);

const Dropdown = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(({
  placeholderTxt,
  labelTxt,
  disableState,
  inputWidth,
  margin,
  errorState,
  value,
  rightEndText,
  onRightElementClick,
  onLeftIconClick,
  handleDropdownPress,
  inputWprId,
  subLabelTxt,
  rightIcon,
  leftIcon,
  leftIconStyle: _leftIconStyle = {
    height: '24px',
    width: '24px'
  },
  rightIconStyle: _rightIconStyle = {
    height: '24px',
    width: '24px'
  },
  rightEndTextColor,
  adjacentText,
  rightEndTextMaxWidth: _rightEndTextMaxWidth = '60px',
  className
}, ref) => {
  const [isFocused, setIsFocused] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  const handleFocus = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    setIsFocused(false);
  };
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownInputWrap, {
    className: className,
    disableState: disableState,
    margin: margin,
    inputWidth: inputWidth,
    placeholder: placeholderTxt,
    id: inputWprId,
    errorState: errorState,
    leftIcon: leftIcon,
    onClick: handleDropdownPress,
    value: value,
    isFocused: isFocused,
    tabIndex: 0,
    onFocus: handleFocus,
    onBlur: handleBlur,
    paddingLeft: leftIcon && (_leftIconStyle === null || _leftIconStyle === void 0 ? void 0 : _leftIconStyle.width) ? `${parseInt(_leftIconStyle.width, 10) + 20}px` : '44px',
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownInputWpr, {
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownInputStyle, {
        isFocused: isFocused,
        value: value,
        disableState: disableState,
        rightEndText: rightEndText,
        errorState: errorState,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        placeholder: placeholderTxt,
        paddingRight: '4px',
        paddingLeft: leftIcon && (_leftIconStyle === null || _leftIconStyle === void 0 ? void 0 : _leftIconStyle.width) ? `${parseInt(_leftIconStyle.width, 10) + 20}px` : '44px',
        children: value || placeholderTxt
      }), labelTxt && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        children: [labelTxt, subLabelTxt && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
          style: {
            fontSize: '10px',
            marginLeft: '2px',
            fontWeight: theme.fontWeight.regular,
            color: disableState || placeholderTxt && !value ? theme.colors.disabled : theme.colors.mediumEmphasis
          },
          children: subLabelTxt
        })]
      }), value && adjacentText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AdjacentTextSpan, {
        value: value,
        disableState: disableState,
        placeholder: placeholderTxt,
        children: adjacentText
      }), rightEndText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownRightTextContainer, {
        onClick: event => {
          event.stopPropagation();
          onRightElementClick === null || onRightElementClick === void 0 ? void 0 : onRightElementClick();
        },
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownParaTag, {
          margin: "12px 0px 12px 16px",
          color: rightEndTextColor,
          maxWidth: _rightEndTextMaxWidth,
          rightEndText: rightEndText,
          children: rightEndText
        })
      }), leftIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownIconContainer, {
        isFocus: isFocused,
        direction: "left",
        onClick: onLeftIconClick,
        value: value,
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: leftIcon,
          height: _leftIconStyle.height,
          width: _leftIconStyle.width
        })
      }), rightIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownIconContainer, {
        direction: "right",
        onClick: event => {
          event.stopPropagation();
          onRightElementClick === null || onRightElementClick === void 0 ? void 0 : onRightElementClick();
        },
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: rightIcon,
          height: _rightIconStyle.height,
          width: _rightIconStyle.width
        })
      })]
    }), errorState && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownParaTag, {
      margin: "4px 0px 0px 12px",
      color: theme.colors.error,
      errorState: errorState,
      children: errorState
    })]
  });
});

const ArrowCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "SlickArrowstyles__ArrowCont",
  componentId: "h2nhfg-0"
})(["width:68px;padding:0 5px;height:30px;background-color:", ";box-shadow:0px 0 6px rgba(0,0,0,0.1);border-radius:20px;display:flex;flex-shrink:0;align-items:center;justify-content:space-between;"], ({
  theme
}) => theme.colors.white);
const ArrowBtn = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].button.withConfig({
  displayName: "SlickArrowstyles__ArrowBtn",
  componentId: "h2nhfg-1"
})(["width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;position:relative;outline:none;border:0;background-color:transparent;cursor:pointer;position:relative;&::before{display:inline-block;content:'';border:solid ", ";border-width:0 2px 2px 0;padding:3.5px;}&.disabled{cursor:not-allowed;opacity:0.5;}&::before{transform:", ";}"], ({
  theme
}) => theme.colors.primaryAccent, ({
  buttonType
}) => buttonType === 'next' ? 'rotate(-45deg)' : 'rotate(135deg)');

const SlickArrow = ({
  sliderRef,
  isFirstSlide,
  isLastSlide
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ArrowCont, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
      buttonType: "prev",
      onClick: () => {
        var _a;
        (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickPrev();
      },
      disabled: isFirstSlide,
      className: isFirstSlide ? 'disabled' : ''
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
      buttonType: "next",
      onClick: () => {
        var _a;
        return (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickNext();
      },
      disabled: isLastSlide,
      className: isLastSlide ? 'disabled' : ''
    })]
  });
};

const rotate = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const SpinnerCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Spinnerstyles__SpinnerCont",
  componentId: "sc-6mckxy-0"
})(["display:inline-block;animation:", " 1s linear infinite;border-radius:50%;flex-shrink:0;", ""], rotate, ({
  spinnerWidth,
  spinnerColor,
  thickness
}) => (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["width:", "px;height:", "px;border:", ";border-right-color:transparent;"], spinnerWidth, spinnerWidth, ({
  theme
}) => `${thickness}px solid ${spinnerColor || theme.colors.primaryAccent}`));

const Spinner = ({
  spinnerWidth: _spinnerWidth = 22,
  spinnerColor,
  thickness: _thickness = 2,
  className
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpinnerCont, {
    spinnerWidth: _spinnerWidth,
    spinnerColor: spinnerColor,
    thickness: _thickness,
    className: className
  });
};

const InputWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "SearchInputstyles__InputWrapper",
  componentId: "sc-1ieln6g-0"
})(["display:flex;align-items:center;background-color:#fff;column-gap:9px;"]);
const InputStyles = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
  displayName: "SearchInputstyles__InputStyles",
  componentId: "sc-1ieln6g-1"
})(["color:", ";width:100%;background-color:transparent;border:none;caret-color:", ";", "::placeholder{color:", ";}"], ({
  theme
}) => theme.colors.highEmphasis, ({
  theme
}) => theme.colors.primaryAccent, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW2, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
    `;
}, ({
  theme
}) => theme.colors.disabled);

const SearchInput = ({
  value,
  onChange,
  placeholder,
  src,
  ImageWidth,
  ImageHeight,
  className,
  autoFocus: _autoFocus = false
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWrapper, {
    className: className,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
      src: src,
      width: ImageWidth,
      height: ImageHeight
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputStyles, {
      value: value,
      onChange: onChange,
      placeholder: placeholder,
      autoFocus: _autoFocus
    })]
  });
};

const shimmer = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
const ShimmerComp = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Shimmerstyles__ShimmerComp",
  componentId: "sc-1d3ucui-0"
})(["animation:", " 1s linear infinite;background:linear-gradient(to right,#e2e2e2 8%,#f6f6f6 18%,#e2e2e2 33%);position:relative;background-size:800px 104px;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;display:flex;align-items:flex-end;"], shimmer, ({
  width
}) => width || '100%', ({
  height
}) => height || '14px', ({
  margin
}) => margin || '');

const Shimmer = ({
  width,
  height,
  margin
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShimmerComp, {
    width: width,
    height: height,
    margin: margin
  });
};

const ToastContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Toaststyles__ToastContainer",
  componentId: "sc-10qaa2n-0"
})(["display:flex;align-items:center;border-radius:", ";font-size:14px;margin:8px 0;position:fixed;bottom:50px;left:40%;z-index:20;padding:12px 16px;background:", ";"], ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.mediumEmphasis);
const Message = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "Toaststyles__Message",
  componentId: "sc-10qaa2n-1"
})(["max-width:402px;padding:2px 16px 2px 8px;"]);
const ToastIcon = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Image).withConfig({
  displayName: "Toaststyles__ToastIcon",
  componentId: "sc-10qaa2n-2"
})(["padding:2px 0px;cursor:pointer;"]);
const RightTextAction = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "Toaststyles__RightTextAction",
  componentId: "sc-10qaa2n-3"
})(["cursor:pointer;padding:9px 8px;"]);

const Toast = ({
  showCrossIcon: _showCrossIcon = false,
  message,
  type,
  duration: _duration = 5000,
  toastIcon,
  rightText,
  onToastIconClick,
  onRightTextActionClick,
  onClose,
  className
}) => {
  const [visible, setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    setVisible(true);
    startTimer();
    return () => clearTimer();
  }, [_duration]);
  const startTimer = () => {
    timerRef.current = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, _duration);
  };
  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };
  if (!visible) return null;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ToastContainer, {
    type: type,
    className: className,
    children: [_showCrossIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ToastIcon, {
      src: toastIcon || 'https://tripmoneycmsimgak.mmtcdn.com/img/Vector_1_83cdc73532.png',
      height: "20px",
      width: "20px",
      onClick: onToastIconClick
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Message, {
      text: message,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.white
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightTextAction, {
      text: rightText,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.white,
      onClick: onRightTextActionClick
    })]
  });
};

const SnackBarCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "SnackBarstyles__SnackBarCont",
  componentId: "sc-109egym-0"
})(["margin:", ";background:", ";padding:8px 12px;border-radius:", ";width:", ";"], ({
  margin
}) => margin, ({
  theme,
  backGroundColor
}) => backGroundColor || theme.colors.errorSnackBg, ({
  theme
}) => theme.borderRadius.br8, ({
  width
}) => width || '100%');

const SnackBar = ({
  backGroundColor,
  width,
  margin,
  text,
  typography,
  className,
  color
}) => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SnackBarCont, {
    className: className,
    backGroundColor: backGroundColor,
    margin: margin,
    width: width,
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormattedText, {
      text: text,
      color: color || theme.colors.mediumEmphasis,
      typography: typography
    })
  });
};




/***/ }),

/***/ 8772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BORDER_RADIUS_KEYS": function() { return /* binding */ BORDER_RADIUS_KEYS; },
/* harmony export */   "DEVICE": function() { return /* binding */ DEVICE; },
/* harmony export */   "FONT_FAMILY": function() { return /* binding */ FONT_FAMILY; },
/* harmony export */   "FONT_SIZE_KEYS": function() { return /* binding */ FONT_SIZE_KEYS; },
/* harmony export */   "FONT_WEIGHTS": function() { return /* binding */ FONT_WEIGHTS; },
/* harmony export */   "PARTNER": function() { return /* binding */ PARTNER; },
/* harmony export */   "TYPOGRAPHY_KEYS": function() { return /* binding */ TYPOGRAPHY_KEYS; },
/* harmony export */   "getFontSizeStyles": function() { return /* binding */ getFontSizeStyles; },
/* harmony export */   "getTheme": function() { return /* binding */ getTheme; },
/* harmony export */   "getTypographyStyles": function() { return /* binding */ getTypographyStyles; }
/* harmony export */ });
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var FONT_FAMILY;
(function(FONT_FAMILY) {
    FONT_FAMILY["LATO"] = "Lato";
    FONT_FAMILY["RUBIK"] = "Rubik";
})(FONT_FAMILY || (FONT_FAMILY = {}));
var PARTNER;
(function(PARTNER) {
    PARTNER["MMT"] = "mmt";
    PARTNER["GI"] = "gi";
})(PARTNER || (PARTNER = {}));
var DEVICE;
(function(DEVICE) {
    DEVICE["WEB"] = "web";
    DEVICE["APP"] = "app";
})(DEVICE || (DEVICE = {}));
var FONT_SIZE_KEYS;
(function(FONT_SIZE_KEYS) {
    FONT_SIZE_KEYS["FONT32"] = "font32";
    FONT_SIZE_KEYS["FONT30"] = "font30";
    FONT_SIZE_KEYS["FONT24"] = "font24";
    FONT_SIZE_KEYS["FONT22"] = "font22";
    FONT_SIZE_KEYS["FONT18"] = "font18";
    FONT_SIZE_KEYS["FONT16"] = "font16";
    FONT_SIZE_KEYS["FONT14"] = "font14";
    FONT_SIZE_KEYS["FONT12"] = "font12";
})(FONT_SIZE_KEYS || (FONT_SIZE_KEYS = {}));
var BORDER_RADIUS_KEYS;
(function(BORDER_RADIUS_KEYS) {
    BORDER_RADIUS_KEYS["BR2"] = "br2";
    BORDER_RADIUS_KEYS["BR4"] = "br4";
    BORDER_RADIUS_KEYS["BR6"] = "br6";
    BORDER_RADIUS_KEYS["BR8"] = "br8";
    BORDER_RADIUS_KEYS["BR10"] = "br10";
    BORDER_RADIUS_KEYS["BR12"] = "br12";
    BORDER_RADIUS_KEYS["BR16"] = "br16";
    BORDER_RADIUS_KEYS["BR20"] = "br20";
})(BORDER_RADIUS_KEYS || (BORDER_RADIUS_KEYS = {}));
var FONT_WEIGHTS;
(function(FONT_WEIGHTS) {
    FONT_WEIGHTS[FONT_WEIGHTS["REGULAR"] = 400] = "REGULAR";
    FONT_WEIGHTS[FONT_WEIGHTS["MEDIUM"] = 500] = "MEDIUM";
    FONT_WEIGHTS[FONT_WEIGHTS["SEMIBOLD"] = 600] = "SEMIBOLD";
    FONT_WEIGHTS[FONT_WEIGHTS["BOLD"] = 700] = "BOLD";
    FONT_WEIGHTS[FONT_WEIGHTS["EXTRABOLD"] = 900] = "EXTRABOLD";
})(FONT_WEIGHTS || (FONT_WEIGHTS = {}));

const BORDER_RADIUS = {
    [BORDER_RADIUS_KEYS.BR2]: 2,
    [BORDER_RADIUS_KEYS.BR4]: 4,
    [BORDER_RADIUS_KEYS.BR6]: 6,
    [BORDER_RADIUS_KEYS.BR8]: 8,
    [BORDER_RADIUS_KEYS.BR10]: 8,
    [BORDER_RADIUS_KEYS.BR12]: 12,
    [BORDER_RADIUS_KEYS.BR16]: 16,
    [BORDER_RADIUS_KEYS.BR20]: 20
};

// Common color definitions
const COMMON_COLORS$1 = {
    white: '#FFFFFF',
    bodyBg: '#F2F2F2',
    overlay: 'rgba(0, 0, 0, 0.5)',
    shadow: 'rgba(0, 0, 0, 0.2)',
    danger: '#EB2026',
    positiveBg: '#E6FFF9',
    bgLight: '#FCEDD4',
    blueCardBorder: `#CCE8FF`,
    verticalDividerLightBlue: '#d6e7fa',
    bulletPointBlueColor: '#16477f',
    borderBottomGreyColor: '#E8E8E8',
    errorSnackBg: '#FCDADB',
    greyBorder: '#d9d9d9',
    borderColor: '#e7e7e7',
    violetColor: '#8A50C7',
    lightGreenBg: '#e4fbf4',
    royalBlue: '#3543BF',
    lightPastelBlue: '#EFF1FF',
    brightGray: '#ECECEC',
    lightPeach: '#FFEDD1'
};
// MMT and GI-specific overrides
const MMT_COLOR_OVERRIDES$1 = {
    screenBg: '#F6F6F6',
    highEmphasis: '#000000',
    mediumEmphasis: '#4A4A4A',
    lowEmphasis: '#757575',
    disabled: 'rgba(0, 0, 0, 0.3)',
    positive: '#007E7D',
    warning: '#CF8100',
    error: '#EC2127',
    errorBg: '#FFFAFA',
    primaryAccent: '#008CFF',
    lightBlue: '#EAF5FF',
    cardBorder: '#D8D8D8',
    disabledBg: '#CBCBCB',
    lightPurple: '#f3f4fe',
    darkPurple: '#3023AE'
};
const GI_COLOR_OVERRIDES$1 = {
    screenBg: '#F7F7F7',
    highEmphasis: '#222222',
    mediumEmphasis: '#717171',
    lowEmphasis: '#B0B0B0',
    disabled: '#E6E6E6',
    positive: '#156128',
    warning: '#714D0A',
    error: '#FF3A5C',
    errorBg: '#FFEDED',
    primaryAccent: '#2276E3',
    lightBlue: '#E5F3FF',
    cardBorder: '#E4E4E4',
    disabledBg: '#E6E6E6',
    lightPurple: '#f3f4fe',
    darkPurple: '#3023AE'
};
// Utility function to generate color configurations
const createColorConfig$1 = (brandColors)=>_extends({}, COMMON_COLORS$1, brandColors);
// Generate MMT and GI color configurations using the utility function
const MMT_COLORS = createColorConfig$1(MMT_COLOR_OVERRIDES$1);
const GI_COLORS = createColorConfig$1(GI_COLOR_OVERRIDES$1);

// Common color definitions
const COMMON_COLORS = {
    orderNudge: 'linear-gradient(225deg, #3023AE 0%, #C86DD7 100%)'
};
// MMT and GI-specific overrides
const MMT_COLOR_OVERRIDES = {
    buttonBgColor: 'linear-gradient(90deg, rgba(83, 178, 254, 1) 0%, rgba(6, 90, 243, 1) 100%)'
};
const GI_COLOR_OVERRIDES = {
    buttonBgColor: '#FF6D38'
};
// Utility function to generate color configurations
const createColorConfig = (brandColors)=>_extends({}, COMMON_COLORS, brandColors);
// Generate MMT and GI color configurations using the utility function
const MMT_GRADIENT_COLORS = createColorConfig(MMT_COLOR_OVERRIDES);
const GI_GRADIENT_COLORS = createColorConfig(GI_COLOR_OVERRIDES);

const MMT_FONT_WEIGHT = {
    regular: FONT_WEIGHTS.REGULAR,
    medium: FONT_WEIGHTS.BOLD,
    bold: FONT_WEIGHTS.EXTRABOLD
};
const GI_FONT_WEIGHT = {
    regular: FONT_WEIGHTS.REGULAR,
    medium: FONT_WEIGHTS.MEDIUM,
    bold: FONT_WEIGHTS.BOLD
};

const LINE_HEIGHTS = {
    lh38: 38,
    lh36: 36,
    lh28: 28,
    lh26: 26,
    lh21: 21,
    lh18: 18,
    lh16: 16,
    lh14: 14
};

const FONT_SIZES = {
    [FONT_SIZE_KEYS.FONT32]: 32,
    [FONT_SIZE_KEYS.FONT30]: 30,
    [FONT_SIZE_KEYS.FONT24]: 24,
    [FONT_SIZE_KEYS.FONT22]: 22,
    [FONT_SIZE_KEYS.FONT18]: 18,
    [FONT_SIZE_KEYS.FONT16]: 16,
    [FONT_SIZE_KEYS.FONT14]: 14,
    [FONT_SIZE_KEYS.FONT12]: 12
};

const FONT_SIZE_STYLES = {
    [FONT_SIZE_KEYS.FONT32]: {
        fontSize: FONT_SIZES.font32,
        lineHeight: LINE_HEIGHTS.lh38
    },
    [FONT_SIZE_KEYS.FONT30]: {
        fontSize: FONT_SIZES.font30,
        lineHeight: LINE_HEIGHTS.lh36
    },
    [FONT_SIZE_KEYS.FONT24]: {
        fontSize: FONT_SIZES.font24,
        lineHeight: LINE_HEIGHTS.lh28
    },
    [FONT_SIZE_KEYS.FONT22]: {
        fontSize: FONT_SIZES.font22,
        lineHeight: LINE_HEIGHTS.lh26
    },
    [FONT_SIZE_KEYS.FONT18]: {
        fontSize: FONT_SIZES.font18,
        lineHeight: LINE_HEIGHTS.lh21
    },
    [FONT_SIZE_KEYS.FONT16]: {
        fontSize: FONT_SIZES.font16,
        lineHeight: LINE_HEIGHTS.lh18
    },
    [FONT_SIZE_KEYS.FONT14]: {
        fontSize: FONT_SIZES.font14,
        lineHeight: LINE_HEIGHTS.lh16
    },
    [FONT_SIZE_KEYS.FONT12]: {
        fontSize: FONT_SIZES.font12,
        lineHeight: LINE_HEIGHTS.lh14
    }
};
const getFontSizeStyles = (fontSize, device)=>{
    const { fontSize: fs, lineHeight: lh } = FONT_SIZE_STYLES[fontSize] || FONT_SIZE_STYLES[FONT_SIZE_KEYS.FONT14];
    if (device === DEVICE.WEB) {
        return `
      font-size: ${fs}px;
      line-height: ${lh}px;
    `;
    }
    return {
        fontSize: fs,
        lineHeight: lh
    };
};

// Utility function to add "px" suffix to values
const addPxToValues = (obj)=>{
    return Object.fromEntries(Object.entries(obj).map(([key, value])=>[
            key,
            `${value}px`
        ]));
};

// Helper function to get the font weight based on partner
const getFontWeight = (partner, weightType)=>{
    return partner === PARTNER.MMT ? MMT_FONT_WEIGHT[weightType] : GI_FONT_WEIGHT[weightType];
};
const TYPOGRAPHY_KEYS = {
    xLarge: 'xLarge',
    large30: 'large30',
    large: 'large',
    medium: 'medium',
    small: 'small',
    base: 'base',
    largeW1: 'labelLargeW1',
    largeW2: 'labelLargeW2',
    largeW3: 'labelLargeW3',
    mediumW1: 'labelMediumW1',
    mediumW2: 'labelMediumW2',
    mediumW3: 'labelMediumW3',
    smallW1: 'labelSmallW1',
    smallW2: 'labelSmallW2',
    smallW3: 'labelSmallW3',
    baseW1: 'labelBaseW1',
    baseW2: 'labelBaseW2',
    baseW3: 'labelBaseW3'
};
const typographyMap = {
    [TYPOGRAPHY_KEYS.xLarge]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT32,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.large30]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT30,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.large]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT24,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.medium]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT22,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.small]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.base]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.largeW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.largeW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.largeW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.mediumW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.mediumW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.mediumW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.smallW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT14,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.smallW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT14,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.smallW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT14,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.baseW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT12,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.baseW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT12,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.baseW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT12,
            fontWeight: getFontWeight(partner, 'bold')
        })
};
const getTypographyStyles = (typography, partner)=>{
    const styleFunction = typographyMap[typography];
    return styleFunction ? styleFunction(partner) : {
        fontSize: FONT_SIZE_KEYS.FONT14,
        fontWeight: getFontWeight(partner, 'regular')
    };
};

const getTheme = (partner, device)=>{
    const isMMT = partner === PARTNER.MMT;
    const baseTheme = {
        colors: isMMT ? MMT_COLORS : GI_COLORS,
        borderRadius: BORDER_RADIUS,
        fontSize: FONT_SIZES,
        lineHeight: LINE_HEIGHTS,
        partner
    };
    if (device === DEVICE.WEB) {
        return _extends({}, baseTheme, {
            borderRadius: addPxToValues(baseTheme.borderRadius),
            fontSize: addPxToValues(baseTheme.fontSize),
            lineHeight: addPxToValues(baseTheme.lineHeight),
            gradientColors: isMMT ? MMT_GRADIENT_COLORS : GI_GRADIENT_COLORS,
            fontFamily: isMMT ? FONT_FAMILY.LATO : FONT_FAMILY.RUBIK,
            fontWeight: isMMT ? MMT_FONT_WEIGHT : GI_FONT_WEIGHT
        });
    }
    return baseTheme;
};




/***/ }),

/***/ 2391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const track_1 = __webpack_require__(7169);
const Utils_1 = __webpack_require__(7817);
const isOnClient = typeof window !== 'undefined';
class CaptureWebVitals {
    // init: ((async: boolean, defer: boolean, appendOnBody: boolean) => void) | undefined
    /**
     *
     * @param moduleName This name will be used for PDT event name for ex if name is FLIGHTS_WEB_VITALS then log would be like FLIGHTS_WEB_VITALS_FCP, FLIGHTS_WEB_VITALS_LCP etc.
     * @param sampleSize sample size, by default this would be 1% of overall traffic
     */
    constructor(moduleName, sampleSize = 100, templateId, templateName) {
        this.addToQueue = (metric) => {
            const payload = (0, Utils_1.createPayload)(metric, this.moduleName, this.templateId, this.templateName);
            this.queue.add(payload);
        };
        this.initiatePDTCall = () => {
            const body = Array.from(this.queue);
            body.forEach((payload) => {
                (0, track_1.trackEvent)(payload);
            });
        };
        this.flushQueue = () => {
            if (this.queue.size > 0) {
                this.initiatePDTCall();
                this.queue.clear();
            }
        };
        this.handleOnload = () => {
            const webVitals = window.webVitals;
            ['onFCP', 'onLCP', 'onCLS', 'onFID', 'onINP', 'onTTFB'].forEach(event => {
                webVitals[event](this.addToQueue);
            });
        };
        this.addScript = (src, async = true, defer = true, onLoad = () => { }, appendOnBody = false) => {
            if (src) {
                const newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = async;
                newScript.defer = defer;
                newScript.src = src;
                newScript.id = 'core_web_vitals';
                newScript.onload = onLoad;
                appendOnBody ? document.body.appendChild(newScript) : document.head.appendChild(newScript);
            }
        };
        this.init = (async = true, defer = true, appendOnBody = true) => {
            const existingScript = document.getElementById('core_web_vitals');
            const num = Math.floor(Math.random() * 1000);
            if (num > this.sampleSize * 10 || existingScript)
                return;
            this.addScript('https://unpkg.com/web-vitals@3/dist/web-vitals.attribution.iife.js', async, defer, this.handleOnload, appendOnBody);
            if (isOnClient) {
                window.addEventListener('visibilitychange', () => {
                    if (document.visibilityState === 'hidden') {
                        this.flushQueue();
                    }
                });
                window.addEventListener('pagehide', this.flushQueue);
            }
        };
        this.moduleName = moduleName;
        this.queue = new Set();
        this.sampleSize = sampleSize;
        this.templateId = templateId || 52317;
        this.templateName = templateName || 'mmt_commons_b2c_pdt_client_logging';
        window.initWebVitals = this.init;
    }
}
exports["default"] = CaptureWebVitals;


/***/ }),

/***/ 7169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.trackEvent = void 0;
const event_logger_1 = __webpack_require__(2137);
const AnalyticsSdk = (0, event_logger_1.initAndGetAnalyticsSdk)({});
function trackEvent(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        AnalyticsSdk.track(Object.assign({}, payload), 'common');
    });
}
exports.trackEvent = trackEvent;


/***/ }),

/***/ 7817:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createPayload = exports.detectOS = void 0;
const NOT_AVAILABLE = 'NA';
function detectOS() {
    var _a;
    const platform = window.navigator.platform || '';
    if (/(Macintosh|MacIntel|MacPPC|Mac68K)/.test(platform))
        return 'Mac OS';
    if (/(iPhone|iPad|iPod)/.test(platform))
        return 'iOS';
    if (/(Win32|Win64|Windows|WinCE)/.test(platform))
        return 'Windows';
    if (/Android/.test((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent))
        return 'Android';
    if (/Linux/.test(platform))
        return 'Linux';
    return '';
}
exports.detectOS = detectOS;
function getTimeZone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || NOT_AVAILABLE;
    }
    catch (e) {
        return NOT_AVAILABLE;
    }
}
function readCookieValue(cookieString, cookieName) {
    const match = cookieString.match(new RegExp(cookieName + '=(.*?)($|;)'));
    return match ? match[1] : null;
}
function getDeviceName() {
    const parts = ((navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.match(/\((.*?)\)/)) || ['', ''])[1].split(" ");
    return (parts[3] + ' ' + parts[4]) || '';
}
const createPayload = (input, moduleName, templateId, templateName) => {
    var _a, _b;
    const { name, value, attribution } = input;
    const event_detail = {
        event_name: `${moduleName}_${name}`,
        event_type: 'action',
        event_value: value,
        event_id: '',
        event_timestamp: new Date().getTime(),
    };
    const device_context = {
        device_id: readCookieValue(document.cookie, 'dvid') || NOT_AVAILABLE,
        os_version: ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || NOT_AVAILABLE,
        platform: ((_b = window.navigator) === null || _b === void 0 ? void 0 : _b.userAgent.includes('Mobi')) ? 'pwa' : 'desktop',
        os: detectOS() || NOT_AVAILABLE,
        network_type: navigator.connection.effectiveType,
        model: getDeviceName(),
        time_zone: getTimeZone(),
        app_ver: NOT_AVAILABLE,
        build_ver: NOT_AVAILABLE,
        ip_addr: NOT_AVAILABLE,
    };
    switch (name) {
        case 'CLS':
            event_detail.event_id = attribution.largestShiftTarget;
            break;
        case 'LCP':
            event_detail.event_id = attribution.element;
            break;
        case 'FID':
        case 'INP':
            event_detail.event_id = attribution.eventTarget;
            // event_detail.inp_type = attribution.eventType;
            // event_detail.inp_time = attribution.eventTime;
            // event_detail.inp_load_state = attribution.loadState;
            break;
        default:
            break;
    }
    const payload = {
        page_context: {
            page_name: window.location.href || '',
        },
        event_tracking_context: {
            template_id: templateId,
            topic_name: templateName,
            session_visit_number: 1,
            env: 'prod',
            funnel_source: 'mmt',
        },
        context: {
            template_id: templateId,
            topic_name: templateName
        }
    };
    console.log("payload will be ", payload);
    return Object.assign(Object.assign({}, payload), { event_detail, device_context });
};
exports.createPayload = createPayload;


/***/ }),

/***/ 807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.Z = void 0;
var captureWebVitals_1 = __webpack_require__(2391);
Object.defineProperty(exports, "Z", ({ enumerable: true, get: function () { return captureWebVitals_1.default; } }));


/***/ }),

/***/ 5720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-expect-error "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 7392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5720);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(4406);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 7790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7392);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 63:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 5328:
/***/ (function(module) {

/*! For license information please see index.js.LICENSE.txt */
!function(t,e){ true?module.exports=e():0}(this,(()=>(()=>{var t={5098:(t,e,r)=>{var n=r(3305),o=r(9361),i=r(1112),a=r(5276),u=r(7452);function c(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}c.prototype.clear=n,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=a,c.prototype.set=u,t.exports=c},1386:(t,e,r)=>{var n=r(2393),o=r(2049),i=r(7144),a=r(5071),u=r(3964);function c(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}c.prototype.clear=n,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=a,c.prototype.set=u,t.exports=c},9770:(t,e,r)=>{var n=r(4715)(r(8942),"Map");t.exports=n},8250:(t,e,r)=>{var n=r(9753),o=r(5681),i=r(88),a=r(4732),u=r(9068);function c(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}c.prototype.clear=n,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=a,c.prototype.set=u,t.exports=c},5650:(t,e,r)=>{var n=r(8942).Symbol;t.exports=n},5111:t=>{t.exports=function(t,e){for(var r=-1,n=null==t?0:t.length,o=Array(n);++r<n;)o[r]=e(t[r],r,t);return o}},7034:(t,e,r)=>{var n=r(6285);t.exports=function(t,e){for(var r=t.length;r--;)if(n(t[r][0],e))return r;return-1}},7923:(t,e,r)=>{var n=r(3526),o=r(6040);t.exports=function(t,e){for(var r=0,i=(e=n(e,t)).length;null!=t&&r<i;)t=t[o(e[r++])];return r&&r==i?t:void 0}},7379:(t,e,r)=>{var n=r(5650),o=r(8870),i=r(9005),a=n?n.toStringTag:void 0;t.exports=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":a&&a in Object(t)?o(t):i(t)}},9624:(t,e,r)=>{var n=r(3655),o=r(4759),i=r(1580),a=r(4066),u=/^\[object .+?Constructor\]$/,c=Function.prototype,l=Object.prototype,s=c.toString,f=l.hasOwnProperty,p=RegExp("^"+s.call(f).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=function(t){return!(!i(t)||o(t))&&(n(t)?p:u).test(a(t))}},2291:(t,e,r)=>{var n=r(5650),o=r(5111),i=r(3142),a=r(1187),u=n?n.prototype:void 0,c=u?u.toString:void 0;t.exports=function t(e){if("string"==typeof e)return e;if(i(e))return o(e,t)+"";if(a(e))return c?c.call(e):"";var r=e+"";return"0"==r&&1/e==-1/0?"-0":r}},3526:(t,e,r)=>{var n=r(3142),o=r(5187),i=r(6493),a=r(5243);t.exports=function(t,e){return n(t)?t:o(t,e)?[t]:i(a(t))}},1950:(t,e,r)=>{var n=r(8942)["__core-js_shared__"];t.exports=n},4967:(t,e,r)=>{var n="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g;t.exports=n},4700:(t,e,r)=>{var n=r(9067);t.exports=function(t,e){var r=t.__data__;return n(e)?r["string"==typeof e?"string":"hash"]:r.map}},4715:(t,e,r)=>{var n=r(9624),o=r(155);t.exports=function(t,e){var r=o(t,e);return n(r)?r:void 0}},8870:(t,e,r)=>{var n=r(5650),o=Object.prototype,i=o.hasOwnProperty,a=o.toString,u=n?n.toStringTag:void 0;t.exports=function(t){var e=i.call(t,u),r=t[u];try{t[u]=void 0;var n=!0}catch(t){}var o=a.call(t);return n&&(e?t[u]=r:delete t[u]),o}},155:t=>{t.exports=function(t,e){return null==t?void 0:t[e]}},3305:(t,e,r)=>{var n=r(4497);t.exports=function(){this.__data__=n?n(null):{},this.size=0}},9361:t=>{t.exports=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}},1112:(t,e,r)=>{var n=r(4497),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;if(n){var r=e[t];return"__lodash_hash_undefined__"===r?void 0:r}return o.call(e,t)?e[t]:void 0}},5276:(t,e,r)=>{var n=r(4497),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;return n?void 0!==e[t]:o.call(e,t)}},7452:(t,e,r)=>{var n=r(4497);t.exports=function(t,e){var r=this.__data__;return this.size+=this.has(t)?0:1,r[t]=n&&void 0===e?"__lodash_hash_undefined__":e,this}},5187:(t,e,r)=>{var n=r(3142),o=r(1187),i=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,a=/^\w*$/;t.exports=function(t,e){if(n(t))return!1;var r=typeof t;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=t&&!o(t))||a.test(t)||!i.test(t)||null!=e&&t in Object(e)}},9067:t=>{t.exports=function(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}},4759:(t,e,r)=>{var n,o=r(1950),i=(n=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||""))?"Symbol(src)_1."+n:"";t.exports=function(t){return!!i&&i in t}},2393:t=>{t.exports=function(){this.__data__=[],this.size=0}},2049:(t,e,r)=>{var n=r(7034),o=Array.prototype.splice;t.exports=function(t){var e=this.__data__,r=n(e,t);return!(r<0||(r==e.length-1?e.pop():o.call(e,r,1),--this.size,0))}},7144:(t,e,r)=>{var n=r(7034);t.exports=function(t){var e=this.__data__,r=n(e,t);return r<0?void 0:e[r][1]}},5071:(t,e,r)=>{var n=r(7034);t.exports=function(t){return n(this.__data__,t)>-1}},3964:(t,e,r)=>{var n=r(7034);t.exports=function(t,e){var r=this.__data__,o=n(r,t);return o<0?(++this.size,r.push([t,e])):r[o][1]=e,this}},9753:(t,e,r)=>{var n=r(5098),o=r(1386),i=r(9770);t.exports=function(){this.size=0,this.__data__={hash:new n,map:new(i||o),string:new n}}},5681:(t,e,r)=>{var n=r(4700);t.exports=function(t){var e=n(this,t).delete(t);return this.size-=e?1:0,e}},88:(t,e,r)=>{var n=r(4700);t.exports=function(t){return n(this,t).get(t)}},4732:(t,e,r)=>{var n=r(4700);t.exports=function(t){return n(this,t).has(t)}},9068:(t,e,r)=>{var n=r(4700);t.exports=function(t,e){var r=n(this,t),o=r.size;return r.set(t,e),this.size+=r.size==o?0:1,this}},6853:(t,e,r)=>{var n=r(9011);t.exports=function(t){var e=n(t,(function(t){return 500===r.size&&r.clear(),t})),r=e.cache;return e}},4497:(t,e,r)=>{var n=r(4715)(Object,"create");t.exports=n},9005:t=>{var e=Object.prototype.toString;t.exports=function(t){return e.call(t)}},8942:(t,e,r)=>{var n=r(4967),o="object"==typeof self&&self&&self.Object===Object&&self,i=n||o||Function("return this")();t.exports=i},6493:(t,e,r)=>{var n=r(6853),o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,i=/\\(\\)?/g,a=n((function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(o,(function(t,r,n,o){e.push(n?o.replace(i,"$1"):r||t)})),e}));t.exports=a},6040:(t,e,r)=>{var n=r(1187);t.exports=function(t){if("string"==typeof t||n(t))return t;var e=t+"";return"0"==e&&1/t==-1/0?"-0":e}},4066:t=>{var e=Function.prototype.toString;t.exports=function(t){if(null!=t){try{return e.call(t)}catch(t){}try{return t+""}catch(t){}}return""}},6285:t=>{t.exports=function(t,e){return t===e||t!=t&&e!=e}},6123:(t,e,r)=>{var n=r(7923);t.exports=function(t,e,r){var o=null==t?void 0:n(t,e);return void 0===o?r:o}},3142:t=>{var e=Array.isArray;t.exports=e},3655:(t,e,r)=>{var n=r(7379),o=r(1580);t.exports=function(t){if(!o(t))return!1;var e=n(t);return"[object Function]"==e||"[object GeneratorFunction]"==e||"[object AsyncFunction]"==e||"[object Proxy]"==e}},1580:t=>{t.exports=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}},547:t=>{t.exports=function(t){return null!=t&&"object"==typeof t}},1187:(t,e,r)=>{var n=r(7379),o=r(547);t.exports=function(t){return"symbol"==typeof t||o(t)&&"[object Symbol]"==n(t)}},9011:(t,e,r)=>{var n=r(8250);function o(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new TypeError("Expected a function");var r=function(){var n=arguments,o=e?e.apply(this,n):n[0],i=r.cache;if(i.has(o))return i.get(o);var a=t.apply(this,n);return r.cache=i.set(o,a)||i,a};return r.cache=new(o.Cache||n),r}o.Cache=n,t.exports=o},5243:(t,e,r)=>{var n=r(2291);t.exports=function(t){return null==t?"":n(t)}},7048:(t,e,r)=>{var n=r(4319).default;function o(){"use strict";t.exports=o=function(){return r},t.exports.__esModule=!0,t.exports.default=t.exports;var e,r={},i=Object.prototype,a=i.hasOwnProperty,u=Object.defineProperty||function(t,e,r){t[e]=r.value},c="function"==typeof Symbol?Symbol:{},l=c.iterator||"@@iterator",s=c.asyncIterator||"@@asyncIterator",f=c.toStringTag||"@@toStringTag";function p(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{p({},"")}catch(e){p=function(t,e,r){return t[e]=r}}function d(t,e,r,n){var o=e&&e.prototype instanceof x?e:x,i=Object.create(o.prototype),a=new D(n||[]);return u(i,"_invoke",{value:C(t,r,a)}),i}function v(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}r.wrap=d;var y="suspendedStart",h="suspendedYield",m="executing",g="completed",b={};function x(){}function w(){}function S(){}var _={};p(_,l,(function(){return this}));var O=Object.getPrototypeOf,E=O&&O(O(L([])));E&&E!==i&&a.call(E,l)&&(_=E);var I=S.prototype=x.prototype=Object.create(_);function T(t){["next","throw","return"].forEach((function(e){p(t,e,(function(t){return this._invoke(e,t)}))}))}function A(t,e){function r(o,i,u,c){var l=v(t[o],t,i);if("throw"!==l.type){var s=l.arg,f=s.value;return f&&"object"==n(f)&&a.call(f,"__await")?e.resolve(f.__await).then((function(t){r("next",t,u,c)}),(function(t){r("throw",t,u,c)})):e.resolve(f).then((function(t){s.value=t,u(s)}),(function(t){return r("throw",t,u,c)}))}c(l.arg)}var o;u(this,"_invoke",{value:function(t,n){function i(){return new e((function(e,o){r(t,n,e,o)}))}return o=o?o.then(i,i):i()}})}function C(t,r,n){var o=y;return function(i,a){if(o===m)throw Error("Generator is already running");if(o===g){if("throw"===i)throw a;return{value:e,done:!0}}for(n.method=i,n.arg=a;;){var u=n.delegate;if(u){var c=P(u,n);if(c){if(c===b)continue;return c}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===y)throw o=g,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=m;var l=v(t,r,n);if("normal"===l.type){if(o=n.done?g:h,l.arg===b)continue;return{value:l.arg,done:n.done}}"throw"===l.type&&(o=g,n.method="throw",n.arg=l.arg)}}}function P(t,r){var n=r.method,o=t.iterator[n];if(o===e)return r.delegate=null,"throw"===n&&t.iterator.return&&(r.method="return",r.arg=e,P(t,r),"throw"===r.method)||"return"!==n&&(r.method="throw",r.arg=new TypeError("The iterator does not provide a '"+n+"' method")),b;var i=v(o,t.iterator,r.arg);if("throw"===i.type)return r.method="throw",r.arg=i.arg,r.delegate=null,b;var a=i.arg;return a?a.done?(r[t.resultName]=a.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,b):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,b)}function j(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function N(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function D(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(j,this),this.reset(!0)}function L(t){if(t||""===t){var r=t[l];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,i=function r(){for(;++o<t.length;)if(a.call(t,o))return r.value=t[o],r.done=!1,r;return r.value=e,r.done=!0,r};return i.next=i}}throw new TypeError(n(t)+" is not iterable")}return w.prototype=S,u(I,"constructor",{value:S,configurable:!0}),u(S,"constructor",{value:w,configurable:!0}),w.displayName=p(S,f,"GeneratorFunction"),r.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===w||"GeneratorFunction"===(e.displayName||e.name))},r.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,S):(t.__proto__=S,p(t,f,"GeneratorFunction")),t.prototype=Object.create(I),t},r.awrap=function(t){return{__await:t}},T(A.prototype),p(A.prototype,s,(function(){return this})),r.AsyncIterator=A,r.async=function(t,e,n,o,i){void 0===i&&(i=Promise);var a=new A(d(t,e,n,o),i);return r.isGeneratorFunction(e)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},T(I),p(I,f,"Generator"),p(I,l,(function(){return this})),p(I,"toString",(function(){return"[object Generator]"})),r.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},r.values=L,D.prototype={constructor:D,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(N),!t)for(var r in this)"t"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function n(n,o){return u.type="throw",u.arg=t,r.next=n,o&&(r.method="next",r.arg=e),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],u=i.completion;if("root"===i.tryLoc)return n("end");if(i.tryLoc<=this.prev){var c=a.call(i,"catchLoc"),l=a.call(i,"finallyLoc");if(c&&l){if(this.prev<i.catchLoc)return n(i.catchLoc,!0);if(this.prev<i.finallyLoc)return n(i.finallyLoc)}else if(c){if(this.prev<i.catchLoc)return n(i.catchLoc,!0)}else{if(!l)throw Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return n(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=t,i.arg=e,o?(this.method="next",this.next=o.finallyLoc,b):this.complete(i)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),b},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),N(r),b}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;N(r)}return o}}throw Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:L(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),b}},r}t.exports=o,t.exports.__esModule=!0,t.exports.default=t.exports},4319:t=>{function e(r){return t.exports=e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,e(r)}t.exports=e,t.exports.__esModule=!0,t.exports.default=t.exports},5799:(t,e,r)=>{var n=r(7048)();t.exports=n;try{regeneratorRuntime=n}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}}},e={};function r(n){var o=e[n];if(void 0!==o)return o.exports;var i=e[n]={exports:{}};return t[n](i,i.exports,r),i.exports}r.n=t=>{var e=t&&t.__esModule?()=>t.default:()=>t;return r.d(e,{a:e}),e},r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"==typeof window)return window}}(),r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),r.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var n={};return(()=>{"use strict";function t(t,e,r,n,o,i,a){try{var u=t[i](a),c=u.value}catch(t){return void r(t)}u.done?e(c):Promise.resolve(c).then(n,o)}r.r(n),r.d(n,{getUserInfoPIIClient:()=>Mt});var e=r(5799),o=r.n(e),i="awefewfuihewfhewfuhiebc",a="limitedConsent",u="isGdprRegion",c="enct-",l="GDPR_C",s={ES:"essential",N_ES:"nonEssential"};const f="undefined"!=typeof window;function p(t){return p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},p(t)}function d(t,e,r){return(e=function(t){var e=function(t,e){if("object"!=p(t)||!t)return t;var r=t[Symbol.toPrimitive];if(void 0!==r){var n=r.call(t,"string");if("object"!=p(n))return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(t)}(t);return"symbol"==p(e)?e:e+""}(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}var v="GI",y="IGO",h="HDFC_SB",m="AFFCGOBIZMMTAIX",g=(d(d(d({},v,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),y,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),m,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),d(d({},v,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),y,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(t){var e,r=t||"";f&&(r=(null===(e=window)||void 0===e||null===(e=e.location)||void 0===e?void 0:e.hostname)||"");var n="";return r&&(-1!==r.indexOf("giholidays")?n=v:-1!==r.indexOf("6eholidays")?n=y:-1!==r.indexOf("hdfcsmartbuyholidays")||-1!==r.indexOf("hdfcsmartbuyrailways")?n=h:-1!==r.indexOf("airindiaexpressholidays")?n=m:-1!==r.indexOf("flightsexpert.goibibo")?n="AFFCGOBIZGIFLTEXP":-1!==r.indexOf("flightsexpert.makemytrip")||-1!==r.indexOf("holidaysexpert.makemytrip")?n="AFFCGOBIZMMTFLTEXP":-1!==r.indexOf("forexexpert.makemytrip")?n="AFFTMFXMMTFOREXEXP":-1!==r.indexOf("forexexpert.goibibo")&&(n="AFFTMFXGIFOREXEXP")),n}),b=function(t,e){var r=g(e).toLowerCase();return r?"".concat(t,"-").concat(r):t},x=(new Date,function(t){return f&&g()?".".concat(window.location.hostname):".".concat(S(t))}),w=function(){var t,e,r,n,o=R(b("dvid"),void 0,s.ES)||(n=(new Date).getTime(),"undefined"!=typeof performance&&"function"==typeof performance.now&&(n+=performance.now()),"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(t){var e=(n+16*Math.random())%16|0;return n=Math.floor(n/16),("x"===t?e:3&e|8).toString(16)})));return t=o,!R(b("dvid"),void 0,s.ES)&&t&&U(b("dvid"),t,{expiresVal:(e=new Date,r=e.getTime(),r+=305856e5,e.setTime(r),e),path:"/",domain:x()},s.ES),o},S=function(t){var e=t||"www.makemytrip.com";f&&(e=window.location.hostname);var r=(e=(e=e.replace("www.","").replace(":8000")).replace("ae.","")).split(".");return r.splice(r.length-2,r.length).join(".")},_=function(t){return!t||"IS"!==t&&"11"!==t?"fullConsent":a},O=function(t){try{return JSON.stringify(t)}catch(t){return null}},E=function(t){try{return JSON.parse(t)}catch(t){return null}},I={},T=function(t,e,r,n){var o,i,a=r,u=n,c=(null==I?void 0:I[t])||{};return f&&(a=void 0===r?(null===(o=c[e])||void 0===o?void 0:o.type)||s.N_ES:r,u=void 0===n?(null===(i=c[e])||void 0===i?void 0:i.isPiiData)||!1:n),{essential:a=a===s.ES,piiData:u}},A=function(t){return new RegExp("(?:^|;\\s*)".concat(t,"\\s*=\\s*([^;]*)"))},C=function(t){var e=b(t),r=A(e).exec(document.cookie);return null!==r?decodeURIComponent(r[1]):null},P=function(){var t=C("myBusinessSubscription"),e=C("mmt-auth"),r=null==e?void 0:e.charAt(e.length-1);return!(!t||"b2b"!==t)||"C"===r},j=function(){var t;return"1"!==C(u)||!!P()||(t=C(l),_(t)!==a)},N="cookieList",D="sessionList";function L(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during encryption:",t),null}}function k(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during the decryption process:",t),null}}var F=function(t){return new TypeError("Valid key & value is required for @MMT-UI/storages$$/client/cookies ".concat(t))},R=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2?arguments[2]:void 0;try{var n;if(!f)return null;if(!t)throw F("get");var o,a=(e||{}).isPiiData,u=(e||{}).shouldParseJson,l=T(N,t,r,a);if(o=l.essential,a=l.piiData,!o&&!j())return null;var s=A(t).exec(document.cookie),p=null!==s?decodeURIComponent(s[1]):null;if(a&&null!==(n=p)&&void 0!==n&&n.includes(c)){var d=new RegExp("^".concat(c));p=k(p=p.replace(d,""),i)}return u&&(p=E(p)),p}catch(t){return null}},U=function(t,e,r,n){try{if(!f)return!1;if(!t||void 0===e)throw F("set");var o,a=r||{},u=a.expiresVal,l=a.maxAge,s=a.path,d=a.domain,v=a.secure,y=a.sameSite,h=a.shouldStringifyJson,m=a.partitioned,g=(r||{}).isPiiData,b=T(N,t,n,g);if(o=b.essential,g=b.piiData,!o&&!j())return!1;var x=h?O(e):e;if(x&&g){var w=L(x,i);if(!w)return!1;x="".concat(c).concat(w)}var S=function(t,e){var r=t?"; max-age=".concat(t):"",n="";if(e)switch(p(e)){case"string":n="; expires=".concat(new Date(e).toUTCString());break;case"number":var o=new Date;o.setSeconds(e),n="; expires=".concat(o.toUTCString());break;case"object":e instanceof Date&&(n="; expires=".concat(e.toUTCString()))}return{sMaxAge:r,sExpiry:n}}(l,u),_=S.sMaxAge,E=S.sExpiry,I=m?"; samesite=none; secure; partitioned":"";I||(I=v?y?"; samesite=".concat(y,"; secure"):"; secure":y?"; samesite=".concat(y):"");var A="".concat(encodeURIComponent(t),"=").concat(encodeURIComponent(x)),C="".concat(_).concat(E).concat(s?"; path=".concat(s):""),P="".concat(d?"; domain=".concat(d):"").concat(I);return document.cookie="".concat(A).concat(C).concat(P),!0}catch(t){return!1}},M=function(t){return new TypeError("Valid key & value is required for sessionStorage ".concat(t))},G=function(t,e,r,n){try{if(!f||!sessionStorage)return!1;if(!t||void 0===e)throw M("get");var o,a=(r||{}).isPiiData,u=(r||{}).shouldStringifyJson,l=T(D,t,n,a);if(o=l.essential,a=l.piiData,!o&&!j())return!1;var s=u?O(e):e;if(s&&a){var p=L(s,i);if(!p)return!1;s="".concat(c).concat(p)}return sessionStorage.setItem(t,s),!0}catch(t){return!1}},z=function(t){try{if(!f||!sessionStorage)return!1;if(!t)throw M("get");return sessionStorage.removeItem(t),!0}catch(t){return!1}},B=function(t){try{if(!f||!localStorage)return!1;if(!t)throw new TypeError("Valid key & value is required for localstorage ".concat("get"));return localStorage.removeItem(t),!0}catch(t){return!1}};function J(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=Array(e);r<e;r++)n[r]=t[r];return n}function V(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var r=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null!=r){var n,o,i,a,u=[],c=!0,l=!1;try{if(i=(r=r.call(t)).next,0===e){if(Object(r)!==r)return;c=!1}else for(;!(c=(n=i.call(r)).done)&&(u.push(n.value),u.length!==e);c=!0);}catch(t){l=!0,o=t}finally{try{if(!c&&null!=r.return&&(a=r.return(),Object(a)!==a))return}finally{if(l)throw o}}return u}}(t,e)||function(t,e){if(t){if("string"==typeof t)return J(t,e);var r={}.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?J(t,e):void 0}}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}var W=r(6123),H=r.n(W),$="//www.makemytrip.com",q="BUSINESS",X=".makemytrip.global",K=("ae".concat(X),"sa".concat(X),"www".concat(X),{USER_NAME:"userName",LOGGED_IN_TILE:"showLoggedInTile",AUTH:"mmt-auth",LOGIN_DISMISS:"loginDismissed",USER_INFO:"userInfo",ORCHASTATOR:"orchestator",PREFILL:"prefill",LINK_MOBILE:"linkMobile",SIGNUP_TXN_ID:"signupTxnId",SMART_LOCK_DISMISS:"smartLockDismissed",YOLO_DISMISS:"yoloDismissed",OTP_CONFIG:"otpConfig",MMT_UUID:"mmt-uuid",IS_CTA:"isCTA",EVAR39:"evar39",AUTO_FETCH_RESPONSE:"autoFetchResponse",HISTORY_STATE:"historyState",COUNTRY_CODE:"countryCode",OTP_SENT:"otpSent",LOGIN_EXPIRED:"loginExpired",VERTICAL:"vertical",MY_BIZ_SUBSCRIPTION:"myBusinessSubscription",SIGNUP_FULLNAME:"signupFullName",GCC_APP_DOWNLOAD_PROMPT_DISMISS:"gccAppDownloadPromptDismiss",AUTHS:"auths",WALLET_CREDIT_POPUP_STATUS:"walletCreditPopupStatus",LOGIN_TYPE:"loginType",AUTH_ALT:"mmt-auth-alt",LOGIN_CHANNEL:"loginChannel",CHANNEL:"channel"}),Y=(d({},"accountLinked",{title:{id:"login.widget.pwa.account.linked.successfully",defaultMessage:"Account linked Successfully"}}),"//mapi.makemytrip.com"),Q="".concat(Y,"/ext/web/pwa"),Z="".concat(Y,"/pwa/hlp/v3/api/get-header-config"),tt=("".concat(Y,"/ext/hcs"),"".concat(Y,"/surveymgmt/v1/commonnps/createDesktopSurvey"),"x-gommt-client-id"),et=function(t){return void 0!==t.initialGdprRegion?t.initialGdprRegion:"1"===t.cookies[u]},rt=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=arguments.length>3?arguments[3]:void 0;try{var o;if(f)return null;if(!e)throw new TypeError("Valid key & value is required for @MMT-UI/storages$$/server/cookies ".concat("get"));if(et(t)&&n!==s.ES&&!function(t){if(et(t)){if(function(t){var e,r,n=null===(e=t.cookies)||void 0===e?void 0:e.myBusinessSubscription,o=null===(r=t.cookies)||void 0===r?void 0:r["mmt-auth"],i=null==o?void 0:o.charAt(o.length-1);return!(!n||"b2b"!==n)||"C"===i}(t))return!0;var e=function(t){var e,r,n=b(l);return r=void 0!==t.initialCheckGdprConsent?t.initialCheckGdprConsent:null===(e=t.cookies)||void 0===e?void 0:e[n],_(r)}(t);return e!==a}return!0}(t))return null;var u=r||{},p=u.isPiiData,d=u.shouldParseJson,v=t.cookies[e]||null;if(p&&null!==(o=v)&&void 0!==o&&o.includes(c)){var y=new RegExp("^".concat(c));v=k(v=v.replace(y,""),i)}return d&&(v=E(v)),v}catch(t){return!1}},nt="IN",ot="eng",it={IN:"in",AE:"ae",US:"us",OM:"om",SA:"sa",KW:"kw"},at={IN:ot,AE:ot,US:ot,OM:ot,SA:ot,KW:ot},ut={IN:"inr",AE:"aed",US:"usd",SA:"sar",KW:"kwd",OM:"omr"},ct={},lt=function(){return ct.countryCode?ct:{countryCode:it[nt],language:at[nt],currency:ut[nt]}},st={},ft=function(){return(null==st?void 0:st.languageCode)||ot},pt=function(){return lt().currency},dt=function(){return lt().countryCode},vt=("".concat($,"/legal/").concat(dt(),"/").concat(ft(),"/user_agreement.html"),"".concat($,"/legal/").concat(dt(),"/").concat(ft(),"/privacy_policy.html"),"".concat($,"/legal/").concat(dt(),"/").concat(ft(),"/user_agreement.html#tos"),function(t){var e=g();if(e){var r=e.toLowerCase();return"".concat(t,"-").concat(r)}return t}),yt={IN:"inr",AE:"aed",US:"usd",SA:"sar"},ht="vertical",mt="myBusinessSubscription",gt="myPartner",bt=function(){return R(vt(mt),void 0,s.ES)===gt||R(vt(ht),void 0,s.ES)===gt},xt=function(t){return f?bt():function(t){return rt(t,vt(mt),void 0,s.ES)===gt||rt(t,vt(ht),void 0,s.ES)===gt}(t)};function wt(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function St(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?wt(Object(r),!0).forEach((function(e){d(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):wt(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}var _t={type:"SESSION_ID",query:[[{name:"extendedUser",keys:["primaryEmailId","uuid","accountId","profileType","contactDetails","corporateData","affiliateId"]}],[{name:"extendedUser"},{name:"contactDetails",keys:["contactId","type","category","name","info","additionalDetails","status"],filters:[{name:"status",value:"ACTIVE"}]}],[{name:"extendedUser"},{name:"userImages",keys:["fileName","filePath","id","status"],filters:[{name:"status",value:"ACTIVE"}]}],[{name:"personalDetails",keys:["name","gender","childNCount","maritalStatus","anniversaryDate","dateOfBirth","nationality"]}],[{name:"extendedUser"},{name:"loginInfoList",keys:["loginId","verified","status","loginType","countryCode"],filters:[{name:"verified",value:!0},{name:"status",value:"ACTIVE"}]}],[{name:"extendedUser"},{name:"miscFields",keys:["agentInfo","heAgentInfo","ldapId"]}]]},Ot=St({"makemytrip.us":{siteDomain:"US",authorization:"FIxy0LJVle9UIg8"},"makemytrip.ae":{siteDomain:"UAE",authorization:"6gA2Wuz9cQEwqJq"},"makemytrip.om":{siteDomain:"OM",authorization:"6gA2Wuz9cQEwqJq"},"makemytrip.sa":{siteDomain:"SA",authorization:"6gA2Wuz9cQEwqJq"},"makemytrip.kw":{siteDomain:"KW",authorization:"6gA2Wuz9cQEwqJq"}},{}),Et=function(t){var e;return(null==t||null===(e=t.data)||void 0===e?void 0:e.profileLoginResponse)||[]},It=function(t,e){var r;return null===(r=t.filter((function(t){return(null==t?void 0:t.authToken)===e}))[0])||void 0===r?void 0:r.userDetails},Tt=function(t){var e,r,n,o,i,a=t.extendedUser,u=a.personalDetails,c=function(t){var e,r=JSON.parse(null==t?void 0:t.corporateData),n=H()(r,"employee.employeeStatus"),o=function(t){var e=!1;if(t&&t.employee){var r=t.employee,n=r.provisionAdmin,o=r.roles,i=!1;o&&o.indexOf(q)>-1&&(i=!0),e=n&&!i}return e}(r);n?("DISABLED"===n&&(e={isEmployee:!0,isActive:!1,message:r.employee.displayMessage}),e={isEmployee:!0,isActive:!0,employeeInfo:r,isProvAdmin:o}):e={isEmployee:!1};var i,a,u,c=(i=e,a="",(u=H()(i,"employeeInfo.employee.roles"))&&u.indexOf("ADMIN")>-1?a="admin":u&&u.length>0&&(a="nonadmin"),a);return St(St({},e),{},{corporateRole:c,blockLobs:H()(r,"employee.blockLobs",[])})}(a),l=JSON.parse(a.corporateData),s=H()(l,"employee.showMsmeWelcomePopup"),f=null==l||null===(e=l.employee)||void 0===e?void 0:e.showSubscriptionPopup,p=c.blockLobs,d=null==p||null===(r=p.filter((function(t){var e;return"1"===(null==t||null===(e=t.split("|"))||void 0===e?void 0:e[1])})))||void 0===r?void 0:r.map((function(t){var e;return null==t||null===(e=t.split("|"))||void 0===e?void 0:e[0]})),v=null==p||null===(n=p.filter((function(t){var e;return"0"===(null==t||null===(e=t.split("|"))||void 0===e?void 0:e[1])})))||void 0===n?void 0:n.map((function(t){var e;return null==t||null===(e=t.split("|"))||void 0===e?void 0:e[0]})),y={};if(!1===c.isEmployee||null!=c&&c.isEmployee&&null!=c&&c.isActive){var h;y.email=null==a?void 0:a.primaryEmailId,y.uuid=null==a?void 0:a.uuid,c.isEmployee&&(y.employeeInfo=null==c?void 0:c.employeeInfo,y.isProvAdmin=null==c?void 0:c.isProvAdmin,y.corporateRole=null==c?void 0:c.corporateRole,y.showMsmeWelcomePopup=s,y.showSubscriptionPopup=f),y.firstName=u&&u.name&&u.name.firstName?u.name.firstName:"",y.lastName=u&&u.name&&u.name.lastName?u.name.lastName:"";var m=(o=a.contactDetails,(i=a.loginInfoList)&&function(t){return!!t&&t.filter((function(t){return t&&"MOBILE"===t.loginType})).length>0}(i)?V(i.filter((function(t){return t&&"MOBILE"===(null==t?void 0:t.loginType)})).map((function(t){var e=t.countryCode,r=t.loginId;return r.startsWith(e)&&(r=r.substring(e.toString().length)),{countryCode:e,mobileNumber:r,verified:!0}})),1)[0]||{}:o&&V(o.filter((function(t){return t&&"MOBILE"===t.type})).map((function(t){var e=JSON.parse(t.additionalDetails).CountryCode,r=t.info;return r.startsWith(e)&&(r=r.substring(e.toString().length)),{countryCode:e,mobileNumber:r,verified:!1}})),1)[0]||{});return y.mobileNumber=null!=m&&m.mobileNumber?m.mobileNumber:"",y.countryCode=m.countryCode?m.countryCode.toString():"",y.verified=!!m.verified,y.profileType=a.profileType,y.actualProfileType=a.actualProfileType,y.blockLobs=d,y.hiddenLobs=v,y.corporateData=null==a?void 0:a.corporateData,y.affiliateId=null==a?void 0:a.affiliateId,y.nationality=null==a||null===(h=a.personalDetails)||void 0===h?void 0:h.nationality,y.personalDetails=null==a?void 0:a.personalDetails,y.miscFields=null==a?void 0:a.miscFields,y}return null==c||!c.isEmployee||null!=c&&c.isActive||(y.error=null==c?void 0:c.message),y},At=function(t,e){var r,n,o=It(t,e);return o?(function(t){return t!==q&&"AGENT"!==t&&"PERSONAL"!==t}(n=(r=o.extendedUser).profileType)&&(r.actualProfileType=n,r.profileType=n),{userInfo:Tt(o)}):{userInfo:null}},Ct={currency:"INR",isGlobalFlagEnabled:!1,language:"eng",region:"IN",userCountry:"IN",country:"IN",userCurrency:"INR",entityName:"india"},Pt=["headers","body"];function jt(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function Nt(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?jt(Object(r),!0).forEach((function(e){d(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):jt(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}var Dt=function(){var t=P()||bt()||window.vendor&&"false"!==window.vendor?Ct:{region:R("ccde",void 0,s.ES),userCurrency:R("userCurrency",void 0,s.ES),userCountry:R("cc",void 0,s.ES),isWorldwide:R("isWW",void 0,s.ES),language:R("lang",void 0,s.ES)},e=t.region,r=t.language,n=t.userCurrency,o=w(),i=xt(),a=R("ccde",void 0,s.ES),u={"Content-Type":"application/json",vid:o,tid:o,"usr-mcid":o,deviceid:o,Authorization:"h4nhc9jcgpAGIjp",Accept:"application/json","visitor-id":o,region:i?a:e,language:r,currency:yt[e],"user-currency":n},c=R(b("mmt-auth"),void 0,s.ES),l=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments.length>1?arguments[1]:void 0;if(function(t){var e,r=f?R("GL",void 0,s.ES):(null==t||null===(e=t.userGeoConfig)||void 0===e?void 0:e.isGlobalEnabled)||rt(t,"GL",void 0,s.ES);return"true"===r||!0===r}(e)){var r,n,o=parseInt(null==t?void 0:t.isWorldwide,10),i=null!==(r=null==t?void 0:t.userCountry)&&void 0!==r?r:null==t?void 0:t.ccde;return{"user-country":o?i:(null==t?void 0:t.region)||(null==t?void 0:t.ccde)||"IN",region:(null===(n=(null==t?void 0:t.region)||(null==t?void 0:t.ccde))||void 0===n?void 0:n.toLowerCase())||"IN","entity-name":null!=t&&t.ccde&&"IN"!==(null==t?void 0:t.ccde)||null!=t&&t.region&&"IN"!==(null==t?void 0:t.region)?"global":"india"}}return xt(e)?{"entity-name":"india"}:{}}(t);return function(t,e){Object.keys(e).forEach((function(r){t[r]=e[r]}))}(u,l),c&&(u=Nt(Nt({},u),{},{"mmt-auth":c})),u};const Lt=function(t){var e,r,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=n.headers,i=void 0===o?{}:o,a=n.body,u=function(t,e){if(null==t)return{};var r,n,o=function(t,e){if(null==t)return{};var r={};for(var n in t)if({}.hasOwnProperty.call(t,n)){if(e.includes(n))continue;r[n]=t[n]}return r}(t,e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(t);for(n=0;n<i.length;n++)r=i[n],e.includes(r)||{}.propertyIsEnumerable.call(t,r)&&(o[r]=t[r])}return o}(n,Pt),c=arguments.length>2?arguments[2]:void 0,l=arguments.length>3?arguments[3]:void 0,s=(arguments.length>4?arguments[4]:void 0)?t:function(t){var e="region=".concat(dt(),"&language=").concat(ft(),"&currency=").concat(pt());return-1!==t.indexOf("?")?"".concat(t,"&").concat(e):"".concat(t,"?").concat(e)}(t);s=function(t){return null!=(r=f?window.location.hostname:null==e?void 0:e.hostname)&&r.includes("global")?t.replace(".com",".global"):t;var e,r}(s);var p=Nt({headers:Nt(c?{}:Nt({},Dt()),i),body:l?a:JSON.stringify(a)},u);return null!==(e=p)&&void 0!==e&&null!==(e=e.headers)&&void 0!==e&&e[tt]&&(null===(r=p)||void 0===r||null===(r=r.headers)||void 0===r?void 0:r[tt])!==h||delete p.headers[tt],function(t){return t.includes(Q)||t.includes(Z)}(t)&&(p=Nt(Nt({},p),{},{credentials:"include"})),fetch(s,p).then((function(t){var e=null==t?void 0:t.json();return(null==t?void 0:t.status)>=200&&(null==t?void 0:t.status)<300?e:null==e?void 0:e.then((function(e){throw{body:e,status:t.status}}))}))};var kt=function(){return function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2?arguments[2]:void 0;try{var n;if(!f||!sessionStorage)return null;if(!t)throw M("get");var o,a=(e||{}).isPiiData,u=(e||{}).shouldParseJson,l=T(D,t,r,a);if(o=l.essential,a=l.piiData,!o&&!j())return null;var s=sessionStorage.getItem(t);if(a&&null!==(n=s)&&void 0!==n&&n.includes(c)){var p=new RegExp("^".concat(c));s=k(s=s.replace(p,""),i)}return u&&(s=E(s)),s}catch(t){return!1}}(K.AUTHS,{isPiiData:!0,shouldParseJson:!0},s.ES)},Ft=function(t){t&&G(K.USER_INFO,t,{isPiiData:!0,shouldStringifyJson:!0},s.ES)},Rt=function(t){(null==t?void 0:t.length)>0&&G(K.AUTHS,t,{isPiiData:!0,shouldStringifyJson:!0},s.ES)},Ut=function(){var t=g(),e={};t&&t!==h&&(e.profileType="4"),t&&t!==h&&(e[tt]=t);var r=function(t){var e=St({},t);return e["Content-Type"]="application/json",e.os="desktop",e.vid=(null==e?void 0:e.dvid)||w(),e.tid=(null==e?void 0:e.dvid)||w(),e.deviceId=(null==e?void 0:e.dvid)||w(),e.Authorization=(Ot[function(){var t="www.makemytrip.com";f&&(t=window.location.hostname);var e=(t=(t=t.replace("www.","").replace(":8000")).replace("ae.","")).split(".");return e.splice(e.length-2,e.length).join(".")}()]||"").authorization||"h4nhc9jcgpAGIjp",e.Accept="application/json",e["visitor-id"]=w(),e.region=dt(),e.currency=pt(),e.language=R("lang",void 0,s.ES)||ft(),R(b("mmt-auth"),void 0,s.ES)||e["mmt-auth"]?e["mmt-auth"]=R(b("mmt-auth"),void 0,s.ES)||e["mmt-auth"]:(e["mmt-auth"]=null,delete e["mmt-auth"]),R("user-identifier",void 0,s.ES)?e["user-identifier"]=R("user-identifier",void 0,s.ES):e["user-identifier"]=JSON.stringify({ipAddress:"ipAddress",imie:"imie",appVersion:"appVersion",os:function(){if(f)return window.isDesktop}()?"DESKTOP":"PWA",osVersion:"osVersion",timeZone:"timeZone",type:"mmt-auth",profileType:(null==e?void 0:e.profileType)||"",Authorization:e.Authorization,deviceId:(null==e?void 0:e.dvid)||w(),cookie:e["mmt-auth"],value:e["mmt-auth"]}),null!=e&&e.profileType&&delete e.profileType,e}(e);return Lt("//mapi.makemytrip.com/".concat("ext/web/pwa/login","?region=").concat(dt(),"&currency=").concat(pt(),"&language=").concat(ft()),{method:"POST",body:_t,headers:r})};function Mt(){return Gt.apply(this,arguments)}function Gt(){var e;return e=o().mark((function t(){var e,r,n,i,a,u,c,l,f,p=arguments;return o().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(e=p.length>0&&void 0!==p[0]&&p[0],r=!(p.length>1&&void 0!==p[1])||p[1],n=R(b("mmt-auth"),void 0,s.ES),i=kt(),n){t.next=10;break}throw z(K.USER_INFO),z(K.AUTHS),B(K.USER_INFO),B(K.AUTHS),Error("Application not Logged In");case 10:if(i&&n&&(a=It(i,n)),!(i&&n&&a)||e){t.next=16;break}if(!r){t.next=15;break}return u=At(i,n),t.abrupt("return",null==u?void 0:u.userInfo);case 15:return t.abrupt("return",i);case 16:return t.prev=16,t.next=19,Ut();case 19:if(c=t.sent,l=Et(c),Rt(l),f=At(l,n),Ft(null==f?void 0:f.userInfo),!r){t.next=26;break}return t.abrupt("return",null==f?void 0:f.userInfo);case 26:return t.abrupt("return",l);case 29:throw t.prev=29,t.t0=t.catch(16),Error(t.t0);case 32:case"end":return t.stop()}}),t,null,[[16,29]])})),Gt=function(){var r=this,n=arguments;return new Promise((function(o,i){var a=e.apply(r,n);function u(e){t(a,o,i,u,c,"next",e)}function c(e){t(a,o,i,u,c,"throw",e)}u(void 0)}))},Gt.apply(this,arguments)}})(),n})()));

/***/ }),

/***/ 8131:
/***/ (function(module) {

/*! For license information please see index.js.LICENSE.txt */
!function(t,e){ true?module.exports=e():0}(this,(()=>(()=>{var t={48:(t,e,r)=>{var n=r(319).default;function o(){"use strict";t.exports=o=function(){return r},t.exports.__esModule=!0,t.exports.default=t.exports;var e,r={},i=Object.prototype,a=i.hasOwnProperty,c=Object.defineProperty||function(t,e,r){t[e]=r.value},u="function"==typeof Symbol?Symbol:{},s=u.iterator||"@@iterator",l=u.asyncIterator||"@@asyncIterator",f=u.toStringTag||"@@toStringTag";function p(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{p({},"")}catch(e){p=function(t,e,r){return t[e]=r}}function h(t,e,r,n){var o=e&&e.prototype instanceof x?e:x,i=Object.create(o.prototype),a=new j(n||[]);return c(i,"_invoke",{value:T(t,r,a)}),i}function d(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}r.wrap=h;var y="suspendedStart",m="suspendedYield",g="executing",v="completed",b={};function x(){}function w(){}function C(){}var F={};p(F,s,(function(){return this}));var E=Object.getPrototypeOf,S=E&&E(E(P([])));S&&S!==i&&a.call(S,s)&&(F=S);var O=C.prototype=x.prototype=Object.create(F);function _(t){["next","throw","return"].forEach((function(e){p(t,e,(function(t){return this._invoke(e,t)}))}))}function L(t,e){function r(o,i,c,u){var s=d(t[o],t,i);if("throw"!==s.type){var l=s.arg,f=l.value;return f&&"object"==n(f)&&a.call(f,"__await")?e.resolve(f.__await).then((function(t){r("next",t,c,u)}),(function(t){r("throw",t,c,u)})):e.resolve(f).then((function(t){l.value=t,c(l)}),(function(t){return r("throw",t,c,u)}))}u(s.arg)}var o;c(this,"_invoke",{value:function(t,n){function i(){return new e((function(e,o){r(t,n,e,o)}))}return o=o?o.then(i,i):i()}})}function T(t,r,n){var o=y;return function(i,a){if(o===g)throw Error("Generator is already running");if(o===v){if("throw"===i)throw a;return{value:e,done:!0}}for(n.method=i,n.arg=a;;){var c=n.delegate;if(c){var u=k(c,n);if(u){if(u===b)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===y)throw o=v,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=g;var s=d(t,r,n);if("normal"===s.type){if(o=n.done?v:m,s.arg===b)continue;return{value:s.arg,done:n.done}}"throw"===s.type&&(o=v,n.method="throw",n.arg=s.arg)}}}function k(t,r){var n=r.method,o=t.iterator[n];if(o===e)return r.delegate=null,"throw"===n&&t.iterator.return&&(r.method="return",r.arg=e,k(t,r),"throw"===r.method)||"return"!==n&&(r.method="throw",r.arg=new TypeError("The iterator does not provide a '"+n+"' method")),b;var i=d(o,t.iterator,r.arg);if("throw"===i.type)return r.method="throw",r.arg=i.arg,r.delegate=null,b;var a=i.arg;return a?a.done?(r[t.resultName]=a.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,b):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,b)}function I(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function R(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function j(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(I,this),this.reset(!0)}function P(t){if(t||""===t){var r=t[s];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,i=function r(){for(;++o<t.length;)if(a.call(t,o))return r.value=t[o],r.done=!1,r;return r.value=e,r.done=!0,r};return i.next=i}}throw new TypeError(n(t)+" is not iterable")}return w.prototype=C,c(O,"constructor",{value:C,configurable:!0}),c(C,"constructor",{value:w,configurable:!0}),w.displayName=p(C,f,"GeneratorFunction"),r.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===w||"GeneratorFunction"===(e.displayName||e.name))},r.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,C):(t.__proto__=C,p(t,f,"GeneratorFunction")),t.prototype=Object.create(O),t},r.awrap=function(t){return{__await:t}},_(L.prototype),p(L.prototype,l,(function(){return this})),r.AsyncIterator=L,r.async=function(t,e,n,o,i){void 0===i&&(i=Promise);var a=new L(h(t,e,n,o),i);return r.isGeneratorFunction(e)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},_(O),p(O,f,"Generator"),p(O,s,(function(){return this})),p(O,"toString",(function(){return"[object Generator]"})),r.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},r.values=P,j.prototype={constructor:j,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(R),!t)for(var r in this)"t"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function n(n,o){return c.type="throw",c.arg=t,r.next=n,o&&(r.method="next",r.arg=e),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],c=i.completion;if("root"===i.tryLoc)return n("end");if(i.tryLoc<=this.prev){var u=a.call(i,"catchLoc"),s=a.call(i,"finallyLoc");if(u&&s){if(this.prev<i.catchLoc)return n(i.catchLoc,!0);if(this.prev<i.finallyLoc)return n(i.finallyLoc)}else if(u){if(this.prev<i.catchLoc)return n(i.catchLoc,!0)}else{if(!s)throw Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return n(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=t,i.arg=e,o?(this.method="next",this.next=o.finallyLoc,b):this.complete(i)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),b},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),R(r),b}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;R(r)}return o}}throw Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:P(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),b}},r}t.exports=o,t.exports.__esModule=!0,t.exports.default=t.exports},319:t=>{function e(r){return t.exports=e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,e(r)}t.exports=e,t.exports.__esModule=!0,t.exports.default=t.exports},799:(t,e,r)=>{var n=r(48)();t.exports=n;try{regeneratorRuntime=n}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}}},e={};function r(n){var o=e[n];if(void 0!==o)return o.exports;var i=e[n]={exports:{}};return t[n](i,i.exports,r),i.exports}r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),r.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var n={};return(()=>{"use strict";r.r(n),r.d(n,{CL_LIST:()=>F,addKeyConfigMapping:()=>y,getCookie:()=>S,getUserConsentInGdprClient:()=>C,isB2bUserOnClient:()=>x,isFullConsentInGdprClient:()=>w,isGdprRegionOnClient:()=>b,itemType:()=>u,removeCookie:()=>_,setCookie:()=>O});const t="undefined"!=typeof window;r(799);function e(t){return e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e(t)}var o="awefewfuihewfhewfuhiebc",i="limitedConsent",a="enct-",c="GDPR_C",u={ES:"essential",N_ES:"nonEssential"};function s(t,r,n){return(r=function(t){var r=function(t,r){if("object"!=e(t)||!t)return t;var n=t[Symbol.toPrimitive];if(void 0!==n){var o=n.call(t,"string");if("object"!=e(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(t)}(t);return"symbol"==e(r)?r:r+""}(r))in t?Object.defineProperty(t,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[r]=n,t}var l="GI",f="IGO",p="AFFCGOBIZMMTAIX",h=(s(s(s({},l,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),f,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),p,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),s(s({},l,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),f,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(e){var r,n=e||"";t&&(n=(null===(r=window)||void 0===r||null===(r=r.location)||void 0===r?void 0:r.hostname)||"");var o="";return n&&(-1!==n.indexOf("giholidays")?o=l:-1!==n.indexOf("6eholidays")?o=f:-1!==n.indexOf("hdfcsmartbuyholidays")||-1!==n.indexOf("hdfcsmartbuyrailways")?o="HDFC_SB":-1!==n.indexOf("airindiaexpressholidays")?o=p:-1!==n.indexOf("flightsexpert.goibibo")?o="AFFCGOBIZGIFLTEXP":-1!==n.indexOf("flightsexpert.makemytrip")||-1!==n.indexOf("holidaysexpert.makemytrip")?o="AFFCGOBIZMMTFLTEXP":-1!==n.indexOf("forexexpert.makemytrip")?o="AFFTMFXMMTFOREXEXP":-1!==n.indexOf("forexexpert.goibibo")&&(o="AFFTMFXGIFOREXEXP")),o}),d={},y=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};d[t]=e},m=function(e,r,n,o){var i,a,c=n,s=o,l=(null==d?void 0:d[e])||{};return t&&(c=void 0===n?(null===(i=l[r])||void 0===i?void 0:i.type)||u.N_ES:n,s=void 0===o?(null===(a=l[r])||void 0===a?void 0:a.isPiiData)||!1:o),{essential:c=c===u.ES,piiData:s}},g=function(t){return new RegExp("(?:^|;\\s*)".concat(t,"\\s*=\\s*([^;]*)"))},v=function(t){var e,r,n=(e=t,(r=h(undefined).toLowerCase())?"".concat(e,"-").concat(r):e),o=g(n).exec(document.cookie);return null!==o?decodeURIComponent(o[1]):null},b=function(){return"1"===v("isGdprRegion")},x=function(){var t=v("myBusinessSubscription"),e=v("mmt-auth"),r=null==e?void 0:e.charAt(e.length-1);return!(!t||"b2b"!==t)||"C"===r},w=function(){return!b()||!!x()||(!(t=v(c))||"IS"!==t&&"11"!==t?"fullConsent":i)!==i;var t},C=function(){return v(c)},F="cookieList",E=function(t){return new TypeError("Valid key & value is required for @MMT-UI/storages$$/client/cookies ".concat(t))},S=function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0;try{var i;if(!t)return null;if(!e)throw E("get");var c,u=(r||{}).isPiiData,s=(r||{}).shouldParseJson,l=m(F,e,n,u);if(c=l.essential,u=l.piiData,!c&&!w())return null;var f=g(e).exec(document.cookie),p=null!==f?decodeURIComponent(f[1]):null;if(u&&null!==(i=p)&&void 0!==i&&i.includes(a)){var h=new RegExp("^".concat(a));p=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during the decryption process:",t),null}}(p=p.replace(h,""),o)}return s&&(p=function(t){try{return JSON.parse(t)}catch(t){return null}}(p)),p}catch(t){return null}},O=function(r,n,i,c){try{if(!t)return!1;if(!r||void 0===n)throw E("set");var u,s=i||{},l=s.expiresVal,f=s.maxAge,p=s.path,h=s.domain,d=s.secure,y=s.sameSite,g=s.shouldStringifyJson,v=s.partitioned,b=(i||{}).isPiiData,x=m(F,r,c,b);if(u=x.essential,b=x.piiData,!u&&!w())return!1;var C=g?function(t){try{return JSON.stringify(t)}catch(t){return null}}(n):n;if(C&&b){var S=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during encryption:",t),null}}(C,o);if(!S)return!1;C="".concat(a).concat(S)}var O=function(t,r){var n=t?"; max-age=".concat(t):"",o="";if(r)switch(e(r)){case"string":o="; expires=".concat(new Date(r).toUTCString());break;case"number":var i=new Date;i.setSeconds(r),o="; expires=".concat(i.toUTCString());break;case"object":r instanceof Date&&(o="; expires=".concat(r.toUTCString()))}return{sMaxAge:n,sExpiry:o}}(f,l),_=O.sMaxAge,L=O.sExpiry,T=v?"; samesite=none; secure; partitioned":"";T||(T=d?y?"; samesite=".concat(y,"; secure"):"; secure":y?"; samesite=".concat(y):"");var k="".concat(encodeURIComponent(r),"=").concat(encodeURIComponent(C)),I="".concat(_).concat(L).concat(p?"; path=".concat(p):""),R="".concat(h?"; domain=".concat(h):"").concat(T);return document.cookie="".concat(k).concat(I).concat(R),!0}catch(t){return!1}},_=function(e,r){try{if(!t)return!1;if(!e)throw E("remove");var n=r||{},o=n.path,i=n.domain,a=n.secure,c=n.sameSite,u=n.partitioned?"; samesite=none; secure; partitioned":"";u||(u=a?c?"; samesite=".concat(c,"; secure"):"; secure":c?"; samesite=".concat(c):"");var s="".concat(encodeURIComponent(e),"=; max-age=0").concat(o?"; path=".concat(o):""),l="".concat(i?"; domain=".concat(i):"").concat(u);return document.cookie="".concat(s).concat(l),!0}catch(t){return!1}}})(),n})()));

/***/ }),

/***/ 156:
/***/ (function(module) {

/*! For license information please see index.js.LICENSE.txt */
!function(t,e){ true?module.exports=e():0}(this,(()=>(()=>{var t={48:(t,e,r)=>{var n=r(319).default;function o(){"use strict";t.exports=o=function(){return r},t.exports.__esModule=!0,t.exports.default=t.exports;var e,r={},i=Object.prototype,a=i.hasOwnProperty,l=Object.defineProperty||function(t,e,r){t[e]=r.value},c="function"==typeof Symbol?Symbol:{},u=c.iterator||"@@iterator",s=c.asyncIterator||"@@asyncIterator",f=c.toStringTag||"@@toStringTag";function p(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{p({},"")}catch(e){p=function(t,e,r){return t[e]=r}}function h(t,e,r,n){var o=e&&e.prototype instanceof w?e:w,i=Object.create(o.prototype),a=new k(n||[]);return l(i,"_invoke",{value:I(t,r,a)}),i}function y(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}r.wrap=h;var d="suspendedStart",m="suspendedYield",g="executing",v="completed",b={};function w(){}function x(){}function S(){}var E={};p(E,u,(function(){return this}));var F=Object.getPrototypeOf,O=F&&F(F(P([])));O&&O!==i&&a.call(O,u)&&(E=O);var _=S.prototype=w.prototype=Object.create(E);function L(t){["next","throw","return"].forEach((function(e){p(t,e,(function(t){return this._invoke(e,t)}))}))}function C(t,e){function r(o,i,l,c){var u=y(t[o],t,i);if("throw"!==u.type){var s=u.arg,f=s.value;return f&&"object"==n(f)&&a.call(f,"__await")?e.resolve(f.__await).then((function(t){r("next",t,l,c)}),(function(t){r("throw",t,l,c)})):e.resolve(f).then((function(t){s.value=t,l(s)}),(function(t){return r("throw",t,l,c)}))}c(u.arg)}var o;l(this,"_invoke",{value:function(t,n){function i(){return new e((function(e,o){r(t,n,e,o)}))}return o=o?o.then(i,i):i()}})}function I(t,r,n){var o=d;return function(i,a){if(o===g)throw Error("Generator is already running");if(o===v){if("throw"===i)throw a;return{value:e,done:!0}}for(n.method=i,n.arg=a;;){var l=n.delegate;if(l){var c=T(l,n);if(c){if(c===b)continue;return c}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===d)throw o=v,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=g;var u=y(t,r,n);if("normal"===u.type){if(o=n.done?v:m,u.arg===b)continue;return{value:u.arg,done:n.done}}"throw"===u.type&&(o=v,n.method="throw",n.arg=u.arg)}}}function T(t,r){var n=r.method,o=t.iterator[n];if(o===e)return r.delegate=null,"throw"===n&&t.iterator.return&&(r.method="return",r.arg=e,T(t,r),"throw"===r.method)||"return"!==n&&(r.method="throw",r.arg=new TypeError("The iterator does not provide a '"+n+"' method")),b;var i=y(o,t.iterator,r.arg);if("throw"===i.type)return r.method="throw",r.arg=i.arg,r.delegate=null,b;var a=i.arg;return a?a.done?(r[t.resultName]=a.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,b):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,b)}function j(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function k(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(j,this),this.reset(!0)}function P(t){if(t||""===t){var r=t[u];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,i=function r(){for(;++o<t.length;)if(a.call(t,o))return r.value=t[o],r.done=!1,r;return r.value=e,r.done=!0,r};return i.next=i}}throw new TypeError(n(t)+" is not iterable")}return x.prototype=S,l(_,"constructor",{value:S,configurable:!0}),l(S,"constructor",{value:x,configurable:!0}),x.displayName=p(S,f,"GeneratorFunction"),r.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===x||"GeneratorFunction"===(e.displayName||e.name))},r.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,S):(t.__proto__=S,p(t,f,"GeneratorFunction")),t.prototype=Object.create(_),t},r.awrap=function(t){return{__await:t}},L(C.prototype),p(C.prototype,s,(function(){return this})),r.AsyncIterator=C,r.async=function(t,e,n,o,i){void 0===i&&(i=Promise);var a=new C(h(t,e,n,o),i);return r.isGeneratorFunction(e)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},L(_),p(_,f,"Generator"),p(_,u,(function(){return this})),p(_,"toString",(function(){return"[object Generator]"})),r.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},r.values=P,k.prototype={constructor:k,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(A),!t)for(var r in this)"t"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function n(n,o){return l.type="throw",l.arg=t,r.next=n,o&&(r.method="next",r.arg=e),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],l=i.completion;if("root"===i.tryLoc)return n("end");if(i.tryLoc<=this.prev){var c=a.call(i,"catchLoc"),u=a.call(i,"finallyLoc");if(c&&u){if(this.prev<i.catchLoc)return n(i.catchLoc,!0);if(this.prev<i.finallyLoc)return n(i.finallyLoc)}else if(c){if(this.prev<i.catchLoc)return n(i.catchLoc,!0)}else{if(!u)throw Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return n(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=t,i.arg=e,o?(this.method="next",this.next=o.finallyLoc,b):this.complete(i)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),b},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),b}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;A(r)}return o}}throw Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:P(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),b}},r}t.exports=o,t.exports.__esModule=!0,t.exports.default=t.exports},319:t=>{function e(r){return t.exports=e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,e(r)}t.exports=e,t.exports.__esModule=!0,t.exports.default=t.exports},799:(t,e,r)=>{var n=r(48)();t.exports=n;try{regeneratorRuntime=n}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}}},e={};function r(n){var o=e[n];if(void 0!==o)return o.exports;var i=e[n]={exports:{}};return t[n](i,i.exports,r),i.exports}r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),r.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var n={};return(()=>{"use strict";function t(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=Array(e);r<e;r++)n[r]=t[r];return n}r.r(n),r.d(n,{LS_LIST:()=>E,addKeyConfigMapping:()=>g,getItem:()=>T,handleLocalStorageInGdpr:()=>j,itemType:()=>u,removeItem:()=>I,setItem:()=>C});const e="undefined"!=typeof window;var o="awefewfuihewfhewfuhiebc",i="limitedConsent",a="enct-",l="GDPR_C",c="clearLocalStorage",u={ES:"essential",N_ES:"nonEssential"};function s(t){return s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},s(t)}function f(t,e,r){return(e=function(t){var e=function(t,e){if("object"!=s(t)||!t)return t;var r=t[Symbol.toPrimitive];if(void 0!==r){var n=r.call(t,"string");if("object"!=s(n))return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(t)}(t);return"symbol"==s(e)?e:e+""}(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}var p="GI",h="IGO",y="AFFCGOBIZMMTAIX",d=(f(f(f({},p,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),h,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),y,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),f(f({},p,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),h,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(t){var r,n=t||"";e&&(n=(null===(r=window)||void 0===r||null===(r=r.location)||void 0===r?void 0:r.hostname)||"");var o="";return n&&(-1!==n.indexOf("giholidays")?o=p:-1!==n.indexOf("6eholidays")?o=h:-1!==n.indexOf("hdfcsmartbuyholidays")||-1!==n.indexOf("hdfcsmartbuyrailways")?o="HDFC_SB":-1!==n.indexOf("airindiaexpressholidays")?o=y:-1!==n.indexOf("flightsexpert.goibibo")?o="AFFCGOBIZGIFLTEXP":-1!==n.indexOf("flightsexpert.makemytrip")||-1!==n.indexOf("holidaysexpert.makemytrip")?o="AFFCGOBIZMMTFLTEXP":-1!==n.indexOf("forexexpert.makemytrip")?o="AFFTMFXMMTFOREXEXP":-1!==n.indexOf("forexexpert.goibibo")&&(o="AFFTMFXGIFOREXEXP")),o}),m={},g=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};m[t]=e},v=function(t,r,n,o){var i,a,l=n,c=o,s=(null==m?void 0:m[t])||{};return e&&(l=void 0===n?(null===(i=s[r])||void 0===i?void 0:i.type)||u.N_ES:n,c=void 0===o?(null===(a=s[r])||void 0===a?void 0:a.isPiiData)||!1:o),{essential:l=l===u.ES,piiData:c}},b=function(t){var e,r,n=function(t){return new RegExp("(?:^|;\\s*)".concat(t,"\\s*=\\s*([^;]*)"))}((e=t,(r=d(undefined).toLowerCase())?"".concat(e,"-").concat(r):e)),o=n.exec(document.cookie);return null!==o?decodeURIComponent(o[1]):null},w=function(){return"1"===b("isGdprRegion")},x=function(){var t=b("myBusinessSubscription"),e=b("mmt-auth"),r=null==e?void 0:e.charAt(e.length-1);return!(!t||"b2b"!==t)||"C"===r},S=function(){return!w()||!!x()||(!(t=b(l))||"IS"!==t&&"11"!==t?"fullConsent":i)!==i;var t},E="localStorageList",F="$localStorageExp$",O=(r(799),function(t){return e&&d()?".".concat(window.location.hostname):".".concat(_(t))}),_=function(t){var r=t||"www.makemytrip.com";e&&(r=window.location.hostname);var n=(r=(r=r.replace("www.","").replace(":8000")).replace("ae.","")).split(".");return n.splice(n.length-2,n.length).join(".")},L=function(t){return new TypeError("Valid key & value is required for localstorage ".concat(t))},C=function(t,r,n,i){try{if(!e||!localStorage)return!1;if(!t||void 0===r)throw L("get");var l,c=(n||{}).isPiiData,u=(n||{}).shouldStringifyJson,s=v(E,t,i,c);if(l=s.essential,c=s.piiData,!l&&!S())return!1;var f=u?function(t){try{return JSON.stringify(t)}catch(t){return null}}(r):r;if(f&&c){var p=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during encryption:",t),null}}(f,o);if(!p)return!1;f="".concat(a).concat(p)}var h=(n||{}).expiry;if(h){var y="".concat(f).concat(F).concat(h);localStorage.setItem(t,y)}else localStorage.setItem(t,f);return!0}catch(t){return!1}},I=function(t){try{if(!e||!localStorage)return!1;if(!t)throw L("get");return localStorage.removeItem(t),!0}catch(t){return!1}},T=function(r){var n,i,l=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},c=arguments.length>2?arguments[2]:void 0;try{var u,s;if(!e||!localStorage)return null;if(!r)throw L("get");var f,p=(l||{}).isPiiData,h=(l||{}).shouldParseJson,y=v(E,r,c,p);if(f=y.essential,p=y.piiData,!f&&!S())return null;var d=localStorage.getItem(r),m=null;if(null!==(u=d)&&void 0!==u&&u.includes(F)){var g=(n=d.split(F),i=2,function(t){if(Array.isArray(t))return t}(n)||function(t,e){var r=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null!=r){var n,o,i,a,l=[],c=!0,u=!1;try{if(i=(r=r.call(t)).next,0===e){if(Object(r)!==r)return;c=!1}else for(;!(c=(n=i.call(r)).done)&&(l.push(n.value),l.length!==e);c=!0);}catch(t){u=!0,o=t}finally{try{if(!c&&null!=r.return&&(a=r.return(),Object(a)!==a))return}finally{if(u)throw o}}return l}}(n,i)||function(e,r){if(e){if("string"==typeof e)return t(e,r);var n={}.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?t(e,r):void 0}}(n,i)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}());d=g[0],m=g[1]}var b=d;if(void 0===b)return null;if(p&&null!==(s=b)&&void 0!==s&&s.includes(a)){var w=new RegExp("^".concat(a));b=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during the decryption process:",t),null}}(b=b.replace(w,""),o)}if(h&&(b=function(t){try{return JSON.parse(t)}catch(t){return null}}(b)),!m)return b;var x=new Date;return new Date(m)<x?(I(r),null):b}catch(i){return null}},j=function(){var t,e,r=null===(t=window)||void 0===t||null===(t=t.app_bridge)||void 0===t||null===(e=t.getUserConsent)||void 0===e?void 0:e.call(t);r&&!b(l)&&(document.cookie="".concat(l,"=").concat(r,"; domain=").concat(O(),"; path=/; secure")),w()&&!r&&b(c)&&(x()||(localStorage.clear(),document.cookie="".concat(c,"=; max-age=0; path=/; domain=.makemytrip.com; secure")))}})(),n})()));

/***/ }),

/***/ 8456:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(()=>(()=>{"use strict";var e={d:(t,r)=>{for(var o in r)e.o(r,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:r[o]})},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},t={};e.r(t),e.d(t,{SS_LIST:()=>b,addKeyConfigMapping:()=>m,getItemBySession:()=>C,itemType:()=>a,removeItemBySession:()=>F,setItemBySession:()=>S});const r="undefined"!=typeof window;var o="awefewfuihewfhewfuhiebc",i="limitedConsent",n="enct-",a={ES:"essential",N_ES:"nonEssential"};function s(e){return s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s(e)}function l(e,t,r){return(t=function(e){var t=function(e,t){if("object"!=s(e)||!e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!=s(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return"symbol"==s(t)?t:t+""}(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}var u="GI",c="IGO",f="AFFCGOBIZMMTAIX",d=(l(l(l({},u,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),c,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),f,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),l(l({},u,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),c,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(e){var t,o=e||"";r&&(o=(null===(t=window)||void 0===t||null===(t=t.location)||void 0===t?void 0:t.hostname)||"");var i="";return o&&(-1!==o.indexOf("giholidays")?i=u:-1!==o.indexOf("6eholidays")?i=c:-1!==o.indexOf("hdfcsmartbuyholidays")||-1!==o.indexOf("hdfcsmartbuyrailways")?i="HDFC_SB":-1!==o.indexOf("airindiaexpressholidays")?i=f:-1!==o.indexOf("flightsexpert.goibibo")?i="AFFCGOBIZGIFLTEXP":-1!==o.indexOf("flightsexpert.makemytrip")||-1!==o.indexOf("holidaysexpert.makemytrip")?i="AFFCGOBIZMMTFLTEXP":-1!==o.indexOf("forexexpert.makemytrip")?i="AFFTMFXMMTFOREXEXP":-1!==o.indexOf("forexexpert.goibibo")&&(i="AFFTMFXGIFOREXEXP")),i}),y={},m=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};y[e]=t},p=function(e,t,o,i){var n,s,l=o,u=i,c=(null==y?void 0:y[e])||{};return r&&(l=void 0===o?(null===(n=c[t])||void 0===n?void 0:n.type)||a.N_ES:o,u=void 0===i?(null===(s=c[t])||void 0===s?void 0:s.isPiiData)||!1:i),{essential:l=l===a.ES,piiData:u}},g=function(e){var t,r,o=function(e){return new RegExp("(?:^|;\\s*)".concat(e,"\\s*=\\s*([^;]*)"))}((t=e,(r=d(undefined).toLowerCase())?"".concat(t,"-").concat(r):t)),i=o.exec(document.cookie);return null!==i?decodeURIComponent(i[1]):null},h=function(){var e,t,r,o;return"1"!==g("isGdprRegion")||(e=g("myBusinessSubscription"),r=null==(t=g("mmt-auth"))?void 0:t.charAt(t.length-1),!!(e&&"b2b"===e||"C"===r)||(!(o=g("GDPR_C"))||"IS"!==o&&"11"!==o?"fullConsent":i)!==i)},b="sessionList",v=function(e){return new TypeError("Valid key & value is required for sessionStorage ".concat(e))},S=function(e,t,i,a){try{if(!r||!sessionStorage)return!1;if(!e||void 0===t)throw v("get");var s,l=(i||{}).isPiiData,u=(i||{}).shouldStringifyJson,c=p(b,e,a,l);if(s=c.essential,l=c.piiData,!s&&!h())return!1;var f=u?function(e){try{return JSON.stringify(e)}catch(e){return null}}(t):t;if(f&&l){var d=function(e,t){try{var r="",o=0;if(!t)throw new Error("Key is empty");for(var i=0;i<e.length;i+=1){var n=e.charCodeAt(i)^t.charCodeAt(o);r+=String.fromCharCode(n),o=(o+1)%t.length}return r}catch(e){return console.error("An error occurred during encryption:",e),null}}(f,o);if(!d)return!1;f="".concat(n).concat(d)}return sessionStorage.setItem(e,f),!0}catch(e){return!1}},F=function(e){try{if(!r||!sessionStorage)return!1;if(!e)throw v("get");return sessionStorage.removeItem(e),!0}catch(e){return!1}},C=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2?arguments[2]:void 0;try{var a;if(!r||!sessionStorage)return null;if(!e)throw v("get");var s,l=(t||{}).isPiiData,u=(t||{}).shouldParseJson,c=p(b,e,i,l);if(s=c.essential,l=c.piiData,!s&&!h())return null;var f=sessionStorage.getItem(e);if(l&&null!==(a=f)&&void 0!==a&&a.includes(n)){var d=new RegExp("^".concat(n));f=function(e,t){try{var r="",o=0;if(!t)throw new Error("Key is empty");for(var i=0;i<e.length;i+=1){var n=e.charCodeAt(i)^t.charCodeAt(o);r+=String.fromCharCode(n),o=(o+1)%t.length}return r}catch(e){return console.error("An error occurred during the decryption process:",e),null}}(f=f.replace(d,""),o)}return u&&(f=function(e){try{return JSON.parse(e)}catch(e){return null}}(f)),f}catch(e){return!1}};return t})()));

/***/ }),

/***/ 8277:
/***/ (function(module) {

/*! For license information please see visitorDvid.js.LICENSE.txt */
!function(t,e){ true?module.exports=e():0}(this,(()=>(()=>{var t={48:(t,e,r)=>{var n=r(319).default;function o(){"use strict";t.exports=o=function(){return r},t.exports.__esModule=!0,t.exports.default=t.exports;var e,r={},i=Object.prototype,a=i.hasOwnProperty,c=Object.defineProperty||function(t,e,r){t[e]=r.value},u="function"==typeof Symbol?Symbol:{},s=u.iterator||"@@iterator",l=u.asyncIterator||"@@asyncIterator",f=u.toStringTag||"@@toStringTag";function p(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{p({},"")}catch(e){p=function(t,e,r){return t[e]=r}}function h(t,e,r,n){var o=e&&e.prototype instanceof b?e:b,i=Object.create(o.prototype),a=new j(n||[]);return c(i,"_invoke",{value:T(t,r,a)}),i}function d(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}r.wrap=h;var y="suspendedStart",m="suspendedYield",v="executing",g="completed",x={};function b(){}function w(){}function F(){}var E={};p(E,s,(function(){return this}));var O=Object.getPrototypeOf,_=O&&O(O(A([])));_&&_!==i&&a.call(_,s)&&(E=_);var C=F.prototype=b.prototype=Object.create(E);function S(t){["next","throw","return"].forEach((function(e){p(t,e,(function(t){return this._invoke(e,t)}))}))}function L(t,e){function r(o,i,c,u){var s=d(t[o],t,i);if("throw"!==s.type){var l=s.arg,f=l.value;return f&&"object"==n(f)&&a.call(f,"__await")?e.resolve(f.__await).then((function(t){r("next",t,c,u)}),(function(t){r("throw",t,c,u)})):e.resolve(f).then((function(t){l.value=t,c(l)}),(function(t){return r("throw",t,c,u)}))}u(s.arg)}var o;c(this,"_invoke",{value:function(t,n){function i(){return new e((function(e,o){r(t,n,e,o)}))}return o=o?o.then(i,i):i()}})}function T(t,r,n){var o=y;return function(i,a){if(o===v)throw Error("Generator is already running");if(o===g){if("throw"===i)throw a;return{value:e,done:!0}}for(n.method=i,n.arg=a;;){var c=n.delegate;if(c){var u=I(c,n);if(u){if(u===x)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===y)throw o=g,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=v;var s=d(t,r,n);if("normal"===s.type){if(o=n.done?g:m,s.arg===x)continue;return{value:s.arg,done:n.done}}"throw"===s.type&&(o=g,n.method="throw",n.arg=s.arg)}}}function I(t,r){var n=r.method,o=t.iterator[n];if(o===e)return r.delegate=null,"throw"===n&&t.iterator.return&&(r.method="return",r.arg=e,I(t,r),"throw"===r.method)||"return"!==n&&(r.method="throw",r.arg=new TypeError("The iterator does not provide a '"+n+"' method")),x;var i=d(o,t.iterator,r.arg);if("throw"===i.type)return r.method="throw",r.arg=i.arg,r.delegate=null,x;var a=i.arg;return a?a.done?(r[t.resultName]=a.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,x):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,x)}function k(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function R(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function j(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(k,this),this.reset(!0)}function A(t){if(t||""===t){var r=t[s];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,i=function r(){for(;++o<t.length;)if(a.call(t,o))return r.value=t[o],r.done=!1,r;return r.value=e,r.done=!0,r};return i.next=i}}throw new TypeError(n(t)+" is not iterable")}return w.prototype=F,c(C,"constructor",{value:F,configurable:!0}),c(F,"constructor",{value:w,configurable:!0}),w.displayName=p(F,f,"GeneratorFunction"),r.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===w||"GeneratorFunction"===(e.displayName||e.name))},r.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,F):(t.__proto__=F,p(t,f,"GeneratorFunction")),t.prototype=Object.create(C),t},r.awrap=function(t){return{__await:t}},S(L.prototype),p(L.prototype,l,(function(){return this})),r.AsyncIterator=L,r.async=function(t,e,n,o,i){void 0===i&&(i=Promise);var a=new L(h(t,e,n,o),i);return r.isGeneratorFunction(e)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},S(C),p(C,f,"Generator"),p(C,s,(function(){return this})),p(C,"toString",(function(){return"[object Generator]"})),r.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},r.values=A,j.prototype={constructor:j,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(R),!t)for(var r in this)"t"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function n(n,o){return c.type="throw",c.arg=t,r.next=n,o&&(r.method="next",r.arg=e),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],c=i.completion;if("root"===i.tryLoc)return n("end");if(i.tryLoc<=this.prev){var u=a.call(i,"catchLoc"),s=a.call(i,"finallyLoc");if(u&&s){if(this.prev<i.catchLoc)return n(i.catchLoc,!0);if(this.prev<i.finallyLoc)return n(i.finallyLoc)}else if(u){if(this.prev<i.catchLoc)return n(i.catchLoc,!0)}else{if(!s)throw Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return n(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=t,i.arg=e,o?(this.method="next",this.next=o.finallyLoc,x):this.complete(i)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),x},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),R(r),x}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;R(r)}return o}}throw Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:A(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),x}},r}t.exports=o,t.exports.__esModule=!0,t.exports.default=t.exports},319:t=>{function e(r){return t.exports=e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,e(r)}t.exports=e,t.exports.__esModule=!0,t.exports.default=t.exports},799:(t,e,r)=>{var n=r(48)();t.exports=n;try{regeneratorRuntime=n}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}}},e={};function r(n){var o=e[n];if(void 0!==o)return o.exports;var i=e[n]={exports:{}};return t[n](i,i.exports,r),i.exports}r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var n={};return(()=>{"use strict";r.d(n,{default:()=>C}),r(799);const t="undefined"!=typeof window;function e(t){return e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e(t)}var o="awefewfuihewfhewfuhiebc",i="limitedConsent",a="enct-",c="essential";function u(t,r,n){return(r=function(t){var r=function(t,r){if("object"!=e(t)||!t)return t;var n=t[Symbol.toPrimitive];if(void 0!==n){var o=n.call(t,"string");if("object"!=e(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(t)}(t);return"symbol"==e(r)?r:r+""}(r))in t?Object.defineProperty(t,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[r]=n,t}var s="GI",l="IGO",f="AFFCGOBIZMMTAIX",p=(u(u(u({},s,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),l,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),f,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),u(u({},s,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),l,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(e){var r,n=e||"";t&&(n=(null===(r=window)||void 0===r||null===(r=r.location)||void 0===r?void 0:r.hostname)||"");var o="";return n&&(-1!==n.indexOf("giholidays")?o=s:-1!==n.indexOf("6eholidays")?o=l:-1!==n.indexOf("hdfcsmartbuyholidays")||-1!==n.indexOf("hdfcsmartbuyrailways")?o="HDFC_SB":-1!==n.indexOf("airindiaexpressholidays")?o=f:-1!==n.indexOf("flightsexpert.goibibo")?o="AFFCGOBIZGIFLTEXP":-1!==n.indexOf("flightsexpert.makemytrip")||-1!==n.indexOf("holidaysexpert.makemytrip")?o="AFFCGOBIZMMTFLTEXP":-1!==n.indexOf("forexexpert.makemytrip")?o="AFFTMFXMMTFOREXEXP":-1!==n.indexOf("forexexpert.goibibo")&&(o="AFFTMFXGIFOREXEXP")),o}),h=function(t,e){var r=p(e).toLowerCase();return r?"".concat(t,"-").concat(r):t},d={},y=function(e,r,n,o){var i,a,u=n,s=o,l=(null==d?void 0:d[e])||{};return t&&(u=void 0===n?(null===(i=l[r])||void 0===i?void 0:i.type)||"nonEssential":n,s=void 0===o?(null===(a=l[r])||void 0===a?void 0:a.isPiiData)||!1:o),{essential:u=u===c,piiData:s}},m=function(t){return new RegExp("(?:^|;\\s*)".concat(t,"\\s*=\\s*([^;]*)"))},v=function(t){var e=h(t),r=m(e).exec(document.cookie);return null!==r?decodeURIComponent(r[1]):null},g=function(){var t,e,r,n;return"1"!==v("isGdprRegion")||(t=v("myBusinessSubscription"),r=null==(e=v("mmt-auth"))?void 0:e.charAt(e.length-1),!!(t&&"b2b"===t||"C"===r)||(!(n=v("GDPR_C"))||"IS"!==n&&"11"!==n?"fullConsent":i)!==i)},x="cookieList",b=function(t){return new TypeError("Valid key & value is required for @MMT-UI/storages$$/client/cookies ".concat(t))},w=function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0;try{var i;if(!t)return null;if(!e)throw b("get");var c,u=(r||{}).isPiiData,s=(r||{}).shouldParseJson,l=y(x,e,n,u);if(c=l.essential,u=l.piiData,!c&&!g())return null;var f=m(e).exec(document.cookie),p=null!==f?decodeURIComponent(f[1]):null;if(u&&null!==(i=p)&&void 0!==i&&i.includes(a)){var h=new RegExp("^".concat(a));p=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during the decryption process:",t),null}}(p=p.replace(h,""),o)}return s&&(p=function(t){try{return JSON.parse(t)}catch(t){return null}}(p)),p}catch(t){return null}},F=(new Date,function(e){return t&&p()?".".concat(window.location.hostname):".".concat(O(e))}),E=function(){var t=(new Date).getTime();return"undefined"!=typeof performance&&"function"==typeof performance.now&&(t+=performance.now()),"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var r=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"===e?r:3&r|8).toString(16)}))},O=function(e){var r=e||"www.makemytrip.com";t&&(r=window.location.hostname);var n=(r=(r=r.replace("www.","").replace(":8000")).replace("ae.","")).split(".");return n.splice(n.length-2,n.length).join(".")},_=function(){return false};const C={getVisitorId:function(){var r,n,i,u=w(h("dvid"),void 0,c)||E();return r=u,!w(h("dvid"),void 0,c)&&r&&function(r,n,i,c){try{if(!t)return!1;if(!r||void 0===n)throw b("set");var u,s=i||{},l=s.expiresVal,f=s.maxAge,p=s.path,h=s.domain,d=s.secure,m=s.sameSite,v=s.shouldStringifyJson,w=s.partitioned,F=(i||{}).isPiiData,E=y(x,r,c,F);if(u=E.essential,F=E.piiData,!u&&!g())return!1;var O=v?function(t){try{return JSON.stringify(t)}catch(t){return null}}(n):n;if(O&&F){var C=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during encryption:",t),null}}(O,o);if(!C)return!1;O="".concat(a).concat(C)}var S=function(t,r){var n=t?"; max-age=".concat(t):"",o="";if(r)switch(e(r)){case"string":o="; expires=".concat(new Date(r).toUTCString());break;case"number":var i=new Date;i.setSeconds(r),o="; expires=".concat(i.toUTCString());break;case"object":r instanceof Date&&(o="; expires=".concat(r.toUTCString()))}return{sMaxAge:n,sExpiry:o}}(f,l),L=S.sMaxAge,T=S.sExpiry,I=w||_()?"; samesite=none; secure; partitioned":"";I||(I=d?m?"; samesite=".concat(m,"; secure"):"; secure":m?"; samesite=".concat(m):"");var k="".concat(encodeURIComponent(r),"=").concat(encodeURIComponent(O)),R="".concat(L).concat(T).concat(p?"; path=".concat(p):""),j="".concat(h?"; domain=".concat(h):"").concat(I);return document.cookie="".concat(k).concat(R).concat(j),!0}catch(t){return!1}}(h("dvid"),r,{expiresVal:(n=new Date,i=n.getTime(),i+=305856e5,n.setTime(i),n),path:"/",domain:F()},c),u},generateUUIDForUser:E}})(),n.default})()));

/***/ }),

/***/ 9644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5644);

/***/ }),

/***/ 353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var settle = __webpack_require__(6955);
var cookies = __webpack_require__(2233);
var buildURL = __webpack_require__(8030);
var buildFullPath = __webpack_require__(7948);
var parseHeaders = __webpack_require__(1875);
var isURLSameOrigin = __webpack_require__(842);
var transitionalDefaults = __webpack_require__(8560);
var AxiosError = __webpack_require__(1218);
var CanceledError = __webpack_require__(8047);
var parseProtocol = __webpack_require__(738);
var platform = __webpack_require__(7721);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var withXSRFToken = config.withXSRFToken;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    // false, 0 (zero number), and '' (empty string) are valid JSON values
    if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 5644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var bind = __webpack_require__(3644);
var Axios = __webpack_require__(2215);
var mergeConfig = __webpack_require__(2937);
var defaults = __webpack_require__(663);
var formDataToJSON = __webpack_require__(9468);
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(8047);
axios.CancelToken = __webpack_require__(4089);
axios.isCancel = __webpack_require__(8041);
axios.VERSION = (__webpack_require__(9241).version);
axios.toFormData = __webpack_require__(9027);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(1218);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(783);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(5587);

axios.formToJSON = function(thing) {
  return formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
};

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 4089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(8047);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i = token._listeners.length;

    while (i-- > 0) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message, config, request) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message, config, request);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 8047:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(1218);
var utils = __webpack_require__(3044);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 8041:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 2215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var buildURL = __webpack_require__(8030);
var InterceptorManager = __webpack_require__(946);
var dispatchRequest = __webpack_require__(6895);
var mergeConfig = __webpack_require__(2937);
var buildFullPath = __webpack_require__(7948);
var validator = __webpack_require__(7525);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  var paramsSerializer = config.paramsSerializer;

  if (paramsSerializer !== undefined) {
    validator.assertOptions(paramsSerializer, {
      encode: validators.function,
      serialize: validators.function
    }, true);
  }

  utils.isFunction(paramsSerializer) && (config.paramsSerializer = {serialize: paramsSerializer});

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 1218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Clear all interceptors from the stack
 */
InterceptorManager.prototype.clear = function clear() {
  if (this.handlers) {
    this.handlers = [];
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 7948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(9192);
var combineURLs = __webpack_require__(8762);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 6895:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var transformData = __webpack_require__(8556);
var isCancel = __webpack_require__(8041);
var defaults = __webpack_require__(663);
var CanceledError = __webpack_require__(8047);
var normalizeHeaderName = __webpack_require__(8868);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    null,
    config.transformRequest
  );

  normalizeHeaderName(config.headers, 'Accept');
  normalizeHeaderName(config.headers, 'Content-Type');

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      response.status,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          reason.response.status,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 2937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isEmptyObject(source)) {
      return utils.merge({}, target);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'withXSRFToken': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 6955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(1218);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var defaults = __webpack_require__(663);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, status, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers, status);
  });

  return data;
};


/***/ }),

/***/ 663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4406);


var utils = __webpack_require__(3044);
var normalizeHeaderName = __webpack_require__(8868);
var AxiosError = __webpack_require__(1218);
var transitionalDefaults = __webpack_require__(8560);
var toFormData = __webpack_require__(9027);
var toURLEncodedForm = __webpack_require__(1746);
var platform = __webpack_require__(7721);
var formDataToJSON = __webpack_require__(9468);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(353);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(353);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    var contentType = headers && headers['Content-Type'] || '';
    var hasJSONContentType = contentType.indexOf('application/json') > -1;
    var isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    var isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        var _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 8560:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 5694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// eslint-disable-next-line strict
module.exports = __webpack_require__(1688);


/***/ }),

/***/ 9241:
/***/ (function(module) {

module.exports = {
  "version": "0.28.1"
};

/***/ }),

/***/ 3831:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toFormData = __webpack_require__(9027);

function encode(str) {
  var charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

var prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  var _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

module.exports = AxiosURLSearchParams;


/***/ }),

/***/ 3644:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
};


/***/ }),

/***/ 8030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var AxiosURLSearchParams = __webpack_require__(3831);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var hashmarkIndex = url.indexOf('#');

  if (hashmarkIndex !== -1) {
    url = url.slice(0, hashmarkIndex);
  }

  var _encode = options && options.encode || encode;

  var serializeFn = options && options.serialize;

  var serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 8762:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 2233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 9468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

function arrayToObject(arr) {
  var obj = {};
  var keys = Object.keys(arr);
  var i;
  var len = keys.length;
  var key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    var name = path[index++];
    var isNumericKey = Number.isFinite(+name);
    var isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProperty(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    var result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    var obj = {};

    utils.forEachEntry(formData, function(name, value) {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

module.exports = formDataToJSON;


/***/ }),

/***/ 9192:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 5587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */
      function resolveURL(url) {
        var href = url;

        if (msie) {
          // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

    // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 8868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 1875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.slice(0, i)).toLowerCase();
    val = utils.trim(line.slice(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 738:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 783:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 9027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(8834)["lW"];


var utils = __webpack_require__(3044);
var AxiosError = __webpack_require__(1218);
var envFormData = __webpack_require__(5694);

function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

var predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

function isSpecCompliant(thing) {
  return thing && utils.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/

function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (envFormData || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  var metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  var visitor = options.visitor || defaultVisitor;
  var dots = options.dots;
  var indexes = options.indexes;
  var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  var useBlob = _Blob && isSpecCompliant(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    var arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        (utils.isFileList(value) || utils.endsWith(key, '[]') && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !utils.isUndefined(el) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  var stack = [];

  var exposedHelpers = Object.assign(predicates, {
    defaultVisitor: defaultVisitor,
    convertValue: convertValue,
    isVisitable: isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      var result = !utils.isUndefined(el) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 1746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var toFormData = __webpack_require__(9027);
var platform = __webpack_require__(7721);

module.exports = function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
};


/***/ }),

/***/ 7525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(9241).version);
var AxiosError = __webpack_require__(1218);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 319:
/***/ (function(module) {

"use strict";


module.exports = FormData;


/***/ }),

/***/ 1159:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosURLSearchParams = __webpack_require__(3831);

module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;


/***/ }),

/***/ 1279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  isBrowser: true,
  classes: {
    URLSearchParams: __webpack_require__(1159),
    FormData: __webpack_require__(319),
    Blob: Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};


/***/ }),

/***/ 7721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1279);


/***/ }),

/***/ 3044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(3644);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */
function isEmptyObject(val) {
  return val && Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  var product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter, propFilter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */
function toArray(thing) {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  var i = thing.length;
  if (!isNumber(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

function forEachEntry(obj, fn) {
  var generator = obj && obj[Symbol.iterator];

  var iterator = generator.call(obj);

  var result;

  while ((result = iterator.next()) && !result.done) {
    var pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

function matchAll(regExp, str) {
  var matches;
  var arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

var isHTMLForm = kindOfTest('HTMLFormElement');

var hasOwnProperty = (function resolver(_hasOwnProperty) {
  return function(obj, prop) {
    return _hasOwnProperty.call(obj, prop);
  };
})(Object.prototype.hasOwnProperty);

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isEmptyObject: isEmptyObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList,
  forEachEntry: forEachEntry,
  matchAll: matchAll,
  isHTMLForm: isHTMLForm,
  hasOwnProperty: hasOwnProperty
};


/***/ }),

/***/ 5626:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 8834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(5626)
var ieee754 = __webpack_require__(2333)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 9785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 2765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 5027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6522);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(9785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || (0,esm_typeof/* default */.Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(6700);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(2765);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var timestamp = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate/* default */.Z)(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 6700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6522);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9785);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 8879:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 9385:
/***/ (function(module) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),

/***/ 1688:
/***/ (function(module) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),

/***/ 5480:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
	 true ? factory(exports) :
	0;
}(this, (function (exports) { 'use strict';

	/*!
	 * ScrollTrigger 3.8.0
	 * https://greensock.com
	 *
	 * @license Copyright 2008-2021, GreenSock. All rights reserved.
	 * Subject to the terms at https://greensock.com/standard-license or for
	 * Club GreenSock members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/
	var gsap,
	    _coreInitted,
	    _win,
	    _doc,
	    _docEl,
	    _body,
	    _root,
	    _resizeDelay,
	    _raf,
	    _request,
	    _toArray,
	    _clamp,
	    _time2,
	    _syncInterval,
	    _refreshing,
	    _pointerIsDown,
	    _transformProp,
	    _i,
	    _prevWidth,
	    _prevHeight,
	    _autoRefresh,
	    _sort,
	    _suppressOverwrites,
	    _ignoreResize,
	    _limitCallbacks,
	    _startup = 1,
	    _proxies = [],
	    _scrollers = [],
	    _getTime = Date.now,
	    _time1 = _getTime(),
	    _lastScrollTime = 0,
	    _enabled = 1,
	    _passThrough = function _passThrough(v) {
	  return v;
	},
	    _getTarget = function _getTarget(t) {
	  return _toArray(t)[0] || (_isString(t) ? console.warn("Element not found:", t) : null);
	},
	    _round = function _round(value) {
	  return Math.round(value * 100000) / 100000 || 0;
	},
	    _windowExists = function _windowExists() {
	  return typeof window !== "undefined";
	},
	    _getGSAP = function _getGSAP() {
	  return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
	},
	    _isViewport = function _isViewport(e) {
	  return !!~_root.indexOf(e);
	},
	    _getProxyProp = function _getProxyProp(element, property) {
	  return ~_proxies.indexOf(element) && _proxies[_proxies.indexOf(element) + 1][property];
	},
	    _getScrollFunc = function _getScrollFunc(element, _ref) {
	  var s = _ref.s,
	      sc = _ref.sc;

	  var i = _scrollers.indexOf(element),
	      offset = sc === _vertical.sc ? 1 : 2;

	  !~i && (i = _scrollers.push(element) - 1);
	  return _scrollers[i + offset] || (_scrollers[i + offset] = _getProxyProp(element, s) || (_isViewport(element) ? sc : function (value) {
	    return arguments.length ? element[s] = value : element[s];
	  }));
	},
	    _getBoundsFunc = function _getBoundsFunc(element) {
	  return _getProxyProp(element, "getBoundingClientRect") || (_isViewport(element) ? function () {
	    _winOffsets.width = _win.innerWidth;
	    _winOffsets.height = _win.innerHeight;
	    return _winOffsets;
	  } : function () {
	    return _getBounds(element);
	  });
	},
	    _getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref2) {
	  var d = _ref2.d,
	      d2 = _ref2.d2,
	      a = _ref2.a;
	  return (a = _getProxyProp(scroller, "getBoundingClientRect")) ? function () {
	    return a()[d];
	  } : function () {
	    return (isViewport ? _win["inner" + d2] : scroller["client" + d2]) || 0;
	  };
	},
	    _getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
	  return !isViewport || ~_proxies.indexOf(element) ? _getBoundsFunc(element) : function () {
	    return _winOffsets;
	  };
	},
	    _maxScroll = function _maxScroll(element, _ref3) {
	  var s = _ref3.s,
	      d2 = _ref3.d2,
	      d = _ref3.d,
	      a = _ref3.a;
	  return (s = "scroll" + d2) && (a = _getProxyProp(element, s)) ? a() - _getBoundsFunc(element)()[d] : _isViewport(element) ? (_body[s] || _docEl[s]) - (_win["inner" + d2] || _docEl["client" + d2] || _body["client" + d2]) : element[s] - element["offset" + d2];
	},
	    _iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
	  for (var i = 0; i < _autoRefresh.length; i += 3) {
	    (!events || ~events.indexOf(_autoRefresh[i + 1])) && func(_autoRefresh[i], _autoRefresh[i + 1], _autoRefresh[i + 2]);
	  }
	},
	    _isString = function _isString(value) {
	  return typeof value === "string";
	},
	    _isFunction = function _isFunction(value) {
	  return typeof value === "function";
	},
	    _isNumber = function _isNumber(value) {
	  return typeof value === "number";
	},
	    _isObject = function _isObject(value) {
	  return typeof value === "object";
	},
	    _callIfFunc = function _callIfFunc(value) {
	  return _isFunction(value) && value();
	},
	    _combineFunc = function _combineFunc(f1, f2) {
	  return function () {
	    var result1 = _callIfFunc(f1),
	        result2 = _callIfFunc(f2);

	    return function () {
	      _callIfFunc(result1);

	      _callIfFunc(result2);
	    };
	  };
	},
	    _endAnimation = function _endAnimation(animation, reversed, pause) {
	  return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
	},
	    _callback = function _callback(self, func) {
	  var result = func(self);
	  result && result.totalTime && (self.callbackAnimation = result);
	},
	    _abs = Math.abs,
	    _scrollLeft = "scrollLeft",
	    _scrollTop = "scrollTop",
	    _left = "left",
	    _top = "top",
	    _right = "right",
	    _bottom = "bottom",
	    _width = "width",
	    _height = "height",
	    _Right = "Right",
	    _Left = "Left",
	    _Top = "Top",
	    _Bottom = "Bottom",
	    _padding = "padding",
	    _margin = "margin",
	    _Width = "Width",
	    _Height = "Height",
	    _px = "px",
	    _horizontal = {
	  s: _scrollLeft,
	  p: _left,
	  p2: _Left,
	  os: _right,
	  os2: _Right,
	  d: _width,
	  d2: _Width,
	  a: "x",
	  sc: function sc(value) {
	    return arguments.length ? _win.scrollTo(value, _vertical.sc()) : _win.pageXOffset || _doc[_scrollLeft] || _docEl[_scrollLeft] || _body[_scrollLeft] || 0;
	  }
	},
	    _vertical = {
	  s: _scrollTop,
	  p: _top,
	  p2: _Top,
	  os: _bottom,
	  os2: _Bottom,
	  d: _height,
	  d2: _Height,
	  a: "y",
	  op: _horizontal,
	  sc: function sc(value) {
	    return arguments.length ? _win.scrollTo(_horizontal.sc(), value) : _win.pageYOffset || _doc[_scrollTop] || _docEl[_scrollTop] || _body[_scrollTop] || 0;
	  }
	},
	    _getComputedStyle = function _getComputedStyle(element) {
	  return _win.getComputedStyle(element);
	},
	    _makePositionable = function _makePositionable(element) {
	  var position = _getComputedStyle(element).position;

	  element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
	},
	    _setDefaults = function _setDefaults(obj, defaults) {
	  for (var p in defaults) {
	    p in obj || (obj[p] = defaults[p]);
	  }

	  return obj;
	},
	    _getBounds = function _getBounds(element, withoutTransforms) {
	  var tween = withoutTransforms && _getComputedStyle(element)[_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && gsap.to(element, {
	    x: 0,
	    y: 0,
	    xPercent: 0,
	    yPercent: 0,
	    rotation: 0,
	    rotationX: 0,
	    rotationY: 0,
	    scale: 1,
	    skewX: 0,
	    skewY: 0
	  }).progress(1),
	      bounds = element.getBoundingClientRect();
	  tween && tween.progress(0).kill();
	  return bounds;
	},
	    _getSize = function _getSize(element, _ref4) {
	  var d2 = _ref4.d2;
	  return element["offset" + d2] || element["client" + d2] || 0;
	},
	    _getLabelRatioArray = function _getLabelRatioArray(timeline) {
	  var a = [],
	      labels = timeline.labels,
	      duration = timeline.duration(),
	      p;

	  for (p in labels) {
	    a.push(labels[p] / duration);
	  }

	  return a;
	},
	    _getClosestLabel = function _getClosestLabel(animation) {
	  return function (value) {
	    return gsap.utils.snap(_getLabelRatioArray(animation), value);
	  };
	},
	    _snapDirectional = function _snapDirectional(snapIncrementOrArray) {
	  var snap = gsap.utils.snap(snapIncrementOrArray),
	      a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function (a, b) {
	    return a - b;
	  });
	  return a ? function (value, direction) {
	    var i;

	    if (!direction) {
	      return snap(value);
	    }

	    if (direction > 0) {
	      value -= 1e-4;

	      for (i = 0; i < a.length; i++) {
	        if (a[i] >= value) {
	          return a[i];
	        }
	      }

	      return a[i - 1];
	    } else {
	      i = a.length;
	      value += 1e-4;

	      while (i--) {
	        if (a[i] <= value) {
	          return a[i];
	        }
	      }
	    }

	    return a[0];
	  } : function (value, direction) {
	    var snapped = snap(value);
	    return !direction || Math.abs(snapped - value) < 0.001 || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
	  };
	},
	    _getLabelAtDirection = function _getLabelAtDirection(timeline) {
	  return function (value, st) {
	    return _snapDirectional(_getLabelRatioArray(timeline))(value, st.direction);
	  };
	},
	    _multiListener = function _multiListener(func, element, types, callback) {
	  return types.split(",").forEach(function (type) {
	    return func(element, type, callback);
	  });
	},
	    _addListener = function _addListener(element, type, func) {
	  return element.addEventListener(type, func, {
	    passive: true
	  });
	},
	    _removeListener = function _removeListener(element, type, func) {
	  return element.removeEventListener(type, func);
	},
	    _markerDefaults = {
	  startColor: "green",
	  endColor: "red",
	  indent: 0,
	  fontSize: "16px",
	  fontWeight: "normal"
	},
	    _defaults = {
	  toggleActions: "play",
	  anticipatePin: 0
	},
	    _keywords = {
	  top: 0,
	  left: 0,
	  center: 0.5,
	  bottom: 1,
	  right: 1
	},
	    _offsetToPx = function _offsetToPx(value, size) {
	  if (_isString(value)) {
	    var eqIndex = value.indexOf("="),
	        relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;

	    if (~eqIndex) {
	      value.indexOf("%") > eqIndex && (relative *= size / 100);
	      value = value.substr(0, eqIndex - 1);
	    }

	    value = relative + (value in _keywords ? _keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
	  }

	  return value;
	},
	    _createMarker = function _createMarker(type, name, container, direction, _ref5, offset, matchWidthEl, containerAnimation) {
	  var startColor = _ref5.startColor,
	      endColor = _ref5.endColor,
	      fontSize = _ref5.fontSize,
	      indent = _ref5.indent,
	      fontWeight = _ref5.fontWeight;

	  var e = _doc.createElement("div"),
	      useFixedPosition = _isViewport(container) || _getProxyProp(container, "pinType") === "fixed",
	      isScroller = type.indexOf("scroller") !== -1,
	      parent = useFixedPosition ? _body : container,
	      isStart = type.indexOf("start") !== -1,
	      color = isStart ? startColor : endColor,
	      css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";

	  css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
	  (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === _vertical ? _right : _bottom) + ":" + (offset + parseFloat(indent)) + "px;");
	  matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
	  e._isStart = isStart;
	  e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
	  e.style.cssText = css;
	  e.innerText = name || name === 0 ? type + "-" + name : type;
	  parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
	  e._offset = e["offset" + direction.op.d2];

	  _positionMarker(e, 0, direction, isStart);

	  return e;
	},
	    _positionMarker = function _positionMarker(marker, start, direction, flipped) {
	  var vars = {
	    display: "block"
	  },
	      side = direction[flipped ? "os2" : "p2"],
	      oppositeSide = direction[flipped ? "p2" : "os2"];
	  marker._isFlipped = flipped;
	  vars[direction.a + "Percent"] = flipped ? -100 : 0;
	  vars[direction.a] = flipped ? "1px" : 0;
	  vars["border" + side + _Width] = 1;
	  vars["border" + oppositeSide + _Width] = 0;
	  vars[direction.p] = start + "px";
	  gsap.set(marker, vars);
	},
	    _triggers = [],
	    _ids = {},
	    _sync = function _sync() {
	  return _getTime() - _lastScrollTime > 20 && _updateAll();
	},
	    _onScroll = function _onScroll() {
	  var time = _getTime();

	  if (_lastScrollTime !== time) {
	    _updateAll();

	    _lastScrollTime || _dispatch("scrollStart");
	    _lastScrollTime = time;
	  } else if (!_request) {
	    _request = _raf(_updateAll);
	  }
	},
	    _onResize = function _onResize() {
	  return !_refreshing && !_ignoreResize && !_doc.fullscreenElement && _resizeDelay.restart(true);
	},
	    _listeners = {},
	    _emptyArray = [],
	    _media = [],
	    _creatingMedia,
	    _lastMediaTick,
	    _onMediaChange = function _onMediaChange(e) {
	  var tick = gsap.ticker.frame,
	      matches = [],
	      i = 0,
	      index;

	  if (_lastMediaTick !== tick || _startup) {
	    _revertAll();

	    for (; i < _media.length; i += 4) {
	      index = _win.matchMedia(_media[i]).matches;

	      if (index !== _media[i + 3]) {
	        _media[i + 3] = index;
	        index ? matches.push(i) : _revertAll(1, _media[i]) || _isFunction(_media[i + 2]) && _media[i + 2]();
	      }
	    }

	    _revertRecorded();

	    for (i = 0; i < matches.length; i++) {
	      index = matches[i];
	      _creatingMedia = _media[index];
	      _media[index + 2] = _media[index + 1](e);
	    }

	    _creatingMedia = 0;
	    _coreInitted && _refreshAll(0, 1);
	    _lastMediaTick = tick;

	    _dispatch("matchMedia");
	  }
	},
	    _softRefresh = function _softRefresh() {
	  return _removeListener(ScrollTrigger, "scrollEnd", _softRefresh) || _refreshAll(true);
	},
	    _dispatch = function _dispatch(type) {
	  return _listeners[type] && _listeners[type].map(function (f) {
	    return f();
	  }) || _emptyArray;
	},
	    _savedStyles = [],
	    _revertRecorded = function _revertRecorded(media) {
	  for (var i = 0; i < _savedStyles.length; i += 5) {
	    if (!media || _savedStyles[i + 4] === media) {
	      _savedStyles[i].style.cssText = _savedStyles[i + 1];
	      _savedStyles[i].getBBox && _savedStyles[i].setAttribute("transform", _savedStyles[i + 2] || "");
	      _savedStyles[i + 3].uncache = 1;
	    }
	  }
	},
	    _revertAll = function _revertAll(kill, media) {
	  var trigger;

	  for (_i = 0; _i < _triggers.length; _i++) {
	    trigger = _triggers[_i];

	    if (!media || trigger.media === media) {
	      if (kill) {
	        trigger.kill(1);
	      } else {
	        trigger.revert();
	      }
	    }
	  }

	  media && _revertRecorded(media);
	  media || _dispatch("revert");
	},
	    _clearScrollMemory = function _clearScrollMemory() {
	  return _scrollers.forEach(function (obj) {
	    return typeof obj === "function" && (obj.rec = 0);
	  });
	},
	    _refreshingAll,
	    _refreshAll = function _refreshAll(force, skipRevert) {
	  if (_lastScrollTime && !force) {
	    _addListener(ScrollTrigger, "scrollEnd", _softRefresh);

	    return;
	  }

	  _refreshingAll = true;

	  var refreshInits = _dispatch("refreshInit");

	  _sort && ScrollTrigger.sort();
	  skipRevert || _revertAll();

	  _triggers.forEach(function (t) {
	    return t.refresh();
	  });

	  refreshInits.forEach(function (result) {
	    return result && result.render && result.render(-1);
	  });

	  _clearScrollMemory();

	  _resizeDelay.pause();

	  _refreshingAll = false;

	  _dispatch("refresh");
	},
	    _lastScroll = 0,
	    _direction = 1,
	    _updateAll = function _updateAll() {
	  if (!_refreshingAll) {
	    var l = _triggers.length,
	        time = _getTime(),
	        recordVelocity = time - _time1 >= 50,
	        scroll = l && _triggers[0].scroll();

	    _direction = _lastScroll > scroll ? -1 : 1;
	    _lastScroll = scroll;

	    if (recordVelocity) {
	      if (_lastScrollTime && !_pointerIsDown && time - _lastScrollTime > 200) {
	        _lastScrollTime = 0;

	        _dispatch("scrollEnd");
	      }

	      _time2 = _time1;
	      _time1 = time;
	    }

	    if (_direction < 0) {
	      _i = l;

	      while (_i-- > 0) {
	        _triggers[_i] && _triggers[_i].update(0, recordVelocity);
	      }

	      _direction = 1;
	    } else {
	      for (_i = 0; _i < l; _i++) {
	        _triggers[_i] && _triggers[_i].update(0, recordVelocity);
	      }
	    }

	    _request = 0;
	  }
	},
	    _propNamesToCopy = [_left, _top, _bottom, _right, _margin + _Bottom, _margin + _Right, _margin + _Top, _margin + _Left, "display", "flexShrink", "float", "zIndex", "grid-column-start", "grid-column-end", "grid-row-start", "grid-row-end", "grid-area", "justify-self", "align-self", "place-self"],
	    _stateProps = _propNamesToCopy.concat([_width, _height, "boxSizing", "max" + _Width, "max" + _Height, "position", _margin, _padding, _padding + _Top, _padding + _Right, _padding + _Bottom, _padding + _Left]),
	    _swapPinOut = function _swapPinOut(pin, spacer, state) {
	  _setState(state);

	  var cache = pin._gsap;

	  if (cache.spacerIsNative) {
	    _setState(cache.spacerState);
	  } else if (pin.parentNode === spacer) {
	    var parent = spacer.parentNode;

	    if (parent) {
	      parent.insertBefore(pin, spacer);
	      parent.removeChild(spacer);
	    }
	  }
	},
	    _swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
	  if (pin.parentNode !== spacer) {
	    var i = _propNamesToCopy.length,
	        spacerStyle = spacer.style,
	        pinStyle = pin.style,
	        p;

	    while (i--) {
	      p = _propNamesToCopy[i];
	      spacerStyle[p] = cs[p];
	    }

	    spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
	    cs.display === "inline" && (spacerStyle.display = "inline-block");
	    pinStyle[_bottom] = pinStyle[_right] = "auto";
	    spacerStyle.overflow = "visible";
	    spacerStyle.boxSizing = "border-box";
	    spacerStyle[_width] = _getSize(pin, _horizontal) + _px;
	    spacerStyle[_height] = _getSize(pin, _vertical) + _px;
	    spacerStyle[_padding] = pinStyle[_margin] = pinStyle[_top] = pinStyle[_left] = "0";

	    _setState(spacerState);

	    pinStyle[_width] = pinStyle["max" + _Width] = cs[_width];
	    pinStyle[_height] = pinStyle["max" + _Height] = cs[_height];
	    pinStyle[_padding] = cs[_padding];
	    pin.parentNode.insertBefore(spacer, pin);
	    spacer.appendChild(pin);
	  }
	},
	    _capsExp = /([A-Z])/g,
	    _setState = function _setState(state) {
	  if (state) {
	    var style = state.t.style,
	        l = state.length,
	        i = 0,
	        p,
	        value;
	    (state.t._gsap || gsap.core.getCache(state.t)).uncache = 1;

	    for (; i < l; i += 2) {
	      value = state[i + 1];
	      p = state[i];

	      if (value) {
	        style[p] = value;
	      } else if (style[p]) {
	        style.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
	      }
	    }
	  }
	},
	    _getState = function _getState(element) {
	  var l = _stateProps.length,
	      style = element.style,
	      state = [],
	      i = 0;

	  for (; i < l; i++) {
	    state.push(_stateProps[i], style[_stateProps[i]]);
	  }

	  state.t = element;
	  return state;
	},
	    _copyState = function _copyState(state, override, omitOffsets) {
	  var result = [],
	      l = state.length,
	      i = omitOffsets ? 8 : 0,
	      p;

	  for (; i < l; i += 2) {
	    p = state[i];
	    result.push(p, p in override ? override[p] : state[i + 1]);
	  }

	  result.t = state.t;
	  return result;
	},
	    _winOffsets = {
	  left: 0,
	  top: 0
	},
	    _parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation) {
	  _isFunction(value) && (value = value(self));

	  if (_isString(value) && value.substr(0, 3) === "max") {
	    value = scrollerMax + (value.charAt(4) === "=" ? _offsetToPx("0" + value.substr(3), scrollerSize) : 0);
	  }

	  var time = containerAnimation ? containerAnimation.time() : 0,
	      p1,
	      p2,
	      element;
	  containerAnimation && containerAnimation.seek(0);

	  if (!_isNumber(value)) {
	    _isFunction(trigger) && (trigger = trigger(self));
	    var offsets = value.split(" "),
	        bounds,
	        localOffset,
	        globalOffset,
	        display;
	    element = _getTarget(trigger) || _body;
	    bounds = _getBounds(element) || {};

	    if ((!bounds || !bounds.left && !bounds.top) && _getComputedStyle(element).display === "none") {
	      display = element.style.display;
	      element.style.display = "block";
	      bounds = _getBounds(element);
	      display ? element.style.display = display : element.style.removeProperty("display");
	    }

	    localOffset = _offsetToPx(offsets[0], bounds[direction.d]);
	    globalOffset = _offsetToPx(offsets[1] || "0", scrollerSize);
	    value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
	    markerScroller && _positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
	    scrollerSize -= scrollerSize - globalOffset;
	  } else if (markerScroller) {
	    _positionMarker(markerScroller, scrollerSize, direction, true);
	  }

	  if (marker) {
	    var position = value + scrollerSize,
	        isStart = marker._isStart;
	    p1 = "scroll" + direction.d2;

	    _positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max(_body[p1], _docEl[p1]) : marker.parentNode[p1]) <= position + 1);

	    if (useFixedPosition) {
	      scrollerBounds = _getBounds(markerScroller);
	      useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + _px);
	    }
	  }

	  if (containerAnimation && element) {
	    p1 = _getBounds(element);
	    containerAnimation.seek(scrollerMax);
	    p2 = _getBounds(element);
	    containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
	    value = value / containerAnimation._caScrollDist * scrollerMax;
	  }

	  containerAnimation && containerAnimation.seek(time);
	  return containerAnimation ? value : Math.round(value);
	},
	    _prefixExp = /(?:webkit|moz|length|cssText|inset)/i,
	    _reparent = function _reparent(element, parent, top, left) {
	  if (element.parentNode !== parent) {
	    var style = element.style,
	        p,
	        cs;

	    if (parent === _body) {
	      element._stOrig = style.cssText;
	      cs = _getComputedStyle(element);

	      for (p in cs) {
	        if (!+p && !_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") {
	          style[p] = cs[p];
	        }
	      }

	      style.top = top;
	      style.left = left;
	    } else {
	      style.cssText = element._stOrig;
	    }

	    gsap.core.getCache(element).uncache = 1;
	    parent.appendChild(element);
	  }
	},
	    _getTweenCreator = function _getTweenCreator(scroller, direction) {
	  var getScroll = _getScrollFunc(scroller, direction),
	      prop = "_scroll" + direction.p2,
	      lastScroll1,
	      lastScroll2,
	      getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
	    var tween = getTween.tween,
	        onComplete = vars.onComplete,
	        modifiers = {};
	    tween && tween.kill();
	    lastScroll1 = Math.round(initialValue);
	    vars[prop] = scrollTo;
	    vars.modifiers = modifiers;

	    modifiers[prop] = function (value) {
	      value = _round(getScroll());

	      if (value !== lastScroll1 && value !== lastScroll2 && Math.abs(value - lastScroll1) > 2) {
	        tween.kill();
	        getTween.tween = 0;
	      } else {
	        value = initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio;
	      }

	      lastScroll2 = lastScroll1;
	      return lastScroll1 = _round(value);
	    };

	    vars.onComplete = function () {
	      getTween.tween = 0;
	      onComplete && onComplete.call(tween);
	    };

	    tween = getTween.tween = gsap.to(scroller, vars);
	    return tween;
	  };

	  scroller[prop] = getScroll;
	  scroller.addEventListener("wheel", function () {
	    return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
	  }, {
	    passive: true
	  });
	  return getTween;
	};

	_horizontal.op = _vertical;
	var ScrollTrigger = function () {
	  function ScrollTrigger(vars, animation) {
	    _coreInitted || ScrollTrigger.register(gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
	    this.init(vars, animation);
	  }

	  var _proto = ScrollTrigger.prototype;

	  _proto.init = function init(vars, animation) {
	    this.progress = this.start = 0;
	    this.vars && this.kill(1);

	    if (!_enabled) {
	      this.update = this.refresh = this.kill = _passThrough;
	      return;
	    }

	    vars = _setDefaults(_isString(vars) || _isNumber(vars) || vars.nodeType ? {
	      trigger: vars
	    } : vars, _defaults);

	    var _vars = vars,
	        onUpdate = _vars.onUpdate,
	        toggleClass = _vars.toggleClass,
	        id = _vars.id,
	        onToggle = _vars.onToggle,
	        onRefresh = _vars.onRefresh,
	        scrub = _vars.scrub,
	        trigger = _vars.trigger,
	        pin = _vars.pin,
	        pinSpacing = _vars.pinSpacing,
	        invalidateOnRefresh = _vars.invalidateOnRefresh,
	        anticipatePin = _vars.anticipatePin,
	        onScrubComplete = _vars.onScrubComplete,
	        onSnapComplete = _vars.onSnapComplete,
	        once = _vars.once,
	        snap = _vars.snap,
	        pinReparent = _vars.pinReparent,
	        pinSpacer = _vars.pinSpacer,
	        containerAnimation = _vars.containerAnimation,
	        fastScrollEnd = _vars.fastScrollEnd,
	        preventOverlaps = _vars.preventOverlaps,
	        direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? _horizontal : _vertical,
	        isToggle = !scrub && scrub !== 0,
	        scroller = _getTarget(vars.scroller || _win),
	        scrollerCache = gsap.core.getCache(scroller),
	        isViewport = _isViewport(scroller),
	        useFixedPosition = ("pinType" in vars ? vars.pinType : _getProxyProp(scroller, "pinType") || isViewport && "fixed") === "fixed",
	        callbacks = [vars.onEnter, vars.onLeave, vars.onEnterBack, vars.onLeaveBack],
	        toggleActions = isToggle && vars.toggleActions.split(" "),
	        markers = "markers" in vars ? vars.markers : _defaults.markers,
	        borderWidth = isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0,
	        self = this,
	        onRefreshInit = vars.onRefreshInit && function () {
	      return vars.onRefreshInit(self);
	    },
	        getScrollerSize = _getSizeFunc(scroller, isViewport, direction),
	        getScrollerOffsets = _getOffsetsFunc(scroller, isViewport),
	        lastSnap = 0,
	        scrollFunc = _getScrollFunc(scroller, direction),
	        tweenTo,
	        pinCache,
	        snapFunc,
	        scroll1,
	        scroll2,
	        start,
	        end,
	        markerStart,
	        markerEnd,
	        markerStartTrigger,
	        markerEndTrigger,
	        markerVars,
	        change,
	        pinOriginalState,
	        pinActiveState,
	        pinState,
	        spacer,
	        offset,
	        pinGetter,
	        pinSetter,
	        pinStart,
	        pinChange,
	        spacingStart,
	        spacerState,
	        markerStartSetter,
	        markerEndSetter,
	        cs,
	        snap1,
	        snap2,
	        scrubTween,
	        scrubSmooth,
	        snapDurClamp,
	        snapDelayedCall,
	        prevProgress,
	        prevScroll,
	        prevAnimProgress,
	        caMarkerSetter;

	    self.media = _creatingMedia;
	    anticipatePin *= 45;
	    self.scroller = scroller;
	    self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
	    scroll1 = scrollFunc();
	    self.vars = vars;
	    animation = animation || vars.animation;
	    "refreshPriority" in vars && (_sort = 1);
	    scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
	      top: _getTweenCreator(scroller, _vertical),
	      left: _getTweenCreator(scroller, _horizontal)
	    };
	    self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];

	    if (animation) {
	      animation.vars.lazy = false;
	      animation._initted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.render(0, true, true);
	      self.animation = animation.pause();
	      animation.scrollTrigger = self;
	      scrubSmooth = _isNumber(scrub) && scrub;
	      scrubSmooth && (scrubTween = gsap.to(animation, {
	        ease: "power3",
	        duration: scrubSmooth,
	        onComplete: function onComplete() {
	          return onScrubComplete && onScrubComplete(self);
	        }
	      }));
	      snap1 = 0;
	      id || (id = animation.vars.id);
	    }

	    _triggers.push(self);

	    if (snap) {
	      if (!_isObject(snap) || snap.push) {
	        snap = {
	          snapTo: snap
	        };
	      }

	      "scrollBehavior" in _body.style && gsap.set(isViewport ? [_body, _docEl] : scroller, {
	        scrollBehavior: "auto"
	      });
	      snapFunc = _isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? _getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? _getLabelAtDirection(animation) : snap.directional !== false ? function (value, st) {
	        return _snapDirectional(snap.snapTo)(value, st.direction);
	      } : gsap.utils.snap(snap.snapTo);
	      snapDurClamp = snap.duration || {
	        min: 0.1,
	        max: 2
	      };
	      snapDurClamp = _isObject(snapDurClamp) ? _clamp(snapDurClamp.min, snapDurClamp.max) : _clamp(snapDurClamp, snapDurClamp);
	      snapDelayedCall = gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function () {
	        if (Math.abs(self.getVelocity()) < 10 && !_pointerIsDown && lastSnap !== scrollFunc()) {
	          var totalProgress = animation && !isToggle ? animation.totalProgress() : self.progress,
	              velocity = (totalProgress - snap2) / (_getTime() - _time2) * 1000 || 0,
	              change1 = gsap.utils.clamp(-self.progress, 1 - self.progress, _abs(velocity / 2) * velocity / 0.185),
	              naturalEnd = self.progress + (snap.inertia === false ? 0 : change1),
	              endValue = _clamp(0, 1, snapFunc(naturalEnd, self)),
	              scroll = scrollFunc(),
	              endScroll = Math.round(start + endValue * change),
	              _snap = snap,
	              onStart = _snap.onStart,
	              _onInterrupt = _snap.onInterrupt,
	              _onComplete = _snap.onComplete,
	              tween = tweenTo.tween;

	          if (scroll <= end && scroll >= start && endScroll !== scroll) {
	            if (tween && !tween._initted && tween.data <= _abs(endScroll - scroll)) {
	              return;
	            }

	            if (snap.inertia === false) {
	              change1 = endValue - self.progress;
	            }

	            tweenTo(endScroll, {
	              duration: snapDurClamp(_abs(Math.max(_abs(naturalEnd - totalProgress), _abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
	              ease: snap.ease || "power3",
	              data: _abs(endScroll - scroll),
	              onInterrupt: function onInterrupt() {
	                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
	              },
	              onComplete: function onComplete() {
	                lastSnap = scrollFunc();
	                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
	                onSnapComplete && onSnapComplete(self);
	                _onComplete && _onComplete(self);
	              }
	            }, scroll, change1 * change, endScroll - scroll - change1 * change);
	            onStart && onStart(self, tweenTo.tween);
	          }
	        } else if (self.isActive) {
	          snapDelayedCall.restart(true);
	        }
	      }).pause();
	    }

	    id && (_ids[id] = self);
	    trigger = self.trigger = _getTarget(trigger || pin);
	    pin = pin === true ? trigger : _getTarget(pin);
	    _isString(toggleClass) && (toggleClass = {
	      targets: trigger,
	      className: toggleClass
	    });

	    if (pin) {
	      pinSpacing === false || pinSpacing === _margin || (pinSpacing = !pinSpacing && _getComputedStyle(pin.parentNode).display === "flex" ? false : _padding);
	      self.pin = pin;
	      vars.force3D !== false && gsap.set(pin, {
	        force3D: true
	      });
	      pinCache = gsap.core.getCache(pin);

	      if (!pinCache.spacer) {
	        if (pinSpacer) {
	          pinSpacer = _getTarget(pinSpacer);
	          pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement);
	          pinCache.spacerIsNative = !!pinSpacer;
	          pinSpacer && (pinCache.spacerState = _getState(pinSpacer));
	        }

	        pinCache.spacer = spacer = pinSpacer || _doc.createElement("div");
	        spacer.classList.add("pin-spacer");
	        id && spacer.classList.add("pin-spacer-" + id);
	        pinCache.pinState = pinOriginalState = _getState(pin);
	      } else {
	        pinOriginalState = pinCache.pinState;
	      }

	      self.spacer = spacer = pinCache.spacer;
	      cs = _getComputedStyle(pin);
	      spacingStart = cs[pinSpacing + direction.os2];
	      pinGetter = gsap.getProperty(pin);
	      pinSetter = gsap.quickSetter(pin, direction.a, _px);

	      _swapPinIn(pin, spacer, cs);

	      pinState = _getState(pin);
	    }

	    if (markers) {
	      markerVars = _isObject(markers) ? _setDefaults(markers, _markerDefaults) : _markerDefaults;
	      markerStartTrigger = _createMarker("scroller-start", id, scroller, direction, markerVars, 0);
	      markerEndTrigger = _createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
	      offset = markerStartTrigger["offset" + direction.op.d2];
	      markerStart = _createMarker("start", id, scroller, direction, markerVars, offset, 0, containerAnimation);
	      markerEnd = _createMarker("end", id, scroller, direction, markerVars, offset, 0, containerAnimation);
	      containerAnimation && (caMarkerSetter = gsap.quickSetter([markerStart, markerEnd], direction.a, _px));

	      if (!useFixedPosition && !(_proxies.length && _getProxyProp(scroller, "fixedMarkers") === true)) {
	        _makePositionable(isViewport ? _body : scroller);

	        gsap.set([markerStartTrigger, markerEndTrigger], {
	          force3D: true
	        });
	        markerStartSetter = gsap.quickSetter(markerStartTrigger, direction.a, _px);
	        markerEndSetter = gsap.quickSetter(markerEndTrigger, direction.a, _px);
	      }
	    }

	    if (containerAnimation) {
	      var oldOnUpdate = containerAnimation.vars.onUpdate,
	          oldParams = containerAnimation.vars.onUpdateParams;
	      containerAnimation.eventCallback("onUpdate", function () {
	        self.update(0, 0, 1);
	        oldOnUpdate && oldOnUpdate.apply(oldParams || []);
	      });
	    }

	    self.previous = function () {
	      return _triggers[_triggers.indexOf(self) - 1];
	    };

	    self.next = function () {
	      return _triggers[_triggers.indexOf(self) + 1];
	    };

	    self.revert = function (revert) {
	      var r = revert !== false || !self.enabled,
	          prevRefreshing = _refreshing;

	      if (r !== self.isReverted) {
	        if (r) {
	          self.scroll.rec || (self.scroll.rec = scrollFunc());
	          prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0);
	          prevProgress = self.progress;
	          prevAnimProgress = animation && animation.progress();
	        }

	        markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
	          return m.style.display = r ? "none" : "block";
	        });
	        r && (_refreshing = 1);
	        self.update(r);
	        _refreshing = prevRefreshing;
	        pin && (r ? _swapPinOut(pin, spacer, pinOriginalState) : (!pinReparent || !self.isActive) && _swapPinIn(pin, spacer, _getComputedStyle(pin), spacerState));
	        self.isReverted = r;
	      }
	    };

	    self.refresh = function (soft, force) {
	      if ((_refreshing || !self.enabled) && !force) {
	        return;
	      }

	      if (pin && soft && _lastScrollTime) {
	        _addListener(ScrollTrigger, "scrollEnd", _softRefresh);

	        return;
	      }

	      _refreshing = 1;
	      scrubTween && scrubTween.pause();
	      invalidateOnRefresh && animation && animation.progress(0).invalidate();
	      self.isReverted || self.revert();

	      var size = getScrollerSize(),
	          scrollerBounds = getScrollerOffsets(),
	          max = containerAnimation ? containerAnimation.duration() : _maxScroll(scroller, direction),
	          offset = 0,
	          otherPinOffset = 0,
	          parsedEnd = vars.end,
	          parsedEndTrigger = vars.endTrigger || trigger,
	          parsedStart = vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"),
	          pinnedContainer = vars.pinnedContainer && _getTarget(vars.pinnedContainer),
	          triggerIndex = trigger && Math.max(0, _triggers.indexOf(self)) || 0,
	          i = triggerIndex,
	          cs,
	          bounds,
	          scroll,
	          isVertical,
	          override,
	          curTrigger,
	          curPin,
	          oppositeScroll,
	          initted,
	          revertedPins;

	      while (i--) {
	        curTrigger = _triggers[i];
	        curTrigger.end || curTrigger.refresh(0, 1) || (_refreshing = 1);
	        curPin = curTrigger.pin;

	        if (curPin && (curPin === trigger || curPin === pin) && !curTrigger.isReverted) {
	          revertedPins || (revertedPins = []);
	          revertedPins.unshift(curTrigger);
	          curTrigger.revert();
	        }
	      }

	      _isFunction(parsedStart) && (parsedStart = parsedStart(self));
	      start = _parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation) || (pin ? -0.001 : 0);
	      _isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));

	      if (_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
	        if (~parsedEnd.indexOf(" ")) {
	          parsedEnd = (_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
	        } else {
	          offset = _offsetToPx(parsedEnd.substr(2), size);
	          parsedEnd = _isString(parsedStart) ? parsedStart : start + offset;
	          parsedEndTrigger = trigger;
	        }
	      }

	      end = Math.max(start, _parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation)) || -0.001;
	      change = end - start || (start -= 0.01) && 0.001;
	      offset = 0;
	      i = triggerIndex;

	      while (i--) {
	        curTrigger = _triggers[i];
	        curPin = curTrigger.pin;

	        if (curPin && curTrigger.start - curTrigger._pinPush < start && !containerAnimation) {
	          cs = curTrigger.end - curTrigger.start;
	          (curPin === trigger || curPin === pinnedContainer) && !_isNumber(parsedStart) && (offset += cs);
	          curPin === pin && (otherPinOffset += cs);
	        }
	      }

	      start += offset;
	      end += offset;
	      self._pinPush = otherPinOffset;

	      if (markerStart && offset) {
	        cs = {};
	        cs[direction.a] = "+=" + offset;
	        pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
	        gsap.set([markerStart, markerEnd], cs);
	      }

	      if (pin) {
	        cs = _getComputedStyle(pin);
	        isVertical = direction === _vertical;
	        scroll = scrollFunc();
	        pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
	        !max && end > 1 && ((isViewport ? _body : scroller).style["overflow-" + direction.a] = "scroll");

	        _swapPinIn(pin, spacer, cs);

	        pinState = _getState(pin);
	        bounds = _getBounds(pin, true);
	        oppositeScroll = useFixedPosition && _getScrollFunc(scroller, isVertical ? _horizontal : _vertical)();

	        if (pinSpacing) {
	          spacerState = [pinSpacing + direction.os2, change + otherPinOffset + _px];
	          spacerState.t = spacer;
	          i = pinSpacing === _padding ? _getSize(pin, direction) + change + otherPinOffset : 0;
	          i && spacerState.push(direction.d, i + _px);

	          _setState(spacerState);

	          useFixedPosition && scrollFunc(prevScroll);
	        }

	        if (useFixedPosition) {
	          override = {
	            top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + _px,
	            left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + _px,
	            boxSizing: "border-box",
	            position: "fixed"
	          };
	          override[_width] = override["max" + _Width] = Math.ceil(bounds.width) + _px;
	          override[_height] = override["max" + _Height] = Math.ceil(bounds.height) + _px;
	          override[_margin] = override[_margin + _Top] = override[_margin + _Right] = override[_margin + _Bottom] = override[_margin + _Left] = "0";
	          override[_padding] = cs[_padding];
	          override[_padding + _Top] = cs[_padding + _Top];
	          override[_padding + _Right] = cs[_padding + _Right];
	          override[_padding + _Bottom] = cs[_padding + _Bottom];
	          override[_padding + _Left] = cs[_padding + _Left];
	          pinActiveState = _copyState(pinOriginalState, override, pinReparent);
	        }

	        if (animation) {
	          initted = animation._initted;

	          _suppressOverwrites(1);

	          animation.render(animation.duration(), true, true);
	          pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
	          change !== pinChange && pinActiveState.splice(pinActiveState.length - 2, 2);
	          animation.render(0, true, true);
	          initted || animation.invalidate();

	          _suppressOverwrites(0);
	        } else {
	          pinChange = change;
	        }
	      } else if (trigger && scrollFunc() && !containerAnimation) {
	        bounds = trigger.parentNode;

	        while (bounds && bounds !== _body) {
	          if (bounds._pinOffset) {
	            start -= bounds._pinOffset;
	            end -= bounds._pinOffset;
	          }

	          bounds = bounds.parentNode;
	        }
	      }

	      revertedPins && revertedPins.forEach(function (t) {
	        return t.revert(false);
	      });
	      self.start = start;
	      self.end = end;
	      scroll1 = scroll2 = scrollFunc();

	      if (!containerAnimation) {
	        scroll1 < prevScroll && scrollFunc(prevScroll);
	        self.scroll.rec = 0;
	      }

	      self.revert(false);
	      _refreshing = 0;
	      animation && isToggle && animation._initted && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress, true).render(animation.time(), true, true);

	      if (prevProgress !== self.progress) {
	        animation && !isToggle && animation.totalProgress(prevProgress, true);
	        self.progress = prevProgress;
	        self.update(0, 0, 1);
	      }

	      pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
	      onRefresh && onRefresh(self);
	    };

	    self.getVelocity = function () {
	      return (scrollFunc() - scroll2) / (_getTime() - _time2) * 1000 || 0;
	    };

	    self.endAnimation = function () {
	      _endAnimation(self.callbackAnimation);

	      if (animation) {
	        scrubTween ? scrubTween.progress(1) : !animation.paused() ? _endAnimation(animation, animation.reversed()) : isToggle || _endAnimation(animation, self.direction < 0, 1);
	      }
	    };

	    self.getTrailing = function (name) {
	      var i = _triggers.indexOf(self),
	          a = self.direction > 0 ? _triggers.slice(0, i).reverse() : _triggers.slice(i + 1);

	      return _isString(name) ? a.filter(function (t) {
	        return t.vars.preventOverlaps === name;
	      }) : a;
	    };

	    self.update = function (reset, recordVelocity, forceFake) {
	      if (containerAnimation && !forceFake && !reset) {
	        return;
	      }

	      var scroll = self.scroll(),
	          p = reset ? 0 : (scroll - start) / change,
	          clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0,
	          prevProgress = self.progress,
	          isActive,
	          wasActive,
	          toggleState,
	          action,
	          stateChanged,
	          toggled,
	          isAtMax,
	          isTakingAction;

	      if (recordVelocity) {
	        scroll2 = scroll1;
	        scroll1 = containerAnimation ? scrollFunc() : scroll;

	        if (snap) {
	          snap2 = snap1;
	          snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
	        }
	      }

	      anticipatePin && !clipped && pin && !_refreshing && !_startup && _lastScrollTime && start < scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin && (clipped = 0.0001);

	      if (clipped !== prevProgress && self.enabled) {
	        isActive = self.isActive = !!clipped && clipped < 1;
	        wasActive = !!prevProgress && prevProgress < 1;
	        toggled = isActive !== wasActive;
	        stateChanged = toggled || !!clipped !== !!prevProgress;
	        self.direction = clipped > prevProgress ? 1 : -1;
	        self.progress = clipped;

	        if (stateChanged && !_refreshing) {
	          toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3;

	          if (isToggle) {
	            action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState];
	            isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
	          }
	        }

	        preventOverlaps && toggled && (isTakingAction || scrub || !animation) && (_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function (t) {
	          return t.endAnimation();
	        }));

	        if (!isToggle) {
	          if (scrubTween && !_refreshing && !_startup) {
	            scrubTween.vars.totalProgress = clipped;
	            scrubTween.invalidate().restart();
	          } else if (animation) {
	            animation.totalProgress(clipped, !!_refreshing);
	          }
	        }

	        if (pin) {
	          reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);

	          if (!useFixedPosition) {
	            pinSetter(pinStart + pinChange * clipped);
	          } else if (stateChanged) {
	            isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= _maxScroll(scroller, direction);

	            if (pinReparent) {
	              if (!reset && (isActive || isAtMax)) {
	                var bounds = _getBounds(pin, true),
	                    _offset = scroll - start;

	                _reparent(pin, _body, bounds.top + (direction === _vertical ? _offset : 0) + _px, bounds.left + (direction === _vertical ? 0 : _offset) + _px);
	              } else {
	                _reparent(pin, spacer);
	              }
	            }

	            _setState(isActive || isAtMax ? pinActiveState : pinState);

	            pinChange !== change && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
	          }
	        }

	        snap && !tweenTo.tween && !_refreshing && !_startup && snapDelayedCall.restart(true);
	        toggleClass && (toggled || once && clipped && (clipped < 1 || !_limitCallbacks)) && _toArray(toggleClass.targets).forEach(function (el) {
	          return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
	        });
	        onUpdate && !isToggle && !reset && onUpdate(self);

	        if (stateChanged && !_refreshing) {
	          if (isToggle) {
	            if (isTakingAction) {
	              if (action === "complete") {
	                animation.pause().totalProgress(1);
	              } else if (action === "reset") {
	                animation.restart(true).pause();
	              } else if (action === "restart") {
	                animation.restart(true);
	              } else {
	                animation[action]();
	              }
	            }

	            onUpdate && onUpdate(self);
	          }

	          if (toggled || !_limitCallbacks) {
	            onToggle && toggled && _callback(self, onToggle);
	            callbacks[toggleState] && _callback(self, callbacks[toggleState]);
	            once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0);

	            if (!toggled) {
	              toggleState = clipped === 1 ? 1 : 3;
	              callbacks[toggleState] && _callback(self, callbacks[toggleState]);
	            }
	          }

	          if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > (_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
	            _endAnimation(self.callbackAnimation);

	            scrubTween ? scrubTween.progress(1) : _endAnimation(animation, !clipped, 1);
	          }
	        } else if (isToggle && onUpdate && !_refreshing) {
	          onUpdate(self);
	        }
	      }

	      if (markerEndSetter) {
	        var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
	        markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
	        markerEndSetter(n);
	      }

	      caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
	    };

	    self.enable = function (reset, refresh) {
	      if (!self.enabled) {
	        self.enabled = true;

	        _addListener(scroller, "resize", _onResize);

	        _addListener(scroller, "scroll", _onScroll);

	        onRefreshInit && _addListener(ScrollTrigger, "refreshInit", onRefreshInit);

	        if (reset !== false) {
	          self.progress = prevProgress = 0;
	          scroll1 = scroll2 = lastSnap = scrollFunc();
	        }

	        refresh !== false && self.refresh();
	      }
	    };

	    self.getTween = function (snap) {
	      return snap && tweenTo ? tweenTo.tween : scrubTween;
	    };

	    self.disable = function (reset, allowAnimation) {
	      if (self.enabled) {
	        reset !== false && self.revert();
	        self.enabled = self.isActive = false;
	        allowAnimation || scrubTween && scrubTween.pause();
	        prevScroll = 0;
	        pinCache && (pinCache.uncache = 1);
	        onRefreshInit && _removeListener(ScrollTrigger, "refreshInit", onRefreshInit);

	        if (snapDelayedCall) {
	          snapDelayedCall.pause();
	          tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
	        }

	        if (!isViewport) {
	          var i = _triggers.length;

	          while (i--) {
	            if (_triggers[i].scroller === scroller && _triggers[i] !== self) {
	              return;
	            }
	          }

	          _removeListener(scroller, "resize", _onResize);

	          _removeListener(scroller, "scroll", _onScroll);
	        }
	      }
	    };

	    self.kill = function (revert, allowAnimation) {
	      self.disable(revert, allowAnimation);
	      scrubTween && scrubTween.kill();
	      id && delete _ids[id];

	      var i = _triggers.indexOf(self);

	      _triggers.splice(i, 1);

	      i === _i && _direction > 0 && _i--;
	      i = 0;

	      _triggers.forEach(function (t) {
	        return t.scroller === self.scroller && (i = 1);
	      });

	      i || (self.scroll.rec = 0);

	      if (animation) {
	        animation.scrollTrigger = null;
	        revert && animation.render(-1);
	        allowAnimation || animation.kill();
	      }

	      markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
	        return m.parentNode && m.parentNode.removeChild(m);
	      });

	      if (pin) {
	        pinCache && (pinCache.uncache = 1);
	        i = 0;

	        _triggers.forEach(function (t) {
	          return t.pin === pin && i++;
	        });

	        i || (pinCache.spacer = 0);
	      }
	    };

	    self.enable(false, false);
	    !animation || !animation.add || change ? self.refresh() : gsap.delayedCall(0.01, function () {
	      return start || end || self.refresh();
	    }) && (change = 0.01) && (start = end = 0);
	  };

	  ScrollTrigger.register = function register(core) {
	    if (!_coreInitted) {
	      gsap = core || _getGSAP();

	      if (_windowExists() && window.document) {
	        _win = window;
	        _doc = document;
	        _docEl = _doc.documentElement;
	        _body = _doc.body;
	      }

	      if (gsap) {
	        _toArray = gsap.utils.toArray;
	        _clamp = gsap.utils.clamp;
	        _suppressOverwrites = gsap.core.suppressOverwrites || _passThrough;
	        gsap.core.globals("ScrollTrigger", ScrollTrigger);

	        if (_body) {
	          _raf = _win.requestAnimationFrame || function (f) {
	            return setTimeout(f, 16);
	          };

	          _addListener(_win, "wheel", _onScroll);

	          _root = [_win, _doc, _docEl, _body];

	          _addListener(_doc, "scroll", _onScroll);

	          var bodyStyle = _body.style,
	              border = bodyStyle.borderTopStyle,
	              bounds;
	          bodyStyle.borderTopStyle = "solid";
	          bounds = _getBounds(_body);
	          _vertical.m = Math.round(bounds.top + _vertical.sc()) || 0;
	          _horizontal.m = Math.round(bounds.left + _horizontal.sc()) || 0;
	          border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
	          _syncInterval = setInterval(_sync, 200);
	          gsap.delayedCall(0.5, function () {
	            return _startup = 0;
	          });

	          _addListener(_doc, "touchcancel", _passThrough);

	          _addListener(_body, "touchstart", _passThrough);

	          _multiListener(_addListener, _doc, "pointerdown,touchstart,mousedown", function () {
	            return _pointerIsDown = 1;
	          });

	          _multiListener(_addListener, _doc, "pointerup,touchend,mouseup", function () {
	            return _pointerIsDown = 0;
	          });

	          _transformProp = gsap.utils.checkPrefix("transform");

	          _stateProps.push(_transformProp);

	          _coreInitted = _getTime();
	          _resizeDelay = gsap.delayedCall(0.2, _refreshAll).pause();
	          _autoRefresh = [_doc, "visibilitychange", function () {
	            var w = _win.innerWidth,
	                h = _win.innerHeight;

	            if (_doc.hidden) {
	              _prevWidth = w;
	              _prevHeight = h;
	            } else if (_prevWidth !== w || _prevHeight !== h) {
	              _onResize();
	            }
	          }, _doc, "DOMContentLoaded", _refreshAll, _win, "load", function () {
	            return _lastScrollTime || _refreshAll();
	          }, _win, "resize", _onResize];

	          _iterateAutoRefresh(_addListener);
	        }
	      }
	    }

	    return _coreInitted;
	  };

	  ScrollTrigger.defaults = function defaults(config) {
	    for (var p in config) {
	      _defaults[p] = config[p];
	    }
	  };

	  ScrollTrigger.kill = function kill() {
	    _enabled = 0;

	    _triggers.slice(0).forEach(function (trigger) {
	      return trigger.kill(1);
	    });
	  };

	  ScrollTrigger.config = function config(vars) {
	    "limitCallbacks" in vars && (_limitCallbacks = !!vars.limitCallbacks);
	    var ms = vars.syncInterval;
	    ms && clearInterval(_syncInterval) || (_syncInterval = ms) && setInterval(_sync, ms);

	    if ("autoRefreshEvents" in vars) {
	      _iterateAutoRefresh(_removeListener) || _iterateAutoRefresh(_addListener, vars.autoRefreshEvents || "none");
	      _ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
	    }
	  };

	  ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
	    var t = _getTarget(target),
	        i = _scrollers.indexOf(t),
	        isViewport = _isViewport(t);

	    if (~i) {
	      _scrollers.splice(i, isViewport ? 6 : 2);
	    }

	    isViewport ? _proxies.unshift(_win, vars, _body, vars, _docEl, vars) : _proxies.unshift(t, vars);
	  };

	  ScrollTrigger.matchMedia = function matchMedia(vars) {
	    var mq, p, i, func, result;

	    for (p in vars) {
	      i = _media.indexOf(p);
	      func = vars[p];
	      _creatingMedia = p;

	      if (p === "all") {
	        func();
	      } else {
	        mq = _win.matchMedia(p);

	        if (mq) {
	          mq.matches && (result = func());

	          if (~i) {
	            _media[i + 1] = _combineFunc(_media[i + 1], func);
	            _media[i + 2] = _combineFunc(_media[i + 2], result);
	          } else {
	            i = _media.length;

	            _media.push(p, func, result);

	            mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
	          }

	          _media[i + 3] = mq.matches;
	        }
	      }

	      _creatingMedia = 0;
	    }

	    return _media;
	  };

	  ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
	    query || (_media.length = 0);
	    query = _media.indexOf(query);
	    query >= 0 && _media.splice(query, 4);
	  };

	  ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
	    var bounds = (_isString(element) ? _getTarget(element) : element).getBoundingClientRect(),
	        offset = bounds[horizontal ? _width : _height] * ratio || 0;
	    return horizontal ? bounds.right - offset > 0 && bounds.left + offset < _win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < _win.innerHeight;
	  };

	  ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
	    _isString(element) && (element = _getTarget(element));
	    var bounds = element.getBoundingClientRect(),
	        size = bounds[horizontal ? _width : _height],
	        offset = referencePoint == null ? size / 2 : referencePoint in _keywords ? _keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
	    return horizontal ? (bounds.left + offset) / _win.innerWidth : (bounds.top + offset) / _win.innerHeight;
	  };

	  return ScrollTrigger;
	}();
	ScrollTrigger.version = "3.8.0";

	ScrollTrigger.saveStyles = function (targets) {
	  return targets ? _toArray(targets).forEach(function (target) {
	    if (target && target.style) {
	      var i = _savedStyles.indexOf(target);

	      i >= 0 && _savedStyles.splice(i, 5);

	      _savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), gsap.core.getCache(target), _creatingMedia);
	    }
	  }) : _savedStyles;
	};

	ScrollTrigger.revert = function (soft, media) {
	  return _revertAll(!soft, media);
	};

	ScrollTrigger.create = function (vars, animation) {
	  return new ScrollTrigger(vars, animation);
	};

	ScrollTrigger.refresh = function (safe) {
	  return safe ? _onResize() : (_coreInitted || ScrollTrigger.register()) && _refreshAll(true);
	};

	ScrollTrigger.update = _updateAll;
	ScrollTrigger.clearScrollMemory = _clearScrollMemory;

	ScrollTrigger.maxScroll = function (element, horizontal) {
	  return _maxScroll(element, horizontal ? _horizontal : _vertical);
	};

	ScrollTrigger.getScrollFunc = function (element, horizontal) {
	  return _getScrollFunc(_getTarget(element), horizontal ? _horizontal : _vertical);
	};

	ScrollTrigger.getById = function (id) {
	  return _ids[id];
	};

	ScrollTrigger.getAll = function () {
	  return _triggers.slice(0);
	};

	ScrollTrigger.isScrolling = function () {
	  return !!_lastScrollTime;
	};

	ScrollTrigger.snapDirectional = _snapDirectional;

	ScrollTrigger.addEventListener = function (type, callback) {
	  var a = _listeners[type] || (_listeners[type] = []);
	  ~a.indexOf(callback) || a.push(callback);
	};

	ScrollTrigger.removeEventListener = function (type, callback) {
	  var a = _listeners[type],
	      i = a && a.indexOf(callback);
	  i >= 0 && a.splice(i, 1);
	};

	ScrollTrigger.batch = function (targets, vars) {
	  var result = [],
	      varsCopy = {},
	      interval = vars.interval || 0.016,
	      batchMax = vars.batchMax || 1e9,
	      proxyCallback = function proxyCallback(type, callback) {
	    var elements = [],
	        triggers = [],
	        delay = gsap.delayedCall(interval, function () {
	      callback(elements, triggers);
	      elements = [];
	      triggers = [];
	    }).pause();
	    return function (self) {
	      elements.length || delay.restart(true);
	      elements.push(self.trigger);
	      triggers.push(self);
	      batchMax <= elements.length && delay.progress(1);
	    };
	  },
	      p;

	  for (p in vars) {
	    varsCopy[p] = p.substr(0, 2) === "on" && _isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
	  }

	  if (_isFunction(batchMax)) {
	    batchMax = batchMax();

	    _addListener(ScrollTrigger, "refresh", function () {
	      return batchMax = vars.batchMax();
	    });
	  }

	  _toArray(targets).forEach(function (target) {
	    var config = {};

	    for (p in varsCopy) {
	      config[p] = varsCopy[p];
	    }

	    config.trigger = target;
	    result.push(ScrollTrigger.create(config));
	  });

	  return result;
	};

	ScrollTrigger.sort = function (func) {
	  return _triggers.sort(func || function (a, b) {
	    return (a.vars.refreshPriority || 0) * -1e6 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1e6);
	  });
	};

	_getGSAP() && gsap.registerPlugin(ScrollTrigger);

	exports.ScrollTrigger = ScrollTrigger;
	exports.default = ScrollTrigger;

	Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 4682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ gsapWithCSS; },
  "p8": function() { return /* binding */ gsapWithCSS; }
});

// UNUSED EXPORTS: Back, Bounce, CSSPlugin, Circ, Cubic, Elastic, Expo, Linear, Power0, Power1, Power2, Power3, Power4, Quad, Quart, Quint, Sine, SteppedEase, Strong, TimelineLite, TimelineMax, TweenLite, TweenMax

;// CONCATENATED MODULE: ../../node_modules/gsap/gsap-core.js
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/*!
 * GSAP 3.8.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
},
    _defaults = {
  duration: .5,
  overwrite: false,
  delay: 0
},
    _suppressOverwrites,
    _bigNum = 1e8,
    _tinyNum = 1 / _bigNum,
    _2PI = Math.PI * 2,
    _HALF_PI = _2PI / 4,
    _gsID = 0,
    _sqrt = Math.sqrt,
    _cos = Math.cos,
    _sin = Math.sin,
    _isString = function _isString(value) {
  return typeof value === "string";
},
    _isFunction = function _isFunction(value) {
  return typeof value === "function";
},
    _isNumber = function _isNumber(value) {
  return typeof value === "number";
},
    _isUndefined = function _isUndefined(value) {
  return typeof value === "undefined";
},
    _isObject = function _isObject(value) {
  return typeof value === "object";
},
    _isNotFalse = function _isNotFalse(value) {
  return value !== false;
},
    _windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _isFuncOrString = function _isFuncOrString(value) {
  return _isFunction(value) || _isString(value);
},
    _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
    // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray,
    _strictNumExp = /(?:-?\.?\d|\.)+/gi,
    //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/,
    _delimitedValueExp = /[^,'"\[\]\s]+/gi,
    // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /[\d.+\-=]+(?:e[-+]\d*)*/i,
    _globalTimeline,
    _win,
    _coreInitted,
    _doc,
    _globals = {},
    _installScope = {},
    _coreReady,
    _install = function _install(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
},
    _missingPlugin = function _missingPlugin(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
},
    _warn = function _warn(message, suppress) {
  return !suppress && console.warn(message);
},
    _addGlobal = function _addGlobal(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
},
    _emptyFunc = function _emptyFunc() {
  return 0;
},
    _reservedProps = {},
    _lazyTweens = [],
    _lazyLookup = {},
    _lastRenderedFrame,
    _plugins = {},
    _effects = {},
    _nextGCFrame = 30,
    _harnessPlugins = [],
    _callbackNames = "",
    _harness = function _harness(targets) {
  var target = targets[0],
      harnessPlugin,
      i;
  _isObject(target) || _isFunction(target) || (targets = [targets]);

  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
    i = _harnessPlugins.length;

    while (i-- && !_harnessPlugins[i].targetTest(target)) {}

    harnessPlugin = _harnessPlugins[i];
  }

  i = targets.length;

  while (i--) {
    targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
  }

  return targets;
},
    _getCache = function _getCache(target) {
  return target._gsap || _harness(toArray(target))[0]._gsap;
},
    _getProperty = function _getProperty(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
},
    _forEachName = function _forEachName(names, func) {
  return (names = names.split(",")).forEach(func) || names;
},
    //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
  return Math.round(value * 100000) / 100000 || 0;
},
    _roundPrecise = function _roundPrecise(value) {
  return Math.round(value * 10000000) / 10000000 || 0;
},
    // increased precision mostly for timing values.
_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
  //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
  var l = toFind.length,
      i = 0;

  for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

  return i < l;
},
    _lazyRender = function _lazyRender() {
  var l = _lazyTweens.length,
      a = _lazyTweens.slice(0),
      i,
      tween;

  _lazyLookup = {};
  _lazyTweens.length = 0;

  for (i = 0; i < l; i++) {
    tween = a[i];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
},
    _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
  _lazyTweens.length && _lazyRender();
  animation.render(time, suppressEvents, force);
  _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
},
    _numericIfPossible = function _numericIfPossible(value) {
  var n = parseFloat(value);
  return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
},
    _passThrough = function _passThrough(p) {
  return p;
},
    _setDefaults = function _setDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || (obj[p] = defaults[p]);
  }

  return obj;
},
    _setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || p === "duration" || p === "ease" || (obj[p] = defaults[p]);
  }
},
    _merge = function _merge(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }

  return base;
},
    _mergeDeep = function _mergeDeep(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }

  return base;
},
    _copyExcluding = function _copyExcluding(obj, excluding) {
  var copy = {},
      p;

  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }

  return copy;
},
    _inheritDefaults = function _inheritDefaults(vars) {
  var parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults : _setDefaults;

  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }

  return vars;
},
    _arraysMatch = function _arraysMatch(a1, a2) {
  var i = a1.length,
      match = i === a2.length;

  while (match && i-- && a1[i] === a2[i]) {}

  return i < 0;
},
    _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = parent[lastProp],
      t;

  if (sortBy) {
    t = child[sortBy];

    while (prev && prev[sortBy] > t) {
      prev = prev._prev;
    }
  }

  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }

  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }

  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
},
    _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = child._prev,
      next = child._next;

  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }

  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }

  child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
},
    _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
  child._act = 0;
},
    _uncache = function _uncache(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
    var a = animation;

    while (a) {
      a._dirty = 1;
      a = a.parent;
    }
  }

  return animation;
},
    _recacheAncestors = function _recacheAncestors(animation) {
  var parent = animation.parent;

  while (parent && parent.parent) {
    //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }

  return animation;
},
    _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
},
    _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
},
    // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
},
    _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
},
    _setEnd = function _setEnd(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
},
    _alignPlayhead = function _alignPlayhead(animation, totalTime) {
  // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
  var parent = animation._dp;

  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

    _setEnd(animation);

    parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
  }

  return animation;
},

/*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/
_postAddChecks = function _postAddChecks(timeline, child) {
  var t;

  if (child._time || child._initted && !child._dur) {
    //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
    t = _parentToChildTotalTime(timeline.rawTime(), child);

    if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
      child.render(t, true);
    }
  } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.


  if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
    //in case any of the ancestors had completed but should now be enabled...
    if (timeline._dur < timeline.duration()) {
      t = timeline;

      while (t._dp) {
        t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.

        t = t._dp;
      }
    }

    timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
  }
},
    _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

  _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

  _isFromOrFromStart(child) || (timeline._recent = child);
  skipChecks || _postAddChecks(timeline, child);
  return timeline;
},
    _scrollTrigger = function _scrollTrigger(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
},
    _attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
  _initTween(tween, totalTime);

  if (!tween._initted) {
    return 1;
  }

  if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);

    tween._lazy = [totalTime, suppressEvents];
    return 1;
  }
},
    _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
},
    // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
},
    _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio,
      ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
      // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
  repeatDelay = tween._rDelay,
      tTime = 0,
      pt,
      iteration,
      prevIteration;

  if (repeatDelay && tween._repeat) {
    // in case there's a zero-duration tween that has a repeat with a repeatDelay
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    prevIteration = _animationCycle(tween._tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

    if (iteration !== prevIteration) {
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }

  if (ratio !== prevRatio || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents)) {
      // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
      return;
    }

    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

    suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.

    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }

    tween._startAt && totalTime < 0 && tween._startAt.render(totalTime, true, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);

      if (!suppressEvents) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
},
    _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
  var child;

  if (time > prevTime) {
    child = animation._first;

    while (child && child._start <= time) {
      if (!child._dur && child.data === "isPause" && child._start > prevTime) {
        return child;
      }

      child = child._next;
    }
  } else {
    child = animation._last;

    while (child && child._start >= time) {
      if (!child._dur && child.data === "isPause" && child._start < prevTime) {
        return child;
      }

      child = child._prev;
    }
  }
},
    _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
  var repeat = animation._repeat,
      dur = _roundPrecise(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress && !leavePlayhead ? _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress) : animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
},
    _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
},
    _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
},
    _parsePosition = function _parsePosition(animation, position, percentAnimation) {
  var labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
      //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
  i,
      offset,
      isPercent;

  if (_isString(position) && (isNaN(position) || position in labels)) {
    //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i = position.indexOf("=");

    if (offset === "<" || offset === ">") {
      i >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }

    if (i < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }

    offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }

    return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
  }

  return position == null ? clippedDuration : +position;
},
    _createTweenType = function _createTweenType(type, params, timeline) {
  var isLegacy = _isNumber(params[1]),
      varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
      vars = params[varsIndex],
      irVars,
      parent;

  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline;

  if (type) {
    irVars = vars;
    parent = timeline;

    while (parent && !("immediateRender" in irVars)) {
      // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }

    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
  }

  return new Tween(params[0], vars, params[varsIndex + 1]);
},
    _conditionalReturn = function _conditionalReturn(value, func) {
  return value || value === 0 ? func(value) : func;
},
    _clamp = function _clamp(min, max, value) {
  return value < min ? min : value > max ? max : value;
},
    getUnit = function getUnit(value) {
  if (typeof value !== "string") {
    return "";
  }

  var v = _unitExp.exec(value);

  return v ? value.substr(v.index + v[0].length) : "";
},
    // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
  return _conditionalReturn(value, function (v) {
    return _clamp(min, max, v);
  });
},
    _slice = [].slice,
    _isArrayLike = function _isArrayLike(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
},
    _flatten = function _flatten(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }

  return ar.forEach(function (value) {
    var _accumulator;

    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
  }) || accumulator;
},
    //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
  return _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
},
    selector = function selector(value) {
  value = toArray(value)[0] || _warn("Invalid scope") || {};
  return function (v) {
    var el = value.current || value.nativeElement || value;
    return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
  };
},
    shuffle = function shuffle(a) {
  return a.sort(function () {
    return .5 - Math.random();
  });
},
    // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
  if (_isFunction(v)) {
    return v;
  }

  var vars = _isObject(v) ? v : {
    each: v
  },
      //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  ease = _parseEase(vars.ease),
      from = vars.from || 0,
      base = parseFloat(vars.base) || 0,
      cache = {},
      isDecimal = from > 0 && from < 1,
      ratios = isNaN(from) || isDecimal,
      axis = vars.axis,
      ratioX = from,
      ratioY = from;

  if (_isString(from)) {
    ratioX = ratioY = {
      center: .5,
      edges: .5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }

  return function (i, target, a) {
    var l = (a || vars).length,
        distances = cache[l],
        originX,
        originY,
        x,
        y,
        d,
        j,
        max,
        min,
        wrapAt;

    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];

      if (!wrapAt) {
        max = -_bigNum;

        while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

        wrapAt--;
      }

      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
      originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum;

      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }

      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0; //unit

      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }

    l = (distances[i] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  };
},
    _roundModifier = function _roundModifier(v) {
  //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())

  return function (raw) {
    var n = Math.round(parseFloat(raw) / v) * v * p;
    return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  };
},
    snap = function snap(snapTo, value) {
  var isArray = _isArray(snapTo),
      radius,
      is2D;

  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum;

    if (snapTo.values) {
      snapTo = toArray(snapTo.values);

      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }

  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function (raw) {
    var x = parseFloat(is2D ? raw.x : raw),
        y = parseFloat(is2D ? raw.y : 0),
        min = _bigNum,
        closest = 0,
        i = snapTo.length,
        dx,
        dy;

    while (i--) {
      if (is2D) {
        dx = snapTo[i].x - x;
        dy = snapTo[i].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i] - x);
      }

      if (dx < min) {
        min = dx;
        closest = i;
      }
    }

    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
},
    random = function random(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
},
    pipe = function pipe() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (value) {
    return functions.reduce(function (v, f) {
      return f(v);
    }, value);
  };
},
    unitize = function unitize(func, unit) {
  return function (value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
},
    normalize = function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value);
},
    _wrapArray = function _wrapArray(a, wrapper, value) {
  return _conditionalReturn(value, function (index) {
    return a[~~wrapper(index)];
  });
},
    wrap = function wrap(min, max, value) {
  // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
    return (range + (value - min) % range) % range + min;
  });
},
    wrapYoyo = function wrapYoyo(min, max, value) {
  var range = max - min,
      total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
    value = (total + (value - min) % total) % total || 0;
    return min + (value > range ? total - value : value);
  });
},
    _replaceRandom = function _replaceRandom(value) {
  //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
  var prev = 0,
      s = "",
      i,
      nums,
      end,
      isArray;

  while (~(i = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i);
    isArray = value.charAt(i + 7) === "[";
    nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }

  return s + value.substr(prev, value.length - prev);
},
    mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin,
      outRange = outMax - outMin;
  return _conditionalReturn(value, function (value) {
    return outMin + ((value - inMin) / inRange * outRange || 0);
  });
},
    interpolate = function interpolate(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function (p) {
    return (1 - p) * start + p * end;
  };

  if (!func) {
    var isString = _isString(start),
        master = {},
        p,
        i,
        interpolators,
        l,
        il;

    progress === true && (mutate = 1) && (progress = null);

    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;

      for (i = 1; i < l; i++) {
        interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
      }

      l--;

      func = function func(p) {
        p *= l;
        var i = Math.min(il, ~~p);
        return interpolators[i](p - i);
      };

      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }

    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }

      func = function func(p) {
        return _renderPropTweens(p, master) || (isString ? start.p : start);
      };
    }
  }

  return _conditionalReturn(progress, func);
},
    _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
  //used for nextLabel() and previousLabel()
  var labels = timeline.labels,
      min = _bigNum,
      p,
      distance,
      label;

  for (p in labels) {
    distance = labels[p] - fromTime;

    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }

  return label;
},
    _callback = function _callback(animation, type, executeLazyFirst) {
  var v = animation.vars,
      callback = v[type],
      params,
      scope;

  if (!callback) {
    return;
  }

  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.

  return params ? callback.apply(scope, params) : callback.call(scope);
},
    _interrupt = function _interrupt(animation) {
  _removeFromParent(animation);

  animation.scrollTrigger && animation.scrollTrigger.kill(false);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
},
    _quickTween,
    _createPlugin = function _createPlugin(config) {
  config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.

  var name = config.name,
      isFunc = _isFunction(config),
      Plugin = name && !isFunc && config.init ? function () {
    this._props = [];
  } : config,
      //in case someone passes in an object that's not a plugin, like CustomEase
  instanceDefaults = {
    init: _emptyFunc,
    render: _renderPropTweens,
    add: _addPropTween,
    kill: _killPropTweensOf,
    modifier: _addPluginModifier,
    rawVars: 0
  },
      statics = {
    targetTest: 0,
    get: 0,
    getSetter: _getSetter,
    aliases: {},
    register: 0
  };

  _wake();

  if (config !== Plugin) {
    if (_plugins[name]) {
      return;
    }

    _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods


    _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods


    _plugins[Plugin.prop = name] = Plugin;

    if (config.targetTest) {
      _harnessPlugins.push(Plugin);

      _reservedProps[name] = 1;
    }

    name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
  }

  _addGlobal(name, Plugin);

  config.register && config.register(gsap, Plugin, PropTween);
},

/*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */
_255 = 255,
    _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
},
    _hue = function _hue(h, m1, m2) {
  h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
},
    splitColor = function splitColor(v, toHSL, forceAlpha) {
  var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
      r,
      g,
      b,
      h,
      s,
      l,
      max,
      min,
      d,
      wasHSL;

  if (!a) {
    if (v.substr(-1) === ",") {
      //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
      v = v.substr(0, v.length - 1);
    }

    if (_colorLookup[v]) {
      a = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        //for shorthand like #9F0 or #9F0F (could have alpha)
        r = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }

      if (v.length === 9) {
        // hex with alpha, like #fd5e53ff
        a = parseInt(v.substr(1, 6), 16);
        return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
      }

      v = parseInt(v.substr(1), 16);
      a = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a = wasHSL = v.match(_strictNumExp);

      if (!toHSL) {
        h = +a[0] % 360 / 360;
        s = +a[1] / 100;
        l = +a[2] / 100;
        g = l <= .5 ? l * (s + 1) : l + s - l * s;
        r = l * 2 - g;
        a.length > 3 && (a[3] *= 1); //cast as number

        a[0] = _hue(h + 1 / 3, r, g);
        a[1] = _hue(h, r, g);
        a[2] = _hue(h - 1 / 3, r, g);
      } else if (~v.indexOf("=")) {
        //if relative values are found, just return the raw strings with the relative prefixes in place.
        a = v.match(_numExp);
        forceAlpha && a.length < 4 && (a[3] = 1);
        return a;
      }
    } else {
      a = v.match(_strictNumExp) || _colorLookup.transparent;
    }

    a = a.map(Number);
  }

  if (toHSL && !wasHSL) {
    r = a[0] / _255;
    g = a[1] / _255;
    b = a[2] / _255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }

    a[0] = ~~(h + .5);
    a[1] = ~~(s * 100 + .5);
    a[2] = ~~(l * 100 + .5);
  }

  forceAlpha && a.length < 4 && (a[3] = 1);
  return a;
},
    _colorOrderData = function _colorOrderData(v) {
  // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
  var values = [],
      c = [],
      i = -1;
  v.split(_colorExp).forEach(function (v) {
    var a = v.match(_numWithUnitExp) || [];
    values.push.apply(values, a);
    c.push(i += a.length + 1);
  });
  values.c = c;
  return values;
},
    _formatColors = function _formatColors(s, toHSL, orderMatchData) {
  var result = "",
      colors = (s + result).match(_colorExp),
      type = toHSL ? "hsla(" : "rgba(",
      i = 0,
      c,
      shell,
      d,
      l;

  if (!colors) {
    return s;
  }

  colors = colors.map(function (color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });

  if (orderMatchData) {
    d = _colorOrderData(s);
    c = orderMatchData.c;

    if (c.join(result) !== d.c.join(result)) {
      shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }

  if (!shell) {
    shell = s.split(_colorExp);
    l = shell.length - 1;

    for (; i < l; i++) {
      result += shell[i] + colors[i];
    }
  }

  return result + shell[l];
},
    _colorExp = function () {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
      //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
  p;

  for (p in _colorLookup) {
    s += "|" + p + "\\b";
  }

  return new RegExp(s + ")", "gi");
}(),
    _hslExp = /hsl[a]?\(/,
    _colorStringFilter = function _colorStringFilter(a) {
  var combined = a.join(" "),
      toHSL;
  _colorExp.lastIndex = 0;

  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a[1] = _formatColors(a[1], toHSL);
    a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.

    return true;
  }
},

/*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */
_tickerActive,
    _ticker = function () {
  var _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners = [],
      _id,
      _req,
      _raf,
      _self,
      _delta,
      _i,
      _tick = function _tick(v) {
    var elapsed = _getTime() - _lastUpdate,
        manual = v === true,
        overlap,
        dispatch,
        time,
        frame;

    elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;

    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1000;
      _self.time = time = time / 1000;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }

    manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.

    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };

  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1000 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists()) {
          _win = _coreInitted = window;
          _doc = _win.document || {};
          _globals.gsap = gsap;
          (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);

          _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});

          _raf = _win.requestAnimationFrame;
        }

        _id && _self.sleep();

        _req = _raf || function (f) {
          return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
        };

        _tickerActive = 1;

        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || 1 / _tinyNum; //zero should be interpreted as basically unlimited

      _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
    },
    fps: function fps(_fps) {
      _gap = 1000 / (_fps || 240);
      _nextTime = _self.time * 1000 + _gap;
    },
    add: function add(callback) {
      _listeners.indexOf(callback) < 0 && _listeners.push(callback);

      _wake();
    },
    remove: function remove(callback) {
      var i;
      ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
    },
    _listeners: _listeners
  };
  return _self;
}(),
    _wake = function _wake() {
  return !_tickerActive && _ticker.wake();
},
    //also ensures the core classes are initialized.

/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/
_easeMap = {},
    _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
    _quotesExp = /["']/g,
    _parseObjectInString = function _parseObjectInString(value) {
  //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
  var obj = {},
      split = value.substr(1, value.length - 3).split(":"),
      key = split[0],
      i = 1,
      l = split.length,
      index,
      val,
      parsedVal;

  for (; i < l; i++) {
    val = split[i];
    index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }

  return obj;
},
    _valueInParentheses = function _valueInParentheses(value) {
  var open = value.indexOf("(") + 1,
      close = value.indexOf(")"),
      nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
},
    _configEaseFromString = function _configEaseFromString(name) {
  //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
  var split = (name + "").split("("),
      ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
},
    _invertEase = function _invertEase(ease) {
  return function (p) {
    return 1 - ease(1 - p);
  };
},
    // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
  var child = timeline._first,
      ease;

  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }

    child = child._next;
  }
},
    _parseEase = function _parseEase(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
},
    _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut(p) {
      return 1 - easeIn(1 - p);
    };
  }

  if (easeInOut === void 0) {
    easeInOut = function easeInOut(p) {
      return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }

  var ease = {
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut
  },
      lowercaseName;

  _forEachName(names, function (name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });

  return ease;
},
    _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
  return function (p) {
    return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
  };
},
    _configElastic = function _configElastic(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1,
      //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
  p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = function easeOut(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  p2 = _2PI / p2; //precalculate to optimize

  ease.config = function (amplitude, period) {
    return _configElastic(type, amplitude, period);
  };

  return ease;
},
    _configBack = function _configBack(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }

  var easeOut = function easeOut(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  ease.config = function (overshoot) {
    return _configBack(type, overshoot);
  };

  return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };


_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
  var power = i < 5 ? i + 1 : i;

  _insertEase(name + ",Power" + (power - 1), i ? function (p) {
    return Math.pow(p, power);
  } : function (p) {
    return p;
  }, function (p) {
    return 1 - Math.pow(1 - p, power);
  }, function (p) {
    return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});

_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

(function (n, c) {
  var n1 = 1 / c,
      n2 = 2 * n1,
      n3 = 2.5 * n1,
      easeOut = function easeOut(p) {
    return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
  };

  _insertEase("Bounce", function (p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);

_insertEase("Expo", function (p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});

_insertEase("Circ", function (p) {
  return -(_sqrt(1 - p * p) - 1);
});

_insertEase("Sine", function (p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});

_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }

    var p1 = 1 / steps,
        p2 = steps + (immediateStart ? 0 : 1),
        p3 = immediateStart ? 1 : 0,
        max = 1 - _tinyNum;
    return function (p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];

_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
  return _callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */


var GSCache = function GSCache(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

var Animation = /*#__PURE__*/function () {
  function Animation(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;

    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }

    this._ts = 1;

    _setDuration(this, +vars.duration, 1, 1);

    this.data = vars.data;
    _tickerActive || _ticker.wake();
  }

  var _proto = Animation.prototype;

  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }

    return this._delay;
  };

  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };

  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };

  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();

    if (!arguments.length) {
      return this._tTime;
    }

    var parent = this._dp;

    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);

      !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
      //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.

      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }

        parent = parent.parent;
      }

      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }

    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
      this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
      //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
      //   this._lock = 1;

      _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
      //}

    }

    return this;
  };

  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
  };

  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
  };

  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
  };

  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;

    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  } // potential future addition:
  // isPlayingBackwards() {
  // 	let animation = this,
  // 		orientation = 1; // 1 = forward, -1 = backward
  // 	while (animation) {
  // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
  // 		animation = animation.parent;
  // 	}
  // 	return orientation < 0;
  // }
  ;

  _proto.timeScale = function timeScale(value) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }

    if (this._rts === value) {
      return this;
    }

    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
    // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
    //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.

    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.

    _recacheAncestors(this.totalTime(_clamp(-this._delay, this._tDur, tTime), true));

    _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.


    return this;
  };

  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }

    if (this._ps !== value) {
      this._ps = value;

      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.

        this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
      } else {
        _wake();

        this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.

        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
      }
    }

    return this;
  };

  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }

    return this._start;
  };

  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };

  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp; // _dp = detached parent

    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };

  _proto.globalTime = function globalTime(rawTime) {
    var animation = this,
        time = arguments.length ? rawTime : animation.rawTime();

    while (animation) {
      time = animation._start + time / (animation._ts || 1);
      animation = animation._dp;
    }

    return time;
  };

  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }

    return this._repeat === -2 ? Infinity : this._repeat;
  };

  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;

      _onUpdateTotalDuration(this);

      return time ? this.time(time) : this;
    }

    return this._rDelay;
  };

  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }

    return this._yoyo;
  };

  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };

  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };

  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };

  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };

  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };

  _proto.resume = function resume() {
    return this.paused(false);
  };

  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.

      return this;
    }

    return this._rts < 0;
  };

  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };

  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp,
        start = this._start,
        rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };

  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;

    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }

      return this;
    }

    return vars[type];
  };

  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function (resolve) {
      var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
          _resolve = function _resolve() {
        var _then = self.then;
        self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)

        _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
        resolve(f);
        self.then = _then;
      };

      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };

  _proto.kill = function kill() {
    _interrupt(this);
  };

  return Animation;
}();

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */


var Timeline = /*#__PURE__*/function (_Animation) {
  _inheritsLoose(Timeline, _Animation);

  function Timeline(vars, position) {
    var _this;

    if (vars === void 0) {
      vars = {};
    }

    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }

  var _proto2 = Timeline.prototype;

  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);

    return this;
  };

  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);

    return this;
  };

  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);

    return this;
  };

  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };

  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  } //ONLY for backward compatibility! Maybe delete?
  ;

  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };

  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._dirty ? this.totalDuration() : this._tDur,
        dur = this._dur,
        tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
        // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
    crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
        time,
        child,
        next,
        iteration,
        cycleDuration,
        prevPaused,
        pauseTween,
        timeScale,
        prevStart,
        prevIteration,
        yoyo,
        isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005

        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */


        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1,
              doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : dur;
          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.

          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat

          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          } //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.


          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;

        while (child) {
          next = child._next;

          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.

        while (child) {
          next = child._prev;

          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

        if (this._ts) {
          //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.

          _setEnd(this);

          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto2.add = function add(child, position) {
    var _this2 = this;

    _isNumber(position) || (position = _parsePosition(this, position, child));

    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function (obj) {
          return _this2.add(obj, position);
        });
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  };

  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }

    if (tweens === void 0) {
      tweens = true;
    }

    if (timelines === void 0) {
      timelines = true;
    }

    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum;
    }

    var a = [],
        child = this._first;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a.push(child);
        } else {
          timelines && a.push(child);
          nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
        }
      }

      child = child._next;
    }

    return a;
  };

  _proto2.getById = function getById(id) {
    var animations = this.getChildren(1, 1, 1),
        i = animations.length;

    while (i--) {
      if (animations[i].vars.id === id) {
        return animations[i];
      }
    }
  };

  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);

    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  };

  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = 1;

    if (!this._dp && this._ts) {
      //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }

    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

    this._forcing = 0;
    return this;
  };

  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };

  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };

  _proto2.addPause = function addPause(position, callback, params) {
    var t = Tween.delayedCall(0, callback || _emptyFunc, params);
    t.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t, _parsePosition(this, position));
  };

  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);

    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }

      child = child._next;
    }
  };

  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive),
        i = tweens.length;

    while (i--) {
      _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
    }

    return this;
  };

  _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
    var a = [],
        parsedTargets = toArray(targets),
        child = this._first,
        isGlobalTime = _isNumber(onlyActive),
        // a number is interpreted as a global time. If the animation spans
    children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push.apply(a, children);
      }

      child = child._next;
    }

    return a;
  } // potential future feature - targets() on timelines
  // targets() {
  // 	let result = [];
  // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
  // 	return result.filter((v, i) => result.indexOf(v) === i);
  // }
  ;

  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};

    var tl = this,
        endTime = _parsePosition(tl, position),
        _vars = vars,
        startAt = _vars.startAt,
        _onStart = _vars.onStart,
        onStartParams = _vars.onStartParams,
        immediateRender = _vars.immediateRender,
        initted,
        tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();

        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }

        _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
      }
    }, vars));

    return immediateRender ? tween.render(0) : tween;
  };

  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };

  _proto2.recent = function recent() {
    return this._recent;
  };

  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };

  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };

  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };

  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }

    var child = this._first,
        labels = this.labels,
        p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }

      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  };

  _proto2.invalidate = function invalidate() {
    var child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate();
      child = child._next;
    }

    return _Animation.prototype.invalidate.call(this);
  };

  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }

    var child = this._first,
        next;

    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }

    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };

  _proto2.totalDuration = function totalDuration(value) {
    var max = 0,
        self = this,
        child = self._last,
        prevStart = _bigNum,
        prev,
        start,
        parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...

        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.

        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) {
          //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().

          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) {
          //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

      self._dirty = 0;
    }

    return self._tDur;
  };

  Timeline.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

      _lastRenderedFrame = _ticker.frame;
    }

    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }

        child || _ticker.sleep();
      }
    }
  };

  return Timeline;
}(Animation);

_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});

var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
  //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result,
      startNums,
      color,
      endNum,
      chunk,
      startNum,
      hasRandom,
      a;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }

  if (stringFilter) {
    a = [start, end];
    stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.

    start = a[0];
    end = a[1];
  }

  startNums = start.match(_complexStringNumExp) || [];

  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);

    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }

    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.

      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }

  pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)

  pt.fp = funcParam;

  if (_relExp.test(end) || hasRandom) {
    pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
  }

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop],
      parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt;

  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (end.charAt(1) === "=") {
      pt = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + (getUnit(parsedStart) || 0);

      if (pt || pt === 0) {
        // to avoid isNaN, like if someone passes in a value like "!= whatever"
        end = pt;
      }
    }
  }

  if (parsedStart !== end) {
    if (!isNaN(parsedStart * end) && end !== "") {
      // fun fact: any number multiplied by "" is evaluated as the number 0!
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }

    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
},
    //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }

  var copy = {},
      p;

  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }

  return copy;
},
    _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i;

  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.

      i = plugin._props.length;

      while (i--) {
        ptLookup[plugin._props[i]] = pt;
      }
    }
  }

  return plugin;
},
    _overwritingTween,
    //store a reference temporarily so we can avoid overwriting itself.
_initTween = function _initTween(tween, time) {
  var vars = tween.vars,
      ease = vars.ease,
      startAt = vars.startAt,
      immediateRender = vars.immediateRender,
      lazy = vars.lazy,
      onUpdate = vars.onUpdate,
      onUpdateParams = vars.onUpdateParams,
      callbackScope = vars.callbackScope,
      runBackwards = vars.runBackwards,
      yoyoEase = vars.yoyoEase,
      keyframes = vars.keyframes,
      autoRevert = vars.autoRevert,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets,
      autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars,
      i,
      p,
      pt,
      target,
      hasPriority,
      gsData,
      harness,
      plugin,
      ptLookup,
      index,
      harnessVars,
      overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

  if (yoyoEase && tween._yoyo && !tween._repeat) {
    //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }

  tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

  if (!tl) {
    //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.

    cleanVars = _copyExcluding(vars, _reservedProps);
    prevStartAt && prevStartAt.render(-1, true).kill();

    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent: parent,
        immediateRender: true,
        lazy: _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate,
        onUpdateParams: onUpdateParams,
        callbackScope: callbackScope,
        stagger: 0
      }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);


      time < 0 && !immediateRender && !autoRevert && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

      if (immediateRender) {
        time > 0 && !autoRevert && (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.

        if (dur && time <= 0) {
          time && (tween._zTime = time);
          return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        } // if (time > 0) {
        // 	autoRevert || (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
        // } else if (dur && !(time < 0 && prevStartAt)) {
        // 	time && (tween._zTime = time);
        // 	return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        // }

      } else if (autoRevert === false) {
        tween._startAt = 0;
      }
    } else if (runBackwards && dur) {
      //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
      if (prevStartAt) {
        !autoRevert && (tween._startAt = 0);
      } else {
        time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0

        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && _isNotFalse(lazy),
          immediateRender: immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})

        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})

        _removeFromParent(tween._startAt = Tween.set(targets, p));

        time < 0 && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted from() tween.

        if (!immediateRender) {
          _initTween(tween._startAt, _tinyNum); //ensures that the initial values are recorded

        } else if (!time) {
          return;
        }
      }
    }

    tween._pt = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;

    for (i = 0; i < targets.length; i++) {
      target = targets[i];
      gsData = target._gsap || _harness(targets)[i]._gsap;
      tween._ptLookup[i] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)

      index = fullTargets === targets ? i : fullTargets.indexOf(target);

      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

        plugin._props.forEach(function (name) {
          ptLookup[name] = pt;
        });

        plugin.priority && (hasPriority = 1);
      }

      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }

      tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;

        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!


        overwritten = !tween.parent;
        _overwritingTween = 0;
      }

      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }

    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
  }

  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
},
    _addAliasesToVars = function _addAliasesToVars(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0,
      propertyAliases = harness && harness.aliases,
      copy,
      p,
      i,
      aliases;

  if (!propertyAliases) {
    return vars;
  }

  copy = _merge({}, vars);

  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i = aliases.length;

      while (i--) {
        copy[aliases[i]] = copy[p];
      }
    }
  }

  return copy;
},
    _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
  return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
},
    _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase",
    _staggerPropsToSkip = (_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger").split(",");
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */


var Tween = /*#__PURE__*/function (_Animation2) {
  _inheritsLoose(Tween, _Animation2);

  function Tween(targets, vars, position, skipInherit) {
    var _this3;

    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }

    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars,
        duration = _this3$vars.duration,
        delay = _this3$vars.delay,
        immediateRender = _this3$vars.immediateRender,
        stagger = _this3$vars.stagger,
        overwrite = _this3$vars.overwrite,
        keyframes = _this3$vars.keyframes,
        defaults = _this3$vars.defaults,
        scrollTrigger = _this3$vars.scrollTrigger,
        yoyoEase = _this3$vars.yoyoEase,
        parent = vars.parent || _globalTimeline,
        parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
        tl,
        i,
        copy,
        l,
        p,
        curTarget,
        staggerFunc,
        staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _this3._overwrite = overwrite;

    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults || {}
      });
      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;

      if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));

        stagger ? parsedTargets.forEach(function (t, i) {
          return keyframes.forEach(function (frame, j) {
            return tl.to(t, frame, j ? ">" : i * stagger);
          });
        }) : keyframes.forEach(function (frame) {
          return tl.to(parsedTargets, frame, ">");
        });
      } else {
        l = parsedTargets.length;
        staggerFunc = stagger ? distribute(stagger) : _emptyFunc;

        if (_isObject(stagger)) {
          //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }

        for (i = 0; i < l; i++) {
          copy = {};

          for (p in vars) {
            if (_staggerPropsToSkip.indexOf(p) < 0) {
              copy[p] = vars[p];
            }
          }

          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.

          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

          if (!stagger && l === 1 && copy.delay) {
            // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }

          tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
        }

        tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
      }

      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
    }

    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);

      _globalTimeline.killTweensOf(parsedTargets);

      _overwritingTween = 0;
    }

    _addToTimeline(parent, _assertThisInitialized(_this3), position);

    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);

    if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)

      _this3.render(Math.max(0, -delay)); //in case delay is negative

    }

    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }

  var _proto3 = Tween.prototype;

  _proto3.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._tDur,
        dur = this._dur,
        tTime = totalTime > tDur - _tinyNum && totalTime >= 0 ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        time,
        pt,
        iteration,
        cycleDuration,
        prevIteration,
        isYoyo,
        ratio,
        timeline,
        yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== totalTime < 0) {
      //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && iteration & 1;

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality

          if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.

            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, totalTime < 0 ? totalTime : time, force, suppressEvents)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (dur !== this._dur) {
          // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);

      if (this._onUpdate && !suppressEvents) {
        totalTime < 0 && this._startAt && this._startAt.render(totalTime, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.

        _callback(this, "onUpdate");
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        totalTime < 0 && this._startAt && !this._onUpdate && this._startAt.render(totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
          // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto3.targets = function targets() {
    return this._targets;
  };

  _proto3.invalidate = function invalidate() {
    this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate();
    return _Animation2.prototype.invalidate.call(this);
  };

  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }

    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }

    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.

      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.

      return this;
    }

    var parsedTargets = this._targets,
        killingTargets = targets ? toArray(targets) : parsedTargets,
        propTweenLookup = this._ptLookup,
        firstPT = this._pt,
        overwrittenProps,
        curLookup,
        curOverwriteProps,
        props,
        p,
        pt,
        i;

    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }

    overwrittenProps = this._op = this._op || [];

    if (vars !== "all") {
      //so people can pass in a comma-delimited list of property names
      if (_isString(vars)) {
        p = {};

        _forEachName(vars, function (name) {
          return p[name] = 1;
        });

        vars = p;
      }

      vars = _addAliasesToVars(parsedTargets, vars);
    }

    i = parsedTargets.length;

    while (i--) {
      if (~killingTargets.indexOf(parsedTargets[i])) {
        curLookup = propTweenLookup[i];

        if (vars === "all") {
          overwrittenProps[i] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
          props = vars;
        }

        for (p in props) {
          pt = curLookup && curLookup[p];

          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }

            delete curLookup[p];
          }

          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }

    this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.

    return this;
  };

  Tween.to = function to(targets, vars) {
    return new Tween(targets, vars, arguments[2]);
  };

  Tween.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };

  Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay: delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    });
  };

  Tween.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };

  Tween.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween(targets, vars);
  };

  Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };

  return Tween;
}(Animation);

_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.


_forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
  Tween[name] = function () {
    var tl = new Timeline(),
        params = _slice.call(arguments, 0);

    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */


var _setterPlain = function _setterPlain(target, property, value) {
  return target[property] = value;
},
    _setterFunc = function _setterFunc(target, property, value) {
  return target[property](value);
},
    _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
  return target[property](data.fp, value);
},
    _setterAttribute = function _setterAttribute(target, property, value) {
  return target.setAttribute(property, value);
},
    _getSetter = function _getSetter(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
},
    _renderPlain = function _renderPlain(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
},
    _renderBoolean = function _renderBoolean(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
},
    _renderComplexString = function _renderComplexString(ratio, data) {
  var pt = data._pt,
      s = "";

  if (!ratio && data.b) {
    //b = beginning string
    s = data.b;
  } else if (ratio === 1 && data.e) {
    //e = ending string
    s = data.e;
  } else {
    while (pt) {
      s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.

      pt = pt._next;
    }

    s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
  }

  data.set(data.t, data.p, s, data);
},
    _renderPropTweens = function _renderPropTweens(ratio, data) {
  var pt = data._pt;

  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
},
    _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
  var pt = this._pt,
      next;

  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
},
    _killPropTweensOf = function _killPropTweensOf(property) {
  var pt = this._pt,
      hasNonDependentRemaining,
      next;

  while (pt) {
    next = pt._next;

    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }

    pt = next;
  }

  return !hasNonDependentRemaining;
},
    _setterWithModifier = function _setterWithModifier(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
},
    _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
  var pt = parent._pt,
      next,
      pt2,
      first,
      last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)

  while (pt) {
    next = pt._next;
    pt2 = first;

    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }

    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }

    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }

    pt = next;
  }

  parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)


var PropTween = /*#__PURE__*/function () {
  function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;

    if (next) {
      next._prev = this;
    }
  }

  var _proto4 = PropTween.prototype;

  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)

    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target

    this.tween = tween;
  };

  return PropTween;
}(); //Initialization tasks

_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
  return _reservedProps[name] = 1;
});

_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */

var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    args.forEach(function (config) {
      return _createPlugin(config);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in

    var getter = _getCache(target || {}).get,
        format = unit ? _passThrough : _numericIfPossible;

    unit === "native" && (unit = "");
    return !target ? target : !property ? function (property, unit, uncache) {
      return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray(target);

    if (target.length > 1) {
      var setters = target.map(function (t) {
        return gsap.quickSetter(t, property, unit);
      }),
          l = setters.length;
      return function (value) {
        var i = l;

        while (i--) {
          setters[i](value);
        }
      };
    }

    target = target[0] || {};

    var Plugin = _plugins[property],
        cache = _getCache(target),
        p = cache.harness && (cache.harness.aliases || {})[property] || property,
        // in case it's an alias, like "rotate" for "rotation".
    setter = Plugin ? function (value) {
      var p = new Plugin();
      _quickTween._pt = 0;
      p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p.render(1, p);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);

    return Plugin ? setter : function (value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name,
        effect = _ref3.effect,
        plugins = _ref3.plugins,
        defaults = _ref3.defaults,
        extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function (pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });

    _effects[name] = function (targets, vars, tl) {
      return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
    };

    if (extendTimeline) {
      Timeline.prototype[name] = function (targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }

    var tl = new Timeline(vars),
        child,
        next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

    _globalTimeline.remove(tl);

    tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).

    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;

    while (child) {
      next = child._next;

      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }

      child = next;
    }

    _addToTimeline(_globalTimeline, tl, 0);

    return tl;
  },
  utils: {
    wrap: wrap,
    wrapYoyo: wrapYoyo,
    distribute: distribute,
    random: random,
    snap: snap,
    normalize: normalize,
    getUnit: getUnit,
    clamp: clamp,
    splitColor: splitColor,
    toArray: toArray,
    selector: selector,
    mapRange: mapRange,
    pipe: pipe,
    unitize: unitize,
    interpolate: interpolate,
    shuffle: shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween: PropTween,
    globals: _addGlobal,
    Tween: Tween,
    Timeline: Timeline,
    Animation: Animation,
    getCache: _getCache,
    _removeLinkedListItem: _removeLinkedListItem,
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};

_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
  return _gsap[name] = Tween[name];
});

_ticker.add(Timeline.updateRoot);

_quickTween = _gsap.to({}, {
  duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------

var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
  var pt = plugin._pt;

  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }

  return pt;
},
    _addModifiers = function _addModifiers(tween, modifiers) {
  var targets = tween._targets,
      p,
      i,
      pt;

  for (p in modifiers) {
    i = targets.length;

    while (i--) {
      pt = tween._ptLookup[i][p];

      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          // is a plugin
          pt = _getPluginPropTween(pt, p);
        }

        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
      }
    }
  }
},
    _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
  return {
    name: name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init(target, vars, tween) {
      tween._onInit = function (tween) {
        var temp, p;

        if (_isString(vars)) {
          temp = {};

          _forEachName(vars, function (name) {
            return temp[name] = 1;
          }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.


          vars = temp;
        }

        if (modifier) {
          temp = {};

          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }

          vars = temp;
        }

        _addModifiers(tween, vars);
      };
    }
  };
}; //register core plugins


var gsap = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt;

    for (p in vars) {
      pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
      pt && (pt.op = p);

      this._props.push(p);
    }
  }
}, {
  name: "endArray",
  init: function init(target, value) {
    var i = value.length;

    while (i--) {
      this.add(target, i, target[i] || 0, value[i]);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.

Tween.version = Timeline.version = gsap.version = "3.8.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0,
    Power1 = _easeMap.Power1,
    Power2 = _easeMap.Power2,
    Power3 = _easeMap.Power3,
    Power4 = _easeMap.Power4,
    Linear = _easeMap.Linear,
    Quad = _easeMap.Quad,
    Cubic = _easeMap.Cubic,
    Quart = _easeMap.Quart,
    Quint = _easeMap.Quint,
    Strong = _easeMap.Strong,
    Elastic = _easeMap.Elastic,
    Back = _easeMap.Back,
    SteppedEase = _easeMap.SteppedEase,
    Bounce = _easeMap.Bounce,
    Sine = _easeMap.Sine,
    Expo = _easeMap.Expo,
    Circ = _easeMap.Circ;

 //export some internal methods/orojects for use in CSSPlugin so that we can externalize that file and allow custom builds that exclude it.


;// CONCATENATED MODULE: ../../node_modules/gsap/CSSPlugin.js
/*!
 * CSSPlugin 3.8.0
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */


var CSSPlugin_win,
    CSSPlugin_doc,
    _docElement,
    _pluginInitted,
    _tempDiv,
    _tempDivStyler,
    _recentSetterPlugin,
    CSSPlugin_windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _transformProps = {},
    _RAD2DEG = 180 / Math.PI,
    _DEG2RAD = Math.PI / 180,
    _atan2 = Math.atan2,
    CSSPlugin_bigNum = 1e8,
    _capsExp = /([A-Z])/g,
    _horizontalExp = /(?:left|right|width|margin|padding|x)/i,
    _complexExp = /[\s,\(]\S/,
    _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
},
    _renderCSSProp = function _renderCSSProp(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
},
    //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
},
    _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
},
    _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
},
    _setterCSSStyle = function _setterCSSStyle(target, property, value) {
  return target.style[property] = value;
},
    _setterCSSProp = function _setterCSSProp(target, property, value) {
  return target.style.setProperty(property, value);
},
    _setterTransform = function _setterTransform(target, property, value) {
  return target._gsap[property] = value;
},
    _setterScale = function _setterScale(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
},
    _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
},
    _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
},
    _transformProp = "transform",
    _transformOriginProp = _transformProp + "Origin",
    _supports3D,
    _createElement = function _createElement(type, ns) {
  var e = CSSPlugin_doc.createElementNS ? CSSPlugin_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : CSSPlugin_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.

  return e.style ? e : CSSPlugin_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
},
    _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
},
    _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
    _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
  var e = element || _tempDiv,
      s = e.style,
      i = 5;

  if (property in s && !preferPrefix) {
    return property;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);

  while (i-- && !(_prefixes[i] + property in s)) {}

  return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
},
    _initCore = function _initCore() {
  if (CSSPlugin_windowExists() && window.document) {
    CSSPlugin_win = window;
    CSSPlugin_doc = CSSPlugin_win.document;
    _docElement = CSSPlugin_doc.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _tempDivStyler = _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.

    _supports3D = !!_checkPropPrefix("perspective");
    _pluginInitted = 1;
  }
},
    _getBBoxHack = function _getBBoxHack(swapIfPossible) {
  //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
      oldParent = this.parentNode,
      oldSibling = this.nextSibling,
      oldCSS = this.style.cssText,
      bbox;

  _docElement.appendChild(svg);

  svg.appendChild(this);
  this.style.display = "block";

  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox; //store the original

      this.getBBox = _getBBoxHack;
    } catch (e) {}
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }

  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }

  _docElement.removeChild(svg);

  this.style.cssText = oldCSS;
  return bbox;
},
    _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
  var i = attributesArray.length;

  while (i--) {
    if (target.hasAttribute(attributesArray[i])) {
      return target.getAttribute(attributesArray[i]);
    }
  }
},
    _getBBox = function _getBBox(target) {
  var bounds;

  try {
    bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }

  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.

  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
},
    _isSVG = function _isSVG(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
},
    //reports if the element is an SVG on which getBBox() actually works
_removeProperty = function _removeProperty(target, property) {
  if (property) {
    var style = target.style;

    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }

    if (style.removeProperty) {
      if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") {
        //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
        property = "-" + property;
      }

      style.removeProperty(property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
      style.removeAttribute(property);
    }
  }
},
    _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;

  plugin._props.push(property);

  return pt;
},
    _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
},
    //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
_convertToUnit = function _convertToUnit(target, property, value, unit) {
  var curValue = parseFloat(value) || 0,
      curUnit = (value + "").trim().substr((curValue + "").length) || "px",
      // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
  style = _tempDiv.style,
      horizontal = _horizontalExp.test(property),
      isRootSVG = target.tagName.toLowerCase() === "svg",
      measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
      amount = 100,
      toPixels = unit === "px",
      toPercent = unit === "%",
      px,
      parent,
      cache,
      isSVG;

  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }

  curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);

  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
  }

  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }

  if (!parent || parent === CSSPlugin_doc || !parent.appendChild) {
    parent = CSSPlugin_doc.body;
  }

  cache = parent._gsap;

  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time) {
    return _round(curValue / cache.width * amount);
  } else {
    (toPercent || curUnit === "%") && (style.position = _getComputedProperty(target, "position"));
    parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.

    parent.appendChild(_tempDiv);
    px = _tempDiv[measureProperty];
    parent.removeChild(_tempDiv);
    style.position = "absolute";

    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }

  return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
},
    _get = function _get(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();

  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];

    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }

  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];

    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
  }

  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
},
    _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
  //note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  if (!start || start === "none") {
    // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
    var p = _checkPropPrefix(prop, target, 1),
        s = p && _getComputedProperty(target, p, 1);

    if (s && s !== start) {
      prop = p;
      start = s;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
  }

  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
      index = 0,
      matchIndex = 0,
      a,
      result,
      startValues,
      startNum,
      color,
      startValue,
      endValue,
      endNum,
      chunk,
      endUnit,
      startUnit,
      relative,
      endValues;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (end === "auto") {
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    target.style[prop] = start;
  }

  a = [start, end];

  _colorStringFilter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().


  start = a[0];
  end = a[1];
  startValues = start.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];

  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }

      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;

        if (relative) {
          endValue = endValue.substr(2);
        }

        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;

        if (!endUnit) {
          //if something like "perspective:300" is passed in and we must add a unit to the end
          endUnit = endUnit || _config.units[prop] || startUnit;

          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }

        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        } //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.


        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: relative ? relative * endNum : endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }

  _relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
},
    _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
  var split = value.split(" "),
      x = split[0],
      y = split[1] || "50%";

  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    //the user provided them in the wrong order, so flip them
    value = x;
    x = y;
    y = value;
  }

  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
},
    _renderClearProps = function _renderClearProps(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t,
        style = target.style,
        props = data.u,
        cache = target._gsap,
        prop,
        clearTransforms,
        i;

    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i = props.length;

      while (--i > -1) {
        prop = props[i];

        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }

        _removeProperty(target, prop);
      }
    }

    if (clearTransforms) {
      _removeProperty(target, _transformProp);

      if (cache) {
        cache.svg && target.removeAttribute("transform");

        _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.


        cache.uncache = 1;
      }
    }
  }
},
    // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
_specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;

      plugin._props.push(property);

      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://greensock.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */

},

/*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */
_identity2DMatrix = [1, 0, 0, 1, 0, 0],
    _rotationalProperties = {},
    _isNullTransform = function _isNullTransform(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
},
    _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
  var matrixString = _getComputedProperty(target, _transformProp);

  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
},
    _getMatrix = function _getMatrix(target, force2D) {
  var cache = target._gsap || _getCache(target),
      style = target.style,
      matrix = _getComputedTransformMatrixAsArray(target),
      parent,
      nextSibling,
      temp,
      addedToDOM;

  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.

    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;

    if (!parent || !target.offsetParent) {
      // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
      addedToDOM = 1; //flag

      nextSibling = target.nextSibling;

      _docElement.appendChild(target); //we must add it to the DOM in order to get values properly

    }

    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");

    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }

  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
},
    _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap,
      matrix = matrixArray || _getMatrix(target, true),
      xOriginOld = cache.xOrigin || 0,
      yOriginOld = cache.yOrigin || 0,
      xOffsetOld = cache.xOffset || 0,
      yOffsetOld = cache.yOffset || 0,
      a = matrix[0],
      b = matrix[1],
      c = matrix[2],
      d = matrix[3],
      tx = matrix[4],
      ty = matrix[5],
      originSplit = origin.split(" "),
      xOrigin = parseFloat(originSplit[0]) || 0,
      yOrigin = parseFloat(originSplit[1]) || 0,
      bounds,
      determinant,
      x,
      y;

  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
  } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
    //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
    x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y;
  }

  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }

  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).

  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }

  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
},
    _parseTransform = function _parseTransform(target, uncache) {
  var cache = target._gsap || new GSCache(target);

  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }

  var style = target.style,
      invertedScaleX = cache.scaleX < 0,
      px = "px",
      deg = "deg",
      origin = _getComputedProperty(target, _transformOriginProp) || "0",
      x,
      y,
      z,
      scaleX,
      scaleY,
      rotation,
      rotationX,
      rotationY,
      skewX,
      skewY,
      perspective,
      xOrigin,
      yOrigin,
      matrix,
      angle,
      cos,
      sin,
      a,
      b,
      c,
      d,
      a12,
      a22,
      t1,
      t2,
      t3,
      a13,
      a23,
      a33,
      a42,
      a43,
      a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));
  matrix = _getMatrix(target, cache.svg);

  if (cache.svg) {
    t1 = (!cache.uncache || origin === "0px 0px") && !uncache && target.getAttribute("data-svg-origin"); // if origin is 0,0 and cache.uncache is true, let the recorded data-svg-origin stay. Otherwise, whenever we set cache.uncache to true, we'd need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.

    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }

  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;

  if (matrix !== _identity2DMatrix) {
    a = matrix[0]; //a11

    b = matrix[1]; //a21

    c = matrix[2]; //a31

    d = matrix[3]; //a41

    x = a12 = matrix[4];
    y = a22 = matrix[5]; //2D matrix

    if (matrix.length === 6) {
      scaleX = Math.sqrt(a * a + b * b);
      scaleY = Math.sqrt(d * d + c * c);
      rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).

      skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

      if (cache.svg) {
        x -= xOrigin - (xOrigin * a + yOrigin * c);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      } //3D matrix

    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG; //rotationX

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      } //rotationY


      angle = _atan2(-c, a33);
      rotationY = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a = t1;
        b = t2;
        c = t3;
      } //rotationZ


      angle = _atan2(b, a);
      rotation = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a * sin;
        a22 = a22 * cos - a12 * sin;
        a = t1;
        a12 = t2;
      }

      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }

      scaleX = _round(Math.sqrt(a * a + b * b + c * c));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }

    if (cache.svg) {
      //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }

  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }

  cache.x = x - ((cache.xPercent = x && (cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;

  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }

  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
},
    _firstTwoOnly = function _firstTwoOnly(value) {
  return (value = value.split(" "))[0] + " " + value[1];
},
    //for handling transformOrigin values, stripping out the 3rd dimension
_addPxTranslate = function _addPxTranslate(target, start, value) {
  var unit = getUnit(start);
  return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
},
    _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;

  _renderCSSTransforms(ratio, cache);
},
    _zeroDeg = "0deg",
    _zeroPx = "0px",
    _endParenthesis = ") ",
    _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
  var _ref = cache || this,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      rotation = _ref.rotation,
      rotationY = _ref.rotationY,
      rotationX = _ref.rotationX,
      skewX = _ref.skewX,
      skewY = _ref.skewY,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      transformPerspective = _ref.transformPerspective,
      force3D = _ref.force3D,
      target = _ref.target,
      zOrigin = _ref.zOrigin,
      transforms = "",
      use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)


  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD,
        a13 = Math.sin(angle),
        a33 = Math.cos(angle),
        cos;

    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }

  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }

  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }

  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }

  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }

  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }

  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }

  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }

  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }

  target.style[_transformProp] = transforms || "translate(0, 0)";
},
    _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
  var _ref2 = cache || this,
      xPercent = _ref2.xPercent,
      yPercent = _ref2.yPercent,
      x = _ref2.x,
      y = _ref2.y,
      rotation = _ref2.rotation,
      skewX = _ref2.skewX,
      skewY = _ref2.skewY,
      scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY,
      target = _ref2.target,
      xOrigin = _ref2.xOrigin,
      yOrigin = _ref2.yOrigin,
      xOffset = _ref2.xOffset,
      yOffset = _ref2.yOffset,
      forceCSS = _ref2.forceCSS,
      tx = parseFloat(x),
      ty = parseFloat(y),
      a11,
      a21,
      a12,
      a22,
      temp;

  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);

  if (skewY) {
    //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }

  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;

    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;

      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }

    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }

  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }

  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }

  if (xPercent || yPercent) {
    //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }

  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the  transform attribute changes!)
},
    _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
  var cap = 360,
      isString = _isString(endValue),
      endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
      change = relative ? endNum * relative : endNum - startNum,
      finalValue = startNum + change + "deg",
      direction,
      pt;

  if (isString) {
    direction = endValue.split("_")[1];

    if (direction === "short") {
      change %= cap;

      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }

    if (direction === "cw" && change < 0) {
      change = (change + cap * CSSPlugin_bigNum) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * CSSPlugin_bigNum) % cap - ~~(change / cap) * cap;
    }
  }

  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";

  plugin._props.push(property);

  return pt;
},
    _assign = function _assign(target, source) {
  // Internet Explorer doesn't have Object.assign(), so we recreate it here.
  for (var p in source) {
    target[p] = source[p];
  }

  return target;
},
    _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
  //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
  var startCache = _assign({}, target._gsap),
      exclude = "perspective,force3D,transformOrigin,svgOrigin",
      style = target.style,
      endCache,
      p,
      startValue,
      endValue,
      startNum,
      endNum,
      startUnit,
      endUnit;

  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);

    _removeProperty(target, _transformProp);

    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }

  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];

    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;

      plugin._props.push(p);
    }
  }

  _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.


_forEachName("padding,margin,Width,Radius", function (name, index) {
  var t = "Top",
      r = "Right",
      b = "Bottom",
      l = "Left",
      props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
    return index < 2 ? name + side : "border" + side + name;
  });

  _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
    var a, vars;

    if (arguments.length < 4) {
      // getter, passed target, property, and unit (from _get())
      a = props.map(function (prop) {
        return _get(plugin, prop, property);
      });
      vars = a.join(" ");
      return vars.split(a[0]).length === 5 ? a[0] : vars;
    }

    a = (endValue + "").split(" ");
    vars = {};
    props.forEach(function (prop, i) {
      return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});

var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init(target, vars, tween, index, targets) {
    var props = this._props,
        style = target.style,
        startAt = tween.vars.startAt,
        startValue,
        endValue,
        endNum,
        startNum,
        type,
        specialProp,
        p,
        startUnit,
        endUnit,
        relative,
        isTransformRelated,
        transformPropTween,
        cache,
        smooth,
        hasPriority;
    _pluginInitted || _initCore();

    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }

      endValue = vars[p];

      if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
        // plugins
        continue;
      }

      type = typeof endValue;
      specialProp = _specialProps[p];

      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }

      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }

      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        //CSS variable
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;

        if (!_colorExp.test(startValue)) {
          // colors don't have units
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
        }

        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          p in _config.units && !getUnit(startValue) && (startValue += _config.units[p]); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.

          _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
        } else {
          startValue = _get(target, p);
        }

        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);

        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
              startNum = 0;
            }

            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }

          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }

        isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---

        if (isTransformRelated) {
          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.

            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)

            transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
          }

          if (p === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? relative * endNum : endNum - cache.scaleY) || 0);
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.

            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!

              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }

            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);

            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, endValue, relative);

            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);

            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }

        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0); // protect against NaN

          endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;

          if (startUnit !== endUnit && endUnit !== "%") {
            //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
            this.add(target, p, startValue || target[p], endValue, index, targets);
          } else {
            _missingPlugin(p, endValue);

            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, endValue);
        }

        props.push(p);
      }
    }

    hasPriority && _sortPropTweensByPriority(this);
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty: _removeProperty,
    _getMatrix: _getMatrix
  }
};
gsap.utils.checkPrefix = _checkPropPrefix;

(function (positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
    _transformProps[name] = 1;
  });

  _forEachName(rotation, function (name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });

  _propertyAliases[all[13]] = positionAndScale + "," + rotation;

  _forEachName(aliases, function (name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
  _config.units[name] = "px";
});

gsap.registerPlugin(CSSPlugin);

;// CONCATENATED MODULE: ../../node_modules/gsap/index.js


var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap,
    // to protect from tree shaking
TweenMaxWithCSS = gsapWithCSS.core.Tween;


/***/ }),

/***/ 3463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(3887);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 3459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3459);
} else {}


/***/ }),

/***/ 2333:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 6299:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 3335:
/***/ (function(module) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ 5525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8573);
/* harmony import */ var _tm_ui_contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1726);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9666);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5153);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(path__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2322);
/* provided dependency */ var process = __webpack_require__(4406);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // Magic import, https://github.com/nrwl/nx/issues/9017#issuecomment-1140066503




path__WEBPACK_IMPORTED_MODULE_6___default().resolve("./next.config.js");

CustomApp.getInitialProps = function (context) {
  return {
    publicEnv: {
      proxyCmsPrefix: process.env.PUBLIC_CMS_CONTEXT_PATH,
      exchangeRateApi: process.env.PUBLIC_EXCHANGE_RATE_API
    }
  };
};

function CustomApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      publicEnv = _ref.publicEnv;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_5__.addWebVitalsScript)({
      sampleSize: 30
    });
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_3__/* .GlobalStyles */ .nz, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
      children: pageProps !== null && pageProps !== void 0 && pageProps.isTablet ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "viewport",
        content: "width=1440"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("main", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_ui_contexts__WEBPACK_IMPORTED_MODULE_4__/* .PublicEnvProvider */ .eV, {
        value: publicEnv,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Component, _objectSpread({}, pageProps))
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (CustomApp);

/***/ }),

/***/ 1517:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/is.js
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function is_isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isVueViewModel(wat) {
  // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
  return !!(typeof wat === 'object' && wat !== null && ((wat ).__isVue || (wat )._isVue));
}


//# sourceMappingURL=is.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(63);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/browser.js



// eslint-disable-next-line deprecation/deprecation
const browser_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  if (!elem) {
    return '<unknown>';
  }

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && isString(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return browser_WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (browser_WINDOW.document && browser_WINDOW.document.querySelector) {
    return browser_WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/logger.js


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/** This may be mutated by the console instrumentation. */
const originalConsoleMethods

 = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
    return callback();
  }

  const console = worldwide/* GLOBAL_OBJ.console */.n2.console ;
  const wrappedFuncs = {};

  const wrappedLevels = Object.keys(originalConsoleMethods) ;

  // Restore all wrapped console methods
  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level] ;
    wrappedFuncs[level] = console[level] ;
    console[level] = originalConsoleMethod;
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level] ;
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled,
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            worldwide/* GLOBAL_OBJ.console */.n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

const logger_logger = makeLogger();


//# sourceMappingURL=logger.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/string.js


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function string_snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
      // console warnings. This happens when a Vue template is rendered with
      // an undeclared variable, which we try to stringify, ultimately causing
      // Vue to issue another warning which repeats indefinitely.
      // see: https://github.com/getsentry/sentry-javascript/pull/8981
      if (isVueViewModel(value)) {
        output.push('[VueViewModel]');
      } else {
        output.push(String(value));
      }
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!isString(value)) {
    return false;
  }

  if (isRegExp(pattern)) {
    return pattern.test(value);
  }
  if (isString(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/object.js





/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    markFunctionWrapped(wrapped, original);
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: value,
      writable: true,
      configurable: true,
    });
  } catch (o_O) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`Failed to add non-enumerable property "${name}" to object`, obj);
  }
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
  } catch (o_O) {} // eslint-disable-line no-empty
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if (isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if (isEvent(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return truncate(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return truncate(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPlainObject(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/misc.js




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function misc_uuid4() {
  const gbl = worldwide/* GLOBAL_OBJ */.n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (crypto && crypto.getRandomValues) {
      getRandomByte = () => crypto.getRandomValues(new Uint8Array(1))[0];
    }
  } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
  }

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    addNonEnumerableProperty(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(7790);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/constants.js
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/syncpromise.js


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];

    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init2() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init3() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if (is_isThenable(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init4() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/eventProcessors.js


/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,worldwide/* getGlobalSingleton */.YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(
  processors,
  event,
  hint,
  index = 0,
) {
  return new SyncPromise((resolve, reject) => {
    const processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor({ ...event }, hint) ;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        processor.id &&
        result === null &&
        logger_logger.log(`Event processor "${processor.id}" dropped event`);

      if (is_isThenable(result)) {
        void result
          .then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
          .then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1)
          .then(resolve)
          .then(null, reject);
      }
    }
  });
}


//# sourceMappingURL=eventProcessors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/session.js


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,esm_time/* timestampInSeconds */.ph)();

  const session = {
    sid: misc_uuid4(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,esm_time/* timestampInSeconds */.ph)();

  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : misc_uuid4();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return dropUndefinedKeys({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/scope.js




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class scope_Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new scope_Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
      newScope._propagationContext = { ...scope._propagationContext };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof scope_Scope ? updatedScope : this;
    }

    if (captureContext instanceof scope_Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
      if (captureContext._propagationContext) {
        this._propagationContext = captureContext._propagationContext;
      }
    } else if (isPlainObject(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
      if (captureContext.propagationContext) {
        this._propagationContext = captureContext.propagationContext;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,esm_time/* dateTimestampInSeconds */.yW)(),
      ...breadcrumb,
    };

    const breadcrumbs = this._breadcrumbs;
    breadcrumbs.push(mergedBreadcrumb);
    this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;

    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(
    event,
    hint = {},
    additionalEventProcessors,
  ) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transaction = this._span.transaction;
      if (transaction) {
        event.sdkProcessingMetadata = {
          dynamicSamplingContext: transaction.getDynamicSamplingContext(),
          ...event.sdkProcessingMetadata,
        };
        const transactionName = transaction.name;
        if (transactionName) {
          event.tags = { transaction: transactionName, ...event.tags };
        }
      }
    }

    this._applyFingerprint(event);

    const scopeBreadcrumbs = this._getBreadcrumbs();
    const breadcrumbs = [...(event.breadcrumbs || []), ...scopeBreadcrumbs];
    event.breadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;

    event.sdkProcessingMetadata = {
      ...event.sdkProcessingMetadata,
      ...this._sdkProcessingMetadata,
      propagationContext: this._propagationContext,
    };

    // TODO (v8): Update this order to be: Global > Client > Scope
    return notifyEventProcessors(
      [...(additionalEventProcessors || []), ...getGlobalEventProcessors(), ...this._eventProcessors],
      event,
      hint,
    );
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * @inheritDoc
   */
   setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }

  /**
   * @inheritDoc
   */
   getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * Get the breadcrumbs for this scope.
   */
   _getBreadcrumbs() {
    return this._breadcrumbs;
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? arrayify(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

function generatePropagationContext() {
  return {
    traceId: misc_uuid4(),
    spanId: misc_uuid4().substring(16),
  };
}


//# sourceMappingURL=scope.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/hub.js





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new scope_Scope(),   _version = API_VERSION) {this._version = _version;
    this._stack = [{ scope }];
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = scope_Scope.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : misc_uuid4());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : misc_uuid4());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : misc_uuid4();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,esm_time/* dateTimestampInSeconds */.yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? (consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this.getScope().setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this.getScope().setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this.getScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.getScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    this.getScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) {
      const client = this.getClient();
      if (!client) {
        // eslint-disable-next-line no-console
        console.warn(
          "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'",
        );
      } else {
        // eslint-disable-next-line no-console
        console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
      }
    }

    return result;
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      closeSession(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = DEFAULT_ENVIRONMENT } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = worldwide/* GLOBAL_OBJ.navigator */.n2.navigator || {};

    const session = makeSession({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      updateSession(currentSession, { status: 'exited' });
    }
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ = worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return worldwide/* GLOBAL_OBJ */.n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function hub_getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (!hasHubOnCarrier(carrier) || getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
    const globalHubTopStack = parent.getStackTop();
    setHubOnCarrier(carrier, new Hub(globalHubTopStack.client, Scope.clone(globalHubTopStack.scope)));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,worldwide/* getGlobalSingleton */.YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/utils/hasTracingEnabled.js


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = hub_getCurrentHub().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */
function splitPath(filename) {
  // Truncate files names greater than 1024 characters to avoid regex dos
  // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
  const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
  const parts = splitPathRe.exec(truncated);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);
    this.name = RewriteFrames.id;

    if (options.root) {
      this._root = options.root;
    }
    this._prefix = options.prefix || 'app:///';
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
  }

  /** @inheritDoc */
   processEvent(event) {
    return this.process(event);
  }

  /**
   * TODO (v8): Make this private/internal
   */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    const isWindowsFrame =
      /^[a-zA-Z]:\\/.test(frame.filename) ||
      // or the presence of a backslash without a forward slash (which are not allowed on Windows)
      (frame.filename.includes('\\') && !frame.filename.includes('/'));
    // Check if the frame filename begins with `/`
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.77.0';


//# sourceMappingURL=version.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */

   constructor(options = {}) {
    this.name = InboundFilters.id;
    this._options = options;
  }

  /**
   * @inheritDoc
   */
   setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
  }

  /** @inheritDoc */
   processEvent(event, _eventHint, client) {
    const clientOptions = client.getOptions();
    const options = _mergeOptions(this._options, clientOptions);
    return _shouldDropEvent(event, options) ? null : event;
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${getEventDescription(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${getEventDescription(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${getEventDescription(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${getEventDescription(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${getEventDescription(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => stringMatchesSomePattern(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? stringMatchesSomePattern(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : stringMatchesSomePattern(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : stringMatchesSomePattern(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  const possibleMessages = [];

  if (event.message) {
    possibleMessages.push(event.message);
  }

  let lastException;
  try {
    // @ts-expect-error Try catching to save bundle size
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    lastException = event.exception.values[event.exception.values.length - 1];
  } catch (e) {
    // try catching to save bundle size checking existence of variables
  }

  if (lastException) {
    if (lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  }

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && possibleMessages.length === 0) {
    logger_logger.error(`Could not extract message for event ${getEventDescription(event)}`);
  }

  return possibleMessages;
}

function _isSentryError(event) {
  try {
    // @ts-expect-error can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-expect-error we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.error(`Cannot extract url for event ${getEventDescription(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */

   constructor() {
    this.name = FunctionToString.id;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // intrinsics (like Function.prototype) might be immutable in some environments
    // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Function.prototype.toString = function ( ...args) {
        const context = getOriginalFunction(this) || this;
        return originalFunctionToString.apply(context, args);
      };
    } catch (e) {
      // ignore errors here, just don't patch this
    }
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = arrayify(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(client, integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(client, integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(addGlobalEventProcessor, hub_getCurrentHub);
    installedIntegrations.push(integration.name);
  }

  if (client.on && typeof integration.preprocessEvent === 'function') {
    const callback = integration.preprocessEvent.bind(integration) ;
    client.on('preprocessEvent', (event, hint) => callback(event, hint, client));
  }

  if (client.addEventProcessor && typeof integration.processEvent === 'function') {
    const callback = integration.processEvent.bind(integration) ;

    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name,
    });

    client.addEventProcessor(processor);
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`Integration installed: ${integration.name}`);
}

/** Add an integration to the current hub's client. */
function addIntegration(integration) {
  const client = getCurrentHub().getClient();

  if (!client || !client.addIntegration) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
    return;
  }

  client.addIntegration(integration);
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger_logger.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = hub_getCurrentHub();
  const scope = hub.getScope();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/stacktrace.js



const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = Array.from(stack);

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();

    // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
    // is produced within the hub itself, making it:
    //
    //   Sentry.captureException()
    //   getCurrentHub().captureException()
    //
    // instead of just the top `Sentry` call itself.
    // This forces us to possibly strip an additional frame in the exact same was as above.
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
      localStack.pop();
    }
  }

  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/supports.js



// eslint-disable-next-line deprecation/deprecation
const supports_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-expect-error It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in supports_WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(supports_WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = supports_WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in supports_WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const supportsHistory_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (supportsHistory_WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in supportsHistory_WINDOW && !!supportsHistory_WINDOW.history.pushState && !!supportsHistory_WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument.js









// eslint-disable-next-line deprecation/deprecation
const instrument_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v2__';

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(key => {
    handlers[key ] = undefined;
  });
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${getFunctionName(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
    return;
  }

  CONSOLE_LEVELS.forEach(function (level) {
    if (!(level in worldwide/* GLOBAL_OBJ.console */.n2.console)) {
      return;
    }

    fill(worldwide/* GLOBAL_OBJ.console */.n2.console, level, function (originalConsoleMethod) {
      originalConsoleMethods[level] = originalConsoleMethod;

      return function (...args) {
        triggerHandlers('console', { args, level });

        const log = originalConsoleMethods[level];
        log && log.apply(worldwide/* GLOBAL_OBJ.console */.n2.console, args);
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }

  fill(worldwide/* GLOBAL_OBJ */.n2, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(worldwide/* GLOBAL_OBJ */.n2, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}

/** JSDoc */
function instrumentXHR() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (!(instrument_WINDOW ).XMLHttpRequest) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  fill(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const startTimestamp = Date.now();

      const url = args[1];
      const xhrInfo = (this[SENTRY_XHR_DATA_KEY] = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: isString(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
        request_headers: {},
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args: args ,
            endTimestamp: Date.now(),
            startTimestamp,
            xhr: this,
          } );
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        fill(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      fill(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs ;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  fill(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
      if (sentryXhrData && args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = instrument_WINDOW.onpopstate;
  instrument_WINDOW.onpopstate = function ( ...args) {
    const to = instrument_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  fill(instrument_WINDOW.history, 'pushState', historyReplacementFunction);
  fill(instrument_WINDOW.history, 'replaceState', historyReplacementFunction);
}

const DEBOUNCE_DURATION = 1000;
let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;

/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */
function isSimilarToLastCapturedEvent(event) {
  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (event.type !== lastCapturedEventType) {
    return false;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (!event.target || (event.target )._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return true;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(eventType, target) {
  // We are only interested in filtering `keypress` events for now.
  if (eventType !== 'keypress') {
    return false;
  }

  if (!target || !target.tagName) {
    return true;
  }

  // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
  // e.g.tabbing through elements, hotkeys, etc.
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
    return false;
  }

  return true;
}

function getEventTarget(event) {
  try {
    return event.target ;
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    return null;
  }
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || event['_sentryCaptured']) {
      return;
    }

    const target = getEventTarget(event);

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }

    // Mark event as "seen"
    addNonEnumerableProperty(event, '_sentryCaptured', true);

    if (target && !target._sentryId) {
      // Add UUID to event target so we can identify if
      addNonEnumerableProperty(target, '_sentryId', misc_uuid4());
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
    // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    if (!isSimilarToLastCapturedEvent(event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : undefined;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = instrument_WINDOW.setTimeout(() => {
      lastCapturedEventTargetId = undefined;
      lastCapturedEventType = undefined;
    }, DEBOUNCE_DURATION);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!instrument_WINDOW.document) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  instrument_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  instrument_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (instrument_WINDOW )[target] && (instrument_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    fill(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    fill(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = instrument_WINDOW.onerror;

  instrument_WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  instrument_WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = instrument_WINDOW.onunhandledrejection;

  instrument_WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  instrument_WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    // eslint-disable-next-line no-console
    console.error(`Invalid Sentry Dsn: ${str}`);
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      logger_logger.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    logger_logger.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    logger_logger.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    logger_logger.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !is_isNaN(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = convertToPlainObject(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    if (isVueViewModel(value)) {
      return '[VueViewModel]';
    }

    // React's SyntheticEvent thingy
    if (isSyntheticEvent(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${getFunctionName(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    dropUndefinedKeys({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
  // TODO: This is a temporary workaround until we have a proper data category for metrics
  statsd: 'unknown',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
    ...(dynamicSamplingContext && {
      trace: dropUndefinedKeys({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return urlEncode({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */
function getDynamicSamplingContextFromClient(
  trace_id,
  client,
  scope,
) {
  const options = client.getOptions();

  const { publicKey: public_key } = client.getDsn() || {};
  const { segment: user_segment } = (scope && scope.getUser()) || {};

  const dsc = dropUndefinedKeys({
    environment: options.environment || DEFAULT_ENVIRONMENT,
    release: options.release,
    user_segment,
    public_key,
    trace_id,
  }) ;

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}


//# sourceMappingURL=dynamicSamplingContext.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/utils/prepareEvent.js





/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
  client,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || misc_uuid4(),
    timestamp: event.timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = scope_Scope.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = resolvedSyncPromise(prepared);

  const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint, clientEventProcessors);
  } else {
    // Apply client & global event processors even if there is no scope
    // TODO (v8): Update the order to be Global > Client
    result = notifyEventProcessors([...clientEventProcessors, ...getGlobalEventProcessors()], prepared, hint);
  }

  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }

    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : DEFAULT_ENVIRONMENT;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = truncate(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = truncate(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = truncate(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  const debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach(filename => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id: filenameDebugIdMap[filename],
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: normalize(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: normalize(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: normalize(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: normalize(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = normalize(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/baseclient.js








const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Indicates whether this client's integrations have been set up. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {
    this._options = options;
    this._integrations = {};
    this._integrationsInitialized = false;
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];

    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('No DSN provided, client will not send events.');
    }

    if (this._dsn) {
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if (checkOrSetAlreadyCaught(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = is_isPrimitive(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      updateSession(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return resolvedSyncPromise(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /** Get all installed event processors. */
   getEventProcessors() {
    return this._eventProcessors;
  }

  /** @inheritDoc */
   addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations(forceInitialize) {
    if ((forceInitialize && !this._integrationsInitialized) || (this._isEnabled() && !this._integrationsInitialized)) {
      this._integrations = setupIntegrations(this, this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    setupIntegration(this, integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    this.emit('beforeSendEvent', event, hint);

    let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

    for (const attachment of hint.attachments || []) {
      env = addItemToEnvelope(
        env,
        createAttachmentEnvelopeItem(
          attachment,
          this._options.transportOptions && this._options.transportOptions.textEncoder,
        ),
      );
    }

    const promise = this._sendEnvelope(env);
    if (promise) {
      promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
    void this._sendEnvelope(env);
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-expect-error We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /* eslint-enable @typescript-eslint/unified-signatures */

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      updateSession(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new SyncPromise(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a transport is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }

    this.emit('preprocessEvent', event, hint);

    return prepareEvent(options, event, hint, scope, this).then(evt => {
      if (evt === null) {
        return evt;
      }

      // If a trace context is not set on the event, we use the propagationContext set on the event to
      // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
      // also generate one for it.
      const { propagationContext } = evt.sdkProcessingMetadata || {};
      const trace = evt.contexts && evt.contexts.trace;
      if (!trace && propagationContext) {
        const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext ;
        evt.contexts = {
          trace: {
            trace_id,
            span_id: spanId,
            parent_span_id: parentSpanId,
          },
          ...evt.contexts,
        };

        const dynamicSamplingContext = dsc ? dsc : getDynamicSamplingContextFromClient(trace_id, this, scope);

        evt.sdkProcessingMetadata = {
          dynamicSamplingContext,
          ...evt.sdkProcessingMetadata,
        };
      }
      return evt;
    });
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            logger_logger.log(sentryError.message);
          } else {
            logger_logger.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    const isTransaction = isTransactionEvent(event);
    const isError = baseclient_isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return rejectedSyncPromise(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    this.emit('beforeEnvelope', envelope);

    if (this._isEnabled() && this._transport) {
      return this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if (is_isThenable(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!isPlainObject(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!isPlainObject(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (baseclient_isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function baseclient_isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(5720);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = hub_getCurrentHub();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }),
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return resolvedSyncPromise(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return resolvedSyncPromise(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if (isErrorEvent(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if (isDOMError(exception) || isDOMException(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || (isDOMError(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      addExceptionTypeValue(event, message);
    }
    if ('code' in domException) {
      // eslint-disable-next-line deprecation/deprecation
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if (isError(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if (isPlainObject(exception) || isEvent(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    addExceptionMechanism(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  addExceptionTypeValue(event, `${exception}`, undefined);
  addExceptionMechanism(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}

function getNonErrorObjectExceptionValue(
  exception,
  { isUnhandledRejection },
) {
  const keys = extractExceptionKeysForMessage(exception);
  const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if (isErrorEvent(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }

  if (isEvent(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }

  return `Object captured as ${captureType} with keys: ${keys}`;
}

function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}


//# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/exports.js



// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return hub_getCurrentHub().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  hub_getCurrentHub().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  hub_getCurrentHub().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const hub = getCurrentHub();
  const scope = hub.getScope();
  const client = hub.getClient();
  if (!client) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }

  return uuid4();
}

/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function withMonitor(
  monitorSlug,
  callback,
  upsertMonitorConfig,
) {
  const checkInId = captureCheckIn({ monitorSlug, status: 'in_progress' }, upsertMonitorConfig);
  const now = timestampInSeconds();

  function finishCheckIn(status) {
    captureCheckIn({ monitorSlug, status, checkInId, duration: timestampInSeconds() - now });
  }

  let maybePromiseResult;
  try {
    maybePromiseResult = callback();
  } catch (e) {
    finishCheckIn('error');
    throw e;
  }

  if (isThenable(maybePromiseResult)) {
    Promise.resolve(maybePromiseResult).then(
      () => {
        finishCheckIn('ok');
      },
      () => {
        finishCheckIn('error');
      },
    );
  } else {
    finishCheckIn('ok');
  }

  return maybePromiseResult;
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function flush(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return Promise.resolve(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function exports_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return Promise.resolve(false);
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}


//# sourceMappingURL=exports.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if (getOriginalFunction(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      withScope((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            addExceptionTypeValue(event, undefined, undefined);
            addExceptionMechanism(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        captureException(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  markFunctionWrapped(sentryWrapped, fn);

  addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/userfeedback.js


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: dsn_dsnToString(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return createEnvelope(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/client.js






/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers_WINDOW.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: `${sdkSource}:@sentry/browser`,
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = createUserFeedbackEnvelope(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });
    void this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('No outcomes to send');
      return;
    }

    // This is really the only place where we want to check for a DSN and only send outcomes then
    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));
    void this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */

  /** JSDoc */
   constructor(options) {
    this.name = GlobalHandlers.id;
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };

    this._installFunc = {
      onerror: _installGlobalOnErrorHandler,
      onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  addInstrumentationHandler(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && isString(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  addInstrumentationHandler(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = is_isPrimitive(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = isErrorEvent(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = isString(url) && url.length > 0 ? url : getLocationHref();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  addExceptionMechanism(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = hub_getCurrentHub();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'BroadcastChannel',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'SharedWorker',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {
    this.name = TryCatch.id;
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      fill(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      fill(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      fill(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: getFunctionName(original) },
        handled: false,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: getFunctionName(original),
          },
          handled: false,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        fill(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: getFunctionName(original),
              },
              handled: false,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = getOriginalFunction(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  fill(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: getFunctionName(fn),
                target,
              },
              handled: false,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: getFunctionName(fn),
              target,
            },
            handled: false,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  fill(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        .replace(':80', '')
        .replace(':443', '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Breadcrumbs';}

  /**
   * @inheritDoc
   */

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {
    this.name = Breadcrumbs.id;
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      addInstrumentationHandler('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      addInstrumentationHandler('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      addInstrumentationHandler('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      addInstrumentationHandler('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      addInstrumentationHandler('history', _historyBreadcrumb);
    }
    if (this.options.sentry) {
      const client = hub_getCurrentHub().getClient();
      client && client.on && client.on('beforeSendEvent', addSentryBreadcrumb);
    }
  }
} Breadcrumbs.__initStatic();

/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */
function addSentryBreadcrumb(event) {
  hub_getCurrentHub().addBreadcrumb(
    {
      category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
      event_id: event.event_id,
      level: event.level,
      message: getEventDescription(event),
    },
    {
      event,
    },
  );
}

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      target = _isEvent(event)
        ? htmlTreeAsString(event.target, { keyAttrs, maxStringLength })
        : htmlTreeAsString(event, { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    hub_getCurrentHub().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: safeJoin(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${safeJoin(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  hub_getCurrentHub().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  const sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];

  // We only capture complete, non-sentry requests
  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return;
  }

  const { method, url, status_code, body } = sentryXhrData;

  const data = {
    method,
    url,
    status_code,
  };

  const hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp,
    endTimestamp,
  };

  hub_getCurrentHub().addBreadcrumb(
    {
      category: 'xhr',
      data,
      type: 'http',
    },
    hint,
  );
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  // We only capture complete fetch requests
  if (!endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    const data = handlerData.fetchData;
    const hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp,
      endTimestamp,
    };

    hub_getCurrentHub().addBreadcrumb(
      {
        category: 'fetch',
        data,
        level: 'error',
        type: 'http',
      },
      hint,
    );
  } else {
    const data = {
      ...handlerData.fetchData,
      status_code: handlerData.response && handlerData.response.status,
    };
    const hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp,
      endTimestamp,
    };
    hub_getCurrentHub().addBreadcrumb(
      {
        category: 'fetch',
        data,
        type: 'http',
      },
      hint,
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  hub_getCurrentHub().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}

function _isEvent(event) {
  return !!event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/aggregate-errors.js



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */
function applyAggregateErrorsToEvent(
  exceptionFromErrorImplementation,
  parser,
  maxValueLimit = 250,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
    return;
  }

  // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
  const originalException =
    event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;

  // We only create exception grouping if there is an exception in the event.
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(
      aggregateExceptionsFromError(
        exceptionFromErrorImplementation,
        parser,
        limit,
        hint.originalException ,
        key,
        event.exception.values,
        originalException,
        0,
      ),
      maxValueLimit,
    );
  }
}

function aggregateExceptionsFromError(
  exceptionFromErrorImplementation,
  parser,
  limit,
  error,
  key,
  prevExceptions,
  exception,
  exceptionId,
) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }

  let newExceptions = [...prevExceptions];

  if (isInstanceOf(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId,
    );
  }

  // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if (isInstanceOf(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId,
        );
      }
    });
  }

  return newExceptions;
}

function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    is_exception_group: true,
    exception_id: exceptionId,
  };
}

function applyExceptionGroupFieldsForChildException(
  exception,
  source,
  exceptionId,
  parentId,
) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    type: 'chained',
    source,
    exception_id: exceptionId,
    parent_id: parentId,
  };
}

/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(exception => {
    if (exception.value) {
      exception.value = truncate(exception.value, maxValueLength);
    }
    return exception;
  });
}


//# sourceMappingURL=aggregate-errors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/linkederrors.js



const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {
    this.name = LinkedErrors.id;
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /** @inheritdoc */
   setupOnce() {
    // noop
  }

  /**
   * @inheritDoc
   */
   preprocessEvent(event, hint, client) {
    const options = client.getOptions();

    applyAggregateErrorsToEvent(
      exceptionFromError,
      options.stackParser,
      options.maxValueLength,
      this._key,
      this._limit,
      event,
      hint,
    );
  }
} LinkedErrors.__initStatic();


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/httpcontext.js


/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */

   constructor() {
    this.name = HttpContext.id;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    // noop
  }

  /** @inheritDoc */
   preprocessEvent(event) {
    // if none of the information we want exists, don't bother
    if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
      return;
    }

    // grab as much info as exists and add it to the event
    const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
    const { referrer } = helpers_WINDOW.document || {};
    const { userAgent } = helpers_WINDOW.navigator || {};

    const headers = {
      ...(event.request && event.request.headers),
      ...(referrer && { Referer: referrer }),
      ...(userAgent && { 'User-Agent': userAgent }),
    };
    const request = { ...event.request, ...(url && { url }), headers };

    event.request = request;
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

   constructor() {
    this.name = Dedupe.id;
  }

  /** @inheritDoc */
   setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
  }

  /**
   * @inheritDoc
   */
   processEvent(currentEvent) {
    // We want to ignore any non-error type events, e.g. transactions or replays
    // These should never be deduped, and also not be compared against as _previousEvent.
    if (currentEvent.type) {
      return currentEvent;
    }

    // Juuust in case something goes wrong
    try {
      if (dedupe_shouldDropEvent(currentEvent, this._previousEvent)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Event dropped due to being a duplicate of previously captured event.');
        return null;
      }
    } catch (_oO) {} // eslint-disable-line no-empty

    return (this._previousEvent = currentEvent);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-expect-error Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = createStackParser(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return rejectedSyncPromise(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new SyncPromise((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void resolvedSyncPromise(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return resolvedSyncPromise();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return resolvedSyncPromise();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if (isNativeFetch(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return rejectedSyncPromise(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new SyncPromise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: stackParserFromStackParserOptions(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || (supportsFetch() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = hub_getCurrentHub();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  addInstrumentationHandler('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub(hub_getCurrentHub());
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = getCurrentHub().getClient();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  const opts = {
    _metadata: {} ,
    ...options,
  };

  opts._metadata.sdk = opts._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(opts);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!isString(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/tracing.js



const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}

/**
 * Create tracing context from incoming headers.
 */
function tracingContextFromHeaders(
  sentryTrace,
  baggage,
)

 {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  const propagationContext = {
    traceId: traceId || misc_uuid4(),
    spanId: misc_uuid4().substring(16),
    sampled: parentSampled,
  };

  if (parentSpanId) {
    propagationContext.parentSpanId = parentSpanId;
  }

  if (dynamicSamplingContext) {
    propagationContext.dsc = dynamicSamplingContext ;
  }

  return {
    traceparentData,
    dynamicSamplingContext,
    propagationContext,
  };
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(
  traceId = misc_uuid4(),
  spanId = misc_uuid4().substring(16),
  sampled,
) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/span.js


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {

   constructor(maxlen = 1000) {
    this._maxlen = maxlen;
    this.spans = [];
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */

  /**
   * The origin of the span, giving context about what created the span.
   */

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext = {}) {
    this.traceId = spanContext.traceId || misc_uuid4();
    this.spanId = spanContext.spanId || misc_uuid4().substring(16);
    this.startTimestamp = spanContext.startTimestamp || (0,esm_time/* timestampInSeconds */.ph)();
    this.tags = spanContext.tags || {};
    this.data = spanContext.data || {};
    this.instrumenter = spanContext.instrumenter || 'sentry';
    this.origin = spanContext.origin || 'manual';

    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.name) {
      this.description = spanContext.name;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }

  /** An alias for `description` of the Span. */
   get name() {
    return this.description || '';
  }
  /** Update the name of the span. */
   set name(name) {
    this.setName(name);
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      logger_logger.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    this.setData('http.response.status_code', httpStatus);
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   setName(name) {
    this.description = name;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        logger_logger.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,esm_time/* timestampInSeconds */.ph)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    return generateSentryTraceHeader(this.traceId, this.spanId, this.sampled);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return dropUndefinedKeys({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return dropUndefinedKeys({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return dropUndefinedKeys({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
      origin: this.origin,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/transaction.js





/** JSDoc */
class Transaction extends Span  {

  /**
   * The reference to the current hub.
   */

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);
    // We need to delete description since it's set by the Span class constructor
    // but not needed for transactions.
    delete this.description;

    this._measurements = {};
    this._contexts = {};

    this._hub = hub || hub_getCurrentHub();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new SpanRecorder(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    const transaction = this._finishTransaction(endTimestamp);
    if (!transaction) {
      return undefined;
    }
    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return dropUndefinedKeys({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || hub_getCurrentHub();
    const client = hub.getClient();

    if (!client) return {};

    const scope = hub.getScope();
    const dsc = getDynamicSamplingContextFromClient(this.traceId, client, scope);

    const maybeSampleRate = this.metadata.sampleRate;
    if (maybeSampleRate !== undefined) {
      dsc.sample_rate = `${maybeSampleRate}`;
    }

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = this.metadata.source;
    if (source && source !== 'url') {
      dsc.transaction = this.name;
    }

    if (this.sampled !== undefined) {
      dsc.sampled = String(this.sampled);
    }

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
   setHub(hub) {
    this._hub = hub;
  }

  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
   _finishTransaction(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return transaction;
  }
}


//# sourceMappingURL=transaction.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/idletransaction.js




const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends SpanRecorder {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,esm_time/* timestampInSeconds */.ph)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends Transaction {
  // Activities store a list of active spans

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.

  // We should not use heartbeat if we finished a transaction

  // Idle timeout was canceled and we should finish the transaction with the last span end.

  /**
   * Timer that tracks Transaction idleTimeout
   */

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;
    this.activities = {};
    this._heartbeatCounter = 0;
    this._finished = false;
    this._idleTimeoutCanceledPermanently = false;
    this._beforeFinishCallbacks = [];
    this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];

    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._restartIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,esm_time/* timestampInSeconds */.ph)()) {
    this._finished = true;
    this.activities = {};

    if (this.op === 'ui.action.click') {
      this.setTag(FINISH_REASON_TAG, this._finishReason);
    }

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            logger_logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const spanStartedBeforeTransactionFinish = span.startTimestamp < endTimestamp;

        // Add a delta with idle timeout so that we prevent false positives
        const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
        const spanEndedBeforeFinalTimeout = span.endTimestamp - this.startTimestamp < timeoutWithMarginOfError;

        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          const stringifiedSpan = JSON.stringify(span, undefined, 2);
          if (!spanStartedBeforeTransactionFinish) {
            logger_logger.log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
          } else if (!spanEndedBeforeFinalTimeout) {
            logger_logger.log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
          }
        }

        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      const scope = this._idleHub.getScope();
      if (scope.getTransaction() === this) {
        scope.setSpan(undefined);
      }
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,esm_time/* timestampInSeconds */.ph)();
      if (this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/utils.js



/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || hub_getCurrentHub();
  const scope = hub.getScope();
  return scope.getTransaction() ;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/errors.js



let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  addInstrumentationHandler('error', errorCallback);
  addInstrumentationHandler('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = getActiveTransaction();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/sampling.js



/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */
function sampleTransaction(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!hasTracingEnabled(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setMetadata({
      sampleRate,
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (is_isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}


//# sourceMappingURL=sampling.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/hubextensions.js







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': span.toTraceparent(),
      }
    : {};
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new Transaction(transactionContext, this);
  transaction = sampleTransaction(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new IdleTransaction(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sampleTransaction(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = getMainCarrier();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = getActiveTransaction() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger_logger.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger_logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      // eslint-disable-next-line deprecation/deprecation
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/instrument.js






const instrument_handlers = {};
const instrument_instrumented = {};

let _previousCls;
let _previousFid;
let _previousLcp;

/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addClsInstrumentationHandler(callback) {
  return addMetricObserver('cls', callback, instrumentCls, _previousCls);
}

/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addLcpInstrumentationHandler(callback) {
  return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addFidInstrumentationHandler(callback) {
  return addMetricObserver('fid', callback, instrumentFid, _previousFid);
}

/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addPerformanceInstrumentationHandler(
  type,
  callback,
) {
  addHandler(type, callback);

  if (!instrument_instrumented[type]) {
    instrumentPerformanceObserver(type);
    instrument_instrumented[type] = true;
  }

  return getCleanupCallback(type, callback);
}

/** Trigger all handlers of a given type. */
function instrument_triggerHandlers(type, data) {
  const typeHandlers = instrument_handlers[type];

  if (!typeHandlers || !typeHandlers.length) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${getFunctionName(handler)}\nError:`,
          e,
        );
    }
  }
}

function instrumentCls() {
  onCLS(metric => {
    instrument_triggerHandlers('cls', {
      metric,
    });
    _previousCls = metric;
  });
}

function instrumentFid() {
  onFID(metric => {
    instrument_triggerHandlers('fid', {
      metric,
    });
    _previousFid = metric;
  });
}

function instrumentLcp() {
  onLCP(metric => {
    instrument_triggerHandlers('lcp', {
      metric,
    });
    _previousLcp = metric;
  });
}

function addMetricObserver(
  type,
  callback,
  instrumentFn,
  previousValue,
) {
  addHandler(type, callback);

  if (!instrument_instrumented[type]) {
    instrumentFn();
    instrument_instrumented[type] = true;
  }

  if (previousValue) {
    callback({ metric: previousValue });
  }

  return getCleanupCallback(type, callback);
}

function instrumentPerformanceObserver(type) {
  const options = {};

  // Special per-type options we want to use
  if (type === 'event') {
    options.durationThreshold = 0;
  }

  observe(
    type,
    entries => {
      instrument_triggerHandlers(type, { entries });
    },
    options,
  );
}

function addHandler(type, handler) {
  instrument_handlers[type] = instrument_handlers[type] || [];
  (instrument_handlers[type] ).push(handler);
}

// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback) {
  return () => {
    const typeHandlers = instrument_handlers[type];

    if (!typeHandlers) {
      return;
    }

    const index = typeHandlers.indexOf(callback);
    if (index !== -1) {
      typeHandlers.splice(index, 1);
    }
  };
}


//# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js







/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    const fidCallback = _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();

    return () => {
      fidCallback();
      clsCallback();
      lcpCallback();
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  addPerformanceInstrumentationHandler('longtask', ({ entries }) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  });
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  addPerformanceInstrumentationHandler('event', ({ entries }) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        transaction.startChild({
          description: htmlTreeAsString(entry.target),
          op: `ui.interaction.${entry.name}`,
          origin: 'auto.ui.browser.metrics',
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        });
      }
    }
  });
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  return addClsInstrumentationHandler(({ metric }) => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return addLcpInstrumentationHandler(({ metric }) => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  return addFidInstrumentationHandler(({ metric }) => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
        requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    origin: 'auto.resource.browser.metrics',
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: 'request',
    startTimestamp: timeOrigin + msToSec(entry.requestStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: 'response',
    startTimestamp: timeOrigin + msToSec(entry.responseStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['http.response_transfer_size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['http.response_content_length'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['http.decoded_response_content_length'] = entry.decodedBodySize;
  }
  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    origin: 'auto.resource.browser.metrics',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', htmlTreeAsString(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, htmlTreeAsString(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/request.js




/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  const {
    traceFetch,
    traceXHR,
    // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
  } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    addInstrumentationHandler('fetch', (handlerData) => {
      const createdSpan = fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }

  if (traceXHR) {
    addInstrumentationHandler('xhr', (handlerData) => {
      const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}

function isPerformanceResourceTiming(entry) {
  return (
    entry.entryType === 'resource' &&
    'initiatorType' in entry &&
    typeof (entry ).nextHopProtocol === 'string' &&
    (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
  );
}

/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */
function addHTTPTimings(span) {
  const url = span.data.url;

  if (!url) {
    return;
  }

  const cleanup = addPerformanceInstrumentationHandler('resource', ({ entries }) => {
    entries.forEach(entry => {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        const spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(data => span.setData(...data));
        // In the next tick, clean this handler up
        // We have to wait here because otherwise this cleans itself up before it is fully done
        setTimeout(cleanup);
      }
    });
  });
}

/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */
function extractNetworkProtocol(nextHopProtocol) {
  let name = 'unknown';
  let version = 'unknown';
  let _name = '';
  for (const char of nextHopProtocol) {
    // http/1.1 etc.
    if (char === '/') {
      [name, version] = nextHopProtocol.split('/');
      break;
    }
    // h2, h3 etc.
    if (!isNaN(Number(char))) {
      name = _name === 'h' ? 'http' : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }
  return { name, version };
}

function getAbsoluteTime(time = 0) {
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}

function resourceTimingEntryToSpanData(resourceTiming) {
  const { name, version } = extractNetworkProtocol(resourceTiming.nextHopProtocol);

  const timingSpanData = [];

  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);

  if (!esm_time/* browserPerformanceTimeOrigin */.Z1) {
    return timingSpanData;
  }
  return [
    ...timingSpanData,
    ['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)],
    ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)],
    ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)],
    ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)],
    ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)],
    ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)],
    ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)],
    ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)],
    ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)],
    ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)],
  ];
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return stringMatchesSomePattern(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!hasTracingEnabled() || !handlerData.fetchData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);

  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);

        const contentLength =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

        const contentLengthNum = parseInt(contentLength);
        if (contentLengthNum > 0) {
          span.setData('http.response_content_length', contentLengthNum);
        }
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const hub = hub_getCurrentHub();
  const scope = hub.getScope();
  const client = hub.getClient();
  const parentSpan = scope.getSpan();

  const { method, url } = handlerData.fetchData;

  const span =
    shouldCreateSpanResult && parentSpan
      ? parentSpan.startChild({
          data: {
            url,
            type: 'fetch',
            'http.method': method,
          },
          description: `${method} ${url}`,
          op: 'http.client',
          origin: 'auto.http.browser',
        })
      : undefined;

  if (span) {
    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;
  }

  if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span);
  }

  return span;
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  client,
  scope,
  options

,
  requestSpan,
) {
  const span = requestSpan || scope.getSpan();

  const transaction = span && span.transaction;

  const { traceId, sampled, dsc } = scope.getPropagationContext();

  const sentryTraceHeader = span ? span.toTraceparent() : generateSentryTraceHeader(traceId, undefined, sampled);
  const dynamicSamplingContext = transaction
    ? transaction.getDynamicSamplingContext()
    : dsc
    ? dsc
    : getDynamicSamplingContextFromClient(traceId, client, scope);

  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

  const headers =
    typeof Request !== 'undefined' && isInstanceOf(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && isInstanceOf(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
// eslint-disable-next-line complexity
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[SENTRY_XHR_DATA_KEY];

  if (!hasTracingEnabled() || (xhr && xhr.__sentry_own_request__) || !xhr || !sentryXhrData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(sentryXhrData.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const hub = hub_getCurrentHub();
  const scope = hub.getScope();
  const parentSpan = scope.getSpan();

  const span =
    shouldCreateSpanResult && parentSpan
      ? parentSpan.startChild({
          data: {
            ...sentryXhrData.data,
            type: 'xhr',
            'http.method': sentryXhrData.method,
            url: sentryXhrData.url,
          },
          description: `${sentryXhrData.method} ${sentryXhrData.url}`,
          op: 'http.client',
          origin: 'auto.http.browser',
        })
      : undefined;

  if (span) {
    xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
  }

  if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
    if (span) {
      const transaction = span && span.transaction;
      const dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
      const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
      setHeaderOnXhr(xhr, span.toTraceparent(), sentryBaggageHeader);
    } else {
      const client = hub.getClient();
      const { traceId, sampled, dsc } = scope.getPropagationContext();
      const sentryTraceHeader = generateSentryTraceHeader(traceId, undefined, sampled);
      const dynamicSamplingContext =
        dsc || (client ? getDynamicSamplingContextFromClient(traceId, client, scope) : undefined);
      const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
      setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
  }

  return span;
}

function setHeaderOnXhr(
  xhr,
  sentryTraceHeader,
  sentryBaggageHeader,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }
  } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      origin: 'auto.pageload.browser',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    addInstrumentationHandler('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          origin: 'auto.navigation.browser',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js








const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */

   constructor(_options) {
    this.name = BROWSER_TRACING_INTEGRATION_ID;
    this._hasSetTracePropagationTargets = false;

    addTracingExtensions();

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      this._hasSetTracePropagationTargets = !!(
        _options &&
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      );
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;
    const hub = getCurrentHub();
    const client = hub.getClient();
    const clientOptions = client && client.getOptions();

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
      _experiments,
    } = this.options;

    const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
    // There are three ways to configure tracePropagationTargets:
    // 1. via top level client option `tracePropagationTargets`
    // 2. via BrowserTracing option `tracePropagationTargets`
    // 3. via BrowserTracing option `tracingOrigins` (deprecated)
    //
    // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
    // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
    // This is done as it minimizes bundle size (we don't have to have undefined checks).
    //
    // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
    // eslint-disable-next-line deprecation/deprecation
    const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
      logger_logger.warn(
        '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
      );
    }

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const hub = this._getCurrentHub();

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
    const baggage = isPageloadTransaction ? getMetaContent('baggage') : '';
    const { traceparentData, dynamicSamplingContext, propagationContext } = tracingContextFromHeaders(
      sentryTrace,
      baggage,
    );

    const expandedContext = {
      ...context,
      ...traceparentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger_logger.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = types_WINDOW;

    const idleTransaction = startIdleTransaction(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );

    const scope = hub.getScope();

    // If it's a pageload and there is a meta tag set
    // use the traceparentData as the propagation context
    if (isPageloadTransaction && traceparentData) {
      scope.setPropagationContext(propagationContext);
    } else {
      // Navigation transactions should set a new propagation context based on the
      // created idle transaction.
      scope.setPropagationContext({
        traceId: idleTransaction.traceId,
        spanId: idleTransaction.spanId,
        parentSpanId: idleTransaction.parentSpanId,
        sampled: idleTransaction.sampled,
      });
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      const currentTransaction = getActiveTransaction();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger_logger.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger_logger.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = startIdleTransaction(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = getDomElement(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(4406);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
    nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = hub_getCurrentHub().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, params, sentryTrace, baggage } = extractNextDataTagInformation();
  const { traceparentData, dynamicSamplingContext, propagationContext } = tracingContextFromHeaders(
    sentryTrace,
    baggage,
  );

  hub_getCurrentHub().getScope().setPropagationContext(propagationContext);
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceparentData,
      metadata: {
        source,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const strippedNavigationTarget = stripUrlQueryAndFragment(navigationTarget);
      const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = strippedNavigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
          origin: 'auto.navigation.nextjs',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsnFromString(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/index.js


























// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  const opts = {
    environment: getVercelEnv(true) || "production",
    ...options,
  };

  applyTunnelRouteOption(opts);
  buildMetadata(opts, ['nextjs', 'react']);

  addClientIntegrations(opts);

  sdk_init(opts);

  configureScope(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if (hasTracingEnabled(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./sentry.client.config.js
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;

_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
  "id": "TM7c0PIsYN3PYMy9108Cp"
};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/tripmoney/apps/landing-pages";

var SENTRY_DSN = "https://c7d0bbd368d04cb6958a0b578b915efd@o162542.ingest.sentry.io/4504931665248256";

if (true) {
  client_init({
    dsn: SENTRY_DSN,
    tracesSampleRate: 1.0
  });
}

/***/ }),

/***/ 7581:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 2817:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

var _slicedToArray = __webpack_require__(4429);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(5154)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _router = __webpack_require__(7744);

var _addLocale = __webpack_require__(7640);

var _routerContext = __webpack_require__(7258);

var _appRouterContext = __webpack_require__(4117);

var _useIntersection = __webpack_require__(1514);

var _getDomainLocale = __webpack_require__(7581);

var _addBasePath = __webpack_require__(5409);

'use client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options)).catch(function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push'; // Apply `as` if it's provided.

      router[method](as || href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react.default.startTransition(navigate);
  } else {
    navigate();
  }
}
/**
 * React Component that enables client-side transitions between routes.
 */


var Link = /*#__PURE__*/_react.default.forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(true) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react.default.useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react.default.useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react.default.useRef(href);

  var previousAs = _react.default.useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react.default.Children.only(children);
    }
  } else {
    if (false) { var ref; }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react.default.useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react.default.useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react.default.cloneElement(child, childProps) : /*#__PURE__*/_react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(4429);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(2784);

var _requestIdleCallback = __webpack_require__(1859);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 2403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var AmpStateContext = _react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 4117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

'use client';

var AppRouterContext = _react.default.createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react.default.createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react.default.createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react.default.createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 2795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadable = _interop_require_default(__webpack_require__(4949));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 3233:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(199)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(2784));

var _sideEffect = _interop_require_default(__webpack_require__(4381));

var _ampContext = __webpack_require__(2403);

var _headManagerContext = __webpack_require__(5285);

var _ampMode = __webpack_require__(7309);

var _utils = __webpack_require__(3177);

'use client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react.default.cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 9749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var LoadableContext = _react.default.createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 4949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(2624);

var _createClass = __webpack_require__(5458);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadableContext = __webpack_require__(9749);

var _ref =  true ? __webpack_require__(2784) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react.default.useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react.default.forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks.delete(callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 4381:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(199)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(2784));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.delete(props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 4178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AppUpdateModal": function() { return /* reexport */ AppUpdateModal; },
  "EmailLoginModal": function() { return /* reexport */ EmailLoginModal; },
  "LoginErrorModal": function() { return /* reexport */ LoginErrorModal; },
  "MMTLogin": function() { return /* reexport */ MMTLogin; },
  "delay": function() { return /* reexport */ delay; },
  "getAuth": function() { return /* reexport */ tmAuth_getAuth; },
  "getMyAccountType": function() { return /* reexport */ getMyAccountType; },
  "isAuthBridgesPresent": function() { return /* reexport */ isAuthBridgesPresent; },
  "isPartnerLoggedIn": function() { return /* reexport */ isPartnerLoggedIn; },
  "isUserLoggedin": function() { return /* reexport */ isUserLoggedin; },
  "loginIfPartnerLoggedin": function() { return /* reexport */ loginIfPartnerLoggedin; },
  "loginToPartner": function() { return /* reexport */ loginToPartner; },
  "logout": function() { return /* reexport */ logout; },
  "setUtmParamStr": function() { return /* reexport */ setUtmParamStr; },
  "useAuthentication": function() { return /* reexport */ useAuthentication; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/auth/src/lib/constants/index.ts
var constants = __webpack_require__(4823);
// EXTERNAL MODULE: ../../libs/auth/src/lib/common/index.ts
var common = __webpack_require__(5806);
// EXTERNAL MODULE: ../../libs/auth/src/lib/common/cookieUtils.ts
var cookieUtils = __webpack_require__(8631);
// EXTERNAL MODULE: ../../node_modules/MMT-UI/visitorDvid/visitorDvid.js
var visitorDvid = __webpack_require__(8277);
var visitorDvid_default = /*#__PURE__*/__webpack_require__.n(visitorDvid);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/common/fetchApi.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function fetchApi(_x) {
  return _fetchApi.apply(this, arguments);
}

function _fetchApi() {
  _fetchApi = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(url) {
    var options,
        timeout,
        _options$maxRetries,
        maxRetries,
        _options$retryDelay,
        retryDelay,
        _options$headers,
        headers,
        _options$method,
        method,
        _options$data,
        data,
        retries,
        _ret,
        _args2 = arguments;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            timeout = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 10000;
            _options$maxRetries = options.maxRetries, maxRetries = _options$maxRetries === void 0 ? 1 : _options$maxRetries, _options$retryDelay = options.retryDelay, retryDelay = _options$retryDelay === void 0 ? 1000 : _options$retryDelay, _options$headers = options.headers, headers = _options$headers === void 0 ? {} : _options$headers, _options$method = options.method, method = _options$method === void 0 ? "GET" : _options$method, _options$data = options.data, data = _options$data === void 0 ? null : _options$data;
            retries = 1;

          case 4:
            if (!(retries <= maxRetries)) {
              _context2.next = 24;
              break;
            }

            _context2.prev = 5;
            return _context2.delegateYield( /*#__PURE__*/regenerator_default().mark(function _callee() {
              var controller, signal, tmAuthHeaders, response, responseData;
              return regenerator_default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      controller = new AbortController();
                      signal = controller.signal;
                      setTimeout(function () {
                        return controller.abort();
                      }, timeout);
                      tmAuthHeaders = url !== null && url !== void 0 && url.includes("/pdt") || url !== null && url !== void 0 && url.includes((0,constants/* APP_SOCIAL_URL */.ku)((0,common/* getPartner */.kW)())) || url !== null && url !== void 0 && url.includes((0,constants/* GET_SLT_TOKEN_URL */.Ie)((0,common/* getPartner */.kW)())) ? {} : {
                        "x-tm-auth": (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "",
                        partner: (0,common/* getPartner */.kW)() || "",
                        credentials: "include"
                      };
                      _context.next = 6;
                      return fetch(url, {
                        method: method,
                        headers: _objectSpread(_objectSpread({
                          "Content-Type": "application/json"
                        }, headers), tmAuthHeaders),
                        body: data && JSON.stringify(data),
                        signal: signal
                      });

                    case 6:
                      response = _context.sent;

                      if (!(response.status === 500)) {
                        _context.next = 9;
                        break;
                      }

                      throw new Error("Internal Server Error");

                    case 9:
                      if (!(response.status === 404)) {
                        _context.next = 11;
                        break;
                      }

                      throw new Error("Resource Not Found");

                    case 11:
                      _context.next = 13;
                      return response.json();

                    case 13:
                      responseData = _context.sent;
                      return _context.abrupt("return", {
                        v: responseData
                      });

                    case 15:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })(), "t0", 7);

          case 7:
            _ret = _context2.t0;

            if (!(typeof _ret === "object")) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 10:
            _context2.next = 22;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t1 = _context2["catch"](5);

            if (!(_context2.t1.name === "AbortError")) {
              _context2.next = 17;
              break;
            }

            console.error("Request cancelled");
            throw new Error("Request cancelled");

          case 17:
            console.error(_context2.t1);
            retries++;
            _context2.next = 21;
            return new Promise(function (resolve) {
              return setTimeout(resolve, retryDelay);
            });

          case 21:
            return _context2.abrupt("continue", 4);

          case 22:
            _context2.next = 4;
            break;

          case 24:
            throw new Error("Failed to fetch API after ".concat(maxRetries, " attempts."));

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 12]]);
  }));
  return _fetchApi.apply(this, arguments);
}
// EXTERNAL MODULE: ../../libs/auth/src/lib/methods/bridgeMethods.ts
var bridgeMethods = __webpack_require__(7931);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/api/auth.ts



function auth_getAuth(_x) {
  return _getAuth.apply(this, arguments);
}

function _getAuth() {
  _getAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var response, responseData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(AppSocialLogin, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: AUTHTOKEN,
                //TODO
                "User-Identifier": '{"type" :"auth","value":"","deviceId":"device1","os":"android","osVersion":"6.0.0","appVersion":"5.4.1","imie":"132342354","ipAddress":"127.0.0.1","timeZone":"+5.30 GMT"}'
              },
              body: data
            });

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            responseData = _context.sent;

            if (!response.ok) {
              console.log("Code: ".concat(responseData === null || responseData === void 0 ? void 0 : responseData.code, ", Message: ").concat(responseData === null || responseData === void 0 ? void 0 : responseData.message));
            }

            return _context.abrupt("return", responseData);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAuth.apply(this, arguments);
}
;// CONCATENATED MODULE: ../../libs/auth/src/lib/methods/loginWithMobile.ts






function fetchTmAuthFromSLT(_x, _x2) {
  return _fetchTmAuthFromSLT.apply(this, arguments);
}

function _fetchTmAuthFromSLT() {
  _fetchTmAuthFromSLT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(authData, appSocialLoginResponse) {
    var response, _response$data, _response$data$profil, _response$data$profil2, catchTmAuth;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getAuth(authData);

          case 2:
            response = _context5.sent;

            if ((response === null || response === void 0 ? void 0 : response.message) === "SUCCESS") {
              catchTmAuth = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$profil = _response$data.profileLoginResponse) === null || _response$data$profil === void 0 ? void 0 : (_response$data$profil2 = _response$data$profil[0]) === null || _response$data$profil2 === void 0 ? void 0 : _response$data$profil2.authToken;
              saveTMToken(catchTmAuth);
              appSocialLoginResponse(true);
            } else if (response.code === 4401) {
              appSocialLoginResponse(response.code);
            } else {
              appSocialLoginResponse(response.code);
            }

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchTmAuthFromSLT.apply(this, arguments);
}

function loginWithMobile_loginWithMobile(_ref) {
  var props = _ref.props,
      isUserLogged = _ref.isUserLogged;
  var partner = getPartner();

  function generateTmAuth(_x3) {
    return _generateTmAuth.apply(this, arguments);
  }

  function _generateTmAuth() {
    _generateTmAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
      var authData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              authData = JSON.stringify({
                accType: partner === MakeMyTrip ? "MMT" : "GI",
                authToken: token
              });
              _context.next = 3;
              return fetchTmAuthFromSLT(authData, isUserLogged);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _generateTmAuth.apply(this, arguments);
  }

  window.onLoginSuccess = function (auth) {
    getSLToken(partner);
  };

  window.onLoginCancelled = function () {
    isUserLogged(false);
  };

  window.shortLivToken = function (token) {
    generateTmAuth(token);
  };

  loginUser(props === null || props === void 0 ? void 0 : props.loginOptions);
}
function loginWithMobile_editNumberReLogin(_ref2) {
  var props = _ref2.props,
      isUserLogged = _ref2.isUserLogged;
  var partner = getPartner();

  function generateTmAuth(_x4) {
    return _generateTmAuth2.apply(this, arguments);
  }

  function _generateTmAuth2() {
    _generateTmAuth2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(token) {
      var authData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              authData = JSON.stringify({
                accType: partner === MakeMyTrip ? "MMT" : "GI",
                authToken: token
              });
              _context2.next = 3;
              return fetchTmAuthFromSLT(authData, isUserLogged);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _generateTmAuth2.apply(this, arguments);
  }

  window.onLoginSuccess = function (auth) {
    getSLToken(partner);
  };

  window.onLoginCancelled = function () {
    isUserLogged(false);
  };

  window.shortLivToken = function (token) {
    generateTmAuth(token);
  };

  reloginUser(props === null || props === void 0 ? void 0 : props.loginOptions);
}
var loginWithMobile_generateNewAuth = function generateNewAuth() {
  var partner = getPartner();
  var promise = new Promise(function (resolve, reject) {
    var isNewAuthGenerated = function isNewAuthGenerated(response) {
      if (response) {
        resolve(true);
      } else {
        reject(response);
      }
    };

    function generateTmAuth(_x5) {
      return _generateTmAuth3.apply(this, arguments);
    }

    function _generateTmAuth3() {
      _generateTmAuth3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(token) {
        var authData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                authData = JSON.stringify({
                  accType: partner === MakeMyTrip ? "MMT" : "GI",
                  authToken: token
                });
                _context4.next = 3;
                return fetchTmAuthFromSLT(authData, isNewAuthGenerated);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _generateTmAuth3.apply(this, arguments);
    }

    window.shortLivToken = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(token) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return generateTmAuth(token);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x6) {
        return _ref3.apply(this, arguments);
      };
    }();

    getSLToken(partner);
  });
  return promise;
};
// EXTERNAL MODULE: ../../node_modules/MMT-UI/storages/client/localStorage/index.js
var localStorage = __webpack_require__(156);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/common/clientStorageUtils.ts
// prettier-ignore
//@ts-ignore
 // prettier-ignore
//@ts-ignore



/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = localStorage.itemType.ES,
    N_ES = localStorage.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
} // local storage utils


function setLocalStorage(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = getUtilOptions(options);
  setLocalStorageItem(key, value, options, getEssentialItemType(isEssential));
}
function getLocalStorage(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = getUtilOptions(options);
  return getLocalStorageItem(key, options, getEssentialItemType(isEssential));
}
function deleteLocalStorage(key) {
  removeLocalStorageItem(key);
} // sesstion storage utils

function clientStorageUtils_setSessionStorageItem(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = getUtilOptions(options);
  setItemBySession(key, value, options, getEssentialItemType(isEssential));
}
function getSessionStorageItem(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = getUtilOptions(options);
  return getItemBySession(key, options, getEssentialItemType(isEssential));
}
function removeSessionStorageItem(key) {
  removeItemBySession(key);
}
;// CONCATENATED MODULE: ../../libs/auth/src/lib/methods/index.ts








// To edit phone number.
function editNumberLogin(props) {
  var onApp = isApp();

  if (onApp) {
    var promise = new Promise(function (resolve, reject) {
      var isUserLogged = function isUserLogged(response) {
        if (response === true) {
          resolve(true);
        } else {
          reject(response);
        }
      };

      editNumberReLogin({
        props: props,
        isUserLogged: isUserLogged
      });
    });
    return promise;
  } else {
    return;
  }
}
function login(props) {
  var onApp = isApp();

  if (onApp) {
    var promise = new Promise(function (resolve, reject) {
      var isUserLogged = function isUserLogged(response) {
        if (response === true) {
          resolve(true);
        } else {
          reject(response);
        }
      };

      loginWithMobile({
        props: props,
        isUserLogged: isUserLogged
      });
    });
    return promise;
  } else {
    return;
  }
}
var getTmAuth = function getTmAuth() {
  var onApp = isApp();

  if (onApp) {
    return getTmToken();
  } else {
    return getCookie("tm-auth", true);
  }
};
var refreshTmAuth = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var onApp, tmToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            onApp = isApp();

            if (!onApp) {
              _context.next = 10;
              break;
            }

            _context.next = 4;
            return generateNewAuth();

          case 4:
            _context.next = 6;
            return getTmToken();

          case 6:
            tmToken = _context.sent;
            return _context.abrupt("return", tmToken);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function refreshTmAuth() {
    return _ref.apply(this, arguments);
  };
}()));
var isUserLogin = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var onApp, isLoggedIn;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onApp = isApp();

            if (!onApp) {
              _context2.next = 6;
              break;
            }

            _context2.next = 4;
            return getUserLoginStatus();

          case 4:
            isLoggedIn = _context2.sent;
            return _context2.abrupt("return", isLoggedIn);

          case 6:
            return _context2.abrupt("return");

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function isUserLogin() {
    return _ref2.apply(this, arguments);
  };
}()));
var storeInSession = function storeInSession() {
  var tmAuth = getCookie("tm-auth", true);
  deleteSpecificCookie("tm-auth");
  setSessionStorageItem("tm-auth", tmAuth || "", true);
};
var encodeJSON = function encodeJSON(json) {
  var jsonStr = JSON.stringify(json);
  var encodedString = btoa(jsonStr);
  return encodedString;
};
var decodeJSON = function decodeJSON(str) {
  str = str.replace(/"/g, "");
  var decodedStr = atob(str);
  return JSON.parse(decodedStr);
};
var getTmAuthJsonForIos = function getTmAuthJsonForIos(partnerAuth, tmAuth) {
  return {
    tmAuth: tmAuth,
    tmPartnerAuth: "".concat(tmAuth, "___").concat(partnerAuth)
  };
};
var getTmAuthFromIosBridge = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(partner) {
    var tokenString, decodedJson;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0,bridgeMethods/* getTmToken */.Wd)();

          case 2:
            tokenString = _context3.sent;

            if (tokenString) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return");

          case 5:
            decodedJson = decodeJSON(tokenString);

            if (partner === constants/* MakeMyTrip */.yO) {
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, decodedJson.tmAuth, {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(decodedJson.tmPartnerAuth), {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
            } else if (partner === constants/* GoIbibo */.Y_) {
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, decodedJson.tmAuth, {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(decodedJson.tmPartnerAuth), {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
            }

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getTmAuthFromIosBridge(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var closeWebview = function closeWebview() {
  var _window, _window4, _window4$mmt_android_, _window$history;

  //@ts-ignore
  if ((_window = window) !== null && _window !== void 0 && _window.app_bridge) {
    if ((0,common/* getUserDeviceOS */.h0)() === constants/* ANDROID */.IP) {
      var _window2, _window2$app_bridge;

      //@ts-ignore
      (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$app_bridge = _window2.app_bridge) === null || _window2$app_bridge === void 0 ? void 0 : _window2$app_bridge.closeAndRefreshWebView();
    } else if ((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7) {
      var _window3, _window3$webkit$messa, _window3$webkit$messa2;

      // @ts-ignore
      (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$webkit$messa = _window3.webkit.messageHandlers) === null || _window3$webkit$messa === void 0 ? void 0 : (_window3$webkit$messa2 = _window3$webkit$messa.closeAndRefreshWebView) === null || _window3$webkit$messa2 === void 0 ? void 0 : _window3$webkit$messa2.postMessage(JSON.stringify(true));
    }

    return; //@ts-ignore
  } else if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$mmt_android_ = _window4.mmt_android_bridge) !== null && _window4$mmt_android_ !== void 0 && _window4$mmt_android_.closeWebView) {
    var _window5, _window5$mmt_android_;

    //@ts-ignore
    (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$mmt_android_ = _window5.mmt_android_bridge) === null || _window5$mmt_android_ === void 0 ? void 0 : _window5$mmt_android_.closeWebView(false);
    return;
  }

  (_window$history = window.history) === null || _window$history === void 0 ? void 0 : _window$history.back();
};
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(6364);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/api/tmAuth.ts



function tmAuth_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tmAuth_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tmAuth_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tmAuth_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




 //@ts-ignore




 //@ts-ignore


var getVisitorId = (visitorDvid_default()).getVisitorId;

var validateMmtAuth = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var isOnlyValidate,
        redirectUrl,
        tm_auth,
        mmt_auth,
        tm_mmt_auth,
        split_tm_mmt_auth,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isOnlyValidate = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            redirectUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";

            if (!((0,common/* isApp */.N0)() && !isAuthBridgesPresent())) {
              _context.next = 5;
              break;
            }

            //handle update app popup
            document.dispatchEvent((0,common/* getAppUpdateCustomEvent */.nC)({
              showModal: true
            }));
            return _context.abrupt("return", false);

          case 5:
            if (!((0,common/* isApp */.N0)() && (0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7)) {
              _context.next = 9;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)(false);
            _context.next = 9;
            return getTmAuthFromIosBridge(constants/* MakeMyTrip */.yO);

          case 9:
            tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true);
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            tm_mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, true);

            if (mmt_auth) {
              _context.next = 18;
              break;
            }

            if (!((0,common/* isApp */.N0)() && tm_auth)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", true);

          case 15:
            if (!isOnlyValidate) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", false);

          case 17:
            return _context.abrupt("return", partnerLogin(redirectUrl));

          case 18:
            if (!tm_auth) {
              _context.next = 32;
              break;
            }

            if (tm_mmt_auth) {
              _context.next = 23;
              break;
            }

            if (!isOnlyValidate) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", false);

          case 22:
            return _context.abrupt("return");

          case 23:
            split_tm_mmt_auth = tm_mmt_auth.split("___");

            if (!(mmt_auth !== split_tm_mmt_auth[1] || tm_auth !== split_tm_mmt_auth[0])) {
              _context.next = 28;
              break;
            }

            if (!isOnlyValidate) {
              _context.next = 27;
              break;
            }

            return _context.abrupt("return", false);

          case 27:
            return _context.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 28:
            if (!isOnlyValidate) {
              _context.next = 30;
              break;
            }

            return _context.abrupt("return", true);

          case 30:
            _context.next = 35;
            break;

          case 32:
            if (!isOnlyValidate) {
              _context.next = 34;
              break;
            }

            return _context.abrupt("return", false);

          case 34:
            return _context.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateMmtAuth() {
    return _ref.apply(this, arguments);
  };
}();

var validateGiAuth = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var isOnlyValidate,
        redirectUrl,
        tm_auth,
        gi_auth,
        tm_gi_auth,
        split_tm_mmt_auth,
        _args2 = arguments;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isOnlyValidate = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
            redirectUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "";

            if (!((0,common/* isApp */.N0)() && !isAuthBridgesPresent())) {
              _context2.next = 5;
              break;
            }

            //handle update app
            document.dispatchEvent((0,common/* getAppUpdateCustomEvent */.nC)({
              showModal: true
            }));
            return _context2.abrupt("return", false);

          case 5:
            if (!((0,common/* isApp */.N0)() && (0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7)) {
              _context2.next = 9;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)(false);
            _context2.next = 9;
            return getTmAuthFromIosBridge(constants/* GoIbibo */.Y_);

          case 9:
            tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            tm_gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, true);

            if (gi_auth) {
              _context2.next = 18;
              break;
            }

            if (!((0,common/* isApp */.N0)() && tm_auth)) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("return", true);

          case 15:
            if (!isOnlyValidate) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", false);

          case 17:
            return _context2.abrupt("return", partnerLogin(redirectUrl));

          case 18:
            if (!tm_auth) {
              _context2.next = 32;
              break;
            }

            if (tm_gi_auth) {
              _context2.next = 23;
              break;
            }

            if (!isOnlyValidate) {
              _context2.next = 22;
              break;
            }

            return _context2.abrupt("return", false);

          case 22:
            return _context2.abrupt("return");

          case 23:
            split_tm_mmt_auth = tm_gi_auth.split("___");

            if (!(gi_auth !== split_tm_mmt_auth[1] || tm_auth !== split_tm_mmt_auth[0])) {
              _context2.next = 28;
              break;
            }

            if (!isOnlyValidate) {
              _context2.next = 27;
              break;
            }

            return _context2.abrupt("return", false);

          case 27:
            return _context2.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 28:
            if (!isOnlyValidate) {
              _context2.next = 30;
              break;
            }

            return _context2.abrupt("return", true);

          case 30:
            _context2.next = 35;
            break;

          case 32:
            if (!isOnlyValidate) {
              _context2.next = 34;
              break;
            }

            return _context2.abrupt("return", false);

          case 34:
            return _context2.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function validateGiAuth() {
    return _ref2.apply(this, arguments);
  };
}();

var validateForexAgentAuth = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var isOnlyValidate,
        agent_auth,
        _args3 = arguments;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isOnlyValidate = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
            agent_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.FOREX_AGENT_AUTH_KEY */.E9.FOREX_AGENT_AUTH_KEY, true);

            if (agent_auth) {
              _context3.next = 6;
              break;
            }

            if (!isOnlyValidate) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", false);

          case 5:
            return _context3.abrupt("return", partnerLogin());

          case 6:
            if (!isOnlyValidate) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", true);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function validateForexAgentAuth() {
    return _ref3.apply(this, arguments);
  };
}();

var partnerLogin = function partnerLogin() {
  var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  (0,common/* removeTmMmmtAuthCookie */._A)();

  if ((0,common/* isApp */.N0)()) {
    //app bridge handling
    appLogin(redirectUrl);
  } else {
    if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
      mmtLoginRedirection();
    } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
      //handling for Goibibo
      goibiboLoginRedirection();
    }
  }
};

var setUtmParamStr = function setUtmParamStr() {
  var utmParams = (0,common/* fetchutmParamsFromCookie */.Tz)();
  var utm_source = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_source) || "no_source";
  var utm_medium = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_medium) || "";
  var utm_content = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_content) || "";
  var utm_campaign = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_campaign) || "";
  var utmStr = "".concat(utm_source ? "utm_source=".concat(utm_source) : "").concat(utm_medium ? "&utm_medium=".concat(utm_medium) : "").concat(utm_content ? "&utm_content=".concat(utm_content) : "").concat(utm_campaign ? "&utm_campaign=".concat(utm_campaign) : "");
  return utmStr;
}; // const loginHandlerGIDWeb = (encodedString: string, redirectUrl: string) => {
//     const url = `https://${process.env['NODE_ENV'] === 'production' ? "goibibo.com" : "newprodpp.goibibo.com"}/login/vendor/?lob=tripmoney&customData=${encodedString}&next=${redirectUrl}`
//     window.location.href = url;
// }
// const loginHandlerGIMweb = (encodedString: string, redirectUrl: string) => {
//     const url = `https://${process.env['NODE_ENV'] === 'production' ? "goibibo.com" : "newprodpp.goibibo.com"}/login/?lob=tripmoney&customData=${encodedString}&next=${redirectUrl}`
//     window.location.href = url;
// }

var mmtLoginRedirection = function mmtLoginRedirection() {
  var utmStr = setUtmParamStr() || "";

  if ((0,common/* getHostName */.Lp)() !== constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP && (0,common/* isMobile */.tq)()) {
    var redirectUrl = '"' + window.location.href + "".concat(utmStr ? "".concat(window.location.href.includes("?") ? "&" : "?").concat(utmStr) : "") + '"';
    (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.MMT_LOGIN_REDIRECT_KEY */.E9.MMT_LOGIN_REDIRECT_KEY, (0,common/* getHostName */.Lp)() === constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP ? constants/* MMT_FOREX_URL */.yY : redirectUrl, {
      path: "/",
      domain: constants/* MMT_SUB_DOMAIN */.FJ
    });
  }

  if ((0,common/* isMobile */.tq)()) {
    window.location.href = constants/* MMT_LOGIN_URL */.Cp;
  } else {
    document.dispatchEvent((0,common/* getMmtLoginCustomEvent */.jd)({
      activeModal: "LOGIN"
    })); // window.location.href = MMT_FOREX_URL;
  }
};

var goibiboLoginRedirection = function goibiboLoginRedirection() {
  var device = (0,common/* getUserDeviceOS */.h0)();
  var defaultCustomData = {
    userName: "",
    isSocial: false,
    isOnlyPhoneMode: true,
    isTokenEnable: true,
    prefillMobileNumber: "",
    isMobileNumberDisabled: false,
    enableTruecaller: false,
    skipMobileScreen: true,
    partner: "GI",
    userUrl: ""
  };
  var customDatajson = JSON.stringify(defaultCustomData);
  var encodedString = btoa(customDatajson);
  var utmStr = setUtmParamStr() || "";
  var redirectUrl = window.location.href + "".concat(utmStr ? "".concat(window.location.href.includes("?") ? "&" : "?").concat(utmStr) : "");

  if (device === constants/* DEVICE_OS.ANDROID */.Lh.ANDROID || device === constants/* DEVICE_OS.IOS */.Lh.IOS) {
    (0,constants/* loginHandlerGIMweb */.Dd)(encodedString, redirectUrl);
  } else {
    (0,constants/* loginHandlerGIDWeb */.ZO)(encodedString, redirectUrl);
  }
};

var generateTmAuthUsingPartnerAuth = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var tmAuthResultObj, sltTokenData, accountType, _sltTokenData$data, reqBody, tmAuthResponse, _tmAuthResponse$data, _tmAuthResponse$data$, _tmAuthResponse$data$2, _tmAuthResponse$data2, _tmAuthResponse$data3, _tmAuthResponse$data4, _tmAuthResponse$data5, _tmAuthResponse$data6, _tmAuthResponse$data7, _tmAuthResponse$data8, _tmAuthResponse$data9, _tmAuthResponse$data10, _tmAuthResponse$data11, _corporateData$employ, tmAuth, mmtAuth, giAuth, loginInfoList, isMobileRegistered, corporateData, phoneNumberVerified;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            tmAuthResultObj = (0,common/* getTmAuthDefaultObj */.hF)();

            if (!(0,common/* isApp */.N0)()) {
              _context4.next = 7;
              break;
            }

            _context4.next = 4;
            return getShortLiveTokenForApp();

          case 4:
            _context4.t0 = _context4.sent;
            _context4.next = 10;
            break;

          case 7:
            _context4.next = 9;
            return getShortLiveToken();

          case 9:
            _context4.t0 = _context4.sent;

          case 10:
            sltTokenData = _context4.t0;
            _context4.next = 13;
            return (0,common/* getAccountType */.lx)();

          case 13:
            accountType = _context4.sent;

            if (!(sltTokenData !== null && sltTokenData !== void 0 && sltTokenData.success)) {
              _context4.next = 42;
              break;
            }

            tmAuthResultObj.loginToken.success = true;
            reqBody = {
              accType: accountType,
              authToken: sltTokenData === null || sltTokenData === void 0 ? void 0 : (_sltTokenData$data = sltTokenData.data) === null || _sltTokenData$data === void 0 ? void 0 : _sltTokenData$data.encryptedToken,
              query: common/* getAppSocialLoginQuery */.GE
            };
            _context4.next = 19;
            return tmAuth_getAuth(reqBody);

          case 19:
            tmAuthResponse = _context4.sent;

            if (!(tmAuthResponse !== null && tmAuthResponse !== void 0 && tmAuthResponse.success)) {
              _context4.next = 39;
              break;
            }

            tmAuthResultObj.appSocialToken.success = true;
            tmAuth = tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data = tmAuthResponse.data) === null || _tmAuthResponse$data === void 0 ? void 0 : (_tmAuthResponse$data$ = _tmAuthResponse$data.profileLoginResponse) === null || _tmAuthResponse$data$ === void 0 ? void 0 : (_tmAuthResponse$data$2 = _tmAuthResponse$data$[0]) === null || _tmAuthResponse$data$2 === void 0 ? void 0 : _tmAuthResponse$data$2.authToken;
            mmtAuth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            giAuth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            loginInfoList = (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data2 = tmAuthResponse.data) === null || _tmAuthResponse$data2 === void 0 ? void 0 : (_tmAuthResponse$data3 = _tmAuthResponse$data2.profileLoginResponse) === null || _tmAuthResponse$data3 === void 0 ? void 0 : (_tmAuthResponse$data4 = _tmAuthResponse$data3[0]) === null || _tmAuthResponse$data4 === void 0 ? void 0 : (_tmAuthResponse$data5 = _tmAuthResponse$data4.userDetails) === null || _tmAuthResponse$data5 === void 0 ? void 0 : (_tmAuthResponse$data6 = _tmAuthResponse$data5.extendedUser) === null || _tmAuthResponse$data6 === void 0 ? void 0 : _tmAuthResponse$data6.loginInfoList) || [];
            isMobileRegistered = loginInfoList.find(function (e) {
              return (e === null || e === void 0 ? void 0 : e.loginType) === constants/* LOGIN_TYPE.MOBILE */.Ez.MOBILE;
            });
            corporateData = JSON.parse((tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data7 = tmAuthResponse.data) === null || _tmAuthResponse$data7 === void 0 ? void 0 : (_tmAuthResponse$data8 = _tmAuthResponse$data7.profileLoginResponse) === null || _tmAuthResponse$data8 === void 0 ? void 0 : (_tmAuthResponse$data9 = _tmAuthResponse$data8[0]) === null || _tmAuthResponse$data9 === void 0 ? void 0 : (_tmAuthResponse$data10 = _tmAuthResponse$data9.userDetails) === null || _tmAuthResponse$data10 === void 0 ? void 0 : (_tmAuthResponse$data11 = _tmAuthResponse$data10.extendedUser) === null || _tmAuthResponse$data11 === void 0 ? void 0 : _tmAuthResponse$data11.corporateData) || "{}");
            phoneNumberVerified = corporateData === null || corporateData === void 0 ? void 0 : (_corporateData$employ = corporateData.employee) === null || _corporateData$employ === void 0 ? void 0 : _corporateData$employ.phoneNumberVerified;

            if (!(!isMobileRegistered && !phoneNumberVerified)) {
              _context4.next = 36;
              break;
            }

            console.log("Error: Email login not supported");
            tmAuthResultObj.appSocialToken.success = false;
            tmAuthResultObj.appSocialToken.error = {
              code: "4401",
              description: "Email login not supported"
            };
            tmAuthResultObj.showEmailPopup = true;
            document.dispatchEvent((0,common/* getEmailLoginErrorCustomEvent */.V2)({
              showModal: true
            }));
            return _context4.abrupt("return", tmAuthResultObj);

          case 36:
            if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(tmAuth, "___").concat(mmtAuth), {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });

              if ((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7) {
                (0,bridgeMethods/* saveTMToken */.wE)(encodeJSON(getTmAuthJsonForIos(mmtAuth, tmAuth)));
              }
            } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              //handling for Goibibo
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(tmAuth, "___").concat(giAuth), {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });

              if ((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7) {
                (0,bridgeMethods/* saveTMToken */.wE)(encodeJSON(getTmAuthJsonForIos(giAuth, tmAuth)));
              }
            }

            _context4.next = 40;
            break;

          case 39:
            if ((tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : tmAuthResponse.code) === 4401) {
              console.log("Error: Email login not supported");
              tmAuthResultObj.appSocialToken.success = false;
              tmAuthResultObj.appSocialToken.error = {
                code: "4401",
                description: "Email login not supported"
              };
              tmAuthResultObj.showEmailPopup = true;
              document.dispatchEvent((0,common/* getEmailLoginErrorCustomEvent */.V2)({
                showModal: true
              })); // return {
              //     showEmailPopup: true
              // }
            } else {
              tmAuthResultObj.appSocialToken.success = false;
              tmAuthResultObj.appSocialToken.error = {
                code: (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : tmAuthResponse.code) || "UNKNOWN",
                description: (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : tmAuthResponse.message) || "Error in fetching tmAuth"
              };
              console.log("Error: In fetching tmAuth"); //show login fail popup

              document.dispatchEvent((0,common/* getLoginErrorCustomEvent */.FQ)({
                showModal: true
              }));
            }

          case 40:
            _context4.next = 48;
            break;

          case 42:
            tmAuthResultObj.loginToken.success = false;
            tmAuthResultObj.loginToken.error = {
              code: (sltTokenData === null || sltTokenData === void 0 ? void 0 : sltTokenData.code) || "UNKNOWN",
              description: (sltTokenData === null || sltTokenData === void 0 ? void 0 : sltTokenData.message) || "Error in fetching short live token"
            };
            console.log("Error: in fetching short live token"); //show login fail popup

            if (!(0,common/* isApp */.N0)()) {
              _context4.next = 47;
              break;
            }

            return _context4.abrupt("return", tmAuthResultObj);

          case 47:
            document.dispatchEvent((0,common/* getLoginErrorCustomEvent */.FQ)({
              showModal: true
            }));

          case 48:
            return _context4.abrupt("return", tmAuthResultObj);

          case 49:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function generateTmAuthUsingPartnerAuth() {
    return _ref4.apply(this, arguments);
  };
}();

var getShortLiveTokenForApp = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
    var promise;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            promise = new Promise(function (resolve, reject) {
              window.shortLivToken = function (token) {
                resolve({
                  success: token ? true : false,
                  data: {
                    encryptedToken: token
                  }
                });
              };

              try {
                if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
                  (0,bridgeMethods/* getSLToken */.gc)(constants/* MakeMyTrip */.yO);
                } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
                  (0,bridgeMethods/* getSLToken */.gc)(constants/* GoIbibo */.Y_);
                }
              } catch (err) {
                console.log("Error", err);
                resolve(null);
              }
            });
            return _context5.abrupt("return", promise);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getShortLiveTokenForApp() {
    return _ref5.apply(this, arguments);
  };
}();

var getShortLiveToken = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
    var _window, _window$app_bridge, _window$app_bridge$de;

    var mmt_auth, gi_auth, auth, deviceId, data, response;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            auth = "";
            deviceId = ((_window = window) === null || _window === void 0 ? void 0 : (_window$app_bridge = _window.app_bridge) === null || _window$app_bridge === void 0 ? void 0 : (_window$app_bridge$de = _window$app_bridge.deviceId) === null || _window$app_bridge$de === void 0 ? void 0 : _window$app_bridge$de.call(_window$app_bridge)) || getVisitorId();

            if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              auth = mmt_auth;
            } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              auth = gi_auth;
            }

            data = {
              client: "TM"
            };
            _context6.prev = 6;
            _context6.next = 9;
            return fetchApi((0,constants/* GET_SLT_TOKEN_URL */.Ie)((0,common/* getPartner */.kW)()), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: constants/* USER_SERVICE_TOKEN */.HL,
                "User-Identifier": (0,constants/* getUserIdentifier */.Xx)(auth, deviceId),
                deviceid: deviceId,
                "x-request-tracker": (0,v4/* default */.Z)()
              },
              data: data
            });

          case 9:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](6);
            console.log("Error", _context6.t0);
            return _context6.abrupt("return", null);

          case 17:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[6, 13]]);
  }));

  return function getShortLiveToken() {
    return _ref6.apply(this, arguments);
  };
}();

function tmAuth_getAuth(_x) {
  return api_tmAuth_getAuth.apply(this, arguments);
}

function api_tmAuth_getAuth() {
  api_tmAuth_getAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12(data) {
    var mmt_auth, gi_auth, auth, accountType, _window7, _window7$app_bridge, _window7$app_bridge$d, deviceId, headers, response;

    return regenerator_default().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            auth = "";
            _context12.next = 5;
            return (0,common/* getAccountType */.lx)();

          case 5:
            accountType = _context12.sent;

            if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              auth = mmt_auth;
            } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              auth = gi_auth;
            }

            _context12.prev = 7;
            deviceId = ((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$app_bridge = _window7.app_bridge) === null || _window7$app_bridge === void 0 ? void 0 : (_window7$app_bridge$d = _window7$app_bridge.deviceId) === null || _window7$app_bridge$d === void 0 ? void 0 : _window7$app_bridge$d.call(_window7$app_bridge)) || getVisitorId();
            headers = {
              "Content-Type": "application/json",
              Authorization: constants/* USER_SERVICE_TM_AUTH */.xf,
              "User-Identifier": (0,constants/* getUserIdentifierForSocialLogin */.n7)(auth, deviceId),
              "x-request-tracker": (0,v4/* default */.Z)()
            };

            if (accountType === constants/* ACCOUNT_TYPE.MYBIZ */.Q5.MYBIZ) {
              headers["x-gommt-client-id"] = constants/* ACCOUNT_TYPE.MYBIZ */.Q5.MYBIZ;
            }

            _context12.next = 13;
            return fetchApi((0,constants/* APP_SOCIAL_URL */.ku)((0,common/* getPartner */.kW)()), {
              method: "POST",
              headers: headers,
              data: data
            });

          case 13:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 17:
            _context12.prev = 17;
            _context12.t0 = _context12["catch"](7);
            console.error("Error", _context12.t0);
            return _context12.abrupt("return", null);

          case 21:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[7, 17]]);
  }));
  return api_tmAuth_getAuth.apply(this, arguments);
}

var appLogin = function appLogin() {
  var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  //@ts-ignore
  window.onLoginSuccess = function () {
    var auth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    console.log("Login successful");

    if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, auth, {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, auth, {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = "".concat(window.location.href);
    }
  }; //@ts-ignore


  window.onLoginCancelled = function () {
    console.log("Login cancelled");
    window.location.reload();
  };

  tmAuth_loginUser();
};

var tmAuth_loginUser = function loginUser(loginJson) {
  var defaultLoginJson = {
    // loginId: null,
    countryCode: "91",
    allowedType: "mobile",
    type: "mobile",
    editable: true,
    showReferral: false,
    socialActionEnabled: false,
    // bannerText: null,
    // bannerIcon: null,
    // icon: null,
    header: "Login to continue",
    // description: null,
    bottomSheet: true
  };
  loginJson = tmAuth_objectSpread(tmAuth_objectSpread({}, defaultLoginJson), loginJson);

  if ((0,common/* getUserDeviceOS */.h0)() === constants/* DEVICE_OS.ANDROID */.Lh.ANDROID) {
    var _window2, _window2$app_bridge, _window2$app_bridge$l;

    //@ts-ignore
    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$app_bridge = _window2.app_bridge) === null || _window2$app_bridge === void 0 ? void 0 : (_window2$app_bridge$l = _window2$app_bridge.login) === null || _window2$app_bridge$l === void 0 ? void 0 : _window2$app_bridge$l.call(_window2$app_bridge, JSON.stringify(loginJson));
  } else {
    var _window3, _window3$webkit$messa, _window3$webkit$messa2;

    //@ts-ignore
    (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$webkit$messa = _window3.webkit.messageHandlers) === null || _window3$webkit$messa === void 0 ? void 0 : (_window3$webkit$messa2 = _window3$webkit$messa.login) === null || _window3$webkit$messa2 === void 0 ? void 0 : _window3$webkit$messa2.postMessage(loginJson);
  }
};

var loginToPartner = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
    var redirectUrl,
        _args7 = arguments;
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            redirectUrl = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : "";

            if (!(0,common/* isApp */.N0)()) {
              _context7.next = 3;
              break;
            }

            return _context7.abrupt("return", partnerLogin(redirectUrl));

          case 3:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context7.next = 7;
              break;
            }

            validateForexAgentAuth();
            _context7.next = 13;
            break;

          case 7:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              _context7.next = 11;
              break;
            }

            return _context7.abrupt("return", validateMmtAuth());

          case 11:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              _context7.next = 13;
              break;
            }

            return _context7.abrupt("return", validateGiAuth());

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function loginToPartner() {
    return _ref7.apply(this, arguments);
  };
}();
var isUserLoggedin = /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context8.next = 4;
              break;
            }

            return _context8.abrupt("return", validateForexAgentAuth(true));

          case 4:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              _context8.next = 8;
              break;
            }

            return _context8.abrupt("return", validateMmtAuth(true));

          case 8:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              _context8.next = 10;
              break;
            }

            return _context8.abrupt("return", validateGiAuth(true));

          case 10:
            return _context8.abrupt("return", false);

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function isUserLoggedin() {
    return _ref8.apply(this, arguments);
  };
}();
var logout = /*#__PURE__*/function () {
  var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(0,common/* isApp */.N0)()) {
              _context9.next = 5;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)();

            if (isAuthBridgesPresent()) {
              _context9.next = 4;
              break;
            }

            return _context9.abrupt("return");

          case 4:
            return _context9.abrupt("return", (0,bridgeMethods/* logoutUser */.TX)());

          case 5:
            return _context9.abrupt("return", (0,common/* removeTmMmmtAuthCookie */._A)());

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function logout() {
    return _ref9.apply(this, arguments);
  };
}();
var isPartnerLoggedIn = /*#__PURE__*/function () {
  var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
    var mmt_auth, gi_auth, _tmAuthRes$appSocialT, tm_auth, tmAuthRes;

    return regenerator_default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context10.next = 2;
              break;
            }

            return _context10.abrupt("return", isUserLoggedin());

          case 2:
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);

            if (!(!(mmt_auth || gi_auth) && (0,common/* isApp */.N0)())) {
              _context10.next = 27;
              break;
            }

            if (isAuthBridgesPresent()) {
              _context10.next = 8;
              break;
            }

            //show popup
            document.dispatchEvent((0,common/* getAppUpdateCustomEvent */.nC)({
              showModal: true
            }));
            return _context10.abrupt("return", false);

          case 8:
            if (!((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7)) {
              _context10.next = 18;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)();

            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              _context10.next = 15;
              break;
            }

            _context10.next = 13;
            return getTmAuthFromIosBridge(constants/* MakeMyTrip */.yO);

          case 13:
            _context10.next = 18;
            break;

          case 15:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              _context10.next = 18;
              break;
            }

            _context10.next = 18;
            return getTmAuthFromIosBridge(constants/* GoIbibo */.Y_);

          case 18:
            tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true);

            if (!tm_auth) {
              _context10.next = 21;
              break;
            }

            return _context10.abrupt("return", true);

          case 21:
            _context10.next = 23;
            return generateTmAuthUsingPartnerAuth();

          case 23:
            tmAuthRes = _context10.sent;

            if (!(tmAuthRes !== null && tmAuthRes !== void 0 && (_tmAuthRes$appSocialT = tmAuthRes.appSocialToken) !== null && _tmAuthRes$appSocialT !== void 0 && _tmAuthRes$appSocialT.success)) {
              _context10.next = 26;
              break;
            }

            return _context10.abrupt("return", true);

          case 26:
            return _context10.abrupt("return", false);

          case 27:
            return _context10.abrupt("return", mmt_auth || gi_auth ? true : false);

          case 28:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function isPartnerLoggedIn() {
    return _ref10.apply(this, arguments);
  };
}();
var loginIfPartnerLoggedin = /*#__PURE__*/function () {
  var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
    var isPartnerLoggedin;
    return regenerator_default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return", null);

          case 2:
            (0,common/* removeTmMmmtAuthCookie */._A)(false);
            _context11.next = 5;
            return isPartnerLoggedIn();

          case 5:
            isPartnerLoggedin = _context11.sent;

            if (!isPartnerLoggedin) {
              _context11.next = 8;
              break;
            }

            return _context11.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 8:
            return _context11.abrupt("return", null);

          case 9:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function loginIfPartnerLoggedin() {
    return _ref11.apply(this, arguments);
  };
}();
var isAuthBridgesPresent = function isAuthBridgesPresent() {
  if ((0,common/* getUserDeviceOS */.h0)() === constants/* ANDROID */.IP) {
    if ((0,common/* isAndroidAuthBridgePresent */.SM)()) {
      return true;
    }
  } else {
    var _window4, _window4$webkit, _window4$webkit$messa, _window5, _window5$webkit, _window5$webkit$messa, _window6, _window6$webkit, _window6$webkit$messa;

    if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$webkit = _window4.webkit) !== null && _window4$webkit !== void 0 && (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null && _window4$webkit$messa !== void 0 && _window4$webkit$messa.logoutUser && (_window5 = window) !== null && _window5 !== void 0 && (_window5$webkit = _window5.webkit) !== null && _window5$webkit !== void 0 && (_window5$webkit$messa = _window5$webkit.messageHandlers) !== null && _window5$webkit$messa !== void 0 && _window5$webkit$messa.login && (_window6 = window) !== null && _window6 !== void 0 && (_window6$webkit = _window6.webkit) !== null && _window6$webkit !== void 0 && (_window6$webkit$messa = _window6$webkit.messageHandlers) !== null && _window6$webkit$messa !== void 0 && _window6$webkit$messa.getShortLivToken) {
      return true;
    }
  }

  return false;
};
function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}
var getMyAccountType = common/* getAccountType */.lx;
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/MMTLogin/index.tsx


 //@ts-ignore


var Header = /*#__PURE__*/react.lazy(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9575), __webpack_require__.e(4329), __webpack_require__.e(9470)]).then(__webpack_require__.bind(__webpack_require__, 9470));
});
var MMTLogin = function MMTLogin(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen;

  var _useState = (0,react.useState)(""),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  var timeoutRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.MMT_LOGIN_CUSTOM_EVENT */.fD.MMT_LOGIN_CUSTOM_EVENT, onMMTLoginEventDispatch);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.MMT_LOGIN_CUSTOM_EVENT */.fD.MMT_LOGIN_CUSTOM_EVENT, onMMTLoginEventDispatch);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  var onMMTLoginEventDispatch = function onMMTLoginEventDispatch(event) {
    setActiveModal("");
    timeoutRef.current = setTimeout(function () {
      var _event$detail;

      setActiveModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.activeModal) || "");

      if (onOpen) {
        onOpen();
      }
    }, 10);
  };

  var onLoginFlowComplete = function onLoginFlowComplete() {
    document.dispatchEvent((0,common/* getMmtLoginCustomEvent */.jd)());

    if (onClose) {
      onClose();
    }

    window.location.reload();
  }; // if (typeof document !== "undefined" && !document?.getElementById(MMT_DESKTOP_DIV)) {
  //     const elem = document.createElement('div');
  //     elem.setAttribute('id', MMT_DESKTOP_DIV);
  //     document.body.appendChild(elem);
  // }
  // const root = ReactDOM.createRoot(
  //     document.getElementById(MMT_DESKTOP_DIV) as HTMLElement
  // );
  // root.render(
  //     <React.StrictMode>
  //         <Header
  //             showNav={false}
  //             onLoginFlowComplete={onLoginFlowComplete}
  //             activeModal={activeModal}
  //         />
  //     </React.StrictMode>
  // );


  return activeModal ? /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
    showNav: false,
    onLoginFlowComplete: onLoginFlowComplete,
    activeModal: activeModal,
    socialLogin: false
  }) : null;
};
// EXTERNAL MODULE: ../../libs/auth/src/lib/hooks/useDeviceContext.ts
var useDeviceContext = __webpack_require__(5766);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/hooks/useDevice.ts


var useDevice = function useDevice() {
  var device = (0,useDeviceContext/* useBreakpointV2 */.b)();

  var _useState = (0,react.useState)(device),
      breakpoint = _useState[0],
      setBreakpoint = _useState[1];

  (0,react.useEffect)(function () {
    if (breakpoint) return;

    var handleResize = function handleResize() {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setBreakpoint("sm");
      } else {
        setBreakpoint("lg");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);
  return breakpoint;
};
;// CONCATENATED MODULE: ../../libs/auth/src/lib/css/Global.ts
var theme = {
  blackText: "#000",
  blackText3: "#022135",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#2B825E",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "rgba(255, 255, 255, 0.8)",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  blueText2: "#F6FAFF"
};
var fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
var fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
var lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/myStyle.ts
 // prettier-ignore
//@ts-ignore

var MyStyled = typeof styled_components_browser_esm["default"] === 'function' ? styled_components_browser_esm["default"] : styled_components_browser_esm["default"]["default"];
/* harmony default export */ var myStyle = (MyStyled);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/FlexComp/FlexComp.style.ts


var _templateObject;



var fadeIn = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);

var renderAlign = function renderAlign(alignItems) {
  switch (alignItems) {
    case "center":
      return "align-items: center;";

    case "baseline":
      return "align-items: baseline;";

    case "flex-start":
      return "align-items:flex-start;";

    case "flex-end":
      return "align-items:flex-end;";

    default:
      return "align-items:center;";
  }
};

var renderJustify = function renderJustify(justifyContent) {
  switch (justifyContent) {
    case "center":
      return "justify-content:center;";

    case "flex-start":
      return "justify-content:flex-start;";

    case "end":
      return "justify-content:end;";

    case "space-between":
      return "justify-content:space-between;";

    default:
      return "justify-content:center;";
  }
};

var renderDir = function renderDir(flexDirection) {
  switch (flexDirection) {
    case "row":
      return "flex-direction:row;";

    case "column":
      return "flex-direction:column;";

    default:
      return "flex-direction:row;";
  }
};

var FlexCompStyle = myStyle("div")(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: relative;\n  cursor: ", ";\n  ", "\n  ", "\n  ", "\n    gap: var(--gap,0);\n  flex: var(--flex, unset);\n  flex-shrink: var(--flexShrink, unset);\n  margin: var(--flexMargin, unset);\n  padding: var(--padding, 0);\n  border-bottom: var(--borderBottom, none);\n  border-top: var(--borderTop, none);\n  background: var(--bgColor, transparent);\n  border-radius: var(--borderRadius, 0);\n  height: var(--height, unset);\n  ", "\n  width: var(--width, unset);\n  box-shadow: var(--boxShadow, unset);\n"])), function (props) {
  return props.isCursorPointer ? "pointer" : "default";
}, function (p) {
  return p.alignItems && "\n    ".concat(renderAlign(p.alignItems), "\n  ");
}, function (p) {
  return p.justifyContent && "\n    ".concat(renderJustify(p.justifyContent), "\n  ");
}, function (p) {
  return p.flexDirection && "\n    ".concat(renderDir(p.flexDirection), "\n  ");
}, function (props) {
  return props.minHeight && "min-height: ".concat(props.minHeight, ";");
});
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/FlexComp/FlexComp.tsx




var FlexComp = function FlexComp(_ref) {
  var children = _ref.children,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      margin = _ref.margin,
      borderBottom = _ref.borderBottom,
      borderTop = _ref.borderTop,
      padding = _ref.padding,
      flex = _ref.flex,
      bgColor = _ref.bgColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      alignSelf = _ref.alignSelf,
      flexShrink = _ref.flexShrink,
      handleClick = _ref.handleClick,
      boxShadow = _ref.boxShadow,
      width = _ref.width,
      minHeight = _ref.minHeight,
      _ref$isCursorPointer = _ref.isCursorPointer,
      isCursorPointer = _ref$isCursorPointer === void 0 ? false : _ref$isCursorPointer,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    id: id,
    alignItems: alignItems,
    flexDirection: flexDirection,
    justifyContent: justifyContent,
    minHeight: minHeight,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    style: {
      "--gap": gap,
      "--flexMargin": margin,
      "--borderBottom": borderBottom,
      "--borderTop": borderTop,
      "--padding": padding,
      "--flex": flex,
      "--bgColor": bgColor,
      "--borderRadius": borderRadius,
      "--height": height,
      "--alignSelf": alignSelf,
      "--flexShrink": flexShrink,
      "--width": width,
      "--boxShadow": boxShadow
    },
    onClick: handleClick,
    children: children
  });
};

/* harmony default export */ var FlexComp_FlexComp = (FlexComp);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/TextStyles/TextStyles.style.ts


var TextStyles_style_templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;



var renderFont = function renderFont(fontSize) {
  switch (fontSize) {
    case "xxs":
      return "\n          font-size: 10px;\n          line-height: 16px;\n        ";

    case "xs":
      return "\n          font-size: 12px;\n          line-height: 16px;\n        ";

    case "sm":
      return "\n          font-size: 14px;\n          line-height: 20px;\n        ";

    case "md":
      return "\n        font-size: 16px;\n        line-height: 22px;\n      ";

    case "large":
      return "\n          font-size: 18px;\n          line-height: 24px;\n        ";

    case "xlarge":
      return "\n        font-size: 22px;\n        line-height: 32px;\n      ";

    case "xxlarge":
      return "\n        font-size: 24px;\n        line-height: 32px;\n      ";

    case "xxxlarge":
      return "\n        font-size: 28px;\n        line-height: 32px;\n      ";

    default:
      return "\n      font-size: 14px;\n      line-height: 20px;\n    ";
  }
};

var renderFontWeight = function renderFontWeight(fontWeight) {
  switch (fontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "medium":
      return "\n        font-weight: 500;\n      ";

    case "semiBold":
      return "\n        font-weight: 600;\n      ";

    case "bold":
      return "\n        font-weight: 700;\n      ";

    case "extraBold":
      return "\n    font-weight: 800;\n  ";

    case "black":
      return "\n      font-weight: 900;\n        ";

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var H1TagStyle = myStyle("h1")(TextStyles_style_templateObject || (TextStyles_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 56px;\n  line-height: 72px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n\n  span {\n    font-size: 56px;\n    line-height: 72px;\n    font-weight: 500;\n    margin: var(--margin, 0);\n    font-family: \"Raleway\";\n    color: var(--color, #000);\n  }\n"])));
var H2TagStyle = myStyle("h2")(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 48px;\n  line-height: 64px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n"])));
var H3TagStyle = myStyle("h3")(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 40px;\n  line-height: 54px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n  text-align: var(--textAlign, left);\n"])));
var H4TagStyle = myStyle("h4")(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n"])));
var H5TagStyle = myStyle("h5")(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 24px;\n  line-height: 32px;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n  font-weight: var(--fontWeight, 500);\n  span {\n    font-size: 24px;\n    line-height: 32px;\n    font-family: \"Raleway\";\n    font-weight: var(--fontWeight, 500);\n  }\n"])));
var H6TagStyle = myStyle("h6")(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 16px;\n  line-height: 25px;\n  font-weight: var(--fontWeight, 500);\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n"])));
var ParaTagStyle = myStyle("p")(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-family: \"Open Sans\";\n  ", "\n  ", "\n    margin: ", ";\n  text-align: ", ";\n  color: ", ";\n  line-height: ", ";\n"])), function (p) {
  return p.fontSize ? "\n    ".concat(renderFont(p.fontSize), "\n  ") : "";
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  var _p$margin;

  return (_p$margin = p.margin) !== null && _p$margin !== void 0 ? _p$margin : 0;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.lineHeight && p.lineHeight;
});
var SpanTagStyle = myStyle("span")(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: \"Open Sans\";\n  ", "\n  ", "\n    display: ", ";\n  color: ", ";\n  margin: ", ";\n  text-align: ", ";\n  background-color: ", ";\n"])), function (p) {
  return p.fontSize ? "".concat(renderFont(p.fontSize)) : "";
}, function (p) {
  return p.fontWeight && "".concat(renderFontWeight(p.fontWeight));
}, function (p) {
  var _p$display;

  return (_p$display = p.display) !== null && _p$display !== void 0 ? _p$display : "inline-block";
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.bgColor && p.bgColor;
});
var AnchorTagStyle = myStyle("a")(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #008cff;\n  text-decoration: none;\n  cursor: pointer;\n  font-family: \"Open Sans\";\n  ", "\n  ", "\n    margin: ", ";\n  display: ", ";\n  color: ", ";\n  text-align: ", ";\n  width: ", ";\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    outline: none;\n  }\n"])), function (p) {
  return p.fontSize ? "".concat(renderFont(p.fontSize)) : "";
}, function (p) {
  return p.fontWeight && "".concat(renderFontWeight(p.fontWeight));
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.display && p.display;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.width && p.width;
});
var CliptextStyleComp = myStyle("div")(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: linear-gradient(\n    92.2deg,\n    #ffe2e8 0.47%,\n    #fffcfc 25.07%,\n    #8cc8ea 64.68%\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n  width: fit-content;\n  font-weight: 600;\n  margin: ", ";\n"])), function (props) {
  return props.margin && props.margin;
});
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/TextStyles/ParaTag.tsx




var ParaTag = function ParaTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000000" : _ref$color,
      margin = _ref.margin,
      textAlign = _ref.textAlign,
      lineHeight = _ref.lineHeight,
      dangerousText = _ref.dangerousText,
      id = _ref.id;
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    id: id,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    id: id,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    children: children
  });
};

/* harmony default export */ var TextStyles_ParaTag = (ParaTag);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/TextStyles/H5Tag.tsx




var H5Tag = function H5Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H5TagStyle, {
    style: {
      "--color": color,
      "--margin": margin
    },
    children: children
  });
};

/* harmony default export */ var TextStyles_H5Tag = (H5Tag);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/Modal/Modal.styles.ts


var Modal_styles_templateObject, Modal_styles_templateObject2;


var ModalWrapper = myStyle("div")(Modal_styles_templateObject || (Modal_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  width: ", ";\n  padding: ", ";\n  background-color: #fff;\n  border-radius: 12px;\n  position: fixed;\n  z-index: 11;\n  ", "\n  ", "\n    ", "\n"])), function (props) {
  return props.modalWidth ? "".concat(props.modalWidth, "px") : "420px";
}, function (props) {
  return props.padding ? "".concat(props.padding) : "20px 30px 30px 30px";
}, function (props) {
  return props.modalType === "centered" && "\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    ";
}, function (props) {
  return props.modalType === "bottomSheet" && "\n        ".concat(props.stickToTop ? "\n                left: 0;\n                top: 0;\n                height: 100%;\n            " : "\n                left: 0;\n                bottom: 0;\n            ", ";\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        animation: modalAnim 0.6s;\n    @keyframes modalAnim {\n        from{bottom:-600px;}\n        to{bottom:0;}\n    }\n    ");
}, function (props) {
  return props.modalType === "fullPage" && "\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: 0;\n        \n        animation: fullModalAnim 0.8s;\n        @keyframes fullModalAnim {\n            from{top:".concat(window.innerHeight, "px;}\n            to{top:0;}\n        }\n    ");
});
var ModalBackdrop = myStyle("div")(Modal_styles_templateObject2 || (Modal_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 10;\n"])));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/Modal/Modal.tsx









var Modal = function Modal(_ref) {
  var children = _ref.children,
      modalWidth = _ref.modalWidth,
      modalHeading = _ref.modalHeading,
      modalHeadingComp = _ref.modalHeadingComp,
      modalSubHeading = _ref.modalSubHeading,
      _ref$modalHeadingCtrM = _ref.modalHeadingCtrMargin,
      modalHeadingCtrMargin = _ref$modalHeadingCtrM === void 0 ? "0 0 32px 0" : _ref$modalHeadingCtrM,
      closeButton = _ref.closeButton,
      onModalClose = _ref.onModalClose,
      padding = _ref.padding,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? "centered" : _ref$modalType,
      backBtn = _ref.backBtn,
      _ref$showBackBtn = _ref.showBackBtn,
      showBackBtn = _ref$showBackBtn === void 0 ? false : _ref$showBackBtn,
      _ref$stickToTop = _ref.stickToTop,
      stickToTop = _ref$stickToTop === void 0 ? false : _ref$stickToTop;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ModalWrapper, {
      padding: padding,
      modalType: modalType,
      modalWidth: modalWidth,
      stickToTop: stickToTop,
      children: [modalType === "fullPage" && showBackBtn ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
        alignItems: "center",
        margin: modalHeadingCtrMargin,
        width: "100%",
        children: [backBtn && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          onClick: onModalClose,
          children: backBtn
        }), (modalHeading || modalSubHeading) && (modalSubHeading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
          flexDirection: "column",
          margin: "0px",
          children: [modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "md",
            margin: "0px 0px 0px 20px",
            color: theme.greyText,
            fontWeight: "bold",
            children: modalHeading
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "xs",
            margin: "0px 0px 0px 20px",
            color: theme.greyText6,
            children: modalSubHeading
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "md",
          margin: "0px 0px 0px 20px",
          color: theme.greyText,
          fontWeight: "bold",
          children: modalHeading
        })), modalHeadingComp && modalHeadingComp]
      }) : (modalHeading || closeButton || modalHeadingComp) && /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        margin: modalHeadingCtrMargin,
        width: "100%",
        height: "100%",
        children: [(modalHeading || modalSubHeading) && modalSubHeading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
          margin: "0px",
          flexDirection: "column",
          children: [modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
            children: modalHeading
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: modalSubHeading
          })]
        }) : modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
          children: modalHeading
        }), modalHeadingComp && modalHeadingComp, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          onClick: onModalClose,
          children: closeButton
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalBackdrop, {
      onClick: onModalClose
    })]
  });
};

/* harmony default export */ var Modal_Modal = (Modal);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/LandingButton/LandingButton.style.ts


var LandingButton_style_templateObject, LandingButton_style_templateObject2, LandingButton_style_templateObject3, LandingButton_style_templateObject4;


var LandingButtonStyle = myStyle("button")(LandingButton_style_templateObject || (LandingButton_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: var(\n    --btnBg,\n    linear-gradient(91.91deg, #000000 0.3%, #330e0e 100%)\n  );\n  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);\n  border-radius: 6px;\n  font-weight: 900;\n  font-size: var(--btnFont, 16px);\n  line-height: 20px;\n  color: var(--btnColor, #fff);\n  width: var(--customWidth, fit-content);\n  height: var(--customHeight, 44px);\n  border: none;\n  outline: none;\n  cursor: pointer;\n  margin: var(--btnMargin, unset);\n  flex: var(--btnFlex, unset);\n  flex-shrink: var(--btnFlexShrink, unset);\n  border: var(--btnBorder);\n  font-family: \"Open Sans\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: var(--btnPadding, 12px);\n  text-transform: uppercase;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.btnIcon && "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding:16px;\n  }\n\t";
}, function (props) {
  return props.disableState && "\n  background: #CBCBCB;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.3);\n  ";
});
var ShimmerWrap = myStyle("div")(LandingButton_style_templateObject2 || (LandingButton_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 68px;\n  height: 48px;\n  z-index: 12;\n  top: -43px;\n  animation: shimmmer 2.9s ease-in;\n  animation-iteration-count: infinite;\n  animation-fill-mode: backwards;\n\n  @keyframes shimmmer {\n    0% {\n      transform: translateX(-311px);\n    }\n    100% {\n      transform: translateX(311px);\n    }\n  }\n"])));
var BtnMainIcon = myStyle("div")(LandingButton_style_templateObject3 || (LandingButton_style_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
var LandingButtonWhiteStyle = myStyle(LandingButtonStyle)(LandingButton_style_templateObject4 || (LandingButton_style_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: #ffffff;\n  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  color: #008cff;\n"])));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/LandingButton/LandingButton.tsx




var LandingButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      btnIcon = _ref.btnIcon,
      background = _ref.background,
      color = _ref.color,
      customHeight = _ref.customHeight,
      shimmerBtn = _ref.shimmerBtn,
      flex = _ref.flex,
      border = _ref.border,
      btnMainIcon = _ref.btnMainIcon,
      fontSize = _ref.fontSize,
      padding = _ref.padding,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingButtonStyle, {
    ref: ref,
    id: id,
    btnIcon: btnIcon,
    onClick: onClick,
    style: {
      "--btnBg": background,
      "--btnColor": color,
      "--customWidth": customWidth,
      "--btnMargin": margin,
      "--customHeight": customHeight,
      "--btnFlexShrink": flexShrink,
      "--btnFlex": flex,
      "--btnBorder": border,
      "--btnFont": fontSize,
      "--btnPadding": padding
    },
    disableState: disableState,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BtnMainIcon, {
      children: [btnMainIcon, customTitle]
    }), btnIcon && btnIcon, shimmerBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerWrap, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "../../../images/shimmerBtn.svg"
      })
    })]
  });
});
/* harmony default export */ var LandingButton_LandingButton = (LandingButton);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/EmailLoginModal/index.tsx












var EmailLoginModal = function EmailLoginModal(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      forceHide = _ref.forceHide;
  var device = useDevice();

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */.fD.EMAIL_LOGIN_ERROR_EVENT, onEmailLoginEventDispatched);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */.fD.EMAIL_LOGIN_ERROR_EVENT, onEmailLoginEventDispatched);
    };
  }, []);

  var onEmailLoginEventDispatched = function onEmailLoginEventDispatched(event) {
    var _event$detail, _event$detail2;

    setShowModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.showModal) || "");

    if (event !== null && event !== void 0 && (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 && _event$detail2.showModal && onOpen) {
      onOpen();
    }
  };

  var onCloseEmailLogin = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setShowModal(false);

              if (onClose) {
                onClose();
              } // await logout()
              // Need some delay while getting logout callback from  app  bridges
              // await delay(100)
              // await loginToPartner()
              // Need for future to redirect to profile page


              if (!(0,common/* isApp */.N0)()) {
                _context.next = 5;
                break;
              }

              closeWebview();
              return _context.abrupt("return");

            case 5:
              if (!((0,common/* getPartner */.kW)() === constants/* MakeMyTrip */.yO)) {
                _context.next = 10;
                break;
              }

              if ((0,common/* isMobile */.tq)()) {
                window.location.href = constants/* PROFILE_URL.MMT_PWA */.bo.MMT_PWA;
              } else {
                window.location.href = constants/* PROFILE_URL.MMT_DT */.bo.MMT_DT;
              }

              return _context.abrupt("return");

            case 10:
              if (!((0,common/* getPartner */.kW)() === constants/* GoIbibo */.Y_)) {
                _context.next = 13;
                break;
              }

              window.location.href = constants/* PROFILE_URL.GI */.bo.GI;
              return _context.abrupt("return");

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onCloseEmailLogin() {
      return _ref2.apply(this, arguments);
    };
  }();

  return showModal && !forceHide ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Modal, {
    modalHeading: "Mobile Number not linked to ".concat((0,common/* getPartner */.kW)() === constants/* MakeMyTrip */.yO ? "MakeMyTrip" : "Goibibo", " Account"),
    onModalClose: function onModalClose() {
      setShowModal(false);
      onClose && onClose();
    },
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0 16px 0",
      children: constants/* MESSAGES.EMAIL_LOGIN_ERROR */.X3.EMAIL_LOGIN_ERROR((0,common/* getPartner */.kW)() === constants/* MakeMyTrip */.yO ? "MakeMyTrip" : "Goibibo")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: "LINK MOBILE NUMBER",
      onClick: onCloseEmailLogin,
      customWidth: "100%"
    })]
  }) : null;
};
/* harmony default export */ var components_EmailLoginModal = ((/* unused pure expression or super */ null && (EmailLoginModal)));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/AppUpdateModal/index.tsx








var AppUpdateModal = function AppUpdateModal(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      forceHide = _ref.forceHide;
  var device = useDevice();

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.APP_UPDATE_MODAL_EVENT */.fD.APP_UPDATE_MODAL_EVENT, onAppUpdateEventDispatched);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */.fD.EMAIL_LOGIN_ERROR_EVENT, onAppUpdateEventDispatched);
    };
  }, []);

  var onAppUpdateEventDispatched = function onAppUpdateEventDispatched(event) {
    var _event$detail, _event$detail2;

    setShowModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.showModal) || "");

    if (event !== null && event !== void 0 && (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 && _event$detail2.showModal && onOpen) {
      onOpen();
    }
  };

  return showModal && !forceHide ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Modal, {
    modalHeading: "Login Error",
    onModalClose: function onModalClose() {
      setShowModal(false);
      onClose && onClose();
    },
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0 16px 0",
      children: constants/* MESSAGES.APP_UPDATE */.X3.APP_UPDATE
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: "OK",
      onClick: function onClick() {
        setShowModal(false);
        onClose && onClose();
      },
      customWidth: "100%"
    })]
  }) : null;
};
/* harmony default export */ var components_AppUpdateModal = ((/* unused pure expression or super */ null && (AppUpdateModal)));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/LoginErrorModal/index.tsx








var LoginErrorModal = function LoginErrorModal(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      forceHide = _ref.forceHide;
  var device = useDevice();

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.LOGIN_ERROR_EVENT */.fD.LOGIN_ERROR_EVENT, onLoginErrorEventDispatched);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.LOGIN_ERROR_EVENT */.fD.LOGIN_ERROR_EVENT, onLoginErrorEventDispatched);
    };
  }, []);

  var onLoginErrorEventDispatched = function onLoginErrorEventDispatched(event) {
    var _event$detail, _event$detail2;

    setShowModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.showModal) || "");

    if (event !== null && event !== void 0 && (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 && _event$detail2.showModal && onOpen) {
      onOpen();
    }
  };

  return showModal && !forceHide ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Modal, {
    modalHeading: "Login Error",
    onModalClose: function onModalClose() {
      setShowModal(false);
      onClose && onClose();
    },
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0 16px 0",
      children: constants/* MESSAGES.LOGIN_ERROR */.X3.LOGIN_ERROR
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: "OK",
      onClick: function onClick() {
        setShowModal(false);
        onClose && onClose();
      },
      customWidth: "100%"
    })]
  }) : null;
};
/* harmony default export */ var components_LoginErrorModal = ((/* unused pure expression or super */ null && (LoginErrorModal)));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(1701);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(129);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(9017);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(8200);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/baseAuth.ts



var AuthAbstract = /*#__PURE__*/(0,createClass/* default */.Z)(function AuthAbstract() {
  (0,classCallCheck/* default */.Z)(this, AuthAbstract);

  (0,defineProperty/* default */.Z)(this, "partner", void 0);

  (0,defineProperty/* default */.Z)(this, "accType", void 0);
});
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/mmtAndroidAuth.ts








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var MMTAndroidAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(MMTAndroidAuth, _AuthAbstract);

  var _super = _createSuper(MMTAndroidAuth);

  function MMTAndroidAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MMTAndroidAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "MMT");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "MMT");

    return _this;
  }

  (0,createClass/* default */.Z)(MMTAndroidAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$app_bridge;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$app_bridge = _window.app_bridge) !== null && _window$app_bridge !== void 0 && _window$app_bridge.getShortLivToken)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in MMT Android"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from MMT Android"));
          }

          resolve(token);
          tokenSent = true;
        };

        window.app_bridge.getShortLivToken(JSON.stringify({
          client: "TM"
        }), "shortLivToken");
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in MMT Android");
          }
        }, 5000);
      });
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true) || "";
      return mmt_auth;
    }
  }, {
    key: "getTMAuth",
    value: function getTMAuth() {
      var _this2 = this;

      // TODO - Confirm why bridge method is not used similar to iOS?
      return new Promise(function (resolve) {
        resolve(_this2.getTMAuthFromCookie());
      });
    }
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }]);

  return MMTAndroidAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/mmtIosAuth.ts










function mmtIosAuth_createSuper(Derived) { var hasNativeReflectConstruct = mmtIosAuth_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function mmtIosAuth_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var MMTIOSAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(MMTIOSAuth, _AuthAbstract);

  var _super = mmtIosAuth_createSuper(MMTIOSAuth);

  function MMTIOSAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MMTIOSAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "MMT");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "MMT");

    return _this;
  }

  (0,createClass/* default */.Z)(MMTIOSAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$webkit, _window$webkit$messag, _window$webkit$messag2, _window2, _window2$webkit, _window2$webkit$messa, _window2$webkit$messa2;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$webkit = _window.webkit) !== null && _window$webkit !== void 0 && (_window$webkit$messag = _window$webkit.messageHandlers) !== null && _window$webkit$messag !== void 0 && (_window$webkit$messag2 = _window$webkit$messag.getShortLivToken) !== null && _window$webkit$messag2 !== void 0 && _window$webkit$messag2.postMessage)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in MMT IOS"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from MMT IOS"));
          }

          resolve(token);
          tokenSent = true;
        };

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit = _window2.webkit) === null || _window2$webkit === void 0 ? void 0 : (_window2$webkit$messa = _window2$webkit.messageHandlers) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.getShortLivToken) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.postMessage(JSON.stringify({
          client: "TM"
        }));
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in MMT IOS");
          }
        }, 5000);
      });
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true) || "";
      return mmt_auth;
    }
  }, {
    key: "getTmAuthFromBridge",
    value: function getTmAuthFromBridge() {
      return new Promise(function (resolve, reject) {
        var _window3, _window3$webkit, _window3$webkit$messa, _window3$webkit$messa2;

        if (!window || !((_window3 = window) !== null && _window3 !== void 0 && (_window3$webkit = _window3.webkit) !== null && _window3$webkit !== void 0 && (_window3$webkit$messa = _window3$webkit.messageHandlers) !== null && _window3$webkit$messa !== void 0 && (_window3$webkit$messa2 = _window3$webkit$messa.getTMToken) !== null && _window3$webkit$messa2 !== void 0 && _window3$webkit$messa2.postMessage)) {
          console.error("Failed to find ios getTMToken bridge");
          return resolve(null);
        }

        window.tripMoneyToken = function (tokenObject) {
          var token = null;

          try {
            var decodedJson = decodeJSON(tokenObject);
            token = decodedJson.tmAuth;
          } catch (e) {
            console.error("Error while decoding tmToken", e);
          }

          resolve(token);
        };

        window.webkit.messageHandlers.getTMToken.postMessage(JSON.stringify(true));
      });
    }
    /**
     * Retrieves TM Auth directly from bridge.
     * Note: After discussion, it was decided that TM Auth from cookie is not needed.
     * We directly fetch from bridge to ensure we always have the latest auth token.
     */

  }, {
    key: "getTMAuth",
    value: function () {
      var _getTMAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var tmAuth;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getTmAuthFromBridge();

              case 2:
                tmAuth = _context.sent;
                return _context.abrupt("return", tmAuth);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTMAuth() {
        return _getTMAuth.apply(this, arguments);
      }

      return getTMAuth;
    }()
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInAppStorage(tmAuth);
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuthInAppStorage",
    value: function saveTMAuthInAppStorage(tmAuth) {
      var _window4, _window4$webkit, _window4$webkit$messa, _window4$webkit$messa2, _window$webkit$messag3;

      if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$webkit = _window4.webkit) !== null && _window4$webkit !== void 0 && (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null && _window4$webkit$messa !== void 0 && (_window4$webkit$messa2 = _window4$webkit$messa.saveTMToken) !== null && _window4$webkit$messa2 !== void 0 && _window4$webkit$messa2.postMessage) {
        console.error("SaveTMToken handler not found");
        return;
      }

      var token = encodeJSON(getTmAuthJsonForIos(this.getPartnerAuthFromCookie(), tmAuth));
      (_window$webkit$messag3 = window.webkit.messageHandlers.saveTMToken) === null || _window$webkit$messag3 === void 0 ? void 0 : _window$webkit$messag3.postMessage(JSON.stringify(token));
    }
  }]);

  return MMTIOSAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/giIosAuth.ts










function giIosAuth_createSuper(Derived) { var hasNativeReflectConstruct = giIosAuth_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function giIosAuth_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var GIIosAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(GIIosAuth, _AuthAbstract);

  var _super = giIosAuth_createSuper(GIIosAuth);

  function GIIosAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, GIIosAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "GI");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "GI");

    return _this;
  }

  (0,createClass/* default */.Z)(GIIosAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$webkit, _window$webkit$messag, _window$webkit$messag2, _window2, _window2$webkit, _window2$webkit$messa, _window2$webkit$messa2;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$webkit = _window.webkit) !== null && _window$webkit !== void 0 && (_window$webkit$messag = _window$webkit.messageHandlers) !== null && _window$webkit$messag !== void 0 && (_window$webkit$messag2 = _window$webkit$messag.getShortLivToken) !== null && _window$webkit$messag2 !== void 0 && _window$webkit$messag2.postMessage)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in GI IOS"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from GI IOS"));
          }

          resolve(token);
          tokenSent = true;
        };

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit = _window2.webkit) === null || _window2$webkit === void 0 ? void 0 : (_window2$webkit$messa = _window2$webkit.messageHandlers) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.getShortLivToken) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.postMessage({
          client: "TM"
        });
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in GI IOS");
          }
        }, 5000);
      });
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true) || "";
      return gi_auth;
    }
  }, {
    key: "getTmAuthFromBridge",
    value: function getTmAuthFromBridge() {
      return new Promise(function (resolve, reject) {
        var _window3, _window3$webkit, _window3$webkit$messa, _window3$webkit$messa2;

        if (!window || !((_window3 = window) !== null && _window3 !== void 0 && (_window3$webkit = _window3.webkit) !== null && _window3$webkit !== void 0 && (_window3$webkit$messa = _window3$webkit.messageHandlers) !== null && _window3$webkit$messa !== void 0 && (_window3$webkit$messa2 = _window3$webkit$messa.getTMToken) !== null && _window3$webkit$messa2 !== void 0 && _window3$webkit$messa2.postMessage)) {
          console.error("Failed to find ios getTMToken bridge");
          return resolve(null);
        }

        window.tripMoneyToken = function (tokenObject) {
          var token = null;

          try {
            var decodedJson = decodeJSON(tokenObject);
            token = decodedJson.tmAuth;
          } catch (e) {
            console.error("Error while decoding tmToken", e);
          }

          resolve(token);
        };

        window.webkit.messageHandlers.getTMToken.postMessage(JSON.stringify(true));
      });
    }
  }, {
    key: "getTMAuth",
    value: function () {
      var _getTMAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var tmAuth;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tmAuth = this.getTMAuthFromCookie();

                if (tmAuth) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this.getTmAuthFromBridge();

              case 4:
                tmAuth = _context.sent;

              case 5:
                return _context.abrupt("return", tmAuth);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTMAuth() {
        return _getTMAuth.apply(this, arguments);
      }

      return getTMAuth;
    }()
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInAppStorage(tmAuth);
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuthInAppStorage",
    value: function saveTMAuthInAppStorage(tmAuth) {
      var _window4, _window4$webkit, _window4$webkit$messa, _window4$webkit$messa2, _window$webkit$messag3;

      if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$webkit = _window4.webkit) !== null && _window4$webkit !== void 0 && (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null && _window4$webkit$messa !== void 0 && (_window4$webkit$messa2 = _window4$webkit$messa.saveTMToken) !== null && _window4$webkit$messa2 !== void 0 && _window4$webkit$messa2.postMessage) {
        console.error("SaveTMToken handler not found");
        return;
      }

      var token = encodeJSON(getTmAuthJsonForIos(this.getPartnerAuthFromCookie(), tmAuth));
      (_window$webkit$messag3 = window.webkit.messageHandlers.saveTMToken) === null || _window$webkit$messag3 === void 0 ? void 0 : _window$webkit$messag3.postMessage(JSON.stringify(token));
    }
  }]);

  return GIIosAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/giAndroidAuth.ts








function giAndroidAuth_createSuper(Derived) { var hasNativeReflectConstruct = giAndroidAuth_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function giAndroidAuth_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var GIAndroidAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(GIAndroidAuth, _AuthAbstract);

  var _super = giAndroidAuth_createSuper(GIAndroidAuth);

  function GIAndroidAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, GIAndroidAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "GI");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "GI");

    return _this;
  }

  (0,createClass/* default */.Z)(GIAndroidAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$app_bridge;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$app_bridge = _window.app_bridge) !== null && _window$app_bridge !== void 0 && _window$app_bridge.getShortLivToken)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in GI Android"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from GI Android"));
          }

          resolve(token);
          tokenSent = true;
        };

        window.app_bridge.getShortLivToken(JSON.stringify({
          client: "TM"
        }), "shortLivToken");
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in GI Android");
          }
        }, 5000);
      });
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true) || "";
      return mmt_auth;
    }
  }, {
    key: "getTMAuth",
    value: function getTMAuth() {
      var _this2 = this;

      // TODO - Confirm why bridge method is not used similar to iOS?
      return new Promise(function (resolve) {
        resolve(_this2.getTMAuthFromCookie());
      });
    }
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }]);

  return GIAndroidAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/index.ts





;// CONCATENATED MODULE: ../../libs/auth/src/lib/services/AuthFactory.ts









/**
 * AuthFactory class is responsible for creating an instance of Auth based on the platform provided.
 */

var AuthFactory = /*#__PURE__*/function () {
  /**
   * Constructs an instance of AuthFactory.
   * @param platform - The platform for which the Auth instance needs to be created ('iOS' or 'Android').
   * @throws Error - If an invalid platform is provided.
   */
  function AuthFactory() {
    var _SOURCE$MAKEMYTRIP, _SOURCE$GOIBIBO, _authClasses;

    (0,classCallCheck/* default */.Z)(this, AuthFactory);

    (0,defineProperty/* default */.Z)(this, "auth", null);

    var device = (0,common/* getUserDeviceOS */.h0)();
    var authClasses = (_authClasses = {}, (0,defineProperty/* default */.Z)(_authClasses, constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP, (_SOURCE$MAKEMYTRIP = {}, (0,defineProperty/* default */.Z)(_SOURCE$MAKEMYTRIP, constants/* ANDROID */.IP, MMTAndroidAuth), (0,defineProperty/* default */.Z)(_SOURCE$MAKEMYTRIP, constants/* IOS */.z7, MMTIOSAuth), _SOURCE$MAKEMYTRIP)), (0,defineProperty/* default */.Z)(_authClasses, constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO, (_SOURCE$GOIBIBO = {}, (0,defineProperty/* default */.Z)(_SOURCE$GOIBIBO, constants/* ANDROID */.IP, GIAndroidAuth), (0,defineProperty/* default */.Z)(_SOURCE$GOIBIBO, constants/* IOS */.z7, GIIosAuth), _SOURCE$GOIBIBO)), _authClasses);
    var source = [constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO, constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP].find(common/* isPartnerHost */.Ip);

    if (source && device) {
      var AuthClass = authClasses[source][device];

      if (AuthClass) {
        this.auth = new AuthClass();
      } else {
        console.info("AuthFactory: ".concat(source, " device not found"));
      }
    } else {
      console.log("AuthFactory: Invalid partner found");
    }
  }
  /**
   * Authenticates the user.
   * @returns A Promise that resolves to a boolean indicating whether the user is authenticated or not.
   */


  (0,createClass/* default */.Z)(AuthFactory, [{
    key: "authenticateUser",
    value: function () {
      var _authenticateUser = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var tmAuth;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.auth === null)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                if (this.auth.getPartnerAuthFromCookie()) {
                  _context.next = 5;
                  break;
                }

                console.error("Partner token not found");
                return _context.abrupt("return", false);

              case 5:
                _context.next = 7;
                return this.auth.getTMAuth();

              case 7:
                tmAuth = _context.sent;

                // This case runs for iOS where TM Auth is returned from bridge handler and we need to save in cookie
                if (tmAuth && !this.auth.getTMAuthFromCookie()) {
                  this.auth.saveTMAuthInCookie(tmAuth);
                }

                if (tmAuth) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return this.generateTmAuth();

              case 12:
                tmAuth = _context.sent;
                if (tmAuth) this.auth.saveTMAuth(tmAuth);

              case 14:
                return _context.abrupt("return", Boolean(tmAuth));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authenticateUser() {
        return _authenticateUser.apply(this, arguments);
      }

      return authenticateUser;
    }()
    /**
     * Generates the TM_AUTH value by making an API call.
     * @returns A Promise that resolves to the generated TM_AUTH value or null if it couldn't be generated.
     */

  }, {
    key: "generateTmAuth",
    value: function () {
      var _generateTmAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _tmAuthResponse$data, _tmAuthResponse$data$, _tmAuthResponse$data$2, _tmAuthResponse$data2, _tmAuthResponse$data3, _tmAuthResponse$data4, _tmAuthResponse$data5, _tmAuthResponse$data6;

        var authToken, reqBody, tmAuthResponse, tmAuth, loginInfoList, isMobileRegistered;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.auth) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", null);

              case 2:
                _context2.next = 4;
                return this.auth.getSLTToken();

              case 4:
                authToken = _context2.sent;
                reqBody = {
                  accType: this.auth.accType,
                  authToken: authToken,
                  query: common/* getAppSocialLoginQuery */.GE
                };
                _context2.next = 8;
                return tmAuth_getAuth(reqBody);

              case 8:
                tmAuthResponse = _context2.sent;
                tmAuth = (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data = tmAuthResponse.data) === null || _tmAuthResponse$data === void 0 ? void 0 : (_tmAuthResponse$data$ = _tmAuthResponse$data.profileLoginResponse) === null || _tmAuthResponse$data$ === void 0 ? void 0 : (_tmAuthResponse$data$2 = _tmAuthResponse$data$[0]) === null || _tmAuthResponse$data$2 === void 0 ? void 0 : _tmAuthResponse$data$2.authToken) || null;
                loginInfoList = (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data2 = tmAuthResponse.data) === null || _tmAuthResponse$data2 === void 0 ? void 0 : (_tmAuthResponse$data3 = _tmAuthResponse$data2.profileLoginResponse) === null || _tmAuthResponse$data3 === void 0 ? void 0 : (_tmAuthResponse$data4 = _tmAuthResponse$data3[0]) === null || _tmAuthResponse$data4 === void 0 ? void 0 : (_tmAuthResponse$data5 = _tmAuthResponse$data4.userDetails) === null || _tmAuthResponse$data5 === void 0 ? void 0 : (_tmAuthResponse$data6 = _tmAuthResponse$data5.extendedUser) === null || _tmAuthResponse$data6 === void 0 ? void 0 : _tmAuthResponse$data6.loginInfoList) || [];
                isMobileRegistered = loginInfoList.find(function (e) {
                  return (e === null || e === void 0 ? void 0 : e.loginType) === constants/* LOGIN_TYPE.MOBILE */.Ez.MOBILE;
                });

                if (isMobileRegistered) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", null);

              case 14:
                return _context2.abrupt("return", tmAuth);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function generateTmAuth() {
        return _generateTmAuth.apply(this, arguments);
      }

      return generateTmAuth;
    }()
  }]);

  return AuthFactory;
}();
;// CONCATENATED MODULE: ../../libs/auth/src/lib/hooks/useAuthentication.ts



/**
 * Custom React hook for handling authentication.
 *
 * @returns An object with the following properties:
 * - authenticationProcessCompleted: A boolean value indicating whether the authentication process has completed.
 */


var useAuthentication = function useAuthentication() {
  var _useState = (0,react.useState)(null),
      isAuthenticated = _useState[0],
      updateIsAuthenticated = _useState[1];

  (0,react.useEffect)(function () {
    var authService = new AuthFactory();

    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var authenticated;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return authService.authenticateUser();

            case 3:
              authenticated = _context.sent;
              updateIsAuthenticated(authenticated);
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              updateIsAuthenticated(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }, []);
  return {
    authenticationProcessCompleted: isAuthenticated !== null
  };
};
;// CONCATENATED MODULE: ../../libs/auth/src/index.ts
// export * from './lib/methods';





/**
 * Hooks export
 */



/***/ }),

/***/ 8631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "nJ": function() { return /* binding */ removeCookie; }
/* harmony export */ });
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8131);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5806);
// prettier-ignore
//@ts-ignore


/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.ES,
    N_ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
}

function setCookie(name, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  options = (0,___WEBPACK_IMPORTED_MODULE_0__/* .getUtilOptions */ .Bv)(options);
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.setCookie)(name, value, options, getEssentialItemType(isEssential));
}
function getCookie(name) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = (0,___WEBPACK_IMPORTED_MODULE_0__/* .getUtilOptions */ .Bv)(options);
  return (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.getCookie)(name, options, getEssentialItemType(isEssential));
}
function removeCookie(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.removeCookie)(name, options);
}

/***/ }),

/***/ 5806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ getUtilOptions; },
/* harmony export */   "FQ": function() { return /* binding */ getLoginErrorCustomEvent; },
/* harmony export */   "GE": function() { return /* binding */ getAppSocialLoginQuery; },
/* harmony export */   "Ip": function() { return /* binding */ isPartnerHost; },
/* harmony export */   "Lp": function() { return /* binding */ getHostName; },
/* harmony export */   "N0": function() { return /* binding */ isApp; },
/* harmony export */   "Nk": function() { return /* binding */ getCookieExpiryTime; },
/* harmony export */   "SM": function() { return /* binding */ isAndroidAuthBridgePresent; },
/* harmony export */   "Tz": function() { return /* binding */ fetchutmParamsFromCookie; },
/* harmony export */   "V2": function() { return /* binding */ getEmailLoginErrorCustomEvent; },
/* harmony export */   "_A": function() { return /* binding */ removeTmMmmtAuthCookie; },
/* harmony export */   "h0": function() { return /* binding */ getUserDeviceOS; },
/* harmony export */   "hF": function() { return /* binding */ getTmAuthDefaultObj; },
/* harmony export */   "jd": function() { return /* binding */ getMmtLoginCustomEvent; },
/* harmony export */   "kW": function() { return /* binding */ getPartner; },
/* harmony export */   "l7": function() { return /* binding */ getDeviceType; },
/* harmony export */   "lx": function() { return /* binding */ getAccountType; },
/* harmony export */   "nC": function() { return /* binding */ getAppUpdateCustomEvent; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; },
/* harmony export */   "yH": function() { return /* binding */ persistSpecificParamInCookie; }
/* harmony export */ });
/* unused harmony exports DEVICE_MODEL_TYPE, isOnServer, deleteSpecificCookie, getMmtAndroidVersion, getGIAndroidVersion, getGIIOSVersion, getInstalledVersion, versionCheck, getMmtAgentLoginCustomEvent, DEVICE_TYPE, getDeviceModelType, disableEncrytionInWeb */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(406);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4823);
/* harmony import */ var _methods_bridgeMethods__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7931);
/* harmony import */ var _cookieUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8631);
/* harmony import */ var MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5328);
/* harmony import */ var MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 //@ts-ignore

 //@ts-ignore


var DEVICE_MODEL_TYPE;

(function (DEVICE_MODEL_TYPE) {
  DEVICE_MODEL_TYPE["APP"] = "App";
  DEVICE_MODEL_TYPE["WEB"] = "Web";
})(DEVICE_MODEL_TYPE || (DEVICE_MODEL_TYPE = {}));

var isOnServer = function isOnServer() {
  if (false) {}

  return false;
};
var isApp = function isApp() {
  var _window, _window2, _window2$webkit, _window2$webkit$messa;

  if (isOnServer()) {
    return false;
  }

  return (_window = window) !== null && _window !== void 0 && _window.app_bridge || (_window2 = window) !== null && _window2 !== void 0 && (_window2$webkit = _window2.webkit) !== null && _window2$webkit !== void 0 && (_window2$webkit$messa = _window2$webkit.messageHandlers) !== null && _window2$webkit$messa !== void 0 && _window2$webkit$messa.login ? true : false;
};
var getPartner = function getPartner() {
  if (isOnServer()) {
    return null;
  }

  if (getHostName() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .MakeMyTrip */ .yO;
  } else if (getHostName() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.GOIBIBO */ .M5.GOIBIBO) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .GoIbibo */ .Y_;
  }

  var url = window.location.pathname;
  url = url.replace(/\/+$/, "");
  var urlParts = url.split("/");
  var partnersIndex = urlParts.indexOf("partners");

  if (partnersIndex !== -1 && partnersIndex + 1 < urlParts.length) {
    return urlParts[partnersIndex + 1];
  } else {
    return null;
  }
};
var deleteSpecificCookie = function deleteSpecificCookie(specificParamKey) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    path: "/"
  };
  removeCookie(specificParamKey, options);
};
var getUserDeviceOS = function getUserDeviceOS() {
  var _navigator, _navigator2, _window3, _ref, _ref2, _window4;

  if (isOnServer()) {
    return null;
  }

  var userAgent = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.vendor) || ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.opera);

  if ((_ref = /android/i) !== null && _ref !== void 0 && _ref.test(userAgent)) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP;
  }

  if ((_ref2 = /iPad|iPhone|iPod/) !== null && _ref2 !== void 0 && _ref2.test(userAgent) && !((_window4 = window) !== null && _window4 !== void 0 && _window4.MSStream)) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .IOS */ .z7;
  }

  return _constants__WEBPACK_IMPORTED_MODULE_2__/* .UNKNOWN */ .lz;
};
var getMmtAndroidVersion = function getMmtAndroidVersion() {
  var _window5, _window5$app_bridge;

  if (isOnServer()) {
    return null;
  }

  var version = (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$app_bridge = _window5.app_bridge) === null || _window5$app_bridge === void 0 ? void 0 : _window5$app_bridge.getAppVersion();
  var mmtAndroidAppVersion = {};

  if (version) {
    try {
      mmtAndroidAppVersion = JSON.parse(decodeURIComponent(version));
    } catch (e) {
      console.error("Error parsing app version. Got version: ".concat(version), e);
    }
  }

  return mmtAndroidAppVersion;
};
var getGIAndroidVersion = function getGIAndroidVersion() {
  var _window6, _window6$app_bridge, _window6$app_bridge$g;

  if (isOnServer()) {
    return null;
  }

  var version = (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$app_bridge = _window6.app_bridge) === null || _window6$app_bridge === void 0 ? void 0 : (_window6$app_bridge$g = _window6$app_bridge.getAppVersion) === null || _window6$app_bridge$g === void 0 ? void 0 : _window6$app_bridge$g.call(_window6$app_bridge);

  if (version !== null && version !== void 0 && version.length) {
    return version;
  } else {
    return "";
  }
};
var getGIIOSVersion = function getGIIOSVersion() {
  var _window7, _window7$app_bridge, _window7$app_bridge$g;

  if (isOnServer()) {
    return null;
  }

  var version = (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$app_bridge = _window7.app_bridge) === null || _window7$app_bridge === void 0 ? void 0 : (_window7$app_bridge$g = _window7$app_bridge.getAppVersion) === null || _window7$app_bridge$g === void 0 ? void 0 : _window7$app_bridge$g.call(_window7$app_bridge);
  return version !== null && version !== void 0 && version.length ? version : "";
};
var getInstalledVersion = function getInstalledVersion(partner) {
  var _getMmtAndroidVersion;

  return partner === MakeMyTrip ? getUserDeviceOS() === ANDROID ? (_getMmtAndroidVersion = getMmtAndroidVersion()) === null || _getMmtAndroidVersion === void 0 ? void 0 : _getMmtAndroidVersion.v_name : "" : // FOR GI
  getUserDeviceOS() === ANDROID ? getGIAndroidVersion() : getGIIOSVersion();
}; //TODO: Mention the required versions.

var reqVersions = {
  iOS: {
    gi: "1",
    mmt: "2"
  },
  android: {
    gi: "3",
    mmt: "4"
  }
};

function compareVersionsInclusive(reqVersion, currVersion) {
  var parts1 = reqVersion.split(".").map(Number);
  var parts2 = currVersion.split(".").map(Number);
  var maxLength = Math.max(parts1.length, parts2.length);

  for (var i = 0; i < maxLength; i++) {
    var num1 = i < parts1.length ? parts1[i] : 0;
    var num2 = i < parts2.length ? parts2[i] : 0;

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return 0;
    }
  }

  return 1;
}

var versionCheck = function versionCheck(os, partner) {
  var currVersion = getInstalledVersion(partner);
  var reqVersion = reqVersions[os][partner];
  var isVersionPassed = compareVersionsInclusive(reqVersion, currVersion);

  if (isVersionPassed === 1) {
    return true;
  }

  return false;
};
function getHostName() {
  if (isOnServer()) {
    return null;
  }

  return window.location.hostname;
}
var isPartnerHost = function isPartnerHost(partner) {
  var hostname = getHostName() || "";
  return hostname.includes(partner);
};
var getCookieExpiryTime = function getCookieExpiryTime(days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date.toUTCString();
};
var persistSpecificParamInCookie = function persistSpecificParamInCookie(specificParamKey, specificParamValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    path: "/"
  };
  (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .setCookie */ .d8)(specificParamKey, specificParamValue, true, options);
};
var isAndroidAuthBridgePresent = function isAndroidAuthBridgePresent() {
  if (!window || !window.app_bridge) {
    return false;
  }

  return Boolean(window.app_bridge.logoutUser && window.app_bridge.login && window.app_bridge.getShortLivToken);
};
var isMobile = function isMobile() {
  var _window8;

  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a ? a.substr(0, 4) : null)) check = true;
  })( // @ts-ignore
  !isOnServer() ? //@ts-ignore
  navigator.userAgent || navigator.vendor || ((_window8 = window) === null || _window8 === void 0 ? void 0 : _window8.opera) : null);

  return check;
};
var getMmtLoginCustomEvent = function getMmtLoginCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    activeModal: ""
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.MMT_LOGIN_CUSTOM_EVENT */ .fD.MMT_LOGIN_CUSTOM_EVENT, defaultData);
};
var getMmtAgentLoginCustomEvent = function getMmtAgentLoginCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    activeModal: ""
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(CUSTOM_EVENTS.MMT_AGENT_LOGIN_CUSTOM_EVENT, defaultData);
};
var getEmailLoginErrorCustomEvent = function getEmailLoginErrorCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    showModal: false
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */ .fD.EMAIL_LOGIN_ERROR_EVENT, defaultData);
};
var getAppUpdateCustomEvent = function getAppUpdateCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    showModal: false
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.APP_UPDATE_MODAL_EVENT */ .fD.APP_UPDATE_MODAL_EVENT, defaultData);
};
var getLoginErrorCustomEvent = function getLoginErrorCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    showModal: false
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.LOGIN_ERROR_EVENT */ .fD.LOGIN_ERROR_EVENT, defaultData);
};
var removeTmMmmtAuthCookie = function removeTmMmmtAuthCookie() {
  var shouldRemovePartnerAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (isPartnerHost(_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCE.FOREX_EXPERT */ .Hx.FOREX_EXPERT)) {
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.FOREX_AGENT_AUTH_KEY */ .E9.FOREX_AGENT_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
    });
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.FOREX_AGENT_AUTH_KEY */ .E9.FOREX_AGENT_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
    });
    return;
  }

  if (isPartnerHost(_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCE.MAKEMYTRIP */ .Hx.MAKEMYTRIP)) {
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_AUTH_KEY */ .E9.TM_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
    });
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_MMT_AUTH_KEY */ .E9.TM_MMT_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
    });

    if (shouldRemovePartnerAuth) {
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.MMT_AUTH_KEY */ .E9.MMT_AUTH_KEY, {
        path: "/",
        domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
      });
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.MMT_AUTH_KEY */ .E9.MMT_AUTH_KEY, {
        path: "/",
        domain: "tripmoney".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ)
      });
    }
  } else if (isPartnerHost(_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCE.GOIBIBO */ .Hx.GOIBIBO)) {
    persistSpecificParamInCookie(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_AUTH_KEY */ .E9.TM_AUTH_KEY, "", {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
    });
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_GI_AUTH_KEY */ .E9.TM_GI_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
    });

    if (shouldRemovePartnerAuth) {
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.GI_AUTH_KEY */ .E9.GI_AUTH_KEY, {
        path: "/",
        domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
      });
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.GI_AUTH_KEY */ .E9.GI_AUTH_KEY, {
        path: "/",
        domain: "tripmoney".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7)
      });
    }
  }
};
var DEVICE_TYPE;

(function (DEVICE_TYPE) {
  DEVICE_TYPE["DESKTOP"] = "desktop";
  DEVICE_TYPE["MOBILE"] = "mobile";
  DEVICE_TYPE["TABLET"] = "tablet";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));

function getDeviceType() {
  var _window9, _window9$navigator;

  var userAgent =  true ? ((_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$navigator = _window9.navigator) === null || _window9$navigator === void 0 ? void 0 : _window9$navigator.userAgent) || "" : 0;
  var mobileRegex = new RegExp(/Mobile|Android|BlackBerry/);
  var tabletRegex = new RegExp(/iPad|(Android(?!.*Mobile))|Tablet|PlayBook|Kindle|GT-P1000|SCH-I800|sholes|Xoom|Libero|\b4G\b/);

  if (userAgent.match(mobileRegex)) {
    return DEVICE_TYPE.MOBILE;
  } else if (userAgent.match(tabletRegex)) {
    return DEVICE_TYPE.TABLET;
  }

  return DEVICE_TYPE.DESKTOP;
}
var fetchutmParamsFromCookie = function fetchutmParamsFromCookie() {
  var utm_medium = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_medium", false, {
    path: "/"
  });
  var utm_source = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_source", false, {
    path: "/"
  });
  var utm_campaign = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_campaign", false, {
    path: "/"
  });
  var utm_lender = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_lender", false, {
    path: "/"
  });
  var utm_login = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_login", false, {
    path: "/"
  });
  var utm_content = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_content", false, {
    path: "/"
  });
  var utm_flow = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_flow", false, {
    path: "/"
  });
  return {
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaign: utm_campaign,
    utm_lender: utm_lender,
    utm_login: utm_login,
    utm_content: utm_content,
    utm_flow: utm_flow
  };
};
var getTmAuthDefaultObj = function getTmAuthDefaultObj() {
  return {
    showEmailPopup: false,
    loginToken: {
      success: false,
      error: {
        code: null,
        description: ""
      }
    },
    appSocialToken: {
      success: false,
      error: {
        code: null,
        description: ""
      }
    }
  };
};
var getAppSocialLoginQuery = [[{
  name: "extendedUser",
  keys: ["uuid", "status", "userType", "profileType", "affiliateId", "corporateData"]
}], [{
  name: "extendedUser"
}, {
  name: "personalDetails"
}, {
  name: "name",
  keys: ["title", "firstName", "middleName", "lastName"]
}], [{
  name: "loginInfoList",
  keys: ["loginId", "loginType", "primary", "status", "countryCode", "verified", "verifiedAt"]
}], [{
  name: "extendedUser"
}, {
  name: "miscFields",
  keys: ["partnerUUID"]
}]];
var getDeviceModelType = function getDeviceModelType() {
  if (isOnServer()) return null; // @ts-ignore

  if (window.mmt_android_bridge || window.app_bridge) {
    return DEVICE_MODEL_TYPE.APP;
  }

  return DEVICE_MODEL_TYPE.WEB;
};
function disableEncrytionInWeb() {
  return getDeviceModelType() === DEVICE_MODEL_TYPE.WEB && [_constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP, _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.TRIPMONEY_MAKEMYTRIP */ .M5.TRIPMONEY_MAKEMYTRIP, _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.FOREX_MAKEMYTRIP */ .M5.FOREX_MAKEMYTRIP].includes(getHostName() || "");
}
function getUtilOptions(options) {
  return disableEncrytionInWeb() ? _objectSpread(_objectSpread({}, options), {}, {
    isPiiData: false
  }) : options;
}
var getAccountType = /*#__PURE__*/function () {
  var _ref3 = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _profileTypeRes;

    var profileTypeRes;
    return _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            profileTypeRes = null;
            _context.prev = 1;

            if (!(isApp() && getUserDeviceOS() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .IOS */ .z7)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return (0,_methods_bridgeMethods__WEBPACK_IMPORTED_MODULE_3__/* .getUserProfileType */ .C5)();

          case 5:
            profileTypeRes = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.next = 10;
            return (0,MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6__.getUserInfoPIIClient)();

          case 10:
            profileTypeRes = _context.sent;

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.log("Error", _context.t0);

          case 16:
            if (!(((_profileTypeRes = profileTypeRes) === null || _profileTypeRes === void 0 ? void 0 : _profileTypeRes.profileType) === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_TYPE.BUSINESS */ .Q5.BUSINESS)) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", _constants__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_TYPE.MYBIZ */ .Q5.MYBIZ);

          case 18:
            return _context.abrupt("return", getPartner() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .MakeMyTrip */ .yO ? "MMT" : "GI");

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));

  return function getAccountType() {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 4823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ MMT_LOGIN_URL; },
/* harmony export */   "Dd": function() { return /* binding */ loginHandlerGIMweb; },
/* harmony export */   "E9": function() { return /* binding */ COOKIES; },
/* harmony export */   "Ez": function() { return /* binding */ LOGIN_TYPE; },
/* harmony export */   "FJ": function() { return /* binding */ MMT_SUB_DOMAIN; },
/* harmony export */   "HL": function() { return /* binding */ USER_SERVICE_TOKEN; },
/* harmony export */   "Hx": function() { return /* binding */ SOURCE; },
/* harmony export */   "IP": function() { return /* binding */ ANDROID; },
/* harmony export */   "Ie": function() { return /* binding */ GET_SLT_TOKEN_URL; },
/* harmony export */   "Lh": function() { return /* binding */ DEVICE_OS; },
/* harmony export */   "M5": function() { return /* binding */ HOST; },
/* harmony export */   "Q5": function() { return /* binding */ ACCOUNT_TYPE; },
/* harmony export */   "Q7": function() { return /* binding */ GI_SUB_DOMAIN; },
/* harmony export */   "X3": function() { return /* binding */ MESSAGES; },
/* harmony export */   "Xx": function() { return /* binding */ getUserIdentifier; },
/* harmony export */   "YG": function() { return /* binding */ TM_AUTH_EXPIRY_DAYS; },
/* harmony export */   "Y_": function() { return /* binding */ GoIbibo; },
/* harmony export */   "ZO": function() { return /* binding */ loginHandlerGIDWeb; },
/* harmony export */   "bo": function() { return /* binding */ PROFILE_URL; },
/* harmony export */   "fD": function() { return /* binding */ CUSTOM_EVENTS; },
/* harmony export */   "ku": function() { return /* binding */ APP_SOCIAL_URL; },
/* harmony export */   "lz": function() { return /* binding */ UNKNOWN; },
/* harmony export */   "n7": function() { return /* binding */ getUserIdentifierForSocialLogin; },
/* harmony export */   "xf": function() { return /* binding */ USER_SERVICE_TM_AUTH; },
/* harmony export */   "yO": function() { return /* binding */ MakeMyTrip; },
/* harmony export */   "yY": function() { return /* binding */ MMT_FOREX_URL; },
/* harmony export */   "z7": function() { return /* binding */ IOS; }
/* harmony export */ });
/* unused harmony exports AUTHTOKEN, MMT, GI, TripMoney, MMTGI, TMAUTH, GI_MMT_AUTH, UserURL, RedirectURL, AppSocialLogin, DISCOUNT_BANNER_TEXT, DISCOUNT_BANNER_REDIRECTION_MMT_URL, DISCOUNT_BANNER_REDIRECTION_GI_URL, IS_INITOTU_SESSION_KEY, MMT_URL, UTM_PARAMS_KEY, UTM_SOURCE_VALUE, SUB_DOMAIN, MMT_DESKTOP_DIV */
/* harmony import */ var _common_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5806);
/* provided dependency */ var process = __webpack_require__(4406);
var _getHostName;


var AUTHTOKEN = (/* unused pure expression or super */ null && ( true ? "554DIGG7SWt1EHO" : 0)); // : 'tXXXkb1UwVZn3n6'; //QA credentials use it when user service pointed to QA

var ANDROID = "android";
var IOS = "ios";
var UNKNOWN = "unknown";
var MMT = "MMT";
var GI = "GI";
var MakeMyTrip = "mmt";
var GoIbibo = "gi";
var TripMoney = "tm";
var MMTGI = "mmtgi";
var TMAUTH = "tm-auth";
var GI_MMT_AUTH = "gi-mmt-auth";
var UserURL = "https://www.tripmoney.com";
var RedirectURL = "https://www.tripmoney.com/api/auth";
var HOST = {
  TRIPMONEY: "www.tripmoney.com",
  MAKEMYTRIP: "www.makemytrip.com",
  GOIBIBO: "www.goibibo.com",
  LOCALHOST: "localhost",
  TRIPMONEY_MAKEMYTRIP: "tripmoney.makemytrip.com",
  FOREX_MAKEMYTRIP: "forex.makemytrip.com",
  FOREX_EXPERT: "forexexpert.makemytrip.com",
  FOREX_EXPERT_GI: "forexexpert.goibibo.com"
};
var SOURCE = {
  TRIPMONEY: "tripmoney",
  MAKEMYTRIP: "makemytrip",
  GOIBIBO: "goibibo",
  LOCALHOST: "localhost",
  FOREX_EXPERT: "forexexpert"
};
var mapiHost = (_getHostName = (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getHostName */ .Lp)()) !== null && _getHostName !== void 0 && _getHostName.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
var AppSocialLogin = process.env["NX_ENV"] === "local" ? "".concat(mapiHost, "/ext/TripMoney/Forex/appSocialLogin") : "".concat(mapiHost, "/ext/TripMoney/Forex/appSocialLogin");
var COOKIES = {
  MMT_AUTH_KEY: "mmt-auth",
  TM_AUTH_KEY: "x-tm-auth",
  MMT_LOGIN_REDIRECT_KEY: "loginActionDetails",
  TM_MMT_AUTH_KEY: "tm-mmt-auth",
  GI_AUTH_KEY: "OAUTH-GOIBIBO",
  TM_GI_AUTH_KEY: "tm-gi-auth",
  INR_SESSION_COOKIE: "is-initial-landing",
  MMT_DEVICE_ID: "dvid",
  GI_DEVICE_ID: "__gi_vid",
  FOREX_AGENT_AUTH_KEY: (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getPartner */ .kW)() === MakeMyTrip ? "mmt-auth-afftmfxmmtforexexp" : "mmt-auth-afftmfxgiforexexp"
};
var APP_SOCIAL_URL = function APP_SOCIAL_URL(partner) {
  var _getHostName2;

  var hostname = (_getHostName2 = (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getHostName */ .Lp)()) !== null && _getHostName2 !== void 0 && _getHostName2.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return "".concat(hostname, "/ext/TripMoney/Forex/appSocialLogin");
};
var GET_SLT_TOKEN_URL = function GET_SLT_TOKEN_URL(partner) {
  var _getHostName3;

  var hostname = (_getHostName3 = (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getHostName */ .Lp)()) !== null && _getHostName3 !== void 0 && _getHostName3.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return "".concat(hostname, "/ext/web/pwa/jwt/loginToken");
};
var USER_SERVICE_TOKEN =  true ? "h4nhc9jcgpAGIjp" : 0; // : 'cmVzdDoxMjM0NTY='; //QA credentials use when pointed to QA user service

var USER_SERVICE_TM_AUTH =  true ? "554DIGG7SWt1EHO" : 0; // : 'tXXXkb1UwVZn3n6'; //QA credentials use when pointed to QA user service

var TM_AUTH_EXPIRY_DAYS = 89;
var MMT_LOGIN_URL = "//www.makemytrip.com/pwa/hlp/v3/login";
var MMT_SUB_DOMAIN = ".makemytrip.com";
var GI_SUB_DOMAIN = ".goibibo.com";
var DEVICE_OS = {
  ANDROID: "android",
  IOS: "ios",
  UNKNOWN: "unknown"
};
var getUserIdentifier = function getUserIdentifier(auth, deviceId) {
  return "{\"ipAddress\":\"ipAddress\",\"imie\":\"imie\",\"appVersion\":\"appVersion\",\"os\":\"DESKTOP\",\"osVersion\":\"osVersion\",\"timeZone\":\"timeZone\",\"type\":\"mmt-auth\",\"profileType\":\"\",\"Authorization\":\"".concat(USER_SERVICE_TOKEN, "\",\"deviceId\":\"").concat(deviceId, "\",\"cookie\":\"").concat(auth, "\",\"value\":\"").concat(auth, "\"}");
};
var getUserIdentifierForSocialLogin = function getUserIdentifierForSocialLogin(auth, deviceId) {
  return "{\"type\" :\"auth\",\"value\":\"\",\"deviceId\":\"".concat(deviceId, "\",\"os\":\"android\",\"osVersion\":\"6.0.0\",\"appVersion\":\"5.4.1\",\"imie\":\"132342354\",\"ipAddress\":\"127.0.0.1\",\"timeZone\":\"+5.30 GMT\"}");
};
var DISCOUNT_BANNER_TEXT = "Upto <b>INR 7500 cashback</b> on Forex Card & Currency Notes";
var DISCOUNT_BANNER_REDIRECTION_MMT_URL = "https://www.makemytrip.com/promos/forex-cashback.html?utm_source=cashback&utm_medium=mlp";
var DISCOUNT_BANNER_REDIRECTION_GI_URL = "https://www.goibibo.com/offers/tripmoney-forex";
var MMT_FOREX_URL = "https://www.makemytrip.com/forex";
var IS_INITOTU_SESSION_KEY = "is_initotu";
var MMT_URL = "https://www.makemytrip.com";
var UTM_PARAMS_KEY = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign"
};
var UTM_SOURCE_VALUE = {
  BOTTOM_BAR: "bottombar"
};
var SUB_DOMAIN = {
  MAKEMYTRIP: ".makemytrip.com",
  GOIBIBO: ".goibibo.com",
  TRIPMONEY: ".tripmoney.com",
  LOCALHOST: "localhost"
};
var MMT_DESKTOP_DIV = "mmt-login-desktop";
var CUSTOM_EVENTS = {
  MMT_LOGIN_CUSTOM_EVENT: "mmtlogin",
  MMT_AGENT_LOGIN_CUSTOM_EVENT: "mmtAgentlogin",
  EMAIL_LOGIN_ERROR_EVENT: "emailLoginError",
  APP_UPDATE_MODAL_EVENT: "appUpdateModalEvent",
  LOGIN_ERROR_EVENT: "loginErrorEvent"
};
var loginHandlerGIDWeb = function loginHandlerGIDWeb(encodedString, redirectUrl) {
  var url = "https://".concat( true ? "goibibo.com" : 0, "/login/vendor/?lob=tripmoney&customData=").concat(encodedString, "&next=").concat(redirectUrl);
  window.location.href = url;
};
var loginHandlerGIMweb = function loginHandlerGIMweb(encodedString, redirectUrl) {
  var url = "https://".concat( true ? "goibibo.com" : 0, "/login/?lob=tripmoney&customData=").concat(encodedString, "&next=").concat(redirectUrl);
  window.location.href = url;
};
var MESSAGES = {
  EMAIL_LOGIN_ERROR: function EMAIL_LOGIN_ERROR(partnerName) {
    return "Please add mobile number in your ".concat(partnerName, " profile and continue to book forex");
  },
  APP_UPDATE: "Please update your app to the latest version to continue.",
  LOGIN_ERROR: "Failed to login. Please try after sometime."
};
var PROFILE_URL = {
  MMT_PWA: "https://www.makemytrip.com/pwa/hlp/v3/accountDetails/",
  MMT_DT: "https://www.makemytrip.com/my-profile/",
  GI: "https://www.goibibo.com/profile/"
};
var LOGIN_TYPE;

(function (LOGIN_TYPE) {
  LOGIN_TYPE["MOBILE"] = "MOBILE";
  LOGIN_TYPE["EMAIL"] = "EMAIL";
})(LOGIN_TYPE || (LOGIN_TYPE = {}));

var ACCOUNT_TYPE;

(function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE["MYBIZ"] = "MYBIZ";
  ACCOUNT_TYPE["BUSINESS"] = "BUSINESS";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));

/***/ }),

/***/ 5766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useBreakpointV2; }
/* harmony export */ });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5806);

var useBreakpointV2 = function useBreakpointV2() {
  var device = (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .getDeviceType */ .l7)();

  switch (device) {
    case "mobile":
      return "sm";

    case "desktop":
      return "lg";

    case "tablet":
      return "md";

    default:
      return "md";
  }
};

/***/ }),

/***/ 7931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ getUserProfileType; },
/* harmony export */   "TX": function() { return /* binding */ logoutUser; },
/* harmony export */   "Wd": function() { return /* binding */ getTmToken; },
/* harmony export */   "gc": function() { return /* binding */ getSLToken; },
/* harmony export */   "wE": function() { return /* binding */ saveTMToken; }
/* harmony export */ });
/* unused harmony exports loginUser, reloginUser, reloginEmailUser, getUserLoginStatus */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5806);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4823);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var loginUser = function loginUser(loginOptions) {
  var defaultloginOptions = {
    loginId: "",
    countryCode: "91",
    allowedType: "mobile",
    editable: "true",
    showReferral: false,
    socialActionEnabled: "false",
    bannerText: "",
    bannerIcon: "",
    icon: "",
    header: "login to view bookings",
    description: "",
    bottomSheet: "false"
  };
  loginOptions = _objectSpread(_objectSpread({}, defaultloginOptions), loginOptions);

  if (getUserDeviceOS() === ANDROID) {
    var _window, _window$app_bridge, _window$app_bridge$lo;

    (_window = window) === null || _window === void 0 ? void 0 : (_window$app_bridge = _window.app_bridge) === null || _window$app_bridge === void 0 ? void 0 : (_window$app_bridge$lo = _window$app_bridge.login) === null || _window$app_bridge$lo === void 0 ? void 0 : _window$app_bridge$lo.call(_window$app_bridge, JSON.stringify(loginOptions));
  } else {
    var _window2, _window2$webkit$messa, _window2$webkit$messa2;

    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit$messa = _window2.webkit.messageHandlers) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.login) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.postMessage(loginOptions);
  }
};
var reloginUser = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(loginOptions) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return logoutUser();

          case 2:
            loginUser(loginOptions);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function reloginUser(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var reloginEmailUser = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(loginOptions) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return logoutUser();

          case 2:
            loginUser(loginOptions);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function reloginEmailUser(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));
var logoutUser = function logoutUser() {
  var promise = new Promise(function (resolve, reject) {
    window.logoutUser = function () {
      resolve(true);
    };

    if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
      var _window3, _window3$app_bridge;

      (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$app_bridge = _window3.app_bridge) === null || _window3$app_bridge === void 0 ? void 0 : _window3$app_bridge.logoutUser();
    } else {
      var _window4, _window4$webkit, _window4$webkit$messa, _window4$webkit$messa2;

      (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$webkit = _window4.webkit) === null || _window4$webkit === void 0 ? void 0 : (_window4$webkit$messa = _window4$webkit.messageHandlers) === null || _window4$webkit$messa === void 0 ? void 0 : (_window4$webkit$messa2 = _window4$webkit$messa.logoutUser) === null || _window4$webkit$messa2 === void 0 ? void 0 : _window4$webkit$messa2.postMessage(JSON.stringify(true));
    }
  });
  return promise;
};
function getTmToken() {
  var promise = new Promise(function (resolve, reject) {
    if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
      var _window5, _window5$app_bridge;

      resolve((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$app_bridge = _window5.app_bridge) === null || _window5$app_bridge === void 0 ? void 0 : _window5$app_bridge.getTMToken());
    } else {
      var _window6, _window6$webkit, _window6$webkit$messa, _window6$webkit$messa2;

      window.tripMoneyToken = function (token) {
        resolve(token);
      };

      (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$webkit = _window6.webkit) === null || _window6$webkit === void 0 ? void 0 : (_window6$webkit$messa = _window6$webkit.messageHandlers) === null || _window6$webkit$messa === void 0 ? void 0 : (_window6$webkit$messa2 = _window6$webkit$messa.getTMToken) === null || _window6$webkit$messa2 === void 0 ? void 0 : _window6$webkit$messa2.postMessage(JSON.stringify(true));
    }
  });
  return promise;
}
function getSLToken(partner) {
  if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
    var _window7, _window7$app_bridge;

    (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$app_bridge = _window7.app_bridge) === null || _window7$app_bridge === void 0 ? void 0 : _window7$app_bridge.getShortLivToken(JSON.stringify({
      client: "TM"
    }), "shortLivToken");
  } else {
    if (partner === _constants__WEBPACK_IMPORTED_MODULE_2__/* .MakeMyTrip */ .yO) {
      var _window8, _window8$webkit, _window8$webkit$messa, _window8$webkit$messa2;

      (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$webkit = _window8.webkit) === null || _window8$webkit === void 0 ? void 0 : (_window8$webkit$messa = _window8$webkit.messageHandlers) === null || _window8$webkit$messa === void 0 ? void 0 : (_window8$webkit$messa2 = _window8$webkit$messa.getShortLivToken) === null || _window8$webkit$messa2 === void 0 ? void 0 : _window8$webkit$messa2.postMessage(JSON.stringify({
        client: "TM"
      }));
    } else {
      var _window9, _window9$webkit, _window9$webkit$messa, _window9$webkit$messa2;

      (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$webkit = _window9.webkit) === null || _window9$webkit === void 0 ? void 0 : (_window9$webkit$messa = _window9$webkit.messageHandlers) === null || _window9$webkit$messa === void 0 ? void 0 : (_window9$webkit$messa2 = _window9$webkit$messa.getShortLivToken) === null || _window9$webkit$messa2 === void 0 ? void 0 : _window9$webkit$messa2.postMessage({
        client: "TM"
      });
    }
  }
}
function saveTMToken(token) {
  if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
    var _window10, _window10$app_bridge;

    (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$app_bridge = _window10.app_bridge) === null || _window10$app_bridge === void 0 ? void 0 : _window10$app_bridge.saveTMToken(JSON.stringify(token));
  } else {
    var _window11, _window11$webkit, _window11$webkit$mess, _window11$webkit$mess2;

    (_window11 = window) === null || _window11 === void 0 ? void 0 : (_window11$webkit = _window11.webkit) === null || _window11$webkit === void 0 ? void 0 : (_window11$webkit$mess = _window11$webkit.messageHandlers) === null || _window11$webkit$mess === void 0 ? void 0 : (_window11$webkit$mess2 = _window11$webkit$mess.saveTMToken) === null || _window11$webkit$mess2 === void 0 ? void 0 : _window11$webkit$mess2.postMessage(JSON.stringify(token));
  }
}
function getUserLoginStatus() {
  var promise = new Promise(function (resolve, reject) {
    if (getUserDeviceOS() === ANDROID) {
      var _window12, _window12$app_bridge;

      resolve((_window12 = window) === null || _window12 === void 0 ? void 0 : (_window12$app_bridge = _window12.app_bridge) === null || _window12$app_bridge === void 0 ? void 0 : _window12$app_bridge.getUserLoginStatus());
    } else {
      var _window13, _window13$webkit, _window13$webkit$mess, _window13$webkit$mess2;

      window.loginStatus = function (status) {
        resolve(status);
      };

      (_window13 = window) === null || _window13 === void 0 ? void 0 : (_window13$webkit = _window13.webkit) === null || _window13$webkit === void 0 ? void 0 : (_window13$webkit$mess = _window13$webkit.messageHandlers) === null || _window13$webkit$mess === void 0 ? void 0 : (_window13$webkit$mess2 = _window13$webkit$mess.getUserLoginStatus) === null || _window13$webkit$mess2 === void 0 ? void 0 : _window13$webkit$mess2.postMessage(JSON.stringify(true));
    }
  });
  return promise;
}
function getUserProfileType() {
  var promise = new Promise(function (resolve, reject) {
    if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
      var _window14, _window14$app_bridge;

      resolve((_window14 = window) === null || _window14 === void 0 ? void 0 : (_window14$app_bridge = _window14.app_bridge) === null || _window14$app_bridge === void 0 ? void 0 : _window14$app_bridge.getUserProfileType());
    } else {
      var _window15, _window15$webkit, _window15$webkit$mess;

      window.profileType = function (profileType) {
        resolve({
          profileType: profileType
        });
      };

      if ((_window15 = window) !== null && _window15 !== void 0 && (_window15$webkit = _window15.webkit) !== null && _window15$webkit !== void 0 && (_window15$webkit$mess = _window15$webkit.messageHandlers) !== null && _window15$webkit$mess !== void 0 && _window15$webkit$mess.getUserProfileType) {
        var _window16, _window16$webkit, _window16$webkit$mess;

        (_window16 = window) === null || _window16 === void 0 ? void 0 : (_window16$webkit = _window16.webkit) === null || _window16$webkit === void 0 ? void 0 : (_window16$webkit$mess = _window16$webkit.messageHandlers) === null || _window16$webkit$mess === void 0 ? void 0 : _window16$webkit$mess.getUserProfileType.postMessage(true);
      } else {
        resolve(null);
      }
    }
  });
  return promise;
}

/***/ }),

/***/ 9707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "COMPONENT_TYPE": function() { return /* reexport */ COMPONENT_TYPE; }
});

// UNUSED EXPORTS: DEVICE_MODEL_TYPE, DEVICE_TYPE, HOST

;// CONCATENATED MODULE: ../../libs/types/src/lib/enum/index.ts
var COMPONENT_TYPE;

(function (COMPONENT_TYPE) {
  COMPONENT_TYPE["HEADER"] = "header";
  COMPONENT_TYPE["HEADER_MOBILE"] = "header-mobile";
  COMPONENT_TYPE["HERO"] = "hero";
  COMPONENT_TYPE["HERO_MOBILE"] = "hero-mobile";
  COMPONENT_TYPE["TRIPMONEY_LOGO"] = "tripmoney-logo";
  COMPONENT_TYPE["FAQS_HEADER_LINK"] = "anchor-#faqs";
  COMPONENT_TYPE["TITLE"] = "title";
  COMPONENT_TYPE["LIVE_EVENT_MAP"] = "live-event-map";
  COMPONENT_TYPE["FOREIGN_CURRENCY_FOREX"] = "foreign-currency-forex";
  COMPONENT_TYPE["FOREIGN_CURRENCY_FOREX_MOBILE"] = "foreign-currency-forex-mobile";
  COMPONENT_TYPE["FOREX_CARD_SECTION"] = "forex-card-section";
  COMPONENT_TYPE["FOREX_CARD_SECTION_MOBILE"] = "forex-card-section-mobile";
  COMPONENT_TYPE["INSURANCE_SECTION"] = "insurance-section";
  COMPONENT_TYPE["INSURANCE_SECTION_MOBILE"] = "insurance-section-mobile";
  COMPONENT_TYPE["TRAVEL_LOAN_MOBILE_SECTION"] = "travel-loan-section-mobile";
  COMPONENT_TYPE["TRANSER_MONEY"] = "transfer-money";
  COMPONENT_TYPE["TRANSFER_MONEY_MOBILE"] = "transfer-money-mobile";
  COMPONENT_TYPE["PRIVACY_SECTION"] = "privacy-section";
  COMPONENT_TYPE["PRIVACY_SECTION_MOBILE"] = "privacy-section-mobile";
  COMPONENT_TYPE["TESTIMONIALS_SECTION"] = "testimonials-section";
  COMPONENT_TYPE["TESTIMONIALS_MOBILE"] = "testimonials-section-mobile";
  COMPONENT_TYPE["FAQS_SECTION"] = "faqs-section";
  COMPONENT_TYPE["FAQS_SECTION_MOBILE"] = "faqs-section-mobile";
  COMPONENT_TYPE["FOOTER"] = "footer";
  COMPONENT_TYPE["FOOTER_MOBILE"] = "footer-mobile";
  COMPONENT_TYPE["ERROR_PAGE"] = "error-page";
  COMPONENT_TYPE["ABOUT_US"] = "about-us";
  COMPONENT_TYPE["ABOUT_US_MOBILE"] = "about-us-mobile";
})(COMPONENT_TYPE || (COMPONENT_TYPE = {}));

var DEVICE_TYPE;

(function (DEVICE_TYPE) {
  DEVICE_TYPE["DESKTOP"] = "desktop";
  DEVICE_TYPE["MOBILE"] = "mobile";
  DEVICE_TYPE["TABLET"] = "tablet";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));

var DEVICE_MODEL_TYPE;

(function (DEVICE_MODEL_TYPE) {
  DEVICE_MODEL_TYPE["APP"] = "App";
  DEVICE_MODEL_TYPE["WEB"] = "Web";
})(DEVICE_MODEL_TYPE || (DEVICE_MODEL_TYPE = {}));

var HOST = {
  TRIPMONEY: "www.tripmoney.com",
  MAKEMYTRIP: "www.makemytrip.com",
  GOIBIBO: "www.goibibo.com",
  LOCALHOST: "localhost",
  TRIPMONEY_MAKEMYTRIP: "forex.makemytrip.com"
};
;// CONCATENATED MODULE: ../../libs/types/src/index.ts




/***/ }),

/***/ 9666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OMNITURE_MAP": function() { return /* reexport safe */ _lib_analytics__WEBPACK_IMPORTED_MODULE_14__.ri; },
/* harmony export */   "OMNI_EVENTS_MAP": function() { return /* reexport safe */ _lib_analytics__WEBPACK_IMPORTED_MODULE_14__.r9; },
/* harmony export */   "addWebVitalsScript": function() { return /* reexport safe */ _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__.addWebVitalsScript; },
/* harmony export */   "getCommonSeoOmniData": function() { return /* reexport safe */ _lib_analytics__WEBPACK_IMPORTED_MODULE_14__.YJ; },
/* harmony export */   "getHostName": function() { return /* reexport safe */ _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__.getHostName; },
/* harmony export */   "isOnServer": function() { return /* reexport safe */ _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__.isOnServer; },
/* harmony export */   "useBreakpointV2": function() { return /* reexport safe */ _lib_hooks_useDeviceContext__WEBPACK_IMPORTED_MODULE_17__.bU; },
/* harmony export */   "withDeviceProvider": function() { return /* reexport safe */ _lib_hoc_withDeviceProvider__WEBPACK_IMPORTED_MODULE_18__.J; }
/* harmony export */ });
/* harmony import */ var _lib_components_ForexCardsWidget__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5801);
/* harmony import */ var _lib_components_ForexCurrencyCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1125);
/* harmony import */ var _lib_components_ForexLandingFaqs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6823);
/* harmony import */ var _lib_components_ForexLandingOfferings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7855);
/* harmony import */ var _lib_components_TrustUs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6147);
/* harmony import */ var _lib_components_ForexBanners__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7566);
/* harmony import */ var _lib_components_BMFLicenceFooter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5643);
/* harmony import */ var _lib_static_components_PriceHikeWarning__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8150);
/* harmony import */ var _lib_components_RootContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4027);
/* harmony import */ var _lib_constants_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2638);
/* harmony import */ var _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6198);
/* harmony reexport (checked) */ if(__webpack_require__.o(_lib_utils_index__WEBPACK_IMPORTED_MODULE_10__, "OMNITURE_MAP")) __webpack_require__.d(__webpack_exports__, { "OMNITURE_MAP": function() { return _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__.OMNITURE_MAP; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_lib_utils_index__WEBPACK_IMPORTED_MODULE_10__, "OMNI_EVENTS_MAP")) __webpack_require__.d(__webpack_exports__, { "OMNI_EVENTS_MAP": function() { return _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__.OMNI_EVENTS_MAP; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_lib_utils_index__WEBPACK_IMPORTED_MODULE_10__, "getCommonSeoOmniData")) __webpack_require__.d(__webpack_exports__, { "getCommonSeoOmniData": function() { return _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__.getCommonSeoOmniData; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_lib_utils_index__WEBPACK_IMPORTED_MODULE_10__, "getRequestIdHeaders")) __webpack_require__.d(__webpack_exports__, { "getRequestIdHeaders": function() { return _lib_utils_index__WEBPACK_IMPORTED_MODULE_10__.getRequestIdHeaders; } });
/* harmony import */ var _lib_utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4556);
/* harmony import */ var _lib_utils_cookieUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2151);
/* harmony import */ var _lib_api_fetchApi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5859);
/* harmony import */ var _lib_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1619);
/* harmony import */ var _lib_Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2633);
/* harmony import */ var _lib_Contexts_ExperimentTrackingStringContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6840);
/* harmony import */ var _lib_hooks_useDeviceContext__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4738);
/* harmony import */ var _lib_hoc_withDeviceProvider__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7874);
/* harmony import */ var _lib_hooks__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5289);
/* harmony import */ var _lib_hooks_useSetUTMParams__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(3943);






















/***/ }),

/***/ 2633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ DeviceContextV2; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var DeviceContextV2 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("mobile");
var DeviceContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (DeviceContext);

/***/ }),

/***/ 7752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
var DispatchContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
/* harmony default export */ __webpack_exports__["Z"] = (DispatchContext);

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExperimentTrackingString */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var ExperimentTrackingString = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext("")));

/***/ }),

/***/ 8817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var ForexListingDataContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (ForexListingDataContext);

/***/ }),

/***/ 8169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var GlobalConfigContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (GlobalConfigContext);

/***/ }),

/***/ 1619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ri": function() { return /* reexport */ OMNITURE_MAP; },
  "r9": function() { return /* reexport */ OMNI_EVENTS_MAP; },
  "a3": function() { return /* reexport */ PAGE_NAMES; },
  "YJ": function() { return /* reexport */ getCommonSeoOmniData; },
  "Td": function() { return /* reexport */ trackListingClickEvents; },
  "AM": function() { return /* reexport */ trackPageError; }
});

// UNUSED EXPORTS: LOGGED_IN, NOT_LOGGED_IN, PAGE_AND_CATEGORY_MAP, PAGE_NAME_MAP, USER_LOCATION_LOCAL_STORAGE_KEY, getCommonOmniData, getDeviceTypeForOmniture, trackPageLoad

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/analytics/OmnitureAnalytics/constants.ts


var _OMNITURE_MAP;

var USER_LOCATION_LOCAL_STORAGE_KEY = "user_location";
var PAGE_NAMES = {
  LISTING: "LISTING",
  FOREX_DASHBOARD: "FOREX_DASHBOARD"
};
var PAGE_NAME_MAP = {
  LISTING: "landing:tripmoney forex:landing",
  FOREX_DASHBOARD: "funnel:tripmoney forex:dashboard"
};
var OMNI_EVENTS_MAP = {
  PAGE_NAME: "pageName",
  LOB: "lob",
  SITE_SECTION: "siteSection",
  BOTTOM_SHEET_TRIGGER: "bottomSheetTrigger",
  FUNNEL_TYPE: "funnelType",
  USER_LOC: "userLocation",
  CTA_INFO: "ctaInfo",
  INTERACTION_ID: "interactionID",
  LOGIN_STATUS: "loginStatus",
  BOOKING_STATUS: "bookingStatus",
  DASHBOARD_STATES: "dashboardStates",
  PLATFORM: "platform",
  AMOUNT: "amount",
  ERROR_CODE: "errorCode",
  CURRIENCIES_SELECTED: "currienciesSelected",
  CITY: "city",
  CURRENCY: "currency",
  DENOMINATION: "denomination",
  TM_USER_ID: "tm_user_id",
  DESTINATION: "destination",
  TRAVEL_START_DATE: "travel_start_date",
  TRAVEL_END_DATE: "travel_end_date",
  UPCOMING_TRIP_DETECTED: "upcoming_trip_detected"
};
var OMNITURE_MAP = (_OMNITURE_MAP = {}, (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.PAGE_NAME, "eVar15"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.LOB, "eVar24"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.SITE_SECTION, "channel"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.BOTTOM_SHEET_TRIGGER, "event327"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.FUNNEL_TYPE, "eVar108"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.USER_LOC, "eVar32"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "ApWindow", "eVar7"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.CTA_INFO, "prop67"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "previousPageName", "prop23"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.INTERACTION_ID, "eVar16"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.LOGIN_STATUS, "eVar39"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.TM_USER_ID, "eVar20"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "travelPurpose", "eVar9"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "freeCardOpted", "prop52"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.BOOKING_STATUS, "eVar14"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.DASHBOARD_STATES, "prop67"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.PLATFORM, "eVar75"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.AMOUNT, "event328"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.ERROR_CODE, "eVar22"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.CURRIENCIES_SELECTED, "eVar46"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.CITY, "eVar31"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.CURRENCY, "eVar123"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.DENOMINATION, "prop46"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.DESTINATION, "eVar31"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.TRAVEL_START_DATE, "eVar4"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.TRAVEL_END_DATE, "eVar5"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.UPCOMING_TRIP_DETECTED, "eVar70"), _OMNITURE_MAP);
var LOB_NAME = {
  FOREX_CARDS: "tripmoney forex card",
  PS_FOREX_CARDS: "ps tripmoney forex card",
  FOREX_CURRENCY: "tripmoney forex currency"
};
var SITE_SECTION = {
  LANDING: "landing",
  FUNNEL: " tripmoney forex funnel card",
  NA: ""
};
var constants_PAGE_AND_CATEGORY_MAP = {
  LISTING: {
    pageName: PAGE_NAME_MAP.LISTING,
    lob: LOB_NAME.FOREX_CARDS,
    siteSection: SITE_SECTION.LANDING
  },
  FOREX_DASHBOARD: {
    pageName: PAGE_NAME_MAP.FOREX_DASHBOARD,
    lob: LOB_NAME.PS_FOREX_CARDS,
    siteSection: SITE_SECTION.NA
  }
};
var LOGGED_IN = "Loggedin";
var NOT_LOGGED_IN = "Not Loggedin";
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(4556);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(2151);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/analytics/OmnitureAnalytics/type.ts
var DEVICE_MODEL_TYPE_OMNITURE;

(function (DEVICE_MODEL_TYPE_OMNITURE) {
  DEVICE_MODEL_TYPE_OMNITURE["APP"] = "APP";
  DEVICE_MODEL_TYPE_OMNITURE["WEB"] = "DESKTOP";
  DEVICE_MODEL_TYPE_OMNITURE["PWA"] = "PWA_DIRECT";
})(DEVICE_MODEL_TYPE_OMNITURE || (DEVICE_MODEL_TYPE_OMNITURE = {}));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/analytics/OmnitureAnalytics/common.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function common_trackEventMweb(omniData) {
  var _window;

  if (((_window = window) !== null && _window !== void 0 && _window.omniscriptLoaded || (0,utils.getHostName)() === constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP) && typeof window.s !== "undefined") {
    for (var _i = 0, _Object$entries = Object.entries(omniData); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      window.s[key] = value;
    }

    window.s.t();
  } else {
    if (!window.omnidata) window.omnidata = [];
    window.omnidata.push(omniData);
  }
}
var isOnServer = function isOnServer() {
  if (false) {}

  return false;
};
function getLogInStatus() {
  var isLoggedInCookie = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true);
  var status = isLoggedInCookie ? LOGGED_IN : NOT_LOGGED_IN;
  return status;
}
function getUserCityAndLocation() {
  var _getSessionStorageIte;

  if (isOnServer()) return "";
  var userLocation = "";
  var options = {
    isPiiData: true,
    shouldParseJson: true
  };

  var _ref = (_getSessionStorageIte = (0,clientStorageUtils/* getSessionStorageItem */.St)(USER_LOCATION_LOCAL_STORAGE_KEY, true, options)) !== null && _getSessionStorageIte !== void 0 ? _getSessionStorageIte : {},
      _ref$city = _ref.city,
      city = _ref$city === void 0 ? "" : _ref$city,
      _ref$pincode = _ref.pincode,
      pincode = _ref$pincode === void 0 ? "" : _ref$pincode;

  userLocation = city && pincode ? "".concat(city, ",").concat(pincode) : "";
  return userLocation;
}
function getDeviceTypeForOmniture() {
  var _window2, _window3;

  if (isOnServer() || !navigator) return ""; // @ts-ignore

  if ((_window2 = window) !== null && _window2 !== void 0 && _window2.mmt_android_bridge || (_window3 = window) !== null && _window3 !== void 0 && _window3.app_bridge) {
    return DEVICE_MODEL_TYPE_OMNITURE.APP;
  } else if ((0,utils.isMobile)()) {
    return DEVICE_MODEL_TYPE_OMNITURE.PWA;
  }

  return DEVICE_MODEL_TYPE_OMNITURE.WEB;
}
function common_getCommonOmniData(_ref2) {
  var _objectSpread2;

  var pageName = _ref2.pageName,
      lob = _ref2.lob,
      siteSection = _ref2.siteSection,
      partner = _ref2.partner,
      location = _ref2.location,
      platform = _ref2.platform,
      loginStatus = _ref2.loginStatus,
      code = _ref2.code,
      tmUserId = _ref2.tmUserId,
      upcomingTrip = _ref2.upcomingTrip;
  var PAGE_NAME = OMNI_EVENTS_MAP.PAGE_NAME,
      LOB = OMNI_EVENTS_MAP.LOB,
      SITE_SECTION = OMNI_EVENTS_MAP.SITE_SECTION,
      FUNNEL_TYPE = OMNI_EVENTS_MAP.FUNNEL_TYPE,
      USER_LOC = OMNI_EVENTS_MAP.USER_LOC,
      PLATFORM = OMNI_EVENTS_MAP.PLATFORM,
      LOGIN_STATUS = OMNI_EVENTS_MAP.LOGIN_STATUS,
      TM_USER_ID = OMNI_EVENTS_MAP.TM_USER_ID,
      UPCOMING_TRIP_DETECTED = OMNI_EVENTS_MAP.UPCOMING_TRIP_DETECTED,
      TRAVEL_END_DATE = OMNI_EVENTS_MAP.TRAVEL_END_DATE,
      TRAVEL_START_DATE = OMNI_EVENTS_MAP.TRAVEL_START_DATE,
      DESTINATION = OMNI_EVENTS_MAP.DESTINATION;
  var productType = code === "CN" ? "Currency" : "Card";

  var _ref3 = upcomingTrip !== null && upcomingTrip !== void 0 ? upcomingTrip : {},
      intl_travel = _ref3.intl_travel,
      country = _ref3.country,
      start_date = _ref3.start_date,
      end_date = _ref3.end_date;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread((_objectSpread2 = {}, (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[PAGE_NAME], pageName), (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[LOB], lob), (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[SITE_SECTION], siteSection), (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[FUNNEL_TYPE], "Tripmoney|BMF_".concat(productType, "|").concat(partner)), (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[USER_LOC], location), (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[PLATFORM], platform), (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[LOGIN_STATUS], loginStatus), (0,defineProperty/* default */.Z)(_objectSpread2, OMNITURE_MAP[TM_USER_ID], tmUserId), _objectSpread2), intl_travel && (0,defineProperty/* default */.Z)({}, OMNITURE_MAP[UPCOMING_TRIP_DETECTED], intl_travel ? "intl_travel" : "")), start_date && (0,defineProperty/* default */.Z)({}, OMNITURE_MAP[TRAVEL_START_DATE], new Date(start_date * 1000).toLocaleDateString())), end_date && (0,defineProperty/* default */.Z)({}, OMNITURE_MAP[TRAVEL_END_DATE], new Date(end_date * 1000).toLocaleDateString())), country && (0,defineProperty/* default */.Z)({}, OMNITURE_MAP[DESTINATION], country));
}
function getCommonSeoOmniData(_ref8) {
  var _ref9;

  var pageName = _ref8.pageName;
  var PAGE_NAME = OMNI_EVENTS_MAP.PAGE_NAME,
      LOB = OMNI_EVENTS_MAP.LOB,
      SITE_SECTION = OMNI_EVENTS_MAP.SITE_SECTION;
  return _ref9 = {}, (0,defineProperty/* default */.Z)(_ref9, OMNITURE_MAP[PAGE_NAME], pageName), (0,defineProperty/* default */.Z)(_ref9, OMNITURE_MAP[LOB], "tripmoney forex currency"), (0,defineProperty/* default */.Z)(_ref9, OMNITURE_MAP[SITE_SECTION], "landing"), _ref9;
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/analytics/OmnitureAnalytics/forexEvents/impression.ts


function impression_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function impression_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? impression_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : impression_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var impression_location = getUserCityAndLocation();
var platform = getDeviceTypeForOmniture() || "";
var loginStatus = getLogInStatus(); // function for page load events

function trackPageLoad(deps) {
  try {
    var page = deps.pageName,
        partner = deps.partner,
        tmUserId = deps.tmUserId,
        upcomingTrip = deps.upcomingTrip;
    var _PAGE_AND_CATEGORY_MA = PAGE_AND_CATEGORY_MAP[page],
        pageName = _PAGE_AND_CATEGORY_MA.pageName,
        lob = _PAGE_AND_CATEGORY_MA.lob,
        siteSection = _PAGE_AND_CATEGORY_MA.siteSection;
    var commonOmniData = getCommonOmniData({
      pageName: pageName,
      lob: lob,
      siteSection: siteSection,
      partner: partner,
      location: impression_location,
      platform: platform,
      loginStatus: loginStatus,
      tmUserId: tmUserId,
      upcomingTrip: upcomingTrip
    });

    var omniData = impression_objectSpread({}, commonOmniData);

    trackEventMweb(impression_objectSpread(impression_objectSpread({}, omniData), {}, {
      pageName: pageName
    }));
  } catch (e) {
    console.error(e);
  }
} // function for page load error events

function trackPageError(deps) {
  try {
    var page = deps.pageName,
        errText = deps.errText,
        partner = deps.partner;
    var _PAGE_AND_CATEGORY_MA2 = constants_PAGE_AND_CATEGORY_MAP[page],
        pageName = _PAGE_AND_CATEGORY_MA2.pageName,
        lob = _PAGE_AND_CATEGORY_MA2.lob,
        siteSection = _PAGE_AND_CATEGORY_MA2.siteSection;
    var commonOmniData = common_getCommonOmniData({
      pageName: pageName,
      lob: lob,
      siteSection: siteSection,
      partner: partner,
      location: impression_location,
      platform: platform,
      loginStatus: loginStatus
    });

    var omniData = impression_objectSpread(impression_objectSpread({}, commonOmniData), errText && (0,defineProperty/* default */.Z)({}, OMNITURE_MAP.errorCode, errText));

    common_trackEventMweb(impression_objectSpread(impression_objectSpread({}, omniData), {}, {
      pageName: pageName
    }));
  } catch (e) {
    console.error(e);
  }
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/analytics/OmnitureAnalytics/forexEvents/click.ts


function click_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function click_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? click_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : click_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CTA_INFO = OMNI_EVENTS_MAP.CTA_INFO; //  listing click events

function trackListingClickEvents(deps) {
  try {
    var actionType = deps.actionType,
        partner = deps.partner,
        tmUserId = deps.tmUserId;
    var _PAGE_AND_CATEGORY_MA = constants_PAGE_AND_CATEGORY_MAP[PAGE_NAMES.LISTING],
        pageName = _PAGE_AND_CATEGORY_MA.pageName,
        lob = _PAGE_AND_CATEGORY_MA.lob,
        siteSection = _PAGE_AND_CATEGORY_MA.siteSection;
    var location = getUserCityAndLocation();
    var platform = getDeviceTypeForOmniture() || "";
    var loginStatus = getLogInStatus();
    var commonOmniData = common_getCommonOmniData({
      pageName: pageName,
      lob: lob,
      siteSection: siteSection,
      partner: partner,
      location: location,
      platform: platform,
      loginStatus: loginStatus,
      tmUserId: tmUserId
    });

    var omniData = click_objectSpread(click_objectSpread({}, commonOmniData), {}, (0,defineProperty/* default */.Z)({}, OMNITURE_MAP[CTA_INFO], actionType));

    common_trackEventMweb(click_objectSpread(click_objectSpread({}, omniData), {}, {
      pageName: pageName
    }));
  } catch (e) {
    console.error(e);
  }
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/analytics/OmnitureAnalytics/forexEvents/index.ts
/* Use impression for load/view  events. 
   click for onclick an other events 
 */


;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/analytics/index.ts





/***/ }),

/***/ 5859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DA": function() { return /* binding */ sendPdtDataApi; },
/* harmony export */   "Xs": function() { return /* binding */ fetchApiForexListing; }
/* harmony export */ });
/* unused harmony exports fetchApi, fetchApiCrossSellData, postXpressRtData */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(406);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _utils_cookieUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2151);
/* harmony import */ var _tm_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4178);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2638);
/* harmony import */ var _utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4556);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var getHeaders = function getHeaders(url) {
  var headers = {
    partner: (0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)() || "",
    credentials: "include"
  };

  if (url !== null && url !== void 0 && url.includes("/pdt") || url !== null && url !== void 0 && url.includes((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .APP_SOCIAL_URL */ .ku)((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)())) || url !== null && url !== void 0 && url.includes((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_SLT_TOKEN_URL */ .Ie)((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)())) || url !== null && url !== void 0 && url.includes(getPdtBaseUrl())) {
    return {};
  } else if ((0,_utils__WEBPACK_IMPORTED_MODULE_2__.isPartnerHost)(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SOURCE.FOREX_EXPERT */ .Hx.FOREX_EXPERT)) {
    headers["x-agent-auth"] = (0,_utils_cookieUtils__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)(_constants__WEBPACK_IMPORTED_MODULE_5__/* .COOKIES.FOREX_AGENT_AUTH_KEY */ .E9.FOREX_AGENT_AUTH_KEY, true) || "";
    headers["x-ticket-id"] = (0,_utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .getSessionStorageItem */ .St)("ticket_id", true) || "";
  } else {
    headers["x-tm-auth"] = (0,_utils_cookieUtils__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)("x-tm-auth", true) || "";
  }

  return headers;
};

function fetchApi(_x) {
  return _fetchApi.apply(this, arguments);
}

function _fetchApi() {
  _fetchApi = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(url) {
    var options,
        _options$maxRetries,
        maxRetries,
        _options$retryDelay,
        retryDelay,
        _options$headers,
        headers,
        _options$method,
        method,
        _options$data,
        data,
        retries,
        _responseData$data,
        controller,
        signal,
        tmAuthHeaders,
        deviceDetails,
        response,
        isTmAuthPresent,
        responseData,
        error,
        _ref6,
        code,
        _args5 = arguments;

    return _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            _options$maxRetries = options.maxRetries, maxRetries = _options$maxRetries === void 0 ? 2 : _options$maxRetries, _options$retryDelay = options.retryDelay, retryDelay = _options$retryDelay === void 0 ? 1000 : _options$retryDelay, _options$headers = options.headers, headers = _options$headers === void 0 ? {} : _options$headers, _options$method = options.method, method = _options$method === void 0 ? "GET" : _options$method, _options$data = options.data, data = _options$data === void 0 ? null : _options$data;
            retries = 1;

          case 3:
            if (!(retries <= maxRetries)) {
              _context5.next = 49;
              break;
            }

            _context5.prev = 4;
            controller = new AbortController();
            signal = controller.signal;
            tmAuthHeaders = getHeaders(url);
            deviceDetails = url !== null && url !== void 0 && url.includes("/pdt") || url !== null && url !== void 0 && url.includes((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .APP_SOCIAL_URL */ .ku)((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)())) || url !== null && url !== void 0 && url.includes((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_SLT_TOKEN_URL */ .Ie)((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)())) || url !== null && url !== void 0 && url.includes(getPdtBaseUrl()) ? {} : (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_5__/* .DEVICE */ .Td, JSON.stringify((0,_utils__WEBPACK_IMPORTED_MODULE_2__.getDeviceDetailsObject)(navigator.userAgent, (0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)())));
            _context5.next = 11;
            return fetch(url, {
              method: method,
              headers: _objectSpread(_objectSpread(_objectSpread({
                "Content-Type": "application/json"
              }, headers), tmAuthHeaders), deviceDetails),
              body: data && JSON.stringify(data),
              signal: signal
            });

          case 11:
            response = _context5.sent;

            if (!(response.status === 500)) {
              _context5.next = 14;
              break;
            }

            throw new Error("Internal Server Error");

          case 14:
            if (!(response.status === 404)) {
              _context5.next = 16;
              break;
            }

            throw new Error("Resource Not Found");

          case 16:
            if (!(response.status === 204 || response.headers.get("Content-Length") === "0")) {
              _context5.next = 18;
              break;
            }

            return _context5.abrupt("return");

          case 18:
            isTmAuthPresent = (0,_utils_cookieUtils__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)("x-tm-auth", true);
            _context5.next = 21;
            return response.json();

          case 21:
            responseData = _context5.sent;

            if (responseData !== null && responseData !== void 0 && responseData.success) {
              _context5.next = 32;
              break;
            }

            error = responseData === null || responseData === void 0 ? void 0 : responseData.error;
            _ref6 = error || "", code = _ref6.code;

            if (!(code === _constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_CODE.LOGIN_REQUIRED */ .Bq.LOGIN_REQUIRED)) {
              _context5.next = 30;
              break;
            }

            _context5.next = 28;
            return (0,_tm_auth__WEBPACK_IMPORTED_MODULE_4__.loginIfPartnerLoggedin)();

          case 28:
            retries++;
            return _context5.abrupt("continue", 3);

          case 30:
            _context5.next = 37;
            break;

          case 32:
            if (!((responseData === null || responseData === void 0 ? void 0 : (_responseData$data = responseData.data) === null || _responseData$data === void 0 ? void 0 : _responseData$data.is_auth_token_valid) === false && isTmAuthPresent && !(0,_utils__WEBPACK_IMPORTED_MODULE_2__.isAgentFlow)())) {
              _context5.next = 37;
              break;
            }

            _context5.next = 35;
            return (0,_tm_auth__WEBPACK_IMPORTED_MODULE_4__.loginIfPartnerLoggedin)();

          case 35:
            retries++;
            return _context5.abrupt("continue", 3);

          case 37:
            return _context5.abrupt("return", responseData);

          case 40:
            _context5.prev = 40;
            _context5.t0 = _context5["catch"](4);
            console.log("Error in fetchApi", _context5.t0.message);

            if (!(_context5.t0.name === "AbortError")) {
              _context5.next = 46;
              break;
            }

            console.error("Request cancelled");
            throw new Error("Request cancelled");

          case 46:
            throw new Error(_context5.t0);

          case 47:
            _context5.next = 3;
            break;

          case 49:
            throw new Error("Error received in API ".concat(url, " after ").concat(maxRetries, " attempts."));

          case 50:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[4, 40]]);
  }));
  return _fetchApi.apply(this, arguments);
}

var fetchApiForexListing = /*#__PURE__*/function () {
  var _ref = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, options) {
    var headers, baseUrl, response;
    return _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (shouldIncludeExternalHeaders(url)) {
              headers = {};
              (0,_utils__WEBPACK_IMPORTED_MODULE_2__.setPageContextHeaders)(headers);
              options = _objectSpread(_objectSpread({}, options), {}, {
                headers: _objectSpread(_objectSpread(_objectSpread({}, (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getRequestIdHeaders)()), options.headers), headers)
              });
            }

            baseUrl = getBaseUrl();
            url = baseUrl + url;
            _context.next = 6;
            return fetchApi(url, options);

          case 6:
            response = _context.sent;
            return _context.abrupt("return", transformResponse(response));

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            throw new Error(_context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function fetchApiForexListing(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

function shouldIncludeExternalHeaders(url) {
  return url !== null && url !== void 0 && url.includes("/pdt") || url !== null && url !== void 0 && url.includes((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .APP_SOCIAL_URL */ .ku)((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)())) || url !== null && url !== void 0 && url.includes((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .GET_SLT_TOKEN_URL */ .Ie)((0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .getPartner */ .kW)())) || url !== null && url !== void 0 && url.includes(getPdtBaseUrl()) ? false : true;
}

var sendPdtDataApi = /*#__PURE__*/function () {
  var _ref2 = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(data) {
    var url, headers, response;
    return _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            url = getPdtBaseUrl();
            headers = {
              "Content-Type": "application/json",
              "Request-Data-Encoding": "json"
            };
            _context2.next = 5;
            return fetchApi(url, {
              headers: headers,
              method: "POST",
              data: data
            });

          case 5:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function sendPdtDataApi(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchApiCrossSellData = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, options) {
    var baseUrl, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            baseUrl = getBaseUrl();
            url = baseUrl + url;
            _context3.next = 5;
            return fetchApi(url, options);

          case 5:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            throw new Error(_context3.t0);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));

  return function fetchApiCrossSellData(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}()));
var postXpressRtData = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, data) {
    var baseUrl, host, _HOST$TRIPMONEY_MAKEM, response;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            baseUrl = getBaseUrl();
            url = baseUrl + url;
            host = getHostName();

            if (!baseUrl && host === HOST.MAKEMYTRIP) {
              url = "https://" + ((_HOST$TRIPMONEY_MAKEM = HOST.TRIPMONEY_MAKEMYTRIP) !== null && _HOST$TRIPMONEY_MAKEM !== void 0 && _HOST$TRIPMONEY_MAKEM.includes("forex.makemytrip") ? "forex-gw.makemytrip.com" : HOST.TRIPMONEY_MAKEMYTRIP) + url;
            }

            _context4.prev = 4;
            _context4.next = 7;
            return fetchApi(url, {
              method: "POST",
              data: data
            });

          case 7:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](4);
            console.error(_context4.t0);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[4, 11]]);
  }));

  return function postXpressRtData(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}()));

function transformResponse(res) {
  var isTM = isTripmoneyHost();

  if (isTM) {
    return res;
  } // TODO: Transform skywalker response.


  return res;
}

function getBaseUrl() {
  var host = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHostName)();

  switch (host) {
    case _constants__WEBPACK_IMPORTED_MODULE_5__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP:
      // TODO: Return skywalker base url of MMT.
      return _constants__WEBPACK_IMPORTED_MODULE_5__/* .BASE_URL */ ._n;

    case _constants__WEBPACK_IMPORTED_MODULE_5__/* .HOST.GOIBIBO */ .M5.GOIBIBO:
      // TODO: Return skywalker base url of GI.
      return _constants__WEBPACK_IMPORTED_MODULE_5__/* .BASE_URL */ ._n;

    default:
      return _constants__WEBPACK_IMPORTED_MODULE_5__/* .BASE_URL */ ._n;
  }
}

function isTripmoneyHost() {
  var host = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHostName)();
  return ![_constants__WEBPACK_IMPORTED_MODULE_5__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP, _constants__WEBPACK_IMPORTED_MODULE_5__/* .HOST.GOIBIBO */ .M5.GOIBIBO].includes(host || "");
}

function getPdtBaseUrl() {
  var host = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHostName)();

  switch (host) {
    case _constants__WEBPACK_IMPORTED_MODULE_5__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP:
      return "https://pdt.makemytrip.com/dts/s/da/n";

    default:
      return "https://pdt.makemytrip.com/dts/s/da/n";
  }
}

/***/ }),

/***/ 5643:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hooks_useDevice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5187);
/* harmony import */ var _static_CommonStyle_CommonStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4334);
/* harmony import */ var _static_components_ui_atoms_TextStyles_SpanTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3634);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);






var BMFLicenseFooter = function BMFLicenseFooter() {
  var device = useDevice();
  return /*#__PURE__*/_jsx(GreyBackgroundStyled, {
    children: /*#__PURE__*/_jsxs(LicenseFooterWrap, {
      children: [/*#__PURE__*/_jsx(SpanTag, {
        color: "#757575",
        children: "Book My Forex Pvt. Ltd., a MakeMyTrip group company, is a currency exchange service provider authorised by the Reserve Bank of India (RBI)."
      }), /*#__PURE__*/_jsx(SpanTag, {
        margin: device === "lg" ? "0 0 0 5px" : "",
        color: "#757575",
        children: "License number : NDL-FFMC-0093-2023"
      })]
    })
  });
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (BMFLicenseFooter)));

/***/ }),

/***/ 7566:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useDevice.ts
var hooks_useDevice = __webpack_require__(5187);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var hooks_useGlobalSelector = __webpack_require__(2053);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useFetchBannerData/index.ts



var useFetchBannerData_useFetchBannerData = function useFetchBannerData() {
  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      banners = _useGlobalSelector.banners;

  var device = useDevice();

  var _ref = banners || {},
      orders = _ref.orders,
      campaign = _ref.campaign,
      marketing = _ref.marketing;

  var campaignData = device === "lg" ? campaign === null || campaign === void 0 ? void 0 : campaign.desktop : campaign === null || campaign === void 0 ? void 0 : campaign.mobile;
  var marketingData = device === "lg" ? marketing === null || marketing === void 0 ? void 0 : marketing.desktop : marketing === null || marketing === void 0 ? void 0 : marketing.mobile;
  return {
    bannerOrdering: orders,
    campaignData: campaignData,
    marketingData: marketingData
  };
};

/* harmony default export */ var hooks_useFetchBannerData = ((/* unused pure expression or super */ null && (useFetchBannerData_useFetchBannerData)));
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/MarketingBanner/MarketingBanner.style.ts


var MarketingBanner_style_CarouselCntWrp = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MarketingBannerstyle__CarouselCntWrp",
  componentId: "h2gbt2-0"
})(["display:flex;flex-direction:column;justify-content:center;padding-bottom:16px;@media ", "{margin:32px 16px -32px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
var MarketingBanner_style_CarouselCont = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MarketingBannerstyle__CarouselCont",
  componentId: "h2gbt2-1"
})(["display:flex;flex-direction:column;justify-content:center;position:relative;margin:0 auto;overflow:hidden;width:100%;border-radius:16px;"]);
var MarketingBanner_style_CarouselSlider = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MarketingBannerstyle__CarouselSlider",
  componentId: "h2gbt2-2"
})(["white-space:nowrap;width:100%;transform:", ";transition:ease 1000ms;"], function (props) {
  return props.translate ? "translate(".concat(props.translate, "%)") : "#fff";
});
var MarketingBanner_style_CarouselElmnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MarketingBannerstyle__CarouselElmnt",
  componentId: "h2gbt2-3"
})(["display:inline-block;height:280px;width:100%;border-radius:16px;background-color:", ";cursor:pointer;@media ", "{height:180px;}"], function (props) {
  return props.bgColor ? props.bgColor : "#fff";
}, utils/* deviceType.mobile */.vO.mobile);
var MarketingBanner_style_SlideShowDotsCnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MarketingBannerstyle__SlideShowDotsCnt",
  componentId: "h2gbt2-4"
})(["display:flex;align-self:center;"]);
var MarketingBanner_style_SlideShowDot = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MarketingBannerstyle__SlideShowDot",
  componentId: "h2gbt2-5"
})(["height:10px;width:10px;border-radius:50%;cursor:pointer;margin:12px 4px 0px;background-color:", ";"], function (props) {
  return props.isActive ? "#2276E3" : "#c4c4c4";
});
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ImageTag/ImageTag.tsx + 1 modules
var ImageTag_ImageTag = __webpack_require__(4911);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts + 3 modules
var usePdtLogger = __webpack_require__(761);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalConfig.ts
var hooks_useGlobalConfig = __webpack_require__(588);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useListingPdtLoggerV2/index.ts
var hooks_useListingPdtLoggerV2 = __webpack_require__(2221);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var lib_utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/MarketingBanner/MarketingBanner.tsx












var MarketingBanner_MarketingBanner = function MarketingBanner(_ref) {
  var _carouselData$length2;

  var carouselData = _ref.carouselData,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 5 : _ref$delay;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtMarketingBannerCtaClickEvent = _useListingPdtLogger.sendPdtMarketingBannerCtaClickEvent;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendCTAData = _useListingPdtLoggerV.sendCTAData;

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner;

  var device = useDevice();

  var _useState = useState(0),
      activeIdx = _useState[0],
      setActiveIdx = _useState[1];

  var handleOnClick = function handleOnClick(item) {
    sendPdtMarketingBannerCtaClickEvent();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.MARKETING_BANNER_CTA
    });
    sendCTAData({
      eventDetail: eventDetail
    });
    var cta = "";

    if (partner === MakeMyTrip) {
      var _item$partner_to_cta;

      cta = item === null || item === void 0 ? void 0 : (_item$partner_to_cta = item.partner_to_cta) === null || _item$partner_to_cta === void 0 ? void 0 : _item$partner_to_cta.mmt;
    } else if (partner === Goibibo) {
      var _item$partner_to_cta2;

      cta = item === null || item === void 0 ? void 0 : (_item$partner_to_cta2 = item.partner_to_cta) === null || _item$partner_to_cta2 === void 0 ? void 0 : _item$partner_to_cta2.gi;
    }

    if (cta) {
      window.location.href = cta;
    }
  };

  var getLinkBasedOnPartner = function getLinkBasedOnPartner(item) {
    if (partner === MakeMyTrip) {
      var _item$partner_to_link;

      return (item === null || item === void 0 ? void 0 : (_item$partner_to_link = item.partner_to_link) === null || _item$partner_to_link === void 0 ? void 0 : _item$partner_to_link.mmt) || "";
    } else if (partner === Goibibo) {
      var _item$partner_to_link2;

      return (item === null || item === void 0 ? void 0 : (_item$partner_to_link2 = item.partner_to_link) === null || _item$partner_to_link2 === void 0 ? void 0 : _item$partner_to_link2.gi) || "";
    }

    return "";
  };

  var renderCarouselItems = carouselData === null || carouselData === void 0 ? void 0 : carouselData.map(function (item, idx) {
    return /*#__PURE__*/_jsx(CarouselElmnt, {
      onClick: function onClick() {
        return handleOnClick(item);
      },
      children: /*#__PURE__*/_jsx(ImageTag, {
        src: getLinkBasedOnPartner(item),
        height: device === "sm" ? "180px" : "280px",
        width: "100%"
      })
    }, "banner" + idx);
  });
  var renderDots = carouselData === null || carouselData === void 0 ? void 0 : carouselData.map(function (_, idx) {
    return /*#__PURE__*/_jsx(SlideShowDot, {
      isActive: idx === activeIdx,
      onClick: function onClick() {
        return updateActiveIndex(idx);
      }
    }, "banner" + _);
  });

  var updateActiveIndex = function updateActiveIndex(idx) {
    var _carouselData$length;

    if (idx === (carouselData === null || carouselData === void 0 ? void 0 : carouselData.length)) setActiveIdx(0);else if (idx < 0) setActiveIdx(((_carouselData$length = carouselData === null || carouselData === void 0 ? void 0 : carouselData.length) !== null && _carouselData$length !== void 0 ? _carouselData$length : 1) - 1);else setActiveIdx(idx);
  }; // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (activeIdx === carouselData?.length - 1) setActiveIdx(0);
  //     else setActiveIdx((prevIdx) => prevIdx + 1);
  //   }, delay * 1000);
  //   return () => clearTimeout(timer);
  // }, [activeIdx, carouselData?.length, delay]);


  return /*#__PURE__*/_jsxs(CarouselCntWrp, {
    children: [/*#__PURE__*/_jsx(CarouselCont, {
      children: /*#__PURE__*/_jsx(CarouselSlider, {
        translate: -activeIdx * 100,
        children: renderCarouselItems
      })
    }), ((_carouselData$length2 = carouselData === null || carouselData === void 0 ? void 0 : carouselData.length) !== null && _carouselData$length2 !== void 0 ? _carouselData$length2 : 0) > 1 && /*#__PURE__*/_jsx(SlideShowDotsCnt, {
      children: renderDots
    })]
  });
};

/* harmony default export */ var components_MarketingBanner_MarketingBanner = ((/* unused pure expression or super */ null && (MarketingBanner_MarketingBanner)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/ListingPageComponents.style.ts
var ListingPageComponents_style = __webpack_require__(7998);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(4334);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/ForexMarketingBanner/index.tsx










var ForexMarketingBanner_ForexMarketingBanner = function ForexMarketingBanner(_ref) {
  var bannerData = _ref.bannerData,
      delay = _ref.delay;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtMarketingBannerLoadEvent = _useListingPdtLogger.sendPdtMarketingBannerLoadEvent;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendCTAData = _useListingPdtLoggerV.sendCTAData;

  useEffect(function () {
    sendPdtMarketingBannerLoadEvent();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.MARKETING_BANNER_LOAD
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  }, []);
  return /*#__PURE__*/_jsx(WhiteBackgroundStyled, {
    children: /*#__PURE__*/_jsx(BMFListingContainer, {
      children: /*#__PURE__*/_jsx(MarketingBanner, {
        carouselData: bannerData,
        delay: delay
      })
    })
  });
};

/* harmony default export */ var components_ForexMarketingBanner = ((/* unused pure expression or super */ null && (ForexMarketingBanner_ForexMarketingBanner)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/ForexBanners/index.tsx
/* eslint-disable react/jsx-no-useless-fragment */






var ForexBanners = function ForexBanners() {
  var _useFetchBannerData = useFetchBannerData(),
      bannerOrdering = _useFetchBannerData.bannerOrdering,
      campaignData = _useFetchBannerData.campaignData,
      marketingData = _useFetchBannerData.marketingData;

  return /*#__PURE__*/_jsx(_Fragment, {
    children: bannerOrdering === null || bannerOrdering === void 0 ? void 0 : bannerOrdering.map(function (orderType) {
      var data = orderType === BANNER_TYPE.CAMPAIGN ? campaignData : marketingData;
      return /*#__PURE__*/_jsx(ForexMarketingBanner, {
        bannerData: data
      });
    })
  });
};

/* harmony default export */ var components_ForexBanners = ((/* unused pure expression or super */ null && (ForexBanners)));

/***/ }),

/***/ 5801:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: ForexCardsWidget, default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/ListingPageComponents.style.ts
var ListingPageComponents_style = __webpack_require__(7998);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/FlexComp/FlexComp.tsx + 1 modules
var FlexComp_FlexComp = __webpack_require__(8575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ImageTag/ImageTag.tsx + 1 modules
var ImageTag_ImageTag = __webpack_require__(4911);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/AnchorTag.tsx
var TextStyles_AnchorTag = __webpack_require__(19);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/Header/Header.tsx + 3 modules
var Header_Header = __webpack_require__(8959);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/BackIcon.tsx
var icons_BackIcon = __webpack_require__(5025);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(4575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalConfig.ts
var hooks_useGlobalConfig = __webpack_require__(588);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/Portal/Portal.tsx
var Portal_Portal = __webpack_require__(7452);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/coachmarkArrow.png
/* harmony default export */ var coachmarkArrow = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/coachmarkArrow.989d6583.png","height":85,"width":68,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAQAAABwz0azAAAAS0lEQVR42jXLIQ6DQAAF0b/QQzTVNUgsGDwKhwHHRQjnfiEbgnyZTEQcLlEiepvTKNGIv8FH82DSS0UrFr/3KXZFpKIzi/bB6qv23O5fNGgJ4+eQAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/SpanTag.tsx
var TextStyles_SpanTag = __webpack_require__(3634);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/LandingButton/LandingButton.tsx
var LandingButton_LandingButton = __webpack_require__(1152);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/ListingPageHeader.tsx


















var ListingPageHeader_ListingPageHeader = function ListingPageHeader(_ref) {
  var arrowIcon = _ref.arrowIcon,
      _ref$isLoggedIn = _ref.isLoggedIn,
      isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
      userAvatarImgURI = _ref.userAvatarImgURI,
      loginBtnProps = _ref.loginBtnProps,
      onClickBack = _ref.onClickBack,
      handleLoginClick = _ref.handleLoginClick,
      isScrolled = _ref.isScrolled,
      rightCtaTxt = _ref.rightCtaTxt,
      handleAvatarClick = _ref.handleAvatarClick,
      orderCount = _ref.orderCount,
      _ref$showCoachmark = _ref.showCoachmark,
      showCoachmark = _ref$showCoachmark === void 0 ? false : _ref$showCoachmark,
      _ref$coachmarkTitle = _ref.coachmarkTitle,
      coachmarkTitle = _ref$coachmarkTitle === void 0 ? "Find all your ongoing and past currency order here" : _ref$coachmarkTitle,
      _ref$coachmarkBtnTitl = _ref.coachmarkBtnTitle,
      coachmarkBtnTitle = _ref$coachmarkBtnTitl === void 0 ? "OK GOT IT" : _ref$coachmarkBtnTitl,
      coachmarkClickHandler = _ref.coachmarkClickHandler,
      version = _ref.version;

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner; // prettier-ignore


  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      padding: "16px",
      alignItems: 'center',
      justifyContent: "space-between",
      width: '100%',
      children: [/*#__PURE__*/_jsx(ArrowIconContainer, {
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.BACK_BUTTON),
        onClick: onClickBack,
        children: arrowIcon ? /*#__PURE__*/_jsx(ImageTag, {
          src: arrowIcon
        }) : /*#__PURE__*/_jsx(BackIcon, {})
      }), !isLoggedIn ? /*#__PURE__*/_jsx(AnchorTag, {
        fontWeight: "bold",
        fontSize: "sm",
        handleClick: handleLoginClick,
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.RIGHT_BUTTON),
        children: rightCtaTxt
      }) : userAvatarImgURI &&
      /*#__PURE__*/
      // <ImageTag width="24px" src={userAvatarImgURI} />
      _jsxs(AnchorTag, {
        handleClick: handleAvatarClick,
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.RIGHT_BUTTON),
        children: [/*#__PURE__*/_jsxs(AvatarIconWpr, {
          children: [partner === PARTNER.MMT ? version === VERSIONS.V3 ? /*#__PURE__*/_jsx(MMTAvatarIconV3, {}) : /*#__PURE__*/_jsx(MMTAvatarIcon, {}) : /*#__PURE__*/_jsx(GIAvatarIcon, {}), orderCount && /*#__PURE__*/_jsx(CounterTag, {
            children: orderCount
          })]
        }), showCoachmark && /*#__PURE__*/_jsx(Portal, {
          id: "coachmarkPortal",
          children: /*#__PURE__*/_jsx(CoachmarkContainer, {
            children: /*#__PURE__*/_jsxs(CoachmarkInnerContainer, {
              children: [/*#__PURE__*/_jsxs(AvatarIconWpr, {
                children: [partner === PARTNER.MMT ? version === VERSIONS.V3 ? /*#__PURE__*/_jsx(MMTAvatarIconV3, {}) : /*#__PURE__*/_jsx(MMTAvatarIcon, {}) : /*#__PURE__*/_jsx(GIAvatarIcon, {}), /*#__PURE__*/_jsx(CounterTag, {
                  children: orderCount
                })]
              }), /*#__PURE__*/_jsx(ImageTag, {
                src: CoachmarkArrow.src,
                height: "38px",
                margin: "10px 0px 0px 0px"
              }), /*#__PURE__*/_jsx(SpanTag, {
                color: "#fff",
                fontSize: "sm",
                fontWeight: "bold",
                customWidth: '70%',
                margin: '10px 0px 0px 0px',
                textAlign: 'right',
                children: coachmarkTitle
              }), /*#__PURE__*/_jsx(LandingButton, {
                background: "#fff",
                customTitle: coachmarkBtnTitle,
                fontSize: '12px',
                color: "#008CFF",
                padding: "12px 20px",
                margin: "16px 0px 0px",
                onClick: coachmarkClickHandler
              })]
            })
          })
        })]
      })]
    }), isScrolled && /*#__PURE__*/_jsx(Header, {
      bgColor: theme.whiteText,
      showShadow: true,
      titleText: "Forex Listing",
      backArrow: /*#__PURE__*/_jsx(BackIcon, {}),
      backBtnHandler: onClickBack,
      handleRightBtnClick: handleLoginClick,
      rightCtaTitle: rightCtaTxt,
      showRightCta: !isLoggedIn,
      headerWprId: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.BACK_BUTTON),
      userInfoId: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.RIGHT_BUTTON)
    })]
  });
};

/* harmony default export */ var ListingPageComponents_ListingPageHeader = ((/* unused pure expression or super */ null && (ListingPageHeader_ListingPageHeader)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/ParaTag.tsx
var TextStyles_ParaTag = __webpack_require__(8135);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var static_utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/LandingCardFeature.style.ts




var LandingCardFeature_style_NotLocationText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__NotLocationText",
  componentId: "sc-13mqvw6-0"
})(["border-radius:8px;background-color:", ";padding:8px;margin-top:24px;"], function (props) {
  return props.version === constants/* VERSIONS.V3 */.Kr.V3 ? "#F6F6F6" : Global/* theme.yellowText2 */.rS.yellowText2;
});
var LandingCardFeature_style_ZeroPayment = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__ZeroPayment",
  componentId: "sc-13mqvw6-1"
})(["position:absolute;left:16px;top:0;z-index:1;"]);
var LandingCardFeature_style_LandingCardFeatureStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__LandingCardFeatureStyle",
  componentId: "sc-13mqvw6-2"
})(["display:flex;position:relative;flex:1;", " ", " flex-direction:column;", " ", " border-radius:", ";cursor:pointer;align-self:", ";@media ", "{", "}"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.padding && "padding: ".concat(props.padding, ";");
}, function (props) {
  return props.border && "border: ".concat(props.border, ";");
}, function (props) {
  return props.borderWidth && "border-width: ".concat(props.borderWidth, ";");
}, function (props) {
  return props.version === constants/* VERSIONS.V3 */.Kr.V3 ? "16px" : "4px";
}, function (props) {
  return props.version === constants/* VERSIONS.V3 */.Kr.V3 ? "flex-start" : "unset";
}, static_utils/* deviceType.desktop */.vO.desktop, function (props) {
  return props.isZeroPayment && "padding: 38px 16px 16px 16px;";
});
var LandingCardFeature_style_LogoContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__LogoContainer",
  componentId: "sc-13mqvw6-3"
})(["width:140px;@media screen and ", "{width:60px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingCardFeature_style_AbsTag = styled_components_browser_esm["default"].p.withConfig({
  displayName: "LandingCardFeaturestyle__AbsTag",
  componentId: "sc-13mqvw6-4"
})(["margin:0;position:absolute;top:16px;right:16px;background-color:", ";padding:4px 12px;border-radius:20px;"], Global/* theme.greenText2 */.rS.greenText2);
var LandingCardFeatureInnerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__LandingCardFeatureInnerStyle",
  componentId: "sc-13mqvw6-5"
})(["display:flex;"]);
var LandingCardFeature_style_PointsContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__PointsContainer",
  componentId: "sc-13mqvw6-6"
})(["padding:0px;list-style:none;margin:12px 0 0 0;& > span:not(:last-child):after{content:\"|\";margin-left:2px;margin-right:2px;}@media screen and ", "{margin-bottom:0px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingCardFeature_style_RightButtonContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__RightButtonContainer",
  componentId: "sc-13mqvw6-7"
})(["display:flex;flex-direction:row;gap:4px;align-items:center;"]);
var DeliveryLabelContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__DeliveryLabelContainer",
  componentId: "sc-13mqvw6-8"
})(["margin:18px 0px 0px;@media ", "{border-top:1px solid #f2f2f2;margin:12px 0px 0px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var FreeCard = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__FreeCard",
  componentId: "sc-13mqvw6-9"
})(["display:flex;flex-direction:row;border-radius:4px;padding:4px 8px;gap:4px;background:linear-gradient( 160deg,rgba(210,242,237,1) 0%,rgba(255,255,255,1) 50%,rgba(255,255,255,1) 100% );align-self:flex-start;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/ArrowIcon.tsx


var _excluded = (/* unused pure expression or super */ null && (["color", "size", "cursor", "margin", "id", "onClick"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ArrowIcon_ArrowIcon = function ArrowIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008cff" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "0px" : _ref$margin,
      id = _ref.id,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    id: id,
    style: {
      cursor: cursor,
      margin: margin
    },
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: onClick
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.99984 13.8333L7.04984 12.9L10.7832 9.16663H2.6665V7.83329H10.7832L7.04984 4.09996L7.99984 3.16663L13.3332 8.49996L7.99984 13.8333Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/LocationIcon.tsx


function LocationIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var LocationIcon_LocationIcon = function LocationIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#2B825E" : _ref$color,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", LocationIcon_objectSpread(LocationIcon_objectSpread({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.18195 3.91311C8.18195 6.07426 5.68191 8.4784 4.09098 10.0002C2.27276 8.261 0 6.07426 0 3.91311C0 1.75196 1.83159 0 4.09098 0C6.35036 0 8.18195 1.75196 8.18195 3.91311Z",
      fill: color
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 4.09106,
      cy: 3.53368,
      rx: 2,
      ry: 1.95556,
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/PersuasionTile.style.ts



var PersuasionTileStyles = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PersuasionTilestyle__PersuasionTileStyles",
  componentId: "sc-1n74jmn-0"
})(["background:", ";border-radius:4px;display:flex;justify-content:space-between;align-items:center;padding:8px 12px 8px 8px;", ""], function (props) {
  return props.bgColor;
}, function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
});
var LabelTag = styled_components_browser_esm["default"].p.withConfig({
  displayName: "PersuasionTilestyle__LabelTag",
  componentId: "sc-1n74jmn-1"
})(["padding:0;font-size:12px;line-height:18px;margin:0 0 0 4px;color:", ";.blackBoldText{font-weight:700;}.greenBoldText{font-weight:700;color:", ";}@media screen and ", "{margin-left:0px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.greenText */.rS.greenText, static_utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useDevice.ts
var hooks_useDevice = __webpack_require__(5187);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/PersuasionTile.tsx











var PersuasionTile_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PersuasionTile__Container",
  componentId: "sc-1e8gm4q-0"
})(["font-size:14px;line-height:20px;"]);

var PersuasionTile_PersuasionTile = function PersuasionTile(_ref) {
  var bgColor = _ref.bgColor,
      leftIcon = _ref.leftIcon,
      text = _ref.text,
      margin = _ref.margin,
      _ref$normalTextColor = _ref.normalTextColor,
      normalTextColor = _ref$normalTextColor === void 0 ? "black" : _ref$normalTextColor,
      linkBtn = _ref.linkBtn,
      isHtml = _ref.isHtml,
      id = _ref.id,
      flexId = _ref.flexId,
      htmlStyle = _ref.htmlStyle,
      _ref$doNotShiftLink = _ref.doNotShiftLink,
      doNotShiftLink = _ref$doNotShiftLink === void 0 ? false : _ref$doNotShiftLink;
  var device = (0,hooks_useDevice/* useDevice */.F)();

  var paraTagRenderer = function paraTagRenderer() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(PersuasionTile_Container, {
      children: [text && text.blackBoldText && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag/* default */.Z, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.blackText */.rS.blackText,
        children: text.blackBoldText
      }), " ", text && text.greenBoldText && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag/* default */.Z, {
        color: Global/* theme.greenText */.rS.greenText,
        fontSize: "xs",
        fontWeight: "bold",
        children: text.greenBoldText
      }), " ", (text === null || text === void 0 ? void 0 : text.normalText) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isHtml ? text.normalText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: text.normalText || ""
          },
          style: htmlStyle,
          suppressHydrationWarning: true
        }) : text.normalText && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag/* default */.Z, {
          fontSize: "xs",
          color: normalTextColor,
          children: text.normalText
        })
      }), " "]
    });
  };

  return device ? /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionTileStyles, {
    margin: margin,
    bgColor: bgColor,
    children: device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
        id: flexId,
        gap: "4px",
        alignItems: "center",
        flex: "1",
        padding: "0",
        children: [leftIcon && leftIcon, paraTagRenderer()]
      }), linkBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag/* default */.Z, {
        id: id,
        margin: "0px 0px 0px 8px",
        fontSize: "xs",
        fontWeight: "bold",
        handleClick: linkBtn.onClick,
        children: linkBtn.label
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
      id: flexId,
      gap: "12px",
      flex: "1",
      alignItems: "center",
      padding: "0",
      children: [leftIcon && leftIcon, /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
        gap: "0px",
        flexDirection: doNotShiftLink ? "row" : "column",
        alignItems: doNotShiftLink ? "center" : undefined,
        justifyContent: doNotShiftLink ? "space-between" : undefined,
        flex: "1",
        padding: "0",
        children: [paraTagRenderer(), linkBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag/* default */.Z, {
          id: id,
          handleClick: linkBtn.onClick,
          fontSize: "xs",
          fontWeight: "bold",
          children: linkBtn.label
        })]
      })]
    })
  }) : null;
};

/* harmony default export */ var LandingCardFeature_PersuasionTile = (PersuasionTile_PersuasionTile);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/RoundEcllipseIcon.tsx


function RoundEcllipseIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RoundEcllipseIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoundEcllipseIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoundEcllipseIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var RoundEcllipseIcon_RoundEcllipseIcon = function RoundEcllipseIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#CF8100" : _ref$color,
      props = _ref.props,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", RoundEcllipseIcon_objectSpread(RoundEcllipseIcon_objectSpread({
    width: width || 20,
    height: height || 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.068 9.49978C15.068 6.79315 12.8738 4.59899 10.1672 4.59899C7.46058 4.59899 5.26642 6.79315 5.26642 9.49978C5.26642 12.2064 7.46057 14.4006 10.1672 14.4006C12.8738 14.4006 15.068 12.2064 15.068 9.49978ZM10.1672 2.63867C13.9565 2.63867 17.0283 5.7105 17.0283 9.49978C17.0283 13.2891 13.9565 16.3609 10.1672 16.3609C6.37792 16.3609 3.3061 13.2891 3.3061 9.49978C3.3061 5.7105 6.37792 2.63867 10.1672 2.63867Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.068 9.49978C15.068 6.79315 12.8738 4.59899 10.1672 4.59899C9.62588 4.59899 9.18705 4.16016 9.18705 3.61883C9.18705 3.0775 9.62588 2.63867 10.1672 2.63867C13.9565 2.63867 17.0283 5.7105 17.0283 9.49978C17.0283 13.2891 13.9565 16.3609 10.1672 16.3609C9.62588 16.3609 9.18705 15.9221 9.18705 15.3807C9.18705 14.8394 9.62588 14.4006 10.1672 14.4006C12.8738 14.4006 15.068 12.2064 15.068 9.49978Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/DocsUploadIcon.tsx


function DocsUploadIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DocsUploadIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DocsUploadIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DocsUploadIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var DocsUploadIcon_DocsUploadIcon = function DocsUploadIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 48 : _ref$size,
      _ref$documentColor = _ref.documentColor,
      documentColor = _ref$documentColor === void 0 ? "#2B8DFF" : _ref$documentColor,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#F8F8F8" : _ref$bgColor,
      props = _ref.props;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", DocsUploadIcon_objectSpread(DocsUploadIcon_objectSpread({
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      width: 48,
      height: 48,
      rx: 24,
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: 13.2002,
      y: 10.801,
      width: 21.2677,
      height: 26.5846,
      rx: 2,
      fill: documentColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.7917 15.1197H29.8756",
      stroke: bgColor,
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.7917 19.8839H29.8756",
      stroke: bgColor,
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.8525 24.0942H23.1695",
      stroke: bgColor,
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: 31.4773,
      cy: 33.5074,
      r: 7.2,
      fill: "url(#paint0_linear_1755_53184)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M31.9004 29.9145V37.1021",
      stroke: "white",
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M28.3076 33.5069H35.4951",
      stroke: "white",
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint0_linear_1755_53184",
        x1: 26.3862,
        y1: 38.5985,
        x2: 36.5685,
        y2: 28.4162,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#EDD287"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#B8860B"
        })]
      })
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/LandingCardFeature.tsx


function LandingCardFeature_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LandingCardFeature_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LandingCardFeature_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LandingCardFeature_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var LandingCardFeature_LandingCardFeature = function LandingCardFeature(_ref) {
  var _loadCurrency$linkBtn, _viewOrdersPersuasion, _loadCurrency$btnOpti, _isUnavailableAtLoc$l;

  var margin = _ref.margin,
      padding = _ref.padding,
      border = _ref.border,
      borderWidth = _ref.borderWidth,
      data = _ref.data,
      idx = _ref.idx,
      loadCurrenyBtnHandler = _ref.loadCurrenyBtnHandler,
      recommendedBtnHandler = _ref.recommendedBtnHandler,
      startFromWhereLeftHandler = _ref.startFromWhereLeftHandler,
      docsPendingHandler = _ref.docsPendingHandler,
      onClick = _ref.onClick,
      onClickAnotherLocation = _ref.onClickAnotherLocation,
      onClickLoadMoney = _ref.onClickLoadMoney,
      viewDashBoardClickHandler = _ref.viewDashBoardClickHandler,
      viewOrdersClickHandler = _ref.viewOrdersClickHandler,
      isInfoOnRightSide = _ref.isInfoOnRightSide;
  var device = useDevice();
  var logoSrc = data.logoSrc,
      arrowIconSrc = data.arrowIconSrc,
      label = data.label,
      subLabel = data.subLabel,
      featuresArr = data.featuresArr,
      featureArrDesktop = data.featureArrDesktop,
      loadCurrency = data.loadCurrency,
      isleftOffBefore = data.isleftOffBefore,
      isRecommended = data.isRecommended,
      logoDesc = data.logoDesc,
      isRecommendNotification = data.isRecommendNotification,
      deliveryLabel = data.deliveryLabel,
      docsPending = data.docsPending,
      isUnavailableAtLoc = data.isUnavailableAtLoc,
      backendPersuasion = data.backendPersuasion,
      viewOrdersPersuasion = data.viewOrdersPersuasion,
      version = data.version;

  var loadCurrencyHandler = function loadCurrencyHandler(e, data) {
    loadCurrenyBtnHandler === null || loadCurrenyBtnHandler === void 0 ? void 0 : loadCurrenyBtnHandler(data);
    e.stopPropagation();
  };

  var onClickViewDashboard = function onClickViewDashboard(e, data) {
    viewDashBoardClickHandler === null || viewDashBoardClickHandler === void 0 ? void 0 : viewDashBoardClickHandler(data);
    e.stopPropagation();
  };

  var onClickViewOrders = function onClickViewOrders(e, data) {
    viewOrdersClickHandler === null || viewOrdersClickHandler === void 0 ? void 0 : viewOrdersClickHandler(data);
    e.stopPropagation();
  };

  var arrowIcon = arrowIconSrc ? /*#__PURE__*/_jsx(ImageTag, {
    src: arrowIconSrc
  }) : /*#__PURE__*/_jsx(ArrowIcon, {});
  return device ? /*#__PURE__*/_jsxs(LandingCardFeatureStyle, {
    margin: margin,
    border: border,
    padding: padding,
    borderWidth: borderWidth,
    version: version,
    children: [isRecommendNotification && device === "lg" && /*#__PURE__*/_jsx(AbsTag, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greenText,
        children: "Recommended"
      })
    }), /*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: device === "lg" ? isInfoOnRightSide ? "row" : "column" : "row",
      flex: "1",
      padding: "0px",
      gap: device === "lg" ? "0px" : "16px",
      handleClick: function handleClick() {
        onClick === null || onClick === void 0 ? void 0 : onClick(data, idx);
      },
      isCursorPointer: true,
      children: [/*#__PURE__*/_jsxs(LogoContainer, {
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.LOGO_CONTAINER),
        children: [/*#__PURE__*/_jsx(ImageTag, {
          src: logoSrc,
          width: device === "lg" ? "120px" : "100%"
        }), logoDesc && /*#__PURE__*/_jsxs(ParaTag, {
          margin: device === "lg" ? "0px 0px 6px" : "0px",
          fontSize: device === "sm" ? "xxs" : "xs",
          color: theme.greyText,
          children: [logoDesc.normalText, " ", logoDesc.boldText && /*#__PURE__*/_jsx(SpanTag, {
            fontWeight: "bold",
            color: theme.greyText,
            fontSize: device === "sm" ? "xxs" : "xs",
            children: logoDesc.boldText
          })]
        })]
      }), /*#__PURE__*/_jsxs(FlexComp, {
        padding: "0px",
        gap: "0px",
        flexDirection: "column",
        isCursorPointer: true,
        children: [/*#__PURE__*/_jsxs(FlexComp // handleClick={() => onClick(data, idx)}
        , {
          flex: "0",
          gap: "12px",
          justifyContent: device === "sm" ? "space-between" : "flex-start",
          alignItems: "center",
          isCursorPointer: true,
          children: [/*#__PURE__*/_jsx(ParaTag, {
            id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.HEADING),
            fontSize: "large",
            fontWeight: "bold",
            children: label
          }), !(loadCurrency !== null && loadCurrency !== void 0 && loadCurrency.isLoaded) && loadCurrency !== null && loadCurrency !== void 0 && loadCurrency.toAdd ? device === "lg" && arrowIcon : arrowIcon]
        }), !!subLabel && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "sm",
          children: subLabel
        }), featuresArr && featureArrDesktop && !loadCurrency && /*#__PURE__*/_jsx(PointsContainer, {
          children: (device === "lg" ? featureArrDesktop : featuresArr).map(function (item, idx) {
            return /*#__PURE__*/_jsx(SpanTag, {
              fontSize: device === "lg" ? "sm" : "xs",
              color: theme.greyText,
              display: "inline",
              children: item.label
            }, idx);
          })
        }), loadCurrency && /*#__PURE__*/_jsx(Fragment, {
          children: /*#__PURE__*/_jsxs(FlexComp, {
            margin: device === "lg" ? "12px 0px 0px" : "4px 0px 0px",
            flexDirection: "column",
            children: [!!loadCurrency.label && /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "xs",
              fontWeight: "bold",
              children: loadCurrency.label
            }), !!loadCurrency.subLabel && /*#__PURE__*/_jsxs(ParaTag, {
              fontSize: "xs",
              color: theme.greyText,
              margin: "2px 0px 12px",
              children: [loadCurrency.subLabel, !!loadCurrency.addText && /*#__PURE__*/_jsx(AnchorTag, {
                fontSize: "xs",
                fontWeight: "extraBold",
                margin: "0 0 0 4px",
                handleClick: function handleClick(e) {
                  return loadCurrencyHandler(e, data);
                },
                children: loadCurrency.addText
              })]
            }), !!loadCurrency.linkBtnInMobile && /*#__PURE__*/_jsx(AnchorTag, {
              id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.QUICK_LOAD),
              width: "fit-content",
              fontSize: device === "lg" ? "sm" : "xs",
              fontWeight: "bold",
              margin: device === "lg" ? "0px" : "12px 0 0 0",
              handleClick: function handleClick(e) {
                return onClickViewDashboard(e, data);
              },
              children: loadCurrency === null || loadCurrency === void 0 ? void 0 : (_loadCurrency$linkBtn = loadCurrency.linkBtnInMobile) === null || _loadCurrency$linkBtn === void 0 ? void 0 : _loadCurrency$linkBtn.label
            })]
          })
        }), viewOrdersPersuasion && version === VERSIONS.V2 && /*#__PURE__*/_jsx(FlexComp, {
          margin: device === "lg" ? "12px 0px 0px" : "4px 0px 0px",
          flexDirection: "column",
          children: (viewOrdersPersuasion === null || viewOrdersPersuasion === void 0 ? void 0 : viewOrdersPersuasion.linkBtnInMobile) && /*#__PURE__*/_jsx(AnchorTag, {
            width: "fit-content",
            fontSize: device === "lg" ? "sm" : "xs",
            fontWeight: "bold",
            margin: device === "lg" ? "0px" : "12px 0 0 0",
            handleClick: function handleClick(e) {
              return onClickViewOrders(e, data);
            },
            children: viewOrdersPersuasion === null || viewOrdersPersuasion === void 0 ? void 0 : (_viewOrdersPersuasion = viewOrdersPersuasion.linkBtnInMobile) === null || _viewOrdersPersuasion === void 0 ? void 0 : _viewOrdersPersuasion.label
          })
        }), !!deliveryLabel && /*#__PURE__*/_jsxs(FlexComp, {
          margin: "4px 0px 0px",
          alignItems: "center",
          flex: "0",
          padding: "0px",
          gap: "4px",
          children: [/*#__PURE__*/_jsx(LocationIcon, {}), /*#__PURE__*/_jsx(SpanTag, {
            id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.DELIVERY_ETA),
            color: theme.greenText,
            fontSize: "xs",
            fontWeight: "bold",
            dangerousText: deliveryLabel
          })]
        })]
      })]
    }), backendPersuasion && (backendPersuasion === null || backendPersuasion === void 0 ? void 0 : backendPersuasion.length) > 0 ? /*#__PURE__*/_jsx(_Fragment, {
      children: backendPersuasion === null || backendPersuasion === void 0 ? void 0 : backendPersuasion.map(function (_ref2, index) {
        var value = _ref2.value,
            theme = _ref2.theme;
        return /*#__PURE__*/_jsx(PersuasionTile, {
          flexId: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.PERSUASION_TILE.concat(index)),
          margin: "24px 0px 0px",
          text: {
            normalText: value
          },
          isHtml: true,
          bgColor: theme
        }, index);
      })
    }) : null, isleftOffBefore && /*#__PURE__*/_jsx(PersuasionTile, {
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.COMPLETE_ORDER),
      margin: "24px 0px 0px",
      text: isleftOffBefore.text,
      bgColor: theme.yellowText2,
      linkBtn: LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({}, isleftOffBefore === null || isleftOffBefore === void 0 ? void 0 : isleftOffBefore.linkBtn), {}, {
        onClick: startFromWhereLeftHandler ? function () {
          return startFromWhereLeftHandler(data);
        } : function () {
          console.log("link button");
        }
      }),
      leftIcon: isleftOffBefore.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
        src: isleftOffBefore.iconSrc
      }) : /*#__PURE__*/_jsx(RoundEcllipseIcon, {
        width: "50px",
        height: "50px"
      })
    }), isRecommended && /*#__PURE__*/_jsx(PersuasionTile, {
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.TRACK_BTN),
      margin: "24px 0px 0px",
      text: isRecommended.text,
      doNotShiftLink: true,
      bgColor: theme.greenText2,
      isHtml: true,
      htmlStyle: {
        fontSize: "12px",
        lineHeight: 1,
        marginBottom: "4px"
      },
      linkBtn: LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({}, isRecommended === null || isRecommended === void 0 ? void 0 : isRecommended.linkBtn), {}, {
        onClick: recommendedBtnHandler ? function () {
          return recommendedBtnHandler(data);
        } : function () {
          console.log("recommended");
        }
      })
    }), loadCurrency && loadCurrency.btnOptions ? /*#__PURE__*/_jsx(LandingButton, LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({}, loadCurrency.btnOptions), {}, {
      onClick: loadCurrenyBtnHandler ? function () {
        return loadCurrenyBtnHandler(data);
      } : function () {
        console.log("landing button: load currency");
      },
      fontSize: "12px",
      margin: "25px 0px 0px",
      customHeight: "32px",
      customWidth: "100%"
    })) : /*#__PURE__*/_jsx(AnchorTag, {
      width: "fit-content",
      fontSize: "xs",
      fontWeight: "extraBold" // margin="12px 0px 0px"
      ,
      handleClick: loadCurrenyBtnHandler ? function () {
        return loadCurrenyBtnHandler(data);
      } : function () {
        console.log("load currency");
      },
      children: loadCurrency === null || loadCurrency === void 0 ? void 0 : (_loadCurrency$btnOpti = loadCurrency.btnOptions) === null || _loadCurrency$btnOpti === void 0 ? void 0 : _loadCurrency$btnOpti.customTitle
    }), isUnavailableAtLoc &&
    /*#__PURE__*/
    // <PersuasionTile
    //     margin="24px 0px 0px"
    //     bgColor={theme.yellowText2}
    //     normalTextColor={theme.brownText}
    //     text={isUnavailableAtLoc.text}
    // />
    _jsx(NotLocationText, {
      children: isUnavailableAtLoc.normalText && /*#__PURE__*/_jsxs(ParaTag, {
        fontSize: "xs",
        color: theme.brownText,
        children: [isUnavailableAtLoc.normalText, " ", isUnavailableAtLoc.linkText && /*#__PURE__*/_jsx(AnchorTag, {
          id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.ANOTHER_LOC_BTN),
          width: "fit-content",
          fontSize: "xs",
          fontWeight: "bold" // hrefProp={
          //     isUnavailableAtLoc.linkText.hrefLink
          // }
          ,
          onClick: onClickAnotherLocation ? function () {
            return onClickAnotherLocation(data);
          } : function () {
            console.log("another location");
          },
          children: (_isUnavailableAtLoc$l = isUnavailableAtLoc.linkText) === null || _isUnavailableAtLoc$l === void 0 ? void 0 : _isUnavailableAtLoc$l.text
        })]
      })
    }), docsPending && /*#__PURE__*/_jsxs(FlexComp, {
      padding: "12px",
      borderRadius: "8px",
      margin: "24px 0px 0px",
      justifyContent: "space-between",
      flexDirection: device === "sm" ? "column" : "row",
      bgColor: "linear-gradient(159.48deg, #FFF9ED 4.69%, rgba(255, 239, 236, 0.736176) 27.76%, #F8F9E7 92.13%)",
      children: [(docsPending.label || docsPending.iconSrc) && /*#__PURE__*/_jsxs(FlexComp, {
        padding: "0px",
        alignItems: "center",
        justifyContent: "space-between",
        margin: device === "sm" ? "0px 0px 16px" : "0px",
        children: [docsPending.label && /*#__PURE__*/_jsx(ParaTag, {
          fontWeight: "bold",
          color: theme.brownText,
          margin: "0px 20px 0px 0px",
          children: docsPending.label
        }), device === "sm" && (docsPending.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
          src: docsPending.iconSrc
        }) : /*#__PURE__*/_jsx(DocsUploadIcon, {}))]
      }), docsPending.btnProps && /*#__PURE__*/_jsx(LandingButton, LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.UPLOAD_NOW)
      }, docsPending.btnProps), {}, {
        onClick: docsPendingHandler ? function () {
          return docsPendingHandler(data);
        } : function () {
          console.log("doc pending");
        },
        flexShrink: "0",
        customWidth: device === "sm" ? "100%" : undefined
      }))]
    }), viewOrdersPersuasion && version === VERSIONS.V1 && /*#__PURE__*/_jsxs(FlexComp, {
      padding: "12px",
      borderRadius: "8px",
      margin: "24px 0px 0px",
      justifyContent: "space-between",
      flexDirection: device === "sm" ? "column" : "row",
      bgColor: "linear-gradient(159.48deg, #FFF9ED 4.69%, rgba(255, 239, 236, 0.736176) 27.76%, #F8F9E7 92.13%)",
      children: [(viewOrdersPersuasion.label || viewOrdersPersuasion.iconSrc) && /*#__PURE__*/_jsxs(FlexComp, {
        padding: "0px",
        alignItems: "center",
        justifyContent: "space-between",
        margin: device === "sm" ? "0px 0px 16px" : "0px",
        children: [viewOrdersPersuasion.label && /*#__PURE__*/_jsx(ParaTag, {
          fontWeight: "bold",
          color: theme.brownText,
          margin: "0px 20px 0px 0px",
          children: viewOrdersPersuasion.label
        }), device === "sm" && (viewOrdersPersuasion.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
          src: viewOrdersPersuasion.iconSrc
        }) : /*#__PURE__*/_jsx(DocsUploadIcon, {}))]
      }), viewOrdersPersuasion.btnProps && /*#__PURE__*/_jsx(LandingButton, LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.UPLOAD_NOW)
      }, viewOrdersPersuasion.btnProps), {}, {
        onClick: docsPendingHandler ? function () {
          return docsPendingHandler(data);
        } : function () {
          console.log("view orders");
        },
        flexShrink: "0",
        customWidth: device === "sm" ? "100%" : undefined
      }))]
    })]
  }) : /*#__PURE__*/_jsx(Fragment, {});
};

/* harmony default export */ var components_LandingCardFeature_LandingCardFeature = ((/* unused pure expression or super */ null && (LandingCardFeature_LandingCardFeature)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/IconTextTag/IconTextTag.style.ts

var IconTextTag_style_IconTextTagStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "IconTextTagstyle__IconTextTagStyle",
  componentId: "sc-1rd5pla-0"
})(["cursor:pointer;display:flex;padding:12px 16px;", " background:linear-gradient( 147.2deg,#fff6d8 4.79%,#fffaf3 43.98%,#f3f0e6 120.5% );justify-content:space-between;"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/IconTextTag/IconTextTag.tsx











var IconTextTag_IconTextTag = function IconTextTag(_ref) {
  var label = _ref.label,
      subLabel = _ref.subLabel,
      icon = _ref.icon,
      margin = _ref.margin,
      onClick = _ref.onClick;
  var device = useDevice();
  return device ? /*#__PURE__*/_jsxs(IconTextTagStyle, {
    onClick: onClick,
    margin: margin,
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "4px",
      padding: "0px",
      isCursorPointer: true,
      flexDirection: device === "lg" ? "row" : "column",
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.blackText,
        children: label
      }), subLabel && /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        color: theme.greyText,
        children: subLabel
      })]
    }), icon ? /*#__PURE__*/_jsx(ImageTag, {
      src: icon,
      showCursorPointer: true
    }) : /*#__PURE__*/_jsx(ArrowIcon, {})]
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};

/* harmony default export */ var components_IconTextTag_IconTextTag = ((/* unused pure expression or super */ null && (IconTextTag_IconTextTag)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(7001);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/CliptextStyle.tsx




var CliptextStyle_CliptextStyle = function CliptextStyle(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      id = _ref.id;
  return /*#__PURE__*/_jsx(CliptextStyleComp, {
    margin: margin,
    id: id,
    children: children
  });
};

/* harmony default export */ var TextStyles_CliptextStyle = ((/* unused pure expression or super */ null && (CliptextStyle_CliptextStyle)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/ChevronDownIcon.tsx


var ChevronDownIcon_excluded = (/* unused pure expression or super */ null && (["cursor", "sizeX", "sizeY", "viewBoxPosX", "viewBoxPosY", "viewBoxSizeX", "viewBoxSizeY"]));

function ChevronDownIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevronDownIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevronDownIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevronDownIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ChevronDownIcon_ChevronDownIcon = function ChevronDownIcon(_ref) {
  var _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      _ref$sizeX = _ref.sizeX,
      sizeX = _ref$sizeX === void 0 ? 24 : _ref$sizeX,
      _ref$sizeY = _ref.sizeY,
      sizeY = _ref$sizeY === void 0 ? 24 : _ref$sizeY,
      _ref$viewBoxPosX = _ref.viewBoxPosX,
      viewBoxPosX = _ref$viewBoxPosX === void 0 ? 0 : _ref$viewBoxPosX,
      _ref$viewBoxPosY = _ref.viewBoxPosY,
      viewBoxPosY = _ref$viewBoxPosY === void 0 ? 0 : _ref$viewBoxPosY,
      _ref$viewBoxSizeX = _ref.viewBoxSizeX,
      viewBoxSizeX = _ref$viewBoxSizeX === void 0 ? 24 : _ref$viewBoxSizeX,
      _ref$viewBoxSizeY = _ref.viewBoxSizeY,
      viewBoxSizeY = _ref$viewBoxSizeY === void 0 ? 24 : _ref$viewBoxSizeY,
      props = _objectWithoutProperties(_ref, ChevronDownIcon_excluded);

  return /*#__PURE__*/_jsx("svg", ChevronDownIcon_objectSpread(ChevronDownIcon_objectSpread({
    width: 24,
    height: 24,
    fill: "none",
    style: {
      cursor: cursor
    },
    viewBox: "".concat(viewBoxPosX, " ").concat(viewBoxPosY, " ").concat(viewBoxSizeX, " ").concat(viewBoxSizeY),
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.8583 13.3941C11.9364 13.4722 12.063 13.4722 12.1411 13.3941L16.2423 9.29289C16.6329 8.90237 17.266 8.90237 17.6566 9.29289C18.0471 9.68342 18.0471 10.3166 17.6566 10.7071L12.7068 15.6569C12.3163 16.0474 11.6831 16.0474 11.2926 15.6569L6.34285 10.7071C5.95232 10.3166 5.95232 9.68342 6.34285 9.29289C6.73337 8.90237 7.36654 8.90237 7.75706 9.29289L11.8583 13.3941Z",
      fill: "#008CFF"
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/SectionDividers/SectionDividers.style.ts

var SectionDividers_style_SectionDividersStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionDividersstyle__SectionDividersStyle",
  componentId: "aokiou-0"
})(["background:#f2f2f2;width:var(--tm-width,unset);height:var(--tm-height,4px);border-radius:var(--borderRadius,0px);margin:var(--margin,0px);", ";", ";", ";flex-shrink:0;"], function (p) {
  return p.xs && "height: 1px;";
}, function (p) {
  return p.small && "height: 10px;";
}, function (p) {
  return p.large && "height: 25px;";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/SectionDividers/SectionDividers.tsx



var SectionDividers_SectionDividers = function SectionDividers(_ref) {
  var small = _ref.small,
      large = _ref.large,
      xs = _ref.xs,
      width = _ref.width,
      height = _ref.height,
      borderRadius = _ref.borderRadius,
      margin = _ref.margin;
  return /*#__PURE__*/_jsx(SectionDividersStyle, {
    small: small,
    large: large,
    xs: xs,
    style: {
      "--tm-width": width,
      "--tm-height": height,
      "--borderRadius": borderRadius,
      "--margin": margin
    }
  });
};

/* harmony default export */ var components_SectionDividers_SectionDividers = ((/* unused pure expression or super */ null && (SectionDividers_SectionDividers)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/DeliveryPersuasion/DeliveryPersuasion.style.ts
var DeliveryPersuasion_style = __webpack_require__(3636);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DeliveryPersuasion/DeliveryPersuasion.tsx















var DeliveryPersuasion_DeliveryPersuasion = function DeliveryPersuasion(_ref) {
  var margin = _ref.margin,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "8px 12px" : _ref$padding,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "linear-gradient(90.01deg, #deedff 0%, rgba(230, 241, 255, 0) 108.89%)" : _ref$bgColor,
      text = _ref.text,
      editLocationHandler = _ref.editLocationHandler,
      upArrow = _ref.upArrow,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
      _ref$checkPincode = _ref.checkPincode,
      checkPincode = _ref$checkPincode === void 0 ? false : _ref$checkPincode,
      checkPincodeLabel = _ref.checkPincodeLabel,
      checkPincodeHandler = _ref.checkPincodeHandler,
      arrowIcon = _ref.arrowIcon,
      ctaText = _ref.ctaText,
      _ref$isTextCenter = _ref.isTextCenter,
      isTextCenter = _ref$isTextCenter === void 0 ? false : _ref$isTextCenter,
      _ref$styleWithFlex = _ref.styleWithFlex,
      styleWithFlex = _ref$styleWithFlex === void 0 ? true : _ref$styleWithFlex,
      _ref$showDivider = _ref.showDivider,
      showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider,
      version = _ref.version;
  return checkPincode ? /*#__PURE__*/_jsx(_Fragment, {
    children: checkPincode ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [showDivider && /*#__PURE__*/_jsx(SectionDividers, {
        width: "40px",
        borderRadius: "15px",
        margin: "0px 0px 12px 0px"
      }), /*#__PURE__*/_jsx(DeliveryPersuasionComp, {
        bgColor: theme.whiteText,
        padding: "Opx",
        margin: margin,
        children: /*#__PURE__*/_jsx(DeliveryPersuasionStyle, {
          fontSize: "sm",
          dangerouslySetInnerHTML: {
            __html: text
          }
        })
      }), /*#__PURE__*/_jsx(ParaTag, {
        margin: "0 0 8px 0",
        children: /*#__PURE__*/_jsxs(Cta, {
          onClick: checkPincodeHandler,
          children: [checkPincodeLabel, " ", arrowIcon ? /*#__PURE__*/_jsx(ImgWpr, {
            isFlex: true,
            children: /*#__PURE__*/_jsx(ImageTag, {
              src: arrowIcon
            })
          }) : /*#__PURE__*/_jsx(ImgWpr, {
            isFlex: true,
            children: /*#__PURE__*/_jsx(ArrowIcon, {})
          })]
        })
      })]
    }) : /*#__PURE__*/_jsx(DeliveryPersuasionComp, {
      margin: margin,
      bgColor: bgColor,
      padding: padding,
      isTextCenter: isTextCenter,
      styleWithFlex: styleWithFlex,
      children: /*#__PURE__*/_jsxs(DeliveryPersuasionStyle, {
        fontSize: "sm",
        children: [/*#__PURE__*/_jsx(SpanTag, {
          color: version === VERSIONS.V3 ? theme.blackText : theme.whiteText,
          fontSize: "sm",
          dangerousText: text
        }), (!!ctaText || showIcon) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [" ", /*#__PURE__*/_jsxs(AnchorTag, {
            id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.DELIVERY, ElementNameMapping.DELIVERY_LOC),
            fontSize: "sm",
            display: "inline-flex",
            handleClick: editLocationHandler,
            children: [!!ctaText && /*#__PURE__*/_jsx(DeliveryLocationText, {
              fontWeight: "bold",
              color: theme.blueText,
              dangerouslySetInnerHTML: {
                __html: ctaText
              }
            }), showIcon && (upArrow ? /*#__PURE__*/_jsx(ImageTag, {
              src: upArrow
            }) : /*#__PURE__*/_jsx(ChevronDownIcon, {
              sizeY: 24,
              viewBoxPosY: 2,
              viewBoxSizeY: 24
            }))]
          })]
        })]
      })
    })
  }) : /*#__PURE__*/_jsx(DeliveryPersuasionComp, {
    margin: margin,
    bgColor: bgColor,
    padding: padding,
    isTextCenter: isTextCenter,
    styleWithFlex: styleWithFlex,
    children: /*#__PURE__*/_jsxs(DeliveryPersuasionStyle, {
      fontSize: "sm",
      children: [/*#__PURE__*/_jsx(SpanTag, {
        color: version === VERSIONS.V3 ? theme.blackText : theme.greyText9,
        fontSize: "sm",
        dangerousText: text
      }), (!!ctaText || showIcon) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [" ", /*#__PURE__*/_jsxs(AnchorTag, {
          id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.DELIVERY, ElementNameMapping.DELIVERY_LOC),
          fontSize: "sm",
          display: "inline-flex",
          handleClick: editLocationHandler,
          children: [!!ctaText && /*#__PURE__*/_jsx(DeliveryLocationText, {
            fontWeight: "bold",
            color: theme.blueText,
            dangerouslySetInnerHTML: {
              __html: ctaText
            }
          }), showIcon && (upArrow ? /*#__PURE__*/_jsx(ImageTag, {
            src: upArrow
          }) : /*#__PURE__*/_jsx(ChevronDownIcon, {
            sizeY: 24,
            viewBoxPosY: 2,
            viewBoxSizeY: 24
          }))]
        })]
      })]
    })
  });
};

/* harmony default export */ var components_DeliveryPersuasion_DeliveryPersuasion = ((/* unused pure expression or super */ null && (DeliveryPersuasion_DeliveryPersuasion)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/H4Tag.tsx




var H4Tag_H4Tag = function H4Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color,
      id = _ref.id,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "h4" : _ref$as;
  return /*#__PURE__*/_jsx(H4TagStyle, {
    id: id,
    style: {
      "--color": color,
      "--margin": margin
    },
    as: as,
    children: children
  });
};

/* harmony default export */ var TextStyles_H4Tag = ((/* unused pure expression or super */ null && (H4Tag_H4Tag)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/MarqueeBar/Marquee.style.ts



var dotsFadeInOne = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0.3;};33%{opacity:1;}100%{opacity:1;};"]);
var dotsFadeInTwo = (0,styled_components_browser_esm.keyframes)(["0%{opacity:1;};33%{opacity:0.3;}100%{opacity:1;};"]);
var dotsFadeInThree = (0,styled_components_browser_esm.keyframes)(["0%{opacity:1;};66%{opacity:0.3;}100%{opacity:1;};"]);
var marqueeScroll = (0,styled_components_browser_esm.keyframes)(["from{transform:translateX(0);}to{transform:translateX(calc(-100%));}"]);
var Marquee_style_MarqueeBarStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Marqueestyle__MarqueeBarStyle",
  componentId: "sc-1temmac-0"
})(["display:flex;align-items:center;gap:", ";border-radius:4px 0px 0px 4px;", " ", ""], function (props) {
  return props.gap ? props.gap : "0px";
}, function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.padding && "padding: ".concat(props.padding, ";");
});
var Tag = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Marqueestyle__Tag",
  componentId: "sc-1temmac-1"
})(["padding:12px 15px;border-radius:4px 0px 0px 4px;flex-shrink:0;position:relative;overflow:hidden;z-index:2;background-color:", ";&:after{content:\"\";position:absolute;width:100px;height:100px;top:-61px;z-index:-1;left:-60px;background-color:", ";transform:rotate(53deg);}@media screen and ", "{padding:12px 6px;}"], Global/* theme.redText3 */.rS.redText3, Global/* theme.redText4 */.rS.redText4, static_utils/* deviceType.mobile */.vO.mobile);
var Marquee_style_DotsAnimation = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Marqueestyle__DotsAnimation",
  componentId: "sc-1temmac-2"
})(["padding-top:6px;display:flex;& > span{display:inline-block;width:3px;height:3px;border-radius:50%;margin-right:2px;background-color:", ";}& > span:nth-child(1){animation:", " linear 2s infinite;}& > span:nth-child(2){animation:", " linear 2s infinite;}& > span:nth-child(3){animation:", " linear 2s infinite;}& > span:last-child{margin-right:0px;}"], function (props) {
  return props.isOnBottom ? Global/* theme.yellowText */.rS.yellowText : Global/* theme.yellowText4 */.rS.yellowText4;
}, dotsFadeInOne, dotsFadeInTwo, dotsFadeInThree);
var Marquee_style_MarqueeContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Marqueestyle__MarqueeContainer",
  componentId: "sc-1temmac-3"
})(["position:relative;display:flex;user-select:none;overflow:hidden;width:100%;", " @media screen and ", "{", " z-index:10;width:100%;overflow-x:scroll;}"], function (props) {
  return props.isOnBottom && "\n        background-color: ".concat(Global/* theme.smokeWhite */.rS.smokeWhite, ";\n    ");
}, static_utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.isOnBottom && "padding: 8px;";
});
var Marquee_style_MarqueeRibbon = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "Marqueestyle__MarqueeRibbon",
  componentId: "sc-1temmac-4"
})(["padding:0;list-style:none;flex-shrink:0;display:flex;justify-content:space-around;min-width:100%;animation:", " 20s linear infinite;& > li{margin:0px 10px;}@media screen and ", "{animation:none;}", ""], marqueeScroll, static_utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.isPaused && "animation-play-state: paused !important;";
});
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/Shimmer.tsx + 1 modules
var Shimmer_Shimmer = __webpack_require__(7005);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/MarqueeBar/MarqueeBar.tsx












var MarqueeBar = function MarqueeBar(_ref) {
  var leftTagText = _ref.leftTagText,
      marqueeData = _ref.marqueeData,
      margin = _ref.margin,
      padding = _ref.padding,
      _ref$isOnBottom = _ref.isOnBottom,
      isOnBottom = _ref$isOnBottom === void 0 ? false : _ref$isOnBottom,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading,
      loadingText = _ref.loadingText,
      marqueeCtrBgColor = _ref.marqueeCtrBgColor,
      _ref$marqueeBarBgColo = _ref.marqueeBarBgColor,
      marqueeBarBgColor = _ref$marqueeBarBgColo === void 0 ? "rgba(74, 74, 74, 0.3)" : _ref$marqueeBarBgColo,
      LIVETagImgURI = _ref.LIVETagImgURI,
      version = _ref.version;
  var device = useDevice();

  var _useState = useState(false),
      isPaused = _useState[0],
      setIsPaused = _useState[1];

  var loaderRender = function loaderRender() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [loadingText && /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        margin: "0px 4px 0px 10px",
        color: isOnBottom ? theme.yellowText : theme.yellowText4,
        children: loadingText
      }), /*#__PURE__*/_jsxs(DotsAnimation, {
        isOnBottom: isOnBottom,
        children: [/*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("span", {})]
      }), /*#__PURE__*/_jsx(FlexComp, {
        margin: "0px 0px 0px 16px",
        flex: "1",
        gap: "16px",
        children: device === "lg" ? /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px"
          })]
        }) : /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px",
            background: isOnBottom ? "linear-gradient(to right, #CBCBCB 8%, rgba(203, 203, 203, 0) 18%, #CBCBCB 33%)" : undefined
          }), /*#__PURE__*/_jsx(Shimmer, {
            flex: 1,
            height: "16px",
            background: isOnBottom ? "linear-gradient(to right, #CBCBCB 8%, rgba(203, 203, 203, 0) 18%, #CBCBCB 33%)" : undefined
          })]
        })
      })]
    });
  };

  return device ? /*#__PURE__*/_jsx(MarqueeBarStyle, {
    margin: margin,
    padding: padding,
    isLoading: isLoading,
    isOnBottom: isOnBottom,
    marqueeBarBgColor: marqueeBarBgColor,
    onMouseEnter: device === "lg" ? function () {
      setIsPaused(true);
    } : undefined,
    onMouseLeave: device === "lg" ? function () {
      setIsPaused(false);
    } : undefined,
    onTouchStart: device === "sm" ? function () {
      setIsPaused(true);
    } : undefined,
    onTouchEnd: device === "sm" ? function () {
      setIsPaused(false);
    } : undefined,
    children: isLoading ? loaderRender() : /*#__PURE__*/_jsxs(Fragment, {
      children: [LIVETagImgURI && /*#__PURE__*/_jsx(ImageTag, {
        src: LIVETagImgURI,
        width: device === "lg" ? "50px" : "35px"
      }), marqueeData && /*#__PURE__*/_jsxs(MarqueeContainer, {
        isOnBottom: isOnBottom,
        onMouseEnter: function onMouseEnter() {
          setIsPaused(true);
        },
        onMouseLeave: function onMouseLeave() {
          setIsPaused(false);
        },
        marqueeCtrBgColor: marqueeCtrBgColor,
        children: [/*#__PURE__*/_jsx(MarqueeRibbon, {
          isOnBottom: isOnBottom,
          isPaused: isPaused,
          children: marqueeData.map(function (item) {
            return /*#__PURE__*/_jsxs("li", {
              children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
                color: isOnBottom ? theme.blackText : version === VERSIONS.V3 && device === "sm" ? theme.blackText : theme.whiteText,
                fontWeight: "bold",
                margin: device === "lg" ? "0px 4px 0px 0px" : "0px 4px 4px 0px",
                fontSize: device === "sm" ? "xs" : "sm",
                children: item.boldText
              }), item.text && /*#__PURE__*/_jsx(SpanTag, {
                fontSize: device === "sm" ? "xs" : "sm",
                color: isOnBottom ? theme.greyText6 : version === VERSIONS.V3 && device === "sm" ? theme.greyText6 : theme.whiteText,
                children: item.text
              }), item.blueText && /*#__PURE__*/_jsx(SpanTag, {
                fontSize: device === "sm" ? "xs" : "md",
                color: theme.blueText,
                fontWeight: "bold",
                children: item.blueText
              })]
            }, item.id);
          })
        }), device === "lg" && /*#__PURE__*/_jsx(MarqueeRibbon, {
          isPaused: isPaused,
          "aria-hidden": "true",
          isOnBottom: isOnBottom,
          children: marqueeData.map(function (item) {
            return /*#__PURE__*/_jsxs("li", {
              children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
                color: isOnBottom ? theme.blackText : theme.whiteText,
                margin: device === "lg" ? "0px 4px 0px 0px" : "0px 4px 4px 0px",
                fontWeight: "bold",
                fontSize: "sm",
                children: item.boldText
              }), item.text && /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                color: isOnBottom ? theme.greyText6 : theme.whiteText,
                children: item.text
              }), item.blueText && /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "md",
                color: theme.blueText,
                fontWeight: "bold",
                children: item.blueText
              })]
            }, item.id);
          })
        })]
      })]
    })
  }) : /*#__PURE__*/_jsx(Fragment, {});
};

/* harmony default export */ var MarqueeBar_MarqueeBar = ((/* unused pure expression or super */ null && (MarqueeBar)));
var MarqueeBar_MarqueeBanner = (/* unused pure expression or super */ null && (MarqueeBar));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/LocationFetchingIcon.tsx


function LocationFetchingIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationFetchingIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationFetchingIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationFetchingIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var LocationFetchingIcon_LocationFetchingIcon = function LocationFetchingIcon(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", LocationFetchingIcon_objectSpread(LocationFetchingIcon_objectSpread({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M36 17.2174C36 26.7263 25 37.3043 18 44C10 36.3478 0 26.7263 0 17.2174C0 7.70849 8.05887 0 18 0C27.9411 0 36 7.70849 36 17.2174Z",
      fill: "#008CFF"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 18,
      cy: 17.6004,
      rx: 13.5,
      ry: 13.2,
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/LocationMarkerWithCheck.tsx


function LocationMarkerWithCheck_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationMarkerWithCheck_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationMarkerWithCheck_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationMarkerWithCheck_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var LocationMarkerWithCheck_LocationMarkerWithCheck = function LocationMarkerWithCheck(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 36 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 44 : _ref$height,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", LocationMarkerWithCheck_objectSpread(LocationMarkerWithCheck_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M36 17.2174C36 26.7263 25 37.3043 18 44C10 36.3478 0 26.7263 0 17.2174C0 7.70849 8.05887 0 18 0C27.9411 0 36 7.70849 36 17.2174Z",
      fill: "#008CFF"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 18,
      cy: 17.6004,
      rx: 13.5,
      ry: 13.2,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 17.2174C36 26.7263 25 37.3043 18 44C10 36.3478 0 26.7263 0 17.2174C0 7.70849 8.05887 0 18 0C27.9411 0 36 7.70849 36 17.2174Z",
      fill: "#2B825E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 18,
      cy: 17.6004,
      rx: 13.5,
      ry: 13.2,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.734 11.9977C25.0547 11.4664 24.0636 11.574 23.5202 12.2382L15.7396 21.7478L12.4717 17.821C11.9227 17.1613 10.9307 17.0617 10.256 17.5985C9.58128 18.1353 9.4794 19.1053 10.0284 19.765L13.6484 24.1147C14.7346 25.42 16.7758 25.4117 17.851 24.0977L25.9799 14.1622C26.5233 13.4981 26.4132 12.529 25.734 11.9977Z",
      fill: "#2B825E"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DiscountBanner/DiscountBanner.style.ts




var DiscountBanner_style_LabelContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DiscountBannerstyle__LabelContainer",
  componentId: "sc-1vypl57-0"
})(["display:flex;flex-direction:row;gap:4px;align-items:baseline;margin-right:10px;@media ", "{flex-direction:column;flex:1;}"], static_utils/* deviceType.mobile */.vO.mobile);
var DiscountBanner_style_DiscountLabel = (0,styled_components_browser_esm["default"])(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "DiscountBannerstyle__DiscountLabel",
  componentId: "sc-1vypl57-1"
})(["font-weight:", ";font-size:", ";line-height:", ";color:", ";padding-top:", ";.greenTextMob{color:#5ee8ba;font-weight:700;}.greenTextMobV3{color:#1e5c43;font-weight:700;}.greenTextWeb{color:#1e5c43;font-weight:700;}"], function (props) {
  return props !== null && props !== void 0 && props.fontWeight ? props.fontWeight : 700;
}, function (props) {
  return props !== null && props !== void 0 && props.fontSize ? props.fontSize : "12px";
}, function (props) {
  return props !== null && props !== void 0 && props.lineHeight ? props.lineHeight : "16px";
}, function (props) {
  return props !== null && props !== void 0 && props.color ? props.color : Global/* theme.blackText */.rS.blackText;
}, function (props) {
  var _props$paddingTop;

  return (_props$paddingTop = props === null || props === void 0 ? void 0 : props.paddingTop) !== null && _props$paddingTop !== void 0 ? _props$paddingTop : "0px";
});
var DiscountBanner_style_DiscountSubLabel = (0,styled_components_browser_esm["default"])(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "DiscountBannerstyle__DiscountSubLabel",
  componentId: "sc-1vypl57-2"
})(["font-weight:400;font-size:12px;line-height:16px;color:#1e5c43;.greenTextMob{color:#5ee8ba;font-weight:700;}.greenTextMobV3{color:#1e5c43;font-weight:700;}.greenTextWeb{color:#1e5c43;font-weight:700;}@media ", "{font-weight:400;color:", ";}"], static_utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props !== null && props !== void 0 && props.color ? props.color : Global/* theme.whiteText */.rS.whiteText;
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/ChevRight.tsx


var ChevRight_excluded = (/* unused pure expression or super */ null && (["color", "cursor"]));

function ChevRight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevRight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevRight_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevRight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var ChevRight_ChevRight = function ChevRight(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, ChevRight_excluded);

  return /*#__PURE__*/_jsx("svg", ChevRight_objectSpread(ChevRight_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    color: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.3941 12.1414C13.4722 12.0633 13.4722 11.9367 13.3941 11.8586L9.29289 7.75735C8.90237 7.36683 8.90237 6.73366 9.29289 6.34314C9.68342 5.95261 10.3166 5.95261 10.7071 6.34314L15.6569 11.2929C16.0474 11.6834 16.0474 12.3166 15.6569 12.7071L10.7071 17.6568C10.3166 18.0474 9.68342 18.0474 9.29289 17.6568C8.90237 17.2663 8.90237 16.6332 9.29289 16.2426L13.3941 12.1414Z",
      fill: color
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/InfoIcon.tsx


var InfoIcon_excluded = (/* unused pure expression or super */ null && (["cursor", "color", "width", "height"]));

function InfoIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InfoIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InfoIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InfoIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var InfoIcon_InfoIcon = function InfoIcon(_ref) {
  var _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      color = _ref.color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 16 : _ref$height,
      props = _objectWithoutProperties(_ref, InfoIcon_excluded);

  return /*#__PURE__*/_jsx("svg", InfoIcon_objectSpread(InfoIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.600098 7.99998C0.600098 12.0869 3.91319 15.4 8.0001 15.4C12.087 15.4 15.4001 12.0869 15.4001 7.99998C15.4001 3.91307 12.087 0.599976 8.0001 0.599976C3.91319 0.599976 0.600098 3.91307 0.600098 7.99998ZM14.4001 7.99998C14.4001 11.5346 11.5347 14.4 8.0001 14.4C4.46547 14.4 1.6001 11.5346 1.6001 7.99998C1.6001 4.46535 4.46547 1.59998 8.0001 1.59998C11.5347 1.59998 14.4001 4.46535 14.4001 7.99998ZM8.67002 7.32318V11.732C8.67002 12.102 8.37008 12.4019 8.0001 12.4019C7.63011 12.4019 7.33018 12.102 7.33018 11.732V7.32318C7.33018 6.95319 7.63011 6.65326 8.0001 6.65326C8.37008 6.65326 8.67002 6.95319 8.67002 7.32318ZM8.79646 5.51487C8.84592 5.40887 8.87066 5.29462 8.87066 5.17422C8.87066 5.05465 8.84628 4.93973 8.79782 4.83127C8.751 4.72648 8.68784 4.634 8.6088 4.55495C8.52894 4.47509 8.43531 4.4123 8.32921 4.36714C8.22161 4.32136 8.10785 4.29838 7.98954 4.29838C7.87042 4.29838 7.75737 4.32168 7.65223 4.36841C7.54976 4.41395 7.45911 4.47707 7.38144 4.55702C7.30423 4.63651 7.24305 4.72941 7.19831 4.83454C7.15252 4.94214 7.12954 5.05591 7.12954 5.17422C7.12954 5.29334 7.15285 5.40638 7.19958 5.51152C7.24433 5.61222 7.30514 5.7023 7.38144 5.78085C7.45911 5.8608 7.54976 5.92392 7.65223 5.96946C7.75737 6.01619 7.87042 6.0395 7.98954 6.0395C8.10785 6.0395 8.22161 6.01651 8.32921 5.97073C8.43531 5.92558 8.52894 5.86278 8.6088 5.78292C8.6869 5.70482 8.74965 5.61518 8.79646 5.51487Z",
      fill: color || "#4A4A4A"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DiscountBanner/DiscountBanner.tsx











var DiscountBanner_DiscountBanner = function DiscountBanner(_ref) {
  var discountImg = _ref.discountImg,
      label = _ref.label,
      bgColor = _ref.bgColor,
      width = _ref.width,
      margin = _ref.margin,
      padding = _ref.padding,
      color = _ref.color,
      fontWeight = _ref.fontWeight,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
      onPressHandler = _ref.onPressHandler,
      iconColor = _ref.iconColor,
      height = _ref.height,
      lineHeight = _ref.lineHeight,
      fontSize = _ref.fontSize,
      subLabelColor = _ref.subLabelColor,
      subLabel = _ref.subLabel,
      showInfoIcon = _ref.showInfoIcon,
      infoIconHandler = _ref.infoIconHandler,
      infoIconColor = _ref.infoIconColor,
      borderRadius = _ref.borderRadius;
  var device = useDevice();
  return /*#__PURE__*/_jsxs(FlexComp, {
    flexDirection: "row",
    alignItems: alignItems || "center",
    bgColor: bgColor || theme.blueText2,
    padding: padding || "8px",
    borderRadius: borderRadius || "4px",
    margin: margin || "12px 0px 0px 0px",
    width: width,
    justifyContent: justifyContent || "unset",
    handleClick: onPressHandler,
    height: height,
    children: [discountImg && /*#__PURE__*/_jsx(ImageTag, {
      height: "20px",
      width: "20px",
      margin: "0px 4px 0px 0px",
      src: discountImg
    }), /*#__PURE__*/_jsxs(LabelContainer, {
      children: [label && /*#__PURE__*/_jsx(DiscountLabel, {
        fontWeight: fontWeight,
        color: color,
        dangerouslySetInnerHTML: {
          __html: label
        },
        lineHeight: lineHeight,
        fontSize: fontSize,
        paddingTop: device === "sm" ? "2px" : "0px"
      }), subLabel && /*#__PURE__*/_jsx(DiscountSubLabel, {
        color: subLabelColor,
        dangerouslySetInnerHTML: {
          __html: subLabel
        }
      })]
    }), showInfoIcon && /*#__PURE__*/_jsx(AnchorTag, {
      onClick: infoIconHandler,
      margin: device === "sm" ? "0px" : "4px 0px 0px",
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: infoIconColor || (device === "sm" ? theme.whiteText : theme.blueText)
      })
    }), showIcon && !showInfoIcon && /*#__PURE__*/_jsx(ChevRight, {
      color: iconColor || theme.whiteText
    })]
  });
};

/* harmony default export */ var components_DiscountBanner_DiscountBanner = ((/* unused pure expression or super */ null && (DiscountBanner_DiscountBanner)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/H5Tag.tsx
var TextStyles_H5Tag = __webpack_require__(7145);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/TopShowcase.tsx


function TopShowcase_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TopShowcase_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TopShowcase_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TopShowcase_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























var TopShowcase_TopShowcase = function TopShowcase(_ref) {
  var isPageLoading = _ref.isPageLoading,
      isPageLoadingGif = _ref.isPageLoadingGif,
      isPageLoadingText = _ref.isPageLoadingText,
      sectionBgImgURI = _ref.sectionBgImgURI,
      otherProductsText = _ref.otherProductsText,
      iconTextTag = _ref.iconTextTag,
      deliveryPersuasion = _ref.deliveryPersuasion,
      landingTitle = _ref.landingTitle,
      marqueeData = _ref.marqueeData,
      otherShowcaseCardsData = _ref.otherShowcaseCardsData,
      pinnedShowcaseCardData = _ref.pinnedShowcaseCardData,
      _ref$isMarqueeOnBotto = _ref.isMarqueeOnBottom,
      isMarqueeOnBottom = _ref$isMarqueeOnBotto === void 0 ? false : _ref$isMarqueeOnBotto,
      mobileStickyHeadingData = _ref.mobileStickyHeadingData,
      mobileTitle = _ref.mobileTitle,
      locationFetchingData = _ref.locationFetchingData,
      discountBanner = _ref.discountBanner,
      isShowDiscountBanner = _ref.isShowDiscountBanner,
      discountOfferHandler = _ref.discountOfferHandler,
      discountInfoIconHandler = _ref.discountInfoIconHandler,
      discountBannerBgColor = _ref.discountBannerBgColor,
      showInfoIcon = _ref.showInfoIcon,
      version = _ref.version,
      viewOrderLabel = _ref.viewOrderLabel,
      loadCurrenyBtnHandler = _ref.loadCurrenyBtnHandler,
      docsPendingHandler = _ref.docsPendingHandler,
      recommendedBtnHandler = _ref.recommendedBtnHandler,
      startFromWhereLeftHandler = _ref.startFromWhereLeftHandler,
      onClickAnotherLocation = _ref.onClickAnotherLocation,
      viewDashBoardClickHandler = _ref.viewDashBoardClickHandler,
      viewOrdersClickHandler = _ref.viewOrdersClickHandler;
  var device = useDevice();
  var host = getHostName(); // For Location Fetching

  var _ref2 = locationFetchingData,
      locRenderingData = _ref2.data;
  var LandingCardComponent = LandingCardFeature;

  var locationFetchingRenderer = function locationFetchingRenderer() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [(mobileStickyHeadingData === null || mobileStickyHeadingData === void 0 ? void 0 : mobileStickyHeadingData.isLoggedIn) && /*#__PURE__*/_jsx(ListingPageHeader, TopShowcase_objectSpread({}, mobileStickyHeadingData)), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        flex: "1",
        alignItems: "center",
        width: "auto",
        height: "auto",
        children: [/*#__PURE__*/_jsxs(LocationLoadingCtr, {
          children: [/*#__PURE__*/_jsx(LocationLoading, {
            children: /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(AbsIconContainer, {
                children: (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) === "ERROR" || (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) === "SUCCESS" ? locRenderingData !== null && locRenderingData !== void 0 && locRenderingData.fetchedData.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
                  src: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.iconSrc
                }) : /*#__PURE__*/_jsx(LocationMarkerWithCheck, {}) : locRenderingData !== null && locRenderingData !== void 0 && locRenderingData.fetchingData.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
                  src: locRenderingData.fetchingData.iconSrc
                }) : /*#__PURE__*/_jsx(LocationFetchingIcon, {})
              }), (locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchingData.loadingGifSrc) && /*#__PURE__*/_jsx(FadeImg, {
                showAnim: (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING",
                children: /*#__PURE__*/_jsx(ImageTag, {
                  src: locRenderingData.fetchingData.loadingGifSrc
                })
              })]
            })
          }), (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING" && (locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.label) && /*#__PURE__*/_jsx(MoveUpAnimation, {
            children: /*#__PURE__*/_jsx(DeliveryPersuasion, {
              bgColor: "",
              fontSize: "md",
              padding: "0px",
              text: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.label,
              styleWithFlex: false,
              isTextCenter: true,
              ctaText: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.ctaText,
              editLocationHandler: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.ctaHandler,
              showIcon: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.showDeliveryIcon
            })
          }), !!(locRenderingData !== null && locRenderingData !== void 0 && locRenderingData.fetchingData.label) && /*#__PURE__*/_jsx(MoveUpAndScale, {
            showAnim: (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING",
            children: /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "md" // margin="16px 0px 0px"
              ,
              color: theme.greyText9,
              children: locRenderingData.fetchingData.label
            })
          })]
        }), (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING" && (locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.conditionsText) && /*#__PURE__*/_jsx(ConditionsText, {
          isFadeIn: true,
          children: /*#__PURE__*/_jsxs(ParaTag, {
            fontSize: "xs",
            color: theme.greyText,
            margin: "0 0 20px 0",
            children: [!!locRenderingData.conditionsText.greenText && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: theme.greenText,
              children: locRenderingData.conditionsText.greenText
            }), " ", !!locRenderingData.conditionsText.normalText && locRenderingData.conditionsText.normalText]
          })
        })]
      })]
    });
  };

  var mobileViewRenderer = function mobileViewRenderer() {
    var _pinnedShowcaseCardDa, _otherShowcaseCardsDa;

    return /*#__PURE__*/_jsx(Fragment, {
      children: locationFetchingData !== null && locationFetchingData !== void 0 && locationFetchingData.isLocationFetching ? locationFetchingRenderer() : /*#__PURE__*/_jsxs(_Fragment, {
        children: [mobileStickyHeadingData && /*#__PURE__*/_jsx(ListingPageHeader, TopShowcase_objectSpread({}, mobileStickyHeadingData)), /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          moveFromDistance: "50px",
          delay: "0s",
          moveDelay: "0s",
          children: /*#__PURE__*/_jsxs(FlexComp, {
            flexDirection: "column",
            padding: "16px",
            width: "auto",
            height: "auto",
            children: [mobileTitle && (version === VERSIONS.V3 ? /*#__PURE__*/_jsx(H4Tag, {
              id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.HEADING),
              children: mobileTitle
            }) : /*#__PURE__*/_jsx(CliptextStyle, {
              id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.HEADING),
              children: /*#__PURE__*/_jsx(H4Tag, {
                children: mobileTitle
              })
            })), !(locationFetchingData !== null && locationFetchingData !== void 0 && locationFetchingData.isLocationFetching) && deliveryPersuasion && /*#__PURE__*/_jsx(FadeInAnimation, {
              delay: "0s",
              children: /*#__PURE__*/_jsx(DeliveryPersuasion, TopShowcase_objectSpread({
                fontSize: "sm",
                padding: "0px",
                bgColor: "",
                margin: "16px 0px 12px 0px"
              }, deliveryPersuasion))
            })]
          })
        }), marqueeData && !isMarqueeOnBottom && /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          delay: "0.25s",
          moveDelay: "0s",
          moveFromDistance: "100px",
          children: /*#__PURE__*/_jsx(MarqueeBanner, {
            LIVETagImgURI: marqueeData.LIVETagImgURI,
            isLoading: marqueeData.isLoading,
            padding: marqueeData.isLoading ? "8px 0px" : undefined,
            loadingText: "Fetching LIVE Rates",
            margin: device === "lg" ? "0px 0px 16px" : "0px 16px 16px",
            marqueeData: marqueeData.data,
            version: version
          })
        }), isShowDiscountBanner && /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          delay: "0s",
          moveDelay: "0s",
          moveFromDistance: "100px",
          children: /*#__PURE__*/_jsx(DiscountBanner, {
            alignItems: "flex-start",
            bgColor: discountBannerBgColor || theme.darkGreen2,
            discountImg: discountBanner.imgSrc,
            label: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.label,
            subLabel: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.subLabel // onPressHandler={discountOfferHandler}
            // showIcon
            ,
            margin: "0px 16px 18px",
            color: theme.whiteText,
            fontWeight: "800",
            width: "calc(100% - 32px)",
            height: "fit-content",
            infoIconHandler: discountInfoIconHandler,
            showInfoIcon: showInfoIcon
          })
        }), /*#__PURE__*/_jsxs(MarkerContainer, {
          moveFromDistance: "150px",
          delay: "0.5s",
          moveDelay: "0s",
          children: [pinnedShowcaseCardData && (pinnedShowcaseCardData === null || pinnedShowcaseCardData === void 0 ? void 0 : (_pinnedShowcaseCardDa = pinnedShowcaseCardData.data) === null || _pinnedShowcaseCardDa === void 0 ? void 0 : _pinnedShowcaseCardDa.length) > 0 && /*#__PURE__*/_jsx(_Fragment, {
            children: pinnedShowcaseCardData && pinnedShowcaseCardData.data.map(function (item) {
              return /*#__PURE__*/_jsx(SpecialAttention, {
                withShadow: true,
                children: /*#__PURE__*/_jsx(FlexComp, {
                  padding: device === "lg" ? "24px" : "16px",
                  width: "auto",
                  height: "auto",
                  children: /*#__PURE__*/_jsx(LandingCardComponent, {
                    data: item,
                    onClick: pinnedShowcaseCardData.onClick,
                    loadCurrenyBtnHandler: loadCurrenyBtnHandler,
                    recommendedBtnHandler: recommendedBtnHandler,
                    startFromWhereLeftHandler: startFromWhereLeftHandler,
                    docsPendingHandler: docsPendingHandler,
                    onClickAnotherLocation: onClickAnotherLocation,
                    viewDashBoardClickHandler: viewDashBoardClickHandler,
                    viewOrdersClickHandler: viewOrdersClickHandler,
                    isInfoOnRightSide: false
                  })
                })
              }, item.id);
            })
          }), otherShowcaseCardsData && (otherShowcaseCardsData === null || otherShowcaseCardsData === void 0 ? void 0 : (_otherShowcaseCardsDa = otherShowcaseCardsData.data) === null || _otherShowcaseCardsDa === void 0 ? void 0 : _otherShowcaseCardsDa.length) > 0 && /*#__PURE__*/_jsxs(SpecialAttention, {
            withShadow: true,
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              flexDirection: "column",
              padding: device === "lg" ? "24px" : "16px",
              width: "auto",
              height: "auto",
              children: [otherProductsText && /*#__PURE__*/_jsx(ParaTag, {
                fontSize: "sm",
                fontWeight: "bold",
                margin: "0px 0px 16px",
                color: theme.greyText,
                children: otherProductsText
              }), otherShowcaseCardsData && otherShowcaseCardsData.data.map(function (item, idx) {
                return /*#__PURE__*/_jsx(LandingCardComponent, {
                  isInfoOnRightSide: false,
                  data: item,
                  border: idx + 1 < otherShowcaseCardsData.data.length ? "1px #e2e2e2 solid" : "",
                  padding: idx + 1 < otherShowcaseCardsData.data.length ? "0px 0px 16px 0px" : "0px",
                  margin: idx + 1 < otherShowcaseCardsData.data.length ? "0px 0px 16px 0px" : "0px",
                  borderWidth: idx + 1 < otherShowcaseCardsData.data.length ? "0px 0px 1px 0px" : "0px",
                  onClick: otherShowcaseCardsData.itemHandler,
                  loadCurrenyBtnHandler: loadCurrenyBtnHandler,
                  recommendedBtnHandler: recommendedBtnHandler,
                  startFromWhereLeftHandler: startFromWhereLeftHandler,
                  docsPendingHandler: docsPendingHandler,
                  onClickAnotherLocation: onClickAnotherLocation,
                  viewDashBoardClickHandler: viewDashBoardClickHandler,
                  viewOrdersClickHandler: viewOrdersClickHandler
                }, (item === null || item === void 0 ? void 0 : item.id) || idx);
              })]
            }), iconTextTag && /*#__PURE__*/_jsx(IconTextTag, {
              label: iconTextTag.label,
              subLabel: iconTextTag.subLabel,
              onClick: iconTextTag.btnHandler
            })]
          })]
        })]
      })
    });
  };

  var desktopViewHandler = function desktopViewHandler() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(BMFListingContainer, {
        children: /*#__PURE__*/_jsx(FlexComp, {
          padding: "24px 24px 48px 24px",
          minHeight: "200px",
          flexDirection: "column",
          justifyContent: "center",
          width: "auto",
          height: "auto",
          children: otherShowcaseCardsData !== null && otherShowcaseCardsData !== void 0 && otherShowcaseCardsData.isLoading ? /*#__PURE__*/_jsxs(FlexComp, {
            padding: "0px",
            alignItems: "center" // justifyContent="center"
            ,
            flexDirection: "column",
            width: "auto",
            height: "auto",
            children: [otherShowcaseCardsData.loadingImgSrc && /*#__PURE__*/_jsx(ImageTag, {
              width: "56px",
              src: otherShowcaseCardsData.loadingImgSrc
            }), !!otherShowcaseCardsData.loadingText && /*#__PURE__*/_jsx(ParaTag, {
              fontWeight: "bold",
              children: otherShowcaseCardsData.loadingText
            })]
          }) : /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              gap: version === VERSIONS.V3 ? "0px" : "6px",
              padding: "0px",
              alignItems: "center",
              justifyContent: version === VERSIONS.V3 ? "space-between" : "center",
              margin: "".concat(host === HOST.MAKEMYTRIP ? "40px" : "0px", " 0px 24px 0px"),
              width: "auto",
              height: "auto",
              children: [/*#__PURE__*/_jsxs(FlexComp, {
                gap: "6px",
                flexDirection: "row",
                alignItems: "unset",
                margin: "0px",
                padding: "unset",
                width: "unset",
                height: "unset",
                children: [(landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textOne) && /*#__PURE__*/_jsx(H5Tag, {
                  children: landingTitle.textOne
                }), (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textTwo) && (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textThree) && (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textFour) && /*#__PURE__*/_jsxs(ParaTag // margin="4px 0px 0px"
                , {
                  color: theme.greyText,
                  fontSize: "large",
                  children: [landingTitle.textTwo, " ", /*#__PURE__*/_jsx(SpanTag, {
                    color: theme.greenText,
                    fontSize: "large",
                    fontWeight: "bold",
                    children: landingTitle.textThree
                  }), " ", landingTitle.textFour, " "]
                })]
              }), viewOrderLabel && version === VERSIONS.V3 && /*#__PURE__*/_jsxs(FlexComp, {
                gap: "4px",
                flexDirection: "row",
                margin: "0px",
                padding: "unset",
                alignItems: "center",
                width: "unset",
                height: "unset",
                children: [/*#__PURE__*/_jsx(AnchorTag, {
                  fontSize: "sm",
                  fontWeight: "bold",
                  onClick: viewOrdersClickHandler.bind(null, {
                    label: "View Orders",
                    version: VERSIONS.V3
                  }),
                  children: viewOrderLabel
                }), /*#__PURE__*/_jsx(ArrowIcon, {})]
              })]
            }), isShowDiscountBanner && /*#__PURE__*/_jsx(DiscountBanner, {
              alignItems: "center",
              fontSize: "sm",
              bgColor: theme.greenText2,
              discountImg: discountBanner.imgSrc,
              label: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.label,
              subLabel: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.subLabel // onPressHandler={discountOfferHandler}
              // showIcon
              ,
              margin: "0px 0px 18px",
              color: theme.darkGreen,
              fontWeight: "800",
              iconColor: theme.blueText,
              width: "fit-content",
              infoIconHandler: discountInfoIconHandler,
              showInfoIcon: showInfoIcon
            }), otherShowcaseCardsData && /*#__PURE__*/_jsx(LandingCardFeatureCtr, {
              version: version,
              children: otherShowcaseCardsData.data.map(function (item, index) {
                return /*#__PURE__*/_jsx(LandingCardComponent, {
                  isInfoOnRightSide: otherShowcaseCardsData.showInfoOnRightSideInCards,
                  data: item,
                  idx: index,
                  padding: "16px",
                  border: "1px #e2e2e2 solid",
                  onClick: otherShowcaseCardsData.itemHandler,
                  loadCurrenyBtnHandler: loadCurrenyBtnHandler,
                  recommendedBtnHandler: recommendedBtnHandler,
                  startFromWhereLeftHandler: startFromWhereLeftHandler,
                  docsPendingHandler: docsPendingHandler,
                  onClickAnotherLocation: onClickAnotherLocation,
                  viewDashBoardClickHandler: viewDashBoardClickHandler,
                  viewOrdersClickHandler: viewOrdersClickHandler
                }, index);
              })
            }), iconTextTag && /*#__PURE__*/_jsx(IconTextTag, {
              margin: "8px 0px 0px",
              label: iconTextTag.label,
              subLabel: iconTextTag.subLabel,
              onClick: iconTextTag.btnHandler
            })]
          })
        })
      }), marqueeData && !isMarqueeOnBottom && /*#__PURE__*/_jsx(MarqueeBanner, {
        margin: "24px 0px 0px",
        isLoading: marqueeData.isLoading,
        padding: marqueeData.isLoading ? device === "lg" ? "11px 24px" : device === "sm" ? "8px 16px" : undefined : device === "lg" ? "4px 0px" : undefined,
        marqueeData: marqueeData.data,
        LIVETagImgURI: marqueeData.LIVETagImgURI,
        loadingText: marqueeData.loadingText,
        version: version
      })]
    });
  };

  return device ? /*#__PURE__*/_jsx(ListingTopContainer, {
    fullPageHeight: true,
    bgImage: sectionBgImgURI,
    isPageLoading: isPageLoading,
    isLocationFetching: locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.isLocationFetching,
    version: version,
    children: isPageLoading && device === "sm" && !(locationFetchingData !== null && locationFetchingData !== void 0 && locationFetchingData.isLocationFetching) ? /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      flexDirection: "column",
      width: "auto",
      height: "auto",
      children: [isPageLoadingGif && /*#__PURE__*/_jsx(GifContainer, {
        children: /*#__PURE__*/_jsx(ImageTag, {
          src: isPageLoadingGif,
          width: "48px"
        })
      }), isPageLoadingText && /*#__PURE__*/_jsx(ParaTag, {
        margin: "90px 0px 0px",
        fontSize: "md",
        color: theme.whiteText,
        children: isPageLoadingText
      })]
    }) : device === "lg" ? desktopViewHandler() : mobileViewRenderer()
  }) : /*#__PURE__*/_jsx(Fragment, {});
};

/* harmony default export */ var ListingPageComponents_TopShowcase = ((/* unused pure expression or super */ null && (TopShowcase_TopShowcase)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/defaultCardData.ts/index.ts
var defaultCardData_ts = __webpack_require__(5692);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/componentPropsMapper.ts



var componentPropsMapper_excluded = (/* unused pure expression or super */ null && (["eta_in_days"])),
    _excluded2 = (/* unused pure expression or super */ null && (["theme", "value"])),
    _excluded3 = (/* unused pure expression or super */ null && (["sub_label", "action", "title", "show_add_btn", "is_primary_button"])),
    _excluded4 = (/* unused pure expression or super */ null && (["sub_label", "action", "title", "show_add_btn", "is_primary_button"])),
    _excluded5 = (/* unused pure expression or super */ null && (["value", "order_id", "redirect_to"])),
    _excluded6 = (/* unused pure expression or super */ null && (["value"]));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function componentPropsMapper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function componentPropsMapper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? componentPropsMapper_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : componentPropsMapper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function componentPropsMapper_getTickerData(forex_rates) {
  var data = [];

  for (var _i = 0, _Object$entries = Object.entries(forex_rates || {}); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    data.push({
      id: key,
      text: "\u20B9".concat(value),
      boldText: key.toUpperCase()
    });
  }

  if (data.length > 0) {
    data.push({
      id: "100_currencies_text",
      blueText: "100+ Currencies"
    });
  }

  return data;
}
function getDeliverableText(eta_in_days, city, pincode, version) {
  var ctaText = version === VERSIONS.V3 ? "<span class='regular blackText'>in</span> ".concat(city !== null && city !== void 0 ? city : "", " ").concat(pincode !== null && pincode !== void 0 ? pincode : "") : "<span class='regular greyText9'>in</span> ".concat(city !== null && city !== void 0 ? city : "", " ").concat(pincode !== null && pincode !== void 0 ? pincode : "");
  var datePlaceHolder = "";

  var _getFutureDate = getFutureDate(Number(eta_in_days)),
      date = _getFutureDate.date,
      monthName = _getFutureDate.monthName,
      suffix = _getFutureDate.suffix,
      day = _getFutureDate.day;

  var formattedDate = "".concat(date, " ").concat(monthName);

  if (Number(eta_in_days) >= 0) {
    datePlaceHolder = Number(eta_in_days) === 0 ? "Today, 9 pm" : Number(eta_in_days) === 1 ? "Tomorrow, 9 pm" : "".concat(day, ", ").concat(formattedDate);
  } else {
    throw new Error("Delivery eta should be greater than or equal to 0");
  }

  var text = version === VERSIONS.V3 ? "<span class=\"blackText\">Delivery by </span> <span id='listingPage_delivery_deliveryEta' class='boldText greenText'>".concat(datePlaceHolder, "</span>") : "Delivery by <br/> <span id='listingPage_delivery_deliveryEta' class='boldText greenText'>".concat(datePlaceHolder, "</span>");
  return {
    checkPincode: false,
    checkPincodeLabel: "",
    ctaText: ctaText,
    text: text
  };
}
function componentPropsMapper_getDeliveryDetailsContent(deliveryDetails, isErrorDeliveryDetails, version) {
  var _ref = deliveryDetails || {},
      city = _ref.city,
      deliverable = _ref.deliverable,
      _ref$eta_in_days = _ref.eta_in_days,
      eta_in_days = _ref$eta_in_days === void 0 ? 0 : _ref$eta_in_days,
      pincode = _ref.pincode;

  var deliveryContent = {
    ctaText: "",
    text: "",
    checkPincode: false,
    checkPincodeLabel: ""
  };

  if (isErrorDeliveryDetails) {
    return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({}, deliveryContent), {}, {
      checkPincode: true,
      checkPincodeLabel: "Enter pincode to check Delivery Dates"
    });
  }

  if (deliverable) {
    deliveryContent = getDeliverableText(eta_in_days, city, pincode, version);
  } else if (!deliverable) {
    var message = "Enter pincode to check Delivery Dates";
    deliveryContent.checkPincode = true;
    deliveryContent.checkPincodeLabel = message;
    deliveryContent.ctaText = message;
    deliveryContent.text = "";
  }

  return deliveryContent;
}
var componentPropsMapper_getLocationFetchingScreenLabel = function getLocationFetchingScreenLabel(locFetchingMode, deliveryDetailsContent, persona, version, isErrorDeliveryDetails) {
  if (persona !== null && persona !== void 0 && persona.multi_cx_card_cust && version === VERSIONS.V3) {
    return "Welcome back";
  }

  if (isErrorDeliveryDetails) {
    return "Enter pincode to check Delivery Dates";
  } else {
    if (!deliveryDetailsContent) {
      return null;
    }

    return locFetchingMode === "SUCCESS" ? "".concat(deliveryDetailsContent !== null && deliveryDetailsContent !== void 0 && deliveryDetailsContent.text ? "".concat(deliveryDetailsContent === null || deliveryDetailsContent === void 0 ? void 0 : deliveryDetailsContent.text) : "", " <span class='boldText blueText'>").concat(deliveryDetailsContent === null || deliveryDetailsContent === void 0 ? void 0 : deliveryDetailsContent.ctaText, "</span>") : "Delivery by <span class='boldText greenText'>Tomorrow*</span> in <span class='boldText blueText'>100+ cities </span>";
  }
};
function componentPropsMapper_prepareNonPinnedForexCardsMobile(products, device, version) {
  var nonPinnedForexCards = [];

  var _iterator = _createForOfIteratorHelper(products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;

      for (var _i2 = 0, _Object$entries2 = Object.entries(product); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            productKey = _Object$entries2$_i[0],
            productValue = _Object$entries2$_i[1];

        var _ref2 = productValue || {},
            render_separately = _ref2.render_separately;

        if (!render_separately) {
          var card = componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({}, defaultForexCardsData[productKey]), productValue);

          if (version) {
            card.version = version;
          } // Not showing subLabel for mobile.


          card.subLabel = "";
          card = setForexCardPersuasions(card, productValue);
          card = setUnavailableCardContent(card, productValue);
          nonPinnedForexCards.push(card);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return nonPinnedForexCards;
}
function componentPropsMapper_prepareForexCardsForDesktop(products, device, version) {
  var forexCards = [];

  var _iterator2 = _createForOfIteratorHelper(products),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var product = _step2.value;

      for (var _i3 = 0, _Object$entries3 = Object.entries(product); _i3 < _Object$entries3.length; _i3++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
            productKey = _Object$entries3$_i[0],
            productValue = _Object$entries3$_i[1];

        var card = componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({}, defaultForexCardsData[productKey]), productValue);

        card = setForexCardPersuasions(card, productValue);
        card = setUnavailableCardContent(card, productValue);

        if (version) {
          card.version = version;
        }

        if (device === "lg") {
          card.isUnavailableAtLoc = null;
        }

        forexCards.push(card);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return forexCards;
}
function componentPropsMapper_prepareForexCardsV3(products, device, version, persona) {
  var pinnedCards = [];
  var otherCards = [];
  var pinned_mapping = {
    multi_cx_card: true,
    currency: true,
    inr_card: true
  };

  if (persona !== null && persona !== void 0 && persona.multi_cx_card_cust && !(persona !== null && persona !== void 0 && persona.currency_order_active)) {
    pinned_mapping["currency"] = false;
  } else if (persona !== null && persona !== void 0 && persona.multi_cx_card_cust && persona !== null && persona !== void 0 && persona.currency_order_active) {
    // In this case delivery date should hide
    pinned_mapping["multi_cx_card"] = false;
    pinned_mapping["currency"] = false;
  }

  if (device === "lg") {
    pinned_mapping["inr_card"] = false;
    pinned_mapping["multi_cx_card"] = false;
    pinned_mapping["currency"] = false;
  }

  var _iterator3 = _createForOfIteratorHelper(products),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var product = _step3.value;

      for (var _i4 = 0, _Object$entries4 = Object.entries(product); _i4 < _Object$entries4.length; _i4++) {
        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
            productKey = _Object$entries4$_i[0],
            productValue = _Object$entries4$_i[1];

        var card = componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({}, defaultForexCardsData[productKey]), productValue);

        if (version) {
          card.version = version;
        }

        if (!productValue.version) {
          productValue.version = version;
        }

        if (productValue.show_best_rate) {
          card.showBestRate = true;
        }

        card = setForexCardPersuasions(card, productValue);
        card = setUnavailableCardContent(card, productValue);

        if (device === "lg") {
          card.isUnavailableAtLoc = null;
        } else {
          // Not showing subLabel for mobile.
          card.subLabel = "";
        }

        if (pinned_mapping[productKey]) {
          pinnedCards.push(card);
        } else {
          otherCards.push(card);
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return [pinnedCards, otherCards];
}
function componentPropsMapper_preparePinnedForexCardsMobile(products, device, version) {
  var pinnedForexCards = [];

  var _iterator4 = _createForOfIteratorHelper(products),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var product = _step4.value;

      for (var _i5 = 0, _Object$entries5 = Object.entries(product); _i5 < _Object$entries5.length; _i5++) {
        var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
            productKey = _Object$entries5$_i[0],
            productValue = _Object$entries5$_i[1];

        var _ref3 = productValue || {},
            render_separately = _ref3.render_separately;

        if (render_separately) {
          var card = componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({}, defaultForexCardsData[productKey]), productValue);

          if (version) {
            card.version = version;
          } // Not showing subLabel for mobile.


          card.subLabel = "";
          card = setForexCardPersuasions(card, productValue);
          card = setUnavailableCardContent(card, productValue);
          pinnedForexCards.push(card);
        }
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return pinnedForexCards;
}

function setForexCardPersuasions(card, productValue) {
  var newCard = componentPropsMapper_objectSpread({}, card); // prepare persuasion related data.


  var persuations = componentPropsMapper_getPersuasionsProps(productValue);
  newCard.isRecommended = persuations[PERSUASION_TYPE.DELIVERY_TRACKING];
  newCard.loadCurrency = persuations[PERSUASION_TYPE.MINI_DASHBOARD];
  newCard.docsPending = persuations[PERSUASION_TYPE.UPLOAD_DOCUMENTS];
  newCard.isleftOffBefore = persuations[PERSUASION_TYPE.DROP_OFF];
  newCard.backendPersuasion = persuations[PERSUASION_TYPE.BACKEND];
  newCard.viewOrdersPersuasion = persuations[PERSUASION_TYPE.VIEW_ORDERS];
  newCard.startOrder = persuations[PERSUASION_TYPE.START_ORDER];
  return newCard;
}

var setUnavailableCardContent = function setUnavailableCardContent(card, productValue) {
  var _ref4 = productValue || {},
      delivery_details = _ref4.delivery_details;

  var _ref5 = delivery_details || {},
      deliverable = _ref5.deliverable,
      eta_in_days = _ref5.eta_in_days;

  var newCard = componentPropsMapper_objectSpread({}, card);

  var host = getHostName();

  if (!host && host === HOST.MAKEMYTRIP || deliverable === null || deliverable === undefined) {
    return newCard;
  }

  if (deliverable) {
    var deliveryLabel = "Delivery by ";

    var _getFutureDate2 = getFutureDate(Number(eta_in_days)),
        date = _getFutureDate2.date,
        monthName = _getFutureDate2.monthName,
        suffix = _getFutureDate2.suffix;

    deliveryLabel += "".concat(date, " ").concat(monthName);
    newCard.deliveryLabel = deliveryLabel;
  } else if (deliverable === false) {
    newCard.isUnavailableAtLoc = {
      normalText: "Unavailable at your location. You can try getting it delivered to",
      linkText: {
        text: "Another Location",
        hrefLink: ""
      }
    };
  }

  return newCard;
};

function componentPropsMapper_getPersuasionProp(type, data) {
  switch (type) {
    case PERSUASION_TYPE.DELIVERY_TRACKING:
      return getDeliveryTrackingPersuasionProps(data);

    case PERSUASION_TYPE.BACKEND:
      return getBackendPersuasionProps(data);

    case PERSUASION_TYPE.DROP_OFF:
      return getDropOffPersuasionProps(data);

    case PERSUASION_TYPE.MINI_DASHBOARD:
      return getMiniDashboardPersuasionProps(data);

    case PERSUASION_TYPE.UPLOAD_DOCUMENTS:
      return getUploadDocsPersuationProps(data);

    case PERSUASION_TYPE.VIEW_ORDERS:
      return getViewOrdersPersuationProps(data);

    case PERSUASION_TYPE.ACTIVATION_IN_PROGRESS:
      return getActivationInProgressPersuasionProps(data);

    case PERSUASION_TYPE.START_ORDER:
      return getStartOrderPersuasionProps(data);

    case PERSUASION_TYPE.UNDELIVERABLE:
      return getUndeliverablePersuasionProps(data);

    case PERSUASION_TYPE.UPCOMING_TRIPS:
      return getUpcomingTripsPersuasionProps(data);

    case PERSUASION_TYPE.CROSS_SELL:
      return getCrossSellPersuasionProps(data);

    case PERSUASION_TYPE.FREE_CARD:
      return getFreeCardPersuasionProps(data);

    case PERSUASION_TYPE.RELOAD_TRIP:
      return getReloadTripPersuasionProps(data);

    default:
      console.error("Invalid persuasion type [".concat(type, "]"));
      return data;
  }
}

function getReloadTripPersuasionProps(data) {
  var _reloadData$derived_n;

  var reloadData = data === null || data === void 0 ? void 0 : data.reload_discovery_order_details;
  var countries = reloadData === null || reloadData === void 0 ? void 0 : reloadData.countries;
  var countryLabel = "";

  if (!(countries !== null && countries !== void 0 && countries.length)) {
    countryLabel = "";
  } else if (countries.length === 1) {
    countryLabel = "".concat(countries[0]);
  } else {
    countryLabel = "".concat(countries[0], " +").concat(countries.length - 1);
  }

  var label = reloadData !== null && reloadData !== void 0 && reloadData.is_current_trip && reloadData !== null && reloadData !== void 0 && reloadData.is_instant_reload_possible ? "INSTANT LOAD" : "RECOMMENDED";
  var subLabel = reloadData !== null && reloadData !== void 0 && reloadData.is_current_trip ? "For your trip to ".concat(countryLabel) : "For your upcoming trip to ".concat(countryLabel);
  return {
    label: label,
    subLabel: subLabel,
    showInstantLoadIcon: !!(reloadData !== null && reloadData !== void 0 && reloadData.is_instant_reload_possible),
    nextSignalState: (_reloadData$derived_n = reloadData === null || reloadData === void 0 ? void 0 : reloadData.derived_next_signal_state) !== null && _reloadData$derived_n !== void 0 ? _reloadData$derived_n : null,
    btnProps: {
      customTitle: "LOAD NOW"
    }
  };
}

function componentPropsMapper_getPersuasionsProps(product) {
  var _persuationProps;

  var persuationProps = (_persuationProps = {}, _defineProperty(_persuationProps, PERSUASION_TYPE.DELIVERY_TRACKING, null), _defineProperty(_persuationProps, PERSUASION_TYPE.BACKEND, []), _defineProperty(_persuationProps, PERSUASION_TYPE.DROP_OFF, null), _defineProperty(_persuationProps, PERSUASION_TYPE.MINI_DASHBOARD, null), _defineProperty(_persuationProps, PERSUASION_TYPE.UPLOAD_DOCUMENTS, null), _defineProperty(_persuationProps, PERSUASION_TYPE.VIEW_ORDERS, null), _defineProperty(_persuationProps, PERSUASION_TYPE.ACTIVATION_IN_PROGRESS, null), _defineProperty(_persuationProps, PERSUASION_TYPE.START_ORDER, null), _defineProperty(_persuationProps, PERSUASION_TYPE.UNDELIVERABLE, null), _defineProperty(_persuationProps, PERSUASION_TYPE.UPCOMING_TRIPS, null), _defineProperty(_persuationProps, PERSUASION_TYPE.CROSS_SELL, null), _defineProperty(_persuationProps, PERSUASION_TYPE.FREE_CARD, null), _persuationProps);
  var _product$persuasions = product.persuasions,
      persuasions = _product$persuasions === void 0 ? [] : _product$persuasions,
      version = product.version;

  var _iterator5 = _createForOfIteratorHelper(persuasions),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var persuasionObj = _step5.value;

      var _ref6 = persuasionObj || {},
          type = _ref6.type,
          data = _ref6.data,
          cta = _ref6.cta;

      switch (type) {
        case PERSUASION_TYPE.DELIVERY_TRACKING:
          persuationProps[PERSUASION_TYPE.DELIVERY_TRACKING] = getDeliveryTrackingPersuasionProps(data, cta);
          break;

        case PERSUASION_TYPE.BACKEND:
          persuationProps[PERSUASION_TYPE.BACKEND].push(getBackendPersuasionProps(data, cta));
          break;

        case PERSUASION_TYPE.DROP_OFF:
          persuationProps[PERSUASION_TYPE.DROP_OFF] = getDropOffPersuasionProps(data, cta);
          break;

        case PERSUASION_TYPE.MINI_DASHBOARD:
          persuationProps[PERSUASION_TYPE.MINI_DASHBOARD] = version === VERSIONS.V3 ? getMiniDashboardPersuasionPropsV2(data, cta) : getMiniDashboardPersuasionProps(data, cta);
          break;

        case PERSUASION_TYPE.UPLOAD_DOCUMENTS:
          persuationProps[PERSUASION_TYPE.UPLOAD_DOCUMENTS] = getUploadDocsPersuationProps(data, cta);
          break;

        case PERSUASION_TYPE.VIEW_ORDERS:
          persuationProps[PERSUASION_TYPE.VIEW_ORDERS] = getViewOrdersPersuationProps(data, cta);
          break;

        case PERSUASION_TYPE.ACTIVATION_IN_PROGRESS:
          persuationProps[PERSUASION_TYPE.ACTIVATION_IN_PROGRESS] = getActivationInProgressPersuasionProps(data, cta);
          break;

        case PERSUASION_TYPE.START_ORDER:
          persuationProps[PERSUASION_TYPE.START_ORDER] = getStartOrderPersuasionProps(data, cta);
          break;

        case PERSUASION_TYPE.UNDELIVERABLE:
          persuationProps[PERSUASION_TYPE.UNDELIVERABLE] = getUndeliverablePersuasionProps(data, cta);
          break;

        case PERSUASION_TYPE.UPCOMING_TRIPS:
          persuationProps[PERSUASION_TYPE.UPCOMING_TRIPS] = getUpcomingTripsPersuasionProps(data, cta);
          break;

        case PERSUASION_TYPE.CROSS_SELL:
          persuationProps[PERSUASION_TYPE.CROSS_SELL] = getCrossSellPersuasionProps(data);
          break;

        case PERSUASION_TYPE.FREE_CARD:
          persuationProps[PERSUASION_TYPE.FREE_CARD] = getFreeCardPersuasionProps(data);
          break;

        default:
          console.error("Invalid persuasion type [".concat(type, "]"));
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return persuationProps;
}

function getUpcomingTripsPersuasionProps(data, cta) {
  return {
    label: "<span><span style=\"color:#2B825E; font-weight:bold\">Recommended</span> <span style=\"font-weight:bold\">For your upcoming trip</span><br/> Preferred by the users travelling to ".concat(data.destination, " <span>"),
    type: PERSUASION_TYPE.UPCOMING_TRIPS
  };
}

function getActivationInProgressPersuasionProps(data, cta) {
  return {
    label: "Card Delivered. <b style=\"color: #2B825E\">Activation Under Progress </b>",
    type: PERSUASION_TYPE.ACTIVATION_IN_PROGRESS
  };
}

function getUndeliverablePersuasionProps(data, cta) {
  return {
    normalText: "Delivery unavailable at your location. You can try",
    linkText: {
      text: "Another location"
    }
  };
}

function getStartOrderPersuasionProps(data, cta) {
  return {
    isPrimaryButton: (data === null || data === void 0 ? void 0 : data.is_primary_button) !== undefined ? data.is_primary_button : true,
    linkBtnInMobile: {
      label: ((data === null || data === void 0 ? void 0 : data.label) || "Start Order").toUpperCase()
    },
    cta: cta
  };
}

function getCrossSellPersuasionProps(data) {
  var _ref7 = (data === null || data === void 0 ? void 0 : data.cross_sell_data) || {},
      cross_sell_product = _ref7.cross_sell_product,
      pii = _ref7.pii,
      address = _ref7.address,
      upcoming_trip = _ref7.upcoming_trip,
      cards = _ref7.cards,
      delivery_details = _ref7.delivery_details;

  var _ref8 = pii !== null && pii !== void 0 ? pii : {},
      name = _ref8.name,
      email = _ref8.email,
      phone = _ref8.phone,
      user_id = _ref8.user_id;

  var _ref9 = address !== null && address !== void 0 ? address : {},
      line1 = _ref9.line1,
      line2 = _ref9.line2,
      city = _ref9.city,
      state = _ref9.state,
      country = _ref9.country,
      pincode = _ref9.pincode,
      city_code = _ref9.city_code,
      state_code = _ref9.state_code;

  var _ref10 = upcoming_trip !== null && upcoming_trip !== void 0 ? upcoming_trip : {},
      intl_travel = _ref10.intl_travel,
      start_date = _ref10.start_date,
      end_date = _ref10.end_date,
      no_of_travellers = _ref10.no_of_travellers,
      trip_details = _ref10.trip_details;

  var _ref11 = delivery_details !== null && delivery_details !== void 0 ? delivery_details : {},
      deliverable = _ref11.deliverable,
      eta_in_days = _ref11.eta_in_days,
      delivery_city = _ref11.city,
      delivery_pincode = _ref11.pincode;

  var payload = {
    crossSellProduct: cross_sell_product,
    crossSellPii: {
      name: name,
      email: email,
      phone: phone,
      userId: user_id
    },
    crossSellAddress: {
      addressLine1: line1,
      addressLine2: line2,
      city: city,
      state: state,
      country: country,
      pincode: pincode,
      cityCode: city_code,
      stateCode: state_code
    },
    crossSellUpcomingTrips: {
      intlTravel: intl_travel,
      startDate: start_date,
      endDate: end_date,
      noOfTravellers: no_of_travellers,
      tripDetails: trip_details === null || trip_details === void 0 ? void 0 : trip_details.map(function (trip) {
        return {
          countryName: trip.country_name,
          currencyCode: trip.currency_code,
          rate: trip.rate
        };
      })
    },
    crossSellCards: cards === null || cards === void 0 ? void 0 : cards.map(function (card) {
      return {
        acqCurr: card.acq_curr,
        acqQuantity: card.acq_quantity,
        isActive: card.is_active,
        rate: card.rate
      };
    }),
    crossSellDeliveryDetails: {
      deliverable: deliverable,
      eta_in_days: eta_in_days,
      city: delivery_city,
      pincode: delivery_pincode
    }
  };
  return payload;
}

function getFreeCardPersuasionProps(data) {
  var _ref12 = data || {},
      cashback = _ref12.cashback,
      offer_text = _ref12.offer_text;

  return {
    cashback: cashback,
    text: offer_text
  };
}

var getDeliveryEta = function getDeliveryEta(etaInDays, deliveryEtaStr) {
  var deliveryText = "";

  if (etaInDays === 0) {
    deliveryText = "Today, 9 pm";
  } else if (etaInDays === 1) {
    deliveryText = "Tomorrow, 9 pm";
  } else {
    deliveryText = deliveryEtaStr;
  }

  return deliveryText;
};

function getDeliveryTrackingPersuasionProps(data, cta) {
  var _ref13 = data || {},
      eta_in_days = _ref13.eta_in_days,
      rest = _objectWithoutProperties(_ref13, componentPropsMapper_excluded);

  var cardDeliveryMessage = "";
  var label = "";

  if (eta_in_days === 0 || eta_in_days) {
    var _getFutureDate3 = getFutureDate(Number(eta_in_days)),
        date = _getFutureDate3.date,
        monthName = _getFutureDate3.monthName,
        suffix = _getFutureDate3.suffix,
        day = _getFutureDate3.day;

    cardDeliveryMessage = "Expected delivery by ".concat(date, " ").concat(monthName);
    var deliveryEtaStr = "".concat(day, ", ").concat(date, " ").concat(monthName);
    deliveryEtaStr = getDeliveryEta(eta_in_days, deliveryEtaStr);
    label = "Expected delivery by <b style=\"color: #2B825E\"> ".concat(deliveryEtaStr, " </b>");
  }

  return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({
    text: {
      blackBoldText: "Your card is",
      greenBoldText: "On the Way!",
      normalText: cardDeliveryMessage
    },
    linkBtn: {
      label: "Track"
    },
    label: label,
    type: PERSUASION_TYPE.DELIVERY_TRACKING
  }, rest), {}, {
    cta: cta
  });
}

function getBackendPersuasionProps(data, cta) {
  var _ref14 = data || {},
      theme = _ref14.theme,
      value = _ref14.value,
      rest = _objectWithoutProperties(_ref14, _excluded2);

  return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({
    theme: theme,
    value: value
  }, rest), {}, {
    cta: cta
  });
}

function getDropOffPersuasionProps(data, cta) {
  return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({
    text: {
      blackBoldText: "Almost there! Order now and save big on forex markup"
    },
    linkBtn: {
      label: "Complete Order"
    }
  }, data), {}, {
    cta: cta
  });
}

function getMiniDashboardPersuasionPropsV2(data, cta) {
  var _ref15 = data || {},
      sub_label = _ref15.sub_label,
      action = _ref15.action,
      title = _ref15.title,
      _ref15$show_add_btn = _ref15.show_add_btn,
      show_add_btn = _ref15$show_add_btn === void 0 ? false : _ref15$show_add_btn,
      _ref15$is_primary_but = _ref15.is_primary_button,
      is_primary_button = _ref15$is_primary_but === void 0 ? true : _ref15$is_primary_but,
      rest = _objectWithoutProperties(_ref15, _excluded3);

  return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({
    label: title,
    subLabel: sub_label,
    linkBtnInMobile: {
      label: "VIEW DASHBOARD"
    },
    toAdd: true,
    addText: show_add_btn ? "LOAD CURRENCY" : null,
    isPrimaryButton: is_primary_button
  }, rest), {}, {
    cta: cta
  });
}

function getMiniDashboardPersuasionProps(data, cta) {
  var _ref16 = data || {},
      sub_label = _ref16.sub_label,
      action = _ref16.action,
      title = _ref16.title,
      _ref16$show_add_btn = _ref16.show_add_btn,
      show_add_btn = _ref16$show_add_btn === void 0 ? false : _ref16$show_add_btn,
      _ref16$is_primary_but = _ref16.is_primary_button,
      is_primary_button = _ref16$is_primary_but === void 0 ? true : _ref16$is_primary_but,
      rest = _objectWithoutProperties(_ref16, _excluded4);

  return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({
    label: title,
    subLabel: sub_label,
    linkBtnInMobile: {
      label: "VIEW DASHBOARD"
    },
    toAdd: true,
    addText: show_add_btn ? "+ Add" : null,
    isPrimaryButton: is_primary_button
  }, rest), {}, {
    cta: cta
  });
}

function getUploadDocsPersuationProps(data, cta) {
  var _ref17 = data || {},
      _ref17$value = _ref17.value,
      value = _ref17$value === void 0 ? "" : _ref17$value,
      _ref17$order_id = _ref17.order_id,
      order_id = _ref17$order_id === void 0 ? "" : _ref17$order_id,
      _ref17$redirect_to = _ref17.redirect_to,
      redirect_to = _ref17$redirect_to === void 0 ? "" : _ref17$redirect_to,
      rest = _objectWithoutProperties(_ref17, _excluded5);

  return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({
    label: value,
    //'Upload documents to add currency in forex card',
    iconSrc: undefined,
    btnProps: {
      customTitle: "Upload Now"
    },
    order_id: order_id,
    redirect_to: redirect_to
  }, rest), {}, {
    cta: cta
  });
}

function getViewOrdersPersuationProps(data, cta) {
  var _ref18 = data || {},
      _ref18$value = _ref18.value,
      value = _ref18$value === void 0 ? "" : _ref18$value,
      rest = _objectWithoutProperties(_ref18, _excluded6);

  return componentPropsMapper_objectSpread(componentPropsMapper_objectSpread({
    label: value,
    iconSrc: undefined,
    linkBtnInMobile: {
      label: "VIEW ORDERS"
    },
    btnProps: {
      customTitle: "View Orders"
    }
  }, rest), {}, {
    cta: cta
  });
}

function componentPropsMapper_getMobileTitle(persona, device) {
  if (persona && device === "sm") {
    var _ref19 = persona || {},
        upcoming_trip = _ref19.upcoming_trip,
        user_name = _ref19.user_name,
        user_type = _ref19.user_type;

    if (user_type === USER_TYPE.EXISTING_CUSTOMER && user_name) {
      return "Hey ".concat(user_name !== null && user_name !== void 0 ? user_name : "");
    }

    var _ref20 = upcoming_trip || {},
        country = _ref20.country;

    if (upcoming_trip && country) {
      return "Get Forex Card & Currency For Your Upcoming Trip";
    }
  }

  return "Get Forex Card & Currency At Your Doorstep";
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/BackendPersuasion.tsx




function BackendPersuasion(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCardFeature_PersuasionTile, {
    flexId: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(props.cardData.label), constants/* ElementNameMapping.PERSUASION_TILE.concat */.vT.PERSUASION_TILE.concat(props.index)),
    margin: "24px 0px 0px",
    text: {
      normalText: props.persuasionProps.value
    },
    isHtml: true,
    bgColor: props.persuasionProps.theme
  }, props.index);
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/DeliveryStatusPersuasion.tsx






function DeliveryStatusPersuasion(_ref) {
  var persuasionProps = _ref.persuasionProps,
      cardData = _ref.cardData,
      type = _ref.type;
  var device = (0,hooks_useDevice/* useDevice */.F)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryLabelContainer, {
    id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(persuasionProps.type), constants/* ElementNameMapping.DELIVERY_ETA */.vT.DELIVERY_ETA),
    style: type === "upcoming_trips" ? {
      background: "#E6FFF9",
      padding: "8px 12px 8px 8px",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center"
    } : {},
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
      dangerousText: persuasionProps.label,
      fontSize: device === "lg" ? "sm" : "xs",
      color: "#000",
      margin: device === "lg" ? "0" : type === "upcoming_trips" ? "0px" : "12px 0px 0px"
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/DropOffPersuasion.tsx


function DropOffPersuasion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DropOffPersuasion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DropOffPersuasion_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DropOffPersuasion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function DropOffPersuasion(props) {
  var _props$persuasionProp;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      props.handlers.startFromWhereLeftHandler(props.cardData);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCardFeature_PersuasionTile, {
      id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(props.cardData.label), constants/* ElementNameMapping.COMPLETE_ORDER */.vT.COMPLETE_ORDER),
      margin: "24px 0px 0px",
      text: props.persuasionProps.text,
      bgColor: "#EAF5FF",
      linkBtn: DropOffPersuasion_objectSpread(DropOffPersuasion_objectSpread({}, (_props$persuasionProp = props.persuasionProps) === null || _props$persuasionProp === void 0 ? void 0 : _props$persuasionProp.linkBtn), {}, {
        onClick: props.handlers.startFromWhereLeftHandler ? function (e) {
          props.handlers.startFromWhereLeftHandler(props.cardData);
          e.stopPropagation();
        } : function () {
          console.log("link button");
        }
      }),
      leftIcon: props.persuasionProps.iconSrc ? /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag/* default */.Z, {
        src: props.persuasionProps.iconSrc
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(RoundEcllipseIcon_RoundEcllipseIcon, {
        width: "50px",
        height: "50px",
        color: "#125BD3"
      })
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/MiniDashboardPersuasion.tsx


function MiniDashboardPersuasion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MiniDashboardPersuasion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MiniDashboardPersuasion_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MiniDashboardPersuasion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function MiniDashboardPersuasion(props) {
  var _props$persuasionProp, _props$persuasionProp2;

  return props.persuasionProps.btnOptions ? /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton/* default */.Z, MiniDashboardPersuasion_objectSpread(MiniDashboardPersuasion_objectSpread({}, props.persuasionProps.btnOptions), {}, {
    onClick: props.handlers.loadCurrenyBtnHandler ? function () {
      return props.handlers.loadCurrenyBtnHandler(props.cardData);
    } : function () {
      console.log("landing button: load currency");
    },
    fontSize: "12px",
    margin: "25px 0px 0px",
    customHeight: "32px",
    customWidth: "100%"
  })) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag/* default */.Z, {
    width: "fit-content",
    fontSize: "xs",
    fontWeight: "extraBold" // margin="12px 0px 0px"
    ,
    handleClick: props.handlers.loadCurrenyBtnHandler ? function () {
      return props.handlers.loadCurrenyBtnHandler(props.cardData);
    } : function () {
      console.log("load currency");
    },
    children: (_props$persuasionProp = props.persuasionProps) === null || _props$persuasionProp === void 0 ? void 0 : (_props$persuasionProp2 = _props$persuasionProp.btnOptions) === null || _props$persuasionProp2 === void 0 ? void 0 : _props$persuasionProp2.customTitle
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/UnavailableLocationPersuasion.tsx










function UnavailableLocationPersuasion(props) {
  var _props$persuasionProp;

  var device = (0,hooks_useDevice/* useDevice */.F)();
  if (device === "lg") return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCardFeature_style_NotLocationText, {
    version: constants/* VERSIONS.V3 */.Kr.V3,
    children: props.persuasionProps.normalText && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      onClick: props.handlers.deliveryUnavailbleClickHandler,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag/* default */.Z, {
        fontSize: "xs",
        color: Global/* theme.brownText */.rS.brownText,
        children: [props.persuasionProps.normalText, " ", props.persuasionProps.linkText && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag/* default */.Z, {
          id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(props.cardData.label), constants/* ElementNameMapping.ANOTHER_LOC_BTN */.vT.ANOTHER_LOC_BTN),
          width: "fit-content",
          fontSize: "xs",
          fontWeight: "bold",
          onClick: function onClick() {
            return props.handlers.onClickAnotherLocation(props.cardData);
          },
          children: (_props$persuasionProp = props.persuasionProps.linkText) === null || _props$persuasionProp === void 0 ? void 0 : _props$persuasionProp.text
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/UploadDocsPersuasion.tsx


function UploadDocsPersuasion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UploadDocsPersuasion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UploadDocsPersuasion_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UploadDocsPersuasion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










function UploadDocsPersuasion(props) {
  var device = (0,hooks_useDevice/* useDevice */.F)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      props.handlers.docsPendingHandler(props.cardData);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
      padding: device === "lg" ? "8px 12px" : "16px",
      borderRadius: "8px",
      margin: device === "lg" ? "24px 0px 0px" : "24px -16px -16px",
      justifyContent: "space-between",
      flexDirection: "row",
      bgColor: "linear-gradient(147deg, #FFF6D8 4.79%, #FFFAF3 43.98%, #F3F0E6 120.5%)",
      alignItems: "center",
      children: [(props.persuasionProps.label || props.persuasionProps.iconSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)(FlexComp_FlexComp/* default */.Z, {
        padding: "0px",
        alignItems: "center",
        justifyContent: "space-between",
        margin: device === "sm" ? "0px 0px 0" : "0px",
        bgColor: "transparent",
        children: props.persuasionProps.label && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
          fontWeight: "bold",
          color: Global/* theme.blackText */.rS.blackText,
          margin: "0px 20px 0px 0px",
          children: props.persuasionProps.label
        })
      }), props.persuasionProps.btnProps && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton/* default */.Z, UploadDocsPersuasion_objectSpread(UploadDocsPersuasion_objectSpread({
        id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(props.cardData.label), constants/* ElementNameMapping.UPLOAD_NOW */.vT.UPLOAD_NOW)
      }, props.persuasionProps.btnProps), {}, {
        flexShrink: "0",
        fontSize: "12px",
        customHeight: "32px",
        padding: "12px 16px"
      }))]
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/ViewOrdersPersuasion.tsx


function ViewOrdersPersuasion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ViewOrdersPersuasion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ViewOrdersPersuasion_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ViewOrdersPersuasion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













function ViewOrdersPersuasion(props) {
  var device = (0,hooks_useDevice/* useDevice */.F)();

  if (props.cardData.version !== constants/* VERSIONS.V1 */.Kr.V1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
    padding: "12px",
    borderRadius: "8px",
    margin: "24px 0px 0px",
    justifyContent: "space-between",
    flexDirection: device === "sm" ? "column" : "row",
    bgColor: "linear-gradient(159.48deg, #FFF9ED 4.69%, rgba(255, 239, 236, 0.736176) 27.76%, #F8F9E7 92.13%)",
    children: [(props.persuasionProps.label || props.persuasionProps.iconSrc) && /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
      padding: "0px",
      alignItems: "center",
      justifyContent: "space-between",
      margin: device === "sm" ? "0px 0px 16px" : "0px",
      children: [props.persuasionProps.label && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
        fontWeight: "bold",
        color: Global/* theme.brownText */.rS.brownText,
        margin: "0px 20px 0px 0px",
        children: props.persuasionProps.label
      }), device === "sm" && (props.persuasionProps.iconSrc ? /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag/* default */.Z, {
        src: props.persuasionProps.iconSrc
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DocsUploadIcon_DocsUploadIcon, {}))]
    }), props.persuasionProps.btnProps && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton/* default */.Z, ViewOrdersPersuasion_objectSpread(ViewOrdersPersuasion_objectSpread({
      id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(props.cardData.label), constants/* ElementNameMapping.UPLOAD_NOW */.vT.UPLOAD_NOW)
    }, props.persuasionProps.btnProps), {}, {
      onClick: props.handlers.docsPendingHandler ? function () {
        return props.handlers.docsPendingHandler(props.cardData);
      } : function () {
        console.log("view orders");
      },
      flexShrink: "0",
      customWidth: device === "sm" ? "100%" : undefined
    }))]
  });
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(2151);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/crossSellUtils.ts



// Function to get cross sell component data
function getCrossSellComponentData(_ref) {
  var _crossSellUpcomingTri;

  var crossSellProduct = _ref.crossSellProduct,
      crossSellAddress = _ref.crossSellAddress,
      crossSellCards = _ref.crossSellCards,
      crossSellDeliveryDetails = _ref.crossSellDeliveryDetails,
      crossSellPii = _ref.crossSellPii,
      crossSellUpcomingTrips = _ref.crossSellUpcomingTrips;

  var _getFutureDate = (0,static_utils/* getFutureDate */.O8)(Number(crossSellDeliveryDetails === null || crossSellDeliveryDetails === void 0 ? void 0 : crossSellDeliveryDetails.eta_in_days)),
      date = _getFutureDate.date,
      monthName = _getFutureDate.monthName,
      suffix = _getFutureDate.suffix,
      day = _getFutureDate.day;

  var deliveryLabel = "";
  deliveryLabel += " ".concat(day, ", ").concat(date).concat(suffix, " ").concat(monthName);
  var deliveryDate = deliveryLabel;
  var tripDetailsDate = crossSellUpcomingTrips !== null && crossSellUpcomingTrips !== void 0 && crossSellUpcomingTrips.startDate ? (0,utils.formatDate)(crossSellUpcomingTrips === null || crossSellUpcomingTrips === void 0 ? void 0 : crossSellUpcomingTrips.startDate, constants/* DATE_FORMATS.dd MMM, yyyy */.lv["dd MMM, yyyy"]) : "";
  var tripDetail = [{
    id: "1",
    label: "Destination",
    info: (crossSellUpcomingTrips === null || crossSellUpcomingTrips === void 0 ? void 0 : (_crossSellUpcomingTri = crossSellUpcomingTrips.tripDetails) === null || _crossSellUpcomingTri === void 0 ? void 0 : _crossSellUpcomingTri.map(function (e) {
      return e === null || e === void 0 ? void 0 : e.countryName;
    }).join(",")) || ""
  }, {
    id: "2",
    label: "Travel Start Date",
    info: tripDetailsDate
  }, {
    id: "3",
    label: "Currency to Load",
    info: (crossSellCards === null || crossSellCards === void 0 ? void 0 : crossSellCards.map(function (e) {
      return e === null || e === void 0 ? void 0 : e.acqCurr;
    }).join(",")) || ""
  }];
  var btnTitle = "BUY ".concat(crossSellProduct === constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD ? "CARD" : "CURRENCY");
  var isCardCrossSell = crossSellProduct === constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD;
  var heading = "".concat(crossSellProduct === constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD ? "Forex Card" : "Foreign Currency Notes", ", Just One Step Away!");
  var additionalInfo = crossSellProduct === constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD ? "BookMyForex Card is the trusted choice of more than <b>1 Lakh Travellers</b>" : "90% Forex card users also <b>buy foreign currency notes</b> for their trip";
  return {
    deliveryDate: deliveryDate,
    tripDetail: tripDetail,
    btnTitle: btnTitle,
    isCardCrossSell: isCardCrossSell,
    heading: heading,
    additionalInfo: additionalInfo
  };
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useRedirectionUrls/index.ts + 3 modules
var hooks_useRedirectionUrls = __webpack_require__(4155);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/CrossSellPersuasion.tsx


function CrossSellPersuasion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CrossSellPersuasion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CrossSellPersuasion_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CrossSellPersuasion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var BuyCurrencyBS = /*#__PURE__*/(0,react.lazy)(function () {
  return __webpack_require__.e(/* import() | BuyCurrencyBS */ 9135).then(__webpack_require__.bind(__webpack_require__, 2896));
});

var CrossSellPersuasion = function CrossSellPersuasion(props) {
  var _useGlobalConfig = (0,hooks_useGlobalConfig/* useGlobalConfig */.W)(),
      partner = _useGlobalConfig.partner;

  var device = (0,hooks_useDevice/* useDevice */.F)();

  var _useRedirectionUrls = (0,hooks_useRedirectionUrls/* default */.Z)(),
      crossSellRedirect = _useRedirectionUrls.crossSellRedirect;

  var _useState = (0,react.useState)(false),
      isBuyCurrencyModalOpen = _useState[0],
      setBuyCurrencyModalOpen = _useState[1];

  var _props$persuasionProp = props.persuasionProps,
      crossSellProduct = _props$persuasionProp.crossSellProduct,
      crossSellAddress = _props$persuasionProp.crossSellAddress,
      crossSellCards = _props$persuasionProp.crossSellCards,
      crossSellDeliveryDetails = _props$persuasionProp.crossSellDeliveryDetails,
      crossSellPii = _props$persuasionProp.crossSellPii,
      crossSellUpcomingTrips = _props$persuasionProp.crossSellUpcomingTrips; // showing cross sell nudge

  (0,react.useEffect)(function () {
    var isCrossSellNudgeShown = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.CROSS_SELL_NUDGE_SHOWN */.E9.CROSS_SELL_NUDGE_SHOWN);

    if (!isCrossSellNudgeShown) {
      setTimeout(function () {
        setBuyCurrencyModalOpen(true);
        (0,utils.persistSpecificParamInCookie)(constants/* COOKIES.CROSS_SELL_NUDGE_SHOWN */.E9.CROSS_SELL_NUDGE_SHOWN, "true", {
          path: "/",
          domain: partner === constants/* MakeMyTrip */.yO ? constants/* MMT_SUB_DOMAIN */.FJ : constants/* GI_SUB_DOMAIN */.Q7
        });
      }, 1000);
    }
  }, []);
  (0,react.useEffect)(function () {
    if (crossSellProduct) {
      props.handlers.sendCrossSellPdtEvent({
        eventName: constants/* PDT_EVENTS.CROSS_SELL_NUDGE_SHOWN */.sJ.CROSS_SELL_NUDGE_SHOWN,
        eventValue: crossSellProduct || ""
      });
    }
  }, [crossSellProduct]);

  var getFacilities = function getFacilities() {
    if (crossSellProduct === constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD) {
      return [{
        id: "1",
        label: "<b>ZERO</b> Forex Markup"
      }, {
        id: "2",
        label: "<b>Best Exchange Rates</b>"
      }];
    } else {
      return [{
        id: "1",
        label: "<b><BEST/b> Exchange Rates"
      }, {
        id: "2",
        label: "<b>RBI</b> Authorised"
      }];
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
      padding: device === "lg" ? "8px 12px" : "16px",
      borderRadius: "8px",
      margin: device === "lg" ? "24px 0px 0px" : "24px -16px -16px",
      justifyContent: "space-between",
      flexDirection: "row",
      bgColor: "linear-gradient(147deg, #FFF6D8 4.79%, #FFFAF3 43.98%, #F3F0E6 120.5%)",
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
        padding: "0px" // alignItems="center"
        // justifyContent="space-between"
        ,
        margin: device === "sm" ? "0px 0px 0" : "0px",
        bgColor: "transparent",
        flexDirection: "column",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "xs",
          dangerousText: crossSellProduct === constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD ? "For your upcoming trip, get forex card with <span class=\"boldText blackText\">".concat(crossSellCards === null || crossSellCards === void 0 ? void 0 : crossSellCards.map(function (e) {
            return e.acqCurr;
          }).join(", "), "</span> in just one step") : "For your upcoming trip, buy <span class=\"boldText blackText\">".concat(crossSellCards === null || crossSellCards === void 0 ? void 0 : crossSellCards.map(function (e) {
            return e.acqCurr;
          }).join(", "), "</span> in just one step"),
          margin: "0px 20px 0px 0px"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag/* default */.Z, {
          fontSize: "xs",
          color: "#2B825E",
          fontWeight: "bold",
          children: ["No additional documents", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag/* default */.Z, {
            color: "#EB2026",
            children: "*"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton/* default */.Z, {
        id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(props.cardData.label), constants/* ElementNameMapping.UPLOAD_NOW */.vT.UPLOAD_NOW) // {...props.persuasionProps.btnProps}
        ,
        customTitle: props.persuasionProps.crossSellProduct === constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD ? "BUY CARD" : "BUY CURRENCY",
        flexShrink: "0",
        fontSize: "12px",
        customHeight: "32px",
        padding: "12px 16px",
        onClick: function onClick(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          crossSellRedirect({
            partner: partner,
            crossSellProduct: crossSellProduct,
            item: props.cardData
          });
        }
      })]
    }), isBuyCurrencyModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
        fallback: null,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BuyCurrencyBS // deliveryDate={'Mon, 25th December'}
        , CrossSellPersuasion_objectSpread({
          onModalClose: function onModalClose() {
            setBuyCurrencyModalOpen(false);
          } // heading="Foreign Currency Notes, Just One Step Away!"
          // tripDetail={tripDetails}
          // btnTitle="BUY CURRENCY"
          ,
          btnClickHandler: function btnClickHandler(e) {
            props.handlers.sendCrossSellPdtEvent({
              eventName: constants/* PDT_EVENTS.CROSS_SELL_NUDGE_CLICKED */.sJ.CROSS_SELL_NUDGE_CLICKED,
              eventValue: crossSellProduct || ""
            });
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            crossSellRedirect({
              partner: partner,
              crossSellProduct: crossSellProduct,
              item: props.cardData
            });
          } // additionalInfo={`BookMyForex Currency is the trusted choice of <b>80% Traveller</b>`}
          // isCardCrossSell={true}
          ,
          facilities: getFacilities(),
          isLoading: false
        }, getCrossSellComponentData({
          crossSellAddress: crossSellAddress,
          crossSellCards: crossSellCards,
          crossSellDeliveryDetails: crossSellDeliveryDetails,
          crossSellPii: crossSellPii,
          crossSellUpcomingTrips: crossSellUpcomingTrips,
          crossSellProduct: crossSellProduct
        })))
      })
    })]
  });
};

/* harmony default export */ var Persuasions_CrossSellPersuasion = (CrossSellPersuasion);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/ProductOffers/index.tsx





var ProductOffers_FreeCardOffer = function FreeCardOffer(props) {
  var _ref = props.persuasionProps || {},
      cashback = _ref.cashback,
      text = _ref.text;

  return !!cashback ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FreeCard, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
      fontSize: "xs",
      fontWeight: "bold",
      color: "#007E7D",
      children: "\u20B9 ".concat(cashback, " Cashback")
    }), text && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
        fontSize: "xs",
        fontWeight: "bold",
        color: "#000",
        children: "|"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
        fontSize: "xs",
        fontWeight: "bold",
        color: "#007E7D",
        children: text
      })]
    })]
  }) : null;
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/ReloadTripPersuasion.tsx


function ReloadTripPersuasion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReloadTripPersuasion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReloadTripPersuasion_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReloadTripPersuasion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function ReloadTripPersuasion(props) {
  var device = (0,hooks_useDevice/* useDevice */.F)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      props.handlers.reloadTripHandler(props.cardData);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
      padding: device === "lg" ? "8px 12px" : "16px",
      borderRadius: "8px",
      margin: device === "lg" ? "24px 0px 0px" : "24px -16px -16px",
      justifyContent: "space-between",
      flexDirection: "row",
      bgColor: "linear-gradient(147deg, #FFF6D8 4.79%, #FFFAF3 43.98%, #F3F0E6 120.5%)",
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
        margin: "0px",
        padding: "0px",
        children: [props.persuasionProps.showInstantLoadIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/load_Instantly_dc4ba861d7.svg",
          alt: "IL",
          style: {
            marginRight: "10px"
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), props.persuasionProps.label ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp/* default */.Z, {
          padding: "0px",
          alignItems: "flex-start",
          justifyContent: "space-between",
          margin: device === "sm" ? "0px 20px 0px 0px" : "0px",
          bgColor: "transparent",
          flexDirection: "column",
          children: [props.persuasionProps.label && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
            fontWeight: "bold",
            color: Global/* theme.blackText */.rS.blackText,
            children: props.persuasionProps.label
          }), props.persuasionProps.subLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag/* default */.Z, {
            color: Global/* theme.greyText */.rS.greyText,
            children: props.persuasionProps.subLabel
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
      }), props.persuasionProps.btnProps && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton/* default */.Z, ReloadTripPersuasion_objectSpread(ReloadTripPersuasion_objectSpread({
        id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, (0,utils.getCamelCaseStr)(props.cardData.label), constants/* ElementNameMapping.RELOAD_TRIP */.vT.RELOAD_TRIP)
      }, props.persuasionProps.btnProps), {}, {
        flexShrink: "0",
        fontSize: "12px",
        customHeight: "32px",
        padding: "12px 16px"
      }))]
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasion.tsx














var perusasionTypeToComponentMapping = {
  backend: BackendPersuasion,
  dropoff: DropOffPersuasion,
  delivery_tracking: DeliveryStatusPersuasion,
  mini_dashboard: MiniDashboardPersuasion,
  upload_docs: UploadDocsPersuasion,
  view_orders: ViewOrdersPersuasion,
  activation_in_progress: DeliveryStatusPersuasion,
  start_order: function start_order() {},
  undeliverable: UnavailableLocationPersuasion,
  upcoming_trips: DeliveryStatusPersuasion,
  cross_sell: Persuasions_CrossSellPersuasion,
  free_card: ProductOffers_FreeCardOffer,
  reload_discovery: ReloadTripPersuasion
};
function Persuasion_PersuasionListing(props) {
  var _props$persuasions;

  return /*#__PURE__*/_jsx(_Fragment, {
    children: (_props$persuasions = props.persuasions) === null || _props$persuasions === void 0 ? void 0 : _props$persuasions.map(function (persuasionData, key) {
      if (excludePersuasionList !== null && excludePersuasionList !== void 0 && excludePersuasionList.includes((persuasionData === null || persuasionData === void 0 ? void 0 : persuasionData.type) || "")) {
        return null;
      }

      return /*#__PURE__*/_jsx(Persuasion, {
        handlers: props.handlers,
        index: "persuasion_" + key,
        cardData: props.cardData,
        persuasionData: persuasionData
      }, "".concat(persuasionData.type).concat(key));
    })
  });
}

function Persuasion(props) {
  if (!props.persuasionData.type || !perusasionTypeToComponentMapping[props.persuasionData.type]) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var persuasionProps = getPersuasionProp(props.persuasionData.type, props.persuasionData.data);
  var PersuasionComponent = perusasionTypeToComponentMapping[props.persuasionData.type];
  return /*#__PURE__*/_jsx(PersuasionComponent, {
    type: props.persuasionData.type,
    handlers: props.handlers,
    cardData: props.cardData,
    persuasionProps: persuasionProps,
    index: props.index
  });
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var hooks_useGlobalSelector = __webpack_require__(2053);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/Persuasions/CardCtaPersuasion.tsx












function CardCtaPersuasion_CardCtaPersuasion(_ref) {
  var _experiments$swap_min, _cardData$linkBtnInMo4;

  var rightBtnClickHandler = _ref.rightBtnClickHandler,
      leftBtnClickHandler = _ref.leftBtnClickHandler,
      cardData = _ref.cardData,
      id = _ref.id,
      arrowIconSrc = _ref.arrowIconSrc,
      bestRateApplicableTxt = _ref.bestRateApplicableTxt;
  var device = useDevice();

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state || {};
  }),
      experiments = _useGlobalSelector.experiments;

  var isMiniDashboardSwitchBtnExpEnabled = experiments === null || experiments === void 0 ? void 0 : (_experiments$swap_min = experiments.swap_mini_dashboard_btns) === null || _experiments$swap_min === void 0 ? void 0 : _experiments$swap_min.enabled;
  var arrowIcon = arrowIconSrc ? /*#__PURE__*/_jsx(ImageTag, {
    src: arrowIconSrc
  }) : /*#__PURE__*/_jsx(ArrowIcon, {});

  var rightClickBtnHandlerWrapper = function rightClickBtnHandlerWrapper(e) {
    e.stopPropagation();
    rightBtnClickHandler && rightBtnClickHandler(e);
  };

  var leftClickBtnHandlerWrapper = function leftClickBtnHandlerWrapper(event) {
    event.stopPropagation();
    leftBtnClickHandler && leftBtnClickHandler(event);
  };

  function renderRightButtonMiniDashboard() {
    var _cardData$linkBtnInMo, _cardData$linkBtnInMo2;

    if (!(cardData !== null && cardData !== void 0 && cardData.linkBtnInMobile)) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    } // Render load currency button if props coming.


    if (!!isMiniDashboardSwitchBtnExpEnabled && !!(cardData !== null && cardData !== void 0 && cardData.addText)) {
      return /*#__PURE__*/_jsx(LandingButton, {
        id: "ListingPage_load_currency_btn",
        margin: "0px 0px 0px auto",
        onClick: leftClickBtnHandlerWrapper,
        fontSize: "12px",
        customHeight: "32px",
        customTitle: cardData === null || cardData === void 0 ? void 0 : cardData.addText
      });
    }

    return cardData !== null && cardData !== void 0 && cardData.isPrimaryButton ? /*#__PURE__*/_jsx(LandingButton, {
      customTitle: cardData === null || cardData === void 0 ? void 0 : (_cardData$linkBtnInMo = cardData.linkBtnInMobile) === null || _cardData$linkBtnInMo === void 0 ? void 0 : _cardData$linkBtnInMo.label,
      margin: "0px 0px 0px auto",
      onClick: rightClickBtnHandlerWrapper,
      fontSize: "12px",
      customHeight: "32px",
      id: id
    }) : /*#__PURE__*/_jsx(AnchorTag, {
      id: id,
      width: "fit-content",
      fontSize: "xs",
      fontWeight: "bold",
      margin: "0px 0 0 auto",
      handleClick: rightClickBtnHandlerWrapper,
      children: cardData === null || cardData === void 0 ? void 0 : (_cardData$linkBtnInMo2 = cardData.linkBtnInMobile) === null || _cardData$linkBtnInMo2 === void 0 ? void 0 : _cardData$linkBtnInMo2.label
    });
  }

  if (device === "lg") {
    var _cardData$linkBtnInMo3;

    return /*#__PURE__*/_jsxs(RightButtonContainer, {
      onClick: rightClickBtnHandlerWrapper,
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        id: id,
        width: "fit-content",
        fontSize: "sm",
        fontWeight: "bold",
        children: cardData === null || cardData === void 0 ? void 0 : (_cardData$linkBtnInMo3 = cardData.linkBtnInMobile) === null || _cardData$linkBtnInMo3 === void 0 ? void 0 : _cardData$linkBtnInMo3.label
      }), arrowIcon]
    });
  }

  return /*#__PURE__*/_jsxs(FlexComp, {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 0px 0px",
    children: [!!isMiniDashboardSwitchBtnExpEnabled && !!(cardData !== null && cardData !== void 0 && cardData.addText) && /*#__PURE__*/_jsx(AnchorTag, {
      id: id,
      width: "fit-content",
      fontSize: "xs",
      fontWeight: "bold",
      margin: "0px",
      handleClick: rightClickBtnHandlerWrapper,
      children: cardData === null || cardData === void 0 ? void 0 : (_cardData$linkBtnInMo4 = cardData.linkBtnInMobile) === null || _cardData$linkBtnInMo4 === void 0 ? void 0 : _cardData$linkBtnInMo4.label
    }), !isMiniDashboardSwitchBtnExpEnabled && !!(cardData !== null && cardData !== void 0 && cardData.addText) && /*#__PURE__*/_jsx(AnchorTag, {
      id: "ListingPage_load_currency_btn",
      width: "fit-content",
      fontSize: "xs",
      fontWeight: "bold",
      margin: "0px",
      handleClick: leftClickBtnHandlerWrapper,
      children: cardData.addText
    }), device === "sm" && bestRateApplicableTxt && /*#__PURE__*/_jsx(FlexComp, {
      bgColor: "linear-gradient(90deg, #ECEAF8 0%, rgba(255, 255, 255, 0) 93.75%)",
      padding: "4px",
      margin: "0 0 0 -16px",
      children: /*#__PURE__*/_jsx(SpanTag, {
        color: "#3A27B0",
        fontSize: "xs",
        children: bestRateApplicableTxt
      })
    }), renderRightButtonMiniDashboard()]
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingCardFeature/LandingCardFeatureV3.tsx


















var LandingCardFeatureV3_LandingCardFeatureV3 = function LandingCardFeatureV3(_ref) {
  var _data$program_details, _data$program_details2, _viewOrdersPersuasion;

  var margin = _ref.margin,
      padding = _ref.padding,
      border = _ref.border,
      borderWidth = _ref.borderWidth,
      data = _ref.data,
      idx = _ref.idx,
      loadCurrenyBtnHandler = _ref.loadCurrenyBtnHandler,
      recommendedBtnHandler = _ref.recommendedBtnHandler,
      startFromWhereLeftHandler = _ref.startFromWhereLeftHandler,
      docsPendingHandler = _ref.docsPendingHandler,
      _onClick = _ref.onClick,
      onClickAnotherLocation = _ref.onClickAnotherLocation,
      onClickLoadMoney = _ref.onClickLoadMoney,
      viewDashBoardClickHandler = _ref.viewDashBoardClickHandler,
      viewOrdersClickHandler = _ref.viewOrdersClickHandler,
      isInfoOnRightSide = _ref.isInfoOnRightSide,
      startOrderClicked = _ref.startOrderClicked,
      deliveryUnavailbleClickHandler = _ref.deliveryUnavailbleClickHandler,
      sendCrossSellPdtEvent = _ref.sendCrossSellPdtEvent,
      reloadTripHandler = _ref.reloadTripHandler,
      bestRateApplicableTxt = _ref.bestRateApplicableTxt;
  var device = useDevice();
  var logoSrc = data.logoSrc,
      label = data.label,
      subLabel = data.subLabel,
      featuresArr = data.featuresArr,
      featureArrDesktop = data.featureArrDesktop,
      loadCurrency = data.loadCurrency,
      startOrder = data.startOrder,
      logoDesc = data.logoDesc,
      isRecommendNotification = data.isRecommendNotification,
      viewOrdersPersuasion = data.viewOrdersPersuasion,
      version = data.version,
      persuasions = data.persuasions;

  var loadCurrencyHandler = function loadCurrencyHandler(e, data) {
    loadCurrenyBtnHandler === null || loadCurrenyBtnHandler === void 0 ? void 0 : loadCurrenyBtnHandler(data);
    e.stopPropagation();
  };

  var onClickViewDashboard = function onClickViewDashboard(e, data) {
    viewDashBoardClickHandler === null || viewDashBoardClickHandler === void 0 ? void 0 : viewDashBoardClickHandler(data);
    e.stopPropagation();
  };

  var onClickViewOrders = function onClickViewOrders(e, data) {
    viewOrdersClickHandler === null || viewOrdersClickHandler === void 0 ? void 0 : viewOrdersClickHandler(data);
    e.stopPropagation();
  };

  var getFreeCardPersuation = function getFreeCardPersuation() {
    var persuarionProps = getPersuasionsProps(data);
    return persuarionProps[PERSUASION_TYPE.FREE_CARD];
  };

  return device ? /*#__PURE__*/_jsxs(LandingCardFeatureStyle, {
    margin: margin,
    border: border,
    padding: padding,
    borderWidth: borderWidth,
    version: version,
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(data, idx);
    },
    isZeroPayment: (data === null || data === void 0 ? void 0 : (_data$program_details = data.program_details) === null || _data$program_details === void 0 ? void 0 : _data$program_details.type) === PROGRAM_DETAILS_ENUM.FREE_CARD,
    children: [device === "lg" && (data === null || data === void 0 ? void 0 : (_data$program_details2 = data.program_details) === null || _data$program_details2 === void 0 ? void 0 : _data$program_details2.type) === PROGRAM_DETAILS_ENUM.FREE_CARD && /*#__PURE__*/_jsx(ZeroPayment, {
      children: /*#__PURE__*/_jsx(ImageTag, {
        src: IMAGE_URLS.ZERO_PAYMENT_FREE_CARD_IMAGE,
        width: "108px",
        height: "22px"
      })
    }), isRecommendNotification && device === "lg" && /*#__PURE__*/_jsx(AbsTag, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greenText,
        children: "Recommended"
      })
    }), /*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: device === "lg" ? isInfoOnRightSide ? "row" : "column" : "row",
      flex: "1",
      padding: "0px",
      gap: device === "lg" ? "0px" : "16px",
      isCursorPointer: true,
      children: [/*#__PURE__*/_jsxs(LogoContainer, {
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.LOGO_CONTAINER),
        children: [/*#__PURE__*/_jsx(ImageTag, {
          src: logoSrc,
          width: device === "lg" ? "120px" : "100%"
        }), logoDesc && /*#__PURE__*/_jsxs(ParaTag, {
          margin: device === "lg" ? "0px 0px 6px" : "0px",
          fontSize: device === "sm" ? "xxs" : "xs",
          color: theme.greyText,
          children: [logoDesc.normalText, " ", logoDesc.boldText && /*#__PURE__*/_jsx(SpanTag, {
            fontWeight: "bold",
            color: theme.greyText,
            fontSize: device === "sm" ? "xxs" : "xs",
            children: logoDesc.boldText
          })]
        })]
      }), /*#__PURE__*/_jsxs(FlexComp, {
        padding: "0px",
        gap: "0px",
        flexDirection: "column",
        isCursorPointer: true,
        children: [/*#__PURE__*/_jsxs(FlexComp // handleClick={() => onClick(data, idx)}
        , {
          flex: "0",
          gap: "12px",
          justifyContent: "space-between",
          alignItems: "center",
          isCursorPointer: true,
          children: [/*#__PURE__*/_jsx(ParaTag, {
            id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.HEADING),
            fontSize: "large",
            fontWeight: "bold",
            children: label
          }), !!(startOrder !== null && startOrder !== void 0 && startOrder.linkBtnInMobile) && device === "lg" && /*#__PURE__*/_jsx(CardCtaPersuasion, {
            cardData: startOrder,
            rightBtnClickHandler: function rightBtnClickHandler(e) {
              e.stopPropagation();
              startOrderClicked(data);
            },
            id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.QUICK_LOAD // @TODO: UPDATE KEY
            )
          }), !!(loadCurrency !== null && loadCurrency !== void 0 && loadCurrency.linkBtnInMobile) && device === "lg" && /*#__PURE__*/_jsx(CardCtaPersuasion, {
            cardData: loadCurrency,
            rightBtnClickHandler: function rightBtnClickHandler(e) {
              return onClickViewDashboard(e, data);
            },
            leftBtnClickHandler: function leftBtnClickHandler(e) {
              return loadCurrencyHandler(e, data);
            },
            id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.QUICK_LOAD)
          })]
        }), !!subLabel && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "sm",
          children: subLabel
        }), featuresArr && featureArrDesktop && !loadCurrency && /*#__PURE__*/_jsx(PointsContainer, {
          children: (device === "lg" ? featureArrDesktop : featuresArr).map(function (item, idx) {
            return /*#__PURE__*/_jsx(SpanTag, {
              fontSize: device === "lg" ? "sm" : "xs",
              color: theme.greyText,
              display: "inline",
              children: item.label
            }, idx);
          })
        }), loadCurrency && /*#__PURE__*/_jsx(Fragment, {
          children: /*#__PURE__*/_jsxs(FlexComp, {
            margin: device === "lg" ? "8px 0px 0px" : "4px 0px 0px",
            flexDirection: "column",
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              flexDirection: "row",
              gap: "4px",
              margin: "0px 0px 12px",
              children: [!!loadCurrency.label && /*#__PURE__*/_jsx(ParaTag, {
                fontSize: device === "lg" ? "sm" : "xs",
                fontWeight: "regular",
                children: loadCurrency.label
              }), !!loadCurrency.subLabel && /*#__PURE__*/_jsx(ParaTag, {
                fontSize: device === "lg" ? "sm" : "xs",
                color: theme.greyText,
                fontWeight: "bold",
                children: loadCurrency.subLabel
              })]
            }), device === "lg" && !!loadCurrency.addText && /*#__PURE__*/_jsx(AnchorTag, {
              id: "ListingPage_load_currency_btn",
              width: "fit-content",
              fontSize: "sm",
              fontWeight: "bold",
              margin: "0px",
              handleClick: function handleClick(e) {
                return loadCurrencyHandler(e, data);
              },
              children: loadCurrency.addText
            })]
          })
        }), viewOrdersPersuasion && version === VERSIONS.V2 && /*#__PURE__*/_jsx(FlexComp, {
          margin: device === "lg" ? "12px 0px 0px" : "4px 0px 0px",
          flexDirection: "column",
          children: (viewOrdersPersuasion === null || viewOrdersPersuasion === void 0 ? void 0 : viewOrdersPersuasion.linkBtnInMobile) && /*#__PURE__*/_jsx(AnchorTag, {
            width: "fit-content",
            fontSize: device === "lg" ? "sm" : "xs",
            fontWeight: "bold",
            margin: device === "lg" ? "0px" : "12px 0 0 0",
            handleClick: function handleClick(e) {
              return onClickViewOrders(e, data);
            },
            children: viewOrdersPersuasion === null || viewOrdersPersuasion === void 0 ? void 0 : (_viewOrdersPersuasion = viewOrdersPersuasion.linkBtnInMobile) === null || _viewOrdersPersuasion === void 0 ? void 0 : _viewOrdersPersuasion.label
          })
        }), /*#__PURE__*/_jsx(FreeCardOffer, {
          persuasionProps: getFreeCardPersuation()
        })]
      })]
    }), device === "sm" && !!(startOrder !== null && startOrder !== void 0 && startOrder.linkBtnInMobile) && /*#__PURE__*/_jsx(CardCtaPersuasion, {
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.QUICK_LOAD),
      cardData: startOrder,
      rightBtnClickHandler: function rightBtnClickHandler(e) {
        e.stopPropagation();
        startOrderClicked(data);
      },
      leftBtnClickHandler: function leftBtnClickHandler(e) {
        return loadCurrencyHandler(e, data);
      },
      bestRateApplicableTxt: bestRateApplicableTxt
    }), device === "sm" && (!!(loadCurrency !== null && loadCurrency !== void 0 && loadCurrency.addText) || !!(loadCurrency !== null && loadCurrency !== void 0 && loadCurrency.linkBtnInMobile)) && /*#__PURE__*/_jsx(CardCtaPersuasion, {
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.label), ElementNameMapping.QUICK_LOAD),
      cardData: loadCurrency,
      rightBtnClickHandler: function rightBtnClickHandler(e) {
        return onClickViewDashboard(e, data);
      },
      leftBtnClickHandler: function leftBtnClickHandler(e) {
        return loadCurrencyHandler(e, data);
      }
    }), device === "lg" && bestRateApplicableTxt && /*#__PURE__*/_jsx(FlexComp, {
      alignSelf: "flex-start",
      padding: "0",
      children: /*#__PURE__*/_jsx(FlexComp, {
        bgColor: "linear-gradient(90deg, #ECEAF8 0%, rgba(255, 255, 255, 0) 93.75%)",
        padding: "4px",
        margin: "2px 0 0 0px",
        borderRadius: "4px",
        children: /*#__PURE__*/_jsx(SpanTag, {
          color: "#3A27B0",
          fontSize: "xs",
          children: bestRateApplicableTxt
        })
      })
    }), /*#__PURE__*/_jsx(PersuasionListing, {
      handlers: {
        onClickAnotherLocation: onClickAnotherLocation,
        docsPendingHandler: docsPendingHandler,
        loadCurrenyBtnHandler: loadCurrenyBtnHandler,
        recommendedBtnHandler: recommendedBtnHandler,
        startFromWhereLeftHandler: startFromWhereLeftHandler,
        deliveryUnavailbleClickHandler: deliveryUnavailbleClickHandler,
        sendCrossSellPdtEvent: sendCrossSellPdtEvent,
        reloadTripHandler: reloadTripHandler
      },
      cardData: data,
      persuasions: persuasions
    })]
  }) : /*#__PURE__*/_jsx(Fragment, {});
};

/* harmony default export */ var LandingCardFeature_LandingCardFeatureV3 = ((/* unused pure expression or super */ null && (LandingCardFeatureV3_LandingCardFeatureV3)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/PriceTicker/mockData.ts
var mockData_PriceTickerData = [{
  id: "1",
  currencyCode: "THB",
  amount: "45.20 INR",
  conditional: true,
  upcomingTripInfo: "For upcoming trip to <b>Thailand</b>"
}, {
  id: "2",
  currencyCode: "EUR",
  amount: "92.03 INR",
  conditional: true,
  upcomingTripInfo: ""
}, {
  id: "3",
  currencyCode: "USD",
  amount: "82.32 INR",
  conditional: true,
  upcomingTripInfo: ""
}, {
  id: "4",
  currencyCode: "AED",
  amount: "45.25 INR",
  conditional: true,
  upcomingTripInfo: ""
}];
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/PriceTicker/PriceTicker.style.ts

var PriceTicker_style_PriceTickerContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PriceTickerstyle__PriceTickerContainer",
  componentId: "sc-15xanj5-0"
})(["overflow:hidden;height:", "px;"], function (props) {
  return props.height;
});
var PriceTicker_style_TickerList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "PriceTickerstyle__TickerList",
  componentId: "sc-15xanj5-1"
})(["list-style:none;padding:0;margin:0;transition:all 0.8s ease-in-out;> li{height:", "px;display:flex;flex-direction:column;justify-content:center;padding:5px;}"], function (props) {
  return props.height;
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/PriceTicker/PriceTicker.tsx














var PriceTicker_PriceTicker = function PriceTicker(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 56 : _ref$height,
      _ref$priceTickerData = _ref.priceTickerData,
      priceTickerData = _ref$priceTickerData === void 0 ? PriceTickerData : _ref$priceTickerData;

  var _useState = useState(0),
      index = _useState[0],
      setIndex = _useState[1];

  var items = priceTickerData;
  var doubledItems = [].concat(_toConsumableArray(items), _toConsumableArray(items));
  var tickerRef = useRef(null);
  var UPCOMING_TRIP_INTERVAL = 5000;
  var NORMAL_INTERVAL = 3000;
  var device = useDevice();
  useEffect(function () {
    var _items$index;

    var isItemUpcomingTrip = (_items$index = items[index]) !== null && _items$index !== void 0 && _items$index.upcomingTripInfo ? true : false;
    var interval = setInterval(function () {
      setIndex(function (prevIndex) {
        return prevIndex + 1;
      });
    }, isItemUpcomingTrip ? UPCOMING_TRIP_INTERVAL : NORMAL_INTERVAL);
    return function () {
      return clearInterval(interval);
    };
  }, [index]);
  useEffect(function () {
    if (index === items.length) {
      setTimeout(function () {
        if (tickerRef.current) {
          tickerRef.current.style.transition = "none";
          tickerRef.current.style.transform = "translateY(0px)";
          tickerRef.current.offsetHeight; // force reflow
        }

        setIndex(0);
        setTimeout(function () {
          if (tickerRef.current) {
            tickerRef.current.style.transition = "transform 0.8s ease-in-out";
          }
        }, 50); // Small delay to ensure the transition is applied correctly
      }, 50); // Small delay to avoid the glitch
    }
  }, [index, items.length]);
  return /*#__PURE__*/_jsx(PriceTickerContainer, {
    height: height,
    id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.PRICE_TICKER),
    children: /*#__PURE__*/_jsx(TickerList, {
      ref: tickerRef,
      height: height,
      style: {
        transform: "translateY(".concat(-index * height, "px)")
      },
      children: doubledItems === null || doubledItems === void 0 ? void 0 : doubledItems.map(function (item, i) {
        return /*#__PURE__*/_jsxs("li", {
          children: [device === "lg" && (item === null || item === void 0 ? void 0 : item.upcomingTripInfo) && /*#__PURE__*/_jsx(ParaTag, {
            color: theme.greyText,
            fontSize: "xs",
            margin: "0px 0px 2px",
            dangerousText: item.upcomingTripInfo
          }), /*#__PURE__*/_jsxs(ParaTag, {
            color: theme.blackText,
            fontWeight: device === "lg" ? "bold" : "medium",
            fontSize: "xxlarge",
            children: [item.currencyCode, /*#__PURE__*/_jsx(SpanTag, {
              color: theme.greyText6,
              fontWeight: "regular",
              margin: "0px 4px 0px 4px",
              fontSize: "xxlarge",
              children: "@"
            }), (item === null || item === void 0 ? void 0 : item.amount) && /*#__PURE__*/_jsx(SpanTag, {
              color: theme.greenText5,
              fontWeight: device === "lg" ? "bold" : "semiBold",
              fontSize: "xxlarge",
              children: item.amount
            }), item.conditional && /*#__PURE__*/_jsx(SpanTag, {
              color: theme.redText2,
              fontSize: "xxlarge",
              children: "*"
            }), item !== null && item !== void 0 && item.amount ? /*#__PURE__*/_jsx(SpanTag, {
              color: theme.greenText5,
              margin: "0px 0px 0px 4px",
              fontWeight: device === "lg" ? "bold" : "semiBold",
              fontSize: "xxlarge",
              children: "INR"
            }) : /*#__PURE__*/_jsx(_Fragment, {})]
          }), device === "sm" && (item === null || item === void 0 ? void 0 : item.upcomingTripInfo) && /*#__PURE__*/_jsx(ParaTag, {
            color: theme.greyText,
            fontSize: "xs",
            margin: "2px 0px 0px",
            dangerousText: item.upcomingTripInfo
          })]
        }, i);
      })
    })
  });
};

/* harmony default export */ var components_PriceTicker_PriceTicker = ((/* unused pure expression or super */ null && (PriceTicker_PriceTicker)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/ClubOfferBanner.tsx














var ClubOfferBanner_ClubOfferBanner = function ClubOfferBanner(_ref) {
  var viewAllPriceHandler = _ref.viewAllPriceHandler,
      priceTickerData = _ref.priceTickerData,
      desktopLandingTitle = _ref.desktopLandingTitle,
      bestPriceLabel = _ref.bestPriceLabel,
      onBestPriceLabelClick = _ref.onBestPriceLabelClick,
      bestRateHyperlink = _ref.bestRateHyperlink;
  var device = useDevice();
  var host = getHostName();
  if (!(priceTickerData !== null && priceTickerData !== void 0 && priceTickerData.length)) return /*#__PURE__*/_jsx(_Fragment, {
    children: host === HOST.MAKEMYTRIP ? /*#__PURE__*/_jsx(FlexComp, {}) : /*#__PURE__*/_jsx(_Fragment, {})
  });
  return device === "lg" ? /*#__PURE__*/_jsxs(FlexComp, {
    gap: "0px",
    margin: "".concat(host === HOST.MAKEMYTRIP ? "40px" : "0px", " 0px 24px 0px"),
    padding: "0px",
    alignItems: "center",
    justifyContent: "space-between",
    width: "auto",
    height: "auto",
    id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.CLUB_OFFER),
    children: [/*#__PURE__*/_jsxs(PriceRatesWrapper, {
      children: [/*#__PURE__*/_jsx(PriceRatesContainerOuter, {
        children: /*#__PURE__*/_jsx(AnchorTag, {
          hrefProp: bestRateHyperlink,
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: function onClick(e) {
            if (!bestRateHyperlink) e.preventDefault();
          },
          children: /*#__PURE__*/_jsxs(PriceRatesContainer, {
            children: [/*#__PURE__*/_jsx(ImageTag, {
              src: "https://tripmoneycmsimgak.mmtcdn.com/img/rupee_3c03082b28.svg",
              height: "16px",
              width: "16px"
            }), /*#__PURE__*/_jsx(BestPriceTextGradient, {
              children: bestPriceLabel
            })]
          })
        })
      }), /*#__PURE__*/_jsx(PriceTickerOuter, {
        onClick: viewAllPriceHandler,
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.VIEW_PRICES),
        children: /*#__PURE__*/_jsxs(PriceTickerInner, {
          children: [/*#__PURE__*/_jsx(PriceTicker, {
            height: 60,
            priceTickerData: priceTickerData
          }), /*#__PURE__*/_jsx(ImageTag, {
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/circular_Right_Chev_0b385a64bf.svg",
            height: "24px",
            width: "24px",
            margin: "0px 0px 0px 16px"
          })]
        })
      })]
    }), desktopLandingTitle && /*#__PURE__*/_jsx(LandingTitleStyle, {
      color: theme.greyText,
      fontSize: "sm",
      dangerouslySetInnerHTML: {
        __html: desktopLandingTitle
      }
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FlexComp, {
      alignSelf: "flex-start",
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.CLUB_OFFER),
      children: /*#__PURE__*/_jsx(FlexComp, {
        margin: "0px 16px",
        bgColor: "linear-gradient(87.29deg, #C86DD7 0%, #3023AE 100%)",
        padding: "2px 8px",
        borderRadius: "16px",
        handleClick: onBestPriceLabelClick,
        children: /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          color: theme.whiteText,
          children: bestPriceLabel
        })
      })
    }), /*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "20px",
      margin: "4px 16px 12px",
      children: [/*#__PURE__*/_jsx(PriceTicker, {
        height: 56,
        priceTickerData: priceTickerData
      }), /*#__PURE__*/_jsx(AnchorTag, {
        fontWeight: "bold",
        onClick: viewAllPriceHandler,
        fontSize: "xs",
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.VIEW_PRICES),
        children: "Know more"
      })]
    })]
  });
};

/* harmony default export */ var ListingPageComponents_ClubOfferBanner = ((/* unused pure expression or super */ null && (ClubOfferBanner_ClubOfferBanner)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(4556);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/EditLocation/EditLocation.styles.ts
var EditLocation_styles = __webpack_require__(8869);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/BlueLoaderSvg/index.tsx



var blueLoaderSvg = function blueLoaderSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "40",
      height: "40",
      fill: "url(#pattern0)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1",
        children: /*#__PURE__*/_jsx("use", {
          href: "#image0_1845_37056",
          transform: "scale(0.00333333)"
        })
      }), /*#__PURE__*/_jsx("image", {
        id: "image0_1845_37056",
        width: "300",
        height: "300",
        href: "data:image/png;base64,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"
      })]
    })]
  });
};

/* harmony default export */ var BlueLoaderSvg = ((/* unused pure expression or super */ null && (blueLoaderSvg)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/PageLoader/style.ts

var spinKeyframe = (0,styled_components_browser_esm.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var style_PageLoaderStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "style__PageLoaderStyle",
  componentId: "sc-110g8py-0"
})(["height:100vh;width:100%;display:flex;align-items:center;flex-direction:column;justify-content:center;background:", ";gap:10px;position:fixed;top:0;left:0;z-index:99;svg{-webkit-animation-name:spin;-webkit-animation-duration:2000ms;-webkit-animation-iteration-count:infinite;-webkit-animation-timing-function:linear;-moz-animation-name:spin;-moz-animation-duration:2000ms;-moz-animation-iteration-count:infinite;-moz-animation-timing-function:linear;-ms-animation-name:spin;-ms-animation-duration:2000ms;-ms-animation-iteration-count:infinite;-ms-animation-timing-function:linear;animation-name:", ";animation-duration:2000ms;animation-iteration-count:infinite;animation-timing-function:linear;}"], function (p) {
  return p.dark ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.9)";
}, spinKeyframe);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/PageLoader/index.tsx








var PageLoader_PageLoader = function PageLoader(props) {
  var messages = props.messages,
      darkTheme = props.darkTheme;
  useEffect(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/_jsxs(PageLoaderStyle, {
    dark: darkTheme,
    children: [/*#__PURE__*/_jsx(BlueLoader, {}), messages === null || messages === void 0 ? void 0 : messages.map(function (e, i) {
      return /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        color: darkTheme ? theme.whiteText : theme.greyText,
        fontWeight: i === 0 ? "bold" : "regular",
        children: e
      }, new Date().getMilliseconds() + i);
    })]
  });
};

/* harmony default export */ var components_PageLoader = ((/* unused pure expression or super */ null && (PageLoader_PageLoader)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/PriceHikeWarning/index.tsx
var components_PriceHikeWarning = __webpack_require__(8150);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useTimer/index.ts


var useTimer_useTimer = function useTimer(_ref) {
  var startHours = _ref.startHours,
      startMinutes = _ref.startMinutes,
      startSeconds = _ref.startSeconds,
      counterType = _ref.counterType,
      stopHours = _ref.stopHours,
      stopMinutes = _ref.stopMinutes,
      stopSeconds = _ref.stopSeconds,
      _ref$padLength = _ref.padLength,
      padLength = _ref$padLength === void 0 ? 1 : _ref$padLength;

  var _useState = useState(startHours),
      hours = _useState[0],
      setHours = _useState[1];

  var _useState2 = useState(startMinutes),
      minutes = _useState2[0],
      setMinutes = _useState2[1];

  var _useState3 = useState(startSeconds),
      seconds = _useState3[0],
      setSeconds = _useState3[1];

  var timerRef = useRef(null);
  var hoursRef = useRef(startHours);
  var minutesRef = useRef(startMinutes);
  var secondsRef = useRef(startSeconds);

  var tick = function tick() {
    var totalSeconds = hoursRef.current * 3600 + minutesRef.current * 60 + secondsRef.current + (counterType === "increment" ? 1 : -1);

    if (totalSeconds < 0) {
      return;
    }

    var newHours = Math.floor(totalSeconds / 3600);
    var newMinutes = Math.floor(totalSeconds % 3600 / 60);
    var newSeconds = totalSeconds % 60;

    if (newHours === stopHours && newMinutes === stopMinutes && newSeconds === stopSeconds) {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    } // Update refs


    hoursRef.current = newHours;
    minutesRef.current = newMinutes;
    secondsRef.current = newSeconds; // Update state

    setHours(newHours);
    setMinutes(newMinutes);
    setSeconds(newSeconds);
  };

  useEffect(function () {
    if (!timerRef.current) {
      timerRef.current = setInterval(tick, 1000);
    }

    return function () {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [counterType, stopHours, stopMinutes, stopSeconds]);

  var formatTime = function formatTime(time) {
    return String(time).padStart(padLength, "0");
  };

  return {
    hours: formatTime(hours),
    minutes: formatTime(minutes),
    seconds: formatTime(seconds)
  };
};

/* harmony default export */ var hooks_useTimer = ((/* unused pure expression or super */ null && (useTimer_useTimer)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ToolTip/ToolTip.styles.ts

var ToolTip_styles_ToolTipCont = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ToolTipstyles__ToolTipCont",
  componentId: "sc-52an4f-0"
})(["width:", ";background-color:", ";padding:8px;border-radius:4px;position:absolute;", ""], function (props) {
  return props.width || "400px";
}, function (props) {
  return props.bgColor || "#005756";
}, function (props) {
  var arrowStyles = "\n            content: \"\";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border: solid transparent;\n            border-color: rgba(0, 87, 86, 0);\n        ";

  switch (props.arrowDirection) {
    case "up":
      return "\n                    ::after {\n                        ".concat(arrowStyles, "\n                        bottom: 100%;\n                        left: ").concat(props.arrowPosition || "50%", ";\n                        border-bottom-color: ").concat(props.bgColor || "#005756", ";\n                        border-width: 8px;\n                        margin-left: -8px;\n                    }\n                ");

    case "right":
      return "\n                    ::after {\n                        ".concat(arrowStyles, "\n                        left: 100%;\n                        top: ").concat(props.arrowPosition || "50%", ";\n                        border-left-color: ").concat(props.bgColor || "#005756", ";\n                        border-width: 8px;\n                        margin-top: -8px;\n                    }\n                ");

    case "down":
      return "\n                    ::after {\n                        ".concat(arrowStyles, "\n                        top: 100%;\n                        left: ").concat(props.arrowPosition || "50%", ";\n                        border-top-color: ").concat(props.bgColor || "#005756", ";\n                        border-width: 8px;\n                        margin-left: -8px;\n                    }\n                ");

    case "left":
      return "\n                    ::after {\n                        ".concat(arrowStyles, "\n                        right: 100%;\n                        top: ").concat(props.arrowPosition || "50%", ";\n                        border-right-color: ").concat(props.bgColor || "#005756", ";\n                        border-width: 8px;\n                        margin-top: -8px;\n                    }\n                ");

    default:
      return "";
  }
});
var ToolTip_styles_ToolTipBackdrop = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ToolTipstyles__ToolTipBackdrop",
  componentId: "sc-52an4f-1"
})(["width:100%;height:100%;position:fixed;left:0;top:0;z-index:0;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ToolTip/ToolTip.tsx






var ToolTip_ToolTip = function ToolTip(_ref) {
  var width = _ref.width,
      children = _ref.children,
      bgColor = _ref.bgColor,
      _ref$arrowDirection = _ref.arrowDirection,
      arrowDirection = _ref$arrowDirection === void 0 ? "down" : _ref$arrowDirection,
      arrowPosition = _ref.arrowPosition,
      style = _ref.style,
      closeTooltip = _ref.closeTooltip,
      id = _ref.id;
  var device = useDevice();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ToolTipCont, {
      width: width,
      arrowDirection: arrowDirection,
      arrowPosition: arrowPosition,
      bgColor: bgColor,
      style: style,
      id: id,
      children: children
    }), device === "sm" && /*#__PURE__*/_jsx(ToolTipBackdrop, {
      onClick: function onClick(e) {
        return closeTooltip === null || closeTooltip === void 0 ? void 0 : closeTooltip(e);
      }
    })]
  });
};

/* harmony default export */ var ui_atoms_ToolTip_ToolTip = ((/* unused pure expression or super */ null && (ToolTip_ToolTip)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(5289);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/OrderTimeText/index.tsx















var OrderTimeWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderTimeText__OrderTimeWrapper",
  componentId: "sc-1pqldbd-0"
})(["font-size:14px;color:#555;display:flex;"]);
var HighlightText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "OrderTimeText__HighlightText",
  componentId: "sc-1pqldbd-1"
})(["color:#d98000;font-weight:bold;"]);
var InfoIconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderTimeText__InfoIconWrapper",
  componentId: "sc-1pqldbd-2"
})(["position:relative;display:flex;"]);

var OrderTimeText_OrderTime = function OrderTime(_ref) {
  var orderCutOffText = _ref.orderCutOffText,
      startHours = _ref.startHours,
      startMinutes = _ref.startMinutes,
      _ref$startSeconds = _ref.startSeconds,
      startSeconds = _ref$startSeconds === void 0 ? 0 : _ref$startSeconds,
      _ref$counterType = _ref.counterType,
      counterType = _ref$counterType === void 0 ? "decrement" : _ref$counterType,
      _ref$stopHours = _ref.stopHours,
      stopHours = _ref$stopHours === void 0 ? 0 : _ref$stopHours,
      _ref$stopMinutes = _ref.stopMinutes,
      stopMinutes = _ref$stopMinutes === void 0 ? 0 : _ref$stopMinutes,
      _ref$stopSeconds = _ref.stopSeconds,
      stopSeconds = _ref$stopSeconds === void 0 ? 0 : _ref$stopSeconds,
      toolTipInfo = _ref.toolTipInfo;

  var _useTimer = useTimer({
    startHours: startHours,
    startMinutes: startMinutes,
    startSeconds: startSeconds,
    counterType: counterType,
    stopHours: stopHours,
    stopMinutes: stopMinutes,
    stopSeconds: stopSeconds
  }),
      hours = _useTimer.hours,
      minutes = _useTimer.minutes;

  var device = useDevice();

  var _useState = useState(false),
      showToolTip = _useState[0],
      setShowToolTip = _useState[1];

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtDataV2 = _useListingPdtLoggerV.sendPdtDataV2;

  var infoHandler = function infoHandler() {
    setShowToolTip(!showToolTip);
    sendPdtDataV2({
      event_detail: getEventDetails({
        event_name: PDT_EVENTS.ORDER_TIMER_INFO_CLICKED
      })
    });
  };

  var closeTooltip = function closeTooltip() {
    setShowToolTip(false);
  };

  return /*#__PURE__*/_jsxs(FlexComp, {
    margin: "0",
    padding: "0",
    justifyContent: device === "lg" ? "center" : "",
    alignItems: device === "lg" ? "center" : "",
    children: [/*#__PURE__*/_jsxs(OrderTimeWrapper, {
      children: [Number(hours) > 0 || Number(minutes) > 0 ? /*#__PURE__*/_jsxs(SpanTag, {
        fontSize: device === "lg" ? "large" : "sm",
        children: ["Order within", " ", /*#__PURE__*/_jsx(HighlightText, {
          children: "".concat(Number(hours) !== 0 ? "".concat(hours, "hr") : "", " \n            ").concat(Number(minutes) !== 0 ? "".concat(minutes, "min") : "")
        })]
      }) : null, orderCutOffText && /*#__PURE__*/_jsx(SpanTag, {
        fontSize: device === "lg" ? "large" : "sm",
        dangerousText: orderCutOffText
      })]
    }), (Number(hours) > 0 || Number(minutes) > 0 || orderCutOffText) && toolTipInfo ? /*#__PURE__*/_jsxs(InfoIconWrapper, {
      children: [/*#__PURE__*/_jsx(ImageTag, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Info_0a25f3f0f9.svg",
        showCursorPointer: true,
        margin: "0px 0px 0px 4px",
        onClick: infoHandler,
        height: "18px"
      }), showToolTip && /*#__PURE__*/_jsx(ToolTip, {
        closeTooltip: closeTooltip,
        arrowPosition: device === "lg" ? "68%" : "134px",
        style: {
          right: device === "lg" ? "-95px" : "-178px",
          width: device === "lg" ? "320px" : "320px",
          zIndex: 100,
          background: "#007E7D",
          top: "25px"
        },
        arrowDirection: "up",
        bgColor: "#007E7D",
        children: /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(ParaTag, {
            color: theme.whiteText,
            fontWeight: "regular",
            children: toolTipInfo
          }), /*#__PURE__*/_jsx(ImageTag, {
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Close_ef36e1a467.png",
            width: "24px",
            height: "24px",
            onClick: closeTooltip
          })]
        })
      })]
    }) : null]
  });
};

/* harmony default export */ var OrderTimeText = ((/* unused pure expression or super */ null && (OrderTimeText_OrderTime)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DeliveryStatusText/index.tsx



var DeliveryStatusTextStyled = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DeliveryStatusText__DeliveryStatusTextStyled",
  componentId: "sc-1luz22i-0"
})(["padding:6px;font-size:12px;font-weight:400;background:linear-gradient( 90deg,#e0f0ff 33.5%,rgba(255,255,255,0) 100% );border-radius:6px;"]);

var DeliveryStatusText_DeliveryStatusText = function DeliveryStatusText(_ref) {
  var text = _ref.text;
  if (!text) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(DeliveryStatusTextStyled, {
      children: text
    })
  });
};

/* harmony default export */ var components_DeliveryStatusText = ((/* unused pure expression or super */ null && (DeliveryStatusText_DeliveryStatusText)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/TopShowcaseV3.tsx


function TopShowcaseV3_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TopShowcaseV3_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TopShowcaseV3_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TopShowcaseV3_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




































var TicketIDModal = /*#__PURE__*/(/* unused pure expression or super */ null && (lazy(function () {
  return __webpack_require__.e(/* import() | TicketIDModal */ 8717).then(__webpack_require__.bind(__webpack_require__, 7009));
})));

var TopShowcaseV3_TopShowcaseV3 = function TopShowcaseV3(_ref) {
  var isPageLoading = _ref.isPageLoading,
      isPageLoadingGif = _ref.isPageLoadingGif,
      isPageLoadingText = _ref.isPageLoadingText,
      sectionBgImgURI = _ref.sectionBgImgURI,
      otherProductsText = _ref.otherProductsText,
      iconTextTag = _ref.iconTextTag,
      deliveryPersuasion = _ref.deliveryPersuasion,
      landingTitle = _ref.landingTitle,
      marqueeData = _ref.marqueeData,
      otherShowcaseCardsData = _ref.otherShowcaseCardsData,
      pinnedShowcaseCardData = _ref.pinnedShowcaseCardData,
      _ref$isMarqueeOnBotto = _ref.isMarqueeOnBottom,
      isMarqueeOnBottom = _ref$isMarqueeOnBotto === void 0 ? false : _ref$isMarqueeOnBotto,
      mobileStickyHeadingData = _ref.mobileStickyHeadingData,
      mobileTitle = _ref.mobileTitle,
      locationFetchingData = _ref.locationFetchingData,
      discountBanner = _ref.discountBanner,
      isShowDiscountBanner = _ref.isShowDiscountBanner,
      discountOfferHandler = _ref.discountOfferHandler,
      version = _ref.version,
      viewOrderLabel = _ref.viewOrderLabel,
      loadCurrenyBtnHandler = _ref.loadCurrenyBtnHandler,
      docsPendingHandler = _ref.docsPendingHandler,
      recommendedBtnHandler = _ref.recommendedBtnHandler,
      startFromWhereLeftHandler = _ref.startFromWhereLeftHandler,
      onClickAnotherLocation = _ref.onClickAnotherLocation,
      viewDashBoardClickHandler = _ref.viewDashBoardClickHandler,
      viewOrdersClickHandler = _ref.viewOrdersClickHandler,
      startOrderClicked = _ref.startOrderClicked,
      deliveryUnavailbleClickHandler = _ref.deliveryUnavailbleClickHandler,
      discountInfoIconHandler = _ref.discountInfoIconHandler,
      discountBannerBgColor = _ref.discountBannerBgColor,
      showInfoIcon = _ref.showInfoIcon,
      locationFetchingDataV3 = _ref.locationFetchingDataV3,
      sendCrossSellPdtEvent = _ref.sendCrossSellPdtEvent,
      reloadTripHandler = _ref.reloadTripHandler,
      showEffectiveRateBanner = _ref.showEffectiveRateBanner,
      effectiveRateBannerLabel = _ref.effectiveRateBannerLabel,
      effectiveRateIconHandler = _ref.effectiveRateIconHandler,
      showPriceTicker = _ref.showPriceTicker,
      priceTickerData = _ref.priceTickerData,
      viewAllPriceHandler = _ref.viewAllPriceHandler,
      desktopLandingTitle = _ref.desktopLandingTitle,
      pricingNudge = _ref.pricingNudge,
      deliveryNudge = _ref.deliveryNudge;
  var device = useDevice();
  var host = getHostName();

  var _useState = useState(true),
      tickedIdModalOpen = _useState[0],
      setTicketIdModalOpen = _useState[1];

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner,
      isLoggedInUser = _useGlobalConfig.isLoggedInUser,
      mobileNumberRequiredError = _useGlobalConfig.mobileNumberRequiredError;

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      _useGlobalSelector$be = _useGlobalSelector.best_rate_hyperlink,
      best_rate_hyperlink = _useGlobalSelector$be === void 0 ? "" : _useGlobalSelector$be;

  var _useState2 = useState(false),
      isTicketIdEdit = _useState2[0],
      setIsTicketIdEdit = _useState2[1];

  var onBestPriceLabelClick = function onBestPriceLabelClick() {
    if (!best_rate_hyperlink) return;
    window.location.href = best_rate_hyperlink;
  };

  var _ref2 = deliveryNudge || {},
      timer = _ref2.timer,
      order_cutoff_text = _ref2.order_cutoff_text,
      delivery_status_text = _ref2.delivery_status_text,
      tooltip_text = _ref2.tooltip_text; // For Location Fetching


  var _ref3 = locationFetchingData,
      locRenderingData = _ref3.data;
  var LandingCardComponent = LandingCardFeatureV3;

  var locationFetchingRenderer = function locationFetchingRenderer() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [(mobileStickyHeadingData === null || mobileStickyHeadingData === void 0 ? void 0 : mobileStickyHeadingData.isLoggedIn) && /*#__PURE__*/_jsx(ListingPageHeader, TopShowcaseV3_objectSpread({}, mobileStickyHeadingData)), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        flex: "1",
        alignItems: "center",
        width: "auto",
        height: "auto",
        children: [/*#__PURE__*/_jsxs(LocationLoadingCtr, {
          children: [/*#__PURE__*/_jsx(LocationLoading, {
            children: /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(AbsIconContainer, {
                children: (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) === "ERROR" || (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) === "SUCCESS" ? locRenderingData !== null && locRenderingData !== void 0 && locRenderingData.fetchedData.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
                  src: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.iconSrc
                }) : /*#__PURE__*/_jsx(LocationMarkerWithCheck, {}) : locRenderingData !== null && locRenderingData !== void 0 && locRenderingData.fetchingData.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
                  src: locRenderingData.fetchingData.iconSrc
                }) : /*#__PURE__*/_jsx(LocationFetchingIcon, {})
              }), (locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchingData.loadingGifSrc) && /*#__PURE__*/_jsx(FadeImg, {
                showAnim: (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING",
                children: /*#__PURE__*/_jsx(ImageTag, {
                  src: locRenderingData.fetchingData.loadingGifSrc
                })
              })]
            })
          }), (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING" && (locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.label) && /*#__PURE__*/_jsx(MoveUpAnimation, {
            children: /*#__PURE__*/_jsx(DeliveryPersuasion, {
              bgColor: "",
              fontSize: "md",
              padding: "0px",
              text: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.label,
              styleWithFlex: false,
              isTextCenter: true,
              ctaText: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.ctaText,
              editLocationHandler: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.ctaHandler,
              showIcon: locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.fetchedData.showDeliveryIcon,
              version: version
            })
          }), !!(locRenderingData !== null && locRenderingData !== void 0 && locRenderingData.fetchingData.label) && /*#__PURE__*/_jsx(MoveUpAndScale, {
            showAnim: (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING",
            children: /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "md" // margin="16px 0px 0px"
              ,
              color: theme.blackText,
              children: locRenderingData.fetchingData.label
            })
          })]
        }), (locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.locFetchingMode) !== "FETCHING" && (locRenderingData === null || locRenderingData === void 0 ? void 0 : locRenderingData.conditionsText) && /*#__PURE__*/_jsx(ConditionsText, {
          isFadeIn: true,
          children: /*#__PURE__*/_jsxs(ParaTag, {
            fontSize: "xs",
            color: theme.greyText,
            margin: "0 0 20px 0",
            children: [!!locRenderingData.conditionsText.greenText && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: theme.greenText,
              children: locRenderingData.conditionsText.greenText
            }), " ", !!locRenderingData.conditionsText.normalText && locRenderingData.conditionsText.normalText]
          })
        })]
      })]
    });
  };

  var mobileViewRenderer = function mobileViewRenderer() {
    var _pinnedShowcaseCardDa, _otherShowcaseCardsDa, _pinnedShowcaseCardDa2, _pinnedShowcaseCardDa3, _otherShowcaseCardsDa2, _otherShowcaseCardsDa3, _otherShowcaseCardsDa4;

    var specialAttentionPadding = function specialAttentionPadding(item) {
      var _item$program_details;

      return (item === null || item === void 0 ? void 0 : (_item$program_details = item.program_details) === null || _item$program_details === void 0 ? void 0 : _item$program_details.type) === PROGRAM_DETAILS_ENUM.FREE_CARD ? "40px 16px 16px 16px" : device === "lg" ? "24px" : "16px";
    };

    return /*#__PURE__*/_jsx(Fragment, {
      children: locationFetchingData !== null && locationFetchingData !== void 0 && locationFetchingData.isLocationFetching ? locationFetchingRenderer() : /*#__PURE__*/_jsxs(MobileViewListingProductCardContainer, {
        children: [mobileStickyHeadingData && /*#__PURE__*/_jsx(ListingPageHeader, TopShowcaseV3_objectSpread({}, mobileStickyHeadingData)), /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          moveFromDistance: "50px",
          delay: "0s",
          moveDelay: "0s",
          zIndex: 2,
          children: /*#__PURE__*/_jsxs(FlexComp, {
            flexDirection: "column",
            padding: "0px 16px",
            width: "auto",
            height: "auto",
            margin: "0px 0px 12px",
            children: [mobileTitle && (version === VERSIONS.V3 ? /*#__PURE__*/_jsx(H4Tag, {
              id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.HEADING),
              as: "h1",
              children: mobileTitle
            }) : /*#__PURE__*/_jsx(CliptextStyle, {
              id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.HEADING),
              children: /*#__PURE__*/_jsx(H4Tag, {
                children: mobileTitle
              })
            })), !(locationFetchingData !== null && locationFetchingData !== void 0 && locationFetchingData.isLocationFetching) && (pinnedShowcaseCardData === null || pinnedShowcaseCardData === void 0 ? void 0 : (_pinnedShowcaseCardDa = pinnedShowcaseCardData.data) === null || _pinnedShowcaseCardDa === void 0 ? void 0 : _pinnedShowcaseCardDa.length) && !(otherShowcaseCardsData !== null && otherShowcaseCardsData !== void 0 && (_otherShowcaseCardsDa = otherShowcaseCardsData.data) !== null && _otherShowcaseCardsDa !== void 0 && _otherShowcaseCardsDa.length) && deliveryPersuasion && /*#__PURE__*/_jsxs(FadeInAnimation, {
              delay: "0s",
              children: [/*#__PURE__*/_jsx(DeliveryPersuasion, TopShowcaseV3_objectSpread({
                fontSize: "sm",
                padding: "0px",
                bgColor: "",
                margin: "16px 0px 0px 0px"
              }, deliveryPersuasion)), /*#__PURE__*/_jsx(OrderTime, {
                orderCutOffText: order_cutoff_text,
                startHours: (timer === null || timer === void 0 ? void 0 : timer.hours) || 0,
                startMinutes: (timer === null || timer === void 0 ? void 0 : timer.minutes) || 0,
                toolTipInfo: tooltip_text
              }), /*#__PURE__*/_jsx(DeliveryStatusListingTop, {
                children: /*#__PURE__*/_jsx(DeliveryStatusText, {
                  text: delivery_status_text
                })
              })]
            }) || /*#__PURE__*/_jsx(_Fragment, {})]
          })
        }), marqueeData && !isMarqueeOnBottom && /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          delay: "0.25s",
          moveDelay: "0s",
          moveFromDistance: "100px",
          children: /*#__PURE__*/_jsx(MarqueeBanner, {
            LIVETagImgURI: marqueeData.LIVETagImgURI,
            isLoading: marqueeData.isLoading,
            padding: marqueeData.isLoading ? "8px 0px" : undefined,
            loadingText: "Fetching LIVE Rates",
            margin: device === "lg" ? "0px 0px 16px" : "0px 16px 16px",
            marqueeData: marqueeData.data,
            version: version
          })
        }), isShowDiscountBanner && /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          delay: "0s",
          moveDelay: "0s",
          moveFromDistance: "100px",
          children: /*#__PURE__*/_jsx(DiscountBanner, {
            alignItems: "flex-start",
            bgColor: theme.greenText2,
            discountImg: discountBanner.imgSrc,
            label: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.label,
            subLabel: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.subLabel,
            onPressHandler: discountOfferHandler,
            showIcon: true,
            margin: "0px 16px 18px",
            color: theme.darkGreen,
            width: "calc(100% - 32px)",
            height: "fit-content",
            infoIconHandler: discountInfoIconHandler,
            showInfoIcon: showInfoIcon,
            subLabelColor: "#1E5C43",
            infoIconColor: theme.blueText,
            iconColor: theme.greyText,
            fontWeight: "400"
          })
        }), showPriceTicker && /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          delay: "0s",
          moveDelay: "0s",
          moveFromDistance: "100px",
          children: /*#__PURE__*/_jsx(ClubOfferBanner, {
            bestPriceLabel: "Lowest Rate Guarantee",
            priceTickerData: priceTickerData,
            viewAllPriceHandler: viewAllPriceHandler,
            onBestPriceLabelClick: onBestPriceLabelClick
          })
        }), showEffectiveRateBanner && /*#__PURE__*/_jsx(FadeInAndMoveUpAnimation, {
          delay: "0s",
          moveDelay: "0s",
          moveFromDistance: "100px",
          children: /*#__PURE__*/_jsx(DiscountBanner, {
            alignItems: "center",
            bgColor: "linear-gradient(90deg, #E4FBF4 0%, #FFFFFF 100%)",
            label: effectiveRateBannerLabel,
            margin: "4px 0px 18px",
            color: theme.greyText,
            width: "100%",
            height: "fit-content",
            infoIconHandler: effectiveRateIconHandler,
            showInfoIcon: true,
            infoIconColor: theme.greyText,
            fontWeight: "400",
            borderRadius: "0",
            padding: "8px 16px"
          })
        }), /*#__PURE__*/_jsxs(MarkerContainer, {
          moveFromDistance: "150px",
          delay: "0.5s",
          moveDelay: "0s",
          children: [pinnedShowcaseCardData && (pinnedShowcaseCardData === null || pinnedShowcaseCardData === void 0 ? void 0 : (_pinnedShowcaseCardDa2 = pinnedShowcaseCardData.data) === null || _pinnedShowcaseCardDa2 === void 0 ? void 0 : _pinnedShowcaseCardDa2.length) > 0 && /*#__PURE__*/_jsx(_Fragment, {
            children: pinnedShowcaseCardData && pinnedShowcaseCardData.data.map(function (item) {
              var _item$program_details2, _item$program_details3;

              return /*#__PURE__*/_jsx(SpecialAttention, {
                withShadow: true,
                children: /*#__PURE__*/_jsxs(FlexComp, {
                  padding: (item === null || item === void 0 ? void 0 : (_item$program_details2 = item.program_details) === null || _item$program_details2 === void 0 ? void 0 : _item$program_details2.type) === PROGRAM_DETAILS_ENUM.FREE_CARD ? "40px 16px 16px 16px" : device === "lg" ? "24px" : "16px",
                  width: "auto",
                  height: "auto",
                  children: [/*#__PURE__*/_jsx(LandingCardComponent, {
                    reloadTripHandler: reloadTripHandler,
                    data: item,
                    onClick: pinnedShowcaseCardData.onClick,
                    loadCurrenyBtnHandler: loadCurrenyBtnHandler,
                    recommendedBtnHandler: recommendedBtnHandler,
                    startFromWhereLeftHandler: startFromWhereLeftHandler,
                    docsPendingHandler: docsPendingHandler,
                    onClickAnotherLocation: onClickAnotherLocation,
                    viewDashBoardClickHandler: viewDashBoardClickHandler,
                    viewOrdersClickHandler: viewOrdersClickHandler,
                    isInfoOnRightSide: false,
                    deliveryUnavailbleClickHandler: deliveryUnavailbleClickHandler,
                    startOrderClicked: startOrderClicked,
                    sendCrossSellPdtEvent: sendCrossSellPdtEvent,
                    bestRateApplicableTxt: item.showBestRate ? "Best Rate Applicable" : "" // add condition as required

                  }), (item === null || item === void 0 ? void 0 : (_item$program_details3 = item.program_details) === null || _item$program_details3 === void 0 ? void 0 : _item$program_details3.type) === PROGRAM_DETAILS_ENUM.FREE_CARD && /*#__PURE__*/_jsx(ZeroPayment, {
                    children: /*#__PURE__*/_jsx(ImageTag, {
                      src: IMAGE_URLS.ZERO_PAYMENT_FREE_CARD_IMAGE,
                      width: "108px",
                      height: "22px"
                    })
                  })]
                })
              }, item.id);
            })
          }), pinnedShowcaseCardData !== null && pinnedShowcaseCardData !== void 0 && (_pinnedShowcaseCardDa3 = pinnedShowcaseCardData.data) !== null && _pinnedShowcaseCardDa3 !== void 0 && _pinnedShowcaseCardDa3.length && otherShowcaseCardsData !== null && otherShowcaseCardsData !== void 0 && (_otherShowcaseCardsDa2 = otherShowcaseCardsData.data) !== null && _otherShowcaseCardsDa2 !== void 0 && _otherShowcaseCardsDa2.length ? /*#__PURE__*/_jsx(_Fragment, {
            children: otherProductsText && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(ParaTag, {
                fontSize: "xs",
                fontWeight: "bold",
                margin: "12px 0px 0px",
                color: theme.greyText,
                children: otherProductsText
              }), deliveryPersuasion && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(DeliveryPersuasion, TopShowcaseV3_objectSpread(TopShowcaseV3_objectSpread({
                  fontSize: "sm",
                  padding: "0px",
                  bgColor: "",
                  margin: "-12px 0px 0px 0px"
                }, deliveryPersuasion), {}, {
                  showDivider: false
                })), /*#__PURE__*/_jsx(OrderTimeListingWrapper, {
                  children: /*#__PURE__*/_jsx(OrderTime, {
                    orderCutOffText: order_cutoff_text,
                    startHours: (timer === null || timer === void 0 ? void 0 : timer.hours) || 0,
                    startMinutes: (timer === null || timer === void 0 ? void 0 : timer.minutes) || 0,
                    toolTipInfo: tooltip_text
                  })
                }), /*#__PURE__*/_jsx(DeliveryStatusText, {
                  text: delivery_status_text
                })]
              })]
            })
          }) : null, otherShowcaseCardsData && (otherShowcaseCardsData === null || otherShowcaseCardsData === void 0 ? void 0 : (_otherShowcaseCardsDa3 = otherShowcaseCardsData.data) === null || _otherShowcaseCardsDa3 === void 0 ? void 0 : _otherShowcaseCardsDa3.length) > 0 ? otherShowcaseCardsData && (otherShowcaseCardsData === null || otherShowcaseCardsData === void 0 ? void 0 : (_otherShowcaseCardsDa4 = otherShowcaseCardsData.data) === null || _otherShowcaseCardsDa4 === void 0 ? void 0 : _otherShowcaseCardsDa4.map(function (item, idx) {
            var _item$program_details4;

            return /*#__PURE__*/_jsx(SpecialAttention, {
              withShadow: true,
              children: /*#__PURE__*/_jsxs(FlexComp, {
                padding: specialAttentionPadding(item),
                width: "auto",
                height: "auto",
                children: [/*#__PURE__*/_jsx(LandingCardComponent, {
                  reloadTripHandler: reloadTripHandler,
                  isInfoOnRightSide: false,
                  data: item,
                  onClick: otherShowcaseCardsData.itemHandler,
                  loadCurrenyBtnHandler: loadCurrenyBtnHandler,
                  recommendedBtnHandler: recommendedBtnHandler,
                  startFromWhereLeftHandler: startFromWhereLeftHandler,
                  docsPendingHandler: docsPendingHandler,
                  onClickAnotherLocation: onClickAnotherLocation,
                  viewDashBoardClickHandler: viewDashBoardClickHandler,
                  viewOrdersClickHandler: viewOrdersClickHandler,
                  deliveryUnavailbleClickHandler: deliveryUnavailbleClickHandler,
                  startOrderClicked: startOrderClicked,
                  sendCrossSellPdtEvent: sendCrossSellPdtEvent,
                  bestRateApplicableTxt: item.showBestRate ? "Best Rate Applicable" : ""
                }, (item === null || item === void 0 ? void 0 : item.id) || idx), (item === null || item === void 0 ? void 0 : (_item$program_details4 = item.program_details) === null || _item$program_details4 === void 0 ? void 0 : _item$program_details4.type) === PROGRAM_DETAILS_ENUM.FREE_CARD && /*#__PURE__*/_jsx(ZeroPayment, {
                  children: /*#__PURE__*/_jsx(ImageTag, {
                    src: IMAGE_URLS.ZERO_PAYMENT_FREE_CARD_IMAGE,
                    width: "108px",
                    height: "22px"
                  })
                })]
              })
            });
          })) : /*#__PURE__*/_jsx(_Fragment, {})]
        }), /*#__PURE__*/_jsx(FixedBottomContainer, {
          children: /*#__PURE__*/_jsx(PriceHikeWarning, {
            text: pricingNudge === null || pricingNudge === void 0 ? void 0 : pricingNudge.text,
            info: pricingNudge === null || pricingNudge === void 0 ? void 0 : pricingNudge.info
          })
        })]
      })
    });
  };

  var desktopViewHandler = function desktopViewHandler() {
    var ticketId = getSessionStorageItem(SESSION_STORAGE_KEYS.TICKET_ID, true);
    var isShowTicket = ticketId && isPartnerHost(SOURCE.FOREX_EXPERT);
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [isShowTicket && /*#__PURE__*/_jsxs(FlexComp, {
        margin: "0px auto 20px auto",
        width: "1200px",
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          color: "#fff",
          fontSize: "md",
          children: [/*#__PURE__*/_jsxs(SpanTag, {
            fontWeight: "bold",
            color: "#fff",
            children: [" ", "Ticket ID:", " "]
          }), /*#__PURE__*/_jsx(SpanTag, {
            color: "#fff",
            margin: "0 10px 0 0",
            children: ticketId
          })]
        }), /*#__PURE__*/_jsx(Cta, {
          onClick: function onClick() {
            setIsTicketIdEdit(true);
          },
          children: "Change Ticket ID"
        })]
      }), /*#__PURE__*/_jsx(BMFListingContainer, {
        margin: "0px auto 20px auto",
        children: /*#__PURE__*/_jsx(FlexComp, {
          padding: "24px 24px 48px 24px",
          minHeight: "200px",
          flexDirection: "column",
          justifyContent: "center",
          width: "auto",
          height: "auto",
          children: otherShowcaseCardsData !== null && otherShowcaseCardsData !== void 0 && otherShowcaseCardsData.isLoading ? /*#__PURE__*/_jsxs(FlexComp, {
            padding: "0px",
            alignItems: "center" // justifyContent="center"
            ,
            flexDirection: "column",
            width: "auto",
            height: "auto",
            children: [otherShowcaseCardsData.loadingImgSrc && /*#__PURE__*/_jsx(ImageTag, {
              width: "56px",
              src: otherShowcaseCardsData.loadingImgSrc
            }), !!otherShowcaseCardsData.loadingText && /*#__PURE__*/_jsx(ParaTag, {
              fontWeight: "bold",
              children: otherShowcaseCardsData.loadingText
            })]
          }) : /*#__PURE__*/_jsxs(Fragment, {
            children: [!showPriceTicker && /*#__PURE__*/_jsxs(FlexComp, {
              gap: version === VERSIONS.V3 ? "0px" : "6px",
              padding: "0px",
              alignItems: "center",
              justifyContent: version === VERSIONS.V3 ? "space-between" : "center",
              margin: "".concat(host === HOST.MAKEMYTRIP ? "40px" : "0px", " 0px 24px 0px"),
              width: "auto",
              height: "auto",
              children: [/*#__PURE__*/_jsxs(FlexComp, {
                gap: "6px",
                flexDirection: "row",
                alignItems: "unset",
                margin: "0px",
                padding: "unset",
                width: "unset",
                height: "unset",
                children: [(landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textOne) && /*#__PURE__*/_jsx(H5Tag, {
                  children: landingTitle.textOne
                }), (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textTwo) && (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textThree) && (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textFour) && /*#__PURE__*/_jsxs(ParaTag // margin="4px 0px 0px"
                , {
                  color: theme.greyText,
                  fontSize: "large",
                  children: [landingTitle.textTwo, " ", /*#__PURE__*/_jsx(SpanTag, {
                    color: theme.greenText,
                    fontSize: "large",
                    fontWeight: "bold",
                    children: landingTitle.textThree
                  }), " ", landingTitle.textFour, " "]
                })]
              }), viewOrderLabel && version === VERSIONS.V3 && /*#__PURE__*/_jsxs(FlexComp, {
                gap: "4px",
                flexDirection: "row",
                margin: "0px",
                padding: "unset",
                alignItems: "center",
                width: "unset",
                height: "unset",
                children: [/*#__PURE__*/_jsx(AnchorTag, {
                  fontSize: "sm",
                  fontWeight: "bold",
                  onClick: function onClick() {
                    return viewOrdersClickHandler({
                      label: "view_order_listing_header",
                      version: VERSIONS.V3
                    });
                  },
                  children: viewOrderLabel
                }), /*#__PURE__*/_jsx(ArrowIcon, {})]
              })]
            }), isShowDiscountBanner && /*#__PURE__*/_jsx(DiscountBanner, {
              alignItems: "center",
              fontSize: "sm",
              bgColor: theme.greenText2,
              discountImg: discountBanner.imgSrc,
              label: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.label,
              subLabel: discountBanner === null || discountBanner === void 0 ? void 0 : discountBanner.subLabel,
              onPressHandler: discountOfferHandler,
              showIcon: true,
              margin: "0px 0px 18px",
              color: theme.darkGreen,
              fontWeight: "400",
              iconColor: theme.greyText,
              width: "fit-content",
              infoIconHandler: discountInfoIconHandler,
              showInfoIcon: showInfoIcon
            }), showPriceTicker && /*#__PURE__*/_jsx(ClubOfferBanner, {
              priceTickerData: priceTickerData,
              viewAllPriceHandler: viewAllPriceHandler,
              bestPriceLabel: "Lowest Rate Guarantee",
              desktopLandingTitle: desktopLandingTitle,
              bestRateHyperlink: best_rate_hyperlink
            }), otherShowcaseCardsData && /*#__PURE__*/_jsx(LandingCardFeatureCtr, {
              version: version,
              children: otherShowcaseCardsData.data.map(function (item, index) {
                return /*#__PURE__*/_jsx(LandingCardComponent, {
                  reloadTripHandler: reloadTripHandler,
                  isInfoOnRightSide: otherShowcaseCardsData.showInfoOnRightSideInCards,
                  data: item,
                  idx: index,
                  padding: "16px",
                  border: "1px #e2e2e2 solid",
                  onClick: otherShowcaseCardsData.itemHandler,
                  loadCurrenyBtnHandler: loadCurrenyBtnHandler,
                  recommendedBtnHandler: recommendedBtnHandler,
                  startFromWhereLeftHandler: startFromWhereLeftHandler,
                  docsPendingHandler: docsPendingHandler,
                  onClickAnotherLocation: onClickAnotherLocation,
                  viewDashBoardClickHandler: viewDashBoardClickHandler,
                  viewOrdersClickHandler: viewOrdersClickHandler,
                  startOrderClicked: startOrderClicked,
                  deliveryUnavailbleClickHandler: deliveryUnavailbleClickHandler,
                  sendCrossSellPdtEvent: sendCrossSellPdtEvent,
                  bestRateApplicableTxt: item.showBestRate ? "Best Rate Applicable" : ""
                }, index);
              })
            }), iconTextTag && /*#__PURE__*/_jsx(IconTextTag, {
              margin: "8px 0px 0px",
              label: iconTextTag.label,
              subLabel: iconTextTag.subLabel,
              onClick: iconTextTag.btnHandler
            }), /*#__PURE__*/_jsxs(EffectiveRateContainer, {
              showEffectiveBanner: showEffectiveRateBanner,
              children: [showEffectiveRateBanner ? /*#__PURE__*/_jsx(DiscountBanner, {
                alignItems: "center",
                bgColor: "linear-gradient(90deg, #E4FBF4 0%, #FFFFFF 100%)",
                label: effectiveRateBannerLabel,
                color: theme.greyText,
                margin: "0px 0px 0px",
                height: "fit-content",
                infoIconHandler: effectiveRateIconHandler,
                showInfoIcon: true,
                infoIconColor: theme.greyText,
                fontWeight: "400"
              }) : /*#__PURE__*/_jsx(_Fragment, {}), viewOrderLabel && version === VERSIONS.V3 && /*#__PURE__*/_jsxs(FlexComp, {
                gap: "4px",
                flexDirection: "row",
                margin: "0px",
                padding: "0px",
                alignItems: "center",
                width: "unset",
                height: "unset",
                children: [/*#__PURE__*/_jsx(AnchorTag, {
                  fontSize: "sm",
                  fontWeight: "bold",
                  onClick: function onClick() {
                    return viewOrdersClickHandler({
                      label: "view_order_listing_header",
                      version: VERSIONS.V3
                    });
                  },
                  children: viewOrderLabel
                }), /*#__PURE__*/_jsx(ArrowIcon, {})]
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(PriceHikeWarningWrapper, {
        children: /*#__PURE__*/_jsx(PriceHikeWarning, {
          text: pricingNudge === null || pricingNudge === void 0 ? void 0 : pricingNudge.text,
          info: pricingNudge === null || pricingNudge === void 0 ? void 0 : pricingNudge.info
        })
      }), marqueeData && !isMarqueeOnBottom && /*#__PURE__*/_jsx(MarqueeBanner, {
        margin: "24px 0px 0px",
        isLoading: marqueeData.isLoading,
        padding: marqueeData.isLoading ? device === "lg" ? "11px 24px" : device === "sm" ? "8px 16px" : undefined : device === "lg" ? "4px 0px" : undefined,
        marqueeData: marqueeData.data,
        LIVETagImgURI: marqueeData.LIVETagImgURI,
        loadingText: marqueeData.loadingText,
        version: version
      })]
    });
  };

  var shouldOpenTickerIdModal = function shouldOpenTickerIdModal() {
    var ticketId = getSessionStorageItem(SESSION_STORAGE_KEYS.TICKET_ID, true);
    return tickedIdModalOpen && isLoggedInUser && isPartnerHost(SOURCE.FOREX_EXPERT) && !ticketId;
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [device ? /*#__PURE__*/_jsx(ListingTopContainer, {
      fullPageHeight: true,
      bgImage: sectionBgImgURI,
      isPageLoading: isPageLoading,
      isLocationFetching: locationFetchingData === null || locationFetchingData === void 0 ? void 0 : locationFetchingData.isLocationFetching,
      version: version,
      children: isPageLoading && device === "sm" && !(locationFetchingData !== null && locationFetchingData !== void 0 && locationFetchingData.isLocationFetching) ? /*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        flexDirection: "column",
        width: "auto",
        height: "auto",
        children: [isPageLoadingGif && /*#__PURE__*/_jsx(GifContainer, {
          children: /*#__PURE__*/_jsx(ImageTag, {
            src: isPageLoadingGif,
            width: "48px"
          })
        }), isPageLoadingText && /*#__PURE__*/_jsx(ParaTag, {
          margin: "90px 0px 0px",
          fontSize: "md",
          color: theme.blackText,
          children: isPageLoadingText
        })]
      }) : device === "lg" ? desktopViewHandler() : mobileViewRenderer()
    }) : /*#__PURE__*/_jsx(Fragment, {}), (shouldOpenTickerIdModal() || isTicketIdEdit) && /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(PageLoader, {}),
      children: /*#__PURE__*/_jsx(TicketIDModal, {
        onModalClose: function onModalClose() {
          return setTicketIdModalOpen(false);
        },
        modalInfo: "Required to fetch the order information!",
        modalHeading: "Ticket ID"
      })
    })]
  });
};

/* harmony default export */ var ListingPageComponents_TopShowcaseV3 = ((/* unused pure expression or super */ null && (TopShowcaseV3_TopShowcaseV3)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useForexWidgetProps/index.tsx



function useForexWidgetProps_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useForexWidgetProps_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useForexWidgetProps_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useForexWidgetProps_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var useForexWidgetProps_useForexWidgetProps = function useForexWidgetProps() {
  var _versionHandlers;

  var device = useDevice();

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      forex_rates = _useGlobalSelector.forex_rates,
      persona = _useGlobalSelector.persona,
      _useGlobalSelector$pr = _useGlobalSelector.products,
      products = _useGlobalSelector$pr === void 0 ? [] : _useGlobalSelector$pr,
      delivery_details = _useGlobalSelector.delivery_details,
      isErrorDeliveryDetails = _useGlobalSelector.isErrorDeliveryDetails,
      version = _useGlobalSelector.version;

  var deliveryDetailsContent = useMemo(function () {
    var host = getHostName();

    if (host !== HOST.MAKEMYTRIP) {
      return getDeliveryDetailsContent(useForexWidgetProps_objectSpread({}, delivery_details), isErrorDeliveryDetails, version);
    } else {
      return null;
    }
  }, [delivery_details, isErrorDeliveryDetails, version]);
  var deliveryDetailsContentV3 = useMemo(function () {
    var host = getHostName();

    if (host !== HOST.MAKEMYTRIP) {
      return getDeliveryDetailsContent(useForexWidgetProps_objectSpread({}, delivery_details), isErrorDeliveryDetails, VERSIONS.V2);
    } else {
      return null;
    }
  }, [delivery_details, isErrorDeliveryDetails, version]);
  useEffect(function () {
    if (products !== null && products !== void 0 && products.length) {
      persistSpecificParamInCookie(COOKIES.CURRENCY_DEEPLOGIN_ALLOWED, String(true), {
        path: "/",
        domain: MMT_SUB_DOMAIN
      });
      persistSpecificParamInCookie(COOKIES.CURRENCY_DEEPLOGIN_ALLOWED, String(true), {
        path: "/",
        domain: GI_SUB_DOMAIN
      });
    }
  }, [products]); // Ticker data preparation.

  var tickerData = useMemo(function () {
    return getTickerData(forex_rates);
  }, [forex_rates]);

  var prepareCards = function prepareCards(products, device, version, persona) {
    // TODO - will remove after migration to v3 is done
    var pinnedCards = preparePinnedForexCardsMobile(products, device, version);

    var _prepareForexCardsV = prepareForexCardsV3(products, device, version, persona),
        _prepareForexCardsV2 = _slicedToArray(_prepareForexCardsV, 2),
        pinnedCardsV2 = _prepareForexCardsV2[0],
        cardsV2 = _prepareForexCardsV2[1];

    var cards = device === "lg" ? prepareForexCardsForDesktop(products, device, version) : prepareNonPinnedForexCardsMobile(products, device, version);
    return {
      pinnedCards: pinnedCards,
      pinnedCardsV2: pinnedCardsV2,
      cards: cards,
      cardsV2: cardsV2
    };
  };

  var _useMemo = useMemo(function () {
    return prepareCards(products, device, version, persona);
  }, [products, device, version, persona]),
      pinnedCards = _useMemo.pinnedCards,
      pinnedCardsV2 = _useMemo.pinnedCardsV2,
      cards = _useMemo.cards,
      cardsV2 = _useMemo.cardsV2;

  var versionHandlers = (_versionHandlers = {}, _defineProperty(_versionHandlers, VERSIONS.V3, {
    landingPinnedCardShowcaseData: pinnedCardsV2,
    landingCardShowcaseData: cardsV2
  }), _defineProperty(_versionHandlers, VERSIONS.V2, {
    landingPinnedCardShowcaseData: pinnedCards,
    landingCardShowcaseData: cards
  }), _defineProperty(_versionHandlers, "default", {
    landingPinnedCardShowcaseData: pinnedCards,
    landingCardShowcaseData: cards
  }), _versionHandlers);
  var _versionHandlers2 = versionHandlers[version || VERSIONS.V2],
      landingPinnedCardShowcaseData = _versionHandlers2.landingPinnedCardShowcaseData,
      landingCardShowcaseData = _versionHandlers2.landingCardShowcaseData;
  var mobileTitle = getMobileTitle(persona, device);
  return {
    mobileTitle: mobileTitle,
    showTickerAtBottomInMobile: false,
    landingPinnedCardShowcaseData: landingPinnedCardShowcaseData,
    landingCardShowcaseData: landingCardShowcaseData,
    deliveryDetailsContent: deliveryDetailsContent,
    version: version || VERSIONS.V2,
    deliveryDetailsContentV3: deliveryDetailsContentV3
  };
};

/* harmony default export */ var hooks_useForexWidgetProps = ((/* unused pure expression or super */ null && (useForexWidgetProps_useForexWidgetProps)));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/global-style/index.style.ts


var _templateObject;


var index_style_GlobalStyles = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([" \nhtml,\nbody {\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  background: #fff;\n  color: #022135;\n  font-size: 16px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n}\n\n*,\nhtml {\n  box-sizing: border-box;\n  scroll-behavior: smooth;\n}\nimg {\n  max-width: 100%;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\na {\n  color: #008cff;\n  text-decoration: none;\n  cursor: pointer;\n}\na:hover,\na:focus {\n  text-decoration: none;\n  outline: none;\n}\ncode {\n  font-family: lato;\n}\n\ninput, textarea, button {font-family: inherit; border: none; outline: none;}\n\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v28/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v28/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: 100%;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 500;\n  font-stretch: 100%;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-stretch: 100%;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-stretch: 100%;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXiWtFCc.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n  @font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwiPGQ3q5d0.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFV0U1dYPFkZVO.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-4I-FV0U1dYPFkZVO.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* @font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-ro-FV0U1dYPFkZVO.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n} */\n"])));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ErrorScreen/ErrorScreen.style.ts
var ErrorScreen_style = __webpack_require__(3256);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/api/fetchApi.ts
var fetchApi = __webpack_require__(5859);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/authUtils.ts
var authUtils = __webpack_require__(277);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalDispatch.ts
var hooks_useGlobalDispatch = __webpack_require__(3211);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useListingPdtLoggerV2/index.ts
var hooks_useListingPdtLoggerV2 = __webpack_require__(2221);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts + 3 modules
var usePdtLogger = __webpack_require__(761);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useFetchCardCtaSignalState/index.ts




function useFetchCardCtaSignalState_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFetchCardCtaSignalState_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFetchCardCtaSignalState_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFetchCardCtaSignalState_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var useFetchCardCtaSignalState_useFetchCardCtaSignalState = function useFetchCardCtaSignalState() {
  var dispatch = useGlobalDispatch();

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state || {};
  }),
      isLoadingCardCtaSignalState = _useGlobalSelector.isLoadingCardCtaSignalState,
      isErrorCardCtaSignalState = _useGlobalSelector.isErrorCardCtaSignalState,
      isSuccessCardCtaSignalState = _useGlobalSelector.isSuccessCardCtaSignalState;

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtListingError = _useListingPdtLogger.sendPdtListingError,
      sendPdtLoginPopOpen = _useListingPdtLogger.sendPdtLoginPopOpen;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtListingErrorV2 = _useListingPdtLoggerV.sendPdtListingErrorV2;

  var _useListingPdtLoggerV2 = useListingPdtLoggerV2(),
      sendCTAData = _useListingPdtLoggerV2.sendCTAData;

  var sendPdtLoginPopupOpenV2 = function sendPdtLoginPopupOpenV2() {
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.LOGIN_POP_UP_OPEN
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  var fetchCardCtaSignalState = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(card_type, reqId) {
      var ctaStateUrl, headers, response, success, data, error, _ref2, code, _e$message, _e$message2, _error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(loadingCardCtaSignalState());
              ctaStateUrl = getCardCtaSignalStateUrl({
                partner: partner,
                card_type: card_type
              });
              _context.prev = 2;
              headers = {};

              if (getHostName() !== HOST.MAKEMYTRIP) {
                headers = useFetchCardCtaSignalState_objectSpread({}, getRequestIdHeaders(reqId));
              }

              _context.next = 7;
              return fetchApiForexListing(ctaStateUrl, {
                method: "GET",
                headers: useFetchCardCtaSignalState_objectSpread({}, getRequestIdHeaders(reqId))
              });

            case 7:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 10;
                break;
              }

              _context.t0 = {};

            case 10:
              response = _context.t0;
              success = response.success, data = response.data, error = response.error;

              if (!success) {
                _context.next = 17;
                break;
              }

              dispatch(fetchingCardCtaSignalState(data, {
                card_type: card_type
              }));
              return _context.abrupt("return", response);

            case 17:
              _ref2 = error || {}, code = _ref2.code;

              if (!(code === "LOGIN_REQUIRED")) {
                _context.next = 24;
                break;
              }

              dispatch(errorCardCtaSignalState(error));
              _context.next = 22;
              return loginInPartner(sendPdtLoginPopOpen, sendPdtLoginPopupOpenV2);

            case 22:
              _context.next = 25;
              break;

            case 24:
              dispatch(errorCardCtaSignalState(error, {
                card_type: card_type
              }));

            case 25:
              sendPdtListingError(error, ERROR_MSGS.CARD_CTA_API_ERROR);
              sendPdtListingErrorV2(error, ERROR_MSGS.CARD_CTA_API_ERROR);
              return _context.abrupt("return", error);

            case 28:
              _context.next = 37;
              break;

            case 30:
              _context.prev = 30;
              _context.t1 = _context["catch"](2);
              _error = {
                success: false,
                apiUrl: ctaStateUrl,
                code: _context.t1 !== null && _context.t1 !== void 0 && (_e$message = _context.t1.message) !== null && _e$message !== void 0 && _e$message.includes(ERROR_MSGS.FETCH_ERROR) ? ERROR_CODE_CONST.NETWORK : "",
                description: _context.t1 !== null && _context.t1 !== void 0 && (_e$message2 = _context.t1.message) !== null && _e$message2 !== void 0 && _e$message2.includes(ERROR_MSGS.FETCH_ERROR) ? ERROR_MSGS.FETCH_ERROR : _context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message
              };
              dispatch(errorCardCtaSignalState(_error));
              sendPdtListingError(_error);
              sendPdtListingErrorV2(_error);
              return _context.abrupt("return", _error);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 30]]);
    }));

    return function fetchCardCtaSignalState(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    isLoadingCardCtaSignalState: isLoadingCardCtaSignalState,
    isSuccessCardCtaSignalState: isSuccessCardCtaSignalState,
    isErrorCardCtaSignalState: isErrorCardCtaSignalState,
    fetchCardCtaSignalState: fetchCardCtaSignalState
  };
};

/* harmony default export */ var hooks_useFetchCardCtaSignalState = ((/* unused pure expression or super */ null && (useFetchCardCtaSignalState_useFetchCardCtaSignalState)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useOpenLoginForm/index.ts
var hooks_useOpenLoginForm = __webpack_require__(5426);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useRedirectForexProductsLinksV2/index.ts



function useRedirectForexProductsLinksV2_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = useRedirectForexProductsLinksV2_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function useRedirectForexProductsLinksV2_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useRedirectForexProductsLinksV2_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useRedirectForexProductsLinksV2_arrayLikeToArray(o, minLen); }

function useRedirectForexProductsLinksV2_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }










var useRedirectForexProductsLinksV2_useRedirectForexProductLinksV2 = function useRedirectForexProductLinksV2() {
  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state || {};
  }),
      products = _useGlobalSelector.products,
      version = _useGlobalSelector.version,
      feature_flag = _useGlobalSelector.feature_flag;

  var _useGlobalConfig = useGlobalConfig(),
      isLoggedInUser = _useGlobalConfig.isLoggedInUser;

  var _useFetchCardCtaSigna = useFetchCardCtaSignalState(),
      fetchCardCtaSignalState = _useFetchCardCtaSigna.fetchCardCtaSignalState;

  var _useRedirectionUrls = useRedirectionUrls(),
      productTilesRedirections = _useRedirectionUrls.productTilesRedirections;

  var _useOpenLoginForm = useOpenLoginForm(),
      openLoginFormForNonLoggedInUser = _useOpenLoginForm.openLoginFormForNonLoggedInUser;

  function redirectForexProductLinksV2(_x, _x2) {
    return _redirectForexProductLinksV.apply(this, arguments);
  }

  function _redirectForexProductLinksV() {
    _redirectForexProductLinksV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, reqId) {
      var currencyCardData, ctaObj, _ref, success, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (item !== null && item !== void 0 && item.version) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              item.feature_flag = feature_flag || {};

              if (!((item === null || item === void 0 ? void 0 : item.version) === VERSIONS.V1 || (item === null || item === void 0 ? void 0 : item.id) === CARD_TYPE.INR_CARD)) {
                _context.next = 12;
                break;
              }

              if (!isLoggedInUser) {
                _context.next = 9;
                break;
              }

              productTilesRedirections(item);
              return _context.abrupt("return");

            case 9:
              _context.next = 11;
              return openLoginFormForNonLoggedInUser();

            case 11:
              return _context.abrupt("return");

            case 12:
              currencyCardData = getCardValue(products, CARD_TYPE.CURRENCY); // Only for multicurrency card for v2.

              if (isLoggedInUser) {
                _context.next = 20;
                break;
              }

              if (!((item === null || item === void 0 ? void 0 : item.id) === CARD_TYPE.MULTI_CURRENCY_CARD)) {
                _context.next = 19;
                break;
              }

              productTilesRedirections(item);
              return _context.abrupt("return");

            case 19:
              if ((item === null || item === void 0 ? void 0 : item.id) === CARD_TYPE.CURRENCY) {
                productTilesRedirections(item);
              }

            case 20:
              ctaObj = getCtaObjectForProduct({
                products: products || [],
                productType: item.id
              }); // if (
              //     item?.id === CARD_TYPE.MULTI_CURRENCY_CARD &&
              //     getHostName() === HOST.MAKEMYTRIP &&
              //     !ctaObj
              // ) {
              //     redirectInterceptHref(
              //         `${getHostName() === HOST.MAKEMYTRIP ? "https://" + HOST.TRIPMONEY_MAKEMYTRIP : ""}/partners/mmt/forex/bmf/onboarding/landing?source=listing`
              //     );
              //     return;
              // }
              // cta object didn't come from product listing api then call fetch signal state api.

              if (!(!ctaObj && getHostName() !== HOST.MAKEMYTRIP)) {
                _context.next = 45;
                break;
              }

              _context.prev = 22;
              _context.next = 25;
              return fetchCardCtaSignalState(item.id, reqId);

            case 25:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 28;
                break;
              }

              _context.t0 = {};

            case 28:
              _ref = _context.t0;
              success = _ref.success;
              data = _ref.data;

              if (success) {
                _context.next = 33;
                break;
              }

              return _context.abrupt("return");

            case 33:
              item.feature_flag = (data === null || data === void 0 ? void 0 : data.feature_flag) || {};
              item.cta = (data === null || data === void 0 ? void 0 : data.cta) || {};
              item.cta_redirect = REDIRECTION_FLOW.NEW;
              item.version = REDIRECTION_FLOW.NEW;
              productTilesRedirections(item);
              _context.next = 43;
              break;

            case 40:
              _context.prev = 40;
              _context.t1 = _context["catch"](22);
              console.error("Fetch card cta api failed");

            case 43:
              _context.next = 46;
              break;

            case 45:
              productTilesRedirections(item);

            case 46:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[22, 40]]);
    }));
    return _redirectForexProductLinksV.apply(this, arguments);
  }

  return {
    redirectForexProductLinksV2: redirectForexProductLinksV2
  };
};

/* harmony default export */ var useRedirectForexProductsLinksV2 = ((/* unused pure expression or super */ null && (useRedirectForexProductsLinksV2_useRedirectForexProductLinksV2)));

function getCtaObjectForProduct(_ref2) {
  var products = _ref2.products,
      productType = _ref2.productType;

  var _iterator = useRedirectForexProductsLinksV2_createForOfIteratorHelper(products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;

      for (var _i = 0, _Object$entries = Object.entries(product); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (key === productType) {
          return value === null || value === void 0 ? void 0 : value.cta;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useFetchDeliveryDetails/index.ts
var hooks_useFetchDeliveryDetails = __webpack_require__(9611);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useFetchListingDetails/index.ts
var hooks_useFetchListingDetails = __webpack_require__(599);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGeolocation/index.ts + 1 modules
var useGeolocation = __webpack_require__(7327);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useManageBodyScrollForLocFetching/index.ts


var useManageBodyScrollForLocFetching_useManageBodyScrollForLocFetching = function useManageBodyScrollForLocFetching(isPageLoading, isLocationFetching) {
  var device = useDevice();
  useEffect(function () {
    if (device !== "sm") return;

    if (isPageLoading || isLocationFetching) {
      window.scrollTo({
        left: 0,
        top: 0
      });
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }

    return function () {
      document.body.style.overflow = "scroll";
    };
  }, [isPageLoading, isLocationFetching, device]);
};
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/analytics/index.ts + 6 modules
var analytics = __webpack_require__(1619);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useFetchListingPostLocationChange/index.ts
/* provided dependency */ var process = __webpack_require__(4406);




function useFetchListingPostLocationChange_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFetchListingPostLocationChange_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFetchListingPostLocationChange_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFetchListingPostLocationChange_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var MMT_FOREX_COOKIE = constants/* COOKIES.MMT_FOREX_COOKIE */.E9.MMT_FOREX_COOKIE;

var useFetchListingPostLocationChange_useFetchListingPostLocationChange = function useFetchListingPostLocationChange(isLoggedInUser, listingDetailsReqIdRef) {
  var timerRef = useRef();

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner,
      isBot = _useGlobalConfig.isBot;

  var device = useDevice();

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state || {};
  }),
      products = _useGlobalSelector.products,
      persona = _useGlobalSelector.persona,
      isSuccessDeliveryDetails = _useGlobalSelector.isSuccessDeliveryDetails,
      isLoadingDeliveryDetails = _useGlobalSelector.isLoadingDeliveryDetails,
      isErrorDeliveryDetails = _useGlobalSelector.isErrorDeliveryDetails,
      delivery_details = _useGlobalSelector.delivery_details,
      isSuccessListingDetailsOnLocChange = _useGlobalSelector.isSuccessListingDetailsOnLocChange,
      tm_user_id = _useGlobalSelector.tm_user_id,
      experiments = _useGlobalSelector.experiments;

  var _useFetchListingDetai = useFetchListingDetails(),
      fetchListingDetailsOnLocationChange = _useFetchListingDetai.fetchListingDetailsOnLocationChange;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendListingPdtLocationDetectedViewEvent = _useListingPdtLogger.sendListingPdtLocationDetectedViewEvent;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendListingPdtLocationDetectedViewEventV2 = _useListingPdtLoggerV.sendListingPdtLocationDetectedViewEventV2,
      sendPdtDataV2 = _useListingPdtLoggerV.sendPdtDataV2;

  var _ref = persona || {},
      upcomingTrip = _ref.upcoming_trip;

  var _useGeoLocation = useGeoLocation(partner),
      _useGeoLocation$locat = _useGeoLocation.location,
      latitude = _useGeoLocation$locat.latitude,
      longitude = _useGeoLocation$locat.longitude,
      isLoading = _useGeoLocation.isLoading,
      isSuccess = _useGeoLocation.isSuccess,
      isError = _useGeoLocation.isError,
      setUserLocation = _useGeoLocation.setUserLocation,
      setUserLocationIfPermitted = _useGeoLocation.setUserLocationIfPermitted;

  var userLocation = getSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, true, getSessionPiiDataOpts);
  var isProductFetched = !!(products && (products === null || products === void 0 ? void 0 : products.length) > 0);
  var host = getHostName();

  var _useState = useState(isProductFetched || host === HOST.MAKEMYTRIP ? false : !userLocation),
      isLocationFetching = _useState[0],
      setIsLocationFetching = _useState[1];

  var _useState2 = useState(isProductFetched ? false : !!userLocation || host === HOST.MAKEMYTRIP && !isProductFetched),
      isPageLoading = _useState2[0],
      setIsPageLoading = _useState2[1];

  var _useState3 = useState("FETCHING"),
      locFetchingMode = _useState3[0],
      setLocFetchingMode = _useState3[1];

  var _useState4 = useState(false),
      showEmailLoginPopup = _useState4[0],
      setShowEmailLoginPopup = _useState4[1];

  var _useState5 = useState(true),
      shouldfetchLocFromSession = _useState5[0],
      setShouldfetchLocFromSession = _useState5[1];

  useManageBodyScrollForLocFetching(isPageLoading, isLocationFetching);
  var deliveryDetailsReqIdRef = useRef(generateRequestId());
  var requestBody = process.env["NX_ENV"] === "local" ? {
    reqId: deliveryDetailsReqIdRef.current,
    latitude: 12,
    longitude: 12
  } : useFetchListingPostLocationChange_objectSpread({
    reqId: deliveryDetailsReqIdRef.current,
    latitude: latitude,
    longitude: longitude
  }, delivery_details);

  var _useFetchDeliveryDeta = useFetchDeliveryDetails(requestBody),
      fetchUserDeliveryInfo = _useFetchDeliveryDeta.fetchUserDeliveryInfo;

  useEffect(function () {
    return function () {
      return clearTimeout(timerRef.current);
    };
  }, []);
  useEffect(function () {
    var mmtRedirectionCookie = getCookie(MMT_FOREX_COOKIE, true) || "";
    if (mmtRedirectionCookie) deleteCookiesWithPrefix(MMT_FOREX_COOKIE, Object.values(SUB_DOMAIN));
  }, []);
  useEffect(function () {
    if (isSuccessListingDetailsOnLocChange) {
      trackPageLoad({
        pageName: PAGE_NAMES["LISTING"],
        partner: getPartner(),
        tmUserId: tm_user_id,
        upcomingTrip: upcomingTrip
      });
    }
  }, [partner, tm_user_id, isSuccessListingDetailsOnLocChange]);
  useEffect(function () {
    if (host === HOST.MAKEMYTRIP) {
      if (products && (products === null || products === void 0 ? void 0 : products.length) > 0) {
        setIsPageLoading(false);
      } else {
        setIsPageLoading(true);
      }
    }
  }, [products, host]);
  useEffect(function () {
    if (isBot || host === HOST.MAKEMYTRIP) {
      return;
    }

    if (userLocation && Number(userLocation === null || userLocation === void 0 ? void 0 : userLocation.eta_in_days) > 1 || device === "lg" && !isAgentFlow()) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsPageLoading(true);

                if (!(isLoggedInUser == null)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                listingDetailsReqIdRef.current = generateRequestId();
                _context.next = 6;
                return fetchListingDetailsOnLocationChange(null, userLocation, {
                  reqId: listingDetailsReqIdRef.current
                });

              case 6:
                setIsPageLoading(false);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();

      return;
    }

    var currentDate = new Date();

    if (Number(userLocation === null || userLocation === void 0 ? void 0 : userLocation.eta_in_days) === 0 && currentDate.getHours() >= 13 && currentDate.getMinutes() > 0) {
      setShouldfetchLocFromSession(false);
    }

    if (userLocation && Number(userLocation === null || userLocation === void 0 ? void 0 : userLocation.eta_in_days) === 1 && currentDate.getHours() < 13) {
      setShouldfetchLocFromSession(false);
    }

    if (device === "sm" || isAgentFlow()) {
      setUserLocationIfPermitted();
      return;
    }
  }, [device, isBot, host, isLoggedInUser]);
  useEffect(function () {
    if (host === HOST.MAKEMYTRIP) {
      setIsLocationFetching(false);
      return;
    }

    var permission_details = "";
    var location_source = "";

    if (isSuccess) {
      permission_details = "allowed";
      location_source = "app";
    }

    if (isError) {
      permission_details = "denied";
      location_source = "akamai";
    }

    if ((isError || isSuccess) && (device === "sm" || isAgentFlow())) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _response$listingData, _response$listingData2, _response$listingData3;

        var _ref4, request_id, userLocationData, userLocationSession, deliveryDetails, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setIsLocationFetching(true);

                if (!(isLoggedInUser == null)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                setLocFetchingMode("FETCHING");
                _context2.next = 6;
                return fetchUserDeliveryInfo(shouldfetchLocFromSession);

              case 6:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 9;
                  break;
                }

                _context2.t0 = {};

              case 9:
                _ref4 = _context2.t0;
                request_id = _ref4.request_id;
                userLocationData = _ref4.userLocationData;
                userLocationSession = _ref4.userLocationSession;

                if (request_id || userLocationData || userLocationSession) {
                  setLocFetchingMode("SUCCESS");
                } else {
                  setLocFetchingMode("ERROR");
                }

                timerRef.current = setTimeout(function () {
                  setIsLocationFetching(false);
                }, WAITING_TIME_LOC_SUCCESS_SCREEN);
                deliveryDetails = useFetchListingPostLocationChange_objectSpread(useFetchListingPostLocationChange_objectSpread(useFetchListingPostLocationChange_objectSpread({}, requestBody), userLocationData), userLocationSession);
                setIsPageLoading(true);
                listingDetailsReqIdRef.current = generateRequestId();
                _context2.next = 20;
                return fetchListingDetailsOnLocationChange(request_id, deliveryDetails, {
                  reqId: listingDetailsReqIdRef.current
                });

              case 20:
                response = _context2.sent;
                setIsPageLoading(false);
                sendListingPdtLocationDetectedViewEvent(location_source, permission_details, (response === null || response === void 0 ? void 0 : (_response$listingData = response.listingData) === null || _response$listingData === void 0 ? void 0 : _response$listingData.version) || VERSIONS.V2, response === null || response === void 0 ? void 0 : (_response$listingData2 = response.listingData) === null || _response$listingData2 === void 0 ? void 0 : _response$listingData2.tm_user_id, response === null || response === void 0 ? void 0 : (_response$listingData3 = response.listingData) === null || _response$listingData3 === void 0 ? void 0 : _response$listingData3.puid);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, [isSuccess, isError, device, isLoggedInUser]);
  useEffect(function () {
    if (isSuccessDeliveryDetails) {
      sendListingPdtLocationDetectedViewEventV2({
        eventTrackingContext: getEventTrackingContext({
          request_id: deliveryDetailsReqIdRef.current
        })
      });
    }
  }, [isSuccessDeliveryDetails]);
  return {
    isLocationFetching: isLocationFetching,
    isPageLoading: isPageLoading,
    locFetchingMode: locFetchingMode,
    isLoading: isLoading,
    isSuccess: isSuccess,
    isLoadingDeliveryDetails: isLoadingDeliveryDetails,
    isSuccessDeliveryDetails: isSuccessDeliveryDetails,
    isErrorDeliveryDetails: isErrorDeliveryDetails,
    setUserLocation: setUserLocation,
    setUserLocationIfPermitted: setUserLocationIfPermitted,
    fetchUserDeliveryInfo: fetchUserDeliveryInfo,
    showEmailLoginPopup: showEmailLoginPopup,
    setShowEmailLoginPopup: setShowEmailLoginPopup
  };
};

/* harmony default export */ var hooks_useFetchListingPostLocationChange = ((/* unused pure expression or super */ null && (useFetchListingPostLocationChange_useFetchListingPostLocationChange)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/Modal/Modal.tsx + 1 modules
var Modal_Modal = __webpack_require__(3433);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/EmailLoginModal/index.tsx







var EmailLoginModal_EmailLoginModal = function EmailLoginModal(_ref) {
  var onClose = _ref.onClose;
  var device = useDevice();
  return /*#__PURE__*/_jsxs(Modal, {
    modalHeading: "Login Error",
    onModalClose: onClose ? onClose : function () {},
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/_jsx(ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0 16px 0",
      children: "Please login with mobile number to proceed further."
    }), /*#__PURE__*/_jsx(LandingButton, {
      customTitle: "OK",
      onClick: onClose,
      customWidth: "100%"
    })]
  });
};

/* harmony default export */ var components_EmailLoginModal = ((/* unused pure expression or super */ null && (EmailLoginModal_EmailLoginModal)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useFreezeBodyScroll/index.tsx
var hooks_useFreezeBodyScroll = __webpack_require__(6107);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DowntimeModal/index.tsx






var DowntimeModal_DowntimeModal = function DowntimeModal() {
  var device = useDevice();
  useFreezeBodyScroll(true);
  return /*#__PURE__*/_jsx(Modal, {
    modalHeading: "Oops!",
    onModalClose: function onModalClose() {},
    modalType: device === "lg" ? "centered" : "fullPage",
    children: /*#__PURE__*/_jsx(ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0px 16px 0",
      children: "Site Under Maintenance: We're making things even better. Be back soon!"
    })
  });
};

/* harmony default export */ var components_DowntimeModal = ((/* unused pure expression or super */ null && (DowntimeModal_DowntimeModal)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useScrolledMwebHeaderContent/index.ts


var useScrolledMwebHeaderContent_useScrolledMwebHeaderContent = function useScrolledMwebHeaderContent() {
  var _useState = useState(false),
      scrolledMWebHeaderContent = _useState[0],
      setScrolledMWebHeaderContent = _useState[1];

  var changeNavBg = function changeNavBg() {
    var scrollPos = window.scrollY;
    scrollPos >= 200 ? setScrolledMWebHeaderContent(true) : setScrolledMWebHeaderContent(false);
  };

  useEffect(function () {
    window.addEventListener("scroll", changeNavBg);
    return function () {
      return window.removeEventListener("scroll", changeNavBg);
    };
  }, []);
  return {
    scrolledMWebHeaderContent: scrolledMWebHeaderContent
  };
};

/* harmony default export */ var hooks_useScrolledMwebHeaderContent = ((/* unused pure expression or super */ null && (useScrolledMwebHeaderContent_useScrolledMwebHeaderContent)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useCountTimer/index.ts


var useCountTimer_useCountTimer = function useCountTimer() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000;

  var _useState = useState(count),
      startCount = _useState[0],
      setStartCount = _useState[1];

  var intervalRef = useRef(null);
  useEffect(function () {
    intervalRef.current = setInterval(function () {
      setStartCount(function (startCount) {
        return startCount + 1;
      });
    }, interval);
    return function () {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
  return {
    count: startCount
  };
};

/* harmony default export */ var hooks_useCountTimer = ((/* unused pure expression or super */ null && (useCountTimer_useCountTimer)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useFetchForexRates/index.ts
var useFetchForexRates = __webpack_require__(2897);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useRefreshCurrencyRates/index.ts










var useRefreshCurrencyRates_useRefreshCurrencyRates = function useRefreshCurrencyRates() {
  var host = getHostName();

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state || {};
  }),
      forex_rates = _useGlobalSelector.forex_rates,
      isErrorListingPageLocationChange = _useGlobalSelector.isErrorListingPageLocationChange,
      isSuccessListingDetailsOnLocChange = _useGlobalSelector.isSuccessListingDetailsOnLocChange;

  var _useCountTimer = useCountTimer(0, CURRENCY_RATE_REFRESH_TIME),
      count = _useCountTimer.count;

  var _useFetchForexRatex = useFetchForexRatex(),
      fetchForexRates = _useFetchForexRatex.fetchForexRates;

  var _useGlobalConfig = useGlobalConfig(),
      isBot = _useGlobalConfig.isBot;

  useEffect(function () {
    if (count <= 0 || host === HOST.MAKEMYTRIP || isBot) return;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchForexRates();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [count, host, isBot]);
  var isProdListingDetailsReqCompleted = isApiRequestCompleted(isSuccessListingDetailsOnLocChange, isErrorListingPageLocationChange);
  var forexRatesLength = forex_rates && Object.keys(forex_rates).length;
  useEffect(function () {
    if (host === HOST.MAKEMYTRIP || isBot) {
      return;
    }

    if (!isProdListingDetailsReqCompleted || isProdListingDetailsReqCompleted && forexRatesLength) return;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchForexRates();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [isProdListingDetailsReqCompleted, forexRatesLength, host, isBot]);
};

/* harmony default export */ var hooks_useRefreshCurrencyRates = ((/* unused pure expression or super */ null && (useRefreshCurrencyRates_useRefreshCurrencyRates)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useCoachmarks/index.ts







function useCoachmarks_useCoachmarks() {
  var currency_active_orders = useGlobalSelector(function (state) {
    var _state$persona;

    return (_state$persona = state.persona) === null || _state$persona === void 0 ? void 0 : _state$persona.currency_active_orders;
  });

  var _useState = useState(false),
      showCurrencyOrderCoachmark = _useState[0],
      updateShowCurrencyOrderCoachmark = _useState[1];

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtCoachmarkView = _useListingPdtLogger.sendPdtCoachmarkView,
      sendPdtCoachmarkButtonClick = _useListingPdtLogger.sendPdtCoachmarkButtonClick;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtDataV2 = _useListingPdtLoggerV.sendPdtDataV2;

  function isCoachmarkBridgeAvailable() {
    // This will be updated when bridge name is defined
    return false;
  }

  useEffect(function () {
    var currencyOrderCoachmarkShown = getLocalStorage(LOCAL_STORAGE_KEYS.CURRENCY_ORDER_COACHMARK_KEY);

    if (currency_active_orders && !currencyOrderCoachmarkShown && isCoachmarkBridgeAvailable()) {
      updateShowCurrencyOrderCoachmark(true);
      setLocalStorage(LOCAL_STORAGE_KEYS.CURRENCY_ORDER_COACHMARK_KEY, true);
      sendPdtCoachmarkView();
      sendPdtDataV2({
        event_detail: getEventDetails({
          event_name: PDT_EVENTS.COACHMARK_VIEWED
        })
      });
    }
  }, [currency_active_orders]);

  function closeCurrencyOrderCoachmark(e) {
    e.stopPropagation();
    updateShowCurrencyOrderCoachmark(false);
    sendPdtCoachmarkButtonClick();
    sendPdtDataV2({
      event_detail: getEventDetails({
        event_name: PDT_EVENTS.COACKMARK_BUTTON_CLICK
      })
    });
  }

  return {
    showCurrencyOrderCoachmark: showCurrencyOrderCoachmark,
    closeCurrencyOrderCoachmark: closeCurrencyOrderCoachmark
  };
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/priceTickerLiveTag.svg
/* harmony default export */ var priceTickerLiveTag = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/priceTickerLiveTag.e005ee66.svg","height":18,"width":35});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/types/index.ts

var types_RateTickerType;

(function (RateTickerType) {
  RateTickerType["UPCOMING_TRIP"] = "upcoming_trip";
  RateTickerType["TOP_CURRENCY"] = "top_currency";
})(types_RateTickerType || (types_RateTickerType = {}));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/topShowCasePropsMapper.ts


function topShowCasePropsMapper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function topShowCasePropsMapper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? topShowCasePropsMapper_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : topShowCasePropsMapper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function topShowCasePropsMapper_getLocationFetchingDataProps(locFetchingMode, isLocationFetching, locationFetchingScreenLabel) {
  var props = {
    locFetchingMode: locFetchingMode,
    isLocationFetching: isLocationFetching,
    data: {
      fetchingData: {
        loadingGifSrc: "https://tripmoneycmsimgak.mmtcdn.com/img/Ripple_listing_aa2677db1e.gif",
        label: "Loading Forex Products"
      },
      fetchedData: {
        showDeliveryIcon: false,
        label: locationFetchingScreenLabel
      },
      conditionsText: {
        greenText: "*",
        normalText: "Please note that these are tentative dates. The actual dates may vary"
      }
    }
  };
  return props;
}
function topShowCasePropsMapper_getSectionBgImgURI(version, isLocationFetching) {
  if (version === VERSIONS.V3) {
    if (isLocationFetching) {
      return "https://tripmoneycmsimgak.mmtcdn.com/img/tripmoney_mmt_bg_V3_3af87d2023.avif";
    } else {
      return "https://tripmoneycmsimgak.mmtcdn.com/img/bg_14c7031087.png";
    }
  } else {
    return "https://tripmoneycmsimgak.mmtcdn.com/img/listing_bg_grill_fcf0a7f743.svg";
  }
}
function topShowCasePropsMapper_getLandingTitle(mobileTitle) {
  return {
    textOne: mobileTitle,
    textTwo: "We offer",
    textThree: "same-day delivery",
    textFour: "in 125+ Indian cities"
  };
}
function getMarqueeData(tickerData) {
  return {
    isLoading: tickerData && tickerData.length === 0,
    loadingText: "Fetching LIVE Rates",
    data: tickerData,
    // @ts-ignore
    // Remove this when link is added intead of import
    LIVETagImgURI: LIVETag.src
  };
}
function getDiscountBanner(offer_persuasion_text, device) {
  return {
    imgSrc: device === "lg" ? "https://tripmoneycmsimgak.mmtcdn.com/img/discount_Green_6294b6813d.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/discount_White_5206665087.svg",
    label: offer_persuasion_text
  };
}
function topShowCasePropsMapper_getOtherProductsText(landingPinnedCardShowcaseData, version) {
  return landingPinnedCardShowcaseData.length > 0 ? version === VERSIONS.V3 ? "Other Forex Products" : "You can also try" : "";
}
function topShowCasePropsMapper_getDeliveryPersuasion(deliveryDetailsContent, checkPincodeHandler, editLocationHandler) {
  return deliveryDetailsContent ? topShowCasePropsMapper_objectSpread({
    checkPincodeHandler: checkPincodeHandler,
    editLocationHandler: editLocationHandler
  }, deliveryDetailsContent) : null;
}
function topShowCasePropsMapper_getOtherShowcaseCardsData(landingCardShowcaseData, otherShowcaseCardsHandler) {
  return {
    data: landingCardShowcaseData,
    itemHandler: otherShowcaseCardsHandler,
    isLoading: landingCardShowcaseData && landingCardShowcaseData.length === 0,
    loadingImgSrc: "https://tripmoneycmsimgak.mmtcdn.com/img/infinity_Loading_min_f0a0b9bcba.gif",
    loadingText: "Loading Forex Offerings",
    showInfoOnRightSideInCards: landingCardShowcaseData.length <= SHOW_DATA_ON_RIGHT_SIDE_IN_FOREX_CARD_LIMIT
  };
}
function topShowCasePropsMapper_getViewOrderLabel(isLoggedInUser) {
  return isLoggedInUser ? "VIEW PREVIOUS ORDERS" : "";
}
function shouldShowDiscountBanner(offerPersuasions) {
  if (!(offerPersuasions !== null && offerPersuasions !== void 0 && offerPersuasions.length)) {
    return false;
  }

  return true;
}
function topShowCasePropsMapper_getEffectiveRateBannerLabel(_ref) {
  var offerPersuasions = _ref.offerPersuasions,
      device = _ref.device;

  if (!(offerPersuasions !== null && offerPersuasions !== void 0 && offerPersuasions.length)) {
    return "";
  }

  var firstOffer = offerPersuasions[0];

  if (firstOffer.type === OFFER_TYPES.CROSS_SELL_HOTEL) {
    return "<b>Exclusive Offer for you!</b> ".concat(getHotelCouponDiscountBannerSubLabel(firstOffer));
  } else if (firstOffer.type === OFFER_TYPES.CROSS_SELL_FLIGHT) {
    return "<b>Exclusive Flyer Offer for you!</b> ".concat(getFlightCouponDiscountBannerSubLabel(firstOffer));
  } else if (firstOffer.type === OFFER_TYPES.SALE_COUPONS) {
    return "*Net effective rate after cashback is applied";
  } else {
    return "";
  }
}
function topShowCasePropsMapper_getDiscountBannerProps(offerPersuasions, device) {
  if (!(offerPersuasions !== null && offerPersuasions !== void 0 && offerPersuasions.length)) {
    return {};
  }

  var firstOffer = offerPersuasions[0];

  if (!firstOffer) {
    return {};
  }

  if (firstOffer.type === OFFER_TYPES.CROSS_SELL_HOTEL) {
    return getHotelCouponDiscountBannerProps(firstOffer, device);
  } else if (firstOffer.type === OFFER_TYPES.CROSS_SELL_FLIGHT) {
    return getFlightCouponDiscountBannerProps(firstOffer, device);
  } else {
    return getSaleCouponDiscountBannerProps(firstOffer, device);
  }
}

function getSaleCouponDiscountBannerProps(offerPersuasion, device) {
  var _offerPersuasion$valu, _offerPersuasion$valu2;

  var details = (_offerPersuasion$valu = offerPersuasion.value) === null || _offerPersuasion$valu === void 0 ? void 0 : (_offerPersuasion$valu2 = _offerPersuasion$valu.details) === null || _offerPersuasion$valu2 === void 0 ? void 0 : _offerPersuasion$valu2[0];
  return {
    imgSrc: device === "lg" ? "https://tripmoneycmsimgak.mmtcdn.com/img/discount_Green_6294b6813d.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/discount_68d1265618.svg",
    label: "Get upto  <span class=\"greenTextWeb\"> INR ".concat(details === null || details === void 0 ? void 0 : details.max_cashback, " Cashback</span> on Forex Card & Currency"),
    subLabel: ""
  };
}

function getHotelCouponDiscountBannerSubLabel(offerPersuasion) {
  var _offerPersuasion$valu3, _offerPersuasion$valu4, _offerPersuasion$valu5;

  var details = (_offerPersuasion$valu3 = offerPersuasion.value) === null || _offerPersuasion$valu3 === void 0 ? void 0 : (_offerPersuasion$valu4 = _offerPersuasion$valu3.details) === null || _offerPersuasion$valu4 === void 0 ? void 0 : _offerPersuasion$valu4[0];
  return details !== null && details !== void 0 && details.coupon_cashback ? "Claim <span class=\"greenTextWeb\">".concat((details === null || details === void 0 ? void 0 : details.coupon_currency) || "INR", " ").concat(details === null || details === void 0 ? void 0 : details.coupon_cashback, " Assured Cashback</span> on forex card or currency purchase of minimum INR ").concat(((_offerPersuasion$valu5 = offerPersuasion.value) === null || _offerPersuasion$valu5 === void 0 ? void 0 : _offerPersuasion$valu5.min_purchase) || "3,000") : "";
}

function getHotelCouponDiscountBannerProps(offerPersuasion, device) {
  var _offerPersuasion$valu6;

  return {
    imgSrc: device === "lg" ? "https://tripmoneycmsimgak.mmtcdn.com/img/discount_Green_6294b6813d.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/discount_68d1265618.svg",
    label: "<span class=\"greenTextWeb\">".concat((_offerPersuasion$valu6 = offerPersuasion.value) === null || _offerPersuasion$valu6 === void 0 ? void 0 : _offerPersuasion$valu6.text, "</span>") || 0,
    subLabel: getHotelCouponDiscountBannerSubLabel(offerPersuasion)
  };
}

function getFlightCouponDiscountBannerSubLabel(offerPersuasion) {
  var _offerPersuasion$valu7, _details$, _offerPersuasion$valu8;

  var details = (_offerPersuasion$valu7 = offerPersuasion.value) === null || _offerPersuasion$valu7 === void 0 ? void 0 : _offerPersuasion$valu7.details;
  if (!(details !== null && details !== void 0 && (_details$ = details[0]) !== null && _details$ !== void 0 && _details$.coupon_cashback)) return "";
  var maxCashBackDetails = details.reduce(function (maxAmountDetail, currentDetail) {
    return (maxAmountDetail === null || maxAmountDetail === void 0 ? void 0 : maxAmountDetail.coupon_cashback) !== undefined && (currentDetail === null || currentDetail === void 0 ? void 0 : currentDetail.coupon_cashback) !== undefined && (maxAmountDetail === null || maxAmountDetail === void 0 ? void 0 : maxAmountDetail.coupon_cashback) > (currentDetail === null || currentDetail === void 0 ? void 0 : currentDetail.coupon_cashback) ? maxAmountDetail : currentDetail;
  });
  return maxCashBackDetails !== null && maxCashBackDetails !== void 0 && maxCashBackDetails.coupon_cashback ? "Claim <span class=\"greenTextWeb\">".concat((maxCashBackDetails === null || maxCashBackDetails === void 0 ? void 0 : maxCashBackDetails.coupon_currency) || "INR", " ").concat(maxCashBackDetails === null || maxCashBackDetails === void 0 ? void 0 : maxCashBackDetails.coupon_cashback, " Assured Cashback</span> on forex card or currency purchase of minimum INR ").concat(((_offerPersuasion$valu8 = offerPersuasion.value) === null || _offerPersuasion$valu8 === void 0 ? void 0 : _offerPersuasion$valu8.min_purchase) || "3,000") : "";
}

function getFlightCouponDiscountBannerProps(offerPersuasion, device) {
  var _offerPersuasion$valu9;

  return {
    imgSrc: device === "lg" ? "https://tripmoneycmsimgak.mmtcdn.com/img/discount_Green_6294b6813d.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/discount_68d1265618.svg",
    label: "<span class=\"greenTextWeb\">".concat((_offerPersuasion$valu9 = offerPersuasion.value) === null || _offerPersuasion$valu9 === void 0 ? void 0 : _offerPersuasion$valu9.text, "</span>") || 0,
    subLabel: getFlightCouponDiscountBannerSubLabel(offerPersuasion)
  };
}

function topShowCasePropsMapper_getCouponDetailProps(offerPersuasions) {
  var _offerPersuasions$, _offerPersuasions$$va;

  return {
    title: getCouponDetailsTitle(offerPersuasions),
    couponsData: getCouponData(offerPersuasions),
    cashbackSlabs: getCashbackSlabs(offerPersuasions),
    stepsToApply: [],
    tncData: getCouponDetailsTncData((offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$ = offerPersuasions[0]) === null || _offerPersuasions$ === void 0 ? void 0 : (_offerPersuasions$$va = _offerPersuasions$.value) === null || _offerPersuasions$$va === void 0 ? void 0 : _offerPersuasions$$va.tnc) || []),
    modalHeading: getCouponDetailsModalHeading(offerPersuasions)
  };
}

function getCouponDetailsModalHeading(offerPersuasion) {
  if (!(offerPersuasion !== null && offerPersuasion !== void 0 && offerPersuasion.length)) {
    return "";
  }

  if ([OFFER_TYPES.CROSS_SELL_HOTEL, OFFER_TYPES.CROSS_SELL_FLIGHT].includes(offerPersuasion[0].type || "")) {
    return "Offer Details";
  } else {
    return "Coupon Details";
  }
}

function getCouponDetailsTitle(offerPersuasion) {
  if (!(offerPersuasion !== null && offerPersuasion !== void 0 && offerPersuasion.length)) {
    return "";
  }

  if (offerPersuasion[0].type === OFFER_TYPES.CROSS_SELL_HOTEL) {
    return "Offer(s) available basis your international hotel bookings";
  } else if (offerPersuasion[0].type === OFFER_TYPES.CROSS_SELL_FLIGHT) {
    return "Offer(s) available because you booked international flight.";
  } else {
    return "";
  }
}

function getCouponDetailsTncData(tncs) {
  return tncs.filter(function (tncItem) {
    return !!tncItem;
  }).map(function (tncItem, index) {
    return {
      id: String(index),
      info: tncItem
    };
  });
}

function getCashbackSlabs(offerPersuasions) {
  var _offerPersuasions$0$v, _offerPersuasions$0$v2;

  if (!(offerPersuasions !== null && offerPersuasions !== void 0 && offerPersuasions.length)) {
    return [];
  }

  var updateSlab = ((_offerPersuasions$0$v = offerPersuasions[0].value) === null || _offerPersuasions$0$v === void 0 ? void 0 : (_offerPersuasions$0$v2 = _offerPersuasions$0$v.slab) === null || _offerPersuasions$0$v2 === void 0 ? void 0 : _offerPersuasions$0$v2.map(function (slab, index) {
    var updateSlab = topShowCasePropsMapper_objectSpread(topShowCasePropsMapper_objectSpread({}, slab), {}, {
      id: "offer_slab_".concat(index)
    });

    return updateSlab;
  })) || [];
  return updateSlab;
}

function getCouponDetailsLabelForHotel(coupon) {
  return "Get <b><span style=\"color: #2B825E\">".concat((coupon === null || coupon === void 0 ? void 0 : coupon.coupon_currency) || "INR", " ").concat(coupon.coupon_cashback, "</span></b> assured cashback on purchase of forex card or currency. Offer earned via hotel Booking ").concat((coupon === null || coupon === void 0 ? void 0 : coupon.booking_id) || "", ".");
}

function getCouponData(offerPersuasions) {
  var _offerPersuasions$2, _offerPersuasions$4;

  if (!(offerPersuasions !== null && offerPersuasions !== void 0 && offerPersuasions.length)) {
    return [];
  }

  if ((offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$2 = offerPersuasions[0]) === null || _offerPersuasions$2 === void 0 ? void 0 : _offerPersuasions$2.type) === OFFER_TYPES.CROSS_SELL_HOTEL) {
    var _offerPersuasions$3, _offerPersuasions$3$v;

    var coupons = (offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$3 = offerPersuasions[0]) === null || _offerPersuasions$3 === void 0 ? void 0 : (_offerPersuasions$3$v = _offerPersuasions$3.value) === null || _offerPersuasions$3$v === void 0 ? void 0 : _offerPersuasions$3$v.details) || [];
    return coupons.filter(function (coupon) {
      return coupon === null || coupon === void 0 ? void 0 : coupon.coupon_cashback;
    }).map(function (coupon, index) {
      return {
        id: String(index + ((coupon === null || coupon === void 0 ? void 0 : coupon.coupon_cashback) || 0)),
        code: "CASHBACK ".concat((coupon === null || coupon === void 0 ? void 0 : coupon.coupon_currency) || "INR", " ").concat(coupon.coupon_cashback),
        details: getCouponDetailsLabelForHotel(coupon),
        expiryText: "Valid till: ".concat(coupon !== null && coupon !== void 0 && coupon.coupon_expiry ? convertEpochToDate(coupon === null || coupon === void 0 ? void 0 : coupon.coupon_expiry) : ""),
        expiryDate: coupon !== null && coupon !== void 0 && coupon.coupon_expiry ? convertEpochToDate(coupon === null || coupon === void 0 ? void 0 : coupon.coupon_expiry) : ""
      };
    });
  } else if ((offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$4 = offerPersuasions[0]) === null || _offerPersuasions$4 === void 0 ? void 0 : _offerPersuasions$4.type) === OFFER_TYPES.CROSS_SELL_FLIGHT) {
    var _offerPersuasions$5, _offerPersuasions$5$v;

    var _coupons = (offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$5 = offerPersuasions[0]) === null || _offerPersuasions$5 === void 0 ? void 0 : (_offerPersuasions$5$v = _offerPersuasions$5.value) === null || _offerPersuasions$5$v === void 0 ? void 0 : _offerPersuasions$5$v.details) || [];

    return _coupons.filter(function (coupon) {
      return coupon === null || coupon === void 0 ? void 0 : coupon.coupon_cashback;
    }).map(function (coupon, index) {
      return {
        id: String(index + ((coupon === null || coupon === void 0 ? void 0 : coupon.coupon_cashback) || 0)),
        code: (coupon === null || coupon === void 0 ? void 0 : coupon.title) || "",
        details: (coupon === null || coupon === void 0 ? void 0 : coupon.message) || "",
        expiryText: (coupon === null || coupon === void 0 ? void 0 : coupon.period) || "",
        expiryDate: (coupon === null || coupon === void 0 ? void 0 : coupon.period) || ""
      };
    });
  } else {
    var _offerPersuasions$6, _offerPersuasions$6$v, _offerPersuasions$6$v2;

    var coupon = (offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$6 = offerPersuasions[0]) === null || _offerPersuasions$6 === void 0 ? void 0 : (_offerPersuasions$6$v = _offerPersuasions$6.value) === null || _offerPersuasions$6$v === void 0 ? void 0 : (_offerPersuasions$6$v2 = _offerPersuasions$6$v.details) === null || _offerPersuasions$6$v2 === void 0 ? void 0 : _offerPersuasions$6$v2[0]) || {
      max_cashback: "",
      title: "",
      message: "",
      period: ""
    };
    return [{
      id: "sale_coupon_offer",
      code: (coupon === null || coupon === void 0 ? void 0 : coupon.title) || "",
      details: (coupon === null || coupon === void 0 ? void 0 : coupon.message) || "",
      expiryText: (coupon === null || coupon === void 0 ? void 0 : coupon.period) || ""
    }];
  }
}

function topShowCasePropsMapper_getForexRateTickerProps(_ref2) {
  var forexRateTicker = _ref2.forexRateTicker,
      offerPersuasions = _ref2.offerPersuasions;

  if (!forexRateTicker) {
    return [];
  }

  return forexRateTicker.filter(function (ticker) {
    var _ticker$currency_rate, _ticker$currency_rate2;

    return ((_ticker$currency_rate = ticker.currency_rate) === null || _ticker$currency_rate === void 0 ? void 0 : _ticker$currency_rate.card) || ((_ticker$currency_rate2 = ticker.currency_rate) === null || _ticker$currency_rate2 === void 0 ? void 0 : _ticker$currency_rate2.currency);
  }).map(function (ticker, index) {
    var _ticker$currency_rate3, _ticker$currency_rate4, _offerPersuasions$7;

    var cardRate = (_ticker$currency_rate3 = ticker.currency_rate) === null || _ticker$currency_rate3 === void 0 ? void 0 : _ticker$currency_rate3.card;
    var cardPrecision = (cardRate !== null && cardRate !== void 0 ? cardRate : 0) >= 1 ? 2 : 4;
    var currencyRate = (_ticker$currency_rate4 = ticker.currency_rate) === null || _ticker$currency_rate4 === void 0 ? void 0 : _ticker$currency_rate4.currency;
    var currencyPrecision = (currencyRate !== null && currencyRate !== void 0 ? currencyRate : 0) >= 1 ? 2 : 4;
    var rateToShow = "-";

    if (cardRate) {
      rateToShow = toLocaleStringINRFormat(cardRate, cardPrecision, cardPrecision);
    } else if (currencyRate) {
      rateToShow = toLocaleStringINRFormat(currencyRate, currencyPrecision, currencyPrecision);
    } else {
      rateToShow = "-";
    }

    return {
      id: "top_currency_ticker_".concat(index),
      currencyCode: ticker.currency_code,
      amount: rateToShow,
      upcomingTripInfo: ticker.currency_source === RateTickerType.UPCOMING_TRIP ? "For upcoming trip to <b>".concat(ticker.label, "</b>") : "",
      type: ticker.currency_source,
      conditional: (offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$7 = offerPersuasions[0]) === null || _offerPersuasions$7 === void 0 ? void 0 : _offerPersuasions$7.type) === OFFER_TYPES.SALE_COUPONS
    };
  });
}

function transformTickerDataForModal(rateTicker, isMMTSaleCouponAvailable) {
  var _rateTicker$currency_, _rateTicker$image_url, _rateTicker$currency_2, _rateTicker$currency_3, _rateTicker$currency_4, _rateTicker$currency_5, _rateTicker$currency_6, _rateTicker$currency_7;

  var rateSuffix = isMMTSaleCouponAvailable ? "*" : "";
  return {
    id: (_rateTicker$currency_ = rateTicker.currency_name) !== null && _rateTicker$currency_ !== void 0 ? _rateTicker$currency_ : "",
    flag: (_rateTicker$image_url = rateTicker.image_url) !== null && _rateTicker$image_url !== void 0 ? _rateTicker$image_url : "",
    currencyName: (_rateTicker$currency_2 = rateTicker.currency_name) !== null && _rateTicker$currency_2 !== void 0 ? _rateTicker$currency_2 : "",
    currencyCode: (_rateTicker$currency_3 = rateTicker.currency_code) !== null && _rateTicker$currency_3 !== void 0 ? _rateTicker$currency_3 : "",
    cardRate: (_rateTicker$currency_4 = rateTicker.currency_rate) !== null && _rateTicker$currency_4 !== void 0 && _rateTicker$currency_4.card ? "".concat(toLocaleStringINRFormat((_rateTicker$currency_5 = rateTicker.currency_rate) === null || _rateTicker$currency_5 === void 0 ? void 0 : _rateTicker$currency_5.card, 4, 4)).concat(rateSuffix) : "-",
    currencyRate: (_rateTicker$currency_6 = rateTicker.currency_rate) !== null && _rateTicker$currency_6 !== void 0 && _rateTicker$currency_6.currency ? "".concat(toLocaleStringINRFormat((_rateTicker$currency_7 = rateTicker.currency_rate) === null || _rateTicker$currency_7 === void 0 ? void 0 : _rateTicker$currency_7.currency, 4, 4)).concat(rateSuffix) : "-"
  };
}

function topShowCasePropsMapper_getPropsForTickerModal(_ref3) {
  var _offerPersuasions$8;

  var forexRateTicker = _ref3.forexRateTicker,
      offerPersuasions = _ref3.offerPersuasions;
  var isMMTSaleCouponAvailable = (offerPersuasions === null || offerPersuasions === void 0 ? void 0 : (_offerPersuasions$8 = offerPersuasions[0]) === null || _offerPersuasions$8 === void 0 ? void 0 : _offerPersuasions$8.type) === OFFER_TYPES.SALE_COUPONS;
  var forexRatesData = [{
    id: "1",
    title: "For upcoming trip",
    data: []
  }, {
    id: "2",
    title: "Top Currencies",
    data: []
  }];
  forexRateTicker === null || forexRateTicker === void 0 ? void 0 : forexRateTicker.forEach(function (rateTicker) {
    var tickerTypeToUpdate = rateTicker.currency_source === RateTickerType.UPCOMING_TRIP ? 0 : 1;
    forexRatesData[tickerTypeToUpdate].data.push(transformTickerDataForModal(rateTicker, isMMTSaleCouponAvailable));
  });
  var filteredForexRatesData = forexRatesData === null || forexRatesData === void 0 ? void 0 : forexRatesData.filter(function (rateObject) {
    return rateObject.data.length;
  });

  if (isMMTSaleCouponAvailable) {
    return {
      title: "Below are the net effective rates after <b>UPTO INR 7500 CASHBACK</b> coupon is applied.",
      footerText: "Proceed with forex card or currency notes to know net effective rates of any other desired currency.",
      forexRatesData: filteredForexRatesData
    };
  } else {
    return {
      title: "",
      footerText: "Proceed with forex card or currency notes to know rates of any other desired currency.",
      forexRatesData: filteredForexRatesData
    };
  }
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CouponDetailsModal/CouponDetailsModal.style.ts


var CouponDetailsModal_style_CouponItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CouponDetailsModalstyle__CouponItem",
  componentId: "eenszz-0"
})(["display:flex;flex-direction:column;padding:12px 16px 16px;margin-top:8px;border:1px solid #e2e2e2;border-radius:8px;"]);
var CouponDetailsModal_style_TncContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CouponDetailsModalstyle__TncContainer",
  componentId: "eenszz-1"
})(["margin:24px 0px;"]);
var CouponDetailsModal_style_TncListItems = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "CouponDetailsModalstyle__TncListItems",
  componentId: "eenszz-2"
})(["display:flex;flex-direction:column;gap:16px;margin-top:12px;li{font-size:12px;font-weight:400;color:", ";padding-left:14px;position:relative;}li::before{content:\"\";position:absolute;left:0;top:6px;width:8px;height:8px;border-radius:4px;background-color:", ";}"], Global/* theme.greyText */.rS.greyText, Global/* theme.blueText */.rS.blueText);
var CouponDetailsModal_style_AvailInstructions = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CouponDetailsModalstyle__AvailInstructions",
  componentId: "eenszz-3"
})(["margin:24px 0px;"]);
var CouponDetailsModal_style_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CouponDetailsModalstyle__Container",
  componentId: "eenszz-4"
})(["max-height:50vh;overflow-y:auto;"]); // export const AvailInstructionsItems = styled.ul<any>`
//     display: flex;
//     flex-direction: column;
//     gap: 4px;
//     margin-top: 8px;
//     padding-left: 12px;
//     li {
//         font-size: 12px;
//         font-weight: 400;
//         color: ${theme.greyText};
//         padding-left: 14px;
//         position: relative;
//     }
//     li::before {
//         content: '';
//         position: absolute;
//         left: 0;
//         top: 6px;
//         width: 4px;
//         height: 4px;
//         border-radius: 4px;
//         background-color: ${theme.blackText};
//     }
// `;

var CouponDetailsModal_style_CashbackSlabContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CouponDetailsModalstyle__CashbackSlabContainer",
  componentId: "eenszz-5"
})(["border:1px solid #e2e2e2;border-radius:8px;margin:8px 0px 0px;"]);
var CouponDetailsModal_style_CashbackSlabHeadingRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CouponDetailsModalstyle__CashbackSlabHeadingRow",
  componentId: "eenszz-6"
})(["display:flex;flex-direction:row;justify-content:space-between;border-bottom:", ";background:#f6f6f6;> div{flex:1;padding:10px 8px;justify-content:space-around;align-items:center;&:first-child{border-right:1px solid #e2e2e2;}}"], function (p) {
  return p.borderBottom ? p.borderBottom : "1px solid #e2e2e2";
});
var CouponDetailsModal_style_CashbackSlabRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CouponDetailsModalstyle__CashbackSlabRow",
  componentId: "eenszz-7"
})(["display:flex;flex-direction:row;justify-content:space-between;border-bottom:", ";> div{flex:1;padding:10px 14px;&:first-child{border-right:1px solid #e2e2e2;}}"], function (p) {
  return p.borderBottom ? p.borderBottom : "1px solid #e2e2e2";
});
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/CloseIcon.tsx
var icons_CloseIcon = __webpack_require__(1269);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CouponDetailsModal/CouponDetailsModal.tsx












var CouponDetailsModal_CouponDetailsModal = function CouponDetailsModal(_ref) {
  var _couponsData$slice;

  var modalHeading = _ref.modalHeading,
      onModalClose = _ref.onModalClose,
      title = _ref.title,
      couponsData = _ref.couponsData,
      tncData = _ref.tncData,
      availInstructions = _ref.availInstructions,
      stepsToApply = _ref.stepsToApply,
      cashbackSlabs = _ref.cashbackSlabs;
  var device = useDevice();

  var _useState = useState(false),
      showAll = _useState[0],
      setShowAll = _useState[1];

  var toggleShowAll = function toggleShowAll() {
    setShowAll(!showAll);
  };

  var renderCouponItem = function renderCouponItem(item) {
    return /*#__PURE__*/_jsxs(CouponItem, {
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.blackText,
        children: (item === null || item === void 0 ? void 0 : item.code) || ""
      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "xs",
        color: theme.greyText,
        dangerousText: (item === null || item === void 0 ? void 0 : item.details) || "",
        margin: "8px 0px 0px"
      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "xs",
        color: theme.greyText6,
        margin: "4px 0px 0px",
        children: (item === null || item === void 0 ? void 0 : item.expiryText) || ""
      })]
    }, item === null || item === void 0 ? void 0 : item.id);
  };

  var renderHowToAvail = function renderHowToAvail() {
    return /*#__PURE__*/_jsxs(AvailInstructions, {
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.greyText6,
        children: "How to avail Offer"
      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "xs",
        color: theme.greyText,
        margin: "8px 0px 0px",
        children: availInstructions
      })]
    });
  };

  var renderTncSection = function renderTncSection() {
    return /*#__PURE__*/_jsxs(TncContainer, {
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.greyText6,
        children: "Terms & Conditions"
      }), /*#__PURE__*/_jsx(TncListItems, {
        children: tncData === null || tncData === void 0 ? void 0 : tncData.map(function (item) {
          return /*#__PURE__*/_jsx("li", {
            id: item.id,
            dangerouslySetInnerHTML: {
              __html: item.info || ""
            }
          });
        })
      })]
    });
  };

  var renderSteps = function renderSteps() {
    return /*#__PURE__*/_jsxs(TncContainer, {
      id: "steps_id",
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.greyText6,
        children: "How to Apply"
      }), /*#__PURE__*/_jsx(TncListItems, {
        children: stepsToApply === null || stepsToApply === void 0 ? void 0 : stepsToApply.map(function (item) {
          return /*#__PURE__*/_jsx("li", {
            id: item.id,
            children: item.info
          });
        })
      })]
    });
  };

  var renderSlabs = function renderSlabs() {
    var length = cashbackSlabs ? cashbackSlabs.length : 0;

    if (!length) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }

    return /*#__PURE__*/_jsxs(TncContainer, {
      id: "cashback_slabs_id",
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.greyText6,
        children: "Cashback Slabs"
      }), /*#__PURE__*/_jsxs(CashbackSlabContainer, {
        children: [/*#__PURE__*/_jsxs(CashbackSlabHeadingRow, {
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(ParaTag, {
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "sm",
              children: "Slabs (in INR)"
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(ParaTag, {
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "sm",
              children: "Cashback (INR)"
            })
          })]
        }), cashbackSlabs === null || cashbackSlabs === void 0 ? void 0 : cashbackSlabs.map(function (item, index) {
          return /*#__PURE__*/_jsxs(CashbackSlabRow, {
            borderBottom: index === length - 1 && "unset",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(ParaTag, {
                textAlign: "center",
                fontSize: "xs",
                children: item.range
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(ParaTag, {
                textAlign: "center",
                fontSize: "xs",
                children: item.cashback
              })
            })]
          }, item.id);
        })]
      })]
    });
  };

  return /*#__PURE__*/_jsx(Modal, {
    modalHeading: modalHeading,
    onModalClose: onModalClose,
    closeButton: /*#__PURE__*/_jsx(CloseIcon, {}),
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        color: theme.greyText6,
        fontWeight: "bold",
        children: title
      }), renderCouponItem(couponsData[0]), showAll && (couponsData === null || couponsData === void 0 ? void 0 : (_couponsData$slice = couponsData.slice(1)) === null || _couponsData$slice === void 0 ? void 0 : _couponsData$slice.map(function (item) {
        return renderCouponItem(item);
      })), (couponsData === null || couponsData === void 0 ? void 0 : couponsData.length) > 1 && /*#__PURE__*/_jsx(AnchorTag, {
        fontSize: "sm",
        fontWeight: "bold",
        onClick: toggleShowAll,
        margin: "8px 0px 0px",
        children: !showAll ? "+ ".concat(couponsData.length - 1, " More Offer") : "Show Less"
      }), availInstructions && renderHowToAvail(), cashbackSlabs && renderSlabs(), renderTncSection()]
    })
  });
};

/* harmony default export */ var components_CouponDetailsModal_CouponDetailsModal = ((/* unused pure expression or super */ null && (CouponDetailsModal_CouponDetailsModal)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ForexRatesModal/ForexRatesModal.style.ts

var ForexRatesModal_style_ForexRatesDetails = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ForexRatesModalstyle__ForexRatesDetails",
  componentId: "to0d2j-0"
})(["> li{flex-direction:\"row\";display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #f2f2f2;padding:8px 8px 8px 0px;}> li:last-child{border-bottom:unset;}"]);
var ForexRatesModal_style_ForexRatesHdr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexRatesModalstyle__ForexRatesHdr",
  componentId: "to0d2j-1"
})(["display:flex;text-align:right;gap:25px;justify-content:flex-end;margin-bottom:-23px;span:last-child{width:73px;}"]);
var ForexRatesModal_style_ForexRatesBody = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexRatesModalstyle__ForexRatesBody",
  componentId: "to0d2j-2"
})(["&:not(:last-child){border-bottom:1px solid #f2f2f2;margin-bottom:12px;}"]);
var ForexRatesModal_style_ForexRatesFtr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexRatesModalstyle__ForexRatesFtr",
  componentId: "to0d2j-3"
})(["margin:20px -30px -30px -30px;background-color:#eaf5ff;padding:8px 16px;"]);
var ForexRatesModal_style_ForexRatesLeftContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexRatesModalstyle__ForexRatesLeftContainer",
  componentId: "to0d2j-4"
})(["display:flex;flex:1;flex-direction:row;align-items:center;gap:8px;"]);
var ForexRatesModal_style_CurrencyInfoContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexRatesModalstyle__CurrencyInfoContainer",
  componentId: "to0d2j-5"
})(["display:flex;flex-direction:column;gap:2px;"]);
var ForexRatesModal_style_ForexRatesRightContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexRatesModalstyle__ForexRatesRightContainer",
  componentId: "to0d2j-6"
})(["display:flex;margin-left:20px;gap:20px;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ForexRatesModal/ForexRatesModal.tsx











var ForexRatesModal_ForexRatesModal = function ForexRatesModal(_ref) {
  var modalHeading = _ref.modalHeading,
      onModalClose = _ref.onModalClose,
      title = _ref.title,
      forexRatesData = _ref.forexRatesData,
      footerText = _ref.footerText;
  var device = useDevice();
  return /*#__PURE__*/_jsxs(Modal, {
    modalHeading: modalHeading,
    onModalClose: onModalClose,
    closeButton: /*#__PURE__*/_jsx(CloseIcon, {}),
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/_jsx(ParaTag, {
      fontSize: "xs",
      color: theme.greyText,
      dangerousText: title,
      margin: "0px 0px 20px"
    }), /*#__PURE__*/_jsxs(ForexRatesHdr, {
      children: [/*#__PURE__*/_jsx(SpanTag, {
        color: theme.blackText,
        fontSize: "xs",
        fontWeight: "bold",
        children: "Card (\u20B9)"
      }), /*#__PURE__*/_jsx(SpanTag, {
        color: theme.blackText,
        fontSize: "xs",
        fontWeight: "bold",
        children: "Currency (\u20B9)"
      })]
    }), forexRatesData === null || forexRatesData === void 0 ? void 0 : forexRatesData.map(function (item, index) {
      var _item$data;

      return /*#__PURE__*/_jsxs(ForexRatesBody, {
        children: [/*#__PURE__*/_jsx(SpanTag, {
          color: theme.blackText,
          fontSize: "xs",
          fontWeight: "bold",
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/_jsx(SectionDividers, {
          height: "1px",
          margin: "8px 0px 0px"
        }), /*#__PURE__*/_jsx(ForexRatesDetails, {
          children: item === null || item === void 0 ? void 0 : (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.map(function (rateDetails) {
            return /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsxs(ForexRatesLeftContainer, {
                children: [(rateDetails === null || rateDetails === void 0 ? void 0 : rateDetails.flag) && /*#__PURE__*/_jsx(SpanTag, {
                  children: rateDetails.flag
                }), /*#__PURE__*/_jsxs(CurrencyInfoContainer, {
                  children: [/*#__PURE__*/_jsx(SpanTag, {
                    color: theme.blackText,
                    fontSize: "xs",
                    children: rateDetails === null || rateDetails === void 0 ? void 0 : rateDetails.currencyName
                  }), /*#__PURE__*/_jsx(SpanTag, {
                    color: theme.greyText6,
                    fontSize: "xs",
                    children: rateDetails === null || rateDetails === void 0 ? void 0 : rateDetails.currencyCode
                  })]
                })]
              }), /*#__PURE__*/_jsxs(ForexRatesRightContainer, {
                children: [/*#__PURE__*/_jsx(SpanTag, {
                  textAlign: "right",
                  color: theme.blackText,
                  fontSize: "xs",
                  children: rateDetails === null || rateDetails === void 0 ? void 0 : rateDetails.cardRate
                }), /*#__PURE__*/_jsx(SpanTag, {
                  textAlign: "right",
                  customWidth: "70px",
                  color: theme.blackText,
                  fontSize: "xs",
                  children: rateDetails === null || rateDetails === void 0 ? void 0 : rateDetails.currencyRate
                })]
              })]
            });
          })
        })]
      }, (item === null || item === void 0 ? void 0 : item.id) || index);
    }), /*#__PURE__*/_jsx(ForexRatesFtr, {
      children: /*#__PURE__*/_jsx(ParaTag, {
        color: theme.greyText,
        fontSize: "xs",
        children: footerText
      })
    })]
  });
};

/* harmony default export */ var components_ForexRatesModal_ForexRatesModal = ((/* unused pure expression or super */ null && (ForexRatesModal_ForexRatesModal)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useTrackListingClickEvent/useTrackListingClickEvent.ts



function useTrackListingClickEvent_useTrackListingClickEvent() {
  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      tm_user_id = _useGlobalSelector.tm_user_id;

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner;

  function trackListingClickEventsInOmniture(data) {
    trackListingClickEvents({
      actionType: data.actionType,
      tmUserId: tm_user_id,
      partner: partner
    });
  }

  return {
    trackListingClickEvents: trackListingClickEventsInOmniture
  };
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/ForexCards/index.tsx



function ForexCards_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ForexCards_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ForexCards_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ForexCards_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











































var AssitanceBot = /*#__PURE__*/(/* unused pure expression or super */ null && (lazy(function () {
  return __webpack_require__.e(/* import() | AssistanceBot */ 6089).then(__webpack_require__.bind(__webpack_require__, 8855));
})));
var EditLocationWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (lazy(function () {
  return Promise.all(/* import() | EditLocationWrapper */[__webpack_require__.e(9325), __webpack_require__.e(8875)]).then(__webpack_require__.bind(__webpack_require__, 3407));
})));
var ErrorScreen = /*#__PURE__*/(/* unused pure expression or super */ null && (lazy(function () {
  return __webpack_require__.e(/* import() | ErrorScreen */ 7528).then(__webpack_require__.bind(__webpack_require__, 1777));
})));
var ASSISTANCE_FLOW_TYPE = {
  MYRA: "MYRA",
  IVR: "IVR"
};

var ForexCards_ForexCards = function ForexCards(_ref) {
  var _offer_persuasions$6, _offer_persuasions$7, _offer_persuasions$7$;

  var getonLoginCallback = _ref.getonLoginCallback;
  var listingDetailsReqIdRef = useRef(null);
  var device = useDevice();

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner,
      isLoggedInUser = _useGlobalConfig.isLoggedInUser,
      mobileNumberRequiredError = _useGlobalConfig.mobileNumberRequiredError;

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      isErrorDeliveryDetails = _useGlobalSelector.isErrorDeliveryDetails,
      downtime = _useGlobalSelector.downtime,
      persona = _useGlobalSelector.persona,
      isSuccessListingDetailsOnLocChange = _useGlobalSelector.isSuccessListingDetailsOnLocChange,
      forex_rates = _useGlobalSelector.forex_rates,
      tm_user_id = _useGlobalSelector.tm_user_id,
      products = _useGlobalSelector.products,
      puid = _useGlobalSelector.puid,
      offer_persuasions = _useGlobalSelector.offer_persuasions,
      recommended_currencies_ticker = _useGlobalSelector.recommended_currencies_ticker,
      experiments = _useGlobalSelector.experiments,
      _useGlobalSelector$be = _useGlobalSelector.best_rate_hyperlink,
      best_rate_hyperlink = _useGlobalSelector$be === void 0 ? "" : _useGlobalSelector$be,
      assistance_flow = _useGlobalSelector.assistance_flow,
      pricing_nudge = _useGlobalSelector.pricing_nudge,
      delivery_nudge = _useGlobalSelector.delivery_nudge;

  var _ref2 = persona || {},
      upcomingTrip = _ref2.upcoming_trip;

  var _useFetchListingPostL = useFetchListingPostLocationChange(isLoggedInUser, listingDetailsReqIdRef),
      isLocationFetching = _useFetchListingPostL.isLocationFetching,
      isPageLoading = _useFetchListingPostL.isPageLoading,
      locFetchingMode = _useFetchListingPostL.locFetchingMode,
      showEmailLoginPopup = _useFetchListingPostL.showEmailLoginPopup,
      setShowEmailLoginPopup = _useFetchListingPostL.setShowEmailLoginPopup;

  var _useState = useState(false),
      isEditLocModalOpen = _useState[0],
      setEditModalLocOpen = _useState[1];

  var _useState2 = useState(false),
      showCouponsModal = _useState2[0],
      setShowCouponsModal = _useState2[1];

  var _useState3 = useState(false),
      showPriceRatesModal = _useState3[0],
      setShowPriceRatesModal = _useState3[1];

  var _useListingPdtLogger = useListingPdtLogger(),
      sendListingPdtEventOnLocationBarClick = _useListingPdtLogger.sendListingPdtEventOnLocationBarClick,
      sendPdtProductTilesCtaClickEvent = _useListingPdtLogger.sendPdtProductTilesCtaClickEvent,
      sendPdtPersuasionLinkCtaClickEvent = _useListingPdtLogger.sendPdtPersuasionLinkCtaClickEvent,
      sendPdtFDOCtaClickEvent = _useListingPdtLogger.sendPdtFDOCtaClickEvent,
      sendPdtUnavailableLocationCtaClickEvent = _useListingPdtLogger.sendPdtUnavailableLocationCtaClickEvent,
      sendPdtLocationBottomSheetViewEvent = _useListingPdtLogger.sendPdtLocationBottomSheetViewEvent,
      sendPdtViewDashboardCtaClickEvent = _useListingPdtLogger.sendPdtViewDashboardCtaClickEvent,
      sendPdtViewOrdersCtaClickEvent = _useListingPdtLogger.sendPdtViewOrdersCtaClickEvent,
      sendPdtCouponShown = _useListingPdtLogger.sendPdtCouponShown,
      sendPdtViewCoupons = _useListingPdtLogger.sendPdtViewCoupons,
      sendPdtListingPageViewEvent = _useListingPdtLogger.sendPdtListingPageViewEvent,
      sendCtaEvent = _useListingPdtLogger.sendCtaEvent,
      myraIconShownPdtLoadEvent = _useListingPdtLogger.myraIconShownPdtLoadEvent;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendCTAData = _useListingPdtLoggerV.sendCTAData,
      sendPdtLocationBottomSheetViewEventV2 = _useListingPdtLoggerV.sendPdtLocationBottomSheetViewEventV2,
      sendPdtDataV2 = _useListingPdtLoggerV.sendPdtDataV2;

  var _useForexWidgetProps = useForexWidgetProps(),
      mobileTitle = _useForexWidgetProps.mobileTitle,
      showTickerAtBottomInMobile = _useForexWidgetProps.showTickerAtBottomInMobile,
      landingPinnedCardShowcaseData = _useForexWidgetProps.landingPinnedCardShowcaseData,
      landingCardShowcaseData = _useForexWidgetProps.landingCardShowcaseData,
      deliveryDetailsContent = _useForexWidgetProps.deliveryDetailsContent,
      deliveryDetailsContentV3 = _useForexWidgetProps.deliveryDetailsContentV3;

  var _useTrackListingClick = useTrackListingClickEvent(),
      trackListingClickEvents = _useTrackListingClick.trackListingClickEvents;

  var version = VERSIONS.V3;
  var TopShowCaseComp = version === VERSIONS.V3 ? TopShowcaseV3 : TopShowcase;

  var _useFetchCardCtaSigna = useFetchCardCtaSignalState(),
      isLoadingCardCtaSignalState = _useFetchCardCtaSigna.isLoadingCardCtaSignalState,
      isErrorCardCtaSignalState = _useFetchCardCtaSigna.isErrorCardCtaSignalState;

  var _useState4 = useState(isErrorCardCtaSignalState),
      showCardCtaErrorScreen = _useState4[0],
      setShowCardCtaErrorScreen = _useState4[1];

  var _useCoachmarks = useCoachmarks(),
      showCurrencyOrderCoachmark = _useCoachmarks.showCurrencyOrderCoachmark,
      closeCurrencyOrderCoachmark = _useCoachmarks.closeCurrencyOrderCoachmark;

  var _useRedirectionUrls = useRedirectionUrls(),
      landingPageRedirect = _useRedirectionUrls.landingPageRedirect,
      quickLoadMoneyRedirections = _useRedirectionUrls.quickLoadMoneyRedirections,
      redirectUploadDocs = _useRedirectionUrls.redirectUploadDocs,
      trackCardRedirections = _useRedirectionUrls.trackCardRedirections,
      viewDashboardRedirections = _useRedirectionUrls.viewDashboardRedirections,
      viewOrdersRedirections = _useRedirectionUrls.viewOrdersRedirections,
      startOrderRedirections = _useRedirectionUrls.startOrderRedirections,
      reloadTripRedirection = _useRedirectionUrls.reloadTripRedirection;

  var _useRedirectForexProd = useRedirectForexProductLinksV2(),
      redirectForexProductLinksV2 = _useRedirectForexProd.redirectForexProductLinksV2;

  var locationFetchingScreenLabel = getLocationFetchingScreenLabel(locFetchingMode, deliveryDetailsContent, persona, version, isErrorDeliveryDetails);
  var locationFetchingScreenLabelV3 = getLocationFetchingScreenLabel(locFetchingMode, deliveryDetailsContentV3, persona, version, isErrorDeliveryDetails);
  var pdtExperimentDetailsObj = getExperimentDetails(getExperimentDetailsForPdt(experiments));

  var _useScrolledMwebHeade = useScrolledMwebHeaderContent(),
      scrolledMWebHeaderContent = _useScrolledMwebHeade.scrolledMWebHeaderContent;

  var _useOpenLoginForm = useOpenLoginForm(),
      openLoginFormForNonLoggedInUser = _useOpenLoginForm.openLoginFormForNonLoggedInUser;

  var dispatch = useGlobalDispatch();
  useRefreshCurrencyRates(); // Pass callback to consumer app, it will be called once the user login on partner platform successfully.

  useEffect(function () {
    getonLoginCallback === null || getonLoginCallback === void 0 ? void 0 : getonLoginCallback(refreshPage);
  }, []);
  useFreezeBodyScroll(showCouponsModal);
  var showAssistanceBotMyra = (assistance_flow === null || assistance_flow === void 0 ? void 0 : assistance_flow.type) === ASSISTANCE_FLOW_TYPE.MYRA;
  useEffect(function () {
    if (showAssistanceBotMyra) {
      myraIconShownPdtLoadEvent();
      sendPdtDataV2({
        event_detail: getEventDetails({
          event_name: PDT_EVENTS.LISTING_MYRA_BOT_ICON_SHOWN
        })
      });
    }
  }, [showAssistanceBotMyra]);
  useEffect(function () {
    setShowCardCtaErrorScreen(isErrorCardCtaSignalState);
  }, [isErrorCardCtaSignalState]);
  useEffect(function () {
    setSessionStorageItem(SESSION_STORAGE_KEYS.FOREX_EXPERIMENTS, experiments);
  }, [experiments, device]);
  useEffect(function () {
    var _offer_persuasions$, _offer_persuasions$2, _offer_persuasions$2$, _offer_persuasions$5;

    if ([OFFER_TYPES.CROSS_SELL_HOTEL, OFFER_TYPES.CROSS_SELL_FLIGHT].includes((offer_persuasions === null || offer_persuasions === void 0 ? void 0 : (_offer_persuasions$ = offer_persuasions[0]) === null || _offer_persuasions$ === void 0 ? void 0 : _offer_persuasions$.type) || "") && offer_persuasions !== null && offer_persuasions !== void 0 && (_offer_persuasions$2 = offer_persuasions[0]) !== null && _offer_persuasions$2 !== void 0 && (_offer_persuasions$2$ = _offer_persuasions$2.value) !== null && _offer_persuasions$2$ !== void 0 && _offer_persuasions$2$.text) {
      var _offer_persuasions$3, _offer_persuasions$3$, _offer_persuasions$4, _details$, _details$2;

      var details = offer_persuasions === null || offer_persuasions === void 0 ? void 0 : (_offer_persuasions$3 = offer_persuasions[0]) === null || _offer_persuasions$3 === void 0 ? void 0 : (_offer_persuasions$3$ = _offer_persuasions$3.value) === null || _offer_persuasions$3$ === void 0 ? void 0 : _offer_persuasions$3$.details;
      var couponShown = "".concat((_offer_persuasions$4 = offer_persuasions[0]) === null || _offer_persuasions$4 === void 0 ? void 0 : _offer_persuasions$4.type, "-").concat(details === null || details === void 0 ? void 0 : (_details$ = details[0]) === null || _details$ === void 0 ? void 0 : _details$.booking_id, "-").concat(details === null || details === void 0 ? void 0 : (_details$2 = details[0]) === null || _details$2 === void 0 ? void 0 : _details$2.coupon_cashback);
      var totalCoupons = (details === null || details === void 0 ? void 0 : details.length) || 0;
      sendPdtCouponShown(PDT_EVENTS.LISTING_COUPON_SHOWN, couponShown, totalCoupons);
      sendCTAData({
        eventDetail: getEventDetails({
          event_name: PDT_EVENTS.LISTING_COUPON_SHOWN,
          event_value: "".concat(couponShown, "--Total Coupons-").concat(totalCoupons)
        })
      });
    } else if ((offer_persuasions === null || offer_persuasions === void 0 ? void 0 : (_offer_persuasions$5 = offer_persuasions[0]) === null || _offer_persuasions$5 === void 0 ? void 0 : _offer_persuasions$5.type) === OFFER_TYPES.SALE_COUPONS) {
      sendPdtCouponShown(PDT_EVENTS.LISTING_COUPON_SHOWN, OFFER_TYPES.SALE_COUPONS, 1);
      sendCTAData({
        eventDetail: getEventDetails({
          event_name: PDT_EVENTS.LISTING_COUPON_SHOWN,
          event_value: "".concat(OFFER_TYPES.SALE_COUPONS, "--Total Coupons-1")
        })
      });
    }
  }, [offer_persuasions]);
  useEffect(function () {
    if (isSuccessListingDetailsOnLocChange && getHostName() !== HOST.MAKEMYTRIP) {
      var deliveryDetails = getSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, true, getSessionPiiDataOpts) || null;
      sendPdtListingPageViewEvent({
        persona: persona,
        forex_rates: forex_rates,
        tm_user_id: tm_user_id,
        products: products,
        puid: puid
      });

      var _ref3 = upcomingTrip !== null && upcomingTrip !== void 0 ? upcomingTrip : {},
          intl_travel = _ref3.intl_travel,
          country_code = _ref3.country_code,
          start_date = _ref3.start_date,
          end_date = _ref3.end_date;

      sendPdtDataV2({
        event_detail: getEventDetails({
          event_name: PDT_EVENTS.PAGE_LOAD_EVENT,
          upcoming_trip: {
            intl_travel: intl_travel,
            trip_details: [{
              country_code: country_code,
              start_date: start_date,
              end_date: end_date
            }]
          },
          delivery_details: getDeliveryDetails({
            city: deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.city,
            pincode: deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.pincode,
            deliverable: deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.deliverable,
            eta: deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.eta_in_days,
            state: deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.state,
            state_code: deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.state_code
          }),
          components: getComponentsPdt({
            content_details: [{
              description: Object.keys(pricing_nudge || {}).length > 0 ? "RATE_INCREASE_NUDGE" : "NA"
            }, {
              description: Object.keys(delivery_nudge || {}).length > 0 ? "ORDER_TIMER" : "NA"
            }]
          })
        }),
        event_tracking_context: getEventTrackingContext({
          request_id: listingDetailsReqIdRef.current
        }),
        experiment_details: pdtExperimentDetailsObj
      });
    }
  }, [isSuccessListingDetailsOnLocChange]); // FOR LANDING FEATURES CARD

  var loadCurrenyBtnHandler = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
      var eventDetail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isLoggedInUser) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return openLoginFormForNonLoggedInUser();

            case 3:
              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return sendPdtPersuasionLinkCtaClickEvent(PDT_EVENTS.QUICK_LOAD_CTA, item.label);

            case 6:
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.QUICK_LOAD_CTA,
                event_value: item.label
              });
              sendPdtDataV2({
                event_detail: eventDetail,
                experiment_details: pdtExperimentDetailsObj
              });
              trackListingClickEvents({
                actionType: CARD_TO_ACTION_QUICKLOAD_MAPPING[item.label]
              });
              quickLoadMoneyRedirections(item);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadCurrenyBtnHandler(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var recommendedBtnHandler = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
      var eventDetail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (isLoggedInUser) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return openLoginFormForNonLoggedInUser();

            case 3:
              return _context2.abrupt("return");

            case 4:
              _context2.next = 6;
              return sendPdtPersuasionLinkCtaClickEvent(PDT_EVENTS.TRACK_CARD_CTA, item.label);

            case 6:
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.TRACK_CARD_CTA,
                event_value: item.label
              });
              sendCTAData({
                eventDetail: eventDetail
              });
              trackListingClickEvents({
                actionType: "track_button_clicked"
              });
              trackCardRedirections(item);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function recommendedBtnHandler(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  var startFromWhereLeftHandler = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
      var eventDetail, reqId;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              sendPdtFDOCtaClickEvent(item.label);
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.COMPLETE_ORDER_CTA,
                event_value: item.label
              });
              reqId = generateRequestId();
              sendCTAData({
                eventDetail: eventDetail,
                event_tracking_context: getEventTrackingContext({
                  request_id: reqId
                })
              });
              trackListingClickEvents({
                actionType: CARD_TO_ACTION_RESUME_MAPPING[item.label]
              });
              _context3.next = 7;
              return sendXpressRtEvent(item);

            case 7:
              _context3.next = 9;
              return redirectForexProductLinksV2(item, reqId);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function startFromWhereLeftHandler(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();

  var pinnedShowcaseCardHandler = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item) {
      var eventDetail, reqId;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return sendPdtProductTilesCtaClickEvent(item.label);

            case 2:
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.PRODUCT_TILE_CTA,
                event_value: item.label
              });
              reqId = generateRequestId();
              sendCTAData({
                eventDetail: eventDetail,
                event_tracking_context: getEventTrackingContext({
                  request_id: reqId
                })
              });
              trackListingClickEvents({
                actionType: CARD_TO_ACTION_MAPPING[item.label]
              });
              _context4.next = 8;
              return sendXpressRtEvent(item);

            case 8:
              _context4.next = 10;
              return redirectForexProductLinksV2(item, reqId);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function pinnedShowcaseCardHandler(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  var otherShowcaseCardsHandler = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(item) {
      var eventDetail, reqId;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return sendPdtProductTilesCtaClickEvent(item.label);

            case 2:
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.PRODUCT_TILE_CTA,
                event_value: item.label
              });
              reqId = generateRequestId();
              sendCTAData({
                eventDetail: eventDetail,
                event_tracking_context: getEventTrackingContext({
                  request_id: reqId
                })
              });
              trackListingClickEvents({
                actionType: CARD_TO_ACTION_MAPPING[item.label]
              });
              _context5.next = 8;
              return sendXpressRtEvent(item);

            case 8:
              _context5.next = 10;
              return redirectForexProductLinksV2(item, reqId);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function otherShowcaseCardsHandler(_x5) {
      return _ref8.apply(this, arguments);
    };
  }();

  var docsPendingHandler = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(item) {
      var eventDetail;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (isLoggedInUser) {
                _context6.next = 4;
                break;
              }

              _context6.next = 3;
              return openLoginFormForNonLoggedInUser();

            case 3:
              return _context6.abrupt("return");

            case 4:
              _context6.next = 6;
              return sendPdtPersuasionLinkCtaClickEvent(PDT_EVENTS.UPLOAD_DOCS_CTA, item.label);

            case 6:
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.UPLOAD_DOCS_CTA,
                event_value: item.label
              });
              sendCTAData({
                eventDetail: eventDetail
              });
              redirectUploadDocs(item);

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function docsPendingHandler(_x6) {
      return _ref9.apply(this, arguments);
    };
  }();

  var editLocationHandler = function editLocationHandler() {
    setEditModalLocOpen(true);
    sendListingPdtEventOnLocationBarClick();
    sendCTAData({
      eventDetail: getEventDetails({
        event_name: PDT_EVENTS.LOCATION_BAR_CTA
      })
    });
    sendPdtLocationBottomSheetViewEvent();
    sendPdtLocationBottomSheetViewEventV2();
    trackListingClickEvents({
      actionType: "location_dropdown_clicked"
    });
  };

  var deliveryUnavailbleClickHandler = function deliveryUnavailbleClickHandler(e) {
    e.stopPropagation();
    setEditModalLocOpen(true);
    sendListingPdtEventOnLocationBarClick();
    sendPdtLocationBottomSheetViewEvent();
    trackListingClickEvents({
      actionType: "location_dropdown_clicked"
    });
  };

  var onEditLocModalClose = function onEditLocModalClose() {
    setEditModalLocOpen(false);
  };

  var onClickAnotherLocation = function onClickAnotherLocation(item) {
    sendPdtUnavailableLocationCtaClickEvent(item.label);
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.UNAVAILABLE_LOC,
      event_value: item.label
    });
    sendCTAData({
      eventDetail: eventDetail
    });
    setEditModalLocOpen(true);
  };

  var checkPincodeHandler = function checkPincodeHandler() {
    setEditModalLocOpen(true);
    trackListingClickEvents({
      actionType: "location_dropdown_clicked"
    });
  };

  function refreshPage() {
    window.location.reload();
  }

  var onClickBackFromErrorScreen = function onClickBackFromErrorScreen() {
    setShowCardCtaErrorScreen(false);
  };

  var viewDashBoardClickHandler = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(data) {
      var eventDetail;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (isLoggedInUser) {
                _context7.next = 4;
                break;
              }

              _context7.next = 3;
              return openLoginFormForNonLoggedInUser();

            case 3:
              return _context7.abrupt("return");

            case 4:
              _context7.next = 6;
              return sendPdtViewDashboardCtaClickEvent(data === null || data === void 0 ? void 0 : data.label);

            case 6:
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.VIEW_DASHBOARD,
                event_value: data === null || data === void 0 ? void 0 : data.label
              });
              sendPdtDataV2({
                event_detail: eventDetail,
                experiment_details: pdtExperimentDetailsObj
              });
              viewDashboardRedirections(data);

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function viewDashBoardClickHandler(_x7) {
      return _ref10.apply(this, arguments);
    };
  }();

  var viewOrdersClickHandler = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
      var eventDetail;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (isLoggedInUser) {
                _context8.next = 4;
                break;
              }

              _context8.next = 3;
              return openLoginFormForNonLoggedInUser();

            case 3:
              return _context8.abrupt("return");

            case 4:
              _context8.next = 6;
              return sendPdtViewOrdersCtaClickEvent(data === null || data === void 0 ? void 0 : data.label);

            case 6:
              // Need to be changed
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.VIEW_ORDERS,
                event_value: data === null || data === void 0 ? void 0 : data.label
              });
              sendCTAData({
                eventDetail: eventDetail
              });
              viewOrdersRedirections(data);

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function viewOrdersClickHandler(_x8) {
      return _ref11.apply(this, arguments);
    };
  }();

  var onCloseEmailLogin = function onCloseEmailLogin() {
    setShowEmailLoginPopup(false);

    if (getDeviceType() === DEVICE_MODEL_TYPE.APP) {
      closeWebview();
      return;
    }

    if (getPartner() === MakeMyTrip) {
      if (isMobile()) {
        redirectInterceptHref(PROFILE_URL.MMT_PWA, true);
      } else {
        redirectInterceptHref(PROFILE_URL.MMT_DT, true);
      }

      return;
    } else if (getPartner() === Goibibo) {
      redirectInterceptHref(PROFILE_URL.GI, true);
      return;
    }
  };

  var handleLoginClick = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dispatch(updateForceLoginEmailModal(false));

              if (!mobileNumberRequiredError) {
                _context9.next = 4;
                break;
              }

              dispatchEmailLoginCustomEvent(true);
              return _context9.abrupt("return");

            case 4:
              if (isLoggedInUser) {
                _context9.next = 8;
                break;
              }

              _context9.next = 7;
              return openLoginFormForNonLoggedInUser();

            case 7:
              return _context9.abrupt("return");

            case 8:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function handleLoginClick() {
      return _ref12.apply(this, arguments);
    };
  }();

  var startOrderClicked = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(data) {
      var _data$startOrder;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              sendPdtPersuasionLinkCtaClickEvent(PDT_EVENTS.START_ORDER_CTA, (_data$startOrder = data.startOrder) === null || _data$startOrder === void 0 ? void 0 : _data$startOrder.linkBtnInMobile.label);
              _context10.next = 3;
              return sendXpressRtEvent(data);

            case 3:
              startOrderRedirections(data);

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function startOrderClicked(_x9) {
      return _ref13.apply(this, arguments);
    };
  }();

  var sendXpressRtEvent = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(data) {
      var _getSessionStorageIte;

      var apiUrl, xpressRtData, city_code, _ref15, country_code, start_date, end_date;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (isLoggedInUser) {
                _context11.next = 2;
                break;
              }

              return _context11.abrupt("return");

            case 2:
              if (!isAgentFlow()) {
                _context11.next = 4;
                break;
              }

              return _context11.abrupt("return");

            case 4:
              apiUrl = getXpressRtApiUrl(partner);
              xpressRtData = {};
              city_code = ((_getSessionStorageIte = getSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, true, getSessionPiiDataOpts)) === null || _getSessionStorageIte === void 0 ? void 0 : _getSessionStorageIte.city_code) || "";
              xpressRtData.source = getPageName();
              xpressRtData.current_city = city_code;
              xpressRtData.product = (data === null || data === void 0 ? void 0 : data.id) || "";
              _ref15 = upcomingTrip !== null && upcomingTrip !== void 0 ? upcomingTrip : {}, country_code = _ref15.country_code, start_date = _ref15.start_date, end_date = _ref15.end_date;
              xpressRtData.trip_details = {
                country: country_code || "",
                start_timestamp: start_date,
                end_timestamp: end_date,
                currency: "",
                amount: null
              };
              _context11.next = 14;
              return postXpressRtData(apiUrl, xpressRtData);

            case 14:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function sendXpressRtEvent(_x10) {
      return _ref14.apply(this, arguments);
    };
  }();

  function handleAvatarClick() {
    if (version === VERSIONS.V3) {
      viewOrdersClickHandler({
        label: "avatar_click",
        version: VERSIONS.V3
      });
    }
  }

  var locationFetchingDataProps = getLocationFetchingDataProps(locFetchingMode, isLocationFetching, locationFetchingScreenLabel);
  var locationFetchingDataPropsV3 = getLocationFetchingDataProps(locFetchingMode, isLocationFetching, locationFetchingScreenLabelV3);
  var sectionBgImgURI = getSectionBgImgURI(version, isLocationFetching);
  var landingTitle = getLandingTitle(mobileTitle);
  var otherProductsText = getOtherProductsText(landingCardShowcaseData, version);
  var deliveryPersuasion = getDeliveryPersuasion(deliveryDetailsContent, checkPincodeHandler, editLocationHandler);
  var otherShowcaseCardsData = getOtherShowcaseCardsData(landingCardShowcaseData, otherShowcaseCardsHandler);
  var viewOrderLabel = getViewOrderLabel(isLoggedInUser);

  var sendCrossSellPdtEvent = function sendCrossSellPdtEvent(_ref16) {
    var eventName = _ref16.eventName,
        eventValue = _ref16.eventValue;
    sendCtaEvent({
      eventName: eventName,
      primaryValue: eventValue
    });
    sendPdtDataV2({
      event_detail: getEventDetails({
        event_name: eventName,
        event_value: eventValue
      })
    });
  };

  var reloadTripHandler = function reloadTripHandler(data) {
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.RELOAD_CURRENT_TRIP,
      event_value: data === null || data === void 0 ? void 0 : data.label
    });
    sendCTAData({
      eventDetail: eventDetail
    });
    reloadTripRedirection(data);
  };

  var effectiveRateBanner = getEffectiveRateBannerLabel({
    offerPersuasions: offer_persuasions,
    device: device
  });
  var tickerModalProps = getPropsForTickerModal({
    forexRateTicker: recommended_currencies_ticker,
    offerPersuasions: offer_persuasions
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [downtime === true ? /*#__PURE__*/_jsx(DowntimeModal, {}) : null, /*#__PURE__*/_jsx(GlobalStyles, {}), /*#__PURE__*/_jsx(TopShowCaseComp, {
      pricingNudge: pricing_nudge,
      deliveryNudge: delivery_nudge,
      isShowDiscountBanner: false,
      discountBannerBgColor: device !== "lg" && (offer_persuasions === null || offer_persuasions === void 0 ? void 0 : (_offer_persuasions$6 = offer_persuasions[0]) === null || _offer_persuasions$6 === void 0 ? void 0 : _offer_persuasions$6.type) === OFFER_TYPES.CROSS_SELL_HOTEL && offer_persuasions !== null && offer_persuasions !== void 0 && (_offer_persuasions$7 = offer_persuasions[0]) !== null && _offer_persuasions$7 !== void 0 && (_offer_persuasions$7$ = _offer_persuasions$7.value) !== null && _offer_persuasions$7$ !== void 0 && _offer_persuasions$7$.text ? theme.greenBg : "",
      reloadTripHandler: reloadTripHandler,
      isPageLoading: isPageLoading,
      isPageLoadingGif: "https://tripmoneycmsimgak.mmtcdn.com/img/infinity_Loading_min_f0a0b9bcba.gif",
      isPageLoadingText: "Loading Forex Offerings...",
      locationFetchingData: locationFetchingDataProps,
      version: version,
      isMarqueeOnBottom: showTickerAtBottomInMobile,
      otherProductsText: otherProductsText,
      deliveryPersuasion: deliveryPersuasion,
      landingTitle: landingTitle,
      mobileTitle: mobileTitle,
      sectionBgImgURI: sectionBgImgURI // marqueeData={marqueeData}
      ,
      pinnedShowcaseCardData: {
        data: landingPinnedCardShowcaseData,
        onClick: pinnedShowcaseCardHandler
      },
      loadCurrenyBtnHandler: loadCurrenyBtnHandler,
      recommendedBtnHandler: recommendedBtnHandler,
      docsPendingHandler: docsPendingHandler,
      startFromWhereLeftHandler: startFromWhereLeftHandler,
      onClickAnotherLocation: onClickAnotherLocation,
      viewDashBoardClickHandler: viewDashBoardClickHandler,
      viewOrdersClickHandler: viewOrdersClickHandler,
      startOrderClicked: startOrderClicked,
      deliveryUnavailbleClickHandler: deliveryUnavailbleClickHandler,
      otherShowcaseCardsData: otherShowcaseCardsData,
      sendCrossSellPdtEvent: sendCrossSellPdtEvent,
      viewOrderLabel: viewOrderLabel,
      locationFetchingDataV3: locationFetchingDataPropsV3,
      mobileStickyHeadingData: {
        userAvatarImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/listing_avatar_7f9e7d2ae5.png",
        onClickBack: landingPageRedirect,
        isScrolled: scrolledMWebHeaderContent,
        rightCtaTxt: "LOG IN",
        handleLoginClick: handleLoginClick,
        isLoggedIn: isLoggedInUser,
        //isUserLoggedin() as boolean
        handleAvatarClick: handleAvatarClick,
        orderCount: persona === null || persona === void 0 ? void 0 : persona.currency_active_orders,
        showCoachmark: showCurrencyOrderCoachmark,
        coachmarkClickHandler: closeCurrencyOrderCoachmark,
        version: version
      } // Removed this banner as discount period is finished. Can be utilised for future banners
      //update as required
      ,
      discountBanner: getDiscountBannerProps(offer_persuasions, device) // showInfoIcon={
      //     !!(
      //         offer_persuasions?.[0]?.type ===
      //             OFFER_TYPES.CROSS_SELL_HOTEL &&
      //         offer_persuasions?.[0]?.value?.details?.[0]
      //             ?.coupon_cashback
      //     )
      // }
      // discountInfoIconHandler={() => {
      //     if (
      //         offer_persuasions?.[0]?.type ===
      //         OFFER_TYPES.CROSS_SELL_HOTEL
      //     ) {
      //         sendPdtViewCoupons(
      //             PDT_EVENTS.LISTING_VIEW_COUPONS_CLICK
      //         );
      //         sendCTAData({
      //             eventDetail: getEventDetails({
      //                 event_name:
      //                     PDT_EVENTS.LISTING_VIEW_COUPONS_CLICK,
      //             }),
      //         });
      //     }
      //     setShowCouponsModal(true);
      // }}
      ,
      discountOfferHandler: function discountOfferHandler() {
        return setShowCouponsModal(true);
      },
      showEffectiveRateBanner: effectiveRateBanner ? true : false,
      effectiveRateBannerLabel: effectiveRateBanner,
      effectiveRateIconHandler: function effectiveRateIconHandler() {
        return setShowCouponsModal(true);
      },
      priceTickerData: getForexRateTickerProps({
        forexRateTicker: recommended_currencies_ticker,
        offerPersuasions: offer_persuasions
      }),
      showPriceTicker: true,
      viewAllPriceHandler: function viewAllPriceHandler() {
        setShowPriceRatesModal(true);
      },
      desktopLandingTitle: "<span class=\"greenText boldText font16\">Door-step Delivery</span> | Across 185+ Indian cities"
    }), isEditLocModalOpen && /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(PageLoader, {}),
      children: /*#__PURE__*/_jsx(EditLocationWrapper, {
        isModalOpen: isEditLocModalOpen,
        onModalClose: onEditLocModalClose,
        listingDetailsReqIdRef: listingDetailsReqIdRef
      })
    }), isLoadingCardCtaSignalState && /*#__PURE__*/_jsx(PageLoader, {}), showCardCtaErrorScreen && /*#__PURE__*/_jsx(FullPageWrapper, {
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(PageLoader, {}),
        children: /*#__PURE__*/_jsx(ErrorScreen, {
          errorType: "PAGE",
          retryHandler: refreshPage,
          onClickBack: onClickBackFromErrorScreen
        })
      })
    }), showEmailLoginPopup && /*#__PURE__*/_jsx(EmailLoginModal, {
      onClose: onCloseEmailLogin
    }), showCouponsModal && /*#__PURE__*/_jsx(CouponDetailsModal, ForexCards_objectSpread({
      onModalClose: function onModalClose() {
        setShowCouponsModal(false);
      }
    }, getCouponDetailProps(offer_persuasions))), showPriceRatesModal && /*#__PURE__*/_jsx(ForexRatesModal, {
      modalHeading: "Forex Rates",
      onModalClose: function onModalClose() {
        return setShowPriceRatesModal(false);
      },
      title: tickerModalProps.title,
      forexRatesData: tickerModalProps.forexRatesData,
      footerText: tickerModalProps.footerText
    }), showAssistanceBotMyra && /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(AssitanceBot, {
        page: MYRA_PAGE_NAME.LISTING,
        lobCategory: MYRA_LOB_CATEGORY.LISTING
      })
    })]
  });
};

/* harmony default export */ var components_ForexCards = ((/* unused pure expression or super */ null && (ForexCards_ForexCards)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/ForexCardsWidget/index.tsx


function ForexCardsWidget_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ForexCardsWidget_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ForexCardsWidget_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ForexCardsWidget_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var ForexCardsWidget = function ForexCardsWidget(props) {
  return /*#__PURE__*/_jsx(ForexCards, ForexCardsWidget_objectSpread({}, props));
};
/* harmony default export */ var components_ForexCardsWidget = ((/* unused pure expression or super */ null && (ForexCardsWidget)));

/***/ }),

/***/ 1125:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/mockData/index.tsx
var mockData = __webpack_require__(8403);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/ListingPageComponents.style.ts
var ListingPageComponents_style = __webpack_require__(7998);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.tsx + 1 modules
var BulletListItem_BulletListItem = __webpack_require__(2357);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/LandingButton/LandingButton.tsx
var LandingButton_LandingButton = __webpack_require__(1152);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/H3Tag.tsx
var TextStyles_H3Tag = __webpack_require__(8830);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/SpanTag.tsx
var TextStyles_SpanTag = __webpack_require__(3634);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/PersuasionBanner/PersuasionBanner.style.tsx

var PersuasionBanner_style_PersuasionBannerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PersuasionBannerstyle__PersuasionBannerStyle",
  componentId: "sc-6vw0fv-0"
})(["", " padding:40px 60px;border-radius:25px;background-image:", ";background-size:100% 100%;min-height:400px;background-repeat:no-repeat;"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return "url(".concat(props.bgImage, ")");
});
var PersuasionBanner_style_BulletListStyle = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "PersuasionBannerstyle__BulletListStyle",
  componentId: "sc-6vw0fv-1"
})(["list-style:none;margin-bottom:40px;padding:0;"]);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/PersuasionBanner/PersuasionBanner.tsx










var PersuasionBanner_PersuasionBanner = function PersuasionBanner(_ref) {
  var heading = _ref.heading,
      bgImage = _ref.bgImage,
      bulletPoints = _ref.bulletPoints,
      btnText = _ref.btnText,
      margin = _ref.margin,
      btnHandler = _ref.btnHandler;
  return /*#__PURE__*/_jsxs(PersuasionBannerStyle, {
    margin: margin,
    bgImage: bgImage,
    children: [/*#__PURE__*/_jsx(H3Tag, {
      margin: "0px 0px 24px 0px",
      children: heading
    }), (bulletPoints === null || bulletPoints === void 0 ? void 0 : bulletPoints.length) > 0 && /*#__PURE__*/_jsx(BulletListStyle, {
      children: bulletPoints.map(function (item) {
        return /*#__PURE__*/_jsxs(BulletListItem, {
          children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
            fontWeight: "bold",
            children: item.boldText
          }), " ", /*#__PURE__*/_jsx(SpanTag, {
            children: item.normalText
          })]
        }, item.id);
      })
    }), /*#__PURE__*/_jsx(LandingButton, {
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.CURR_CARD, ElementNameMapping.EXPLORE_MORE_BTN),
      customTitle: btnText,
      onClick: btnHandler,
      padding: "0px 40px"
    })]
  });
};

/* harmony default export */ var components_PersuasionBanner_PersuasionBanner = ((/* unused pure expression or super */ null && (PersuasionBanner_PersuasionBanner)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useDevice.ts
var hooks_useDevice = __webpack_require__(5187);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useRedirectionUrls/index.ts + 3 modules
var hooks_useRedirectionUrls = __webpack_require__(4155);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(4334);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useOpenLoginForm/index.ts
var hooks_useOpenLoginForm = __webpack_require__(5426);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalConfig.ts
var hooks_useGlobalConfig = __webpack_require__(588);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var hooks_useGlobalSelector = __webpack_require__(2053);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/ForexCurrencyCard/index.tsx














var persuasionBanner = {
  data: mockData/* persuasionData */.uW,
  bgImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/listing_coins_bg_2ec4b8ddab.png",
  btnTitle: "EXPLORE FOREX CURRENCY",
  title: "Order Genuine Foreign Currency Notes"
};

var ForexCurrencyCard = function ForexCurrencyCard() {
  var device = useDevice();
  return device === "lg" ? /*#__PURE__*/_jsx(ForexCurrencyCardContainer, {}) : null;
};

/* harmony default export */ var components_ForexCurrencyCard = ((/* unused pure expression or super */ null && (ForexCurrencyCard)));

var ForexCurrencyCardContainer = function ForexCurrencyCardContainer() {
  var _useGlobalConfig = useGlobalConfig(),
      isLoggedInUser = _useGlobalConfig.isLoggedInUser;

  var _useRedirectionUrls = useRedirectionUrls(),
      exploreForexCurrencyRedirection = _useRedirectionUrls.exploreForexCurrencyRedirection;

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      products = _useGlobalSelector.products;

  var _useOpenLoginForm = useOpenLoginForm(),
      openLoginFormForNonLoggedInUser = _useOpenLoginForm.openLoginFormForNonLoggedInUser;

  var onClickForexCurrency = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cardValue;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isLoggedInUser) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return openLoginFormForNonLoggedInUser();

            case 3:
              return _context.abrupt("return");

            case 4:
              cardValue = getCardValue(products, CARD_TYPE.CURRENCY);
              exploreForexCurrencyRedirection(cardValue);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onClickForexCurrency() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(WhiteBackgroundStyled, {
    children: /*#__PURE__*/_jsx(BMFListingContainer, {
      children: /*#__PURE__*/_jsx(PersuasionBanner, {
        heading: persuasionBanner.title,
        bgImage: persuasionBanner.bgImgURI,
        btnText: persuasionBanner.btnTitle,
        bulletPoints: persuasionBanner.data,
        btnHandler: onClickForexCurrency
      })
    })
  });
};

/***/ }),

/***/ 6823:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useDevice.ts
var hooks_useDevice = __webpack_require__(5187);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalConfig.ts
var hooks_useGlobalConfig = __webpack_require__(588);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var hooks_useGlobalSelector = __webpack_require__(2053);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useListingPdtLoggerV2/index.ts
var hooks_useListingPdtLoggerV2 = __webpack_require__(2221);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useOpenLoginForm/index.ts
var hooks_useOpenLoginForm = __webpack_require__(5426);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts + 3 modules
var usePdtLogger = __webpack_require__(761);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useRedirectionUrls/index.ts + 3 modules
var hooks_useRedirectionUrls = __webpack_require__(4155);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(4334);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(4575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingFaq/LandingFaq.style.ts
var LandingFaq_style = __webpack_require__(5423);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/ParaTag.tsx
var TextStyles_ParaTag = __webpack_require__(8135);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/AnchorTag.tsx
var TextStyles_AnchorTag = __webpack_require__(19);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/analytics/index.ts + 6 modules
var analytics = __webpack_require__(1619);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/FlexComp/FlexComp.tsx + 1 modules
var FlexComp_FlexComp = __webpack_require__(8575);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingFaq/LandingFaqV2.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var LandingFaqV2_LandingFaqV2 = function LandingFaqV2(_ref) {
  var _data$find, _data$find$faqData;

  var customTitle = _ref.customTitle,
      customFaq = _ref.customFaq,
      faq = _ref.faq,
      margin = _ref.margin,
      id = _ref.id,
      padding = _ref.padding,
      faqAnswerLinkTextOnClick = _ref.faqAnswerLinkTextOnClick,
      onTabClick = _ref.onTabClick;

  var _useState = useState(-1),
      exp = _useState[0],
      setExp = _useState[1];

  var device = useDevice();

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtFaqClickEvent = _useListingPdtLogger.sendPdtFaqClickEvent;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtDataV2 = _useListingPdtLoggerV.sendPdtDataV2;

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner;

  var _useState2 = useState(faq),
      data = _useState2[0],
      setData = _useState2[1];

  var handleClick = function handleClick(index, item) {
    exp != index ? setExp(index) : setExp(-1);
    sendPdtDataV2({
      event_detail: getEventDetails({
        event_name: PDT_EVENTS.FAQ_CTA,
        event_value: item.ques
      })
    });
    sendPdtFaqClickEvent(item.ques);
    trackListingClickEvents({
      actionType: "faq_".concat(index + 1, "_clicked"),
      partner: partner
    });
  };

  var textWithLinkRenderer = function textWithLinkRenderer(textList) {
    return textList.map(function (item) {
      if (item.linkText) {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [" ", /*#__PURE__*/_jsx(AnchorTag, {
            fontSize: device === "lg" ? "md" : "sm",
            handleClick: faqAnswerLinkTextOnClick ? function (e) {
              e.stopPropagation();
              faqAnswerLinkTextOnClick(item);
            } : function () {},
            hrefProp: item.href,
            children: item.linkText
          }), " "]
        });
      }

      return /*#__PURE__*/_jsx("span", {
        dangerouslySetInnerHTML: {
          __html: item.text
        }
      });
    });
  };

  var handleTabClick = function handleTabClick(item) {
    onTabClick(item.id);
    setData(data === null || data === void 0 ? void 0 : data.map(function (dataItem) {
      return (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id) === (item === null || item === void 0 ? void 0 : item.id) ? _objectSpread(_objectSpread({}, dataItem), {}, {
        isSelected: true
      }) : _objectSpread(_objectSpread({}, dataItem), {}, {
        isSelected: false
      });
    }));
  };

  return /*#__PURE__*/_jsx(LandingFaqStyle, {
    id: id,
    margin: margin,
    customFaq: customFaq,
    padding: padding,
    children: /*#__PURE__*/_jsxs(InnerContentWrap, {
      children: [customTitle && /*#__PURE__*/_jsx(LandingFaqTitle, {
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.FAQs, ElementNameMapping.COMP_HEADING),
        marginLeft: device === "sm" ? "16px" : "",
        marginBottom: "16px",
        children: customTitle
      }), /*#__PURE__*/_jsx(FlexComp, {
        flexDirection: "row",
        gap: "8px",
        margin: "0px 0px 0px 16px",
        children: data === null || data === void 0 ? void 0 : data.map(function (item) {
          return /*#__PURE__*/_jsx(TabItem, {
            onClick: function onClick() {
              return handleTabClick(item);
            },
            isSelected: item.isSelected,
            children: item.label
          });
        })
      }), data && /*#__PURE__*/_jsx(LandingFaqList, {
        customFaq: customFaq,
        children: data === null || data === void 0 ? void 0 : (_data$find = data.find(function (item) {
          return item.isSelected;
        })) === null || _data$find === void 0 ? void 0 : (_data$find$faqData = _data$find.faqData) === null || _data$find$faqData === void 0 ? void 0 : _data$find$faqData.map(function (item, index) {
          return /*#__PURE__*/_jsxs("li", {
            id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.FAQs.concat(index), ElementNameMapping.DOWN_ARROW),
            className: "".concat(exp == index ? "open_forex" : "close_forex"),
            onClick: function onClick() {
              return handleClick(index, item);
            },
            children: [/*#__PURE__*/_jsx(LandingFaqQues, {
              customFaq: customFaq,
              children: item.ques
            }),  true && /*#__PURE__*/_jsx("div", {
              className: "pointCtr ".concat(exp === index ? "open_forex" : ""),
              children: item.answer && item.answer.map(function (item) {
                return /*#__PURE__*/_jsxs("div", {
                  children: [item.aboveTextList && /*#__PURE__*/_jsx(ParaTag, {
                    color: theme.blackText3,
                    margin: "0px 0px 16px",
                    fontSize: device === "lg" ? "md" : "sm",
                    children: textWithLinkRenderer(item.aboveTextList)
                  }), item.pointsList && /*#__PURE__*/_jsx(LandingInnerPointsCtr, {
                    children: item.pointsList.map(function (ele) {
                      return /*#__PURE__*/_jsxs("div", {
                        children: [ele.label && /*#__PURE__*/_jsx(ParaTag, {
                          dangerousText: ele.label,
                          color: theme.blackText3,
                          fontSize: device === "lg" ? "md" : "sm"
                        }), ele.info && /*#__PURE__*/_jsx(ParaTag, {
                          dangerousText: ele.info,
                          color: theme.blackText3,
                          fontSize: device === "lg" ? "md" : "sm"
                        })]
                      }, ele.id);
                    })
                  }), item.belowTextList && /*#__PURE__*/_jsx(ParaTag, {
                    margin: "0px 0px 24px",
                    fontSize: device === "lg" ? "md" : "sm",
                    color: theme.blackText3,
                    children: textWithLinkRenderer(item.belowTextList)
                  })]
                }, item.id);
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var LandingFaq_LandingFaqV2 = ((/* unused pure expression or super */ null && (LandingFaqV2_LandingFaqV2)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/mockData/index.tsx
var mockData = __webpack_require__(8403);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/ForexLandingFaqs/index.tsx




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function ForexLandingFaqs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ForexLandingFaqs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ForexLandingFaqs_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ForexLandingFaqs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var landingFaqV2 = {
  title: {
    desktop: "FAQs",
    mobile: "FAQs"
  }
};

var ForexLandingFaqs = function ForexLandingFaqs(_ref) {
  var id = _ref.id;

  var _useGlobalConfig = useGlobalConfig(),
      isLoggedInUser = _useGlobalConfig.isLoggedInUser;

  var device = useDevice();

  var _useRedirectionUrls = useRedirectionUrls(),
      redirectKnowMoreCardLinks = _useRedirectionUrls.redirectKnowMoreCardLinks,
      completeOrderRedirections = _useRedirectionUrls.completeOrderRedirections,
      exploreForexCurrencyRedirection = _useRedirectionUrls.exploreForexCurrencyRedirection;

  var _ref2 = useGlobalSelector(function (state) {
    return state;
  }) || {},
      products = _ref2.products,
      version = _ref2.version,
      _ref2$feature_flag = _ref2.feature_flag,
      feature_flag = _ref2$feature_flag === void 0 ? {} : _ref2$feature_flag;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtFaqTabClickEvent = _useListingPdtLogger.sendPdtFaqTabClickEvent;

  var _useOpenLoginForm = useOpenLoginForm(),
      openLoginFormForNonLoggedInUser = _useOpenLoginForm.openLoginFormForNonLoggedInUser;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtDataV2 = _useListingPdtLoggerV.sendPdtDataV2;

  var clickHereHandler = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
      var itemObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              itemObj = ForexLandingFaqs_objectSpread({}, item);
              itemObj.id = CARD_TYPE.MULTI_CURRENCY_CARD;

              if (item.id === FAQ_CLICK_HERE_LINK_ID.WHAT_IS_MX_CARD_CLICK_HERE) {
                redirectKnowMoreCardLinks(itemObj);
              } else if (item.id === FAQ_CLICK_HERE_LINK_ID.HOW_TO_GET_CARD_CLICK_HERE) {
                itemObj.cta = getMXCardCtaObj(products);
                itemObj.feature_flag = feature_flag;
                completeOrderRedirections(itemObj);
              } else if (item.id === FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE) {
                exploreForexCurrencyRedirection(item);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clickHereHandler(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  function onTabClick(tabName) {
    sendPdtFaqTabClickEvent(tabName);
    sendPdtDataV2({
      event_detail: getEventDetails({
        event_name: PDT_EVENTS.FAQ_TAB_CTA,
        event_value: tabName
      })
    });
  }

  return /*#__PURE__*/_jsx(WhiteBackgroundStyled, {
    children: /*#__PURE__*/_jsx(LandingFaqV2, {
      id: id,
      faq: landingFaqDataV2Generator(getPartner()),
      padding: "80px 0px 50px 0px",
      customTitle: device === "lg" ? landingFaqV2.title.desktop : landingFaqV2.title.mobile,
      faqAnswerLinkTextOnClick: clickHereHandler,
      onTabClick: onTabClick
    })
  });
};

/* harmony default export */ var components_ForexLandingFaqs = ((/* unused pure expression or super */ null && (ForexLandingFaqs)));

function getMXCardCtaObj(products) {
  if (!products) {
    return null;
  }

  var _iterator = _createForOfIteratorHelper(products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;

      for (var _i = 0, _Object$entries = Object.entries(product); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            card = _Object$entries$_i[0],
            cardValue = _Object$entries$_i[1];

        if (card === CARD_TYPE.MULTI_CURRENCY_CARD) {
          return cardValue === null || cardValue === void 0 ? void 0 : cardValue.cta;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}

/***/ }),

/***/ 7855:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingOfferingContainer/LandingOfferingContainer.style.ts


var LandingOfferingContainer_style_LandingOfferingContainerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingOfferingContainerstyle__LandingOfferingContainerStyle",
  componentId: "sc-1ono6jd-0"
})(["@media ", "{padding-top:56px;width:90%;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingOfferingContainer_style_ForexOfferingWpr = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingOfferingContainerstyle__ForexOfferingWpr",
  componentId: "sc-1ono6jd-1"
})(["list-style:none;", " width:100%;padding-top:4px;padding-bottom:6px;display:flex;overflow-x:scroll;box-sizing:initial;@media ", "{padding-left:16px;padding-right:16px;}"], function (props) {
  var _props$margin;

  return props.margin && "margin: ".concat((_props$margin = props.margin) !== null && _props$margin !== void 0 ? _props$margin : 0, ";");
}, utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useDevice.ts
var hooks_useDevice = __webpack_require__(5187);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingFaq/LandingFaq.style.ts
var LandingFaq_style = __webpack_require__(5423);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ForexOfferingCard/ForexOfferingCard.style.ts


var ForexOfferingCard_style_ForexOfferingsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexOfferingCardstyle__ForexOfferingsStyle",
  componentId: "sc-854ia2-0"
})(["width:285px;@media ", "{display:flex;flex:1;}overflow:hidden;flex-direction:column;flex-shrink:0;background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:8px;margin:3px;margin:", ";"], utils/* deviceType.desktop */.vO.desktop, function (p) {
  return p.margin ? p.margin : "";
});
var ForexOfferingCard_style_ForexOfferingCntnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexOfferingCardstyle__ForexOfferingCntnt",
  componentId: "sc-854ia2-1"
})(["padding:18px;"]);
var ForexOfferingList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ForexOfferingCardstyle__ForexOfferingList",
  componentId: "sc-854ia2-2"
})(["padding:0px;list-style:none;display:flex;flex-direction:column;gap:4px;margin:0 0 18px 0;li{position:relative;padding:0 0 0 18px;}li:before{content:\"\";position:absolute;background:#008cff;width:5px;height:14px;top:8px;left:0;border-radius:4px;}"]);
var ForexOfferingCard_style_LabelCtr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexOfferingCardstyle__LabelCtr",
  componentId: "sc-854ia2-3"
})(["margin-bottom:20px;"]);
var ForexOfferingCard_style_CardImgContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexOfferingCardstyle__CardImgContainer",
  componentId: "sc-854ia2-4"
})(["width:590px;height:148px;"]);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ImageTag/ImageTag.tsx + 1 modules
var ImageTag_ImageTag = __webpack_require__(4911);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/ParaTag.tsx
var TextStyles_ParaTag = __webpack_require__(8135);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.tsx + 1 modules
var BulletListItem_BulletListItem = __webpack_require__(2357);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(4575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/SpanTag.tsx
var TextStyles_SpanTag = __webpack_require__(3634);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/FlexComp/FlexComp.tsx + 1 modules
var FlexComp_FlexComp = __webpack_require__(8575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/AnchorTag.tsx
var TextStyles_AnchorTag = __webpack_require__(19);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var lib_utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ForexOfferingCard/ForexOfferingCard.tsx














var ForexOfferings = function ForexOfferings(_ref) {
  var data = _ref.data,
      margin = _ref.margin,
      _onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs(ForexOfferingsStyle, {
    margin: margin,
    children: [/*#__PURE__*/_jsx(CardImgContainer, {
      children: /*#__PURE__*/_jsx(ImageTag, {
        src: data.cardImg
      })
    }), /*#__PURE__*/_jsxs(ForexOfferingCntnt, {
      children: [(data.cardTitle || data.cardInfo) && /*#__PURE__*/_jsxs(LabelCtr, {
        children: [data.cardTitle && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "large",
          fontWeight: "bold",
          children: data.cardTitle
        }), data.cardInfo && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          children: data.cardInfo
        })]
      }), /*#__PURE__*/_jsx("ul", {
        children: data.cardFeatList.map(function (item) {
          return /*#__PURE__*/_jsxs(BulletListItem, {
            bulletColor: theme.blueText,
            children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
              fontWeight: "bold",
              children: item.boldText
            }), " ", item.normalText]
          }, item.id);
        })
      }), /*#__PURE__*/_jsx(FlexComp, {
        margin: "22px 0px 0px",
        justifyContent: "center",
        width: "auto",
        height: "auto",
        children: /*#__PURE__*/_jsx(AnchorTag, {
          id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, getCamelCaseStr(data.cardTitle), ElementNameMapping.KNOW_MORE_BTN),
          fontSize: "sm",
          fontWeight: "bold",
          textAlign: "center",
          onClick: function onClick() {
            return _onClick(data);
          },
          children: data.ctaTxt
        })
      })]
    })]
  });
};

/* harmony default export */ var ForexOfferingCard_ForexOfferingCard = ((/* unused pure expression or super */ null && (ForexOfferings)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingOfferingContainer/LandingOfferingContainer.tsx









var LandingOfferingContainer_LandingOfferingContainer = function LandingOfferingContainer(_ref) {
  var heading = _ref.heading,
      data = _ref.data,
      onClickProceed = _ref.onClickProceed;
  var device = useDevice();
  return /*#__PURE__*/_jsxs(LandingOfferingContainerStyle, {
    children: [heading && /*#__PURE__*/_jsx(LandingFaqTitle, {
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.OFFERINGS, ElementNameMapping.COMP_HEADING),
      marginLeft: "16px",
      children: heading
    }), /*#__PURE__*/_jsx(ForexOfferingWpr, {
      margin: "".concat(device === "sm" ? 24 : 32, "px 0px 0px 0px"),
      children: data.map(function (item, idx) {
        return /*#__PURE__*/_jsx(ForexOfferingCard, {
          data: item,
          onClick: function onClick() {
            return onClickProceed(item);
          },
          margin: idx + 1 < data.length ? "0px 18px 0px 0px" : "0px"
        }, item.id);
      })
    })]
  });
};

/* harmony default export */ var components_LandingOfferingContainer_LandingOfferingContainer = ((/* unused pure expression or super */ null && (LandingOfferingContainer_LandingOfferingContainer)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/mockData/index.tsx
var mockData = __webpack_require__(8403);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useRedirectionUrls/index.ts + 3 modules
var hooks_useRedirectionUrls = __webpack_require__(4155);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts + 3 modules
var usePdtLogger = __webpack_require__(761);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalConfig.ts
var hooks_useGlobalConfig = __webpack_require__(588);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useOpenLoginForm/index.ts
var hooks_useOpenLoginForm = __webpack_require__(5426);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/analytics/index.ts + 6 modules
var analytics = __webpack_require__(1619);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var hooks_useGlobalSelector = __webpack_require__(2053);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useListingPdtLoggerV2/index.ts
var hooks_useListingPdtLoggerV2 = __webpack_require__(2221);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(4334);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/ListingPageComponents.style.ts
var ListingPageComponents_style = __webpack_require__(7998);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/ForexLandingOfferings/index.tsx

















var forexOffering = {
  data: mockData/* landingForexOfferingCardData */.Ib,
  title: "Know More about our Products"
};
var CARD_TO_ACTION_MAPPING = {
  "Multicurrency Card": "multicurrency_details_clicked",
  "Foreign Currency Notes": "currency_notes_details_clicked"
};

var ForexLandingOfferings = function ForexLandingOfferings() {
  var device = useDevice();
  return /*#__PURE__*/_jsx(ForexLandingOfferingsContainer, {});
};

/* harmony default export */ var components_ForexLandingOfferings = ((/* unused pure expression or super */ null && (ForexLandingOfferings)));

var ForexLandingOfferingsContainer = function ForexLandingOfferingsContainer() {
  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner,
      isLoggedInUser = _useGlobalConfig.isLoggedInUser;

  var _useRedirectionUrls = useRedirectionUrls(),
      redirectKnowMoreCardLinks = _useRedirectionUrls.redirectKnowMoreCardLinks;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtKnowMoreCardCtaClickEvent = _useListingPdtLogger.sendPdtKnowMoreCardCtaClickEvent;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendCTAData = _useListingPdtLoggerV.sendCTAData;

  var _useOpenLoginForm = useOpenLoginForm(),
      openLoginFormForNonLoggedInUser = _useOpenLoginForm.openLoginFormForNonLoggedInUser;

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      products = _useGlobalSelector.products;

  var proceedHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
      var cardValue, eventDetail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cardValue = getCardValue(products, item === null || item === void 0 ? void 0 : item.id);

              if (!(!isLoggedInUser && !((cardValue === null || cardValue === void 0 ? void 0 : cardValue.deep_login_allowed) == true && item.id === CARD_TYPE.CURRENCY) && item.id !== CARD_TYPE.MULTI_CURRENCY_CARD)) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return openLoginFormForNonLoggedInUser();

            case 4:
              return _context.abrupt("return");

            case 5:
              _context.next = 7;
              return sendPdtKnowMoreCardCtaClickEvent(item.cardTitle);

            case 7:
              eventDetail = getEventDetails({
                event_name: PDT_EVENTS.KNOW_MORE_CTA,
                event_value: item.cardTitle
              });
              sendCTAData({
                eventDetail: eventDetail
              });
              trackListingClickEvents({
                actionType: CARD_TO_ACTION_MAPPING[item.cardTitle],
                partner: partner
              });
              item.cta_redirect = cardValue === null || cardValue === void 0 ? void 0 : cardValue.cta_redirect;
              item.version = (cardValue === null || cardValue === void 0 ? void 0 : cardValue.version) || DEFAULT_FLOW;
              item.cta = cardValue === null || cardValue === void 0 ? void 0 : cardValue.cta;
              redirectKnowMoreCardLinks(item);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function proceedHandler(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(WhiteBackgroundStyled, {
    children: /*#__PURE__*/_jsx(BMFListingContainer, {
      children: /*#__PURE__*/_jsx(LandingOfferingContainer, {
        heading: forexOffering.title,
        data: forexOffering.data,
        onClickProceed: proceedHandler
      })
    })
  });
};

/***/ }),

/***/ 4027:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/DeviceContext.ts
var Contexts_DeviceContext = __webpack_require__(2633);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/DispatchContext.ts
var Contexts_DispatchContext = __webpack_require__(7752);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ForexListingDataContext.ts
var Contexts_ForexListingDataContext = __webpack_require__(8817);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/store/forexListingReducer.ts



function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialVersion = {
  version: constants/* DEFAULT_MX_FLOW_VERSION */.DI
};
var initialDeliveryDetails = {
  isLoadingDeliveryDetails: false,
  delivery_details: null,
  isErrorDeliveryDetails: false,
  isSuccessDeliveryDetails: false,
  errorMessageFetchingDeliveryDetails: {
    description: ""
  }
};
var initialListingPageLocationChange = {
  isLoadingListingPageLocationChange: false,
  isErrorListingPageLocationChange: false,
  errorListingPageLocationChange: {
    description: ""
  },
  isSuccessListingDetailsOnLocChange: false // persona: {},
  // products: [],
  // forex_rates: {}

};
var initailCardCtaSignalState = {
  isLoadingCardCtaSignalState: false,
  isSuccessCardCtaSignalState: false,
  isErrorCardCtaSignalState: false,
  errorListingCardCtaSignalState: {
    inr_card: null,
    multi_cx_card: null,
    currency: null
  }
};
var initialGlobalCommonState = {
  forceLoginEmailModal: true
};
var initialCrossSellData = {
  crossSellProduct: null,
  crossSellPii: null,
  crossSellAddress: null,
  crossSellDeliveryDetails: null,
  crossSellUpcomingTrips: null,
  crossSellCards: null
};
var initialAssistanceFlow = {
  type: null
};
var forexListingReducer_intialListingData = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, initialVersion), initialDeliveryDetails), initialListingPageLocationChange), initailCardCtaSignalState), initialGlobalCommonState), initialCrossSellData), initialAssistanceFlow);
var forexListingReducer_listingReducer = function listingReducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload,
      options = _ref.options;

  var _ref2 = options || {},
      card_type = _ref2.card_type;

  switch (type) {
    // Only for currency rates.
    case FETCH_FOREX_CURRENCY_RATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        forex_rates: _objectSpread({}, payload)
      });
    // DELIVERY DETAILS

    case FETCH_DELIVERY_DETAILS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initialDeliveryDetails), {}, {
        isSuccessDeliveryDetails: true,
        delivery_details: _objectSpread({}, payload)
      });

    case PERSONA_AND_VERSION_FETCHED_ON_LOAD:
      var persona = payload.persona,
          version = payload.version;
      return _objectSpread(_objectSpread({}, state), {}, {
        persona: persona,
        version: version
      });

    case IS_LOADING_DELIVERY_DETAILS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initialDeliveryDetails), {}, {
        isLoadingDeliveryDetails: true
      });

    case IS_ERROR_FETCHING_DELIVERY_DETAILS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initialDeliveryDetails), {}, {
        isErrorDeliveryDetails: true,
        errorMessageFetchingDeliveryDetails: _objectSpread({}, payload)
      });
    // Listing page: "forex rates", "persona", "products"

    case LOADING_LISTING_PAGE_LOCATION_CHANGE:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initialListingPageLocationChange), {}, {
        isLoadingListingPageLocationChange: true
      });

    case FETCH_LISTING_PAGE_LOCATION_CHANGE:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initialListingPageLocationChange), {}, {
        isSuccessListingDetailsOnLocChange: true
      }, payload);

    case FETCH_CROSS_SELL_DATA:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initialCrossSellData), payload);

    case ERROR_LISTING_PAGE_LOCATION_CHANGE:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initialListingPageLocationChange), {}, {
        isErrorListingPageLocationChange: true,
        errorListingPageLocationChange: _objectSpread({}, payload)
      });
    // Card cta signal state.

    case LOADING_CARD_CTA_SIGNAL_STATE:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initailCardCtaSignalState), {}, {
        isLoadingCardCtaSignalState: true
      });

    case FETCH_CARD_CTA_SIGNAL_STATE:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initailCardCtaSignalState), {}, {
        isSuccessCardCtaSignalState: true
      }, updateProductsWithCtaState(state === null || state === void 0 ? void 0 : state.products, card_type, payload));

    case ERROR_CARD_CTA_SIGNAL_STATE:
      return _objectSpread(_objectSpread(_objectSpread({}, state), initailCardCtaSignalState), {}, {
        isErrorCardCtaSignalState: true,
        errorListingCardCtaSignalState: _objectSpread(_objectSpread({}, initailCardCtaSignalState.errorListingCardCtaSignalState), {}, _defineProperty({}, card_type, _objectSpread({}, payload)))
      });
    // Update global common state.

    case UPDATE_LOGIN_EMAIL_MODAL_STATE:
      {
        return _objectSpread(_objectSpread(_objectSpread({}, state), initialGlobalCommonState), {}, {
          forceLoginEmailModal: payload
        });
      }

    default:
      throw new Error("Invalid action in [Listing Reducer]");
  }
};

function updateProductsWithCtaState(products, cardType, payload) {
  if (!cardType) return products || [];

  var _iterator = _createForOfIteratorHelper(products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;

      for (var _i = 0, _Object$entries = Object.entries(product); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            card = _Object$entries$_i[0],
            cardValue = _Object$entries$_i[1];

        if (card === cardType) {
          cardValue = _objectSpread(_objectSpread({}, cardValue), payload);
        }

        product[card] = cardValue;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return products;
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(4556);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/GlobalConfigContext.ts
var Contexts_GlobalConfigContext = __webpack_require__(8169);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useSetUTMParams/index.ts
var hooks_useSetUTMParams = __webpack_require__(3943);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/authUtils.ts
var authUtils = __webpack_require__(277);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts + 3 modules
var usePdtLogger = __webpack_require__(761);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useListingPdtLoggerV2/index.ts
var hooks_useListingPdtLoggerV2 = __webpack_require__(2221);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useIsLoggedInUser/index.ts







var useIsLoggedInUser_useIsLoggedInUser = function useIsLoggedInUser() {
  var _useState = useState(null),
      loggedInUser = _useState[0],
      setLoggedInUser = _useState[1];

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtAppSocialError = _useListingPdtLogger.sendPdtAppSocialError,
      sendPdtLoginTokenError = _useListingPdtLogger.sendPdtLoginTokenError;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtAppSocialErrorV2 = _useListingPdtLoggerV.sendPdtAppSocialErrorV2,
      sendPdtLoginTokenErrorV2 = _useListingPdtLoggerV.sendPdtLoginTokenErrorV2;

  var _useState2 = useState(false),
      mobileRequiredError = _useState2[0],
      updateMobileRequiredError = _useState2[1];

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return isUserLoggedInFn({
                sendPdtAppSocialError: sendPdtAppSocialError,
                sendPdtLoginTokenError: sendPdtLoginTokenError,
                sendPdtAppSocialErrorV2: sendPdtAppSocialErrorV2,
                sendPdtLoginTokenErrorV2: sendPdtLoginTokenErrorV2
              });

            case 2:
              response = _context.sent;
              setLoggedInUser(response.loggedIn);
              updateMobileRequiredError(response.mobileRequiredError);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);
  return [loggedInUser, mobileRequiredError];
};

/* harmony default export */ var hooks_useIsLoggedInUser = ((/* unused pure expression or super */ null && (useIsLoggedInUser_useIsLoggedInUser)));
// EXTERNAL MODULE: ../../libs/auth/src/index.ts + 30 modules
var src = __webpack_require__(4178);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var hooks_useGlobalSelector = __webpack_require__(2053);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/AuthModalContainer/index.tsx










var AuthModalContainer_AuthModalContainer = function AuthModalContainer() {
  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendCTAData = _useListingPdtLoggerV.sendCTAData;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtOpenEmailPopUp = _useListingPdtLogger.sendPdtOpenEmailPopUp,
      sendPdtEmailPopUpOkClick = _useListingPdtLogger.sendPdtEmailPopUpOkClick,
      sendPdtOpenAppUpdatePopUp = _useListingPdtLogger.sendPdtOpenAppUpdatePopUp,
      sendPdtOpenUpdateAppPopUpOkClick = _useListingPdtLogger.sendPdtOpenUpdateAppPopUpOkClick,
      sendPdtLoginErrorPopUpOpen = _useListingPdtLogger.sendPdtLoginErrorPopUpOpen,
      sendPdtLoginErrorPopUpOkClick = _useListingPdtLogger.sendPdtLoginErrorPopUpOkClick;

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state;
  }),
      forceLoginEmailModal = _useGlobalSelector.forceLoginEmailModal;

  var onOpenEmailLoginModal = function onOpenEmailLoginModal() {
    sendPdtOpenEmailPopUp();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.EMAIL_LOGIN_POP_UP_OPEN
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  var onCloseEmailLoginModal = function onCloseEmailLoginModal() {
    sendPdtEmailPopUpOkClick();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.EMAIL_LOGIN_POP_UP_OK_CLICK
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  var onOpenAppUpdateModal = function onOpenAppUpdateModal() {
    sendPdtOpenAppUpdatePopUp();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.UPDATE_APP_POP_UP_OPEN
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  var onCloseAppUpdateModal = function onCloseAppUpdateModal() {
    sendPdtOpenUpdateAppPopUpOkClick();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.UPDATE_APP_POP_UP_OK_CLICK
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  var onOpenErrorModal = function onOpenErrorModal() {
    sendPdtLoginErrorPopUpOpen();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.LOGIN_ERROR_POP_UP_OPEN
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  var onCloseErrorModal = function onCloseErrorModal() {
    sendPdtLoginErrorPopUpOkClick();
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.LOGIN_ERROR_POP_UP_OK_CLICK
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmailLoginModal, {
      onOpen: onOpenEmailLoginModal,
      onClose: onCloseEmailLoginModal
    }), /*#__PURE__*/_jsx(AppUpdateModal, {
      onOpen: onOpenAppUpdateModal,
      onClose: onCloseAppUpdateModal
    }), /*#__PURE__*/_jsx(LoginErrorModal, {
      onOpen: onOpenErrorModal,
      onClose: onCloseErrorModal
    })]
  });
};

/* harmony default export */ var components_AuthModalContainer = ((/* unused pure expression or super */ null && (AuthModalContainer_AuthModalContainer)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/RootContainer/index.tsx



function RootContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RootContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RootContainer_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RootContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var RootContainer = function RootContainer(_ref) {
  var children = _ref.children,
      emperiaResponse = _ref.emperiaResponse,
      _ref$isDesktop = _ref.isDesktop,
      isDesktop = _ref$isDesktop === void 0 ? true : _ref$isDesktop,
      partner = _ref.partner,
      isBot = _ref.isBot,
      onLoginClick = _ref.onLoginClick;

  var _useIsLoggedInUser = useIsLoggedInUser(),
      _useIsLoggedInUser2 = _slicedToArray(_useIsLoggedInUser, 2),
      isLoggedInUser = _useIsLoggedInUser2[0],
      mobileNumberRequiredError = _useIsLoggedInUser2[1];

  useEffect(function () {
    persistSpecificParamInCookie(COOKIES.INR_SESSION_COOKIE, "true", {
      domain: getPartner() === MakeMyTrip ? MMT_SUB_DOMAIN : GI_SUB_DOMAIN,
      path: "/"
    });
  }, []);
  var delivery_details = getSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, true, getSessionPiiDataOpts);

  var _useReducer = useReducer(listingReducer, RootContainer_objectSpread(RootContainer_objectSpread(RootContainer_objectSpread({}, intialListingData), emperiaResponse), {}, {
    delivery_details: delivery_details
  })),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var _useSetUTMParams = useSetUTMParams(),
      persistUTMParamsInCookie = _useSetUTMParams.persistUTMParamsInCookie;

  var _useState = useState(false),
      isReqIdCreated = _useState[0],
      setReqIdCreated = _useState[1];

  useEffect(function () {
    if (getSessionStorageItem(SESSION_STORAGE_KEYS.SOURCE_REACT_NATIVE, true)) {
      closeTmWebview({
        openRNListingPage: true
      });
    }

    setReqIdCreated(true);
    persistUTMParamsInCookie(true);
    addWebVitalsScript();
  }, []);
  useEffect(function () {
    if (emperiaResponse) {
      dispatch(fetchingListingPageOnLocationChange(emperiaResponse));
    }
  }, [emperiaResponse]);
  var device = getDevice(isDesktop);

  if (!isReqIdCreated) {
    return null;
  }

  return /*#__PURE__*/_jsx(DeviceContext.Provider, {
    value: device,
    children: /*#__PURE__*/_jsx(DispatchContext.Provider, {
      value: dispatch,
      children: /*#__PURE__*/_jsx(GlobalConfigContext.Provider, {
        value: {
          partner: getPartner(),
          isBot: isBot,
          isLoggedInUser: isLoggedInUser,
          onLoginClick: onLoginClick,
          mobileNumberRequiredError: mobileNumberRequiredError
        },
        children: /*#__PURE__*/_jsxs(ForexListingDataContext.Provider, {
          value: state,
          children: [children, /*#__PURE__*/_jsx(AuthModalContainer, {})]
        })
      })
    })
  });
};

/* harmony default export */ var components_RootContainer = ((/* unused pure expression or super */ null && (RootContainer)));

/***/ }),

/***/ 6147:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useDevice.ts
var hooks_useDevice = __webpack_require__(5187);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(4334);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/HappyClientsBanner/HappyClientsBanner.style.ts


var HappyClientsBanner_style_PoweredByContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "HappyClientsBannerstyle__PoweredByContainer",
  componentId: "kcg9ve-0"
})(["border-left:1px #e2e2e2 solid;padding-left:32px;& > ul{padding:0;margin:0;list-style:none;display:flex;align-items:center;}& > ul > li{display:flex;align-items:center;}& > ul > li:not(:last-child){margin-right:4px;}@media screen and ", "{height:auto;overflow-y:unset;}"], utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingFaq/LandingFaq.style.ts
var LandingFaq_style = __webpack_require__(5423);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/FlexComp/FlexComp.tsx + 1 modules
var FlexComp_FlexComp = __webpack_require__(8575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/H3Tag.tsx
var TextStyles_H3Tag = __webpack_require__(8830);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/ParaTag.tsx
var TextStyles_ParaTag = __webpack_require__(8135);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ImageTag/ImageTag.tsx + 1 modules
var ImageTag_ImageTag = __webpack_require__(4911);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var lib_utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/HappyClientsBanner/HappyClientsBanner.tsx












var HappyClientsBanner_HappyClientsBanner = function HappyClientsBanner(_ref) {
  var leftText = _ref.leftText,
      rightText = _ref.rightText,
      rightSubText = _ref.rightSubText,
      poweredByLogosArr = _ref.poweredByLogosArr,
      poweredByText = _ref.poweredByText;
  var device = useDevice();
  return device ? /*#__PURE__*/_jsxs(FlexComp, {
    flexDirection: device === "lg" ? "row" : "column",
    padding: device === "lg" ? "56px 0px" : "86px 16px 0px 16px",
    justifyContent: "space-between",
    alignItems: device === "lg" ? "center" : "flex-start",
    width: "auto",
    height: "auto",
    children: [leftText && /*#__PURE__*/_jsx(LandingFaqTitle, {
      id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.TRUST_US, ElementNameMapping.COMP_HEADING),
      marginBottom: "0px",
      children: leftText
    }), /*#__PURE__*/_jsxs(FlexComp, {
      margin: device === "lg" ? "0px" : "16px 0px 0px",
      padding: "0px",
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        padding: "0",
        justifyContent: "center",
        flexDirection: "column",
        margin: device === "lg" ? "0px 130px 0px 0px" : "0px 20px 0px 0px",
        width: "auto",
        height: "auto",
        children: [device === "lg" ? rightText && /*#__PURE__*/_jsx(H3Tag, {
          children: rightText
        }) : rightText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          fontWeight: "bold",
          children: rightText
        }), rightSubText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: device === "lg" ? "md" : "xs",
          children: rightSubText
        })]
      }), /*#__PURE__*/_jsxs(PoweredByContainer, {
        children: [poweredByText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: device === "lg" ? "md" : "xs",
          children: poweredByText
        }), poweredByLogosArr && /*#__PURE__*/_jsx("ul", {
          children: poweredByLogosArr.map(function (item, idx) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(ImageTag, {
                src: item.logoSrc,
                width: "".concat(device === "lg" ? item.width : item.width * 0.9, "px")
              })
            }, idx);
          })
        })]
      })]
    })]
  }) : null;
};

/* harmony default export */ var components_HappyClientsBanner_HappyClientsBanner = ((/* unused pure expression or super */ null && (HappyClientsBanner_HappyClientsBanner)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ListingPageComponents/ListingPageComponents.style.ts
var ListingPageComponents_style = __webpack_require__(7998);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/mockData/index.tsx
var mockData = __webpack_require__(8403);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/components/TrustUs/index.tsx







var TrustUs = function TrustUs(props) {
  var device = useDevice();
  return /*#__PURE__*/_jsx(WhiteBackgroundStyled, {
    children: /*#__PURE__*/_jsx(BMFListingContainer, {
      id: props === null || props === void 0 ? void 0 : props.id,
      margin: device === "lg" ? "0px auto" : "-50px 0px 0px",
      children: /*#__PURE__*/_jsx(HappyClientsBanner, {
        rightText: "12,00,000+",
        leftText: "Why Trust Us",
        rightSubText: "Happy Travellers with Forex Transactions",
        poweredByText: "Forex Powered by",
        poweredByLogosArr: poweredByLogos
      })
    })
  });
};

/* harmony default export */ var components_TrustUs = ((/* unused pure expression or super */ null && (TrustUs)));

/***/ }),

/***/ 5692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ defaultForexCardsData; }
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2638);


var _defaultForexCardsDat;


var defaultForexCardsData = (_defaultForexCardsDat = {}, (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_defaultForexCardsDat, ___WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.INR_CARD */ .WK.INR_CARD, {
  id: ___WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.INR_CARD */ .WK.INR_CARD,
  logoSrc: "https://tripmoneycmsimgak.mmtcdn.com/img/mini_tripmoney_card_img_60eaa9307b.png",
  // logoDesc: {
  //     boldText: 'SBM Bank',
  //     normalText: 'Powered by',
  // },
  label: "TripMoney Global Card",
  // subLabel: 'for the Casual Frequent Traveller',
  featuresArr: [{
    id: "1",
    label: "No pre-load required"
  }, {
    id: "2",
    label: "Real-time exchange rates"
  }, {
    id: "3",
    label: "VISA rates applicable"
  }],
  deliveryLabel: null,
  isleftOffBefore: null,
  isRecommended: null,
  isUnavailableAtLoc: null,
  loadCurrency: null,
  docsPending: null,
  isRecommendNotification: false,
  viewOrdersPersuasion: null,
  backendPersuasion: [],
  startOrder: null
}), (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_defaultForexCardsDat, ___WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.MULTI_CURRENCY_CARD */ .WK.MULTI_CURRENCY_CARD, {
  id: ___WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.MULTI_CURRENCY_CARD */ .WK.MULTI_CURRENCY_CARD,
  cta_redirect: ___WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_MX_FLOW_VERSION */ .DI,
  version: ___WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_MX_FLOW_VERSION */ .DI,
  logoSrc: "https://tripmoneycmsimgak.mmtcdn.com/img/new_bmf_card_714a7ae7ca.png",
  // logoDesc: {
  //     boldText: 'Yes Bank',
  //     normalText: 'Powered by',
  // },
  label: "Forex Card",
  // subLabel: 'for the Luxurious Traveller',
  featuresArr: [{
    id: "1",
    label: "Zero forex mark-up"
  }, {
    id: "2",
    label: "Accepted in 150+ countries"
  }, {
    id: "3",
    label: "Offers & Cashback"
  }],
  featureArrDesktop: [{
    id: "1",
    label: "Zero forex mark-up"
  }, {
    id: "2",
    label: "Accepted in 150+ countries"
  }, {
    id: "3",
    label: "Up to 5% more savings over Credit/Debit Cards"
  }, {
    id: "4",
    label: "Offers & cashback"
  }],
  deliveryLabel: null,
  isleftOffBefore: null,
  isRecommended: null,
  isUnavailableAtLoc: null,
  loadCurrency: null,
  docsPending: null,
  isRecommendNotification: false,
  viewOrdersPersuasion: null,
  backendPersuasion: [],
  startOrder: null
}), (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_defaultForexCardsDat, ___WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.CURRENCY */ .WK.CURRENCY, {
  id: ___WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.CURRENCY */ .WK.CURRENCY,
  cta_redirect: ___WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_CN_FLOW_VERSION */ .$H,
  version: ___WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_CN_FLOW_VERSION */ .$H,
  logoSrc: "https://tripmoneycmsimgak.mmtcdn.com/img/currency_img_small_8bc249fe6d.png",
  // logoDesc: {
  //     boldText: 'RBI',
  //     normalText: 'Verified By',
  // },
  label: "Foreign Currency Notes",
  // subLabel: 'for the Luxurious Traveller',
  featuresArr: [{
    id: "1",
    label: "40+ currencies"
  }, {
    id: "2",
    label: "Best rates"
  }, {
    id: "3",
    label: "Genuine Notes from RBI licensed companies"
  }],
  featureArrDesktop: [{
    id: "1",
    label: "40+ currencies"
  }, {
    id: "2",
    label: "Best rates"
  }, {
    id: "3",
    label: "Genuine Notes from RBI licensed companies"
  }],
  deliveryLabel: null,
  isleftOffBefore: null,
  isRecommended: null,
  isUnavailableAtLoc: null,
  loadCurrency: null,
  docsPending: null,
  isRecommendNotification: false,
  viewOrdersPersuasion: null,
  backendPersuasion: [],
  startOrder: null
}), _defaultForexCardsDat);

/***/ }),

/***/ 2638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$C": function() { return /* binding */ deepLink; },
/* harmony export */   "$H": function() { return /* binding */ DEFAULT_CN_FLOW_VERSION; },
/* harmony export */   "Bq": function() { return /* binding */ ERROR_CODE; },
/* harmony export */   "DI": function() { return /* binding */ DEFAULT_MX_FLOW_VERSION; },
/* harmony export */   "E9": function() { return /* binding */ COOKIES; },
/* harmony export */   "El": function() { return /* binding */ LSITING_PDT_EVENTS_V2; },
/* harmony export */   "FJ": function() { return /* binding */ MMT_SUB_DOMAIN; },
/* harmony export */   "HL": function() { return /* binding */ DEFAULT_FLOW; },
/* harmony export */   "HY": function() { return /* binding */ FAQ_CLICK_HERE_LINK_ID; },
/* harmony export */   "Hp": function() { return /* binding */ DERIVED_NEXT_SIGNAL_STATE; },
/* harmony export */   "Hx": function() { return /* binding */ SOURCE; },
/* harmony export */   "I$": function() { return /* binding */ SIGNAL_STATE; },
/* harmony export */   "Ie": function() { return /* binding */ GET_SLT_TOKEN_URL; },
/* harmony export */   "J6": function() { return /* binding */ UTM_PARAMS_KEY; },
/* harmony export */   "Jq": function() { return /* binding */ MOBILE; },
/* harmony export */   "Kr": function() { return /* binding */ VERSIONS; },
/* harmony export */   "M5": function() { return /* binding */ HOST; },
/* harmony export */   "MR": function() { return /* binding */ REDIRECTION_FLOW; },
/* harmony export */   "NM": function() { return /* binding */ PERSUASION_TYPE; },
/* harmony export */   "Q7": function() { return /* binding */ GI_SUB_DOMAIN; },
/* harmony export */   "RL": function() { return /* binding */ PARTNER; },
/* harmony export */   "Rw": function() { return /* binding */ SectionNameMapping; },
/* harmony export */   "T8": function() { return /* binding */ CN_UPLOAD_DOC_REDIRECTION; },
/* harmony export */   "Td": function() { return /* binding */ DEVICE; },
/* harmony export */   "Tu": function() { return /* binding */ POKUS_EXP_VERSION; },
/* harmony export */   "W6": function() { return /* binding */ SUB_DOMAIN; },
/* harmony export */   "WK": function() { return /* binding */ CARD_TYPE; },
/* harmony export */   "XF": function() { return /* binding */ WAITING_TIME_LOCATION_FETCING; },
/* harmony export */   "XH": function() { return /* binding */ PageNameMapping; },
/* harmony export */   "Yr": function() { return /* binding */ DEVICE_MODEL_TYPE; },
/* harmony export */   "_N": function() { return /* binding */ setSessionPiiDataOpts; },
/* harmony export */   "_n": function() { return /* binding */ BASE_URL; },
/* harmony export */   "bX": function() { return /* binding */ getSessionPiiDataOpts; },
/* harmony export */   "cg": function() { return /* binding */ LISTING_API_PATH; },
/* harmony export */   "fH": function() { return /* binding */ LOB_FUNNEL_TYPE; },
/* harmony export */   "gy": function() { return /* binding */ DELIVERY_DETAILS_FILTER_MODE; },
/* harmony export */   "iw": function() { return /* binding */ PLATFORM; },
/* harmony export */   "kG": function() { return /* binding */ FOREX_RATES_FILER_MODE; },
/* harmony export */   "kW": function() { return /* binding */ getPartner; },
/* harmony export */   "ku": function() { return /* binding */ APP_SOCIAL_URL; },
/* harmony export */   "l2": function() { return /* binding */ shortenHeader; },
/* harmony export */   "lU": function() { return /* binding */ DEVICE_ID_BRIDGE_STATE; },
/* harmony export */   "lv": function() { return /* binding */ DATE_FORMATS; },
/* harmony export */   "mu": function() { return /* binding */ UTM_SOURCE_VALUE; },
/* harmony export */   "mx": function() { return /* binding */ MMT_URL; },
/* harmony export */   "q5": function() { return /* binding */ DESKTOP; },
/* harmony export */   "r6": function() { return /* binding */ LOB; },
/* harmony export */   "rI": function() { return /* binding */ ERROR_MSGS; },
/* harmony export */   "sJ": function() { return /* binding */ PDT_EVENTS; },
/* harmony export */   "sO": function() { return /* binding */ SESSION_STORAGE_KEYS; },
/* harmony export */   "vT": function() { return /* binding */ ElementNameMapping; },
/* harmony export */   "yO": function() { return /* binding */ MakeMyTrip; }
/* harmony export */ });
/* unused harmony exports CURRENCY_RATE_REFRESH_TIME, WAITING_TIME_LOC_SUCCESS_SCREEN, FOREX_API_BASE_URL, PDT_BASE_URL, CLIENT_BACKEND_BASE_URL, GET_CONFIG_API_PATH, CARD_CTA_FETCH_API_PATH, CROSS_SELL_API_PATH, XPRESS_RT_API_PATH, USER_TYPE, Goibibo, LOCAL_STORAGE_KEYS, SCREEN, MINI_DASHBOARD_ACTION, MINI_DASHBOARD_BUTTON_LABEL, USER_STATE, DEVICE_MODEL, DEEPLINK, SHOW_DATA_ON_RIGHT_SIDE_IN_FOREX_CARD_LIMIT, MMT_FONT_FAMILY, GOIBIBO_FONT_FAMILY, TRIPMONEY_FONT_FAMILY, USER_SERVICE_TOKEN, USER_SERVICE_TM_AUTH, TM_AUTH_EXPIRY_DAYS, MMT_LOGIN_URL, DEVICE_OS, getUserIdentifier, getUserIdentifierForSocialLogin, DISCOUNT_BANNER_TEXT, DISCOUNT_BANNER_REDIRECTION_MMT_URL, DISCOUNT_BANNER_REDIRECTION_GI_URL, MMT_FOREX_URL, IS_INITOTU_SESSION_KEY, PROFILE_URL, CARD_TO_ACTION_MAPPING, CARD_TO_ACTION_RESUME_MAPPING, CARD_TO_ACTION_QUICKLOAD_MAPPING, MMT_LISTING_PAGE_REQ_BODY, BANNER_TYPE, LOB_CATEGORY, PROGRAM_DETAILS_ENUM, excludePersuasionList, IMAGE_URLS, MYRA_PAGE_NAME, MYRA_LOB_CATEGORY, RN_FUNNEL_NON_INCLUSIVE_APP_VERSIONS */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6198);
/* provided dependency */ var process = __webpack_require__(4406);


var _MINI_DASHBOARD_BUTTO;


var CURRENCY_RATE_REFRESH_TIME = 60000;
var WAITING_TIME_LOC_SUCCESS_SCREEN = 2500;
var WAITING_TIME_LOCATION_FETCING = 1000;
var FOREX_API_BASE_URL = (0,_utils__WEBPACK_IMPORTED_MODULE_0__.getBaseUrlBasedOnDomains)();
var BASE_URL = process.env["NX_ENV"] === "local" ? "http://localhost:9000/api" : (0,_utils__WEBPACK_IMPORTED_MODULE_0__.getBaseUrlBasedOnDomains)();
var DEVICE = "device";
var PDT_BASE_URL = "ext/api/v1";
var CLIENT_BACKEND_BASE_URL = "forex-client-backend/cb";
var LISTING_API_PATH = process.env["NX_ENV"] === "local" ? "/card-management/ext/api/v1/{partner}/landing/query?page=product_listing" : "/".concat(CLIENT_BACKEND_BASE_URL, "/card-management/ext/api/v1/{partner}/listing/query?page=product_listing");
var GET_CONFIG_API_PATH = process.env["NX_ENV"] === "local" ? "/card-management/api/v1/get-config" : "/".concat(CLIENT_BACKEND_BASE_URL, "/card-management/api/v1/get-config");
var CARD_CTA_FETCH_API_PATH = process.env["NX_ENV"] === "local" ? "/card-management/ext/api/v1/{partner}/landing/cta?product={card_type}" : "/".concat(CLIENT_BACKEND_BASE_URL, "/card-management/ext/api/v1/{partner}/listing/cta?product={card_type}");
var CROSS_SELL_API_PATH = process.env["NX_ENV"] === "local" ? "/card-management/ext/api/v1/{partner}/landing/cross-sell" : "/".concat(CLIENT_BACKEND_BASE_URL, "/multi-currency/pre-sales/ext/api/v1/{partner}/cross-sell-product");
var XPRESS_RT_API_PATH = process.env["NX_ENV"] === "local" ? "/forex-utils/ext/api/v1/{partner}/xpress-rt-event" : "/".concat(CLIENT_BACKEND_BASE_URL, "/forex-utils/ext/api/v1/{partner}/xpress-rt-event");
var USER_TYPE;

(function (USER_TYPE) {
  USER_TYPE["EXISTING_CUSTOMER"] = "existing_customer";
  USER_TYPE["NEW_CUSTOMER"] = "new_customer";
})(USER_TYPE || (USER_TYPE = {}));

var FOREX_RATES_FILER_MODE;

(function (FOREX_RATES_FILER_MODE) {
  FOREX_RATES_FILER_MODE["TOP"] = "TOP";
  FOREX_RATES_FILER_MODE["SELECT"] = "SELECT";
})(FOREX_RATES_FILER_MODE || (FOREX_RATES_FILER_MODE = {}));

var MakeMyTrip = "mmt";
var Goibibo = "gi";
var PERSUASION_TYPE;

(function (PERSUASION_TYPE) {
  PERSUASION_TYPE["DELIVERY_TRACKING"] = "delivery_tracking";
  PERSUASION_TYPE["BACKEND"] = "backend";
  PERSUASION_TYPE["DROP_OFF"] = "dropoff";
  PERSUASION_TYPE["MINI_DASHBOARD"] = "mini_dashboard";
  PERSUASION_TYPE["UPLOAD_DOCUMENTS"] = "upload_docs";
  PERSUASION_TYPE["VIEW_ORDERS"] = "view_orders";
  PERSUASION_TYPE["START_ORDER"] = "start_order";
  PERSUASION_TYPE["UPCOMING_TRIPS"] = "upcoming_trips";
  PERSUASION_TYPE["UNDELIVERABLE"] = "undeliverable";
  PERSUASION_TYPE["ACTIVATION_IN_PROGRESS"] = "activation_in_progress";
  PERSUASION_TYPE["CROSS_SELL"] = "cross_sell";
  PERSUASION_TYPE["FREE_CARD"] = "free_card";
  PERSUASION_TYPE["RELOAD_TRIP"] = "reload_discovery";
})(PERSUASION_TYPE || (PERSUASION_TYPE = {}));

var CARD_TYPE = {
  INR_CARD: "inr_card",
  MULTI_CURRENCY_CARD: "multi_cx_card",
  CURRENCY: "currency"
};
var PARTNER;

(function (PARTNER) {
  PARTNER["MMT"] = "mmt";
  PARTNER["GI"] = "gi";
  PARTNER["TRIPMONEY"] = "tm";
})(PARTNER || (PARTNER = {}));

var SESSION_STORAGE_KEYS = {
  USER_LOCATION_SESSION_KEY: "user_location",
  REQUEST_ID: "request_id",
  IS_FALLBACK_CITY_MODE: "is_fallback_city_mode",
  ITINERARY_ID: "itinerary_id",
  TICKET_ID: "ticket_id",
  FOREX_EXPERIMENTS: "forex_experiments",
  SOURCE_REACT_NATIVE: "rn"
};
var LOCAL_STORAGE_KEYS;

(function (LOCAL_STORAGE_KEYS) {
  LOCAL_STORAGE_KEYS["CURRENCY_ORDER_COACHMARK_KEY"] = "currency_order_coachmark";
})(LOCAL_STORAGE_KEYS || (LOCAL_STORAGE_KEYS = {}));

var SCREEN;

(function (SCREEN) {
  SCREEN["LISTING_PAGE"] = "LISTING_PAGE";
  SCREEN["EDIT_LOCATION"] = "EDIT_LOCATION";
})(SCREEN || (SCREEN = {}));

var HOST = {
  TRIPMONEY: "www.tripmoney.com",
  MAKEMYTRIP: "www.makemytrip.com",
  GOIBIBO: "www.goibibo.com",
  LOCALHOST: "localhost",
  TRIPMONEY_MAKEMYTRIP: "forex.makemytrip.com",
  TRIPMONEY_GOIBIBO: "forex.goibibo.com"
};
var SOURCE = {
  TRIPMONEY: "tripmoney",
  MAKEMYTRIP: "makemytrip",
  GOIBIBO: "goibibo",
  LOCALHOST: "localhost",
  FOREX_EXPERT: "forexexpert"
};
var PageNameMapping = {
  LISTING_PAGE: "listingPage"
};
var SectionNameMapping = {
  HEADER: "header",
  DELIVERY: "delivery",
  EDIT_ADDRESS: "editAddress",
  FAQs: "faqs",
  CURR_CARD: "forexCurrencyCard",
  LANDING_CARDS: "landingCardFeature",
  TRUST_US: "trustUs",
  OFFERINGS: "knowMoreOfferings"
};
var ElementNameMapping = {
  BACK_BUTTON: "backBtn",
  DOWN_ARROW: "downArrow",
  CLOSE_BUTTON: "closeButton",
  PINCODE: "pincode",
  DETECT_LOC: "detectLocation",
  CONTINUE_BTN: "continueBtn",
  KNOW_MORE_BTN: "knowMoreOfferingsBtn",
  EXPLORE_MORE_BTN: "exploreMoreBtn",
  SIDE_ARROW: "sideArrow",
  QUICK_LOAD: "quickLoadBtn",
  COMPLETE_ORDER: "completeOrderBtn",
  TRACK_BTN: "trackBtn",
  UPLOAD_NOW: "uploadNowBtn",
  ANOTHER_LOC_BTN: "anotherLocationBtn",
  LOGO_CONTAINER: "logoContainer",
  DELIVERY_LABEL: "deliveryLabel",
  DELIVERY_LOC: "deliveryLocation",
  DELIVERY_ETA: "deliveryEta",
  HEADING: "mainHeading",
  PERSUASION_TILE: "persuasionTile",
  COMP_HEADING: "heading",
  RIGHT_BUTTON: "rightButton",
  RELOAD_TRIP: "reloadTripBtn",
  CLUB_OFFER: "clubOfferWrapper",
  VIEW_PRICES: "viewPrices",
  PRICE_TICKER: "priceTicker"
};
var deepLink;

(function (deepLink) {
  deepLink["MULTI_CURRENCY_CARD"] = "bmf-card";
  deepLink["CURRENCY_NOTES"] = "bmf-currencies";
  deepLink["INR_CARD"] = "inr-card";
  deepLink["RELOAD_TRACK_ORDER"] = "reload_track_order";
  deepLink["RELOAD_UPLOAD_DOCS"] = "reload_upload_docs";
  deepLink["RELOAD_ORDER_ID"] = "dp_orderId";
  deepLink["RELOAD_LOAD_CURRENCY"] = "reload_load_currency";
  deepLink["RELOAD_DASHBOARD"] = "reload_dashboard";
  deepLink["BMF_TRAVELLER_DETAILS"] = "bmf_traveller_details";
  deepLink["BMF_ADD_PRODUCTS"] = "bmf_load_currency";
  deepLink["BMF_PAYMENT_CONFIRMED"] = "bmf_payment_confirmed";
  deepLink["BMF_PAYMENT_FAILED"] = "bmf_payment_failed";
  deepLink["BMF_ORDER_SUBMITTED"] = "bmf_order_submitted";
  deepLink["BMF_PAYMENT_BEING_CONFIRMED"] = "bmf_payment_being_confirmed";
  deepLink["BMF_START_PAYMENT"] = "bmf_start_payment";
  deepLink["BMF_ORDER_UNDER_PROCESSING"] = "bmf_order_under_processing";
  deepLink["BMF_LANDING_PAGE"] = "bmf_onboarding_landing";
  deepLink["BMF_RELOAD_DOCUMENT_SUBMIT"] = "reload_document_submit";
})(deepLink || (deepLink = {}));

var MINI_DASHBOARD_ACTION;

(function (MINI_DASHBOARD_ACTION) {
  MINI_DASHBOARD_ACTION["LOAD_CURRENCY"] = "load_currency";
  MINI_DASHBOARD_ACTION["QUICK_LOAD"] = "quick_load";
})(MINI_DASHBOARD_ACTION || (MINI_DASHBOARD_ACTION = {}));

var MINI_DASHBOARD_BUTTON_LABEL = (_MINI_DASHBOARD_BUTTO = {}, (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_MINI_DASHBOARD_BUTTO, MINI_DASHBOARD_ACTION.LOAD_CURRENCY, "LOAD CURRENCY"), (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_MINI_DASHBOARD_BUTTO, MINI_DASHBOARD_ACTION.QUICK_LOAD, "QUICK LOAD"), _MINI_DASHBOARD_BUTTO);
var ERROR_CODE;

(function (ERROR_CODE) {
  ERROR_CODE["DISPLAY_ERROR"] = "DISPLAY_ERROR";
  ERROR_CODE["LOGIN_REQUIRED"] = "LOGIN_REQUIRED";
  ERROR_CODE["NETWORK"] = "NETWORK";
})(ERROR_CODE || (ERROR_CODE = {}));

var SIGNAL_STATE = {
  BMF_CARD_LANDING: "landing",
  BMF_RELOAD_DOCUMENT_PENDING: "documents",
  BMF_DASHBOARD: "dashboard",
  BMF_PAYMENT_CONFIRMED: "payment_confirmed",
  BMF_PAYMENT_BEING_CONFIRMED: "payment_being_confirmed",
  BMF_ORDER_SUBMITTED: "order_submitted",
  BMF_PAYMENT_FAILED: "payment_failed",
  BMF_ASYNC_PROCESS_PENDING: "async_process_pending",
  TRAVELLER_DETAILS: "traveller_details",
  ADD_PRODUCTS: "add_products",
  PRODUCTS_ADDED: "products_added",
  ORDER_UNDER_PROCESSING: "order_under_processing",
  ADD_PRODUCTS_AWAITED: "order_under_processing",
  ADD_PRODUCTS_FAILED: "add_products_failed",
  TRAVELLER_DETAILS_ADDED: "traveller_details_added",
  TRAVELLER_DETAILS_FAILED: "traveler_details_failed",
  TRAVELLER_DETAILS_AWAITED: "traveler_details_awaited",
  PAYMENT_BEING_CONFIRMED: "payment_being_confirmed",
  PAYMENT_FAILED: "payment_failed",
  PAYMENT_CONFIRMED: "payment_confirmed",
  START_PAYMENT: "start_payment",
  PAYMENT_DONE: "payment_done",
  BMF_PAYMENT_NOT_POSSIBLE: "payment_not_possible",
  DOCUMENT_PENDING: "document_pending",
  VIEW_ORDERS: "view_orders"
};
var USER_STATE = {
  DASHBOARD: "DASHBOARD",
  ORDER_IN_PROGRESS: "ORDER_IN_PROGRESS"
};
var VERSIONS = {
  V1: 1,
  V2: 2,
  V3: 3
};
var DEFAULT_MX_FLOW_VERSION = VERSIONS.V2;
var DEFAULT_CN_FLOW_VERSION = VERSIONS.V1;
var DEFAULT_FLOW = VERSIONS.V2;
var DEVICE_MODEL = {
  APP: "App",
  WEB: "Web"
};
var DEVICE_MODEL_TYPE;

(function (DEVICE_MODEL_TYPE) {
  DEVICE_MODEL_TYPE["APP"] = "App";
  DEVICE_MODEL_TYPE["WEB"] = "Web";
})(DEVICE_MODEL_TYPE || (DEVICE_MODEL_TYPE = {}));

var PLATFORM;

(function (PLATFORM) {
  PLATFORM["PWA"] = "pwa";
  PLATFORM["DESKTOP"] = "desktop";
  PLATFORM["APP"] = "app";
})(PLATFORM || (PLATFORM = {}));

var COOKIES = {
  MMT_AUTH_KEY: "mmt-auth",
  TM_AUTH_KEY: "x-tm-auth",
  MMT_LOGIN_REDIRECT_KEY: "loginActionDetails",
  TM_MMT_AUTH_KEY: "tm-mmt-auth",
  GI_AUTH_KEY: "OAUTH-GOIBIBO",
  TM_GI_AUTH_KEY: "tm-gi-auth",
  INR_SESSION_COOKIE: "is-initial-landing",
  MMT_DEVICE_ID: "dvid",
  GI_DEVICE_ID: "__gi_vid",
  MMT_FOREX_COOKIE: "mmt_forex",
  CURRENCY_DEEPLOGIN_ALLOWED: "currency_deeplogin_allowed",
  PDT_JOURNEY_ID: "x-jo-id",
  CROSS_SELL_FLOW: "cross_sell_flow",
  CROSS_SELL_NUDGE_SHOWN: "cross_sell_nudge_shown",
  FOREX_AGENT_AUTH_KEY: getPartner() === MakeMyTrip ? "mmt-auth-afftmfxmmtforexexp" : "mmt-auth-afftmfxgiforexexp"
};
var DEEPLINK = "deeplink";
var DELIVERY_DETAILS_FILTER_MODE;

(function (DELIVERY_DETAILS_FILTER_MODE) {
  DELIVERY_DETAILS_FILTER_MODE["AUTO"] = "AUTO";
  DELIVERY_DETAILS_FILTER_MODE["FORCE"] = "FORCE";
  DELIVERY_DETAILS_FILTER_MODE["CITY_FALLBACK"] = "CITY_FALLBACK";
})(DELIVERY_DETAILS_FILTER_MODE || (DELIVERY_DETAILS_FILTER_MODE = {}));

var SHOW_DATA_ON_RIGHT_SIDE_IN_FOREX_CARD_LIMIT = 2;
var MMT_FONT_FAMILY = {
  headingFontFamily: "Lato",
  bodyFontFamily: "Lato"
};
var GOIBIBO_FONT_FAMILY = {
  headingFontFamily: "Raleway",
  bodyFontFamily: "Open Sans"
};
var TRIPMONEY_FONT_FAMILY = {
  headingFontFamily: "Raleway",
  bodyFontFamily: "Open Sans"
};
var ERROR_MSGS = {
  UNABLE_TO_FETCH_LOC: "We are Sorry! Unable to fetch location at the moment",
  FAILED_TO_FETCH_LOC: "We failed to fetch your location. Please try again in some time.",
  GEOLOCATION_NOT_SUPPORTED: "Geolocation not supported",
  CARD_CTA_API_ERROR: "error fetching card cta api",
  FOREX_RATES_API_ERROR: "error fetching forex rates api",
  FOREX_RATES_SUCCESS_ERROR: "fetched forex rates api with success as false",
  FOREX_RATES_API_REQUEST_ERROR: "error receiving forex rates api response",
  FOREX_RATES_NOT_FOUND: "fetched empty forex rates data",
  FOREX_RATES_RESPONSE_NULL: "forex rates api returning null object",
  PRODUCT_LISTING_API_ERROR: "error in fetching product listing api",
  PRODUCT_LIST_ERROR: "error in fetching products list from listing api",
  LISTING_API_FAIL: "product listing api failed",
  LOCATION_DENIED: "Location denied",
  LOCATION_FETCH_ERROR: "location fetch error",
  INVALID_PINCODE: "Invalid Pin code. Please enter a valid Pin code.",
  PINCODE_NOT_SERVICEABLE: "This Pincode is not serviceable at the moment. Please enter another pincode.",
  FETCH_ERROR: "Failed to fetch"
};
var PDT_EVENTS = {
  QUICK_LOAD_CTA: "listing_quick_load_clicked",
  TRACK_CARD_CTA: "listing_track_card_clicked",
  UPLOAD_DOCS_CTA: "listing_upload_docs_clicked",
  LOC_DETECT_EVENT: "listing_location_detection_event",
  START_ORDER_CTA: "listing_start_order_clicked",
  PAGE_LOAD_EVENT: "listing_page_load_event",
  LOCATION_BAR_CTA: "listing_location_bar_clicked",
  UPCOMING_TRIP: "listing_upcoming_trip",
  LOC_BOTTOM_SHEET_VIEWED: "listing_locationBottomSheet_viewed",
  DETECT_LOC_CTA: "listing_locationBottomSheet_detectLocation_clicked",
  SUBMIT_PINCODE_CTA: "listing_locationBottomSheet_submitPincode_clicked",
  RATE_TICKER_LOAD: "listing_rate_ticker_load_event",
  PRODUCT_TILE_CTA: "listing_productTile_clicked",
  KNOW_MORE_CTA: "listing_knowMoreCard_clicked",
  FAQ_CTA: "listing_faq_clicked",
  FAQ_TAB_CTA: "listing_faq_tab_clicked",
  COMPLETE_ORDER_CTA: "listing_completeOrder_clicked",
  UNAVAILABLE_LOC: "listing_unavailable_location_clicked",
  ANOTHER_LOC: "unavailable_loc",
  VIEW_DASHBOARD: "listing_view_dashboard_clicked",
  RELOAD_CURRENT_TRIP: "listing_current_trip_reload_clicked",
  JWT_TOKEN_API_CALLER: "JWTTokenApiCaller",
  APP_SOCIAL_API_CALLED: "appSocialApiCalled",
  VIEW_ORDERS: "listing_currency_view_orders_clicked",
  MARKETING_BANNER_CTA: "listingPgMktgBannerClicked",
  MARKETING_BANNER_LOAD: "listingPgMktgBannerLoaded",
  // DEEP LOGIN PDT.
  LISTING_PAGE_LOGIN_CLICK: "listing_pg_login_click",
  LOGIN_POP_UP_OPEN: "login_pop_up_open",
  EMAIL_LOGIN_POP_UP_OPEN: "email_login_pop_up_open",
  EMAIL_LOGIN_POP_UP_OK_CLICK: "email_login_pop_up_ok_click",
  UPDATE_APP_POP_UP_OPEN: "update_app_pop_up_open",
  UPDATE_APP_POP_UP_OK_CLICK: "update_app_pop_up_ok_click",
  LOGIN_ERROR_POP_UP_OPEN: "login_error_pop_up_open",
  LOGIN_ERROR_POP_UP_OK_CLICK: "login_error_pop_up_ok_click",
  //Fallback City
  FALLBACK_CITY_TRIGGERED: "fallback_city_triggered",
  FALLBACK_CITY_SUBMITTED: "fallback_city_submitted",
  // Listing Coupon Shown
  LISTING_COUPON_SHOWN: "listing_coupon_shown",
  LISTING_VIEW_COUPONS_CLICK: "listing_view_coupons_click",
  // Coachmark PDT
  COACHMARK_VIEWED: "listing_coachmark_viewed",
  COACKMARK_BUTTON_CLICK: "listing_coachmark_button_click",
  //cross sell
  CROSS_SELL_NUDGE_SHOWN: "listing_cross_sell_nudge_shown",
  CROSS_SELL_NUDGE_CLICKED: "listing_cross_sell_nudge_clicked",
  LISTING_MYRA_BOT_ICON_SHOWN: "myra_icon-shown",
  LISTING_MYRA_BOT_OPENED: "myra_bot_opened",
  LISTING_MYRA_BOT_CLOSED: "myra_bot_closed",
  // Pricing & delivery nudge events
  RATE_INCREASE_NUDGE_INFO_CLICKED: "rate_increase_nudge_info-clicked",
  ORDER_TIMER_INFO_CLICKED: "order_timer_info-clicked"
};
var LSITING_PDT_EVENTS_V2 = {
  listing_quick_load_clicked: "listing_quick_load_cta-clicked",
  listing_track_card_clicked: "listing_track_card_cta-clicked",
  listing_upload_docs_clicked: "listing_upload_docs_cta-clicked",
  listing_location_detection_event: "listing_location_detection-loaded",
  listing_start_order_clicked: "listing_start_order_cta-clicked",
  listing_page_load_event: "listing_page-loaded",
  listing_location_bar_clicked: "listing_location_bar_cta-clicked",
  listing_upcoming_trip: "listing_upcoming_trip-viewed",
  listing_locationBottomSheet_viewed: "listing_location_bottom_sheet-viewed",
  listing_locationBottomSheet_detectLocation_clicked: "listing_location_bottom_sheet_detect_location_cta-clicked",
  listing_locationBottomSheet_submitPincode_clicked: "listing_location_bottom_sheet_submit_pincode_cta-clicked",
  listing_rate_ticker_load_event: "listing_rate_ticker-loaded",
  listing_productTile_clicked: "listing_product_tile_cta-clicked",
  listing_knowMoreCard_clicked: "listing_know_more_card_cta-clicked",
  listing_faq_clicked: "listing_faq-clicked",
  listing_faq_tab_clicked: "listing_faq_tab-clicked",
  listing_completeOrder_clicked: "listing_complete_order_cta-clicked",
  listing_unavailable_location_clicked: "listing_unavailable_location_cta-clicked",
  unavailable_loc: "listing_unavailable_location-viewed",
  listing_view_dashboard_clicked: "listing_view_dashboard_cta-clicked",
  JWTTokenApiCaller: "jwt_token_api-called",
  appSocialApiCalled: "app_social_api-called",
  listing_currency_view_orders_clicked: "listing_currency_view_orders_cta-clicked",
  listingPgMktgBannerClicked: "listing_pg_mktg_banner-clicked",
  listingPgMktgBannerLoaded: "listing_pg_mktg_banner-loaded",
  listing_pg_login_click: "listing_pg_login_cta-clicked",
  login_pop_up_open: "listing_login_pop_up-opened",
  email_login_pop_up_open: "email_login_pop_up-opened",
  email_login_pop_up_ok_click: "email_login_pop_up_ok_cta-clicked",
  update_app_pop_up_open: "update_app_pop_up-opened",
  update_app_pop_up_ok_click: "update_app_pop_up_ok_cta-clicked",
  login_error_pop_up_open: "login_error_pop_up-opened",
  login_error_pop_up_ok_click: "login_error_pop_up_ok_cta-clicked",
  fallback_city_triggered: "fallback_city-triggered",
  fallback_city_submitted: "fallback_city-submitted",
  listing_coupon_shown: "listing_coupon-viewed",
  listing_view_coupons_click: "listing_view_coupons_cta-clicked",
  listing_coachmark_viewed: "listing_coachmark-viewed",
  listing_coachmark_button_click: "listing_coachmark_cta-clicked"
};
var FAQ_CLICK_HERE_LINK_ID;

(function (FAQ_CLICK_HERE_LINK_ID) {
  FAQ_CLICK_HERE_LINK_ID["WHAT_IS_MX_CARD_CLICK_HERE"] = "what_is_mx_card_click_here";
  FAQ_CLICK_HERE_LINK_ID["HOW_TO_GET_CARD_CLICK_HERE"] = "how_to_get_card_click_here";
  FAQ_CLICK_HERE_LINK_ID["ORDER_CURRENCY_CLICK_HERE"] = "order_currency_click_here";
})(FAQ_CLICK_HERE_LINK_ID || (FAQ_CLICK_HERE_LINK_ID = {}));

var DESKTOP = "Desktop";
var MOBILE = "Mobile";
var APP_SOCIAL_URL = function APP_SOCIAL_URL(partner) {
  var _getHostName;

  var hostname = (_getHostName = (0,_utils__WEBPACK_IMPORTED_MODULE_0__.getHostName)()) !== null && _getHostName !== void 0 && _getHostName.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return "".concat(hostname, "/ext/TripMoney/Forex/appSocialLogin");
};
var GET_SLT_TOKEN_URL = function GET_SLT_TOKEN_URL(partner) {
  var _getHostName2;

  var hostname = (_getHostName2 = (0,_utils__WEBPACK_IMPORTED_MODULE_0__.getHostName)()) !== null && _getHostName2 !== void 0 && _getHostName2.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return "".concat(hostname, "/ext/web/pwa/jwt/loginToken");
};
var USER_SERVICE_TOKEN = (/* unused pure expression or super */ null && ( true ? "h4nhc9jcgpAGIjp" : 0)); // : 'cmVzdDoxMjM0NTY='; //QA credentials use it when user service pointed to QA

var USER_SERVICE_TM_AUTH = (/* unused pure expression or super */ null && ( true ? "554DIGG7SWt1EHO" : 0)); // : 'tXXXkb1UwVZn3n6'; //QA credentials use it when user service pointed to QA

var TM_AUTH_EXPIRY_DAYS = 89;
var MMT_LOGIN_URL = "//www.makemytrip.com/pwa/hlp/v3/login";
var MMT_SUB_DOMAIN = ".makemytrip.com";
var GI_SUB_DOMAIN = ".goibibo.com";
var DEVICE_OS = {
  ANDROID: "android",
  IOS: "ios",
  UNKNOWN: "unknown"
};
/**
 * Returns the partner based on the host name.
 * @param partner - The partner name.
 * @returns The partner name based on the host name.
 */

function getPartner() {
  if ((0,_utils__WEBPACK_IMPORTED_MODULE_0__.isOnServer)()) {
    return "";
  }

  if ((0,_utils__WEBPACK_IMPORTED_MODULE_0__.isHostMMT)()) {
    return MakeMyTrip;
  } else {
    return Goibibo;
  }
}
var getUserIdentifier = function getUserIdentifier(auth, deviceId) {
  return "{\"ipAddress\":\"ipAddress\",\"imie\":\"imie\",\"appVersion\":\"appVersion\",\"os\":\"DESKTOP\",\"osVersion\":\"osVersion\",\"timeZone\":\"timeZone\",\"type\":\"mmt-auth\",\"profileType\":\"\",\"Authorization\":\"".concat(USER_SERVICE_TOKEN, "\",\"deviceId\":\"").concat(deviceId, "\",\"cookie\":\"").concat(auth, "\",\"value\":\"").concat(auth, "\"}");
};
var getUserIdentifierForSocialLogin = function getUserIdentifierForSocialLogin(auth, deviceId) {
  return "{\"type\" :\"auth\",\"value\":\"\",\"deviceId\":\"".concat(deviceId, "\",\"os\":\"android\",\"osVersion\":\"6.0.0\",\"appVersion\":\"5.4.1\",\"imie\":\"132342354\",\"ipAddress\":\"127.0.0.1\",\"timeZone\":\"+5.30 GMT\"}");
};
var DISCOUNT_BANNER_TEXT = "Get upto <b>INR 1000 cashback</b>* on <b>Thai Baht</b> orders over THB 20,000. Valid from 13th to 15th Nov only.";
var DISCOUNT_BANNER_REDIRECTION_MMT_URL = "https://www.makemytrip.com/promos/forex-cashback.html?utm_source=cashback&utm_medium=mlp";
var DISCOUNT_BANNER_REDIRECTION_GI_URL = "https://www.goibibo.com/offers/tripmoney-forex";
var MMT_FOREX_URL = "https://www.makemytrip.com/forex";
var IS_INITOTU_SESSION_KEY = "is_initotu";
var MMT_URL = "https://www.makemytrip.com";
var UTM_PARAMS_KEY = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_CONTENT: "utm_content",
  UTM_LOGIN: "utm_login",
  UTM_LENDER: "utm_lender",
  UTM_FLOW: "utm_flow"
};
var UTM_SOURCE_VALUE = {
  BOTTOM_BAR: "bottombar"
};
var SUB_DOMAIN = {
  MAKEMYTRIP: ".makemytrip.com",
  GOIBIBO: ".goibibo.com",
  TRIPMONEY: ".tripmoney.com",
  LOCALHOST: "localhost"
};
var PROFILE_URL = {
  MMT_PWA: "https://www.makemytrip.com/pwa/hlp/v3/accountDetails/",
  MMT_DT: "https://www.makemytrip.com/my-profile/",
  GI: "https://www.goibibo.com/profile/"
};
var CARD_TO_ACTION_MAPPING = {
  "Multicurrency Card": "multicurrency_card_clicked",
  "Foreign Currency Notes": "currency_notes_clicked"
};
var CARD_TO_ACTION_RESUME_MAPPING = {
  "Multicurrency Card": "multicurrency_card_resume_clicked",
  "Foreign Currency Notes": "currency_notes_resume_clicked"
};
var CARD_TO_ACTION_QUICKLOAD_MAPPING = {
  "Multicurrency Card": "multicurrency_quick_load_button_clicked",
  "Global Cash Card": "inr_quick_load_button_clicked"
};
var getSessionPiiDataOpts = {
  isPiiData: true,
  shouldParseJson: true
};
var setSessionPiiDataOpts = {
  isPiiData: true,
  shouldStringifyJson: true
};
var MMT_LISTING_PAGE_REQ_BODY = {
  query: {
    mandatory: {
      forex_rates: {
        filter: {
          mode: FOREX_RATES_FILER_MODE.TOP
        }
      },
      products: {
        inr_card: {
          persuasions: true,
          delivery_details: false
        },
        multi_cx_card: {
          persuasions: true,
          delivery_details: false,
          cta: true
        },
        currency: {
          cta: true,
          persuasions: true,
          delivery_details: false
        }
      },
      assistance_flow: {
        type: true
      },
      persona: true,
      offer_persuasions: true,
      recommended_currencies_ticker: true,
      pricing_nudge: true
    }
  },
  data: {}
};
var REDIRECTION_FLOW = {
  OLD: VERSIONS.V1,
  NEW: VERSIONS.V2
};
var POKUS_EXP_VERSION = {
  MMT: {
    OLD: 7214,
    NEW: 7215
  },
  GI: {
    OLD: 1901,
    NEW: 1902
  }
};
var CN_UPLOAD_DOC_REDIRECTION = {
  CN_ORDER_LISTING: "history",
  CN_UPLOAD_DOC: "specific_order"
};
var BANNER_TYPE = {
  CAMPAIGN: "campaign",
  MARKETING: "marketing"
};
var DEVICE_ID_BRIDGE_STATE = {
  AVAILABLE: "AVAILABLE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  NON_FUNCTIONAL: "NON_FUNCTIONAL"
};
var LOB_FUNNEL_TYPE = {
  BUY: "Buy",
  POSTSALE: "PostSale",
  LISTING: "Listing"
};
var LOB_CATEGORY = {
  PC: "PC",
  CN: "CN",
  NIUM: "NC"
};
var LOB = {
  FOREX: "forex"
};
var shortenHeader = {
  lob: "lob",
  lob_category: "lc",
  lob_funnel: "lf",
  page_name: "pn",
  prev_page_name: "ppn",
  funnel_step: "fs",
  pg_time_interval: "pti",
  navigation: "nav",
  utm_source: "us",
  utm_medium: "um",
  utm_campaign: "uc",
  cmp: "cmp",
  requestId: "rq-id"
};
var DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM'yy";
  DATE_FORMATS["dd MMM, yyyy"] = "dd MMM, yyyy";
  DATE_FORMATS["YYYY-MM-DD"] = "yyyy-MM-dd";
})(DATE_FORMATS || (DATE_FORMATS = {}));

var PROGRAM_DETAILS_ENUM;

(function (PROGRAM_DETAILS_ENUM) {
  PROGRAM_DETAILS_ENUM["FREE_CARD"] = "free_card_flow";
})(PROGRAM_DETAILS_ENUM || (PROGRAM_DETAILS_ENUM = {}));

var excludePersuasionList = (/* unused pure expression or super */ null && (["free_card"]));
var IMAGE_URLS = {
  ZERO_PAYMENT_FREE_CARD_IMAGE: "https://tripmoneycmsimgak.mmtcdn.com/img/free_Card_36c13af5e6.png"
};
/*
 * These are the signal states which BE derives based on some custom logic at their end instead of sending it via workflow.
 * Some use cases -
 * 1. Workflow does not exist for reload till user goes to payment page. But user needs to be redirected from listing page based on some signal state. Hence it is derived at BE.
 */

var DERIVED_NEXT_SIGNAL_STATE;

(function (DERIVED_NEXT_SIGNAL_STATE) {
  DERIVED_NEXT_SIGNAL_STATE["RELOAD_CURRENT_TRIP"] = "RELOAD_CURRENT_TRIP";
  DERIVED_NEXT_SIGNAL_STATE["RELOAD_NEW_UPCOMING_TRIP"] = "RELOAD_NEW_UPCOMING_TRIP";
  DERIVED_NEXT_SIGNAL_STATE["RELOAD_NEW_TRIP"] = "RELOAD_NEW_TRIP";
})(DERIVED_NEXT_SIGNAL_STATE || (DERIVED_NEXT_SIGNAL_STATE = {}));

var MYRA_PAGE_NAME = {
  LISTING: "LISTING",
  LANDING: "LANDING",
  TRAVELLER_DETAILS: "TRAVELLER_DETAILS",
  ADD_CURRENCY: "ADD_CURRENCY"
};
var MYRA_LOB_CATEGORY = {
  LISTING: "listing",
  CARD: "card",
  CURRENCY: "currency"
};
var RN_FUNNEL_NON_INCLUSIVE_APP_VERSIONS = {
  ANDROID: "12.1.1",
  IOS: "9.3.3"
};

/***/ }),

/***/ 7874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ withDeviceProvider; }
/* harmony export */ });
/* harmony import */ var _Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2633);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);


function withDeviceProvider(comp, device) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_0__/* .DeviceContextV2.Provider */ .M.Provider, {
    value: device,
    children: comp
  });
}

/***/ }),

/***/ 5289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FQ": function() { return /* reexport */ useListingPdtLoggerV2/* default */.Z; },
  "uO": function() { return /* reexport */ useReferrerContext; }
});

// UNUSED EXPORTS: useListingPdtLogger

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/Contexts/ReferrerContext.ts

var ReferrerContext = /*#__PURE__*/(0,react.createContext)("");
/* harmony default export */ var Contexts_ReferrerContext = (ReferrerContext);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useReferrerContext.ts


var useReferrerContext = function useReferrerContext() {
  return (0,react.useContext)(Contexts_ReferrerContext);
};
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts + 3 modules
var usePdtLogger = __webpack_require__(761);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useListingPdtLoggerV2/index.ts
var useListingPdtLoggerV2 = __webpack_require__(2221);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts





/***/ }),

/***/ 5187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useDevice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _useDeviceContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4738);


var useDevice = function useDevice() {
  var device = (0,_useDeviceContext__WEBPACK_IMPORTED_MODULE_1__/* .useDeviceContext */ .v$)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(device),
      breakpoint = _useState[0],
      setBreakpoint = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (breakpoint) return;

    var handleResize = function handleResize() {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setBreakpoint("sm");
      } else {
        setBreakpoint("lg");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);
  return breakpoint;
};

/***/ }),

/***/ 4738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bU": function() { return /* binding */ useBreakpointV2; },
/* harmony export */   "v$": function() { return /* binding */ useDeviceContext; }
/* harmony export */ });
/* unused harmony export useDeviceV2 */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2633);


var useDeviceContext = function useDeviceContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};
var useDeviceV2 = function useDeviceV2() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_1__/* .DeviceContextV2 */ .M);
};
var useBreakpointV2 = function useBreakpointV2() {
  var device = useDeviceV2();

  switch (device) {
    case "mobile":
      return "sm";

    case "desktop":
      return "lg";

    case "tablet":
      return "md";

    default:
      return "md";
  }
};

/***/ }),

/***/ 9611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kH": function() { return /* binding */ getLocationBody; }
/* harmony export */ });
/* unused harmony export getLocationQuery */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _useGlobalConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(588);
/* harmony import */ var _useGlobalDispatch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3211);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2638);
/* harmony import */ var _api_fetchApi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5859);
/* harmony import */ var _useGlobalSelector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2053);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6198);
/* harmony import */ var _utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4556);
/* harmony import */ var _useFetchForexRates__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2897);
/* harmony import */ var _useDevice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5187);
/* harmony import */ var _usePdtLogger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(761);
/* harmony import */ var _useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2221);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var useFetchDeliveryDetails = function useFetchDeliveryDetails(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude,
      pincode = _ref.pincode,
      reqId = _ref.reqId;
  var dispatch = useGlobalDispatch();

  var _useGlobalConfig = useGlobalConfig(),
      partner = _useGlobalConfig.partner;

  var device = useDevice();

  var _useGlobalSelector = useGlobalSelector(function (state) {
    return state || {};
  }),
      forex_rates = _useGlobalSelector.forex_rates,
      isLoadingDeliveryDetails = _useGlobalSelector.isLoadingDeliveryDetails,
      isErrorDeliveryDetails = _useGlobalSelector.isErrorDeliveryDetails,
      errorMessageFetchingDeliveryDetails = _useGlobalSelector.errorMessageFetchingDeliveryDetails;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtListingError = _useListingPdtLogger.sendPdtListingError;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtListingErrorV2 = _useListingPdtLoggerV.sendPdtListingErrorV2;

  var fetchUserDeliveryInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fromSession,
          contextUrl,
          userLocationSession,
          request_id,
          data,
          response,
          _ref3,
          _request_id,
          delivery_details,
          persona,
          version,
          userLocationData,
          error,
          _ref4,
          type,
          _e$message,
          _e$message2,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fromSession = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              contextUrl = getContextUrl(partner);
              _context.prev = 2;

              if (!fromSession) {
                _context.next = 10;
                break;
              }

              dispatch(loadingDeliveryDetailsAction());
              userLocationSession = getSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, true, getSessionPiiDataOpts);
              request_id = getSessionStorageItem(SESSION_STORAGE_KEYS.REQUEST_ID, true);

              if (!userLocationSession) {
                _context.next = 10;
                break;
              }

              dispatch(fetchDeliveryDetailsAction(_objectSpread({}, userLocationSession)));
              return _context.abrupt("return", {
                userLocationSession: userLocationSession,
                request_id: request_id
              });

            case 10:
              data = getLocationQuery(forex_rates, {
                latitude: latitude,
                longitude: longitude,
                pincode: pincode
              }, device);
              dispatch(loadingDeliveryDetailsAction());
              _context.next = 14;
              return fetchApiForexListing(contextUrl, {
                method: "POST",
                data: data,
                headers: _objectSpread({}, getRequestIdHeaders(reqId))
              });

            case 14:
              response = _context.sent;

              if (!(response !== null && response !== void 0 && response.success)) {
                _context.next = 24;
                break;
              }

              _ref3 = (response === null || response === void 0 ? void 0 : response.data) || {}, _request_id = _ref3.request_id, delivery_details = _ref3.delivery_details, persona = _ref3.persona, version = _ref3.version;
              userLocationData = _objectSpread({
                latitude: latitude,
                longitude: longitude
              }, delivery_details);
              dispatch(fetchDeliveryDetailsAction(userLocationData));
              dispatch(fetchedPersonaAndVersionOnLoad({
                persona: persona,
                version: version
              }));

              if ((userLocationData === null || userLocationData === void 0 ? void 0 : userLocationData.eta_in_days) >= 0 && (userLocationData !== null && userLocationData !== void 0 && userLocationData.pincode || userLocationData !== null && userLocationData !== void 0 && userLocationData.city)) {
                setSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, userLocationData, true, setSessionPiiDataOpts);
                setSessionStorageItem(SESSION_STORAGE_KEYS.REQUEST_ID, _request_id, true);

                if ((userLocationData === null || userLocationData === void 0 ? void 0 : userLocationData.detection_source) === "city_fallback") {
                  setSessionStorageItem(SESSION_STORAGE_KEYS.IS_FALLBACK_CITY_MODE, "true", true);
                }
              }

              return _context.abrupt("return", {
                userLocationData: userLocationData,
                request_id: _request_id
              });

            case 24:
              error = response || {};
              _ref4 = error || {}, type = _ref4.type;

              if (type === "INLINE") {
                dispatch(errorFetchingDeliveryDetails(error));
              } else {
                error.errorDescription = ERROR_MSGS.FAILED_TO_FETCH_LOC;
                sendPdtListingError(error);
                sendPdtListingErrorV2(error);
                dispatch(errorFetchingDeliveryDetails({
                  description: ERROR_MSGS.FAILED_TO_FETCH_LOC
                }));
              }

              removeSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY);
              removeSessionStorageItem(SESSION_STORAGE_KEYS.REQUEST_ID);

            case 29:
              _context.next = 39;
              break;

            case 31:
              _context.prev = 31;
              _context.t0 = _context["catch"](2);
              sendPdtListingError({
                apiUrl: contextUrl,
                code: _context.t0 !== null && _context.t0 !== void 0 && (_e$message = _context.t0.message) !== null && _e$message !== void 0 && _e$message.includes(ERROR_MSGS.FETCH_ERROR) ? ERROR_CODE.NETWORK : "",
                description: _context.t0 !== null && _context.t0 !== void 0 && (_e$message2 = _context.t0.message) !== null && _e$message2 !== void 0 && _e$message2.includes(ERROR_MSGS.FETCH_ERROR) ? ERROR_MSGS.FETCH_ERROR : _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
              });
              sendPdtListingErrorV2({
                errorDescription: "fetchUserDeliveryInfo: ".concat(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message)
              });
              dispatch(errorFetchingDeliveryDetails({
                description: ERROR_MSGS.FAILED_TO_FETCH_LOC
              }));
              removeSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY);
              removeSessionStorageItem(SESSION_STORAGE_KEYS.REQUEST_ID);
              console.error(_context.t0);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 31]]);
    }));

    return function fetchUserDeliveryInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    isLoadingDeliveryDetails: isLoadingDeliveryDetails,
    isErrorDeliveryDetails: isErrorDeliveryDetails,
    errorMessageFetchingDeliveryDetails: errorMessageFetchingDeliveryDetails,
    fetchUserDeliveryInfo: fetchUserDeliveryInfo
  };
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useFetchDeliveryDetails)));
function getLocationQuery(forex_rates, location, device) {
  var _ref5 = location || {},
      latitude = _ref5.latitude,
      longitude = _ref5.longitude,
      pincode = _ref5.pincode,
      city = _ref5.city,
      city_name = _ref5.city_name,
      locus_city_code = _ref5.locus_city_code;

  var filter = getForexRatesFilterInfo(forex_rates);
  var data = getLocationBody({
    latitude: latitude,
    longitude: longitude,
    pincode: pincode,
    city: city,
    city_name: city_name,
    locus_city_code: locus_city_code
  });
  return {
    query: {
      mandatory: {
        delivery_details: {
          filter: {
            mode: locus_city_code || getSessionStorageItem(SESSION_STORAGE_KEYS.IS_FALLBACK_CITY_MODE, true) === "true" ? DELIVERY_DETAILS_FILTER_MODE.CITY_FALLBACK : DELIVERY_DETAILS_FILTER_MODE.AUTO
          }
        },
        persona: true
      },
      precompute: {
        forex_rates: {
          filter: filter
        },
        products: {
          inr_card: {
            delivery_details: device === "sm" ? true : false,
            persuasions: true
          },
          multi_cx_card: {
            cta: true,
            delivery_details: device === "sm" ? true : false,
            persuasions: true,
            card_cta: true,
            program_details: true
          },
          currency: {
            cta: true,
            delivery_details: device === "sm" ? true : false,
            persuasions: true
          }
        },
        assistance_flow: {
          type: true
        }
      }
    },
    data: data
  };
}
function getLocationBody(_ref6) {
  var latitude = _ref6.latitude,
      longitude = _ref6.longitude,
      pincode = _ref6.pincode,
      city = _ref6.city,
      city_name = _ref6.city_name,
      locus_city_code = _ref6.locus_city_code;
  var body = null;

  if (latitude && longitude) {
    body = {
      location: {
        latitude: latitude,
        longitude: longitude,
        city: city,
        city_name: city_name,
        locus_city_code: locus_city_code
      }
    };
  }

  if (pincode) {
    body = {
      location: {
        pincode: pincode,
        city: city,
        city_name: city_name,
        locus_city_code: locus_city_code
      }
    };
  }

  return body;
}

/***/ }),

/***/ 2897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zt": function() { return /* binding */ getForexRatesFilterInfo; }
/* harmony export */ });
/* unused harmony export getBody */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(406);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api_fetchApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5859);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2638);
/* harmony import */ var _store_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7377);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6198);
/* harmony import */ var _utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4556);
/* harmony import */ var _useGlobalConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(588);
/* harmony import */ var _useGlobalDispatch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3211);
/* harmony import */ var _useGlobalSelector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2053);
/* harmony import */ var _useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2221);
/* harmony import */ var _usePdtLogger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(761);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var useFetchForexRatex = function useFetchForexRatex() {
  var dispatch = (0,_useGlobalDispatch__WEBPACK_IMPORTED_MODULE_7__/* .useGlobalDispatch */ .x)();

  var _useGlobalConfig = (0,_useGlobalConfig__WEBPACK_IMPORTED_MODULE_6__/* .useGlobalConfig */ .W)(),
      partner = _useGlobalConfig.partner;

  var _useGlobalSelector = (0,_useGlobalSelector__WEBPACK_IMPORTED_MODULE_8__/* .useGlobalSelector */ .a)(function (state) {
    return state || {};
  }),
      forex_rates = _useGlobalSelector.forex_rates;

  var _useListingPdtLogger = (0,_usePdtLogger__WEBPACK_IMPORTED_MODULE_10__/* .useListingPdtLogger */ .v)(),
      sendPdtRateTickerViewEvent = _useListingPdtLogger.sendPdtRateTickerViewEvent,
      sendPdtListingError = _useListingPdtLogger.sendPdtListingError;

  var _useListingPdtLoggerV = (0,_useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(),
      sendPdtListingErrorV2 = _useListingPdtLoggerV.sendPdtListingErrorV2;

  var _useListingPdtLoggerV2 = (0,_useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(),
      sendPdtRateTickerViewEventV2 = _useListingPdtLoggerV2.sendPdtRateTickerViewEventV2;

  var fetchForexRates = /*#__PURE__*/function () {
    var _ref = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var contextUrl, response, _response, _response$data, _response2, userLocationData, data, reqId, _e$message, _e$message2, error, forexRates, _error, _response3, _response3$data, _response4, _response4$data, _response5, _response5$data, _response6, _error2, _e$message3, _e$message4, _error3;

      return _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              contextUrl = (0,_utils__WEBPACK_IMPORTED_MODULE_4__.getContextUrl)(partner);
              _context.prev = 1;
              userLocationData = (0,_utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_5__/* .getSessionStorageItem */ .St)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY */ .sO.USER_LOCATION_SESSION_KEY, true, _constants__WEBPACK_IMPORTED_MODULE_3__/* .getSessionPiiDataOpts */ .bX);
              data = getBody(forex_rates, userLocationData);
              reqId = (0,_utils__WEBPACK_IMPORTED_MODULE_4__.generateRequestId)();
              _context.prev = 5;
              _context.next = 8;
              return (0,_api_fetchApi__WEBPACK_IMPORTED_MODULE_2__/* .fetchApiForexListing */ .Xs)(contextUrl, {
                method: "POST",
                data: data,
                headers: _objectSpread({}, (0,_utils__WEBPACK_IMPORTED_MODULE_4__.getRequestIdHeaders)(reqId))
              });

            case 8:
              response = _context.sent;
              _context.next = 18;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);
              error = {
                apiUrl: contextUrl,
                code: _context.t0 !== null && _context.t0 !== void 0 && (_e$message = _context.t0.message) !== null && _e$message !== void 0 && _e$message.includes(_constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR) ? _constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_CODE.NETWORK */ .Bq.NETWORK : "",
                description: _context.t0 !== null && _context.t0 !== void 0 && (_e$message2 = _context.t0.message) !== null && _e$message2 !== void 0 && _e$message2.includes(_constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR) ? _constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR : _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
              };
              sendPdtListingError(error);
              sendPdtListingErrorV2(error);
              console.error(_context.t0);
              return _context.abrupt("return", _context.t0);

            case 18:
              forexRates = (_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.forex_rates;

              if ((_response2 = response) !== null && _response2 !== void 0 && _response2.success) {
                if (!forexRates || !Object.keys(forexRates).length) {
                  _error = {
                    errorDescription: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FOREX_RATES_NOT_FOUND */ .rI.FOREX_RATES_NOT_FOUND
                  };
                  sendPdtListingError(_error);
                  sendPdtListingErrorV2(_error);
                } else {
                  sendPdtRateTickerViewEvent((_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$data = _response3.data) === null || _response3$data === void 0 ? void 0 : _response3$data.forex_rates);
                  sendPdtRateTickerViewEventV2((_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$data = _response4.data) === null || _response4$data === void 0 ? void 0 : _response4$data.forex_rates, reqId);
                  dispatch((0,_store_action__WEBPACK_IMPORTED_MODULE_12__/* .fetchForexCurrencyRateAction */ .kD)((_response5 = response) === null || _response5 === void 0 ? void 0 : (_response5$data = _response5.data) === null || _response5$data === void 0 ? void 0 : _response5$data.forex_rates));
                }
              } else {
                if (((_response6 = response) === null || _response6 === void 0 ? void 0 : _response6.success) === false) {
                  //ERROR PDT
                  _error2 = {
                    errorDescription: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FOREX_RATES_SUCCESS_ERROR */ .rI.FOREX_RATES_SUCCESS_ERROR
                  };
                  sendPdtListingError(_error2);
                  sendPdtListingErrorV2(_error2);
                }
              }

              _context.next = 28;
              break;

            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](1);
              //ERROR PDT
              _error3 = {
                apiUrl: contextUrl,
                code: _context.t1 !== null && _context.t1 !== void 0 && (_e$message3 = _context.t1.message) !== null && _e$message3 !== void 0 && _e$message3.includes(_constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR) ? _constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_CODE.NETWORK */ .Bq.NETWORK : "",
                description: _context.t1 !== null && _context.t1 !== void 0 && (_e$message4 = _context.t1.message) !== null && _e$message4 !== void 0 && _e$message4.includes(_constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR) ? _constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR : _context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message
              };
              sendPdtListingError(_error3);
              sendPdtListingErrorV2(_context.t1, _constants__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_MSGS.FOREX_RATES_API_ERROR */ .rI.FOREX_RATES_API_ERROR);
              console.error(_context.t1);

            case 28:
              return _context.abrupt("return", response);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 22], [5, 11]]);
    }));

    return function fetchForexRates() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    fetchForexRates: fetchForexRates
  };
};

/* harmony default export */ __webpack_exports__["ZP"] = (useFetchForexRatex);
function getBody(forex_rates, delivery_details) {
  var filter = getForexRatesFilterInfo(forex_rates);
  return {
    query: {
      mandatory: {
        forex_rates: {
          filter: filter
        }
      }
    },
    data: {
      location: _objectSpread({}, delivery_details)
    }
  };
}
function getForexRatesFilterInfo(forex_rates) {
  var filter = null;

  if (forex_rates && Object.keys(forex_rates).length > 0) {
    filter = {
      mode: _constants__WEBPACK_IMPORTED_MODULE_3__/* .FOREX_RATES_FILER_MODE.SELECT */ .kG.SELECT,
      currencies: Object.keys(forex_rates)
    };
  } else {
    filter = {
      mode: _constants__WEBPACK_IMPORTED_MODULE_3__/* .FOREX_RATES_FILER_MODE.TOP */ .kG.TOP
    };
  }

  return filter;
}

/***/ }),

/***/ 599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(406);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _useGlobalConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(588);
/* harmony import */ var _api_fetchApi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5859);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2638);
/* harmony import */ var _store_action__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7377);
/* harmony import */ var _useGlobalDispatch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3211);
/* harmony import */ var _useGlobalSelector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2053);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6198);
/* harmony import */ var _useFetchForexRates__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2897);
/* harmony import */ var _useDevice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5187);
/* harmony import */ var _usePdtLogger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(761);
/* harmony import */ var _useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2221);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var useFetchListingDetails = function useFetchListingDetails() {
  var _useGlobalConfig = (0,_useGlobalConfig__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalConfig */ .W)(),
      partner = _useGlobalConfig.partner;

  var device = (0,_useDevice__WEBPACK_IMPORTED_MODULE_9__/* .useDevice */ .F)();
  var dispatch = (0,_useGlobalDispatch__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalDispatch */ .x)();

  var _useGlobalSelector = (0,_useGlobalSelector__WEBPACK_IMPORTED_MODULE_6__/* .useGlobalSelector */ .a)(function (state) {
    return state || {};
  }),
      forex_rates = _useGlobalSelector.forex_rates;

  var _useListingPdtLogger = (0,_usePdtLogger__WEBPACK_IMPORTED_MODULE_10__/* .useListingPdtLogger */ .v)(),
      sendPdtRateTickerViewEvent = _useListingPdtLogger.sendPdtRateTickerViewEvent,
      sendPdtListingError = _useListingPdtLogger.sendPdtListingError;

  var _useListingPdtLoggerV = (0,_useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(),
      sendPdtListingErrorV2 = _useListingPdtLoggerV.sendPdtListingErrorV2;

  var fetchListingDetailsOnLocationChange = /*#__PURE__*/function () {
    var _ref = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(request_id, delivery_details, options) {
      var contextUrl, _response$data5, _ref2, reqId, data, headers, response, _response$data, _response$data2, _response$data3, _response$data4, products, _e$message, _e$message2, error;

      return _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              contextUrl = (0,_utils__WEBPACK_IMPORTED_MODULE_7__.getContextUrl)(partner);
              _context.prev = 1;
              _ref2 = options || {}, reqId = _ref2.reqId;
              dispatch((0,_store_action__WEBPACK_IMPORTED_MODULE_13__/* .loadingListingPageOnLocationChange */ .Pd)());
              data = getBody(delivery_details || {}, request_id, forex_rates, device);
              headers = {};

              if ((0,_utils__WEBPACK_IMPORTED_MODULE_7__.getHostName)() !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP) {
                headers = _objectSpread({}, (0,_utils__WEBPACK_IMPORTED_MODULE_7__.getRequestIdHeaders)(reqId));
              }

              _context.next = 9;
              return (0,_api_fetchApi__WEBPACK_IMPORTED_MODULE_3__/* .fetchApiForexListing */ .Xs)(contextUrl, {
                method: "POST",
                data: data,
                headers: headers
              });

            case 9:
              response = _context.sent;

              if (!(response !== null && response !== void 0 && response.success)) {
                _context.next = 17;
                break;
              }

              dispatch((0,_store_action__WEBPACK_IMPORTED_MODULE_13__/* .fetchingListingPageOnLocationChange */ .K$)(response === null || response === void 0 ? void 0 : response.data));
              sendPdtRateTickerViewEvent(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.forex_rates, response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.tm_user_id, response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.puid);
              (0,_utils__WEBPACK_IMPORTED_MODULE_7__.setJourneyIdInCookie)({
                partner: partner,
                journeyId: response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4["x-jo-id"]
              });
              return _context.abrupt("return", {
                listingData: response.data
              });

            case 17:
              if (response !== null && response !== void 0 && response.success) {
                _context.next = 22;
                break;
              }

              sendPdtListingError(response === null || response === void 0 ? void 0 : response.error, _constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.PRODUCT_LISTING_API_ERROR */ .rI.PRODUCT_LISTING_API_ERROR);
              sendPdtListingErrorV2(response === null || response === void 0 ? void 0 : response.error, _constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.PRODUCT_LISTING_API_ERROR */ .rI.PRODUCT_LISTING_API_ERROR);
              dispatch((0,_store_action__WEBPACK_IMPORTED_MODULE_13__/* .fetchingListingPageOnLocationChange */ .K$)({
                // TODO: Set default version according to the other application releases.
                version: _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_MX_FLOW_VERSION */ .DI,
                products: (0,_utils__WEBPACK_IMPORTED_MODULE_7__.setDefaultForexCardsData)()
              }));
              return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.error);

            case 22:
              products = response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.products; // Set default products if api doesn't return forex products list.

              if (!(!products || !products.length)) {
                _context.next = 28;
                break;
              }

              sendPdtListingError(response === null || response === void 0 ? void 0 : response.error, _constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.PRODUCT_LIST_ERROR */ .rI.PRODUCT_LIST_ERROR);
              sendPdtListingErrorV2(response === null || response === void 0 ? void 0 : response.error, _constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.PRODUCT_LIST_ERROR */ .rI.PRODUCT_LIST_ERROR);
              dispatch((0,_store_action__WEBPACK_IMPORTED_MODULE_13__/* .fetchingListingPageOnLocationChange */ .K$)({
                // TODO: Set default version according to the other application releases.
                version: _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_MX_FLOW_VERSION */ .DI,
                products: (0,_utils__WEBPACK_IMPORTED_MODULE_7__.setDefaultForexCardsData)()
              }));
              return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

            case 28:
              _context.next = 37;
              break;

            case 30:
              _context.prev = 30;
              _context.t0 = _context["catch"](1);
              error = {
                apiUrl: contextUrl,
                code: _context.t0 !== null && _context.t0 !== void 0 && (_e$message = _context.t0.message) !== null && _e$message !== void 0 && _e$message.includes(_constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR) ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_CODE.NETWORK */ .Bq.NETWORK : "",
                description: _context.t0 !== null && _context.t0 !== void 0 && (_e$message2 = _context.t0.message) !== null && _e$message2 !== void 0 && _e$message2.includes(_constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR) ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.FETCH_ERROR */ .rI.FETCH_ERROR : _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
              };
              sendPdtListingError(error);
              sendPdtListingErrorV2(_context.t0, _constants__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_MSGS.LISTING_API_FAIL */ .rI.LISTING_API_FAIL); // Set default product if api fails for any reason.

              dispatch((0,_store_action__WEBPACK_IMPORTED_MODULE_13__/* .fetchingListingPageOnLocationChange */ .K$)({
                // TODO: Set default version according to the other application releases.
                version: _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_MX_FLOW_VERSION */ .DI,
                products: (0,_utils__WEBPACK_IMPORTED_MODULE_7__.setDefaultForexCardsData)()
              }));
              console.error(_context.t0);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 30]]);
    }));

    return function fetchListingDetailsOnLocationChange(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    fetchListingDetailsOnLocationChange: fetchListingDetailsOnLocationChange
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useFetchListingDetails);

function getBody(delivery_details, request_id, forex_rates, device) {
  var filter = (0,_useFetchForexRates__WEBPACK_IMPORTED_MODULE_8__/* .getForexRatesFilterInfo */ .zt)(forex_rates);
  return {
    query: {
      request_id: request_id,
      mandatory: {
        forex_rates: {
          filter: filter
        },
        products: {
          inr_card: {
            delivery_details: device === "sm" ? true : false,
            persuasions: true
          },
          multi_cx_card: {
            cta: true,
            delivery_details: device === "sm" ? true : false,
            persuasions: true,
            card_cta: true,
            program_details: true
          },
          currency: {
            cta: true,
            delivery_details: device === "sm" ? true : false,
            persuasions: true
          }
        },
        persona: true,
        offer_persuasions: true,
        recommended_currencies_ticker: true,
        assistance_flow: {
          type: true
        },
        pricing_nudge: true,
        delivery_nudge: device === "lg" ? false : true
      }
    },
    data: {
      location: _objectSpread({}, delivery_details)
    }
  };
}

/***/ }),

/***/ 6107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useFreezeBodyScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useFreezeBodyScroll = function useFreezeBodyScroll(isModalOpen) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }

    return function () {
      document.body.style.overflow = "scroll";
    };
  }, [isModalOpen]);
};

/***/ }),

/***/ 7327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useGeoLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var utils = __webpack_require__(8333);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useDevice.ts
var useDevice = __webpack_require__(5187);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts + 3 modules
var usePdtLogger = __webpack_require__(761);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useDefaultLocationTimer/index.ts

var useDefaultLocationTimer = function useDefaultLocationTimer(_ref) {
  var _ref$initialTime = _ref.initialTime,
      initialTime = _ref$initialTime === void 0 ? 0 : _ref$initialTime,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 1000 : _ref$interval;
  var timerRef = (0,react.useRef)(null);
  var timeRef = (0,react.useRef)(initialTime);

  var startTimer = function startTimer(callback) {
    if (timerRef.current === null) {
      timerRef.current = setInterval(function () {
        console.log("time:", timeRef.current);

        if (timeRef.current > 0) {
          timeRef.current -= interval;
        } else {
          callback();
          resetTimer();
        }
      }, interval);
    }
  };

  var resetTimer = function resetTimer() {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    timeRef.current = initialTime;
  };

  var stopTimer = function stopTimer() {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
    }
  };

  return {
    startTimer: startTimer,
    resetTimer: resetTimer
  };
};
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useListingPdtLoggerV2/index.ts
var useListingPdtLoggerV2 = __webpack_require__(2221);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useGeolocation/index.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var initialLocation = {
  latitude: null,
  longitude: null
};
var initialState = {
  location: initialLocation,
  error: null,
  isError: false,
  isLoading: false,
  isSuccess: false
};
var LOCATION_FETCH_LOADING = "LOCATION_FETCH_LOADING";
var LOCATION_FETCH_SUCCESS = "LOCATION_FETCH_SUCCESS";
var LOCATION_FETCH_ERROR = "LOCATION_FETCH_ERROR";

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case LOCATION_FETCH_LOADING:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isLoading: true
      });

    case LOCATION_FETCH_SUCCESS:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        location: payload,
        isSuccess: true
      });

    case LOCATION_FETCH_ERROR:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isError: true,
        error: payload
      });

    default:
      return state;
  }
};

var FETCH_USER_LOC_FUNCTION = "fetchUserLocation";
var useGeoLocation = function useGeoLocation(partner) {
  var timerRef = (0,react.useRef)();

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var device = (0,useDevice/* useDevice */.F)();

  var _useListingPdtLogger = (0,usePdtLogger/* useListingPdtLogger */.v)(),
      sendPdtListingError = _useListingPdtLogger.sendPdtListingError;

  var _useListingPdtLoggerV = (0,useListingPdtLoggerV2/* default */.Z)(),
      sendPdtListingErrorV2 = _useListingPdtLoggerV.sendPdtListingErrorV2;

  var _useDefaultLocationTi = useDefaultLocationTimer({
    initialTime: 5 * 1000,
    interval: 1000
  }),
      startTimer = _useDefaultLocationTi.startTimer,
      resetTimer = _useDefaultLocationTi.resetTimer;

  (0,react.useEffect)(function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.fetchUserLocation = function (userLocation) {
      resetTimer();

      try {
        if (userLocation === "null") {
          timerRef.current = setTimeout(function () {
            dispatch({
              type: LOCATION_FETCH_ERROR,
              payload: {
                message: "Location denied"
              }
            });
          }, 20);
          return;
        }

        var location = JSON.parse(userLocation);

        var _ref2 = location || {},
            Latitude = _ref2.Latitude,
            Longitude = _ref2.Longitude;

        if (Latitude && Longitude) {
          timerRef.current = setTimeout(function () {
            dispatch({
              type: LOCATION_FETCH_SUCCESS,
              payload: {
                latitude: Latitude,
                longitude: Longitude
              }
            });
          }, 20);
        } else {
          timerRef.current = setTimeout(function () {
            dispatch({
              type: LOCATION_FETCH_ERROR,
              payload: {
                message: "Location denied"
              }
            });
          }, 20);
        }
      } catch (_unused) {
        timerRef.current = setTimeout(function () {
          dispatch({
            type: LOCATION_FETCH_ERROR,
            payload: {
              message: "Location denied"
            }
          });
        }, 20);
      }
    };

    return function () {
      clearTimeout(timerRef.current);
    };
  }, []);

  var setUserLocationWeb = function setUserLocationWeb() {
    if (navigator.permissions) {
      dispatch({
        type: LOCATION_FETCH_LOADING
      });
      navigator.geolocation.getCurrentPosition(function (position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        resetTimer();
        dispatch({
          type: LOCATION_FETCH_SUCCESS,
          payload: {
            latitude: latitude,
            longitude: longitude
          }
        });
      }, function (error) {
        resetTimer();
        dispatch({
          type: LOCATION_FETCH_ERROR,
          payload: error
        });
      }, {
        timeout: 10000
      });
    } else {
      resetTimer();
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: {
          message: constants/* ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED */.rI.GEOLOCATION_NOT_SUPPORTED
        }
      });
      var error = {
        errorDescription: constants/* ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED */.rI.GEOLOCATION_NOT_SUPPORTED
      };
      sendPdtListingError(error);
      sendPdtListingErrorV2(error);
      console.error(constants/* ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED */.rI.GEOLOCATION_NOT_SUPPORTED);
    }
  };

  var setUserLocationAndroid = function setUserLocationAndroid() {
    try {
      var _window, _window$app_bridge;

      dispatch({
        type: LOCATION_FETCH_LOADING
      }); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      if ((_window = window) !== null && _window !== void 0 && (_window$app_bridge = _window.app_bridge) !== null && _window$app_bridge !== void 0 && _window$app_bridge.fetchLocation) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.app_bridge.fetchLocation(FETCH_USER_LOC_FUNCTION, true);
      } else {
        resetTimer();
        timerRef.current = setTimeout(function () {
          dispatch({
            type: LOCATION_FETCH_ERROR,
            payload: {
              error: "Fetch location method is not available"
            }
          });
        }, constants/* WAITING_TIME_LOCATION_FETCING */.XF);
      }
    } catch (e) {
      resetTimer();
      timerRef.current = setTimeout(function () {
        dispatch({
          type: LOCATION_FETCH_ERROR,
          payload: {
            error: e === null || e === void 0 ? void 0 : e.message
          }
        });
      }, constants/* WAITING_TIME_LOCATION_FETCING */.XF);

      var errorObj = _objectSpread(_objectSpread({}, e), {}, {
        message: "".concat(e.message, " setUserLocationAndroid fetchLocation")
      });

      sendPdtListingError(errorObj);
      sendPdtListingErrorV2(errorObj);
    }
  };

  var setUserLocation = function setUserLocation() {
    var _window2, _window3;

    startTimer(function () {
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: initialState.location
      });
    });
    var mobileOS = (0,utils/* getMobileOperatingSystem */.HG)();

    if (mobileOS.toLowerCase() === "android" && ( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (_window2 = window) !== null && _window2 !== void 0 && _window2.app_bridge || (_window3 = window) !== null && _window3 !== void 0 && _window3.mmt_android_bridge)) {
      setUserLocationAndroid();
      return;
    }

    setUserLocationWeb();
  };

  var setUserLocationIfPermittedDesktop = function setUserLocationIfPermittedDesktop() {
    if (navigator.permissions) {
      navigator.permissions.query({
        name: "geolocation"
      }).then(function (permissionStatus) {
        if (permissionStatus.state === "granted") {
          setUserLocationWeb();
        } else {
          // Permission not granted, do not request location
          resetTimer();
          dispatch({
            type: LOCATION_FETCH_SUCCESS,
            payload: initialState.location
          });
          console.error("Permission not granted", permissionStatus.state);
        }
      });
    } else {
      // Geolocation not supported
      resetTimer();
      dispatch({
        type: LOCATION_FETCH_SUCCESS,
        payload: initialState.location
      });
      console.log(constants/* ERROR_MSGS.GEOLOCATION_NOT_SUPPORTED */.rI.GEOLOCATION_NOT_SUPPORTED);
    }
  };

  var setUserLocationIfPermittedAndroid = function setUserLocationIfPermittedAndroid() {
    // TODO: Once method is available on bridge.
    // TODO: Add version conditions.
    try {
      var _window4, _window4$app_bridge;

      dispatch({
        type: LOCATION_FETCH_LOADING
      }); //@ts-ignore

      if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$app_bridge = _window4.app_bridge) !== null && _window4$app_bridge !== void 0 && _window4$app_bridge.fetchLocation) {
        //@ts-ignore
        window.app_bridge.fetchLocation(FETCH_USER_LOC_FUNCTION, false);
      } else {
        resetTimer();
        timerRef.current = setTimeout(function () {
          dispatch({
            type: LOCATION_FETCH_ERROR,
            payload: {
              error: "Method fetchLocation is not available"
            }
          });
        }, constants/* WAITING_TIME_LOCATION_FETCING */.XF);
      }
    } catch (e) {
      resetTimer();
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: {
          error: e.message
        }
      });

      var errorObj = _objectSpread(_objectSpread({}, e), {}, {
        message: "".concat(e.message, " setUserLocationIfPermittedAndroid fetchLocation")
      });

      sendPdtListingError(errorObj);
      sendPdtListingErrorV2(errorObj);
    }
  };

  var setUserLocationIfPermittedIOS = function setUserLocationIfPermittedIOS() {
    // TODO: Once method is available on bridge.
    // TODO Apply bridge conditions.
    var location = _objectSpread({}, initialLocation);

    try {
      var _location, _location2;

      if (partner === constants/* PARTNER.MMT */.RL.MMT) {
        var _window5, _window5$app_bridge;

        //@ts-ignore
        location = (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$app_bridge = _window5.app_bridge) === null || _window5$app_bridge === void 0 ? void 0 : _window5$app_bridge.lastKnownLocation();
      } else if (partner === constants/* PARTNER.GI */.RL.GI) {
        var _window6, _window6$app_bridge;

        location = JSON.parse( //@ts-ignore
        (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$app_bridge = _window6.app_bridge) === null || _window6$app_bridge === void 0 ? void 0 : _window6$app_bridge.fetchLocation(JSON.stringify(true)));
      }

      if ((_location = location) !== null && _location !== void 0 && _location.latitude && (_location2 = location) !== null && _location2 !== void 0 && _location2.longitude) {
        resetTimer();
        dispatch({
          type: LOCATION_FETCH_SUCCESS,
          payload: location
        });
      } else {
        resetTimer();
        dispatch({
          type: LOCATION_FETCH_ERROR,
          payload: {
            error: "Unable to fetch location"
          }
        });
      }
    } catch (e) {
      resetTimer();
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: {
          error: e === null || e === void 0 ? void 0 : e.message
        }
      });
    }
  };

  var setUserLocationIfPermitted = function setUserLocationIfPermitted() {
    startTimer(function () {
      dispatch({
        type: LOCATION_FETCH_ERROR,
        payload: initialState.location
      });
    });

    if (device === "lg") {
      setUserLocationIfPermittedDesktop();
    } else if (device === "sm") {
      var _window7;

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if ((_window7 = window) !== null && _window7 !== void 0 && _window7.app_bridge) {
        var mobileOS = (0,utils/* getMobileOperatingSystem */.HG)();

        if (mobileOS.toLowerCase() === "android") {
          setUserLocationIfPermittedAndroid();
        } else if (mobileOS.toLocaleLowerCase() === "ios") {
          setUserLocationIfPermittedIOS();
        }
      } else {
        setUserLocationIfPermittedDesktop();
      }
    }
  };

  return _objectSpread(_objectSpread({}, state), {}, {
    setUserLocation: setUserLocation,
    setUserLocationIfPermitted: setUserLocationIfPermitted
  });
};

/***/ }),

/***/ 588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useGlobalConfig; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Contexts_GlobalConfigContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8169);


var useGlobalConfig = function useGlobalConfig() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Contexts_GlobalConfigContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};

/***/ }),

/***/ 3211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useGlobalDispatch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Contexts_DispatchContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7752);


var useGlobalDispatch = function useGlobalDispatch() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Contexts_DispatchContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};

/***/ }),

/***/ 2053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useGlobalSelector; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Contexts_ForexListingDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8817);


var useGlobalSelector = function useGlobalSelector(cb) {
  var data = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Contexts_ForexListingDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  return cb(data);
};

/***/ }),

/***/ 2221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2638);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6198);
/* harmony import */ var _utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4556);
/* harmony import */ var _useGlobalSelector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2053);





var useListingPdtLoggerV2 = function useListingPdtLoggerV2() {
  var _useGlobalSelector = (0,_useGlobalSelector__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalSelector */ .a)(function (state) {
    return state;
  }),
      userId = _useGlobalSelector.tm_user_id,
      puid = _useGlobalSelector.puid;

  var _getPdtLoggerMethods = (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getPdtLoggerMethods)({
    lobFunnelType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .LOB_FUNNEL_TYPE.LISTING */ .fH.LISTING,
    puid: puid ? "".concat(puid) : null,
    userId: userId ? "".concat(userId) : null,
    lobCategory: "Listing",
    pdtEvents: _constants__WEBPACK_IMPORTED_MODULE_0__/* .LSITING_PDT_EVENTS_V2 */ .El,
    funnelStep: "0"
  }),
      sendCTAData = _getPdtLoggerMethods.sendCTAData,
      sendPdtDataV2 = _getPdtLoggerMethods.sendPdtDataV2;

  var sendListingPdtLocationDetectedViewEventV2 = function sendListingPdtLocationDetectedViewEventV2(_ref) {
    var eventTrackingContext = _ref.eventTrackingContext;

    try {
      var userLocation = (0,_utils_clientStorageUtils__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorageItem */ .St)(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY */ .sO.USER_LOCATION_SESSION_KEY, true, _constants__WEBPACK_IMPORTED_MODULE_0__/* .getSessionPiiDataOpts */ .bX);
      var eventDetail = {
        event_name: _constants__WEBPACK_IMPORTED_MODULE_0__/* .PDT_EVENTS.LOC_DETECT_EVENT */ .sJ.LOC_DETECT_EVENT,
        delivery_details: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getDeliveryDetailsPdtSchema)({
          deliveryDetails: userLocation
        })
      };
      sendPdtDataV2({
        event_detail: eventDetail,
        event_tracking_context: eventTrackingContext
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtLocationBottomSheetViewEventV2 = function sendPdtLocationBottomSheetViewEventV2() {
    try {
      var eventDetail = {
        event_name: _constants__WEBPACK_IMPORTED_MODULE_0__/* .PDT_EVENTS.LOC_BOTTOM_SHEET_VIEWED */ .sJ.LOC_BOTTOM_SHEET_VIEWED
      };
      var pageContextData = {
        subpage_name: _constants__WEBPACK_IMPORTED_MODULE_0__/* .PDT_EVENTS.LOC_BOTTOM_SHEET_VIEWED */ .sJ.LOC_BOTTOM_SHEET_VIEWED
      };
      sendPdtDataV2({
        event_detail: eventDetail,
        page_context: pageContextData
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtLoginClickEventListingPageV2 = function sendPdtLoginClickEventListingPageV2() {
    try {
      var eventDetail = (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getEventDetails)({
        event_name: _constants__WEBPACK_IMPORTED_MODULE_0__/* .PDT_EVENTS.LISTING_PAGE_LOGIN_CLICK */ .sJ.LISTING_PAGE_LOGIN_CLICK
      });
      sendCTAData({
        eventDetail: eventDetail
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtRateTickerViewEventV2 = function sendPdtRateTickerViewEventV2(forex_rates, reqId) {
    try {
      var eventDetail = {
        event_name: _constants__WEBPACK_IMPORTED_MODULE_0__/* .PDT_EVENTS.RATE_TICKER_LOAD */ .sJ.RATE_TICKER_LOAD,
        ticker: {
          available_currency: JSON.stringify(Object.keys(forex_rates || {})),
          ticker_shown: Object.keys(forex_rates || {}).length ? true : false
        }
      };
      sendPdtDataV2({
        event_detail: eventDetail,
        event_tracking_context: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getEventTrackingContext)({
          request_id: reqId
        })
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtListingErrorV2 = function sendPdtListingErrorV2(error) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    try {
      var eventDetail = {
        vendor_error_details: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getVendorErrorDetails)({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: (error === null || error === void 0 ? void 0 : error.errorTitle) || (error === null || error === void 0 ? void 0 : error.errorDescription) || (error === null || error === void 0 ? void 0 : error.description) || description || "Unknown error"
        })
      };
      sendPdtDataV2({
        event_detail: eventDetail
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtUserServiceApiCallEventV2 = function sendPdtUserServiceApiCallEventV2(eventCta) {
    try {
      var eventDetail = (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getEventDetails)({
        event_name: eventCta
      });
      sendCTAData({
        eventDetail: eventDetail
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtLoginTokenErrorV2 = function sendPdtLoginTokenErrorV2(error) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    try {
      var eventDetail = {
        vendor_error_details: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getVendorErrorDetails)({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: (error === null || error === void 0 ? void 0 : error.errorTitle) || (error === null || error === void 0 ? void 0 : error.errorDescription) || (error === null || error === void 0 ? void 0 : error.description) || description || "Unknown error"
        })
      };
      sendPdtDataV2({
        event_detail: eventDetail
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtAppSocialErrorV2 = function sendPdtAppSocialErrorV2(error) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    try {
      var eventDetail = {
        vendor_error_details: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getVendorErrorDetails)({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: (error === null || error === void 0 ? void 0 : error.errorTitle) || (error === null || error === void 0 ? void 0 : error.errorDescription) || (error === null || error === void 0 ? void 0 : error.description) || description || "Unknown error"
        })
      };
      sendPdtDataV2({
        event_detail: eventDetail
      });
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  return {
    sendCTAData: sendCTAData,
    sendPdtDataV2: sendPdtDataV2,
    sendListingPdtLocationDetectedViewEventV2: sendListingPdtLocationDetectedViewEventV2,
    sendPdtLocationBottomSheetViewEventV2: sendPdtLocationBottomSheetViewEventV2,
    sendPdtLoginClickEventListingPageV2: sendPdtLoginClickEventListingPageV2,
    sendPdtRateTickerViewEventV2: sendPdtRateTickerViewEventV2,
    sendPdtListingErrorV2: sendPdtListingErrorV2,
    sendPdtUserServiceApiCallEventV2: sendPdtUserServiceApiCallEventV2,
    sendPdtLoginTokenErrorV2: sendPdtLoginTokenErrorV2,
    sendPdtAppSocialErrorV2: sendPdtAppSocialErrorV2
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useListingPdtLoggerV2);

/***/ }),

/***/ 5426:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2638);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _utils_authUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(277);
/* harmony import */ var _useGlobalConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(588);
/* harmony import */ var _useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2221);
/* harmony import */ var _usePdtLogger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(761);









var useOpenLoginForm = function useOpenLoginForm() {
  var _useGlobalConfig = useGlobalConfig(),
      onLoginClick = _useGlobalConfig.onLoginClick;

  var _useListingPdtLogger = useListingPdtLogger(),
      sendPdtLoginPopOpen = _useListingPdtLogger.sendPdtLoginPopOpen;

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendCTAData = _useListingPdtLoggerV.sendCTAData;

  var sendPdtLoginPopupOpenV2 = function sendPdtLoginPopupOpenV2() {
    var eventDetail = getEventDetails({
      event_name: PDT_EVENTS.LOGIN_POP_UP_OPEN
    });
    sendCTAData({
      eventDetail: eventDetail
    });
  };

  var openLoginFormForNonLoggedInUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!shouldOpenMMTLogin()) {
                _context.next = 5;
                break;
              }

              sendPdtLoginPopOpen();
              sendPdtLoginPopupOpenV2();
              onLoginClick === null || onLoginClick === void 0 ? void 0 : onLoginClick();
              return _context.abrupt("return");

            case 5:
              _context.next = 7;
              return loginInPartner(sendPdtLoginPopOpen, sendPdtLoginPopupOpenV2);

            case 7:
              return _context.abrupt("return");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openLoginFormForNonLoggedInUser() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    openLoginFormForNonLoggedInUser: openLoginFormForNonLoggedInUser
  };
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useOpenLoginForm)));

/***/ }),

/***/ 761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ useListingPdtLogger; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(2151);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/utils/commonPdtUtils.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var getPdtErrorData = function getPdtErrorData(error) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var user_details = arguments.length > 2 ? arguments[2] : undefined;
  var device = arguments.length > 3 ? arguments[3] : undefined;
  var context = arguments.length > 4 ? arguments[4] : undefined;
  var exp_experiment_details_list = arguments.length > 5 ? arguments[5] : undefined;
  var errorLog = error ? error : false;
  return [{
    context: context,
    user_details: user_details ? user_details : null,
    device: device ? device : null,
    page: {
      url: window.location.href || null,
      error: errorLog ? "true" : null,
      error_details: errorLog ? {
        api_url: (errorLog === null || errorLog === void 0 ? void 0 : errorLog.apiUrl) || null,
        code: errorLog ? errorLog.code ? errorLog.code : null : "NO_CODE_FOUND",
        description: errorLog ? errorLog.errorTitle || errorLog.errorDescription || errorLog.description || errorLog.message || description : "Unknown error"
      } : null,
      utm: getUtmPdtObj(),
      page_source: constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE
    },
    exp_experiment_details_list: exp_experiment_details_list
  }];
};
var setPdtCtaAndCommonPdtData = function setPdtCtaAndCommonPdtData(user_details, device, ctaData, context, version, partner, pageName) {
  var exp_experiment_details_list = [{
    exp_experiment_variant_id: (0,utils.getPokusExpVersion)({
      partner: partner
    }),
    exp_experiment_version: version
  }];
  return [{
    context: context,
    page: {
      url: window.location.href || null,
      utm: getUtmPdtObj(),
      page_source: constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE
    },
    user_details: user_details ? user_details : null,
    device: device ? device : null,
    cta: {
      label: ctaData !== null && ctaData !== void 0 && ctaData.label ? ctaData.label : null,
      cta_info: {
        primary_value: (ctaData === null || ctaData === void 0 ? void 0 : ctaData.primary_value) || null,
        secondary_value: (ctaData === null || ctaData === void 0 ? void 0 : ctaData.secondary_value) || null,
        others: ctaData !== null && ctaData !== void 0 && ctaData.others ? ctaData.others : null
      }
    },
    exp_experiment_details_list: exp_experiment_details_list
  }];
};
var setPdtEventData = function setPdtEventData(user_details, device, otherData, context, eventCta) {
  var exp_experiment_details_list = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return [_objectSpread({
    context: context,
    page: {
      url: window.location.href || null,
      utm: getUtmPdtObj(),
      page_source: constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE
    },
    user_details: user_details ? user_details : null,
    device: device ? device : null,
    cta: {
      label: eventCta ? eventCta : null
    },
    exp_experiment_details_list: exp_experiment_details_list ? exp_experiment_details_list : null
  }, otherData)];
};
var getPdtOtherDataSchema = function getPdtOtherDataSchema() {
  return {
    funnel_details: {
      delivery_details: {
        latitude: null,
        longitude: null,
        location_source: null,
        pincode: null,
        city: null,
        location_permission: null
      },
      forex_listing_details: {
        persuasions: {
          delivery_tracking: {
            is_visible: null
          },
          backend: {
            is_visible: null
          },
          drop_off: {
            is_visible: null
          },
          mini_dashboard: {
            is_visible: null
          },
          upload_docs: {
            is_visible: null
          }
        },
        unavailable_Location: {
          is_visible: null
        },
        default: {
          is_visible: null
        }
      },
      rate_ticker: {
        currencies: null
      }
    }
  };
};
var setPdtLocationDetectedSchema = function setPdtLocationDetectedSchema(locationSource, permissionDetails, delivery_details) {
  return {
    latitude: "".concat(delivery_details === null || delivery_details === void 0 ? void 0 : delivery_details.latitude) || null,
    longitude: "".concat(delivery_details === null || delivery_details === void 0 ? void 0 : delivery_details.longitude) || null,
    location_source: locationSource || null,
    pincode: "".concat(delivery_details === null || delivery_details === void 0 ? void 0 : delivery_details.pincode) || null,
    city: "".concat(delivery_details === null || delivery_details === void 0 ? void 0 : delivery_details.city) || null,
    location_permission: permissionDetails || null
  };
};

function getUtmPdtObj() {
  return {
    medium: (0,cookieUtils/* getCookie */.ej)(constants/* UTM_PARAMS_KEY.UTM_MEDIUM */.J6.UTM_MEDIUM, false, {
      path: "/"
    }) || null,
    source: (0,cookieUtils/* getCookie */.ej)(constants/* UTM_PARAMS_KEY.UTM_SOURCE */.J6.UTM_SOURCE, false, {
      path: "/"
    }) || null,
    campaign: (0,cookieUtils/* getCookie */.ej)(constants/* UTM_PARAMS_KEY.UTM_CAMPAIGN */.J6.UTM_CAMPAIGN, false, {
      path: "/"
    }) || null
  };
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/api/fetchApi.ts
var fetchApi = __webpack_require__(5859);
// EXTERNAL MODULE: ../../node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(6353);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var useGlobalSelector = __webpack_require__(2053);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalConfig.ts
var useGlobalConfig = __webpack_require__(588);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/bridges/index.ts
var bridges = __webpack_require__(6787);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(4556);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useItineraryId/index.ts




function useItineraryId() {
  var ITINERARY_ID_KEY = "itinerary_id";

  var _useState = (0,react.useState)(""),
      itineraryId = _useState[0],
      setItineraryId = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isItineraryIdFetched = _useState2[0],
      setIsItineraryIdFetched = _useState2[1];

  (0,react.useEffect)(function () {
    var id = "";
    var urlItineraryIdParam = (0,utils.getQueryParamsFromUrl)()[ITINERARY_ID_KEY] || "";

    if (urlItineraryIdParam) {
      if (Array.isArray(urlItineraryIdParam)) {
        id = urlItineraryIdParam[0];
      } else {
        id = urlItineraryIdParam;
      }
    } else {
      var sessionItineraryId = (0,clientStorageUtils/* getSessionStorageItem */.St)(constants/* SESSION_STORAGE_KEYS.ITINERARY_ID */.sO.ITINERARY_ID, true, constants/* getSessionPiiDataOpts */.bX);
      id = sessionItineraryId || "";
    }

    (0,clientStorageUtils/* setSessionStorageItem */.D9)(constants/* SESSION_STORAGE_KEYS.ITINERARY_ID */.sO.ITINERARY_ID, id, true, constants/* setSessionPiiDataOpts */._N);
    setIsItineraryIdFetched(true);
    setItineraryId(id);
  }, []);
  return {
    isItineraryIdFetched: isItineraryIdFetched,
    itineraryId: itineraryId
  };
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useGetCommonPdtData.ts
// @ts-ignore







var useGetCommonPdtData = function useGetCommonPdtData() {
  var latitude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var longitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useGlobalSelector = (0,useGlobalSelector/* useGlobalSelector */.a)(function (state) {
    return state;
  }),
      userId = _useGlobalSelector.tm_user_id,
      puid = _useGlobalSelector.puid,
      version = _useGlobalSelector.version;

  var _useGlobalConfig = (0,useGlobalConfig/* useGlobalConfig */.W)(),
      partner = _useGlobalConfig.partner;

  var _useItineraryId = useItineraryId(),
      itineraryId = _useItineraryId.itineraryId;

  var ua = !(0,utils.isOnServer)() ? navigator.userAgent : null;
  var parser = new (ua_parser_default())().setUA(ua).getResult();
  var app_version = !(0,utils.isOnServer)() ? bridges/* BridgeMethods.getAppVersion */.X.getAppVersion() : null;
  var user = {
    zuid: "".concat(userId !== null && userId !== void 0 ? userId : ""),
    puid: "".concat(puid !== null && puid !== void 0 ? puid : ""),
    partner: (0,constants/* getPartner */.kW)(),
    is_loggedin: userId ? "true" : null
  };
  app_version = "".concat((0,constants/* getPartner */.kW)() === constants/* PARTNER.MMT */.RL.MMT ? constants/* PARTNER.MMT.toUpperCase */.RL.MMT.toUpperCase() : constants/* PARTNER.GI.toUpperCase */.RL.GI.toUpperCase(), "_") + app_version;
  var context = {
    topic_name: "tripmoney_forex_ui",
    template_id: "59243",
    client_timestamp: new Date().getTime(),
    lob_name: "LEN",
    environment: "prod",
    correlation_key: itineraryId
  };
  return {
    context: context,
    user_details: {
      zuid: user && user.zuid ? user.zuid : null,
      puid: user && user.puid ? user.puid : null,
      partner: user && user.partner ? user.partner : null,
      is_loggedin: user !== null && user !== void 0 && user.is_loggedin ? user.is_loggedin : null
    },
    device: {
      latitude: latitude ? latitude : null,
      longitude: longitude ? longitude : null,
      os: parser && parser.os && parser.os.name ? parser.os.name : null,
      type: !(0,utils.isMobile)() ? "Desktop" : parser && parser.device && parser.device.type ? parser.device.type : null,
      os_version: parser && parser.os && parser.os.version ? parser.os.version : null,
      app_version: app_version || null,
      user_agent: ua,
      model: (0,utils.getDeviceType)() || null,
      connection_type: (0,utils.getDeviceIdStatus)(),
      id: (0,utils.getDeviceId)((0,constants/* getPartner */.kW)())
    },
    version: version
  };
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/usePdtLogger.ts




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }









var useListingPdtLogger = function useListingPdtLogger() {
  var _useGetCommonPdtData = useGetCommonPdtData(),
      user_details = _useGetCommonPdtData.user_details,
      device = _useGetCommonPdtData.device,
      context = _useGetCommonPdtData.context;

  var _useGlobalSelector = (0,useGlobalSelector/* useGlobalSelector */.a)(function (state) {
    return state;
  }),
      version = _useGlobalSelector.version;

  var otherData = getPdtOtherDataSchema();

  var _useGlobalConfig = (0,useGlobalConfig/* useGlobalConfig */.W)(),
      partner = _useGlobalConfig.partner;

  var getExperimentDetails = function getExperimentDetails(override) {
    var exp_experiment_details_list = [{
      exp_experiment_variant_id: (0,utils.getPokusExpVersion)({
        partner: (override === null || override === void 0 ? void 0 : override.partner) || partner
      }),
      exp_experiment_version: (override === null || override === void 0 ? void 0 : override.version) || version
    }];
    return exp_experiment_details_list;
  };

  var getPdtCommonCtaData = function getPdtCommonCtaData(ctaData) {
    var pdtData = setPdtCtaAndCommonPdtData(user_details, device, ctaData, context, version, partner);
    return pdtData;
  };

  var sendListingPdtLocationDetectedViewEvent = function sendListingPdtLocationDetectedViewEvent(locationSource, permissionDetails, version, tm_user_id, puid) {
    var exp_experiment_details_list = getExperimentDetails({
      version: version
    });
    var userLocation = (0,clientStorageUtils/* getSessionStorageItem */.St)(constants/* SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY */.sO.USER_LOCATION_SESSION_KEY, true, constants/* getSessionPiiDataOpts */.bX);
    otherData.funnel_details.delivery_details = setPdtLocationDetectedSchema(locationSource, permissionDetails, userLocation);
    user_details.zuid = tm_user_id ? "".concat(tm_user_id) : user_details.zuid;
    user_details.puid = puid ? "".concat(puid) : user_details.puid;
    user_details.is_loggedin = user_details !== null && user_details !== void 0 && user_details.zuid || user_details !== null && user_details !== void 0 && user_details.puid ? "true" : null;
    var listingLocationPdtData = setPdtEventData(user_details, device, otherData, context, constants/* PDT_EVENTS.LOC_DETECT_EVENT */.sJ.LOC_DETECT_EVENT, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(listingLocationPdtData);
  };

  var sendPdtListingPageViewEvent = function sendPdtListingPageViewEvent(listingData) {
    var _ref = listingData || {},
        persona = _ref.persona,
        forex_rates = _ref.forex_rates,
        tm_user_id = _ref.tm_user_id,
        products = _ref.products,
        puid = _ref.puid;

    var _ref2 = persona || {},
        upcoming_trip = _ref2.upcoming_trip;

    var loadedPageVersion = new Set();
    var currencyCardValue = (0,utils.getCardValue)(products, constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY);
    var currencyCtaRedirect = currencyCardValue === null || currencyCardValue === void 0 ? void 0 : currencyCardValue.cta_redirect;

    var _iterator = _createForOfIteratorHelper(products || []),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var product = _step.value;

        for (var _i = 0, _Object$entries = Object.entries(product); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
              card = _Object$entries$_i[0],
              cardValue = _Object$entries$_i[1];

          var _ref3 = (cardValue === null || cardValue === void 0 ? void 0 : cardValue.delivery_details) || {},
              deliverable = _ref3.deliverable;

          if (deliverable === false) {
            loadedPageVersion.add(constants/* PDT_EVENTS.ANOTHER_LOC */.sJ.ANOTHER_LOC);
          }

          var _cardValue$persuasion = cardValue.persuasions,
              persuasions = _cardValue$persuasion === void 0 ? [] : _cardValue$persuasion;

          var _iterator2 = _createForOfIteratorHelper(persuasions),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var persuasionObj = _step2.value;

              var _ref4 = persuasionObj || {},
                  type = _ref4.type;

              loadedPageVersion.add(type);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var userLocation = (0,clientStorageUtils/* getSessionStorageItem */.St)(constants/* SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY */.sO.USER_LOCATION_SESSION_KEY, true, constants/* getSessionPiiDataOpts */.bX);

    if (loadedPageVersion === null || loadedPageVersion.size == 0) {
      otherData.funnel_details.forex_listing_details.default.is_visible = "true";
    } else {
      var persuasionsData = otherData.funnel_details.forex_listing_details.persuasions;

      if (loadedPageVersion.has(constants/* PERSUASION_TYPE.DELIVERY_TRACKING */.NM.DELIVERY_TRACKING)) {
        persuasionsData.delivery_tracking.is_visible = "true";
      }

      if (loadedPageVersion.has(constants/* PERSUASION_TYPE.BACKEND */.NM.BACKEND)) {
        persuasionsData.backend.is_visible = "true";
      }

      if (loadedPageVersion.has(constants/* PERSUASION_TYPE.DROP_OFF */.NM.DROP_OFF)) {
        persuasionsData.drop_off.is_visible = "true";
      }

      if (loadedPageVersion.has(constants/* PERSUASION_TYPE.MINI_DASHBOARD */.NM.MINI_DASHBOARD)) {
        persuasionsData.mini_dashboard.is_visible = "true";
      }

      if (loadedPageVersion.has(constants/* PERSUASION_TYPE.UPLOAD_DOCUMENTS */.NM.UPLOAD_DOCUMENTS)) {
        persuasionsData.upload_docs.is_visible = "true";
      }
    }

    if (loadedPageVersion && loadedPageVersion.has(constants/* PDT_EVENTS.ANOTHER_LOC */.sJ.ANOTHER_LOC)) {
      otherData.funnel_details.forex_listing_details.unavailable_Location.is_visible = "true";
    }

    if (upcoming_trip) {
      var destination = (upcoming_trip === null || upcoming_trip === void 0 ? void 0 : upcoming_trip.country) || "";
      otherData.forex_context_item = {
        context_key: constants/* PDT_EVENTS.UPCOMING_TRIP */.sJ.UPCOMING_TRIP,
        context_value: destination
      };
    }

    if (forex_rates) {
      otherData.funnel_details.rate_ticker.currencies = forex_rates ? Object.keys(forex_rates) : null;
    }

    if (userLocation) {
      otherData.funnel_details.delivery_details = setPdtLocationDetectedSchema(null, null, userLocation);
    }

    user_details.zuid = tm_user_id ? "".concat(tm_user_id) : user_details.zuid;
    user_details.puid = puid ? "".concat(puid) : user_details.puid;
    user_details.is_loggedin = user_details !== null && user_details !== void 0 && user_details.zuid || user_details !== null && user_details !== void 0 && user_details.puid ? "true" : null;
    var exp_experiment_details_list = [{
      exp_experiment_variant_id: (0,utils.getPokusExpVersion)({
        partner: partner,
        currencyCtaRedirect: currencyCtaRedirect
      }),
      exp_experiment_version: version
    }];
    var pdtEventData = setPdtEventData(user_details, device, otherData, context, constants/* PDT_EVENTS.PAGE_LOAD_EVENT */.sJ.PAGE_LOAD_EVENT, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtEventData);
  };

  var sendListingPdtEventOnLocationBarClick = function sendListingPdtEventOnLocationBarClick() {
    var ctaData = {
      label: constants/* PDT_EVENTS.LOCATION_BAR_CTA */.sJ.LOCATION_BAR_CTA,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtLocationBottomSheetViewEvent = function sendPdtLocationBottomSheetViewEvent() {
    var exp_experiment_details_list = getExperimentDetails();
    otherData.event_details = {
      bottom_sheet_shown: {
        bottom_sheet_name: constants/* PDT_EVENTS.LOC_BOTTOM_SHEET_VIEWED */.sJ.LOC_BOTTOM_SHEET_VIEWED
      }
    };
    var pdtEventData = setPdtEventData(user_details, device, otherData, context, constants/* PDT_EVENTS.LOC_BOTTOM_SHEET_VIEWED */.sJ.LOC_BOTTOM_SHEET_VIEWED, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtEventData);
  };

  var sendPdtLocationDetectedOnBottomSheetClickEvent = function sendPdtLocationDetectedOnBottomSheetClickEvent() {
    var ctaData = {
      label: constants/* PDT_EVENTS.DETECT_LOC_CTA */.sJ.DETECT_LOC_CTA,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtSubmitPincodeBottomSheetClickEvent = function sendPdtSubmitPincodeBottomSheetClickEvent(isFallbackCity) {
    var city = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var pincode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var ctaData = {
      label: isFallbackCity ? constants/* PDT_EVENTS.FALLBACK_CITY_SUBMITTED */.sJ.FALLBACK_CITY_SUBMITTED : constants/* PDT_EVENTS.SUBMIT_PINCODE_CTA */.sJ.SUBMIT_PINCODE_CTA,
      primary_value: "",
      secondary_value: "",
      others: "".concat(pincode, "-").concat(city === null || city === void 0 ? void 0 : city.toLocaleLowerCase())
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtLoginClickEventListingPage = function sendPdtLoginClickEventListingPage() {
    var ctaData = {
      label: constants/* PDT_EVENTS.LISTING_PAGE_LOGIN_CLICK */.sJ.LISTING_PAGE_LOGIN_CLICK,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtLoginPopOpen = function sendPdtLoginPopOpen() {
    var ctaData = {
      label: constants/* PDT_EVENTS.LOGIN_POP_UP_OPEN */.sJ.LOGIN_POP_UP_OPEN,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtOpenEmailPopUp = function sendPdtOpenEmailPopUp() {
    var ctaData = {
      label: constants/* PDT_EVENTS.EMAIL_LOGIN_POP_UP_OPEN */.sJ.EMAIL_LOGIN_POP_UP_OPEN,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtEmailPopUpOkClick = function sendPdtEmailPopUpOkClick() {
    var ctaData = {
      label: constants/* PDT_EVENTS.EMAIL_LOGIN_POP_UP_OK_CLICK */.sJ.EMAIL_LOGIN_POP_UP_OK_CLICK,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtOpenAppUpdatePopUp = function sendPdtOpenAppUpdatePopUp() {
    var ctaData = {
      label: constants/* PDT_EVENTS.UPDATE_APP_POP_UP_OPEN */.sJ.UPDATE_APP_POP_UP_OPEN,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtOpenUpdateAppPopUpOkClick = function sendPdtOpenUpdateAppPopUpOkClick() {
    var ctaData = {
      label: constants/* PDT_EVENTS.UPDATE_APP_POP_UP_OK_CLICK */.sJ.UPDATE_APP_POP_UP_OK_CLICK,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtLoginErrorPopUpOpen = function sendPdtLoginErrorPopUpOpen() {
    var ctaData = {
      label: constants/* PDT_EVENTS.LOGIN_ERROR_POP_UP_OPEN */.sJ.LOGIN_ERROR_POP_UP_OPEN,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtLoginErrorPopUpOkClick = function sendPdtLoginErrorPopUpOkClick() {
    var ctaData = {
      label: constants/* PDT_EVENTS.LOGIN_ERROR_POP_UP_OK_CLICK */.sJ.LOGIN_ERROR_POP_UP_OK_CLICK,
      primary_value: "",
      secondary_value: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtRateTickerViewEvent = function sendPdtRateTickerViewEvent(forex_rates, tm_user_id, puid) {
    var exp_experiment_details_list = getExperimentDetails();
    otherData.funnel_details.rate_ticker.currencies = forex_rates ? Object.keys(forex_rates) : null;
    user_details.zuid = tm_user_id ? "".concat(tm_user_id) : user_details.zuid;
    user_details.puid = puid ? "".concat(puid) : user_details.puid;
    user_details.is_loggedin = user_details !== null && user_details !== void 0 && user_details.zuid || user_details !== null && user_details !== void 0 && user_details.puid ? "true" : null;
    var pdtRateTickerData = setPdtEventData(user_details, device, otherData, context, constants/* PDT_EVENTS.RATE_TICKER_LOAD */.sJ.RATE_TICKER_LOAD, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtRateTickerData);
  };

  var sendPdtProductTilesCtaClickEvent = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(productClicked) {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ctaData = {
                label: constants/* PDT_EVENTS.PRODUCT_TILE_CTA */.sJ.PRODUCT_TILE_CTA,
                primary_value: "",
                secondary_value: "",
                others: productClicked
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendPdtProductTilesCtaClickEvent(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  var sendPdtKnowMoreCardCtaClickEvent = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(productClicked) {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              ctaData = {
                label: constants/* PDT_EVENTS.KNOW_MORE_CTA */.sJ.KNOW_MORE_CTA,
                primary_value: "",
                secondary_value: "",
                others: productClicked
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function sendPdtKnowMoreCardCtaClickEvent(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var sendPdtFaqClickEvent = function sendPdtFaqClickEvent(faqClicked) {
    var ctaData = {
      label: constants/* PDT_EVENTS.FAQ_CTA */.sJ.FAQ_CTA,
      primary_value: "",
      secondary_value: "",
      others: faqClicked
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtFaqTabClickEvent = function sendPdtFaqTabClickEvent(tabName) {
    var ctaData = {
      label: constants/* PDT_EVENTS.FAQ_TAB_CTA */.sJ.FAQ_TAB_CTA,
      currency: "",
      others: tabName
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtPersuasionLinkCtaClickEvent = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(ctaClicked, productClicked) {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              ctaData = {
                label: ctaClicked,
                primary_value: "",
                secondary_value: "",
                others: productClicked
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function sendPdtPersuasionLinkCtaClickEvent(_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  var sendPdtFDOCtaClickEvent = function sendPdtFDOCtaClickEvent(productClicked) {
    var ctaData = {
      label: constants/* PDT_EVENTS.COMPLETE_ORDER_CTA */.sJ.COMPLETE_ORDER_CTA,
      primary_value: "",
      secondary_value: "",
      others: productClicked
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtUnavailableLocationCtaClickEvent = function sendPdtUnavailableLocationCtaClickEvent(productClicked) {
    var ctaData = {
      label: constants/* PDT_EVENTS.UNAVAILABLE_LOC */.sJ.UNAVAILABLE_LOC,
      primary_value: "",
      secondary_value: "",
      others: productClicked
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtViewDashboardCtaClickEvent = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(productClicked) {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              ctaData = {
                label: constants/* PDT_EVENTS.VIEW_DASHBOARD */.sJ.VIEW_DASHBOARD,
                primary_value: "",
                secondary_value: "",
                others: productClicked
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              _context4.next = 4;
              return (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function sendPdtViewDashboardCtaClickEvent(_x5) {
      return _ref8.apply(this, arguments);
    };
  }();

  var sendPdtViewOrdersCtaClickEvent = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(productClicked) {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              ctaData = {
                label: constants/* PDT_EVENTS.VIEW_ORDERS */.sJ.VIEW_ORDERS,
                others: productClicked
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              _context5.next = 4;
              return (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function sendPdtViewOrdersCtaClickEvent(_x6) {
      return _ref9.apply(this, arguments);
    };
  }();

  var sendPdtMarketingBannerCtaClickEvent = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              ctaData = {
                label: constants/* PDT_EVENTS.MARKETING_BANNER_CTA */.sJ.MARKETING_BANNER_CTA
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              _context6.next = 4;
              return (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function sendPdtMarketingBannerCtaClickEvent() {
      return _ref10.apply(this, arguments);
    };
  }();

  var sendPdtMarketingBannerLoadEvent = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              ctaData = {
                label: constants/* PDT_EVENTS.MARKETING_BANNER_LOAD */.sJ.MARKETING_BANNER_LOAD
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              _context7.next = 4;
              return (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function sendPdtMarketingBannerLoadEvent() {
      return _ref11.apply(this, arguments);
    };
  }();

  var sendPdtListingError = function sendPdtListingError(error) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var exp_experiment_details_list = getExperimentDetails();
    var pdtErrorData = getPdtErrorData(error, description, user_details, device, context, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtErrorData);
  };

  var sendPdtUserServiceApiCallEvent = function sendPdtUserServiceApiCallEvent(eventCta) {
    var exp_experiment_details_list = getExperimentDetails();
    var pdtEventData = setPdtEventData(null, device, null, context, eventCta, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtEventData);
  };

  var sendPdtLoginTokenError = function sendPdtLoginTokenError(error) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var exp_experiment_details_list = getExperimentDetails();
    var pdtErrorData = getPdtErrorData(error, description, user_details, device, context, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtErrorData);
  };

  var sendPdtAppSocialError = function sendPdtAppSocialError(error) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var exp_experiment_details_list = getExperimentDetails();
    var pdtErrorData = getPdtErrorData(error, description, user_details, device, context, exp_experiment_details_list);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtErrorData);
  };

  var sendPdtFallbackCity = function sendPdtFallbackCity(eventName) {
    var pincode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var ctaData = {
      label: eventName,
      currency: "",
      others: pincode
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtCouponShown = /*#__PURE__*/function () {
    var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(eventName, couponShown, totalCoupons) {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              ctaData = {
                label: eventName,
                primary_value: "",
                secondary_value: "",
                others: "".concat(couponShown, "--Total Coupons-").concat(totalCoupons)
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              _context8.next = 4;
              return (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function sendPdtCouponShown(_x7, _x8, _x9) {
      return _ref12.apply(this, arguments);
    };
  }();

  var sendPdtViewCoupons = /*#__PURE__*/function () {
    var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(eventName) {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              ctaData = {
                label: eventName,
                primary_value: "",
                secondary_value: "",
                others: ""
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              _context9.next = 4;
              return (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function sendPdtViewCoupons(_x10) {
      return _ref13.apply(this, arguments);
    };
  }();

  var sendPdtCoachmarkView = function sendPdtCoachmarkView() {
    var ctaData = {
      label: constants/* PDT_EVENTS.COACHMARK_VIEWED */.sJ.COACHMARK_VIEWED,
      currency: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendPdtCoachmarkButtonClick = function sendPdtCoachmarkButtonClick() {
    var ctaData = {
      label: constants/* PDT_EVENTS.COACKMARK_BUTTON_CLICK */.sJ.COACKMARK_BUTTON_CLICK,
      currency: "",
      others: ""
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var sendCtaEvent = function sendCtaEvent(_ref14) {
    var eventName = _ref14.eventName,
        primaryValue = _ref14.primaryValue,
        secondaryValue = _ref14.secondaryValue,
        others = _ref14.others;
    var ctaData = {
      label: eventName,
      primary_value: primaryValue,
      secondary_value: secondaryValue,
      others: others
    };
    var pdtCtaCommonData = getPdtCommonCtaData(ctaData);
    (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);
  };

  var myraIconShownPdtLoadEvent = /*#__PURE__*/function () {
    var _ref15 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
      var ctaData, pdtCtaCommonData;
      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              ctaData = {
                label: constants/* PDT_EVENTS.LISTING_MYRA_BOT_ICON_SHOWN */.sJ.LISTING_MYRA_BOT_ICON_SHOWN
              };
              pdtCtaCommonData = getPdtCommonCtaData(ctaData);
              _context10.next = 4;
              return (0,fetchApi/* sendPdtDataApi */.DA)(pdtCtaCommonData);

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function myraIconShownPdtLoadEvent() {
      return _ref15.apply(this, arguments);
    };
  }();

  return {
    sendListingPdtLocationDetectedViewEvent: sendListingPdtLocationDetectedViewEvent,
    sendPdtListingPageViewEvent: sendPdtListingPageViewEvent,
    sendListingPdtEventOnLocationBarClick: sendListingPdtEventOnLocationBarClick,
    sendPdtLocationBottomSheetViewEvent: sendPdtLocationBottomSheetViewEvent,
    sendPdtLocationDetectedOnBottomSheetClickEvent: sendPdtLocationDetectedOnBottomSheetClickEvent,
    sendPdtSubmitPincodeBottomSheetClickEvent: sendPdtSubmitPincodeBottomSheetClickEvent,
    sendPdtRateTickerViewEvent: sendPdtRateTickerViewEvent,
    sendPdtProductTilesCtaClickEvent: sendPdtProductTilesCtaClickEvent,
    sendPdtKnowMoreCardCtaClickEvent: sendPdtKnowMoreCardCtaClickEvent,
    sendPdtFaqClickEvent: sendPdtFaqClickEvent,
    sendPdtFaqTabClickEvent: sendPdtFaqTabClickEvent,
    sendPdtPersuasionLinkCtaClickEvent: sendPdtPersuasionLinkCtaClickEvent,
    sendPdtFDOCtaClickEvent: sendPdtFDOCtaClickEvent,
    sendPdtViewDashboardCtaClickEvent: sendPdtViewDashboardCtaClickEvent,
    sendPdtViewOrdersCtaClickEvent: sendPdtViewOrdersCtaClickEvent,
    sendPdtMarketingBannerCtaClickEvent: sendPdtMarketingBannerCtaClickEvent,
    sendPdtUnavailableLocationCtaClickEvent: sendPdtUnavailableLocationCtaClickEvent,
    sendPdtListingError: sendPdtListingError,
    sendPdtUserServiceApiCallEvent: sendPdtUserServiceApiCallEvent,
    sendPdtMarketingBannerLoadEvent: sendPdtMarketingBannerLoadEvent,
    sendPdtLoginClickEventListingPage: sendPdtLoginClickEventListingPage,
    sendPdtLoginPopOpen: sendPdtLoginPopOpen,
    sendPdtOpenEmailPopUp: sendPdtOpenEmailPopUp,
    sendPdtEmailPopUpOkClick: sendPdtEmailPopUpOkClick,
    sendPdtOpenAppUpdatePopUp: sendPdtOpenAppUpdatePopUp,
    sendPdtOpenUpdateAppPopUpOkClick: sendPdtOpenUpdateAppPopUpOkClick,
    sendPdtLoginErrorPopUpOpen: sendPdtLoginErrorPopUpOpen,
    sendPdtLoginErrorPopUpOkClick: sendPdtLoginErrorPopUpOkClick,
    sendPdtAppSocialError: sendPdtAppSocialError,
    sendPdtLoginTokenError: sendPdtLoginTokenError,
    sendPdtFallbackCity: sendPdtFallbackCity,
    sendPdtCouponShown: sendPdtCouponShown,
    sendPdtViewCoupons: sendPdtViewCoupons,
    sendPdtCoachmarkView: sendPdtCoachmarkView,
    sendPdtCoachmarkButtonClick: sendPdtCoachmarkButtonClick,
    sendCtaEvent: sendCtaEvent,
    myraIconShownPdtLoadEvent: myraIconShownPdtLoadEvent
  };
};

/***/ }),

/***/ 4155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useRedirectionUrls; },
  "C": function() { return /* binding */ redirectToTMLandingPage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(4556);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var static_utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/redirectionUtils.ts




var signalStateRedirectionForCurrency = function signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, signalState) {
  var _data$signal_data;

  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otuForexPartnerUrl = arguments.length > 4 ? arguments[4] : undefined;
  var url = "".concat(tmBaseUrl, "/bmf/currency");
  var redirectBaseUrl = tmBaseUrl + "?";
  var queryParam = "";
  var partner = (0,utils.getPartnerFromUrl)();

  switch (signalState) {
    case constants/* SIGNAL_STATE.TRAVELLER_DETAILS */.I$.TRAVELLER_DETAILS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/traveller-details?").concat(data !== null && data !== void 0 && data.order_id ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : "", "&source=listing"));
      break;

    case constants/* SIGNAL_STATE.ADD_PRODUCTS */.I$.ADD_PRODUCTS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/load-currency?").concat(data !== null && data !== void 0 && data.order_id ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : ""));
      break;

    case constants/* SIGNAL_STATE.ORDER_UNDER_PROCESSING */.I$.ORDER_UNDER_PROCESSING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/traveller-details?").concat(data !== null && data !== void 0 && data.order_id ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : "", "&source=listing"));
      break;

    case constants/* SIGNAL_STATE.DOCUMENT_PENDING */.I$.DOCUMENT_PENDING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(redirectBaseUrl, "deeplink=").concat(constants/* deepLink.CURRENCY_NOTES */.$C.CURRENCY_NOTES));
      break;

    case constants/* SIGNAL_STATE.START_PAYMENT */.I$.START_PAYMENT:
      if (data !== null && data !== void 0 && (_data$signal_data = data.signal_data) !== null && _data$signal_data !== void 0 && _data$signal_data.checkout_url) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(data.signal_data.checkout_url));
      } else {
        (0,utils.redirectToListingPage)(partner);
      }

      break;

    case constants/* SIGNAL_STATE.VIEW_ORDERS */.I$.VIEW_ORDERS:
      (0,static_utils/* redirectInterceptHref */.Xu)("deeplink=".concat(constants/* deepLink.CURRENCY_NOTES */.$C.CURRENCY_NOTES));
      break;

    default:
      (0,utils.redirectToListingPage)(partner);
      break;
  }
};
function productTilesRedirections(item, _ref) {
  var _item$cta, _item$cta$user_state_, _item$cta2;

  var otuForexPartnerUrl = _ref.otuForexPartnerUrl,
      _ref$tmBaseUrl = _ref.tmBaseUrl,
      tmBaseUrl = _ref$tmBaseUrl === void 0 ? "" : _ref$tmBaseUrl,
      device = _ref.device,
      _ref$mwebtmBaseUrl = _ref.mwebtmBaseUrl,
      mwebtmBaseUrl = _ref$mwebtmBaseUrl === void 0 ? "" : _ref$mwebtmBaseUrl;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var nextSignalState;

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(constants/* deepLink.MULTI_CURRENCY_CARD */.$C.MULTI_CURRENCY_CARD);
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(redirectBaseUrl).concat(queryParam));
      break;

    case constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY:
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta = item.cta) === null || _item$cta === void 0 ? void 0 : (_item$cta$user_state_ = _item$cta.user_state_data) === null || _item$cta$user_state_ === void 0 ? void 0 : _item$cta$user_state_.next_signal_state;
      signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, item === null || item === void 0 ? void 0 : (_item$cta2 = item.cta) === null || _item$cta2 === void 0 ? void 0 : _item$cta2.user_state_data, otuForexPartnerUrl);
      break;

    case constants/* CARD_TYPE.INR_CARD */.WK.INR_CARD:
      queryParam = "deeplink=".concat(constants/* deepLink.INR_CARD */.$C.INR_CARD);
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(redirectBaseUrl).concat(queryParam));
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [productTilesRedirections]"));
  }
}
function redirectUploadDocs(item, _ref2) {
  var otuForexPartnerUrl = _ref2.otuForexPartnerUrl,
      tmBaseUrl = _ref2.tmBaseUrl,
      device = _ref2.device;
  removeSessionStorageItem(SESSION_STORAGE_KEYS.REQUEST_ID);
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  switch (item.id) {
    case CARD_TYPE.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(deepLink.MULTI_CURRENCY_CARD);
      break;

    case CARD_TYPE.CURRENCY:
      queryParam = "deeplink=".concat(deepLink.CURRENCY_NOTES);
      break;
    // Note: For INR CARD, Upload docs persuasion won't come.
    // case CARD_TYPE.INR_CARD:
    //     redirectInterceptHref('');
    //     break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [redirectUploadDocs]"));
  }

  return redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
}
function redirectKnowMoreCardLinks(item, _ref3) {
  var _item$cta3, _item$cta3$user_state, _item$cta4;

  var otuForexPartnerUrl = _ref3.otuForexPartnerUrl,
      _ref3$tmBaseUrl = _ref3.tmBaseUrl,
      tmBaseUrl = _ref3$tmBaseUrl === void 0 ? "" : _ref3$tmBaseUrl,
      device = _ref3.device,
      _ref3$mwebtmBaseUrl = _ref3.mwebtmBaseUrl,
      mwebtmBaseUrl = _ref3$mwebtmBaseUrl === void 0 ? "" : _ref3$mwebtmBaseUrl;
  removeSessionStorageItem(SESSION_STORAGE_KEYS.REQUEST_ID);
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var nextSignalState;

  switch (item.id) {
    case CARD_TYPE.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(deepLink.MULTI_CURRENCY_CARD);
      redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
      break;

    case CARD_TYPE.CURRENCY:
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta3 = item.cta) === null || _item$cta3 === void 0 ? void 0 : (_item$cta3$user_state = _item$cta3.user_state_data) === null || _item$cta3$user_state === void 0 ? void 0 : _item$cta3$user_state.next_signal_state;
      signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, item === null || item === void 0 ? void 0 : (_item$cta4 = item.cta) === null || _item$cta4 === void 0 ? void 0 : _item$cta4.user_state_data, otuForexPartnerUrl);
      break;

    case CARD_TYPE.INR_CARD:
      queryParam = "deeplink=".concat(deepLink.INR_CARD);
      redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [redirectKnowMoreCardLinks]"));
  }
}
function exploreForexCurrencyRedirection(item, _ref4) {
  var _item$cta5, _item$cta5$user_state, _item$cta6;

  var otuForexPartnerUrl = _ref4.otuForexPartnerUrl,
      _ref4$tmBaseUrl = _ref4.tmBaseUrl,
      tmBaseUrl = _ref4$tmBaseUrl === void 0 ? "" : _ref4$tmBaseUrl,
      device = _ref4.device,
      _ref4$mwebtmBaseUrl = _ref4.mwebtmBaseUrl,
      mwebtmBaseUrl = _ref4$mwebtmBaseUrl === void 0 ? "" : _ref4$mwebtmBaseUrl;
  var nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta5 = item.cta) === null || _item$cta5 === void 0 ? void 0 : (_item$cta5$user_state = _item$cta5.user_state_data) === null || _item$cta5$user_state === void 0 ? void 0 : _item$cta5$user_state.next_signal_state;
  signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, item === null || item === void 0 ? void 0 : (_item$cta6 = item.cta) === null || _item$cta6 === void 0 ? void 0 : _item$cta6.user_state_data, otuForexPartnerUrl);
}
function quickLoadMoneyRedirections(item, _ref5) {
  var tmBaseUrl = _ref5.tmBaseUrl,
      otuForexPartnerUrl = _ref5.otuForexPartnerUrl,
      device = _ref5.device;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  switch (item.id) {
    case CARD_TYPE.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(deepLink.MULTI_CURRENCY_CARD);
      break;
    // Note: For Currency Notes, Quick load persuasion won't come.
    // case CARD_TYPE.CURRENCY:
    //     // TODO: SET REIDRECTION LINKS.
    //     redirectInterceptHref('');
    //     break;

    case CARD_TYPE.INR_CARD:
      // For mobile - https://www.tripmoney.com/partners/mmt/forex/common?deeplink=load-money;
      // For desktop - otuForexPartnerUrl?deeplink=load-money
      queryParam = "deeplink=load-money";
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [quickLoadRedirections]"));
  }

  return redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
}
function completeOrderRedirections(item, _ref6) {
  var _item$cta7, _item$cta7$user_state, _item$cta8;

  var otuForexPartnerUrl = _ref6.otuForexPartnerUrl,
      _ref6$tmBaseUrl = _ref6.tmBaseUrl,
      tmBaseUrl = _ref6$tmBaseUrl === void 0 ? "" : _ref6$tmBaseUrl,
      device = _ref6.device,
      _ref6$mwebtmBaseUrl = _ref6.mwebtmBaseUrl,
      mwebtmBaseUrl = _ref6$mwebtmBaseUrl === void 0 ? "" : _ref6$mwebtmBaseUrl;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var nextSignalState;

  switch (item.id) {
    case CARD_TYPE.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(deepLink.MULTI_CURRENCY_CARD);
      redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
      break;

    case CARD_TYPE.CURRENCY:
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta7 = item.cta) === null || _item$cta7 === void 0 ? void 0 : (_item$cta7$user_state = _item$cta7.user_state_data) === null || _item$cta7$user_state === void 0 ? void 0 : _item$cta7$user_state.next_signal_state;
      signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, item === null || item === void 0 ? void 0 : (_item$cta8 = item.cta) === null || _item$cta8 === void 0 ? void 0 : _item$cta8.user_state_data, otuForexPartnerUrl);
      break;
    // Note: For INR CARD, drop off persuasion won't come.
    // case CARD_TYPE.INR_CARD:
    //     redirectInterceptHref('');
    //     break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [completeOrderRedirections]"));
  }
}
function trackCardRedirections(item, _ref7) {
  var tmBaseUrl = _ref7.tmBaseUrl,
      otuForexPartnerUrl = _ref7.otuForexPartnerUrl,
      device = _ref7.device;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  removeSessionStorageItem(SESSION_STORAGE_KEYS.REQUEST_ID);

  switch (item.id) {
    case CARD_TYPE.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(deepLink.MULTI_CURRENCY_CARD);
      break;

    /* 
        Note: For INR CARD & CURRENCY notes, track card persuasion won't come. 
        case CARD_TYPE.CURRENCY:
            redirectInterceptHref(
                ''
            );
            break;
         case CARD_TYPE.INR_CARD:
            redirectInterceptHref('');
            break;
        */

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [trackCardRedirections]"));
  }

  return redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
}
function landingPageRedirect(_ref8) {
  var otuLandingPartnerUrl = _ref8.otuLandingPartnerUrl;
  redirectInterceptHref("".concat(otuLandingPartnerUrl));
}
function viewDashboardRedirectionsV1(item, _ref9) {
  var tmBaseUrl = _ref9.tmBaseUrl,
      otuForexPartnerUrl = _ref9.otuForexPartnerUrl,
      device = _ref9.device;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  switch (item.id) {
    case CARD_TYPE.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(deepLink.MULTI_CURRENCY_CARD);
      redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
      break;

    case CARD_TYPE.INR_CARD:
      queryParam = "deeplink=".concat(deepLink.INR_CARD);
      redirectInterceptHref("".concat(redirectBaseUrl).concat(queryParam));
      break;
    // For currency mini dashboard won't come
    // case CARD_TYPE.CURRENCY:
    //     queryParam = `deeplink=${deepLink.CURRENCY_NOTES}`;
    //     redirectInterceptHref(`${redirectBaseUrl}${queryParam}`);
    //     break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [viewDashboardRedirectionsV1]"));
  }
}
var viewOrdersRedirections = function viewOrdersRedirections(item, _ref10) {
  var otuForexPartnerUrl = _ref10.otuForexPartnerUrl,
      tmBaseUrl = _ref10.tmBaseUrl,
      device = _ref10.device;

  switch (item.id) {
    case CARD_TYPE.CURRENCY:
      redirectInterceptHref("deeplink=".concat(deepLink.CURRENCY_NOTES));
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [viewOrdersRedirections]"));
  }
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/redirectionUtilsV2.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var redirectionUtilsV2_signalStateRedirectionForCurrency = function signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, signalState) {
  var _data$signal_data;

  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otuForexPartnerUrl = arguments.length > 4 ? arguments[4] : undefined;
  var url = "".concat(tmBaseUrl, "/bmf/currency");
  var partner = (0,utils.getPartnerFromUrl)();
  var redirectBaseUrl = tmBaseUrl + "?";
  var queryParam = "";

  switch (signalState) {
    case constants/* SIGNAL_STATE.TRAVELLER_DETAILS */.I$.TRAVELLER_DETAILS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/traveller-details?").concat(data !== null && data !== void 0 && data.order_id ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : "", "&source=listing"));
      break;

    case constants/* SIGNAL_STATE.ADD_PRODUCTS */.I$.ADD_PRODUCTS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/load-currency?").concat(data !== null && data !== void 0 && data.order_id ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : ""));
      break;

    case constants/* SIGNAL_STATE.ORDER_UNDER_PROCESSING */.I$.ORDER_UNDER_PROCESSING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/traveller-details?").concat(data !== null && data !== void 0 && data.order_id ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : "", "&source=listing"));
      break;

    case constants/* SIGNAL_STATE.DOCUMENT_PENDING */.I$.DOCUMENT_PENDING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/post-sales/upload-documents/").concat(data === null || data === void 0 ? void 0 : data.order_id));
      break;

    case constants/* SIGNAL_STATE.START_PAYMENT */.I$.START_PAYMENT:
      if (data !== null && data !== void 0 && (_data$signal_data = data.signal_data) !== null && _data$signal_data !== void 0 && _data$signal_data.checkout_url) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(data.signal_data.checkout_url));
      } else {
        (0,utils.redirectToListingPage)(partner);
      }

      break;

    case constants/* SIGNAL_STATE.VIEW_ORDERS */.I$.VIEW_ORDERS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/post-sales/orders-listing"));
      break;

    default:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/load-currency?source=listing"));
      break;
  }
};
function productTilesRedirectionsV2(item, _ref) {
  var _item$cta, _item$cta2, _item$cta2$user_state, _item$cta3, _item$cta3$user_state;

  var otuForexPartnerUrl = _ref.otuForexPartnerUrl,
      tmBaseUrl = _ref.tmBaseUrl,
      device = _ref.device,
      mwebtmBaseUrl = _ref.mwebtmBaseUrl;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var nextSignalState;

  var data = _objectSpread(_objectSpread({}, (_item$cta = item.cta) === null || _item$cta === void 0 ? void 0 : _item$cta.user_state_data), {}, {
    feature_flag: item.feature_flag
  });

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      // eslint-disable-next-line no-case-declarations
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta2 = item.cta) === null || _item$cta2 === void 0 ? void 0 : (_item$cta2$user_state = _item$cta2.user_state_data) === null || _item$cta2$user_state === void 0 ? void 0 : _item$cta2$user_state.next_signal_state;
      signalStateRedirection(tmBaseUrl, mwebtmBaseUrl, nextSignalState, data, otuForexPartnerUrl);
      break;

    case constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY:
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta3 = item.cta) === null || _item$cta3 === void 0 ? void 0 : (_item$cta3$user_state = _item$cta3.user_state_data) === null || _item$cta3$user_state === void 0 ? void 0 : _item$cta3$user_state.next_signal_state;
      redirectionUtilsV2_signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, data, otuForexPartnerUrl);
      break;

    case constants/* CARD_TYPE.INR_CARD */.WK.INR_CARD:
      queryParam = "deeplink=".concat(constants/* deepLink.INR_CARD */.$C.INR_CARD);
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(redirectBaseUrl).concat(queryParam));
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [productTilesRedirections]"));
  }
}
function redirectUploadDocsV2(item, _ref2) {
  var _item$docsPending, _item$docsPending3;

  var otuForexPartnerUrl = _ref2.otuForexPartnerUrl,
      tmBaseUrl = _ref2.tmBaseUrl,
      mwebtmBaseUrl = _ref2.mwebtmBaseUrl,
      device = _ref2.device;
  (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
  var host = (0,utils.getHostName)();
  var cnPostSaleBaseUrl = "/bmf/currency/post-sales"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      // if (host === HOST.MAKEMYTRIP) {
      //     redirectInterceptHref(
      //         `${otuForexPartnerUrl}&deeplink=${
      //             deepLink.RELOAD_UPLOAD_DOCS
      //         }${item?.order_id ? '&dp_orderId=' + item?.order_id : ''}`
      //     );
      // } else {
      //     redirectInterceptHref(
      //         `${mwebtmBaseUrl}/uploadDocs?deeplink=${
      //             deepLink.RELOAD_UPLOAD_DOCS
      //         }${item?.order_id ? '&dp_orderId=' + item?.order_id : ''}`
      //     );
      // }
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/dashboard?deeplink=").concat(constants/* deepLink.RELOAD_UPLOAD_DOCS */.$C.RELOAD_UPLOAD_DOCS));
      break;

    case constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY:
      if ((item === null || item === void 0 ? void 0 : (_item$docsPending = item.docsPending) === null || _item$docsPending === void 0 ? void 0 : _item$docsPending.redirect_to) === constants/* CN_UPLOAD_DOC_REDIRECTION.CN_UPLOAD_DOC */.T8.CN_UPLOAD_DOC) {
        var _item$docsPending2;

        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl).concat(cnPostSaleBaseUrl, "/upload-documents/").concat(item === null || item === void 0 ? void 0 : (_item$docsPending2 = item.docsPending) === null || _item$docsPending2 === void 0 ? void 0 : _item$docsPending2.order_id));
      } else if ((item === null || item === void 0 ? void 0 : (_item$docsPending3 = item.docsPending) === null || _item$docsPending3 === void 0 ? void 0 : _item$docsPending3.redirect_to) === constants/* CN_UPLOAD_DOC_REDIRECTION.CN_ORDER_LISTING */.T8.CN_ORDER_LISTING) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl).concat(cnPostSaleBaseUrl, "/orders-listing"));
      }

      break;
    // Note: For INR CARD, Upload docs persuasion won't come.
    // case CARD_TYPE.INR_CARD:
    //     redirectInterceptHref('');
    //     break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [redirectUploadDocs]"));
  }
}
function redirectKnowMoreCardLinksV2(item, _ref3) {
  var _item$cta4, _item$cta4$user_state, _item$cta5;

  var otuForexPartnerUrl = _ref3.otuForexPartnerUrl,
      tmBaseUrl = _ref3.tmBaseUrl,
      device = _ref3.device,
      mwebtmBaseUrl = _ref3.mwebtmBaseUrl;
  (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var host = (0,utils.getHostName)();
  var nextSignalState;

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      // if (host === HOST.MAKEMYTRIP) {
      //     queryParam = `deeplink=${deepLink.BMF_LANDING_PAGE}&source=listing`;
      //     redirectInterceptHref(`${otuForexPartnerUrl}&${queryParam}`);
      // } else {
      //     redirectInterceptHref(
      //         `${tmBaseUrl}/bmf/onboarding/landing?source=listing`
      //     );
      // }
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl, "/bmf/onboarding/landing?source=listing"));
      break;

    case constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY:
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta4 = item.cta) === null || _item$cta4 === void 0 ? void 0 : (_item$cta4$user_state = _item$cta4.user_state_data) === null || _item$cta4$user_state === void 0 ? void 0 : _item$cta4$user_state.next_signal_state;
      redirectionUtilsV2_signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, item === null || item === void 0 ? void 0 : (_item$cta5 = item.cta) === null || _item$cta5 === void 0 ? void 0 : _item$cta5.user_state_data, otuForexPartnerUrl);
      break;

    case constants/* CARD_TYPE.INR_CARD */.WK.INR_CARD:
      queryParam = "deeplink=".concat(constants/* deepLink.INR_CARD */.$C.INR_CARD);
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(redirectBaseUrl).concat(queryParam));
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [productTilesRedirections]"));
  }
}
function exploreForexCurrencyRedirectionV2(item, _ref4) {
  var _item$cta6, _item$cta6$user_state, _item$cta7;

  var otuForexPartnerUrl = _ref4.otuForexPartnerUrl,
      tmBaseUrl = _ref4.tmBaseUrl,
      device = _ref4.device,
      mwebtmBaseUrl = _ref4.mwebtmBaseUrl;
  var nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta6 = item.cta) === null || _item$cta6 === void 0 ? void 0 : (_item$cta6$user_state = _item$cta6.user_state_data) === null || _item$cta6$user_state === void 0 ? void 0 : _item$cta6$user_state.next_signal_state;
  redirectionUtilsV2_signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, item === null || item === void 0 ? void 0 : (_item$cta7 = item.cta) === null || _item$cta7 === void 0 ? void 0 : _item$cta7.user_state_data, otuForexPartnerUrl);
}
function quickLoadMoneyRedirectionsV2(item, _ref5) {
  var _item$feature_flag;

  var tmBaseUrl = _ref5.tmBaseUrl,
      otuForexPartnerUrl = _ref5.otuForexPartnerUrl,
      mwebtmBaseUrl = _ref5.mwebtmBaseUrl,
      device = _ref5.device;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var host = (0,utils.getHostName)();

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      // if (host === HOST.MAKEMYTRIP) {
      //     redirectInterceptHref(
      //         `${otuForexPartnerUrl}&deeplink=${
      //             deepLink.RELOAD_LOAD_CURRENCY
      //         }${item?.order_id ? '&dp_orderId=' + item?.order_id : ''}`
      //     );
      // } else {
      //     redirectInterceptHref(
      //         `${mwebtmBaseUrl}/loadCurrency?deeplink=${
      //             deepLink.RELOAD_LOAD_CURRENCY
      //         }${item?.order_id ? '&dp_orderId=' + item?.order_id : ''}`
      //     );
      // }
      if ((_item$feature_flag = item.feature_flag) !== null && _item$feature_flag !== void 0 && _item$feature_flag.solve_reload) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl, "/bmf/card/post-sales/new-trip?deeplink=").concat(constants/* deepLink.RELOAD_LOAD_CURRENCY */.$C.RELOAD_LOAD_CURRENCY));
      } else {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/loadCurrency?deeplink=").concat(constants/* deepLink.RELOAD_LOAD_CURRENCY */.$C.RELOAD_LOAD_CURRENCY));
      }

      break;
    // Quick load money option is not available.
    // case CARD_TYPE.CURRENCY:
    //     queryParam = `deeplink=${deepLink.CURRENCY_NOTES}`;
    //     redirectInterceptHref(`${redirectBaseUrl}${queryParam}`);
    //     break;

    case constants/* CARD_TYPE.INR_CARD */.WK.INR_CARD:
      queryParam = "deeplink=load-money";
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(redirectBaseUrl).concat(queryParam));
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [quickLoadRedirections]"));
  }
}
function completeOrderRedirectionsV2(item, _ref6) {
  var _item$cta8, _item$cta9, _item$cta9$user_state, _item$cta10, _item$cta10$user_stat, _item$cta11;

  var otuForexPartnerUrl = _ref6.otuForexPartnerUrl,
      tmBaseUrl = _ref6.tmBaseUrl,
      mwebtmBaseUrl = _ref6.mwebtmBaseUrl,
      device = _ref6.device;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var nextSignalState;

  var data = _objectSpread(_objectSpread({}, (_item$cta8 = item.cta) === null || _item$cta8 === void 0 ? void 0 : _item$cta8.user_state_data), {}, {
    feature_flag: item.feature_flag
  });

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      // eslint-disable-next-line no-case-declarations
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta9 = item.cta) === null || _item$cta9 === void 0 ? void 0 : (_item$cta9$user_state = _item$cta9.user_state_data) === null || _item$cta9$user_state === void 0 ? void 0 : _item$cta9$user_state.next_signal_state;
      signalStateRedirection(tmBaseUrl, mwebtmBaseUrl, nextSignalState, data, otuForexPartnerUrl);
      break;

    case constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY:
      nextSignalState = item === null || item === void 0 ? void 0 : (_item$cta10 = item.cta) === null || _item$cta10 === void 0 ? void 0 : (_item$cta10$user_stat = _item$cta10.user_state_data) === null || _item$cta10$user_stat === void 0 ? void 0 : _item$cta10$user_stat.next_signal_state;
      redirectionUtilsV2_signalStateRedirectionForCurrency(tmBaseUrl, mwebtmBaseUrl, nextSignalState, item === null || item === void 0 ? void 0 : (_item$cta11 = item.cta) === null || _item$cta11 === void 0 ? void 0 : _item$cta11.user_state_data, otuForexPartnerUrl);
      break;
    // Note: For INR CARD, drop off persuasion won't come.
    // case CARD_TYPE.INR_CARD:
    //     redirectInterceptHref('');
    //     break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [completeOrderRedirections]"));
  }
}
function trackCardRedirectionsV2(item, _ref7) {
  var mwebtmBaseUrl = _ref7.mwebtmBaseUrl,
      otuForexPartnerUrl = _ref7.otuForexPartnerUrl,
      partner = _ref7.partner,
      device = _ref7.device;
  (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
  var host = (0,utils.getHostName)();
  var queryParam = "";

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      queryParam = "deeplink=".concat(constants/* deepLink.RELOAD_TRACK_ORDER */.$C.RELOAD_TRACK_ORDER).concat(item !== null && item !== void 0 && item.order_id ? "&dp_orderId=" + (item === null || item === void 0 ? void 0 : item.order_id) : ""); // if (host === HOST.MAKEMYTRIP) {
      //     redirectInterceptHref(`${otuForexPartnerUrl}&${queryParam}`);
      // } else {
      //     redirectInterceptHref(
      //         `${mwebtmBaseUrl}/dashboard?${queryParam}`
      //     );
      // }

      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/dashboard?").concat(queryParam));
      break;

    /*
        Note: For INR CARD & CURRENCY notes, track card persuasion won't come.
        case CARD_TYPE.CURRENCY:
            redirectInterceptHref(
                ''
            );
            break;
         case CARD_TYPE.INR_CARD:
            redirectInterceptHref('');
            break;
        */

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [trackCardRedirections]"));
  }
}
function landingPageRedirectV2(_ref8) {
  var otuLandingPartnerUrl = _ref8.otuLandingPartnerUrl,
      tmBaseUrl = _ref8.tmBaseUrl,
      device = _ref8.device;
  redirectInterceptHref("".concat(otuLandingPartnerUrl));
}
var signalStateRedirection = function signalStateRedirection(tmBaseUrl, mwebtmBaseUrl, signalState) {
  var _data$signal_data2;

  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otuForexPartnerUrl = arguments.length > 4 ? arguments[4] : undefined;
  var url = "".concat(tmBaseUrl, "/bmf/onboarding");
  var host = (0,utils.getHostName)();
  var queryParam = "";

  switch (signalState) {
    case constants/* SIGNAL_STATE.TRAVELLER_DETAILS */.I$.TRAVELLER_DETAILS:
      // if (host === HOST.MAKEMYTRIP) {
      //     redirectInterceptHref(
      //         `${otuForexPartnerUrl}&deeplink=${
      //             deepLink.BMF_TRAVELLER_DETAILS
      //         }${data?.order_id ? '&dp_orderId=' + data?.order_id : ''}`
      //     );
      // } else {
      //     redirectInterceptHref(
      //         `${url}/traveller-details?deeplink=${
      //             deepLink.BMF_TRAVELLER_DETAILS
      //         }${data?.order_id ? '&dp_orderId=' + data?.order_id : ''}`
      //     );
      // }
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/traveller-details?deeplink=").concat(constants/* deepLink.BMF_TRAVELLER_DETAILS */.$C.BMF_TRAVELLER_DETAILS).concat(data !== null && data !== void 0 && data.order_id ? "&dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : "", "&source=listing"));
      break;

    case constants/* SIGNAL_STATE.DOCUMENT_PENDING */.I$.DOCUMENT_PENDING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/uploadDocs?dp_orderId=").concat(data.orderId));
      break;

    case constants/* SIGNAL_STATE.ORDER_UNDER_PROCESSING */.I$.ORDER_UNDER_PROCESSING:
    case constants/* SIGNAL_STATE.ADD_PRODUCTS */.I$.ADD_PRODUCTS:
      // if (host === HOST.MAKEMYTRIP) {
      //     redirectInterceptHref(
      //         `${otuForexPartnerUrl}&deeplink=${
      //             deepLink.BMF_ADD_PRODUCTS
      //         }${data?.order_id ? '&dp_orderId=' + data?.order_id : ''}`
      //     );
      // } else {
      //     redirectInterceptHref(
      //         `${url}/load-currency?deeplink=${
      //             deepLink.BMF_ADD_PRODUCTS
      //         }${data?.order_id ? '&dp_orderId=' + data?.order_id : ''}`
      //     );
      // }
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/load-currency?deeplink=").concat(constants/* deepLink.BMF_ADD_PRODUCTS */.$C.BMF_ADD_PRODUCTS).concat(data !== null && data !== void 0 && data.order_id ? "&dp_orderId=" + (data === null || data === void 0 ? void 0 : data.order_id) : ""));
      break;

    case constants/* SIGNAL_STATE.START_PAYMENT */.I$.START_PAYMENT:
      if (data !== null && data !== void 0 && (_data$signal_data2 = data.signal_data) !== null && _data$signal_data2 !== void 0 && _data$signal_data2.checkout_url) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(data.signal_data.checkout_url));
      } else {
        // if (host === HOST.MAKEMYTRIP) {
        //     redirectInterceptHref(
        //         `${otuForexPartnerUrl}&deeplink=${deepLink.BMF_LANDING_PAGE}&source=listing`
        //     );
        // } else {
        //     redirectInterceptHref(`${url}/landing?source=listing`);
        // }
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/landing?source=listing"));
      }

      break;

    case constants/* SIGNAL_STATE.BMF_CARD_LANDING */.I$.BMF_CARD_LANDING:
      // if (host === HOST.MAKEMYTRIP) {
      //     redirectInterceptHref(
      //         `${otuForexPartnerUrl}&deeplink=${deepLink.BMF_LANDING_PAGE}&source=listing`
      //     );
      // } else {
      //     redirectInterceptHref(`${url}/landing?source=listing`);
      // }
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/landing?source=listing"));
      break;

    case constants/* SIGNAL_STATE.BMF_PAYMENT_FAILED */.I$.BMF_PAYMENT_FAILED:
    case constants/* SIGNAL_STATE.BMF_PAYMENT_CONFIRMED */.I$.BMF_PAYMENT_CONFIRMED:
    case constants/* SIGNAL_STATE.BMF_PAYMENT_BEING_CONFIRMED */.I$.BMF_PAYMENT_BEING_CONFIRMED:
    case constants/* SIGNAL_STATE.BMF_DASHBOARD */.I$.BMF_DASHBOARD:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/dashboard/new"));
      break;

    case constants/* SIGNAL_STATE.BMF_ORDER_SUBMITTED */.I$.BMF_ORDER_SUBMITTED:
      // if (host === HOST.MAKEMYTRIP) {
      //     redirectInterceptHref(
      //         `${otuForexPartnerUrl}&deeplink=${deepLink.BMF_ORDER_SUBMITTED}`
      //     );
      // } else {
      //     redirectInterceptHref(
      //         `${mwebtmBaseUrl}/documentSubmit?deeplink=${deepLink.BMF_ORDER_SUBMITTED}`
      //     );
      // }
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/documentSubmit?deeplink=").concat(constants/* deepLink.BMF_ORDER_SUBMITTED */.$C.BMF_ORDER_SUBMITTED));
      break;

    case constants/* DERIVED_NEXT_SIGNAL_STATE.RELOAD_CURRENT_TRIP */.Hp.RELOAD_CURRENT_TRIP:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl, "/bmf/card/post-sales/current-trip"));
      break;

    case constants/* DERIVED_NEXT_SIGNAL_STATE.RELOAD_NEW_TRIP */.Hp.RELOAD_NEW_TRIP:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl, "/bmf/card/post-sales/new-trip"));
      break;

    case constants/* DERIVED_NEXT_SIGNAL_STATE.RELOAD_NEW_UPCOMING_TRIP */.Hp.RELOAD_NEW_UPCOMING_TRIP:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl, "/bmf/card/post-sales/new-trip?prefill_reload=true"));
      break;

    default:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/load-currency?source=listing"));
      break;
  }
};
var redirectionUtilsV2_reloadTripRedirection = function reloadTripRedirection(item, _ref9) {
  var _reload_discovery_ord, _item$persuasions, _item$persuasions$fin, _item$persuasions$fin2, _item$persuasions$fin3, _item$persuasions$fin4;

  var otuForexPartnerUrl = _ref9.otuForexPartnerUrl,
      tmBaseUrl = _ref9.tmBaseUrl,
      device = _ref9.device,
      mwebtmBaseUrl = _ref9.mwebtmBaseUrl;

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      var nextSignalState = (_reload_discovery_ord = (_item$persuasions = item.persuasions) === null || _item$persuasions === void 0 ? void 0 : (_item$persuasions$fin = _item$persuasions.find) === null || _item$persuasions$fin === void 0 ? void 0 : (_item$persuasions$fin2 = _item$persuasions$fin.call(_item$persuasions, function (persuasion) {
        return persuasion.type === constants/* PERSUASION_TYPE.RELOAD_TRIP */.NM.RELOAD_TRIP;
      })) === null || _item$persuasions$fin2 === void 0 ? void 0 : (_item$persuasions$fin3 = _item$persuasions$fin2.data) === null || _item$persuasions$fin3 === void 0 ? void 0 : (_item$persuasions$fin4 = _item$persuasions$fin3.reload_discovery_order_details) === null || _item$persuasions$fin4 === void 0 ? void 0 : _item$persuasions$fin4.derived_next_signal_state) !== null && _reload_discovery_ord !== void 0 ? _reload_discovery_ord : constants/* DERIVED_NEXT_SIGNAL_STATE.RELOAD_CURRENT_TRIP */.Hp.RELOAD_CURRENT_TRIP;
      signalStateRedirection(tmBaseUrl, mwebtmBaseUrl, nextSignalState, {}, otuForexPartnerUrl);
      break;

    default:
      console.error("Current trip reload is supported only for card product");
  }
};
var viewDashboardRedirectionsV2 = function viewDashboardRedirectionsV2(item, _ref10) {
  var _item$feature_flag2;

  var otuForexPartnerUrl = _ref10.otuForexPartnerUrl,
      tmBaseUrl = _ref10.tmBaseUrl,
      device = _ref10.device,
      mwebtmBaseUrl = _ref10.mwebtmBaseUrl;
  var queryParam = "";
  var redirectBaseUrl = tmBaseUrl + "?"; // device === DEVICE_MODEL.WEB
  //     ? `${otuForexPartnerUrl}&`
  //     : `${tmBaseUrl}/common?`;

  var host = (0,utils.getHostName)();

  switch (item.id) {
    case constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD:
      // if (host === HOST.MAKEMYTRIP) {
      //     queryParam = `deeplink=${deepLink.RELOAD_DASHBOARD}`;
      //     redirectInterceptHref(`${otuForexPartnerUrl}&${queryParam}`);
      // } else {
      //     redirectInterceptHref(`${mwebtmBaseUrl}/dashboard`);
      // }
      if ((_item$feature_flag2 = item.feature_flag) !== null && _item$feature_flag2 !== void 0 && _item$feature_flag2.solve_reload) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/dashboard/new"));
      } else {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/dashboard"));
      }

      break;

    case constants/* CARD_TYPE.INR_CARD */.WK.INR_CARD:
      queryParam = "deeplink=".concat(constants/* deepLink.INR_CARD */.$C.INR_CARD);
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(redirectBaseUrl).concat(queryParam));
      break;
    // For currency mini dashboard won't come
    // case CARD_TYPE.CURRENCY:
    //     queryParam = `deeplink=${deepLink.CURRENCY_NOTES}`;
    //     redirectInterceptHref(`${redirectBaseUrl}${queryParam}`);
    //     break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [viewDashboardRedirectionsV2]"));
  }
};
var viewOrdersRedirectionsV2 = function viewOrdersRedirectionsV2(item, _ref11) {
  var otuForexPartnerUrl = _ref11.otuForexPartnerUrl,
      tmBaseUrl = _ref11.tmBaseUrl,
      device = _ref11.device,
      mwebtmBaseUrl = _ref11.mwebtmBaseUrl;

  switch (item.id) {
    case constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl, "/bmf/currency/post-sales/orders-listing"));
      break;

    default:
      throw new Error("Invalid Card Id: ".concat(item.id, " [viewOrdersRedirectionsV2]"));
  }
};
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalConfig.ts
var useGlobalConfig = __webpack_require__(588);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/useGlobalSelector.ts
var useGlobalSelector = __webpack_require__(2053);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/redirectionUtilsV3.ts


var _cardTypeHandlers;






function extractCommonRedirectionData(item, persuasionType) {
  var _item$persuasions$fin, _persuasionCta$user_s, _item$cta, _item$cta$user_state_, _persuasionCta$user_s2, _item$cta2, _item$cta2$user_state;

  var persuasionCta = (_item$persuasions$fin = item.persuasions.find(function (persuasion) {
    return persuasion.type === persuasionType;
  })) === null || _item$persuasions$fin === void 0 ? void 0 : _item$persuasions$fin.cta;
  var nextSignalState = (persuasionCta === null || persuasionCta === void 0 ? void 0 : (_persuasionCta$user_s = persuasionCta.user_state_data) === null || _persuasionCta$user_s === void 0 ? void 0 : _persuasionCta$user_s.next_signal_state) || ((_item$cta = item.cta) === null || _item$cta === void 0 ? void 0 : (_item$cta$user_state_ = _item$cta.user_state_data) === null || _item$cta$user_state_ === void 0 ? void 0 : _item$cta$user_state_.next_signal_state);
  var orderId = (persuasionCta === null || persuasionCta === void 0 ? void 0 : (_persuasionCta$user_s2 = persuasionCta.user_state_data) === null || _persuasionCta$user_s2 === void 0 ? void 0 : _persuasionCta$user_s2.order_id) || (item === null || item === void 0 ? void 0 : (_item$cta2 = item.cta) === null || _item$cta2 === void 0 ? void 0 : (_item$cta2$user_state = _item$cta2.user_state_data) === null || _item$cta2$user_state === void 0 ? void 0 : _item$cta2$user_state.order_id);
  return {
    nextSignalState: nextSignalState,
    orderId: orderId
  };
}

var signalStateRedirectionV3 = function signalStateRedirectionV3(tmBaseUrl, mwebtmBaseUrl, signalState) {
  var _data$signal_data, _data$feature_flag;

  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otuForexPartnerUrl = arguments.length > 4 ? arguments[4] : undefined;
  var url = "".concat(tmBaseUrl, "/bmf/onboarding");

  switch (signalState) {
    case constants/* SIGNAL_STATE.TRAVELLER_DETAILS */.I$.TRAVELLER_DETAILS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/traveller-details?deeplink=").concat(constants/* deepLink.BMF_TRAVELLER_DETAILS */.$C.BMF_TRAVELLER_DETAILS).concat(data !== null && data !== void 0 && data.orderId ? "&dp_orderId=" + (data === null || data === void 0 ? void 0 : data.orderId) : "", "&source=listing"));
      break;

    case constants/* SIGNAL_STATE.DOCUMENT_PENDING */.I$.DOCUMENT_PENDING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/uploadDocs?dp_orderId=").concat(data.orderId));
      break;

    case constants/* SIGNAL_STATE.ORDER_UNDER_PROCESSING */.I$.ORDER_UNDER_PROCESSING:
    case constants/* SIGNAL_STATE.ADD_PRODUCTS */.I$.ADD_PRODUCTS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/load-currency?deeplink=").concat(constants/* deepLink.BMF_ADD_PRODUCTS */.$C.BMF_ADD_PRODUCTS).concat(data !== null && data !== void 0 && data.orderId ? "&dp_orderId=" + (data === null || data === void 0 ? void 0 : data.orderId) : ""));
      break;

    case constants/* SIGNAL_STATE.START_PAYMENT */.I$.START_PAYMENT:
      if (data !== null && data !== void 0 && (_data$signal_data = data.signal_data) !== null && _data$signal_data !== void 0 && _data$signal_data.checkout_url) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(data.signal_data.checkout_url));
      } else {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/landing?source=listing"));
      }

      break;

    case constants/* SIGNAL_STATE.BMF_CARD_LANDING */.I$.BMF_CARD_LANDING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/landing?source=listing"));
      break;

    case constants/* SIGNAL_STATE.BMF_PAYMENT_FAILED */.I$.BMF_PAYMENT_FAILED:
    case constants/* SIGNAL_STATE.BMF_PAYMENT_CONFIRMED */.I$.BMF_PAYMENT_CONFIRMED:
    case constants/* SIGNAL_STATE.BMF_PAYMENT_BEING_CONFIRMED */.I$.BMF_PAYMENT_BEING_CONFIRMED:
    case constants/* SIGNAL_STATE.BMF_DASHBOARD */.I$.BMF_DASHBOARD:
      if (data !== null && data !== void 0 && (_data$feature_flag = data.feature_flag) !== null && _data$feature_flag !== void 0 && _data$feature_flag.solve_reload) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/dashboard/new").concat(data.queryParam ? "?" + data.queryParam : ""));
        return;
      }

      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/dashboard").concat(data.queryParam ? "?" + data.queryParam : ""));
      break;

    case constants/* SIGNAL_STATE.BMF_ORDER_SUBMITTED */.I$.BMF_ORDER_SUBMITTED:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(mwebtmBaseUrl, "/documentSubmit?deeplink=").concat(constants/* deepLink.BMF_ORDER_SUBMITTED */.$C.BMF_ORDER_SUBMITTED));
      break;

    default:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/load-currency?source=listing"));
      break;
  }
};
var signalStateRedirectionForCurrencyV3 = function signalStateRedirectionForCurrencyV3(tmBaseUrl, mwebtmBaseUrl, signalState) {
  var _data$signal_data2;

  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otuForexPartnerUrl = arguments.length > 4 ? arguments[4] : undefined;
  var url = "".concat(tmBaseUrl, "/bmf/currency");
  var partner = (0,utils.getPartnerFromUrl)();

  switch (signalState) {
    case constants/* SIGNAL_STATE.TRAVELLER_DETAILS */.I$.TRAVELLER_DETAILS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/load-currency?source=listing"));
      break;

    case constants/* SIGNAL_STATE.ADD_PRODUCTS */.I$.ADD_PRODUCTS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/load-currency?").concat(data !== null && data !== void 0 && data.orderId ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.orderId) : ""));
      break;

    case constants/* SIGNAL_STATE.ORDER_UNDER_PROCESSING */.I$.ORDER_UNDER_PROCESSING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/traveller-details?").concat(data !== null && data !== void 0 && data.orderId ? "dp_orderId=" + (data === null || data === void 0 ? void 0 : data.orderId) : "", "&source=listing"));
      break;

    case constants/* SIGNAL_STATE.DOCUMENT_PENDING */.I$.DOCUMENT_PENDING:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/post-sales/upload-documents/").concat(data === null || data === void 0 ? void 0 : data.orderId));
      break;

    case constants/* SIGNAL_STATE.START_PAYMENT */.I$.START_PAYMENT:
      if (data !== null && data !== void 0 && (_data$signal_data2 = data.signal_data) !== null && _data$signal_data2 !== void 0 && _data$signal_data2.checkout_url) {
        (0,static_utils/* redirectInterceptHref */.Xu)("".concat(data.signal_data.checkout_url));
      } else {
        (0,utils.redirectToListingPage)(partner);
      }

      break;

    case constants/* SIGNAL_STATE.VIEW_ORDERS */.I$.VIEW_ORDERS:
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/post-sales/orders-listing"));
      break;

    default:
      // Fallback case for non-loggedin user when cta is empty
      (0,static_utils/* redirectInterceptHref */.Xu)("".concat(url, "/onboarding/load-currency").concat(data !== null && data !== void 0 && data.orderId ? "?dp_orderId=" + (data === null || data === void 0 ? void 0 : data.orderId) : ""));
      break;
  }
};
var cardTypeHandlers = (_cardTypeHandlers = {}, (0,defineProperty/* default */.Z)(_cardTypeHandlers, constants/* CARD_TYPE.MULTI_CURRENCY_CARD */.WK.MULTI_CURRENCY_CARD, signalStateRedirectionV3), (0,defineProperty/* default */.Z)(_cardTypeHandlers, constants/* CARD_TYPE.CURRENCY */.WK.CURRENCY, signalStateRedirectionForCurrencyV3), _cardTypeHandlers);
function startOrderRedirectionsV3(item, _ref) {
  var otuForexPartnerUrl = _ref.otuForexPartnerUrl,
      tmBaseUrl = _ref.tmBaseUrl,
      mwebtmBaseUrl = _ref.mwebtmBaseUrl,
      device = _ref.device;

  var _extractCommonRedirec = extractCommonRedirectionData(item, constants/* PERSUASION_TYPE.START_ORDER */.NM.START_ORDER),
      nextSignalState = _extractCommonRedirec.nextSignalState,
      orderId = _extractCommonRedirec.orderId;

  var handler = item.id ? cardTypeHandlers[item.id] : function () {};
  handler(tmBaseUrl, mwebtmBaseUrl, nextSignalState, {
    orderId: orderId
  }, otuForexPartnerUrl);
}
function trackCardRedirectionsV3(item, _ref2) {
  var otuForexPartnerUrl = _ref2.otuForexPartnerUrl,
      tmBaseUrl = _ref2.tmBaseUrl,
      mwebtmBaseUrl = _ref2.mwebtmBaseUrl,
      device = _ref2.device;
  (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);

  var _extractCommonRedirec2 = extractCommonRedirectionData(item, constants/* PERSUASION_TYPE.DELIVERY_TRACKING */.NM.DELIVERY_TRACKING),
      nextSignalState = _extractCommonRedirec2.nextSignalState,
      orderId = _extractCommonRedirec2.orderId;

  var queryParam = "deeplink=".concat(constants/* deepLink.RELOAD_TRACK_ORDER */.$C.RELOAD_TRACK_ORDER).concat(orderId ? "&dp_orderId=" + orderId : "");
  var handler = item.id ? cardTypeHandlers[item.id] : function () {};
  handler(tmBaseUrl, mwebtmBaseUrl, nextSignalState, {
    queryParam: queryParam
  }, otuForexPartnerUrl);
}
function redirectDropOffV3(item, _ref3) {
  var otuForexPartnerUrl = _ref3.otuForexPartnerUrl,
      tmBaseUrl = _ref3.tmBaseUrl,
      mwebtmBaseUrl = _ref3.mwebtmBaseUrl,
      device = _ref3.device;

  var _extractCommonRedirec3 = extractCommonRedirectionData(item, constants/* PERSUASION_TYPE.DROP_OFF */.NM.DROP_OFF),
      nextSignalState = _extractCommonRedirec3.nextSignalState;

  var handler = item.id ? cardTypeHandlers[item.id] : function () {};
  handler(tmBaseUrl, mwebtmBaseUrl, nextSignalState, {}, otuForexPartnerUrl);
}
function redirectUploadDocsV3(item, _ref4) {
  var otuForexPartnerUrl = _ref4.otuForexPartnerUrl,
      tmBaseUrl = _ref4.tmBaseUrl,
      mwebtmBaseUrl = _ref4.mwebtmBaseUrl,
      device = _ref4.device;
  (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
  var host = (0,utils.getHostName)();
  var cnPostSaleBaseUrl = "/bmf/currency/post-sales";

  var _extractCommonRedirec4 = extractCommonRedirectionData(item, constants/* PERSUASION_TYPE.UPLOAD_DOCUMENTS */.NM.UPLOAD_DOCUMENTS),
      nextSignalState = _extractCommonRedirec4.nextSignalState,
      orderId = _extractCommonRedirec4.orderId;

  var handler = item.id ? cardTypeHandlers[item.id] : function () {};
  handler(tmBaseUrl, mwebtmBaseUrl, nextSignalState, {
    orderId: orderId,
    feature_flag: item.feature_flag
  }, otuForexPartnerUrl);
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useRedirectionUrls/index.ts


function useRedirectionUrls_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useRedirectionUrls_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useRedirectionUrls_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useRedirectionUrls_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var useRedirectionUrls = function useRedirectionUrls() {
  var _useGlobalConfig = (0,useGlobalConfig/* useGlobalConfig */.W)(),
      tmAppPartner = _useGlobalConfig.partner;

  var _useState = (0,react.useState)({
    partner: null,
    host: ""
  }),
      _useState$ = _useState[0],
      partner = _useState$.partner,
      host = _useState$.host,
      setPartnerHost = _useState[1];

  var _useState2 = (0,react.useState)(null),
      device = _useState2[0],
      setDevice = _useState2[1];

  (0,react.useEffect)(function () {
    var appType = (0,utils.getDeviceType)();
    setDevice(appType);
  }, []);

  var _useGlobalSelector = (0,useGlobalSelector/* useGlobalSelector */.a)(function (state) {
    return state || {};
  }),
      version = _useGlobalSelector.version,
      feature_flag = _useGlobalSelector.feature_flag;

  (0,react.useEffect)(function () {
    if (tmAppPartner) {
      setPartnerHost(getHostPartnerInfoForRedirections(tmAppPartner));
    }
  }, [tmAppPartner]);
  var isHostMakeMyTrip = (0,utils.getHostName)() === constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP;
  var initString = partner === constants/* PARTNER.MMT */.RL.MMT ? "initOTU" : "initOTUGI";
  var basePartnerUrl = "https://lending.".concat(host, ".com/ext/api/v1/partners/").concat(partner, "/").concat(initString);
  var otuForexPartnerUrl = "".concat(basePartnerUrl, "?product=forex").concat(isHostMakeMyTrip ? "&mmt_forex=true" : "");
  var tmBaseUrl = "".concat((0,utils.getHostName)() === constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP ? "https://" + constants/* HOST.TRIPMONEY_MAKEMYTRIP */.M5.TRIPMONEY_MAKEMYTRIP : "", "/partners/").concat(partner, "/forex");
  var mwebtmBaseUrl = "".concat((0,utils.getHostName)() === constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP ? "https://" + constants/* HOST.TRIPMONEY_MAKEMYTRIP */.M5.TRIPMONEY_MAKEMYTRIP : "", "/mweb/partners/").concat(partner, "/forex/bmf");
  return {
    productTilesRedirections: function productTilesRedirections(item) {
      var _versionToHandlerMap;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var versionToHandlerMap = (_versionToHandlerMap = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap, constants/* VERSIONS.V3 */.Kr.V3, productTilesRedirectionsV2), (0,defineProperty/* default */.Z)(_versionToHandlerMap, constants/* VERSIONS.V2 */.Kr.V2, productTilesRedirectionsV2), _versionToHandlerMap);
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      versionToHandlerMap[productVersion](item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        device: device,
        mwebtmBaseUrl: mwebtmBaseUrl
      });
    },
    startOrderRedirections: function startOrderRedirections(item) {
      var _versionToHandlerMap2;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      var versionToHandlerMap = (_versionToHandlerMap2 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap2, constants/* VERSIONS.V3 */.Kr.V3, startOrderRedirectionsV3), (0,defineProperty/* default */.Z)(_versionToHandlerMap2, constants/* VERSIONS.V2 */.Kr.V2, productTilesRedirections), _versionToHandlerMap2);
      versionToHandlerMap[productVersion](item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    redirectUploadDocs: function redirectUploadDocs(item) {
      var _versionToHandlerMap3;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      item.feature_flag = feature_flag || {};
      var versionToHandlerMap = (_versionToHandlerMap3 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap3, constants/* VERSIONS.V3 */.Kr.V3, redirectUploadDocsV3), (0,defineProperty/* default */.Z)(_versionToHandlerMap3, constants/* VERSIONS.V2 */.Kr.V2, redirectUploadDocsV2), _versionToHandlerMap3);
      versionToHandlerMap[productVersion](item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    redirectKnowMoreCardLinks: function redirectKnowMoreCardLinks(item) {
      var _versionToHandlerMap4;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      var versionToHandlerMap = (_versionToHandlerMap4 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap4, constants/* VERSIONS.V3 */.Kr.V3, redirectKnowMoreCardLinksV2), (0,defineProperty/* default */.Z)(_versionToHandlerMap4, constants/* VERSIONS.V2 */.Kr.V2, redirectKnowMoreCardLinksV2), _versionToHandlerMap4);
      versionToHandlerMap[productVersion](item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    exploreForexCurrencyRedirection: function exploreForexCurrencyRedirection(item) {
      var _versionToHandlerMap5;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      var versionToHandlerMap = (_versionToHandlerMap5 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap5, constants/* VERSIONS.V3 */.Kr.V3, exploreForexCurrencyRedirectionV2), (0,defineProperty/* default */.Z)(_versionToHandlerMap5, constants/* VERSIONS.V2 */.Kr.V2, exploreForexCurrencyRedirectionV2), _versionToHandlerMap5);
      versionToHandlerMap[productVersion](item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    dropOffPersuasionRedirection: function dropOffPersuasionRedirection(item) {
      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      redirectDropOffV3(item, {
        tmBaseUrl: tmBaseUrl,
        otuForexPartnerUrl: otuForexPartnerUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    quickLoadMoneyRedirections: function quickLoadMoneyRedirections(item) {
      var _versionToHandlerMap6;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      var versionToHandlerMap = (_versionToHandlerMap6 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap6, constants/* VERSIONS.V3 */.Kr.V3, quickLoadMoneyRedirectionsV2), (0,defineProperty/* default */.Z)(_versionToHandlerMap6, constants/* VERSIONS.V2 */.Kr.V2, quickLoadMoneyRedirectionsV2), _versionToHandlerMap6);
      item.feature_flag = feature_flag || {};
      versionToHandlerMap[productVersion](item, {
        tmBaseUrl: tmBaseUrl,
        otuForexPartnerUrl: otuForexPartnerUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    completeOrderRedirections: function completeOrderRedirections(item) {
      var _versionToHandlerMap7;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      var versionToHandlerMap = (_versionToHandlerMap7 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap7, constants/* VERSIONS.V3 */.Kr.V3, completeOrderRedirectionsV2), (0,defineProperty/* default */.Z)(_versionToHandlerMap7, constants/* VERSIONS.V2 */.Kr.V2, completeOrderRedirectionsV2), _versionToHandlerMap7);
      versionToHandlerMap[productVersion](item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    landingPageRedirect: function landingPageRedirect() {
      (0,utils.closeWebview)({
        partner: partner
      });
    },
    trackCardRedirections: function trackCardRedirections(item) {
      var _versionToHandlerMap8;

      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      var versionToHandlerMap = (_versionToHandlerMap8 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap8, constants/* VERSIONS.V3 */.Kr.V3, trackCardRedirectionsV3), (0,defineProperty/* default */.Z)(_versionToHandlerMap8, constants/* VERSIONS.V2 */.Kr.V2, trackCardRedirectionsV2), _versionToHandlerMap8);
      versionToHandlerMap[productVersion](item, {
        mwebtmBaseUrl: mwebtmBaseUrl,
        otuForexPartnerUrl: otuForexPartnerUrl,
        partner: partner,
        device: device,
        tmBaseUrl: tmBaseUrl
      });
    },
    reloadTripRedirection: function reloadTripRedirection(item) {
      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();

      redirectionUtilsV2_reloadTripRedirection(item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    viewDashboardRedirections: function viewDashboardRedirections(item) {
      var _versionToHandlerMap9;

      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)();
      var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
      var versionToHandlerMap = (_versionToHandlerMap9 = {}, (0,defineProperty/* default */.Z)(_versionToHandlerMap9, constants/* VERSIONS.V3 */.Kr.V3, viewDashboardRedirectionsV2), (0,defineProperty/* default */.Z)(_versionToHandlerMap9, constants/* VERSIONS.V2 */.Kr.V2, viewDashboardRedirectionsV2), _versionToHandlerMap9);
      item.feature_flag = feature_flag || {};
      versionToHandlerMap[productVersion](item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        mwebtmBaseUrl: mwebtmBaseUrl,
        device: device
      });
    },
    viewOrdersRedirections: function viewOrdersRedirections(item) {
      (0,clientStorageUtils/* removeSessionStorageItem */.lD)(constants/* SESSION_STORAGE_KEYS.REQUEST_ID */.sO.REQUEST_ID);
      (0,utils.setMmtRedirectionCookie)(); // In listing revamp `view order` will show by default and is not a persuasion

      if ((item === null || item === void 0 ? void 0 : item.version) === constants/* VERSIONS.V3 */.Kr.V3) {
        return (0,static_utils/* redirectInterceptHref */.Xu)("".concat(tmBaseUrl, "/bmf/currency/post-sales/orders-listing"));
      } else {
        var productVersion = (item === null || item === void 0 ? void 0 : item.version) || constants/* DEFAULT_FLOW */.HL;
        viewOrdersRedirectionsV2(item, {
          otuForexPartnerUrl: otuForexPartnerUrl,
          tmBaseUrl: tmBaseUrl,
          device: device,
          mwebtmBaseUrl: mwebtmBaseUrl
        });
      }
    },
    crossSellRedirect: function crossSellRedirect(_ref) {
      var partner = _ref.partner,
          crossSellProduct = _ref.crossSellProduct,
          item = _ref.item;
      if (!partner || !crossSellProduct) return;
      var redirectionUrl = "";
      (0,utils.persistSpecificParamInCookie)(constants/* COOKIES.CROSS_SELL_FLOW */.E9.CROSS_SELL_FLOW, crossSellProduct, {
        path: "/",
        domain: partner === constants/* MakeMyTrip */.yO ? constants/* MMT_SUB_DOMAIN */.FJ : constants/* GI_SUB_DOMAIN */.Q7
      }); // For cross sell there are no individual persuasion cta. Hence, main/root cta of card/currency will be used

      productTilesRedirectionsV2(item, {
        otuForexPartnerUrl: otuForexPartnerUrl,
        tmBaseUrl: tmBaseUrl,
        device: device,
        mwebtmBaseUrl: mwebtmBaseUrl
      });
    }
  };
};

/* harmony default export */ var hooks_useRedirectionUrls = (useRedirectionUrls);

function getHostPartnerInfoForRedirections(partner) {
  var source = (0,utils.getSourceName)();
  var response = {
    host: source,
    partner: partner
  };

  switch (source) {
    case constants/* SOURCE.TRIPMONEY */.Hx.TRIPMONEY:
    case constants/* SOURCE.LOCALHOST */.Hx.LOCALHOST:
      {
        var host = getPartnerSourceForTM(partner);
        response = useRedirectionUrls_objectSpread(useRedirectionUrls_objectSpread({}, response), {}, {
          host: host
        });
        break;
      }

    case constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP:
      response = useRedirectionUrls_objectSpread(useRedirectionUrls_objectSpread({}, response), {}, {
        partner: partner !== null && partner !== void 0 ? partner : constants/* PARTNER.MMT */.RL.MMT
      });
      break;

    case constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO:
      response = useRedirectionUrls_objectSpread(useRedirectionUrls_objectSpread({}, response), {}, {
        partner: partner !== null && partner !== void 0 ? partner : constants/* PARTNER.GI */.RL.GI
      });
      break;
  }

  return response;
}

function getPartnerSourceForTM(partner) {
  if (partner === constants/* PARTNER.MMT */.RL.MMT) {
    return constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP;
  } else if (partner === constants/* PARTNER.GI */.RL.GI) {
    return constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO;
  } else {
    throw new Error("Wrong partner received from tripmoney app [getHostPartnerInfo]");
  }
}

function redirectToTMLandingPage(partner) {
  (0,static_utils/* redirectInterceptHref */.Xu)("https://www.tripmoney.com/partner/".concat(partner, "/context/landing"));
}

/***/ }),

/***/ 3943:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6198);


var useSetUTMParams = function useSetUTMParams() {
  function persistUTMParamsInCookie() {
    var shouldDeleteCookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var utmParams = getUTMParamsFromQuery();

    if (shouldDeleteCookie) {
      if (Object.keys(utmParams).length === 0) {
        deleteUtmParamsFromCookie();
        return;
      }
    }

    setUtmParamsInCookie(utmParams);
  }

  return {
    persistUTMParamsInCookie: persistUTMParamsInCookie
  };
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useSetUTMParams)));

/***/ }),

/***/ 4334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports InnerContentWrap, WhiteBackgroundStyled, GreyBackgroundStyled, LicenseFooterWrap */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8333);


var InnerContentWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "CommonStylesstyle__InnerContentWrap",
  componentId: "sc-1tlkskw-0"
})(["width:1200px;margin:0 auto;background:white;@media screen and ", "{width:100%;}"], _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
var WhiteBackgroundStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "CommonStylesstyle__WhiteBackgroundStyled",
  componentId: "sc-1tlkskw-1"
})(["background:white;"]);
var GreyBackgroundStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "CommonStylesstyle__GreyBackgroundStyled",
  componentId: "sc-1tlkskw-2"
})(["background:#f6f6f6;padding:16px;gap:9px;"]);
var LicenseFooterWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "CommonStylesstyle__LicenseFooterWrap",
  componentId: "sc-1tlkskw-3"
})(["width:1200px;margin:0 auto;background:#f6f6f6;@media screen and ", "{width:100%;}"], _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);

/***/ }),

/***/ 2357:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(4575);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.style.ts


var BulletListItem_style_BulletListItemStyle = styled_components_browser_esm["default"].li.withConfig({
  displayName: "BulletListItemstyle__BulletListItemStyle",
  componentId: "m828am-0"
})(["margin-bottom:20px;padding-left:20px;position:relative;font-size:14px;line-height:20px;color:", ";&:last-child{margin-bottom:0px;}&:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}"], Global/* theme.greyText */.rS.greyText, function (props) {
  return props.bulletColor;
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.tsx




var BulletListItem = function BulletListItem(_ref) {
  var children = _ref.children,
      _ref$bulletColor = _ref.bulletColor,
      bulletColor = _ref$bulletColor === void 0 ? theme.darkYellowText : _ref$bulletColor;
  return /*#__PURE__*/_jsx(BulletListItemStyle, {
    bulletColor: bulletColor,
    children: children
  });
};

/* harmony default export */ var BulletListItem_BulletListItem = ((/* unused pure expression or super */ null && (BulletListItem)));

/***/ }),

/***/ 3636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_D": function() { return /* binding */ Cta; }
/* harmony export */ });
/* unused harmony exports DeliveryPersuasionStyle, DeliveryPersuasionComp, ImgWpr, DeliveryLocationText */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);
/* harmony import */ var _ui_atoms_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7001);
/* harmony import */ var _css_Global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4575);



var DeliveryPersuasionStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_ui_atoms_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_0__/* .ParaTagStyle */ .OG).withConfig({
  displayName: "DeliveryPersuasionstyle__DeliveryPersuasionStyle",
  componentId: "sc-1821ms5-0"
})(["border-radius:4px;width:fit-content;color:", ";.boldText{font-weight:700;}.blueText{color:", ";}.greenText{color:", ";}.blackText{color:", ";}"], _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText, _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greenText5 */ .rS.greenText5, _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blackText */ .rS.blackText);
var DeliveryPersuasionComp = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "DeliveryPersuasionstyle__DeliveryPersuasionComp",
  componentId: "sc-1821ms5-1"
})(["padding:", ";margin:", ";background:", ";", ";", ";"], function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.bgColor;
}, function (props) {
  return props.isTextCenter && "\n        text-align: center;\n    ";
}, function (props) {
  return props.styleWithFlex && "\n        display: flex;\n        align-items: baseline;\n    ";
});
var Cta = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].a.withConfig({
  displayName: "DeliveryPersuasionstyle__Cta",
  componentId: "sc-1821ms5-2"
})(["text-decoration:none;cursor:pointer;font-size:14px;line-height:19px;font-weight:700;font-family:\"Open Sans\";color:", ";display:flex;align-items:center;margin:", ";&:hover,&:focus{text-decoration:none;outline:none;}"], _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, function (props) {
  return props !== null && props !== void 0 && props.margin ? props.margin : "0px 0px 0px";
});
var ImgWpr = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "DeliveryPersuasionstyle__ImgWpr",
  componentId: "sc-1821ms5-3"
})(["margin:0 0 0 6px;display:", ";"], function (props) {
  return props.isFlex ? "flex" : "block";
});
var DeliveryLocationText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_ui_atoms_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_0__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "DeliveryPersuasionstyle__DeliveryLocationText",
  componentId: "sc-1821ms5-4"
})([".regular{font-weight:400;}.greyText9{color:", ";}"], _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText);

/***/ }),

/***/ 8869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "_D": function() { return /* binding */ Cta; },
/* harmony export */   "sE": function() { return /* binding */ GpsIconWpr; }
/* harmony export */ });
/* unused harmony export StickyWpr */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);
/* harmony import */ var _css_Global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4575);


var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "EditLocationstyles__Container",
  componentId: "sc-7y4ns8-0"
})([""]);
var Cta = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].a.withConfig({
  displayName: "EditLocationstyles__Cta",
  componentId: "sc-7y4ns8-1"
})(["text-decoration:none;cursor:pointer;font-size:12px;line-height:16px;color:", ";font-weight:700;display:flex;align-items:center;margin-left:5px;&:hover,&:focus{text-decoration:none;outline:none;}"], _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText);
var GpsIconWpr = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "EditLocationstyles__GpsIconWpr",
  componentId: "sc-7y4ns8-2"
})(["margin:0 2px 0 0;"]);
var StickyWpr = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "EditLocationstyles__StickyWpr",
  componentId: "sc-7y4ns8-3"
})(["position:sticky;background-color:", ";padding:16px;box-shadow:0px 0px 6px rgba(0,0,0,0.16);margin:0px -32px -32px -32px;bottom:-32px;left:0;right:0;z-index:2;"], _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.smokeWhite */ .rS.smokeWhite);

/***/ }),

/***/ 3256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jO": function() { return /* binding */ ErrorScreenStyle; },
/* harmony export */   "xe": function() { return /* binding */ ErrorComp; }
/* harmony export */ });
/* unused harmony export FullPageWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8333);


var ErrorScreenStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "ErrorScreenstyle__ErrorScreenStyle",
  componentId: "sc-11l2kf4-0"
})(["height:100vh;display:flex;flex-direction:column;background:#fff;"]);
var ErrorComp = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "ErrorScreenstyle__ErrorComp",
  componentId: "sc-11l2kf4-1"
})(["display:flex;width:330px;margin:0 auto;flex-direction:column;align-items:center;margin-top:88px;flex:1;@media ", "{width:100%;flex-direction:column;padding:0px 16px;margin-top:unset;justify-content:center;}"], _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
var FullPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "ErrorScreenstyle__FullPageWrapper",
  componentId: "sc-11l2kf4-2"
})(["position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;overflow:hidden;"]);

/***/ }),

/***/ 8959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header_Header; }
});

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Header/Header.styles.ts


var HeaderCont = styled_components_browser_esm["default"].header.withConfig({
  displayName: "Headerstyles__HeaderCont",
  componentId: "sc-1p8qhc2-0"
})(["background-color:", ";position:fixed;top:0;z-index:11;box-shadow:", ";width:100%;"], function (props) {
  return props.bgColor;
}, function (props) {
  return props.showShadow ? "0px 1px 7px rgba(0, 0, 0, 0.21)" : "unset";
});
var HeaderInner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Headerstyles__HeaderInner",
  componentId: "sc-1p8qhc2-1"
})(["width:1200px;padding:", ";margin:0 auto;display:flex;align-items:center;justify-content:space-between;@media ", "{width:100%;}"], function (props) {
  return props.headerType === "mobile" ? "16px" : "20px 0";
}, utils/* deviceType.mobile */.vO.mobile);
var HeaderLft = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Headerstyles__HeaderLft",
  componentId: "sc-1p8qhc2-2"
})(["flex:1;display:flex;align-items:center;> span{display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-left:10px;}"]);
var HeaderRht = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Headerstyles__HeaderRht",
  componentId: "sc-1p8qhc2-3"
})(["display:flex;align-items:center;flex-shrink:0;"]);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/UserInfo/UserInfo.styles.ts

var UserCont = styled_components_browser_esm["default"].div.withConfig({
  displayName: "UserInfostyles__UserCont",
  componentId: "sc-1kbktns-0"
})(["display:inline-flex;align-items:center;position:relative;padding-right:30px;cursor:pointer;::after{display:inline-flex;border:solid white;border-width:0 2px 2px 0;padding:3px;content:\"\";transform:rotate(45deg);position:absolute;right:0;top:6px;}"]);
var UserIcon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "UserInfostyles__UserIcon",
  componentId: "sc-1kbktns-1"
})(["width:21px;height:21px;background:linear-gradient(222.16deg,#ff684a 5.2%,#ff4959 96.35%);border-radius:50%;flex-shrink:0;margin-right:10px;display:flex;align-items:center;justify-content:center;font-size:10px;line-height:12px;font-weight:900;color:#fff;"]);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/ParaTag.tsx
var ParaTag = __webpack_require__(8135);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/UserInfo/UserInfo.tsx






var UserInfo = function UserInfo(_ref) {
  var userName = _ref.userName,
      _ref$greetingText = _ref.greetingText,
      greetingText = _ref$greetingText === void 0 ? "Hey" : _ref$greetingText,
      _ref$txtColor = _ref.txtColor,
      txtColor = _ref$txtColor === void 0 ? "#fff" : _ref$txtColor,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "xs" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      onPress = _ref.onPress,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(UserCont, {
    onClick: onPress,
    id: id,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UserIcon, {
      children: userName.split("")[0]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ParaTag/* default */.Z, {
      color: txtColor,
      fontWeight: fontWeight,
      fontSize: fontSize,
      children: [greetingText, " ", userName]
    })]
  });
};

/* harmony default export */ var UserInfo_UserInfo = (UserInfo);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ImageTag/ImageTag.tsx + 1 modules
var ImageTag = __webpack_require__(4911);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/AnchorTag.tsx
var AnchorTag = __webpack_require__(19);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Header/Header.tsx








var Header = function Header(_ref) {
  var logo = _ref.logo,
      userName = _ref.userName,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#000" : _ref$bgColor,
      titleText = _ref.titleText,
      backArrow = _ref.backArrow,
      headerType = _ref.headerType,
      children = _ref.children,
      userInfoHandler = _ref.userInfoHandler,
      greetingText = _ref.greetingText,
      _ref$showShadow = _ref.showShadow,
      showShadow = _ref$showShadow === void 0 ? false : _ref$showShadow,
      backBtnHandler = _ref.backBtnHandler,
      headerWprId = _ref.headerWprId,
      backBtnId = _ref.backBtnId,
      userInfoId = _ref.userInfoId,
      _ref$userTextColor = _ref.userTextColor,
      userTextColor = _ref$userTextColor === void 0 ? "#fff" : _ref$userTextColor,
      _ref$userFontSize = _ref.userFontSize,
      userFontSize = _ref$userFontSize === void 0 ? "xs" : _ref$userFontSize,
      _ref$userFontWeight = _ref.userFontWeight,
      userFontWeight = _ref$userFontWeight === void 0 ? "regular" : _ref$userFontWeight,
      userImg = _ref.userImg,
      handleRightBtnClick = _ref.handleRightBtnClick,
      showRightCta = _ref.showRightCta,
      rightCtaTitle = _ref.rightCtaTitle;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderCont, {
    bgColor: bgColor,
    showShadow: showShadow,
    id: headerWprId,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderInner, {
      headerType: headerType,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderLft, {
        children: [backArrow && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          onClick: backBtnHandler,
          id: backBtnId,
          children: backArrow
        }), logo && logo, titleText && /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
          fontSize: "md",
          color: "#4a4a4a",
          fontWeight: "bold",
          margin: "0 0 0 15px",
          children: titleText
        }), userImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag/* default */.Z, {
          margin: "0px 0px 0px auto",
          height: "24px",
          width: "24px",
          borderRadius: "12px",
          showCursorPointer: true,
          src: userImg
        })]
      }), showRightCta && /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderRht, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorTag/* default */.Z, {
          fontWeight: "bold",
          fontSize: "sm",
          handleClick: handleRightBtnClick,
          margin: "0px 16px 0px",
          children: rightCtaTitle
        })
      }), !showRightCta && userName && /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderRht, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(UserInfo_UserInfo, {
          id: userInfoId,
          userName: userName,
          onPress: userInfoHandler,
          greetingText: greetingText,
          txtColor: userTextColor,
          fontSize: userFontSize,
          fontWeight: userFontWeight
        })
      })]
    }), children]
  });
};

/* harmony default export */ var Header_Header = (Header);

/***/ }),

/***/ 5423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports LandingFaqStyle, LandingFaqTitle, LandingFaqList, LandingInnerPointsCtr, LandingFaqQues, TabItem */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8333);
/* harmony import */ var _css_Global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4575);



var LandingFaqStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].section.withConfig({
  displayName: "LandingFaqstyle__LandingFaqStyle",
  componentId: "o5ukui-0"
})(["", " ", " display:flex;background:#fff;flex-direction:column;width:100%;background:white;", ""], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.padding && "padding: ".concat(props.padding, ";");
}, function (props) {
  return props.customFaq && "";
});
var LandingFaqTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqTitle",
  componentId: "o5ukui-1"
})(["padding:0;font-family:\"Raleway\";font-weight:500;font-size:48px;line-height:56px;margin-left:", ";margin-bottom:", ";color:", ";background:white;@media screen and ", "{font-weight:500;font-size:24px;line-height:32px;margin-bottom:8px;margin-left:", ";}"], function (props) {
  return props.marginLeft ? props.marginLeft : "0px";
}, function (props) {
  return props.marginBottom ? props.marginBottom : "56px";
}, _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blackText */ .rS.blackText, _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, function (props) {
  return props.marginLeft ? props.marginLeft : "0px";
});
var LandingFaqList = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].ul.withConfig({
  displayName: "LandingFaqstyle__LandingFaqList",
  componentId: "o5ukui-2"
})(["list-style:none;width:1000px;gap:16px;padding:0;background:white;li{margin-bottom:16px;position:relative;cursor:pointer;}li h5{padding:24px;@media screen and ", "{padding:16px;}}li > .pointCtr{padding:0 24px;overflow:hidden;max-height:0px;transition:max-height 0.25s;@media screen and ", "{padding:0 16px;}}li > .pointCtr.open_forex{max-height:1000px;transition:max-height 1s ease-out;}li > .pointCtr .boldText{font-weight:700;}li:after{content:\"\";position:absolute;border:solid black;border-width:0 3px 3px 0;display:inline-block;padding:3px;right:24px;top:33px;transition:0.3s ease-in;@media screen and ", "{top:16px;}}li.close_forex:after{transform:rotate(45deg);-webkit-transform:rotate(45deg);}li.open_forex:after{transform:rotate(-135deg);-webkit-transform:rotate(-135deg);}li:hover{background:#ffffff;box-shadow:0px 4px 16px rgba(0,0,0,0.16);border-radius:6px;}li:last-child{margin-bottom:unset;}", " @media screen and ", "{width:100%;li:hover{box-shadow:unset;}}"], _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, function (props) {
  return props.customFaq && "\n            width:100%;\n            gap:8px;\n            margin-bottom: 24px;\n            li {\n                padding: 12px 16px;\n                background: #FFFFFF;\n                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);\n                border-radius: 6px;\n            }\n            li h5 {\n                padding: unset;\n            }\n            li p {\n                padding:unset;\n                font-family: 'Open Sans';\n                font-size: 12px;\n                line-height: 16px;\n                color: #000000;\n            }\n            li:after {\n                border: solid #008CFF;\n                border-width: 0 2px 2px 0;\n                padding: 4px;\n                right: 24px;\n                top: 13px;\n            }\n    ";
}, _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
var LandingInnerPointsCtr = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "LandingFaqstyle__LandingInnerPointsCtr",
  componentId: "o5ukui-3"
})(["& > div{margin-bottom:16px;}"]);
var LandingFaqQues = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].h5.withConfig({
  displayName: "LandingFaqstyle__LandingFaqQues",
  componentId: "o5ukui-4"
})(["margin:0;padding:0;font-weight:700;font-size:22px;line-height:30px;width:95%;color:#000;background:white;", " @media screen and ", "{font-weight:700;font-size:16px;line-height:20px;}"], function (props) {
  return props.customFaq && "\n        font-family: 'Open Sans';\n        font-size: 12px;\n        line-height: 16px;\n        color: #000000;";
}, _utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
var TabItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "LandingFaqstyle__TabItem",
  componentId: "o5ukui-5"
})(["border-radius:4px;box-shadow:0px 0px 4px 0px rgba(0,0,0,0.16);display:flex;padding:12px 16px;align-items:center;background-color:", ";border:", ";font-size:14px;font-weight:", ";color:", ";margin-bottom:24px;"], function (props) {
  return props.isSelected ? "#EAF5FF" : _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText;
}, function (props) {
  return props.isSelected ? "1px solid #008CFF" : "unset";
}, function (props) {
  return props.isSelected ? 700 : 400;
}, function (props) {
  return props.isSelected ? _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText : _css_Global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText;
});

/***/ }),

/***/ 7998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports FadeInAnimation, FadeInAndMoveUpAnimation, BMFListingContainer, ArrowIconContainer, ListingTopContainer, LandingCardFeatureCtr, MarkerContainer, SpecialAttention, LocationLoading, LocationLoadingCtr, AbsIconContainer, MoveUpAnimation, FadeImg, MoveUpAndScale, ConditionsText, GifContainer, MMTAvatarIcon, MMTAvatarIconV3, GIAvatarIcon, AvatarIconWpr, CoachmarkContainer, CoachmarkInnerContainer, CounterTag, EffectiveRateContainer, PriceRatesWrapper, PriceRatesContainerOuter, PriceRatesContainer, PriceTickerOuter, PriceTickerInner, LandingTitleStyle, BestPriceTextGradient, ZeroPayment, MobileViewListingProductCardContainer, FixedBottomContainer, PriceHikeWarningWrapper, DeliveryStatusListingTop, OrderTimeListingWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);
/* harmony import */ var _css_Global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4575);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8333);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2638);
/* harmony import */ var _ui_atoms_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7001);






var fadeIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);
var fadeOut = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.keyframes)(["0%{opacity:1;}100%{opacity:0;}"]);
var moveUpText = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.keyframes)(["from{transform:translateY(50vh);}to{transform:translateY(0px);}"]);
var moveUpTextTwo = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.keyframes)(["from{transform:translateY(50vh);}to{transform:translateY(-80px);}"]);
var moveAndScale = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.keyframes)(["from{transform:translateY(0px) scale(1);}to{transform:translateY(-100px) scale(0.2);opacity:0;}"]); // ANIMATIONS STARTS

var FadeInAnimation = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__FadeInAnimation",
  componentId: "ue3gat-0"
})(["opacity:0;animation:", " linear 0.8s ", ";animation-fill-mode:forwards;"], fadeIn, function (props) {
  return props.delay ? props.delay : "0.5s";
});
var FadeInAndMoveUpAnimation = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__FadeInAndMoveUpAnimation",
  componentId: "ue3gat-1"
})(["position:relative;", ";transform:", ";", " ", "{text-transform:none;}"], function (props) {
  return props.zIndex && "\n      z-index: ".concat(props.zIndex, ";\n    ");
}, function (props) {
  return props.moveFromDistance ? "translateY(".concat(props.moveFromDistance, ")") : "translateY(0px)";
}, "\n    animation: moveUp ease-out 0.8s;\n    ".concat(function (props) {
  return props.moveDelay ? props.moveDelay : "0s";
}, ";\n    animation-fill-mode: forwards;\n    @keyframes moveUp {\n        0% { transform: translateY(").concat(function (props) {
  return props.moveFromDistance ? props.moveFromDistance : "0px";
}, ") }\n        100% { transform: translateY(0px) }\n    }\n    "), _ui_atoms_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_4__/* .H4TagStyle */ .sz); // ANIMATIONS ENDS

var BMFListingContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__BMFListingContainer",
  componentId: "ue3gat-2"
})(["width:1200px;margin:", ";", " background-color:", ";@media screen and ", "{width:100%;}"], function (props) {
  return props.margin ? props.margin : "0px auto";
}, function (props) {
  return props.padding && "padding: ".concat(props.padding, ";");
}, _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
var ArrowIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].span.withConfig({
  displayName: "ListingPageComponentsstyle__ArrowIconContainer",
  componentId: "ue3gat-3"
})(["transform:scale(1);"]);
var ListingTopContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__ListingTopContainer",
  componentId: "ue3gat-4"
})(["position:relative;background-color:", ";padding:", ";@media screen and ", "{background-image:", ";background-repeat:no-repeat;background-size:100%;padding-bottom:unset;padding:unset;padding-top:16px;background-color:", ";", "}"],  true && (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHostName)() === _constants__WEBPACK_IMPORTED_MODULE_3__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP ? "none" : _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blackText */ .rS.blackText,  true && (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHostName)() === _constants__WEBPACK_IMPORTED_MODULE_3__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP ? "0px 0px 20px 0px" : "100px 0px 20px", _utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile, function (props) {
  return "url(".concat(props.bgImage, ")");
}, function (props) {
  return props.version === _constants__WEBPACK_IMPORTED_MODULE_3__/* .VERSIONS.V3 */ .Kr.V3 ? _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText : _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blackText */ .rS.blackText;
}, function (props) {
  return (props.isLocationFetching || props.isPageLoading) && "\n            background-color:  ".concat(function (props) {
    return props.version === _constants__WEBPACK_IMPORTED_MODULE_3__/* .VERSIONS.V3 */ .Kr.V3 ? _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText : _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blackText */ .rS.blackText;
  }, ";\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n            height: 106vh;\n            background-size: cover;\n            background-image: ").concat(function (props) {
    return props.version === _constants__WEBPACK_IMPORTED_MODULE_3__/* .VERSIONS.V3 */ .Kr.V3 ? "url(".concat(props.bgImage, ")") : "url(https://tripmoneycmsimgak.mmtcdn.com/img/listing_bg_grill_fcf0a7f743.svg)}";
  }, ";\n        ");
});
var LandingCardFeatureCtr = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__LandingCardFeatureCtr",
  componentId: "ue3gat-5"
})(["display:flex;gap:", ";@media screen and ", "{flex-direction:column;gap:8px;}"], function (props) {
  return props.version === _constants__WEBPACK_IMPORTED_MODULE_3__/* .VERSIONS.V3 */ .Kr.V3 ? "24px" : "6px";
}, _utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
var MarkerContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(FadeInAndMoveUpAnimation).withConfig({
  displayName: "ListingPageComponentsstyle__MarkerContainer",
  componentId: "ue3gat-6"
})(["display:flex;flex-direction:column;gap:12px;position:relative;z-index:2;@media screen and ", "{padding:0px 16px 0px;}"], _utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
var SpecialAttention = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__SpecialAttention",
  componentId: "ue3gat-7"
})(["overflow:hidden;border-radius:16px;background:white;", " ", ""], function (props) {
  return props.withShadow && "box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);";
}, function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}); // Location Fetching Styles

var LocationLoading = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__LocationLoading",
  componentId: "ue3gat-8"
})(["position:relative;width:208px;height:208px;display:flex;align-items:center;justify-content:center;"]);
var LocationLoadingCtr = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__LocationLoadingCtr",
  componentId: "ue3gat-9"
})(["display:flex;flex-direction:column;align-items:center;position:absolute;width:300px;top:50%;left:50%;transform:translate(-50%,-90%);"]);
var AbsIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__AbsIconContainer",
  componentId: "ue3gat-10"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-100%);", ""], function (props) {
  return props.isFadeIn && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.css)(["animation:", " linear 1s;"], fadeIn);
});
var MoveUpAnimation = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__MoveUpAnimation",
  componentId: "ue3gat-11"
})(["position:absolute;bottom:0px;display:flex;justify-content:center;transform:translateY(-100px);animation:", " ease-out 1.2s;animation-fill-mode:forwards;"], moveUpTextTwo);
var FadeImg = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__FadeImg",
  componentId: "ue3gat-12"
})(["", ""], function (props) {
  return props.showAnim && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.css)(["animation:", " linear 1.2s;animation-fill-mode:forwards;"], fadeOut);
});
var MoveUpAndScale = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__MoveUpAndScale",
  componentId: "ue3gat-13"
})(["", ""], function (props) {
  return props.showAnim && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.css)(["animation:", " linear 1s;animation-fill-mode:forwards;"], moveAndScale);
});
var ConditionsText = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__ConditionsText",
  componentId: "ue3gat-14"
})(["margin:auto 0px 50px;text-align:center;width:285px;transform:translateY(0px);animation:", " ease-out 1.2s;"], moveUpText);
var GifContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__GifContainer",
  componentId: "ue3gat-15"
})(["width:56px;height:56px;display:flex;border-radius:50%;align-items:center;justify-content:center;background:", ";"], _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
var MMTAvatarIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].span.withConfig({
  displayName: "ListingPageComponentsstyle__MMTAvatarIcon",
  componentId: "ue3gat-16"
})(["background-image:url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/homePageV3/home-revamp-sprite17.webp);background-size:300px 550px !important;background-repeat:no-repeat;display:inline-block;flex-shrink:0;height:26px;width:27px;margin-left:-4px;margin-right:-5px;background-position:-241px -142px;"]);
var MMTAvatarIconV3 = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].span.withConfig({
  displayName: "ListingPageComponentsstyle__MMTAvatarIconV3",
  componentId: "ue3gat-17"
})(["background:url(https://tripmoneycmsimgak.mmtcdn.com/img/tripmoney_mmtprofile_V3_0e8b64f5a3.png) 0 0 no-repeat;background-size:32px 32px !important;display:inline-block;flex-shrink:0;height:32px;width:32px;margin-left:-4px;margin-right:-5px;"]);
var GIAvatarIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].span.withConfig({
  displayName: "ListingPageComponentsstyle__GIAvatarIcon",
  componentId: "ue3gat-18"
})(["height:30px;width:30px;display:inline-block;background-repeat:no-repeat;background-position:center center;background-image:url(\"data:image/svg+xml,%3Csvg width='29' height='28' viewBox='0 0 29 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='14.2687' cy='14' r='14' fill='%23DEE5EA'/%3E%3Cpath d='M14.2314 5.69614C16.5908 5.69614 18.5032 7.67932 18.5032 10.1262C18.5032 12.573 16.5908 14.5562 14.2314 14.5562C11.8719 14.5562 9.95956 12.573 9.95956 10.1262C9.95956 7.67932 11.8719 5.69614 14.2314 5.69614Z' fill='%23657A97'/%3E%3Cpath d='M14.0814 16.1384C11.1298 16.137 8.39518 17.584 6.88809 19.9477C6.76431 20.1403 6.76431 20.3803 6.88809 20.5729C7.01768 20.7682 7.24629 20.8862 7.49238 20.8848H20.6529C20.899 20.8862 21.1276 20.7682 21.2572 20.5743C21.3824 20.3817 21.3824 20.1417 21.2572 19.9491C19.7559 17.5881 17.0286 16.1397 14.0814 16.1384Z' fill='%23657A97'/%3E%3C/svg%3E%0A\");"]);
var AvatarIconWpr = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__AvatarIconWpr",
  componentId: "ue3gat-19"
})(["position:relative;display:inline-block;"]);
var CoachmarkContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__CoachmarkContainer",
  componentId: "ue3gat-20"
})(["height:100vh;width:100vw;background:rgba(0,0,0,0.7);position:fixed;z-index:1000;"]);
var CoachmarkInnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__CoachmarkInnerContainer",
  componentId: "ue3gat-21"
})(["position:absolute;right:16px;top:32px;display:flex;flex-direction:column;align-items:flex-end;"]);
var CounterTag = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__CounterTag",
  componentId: "ue3gat-22"
})(["font-size:10px;color:", ";position:absolute;top:-8px;right:-14px;border-radius:50%;height:20px;width:20px;align-items:center;justify-content:center;display:flex;font-family:\"Open Sans\";font-weight:400;background:#eb2026;"], _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
var EffectiveRateContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__EffectiveRateContainer",
  componentId: "ue3gat-23"
})(["display:flex;flex-direction:row;align-items:center;justify-content:", ";margin:24px 0px 0px;"], function (props) {
  return props.showEffectiveBanner ? "space-between" : "right";
});
var PriceRatesWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__PriceRatesWrapper",
  componentId: "ue3gat-24"
})(["display:flex;"]);
var PriceRatesContainerOuter = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__PriceRatesContainerOuter",
  componentId: "ue3gat-25"
})(["border-radius:8px;background:linear-gradient(90deg,#f9f0fb,#eae9f7);padding:1px;"]);
var PriceRatesContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__PriceRatesContainer",
  componentId: "ue3gat-26"
})(["height:60px;display:flex;align-items:center;border-radius:7px;gap:4px;background:linear-gradient(90deg,#ffffff,#faf1fb);padding:8px 24px 8px 8px;"]);
var PriceTickerOuter = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__PriceTickerOuter",
  componentId: "ue3gat-27"
})(["border-radius:8px;background:linear-gradient(90deg,#f9f0fb,#eae9f7);padding:1px;margin-left:-14px;"]);
var PriceTickerInner = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__PriceTickerInner",
  componentId: "ue3gat-28"
})(["height:60px;display:flex;align-items:center;justify-content:space-between;border-radius:7px;background:#fff;padding:0 24px;"]);
var LandingTitleStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_ui_atoms_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_4__/* .ParaTagStyle */ .OG).withConfig({
  displayName: "ListingPageComponentsstyle__LandingTitleStyle",
  componentId: "ue3gat-29"
})(["font-size:14px;line-height:20px;color:", ";.boldText{font-weight:700;}.greenText{color:", ";}.font16{font-size:16px;line-height:22px;}"], _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText, _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greenText6 */ .rS.greenText6);
var BestPriceTextGradient = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_ui_atoms_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_4__/* .ParaTagStyle */ .OG).withConfig({
  displayName: "ListingPageComponentsstyle__BestPriceTextGradient",
  componentId: "ue3gat-30"
})(["font-size:14px;line-height:20px;font-weight:bold;background:-webkit-linear-gradient(120deg,#3023ae,#c86dd7);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"]);
var ZeroPayment = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__ZeroPayment",
  componentId: "ue3gat-31"
})(["position:absolute;left:16px;top:0;z-index:1;"]);
var MobileViewListingProductCardContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__MobileViewListingProductCardContainer",
  componentId: "ue3gat-32"
})(["position:relative;"]);
var FixedBottomContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__FixedBottomContainer",
  componentId: "ue3gat-33"
})(["position:fixed;bottom:0;z-index:11;background:", ";"], _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
var PriceHikeWarningWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__PriceHikeWarningWrapper",
  componentId: "ue3gat-34"
})(["background:", ";border-radius:12px;@media (", "){width:1200px;margin:0px auto 20px auto;}"], _css_Global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.desktop */ .vO.desktop);
var DeliveryStatusListingTop = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__DeliveryStatusListingTop",
  componentId: "ue3gat-35"
})(["margin-bottom:10px;margin-top:5px;"]);
var OrderTimeListingWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__OrderTimeListingWrapper",
  componentId: "ue3gat-36"
})(["margin-top:-14px;margin-bottom:-8px;"]);

/***/ }),

/***/ 3433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(4575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/FlexComp/FlexComp.tsx + 1 modules
var FlexComp = __webpack_require__(8575);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/ParaTag.tsx
var ParaTag = __webpack_require__(8135);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/H5Tag.tsx
var H5Tag = __webpack_require__(7145);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Modal/Modal.styles.ts

var ModalWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Modalstyles__ModalWrapper",
  componentId: "i4onzq-0"
})(["overflow:hidden;width:", ";padding:", ";background-color:#fff;border-radius:12px;position:fixed;z-index:100;", " ", " ", ""], function (props) {
  return props.modalWidth ? "".concat(props.modalWidth, "px") : "420px";
}, function (props) {
  return props.padding ? "".concat(props.padding) : "20px 30px 30px 30px";
}, function (props) {
  return props.modalType === "centered" && "\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    ";
}, function (props) {
  return props.modalType === "bottomSheet" && "\n        ".concat(props.stickToTop ? "\n                left: 0;\n                top: 0;\n                height: 100%;\n            " : "\n                left: 0;\n                bottom: 0;\n            ", ";\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        animation: modalAnim 0.6s;\n    @keyframes modalAnim {\n        from{bottom:-600px;}\n        to{bottom:0;}\n    }\n    ");
}, function (props) {
  return props.modalType === "fullPage" && "\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: 0;\n        \n        animation: fullModalAnim 0.8s;\n        @keyframes fullModalAnim {\n            from{top:".concat(window.innerHeight, "px;}\n            to{top:0;}\n        }\n    ");
});
var ModalBackdrop = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Modalstyles__ModalBackdrop",
  componentId: "i4onzq-1"
})(["width:100%;height:100%;background-color:rgba(0,0,0,0.5);position:fixed;left:0;top:0;z-index:99;"]);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Modal/Modal.tsx











var Modal = function Modal(_ref) {
  var children = _ref.children,
      modalWidth = _ref.modalWidth,
      modalHeading = _ref.modalHeading,
      modalHeadingComp = _ref.modalHeadingComp,
      modalSubHeading = _ref.modalSubHeading,
      _ref$modalHeadingCtrM = _ref.modalHeadingCtrMargin,
      modalHeadingCtrMargin = _ref$modalHeadingCtrM === void 0 ? "0 0 32px 0" : _ref$modalHeadingCtrM,
      closeButton = _ref.closeButton,
      onModalClose = _ref.onModalClose,
      padding = _ref.padding,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? "centered" : _ref$modalType,
      backBtn = _ref.backBtn,
      _ref$showBackBtn = _ref.showBackBtn,
      showBackBtn = _ref$showBackBtn === void 0 ? false : _ref$showBackBtn,
      _ref$stickToTop = _ref.stickToTop,
      stickToTop = _ref$stickToTop === void 0 ? false : _ref$stickToTop,
      modalIcon = _ref.modalIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ModalWrapper, {
      padding: padding,
      modalType: modalType,
      modalWidth: modalWidth,
      stickToTop: stickToTop,
      children: [modalType === "fullPage" && showBackBtn ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        alignItems: "center",
        margin: modalHeadingCtrMargin,
        width: "100%",
        children: [backBtn && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          onClick: onModalClose,
          children: backBtn
        }), (modalHeading || modalSubHeading) && (modalSubHeading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          flexDirection: "column",
          margin: "0px",
          children: [modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
            fontSize: "md",
            margin: "0px 0px 0px 20px",
            color: Global/* theme.greyText */.rS.greyText,
            fontWeight: "bold",
            children: modalHeading
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
            fontSize: "xs",
            margin: "0px 0px 0px 20px",
            color: Global/* theme.greyText6 */.rS.greyText6,
            children: modalSubHeading
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
          fontSize: "md",
          margin: "0px 0px 0px 20px",
          color: Global/* theme.greyText */.rS.greyText,
          fontWeight: "bold",
          children: modalHeading
        })), modalHeadingComp && modalHeadingComp]
      }) : (modalHeading || closeButton || modalHeadingComp) && /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        margin: modalHeadingCtrMargin,
        width: "100%",
        children: [modalIcon && modalIcon, (modalHeading || modalSubHeading) && modalSubHeading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          margin: "0px",
          flexDirection: "column",
          children: [modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(H5Tag/* default */.Z, {
            children: modalHeading
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
            fontSize: "xs",
            color: Global/* theme.greyText */.rS.greyText,
            children: modalSubHeading
          })]
        }) : modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(H5Tag/* default */.Z, {
          children: modalHeading
        }), modalHeadingComp && modalHeadingComp, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          id: (0,utils.getElementUniqueIds)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, constants/* SectionNameMapping.EDIT_ADDRESS */.Rw.EDIT_ADDRESS, constants/* ElementNameMapping.CLOSE_BUTTON */.vT.CLOSE_BUTTON),
          onClick: onModalClose,
          children: closeButton
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalBackdrop, {
      onClick: onModalClose
    })]
  });
};

/* harmony default export */ var Modal_Modal = (Modal);

/***/ }),

/***/ 7452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8316);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);




var Portal = function Portal(_ref) {
  var children = _ref.children,
      id = _ref.id;
  var portalId = id || "portal";
  var portalEle = document.getElementById(portalId);
  return portalEle ? /*#__PURE__*/(0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(children, portalEle) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    id: id,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Portal);

/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5505);
/* harmony import */ var _ui_atoms_ImageTag_ImageTag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4911);
/* harmony import */ var _ui_atoms_TextStyles_SpanTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3634);
/* harmony import */ var _Modal_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3433);
/* harmony import */ var _ui_atoms_LandingButton_LandingButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1152);
/* harmony import */ var _icons_CloseIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1269);
/* harmony import */ var _hooks_useDevice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5187);
/* harmony import */ var _hooks_useListingPdtLoggerV2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2221);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6198);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2638);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8333);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2322);















var ForexRatesWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
  displayName: "PriceHikeWarning__ForexRatesWrapper",
  componentId: "f3wx76-0"
})(["padding:8px;display:flex;align-items:center;background:linear-gradient( 90deg,#e0f0ff 33.5%,rgba(255,255,255,0) 100% );color:#1a73e8;border-radius:12px;@media (", "){border-radius:0px;}"], _utils__WEBPACK_IMPORTED_MODULE_10__/* .deviceType.mobile */ .vO.mobile);

var PriceHikeWarning = function PriceHikeWarning(_ref) {
  var text = _ref.text,
      info = _ref.info;

  var _useState = useState(false),
      showInfo = _useState[0],
      setShowInfo = _useState[1];

  var device = useDevice();

  var _useListingPdtLoggerV = useListingPdtLoggerV2(),
      sendPdtDataV2 = _useListingPdtLoggerV.sendPdtDataV2;

  var handleInfoClick = function handleInfoClick() {
    setShowInfo(true);
    sendPdtDataV2({
      event_detail: getEventDetails({
        event_name: PDT_EVENTS.RATE_INCREASE_NUDGE_INFO_CLICKED
      })
    });
  };

  var handleModalClose = function handleModalClose() {
    setShowInfo(false);
  };

  if (!text || !info) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ForexRatesWrapper, {
      device: device,
      children: [/*#__PURE__*/_jsx(ImageTag, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/price_hike_6cb035f6a3.svg",
        margin: "0px 8px 0px 0px"
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        color: "#005499",
        children: text
      }), /*#__PURE__*/_jsx(ImageTag, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Info_0a25f3f0f9.svg",
        showCursorPointer: true,
        margin: "0px 0px 0px 8px",
        onClick: handleInfoClick
      })]
    }), showInfo && /*#__PURE__*/_jsxs(Modal, {
      modalWidth: 480,
      closeButton: /*#__PURE__*/_jsx(CloseIcon, {}),
      onModalClose: handleModalClose,
      modalHeading: "Forex Rates",
      modalSubHeading: "",
      modalHeadingCtrMargin: "0px 0px 20px",
      modalType: device === "lg" ? "centered" : "bottomSheet",
      children: [info, /*#__PURE__*/_jsx(LandingButton, {
        onClick: handleModalClose,
        customTitle: "OK",
        customWidth: "100%",
        margin: "24px 0 0 0"
      })]
    })]
  });
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (PriceHikeWarning)));

/***/ }),

/***/ 7005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Shimmer; }
});

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/Shimmer.style.ts

var shimmer = (0,styled_components_browser_esm.keyframes)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
var ShimmerComp = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Shimmerstyle__ShimmerComp",
  componentId: "bk32cl-0"
})(["animation:", " 1s linear infinite;background:", ";background-size:800px 104px;position:relative;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;padding:", ";display:flex;", ";align-items:flex-end;}"], shimmer, function (p) {
  return p.background ? p.background : "linear-gradient(to right, #2F2F2F 8%, #393939 18%, #2F2F2F 33%)";
}, function (p) {
  return p.width ? p.width : "100%";
}, function (p) {
  return p.height ? p.height : "14px";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.padding ? p.padding : "";
}, function (p) {
  return p.flex && "flex: ".concat(p.flex);
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/Shimmer.tsx


function Shimmer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      borderRadius = _ref.borderRadius,
      margin = _ref.margin,
      padding = _ref.padding,
      flex = _ref.flex,
      background = _ref.background;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerComp, {
    flex: flex,
    width: width,
    margin: margin,
    height: height,
    padding: padding,
    background: background,
    borderRadius: borderRadius
  });
}

/***/ }),

/***/ 8575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FlexComp_FlexComp; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/FlexComp/FlexComp.style.ts

var fadeIn = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);

var renderAlign = function renderAlign(alignItems) {
  switch (alignItems) {
    case "center":
      return "align-items: center;";

    case "baseline":
      return "align-items: baseline;";

    case "flex-start":
      return "align-items:flex-start;";

    case "flex-end":
      return "align-items:flex-end;";

    default:
      return "align-items:center;";
  }
};

var renderJustify = function renderJustify(justifyContent) {
  switch (justifyContent) {
    case "center":
      return "justify-content:center;";

    case "flex-start":
      return "justify-content:flex-start;";

    case "end":
      return "justify-content:end;";

    case "space-between":
      return "justify-content:space-between;";

    default:
      return "justify-content:center;";
  }
};

var renderDir = function renderDir(flexDirection) {
  switch (flexDirection) {
    case "row":
      return "flex-direction:row;";

    case "column":
      return "flex-direction:column;";

    default:
      return "flex-direction:row;";
  }
};

var FlexCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FlexCompstyle__FlexCompStyle",
  componentId: "k4pbfn-0"
})(["display:flex;position:relative;cursor:", ";", " ", " ", " gap:var(--gap,0);flex:var(--flex,unset);flex-shrink:var(--flexShrink,unset);margin:var(--flexMargin,unset);padding:var(--padding,0);border-bottom:var(--borderBottom,none);border-top:var(--borderTop,none);background:var(--bgColor,transparent);border-radius:var(--borderRadius,0);height:var(--tm-height,unset);", " width:var(--tm-width,unset);box-shadow:var(--boxShadow,unset);"], function (props) {
  return props.isCursorPointer ? "pointer" : "default";
}, function (p) {
  return p.alignItems && "\n    ".concat(renderAlign(p.alignItems), "\n  ");
}, function (p) {
  return p.justifyContent && "\n    ".concat(renderJustify(p.justifyContent), "\n  ");
}, function (p) {
  return p.flexDirection && "\n    ".concat(renderDir(p.flexDirection), "\n  ");
}, function (props) {
  return props.minHeight && "min-height: ".concat(props.minHeight, ";");
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/FlexComp/FlexComp.tsx




var FlexComp = function FlexComp(_ref) {
  var children = _ref.children,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      margin = _ref.margin,
      borderBottom = _ref.borderBottom,
      borderTop = _ref.borderTop,
      padding = _ref.padding,
      flex = _ref.flex,
      bgColor = _ref.bgColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      alignSelf = _ref.alignSelf,
      flexShrink = _ref.flexShrink,
      handleClick = _ref.handleClick,
      boxShadow = _ref.boxShadow,
      width = _ref.width,
      minHeight = _ref.minHeight,
      _ref$isCursorPointer = _ref.isCursorPointer,
      isCursorPointer = _ref$isCursorPointer === void 0 ? false : _ref$isCursorPointer,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    id: id,
    alignItems: alignItems,
    flexDirection: flexDirection,
    justifyContent: justifyContent,
    minHeight: minHeight,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    style: {
      "--gap": gap,
      "--flexMargin": margin,
      "--borderBottom": borderBottom,
      "--borderTop": borderTop,
      "--padding": padding,
      "--flex": flex,
      "--bgColor": bgColor,
      "--borderRadius": borderRadius,
      "--tm-height": height,
      "--alignSelf": alignSelf,
      "--flexShrink": flexShrink,
      "--tm-width": width,
      "--boxShadow": boxShadow
    },
    onClick: handleClick,
    children: children
  });
};

/* harmony default export */ var FlexComp_FlexComp = (FlexComp);

/***/ }),

/***/ 4911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ImageTag_ImageTag; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ImageTag/ImageTag.style.ts

var ImageTagStyle = styled_components_browser_esm["default"].img.withConfig({
  displayName: "ImageTagstyle__ImageTagStyle",
  componentId: "sc-7ysxf3-0"
})(["display:inline-block;margin:", ";width:", ";position:", ";right:", ";z-index:", ";bottom:", ";border-radius:", ";flex-shrink:0;", ""], function (props) {
  return props.margin;
}, function (props) {
  return props.width;
}, function (props) {
  return props.position;
}, function (props) {
  return props.right;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props !== null && props !== void 0 && props.borderRadius ? props.borderRadius : "unset";
}, function (props) {
  return props.showCursorPointer && " cursor: pointer;";
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/ImageTag/ImageTag.tsx



var ImageTag = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var src = _ref.src,
      width = _ref.width,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "image-tag" : _ref$alt,
      margin = _ref.margin,
      height = _ref.height,
      _ref$showCursorPointe = _ref.showCursorPointer,
      showCursorPointer = _ref$showCursorPointe === void 0 ? false : _ref$showCursorPointe,
      borderRadius = _ref.borderRadius,
      position = _ref.position,
      bottom = _ref.bottom,
      right = _ref.right,
      zIndex = _ref.zIndex,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTagStyle, {
    ref: ref,
    src: src,
    width: width,
    margin: margin,
    height: height,
    showCursorPointer: showCursorPointer,
    alt: alt,
    borderRadius: borderRadius,
    position: position,
    bottom: bottom,
    right: right,
    zIndex: zIndex,
    onClick: onClick
  });
});
/* harmony default export */ var ImageTag_ImageTag = (ImageTag);

/***/ }),

/***/ 8721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ BtnMainIcon; },
/* harmony export */   "aA": function() { return /* binding */ LandingButtonWhiteStyle; },
/* harmony export */   "vj": function() { return /* binding */ ShimmerWrap; },
/* harmony export */   "zm": function() { return /* binding */ LandingButtonStyle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var LandingButtonStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
  displayName: "LandingButtonstyle__LandingButtonStyle",
  componentId: "sc-3pie8o-0"
})(["background:var( --btnBg,linear-gradient(91.91deg,#000000 0.3%,#330e0e 100%) );box-shadow:0px 1px 7px rgba(0,0,0,0.21);border-radius:6px;font-weight:900;font-size:var(--btnFont,16px);line-height:20px;color:var(--btnColor,#fff);width:var(--customWidth,fit-content);height:var(--customHeight,44px);border:none;outline:none;cursor:pointer;margin:var(--btnMargin,unset);flex:var(--btnFlex,unset);flex-shrink:var(--btnFlexShrink,unset);border:var(--btnBorder);font-family:\"Open Sans\";display:flex;align-items:center;justify-content:center;position:relative;padding:var(--btnPadding,12px);text-transform:uppercase;", " ", ""], function (props) {
  return props.btnIcon && "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding:16px;\n  }\n\t";
}, function (props) {
  return props.disableState && "\n  background: #CBCBCB;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.3);\n  ";
});
var ShimmerWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingButtonstyle__ShimmerWrap",
  componentId: "sc-3pie8o-1"
})(["position:absolute;width:68px;height:48px;z-index:12;top:-43px;animation:shimmmer 2.9s ease-in;animation-iteration-count:infinite;animation-fill-mode:backwards;@keyframes shimmmer{0%{transform:translateX(-311px);}100%{transform:translateX(311px);}}"]);
var BtnMainIcon = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingButtonstyle__BtnMainIcon",
  componentId: "sc-3pie8o-2"
})(["display:flex;align-items:center;gap:8px;"]);
var LandingButtonWhiteStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonWhiteStyle",
  componentId: "sc-3pie8o-3"
})(["background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;color:#008cff;"]);

/***/ }),

/***/ 1152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _LandingButton_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8721);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);




var LandingButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      btnIcon = _ref.btnIcon,
      background = _ref.background,
      color = _ref.color,
      customHeight = _ref.customHeight,
      shimmerBtn = _ref.shimmerBtn,
      flex = _ref.flex,
      border = _ref.border,
      btnMainIcon = _ref.btnMainIcon,
      fontSize = _ref.fontSize,
      padding = _ref.padding,
      id = _ref.id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_LandingButton_style__WEBPACK_IMPORTED_MODULE_1__/* .LandingButtonStyle */ .zm, {
    ref: ref,
    id: id,
    btnIcon: btnIcon,
    onClick: onClick,
    style: {
      "--btnBg": background,
      "--btnColor": color,
      "--customWidth": customWidth,
      "--btnMargin": margin,
      "--customHeight": customHeight,
      "--btnFlexShrink": flexShrink,
      "--btnFlex": flex,
      "--btnBorder": border,
      "--btnFont": fontSize,
      "--btnPadding": padding
    },
    disableState: disableState,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_LandingButton_style__WEBPACK_IMPORTED_MODULE_1__/* .BtnMainIcon */ .Am, {
      children: [btnMainIcon, customTitle]
    }), btnIcon && btnIcon, shimmerBtn && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_LandingButton_style__WEBPACK_IMPORTED_MODULE_1__/* .ShimmerWrap */ .vj, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
        src: "../../../images/shimmerBtn.svg"
      })
    })]
  });
});
/* harmony default export */ __webpack_exports__["Z"] = (LandingButton);

/***/ }),

/***/ 19:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7001);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);


var _excluded = ["children", "fontSize", "fontWeight", "color", "handleClick", "hrefProp", "textAlign", "margin", "id", "width", "display", "textTransform"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var AnchorTag = function AnchorTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      color = _ref.color,
      handleClick = _ref.handleClick,
      hrefProp = _ref.hrefProp,
      textAlign = _ref.textAlign,
      margin = _ref.margin,
      id = _ref.id,
      width = _ref.width,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? "inline-block" : _ref$display,
      textTransform = _ref.textTransform,
      rest = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .AnchorTagStyle */ .C2, _objectSpread(_objectSpread({
    id: id,
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    onClick: handleClick,
    href: hrefProp,
    margin: margin,
    width: width,
    display: display,
    textTransform: textTransform
  }, rest), {}, {
    children: children
  }));
}; // export const AnchorTag = styled.a<AnchorTagProps>`
//   font-family: 'Open Sans';
//   font-size:${props=>fontSize[props.fontSize]}
//   font-weight:${props=>fontWeight[props.fontWeight]}
//   margin: ${p => p.margin && p.margin};
//   display: inline-block;
//   color: ${p => p.color && p.color};
//   text-align: ${p => p.textAlign && p.textAlign};
// `;


/* harmony default export */ __webpack_exports__["Z"] = (AnchorTag);

/***/ }),

/***/ 8830:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7001);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);




var H3Tag = function H3Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  return /*#__PURE__*/_jsx(H3TagStyle, {
    style: {
      "--color": color,
      "--margin": margin
    },
    children: children
  });
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (H3Tag)));

/***/ }),

/***/ 7145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7001);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);




var H5Tag = function H5Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H5TagStyle */ .Wl, {
    style: {
      "--color": color,
      "--margin": margin
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (H5Tag);

/***/ }),

/***/ 8135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7001);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);




var ParaTag = function ParaTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000000" : _ref$color,
      margin = _ref.margin,
      textAlign = _ref.textAlign,
      lineHeight = _ref.lineHeight,
      dangerousText = _ref.dangerousText,
      id = _ref.id;
  return dangerousText ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .ParaTagStyle */ .OG, {
    id: id,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .ParaTagStyle */ .OG, {
    id: id,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ParaTag);

/***/ }),

/***/ 3634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7001);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);




var SpanTag = function SpanTag(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "black" : _ref$color,
      textAlign = _ref.textAlign,
      margin = _ref.margin,
      children = _ref.children,
      bgColor = _ref.bgColor,
      dangerousText = _ref.dangerousText,
      id = _ref.id,
      display = _ref.display,
      customWidth = _ref.customWidth;
  return dangerousText ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .SpanTagStyle */ .zs, {
    id: id,
    margin: margin,
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    bgColor: bgColor,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    display: display,
    customWidth: customWidth
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .SpanTagStyle */ .zs, {
    id: id,
    margin: margin,
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    bgColor: bgColor,
    display: display,
    customWidth: customWidth,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SpanTag);

/***/ }),

/***/ 7001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ AnchorTagStyle; },
/* harmony export */   "OG": function() { return /* binding */ ParaTagStyle; },
/* harmony export */   "Wl": function() { return /* binding */ H5TagStyle; },
/* harmony export */   "sz": function() { return /* binding */ H4TagStyle; },
/* harmony export */   "zs": function() { return /* binding */ SpanTagStyle; }
/* harmony export */ });
/* unused harmony exports H1TagStyle, H2TagStyle, H3TagStyle, H6TagStyle, CliptextStyleComp */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);


var renderFont = function renderFont(fontSize) {
  switch (fontSize) {
    case "xxs":
      return "\n          font-size: 10px;\n          line-height: 16px;\n        ";

    case "xs":
      return "\n          font-size: 12px;\n          line-height: 16px;\n        ";

    case "sm":
      return "\n          font-size: 14px;\n          line-height: 20px;\n        ";

    case "md":
      return "\n        font-size: 16px;\n        line-height: 22px;\n      ";

    case "large":
      return "\n          font-size: 18px;\n          line-height: 24px;\n        ";

    case "xlarge":
      return "\n        font-size: 22px;\n        line-height: 32px;\n      ";

    case "xxlarge":
      return "\n        font-size: 24px;\n        line-height: 32px;\n      ";

    case "xxxlarge":
      return "\n        font-size: 28px;\n        line-height: 32px;\n      ";

    default:
      return "\n      font-size: 14px;\n      line-height: 20px;\n    ";
  }
};

var renderFontWeight = function renderFontWeight(fontWeight) {
  switch (fontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "medium":
      return "\n        font-weight: 500;\n      ";

    case "semiBold":
      return "\n        font-weight: 600;\n      ";

    case "bold":
      return "\n        font-weight: 700;\n      ";

    case "extraBold":
      return "\n    font-weight: 800;\n  ";

    case "black":
      return "\n      font-weight: 900;\n        ";

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var H1TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({
  displayName: "TextStylesstyle__H1TagStyle",
  componentId: "tdz7k0-0"
})(["padding:0;font-size:56px;line-height:72px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);span{font-size:56px;line-height:72px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);}"]);
var H2TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "tdz7k0-1"
})(["padding:0;font-size:48px;line-height:64px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);"]);
var H3TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "tdz7k0-2"
})(["padding:0;font-size:40px;line-height:54px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);text-align:var(--textAlign,left);"]);
var H4TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "tdz7k0-3"
})(["padding:0;font-size:32px;line-height:40px;font-weight:500;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);"]);
var H5TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "tdz7k0-4"
})(["padding:0;font-size:24px;line-height:32px;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);font-weight:var(--fontWeight,500);span{font-size:24px;line-height:32px;font-family:\"Raleway\";font-weight:var(--fontWeight,500);}"]);
var H6TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "tdz7k0-5"
})(["padding:0;font-size:16px;line-height:25px;font-weight:var(--fontWeight,500);margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);"]);
var ParaTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "tdz7k0-6"
})(["padding:0;font-family:\"Open Sans\";", " ", " margin:", ";text-align:", ";color:", ";line-height:", ";"], function (p) {
  return p.fontSize ? "\n    ".concat(renderFont(p.fontSize), "\n  ") : "";
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  var _p$margin;

  return (_p$margin = p.margin) !== null && _p$margin !== void 0 ? _p$margin : 0;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.lineHeight && p.lineHeight;
});
var SpanTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "tdz7k0-7"
})(["font-family:\"Open Sans\";", " ", " display:", ";color:", ";margin:", ";text-align:", ";background-color:", ";width:", ";"], function (p) {
  return p.fontSize ? "".concat(renderFont(p.fontSize)) : "";
}, function (p) {
  return p.fontWeight && "".concat(renderFontWeight(p.fontWeight));
}, function (p) {
  var _p$display;

  return (_p$display = p.display) !== null && _p$display !== void 0 ? _p$display : "inline-block";
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.bgColor && p.bgColor;
}, function (p) {
  return p.customWidth && p.customWidth;
});
var AnchorTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "tdz7k0-8"
})(["color:#008cff;text-decoration:none;cursor:pointer;font-family:\"Open Sans\";", " ", " margin:", ";display:", ";color:", ";text-align:", ";width:", ";text-transform:", ";&:hover,&:focus{text-decoration:none;outline:none;}"], function (p) {
  return p.fontSize ? "".concat(renderFont(p.fontSize)) : "";
}, function (p) {
  return p.fontWeight && "".concat(renderFontWeight(p.fontWeight));
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.display && p.display;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.width && p.width;
}, function (p) {
  return p.textTransform && p.textTransform;
});
var CliptextStyleComp = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "TextStylesstyle__CliptextStyleComp",
  componentId: "tdz7k0-9"
})(["background:linear-gradient( 92.2deg,#ffe2e8 0.47%,#fffcfc 25.07%,#8cc8ea 64.68% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;width:fit-content;font-weight:600;margin:", ";"], function (props) {
  return props.margin && props.margin;
});

/***/ }),

/***/ 4575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rS": function() { return /* binding */ theme; }
/* harmony export */ });
/* unused harmony exports fontWeight, fontSize, lineHeight */
var theme = {
  blackText: "#000",
  blackText3: "#022135",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#2B825E",
  greenText6: "#007E7D",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "rgba(255, 255, 255, 0.8)",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  greenNeonText3: "#5EE8BA",
  blueText2: "#F6FAFF",
  darkGreen2: "#227055",
  greenBg: "rgba(43, 130, 94, 0.5)"
};
var fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
var fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
var lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};

/***/ }),

/***/ 5025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ BackIcon; }
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2269);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);


var _excluded = ["color", "cursor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var BackIcon = function BackIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#808080" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      cursor: cursor
    }
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z",
      fill: color
    })
  }));
};



/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);


var _excluded = ["color", "onPress", "cursor", "height", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var CloseIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#AFAFAF" : _ref$color,
      onPress = _ref.onPress,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      props = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    ref: ref,
    style: {
      cursor: cursor
    },
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: onPress
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M7.79967 17.8333L11.9997 13.6333L16.1997 17.8333L17.833 16.1999L13.633 11.9999L17.833 7.79992L16.1997 6.16659L11.9997 10.3666L7.79967 6.16659L6.16634 7.79992L10.3663 11.9999L6.16634 16.1999L7.79967 17.8333ZM11.9997 23.6666C10.3858 23.6666 8.86912 23.3601 7.44968 22.7473C6.03023 22.1351 4.79551 21.3041 3.74551 20.2541C2.69551 19.2041 1.86445 17.9694 1.25234 16.5499C0.639452 15.1305 0.333008 13.6138 0.333008 11.9999C0.333008 10.386 0.639452 8.86936 1.25234 7.44992C1.86445 6.03048 2.69551 4.79575 3.74551 3.74575C4.79551 2.69575 6.03023 1.86431 7.44968 1.25142C8.86912 0.639307 10.3858 0.333252 11.9997 0.333252C13.6136 0.333252 15.1302 0.639307 16.5497 1.25142C17.9691 1.86431 19.2038 2.69575 20.2538 3.74575C21.3038 4.79575 22.1349 6.03048 22.747 7.44992C23.3599 8.86936 23.6663 10.386 23.6663 11.9999C23.6663 13.6138 23.3599 15.1305 22.747 16.5499C22.1349 17.9694 21.3038 19.2041 20.2538 20.2541C19.2038 21.3041 17.9691 22.1351 16.5497 22.7473C15.1302 23.3601 13.6136 23.6666 11.9997 23.6666Z",
      fill: color
    })
  }));
});

/***/ }),

/***/ 8403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ib": function() { return /* binding */ landingForexOfferingCardData; },
/* harmony export */   "uW": function() { return /* binding */ persuasionData; }
/* harmony export */ });
/* unused harmony exports landingCardFaqData, landingFaqData, landingFaqDataV2Generator, poweredByLogos */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2638);

var persuasionData = [{
  id: "1",
  boldText: "Best rates.",
  normalText: "Upto 10% savings over Airport Counter rates"
}, {
  id: "2",
  boldText: "100+ RBI-licensed money changes",
  normalText: "across 50+ cities"
}, {
  id: "3",
  boldText: "Attractive offers",
  normalText: "& cashback"
}]; // aboveText?: string;
// pointsList?: { id: string; label: string; info: string }[];
// belowText?: string;
//ADDTHEM

var landingCardFaqData = [{
  ques: "What is a Forex Card?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "A Forex Card is a prepaid card designed specifically for international travelers. It is fully compliant with RBI regulations and provides peace of mind with 100% acceptance at all merchants in over 150 countries. It also provides digital controls within the app, allowing you to lock/unlock the card instantly and offers several benefits, without the need to link your bank account to the card."
    }, {
      id: _constants__WEBPACK_IMPORTED_MODULE_0__/* .FAQ_CLICK_HERE_LINK_ID.WHAT_IS_MX_CARD_CLICK_HERE */ .HY.WHAT_IS_MX_CARD_CLICK_HERE,
      linkText: "Click here"
    }, {
      id: "1",
      text: "to know more."
    }]
  }]
}, {
  ques: "Who should use Forex Card?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "Forex Card is ideal for anyone who values peace of mind during international trips and wants to avoid all forex markups and hidden charges."
    }]
  }]
}, {
  ques: "Is there any documentation or KYC required?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket after making payment for forex transactions on Makemytrip. These will be verified before processing the order."
    }]
  }]
}, {
  ques: "Why should I not use a Debit/Credit card instead?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "Using a Debit/Credit card for international transactions may come with several drawbacks such as high markups (up to 5%), additional service charges, hidden fees, low acceptance at certain places, higher risk of scams, potential misuse in case of loss, negative impact on your CIBIL score, and fluctuating exchange rates. You can avoid all these by opting for Forex Card."
    }]
  }]
}, {
  ques: "Does this card give reward points?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "No, this card does not offer reward points. However, it is still the most rewarding option due to its lowest forex rates and cashback offers."
    }]
  }]
}, {
  ques: "How do I get this card?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "You can easily order this card online within 2 minutes. Simply enter your PAN (Permanent Account Number) and delivery address, and the card will be delivered to your doorstep within 48 hours."
    }, {
      id: _constants__WEBPACK_IMPORTED_MODULE_0__/* .FAQ_CLICK_HERE_LINK_ID.HOW_TO_GET_CARD_CLICK_HERE */ .HY.HOW_TO_GET_CARD_CLICK_HERE,
      linkText: "Click here"
    }, {
      id: "1",
      text: "to order now."
    }]
  }]
}, {
  ques: "How can I load money into my card?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "You can load money instantly using UPI, NetBanking, and Debit Card. You can top up your card anytime, even during your international trip.                                                                                                                                                                                                             "
    }]
  }]
}, {
  ques: "What if I don\u2019t want to use the card later?",
  answer: [{
    id: "1",
    aboveTextList: [{
      id: "1",
      text: "If you no longer wish to use the card, you have the option to withdraw the unused money instantly. Additionally, you can choose to temporarily lock the card or close it anytime."
    }]
  }]
}];
var FAQ_IDS = {
  CARD_FAQ: "card_faq",
  CURRENCY_FAQ: "currency_faq"
};
var landingFaqData = (/* unused pure expression or super */ null && (landingCardFaqData));
var landingFaqDataV2Generator = function landingFaqDataV2Generator(partner) {
  return [{
    faqData: landingCardFaqData,
    id: FAQ_IDS.CARD_FAQ,
    label: "Forex Card",
    isSelected: true
  }, {
    faqData: landingCurrencyFaqDataGenerator(partner),
    id: FAQ_IDS.CURRENCY_FAQ,
    label: "Foreign Currency",
    isSelected: false
  }];
};

var landingCurrencyFaqDataGenerator = function landingCurrencyFaqDataGenerator(partner) {
  return [{
    ques: "Who should buy foreign currency notes?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Every international traveller should purchase some foreign currency notes, before their trip. Currency notes are always a good option to prevent any potential inconvenience while spending in a foreign country, especially in case your forex or credit card are not accepted in some outlets or for local conveyance. "
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "Why should I buy foreign currency notes from ".concat(partner === PARTNER.GI ? "Goibibo" : "Makemytrip", "?"),
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "We offer best exchange rates, genuine notes from RBI licensed companies, doorstep delivery across 50+ cities, 40+ currencies available, instant customer support and many more.  "
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "How can I place the order for currency notes?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Ordering foreign currency notes through MakeMyTrip takes just two minutes. All you need to do is provide the currency and amount required, along with your PAN and address details. That's it! Your currency notes will be delivered to your address within the specified time. "
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "How many days before travel should I buy currency notes?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Purchasing foreign currency notes well in advance of your travel is a prudent practice to prevent potential stock shortages, unforeseen delays, or fluctuations in exchange rates. You can buy foreign currency notes within 60 days of your trip start date. Advance purchase prior to this 60-day period is not allowed. "
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "What’s my foreign exchange entitlement (limit) for personal / leisure travel?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Not exceeding US Dollars 2,50,000 in a financial year. If not consumed any part of it for any other purpose stated as per RBI's guidelines covering the new liberalized Remittance Scheme (LRS). Limit can be utilized in one or more visits abroad for personal/leisure purposes. <br/> <br/>\n  \n  If an individual has already remitted any amount under the Liberalized Remittance Scheme in a financial year, then the applicable limit for traveling purposes for such an individual would be reduced from USD 250,000 by the amount so remitted "
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "Is there a separate limit for carrying currency notes?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Travelers are allowed to purchase foreign currency notes/coins only up to US$ 3000 individually. Exceptions to this rule are the following:\u202F <br/> <br/>\n  \n  (a) travellers proceeding to Iraq and Libya can draw foreign exchange in the form of foreign currency notes and coins not exceeding US$ 5000 or its equivalent\u202F <br/> <br/>\n  \n  (b) travellers proceeding to the Islamic Republic of Iran, the Russian Federation, and other Republics of the Commonwealth of Independent States who can draw entire foreign exchange in the form of foreign currency notes or coins. <br/> <br/>\n  \n  (c ) For travelers proceeding for Haj/ Umrah pilgrimage, the full amount of BTQ entitlement (USD 250, 000) in cash or up to the cash limit as specified by the Haj Committee of India, may be released by the ADs and FFMCs. <br/> <br/>\n  \n  Minimum order limit for foreign currency is set at INR 3000 "
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "Is there any documentation or KYC required?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket and Visa (if not on arrival), after making payment for forex transactions on Makemytrip. These will be verified before processing the order. "
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "Can I sell back my left over foreign currency notes?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Any remaining foreign currency notes that you have after your international trip can be conveniently exchanged through the BookMyForex app or website. This allows you to convert your leftover foreign currency back into your home currency, ensuring that your funds don't go to waste."
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }, {
    ques: "Is there anything else I should be aware of while purchasing foreign currency notes?",
    answer: [{
      id: "1",
      aboveTextList: [{
        id: "1",
        text: "Yes, you should make payment for forex transactions from traveller\u2019s bank account, whose PAN number is provided. As per RBI guidelines, name in PAN should match with the Bank account holder name."
      }, {
        id: FAQ_CLICK_HERE_LINK_ID.ORDER_CURRENCY_CLICK_HERE,
        linkText: "Click here to order now!"
      }]
    }]
  }];
};

var poweredByLogos = [{
  logoSrc: "https://tripmoneycmsimgak.mmtcdn.com/img/bmf_transaprent_2_ee2f21b3a8.png",
  width: 130
}];
var landingForexOfferingCardData = [// {
//     id: CARD_TYPE.INR_CARD,
//     cardTitle: 'Global Cash Card',
//     cardInfo: 'for Casual Travelers',
//     cardImg: 'https://tripmoneycmsimgak.mmtcdn.com/img/Global_Cash_Card_edf224f322.png',
//     cardFeatList: [
//         {
//             id: '1',
//             boldText: '',
//             normalText: 'No pre-load required',
//         },
//         {
//             id: '2',
//             boldText: '',
//             normalText: 'Spend globally at no forex mark-up',
//         },
//         {
//             id: '3',
//             boldText: '',
//             normalText: 'Manage card digitally on the app',
//         },
//     ],
//     ctaTxt: 'Proceed',
// },
{
  id: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.MULTI_CURRENCY_CARD */ .WK.MULTI_CURRENCY_CARD,
  cardTitle: "Forex Card",
  // cardInfo: '', //'for Business Travelers',
  cardImg: "https://tripmoneycmsimgak.mmtcdn.com/img/tilted_bmf_card_953aed2863.png",
  cardFeatList: [{
    id: "1",
    boldText: "Zero forex markup.",
    normalText: "Get actual interbank rates"
  }, {
    id: "2",
    boldText: "No hidden charges.",
    normalText: "Zero reload, unload & annual fee"
  }, {
    id: "3",
    boldText: "Save upto 5%",
    normalText: "over your Credit/Debit cards"
  }],
  ctaTxt: "Know More"
}, {
  id: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.CURRENCY */ .WK.CURRENCY,
  cardTitle: "Foreign Currency Notes",
  // cardInfo: '', //'for Last Minute Plans',
  cardImg: "https://tripmoneycmsimgak.mmtcdn.com/img/Mask_group2_9e45a9dc44.svg",
  cardFeatList: [{
    id: "1",
    boldText: "40+ currencies available.",
    normalText: "Genuine currency notes"
  }, {
    id: "2",
    boldText: "Best exchange rates.",
    normalText: "Lowest rates in the market"
  }, {
    id: "3",
    boldText: "100+ RBI-licensed money changers",
    normalText: "across 50+ cities"
  }],
  ctaTxt: "Order Now"
}];

/***/ }),

/***/ 8333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vO": function() { return /* binding */ deviceType; },
  "O8": function() { return /* binding */ getFutureDate; },
  "HG": function() { return /* binding */ getMobileOperatingSystem; },
  "Xu": function() { return /* reexport */ redirectInterceptHref; }
});

// UNUSED EXPORTS: MONTHS, SHORT_WEEK_DAYS, breakpoint, fetchutmParamsFromCookie, formUrlForRedirection, getDeviceType, persistutmParamsInCookie

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/types/index.ts
var types_DEVICE_TYPE;

(function (DEVICE_TYPE) {
  DEVICE_TYPE["DESKTOP"] = "desktop";
  DEVICE_TYPE["MOBILE"] = "mobile";
  DEVICE_TYPE["TABLET"] = "tablet";
})(types_DEVICE_TYPE || (types_DEVICE_TYPE = {}));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(2151);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/utils/redirectionUtils.ts



var UTM_SOURCE = constants/* UTM_PARAMS_KEY.UTM_SOURCE */.J6.UTM_SOURCE,
    UTM_CAMPAIGN = constants/* UTM_PARAMS_KEY.UTM_CAMPAIGN */.J6.UTM_CAMPAIGN,
    UTM_MEDIUM = constants/* UTM_PARAMS_KEY.UTM_MEDIUM */.J6.UTM_MEDIUM,
    UTM_CONTENT = constants/* UTM_PARAMS_KEY.UTM_CONTENT */.J6.UTM_CONTENT,
    UTM_LENDER = constants/* UTM_PARAMS_KEY.UTM_LENDER */.J6.UTM_LENDER,
    UTM_LOGIN = constants/* UTM_PARAMS_KEY.UTM_LOGIN */.J6.UTM_LOGIN,
    UTM_FLOW = constants/* UTM_PARAMS_KEY.UTM_FLOW */.J6.UTM_FLOW;
var persistutmParamsInCookie = function persistutmParamsInCookie(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, utm_flow) {
  if (!!utm_source && utm_source != null && utm_source !== "video-kycookieCutter.happay.in") {
    setCookie(UTM_SOURCE, utm_source, false, {
      path: "/"
    });
  }

  if (!!utm_medium && utm_medium != null && utm_medium !== "referral") {
    setCookie(UTM_MEDIUM, utm_medium, false, {
      path: "/"
    });
  }

  if (!!utm_campaign && utm_campaign != null) {
    setCookie(UTM_CAMPAIGN, utm_campaign, false, {
      path: "/"
    });
  }

  if (!!utm_lender && utm_lender != null) {
    setCookie(UTM_LENDER, utm_lender, false, {
      path: "/"
    });
  }

  if (!!utm_login && utm_login != null) {
    setCookie(UTM_LOGIN, utm_login, false, {
      path: "/"
    });
  }

  if (!!utm_content && utm_content != null) {
    setCookie(UTM_CONTENT, utm_content, false, {
      path: "/"
    });
  }

  if (!!utm_flow && utm_flow != null) {
    setCookie(UTM_FLOW, utm_flow, false, {
      path: "/"
    });
  }
};
var fetchutmParamsFromCookie = function fetchutmParamsFromCookie() {
  var utm_medium = (0,cookieUtils/* getCookie */.ej)(UTM_MEDIUM, false, {
    path: "/"
  });
  var utm_source = (0,cookieUtils/* getCookie */.ej)(UTM_SOURCE, false, {
    path: "/"
  });
  var utm_campaign = (0,cookieUtils/* getCookie */.ej)(UTM_CAMPAIGN, false, {
    path: "/"
  });
  var utm_lender = (0,cookieUtils/* getCookie */.ej)(UTM_LENDER, false, {
    path: "/"
  });
  var utm_login = (0,cookieUtils/* getCookie */.ej)(UTM_LOGIN, false, {
    path: "/"
  });
  var utm_content = (0,cookieUtils/* getCookie */.ej)(UTM_CONTENT, false, {
    path: "/"
  });
  var utm_flow = (0,cookieUtils/* getCookie */.ej)(UTM_FLOW, false, {
    path: "/"
  });
  return {
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaign: utm_campaign,
    utm_lender: utm_lender,
    utm_login: utm_login,
    utm_content: utm_content,
    utm_flow: utm_flow
  };
};
var formUrlForRedirection = function formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, utm_flow) {
  var urlParam = "";

  if (utm_source) {
    if (!urlParam) {
      urlParam = urlParam + "utm_source=" + utm_source;
    } else {
      urlParam = urlParam + "utm_source=" + utm_source;
    }
  }

  if (utm_medium) {
    if (!urlParam) {
      urlParam = urlParam + "utm_medium=" + utm_medium;
    } else {
      urlParam = urlParam + "&utm_medium=" + utm_medium;
    }
  }

  if (utm_campaign) {
    if (!urlParam) {
      urlParam = urlParam + "utm_campaign=" + utm_campaign;
    } else {
      urlParam = urlParam + "&utm_campaign=" + utm_campaign;
    }
  }

  if (utm_lender) {
    if (!urlParam) {
      urlParam = urlParam + "utm_lender=" + utm_lender;
    } else {
      urlParam = urlParam + "&utm_lender=" + utm_lender;
    }
  }

  if (utm_login) {
    if (!urlParam) {
      urlParam = urlParam + "utm_login=" + utm_login;
    } else {
      urlParam = urlParam + "&utm_login=" + utm_login;
    }
  }

  if (utm_content) {
    if (!urlParam) {
      urlParam = urlParam + "utm_content=" + utm_content;
    } else {
      urlParam = urlParam + "&utm_content=" + utm_content;
    }
  }

  if (utm_flow) {
    if (!urlParam) {
      urlParam = urlParam + "utm_flow=" + utm_flow;
    } else {
      urlParam = urlParam + "&utm_flow=" + utm_flow;
    }
  }

  return urlParam;
};
var redirectInterceptHref = function redirectInterceptHref(url) {
  var hideParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _fetchutmParamsFromCo = fetchutmParamsFromCookie(),
      utm_source = _fetchutmParamsFromCo.utm_source,
      utm_medium = _fetchutmParamsFromCo.utm_medium,
      utm_campaign = _fetchutmParamsFromCo.utm_campaign,
      utm_lender = _fetchutmParamsFromCo.utm_lender,
      utm_login = _fetchutmParamsFromCo.utm_login,
      utm_content = _fetchutmParamsFromCo.utm_content,
      utm_flow = _fetchutmParamsFromCo.utm_flow;

  var urlParam = formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, utm_flow);
  var isHostMakeMyTrip = (0,utils.getHostName)() === constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP;

  if (url && !hideParam) {
    if (url.includes("?")) {
      url = url + "&" + urlParam;
    } else {
      url = url + "?" + urlParam;
    }
  }

  if (isHostMakeMyTrip && !hideParam) {
    if (url.endsWith("&") || url.endsWith("?")) {
      url += "mmt_forex=true";
    } else {
      url += "&mmt_forex=true";
    }
  }

  window.location.href = url;
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx

 // RESPONSIVE BREAKPOINTS

var breakpoint = {
  mobile: 768
};
var deviceType = {
  mobile: "(max-width: ".concat(breakpoint.mobile, "px)"),
  desktop: "(min-width: ".concat(breakpoint.mobile, "px)")
};
var MONTHS = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]));
var SHORT_WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

var getSuffix = function getSuffix(dayNo) {
  if (dayNo > 3 && dayNo < 21) return "th";

  switch (dayNo % 10) {
    case 1:
      return "st";

    case 2:
      return "nd";

    case 3:
      return "rd";

    default:
      return "th";
  }
};

var getFutureDate = function getFutureDate() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; // Get today's date

  var today = new Date();
  var tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + count); // Get the month name from the monthNames array

  var monthName = monthNames[tomorrow.getMonth()]; // Output the date in the desired format

  var date = tomorrow.getDate();
  var year = tomorrow.getFullYear();
  var suffix = getSuffix(date);
  return {
    date: date,
    year: year,
    monthName: monthName,
    suffix: suffix,
    day: SHORT_WEEK_DAYS[tomorrow.getDay()]
  };
};
function getDeviceType(userAgent) {
  var mobileRegex = new RegExp(/Mobile|Android|BlackBerry/);
  var tabletRegex = new RegExp(/iPad|(Android(?!.*Mobile))|Tablet|PlayBook|Kindle|GT-P1000|SCH-I800|sholes|Xoom|Libero|\b4G\b/);

  if (userAgent.match(mobileRegex)) {
    return DEVICE_TYPE.MOBILE;
  } else if (userAgent.match(tabletRegex)) {
    return DEVICE_TYPE.TABLET;
  }

  return DEVICE_TYPE.DESKTOP;
}
var getMobileOperatingSystem = function getMobileOperatingSystem() {
  var _navigator, _navigator2, _window;

  //@ts-ignore
  var userAgent = !(0,utils.isOnServer)() ? ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.vendor) || ((_window = window) === null || _window === void 0 ? void 0 : _window.opera) : null; // Windows Phone must come first because its UA also contains "Android"

  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710
  //@ts-ignore


  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};


/***/ }),

/***/ 7377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "au": function() { return /* binding */ fetchDeliveryDetailsAction; },
  "kD": function() { return /* binding */ fetchForexCurrencyRateAction; },
  "K$": function() { return /* binding */ fetchingListingPageOnLocationChange; },
  "Pd": function() { return /* binding */ loadingListingPageOnLocationChange; }
});

// UNUSED EXPORTS: errorCardCtaSignalState, errorFetchingDeliveryDetails, errorFetchingListingPageOnLocationChange, fetchedPersonaAndVersionOnLoad, fetchingCardCtaSignalState, fetchingCrossSellDataState, loadingCardCtaSignalState, loadingDeliveryDetailsAction, updateForceLoginEmailModal

;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/store/actionType.ts
var GET_FOREX_LISTING_DATA = "GET_FOREX_LISTING_DATA";
var FETCH_FOREX_CURRENCY_RATE = "FETCH_FOREX_CURRENCY_RATE";
var actionType_IS_LOADING_DELIVERY_DETAILS = "IS_LOADING_DELIVERY_DETAILS";
var FETCH_DELIVERY_DETAILS = "FETCH_DELIVERY_DETAILS";
var actionType_IS_ERROR_FETCHING_DELIVERY_DETAILS = "IS_ERROR_FETCHING_DELIVERY_DETAILS";
var FETCH_PRODUCTS = "FETCH_PRODUCTS";
var LOADING_LISTING_PAGE_LOCATION_CHANGE = "LOADING_LISTING_PAGE_LOCATION_CHANGE";
var FETCH_LISTING_PAGE_LOCATION_CHANGE = "FETCH_LISTING_PAGE_LOCATION_CHANGE";
var actionType_ERROR_LISTING_PAGE_LOCATION_CHANGE = "ERROR_LISTING_PAGE_LOCATION_CHANGE";
var actionType_LOADING_CARD_CTA_SIGNAL_STATE = "LOADING_CARD_CTA_SIGNAL_STATE";
var actionType_FETCH_CARD_CTA_SIGNAL_STATE = "FETCH_CARD_CTA_SIGNAL_STATE";
var actionType_ERROR_CARD_CTA_SIGNAL_STATE = "ERROR_CARD_CTA_SIGNAL_STATE";
var actionType_PERSONA_AND_VERSION_FETCHED_ON_LOAD = "PERSONA_AND_VERSION_FETCHED_ON_LOAD";
var actionType_UPDATE_LOGIN_EMAIL_MODAL_STATE = "UPDATE_LOGIN_EMAIL_MODAL_STATE";
var actionType_FETCH_CROSS_SELL_DATA = "FETCH_CROSS_SELL_DATA";
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/store/action.ts

var fetchForexCurrencyRateAction = function fetchForexCurrencyRateAction(payload) {
  return {
    type: FETCH_FOREX_CURRENCY_RATE,
    payload: payload
  };
}; // Delivery details

var loadingDeliveryDetailsAction = function loadingDeliveryDetailsAction() {
  return {
    type: IS_LOADING_DELIVERY_DETAILS
  };
};
var fetchDeliveryDetailsAction = function fetchDeliveryDetailsAction(payload) {
  return {
    type: FETCH_DELIVERY_DETAILS,
    payload: payload
  };
};
var fetchedPersonaAndVersionOnLoad = function fetchedPersonaAndVersionOnLoad(payload) {
  return {
    type: PERSONA_AND_VERSION_FETCHED_ON_LOAD,
    payload: payload
  };
};
var errorFetchingDeliveryDetails = function errorFetchingDeliveryDetails(payload) {
  return {
    type: IS_ERROR_FETCHING_DELIVERY_DETAILS,
    payload: payload
  };
}; // Fetch Listing page once pincode or location detected changes.

var loadingListingPageOnLocationChange = function loadingListingPageOnLocationChange() {
  return {
    type: LOADING_LISTING_PAGE_LOCATION_CHANGE
  };
};
var fetchingListingPageOnLocationChange = function fetchingListingPageOnLocationChange(payload) {
  return {
    type: FETCH_LISTING_PAGE_LOCATION_CHANGE,
    payload: payload
  };
};
var errorFetchingListingPageOnLocationChange = function errorFetchingListingPageOnLocationChange(payload) {
  return {
    type: ERROR_LISTING_PAGE_LOCATION_CHANGE,
    payload: payload
  };
}; // Fetching Card CTA signal state actions

var loadingCardCtaSignalState = function loadingCardCtaSignalState() {
  return {
    type: LOADING_CARD_CTA_SIGNAL_STATE
  };
};
var fetchingCardCtaSignalState = function fetchingCardCtaSignalState(payload, options) {
  return {
    type: FETCH_CARD_CTA_SIGNAL_STATE,
    payload: payload,
    options: options
  };
};
var fetchingCrossSellDataState = function fetchingCrossSellDataState(payload) {
  return {
    type: FETCH_CROSS_SELL_DATA,
    payload: payload
  };
};
var errorCardCtaSignalState = function errorCardCtaSignalState(payload, options) {
  return {
    type: ERROR_CARD_CTA_SIGNAL_STATE,
    payload: payload,
    options: options
  };
};
var updateForceLoginEmailModal = function updateForceLoginEmailModal(payload) {
  return {
    type: UPDATE_LOGIN_EMAIL_MODAL_STATE,
    payload: payload
  };
};

/***/ }),

/***/ 277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports isUserLoggedInFn, logoutFromPartner, loginInPartner */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tm_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4178);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var generateTmAuth = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", loginIfPartnerLoggedin());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function generateTmAuth() {
    return _ref.apply(this, arguments);
  };
}()));

function tmAuthDataHasMobileError(tmAuthData) {
  var _tmAuthData$appSocial, _tmAuthData$appSocial2;

  return (tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$appSocial = tmAuthData.appSocialToken) === null || _tmAuthData$appSocial === void 0 ? void 0 : (_tmAuthData$appSocial2 = _tmAuthData$appSocial.error) === null || _tmAuthData$appSocial2 === void 0 ? void 0 : _tmAuthData$appSocial2.code) === "4401";
}

var isUserLoggedInFn = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var sendPdtAppSocialError, sendPdtLoginTokenError, sendPdtAppSocialErrorV2, sendPdtLoginTokenErrorV2;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            sendPdtAppSocialError = _ref2.sendPdtAppSocialError, sendPdtLoginTokenError = _ref2.sendPdtLoginTokenError, sendPdtAppSocialErrorV2 = _ref2.sendPdtAppSocialErrorV2, sendPdtLoginTokenErrorV2 = _ref2.sendPdtLoginTokenErrorV2;
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var _window, _window$auth;

              //@ts-ignore
              if (!((_window = window) !== null && _window !== void 0 && (_window$auth = _window.auth) !== null && _window$auth !== void 0 && _window$auth.status)) {
                //@ts-ignore
                window.auth = {
                  status: true
                };
                isPartnerLoggedIn().then( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(isPartnerLogIn) {
                    var isloggedIn, _tmAuthData$loginToke, _tmAuthData$appSocial3, tmAuthData, _tmAuthData$loginToke2, _tmAuthData$appSocial4, _tmAuthData$loginToke3, _tmAuthData$loginToke4, _tmAuthData$appSocial5, _tmAuthData$appSocial6;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return isUserLoggedin();

                          case 2:
                            isloggedIn = _context2.sent;

                            if (!(isPartnerLogIn && !isloggedIn)) {
                              _context2.next = 13;
                              break;
                            }

                            _context2.next = 6;
                            return generateTmAuth();

                          case 6:
                            tmAuthData = _context2.sent;

                            if ((tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$loginToke = tmAuthData.loginToken) === null || _tmAuthData$loginToke === void 0 ? void 0 : _tmAuthData$loginToke.success) === false || (tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$appSocial3 = tmAuthData.appSocialToken) === null || _tmAuthData$appSocial3 === void 0 ? void 0 : _tmAuthData$appSocial3.success) === false) {
                              if ((tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$loginToke2 = tmAuthData.loginToken) === null || _tmAuthData$loginToke2 === void 0 ? void 0 : _tmAuthData$loginToke2.success) === false) {
                                sendPdtLoginTokenError(_objectSpread(_objectSpread({}, tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$loginToke3 = tmAuthData.loginToken) === null || _tmAuthData$loginToke3 === void 0 ? void 0 : _tmAuthData$loginToke3.error), {}, {
                                  apiUrl: "loginTokenApi"
                                }));
                                sendPdtLoginTokenErrorV2(_objectSpread(_objectSpread({}, tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$loginToke4 = tmAuthData.loginToken) === null || _tmAuthData$loginToke4 === void 0 ? void 0 : _tmAuthData$loginToke4.error), {}, {
                                  apiUrl: "loginTokenApi"
                                }));
                              }

                              if ((tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$appSocial4 = tmAuthData.appSocialToken) === null || _tmAuthData$appSocial4 === void 0 ? void 0 : _tmAuthData$appSocial4.success) === false) {
                                sendPdtAppSocialError(_objectSpread(_objectSpread({}, tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$appSocial5 = tmAuthData.appSocialToken) === null || _tmAuthData$appSocial5 === void 0 ? void 0 : _tmAuthData$appSocial5.error), {}, {
                                  apiUrl: "appSocialLoginApi"
                                }));
                                sendPdtAppSocialErrorV2(_objectSpread(_objectSpread({}, tmAuthData === null || tmAuthData === void 0 ? void 0 : (_tmAuthData$appSocial6 = tmAuthData.appSocialToken) === null || _tmAuthData$appSocial6 === void 0 ? void 0 : _tmAuthData$appSocial6.error), {}, {
                                  apiUrl: "appSocialLoginApi"
                                }));
                              } //@ts-ignore


                              window.auth = {
                                status: false
                              };
                              resolve({
                                loggedIn: false,
                                mobileRequiredError: tmAuthDataHasMobileError(tmAuthData)
                              });
                            }

                            _context2.next = 10;
                            return isUserLoggedin();

                          case 10:
                            isloggedIn = _context2.sent;
                            //@ts-ignore
                            window.auth = {
                              status: false
                            };
                            resolve({
                              loggedIn: !!isloggedIn,
                              mobileRequiredError: tmAuthDataHasMobileError(tmAuthData)
                            });

                          case 13:
                            //@ts-ignore
                            window.auth = {
                              status: false
                            };
                            resolve({
                              loggedIn: !!isloggedIn,
                              mobileRequiredError: false
                            });

                          case 15:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }());
              }
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function isUserLoggedInFn(_x) {
    return _ref3.apply(this, arguments);
  };
}()));
var logoutFromPartner = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return logout();

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function logoutFromPartner() {
    return _ref5.apply(this, arguments);
  };
}()));
var loginInPartner = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sendPdtLoginPopOpen, sendPdtLoginPopupOpenV2) {
    var data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return sendPdtLoginPopOpen === null || sendPdtLoginPopOpen === void 0 ? void 0 : sendPdtLoginPopOpen();

          case 2:
            _context5.next = 4;
            return sendPdtLoginPopupOpenV2 === null || sendPdtLoginPopupOpenV2 === void 0 ? void 0 : sendPdtLoginPopupOpenV2();

          case 4:
            _context5.next = 6;
            return loginToPartner();

          case 6:
            data = _context5.sent;
            return _context5.abrupt("return", data);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function loginInPartner(_x3, _x4) {
    return _ref6.apply(this, arguments);
  };
}()));

/***/ }),

/***/ 4743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HG": function() { return /* binding */ getMobileOperatingSystem; },
/* harmony export */   "IP": function() { return /* binding */ ANDROID; },
/* harmony export */   "z7": function() { return /* binding */ IOS; }
/* harmony export */ });
/* unused harmony exports MakeMyTrip, GRANTED, GEOLOCATION */
var getMobileOperatingSystem = function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710


  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};
var ANDROID = "android";
var IOS = "ios";
var MakeMyTrip = "mmt";
var GRANTED = "granted";
var GEOLOCATION = "geolocation";

/***/ }),

/***/ 6787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ BridgeMethods; }
/* harmony export */ });
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9666);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4743);


var USER_LOCATION_APP_STORAGE_KEY = "location";
/**
 * Function to get version of the app
 * @returns {String} AppVersion
 */

var getAppVersion = function getAppVersion() {
  if ((0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_0__.isOnServer)()) {
    return null;
  }

  var mobileOS = (0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getMobileOperatingSystem */ .HG)();
  var version = null;

  try {
    if (mobileOS.toLowerCase() === _common__WEBPACK_IMPORTED_MODULE_1__/* .ANDROID */ .IP) {
      var _window, _window$app_bridge, _window$app_bridge$ge;

      //@ts-ignore
      version = (_window = window) === null || _window === void 0 ? void 0 : (_window$app_bridge = _window.app_bridge) === null || _window$app_bridge === void 0 ? void 0 : (_window$app_bridge$ge = _window$app_bridge.getAppVersion) === null || _window$app_bridge$ge === void 0 ? void 0 : _window$app_bridge$ge.call(_window$app_bridge);
      var mmtAndroidAppVersion = {};

      if (version) {
        try {
          var _mmtAndroidAppVersion;

          mmtAndroidAppVersion = JSON.parse(decodeURIComponent(version));
          return (_mmtAndroidAppVersion = mmtAndroidAppVersion) === null || _mmtAndroidAppVersion === void 0 ? void 0 : _mmtAndroidAppVersion.app_version_name;
        } catch (e) {
          console.error("Error parsing app version. Got version: ".concat(version), e);
          return null;
        }
      }
    } else if (mobileOS.toLowerCase() === _common__WEBPACK_IMPORTED_MODULE_1__/* .IOS */ .z7) {
      var _window2, _window2$app_bridge;

      //@ts-ignore
      version = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$app_bridge = _window2.app_bridge) === null || _window2$app_bridge === void 0 ? void 0 : _window2$app_bridge.getAppVersion();
      return version;
    }
  } catch (e) {
    console.error("error while fetching app version: " + e);
    return null;
  }
};

var setUserLocationInAppStorage = function setUserLocationInAppStorage(data) {
  var _window3, _window3$app_bridge, _window4, _window4$webkit, _window4$webkit$messa;

  if ((_window3 = window) !== null && _window3 !== void 0 && (_window3$app_bridge = _window3.app_bridge) !== null && _window3$app_bridge !== void 0 && _window3$app_bridge.setInSessionStorage) {
    window.app_bridge.setInSessionStorage(USER_LOCATION_APP_STORAGE_KEY, JSON.stringify(data));
  } else if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$webkit = _window4.webkit) !== null && _window4$webkit !== void 0 && (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null && _window4$webkit$messa !== void 0 && _window4$webkit$messa.setUserSessionStorage) {
    window.webkit.messageHandlers.setUserSessionStorage.postMessage({
      key: USER_LOCATION_APP_STORAGE_KEY,
      value: JSON.stringify(data)
    });
  }
};

var openDeeplink = function openDeeplink(deeplink) {
  var mobileOS = (0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getMobileOperatingSystem */ .HG)();

  try {
    if (mobileOS.toLowerCase() === _common__WEBPACK_IMPORTED_MODULE_1__/* .ANDROID */ .IP) {
      var _window5, _window5$app_bridge;

      (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$app_bridge = _window5.app_bridge) === null || _window5$app_bridge === void 0 ? void 0 : _window5$app_bridge.openDeeplink(deeplink);
    } else if (mobileOS.toLowerCase() === _common__WEBPACK_IMPORTED_MODULE_1__/* .IOS */ .z7) {
      window.location.href = deeplink;
    }
  } catch (e) {
    console.error("error while executing close application: " + e);
  }
};

var BridgeMethods = {
  getAppVersion: getAppVersion,
  setUserLocationInAppStorage: setUserLocationInAppStorage,
  openDeeplink: openDeeplink
};

/***/ }),

/***/ 4556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D9": function() { return /* binding */ setSessionStorageItem; },
/* harmony export */   "St": function() { return /* binding */ getSessionStorageItem; },
/* harmony export */   "lD": function() { return /* binding */ removeSessionStorageItem; }
/* harmony export */ });
/* unused harmony exports setLocalStorage, getLocalStorage, deleteLocalStorage */
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(156);
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8456);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6198);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2638);
/* harmony import */ var _bridges__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6787);
// prettier-ignore
//@ts-ignore
 // prettier-ignore
//@ts-ignore





/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_3__.itemType.ES,
    N_ES = MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_3__.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
} // local storage utils


function setLocalStorage(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = getUtilOptions(options);
  setLocalStorageItem(key, value, options, getEssentialItemType(isEssential));
}
function getLocalStorage(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = getUtilOptions(options);
  return getLocalStorageItem(key, options, getEssentialItemType(isEssential));
}
function deleteLocalStorage(key) {
  removeLocalStorageItem(key);
} // sesstion storage utils

function setSessionStorageItem(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };

  if (key === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY */ .sO.USER_LOCATION_SESSION_KEY) {
    var transformedUserLocation = {
      locusCityCode: value.locus_city_code,
      pincode: value.pincode,
      detectionSource: value.detection_source
    };
    _bridges__WEBPACK_IMPORTED_MODULE_2__/* .BridgeMethods.setUserLocationInAppStorage */ .X.setUserLocationInAppStorage(transformedUserLocation);
  }

  options = (0,___WEBPACK_IMPORTED_MODULE_0__.getUtilOptions)(options);
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_4__.setItemBySession)(key, value, options, getEssentialItemType(isEssential));
}
function getSessionStorageItem(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = (0,___WEBPACK_IMPORTED_MODULE_0__.getUtilOptions)(options);
  return (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_4__.getItemBySession)(key, options, getEssentialItemType(isEssential));
}
function removeSessionStorageItem(key) {
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_4__.removeItemBySession)(key);
}

/***/ }),

/***/ 2151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "nJ": function() { return /* binding */ removeCookie; }
/* harmony export */ });
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8131);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6198);
// prettier-ignore
//@ts-ignore


/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.ES,
    N_ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
}

function setCookie(name, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  options = (0,___WEBPACK_IMPORTED_MODULE_0__.getUtilOptions)(options);
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.setCookie)(name, value, options, getEssentialItemType(isEssential));
}
function getCookie(name) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = (0,___WEBPACK_IMPORTED_MODULE_0__.getUtilOptions)(options);
  return (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.getCookie)(name, options, getEssentialItemType(isEssential));
}
function removeCookie(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.removeCookie)(name, options);
}

/***/ }),

/***/ 6198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addWebVitalsScript": function() { return /* binding */ addWebVitalsScript; },
/* harmony export */   "closeWebview": function() { return /* binding */ closeWebview; },
/* harmony export */   "formatDate": function() { return /* binding */ formatDate; },
/* harmony export */   "generateRequestId": function() { return /* binding */ generateRequestId; },
/* harmony export */   "getBaseUrlBasedOnDomains": function() { return /* binding */ getBaseUrlBasedOnDomains; },
/* harmony export */   "getCamelCaseStr": function() { return /* binding */ getCamelCaseStr; },
/* harmony export */   "getCardValue": function() { return /* binding */ getCardValue; },
/* harmony export */   "getComponentsPdt": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getComponentsPdt; },
/* harmony export */   "getContextUrl": function() { return /* binding */ getContextUrl; },
/* harmony export */   "getDeliveryDetailsPdtSchema": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getDeliveryDetailsPdtSchema; },
/* harmony export */   "getDeviceContext": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getDeviceContext; },
/* harmony export */   "getDeviceDetailsObject": function() { return /* binding */ getDeviceDetailsObject; },
/* harmony export */   "getDeviceId": function() { return /* binding */ getDeviceId; },
/* harmony export */   "getDeviceIdStatus": function() { return /* binding */ getDeviceIdStatus; },
/* harmony export */   "getDeviceType": function() { return /* binding */ getDeviceType; },
/* harmony export */   "getElementUniqueIds": function() { return /* binding */ getElementUniqueIds; },
/* harmony export */   "getEventDetails": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getEventDetails; },
/* harmony export */   "getEventTrackingContext": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getEventTrackingContext; },
/* harmony export */   "getHostName": function() { return /* binding */ getHostName; },
/* harmony export */   "getJourneyIdFromCookie": function() { return /* binding */ getJourneyIdFromCookie; },
/* harmony export */   "getPageContext": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getPageContext; },
/* harmony export */   "getPageName": function() { return /* binding */ getPageName; },
/* harmony export */   "getPageUrl": function() { return /* binding */ getPageUrl; },
/* harmony export */   "getPartnerFromUrl": function() { return /* binding */ getPartnerFromUrl; },
/* harmony export */   "getPdtLoggerMethods": function() { return /* reexport safe */ _pdtutils_pdtLogger__WEBPACK_IMPORTED_MODULE_15__._h; },
/* harmony export */   "getPlatform": function() { return /* binding */ getPlatform; },
/* harmony export */   "getPokusExpVersion": function() { return /* binding */ getPokusExpVersion; },
/* harmony export */   "getQueryParamsFromUrl": function() { return /* binding */ getQueryParamsFromUrl; },
/* harmony export */   "getRequestIdHeaders": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getRequestIdHeaders; },
/* harmony export */   "getSourceName": function() { return /* binding */ getSourceName; },
/* harmony export */   "getTmUserDetails": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getTmUserDetails; },
/* harmony export */   "getUserContext": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getUserContext; },
/* harmony export */   "getUtilOptions": function() { return /* binding */ getUtilOptions; },
/* harmony export */   "getVendorErrorDetails": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getVendorErrorDetails; },
/* harmony export */   "isAgentFlow": function() { return /* binding */ isAgentFlow; },
/* harmony export */   "isApiInvoked": function() { return /* binding */ isApiInvoked; },
/* harmony export */   "isHostMMT": function() { return /* binding */ isHostMMT; },
/* harmony export */   "isMobile": function() { return /* binding */ isMobile; },
/* harmony export */   "isOnServer": function() { return /* binding */ isOnServer; },
/* harmony export */   "isPartnerHost": function() { return /* binding */ isPartnerHost; },
/* harmony export */   "persistSpecificParamInCookie": function() { return /* binding */ persistSpecificParamInCookie; },
/* harmony export */   "redirectToListingPage": function() { return /* reexport safe */ _reactNativeUtils__WEBPACK_IMPORTED_MODULE_16__.MS; },
/* harmony export */   "removeEmptyKeys": function() { return /* binding */ removeEmptyKeys; },
/* harmony export */   "removeNullableField": function() { return /* binding */ removeNullableField; },
/* harmony export */   "setDefaultForexCardsData": function() { return /* binding */ setDefaultForexCardsData; },
/* harmony export */   "setJourneyIdInCookie": function() { return /* binding */ setJourneyIdInCookie; },
/* harmony export */   "setMmtRedirectionCookie": function() { return /* binding */ setMmtRedirectionCookie; },
/* harmony export */   "setPageContextHeaders": function() { return /* reexport safe */ _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.setPageContextHeaders; }
/* harmony export */ });
/* unused harmony exports getDevice, isApiRequestCompleted, getConfigUrl, getCrossSellApiUrl, getXpressRtApiUrl, getCardCtaSignalStateUrl, dispatchEmailLoginCustomEvent, shouldOpenMMTLogin, isPartnerLoggedIn, getHostFontFamily, getCookieExpiryTime, getUserDeviceOS, getUTMParamsFromQuery, setUtmParamsInCookie, deleteUtmParamsFromCookie, deleteCookiesWithPrefix, isApp, isValidJSON, disableEncrytionInWeb, getTimeZone, OFFER_TYPES, convertEpochToDate, toLocaleStringINRFormat */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8529);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2746);
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6353);
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(ua_parser_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6364);
/* harmony import */ var _mmt_web_vitals_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(807);
/* harmony import */ var MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8277);
/* harmony import */ var MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2638);
/* harmony import */ var _constants_defaultCardData_ts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5692);
/* harmony import */ var _cookieUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2151);
/* harmony import */ var _hooks_useRedirectionUrls__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4155);
/* harmony import */ var _static_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8333);
/* harmony import */ var _bridges__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6787);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5027);
/* harmony import */ var _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8156);
/* harmony reexport (checked) */ if(__webpack_require__.o(_pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__, "OMNITURE_MAP")) __webpack_require__.d(__webpack_exports__, { "OMNITURE_MAP": function() { return _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.OMNITURE_MAP; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__, "OMNI_EVENTS_MAP")) __webpack_require__.d(__webpack_exports__, { "OMNI_EVENTS_MAP": function() { return _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.OMNI_EVENTS_MAP; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__, "getCommonSeoOmniData")) __webpack_require__.d(__webpack_exports__, { "getCommonSeoOmniData": function() { return _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getCommonSeoOmniData; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__, "getPdtLoggerMethods")) __webpack_require__.d(__webpack_exports__, { "getPdtLoggerMethods": function() { return _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.getPdtLoggerMethods; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__, "redirectToListingPage")) __webpack_require__.d(__webpack_exports__, { "redirectToListingPage": function() { return _pdtutils_pdtutils__WEBPACK_IMPORTED_MODULE_14__.redirectToListingPage; } });
/* harmony import */ var _pdtutils_pdtLogger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5253);
/* harmony import */ var _reactNativeUtils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1876);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// @ts-ignore


 // @ts-ignore


var getVisitorId = (MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_3___default().getVisitorId);







var getDevice = function getDevice(isDesktop) {
  if (isDesktop != null) {
    return isDesktop ? "lg" : "sm";
  }

  return null;
}; // Function to get a value from session storage

function isOnServer() {
  if (false) {}

  return false;
}
var isApiInvoked = function isApiInvoked(isSuccess, isLoading, isError) {
  if (!(isSuccess || isLoading || isError)) {
    return false;
  }

  return true;
};
var getElementUniqueIds = function getElementUniqueIds(page, section) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return [page, section, element].filter(Boolean).join("_");
};
var isApiRequestCompleted = function isApiRequestCompleted(isSuccess, isError) {
  return isSuccess || isError;
};
function getContextUrl(partner) {
  return _constants__WEBPACK_IMPORTED_MODULE_4__/* .LISTING_API_PATH.replace */ .cg.replace(/\{partner\}/g, partner !== null && partner !== void 0 ? partner : "");
}
function getConfigUrl(partner) {
  return GET_CONFIG_API_PATH.replace(/\{partner\}/g, partner !== null && partner !== void 0 ? partner : "");
}
function getCrossSellApiUrl(partner) {
  return CROSS_SELL_API_PATH.replace(/\{partner\}/g, partner !== null && partner !== void 0 ? partner : "");
}
function getXpressRtApiUrl(partner) {
  return XPRESS_RT_API_PATH.replace(/\{partner\}/g, partner !== null && partner !== void 0 ? partner : "");
}
function getCardCtaSignalStateUrl(_ref) {
  var partner = _ref.partner,
      card_type = _ref.card_type;
  return CARD_CTA_FETCH_API_PATH.replace(/\{partner\}/g, partner !== null && partner !== void 0 ? partner : "").replace(/\{card_type\}/g, card_type !== null && card_type !== void 0 ? card_type : "");
}
function getHostName() {
  if (isOnServer()) {
    return null;
  }

  return window.location.hostname;
}
function getSourceName() {
  var _window$location$host, _window$location$host2;

  if (isOnServer()) {
    return null;
  }

  var hostName = window.location.hostname;
  var source = hostName === _constants__WEBPACK_IMPORTED_MODULE_4__/* .SOURCE.LOCALHOST */ .Hx.LOCALHOST ? hostName : (_window$location$host = window.location.hostname) === null || _window$location$host === void 0 ? void 0 : (_window$location$host2 = _window$location$host.split(".")) === null || _window$location$host2 === void 0 ? void 0 : _window$location$host2[1];

  if (!(0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Object.values(_constants__WEBPACK_IMPORTED_MODULE_4__/* .SOURCE */ .Hx)).includes(source)) {
    throw new Error("Wrong source name ".concat(source, " [getSourceName]"));
  }

  return source;
}
var getCamelCaseStr = function getCamelCaseStr(text) {
  var ans = text.toLowerCase();
  return ans.split(" ").reduce(function (s, c) {
    return s + (c.charAt(0).toUpperCase() + c.slice(1));
  });
};
var persistSpecificParamInCookie = function persistSpecificParamInCookie(specificParamKey, specificParamValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    path: "/"
  };
  (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .setCookie */ .d8)(specificParamKey, specificParamValue, true, options);
};
function dispatchEmailLoginCustomEvent(showModal) {
  document.dispatchEvent(new CustomEvent("emailLoginError", {
    detail: {
      showModal: showModal
    }
  }));
}
function shouldOpenMMTLogin() {
  return getHostName() === HOST.MAKEMYTRIP && !getCookie(COOKIES.MMT_AUTH_KEY, true);
}
var isPartnerLoggedIn = function isPartnerLoggedIn() {
  if (getCookie(COOKIES.GI_AUTH_KEY, true) || getCookie(COOKIES.MMT_AUTH_KEY, true)) {
    return true;
  }

  return false;
};
function setDefaultForexCardsData() {
  var forexCards = [];

  for (var _i = 0, _Object$entries = Object.entries(_constants_defaultCardData_ts__WEBPACK_IMPORTED_MODULE_5__/* .defaultForexCardsData */ .O); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (key !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .CARD_TYPE.INR_CARD */ .WK.INR_CARD) {
      forexCards.push((0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, value));
    }
  }

  return forexCards;
}
function getHostFontFamily(hostname) {
  switch (hostname) {
    case HOST.MAKEMYTRIP:
      return MMT_FONT_FAMILY;

    case HOST.GOIBIBO:
      return GOIBIBO_FONT_FAMILY;

    default:
      return TRIPMONEY_FONT_FAMILY;
  }
}
var getDeviceType = function getDeviceType() {
  if (isOnServer()) return null; // @ts-ignore

  if (window.mmt_android_bridge || window.app_bridge) {
    return _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_MODEL_TYPE.APP */ .Yr.APP;
  }

  return _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_MODEL_TYPE.WEB */ .Yr.WEB;
};
function getPlatform() {
  if (isOnServer()) return null;
  var deviceType = getDeviceType();

  if (deviceType === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_MODEL_TYPE.WEB */ .Yr.WEB) {
    if (isMobile()) {
      return _constants__WEBPACK_IMPORTED_MODULE_4__/* .PLATFORM.PWA */ .iw.PWA;
    }

    return _constants__WEBPACK_IMPORTED_MODULE_4__/* .PLATFORM.DESKTOP */ .iw.DESKTOP;
  }

  return _constants__WEBPACK_IMPORTED_MODULE_4__/* .PLATFORM.APP */ .iw.APP;
}
var isMobile = function isMobile() {
  var _window;

  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a ? a.substr(0, 4) : null)) check = true;
  })( // @ts-ignore
  !isOnServer() ? //@ts-ignore
  navigator.userAgent || navigator.vendor || ((_window = window) === null || _window === void 0 ? void 0 : _window.opera) : null);

  return check;
};
var closeWebview = function closeWebview() {
  var _window2, _window5, _window5$mmt_android_, _window$history;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      partner = _ref2.partner;

  if (getHostName() === _constants__WEBPACK_IMPORTED_MODULE_4__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP) {
    (0,_static_utils__WEBPACK_IMPORTED_MODULE_8__/* .redirectInterceptHref */ .Xu)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .MMT_URL */ .mx);
    return;
  }

  if (partner === _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.GI */ .RL.GI && getDeviceType() === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_MODEL_TYPE.WEB */ .Yr.WEB && (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .UTM_PARAMS_KEY.UTM_SOURCE */ .J6.UTM_SOURCE, false, {
    path: "/"
  }) === _constants__WEBPACK_IMPORTED_MODULE_4__/* .UTM_SOURCE_VALUE.BOTTOM_BAR */ .mu.BOTTOM_BAR) {
    (0,_hooks_useRedirectionUrls__WEBPACK_IMPORTED_MODULE_7__/* .redirectToTMLandingPage */ .C)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.GI */ .RL.GI);
    return;
  }

  var mobileos = (0,_static_utils__WEBPACK_IMPORTED_MODULE_8__/* .getMobileOperatingSystem */ .HG)(); //@ts-ignore

  if ((_window2 = window) !== null && _window2 !== void 0 && _window2.app_bridge) {
    if (mobileos.toLowerCase() === "android") {
      var _window3, _window3$app_bridge;

      //@ts-ignore
      (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$app_bridge = _window3.app_bridge) === null || _window3$app_bridge === void 0 ? void 0 : _window3$app_bridge.closeAndRefreshWebView();
    } else if (mobileos.toLowerCase() === "ios") {
      var _window4, _window4$webkit$messa, _window4$webkit$messa2;

      // @ts-ignore
      (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$webkit$messa = _window4.webkit.messageHandlers) === null || _window4$webkit$messa === void 0 ? void 0 : (_window4$webkit$messa2 = _window4$webkit$messa.closeAndRefreshWebView) === null || _window4$webkit$messa2 === void 0 ? void 0 : _window4$webkit$messa2.postMessage(JSON.stringify(true));
    }

    return; //@ts-ignore
  } else if ((_window5 = window) !== null && _window5 !== void 0 && (_window5$mmt_android_ = _window5.mmt_android_bridge) !== null && _window5$mmt_android_ !== void 0 && _window5$mmt_android_.closeWebView) {
    var _window6, _window6$mmt_android_;

    //@ts-ignore
    (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$mmt_android_ = _window6.mmt_android_bridge) === null || _window6$mmt_android_ === void 0 ? void 0 : _window6$mmt_android_.closeWebView(false);
    return;
  }

  (_window$history = window.history) === null || _window$history === void 0 ? void 0 : _window$history.back();
};
var getCookieExpiryTime = function getCookieExpiryTime(days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date.toUTCString();
};
var getUserDeviceOS = function getUserDeviceOS() {
  var _navigator, _navigator2, _window7, _ref3, _ref4, _window8;

  if (isOnServer()) {
    return null;
  } //@ts-ignore


  var userAgent = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.vendor) || ((_window7 = window) === null || _window7 === void 0 ? void 0 : _window7.opera);

  if ((_ref3 = /android/i) !== null && _ref3 !== void 0 && _ref3.test(userAgent)) {
    return DEVICE_OS.ANDROID;
  } //@ts-ignore


  if ((_ref4 = /iPad|iPhone|iPod/) !== null && _ref4 !== void 0 && _ref4.test(userAgent) && !((_window8 = window) !== null && _window8 !== void 0 && _window8.MSStream)) {
    return DEVICE_OS.IOS;
  }

  return DEVICE_OS.UNKNOWN;
};
var isPartnerHost = function isPartnerHost(partner) {
  var hostname = getHostName() || "";
  return hostname.includes(partner);
};
function getUTMParamsFromQuery() {
  var queryParams = new URLSearchParams(window.location.search);
  var utmParams = {};
  queryParams.forEach(function (value, key) {
    if (key.startsWith("utm_")) {
      utmParams[key] = value;
    }
  });
  return utmParams;
}
function setUtmParamsInCookie(utmParams) {
  var _loop = function _loop(name) {
    var value = utmParams[name];

    _toConsumableArray(Object.values(SUB_DOMAIN)).forEach(function (domain) {
      setCookie(name, value, false, {
        domain: domain,
        path: "/"
      });
    });
  };

  for (var name in utmParams) {
    _loop(name);
  }
}
function deleteUtmParamsFromCookie() {
  deleteCookiesWithPrefix("utm_", Object.values(SUB_DOMAIN));
}
function deleteCookiesWithPrefix(prefix, domainList) {
  // Loop through each domain
  domainList.forEach(function (domain) {
    // Get all cookies for the current domain
    var cookies = document.cookie.split("; ");
    cookies.forEach(function (cookie) {
      // Split cookie into key and value
      var _cookie$split = cookie.split("="),
          _cookie$split2 = _slicedToArray(_cookie$split, 1),
          key = _cookie$split2[0];

      if (key.startsWith(prefix)) {
        removeCookie(key, {
          domain: domain
        });
      }
    });
  });
}
var getPartnerFromUrl = function getPartnerFromUrl() {
  if (isOnServer()) {
    return null;
  }

  var path = window.location.pathname;
  var partner = path.split("/")[2] || null;
  return partner;
};

var getDeviceIdWeb = function getDeviceIdWeb(partner) {
  switch (partner) {
    case _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.MMT */ .RL.MMT:
      return (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.MMT_DEVICE_ID */ .E9.MMT_DEVICE_ID, true) || getVisitorId();

    case _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.GI */ .RL.GI:
      return (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.GI_DEVICE_ID */ .E9.GI_DEVICE_ID, true) || null;

    default:
      return null;
  }
};

var getDeviceIdApp = function getDeviceIdApp() {
  var _window9, _window9$app_bridge, _window9$app_bridge$d;

  if (isOnServer()) {
    return null;
  }

  return ((_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$app_bridge = _window9.app_bridge) === null || _window9$app_bridge === void 0 ? void 0 : (_window9$app_bridge$d = _window9$app_bridge.deviceId) === null || _window9$app_bridge$d === void 0 ? void 0 : _window9$app_bridge$d.call(_window9$app_bridge)) || null;
};

var isApp = function isApp() {
  var _window10, _window11, _window11$webkit, _window11$webkit$mess;

  if (isOnServer()) {
    return false;
  }

  return (_window10 = window) !== null && _window10 !== void 0 && _window10.app_bridge || (_window11 = window) !== null && _window11 !== void 0 && (_window11$webkit = _window11.webkit) !== null && _window11$webkit !== void 0 && (_window11$webkit$mess = _window11$webkit.messageHandlers) !== null && _window11$webkit$mess !== void 0 && _window11$webkit$mess.login ? true : false;
};
var getDeviceIdStatus = function getDeviceIdStatus() {
  if (isOnServer()) {
    return null;
  }

  if (isApp()) {
    var _window12, _window12$app_bridge;

    if ((_window12 = window) !== null && _window12 !== void 0 && (_window12$app_bridge = _window12.app_bridge) !== null && _window12$app_bridge !== void 0 && _window12$app_bridge.deviceId) {
      var _window13, _window13$app_bridge, _window13$app_bridge$;

      if ((_window13 = window) !== null && _window13 !== void 0 && (_window13$app_bridge = _window13.app_bridge) !== null && _window13$app_bridge !== void 0 && (_window13$app_bridge$ = _window13$app_bridge.deviceId) !== null && _window13$app_bridge$ !== void 0 && _window13$app_bridge$.call(_window13$app_bridge)) {
        return _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_ID_BRIDGE_STATE.AVAILABLE */ .lU.AVAILABLE;
      } else {
        return _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_ID_BRIDGE_STATE.NON_FUNCTIONAL */ .lU.NON_FUNCTIONAL;
      }
    } else {
      return _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_ID_BRIDGE_STATE.NOT_AVAILABLE */ .lU.NOT_AVAILABLE;
    }
  }

  return null;
};
var getDeviceId = function getDeviceId(partner) {
  if (isOnServer()) {
    return null;
  }

  var deviceType = getDeviceType();

  if (deviceType === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_MODEL_TYPE.WEB */ .Yr.WEB) {
    return getDeviceIdWeb(partner);
  } else if (deviceType === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_MODEL_TYPE.APP */ .Yr.APP) {
    return getDeviceIdApp();
  }

  return null;
};
var setMmtRedirectionCookie = function setMmtRedirectionCookie() {
  if (getHostName() === _constants__WEBPACK_IMPORTED_MODULE_4__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP) (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .setCookie */ .d8)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.MMT_FOREX_COOKIE */ .E9.MMT_FOREX_COOKIE, "true", true, {
    domain: _constants__WEBPACK_IMPORTED_MODULE_4__/* .MMT_SUB_DOMAIN */ .FJ,
    path: "/"
  });
};
var isValidJSON = function isValidJSON(value) {
  if (typeof value !== "string") {
    return false;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return false;
  }
};
function getCardValue(products, cardType) {
  if (!products) {
    return null;
  }

  var _iterator = _createForOfIteratorHelper(products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;

      for (var _i2 = 0, _Object$entries2 = Object.entries(product); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_Object$entries2[_i2], 2),
            card = _Object$entries2$_i[0],
            cardValue = _Object$entries2$_i[1];

        if (card === cardType) {
          return cardValue;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
function getPokusExpVersion(_ref5) {
  var partner = _ref5.partner,
      currencyCtaRedirect = _ref5.currencyCtaRedirect;

  if (partner === _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.MMT */ .RL.MMT) {
    return currencyCtaRedirect === _constants__WEBPACK_IMPORTED_MODULE_4__/* .REDIRECTION_FLOW.OLD */ .MR.OLD ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .POKUS_EXP_VERSION.MMT.OLD */ .Tu.MMT.OLD : _constants__WEBPACK_IMPORTED_MODULE_4__/* .POKUS_EXP_VERSION.MMT.NEW */ .Tu.MMT.NEW;
  } else {
    return currencyCtaRedirect === _constants__WEBPACK_IMPORTED_MODULE_4__/* .REDIRECTION_FLOW.OLD */ .MR.OLD ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .POKUS_EXP_VERSION.GI.OLD */ .Tu.GI.OLD : _constants__WEBPACK_IMPORTED_MODULE_4__/* .POKUS_EXP_VERSION.GI.NEW */ .Tu.GI.NEW;
  }
}
var getDeviceDetailsObject = function getDeviceDetailsObject(ua, partner) {
  var parser = new (ua_parser_js__WEBPACK_IMPORTED_MODULE_1___default())().setUA(ua).getResult();
  var app_version = _bridges__WEBPACK_IMPORTED_MODULE_9__/* .BridgeMethods.getAppVersion */ .X.getAppVersion();
  app_version = "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getPartner */ .kW)() === _constants__WEBPACK_IMPORTED_MODULE_4__/* .MakeMyTrip */ .yO ? "MMT" : "GI", "_").concat(app_version);
  return {
    id: getDeviceId(partner),
    os: parser && parser.os && parser.os.name ? parser.os.name : "",
    type: !isMobile() ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .DESKTOP */ .q5 : parser && parser.device && parser.device.type ? parser.device.type : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE */ .Jq,
    os_version: parser && parser.os && parser.os.version ? parser.os.version : "",
    app_version: app_version || null,
    user_agent: ua,
    model: getDeviceType() || null,
    connection_type: getDeviceIdStatus(),
    platform: getPlatform() || ""
  };
};
function disableEncrytionInWeb() {
  return getDeviceType() === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_MODEL_TYPE.WEB */ .Yr.WEB && [_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP, _constants__WEBPACK_IMPORTED_MODULE_4__/* .HOST.TRIPMONEY_MAKEMYTRIP */ .M5.TRIPMONEY_MAKEMYTRIP].includes(getHostName() || "");
} // for gdpr options

function getUtilOptions(options) {
  return disableEncrytionInWeb() ? _objectSpread(_objectSpread({}, options), {}, {
    isPiiData: false
  }) : options;
}
function removeNullableField(obj) {
  var result = null;

  for (var _i3 = 0, _Object$entries3 = Object.entries(obj); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_Object$entries3[_i3], 2),
        key = _Object$entries3$_i[0],
        value = _Object$entries3$_i[1];

    if (value != null) {
      if (!result) result = {};
      result[key] = value;
    }
  }

  return result;
}
function removeEmptyKeys(obj) {
  var result = {};

  for (var _i4 = 0, _Object$entries4 = Object.entries(obj); _i4 < _Object$entries4.length; _i4++) {
    var _Object$entries4$_i = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_Object$entries4[_i4], 2),
        key = _Object$entries4$_i[0],
        value = _Object$entries4$_i[1];

    if (value) {
      result[key] = value;
    }
  }

  return result;
}
function getPageName() {
  if (isOnServer()) return "";
  var pathname = window.location.pathname;

  function findValidSegment(segments) {
    if (segments.length === 0) {
      return "";
    }

    var lastSegment = segments[segments.length - 1];

    if (/^[a-zA-Z]+$/.test(lastSegment)) {
      return lastSegment;
    } else {
      // If the last segment contains any alphanumeric character,
      // remove it and continue recursively
      segments.pop();
      return findValidSegment(segments);
    }
  }

  try {
    var pathSegments = pathname.split("/").filter(function (segment) {
      return segment !== "";
    });
    return findValidSegment(pathSegments);
  } catch (e) {
    console.error(e === null || e === void 0 ? void 0 : e.message);
  }

  return window.location.pathname;
}
function generateRequestId() {
  return (0,uuid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
}
function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
var OFFER_TYPES = {
  OFFER: "offer",
  CROSS_SELL_HOTEL: "cross_sell_hotel",
  SALE_COUPONS: "sale_coupons",
  CROSS_SELL_FLIGHT: "cross_sell_flight"
};
function convertEpochToDate(epoch) {
  var date = new Date(epoch);
  var options = {
    day: "numeric",
    month: "short",
    year: "numeric"
  };
  var formattedDate = date.toLocaleDateString("en-US", options);
  return formattedDate.replace(/(\w+) (\d+), (\d+)/, "$2 $1'$3");
}
function getJourneyIdFromCookie(partner) {
  if (partner === _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.MMT */ .RL.MMT) {
    return (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.PDT_JOURNEY_ID */ .E9.PDT_JOURNEY_ID, true, {
      domain: "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .SUB_DOMAIN.MAKEMYTRIP */ .W6.MAKEMYTRIP),
      path: "/"
    });
  } else if (partner === _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.GI */ .RL.GI) {
    return (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .getCookie */ .ej)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.PDT_JOURNEY_ID */ .E9.PDT_JOURNEY_ID, true, {
      domain: _constants__WEBPACK_IMPORTED_MODULE_4__/* .SUB_DOMAIN.GOIBIBO */ .W6.GOIBIBO,
      path: "/"
    });
  }

  return null;
}
function setJourneyIdInCookie(_ref6) {
  var partner = _ref6.partner,
      journeyId = _ref6.journeyId;
  var journeyIdCookie = getJourneyIdFromCookie(partner);

  if (!journeyIdCookie && journeyId) {
    // Get the current date and time
    var currentDate = new Date(); // Set the expiration time to 1 hour from now

    var expirationTime = new Date(currentDate.getTime() + 60 * 60 * 1000); // 60 minutes * 60 seconds * 1000 milliseconds
    // Convert the expiration time to the HTTP Date format

    var expires = expirationTime.toUTCString();
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.PDT_JOURNEY_ID */ .E9.PDT_JOURNEY_ID);

    if (partner === _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.MMT */ .RL.MMT) {
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .setCookie */ .d8)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.PDT_JOURNEY_ID */ .E9.PDT_JOURNEY_ID, journeyId, true, {
        domain: _constants__WEBPACK_IMPORTED_MODULE_4__/* .SUB_DOMAIN.MAKEMYTRIP */ .W6.MAKEMYTRIP,
        path: "/",
        expiresVal: expires
      });
    } else if (partner === _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER.GI */ .RL.GI) {
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_6__/* .setCookie */ .d8)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .COOKIES.PDT_JOURNEY_ID */ .E9.PDT_JOURNEY_ID, journeyId, true, {
        domain: _constants__WEBPACK_IMPORTED_MODULE_4__/* .SUB_DOMAIN.GOIBIBO */ .W6.GOIBIBO,
        path: "/",
        expiresVal: expires
      });
    }
  }
}
function getPageUrl() {
  if (isOnServer()) {
    return null;
  }

  return window.location.href;
}
var formatDate = function formatDate(date, dateFormat) {
  if (date) {
    try {
      date = new Date(date);
      return (0,date_fns__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(date, dateFormat);
    } catch (error) {
      console.log(error);
      console.log("Error in formatting given date", "".concat(date, " | ").concat(dateFormat));
    }
  }

  return "";
};
var getQueryParamsFromUrl = function getQueryParamsFromUrl(url) {
  if (!url) {
    url = window.location.search;
  }

  var urlSearchParams = new URLSearchParams(url);
  var queryParams = {};
  urlSearchParams.forEach(function (value, key) {
    queryParams[key] = value;
  });
  return queryParams;
};
var toLocaleStringINRFormat = function toLocaleStringINRFormat(currency) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (currency) {
    return Number(currency).toLocaleString("en-IN", {
      minimumFractionDigits: minimumFractionDigits > maximumFractionDigits ? 2 : minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits == 0 && maximumFractionDigits == 0 ? 0 : maximumFractionDigits > 2 ? maximumFractionDigits : 2
    });
  }

  return "0";
};
var addWebVitalsScript = function addWebVitalsScript() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$prefix = _ref7.prefix,
      prefix = _ref7$prefix === void 0 ? "FOREX_VITALS" : _ref7$prefix,
      _ref7$sampleSize = _ref7.sampleSize,
      sampleSize = _ref7$sampleSize === void 0 ? 100 : _ref7$sampleSize;

  var Event = new _mmt_web_vitals_logger__WEBPACK_IMPORTED_MODULE_2__/* .CaptureWebVitals */ .Z(prefix, sampleSize, 65871, "mmt_commons_b2c_pdt_client_metric_logging");
  Event.init(true, true, true);
};
function isHostMMT() {
  var _window14, _window14$location, _window14$location$ho;

  if (isOnServer()) {
    return null;
  }

  if ((_window14 = window) !== null && _window14 !== void 0 && (_window14$location = _window14.location) !== null && _window14$location !== void 0 && (_window14$location$ho = _window14$location.hostname) !== null && _window14$location$ho !== void 0 && _window14$location$ho.includes("makemytrip")) {
    return true;
  }

  return false;
}
function getBaseUrlBasedOnDomains() {
  if (isOnServer()) {
    return "";
  }

  var hostName = getHostName();

  if (hostName !== null && hostName !== void 0 && hostName.includes("forex.makemytrip.com")) {
    return "https://forex-gw.makemytrip.com";
  } else if (hostName !== null && hostName !== void 0 && hostName.includes("forex.goibibo.com")) {
    return "https://forex-gw.goibibo.com";
  }

  return "";
}
var isAgentFlow = function isAgentFlow() {
  if (isOnServer()) return false;
  return isPartnerHost(_constants__WEBPACK_IMPORTED_MODULE_4__/* .SOURCE.FOREX_EXPERT */ .Hx.FOREX_EXPERT);
};




/***/ }),

/***/ 5853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ getCommonPdtDataV2; }
});

// UNUSED EXPORTS: getLobCategory

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(6353);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(2151);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/pdtutils/getCommonPdtDataV2/commonpdtUtils.ts
//@ts-ignore



function getDeviceSpecificInfo() {
  var _parser$os, _parser$device;

  var ua = !(0,utils.isOnServer)() ? navigator.userAgent : null;
  var parser = new (ua_parser_default())().setUA(ua).getResult();
  return {
    os: parser && (parser === null || parser === void 0 ? void 0 : (_parser$os = parser.os) === null || _parser$os === void 0 ? void 0 : _parser$os.name) || "",
    type: !(0,utils.isMobile)() ? "Desktop" : parser && (parser === null || parser === void 0 ? void 0 : (_parser$device = parser.device) === null || _parser$device === void 0 ? void 0 : _parser$device.type) || "",
    os_version: parser && parser.os && parser.os.version ? parser.os.version : "",
    user_agent: ua || ""
  };
}
function getUtmPdtObj() {
  return {
    funnel_medium: (0,cookieUtils/* getCookie */.ej)(UTM_PARAMS_KEY.UTM_MEDIUM, false, {
      path: "/"
    }) || null,
    funnel_source: (0,cookieUtils/* getCookie */.ej)(UTM_PARAMS_KEY.UTM_SOURCE, false, {
      path: "/"
    }) || null,
    funnel_campaign: (0,cookieUtils/* getCookie */.ej)(UTM_PARAMS_KEY.UTM_CAMPAIGN, false, {
      path: "/"
    }) || null
  };
}
var UTM_PARAMS_KEY = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_CONTENT: "utm_content"
};
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/bridges/index.ts
var bridges = __webpack_require__(6787);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/pdtutils/getCommonPdtDataV2/index.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var getCommonPdtDataV2 = function getCommonPdtDataV2(_ref) {
  var userId = _ref.userId,
      puid = _ref.puid,
      partner = _ref.partner,
      lobCategory = _ref.lobCategory,
      lobFunnelType = _ref.lobFunnelType,
      funnelStep = _ref.funnelStep;
  if ((0,utils.isOnServer)()) return {};
  var app_ver = !(0,utils.isOnServer)() ? bridges/* BridgeMethods.getAppVersion */.X.getAppVersion() : null;
  app_ver = "".concat(partner === constants/* PARTNER.MMT */.RL.MMT ? constants/* PARTNER.MMT.toUpperCase */.RL.MMT.toUpperCase() : constants/* PARTNER.GI.toUpperCase */.RL.GI.toUpperCase(), "_").concat(app_ver);

  var _getDeviceSpecificInf = getDeviceSpecificInfo(),
      os = _getDeviceSpecificInf.os,
      user_agent = _getDeviceSpecificInf.user_agent,
      os_version = _getDeviceSpecificInf.os_version;

  return {
    event_tracking_context: (0,utils.getEventTrackingContext)(_objectSpread(_objectSpread({}, getUtmPdtObj()), {}, {
      template_id: 61857,
      topic_name: "tripmoney_forex_b2c_pdt_client_logging",
      timestamp: new Date().getTime(),
      env: "prod",
      journey_id: (0,utils.getJourneyIdFromCookie)(partner)
    })),
    event_detail: (0,utils.getEventDetails)({
      event_type: "NA",
      event_name: "NA",
      event_timestamp: new Date().getTime(),
      user_details: (0,utils.getTmUserDetails)({
        tm_uuid: "".concat(userId !== null && userId !== void 0 ? userId : "NA"),
        partner: partner
      }),
      components: (0,utils.getComponentsPdt)({
        bridge_status: (0,utils.getDeviceIdStatus)()
      })
    }),
    user_context: (0,utils.getUserContext)({
      // TODO - ask if nullable
      uuid: "".concat(puid !== null && puid !== void 0 ? puid : "NA"),
      is_logged_in: userId ? true : false
    }),
    device_context: (0,utils.getDeviceContext)({
      os: os,
      os_version: os_version,
      app_ver: app_ver,
      user_agent: user_agent,
      platform: (0,utils.getPlatform)() || "NA",
      device_id: (0,utils.getDeviceId)(partner) || "NA"
    }),
    page_context: (0,utils.getPageContext)({
      page_name: (0,utils.getPageName)(),
      // nullable, string
      prev_page_name: constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE,
      // nullable, string
      lob: constants/* LOB.FOREX */.r6.FOREX,
      lob_funnel: lobFunnelType,
      lob_category: lobCategory,
      page_url: (0,utils.getPageUrl)(),
      funnel_step: funnelStep
    })
  };
};
function getLobCategory() {
  if (isOnServer()) {
    return "NA";
  }

  var url = window.location.pathname;

  if (/currency/i.test(url)) {
    return LOB_CATEGORY.CN;
  } else if (/onboarding/i.test(url)) {
    return LOB_CATEGORY.PC;
  } else {
    return "";
  }
}

/***/ }),

/***/ 5253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_h": function() { return /* binding */ getPdtLoggerMethods; }
});

// UNUSED EXPORTS: replacePipeWithComma, sendPdtErrorEvent, transformComponentData, transformUpcomingTrip

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(6353);
;// CONCATENATED MODULE: ../../node_modules/@mmt/event-logger/dist/index.mjs
var x;(function(n){n.assertEqual=s=>s;function e(s){}n.assertIs=e;function t(s){throw new Error}n.assertNever=t,n.arrayToEnum=s=>{let a={};for(let i of s)a[i]=i;return a},n.getValidEnumValues=s=>{let a=n.objectKeys(s).filter(o=>typeof s[s[o]]!="number"),i={};for(let o of a)i[o]=s[o];return n.objectValues(i)},n.objectValues=s=>n.objectKeys(s).map(function(a){return s[a]}),n.objectKeys=typeof Object.keys=="function"?s=>Object.keys(s):s=>{let a=[];for(let i in s)Object.prototype.hasOwnProperty.call(s,i)&&a.push(i);return a},n.find=(s,a)=>{for(let i of s)if(a(i))return i},n.isInteger=typeof Number.isInteger=="function"?s=>Number.isInteger(s):s=>typeof s=="number"&&isFinite(s)&&Math.floor(s)===s;function r(s,a=" | "){return s.map(i=>typeof i=="string"?`'${i}'`:i).join(a)}n.joinValues=r,n.jsonStringifyReplacer=(s,a)=>typeof a=="bigint"?a.toString():a})(x||(x={}));var tt;(function(n){n.mergeShapes=(e,t)=>({...e,...t})})(tt||(tt={}));var f=x.arrayToEnum(["string","nan","number","integer","float","boolean","date","bigint","symbol","function","undefined","null","array","object","unknown","promise","void","never","map","set"]),U=n=>{switch(typeof n){case"undefined":return f.undefined;case"string":return f.string;case"number":return isNaN(n)?f.nan:f.number;case"boolean":return f.boolean;case"function":return f.function;case"bigint":return f.bigint;case"symbol":return f.symbol;case"object":return Array.isArray(n)?f.array:n===null?f.null:n.then&&typeof n.then=="function"&&n.catch&&typeof n.catch=="function"?f.promise:typeof Map<"u"&&n instanceof Map?f.map:typeof Set<"u"&&n instanceof Set?f.set:typeof Date<"u"&&n instanceof Date?f.date:f.object;default:return f.unknown}},d=x.arrayToEnum(["invalid_type","invalid_literal","custom","invalid_union","invalid_union_discriminator","invalid_enum_value","unrecognized_keys","invalid_arguments","invalid_return_type","invalid_date","invalid_string","too_small","too_big","invalid_intersection_types","not_multiple_of","not_finite"]),mn=n=>JSON.stringify(n,null,2).replace(/"([^"]+)":/g,"$1:"),C=class n extends Error{get errors(){return this.issues}constructor(e){super(),this.issues=[],this.addIssue=r=>{this.issues=[...this.issues,r]},this.addIssues=(r=[])=>{this.issues=[...this.issues,...r]};let t=new.target.prototype;Object.setPrototypeOf?Object.setPrototypeOf(this,t):this.__proto__=t,this.name="ZodError",this.issues=e}format(e){let t=e||function(a){return a.message},r={_errors:[]},s=a=>{for(let i of a.issues)if(i.code==="invalid_union")i.unionErrors.map(s);else if(i.code==="invalid_return_type")s(i.returnTypeError);else if(i.code==="invalid_arguments")s(i.argumentsError);else if(i.path.length===0)r._errors.push(t(i));else{let o=r,u=0;for(;u<i.path.length;){let c=i.path[u];u===i.path.length-1?(o[c]=o[c]||{_errors:[]},o[c]._errors.push(t(i))):o[c]=o[c]||{_errors:[]},o=o[c],u++}}};return s(this),r}static assert(e){if(!(e instanceof n))throw new Error(`Not a ZodError: ${e}`)}toString(){return this.message}get message(){return JSON.stringify(this.issues,x.jsonStringifyReplacer,2)}get isEmpty(){return this.issues.length===0}flatten(e=t=>t.message){let t={},r=[];for(let s of this.issues)s.path.length>0?(t[s.path[0]]=t[s.path[0]]||[],t[s.path[0]].push(e(s))):r.push(e(s));return{formErrors:r,fieldErrors:t}}get formErrors(){return this.flatten()}};C.create=n=>new C(n);var he=(n,e)=>{let t;switch(n.code){case d.invalid_type:n.received===f.undefined?t="Required":t=`Expected ${n.expected}, received ${n.received}`;break;case d.invalid_literal:t=`Invalid literal value, expected ${JSON.stringify(n.expected,x.jsonStringifyReplacer)}`;break;case d.unrecognized_keys:t=`Unrecognized key(s) in object: ${x.joinValues(n.keys,", ")}`;break;case d.invalid_union:t="Invalid input";break;case d.invalid_union_discriminator:t=`Invalid discriminator value. Expected ${x.joinValues(n.options)}`;break;case d.invalid_enum_value:t=`Invalid enum value. Expected ${x.joinValues(n.options)}, received '${n.received}'`;break;case d.invalid_arguments:t="Invalid function arguments";break;case d.invalid_return_type:t="Invalid function return type";break;case d.invalid_date:t="Invalid date";break;case d.invalid_string:typeof n.validation=="object"?"includes"in n.validation?(t=`Invalid input: must include "${n.validation.includes}"`,typeof n.validation.position=="number"&&(t=`${t} at one or more positions greater than or equal to ${n.validation.position}`)):"startsWith"in n.validation?t=`Invalid input: must start with "${n.validation.startsWith}"`:"endsWith"in n.validation?t=`Invalid input: must end with "${n.validation.endsWith}"`:x.assertNever(n.validation):n.validation!=="regex"?t=`Invalid ${n.validation}`:t="Invalid";break;case d.too_small:n.type==="array"?t=`Array must contain ${n.exact?"exactly":n.inclusive?"at least":"more than"} ${n.minimum} element(s)`:n.type==="string"?t=`String must contain ${n.exact?"exactly":n.inclusive?"at least":"over"} ${n.minimum} character(s)`:n.type==="number"?t=`Number must be ${n.exact?"exactly equal to ":n.inclusive?"greater than or equal to ":"greater than "}${n.minimum}`:n.type==="date"?t=`Date must be ${n.exact?"exactly equal to ":n.inclusive?"greater than or equal to ":"greater than "}${new Date(Number(n.minimum))}`:t="Invalid input";break;case d.too_big:n.type==="array"?t=`Array must contain ${n.exact?"exactly":n.inclusive?"at most":"less than"} ${n.maximum} element(s)`:n.type==="string"?t=`String must contain ${n.exact?"exactly":n.inclusive?"at most":"under"} ${n.maximum} character(s)`:n.type==="number"?t=`Number must be ${n.exact?"exactly":n.inclusive?"less than or equal to":"less than"} ${n.maximum}`:n.type==="bigint"?t=`BigInt must be ${n.exact?"exactly":n.inclusive?"less than or equal to":"less than"} ${n.maximum}`:n.type==="date"?t=`Date must be ${n.exact?"exactly":n.inclusive?"smaller than or equal to":"smaller than"} ${new Date(Number(n.maximum))}`:t="Invalid input";break;case d.custom:t="Invalid input";break;case d.invalid_intersection_types:t="Intersection results could not be merged";break;case d.not_multiple_of:t=`Number must be a multiple of ${n.multipleOf}`;break;case d.not_finite:t="Number must be finite";break;default:t=e.defaultError,x.assertNever(n)}return{message:t}},gt=he;function hn(n){gt=n}function Ze(){return gt}var Ue=n=>{let{data:e,path:t,errorMaps:r,issueData:s}=n,a=[...t,...s.path||[]],i={...s,path:a};if(s.message!==void 0)return{...s,path:a,message:s.message};let o="",u=r.filter(c=>!!c).slice().reverse();for(let c of u)o=c(i,{data:e,defaultError:o}).message;return{...s,path:a,message:o}},gn=[];function l(n,e){let t=Ze(),r=Ue({issueData:e,data:n.data,path:n.path,errorMaps:[n.common.contextualErrorMap,n.schemaErrorMap,t,t===he?void 0:he].filter(s=>!!s)});n.common.issues.push(r)}var w=class n{constructor(){this.value="valid"}dirty(){this.value==="valid"&&(this.value="dirty")}abort(){this.value!=="aborted"&&(this.value="aborted")}static mergeArray(e,t){let r=[];for(let s of t){if(s.status==="aborted")return g;s.status==="dirty"&&e.dirty(),r.push(s.value)}return{status:e.value,value:r}}static async mergeObjectAsync(e,t){let r=[];for(let s of t){let a=await s.key,i=await s.value;r.push({key:a,value:i})}return n.mergeObjectSync(e,r)}static mergeObjectSync(e,t){let r={};for(let s of t){let{key:a,value:i}=s;if(a.status==="aborted"||i.status==="aborted")return g;a.status==="dirty"&&e.dirty(),i.status==="dirty"&&e.dirty(),a.value!=="__proto__"&&(typeof i.value<"u"||s.alwaysSet)&&(r[a.value]=i.value)}return{status:e.value,value:r}}},g=Object.freeze({status:"aborted"}),me=n=>({status:"dirty",value:n}),S=n=>({status:"valid",value:n}),nt=n=>n.status==="aborted",rt=n=>n.status==="dirty",H=n=>n.status==="valid",Ee=n=>typeof Promise<"u"&&n instanceof Promise;function Le(n,e,t,r){if(t==="a"&&!r)throw new TypeError("Private accessor was defined without a getter");if(typeof e=="function"?n!==e||!r:!e.has(n))throw new TypeError("Cannot read private member from an object whose class did not declare it");return t==="m"?r:t==="a"?r.call(n):r?r.value:e.get(n)}function yt(n,e,t,r,s){if(r==="m")throw new TypeError("Private method is not writable");if(r==="a"&&!s)throw new TypeError("Private accessor was defined without a setter");if(typeof e=="function"?n!==e||!s:!e.has(n))throw new TypeError("Cannot write private member to an object whose class did not declare it");return r==="a"?s.call(n,t):s?s.value=t:e.set(n,t),t}var m;(function(n){n.errToObj=e=>typeof e=="string"?{message:e}:e||{},n.toString=e=>typeof e=="string"?e:e?.message})(m||(m={}));var Se,Te,O=class{constructor(e,t,r,s){this._cachedPath=[],this.parent=e,this.data=t,this._path=r,this._key=s}get path(){return this._cachedPath.length||(this._key instanceof Array?this._cachedPath.push(...this._path,...this._key):this._cachedPath.push(...this._path,this._key)),this._cachedPath}},pt=(n,e)=>{if(H(e))return{success:!0,data:e.value};if(!n.common.issues.length)throw new Error("Validation failed but no issues detected.");return{success:!1,get error(){if(this._error)return this._error;let t=new C(n.common.issues);return this._error=t,this._error}}};function v(n){if(!n)return{};let{errorMap:e,invalid_type_error:t,required_error:r,description:s}=n;if(e&&(t||r))throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);return e?{errorMap:e,description:s}:{errorMap:(i,o)=>{var u,c;let{message:p}=n;return i.code==="invalid_enum_value"?{message:p??o.defaultError}:typeof o.data>"u"?{message:(u=p??r)!==null&&u!==void 0?u:o.defaultError}:i.code!=="invalid_type"?{message:o.defaultError}:{message:(c=p??t)!==null&&c!==void 0?c:o.defaultError}},description:s}}var _=class{get description(){return this._def.description}_getType(e){return U(e.data)}_getOrReturnCtx(e,t){return t||{common:e.parent.common,data:e.data,parsedType:U(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}_processInputParams(e){return{status:new w,ctx:{common:e.parent.common,data:e.data,parsedType:U(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}}_parseSync(e){let t=this._parse(e);if(Ee(t))throw new Error("Synchronous parse encountered promise.");return t}_parseAsync(e){let t=this._parse(e);return Promise.resolve(t)}parse(e,t){let r=this.safeParse(e,t);if(r.success)return r.data;throw r.error}safeParse(e,t){var r;let s={common:{issues:[],async:(r=t?.async)!==null&&r!==void 0?r:!1,contextualErrorMap:t?.errorMap},path:t?.path||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)},a=this._parseSync({data:e,path:s.path,parent:s});return pt(s,a)}"~validate"(e){var t,r;let s={common:{issues:[],async:!!this["~standard"].async},path:[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)};if(!this["~standard"].async)try{let a=this._parseSync({data:e,path:[],parent:s});return H(a)?{value:a.value}:{issues:s.common.issues}}catch(a){!((r=(t=a?.message)===null||t===void 0?void 0:t.toLowerCase())===null||r===void 0)&&r.includes("encountered")&&(this["~standard"].async=!0),s.common={issues:[],async:!0}}return this._parseAsync({data:e,path:[],parent:s}).then(a=>H(a)?{value:a.value}:{issues:s.common.issues})}async parseAsync(e,t){let r=await this.safeParseAsync(e,t);if(r.success)return r.data;throw r.error}async safeParseAsync(e,t){let r={common:{issues:[],contextualErrorMap:t?.errorMap,async:!0},path:t?.path||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)},s=this._parse({data:e,path:r.path,parent:r}),a=await(Ee(s)?s:Promise.resolve(s));return pt(r,a)}refine(e,t){let r=s=>typeof t=="string"||typeof t>"u"?{message:t}:typeof t=="function"?t(s):t;return this._refinement((s,a)=>{let i=e(s),o=()=>a.addIssue({code:d.custom,...r(s)});return typeof Promise<"u"&&i instanceof Promise?i.then(u=>u?!0:(o(),!1)):i?!0:(o(),!1)})}refinement(e,t){return this._refinement((r,s)=>e(r)?!0:(s.addIssue(typeof t=="function"?t(r,s):t),!1))}_refinement(e){return new I({schema:this,typeName:h.ZodEffects,effect:{type:"refinement",refinement:e}})}superRefine(e){return this._refinement(e)}constructor(e){this.spa=this.safeParseAsync,this._def=e,this.parse=this.parse.bind(this),this.safeParse=this.safeParse.bind(this),this.parseAsync=this.parseAsync.bind(this),this.safeParseAsync=this.safeParseAsync.bind(this),this.spa=this.spa.bind(this),this.refine=this.refine.bind(this),this.refinement=this.refinement.bind(this),this.superRefine=this.superRefine.bind(this),this.optional=this.optional.bind(this),this.nullable=this.nullable.bind(this),this.nullish=this.nullish.bind(this),this.array=this.array.bind(this),this.promise=this.promise.bind(this),this.or=this.or.bind(this),this.and=this.and.bind(this),this.transform=this.transform.bind(this),this.brand=this.brand.bind(this),this.default=this.default.bind(this),this.catch=this.catch.bind(this),this.describe=this.describe.bind(this),this.pipe=this.pipe.bind(this),this.readonly=this.readonly.bind(this),this.isNullable=this.isNullable.bind(this),this.isOptional=this.isOptional.bind(this),this["~standard"]={version:1,vendor:"zod",validate:t=>this["~validate"](t)}}optional(){return A.create(this,this._def)}nullable(){return M.create(this,this._def)}nullish(){return this.nullable().optional()}array(){return $.create(this)}promise(){return q.create(this,this._def)}or(e){return ee.create([this,e],this._def)}and(e){return te.create(this,e,this._def)}transform(e){return new I({...v(this._def),schema:this,typeName:h.ZodEffects,effect:{type:"transform",transform:e}})}default(e){let t=typeof e=="function"?e:()=>e;return new ie({...v(this._def),innerType:this,defaultValue:t,typeName:h.ZodDefault})}brand(){return new Ce({typeName:h.ZodBranded,type:this,...v(this._def)})}catch(e){let t=typeof e=="function"?e:()=>e;return new oe({...v(this._def),innerType:this,catchValue:t,typeName:h.ZodCatch})}describe(e){let t=this.constructor;return new t({...this._def,description:e})}pipe(e){return Ie.create(this,e)}readonly(){return ce.create(this)}isOptional(){return this.safeParse(void 0).success}isNullable(){return this.safeParse(null).success}},yn=/^c[^\s-]{8,}$/i,vn=/^[0-9a-z]+$/,_n=/^[0-9A-HJKMNP-TV-Z]{26}$/i,xn=/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i,bn=/^[a-z0-9_-]{21}$/i,wn=/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/,kn=/^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/,Sn=/^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i,Tn="^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$",et,En=/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,Cn=/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,In=/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/,An=/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,On=/^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,Pn=/^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,vt="((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))",Rn=new RegExp(`^${vt}$`);function _t(n){let e="[0-5]\\d";n.precision?e=`${e}\\.\\d{${n.precision}}`:n.precision==null&&(e=`${e}(\\.\\d+)?`);let t=n.precision?"+":"?";return`([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`}function Dn(n){return new RegExp(`^${_t(n)}$`)}function xt(n){let e=`${vt}T${_t(n)}`,t=[];return t.push(n.local?"Z?":"Z"),n.offset&&t.push("([+-]\\d{2}:?\\d{2})"),e=`${e}(${t.join("|")})`,new RegExp(`^${e}$`)}function Nn(n,e){return!!((e==="v4"||!e)&&En.test(n)||(e==="v6"||!e)&&In.test(n))}function jn(n,e){if(!wn.test(n))return!1;try{let[t]=n.split("."),r=t.replace(/-/g,"+").replace(/_/g,"/").padEnd(t.length+(4-t.length%4)%4,"="),s=JSON.parse(atob(r));return!(typeof s!="object"||s===null||!s.typ||!s.alg||e&&s.alg!==e)}catch{return!1}}function Mn(n,e){return!!((e==="v4"||!e)&&Cn.test(n)||(e==="v6"||!e)&&An.test(n))}var z=class n extends _{_parse(e){if(this._def.coerce&&(e.data=String(e.data)),this._getType(e)!==f.string){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.string,received:a.parsedType}),g}let r=new w,s;for(let a of this._def.checks)if(a.kind==="min")e.data.length<a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_small,minimum:a.value,type:"string",inclusive:!0,exact:!1,message:a.message}),r.dirty());else if(a.kind==="max")e.data.length>a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_big,maximum:a.value,type:"string",inclusive:!0,exact:!1,message:a.message}),r.dirty());else if(a.kind==="length"){let i=e.data.length>a.value,o=e.data.length<a.value;(i||o)&&(s=this._getOrReturnCtx(e,s),i?l(s,{code:d.too_big,maximum:a.value,type:"string",inclusive:!0,exact:!0,message:a.message}):o&&l(s,{code:d.too_small,minimum:a.value,type:"string",inclusive:!0,exact:!0,message:a.message}),r.dirty())}else if(a.kind==="email")Sn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"email",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="emoji")et||(et=new RegExp(Tn,"u")),et.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"emoji",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="uuid")xn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"uuid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="nanoid")bn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"nanoid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="cuid")yn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cuid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="cuid2")vn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cuid2",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="ulid")_n.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"ulid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="url")try{new URL(e.data)}catch{s=this._getOrReturnCtx(e,s),l(s,{validation:"url",code:d.invalid_string,message:a.message}),r.dirty()}else a.kind==="regex"?(a.regex.lastIndex=0,a.regex.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"regex",code:d.invalid_string,message:a.message}),r.dirty())):a.kind==="trim"?e.data=e.data.trim():a.kind==="includes"?e.data.includes(a.value,a.position)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{includes:a.value,position:a.position},message:a.message}),r.dirty()):a.kind==="toLowerCase"?e.data=e.data.toLowerCase():a.kind==="toUpperCase"?e.data=e.data.toUpperCase():a.kind==="startsWith"?e.data.startsWith(a.value)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{startsWith:a.value},message:a.message}),r.dirty()):a.kind==="endsWith"?e.data.endsWith(a.value)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{endsWith:a.value},message:a.message}),r.dirty()):a.kind==="datetime"?xt(a).test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"datetime",message:a.message}),r.dirty()):a.kind==="date"?Rn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"date",message:a.message}),r.dirty()):a.kind==="time"?Dn(a).test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"time",message:a.message}),r.dirty()):a.kind==="duration"?kn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"duration",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="ip"?Nn(e.data,a.version)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"ip",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="jwt"?jn(e.data,a.alg)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"jwt",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="cidr"?Mn(e.data,a.version)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cidr",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="base64"?On.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"base64",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="base64url"?Pn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"base64url",code:d.invalid_string,message:a.message}),r.dirty()):x.assertNever(a);return{status:r.value,value:e.data}}_regex(e,t,r){return this.refinement(s=>e.test(s),{validation:t,code:d.invalid_string,...m.errToObj(r)})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}email(e){return this._addCheck({kind:"email",...m.errToObj(e)})}url(e){return this._addCheck({kind:"url",...m.errToObj(e)})}emoji(e){return this._addCheck({kind:"emoji",...m.errToObj(e)})}uuid(e){return this._addCheck({kind:"uuid",...m.errToObj(e)})}nanoid(e){return this._addCheck({kind:"nanoid",...m.errToObj(e)})}cuid(e){return this._addCheck({kind:"cuid",...m.errToObj(e)})}cuid2(e){return this._addCheck({kind:"cuid2",...m.errToObj(e)})}ulid(e){return this._addCheck({kind:"ulid",...m.errToObj(e)})}base64(e){return this._addCheck({kind:"base64",...m.errToObj(e)})}base64url(e){return this._addCheck({kind:"base64url",...m.errToObj(e)})}jwt(e){return this._addCheck({kind:"jwt",...m.errToObj(e)})}ip(e){return this._addCheck({kind:"ip",...m.errToObj(e)})}cidr(e){return this._addCheck({kind:"cidr",...m.errToObj(e)})}datetime(e){var t,r;return typeof e=="string"?this._addCheck({kind:"datetime",precision:null,offset:!1,local:!1,message:e}):this._addCheck({kind:"datetime",precision:typeof e?.precision>"u"?null:e?.precision,offset:(t=e?.offset)!==null&&t!==void 0?t:!1,local:(r=e?.local)!==null&&r!==void 0?r:!1,...m.errToObj(e?.message)})}date(e){return this._addCheck({kind:"date",message:e})}time(e){return typeof e=="string"?this._addCheck({kind:"time",precision:null,message:e}):this._addCheck({kind:"time",precision:typeof e?.precision>"u"?null:e?.precision,...m.errToObj(e?.message)})}duration(e){return this._addCheck({kind:"duration",...m.errToObj(e)})}regex(e,t){return this._addCheck({kind:"regex",regex:e,...m.errToObj(t)})}includes(e,t){return this._addCheck({kind:"includes",value:e,position:t?.position,...m.errToObj(t?.message)})}startsWith(e,t){return this._addCheck({kind:"startsWith",value:e,...m.errToObj(t)})}endsWith(e,t){return this._addCheck({kind:"endsWith",value:e,...m.errToObj(t)})}min(e,t){return this._addCheck({kind:"min",value:e,...m.errToObj(t)})}max(e,t){return this._addCheck({kind:"max",value:e,...m.errToObj(t)})}length(e,t){return this._addCheck({kind:"length",value:e,...m.errToObj(t)})}nonempty(e){return this.min(1,m.errToObj(e))}trim(){return new n({...this._def,checks:[...this._def.checks,{kind:"trim"}]})}toLowerCase(){return new n({...this._def,checks:[...this._def.checks,{kind:"toLowerCase"}]})}toUpperCase(){return new n({...this._def,checks:[...this._def.checks,{kind:"toUpperCase"}]})}get isDatetime(){return!!this._def.checks.find(e=>e.kind==="datetime")}get isDate(){return!!this._def.checks.find(e=>e.kind==="date")}get isTime(){return!!this._def.checks.find(e=>e.kind==="time")}get isDuration(){return!!this._def.checks.find(e=>e.kind==="duration")}get isEmail(){return!!this._def.checks.find(e=>e.kind==="email")}get isURL(){return!!this._def.checks.find(e=>e.kind==="url")}get isEmoji(){return!!this._def.checks.find(e=>e.kind==="emoji")}get isUUID(){return!!this._def.checks.find(e=>e.kind==="uuid")}get isNANOID(){return!!this._def.checks.find(e=>e.kind==="nanoid")}get isCUID(){return!!this._def.checks.find(e=>e.kind==="cuid")}get isCUID2(){return!!this._def.checks.find(e=>e.kind==="cuid2")}get isULID(){return!!this._def.checks.find(e=>e.kind==="ulid")}get isIP(){return!!this._def.checks.find(e=>e.kind==="ip")}get isCIDR(){return!!this._def.checks.find(e=>e.kind==="cidr")}get isBase64(){return!!this._def.checks.find(e=>e.kind==="base64")}get isBase64url(){return!!this._def.checks.find(e=>e.kind==="base64url")}get minLength(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxLength(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}};z.create=n=>{var e;return new z({checks:[],typeName:h.ZodString,coerce:(e=n?.coerce)!==null&&e!==void 0?e:!1,...v(n)})};function Vn(n,e){let t=(n.toString().split(".")[1]||"").length,r=(e.toString().split(".")[1]||"").length,s=t>r?t:r,a=parseInt(n.toFixed(s).replace(".","")),i=parseInt(e.toFixed(s).replace(".",""));return a%i/Math.pow(10,s)}var W=class n extends _{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte,this.step=this.multipleOf}_parse(e){if(this._def.coerce&&(e.data=Number(e.data)),this._getType(e)!==f.number){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.number,received:a.parsedType}),g}let r,s=new w;for(let a of this._def.checks)a.kind==="int"?x.isInteger(e.data)||(r=this._getOrReturnCtx(e,r),l(r,{code:d.invalid_type,expected:"integer",received:"float",message:a.message}),s.dirty()):a.kind==="min"?(a.inclusive?e.data<a.value:e.data<=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_small,minimum:a.value,type:"number",inclusive:a.inclusive,exact:!1,message:a.message}),s.dirty()):a.kind==="max"?(a.inclusive?e.data>a.value:e.data>=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_big,maximum:a.value,type:"number",inclusive:a.inclusive,exact:!1,message:a.message}),s.dirty()):a.kind==="multipleOf"?Vn(e.data,a.value)!==0&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_multiple_of,multipleOf:a.value,message:a.message}),s.dirty()):a.kind==="finite"?Number.isFinite(e.data)||(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_finite,message:a.message}),s.dirty()):x.assertNever(a);return{status:s.value,value:e.data}}gte(e,t){return this.setLimit("min",e,!0,m.toString(t))}gt(e,t){return this.setLimit("min",e,!1,m.toString(t))}lte(e,t){return this.setLimit("max",e,!0,m.toString(t))}lt(e,t){return this.setLimit("max",e,!1,m.toString(t))}setLimit(e,t,r,s){return new n({...this._def,checks:[...this._def.checks,{kind:e,value:t,inclusive:r,message:m.toString(s)}]})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}int(e){return this._addCheck({kind:"int",message:m.toString(e)})}positive(e){return this._addCheck({kind:"min",value:0,inclusive:!1,message:m.toString(e)})}negative(e){return this._addCheck({kind:"max",value:0,inclusive:!1,message:m.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:0,inclusive:!0,message:m.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:0,inclusive:!0,message:m.toString(e)})}multipleOf(e,t){return this._addCheck({kind:"multipleOf",value:e,message:m.toString(t)})}finite(e){return this._addCheck({kind:"finite",message:m.toString(e)})}safe(e){return this._addCheck({kind:"min",inclusive:!0,value:Number.MIN_SAFE_INTEGER,message:m.toString(e)})._addCheck({kind:"max",inclusive:!0,value:Number.MAX_SAFE_INTEGER,message:m.toString(e)})}get minValue(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxValue(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}get isInt(){return!!this._def.checks.find(e=>e.kind==="int"||e.kind==="multipleOf"&&x.isInteger(e.value))}get isFinite(){let e=null,t=null;for(let r of this._def.checks){if(r.kind==="finite"||r.kind==="int"||r.kind==="multipleOf")return!0;r.kind==="min"?(t===null||r.value>t)&&(t=r.value):r.kind==="max"&&(e===null||r.value<e)&&(e=r.value)}return Number.isFinite(t)&&Number.isFinite(e)}};W.create=n=>new W({checks:[],typeName:h.ZodNumber,coerce:n?.coerce||!1,...v(n)});var G=class n extends _{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte}_parse(e){if(this._def.coerce)try{e.data=BigInt(e.data)}catch{return this._getInvalidInput(e)}if(this._getType(e)!==f.bigint)return this._getInvalidInput(e);let r,s=new w;for(let a of this._def.checks)a.kind==="min"?(a.inclusive?e.data<a.value:e.data<=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_small,type:"bigint",minimum:a.value,inclusive:a.inclusive,message:a.message}),s.dirty()):a.kind==="max"?(a.inclusive?e.data>a.value:e.data>=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_big,type:"bigint",maximum:a.value,inclusive:a.inclusive,message:a.message}),s.dirty()):a.kind==="multipleOf"?e.data%a.value!==BigInt(0)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_multiple_of,multipleOf:a.value,message:a.message}),s.dirty()):x.assertNever(a);return{status:s.value,value:e.data}}_getInvalidInput(e){let t=this._getOrReturnCtx(e);return l(t,{code:d.invalid_type,expected:f.bigint,received:t.parsedType}),g}gte(e,t){return this.setLimit("min",e,!0,m.toString(t))}gt(e,t){return this.setLimit("min",e,!1,m.toString(t))}lte(e,t){return this.setLimit("max",e,!0,m.toString(t))}lt(e,t){return this.setLimit("max",e,!1,m.toString(t))}setLimit(e,t,r,s){return new n({...this._def,checks:[...this._def.checks,{kind:e,value:t,inclusive:r,message:m.toString(s)}]})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}positive(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!1,message:m.toString(e)})}negative(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!1,message:m.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!0,message:m.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!0,message:m.toString(e)})}multipleOf(e,t){return this._addCheck({kind:"multipleOf",value:e,message:m.toString(t)})}get minValue(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxValue(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}};G.create=n=>{var e;return new G({checks:[],typeName:h.ZodBigInt,coerce:(e=n?.coerce)!==null&&e!==void 0?e:!1,...v(n)})};var Q=class extends _{_parse(e){if(this._def.coerce&&(e.data=!!e.data),this._getType(e)!==f.boolean){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.boolean,received:r.parsedType}),g}return S(e.data)}};Q.create=n=>new Q({typeName:h.ZodBoolean,coerce:n?.coerce||!1,...v(n)});var Y=class n extends _{_parse(e){if(this._def.coerce&&(e.data=new Date(e.data)),this._getType(e)!==f.date){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.date,received:a.parsedType}),g}if(isNaN(e.data.getTime())){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_date}),g}let r=new w,s;for(let a of this._def.checks)a.kind==="min"?e.data.getTime()<a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_small,message:a.message,inclusive:!0,exact:!1,minimum:a.value,type:"date"}),r.dirty()):a.kind==="max"?e.data.getTime()>a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_big,message:a.message,inclusive:!0,exact:!1,maximum:a.value,type:"date"}),r.dirty()):x.assertNever(a);return{status:r.value,value:new Date(e.data.getTime())}}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}min(e,t){return this._addCheck({kind:"min",value:e.getTime(),message:m.toString(t)})}max(e,t){return this._addCheck({kind:"max",value:e.getTime(),message:m.toString(t)})}get minDate(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e!=null?new Date(e):null}get maxDate(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e!=null?new Date(e):null}};Y.create=n=>new Y({checks:[],coerce:n?.coerce||!1,typeName:h.ZodDate,...v(n)});var ge=class extends _{_parse(e){if(this._getType(e)!==f.symbol){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.symbol,received:r.parsedType}),g}return S(e.data)}};ge.create=n=>new ge({typeName:h.ZodSymbol,...v(n)});var K=class extends _{_parse(e){if(this._getType(e)!==f.undefined){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.undefined,received:r.parsedType}),g}return S(e.data)}};K.create=n=>new K({typeName:h.ZodUndefined,...v(n)});var X=class extends _{_parse(e){if(this._getType(e)!==f.null){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.null,received:r.parsedType}),g}return S(e.data)}};X.create=n=>new X({typeName:h.ZodNull,...v(n)});var F=class extends _{constructor(){super(...arguments),this._any=!0}_parse(e){return S(e.data)}};F.create=n=>new F({typeName:h.ZodAny,...v(n)});var L=class extends _{constructor(){super(...arguments),this._unknown=!0}_parse(e){return S(e.data)}};L.create=n=>new L({typeName:h.ZodUnknown,...v(n)});var R=class extends _{_parse(e){let t=this._getOrReturnCtx(e);return l(t,{code:d.invalid_type,expected:f.never,received:t.parsedType}),g}};R.create=n=>new R({typeName:h.ZodNever,...v(n)});var ye=class extends _{_parse(e){if(this._getType(e)!==f.undefined){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.void,received:r.parsedType}),g}return S(e.data)}};ye.create=n=>new ye({typeName:h.ZodVoid,...v(n)});var $=class n extends _{_parse(e){let{ctx:t,status:r}=this._processInputParams(e),s=this._def;if(t.parsedType!==f.array)return l(t,{code:d.invalid_type,expected:f.array,received:t.parsedType}),g;if(s.exactLength!==null){let i=t.data.length>s.exactLength.value,o=t.data.length<s.exactLength.value;(i||o)&&(l(t,{code:i?d.too_big:d.too_small,minimum:o?s.exactLength.value:void 0,maximum:i?s.exactLength.value:void 0,type:"array",inclusive:!0,exact:!0,message:s.exactLength.message}),r.dirty())}if(s.minLength!==null&&t.data.length<s.minLength.value&&(l(t,{code:d.too_small,minimum:s.minLength.value,type:"array",inclusive:!0,exact:!1,message:s.minLength.message}),r.dirty()),s.maxLength!==null&&t.data.length>s.maxLength.value&&(l(t,{code:d.too_big,maximum:s.maxLength.value,type:"array",inclusive:!0,exact:!1,message:s.maxLength.message}),r.dirty()),t.common.async)return Promise.all([...t.data].map((i,o)=>s.type._parseAsync(new O(t,i,t.path,o)))).then(i=>w.mergeArray(r,i));let a=[...t.data].map((i,o)=>s.type._parseSync(new O(t,i,t.path,o)));return w.mergeArray(r,a)}get element(){return this._def.type}min(e,t){return new n({...this._def,minLength:{value:e,message:m.toString(t)}})}max(e,t){return new n({...this._def,maxLength:{value:e,message:m.toString(t)}})}length(e,t){return new n({...this._def,exactLength:{value:e,message:m.toString(t)}})}nonempty(e){return this.min(1,e)}};$.create=(n,e)=>new $({type:n,minLength:null,maxLength:null,exactLength:null,typeName:h.ZodArray,...v(e)});function pe(n){if(n instanceof E){let e={};for(let t in n.shape){let r=n.shape[t];e[t]=A.create(pe(r))}return new E({...n._def,shape:()=>e})}else return n instanceof $?new $({...n._def,type:pe(n.element)}):n instanceof A?A.create(pe(n.unwrap())):n instanceof M?M.create(pe(n.unwrap())):n instanceof j?j.create(n.items.map(e=>pe(e))):n}var E=class n extends _{constructor(){super(...arguments),this._cached=null,this.nonstrict=this.passthrough,this.augment=this.extend}_getCached(){if(this._cached!==null)return this._cached;let e=this._def.shape(),t=x.objectKeys(e);return this._cached={shape:e,keys:t}}_parse(e){if(this._getType(e)!==f.object){let c=this._getOrReturnCtx(e);return l(c,{code:d.invalid_type,expected:f.object,received:c.parsedType}),g}let{status:r,ctx:s}=this._processInputParams(e),{shape:a,keys:i}=this._getCached(),o=[];if(!(this._def.catchall instanceof R&&this._def.unknownKeys==="strip"))for(let c in s.data)i.includes(c)||o.push(c);let u=[];for(let c of i){let p=a[c],b=s.data[c];u.push({key:{status:"valid",value:c},value:p._parse(new O(s,b,s.path,c)),alwaysSet:c in s.data})}if(this._def.catchall instanceof R){let c=this._def.unknownKeys;if(c==="passthrough")for(let p of o)u.push({key:{status:"valid",value:p},value:{status:"valid",value:s.data[p]}});else if(c==="strict")o.length>0&&(l(s,{code:d.unrecognized_keys,keys:o}),r.dirty());else if(c!=="strip")throw new Error("Internal ZodObject error: invalid unknownKeys value.")}else{let c=this._def.catchall;for(let p of o){let b=s.data[p];u.push({key:{status:"valid",value:p},value:c._parse(new O(s,b,s.path,p)),alwaysSet:p in s.data})}}return s.common.async?Promise.resolve().then(async()=>{let c=[];for(let p of u){let b=await p.key,T=await p.value;c.push({key:b,value:T,alwaysSet:p.alwaysSet})}return c}).then(c=>w.mergeObjectSync(r,c)):w.mergeObjectSync(r,u)}get shape(){return this._def.shape()}strict(e){return m.errToObj,new n({...this._def,unknownKeys:"strict",...e!==void 0?{errorMap:(t,r)=>{var s,a,i,o;let u=(i=(a=(s=this._def).errorMap)===null||a===void 0?void 0:a.call(s,t,r).message)!==null&&i!==void 0?i:r.defaultError;return t.code==="unrecognized_keys"?{message:(o=m.errToObj(e).message)!==null&&o!==void 0?o:u}:{message:u}}}:{}})}strip(){return new n({...this._def,unknownKeys:"strip"})}passthrough(){return new n({...this._def,unknownKeys:"passthrough"})}extend(e){return new n({...this._def,shape:()=>({...this._def.shape(),...e})})}merge(e){return new n({unknownKeys:e._def.unknownKeys,catchall:e._def.catchall,shape:()=>({...this._def.shape(),...e._def.shape()}),typeName:h.ZodObject})}setKey(e,t){return this.augment({[e]:t})}catchall(e){return new n({...this._def,catchall:e})}pick(e){let t={};return x.objectKeys(e).forEach(r=>{e[r]&&this.shape[r]&&(t[r]=this.shape[r])}),new n({...this._def,shape:()=>t})}omit(e){let t={};return x.objectKeys(this.shape).forEach(r=>{e[r]||(t[r]=this.shape[r])}),new n({...this._def,shape:()=>t})}deepPartial(){return pe(this)}partial(e){let t={};return x.objectKeys(this.shape).forEach(r=>{let s=this.shape[r];e&&!e[r]?t[r]=s:t[r]=s.optional()}),new n({...this._def,shape:()=>t})}required(e){let t={};return x.objectKeys(this.shape).forEach(r=>{if(e&&!e[r])t[r]=this.shape[r];else{let a=this.shape[r];for(;a instanceof A;)a=a._def.innerType;t[r]=a}}),new n({...this._def,shape:()=>t})}keyof(){return bt(x.objectKeys(this.shape))}};E.create=(n,e)=>new E({shape:()=>n,unknownKeys:"strip",catchall:R.create(),typeName:h.ZodObject,...v(e)});E.strictCreate=(n,e)=>new E({shape:()=>n,unknownKeys:"strict",catchall:R.create(),typeName:h.ZodObject,...v(e)});E.lazycreate=(n,e)=>new E({shape:n,unknownKeys:"strip",catchall:R.create(),typeName:h.ZodObject,...v(e)});var ee=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=this._def.options;function s(a){for(let o of a)if(o.result.status==="valid")return o.result;for(let o of a)if(o.result.status==="dirty")return t.common.issues.push(...o.ctx.common.issues),o.result;let i=a.map(o=>new C(o.ctx.common.issues));return l(t,{code:d.invalid_union,unionErrors:i}),g}if(t.common.async)return Promise.all(r.map(async a=>{let i={...t,common:{...t.common,issues:[]},parent:null};return{result:await a._parseAsync({data:t.data,path:t.path,parent:i}),ctx:i}})).then(s);{let a,i=[];for(let u of r){let c={...t,common:{...t.common,issues:[]},parent:null},p=u._parseSync({data:t.data,path:t.path,parent:c});if(p.status==="valid")return p;p.status==="dirty"&&!a&&(a={result:p,ctx:c}),c.common.issues.length&&i.push(c.common.issues)}if(a)return t.common.issues.push(...a.ctx.common.issues),a.result;let o=i.map(u=>new C(u));return l(t,{code:d.invalid_union,unionErrors:o}),g}}get options(){return this._def.options}};ee.create=(n,e)=>new ee({options:n,typeName:h.ZodUnion,...v(e)});var Z=n=>n instanceof ne?Z(n.schema):n instanceof I?Z(n.innerType()):n instanceof re?[n.value]:n instanceof se?n.options:n instanceof ae?x.objectValues(n.enum):n instanceof ie?Z(n._def.innerType):n instanceof K?[void 0]:n instanceof X?[null]:n instanceof A?[void 0,...Z(n.unwrap())]:n instanceof M?[null,...Z(n.unwrap())]:n instanceof Ce||n instanceof ce?Z(n.unwrap()):n instanceof oe?Z(n._def.innerType):[],$e=class n extends _{_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.object)return l(t,{code:d.invalid_type,expected:f.object,received:t.parsedType}),g;let r=this.discriminator,s=t.data[r],a=this.optionsMap.get(s);return a?t.common.async?a._parseAsync({data:t.data,path:t.path,parent:t}):a._parseSync({data:t.data,path:t.path,parent:t}):(l(t,{code:d.invalid_union_discriminator,options:Array.from(this.optionsMap.keys()),path:[r]}),g)}get discriminator(){return this._def.discriminator}get options(){return this._def.options}get optionsMap(){return this._def.optionsMap}static create(e,t,r){let s=new Map;for(let a of t){let i=Z(a.shape[e]);if(!i.length)throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);for(let o of i){if(s.has(o))throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);s.set(o,a)}}return new n({typeName:h.ZodDiscriminatedUnion,discriminator:e,options:t,optionsMap:s,...v(r)})}};function st(n,e){let t=U(n),r=U(e);if(n===e)return{valid:!0,data:n};if(t===f.object&&r===f.object){let s=x.objectKeys(e),a=x.objectKeys(n).filter(o=>s.indexOf(o)!==-1),i={...n,...e};for(let o of a){let u=st(n[o],e[o]);if(!u.valid)return{valid:!1};i[o]=u.data}return{valid:!0,data:i}}else if(t===f.array&&r===f.array){if(n.length!==e.length)return{valid:!1};let s=[];for(let a=0;a<n.length;a++){let i=n[a],o=e[a],u=st(i,o);if(!u.valid)return{valid:!1};s.push(u.data)}return{valid:!0,data:s}}else return t===f.date&&r===f.date&&+n==+e?{valid:!0,data:n}:{valid:!1}}var te=class extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e),s=(a,i)=>{if(nt(a)||nt(i))return g;let o=st(a.value,i.value);return o.valid?((rt(a)||rt(i))&&t.dirty(),{status:t.value,value:o.data}):(l(r,{code:d.invalid_intersection_types}),g)};return r.common.async?Promise.all([this._def.left._parseAsync({data:r.data,path:r.path,parent:r}),this._def.right._parseAsync({data:r.data,path:r.path,parent:r})]).then(([a,i])=>s(a,i)):s(this._def.left._parseSync({data:r.data,path:r.path,parent:r}),this._def.right._parseSync({data:r.data,path:r.path,parent:r}))}};te.create=(n,e,t)=>new te({left:n,right:e,typeName:h.ZodIntersection,...v(t)});var j=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.array)return l(r,{code:d.invalid_type,expected:f.array,received:r.parsedType}),g;if(r.data.length<this._def.items.length)return l(r,{code:d.too_small,minimum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),g;!this._def.rest&&r.data.length>this._def.items.length&&(l(r,{code:d.too_big,maximum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),t.dirty());let a=[...r.data].map((i,o)=>{let u=this._def.items[o]||this._def.rest;return u?u._parse(new O(r,i,r.path,o)):null}).filter(i=>!!i);return r.common.async?Promise.all(a).then(i=>w.mergeArray(t,i)):w.mergeArray(t,a)}get items(){return this._def.items}rest(e){return new n({...this._def,rest:e})}};j.create=(n,e)=>{if(!Array.isArray(n))throw new Error("You must pass an array of schemas to z.tuple([ ... ])");return new j({items:n,typeName:h.ZodTuple,rest:null,...v(e)})};var Be=class n extends _{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.object)return l(r,{code:d.invalid_type,expected:f.object,received:r.parsedType}),g;let s=[],a=this._def.keyType,i=this._def.valueType;for(let o in r.data)s.push({key:a._parse(new O(r,o,r.path,o)),value:i._parse(new O(r,r.data[o],r.path,o)),alwaysSet:o in r.data});return r.common.async?w.mergeObjectAsync(t,s):w.mergeObjectSync(t,s)}get element(){return this._def.valueType}static create(e,t,r){return t instanceof _?new n({keyType:e,valueType:t,typeName:h.ZodRecord,...v(r)}):new n({keyType:z.create(),valueType:e,typeName:h.ZodRecord,...v(t)})}},ve=class extends _{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.map)return l(r,{code:d.invalid_type,expected:f.map,received:r.parsedType}),g;let s=this._def.keyType,a=this._def.valueType,i=[...r.data.entries()].map(([o,u],c)=>({key:s._parse(new O(r,o,r.path,[c,"key"])),value:a._parse(new O(r,u,r.path,[c,"value"]))}));if(r.common.async){let o=new Map;return Promise.resolve().then(async()=>{for(let u of i){let c=await u.key,p=await u.value;if(c.status==="aborted"||p.status==="aborted")return g;(c.status==="dirty"||p.status==="dirty")&&t.dirty(),o.set(c.value,p.value)}return{status:t.value,value:o}})}else{let o=new Map;for(let u of i){let c=u.key,p=u.value;if(c.status==="aborted"||p.status==="aborted")return g;(c.status==="dirty"||p.status==="dirty")&&t.dirty(),o.set(c.value,p.value)}return{status:t.value,value:o}}}};ve.create=(n,e,t)=>new ve({valueType:e,keyType:n,typeName:h.ZodMap,...v(t)});var _e=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.set)return l(r,{code:d.invalid_type,expected:f.set,received:r.parsedType}),g;let s=this._def;s.minSize!==null&&r.data.size<s.minSize.value&&(l(r,{code:d.too_small,minimum:s.minSize.value,type:"set",inclusive:!0,exact:!1,message:s.minSize.message}),t.dirty()),s.maxSize!==null&&r.data.size>s.maxSize.value&&(l(r,{code:d.too_big,maximum:s.maxSize.value,type:"set",inclusive:!0,exact:!1,message:s.maxSize.message}),t.dirty());let a=this._def.valueType;function i(u){let c=new Set;for(let p of u){if(p.status==="aborted")return g;p.status==="dirty"&&t.dirty(),c.add(p.value)}return{status:t.value,value:c}}let o=[...r.data.values()].map((u,c)=>a._parse(new O(r,u,r.path,c)));return r.common.async?Promise.all(o).then(u=>i(u)):i(o)}min(e,t){return new n({...this._def,minSize:{value:e,message:m.toString(t)}})}max(e,t){return new n({...this._def,maxSize:{value:e,message:m.toString(t)}})}size(e,t){return this.min(e,t).max(e,t)}nonempty(e){return this.min(1,e)}};_e.create=(n,e)=>new _e({valueType:n,minSize:null,maxSize:null,typeName:h.ZodSet,...v(e)});var ze=class n extends _{constructor(){super(...arguments),this.validate=this.implement}_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.function)return l(t,{code:d.invalid_type,expected:f.function,received:t.parsedType}),g;function r(o,u){return Ue({data:o,path:t.path,errorMaps:[t.common.contextualErrorMap,t.schemaErrorMap,Ze(),he].filter(c=>!!c),issueData:{code:d.invalid_arguments,argumentsError:u}})}function s(o,u){return Ue({data:o,path:t.path,errorMaps:[t.common.contextualErrorMap,t.schemaErrorMap,Ze(),he].filter(c=>!!c),issueData:{code:d.invalid_return_type,returnTypeError:u}})}let a={errorMap:t.common.contextualErrorMap},i=t.data;if(this._def.returns instanceof q){let o=this;return S(async function(...u){let c=new C([]),p=await o._def.args.parseAsync(u,a).catch(N=>{throw c.addIssue(r(u,N)),c}),b=await Reflect.apply(i,this,p);return await o._def.returns._def.type.parseAsync(b,a).catch(N=>{throw c.addIssue(s(b,N)),c})})}else{let o=this;return S(function(...u){let c=o._def.args.safeParse(u,a);if(!c.success)throw new C([r(u,c.error)]);let p=Reflect.apply(i,this,c.data),b=o._def.returns.safeParse(p,a);if(!b.success)throw new C([s(p,b.error)]);return b.data})}}parameters(){return this._def.args}returnType(){return this._def.returns}args(...e){return new n({...this._def,args:j.create(e).rest(L.create())})}returns(e){return new n({...this._def,returns:e})}implement(e){return this.parse(e)}strictImplement(e){return this.parse(e)}static create(e,t,r){return new n({args:e||j.create([]).rest(L.create()),returns:t||L.create(),typeName:h.ZodFunction,...v(r)})}},ne=class extends _{get schema(){return this._def.getter()}_parse(e){let{ctx:t}=this._processInputParams(e);return this._def.getter()._parse({data:t.data,path:t.path,parent:t})}};ne.create=(n,e)=>new ne({getter:n,typeName:h.ZodLazy,...v(e)});var re=class extends _{_parse(e){if(e.data!==this._def.value){let t=this._getOrReturnCtx(e);return l(t,{received:t.data,code:d.invalid_literal,expected:this._def.value}),g}return{status:"valid",value:e.data}}get value(){return this._def.value}};re.create=(n,e)=>new re({value:n,typeName:h.ZodLiteral,...v(e)});function bt(n,e){return new se({values:n,typeName:h.ZodEnum,...v(e)})}var se=class n extends _{constructor(){super(...arguments),Se.set(this,void 0)}_parse(e){if(typeof e.data!="string"){let t=this._getOrReturnCtx(e),r=this._def.values;return l(t,{expected:x.joinValues(r),received:t.parsedType,code:d.invalid_type}),g}if(Le(this,Se,"f")||yt(this,Se,new Set(this._def.values),"f"),!Le(this,Se,"f").has(e.data)){let t=this._getOrReturnCtx(e),r=this._def.values;return l(t,{received:t.data,code:d.invalid_enum_value,options:r}),g}return S(e.data)}get options(){return this._def.values}get enum(){let e={};for(let t of this._def.values)e[t]=t;return e}get Values(){let e={};for(let t of this._def.values)e[t]=t;return e}get Enum(){let e={};for(let t of this._def.values)e[t]=t;return e}extract(e,t=this._def){return n.create(e,{...this._def,...t})}exclude(e,t=this._def){return n.create(this.options.filter(r=>!e.includes(r)),{...this._def,...t})}};Se=new WeakMap;se.create=bt;var ae=class extends _{constructor(){super(...arguments),Te.set(this,void 0)}_parse(e){let t=x.getValidEnumValues(this._def.values),r=this._getOrReturnCtx(e);if(r.parsedType!==f.string&&r.parsedType!==f.number){let s=x.objectValues(t);return l(r,{expected:x.joinValues(s),received:r.parsedType,code:d.invalid_type}),g}if(Le(this,Te,"f")||yt(this,Te,new Set(x.getValidEnumValues(this._def.values)),"f"),!Le(this,Te,"f").has(e.data)){let s=x.objectValues(t);return l(r,{received:r.data,code:d.invalid_enum_value,options:s}),g}return S(e.data)}get enum(){return this._def.values}};Te=new WeakMap;ae.create=(n,e)=>new ae({values:n,typeName:h.ZodNativeEnum,...v(e)});var q=class extends _{unwrap(){return this._def.type}_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.promise&&t.common.async===!1)return l(t,{code:d.invalid_type,expected:f.promise,received:t.parsedType}),g;let r=t.parsedType===f.promise?t.data:Promise.resolve(t.data);return S(r.then(s=>this._def.type.parseAsync(s,{path:t.path,errorMap:t.common.contextualErrorMap})))}};q.create=(n,e)=>new q({type:n,typeName:h.ZodPromise,...v(e)});var I=class extends _{innerType(){return this._def.schema}sourceType(){return this._def.schema._def.typeName===h.ZodEffects?this._def.schema.sourceType():this._def.schema}_parse(e){let{status:t,ctx:r}=this._processInputParams(e),s=this._def.effect||null,a={addIssue:i=>{l(r,i),i.fatal?t.abort():t.dirty()},get path(){return r.path}};if(a.addIssue=a.addIssue.bind(a),s.type==="preprocess"){let i=s.transform(r.data,a);if(r.common.async)return Promise.resolve(i).then(async o=>{if(t.value==="aborted")return g;let u=await this._def.schema._parseAsync({data:o,path:r.path,parent:r});return u.status==="aborted"?g:u.status==="dirty"||t.value==="dirty"?me(u.value):u});{if(t.value==="aborted")return g;let o=this._def.schema._parseSync({data:i,path:r.path,parent:r});return o.status==="aborted"?g:o.status==="dirty"||t.value==="dirty"?me(o.value):o}}if(s.type==="refinement"){let i=o=>{let u=s.refinement(o,a);if(r.common.async)return Promise.resolve(u);if(u instanceof Promise)throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");return o};if(r.common.async===!1){let o=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});return o.status==="aborted"?g:(o.status==="dirty"&&t.dirty(),i(o.value),{status:t.value,value:o.value})}else return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then(o=>o.status==="aborted"?g:(o.status==="dirty"&&t.dirty(),i(o.value).then(()=>({status:t.value,value:o.value}))))}if(s.type==="transform")if(r.common.async===!1){let i=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});if(!H(i))return i;let o=s.transform(i.value,a);if(o instanceof Promise)throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");return{status:t.value,value:o}}else return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then(i=>H(i)?Promise.resolve(s.transform(i.value,a)).then(o=>({status:t.value,value:o})):i);x.assertNever(s)}};I.create=(n,e,t)=>new I({schema:n,typeName:h.ZodEffects,effect:e,...v(t)});I.createWithPreprocess=(n,e,t)=>new I({schema:e,effect:{type:"preprocess",transform:n},typeName:h.ZodEffects,...v(t)});var A=class extends _{_parse(e){return this._getType(e)===f.undefined?S(void 0):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}};A.create=(n,e)=>new A({innerType:n,typeName:h.ZodOptional,...v(e)});var M=class extends _{_parse(e){return this._getType(e)===f.null?S(null):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}};M.create=(n,e)=>new M({innerType:n,typeName:h.ZodNullable,...v(e)});var ie=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=t.data;return t.parsedType===f.undefined&&(r=this._def.defaultValue()),this._def.innerType._parse({data:r,path:t.path,parent:t})}removeDefault(){return this._def.innerType}};ie.create=(n,e)=>new ie({innerType:n,typeName:h.ZodDefault,defaultValue:typeof e.default=="function"?e.default:()=>e.default,...v(e)});var oe=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r={...t,common:{...t.common,issues:[]}},s=this._def.innerType._parse({data:r.data,path:r.path,parent:{...r}});return Ee(s)?s.then(a=>({status:"valid",value:a.status==="valid"?a.value:this._def.catchValue({get error(){return new C(r.common.issues)},input:r.data})})):{status:"valid",value:s.status==="valid"?s.value:this._def.catchValue({get error(){return new C(r.common.issues)},input:r.data})}}removeCatch(){return this._def.innerType}};oe.create=(n,e)=>new oe({innerType:n,typeName:h.ZodCatch,catchValue:typeof e.catch=="function"?e.catch:()=>e.catch,...v(e)});var xe=class extends _{_parse(e){if(this._getType(e)!==f.nan){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.nan,received:r.parsedType}),g}return{status:"valid",value:e.data}}};xe.create=n=>new xe({typeName:h.ZodNaN,...v(n)});var Zn=Symbol("zod_brand"),Ce=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=t.data;return this._def.type._parse({data:r,path:t.path,parent:t})}unwrap(){return this._def.type}},Ie=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.common.async)return(async()=>{let a=await this._def.in._parseAsync({data:r.data,path:r.path,parent:r});return a.status==="aborted"?g:a.status==="dirty"?(t.dirty(),me(a.value)):this._def.out._parseAsync({data:a.value,path:r.path,parent:r})})();{let s=this._def.in._parseSync({data:r.data,path:r.path,parent:r});return s.status==="aborted"?g:s.status==="dirty"?(t.dirty(),{status:"dirty",value:s.value}):this._def.out._parseSync({data:s.value,path:r.path,parent:r})}}static create(e,t){return new n({in:e,out:t,typeName:h.ZodPipeline})}},ce=class extends _{_parse(e){let t=this._def.innerType._parse(e),r=s=>(H(s)&&(s.value=Object.freeze(s.value)),s);return Ee(t)?t.then(s=>r(s)):r(t)}unwrap(){return this._def.innerType}};ce.create=(n,e)=>new ce({innerType:n,typeName:h.ZodReadonly,...v(e)});function mt(n,e){let t=typeof n=="function"?n(e):typeof n=="string"?{message:n}:n;return typeof t=="string"?{message:t}:t}function wt(n,e={},t){return n?F.create().superRefine((r,s)=>{var a,i;let o=n(r);if(o instanceof Promise)return o.then(u=>{var c,p;if(!u){let b=mt(e,r),T=(p=(c=b.fatal)!==null&&c!==void 0?c:t)!==null&&p!==void 0?p:!0;s.addIssue({code:"custom",...b,fatal:T})}});if(!o){let u=mt(e,r),c=(i=(a=u.fatal)!==null&&a!==void 0?a:t)!==null&&i!==void 0?i:!0;s.addIssue({code:"custom",...u,fatal:c})}}):F.create()}var Un={object:E.lazycreate},h;(function(n){n.ZodString="ZodString",n.ZodNumber="ZodNumber",n.ZodNaN="ZodNaN",n.ZodBigInt="ZodBigInt",n.ZodBoolean="ZodBoolean",n.ZodDate="ZodDate",n.ZodSymbol="ZodSymbol",n.ZodUndefined="ZodUndefined",n.ZodNull="ZodNull",n.ZodAny="ZodAny",n.ZodUnknown="ZodUnknown",n.ZodNever="ZodNever",n.ZodVoid="ZodVoid",n.ZodArray="ZodArray",n.ZodObject="ZodObject",n.ZodUnion="ZodUnion",n.ZodDiscriminatedUnion="ZodDiscriminatedUnion",n.ZodIntersection="ZodIntersection",n.ZodTuple="ZodTuple",n.ZodRecord="ZodRecord",n.ZodMap="ZodMap",n.ZodSet="ZodSet",n.ZodFunction="ZodFunction",n.ZodLazy="ZodLazy",n.ZodLiteral="ZodLiteral",n.ZodEnum="ZodEnum",n.ZodEffects="ZodEffects",n.ZodNativeEnum="ZodNativeEnum",n.ZodOptional="ZodOptional",n.ZodNullable="ZodNullable",n.ZodDefault="ZodDefault",n.ZodCatch="ZodCatch",n.ZodPromise="ZodPromise",n.ZodBranded="ZodBranded",n.ZodPipeline="ZodPipeline",n.ZodReadonly="ZodReadonly"})(h||(h={}));var Ln=(n,e={message:`Input not instance of ${n.name}`})=>wt(t=>t instanceof n,e),kt=z.create,St=W.create,$n=xe.create,Bn=G.create,Tt=Q.create,zn=Y.create,Fn=ge.create,qn=K.create,Jn=X.create,Hn=F.create,Wn=L.create,Gn=R.create,Qn=ye.create,Yn=$.create,Kn=E.create,Xn=E.strictCreate,er=ee.create,tr=$e.create,nr=te.create,rr=j.create,sr=Be.create,ar=ve.create,ir=_e.create,or=ze.create,cr=ne.create,dr=re.create,ur=se.create,lr=ae.create,fr=q.create,ht=I.create,pr=A.create,mr=M.create,hr=I.createWithPreprocess,gr=Ie.create,yr=()=>kt().optional(),vr=()=>St().optional(),_r=()=>Tt().optional(),xr={string:n=>z.create({...n,coerce:!0}),number:n=>W.create({...n,coerce:!0}),boolean:n=>Q.create({...n,coerce:!0}),bigint:n=>G.create({...n,coerce:!0}),date:n=>Y.create({...n,coerce:!0})},br=g,y=Object.freeze({__proto__:null,defaultErrorMap:he,setErrorMap:hn,getErrorMap:Ze,makeIssue:Ue,EMPTY_PATH:gn,addIssueToContext:l,ParseStatus:w,INVALID:g,DIRTY:me,OK:S,isAborted:nt,isDirty:rt,isValid:H,isAsync:Ee,get util(){return x},get objectUtil(){return tt},ZodParsedType:f,getParsedType:U,ZodType:_,datetimeRegex:xt,ZodString:z,ZodNumber:W,ZodBigInt:G,ZodBoolean:Q,ZodDate:Y,ZodSymbol:ge,ZodUndefined:K,ZodNull:X,ZodAny:F,ZodUnknown:L,ZodNever:R,ZodVoid:ye,ZodArray:$,ZodObject:E,ZodUnion:ee,ZodDiscriminatedUnion:$e,ZodIntersection:te,ZodTuple:j,ZodRecord:Be,ZodMap:ve,ZodSet:_e,ZodFunction:ze,ZodLazy:ne,ZodLiteral:re,ZodEnum:se,ZodNativeEnum:ae,ZodPromise:q,ZodEffects:I,ZodTransformer:I,ZodOptional:A,ZodNullable:M,ZodDefault:ie,ZodCatch:oe,ZodNaN:xe,BRAND:Zn,ZodBranded:Ce,ZodPipeline:Ie,ZodReadonly:ce,custom:wt,Schema:_,ZodSchema:_,late:Un,get ZodFirstPartyTypeKind(){return h},coerce:xr,any:Hn,array:Yn,bigint:Bn,boolean:Tt,date:zn,discriminatedUnion:tr,effect:ht,enum:ur,function:or,instanceof:Ln,intersection:nr,lazy:cr,literal:dr,map:ar,nan:$n,nativeEnum:lr,never:Gn,null:Jn,nullable:mr,number:St,object:Kn,oboolean:_r,onumber:vr,optional:pr,ostring:yr,pipeline:gr,preprocess:hr,promise:fr,record:sr,set:ir,strictObject:Xn,string:kt,symbol:Fn,transformer:ht,tuple:rr,undefined:qn,union:er,unknown:Wn,void:Qn,NEVER:br,ZodIssueCode:d,quotelessJson:mn,ZodError:C});function Et(){let n="",e="abcdefghijklmnopqrstuvwxyz0123456789";for(let t=0;t<36;t++)Math.random()>.8&&t!==0&&t!==35&&n[t-1]!=="-"?n+="-":n+=e.charAt(Math.floor(Math.random()*e.length));return n}var wr=()=>{let n=new Date().getTime();return typeof performance<"u"&&typeof performance.now=="function"&&(n+=performance.now()),"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,e=>{let t=(n+Math.random()*16)%16|0;return n=Math.floor(n/16),(e==="x"?t:t&3|8).toString(16)})},Ae=()=>{try{let n=wr();return n||Et()}catch(n){console.error(n)}return Et()},Ct=()=>Ae(),It=()=>Ae(),At=()=>Ae();var J={GI:"GI",MMT:"MMT"};var at=class n{constructor(){this.settings={}}static getInstance(){return n.instance||(n.instance=new n,Object.freeze(n.instance)),n.instance}setSetting(e,t){this.settings[e]=t}getSetting(e){return this.settings[e]}},D=at.getInstance();function Pt(){return typeof window<"u"}function de(n){let e={};for(let t in n)if(Object.prototype.hasOwnProperty.call(n,t)){let r=n[t];r!=null&&r!=="NA"&&r!==""&&(typeof r!="object"||Object.keys(r).length>0)&&(!Array.isArray(r)||r.length>0)&&(e[t]=r)}return e}function k(n,e){let t=n.split("; ");for(let r=0;r<t.length;r++){let s=t[r];if(s.indexOf(e+"=")===0)return s.substring(e.length+1)}return null}function kr(n,e){try{let t="",r=0;if(!e)throw new Error("Key is empty");for(let s=0;s<n.length;s+=1){let a=n.charCodeAt(s),i=e.charCodeAt(r),o=a^i;t+=String.fromCharCode(o),r=(r+1)%e.length}return t}catch(t){return console.error("An error occurred during the decryption process:",t),null}}function it(n){let e=sessionStorage.getItem("userInfo")||localStorage.getItem("userInfo");if(!e)return console.log("userInfo is not found in sessionStorage"),null;if(n)return JSON.parse(e);let t=new RegExp("^enct-"),r=e.replace(t,""),s=kr(r,"awefewfuihewfhewfuhiebc");if(!s)return console.error("Decryption failed"),null;try{return JSON.parse(s)}catch(a){return console.error("Error parsing JSON:",a),null}}function Rt(){let n="marketingCloudVisitorID",e=window?.s?.marketingCloudVisitorID,t=localStorage.getItem(n),r=k(document?.cookie,"s_ecid");return r?decodeURI(r)?.split("|")[1]:e?(e!=t&&localStorage.setItem(n,e),e):t||"NA"}function Fe(n){return it(n===J.GI)}function Oe(n){if(!n)return null;let{uuid:e="",profile_type:t="PERSONAL"}=n;return t&&e?`${e}/${t.toUpperCase()}`:null}function Sr(n){let t=window.location.search.substring(1).split("&");for(let r=0;r<t.length;r++){let s=t[r].split("="),a=decodeURIComponent(s[0]),i=decodeURIComponent(s[1]);if(a===n)return i}}function ot(){let n=Sr("cmp");return n?{campaign_key:n}:null}function Pe(n){return n?/^https?:\/\//i.test(n)?n:`https://${n}`:`https://pdt.${(typeof window<"u"?window.location.hostname:"")?.split(".")?.slice(-2)?.join(".")||"makemytrip.com"}`}function Dt(n,e){let t=e||(typeof window<"u"?window.location.hostname:""),r={};return Nt(t)&&(r={"entity-name":t&&t.includes(".global")?"global":"india"}),{...n,...r}}var Tr={in:"inr",ae:"aed",sa:"sar"};function Er(){return(typeof window<"u"?window.location.hostname:"").includes("goibibo")}function Nt(n){return(n||(typeof window<"u"?window.location.hostname:"")).includes("makemytrip")}function Cr(){return{entity:"india",currency:"inr",region:"in",user_language:"eng",organisation:"gi"}}function Ot(){let n=typeof window<"u"?window.location.hostname:"",e=n&&n.includes(".global")?"global":"india",t=Re(),{region:r,userCountry:s,language:a,userCurrency:i,currency:o,isWorldwide:u}=t;return{entity:e,currency:o,region:r,user_currency:i,user_country:u?s:r,user_language:a,organisation:"mmt"}}function jt(){return Nt()?Ot():Er()?Cr():Ot()}function Re(){let n=k(document?.cookie,"cc")?.toLowerCase()||"in",e=k(document?.cookie,"ccde")?.toLowerCase()||"in",t=k(document?.cookie,"isWorldwide"),r=k(document?.cookie,"lang")?.toLowerCase()||"eng",s=k(document?.cookie,"userCurrency")?.toLowerCase()||"",a=t?parseInt(t):0;return{currency:e?Tr[e]:"",isWorldwide:a,language:r,region:e,userCountry:n,userCurrency:s}}var B={b2b:"business",b2c:"personal",myPartner:"cta"};function De(){let n=k(document?.cookie,"myBusinessSubscription");return B[n]||B.b2c}function Mt(n){return n===J.GI}function Ir(n){if(!n||typeof n!="string")return{};let e={};return n.split("|").forEach(r=>{let[s,a]=r.split(":");s&&a!==void 0&&(e[s.trim()]=a.trim())}),e}function Vt(){let n=De(),e=Fe();if(n===B.myPartner)return{user_role:e?.userCorpData?.agentRole,org_id:e?.userCorpData?.agencyUUID};if(n===B.b2b){let t=localStorage.getItem("myBizOrgContext")||"";if(!t)return{};let r=Ir(t);return{org_id:e?.userCorpData?.organizationId,org_type:e?.userCorpData?.orgType,verification_status:e?.userCorpData?.employeeStatus,user_role:e?.userCorpData?.employeeType,...r}}return{}}var Zt="4.3.0";var P="NA",Ne=n=>{let{screen:e,navigator:t}=n,r=Re(),{userCountry:s,isWorldwide:a,region:i}=r,o=a?s:i,u="",c=P,p=P;e&&e.width&&(c=e.width?`${e.width}`:P,p=e.height?`${e.height}`:P,u+=`${c}*${p}`);let b=k(document.cookie,"dvid")||k(document.cookie,"__gi_vid")||P,T=P;"connection"in n.navigator&&typeof n.navigator.connection=="object"&&n.navigator.connection&&"effectiveType"in n.navigator.connection&&typeof n.navigator.connection.effectiveType=="string"&&(T=n.navigator.connection.effectiveType);let{browser:N,os:ke,device:V}=ua_parser(t.userAgent),le;switch(V.type?.toLowerCase()){case"mobile":case"tablet":le="pwa";break;default:le="desktop";break}return{deviceId:b,os:ke.name?.toLowerCase()||P,osVersion:ke.version||P,browser:N.name||P,version:Zt||P,userAgent:t.userAgent,screenSize:u,screenWidth:c,screenHeight:p,networkType:T,platform:le,model:V.model||P,manufacturer:V.vendor||P,acquired_country:o}};var Lt="session_info";async function qe(n,e){await e.setItem(Lt,JSON.stringify(n))}async function Pr(n){let e=await n.getItem(Lt);return e?JSON.parse(e):null}var Ut={inActiveThresholdInMins:30,expiryInMins:120};function Rr(n){if(!n)return!1;let e=Date.now(),t=(e-n.createdAt)/6e4>Ut.expiryInMins,r=(e-n.lastUsed)/6e4>Ut.inActiveThresholdInMins;return!t&&!r}async function Dr(n){let e=Date.now(),t={createdAt:e,lastUsed:e,id:At(),isSynced:!1,retry:0};return await qe(t,n),setTimeout(async()=>{await je(!0,void 0,n)},0),t}async function ue(n){let e=await Pr(n);return Rr(e)?e:Dr(n)}var be=class{constructor(e){this.storage=e}async getCurrentSessionId(){return(await ue(this.storage)).id}async updateLastUsed(){let e=await ue(this.storage);await qe({...e,lastUsed:Date.now()},this.storage)}async lastUsed(){return(await ue(this.storage)).lastUsed}async updateSyncStatus(){let e=await ue(this.storage);await qe({...e,isSynced:!e?.isSynced},this.storage)}async getSyncStatus(){return(await ue(this.storage)).isSynced}async getRetryStatus(){return(await ue(this.storage)).retry}async updateRetryStatus(){let e=await ue(this.storage);await qe({...e,retry:e?.retry+1},this.storage)}};var Nr="/fs/w",jr={"Content-Type":"application/json","Request-Data-Encoding":"json"},Mr="NA",Vr="mmt_session_aero_store";async function Zr({userId:n,sessionManager:e,deviceDetails:t}){let r=typeof sessionStorage<"u"?it():null,s=n;if(r!==null&&typeof r=="object"){let{uuid:u,profileType:c}=r,p=Oe({uuid:u,profile_type:c});s=n||p}let a=t?.device_id||k(document.cookie,"dvid")||Mr,i=t?.platform||Ne(window)?.platform,o=await e.getCurrentSessionId();return JSON.stringify([{uuidPT:s,deviceId:a,value:{session_id:o},column:i==="pwa"?"pwa":"desktop",datasetName:Vr}])}var je=async(n,e,t)=>{if(!n)return"success";let r=t||ct(),s=e||new be(r),a=await s.getSyncStatus(),i=await s.getRetryStatus(),o=D.getSetting("userIdPt"),u=D.getSetting("deviceContext");if(a||i>6)return"success";try{let c=D.getSetting("pdtHost"),p=`${Pe(c)}${Nr}`,b=await Zr({userId:o,sessionManager:s,deviceDetails:u}),T=await fetch(p,{method:"POST",body:b,headers:jr,keepalive:!0});if(!T.ok)throw new Error(`HTTP error! status: ${T.status}`);return await s.updateSyncStatus(),"success"}catch(c){return console.log("Failed to sync session ID to PDT DB:",c),s.updateRetryStatus(),"failure"}};var $t=200,dt="error",Me="page-rendered",Bt=y.enum(["mmt","gi"]),zt=y.enum(["india","global"]),Ft=y.enum(["in","ae","sa"]),qt=y.enum(["inr","usd","aed","sar"]),Jt=y.enum(["eng","hin","tam","ara"]),Ht=y.enum(["personal","business","cta","affiliates"]),Wt=y.enum(["desktop","pwa","mobile"]),Gt=y.enum(["android","ios","mac os","windows","linux","blackberry","symbian","nokia","webos","unix","samsung","other"]),Qt=y.enum(["landing","funnel","template","promo"]),Yt=y.enum(["landing","listing","detail","review","payment","thankyou"]),Kt=y.enum(["common","flights","hotels","bus","rails","cabs","holidays","travelinsurance","forex","giftcards","visa","w2g","acme","how2go","travelcard","hostapp","postsales"]),Xt=y.enum(["common","df","if","dh","ih","bus","rails","dom_acabs","dom_ocabs","dom_hrcabs","intl_acabs","intl_ocabs","intl_hrcabs","domhld","intlhld","travelinsurance","forex","pc","cn","nc","giftcards","e-visa","sticker-visa","w2g","dom_acme","intl_acme","how2go","travelcard","hostapp"]),en=y.enum([Me,dt,"search-clicked","sort_by-clicked","filter-applied","filter_all-cleared","content_card_filter-clicked","content_header-filter-clicked","map_filter-clicked","product_card_filter-clicked","popup-rendered","login-succeeded","user-logged-out","signup-completed","chat-interacted","send-quote","price-change"]);var Ur=y.object({webPageDetails:y.object({name:y.string().min(1,{message:"webPageDetails.name cannot be empty"}),pageViews:y.object({value:y.number()}),isErrorPage:y.boolean().optional()})}),Lr=y.object({webInteraction:y.object({name:y.string().nullable(),type:y.string().nullable().optional(),url:y.string().nullable().optional(),linkClicks:y.object({value:y.number()})})}),tn=n=>y.object({event:y.string(),web:n===Me?Ur:Lr}).passthrough();var nn=y.object({entity_info:y.object({organisation:Bt,entity:zt,region:Ft,currency:qt,user_language:Jt}),user_context:y.object({profile_type:Ht}),device_context:y.object({platform:Wt,os:Gt}),page_context:y.object({page_type:Qt,funnel_step:Yt,page_name:y.string().min(1,{message:"page_name cannot be empty"}),lob:Kt,lob_category:Xt}),event_detail:y.object({event_type:y.string().min(1,{message:"event_type cannot be empty"}),event_name:y.string().min(1,{message:"event_name cannot be empty"})})}),Je=n=>n.issues.map(e=>({path:e.path.join("."),message:e.message,code:e.code}));var He=class{constructor(e,t){let r=this.createAdobeSchema(e,t);this.validateAdobeSchema(r),this.adobeSchema=r,this.pushToADL()}createAdobeSchema(e,t){let r=`xdm_${e.event_detail.event_name}`,s;return e.event_detail.event_name===Me?(s={webPageDetails:{name:e.page_context.page_name||window.location.pathname,pageViews:{value:1}}},e?.error_details_list?.length&&(s.webPageDetails.isErrorPage=!0)):(r=en.safeParse(e.event_detail.event_name).success?e.event_detail.event_type===dt?"xdm_error":`xdm_${e.event_detail.event_name}`:"xdm_cta_click",s={webInteraction:{name:e.event_detail.event_name,type:"other",url:t?.destinationUrl||"",linkClicks:{value:1}}}),{event:r,web:s,_makemytrip:e}}validateAdobeSchema(e){try{tn(e._makemytrip.event_detail.event_name).parse(e)}catch(t){if(t instanceof y.ZodError){let r=Je(t);throw new Error(`Adobe Analytics Schema validation failed: ${JSON.stringify(r,null,2)}`)}throw t}}pushToADL(){window.adobeDataLayer||(window.adobeDataLayer=[]);let e=this.adobeSchema;try{e.event==="xdm_cta_click"?setTimeout(()=>{window.adobeDataLayer?.push(e)},$t):window.adobeDataLayer.push(e)}catch(t){let r=t instanceof Error?t.message:"Unknown error";throw new Error(`Failed to push to Adobe Data Layer: ${r}`)}}};var We=class{constructor(e){this.validators=[];this.newCorrelationId=()=>Promise.resolve(Ct());this.newRequestId=()=>Promise.resolve(It());this.getSessionId=()=>Promise.resolve(this.sessionManager.getCurrentSessionId());this.setOptOutStatus=e=>this.optInStateManager.updateOptInStatus(e);this.getOptOutStatus=()=>this.optInStateManager.readOptInStatus();this.track=async(e,t)=>{let r=await this.enrichBaseEventArg(e,t);for await(let s of this.validators)await s.assertValidSchema(r,t);this.jobQueue.pushEvent(r),this.sessionManager.updateLastUsed()};this.pushToPDT=async(e,t)=>{let r=t?.lob||"",s=await this.enrichAndValidateBaseEvent(e,t);for await(let a of this.validators)await a.assertValidSchema(s,r);this.jobQueue.pushEvent(s),this.sessionManager.updateLastUsed()};this.pushToAdobeDataLayer=async(e,t)=>{let r=await this.enrichAndValidateBaseEvent(e,t);new He(r,t)};this.pushToAll=async(e,t)=>{await Promise.all([this.pushToPDT(e),this.pushToAdobeDataLayer(e,t)])};this.flushEvents=()=>{this.jobQueue.flushNow("terminal")};this.stopAutoFlush=()=>{this.flushEvents(),this.jobQueue.shutdown()};this.onAppVisibilityChange=e=>{e==="hidden"&&this.flushEvents()};this.enrichBaseEventArg=async(e,t)=>{let r=await this.getSessionId(),s=await this.newRequestId(),a=this.runtimeContextProvider?.getDeviceContext(),i=this.runtimeContextProvider?.getUserContext(this.org),o=this.runtimeContextProvider?.getUserDetailsContextExtended?.(),u=this.runtimeContextProvider?.getDeviceDetailsContextExtended?.(),c=this.sdkRuntimeProvider?.getDeviceContext(),p=this.sdkRuntimeProvider?.getUserContext(this.org),b=this.sdkRuntimeProvider?.getEventTrackingContext?.(),T=ot();if(D.setSetting("deviceContext",a),i?.uuid&&i?.profile_type){let fe=Oe({uuid:i?.uuid,profile_type:i?.profile_type});D.setSetting("userIdPt",fe)}let N=await this.sessionManager.getRetryStatus();!await this.sessionManager.getSyncStatus()&&N>0&&N<6&&setTimeout(async()=>{await je(!0,this.sessionManager,void 0)},10);let V=Object.freeze({...e,event_detail:{event_id:s,event_timestamp:Date.now(),device_details_extended:{...u},user_details_extended:{...o},...e.event_detail},event_tracking_context:{...b,...e.event_tracking_context,session_id:r},user_context:{...p,...i,...e?.user_context},device_context:{...c,...a,...e?.device_context},campaign_details:e.campaign_details||T}),le=this.validators.map(fe=>fe.assertValidSchema(V,t));return await Promise.all(le),V};this.enrichUpdatedBaseEventArg=async(e,t)=>{let r=await this.getSessionId(),s=await this.newRequestId(),a=this.runtimeContextProvider?.getDeviceContext(),i=this.runtimeContextProvider?.getUserContext(this.org),o=this.runtimeContextProvider?.getUserDetailsContextExtended?.(),u=this.runtimeContextProvider?.getDeviceDetailsContextExtended?.(),c=this.sdkRuntimeProvider?.getDeviceContext(),p=this.sdkRuntimeProvider?.getUserContext(this.org),b=this.sdkRuntimeProvider?.getEventTrackingContext?.(),T=ot(),N=jt(),ke=this.sdkRuntimeProvider?.getUserIdentities?.(this.org);if(D.setSetting("deviceContext",a),i?.uuid&&i?.profile_type){let Xe=Oe({uuid:i?.uuid,profile_type:i?.profile_type});D.setSetting("userIdPt",Xe)}let V=await this.sessionManager.getRetryStatus();!await this.sessionManager.getSyncStatus()&&V>0&&V<6&&setTimeout(async()=>{await je(!0,this.sessionManager,void 0)},10);let fe=De(),ln=fe===B.myPartner||fe===B.b2b,fn=Object.freeze({...e,identities:{...ke,...e?.identities},event_detail:{event_id:s,event_timestamp:Date.now(),device_details_extended:{...u},user_details_extended:{...o},...e?.event_detail},event_tracking_context:{...b,...e?.event_tracking_context,session_id:r},user_context:{...p,...i,...e?.user_context},device_context:{...c,...a,...e?.device_context},campaign_details:e?.campaign_details||T,entity_info:N,...ln&&{organization_context:Vt()}}),ft=de(fn),pn=this.validators.map(Xe=>Xe.assertValidSchema(ft,t));return await Promise.all(pn),ft};let{sessionManager:t,optInStateManager:r,runtimeContextProvider:s,jobQueue:a,sdkRuntimeProvider:i,org:o}=e;this.runtimeContextProvider=s,this.sdkRuntimeProvider=i,this.sessionManager=t,this.optInStateManager=r,this.jobQueue=a,this.jobQueue.start(),this.org=o||J.MMT}addValidator(e){this.validators.push(e)}setRuntimeContextProvider(e){this.runtimeContextProvider=e}async enrichAndValidateBaseEvent(e,t){let r=t?.lob||"",s=await this.enrichUpdatedBaseEventArg(e,r);try{nn.parse(s)}catch(a){if(a instanceof y.ZodError){let i=Je(a);throw console.error("Event Schema:",s),new Error(`Schema Validation Failed: ${JSON.stringify(i,null,2)}`)}throw a}return s}};var rn="analytics_opt_in",Ge=class{constructor(e){this.storage=e}async readOptInStatus(){let e=await this.storage.getItem(rn);return Promise.resolve(e!==null&&JSON.parse(e))}async updateOptInStatus(e){await this.storage.setItem(rn,`${e}`)}};var $r="https://pdt.makemytrip.com",sn="/dts/s/da/n",an={"Content-Type":"application/json","Request-Data-Encoding":"json","Accept-Encoding":"gzip"},Br={PDT_HOST:$r,SEND_EVENT_ENDPOINT:sn,PDT_REQ_HEADERS:an},Ve=class{constructor(e){this._host=e?.host||"",D.setSetting("pdtHost",this._host),this._sendEndpoint=`${Pe(this._host)}${e?.sendEndpoint||sn}`,this._baseHeaders=Dt(e?.baseHeaders||an,Pe(this._host))}async sendEvents(e,t,r){if(r)return r({events:e,priority:t,headers:this._baseHeaders,endpoint:this._sendEndpoint});let s=JSON.stringify(e);return await fetch(this._sendEndpoint,{method:"POST",body:s,headers:this._baseHeaders,keepalive:!0}),Promise.resolve("success")}};var Qe=class{getItem(e){return localStorage.getItem(e)}setItem(e,t){localStorage.setItem(e,String(t))}};var we="NA";function zr(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch{return we}}function ut(){if(!Pt())throw new Error("only browser environment not supported")}var lt={getDeviceContext(){ut();let{os:n,osVersion:e,networkType:t,version:r,browser:s,platform:a,deviceId:i,model:o,userAgent:u,acquired_country:c}=Ne(window),p=zr();return de({app_ver:r,vendor_id:s,device_id:i,os:n,os_version:e,network_type:t,platform:a,time_zone:p,model:o,user_agent:u,acquired_country:c})},getUserContext(n){ut();let e=k(document.cookie,"mmt-auth")||k(document.cookie,"OAUTH-GOIBIBO"),t=k(document.cookie,"gitokenid")||void 0,r=Fe(n),s=Rt();if(Mt(n)){let a={uuid:t,profile_type:B.b2c,is_logged_in:!!e,marketing_cloud_id:s,login_channel:J.GI,login_type:"OTP"};return de(a)}else{let a={},i=localStorage.getItem("walletInfo");if(i){let p=JSON.parse(i),b=p?.loyaltyData||{};b?.status&&(a.loyalty_status=b.status),b?.program&&(a.loyalty_type=b.program),b?.currentTier?.name&&(a.loyalty_level=b.currentTier.name),p?.multiCurrencyDetails?.totalWalletAmount&&(a.wallet_bal=p.multiCurrencyDetails.totalWalletAmount)}let o=localStorage.getItem("channel");o&&(a.login_channel=o);let u=localStorage.getItem("loginType");u&&(a.login_type=u);let c={uuid:r?.uuid,profile_type:De(),is_logged_in:!!e,marketing_cloud_id:s,login_channel:a.login_channel,login_type:a.login_type,nationality:r?.nationality,loyalty_status:a.loyalty_status,loyalty_type:a.loyalty_type,loyalty_level:a.loyalty_level,wallet_bal:a.wallet_bal};return de(c)}},getEventTrackingContext(){ut();let n=Re(),{region:e,currency:t,userCurrency:r,language:s}=n;return de({template_id:0,topic_name:we,env:we,timezone:we,session_id:we,funnel_source:we,session_visit_number:0,region:e,user_preferred_currency:r,domain_country:e,domain_language:s,domain_currency:t})},getUserIdentities(n){let e=Fe(n),t=null,r=null;if(n===J.GI&&e)t=e?.value?.mHash,r=e?.value?.eHash;else if(e?.identities)t=e?.identities?.mHash,r=e?.identities?.eHash;else if(Array.isArray(e?.loginInfoList)){let a=e.loginInfoList.find(o=>o.loginType==="MOBILE"&&o.commId),i=e.loginInfoList.find(o=>o.loginType==="EMAIL"&&o.commId);a&&(t=a.commId),i&&(r=i.commId)}let s={};return t&&(s.phone_number_hash=t),r&&(s.email_address_hash=r),Object.keys(s).length?s:null}};var Ye=class{constructor(){this._store={}}getItem(e){return this._store[e]||null}setItem(e,t){this._store[e]=String(t)}};var Fr=60*1e3,Ke=class n{constructor(e,t,r){this.jobs=[];this._timer=-1;this.networkClient=e,this.storage=t,this.config=r,this.restoreState()}start(){this._timer===-1&&(this._timer=setInterval(()=>this.execute(),this.config.autoFlushIntervalInMs))}shutdown(){clearInterval(this._timer),this._timer=-1}flushNow(e="normal"){this.execute(e)}saveState(){this.storage.setItem("@events/job-queue",JSON.stringify(this.jobs))}restoreState(){let e=this.storage.getItem("@events/job-queue");e&&(this.jobs=JSON.parse(e),this.jobs=this.jobs.map(t=>({...t,status:"pending"})))}static findLast(e,t){for(let r=e.length-1;r>=0;r--){let s=e[r];if(t(s,r))return s}}pushEvent(e){let t=n.findLast(this.jobs,r=>r.status==="pending"&&r.events.length<this.config.maxBatchSize);(!t||t.events.length>=this.config.maxBatchSize)&&(t={events:[],status:"pending",id:Ae(),retryCount:0},this.jobs.push(t)),t.events.push(e),this.saveState()}execute(e="normal"){let t=this.jobs.filter(r=>r.status==="pending");for(let r of t)this.updateJobStatus(r,"running"),this.networkClient.sendEvents(r.events,e,null).then(s=>{s==="success"?this.updateJobStatus(r,"done"):s==="failed"&&this.updateJobStatus(r,"failed")})}updateJobStatus(e,t){let r=this.jobs.map(s=>{if(s.id!==e.id)return s;switch(t){case"done":return{...s,status:"done"};case"running":return{...s,start:Date.now(),status:"running"};case"failed":return{...s,status:s.retryCount<2?"pending":"done",retryCount:s.retryCount+1};default:return s}});r=r.filter(s=>s.status!=="done").filter(s=>!(s.status==="running"&&Date.now()-(s.start||0)>Fr)),this.jobs=r,this.saveState()}};function qr(n){let e=ct(),t=n.networkClient||new Ve,r=n.runtimeContextProvider,s=new Ge(e),a=new be(e),i={assertSchema:!1,autoFlushIntervalInMs:5e3,maxBatchSize:5},o=new We({optInStateManager:s,sessionManager:a,runtimeContextProvider:r,sdkRuntimeProvider:lt,jobQueue:new Ke(t,e,i),...n});return typeof window<"u"&&document.addEventListener("visibilitychange",()=>{document.visibilityState==="hidden"&&o.onAppVisibilityChange("hidden")}),o}function ct(){return(()=>{try{if(typeof window?.localStorage<"u")return!0}catch{}return!1})()?new Qe:new Ye}var on={development:"https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-cc2440d362e4-development.min.js",production:"https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-4aefa0b9df82.min.js"},cn=n=>on[n]||on.production,Jr=(n="development")=>`<script src="${cn(n)}" async></script>`,Hr=(n="development")=>cn(n);var dn={development:"https://assets.adobedtm.com/79483c2c7c00/c269e98139c1/launch-197ba8a65d9c-development.min.js",production:"https://assets.adobedtm.com/79483c2c7c00/c269e98139c1/launch-adcfac9ffc6d.min.js"},un=n=>dn[n]||dn.production,Wr=(n="development")=>`<script src="${un(n)}" async></script>`,Gr=(n="development")=>un(n);
//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/pdtutils/pdtutils.ts
var pdtutils = __webpack_require__(8156);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/index.ts
var utils = __webpack_require__(6198);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/constants/index.ts
var constants = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/utils/pdtutils/getCommonPdtDataV2/index.ts + 1 modules
var getCommonPdtDataV2 = __webpack_require__(5853);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/pdtutils/PdtSchemaUpdater.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PdtSchemaUpdater = /*#__PURE__*/function () {
  function PdtSchemaUpdater(commonPdtData) {
    (0,classCallCheck/* default */.Z)(this, PdtSchemaUpdater);

    (0,defineProperty/* default */.Z)(this, "data", void 0);

    this.data = commonPdtData;
  }

  (0,createClass/* default */.Z)(PdtSchemaUpdater, [{
    key: "mergeDeviceContext",
    value: function mergeDeviceContext(deviceContext) {
      var _this$data;

      this.data = _objectSpread(_objectSpread({}, this.data), {}, {
        device_context: _objectSpread(_objectSpread({}, (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.device_context), deviceContext)
      });
      return this;
    }
  }, {
    key: "mergeEventDetailsData",
    value: function mergeEventDetailsData(eventDetail) {
      var _this$data2, _this$data3, _this$data3$event_det, _this$data4, _this$data4$event_det;

      this.data = _objectSpread(_objectSpread({}, this.data), {}, {
        event_detail: _objectSpread(_objectSpread(_objectSpread({}, (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.event_detail), eventDetail), {}, {
          event_name: eventDetail.event_name || ((_this$data3 = this.data) === null || _this$data3 === void 0 ? void 0 : (_this$data3$event_det = _this$data3.event_detail) === null || _this$data3$event_det === void 0 ? void 0 : _this$data3$event_det.event_name),
          event_type: eventDetail.event_type || ((_this$data4 = this.data) === null || _this$data4 === void 0 ? void 0 : (_this$data4$event_det = _this$data4.event_detail) === null || _this$data4$event_det === void 0 ? void 0 : _this$data4$event_det.event_type)
        })
      });
      return this;
    }
  }, {
    key: "mergePageContextData",
    value: function mergePageContextData(pageContextData) {
      var _this$data5, _this$data$page_conte;

      this.data = _objectSpread(_objectSpread({}, this.data), {}, {
        page_context: _objectSpread(_objectSpread(_objectSpread({}, (_this$data5 = this.data) === null || _this$data5 === void 0 ? void 0 : _this$data5.page_context), pageContextData || {}), {}, {
          lob: (pageContextData === null || pageContextData === void 0 ? void 0 : pageContextData.lob) || ((_this$data$page_conte = this.data.page_context) === null || _this$data$page_conte === void 0 ? void 0 : _this$data$page_conte.lob)
        })
      });
      return this;
    }
  }, {
    key: "mergeEventTrackingContext",
    value: function mergeEventTrackingContext(eventTrackingContext) {
      var _this$data6;

      this.data = _objectSpread(_objectSpread({}, this.data), {}, {
        event_tracking_context: _objectSpread(_objectSpread({}, (_this$data6 = this.data) === null || _this$data6 === void 0 ? void 0 : _this$data6.event_tracking_context), eventTrackingContext)
      });
      return this;
    }
  }, {
    key: "mergeExperimentDetails",
    value: function mergeExperimentDetails(experimentDetails) {
      if (experimentDetails) {
        var _this$data7;

        this.data = _objectSpread(_objectSpread({}, this.data), {}, {
          experiment_details: _objectSpread(_objectSpread({}, (_this$data7 = this.data) === null || _this$data7 === void 0 ? void 0 : _this$data7.experiment_details), experimentDetails)
        });
      }

      return this;
    }
  }, {
    key: "getSchema",
    value: function getSchema() {
      return this.data;
    }
  }]);

  return PdtSchemaUpdater;
}();

/* harmony default export */ var pdtutils_PdtSchemaUpdater = (PdtSchemaUpdater);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/utils/pdtutils/pdtLogger.ts


function pdtLogger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function pdtLogger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? pdtLogger_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : pdtLogger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-ignore






var AnalyticsSdk = qr({});
var getPdtLoggerMethods = function getPdtLoggerMethods(_ref) {
  var lobFunnelType = _ref.lobFunnelType,
      userId = _ref.userId,
      puid = _ref.puid,
      lobCategory = _ref.lobCategory,
      pdtEvents = _ref.pdtEvents,
      funnelStep = _ref.funnelStep;
  var partner = (0,constants/* getPartner */.kW)();

  var sendCTAData = function sendCTAData(_ref2) {
    var _ref2$pdtData = _ref2.pdtData,
        pdtData = _ref2$pdtData === void 0 ? {} : _ref2$pdtData,
        eventDetail = _ref2.eventDetail,
        event_tracking_context = _ref2.event_tracking_context;

    try {
      var _event_tracking_conte;

      pdtData = (0,getCommonPdtDataV2/* getCommonPdtDataV2 */.S)({
        partner: partner,
        userId: userId,
        puid: puid,
        lobFunnelType: lobFunnelType,
        lobCategory: lobCategory,
        funnelStep: funnelStep
      });
      AnalyticsSdk.setRuntimeContextProvider({
        getUserContext: function getUserContext() {
          return pdtData.user_context;
        },
        getDeviceContext: function getDeviceContext() {
          return pdtData.device_context;
        }
      });
      var pdtSchemaUpdater = new pdtutils_PdtSchemaUpdater(pdtData);

      var _data = pdtSchemaUpdater.mergeEventDetailsData(eventDetail).mergeEventTrackingContext(pdtLogger_objectSpread(pdtLogger_objectSpread({}, event_tracking_context), {}, {
        request_id: (_event_tracking_conte = event_tracking_context === null || event_tracking_context === void 0 ? void 0 : event_tracking_context.request_id) !== null && _event_tracking_conte !== void 0 ? _event_tracking_conte : (0,utils.generateRequestId)()
      })).getSchema();

      updateEventName(_data.event_detail, pdtEvents);
      AnalyticsSdk.track(_data, constants/* LOB.FOREX */.r6.FOREX);
    } catch (e) {
      console.error(e === null || e === void 0 ? void 0 : e.message);
    }
  };

  var sendPdtDataV2 = function sendPdtDataV2(_ref3) {
    var event_detail = _ref3.event_detail,
        page_context = _ref3.page_context,
        event_tracking_context = _ref3.event_tracking_context,
        user_id = _ref3.user_id,
        partner_id = _ref3.partner_id,
        funnelType = _ref3.funnelType,
        category = _ref3.category,
        experiment_details = _ref3.experiment_details,
        _ref3$shouldFlushEven = _ref3.shouldFlushEvents,
        shouldFlushEvents = _ref3$shouldFlushEven === void 0 ? false : _ref3$shouldFlushEven;

    try {
      var _event_tracking_conte2;

      var commonPdtData = (0,getCommonPdtDataV2/* getCommonPdtDataV2 */.S)({
        partner: partner,
        userId: user_id !== null && user_id !== void 0 ? user_id : userId,
        puid: partner_id !== null && partner_id !== void 0 ? partner_id : puid,
        lobFunnelType: funnelType !== null && funnelType !== void 0 ? funnelType : lobFunnelType,
        lobCategory: category !== null && category !== void 0 ? category : lobCategory,
        funnelStep: funnelStep
      });
      AnalyticsSdk.setRuntimeContextProvider({
        getUserContext: function getUserContext() {
          return commonPdtData.user_context;
        },
        getDeviceContext: function getDeviceContext() {
          return commonPdtData.device_context;
        }
      });
      var pdtSchemaUpdater = new pdtutils_PdtSchemaUpdater(commonPdtData);

      var _data2 = pdtSchemaUpdater.mergeEventDetailsData(event_detail).mergePageContextData(page_context).mergeEventTrackingContext(pdtLogger_objectSpread(pdtLogger_objectSpread({}, event_tracking_context), {}, {
        request_id: (_event_tracking_conte2 = event_tracking_context === null || event_tracking_context === void 0 ? void 0 : event_tracking_context.request_id) !== null && _event_tracking_conte2 !== void 0 ? _event_tracking_conte2 : (0,utils.generateRequestId)()
      })).mergeExperimentDetails(experiment_details).getSchema();

      updateEventName(_data2.event_detail, pdtEvents);
      AnalyticsSdk.track(_data2, constants/* LOB.FOREX */.r6.FOREX);

      if (shouldFlushEvents) {
        AnalyticsSdk === null || AnalyticsSdk === void 0 ? void 0 : AnalyticsSdk.flushEvents();
      }
    } catch (e) {
      console.error("sendPdtDataV2: ", e);
    }
  };

  var getPdtDataV2 = function getPdtDataV2(_ref4) {
    var event_detail = _ref4.event_detail,
        page_context = _ref4.page_context,
        event_tracking_context = _ref4.event_tracking_context,
        user_id = _ref4.user_id,
        partner_id = _ref4.partner_id,
        funnelType = _ref4.funnelType,
        category = _ref4.category,
        experiment_details = _ref4.experiment_details;

    try {
      var _event_tracking_conte3;

      var commonPdtData = (0,getCommonPdtDataV2/* getCommonPdtDataV2 */.S)({
        partner: partner,
        userId: user_id !== null && user_id !== void 0 ? user_id : userId,
        puid: partner_id !== null && partner_id !== void 0 ? partner_id : puid,
        lobFunnelType: funnelType !== null && funnelType !== void 0 ? funnelType : lobFunnelType,
        lobCategory: category !== null && category !== void 0 ? category : lobCategory,
        funnelStep: funnelStep
      });
      var pdtSchemaUpdater = new pdtutils_PdtSchemaUpdater(commonPdtData);

      var _data3 = pdtSchemaUpdater.mergeEventDetailsData(event_detail).mergePageContextData(page_context).mergeEventTrackingContext(pdtLogger_objectSpread(pdtLogger_objectSpread({}, event_tracking_context), {}, {
        request_id: (_event_tracking_conte3 = event_tracking_context === null || event_tracking_context === void 0 ? void 0 : event_tracking_context.request_id) !== null && _event_tracking_conte3 !== void 0 ? _event_tracking_conte3 : (0,utils.generateRequestId)()
      })).mergeExperimentDetails(experiment_details).getSchema();

      updateEventName(_data3.event_detail, pdtEvents);
      return _data3;
    } catch (e) {
      console.error("getPdtDataV2: ", e);
      return null;
    }
  };

  return {
    sendCTAData: sendCTAData,
    sendPdtDataV2: sendPdtDataV2,
    getPdtDataV2: getPdtDataV2
  };
};
function sendPdtErrorEvent(_ref5) {
  var appErrorReducer = _ref5.appErrorReducer,
      sendPdtDataV2 = _ref5.sendPdtDataV2;

  try {
    var _appErrorReducer$pdtI, _appErrorReducer$pdtI2;

    var _ref6 = appErrorReducer || {},
        apiUrl = _ref6.apiUrl;

    var errorMessage = (appErrorReducer === null || appErrorReducer === void 0 ? void 0 : (_appErrorReducer$pdtI = appErrorReducer.pdtInfo) === null || _appErrorReducer$pdtI === void 0 ? void 0 : _appErrorReducer$pdtI.errorDescription) || (appErrorReducer === null || appErrorReducer === void 0 ? void 0 : appErrorReducer.errorTitle) || (appErrorReducer === null || appErrorReducer === void 0 ? void 0 : appErrorReducer.errorDescription) || (appErrorReducer === null || appErrorReducer === void 0 ? void 0 : appErrorReducer.message);

    if (!errorMessage) {
      return;
    }

    sendPdtDataV2({
      event_detail: getEventDetails({
        event_name: "NA",
        vendor_error_details: getVendorErrorDetails({
          error_code: (appErrorReducer === null || appErrorReducer === void 0 ? void 0 : (_appErrorReducer$pdtI2 = appErrorReducer.pdtInfo) === null || _appErrorReducer$pdtI2 === void 0 ? void 0 : _appErrorReducer$pdtI2.code) || (appErrorReducer === null || appErrorReducer === void 0 ? void 0 : appErrorReducer.code) || "NO_CODE_FOUND",
          error_message_shown: errorMessage,
          api_url: apiUrl
        })
      }),
      event_tracking_context: getEventTrackingContext({
        request_id: (appErrorReducer === null || appErrorReducer === void 0 ? void 0 : appErrorReducer.requestId) || ""
      })
    });
  } catch (e) {
    console.error("sendPdtErrorEvent fn ", e);
  }
}

function updateEventName(eventDetail, pdtEvents) {
  var eventName = (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.event_name) || "";

  if (eventName) {
    eventDetail.event_name = pdtEvents[eventName] || eventName;
  }
}

var replacePipeWithComma = function replacePipeWithComma(data) {
  var _data$event_detail, _data$event_detail$co, _data$event_detail$co2;

  data === null || data === void 0 ? void 0 : (_data$event_detail = data.event_detail) === null || _data$event_detail === void 0 ? void 0 : (_data$event_detail$co = _data$event_detail.components) === null || _data$event_detail$co === void 0 ? void 0 : (_data$event_detail$co2 = _data$event_detail$co.content_details) === null || _data$event_detail$co2 === void 0 ? void 0 : _data$event_detail$co2.forEach(function (item) {
    if (typeof item.description === "string") {
      item.description = item.description.replace(/\|/g, ",");
    }
  });
  return data;
};
var transformComponentData = function transformComponentData(components) {
  var contentDetails = components === null || components === void 0 ? void 0 : components.content_details;

  if (!contentDetails || contentDetails.length === 0) {
    return "";
  }

  var transformedItems = contentDetails.filter(function (content) {
    return content != null;
  }).map(function (content) {
    var values = [];
    if (content.id && content.id !== "") values.push("".concat(content.id));
    if (content.type && content.type !== "") values.push("".concat(content.type));
    if (content.description && content.description !== "") values.push("".concat(content.description));
    return values.join(":");
  });
  return transformedItems.join("|");
};
var transformUpcomingTrip = function transformUpcomingTrip(upcomingTrip) {
  var tripDetails = upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.trip_details;

  if (!tripDetails || tripDetails.length === 0) {
    return "";
  } // Transform only the first trip detail


  var firstTrip = tripDetails[0];

  if (!firstTrip) {
    return "";
  }

  var values = [];
  if (firstTrip.intent && firstTrip.intent !== "") values.push("".concat(firstTrip.intent));
  if (firstTrip.dependent_lob && firstTrip.dependent_lob !== "") values.push("".concat(firstTrip.dependent_lob));
  if (firstTrip.country_code && firstTrip.country_code !== "") values.push("".concat(firstTrip.country_code));
  if (firstTrip.rtt) values.push("".concat(firstTrip.rtt));
  if (firstTrip.opportunity_type && firstTrip.opportunity_type !== "") values.push("".concat(firstTrip.opportunity_type));
  return values.join(":");
};

/***/ }),

/***/ 8156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getComponentsPdt": function() { return /* binding */ getComponentsPdt; },
/* harmony export */   "getDeliveryDetailsPdtSchema": function() { return /* binding */ getDeliveryDetailsPdtSchema; },
/* harmony export */   "getDeviceContext": function() { return /* binding */ getDeviceContext; },
/* harmony export */   "getEventDetails": function() { return /* binding */ getEventDetails; },
/* harmony export */   "getEventTrackingContext": function() { return /* binding */ getEventTrackingContext; },
/* harmony export */   "getPageContext": function() { return /* binding */ getPageContext; },
/* harmony export */   "getRequestIdHeaders": function() { return /* binding */ getRequestIdHeaders; },
/* harmony export */   "getTmUserDetails": function() { return /* binding */ getTmUserDetails; },
/* harmony export */   "getUserContext": function() { return /* binding */ getUserContext; },
/* harmony export */   "getVendorErrorDetails": function() { return /* binding */ getVendorErrorDetails; },
/* harmony export */   "setPageContextHeaders": function() { return /* binding */ setPageContextHeaders; }
/* harmony export */ });
/* unused harmony exports setPdtLocationDetectedSchema, getDeliveryDetails, getBookingInfo, getBookingDetails, getPageDetails, getErrorDetailsItem, getExperimentDetails, getCampaignDetails, getPdtDataObjV2, getPdtHeaders */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8529);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6198);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2638);
/* harmony import */ var _cookieUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2151);
/* harmony import */ var _getCommonPdtDataV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5853);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2382);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_5__, "OMNITURE_MAP")) __webpack_require__.d(__webpack_exports__, { "OMNITURE_MAP": function() { return _types__WEBPACK_IMPORTED_MODULE_5__.OMNITURE_MAP; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_5__, "OMNI_EVENTS_MAP")) __webpack_require__.d(__webpack_exports__, { "OMNI_EVENTS_MAP": function() { return _types__WEBPACK_IMPORTED_MODULE_5__.OMNI_EVENTS_MAP; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_5__, "getCommonSeoOmniData")) __webpack_require__.d(__webpack_exports__, { "getCommonSeoOmniData": function() { return _types__WEBPACK_IMPORTED_MODULE_5__.getCommonSeoOmniData; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_5__, "getPdtLoggerMethods")) __webpack_require__.d(__webpack_exports__, { "getPdtLoggerMethods": function() { return _types__WEBPACK_IMPORTED_MODULE_5__.getPdtLoggerMethods; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_5__, "redirectToListingPage")) __webpack_require__.d(__webpack_exports__, { "redirectToListingPage": function() { return _types__WEBPACK_IMPORTED_MODULE_5__.redirectToListingPage; } });





var setPdtLocationDetectedSchema = function setPdtLocationDetectedSchema(locationSource, permissionDetails, delivery_details) {
  var _ref = delivery_details || {},
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      pincode = _ref.pincode,
      city = _ref.city;

  return {
    latitude: latitude ? "".concat(latitude) : null,
    longitude: longitude ? "".concat(longitude) : null,
    location_source: locationSource || null,
    pincode: pincode ? "".concat(pincode) : null,
    city: city ? "".concat(delivery_details === null || delivery_details === void 0 ? void 0 : delivery_details.city) : null,
    location_permission: permissionDetails || null
  };
};
function getDeliveryDetailsPdtSchema(_ref2) {
  var deliveryDetails = _ref2.deliveryDetails;

  var _ref3 = deliveryDetails || {},
      pincode = _ref3.pincode,
      city = _ref3.city,
      latitude = _ref3.latitude,
      longitude = _ref3.longitude;

  return {
    pincode: pincode !== null && pincode !== void 0 ? pincode : null,
    city: city ? "".concat(city) : "",
    location_permission_given: latitude && longitude ? true : false
  };
}
function getVendorErrorDetails(_ref4) {
  var error_code = _ref4.error_code,
      error_type = _ref4.error_type,
      error_source = _ref4.error_source,
      vendor_error_code = _ref4.vendor_error_code,
      vendor_error_message = _ref4.vendor_error_message,
      error_message_shown = _ref4.error_message_shown,
      api_url = _ref4.api_url;
  var vendorErrorObj = {
    error_code: error_code ? "".concat(error_code) : "NO_CODE_FOUND",
    error_type: error_type || null,
    error_source: error_source || null,
    vendor_error_code: vendor_error_code || null,
    vendor_error_message: vendor_error_message || null,
    error_message_shown: error_message_shown || "Unknown error",
    api_url: api_url || null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(vendorErrorObj);
}
function getDeliveryDetails(_ref5) {
  var eta = _ref5.eta,
      pincode = _ref5.pincode,
      city = _ref5.city,
      is_deliverable = _ref5.is_deliverable,
      is_prefetched = _ref5.is_prefetched,
      location_permission_given = _ref5.location_permission_given,
      deliverable = _ref5.deliverable,
      city_code = _ref5.city_code,
      locus_city_code = _ref5.locus_city_code,
      state = _ref5.state,
      state_code = _ref5.state_code,
      is_valid = _ref5.is_valid,
      is_card_deliverable = _ref5.is_card_deliverable,
      is_currency_deliverable = _ref5.is_currency_deliverable,
      fallback_to_city = _ref5.fallback_to_city;
  var etaNum = Number(eta);
  var pincodeNum = Number(pincode);
  var obj = {
    eta: etaNum >= 0 ? etaNum : null,
    pincode: pincodeNum >= 0 ? pincodeNum : null,
    city: city || null,
    is_deliverable: is_deliverable || null,
    is_prefetched: is_prefetched || null,
    location_permission_given: location_permission_given || null,
    deliverable: deliverable || null,
    city_code: city_code || null,
    locus_city_code: locus_city_code || null,
    state: state || null,
    state_code: state_code || null,
    is_valid: is_valid || null,
    is_card_deliverable: is_card_deliverable || null,
    is_currency_deliverable: is_currency_deliverable || null,
    fallback_to_city: fallback_to_city !== undefined ? fallback_to_city : null
  };
  return removeNullableField(obj);
}
function getBookingInfo(_ref6) {
  var amount_details = _ref6.amount_details,
      booking_date = _ref6.booking_date,
      booking_id = _ref6.booking_id,
      booking_parent_id = _ref6.booking_parent_id,
      countries = _ref6.countries,
      coupon_details = _ref6.coupon_details,
      currency = _ref6.currency,
      delivery_city_code = _ref6.delivery_city_code,
      delivery_city_name = _ref6.delivery_city_name,
      document_upload_status = _ref6.document_upload_status,
      from_date_time = _ref6.from_date_time,
      is_coupon_applied = _ref6.is_coupon_applied,
      is_partial_amount_paid = _ref6.is_partial_amount_paid,
      is_payment_possible = _ref6.is_payment_possible,
      is_tcs_applied = _ref6.is_tcs_applied,
      order_items = _ref6.order_items,
      order_type_code = _ref6.order_type_code,
      payment_status = _ref6.payment_status,
      status = _ref6.status,
      status_description = _ref6.status_description,
      tm_order_id = _ref6.tm_order_id,
      to_date_time = _ref6.to_date_time,
      trip_purpose = _ref6.trip_purpose,
      trip_type = _ref6.trip_type;
  return {
    amount_details: amount_details || null,
    booking_date: booking_date || null,
    booking_id: booking_id || null,
    booking_parent_id: booking_parent_id || null,
    countries: countries || null,
    coupon_details: coupon_details || null,
    currency: currency || null,
    delivery_city_code: delivery_city_code || null,
    delivery_city_name: delivery_city_name || null,
    document_upload_status: document_upload_status || null,
    from_date_time: from_date_time || null,
    is_coupon_applied: is_coupon_applied || null,
    is_partial_amount_paid: is_partial_amount_paid || null,
    is_payment_possible: is_payment_possible || null,
    is_tcs_applied: is_tcs_applied || null,
    order_items: order_items || null,
    order_type_code: order_type_code || null,
    payment_status: payment_status || null,
    status: status || null,
    status_description: status_description || null,
    tm_order_id: tm_order_id || null,
    to_date_time: to_date_time || null,
    trip_purpose: trip_purpose || null,
    trip_type: trip_type || null
  };
}
function getBookingDetails(_ref7) {
  var status = _ref7.status,
      created_at = _ref7.created_at,
      is_coupon_applied = _ref7.is_coupon_applied,
      is_partial_amount_paid = _ref7.is_partial_amount_paid,
      parent_order_id = _ref7.parent_order_id,
      is_tcs_applied = _ref7.is_tcs_applied,
      status_description = _ref7.status_description,
      document_upload_status = _ref7.document_upload_status,
      payment_details = _ref7.payment_details;
  return {
    status: status || null,
    created_at: created_at || null,
    is_coupon_applied: is_coupon_applied || null,
    is_partial_amount_paid: is_partial_amount_paid || null,
    parent_order_id: parent_order_id || null,
    is_tcs_applied: is_tcs_applied || null,
    status_description: status_description || null,
    document_upload_status: document_upload_status || null,
    payment_details: payment_details || null
  };
}
function getTmUserDetails(_ref8) {
  var tm_uuid = _ref8.tm_uuid,
      partner = _ref8.partner,
      vendor_user_id = _ref8.vendor_user_id,
      vendor_id = _ref8.vendor_id,
      multi_cx_card_cust = _ref8.multi_cx_card_cust,
      currency_cust = _ref8.currency_cust,
      travel_card_cust = _ref8.travel_card_cust;
  var userObj = {
    tm_uuid: tm_uuid || null,
    partner: partner || null,
    vendor_user_id: vendor_user_id || null,
    vendor_id: vendor_id || null,
    multi_cx_card_cust: multi_cx_card_cust || null,
    currency_cust: currency_cust || null,
    travel_card_cust: travel_card_cust || null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(userObj);
}
function getComponentsPdt(_ref9) {
  var id = _ref9.id,
      content_details = _ref9.content_details,
      component_type = _ref9.component_type,
      share_details = _ref9.share_details,
      bridge_status = _ref9.bridge_status;
  var componentObj = {
    id: id || null,
    content_details: content_details || null,
    component_type: component_type || null,
    share_details: share_details || null,
    bridge_status: bridge_status || null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(componentObj);
}
function getEventDetails(_ref10) {
  var page_details = _ref10.page_details,
      delivery_details = _ref10.delivery_details,
      response_time = _ref10.response_time,
      vendor_error_details = _ref10.vendor_error_details,
      event_name = _ref10.event_name,
      _ref10$event_type = _ref10.event_type,
      event_type = _ref10$event_type === void 0 ? "" : _ref10$event_type,
      event_value = _ref10.event_value,
      booking_info = _ref10.booking_info,
      components = _ref10.components,
      _ref10$event_id = _ref10.event_id,
      event_id = _ref10$event_id === void 0 ? "" : _ref10$event_id,
      event_timestamp = _ref10.event_timestamp,
      user_details = _ref10.user_details,
      webhook_details = _ref10.webhook_details,
      document_details = _ref10.document_details,
      upcoming_trip = _ref10.upcoming_trip;
  var obj = {
    page_details: page_details ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(page_details) : null,
    delivery_details: delivery_details ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(delivery_details) : null,
    response_time: response_time || null,
    vendor_error_details: vendor_error_details ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(vendor_error_details) : null,
    event_name: event_name || "NA",
    event_type: event_type || "NA",
    event_value: event_value || null,
    booking_info: booking_info ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(booking_info) : null,
    components: components ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(components) : null,
    event_id: event_id || null,
    event_timestamp: event_timestamp || new Date().getTime(),
    // non nullable
    user_details: user_details ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(user_details) : null,
    webhook_details: webhook_details ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(webhook_details) : null,
    document_details: document_details ? (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(document_details) : null,
    upcoming_trip: upcoming_trip ? getUpcomingTrip(upcoming_trip) : null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}

function getUpcomingTrip(_ref11) {
  var intl_travel = _ref11.intl_travel,
      trip_details = _ref11.trip_details;
  var upcomingTrip = {
    intl_travel: intl_travel,
    trip_details: getTripDetails(trip_details)
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(upcomingTrip);
}

function getTripDetails(trip_details) {
  var tripDetails = (trip_details !== null && trip_details !== void 0 ? trip_details : []).map(function (tripDetail) {
    return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)({
      dependent_lob: tripDetail.dependent_lob,
      country_code: tripDetail.country_code,
      currency_code: tripDetail.currency_code,
      start_date: tripDetail.start_date,
      end_date: tripDetail.end_date,
      no_of_travellers: tripDetail.no_of_travellers,
      opportunity_type: tripDetail.opportunity_type
    });
  }).filter(function (tripDetail) {
    return tripDetail;
  });
  return tripDetails.length ? tripDetails : null;
}

function getPageDetails(_ref12) {
  var _ref12$segment_key = _ref12.segment_key,
      segment_key = _ref12$segment_key === void 0 ? null : _ref12$segment_key,
      _ref12$documentscanfa = _ref12.documentscanfailed,
      documentscanfailed = _ref12$documentscanfa === void 0 ? null : _ref12$documentscanfa,
      _ref12$secondary_page = _ref12.secondary_page_name,
      secondary_page_name = _ref12$secondary_page === void 0 ? null : _ref12$secondary_page,
      _ref12$auto_suggest = _ref12.auto_suggest,
      auto_suggest = _ref12$auto_suggest === void 0 ? null : _ref12$auto_suggest,
      is_pan_autofilled = _ref12.is_pan_autofilled,
      is_mobile_prefilled = _ref12.is_mobile_prefilled,
      Is_email_prefilled = _ref12.Is_email_prefilled;
  var pageDetailsObj = {
    segment_key: segment_key || null,
    documentscanfailed: documentscanfailed || null,
    secondary_page_name: secondary_page_name || null,
    auto_suggest: auto_suggest || null,
    is_pan_autofilled: is_pan_autofilled,
    // mandatory why?
    is_mobile_prefilled: is_mobile_prefilled,
    // Mandatory why?
    Is_email_prefilled: Is_email_prefilled // Mandatory why?

  };
  return removeNullableField(pageDetailsObj);
}
function getPageContext(_ref13) {
  var lob = _ref13.lob,
      lob_category = _ref13.lob_category,
      lob_funnel = _ref13.lob_funnel,
      page_name = _ref13.page_name,
      prev_page_name = _ref13.prev_page_name,
      subpage_name = _ref13.subpage_name,
      funnel_step = _ref13.funnel_step,
      pg_time_interval = _ref13.pg_time_interval,
      navigation = _ref13.navigation,
      page_url = _ref13.page_url;
  var pageContextObj = {
    lob: lob || _constants__WEBPACK_IMPORTED_MODULE_1__/* .LOB.FOREX */ .r6.FOREX,
    lob_category: lob_category || null,
    lob_funnel: lob_funnel || null,
    page_name: page_name || null,
    prev_page_name: prev_page_name || null,
    subpage_name: subpage_name || null,
    funnel_step: funnel_step || null,
    pg_time_interval: pg_time_interval !== null && pg_time_interval !== void 0 ? pg_time_interval : null,
    navigation: navigation || null,
    page_url: page_url || null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(pageContextObj);
}
function getEventTrackingContext(_ref14) {
  var template_id = _ref14.template_id,
      topic_name = _ref14.topic_name,
      env = _ref14.env,
      session_id = _ref14.session_id,
      request_id = _ref14.request_id,
      journey_id = _ref14.journey_id,
      bu = _ref14.bu,
      organisation = _ref14.organisation,
      funnel_source = _ref14.funnel_source,
      funnel_entry = _ref14.funnel_entry,
      traffic_source = _ref14.traffic_source,
      domain_country = _ref14.domain_country,
      domain_currency = _ref14.domain_currency,
      domain_language = _ref14.domain_language,
      affiliate_id = _ref14.affiliate_id,
      timestamp = _ref14.timestamp,
      funnel_medium = _ref14.funnel_medium,
      funnel_campaign = _ref14.funnel_campaign,
      cmp = _ref14.cmp;
  var obj = {
    template_id: template_id,
    topic_name: topic_name,
    env: env,
    session_id: session_id || null,
    request_id: request_id || null,
    journey_id: journey_id || null,
    bu: bu || null,
    organisation: organisation || null,
    funnel_source: funnel_source || null,
    funnel_entry: funnel_entry || null,
    traffic_source: traffic_source || null,
    domain_country: domain_country || null,
    domain_currency: domain_currency || null,
    domain_language: domain_language || null,
    affiliate_id: affiliate_id || null,
    timestamp: timestamp,
    funnel_medium: funnel_medium || null,
    funnel_campaign: funnel_campaign || null,
    cmp: cmp || null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}
function getErrorDetailsItem(_ref15) {
  var code = _ref15.code,
      message = _ref15.message,
      severity = _ref15.severity,
      source = _ref15.source;
  return {
    code: code,
    message: message,
    severity: severity || null,
    source: source || null
  };
}
function getUserContext(_ref16) {
  var uuid = _ref16.uuid,
      is_logged_in = _ref16.is_logged_in,
      marketing_cloud_id = _ref16.marketing_cloud_id,
      login_channel = _ref16.login_channel,
      profile_type = _ref16.profile_type,
      wallet_bal = _ref16.wallet_bal,
      login_type = _ref16.login_type,
      loyalty_status = _ref16.loyalty_status,
      loyalty_type = _ref16.loyalty_type,
      loyalty_level = _ref16.loyalty_level,
      user_segment_list = _ref16.user_segment_list,
      login_required = _ref16.login_required;
  var obj = {
    uuid: uuid || null,
    is_logged_in: is_logged_in,
    marketing_cloud_id: marketing_cloud_id || null,
    login_channel: login_channel || null,
    profile_type: profile_type || null,
    wallet_bal: wallet_bal || null,
    login_type: login_type || null,
    loyalty_status: loyalty_status || null,
    loyalty_type: loyalty_type || null,
    loyalty_level: loyalty_level || null,
    user_segment_list: user_segment_list || null,
    login_required: login_required || null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}
function getDeviceContext(_ref17) {
  var device_id = _ref17.device_id,
      ip_addr = _ref17.ip_addr,
      network_type = _ref17.network_type,
      os_version = _ref17.os_version,
      user_agent = _ref17.user_agent,
      timezone = _ref17.timezone,
      platform = _ref17.platform,
      country = _ref17.country,
      region = _ref17.region,
      city = _ref17.city,
      lat = _ref17.lat,
      long = _ref17.long,
      app_ver = _ref17.app_ver,
      build_ver = _ref17.build_ver,
      os = _ref17.os,
      visitor_id = _ref17.visitor_id,
      advertiser_id = _ref17.advertiser_id,
      vendor_id = _ref17.vendor_id,
      device_token = _ref17.device_token;
  var obj = {
    device_id: device_id || null,
    ip_addr: ip_addr || null,
    network_type: network_type || null,
    os_version: os_version || "",
    user_agent: user_agent || null,
    timezone: timezone || null,
    platform: platform || "NA",
    country: country || null,
    region: region || null,
    city: city || null,
    lat: lat || null,
    long: long || null,
    app_ver: app_ver || "",
    build_ver: build_ver || null,
    os: os || "",
    visitor_id: visitor_id || null,
    advertiser_id: advertiser_id || null,
    vendor_id: vendor_id || null,
    device_token: device_token || null
  };
  return (0,___WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}
function getExperimentDetails(_ref18) {
  var valid_exp_list = _ref18.valid_exp_list,
      variant_keys = _ref18.variant_keys,
      honoured_exp_list = _ref18.honoured_exp_list;
  return {
    valid_exp_list: valid_exp_list || [],
    variant_keys: variant_keys || "",
    honoured_exp_list: honoured_exp_list || []
  };
}
function getCampaignDetails(_ref19) {
  var campaign_name = _ref19.campaign_name,
      campaign_key = _ref19.campaign_key;
  return {
    campaign_name: campaign_name || "",
    campaign_key: campaign_key || ""
  };
}
function getPdtDataObjV2(_ref20) {
  var page_context = _ref20.page_context,
      event_tracking_context = _ref20.event_tracking_context,
      error_details_list = _ref20.error_details_list,
      user_context = _ref20.user_context,
      device_context = _ref20.device_context,
      experiment_details = _ref20.experiment_details,
      campaign_details = _ref20.campaign_details,
      tracking_info = _ref20.tracking_info,
      event_detail = _ref20.event_detail,
      traveller_info = _ref20.traveller_info,
      addon_details = _ref20.addon_details,
      search_context = _ref20.search_context;
  return {
    page_context: page_context,
    event_tracking_context: event_tracking_context,
    error_details_list: error_details_list || null,
    user_context: user_context,
    device_context: device_context,
    experiment_details: experiment_details || null,
    campaign_details: campaign_details || null,
    tracking_info: tracking_info || null,
    event_detail: event_detail,
    traveller_info: traveller_info || null,
    addon_details: addon_details || null,
    search_context: search_context || null
  };
}
function getPdtHeaders(_ref21) {
  var lobCategory = _ref21.lobCategory,
      lobFunnelType = _ref21.lobFunnelType;
  var partner = (0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getPartner */ .kW)();

  var _getCommonPdtDataV = (0,_getCommonPdtDataV2__WEBPACK_IMPORTED_MODULE_3__/* .getCommonPdtDataV2 */ .S)({
    partner: partner,
    lobCategory: lobCategory,
    lobFunnelType: lobFunnelType
  }),
      page_context = _getCommonPdtDataV.page_context;

  page_context = (0,___WEBPACK_IMPORTED_MODULE_0__.removeEmptyKeys)(page_context);
  page_context = getShortHeaders(page_context);
  var headers = {
    "page-context": page_context
  };
  var journeyId = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)(_constants__WEBPACK_IMPORTED_MODULE_1__/* .COOKIES.PDT_JOURNEY_ID */ .E9.PDT_JOURNEY_ID, true);

  if (journeyId) {
    headers["x-jo-id"] = journeyId;
  }

  return headers;
}

function getShortHeaders(page_context) {
  var result = {};

  for (var _i = 0, _Object$entries = Object.entries(page_context || {}); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    result["x-" + (_constants__WEBPACK_IMPORTED_MODULE_1__/* .shortenHeader */ .l2[key] || key)] = value;
  }

  return result;
}

function setPdtHeaders(pdtHeader, headers) {
  for (var _i2 = 0, _Object$entries2 = Object.entries(pdtHeader); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_Object$entries2[_i2], 2),
        headerKey = _Object$entries2$_i[0],
        headerValue = _Object$entries2$_i[1];

    if (typeof headerValue === "object") {
      setPdtHeaders(headerValue, headers);
    } else {
      headers[headerKey] = headerValue;
    }
  }
}

function setPageContextHeaders(headers) {
  var pdtHeader = getPdtHeaders({
    lobCategory: "",
    lobFunnelType: _constants__WEBPACK_IMPORTED_MODULE_1__/* .LOB_FUNNEL_TYPE.LISTING */ .fH.LISTING
  });
  setPdtHeaders(pdtHeader, headers);
}
function getRequestIdHeaders(reqId) {
  var headers = {};
  headers["x-rq-id"] = reqId || (0,___WEBPACK_IMPORTED_MODULE_0__.generateRequestId)();
  return headers;
}



/***/ }),

/***/ 2382:
/***/ (function() {



/***/ }),

/***/ 1876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ redirectToListingPage; }
/* harmony export */ });
/* unused harmony exports LISTING_DEEPLINK, openBookMyForexManageCardLink, openNiumHomePage, setRNVariablesFromURL, compareNonInclusiveVersions, isRNFunnelLiveBasedOnAppVersion, getRNFunnelFlagFromAppStorage, customBackHandlingForRN, closeTmWebview */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6198);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2638);
/* harmony import */ var _static_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8333);
/* harmony import */ var _bridges__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6787);
/* harmony import */ var _bridges_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4743);
/* harmony import */ var _clientStorageUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4556);








var LISTING_DEEPLINK = "mmyt://lending?cta=webview&ctaurl=https%3A%2F%2Ftripmoney.makemytrip.com%2Fpartners%2Fmmt%2Fforex%2Flisting&mmt_forex=true&utm_medium=mmt&minver=1&mmtauthkey=mmt-auth&showHeader=false&login_required=false&weblink=true";
var openBookMyForexManageCardLink = function openBookMyForexManageCardLink() {
  var BOOKMYFOREX_MANAGE_CARD_DEEPLINK = "mmyt://app/wl/?url=https%3A%2F%2Fwww.bookmyforex.com%2Fforex-card%2Fsingle-currency-forex-card%2Fmanage-card%2F";
  var BOOKMYFOREX_MANAGE_CARD_WEB_URL = "https://www.bookmyforex.com/forex-card/single-currency-forex-card/manage-card/";

  if (isApp()) {
    var mobileOS = getMobileOperatingSystem();

    if (mobileOS.toLowerCase() === ANDROID) {
      BridgeMethods.openDeeplink(BOOKMYFOREX_MANAGE_CARD_DEEPLINK);
    } else {
      window.location.href = "".concat(BOOKMYFOREX_MANAGE_CARD_WEB_URL, "?open=extBrowser&schedule=webview");
    }
  } else {
    window.location.href = BOOKMYFOREX_MANAGE_CARD_WEB_URL;
  }
};
var openNiumHomePage = function openNiumHomePage() {
  var NIUM_HOME_PAGE_WEB_URL = "https://www.niumforex.com";

  if (isApp()) {
    var mobileOS = getMobileOperatingSystem();

    if (mobileOS.toLowerCase() === IOS) {
      window.location.href = "".concat(NIUM_HOME_PAGE_WEB_URL, "?open=extBrowser&schedule=webview");
    } else {
      window.location.href = NIUM_HOME_PAGE_WEB_URL;
    }
  } else {
    window.location.href = NIUM_HOME_PAGE_WEB_URL;
  }
};
function setRNVariablesFromURL(_x) {
  return _setRNVariablesFromURL.apply(this, arguments);
}

function _setRNVariablesFromURL() {
  _setRNVariablesFromURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(partner) {
    var urlParams, rn, mobileOS, isRNFunnelLive, userLocationInWebSessionStorage;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (true) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            urlParams = new URLSearchParams(window.location.search);
            rn = urlParams.get(SESSION_STORAGE_KEYS.SOURCE_REACT_NATIVE);

            if (!(rn && isApp())) {
              _context2.next = 7;
              break;
            }

            setSessionStorageItem(SESSION_STORAGE_KEYS.SOURCE_REACT_NATIVE, rn, true);
            return _context2.abrupt("return");

          case 7:
            mobileOS = getMobileOperatingSystem();
            isRNFunnelLive = false;

            if (!(mobileOS.toLowerCase() === IOS)) {
              _context2.next = 14;
              break;
            }

            /**
             * In iOS, there is no flag in app storage. Hence, we check if userLocationInWebSessionStorage is present in session storage.
             * If it is not present, it means that user has landed via RN funnel.
             */
            userLocationInWebSessionStorage = getSessionStorageItem(SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, true);
            isRNFunnelLive = !userLocationInWebSessionStorage && isRNFunnelLiveBasedOnAppVersion(partner);
            _context2.next = 20;
            break;

          case 14:
            _context2.next = 16;
            return getRNFunnelFlagFromAppStorage();

          case 16:
            _context2.t0 = _context2.sent;

            if (!_context2.t0) {
              _context2.next = 19;
              break;
            }

            _context2.t0 = isRNFunnelLiveBasedOnAppVersion(partner);

          case 19:
            isRNFunnelLive = _context2.t0;

          case 20:
            if (isRNFunnelLive && isApp()) {
              setSessionStorageItem(SESSION_STORAGE_KEYS.SOURCE_REACT_NATIVE, true, true);
            }

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setRNVariablesFromURL.apply(this, arguments);
}

var compareNonInclusiveVersions = function compareNonInclusiveVersions(v1, v2) {
  var v1Parts = v1.split(".").map(Number);
  var v2Parts = v2.split(".").map(Number);

  for (var i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    var v1Part = v1Parts[i] || 0;
    var v2Part = v2Parts[i] || 0;
    if (v1Part > v2Part) return 1;
    if (v1Part < v2Part) return -1;
  }

  return 0;
};
var isRNFunnelLiveBasedOnAppVersion = function isRNFunnelLiveBasedOnAppVersion(partner) {
  var RN_FEATURE_FLAG = true;

  if (!isApp()) {
    return false;
  }

  if (!RN_FEATURE_FLAG || partner === PARTNER.GI) {
    return false;
  }

  var version = BridgeMethods.getAppVersion();
  var mobileOS = getMobileOperatingSystem();

  try {
    if (mobileOS.toLowerCase() === ANDROID) {
      return compareNonInclusiveVersions(version, "10.1.1") === 1;
    } else if (mobileOS.toLowerCase() === IOS) {
      return compareNonInclusiveVersions(version, "9.3.3") === 1;
    }
  } catch (e) {
    console.error("error while executing close application: " + e);
    return false;
  }

  return false;
};
var getRNFunnelFlagFromAppStorage = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var RN_FUNNEL_LIVE_KEY;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            RN_FUNNEL_LIVE_KEY = "rnFunnelLive";
            return _context.abrupt("return", new Promise(function (resolve) {
              var _window, _window$webkit, _window$webkit$messag, _window3, _window3$app_bridge;

              setTimeout(function () {
                resolve(null);
              }, 500);

              window.getUserSessionStorage = function (type, value) {
                if (type === RN_FUNNEL_LIVE_KEY) {
                  resolve(value);
                }
              };

              if ((_window = window) !== null && _window !== void 0 && (_window$webkit = _window.webkit) !== null && _window$webkit !== void 0 && (_window$webkit$messag = _window$webkit.messageHandlers) !== null && _window$webkit$messag !== void 0 && _window$webkit$messag.getUserSessionStorage) {
                var _window2, _window2$webkit, _window2$webkit$messa, _window2$webkit$messa2;

                (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit = _window2.webkit) === null || _window2$webkit === void 0 ? void 0 : (_window2$webkit$messa = _window2$webkit.messageHandlers.getUserSessionStorage) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.postMessage) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.call(_window2$webkit$messa, {
                  key: RN_FUNNEL_LIVE_KEY
                });
              } else if ((_window3 = window) !== null && _window3 !== void 0 && (_window3$app_bridge = _window3.app_bridge) !== null && _window3$app_bridge !== void 0 && _window3$app_bridge.getInSessionStorage) {
                var _window$app_bridge$ge, _window4, _window4$app_bridge;

                resolve((_window$app_bridge$ge = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$app_bridge = _window4.app_bridge) === null || _window4$app_bridge === void 0 ? void 0 : _window4$app_bridge.getInSessionStorage(RN_FUNNEL_LIVE_KEY)) !== null && _window$app_bridge$ge !== void 0 ? _window$app_bridge$ge : null);
              } else {
                resolve(null);
              }
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getRNFunnelFlagFromAppStorage() {
    return _ref.apply(this, arguments);
  };
}()));
function customBackHandlingForRN() {
  if (getSessionStorageItem(SESSION_STORAGE_KEYS.SOURCE_REACT_NATIVE, true)) {
    var fn = function fn() {
      return closeTmWebview({
        openRNListingPage: true
      });
    };

    window.addEventListener("popstate", fn);
    return window.removeEventListener("popstate", fn);
  }
}
function closeTmWebview(params) {
  var _window$webkit2, _window$webkit2$messa, _window$webkit2$messa2, _window$mmt_android_b;

  var os = (0,_bridges_common__WEBPACK_IMPORTED_MODULE_6__/* .getMobileOperatingSystem */ .HG)().toLowerCase();

  if (((_window$webkit2 = window.webkit) === null || _window$webkit2 === void 0 ? void 0 : (_window$webkit2$messa = _window$webkit2.messageHandlers) === null || _window$webkit2$messa === void 0 ? void 0 : (_window$webkit2$messa2 = _window$webkit2$messa.closeWebView) === null || _window$webkit2$messa2 === void 0 ? void 0 : _window$webkit2$messa2.postMessage) !== "undefined" && os === _bridges_common__WEBPACK_IMPORTED_MODULE_6__/* .IOS */ .z7) {
    if (params !== null && params !== void 0 && params.openRNListingPage) {
      // for iOS, we open deeplink with clearStack true
      _bridges__WEBPACK_IMPORTED_MODULE_4__/* .BridgeMethods.openDeeplink */ .X.openDeeplink("".concat(LISTING_DEEPLINK, "&clearStack=true"));
    } else {
      // If we dont want to open any deeplink, we close the webview
      window.webkit.messageHandlers.closeWebView.postMessage(true);
    }
  } else if (typeof ((_window$mmt_android_b = window.mmt_android_bridge) === null || _window$mmt_android_b === void 0 ? void 0 : _window$mmt_android_b.closeWebView) !== "undefined" && os === _bridges_common__WEBPACK_IMPORTED_MODULE_6__/* .ANDROID */ .IP) {
    window.mmt_android_bridge.closeWebView();

    if (params !== null && params !== void 0 && params.openRNListingPage) {
      _bridges__WEBPACK_IMPORTED_MODULE_4__/* .BridgeMethods.openDeeplink */ .X.openDeeplink(LISTING_DEEPLINK);
    }
  }
}
function redirectToListingPage(partner) {
  if ((0,_clientStorageUtils__WEBPACK_IMPORTED_MODULE_5__/* .getSessionStorageItem */ .St)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .SESSION_STORAGE_KEYS.SOURCE_REACT_NATIVE */ .sO.SOURCE_REACT_NATIVE, true)) {
    closeTmWebview({
      openRNListingPage: true
    });
  } else {
    (0,_static_utils__WEBPACK_IMPORTED_MODULE_3__/* .redirectInterceptHref */ .Xu)("/partners/".concat(partner, "/forex/listing"));
  }
}

/***/ }),

/***/ 1726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zw": function() { return /* reexport */ PublicEnv; },
  "eV": function() { return /* reexport */ PublicEnvProvider; }
});

// UNUSED EXPORTS: ConfigContext, ConfigProvider

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/contexts/config/ConfigContext.ts

var ConfigContext = /*#__PURE__*/(0,react.createContext)({
  cmsClientUrl: ""
});
var ConfigProvider = ConfigContext.Provider;
;// CONCATENATED MODULE: ../../libs/ui/src/lib/contexts/config/envContext.ts

var PublicEnv = /*#__PURE__*/(0,react.createContext)({
  proxyCmsPrefix: "",
  exchangeRateApi: ""
});
var PublicEnvProvider = PublicEnv.Provider;
;// CONCATENATED MODULE: ../../libs/ui/src/lib/contexts/index.ts



/***/ }),

/***/ 7510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Um": function() { return /* reexport */ useBotDetection; },
  "MC": function() { return /* reexport */ useForeignCurrencyAnimation; },
  "eQ": function() { return /* reexport */ useForexCardAnimation; },
  "g3": function() { return /* reexport */ useHeaderAnimation; },
  "$D": function() { return /* reexport */ useInsuranaceAnimation; }
});

// UNUSED EXPORTS: useBreakpoint, useCountTimer, useFreezeBodyScroll, useGeoLocation, usePincode, usePrivacyAnimation, useScroll

// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useScroll/index.ts
var useScroll = __webpack_require__(3907);
// EXTERNAL MODULE: ../../node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(4682);
// EXTERNAL MODULE: ../../node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(5480);
var ScrollTrigger_default = /*#__PURE__*/__webpack_require__.n(ScrollTrigger);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useForeignCurrencyAnimation/index.tsx



var useForeignCurrencyAnimation = function useForeignCurrencyAnimation() {
  var ANIMATION_TYPE = "ease-in-out";
  gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollTrigger_default()));
  (0,react.useEffect)(function () {
    var timerId = setTimeout(function () {
      var rootContainerElement = document.getElementById("root_container");
      var currRefElement = document.getElementById("curr_ref");
      var padRefElement = document.getElementById("pad_ref");
      var currDelLeftElement = document.getElementById("curr_del_left");
      var curr1 = document.getElementById("curr1");
      var curr2 = document.getElementById("curr2");
      var curr3 = document.getElementById("curr3");
      gsap/* default.to */.ZP.to(currRefElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        width: "100%",
        borderRadius: 0,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(padRefElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        width: "1200px",
        ease: ANIMATION_TYPE
      });
      gsap/* default.to */.ZP.to(currDelLeftElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        visibility: "visible",
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(curr1, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        rotate: 0,
        left: 25,
        // top: 110,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(curr2, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        left: 117,
        rotate: 0,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(curr3, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        rotate: 0,
        left: 209,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
    }, 300);
    return function () {
      clearTimeout(timerId);
    };
  }, []);
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useForexCardAnimation/index.tsx



var useForexCardAnimation = function useForexCardAnimation() {
  var ANIMATION_TYPE = "ease-in-out";
  gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollTrigger_default()));
  (0,react.useEffect)(function () {
    setTimeout(function () {
      var rootContainerElement = document.getElementById("root_container");
      var currRefElement = document.getElementById("curr_ref");
      var greyRefElement = document.getElementById("grey_ref");
      var padRefElement = document.getElementById("pad_ref");
      var currDelLeftElement = document.getElementById("curr_del_left");
      var bmfCardElement = document.getElementById("bmf_card");
      var forexCardElement = document.getElementById("forex_card");
      var transLeftElement = document.getElementById("trans_left");
      gsap/* default.to */.ZP.to(currRefElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        width: "100%",
        borderRadius: 0,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(padRefElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        width: "1200px",
        ease: ANIMATION_TYPE
      });
      gsap/* default.to */.ZP.to(currDelLeftElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        visibility: "visible",
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(bmfCardElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: greyRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        y: -95,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(forexCardElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: greyRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        y: 40,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(transLeftElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: greyRefElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        opacity: 1,
        delay: 0.3,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
    }, 300);
  }, []);
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/usePincode/index.ts
var usePincode = __webpack_require__(7184);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/usePrivacyAnimation/index.tsx
var usePrivacyAnimation = __webpack_require__(8724);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useInsuranceAnimation/index.ts



var useInsuranaceAnimation = function useInsuranaceAnimation() {
  var ANIMATION_TYPE = "ease-in-out";
  gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollTrigger_default()));
  (0,react.useEffect)(function () {
    setTimeout(function () {
      var rootContainerElement = document.getElementById("root_container");
      var featRefElement = document.getElementById("feat_ref");
      var lug1Element = document.getElementById("lug1_ref");
      var lug2Element = document.getElementById("lug2_ref");
      var shieldElement = document.getElementById("shield_ref");
      var shieldRectElement = document.getElementById("shieldRect_ref");
      var app1Element = document.getElementById("app1_ref");
      var app2Element = document.getElementById("app2_ref");
      var coinsElement = document.getElementById("coins_ref");
      var moneyBagElement = document.getElementById("moneyBag_ref");
      gsap/* default.to */.ZP.to(moneyBagElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        x: -44,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(app1Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        opacity: 1,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(app2Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        opacity: 1,
        ease: ANIMATION_TYPE,
        duration: 0.9,
        delay: 0.5
      }); //-----

      gsap/* default.to */.ZP.to(coinsElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        opacity: 1,
        delay: 0.4,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(lug1Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        x: -43,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(lug2Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        x: 81,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(shieldElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        opacity: 1,
        scale: 1,
        delay: 0.3,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(shieldRectElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: featRefElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        y: -30,
        opacity: 1,
        ease: ANIMATION_TYPE,
        delay: 0.3,
        duration: 0.9
      });
    }, 300);
  }, []);
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useHeaderAnimation/index.tsx



var useHeaderAnimation = function useHeaderAnimation(setIsLight) {
  var ANIMATION_TYPE = "ease-in-out";
  gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollTrigger_default()));
  (0,react.useEffect)(function () {
    var timerId = setTimeout(function () {
      var rootContainerElement = document.getElementById("root_container");
      var bmfValueProp = document.getElementById("curr_ref");
      var landingMapLeft = document.getElementById("LandingMapLeft");
      var tmlogo = document.getElementById("tmlogo");
      var privacyElement = document.getElementById("privacy_ref");
      var greyRefElement = document.getElementById("grey_ref");
      var headerElement = document.getElementById("header_ref");
      var forexCardWidget = document.getElementById("id_forex_card_widget");
      var forexListingTrustUs = document.getElementById("forex_listing_trust_us");
      gsap/* default.to */.ZP.to(tmlogo, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: bmfValueProp,
          start: "top top+=80",
          //toggleActions: "play none restart reset",
          end: "bottom top",
          onEnter: function onEnter() {
            setIsLight(false);
          },
          onLeaveBack: function onLeaveBack() {
            setIsLight(true);
          }
        }
      });

      function registerHeaderBackgroundTransition() {
        var _document$querySelect, _document$querySelect2;

        var gsapConfig = {
          headerLight: {
            color: "#000",
            backgroundColor: "#fff"
          },
          headerDark: {
            backgroundColor: "#000",
            color: "rgba(255,255,255,0.6)"
          },
          headerGrey: {
            color: "#000",
            backgroundColor: "#f5f5f5"
          },
          headerTransparent: {
            backgroundColor: "transparent",
            color: "rgba(255,255,255,0.6)"
          }
        };

        if (((_document$querySelect = document.querySelector("body")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.className) === "about-us") {
          // hero banner section
          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: ".about-us",
              trigger: "#aboutUsWrapper",
              start: "top top",
              end: "bottom top",
              onEnter: function onEnter() {
                setIsLight(false);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerGrey);
              },
              onLeaveBack: function onLeaveBack() {
                setIsLight(false);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerGrey);
              }
            },
            ease: ANIMATION_TYPE
          }); // our journey section

          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: ".about-us",
              trigger: "#ourJourney",
              start: "top 80px",
              end: "bottom top",
              onEnter: function onEnter() {
                setIsLight(true);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerDark);
              },
              onLeaveBack: function onLeaveBack() {
                setIsLight(false);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerGrey);
              }
            },
            ease: ANIMATION_TYPE
          }); // spotlight section

          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: ".about-us",
              trigger: "#spotLight",
              start: "top 80px",
              end: "bottom top",
              onEnter: function onEnter() {
                setIsLight(false);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerLight);
              },
              onLeaveBack: function onLeaveBack() {
                setIsLight(true);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerDark);
              }
            },
            ease: ANIMATION_TYPE
          });
        } else if (((_document$querySelect2 = document.querySelector("body")) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.className) === "forex-listing-page") {
          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: ".forex-listing-page",
              trigger: forexCardWidget,
              start: "top top+=80",
              end: "bottom top",
              onEnter: function onEnter() {
                setIsLight(true);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerDark);
              },
              onLeaveBack: function onLeaveBack() {
                setIsLight(false);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerLight);
              }
            },
            ease: ANIMATION_TYPE
          });
          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: ".forex-listing-page",
              trigger: forexListingTrustUs,
              start: "top top+=80",
              end: "bottom top",
              onEnter: function onEnter() {
                setIsLight(false);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerLight);
              },
              onLeaveBack: function onLeaveBack() {
                setIsLight(true);
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerDark);
              }
            },
            ease: ANIMATION_TYPE
          });
        } else {
          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: rootContainerElement,
              trigger: landingMapLeft,
              start: "top top+=80",
              end: "bottom top",
              onEnter: function onEnter() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerDark);
              },
              onLeaveBack: function onLeaveBack() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerTransparent);
              }
            },
            ease: ANIMATION_TYPE
          });
          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: rootContainerElement,
              trigger: bmfValueProp,
              start: "top top+=80",
              end: "bottom top",
              onEnter: function onEnter() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerLight);
              },
              onLeaveBack: function onLeaveBack() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerDark);
              }
            },
            ease: ANIMATION_TYPE
          });
          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: rootContainerElement,
              trigger: greyRefElement,
              start: "top top+=60",
              end: "bottom top",
              onEnter: function onEnter() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerGrey);
              },
              onLeaveBack: function onLeaveBack() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerLight);
              }
            },
            ease: ANIMATION_TYPE
          });
          gsap/* default.to */.ZP.to(headerElement, {
            scrollTrigger: {
              scroller: rootContainerElement,
              trigger: privacyElement,
              start: "top top+=80",
              // toggleActions: "play none restart reset",
              end: "bottom top",
              onEnter: function onEnter() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerLight);
              },
              onLeaveBack: function onLeaveBack() {
                gsap/* default.to */.ZP.to(headerElement, gsapConfig.headerGrey);
              }
            },
            ease: ANIMATION_TYPE
          });
        }
      }

      registerHeaderBackgroundTransition();
    }, 300);
    return function () {
      clearTimeout(timerId);
    };
  }, []);
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useHeaderMobileAnimation/index.ts
var useHeaderMobileAnimation = __webpack_require__(4466);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 9 modules
var src = __webpack_require__(5537);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useBreakpoint/index.tsx
var hooks_useBreakpoint = __webpack_require__(4484);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useGeolocation/index.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var initialState = {
  location: null,
  error: null,
  isLoading: false
};
var LOCATION_FETCH_LOADING = "LOCATION_FETCH_LOADING";
var LOCATION_FETCH_SUCCESS = "LOCATION_FETCH_SUCCESS";
var LOCATION_FETCH_ERROR = "LOCATION_FETCH_ERROR";

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case LOCATION_FETCH_LOADING:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isLoading: true
      });

    case LOCATION_FETCH_SUCCESS:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        location: payload
      });

    case LOCATION_FETCH_ERROR:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        error: payload
      });

    default:
      return state;
  }
};

var useGeoLocation = function useGeoLocation() {
  var isSaveInSession = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var userSessionKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "user_location";

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var device = useBreakpoint();

  var setUserLocationWeb = function setUserLocationWeb() {
    if (navigator.permissions) {
      dispatch({
        type: LOCATION_FETCH_LOADING
      });
      navigator.geolocation.getCurrentPosition(function (position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        dispatch({
          type: LOCATION_FETCH_SUCCESS,
          payload: {
            latitude: latitude,
            longitude: longitude
          }
        });
      }, function (error) {
        dispatch({
          type: LOCATION_FETCH_ERROR,
          payload: error
        });
      });
    } else {
      console.error("Geolocation not supported");
    }
  };

  var setUserLocationAndroid = function setUserLocationAndroid() {
    var _window, _window$app_bridge;

    dispatch({
      type: LOCATION_FETCH_LOADING
    }); // @ts-ignore

    window.fetchUserLocation = function (userLocation) {
      var location = JSON.parse(userLocation);

      var _ref2 = location || {},
          Latitude = _ref2.Latitude,
          Longitude = _ref2.Longitude;

      if (Latitude && Longitude) {
        dispatch({
          type: LOCATION_FETCH_SUCCESS,
          payload: {
            latitude: Latitude,
            longitude: Longitude
          }
        });
      } else {
        dispatch({
          type: LOCATION_FETCH_ERROR,
          payload: {
            message: "Location denied"
          }
        });
      }
    }; // @ts-ignore


    (_window = window) === null || _window === void 0 ? void 0 : (_window$app_bridge = _window.app_bridge) === null || _window$app_bridge === void 0 ? void 0 : _window$app_bridge.fetchLocation("fetchUserLocation");
  };

  var setUserLocation = function setUserLocation() {
    var _window2;

    var mobileOS = getMobileOperatingSystem(); // @ts-ignore

    if (mobileOS.toLowerCase() === "android" && (_window2 = window) !== null && _window2 !== void 0 && _window2.app_bridge) {
      console.log("android");
      setUserLocationAndroid();
      return;
    }

    setUserLocationWeb();
  };

  var setUserLocationIfPermittedDesktop = function setUserLocationIfPermittedDesktop() {
    if (navigator.permissions) {
      navigator.permissions.query({
        name: "geolocation"
      }).then(function (permissionStatus) {
        if (permissionStatus.state === "granted") {
          setUserLocationWeb();
        } else {
          // Permission not granted, do not request location
          console.error("Permission not granted", permissionStatus.state);
        }
      });
    } else {
      // Geolocation not supported
      console.log("Geolocation not supported");
    }
  };

  var setUserLocationIfPermittedAndroid = function setUserLocationIfPermittedAndroid() {// TODO: Once method is available on bridge.
  };

  var setUserLocationIfPermittedIOS = function setUserLocationIfPermittedIOS() {// TODO: Once method is available on bridge.
  };

  var setUserLocationIfPermitted = function setUserLocationIfPermitted() {
    if (device === "lg") {
      setUserLocationIfPermittedDesktop();
    } else if (device === "sm") {
      var _window3;

      // @ts-ignore
      if ((_window3 = window) !== null && _window3 !== void 0 && _window3.app_bridge) {
        var mobileOS = getMobileOperatingSystem();

        if (mobileOS.toLowerCase() === "android") {
          setUserLocationIfPermittedAndroid();
        } else if (mobileOS.toLocaleLowerCase() === "ios") {
          setUserLocationIfPermittedIOS();
        }
      }
    }
  };

  useEffect(function () {
    if (isSaveInSession) {
      setSessionStorageItem(userSessionKey, state.location, true, {
        isPiiData: true,
        shouldStringifyJson: true
      });
    } else {
      removeSessionStorageData(userSessionKey);
    }
  }, [state.location]);
  return _objectSpread(_objectSpread({}, state), {}, {
    setUserLocation: setUserLocation,
    setUserLocationIfPermitted: setUserLocationIfPermitted
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useFreezeBodyScroll/index.tsx

var useFreezeBodyScroll = function useFreezeBodyScroll(isModalOpen) {
  useEffect(function () {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }

    return function () {
      document.body.style.overflow = "scroll";
    };
  }, [isModalOpen]);
};
;// CONCATENATED MODULE: ../../node_modules/isbot/index.mjs
function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}
function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
  _classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _classPrivateMethodInitSpec(obj, privateSet) {
  _checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}

var list = [
	" daum[ /]",
	" deusu/",
	" yadirectfetcher",
	"(?:^| )site",
	"(?:^|[^g])news",
	"@[a-z]",
	"\\(at\\)[a-z]",
	"\\(github\\.com/",
	"\\[at\\][a-z]",
	"^12345",
	"^<",
	"^[\\w \\.\\-\\(\\)]+(/v?\\d+(\\.\\d+)?(\\.\\d{1,10})?)?$",
	"^[^ ]{50,}$",
	"^active",
	"^ad muncher",
	"^amaya",
	"^anglesharp/",
	"^anonymous",
	"^avsdevicesdk/",
	"^axios/",
	"^bidtellect/",
	"^biglotron",
	"^btwebclient/",
	"^castro",
	"^clamav[ /]",
	"^client/",
	"^cobweb/",
	"^coccoc",
	"^custom",
	"^ddg[_-]android",
	"^discourse",
	"^dispatch/\\d",
	"^downcast/",
	"^duckduckgo",
	"^facebook",
	"^fdm[ /]\\d",
	"^getright/",
	"^gozilla/",
	"^hatena",
	"^hobbit",
	"^hotzonu",
	"^hwcdn/",
	"^jeode/",
	"^jetty/",
	"^jigsaw",
	"^linkdex",
	"^lwp[-: ]",
	"^metauri",
	"^microsoft bits",
	"^movabletype",
	"^mozilla/\\d\\.\\d \\(compatible;?\\)$",
	"^mozilla/\\d\\.\\d \\w*$",
	"^navermailapp",
	"^netsurf",
	"^offline explorer",
	"^php",
	"^postman",
	"^postrank",
	"^python",
	"^read",
	"^reed",
	"^restsharp/",
	"^snapchat",
	"^space bison",
	"^svn",
	"^swcd ",
	"^taringa",
	"^test certificate info",
	"^thumbor/",
	"^tumblr/",
	"^user-agent:mozilla",
	"^valid",
	"^venus/fedoraplanet",
	"^w3c",
	"^webbandit/",
	"^webcopier",
	"^wget",
	"^whatsapp",
	"^xenu link sleuth",
	"^yahoo",
	"^yandex",
	"^zdm/\\d",
	"^zoom marketplace/",
	"^{{.*}}$",
	"adbeat\\.com",
	"appinsights",
	"archive",
	"ask jeeves/teoma",
	"bit\\.ly/",
	"bluecoat drtr",
	"bot",
	"browsex",
	"burpcollaborator",
	"capture",
	"catch",
	"check",
	"chrome-lighthouse",
	"chromeframe",
	"cloud",
	"crawl",
	"cryptoapi",
	"dareboost",
	"datanyze",
	"dataprovider",
	"dejaclick",
	"dmbrowser",
	"download",
	"evc-batch/",
	"feed",
	"firephp",
	"freesafeip",
	"ghost",
	"gomezagent",
	"google",
	"headlesschrome/",
	"http",
	"httrack",
	"hubspot marketing grader",
	"hydra",
	"ibisbrowser",
	"images",
	"iplabel",
	"ips-agent",
	"java",
	"library",
	"mail\\.ru/",
	"manager",
	"monitor",
	"morningscore/",
	"neustar wpm",
	"nutch",
	"offbyone",
	"optimize",
	"pageburst",
	"pagespeed",
	"perl",
	"phantom",
	"pingdom",
	"powermarks",
	"preview",
	"proxy",
	"ptst[ /]\\d",
	"reader",
	"rexx;",
	"rigor",
	"rss",
	"scan",
	"scrape",
	"search",
	"serp ?reputation ?management",
	"server",
	"sogou",
	"sparkler/",
	"speedcurve",
	"spider",
	"statuscake",
	"stumbleupon\\.com",
	"supercleaner",
	"synapse",
	"synthetic",
	"taginspector/",
	"torrent",
	"tracemyfile",
	"transcoder",
	"trendsmapresolver",
	"twingly recon",
	"url",
	"virtuoso",
	"wappalyzer",
	"webglance",
	"webkit2png",
	"websitemetadataretriever",
	"whatcms/",
	"wordpress",
	"zgrab"
];

/**
 * Mutate given list of patter strings
 * @param {string[]} list
 * @returns {string[]}
 */
function amend(list) {
  try {
    // Risk: Uses lookbehind assertion, avoid breakage in parsing by using RegExp constructor
    new RegExp('(?<! cu)bot').test('dangerbot'); // eslint-disable-line prefer-regex-literals
  } catch (error) {
    // Skip regex fixes
    return list;
  }
  [
  // Addresses: Cubot device
  ['bot', '(?<! cu)bot'],
  // Addresses: Android webview
  ['google', '(?<! (?:channel/|google/))google(?!(app|/google| pixel))'],
  // Addresses: libhttp browser
  ['http', '(?<!(?:lib))http'],
  // Addresses: java based browsers
  ['java', 'java(?!;)'],
  // Addresses: Yandex Search App
  ['search', '(?<! ya(?:yandex)?)search']].forEach(_ref => {
    let [search, replace] = _ref;
    const index = list.lastIndexOf(search);
    if (~index) {
      list.splice(index, 1, replace);
    }
  });
  return list;
}

amend(list);
const flags = 'i';

/**
 * Test user agents for matching patterns
 */
var _list = /*#__PURE__*/new WeakMap();
var _pattern = /*#__PURE__*/new WeakMap();
var _update = /*#__PURE__*/new WeakSet();
var _index = /*#__PURE__*/new WeakSet();
class Isbot {
  constructor(patterns) {
    /**
     * Find the first index of an existing rule or -1 if not found
     * @param  {string} rule
     * @returns {number}
     */
    _classPrivateMethodInitSpec(this, _index);
    /**
     * Recreate the pattern from rules list
     */
    _classPrivateMethodInitSpec(this, _update);
    /**
     * @type {string[]}
     */
    _classPrivateFieldInitSpec(this, _list, {
      writable: true,
      value: void 0
    });
    /**
     * @type {RegExp}
     */
    _classPrivateFieldInitSpec(this, _pattern, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _list, patterns || list.slice());
    _classPrivateMethodGet(this, _update, _update2).call(this);
    const isbot = ua => this.test(ua);
    return Object.defineProperties(isbot, Object.entries(Object.getOwnPropertyDescriptors(Isbot.prototype)).reduce((accumulator, _ref) => {
      let [prop, descriptor] = _ref;
      if (typeof descriptor.value === 'function') {
        Object.assign(accumulator, {
          [prop]: {
            value: this[prop].bind(this)
          }
        });
      }
      if (typeof descriptor.get === 'function') {
        Object.assign(accumulator, {
          [prop]: {
            get: () => this[prop]
          }
        });
      }
      return accumulator;
    }, {}));
  }
  /**
   * Get a clone of the pattern
   * @type RegExp
   */
  get pattern() {
    return new RegExp(_classPrivateFieldGet(this, _pattern));
  }

  /**
   * Match given string against out pattern
   * @param  {string} ua User Agent string
   * @returns {boolean}
   */
  test(ua) {
    return Boolean(ua) && _classPrivateFieldGet(this, _pattern).test(ua);
  }

  /**
   * Get the match for strings' known crawler pattern
   * @param  {string} ua User Agent string
   * @returns {string|null}
   */
  find() {
    let ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const match = ua.match(_classPrivateFieldGet(this, _pattern));
    return match && match[0];
  }

  /**
   * Get the patterns that match user agent string if any
   * @param  {string} ua User Agent string
   * @returns {string[]}
   */
  matches() {
    let ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return _classPrivateFieldGet(this, _list).filter(entry => new RegExp(entry, flags).test(ua));
  }

  /**
   * Clear all patterns that match user agent
   * @param  {string} ua User Agent string
   * @returns {void}
   */
  clear() {
    let ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.exclude(this.matches(ua));
  }

  /**
   * Extent patterns for known crawlers
   * @param  {string[]} filters
   * @returns {void}
   */
  extend() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    [].push.apply(_classPrivateFieldGet(this, _list), filters.filter(rule => _classPrivateMethodGet(this, _index, _index2).call(this, rule) === -1).map(filter => filter.toLowerCase()));
    _classPrivateMethodGet(this, _update, _update2).call(this);
  }

  /**
   * Exclude patterns from bot pattern rule
   * @param  {string[]} filters
   * @returns {void}
   */
  exclude() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let {
      length
    } = filters;
    while (length--) {
      const index = _classPrivateMethodGet(this, _index, _index2).call(this, filters[length]);
      if (index > -1) {
        _classPrivateFieldGet(this, _list).splice(index, 1);
      }
    }
    _classPrivateMethodGet(this, _update, _update2).call(this);
  }

  /**
   * Create a new Isbot instance using given list or self's list
   * @param  {string[]} [list]
   * @returns {Isbot}
   */
  spawn(list) {
    return new Isbot(list || _classPrivateFieldGet(this, _list));
  }
}
function _update2() {
  _classPrivateFieldSet(this, _pattern, new RegExp(_classPrivateFieldGet(this, _list).join('|'), flags));
}
function _index2(rule) {
  return _classPrivateFieldGet(this, _list).indexOf(rule.toLowerCase());
}

const isbot = new Isbot();


//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useBotDetection/index.ts



/**
 * Custom hook for client-side bot detection
 * @returns {boolean | null} isBot - true if bot detected, false if not, null if detection not yet complete
 */

var useBotDetection = function useBotDetection() {
  var _useState = (0,react.useState)(null),
      isBot = _useState[0],
      setIsBot = _useState[1];

  (0,react.useEffect)(function () {
    // Client-side bot detection
    if (true) {
      var userAgent = window.navigator.userAgent;
      var botDetected = (0,src/* checkIsBot */.cB)(userAgent, isbot);
      setIsBot(botDetected);
    }
  }, []);
  return isBot;
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useCountTimer/index.ts
var useCountTimer = __webpack_require__(8739);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/index.ts














/***/ }),

/***/ 4484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useBreakpoint */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
 // export const useBreakpoint = () => {
//     const [windowSize, setWindowSize] = useState<number>(1200);
//     function handleResize() {
//         console.log('IN THE FUNCTION: ', window.innerWidth);
//         // Set window width/height to state
//         setWindowSize(window.innerWidth);
//     }
//     useEffect(() => {
//         window.addEventListener('resize', handleResize);
//         handleResize();
//         return () => window.removeEventListener('resize', handleResize);
//     }, []); // Empty array ensures that effect is only run on mount
//     return windowSize;
// };

var useBreakpoint = function useBreakpoint() {
  var _useState = useState("lg"),
      breakpoint = _useState[0],
      setBreakpoint = _useState[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setBreakpoint("sm");
      } else {
        setBreakpoint("lg");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return breakpoint;
};

/***/ }),

/***/ 8739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useCountTimer = function useCountTimer() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(count),
      startCount = _useState[0],
      setStartCount = _useState[1];

  var intervalRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    intervalRef.current = setInterval(function () {
      setStartCount(function (startCount) {
        return startCount + 1;
      });
    }, interval);
    return function () {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
  return {
    count: startCount
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useCountTimer);

/***/ }),

/***/ 4466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4682);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5480);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__);




var useHeaderMobileAnimation = function useHeaderMobileAnimation(setIsLight) {
  var ANIMATION_TYPE = "ease-in-out";
  gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerPlugin */ .ZP.registerPlugin((gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2___default()));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var timerId = setTimeout(function () {
      var _document$querySelect;

      var rootContainerElement = document.getElementById("root_container");
      var hamBlackRefElement = document.getElementById("hamBlackMobile_ref");
      var hamWhiteRefElement = document.getElementById("hamWhiteMobile_ref");
      var tmlogo = document.getElementById("tmlogo_mobile");
      var privacyElement = document.getElementById("privacyMobile_ref");
      var headerMobileElement = document.getElementById("headerMobile_ref");
      var currMobileElement = document.getElementById("currMobile_ref");
      var greyMobileElement = document.getElementById("greyMobile_ref"); // gsap.to(mobileMapRefElement, {
      //   y: 0,
      //   opacity: 1,
      //   ease: "fade-in",
      //   //delay: 4,
      //   duration: 0.4,
      // });

      var gsapConfig = {
        headerLight: {
          color: "#000",
          backgroundColor: "#fff"
        },
        headerDark: {
          backgroundColor: "#000",
          color: "rgba(255,255,255,0.6)"
        },
        headerGrey: {
          color: "#000",
          backgroundColor: "#f5f5f5"
        },
        headerTransparent: {
          backgroundColor: "transparent",
          color: "rgba(255,255,255,0.6)"
        }
      };
      gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(tmlogo, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: currMobileElement,
          start: "top top+=60",
          // toggleActions: "play none restart reset",
          end: "bottom top",
          onEnter: function onEnter() {
            setIsLight(false);
            gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, gsapConfig.headerGrey);
          },
          onLeaveBack: function onLeaveBack() {
            setIsLight(true);
          }
        },
        ease: ANIMATION_TYPE
      });

      if (((_document$querySelect = document.querySelector("body")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.className) === "about-us-mobile") {
        // hero banner section
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
          scrollTrigger: {
            scroller: ".about-us-mobile",
            trigger: "#aboutUsWrapper",
            start: "top top",
            end: "bottom top",
            onEnter: function onEnter() {
              setIsLight(false);
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, gsapConfig.headerGrey);
            },
            onLeaveBack: function onLeaveBack() {
              setIsLight(false);
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, gsapConfig.headerGrey);
            }
          },
          ease: ANIMATION_TYPE
        }); // our journey section

        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
          scrollTrigger: {
            scroller: ".about-us-mobile",
            trigger: "#ourJourney",
            start: "top 80px",
            end: "bottom top",
            onEnter: function onEnter() {
              setIsLight(true);
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, gsapConfig.headerDark);
            },
            onLeaveBack: function onLeaveBack() {
              setIsLight(false);
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, gsapConfig.headerGrey);
            }
          },
          ease: ANIMATION_TYPE
        }); // spotlight section

        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
          scrollTrigger: {
            scroller: ".about-us-mobile",
            trigger: "#spotLight",
            start: "top 80px",
            end: "bottom top",
            onEnter: function onEnter() {
              setIsLight(false);
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, gsapConfig.headerLight);
            },
            onLeaveBack: function onLeaveBack() {
              setIsLight(true);
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, gsapConfig.headerDark);
            }
          },
          ease: ANIMATION_TYPE
        });
      } else {
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamWhiteRefElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: currMobileElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamWhiteRefElement, {
                opacity: 1
              });
            }
          },
          opacity: 1,
          ease: ANIMATION_TYPE
        });
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamWhiteRefElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: privacyElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamWhiteRefElement, {
                opacity: 1
              });
            }
          },
          // opacity: 1,
          ease: ANIMATION_TYPE
        });
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamWhiteRefElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: greyMobileElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamWhiteRefElement, {
                opacity: 1
              });
            }
          },
          // opacity: 1,
          ease: ANIMATION_TYPE
        }); // gsap.to(hamWhiteRefElement, {
        //   scrollTrigger: {
        //     scroller: rootContainerElement,
        //     trigger: rootContainerElement,
        //     start: "top top+=60",
        //     // toggleActions: "play none restart reset",
        //     end: "bottom top",
        //   },
        //   opacity: 0,
        //   color: "#000",
        //   ease: ANIMATION_TYPE,
        // });
        // gsap.to(hamBlackRefElement, {
        //   scrollTrigger: {
        //     scroller: rootContainerElement,
        //     trigger: rootContainerElement,
        //     start: "top top+=60",
        //     // toggleActions: "play none restart reset",
        //     end: "bottom top",
        //     onEnter: () => {
        //       gsap.to(hamBlackRefElement, {opacity:0,display:"none"})
        //     },
        //     onLeaveBack: () => {
        //       gsap.to(hamBlackRefElement, {opacity:1,display:"inline-block"})
        //     },
        //   },
        //   // opacity: 1,
        //   // color: "#000",
        //   ease: ANIMATION_TYPE,
        // });

        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamBlackRefElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: currMobileElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamBlackRefElement, {
                opacity: 0,
                display: "none"
              });
            },
            onLeaveBack: function onLeaveBack() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamBlackRefElement, {
                opacity: 1,
                display: "inline-block"
              });
            }
          },
          // display: "none",
          // opacity: 0,
          // color: "#000",
          ease: ANIMATION_TYPE
        });
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamBlackRefElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: privacyElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamBlackRefElement, {
                opacity: 0,
                display: "none"
              });
            }
          },
          // display: "none",
          // opacity: 0,
          ease: ANIMATION_TYPE
        });
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamBlackRefElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: greyMobileElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(hamBlackRefElement, {
                opacity: 0,
                display: "none"
              });
            }
          },
          // display: "none",
          // opacity: 0,
          ease: ANIMATION_TYPE
        });
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: currMobileElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
                color: "#000",
                backgroundColor: "#fff"
              });
            },
            onLeaveBack: function onLeaveBack() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
                backgroundColor: "#000",
                color: "rgba(255,255,255,0.6)"
              });
            }
          },
          // background: "#fff",
          // color: "#000",
          ease: ANIMATION_TYPE
        });
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: privacyElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
                color: "#000",
                backgroundColor: "#fff"
              });
            },
            onLeaveBack: function onLeaveBack() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
                color: "#000",
                backgroundColor: "#f5f5f5"
              });
            }
          },
          // background: "#fff",
          // color: "#000",
          ease: ANIMATION_TYPE
        });
        gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
          scrollTrigger: {
            scroller: rootContainerElement,
            trigger: greyMobileElement,
            start: "top top+=60",
            // toggleActions: "play none restart reset",
            end: "bottom top",
            onEnter: function onEnter() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
                color: "#000",
                backgroundColor: "#f5f5f5"
              });
            },
            onLeaveBack: function onLeaveBack() {
              gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(headerMobileElement, {
                color: "#000",
                backgroundColor: "#fff"
              });
            }
          },
          // background: "#F5F5F5",
          // color: "#000",
          ease: ANIMATION_TYPE
        });
      }
    }, 300);
    return function () {
      return clearTimeout(timerId);
    };
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useHeaderMobileAnimation);

/***/ }),

/***/ 7184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ usePincode; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9381);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_ui_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1726);



var usePincode = function usePincode() {
  var _data$find, _data$find2;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_tm_ui_contexts__WEBPACK_IMPORTED_MODULE_2__/* .PublicEnv */ .Zw),
      proxyCmsPrefix = _useContext.proxyCmsPrefix;

  var url = "".concat(proxyCmsPrefix, "/jsons?type_in=inrPincodeDeliveryEstimates&type_in=pincodes");

  var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(url),
      data = _useSWR.data;

  var pincodeData = (data === null || data === void 0 ? void 0 : (_data$find = data.find(function (obj) {
    return obj.type === "pincodes";
  })) === null || _data$find === void 0 ? void 0 : _data$find.data) || {};
  var deliveryEstimateData = (data === null || data === void 0 ? void 0 : (_data$find2 = data.find(function (obj) {
    return obj.type === "inrPincodeDeliveryEstimates";
  })) === null || _data$find2 === void 0 ? void 0 : _data$find2.data) || {};
  return {
    pincodeData: pincodeData,
    deliveryEstimateData: deliveryEstimateData
  };
};

/***/ }),

/***/ 8724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ usePrivacyAnimation; }
/* harmony export */ });
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4682);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5480);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



var usePrivacyAnimation = function usePrivacyAnimation() {
  var ANIMATION_TYPE = "ease-in-out";
  gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerPlugin */ .ZP.registerPlugin((gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2___default()));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var timeId = setTimeout(function () {
      var rootContainerElement = document.getElementById("root_container");
      var lockVerElement = document.getElementById("lockVer_ref");
      var lockElement = document.getElementById("lock_ref");
      var lockPrivacyElement = document.getElementById("lock_privacy_ref");
      gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(lockElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: lockPrivacyElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        x: 0,
        y: "31",
        duration: 0.4,
        ease: ANIMATION_TYPE
      });
      gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(lockVerElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: lockPrivacyElement,
          start: "top center",
          toggleActions: "restart none none reverse"
        },
        opacity: 1,
        duration: 0.4,
        ease: ANIMATION_TYPE
      });
    }, 300);
    return function () {
      return clearTimeout(timeId);
    };
  }, []);
};

/***/ }),

/***/ 3907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useScroll = function useScroll() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8000;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      scroll = _useState[0],
      setScroll = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var timeId = setTimeout(function () {
      setScroll(true);
    }, timeout);
    return function () {
      clearTimeout(timeId);
    };
  }, [timeout]);
  return {
    scroll: scroll
  };
};

/***/ }),

/***/ 6533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GW": function() { return /* binding */ PRODUCT_CODE; },
  "fY": function() { return /* binding */ PRODUCT_TYPE; },
  "Y9": function() { return /* binding */ SEO_REDIRECTIONS; }
});

// UNUSED EXPORTS: CASHBACK_STATUS, CASHBACK_TEXT, IOS, PARTNER

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/constants/partner.ts
var PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/constants/index.ts


var _CASHBACK_TEXT;


var SEO_REDIRECTIONS = {
  CARD_LOAD: "https://forex.makemytrip.com/mweb/partners/mmt/forex/bmf/dashboard?",
  CARD_BUY: "https://forex.makemytrip.com/partners/mmt/forex/bmf/onboarding/load-currency?",
  CURRENCY_BUY: "https://forex.makemytrip.com/partners/mmt/forex/bmf/currency/onboarding/load-currency?"
};
var PRODUCT_TYPE = {
  CARD: "card",
  CURRENCY: "currency"
};
var CASHBACK_STATUS = {
  COMMITTED: "COMMITTED",
  CANCELLED: "CANCELLED",
  CREDITED: "CREDITED",
  AVAILABLE: "AVAILABLE"
};
var CASHBACK_TEXT = (_CASHBACK_TEXT = {}, (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, CASHBACK_STATUS.COMMITTED, "Applied"), (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, CASHBACK_STATUS.CANCELLED, "Cancelled"), (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, CASHBACK_STATUS.CREDITED, "Credited"), (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, CASHBACK_STATUS.AVAILABLE, "Available"), _CASHBACK_TEXT);
var PRODUCT_CODE = {
  CARD: "PC",
  CURRENCY: "CN",
  NIUM: "NC"
};
var IOS = "ios";

/***/ }),

/***/ 4709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ getUtmParamsForCalculatorCta; },
/* harmony export */   "Ho": function() { return /* binding */ isHostMakemytrip; },
/* harmony export */   "PL": function() { return /* binding */ addUtmParamsToUrl; },
/* harmony export */   "Ts": function() { return /* binding */ DEVICE_SIZES; },
/* harmony export */   "nk": function() { return /* binding */ SEO_TEMPLATE_TYPE; },
/* harmony export */   "sI": function() { return /* binding */ generateSourceSetImageUrl; },
/* harmony export */   "vO": function() { return /* binding */ deviceType; }
/* harmony export */ });
/* unused harmony exports breakpoint, fakeUUID, randomDayData, dayAdditionalData, MONTHS, SHORT_WEEK_DAYS, LONG_WEEK_DAYS, anyDateCreator, dateArrGenerator, landingDateFormatter, modifyDateFormatter, mfActiveTypeMatch, calendarLabelFormatter, insertBrOnNewLine, convertDateToUnix, convertUnixToDate, DATE_FORMATS, formatDate, replaceHistory, replaceHistoryRemoveParams, checkIfVaildCardHolder, isOnServer, TRIPMONEY_MMT_DOMAIN_NAMES */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tm_utility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5537);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6533);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9666);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



 // RESPONSIVE BREAKPOINTS

var breakpoint = {
  mobile: 768
};
var deviceType = {
  mobile: "(max-width: ".concat(breakpoint.mobile, "px)"),
  desktop: "(min-width: ".concat(breakpoint.mobile, "px)")
}; // Device size constants for UI components

var DEVICE_SIZES = {
  LARGE: "lg",
  SMALL: "sm"
}; // UTILS FUNCTIONS

var fakeUUID = function fakeUUID() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;

  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}; // CALENDAR UTILITY FUNCTIONS

var randomDayData = function randomDayData() {
  var min = 10000;
  var max = 15000;
  var randomNum = Math.floor(Math.random() * (max - min + 1) + min);
  return {
    price: "\u20B9".concat(randomNum),
    class: randomNum <= 12000 ? "greenText" : "redText",
    isSoldOut: randomNum > 12000 && randomNum < 13000,
    availableOnPreviousDate: randomNum >= 13000 && randomNum <= 13500
  };
};
var dayAdditionalData = new Array(31).fill(0).map(function () {
  return randomDayData();
});
var MONTHS = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]));
var SHORT_WEEK_DAYS = (/* unused pure expression or super */ null && (["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"]));
var LONG_WEEK_DAYS = (/* unused pure expression or super */ null && (["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]));
var anyDateCreator = function anyDateCreator(afterDays, dateObj) {
  if (dateObj) {
    var newDateObj = new Date(dateObj.getTime());
    return new Date(newDateObj.setDate(newDateObj.getDate() + afterDays));
  }

  return new Date(new Date().setDate(new Date().getDate() + afterDays));
}; // WILL RETURN ARRAY CONTAINING [dd, mmm, yy, dy]

var dateArrGenerator = function dateArrGenerator(dateObj) {
  return dateObj ? [dateObj.getDate(), MONTHS[dateObj.getMonth()], dateObj.getFullYear().toString().slice(-2), LONG_WEEK_DAYS[dateObj.getDay()]] : [new Date().getDate(), MONTHS[new Date().getMonth()], new Date().getFullYear().toString().slice(-2), LONG_WEEK_DAYS[new Date().getDay()]];
}; // FOR LANDING PAGE LABEL DISPLAY

var landingDateFormatter = function landingDateFormatter(dateObj) {
  return dateObj ? "".concat(dateObj.getDate(), " <span class='latoRegular font18 lineHeight10'>").concat(MONTHS[dateObj.getMonth()], " '").concat(dateObj.getFullYear().toString().slice(-2), "</span>") : "".concat(new Date().getDate(), " <span class='latoRegular font18 lineHeight10'>").concat(MONTHS[new Date().getMonth()], " '").concat(new Date().getFullYear().toString().slice(-2), "</span>");
}; // FOR MODIFY SEARCH LABEL DISPLAY

var modifyDateFormatter = function modifyDateFormatter(dateObj) {
  return dateObj ? "".concat(SHORT_WEEK_DAYS[dateObj.getDay()], ", <span class='latoBlack'>").concat(dateObj.getDate(), " ").concat(MONTHS[dateObj.getMonth()], "</span> ").concat(dateObj.getFullYear().toString().slice(-2)) : "".concat(SHORT_WEEK_DAYS[new Date().getDay()], ", <span class='latoBlack'>").concat(new Date().getDate(), " ").concat(MONTHS[new Date().getMonth()], "</span> ").concat(new Date().getFullYear().toString().slice(-2));
};
var mfActiveTypeMatch = {
  0: "Option 1",
  1: "Option 2",
  2: "Option 3"
}; // FOR DISPAYING INSIDE THE CALENDAR

var calendarLabelFormatter = function calendarLabelFormatter(dateObj) {
  return dateObj ? "".concat(dateObj.getDate(), " ").concat(MONTHS[dateObj.getMonth()], "' ").concat(dateObj.getFullYear().toString().slice(-2)) : "".concat(new Date().getDate(), " ").concat(MONTHS[new Date().getMonth()], "' ").concat(new Date().getFullYear().toString().slice(-2));
};
var insertBrOnNewLine = function insertBrOnNewLine(text) {
  return text.replace(/\n/g, "<br/>");
};
insertBrOnNewLine("hello he\nyello");
var generateSourceSetImageUrl = function generateSourceSetImageUrl(cdnUrlWidths, imgUrl, width) {
  var imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(function (width) {
    return "".concat(imgUrl, "?im=Resize=(").concat(width, ") ").concat(width, "w");
  }).join(",");
};
var convertDateToUnix = function convertDateToUnix(date) {
  return Math.floor(new Date(date).getTime() / 1000);
};
var convertUnixToDate = function convertUnixToDate(unix) {
  return new Date(unix * 1000);
};
var DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM'yy";
})(DATE_FORMATS || (DATE_FORMATS = {}));

var MONTHS_SHORT = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
var formatDate = function formatDate(date, format) {
  try {
    date = new Date(date);

    switch (format) {
      case DATE_FORMATS["DD MMM YY"]:
        return "".concat(date.getDate(), " ").concat(MONTHS_SHORT[date.getMonth()], "'").concat(date.getFullYear().toString().substr(-2));

      default:
        return;
    }
  } catch (error) {
    console.log("Error in formatting given date", date, format);
  }

  return;
};
function replaceHistory(param, value) {
  var baseUrl = window.location.pathname;
  var searchParams = new URLSearchParams(window.location.search);
  (value === null || value === void 0 ? void 0 : value.length) > 0 ? searchParams.set(param, value) : null;
  var url = "".concat(baseUrl).concat(searchParams.toString().length > 0 ? "?" + searchParams : "");
  window.history.replaceState(_objectSpread(_objectSpread({}, window.history.state), {}, {
    as: url,
    url: url
  }), "", url);
}
function replaceHistoryRemoveParams(param) {
  var baseUrl = window.location.pathname;
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(param);
  var url = "".concat(baseUrl).concat(searchParams.toString().length > 0 ? "?" + searchParams : "");
  window.history.replaceState(_objectSpread(_objectSpread({}, window.history.state), {}, {
    as: url,
    url: url
  }), "", url);
}
var checkIfVaildCardHolder = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var tmAuthValue, myHeaders, requestOptions, response, validCardHolderData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            tmAuthValue = getCookie("x-tm-auth") || "";
            myHeaders = new Headers();
            myHeaders.append("x-tm-auth", tmAuthValue);
            myHeaders.append("x-rq-id", generateRequestId());
            requestOptions = {
              method: "GET",
              headers: myHeaders,
              redirect: "follow"
            };
            _context.next = 8;
            return fetch("".concat(FOREX_API_BASE_URL, "/").concat(CLIENT_BACKEND_BASE_URL, "/check-valid-card-holder?program=FOREX_BMF_MAKEMYTRIP"), requestOptions);

          case 8:
            response = _context.sent;
            _context.next = 11;
            return response.json();

          case 11:
            validCardHolderData = _context.sent;

            if (!(validCardHolderData !== null && validCardHolderData !== void 0 && validCardHolderData.success)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", validCardHolderData === null || validCardHolderData === void 0 ? void 0 : validCardHolderData.is_valid_card_holder);

          case 14:
            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            console.error("Exchange Rate Not Found", _context.t0);

          case 19:
            return _context.abrupt("return", false);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function checkIfVaildCardHolder() {
    return _ref.apply(this, arguments);
  };
}()));
var isOnServer = function isOnServer() {
  if (false) {}

  return false;
};
var TRIPMONEY_MMT_DOMAIN_NAMES = (/* unused pure expression or super */ null && (["forex.makemytrip.com", "www.makemytrip.com", "tripmoney.makemytrip.com"]));
var isHostMakemytrip = function isHostMakemytrip() {
  if (isOnServer()) return false;
  return (0,_tm_utility__WEBPACK_IMPORTED_MODULE_1__/* .isHostMMT */ .yL)();
};

var getUtmMedium = function getUtmMedium() {
  var templateType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var utm_medium = "";
  var path = window.location.pathname;

  if (templateType === SEO_TEMPLATE_TYPE.CURRENCY_RATE) {
    utm_medium = SEO_TEMPLATE_TYPE.CURRENCY_RATE;
  } else if (templateType === SEO_TEMPLATE_TYPE.DENOMINATION_SEO) {
    utm_medium = SEO_TEMPLATE_TYPE.DENOMINATION_SEO;
  } else if (path.includes("exchange")) {
    utm_medium = "currency-exchange";
  } else if (path.includes("currency-converter/")) {
    utm_medium = "currency-converter";
  } else if (path.includes("/currency")) {
    utm_medium = "currency";
  }

  return utm_medium;
};

var getUtmParamsForCalculatorCta = function getUtmParamsForCalculatorCta(productType, templateType) {
  var utm_source = "";
  var utm_medium = "";
  var utm_campaign = "";
  var path = window.location.pathname;
  var pathParams = path === null || path === void 0 ? void 0 : path.split("/");
  utm_campaign = pathParams[pathParams.length - 1] === "currency" ? "home" : pathParams[pathParams.length - 1];

  if (productType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_TYPE.CARD */ .fY.CARD) {
    utm_source = "converter-card";
  } else if (productType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_TYPE.CURRENCY */ .fY.CURRENCY) {
    utm_source = "converter-currency";
  }

  utm_medium = getUtmMedium(templateType);
  return "utm_source=".concat(utm_source, "&utm_medium=").concat(utm_medium, "&utm_campaign=").concat(utm_campaign);
};
var addUtmParamsToUrl = function addUtmParamsToUrl(productType, templateType) {
  var utm_source = "",
      utm_medium = "",
      utm_campaign = "";
  var path = window.location.pathname;
  var pathParams = path === null || path === void 0 ? void 0 : path.split("/");
  utm_campaign = pathParams[pathParams.length - 1] === "currency" ? "home" : pathParams[pathParams.length - 1];
  utm_medium = getUtmMedium(templateType);

  if (productType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_TYPE.CARD */ .fY.CARD) {
    utm_source = "card-seo";
  } else if (productType === "currency") {
    utm_source = "currency-notes-seo";
  }

  return "utm_source=".concat(utm_source, "&utm_medium=").concat(utm_medium, "&utm_campaign=").concat(utm_campaign);
};
var SEO_TEMPLATE_TYPE = {
  CURRENCY_RATE: "currency-rate",
  DENOMINATION_SEO: "denomination-seo"
};

/***/ }),

/***/ 2684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);



var BMFLogo = function BMFLogo(_ref) {
  var _ref$isLight = _ref.isLight,
      isLight = _ref$isLight === void 0 ? true : _ref$isLight;
  // const BMFColor = isLight ? "" : "#fff";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: "140",
    height: "39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 140 39",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
        children: "\n      .cls-1 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: #ea2727;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#New_Gradient_Swatch_2-2);\n      }\n\n      .cls-27 {\n        isolation: isolate;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-11 {\n        fill: url(#New_Gradient_Swatch_2);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-20, .cls-28 {\n        mix-blend-mode: screen;\n        opacity: .25;\n      }\n\n      .cls-21 {\n        fill: #838383;\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-23 {\n        fill: #204181;\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-26 {\n        fill: #184a80;\n      }\n    "
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "linear-gradient",
        x1: -464.16,
        y1: -51.35,
        x2: -464.16,
        y2: -65.4,
        gradientTransform: "translate(547.72 71.88)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0,
          stopColor: "#0e1d41"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.22,
          stopColor: "#0c305b"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.75,
          stopColor: "#085c97"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 1,
          stopColor: "#076eaf"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "linear-gradient-2",
        x1: -456.04,
        y1: -57.54,
        x2: -456.04,
        y2: -62.85,
        gradientTransform: "translate(547.72 71.88)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0,
          stopColor: "#fff"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.04,
          stopColor: "#f1f1f1"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.11,
          stopColor: "#cecece"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.21,
          stopColor: "#969696"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.33,
          stopColor: "#494949"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.44,
          stopColor: "#010101"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 1,
          stopColor: "#010101"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-3",
        x1: -460.34,
        y1: -57.52,
        x2: -460.34,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-4",
        x1: -427.78,
        y1: -59.27,
        x2: -427.78,
        y2: -63.04,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-5",
        x1: -416.95,
        y1: -61.44,
        x2: -416.95,
        y2: -63.61,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-6",
        x1: -441.64,
        y1: -58,
        x2: -441.64,
        y2: -63.05,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-7",
        x1: -434.44,
        y1: -58.68,
        x2: -434.44,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-8",
        x1: -449.35,
        y1: -57.65,
        x2: -449.35,
        y2: -65.33,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-9",
        x1: -421.74,
        y1: -60.75,
        x2: -421.74,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-10",
        x1: -478.82,
        y1: -57.88,
        x2: -478.82,
        y2: -65.33,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-11",
        x1: -495.9,
        y1: -59.14,
        x2: -495.9,
        y2: -63.05,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-12",
        x1: -505.32,
        y1: -60.61,
        x2: -505.32,
        y2: -65.33,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-13",
        x1: -465.86,
        y1: -57.51,
        x2: -465.86,
        y2: -65.37,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-14",
        x1: -471.52,
        y1: -57.58,
        x2: -471.52,
        y2: -65.37,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-15",
        x1: -487.49,
        y1: -58.31,
        x2: -487.49,
        y2: -63.05,
        xlinkHref: "#linear-gradient-2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "New_Gradient_Swatch_2",
        "data-name": "New Gradient Swatch 2",
        x1: -462.34,
        y1: -54.25,
        x2: -462.34,
        y2: -65.37,
        gradientTransform: "translate(547.72 71.88)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0,
          stopColor: "#424242"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 1,
          stopColor: "#5a5a5c"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "New_Gradient_Swatch_2-2",
        "data-name": "New Gradient Swatch 2",
        x1: -528.39,
        y1: -50.16,
        x2: -528.39,
        y2: -68.86,
        xlinkHref: "#New_Gradient_Swatch_2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "linear-gradient-16",
        x1: -537.8,
        y1: -55.96,
        x2: -524.86,
        y2: -68.89,
        gradientTransform: "translate(547.72 71.88)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0,
          stopColor: "#f28021"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.26,
          stopColor: "#f2831f"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.48,
          stopColor: "#f48d1b"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.68,
          stopColor: "#f79e15"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.87,
          stopColor: "#fbb60c"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 1,
          stopColor: "#ffcb05"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: "linear-gradient-17",
        x1: -604.26,
        y1: -122.42,
        x2: -591.32,
        y2: -135.35,
        gradientTransform: "translate(-106.28 -582.12) rotate(-90) scale(1 -1)",
        xlinkHref: "#linear-gradient"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "linear-gradient-18",
        x1: -525.78,
        y1: -55.7,
        x2: -535.12,
        y2: -69.54,
        gradientTransform: "translate(547.72 71.88)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0,
          stopColor: "#fff"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 0.3,
          stopColor: "#010101"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: 1,
          stopColor: "#010101"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      className: "cls-27",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Layer_1",
        "data-name": "Layer 1",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          className: "cls-7",
          x: -1.88,
          y: -2.32,
          width: 143.12,
          height: 42.53,
          fill: "transparent"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            className: "cls-3",
            d: "m79.03,14.86l-2.17-8.38h-2.2c-.32.02-.59.14-.81.37-.22.22-.33.49-.33.81v9.81h2.1v-8.86l2.26,8.86h2.33l2.23-8.86v8.86h2.1V6.48h-3.35l-2.17,8.38Zm13.05-5.86c-.55,0-.89.25-1.02.76l-1.5,5.23-1.72-5.99h-2.45l2.96,8.44c.15.45.1.77-.14.97-.24.2-.58.3-1,.3h-.61v1.75c.06,0,.14,0,.24.02.1.01.18.03.24.05h.45c.87,0,1.5-.13,1.88-.38.38-.3.7-.8.96-1.5l3.25-9.65h-1.53Z"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            className: "cls-28",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-16",
              d: "m91.06,9.79l-1.3,4.54c.7-.01,1.39-.02,2.08-.04l1.77-5.27h-1.53c-.55,0-.89.25-1.02.76Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-18",
              d: "m87.84,9.03h-2.45l1.87,5.33c.71,0,1.41-.01,2.11-.02l-1.53-5.31Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-25",
              d: "m122.93,9.98c-.7-.76-1.69-1.15-2.96-1.15s-2.16.39-2.84,1.18c-.56.65-.88,1.52-.96,2.59.76-.09,1.51-.19,2.24-.3.03-.51.19-.9.47-1.18.3-.3.68-.45,1.15-.45.51,0,.9.15,1.18.45.16.18.28.41.36.71.73-.12,1.45-.24,2.15-.36-.17-.58-.43-1.08-.79-1.49Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-10",
              d: "m129.81,8.84l-.95,1.6c1.01-.23,1.97-.47,2.87-.72l.94-1.45h-1.91c-.45,0-.76.19-.96.57Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-5",
              d: "m109.98,13.28s0-.05,0-.08c0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.24.02.47.04.7.73-.04,1.45-.09,2.16-.14-.01-.13-.02-.27-.03-.42-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72,0,.08,0,.16-.01.24.73-.06,1.46-.12,2.17-.19Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-17",
              d: "m115.67,11.29v-2.26h-.32c-.57,0-1.13.07-1.67.22-.54.15-1.01.38-1.42.7-.43.34-.76.79-1,1.35-.22.52-.34,1.15-.36,1.89.75-.07,1.5-.15,2.23-.23.03-.55.17-.96.44-1.23.3-.3.75-.45,1.37-.45h.73Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-22",
              d: "m102.35,8.42v-1.88h-6.82c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v6.54c.75-.02,1.49-.05,2.23-.08v-1.49h3.12c.32,0,.59-.11.81-.33.22-.22.33-.49.33-.81v-.73h-4.27v-2.36h5.74Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-19",
              d: "m126.72,9.03h-2.45l1.33,2.1c.71-.14,1.41-.28,2.08-.43l-.96-1.67Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-24",
              d: "m67.01,6.86c-.21-.21-.47-.32-.76-.32h-1.15v7.1c1.82.13,3.69.25,5.59.35l-1-1.71,3.03-3.25h-2.68l-2.71,3.12v-4.56c0-.28-.11-.52-.32-.73Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-9",
              d: "m55.09,10.75c-.38-.79-.98-1.34-1.78-1.66-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.02.07-.03.13-.05.2.69.12,1.39.23,2.11.34.1-.34.26-.63.47-.86.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.15.24.26.55.32.94.72.1,1.46.19,2.2.28-.05-.74-.22-1.4-.52-1.99Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-1",
              d: "m46.36,10.72c.23-.38.35-.85.35-1.4,0-.87-.3-1.56-.89-2.07-.6-.47-1.46-.7-2.58-.7h-4.01c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v1.76c.69.2,1.41.4,2.17.59v-1.58h2.55c.62,0,1.03.08,1.24.25.26.19.38.49.38.89s-.13.7-.38.89c-.17.13-.42.21-.73.26.82.18,1.68.35,2.56.51.2-.16.37-.34.5-.55Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-12",
              d: "m79.18,14.3c.61.01,1.21.02,1.82.03l1.43-5.69v5.71c.7,0,1.4.01,2.1.01v-7.85h-3.35l-2.01,7.79Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-15",
              d: "m76.86,6.51h-2.2c-.32.02-.59.14-.81.37-.22.22-.33.49-.33.81v6.43c.7.03,1.4.05,2.1.08v-5.56l1.43,5.6c.6.02,1.21.03,1.82.05l-2.01-7.78Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-8",
              d: "m64.11,13.57c0-.12.01-.24.01-.37,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.14,1.13-.34.38-.59.86-.75,1.43-.13.46-.2.91-.23,1.37.71.08,1.42.16,2.15.24,0-.84.2-1.48.61-1.92.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72,0,.05,0,.1,0,.15.71.06,1.43.12,2.16.18Z"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-23",
              d: "m115.06,24.89c-.46,0-.77-.33-.77-.78,0-.52.38-.97.94-.97.46,0,.78.32.78.81,0,.56-.4.95-.95.95h0Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-23",
              d: "m119.65,24.69c-.28.14-.69.21-1.15.21-.99,0-1.78-.58-1.78-1.73,0-1.47,1.14-2.55,2.74-2.55.33,0,.61.05.82.12l-.33,1.07c-.13-.05-.28-.07-.49-.07-.77,0-1.25.59-1.25,1.27,0,.52.37.75.72.75.32,0,.54-.07.75-.15l-.02,1.07Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-23",
              d: "m124.6,22.3c0,1.59-1.08,2.59-2.51,2.59-1.05,0-1.8-.64-1.8-1.7,0-1.44,1.02-2.58,2.52-2.58,1.1,0,1.79.72,1.79,1.68Zm-2.84.87c0,.4.18.65.52.65.58,0,.85-.92.85-1.51,0-.34-.14-.62-.52-.62-.61,0-.86.98-.86,1.48Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-23",
              d: "m124.91,24.81l.5-2.7c.1-.54.17-1.01.22-1.39h1.21l-.06.62h0c.37-.52.86-.72,1.38-.72.67,0,.94.42.97.72.37-.5.88-.72,1.37-.72.7,0,1,.45,1,1.11,0,.17-.03.51-.07.71l-.44,2.37h-1.37l.4-2.19c.03-.16.06-.32.06-.47,0-.22-.11-.39-.32-.39-.36,0-.67.52-.82,1.31l-.32,1.75h-1.36l.41-2.19c.02-.16.05-.32.05-.45,0-.25-.08-.42-.29-.42-.36,0-.7.52-.84,1.31l-.32,1.75h-1.37Z"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            className: "cls-11",
            d: "m45.38,11.54c.42-.21.75-.5.99-.86.23-.38.35-.85.35-1.4,0-.87-.3-1.56-.89-2.07-.6-.47-1.46-.7-2.58-.7h-4.01c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v9.81h5c1.27,0,2.26-.29,2.96-.86.68-.59,1.02-1.42,1.02-2.49,0-.66-.14-1.19-.41-1.59-.3-.42-.72-.75-1.27-.99Zm-5.13-3.12h2.55c.62,0,1.03.08,1.24.25.25.19.38.49.38.89s-.13.7-.38.89c-.26.19-.66.29-1.21.29h-2.58v-2.33Zm4.05,6.72c-.32.23-.78.35-1.37.35h-2.68v-2.87h2.64c.66,0,1.13.11,1.4.32.3.23.45.61.45,1.12s-.15.87-.45,1.08Zm9.01-6.09c-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.7.1,1.38.29,2.02.19.65.51,1.16.96,1.55.42.38.99.65,1.7.81.71.16,1.42.14,2.12-.05.79-.17,1.43-.61,1.94-1.31.23-.34.42-.75.57-1.24.15-.49.22-1.07.22-1.75,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66Zm-.25,5.99c-.25.38-.55.62-.88.72-.33.1-.65.09-.97-.03-.32-.12-.54-.26-.67-.43-.32-.38-.5-1.06-.54-2.02-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72-.02.85-.16,1.47-.41,1.85Zm8.74-5.99c-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.7.1,1.38.29,2.02.19.65.51,1.16.96,1.55.42.38.99.65,1.7.81.71.16,1.42.14,2.12-.05.79-.17,1.43-.61,1.94-1.31.23-.34.43-.75.57-1.24.15-.49.22-1.07.22-1.75,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66Zm-.25,5.99c-.26.38-.55.62-.88.72-.33.1-.65.09-.97-.03-.32-.12-.54-.26-.67-.43-.32-.38-.5-1.06-.54-2.02-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72-.02.85-.16,1.47-.41,1.85Zm11.17-6.05h-2.68l-2.71,3.12v-4.56c0-.28-.11-.52-.32-.73-.21-.21-.47-.32-.76-.32h-1.15v10.96h2.23v-3.22c0-.17.12-.3.35-.38.23-.08.51.16.83.73l1.56,2.87h2.68l-3.06-5.23,3.03-3.25Zm23.9-.61h5.74v-1.88h-6.82c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v9.81h2.23v-4.84h3.12c.32,0,.59-.11.81-.33.22-.22.33-.49.33-.81v-.73h-4.27v-2.36Zm11.04.67c-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.7.1,1.38.29,2.02.19.65.51,1.16.96,1.55.42.38.99.65,1.7.81.71.16,1.42.14,2.12-.05.79-.17,1.43-.61,1.94-1.31.23-.34.42-.75.57-1.24.15-.49.22-1.07.22-1.75,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66Zm-.26,5.99c-.25.38-.55.62-.88.72-.33.1-.65.09-.97-.03-.32-.12-.54-.26-.67-.43-.32-.38-.5-1.06-.54-2.02-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72-.02.85-.16,1.47-.41,1.85Zm6.28-5.83c-.54.15-1.01.38-1.42.7-.43.34-.76.79-1,1.35-.24.56-.37,1.26-.37,2.09v4.11h2.23v-4.36c0-.64.15-1.1.45-1.4.3-.3.75-.45,1.37-.45h.73v-2.26h-.32c-.57,0-1.13.07-1.67.22Zm6.28-.41c-1.21,0-2.16.39-2.84,1.18-.66.76-.99,1.83-.99,3.19s.34,2.52,1.02,3.28c.68.79,1.62,1.18,2.84,1.18,1,0,1.83-.24,2.48-.73.66-.47,1.1-1.15,1.34-2.04h-1.59c-.26,0-.45.05-.59.16-.14.11-.22.19-.24.26-.06.06-.12.12-.18.18-.05.05-.11.09-.18.11-.25.15-.56.22-.92.22-.55,0-.97-.17-1.24-.51-.3-.32-.46-.81-.48-1.47h5.51s.03-.12.03-.22v-.35c0-1.4-.34-2.5-1.02-3.28-.7-.76-1.69-1.15-2.96-1.15Zm-1.56,3.57c.02-.55.18-.98.48-1.27.3-.3.68-.45,1.15-.45.51,0,.9.15,1.18.45.25.28.4.7.45,1.27h-3.25Zm14.28-4.14h-1.91c-.45,0-.76.19-.96.57l-1.62,2.74-1.47-2.55h-2.45l2.61,4.11-2.77,4.36h2.58l1.56-2.68,1.5,2.68h2.55l-2.8-4.33,3.19-4.91Z"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            className: "cls-6",
            d: "m26.34,3.01h-2.21l4.55,4.55v-2.21c0-1.29-1.05-2.34-2.34-2.34Zm-16.36,2.34v2.21l4.55-4.55h-2.21c-1.29,0-2.34,1.05-2.34,2.34Zm0,14.03c0,1.29,1.05,2.34,2.34,2.34h2.21l-4.54-4.55v2.21Zm16.36,2.34c1.29,0,2.34-1.05,2.34-2.34v-2.21l-4.55,4.55h2.21Z"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            className: "cls-13",
            d: "m10.36,16.36l-2.52-2.54s-1.2-1.37.05-2.97L17.7,1.04s1.19-1.34,3-.21l5.71,5.71-3.52,1.32.52.49-3.59,3.59-1.16-1.08-6.89,6.91-1.4-1.4Z"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            className: "cls-2",
            d: "m15.33,21.33l2.54,2.52s1.37,1.2,2.97-.05l9.81-9.81s1.34-1.19.21-3l-4.38-4.38-1.25,3.36-.55-.49-4.85,4.82-1.1-1.11-5.78,5.77,2.37,2.37Z"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            className: "cls-20",
            d: "m16.46,13.03l2.19-2.19,1.17,1.09,3.59-3.61-.52-.48,3.52-1.32L20.7.83c-.45-.26-.8-.43-1.38-.45-.48-.02-1.07.16-1.54.58L7.89,10.85c-.76.95-.73,2.13-.05,2.97l3.92,3.94,4.7-4.73ZM12.3,3.01c-1.29,0-2.34,1.05-2.34,2.34v2.21l4.55-4.55h-2.21Zm12.93,6.96l-.55-.49-4.85,4.81-1.09-1.11-2.15,2.15-3.63,3.62.34.34c7.47-.8,13.36-5.56,14.28-11.59l-1.09-1.09-1.26,3.36Zm-15.27,9.4s0,0,0,0c.37.02.74.03,1.12.03s.73-.01,1.09-.03l-2.21-2.22v2.21ZM27.35,3.24c-.31-.15-.65-.23-1.02-.23h-2.21l3.57,3.57c0-.18.02-.37.02-.55,0-.96-.13-1.89-.36-2.79Z"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            className: "cls-21",
            d: "m33.19,32.78c-.21,0-.37-.08-.49-.22-.12-.15-.18-.36-.18-.63,0-.3.05-.57.15-.83s.24-.46.42-.61c.18-.15.37-.22.59-.22.14,0,.26.03.37.1.1.07.18.16.24.29h.02l.14-.35h.39l-.52,2.42h-.4l.05-.39h-.01c-.23.29-.49.43-.76.43Zm.19-.42c.12,0,.24-.06.35-.17.11-.11.21-.26.29-.45s.11-.4.11-.62c0-.13-.03-.23-.1-.31-.07-.08-.16-.12-.27-.12-.12,0-.24.06-.35.17s-.2.27-.26.46-.1.39-.1.6c0,.15.03.26.09.33.06.07.14.11.25.11Z"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m87.85,29.87l-.07.3-.42.07c.04.09.06.18.06.3,0,.28-.09.51-.26.67-.17.16-.41.25-.7.25-.08,0-.14,0-.2-.02-.16.06-.24.14-.24.23,0,.06.02.09.07.11.05.02.11.04.2.05l.28.03c.26.03.44.1.55.19.11.1.17.23.17.41,0,.29-.11.51-.33.66-.22.15-.53.23-.94.23-.3,0-.53-.05-.69-.16-.16-.11-.24-.26-.24-.45,0-.15.05-.28.15-.39.1-.11.26-.2.49-.28-.11-.07-.17-.16-.17-.28,0-.1.03-.19.1-.26s.17-.14.32-.21c-.2-.12-.3-.3-.3-.55,0-.29.09-.52.27-.69.18-.17.42-.26.71-.26.12,0,.23.02.35.04h.84Zm-1.79,2.38c-.16.03-.29.08-.38.15-.09.08-.13.17-.13.29,0,.09.04.17.12.23.08.06.21.09.37.09.24,0,.42-.04.56-.12.13-.08.2-.19.2-.34,0-.08-.03-.13-.1-.18s-.18-.07-.35-.09l-.3-.03Zm.59-2.09c-.09,0-.18.03-.25.09-.07.06-.13.13-.17.23s-.06.2-.06.32c0,.1.03.18.08.24.05.06.13.09.22.09s.18-.03.25-.09c.07-.06.12-.14.16-.24.04-.1.06-.21.06-.33,0-.21-.1-.31-.29-.31Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m89.43,29.83c.09,0,.17,0,.24.03l-.11.48c-.08-.02-.15-.03-.22-.03-.18,0-.35.08-.49.25-.14.17-.25.38-.3.65l-.23,1.1h-.52l.52-2.42h.4l-.05.45h.02c.12-.17.24-.3.36-.38.12-.08.25-.12.39-.12Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m91.88,30.78c0,.3-.05.56-.16.81-.11.24-.25.43-.44.56-.19.13-.4.19-.64.19-.28,0-.5-.08-.67-.25-.16-.17-.25-.4-.25-.68s.05-.56.16-.8c.1-.24.25-.43.44-.57s.41-.2.65-.2c.29,0,.51.08.67.25.16.17.24.4.24.69Zm-.52-.02c0-.16-.04-.28-.11-.37s-.17-.13-.31-.13-.26.05-.37.16-.19.25-.25.43c-.06.18-.09.37-.09.57,0,.16.04.29.11.37.07.09.18.13.32.13.13,0,.25-.05.36-.15.11-.1.19-.24.25-.42.06-.18.09-.38.09-.59Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m93.2,29.87l-.28,1.34c-.05.2-.07.35-.07.42,0,.2.09.29.28.29.1,0,.21-.04.31-.12s.2-.2.28-.36c.08-.15.14-.33.19-.54l.22-1.03h.51l-.51,2.42h-.41l.05-.45h-.02c-.12.17-.24.29-.37.37-.13.08-.27.12-.42.12-.2,0-.35-.06-.45-.17-.11-.11-.16-.27-.16-.48,0-.09,0-.18.03-.27.02-.09.03-.18.05-.27l.27-1.28h.52Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m96,32.34c-.26,0-.46-.13-.59-.39h-.02c-.01.14-.03.28-.06.41l-.21,1.01h-.51l.74-3.5h.4l-.05.41h.02c.23-.3.48-.46.75-.46.21,0,.37.08.49.23.12.15.18.36.18.63,0,.3-.05.58-.15.84s-.24.46-.42.6c-.18.14-.37.22-.58.22Zm.29-2.09c-.12,0-.24.06-.35.17s-.21.27-.29.46c-.07.19-.11.39-.11.59,0,.14.03.25.1.33.07.08.16.12.29.12s.24-.06.35-.17c.11-.11.19-.27.26-.46.06-.19.09-.39.09-.6,0-.29-.11-.44-.34-.44Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m99.64,32.34c-.29,0-.51-.08-.67-.23-.16-.15-.24-.37-.24-.66,0-.3.05-.58.16-.83s.26-.44.45-.58c.19-.14.41-.21.66-.21s.46.04.65.13l-.15.4c-.18-.08-.34-.12-.48-.12-.22,0-.4.11-.55.34-.15.22-.22.5-.22.83,0,.16.04.29.12.37.08.09.2.13.34.13.11,0,.21-.02.3-.05.09-.03.19-.07.28-.12v.43c-.2.1-.43.16-.67.16Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m102.99,30.78c0,.3-.05.56-.16.81-.11.24-.25.43-.44.56-.19.13-.4.19-.64.19-.28,0-.5-.08-.67-.25-.16-.17-.25-.4-.25-.68s.05-.56.16-.8c.1-.24.25-.43.44-.57s.41-.2.65-.2c.29,0,.51.08.67.25.16.17.24.4.24.69Zm-.52-.02c0-.16-.04-.28-.11-.37s-.17-.13-.31-.13-.26.05-.37.16-.19.25-.25.43c-.06.18-.09.37-.09.57,0,.16.04.29.11.37.07.09.18.13.32.13.13,0,.25-.05.36-.15.11-.1.19-.24.25-.42.06-.18.09-.38.09-.59Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m104.96,29.83c.32,0,.51.17.56.52h.02c.11-.17.23-.3.37-.38.14-.09.28-.13.43-.13.19,0,.34.06.44.17s.15.27.15.47c0,.09-.02.23-.05.4l-.31,1.43h-.51l.31-1.47c.03-.14.04-.24.04-.29,0-.19-.09-.28-.27-.28-.16,0-.3.09-.44.27-.14.18-.24.42-.3.72l-.22,1.05h-.51l.31-1.47c.03-.12.04-.21.04-.28,0-.2-.09-.3-.26-.3s-.31.09-.45.28-.24.43-.3.74l-.21,1.03h-.52l.52-2.42h.4l-.05.45h.02c.22-.33.47-.49.77-.49Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m108.45,32.34c-.26,0-.46-.13-.59-.39h-.02c-.01.14-.03.28-.06.41l-.21,1.01h-.51l.74-3.5h.4l-.05.41h.02c.23-.3.48-.46.75-.46.21,0,.37.08.49.23.12.15.18.36.18.63,0,.3-.05.58-.15.84s-.24.46-.42.6c-.18.14-.37.22-.58.22Zm.29-2.09c-.12,0-.24.06-.35.17s-.21.27-.29.46c-.07.19-.11.39-.11.59,0,.14.03.25.1.33.07.08.16.12.29.12s.24-.06.35-.17c.11-.11.19-.27.26-.46.06-.19.09-.39.09-.6,0-.29-.11-.44-.34-.44Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m110.69,32.34c-.21,0-.37-.08-.49-.22-.12-.15-.18-.36-.18-.63,0-.3.05-.57.15-.83s.24-.46.42-.61c.18-.15.37-.22.59-.22.14,0,.26.03.37.1.1.07.18.16.24.29h.02l.14-.35h.39l-.52,2.42h-.4l.05-.39h-.01c-.23.29-.49.43-.76.43Zm.19-.42c.12,0,.24-.06.35-.17.11-.11.21-.26.29-.45s.11-.4.11-.62c0-.13-.03-.23-.1-.31-.07-.08-.16-.12-.27-.12-.12,0-.24.06-.35.17s-.2.27-.26.46-.1.39-.1.6c0,.15.03.26.09.33.06.07.14.11.25.11Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m113.95,32.3l.31-1.47c.03-.13.04-.23.04-.29,0-.19-.09-.29-.28-.29-.11,0-.21.04-.31.13s-.19.2-.28.36c-.08.16-.14.33-.18.53l-.21,1.03h-.52l.52-2.42h.4l-.05.45h.02c.12-.17.25-.3.37-.37.13-.08.27-.12.42-.12.2,0,.35.06.45.17.11.11.16.27.16.47,0,.1-.02.23-.05.4l-.3,1.43h-.52Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-21",
              d: "m115.28,29.87h.51l.14,1.16c.01.09.02.22.03.38s.02.3.02.4h.01c.13-.31.22-.54.3-.69l.64-1.26h.56l-1.51,2.8c-.13.24-.27.42-.43.53-.15.11-.34.17-.54.17-.11,0-.22-.01-.31-.04v-.41c.11.02.2.03.27.03.11,0,.21-.03.29-.09s.18-.18.27-.34l.11-.2-.36-2.44Z"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-4",
              d: "m67.43,38.63c.86-.01,1.68-.35,2.28-.95.61-.61.94-1.43.94-2.28v-7.8c0-.86-.34-1.68-.93-2.3-.61-.61-1.43-.95-2.29-.95h-7.85c-.86.01-1.68.35-2.28.95-.61.62-.94,1.44-.94,2.3v7.81c.01,1.77,1.45,3.21,3.22,3.22"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-14",
              d: "m65.2,31.93c-.3,1.01.19,2.02,1.23,1.62-.3.73-.81,1.82-.81,2.95,0,0,0,.76.56.95,0,0,.79.19.62-.51-.12-.44-.16-.89-.1-1.34.19-.93.48-1.84.86-2.72,0,0,1.2-2.5,1.9-3.67,0,0,.29-.59-.3-.59-.18,0-.35.09-.46.24l-1.69,3.02c-.26.47-.51.62-.7.62-.43,0-.34-.68-.27-.93.19-.84.49-1.65.9-2.42.3-.66-.3-.72-.3-.72-.38-.1-.67.53-.67.53l-.67,1.37c-.44.76-.92,1.49-1.44,2.2,0,0-.09.11-.16.07-.07-.06-.03-.17-.03-.17.11-.93.3-1.85.56-2.76.01-.06.02-.1.02-.16.01-.12-.02-.25-.1-.34-.08-.1-.19-.16-.31-.16-.3-.03-.45.11-.72.44-.59.73-1.29,1.83-1.63,2.32-.03.06-.1.04-.1-.03,0-.22.79-2.65.79-2.65,0,0,.09-.34-.18-.45,0,0-.42-.26-.75.25l-1.62,2.2c-.12.17-.19.11-.19.11v-.15l.26-1.44c.2-1.1-.18-1.16-.43-1.2-.18,0-.37.06-.53.16-.51.25-.89,1.25-.89,1.25,0,0-.11.36.13.51.08.04.17.08.26.07.36-.02.43-.68.68-.68.04,0,.04.06.04.07l-.83,3.49c-.06.2.03.42.2.53.11.07.24.08.36.06.11-.03.21-.11.28-.21l.3-.47c.44-.77,1.25-1.89,1.32-1.89.03,0,.04,0,.04.03l-.3,2.05c-.03.18.07.37.24.45.16.06.33.04.47-.03.17-.13.31-.3.42-.49.17-.27.98-1.22,1.47-2.1.03-.06.07,0,.06.03-.1.46-.18,1.68-.19,1.99-.02.59.44.66.45.66.3.02.59-.11.76-.36"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-26",
              d: "m41.05,33.28h-.9v-2.01c.01-.22-.03-.45-.13-.64-.1-.15-.28-.24-.46-.21-.16,0-.3.03-.43.11-.13.09-.25.21-.33.35v2.4h-.9v-3.65h.51l.34.49c.09-.08.18-.15.27-.21.09-.06.18-.1.28-.15.1-.04.2-.08.3-.1.1-.02.21-.03.33-.03.12,0,.25.01.36.04.09.03.18.07.27.12.07.06.13.12.19.19.07.09.11.17.16.26.07-.07.15-.15.24-.21.09-.07.19-.13.3-.19.1-.07.21-.12.34-.17.13-.03.27-.06.42-.06.18,0,.35.04.51.12.15.09.27.2.35.34.09.17.16.34.19.53.04.21.07.43.07.65v2.02h-.91v-2.01c.02-.22-.02-.45-.13-.64-.1-.15-.27-.24-.45-.21-.15,0-.29.03-.43.11-.13.09-.26.2-.34.35"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-26",
              d: "m46.23,31.62h-.8c-.17-.01-.33.03-.47.12-.09.09-.15.21-.15.35,0,.12.04.24.13.33.1.08.24.12.37.11.1,0,.2-.01.3-.04.09-.02.18-.06.26-.1.08-.06.15-.11.2-.17.07-.07.11-.13.16-.2m-.01.86c-.12.12-.28.22-.44.29-.21.08-.44.12-.66.11-.16.01-.33-.02-.47-.08-.13-.06-.26-.13-.37-.24-.1-.11-.18-.24-.24-.37-.06-.15-.08-.3-.08-.46,0-.67.53-1.11,1.37-1.11h.9v-.2c0-.13-.08-.25-.19-.3-.18-.08-.38-.12-.58-.11-.22,0-.45.03-.66.08-.17.04-.34.1-.51.17l-.1-.75c.06-.03.13-.06.24-.09.09-.03.2-.06.3-.09.1-.02.24-.04.37-.07.13-.02.28-.02.43-.02.42-.03.84.1,1.16.37.28.29.42.68.39,1.08v2.2h-.64l-.21-.4Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
              className: "cls-26",
              points: "51.3 29.58 49.85 31.4 51.5 33.27 50.37 33.27 48.85 31.42 48.85 33.27 47.96 33.27 47.96 28.28 48.85 28.28 48.85 31.42 50.21 29.58 51.3 29.58"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-26",
              d: "m53.28,30.44c-.11,0-.22.01-.33.04-.09.02-.18.07-.25.12-.08.04-.13.11-.18.19-.04.08-.08.16-.1.25h1.58c0-.08-.01-.16-.04-.24-.02-.07-.08-.13-.13-.19-.07-.06-.15-.1-.22-.13-.11-.03-.22-.06-.33-.04m.17,2.05c.13,0,.28-.01.42-.04.12-.02.25-.06.36-.1.1-.03.2-.08.29-.13.04-.02.09-.06.13-.09l.17.8c-.19.1-.39.19-.61.26-.25.07-.51.1-.76.1-.28,0-.56-.04-.83-.13-.21-.08-.43-.2-.59-.37-.17-.16-.29-.36-.37-.57-.1-.22-.15-.47-.16-.73,0-.24.03-.47.11-.7.08-.22.19-.42.35-.59.15-.17.34-.3.55-.39.48-.19,1.03-.19,1.52,0,.2.08.37.21.52.37.13.16.24.34.3.53.06.2.09.42.09.63v.19c-.01.07-.02.13-.03.19h-2.48c.01.12.04.24.1.34.04.1.12.19.21.26.09.08.19.13.31.16.12.04.26.07.4.07v-.02h0Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-26",
              d: "m71.52,30.15l1.19-1.44h.27v.91h1.02v.79h-1.02v1.5c0,.08.01.17.03.26.02.06.06.11.1.17.04.03.1.07.16.08.06.02.11.03.18.03.1,0,.2-.01.29-.04.09-.01.17-.04.25-.08v.8c-.09.04-.19.08-.3.1-.31.07-.64.06-.94-.03-.15-.04-.27-.12-.38-.22-.09-.1-.17-.22-.21-.36-.04-.15-.08-.31-.07-.47v-1.71h-.58"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-26",
              d: "m75.53,30.39c.13-.22.3-.42.52-.56.18-.13.4-.2.64-.19.07-.01.13-.01.2,0l.12.02s-.02.2-.16.83c-.07-.01-.13-.02-.2-.01-.16-.01-.3.02-.45.08-.13.06-.25.15-.34.26-.09.11-.17.25-.21.39-.04.18-.07.36-.07.54v1.54h-.9v-3.65h.56"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-26",
              d: "m81.04,30.43c-.1-.01-.2.01-.29.04-.09.03-.17.08-.25.13-.07.04-.12.11-.18.18-.04.07-.09.13-.11.21v1.03c.03.07.08.12.13.18.06.06.11.1.18.15.08.04.16.08.24.1.22.06.46.04.67-.03.1-.06.2-.12.27-.21.08-.09.13-.2.17-.31.03-.13.06-.28.07-.43,0-.13-.02-.28-.07-.43-.03-.12-.09-.24-.17-.34-.08-.09-.17-.17-.28-.21-.11-.06-.22-.08-.35-.08m.21-.79c.25-.01.48.04.7.15.19.1.35.24.48.42.12.18.22.38.28.59.06.22.09.46.09.68,0,.24-.03.47-.1.7-.06.21-.16.4-.29.57-.13.17-.29.3-.48.39-.2.1-.44.15-.66.15s-.44-.03-.64-.11c-.17-.08-.33-.18-.45-.33v1.9h-.9v-5.11h.53l.35.44c.13-.13.3-.25.49-.34.19-.07.39-.11.6-.1h.01Z"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
              className: "cls-26",
              d: "m77.93,28.14c-.26,0-.46.2-.46.46s.2.47.46.47.46-.21.46-.47c.01-.12-.04-.24-.13-.33-.08-.09-.2-.15-.33-.15m.44,5.15h-.9v-3.65h.9v3.65Z"
            })]
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BMFLogo);

/***/ }),

/***/ 2534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ CurrencyCityTemplate; },
  "h": function() { return /* reexport */ CurrencyCityTemplateOld; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/index.tsx + 5 modules
var CurrencySEOCommonUI = __webpack_require__(4326);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/BMFLogo/index.tsx
var BMFLogo = __webpack_require__(2684);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOMarkdown/index.tsx + 1 modules
var CurrencySEOMarkdown = __webpack_require__(2558);
// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 137 modules
var react_markdown = __webpack_require__(843);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyCityTemplate/CityFooter.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CityFooter = function CityFooter(_ref) {
  var _footer$section_foote, _footer$section_foote2, _footer$section_foote3, _footer$bottom_footer;

  var footer = _ref.footer,
      city = _ref.city;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [footer !== null && footer !== void 0 && (_footer$section_foote = footer.section_footer) !== null && _footer$section_foote !== void 0 && (_footer$section_foote2 = _footer$section_foote[0]) !== null && _footer$section_foote2 !== void 0 && _footer$section_foote2.links ? footer === null || footer === void 0 ? void 0 : (_footer$section_foote3 = footer.section_footer) === null || _footer$section_foote3 === void 0 ? void 0 : _footer$section_foote3.map(function (section) {
      var _section$links;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        className: "reviewedCurrencies",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "container",
          children: section === null || section === void 0 ? void 0 : section.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: section === null || section === void 0 ? void 0 : (_section$links = section.links) === null || _section$links === void 0 ? void 0 : _section$links.map(function (col) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: "footerLinkCol",
              children: col === null || col === void 0 ? void 0 : col.map(function (link) {
                var title = link.title,
                    href = link.href,
                    target = link.target;
                var linkProps = {
                  href: href,
                  target: target
                };
                if (title == "Currency Exchange in ".concat(city)) return null;
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: "footerLink",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", _objectSpread(_objectSpread({}, linkProps), {}, {
                    children: title
                  }))
                }, title);
              })
            });
          })
        })]
      });
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: footer === null || footer === void 0 ? void 0 : (_footer$bottom_footer = footer.bottom_footer) === null || _footer$bottom_footer === void 0 ? void 0 : _footer$bottom_footer.map(function (col) {
          var _col$list;

          return col.title ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "item",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
              className: "linkTitle",
              children: col === null || col === void 0 ? void 0 : col.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: col === null || col === void 0 ? void 0 : (_col$list = col.list) === null || _col$list === void 0 ? void 0 : _col$list.map(function (link) {
                var title = link.title,
                    href = link.href,
                    target = link.target;
                var linkProps = {
                  href: href,
                  target: target
                };
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", _objectSpread(_objectSpread({}, linkProps), {}, {
                    children: title
                  }))
                }, title);
              })
            })]
          }, col === null || col === void 0 ? void 0 : col.title) : null;
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyCityTemplate/CityDocumet.tsx




var CityDocumet = function CityDocumet(_ref) {
  var _cityData$hero_img, _cityData$hero_img2;

  var cityData = _ref.cityData,
      url = _ref.url;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      httpEquiv: "Content-Type",
      content: "text/html; charset=UTF-8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      httpEquiv: "X-UA-Compatible",
      content: "IE=edge"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: cityData === null || cityData === void 0 ? void 0 : cityData.Meta_desc
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), cityData !== null && cityData !== void 0 && cityData.allow_indexing ? null : /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: "none"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: (cityData === null || cityData === void 0 ? void 0 : cityData.Primary_keyword) + ", " + (cityData === null || cityData === void 0 ? void 0 : cityData.Secondary_keywords)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjx4wXiWtFCc.woff2",
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: "https://www.makemytrip.com".concat(url)
    }), cityData !== null && cityData !== void 0 && (_cityData$hero_img = cityData.hero_img) !== null && _cityData$hero_img !== void 0 && _cityData$hero_img.src ? /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: (_cityData$hero_img2 = cityData.hero_img) === null || _cityData$hero_img2 === void 0 ? void 0 : _cityData$hero_img2.src
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: cityData === null || cityData === void 0 ? void 0 : cityData.Meta_title
    })]
  });
};

/* harmony default export */ var CurrencyCityTemplate_CityDocumet = (CityDocumet);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRootPageTemplate/CurrencyConverter.tsx
var CurrencyConverter = __webpack_require__(9235);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/HeroV2.tsx
var HeroV2 = __webpack_require__(4760);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/HeroWebV2.tsx
var HeroWebV2 = __webpack_require__(1594);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Faqs.tsx + 1 modules
var Faqs = __webpack_require__(9116);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/ForexProducts.tsx + 1 modules
var ForexProducts = __webpack_require__(922);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(4709);
// EXTERNAL MODULE: ../../node_modules/@forex/listing-ui/index.cjs.js
var index_cjs = __webpack_require__(5348);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyCityTemplate/CurrencyCityTemplate.styles.ts


var _templateObject;


var CurrencyCityStyle = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n\n/* Background color classes */\n.bg-light-grey {\n  background-color: #F2F2F2;\n  padding: 0px;\n}\n\n/* Desktop styles for lg deviceType */\n", "\n"])), function (props) {
  return props.deviceType === "lg" ? "\n    @media (min-width: 1024px) {\n      /* Top banner section styling for lg deviceType */\n      #top-banner {\n          background: url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/bg6.jpg) !important;\n          background-repeat: no-repeat !important;\n          padding-bottom: 40px !important;\n          min-height: auto !important;\n          padding: 0 !important;\n          margin: 0 !important;\n      }\n\n      /* Top banner container styles */\n      .top-banner__container {\n          margin: 0 auto !important;\n          padding-top: 32px !important;\n          max-width: 1200px !important;\n      }\n\n      .top-banner__wrapper {\n          padding-bottom: 40px;\n          padding-top: 16px;\n      }\n\n      .top-banner__title {\n          font-size: 36px !important;\n          line-height: 43.2px !important; /* 1.2em of 36px */\n          font-weight: 900 !important;\n          color: #FFFFFF !important;\n          margin: 0 !important;\n      }\n\n      .top-banner__description {\n          color: white;\n          margin-top: 8px;\n          font-weight: 700;\n          line-height: 24px;\n          margin-bottom: 0;\n          font-size: 16px;\n      }\n\n      .top-banner__breadcrumb {\n          margin-top: 16px !important;\n      }\n\n      /* Header styling for lg deviceType */\n      header {\n          position: sticky !important;\n          top: 0 !important;\n          z-index: 10 !important;\n          background-color: #fff !important;\n          padding: 18px 0 !important;\n      }\n\n      /* Remove negative margins for lg deviceType */\n      .container.negativeMargin {\n          margin-top: 0 !important;\n      }\n\n      .pageContainer.pageContainer_margin {\n          margin-top: 0 !important;\n      }\n\n      /* Section wrapper styling for lg deviceType */\n      .sectionWrapper {\n          background-color: #fff;\n          border-radius: 16px;\n          padding: 32px 24px;\n          margin-bottom: 48px;\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n      }\n      \n      .sectionWrapper:last-child {\n          margin-bottom: 0;\n      }\n\n      /* Typography improvements for lg deviceType */\n      .tripMoneySection h2 {\n          font-size: 22px !important;\n          line-height: 26.4px !important;\n          font-weight: 900 !important;\n          color: #000 !important;\n          margin-bottom: 16px !important;\n      }\n\n      .tripMoneySection h3 {\n          font-size: 18px !important;\n          line-height: 21.6px !important;\n          font-weight: 700 !important;\n          color: #000 !important;\n          margin-bottom: 12px !important;\n      }\n\n      .tripMoneySection p,\n      .tripMoneySection .description {\n          font-size: 16px !important;\n          line-height: 19.2px !important;\n          font-weight: 400 !important;\n          color: #4A4A4A !important;\n      }\n\n      .container {\n        max-width: 1200px;\n        width: 1200px !important;\n        margin: 0 auto;\n        padding: 24px 0px;\n      }\n\n      /* Container card improvements */\n      .container__card {\n          background-color: #fff;\n          border-radius: 8px;\n          padding: 0px;\n          box-shadow: none;\n          margin-bottom: 16px;\n      }\n\n      .tripmoneyImgWrap::after {\n          content: '';\n          position: absolute;\n          top: -100px;\n          right: -33px;\n          width: 1px;\n          height: 235px;\n          background: none !important;\n          border: 1px dashed #d5d5d5;      \n      }\n\n      .container__card.container__cardAlign {\n          border: 1px solid #D8D8D8 !important;\n          border-radius: 8px !important;\n          padding: 16px 8px !important;\n      }\n\n      /* Hide separators on desktop by default */\n      .separator {\n          display: none !important;\n      }\n\n      .sectionWrapper .separator {\n          display: none !important;\n      }\n\n      /* Hide containerImg for lg deviceType */\n      .containerImg {\n          display: none !important;\n      }\n\n      /* FAQ section styles for lg deviceType */\n      .faqList {\n          margin-top: 16px !important;\n      }\n\n      .faqList li h4.question {\n          font-size: 16px !important;\n          line-height: 16px !important;\n          padding: 12px 0px !important;\n          font-weight: 400 !important;\n      }\n\n      .faqList li h4.question::after {\n          top: 12px !important;\n      }\n\n      .faqList li:hover {\n          box-shadow: none !important;\n          border-color: transparent !important;\n          background-color: transparent !important;\n      }\n\n      .faqList li:hover h4.question {\n          background-color: transparent !important;\n          box-shadow: none !important;\n          border-radius: none !important;\n      }\n\n      .faqList li div.answer {\n          font-size: 14px !important;\n          margin-bottom: 16px !important;\n      }\n\n      /* Currency Converter styling for lg deviceType */\n      .sectionWrapper .h2 {\n          font-size: 22px !important;\n          line-height: 26.4px !important;\n          font-weight: 900 !important;\n          color: #000 !important;\n          margin-bottom: 24px !important;\n      }\n\n      .sectionWrapper .capSulesList {\n          display: grid !important;\n          grid-template-columns: repeat(4, 1fr) !important;\n          gap: 16px !important;\n          margin-bottom: 24px !important;\n          list-style: none !important;\n          padding: 0 !important;\n      }\n\n      .sectionWrapper .capSulesList li {\n          box-shadow: none !important;\n      }\n\n      .sectionWrapper .capSulesList.grid5 {\n          grid-template-columns: repeat(4, 1fr) !important;\n      }\n\n      .sectionWrapper .capsule {\n          background-color: #F0F0F0 !important;\n          border-radius: 5px !important;\n          padding: 12px 16px !important;\n          text-align: center !important;\n          min-height: 40px !important;\n          display: flex !important;\n          align-items: center !important;\n          justify-content: center !important;\n          border: 1px solid #E0E0E0 !important;\n      }\n\n      .sectionWrapper .capSulesList:not(.showAll) .capsule:nth-child(n+5) {\n          display: none !important;\n      }\n\n      .sectionWrapper .capSulesList.grid5:not(.showAll) .capsule:nth-child(n+5) {\n          display: none !important;\n      }\n\n      .sectionWrapper .capsule a {\n          color: #008CFF!important;\n          text-decoration: none !important;\n          font-size: 14px !important;\n          font-weight: 900 !important;\n          line-height: 16.8px !important;\n          display: block !important;\n          width: 100% !important;\n          white-space: nowrap !important;\n          overflow: hidden !important;\n          text-overflow: ellipsis !important;\n      }\n\n      .sectionWrapper .viewMore {\n          text-align: left !important;\n          margin-top: 24px !important;\n          margin-bottom: 0 !important;\n      }\n\n      .sectionWrapper .viewMore__cta {\n          color: #008CFF !important;\n          text-decoration: none !important;\n          font-size: 16px !important;\n          font-weight: 700 !important;\n          cursor: pointer !important;\n          padding: 8px 16px !important;\n          border-radius: 6px !important;\n          transition: all 0.2s ease !important;\n          display: inline-block !important;\n          background-color: transparent !important;\n          border: none !important;\n      }\n\n      /* Exchange Rate Wrap section styling for lg deviceType */\n      .exchangeRateWrap {\n          display: flex !important;\n          gap: 24px !important;\n          align-items: flex-start !important;\n      }\n\n      .exchangeRateWrap .container__card.flexOne {\n          flex: 1 1 50% !important;\n          max-width: 50% !important;\n          margin-right: 0 !important;\n      }\n\n      .exchangeRateWrap .flexOne.makeFlex.column {\n          flex: 1 1 50% !important;\n          max-width: 50% !important;\n          display: flex !important;\n          flex-direction: column !important;\n          gap: 24px !important;\n      }\n\n      .exchangeRateWrap .flexOne.makeFlex.column .container__card {\n          margin-bottom: 0 !important;\n      }\n\n      /* Identification/Fake Currency section styling */\n      .identification-wrapper {\n          background-color: #fff;\n          border-radius: 16px;\n          padding: 32px 24px;\n          margin-bottom: 24px;\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n      }\n\n      .identification-section .tripMoneySection.makeFlex {\n          display: flex !important;\n          gap: 32px !important;\n          align-items: flex-start !important;\n          justify-content: space-between !important;\n      }\n\n      .identification-section .tripMoneySection.makeFlex > div:first-child {\n        //   flex: 1 1 auto !important;\n        //   max-width: calc(100% - 320px) !important;\n        //   padding-right: 16px !important;\n      }\n\n      .identification-section .tripMoneySection.makeFlex > div:last-child {\n        //   flex: 0 0 auto !important;\n        //   width: 280px !important;\n      }\n\n      .identification-section .counterFietImgWrapMweb {\n          display: none !important;\n      }\n\n      .identification-section ul {\n          max-width: 100% !important;\n          margin: 0 !important;\n          padding: 0 !important;\n          list-style: none !important;\n      }\n\n      .identification-section ul li {\n          font-size: 16px !important;\n          line-height: 24px !important;\n          font-weight: 400 !important;\n          color: #333333 !important;\n          margin-bottom: 12px !important;\n          padding-bottom: 0 !important;\n          border-bottom: none !important;\n      }\n\n      .identification-section ul li:last-child {\n          margin-bottom: 0 !important;\n      }\n\n      .identification-section ul li.makeFlex {\n          display: flex !important;\n          align-items: flex-start !important;\n          gap: 12px !important;\n      }\n\n      .identification-section ul li span {\n          flex: 1 !important;\n          font-size: 16px !important;\n          line-height: 24px !important;\n          font-weight: 400 !important;\n          color: #333333 !important;\n      }\n\n      .identification-section .greenCheckImg {\n          width: 16px !important;\n          height: 16px !important;\n          margin-right: 0 !important;\n          flex-shrink: 0 !important;\n      }\n\n      .identification-section .counterFietImgWrap {\n          display: flex !important;\n          align-items: flex-start !important;\n          justify-content: center !important;\n          height: auto;\n          width: 220px !important;\n      }\n\n      .identification-section .counterFietImgWrap img {\n          max-width: 100% !important;\n          height: auto !important;\n          object-fit: contain !important;\n          border-radius: 8px !important;\n      }\n\n      /* Product Range List styling */\n      .productRangeList li {\n          border-bottom: none !important;\n          padding: 8px 0 !important;\n          font-size: 14px !important;\n          line-height: 20px !important;\n          color: #333333 !important;\n      }\n\n      /* Step count styling */\n      .tripMoneySection__bestRateBuy li {\n          width: auto !important;\n          margin-bottom: 16px !important;\n          background-size: 370px 94px;\n      }\n\n      /* Document list styling */\n      .documentList li {\n          display: flex !important;\n          align-items: flex-start !important;\n          gap: 12px !important;\n          margin-bottom: 12px !important;\n          font-size: 14px !important;\n          line-height: 20px !important;\n          color: #333333 !important;\n      }\n\n      .documentList .greenCheckImg {\n          width: 16px !important;\n          height: 16px !important;\n          flex-shrink: 0 !important;\n      }\n\n      /* Remove padding-bottom and border-bottom from tripMoneySection for lg deviceType */\n      .tripMoneySection {\n          padding-bottom: 0 !important;\n          border-bottom: none !important;\n      }\n\n      /* Add position relative for list items with rectangular icons for lg deviceType */\n      .tripMoneySection li.makeFlex.appendBottom15 {\n          position: relative !important;\n          padding: 0px 0px 9px 25px !important;\n      }\n\n      /* Add rectangular icon before list items as per Figma design for lg deviceType */\n      .tripMoneySection li.makeFlex.appendBottom15::before {\n        content: \"\";\n        width: 7px;\n        height: 15px;\n        border-radius: 4px;\n        background-image: linear-gradient(to bottom, #16477F, #16477F) !important;\n        position: absolute;\n        left: 0;\n        top: 3px;\n      }\n\n      /* Hide green check images for lg deviceType to match Figma design */\n      .tripMoneySection .greenCheckImg {\n          display: none !important;\n      }\n\n      /* Add position relative and padding for productRangeList items for lg deviceType */\n      .productRangeList li {\n          position: relative !important;\n          padding: 0px 0px 9px 25px !important;\n          list-style: none !important;\n      }\n\n      /* Add rectangular icon before productRangeList items as per Figma design for lg deviceType */\n      .productRangeList li::before {\n          content: \"\";\n          width: 7px;\n          height: 15px;\n          border-radius: 4px;\n          background-image: linear-gradient(to bottom, #16477F, #16477F) !important;\n          position: absolute;\n          left: 0;\n          top: 3px;\n      }\n\n      /* Remove default list styling for productRangeList for lg deviceType */\n      .productRangeList {\n          padding-left: 0 !important;\n      }\n\n      /* Add margin-bottom to sections wrapper for lg deviceType */\n      .sections-wrapper-lg {\n          padding-bottom: 80px !important;\n          background-color: #F2F2F2 !important;\n      }\n\n      /* Hide the default ::after bullet points for productRangeList for lg deviceType */\n      .productRangeList li::after {\n          display: none !important;\n      }\n    }\n  " : "";
});
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(7510);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyCityTemplate/CurrencyCityTemplate.tsx


function CurrencyCityTemplate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CurrencyCityTemplate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CurrencyCityTemplate_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CurrencyCityTemplate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















 // Wrapper component to handle deviceType logic





var SectionWrapper = function SectionWrapper(_ref) {
  var children = _ref.children,
      deviceType = _ref.deviceType;

  if (deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "sectionWrapper",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: children
  });
};

var CurrencyCityTemplate = function CurrencyCityTemplate(_ref2) {
  var _cityData$header, _cityData$All_Major_a, _cityData$All_Other_a, _cityData$All_Famous_, _cityData$All_Other_p, _cityData$All_Towns_a, _cityData$All_Other_c, _cityData$All_Nearest, _cityData$All_Carry_c, _cityData$All_Exchang, _cityData$All_Purpose;

  var cityData = _ref2.cityData,
      isMmtHost = _ref2.isMmtHost,
      templateType = _ref2.templateType,
      url = _ref2.url,
      deviceType = _ref2.deviceType,
      page_name = _ref2.page_name;

  var _useState = (0,react.useState)(false),
      scrolled = _useState[0],
      setScrolled = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showViewMore = _useState2[0],
      setShowViewMore = _useState2[1];

  var _useState3 = (0,react.useState)(4),
      cardsToBeShown = _useState3[0],
      setCardsToBeShown = _useState3[1];

  var isBot = (0,hooks/* useBotDetection */.Um)();
  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      if (window.scrollY > 60) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    (0,analytics/* trackSeoPageLoad */.XE)({
      pageName: analytics/* PAGE_NAMES */.a3["SEO_CURRENCY_EXCHANGE_".concat(templateType)],
      city: cityData === null || cityData === void 0 ? void 0 : cityData.City
    });
    window.addEventListener("scroll", handleScroll);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  var _ref3 = cityData || {},
      btn_link = _ref3.hero_btn_link,
      btn_text = _ref3.hero_btn_text,
      img_link = _ref3.hero_img_link,
      desc = _ref3.hero_desc,
      title = _ref3.hero_title,
      list = _ref3.hero_list,
      forex_sol = _ref3.hero_img,
      forex_sol_mobile = _ref3.hero_img_mobile;

  var heroProps = {
    btn_link: btn_link,
    btn_text: btn_text,
    img_link: img_link,
    desc: desc,
    title: title,
    list: list,
    forex_sol: forex_sol,
    forex_sol_mobile: forex_sol_mobile,
    green_check: cityData === null || cityData === void 0 ? void 0 : cityData.green_check
  };

  var handleOnClick = function handleOnClick() {
    setShowViewMore(false);
    setCardsToBeShown(14);
  }; // Define heading1 for top banner title


  var heading1 = cityData !== null && cityData !== void 0 && cityData.City ? "Currency Exchange in ".concat(cityData.City) : "";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* FontStyles */.B2, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* BaseStyles */.xR, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* TripMoneyStyles */.KL, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyCityStyle, {
      deviceType: deviceType
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyCityTemplate_CityDocumet, {
      cityData: cityData,
      url: url
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "header__inner",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: cityData === null || cityData === void 0 ? void 0 : (_cityData$header = cityData.header) === null || _cityData$header === void 0 ? void 0 : _cityData$header.image_link,
            children: isMmtHost ? /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* MMTLogo */.X, {
              isLight: false
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(BMFLogo/* default */.Z, {
              isLight: scrolled ? false : true
            })
          })
        })
      }), deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "topBlueSection"
      }), deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroWebV2/* HeroWebV2 */.F, {
        title: title,
        desc: desc,
        breadcrumb: (cityData === null || cityData === void 0 ? void 0 : cityData.breadcrumb) || [],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_cjs/* ListingUiWrapper */.ev, {
          source_type: "seo",
          isBot: isBot,
          deviceType: deviceType,
          page_name: page_name
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "sections-wrapper ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "sections-wrapper-lg" : ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "greySection ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "bg-light-grey" : ""),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container negativeMargin",
            children: [deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroV2/* HeroV2 */.n, CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({}, heroProps), {}, {
              breadcrumb: cityData === null || cityData === void 0 ? void 0 : cityData.breadcrumb
            })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "pageContainer pageContainer_margin sectionGapping",
              children: deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(ForexProducts/* default */.Z, {
                currencyData: cityData,
                pageName: analytics/* PAGE_NAMES */.a3["SEO_CURRENCY_EXCHANGE_".concat(templateType)]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
              className: "tripMoneySection makeFlex hrtlCenter",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "bannerText",
                children: cityData === null || cityData === void 0 ? void 0 : cityData.Page_title
              })
            }), (cityData === null || cityData === void 0 ? void 0 : cityData.Description_desc) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
                className: "tripMoneySection",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: "appendBottom20",
                  children: cityData !== null && cityData !== void 0 && cityData.Description_title ? cityData === null || cityData === void 0 ? void 0 : cityData.Description_title : ""
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Description_desc
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Description_desc_addendum
                })]
              })
            })]
          })
        }), (cityData === null || cityData === void 0 ? void 0 : cityData.All_Fake_currencies_way_) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "bg-light-grey" : "whiteSection"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "identification-section",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
                  className: "tripMoneySection makeFlex",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                      className: "appendBottom30",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Fake_currencies_title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "counterFietImgWrapMweb",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({}, cityData === null || cityData === void 0 ? void 0 : cityData.fake_currency_mobile_logo), {}, {
                        loading: "lazy"
                      }))
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      className: "appendBottom20",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Fake_currencies_desc
                    }), (cityData === null || cityData === void 0 ? void 0 : cityData.All_Fake_currencies_way_) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.All_Fake_currencies_way_.map(function (way, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "makeFlex ".concat(index < (cityData === null || cityData === void 0 ? void 0 : cityData.All_Fake_currencies_way_.length) - 1 && deviceType !== utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "dashedBorder" : ""),
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                            className: "greenCheckImg"
                          }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                            loading: "eager"
                          })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                              children: way
                            })
                          })]
                        }, way);
                      })
                    })]
                  }), (cityData === null || cityData === void 0 ? void 0 : cityData.fake_currency_logo) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "counterFietImgWrap",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({}, cityData === null || cityData === void 0 ? void 0 : cityData.fake_currency_logo), {}, {
                      loading: "lazy"
                    }))
                  })]
                })
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "greySection ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "bg-light-grey" : ""),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
                className: "tripMoneySection",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "container__card",
                  children: [cityData !== null && cityData !== void 0 && cityData.All_Major_areas_ && cityData !== null && cityData !== void 0 && cityData.All_Other_areas_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "appendBottom18",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Major_areas_title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      className: "appendBottom10",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Major_areas_desc
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Major_a = cityData.All_Major_areas_) === null || _cityData$All_Major_a === void 0 ? void 0 : _cityData$All_Major_a.map(function (area, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "makeFlex appendBottom15",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                            className: "greenCheckImg"
                          }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                            loading: "eager"
                          })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                              children: area
                            })
                          })]
                        }, area);
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "dashedBorder"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "appendBottom18",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Other_areas_title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Other_a = cityData.All_Other_areas_) === null || _cityData$All_Other_a === void 0 ? void 0 : _cityData$All_Other_a.map(function (area, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "makeFlex appendBottom15",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                            className: "greenCheckImg"
                          }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                            loading: "eager"
                          })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                              children: area
                            })
                          })]
                        }, area);
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "dashedBorder"
                    })]
                  }, "Major areas") : null, cityData !== null && cityData !== void 0 && cityData.All_Famous_place_ && cityData !== null && cityData !== void 0 && cityData.All_Other_place_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "appendBottom18",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Famous_place_title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      className: "appendBottom10",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Famous_place_desc
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Famous_ = cityData.All_Famous_place_) === null || _cityData$All_Famous_ === void 0 ? void 0 : _cityData$All_Famous_.map(function (place, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "makeFlex appendBottom15",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                            className: "greenCheckImg"
                          }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                            loading: "eager"
                          })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                              children: place
                            })
                          })]
                        }, place);
                      })
                    }), cityData !== null && cityData !== void 0 && cityData.All_Other_place_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "dashedBorder"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                        className: "appendBottom18",
                        children: cityData === null || cityData === void 0 ? void 0 : cityData.Other_place_title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                        children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Other_p = cityData.All_Other_place_) === null || _cityData$All_Other_p === void 0 ? void 0 : _cityData$All_Other_p.map(function (place) {
                          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                            className: "makeFlex appendBottom15",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                              className: "greenCheckImg"
                            }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                              loading: "eager"
                            })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                                children: place
                              })
                            })]
                          }, place);
                        })
                      })]
                    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
                  }, "Famous places") : null]
                })
              })
            }), (cityData === null || cityData === void 0 ? void 0 : cityData.All_Towns_and_cities_) && (cityData === null || cityData === void 0 ? void 0 : cityData.All_Other_cities_) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
                className: "tripMoneySection",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "container__card appendBottom80",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                    className: "containerImg"
                  }, cityData === null || cityData === void 0 ? void 0 : cityData.towns_cities_img), {}, {
                    loading: "lazy"
                  })), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: "appendBottom30",
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Towns_and_cities_title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                    className: "productRangeList",
                    children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Towns_a = cityData.All_Towns_and_cities_) === null || _cityData$All_Towns_a === void 0 ? void 0 : _cityData$All_Towns_a.map(function (city) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                          children: city
                        })
                      }, city);
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "dashedBorder"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: "appendBottom18",
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Other_cities_title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                    children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Other_c = cityData.All_Other_cities_) === null || _cityData$All_Other_c === void 0 ? void 0 : _cityData$All_Other_c.map(function (city) {
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        className: "makeFlex appendBottom15",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                          className: "greenCheckImg"
                        }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                          loading: "eager"
                        })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                            children: city
                          })
                        })]
                      }, city);
                    })
                  })]
                })
              })
            }), (cityData === null || cityData === void 0 ? void 0 : cityData.All_Nearest_airports_) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
                className: "tripMoneySection",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: "appendBottom20",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Nearest_airports_title
                }), cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Nearest = cityData.All_Nearest_airports_) === null || _cityData$All_Nearest === void 0 ? void 0 : _cityData$All_Nearest.map(function (airport) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                    children: airport
                  });
                })]
              })
            }), (cityData === null || cityData === void 0 ? void 0 : cityData.All_Carry_currency_way_) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
                className: "tripMoneySection",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: "appendBottom20",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Carry_currency_title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                  className: "appendBottom24",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Carry_currency_desc
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "container__card container__cardAlign",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "tripmoneyImgWrap",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplate_objectSpread(CurrencyCityTemplate_objectSpread({
                      className: "tripMoneyImg"
                    }, cityData === null || cityData === void 0 ? void 0 : cityData.best_ways_cary_logo), {}, {
                      loading: "lazy"
                    }))
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Carry_c = cityData.All_Carry_currency_way_) === null || _cityData$All_Carry_c === void 0 ? void 0 : _cityData$All_Carry_c.map(function (way) {
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                          className: "blackText appendBottom10",
                          children: way
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "dashedBorder"
                        })]
                      }, way);
                    })
                  })]
                })]
              })
            }), (cityData === null || cityData === void 0 ? void 0 : cityData.All_Exchange_currency_steps_) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
                className: "tripMoneySection",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: "appendBottom20",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Exchange_currency_title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                  className: "appendBottom24",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Exchange_currency_desc
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "tripMoneySection__bestRateBuy",
                  children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Exchang = cityData.All_Exchange_currency_steps_) === null || _cityData$All_Exchang === void 0 ? void 0 : _cityData$All_Exchang.map(function (step, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: "stepCount",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "font16",
                          children: "STEP"
                        }), " ", index + 1 < 9 ? (index + 1).toString().padStart(2, "0") : index + 1]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: step
                      })]
                    }, step);
                  })
                }), cityData !== null && cityData !== void 0 && cityData.Buy_sell_local_title ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "container__card",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: "appendBottom20",
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_local_title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                    className: "appendBottom20",
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_local_desc
                  })]
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
              })
            }), (cityData === null || cityData === void 0 ? void 0 : cityData.All_Purpose_) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
                className: "tripMoneySection",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "exchangeRateWrap appendBottom35",
                  children: [cityData !== null && cityData !== void 0 && cityData.All_Purpose_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "container__card flexOne",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                      className: "appendBottom22",
                      children: cityData === null || cityData === void 0 ? void 0 : cityData.Purpose_for_exchanging_title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      className: "productRangeList",
                      children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Purpose = cityData.All_Purpose_) === null || _cityData$All_Purpose === void 0 ? void 0 : _cityData$All_Purpose.map(function (purpose) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                          className: "dashedBorder",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                            children: purpose
                          })
                        }, purpose);
                      })
                    })]
                  }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flexOne makeFlex column",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "container__card appendBottom30",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                        className: "appendBottom22",
                        children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_online_title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_online_desc
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "container__card",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                        className: "appendBottom22",
                        children: cityData === null || cityData === void 0 ? void 0 : cityData.Home_delivery_title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: cityData === null || cityData === void 0 ? void 0 : cityData.Home_delivery_desc
                      })]
                    })]
                  })]
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverter/* default */.Z, {
                currConversion: cityData === null || cityData === void 0 ? void 0 : cityData.currency_conversions
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                currencyData: cityData
              })
            })]
          })
        })]
      }), cityData !== null && cityData !== void 0 && cityData.footer ? /*#__PURE__*/(0,jsx_runtime.jsx)(CityFooter, {
        footer: cityData === null || cityData === void 0 ? void 0 : cityData.footer,
        city: cityData === null || cityData === void 0 ? void 0 : cityData.City
      }) : null]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyCityTemplate/CurrencyCityTemplateOld.tsx


function CurrencyCityTemplateOld_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CurrencyCityTemplateOld_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CurrencyCityTemplateOld_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CurrencyCityTemplateOld_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var CurrencyCityTemplateOld = function CurrencyCityTemplateOld(_ref) {
  var _cityData$header, _cityData$All_Major_a, _cityData$All_Other_a, _cityData$All_Famous_, _cityData$All_Other_p, _cityData$All_Towns_a, _cityData$All_Other_c, _cityData$All_Nearest, _cityData$All_Carry_c, _cityData$All_Exchang, _cityData$All_Purpose;

  var cityData = _ref.cityData,
      isMmtHost = _ref.isMmtHost,
      templateType = _ref.templateType,
      url = _ref.url;

  var _useState = (0,react.useState)(false),
      scrolled = _useState[0],
      setScrolled = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showViewMore = _useState2[0],
      setShowViewMore = _useState2[1];

  var _useState3 = (0,react.useState)(4),
      cardsToBeShown = _useState3[0],
      setCardsToBeShown = _useState3[1];

  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      if (window.scrollY > 60) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    (0,analytics/* trackSeoPageLoad */.XE)({
      pageName: analytics/* PAGE_NAMES */.a3["SEO_CURRENCY_EXCHANGE_".concat(templateType)],
      city: cityData === null || cityData === void 0 ? void 0 : cityData.City
    });
    window.addEventListener("scroll", handleScroll);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  var _ref2 = cityData || {},
      btn_link = _ref2.hero_btn_link,
      btn_text = _ref2.hero_btn_text,
      img_link = _ref2.hero_img_link,
      desc = _ref2.hero_desc,
      title = _ref2.hero_title,
      list = _ref2.hero_list,
      forex_sol = _ref2.hero_img,
      forex_sol_mobile = _ref2.hero_img_mobile;

  var heroProps = {
    btn_link: btn_link,
    btn_text: btn_text,
    img_link: img_link,
    desc: desc,
    title: title,
    list: list,
    forex_sol: forex_sol,
    forex_sol_mobile: forex_sol_mobile,
    green_check: cityData === null || cityData === void 0 ? void 0 : cityData.green_check
  };

  var handleOnClick = function handleOnClick() {
    setShowViewMore(false);
    setCardsToBeShown(14);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* FontStyles */.B2, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* BaseStyles */.xR, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* TripMoneyOldStyles */.I8, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyCityTemplate_CityDocumet, {
      cityData: cityData,
      url: url
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "header__inner",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: cityData === null || cityData === void 0 ? void 0 : (_cityData$header = cityData.header) === null || _cityData$header === void 0 ? void 0 : _cityData$header.image_link,
            children: isMmtHost ? /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* MMTLogo */.X, {
              isLight: false
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(BMFLogo/* default */.Z, {
              isLight: scrolled ? false : true
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "topBlueSection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "greySection",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container negativeMargin",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeroV2/* HeroV2 */.n, CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({}, heroProps), {}, {
            breadcrumb: cityData === null || cityData === void 0 ? void 0 : cityData.breadcrumb
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pageContainer pageContainer_margin sectionGapping",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ForexProducts/* default */.Z, {
              currencyData: cityData,
              pageName: analytics/* PAGE_NAMES */.a3["SEO_CURRENCY_EXCHANGE_".concat(templateType)]
            })
          }), cityData !== null && cityData !== void 0 && cityData.Description_title ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
            className: "tripMoneySection makeFlex hrtlCenter",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              className: "bannerText",
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Page_title
            })
          }) : null, cityData !== null && cityData !== void 0 && cityData.Description_desc ? /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: "tripMoneySection",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "appendBottom20",
              children: cityData !== null && cityData !== void 0 && cityData.Description_title ? cityData === null || cityData === void 0 ? void 0 : cityData.Description_title : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Description_desc
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Description_desc_addendum
            })]
          }) : null]
        })
      }), cityData !== null && cityData !== void 0 && cityData.All_Fake_currencies_way_ ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "whiteSection",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: "tripMoneySection makeFlex",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom30",
                children: cityData === null || cityData === void 0 ? void 0 : cityData.Fake_currencies_title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "counterFietImgWrapMweb",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({}, cityData === null || cityData === void 0 ? void 0 : cityData.fake_currency_mobile_logo), {}, {
                  loading: "lazy"
                }))
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "appendBottom20",
                children: cityData === null || cityData === void 0 ? void 0 : cityData.Fake_currencies_desc
              }), cityData !== null && cityData !== void 0 && cityData.All_Fake_currencies_way_ ? /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                children: cityData === null || cityData === void 0 ? void 0 : cityData.All_Fake_currencies_way_.map(function (way, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "makeFlex ".concat(index < (cityData === null || cityData === void 0 ? void 0 : cityData.All_Fake_currencies_way_.length) - 1 ? "dashedBorder" : ""),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                      className: "greenCheckImg"
                    }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                      loading: "eager"
                    })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: way
                      })
                    })]
                  }, way);
                })
              }) : null]
            }), cityData !== null && cityData !== void 0 && cityData.fake_currency_logo ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "counterFietImgWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({}, cityData === null || cityData === void 0 ? void 0 : cityData.fake_currency_logo), {}, {
                loading: "lazy"
              }))
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
          })
        })
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "greySection",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
            className: "tripMoneySection",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "container__card",
              children: [cityData !== null && cityData !== void 0 && cityData.All_Major_areas_ && cityData !== null && cityData !== void 0 && cityData.All_Other_areas_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "appendBottom18",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Major_areas_title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                  className: "appendBottom10",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Major_areas_desc
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Major_a = cityData.All_Major_areas_) === null || _cityData$All_Major_a === void 0 ? void 0 : _cityData$All_Major_a.map(function (area, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      className: "makeFlex appendBottom15",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                        className: "greenCheckImg"
                      }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                        loading: "eager"
                      })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                          children: area
                        })
                      })]
                    }, area);
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "dashedBorder"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "appendBottom18",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Other_areas_title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Other_a = cityData.All_Other_areas_) === null || _cityData$All_Other_a === void 0 ? void 0 : _cityData$All_Other_a.map(function (area, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      className: "makeFlex appendBottom15",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                        className: "greenCheckImg"
                      }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                        loading: "eager"
                      })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                          children: area
                        })
                      })]
                    }, area);
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "dashedBorder"
                })]
              }, "Major areas") : null, cityData !== null && cityData !== void 0 && cityData.All_Famous_place_ && cityData !== null && cityData !== void 0 && cityData.All_Other_place_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "appendBottom18",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Famous_place_title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                  className: "appendBottom10",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Famous_place_desc
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Famous_ = cityData.All_Famous_place_) === null || _cityData$All_Famous_ === void 0 ? void 0 : _cityData$All_Famous_.map(function (place, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      className: "makeFlex appendBottom15",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                        className: "greenCheckImg"
                      }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                        loading: "eager"
                      })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                          children: place
                        })
                      })]
                    }, place);
                  })
                }), cityData !== null && cityData !== void 0 && cityData.All_Other_place_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "dashedBorder"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: "appendBottom18",
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Other_place_title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                    children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Other_p = cityData.All_Other_place_) === null || _cityData$All_Other_p === void 0 ? void 0 : _cityData$All_Other_p.map(function (place) {
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        className: "makeFlex appendBottom15",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                          className: "greenCheckImg"
                        }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                          loading: "eager"
                        })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                            children: place
                          })
                        })]
                      }, place);
                    })
                  })]
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
              }, "Famous places") : null]
            })
          }), cityData !== null && cityData !== void 0 && cityData.All_Towns_and_cities_ && cityData !== null && cityData !== void 0 && cityData.All_Other_cities_ ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
            className: "tripMoneySection",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "container__card appendBottom80",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                className: "containerImg"
              }, cityData === null || cityData === void 0 ? void 0 : cityData.towns_cities_img), {}, {
                loading: "lazy"
              })), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "appendBottom30",
                children: cityData === null || cityData === void 0 ? void 0 : cityData.Towns_and_cities_title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "productRangeList",
                children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Towns_a = cityData.All_Towns_and_cities_) === null || _cityData$All_Towns_a === void 0 ? void 0 : _cityData$All_Towns_a.map(function (city) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      children: city
                    })
                  }, city);
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "dashedBorder"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "appendBottom18",
                children: cityData === null || cityData === void 0 ? void 0 : cityData.Other_cities_title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Other_c = cityData.All_Other_cities_) === null || _cityData$All_Other_c === void 0 ? void 0 : _cityData$All_Other_c.map(function (city) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "makeFlex appendBottom15",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                      className: "greenCheckImg"
                    }, cityData === null || cityData === void 0 ? void 0 : cityData.green_check), {}, {
                      loading: "eager"
                    })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: city
                      })
                    })]
                  }, city);
                })
              })]
            })
          }) : null, cityData !== null && cityData !== void 0 && cityData.All_Nearest_airports_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: "tripMoneySection",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "appendBottom20",
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Nearest_airports_title
            }), cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Nearest = cityData.All_Nearest_airports_) === null || _cityData$All_Nearest === void 0 ? void 0 : _cityData$All_Nearest.map(function (airport) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                children: airport
              });
            })]
          }) : null, cityData !== null && cityData !== void 0 && cityData.All_Carry_currency_way_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: "tripMoneySection",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "appendBottom20",
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Carry_currency_title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
              className: "appendBottom24",
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Carry_currency_desc
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "container__card container__cardAlign",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "tripmoneyImgWrap",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyCityTemplateOld_objectSpread(CurrencyCityTemplateOld_objectSpread({
                  className: "tripMoneyImg"
                }, cityData === null || cityData === void 0 ? void 0 : cityData.best_ways_cary_logo), {}, {
                  loading: "lazy"
                }))
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Carry_c = cityData.All_Carry_currency_way_) === null || _cityData$All_Carry_c === void 0 ? void 0 : _cityData$All_Carry_c.map(function (way) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      className: "blackText appendBottom10",
                      children: way
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "dashedBorder"
                    })]
                  }, way);
                })
              })]
            })]
          }) : null, cityData !== null && cityData !== void 0 && cityData.All_Exchange_currency_steps_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: "tripMoneySection",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "appendBottom20",
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Exchange_currency_title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
              className: "appendBottom24",
              children: cityData === null || cityData === void 0 ? void 0 : cityData.Exchange_currency_desc
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: "tripMoneySection__bestRateBuy",
              children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Exchang = cityData.All_Exchange_currency_steps_) === null || _cityData$All_Exchang === void 0 ? void 0 : _cityData$All_Exchang.map(function (step, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "stepCount",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "font16",
                      children: "STEP"
                    }), " ", index + 1 < 9 ? (index + 1).toString().padStart(2, "0") : index + 1]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                    children: step
                  })]
                }, step);
              })
            }), cityData !== null && cityData !== void 0 && cityData.Buy_sell_local_title ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "container__card",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "appendBottom20",
                children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_local_title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "appendBottom20",
                children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_local_desc
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
          }) : null, cityData !== null && cityData !== void 0 && cityData.All_Purpose_ ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
            className: "tripMoneySection",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "exchangeRateWrap appendBottom35",
              children: [cityData !== null && cityData !== void 0 && cityData.All_Purpose_ ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "container__card flexOne",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: "appendBottom22",
                  children: cityData === null || cityData === void 0 ? void 0 : cityData.Purpose_for_exchanging_title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "productRangeList",
                  children: cityData === null || cityData === void 0 ? void 0 : (_cityData$All_Purpose = cityData.All_Purpose_) === null || _cityData$All_Purpose === void 0 ? void 0 : _cityData$All_Purpose.map(function (purpose) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      className: "dashedBorder",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: purpose
                      })
                    }, purpose);
                  })
                })]
              }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flexOne makeFlex column",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "container__card appendBottom30",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    className: "appendBottom22",
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_online_title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Buy_sell_online_desc
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "container__card",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    className: "appendBottom22",
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Home_delivery_title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                    children: cityData === null || cityData === void 0 ? void 0 : cityData.Home_delivery_desc
                  })]
                })]
              })]
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverter/* default */.Z, {
            currConversion: cityData === null || cityData === void 0 ? void 0 : cityData.currency_conversions
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            currencyData: cityData
          })]
        })
      }), cityData !== null && cityData !== void 0 && cityData.footer ? /*#__PURE__*/(0,jsx_runtime.jsx)(CityFooter, {
        footer: cityData === null || cityData === void 0 ? void 0 : cityData.footer,
        city: cityData === null || cityData === void 0 ? void 0 : cityData.City
      }) : null]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyCityTemplate/index.tsx



/***/ }),

/***/ 9116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Faqs; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOMarkdown/index.tsx + 1 modules
var CurrencySEOMarkdown = __webpack_require__(2558);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Faqs.styles.ts


var _templateObject;


var FaqsStyle = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([".faqList{\n    margin-top: 50px;\n}\n.answer{\n    display:none;\n}\n.toggleAnswer .answer{\n    display:block;\n}\n.faqList li h4.question{\n    font-size: 24px;\n    line-height: 26px;\n    font-weight: 900;\n    color: #000;\n    padding: 30px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.faqList li h4.question::after{\n    content: \"\";\n    border: solid #2f2f2f;\n    display: inline-block;\n    border-width: 0 3px 3px 0;\n    padding: 6px;\n    transform: rotate(45deg);\n    position: absolute;\n    right: 40px;\n    top: 32px;\n}\n.faqList li div.answer{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n    padding: 0 0 0 30px;\n    margin-bottom: 30px;\n}\n.faqList li div.answer span{\n    font-weight: 900;\n}\n.faqList li:hover h4.question{\n    border-radius: 6px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n}\n.faqList li.active h4.question::after{\n    transform: rotate(-135deg);\n    top: 42px;\n}\n\n/* Mobile devices */\n@media (min-width: 320px) and (max-width: 767px) {\n    .faqList li{ border-radius: 6px; box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22); background-color: #fff; padding: 20px 10px; margin-bottom: 40px;}\n    .faqList li:last-child{ margin-bottom: 0;}\n    .faqList li:hover h4.question{ border-radius: unset; box-shadow: unset; background-color: unset;}\n    .faqList li h4.question{ padding: 0 60px 0 0; font-size: 18px; line-height: 22px;}\n    .faqList li h4.question::after{ padding: 4px; right: 10px; top: 5px;}\n    .faqList li.active h4.question::after{ top: 10px;}\n    .faqList li div.answer{ margin-bottom: unset; padding: 10px 0 0 0; font-size: 16px;}\n    .faqList li.active{ box-shadow: unset;}\n}\n"])));
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Faqs.tsx






function Faqs(_ref) {
  var _currencyData$faqs, _currencyData$faqs2;

  var currencyData = _ref.currencyData;

  var _useState = (0,react.useState)(-1),
      open = _useState[0],
      setOpen = _useState[1];

  var faqs = (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$faqs = currencyData.faqs) === null || _currencyData$faqs === void 0 ? void 0 : _currencyData$faqs.list) || [];

  var handleFaq = function handleFaq(index) {
    if (open === index) {
      setOpen(-1);
    } else {
      setOpen(index);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaqsStyle, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$faqs2 = currencyData.faqs) === null || _currencyData$faqs2 === void 0 ? void 0 : _currencyData$faqs2.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "faqList",
      children: faqs.map(function (faq, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          onClick: function onClick() {
            return handleFaq(index);
          },
          className: "".concat(open === index ? "toggleAnswer" : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: "question",
            children: faq === null || faq === void 0 ? void 0 : faq.ques
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "answer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
              children: faq === null || faq === void 0 ? void 0 : faq.ans
            })
          })]
        }, index);
      })
    })]
  });
}

/***/ }),

/***/ 922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ForexProduct; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/constants/index.ts + 1 modules
var constants = __webpack_require__(6533);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(4709);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/ForexProducts.styles.ts


var _templateObject;


var ForexProductsStyle = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n\n.getForex{\n    padding: 56px 24px 44px;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.getForex__title{\n    margin-bottom: 40px;\n}\n.getForex__title .big{\n    font-size: 18px;\n    color: #000;\n    font-weight: 700;\n    margin-right: 10px;\n}\n.getForex__title .small{\n    font-size: 18px;\n    color: #4a4a4a;\n    font-weight: 400;\n}\n.getForex__title .medium{\n    font-size: 18px;\n    color: #2b825e;\n    font-weight: 900;\n}\n.getForex__list{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n.getForex__listItem{\n    border: solid 1px #e2e2e2;\n    padding: 10px 13px;\n    border-radius: 4px;\n    display: flex;\n    cursor: pointer;\n}\n.getForex__listItemImg{\n    width: 140px;\n    flex-shrink: 0;\n    margin-right: 10px;\n}\n.getForex__listItemDesc{\n    flex: 1;\n}\n.getForex__listItemDesc h3.title{\n    font-size: 18px;\n    font-weight: 900;\n    color: #000;\n    display: flex;\n    align-items: center;\n}\n.getForex__listItemDesc p.title{\n    font-size: 18px;\n    font-weight: 900;\n    color: #000;\n    display: flex;\n    align-items: center;\n}\n.getForex__listItemDesc h3.title .arrow{\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin-left: 10px;\n    position: relative;\n}\n.getForex__listItemDesc h3.title .arrow::after{\n    content: \"\";\n    display: inline-block;\n    border: solid #008cff;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: 2px;\n    top: 4px;\n}\n.getForex__listItemDesc h3.title .arrow::before{\n    content: \"\";\n    display: inline-block;\n    width: 10px;\n    height: 2px;\n    background-color: #008cff;\n    position: absolute;\n    right: 3px;\n    top: 7px;\n}\n.getForex__listItemDesc p.desc{\n    font-size: 14px;\n    line-height: 22px;\n    margin-top: 10px;\n}\n.getForex__listItemDesc p.desc span{\n    position: relative;\n    padding: 0 5px 0 10px;\n}\n.getForex__listItemDesc p.desc span::after{\n    width: 4px;\n    height: 4px;\n    background-color: #2b825e;\n    content: \"\";\n    border-radius: 50%;\n    position: absolute;\n    left: 0;\n    top: 8px;\n}\n.getForex__listItemDesc p.desc span:first-child::after{\n    display: none;\n}\n.getForex__listItemDesc p.desc span:first-child{\n    padding: 0 5px 0 0;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n    .getForex{ box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16); border: solid 1px #e8e8e8; padding: 25px 12px; border-radius: 12px;}\n    .getForex__title{ display: none;}\n    .getForex__list{ grid-template-columns: 1fr;}\n    .getForex__listItem{ border: 0; padding: 0; border-radius: 0;}\n    .getForex__listItem:first-child{ border-bottom: 1px #f2f2f2 solid; padding-bottom: 15px;}\n    .getForex__listItemImg{ width: 64px;}\n    .getForex__listItemImg img{ width: 64px; height: unset;}\n    .getForex__listItemDesc p.desc{ margin-top: 5px; font-size: 12px; line-height: 18px;}\n    .getForex__listItemDesc p.desc span::after{ top: 6px;}\n    .getForex__listItemDesc p.title .arrow{ margin-left: auto;}\n}\n"])));
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/ForexProducts.tsx









function ForexProduct(_ref) {
  var _currencyData$forex_p;

  var currencyData = _ref.currencyData,
      pageName = _ref.pageName,
      _ref$templateType = _ref.templateType,
      templateType = _ref$templateType === void 0 ? "" : _ref$templateType;

  var handleRedirection = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(index) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (index == 0) {
                (0,analytics/* trackSeoPageLoad */.XE)({
                  pageName: pageName,
                  cardClicked: "Forex_card"
                });
                window.open("".concat(constants/* SEO_REDIRECTIONS */.Y9 === null || constants/* SEO_REDIRECTIONS */.Y9 === void 0 ? void 0 : constants/* SEO_REDIRECTIONS.CARD_BUY */.Y9.CARD_BUY).concat((0,utils/* addUtmParamsToUrl */.PL)(constants/* PRODUCT_TYPE.CARD */.fY.CARD, templateType)));
              } else {
                (0,analytics/* trackSeoPageLoad */.XE)({
                  pageName: pageName,
                  cardClicked: "Forex_currency_notes"
                });
                window.open("".concat(constants/* SEO_REDIRECTIONS */.Y9 === null || constants/* SEO_REDIRECTIONS */.Y9 === void 0 ? void 0 : constants/* SEO_REDIRECTIONS.CURRENCY_BUY */.Y9.CURRENCY_BUY).concat((0,utils/* addUtmParamsToUrl */.PL)(constants/* PRODUCT_TYPE.CURRENCY */.fY.CURRENCY, templateType)));
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleRedirection(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ForexProductsStyle, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "getForex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: "getForex__title",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "big",
          children: "Get Forex products at your doorstep"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "small",
          children: "we offer"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "medium",
          children: "same day delivery"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "small",
          children: "in 185+ indian cities"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "getForex__list",
        children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$forex_p = currencyData.forex_products) === null || _currencyData$forex_p === void 0 ? void 0 : _currencyData$forex_p.map(function (product, index) {
          var _product$sub_title;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "getForex__listItem",
            onClick: function onClick() {
              return handleRedirection(index);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "getForex__listItemImg",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: product === null || product === void 0 ? void 0 : product.img,
                alt: "multi currency",
                width: "140",
                height: "94"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "getForex__listItemDesc",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                className: "title",
                children: [product === null || product === void 0 ? void 0 : product.title, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "arrow"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "desc",
                children: product === null || product === void 0 ? void 0 : (_product$sub_title = product.sub_title) === null || _product$sub_title === void 0 ? void 0 : _product$sub_title.map(function (desc, ind) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: desc
                  }, ind);
                })
              })]
            })]
          }, index);
        })
      })]
    })]
  });
}

/***/ }),

/***/ 8545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ CurrencyFooter; }
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var react_markdown_lib_react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(843);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CurrencyFooter = function CurrencyFooter(_ref) {
  var _footer$section_foote, _footer$section_foote2, _footer$section_foote3, _footer$bottom_footer;

  var footer = _ref.footer,
      hideTopLinks = _ref.hideTopLinks;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [!hideTopLinks && footer !== null && footer !== void 0 && (_footer$section_foote = footer.section_footer) !== null && _footer$section_foote !== void 0 && (_footer$section_foote2 = _footer$section_foote[0]) !== null && _footer$section_foote2 !== void 0 && _footer$section_foote2.links ? footer === null || footer === void 0 ? void 0 : (_footer$section_foote3 = footer.section_footer) === null || _footer$section_foote3 === void 0 ? void 0 : _footer$section_foote3.map(function (section, index) {
      var _section$links;

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
        className: "reviewedCurrencies",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
          className: "container",
          children: section === null || section === void 0 ? void 0 : section.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "container",
          children: section === null || section === void 0 ? void 0 : (_section$links = section.links) === null || _section$links === void 0 ? void 0 : _section$links.map(function (col, index) {
            var _section$links2;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
              className: "footerLinkCol",
              children: col === null || col === void 0 ? void 0 : col.map(function (link) {
                var title = link.title,
                    href = link.href,
                    target = link.target;
                var linkProps = {
                  href: href,
                  target: target
                };
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                  className: "footerLink",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", _objectSpread(_objectSpread({}, linkProps), {}, {
                    children: title
                  }))
                }, title);
              })
            }, "".concat(section === null || section === void 0 ? void 0 : (_section$links2 = section.links) === null || _section$links2 === void 0 ? void 0 : _section$links2.title).concat(index));
          })
        })]
      }, "".concat(section === null || section === void 0 ? void 0 : section.title).concat(index));
    }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("footer", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "container",
        children: footer === null || footer === void 0 ? void 0 : (_footer$bottom_footer = footer.bottom_footer) === null || _footer$bottom_footer === void 0 ? void 0 : _footer$bottom_footer.map(function (col) {
          var _col$list;

          return col.title ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "item",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_markdown_lib_react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
              className: "linkTitle",
              children: col === null || col === void 0 ? void 0 : col.title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
              children: col === null || col === void 0 ? void 0 : (_col$list = col.list) === null || _col$list === void 0 ? void 0 : _col$list.map(function (link) {
                var title = link.title,
                    href = link.href,
                    target = link.target;
                var linkProps = {
                  href: href,
                  target: target
                };
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", _objectSpread(_objectSpread({}, linkProps), {}, {
                    children: title
                  }))
                }, title);
              })
            })]
          }, col === null || col === void 0 ? void 0 : col.title) : null;
        })
      })
    })]
  });
};

/***/ }),

/***/ 4760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ HeroV2; }
/* harmony export */ });
/* harmony import */ var _forex_Forex_Breadcrumb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(290);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);



function HeroV2(props) {
  var _props$title = props.title,
      title = _props$title === void 0 ? "" : _props$title,
      _props$desc = props.desc,
      desc = _props$desc === void 0 ? "" : _props$desc;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "heroSection__inner heroPadding",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_forex_Forex_Breadcrumb__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        breadCrumbData: props.breadcrumb || []
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "heroSection_info",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
          children: desc
        })]
      })]
    })
  });
}

/***/ }),

/***/ 1594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HeroWebV2; }
/* harmony export */ });
/* harmony import */ var _forex_Forex_Breadcrumb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(290);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);



function HeroWebV2(props) {
  var _props$title = props.title,
      title = _props$title === void 0 ? "" : _props$title,
      _props$desc = props.desc,
      desc = _props$desc === void 0 ? "" : _props$desc,
      _props$breadcrumb = props.breadcrumb,
      breadcrumb = _props$breadcrumb === void 0 ? [] : _props$breadcrumb,
      children = props.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    id: "top-banner",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "top-banner__container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
        className: "top-banner__title",
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
        className: "top-banner__description",
        children: desc
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "top-banner__breadcrumb",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_forex_Forex_Breadcrumb__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          breadCrumbData: breadcrumb
        })
      })]
    }), children && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "top-banner__wrapper",
      children: children
    })]
  });
}

/***/ }),

/***/ 9235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CurrencyConverter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);




function CurrencyConverter(_ref) {
  var _currConversion$cards;

  var currConversion = _ref.currConversion,
      hideSeparator = _ref.hideSeparator;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      showViewMore = _useState[0],
      setShowViewMore = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(4),
      cardsToBeShown = _useState2[0],
      setCardsToBeShown = _useState2[1];

  var handleOnClick = function handleOnClick() {
    setShowViewMore(!showViewMore); // setCardsToBeShown(14);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [!hideSeparator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
      className: "h2",
      children: currConversion === null || currConversion === void 0 ? void 0 : currConversion.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
      className: "capSulesList grid5 ".concat(!showViewMore ? "showAll" : ""),
      children: currConversion === null || currConversion === void 0 ? void 0 : (_currConversion$cards = currConversion.cards) === null || _currConversion$cards === void 0 ? void 0 : _currConversion$cards.map(function (card, index) {
        // if (cardsToBeShown > index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          className: "capsule",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
            href: card === null || card === void 0 ? void 0 : card.href,
            target: "_blank",
            children: card === null || card === void 0 ? void 0 : card.title
          })
        }, "".concat(card === null || card === void 0 ? void 0 : card.title).concat(index)); // }
        // return null;
      })
    }), showViewMore && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
      className: "viewMore",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        className: "viewMore__cta",
        onClick: function onClick() {
          return handleOnClick();
        },
        children: "View More"
      })
    })]
  });
}

/***/ }),

/***/ 4326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xR": function() { return /* reexport */ BaseStyles; },
  "B2": function() { return /* reexport */ FontStyles; },
  "X": function() { return /* reexport */ MMTLogo; },
  "I8": function() { return /* reexport */ TripMoneyOldStyles; },
  "KL": function() { return /* reexport */ TripMoneyStyles; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/fonts.styles.ts


var _templateObject;


var FontStyles = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  /* latin */\n  @font-face {\n    font-family: 'lato';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjx4wXiWtFCc.woff2)\n      format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\n      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\n      U+FEFF, U+FFFD;\n  }\n"])));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/base.styles.ts


var base_styles_templateObject;


var BaseStyles = (0,styled_components_browser_esm.createGlobalStyle)(base_styles_templateObject || (base_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["  \nhtml,\nbody {\n  background: #ffffff;\n  padding: 0;\n  margin: 0;\n  color: #2f2f2f;\n  font-size: 18px;\n  line-height: 26px;\n  font-family: lato;\n  font-weight: 400;\n}\nhtml {\n  box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul {\n  margin: 0;\n  list-style: none;\n  padding: 0;\n}\na {\n  color: #008cff;\n  text-decoration: none;\n  cursor: pointer;\n}\na:hover,\na:focus {\n  text-decoration: none;\n  outline: none;\n}\n.hide {\n  display: none;\n}\n.show {\n  display: block;\n}\nimg {\n  max-width: 100%;\n}\nsvg {\n  flex-shrink: 0;\n}\n.lineThrough {\n  text-decoration: line-through;\n}\n.capText {\n  text-transform: uppercase;\n}\n.makeRelative {\n  position: relative;\n}\n.truncate {\n  width: 100%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.blackText {\n  color: #000000;\n}\n.whiteText {\n  color: #fff;\n}\n.darkBlueText {\n  color: #0e3f76;\n}\n.greyText {\n  color: #696969;\n}\n.greyText2 {\n  color: #4b4a4a;\n}\n.dashedBorder {\n  border-bottom: dashed 1px #cfcfcf;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n}\n.font10 {\n  font-size: 10px;\n  line-height: 10px;\n}\n.font11 {\n  font-size: 11px;\n  line-height: 11px;\n}\n.font12 {\n  font-size: 12px;\n  line-height: 12px;\n}\n.font14 {\n  font-size: 14px;\n  line-height: 14px;\n}\n.font16 {\n  font-size: 16px;\n  line-height: 16px;\n}\n.font18 {\n  font-size: 18px;\n  line-height: 18px;\n}\n.font20 {\n  font-size: 20px;\n  line-height: 20px;\n}\n.font22 {\n  font-size: 22px;\n  line-height: 22px;\n}\n.font28 {\n  font-size: 28px;\n  line-height: 28px;\n}\n.latoRegular {\n  font-weight: 400;\n}\n.latosemiBold {\n  font-weight: 600;\n}\n.latoBold {\n  font-weight: 700;\n}\n.latoBlack {\n  font-weight: 900;\n}\n.latoItalic {\n  font-style: italic;\n}\n.lineHeight14 {\n  line-height: 14px;\n}\n.lineHeight16 {\n  line-height: 16px;\n}\n.lineHeight18 {\n  line-height: 18px;\n}\n.lineHeight20 {\n  line-height: 20px;\n}\n.lineHeight21 {\n  line-height: 21px;\n}\n.lineHeight22 {\n  line-height: 22px;\n}\n.lineHeight25 {\n  line-height: 25px;\n}\n.lineHeight30 {\n  line-height: 30px;\n}\n.textLeft {\n  text-align: left;\n}\n.textRight {\n  text-align: right;\n}\n.textCenter {\n  text-align: center;\n}\n.relative {\n  position: relative;\n}\n.makeFlex {\n  display: flex;\n}\n.makeFlex.flexWrap {\n  flex-wrap: wrap;\n}\n.makeFlex .flexOne {\n  flex: 1;\n}\n.makeFlex.column {\n  flex-direction: column;\n}\n.makeFlex.perfectCenter {\n  align-items: center;\n  justify-content: center;\n}\n.makeFlex.hrtlCenter {\n  align-items: center;\n}\n.makeFlex.spaceBetween {\n  justify-content: space-between;\n}\n.makeFlex.top {\n  align-items: flex-start;\n}\n.noShrink {\n  flex-shrink: 0;\n}\n.flexOne {\n  flex: 1;\n}\n.inlineFlex {\n  display: inline-flex;\n}\n.inlineFlex.hrtlCenter {\n  align-items: center;\n}\n.appendTop2 {\n  margin-top: 2px;\n}\n.appendTop3 {\n  margin-top: 3px;\n}\n.appendTop5 {\n  margin-top: 5px;\n}\n.appendTop6 {\n  margin-top: 6px;\n}\n.appendTop8 {\n  margin-top: 8px;\n}\n.appendTop10 {\n  margin-top: 10px;\n}\n.appendTop15 {\n  margin-top: 15px;\n}\n.appendTop18 {\n  margin-top: 18px;\n}\n.appendTop20 {\n  margin-top: 20px;\n}\n.appendTop25 {\n  margin-top: 25px;\n}\n.appendTop30 {\n  margin-top: 30px;\n}\n.appendTop40 {\n  margin-top: 40px;\n}\n.appendTop45 {\n  margin-top: 45px;\n}\n.appendTop52 {\n  margin-top: 52px;\n}\n.appendRight3 {\n  margin-right: 3px;\n}\n.appendRight5 {\n  margin-right: 5px;\n}\n.appendRight6 {\n  margin-right: 6px;\n}\n.appendRight8 {\n  margin-right: 8px;\n}\n.appendRight10 {\n  margin-right: 10px;\n}\n.appendRight12 {\n  margin-right: 12px;\n}\n.appendRight15 {\n  margin-right: 15px;\n}\n.appendRight20 {\n  margin-right: 20px;\n}\n.appendRight35 {\n  margin-right: 35px;\n}\n.appendBottom2 {\n  margin-bottom: 2px;\n}\n.appendBottom3 {\n  margin-bottom: 3px;\n}\n.appendBottom4 {\n  margin-bottom: 4px;\n}\n.appendBottom5 {\n  margin-bottom: 5px;\n}\n.appendBottom7 {\n  margin-bottom: 7px;\n}\n.appendBottom8 {\n  margin-bottom: 8px;\n}\n.appendBottom10 {\n  margin-bottom: 10px;\n}\n.appendBottom12 {\n  margin-bottom: 12px;\n}\n.appendBottom15 {\n  margin-bottom: 15px;\n}\n.appendBottom18 {\n  margin-bottom: 18px;\n}\n.appendBottom20 {\n  margin-bottom: 20px;\n}\n.appendBottom22 {\n  margin-bottom: 22px;\n}\n.appendBottom24 {\n  margin-bottom: 24px;\n}\n.appendBottom30 {\n  margin-bottom: 30px;\n}\n.appendBottom35 {\n  margin-bottom: 35px;\n}\n.appendBottom40 {\n  margin-bottom: 40px;\n}\n.appendBottom60 {\n  margin-bottom: 60px;\n}\n.appendBottom80 {\n  margin-bottom: 80px;\n}\n.paddingT10 {\n  padding-top: 10px;\n}\n.prependTop5 {\n  padding-top: 5px;\n}\n.prependRight5 {\n  padding-right: 5px;\n}\n.appendLeft3 {\n  margin-left: 3px;\n}\n.appendLeft4 {\n  margin-left: 4px;\n}\n.appendLeft5 {\n  margin-left: 5px;\n}\n.appendLeft10 {\n  margin-left: 10px;\n}\n.appendLeft15 {\n  margin-left: 15px;\n}\n\n.checkmarkOuter {\n  display: inline-flex;\n  position: relative;\n  min-height: 18px;\n  flex-shrink: 0;\n}\n.checkmarkOuter [type='checkbox']:checked,\n.checkmarkOuter [type='checkbox']:not(:checked) {\n  position: absolute;\n  left: -9999px;\n  opacity: 0;\n}\n.checkmarkOuter [type='checkbox']:checked + label,\n.checkmarkOuter [type='checkbox']:not(:checked) + label {\n  position: relative;\n  padding-left: 28px;\n  cursor: pointer;\n  line-height: 20px;\n  display: inline-flex;\n}\n.checkmarkOuter [type='checkbox']:checked + label:before,\n.checkmarkOuter [type='checkbox']:not(:checked) + label:before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border: 1px solid #9b9b9b;\n  border-radius: 2px;\n  background: #fff;\n}\n.checkmarkOuter [type='checkbox']:checked + label:before {\n  border: 1px solid #008cff;\n  content: '';\n  width: 18px;\n  height: 18px;\n  background: #008cff;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 2px;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.checkmarkOuter [type='checkbox']:checked + label:after {\n  position: absolute;\n  left: 6px;\n  top: 3px;\n  content: '';\n  display: block;\n  width: 6px;\n  height: 10px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n\n.primaryBtn {\n  border-radius: 6px;\n  height: 60px;\n  width: 100%;\n  background: var(\n    --btnBg,\n    linear-gradient(91.91deg, #000000 0.3%, #330e0e 100%)\n  );\n  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);\n  display: inline-block;\n  flex-shrink: 0;\n  color: #fff;\n  text-transform: uppercase;\n  font-family: lato;\n  font-size: 20px;\n  font-weight: 900;\n  padding: 9px 20px;\n  cursor: pointer;\n  outline: 0;\n  border: 0;\n  text-align: center;\n}\n.flip {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n}\n\n/* Left Navigation Start*/\n\n.leftNav {\n  width: 150px;\n  background-color: #fff;\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n  position: fixed;\n  left: 0;\n  top: 50%;\n  z-index: 11;\n  padding: 16px;\n  border-radius: 0 10px 10px 0;\n}\n.leftNav > li {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px #efefef solid;\n}\n.leftNav > li:last-child {\n  border-bottom: 0;\n}\n.leftNav > li a {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #4a4a4a;\n}\n.leftNav > li a.activePage {\n  color: #008cff;\n}\n.leftNav > li a::after {\n  content: '';\n  display: inline-block;\n  border: solid #008cff;\n  border-width: 0 2px 2px 0;\n  padding: 3px;\n  transform: rotate(-45deg);\n  margin-right: 5px;\n}\n\n/* Left Navigation End*/\n\n.secondaryBtn {\n  width: 90px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  outline: none;\n  font-weight: 900;\n  color: #008cff;\n  font-size: 16px;\n  line-height: 20px;\n  border-radius: 96px;\n  background: linear-gradient(0deg, #ffffff, #ffffff),\n    linear-gradient(93.66deg, #249083 0%, #249054 100%), #ffffff;\n  box-shadow: 0px 1px 7px rgb(0 0 0 / 20%);\n  -webkit-box-shadow: 0px 1px 7px rgb(0 0 0 / 20%);\n  -webkit-appearance: none;\n  cursor: pointer;\n}\n"])));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/tripmoney.styles.ts


var tripmoney_styles_templateObject;


var TripMoneyStyles = (0,styled_components_browser_esm.createGlobalStyle)(tripmoney_styles_templateObject || (tripmoney_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)([".container {\n    width: 1100px;\n    margin: 0 auto;\n    font-size: 18px;\n    line-height: 22px;\n  }\n  \n  .container.negativeMargin {\n    margin-top: -358px;\n  }\n  \n  .greySection {\n    background-color: #f6f6f6;\n    padding: 60px 0;\n  }\n  .whiteSection {\n    background-color: #fff;\n    padding: 60px 0;\n  }\n  \n  .headerLogo {\n    flex-shrink: 0;\n    width: 150px;\n    height: 59px;\n  }\n  \n  header {\n    background-color: #fff;\n    height: 80px;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 1;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 0;\n  }\n  .topBlueSection {\n    background-color: #010101;\n    height: 450px;\n  }\n  \n  .tripmoney__breadCrumbs {\n    display: flex;\n    font-size: 14px;\n    font-weight: bold;\n    color: #fff;\n    margin-bottom: 32px;\n  }\n  .container .bannerText {\n    font-size: 40px;\n    line-height: 48px;\n    margin-bottom: 10px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container .bannerTextInfo {\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 600;\n    margin-bottom: 35px;\n    color: #4b4a4a;\n  }\n  .container h1 {\n    font-size: 36px;\n    line-height: 44px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container h2 {\n    font-size: 30px;\n    line-height: 44px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container h3 {\n    font-size: 24px;\n    line-height: 30px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container h4 {\n    font-size: 22px;\n    line-height: 26px;\n    font-weight: 900;\n  }\n  .container__card {\n    border-radius: 8px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    padding: 46px 40px 40px;\n    flex: 1;\n    position: relative;\n  }\n  .containerImg {\n    position: absolute;\n    top: -48px;\n    left: 33px;\n    width: 81px;\n    height: 81px;\n  }\n  .forexSolImgWrap {\n    width: 392px;\n    height: 279px;\n    flex-shrink: 0;\n  }\n  .container__card--yellow {\n    background-color: #fffbec;\n    margin-bottom: 42px;\n  }\n  .container__card--blue {\n    background-color: #f0fdff;\n    display: flex;\n    margin-bottom: 34px;\n  }\n  .header__inner,.header__inner2 {\n    max-width: 1100px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .header__links {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n  }\n  .page__section {\n    width: 100%;\n  }\n  .baseHeaderContiner {\n    width: 1200px;\n    margin: 25px auto;\n    display: flex;\n  }\n  .baseLeft {\n    flex: 1;\n    flex-shrink: 0;\n  }\n  .baseLeft__cont {\n    max-width: 770px;\n  }\n  .baseRight {\n    width: 340px;\n    flex-shrink: 0;\n    margin-left: 10px;\n  }\n  .baseRight__item {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(165px, 1fr));\n    gap: 10px;\n  }\n  \n  .tripMoneySection {\n    border-bottom: solid 1px #979797;\n    margin-bottom: 50px;\n    padding-bottom: 50px;\n  }\n  \n  .tripMoneySection:last-child {\n    border: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n  \n  .forexSolList {\n    margin-bottom: 35px;\n  }\n  \n  .forexSolList li {\n    margin-bottom: 10px;\n    color: #696969;\n    display: flex;\n  }\n  \n  .countryList {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 20px;\n    margin-bottom: 35px;\n  }\n  \n  .countryList li {\n    border-radius: 6px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .currencyFacts__heaading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 60px;\n  }\n  .currencyFacts__list {\n    position: relative;\n  }\n  \n  .currencyFacts__list {\n    border-spacing: 12px;\n    position: relative;\n  }\n  \n  .currencyFacts__list::after {\n    content: '';\n    position: absolute;\n    background: #e9e2c6;\n    width: 1px;\n    height: 606px;\n    top: -10px;\n    left: 50%;\n  }\n  \n  .currencyFacts__list tr {\n    margin-bottom: 12px;\n  }\n  \n  .currencyFacts__list td {\n    border-bottom: solid 1px #e9e2c6;\n    padding-bottom: 12px;\n    font-size: 18px;\n    color: #2f2f2f;\n    align-items: center;\n    width: 50%;\n  }\n  \n  .currencyFacts__list tr:last-child td {\n    border-bottom: 0;\n    padding-bottom: 0;\n  }\n  \n  .currencyFacts__list span {\n    padding-left: 120px;\n    display: inline-block;\n  }\n  .currencyFacts__list li:last-child {\n    border: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n  \n  .tripMoneySection__bestRateBuy {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    margin-bottom: 45px;\n  }\n  \n  .tripMoneySection__bestRateBuy li {\n    background-image: url(https://tripmoneycmsimgak.mmtcdn.com/img/img_Bg_Path_85ccab3b71.png);\n    background-size: 353px 94px;\n    background-position: top left;\n    border-radius: 8px;\n    border: solid 1px #cad3dd;\n    background-color: #fff;\n    font-size: 16px;\n    color: #2f2f2f;\n    width: 353px;\n    height: 94px;\n    padding: 10px;\n    padding-left: 110px;\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  \n  .greenCheckImg {\n    width: 18px;\n    height: 18px;\n    margin-right: 12px;\n    margin-top: 3px;\n  }\n  \n  .tripmoneyImgWrap {\n    width: 228px;\n    flex-shrink: 0;\n    height: 48px;\n    margin-right: 75px;\n    align-self: center;\n    position: relative;\n  }\n  \n  .tripmoneyImgWrap::after {\n    content: '';\n    position: absolute;\n    top: -146px;\n    right: -33px;\n    width: 1px;\n    background: #d5d5d5;\n    height: 345px;\n  }\n  .countryImg {\n    border-radius: 50%;\n    margin-right: 8px;\n    object-fit: cover;\n  }\n  \n  .counterFietImgWrap {\n    width: 427px;\n    height: 579px;\n    flex-shrink: 0;\n    margin-left: 22px;\n  }\n  \n  .productRangeList {\n    padding-left: 32px;\n  }\n  \n  .productRangeList li {\n    position: relative;\n    margin-bottom: 20px;\n  }\n  \n  .productRangeList li::after {\n    content: '';\n    width: 7px;\n    height: 7px;\n    border-radius: 100%;\n    background: #000;\n    position: absolute;\n    top: 10px;\n    left: -32px;\n  }\n\n  .reviewedCurrencies {\n    background-color: #e0e0e0;\n    padding: 46px 0;\n  }\n\n  .reviewedCurrencies .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n  }\n\n  .footerLink{\n    padding:6px 0;\n  }\n\n  .footerLinkCol{\n        margin-left: 26px;\n  }\n\n  .footerLinkCol:first-child{\n    margin-left: 0;\n  }\n\n  .reviewedCurrencies h3{\n    font-size:28px;\n    margin-bottom: 16px;\n  }\n  \n  .quickfactsImg {\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    margin-right: 18px;\n  }\n  \n  .stepCount {\n    color: #fff;\n    position: absolute;\n    top: 14px;\n    left: 16px;\n    font-size: 42px;\n    line-height: 50px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .currencyLogoImg {\n    width: 104px;\n    height: 58px;\n    flex-shrink: 0;\n    margin-right: 16px;\n  }\n  .documentList {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    grid-column-gap: 28px;\n  }\n  \n  .documentList li {\n    display: flex;\n  }\n  \n  footer {\n    background-color: #16223e;\n    padding: 46px 0 46px;\n  }\n  \n  footer .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    color: #fff;\n    font-size: 16px;\n  }\n  \n  footer a {\n    font-size: 16px;\n    color: #fff;\n  }\n  \n  footer .linkTitle {\n    margin-bottom: 20px;\n    font-size: 20px;\n    line-height: 20px;\n  }\n  .counterFietImgWrapMweb {\n    display: none;\n  }\n  .exchangeRateWrap {\n    display: flex;\n    gap: 20px;\n  }\n  .container__cardAlign {\n    display: flex;\n  }\n  .container__card .primaryBtn {\n    width: 250px;\n    color: \"#fff\";\n  }\n  .refreshBtn{\n    cursor: pointer;\n  }\n  .forexSolImgWrapMweb {\n    display: none;\n  }\n\n  .capSulesList{\n    display: grid;\n    margin-top: 30px;\n    gap: 15px;\n  }\n  .capSulesList.grid5{\n      grid-template-columns: repeat(5, 1fr);\n  }\n  .capSulesList.grid4{\n      grid-template-columns: repeat(4, 1fr);\n  }\n  .capSulesList li{\n      padding: 19px;\n      border-radius: 6px;\n      cursor: pointer;\n      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n      background-color: #fff;\n      font-size: 16px;\n      font-weight: 700;\n      color: #005cbc;\n      text-align: center;\n  }\n  .viewMore{\n      margin-top: 30px;\n  }\n  .viewMore__cta{\n      font-size: 16px;\n      font-weight: 700;\n      color: #005cbc;\n  }\n  .capSulesList li:nth-child(n+5){\n      display: none;\n  }\n  .capSulesList.showAll li:nth-child(n+5){\n      display: block;\n  }\n  \n  @media only screen and (max-width: 768px) {\n    header{\n      padding: 20px;\n    }\n    .tripmoney__breadCrumbs {\n      margin-bottom: 24px;\n    }\n    .container {\n      width: 100%;\n      margin: unset;\n      padding: 16px;\n      font-size: 16px;\n      line-height: 20px;\n    }\n    .container .bannerText {\n      font-size: 25px;\n      line-height: 30px;\n      text-align: center;\n    }\n    .container__card {\n      padding: 60px 22px 22px;\n    }\n    .container__card--yellow {\n      padding-top: 24px;\n    }\n    .container__card--blue {\n      padding: 22px;\n    }\n    .whiteSection,\n    .greySection {\n      padding: 30px 0;\n    }\n    .forexSolList {\n      font-size: 14px;\n      line-height: 20px;\n    }\n    .countryList {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    .tripMoneySection__bestRateBuy {\n      display: flex;\n      flex-direction: column;\n    }\n    .documentList {\n      display: flex;\n      flex-direction: column;\n    }\n    .container h1 {\n      font-size: 30px;\n      line-height: 36px;\n    }\n    .container h2 {\n      font-size: 22px;\n      line-height: 27px;\n    }\n    .container h3 {\n      font-size: 18px;\n      line-height: 22px;\n    }\n    .currencyFacts__heaading {\n      margin-bottom: 30px;\n    }\n    .currencyFacts__list span {\n      padding-left: 0;\n    }\n    .currencyFacts__list li {\n      font-size: 16px;\n      line-height: 20px;\n    }\n    .currencyFacts__list::before,\n    .currencyFacts__list::after {\n      position: static;\n    }\n    .counterFietImgWrap {\n      display: none;\n    }\n    .counterFietImgWrapMweb {\n      width: 330px;\n      height: 448px;\n      flex-shrink: 0;\n      display: inline-block;\n      margin-bottom: 20px;\n    }\n    .forexSolImgWrap {\n      display: none;\n    }\n    .header__links {\n      display: none;\n    }\n    .exchangeRateWrap {\n      flex-direction: column;\n      gap: 60px;\n    }\n    .container__cardAlign {\n      flex-direction: column;\n    }\n    .container .bannerTextInfo {\n      font-size: 14px;\n      line-height: 20px;\n      text-align: center;\n    }\n    .container__card .primaryBtn {\n      width: 100%;\n    }\n    .tripMoneySection {\n      padding-bottom: 30px;\n      margin-bottom: 30px;\n    }\n    .currencyLogoImg {\n      width: 70px;\n      height: 40px;\n    }\n    .forexSolImgWrapMweb {\n      display: flex;\n      align-items: center;\n      width: 224px;\n      height: 160px;\n      flex-shrink: 0;\n      margin: 0 auto;\n      margin-bottom: 44px;\n    }\n    .containerImg {\n      top: -40px;\n    }\n    .tripmoneyImgWrap {\n      position: static;\n      margin-bottom: 38px;\n    }\n    .tripmoneyImgWrap::after {\n      content: none;\n    }\n    .container h4 {\n      font-size: 18px;\n      line-height: 22px;\n    }\n    .tripMoneySection__bestRateBuy li {\n      width: 100%;\n      background-repeat: no-repeat;\n    }\n    .capSulesList.grid5, .capSulesList.grid4{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n    .currencyList{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n    .capSulesList{ margin-top: 20px;}\n    .viewMore{ text-align: center; margin-top: 20px;}\n  }\n  @media only screen and (max-width: 550px){\n    footer .container{\n      flex-direction: column;\n    }\n    footer .item{\n      margin-bottom: 50px;\n    }\n\n    .reviewedCurrencies .container{\n      flex-direction: column;\n    }\n\n    .reviewedCurrencies h3{\n      margin-bottom: 0;\n      line-height:1.3;\n    }\n\n    .footerLinkCol{\n      margin-left:0;\n    }\n  }\n  \n  .heroSection{\n      background: #000;\n  }\n  .heroSection__inner{\n      max-width: 1200px;\n      margin: 0 auto;\n      background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_4567e802ae.png') top right no-repeat;\n      background-size: 557px 155px;\n      padding: 20px 0 80px 0;\n  }\n  .heroSection__inner.heroPadding {\n    padding: 0 16px 200px 16px;\n  }\n\n  .heroSection .heroSection_info {\n    padding: 38px 0 0;\n  }\n\n  .heroPadding h2{\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n  }\n\n  .heroPadding p{\n    font-size: 22px;\n    line-height: 52px;\n    font-weight: 600;\n    line-height: 30px;\n    color: #fff;\n    margin-top: 10px;\n  }\n\n  .pageContainer.pageContainer_margin {\n    margin: 0 auto;\n    margin-top: -170px;\n  }\n\n  .separator {\n    height: 1px;\n    background-color: #979797;\n    margin: 50px 0;\n  }\n\n  .faqList{\n      margin-top: 50px;\n  }\n  .faqList li h4.question{\n      font-size: 24px;\n      line-height: 26px;\n      font-weight: 900;\n      color: #000;\n      padding: 30px;\n      cursor: pointer;\n      transition: all 0.3s ease-in-out;\n      position: relative;\n  }\n  .faqList li h4.question::after{\n      content: \"\";\n      border: solid #2f2f2f;\n      display: inline-block;\n      border-width: 0 3px 3px 0;\n      padding: 6px;\n      transform: rotate(45deg);\n      position: absolute;\n      right: 40px;\n      top: 32px;\n  }\n  .faqList li p.answer{\n      font-size: 18px;\n      line-height: 24px;\n      color: #000;\n      padding: 0 0 0 30px;\n      margin-bottom: 30px;\n  }\n  .faqList li p.answer span{\n      font-weight: 900;\n  }\n  .faqList li:hover h4.question{\n      border-radius: 6px;\n      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n      background-color: #fff;\n  }\n  .faqList li.active h4.question::after{\n      transform: rotate(-135deg);\n      top: 42px;\n  }\n\n  @media (min-width: 320px) and (max-width: 767px) {\n    .heroPadding h2{\n        font-size: 24px;\n        line-height: 28px;\n    }\n    .heroPadding p{\n        font-size: 16px;\n        line-height: 20px;\n    }\n  }\n\n  @media (min-width: 320px) and (max-width: 767px) {\n      body{ background-color: #ffffff;}\n      .header__right{ display: none;}\n      .headerInner{ justify-content: center; align-items: center;}\n      .heroSection__inner{ padding: 0 12px 30px 12px; background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_mob_d9f0191293.png') top center no-repeat; background-size: 320px 167px;}\n      .heroContent{ flex-direction: column; margin-top: 40px;}\n      .heroContent__left{ width: 100%; display: flex; flex-direction: column;}\n      .heroContent__right{ width: 100%; padding: 20px 16px 30px 16px;}\n      .heroContent__left h1{ font-size: 28px; line-height: 32px; text-align: center;}\n      .heroContent__left .h1{ font-size: 28px; line-height: 32px; text-align: center;}\n      .heroContent__left p{ font-size: 14px; line-height: 18px; text-align: center;}\n      .exchange{ font-size: 15px; margin-left: auto; margin-right: auto; margin-bottom: 25px; padding: 15px 25px;}\n\n      .h2{ font-size: 30px; line-height: 34px;}\n      .h3{ font-size: 20px; line-height: 24px;}\n      .pageContainer{ padding: 0 12px; margin: 30px auto;}\n      .getForex{ box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16); border: solid 1px #e8e8e8; padding: 25px 12px; border-radius: 12px;}\n      .getForex__title{ display: none;}\n      .getForex__list{ grid-template-columns: 1fr;}\n      .getForex__listItem{ border: 0; padding: 0; border-radius: 0;}\n      .getForex__listItem:first-child{ border-bottom: 1px #f2f2f2 solid; padding-bottom: 15px;}\n      .getForex__listItemImg{ width: 64px;}\n      .getForex__listItemImg img{ width: 64px; height: unset;}\n      .getForex__listItemDesc p.desc{ margin-top: 5px; font-size: 12px; line-height: 18px;}\n      .getForex__listItemDesc p.desc span::after{ top: 6px;}\n      .getForex__listItemDesc p.title .arrow{ margin-left: auto;}\n      .deliveryBy{ display: flex;}\n      .planTrip p{ font-size: 16px; line-height: 24px;}\n      .description{ font-size: 16px; line-height: 24px;}\n      .separator{ margin: 30px 0;}\n      .convertCurrency{ padding: 30px 20px;}\n      .ccList__item p.heading{ font-size: 18px; line-height: 22px;}\n      .ccList__item p.desc{ font-size: 16px; line-height: 24px;}\n      .ccList__item{ padding: 16px 20px;}\n      .benifitsList li{ font-size: 16px;}\n      .forexServices{ display: flex; gap: unset; flex-wrap: nowrap; overflow-x: auto; padding: 6px 12px; margin: 20px -12px 0 -12px;}\n      .forexServices::-webkit-scrollbar{ display: none;}\n      .forexServices__item{ width: 258px; flex-shrink: 0; margin-right: 12px; padding: 20px 20px 20px 29px;}\n      .forexServices__itemHdr{ flex-direction: column; margin-bottom: 10px;}\n      .forexServices__itemImg{ margin-right: 0;}\n      .forexServices__itemImg img{ width: 102px; height: auto;}\n      .forexServices__itemTitle{ max-width: unset; font-size: 18px; line-height: 22px; margin-top: 10px;}\n      .conversionRate{ grid-template-columns: 1fr; gap: 26px; margin-top: 30px;}\n      .conversionTbl th{ padding: 14px 25px; }\n      .conversionTbl td{ padding: 14px 25px; font-size: 16px;}\n      .states{ margin-top: 30px;}\n      .capSulesList.grid5, .capSulesList.grid4{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n      .currencyList{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n      .capSulesList{ margin-top: 20px;}\n      .capSulesList li:nth-child(n+5), .currencyList li:nth-child(n+5){display: none;}\n      .viewMore{ text-align: center; margin-top: 20px;}\n      .faqList li{ border-radius: 6px; box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22); background-color: #fff; padding: 20px 10px; margin-bottom: 40px;}\n      .faqList li:last-child{ margin-bottom: 0;}\n      .faqList li:hover h4.question{ border-radius: unset; box-shadow: unset; background-color: unset;}\n      .faqList li h4.question{ padding: 0 60px 0 0; font-size: 18px; line-height: 22px;}\n      .faqList li h4.question::after{ padding: 4px; right: 10px; top: 5px;}\n      .faqList li.active h4.question::after{ top: 10px;}\n      .faqList li p.answer{ margin-bottom: unset; padding: 10px 0 0 0; font-size: 16px;}\n      .faqList li.active{ box-shadow: unset;}\n      .faqList li{ border-radius: 6px; box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22); background-color: #fff; padding: 20px 10px; margin-bottom: 40px;}\n      .faqList li:last-child{ margin-bottom: 0;}\n      .faqList li:hover h4.question{ border-radius: unset; box-shadow: unset; background-color: unset;}\n      .faqList li h4.question{ padding: 0 60px 0 0; font-size: 18px; line-height: 22px;}\n      .faqList li h4.question::after{ padding: 4px; right: 10px; top: 5px;}\n      .faqList li.active h4.question::after{ top: 10px;}\n      .faqList li p.answer{ margin-bottom: unset; padding: 10px 0 0 0; font-size: 16px;}\n      .pageContent{ margin-bottom: 0;}\n      footer{ padding: 30px 12px;}\n      .footernavCont{ grid-template-columns: repeat(2, 1fr);}\n      .footerBottom{ text-align: left;}\n  }\n\n\n  @media (min-width: 768px) and (max-width: 1280px) {\n      header{ padding: 10px 16px;}\n      .heroSection{ padding: 0 16px;}\n      .heroContent__left{ width: 48%;}\n      .heroContent__right{ width: 48%;}\n      .pageContainer{ margin: 30px auto; padding: 0 16px;}\n      .convertCurrency{ padding: 20px 30px;}\n      .forexServices__itemHdr{ flex-direction: column;}\n      .conversionRate{ gap: 30px;}\n      .capSulesList.grid5, .capSulesList.grid4, .currencyList{ grid-template-columns: repeat(3, 1fr);}\n      footer{ padding: 30px 16px;}\n      .faqList li h4.question{ padding-right: 50px;}\n  }\n\n  .sectionGapping{\n    margin-bottom:30px !important;\n  }"])));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/tripmoneyOld.styles.ts


var tripmoneyOld_styles_templateObject;


var TripMoneyOldStyles = (0,styled_components_browser_esm.createGlobalStyle)(tripmoneyOld_styles_templateObject || (tripmoneyOld_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)([".container {\n    width: 1100px;\n    margin: 0 auto;\n    font-size: 18px;\n    line-height: 22px;\n  }\n  \n  .container.negativeMargin {\n    margin-top: -358px;\n  }\n  \n  .greySection {\n    background-color: #f6f6f6;\n    padding: 60px 0;\n  }\n  .whiteSection {\n    background-color: #fff;\n    padding: 60px 0;\n  }\n  \n  .headerLogo {\n    flex-shrink: 0;\n    width: 150px;\n    height: 59px;\n  }\n  \n  header {\n    background-color: #fff;\n    height: 80px;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 1;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 0;\n  }\n  .topBlueSection {\n    background-color: #010101;\n    height: 450px;\n  }\n  \n  .tripmoney__breadCrumbs {\n    display: flex;\n    font-size: 14px;\n    font-weight: bold;\n    color: #fff;\n    margin-bottom: 32px;\n  }\n  .container .bannerText {\n    font-size: 40px;\n    line-height: 48px;\n    margin-bottom: 10px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container .bannerTextInfo {\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 600;\n    margin-bottom: 35px;\n    color: #4b4a4a;\n  }\n  .container h1 {\n    font-size: 36px;\n    line-height: 44px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container h2 {\n    font-size: 30px;\n    line-height: 44px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container h3 {\n    font-size: 24px;\n    line-height: 30px;\n    font-weight: 900;\n    color: #000;\n  }\n  .container h4 {\n    font-size: 22px;\n    line-height: 26px;\n    font-weight: 900;\n  }\n  .container__card {\n    border-radius: 8px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    padding: 46px 40px 40px;\n    flex: 1;\n    position: relative;\n  }\n  .containerImg {\n    position: absolute;\n    top: -48px;\n    left: 33px;\n    width: 81px;\n    height: 81px;\n  }\n  .forexSolImgWrap {\n    width: 392px;\n    height: 279px;\n    flex-shrink: 0;\n  }\n  .container__card--yellow {\n    background-color: #fffbec;\n    margin-bottom: 42px;\n  }\n  .container__card--blue {\n    background-color: #f0fdff;\n    display: flex;\n    margin-bottom: 34px;\n  }\n  .header__inner,.header__inner2 {\n    max-width: 1100px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .header__links {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n  }\n  .page__section {\n    width: 100%;\n  }\n  .baseHeaderContiner {\n    width: 1200px;\n    margin: 25px auto;\n    display: flex;\n  }\n  .baseLeft {\n    flex: 1;\n    flex-shrink: 0;\n  }\n  .baseLeft__cont {\n    max-width: 770px;\n  }\n  .baseRight {\n    width: 340px;\n    flex-shrink: 0;\n    margin-left: 10px;\n  }\n  .baseRight__item {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(165px, 1fr));\n    gap: 10px;\n  }\n  \n  .tripMoneySection {\n    border-bottom: solid 1px #979797;\n    margin-bottom: 50px;\n    padding-bottom: 50px;\n  }\n  \n  .tripMoneySection:last-child {\n    border: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n  \n  .forexSolList {\n    margin-bottom: 35px;\n  }\n  \n  .forexSolList li {\n    margin-bottom: 10px;\n    color: #696969;\n    display: flex;\n  }\n  \n  .countryList {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 20px;\n    margin-bottom: 35px;\n  }\n  \n  .countryList li {\n    border-radius: 6px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .currencyFacts__heaading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 60px;\n  }\n  .currencyFacts__list {\n    position: relative;\n  }\n  \n  .currencyFacts__list {\n    border-spacing: 12px;\n    position: relative;\n  }\n  \n  .currencyFacts__list::after {\n    content: '';\n    position: absolute;\n    background: #e9e2c6;\n    width: 1px;\n    height: 606px;\n    top: -10px;\n    left: 50%;\n  }\n  \n  .currencyFacts__list tr {\n    margin-bottom: 12px;\n  }\n  \n  .currencyFacts__list td {\n    border-bottom: solid 1px #e9e2c6;\n    padding-bottom: 12px;\n    font-size: 18px;\n    color: #2f2f2f;\n    align-items: center;\n    width: 50%;\n  }\n  \n  .currencyFacts__list tr:last-child td {\n    border-bottom: 0;\n    padding-bottom: 0;\n  }\n  \n  .currencyFacts__list span {\n    padding-left: 120px;\n    display: inline-block;\n  }\n  .currencyFacts__list li:last-child {\n    border: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n  \n  .tripMoneySection__bestRateBuy {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    margin-bottom: 45px;\n  }\n  \n  .tripMoneySection__bestRateBuy li {\n    background-image: url(https://tripmoneycmsimgak.mmtcdn.com/img/img_Bg_Path_85ccab3b71.png);\n    background-size: 353px 94px;\n    background-position: top left;\n    border-radius: 8px;\n    border: solid 1px #cad3dd;\n    background-color: #fff;\n    font-size: 16px;\n    color: #2f2f2f;\n    width: 353px;\n    height: 94px;\n    padding: 10px;\n    padding-left: 110px;\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  \n  .greenCheckImg {\n    width: 18px;\n    height: 18px;\n    margin-right: 12px;\n    margin-top: 3px;\n  }\n  \n  .tripmoneyImgWrap {\n    width: 228px;\n    flex-shrink: 0;\n    height: 48px;\n    margin-right: 75px;\n    align-self: center;\n    position: relative;\n  }\n  \n  .tripmoneyImgWrap::after {\n    content: '';\n    position: absolute;\n    top: -146px;\n    right: -33px;\n    width: 1px;\n    background: #d5d5d5;\n    height: 345px;\n  }\n  .countryImg {\n    border-radius: 50%;\n    margin-right: 8px;\n    object-fit: cover;\n  }\n  \n  .counterFietImgWrap {\n    width: 427px;\n    height: 579px;\n    flex-shrink: 0;\n    margin-left: 22px;\n  }\n  \n  .productRangeList {\n    padding-left: 32px;\n  }\n  \n  .productRangeList li {\n    position: relative;\n    margin-bottom: 20px;\n  }\n  \n  .productRangeList li::after {\n    content: '';\n    width: 7px;\n    height: 7px;\n    border-radius: 100%;\n    background: #000;\n    position: absolute;\n    top: 10px;\n    left: -32px;\n  }\n\n  .reviewedCurrencies {\n    background-color: #e0e0e0;\n    padding: 46px 0;\n  }\n\n  .reviewedCurrencies .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n  }\n\n  .footerLink{\n    padding:6px 0;\n  }\n\n  .footerLinkCol{\n        margin-left: 26px;\n  }\n\n  .footerLinkCol:first-child{\n    margin-left: 0;\n  }\n\n  .reviewedCurrencies h3{\n    font-size:28px;\n    margin-bottom: 16px;\n  }\n  \n  .quickfactsImg {\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    margin-right: 18px;\n  }\n  \n  .stepCount {\n    color: #fff;\n    position: absolute;\n    top: 14px;\n    left: 16px;\n    font-size: 42px;\n    line-height: 50px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .currencyLogoImg {\n    width: 104px;\n    height: 58px;\n    flex-shrink: 0;\n    margin-right: 16px;\n  }\n  .documentList {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    grid-column-gap: 28px;\n  }\n  \n  .documentList li {\n    display: flex;\n  }\n  \n  footer {\n    background-color: #16223e;\n    padding: 46px 0 46px;\n  }\n  \n  footer .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    color: #fff;\n    font-size: 16px;\n  }\n  \n  footer a {\n    font-size: 16px;\n    color: #fff;\n  }\n  \n  footer .linkTitle {\n    margin-bottom: 20px;\n    font-size: 20px;\n    line-height: 20px;\n  }\n  .counterFietImgWrapMweb {\n    display: none;\n  }\n  .exchangeRateWrap {\n    display: flex;\n    gap: 20px;\n  }\n  .container__cardAlign {\n    display: flex;\n  }\n  .container__card .primaryBtn {\n    width: 250px;\n    color: \"#fff\";\n  }\n  .refreshBtn{\n    cursor: pointer;\n  }\n  .forexSolImgWrapMweb {\n    display: none;\n  }\n\n  .capSulesList{\n    display: grid;\n    margin-top: 30px;\n    gap: 15px;\n  }\n  .capSulesList.grid5{\n      grid-template-columns: repeat(5, 1fr);\n  }\n  .capSulesList.grid4{\n      grid-template-columns: repeat(4, 1fr);\n  }\n  .capSulesList li{\n      padding: 19px;\n      border-radius: 6px;\n      cursor: pointer;\n      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n      background-color: #fff;\n      font-size: 16px;\n      font-weight: 700;\n      color: #005cbc;\n      text-align: center;\n  }\n  .viewMore{\n      margin-top: 30px;\n  }\n  .viewMore__cta{\n      font-size: 16px;\n      font-weight: 700;\n      color: #005cbc;\n  }\n  .capSulesList li:nth-child(n+5){\n      display: none;\n  }\n  .capSulesList.showAll li:nth-child(n+5){\n      display: block;\n  }\n  \n  @media only screen and (max-width: 768px) {\n    header{\n      padding: 20px;\n    }\n    .tripmoney__breadCrumbs {\n      margin-bottom: 24px;\n    }\n    .container {\n      width: 100%;\n      margin: unset;\n      padding: 16px;\n      font-size: 16px;\n      line-height: 20px;\n    }\n    .container .bannerText {\n      font-size: 25px;\n      line-height: 30px;\n      text-align: center;\n    }\n    .container__card {\n      padding: 60px 22px 22px;\n    }\n    .container__card--yellow {\n      padding-top: 24px;\n    }\n    .container__card--blue {\n      padding: 22px;\n    }\n    .whiteSection,\n    .greySection {\n      padding: 30px 0;\n    }\n    .forexSolList {\n      font-size: 14px;\n      line-height: 20px;\n    }\n    .countryList {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    .tripMoneySection__bestRateBuy {\n      display: flex;\n      flex-direction: column;\n    }\n    .documentList {\n      display: flex;\n      flex-direction: column;\n    }\n    .container h1 {\n      font-size: 30px;\n      line-height: 36px;\n    }\n    .container h2 {\n      font-size: 22px;\n      line-height: 27px;\n    }\n    .container h3 {\n      font-size: 18px;\n      line-height: 22px;\n    }\n    .currencyFacts__heaading {\n      margin-bottom: 30px;\n    }\n    .currencyFacts__list span {\n      padding-left: 0;\n    }\n    .currencyFacts__list li {\n      font-size: 16px;\n      line-height: 20px;\n    }\n    .currencyFacts__list::before,\n    .currencyFacts__list::after {\n      position: static;\n    }\n    .counterFietImgWrap {\n      display: none;\n    }\n    .counterFietImgWrapMweb {\n      width: 330px;\n      height: 448px;\n      flex-shrink: 0;\n      display: inline-block;\n      margin-bottom: 20px;\n    }\n    .forexSolImgWrap {\n      display: none;\n    }\n    .header__links {\n      display: none;\n    }\n    .exchangeRateWrap {\n      flex-direction: column;\n      gap: 60px;\n    }\n    .container__cardAlign {\n      flex-direction: column;\n    }\n    .container .bannerTextInfo {\n      font-size: 14px;\n      line-height: 20px;\n      text-align: center;\n    }\n    .container__card .primaryBtn {\n      width: 100%;\n    }\n    .tripMoneySection {\n      padding-bottom: 30px;\n      margin-bottom: 30px;\n    }\n    .currencyLogoImg {\n      width: 70px;\n      height: 40px;\n    }\n    .forexSolImgWrapMweb {\n      display: flex;\n      align-items: center;\n      width: 224px;\n      height: 160px;\n      flex-shrink: 0;\n      margin: 0 auto;\n      margin-bottom: 44px;\n    }\n    .containerImg {\n      top: -40px;\n    }\n    .tripmoneyImgWrap {\n      position: static;\n      margin-bottom: 38px;\n    }\n    .tripmoneyImgWrap::after {\n      content: none;\n    }\n    .container h4 {\n      font-size: 18px;\n      line-height: 22px;\n    }\n    .tripMoneySection__bestRateBuy li {\n      width: 100%;\n      background-repeat: no-repeat;\n    }\n    .capSulesList.grid5, .capSulesList.grid4{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n    .currencyList{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n    .capSulesList{ margin-top: 20px;}\n    .viewMore{ text-align: center; margin-top: 20px;}\n  }\n  @media only screen and (max-width: 550px){\n    footer .container{\n      flex-direction: column;\n    }\n    footer .item{\n      margin-bottom: 50px;\n    }\n\n    .reviewedCurrencies .container{\n      flex-direction: column;\n    }\n\n    .reviewedCurrencies h3{\n      margin-bottom: 0;\n      line-height:1.3;\n    }\n\n    .footerLinkCol{\n      margin-left:0;\n    }\n  }\n  \n  .heroSection{\n      background: #000;\n  }\n  .heroSection__inner{\n      max-width: 1200px;\n      margin: 0 auto;\n      background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_4567e802ae.png') top right no-repeat;\n      background-size: 557px 155px;\n      padding: 20px 0 80px 0;\n  }\n  .heroSection__inner.heroPadding {\n    padding: 0 16px 200px 16px;\n  }\n\n  .heroSection .heroSection_info {\n    padding: 38px 0 0;\n  }\n\n  .heroPadding h2{\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n  }\n\n  .heroPadding p{\n    font-size: 22px;\n    line-height: 52px;\n    font-weight: 600;\n    line-height: 30px;\n    color: #fff;\n    margin-top: 10px;\n  }\n\n  .pageContainer.pageContainer_margin {\n    margin: 0 auto;\n    margin-top: -170px;\n  }\n\n  .separator {\n    height: 1px;\n    background-color: #979797;\n    margin: 50px 0;\n  }\n\n  .faqList{\n      margin-top: 50px;\n  }\n  .faqList li h4.question{\n      font-size: 24px;\n      line-height: 26px;\n      font-weight: 900;\n      color: #000;\n      padding: 30px;\n      cursor: pointer;\n      transition: all 0.3s ease-in-out;\n      position: relative;\n  }\n  .faqList li h4.question::after{\n      content: \"\";\n      border: solid #2f2f2f;\n      display: inline-block;\n      border-width: 0 3px 3px 0;\n      padding: 6px;\n      transform: rotate(45deg);\n      position: absolute;\n      right: 40px;\n      top: 32px;\n  }\n  .faqList li p.answer{\n      font-size: 18px;\n      line-height: 24px;\n      color: #000;\n      padding: 0 0 0 30px;\n      margin-bottom: 30px;\n  }\n  .faqList li p.answer span{\n      font-weight: 900;\n  }\n  .faqList li:hover h4.question{\n      border-radius: 6px;\n      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n      background-color: #fff;\n  }\n  .faqList li.active h4.question::after{\n      transform: rotate(-135deg);\n      top: 42px;\n  }\n\n  @media (min-width: 320px) and (max-width: 767px) {\n    .heroPadding h2{\n        font-size: 24px;\n        line-height: 28px;\n    }\n    .heroPadding p{\n        font-size: 16px;\n        line-height: 20px;\n    }\n  }\n\n  @media (min-width: 320px) and (max-width: 767px) {\n      body{ background-color: #ffffff;}\n      .header__right{ display: none;}\n      .headerInner{ justify-content: center; align-items: center;}\n      .heroSection__inner{ padding: 0 12px 30px 12px; background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_mob_d9f0191293.png') top center no-repeat; background-size: 320px 167px;}\n      .heroContent{ flex-direction: column; margin-top: 40px;}\n      .heroContent__left{ width: 100%; display: flex; flex-direction: column;}\n      .heroContent__right{ width: 100%; padding: 20px 16px 30px 16px;}\n      .heroContent__left h1{ font-size: 28px; line-height: 32px; text-align: center;}\n      .heroContent__left .h1{ font-size: 28px; line-height: 32px; text-align: center;}\n      .heroContent__left p{ font-size: 14px; line-height: 18px; text-align: center;}\n      .exchange{ font-size: 15px; margin-left: auto; margin-right: auto; margin-bottom: 25px; padding: 15px 25px;}\n\n      .h2{ font-size: 30px; line-height: 34px;}\n      .h3{ font-size: 20px; line-height: 24px;}\n      .pageContainer{ padding: 0 12px; margin: 30px auto;}\n      .getForex{ box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16); border: solid 1px #e8e8e8; padding: 25px 12px; border-radius: 12px;}\n      .getForex__title{ display: none;}\n      .getForex__list{ grid-template-columns: 1fr;}\n      .getForex__listItem{ border: 0; padding: 0; border-radius: 0;}\n      .getForex__listItem:first-child{ border-bottom: 1px #f2f2f2 solid; padding-bottom: 15px;}\n      .getForex__listItemImg{ width: 64px;}\n      .getForex__listItemImg img{ width: 64px; height: unset;}\n      .getForex__listItemDesc p.desc{ margin-top: 5px; font-size: 12px; line-height: 18px;}\n      .getForex__listItemDesc p.desc span::after{ top: 6px;}\n      .getForex__listItemDesc p.title .arrow{ margin-left: auto;}\n      .deliveryBy{ display: flex;}\n      .planTrip p{ font-size: 16px; line-height: 24px;}\n      .description{ font-size: 16px; line-height: 24px;}\n      .separator{ margin: 30px 0;}\n      .convertCurrency{ padding: 30px 20px;}\n      .ccList__item p.heading{ font-size: 18px; line-height: 22px;}\n      .ccList__item p.desc{ font-size: 16px; line-height: 24px;}\n      .ccList__item{ padding: 16px 20px;}\n      .benifitsList li{ font-size: 16px;}\n      .forexServices{ display: flex; gap: unset; flex-wrap: nowrap; overflow-x: auto; padding: 6px 12px; margin: 20px -12px 0 -12px;}\n      .forexServices::-webkit-scrollbar{ display: none;}\n      .forexServices__item{ width: 258px; flex-shrink: 0; margin-right: 12px; padding: 20px 20px 20px 29px;}\n      .forexServices__itemHdr{ flex-direction: column; margin-bottom: 10px;}\n      .forexServices__itemImg{ margin-right: 0;}\n      .forexServices__itemImg img{ width: 102px; height: auto;}\n      .forexServices__itemTitle{ max-width: unset; font-size: 18px; line-height: 22px; margin-top: 10px;}\n      .conversionRate{ grid-template-columns: 1fr; gap: 26px; margin-top: 30px;}\n      .conversionTbl th{ padding: 14px 25px; }\n      .conversionTbl td{ padding: 14px 25px; font-size: 16px;}\n      .states{ margin-top: 30px;}\n      .capSulesList.grid5, .capSulesList.grid4{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n      .currencyList{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n      .capSulesList{ margin-top: 20px;}\n      .capSulesList li:nth-child(n+5), .currencyList li:nth-child(n+5){display: none;}\n      .viewMore{ text-align: center; margin-top: 20px;}\n      .faqList li{ border-radius: 6px; box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22); background-color: #fff; padding: 20px 10px; margin-bottom: 40px;}\n      .faqList li:last-child{ margin-bottom: 0;}\n      .faqList li:hover h4.question{ border-radius: unset; box-shadow: unset; background-color: unset;}\n      .faqList li h4.question{ padding: 0 60px 0 0; font-size: 18px; line-height: 22px;}\n      .faqList li h4.question::after{ padding: 4px; right: 10px; top: 5px;}\n      .faqList li.active h4.question::after{ top: 10px;}\n      .faqList li p.answer{ margin-bottom: unset; padding: 10px 0 0 0; font-size: 16px;}\n      .faqList li.active{ box-shadow: unset;}\n      .faqList li{ border-radius: 6px; box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22); background-color: #fff; padding: 20px 10px; margin-bottom: 40px;}\n      .faqList li:last-child{ margin-bottom: 0;}\n      .faqList li:hover h4.question{ border-radius: unset; box-shadow: unset; background-color: unset;}\n      .faqList li h4.question{ padding: 0 60px 0 0; font-size: 18px; line-height: 22px;}\n      .faqList li h4.question::after{ padding: 4px; right: 10px; top: 5px;}\n      .faqList li.active h4.question::after{ top: 10px;}\n      .faqList li p.answer{ margin-bottom: unset; padding: 10px 0 0 0; font-size: 16px;}\n      .pageContent{ margin-bottom: 0;}\n      footer{ padding: 30px 12px;}\n      .footernavCont{ grid-template-columns: repeat(2, 1fr);}\n      .footerBottom{ text-align: left;}\n  }\n\n\n  @media (min-width: 768px) and (max-width: 1280px) {\n      header{ padding: 10px 16px;}\n      .heroSection{ padding: 0 16px;}\n      .heroContent__left{ width: 48%;}\n      .heroContent__right{ width: 48%;}\n      .pageContainer{ margin: 30px auto; padding: 0 16px;}\n      .convertCurrency{ padding: 20px 30px;}\n      .forexServices__itemHdr{ flex-direction: column;}\n      .conversionRate{ gap: 30px;}\n      .capSulesList.grid5, .capSulesList.grid4, .currencyList{ grid-template-columns: repeat(3, 1fr);}\n      footer{ padding: 30px 16px;}\n      .faqList li h4.question{ padding-right: 50px;}\n  }\n\n  .sectionGapping{\n    margin-bottom:30px !important;\n  }"])));
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/MMTLogo.tsx


var MMTLogo = function MMTLogo(_ref) {
  var _ref$isLight = _ref.isLight,
      isLight = _ref$isLight === void 0 ? true : _ref$isLight;
  var MMTColor = isLight ? "white" : "#124680";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "140",
    height: "40",
    viewBox: "0 0 63 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "27.0926",
      y: "3.14044",
      width: "17.3509",
      height: "16.304",
      rx: "4.53892",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask0_172_2743",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: "25",
      y: "0",
      width: "21",
      height: "20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45.5265 20V0H25.6676V20H45.5265Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask0_172_2743)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M43.8871 6.84148C42.9433 8.46755 41.2573 11.9636 41.2573 11.9636C41.2573 11.9636 40.408 13.8509 40.049 15.7795C39.8893 16.6371 40.1976 17.6333 40.1976 17.6333C40.4283 18.617 39.3355 18.3467 39.3355 18.3467C38.5374 18.083 38.5595 17.011 38.5595 17.011C38.5595 15.4286 39.2597 13.8991 39.6699 12.8754C38.2284 13.447 37.5542 12.0377 37.9645 10.6146L36.3167 12.8499C35.7864 13.4766 35.264 13.3539 35.264 13.3539C35.2375 13.3539 34.6035 13.2762 34.6356 12.4255C34.6511 12.0136 34.7663 10.2952 34.8982 9.65696C34.9116 9.59017 34.8721 9.52374 34.8189 9.60362C34.1318 10.8267 33.0058 12.1597 32.7819 12.5292C32.4915 13.0084 32.2001 13.207 32.2001 13.207C31.966 13.3967 31.5592 13.2533 31.5592 13.2533C31.1424 13.0978 31.2276 12.6237 31.2276 12.6237L31.6223 9.75993C31.6223 9.72065 31.6093 9.70696 31.5695 9.70696C31.4507 9.70696 30.3334 11.264 29.717 12.3502L29.3133 13.0066C29.3133 13.0066 28.9647 13.5567 28.4265 13.2258C28.0055 12.9668 28.1378 12.4829 28.1378 12.4829L29.2923 7.596C29.2923 7.58267 29.2923 7.50291 29.2259 7.50291C28.869 7.50291 28.7674 8.43886 28.2794 8.45696C28.0338 8.466 27.9073 8.36029 27.9073 8.36029C27.5743 8.16767 27.7323 7.66815 27.7323 7.66815C27.7323 7.66815 28.2597 6.26422 28.9586 5.91136C28.9586 5.91136 29.3618 5.65695 29.6977 5.70243C30.0337 5.74791 30.5712 5.82898 30.2891 7.37005L29.9365 9.37458C29.9365 9.37458 29.9013 9.54993 29.9559 9.57791C29.9559 9.57791 30.043 9.66505 30.2185 9.4297L32.4542 6.35469C32.9357 5.64291 33.5035 6.00195 33.5035 6.00195C33.8816 6.16338 33.7519 6.62969 33.7519 6.62969C33.7519 6.62969 32.6499 10.0331 32.6499 10.3522C32.6499 10.4586 32.7427 10.4849 32.7953 10.4056C33.2578 9.70065 34.2362 8.17124 35.0562 7.14743C35.426 6.69541 35.6379 6.49576 36.0474 6.53576C36.4439 6.57564 36.6291 6.82826 36.6291 7.22719C36.6291 7.29374 36.6157 7.3735 36.6029 7.45338C36.6029 7.45338 35.8757 9.96672 35.8224 11.3097C35.8224 11.3097 35.8112 11.5028 35.8621 11.5418C35.9601 11.6171 36.081 11.4477 36.081 11.4477C36.4879 10.9967 37.7893 8.92755 38.0834 8.3841L39.0249 6.45719C39.0249 6.45719 39.4244 5.58052 39.9581 5.71683C39.9581 5.71683 40.8071 5.80303 40.3969 6.73255C40.3297 6.88469 39.6833 7.94148 39.1277 10.1229C39.0353 10.4549 38.9161 11.426 39.5108 11.426C39.7753 11.426 40.1193 11.2128 40.4762 10.5611L42.8159 6.33267C43.0141 6.11957 43.171 6.00195 43.4483 6.00195C44.3147 6.00195 43.8871 6.84148 43.8871 6.84148ZM45.5253 4.5281C45.5253 2.0306 43.5237 0 41.056 0H30.1372C27.6687 0 25.6674 2.0306 25.6674 4.5281L25.6697 15.4693C25.6697 17.9661 27.6707 20 30.139 20H41.0577C43.526 20 45.5262 17.9667 45.5262 15.4693L45.5253 4.5281Z",
        fill: "#EB2226"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask1_172_2743",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: "-1",
      y: "7",
      width: "9",
      height: "6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-0.000244141 12.5065H7.50101V7.41058H-0.000244141V12.5065Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask1_172_2743)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.36949 12.5065H3.13143V9.70321C3.13143 9.3038 3.06823 9.00547 2.94242 8.8088C2.8165 8.61213 2.6037 8.51356 2.30321 8.51356C2.0845 8.51356 1.88425 8.56785 1.70247 8.67666C1.52009 8.78582 1.36552 8.9407 1.23794 9.14154V12.5065H-0.000244141V7.41546H0.704888L1.17036 8.10023C1.27037 8.00868 1.42209 7.89332 1.54494 7.81344C1.66791 7.73356 1.79762 7.66332 1.93431 7.60356C2.07065 7.54392 2.21433 7.49725 2.36452 7.46237C2.5147 7.42773 2.6688 7.41058 2.82668 7.41058C3.00835 7.41058 3.16871 7.42987 3.30635 7.46915C3.4447 7.50785 3.56672 7.56463 3.67288 7.63975C3.77904 7.71439 3.87195 7.80427 3.95077 7.90963C4.02971 8.01558 4.09918 8.13487 4.1599 8.26808C4.25706 8.17047 4.36701 8.07082 4.49009 7.96832C4.61294 7.86594 4.74881 7.77356 4.89757 7.6907C5.04634 7.60796 5.20848 7.54058 5.38447 7.48856C5.56069 7.43654 5.75147 7.41058 5.95823 7.41058C6.23707 7.41058 6.47424 7.46785 6.67047 7.58201C6.86622 7.69654 7.0254 7.85487 7.14848 8.05737C7.27133 8.25987 7.36033 8.50094 7.41667 8.78023C7.47276 9.05975 7.50105 9.3644 7.50105 9.69392V12.5065H6.26287V9.70321C6.26287 9.3038 6.20073 9.00547 6.07623 8.8088C5.95196 8.61213 5.74378 8.51356 5.45299 8.51356C5.2344 8.51356 5.03391 8.56475 4.85165 8.66689C4.66975 8.76916 4.50915 8.92689 4.36949 9.14154V12.5065Z",
        fill: MMTColor
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5853 10.1924H10.4746C10.1774 10.1924 9.9602 10.2628 9.82339 10.3777C9.68705 10.4921 9.61876 10.6524 9.61876 10.8572C9.61876 11.0528 9.67652 11.2036 9.79191 11.3096C9.90718 11.4151 10.0832 11.4687 10.3195 11.4687C10.4625 11.4687 10.598 11.4494 10.7272 11.4113C10.8564 11.3727 10.9753 11.3215 11.0845 11.2564C11.1935 11.1913 11.2906 11.1144 11.3758 11.0243C11.4604 10.9345 11.5304 10.8396 11.5853 10.74V10.1924ZM11.5856 11.946C11.4425 12.1026 11.2181 12.2487 10.9646 12.3542C10.7111 12.459 10.4083 12.512 10.0566 12.512C9.81079 12.512 9.58924 12.4724 9.3916 12.3929C9.19442 12.3141 9.02577 12.2029 8.88458 12.0596C8.74351 11.9162 8.63486 11.7473 8.55876 11.5517C8.48314 11.3559 8.44538 11.1423 8.44538 10.9099C8.44538 9.96136 9.17442 9.3585 10.3427 9.3585H11.5763V9.07707C11.5763 8.90326 11.4894 8.76648 11.3148 8.66743C11.1406 8.56838 10.8728 8.51826 10.5115 8.51826C10.1747 8.51826 9.86287 8.55398 9.57634 8.62505C9.28981 8.69564 9.13087 8.75552 8.88506 8.85743L8.73203 7.79481C8.8228 7.75457 8.93382 7.71219 9.06436 7.66743C9.19442 7.62255 9.34059 7.58124 9.50119 7.54255C9.66203 7.50469 9.83648 7.47267 10.0247 7.4479C10.2125 7.42267 10.4101 7.41052 10.6163 7.41052C11.3324 7.41052 11.8702 7.58671 12.23 7.93993C12.5892 8.29243 12.7691 8.79398 12.7691 9.4441V12.5065H11.8869L11.5856 11.946Z",
      fill: MMTColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.623 7.34006L16.6043 9.88685L18.9004 12.507H17.3438L15.2206 9.92197V12.507H13.9827V5.5191H15.2206V9.92197L17.1117 7.34006H18.623Z",
      fill: MMTColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.3727 8.50879C21.209 8.50879 21.0602 8.52903 20.9264 8.56998C20.793 8.61082 20.6762 8.66915 20.5762 8.74379C20.4762 8.81891 20.3939 8.90939 20.3301 9.01546C20.2666 9.12236 20.2227 9.23939 20.1983 9.36737H22.3969C22.3969 9.25272 22.3763 9.14308 22.3351 9.0382C22.2944 8.93308 22.2314 8.84189 22.1462 8.76451C22.0615 8.68641 21.9544 8.62451 21.8257 8.5782C21.6965 8.53201 21.5458 8.50879 21.3727 8.50879ZM21.6056 11.4143C21.824 11.4143 22.0222 11.3965 22.1996 11.3618C22.3771 11.3272 22.5388 11.281 22.6842 11.2246C22.8301 11.1678 22.9622 11.1018 23.0803 11.0274C23.1986 10.9524 23.1574 10.988 23.2544 10.911L23.4933 12.011C23.2746 12.1511 22.9657 12.2752 22.6545 12.3697C22.3436 12.4646 21.9897 12.5124 21.5921 12.5124C21.1582 12.5124 20.774 12.4511 20.4406 12.3293C20.1067 12.2072 19.825 12.036 19.5957 11.8144C19.3671 11.5929 19.1929 11.3272 19.0748 11.0159C18.9567 10.7046 18.8972 10.3596 18.8972 9.9811C18.8972 9.63134 18.9513 9.30074 19.0589 8.98943C19.1666 8.67801 19.3245 8.40562 19.5322 8.17134C19.7401 7.93693 19.9972 7.75181 20.3037 7.61539C20.6105 7.47931 20.964 7.41098 21.3644 7.41098C21.7682 7.41098 22.1159 7.47574 22.4092 7.60515C22.7015 7.73467 22.9431 7.90705 23.1324 8.12217C23.3224 8.33789 23.4625 8.58515 23.554 8.86455C23.645 9.14384 23.6784 9.43348 23.6784 9.73336C23.6784 9.8142 23.6736 9.90717 23.6645 10.0115C23.6554 10.1159 23.6436 10.2044 23.6282 10.2762H20.1766C20.1946 10.4523 20.2402 10.6106 20.3129 10.7502C20.3856 10.8902 20.4836 11.0091 20.6065 11.1072C20.7295 11.2053 20.875 11.281 21.0433 11.3342C21.2117 11.3878 21.3993 11.4143 21.6056 11.4143Z",
      fill: MMTColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M46.7415 8.13785L48.4142 6.13535H48.7809V7.41559H50.21V8.52392H48.7809V10.6104C48.7809 10.7554 48.7982 10.8764 48.8332 10.9733C48.8677 11.0695 48.9161 11.1464 48.9769 11.2048C49.0372 11.2625 49.107 11.3032 49.1857 11.3279C49.2648 11.3519 49.3485 11.3638 49.4362 11.3638C49.6 11.3638 49.745 11.3481 49.8706 11.3163C49.9969 11.2849 50.1087 11.2449 50.2056 11.1974V12.3069C50.0718 12.3739 49.9315 12.4246 49.7845 12.4595C49.6373 12.4949 49.4575 12.5121 49.245 12.5121C48.9447 12.5121 48.6866 12.4765 48.4714 12.4048C48.256 12.333 48.0798 12.2296 47.9437 12.0931C47.8063 11.9562 47.7056 11.7901 47.6406 11.5952C47.5755 11.4004 47.5424 11.1794 47.5424 10.9323V8.52392H46.7415V8.13785Z",
      fill: MMTColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M52.3236 8.46451C52.4906 8.15939 52.7896 7.86558 53.0369 7.68344C53.2839 7.50154 53.581 7.41058 53.9264 7.41058C54.0447 7.41058 54.1416 7.41654 54.2158 7.42832C54.2901 7.44011 54.3468 7.45154 54.3864 7.46165C54.3864 7.46165 54.3468 7.74963 54.1588 8.62904C54.0825 8.61213 53.9918 8.60356 53.8854 8.60356C53.6517 8.60356 53.4436 8.64392 53.2597 8.72523C53.0761 8.80654 52.9206 8.92368 52.7935 9.07594C52.6662 9.22856 52.5681 9.41594 52.4998 9.63666C52.4311 9.85761 52.3972 10.1077 52.3972 10.3868V12.5065H51.159V7.41535H51.9524L52.3236 8.46451Z",
      fill: MMTColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask2_172_2743",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: "57",
      y: "7",
      width: "6",
      height: "8",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M62.4801 14.5638V7.41098L57.6013 7.41098V14.5638H62.4801Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask2_172_2743)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M60.0112 8.52375C59.8538 8.52375 59.7107 8.5472 59.5835 8.59435C59.4564 8.64113 59.3438 8.7022 59.2467 8.77768C59.1494 8.85232 59.0662 8.93816 58.9965 9.03375C58.9267 9.12899 58.87 9.22709 58.8282 9.32732V10.773C58.8762 10.8603 58.9397 10.943 59.0165 11.0213C59.094 11.0991 59.181 11.1677 59.2785 11.2271C59.3757 11.2864 59.4837 11.3338 59.6039 11.3701C59.7237 11.4057 59.8518 11.4235 59.9886 11.4235C60.1976 11.4235 60.3793 11.3892 60.5323 11.3203C60.6856 11.2521 60.8128 11.1559 60.9148 11.0328C61.0165 10.909 61.092 10.7609 61.14 10.5874C61.1886 10.4143 61.2127 10.2229 61.2127 10.0135C61.2127 9.79506 61.1841 9.59435 61.1261 9.41149C61.0687 9.22863 60.9871 9.07185 60.8806 8.94066C60.7739 8.80958 60.6477 8.70697 60.5005 8.63387C60.3529 8.5603 60.1903 8.52375 60.0112 8.52375ZM61.298 7.62461C61.567 7.76759 61.7891 7.95866 61.9648 8.19782C62.141 8.43699 62.2707 8.71271 62.3543 9.02604C62.4375 9.3383 62.4792 9.66354 62.4792 9.99997C62.4792 10.3435 62.4352 10.6664 62.3473 10.97C62.2592 11.2733 62.1267 11.5394 61.9492 11.7689C61.7716 11.9978 61.5508 12.1793 61.2865 12.3126C61.0229 12.446 60.7135 12.5124 60.3582 12.5124C60.0124 12.5124 59.7204 12.4618 59.482 12.3597C59.2439 12.2588 59.0351 12.1097 58.8564 11.9132L58.8382 11.9238V14.5638H57.6004V7.4158H58.3408L58.8137 8.03592C58.9931 7.85151 59.248 7.67235 59.4958 7.56782C59.7433 7.46318 60.0225 7.41092 60.3356 7.41092C60.7087 7.41092 61.03 7.4827 61.298 7.62461Z",
        fill: MMTColor
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55.6619 5.3201C55.3053 5.3201 55.0171 5.61058 55.0171 5.96903C55.0171 6.3276 55.3053 6.61831 55.6619 6.61831C56.0182 6.61831 56.307 6.3276 56.307 5.96903C56.307 5.61058 56.0182 5.3201 55.6619 5.3201ZM55.0413 12.5066H56.2793V7.41554H55.0413V12.5066Z",
      fill: MMTColor
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/index.tsx






/***/ }),

/***/ 2558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ CurrencySEOMarkdown; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 137 modules
var react_markdown = __webpack_require__(843);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 9 modules
var src = __webpack_require__(5537);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/index.ts + 632 modules
var ui_container = __webpack_require__(8573);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts
var ui_widgets_src = __webpack_require__(9666);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/constants/SeoConstants.ts
var API_BASE_URL = "https://forex.makemytrip.com/forex-client-backend/cb";
var API_ENDPOINT = {
  GET_FOREX_RATES: "".concat(API_BASE_URL, "/card-management/api/v1/forex-rate/PC_CN")
};
var PROGRAMS = {
  FOREX_BMF_MAKEMYTRIP: "FOREX_BMF_MAKEMYTRIP"
};
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOMarkdown/index.tsx



var _excluded = ["children", "className"],
    _excluded2 = ["children"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var CurrencySEOMarkdown = function CurrencySEOMarkdown(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  // Enhanced null check - handle empty, null, undefined, or whitespace-only content
  if (!children || typeof children === "string" && !children.trim()) {
    return null;
  }

  var _useContext = (0,react.useContext)(ui_container/* CurrencySEOContext */.c_),
      refreshBtn = _useContext.refreshBtn,
      currencyCode = _useContext.currencyCode,
      exchangeRateApi = _useContext.exchangeRateApi,
      inrRate = _useContext.inrRate,
      setInrRate = _useContext.setInrRate;

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var prevInrRate;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              prevInrRate = inrRate;
              setInrRate("...");
              setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                var _exchangeRateData$dat, controller, timeoutId, apiUrl, response, exchangeRateData;

                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        controller = new AbortController();
                        timeoutId = setTimeout(function () {
                          return controller.abort();
                        }, 3000);
                        apiUrl = "".concat(API_ENDPOINT, "?currency1={currency_code}&program=").concat(PROGRAMS.FOREX_BMF_MAKEMYTRIP);
                        _context.next = 6;
                        return fetch((0,src.t)(apiUrl, {
                          "{currency_code}": currencyCode
                        }), {
                          signal: controller.signal,
                          headers: _objectSpread({}, (0,ui_widgets_src.getRequestIdHeaders)())
                        });

                      case 6:
                        response = _context.sent;
                        clearTimeout(timeoutId);
                        _context.next = 10;
                        return response.json();

                      case 10:
                        exchangeRateData = _context.sent;

                        if (exchangeRateData !== null && exchangeRateData !== void 0 && exchangeRateData.success && (_exchangeRateData$dat = exchangeRateData.data) !== null && _exchangeRateData$dat !== void 0 && _exchangeRateData$dat[0]) {
                          setInrRate(exchangeRateData.data[0].card || exchangeRateData.data[0].currency);
                        } else {
                          setInrRate(prevInrRate);
                        }

                        _context.next = 18;
                        break;

                      case 14:
                        _context.prev = 14;
                        _context.t0 = _context["catch"](0);
                        setInrRate(prevInrRate);
                        console.error("Exchange Rate Not Found", _context.t0.message);

                      case 18:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 14]]);
              })), 1000);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var RefeshBtn = function RefeshBtn(_ref4) {
    var children = _ref4.children,
        props = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded2);

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [inrRate === "⚠️" ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        title: "Failed to get Exchange Rate",
        style: {
          cursor: "default"
        },
        children: inrRate
      }) : inrRate, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("button", _objectSpread(_objectSpread({
        onClick: handleClick,
        className: "font16 refreshBtn",
        title: "Get latest exchange rate"
      }, props), {}, {
        children: refreshBtn
      }))]
    });
  };

  return children ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, _objectSpread(_objectSpread({
    components: {
      code: RefeshBtn
    },
    className: className
  }, props), {}, {
    children: children
  })) : null;
};

/***/ }),

/***/ 290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Forex/Breadcrumb/style.ts


var _templateObject;


var CurrencyRatePageStyle = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n.breadCrumb{\n    display: flex;\n    margin-bottom:10px;\n}\n.breadCrumb li{\n    font-size: 14px;\n    font-weight: 700;\n}\n.breadCrumb li::after{\n    content: \"\";\n    display: inline-block;\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    padding: 2px;\n    transform: rotate(-45deg);\n    margin: 0 10px;\n}\n.breadCrumb li:last-child:after{\n    display: none;\n}\n.breadCrumb li a{\n    color: #fff;\n}\n.breadCrumb li:last-child a{\n    pointer-events: none;\n}"])));
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Forex/Breadcrumb/index.tsx





var BreadCrumb = function BreadCrumb(_ref) {
  var breadCrumbData = _ref.breadCrumbData;

  if (!breadCrumbData || !breadCrumbData.length) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageStyle, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "breadCrumb",
      children: breadCrumbData.map(function (item, index) {
        var _item$link;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.toLowerCase(),
            children: item.name
          })
        }, index);
      })
    })]
  });
};

/* harmony default export */ var Breadcrumb = (BreadCrumb);

/***/ }),

/***/ 6291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zs": function() { return /* binding */ SpanTagStyle; }
/* harmony export */ });
/* unused harmony exports H1TagStyle, H2TagStyle, H3TagStyle, H4TagStyle, H5TagStyle, H6TagStyle, ParaTagStyle, AnchorTagStyle, CliptextStyleComp */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);


var renderFont = function renderFont(fontSize) {
  switch (fontSize) {
    case "xxs":
      return "\n          font-size: 10px;\n          line-height: 16px;\n        ";

    case "xs":
      return "\n          font-size: 12px;\n          line-height: 16px;\n        ";

    case "sm":
      return "\n          font-size: 14px;\n          line-height: 20px;\n        ";

    case "md":
      return "\n        font-size: 16px;\n        line-height: 24px;\n      ";

    case "xlarge":
      return "\n        font-size: 22px;\n        line-height: 32px;\n      ";

    case "xxlarge":
      return "\n        font-size: 24px;\n        line-height: 32px;\n      ";

    case "xxxlarge":
      return "\n        font-size: 28px;\n        line-height: 32px;\n      ";

    default:
      return "\n      font-size: 14px;\n      line-height: 20px;\n    ";
  }
};

var renderFontWeight = function renderFontWeight(fontWeight) {
  switch (fontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "medium":
      return "\n        font-weight: 500;\n      ";

    case "semiBold":
      return "\n        font-weight: 600;\n      ";

    case "bold":
      return "\n        font-weight: 700;\n      ";

    case "black":
      return "\n      font-weight: 900;\n        ";

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var H1TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({
  displayName: "TextStylesstyle__H1TagStyle",
  componentId: "sc-1wnq3o4-0"
})(["font-size:56px;line-height:72px;font-weight:600;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);span{font-size:56px;line-height:72px;font-weight:600;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);}"]);
var H2TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "sc-1wnq3o4-1"
})(["font-size:48px;line-height:64px;font-weight:600;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);"]);
var H3TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "sc-1wnq3o4-2"
})(["font-size:40px;line-height:54px;font-weight:600;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);text-align:var(--textAlign,left);"]);
var H4TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "sc-1wnq3o4-3"
})(["font-size:32px;line-height:40px;font-weight:600;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);"]);
var H5TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "sc-1wnq3o4-4"
})(["font-size:24px;line-height:32px;margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);font-weight:var(--fontWeight,600);span{font-size:24px;line-height:32px;font-family:\"Raleway\";font-weight:var(--fontWeight,600);}"]);
var H6TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "sc-1wnq3o4-5"
})(["font-size:16px;line-height:25px;font-weight:var(--fontWeight,600);margin:var(--margin,0);font-family:\"Raleway\";color:var(--color,#000);"]);
var ParaTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "sc-1wnq3o4-6"
})(["font-family:\"Open Sans\";", " ", " margin:", ";text-align:", ";color:", ";flex-shrink:", ";"], function (p) {
  return p.fontSize ? "\n    ".concat(renderFont(p.fontSize), "\n  ") : "";
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.flexShrink && p.flexShrink;
});
var SpanTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "sc-1wnq3o4-7"
})(["font-family:\"Open Sans\";", " ", " color:", ";margin:", ";text-align:", ";flex-shrink:", ";align-self:", ";display:inline-block;cursor:", ";", " ", ""], function (p) {
  return p.fontSize && "\n    ".concat(renderFont(p.fontSize), "\n  ");
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.flexShrink && p.flexShrink;
}, function (p) {
  return p.alignSelf && p.alignSelf;
}, function (p) {
  return p.cursor && p.cursor;
}, function (p) {
  return p.lineHeight && "line-height:".concat(p.lineHeight, ";\n  ");
}, function (p) {
  return p.width && "\n    width:".concat(p.width, "\n  ");
});
var AnchorTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "sc-1wnq3o4-8"
})(["font-family:\"Open Sans\";", " ", " margin:", ";display:inline-block;color:", ";text-align:", ";flex-shrink:", ";"], function (p) {
  return p.fontSize && "\n    ".concat(renderFont(p.fontSize), "\n  ");
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.flexShrink && p.flexShrink;
});
var CliptextStyleComp = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "TextStylesstyle__CliptextStyleComp",
  componentId: "sc-1wnq3o4-9"
})(["background:linear-gradient( 92.2deg,#ffe2e8 0.47%,#fffcfc 25.07%,#8cc8ea 64.68% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;width:fit-content;font-weight:600;"]);

/***/ }),

/***/ 8863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Image/utils.ts
var generateSourceSetImageUrl = function generateSourceSetImageUrl(cdnUrlWidths, imgUrl, width) {
  var imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(function (width) {
    return "".concat(imgUrl, "?im=Resize=(").concat(width, ") ").concat(width, "w");
  }).join(",");
};
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx



var Image = function Image(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "lazy" : _ref$loading,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$cdnUrlWidths = _ref.cdnUrlWidths,
      cdnUrlWidths = _ref$cdnUrlWidths === void 0 ? [] : _ref$cdnUrlWidths,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? "" : _ref$sizes;

  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith(".svg")) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height
    });
  }

  var srcsetUrl = generateSourceSetImageUrl(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height
    })]
  });
};

/***/ }),

/***/ 1893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LandingButton_LandingButton; }
});

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingButton/LandingButton.style.ts


var SCLandingButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "LandingButtonstyle__SCLandingButton",
  componentId: "sc-37zw9z-0"
})(["background:linear-gradient( 91.91deg,", " 0.3%,", " 100% );box-shadow:0px 1px 7px ", ";border-radius:8px;font-weight:900;font-size:16px;line-height:20px;color:", ";width:fit-content;height:44px;border:none;outline:none;cursor:pointer;margin:", ";padding:", ";width:", ";flex-shrink:", ";font-family:\"Open Sans\";", " ", " ", ""], colors/* GRADIENT_COLOR.black */.oi.black, colors/* GRADIENT_COLOR.zinnwalditeBrown */.oi.zinnwalditeBrown, colors/* BLACK_COLOR.21 */.wC[21], colors/* TEXT_COLOR.white */.ou.white, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.customWidth;
}, function (props) {
  return props.flexShrink;
}, function (props) {
  return props.theme === "whiteBtn" && "\n    background: ".concat(colors/* BG_COLOR.white */.VR.white, ";\n  box-shadow: 0px 1px 7px ").concat(colors/* BLACK_COLOR.21 */.wC[21], ";\n  border-radius: 6px;\n  font-weight: 900;\n  font-size: 16px;\n  line-height: 20px;\n  color: ").concat(colors/* TEXT_COLOR.high */.ou.high, ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  }\n\t");
}, function (props) {
  return props.disableState && "\n  pointer-events:none;\n  background: #CBCBCB;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.3);\n  ";
}, function (props) {
  return props.background && "\n    background: ".concat(props.background, ";\n  ");
});
var LandingButtonStyle = styled_components_browser_esm["default"].button.withConfig({
  displayName: "LandingButtonstyle__LandingButtonStyle",
  componentId: "sc-37zw9z-1"
})(["background:var( --btnBg,linear-gradient(91.91deg,#000000 0.3%,#330e0e 100%) );box-shadow:0px 1px 7px rgba(0,0,0,0.21);border-radius:6px;font-weight:900;font-size:var(--btnFont,16px);line-height:20px;color:var(--btnColor,#fff);width:var(--customWidth,fit-content);height:var(--customHeight,44px);border:none;outline:none;cursor:pointer;margin:var(--btnMargin,unset);flex:var(--btnFlex,unset);flex-shrink:var(--btnFlexShrink,unset);border:var(--btnBorder);font-family:\"Open Sans\";display:flex;align-items:center;justify-content:center;position:relative;padding:var(--btnPadding,12px);text-transform:uppercase;", " ", ""], function (props) {
  return props.btnIcon && "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding:16px;\n  }\n\t";
}, function (props) {
  return props.disableState && "\n  pointer-events:none;\n  background: #CBCBCB;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.3);\n  ";
});
var ShimmerWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingButtonstyle__ShimmerWrap",
  componentId: "sc-37zw9z-2"
})(["position:absolute;width:68px;height:48px;z-index:12;top:-43px;animation:shimmmer 2.9s ease-in;animation-iteration-count:infinite;animation-fill-mode:backwards;@keyframes shimmmer{0%{transform:translateX(-311px);}100%{transform:translateX(311px);}}"]);
var BtnMainIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingButtonstyle__BtnMainIcon",
  componentId: "sc-37zw9z-3"
})(["display:flex;align-items:center;gap:8px;"]);
var LandingButtonWhiteStyle = (0,styled_components_browser_esm["default"])(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonWhiteStyle",
  componentId: "sc-37zw9z-4"
})(["background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;color:#008cff;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingButton/LandingButton.tsx



var LandingButton = function LandingButton(_ref) {
  var padding = _ref.padding,
      customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      theme = _ref.theme,
      disableState = _ref.disableState,
      handleClick = _ref.handleClick,
      flexShrink = _ref.flexShrink,
      background = _ref.background,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SCLandingButton, {
    id: id,
    onClick: handleClick,
    flexShrink: flexShrink,
    disableState: disableState,
    theme: theme,
    margin: margin,
    customWidth: customWidth,
    padding: padding,
    background: background,
    children: customTitle
  });
};

/* harmony default export */ var LandingButton_LandingButton = (LandingButton);

/***/ }),

/***/ 7583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LandingFooter_LandingFooter; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingFooter/LandingFooter.style.ts

var LandingFooter_style_LandingFooter = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingFooterstyle__LandingFooter",
  componentId: "sc-1ahd1n-0"
})(["background:#000;color:#fff;font-size:12px;line-height:16px;padding-top:32px;padding-bottom:64px;"]);
var LandingFooterSub = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterSub",
  componentId: "sc-1ahd1n-1"
})(["font-weight:900;font-size:14px;line-height:16px;color:#fff;display:flex;align-items:center;margin-bottom:14px;"]);
var IconMargin = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__IconMargin",
  componentId: "sc-1ahd1n-2"
})(["margin:0 16px 0 0;"]);
var LandingFooterWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterWrap",
  componentId: "sc-1ahd1n-3"
})(["margin:0 auto;width:1200px;"]);
var LandingFooterImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterImg",
  componentId: "sc-1ahd1n-4"
})(["width:325px;height:27px;margin-bottom:50px;"]);
var LandingFooterList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingFooterstyle__LandingFooterList",
  componentId: "sc-1ahd1n-5"
})(["margin-bottom:26px;margin:", ";li{line-height:16px;display:inline-block;}li:not(:first-child):before{content:\"\u2022\";display:inline-block;margin:0 10px;font-size:1.8em;line-height:16px;vertical-align:middle;}li a{font-family:\"Open Sans\";font-style:normal;font-weight:400;font-size:12px;color:#ffffff;}li a:hover{text-decoration:underline;}&:last-child{margin-bottom:100px;}", ""], function (props) {
  return props.margin;
}, function (props) {
  return props.flexWrap && "\nheight:198px;\nflex-wrap:wrap;\n    ";
});
var LandingFooterFlex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterFlex",
  componentId: "sc-1ahd1n-6"
})(["display:flex;gap:95px;margin-top:100px;"]);
var Flex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__Flex",
  componentId: "sc-1ahd1n-7"
})(["display:flex;"]);
var LandingFooterCopyRight = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterCopyRight",
  componentId: "sc-1ahd1n-8"
})(["font-family:\"Open Sans\";color:#fff;display:flex;flex-direction:column;align-items:flex-end;margin-left:auto;font-weight:900;font-size:12px;line-height:14px;align-self:center;& span:nth-child(2){font-weight:600;margin-top:3px;}"]);
// EXTERNAL MODULE: ../../libs/utility/src/lib/constants/index.ts + 2 modules
var constants = __webpack_require__(9753);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingFooter/LandingFooter.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var LandingFooter = function LandingFooter(_ref) {
  var mmtInitiativeLink = _ref.mmtInitiativeLink,
      cityIcon = _ref.cityIcon,
      blogIcon = _ref.blogIcon,
      quickLinkIcon = _ref.quickLinkIcon,
      otherIcon = _ref.otherIcon,
      followUsIcon = _ref.followUsIcon,
      downloadIcon = _ref.downloadIcon,
      cityTitle = _ref.cityTitle,
      blogTitle = _ref.blogTitle,
      quickLinkTitle = _ref.quickLinkTitle,
      otherTitle = _ref.otherTitle,
      cities = _ref.cities,
      blog = _ref.blog,
      quickLinks = _ref.quickLinks,
      others = _ref.others,
      followUsTitle = _ref.followUsTitle,
      downloadTitle = _ref.downloadTitle,
      copyRightTitle = _ref.copyRightTitle,
      contryName = _ref.contryName,
      twitterIcon = _ref.twitterIcon,
      fbIcon = _ref.fbIcon,
      linkedInIcon = _ref.linkedInIcon,
      playStoreIcon = _ref.playStoreIcon,
      appStoreIcon = _ref.appStoreIcon,
      faqRedirectionUrl = _ref.faqRedirectionUrl;

  var onOtherLinkHandler = function onOtherLinkHandler(_ref2) {
    var linkEvent = _ref2.linkEvent;
    if (linkEvent) (0,analytics/* pushEvent */.AB)(linkEvent);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooter_style_LandingFooter, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterWrap, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterImg, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, mmtInitiativeLink))
      }), cityIcon && cityTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, cityIcon))
        }), cityTitle]
      }), cities && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
        children: cities === null || cities === void 0 ? void 0 : cities.map(function (_ref3, index) {
          var text = _ref3.text,
              linkEvent = _ref3.linkEvent;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "aria-label": "others",
              href: "#",
              onClick: function onClick() {
                return onOtherLinkHandler({
                  linkEvent: linkEvent
                });
              },
              children: text
            })
          }, index);
        })
      }), blogIcon && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, blogIcon))
        }), blogTitle]
      }), blog && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
        children: blog === null || blog === void 0 ? void 0 : blog.map(function (_ref4, index) {
          var text = _ref4.text,
              linkEvent = _ref4.linkEvent;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "aria-label": "others",
              href: "#",
              onClick: function onClick() {
                return onOtherLinkHandler({
                  linkEvent: linkEvent
                });
              },
              children: text
            })
          }, index);
        })
      }), quickLinkTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, quickLinkIcon))
        }), quickLinkTitle]
      }), quickLinks && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
        children: quickLinks.map(function (_ref5, index) {
          var text = _ref5.text,
              linkEvent = _ref5.linkEvent,
              href = _ref5.href,
              _ref5$target = _ref5.target,
              target = _ref5$target === void 0 ? "_self" : _ref5$target;
          href = text === "FAQ" ? faqRedirectionUrl : href;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              id: (0,constants/* getElementUniqueIds */.QB)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, constants/* SectionNameMapping.FOOTER */.Rw.FOOTER, (0,constants/* getCamelCaseStr */.zh)(text)),
              "aria-label": "others",
              target: target,
              href: href,
              onClick: function onClick() {
                return onOtherLinkHandler({
                  linkEvent: linkEvent
                });
              },
              children: text
            })
          }, index);
        })
      }), otherIcon && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, otherIcon))
        }), otherTitle]
      }), others && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
        children: others.map(function (_ref6, index) {
          var text = _ref6.text,
              linkEvent = _ref6.linkEvent;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "aria-label": "others",
              href: "#",
              onClick: function onClick() {
                return onOtherLinkHandler({
                  linkEvent: linkEvent
                });
              },
              children: text
            })
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterFlex, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, followUsIcon))
            }), followUsTitle]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              id: (0,constants/* getElementUniqueIds */.QB)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, constants/* SectionNameMapping.FOOTER */.Rw.FOOTER, constants/* ElementNameMapping.TWITTER_Link */.vT.TWITTER_Link),
              "aria-label": "twitter",
              href: twitterIcon === null || twitterIcon === void 0 ? void 0 : twitterIcon.redirectionUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: function onClick() {
                return onOtherLinkHandler({
                  linkEvent: twitterIcon === null || twitterIcon === void 0 ? void 0 : twitterIcon.linkEvent
                });
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, twitterIcon === null || twitterIcon === void 0 ? void 0 : twitterIcon.iconProps))
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              id: (0,constants/* getElementUniqueIds */.QB)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, constants/* SectionNameMapping.FOOTER */.Rw.FOOTER, constants/* ElementNameMapping.FB_Link */.vT.FB_Link),
              "aria-label": "facebook",
              href: fbIcon === null || fbIcon === void 0 ? void 0 : fbIcon.redirectionUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: function onClick() {
                return onOtherLinkHandler({
                  linkEvent: twitterIcon === null || twitterIcon === void 0 ? void 0 : twitterIcon.linkEvent
                });
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, fbIcon === null || fbIcon === void 0 ? void 0 : fbIcon.iconProps))
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              id: (0,constants/* getElementUniqueIds */.QB)(constants/* PageNameMapping.LISTING_PAGE */.XH.LISTING_PAGE, constants/* SectionNameMapping.FOOTER */.Rw.FOOTER, constants/* ElementNameMapping.LINKEDIN_Link */.vT.LINKEDIN_Link),
              "aria-label": "linkedin",
              href: linkedInIcon === null || linkedInIcon === void 0 ? void 0 : linkedInIcon.redirectionUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: function onClick() {
                return onOtherLinkHandler({
                  linkEvent: twitterIcon === null || twitterIcon === void 0 ? void 0 : twitterIcon.linkEvent
                });
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, linkedInIcon === null || linkedInIcon === void 0 ? void 0 : linkedInIcon.iconProps))
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, downloadIcon))
            }), downloadTitle]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "aria-label": "googlePlay",
              href: playStoreIcon === null || playStoreIcon === void 0 ? void 0 : playStoreIcon.redirectionUrl,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconMargin, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, playStoreIcon))
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "aria-label": "appleStore",
              href: appStoreIcon === null || appStoreIcon === void 0 ? void 0 : appStoreIcon.redirectionUrl,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, appStoreIcon))
            })]
          })]
        }), copyRightTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterCopyRight, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [" ", copyRightTitle]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: contryName
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var LandingFooter_LandingFooter = (LandingFooter);

/***/ }),

/***/ 6440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I8": function() { return /* binding */ LandingHeaderWrap; },
/* harmony export */   "N2": function() { return /* binding */ LandingHeaderList; },
/* harmony export */   "Sx": function() { return /* binding */ LandingHeader; },
/* harmony export */   "Vh": function() { return /* binding */ TMLogo; }
/* harmony export */ });
/* unused harmony export ProductLinks */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);
/* harmony import */ var _tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2193);


var LandingHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "indexstyle__LandingHeader",
  componentId: "sc-3p476h-0"
})(["height:80px;position:fixed;top:0;width:100%;z-index:1;color:", ";z-index:40;& .displayNone{display:none;}", ""], function (p) {
  return p.isLight ? "".concat(_tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__/* .WHITE_COLOR[60] */ .Y[60]) : "#000";
}, function (props) {
  return props.forexHeader && "\n  background: ".concat(_tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__/* .BG_COLOR.primary */ .VR.primary, ";\n  color: ").concat(_tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__/* .BLACK_COLOR[60] */ .wC[60], ";\n  top:-80px;\n  ");
});
var LandingHeaderWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "indexstyle__LandingHeaderWrap",
  componentId: "sc-3p476h-1"
})(["width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:80px;position:relative;"]);
var TMLogo = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].a.withConfig({
  displayName: "indexstyle__TMLogo",
  componentId: "sc-3p476h-2"
})(["width:140px;height:40px;flex-shrink:0;"]);
var LandingHeaderList = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
  displayName: "indexstyle__LandingHeaderList",
  componentId: "sc-3p476h-3"
})(["margin-left:auto;display:flex;align-items:center;gap:32px;cursor:pointer;list-style-type:none;& li{position:relative;}& li a{color:inherit;font-weight:400;font-size:16px;line-height:22px;text-decoration:none;}& li:first-child{margin-right:16px;}"]);
var ProductLinks = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "indexstyle__ProductLinks",
  componentId: "sc-3p476h-4"
})(["background:", ";box-shadow:0px 2px 16px ", ";border-radius:6px;padding:24px 16px;position:absolute;top:35px;left:0;width:230px;display:flex;flex-direction:column;gap:24px;& a{width:100%;font-family:\"Open Sans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:", ";}"], _tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__/* .BG_COLOR.primary */ .VR.primary, _tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__/* .BLACK_COLOR[16] */ .wC[16], _tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__/* .TEXT_COLOR.medium */ .ou.medium);

/***/ }),

/***/ 8573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O$": function() { return /* reexport */ ActiveLink_ActiveLink; },
  "OJ": function() { return /* reexport */ CurrencyCityTemplate/* CurrencyCityTemplate */.O; },
  "iI": function() { return /* reexport */ CurrencyConverterPageTemplate; },
  "PT": function() { return /* reexport */ CurrencyPageTemplate; },
  "jP": function() { return /* reexport */ CurrencyRatePageTemplate; },
  "c_": function() { return /* reexport */ CurrencySEOContext; },
  "mf": function() { return /* reexport */ ErrorPage; },
  "Cs": function() { return /* reexport */ ErrorScreen_ErrorScreen; },
  "nz": function() { return /* reexport */ GlobalStyles; },
  "ax": function() { return /* reexport */ LandingPageDocument; },
  "j3": function() { return /* reexport */ RenderSection; }
});

// UNUSED EXPORTS: ErrorBoundary, ErrorImg, ErrorPageStyle, Footer, Header, NewRelicSnippet, componentMapper, currencyData

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/types/src/index.ts + 1 modules
var src = __webpack_require__(9707);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/componentMapper/index.tsx


var _componentMapper;



var LandingMoneyTransfer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7725).then(__webpack_require__.bind(__webpack_require__, 7725));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7725)];
    }
  }
});
var LandingMoneyTransferMobile = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6482).then(__webpack_require__.bind(__webpack_require__, 6482));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6482)];
    }
  }
});
var Header = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7055), __webpack_require__.e(1233)]).then(__webpack_require__.bind(__webpack_require__, 1233));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1233)];
    }
  }
});
var Hero = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5582), __webpack_require__.e(4429)]).then(__webpack_require__.bind(__webpack_require__, 863));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(863)];
    }
  }
});
var ForeignCurrencyForex = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9654), __webpack_require__.e(8829)]).then(__webpack_require__.bind(__webpack_require__, 8829));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8829)];
    }
  }
});
var ForexCardSection = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9654), __webpack_require__.e(9029)]).then(__webpack_require__.bind(__webpack_require__, 9029));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9029)];
    }
  }
});
var InsuranceSection = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4383).then(__webpack_require__.bind(__webpack_require__, 4383));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4383)];
    }
  }
});
var PrivacySection = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2211).then(__webpack_require__.bind(__webpack_require__, 2211));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2211)];
    }
  }
});
var TestimonialSection = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9963).then(__webpack_require__.bind(__webpack_require__, 9963));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9963)];
    }
  }
});
var LandingFaq = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1274).then(__webpack_require__.bind(__webpack_require__, 4809));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4809)];
    }
  }
});
var LandingFooter = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7583));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7583)];
    }
  }
});
var componentMapper_LandingHeaderMobile = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7055), __webpack_require__.e(9414)]).then(__webpack_require__.bind(__webpack_require__, 9414));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9414)];
    }
  }
});
var HeroMobile = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5582), __webpack_require__.e(8170)]).then(__webpack_require__.bind(__webpack_require__, 8170));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8170)];
    }
  }
});
var LandingCurrDel = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1029).then(__webpack_require__.bind(__webpack_require__, 1029));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1029)];
    }
  }
});
var LandingTrans = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4551).then(__webpack_require__.bind(__webpack_require__, 4551));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4551)];
    }
  }
});
var InsuranceMobileSection = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7345).then(__webpack_require__.bind(__webpack_require__, 7345));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7345)];
    }
  }
});
var TravelLoanSectionMobile = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2320).then(__webpack_require__.bind(__webpack_require__, 2320));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2320)];
    }
  }
});
var LandingPrivacyMobile = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9494).then(__webpack_require__.bind(__webpack_require__, 9494));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9494)];
    }
  }
});
var LandingTestimonialsMobile = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6000).then(__webpack_require__.bind(__webpack_require__, 6000));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6000)];
    }
  }
});
var LandingFaqMobile = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8113).then(__webpack_require__.bind(__webpack_require__, 8113));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8113)];
    }
  }
});
var LandingFooterMobile = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1122).then(__webpack_require__.bind(__webpack_require__, 1122));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1122)];
    }
  }
});
var AboutUs = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9276).then(__webpack_require__.bind(__webpack_require__, 9276));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9276)];
    }
  }
});
var componentMapper = (_componentMapper = {}, (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.HEADER, Header), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.HEADER_MOBILE, componentMapper_LandingHeaderMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.HERO, Hero), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.HERO_MOBILE, HeroMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FOREIGN_CURRENCY_FOREX, ForeignCurrencyForex), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FOREIGN_CURRENCY_FOREX_MOBILE, LandingCurrDel), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FOREX_CARD_SECTION, ForexCardSection), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FOREX_CARD_SECTION_MOBILE, LandingTrans), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.INSURANCE_SECTION, InsuranceSection), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.INSURANCE_SECTION_MOBILE, InsuranceMobileSection), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.TRAVEL_LOAN_MOBILE_SECTION, TravelLoanSectionMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.TRANSER_MONEY, LandingMoneyTransfer), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.TRANSFER_MONEY_MOBILE, LandingMoneyTransferMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.PRIVACY_SECTION, PrivacySection), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.PRIVACY_SECTION_MOBILE, LandingPrivacyMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.TESTIMONIALS_SECTION, TestimonialSection), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.TESTIMONIALS_MOBILE, LandingTestimonialsMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FAQS_SECTION, LandingFaq), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FAQS_SECTION_MOBILE, LandingFaqMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FOOTER, LandingFooter), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.FOOTER_MOBILE, LandingFooterMobile), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.ABOUT_US, AboutUs), (0,defineProperty/* default */.Z)(_componentMapper, src.COMPONENT_TYPE.ABOUT_US_MOBILE, AboutUs), _componentMapper);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/RenderSection/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var RenderSection = function RenderSection(_ref) {
  var component = _ref.component,
      className = _ref.className;
  var type = component.type,
      data = component.data;
  var Component = componentMapper[type];
  return Component ? /*#__PURE__*/(0,jsx_runtime.jsx)(Component, _objectSpread(_objectSpread({}, data), {}, {
    className: className
  })) : null;
};
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts
var ui_widgets_src = __webpack_require__(9666);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(4709);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Header404/index.style.ts


var index_style_LandingHeader = styled_components_browser_esm["default"].header.withConfig({
  displayName: "indexstyle__LandingHeader",
  componentId: "sc-18byzfg-0"
})(["height:80px;position:fixed;top:0;width:100%;z-index:1;color:", ";z-index:40;& .displayNone{display:none;}"], colors/* WHITE_COLOR.60 */.Y[60]);
var index_style_LandingHeaderWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingHeaderWrap",
  componentId: "sc-18byzfg-1"
})(["width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:80px;position:relative;"]);
var index_style_TMLogo = styled_components_browser_esm["default"].a.withConfig({
  displayName: "indexstyle__TMLogo",
  componentId: "sc-18byzfg-2"
})(["width:140px;height:40px;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Header404/index.tsx






var Header404_Header = function Header() {
  if (!(0,ui_widgets_src.isOnServer)()) {
    var toHome = function toHome() {
      window.location.href = "/";
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_LandingHeader, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_LandingHeaderWrap, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_TMLogo, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: (0,utils/* isHostMakemytrip */.Ho)() ? "https://tripmoneycmsimgak.mmtcdn.com/img/mmt_logo_007ad76964.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/gi_logo_1_dd53c8c777.svg",
            alt: "Blue mmt logo",
            onClick: toHome
          })
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

/* harmony default export */ var Header404 = (Header404_Header);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(9330);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/constants/constants.ts
var constants_RESPONSE_STATUS;

(function (RESPONSE_STATUS) {
  RESPONSE_STATUS["SUCCESS"] = "SUCCESS";
  RESPONSE_STATUS["ERROR"] = "ERROR";
})(constants_RESPONSE_STATUS || (constants_RESPONSE_STATUS = {}));

var constants_PARTNER;

(function (PARTNER) {
  PARTNER["MMT"] = "mmt";
  PARTNER["GI"] = "gi";
})(constants_PARTNER || (constants_PARTNER = {}));

var constants_CONTEXT;

(function (CONTEXT) {
  CONTEXT["INSURANCE"] = "insurance";
  CONTEXT["STANDALONE"] = "standalone";
  CONTEXT["STANDALONE_V2"] = "standalone_v2";
})(constants_CONTEXT || (constants_CONTEXT = {}));

var constants_PLATFORM;

(function (PLATFORM) {
  PLATFORM["WEB"] = "web";
})(constants_PLATFORM || (constants_PLATFORM = {}));

var constants_LOB;

(function (LOB) {
  LOB["STANDALONE"] = "standalone";
})(constants_LOB || (constants_LOB = {}));

var constants_ERROR_CODES;

(function (ERROR_CODES) {
  ERROR_CODES["DISPLAY_ERROR"] = "DISPLAY_ERROR";
})(constants_ERROR_CODES || (constants_ERROR_CODES = {}));

var constants_UTM_PARAMS;

(function (UTM_PARAMS) {
  UTM_PARAMS["UTM_SOURCE"] = "utm_source";
  UTM_PARAMS["UTM_MEDIUM"] = "utm_medium";
  UTM_PARAMS["UTM_CAMPAIGN"] = "utm_campaign";
  UTM_PARAMS["UTM_INS_CAMPAIGN"] = "utm_ins_campaign";
})(constants_UTM_PARAMS || (constants_UTM_PARAMS = {}));

var constants_DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM'yy";
  DATE_FORMATS["YYYY-MM-DD"] = "yyyy-MM-dd";
})(constants_DATE_FORMATS || (constants_DATE_FORMATS = {}));

var MONTHS_SHORT = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
var constants_STORAGE_KEYS;

(function (STORAGE_KEYS) {
  STORAGE_KEYS["TRAVELLER_DETAILS"] = "traveller-details";
})(constants_STORAGE_KEYS || (constants_STORAGE_KEYS = {}));

var constants_FORM_FIELDS_MAP = Object.freeze({
  name: "name",
  dob: "date of birth",
  gender: "gender",
  mobile: "mobile number",
  email: "email id",
  passport: "passport number"
});
var constants_GENDER_VALUES = [{
  id: "1",
  label: "Male",
  isSelected: false
}, {
  id: "2",
  label: "Female",
  isSelected: false
}, {
  id: "3",
  label: "Others",
  isSelected: false
}];
var TXN_SUCCESS_REDIRECT_TIME = 5000;
var TXN_FAILURE_REDIRECT_TIME = 5000;
var constants_PASSPORT_DETAILS_PAGE_ID;

(function (PASSPORT_DETAILS_PAGE_ID) {
  PASSPORT_DETAILS_PAGE_ID["PAYMENT_SUCCESS"] = "PAYMENT_SUCCESS";
  PASSPORT_DETAILS_PAGE_ID["ORDER_CONFIRMED"] = "ORDER_CONFIRMED";
})(constants_PASSPORT_DETAILS_PAGE_ID || (constants_PASSPORT_DETAILS_PAGE_ID = {}));

var constants_TRIPMONEY_DOMAIN_NAME = {
  MMT: ["tripmoney.makemytrip.com", "insurance.makemytrip.com", "www.makemytrip.com"],
  GI: ["tripmoney.goibibo.com", "insurance.goibibo.com", "www.goibibo.com"],
  TRIPMONEY: ["www.tripmoney.com"]
};
var PARTNER_DOMAIN_NAME;

(function (PARTNER_DOMAIN_NAME) {
  PARTNER_DOMAIN_NAME["MMT"] = ".makemytrip.com";
  PARTNER_DOMAIN_NAME["GI"] = ".goibibo.com";
  PARTNER_DOMAIN_NAME["TRIPMONEY"] = "tripmoney.com";
})(PARTNER_DOMAIN_NAME || (PARTNER_DOMAIN_NAME = {}));

var constants_TRAVELLER_NUMBER_CONSTANTS = {
  MAX_TRAVELLERS: 20,
  MIN_TRAVELLERS: 1
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/constants/partner.ts
var partner_PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown"
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/constants/appStrings.ts
var appStrings_constants = {
  formErrorToast: "Please enter the required details to continue",
  addErrorToast: "Please add all traveller details to continue"
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/constants/index.ts

 // export * from './appConstants';


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts




var renderFont = function renderFont(txtfontSize) {
  switch (txtfontSize) {
    case "xxs":
      return "\n        font-size: 10px;\n        line-height: 16px;\n      ";

    case "xs":
      return "\n        font-size: 12px;\n        line-height: 16px;\n      ";

    case "sm":
      return "\n        font-size: 0.875rem;\n        line-height: 20px;\n      ";

    case "md":
      return "\n        font-size: 1em;\n        line-height: 22px;\n      ";

    case "large":
      return "\n        font-size: 18px;\n        line-height: 24px;\n      ";

    case "xlarge":
      return "\n        font-size: 1.375rem;\n        line-height: 26px;\n      ";

    case "xxlarge":
      return "\n        font-size: 1.5em;\n        line-height: 32px;\n      ";

    case "xxxlarge":
      return "\n        font-size: 1.75em;\n        line-height: 32px;\n      ";

    default:
      return "\n        font-size: 0.875em;\n        line-height: 20px;\n      ";
  }
};

var renderFontWeight = function renderFontWeight(txtfontWeight, context) {
  switch (txtfontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "bold":
      return "\n          ".concat(context === partner_PARTNER.MMT ? "font-weight: 700" : "font-weight: 700", ";\n      ");

    case "black":
      return "\n           ".concat(context === partner_PARTNER.MMT ? "font-weight: 900" : "font-weight: 700", ";\n        ");

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var TextStyles_style_H1TagStyle = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "TextStylesstyle__H1TagStyle",
  componentId: "sc-1ci0hiy-0"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === partner_PARTNER.MMT ? "56px" : "32px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "65px" : "37px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var TextStyles_style_H2TagStyle = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "sc-1ci0hiy-1"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === partner_PARTNER.MMT ? "36px" : "32px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "44px" : "37px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H3TagStyle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "sc-1ci0hiy-2"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";text-align:var(--textAlign,left);font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === partner_PARTNER.MMT ? "32px" : "24px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "38px" : "28px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var TextStyles_style_H4TagStyle = styled_components_browser_esm["default"].h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "sc-1ci0hiy-3"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === partner_PARTNER.MMT ? "24px" : "22px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "28px" : "26px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var TextStyles_style_H5TagStyle = styled_components_browser_esm["default"].h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "sc-1ci0hiy-4"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === partner_PARTNER.MMT ? "22px" : "18px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "26px" : "21px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var TextStyles_style_H6TagStyle = styled_components_browser_esm["default"].h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "sc-1ci0hiy-5"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === partner_PARTNER.MMT ? "18px" : "16px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "21px" : "18px";
}, function (p) {
  return p.context === partner_PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var ParaTagStyle = styled_components_browser_esm["default"].p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "sc-1ci0hiy-6"
})(["", " ", " margin:", ";text-align:", ";color:", ";line-height:", ";text-transform:", ";& > .boldText{font-weight:700;}word-break:break-word;"], function (p) {
  return p.txtfontSize ? "\n    ".concat(renderFont(p.txtfontSize), "\n  ") : "";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.txtcolor && p.txtcolor;
}, function (p) {
  return p.lineHeight && p.lineHeight;
}, function (p) {
  return p.textTransform && p.textTransform;
});
var SpanTagStyle = styled_components_browser_esm["default"].span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "sc-1ci0hiy-7"
})(["", " ", " display:inline-block;color:", ";margin:", ";text-transform:", ";word-break:break-word;"], function (p) {
  return p.txtfontSize ? "".concat(renderFont(p.txtfontSize)) : "inherit";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.txtcolor && p.txtcolor;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textTransform && p.textTransform;
});
var TextStyles_style_AnchorTagStyle = styled_components_browser_esm["default"].a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "sc-1ci0hiy-8"
})(["", " ", " margin:", ";display:inline-block;color:", ";text-align:", ";text-transform:", ";", ""], function (p) {
  return p.txtfontSize ? "".concat(renderFont(p.txtfontSize)) : "";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.txtcolor ? p.txtcolor : Global/* theme.blueText */.rS.blueText;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.textTransform && p.textTransform;
}, function (p) {
  return p.disableState && "\n    opacity:0.5;\n    pointer-events:none;\n    ";
});
var TextStyles_style_CliptextStyleComp = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextStylesstyle__CliptextStyleComp",
  componentId: "sc-1ci0hiy-9"
})(["background:linear-gradient( 92.2deg,#ffe2e8 0.47%,#fffcfc 25.07%,#8cc8ea 64.68% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;width:fit-content;font-weight:600;margin:", ";"], function (props) {
  return props.margin && props.margin;
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeader.style.ts


var LandingHeader_style_LandingHeaderStyle = styled_components_browser_esm["default"].header.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderStyle",
  componentId: "sc-2vdv0h-0"
})(["height:80px;width:100%;background:rgba(0,0,0);color:rgba(255,255,255,0.6);z-index:40;box-shadow:0px 1px 16px rgba(0,0,0,0.2);position:sticky;top:0;.displayNone{display:none;}"]);
var LandingHeader_style_LandingHeaderWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderWrap",
  componentId: "sc-2vdv0h-1"
})(["width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:80px;position:relative;z-index:100;background:#000;z-index:40;"]);
var LandingHeader_style_LandingHeaderWhiteStyle = (0,styled_components_browser_esm["default"])(LandingHeader_style_LandingHeaderStyle).withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderWhiteStyle",
  componentId: "sc-2vdv0h-2"
})(["background:#fff;color:#000;z-index:40;", "{background:#fff;}"], LandingHeader_style_LandingHeaderWrap);
var TmLogo = styled_components_browser_esm["default"].a.withConfig({
  displayName: "LandingHeaderstyle__TmLogo",
  componentId: "sc-2vdv0h-3"
})(["width:140px;height:40px;flex-shrink:0;opacity:0;"]);
var LandingHeader_style_LandingHeaderList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderList",
  componentId: "sc-2vdv0h-4"
})(["margin-left:auto;display:flex;align-items:center;gap:32px;cursor:pointer;"]);
var LandingHeader_style_LandingHeaderItem = styled_components_browser_esm["default"].li.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderItem",
  componentId: "sc-2vdv0h-5"
})(["position:relative;& a{color:inherit;font-weight:400;font-size:16px;line-height:22px;}&:first-child{margin-right:16px;}&:first-child:after{content:\"\";position:absolute;border:solid #008cff;border-width:0 2px 2px 0;display:inline-block;padding:4px;top:3px;right:-22px;transition:ease-in 0.4s;", " ", "}"], function (p) {
  return p.opened && "\n        transform: rotate(-135deg);\n        -webkit-transform: rotate(-135deg);\n        top: 9px;\n        ";
}, function (p) {
  return p.closed && "\n        transform: rotate(45deg);\n        -webkit-transform: rotate(45deg);\n        ";
});
var LandingHeader_style_LandingHeaderBtn = styled_components_browser_esm["default"].button.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderBtn",
  componentId: "sc-2vdv0h-6"
})(["width:90px;height:44px;display:flex;align-items:center;justify-content:center;border:none;outline:none;font-weight:900;color:#008cff;font-size:16px;line-height:20px;margin-left:45px;border-radius:96px;background:linear-gradient(0deg,#ffffff,#ffffff),linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);-webkit-box-shadow:0px 1px 7px rgba(0,0,0,0.2);-webkit-appearance:none;cursor:pointer;"]);
var LandingHeader_style_ProductLinks = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingHeaderstyle__ProductLinks",
  componentId: "sc-2vdv0h-7"
})(["background:#ffffff;box-shadow:0px 2px 16px rgba(0,0,0,0.16);border-radius:6px;padding:24px 16px;position:absolute;top:35px;left:0;width:230px;display:flex;flex-direction:column;gap:24px;a{width:100%;font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#4a4a4a;}"]);
var LandingHeader_style_Flex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingHeaderstyle__Flex",
  componentId: "sc-2vdv0h-8"
})(["display:flex;align-items:center;font-weight:700;font-size:10px;line-height:12px;color:#ffffff;cursor:pointer;svg{margin-left:8px;}"]);
var LandingHeader_style_ImageIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingHeaderstyle__ImageIcon",
  componentId: "sc-2vdv0h-9"
})(["width:21px;height:21px;border-radius:100%;margin-right:10px;background:#000;color:#fff;font-weight:700;font-size:10px;line-height:12px;color:#ffffff;display:flex;align-items:center;justify-content:center;flex-shrink:0;"]);
var LandingHeaderMob = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderMob",
  componentId: "sc-2vdv0h-10"
})(["background:#fff;padding:16px;display:flex;flex-direction:column;gap:16px;box-shadow:0px 1px 16px rgba(0,0,0,0.2);position:sticky;top:0;z-index:4;", "{display:flex;}"], TextStyles_style_AnchorTagStyle);
var LandingHeaderMobBlack = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderMobBlack",
  componentId: "sc-2vdv0h-11"
})(["background:transparent;padding:16px;display:flex;flex-direction:column;gap:16px;position:sticky;top:0;z-index:4;", " ", "{display:flex;}picture{width:75px;height:24px;}", ""], function (p) {
  return p.displayWhiteHeader && "\n    background:#fff;\n    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.2);\n    ";
}, TextStyles_style_AnchorTagStyle, function (p) {
  return p.insuranceHeader && "\n    position:fixed;\n    top:0;\n    width:100%;\n    left:0;\n    right:0;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/MMTIcon.tsx


function MMTIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MMTIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MMTIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MMTIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MMTIcon_MMTIcon = function MMTIcon(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", MMTIcon_objectSpread(MMTIcon_objectSpread({
    width: 86,
    height: 28,
    viewBox: "0 0 86 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 37.2598,
      y: 4.68359,
      width: 23.8612,
      height: 22.4215,
      rx: 6,
      fill: "white"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 35,
      y: 0,
      width: 28,
      height: 28,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M62.6091 27.8695V0.365234H35.2988V27.8695H62.6091Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_1734_41229)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M60.3565 9.77361C59.0587 12.0098 56.74 16.8177 56.74 16.8177C56.74 16.8177 55.5721 19.4131 55.0783 22.0653C54.8587 23.2447 55.2827 24.6147 55.2827 24.6147C55.5999 25.9675 54.0972 25.5958 54.0972 25.5958C52.9995 25.2332 53.03 23.7589 53.03 23.7589C53.03 21.5828 53.9928 19.4794 54.557 18.0716C52.5746 18.8576 51.6475 16.9195 52.2116 14.9624L49.9456 18.0365C49.2164 18.8983 48.498 18.7296 48.498 18.7296C48.4615 18.7296 47.5896 18.6228 47.6337 17.4529C47.6551 16.8864 47.8134 14.5232 47.9949 13.6455C48.0133 13.5537 47.9589 13.4623 47.8859 13.5722C46.9409 15.2542 45.3924 17.0873 45.0845 17.5955C44.6851 18.2544 44.2844 18.5275 44.2844 18.5275C43.9624 18.7885 43.403 18.5912 43.403 18.5912C42.8298 18.3774 42.947 17.7255 42.947 17.7255L43.4898 13.7871C43.4898 13.7331 43.4719 13.7143 43.4172 13.7143C43.2538 13.7143 41.7173 15.8555 40.8695 17.3493L40.3144 18.252C40.3144 18.252 39.8351 19.0085 39.0948 18.5534C38.5159 18.1973 38.6979 17.5318 38.6979 17.5318L40.2856 10.8112C40.2856 10.7929 40.2856 10.6832 40.1943 10.6832C39.7034 10.6832 39.5637 11.9704 38.8925 11.9952C38.5548 12.0077 38.3808 11.8623 38.3808 11.8623C37.923 11.5974 38.1403 10.9105 38.1403 10.9105C38.1403 10.9105 38.8655 8.97975 39.8266 8.4945C39.8266 8.4945 40.3811 8.14464 40.843 8.20718C41.3051 8.26972 42.0443 8.38121 41.6563 10.5005L41.1715 13.2572C41.1715 13.2572 41.1231 13.4983 41.1982 13.5368C41.1982 13.5368 41.3179 13.6566 41.5593 13.333L44.6338 9.10418C45.2961 8.12532 46.0768 8.61909 46.0768 8.61909C46.5968 8.84109 46.4184 9.48236 46.4184 9.48236C46.4184 9.48236 44.903 14.1629 44.903 14.6016C44.903 14.748 45.0306 14.7842 45.1029 14.6751C45.7389 13.7056 47.0844 11.6023 48.2122 10.1944C48.7206 9.57273 49.0121 9.29818 49.5753 9.35319C50.1205 9.40804 50.3752 9.75544 50.3752 10.3041C50.3752 10.3956 50.3568 10.5053 50.3393 10.6151C50.3393 10.6151 49.3391 14.0715 49.2659 15.9184C49.2659 15.9184 49.2504 16.1839 49.3204 16.2376C49.4552 16.3411 49.6215 16.1081 49.6215 16.1081C50.1811 15.488 51.9707 12.6424 52.3752 11.8951L53.6699 9.24514C53.6699 9.24514 54.2194 8.03953 54.9533 8.22699C54.9533 8.22699 56.1209 8.34552 55.5568 9.62381C55.4643 9.83304 54.5754 11.2864 53.8114 14.2863C53.6843 14.7429 53.5204 16.0783 54.3382 16.0783C54.702 16.0783 55.175 15.7851 55.6658 14.8889L58.8834 9.07389C59.156 8.78084 59.3718 8.61909 59.7532 8.61909C60.9445 8.61909 60.3565 9.77361 60.3565 9.77361ZM62.6087 6.59235C62.6087 3.15774 59.8562 0.365234 56.4625 0.365234H41.4468C38.052 0.365234 35.2998 3.15774 35.2998 6.59235L35.3031 21.6389C35.3031 25.0725 38.0548 27.8696 41.4493 27.8696H56.4648C59.8593 27.8696 62.61 25.0733 62.61 21.6389L62.6087 6.59235Z",
        fill: "#EB2226"
      })
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 10,
      width: 11,
      height: 8,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 17.5647H10.3158V10.5566H0L0 17.5647Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask1_1734_41229)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.00933 17.5647H4.30673V13.7095C4.30673 13.1602 4.21981 12.7499 4.0468 12.4795C3.87363 12.209 3.58099 12.0735 3.16775 12.0735C2.86697 12.0735 2.59159 12.1481 2.34159 12.2978C2.09078 12.4479 1.87822 12.6609 1.70277 12.9371V17.5647H0V10.5634H0.969709L1.60983 11.505C1.74736 11.3792 1.95602 11.2205 2.12496 11.1107C2.29407 11.0008 2.47245 10.9042 2.66043 10.822C2.84793 10.74 3.04552 10.6758 3.25206 10.6279C3.4586 10.5802 3.67051 10.5566 3.88763 10.5566C4.13746 10.5566 4.358 10.5832 4.54728 10.6372C4.73755 10.6904 4.90535 10.7685 5.05134 10.8718C5.19734 10.9744 5.3251 11.0981 5.4335 11.2429C5.54206 11.3886 5.6376 11.5527 5.72109 11.7359C5.85471 11.6016 6.00592 11.4646 6.17518 11.3237C6.34413 11.1829 6.53097 11.0558 6.73556 10.9419C6.94014 10.8281 7.16312 10.7354 7.40514 10.6639C7.64749 10.5923 7.90985 10.5566 8.19419 10.5566C8.57765 10.5566 8.90381 10.6354 9.17367 10.7924C9.44287 10.9499 9.66178 11.1676 9.83104 11.4461C9.99999 11.7246 10.1224 12.0561 10.1999 12.4402C10.277 12.8246 10.3159 13.2436 10.3159 13.6967V17.5647H8.61313V13.7095C8.61313 13.1602 8.52768 12.7499 8.35646 12.4795C8.18556 12.209 7.89927 12.0735 7.49938 12.0735C7.19877 12.0735 6.92305 12.1439 6.67241 12.2843C6.42225 12.425 6.20139 12.6419 6.00933 12.9371V17.5647Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9324 14.3823H14.4049C13.9962 14.3823 13.6976 14.4792 13.5094 14.6372C13.3219 14.7945 13.228 15.0149 13.228 15.2966C13.228 15.5656 13.3074 15.7729 13.4661 15.9188C13.6246 16.0638 13.8667 16.1375 14.1917 16.1375C14.3883 16.1375 14.5747 16.111 14.7524 16.0586C14.93 16.0055 15.0935 15.9351 15.2438 15.8456C15.3937 15.756 15.5271 15.6503 15.6443 15.5263C15.7607 15.4029 15.8569 15.2724 15.9324 15.1354V14.3823ZM15.9317 16.7939C15.735 17.0092 15.4264 17.2102 15.0777 17.3553C14.7291 17.4994 14.3128 17.5722 13.8291 17.5722C13.491 17.5722 13.1863 17.5179 12.9145 17.4085C12.6434 17.3001 12.4114 17.1472 12.2173 16.9501C12.0233 16.753 11.8739 16.5207 11.7692 16.2517C11.6652 15.9824 11.6133 15.6887 11.6133 15.3691C11.6133 14.0646 12.6159 13.2355 14.2224 13.2355H15.919V12.8485C15.919 12.6095 15.7994 12.4214 15.5593 12.2852C15.3198 12.1489 14.9514 12.08 14.4547 12.08C13.9915 12.08 13.5626 12.1291 13.1686 12.2269C12.7746 12.324 12.556 12.4063 12.2179 12.5464L12.0075 11.0851C12.1323 11.0298 12.285 10.9715 12.4645 10.9099C12.6434 10.8482 12.8444 10.7914 13.0652 10.7382C13.2864 10.6861 13.5263 10.6421 13.7851 10.608C14.0434 10.5733 14.3152 10.5566 14.5987 10.5566C15.5836 10.5566 16.3232 10.7989 16.8179 11.2847C17.3119 11.7695 17.5593 12.4592 17.5593 13.3532V17.5647H16.3461L15.9317 16.7939Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.6119 10.4593L22.8357 13.9617L25.9934 17.5649H23.8528L20.9329 14.01V17.5649H19.2305V7.95508H20.9329V14.01L23.5336 10.4593H25.6119Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.3989 12.0668C29.1738 12.0668 28.9692 12.0946 28.7851 12.1509C28.6017 12.2071 28.441 12.2873 28.3035 12.3899C28.166 12.4932 28.0528 12.6177 27.9651 12.7635C27.8777 12.9105 27.8173 13.0715 27.7838 13.2475H30.8074C30.8074 13.0898 30.779 12.939 30.7224 12.7948C30.6664 12.6502 30.5798 12.5248 30.4626 12.4184C30.3461 12.311 30.1988 12.2259 30.0219 12.1622C29.8442 12.0987 29.637 12.0668 29.3989 12.0668ZM29.7177 16.0621C30.0182 16.0621 30.2906 16.0375 30.5346 15.9899C30.7787 15.9423 31.0011 15.8787 31.2011 15.8011C31.4018 15.723 31.5834 15.6323 31.7458 15.53C31.9084 15.4269 31.8518 15.4758 31.9852 15.3699L32.3137 16.8826C32.0129 17.0753 31.5881 17.2459 31.1602 17.3759C30.7327 17.5064 30.246 17.5722 29.6992 17.5722C29.1025 17.5722 28.5742 17.4879 28.1157 17.3204C27.6564 17.1524 27.269 16.917 26.9538 16.6123C26.6393 16.3077 26.3997 15.9423 26.2373 15.5141C26.0749 15.086 25.9932 14.6116 25.9932 14.0911C25.9932 13.6101 26.0675 13.1555 26.2155 12.7274C26.3636 12.2991 26.5807 11.9245 26.8664 11.6023C27.1523 11.2799 27.5058 11.0254 27.9274 10.8377C28.3492 10.6506 28.8354 10.5566 29.386 10.5566C29.9413 10.5566 30.4195 10.6457 30.8228 10.8237C31.2248 11.0018 31.557 11.2388 31.8174 11.5347C32.0787 11.8313 32.2714 12.1714 32.3972 12.5556C32.5223 12.9397 32.5682 13.338 32.5682 13.7504C32.5682 13.8616 32.5617 13.9894 32.5492 14.1329C32.5367 14.2764 32.5204 14.3982 32.4992 14.497H27.7526C27.7773 14.7391 27.84 14.9568 27.9401 15.1487C28.04 15.3413 28.1748 15.5048 28.3437 15.6397C28.513 15.7746 28.713 15.8787 28.9444 15.9519C29.1761 16.0256 29.434 16.0621 29.7177 16.0621Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M64.2822 11.5566L66.5825 8.80273H67.0869V10.5633H69.0522V12.0875H67.0869V14.9568C67.0869 15.1562 67.1106 15.3227 67.1588 15.456C67.2062 15.5883 67.2727 15.694 67.3564 15.7743C67.4392 15.8537 67.5353 15.9097 67.6435 15.9436C67.7522 15.9766 67.8674 15.993 67.9881 15.993C68.2133 15.993 68.4127 15.9714 68.5854 15.9277C68.759 15.8844 68.9128 15.8294 69.0461 15.7641V17.29C68.8621 17.3821 68.6692 17.4519 68.467 17.4998C68.2646 17.5485 68.0173 17.5722 67.725 17.5722C67.3121 17.5722 66.9571 17.5232 66.6613 17.4245C66.365 17.3258 66.1227 17.1837 65.9355 16.9959C65.7466 16.8076 65.608 16.5793 65.5187 16.3113C65.4292 16.0433 65.3836 15.7394 65.3836 15.3995V12.0875H64.2822V11.5566Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M71.955 12.006C72.1847 11.5864 72.5958 11.1824 72.936 10.9319C73.2757 10.6817 73.6842 10.5566 74.1593 10.5566C74.3219 10.5566 74.4552 10.5648 74.5572 10.581C74.6594 10.5972 74.7374 10.613 74.7918 10.6269C74.7918 10.6269 74.7374 11.0229 74.4788 12.2323C74.374 12.209 74.2491 12.1972 74.1028 12.1972C73.7815 12.1972 73.4952 12.2527 73.2423 12.3646C72.9899 12.4764 72.776 12.6375 72.6012 12.8469C72.4262 13.0568 72.2913 13.3144 72.1974 13.618C72.1028 13.9218 72.0563 14.2658 72.0563 14.6495V17.5647H70.3535V10.5632H71.4445L71.955 12.006Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask2_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 79,
      y: 10,
      width: 7,
      height: 11,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.9243 20.3934V10.5566L79.2148 10.5566V20.3934H85.9243Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask2_1734_41229)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.5325 12.0876C82.316 12.0876 82.1192 12.1199 81.9443 12.1847C81.7694 12.2491 81.6147 12.333 81.481 12.4368C81.3473 12.5395 81.2328 12.6575 81.137 12.789C81.0409 12.92 80.963 13.0549 80.9055 13.1927V15.1809C80.9716 15.3009 81.0589 15.4147 81.1645 15.5222C81.2711 15.6293 81.3907 15.7236 81.5248 15.8053C81.6584 15.8868 81.807 15.952 81.9722 16.0019C82.1371 16.0509 82.3132 16.0754 82.5014 16.0754C82.7888 16.0754 83.0386 16.0283 83.2491 15.9335C83.4598 15.8397 83.6348 15.7074 83.7751 15.5381C83.9149 15.3679 84.0188 15.1642 84.0848 14.9257C84.1516 14.6876 84.1848 14.4244 84.1848 14.1364C84.1848 13.836 84.1454 13.5599 84.0656 13.3085C83.9867 13.057 83.8746 12.8414 83.7281 12.661C83.5813 12.4807 83.4078 12.3396 83.2053 12.2391C83.0023 12.1379 82.7787 12.0876 82.5325 12.0876ZM84.2999 10.8505C84.6698 11.0471 84.9753 11.3099 85.2169 11.6388C85.4592 11.9677 85.6376 12.3469 85.7525 12.7778C85.8669 13.2072 85.9244 13.6545 85.9244 14.1171C85.9244 14.5896 85.8638 15.0336 85.7429 15.4511C85.6218 15.8683 85.4395 16.2342 85.1954 16.5498C84.9512 16.8646 84.6475 17.1141 84.2841 17.2975C83.9216 17.481 83.496 17.5722 83.0074 17.5722C82.5318 17.5722 82.1303 17.5026 81.8025 17.3623C81.4751 17.2235 81.188 17.0185 80.9422 16.7482L80.9171 16.7628V20.3934H79.2148V10.5634H80.2331L80.8834 11.4162C81.1302 11.1626 81.4808 10.9162 81.8214 10.7724C82.1619 10.6285 82.5458 10.5566 82.9763 10.5566C83.4895 10.5566 83.9314 10.6554 84.2999 10.8505Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M76.5459 7.68164C76.0555 7.68164 75.6592 8.08111 75.6592 8.57406C75.6592 9.06717 76.0555 9.46697 76.5459 9.46697C77.0359 9.46697 77.4331 9.06717 77.4331 8.57406C77.4331 8.08111 77.0359 7.68164 76.5459 7.68164ZM75.695 17.5648H77.3974V10.5635H75.695V17.5648Z",
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/GpsIcon.tsx


var _excluded = (/* unused pure expression or super */ null && (["color", "margin", "cursor"]));

function GpsIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GpsIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GpsIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GpsIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var GpsIcon_GpsIcon = function GpsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      margin = _ref.margin,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", GpsIcon_objectSpread(GpsIcon_objectSpread({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: margin,
      cursor: cursor
    }
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10.5005 16.3584C6.98402 16.3584 4.14209 13.5165 4.14209 10C4.14209 6.48353 6.98402 3.6416 10.5005 3.6416C14.017 3.6416 16.8589 6.45953 16.8589 9.97593C16.8589 13.4923 14.017 16.3584 10.5005 16.3584ZM10.5005 5.03853C7.75482 5.03853 5.53901 7.25434 5.53901 10C5.53901 12.7457 7.75482 14.9615 10.5005 14.9615C13.2462 14.9617 15.462 12.7217 15.462 9.97593C15.462 7.25429 13.2462 5.03853 10.5005 5.03853Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.4996 5.0383C10.1142 5.0383 9.80127 4.72515 9.80127 4.33993V2.36488C9.80127 1.97948 10.1144 1.6665 10.4996 1.6665C10.885 1.6665 11.198 1.97966 11.198 2.36488V4.33993C11.1982 4.70113 10.885 5.0383 10.4996 5.0383Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.4996 18.333C10.1142 18.333 9.80127 18.0198 9.80127 17.6346V15.6596C9.80127 15.2742 10.1144 14.9612 10.4996 14.9612C10.885 14.9612 11.198 15.2743 11.198 15.6596V17.6346C11.1982 18.0198 10.885 18.333 10.4996 18.333Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.1363 10.6975H16.1613C15.7759 10.6975 15.4629 10.3844 15.4629 9.99916C15.4629 9.61376 15.776 9.30078 16.1613 9.30078H18.1363C18.5217 9.30078 18.8347 9.61394 18.8347 9.99916C18.8349 10.3844 18.5459 10.6975 18.1363 10.6975Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.84042 10.6975H2.86537C2.47997 10.6975 2.16699 10.3844 2.16699 9.99916C2.16699 9.61376 2.48015 9.30078 2.86537 9.30078H4.84042C5.22581 9.30078 5.53879 9.61394 5.53879 9.99916C5.53879 10.3844 5.22564 10.6975 4.84042 10.6975Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.5017 12.6742C9.00844 12.6742 7.8042 11.47 7.8042 9.97676C7.8042 8.48354 9.00844 7.2793 10.5017 7.2793C11.9951 7.2793 13.1993 8.50758 13.1993 9.97676C13.1993 11.47 11.9951 12.6742 10.5017 12.6742ZM10.5017 8.70031C9.80329 8.70031 9.22517 9.27839 9.22517 9.97681C9.22517 10.6752 9.80325 11.2533 10.5017 11.2533C11.2 11.2533 11.7782 10.6752 11.7782 9.97681C11.7782 9.27839 11.2002 8.70031 10.5017 8.70031Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/EditIcon.tsx


var EditIcon_excluded = (/* unused pure expression or super */ null && (["size", "color", "cursor"]));

function EditIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EditIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EditIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EditIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var EditIcon_EditIcon = function EditIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, EditIcon_excluded);

  return /*#__PURE__*/_jsxs("svg", EditIcon_objectSpread(EditIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.378 5.45329C15.9045 4.9268 16.7581 4.9268 17.2846 5.45328L19.0567 7.2254C19.5832 7.75188 19.5832 8.60548 19.0567 9.13196L18.3203 9.86834C18.1097 10.0789 17.7683 10.0789 17.5577 9.86834L14.6416 6.95229C14.431 6.74169 14.431 6.40025 14.6416 6.18966L15.378 5.45329Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1781 7.64303C13.3887 7.43244 13.7302 7.43244 13.9408 7.64303L16.8568 10.5591C17.0674 10.7697 17.0674 11.1111 16.8568 11.3217L10.3652 17.8134C10.2926 17.8859 10.1997 17.9347 10.0988 17.9532L6.59734 18.5945C6.25606 18.657 5.95467 18.365 6.00634 18.0219L6.55028 14.4106C6.56638 14.3038 6.61629 14.2049 6.69271 14.1285L13.1781 7.64303Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/InfoIcon.tsx


var InfoIcon_excluded = (/* unused pure expression or super */ null && (["cursor", "color", "width", "height"]));

function InfoIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InfoIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InfoIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InfoIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var InfoIcon_InfoIcon = function InfoIcon(_ref) {
  var _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      color = _ref.color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 16 : _ref$height,
      props = _objectWithoutProperties(_ref, InfoIcon_excluded);

  return /*#__PURE__*/_jsx("svg", InfoIcon_objectSpread(InfoIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.600098 7.99998C0.600098 12.0869 3.91319 15.4 8.0001 15.4C12.087 15.4 15.4001 12.0869 15.4001 7.99998C15.4001 3.91307 12.087 0.599976 8.0001 0.599976C3.91319 0.599976 0.600098 3.91307 0.600098 7.99998ZM14.4001 7.99998C14.4001 11.5346 11.5347 14.4 8.0001 14.4C4.46547 14.4 1.6001 11.5346 1.6001 7.99998C1.6001 4.46535 4.46547 1.59998 8.0001 1.59998C11.5347 1.59998 14.4001 4.46535 14.4001 7.99998ZM8.67002 7.32318V11.732C8.67002 12.102 8.37008 12.4019 8.0001 12.4019C7.63011 12.4019 7.33018 12.102 7.33018 11.732V7.32318C7.33018 6.95319 7.63011 6.65326 8.0001 6.65326C8.37008 6.65326 8.67002 6.95319 8.67002 7.32318ZM8.79646 5.51487C8.84592 5.40887 8.87066 5.29462 8.87066 5.17422C8.87066 5.05465 8.84628 4.93973 8.79782 4.83127C8.751 4.72648 8.68784 4.634 8.6088 4.55495C8.52894 4.47509 8.43531 4.4123 8.32921 4.36714C8.22161 4.32136 8.10785 4.29838 7.98954 4.29838C7.87042 4.29838 7.75737 4.32168 7.65223 4.36841C7.54976 4.41395 7.45911 4.47707 7.38144 4.55702C7.30423 4.63651 7.24305 4.72941 7.19831 4.83454C7.15252 4.94214 7.12954 5.05591 7.12954 5.17422C7.12954 5.29334 7.15285 5.40638 7.19958 5.51152C7.24433 5.61222 7.30514 5.7023 7.38144 5.78085C7.45911 5.8608 7.54976 5.92392 7.65223 5.96946C7.75737 6.01619 7.87042 6.0395 7.98954 6.0395C8.10785 6.0395 8.22161 6.01651 8.32921 5.97073C8.43531 5.92558 8.52894 5.86278 8.6088 5.78292C8.6869 5.70482 8.74965 5.61518 8.79646 5.51487Z",
      fill: color || "#4A4A4A"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ArrowIcon.tsx


var ArrowIcon_excluded = (/* unused pure expression or super */ null && (["color", "size", "cursor", "margin"]));

function ArrowIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ArrowIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ArrowIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ArrowIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ArrowIcon_ArrowIcon = function ArrowIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008cff" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "0px" : _ref$margin,
      props = _objectWithoutProperties(_ref, ArrowIcon_excluded);

  return /*#__PURE__*/_jsx("svg", ArrowIcon_objectSpread(ArrowIcon_objectSpread({
    style: {
      cursor: cursor,
      margin: margin
    },
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.99984 13.8333L7.04984 12.9L10.7832 9.16663H2.6665V7.83329H10.7832L7.04984 4.09996L7.99984 3.16663L13.3332 8.49996L7.99984 13.8333Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CrossIcon.tsx


var CrossIcon_excluded = (/* unused pure expression or super */ null && (["color", "onPress", "cursor"]));

function CrossIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CrossIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CrossIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CrossIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var CrossIcon_CrossIcon = function CrossIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#808080" : _ref$color,
      onPress = _ref.onPress,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, CrossIcon_excluded);

  return /*#__PURE__*/_jsx("svg", CrossIcon_objectSpread(CrossIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: onPress
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/RedCrossSvg.tsx

var RedCrossIcon = function RedCrossIcon(_ref) {
  var _ref$tickColor = _ref.tickColor,
      tickColor = _ref$tickColor === void 0 ? "#0EB31F" : _ref$tickColor,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#F2FFF4" : _ref$bgColor,
      props = _ref.props;
  return /*#__PURE__*/_jsx("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75ZM5.37232 13.7849C5.17706 13.5897 5.17706 13.2731 5.37232 13.0778L8.33385 10.1163L5.37232 7.15475C5.17706 6.95949 5.17706 6.64291 5.37232 6.44765L6.44765 5.37232C6.64291 5.17706 6.95949 5.17706 7.15475 5.37232L10.1163 8.33385L13.0778 5.37232C13.2731 5.17706 13.5897 5.17706 13.7849 5.37232L14.8602 6.44765C15.0555 6.64291 15.0555 6.95949 14.8602 7.15475L11.8987 10.1163L14.8602 13.0778C15.0555 13.2731 15.0555 13.5897 14.8602 13.7849L13.7849 14.8602C13.5897 15.0555 13.2731 15.0555 13.0778 14.8602L10.1163 11.8987L7.15475 14.8602C6.95949 15.0555 6.64291 15.0555 6.44764 14.8602L5.37232 13.7849Z",
      fill: "#EB2026"
    })
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CloseIcon.tsx


var CloseIcon_excluded = (/* unused pure expression or super */ null && (["color", "onPress", "cursor"]));

function CloseIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CloseIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CloseIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CloseIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var CloseIcon_CloseIcon = function CloseIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#AFAFAF" : _ref$color,
      onPress = _ref.onPress,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, CloseIcon_excluded);

  return /*#__PURE__*/_jsx("svg", CloseIcon_objectSpread(CloseIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: onPress
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.79967 17.8333L11.9997 13.6333L16.1997 17.8333L17.833 16.1999L13.633 11.9999L17.833 7.79992L16.1997 6.16659L11.9997 10.3666L7.79967 6.16659L6.16634 7.79992L10.3663 11.9999L6.16634 16.1999L7.79967 17.8333ZM11.9997 23.6666C10.3858 23.6666 8.86912 23.3601 7.44968 22.7473C6.03023 22.1351 4.79551 21.3041 3.74551 20.2541C2.69551 19.2041 1.86445 17.9694 1.25234 16.5499C0.639452 15.1305 0.333008 13.6138 0.333008 11.9999C0.333008 10.386 0.639452 8.86936 1.25234 7.44992C1.86445 6.03048 2.69551 4.79575 3.74551 3.74575C4.79551 2.69575 6.03023 1.86431 7.44968 1.25142C8.86912 0.639307 10.3858 0.333252 11.9997 0.333252C13.6136 0.333252 15.1302 0.639307 16.5497 1.25142C17.9691 1.86431 19.2038 2.69575 20.2538 3.74575C21.3038 4.79575 22.1349 6.03048 22.747 7.44992C23.3599 8.86936 23.6663 10.386 23.6663 11.9999C23.6663 13.6138 23.3599 15.1305 22.747 16.5499C22.1349 17.9694 21.3038 19.2041 20.2538 20.2541C19.2038 21.3041 17.9691 22.1351 16.5497 22.7473C15.1302 23.3601 13.6136 23.6666 11.9997 23.6666Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/SafetyIcon.tsx


function SafetyIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SafetyIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SafetyIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SafetyIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SafetyIcon_SafetyIcon = function SafetyIcon(props) {
  return /*#__PURE__*/_jsxs("svg", SafetyIcon_objectSpread(SafetyIcon_objectSpread({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 10,
      cy: 10,
      r: 8,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.6887 11.7899C13.4135 12.5669 12.9972 13.2425 12.4514 13.7978C11.8301 14.4298 11.0165 14.932 10.0332 15.2902C10.0009 15.3019 9.96724 15.3115 9.93342 15.3186C9.88873 15.3278 9.84326 15.3328 9.79818 15.3334H9.78935C9.74131 15.3334 9.69302 15.3284 9.64513 15.3186C9.61131 15.3115 9.5781 15.3019 9.54599 15.2904C8.56154 14.9328 7.74693 14.4308 7.12498 13.7988C6.57888 13.2436 6.16271 12.5684 5.88787 11.7913C5.3881 10.3786 5.41654 8.82226 5.43943 7.57161L5.43982 7.5524C5.44443 7.44913 5.4474 7.34065 5.44904 7.22086C5.4574 6.63273 5.90631 6.14615 6.47099 6.11336C7.64834 6.04492 8.55912 5.64493 9.33732 4.85481L9.34412 4.8483C9.47334 4.72485 9.63615 4.6643 9.79818 4.66682C9.95443 4.66894 10.1101 4.72941 10.2347 4.8483L10.2413 4.85481C11.0197 5.64493 11.9304 6.04492 13.1078 6.11336C13.6725 6.14615 14.1214 6.63273 14.1297 7.22086C14.1314 7.34147 14.1344 7.44978 14.139 7.5524L14.1392 7.56054C14.162 8.81355 14.1903 10.373 13.6887 11.7899Z",
      fill: "#2B825E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.4773 8.96207L10.122 11.4159L9.61301 11.9461C9.49277 12.0713 9.33507 12.1339 9.17754 12.1339C9.01984 12.1339 8.8623 12.0713 8.74191 11.9461L7.64764 10.8057C7.40717 10.5552 7.40717 10.1495 7.64764 9.89881C7.88778 9.64833 8.27778 9.64833 8.51825 9.89881L9.17754 10.5856L11.6067 8.05518C11.8472 7.80452 12.2372 7.80452 12.4773 8.05518C12.7178 8.30567 12.7178 8.71192 12.4773 8.96207Z",
      fill: "white"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/EnergyIcon.tsx


function EnergyIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EnergyIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EnergyIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EnergyIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var EnergyIcon_EnergyIcon = function EnergyIcon(props) {
  return /*#__PURE__*/_jsx("svg", EnergyIcon_objectSpread(EnergyIcon_objectSpread({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.93292 14C2.65306 14 2.43717 13.7589 2.47715 13.4867L3.19678 8.55556H0.398211C-0.305429 8.55556 0.134346 7.97222 0.150338 7.94889C1.15782 6.21444 2.66905 3.64778 4.66803 0.225556C4.74799 0.0855555 4.90791 0 5.06782 0C5.34768 0 5.56357 0.241111 5.52359 0.513333L4.80396 5.44444H7.61053C7.93036 5.44444 8.10627 5.59222 7.93036 5.95778C5.29971 10.4222 3.77249 13.0278 3.33271 13.7744C3.25275 13.9144 3.10083 14 2.93292 14Z",
      fill: "#2B825E"
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ArrowLarge.tsx


var ArrowLarge_excluded = (/* unused pure expression or super */ null && (["color", "margin", "cursor"]));

function ArrowLarge_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ArrowLarge_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ArrowLarge_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ArrowLarge_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var ArrowLarge_ArrowLarge = function ArrowLarge(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      margin = _ref.margin,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, ArrowLarge_excluded);

  return /*#__PURE__*/_jsx("svg", ArrowLarge_objectSpread(ArrowLarge_objectSpread({
    width: 28,
    height: 9,
    style: {
      margin: margin,
      cursor: cursor
    },
    viewBox: "0 0 28 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.86 4.13812L24.06 1.16299C23.8703 0.992485 23.5021 0.9221 23.29 1.11924C23.0811 1.3134 23.0919 1.68997 23.3 1.8849L24.952 3.63686C25.0723 3.76444 24.9819 3.97407 24.8065 3.97407H1.525C1.23506 3.97407 1 4.20912 1 4.49908C1 4.78904 1.23506 5.0241 1.525 5.0241H24.8065C24.9819 5.0241 25.0723 5.23372 24.952 5.36131L23.3 7.11327C23.1209 7.29273 23.0832 7.68254 23.29 7.87893C23.4968 8.07529 23.8781 8.01256 24.06 7.83516L26.86 4.86003C26.9558 4.75822 27.0003 4.63876 27 4.49908C26.9951 4.37395 26.9458 4.22933 26.86 4.13812Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ChevronUpIcon.tsx


var ChevronUpIcon_excluded = (/* unused pure expression or super */ null && (["color", "cursor"]));

function ChevronUpIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevronUpIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevronUpIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevronUpIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ChevronUpIcon_ChevronUpIcon = function ChevronUpIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008cff" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, ChevronUpIcon_excluded);

  return /*#__PURE__*/_jsx("svg", ChevronUpIcon_objectSpread(ChevronUpIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.8583 10.6059C11.9364 10.5278 12.063 10.5278 12.1411 10.6059L16.2423 14.7071C16.6329 15.0976 17.266 15.0976 17.6566 14.7071V14.7071C18.0471 14.3166 18.0471 13.6834 17.6566 13.2929L12.7068 8.34315C12.3163 7.95262 11.6831 7.95262 11.2926 8.34315L6.34285 13.2929C5.95232 13.6834 5.95232 14.3166 6.34285 14.7071V14.7071C6.73337 15.0976 7.36654 15.0976 7.75706 14.7071L11.8583 10.6059Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LocationIcon.tsx


function LocationIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var LocationIcon_LocationIcon = function LocationIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#2B825E" : _ref$color,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", LocationIcon_objectSpread(LocationIcon_objectSpread({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.18195 3.91311C8.18195 6.07426 5.68191 8.4784 4.09098 10.0002C2.27276 8.261 0 6.07426 0 3.91311C0 1.75196 1.83159 0 4.09098 0C6.35036 0 8.18195 1.75196 8.18195 3.91311Z",
      fill: color
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 4.09106,
      cy: 3.53368,
      rx: 2,
      ry: 1.95556,
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/RoundPlayIcon.tsx


function RoundPlayIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RoundPlayIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoundPlayIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoundPlayIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var RoundPlayIcon_RoundPlayIcon = function RoundPlayIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      props = _ref.props;
  return /*#__PURE__*/_jsx("svg", RoundPlayIcon_objectSpread(RoundPlayIcon_objectSpread({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 0.365234C6.72114 0.365234 0 7.08638 0 15.3652C0 23.6441 6.72114 30.3652 15 30.3652C23.2789 30.3652 30 23.6441 30 15.3652C30 7.08638 23.2789 0.365234 15 0.365234ZM12.2931 9.02523C11.9859 8.82613 11.594 8.81229 11.2721 8.98729C10.95 9.16229 10.75 9.49912 10.75 9.86517V20.8652C10.75 21.2312 10.95 21.5681 11.2721 21.7431C11.594 21.9181 11.9859 21.9042 12.2931 21.7051L20.7931 16.2051C21.0779 16.0201 21.25 15.7042 21.25 15.3652C21.25 15.0261 21.0779 14.7103 20.7931 14.5252L12.2931 9.02523Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/RoundTickIcon.tsx


function RoundTickIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RoundTickIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoundTickIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoundTickIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var RoundTickIcon_RoundTickIcon = function RoundTickIcon(_ref) {
  var _ref$tickColor = _ref.tickColor,
      tickColor = _ref$tickColor === void 0 ? "#0EB31F" : _ref$tickColor,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#F2FFF4" : _ref$bgColor,
      props = _ref.props,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", RoundTickIcon_objectSpread(RoundTickIcon_objectSpread({
    width: size,
    height: size + 1,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 16,
      cy: 16.3652,
      r: 16,
      fill: bgColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 16.5349L12.1586 20.2655C12.9783 21.0009 14.2383 20.9352 14.9772 20.1186L23.3846 10.8262",
      stroke: tickColor,
      strokeWidth: 3,
      strokeLinecap: "round"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/RoundCrossIcon.tsx


function RoundCrossIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RoundCrossIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoundCrossIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoundCrossIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var RoundCrossIcon_RoundCrossIcon = function RoundCrossIcon(_ref) {
  var _ref$crossColor = _ref.crossColor,
      crossColor = _ref$crossColor === void 0 ? "#CF3720" : _ref$crossColor,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#FFEAE7" : _ref$bgColor,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", RoundCrossIcon_objectSpread(RoundCrossIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 16,
      cy: 16.3652,
      r: 16,
      fill: bgColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.84375 10.2109L22.1514 22.5186",
      stroke: crossColor,
      strokeWidth: 3,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.1562 10.2109L9.84856 22.5186",
      stroke: crossColor,
      strokeWidth: 3,
      strokeLinecap: "round"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/DocsUploadIcon.tsx


function DocsUploadIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DocsUploadIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DocsUploadIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DocsUploadIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var DocsUploadIcon_DocsUploadIcon = function DocsUploadIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 48 : _ref$size,
      _ref$documentColor = _ref.documentColor,
      documentColor = _ref$documentColor === void 0 ? "#2B8DFF" : _ref$documentColor,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#F8F8F8" : _ref$bgColor,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", DocsUploadIcon_objectSpread(DocsUploadIcon_objectSpread({
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: 48,
      height: 48,
      rx: 24,
      fill: "white"
    }), /*#__PURE__*/_jsx("rect", {
      x: 13.2002,
      y: 10.801,
      width: 21.2677,
      height: 26.5846,
      rx: 2,
      fill: documentColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.7917 15.1197H29.8756",
      stroke: bgColor,
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.7917 19.8839H29.8756",
      stroke: bgColor,
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.8525 24.0942H23.1695",
      stroke: bgColor,
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 31.4773,
      cy: 33.5074,
      r: 7.2,
      fill: "url(#paint0_linear_1755_53184)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M31.9004 29.9145V37.1021",
      stroke: "white",
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M28.3076 33.5069H35.4951",
      stroke: "white",
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1755_53184",
        x1: 26.3862,
        y1: 38.5985,
        x2: 36.5685,
        y2: 28.4162,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#EDD287"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#B8860B"
        })]
      })
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/RoundSearchIcon.tsx


function RoundSearchIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RoundSearchIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoundSearchIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoundSearchIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var RoundSearchIcon_RoundSearchIcon = function RoundSearchIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#EAF5FF" : _ref$bgColor,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", RoundSearchIcon_objectSpread(RoundSearchIcon_objectSpread({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 0.667969,
      width: 40,
      height: 40,
      rx: 20,
      fill: bgColor
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.5619 28.385L29.774 28.1729L25.6906 24.0902C26.9474 22.6164 27.6316 20.7734 27.6316 18.8309C27.6316 16.6585 26.7852 14.6153 25.2494 13.0787C22.078 9.90738 16.9184 9.90738 13.7457 13.0786C10.5744 16.2499 10.5744 21.411 13.7456 24.5823C15.289 26.1257 17.3526 26.961 19.4971 26.961C21.415 26.961 23.275 26.2842 24.7564 25.0234L28.8406 29.1063C28.9661 29.2318 29.1332 29.3 29.3069 29.3C29.4807 29.3 29.6485 29.2318 29.774 29.1063C30.0315 28.8488 30.0315 28.4317 29.7745 28.1734L29.5619 28.385ZM24.316 23.6489C21.6593 26.3056 17.3361 26.306 14.6791 23.6489C12.0222 20.9921 12.0222 16.6689 14.6791 14.0121C15.973 12.7194 17.7006 12.0202 19.4971 12.0202C21.295 12.0202 23.0225 12.7193 24.316 14.0121C25.6033 15.2994 26.3114 17.0097 26.3114 18.8309C26.3114 20.6517 25.603 22.3625 24.316 23.6489Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LocationPinIcon.tsx


var LocationPinIcon_excluded = (/* unused pure expression or super */ null && (["color"]));

function LocationPinIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationPinIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationPinIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationPinIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var LocationPinIcon = function LocationPinIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#fff" : _ref$color,
      props = _objectWithoutProperties(_ref, LocationPinIcon_excluded);

  return /*#__PURE__*/_jsxs("svg", LocationPinIcon_objectSpread(LocationPinIcon_objectSpread({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.25 7.82535C16.25 12.1476 11.2847 16.9558 8.125 19.9993C4.51389 16.521 0 12.1476 0 7.82535C0 3.50313 3.63769 -0.000732422 8.125 -0.000732422C12.6123 -0.000732422 16.25 3.50313 16.25 7.82535Z",
      fill: color
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 8.125,
      cy: 7.99927,
      rx: 6.09375,
      ry: 6,
      fill: "black"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/FooterHeartIcon.tsx


function FooterHeartIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FooterHeartIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FooterHeartIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FooterHeartIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var FooterHeartIcon = function FooterHeartIcon(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", FooterHeartIcon_objectSpread(FooterHeartIcon_objectSpread({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_1734_41302)",
      children: [/*#__PURE__*/_jsx("rect", {
        x: 1,
        y: 1.36914,
        width: 18,
        height: 18,
        rx: 4.5,
        stroke: "#979797",
        strokeWidth: 0.9
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.041 5.3291C11.9294 5.3292 10.9042 5.9446 10.3596 6.93889C9.81505 5.9446 8.78985 5.3292 7.67823 5.3291C5.97803 5.3291 4.59961 6.94705 4.59961 8.69137C4.59961 13.0725 10.3596 16.1291 10.3596 16.1291C10.3596 16.1291 16.1196 13.0725 16.1196 8.69137C16.1196 6.94705 14.7412 5.3291 13.041 5.3291Z",
        fill: "url(#paint0_linear_1734_41302)"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1734_41302",
        x1: 9.28137,
        y1: 22.3257,
        x2: 21.759,
        y2: 10.7275,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1734_41302",
        children: /*#__PURE__*/_jsx("rect", {
          width: 20,
          height: 20,
          fill: "white",
          transform: "translate(0 0.369141)"
        })
      })]
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/RoundEcllipseIcon.tsx


function RoundEcllipseIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RoundEcllipseIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoundEcllipseIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoundEcllipseIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var RoundEcllipseIcon_RoundEcllipseIcon = function RoundEcllipseIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#CF8100" : _ref$color,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", RoundEcllipseIcon_objectSpread(RoundEcllipseIcon_objectSpread({
    width: 26,
    height: 25,
    fill: "none",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.068 9.49978C15.068 6.79315 12.8738 4.59899 10.1672 4.59899C7.46058 4.59899 5.26642 6.79315 5.26642 9.49978C5.26642 12.2064 7.46057 14.4006 10.1672 14.4006C12.8738 14.4006 15.068 12.2064 15.068 9.49978ZM10.1672 2.63867C13.9565 2.63867 17.0283 5.7105 17.0283 9.49978C17.0283 13.2891 13.9565 16.3609 10.1672 16.3609C6.37792 16.3609 3.3061 13.2891 3.3061 9.49978C3.3061 5.7105 6.37792 2.63867 10.1672 2.63867Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.068 9.49978C15.068 6.79315 12.8738 4.59899 10.1672 4.59899C9.62588 4.59899 9.18705 4.16016 9.18705 3.61883C9.18705 3.0775 9.62588 2.63867 10.1672 2.63867C13.9565 2.63867 17.0283 5.7105 17.0283 9.49978C17.0283 13.2891 13.9565 16.3609 10.1672 16.3609C9.62588 16.3609 9.18705 15.9221 9.18705 15.3807C9.18705 14.8394 9.62588 14.4006 10.1672 14.4006C12.8738 14.4006 15.068 12.2064 15.068 9.49978Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LocationGreenIcon.tsx


var LocationGreenIcon_excluded = (/* unused pure expression or super */ null && (["color"]));

function LocationGreenIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationGreenIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationGreenIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationGreenIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var LocationGreenIcon = function LocationGreenIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#2B825E" : _ref$color,
      props = _objectWithoutProperties(_ref, LocationGreenIcon_excluded);

  return /*#__PURE__*/_jsxs("svg", LocationGreenIcon_objectSpread(LocationGreenIcon_objectSpread({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M36 17.2174C36 26.7263 25 37.3043 18 44C10 36.3478 0 26.7263 0 17.2174C0 7.70849 8.05887 0 18 0C27.9411 0 36 7.70849 36 17.2174Z",
      fill: color
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 18,
      cy: 17.6004,
      rx: 13.5,
      ry: 13.2,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.734 11.9977C25.0547 11.4664 24.0636 11.574 23.5202 12.2382L15.7396 21.7478L12.4717 17.821C11.9227 17.1613 10.9307 17.0617 10.256 17.5985C9.5813 18.1353 9.47941 19.1053 10.0284 19.765L13.6484 24.1147C14.7346 25.42 16.7758 25.4117 17.851 24.0977L25.9799 14.1622C26.5233 13.4981 26.4132 12.529 25.734 11.9977Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/FooterDownloadIcon.tsx


function FooterDownloadIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FooterDownloadIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FooterDownloadIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FooterDownloadIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var FooterDownloadIcon = function FooterDownloadIcon(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", FooterDownloadIcon_objectSpread(FooterDownloadIcon_objectSpread({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_1734_41315)",
      children: [/*#__PURE__*/_jsx("rect", {
        x: 1,
        y: 1.36914,
        width: 18,
        height: 18,
        rx: 4.5,
        stroke: "#979797",
        strokeWidth: 0.9
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.82002 16.8491L5.5 11.8091H8.37999V5.3291H11.26V11.8091H14.14L9.82002 16.8491Z",
        fill: "url(#paint0_linear_1734_41315)"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1734_41315",
        x1: 9.01132,
        y1: 23.4588,
        x2: 21.2341,
        y2: 15.4704,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1734_41315",
        children: /*#__PURE__*/_jsx("rect", {
          width: 20,
          height: 20,
          fill: "white",
          transform: "translate(0 0.369141)"
        })
      })]
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LocationMarkerWithCheck.tsx


function LocationMarkerWithCheck_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationMarkerWithCheck_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationMarkerWithCheck_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationMarkerWithCheck_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var LocationMarkerWithCheck_LocationMarkerWithCheck = function LocationMarkerWithCheck(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 36 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 44 : _ref$height,
      props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", LocationMarkerWithCheck_objectSpread(LocationMarkerWithCheck_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M36 17.2174C36 26.7263 25 37.3043 18 44C10 36.3478 0 26.7263 0 17.2174C0 7.70849 8.05887 0 18 0C27.9411 0 36 7.70849 36 17.2174Z",
      fill: "#008CFF"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 18,
      cy: 17.6004,
      rx: 13.5,
      ry: 13.2,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 17.2174C36 26.7263 25 37.3043 18 44C10 36.3478 0 26.7263 0 17.2174C0 7.70849 8.05887 0 18 0C27.9411 0 36 7.70849 36 17.2174Z",
      fill: "#2B825E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 18,
      cy: 17.6004,
      rx: 13.5,
      ry: 13.2,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.734 11.9977C25.0547 11.4664 24.0636 11.574 23.5202 12.2382L15.7396 21.7478L12.4717 17.821C11.9227 17.1613 10.9307 17.0617 10.256 17.5985C9.58128 18.1353 9.4794 19.1053 10.0284 19.765L13.6484 24.1147C14.7346 25.42 16.7758 25.4117 17.851 24.0977L25.9799 14.1622C26.5233 13.4981 26.4132 12.529 25.734 11.9977Z",
      fill: "#2B825E"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LocationFetchingIcon.tsx


function LocationFetchingIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationFetchingIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationFetchingIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationFetchingIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var LocationFetchingIcon_LocationFetchingIcon = function LocationFetchingIcon(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", LocationFetchingIcon_objectSpread(LocationFetchingIcon_objectSpread({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M36 17.2174C36 26.7263 25 37.3043 18 44C10 36.3478 0 26.7263 0 17.2174C0 7.70849 8.05887 0 18 0C27.9411 0 36 7.70849 36 17.2174Z",
      fill: "#008CFF"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 18,
      cy: 17.6004,
      rx: 13.5,
      ry: 13.2,
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TMLogo.tsx


var TMLogo_excluded = (/* unused pure expression or super */ null && (["color"]));

function TMLogo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TMLogo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TMLogo_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TMLogo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var TMLogo_TMLogo = function TMLogo(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#fff" : _ref$color,
      props = _objectWithoutProperties(_ref, TMLogo_excluded);

  return /*#__PURE__*/_jsxs("svg", TMLogo_objectSpread(TMLogo_objectSpread({
    width: 140,
    height: 39,
    viewBox: "0 0 140 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M6.50765 10.3115V17.8732C6.50765 18.5606 6.73679 18.7897 6.87427 18.8814C7.14924 19.0189 7.47004 19.1105 7.8825 19.1105C8.2033 19.1105 9.1657 18.8356 9.71564 18.6064L10.3114 18.4231V21.3103L10.0823 21.4478C9.25735 21.8602 8.38661 22.0894 7.47004 22.0894C3.89542 22.0894 3.11634 19.9355 3.11634 18.1023V10.3115H0L6.50765 3.758V7.33262H10.3572V10.3115H6.50765Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.0806 7.05756V10.2656H20.3932C19.4308 10.2656 18.5142 10.4489 17.6435 10.8155C16.8644 11.1821 16.2686 11.6404 15.8103 12.2362V21.7227H12.4648V7.33253H14.8938L15.4895 9.07401C16.7727 7.74498 18.4225 7.10338 20.3473 7.10338H21.0806V7.05756Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.3511 3.57461C26.3511 4.53701 25.572 5.3161 24.6096 5.3161C23.6472 5.3161 22.8682 4.53701 22.8682 3.57461C22.8682 2.61221 23.6472 1.83313 24.6096 1.83313C25.5262 1.83313 26.3511 2.61221 26.3511 3.57461Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.2136 7.33258H22.8682V21.8144H26.2136V7.33258Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.8865 9.07394C40.5117 7.69909 38.9077 7.01166 37.0745 7.01166C35.2414 7.01166 33.4999 8.11154 32.7208 8.70731L32.0334 7.33246H29.6045V27.9095H32.95V20.6227C34.1415 21.5851 35.5164 22.0892 37.0287 22.0892C38.816 22.0892 40.3742 21.4476 41.7032 20.1644L41.8407 20.0269C43.2156 18.6521 43.903 16.819 43.903 14.5734C43.9488 12.2819 43.2614 10.4488 41.8865 9.07394ZM36.7079 18.8812C35.2872 18.8812 34.0499 18.3313 32.95 17.1856V11.9153C34.0499 10.7696 35.2414 10.2197 36.7079 10.2197C37.8994 10.2197 38.816 10.5863 39.5493 11.3195C40.2825 12.0528 40.6033 13.1527 40.6033 14.5275C40.6033 15.9024 40.2367 17.0023 39.5493 17.7355C38.816 18.5146 37.8994 18.8812 36.7079 18.8812Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M90.3266 9.11984C88.9976 7.74498 87.2103 7.05756 85.0563 7.05756C82.9024 7.05756 81.1151 7.74498 79.7861 9.11984C78.457 10.4947 77.8154 12.3278 77.8154 14.5276C77.8154 16.7732 78.5029 18.5605 79.7861 19.9354C81.1151 21.3102 82.9024 21.9976 85.0563 21.9976C87.2103 21.9976 88.9976 21.3102 90.3266 19.9354C91.6556 18.5605 92.3431 16.7274 92.3431 14.5276C92.2972 12.3278 91.6098 10.4947 90.3266 9.11984ZM85.0563 18.9271C84.0023 18.9271 83.0857 18.5605 82.3066 17.8273C81.5275 17.1398 81.1151 15.9941 81.1151 14.5276C81.1151 13.0611 81.5275 11.9612 82.2608 11.2279C83.0399 10.4947 83.9565 10.1281 85.0105 10.1281C86.0646 10.1281 86.9811 10.4947 87.7602 11.2279C88.5393 11.9154 88.9059 13.0153 88.9059 14.5276C88.9059 15.9941 88.4935 17.1398 87.7602 17.8273C87.027 18.5605 86.1104 18.9271 85.0563 18.9271Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M107.789 12.6945V21.7685H104.443V12.9694C104.443 11.0446 103.664 10.1739 101.968 10.1739C100.594 10.1739 99.3104 10.953 98.073 12.4195V21.7685H94.7275V7.33253H97.1565L97.798 9.07401C99.2187 7.74498 100.777 7.05756 102.564 7.05756C104.168 7.05756 105.451 7.6075 106.414 8.70738C107.33 9.76144 107.789 11.1363 107.789 12.6945Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M122.132 17.598C120.849 18.423 119.474 18.8354 118.008 18.8354C116.541 18.8354 115.441 18.5146 114.754 17.9188C114.158 17.4147 113.791 16.7273 113.608 15.8107H123.782V14.0234C123.69 12.1444 123.14 10.5405 122.086 9.21143C120.941 7.74491 119.199 7.01166 116.999 7.01166C114.8 7.01166 113.104 7.74491 111.912 9.21143C110.767 10.6779 110.171 12.5111 110.171 14.7108C110.171 16.9106 110.812 18.6979 112.142 20.0269C113.425 21.356 115.166 21.9976 117.32 21.9976C119.382 21.9976 121.261 21.5393 122.82 20.6685L123.003 20.6227L122.82 17.1856L122.132 17.598ZM113.562 12.9694C113.7 12.0528 114.066 11.3654 114.616 10.9071C115.304 10.3113 116.083 10.0363 116.954 10.0363C117.824 10.0363 118.603 10.3113 119.291 10.9071C119.887 11.4112 120.253 12.0986 120.345 12.9694H113.562Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M139.181 7.33258L138.952 7.92835L130.657 27.9096H127.22L129.694 21.5394L123.92 7.33258H127.495L131.482 17.369L135.606 7.33258H139.181Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M46.2871 7.43108C46.2871 2.92739 49.2145 0 53.7182 0H68.1863C72.6899 0 75.6173 2.92739 75.6173 7.43108V21.8992C75.6173 26.4028 72.6899 29.3302 68.1863 29.3302H53.7182C49.2145 29.3302 46.2871 26.4028 46.2871 21.8992V7.43108Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_705_6507",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 46,
      y: 0,
      width: 30,
      height: 30,
      children: /*#__PURE__*/_jsx("path", {
        d: "M46.2871 7.43108C46.2871 2.92739 49.2145 0 53.7182 0H68.1863C72.6899 0 75.6173 2.92739 75.6173 7.43108V21.8992C75.6173 26.4028 72.6899 29.3302 68.1863 29.3302H53.7182C49.2145 29.3302 46.2871 26.4028 46.2871 21.8992V7.43108Z",
        fill: "#ED1C24"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_705_6507)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M66.7923 14.4447C66.509 15.7452 66.2618 19.2469 66.2285 20.0863C66.1952 20.9256 66.4681 21.4408 67.139 21.7729C67.713 22.0571 68.2544 22.0497 68.7764 21.6786C68.9721 21.5394 68.6736 19.3188 68.7764 17.8125C68.99 14.6821 70.452 9.9545 70.452 9.9545L70.4562 9.92934C70.4823 9.77505 70.5081 9.62221 70.5081 9.49359C70.5081 8.6807 70.1105 8.16593 69.2593 8.08467C68.3803 8.00316 67.9252 8.40997 67.1315 9.33106C65.371 11.4173 63.2706 14.5338 62.2776 15.9703C62.1648 16.1319 61.9656 16.0783 61.9656 15.8614C61.9656 15.2113 64.3313 8.27607 64.3313 8.27607C64.3313 8.27607 64.6098 7.32586 63.798 6.99692C63.798 6.99692 62.5792 6.26529 61.5454 7.7157L56.7459 13.9816C56.3691 14.4612 56.1821 14.2837 56.1821 14.2837C56.065 14.2266 56.1404 13.8693 56.1404 13.8693L56.8973 9.78469C57.5031 6.64445 56.349 6.47925 55.6277 6.38658C54.9067 6.29391 54.041 6.81232 54.041 6.81232C52.5407 7.53133 51.4086 10.3921 51.4086 10.3921C51.4086 10.3921 51.0694 11.41 51.7841 11.8025C51.7841 11.8025 52.0557 12.0179 52.5829 11.9995C53.6307 11.9626 53.8487 10.0554 54.615 10.0554C54.7575 10.0554 54.7575 10.2179 54.7575 10.2451L52.279 20.2032C52.279 20.2032 51.995 21.1893 52.8987 21.7169C54.0542 22.3913 54.8025 21.2703 54.8025 21.2703L55.6691 19.9327C56.9926 17.7194 59.3911 14.5466 59.6462 14.5466C59.7315 14.5466 59.7595 14.5745 59.7595 14.6546L58.9122 20.4902C58.9122 20.4902 58.7292 21.4561 59.6241 21.7729C59.6241 21.7729 60.4973 22.0653 60.9999 21.6786C60.9999 21.6786 61.6254 21.2739 62.2489 20.2975C62.7296 19.5446 65.1469 16.8284 66.6221 14.3361C66.7361 14.1733 66.821 14.3086 66.7923 14.4447Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.4004 37.3046L31.7588 35.7464H29.7882L29.1924 37.3046H28.5967L30.5215 32.4009H31.0256L32.9504 37.3046H32.4004ZM31.6214 35.2423L31.0256 33.6841C31.0256 33.6383 30.9798 33.5925 30.9798 33.5008C30.9339 33.4092 30.9339 33.3175 30.8881 33.2259C30.8423 33.1342 30.8423 33.0425 30.7964 32.9967C30.7964 33.0884 30.7506 33.18 30.7048 33.2717C30.659 33.3633 30.659 33.455 30.6131 33.5008C30.5673 33.5925 30.5673 33.6383 30.5673 33.6841L29.9715 35.2423H31.6214Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M37.6705 37.3046L36.0206 32.9509H35.9748C35.9748 33.0425 35.9748 33.1342 36.0206 33.2717C36.0206 33.4092 36.0206 33.5467 36.0206 33.6841C36.0206 33.8216 36.0206 34.0049 36.0206 34.1424V37.2588H35.4707V32.4009H36.3414L37.8996 36.4797H37.9454L39.5494 32.4009H40.3744V37.3046H39.8244V34.1424C39.8244 34.0049 39.8244 33.8675 39.8244 33.6841C39.8244 33.5467 39.8244 33.4092 39.8244 33.2717C39.8244 33.1342 39.8244 33.0425 39.8244 32.9509H39.7786L38.0829 37.3046H37.6705Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.0317 33.5467C43.4899 33.5467 43.8107 33.6384 44.0399 33.8217C44.269 34.005 44.3607 34.3258 44.3607 34.7841V37.3046H43.9482L43.8566 36.7547H43.8107C43.7191 36.8922 43.5816 36.9838 43.4899 37.0755C43.3983 37.1671 43.2608 37.213 43.0775 37.2588C42.94 37.3046 42.7567 37.3046 42.5275 37.3046C42.2984 37.3046 42.1151 37.2588 41.9318 37.1671C41.7485 37.0755 41.611 36.9838 41.5193 36.8005C41.4277 36.663 41.3818 36.4339 41.3818 36.2047C41.3818 35.8381 41.5193 35.5631 41.8401 35.3798C42.1151 35.1965 42.5734 35.059 43.1691 35.059L43.8107 35.0132V34.7841C43.8107 34.4633 43.7191 34.2341 43.5816 34.0966C43.4441 33.9592 43.2608 33.9133 42.9858 33.9133C42.8025 33.9133 42.6192 33.9591 42.4359 34.005C42.2526 34.0508 42.1151 34.1425 41.9318 34.1883L41.7485 33.7758C41.9318 33.6842 42.1151 33.6383 42.3442 33.5467C42.5734 33.5925 42.8025 33.5467 43.0317 33.5467ZM43.7649 35.4715L43.215 35.5173C42.7567 35.5173 42.4359 35.609 42.2526 35.7465C42.0693 35.8839 41.9776 36.0673 41.9776 36.2964C41.9776 36.5255 42.0234 36.663 42.1609 36.7547C42.2984 36.8463 42.4817 36.8922 42.665 36.8922C42.9858 36.8922 43.2608 36.8005 43.4899 36.6172C43.7191 36.4339 43.8107 36.1589 43.8107 35.7923V35.4715H43.7649Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M46.0568 32.0801V34.784C46.0568 34.8756 46.0568 34.9673 46.0568 35.1048C46.0568 35.2422 46.0568 35.3339 46.0568 35.4256H46.1026C46.1484 35.3797 46.2401 35.2881 46.3317 35.1506C46.4234 35.0589 46.5151 34.9673 46.5609 34.8756L47.7983 33.5924H48.4399L46.9275 35.1506L48.5315 37.2587H47.8441L46.5151 35.5172L46.0568 35.9297V37.2587H45.5068V32.0801H46.0568Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M50.5942 33.5467C50.915 33.5467 51.19 33.6383 51.4191 33.7758C51.6483 33.9133 51.8316 34.0966 51.9233 34.3716C52.0607 34.6007 52.1066 34.9215 52.1066 35.2423V35.609H49.5402C49.5402 36.0214 49.6777 36.3881 49.861 36.6172C50.0901 36.8463 50.3651 36.938 50.7317 36.938C50.9609 36.938 51.19 36.938 51.3733 36.8922C51.5566 36.8463 51.7399 36.8005 51.9233 36.7089V37.1213C51.7399 37.213 51.5566 37.2588 51.3733 37.3046C51.19 37.3505 50.9609 37.3505 50.7317 37.3505C50.3651 37.3505 50.0443 37.2588 49.8151 37.1213C49.5402 36.9838 49.3569 36.7547 49.2194 36.4797C49.0819 36.2047 48.9902 35.8381 48.9902 35.4715C48.9902 35.059 49.0361 34.7382 49.1735 34.4633C49.311 34.1883 49.4943 33.9591 49.7235 33.7758C49.9526 33.6383 50.2276 33.5467 50.5942 33.5467ZM50.5484 34.005C50.2276 34.005 49.9985 34.0966 49.8151 34.28C49.6318 34.4633 49.5402 34.7382 49.4943 35.1049H51.465C51.465 34.8757 51.4191 34.6924 51.3733 34.5091C51.3275 34.3258 51.19 34.2341 51.0525 34.1425C50.9609 34.0508 50.7775 34.005 50.5484 34.005Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M55.315 37.3046L53.6652 32.9509H53.6193C53.6193 33.0425 53.6193 33.1342 53.6652 33.2717C53.6652 33.4092 53.6652 33.5467 53.6652 33.6841C53.6652 33.8216 53.6652 34.0049 53.6652 34.1424V37.2588H53.1152V32.4009H53.986L55.5441 36.4797H55.59L57.194 32.4009H58.0189V37.3046H57.4689V34.1424C57.4689 34.0049 57.4689 33.8675 57.4689 33.6841C57.4689 33.5467 57.4689 33.4092 57.4689 33.2717C57.4689 33.1342 57.4689 33.0425 57.4689 32.9509L55.7733 37.3046H55.315Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M58.7061 33.6382H59.3018L60.1267 35.7921C60.1726 35.9296 60.2184 36.0213 60.2642 36.1588C60.3101 36.2504 60.3559 36.3879 60.3559 36.4795C60.3559 36.5712 60.4017 36.7087 60.4475 36.8004H60.4934C60.5392 36.7087 60.585 36.5254 60.6309 36.3421C60.6767 36.1588 60.7683 35.9754 60.8142 35.7921L61.5933 33.684H62.189L60.585 37.9002C60.4934 38.1294 60.4017 38.3127 60.2642 38.496C60.1726 38.6793 60.0351 38.771 59.8518 38.8626C59.6685 38.9543 59.4851 39.0001 59.256 39.0001C59.1643 39.0001 59.0727 39.0001 58.981 39.0001C58.8894 39.0001 58.8435 38.9543 58.7519 38.9543V38.496C58.7977 38.496 58.8435 38.496 58.9352 38.5418C59.0269 38.5418 59.0727 38.5418 59.1643 38.5418C59.3018 38.5418 59.4393 38.496 59.531 38.4502C59.6226 38.4043 59.7143 38.3127 59.8059 38.221C59.8976 38.1294 59.9434 37.9919 59.9893 37.8544L60.1726 37.3503L58.7061 33.6382Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M64.3883 37.3046H63.7925V32.9051H62.2344V32.4009H65.9465V32.9051H64.3883V37.3046Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M68.2836 33.5467C68.3752 33.5467 68.421 33.5467 68.5127 33.5467C68.6043 33.5467 68.6502 33.5467 68.7418 33.5925L68.6502 34.0966C68.6043 34.0966 68.5127 34.0508 68.4669 34.0508C68.3752 34.0508 68.3294 34.0508 68.2377 34.0508C68.1002 34.0508 67.9628 34.0966 67.8253 34.1425C67.6878 34.1883 67.5961 34.2799 67.4586 34.4174C67.367 34.5091 67.2753 34.6466 67.2295 34.8299C67.1837 34.9674 67.1378 35.1507 67.1378 35.334V37.3046H66.5879V33.6384H67.0462L67.092 34.3258H67.1378C67.2295 34.1883 67.3211 34.0508 67.4128 33.9591C67.5045 33.8675 67.6419 33.7758 67.7794 33.6842C67.9627 33.5925 68.1002 33.5467 68.2836 33.5467Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M69.9796 33.6382V37.3044H69.4296V33.6382H69.9796ZM69.7046 32.2633C69.7962 32.2633 69.8879 32.3091 69.9337 32.355C69.9796 32.4008 70.0254 32.4924 70.0254 32.6299C70.0254 32.7674 69.9796 32.8591 69.9337 32.9049C69.8879 32.9507 69.7962 32.9966 69.7046 32.9966C69.6129 32.9966 69.5213 32.9507 69.4754 32.9049C69.4296 32.8591 69.3838 32.7674 69.3838 32.6299C69.3838 32.4924 69.4296 32.4008 69.4754 32.355C69.5671 32.2633 69.6129 32.2633 69.7046 32.2633Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M72.9583 33.5467C73.4166 33.5467 73.7832 33.6842 74.0582 34.005C74.3331 34.3258 74.4706 34.7841 74.4706 35.4257C74.4706 35.8381 74.4248 36.2047 74.2873 36.4797C74.1498 36.7547 73.9665 36.9838 73.7374 37.1213C73.5082 37.2588 73.2332 37.3505 72.9124 37.3505C72.7291 37.3505 72.5458 37.3046 72.4083 37.2588C72.2709 37.213 72.1334 37.1213 72.0417 37.0297C71.9501 36.938 71.8584 36.8463 71.7667 36.7547H71.7209C71.7209 36.8463 71.7209 36.938 71.7667 37.0755C71.7667 37.213 71.7667 37.3046 71.7667 37.3963V38.9545H71.2168V33.6384H71.6751L71.7667 34.1883H71.8126C71.9042 34.0966 71.95 33.9592 72.0875 33.8675C72.1792 33.7758 72.3167 33.6842 72.4542 33.6384C72.5458 33.5925 72.7291 33.5467 72.9583 33.5467ZM72.8208 34.005C72.5458 34.005 72.3625 34.0508 72.1792 34.1425C72.0417 34.2341 71.9042 34.3716 71.8584 34.6007C71.7667 34.7841 71.7667 35.059 71.7209 35.334V35.4257C71.7209 35.7465 71.7667 36.0214 71.8126 36.2047C71.9042 36.4339 71.9959 36.5714 72.1334 36.7089C72.3167 36.8005 72.5 36.8922 72.775 36.8922C73.0041 36.8922 73.1874 36.8463 73.3707 36.7089C73.5082 36.5714 73.6457 36.4339 73.6915 36.2047C73.7832 35.9756 73.829 35.7465 73.829 35.4257C73.829 35.0132 73.7374 34.6466 73.5541 34.3716C73.4624 34.1425 73.1874 34.005 72.8208 34.005Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M79.4671 34.7381H81.2085V37.1212C80.9336 37.2129 80.6586 37.2587 80.3836 37.3045C80.1087 37.3503 79.7879 37.3503 79.4671 37.3503C78.963 37.3503 78.5047 37.2587 78.1839 37.0295C77.8172 36.8462 77.5423 36.5254 77.359 36.1588C77.1756 35.7922 77.084 35.3339 77.084 34.8298C77.084 34.3257 77.1756 33.8674 77.4048 33.5007C77.5881 33.1341 77.9089 32.8133 78.2755 32.63C78.6421 32.4009 79.1004 32.3092 79.6504 32.3092C79.9253 32.3092 80.2003 32.355 80.4295 32.4009C80.6586 32.4467 80.8878 32.5383 81.1169 32.63L80.8878 33.1341C80.7044 33.0425 80.5211 32.9966 80.292 32.9508C80.0628 32.905 79.8337 32.8591 79.6046 32.8591C79.1921 32.8591 78.8713 32.9508 78.5505 33.0883C78.2755 33.2716 78.0464 33.5007 77.9089 33.7757C77.7714 34.0965 77.6798 34.4173 77.6798 34.8298C77.6798 35.2422 77.7256 35.6089 77.8631 35.8838C78.0006 36.2046 78.1839 36.4338 78.5047 36.5713C78.7796 36.7546 79.1463 36.8004 79.6046 36.8004C79.8337 36.8004 80.017 36.8004 80.2003 36.7546C80.3836 36.7087 80.5211 36.7087 80.6586 36.6629V35.1506H79.4671V34.7381Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M84.0033 33.5467C84.0949 33.5467 84.1408 33.5467 84.2324 33.5467C84.3241 33.5467 84.3699 33.5467 84.4616 33.5925L84.3699 34.0966C84.3241 34.0966 84.2324 34.0508 84.1866 34.0508C84.0949 34.0508 84.0491 34.0508 83.9574 34.0508C83.82 34.0508 83.6825 34.0966 83.545 34.1425C83.4075 34.1883 83.3158 34.2799 83.1784 34.4174C83.0867 34.5091 82.995 34.6466 82.9492 34.8299C82.9034 34.9674 82.8576 35.1507 82.8576 35.334V37.3046H82.3076V33.6384H82.7659L82.8117 34.3258H82.8576C82.9492 34.1883 83.0409 34.0508 83.1325 33.9591C83.2242 33.8675 83.3617 33.7758 83.4992 33.6842C83.6366 33.5925 83.82 33.5467 84.0033 33.5467Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M88.357 35.4713C88.357 35.7921 88.3112 36.0213 88.2195 36.2962C88.1278 36.5254 88.0362 36.7545 87.8987 36.892C87.7612 37.0753 87.5779 37.167 87.3488 37.2586C87.1196 37.3503 86.8905 37.3961 86.6155 37.3961C86.3864 37.3961 86.1572 37.3503 85.9281 37.2586C85.7448 37.167 85.5614 37.0295 85.3781 36.892C85.2406 36.7087 85.1032 36.5254 85.0115 36.2962C84.9199 36.0671 84.874 35.7921 84.874 35.4713C84.874 35.0589 84.9657 34.7381 85.1032 34.4631C85.2407 34.1881 85.424 33.959 85.6989 33.8215C85.9739 33.684 86.2489 33.5923 86.6155 33.5923C86.9363 33.5923 87.2571 33.684 87.4862 33.8215C87.7612 33.959 87.9445 34.1881 88.082 34.4631C88.2653 34.6922 88.357 35.0589 88.357 35.4713ZM85.5156 35.4713C85.5156 35.7463 85.5614 36.0213 85.6531 36.2504C85.7448 36.4795 85.8364 36.617 86.0197 36.7545C86.203 36.892 86.3864 36.9378 86.6613 36.9378C86.9363 36.9378 87.1196 36.892 87.3029 36.7545C87.4862 36.617 87.5779 36.4795 87.6696 36.2504C87.7612 36.0213 87.807 35.7921 87.807 35.4713C87.807 35.1963 87.7612 34.9214 87.6696 34.6922C87.5779 34.4631 87.4862 34.3256 87.3029 34.1881C87.1196 34.0506 86.9363 34.0048 86.6613 34.0048C86.2947 34.0048 85.9739 34.1423 85.7906 34.3714C85.6073 34.6464 85.5156 35.013 85.5156 35.4713Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M92.3888 33.6384V37.3046H91.9305L91.8389 36.8005C91.7472 36.938 91.6555 37.0297 91.5181 37.1213C91.3806 37.213 91.2431 37.2588 91.1056 37.3046C90.9681 37.3505 90.7848 37.3505 90.6015 37.3505C90.3265 37.3505 90.0515 37.3046 89.8682 37.213C89.6849 37.1213 89.5016 36.9838 89.4099 36.7547C89.3183 36.5714 89.2725 36.2964 89.2725 35.9756V33.5467H89.8224V35.9298C89.8224 36.2506 89.9141 36.4797 90.0516 36.6172C90.189 36.7547 90.4182 36.8463 90.6931 36.8463C90.9681 36.8463 91.1973 36.8005 91.3347 36.7089C91.5181 36.6172 91.6097 36.4339 91.7014 36.2506C91.793 36.0673 91.793 35.7923 91.793 35.5173V33.5925H92.3888V33.6384Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M95.3235 33.5467C95.7818 33.5467 96.1484 33.6842 96.4234 34.005C96.6984 34.3258 96.8359 34.7841 96.8359 35.4257C96.8359 35.8381 96.79 36.2047 96.6525 36.4797C96.5151 36.7547 96.3317 36.9838 96.1026 37.1213C95.8735 37.2588 95.5985 37.3505 95.2777 37.3505C95.0944 37.3505 94.9111 37.3046 94.7736 37.2588C94.6361 37.213 94.4986 37.1213 94.4069 37.0297C94.3153 36.938 94.2236 36.8463 94.132 36.7547H94.0861C94.0861 36.8463 94.0861 36.938 94.132 37.0755C94.132 37.213 94.132 37.3046 94.132 37.3963V38.9545H93.582V33.6384H94.0403L94.132 34.1883H94.1778C94.2695 34.0966 94.3153 33.9592 94.4528 33.8675C94.5444 33.7758 94.6819 33.6842 94.8194 33.6384C94.9569 33.5925 95.1402 33.5467 95.3235 33.5467ZM95.2319 34.005C94.9569 34.005 94.7736 34.0508 94.5903 34.1425C94.4528 34.2341 94.3153 34.3716 94.2695 34.6007C94.1778 34.7841 94.1778 35.059 94.132 35.334V35.4257C94.132 35.7465 94.1778 36.0214 94.2236 36.2047C94.3153 36.4339 94.4069 36.5714 94.5444 36.7089C94.7277 36.8005 94.9111 36.8922 95.186 36.8922C95.4152 36.8922 95.5985 36.8463 95.7818 36.7089C95.9193 36.5714 96.0568 36.4339 96.1026 36.2047C96.1943 35.9756 96.2401 35.7465 96.2401 35.4257C96.2401 35.0132 96.1484 34.6466 95.9651 34.3716C95.8276 34.1425 95.5985 34.005 95.2319 34.005Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M101.83 32.8133C101.555 32.8133 101.326 32.8591 101.097 32.9508C100.868 33.0425 100.685 33.1799 100.547 33.3633C100.41 33.5466 100.272 33.7299 100.181 34.0049C100.089 34.234 100.043 34.5548 100.043 34.8298C100.043 35.2422 100.089 35.6089 100.226 35.8838C100.364 36.2046 100.547 36.4338 100.822 36.5713C101.097 36.7546 101.418 36.8004 101.785 36.8004C102.014 36.8004 102.197 36.8004 102.426 36.7546C102.61 36.7087 102.793 36.6629 103.022 36.6171V37.1212C102.839 37.167 102.655 37.2587 102.472 37.2587C102.289 37.3045 102.06 37.3045 101.785 37.3045C101.28 37.3045 100.868 37.2129 100.501 36.9837C100.181 36.7546 99.9056 36.4796 99.7223 36.113C99.539 35.7463 99.4932 35.2881 99.4932 34.7839C99.4932 34.4173 99.539 34.0965 99.6307 33.7757C99.7223 33.4549 99.9056 33.1799 100.089 32.9966C100.272 32.7675 100.547 32.5842 100.822 32.4925C101.097 32.355 101.464 32.3092 101.83 32.3092C102.06 32.3092 102.335 32.355 102.564 32.4009C102.793 32.4467 103.022 32.5383 103.205 32.63L102.976 33.1341C102.839 33.0425 102.655 32.9966 102.472 32.9508C102.243 32.8591 102.06 32.8133 101.83 32.8133Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M107.239 35.4713C107.239 35.7921 107.193 36.0213 107.101 36.2962C107.01 36.5254 106.918 36.7545 106.781 36.892C106.643 37.0753 106.46 37.167 106.231 37.2586C106.001 37.3503 105.772 37.3961 105.497 37.3961C105.268 37.3961 105.039 37.3503 104.81 37.2586C104.627 37.167 104.443 37.0295 104.26 36.892C104.122 36.7087 103.985 36.5254 103.893 36.2962C103.802 36.0671 103.756 35.7921 103.756 35.4713C103.756 35.0589 103.848 34.7381 103.985 34.4631C104.122 34.1881 104.306 33.959 104.581 33.8215C104.856 33.684 105.131 33.5923 105.497 33.5923C105.818 33.5923 106.139 33.684 106.368 33.8215C106.643 33.959 106.826 34.1881 106.964 34.4631C107.147 34.6922 107.239 35.0589 107.239 35.4713ZM104.397 35.4713C104.397 35.7463 104.443 36.0213 104.535 36.2504C104.627 36.4795 104.718 36.617 104.902 36.7545C105.085 36.892 105.268 36.9378 105.543 36.9378C105.818 36.9378 106.001 36.892 106.185 36.7545C106.368 36.617 106.46 36.4795 106.551 36.2504C106.643 36.0213 106.689 35.7921 106.689 35.4713C106.689 35.1963 106.643 34.9214 106.551 34.6922C106.46 34.4631 106.368 34.3256 106.185 34.1881C106.001 34.0506 105.818 34.0048 105.543 34.0048C105.177 34.0048 104.856 34.1423 104.672 34.3714C104.489 34.6464 104.397 35.013 104.397 35.4713Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M112.234 33.5467C112.647 33.5467 112.967 33.6384 113.151 33.8675C113.38 34.0966 113.472 34.4174 113.472 34.8757V37.3046H112.922V34.9215C112.922 34.6466 112.876 34.4174 112.738 34.2341C112.601 34.0966 112.417 34.005 112.142 34.005C111.776 34.005 111.501 34.0966 111.363 34.3258C111.18 34.5091 111.134 34.8299 111.134 35.2423V37.3046H110.584V34.9215C110.584 34.7382 110.538 34.5549 110.493 34.4174C110.447 34.2799 110.355 34.1883 110.218 34.1425C110.126 34.0966 109.943 34.0508 109.805 34.0508C109.576 34.0508 109.347 34.0966 109.209 34.1883C109.072 34.2799 108.934 34.4174 108.889 34.6466C108.843 34.8299 108.797 35.1049 108.797 35.3798V37.3046H108.247V33.6384H108.705L108.797 34.1425H108.843C108.934 34.005 109.026 33.9133 109.118 33.8217C109.209 33.73 109.347 33.6842 109.484 33.6384C109.622 33.5925 109.759 33.5925 109.943 33.5925C110.218 33.5925 110.447 33.6383 110.63 33.73C110.813 33.8217 110.951 34.005 111.043 34.1883H111.088C111.226 33.9591 111.363 33.8217 111.593 33.73C111.73 33.5925 111.959 33.5467 112.234 33.5467Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M116.358 33.5467C116.816 33.5467 117.183 33.6842 117.458 34.005C117.733 34.3258 117.87 34.7841 117.87 35.4257C117.87 35.8381 117.824 36.2047 117.687 36.4797C117.549 36.7547 117.366 36.9838 117.137 37.1213C116.908 37.2588 116.633 37.3505 116.312 37.3505C116.129 37.3505 115.945 37.3046 115.808 37.2588C115.67 37.213 115.533 37.1213 115.441 37.0297C115.349 36.938 115.258 36.8463 115.166 36.7547H115.12C115.12 36.8463 115.12 36.938 115.166 37.0755C115.166 37.213 115.166 37.3046 115.166 37.3963V38.9545H114.616V33.6384H115.074L115.166 34.1883H115.212C115.304 34.0966 115.395 33.9592 115.487 33.8675C115.579 33.7758 115.716 33.6842 115.854 33.6384C115.991 33.5925 116.174 33.5467 116.358 33.5467ZM116.266 34.005C115.991 34.005 115.808 34.0508 115.624 34.1425C115.487 34.2341 115.349 34.3716 115.304 34.6007C115.212 34.7841 115.212 35.059 115.166 35.334V35.4257C115.166 35.7465 115.212 36.0214 115.258 36.2047C115.349 36.4339 115.441 36.5714 115.579 36.7089C115.762 36.8005 115.945 36.8922 116.22 36.8922C116.449 36.8922 116.633 36.8463 116.816 36.7089C116.953 36.5714 117.091 36.4339 117.137 36.2047C117.228 35.9756 117.274 35.7465 117.274 35.4257C117.274 35.0132 117.183 34.6466 116.999 34.3716C116.862 34.1425 116.633 34.005 116.266 34.005Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M120.253 33.5467C120.712 33.5467 121.032 33.6384 121.262 33.8217C121.491 34.005 121.582 34.3258 121.582 34.7841V37.3046H121.17L121.078 36.7547H121.032C120.941 36.8922 120.803 36.9838 120.712 37.0755C120.62 37.1671 120.482 37.213 120.299 37.2588C120.162 37.3046 119.978 37.3046 119.749 37.3046C119.52 37.3046 119.337 37.2588 119.153 37.1671C118.97 37.0755 118.833 36.9838 118.741 36.8005C118.649 36.663 118.604 36.4339 118.604 36.2047C118.604 35.8381 118.741 35.5631 119.062 35.3798C119.337 35.1965 119.795 35.059 120.391 35.059L121.032 35.0132V34.7841C121.032 34.4633 120.987 34.2341 120.803 34.0966C120.666 33.9592 120.482 33.9133 120.208 33.9133C120.024 33.9133 119.841 33.9591 119.658 34.005C119.474 34.0508 119.291 34.1425 119.153 34.1883L118.97 33.7758C119.153 33.6842 119.337 33.6383 119.566 33.5467C119.795 33.5925 120.024 33.5467 120.253 33.5467ZM121.032 35.4715L120.482 35.5173C120.024 35.5173 119.703 35.609 119.52 35.7465C119.337 35.8839 119.245 36.0673 119.245 36.2964C119.245 36.5255 119.291 36.663 119.428 36.7547C119.566 36.8463 119.749 36.8922 119.933 36.8922C120.253 36.8922 120.528 36.8005 120.757 36.6172C120.987 36.4339 121.078 36.1589 121.078 35.7923V35.4715H121.032Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M124.47 33.5467C124.928 33.5467 125.249 33.6384 125.478 33.8675C125.707 34.0966 125.799 34.4174 125.799 34.8757V37.2588H125.295V34.9215C125.295 34.6007 125.203 34.3716 125.066 34.2341C124.928 34.0966 124.699 34.005 124.424 34.005C124.012 34.005 123.737 34.1425 123.554 34.3716C123.37 34.6007 123.324 34.9215 123.324 35.3798V37.3046H122.774V33.6384H123.233L123.324 34.1883H123.37C123.462 34.0508 123.553 33.9592 123.691 33.8675C123.828 33.7758 123.966 33.73 124.103 33.6842C124.149 33.5925 124.333 33.5467 124.47 33.5467Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M126.394 33.6382H126.989L127.814 35.7921C127.86 35.9296 127.906 36.0213 127.952 36.1588C127.998 36.2504 128.043 36.3879 128.043 36.4795C128.043 36.5712 128.089 36.7087 128.135 36.8004H128.181C128.227 36.7087 128.273 36.5254 128.318 36.3421C128.364 36.1588 128.456 35.9754 128.502 35.7921L129.281 33.684H129.877L128.273 37.9002C128.181 38.1294 128.089 38.3127 127.952 38.496C127.86 38.6793 127.723 38.771 127.539 38.8626C127.356 38.9543 127.173 39.0001 126.944 39.0001C126.852 39.0001 126.76 39.0001 126.669 39.0001C126.577 39.0001 126.531 38.9543 126.439 38.9543V38.496C126.485 38.496 126.531 38.496 126.623 38.5418C126.714 38.5418 126.76 38.5418 126.852 38.5418C126.989 38.5418 127.127 38.496 127.218 38.4502C127.31 38.4043 127.402 38.3127 127.493 38.221C127.585 38.1294 127.631 37.9919 127.677 37.8544L127.86 37.3503L126.394 33.6382Z",
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TripMoneyLogo.tsx




var TripMoneyLogo_TripMoneyLogo = function TripMoneyLogo(_ref) {
  var darkHeader = _ref.darkHeader,
      lightHeader = _ref.lightHeader;
  return /*#__PURE__*/_jsxs("svg", {
    width: 140,
    height: 39,
    viewBox: "0 0 140 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M6.50765 10.3113V17.873C6.50765 18.5604 6.73679 18.7896 6.87427 18.8812C7.14924 19.0187 7.47004 19.1104 7.8825 19.1104C8.2033 19.1104 9.1657 18.8354 9.71564 18.6062L10.3114 18.4229V21.3101L10.0823 21.4476C9.25735 21.8601 8.38661 22.0892 7.47004 22.0892C3.89542 22.0892 3.11634 19.9353 3.11634 18.1021V10.3113H0L6.50765 3.75781V7.33243H10.3572V10.3113H6.50765Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.0806 7.05664V10.2646H20.3932C19.4308 10.2646 18.5142 10.4479 17.6435 10.8146C16.8644 11.1812 16.2686 11.6395 15.8103 12.2353V21.7218H12.4648V7.33161H14.8938L15.4895 9.07309C16.7727 7.74407 18.4225 7.10247 20.3473 7.10247H21.0806V7.05664Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.3506 3.57547C26.3506 4.53787 25.5716 5.31695 24.6092 5.31695C23.6468 5.31695 22.8677 4.53787 22.8677 3.57547C22.8677 2.61307 23.6468 1.83398 24.6092 1.83398C25.5257 1.83398 26.3506 2.61307 26.3506 3.57547Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.2132 7.33203H22.8677V21.8138H26.2132V7.33203Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.886 9.074C40.5112 7.69915 38.9072 7.01172 37.074 7.01172C35.2409 7.01172 33.4994 8.1116 32.7203 8.70737L32.0329 7.33252H29.604V27.9095H32.9495V20.6228C34.141 21.5852 35.5159 22.0893 37.0282 22.0893C38.8155 22.0893 40.3737 21.4477 41.7027 20.1645L41.8402 20.027C43.2151 18.6522 43.9025 16.819 43.9025 14.5734C43.9483 12.282 43.2609 10.4489 41.886 9.074ZM36.7074 18.8813C35.2867 18.8813 34.0494 18.3314 32.9495 17.1856V11.9154C34.0494 10.7697 35.2409 10.2197 36.7074 10.2197C37.899 10.2197 38.8155 10.5863 39.5488 11.3196C40.282 12.0529 40.6028 13.1527 40.6028 14.5276C40.6028 15.9024 40.2362 17.0023 39.5488 17.7356C38.8155 18.5147 37.899 18.8813 36.7074 18.8813Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M90.3266 9.11892C88.9976 7.74407 87.2103 7.05664 85.0563 7.05664C82.9024 7.05664 81.1151 7.74407 79.7861 9.11892C78.457 10.4938 77.8154 12.3269 77.8154 14.5267C77.8154 16.7723 78.5029 18.5596 79.7861 19.9344C81.1151 21.3093 82.9024 21.9967 85.0563 21.9967C87.2103 21.9967 88.9976 21.3093 90.3266 19.9344C91.6556 18.5596 92.3431 16.7265 92.3431 14.5267C92.2972 12.3269 91.6098 10.4938 90.3266 9.11892ZM85.0563 18.9262C84.0023 18.9262 83.0857 18.5596 82.3066 17.8263C81.5275 17.1389 81.1151 15.9932 81.1151 14.5267C81.1151 13.0602 81.5275 11.9603 82.2608 11.227C83.0399 10.4938 83.9565 10.1271 85.0105 10.1271C86.0646 10.1271 86.9811 10.4938 87.7602 11.227C88.5393 11.9145 88.9059 13.0143 88.9059 14.5267C88.9059 15.9932 88.4935 17.1389 87.7602 17.8263C87.027 18.5596 86.1104 18.9262 85.0563 18.9262Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M107.788 12.6935V21.7676H104.443V12.9685C104.443 11.0437 103.664 10.173 101.968 10.173C100.593 10.173 99.3099 10.9521 98.0725 12.4186V21.7676H94.7271V7.33161H97.156L97.7976 9.07309C99.2182 7.74407 100.776 7.05664 102.564 7.05664C104.168 7.05664 105.451 7.60658 106.413 8.70647C107.33 9.76052 107.788 11.1354 107.788 12.6935Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M122.132 17.5981C120.849 18.423 119.474 18.8355 118.008 18.8355C116.541 18.8355 115.441 18.5147 114.754 17.9189C114.158 17.4148 113.791 16.7274 113.608 15.8108H123.782V14.0235C123.69 12.1445 123.14 10.5405 122.086 9.21149C120.941 7.74497 119.199 7.01172 116.999 7.01172C114.8 7.01172 113.104 7.74497 111.912 9.21149C110.767 10.678 110.171 12.5111 110.171 14.7109C110.171 16.9107 110.812 18.698 112.142 20.027C113.425 21.356 115.166 21.9976 117.32 21.9976C119.382 21.9976 121.261 21.5394 122.82 20.6686L123.003 20.6228L122.82 17.1856L122.132 17.5981ZM113.562 12.9694C113.7 12.0529 114.066 11.3654 114.616 10.9071C115.304 10.3114 116.083 10.0364 116.954 10.0364C117.824 10.0364 118.603 10.3114 119.291 10.9071C119.887 11.4113 120.253 12.0987 120.345 12.9694H113.562Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M139.18 7.33203L138.951 7.9278L130.656 27.909H127.219L129.694 21.5389L123.919 7.33203H127.494L131.481 17.3685L135.606 7.33203H139.18Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M46.2866 7.43108C46.2866 2.92739 49.214 0 53.7177 0H68.1858C72.6895 0 75.6169 2.92739 75.6169 7.43108V21.8992C75.6169 26.4028 72.6895 29.3302 68.1858 29.3302H53.7177C49.214 29.3302 46.2866 26.4028 46.2866 21.8992V7.43108Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_841_14902",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 46,
      y: 0,
      width: 30,
      height: 30,
      children: /*#__PURE__*/_jsx("path", {
        d: "M46.2866 7.43108C46.2866 2.92739 49.214 0 53.7177 0H68.1858C72.6895 0 75.6169 2.92739 75.6169 7.43108V21.8992C75.6169 26.4028 72.6895 29.3302 68.1858 29.3302H53.7177C49.214 29.3302 46.2866 26.4028 46.2866 21.8992V7.43108Z",
        fill: "#ED1C24"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_841_14902)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M66.7918 14.4442C66.5085 15.7447 66.2613 19.2464 66.228 20.0858C66.1947 20.9251 66.4676 21.4404 67.1385 21.7724C67.7125 22.0566 68.2539 22.0493 68.7759 21.6781C68.9716 21.5389 68.6731 19.3183 68.7759 17.812C68.9895 14.6816 70.4515 9.95402 70.4515 9.95402L70.4557 9.92885C70.4818 9.77456 70.5076 9.62172 70.5076 9.49311C70.5076 8.68021 70.11 8.16544 69.2589 8.08418C68.3798 8.00267 67.9247 8.40948 67.131 9.33057C65.3705 11.4168 63.2701 14.5333 62.2771 15.9698C62.1643 16.1314 61.9651 16.0778 61.9651 15.8609C61.9651 15.2108 64.3308 8.27558 64.3308 8.27558C64.3308 8.27558 64.6093 7.32538 63.7975 6.99643C63.7975 6.99643 62.5787 6.2648 61.5449 7.71521L56.7454 13.9811C56.3686 14.4607 56.1816 14.2832 56.1816 14.2832C56.0645 14.2262 56.14 13.8688 56.14 13.8688L56.8968 9.78421C57.5026 6.64396 56.3486 6.47876 55.6272 6.38609C54.9062 6.29343 54.0405 6.81183 54.0405 6.81183C52.5402 7.53085 51.4081 10.3916 51.4081 10.3916C51.4081 10.3916 51.0689 11.4095 51.7836 11.802C51.7836 11.802 52.0552 12.0174 52.5824 11.999C53.6302 11.9621 53.8482 10.0549 54.6145 10.0549C54.757 10.0549 54.757 10.2175 54.757 10.2446L52.2785 20.2027C52.2785 20.2027 51.9945 21.1888 52.8982 21.7164C54.0538 22.3908 54.802 21.2698 54.802 21.2698L55.6687 19.9322C56.9921 17.7189 59.3906 14.5461 59.6457 14.5461C59.7311 14.5461 59.759 14.574 59.759 14.6541L58.9117 20.4897C58.9117 20.4897 58.7287 21.4556 59.6236 21.7724C59.6236 21.7724 60.4968 22.0648 60.9994 21.6781C60.9994 21.6781 61.6249 21.2735 62.2484 20.2971C62.7291 19.5441 65.1464 16.8279 66.6216 14.3356C66.7356 14.1728 66.8205 14.3082 66.7918 14.4442Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.4 37.304L31.7584 35.7459H29.7877L29.192 37.304H28.5962L30.521 32.4004H31.0251L32.9499 37.304H32.4ZM31.6209 35.2418L31.0251 33.6836C31.0251 33.6378 30.9793 33.5919 30.9793 33.5003C30.9334 33.4086 30.9334 33.317 30.8876 33.2253C30.8418 33.1336 30.8418 33.042 30.796 32.9962C30.796 33.0878 30.7501 33.1795 30.7043 33.2711C30.6585 33.3628 30.6585 33.4544 30.6126 33.5003C30.5668 33.5919 30.5668 33.6378 30.5668 33.6836L29.971 35.2418H31.6209Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M37.6705 37.304L36.0206 32.9503H35.9748C35.9748 33.042 35.9748 33.1336 36.0206 33.2711C36.0206 33.4086 36.0206 33.5461 36.0206 33.6836C36.0206 33.8211 36.0206 34.0044 36.0206 34.1419V37.2582H35.4707V32.4004H36.3414L37.8996 36.4791H37.9454L39.5494 32.4004H40.3743V37.304H39.8244V34.1419C39.8244 34.0044 39.8244 33.8669 39.8244 33.6836C39.8244 33.5461 39.8244 33.4086 39.8244 33.2711C39.8244 33.1336 39.8244 33.042 39.8244 32.9503H39.7786L38.0829 37.304H37.6705V37.304Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.0317 33.5469C43.4899 33.5469 43.8107 33.6385 44.0399 33.8218C44.269 34.0052 44.3607 34.326 44.3607 34.7842V37.3048H43.9482L43.8566 36.7549H43.8107C43.7191 36.8924 43.5816 36.984 43.4899 37.0757C43.3983 37.1673 43.2608 37.2132 43.0775 37.259C42.94 37.3048 42.7567 37.3048 42.5275 37.3048C42.2984 37.3048 42.1151 37.259 41.9318 37.1673C41.7485 37.0757 41.611 36.984 41.5193 36.8007C41.4277 36.6632 41.3818 36.4341 41.3818 36.2049C41.3818 35.8383 41.5193 35.5633 41.8401 35.38C42.1151 35.1967 42.5734 35.0592 43.1691 35.0592L43.8107 35.0134V34.7842C43.8107 34.4634 43.7191 34.2343 43.5816 34.0968C43.4441 33.9593 43.2608 33.9135 42.9858 33.9135C42.8025 33.9135 42.6192 33.9593 42.4359 34.0052C42.2526 34.051 42.1151 34.1426 41.9318 34.1885L41.7485 33.776C41.9318 33.6844 42.1151 33.6385 42.3442 33.5469C42.5734 33.5927 42.8025 33.5469 43.0317 33.5469ZM43.7649 35.4717L43.215 35.5175C42.7567 35.5175 42.4359 35.6092 42.2526 35.7466C42.0693 35.8841 41.9776 36.0674 41.9776 36.2966C41.9776 36.5257 42.0234 36.6632 42.1609 36.7549C42.2984 36.8465 42.4817 36.8924 42.665 36.8924C42.9858 36.8924 43.2608 36.8007 43.4899 36.6174C43.7191 36.4341 43.8107 36.1591 43.8107 35.7925V35.4717H43.7649Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M46.0563 32.0801V34.784C46.0563 34.8756 46.0563 34.9673 46.0563 35.1048C46.0563 35.2422 46.0563 35.3339 46.0563 35.4256H46.1021C46.1479 35.3797 46.2396 35.2881 46.3313 35.1506C46.4229 35.0589 46.5146 34.9673 46.5604 34.8756L47.7978 33.5924H48.4394L46.927 35.1506L48.531 37.2587H47.8436L46.5146 35.5172L46.0563 35.9297V37.2587H45.5063V32.0801H46.0563Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M50.5937 33.5469C50.9145 33.5469 51.1895 33.6385 51.4187 33.776C51.6478 33.9135 51.8311 34.0968 51.9228 34.3718C52.0603 34.6009 52.1061 34.9217 52.1061 35.2425V35.6092H49.5397C49.5397 36.0216 49.6772 36.3882 49.8605 36.6174C50.0896 36.8465 50.3646 36.9382 50.7312 36.9382C50.9604 36.9382 51.1895 36.9382 51.3728 36.8924C51.5561 36.8465 51.7395 36.8007 51.9228 36.709V37.1215C51.7395 37.2132 51.5561 37.259 51.3728 37.3048C51.1895 37.3506 50.9604 37.3506 50.7312 37.3506C50.3646 37.3506 50.0438 37.259 49.8147 37.1215C49.5397 36.984 49.3564 36.7549 49.2189 36.4799C49.0814 36.2049 48.9897 35.8383 48.9897 35.4717C48.9897 35.0592 49.0356 34.7384 49.1731 34.4634C49.3105 34.1885 49.4939 33.9593 49.723 33.776C49.9521 33.6385 50.2271 33.5469 50.5937 33.5469ZM50.5479 34.0052C50.2271 34.0052 49.998 34.0968 49.8147 34.2801C49.6313 34.4634 49.5397 34.7384 49.4939 35.105H51.4645C51.4645 34.8759 51.4187 34.6926 51.3728 34.5093C51.327 34.326 51.1895 34.2343 51.052 34.1426C50.9604 34.051 50.7771 34.0052 50.5479 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M55.314 37.304L53.6642 32.9503H53.6184C53.6184 33.042 53.6184 33.1336 53.6642 33.2711C53.6642 33.4086 53.6642 33.5461 53.6642 33.6836C53.6642 33.8211 53.6642 34.0044 53.6642 34.1419V37.2582H53.1143V32.4004H53.985L55.5432 36.4791H55.589L57.193 32.4004H58.0179V37.304H57.468V34.1419C57.468 34.0044 57.468 33.8669 57.468 33.6836C57.468 33.5461 57.468 33.4086 57.468 33.2711C57.468 33.1336 57.468 33.042 57.468 32.9503L55.7723 37.304H55.314V37.304Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M58.7051 33.6387H59.3008L60.1258 35.7926C60.1716 35.9301 60.2174 36.0218 60.2632 36.1592C60.3091 36.2509 60.3549 36.3884 60.3549 36.48C60.3549 36.5717 60.4007 36.7092 60.4466 36.8008H60.4924C60.5382 36.7092 60.584 36.5259 60.6299 36.3426C60.6757 36.1592 60.7674 35.9759 60.8132 35.7926L61.5923 33.6845H62.188L60.584 37.9007C60.4924 38.1299 60.4007 38.3132 60.2632 38.4965C60.1716 38.6798 60.0341 38.7715 59.8508 38.8631C59.6675 38.9548 59.4842 39.0006 59.255 39.0006C59.1634 39.0006 59.0717 39.0006 58.9801 39.0006C58.8884 39.0006 58.8426 38.9548 58.7509 38.9548V38.4965C58.7967 38.4965 58.8426 38.4965 58.9342 38.5423C59.0259 38.5423 59.0717 38.5423 59.1634 38.5423C59.3008 38.5423 59.4383 38.4965 59.53 38.4507C59.6216 38.4048 59.7133 38.3132 59.805 38.2215C59.8966 38.1299 59.9424 37.9924 59.9883 37.8549L60.1716 37.3508L58.7051 33.6387Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M64.3873 37.304H63.7916V32.9045H62.2334V32.4004H65.9455V32.9045H64.3873V37.304V37.304Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M68.2831 33.5469C68.3747 33.5469 68.4205 33.5469 68.5122 33.5469C68.6039 33.5469 68.6497 33.5469 68.7413 33.5927L68.6497 34.0968C68.6039 34.0968 68.5122 34.051 68.4664 34.051C68.3747 34.051 68.3289 34.051 68.2372 34.051C68.0997 34.051 67.9623 34.0968 67.8248 34.1426C67.6873 34.1885 67.5956 34.2801 67.4581 34.4176C67.3665 34.5093 67.2748 34.6468 67.229 34.8301C67.1832 34.9676 67.1373 35.1509 67.1373 35.3342V37.3048H66.5874V33.6385H67.0457L67.0915 34.326H67.1373C67.229 34.1885 67.3207 34.051 67.4123 33.9593C67.504 33.8677 67.6415 33.776 67.7789 33.6844C67.9623 33.5927 68.0997 33.5469 68.2831 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M69.9796 33.6385V37.3048H69.4296V33.6385H69.9796ZM69.7046 32.2637C69.7962 32.2637 69.8879 32.3095 69.9337 32.3553C69.9796 32.4012 70.0254 32.4928 70.0254 32.6303C70.0254 32.7678 69.9796 32.8594 69.9337 32.9053C69.8879 32.9511 69.7962 32.9969 69.7046 32.9969C69.6129 32.9969 69.5213 32.9511 69.4754 32.9053C69.4296 32.8594 69.3838 32.7678 69.3838 32.6303C69.3838 32.4928 69.4296 32.4012 69.4754 32.3553C69.5671 32.2637 69.6129 32.2637 69.7046 32.2637Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M72.9583 33.5469C73.4166 33.5469 73.7832 33.6844 74.0582 34.0052C74.3331 34.326 74.4706 34.7842 74.4706 35.4258C74.4706 35.8383 74.4248 36.2049 74.2873 36.4799C74.1498 36.7549 73.9665 36.984 73.7374 37.1215C73.5082 37.259 73.2332 37.3506 72.9124 37.3506C72.7291 37.3506 72.5458 37.3048 72.4083 37.259C72.2709 37.2132 72.1334 37.1215 72.0417 37.0298C71.9501 36.9382 71.8584 36.8465 71.7667 36.7549H71.7209C71.7209 36.8465 71.7209 36.9382 71.7667 37.0757C71.7667 37.2132 71.7667 37.3048 71.7667 37.3965V38.9546H71.2168V33.6385H71.6751L71.7667 34.1885H71.8126C71.9042 34.0968 71.95 33.9593 72.0875 33.8677C72.1792 33.776 72.3167 33.6844 72.4542 33.6385C72.5458 33.5927 72.7291 33.5469 72.9583 33.5469ZM72.8208 34.0052C72.5458 34.0052 72.3625 34.051 72.1792 34.1426C72.0417 34.2343 71.9042 34.3718 71.8584 34.6009C71.7667 34.7842 71.7667 35.0592 71.7209 35.3342V35.4258C71.7209 35.7466 71.7667 36.0216 71.8126 36.2049C71.9042 36.4341 71.9959 36.5716 72.1334 36.709C72.3167 36.8007 72.5 36.8924 72.775 36.8924C73.0041 36.8924 73.1874 36.8465 73.3707 36.709C73.5082 36.5716 73.6457 36.4341 73.6915 36.2049C73.7832 35.9758 73.829 35.7466 73.829 35.4258C73.829 35.0134 73.7374 34.6468 73.5541 34.3718C73.4624 34.1426 73.1874 34.0052 72.8208 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M79.4661 34.7375H81.2076V37.1206C80.9326 37.2122 80.6576 37.2581 80.3827 37.3039C80.1077 37.3497 79.7869 37.3497 79.4661 37.3497C78.962 37.3497 78.5037 37.2581 78.1829 37.0289C77.8163 36.8456 77.5413 36.5248 77.358 36.1582C77.1747 35.7916 77.083 35.3333 77.083 34.8292C77.083 34.325 77.1747 33.8668 77.4038 33.5001C77.5871 33.1335 77.9079 32.8127 78.2745 32.6294C78.6412 32.4002 79.0995 32.3086 79.6494 32.3086C79.9244 32.3086 80.1993 32.3544 80.4285 32.4002C80.6576 32.4461 80.8868 32.5377 81.1159 32.6294L80.8868 33.1335C80.7035 33.0419 80.5201 32.996 80.291 32.9502C80.0619 32.9044 79.8327 32.8585 79.6036 32.8585C79.1911 32.8585 78.8703 32.9502 78.5495 33.0877C78.2745 33.271 78.0454 33.5001 77.9079 33.7751C77.7704 34.0959 77.6788 34.4167 77.6788 34.8292C77.6788 35.2416 77.7246 35.6082 77.8621 35.8832C77.9996 36.204 78.1829 36.4332 78.5037 36.5706C78.7787 36.754 79.1453 36.7998 79.6036 36.7998C79.8327 36.7998 80.016 36.7998 80.1993 36.754C80.3827 36.7081 80.5201 36.7081 80.6576 36.6623V35.15H79.4661V34.7375Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M84.0023 33.5469C84.094 33.5469 84.1398 33.5469 84.2314 33.5469C84.3231 33.5469 84.3689 33.5469 84.4606 33.5927L84.3689 34.0968C84.3231 34.0968 84.2314 34.051 84.1856 34.051C84.094 34.051 84.0481 34.051 83.9565 34.051C83.819 34.051 83.6815 34.0968 83.544 34.1426C83.4065 34.1885 83.3149 34.2801 83.1774 34.4176C83.0857 34.5093 82.9941 34.6468 82.9482 34.8301C82.9024 34.9676 82.8566 35.1509 82.8566 35.3342V37.3048H82.3066V33.6385H82.7649L82.8108 34.326H82.8566C82.9482 34.1885 83.0399 34.051 83.1316 33.9593C83.2232 33.8677 83.3607 33.776 83.4982 33.6844C83.6357 33.5927 83.819 33.5469 84.0023 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M88.357 35.4708C88.357 35.7916 88.3112 36.0207 88.2195 36.2957C88.1278 36.5248 88.0362 36.754 87.8987 36.8914C87.7612 37.0748 87.5779 37.1664 87.3488 37.2581C87.1196 37.3497 86.8905 37.3956 86.6155 37.3956C86.3864 37.3956 86.1572 37.3497 85.9281 37.2581C85.7448 37.1664 85.5614 37.0289 85.3781 36.8914C85.2406 36.7081 85.1032 36.5248 85.0115 36.2957C84.9199 36.0665 84.874 35.7916 84.874 35.4708C84.874 35.0583 84.9657 34.7375 85.1032 34.4625C85.2407 34.1876 85.424 33.9584 85.6989 33.8209C85.9739 33.6835 86.2489 33.5918 86.6155 33.5918C86.9363 33.5918 87.2571 33.6835 87.4862 33.8209C87.7612 33.9584 87.9445 34.1876 88.082 34.4625C88.2653 34.6917 88.357 35.0583 88.357 35.4708ZM85.5156 35.4708C85.5156 35.7457 85.5614 36.0207 85.6531 36.2498C85.7448 36.479 85.8364 36.6165 86.0197 36.754C86.203 36.8914 86.3864 36.9373 86.6613 36.9373C86.9363 36.9373 87.1196 36.8914 87.3029 36.754C87.4862 36.6165 87.5779 36.479 87.6696 36.2498C87.7612 36.0207 87.807 35.7916 87.807 35.4708C87.807 35.1958 87.7612 34.9208 87.6696 34.6917C87.5779 34.4625 87.4862 34.3251 87.3029 34.1876C87.1196 34.0501 86.9363 34.0043 86.6613 34.0043C86.2947 34.0043 85.9739 34.1417 85.7906 34.3709C85.6073 34.6459 85.5156 35.0125 85.5156 35.4708Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M92.3888 33.6385V37.3048H91.9305L91.8389 36.8007C91.7472 36.9382 91.6555 37.0298 91.5181 37.1215C91.3806 37.2132 91.2431 37.259 91.1056 37.3048C90.9681 37.3506 90.7848 37.3506 90.6015 37.3506C90.3265 37.3506 90.0515 37.3048 89.8682 37.2132C89.6849 37.1215 89.5016 36.984 89.4099 36.7549C89.3183 36.5716 89.2725 36.2966 89.2725 35.9758V33.5469H89.8224V35.93C89.8224 36.2508 89.9141 36.4799 90.0516 36.6174C90.189 36.7549 90.4182 36.8465 90.6931 36.8465C90.9681 36.8465 91.1973 36.8007 91.3347 36.709C91.5181 36.6174 91.6097 36.4341 91.7014 36.2508C91.793 36.0674 91.793 35.7925 91.793 35.5175V33.5927H92.3888V33.6385Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M95.323 33.5469C95.7813 33.5469 96.1479 33.6844 96.4229 34.0052C96.6979 34.326 96.8354 34.7842 96.8354 35.4258C96.8354 35.8383 96.7895 36.2049 96.6521 36.4799C96.5146 36.7549 96.3313 36.984 96.1021 37.1215C95.873 37.259 95.598 37.3506 95.2772 37.3506C95.0939 37.3506 94.9106 37.3048 94.7731 37.259C94.6356 37.2132 94.4981 37.1215 94.4065 37.0298C94.3148 36.9382 94.2231 36.8465 94.1315 36.7549H94.0857C94.0857 36.8465 94.0857 36.9382 94.1315 37.0757C94.1315 37.2132 94.1315 37.3048 94.1315 37.3965V38.9546H93.5815V33.6385H94.0398L94.1315 34.1885H94.1773C94.269 34.0968 94.3148 33.9593 94.4523 33.8677C94.5439 33.776 94.6814 33.6844 94.8189 33.6385C94.9564 33.5927 95.1397 33.5469 95.323 33.5469ZM95.2314 34.0052C94.9564 34.0052 94.7731 34.051 94.5898 34.1426C94.4523 34.2343 94.3148 34.3718 94.269 34.6009C94.1773 34.7842 94.1773 35.0592 94.1315 35.3342V35.4258C94.1315 35.7466 94.1773 36.0216 94.2231 36.2049C94.3148 36.4341 94.4065 36.5716 94.5439 36.709C94.7273 36.8007 94.9106 36.8924 95.1855 36.8924C95.4147 36.8924 95.598 36.8465 95.7813 36.709C95.9188 36.5716 96.0563 36.4341 96.1021 36.2049C96.1938 35.9758 96.2396 35.7466 96.2396 35.4258C96.2396 35.0134 96.1479 34.6468 95.9646 34.3718C95.8271 34.1426 95.598 34.0052 95.2314 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M101.83 32.8127C101.555 32.8127 101.326 32.8585 101.097 32.9502C100.868 33.0419 100.684 33.1793 100.547 33.3627C100.409 33.546 100.272 33.7293 100.18 34.0042C100.088 34.2334 100.043 34.5542 100.043 34.8292C100.043 35.2416 100.088 35.6082 100.226 35.8832C100.363 36.204 100.547 36.4332 100.822 36.5706C101.097 36.754 101.417 36.7998 101.784 36.7998C102.013 36.7998 102.197 36.7998 102.426 36.754C102.609 36.7081 102.792 36.6623 103.021 36.6165V37.1206C102.838 37.1664 102.655 37.2581 102.472 37.2581C102.288 37.3039 102.059 37.3039 101.784 37.3039C101.28 37.3039 100.868 37.2122 100.501 36.9831C100.18 36.754 99.9051 36.479 99.7218 36.1124C99.5385 35.7457 99.4927 35.2874 99.4927 34.7833C99.4927 34.4167 99.5385 34.0959 99.6302 33.7751C99.7218 33.4543 99.9051 33.1793 100.088 32.996C100.272 32.7669 100.547 32.5836 100.822 32.4919C101.097 32.3544 101.463 32.3086 101.83 32.3086C102.059 32.3086 102.334 32.3544 102.563 32.4002C102.792 32.4461 103.021 32.5377 103.205 32.6294L102.976 33.1335C102.838 33.0419 102.655 32.996 102.472 32.9502C102.242 32.8585 102.059 32.8127 101.83 32.8127Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M107.238 35.4708C107.238 35.7916 107.192 36.0207 107.1 36.2957C107.009 36.5248 106.917 36.754 106.78 36.8914C106.642 37.0748 106.459 37.1664 106.23 37.2581C106 37.3497 105.771 37.3956 105.496 37.3956C105.267 37.3956 105.038 37.3497 104.809 37.2581C104.626 37.1664 104.442 37.0289 104.259 36.8914C104.122 36.7081 103.984 36.5248 103.892 36.2957C103.801 36.0665 103.755 35.7916 103.755 35.4708C103.755 35.0583 103.847 34.7375 103.984 34.4625C104.122 34.1876 104.305 33.9584 104.58 33.8209C104.855 33.6835 105.13 33.5918 105.496 33.5918C105.817 33.5918 106.138 33.6835 106.367 33.8209C106.642 33.9584 106.825 34.1876 106.963 34.4625C107.146 34.6917 107.238 35.0583 107.238 35.4708ZM104.396 35.4708C104.396 35.7457 104.442 36.0207 104.534 36.2498C104.626 36.479 104.717 36.6165 104.901 36.754C105.084 36.8914 105.267 36.9373 105.542 36.9373C105.817 36.9373 106 36.8914 106.184 36.754C106.367 36.6165 106.459 36.479 106.55 36.2498C106.642 36.0207 106.688 35.7916 106.688 35.4708C106.688 35.1958 106.642 34.9208 106.55 34.6917C106.459 34.4625 106.367 34.3251 106.184 34.1876C106 34.0501 105.817 34.0043 105.542 34.0043C105.176 34.0043 104.855 34.1417 104.671 34.3709C104.488 34.6459 104.396 35.0125 104.396 35.4708Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M112.234 33.5469C112.646 33.5469 112.967 33.6385 113.15 33.8677C113.379 34.0968 113.471 34.4176 113.471 34.8759V37.3048H112.921V34.9217C112.921 34.6468 112.875 34.4176 112.738 34.2343C112.6 34.0968 112.417 34.0052 112.142 34.0052C111.775 34.0052 111.5 34.0968 111.363 34.326C111.18 34.5093 111.134 34.8301 111.134 35.2425V37.3048H110.584V34.9217C110.584 34.7384 110.538 34.5551 110.492 34.4176C110.446 34.2801 110.355 34.1885 110.217 34.1426C110.126 34.0968 109.942 34.051 109.805 34.051C109.576 34.051 109.346 34.0968 109.209 34.1885C109.071 34.2801 108.934 34.4176 108.888 34.6468C108.842 34.8301 108.797 35.105 108.797 35.38V37.3048H108.247V33.6385H108.705L108.797 34.1426H108.842C108.934 34.0052 109.026 33.9135 109.117 33.8218C109.209 33.7302 109.346 33.6844 109.484 33.6385C109.621 33.5927 109.759 33.5927 109.942 33.5927C110.217 33.5927 110.446 33.6385 110.63 33.7302C110.813 33.8218 110.95 34.0052 111.042 34.1885H111.088C111.225 33.9593 111.363 33.8218 111.592 33.7302C111.73 33.5927 111.959 33.5469 112.234 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M116.357 33.5469C116.815 33.5469 117.182 33.6844 117.457 34.0052C117.732 34.326 117.87 34.7842 117.87 35.4258C117.87 35.8383 117.824 36.2049 117.686 36.4799C117.549 36.7549 117.365 36.984 117.136 37.1215C116.907 37.259 116.632 37.3506 116.311 37.3506C116.128 37.3506 115.945 37.3048 115.807 37.259C115.67 37.2132 115.532 37.1215 115.441 37.0298C115.349 36.9382 115.257 36.8465 115.166 36.7549H115.12C115.12 36.8465 115.12 36.9382 115.166 37.0757C115.166 37.2132 115.166 37.3048 115.166 37.3965V38.9546H114.616V33.6385H115.074L115.166 34.1885H115.211C115.303 34.0968 115.395 33.9593 115.486 33.8677C115.578 33.776 115.716 33.6844 115.853 33.6385C115.991 33.5927 116.174 33.5469 116.357 33.5469ZM116.266 34.0052C115.991 34.0052 115.807 34.051 115.624 34.1426C115.486 34.2343 115.349 34.3718 115.303 34.6009C115.211 34.7842 115.211 35.0592 115.166 35.3342V35.4258C115.166 35.7466 115.211 36.0216 115.257 36.2049C115.349 36.4341 115.441 36.5716 115.578 36.709C115.761 36.8007 115.945 36.8924 116.22 36.8924C116.449 36.8924 116.632 36.8465 116.815 36.709C116.953 36.5716 117.09 36.4341 117.136 36.2049C117.228 35.9758 117.274 35.7466 117.274 35.4258C117.274 35.0134 117.182 34.6468 116.999 34.3718C116.861 34.1426 116.632 34.0052 116.266 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M120.252 33.5469C120.711 33.5469 121.031 33.6385 121.261 33.8218C121.49 34.0052 121.581 34.326 121.581 34.7842V37.3048H121.169L121.077 36.7549H121.031C120.94 36.8924 120.802 36.984 120.711 37.0757C120.619 37.1673 120.482 37.2132 120.298 37.259C120.161 37.3048 119.977 37.3048 119.748 37.3048C119.519 37.3048 119.336 37.259 119.152 37.1673C118.969 37.0757 118.832 36.984 118.74 36.8007C118.648 36.6632 118.603 36.4341 118.603 36.2049C118.603 35.8383 118.74 35.5633 119.061 35.38C119.336 35.1967 119.794 35.0592 120.39 35.0592L121.031 35.0134V34.7842C121.031 34.4634 120.986 34.2343 120.802 34.0968C120.665 33.9593 120.482 33.9135 120.207 33.9135C120.023 33.9135 119.84 33.9593 119.657 34.0052C119.473 34.051 119.29 34.1426 119.152 34.1885L118.969 33.776C119.152 33.6844 119.336 33.6385 119.565 33.5469C119.794 33.5927 120.023 33.5469 120.252 33.5469ZM121.031 35.4717L120.482 35.5175C120.023 35.5175 119.702 35.6092 119.519 35.7466C119.336 35.8841 119.244 36.0674 119.244 36.2966C119.244 36.5257 119.29 36.6632 119.427 36.7549C119.565 36.8465 119.748 36.8924 119.932 36.8924C120.252 36.8924 120.527 36.8007 120.756 36.6174C120.986 36.4341 121.077 36.1591 121.077 35.7925V35.4717H121.031Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M124.47 33.5469C124.928 33.5469 125.249 33.6385 125.478 33.8677C125.707 34.0968 125.799 34.4176 125.799 34.8759V37.259H125.294V34.9217C125.294 34.6009 125.203 34.3718 125.065 34.2343C124.928 34.0968 124.699 34.0052 124.424 34.0052C124.011 34.0052 123.736 34.1426 123.553 34.3718C123.37 34.6009 123.324 34.9217 123.324 35.38V37.3048H122.774V33.6385H123.232L123.324 34.1885H123.37C123.461 34.051 123.553 33.9593 123.69 33.8677C123.828 33.776 123.965 33.7302 124.103 33.6844C124.149 33.5927 124.332 33.5469 124.47 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M126.394 33.6387H126.989L127.814 35.7926C127.86 35.9301 127.906 36.0218 127.952 36.1592C127.998 36.2509 128.043 36.3884 128.043 36.48C128.043 36.5717 128.089 36.7092 128.135 36.8008H128.181C128.227 36.7092 128.273 36.5259 128.318 36.3426C128.364 36.1592 128.456 35.9759 128.502 35.7926L129.281 33.6845H129.877L128.273 37.9007C128.181 38.1299 128.089 38.3132 127.952 38.4965C127.86 38.6798 127.723 38.7715 127.539 38.8631C127.356 38.9548 127.173 39.0006 126.944 39.0006C126.852 39.0006 126.76 39.0006 126.669 39.0006C126.577 39.0006 126.531 38.9548 126.439 38.9548V38.4965C126.485 38.4965 126.531 38.4965 126.623 38.5423C126.714 38.5423 126.76 38.5423 126.852 38.5423C126.989 38.5423 127.127 38.4965 127.218 38.4507C127.31 38.4048 127.402 38.3132 127.493 38.2215C127.585 38.1299 127.631 37.9924 127.677 37.8549L127.86 37.3508L126.394 33.6387Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    })]
  });
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/StarFull.tsx


var StarFull_excluded = (/* unused pure expression or super */ null && (["width", "height"]));

function StarFull_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarFull_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarFull_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarFull_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StarFull_StarFull = function StarFull(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 23 : _ref$height,
      props = _objectWithoutProperties(_ref, StarFull_excluded);

  return /*#__PURE__*/_jsx("svg", StarFull_objectSpread(StarFull_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9415 18.9704L4.92475 22.7389L6.26482 14.7571L0.588172 9.10436L8.43311 7.93983L11.9415 0.677734L15.4498 7.93983L23.2948 9.10436L17.6181 14.7571L18.9582 22.7389L11.9415 18.9704Z",
      fill: "#E2B634"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/StarEmpty.tsx


var StarEmpty_excluded = (/* unused pure expression or super */ null && (["width", "height"]));

function StarEmpty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarEmpty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarEmpty_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarEmpty_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StarEmpty_StarEmpty = function StarEmpty(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 26 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 25 : _ref$height,
      props = _objectWithoutProperties(_ref, StarEmpty_excluded);

  return /*#__PURE__*/_jsx("svg", StarEmpty_objectSpread(StarEmpty_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0675 19.9704L6.05072 23.7389L7.3908 15.7571L1.71415 10.1044L9.55909 8.93983L13.0675 1.67773L16.5758 8.93983L24.4208 10.1044L18.7441 15.7571L20.0842 23.7389L13.0675 19.9704Z",
      fill: "#E2B634",
      fillOpacity: 0.1,
      stroke: "#E2B634",
      strokeOpacity: 0.4
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CitiesIcon.tsx


function CitiesIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CitiesIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CitiesIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CitiesIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CitiesIcon_CitiesIcon = function CitiesIcon(props) {
  return /*#__PURE__*/_jsxs("svg", CitiesIcon_objectSpread(CitiesIcon_objectSpread({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 1.50391,
      width: 18,
      height: 18,
      rx: 4.5,
      stroke: "#979797",
      strokeWidth: 0.9
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.1802 14.2845L6.37135 16.2869L7.09877 12.0457L4.01735 9.04202L8.27577 8.42324L10.1802 4.56445L12.0846 8.42324L16.343 9.04202L13.2616 12.0457L13.989 16.2869L10.1802 14.2845Z",
      fill: "url(#paint0_linear_841_15469)"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15469",
        x1: 8.96718,
        y1: 24.9604,
        x2: 23.8392,
        y2: 12.0005,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      })
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/QuickLinks.tsx


function QuickLinks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function QuickLinks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? QuickLinks_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : QuickLinks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var QuickLinks_QuickLinks = function QuickLinks(props) {
  return /*#__PURE__*/_jsxs("svg", QuickLinks_objectSpread(QuickLinks_objectSpread({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 1.50391,
      width: 18,
      height: 18,
      rx: 4.5,
      stroke: "#979797",
      strokeWidth: 0.9
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.3283 6.25372C14.2738 5.19928 12.5643 5.19928 11.5099 6.2537L9.25326 8.51032C8.16258 9.60105 8.26356 11.3389 9.25326 12.3287C9.419 12.4944 9.60237 12.6296 9.79601 12.7406L10.2079 12.3287C10.478 12.0585 10.3829 11.7427 10.3781 11.5148C10.3188 11.4728 10.2611 11.4273 10.2079 11.3741C9.69998 10.8662 9.67714 9.99563 10.2079 9.4649C10.2867 9.38608 12.4166 7.25617 12.4644 7.20833C12.9909 6.68185 13.8472 6.68185 14.3736 7.20833C14.9001 7.73481 14.9001 8.59105 14.3736 9.11752L12.882 10.6091C12.9252 10.8478 13.184 11.4131 13.0509 12.3457C13.0574 12.3393 13.0652 12.3352 13.0716 12.3287L15.3283 10.0721C16.3827 9.01767 16.3827 7.30816 15.3283 6.25372Z",
      fill: "url(#paint0_linear_841_15485)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.6393 9.94311C11.4736 9.77738 11.2902 9.64224 11.0966 9.53125L10.6847 9.94311C10.4145 10.2132 10.5096 10.5291 10.5145 10.757C10.5738 10.799 10.6315 10.8444 10.6847 10.8977C11.1926 11.4056 11.2154 12.2761 10.6847 12.8069C10.6057 12.8859 8.29938 15.1922 8.25323 15.2384C7.72675 15.7648 6.87051 15.7648 6.34404 15.2384C5.81756 14.7119 5.81756 13.8556 6.34404 13.3292L8.01054 11.6627C7.96741 11.424 7.70853 10.8587 7.8417 9.92608C7.8352 9.93247 7.82737 9.93663 7.82089 9.94309L5.38943 12.3746C4.33503 13.429 4.33503 15.1385 5.38943 16.193C6.44387 17.2474 8.15335 17.2474 9.20779 16.193L11.6393 13.7615C12.7097 12.691 12.6512 10.955 11.6393 9.94311Z",
      fill: "url(#paint1_linear_841_15485)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15485",
        x1: 11.5802,
        y1: 16.9162,
        x2: 19.9781,
        y2: 9.22726,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15485",
        x1: 7.7774,
        y1: 21.2597,
        x2: 16.3763,
        y2: 13.3953,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BlogIcon.tsx


function BlogIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BlogIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BlogIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BlogIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var BlogIcon_BlogIcon = function BlogIcon(props) {
  return /*#__PURE__*/_jsxs("svg", BlogIcon_objectSpread(BlogIcon_objectSpread({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 1.50391,
      width: 18,
      height: 18,
      rx: 4.5,
      stroke: "#979797",
      strokeWidth: 0.9
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1652 12.1228C13.0243 12.1477 12.8996 12.1816 12.7722 12.1906C12.3558 12.2206 12.0153 11.9899 11.8548 11.5746C11.7112 11.2029 11.7162 10.8226 11.8003 10.4393C11.8038 10.4237 11.8069 10.4081 11.7938 10.382C11.673 10.5433 11.551 10.7046 11.4306 10.8663C11.1476 11.2446 10.8666 11.6241 10.5826 12.0008C10.4251 12.2089 10.2317 12.371 9.97349 12.438C9.57632 12.5412 9.22314 12.3059 9.20385 11.896C9.18956 11.5929 9.21234 11.2859 9.2409 10.9824C9.28683 10.4961 9.35168 10.0115 9.40803 9.52638C9.40957 9.51157 9.40533 9.49599 9.40185 9.46365C9.37676 9.48586 9.35824 9.49599 9.34897 9.51118C8.91976 10.2503 8.38866 10.9181 7.87221 11.5952C7.70508 11.8142 7.5395 12.0336 7.36388 12.2444C7.23264 12.4021 7.05201 12.4263 6.86017 12.3901C6.58999 12.339 6.44409 12.1364 6.48268 11.8633C6.58536 11.1351 6.69034 10.4073 6.79378 9.67911C6.79919 9.64365 6.80112 9.60742 6.80845 9.53066C6.74052 9.59339 6.69536 9.62651 6.66024 9.6682C6.16155 10.2721 5.73195 10.9239 5.32783 11.5933C5.22014 11.7721 5.1113 11.9506 4.9982 12.1259C4.83069 12.3854 4.58868 12.4742 4.34667 12.3714C4.08266 12.2588 3.96378 12.0149 4.03711 11.7098C4.33663 10.4626 4.63924 9.21663 4.93876 7.96946C4.94996 7.92271 4.93645 7.86972 4.93452 7.81985C4.88318 7.84011 4.8195 7.8479 4.7836 7.88375C4.72647 7.94258 4.68595 8.01817 4.64079 8.0883C4.57517 8.1896 4.51882 8.2983 4.44548 8.39376C4.31888 8.55857 4.16256 8.59714 3.96687 8.5274C3.78121 8.46116 3.69398 8.33298 3.70054 8.12219C3.70286 8.04817 3.70903 7.96907 3.73644 7.90167C3.89507 7.50854 4.08845 7.13451 4.36713 6.81074C4.55896 6.58788 4.79865 6.4371 5.08505 6.38177C5.48068 6.30501 5.78522 6.46515 5.83154 6.90152C5.86898 7.24867 5.79718 7.58413 5.73736 7.92115C5.659 8.36142 5.57447 8.80052 5.49921 9.24118C5.48801 9.30429 5.51156 9.37287 5.51889 9.43871C5.57563 9.4017 5.64742 9.37559 5.68602 9.32416C6.14572 8.70857 6.60118 8.08947 7.05741 7.47114C7.20833 7.26581 7.35693 7.05893 7.51055 6.85554C7.65259 6.66775 7.8259 6.5345 8.07833 6.54541C8.43304 6.5606 8.62102 6.81425 8.5195 7.1536C8.45659 7.36594 8.38016 7.574 8.31532 7.78556C8.10149 8.47986 7.89074 9.17572 7.67922 9.8708C7.6661 9.91444 7.65143 9.95963 7.6495 10.0044C7.64757 10.0422 7.66378 10.0804 7.67228 10.1182C7.70354 10.0979 7.74523 10.0847 7.76453 10.0559C7.94053 9.79716 8.10573 9.53027 8.28753 9.27546C8.71983 8.67116 9.15791 8.07076 9.59832 7.47153C9.66702 7.37802 9.75464 7.29815 9.83878 7.21711C10.0136 7.04841 10.2236 7.01022 10.454 7.0675C10.6505 7.11698 10.7852 7.26347 10.7991 7.4801C10.808 7.61452 10.7929 7.75673 10.7574 7.88686C10.5378 8.69766 10.3247 9.51001 10.2055 10.343C10.1796 10.5246 10.1707 10.7089 10.1618 10.8924C10.1599 10.9317 10.1896 10.9726 10.2051 11.0128C10.2444 10.9945 10.2969 10.9859 10.3209 10.9551C10.483 10.7482 10.6501 10.5437 10.7941 10.3243C11.1612 9.7656 11.5379 9.21195 11.8702 8.63298C12.1771 8.09804 12.4245 7.5288 12.712 6.98178C12.7962 6.82204 12.9131 6.6732 13.0397 6.54424C13.2204 6.36034 13.4693 6.35566 13.6955 6.50216C13.8761 6.61905 13.9475 6.81541 13.8626 7.05503C13.7916 7.25451 13.6893 7.4427 13.5971 7.634C13.2373 8.37817 12.9695 9.15585 12.778 9.95807C12.7282 10.1673 12.7236 10.3995 12.7533 10.6138C12.7946 10.9122 13.0505 11.0233 13.3026 10.8546C13.4612 10.749 13.6106 10.6033 13.7102 10.442C13.9954 9.98028 14.2544 9.50222 14.5211 9.02961C14.9048 8.34856 15.2853 7.66673 15.6679 6.98607C15.8141 6.72619 16.0932 6.60346 16.3823 6.66736C16.5811 6.71139 16.6895 6.8497 16.6533 7.05035C16.6309 7.17503 16.5826 7.29893 16.5243 7.41231C15.8176 8.78649 15.0831 10.147 14.4069 11.536C13.9823 12.4076 13.7113 13.3431 13.5114 14.2953C13.4056 14.7995 13.4647 15.2939 13.5913 15.7836C13.7133 16.2566 13.5361 16.4776 13.0505 16.439C12.7325 16.4137 12.5383 16.2192 12.4117 15.9442C12.2701 15.6364 12.2766 15.3106 12.3056 14.9834C12.3712 14.2427 12.5947 13.5437 12.8668 12.8584C12.9633 12.6153 13.0633 12.3737 13.1652 12.1228",
      fill: "url(#paint0_linear_841_15477)"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15477",
        x1: 8.96718,
        y1: 22.2268,
        x2: 20.569,
        y2: 9.22805,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      })
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/DnldIcon.tsx


function DnldIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DnldIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DnldIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DnldIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var DnldIcon = function DnldIcon(props) {
  return /*#__PURE__*/_jsxs("svg", DnldIcon_objectSpread(DnldIcon_objectSpread({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 1.00391,
      width: 18,
      height: 18,
      rx: 4.5,
      stroke: "#979797",
      strokeWidth: 0.9
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.82002 16.4829L5.5 11.4429H8.37999V4.96289H11.26V11.4429H14.14L9.82002 16.4829Z",
      fill: "url(#paint0_linear_841_15524)"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15524",
        x1: 9.01132,
        y1: 23.0926,
        x2: 21.2341,
        y2: 15.1042,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      })
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/FollowIcon.tsx


function FollowIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FollowIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FollowIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FollowIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var FollowIcon_FollowIcon = function FollowIcon(props) {
  return /*#__PURE__*/_jsxs("svg", FollowIcon_objectSpread(FollowIcon_objectSpread({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 1.00391,
      width: 18,
      height: 18,
      rx: 4.5,
      stroke: "#979797",
      strokeWidth: 0.9
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0415 4.96289C11.9299 4.96299 10.9047 5.57839 10.3601 6.57268C9.81554 5.57839 8.79033 4.96299 7.67872 4.96289C5.97851 4.96289 4.6001 6.58084 4.6001 8.32515C4.6001 12.7063 10.3601 15.7629 10.3601 15.7629C10.3601 15.7629 16.1201 12.7063 16.1201 8.32515C16.1201 6.58084 14.7417 4.96289 13.0415 4.96289Z",
      fill: "url(#paint0_linear_841_15511)"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15511",
        x1: 9.28186,
        y1: 21.9595,
        x2: 21.7595,
        y2: 10.3613,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F0772C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F95776"
        })]
      })
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/OthersIcon.tsx


function OthersIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OthersIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OthersIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OthersIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OthersIcon = function OthersIcon(props) {
  return /*#__PURE__*/_jsxs("svg", OthersIcon_objectSpread(OthersIcon_objectSpread({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 0.503906,
      width: 18,
      height: 18,
      rx: 1.8,
      stroke: "#999999",
      strokeWidth: 0.45
    }), /*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 0.503906,
      width: 18,
      height: 18,
      rx: 1.8,
      stroke: "#999999",
      strokeWidth: 0.45
    }), /*#__PURE__*/_jsx("rect", {
      x: 4.6001,
      y: 5.00391,
      width: 10.8,
      height: 1.8,
      rx: 0.9,
      fill: "url(#paint0_linear_841_15496)"
    }), /*#__PURE__*/_jsx("rect", {
      x: 4.6001,
      y: 8.60352,
      width: 10.8,
      height: 1.8,
      rx: 0.9,
      fill: "url(#paint1_linear_841_15496)"
    }), /*#__PURE__*/_jsx("rect", {
      x: 4.6001,
      y: 12.2031,
      width: 10.8,
      height: 1.8,
      rx: 0.9,
      fill: "url(#paint2_linear_841_15496)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15496",
        x1: 4.6001,
        y1: 6.80391,
        x2: 13.9556,
        y2: 2.11922,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF7F3F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#FF3E5E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15496",
        x1: 4.6001,
        y1: 10.4035,
        x2: 13.9556,
        y2: 5.71883,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF7F3F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#FF3E5E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_15496",
        x1: 4.6001,
        y1: 14.0031,
        x2: 13.9556,
        y2: 9.31844,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF7F3F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#FF3E5E"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LinkedInIcon.tsx


function LinkedInIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LinkedInIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LinkedInIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LinkedInIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LinkedInIcon = function LinkedInIcon(props) {
  return /*#__PURE__*/_jsxs("svg", LinkedInIcon_objectSpread(LinkedInIcon_objectSpread({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      y: 0.00390625,
      width: 27,
      height: 27,
      fill: "url(#pattern0)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: /*#__PURE__*/_jsx("use", {
          xlinkHref: "#image0_841_15520",
          transform: "scale(0.00195312)"
        })
      }), /*#__PURE__*/_jsx("image", {
        id: "image0_841_15520",
        width: 512,
        height: 512,
        xlinkHref: "data:image/png;base64,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"
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/GooglePlay.tsx



function GooglePlay_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GooglePlay_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GooglePlay_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GooglePlay_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var GooglePlay = function GooglePlay(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_jsxs("svg", GooglePlay_objectSpread(GooglePlay_objectSpread({
    width: 128,
    height: 37,
    viewBox: "0 0 128 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.35032 0.00390625C1.94771 0.00390625 0 1.95161 0 4.35422V31.6536C0 34.0562 1.9477 36.0039 4.35032 36.0039H123.65C126.052 36.0039 128 34.0562 128 31.6536V4.35422C128 1.95161 126.052 0.00390625 123.65 0.00390625H4.35032Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M45.1531 27.8593C42.6743 27.9578 40.7438 26.9899 39.4795 24.9119C37.654 21.9126 39.1608 17.9993 42.5935 16.7819C44.7475 16.0183 46.7565 16.3271 48.5533 17.772C48.7656 17.9424 48.7724 18.0416 48.5647 18.2112C48.3434 18.3919 48.1319 18.5918 47.9521 18.8118C47.7339 19.0784 47.5768 19.0672 47.2996 18.8539C45.6168 17.5579 43.1819 17.7342 41.6932 19.2332C40.4425 20.4928 40.1419 22.3531 40.9274 23.9721C41.6713 25.5051 43.3556 26.4285 45.1221 26.2655C46.4914 26.139 47.6017 25.5976 48.2467 24.3424C48.428 23.9906 48.5057 23.6062 48.5639 23.1967C48.2615 23.1967 47.9596 23.1962 47.6581 23.1957L47.6575 23.1957C46.7867 23.1943 45.9189 23.1929 45.0511 23.2034C44.7966 23.2063 44.6932 23.1589 44.7135 22.8864C44.74 22.5435 44.7309 22.1961 44.7158 21.8518C44.7075 21.6548 44.777 21.6023 44.9734 21.603C46.6206 21.6096 48.2678 21.6104 49.9158 21.6023C50.1334 21.6008 50.1968 21.6866 50.2179 21.8755C50.6311 25.5805 48.0246 27.7453 45.1531 27.8593ZM72.2165 25.951C71.5794 26.5273 70.8258 26.6278 70.0534 26.2849C69.1783 25.8963 68.8136 25.1626 68.7978 24.6033C68.8016 23.1079 69.478 22.2803 70.6106 22.0565C71.1587 21.9486 71.6525 22.114 72.0791 22.4481C73.1286 23.2689 73.2011 25.0599 72.2165 25.951ZM74.3238 20.827C74.1949 20.7176 73.9488 20.7391 73.7054 20.7605C73.6053 20.7692 73.5056 20.778 73.4148 20.7775C72.8041 20.7745 72.804 20.7768 72.7708 21.3601L72.7707 21.3605C71.9312 20.612 70.9685 20.3822 69.8895 20.683C68.4028 21.0967 67.4825 22.0757 67.1721 23.5312C66.8475 25.0548 67.4001 26.3182 68.655 27.2543C69.9061 28.1868 71.7016 28.217 72.7889 27.0933C72.8009 27.5144 72.7972 27.8779 72.7345 28.2392C72.5963 29.0305 72.0694 29.5625 71.2705 29.7184C70.295 29.9098 69.5105 29.5647 68.9971 28.6921C68.8876 28.5045 68.8038 28.4609 68.6022 28.5576C68.301 28.7032 67.9913 28.8451 67.6697 28.9359C67.3722 29.0194 67.416 29.1473 67.5262 29.3468C68.6755 31.417 71.1791 31.694 72.8213 30.7217C73.9018 30.0819 74.3488 29.0423 74.3744 27.8602C74.4081 26.2941 74.4021 24.7275 74.3962 23.1613V23.1612V23.161V23.1609V23.1608V23.1607V23.1605V23.1604C74.3944 22.6868 74.3926 22.2131 74.3919 21.7395C74.3917 21.649 74.4036 21.5497 74.4155 21.4501L74.4155 21.45C74.445 21.2041 74.4749 20.9553 74.3238 20.827ZM92.7539 21.9207C93.6918 21.8931 94.4945 21.119 94.5825 20.1939C94.6646 19.3242 94.0036 18.432 93.0875 18.2618C92.5235 18.1571 91.9524 18.1736 91.381 18.1901C91.0724 18.199 90.7637 18.2079 90.456 18.1977C90.3017 18.1923 90.3129 18.2897 90.323 18.3771V18.3771V18.3772V18.3772V18.3773V18.3773V18.3773C90.3255 18.3993 90.328 18.4206 90.3277 18.4395C90.3238 18.8314 90.3244 19.2233 90.325 19.6152C90.3252 19.7563 90.3254 19.8975 90.3254 20.0386C90.3254 20.1926 90.3259 20.3466 90.3265 20.5005C90.3278 20.892 90.3292 21.2833 90.3218 21.6751C90.3179 21.858 90.3516 21.9356 90.5597 21.9311C90.8873 21.9251 91.2149 21.9269 91.5426 21.9287C91.9465 21.9309 92.3503 21.9331 92.7539 21.9207ZM92.6487 16.6463C94.2939 16.6575 95.7711 17.7415 96.1433 19.1958C96.6507 21.1741 95.3375 23.107 93.2761 23.4101C92.6424 23.5032 92.005 23.4878 91.3679 23.4724L91.3679 23.4724C91.1364 23.4669 90.905 23.4613 90.6738 23.4609C90.3672 23.4609 90.3158 23.558 90.3194 23.8342C90.3261 24.3702 90.3254 24.9064 90.3247 25.4425C90.3239 26.0489 90.323 26.6553 90.3329 27.2615C90.3381 27.5504 90.2531 27.6214 89.9807 27.602C89.6346 27.5773 89.2846 27.5781 88.9385 27.602C88.6848 27.6191 88.6311 27.5288 88.6318 27.29C88.6392 25.9746 88.6384 24.6592 88.6376 23.3435C88.6374 22.9327 88.6371 22.5219 88.6371 22.1111C88.6371 21.6843 88.6375 21.2574 88.6379 20.8305V20.8304V20.8304V20.8303V20.8302V20.8302V20.8301C88.639 19.5435 88.6401 18.2567 88.6311 16.9703C88.6297 16.7097 88.6983 16.6351 88.9608 16.6381C89.6306 16.6454 90.3 16.6446 90.9695 16.6437C91.5292 16.6429 92.0889 16.6422 92.6487 16.6463ZM104.57 24.9618C104.427 25.5511 103.957 26.044 103.374 26.2743C103.324 26.2947 103.272 26.313 103.22 26.3283C103.116 26.3606 103.009 26.384 102.9 26.3985C102.818 26.4095 102.735 26.4154 102.653 26.4154H102.607C102.579 26.4154 102.55 26.4147 102.521 26.4125L102.51 26.4124C102.507 26.4123 102.503 26.4121 102.499 26.4117C102.471 26.4103 102.443 26.4073 102.416 26.4044C102.384 26.4 102.353 26.3956 102.322 26.3905L102.319 26.3901C102.3 26.3865 102.28 26.3829 102.261 26.3781C102.123 26.3495 101.99 26.3021 101.862 26.2369C101.242 25.9226 101.182 25.1885 101.74 24.7739C102.361 24.3133 103.837 24.2731 104.487 24.6868C104.616 24.7694 104.596 24.8527 104.57 24.9615L104.57 24.9618ZM106.225 23.3021C106.21 22.5468 105.913 21.8799 105.311 21.3812C104.285 20.5316 103.095 20.4081 101.832 20.6918C101.03 20.8716 100.403 21.303 99.9824 22.0006C99.9753 22.0121 99.9676 22.0238 99.9599 22.0355C99.9029 22.1221 99.8445 22.2108 100.024 22.2784C100.43 22.4319 100.83 22.5972 101.231 22.7638C101.329 22.8049 101.388 22.7945 101.441 22.7002C101.894 21.888 103.346 21.8068 104.131 22.4407C104.444 22.6944 104.614 23.0118 104.591 23.4176C104.58 23.4186 104.571 23.42 104.564 23.4211C104.552 23.423 104.544 23.4242 104.538 23.4219C104.483 23.4034 104.429 23.3843 104.375 23.3652C104.324 23.3473 104.274 23.3295 104.223 23.3122C103.021 22.8999 101.86 22.9942 100.778 23.6435C99.4262 24.455 99.2933 26.1492 100.472 27.1773C101.656 28.2097 103.517 28.0708 104.592 26.8336C104.611 27.2406 104.62 27.4439 104.727 27.5454C104.833 27.6467 105.036 27.6467 105.441 27.6467C105.494 27.6467 105.548 27.6455 105.601 27.6444C105.723 27.6418 105.845 27.6391 105.966 27.6503C106.175 27.6693 106.241 27.602 106.239 27.3914C106.235 26.8408 106.236 26.2899 106.237 25.7391C106.239 24.9267 106.241 24.1142 106.225 23.3021ZM60.6146 24.2232C60.6266 25.4449 61.5628 26.4015 62.7472 26.4022C63.9361 26.4022 64.873 25.4522 64.885 24.2327C64.8971 23.0097 63.9443 22.0129 62.7578 22.007C61.5756 22.0019 60.6033 23.0068 60.6146 24.2232ZM58.9339 24.2174C58.9271 22.1732 60.5912 20.56 62.7118 20.5548C64.8956 20.5505 66.5469 22.1102 66.5552 24.1845C66.5627 26.2741 64.9385 27.8529 62.7667 27.8661C60.6131 27.8792 58.9415 26.288 58.9339 24.2174ZM54.6116 26.4021C53.4048 26.4051 52.4875 25.469 52.4854 24.2306C52.4838 22.9761 53.4115 22.0028 54.6056 22.0072C55.7975 22.0123 56.7056 22.9608 56.7086 24.2049C56.7116 25.4565 55.8125 26.3985 54.6116 26.4021ZM54.7182 20.5551C52.5025 20.5332 50.7876 22.0892 50.7869 24.1772C50.786 26.4313 52.6084 27.8768 54.5756 27.8659C56.6884 27.8893 58.3793 26.3158 58.4079 24.2994C58.4372 22.2311 56.807 20.5771 54.7182 20.5551ZM83.0626 22.7453C82.7436 22.1551 82.0301 21.8633 81.3477 22.022C80.4108 22.2399 79.7826 23.0429 79.77 24.08L80.5413 23.7672L80.5433 23.7664L80.5468 23.765C81.3952 23.4209 82.2283 23.0831 83.0626 22.7453ZM83.9928 25.5946C84.2368 25.7789 84.4956 25.9472 84.7612 26.0992C84.9318 26.1973 84.9511 26.2696 84.8317 26.4312C83.9438 27.63 82.1673 28.1704 80.6467 27.6936C79.1595 27.227 78.1277 25.8513 78.1188 24.3242C78.1099 22.6429 78.9792 21.2819 80.3841 20.7795C82.1999 20.1308 84.0046 20.9213 84.7879 22.7094C85.0453 23.2968 85.0468 23.3003 84.4445 23.5446C83.574 23.898 82.7027 24.2499 81.8314 24.6017C81.2387 24.8411 80.6459 25.0805 80.0533 25.3204C80.7246 26.6199 82.461 26.8057 83.4439 25.6641C83.6456 25.4301 83.771 25.4272 83.9928 25.5946ZM113.861 20.8225C113.756 21.0571 113.653 21.2879 113.551 21.5161C113.355 21.9566 113.163 22.3872 112.969 22.8166C112.676 23.4639 112.383 24.1111 112.089 24.7583L112.087 24.764C111.188 26.7462 110.289 28.7283 109.398 30.7137C109.302 30.9275 109.201 31.0084 108.963 30.9988C108.641 30.986 108.319 30.9885 107.972 30.9913C107.82 30.9924 107.664 30.9937 107.502 30.9937C107.638 30.7026 107.772 30.415 107.905 30.1301C108.295 29.2921 108.675 28.4775 109.065 27.6682C109.178 27.433 109.167 27.25 109.06 27.0178C108.306 25.3876 107.561 23.7529 106.815 22.1182L106.815 22.1176L106.336 21.0657C106.315 21.022 106.298 20.9767 106.276 20.9182C106.265 20.89 106.253 20.8588 106.239 20.8232C106.404 20.8232 106.567 20.8237 106.727 20.8243C107.13 20.8256 107.52 20.8269 107.91 20.8195C108.076 20.8159 108.11 20.9179 108.142 21.0158L108.142 21.016C108.15 21.0383 108.157 21.0605 108.166 21.0811C108.639 22.1931 109.109 23.3059 109.594 24.4537L109.595 24.4555L110.048 25.5286C110.159 25.2589 110.266 24.9997 110.37 24.7468L110.375 24.7351C110.528 24.3659 110.675 24.0098 110.821 23.6535L111.035 23.1352C111.316 22.453 111.597 21.7709 111.871 21.0855C111.947 20.8923 112.045 20.8078 112.272 20.8166C112.631 20.8305 112.991 20.8277 113.369 20.8249C113.529 20.8237 113.693 20.8225 113.861 20.8225ZM98.8805 27.269C98.8821 27.5274 98.8145 27.6185 98.5279 27.5984C98.1809 27.5752 97.8291 27.5699 97.4837 27.5998C97.1376 27.6289 97.0386 27.5409 97.0409 27.2018C97.0535 24.6774 97.0524 22.1524 97.0513 19.6274C97.051 18.9085 97.0507 18.1896 97.0507 17.4707C97.0507 17.0632 97.0507 16.8551 97.1547 16.7489C97.2632 16.6381 97.4849 16.6381 97.9378 16.6381C98.4188 16.6381 98.6526 16.6381 98.7664 16.755C98.8741 16.8656 98.8741 17.0811 98.8741 17.5005V22.1238C98.8741 22.5526 98.8737 22.9813 98.8733 23.4101C98.8721 24.6966 98.8709 25.983 98.8805 27.269ZM76.8153 27.6027C77.0176 27.6132 77.0675 27.5362 77.0648 27.3287C77.0577 26.7643 77.0587 26.1995 77.0598 25.6349C77.0602 25.4296 77.0606 25.2244 77.0606 25.0192C77.0608 24.3299 77.0606 23.6407 77.0604 22.9515C77.0599 20.9705 77.0593 18.9896 77.0675 17.0087C77.069 16.713 76.9969 16.6183 76.7231 16.6414C76.4133 16.6676 76.0993 16.666 75.7896 16.6414C75.5351 16.6213 75.4894 16.728 75.4908 16.978C75.4982 18.2963 75.4975 19.6147 75.4967 20.9326C75.4965 21.3281 75.4963 21.7236 75.4963 22.119C75.4963 22.5359 75.4966 22.9527 75.4969 23.3695C75.4978 24.679 75.4986 25.9884 75.4908 27.2981C75.4894 27.5445 75.5518 27.6169 75.7777 27.6035C76.1229 27.5833 76.4701 27.5855 76.8153 27.6027Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.2972 13.8058C21.2972 13.8058 13.3348 9.37141 12.8671 9.11088C12.3987 8.85036 11.9326 9.0084 11.9326 9.55292C11.9326 10.4605 11.9326 19.0195 11.9326 19.0195C11.9326 19.0195 11.9326 28.2701 11.9326 28.6784C11.9326 29.0861 12.2656 29.2629 12.6726 29.0368C13.0788 28.8107 21.2972 24.2331 21.2972 24.2331C21.2972 24.2331 22.4137 23.6116 22.9719 23.3009C23.8703 22.8009 25.6671 21.8007 25.6671 21.8007C25.6671 21.8007 29.3748 19.7353 29.8681 19.4615C30.3607 19.1869 30.3132 18.8106 29.8977 18.5939C29.4814 18.3779 25.6671 16.239 25.6671 16.239L21.2972 13.8058Z",
      fill: "url(#paint0_linear_841_15529)"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_841_15529",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 12,
      y: 18,
      width: 14,
      height: 12,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5722 29.0632L18.6239 25.7215C20.1142 24.8915 21.2969 24.2327 21.2969 24.2327L25.6978 21.85L22.7679 18.9883L12.1416 29.1212C12.26 29.1595 12.4688 29.1386 12.6317 29.0578",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_841_15529)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.283 13.8044C21.2677 13.8399 13.3084 9.39731 12.8444 9.17055C12.3726 8.8753 11.9067 9.03362 11.9067 9.56325C11.9067 10.4883 11.9067 19.0631 11.9067 19.0666C11.9067 19.0631 11.9067 28.3307 11.9067 28.7271C11.9067 29.1482 12.2396 29.3253 12.61 29.1198C13.0525 28.8723 21.2677 24.2863 21.283 24.2503L25.6586 21.8155C25.6358 21.8495 29.3421 19.7802 29.7998 19.5379C30.3276 19.2308 30.2801 18.8538 29.8779 18.6739C29.4487 18.4204 25.6358 16.2775 25.6586 16.2392L21.283 13.8044Z",
        fill: "url(#paint1_linear_841_15529)"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.7676 18.9883L12.2974 9.01367C12.0531 9.07071 11.9067 9.25437 11.9067 9.56345C11.9067 10.4665 11.9067 19.0245 11.9067 18.9883C11.9067 19.0245 11.9067 28.274 11.9067 28.6487C11.9067 28.911 12.0119 29.067 12.1411 29.12L22.7676 18.9883Z",
      fill: "url(#paint2_linear_841_15529)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.8529 9.10317C12.6513 8.99466 12.4511 8.96362 12.2891 9.00749L22.7679 18.9966L25.6669 16.239L21.2971 13.8058C21.2971 13.8058 17.1783 11.512 14.6914 10.127L12.8529 9.10317Z",
      fill: "url(#paint3_linear_841_15529)"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_841_15529",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 12,
      y: 8,
      width: 14,
      height: 11,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8529 9.10317C12.6513 8.99466 12.4511 8.96362 12.2891 9.00749L22.7679 18.9966L25.6669 16.239L21.2971 13.8058C21.2971 13.8058 17.1783 11.512 14.6914 10.127L12.8529 9.10317Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask1_841_15529)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.186 8.53847C40.186 6.96754 41.434 5.95703 42.9859 5.95703C44.026 5.95703 44.7062 6.42116 45.13 6.98951L44.3703 7.40129C44.0824 7.0269 43.5782 6.73572 42.9859 6.73572C41.9303 6.73572 41.1461 7.48355 41.1461 8.53847C41.1461 9.57796 41.9303 10.3412 42.9859 10.3412C43.5302 10.3412 44.01 10.1094 44.2499 9.89252V9.12178H42.65V8.35104H45.178V10.2141C44.6582 10.7605 43.906 11.1269 42.9859 11.1269C41.434 11.1269 40.186 10.1024 40.186 8.53847ZM46.3882 11.0509V6.03306H50.0943V6.8085H47.3371V8.10185H50.0376V8.87682H47.3371V10.2759H50.0943V11.0509H46.3882ZM52.6148 6.8085V11.0509H53.5491V6.8085H55.1619V6.03306H51.002V6.8085H52.6148ZM58.4899 6.03306H59.3975V11.0509H58.4899V6.03306ZM61.9941 6.8085V11.0509H62.9285V6.8085H64.5408V6.03306H60.3808V6.8085H61.9941ZM67.6418 8.54221C67.6418 7.05092 68.7833 5.95703 70.4028 5.95703C72.0131 5.95703 73.1633 7.05092 73.1633 8.54221C73.1633 10.033 72.0131 11.1269 70.4028 11.1269C68.7833 11.1269 67.6418 10.033 67.6418 8.54221ZM72.18 8.50396C72.18 7.4807 71.4806 6.71731 70.4028 6.71731C69.317 6.71731 68.6251 7.4807 68.6251 8.50396C68.6251 9.51934 69.317 10.2906 70.4028 10.2906C71.4806 10.2906 72.18 9.51934 72.18 8.50396ZM75.1557 7.4627L77.9338 11.0509H78.8359V6.03306H77.9019V9.50893L75.1801 6.03306H74.2222V11.0509H75.1557V7.4627Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15529",
        x1: 18.021,
        y1: 14.1334,
        x2: 24.7014,
        y2: 23.881,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF177B"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#FFEC73"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15529",
        x1: 21.7136,
        y1: 11.4301,
        x2: 6.99676,
        y2: 20.183,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF4521"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#8A33DB"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_15529",
        x1: 8.05715,
        y1: -3.57021,
        x2: -3.96274,
        y2: 21.8206,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#064AA2"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#63FFD4"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_841_15529",
        x1: 3.98231,
        y1: 9.78153,
        x2: 9.28367,
        y2: 23.4836,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00A3B5"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#D6FFA1"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/AppleStore.tsx


function AppleStore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AppleStore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AppleStore_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AppleStore_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var AppleStore = function AppleStore(props) {
  return /*#__PURE__*/_jsxs("svg", AppleStore_objectSpread(AppleStore_objectSpread({
    width: 128,
    height: 37,
    viewBox: "0 0 128 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.35032 0.00390625C1.94771 0.00390625 0 1.95161 0 4.35422V31.6536C0 34.0562 1.9477 36.0039 4.35032 36.0039H123.65C126.052 36.0039 128 34.0562 128 31.6536V4.35422C128 1.95161 126.052 0.00390625 123.65 0.00390625H4.35032Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.3396 6.70117C24.4733 7.92241 23.9918 9.12584 23.2881 10.0104C22.5539 10.8812 21.3792 11.5473 20.2351 11.4615C20.0853 10.2864 20.665 9.03681 21.314 8.27445C22.0474 7.40931 23.3211 6.74649 24.3396 6.70117ZM28.085 13.746C27.9573 13.8226 25.8414 15.0921 25.8645 17.681C25.8919 20.8073 28.5859 21.8408 28.6181 21.8513C28.602 21.9241 28.1962 23.3444 27.1858 24.7834C26.342 26.0524 25.458 27.293 24.0538 27.3141C23.386 27.3299 22.9352 27.137 22.4653 26.936C21.9755 26.7264 21.4651 26.508 20.6666 26.508C19.8202 26.508 19.2871 26.7336 18.773 26.9512C18.3282 27.1394 17.8976 27.3217 17.2907 27.3464C15.9534 27.3958 14.9317 25.9933 14.0573 24.7356C12.3094 22.1693 10.9487 17.5037 12.7731 14.3288C13.6572 12.7717 15.269 11.769 16.992 11.7423C17.7507 11.7267 18.4784 12.0206 19.1164 12.2783C19.6042 12.4753 20.0395 12.6512 20.3961 12.6512C20.7093 12.6512 21.1324 12.4824 21.6256 12.2856C22.4027 11.9756 23.3538 11.5961 24.3227 11.6986C24.9853 11.718 26.871 11.9616 28.0875 13.7445L28.085 13.746Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M75.9555 25.7771C76.59 25.2017 76.908 24.4563 76.908 23.5402C76.908 22.7956 76.6906 22.1716 76.2534 21.6715C75.8187 21.1713 75.1416 20.7359 74.2189 20.362C73.4669 20.0642 72.9468 19.7866 72.6618 19.5309C72.3325 19.2549 72.1674 18.9021 72.1674 18.4772C72.1674 18.0919 72.3131 17.7674 72.599 17.5012C72.9379 17.2033 73.4137 17.0536 74.0192 17.0536C74.7857 17.0536 75.4709 17.2187 76.0779 17.5489L76.5087 16.1423C75.8638 15.8016 75.0514 15.6309 74.0764 15.6309C72.9846 15.6309 72.107 15.9133 71.4452 16.4782C70.7842 17.0439 70.4525 17.7674 70.4525 18.6512C70.4525 20.0035 71.3913 21.0329 73.2672 21.7362C73.9564 21.9903 74.4475 22.2687 74.7446 22.5658C75.0409 22.8644 75.1907 23.2318 75.1907 23.6696C75.1907 24.1585 75.0095 24.5494 74.6488 24.8431C74.2897 25.1353 73.7865 25.2826 73.1392 25.2826C72.2391 25.2826 71.4122 25.0584 70.6594 24.6109L70.2625 26.049C70.9597 26.4965 71.884 26.7199 73.0369 26.7199C74.2849 26.7199 75.2583 26.4051 75.9555 25.7771ZM47.4032 26.5605H49.2317L45.7664 15.7903H43.636L40.186 26.5605H41.9662L42.9203 23.3969H46.4016L47.4032 26.5605ZM45.1939 19.2581L46.0997 22.0697H43.2222L44.1127 19.2581C44.3453 18.3631 44.5152 17.6865 44.6215 17.2284H44.6537C44.9178 18.2935 45.0981 18.97 45.1939 19.2581ZM57.0157 25.7131C57.7298 24.9467 58.0865 23.9027 58.0865 22.5819C58.0865 21.3996 57.7813 20.4462 57.1735 19.7203C56.5648 18.9959 55.8039 18.6342 54.8925 18.6342C53.7267 18.6342 52.858 19.0979 52.2855 20.0262H52.2533L52.1575 18.7944H50.6479C50.6898 19.6668 50.7115 20.5174 50.7115 21.347V29.7086H52.428V25.6338C52.8749 26.3695 53.6108 26.7361 54.6341 26.7361C55.5817 26.7361 56.3764 26.3954 57.0157 25.7131ZM55.8289 20.7756C56.1687 21.266 56.3377 21.8892 56.3377 22.6451C56.3377 23.4657 56.1574 24.1261 55.7967 24.627C55.4368 25.1264 54.9336 25.3781 54.2871 25.3781C53.7364 25.3781 53.2887 25.183 52.9441 24.7946C52.5995 24.4045 52.4272 23.9278 52.4272 23.3645V22.068C52.4272 21.9305 52.4538 21.7565 52.5069 21.5436C52.6124 21.0847 52.8378 20.7149 53.1824 20.4324C53.5262 20.1508 53.9111 20.0084 54.3346 20.0084C54.9594 20.0084 55.4577 20.2649 55.8289 20.7756ZM66.9727 22.5819C66.9727 23.9027 66.616 24.9467 65.9019 25.7131C65.2618 26.3954 64.4679 26.7361 63.5195 26.7361C62.497 26.7361 61.7611 26.3695 61.3134 25.6338V29.7086H59.5969V21.347C59.5969 20.5174 59.5752 19.6668 59.5333 18.7944H61.0429L61.1387 20.0262H61.1709C61.7426 19.0979 62.6113 18.6342 63.778 18.6342C64.6886 18.6342 65.4502 18.9959 66.0597 19.7203C66.6668 20.4462 66.9727 21.3996 66.9727 22.5819ZM65.2232 22.6451C65.2232 21.8892 65.0533 21.266 64.7135 20.7756C64.3432 20.2649 63.8456 20.0084 63.2208 20.0084C62.7973 20.0084 62.4125 20.1508 62.067 20.4324C61.7233 20.7149 61.4978 21.0847 61.3924 21.5436C61.34 21.7565 61.3118 21.9305 61.3118 22.068V23.3645C61.3118 23.9278 61.4849 24.4045 61.8279 24.7946C62.1725 25.1822 62.6202 25.3781 63.1725 25.3781C63.8198 25.3781 64.323 25.1264 64.6821 24.627C65.0428 24.1261 65.2232 23.4657 65.2232 22.6451ZM82.5979 20.0893H80.7058V23.8598C80.7058 24.8189 81.0391 25.2971 81.7074 25.2971C82.0141 25.2971 82.2686 25.2713 82.4698 25.217L82.5173 26.5273C82.1792 26.6543 81.734 26.7183 81.1833 26.7183C80.5045 26.7183 79.9756 26.5095 79.5923 26.0943C79.2107 25.6783 79.0199 24.9815 79.0199 24.0006V20.0861H77.8935V18.7912H79.0199V17.3692L80.7058 16.8578V18.7912H82.5979V20.0893ZM90.1001 25.5537C90.7788 24.7873 91.1177 23.8072 91.1177 22.6135C91.1177 21.4514 90.7901 20.5053 90.1315 19.7712C89.4415 19.0162 88.5317 18.6366 87.3972 18.6366C86.2209 18.6366 85.2854 19.021 84.5914 19.7874C83.899 20.5538 83.5503 21.5396 83.5503 22.743C83.5503 23.893 83.8869 24.8464 84.56 25.6023C85.2331 26.3581 86.1356 26.7361 87.2708 26.7361C88.4471 26.7361 89.3907 26.342 90.1001 25.5537ZM88.8787 20.8209C89.1854 21.3316 89.3384 21.9418 89.3384 22.6532C89.3384 23.3662 89.1798 23.9804 88.865 24.5032C88.4922 25.128 87.9777 25.4436 87.3224 25.4436C86.6509 25.4436 86.1332 25.1353 85.762 24.5178C85.4537 24.0096 85.3015 23.3977 85.3015 22.6855C85.3015 21.9523 85.4537 21.3316 85.762 20.8209C86.1203 20.2042 86.6493 19.8967 87.3361 19.8967C88.0027 19.8967 88.5188 20.2042 88.8787 20.8209ZM96.6997 20.3119C96.5298 20.2803 96.3479 20.2649 96.1587 20.2649C95.5548 20.2649 95.0878 20.4923 94.7594 20.952C94.4735 21.3567 94.331 21.8681 94.331 22.4856V26.5605H92.6145V21.2401C92.6145 20.3458 92.5976 19.5293 92.5646 18.7952H94.0597L94.1225 20.2811H94.17C94.352 19.7704 94.637 19.3585 95.0283 19.051C95.4115 18.7726 95.8237 18.6342 96.269 18.6342C96.4276 18.6342 96.5709 18.6463 96.6981 18.6657L96.6997 20.3119ZM104.314 23.0926C104.356 22.8798 104.377 22.6192 104.377 22.31C104.377 21.3413 104.149 20.5255 103.695 19.8675C103.123 19.0372 102.28 18.622 101.167 18.622C100.033 18.622 99.132 19.0372 98.4654 19.8675C97.8277 20.6453 97.5105 21.6205 97.5105 22.7907C97.5105 23.982 97.8535 24.9346 98.5354 25.6427C99.2198 26.35 100.16 26.7045 101.358 26.7045C102.353 26.7045 103.217 26.5443 103.948 26.2246L103.679 25.0268C103.054 25.2729 102.358 25.3943 101.596 25.3943C100.907 25.3943 100.345 25.213 99.9114 24.852C99.4339 24.4474 99.1835 23.8598 99.165 23.0926H104.314ZM102.406 20.536C102.639 20.9099 102.752 21.3502 102.74 21.8625L99.165 21.8609C99.2174 21.3413 99.3872 20.8921 99.6731 20.519C100.021 20.0496 100.477 19.8158 101.039 19.8158C101.652 19.8158 102.109 20.0553 102.406 20.536Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M56.4545 6.70117H57.2983V12.2692H56.4545V6.70117ZM54.0174 7.313C54.0174 7.60354 54.2364 7.82367 54.5173 7.82367C54.8305 7.82367 55.0487 7.61973 55.0487 7.313C55.0568 7.02246 54.8225 6.81043 54.5335 6.81043C54.2436 6.81043 54.0174 7.02246 54.0174 7.313ZM54.9553 12.2692V8.4525H54.1116V12.2692H54.9553ZM43.7334 12.2692H44.6328L42.9283 6.97552H41.8816L40.186 12.2692H41.0612L41.5306 10.7145H43.2415L43.7334 12.2692ZM42.6481 8.67991L43.0934 10.0622H41.6787L42.1159 8.67991C42.2226 8.28096 42.2968 7.97205 42.3506 7.74834L42.3506 7.74831L42.3663 7.68285H42.3824C42.5153 8.2089 42.6014 8.53829 42.6481 8.67991ZM47.4346 12.2692L48.8726 8.4525H47.9885L47.3477 10.4709C47.2309 10.8399 47.1375 11.162 47.0747 11.4364H47.0514C46.9813 11.1305 46.8879 10.8084 46.7784 10.4709L46.1295 8.4525H45.2229L46.6142 12.2692H47.4346ZM51.9337 12.2692L51.8709 11.8297H51.8475C51.5899 12.1834 51.2147 12.3558 50.7381 12.3558C50.0585 12.3558 49.5738 11.8767 49.5738 11.2324C49.5738 10.2904 50.3862 9.80322 51.7928 9.80322V9.73281C51.7928 9.23024 51.5271 8.97854 51.0038 8.97854C50.6286 8.97854 50.3001 9.07323 50.0118 9.2618L49.8403 8.70419C50.1922 8.48406 50.6294 8.374 51.1455 8.374C52.1374 8.374 52.6382 8.90004 52.6382 9.95294V11.3587C52.6382 11.7439 52.6543 12.0426 52.6929 12.27L51.9337 12.2692ZM51.8161 10.3681C50.8782 10.3681 50.4096 10.5963 50.4096 11.1378C50.4096 11.5384 50.6519 11.7342 50.9877 11.7342C51.4176 11.7342 51.8161 11.4048 51.8161 10.9573V10.3681ZM60.8207 11.8297L60.8843 12.2692H61.6419C61.6049 12.0417 61.5888 11.7431 61.5888 11.3579V9.95213C61.5888 8.89923 61.0872 8.37319 60.0953 8.37319C59.5792 8.37319 59.142 8.48325 58.7902 8.70338L58.9625 9.2618C59.2507 9.07323 59.5792 8.97854 59.9544 8.97854C60.4777 8.97854 60.7434 9.23024 60.7434 9.73281V9.80322C59.3369 9.80322 58.5245 10.2904 58.5245 11.2324C58.5245 11.8767 59.0092 12.3558 59.6887 12.3558C60.1653 12.3558 60.5405 12.1834 60.7982 11.8297H60.8207ZM59.3602 11.1378C59.3602 10.5963 59.8288 10.3681 60.7668 10.3681V10.9573C60.7668 11.4048 60.3682 11.7342 59.9383 11.7342C59.6025 11.7342 59.3602 11.5384 59.3602 11.1378ZM65.0066 12.3558C64.4679 12.3558 64.0702 12.1275 63.8118 11.68H63.7957L63.7474 12.2692H63.0292C63.0517 11.9632 63.0598 11.6169 63.0598 11.2405V6.70117H63.9052V9.01092H63.9205C64.1709 8.58684 64.5766 8.37481 65.1314 8.37481C66.046 8.37481 66.6869 9.16064 66.6869 10.3066C66.6869 11.4914 65.9752 12.3558 65.0066 12.3558ZM64.8351 9.04086C64.3496 9.04086 63.9052 9.46493 63.9052 10.0541V10.7218C63.9052 11.2478 64.3045 11.68 64.8198 11.68C65.4518 11.68 65.8286 11.162 65.8286 10.3374C65.8278 9.56772 65.4365 9.04086 64.8351 9.04086ZM68.7786 6.70117H67.9356V12.2692H68.7786V6.70117ZM73.3711 10.5648H70.8381C70.855 11.2875 71.3301 11.6954 72.0329 11.6954C72.4089 11.6954 72.7527 11.6322 73.0571 11.5149L73.1883 12.1041C72.8292 12.2611 72.4073 12.3396 71.9154 12.3396C70.727 12.3396 70.0241 11.5853 70.0241 10.4159C70.0241 9.24561 70.7439 8.3659 71.8212 8.3659C72.789 8.3659 73.4001 9.08861 73.4001 10.1804C73.4025 10.3293 73.3952 10.4628 73.3711 10.5648ZM72.5981 9.96023C72.5981 9.37106 72.3003 8.95507 71.7608 8.95507C71.2761 8.95507 70.8945 9.37915 70.8381 9.96023H72.5981ZM76.6568 10.3924C76.6568 11.523 77.3758 12.3558 78.4853 12.3558C79.6189 12.3558 80.3773 11.523 80.3773 10.3301C80.3773 9.16711 79.6414 8.374 78.5489 8.374C77.3911 8.374 76.6568 9.21405 76.6568 10.3924ZM77.5175 10.3681C77.5175 9.56691 77.908 8.99392 78.5175 8.99392C79.1108 8.99392 79.5013 9.575 79.5013 10.3519C79.5013 11.1143 79.1028 11.7269 78.5094 11.7269C77.916 11.7269 77.5175 11.1539 77.5175 10.3681ZM84.9134 12.2692H84.0713V10.0776C84.0713 9.40262 83.8128 9.06433 83.3048 9.06433C82.8048 9.06433 82.4602 9.4965 82.4602 9.99907V12.2692H81.618V9.54344C81.618 9.20596 81.6084 8.8442 81.5858 8.45169H82.3281L82.3676 9.04086H82.3918C82.6164 8.63297 83.0785 8.37319 83.5946 8.37319C84.3901 8.37319 84.9134 8.98583 84.9134 9.98289V12.2692ZM89.5059 9.08861H90.4342V8.45169H89.5059V7.50157L88.6782 7.75326V8.4525H88.1251V9.08861H88.6782V11.0131C88.6782 11.9794 89.0743 12.3485 89.7402 12.3485C90.0115 12.3485 90.2313 12.3169 90.3955 12.2538L90.3722 11.6096C90.2716 11.6331 90.1451 11.6492 89.997 11.6492C89.6693 11.6492 89.5059 11.4137 89.5059 10.9419V9.08861ZM94.9027 12.2692H94.0581V10.0938C94.0581 9.41071 93.7996 9.06514 93.2924 9.06514C92.8552 9.06514 92.4494 9.36377 92.4494 9.96832V12.2692H91.6049V6.70117H92.4494V8.99392H92.4655C92.7304 8.57794 93.1145 8.37319 93.6064 8.37319C94.4107 8.37319 94.9027 9.00121 94.9027 9.99907V12.2692ZM96.682 10.5648H99.2141C99.2375 10.4628 99.2455 10.3293 99.2423 10.1804C99.2423 9.08861 98.632 8.3659 97.6635 8.3659C96.5862 8.3659 95.8672 9.24561 95.8672 10.4159C95.8672 11.5853 96.5701 12.3396 97.7577 12.3396C98.2504 12.3396 98.6731 12.2611 99.0314 12.1041L98.8993 11.5149C98.5966 11.6322 98.2536 11.6954 97.8768 11.6954C97.1731 11.6954 96.6981 11.2875 96.682 10.5648ZM97.6047 8.95507C98.1441 8.95507 98.4404 9.37106 98.4404 9.96023H96.682C96.7376 9.37915 97.12 8.95507 97.6047 8.95507Z",
      fill: "#4A4A4A"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LuggageImg.tsx


function LuggageImg_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LuggageImg_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LuggageImg_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LuggageImg_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LuggageImg = function LuggageImg(props) {
  return /*#__PURE__*/_jsxs("svg", LuggageImg_objectSpread(LuggageImg_objectSpread({
    width: 94,
    height: 105,
    viewBox: "0 0 94 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0.170046 78.9453C3.02139 74.5071 91.8243 75.5756 93.0465 78.9453C93.0465 77.3837 93.0465 66.6436 93.0465 65.6573C91.417 61.4657 4.6508 60.8081 0.170046 65.6573C0.170046 67.5477 0.169767 77.2193 0.170046 78.9453Z",
      fill: "#E0E0E0"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.8916 43.0586C6.8916 42.6983 7.15953 42.4062 7.49003 42.4062H8.68688C9.01738 42.4062 9.2853 42.6983 9.2853 43.0586V45.8857C9.2853 46.246 9.01738 46.5381 8.68688 46.5381H7.49003C7.15953 46.5381 6.8916 46.246 6.8916 45.8857V43.0586Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("rect", {
      x: 20.6963,
      y: 11.5234,
      width: 1.19585,
      height: 20.6593,
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("rect", {
      x: 36.7559,
      y: 11.5234,
      width: 1.19585,
      height: 20.6593,
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.1892 33.9219C19.8587 33.9219 19.5908 33.6298 19.5908 33.2695V31.9647C19.5908 31.6044 19.8587 31.3123 20.1892 31.3123H22.5829C22.9134 31.3123 23.1814 31.6044 23.1814 31.9647V33.2695C23.1814 33.6298 22.9134 33.9219 22.5829 33.9219H20.1892Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M35.8582 33.9219C35.5277 33.9219 35.2598 33.6298 35.2598 33.2695V31.9647C35.2598 31.6044 35.5277 31.3123 35.8582 31.3123H38.2519C38.5824 31.3123 38.8503 31.6044 38.8503 31.9647V33.2695C38.8503 33.6298 38.5824 33.9219 38.2519 33.9219H35.8582Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M48.3198 56.9748C48.3198 55.8938 49.1236 55.0176 50.1151 55.0176H50.913C51.9045 55.0176 52.7083 55.8938 52.7083 56.9748V72.6323C52.7083 73.7132 51.9045 74.5895 50.913 74.5895H50.1151C49.1236 74.5895 48.3198 73.7132 48.3198 72.6323V56.9748Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.8916 82.2012C6.8916 81.8409 7.15953 81.5488 7.49003 81.5488H8.68688C9.01738 81.5488 9.2853 81.8409 9.2853 82.2012V85.0283C9.2853 85.3886 9.01738 85.6807 8.68688 85.6807H7.49003C7.15953 85.6807 6.8916 85.3886 6.8916 85.0283V82.2012Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_841_15159",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 7,
      y: 32,
      width: 45,
      height: 66,
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.62842 39.1425C7.62842 35.2992 10.4863 32.1836 14.0116 32.1836H45.1297C48.6551 32.1836 51.513 35.2992 51.513 39.1425V90.4645C51.513 94.3078 48.6551 97.4234 45.1297 97.4234H14.0116C10.4863 97.4234 7.62842 94.3078 7.62842 90.4645V39.1425Z",
        fill: "#D9D9D9"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_841_15159)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.62842 39.1425C7.62842 35.2992 10.4863 32.1836 14.0116 32.1836H45.1297C48.6551 32.1836 51.513 35.2992 51.513 39.1425V90.4645C51.513 94.3078 48.6551 97.4234 45.1297 97.4234H14.0116C10.4863 97.4234 7.62842 94.3078 7.62842 90.4645V39.1425Z",
        fill: "#925454"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.62842 39.1425C7.62842 35.2992 10.4863 32.1836 14.0116 32.1836H45.1297C48.6551 32.1836 51.513 35.2992 51.513 39.1425V90.4645C51.513 94.3078 48.6551 97.4234 45.1297 97.4234H14.0116C10.4863 97.4234 7.62842 94.3078 7.62842 90.4645V39.1425Z",
        fill: "url(#paint0_linear_841_15159)",
        fillOpacity: 0.8
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.62842 39.1425C7.62842 35.2992 10.4863 32.1836 14.0116 32.1836H45.1297C48.6551 32.1836 51.513 35.2992 51.513 39.1425V90.4645C51.513 94.3078 48.6551 97.4234 45.1297 97.4234H14.0116C10.4863 97.4234 7.62842 94.3078 7.62842 90.4645V39.1425Z",
        fill: "url(#paint1_linear_841_15159)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.62842 39.1425C7.62842 35.2992 10.4863 32.1836 14.0116 32.1836H45.1297C48.6551 32.1836 51.513 35.2992 51.513 39.1425V90.4645C51.513 94.3078 48.6551 97.4234 45.1297 97.4234H14.0116C10.4863 97.4234 7.62842 94.3078 7.62842 90.4645V39.1425Z",
        fill: "url(#paint2_linear_841_15159)",
        fillOpacity: 0.4
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.62842 91.9883H11.6179C14.8128 91.9883 17.4027 94.8118 17.4027 98.2948V100.687H7.62842V91.9883Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.62842 91.9883H11.6179C14.8128 91.9883 17.4027 94.8118 17.4027 98.2948V100.687H7.62842V91.9883Z",
        fill: "url(#paint3_linear_841_15159)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        d: "M51.6807 91.9883H47.6912C44.4963 91.9883 41.9064 94.8118 41.9064 98.2948V100.687H51.6807V91.9883Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M51.6807 91.9883H47.6912C44.4963 91.9883 41.9064 94.8118 41.9064 98.2948V100.687H51.6807V91.9883Z",
        fill: "url(#paint4_linear_841_15159)",
        fillOpacity: 0.2
      })]
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 14.6263,
      cy: 100.358,
      rx: 2.89239,
      ry: 3.15326,
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 14.5427,
      cy: 100.358,
      rx: 1.69554,
      ry: 1.84846,
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 43.7464,
      cy: 100.358,
      rx: 2.89239,
      ry: 3.15326,
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 43.6628,
      cy: 100.358,
      rx: 1.69554,
      ry: 1.84846,
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_i_841_15159)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.2446 39.3594C13.2446 38.9991 13.5123 38.707 13.8426 38.707C14.1728 38.707 14.4405 38.9991 14.4405 39.3594V89.5941C14.4405 89.9544 14.1728 90.2465 13.8426 90.2465C13.5123 90.2465 13.2446 89.9544 13.2446 89.5941V39.3594Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter1_i_841_15159)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M21.0791 39.3594C21.0791 38.9991 21.3468 38.707 21.677 38.707C22.0073 38.707 22.275 38.9991 22.275 39.3594V89.5941C22.275 89.9544 22.0073 90.2465 21.677 90.2465C21.3468 90.2465 21.0791 89.9544 21.0791 89.5941V39.3594Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter2_i_841_15159)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.2974 39.3594C29.2974 38.9991 29.5651 38.707 29.8953 38.707C30.2255 38.707 30.4932 38.9991 30.4932 39.3594V89.5941C30.4932 89.9544 30.2255 90.2465 29.8953 90.2465C29.5651 90.2465 29.2974 89.9544 29.2974 89.5941V39.3594Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter3_i_841_15159)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M45.3423 39.3594C45.3423 38.9991 45.61 38.707 45.9402 38.707C46.2704 38.707 46.5381 38.9991 46.5381 39.3594V89.5941C46.5381 89.9544 46.2704 90.2465 45.9402 90.2465C45.61 90.2465 45.3423 89.9544 45.3423 89.5941V39.3594Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter4_i_841_15159)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M37.1318 39.3594C37.1318 38.9991 37.3995 38.707 37.7298 38.707C38.06 38.707 38.3277 38.9991 38.3277 39.3594V89.5941C38.3277 89.9544 38.06 90.2465 37.7298 90.2465C37.3995 90.2465 37.1318 89.9544 37.1318 89.5941V39.3594Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.8389 11.9593C18.8389 10.1577 20.2993 8.69727 22.1009 8.69727H36.1228C37.9244 8.69727 39.3848 10.1577 39.3848 11.9593H35.4452C35.4452 11.9593 31.705 11.5243 29.1118 11.5243C26.5187 11.5243 22.7785 11.9593 22.7785 11.9593H18.8389Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.561 11.957V11.3043C22.561 10.9438 22.829 10.6516 23.1595 10.6516H34.5295C34.86 10.6516 35.128 10.9438 35.128 11.3043V11.957C35.128 11.957 32.0361 11.5219 28.8445 11.5219C25.6529 11.5219 22.561 11.957 22.561 11.957Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("rect", {
      x: 65.4854,
      y: 2.82617,
      width: 1.19585,
      height: 13.7004,
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M64.3726 1.95719C64.3726 0.876266 65.1763 0 66.1678 0Lnan nanL66.1678 0C67.1593 0 67.9631 0.876266 67.9631 1.95719V4.11422C67.9631 4.24406 67.8666 4.34932 67.7475 4.34932H64.5882C64.4691 4.34932 64.3726 4.24406 64.3726 4.11422V1.95719Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M64.971 18.2676C64.6405 18.2676 64.3726 17.9755 64.3726 17.6152V16.3104C64.3726 15.9501 64.6405 15.658 64.971 15.658H67.3647C67.6952 15.658 67.9631 15.9501 67.9631 16.3104V17.6152C67.9631 17.9755 67.6952 18.2676 67.3647 18.2676H64.971Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_841_15159",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 57,
      y: 16,
      width: 27,
      height: 82,
      children: /*#__PURE__*/_jsx("path", {
        d: "M57.2822 23.2649C57.2822 19.5417 60.0508 16.5234 63.466 16.5234H77.6287C81.0439 16.5234 83.8124 19.5417 83.8124 23.2649V90.4619C83.8124 94.1851 81.0439 97.2033 77.6287 97.2033H63.466C60.0508 97.2033 57.2822 94.1851 57.2822 90.4619V23.2649Z",
        fill: "#D9D9D9"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_841_15159)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M57.2822 16.5234H83.8124V97.2033H57.2822V16.5234Z",
        fill: "#444444"
      }), /*#__PURE__*/_jsx("path", {
        d: "M57.2822 16.5234H83.8124V97.2033H57.2822V16.5234Z",
        fill: "url(#paint5_linear_841_15159)",
        fillOpacity: 0.6
      }), /*#__PURE__*/_jsx("path", {
        d: "M57.2822 16.5234H83.8124V97.2033H57.2822V16.5234Z",
        fill: "url(#paint6_linear_841_15159)",
        fillOpacity: 0.4
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter5_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 25.4395C60.159 25.4395 59.8911 25.1472 59.8911 24.7867C59.8911 24.4262 60.159 24.134 60.4895 24.134H80.2376C80.5681 24.134 80.836 24.4262 80.836 24.7867C80.836 25.1472 80.5681 25.4395 80.2376 25.4395H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter6_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 34.1406C60.159 34.1406 59.8911 33.8484 59.8911 33.4879C59.8911 33.1274 60.159 32.8352 60.4895 32.8352H80.2376C80.5681 32.8352 80.836 33.1274 80.836 33.4879C80.836 33.8484 80.5681 34.1406 80.2376 34.1406H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter7_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 42.8359C60.159 42.8359 59.8911 42.5437 59.8911 42.1832C59.8911 41.8227 60.159 41.5305 60.4895 41.5305H80.2376C80.5681 41.5305 80.836 41.8227 80.836 42.1832C80.836 42.5437 80.5681 42.8359 80.2376 42.8359H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter8_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 51.5352C60.159 51.5352 59.8911 51.2429 59.8911 50.8824C59.8911 50.5219 60.159 50.2297 60.4895 50.2297H80.2376C80.5681 50.2297 80.836 50.5219 80.836 50.8824C80.836 51.2429 80.5681 51.5352 80.2376 51.5352H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter9_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 60.2363C60.159 60.2363 59.8911 59.9441 59.8911 59.5836C59.8911 59.2231 60.159 58.9309 60.4895 58.9309H80.2376C80.5681 58.9309 80.836 59.2231 80.836 59.5836C80.836 59.9441 80.5681 60.2363 80.2376 60.2363H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter10_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 68.9316C60.159 68.9316 59.8911 68.6394 59.8911 68.2789C59.8911 67.9184 60.159 67.6262 60.4895 67.6262H80.2376C80.5681 67.6262 80.836 67.9184 80.836 68.2789C80.836 68.6394 80.5681 68.9316 80.2376 68.9316H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter11_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 77.6309C60.159 77.6309 59.8911 77.3386 59.8911 76.9781C59.8911 76.6176 60.159 76.3254 60.4895 76.3254H80.2376C80.5681 76.3254 80.836 76.6176 80.836 76.9781C80.836 77.3386 80.5681 77.6309 80.2376 77.6309H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M64.3799 48.4923C64.3799 47.7717 64.9157 47.1875 65.5767 47.1875C66.2377 47.1875 66.7736 47.7717 66.7736 48.4923V65.4546C66.7736 66.1753 66.2377 66.7594 65.5767 66.7594C64.9157 66.7594 64.3799 66.1753 64.3799 65.4546V48.4923Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M64.3799 48.4923C64.3799 47.7717 64.9157 47.1875 65.5767 47.1875C66.2377 47.1875 66.7736 47.7717 66.7736 48.4923V65.4546C66.7736 66.1753 66.2377 66.7594 65.5767 66.7594C64.9157 66.7594 64.3799 66.1753 64.3799 65.4546V48.4923Z",
        fill: "url(#paint7_linear_841_15159)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter12_i_841_15159)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.4895 86.332C60.159 86.332 59.8911 86.0398 59.8911 85.6793C59.8911 85.3188 60.159 85.0266 60.4895 85.0266H80.2376C80.5681 85.0266 80.836 85.3188 80.836 85.6793C80.836 86.0398 80.5681 86.332 80.2376 86.332H60.4895Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M56.1694 91.7656H60.1589C63.3538 91.7656 65.9437 94.5891 65.9437 98.0721V100.464H56.1694V91.7656Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M56.1694 91.7656H60.1589C63.3538 91.7656 65.9437 94.5891 65.9437 98.0721V100.464H56.1694V91.7656Z",
        fill: "url(#paint8_linear_841_15159)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        d: "M85.2749 91.7656H81.2854C78.0906 91.7656 75.5006 94.5891 75.5006 98.0721V100.464H85.2749V91.7656Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M85.2749 91.7656H81.2854C78.0906 91.7656 75.5006 94.5891 75.5006 98.0721V100.464H85.2749V91.7656Z",
        fill: "url(#paint9_linear_841_15159)",
        fillOpacity: 0.2
      })]
    }), /*#__PURE__*/_jsx("path", {
      d: "M61.373 97.9662C61.373 97.5458 61.6856 97.2051 62.0712 97.2051C62.4568 97.2051 62.7694 97.5458 62.7694 97.9662V102.75C62.7694 103.171 62.4568 103.512 62.0712 103.512C61.6856 103.512 61.373 103.171 61.373 102.75V97.9662Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M63.2305 97.9662C63.2305 97.5458 63.543 97.2051 63.9286 97.2051C64.3142 97.2051 64.6268 97.5458 64.6268 97.9662V102.75C64.6268 103.171 64.3142 103.512 63.9286 103.512C63.543 103.512 63.2305 103.171 63.2305 102.75V97.9662Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M62.8765 98.7272C62.8765 98.6071 62.9657 98.5098 63.0758 98.5098C63.1859 98.5098 63.2751 98.6071 63.2751 98.7272V101.989C63.2751 102.109 63.1859 102.207 63.0758 102.207C62.9657 102.207 62.8765 102.109 62.8765 101.989V98.7272Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M76.6885 97.9662C76.6885 97.5458 77.0011 97.2051 77.3866 97.2051C77.7722 97.2051 78.0848 97.5458 78.0848 97.9662V102.75C78.0848 103.171 77.7722 103.512 77.3866 103.512C77.0011 103.512 76.6885 103.171 76.6885 102.75V97.9662Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M78.5459 97.9662C78.5459 97.5458 78.8585 97.2051 79.2441 97.2051C79.6296 97.2051 79.9422 97.5458 79.9422 97.9662V102.75C79.9422 103.171 79.6296 103.512 79.2441 103.512C78.8585 103.512 78.5459 103.171 78.5459 102.75V97.9662Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M78.1919 98.7272C78.1919 98.6071 78.2811 98.5098 78.3912 98.5098C78.5013 98.5098 78.5905 98.6071 78.5905 98.7272V101.989C78.5905 102.109 78.5013 102.207 78.3912 102.207C78.2811 102.207 78.1919 102.109 78.1919 101.989V98.7272Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("rect", {
      x: 69.9741,
      y: 16.5254,
      width: 1.62941,
      height: 80.5331,
      fill: "#313131"
    }), /*#__PURE__*/_jsx("rect", {
      x: 70.3496,
      y: 16.5254,
      width: 0.597467,
      height: 80.6799,
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("line", {
      x1: 70.8482,
      y1: 16.6626,
      x2: 70.8482,
      y2: 96.9212,
      stroke: "#616161",
      strokeWidth: 0.274477,
      strokeLinecap: "round",
      strokeDasharray: "0.55 0.55"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M70.1671 21.3191C69.9571 21.2358 69.7279 21.3348 69.6456 21.5445L68.5976 24.213C68.4778 24.5181 68.6337 24.8759 68.9392 24.9971C69.2447 25.1183 69.575 24.9535 69.6631 24.6358L70.4337 21.8572C70.4942 21.6389 70.3771 21.4024 70.1671 21.3191ZM68.9549 24.7949C69.1618 24.877 69.3907 24.7605 69.466 24.5347C69.5414 24.3089 69.4348 24.0593 69.2279 23.9772C69.021 23.8951 68.7921 24.0116 68.7168 24.2374C68.6414 24.4632 68.748 24.7128 68.9549 24.7949Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M70.1671 23.2761C69.9571 23.1928 69.7279 23.2919 69.6456 23.5015L68.5976 26.1701C68.4778 26.4751 68.6337 26.8329 68.9392 26.9541C69.2447 27.0753 69.575 26.9105 69.6631 26.5929L70.4337 23.8142C70.4942 23.5959 70.3771 23.3594 70.1671 23.2761ZM68.9549 26.7519C69.1618 26.834 69.3907 26.7175 69.466 26.4917C69.5414 26.2659 69.4348 26.0163 69.2279 25.9342C69.021 25.8521 68.7921 25.9686 68.7168 26.1944C68.6414 26.4202 68.748 26.6698 68.9549 26.7519Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter13_b_841_15159)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0.170046 65.5781C3.02139 71.7234 91.8243 70.2439 93.0465 65.5781C93.0465 67.7403 93.0465 79.2075 93.0465 80.5731C91.417 86.377 4.6508 87.2874 0.170046 80.5731C0.170046 77.9557 0.169767 67.9679 0.170046 65.5781Z",
        fill: "white",
        fillOpacity: 0.9
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter14_b_841_15159)",
      children: /*#__PURE__*/_jsx("ellipse", {
        cx: 46.5238,
        cy: 74.6557,
        rx: 27.7,
        ry: 30.0893,
        fill: "white",
        fillOpacity: 0.9
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M35.6133 62.1446C35.6133 62.1446 43.0182 63.9321 46.8579 59.3145C46.8579 64.9748 46.8579 86.5735 46.8579 90.1485C38.2187 87.7652 35.6131 79.5726 35.6133 76.4445C35.6135 73.3164 35.6133 62.1446 35.6133 62.1446Z",
      fill: "url(#paint10_linear_841_15159)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M58.0112 62.1446C58.0112 62.1446 50.6063 63.9321 46.7667 59.3145C46.7667 64.9748 46.7667 86.5735 46.7667 90.1485C55.4058 87.7652 58.0115 79.5726 58.0112 76.4445C58.011 73.3164 58.0112 62.1446 58.0112 62.1446Z",
      fill: "url(#paint11_linear_841_15159)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M58.0112 62.1446C58.0112 62.1446 50.6063 63.9321 46.7667 59.3145C46.7667 64.9748 46.7667 86.5735 46.7667 90.1485C55.4058 87.7652 58.0115 79.5726 58.0112 76.4445C58.011 73.3164 58.0112 62.1446 58.0112 62.1446Z",
      fill: "black",
      fillOpacity: 0.2
    }), /*#__PURE__*/_jsx("path", {
      d: "M42.4379 71.9122L41.2884 73.1398L41.2884 73.1396C41.2366 73.195 41.2075 73.2698 41.2075 73.348C41.2075 73.4261 41.2366 73.5011 41.2884 73.5563L45.5878 78.1481C45.6956 78.263 45.8702 78.263 45.9781 78.1481L52.6455 71.0275C52.7533 70.9125 52.7533 70.7258 52.6455 70.6109L51.4962 69.3832C51.4445 69.3279 51.3743 69.2969 51.3012 69.2969C51.2279 69.2969 51.1579 69.3279 51.1061 69.3832L45.7829 75.0682L42.828 71.9122C42.7202 71.7973 42.5455 71.7973 42.4379 71.9122Z",
      fill: "#95F47D"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_i_841_15159",
        x: 13.2446,
        y: 38.707,
        width: 1.1958,
        height: 52.9114,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_i_841_15159",
        x: 21.0791,
        y: 38.707,
        width: 1.1958,
        height: 52.9114,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter2_i_841_15159",
        x: 29.2974,
        y: 38.707,
        width: 1.1958,
        height: 52.9114,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter3_i_841_15159",
        x: 45.3423,
        y: 38.707,
        width: 1.1958,
        height: 52.9114,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter4_i_841_15159",
        x: 37.1318,
        y: 38.707,
        width: 1.1958,
        height: 52.9114,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter5_i_841_15159",
        x: 59.8911,
        y: 24.1348,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter6_i_841_15159",
        x: 59.8911,
        y: 32.8359,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter7_i_841_15159",
        x: 59.8911,
        y: 41.5312,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter8_i_841_15159",
        x: 59.8911,
        y: 50.2305,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter9_i_841_15159",
        x: 59.8911,
        y: 58.9316,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter10_i_841_15159",
        x: 59.8911,
        y: 67.627,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter11_i_841_15159",
        x: 59.8911,
        y: 76.3262,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter12_i_841_15159",
        x: 59.8911,
        y: 85.0273,
        width: 20.9448,
        height: 2.67707,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 1.37239
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 1.37239
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_15159"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter13_b_841_15159",
        x: -10.8092,
        y: 54.599,
        width: 114.835,
        height: 41.6535,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          in: "BackgroundImageFix",
          stdDeviation: 5.48955
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_841_15159"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_backgroundBlur_841_15159",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter14_b_841_15159",
        x: 13.3342,
        y: 39.0769,
        width: 66.379,
        height: 71.1568,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          in: "BackgroundImageFix",
          stdDeviation: 2.74477
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_841_15159"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_backgroundBlur_841_15159",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15159",
        x1: 7.84641,
        y1: 44.1206,
        x2: 51.0265,
        y2: 44.4957,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#CD4848"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.0414636,
          stopColor: "#A22626"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.957069,
          stopColor: "#992222"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#CD4848"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15159",
        x1: 11.9199,
        y1: 33.0584,
        x2: 43.1464,
        y2: 95.7009,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.131169,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_15159",
        x1: 50.2112,
        y1: 34.8284,
        x2: 7.42212,
        y2: 93.4964,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.363327,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_841_15159",
        x1: 12.5156,
        y1: 91.9883,
        x2: 12.5156,
        y2: 100.687,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint4_linear_841_15159",
        x1: 46.7935,
        y1: 91.9883,
        x2: 46.7935,
        y2: 100.687,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint5_linear_841_15159",
        x1: 56.9274,
        y1: 46.7729,
        x2: 83.8127,
        y2: 46.7729,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#888888"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.090846,
          stopColor: "#444444"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.935773,
          stopColor: "#444444"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#888888"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint6_linear_841_15159",
        x1: 82.5907,
        y1: 18.8961,
        x2: 54.3207,
        y2: 92.2002,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.218513,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint7_linear_841_15159",
        x1: 65.5767,
        y1: 47.1875,
        x2: 65.5767,
        y2: 66.7594,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint8_linear_841_15159",
        x1: 61.0566,
        y1: 91.7656,
        x2: 61.0566,
        y2: 100.464,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint9_linear_841_15159",
        x1: 80.3878,
        y1: 91.7656,
        x2: 80.3878,
        y2: 100.464,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint10_linear_841_15159",
        x1: 35.8243,
        y1: 72.6207,
        x2: 46.2115,
        y2: 72.6231,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {}), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#181E1F"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint11_linear_841_15159",
        x1: 57.8002,
        y1: 72.6207,
        x2: 47.413,
        y2: 72.6231,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {}), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#253033"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TravAssistCall.tsx


function TravAssistCall_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravAssistCall_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravAssistCall_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravAssistCall_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var TravAssistCall = function TravAssistCall(props) {
  return /*#__PURE__*/_jsxs("svg", TravAssistCall_objectSpread(TravAssistCall_objectSpread({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_841_15232)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask0_841_15232",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 0,
        width: 70,
        height: 69,
        children: /*#__PURE__*/_jsx("path", {
          d: "M58.1782 0H12.5765C6.15167 0 0.943359 5.20847 0.943359 11.6334V57.2366C0.943359 63.6615 6.15167 68.87 12.5765 68.87H58.1782C64.603 68.87 69.8113 63.6615 69.8113 57.2366V11.6334C69.8113 5.20847 64.603 0 58.1782 0Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask0_841_15232)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M58.1782 0H12.5765C6.15167 0 0.943359 5.20847 0.943359 11.6334V57.2366C0.943359 63.6615 6.15167 68.87 12.5765 68.87H58.1782C64.603 68.87 69.8113 63.6615 69.8113 57.2366V11.6334C69.8113 5.20847 64.603 0 58.1782 0Z",
          fill: "url(#paint0_linear_841_15232)"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M35.835 0H58.6358C65.0606 0 70.2689 5.20847 70.2689 11.6334V57.2366C70.2689 63.6615 65.0606 68.87 58.6358 68.87H35.835V0Z",
          fill: "url(#paint1_radial_841_15232)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M51.2725 36.3282V33.1099C51.2725 28.8949 49.5982 24.8521 46.6176 21.8718C43.6373 18.8912 39.5948 17.2168 35.3799 17.2168C31.1651 17.2168 27.1224 18.8912 24.1422 21.8718C21.1616 24.8522 19.4873 28.8949 19.4873 33.1099V36.3282C18.6639 36.8531 18.1646 37.7617 18.1631 38.7385V41.6081C18.1631 42.369 18.4654 43.0989 19.0034 43.6373C19.5418 44.1753 20.2717 44.4776 21.0326 44.4776C21.0326 45.2386 21.3349 45.9685 21.8729 46.5068C22.4113 47.0449 23.1412 47.3472 23.9021 47.3472H25.3368C25.9075 47.3472 26.4552 47.1205 26.8586 46.7169C27.2621 46.3134 27.4889 45.7657 27.4889 45.1951V35.1516C27.4889 34.5809 27.2621 34.0332 26.8586 33.6297C26.4551 33.2263 25.9074 32.9994 25.3368 32.9994H23.9021C23.1411 32.9994 22.4112 33.3018 21.8729 33.8398C21.3349 34.3782 21.0326 35.1081 21.0326 35.869C20.9945 35.869 20.9608 35.8789 20.9221 35.8805V33.1099C20.9224 30.3691 21.7073 27.6856 23.1847 25.3772L24.4084 26.6019C24.5567 26.7527 24.7649 26.829 24.9753 26.8098C25.1857 26.7925 25.3778 26.6829 25.5005 26.5106C27.7766 23.3144 31.4563 21.4149 35.3797 21.4108C38.598 21.3999 41.6862 22.6799 43.9529 24.9648C44.4327 25.4404 44.8699 25.9575 45.2586 26.5101C45.3806 26.683 45.5725 26.7932 45.7829 26.8114H45.8437H45.844C46.0343 26.8114 46.2168 26.7359 46.3513 26.601L47.575 25.3773C49.0524 27.6857 49.8373 30.3693 49.8377 33.11V35.8806C49.8005 35.8806 49.7659 35.8691 49.7272 35.8691C49.7272 35.1082 49.4249 34.3782 48.8868 33.8399C48.3485 33.3019 47.6186 32.9995 46.8577 32.9995H45.423C44.8523 32.9995 44.3046 33.2263 43.9011 33.6298C43.4977 34.0334 43.2709 34.581 43.2709 35.1517V45.1952C43.2722 45.7566 43.4925 46.2953 43.8851 46.6963C44.2778 47.0976 44.8116 47.3291 45.3728 47.3423C45.2152 47.9578 44.8578 48.5032 44.3565 48.8936C43.8553 49.284 43.2388 49.4973 42.6038 49.4996H40.4014C40.4014 48.9289 40.1747 48.3812 39.7712 47.9777C39.3676 47.5743 38.82 47.3474 38.2493 47.3474H36.8146C36.0457 47.3474 35.3353 47.7577 34.9507 48.4235C34.5664 49.0894 34.5664 49.9099 34.9507 50.5757C35.3354 51.2415 36.0457 51.6518 36.8146 51.6518H38.2493C38.8581 51.6499 39.4371 51.3889 39.842 50.9344H42.6039C43.6204 50.9334 44.6036 50.5725 45.3795 49.9163C46.1555 49.2597 46.674 48.3496 46.8434 47.3474H46.8578C47.6187 47.3474 48.3486 47.0451 48.8869 46.5071C49.4249 45.9687 49.7273 45.2388 49.7273 44.4779C50.4882 44.4779 51.2181 44.1755 51.7564 43.6375C52.2944 43.0991 52.5967 42.3692 52.5967 41.6083V38.7387C52.5951 37.7619 52.0959 36.8533 51.2725 36.3284V36.3282ZM21.0322 43.0429C20.6518 43.0429 20.2867 42.8917 20.0177 42.6227C19.7487 42.3537 19.5975 41.9885 19.5975 41.6081V38.7385C19.5975 38.358 19.7487 37.9929 20.0177 37.7239C20.2867 37.4549 20.6518 37.3037 21.0322 37.3037V43.0429ZM51.1618 41.6081C51.1618 41.9885 51.0107 42.3537 50.7417 42.6227C50.4727 42.8917 50.1076 43.0429 49.7271 43.0429V37.3037C50.1076 37.3037 50.4727 37.4549 50.7417 37.7239C51.0107 37.9929 51.1618 38.358 51.1618 38.7385V41.6081Z",
        fill: "white"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15232",
        x1: 35.3773,
        y1: -5.5406e-7,
        x2: 16.7856,
        y2: 70.5767,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#027863"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#163E36"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        id: "paint1_radial_841_15232",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(62.8744 2.53307e-06) rotate(110.806) scale(77.0415 68.4417)",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00E6BC"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#01715D",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_841_15232",
        children: /*#__PURE__*/_jsx("rect", {
          x: 0.943359,
          width: 68.8679,
          height: 68.87,
          rx: 34.434,
          fill: "white"
        })
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/MedicalBenefitIcon.tsx


function MedicalBenefitIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MedicalBenefitIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MedicalBenefitIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MedicalBenefitIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MedicalBenefitIcon = function MedicalBenefitIcon(props) {
  return /*#__PURE__*/_jsxs("svg", MedicalBenefitIcon_objectSpread(MedicalBenefitIcon_objectSpread({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 82,
      cy: 82,
      r: 82,
      fill: "#FAFAFA"
    }), /*#__PURE__*/_jsx("path", {
      d: "M131.057 61.6454V82.8209H96.3694V120.466H72.8521V82.8209H38.1641V61.6454H72.8521V24H96.3694V61.6454H131.057Z",
      fill: "#F4EDED"
    }), /*#__PURE__*/_jsx("path", {
      d: "M119.718 102.307C127.804 94.2018 127.798 81.0774 119.7 72.9798C111.911 65.1904 99.4702 64.8887 91.3199 72.0732C90.7771 72.5517 89.9678 72.5517 89.425 72.0732C81.2747 64.8887 69.291 64.0095 61.5017 71.7988C53.4042 79.8963 52.9413 94.2018 61.0263 102.307L89.365 130.647C89.9214 131.203 90.8235 131.203 91.3799 130.647L119.718 102.307Z",
      fill: "url(#paint0_linear_841_15247)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M120.718 102.307C128.803 94.202 128.798 81.0776 120.7 72.98C112.911 65.1906 100.47 64.8889 92.3197 72.0734C91.7769 72.5519 90.9677 72.5519 90.4248 72.0734C82.2745 64.8889 69.8337 65.1906 62.0444 72.98C53.9469 81.0775 53.9411 94.202 62.0261 102.307L90.3648 130.647C90.9212 131.203 91.8233 131.203 92.3797 130.647L120.718 102.307Z",
      fill: "url(#paint1_linear_841_15247)",
      fillOpacity: 0.8
    }), /*#__PURE__*/_jsx("path", {
      d: "M120.72 102.305L92.3819 130.645C91.8262 131.201 90.9229 131.201 90.3672 130.645L87.5234 127.802L115.185 100.14C123.269 92.0343 123.264 78.9093 115.167 70.8124C113.819 69.4646 112.331 68.3405 110.75 67.4414C114.397 68.2892 117.858 70.1342 120.702 72.9781C128.8 81.0749 128.806 94.1998 120.72 102.305Z",
      fill: "url(#paint2_linear_841_15247)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M92.0124 109.917C92.0124 109.475 91.6542 109.117 91.2124 109.117H81.6374V99.5422C81.6374 99.1004 81.2792 98.7422 80.8374 98.7422H69.9602C69.5183 98.7422 69.1602 99.1004 69.1602 99.5422V109.117H59.5852C59.1433 109.117 58.7852 109.475 58.7852 109.917V120.794C58.7852 121.236 59.1433 121.594 59.5852 121.594H69.1602V131.169C69.1602 131.611 69.5183 131.969 69.9602 131.969H80.8374C81.2792 131.969 81.6374 131.611 81.6374 131.169V121.594H91.2124C91.6543 121.594 92.0124 121.236 92.0124 120.794V109.917Z",
      fill: "url(#paint3_linear_841_15247)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M91.0124 108.917C91.0124 108.475 90.6542 108.117 90.2124 108.117H80.6374V98.5422C80.6374 98.1004 80.2792 97.7422 79.8374 97.7422H68.9602C68.5183 97.7422 68.1602 98.1004 68.1602 98.5422V108.117H58.5852C58.1433 108.117 57.7852 108.475 57.7852 108.917V119.794C57.7852 120.236 58.1433 120.594 58.5852 120.594H68.1602V130.169C68.1602 130.611 68.5183 130.969 68.9602 130.969H79.8374C80.2792 130.969 80.6374 130.611 80.6374 130.169V120.594H90.2124C90.6543 120.594 91.0124 120.236 91.0124 119.794V108.917Z",
      fill: "url(#paint4_linear_841_15247)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M89.9985 110.05C89.9985 109.635 89.6622 109.299 89.2473 109.299H79.7874V99.5052C79.7874 99.0903 79.451 98.7539 79.0361 98.7539H69.7895C69.3746 98.7539 69.0383 99.0903 69.0383 99.5052V109.299H59.5584C59.1435 109.299 58.8071 109.635 58.8071 110.05V118.881C58.8071 119.296 59.1435 119.633 59.5584 119.633H69.0383V129.205C69.0383 129.62 69.3746 129.956 69.7895 129.956H79.0361C79.451 129.956 79.7874 129.62 79.7874 129.205V119.633H89.2473C89.6622 119.633 89.9985 119.296 89.9985 118.881V110.05Z",
      fill: "url(#paint5_linear_841_15247)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15247",
        x1: 90.4841,
        y1: 66.3125,
        x2: 90.4841,
        y2: 131.064,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF9C07"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#FFD6D6",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15247",
        x1: 56.3186,
        y1: 78.6422,
        x2: 90.5745,
        y2: 131.573,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#EE7370"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.570958,
          stopColor: "#EC4545"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#992222"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_15247",
        x1: 123.496,
        y1: 78.2988,
        x2: 90.4961,
        y2: 131.299,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#C73C3C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#CA5A5A",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_841_15247",
        x1: 75.3988,
        y1: 98.7422,
        x2: 75.3988,
        y2: 131.969,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#A3773B"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#D2A76D"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint4_linear_841_15247",
        x1: 74.3988,
        y1: 97.7422,
        x2: 74.3988,
        y2: 130.969,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FFF9DC"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#FFE34E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint5_linear_841_15247",
        x1: 74.4028,
        y1: 98.7539,
        x2: 74.4028,
        y2: 129.956,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F2CC98"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F2CC98",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TravBenefitIcon.tsx


function TravBenefitIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravBenefitIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravBenefitIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravBenefitIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var TravBenefitIcon = function TravBenefitIcon(props) {
  return /*#__PURE__*/_jsxs("svg", TravBenefitIcon_objectSpread(TravBenefitIcon_objectSpread({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 82.0009,
      cy: 82.0009,
      r: 82.0009,
      fill: "#FAFAFA"
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.8389 33.3675C41.8389 33.3675 67.1926 39.179 80.339 24.166C80.339 42.569 80.339 112.791 80.339 124.414C50.7596 116.665 41.8381 90.0294 41.8389 79.8593C41.8396 69.6893 41.8389 33.3675 41.8389 33.3675Z",
      fill: "#F4EDED"
    }), /*#__PURE__*/_jsx("path", {
      d: "M118.525 33.3675C118.525 33.3675 93.1712 39.179 80.0248 24.166C80.0248 42.569 80.0248 112.791 80.0248 124.414C109.604 116.665 118.526 90.0294 118.525 79.8593C118.524 69.6893 118.525 33.3675 118.525 33.3675Z",
      fill: "#F4EDED"
    }), /*#__PURE__*/_jsx("path", {
      d: "M112.134 120.622L103.593 112.081L112.134 103.54C114.492 101.182 118.316 101.182 120.674 103.54C123.033 105.899 123.033 109.723 120.674 112.081L112.134 120.622Z",
      fill: "#868686"
    }), /*#__PURE__*/_jsx("path", {
      d: "M95.365 80.6122L49.6895 55.045C47.3478 53.7375 44.3848 54.1524 42.4852 56.0522L37.166 61.3714L75.8434 100.134L95.365 80.6122Z",
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M124.874 130.316L99.6327 84.8828L80.1113 104.404L118.545 142.838L123.864 137.519C125.764 135.619 126.179 132.656 124.874 130.316Z",
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M60.9086 77.9161L52.3677 69.3752L65.179 56.5638C67.5376 54.2053 71.3614 54.2053 73.7198 56.5638C76.0783 58.9224 76.0783 62.7462 73.7198 65.1046L60.9086 77.9161Z",
      fill: "#868686"
    }), /*#__PURE__*/_jsx("path", {
      d: "M95.365 77.6122L49.6895 52.045C47.3478 50.7375 44.3848 51.1524 42.4852 53.0522L37.166 58.3714L75.8434 97.1337L95.365 77.6122Z",
      fill: "url(#paint0_linear_841_15271)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M124.875 127.316L99.6342 81.8828L80.1128 101.404L118.547 139.838L123.866 134.519C125.766 132.619 126.18 129.656 124.875 127.316Z",
      fill: "url(#paint1_linear_841_15271)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M73.3841 131.468L64.8434 140.008L56.3026 122.927L39.2207 114.386L47.7615 105.845L61.982 108.706L106.102 58.0272C110.03 53.5006 116.906 52.7749 121.688 57.5578C126.428 62.2978 125.746 69.216 121.219 73.1446L70.5229 117.247L73.3841 131.468Z",
      fill: "url(#paint2_linear_841_15271)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M73.3841 131.468L64.8434 140.008L56.3026 122.927L39.2207 114.386L47.7615 105.845L61.982 108.706L106.102 58.0272C110.03 53.5006 116.906 52.7749 121.688 57.5578C126.428 62.2978 125.746 69.216 121.219 73.1446L70.5229 117.247L73.3841 131.468Z",
      fill: "black",
      fillOpacity: 0.2
    }), /*#__PURE__*/_jsx("path", {
      d: "M71.3841 130.468L62.8434 139.008L54.3026 121.927L37.2207 113.386L45.7615 104.845L59.982 107.706L106.102 55.0272C110.03 50.5006 116.906 49.7749 121.688 54.5578C126.428 59.2978 125.746 66.216 121.219 70.1446L68.5229 116.247L71.3841 130.468Z",
      fill: "url(#paint3_linear_841_15271)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15271",
        x1: 69.498,
        y1: 89.5,
        x2: 36.6247,
        y2: 57.7455,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#008CFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#59D7FF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15271",
        x1: 102.872,
        y1: 81.8828,
        x2: 109.5,
        y2: 139,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#0268BC"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#59D7FF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_15271",
        x1: 105.998,
        y1: 55,
        x2: 67.4981,
        y2: 128.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#A3A3A3"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#D9D9D9"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_841_15271",
        x1: 103.998,
        y1: 54,
        x2: 65.498,
        y2: 127.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#A3A3A3"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#D9D9D9"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/PersonalBenefitIcon.tsx


function PersonalBenefitIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PersonalBenefitIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PersonalBenefitIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PersonalBenefitIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PersonalBenefitIcon = function PersonalBenefitIcon(props) {
  return /*#__PURE__*/_jsxs("svg", PersonalBenefitIcon_objectSpread(PersonalBenefitIcon_objectSpread({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 82.0009,
      cy: 82.0009,
      r: 82.0009,
      fill: "#FAFAFA"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M83.6958 43.0661C93.6193 48.6375 104.337 52.2062 115.589 53.5102V53.5164C117.245 53.7223 118.501 55.1635 118.501 56.9541V85.0359C118.501 106.978 103.482 125.87 82.701 129.938C82.5009 130 82.3068 130 82.1066 130C81.9064 130 81.7123 130 81.5122 129.932C60.7311 125.876 45.7124 106.972 45.7124 85.0421V56.9479C45.7124 55.1635 46.968 53.7223 48.6239 53.5164C59.8758 52.2062 70.5939 48.6375 80.5174 43.0661C81.5122 42.517 82.701 42.517 83.6958 43.0661Z",
      fill: "url(#paint0_linear_841_15292)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M83.6958 43.0661C93.6193 48.6375 104.337 52.2062 115.589 53.5102V53.5164C117.245 53.7223 118.501 55.1635 118.501 56.9541V85.0359C118.501 106.978 103.482 125.87 82.701 129.938C82.5009 130 82.3068 130 82.1066 130C81.9064 130 81.7123 130 81.5122 129.932C60.7311 125.876 45.7124 106.972 45.7124 85.0421V56.9479C45.7124 55.1635 46.968 53.7223 48.6239 53.5164C59.8758 52.2062 70.5939 48.6375 80.5174 43.0661C81.5122 42.517 82.701 42.517 83.6958 43.0661Z",
      fill: "black",
      fillOpacity: 0.2
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M83.6958 40.0661C93.6193 45.6375 104.337 49.2062 115.589 50.5102V50.5164C117.245 50.7223 118.501 52.1635 118.501 53.9541V82.0359C118.501 103.978 103.482 122.87 82.701 126.938C82.5009 127 82.3068 127 82.1066 127C81.9064 127 81.7123 127 81.5122 126.932C60.7311 122.876 45.7124 103.972 45.7124 82.0421V53.9479C45.7124 52.1635 46.968 50.7223 48.6239 50.5164C59.8758 49.2062 70.5939 45.6375 80.5174 40.0661C81.5122 39.517 82.701 39.517 83.6958 40.0661Z",
      fill: "url(#paint1_linear_841_15292)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M81.959 126.999C82.0084 127 82.058 127 82.108 127C82.3082 127 82.5023 127 82.7025 126.938C103.484 122.87 118.502 103.978 118.502 82.0359V53.9541C118.502 52.1635 117.247 50.7223 115.591 50.5164V50.5102C104.339 49.2062 93.6207 45.6375 83.6972 40.0661C83.1546 39.7666 82.5542 39.6304 81.959 39.6577V126.999Z",
      fill: "url(#paint2_linear_841_15292)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M81.959 126.999C82.0084 127 82.058 127 82.108 127C82.3082 127 82.5023 127 82.7025 126.938C103.484 122.87 118.502 103.978 118.502 82.0359V53.9541C118.502 52.1635 117.247 50.7223 115.591 50.5164V50.5102C104.339 49.2062 93.6207 45.6375 83.6972 40.0661C83.1546 39.7666 82.5542 39.6304 81.959 39.6577V126.999Z",
      fill: "white",
      fillOpacity: 0.2
    }), /*#__PURE__*/_jsx("circle", {
      opacity: 0.3,
      cx: 106.003,
      cy: 60.002,
      r: 20.998,
      fill: "black"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 107.003,
      cy: 59.002,
      r: 20.998,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M116.762 57.2759V61.6741H109.554V69.493H104.667V61.6741H97.459V57.2759H104.667V49.457H109.554V57.2759H116.762Z",
      fill: "url(#paint3_linear_841_15292)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15292",
        x1: 82.1066,
        y1: 42.6543,
        x2: 82.1066,
        y2: 130,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#28624A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#3DC78E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15292",
        x1: 82.1066,
        y1: 39.6543,
        x2: 82.1066,
        y2: 127,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#28624A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#3DC78E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_15292",
        x1: 100.23,
        y1: 39.6543,
        x2: 100.23,
        y2: 127,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#28624A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#3DC78E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_841_15292",
        x1: 107.11,
        y1: 49.457,
        x2: 107.11,
        y2: 69.493,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#C4AD37"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#FFE55E"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LowestPriceIcon.tsx


function LowestPriceIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LowestPriceIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LowestPriceIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LowestPriceIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LowestPriceIcon = function LowestPriceIcon(props) {
  return /*#__PURE__*/_jsxs("svg", LowestPriceIcon_objectSpread(LowestPriceIcon_objectSpread({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 16.002,
      cy: 16,
      r: 16,
      fill: "#D8E5F7"
    }), /*#__PURE__*/_jsx("rect", {
      x: 0.00195312,
      width: 32,
      height: 32,
      fill: "#D8D8D8",
      fillOpacity: 0.01
    }), /*#__PURE__*/_jsx("circle", {
      cx: 16.002,
      cy: 16.0001,
      r: 9.33333,
      transform: "rotate(45 16.002 16.0001)",
      fill: "white",
      stroke: "#1E1E1E",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.002 12.25H18.8608",
      stroke: "#1E1E1E",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.002 14.7422H18.8608",
      stroke: "#1E1E1E",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.2729 17.2344L16.6171 21.1589",
      stroke: "#1E1E1E",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3452 12.25H14.6157C16.1777 12.25 17.4577 13.3706 17.4577 14.7416C17.4577 16.1127 16.1777 17.2349 14.6157 17.2349H13.3452",
      stroke: "#1E1E1E",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.002 12.25H18.8608",
      stroke: "#1E1E1E",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.002 14.7422H18.8608",
      stroke: "#1E1E1E",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.2729 17.2344L16.6171 21.1589",
      stroke: "#1E1E1E",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.3452 12.25H14.6157C16.1777 12.25 17.4577 13.3706 17.4577 14.7416C17.4577 16.1127 16.1777 17.2349 14.6157 17.2349H13.3452",
      stroke: "#1E1E1E",
      strokeLinecap: "round"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LightGreenShield.tsx


function LightGreenShield_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LightGreenShield_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LightGreenShield_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LightGreenShield_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LightGreenShield = function LightGreenShield(props) {
  return /*#__PURE__*/_jsxs("svg", LightGreenShield_objectSpread(LightGreenShield_objectSpread({
    width: 287,
    height: 321,
    viewBox: "0 0 287 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      opacity: 0.24,
      children: /*#__PURE__*/_jsxs("g", {
        opacity: 0.2,
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M150.226 1.51056C189.214 21.9489 231.324 35.0405 275.532 39.8239V39.8468C282.037 40.6021 286.971 45.889 286.971 52.4577V155.473C286.971 235.968 227.964 305.271 146.318 320.193C145.531 320.422 144.769 320.422 143.982 320.422C143.196 320.422 142.433 320.422 141.647 320.171C60.0006 305.294 0.994141 235.945 0.994141 155.496V52.4348C0.994141 45.8891 5.92723 40.6021 12.4332 39.8468C56.6404 35.0405 98.7504 21.9489 137.739 1.51056C141.647 -0.503521 146.318 -0.503521 150.226 1.51056Z",
          fill: "url(#paint0_linear_841_15041)"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M143.405 320.418C143.606 320.422 143.808 320.422 144.012 320.422C144.798 320.422 145.561 320.422 146.347 320.193C227.994 305.271 287 235.968 287 155.473V52.4577C287 45.889 282.067 40.6021 275.561 39.8468V39.8239C231.354 35.0405 189.244 21.9489 150.256 1.51056C148.117 0.408498 145.75 -0.0905396 143.405 0.0134493V320.418Z",
          fill: "url(#paint1_linear_841_15041)"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M143.405 320.418C143.606 320.422 143.808 320.422 144.012 320.422C144.798 320.422 145.561 320.422 146.347 320.193C227.994 305.271 287 235.968 287 155.473V52.4577C287 45.889 282.067 40.6021 275.561 39.8468V39.8239C231.354 35.0405 189.244 21.9489 150.256 1.51056C148.117 0.408498 145.75 -0.0905396 143.405 0.0134493V320.418Z",
          fill: "white",
          fillOpacity: 0.2
        })]
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_15041",
        x1: 143.982,
        y1: 0,
        x2: 143.982,
        y2: 320.422,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#28624A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#3DC78E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_15041",
        x1: 215.202,
        y1: 0,
        x2: 215.202,
        y2: 320.422,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#28624A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#3DC78E"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/GreySpiral.tsx


function GreySpiral_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GreySpiral_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GreySpiral_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GreySpiral_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var GreySpiral = function GreySpiral(props) {
  return /*#__PURE__*/_jsx("svg", GreySpiral_objectSpread(GreySpiral_objectSpread({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M58.0764 22.5587C58.6531 22.4945 59.0686 21.975 59.0044 21.3984L57.959 12.0008C57.8949 11.4241 57.3754 11.0086 56.7987 11.0727C56.222 11.1369 55.8065 11.6564 55.8707 12.2331L56.7999 20.5865L48.4465 21.5157C47.8698 21.5799 47.4543 22.0994 47.5185 22.676C47.5826 23.2527 48.1021 23.6682 48.6788 23.6041L58.0764 22.5587ZM2.07621 37.2577C8.7142 25.7603 16.3501 20.6118 22.9282 19.6045C29.4773 18.6016 35.1915 21.6601 38.2476 27.0683L40.077 26.0345C36.6112 19.9013 30.0615 16.3865 22.6102 17.5275C15.1879 18.664 7.08677 24.3767 0.256481 36.2071L2.07621 37.2577ZM38.2476 27.0683C39.7792 29.7786 39.9904 32.0064 39.5103 33.6481C39.0325 35.2817 37.8259 36.4953 36.1816 37.1246C32.8862 38.3857 27.7459 37.2658 24.056 31.9463L22.3294 33.144C26.4632 39.1032 32.5687 40.7571 36.9326 39.087C39.1179 38.2507 40.8444 36.5724 41.527 34.2379C42.2074 31.9115 41.8063 29.0948 40.077 26.0345L38.2476 27.0683ZM24.056 31.9463C22.3233 29.4486 22.1974 26.6711 23.299 24.0815C24.4135 21.4615 26.8052 19.0079 30.1299 17.3598C36.7382 14.0838 46.9515 14.0551 57.304 22.335L58.6165 20.694C47.6907 11.9557 36.6084 11.803 29.1966 15.4772C25.5112 17.3042 22.7117 20.0942 21.3654 23.259C20.0063 26.454 20.1502 30.0024 22.3294 33.144L24.056 31.9463Z",
      fill: "#CBCBCB"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BlueChev.tsx


function BlueChev_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BlueChev_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BlueChev_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BlueChev_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var BlueChev_BlueChev = function BlueChev(props) {
  return /*#__PURE__*/_jsx("svg", BlueChev_objectSpread(BlueChev_objectSpread({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00005 9.5L12.25 4.25L13.5 5.5L7.00005 12.0028L0.5 5.5L1.75 4.25L7.00005 9.5Z",
      fill: "#008CFF"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/SearchIcon.tsx


function SearchIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/_jsxs("svg", SearchIcon_objectSpread(SearchIcon_objectSpread({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: 23,
      height: 23,
      rx: 11.5,
      fill: "#EAF5FF"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.6153 16.3216L16.7372 16.1996L14.3893 13.8521C15.112 13.0046 15.5053 11.9449 15.5053 10.828C15.5053 9.57884 15.0187 8.40401 14.1356 7.52048C12.3121 5.69696 9.34528 5.69696 7.52096 7.52042C5.69744 9.34394 5.69744 12.3116 7.52093 14.1351C8.40839 15.0225 9.59496 15.5028 10.828 15.5028C11.9308 15.5028 13.0003 15.1136 13.8521 14.3887L16.2005 16.7364C16.2727 16.8085 16.3688 16.8477 16.4687 16.8477C16.5686 16.8477 16.6651 16.8085 16.7372 16.7363C16.8853 16.5883 16.8853 16.3484 16.7375 16.1999L16.6153 16.3216ZM13.5995 13.5983C12.0719 15.1259 9.58607 15.1262 8.05826 13.5983C6.53058 12.0707 6.53058 9.58483 8.05826 8.05715C8.8023 7.31388 9.79565 6.9118 10.8287 6.9118C11.8624 6.9118 12.8558 7.31383 13.5995 8.05718C14.3397 8.79736 14.7469 9.78078 14.7469 10.828C14.7469 11.8749 14.3395 12.8587 13.5995 13.5983Z",
      fill: "#008CFF"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/LuggageIconShaded.tsx


function LuggageIconShaded_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LuggageIconShaded_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LuggageIconShaded_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LuggageIconShaded_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LuggageIconShaded = function LuggageIconShaded(props) {
  return /*#__PURE__*/_jsxs("svg", LuggageIconShaded_objectSpread(LuggageIconShaded_objectSpread({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: 72,
      height: 80,
      rx: 8,
      fill: "url(#paint0_linear_841_30597)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.0001 52.1772C15.3762 50.1433 58.2344 50.6329 58.8242 52.1772C58.8242 51.4616 58.8242 46.5395 58.8242 46.0875C58.0378 44.1665 16.1626 43.8652 14.0001 46.0875C14.0001 46.9538 13.9999 51.3863 14.0001 52.1772Z",
      fill: "#E0E0E0"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.2446 35.7326C17.2446 35.5675 17.3739 35.4336 17.5334 35.4336H18.1111C18.2706 35.4336 18.3999 35.5675 18.3999 35.7326V37.0282C18.3999 37.1933 18.2706 37.3272 18.1111 37.3272H17.5334C17.3739 37.3272 17.2446 37.1933 17.2446 37.0282V35.7326Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("rect", {
      x: 23.9131,
      y: 21.2798,
      width: 0.577626,
      height: 9.46792,
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("rect", {
      x: 31.6592,
      y: 21.2798,
      width: 0.577626,
      height: 9.46792,
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.657 31.5459C23.4975 31.5459 23.3682 31.412 23.3682 31.2469V30.6489C23.3682 30.4838 23.4975 30.35 23.657 30.35H24.8122C24.9717 30.35 25.101 30.4838 25.101 30.6489V31.2469C25.101 31.412 24.9717 31.5459 24.8122 31.5459H23.657Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M31.2273 31.5459C31.0678 31.5459 30.9385 31.412 30.9385 31.2469V30.6489C30.9385 30.4838 31.0678 30.35 31.2273 30.35H32.3825C32.542 30.35 32.6714 30.4838 32.6714 30.6489V31.2469C32.6714 31.412 32.542 31.5459 32.3825 31.5459H31.2273Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M37.2437 42.1113C37.2437 41.6159 37.6316 41.2144 38.1101 41.2144H38.4952C38.9737 41.2144 39.3616 41.6159 39.3616 42.1113V49.287C39.3616 49.7824 38.9737 50.184 38.4952 50.184H38.1101C37.6316 50.184 37.2437 49.7824 37.2437 49.287V42.1113Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.2446 53.672C17.2446 53.5069 17.3739 53.373 17.5334 53.373H18.1111C18.2706 53.373 18.3999 53.5069 18.3999 53.672V54.9676C18.3999 55.1328 18.2706 55.2666 18.1111 55.2666H17.5334C17.3739 55.2666 17.2446 55.1328 17.2446 54.9676V53.672Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_841_30597",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 17,
      y: 30,
      width: 22,
      height: 31,
      children: /*#__PURE__*/_jsx("path", {
        d: "M17.6021 33.9387C17.6021 32.1774 18.9813 30.7495 20.6827 30.7495H35.701C37.4024 30.7495 38.7817 32.1774 38.7817 33.9387V57.459C38.7817 59.2203 37.4024 60.6482 35.701 60.6482H20.6827C18.9813 60.6482 17.6021 59.2203 17.6021 57.459V33.9387Z",
        fill: "#D9D9D9"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_841_30597)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M17.6021 33.9387C17.6021 32.1774 18.9813 30.7495 20.6827 30.7495H35.701C37.4024 30.7495 38.7817 32.1774 38.7817 33.9387V57.459C38.7817 59.2203 37.4024 60.6482 35.701 60.6482H20.6827C18.9813 60.6482 17.6021 59.2203 17.6021 57.459V33.9387Z",
        fill: "#925454"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.6021 33.9387C17.6021 32.1774 18.9813 30.7495 20.6827 30.7495H35.701C37.4024 30.7495 38.7817 32.1774 38.7817 33.9387V57.459C38.7817 59.2203 37.4024 60.6482 35.701 60.6482H20.6827C18.9813 60.6482 17.6021 59.2203 17.6021 57.459V33.9387Z",
        fill: "url(#paint1_linear_841_30597)",
        fillOpacity: 0.8
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.6021 33.9387C17.6021 32.1774 18.9813 30.7495 20.6827 30.7495H35.701C37.4024 30.7495 38.7817 32.1774 38.7817 33.9387V57.459C38.7817 59.2203 37.4024 60.6482 35.701 60.6482H20.6827C18.9813 60.6482 17.6021 59.2203 17.6021 57.459V33.9387Z",
        fill: "url(#paint2_linear_841_30597)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.6021 33.9387C17.6021 32.1774 18.9813 30.7495 20.6827 30.7495H35.701C37.4024 30.7495 38.7817 32.1774 38.7817 33.9387V57.459C38.7817 59.2203 37.4024 60.6482 35.701 60.6482H20.6827C18.9813 60.6482 17.6021 59.2203 17.6021 57.459V33.9387Z",
        fill: "url(#paint3_linear_841_30597)",
        fillOpacity: 0.4
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.6021 58.1582H19.5275C21.0694 58.1582 22.3193 59.4522 22.3193 61.0484V62.1447H17.6021V58.1582Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.6021 58.1582H19.5275C21.0694 58.1582 22.3193 59.4522 22.3193 61.0484V62.1447H17.6021V58.1582Z",
        fill: "url(#paint4_linear_841_30597)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        d: "M38.8608 58.1582H36.9354C35.3935 58.1582 34.1436 59.4522 34.1436 61.0484V62.1447H38.8608V58.1582Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M38.8608 58.1582H36.9354C35.3935 58.1582 34.1436 59.4522 34.1436 61.0484V62.1447H38.8608V58.1582Z",
        fill: "url(#paint5_linear_841_30597)",
        fillOpacity: 0.2
      })]
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 20.9789,
      cy: 61.9905,
      rx: 1.39593,
      ry: 1.4451,
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 20.9404,
      cy: 61.9902,
      rx: 0.818303,
      ry: 0.847129,
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 35.0346,
      cy: 61.9905,
      rx: 1.39593,
      ry: 1.4451,
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 34.996,
      cy: 61.9902,
      rx: 0.818303,
      ry: 0.847129,
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_i_841_30597)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.3018 34.0392C20.3018 33.8741 20.4311 33.7402 20.5906 33.7402C20.7501 33.7402 20.8794 33.8741 20.8794 34.0392V57.0612C20.8794 57.2263 20.7501 57.3602 20.5906 57.3602C20.4311 57.3602 20.3018 57.2263 20.3018 57.0612V34.0392Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter1_i_841_30597)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.0869 34.0392C24.0869 33.8741 24.2162 33.7402 24.3757 33.7402C24.5352 33.7402 24.6645 33.8741 24.6645 34.0392V57.0612C24.6645 57.2263 24.5352 57.3602 24.3757 57.3602C24.2162 57.3602 24.0869 57.2263 24.0869 57.0612V34.0392Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter2_i_841_30597)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.0483 34.0392C28.0483 33.8741 28.1776 33.7402 28.3372 33.7402C28.4967 33.7402 28.626 33.8741 28.626 34.0392V57.0612C28.626 57.2263 28.4967 57.3602 28.3372 57.3602C28.1776 57.3602 28.0483 57.2263 28.0483 57.0612V34.0392Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter3_i_841_30597)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M35.7944 34.0392C35.7944 33.8741 35.9237 33.7402 36.0832 33.7402C36.2428 33.7402 36.3721 33.8741 36.3721 34.0392V57.0612C36.3721 57.2263 36.2428 57.3602 36.0832 57.3602C35.9237 57.3602 35.7944 57.2263 35.7944 57.0612V34.0392Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter4_i_841_30597)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M31.8335 34.0392C31.8335 33.8741 31.9628 33.7402 32.1223 33.7402C32.2818 33.7402 32.4111 33.8741 32.4111 34.0392V57.0612C32.4111 57.2263 32.2818 57.3602 32.1223 57.3602C31.9628 57.3602 31.8335 57.2263 31.8335 57.0612V34.0392Z",
        fill: "black",
        fillOpacity: 0.05
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.0107 21.4798C23.0107 20.6542 23.68 19.9849 24.5057 19.9849H31.4317C32.2573 19.9849 32.9267 20.6542 32.9267 21.4798H31.0253C31.0253 21.4798 29.2202 21.2805 27.9687 21.2805C26.7172 21.2805 24.9121 21.4798 24.9121 21.4798H23.0107Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.8096 21.479V21.18C24.8096 21.0149 24.9389 20.881 25.0984 20.881H30.5858C30.7453 20.881 30.8746 21.0149 30.8746 21.18V21.479C30.8746 21.479 29.3824 21.2797 27.8421 21.2797C26.3018 21.2797 24.8096 21.479 24.8096 21.479Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("rect", {
      x: 45.5244,
      y: 17.2949,
      width: 0.577626,
      height: 6.27872,
      fill: "#ADADAD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M44.9854 16.897C44.9854 16.4016 45.3733 16 45.8518 16Lnan nanL45.8518 16C46.3303 16 46.7182 16.4016 46.7182 16.897V17.8855C46.7182 17.945 46.6716 17.9932 46.6142 17.9932H45.0894C45.0319 17.9932 44.9854 17.945 44.9854 17.8855V16.897Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M45.2742 24.3706C45.1147 24.3706 44.9854 24.2367 44.9854 24.0716V23.4736C44.9854 23.3085 45.1147 23.1747 45.2742 23.1747H46.4294C46.5889 23.1747 46.7182 23.3085 46.7182 23.4736V24.0716C46.7182 24.2367 46.5889 24.3706 46.4294 24.3706H45.2742Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_841_30597",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 41,
      y: 23,
      width: 14,
      height: 38,
      children: /*#__PURE__*/_jsx("path", {
        d: "M41.5625 26.6623C41.5625 24.956 42.8987 23.5728 44.5469 23.5728H51.3821C53.0304 23.5728 54.3665 24.956 54.3665 26.6623V57.4579C54.3665 59.1642 53.0304 60.5475 51.3821 60.5475H44.5469C42.8987 60.5475 41.5625 59.1642 41.5625 57.4579V26.6623Z",
        fill: "#D9D9D9"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_841_30597)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M41.5625 23.5728H54.3665V60.5475H41.5625V23.5728Z",
        fill: "#444444"
      }), /*#__PURE__*/_jsx("path", {
        d: "M41.5625 23.5728H54.3665V60.5475H41.5625V23.5728Z",
        fill: "url(#paint6_linear_841_30597)",
        fillOpacity: 0.6
      }), /*#__PURE__*/_jsx("path", {
        d: "M41.5625 23.5728H54.3665V60.5475H41.5625V23.5728Z",
        fill: "url(#paint7_linear_841_30597)",
        fillOpacity: 0.4
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter5_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 27.6597C42.9516 27.6597 42.8223 27.5258 42.8223 27.3607C42.8223 27.1956 42.9516 27.0617 43.1111 27.0617H52.6419C52.8014 27.0617 52.9307 27.1956 52.9307 27.3607C52.9307 27.5258 52.8014 27.6597 52.6419 27.6597H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter6_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 31.6445C42.9516 31.6445 42.8223 31.5107 42.8223 31.3455C42.8223 31.1804 42.9516 31.0466 43.1111 31.0466H52.6419C52.8014 31.0466 52.9307 31.1804 52.9307 31.3455C52.9307 31.5107 52.8014 31.6445 52.6419 31.6445H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter7_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 35.6318C42.9516 35.6318 42.8223 35.498 42.8223 35.3328C42.8223 35.1677 42.9516 35.0339 43.1111 35.0339H52.6419C52.8014 35.0339 52.9307 35.1677 52.9307 35.3328C52.9307 35.498 52.8014 35.6318 52.6419 35.6318H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter8_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 39.6196C42.9516 39.6196 42.8223 39.4858 42.8223 39.3206C42.8223 39.1555 42.9516 39.0217 43.1111 39.0217H52.6419C52.8014 39.0217 52.9307 39.1555 52.9307 39.3206C52.9307 39.4858 52.8014 39.6196 52.6419 39.6196H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter9_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 43.604C42.9516 43.604 42.8223 43.4701 42.8223 43.305C42.8223 43.1399 42.9516 43.006 43.1111 43.006H52.6419C52.8014 43.006 52.9307 43.1399 52.9307 43.305C52.9307 43.4701 52.8014 43.604 52.6419 43.604H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter10_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 47.5913C42.9516 47.5913 42.8223 47.4574 42.8223 47.2923C42.8223 47.1272 42.9516 46.9933 43.1111 46.9933H52.6419C52.8014 46.9933 52.9307 47.1272 52.9307 47.2923C52.9307 47.4574 52.8014 47.5913 52.6419 47.5913H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter11_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 51.5791C42.9516 51.5791 42.8223 51.4452 42.8223 51.2801C42.8223 51.115 42.9516 50.9811 43.1111 50.9811H52.6419C52.8014 50.9811 52.9307 51.115 52.9307 51.2801C52.9307 51.4452 52.8014 51.5791 52.6419 51.5791H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M44.9844 38.222C44.9844 37.8917 45.243 37.624 45.562 37.624C45.881 37.624 46.1396 37.8917 46.1396 38.222V45.9957C46.1396 46.3259 45.881 46.5936 45.562 46.5936C45.243 46.5936 44.9844 46.3259 44.9844 45.9957V38.222Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M44.9844 38.222C44.9844 37.8917 45.243 37.624 45.562 37.624C45.881 37.624 46.1396 37.8917 46.1396 38.222V45.9957C46.1396 46.3259 45.881 46.5936 45.562 46.5936C45.243 46.5936 44.9844 46.3259 44.9844 45.9957V38.222Z",
        fill: "url(#paint8_linear_841_30597)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("g", {
        filter: "url(#filter12_i_841_30597)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M43.1111 55.5635C42.9516 55.5635 42.8223 55.4296 42.8223 55.2645C42.8223 55.0994 42.9516 54.9655 43.1111 54.9655H52.6419C52.8014 54.9655 52.9307 55.0994 52.9307 55.2645C52.9307 55.4296 52.8014 55.5635 52.6419 55.5635H43.1111Z",
          fill: "black",
          fillOpacity: 0.05
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M41.0234 58.0566H42.9489C44.4908 58.0566 45.7407 59.3506 45.7407 60.9468V62.0431H41.0234V58.0566Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M41.0234 58.0566H42.9489C44.4908 58.0566 45.7407 59.3506 45.7407 60.9468V62.0431H41.0234V58.0566Z",
        fill: "url(#paint9_linear_841_30597)",
        fillOpacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        d: "M55.0747 58.0566H53.1493C51.6074 58.0566 50.3574 59.3506 50.3574 60.9468V62.0431H55.0747V58.0566Z",
        fill: "#1E1E1E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M55.0747 58.0566H53.1493C51.6074 58.0566 50.3574 59.3506 50.3574 60.9468V62.0431H55.0747V58.0566Z",
        fill: "url(#paint10_linear_841_30597)",
        fillOpacity: 0.2
      })]
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.543 60.8957C43.543 60.703 43.6938 60.5469 43.8799 60.5469C44.066 60.5469 44.2169 60.703 44.2169 60.8957V63.0883C44.2169 63.2809 44.066 63.4371 43.8799 63.4371C43.6938 63.4371 43.543 63.2809 43.543 63.0883V60.8957Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M44.4453 60.8957C44.4453 60.703 44.5962 60.5469 44.7823 60.5469C44.9684 60.5469 45.1192 60.703 45.1192 60.8957V63.0883C45.1192 63.2809 44.9684 63.4371 44.7823 63.4371C44.5962 63.4371 44.4453 63.2809 44.4453 63.0883V60.8957Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M44.2637 61.2442C44.2637 61.1892 44.3068 61.1445 44.3599 61.1445C44.4131 61.1445 44.4562 61.1892 44.4562 61.2442V62.7391C44.4562 62.7942 44.4131 62.8388 44.3599 62.8388C44.3068 62.8388 44.2637 62.7942 44.2637 62.7391V61.2442Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M50.9268 60.8957C50.9268 60.703 51.0776 60.5469 51.2637 60.5469C51.4498 60.5469 51.6007 60.703 51.6007 60.8957V63.0883C51.6007 63.2809 51.4498 63.4371 51.2637 63.4371C51.0776 63.4371 50.9268 63.2809 50.9268 63.0883V60.8957Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M51.8291 60.8957C51.8291 60.703 51.98 60.5469 52.166 60.5469C52.3521 60.5469 52.503 60.703 52.503 60.8957V63.0883C52.503 63.2809 52.3521 63.4371 52.166 63.4371C51.98 63.4371 51.8291 63.2809 51.8291 63.0883V60.8957Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      d: "M51.6475 61.2442C51.6475 61.1892 51.6906 61.1445 51.7437 61.1445C51.7969 61.1445 51.84 61.1892 51.84 61.2442V62.7391C51.84 62.7942 51.7969 62.8388 51.7437 62.8388C51.6906 62.8388 51.6475 62.7942 51.6475 62.7391V61.2442Z",
      fill: "#D9D9D9"
    }), /*#__PURE__*/_jsx("rect", {
      x: 47.6865,
      y: 23.5737,
      width: 0.78639,
      height: 36.9074,
      fill: "#313131"
    }), /*#__PURE__*/_jsx("rect", {
      x: 47.8682,
      y: 23.5737,
      width: 0.288813,
      height: 36.9747,
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("line", {
      x1: 48.0821,
      y1: 23.606,
      x2: 48.0821,
      y2: 60.4489,
      stroke: "#616161",
      strokeWidth: 0.0645043,
      strokeLinecap: "round",
      strokeDasharray: "0.13 0.13"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47.7854 25.7732C47.6839 25.735 47.5721 25.7834 47.5307 25.8835L47.0321 27.089C46.9719 27.2344 47.0453 27.4034 47.1927 27.459C47.3402 27.5145 47.5013 27.4339 47.5455 27.2825L47.9121 26.0272C47.9425 25.923 47.8869 25.8114 47.7854 25.7732ZM47.2058 27.3648C47.3057 27.4024 47.4162 27.3491 47.4526 27.2456C47.4889 27.1422 47.4374 27.0278 47.3375 26.9902C47.2376 26.9525 47.1271 27.0058 47.0907 27.1093C47.0544 27.2127 47.1059 27.3271 47.2058 27.3648Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47.7854 26.6643C47.6839 26.6261 47.5721 26.6745 47.5307 26.7746L47.0321 27.9801C46.9719 28.1256 47.0453 28.2945 47.1927 28.3501C47.3402 28.4056 47.5013 28.325 47.5455 28.1736L47.9121 26.9183C47.9425 26.8141 47.8869 26.7026 47.7854 26.6643ZM47.2058 28.2559C47.3057 28.2935 47.4162 28.2402 47.4526 28.1368C47.4889 28.0333 47.4374 27.9189 47.3375 27.8813C47.2376 27.8436 47.1271 27.897 47.0907 28.0004C47.0544 28.1038 47.1059 28.2182 47.2058 28.2559Z",
      fill: "#1E1E1E"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter13_b_841_30597)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.0001 46.0513C15.3762 48.8676 58.2344 48.1896 58.8242 46.0513C58.8242 47.0422 58.8242 52.2975 58.8242 52.9233C58.0378 55.5832 16.1626 56.0004 14.0001 52.9233C14.0001 51.7238 13.9999 47.1465 14.0001 46.0513Z",
        fill: "white",
        fillOpacity: 0.9
      })
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter14_b_841_30597)",
      children: /*#__PURE__*/_jsx("ellipse", {
        cx: 36.3755,
        cy: 50.2115,
        rx: 13.3686,
        ry: 13.7896,
        fill: "white",
        fillOpacity: 0.9
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M31.1172 44.4743C31.1172 44.4743 34.691 45.2935 36.5441 43.1772C36.5441 45.7713 36.5441 55.6698 36.5441 57.3082C32.3746 56.2159 31.1171 52.4613 31.1172 51.0278C31.1173 49.5942 31.1172 44.4743 31.1172 44.4743Z",
      fill: "url(#paint11_linear_841_30597)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.9282 44.4743C41.9282 44.4743 38.3544 45.2935 36.5014 43.1772C36.5014 45.7713 36.5014 55.6698 36.5014 57.3082C40.6708 56.2159 41.9283 52.4613 41.9282 51.0278C41.9281 49.5942 41.9282 44.4743 41.9282 44.4743Z",
      fill: "url(#paint12_linear_841_30597)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.9282 44.4743C41.9282 44.4743 38.3544 45.2935 36.5014 43.1772C36.5014 45.7713 36.5014 55.6698 36.5014 57.3082C40.6708 56.2159 41.9283 52.4613 41.9282 51.0278C41.9281 49.5942 41.9282 44.4743 41.9282 44.4743Z",
      fill: "black",
      fillOpacity: 0.2
    }), /*#__PURE__*/_jsx("path", {
      d: "M34.4122 48.9491L33.8574 49.5117L33.8574 49.5116C33.8324 49.5369 33.8184 49.5712 33.8184 49.6071C33.8184 49.6429 33.8324 49.6772 33.8574 49.7025L35.9324 51.8069C35.9844 51.8596 36.0687 51.8596 36.1207 51.8069L39.3386 48.5436C39.3906 48.4909 39.3906 48.4054 39.3386 48.3527L38.7839 47.7901C38.759 47.7647 38.7251 47.7505 38.6898 47.7505C38.6544 47.7505 38.6206 47.7647 38.5956 47.7901L36.0266 50.3954L34.6005 48.9491C34.5484 48.8964 34.4641 48.8964 34.4122 48.9491Z",
      fill: "#95F47D"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_i_841_30597",
        x: 20.3018,
        y: 33.7402,
        width: 0.577637,
        height: 23.9426,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_i_841_30597",
        x: 24.0869,
        y: 33.7402,
        width: 0.577637,
        height: 23.9426,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter2_i_841_30597",
        x: 28.0483,
        y: 33.7402,
        width: 0.577637,
        height: 23.9426,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter3_i_841_30597",
        x: 35.7944,
        y: 33.7402,
        width: 0.577637,
        height: 23.9426,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter4_i_841_30597",
        x: 31.8335,
        y: 33.7402,
        width: 0.577637,
        height: 23.9426,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter5_i_841_30597",
        x: 42.8223,
        y: 27.0615,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter6_i_841_30597",
        x: 42.8223,
        y: 31.0464,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter7_i_841_30597",
        x: 42.8223,
        y: 35.0337,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter8_i_841_30597",
        x: 42.8223,
        y: 39.0215,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter9_i_841_30597",
        x: 42.8223,
        y: 43.0059,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter10_i_841_30597",
        x: 42.8223,
        y: 46.9932,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter11_i_841_30597",
        x: 42.8223,
        y: 50.981,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter12_i_841_30597",
        x: 42.8223,
        y: 54.9653,
        width: 10.1084,
        height: 0.920666,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: 0.322522
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: 0.322522
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "shape",
          result: "effect1_innerShadow_841_30597"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter13_b_841_30597",
        x: 11.4198,
        y: 43.4711,
        width: 49.9846,
        height: 14.1867,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          in: "BackgroundImageFix",
          stdDeviation: 1.29009
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_841_30597"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_backgroundBlur_841_30597",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter14_b_841_30597",
        x: 21.7167,
        y: 35.1318,
        width: 29.3175,
        height: 30.1593,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          in: "BackgroundImageFix",
          stdDeviation: 0.645043
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_841_30597"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_backgroundBlur_841_30597",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_30597",
        x1: 0,
        y1: 0,
        x2: 64.7822,
        y2: 40.9614,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#474747"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.872554,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_30597",
        x1: 17.7073,
        y1: 36.2201,
        x2: 38.5467,
        y2: 36.4107,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#CD4848"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.0414636,
          stopColor: "#A22626"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.957069,
          stopColor: "#992222"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#CD4848"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_30597",
        x1: 19.6732,
        y1: 31.1504,
        x2: 33.5336,
        y2: 60.4316,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.131169,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_841_30597",
        x1: 38.1534,
        y1: 31.9616,
        x2: 18.8743,
        y2: 59.7986,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.363327,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint4_linear_841_30597",
        x1: 19.9607,
        y1: 58.1582,
        x2: 19.9607,
        y2: 62.1447,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint5_linear_841_30597",
        x1: 36.5022,
        y1: 58.1582,
        x2: 36.5022,
        y2: 62.1447,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint6_linear_841_30597",
        x1: 41.3912,
        y1: 37.4358,
        x2: 54.3667,
        y2: 37.4358,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#888888"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.090846,
          stopColor: "#444444"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.935773,
          stopColor: "#444444"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#888888"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint7_linear_841_30597",
        x1: 53.7769,
        y1: 24.6601,
        x2: 41.3157,
        y2: 58.6876,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.218513,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint8_linear_841_30597",
        x1: 45.562,
        y1: 37.624,
        x2: 45.562,
        y2: 46.5936,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint9_linear_841_30597",
        x1: 43.3821,
        y1: 58.0566,
        x2: 43.3821,
        y2: 62.0431,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint10_linear_841_30597",
        x1: 52.7161,
        y1: 58.0566,
        x2: 52.7161,
        y2: 62.0431,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.184356
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint11_linear_841_30597",
        x1: 31.219,
        y1: 49.2754,
        x2: 36.2321,
        y2: 49.2766,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {}), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#181E1F"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint12_linear_841_30597",
        x1: 41.8264,
        y1: 49.2754,
        x2: 36.8133,
        y2: 49.2766,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {}), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#253033"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TravAssistShaded.tsx


function TravAssistShaded_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravAssistShaded_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravAssistShaded_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravAssistShaded_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var TravAssistShaded = function TravAssistShaded(props) {
  return /*#__PURE__*/_jsxs("svg", TravAssistShaded_objectSpread(TravAssistShaded_objectSpread({
    width: 72,
    height: 81,
    viewBox: "0 0 72 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      y: 0.449219,
      width: 72,
      height: 80,
      rx: 8,
      fill: "url(#paint0_linear_841_14840)"
    }), /*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_841_14840)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask0_841_14840",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: 12,
        y: 16,
        width: 48,
        height: 49,
        children: /*#__PURE__*/_jsx("path", {
          d: "M51.8919 16.4492H20.1081C15.6301 16.4492 12 20.0793 12 24.5573V56.3411C12 60.8191 15.6301 64.4492 20.1081 64.4492H51.8919C56.3699 64.4492 60 60.8191 60 56.3411V24.5573C60 20.0793 56.3699 16.4492 51.8919 16.4492Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask0_841_14840)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M51.8919 16.4492H20.1081C15.6301 16.4492 12 20.0793 12 24.5573V56.3411C12 60.8191 15.6301 64.4492 20.1081 64.4492H51.8919C56.3699 64.4492 60 60.8191 60 56.3411V24.5573C60 20.0793 56.3699 16.4492 51.8919 16.4492Z",
          fill: "url(#paint1_linear_841_14840)"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M36.3208 16.4492H52.2127C56.6907 16.4492 60.3208 20.0793 60.3208 24.5573V56.3411C60.3208 60.8191 56.6907 64.4492 52.2127 64.4492H36.3208V16.4492Z",
          fill: "url(#paint2_radial_841_14840)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M47.0768 41.7692V39.5261C47.0768 36.5884 45.9099 33.7707 43.8324 31.6936C41.7552 29.6162 38.9376 28.4492 35.9999 28.4492C33.0622 28.4492 30.2445 29.6162 28.1674 31.6936C26.0899 33.7709 24.923 36.5884 24.923 39.5261V41.7692C24.3491 42.1351 24.0011 42.7683 24 43.4491V45.4491C24 45.9794 24.2107 46.4882 24.5857 46.8634C24.9609 47.2384 25.4697 47.4491 26 47.4491C26 47.9794 26.2107 48.4882 26.5857 48.8634C26.9609 49.2384 27.4696 49.4491 28 49.4491H29C29.3977 49.4491 29.7795 49.291 30.0607 49.0098C30.3419 48.7285 30.4999 48.3468 30.4999 47.9491V40.9491C30.4999 40.5514 30.3419 40.1697 30.0607 39.8885C29.7794 39.6073 29.3977 39.4492 29 39.4492H28C27.4696 39.4492 26.9609 39.6599 26.5857 40.0349C26.2107 40.4101 26 40.9188 26 41.4492C25.9734 41.4492 25.95 41.4561 25.923 41.4572V39.5262C25.9232 37.6159 26.4703 35.7456 27.5 34.1367L28.3529 34.9903C28.4563 35.0954 28.6014 35.1486 28.748 35.1352C28.8947 35.1231 29.0286 35.0468 29.1141 34.9267C30.7005 32.6991 33.2652 31.3752 35.9998 31.3723C38.2428 31.3647 40.3953 32.2568 41.9752 33.8493C42.3095 34.1808 42.6142 34.5412 42.8852 34.9263C42.9703 35.0468 43.104 35.1236 43.2506 35.1363H43.293H43.2932C43.4258 35.1363 43.5531 35.0837 43.6468 34.9897L44.4997 34.1368C45.5294 35.7457 46.0765 37.616 46.0768 39.5262V41.4573C46.0509 41.4573 46.0268 41.4492 45.9997 41.4492C45.9997 40.9189 45.789 40.4102 45.414 40.035C45.0388 39.66 44.5301 39.4492 43.9998 39.4492H42.9998C42.602 39.4492 42.2203 39.6073 41.9391 39.8885C41.6579 40.1698 41.4998 40.5515 41.4998 40.9492V47.9492C41.5007 48.3405 41.6542 48.7159 41.9279 48.9954C42.2016 49.2751 42.5737 49.4365 42.9648 49.4456C42.8549 49.8746 42.6058 50.2548 42.2565 50.5269C41.9072 50.799 41.4775 50.9476 41.0348 50.9492H39.4998C39.4998 50.5514 39.3418 50.1697 39.0605 49.8885C38.7793 49.6073 38.3976 49.4492 37.9998 49.4492H36.9998C36.4639 49.4492 35.9688 49.7352 35.7008 50.1992C35.4329 50.6633 35.4329 51.2352 35.7008 51.6992C35.9688 52.1633 36.4639 52.4492 36.9998 52.4492H37.9998C38.4242 52.4479 38.8277 52.266 39.1099 51.9492H41.0349C41.7434 51.9486 42.4287 51.697 42.9695 51.2396C43.5103 50.782 43.8717 50.1477 43.9898 49.4492H43.9998C44.5302 49.4492 45.0389 49.2385 45.4141 48.8635C45.7891 48.4883 45.9998 47.9796 45.9998 47.4492C46.5301 47.4492 47.0389 47.2385 47.4141 46.8635C47.7891 46.4883 47.9998 45.9796 47.9998 45.4492V43.4493C47.9987 42.7685 47.6507 42.1352 47.0768 41.7694V41.7692ZM25.9998 46.4491C25.7346 46.4491 25.4801 46.3437 25.2926 46.1562C25.1051 45.9687 24.9998 45.7143 24.9998 45.4491V43.4491C24.9998 43.1839 25.1051 42.9295 25.2926 42.742C25.4801 42.5545 25.7346 42.4491 25.9998 42.4491V46.4491ZM46.9997 45.4491C46.9997 45.7143 46.8943 45.9687 46.7068 46.1562C46.5193 46.3437 46.2649 46.4491 45.9997 46.4491V42.4491C46.2649 42.4491 46.5193 42.5545 46.7068 42.742C46.8943 42.9295 46.9997 43.1839 46.9997 43.4491V45.4491Z",
        fill: "white"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_14840",
        x1: 0,
        y1: 0.449219,
        x2: 64.7822,
        y2: 41.4106,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#474747"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.872554,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_14840",
        x1: 36,
        y1: 16.4492,
        x2: 23.0426,
        y2: 65.639,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#027863"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#163E36"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        id: "paint2_radial_841_14840",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(55.1669 16.4492) rotate(110.807) scale(53.6954 47.7027)",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00E6BC"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#01715D",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_841_14840",
        children: /*#__PURE__*/_jsx("rect", {
          x: 12,
          y: 16.4492,
          width: 48,
          height: 48,
          rx: 24,
          fill: "white"
        })
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/PalmIcon.tsx


function PalmIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PalmIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PalmIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PalmIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PalmIcon = function PalmIcon(props) {
  return /*#__PURE__*/_jsxs("svg", PalmIcon_objectSpread(PalmIcon_objectSpread({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("mask", {
      id: "mask0_841_31489",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 31,
      height: 32,
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.9969 31.4116C24.2811 31.4116 30.9968 24.4792 30.9968 15.9277C30.9968 7.37621 24.2811 0.443848 15.9969 0.443848C7.71274 0.443848 0.99707 7.37621 0.99707 15.9277C0.99707 24.4792 7.71274 31.4116 15.9969 31.4116Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_841_31489)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.9979 31.4116C24.2821 31.4116 30.9978 24.4792 30.9978 15.9277C30.9978 7.37621 24.2821 0.443848 15.9979 0.443848C7.71372 0.443848 0.998047 7.37621 0.998047 15.9277C0.998047 24.4792 7.71372 31.4116 15.9979 31.4116Z",
        fill: "white"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.3066 21.8853V31.9407",
        stroke: "#4A4A4A",
        strokeWidth: 0.818587,
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.16504 25.8278H16.4472L11.3061 22.603L6.16504 25.8278Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7095 16.0577L11.1371 16.3766L12.0277 15.9456L12.0637 15.4023L12.4913 15.7213L13.382 15.2902L13.4179 14.7469L13.8455 15.0659L14.7361 14.6348L14.7721 14.0916L15.1997 14.4105L16.4465 13.8073C16.4465 13.8073 11.5064 11.7082 9.6123 17.1146L10.6735 16.6009L10.7095 16.0577Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.85 11.2113L10.9338 11.749L11.8589 12.0943L12.2564 11.7364L12.3403 12.274L13.2654 12.6194L13.6629 12.2614L13.7468 12.7991L14.6718 13.1445L15.0695 12.7866L15.1533 13.3241L16.4483 13.8076C16.4483 13.8076 14.3927 8.7174 9.3501 11.1578L10.4523 11.5692L10.85 11.2113Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.2319 13.7372C16.2319 13.7372 23.3683 17.8456 20.5713 32.2839L22.9199 31.505C22.9199 31.505 23.6983 18.0954 16.8938 13.5894",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.9336 19.5866L14.4544 19.5L14.7889 18.5451L14.4422 18.1347L14.9631 18.0482L15.2977 17.0931L14.9508 16.6827L15.4717 16.5962L15.8063 15.6413L15.4596 15.2309L15.9803 15.1443L16.4487 13.8076C16.4487 13.8076 11.5176 15.9294 13.8817 21.1347L14.2803 19.9969L13.9336 19.5866Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.7947 10.6935L21.7587 11.2368L20.868 11.6678L20.4404 11.349L20.4045 11.8921L19.5138 12.3233L19.0862 12.0043L19.0502 12.5476L18.1596 12.9786L17.732 12.6596L17.6961 13.2029L16.4492 13.8064C16.4492 13.8064 18.0462 8.54374 23.2835 10.4989L22.2222 11.0125L21.7947 10.6935Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.0989 7.70335L18.4456 8.11383L18.1111 9.06876L17.5903 9.1552L17.937 9.56568L17.6025 10.5206L17.0816 10.6072L17.4284 11.0175L17.0937 11.9725L16.573 12.059L16.9197 12.4695L16.4515 13.8062C16.4515 13.8062 13.9757 8.91942 19.0184 6.479L18.6198 7.61679L18.0989 7.70335Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.3613 15.5066L21.9637 15.8645L21.0386 15.5191L20.9549 14.9816L20.5572 15.3395L19.6321 14.9941L19.5483 14.4565L19.1507 14.8144L18.2257 14.469L18.1418 13.9314L17.7442 14.2894L16.4492 13.806C16.4492 13.806 21.1833 11.2504 23.5474 16.4558L22.4452 16.0443L22.3613 15.5066Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.8332 14.6856C17.8332 14.9777 17.6039 15.2144 17.3209 15.2144C17.038 15.2144 16.8086 14.9777 16.8086 14.6856C16.8086 14.3935 17.038 14.1567 17.3209 14.1567C17.6039 14.1567 17.8332 14.3935 17.8332 14.6856Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.7837 15.0467C16.7837 15.3229 16.5667 15.5469 16.2991 15.5469C16.0314 15.5469 15.8145 15.3229 15.8145 15.0467C15.8145 14.7704 16.0314 14.5464 16.2991 14.5464C16.5667 14.5464 16.7837 14.7704 16.7837 15.0467Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0713 14.4856C17.0713 14.7619 16.8543 14.9859 16.5867 14.9859C16.319 14.9859 16.1021 14.7619 16.1021 14.4856C16.1021 14.2093 16.319 13.9854 16.5867 13.9854C16.8543 13.9854 17.0713 14.2093 17.0713 14.4856Z",
        fill: "#4A4A4A"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask1_841_31489",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: 17,
        y: 29,
        width: 5,
        height: 3,
        children: /*#__PURE__*/_jsx("path", {
          d: "M17.1123 29.6724H21.1051V31.7332H17.1123V29.6724Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask1_841_31489)",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.1113 31.7332C17.1113 30.595 18.0052 29.6724 19.1077 29.6724C20.2103 29.6724 21.1041 30.595 21.1041 31.7332",
          fill: "#4A4A4A"
        })
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.1074 31.7334C19.1074 30.0901 20.3979 28.7578 21.9899 28.7578C23.5818 28.7578 24.8724 30.0901 24.8724 31.7334",
        fill: "#4A4A4A"
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CalenderIcon.tsx


function CalenderIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CalenderIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CalenderIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CalenderIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CalenderIcon = function CalenderIcon(_ref, props) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#9b9b9b" : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "16" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "16" : _ref$height;
  return /*#__PURE__*/_jsx("svg", CalenderIcon_objectSpread(CalenderIcon_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.1745 3.49118V2.35529H9.90469V3.49118H6.09517V2.35529H4.82533C4.82533 1.94366 4.82533 3.49118 4.82533 3.49118L3.55549 3.49118C2.85072 3.49118 2.29199 4.00233 2.29199 4.62707L2.28564 12.5783C2.28564 13.2031 2.85072 13.7142 3.55549 13.7142H12.4444C13.1428 13.7142 13.7142 13.2031 13.7142 12.5783V4.62707C13.7142 4.00233 13.1428 3.49118 12.4444 3.49118H11.1745ZM12.4444 12.5783H3.55549V5.76296H12.4444V12.5783ZM5.0127 6.89886H7.29841V9.18457H5.0127V6.89886Z",
      fill: color
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BlueOneWayArr.tsx


function BlueOneWayArr_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BlueOneWayArr_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BlueOneWayArr_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BlueOneWayArr_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var BlueOneWayArr = function BlueOneWayArr(props) {
  return /*#__PURE__*/_jsx("svg", BlueOneWayArr_objectSpread(BlueOneWayArr_objectSpread({
    width: 19,
    height: 9,
    viewBox: "0 0 19 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M0.167627 4.08643L3.46856 0.686272C3.69224 0.491411 4.12115 0.410971 4.37116 0.636272C4.61741 0.858172 4.61008 1.28853 4.36476 1.51131L2.04379 3.89893H18.3811C18.7229 3.89893 19 4.16757 19 4.49895C19 4.83033 18.7229 5.09897 18.3811 5.09897H2.04379L4.36476 7.48659C4.57596 7.69169 4.61499 8.13719 4.37116 8.36163C4.12738 8.58605 3.68306 8.51435 3.46856 8.31161L0.167627 4.91147C0.0546741 4.79511 -0.000370026 4.65859 1.90735e-06 4.49895C0.00577927 4.35595 0.0664959 4.19067 0.167627 4.08643Z",
      fill: "#008CFF"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/MmtInitiative.tsx


function MmtInitiative_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MmtInitiative_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MmtInitiative_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MmtInitiative_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MmtInitiative_MmtInitiative = function MmtInitiative(props) {
  return /*#__PURE__*/_jsxs("svg", MmtInitiative_objectSpread(MmtInitiative_objectSpread({
    width: 326,
    height: 28,
    viewBox: "0 0 326 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.80363 16.6053L4.8684 14.1143H1.8237L0.893665 16.6053H0L2.97196 8.72438H3.7669L6.71808 16.6053H5.80363ZM4.60342 13.3037L3.71495 10.8288C3.69416 10.7644 3.65953 10.6588 3.61103 10.5121C3.566 10.3653 3.51924 10.2132 3.47075 10.0558C3.42225 9.89828 3.38242 9.77123 3.35125 9.6746C3.31661 9.82134 3.27851 9.96807 3.23694 10.1148C3.19884 10.258 3.16074 10.3922 3.12263 10.5174C3.08453 10.6391 3.05163 10.7429 3.02391 10.8288L2.11986 13.3037H4.60342Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.3395 10.6141C11.0149 10.6141 11.5259 10.7859 11.8722 11.1295C12.2186 11.4695 12.3918 12.017 12.3918 12.7722V16.6053H11.5397V12.8313C11.5397 12.3409 11.4306 11.9741 11.2124 11.7307C10.9976 11.4874 10.6668 11.3657 10.22 11.3657C9.58959 11.3657 9.14622 11.55 8.88989 11.9186C8.63357 12.2873 8.50541 12.8223 8.50541 13.5238V16.6053H7.64292V10.7215H8.33915L8.46904 11.5697H8.5158C8.63703 11.3621 8.79117 11.1885 8.97822 11.0489C9.16527 10.9058 9.37483 10.7984 9.6069 10.7268C9.83898 10.6517 10.0832 10.6141 10.3395 10.6141Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.0628 16.6053V8.75659H17.9461V16.6053H17.0628Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.6014 10.6141C23.2769 10.6141 23.7878 10.7859 24.1342 11.1295C24.4805 11.4695 24.6537 12.017 24.6537 12.7722V16.6053H23.8016V12.8313C23.8016 12.3409 23.6925 11.9741 23.4743 11.7307C23.2596 11.4874 22.9288 11.3657 22.4819 11.3657C21.8515 11.3657 21.4081 11.55 21.1518 11.9186C20.8955 12.2873 20.7673 12.8223 20.7673 13.5238V16.6053H19.9048V10.7215H20.6011L20.731 11.5697H20.7777C20.899 11.3621 21.0531 11.1885 21.2401 11.0489C21.4272 10.9058 21.6368 10.7984 21.8688 10.7268C22.1009 10.6517 22.3451 10.6141 22.6014 10.6141Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27.2932 10.7215V16.6053H26.4307V10.7215H27.2932ZM26.8723 8.52038C27.0143 8.52038 27.1356 8.56869 27.236 8.66533C27.3399 8.75838 27.3919 8.90512 27.3919 9.10554C27.3919 9.30238 27.3399 9.44912 27.236 9.54576C27.1356 9.64239 27.0143 9.6907 26.8723 9.6907C26.7234 9.6907 26.5987 9.64239 26.4982 9.54576C26.4012 9.44912 26.3527 9.30238 26.3527 9.10554C26.3527 8.90512 26.4012 8.75838 26.4982 8.66533C26.5987 8.56869 26.7234 8.52038 26.8723 8.52038Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.9614 15.9826C31.1034 15.9826 31.2488 15.97 31.3978 15.945C31.5467 15.9199 31.668 15.8895 31.7615 15.8537V16.5462C31.661 16.5928 31.5208 16.6321 31.3406 16.6643C31.164 16.6966 30.9908 16.7127 30.8211 16.7127C30.5197 16.7127 30.2461 16.659 30.0001 16.5516C29.7542 16.4407 29.5568 16.2546 29.4078 15.9933C29.2624 15.732 29.1896 15.3705 29.1896 14.9089V11.4194H28.3791V10.9845L29.1948 10.6356L29.5377 9.35786H30.0573V10.7215H31.7251V11.4194H30.0573V14.882C30.0573 15.2507 30.1387 15.5262 30.3015 15.7088C30.4678 15.8913 30.6877 15.9826 30.9614 15.9826Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.7774 10.7215V16.6053H32.9149V10.7215H33.7774ZM33.3566 8.52038C33.4986 8.52038 33.6198 8.56869 33.7203 8.66533C33.8242 8.75838 33.8762 8.90512 33.8762 9.10554C33.8762 9.30238 33.8242 9.44912 33.7203 9.54576C33.6198 9.64239 33.4986 9.6907 33.3566 9.6907C33.2076 9.6907 33.0829 9.64239 32.9825 9.54576C32.8855 9.44912 32.837 9.30238 32.837 9.10554C32.837 8.90512 32.8855 8.75838 32.9825 8.66533C33.0829 8.56869 33.2076 8.52038 33.3566 8.52038Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M37.7366 10.6248C38.4155 10.6248 38.9195 10.7823 39.2485 11.0972C39.5776 11.4122 39.7421 11.915 39.7421 12.6058V16.6053H39.1135L38.9472 15.7356H38.9056C38.7463 15.9503 38.58 16.1311 38.4068 16.2778C38.2336 16.421 38.0327 16.5301 37.8041 16.6053C37.579 16.6769 37.3019 16.7127 36.9728 16.7127C36.6264 16.7127 36.3181 16.65 36.048 16.5248C35.7813 16.3995 35.57 16.2098 35.4141 15.9557C35.2617 15.7016 35.1855 15.3795 35.1855 14.9894C35.1855 14.4024 35.4106 13.9515 35.8609 13.6365C36.3112 13.3216 36.9971 13.1498 37.9184 13.1212L38.9004 13.0782V12.7185C38.9004 12.2103 38.7948 11.8542 38.5835 11.6502C38.3722 11.4462 38.0743 11.3442 37.6898 11.3442C37.3919 11.3442 37.1079 11.3889 36.8377 11.4784C36.5675 11.5679 36.3112 11.6735 36.0688 11.7951L35.8038 11.1187C36.0601 10.9827 36.3545 10.8664 36.687 10.7698C37.0196 10.6731 37.3694 10.6248 37.7366 10.6248ZM38.89 13.7063L38.0224 13.7439C37.3123 13.7725 36.8117 13.8924 36.5208 14.1036C36.2298 14.3147 36.0843 14.6136 36.0843 15.0001C36.0843 15.3365 36.1831 15.5853 36.3805 15.7463C36.5779 15.9074 36.8395 15.9879 37.1651 15.9879C37.6708 15.9879 38.0847 15.843 38.4068 15.5531C38.729 15.2632 38.89 14.8283 38.89 14.2485V13.7063Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.3584 15.9826C43.5004 15.9826 43.6459 15.97 43.7948 15.945C43.9437 15.9199 44.065 15.8895 44.1585 15.8537V16.5462C44.0581 16.5928 43.9178 16.6321 43.7377 16.6643C43.561 16.6966 43.3878 16.7127 43.2181 16.7127C42.9167 16.7127 42.6431 16.659 42.3972 16.5516C42.1512 16.4407 41.9538 16.2546 41.8048 15.9933C41.6594 15.732 41.5866 15.3705 41.5866 14.9089V11.4194H40.7761V10.9845L41.5918 10.6356L41.9347 9.35786H42.4543V10.7215H44.1221V11.4194H42.4543V14.882C42.4543 15.2507 42.5357 15.5262 42.6985 15.7088C42.8648 15.8913 43.0847 15.9826 43.3584 15.9826Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M46.1744 10.7215V16.6053H45.312V10.7215H46.1744ZM45.7536 8.52038C45.8956 8.52038 46.0168 8.56869 46.1173 8.66533C46.2212 8.75838 46.2732 8.90512 46.2732 9.10554C46.2732 9.30238 46.2212 9.44912 46.1173 9.54576C46.0168 9.64239 45.8956 9.6907 45.7536 9.6907C45.6047 9.6907 45.48 9.64239 45.3795 9.54576C45.2825 9.44912 45.234 9.30238 45.234 9.10554C45.234 8.90512 45.2825 8.75838 45.3795 8.66533C45.48 8.56869 45.6047 8.52038 45.7536 8.52038Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M49.2555 16.6053L47.0941 10.7215H48.0189L49.2711 14.2807C49.3577 14.5241 49.446 14.7925 49.5361 15.086C49.6261 15.3795 49.6885 15.6157 49.7231 15.7947H49.7595C49.8011 15.6157 49.8703 15.3795 49.9673 15.086C50.0643 14.789 50.1526 14.5205 50.2323 14.2807L51.4845 10.7215H52.4093L50.2427 16.6053H49.2555Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M55.5164 10.6141C56.0013 10.6141 56.417 10.725 56.7633 10.9469C57.1097 11.1688 57.3747 11.4802 57.5583 11.881C57.7419 12.2783 57.8337 12.7436 57.8337 13.2768V13.8298H53.9005C53.9109 14.5205 54.0772 15.0466 54.3993 15.4081C54.7214 15.7696 55.1752 15.9503 55.7606 15.9503C56.1208 15.9503 56.4395 15.9163 56.7166 15.8483C56.9937 15.7803 57.2812 15.6801 57.5791 15.5477V16.3315C57.2916 16.4639 57.0058 16.5606 56.7218 16.6214C56.4412 16.6822 56.1087 16.7127 55.7242 16.7127C55.1769 16.7127 54.6989 16.5981 54.2902 16.3691C53.8849 16.1364 53.5697 15.7964 53.3446 15.3491C53.1194 14.9017 53.0068 14.3541 53.0068 13.7063C53.0068 13.0728 53.109 12.5253 53.3134 12.0636C53.5212 11.5983 53.8122 11.2404 54.1863 10.9899C54.5638 10.7393 55.0072 10.6141 55.5164 10.6141ZM55.506 11.3442C55.0453 11.3442 54.6781 11.4999 54.4045 11.8113C54.1308 12.1226 53.968 12.5575 53.9161 13.1158H56.9296C56.9261 12.765 56.8725 12.4573 56.7685 12.1924C56.6681 11.924 56.514 11.7164 56.3061 11.5697C56.0983 11.4194 55.8316 11.3442 55.506 11.3442Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M62.9255 8.25195V10.3403C62.9255 10.5801 62.9186 10.8127 62.9047 11.0382C62.8943 11.2637 62.8856 11.439 62.8787 11.5643H62.9255C63.0814 11.2995 63.3065 11.0758 63.6009 10.8932C63.8954 10.7107 64.2712 10.6194 64.7284 10.6194C65.4419 10.6194 66.01 10.8753 66.4326 11.3871C66.8587 11.8954 67.0717 12.6523 67.0717 13.658C67.0717 14.3201 66.9747 14.8784 66.7807 15.333C66.5867 15.7875 66.3131 16.1311 65.9598 16.3637C65.6065 16.5963 65.1891 16.7127 64.7076 16.7127C64.2573 16.7127 63.8867 16.6268 63.5957 16.455C63.3082 16.2796 63.0865 16.0667 62.9307 15.8161H62.8631L62.6865 16.6053H62.063V8.25195H62.9255ZM64.5881 11.3657C64.1759 11.3657 63.8486 11.4498 63.6061 11.618C63.3637 11.7826 63.1887 12.0331 63.0814 12.3696C62.9774 12.7024 62.9255 13.1247 62.9255 13.6365V13.6848C62.9255 14.4257 63.045 14.993 63.284 15.3867C63.523 15.7768 63.9577 15.9718 64.5881 15.9718C65.1181 15.9718 65.5147 15.7714 65.7779 15.3705C66.0447 14.9697 66.178 14.3971 66.178 13.6526C66.178 12.8939 66.0464 12.323 65.7831 11.9401C65.5233 11.5571 65.125 11.3657 64.5881 11.3657Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M67.6796 10.7215H68.6044L69.8618 14.1358C69.9345 14.3362 70.0021 14.5295 70.0644 14.7156C70.1268 14.8981 70.1822 15.0735 70.2307 15.2417C70.2792 15.4099 70.3173 15.5728 70.345 15.7302H70.3814C70.4298 15.5513 70.4991 15.3169 70.5892 15.027C70.6792 14.7335 70.7762 14.4346 70.8801 14.1304L72.07 10.7215H73L70.5216 17.4696C70.39 17.8311 70.2359 18.146 70.0592 18.4145C69.886 18.6829 69.6747 18.8887 69.4253 19.0318C69.1759 19.1786 68.8746 19.252 68.5213 19.252C68.3585 19.252 68.2147 19.2412 68.09 19.2197C67.9653 19.2018 67.858 19.1804 67.7679 19.1553V18.4413C67.8441 18.4592 67.9359 18.4753 68.0433 18.4896C68.1541 18.5039 68.2684 18.5111 68.3862 18.5111C68.601 18.5111 68.7863 18.4682 68.9421 18.3823C69.1015 18.2999 69.2383 18.1783 69.3526 18.0172C69.4669 17.8562 69.5656 17.6647 69.6488 17.4428L69.9605 16.616L67.6796 10.7215Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("rect", {
      x: 118.26,
      y: 4.31836,
      width: 23.8612,
      height: 22.4215,
      rx: 6,
      fill: "white"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_841_15435",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 116,
      y: 0,
      width: 28,
      height: 28,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M143.609 27.5043V0H116.298V27.5043H143.609Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_841_15435)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M141.356 9.40838C140.058 11.6446 137.739 16.4524 137.739 16.4524C137.739 16.4524 136.571 19.0478 136.077 21.7C135.858 22.8795 136.282 24.2494 136.282 24.2494C136.599 25.6022 135.096 25.2306 135.096 25.2306C133.999 24.868 134.029 23.3937 134.029 23.3937C134.029 21.2176 134.992 19.1141 135.556 17.7063C133.574 18.4923 132.647 16.5543 133.211 14.5972L130.945 17.6713C130.215 18.5331 129.497 18.3643 129.497 18.3643C129.461 18.3643 128.589 18.2576 128.633 17.0877C128.654 16.5212 128.812 14.158 128.994 13.2803C129.012 13.1884 128.958 13.0971 128.885 13.2069C127.94 14.8889 126.391 16.7221 126.083 17.2303C125.684 17.8892 125.283 18.1623 125.283 18.1623C124.961 18.4233 124.402 18.226 124.402 18.226C123.829 18.0122 123.946 17.3602 123.946 17.3602L124.489 13.4219C124.489 13.3679 124.471 13.349 124.416 13.349C124.253 13.349 122.716 15.4903 121.869 16.984L121.313 17.8868C121.313 17.8868 120.834 18.6433 120.094 18.1882C119.515 17.8321 119.697 17.1666 119.697 17.1666L121.285 10.446C121.285 10.4277 121.285 10.318 121.193 10.318C120.702 10.318 120.563 11.6051 119.892 11.63C119.554 11.6425 119.38 11.4971 119.38 11.4971C118.922 11.2322 119.139 10.5452 119.139 10.5452C119.139 10.5452 119.865 8.61452 120.826 8.12926C120.826 8.12926 121.38 7.7794 121.842 7.84194C122.304 7.90448 123.043 8.01597 122.655 10.1353L122.17 12.8919C122.17 12.8919 122.122 13.1331 122.197 13.1716C122.197 13.1716 122.317 13.2914 122.558 12.9677L125.633 8.73894C126.295 7.76008 127.076 8.25385 127.076 8.25385C127.596 8.47585 127.417 9.11713 127.417 9.11713C127.417 9.11713 125.902 13.7976 125.902 14.2364C125.902 14.3827 126.03 14.4189 126.102 14.3099C126.738 13.3404 128.083 11.2371 129.211 9.82913C129.72 9.2075 130.011 8.93295 130.574 8.98796C131.12 9.0428 131.374 9.39021 131.374 9.93882C131.374 10.0303 131.356 10.14 131.338 10.2499C131.338 10.2499 130.338 13.7063 130.265 15.5531C130.265 15.5531 130.249 15.8187 130.319 15.8724C130.454 15.9759 130.621 15.7429 130.621 15.7429C131.18 15.1227 132.97 12.2772 133.374 11.5298L134.669 8.8799C134.669 8.8799 135.218 7.6743 135.952 7.86175C135.952 7.86175 137.12 7.98028 136.556 9.25858C136.463 9.46781 135.574 10.9211 134.81 13.9211C134.683 14.3777 134.519 15.7131 135.337 15.7131C135.701 15.7131 136.174 15.4199 136.665 14.5237L139.882 8.70866C140.155 8.4156 140.371 8.25385 140.752 8.25385C141.944 8.25385 141.356 9.40838 141.356 9.40838ZM143.608 6.22712C143.608 2.79251 140.855 0 137.462 0H122.446C119.051 0 116.299 2.79251 116.299 6.22712L116.302 21.2736C116.302 24.7073 119.054 27.5043 122.448 27.5043H137.464C140.858 27.5043 143.609 24.7081 143.609 21.2736L143.608 6.22712Z",
        fill: "#EB2226"
      })
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_841_15435",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 81,
      y: 10,
      width: 11,
      height: 8,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M81 17.1994H91.3158V10.1914H81V17.1994Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask1_841_15435)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M87.0093 17.1994H85.3067V13.3443C85.3067 12.795 85.2198 12.3847 85.0468 12.1143C84.8736 11.8438 84.581 11.7082 84.1678 11.7082C83.867 11.7082 83.5916 11.7829 83.3416 11.9325C83.0908 12.0827 82.8782 12.2957 82.7028 12.5718V17.1994H81V10.1981H81.9697L82.6098 11.1398C82.7474 11.0139 82.956 10.8553 83.125 10.7454C83.2941 10.6356 83.4725 10.539 83.6604 10.4568C83.8479 10.3748 84.0455 10.3106 84.2521 10.2626C84.4586 10.215 84.6705 10.1914 84.8876 10.1914C85.1375 10.1914 85.358 10.2179 85.5473 10.272C85.7375 10.3252 85.9053 10.4033 86.0513 10.5066C86.1973 10.6092 86.3251 10.7328 86.4335 10.8777C86.5421 11.0234 86.6376 11.1875 86.7211 11.3707C86.8547 11.2364 87.0059 11.0994 87.1752 10.9584C87.3441 10.8176 87.531 10.6906 87.7356 10.5766C87.9401 10.4628 88.1631 10.3702 88.4051 10.2986C88.6475 10.2271 88.9099 10.1914 89.1942 10.1914C89.5776 10.1914 89.9038 10.2702 90.1737 10.4272C90.4429 10.5847 90.6618 10.8024 90.831 11.0809C91 11.3594 91.1224 11.6909 91.1999 12.075C91.277 12.4594 91.3159 12.8783 91.3159 13.3315V17.1994H89.6131V13.3443C89.6131 12.795 89.5277 12.3847 89.3565 12.1143C89.1856 11.8438 88.8993 11.7082 88.4994 11.7082C88.1988 11.7082 87.9231 11.7786 87.6724 11.9191C87.4222 12.0597 87.2014 12.2767 87.0093 12.5718V17.1994Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M96.9324 14.017H95.4049C94.9962 14.017 94.6976 14.114 94.5094 14.2719C94.3219 14.4293 94.228 14.6496 94.228 14.9314C94.228 15.2004 94.3074 15.4076 94.4661 15.5535C94.6246 15.6986 94.8667 15.7722 95.1917 15.7722C95.3883 15.7722 95.5747 15.7457 95.7524 15.6933C95.93 15.6403 96.0935 15.5699 96.2438 15.4803C96.3937 15.3908 96.5271 15.285 96.6443 15.1611C96.7607 15.0376 96.8569 14.9072 96.9324 14.7701V14.017ZM96.9317 16.4287C96.735 16.644 96.4264 16.845 96.0777 16.9901C95.7291 17.1341 95.3128 17.207 94.8291 17.207C94.491 17.207 94.1863 17.1526 93.9145 17.0433C93.6434 16.9349 93.4114 16.782 93.2173 16.5849C93.0233 16.3877 92.8739 16.1554 92.7692 15.8864C92.6652 15.6171 92.6133 15.3234 92.6133 15.0038C92.6133 13.6994 93.6159 12.8703 95.2224 12.8703H96.919V12.4833C96.919 12.2442 96.7994 12.0561 96.5593 11.9199C96.3198 11.7837 95.9514 11.7148 95.4547 11.7148C94.9915 11.7148 94.5626 11.7639 94.1686 11.8616C93.7746 11.9587 93.556 12.0411 93.2179 12.1812L93.0075 10.7199C93.1323 10.6645 93.285 10.6063 93.4645 10.5447C93.6434 10.483 93.8444 10.4262 94.0652 10.373C94.2864 10.3209 94.5263 10.2769 94.7851 10.2428C95.0434 10.2081 95.3152 10.1914 95.5987 10.1914C96.5836 10.1914 97.3232 10.4337 97.8179 10.9195C98.3119 11.4042 98.5593 12.094 98.5593 12.988V17.1994H97.3461L96.9317 16.4287Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M106.612 10.094L103.836 13.5964L106.994 17.1997H104.853L101.933 13.6447V17.1997H100.231V7.58984H101.933V13.6447L104.534 10.094H106.612Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M110.399 11.7015C110.174 11.7015 109.969 11.7294 109.785 11.7857C109.602 11.8418 109.441 11.922 109.303 12.0247C109.166 12.128 109.053 12.2524 108.965 12.3983C108.878 12.5453 108.817 12.7062 108.784 12.8822H111.807C111.807 12.7246 111.779 12.5738 111.722 12.4296C111.666 12.285 111.58 12.1596 111.463 12.0532C111.346 11.9458 111.199 11.8607 111.022 11.797C110.844 11.7334 110.637 11.7015 110.399 11.7015ZM110.718 15.6969C111.018 15.6969 111.291 15.6723 111.535 15.6247C111.779 15.577 112.001 15.5135 112.201 15.4359C112.402 15.3578 112.583 15.2671 112.746 15.1648C112.908 15.0616 112.852 15.1106 112.985 15.0047L113.314 16.5174C113.013 16.7101 112.588 16.8807 112.16 17.0107C111.733 17.1412 111.246 17.207 110.699 17.207C110.102 17.207 109.574 17.1227 109.116 16.9552C108.656 16.7872 108.269 16.5518 107.954 16.2471C107.639 15.9424 107.4 15.577 107.237 15.1489C107.075 14.7208 106.993 14.2463 106.993 13.7259C106.993 13.2449 107.068 12.7902 107.215 12.3621C107.364 11.9338 107.581 11.5593 107.866 11.2371C108.152 10.9147 108.506 10.6601 108.927 10.4725C109.349 10.2854 109.835 10.1914 110.386 10.1914C110.941 10.1914 111.42 10.2805 111.823 10.4584C112.225 10.6366 112.557 10.8736 112.817 11.1694C113.079 11.4661 113.271 11.8061 113.397 12.1904C113.522 12.5745 113.568 12.9728 113.568 13.3852C113.568 13.4963 113.562 13.6242 113.549 13.7676C113.537 13.9112 113.52 14.033 113.499 14.1317H108.753C108.777 14.3739 108.84 14.5916 108.94 14.7835C109.04 14.976 109.175 15.1396 109.344 15.2745C109.513 15.4094 109.713 15.5135 109.944 15.5867C110.176 15.6604 110.434 15.6969 110.718 15.6969Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M145.282 11.1914L147.582 8.4375H148.087V10.1981H150.052V11.7223H148.087V14.5916C148.087 14.791 148.111 14.9575 148.159 15.0908C148.206 15.2231 148.273 15.3288 148.356 15.409C148.439 15.4884 148.535 15.5444 148.643 15.5783C148.752 15.6114 148.867 15.6278 148.988 15.6278C149.213 15.6278 149.413 15.6061 149.585 15.5624C149.759 15.5192 149.913 15.4642 150.046 15.3989V16.9247C149.862 17.0169 149.669 17.0866 149.467 17.1346C149.265 17.1832 149.017 17.207 148.725 17.207C148.312 17.207 147.957 17.158 147.661 17.0593C147.365 16.9606 147.123 16.8185 146.936 16.6307C146.747 16.4424 146.608 16.214 146.519 15.946C146.429 15.678 146.384 15.3742 146.384 15.0343V11.7223H145.282V11.1914Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M152.956 11.6408C153.185 11.2212 153.596 10.8171 153.936 10.5666C154.276 10.3165 154.685 10.1914 155.16 10.1914C155.322 10.1914 155.456 10.1996 155.558 10.2158C155.66 10.232 155.738 10.2477 155.792 10.2616C155.792 10.2616 155.738 10.6577 155.479 11.867C155.374 11.8438 155.25 11.832 155.103 11.832C154.782 11.832 154.496 11.8875 154.243 11.9993C153.99 12.1111 153.776 12.2722 153.602 12.4816C153.427 12.6915 153.292 12.9492 153.198 13.2527C153.103 13.5566 153.057 13.9006 153.057 14.2843V17.1994H151.354V10.198H152.445L152.956 11.6408Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask2_841_15435",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 160,
      y: 10,
      width: 7,
      height: 11,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M166.924 20.0281V10.1914L160.215 10.1914V20.0281H166.924Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask2_841_15435)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M163.532 11.7224C163.316 11.7224 163.119 11.7547 162.944 11.8195C162.769 11.8838 162.615 11.9678 162.481 12.0716C162.347 12.1743 162.233 12.2923 162.137 12.4238C162.041 12.5547 161.963 12.6896 161.906 12.8275V14.8157C161.972 14.9357 162.059 15.0494 162.164 15.157C162.271 15.2641 162.391 15.3584 162.525 15.4401C162.658 15.5216 162.807 15.5868 162.972 15.6367C163.137 15.6856 163.313 15.7102 163.501 15.7102C163.789 15.7102 164.039 15.6631 164.249 15.5683C164.46 15.4745 164.635 15.3422 164.775 15.1729C164.915 15.0026 165.019 14.799 165.085 14.5604C165.152 14.3224 165.185 14.0591 165.185 13.7711C165.185 13.4707 165.145 13.1947 165.066 12.9432C164.987 12.6918 164.875 12.4762 164.728 12.2957C164.581 12.1155 164.408 11.9744 164.205 11.8738C164.002 11.7727 163.779 11.7224 163.532 11.7224ZM165.3 10.4853C165.67 10.6819 165.975 10.9447 166.217 11.2736C166.459 11.6025 166.638 11.9816 166.752 12.4125C166.867 12.842 166.924 13.2892 166.924 13.7519C166.924 14.2244 166.864 14.6684 166.743 15.0859C166.622 15.503 166.44 15.8689 166.195 16.1846C165.951 16.4994 165.648 16.7489 165.284 16.9323C164.922 17.1158 164.496 17.207 164.007 17.207C163.532 17.207 163.13 17.1374 162.803 16.9971C162.475 16.8583 162.188 16.6533 161.942 16.383L161.917 16.3976V20.0281H160.215V10.1981H161.233L161.883 11.0509C162.13 10.7973 162.481 10.5509 162.821 10.4072C163.162 10.2633 163.546 10.1914 163.976 10.1914C164.49 10.1914 164.931 10.2901 165.3 10.4853Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M157.546 7.31641C157.056 7.31641 156.66 7.71587 156.66 8.20882C156.66 8.70194 157.056 9.10173 157.546 9.10173C158.036 9.10173 158.434 8.70194 158.434 8.20882C158.434 7.71587 158.036 7.31641 157.546 7.31641ZM156.695 17.1996H158.398V10.1982H156.695V17.1996Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M177.511 15.9863C177.654 15.9863 177.799 15.9738 177.949 15.9487C178.098 15.9237 178.219 15.8932 178.313 15.8574V16.5503C178.213 16.5968 178.072 16.6362 177.891 16.6685C177.714 16.7007 177.541 16.7168 177.371 16.7168C177.069 16.7168 176.795 16.6631 176.548 16.5557C176.302 16.4447 176.104 16.2585 175.955 15.9971C175.809 15.7357 175.736 15.374 175.736 14.9121V11.4209H174.924V10.9858L175.741 10.6367L176.085 9.3584H176.605V10.7227H178.277V11.4209H176.605V14.8853C176.605 15.2541 176.687 15.5298 176.85 15.7124C177.017 15.895 177.237 15.9863 177.511 15.9863Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M184.389 13.6553C184.389 14.1387 184.328 14.5701 184.207 14.9497C184.085 15.3293 183.91 15.6497 183.681 15.9111C183.452 16.1725 183.174 16.373 182.848 16.5127C182.525 16.6488 182.159 16.7168 181.749 16.7168C181.368 16.7168 181.017 16.6488 180.698 16.5127C180.382 16.373 180.108 16.1725 179.875 15.9111C179.646 15.6497 179.467 15.3293 179.339 14.9497C179.214 14.5701 179.151 14.1387 179.151 13.6553C179.151 13.0107 179.257 12.4629 179.469 12.0117C179.681 11.557 179.983 11.2114 180.375 10.9751C180.771 10.7352 181.241 10.6152 181.786 10.6152C182.306 10.6152 182.761 10.7352 183.15 10.9751C183.542 11.215 183.846 11.5623 184.061 12.0171C184.28 12.4683 184.389 13.0143 184.389 13.6553ZM180.047 13.6553C180.047 14.1279 180.108 14.5379 180.229 14.8853C180.351 15.2326 180.538 15.5011 180.791 15.6909C181.045 15.8807 181.371 15.9756 181.77 15.9756C182.166 15.9756 182.49 15.8807 182.744 15.6909C183.001 15.5011 183.19 15.2326 183.311 14.8853C183.433 14.5379 183.493 14.1279 183.493 13.6553C183.493 13.1862 183.433 12.7816 183.311 12.4414C183.19 12.0977 183.002 11.8327 182.749 11.6465C182.496 11.4603 182.168 11.3672 181.765 11.3672C181.171 11.3672 180.736 11.5695 180.458 11.9741C180.184 12.3787 180.047 12.9391 180.047 13.6553Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M190.527 16.5986L189.512 13.1719C189.467 13.0251 189.424 12.8818 189.382 12.7422C189.344 12.599 189.307 12.4629 189.273 12.334C189.241 12.2015 189.212 12.0798 189.184 11.9688C189.16 11.8542 189.139 11.7557 189.122 11.6733H189.085C189.071 11.7557 189.052 11.8542 189.028 11.9688C189.004 12.0798 188.974 12.2015 188.939 12.334C188.908 12.4665 188.873 12.6061 188.835 12.7529C188.797 12.8962 188.754 13.0412 188.705 13.188L187.643 16.5986H186.669L185.097 10.7119H185.993L186.815 13.9614C186.871 14.1763 186.923 14.3893 186.971 14.6006C187.023 14.8083 187.067 15.0052 187.101 15.1914C187.14 15.374 187.167 15.5334 187.185 15.6694H187.226C187.247 15.5799 187.27 15.4725 187.294 15.3472C187.322 15.2218 187.351 15.0894 187.383 14.9497C187.417 14.8065 187.454 14.665 187.492 14.5254C187.53 14.3822 187.568 14.2479 187.607 14.1226L188.658 10.7119H189.59L190.605 14.1172C190.657 14.2891 190.708 14.4681 190.756 14.6543C190.808 14.8405 190.855 15.0213 190.897 15.1968C190.939 15.3687 190.968 15.5226 190.985 15.6587H191.027C191.041 15.5369 191.067 15.3866 191.105 15.2075C191.143 15.0285 191.187 14.8315 191.235 14.6167C191.287 14.4019 191.341 14.1834 191.397 13.9614L192.23 10.7119H193.11L191.532 16.5986H190.527Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M196.286 10.626C196.966 10.626 197.471 10.7835 197.801 11.0986C198.13 11.4137 198.295 11.9168 198.295 12.6079V16.6094H197.665L197.499 15.7393H197.457C197.297 15.9541 197.131 16.1349 196.957 16.2817C196.784 16.425 196.582 16.5342 196.353 16.6094C196.128 16.681 195.85 16.7168 195.52 16.7168C195.173 16.7168 194.864 16.6541 194.593 16.5288C194.326 16.4035 194.114 16.2137 193.958 15.9595C193.806 15.7052 193.729 15.383 193.729 14.9927C193.729 14.4054 193.955 13.9543 194.406 13.6392C194.857 13.3241 195.544 13.1522 196.468 13.1235L197.452 13.0806V12.7207C197.452 12.2122 197.346 11.856 197.134 11.6519C196.922 11.4478 196.624 11.3457 196.239 11.3457C195.94 11.3457 195.656 11.3905 195.385 11.48C195.114 11.5695 194.857 11.6751 194.614 11.7969L194.349 11.1201C194.606 10.984 194.901 10.8677 195.234 10.771C195.567 10.6743 195.918 10.626 196.286 10.626ZM197.441 13.709L196.572 13.7466C195.86 13.7752 195.359 13.8952 195.067 14.1064C194.776 14.3177 194.63 14.6167 194.63 15.0034C194.63 15.34 194.729 15.5889 194.927 15.75C195.124 15.9111 195.387 15.9917 195.713 15.9917C196.22 15.9917 196.634 15.8467 196.957 15.5566C197.28 15.2666 197.441 14.8315 197.441 14.2515V13.709Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M202.669 10.6152C202.783 10.6152 202.903 10.6224 203.028 10.6367C203.153 10.6475 203.264 10.6636 203.361 10.6851L203.252 11.5122C203.158 11.4871 203.054 11.4674 202.939 11.4531C202.825 11.4388 202.717 11.4316 202.616 11.4316C202.387 11.4316 202.17 11.48 201.966 11.5767C201.764 11.6698 201.587 11.8058 201.435 11.9849C201.282 12.1603 201.162 12.3734 201.075 12.624C200.989 12.8711 200.945 13.1468 200.945 13.4512V16.6094H200.076V10.7227H200.794L200.888 11.8076H200.924C201.042 11.5892 201.185 11.3905 201.351 11.2114C201.518 11.0288 201.711 10.8838 201.929 10.7764C202.151 10.6689 202.398 10.6152 202.669 10.6152Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M206.469 16.7168C205.747 16.7168 205.175 16.4626 204.751 15.9541C204.331 15.4456 204.121 14.6901 204.121 13.6875C204.121 12.6742 204.336 11.9097 204.767 11.394C205.197 10.8748 205.77 10.6152 206.485 10.6152C206.787 10.6152 207.051 10.6564 207.276 10.7388C207.502 10.8211 207.696 10.9321 207.859 11.0718C208.022 11.2078 208.159 11.3636 208.271 11.5391H208.333C208.319 11.4281 208.305 11.2759 208.291 11.0825C208.277 10.8892 208.271 10.7316 208.271 10.6099V8.25195H209.135V16.6094H208.437L208.307 15.7715H208.271C208.163 15.9469 208.026 16.1063 207.859 16.2495C207.696 16.3927 207.5 16.5073 207.271 16.5933C207.045 16.6756 206.778 16.7168 206.469 16.7168ZM206.605 15.9756C207.215 15.9756 207.648 15.7965 207.901 15.4385C208.154 15.0804 208.281 14.5487 208.281 13.8433V13.6821C208.281 12.9338 208.159 12.359 207.917 11.958C207.677 11.557 207.24 11.3564 206.605 11.3564C206.073 11.3564 205.676 11.5677 205.412 11.9902C205.148 12.4092 205.017 12.9821 205.017 13.709C205.017 14.4323 205.147 14.9909 205.407 15.3848C205.671 15.7786 206.07 15.9756 206.605 15.9756Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M214.659 14.998C214.659 15.374 214.567 15.6909 214.383 15.9487C214.202 16.203 213.942 16.3945 213.602 16.5234C213.265 16.6523 212.863 16.7168 212.394 16.7168C211.995 16.7168 211.649 16.6846 211.358 16.6201C211.066 16.5557 210.811 16.4644 210.593 16.3462V15.5244C210.825 15.6426 211.103 15.75 211.426 15.8467C211.748 15.9434 212.078 15.9917 212.415 15.9917C212.908 15.9917 213.265 15.9093 213.487 15.7446C213.709 15.5799 213.821 15.3561 213.821 15.0732C213.821 14.9121 213.775 14.7707 213.685 14.6489C213.598 14.5236 213.451 14.4036 213.243 14.2891C213.034 14.1709 212.746 14.042 212.378 13.9023C212.014 13.7591 211.698 13.6177 211.431 13.478C211.167 13.3348 210.962 13.1611 210.816 12.957C210.674 12.7529 210.603 12.488 210.603 12.1621C210.603 11.6644 210.797 11.283 211.186 11.0181C211.578 10.7495 212.092 10.6152 212.727 10.6152C213.071 10.6152 213.392 10.651 213.69 10.7227C213.992 10.7907 214.273 10.8838 214.534 11.002L214.242 11.7163C214.006 11.6125 213.755 11.5247 213.487 11.4531C213.22 11.3815 212.948 11.3457 212.67 11.3457C212.271 11.3457 211.964 11.4137 211.748 11.5498C211.537 11.6859 211.431 11.8721 211.431 12.1084C211.431 12.291 211.479 12.4414 211.577 12.5596C211.677 12.6777 211.837 12.7887 212.056 12.8926C212.274 12.9964 212.562 13.1182 212.92 13.2578C213.277 13.3939 213.586 13.5353 213.847 13.6821C214.107 13.8254 214.306 14.0008 214.445 14.2085C214.588 14.4126 214.659 14.6758 214.659 14.998Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M222.51 14.998C222.51 15.374 222.418 15.6909 222.234 15.9487C222.054 16.203 221.793 16.3945 221.453 16.5234C221.116 16.6523 220.714 16.7168 220.245 16.7168C219.846 16.7168 219.501 16.6846 219.209 16.6201C218.918 16.5557 218.662 16.4644 218.444 16.3462V15.5244C218.676 15.6426 218.954 15.75 219.277 15.8467C219.6 15.9434 219.929 15.9917 220.266 15.9917C220.759 15.9917 221.116 15.9093 221.339 15.7446C221.561 15.5799 221.672 15.3561 221.672 15.0732C221.672 14.9121 221.627 14.7707 221.536 14.6489C221.45 14.5236 221.302 14.4036 221.094 14.2891C220.886 14.1709 220.597 14.042 220.23 13.9023C219.865 13.7591 219.549 13.6177 219.282 13.478C219.018 13.3348 218.813 13.1611 218.668 12.957C218.525 12.7529 218.454 12.488 218.454 12.1621C218.454 11.6644 218.649 11.283 219.037 11.0181C219.43 10.7495 219.943 10.6152 220.578 10.6152C220.922 10.6152 221.243 10.651 221.542 10.7227C221.844 10.7907 222.125 10.8838 222.385 11.002L222.093 11.7163C221.857 11.6125 221.606 11.5247 221.339 11.4531C221.071 11.3815 220.799 11.3457 220.521 11.3457C220.122 11.3457 219.815 11.4137 219.6 11.5498C219.388 11.6859 219.282 11.8721 219.282 12.1084C219.282 12.291 219.331 12.4414 219.428 12.5596C219.528 12.6777 219.688 12.7887 219.907 12.8926C220.125 12.9964 220.414 13.1182 220.771 13.2578C221.129 13.3939 221.437 13.5353 221.698 13.6821C221.958 13.8254 222.158 14.0008 222.296 14.2085C222.439 14.4126 222.51 14.6758 222.51 14.998Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M228.82 13.6553C228.82 14.1387 228.759 14.5701 228.638 14.9497C228.516 15.3293 228.341 15.6497 228.112 15.9111C227.883 16.1725 227.605 16.373 227.279 16.5127C226.956 16.6488 226.59 16.7168 226.18 16.7168C225.799 16.7168 225.448 16.6488 225.129 16.5127C224.813 16.373 224.539 16.1725 224.306 15.9111C224.077 15.6497 223.898 15.3293 223.77 14.9497C223.645 14.5701 223.582 14.1387 223.582 13.6553C223.582 13.0107 223.688 12.4629 223.9 12.0117C224.112 11.557 224.414 11.2114 224.806 10.9751C225.202 10.7352 225.672 10.6152 226.217 10.6152C226.738 10.6152 227.192 10.7352 227.581 10.9751C227.973 11.215 228.277 11.5623 228.492 12.0171C228.711 12.4683 228.82 13.0143 228.82 13.6553ZM224.478 13.6553C224.478 14.1279 224.539 14.5379 224.66 14.8853C224.782 15.2326 224.969 15.5011 225.222 15.6909C225.476 15.8807 225.802 15.9756 226.201 15.9756C226.597 15.9756 226.921 15.8807 227.175 15.6909C227.432 15.5011 227.621 15.2326 227.742 14.8853C227.864 14.5379 227.925 14.1279 227.925 13.6553C227.925 13.1862 227.864 12.7816 227.742 12.4414C227.621 12.0977 227.433 11.8327 227.18 11.6465C226.927 11.4603 226.599 11.3672 226.196 11.3672C225.603 11.3672 225.167 11.5695 224.889 11.9741C224.615 12.3787 224.478 12.9391 224.478 13.6553Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M231.184 16.6094H230.314V8.25195H231.184V16.6094Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M234.266 16.6094L232.1 10.7227H233.027L234.282 14.2837C234.368 14.5272 234.457 14.7957 234.547 15.0894C234.637 15.383 234.7 15.6193 234.734 15.7983H234.771C234.813 15.6193 234.882 15.383 234.979 15.0894C235.076 14.7922 235.165 14.5236 235.245 14.2837L236.499 10.7227H237.426L235.255 16.6094H234.266Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M239.207 10.7227V16.6094H238.342V10.7227H239.207ZM238.785 8.52051C238.927 8.52051 239.049 8.56885 239.149 8.66553C239.254 8.75863 239.306 8.90544 239.306 9.10596C239.306 9.3029 239.254 9.44971 239.149 9.54639C239.049 9.64307 238.927 9.69141 238.785 9.69141C238.636 9.69141 238.511 9.64307 238.41 9.54639C238.313 9.44971 238.264 9.3029 238.264 9.10596C238.264 8.90544 238.313 8.75863 238.41 8.66553C238.511 8.56885 238.636 8.52051 238.785 8.52051Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M243.741 10.6152C244.418 10.6152 244.93 10.7871 245.277 11.1309C245.624 11.471 245.798 12.0189 245.798 12.7744V16.6094H244.944V12.8335C244.944 12.3429 244.835 11.9759 244.616 11.7324C244.401 11.4889 244.069 11.3672 243.622 11.3672C242.99 11.3672 242.546 11.5516 242.289 11.9204C242.032 12.2892 241.904 12.8245 241.904 13.5264V16.6094H241.039V10.7227H241.737L241.867 11.5713H241.914C242.036 11.3636 242.19 11.1899 242.377 11.0503C242.565 10.9071 242.775 10.7996 243.007 10.728C243.24 10.6528 243.485 10.6152 243.741 10.6152Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M249.172 19.252C248.422 19.252 247.844 19.1069 247.438 18.8169C247.032 18.5304 246.829 18.1276 246.829 17.6084C246.829 17.2396 246.942 16.9245 247.167 16.6631C247.396 16.4017 247.712 16.228 248.115 16.1421C247.966 16.0705 247.837 15.9631 247.73 15.8198C247.625 15.6766 247.573 15.5119 247.573 15.3257C247.573 15.1108 247.631 14.9229 247.745 14.7617C247.863 14.597 248.042 14.4395 248.281 14.2891C247.983 14.1637 247.74 13.9525 247.553 13.6553C247.369 13.3545 247.277 13.0054 247.277 12.6079C247.277 12.1854 247.362 11.8255 247.532 11.5283C247.702 11.2275 247.948 10.9984 248.271 10.8408C248.594 10.6833 248.984 10.6045 249.442 10.6045C249.543 10.6045 249.644 10.6099 249.744 10.6206C249.849 10.6278 249.947 10.6403 250.041 10.6582C250.135 10.6725 250.216 10.6904 250.286 10.7119H252.243V11.2866L251.192 11.4209C251.296 11.5605 251.383 11.7288 251.452 11.9258C251.522 12.1227 251.556 12.3411 251.556 12.5811C251.556 13.1683 251.364 13.6356 250.978 13.9829C250.593 14.3267 250.064 14.4985 249.39 14.4985C249.231 14.4985 249.068 14.4842 248.901 14.4556C248.731 14.5522 248.601 14.6597 248.51 14.7778C248.424 14.896 248.38 15.0321 248.38 15.186C248.38 15.3006 248.413 15.3919 248.479 15.46C248.549 15.528 248.648 15.5781 248.776 15.6104C248.904 15.639 249.059 15.6533 249.239 15.6533H250.244C250.866 15.6533 251.341 15.7876 251.671 16.0562C252.004 16.3247 252.171 16.7168 252.171 17.2324C252.171 17.8841 251.914 18.3836 251.4 18.731C250.886 19.0783 250.144 19.252 249.172 19.252ZM249.198 18.5537C249.67 18.5537 250.06 18.5036 250.369 18.4033C250.682 18.3066 250.914 18.1652 251.067 17.979C251.223 17.7964 251.301 17.578 251.301 17.3237C251.301 17.0874 251.249 16.9084 251.145 16.7866C251.041 16.6685 250.888 16.5897 250.687 16.5503C250.485 16.5073 250.239 16.4858 249.947 16.4858H248.958C248.701 16.4858 248.478 16.527 248.287 16.6094C248.096 16.6917 247.948 16.8135 247.844 16.9746C247.743 17.1357 247.693 17.3363 247.693 17.5762C247.693 17.8949 247.823 18.1366 248.084 18.3013C248.344 18.4696 248.715 18.5537 249.198 18.5537ZM249.422 13.8486C249.835 13.8486 250.145 13.7412 250.354 13.5264C250.562 13.3115 250.666 12.9982 250.666 12.5864C250.666 12.146 250.56 11.8166 250.348 11.5981C250.137 11.3761 249.824 11.2651 249.411 11.2651C249.016 11.2651 248.71 11.3797 248.495 11.6089C248.283 11.8345 248.177 12.1657 248.177 12.6025C248.177 13.0036 248.285 13.3115 248.5 13.5264C248.715 13.7412 249.022 13.8486 249.422 13.8486Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M258.606 16.6094H257.715V9.5625H255.32V8.75684H260.99V9.5625H258.606V16.6094Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M264.603 10.6152C264.718 10.6152 264.838 10.6224 264.963 10.6367C265.088 10.6475 265.199 10.6636 265.296 10.6851L265.186 11.5122C265.093 11.4871 264.989 11.4674 264.874 11.4531C264.76 11.4388 264.652 11.4316 264.551 11.4316C264.322 11.4316 264.105 11.48 263.9 11.5767C263.699 11.6698 263.522 11.8058 263.369 11.9849C263.217 12.1603 263.097 12.3734 263.01 12.624C262.923 12.8711 262.88 13.1468 262.88 13.4512V16.6094H262.011V10.7227H262.729L262.823 11.8076H262.859C262.977 11.5892 263.12 11.3905 263.286 11.2114C263.453 11.0288 263.645 10.8838 263.864 10.7764C264.086 10.6689 264.333 10.6152 264.603 10.6152Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M268.508 10.626C269.188 10.626 269.693 10.7835 270.023 11.0986C270.353 11.4137 270.518 11.9168 270.518 12.6079V16.6094H269.888L269.721 15.7393H269.68C269.52 15.9541 269.353 16.1349 269.18 16.2817C269.006 16.425 268.805 16.5342 268.576 16.6094C268.35 16.681 268.073 16.7168 267.743 16.7168C267.396 16.7168 267.087 16.6541 266.816 16.5288C266.549 16.4035 266.337 16.2137 266.181 15.9595C266.028 15.7052 265.952 15.383 265.952 14.9927C265.952 14.4054 266.177 13.9543 266.629 13.6392C267.08 13.3241 267.767 13.1522 268.69 13.1235L269.674 13.0806V12.7207C269.674 12.2122 269.568 11.856 269.357 11.6519C269.145 11.4478 268.847 11.3457 268.461 11.3457C268.163 11.3457 267.878 11.3905 267.607 11.48C267.337 11.5695 267.08 11.6751 266.837 11.7969L266.571 11.1201C266.828 10.984 267.123 10.8677 267.456 10.771C267.79 10.6743 268.14 10.626 268.508 10.626ZM269.664 13.709L268.794 13.7466C268.083 13.7752 267.581 13.8952 267.29 14.1064C266.998 14.3177 266.852 14.6167 266.852 15.0034C266.852 15.34 266.951 15.5889 267.149 15.75C267.347 15.9111 267.609 15.9917 267.935 15.9917C268.442 15.9917 268.857 15.8467 269.18 15.5566C269.503 15.2666 269.664 14.8315 269.664 14.2515V13.709Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M273.553 16.6094L271.387 10.7227H272.314L273.569 14.2837C273.655 14.5272 273.744 14.7957 273.834 15.0894C273.924 15.383 273.987 15.6193 274.022 15.7983H274.058C274.1 15.6193 274.169 15.383 274.266 15.0894C274.364 14.7922 274.452 14.5236 274.532 14.2837L275.787 10.7227H276.713L274.542 16.6094H273.553Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M279.827 10.6152C280.313 10.6152 280.729 10.7262 281.076 10.9482C281.423 11.1702 281.689 11.4818 281.873 11.8828C282.057 12.2803 282.149 12.7458 282.149 13.2793V13.8325H278.208C278.218 14.5236 278.385 15.05 278.707 15.4116C279.03 15.7733 279.485 15.9541 280.071 15.9541C280.432 15.9541 280.752 15.9201 281.029 15.8521C281.307 15.784 281.595 15.6838 281.894 15.5513V16.3354C281.606 16.4679 281.319 16.5646 281.035 16.6255C280.753 16.6864 280.42 16.7168 280.035 16.7168C279.487 16.7168 279.008 16.6022 278.598 16.373C278.192 16.1403 277.876 15.8001 277.65 15.3525C277.425 14.9049 277.312 14.3571 277.312 13.709C277.312 13.0752 277.414 12.5273 277.619 12.0654C277.827 11.5999 278.119 11.2419 278.494 10.9912C278.872 10.7406 279.317 10.6152 279.827 10.6152ZM279.816 11.3457C279.355 11.3457 278.987 11.5015 278.713 11.813C278.438 12.1245 278.275 12.5596 278.223 13.1182H281.243C281.239 12.7673 281.186 12.4593 281.081 12.1943C280.981 11.9258 280.826 11.7181 280.618 11.5713C280.41 11.4209 280.143 11.3457 279.816 11.3457Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M284.486 16.6094H283.617V8.25195H284.486V16.6094Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M290.099 16.6094H289.214V8.75684H293.452V9.5625H290.099V12.4414H293.249V13.2417H290.099V16.6094Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M295.456 10.7227V16.6094H294.592V10.7227H295.456ZM295.035 8.52051C295.177 8.52051 295.298 8.56885 295.399 8.66553C295.503 8.75863 295.555 8.90544 295.555 9.10596C295.555 9.3029 295.503 9.44971 295.399 9.54639C295.298 9.64307 295.177 9.69141 295.035 9.69141C294.885 9.69141 294.76 9.64307 294.66 9.54639C294.562 9.44971 294.514 9.3029 294.514 9.10596C294.514 8.90544 294.562 8.75863 294.66 8.66553C294.76 8.56885 294.885 8.52051 295.035 8.52051Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M299.991 10.6152C300.668 10.6152 301.18 10.7871 301.527 11.1309C301.874 11.471 302.047 12.0189 302.047 12.7744V16.6094H301.194V12.8335C301.194 12.3429 301.084 11.9759 300.866 11.7324C300.65 11.4889 300.319 11.3672 299.871 11.3672C299.24 11.3672 298.795 11.5516 298.538 11.9204C298.282 12.2892 298.153 12.8245 298.153 13.5264V16.6094H297.289V10.7227H297.987L298.117 11.5713H298.164C298.285 11.3636 298.439 11.1899 298.627 11.0503C298.814 10.9071 299.024 10.7996 299.257 10.728C299.489 10.6528 299.734 10.6152 299.991 10.6152Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M305.963 10.626C306.643 10.626 307.148 10.7835 307.478 11.0986C307.807 11.4137 307.972 11.9168 307.972 12.6079V16.6094H307.342L307.176 15.7393H307.134C306.974 15.9541 306.808 16.1349 306.634 16.2817C306.461 16.425 306.259 16.5342 306.03 16.6094C305.805 16.681 305.527 16.7168 305.197 16.7168C304.85 16.7168 304.541 16.6541 304.271 16.5288C304.003 16.4035 303.792 16.2137 303.635 15.9595C303.483 15.7052 303.406 15.383 303.406 14.9927C303.406 14.4054 303.632 13.9543 304.083 13.6392C304.534 13.3241 305.222 13.1522 306.145 13.1235L307.129 13.0806V12.7207C307.129 12.2122 307.023 11.856 306.811 11.6519C306.6 11.4478 306.301 11.3457 305.916 11.3457C305.617 11.3457 305.333 11.3905 305.062 11.48C304.791 11.5695 304.534 11.6751 304.291 11.7969L304.026 11.1201C304.283 10.984 304.578 10.8677 304.911 10.771C305.244 10.6743 305.595 10.626 305.963 10.626ZM307.118 13.709L306.249 13.7466C305.537 13.7752 305.036 13.8952 304.744 14.1064C304.453 14.3177 304.307 14.6167 304.307 15.0034C304.307 15.34 304.406 15.5889 304.604 15.75C304.802 15.9111 305.064 15.9917 305.39 15.9917C305.897 15.9917 306.311 15.8467 306.634 15.5566C306.957 15.2666 307.118 14.8315 307.118 14.2515V13.709Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M312.455 10.6152C313.132 10.6152 313.644 10.7871 313.991 11.1309C314.338 11.471 314.511 12.0189 314.511 12.7744V16.6094H313.658V12.8335C313.658 12.3429 313.548 11.9759 313.33 11.7324C313.114 11.4889 312.783 11.3672 312.335 11.3672C311.704 11.3672 311.259 11.5516 311.002 11.9204C310.746 12.2892 310.617 12.8245 310.617 13.5264V16.6094H309.753V10.7227H310.451L310.581 11.5713H310.628C310.749 11.3636 310.903 11.1899 311.091 11.0503C311.278 10.9071 311.488 10.7996 311.721 10.728C311.953 10.6528 312.198 10.6152 312.455 10.6152Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M318.578 16.7168C318.064 16.7168 317.611 16.6076 317.219 16.3892C316.827 16.1707 316.521 15.8377 316.302 15.3901C316.084 14.9425 315.974 14.3786 315.974 13.6982C315.974 12.9857 316.089 12.4038 316.318 11.9526C316.551 11.4979 316.87 11.1613 317.276 10.9429C317.682 10.7244 318.144 10.6152 318.661 10.6152C318.946 10.6152 319.22 10.6457 319.484 10.7065C319.751 10.7638 319.969 10.8372 320.14 10.9268L319.879 11.6733C319.706 11.6017 319.504 11.5373 319.275 11.48C319.05 11.4227 318.838 11.394 318.64 11.394C318.244 11.394 317.915 11.4818 317.651 11.6572C317.391 11.8327 317.195 12.0905 317.063 12.4307C316.934 12.7708 316.87 13.1898 316.87 13.6875C316.87 14.1637 316.932 14.5701 317.057 14.9067C317.186 15.2433 317.375 15.5011 317.625 15.6802C317.878 15.8556 318.194 15.9434 318.572 15.9434C318.874 15.9434 319.147 15.9111 319.39 15.8467C319.633 15.7786 319.853 15.6999 320.051 15.6104V16.4053C319.86 16.5055 319.647 16.5825 319.411 16.6362C319.178 16.6899 318.9 16.7168 318.578 16.7168Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M323.602 10.6152C324.088 10.6152 324.504 10.7262 324.851 10.9482C325.198 11.1702 325.464 11.4818 325.648 11.8828C325.832 12.2803 325.924 12.7458 325.924 13.2793V13.8325H321.983C321.993 14.5236 322.16 15.05 322.482 15.4116C322.805 15.7733 323.26 15.9541 323.846 15.9541C324.207 15.9541 324.527 15.9201 324.804 15.8521C325.082 15.784 325.37 15.6838 325.669 15.5513V16.3354C325.381 16.4679 325.094 16.5646 324.81 16.6255C324.529 16.6864 324.195 16.7168 323.81 16.7168C323.262 16.7168 322.783 16.6022 322.373 16.373C321.967 16.1403 321.651 15.8001 321.426 15.3525C321.2 14.9049 321.087 14.3571 321.087 13.709C321.087 13.0752 321.19 12.5273 321.394 12.0654C321.603 11.5999 321.894 11.2419 322.269 10.9912C322.647 10.7406 323.092 10.6152 323.602 10.6152ZM323.591 11.3457C323.13 11.3457 322.762 11.5015 322.488 11.813C322.213 12.1245 322.05 12.5596 321.998 13.1182H325.018C325.014 12.7673 324.961 12.4593 324.857 12.1943C324.756 11.9258 324.601 11.7181 324.393 11.5713C324.185 11.4209 323.918 11.3457 323.591 11.3457Z",
      fill: "white"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/AfganistanFlg.tsx


function AfganistanFlg_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AfganistanFlg_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AfganistanFlg_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AfganistanFlg_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var AfganistanFlg = function AfganistanFlg(props) {
  return /*#__PURE__*/_jsxs("svg", AfganistanFlg_objectSpread(AfganistanFlg_objectSpread({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("mask", {
      id: "mask0_841_19253",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 28,
      height: 16,
      children: /*#__PURE__*/_jsx("path", {
        d: "M28 0H0.5625V16H28V0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_841_19253)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask1_841_19253",
        style: {
          maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 0,
        width: 29,
        height: 16,
        children: /*#__PURE__*/_jsx("path", {
          d: "M28.0039 0H0.566406V16H28.0039V0Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask1_841_19253)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M28.0039 0H0.566406V16H28.0039V0Z",
          fill: "black"
        }), /*#__PURE__*/_jsx("path", {
          d: "M18.8644 0H9.71582V16H18.8644V0Z",
          fill: "#AE0018"
        }), /*#__PURE__*/_jsx("path", {
          d: "M28.0118 0H18.8633V16H28.0118V0Z",
          fill: "#3E9A13"
        }), /*#__PURE__*/_jsx("mask", {
          id: "mask2_841_19253",
          style: {
            maskType: "luminance"
          },
          maskUnits: "userSpaceOnUse",
          x: 0,
          y: 0,
          width: 29,
          height: 16,
          children: /*#__PURE__*/_jsx("path", {
            d: "M28.0049 0H0.567383V16H28.0049V0Z",
            fill: "white"
          })
        }), /*#__PURE__*/_jsxs("g", {
          mask: "url(#mask2_841_19253)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M18.1517 8.11873C18.1517 8.11873 18.1926 8.15962 18.2008 8.15144C18.2417 8.09421 18.3071 7.98792 18.3152 7.92252C18.3152 7.90617 18.258 7.88162 18.2417 7.89797C18.2008 7.94702 18.1599 8.05332 18.1436 8.11873H18.1517Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M18.1922 8.15972C18.1922 8.15972 18.1595 8.15154 18.1514 8.13519C18.1595 8.04526 18.2004 7.93898 18.2413 7.88993C18.2822 7.88175 18.3149 7.88992 18.323 7.90627C18.323 7.98803 18.2576 8.09433 18.2086 8.15156H18.1922V8.15972ZM18.2658 7.90627C18.2168 7.95533 18.1759 8.06163 18.1677 8.12703C18.1677 8.12703 18.1922 8.15156 18.2004 8.15156C18.2413 8.09433 18.3067 7.9962 18.3149 7.9308C18.3149 7.9308 18.2903 7.91445 18.274 7.91445L18.2658 7.90627Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.486 11.422C12.437 11.5855 11.7748 11.2748 11.7012 11.1113C12.0854 11.3157 12.4942 11.2748 12.486 11.422Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3968 11.4799C12.2006 11.4799 11.751 11.2509 11.6855 11.1201C11.8736 11.2019 12.0616 11.2428 12.2088 11.2755C12.3723 11.3163 12.4949 11.3409 12.4867 11.4308C12.4867 11.4553 12.4622 11.488 12.3886 11.488L12.3968 11.4799ZM11.6937 11.1201C11.7836 11.2591 12.4377 11.5453 12.4704 11.4226C12.4704 11.3491 12.3559 11.3245 12.2006 11.2918C12.0534 11.2591 11.8736 11.2182 11.6937 11.1201Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.3775 8.15937C10.4102 8.20025 10.4674 8.17574 10.4184 8.11851C10.3775 8.07763 10.3939 8.06127 10.3693 8.01222C10.3448 7.95499 10.3448 7.92228 10.3121 7.8814C10.2876 7.84052 10.2467 7.88141 10.2712 7.91411C10.3039 7.95499 10.2958 7.97952 10.3121 8.0204C10.353 8.08581 10.3448 8.1185 10.3775 8.15937Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.4095 8.19324C10.4095 8.19324 10.3768 8.18506 10.3686 8.16871C10.3441 8.15236 10.3441 8.12782 10.3359 8.10329C10.3359 8.08694 10.3196 8.06241 10.3032 8.02971C10.2951 8.01336 10.2869 7.99702 10.2869 7.98884C10.2869 7.97249 10.2705 7.94796 10.2542 7.93161C10.246 7.91525 10.246 7.89891 10.2542 7.88255L10.2869 7.86621C10.2869 7.86621 10.3114 7.8662 10.3196 7.88255C10.3441 7.91526 10.3441 7.93161 10.3523 7.96432C10.3523 7.98067 10.3605 7.99703 10.3768 8.02155C10.3768 8.04608 10.385 8.05425 10.3932 8.07061C10.3932 8.08696 10.4013 8.10331 10.4259 8.12784C10.4586 8.16055 10.4504 8.17688 10.4504 8.18505L10.4177 8.20142L10.4095 8.19324ZM10.2705 7.90708C10.2705 7.90708 10.2951 7.95613 10.3032 7.98066C10.3032 7.99701 10.3032 8.0052 10.3196 8.02155C10.3359 8.05426 10.3441 8.07876 10.3523 8.10329C10.3523 8.12782 10.3686 8.14418 10.385 8.16053L10.4177 8.18505L10.434 8.16871C10.434 8.16871 10.434 8.15235 10.4177 8.136C10.3931 8.1033 10.385 8.08695 10.3768 8.06242C10.3768 8.04607 10.3768 8.02973 10.3604 8.02155C10.3523 7.99703 10.3441 7.98067 10.3359 7.96432C10.3359 7.93161 10.3196 7.91526 10.3032 7.89074L10.2705 7.92345V7.90708Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2764 9.24805C11.3827 9.30528 11.4644 9.43608 11.4726 9.54236C11.4808 9.665 11.4971 9.77129 11.5543 9.85305C11.4644 9.82852 11.4235 9.68954 11.4153 9.55873C11.4072 9.41974 11.3254 9.35433 11.2845 9.24805H11.2764Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5704 9.86878H11.5459C11.4315 9.82791 11.4069 9.6317 11.3988 9.54994C11.3906 9.46001 11.3579 9.40278 11.317 9.34555C11.2925 9.31284 11.2761 9.28014 11.2598 9.23926C11.3824 9.28014 11.4642 9.41094 11.4723 9.53357C11.4723 9.65621 11.4969 9.7625 11.5541 9.84426L11.5704 9.86878ZM11.2679 9.2556C11.2679 9.2556 11.317 9.31284 11.3333 9.34555C11.366 9.40278 11.4069 9.46002 11.4151 9.55813C11.4315 9.69711 11.4642 9.79522 11.5214 9.8361C11.4805 9.75434 11.4642 9.65622 11.456 9.54176C11.456 9.43547 11.3661 9.30466 11.2679 9.2556Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4969 9.50195C11.5705 9.64094 11.6686 9.68998 11.6768 9.79627C11.685 9.91073 11.6932 9.91891 11.7259 10.0334C11.6359 10.0088 11.6196 10.0007 11.5951 9.82898C11.5787 9.70634 11.4806 9.6164 11.4969 9.51011V9.50195Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7415 10.0478H11.7251C11.6352 10.0151 11.6107 10.0069 11.5861 9.82703C11.5861 9.7698 11.5534 9.72892 11.5371 9.67987C11.5125 9.62264 11.488 9.56541 11.488 9.5C11.5371 9.55723 11.578 9.59811 11.6107 9.63082C11.6516 9.67987 11.6924 9.72891 11.6924 9.79432C11.6924 9.88425 11.7088 9.9088 11.7251 9.96603L11.7496 10.0478H11.7415ZM11.4799 9.50816C11.4962 9.56539 11.5207 9.61445 11.5453 9.67168C11.5698 9.72074 11.5943 9.76979 11.6025 9.81884C11.627 9.97418 11.6434 9.99054 11.7088 10.0069L11.6924 9.96603C11.6761 9.9088 11.6679 9.88427 11.6597 9.78616C11.6597 9.72893 11.6188 9.68803 11.578 9.63897C11.5453 9.5981 11.5044 9.55723 11.4717 9.5L11.4799 9.50816Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2295 10.2367C13.344 10.3348 13.4175 10.4411 13.4503 10.5719C13.483 10.7027 13.5402 10.8008 13.6137 10.9153C13.4911 10.8335 13.4175 10.7191 13.3848 10.5801C13.3521 10.4493 13.3112 10.3512 13.2295 10.2285V10.2367Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.3475 10.2373C15.233 10.3354 15.1513 10.4417 15.1186 10.5807C15.0777 10.7115 15.0287 10.8096 14.9551 10.9241C15.0777 10.8423 15.1595 10.736 15.1922 10.597C15.2249 10.4662 15.2657 10.3599 15.3475 10.2455V10.2373Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.209 10.2363C15.0863 10.3344 14.9719 10.4489 14.931 10.5879C14.8983 10.7187 14.8737 10.8168 14.792 10.9394C14.9228 10.8577 14.98 10.7351 15.0127 10.5961C15.0454 10.4653 15.1272 10.3671 15.209 10.2363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.8027 10.7686C13.8436 10.8503 13.8927 10.9648 13.9744 10.9484C13.9744 10.883 13.8845 10.8503 13.8027 10.7686Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.9326 10.8008C14.1043 10.8662 14.2433 10.8498 14.2678 10.9643C14.1043 10.9806 14.0553 10.9152 13.9326 10.8008Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.759 10.7852C14.7181 10.8587 14.669 10.9732 14.5791 10.9487C14.5791 10.8914 14.6772 10.8506 14.759 10.7852Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.635 10.8008C14.4633 10.8662 14.3162 10.8498 14.2998 10.9561C14.4551 10.9725 14.5206 10.9071 14.635 10.8008Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4123 7.39895C12.3633 7.30902 12.2979 7.51341 12.069 7.67692C11.9627 7.7505 11.8891 7.93855 11.8891 8.06119C11.8891 8.15112 11.8891 8.23288 11.8891 8.31463C11.8891 8.36369 11.8319 8.47814 11.8646 8.51084C11.9627 8.58443 12.0935 8.74795 12.1507 8.80519C12.1998 8.84606 12.2488 8.57627 12.2815 8.45363C12.3224 8.32282 12.3061 8.16748 12.4205 8.04484C12.5023 7.96309 12.7067 7.88133 12.6822 7.84045L12.4123 7.40713V7.39895Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1657 8.81442H12.1493C12.1493 8.81442 12.1003 8.75717 12.0676 8.71629C12.0104 8.64271 11.9286 8.55278 11.8632 8.5119C11.8305 8.4792 11.855 8.42197 11.8632 8.36474C11.8632 8.34021 11.8795 8.32386 11.8795 8.3075C11.8795 8.25845 11.8795 8.2094 11.8795 8.16035C11.8795 8.12764 11.8795 8.09494 11.8795 8.06224C11.8795 7.93143 11.9531 7.74338 12.0594 7.66979C12.1575 7.59621 12.2311 7.51447 12.2801 7.45724C12.3456 7.38366 12.3864 7.34277 12.411 7.4L12.6808 7.8415C12.6808 7.88238 12.6399 7.90691 12.5663 7.94779C12.5172 7.9805 12.4518 8.01319 12.4191 8.0459C12.3456 8.12766 12.3292 8.22576 12.3129 8.32387C12.3129 8.36475 12.2965 8.41381 12.2883 8.45469C12.272 8.48739 12.2638 8.52826 12.2556 8.57732C12.2229 8.73266 12.1902 8.82258 12.1575 8.82258L12.1657 8.81442ZM12.3864 7.4C12.3864 7.4 12.3292 7.4327 12.3047 7.4654C12.2474 7.5308 12.182 7.61258 12.0758 7.68616C11.9776 7.75974 11.9041 7.9396 11.9041 8.06224C11.9041 8.09494 11.9041 8.13582 11.9041 8.16035C11.9041 8.2094 11.9041 8.25846 11.9041 8.31569C11.9041 8.33204 11.9041 8.3484 11.8877 8.37292C11.8714 8.42198 11.855 8.48739 11.8795 8.50374C11.945 8.55279 12.0185 8.64273 12.0839 8.70813C12.1166 8.74084 12.1412 8.7817 12.1575 8.79806C12.1575 8.79806 12.2148 8.65908 12.2393 8.57732C12.2556 8.52826 12.2638 8.48739 12.272 8.45469C12.2802 8.41381 12.2965 8.36475 12.2965 8.32387C12.3129 8.22576 12.3292 8.11946 12.411 8.02953C12.4437 7.98865 12.5091 7.95597 12.5663 7.92327C12.6154 7.89874 12.6644 7.86601 12.6726 7.84966L12.4028 7.40819H12.3864V7.4Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2812 8.48681C12.2812 8.48681 12.2403 8.40507 12.1994 8.37236C12.1667 8.33148 12.1259 8.29878 12.085 8.2906C12.0441 8.27425 12.0032 8.27424 11.9705 8.25789C11.9542 8.25789 11.9378 8.24155 11.9215 8.21702C11.9133 8.20885 11.9051 8.18432 11.8969 8.16797C11.8969 8.21702 11.8969 8.26607 11.8969 8.31513C11.8969 8.36418 11.8397 8.47863 11.8724 8.51134C11.9705 8.58492 12.1013 8.74845 12.1586 8.80568C12.2076 8.84656 12.2485 8.61762 12.2812 8.48681Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1673 8.81423H12.1509C12.1509 8.81423 12.1101 8.75698 12.0774 8.7161C12.012 8.6507 11.9384 8.56076 11.873 8.51171C11.8403 8.48718 11.8648 8.42178 11.873 8.36455C11.873 8.34002 11.8893 8.32367 11.8893 8.30731C11.8893 8.26644 11.8893 8.2174 11.8893 8.17652C11.9057 8.23375 11.9057 8.27461 11.8975 8.30731C11.8975 8.32367 11.8975 8.34002 11.8812 8.36455C11.8648 8.40543 11.8485 8.47083 11.8648 8.48718C11.9302 8.53624 12.012 8.62617 12.0692 8.69158C12.1019 8.72428 12.1264 8.76517 12.1428 8.78152C12.1428 8.78152 12.2082 8.64254 12.2245 8.56079L12.2491 8.47084C12.2491 8.47084 12.2082 8.39727 12.1755 8.35639C12.1428 8.31551 12.1019 8.29098 12.0692 8.27463C12.0529 8.27463 12.0283 8.27461 12.012 8.25826C11.9874 8.25826 11.9711 8.25009 11.9466 8.24192C11.922 8.23374 11.9057 8.2174 11.8975 8.20105C11.8893 8.1847 11.8811 8.17651 11.873 8.16016C11.8975 8.16016 11.9057 8.17651 11.9139 8.18468C11.922 8.20103 11.9384 8.20922 11.9547 8.22558C11.9711 8.22558 11.9956 8.23374 12.012 8.24192C12.0283 8.24192 12.0529 8.25009 12.0692 8.25826C12.1101 8.26644 12.151 8.29915 12.1918 8.34002C12.2327 8.3809 12.2572 8.42995 12.2654 8.46266L12.2409 8.5526C12.2 8.69977 12.1755 8.79787 12.1346 8.79787L12.1673 8.81423Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.404 8.0709C12.404 8.0709 12.3631 7.98913 12.3304 7.95643C12.2977 7.92372 12.265 7.89101 12.2323 7.87466C12.1914 7.86649 12.1505 7.84197 12.126 7.80927C12.1097 7.79292 12.1015 7.7684 12.0933 7.74387C12.0933 7.71934 12.0933 7.69481 12.0933 7.66211C12.0933 7.66211 12.0933 7.66209 12.0851 7.67027C11.9789 7.74385 11.9053 7.93189 11.9053 8.05453C11.9053 8.08723 11.9053 8.11996 11.9053 8.15266C11.9053 8.16901 11.9216 8.19354 11.9298 8.20171C11.9462 8.21807 11.9625 8.23441 11.9789 8.24258C12.0197 8.25893 12.0524 8.25894 12.0933 8.27529C12.1342 8.29165 12.1751 8.31618 12.2078 8.35706C12.2405 8.39794 12.265 8.4388 12.2895 8.4715C12.2895 8.45515 12.2895 8.43881 12.2977 8.43064C12.3304 8.31617 12.3222 8.16899 12.404 8.05453V8.0709Z",
            fill: "#AE0018"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2821 8.51203L12.2657 8.4875C12.2657 8.4875 12.2248 8.41393 12.1921 8.37305C12.1594 8.33217 12.1186 8.30764 12.0859 8.29129C12.0695 8.29129 12.045 8.2913 12.0286 8.27495C12.0041 8.27495 11.9878 8.26676 11.9632 8.25858C11.9387 8.2504 11.9224 8.23406 11.9142 8.21771C11.8978 8.20136 11.8896 8.185 11.8896 8.16047C11.8896 8.12777 11.8896 8.0869 11.8896 8.06237C11.8896 7.93156 11.9632 7.7435 12.0695 7.66992C11.9714 7.75986 11.906 7.93973 11.906 8.06237V8.16047C11.906 8.16047 11.9223 8.19319 11.9305 8.20137C11.9387 8.21772 11.955 8.22589 11.9714 8.24224C11.9877 8.24224 12.0123 8.2504 12.0286 8.25858C12.045 8.25858 12.0695 8.26677 12.0859 8.27495C12.1267 8.28312 12.1676 8.31583 12.2085 8.35671C12.233 8.38941 12.2576 8.43029 12.2739 8.45482C12.2821 8.40576 12.2984 8.36488 12.2984 8.324C12.3148 8.23407 12.3311 8.15231 12.3884 8.07055C12.3638 8.03785 12.3475 7.99697 12.3148 7.97245C12.2821 7.93157 12.2494 7.91519 12.2167 7.89884C12.184 7.88249 12.1349 7.86614 12.1104 7.82526C12.094 7.80891 12.0777 7.7844 12.0777 7.75987C12.0777 7.74352 12.0777 7.71899 12.0777 7.68629C12.094 7.71899 12.094 7.74352 12.1022 7.75987C12.1022 7.7844 12.1186 7.80075 12.1349 7.81711C12.1594 7.84981 12.2003 7.87432 12.233 7.8825C12.2739 7.89068 12.3148 7.92338 12.3393 7.96426C12.372 7.99697 12.3965 8.03783 12.4129 8.07871C12.3638 8.16865 12.3475 8.25043 12.3311 8.33218C12.3311 8.37306 12.3148 8.41394 12.3066 8.45482L12.2902 8.52021L12.2821 8.51203Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3956 7.37537C12.3466 7.35902 12.273 7.53072 12.085 7.66153C12.085 7.69423 12.085 7.71876 12.085 7.74329C12.085 7.77599 12.1013 7.79234 12.1177 7.80869C12.1422 7.84139 12.1831 7.86591 12.224 7.87408C12.2648 7.89043 12.2975 7.91497 12.3221 7.95585C12.3548 7.98855 12.3793 8.02944 12.3956 8.07032C12.3956 8.05397 12.4038 8.0376 12.4202 8.02942C12.5019 7.94767 12.7063 7.86591 12.6818 7.82503L12.412 7.39171C12.412 7.39171 12.4038 7.37536 12.3875 7.36719L12.3956 7.37537Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3956 8.07811C12.3793 8.03723 12.3548 7.99636 12.3221 7.96366C12.2894 7.92278 12.2567 7.90643 12.224 7.89008C12.1913 7.87373 12.1422 7.85738 12.1177 7.8165C12.1013 7.80015 12.085 7.77561 12.085 7.75108C12.085 7.72655 12.085 7.69386 12.085 7.66116C12.1831 7.58758 12.2485 7.50582 12.2975 7.45676C12.3384 7.40771 12.3711 7.375 12.3956 7.375C12.412 7.375 12.4202 7.38317 12.4283 7.39953L12.6981 7.83284C12.6981 7.87372 12.6572 7.89825 12.5837 7.93913C12.5346 7.97183 12.4692 8.00453 12.4365 8.03724L12.412 8.06176H12.4038L12.3956 8.07811ZM12.3956 7.40771C12.3956 7.40771 12.3384 7.44039 12.3057 7.46492C12.2566 7.52215 12.1913 7.60391 12.0931 7.66932C12.0931 7.70202 12.0931 7.72655 12.0931 7.75108C12.0931 7.77561 12.1095 7.79196 12.1258 7.80832C12.1504 7.84102 12.1913 7.86554 12.224 7.87371C12.2648 7.88189 12.3057 7.9146 12.3302 7.95547C12.3547 7.98818 12.3793 8.0127 12.3956 8.05358C12.4447 7.99635 12.5101 7.95549 12.5673 7.92279C12.6164 7.89009 12.6654 7.86554 12.6736 7.84918L12.4038 7.40771H12.3875H12.3956Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4126 8.06932C12.3635 8.01209 12.3063 7.92215 12.2245 7.88945C12.1428 7.85675 12.0528 7.79951 12.0773 7.65234H12.1019C12.0773 7.79133 12.1509 7.84038 12.2327 7.87308C12.3226 7.90578 12.388 7.99573 12.4126 8.06932Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2978 8.48692C12.2488 8.41334 12.1588 8.31524 12.0853 8.29071C12.0689 8.29071 12.0444 8.28255 12.0362 8.27437C11.9708 8.25802 11.9054 8.24166 11.8809 8.14355H11.8972C11.9217 8.22531 11.9708 8.24167 12.0362 8.24984C12.0526 8.24984 12.0771 8.25801 12.0934 8.26619C12.1752 8.29889 12.2651 8.39699 12.2978 8.48692Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3389 7.30971L12.3797 7.28516L13.1564 8.59329L13.1156 8.61781L12.3389 7.30971Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.1159 8.6349L12.3311 7.31043L12.3719 7.26953L13.165 8.58585L13.1159 8.62672V8.6349ZM12.3719 7.28587L12.3474 7.31858L13.1241 8.61037L13.1568 8.58585L12.3719 7.28587Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3389 7.30971L12.3797 7.28516L13.1564 8.59329L13.1156 8.61781L12.3389 7.30971Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.1159 8.6349L12.3311 7.31043L12.3719 7.26953L13.165 8.58585L13.1159 8.62672V8.6349ZM12.3719 7.28587L12.3474 7.31858L13.1241 8.61037L13.1568 8.58585L12.3719 7.28587Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4211 7.25206C12.4211 7.30111 12.3802 7.34198 12.3311 7.34198C12.2821 7.34198 12.2412 7.30111 12.2412 7.25206C12.2412 7.203 12.2821 7.16211 12.3311 7.16211C12.3884 7.16211 12.4211 7.203 12.4211 7.25206Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3305 7.35932C12.2815 7.35932 12.2324 7.31842 12.2324 7.26119C12.2324 7.21214 12.2733 7.16309 12.3305 7.16309C12.3878 7.16309 12.4287 7.20396 12.4287 7.26119C12.4287 7.31842 12.3878 7.35932 12.3305 7.35932ZM12.3305 7.17945C12.2896 7.17945 12.2488 7.21214 12.2488 7.26119C12.2488 7.35113 12.4123 7.35113 12.4123 7.26119C12.4123 7.22031 12.3796 7.17945 12.3305 7.17945Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4211 7.25206C12.4211 7.30111 12.3802 7.34198 12.3311 7.34198C12.2821 7.34198 12.2412 7.30111 12.2412 7.25206C12.2412 7.203 12.2821 7.16211 12.3311 7.16211C12.3884 7.16211 12.4211 7.203 12.4211 7.25206Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3305 7.35932C12.2815 7.35932 12.2324 7.31842 12.2324 7.26119C12.2324 7.21214 12.2733 7.16309 12.3305 7.16309C12.3878 7.16309 12.4287 7.20396 12.4287 7.26119C12.4287 7.31842 12.3878 7.35932 12.3305 7.35932ZM12.3305 7.17945C12.2896 7.17945 12.2488 7.21214 12.2488 7.26119C12.2488 7.35113 12.4123 7.35113 12.4123 7.26119C12.4123 7.22031 12.3796 7.17945 12.3305 7.17945Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1725 7.42373C16.2297 7.3338 16.287 7.54637 16.5159 7.70989C16.614 7.78347 16.6876 7.97968 16.6876 8.1105C16.6876 8.20043 16.6794 8.28219 16.6876 8.37213C16.6876 8.42936 16.7448 8.54382 16.7121 8.57652C16.614 8.6501 16.4913 8.8218 16.4259 8.88721C16.3769 8.92809 16.3278 8.6501 16.2951 8.51929C16.2542 8.3803 16.2706 8.21679 16.1561 8.09415C16.0744 8.00422 15.8782 7.92245 15.8945 7.88158L16.1643 7.43192L16.1725 7.42373Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.419 8.88728C16.419 8.88728 16.3536 8.79733 16.3209 8.64199C16.3046 8.59294 16.2964 8.54388 16.2882 8.51118C16.2718 8.4703 16.2637 8.42126 16.2555 8.3722C16.2392 8.27409 16.2228 8.1678 16.1492 8.08604C16.1083 8.04516 16.0511 8.01246 15.9939 7.97975C15.9203 7.9307 15.8631 7.89801 15.8876 7.86531L16.1574 7.41562C16.1901 7.36657 16.231 7.39929 16.2964 7.48104C16.3454 7.53827 16.4109 7.6282 16.5171 7.70178C16.6234 7.77536 16.697 7.97158 16.697 8.11057C16.697 8.14327 16.697 8.18416 16.697 8.21686C16.697 8.26591 16.697 8.31496 16.697 8.36402C16.697 8.38037 16.7052 8.4049 16.7133 8.42125C16.7297 8.47848 16.746 8.54388 16.7133 8.56841C16.6479 8.61747 16.5744 8.70741 16.509 8.78099C16.4763 8.82187 16.4435 8.85456 16.4272 8.87091H16.4109L16.419 8.88728ZM16.1983 7.41562L15.9121 7.88165C15.9121 7.88165 15.9775 7.93888 16.0184 7.96341C16.0675 7.99611 16.1329 8.03698 16.1656 8.07786C16.2473 8.16779 16.2637 8.27409 16.28 8.3722C16.28 8.42126 16.2964 8.46212 16.3046 8.51118C16.3209 8.54388 16.3291 8.58476 16.3373 8.64199C16.3618 8.73193 16.3945 8.8791 16.419 8.8791C16.4354 8.86274 16.4599 8.83005 16.4926 8.78917C16.558 8.71559 16.6316 8.62564 16.697 8.56841C16.7215 8.55206 16.697 8.49483 16.6888 8.4376C16.6888 8.41307 16.6725 8.38855 16.6725 8.3722C16.6725 8.33132 16.6725 8.2741 16.6725 8.22504C16.6725 8.18416 16.6725 8.15146 16.6725 8.11875C16.6725 7.98794 16.5989 7.79989 16.5008 7.72631C16.3945 7.65272 16.3291 7.5628 16.2719 7.50557C16.2392 7.45651 16.2146 7.42381 16.1901 7.42381L16.1983 7.41562Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6883 8.20933C16.6883 8.20933 16.672 8.2584 16.6556 8.27475C16.6393 8.2911 16.6229 8.29926 16.6066 8.30744C16.5739 8.32379 16.533 8.32379 16.4921 8.34015C16.4512 8.3565 16.4104 8.38103 16.3777 8.42191C16.3368 8.46279 16.3122 8.50368 16.2959 8.53638C16.3286 8.67537 16.3777 8.91245 16.4185 8.87157C16.4758 8.81434 16.5984 8.64267 16.7047 8.56091C16.7456 8.52821 16.6883 8.41374 16.6802 8.35651C16.6802 8.30746 16.6802 8.2584 16.6802 8.20117L16.6883 8.20933Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.4185 8.88794C16.4185 8.88794 16.3531 8.79799 16.3204 8.64265L16.2959 8.54454C16.3122 8.49549 16.345 8.44643 16.3777 8.41373C16.4185 8.37285 16.4594 8.34016 16.4921 8.3238C16.5166 8.3238 16.533 8.32379 16.5493 8.30744C16.5657 8.30744 16.5902 8.29927 16.6066 8.29109C16.6229 8.29109 16.6393 8.27474 16.6474 8.25838C16.6638 8.24203 16.672 8.2257 16.6802 8.20117C16.6965 8.27475 16.6965 8.31562 16.6965 8.36467C16.6965 8.38102 16.6965 8.40556 16.7129 8.42191C16.7292 8.47914 16.7456 8.54454 16.7129 8.56907C16.6475 8.61812 16.5739 8.70806 16.5085 8.78165C16.4758 8.82252 16.4431 8.85522 16.4267 8.87157H16.4104L16.4185 8.88794ZM16.6802 8.27475C16.6802 8.27475 16.6802 8.28292 16.6802 8.29109C16.6638 8.30745 16.6474 8.32381 16.6229 8.33199C16.6066 8.33199 16.5821 8.34015 16.5657 8.34833C16.5494 8.34833 16.533 8.3565 16.5167 8.36467C16.4758 8.38102 16.4431 8.40556 16.4022 8.44644C16.3695 8.47914 16.345 8.52003 16.3286 8.56091L16.3531 8.65901C16.3777 8.74895 16.4104 8.88794 16.4349 8.88794C16.4512 8.87158 16.4758 8.83069 16.5085 8.79799C16.5739 8.72441 16.6475 8.63448 16.7129 8.57725C16.7374 8.5609 16.7129 8.49549 16.7047 8.44644C16.7047 8.42191 16.6883 8.39739 16.6883 8.38104C16.6883 8.34834 16.6883 8.31561 16.6883 8.28291L16.6802 8.27475Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5083 7.70215C16.5083 7.70215 16.5083 7.76757 16.5083 7.7921C16.5083 7.81662 16.492 7.83296 16.4756 7.85749C16.4429 7.89019 16.4102 7.91473 16.3693 7.92291C16.3284 7.93926 16.2876 7.96379 16.263 7.99649C16.2303 8.02919 16.2058 8.07006 16.1895 8.11094C16.2712 8.23357 16.263 8.37257 16.3039 8.50338C16.3039 8.51156 16.3039 8.51974 16.3039 8.53609C16.3203 8.50339 16.3448 8.45433 16.3857 8.42162C16.4184 8.38074 16.4593 8.35621 16.5001 8.33986C16.5328 8.32351 16.5737 8.3235 16.6146 8.30715C16.631 8.30715 16.6473 8.29082 16.6637 8.27446C16.68 8.25811 16.6882 8.23357 16.6963 8.20904V8.10275C16.6963 7.98012 16.6228 7.78391 16.5247 7.71033C16.5247 7.71033 16.5219 7.71033 16.5165 7.71033L16.5083 7.70215Z",
            fill: "#AE0018"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.304 8.56817L16.2877 8.51912C16.2713 8.47007 16.2632 8.4292 16.255 8.38015C16.2386 8.29021 16.2223 8.20027 16.165 8.11852C16.1896 8.06946 16.2141 8.02858 16.2386 7.9877C16.2713 7.955 16.3122 7.93047 16.3531 7.90594C16.394 7.88959 16.4267 7.87325 16.4594 7.84054C16.4757 7.82419 16.4839 7.79966 16.4921 7.78331C16.4921 7.75878 16.4921 7.73424 16.4921 7.69336C16.6229 7.76694 16.6965 7.96318 16.6965 8.09399C16.6965 8.13487 16.6965 8.16758 16.6965 8.20028C16.6965 8.23298 16.6801 8.25751 16.6638 8.27386C16.6474 8.29021 16.6311 8.30655 16.6065 8.31473C16.5902 8.31473 16.5656 8.32292 16.5493 8.33109C16.5329 8.33109 16.5166 8.33926 16.5002 8.34744C16.4594 8.36379 16.4267 8.38832 16.3858 8.4292C16.3531 8.4619 16.3286 8.50277 16.3122 8.54365V8.56817H16.304ZM16.5084 7.71791C16.5084 7.71791 16.5084 7.76696 16.5084 7.79149C16.5084 7.81602 16.4839 7.84054 16.4757 7.86507C16.443 7.89777 16.4022 7.9223 16.3613 7.93865C16.3204 7.955 16.2877 7.97952 16.255 8.01223C16.2223 8.04493 16.1978 8.08582 16.1814 8.1267C16.2386 8.20028 16.255 8.29021 16.2713 8.38015C16.2713 8.42103 16.2877 8.47006 16.2959 8.51094C16.2959 8.51094 16.3367 8.44554 16.3694 8.41283C16.4103 8.37195 16.4512 8.33926 16.4839 8.32291C16.5084 8.32291 16.5248 8.3229 16.5411 8.30654C16.5575 8.30654 16.582 8.29838 16.5983 8.2902C16.6147 8.2902 16.6311 8.27384 16.6392 8.25749C16.6556 8.24114 16.6638 8.22481 16.6719 8.20028V8.10215C16.6719 7.97951 16.5984 7.78332 16.5002 7.71791H16.5084Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1898 7.4082C16.1898 7.4082 16.1735 7.42455 16.1653 7.42455L15.8955 7.8742C15.8955 7.8742 16.0754 7.99685 16.1571 8.08678C16.1653 8.09496 16.1735 8.11132 16.1817 8.11949C16.198 8.07861 16.2225 8.03772 16.2552 8.00502C16.2879 7.97232 16.3206 7.94779 16.3615 7.93144C16.4024 7.91509 16.4433 7.89875 16.4678 7.86605C16.4841 7.84969 16.4923 7.82515 16.5005 7.80063C16.5005 7.7761 16.5005 7.74341 16.5005 7.7107C16.3206 7.57171 16.2389 7.39183 16.1898 7.41636V7.4082Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1816 8.14439L16.1652 8.11168C16.1243 8.05445 16.0589 8.02175 16.0017 7.98905C15.9281 7.93999 15.8709 7.90728 15.8954 7.87458L16.1897 7.40039C16.1897 7.40039 16.2551 7.43308 16.3042 7.49031C16.3532 7.54754 16.4187 7.62931 16.5086 7.70289C16.5086 7.74377 16.5086 7.77647 16.5086 7.801C16.5086 7.82552 16.4841 7.85005 16.4759 7.87458C16.4432 7.90728 16.4023 7.93183 16.3614 7.94818C16.3206 7.96453 16.2878 7.98906 16.2551 8.02176C16.2224 8.05446 16.1979 8.09533 16.1816 8.13621V8.15257V8.14439ZM16.1979 7.41673L15.9036 7.88276C15.9036 7.88276 15.969 7.94 16.0099 7.97271C16.0671 8.00541 16.1243 8.04627 16.157 8.07897V8.1035C16.157 8.1035 16.2142 8.02994 16.2388 7.99723C16.2715 7.96453 16.3124 7.94 16.3532 7.91547C16.3941 7.89912 16.4268 7.88275 16.4595 7.85005C16.4759 7.8337 16.484 7.80919 16.4922 7.79284C16.4922 7.76831 16.4922 7.74377 16.4922 7.70289C16.4023 7.63748 16.3287 7.55573 16.2797 7.4985C16.247 7.44944 16.2143 7.41673 16.1979 7.41673Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2482 7.33349L16.2074 7.30078L15.4307 8.66612L15.4715 8.69065L16.2482 7.33349Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.47 8.69921L15.4209 8.6665L16.1976 7.29297L16.2548 7.3175L15.47 8.69921ZM16.1976 7.30934L15.4373 8.6665L15.4618 8.68286L16.2385 7.33386L16.1976 7.3175V7.30934Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3121 8.55207C16.3285 8.46213 16.4102 8.36403 16.4919 8.33133C16.5165 8.33133 16.5328 8.32314 16.5492 8.31496C16.6064 8.29861 16.6555 8.29045 16.68 8.20051H16.7045C16.68 8.31497 16.6146 8.32315 16.5574 8.33133C16.541 8.33133 16.5247 8.3395 16.5083 8.34767C16.4266 8.38037 16.3448 8.47848 16.3121 8.55207ZM16.1895 8.12693C16.214 8.02882 16.2876 7.95524 16.3612 7.92254C16.4347 7.88984 16.5165 7.84895 16.5001 7.70996H16.5247C16.5492 7.85713 16.4674 7.91436 16.3775 7.94707C16.3039 7.97159 16.2385 8.04516 16.1976 8.13509L16.1895 8.12693Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2482 7.33349L16.2074 7.30078L15.4307 8.66612L15.4715 8.69065L16.2482 7.33349Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.47 8.69921L15.4209 8.6665L16.1976 7.29297L16.2548 7.3175L15.47 8.69921ZM16.1976 7.30934L15.4373 8.6665L15.4618 8.68286L16.2385 7.33386L16.1976 7.3175V7.30934Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.165 7.27745C16.165 7.33468 16.2059 7.36737 16.255 7.36737C16.304 7.36737 16.3449 7.3265 16.3449 7.27745C16.3449 7.22839 16.304 7.1875 16.255 7.1875C16.2059 7.1875 16.165 7.22839 16.165 7.27745Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2553 7.3759C16.1981 7.3759 16.1572 7.33502 16.1572 7.27779C16.1572 7.22056 16.1981 7.17969 16.2553 7.17969C16.3044 7.17969 16.3534 7.22874 16.3534 7.27779C16.3534 7.33502 16.3126 7.3759 16.2553 7.3759ZM16.2553 7.19603C16.2063 7.19603 16.1654 7.23691 16.1654 7.27779C16.1654 7.36773 16.3289 7.3759 16.3289 7.27779C16.3289 7.23691 16.288 7.19603 16.2471 7.19603H16.2553Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.165 7.27745C16.165 7.33468 16.2059 7.36737 16.255 7.36737C16.304 7.36737 16.3449 7.3265 16.3449 7.27745C16.3449 7.22839 16.304 7.1875 16.255 7.1875C16.2059 7.1875 16.165 7.22839 16.165 7.27745Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2553 7.3759C16.1981 7.3759 16.1572 7.33502 16.1572 7.27779C16.1572 7.22056 16.1981 7.17969 16.2553 7.17969C16.3044 7.17969 16.3534 7.22874 16.3534 7.27779C16.3534 7.33502 16.3126 7.3759 16.2553 7.3759ZM16.2553 7.19603C16.2063 7.19603 16.1654 7.23691 16.1654 7.27779C16.1654 7.36773 16.3289 7.3759 16.3289 7.27779C16.3289 7.23691 16.288 7.19603 16.2471 7.19603H16.2553Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4015 6.20703H13.0908V6.28061H13.4015V6.20703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.41 6.2794H13.0912V6.19764L13.4018 6.18945V6.2794H13.41ZM13.3937 6.19764H13.083V6.27122H13.3855V6.19764H13.3937Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4015 6.3457H13.0908V6.94254H13.4015V6.3457Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.41 6.94949H13.0912V6.33631L13.4018 6.32812V6.94949H13.41ZM13.3937 6.33631H13.083V6.93313H13.3855V6.33631H13.3937Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.0674 6.11636H13.4189C13.4353 6.0019 13.3127 5.87109 13.2472 5.87109C13.1818 5.87109 13.0674 6.0019 13.0674 6.11636Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4271 6.13272H13.0674C13.0674 6.01009 13.1655 5.87109 13.2391 5.87109C13.2718 5.87109 13.3126 5.90379 13.3535 5.94467C13.4026 6.0019 13.4353 6.06732 13.4271 6.13272ZM13.2472 5.88744C13.1818 5.88744 13.0755 6.01826 13.0755 6.12454H13.4107C13.4107 6.06731 13.3862 6.00191 13.3454 5.95286C13.3126 5.91198 13.2718 5.89562 13.2472 5.89562V5.88744Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4859 6.20703H15.167V6.28061H15.4859V6.20703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4862 6.28879H15.1673V6.20703H15.4862V6.29695V6.28879ZM15.4698 6.20703H15.1592V6.28061H15.4617V6.20703H15.4698Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4859 6.3457H15.167V6.95073H15.4859V6.3457Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4862 6.95728H15.1673V6.3441L15.4862 6.33594V6.95728ZM15.4698 6.3441H15.1592V6.94912H15.4617V6.3441H15.4698Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.1436 6.12417H15.4951C15.5115 6.00971 15.3888 5.87891 15.3234 5.87891C15.258 5.87891 15.1436 6.00971 15.1436 6.12417Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5037 6.1331H15.144C15.1358 6.01046 15.2421 5.87146 15.3239 5.86328C15.3647 5.86328 15.3975 5.89598 15.4383 5.93686C15.4874 5.99409 15.5119 6.05951 15.5119 6.12491L15.5037 6.1331ZM15.3239 5.89599C15.2585 5.89599 15.1522 6.01864 15.1522 6.1331H15.4874C15.4874 6.06769 15.4628 6.01044 15.422 5.96139C15.3893 5.92051 15.3484 5.90418 15.3239 5.90418V5.89599Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4015 6.20703H13.0908V6.28061H13.4015V6.20703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.41 6.2794H13.0912V6.19764L13.4018 6.18945V6.2794H13.41ZM13.3937 6.19764H13.083V6.27122H13.3855V6.19764H13.3937Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4015 6.3457H13.0908V6.94254H13.4015V6.3457Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.41 6.94949H13.0912V6.33631L13.4018 6.32812V6.94949H13.41ZM13.3937 6.33631H13.083V6.93313H13.3855V6.33631H13.3937Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.0674 6.11636H13.4189C13.4353 6.0019 13.3127 5.87109 13.2472 5.87109C13.1818 5.87109 13.0674 6.0019 13.0674 6.11636Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4271 6.13272H13.0674C13.0674 6.01009 13.1655 5.87109 13.2391 5.87109C13.2718 5.87109 13.3126 5.90379 13.3535 5.94467C13.4026 6.0019 13.4353 6.06732 13.4271 6.13272ZM13.2472 5.88744C13.1818 5.88744 13.0755 6.01826 13.0755 6.12454H13.4107C13.4107 6.06731 13.3862 6.00191 13.3454 5.95286C13.3126 5.91198 13.2718 5.89562 13.2472 5.89562V5.88744Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4859 6.20703H15.167V6.28061H15.4859V6.20703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4862 6.28879H15.1673V6.20703H15.4862V6.29695V6.28879ZM15.4698 6.20703H15.1592V6.28061H15.4617V6.20703H15.4698Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4859 6.3457H15.167V6.95073H15.4859V6.3457Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4862 6.95728H15.1673V6.3441L15.4862 6.33594V6.95728ZM15.4698 6.3441H15.1592V6.94912H15.4617V6.3441H15.4698Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.1436 6.12417H15.4951C15.5115 6.00971 15.3888 5.87891 15.3234 5.87891C15.258 5.87891 15.1436 6.00971 15.1436 6.12417Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5037 6.1331H15.144C15.1358 6.01046 15.2421 5.87146 15.3239 5.86328C15.3647 5.86328 15.3975 5.89598 15.4383 5.93686C15.4874 5.99409 15.5119 6.05951 15.5119 6.12491L15.5037 6.1331ZM15.3239 5.89599C15.2585 5.89599 15.1522 6.01864 15.1522 6.1331H15.4874C15.4874 6.06769 15.4628 6.01044 15.422 5.96139C15.3893 5.92051 15.3484 5.90418 15.3239 5.90418V5.89599Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4859 6.3457H15.167V6.95073H15.4859V6.3457Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4859 6.20703H15.167V6.28061H15.4859V6.20703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.1436 6.12417H15.4951C15.5115 6.00971 15.3888 5.87891 15.3234 5.87891C15.258 5.87891 15.1436 6.00971 15.1436 6.12417Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.8291 7.04728L13.0253 7.26802H15.5271L15.7314 7.04728H15.0856L14.7831 6.82652L13.7775 6.81836L13.4831 7.04728H12.8291Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.8291 7.04728L13.0253 7.26802H15.5271L15.7314 7.04728H15.0856L14.7831 6.82652L13.7775 6.81836L13.4831 7.04728H12.8291Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4015 6.3457H13.0908V6.94254H13.4015V6.3457Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4015 6.20703H13.0908V6.28061H13.4015V6.20703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.0674 6.11636H13.4189C13.4353 6.0019 13.3127 5.87109 13.2472 5.87109C13.1818 5.87109 13.0674 6.0019 13.0674 6.11636Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.8438 6.80271C13.7212 6.71277 13.6967 6.60649 13.6885 6.42663C13.6885 6.14865 13.8765 5.93609 14.1627 5.92792C14.1954 5.92792 14.2281 5.8952 14.2363 5.86249C14.2363 5.83797 14.2444 5.82161 14.2526 5.80526C14.2526 5.77256 14.2608 5.74805 14.2853 5.74805C14.2853 5.74805 14.3098 5.77256 14.318 5.80526C14.318 5.82161 14.3262 5.84615 14.3344 5.87068C14.3344 5.89521 14.3752 5.91974 14.4079 5.92792C14.6369 5.93609 14.874 6.09142 14.874 6.42663C14.874 6.52474 14.8413 6.7373 14.7186 6.80271H13.8438ZM14.2853 5.77257C14.2853 5.77257 14.2771 5.78891 14.269 5.80526C14.269 5.82161 14.269 5.84615 14.2526 5.87068C14.2362 5.91156 14.1954 5.94426 14.1545 5.94426C13.8847 5.96061 13.6967 6.15683 13.7048 6.42663C13.7048 6.60649 13.7375 6.70461 13.8438 6.78636H14.7104C14.8167 6.72913 14.8494 6.54109 14.8494 6.42663C14.8494 6.10777 14.6205 5.95243 14.3998 5.94426C14.3589 5.94426 14.318 5.91157 14.3098 5.87886C14.3017 5.85434 14.2935 5.82979 14.2935 5.81344C14.2935 5.78891 14.2935 5.77257 14.2853 5.77257Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.8523 6.79383H14.7189C14.8333 6.72842 14.866 6.53219 14.866 6.41773C14.866 6.09887 14.6371 5.93537 14.4082 5.9272C14.3755 5.9272 14.3346 5.89449 14.3183 5.86996C14.2938 5.80455 14.3019 5.76367 14.2774 5.76367C14.261 5.76367 14.2611 5.80455 14.2365 5.86178C14.2283 5.89448 14.1875 5.92718 14.1466 5.93536C13.8604 5.95171 13.6806 6.1561 13.6887 6.41773C13.6887 6.58942 13.7133 6.7039 13.8359 6.79383H13.8523Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.966 6.05091C13.9006 6.07544 13.8516 6.15718 13.8189 6.23894C13.7862 6.32887 13.778 6.427 13.7862 6.50875C13.7862 6.50875 13.7943 6.54964 13.8107 6.56599C13.8107 6.58234 13.827 6.59052 13.8434 6.59052C13.8597 6.59052 13.8679 6.5905 13.8761 6.57415C13.8761 6.56597 13.8761 6.54964 13.8761 6.54146C13.8761 6.45971 13.8761 6.37794 13.8924 6.30436C13.9088 6.23078 13.9497 6.16536 14.0151 6.11631C14.0314 6.10813 14.0396 6.09997 14.0396 6.08362C14.0396 6.06727 14.0396 6.05907 14.0314 6.05907C14.0151 6.04272 13.9905 6.03456 13.966 6.05091ZM13.9742 6.06725C13.9742 6.06725 14.0069 6.06725 14.0151 6.06725C14.0151 6.06725 14.0151 6.06726 14.0151 6.07544C14.0151 6.07544 14.0151 6.09178 14.0069 6.09178C13.9333 6.14901 13.8924 6.21442 13.8679 6.29617C13.8434 6.36976 13.8434 6.45971 13.8516 6.54146V6.55781C13.8516 6.55781 13.8434 6.55781 13.8352 6.54146C13.8352 6.53329 13.8189 6.50876 13.8189 6.49241C13.8025 6.41065 13.8189 6.32071 13.8434 6.23078C13.8761 6.14902 13.9252 6.07544 13.9824 6.05091L13.9742 6.06725Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.0811 6.1408C14.0156 6.16533 13.9748 6.23891 13.9502 6.32067C13.9257 6.40242 13.9257 6.50054 13.9421 6.5823C13.9502 6.63953 13.9829 6.67222 14.0156 6.67222C14.0238 6.67222 14.0402 6.67223 14.0483 6.65588C14.0483 6.63953 14.0565 6.63135 14.0483 6.60682C14.032 6.54142 14.0238 6.45967 14.0483 6.38609C14.0483 6.31251 14.0892 6.2471 14.1464 6.20622C14.1628 6.19804 14.171 6.18987 14.171 6.18169C14.171 6.16534 14.171 6.15716 14.1546 6.14898C14.1383 6.13263 14.1138 6.13263 14.0892 6.14898L14.0811 6.1408ZM14.0811 6.15717C14.0811 6.15717 14.1137 6.15717 14.1219 6.15717C14.1219 6.15717 14.1219 6.15715 14.1219 6.16533C14.1219 6.16533 14.1219 6.17352 14.1056 6.18169C14.0402 6.22257 14.0156 6.29615 13.9993 6.3779C13.9911 6.45149 13.9993 6.54142 14.0156 6.60682C14.0156 6.62318 14.0156 6.63953 14.0156 6.63953C14.0156 6.63953 14.0156 6.64771 13.9993 6.63953C13.9829 6.63953 13.9584 6.61501 13.9421 6.56596C13.9257 6.49237 13.9339 6.39425 13.9502 6.32067C13.9748 6.23891 14.0156 6.17351 14.0729 6.14898L14.0811 6.15717Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.6039 6.05078C14.6039 6.05078 14.5548 6.05078 14.5385 6.05078C14.5385 6.05078 14.5303 6.06714 14.5303 6.08349C14.5303 6.09984 14.5384 6.108 14.5548 6.11618C14.6284 6.17341 14.6611 6.23065 14.6856 6.30423C14.702 6.37781 14.702 6.45958 14.702 6.54133C14.702 6.54951 14.702 6.56584 14.702 6.57402C14.702 6.58219 14.7183 6.59039 14.7347 6.59039C14.7428 6.59039 14.7592 6.58221 14.7674 6.56586C14.7756 6.54951 14.7837 6.53315 14.7919 6.50862C14.8083 6.42687 14.7919 6.32874 14.7674 6.23881C14.7347 6.14887 14.6856 6.07531 14.612 6.05078H14.6039ZM14.6039 6.06712C14.6611 6.09165 14.7101 6.16523 14.7428 6.24699C14.7756 6.32875 14.7837 6.42687 14.7674 6.50862C14.7674 6.53315 14.7592 6.5495 14.751 6.55768C14.751 6.56585 14.7428 6.57402 14.7347 6.57402H14.7265C14.7265 6.57402 14.7265 6.55767 14.7265 6.54949C14.7265 6.46773 14.7265 6.37781 14.7101 6.30423C14.6856 6.22247 14.6529 6.15706 14.5712 6.09983L14.563 6.08349C14.563 6.08349 14.563 6.0753 14.563 6.06712C14.563 6.06712 14.5875 6.05895 14.6039 6.06712Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.489 6.14062C14.489 6.14062 14.4399 6.14062 14.4235 6.14062C14.4235 6.14062 14.4072 6.15698 14.4154 6.17334C14.4154 6.18151 14.4236 6.18969 14.4399 6.20605C14.4971 6.24692 14.5298 6.31233 14.538 6.38591C14.5544 6.4595 14.538 6.54942 14.5298 6.60665C14.5298 6.63118 14.5298 6.63935 14.5298 6.6557C14.538 6.67206 14.5544 6.67205 14.5707 6.67205C14.6034 6.67205 14.6279 6.63936 14.6443 6.58212C14.6606 6.50854 14.6525 6.41043 14.6361 6.32049C14.6116 6.23874 14.5707 6.17333 14.4971 6.14062H14.489ZM14.4808 6.15699C14.538 6.18152 14.5789 6.24691 14.6034 6.32049C14.6279 6.40225 14.6279 6.4922 14.6034 6.56578C14.6034 6.61484 14.5707 6.63936 14.5543 6.63936H14.538C14.538 6.63119 14.5298 6.623 14.538 6.60665C14.5544 6.54124 14.5625 6.45949 14.5462 6.37773C14.538 6.30415 14.5053 6.23057 14.4481 6.18152C14.4317 6.18152 14.4317 6.16515 14.4317 6.16515C14.4317 6.16515 14.4317 6.16517 14.4317 6.15699C14.4399 6.14882 14.4644 6.14064 14.4726 6.15699H14.4808Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4287 9.8694H16.1404L15.8052 9.59961H12.7639L12.4287 9.8694Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4287 9.8694H16.1404L15.8052 9.59961H12.7639L12.4287 9.8694Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4267 7.44141H13.0752V7.9238H13.4267V7.44141Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4349 7.93072H13.0752V7.43201L13.4267 7.42383V7.93072H13.4349ZM13.4186 7.43201H13.0752L13.0834 7.91438H13.4186V7.43201Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4342 8.20117H13.0908V8.30744H13.4342V8.20117Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4424 8.31562H13.0908V8.20117H13.4342V8.3238L13.4424 8.31562ZM13.426 8.20117H13.0908L13.099 8.30744H13.4178V8.20117H13.426Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4346 8.38086H13.083V8.76512H13.4346V8.38086Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4427 8.77365H13.083V8.38123L13.4346 8.37305V8.77365H13.4427ZM13.4264 8.38123H13.083V8.76549H13.4182V8.38123H13.4264Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4419 8.84766H13.0576V9.06023H13.4419V8.84766Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4501 9.06681H13.0658V8.84605L13.4501 8.83789V9.06681ZM13.4337 8.84605H13.0576V9.05863H13.4255V8.84605H13.4337Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.107 8.11178H13.4095L13.475 8.01367H13.0498L13.107 8.11178Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4181 8.11873H13.1074L13.042 8.01244L13.4753 7.99609L13.4181 8.11054V8.11873ZM13.4671 8.00425L13.0502 8.02062L13.1156 8.11054H13.4099L13.4753 8.00425H13.4671Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.5244 7.73466V7.46484H13.737C13.6552 7.53843 13.5735 7.6202 13.5244 7.73466Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.5232 7.74284H13.5068V7.46484H13.7276C13.6377 7.55478 13.5641 7.63656 13.5232 7.74284ZM13.7276 7.46484L13.5232 7.48121V7.70195C13.5804 7.61201 13.6458 7.53843 13.7276 7.46484Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4869 7.44141H15.1436V7.9238H15.4869V7.44141Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4949 7.93133H15.1433L15.127 7.43262H15.4867V7.93133H15.4949ZM15.4785 7.43262H15.1433L15.1515 7.91499H15.4785V7.43262Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4788 8.20117H15.1436V8.30744H15.4788V8.20117Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4869 8.31562H15.1436V8.20117H15.4788V8.3238L15.4869 8.31562ZM15.4706 8.20117H15.1436V8.30744H15.4624V8.20117H15.4706Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4869 8.38086H15.1436V8.76512H15.4869V8.38086Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4948 8.77365H15.1514V8.38123L15.4948 8.37305V8.77365ZM15.4784 8.38123H15.1514V8.76549H15.4784V8.38123Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5108 8.84668H15.1348V9.05926H15.5108V8.84668Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.519 9.06779H15.1348V8.84703L15.5108 8.83887V9.06779H15.519ZM15.5027 8.84703H15.1348V9.0596H15.4945V8.84703H15.5027Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4548 8.11178H15.1523L15.0869 8.01367H15.5039L15.4548 8.11178Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4532 8.11873H15.1425L15.0771 8.01244L15.4941 7.99609L15.445 8.11054L15.4532 8.11873ZM15.4941 8.00425L15.0853 8.02062L15.1507 8.11054H15.4369L15.4859 8.00425H15.4941Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0456 7.73466V7.46484H14.833C14.9148 7.53843 14.9965 7.6202 15.0456 7.73466Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0377 7.74319C14.9969 7.6369 14.9233 7.55513 14.8252 7.47337L15.0377 7.45703L15.0541 7.73501H15.0377V7.74319ZM15.0377 7.47337H14.8415C14.9315 7.54696 14.9969 7.62055 15.0459 7.71048V7.47337H15.0377Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4267 7.44141H13.0752V7.9238H13.4267V7.44141Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4349 7.93072H13.0752V7.43201L13.4267 7.42383V7.93072H13.4349ZM13.4186 7.43201H13.0752L13.0834 7.91438H13.4186V7.43201Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4342 8.20117H13.0908V8.30744H13.4342V8.20117Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4424 8.31562H13.0908V8.20117H13.4342V8.3238L13.4424 8.31562ZM13.426 8.20117H13.0908L13.099 8.30744H13.4178V8.20117H13.426Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4346 8.38086H13.083V8.76512H13.4346V8.38086Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4427 8.77365H13.083V8.38123L13.4346 8.37305V8.77365H13.4427ZM13.4264 8.38123H13.083V8.76549H13.4182V8.38123H13.4264Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4419 8.84766H13.0576V9.06023H13.4419V8.84766Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4501 9.06681H13.0658V8.84605L13.4501 8.83789V9.06681ZM13.4337 8.84605H13.0576V9.05863H13.4255V8.84605H13.4337Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.107 8.11178H13.4095L13.475 8.01367H13.0498L13.107 8.11178Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4181 8.11873H13.1074L13.042 8.01244L13.4753 7.99609L13.4181 8.11054V8.11873ZM13.4671 8.00425L13.0502 8.02062L13.1156 8.11054H13.4099L13.4753 8.00425H13.4671Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.5244 7.73466V7.46484H13.737C13.6552 7.53843 13.5735 7.6202 13.5244 7.73466Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.5232 7.74284H13.5068V7.46484H13.7276C13.6377 7.55478 13.5641 7.63656 13.5232 7.74284ZM13.7276 7.46484L13.5232 7.48121V7.70195C13.5804 7.61201 13.6458 7.53843 13.7276 7.46484Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4869 7.44141H15.1436V7.9238H15.4869V7.44141Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4949 7.93133H15.1433L15.127 7.43262H15.4867V7.93133H15.4949ZM15.4785 7.43262H15.1433L15.1515 7.91499H15.4785V7.43262Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4788 8.20117H15.1436V8.30744H15.4788V8.20117Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4869 8.31562H15.1436V8.20117H15.4788V8.3238L15.4869 8.31562ZM15.4706 8.20117H15.1436V8.30744H15.4624V8.20117H15.4706Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4869 8.38086H15.1436V8.76512H15.4869V8.38086Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4948 8.77365H15.1514V8.38123L15.4948 8.37305V8.77365ZM15.4784 8.38123H15.1514V8.76549H15.4784V8.38123Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5108 8.84668H15.1348V9.05926H15.5108V8.84668Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.519 9.06779H15.1348V8.84703L15.5108 8.83887V9.06779H15.519ZM15.5027 8.84703H15.1348V9.0596H15.4945V8.84703H15.5027Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4548 8.11178H15.1523L15.0869 8.01367H15.5039L15.4548 8.11178Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4532 8.11873H15.1425L15.0771 8.01244L15.4941 7.99609L15.445 8.11054L15.4532 8.11873ZM15.4941 8.00425L15.0853 8.02062L15.1507 8.11054H15.4369L15.4859 8.00425H15.4941Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0456 7.73466V7.46484H14.833C14.9148 7.53843 14.9965 7.6202 15.0456 7.73466Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0377 7.74319C14.9969 7.6369 14.9233 7.55513 14.8252 7.47337L15.0377 7.45703L15.0541 7.73501H15.0377V7.74319ZM15.0377 7.47337H14.8415C14.9315 7.54696 14.9969 7.62055 15.0459 7.71048V7.47337H15.0377Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.3366 7.89754L13.3039 7.88119V7.59504C13.3039 7.59504 13.214 7.57868 13.2058 7.59504C13.2058 7.65227 13.2058 7.72585 13.2058 7.79943V7.84848C13.2058 7.84848 13.124 7.91389 13.124 7.84848V7.55417C13.124 7.46423 13.3203 7.46424 13.3693 7.5133C13.3857 7.52965 13.3938 7.54599 13.3938 7.55417C13.3938 7.62775 13.3938 7.77492 13.3938 7.86485C13.3693 7.89755 13.3611 7.90572 13.3448 7.90572L13.3366 7.89754ZM13.2467 7.56235C13.2467 7.56235 13.2875 7.56234 13.3039 7.57869V7.85667L13.3366 7.88938L13.3611 7.87301C13.3611 7.76672 13.3611 7.61957 13.3611 7.54598C13.2875 7.4397 13.1322 7.48058 13.1322 7.54598V7.84032C13.1322 7.84032 13.1813 7.85668 13.1813 7.84032V7.79127C13.1813 7.71769 13.1813 7.6441 13.1813 7.60322C13.2058 7.56234 13.2221 7.56235 13.2385 7.56235H13.2467Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4053 7.90689L15.3726 7.89054L15.3563 7.60439C15.3563 7.60439 15.2827 7.57986 15.2663 7.60439C15.2663 7.66162 15.2663 7.7352 15.2663 7.80878V7.86602C15.2663 7.86602 15.2418 7.90689 15.2254 7.90689C15.2254 7.90689 15.1927 7.89055 15.1846 7.86602V7.57168C15.1846 7.47357 15.3808 7.48175 15.4298 7.53081C15.438 7.54716 15.4462 7.55533 15.4462 7.57168V7.88236C15.4462 7.88236 15.4135 7.92325 15.4053 7.92325V7.90689ZM15.3154 7.57168C15.3154 7.57168 15.3644 7.57169 15.3726 7.58804V7.86602L15.4053 7.8987L15.4298 7.88236V7.56352C15.3644 7.44906 15.2091 7.48994 15.2091 7.56352V7.85783C15.2091 7.85783 15.2581 7.89054 15.2581 7.85783V7.8006C15.2581 7.73519 15.2581 7.66163 15.2581 7.61257C15.2827 7.57169 15.3072 7.57168 15.3154 7.57168Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.3857 8.7489H13.1322V8.43006L13.3775 8.42188V8.7489H13.3857ZM13.3693 8.43006H13.124V8.74074H13.3611V8.43006H13.3693Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.378 8.56055H13.2881V8.6096H13.378V8.56055Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2218 8.56055H13.1318V8.6096H13.2218V8.56055Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2871 8.4375H13.2217V8.56016H13.2871V8.4375Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2956 8.56903H13.222L13.2139 8.43822L13.2874 8.42188L13.2956 8.56903Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2871 8.60938H13.2217V8.74019H13.2871V8.60938Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2956 8.74872H13.222L13.2139 8.60975L13.2874 8.60156L13.2956 8.74872Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.454 8.74111H15.1924V8.42225L15.4377 8.41406V8.74111H15.4458H15.454ZM15.4377 8.42225H15.2006V8.73293H15.4377V8.42225Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4363 8.55273H15.3545V8.60179H15.4363V8.55273Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.2901 8.55273H15.2002V8.60179H15.2901V8.55273Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.3476 8.42969H15.2822V8.5605H15.3476V8.42969Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.3562 8.56903H15.2826L15.2744 8.43006L15.3562 8.42188V8.56903Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.3476 8.60938H15.2822V8.74019H15.3476V8.60938Z",
            fill: "black"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.3562 8.74909H15.2826L15.2744 8.61012L15.3562 8.59375V8.74909Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0048 8.44531H14.9639V8.756H15.0048V8.44531Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0129 8.7649H14.9639V8.44603L15.0048 8.42969V8.75671H15.0129V8.7649ZM14.9966 8.44603H14.9639L14.9721 8.75671H14.9966V8.44603Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.129 8.85432L14.1944 9.05872H14.3498L14.2271 8.85432H14.129ZM14.0391 9.05872L14.08 9.26311H14.2598L14.1944 9.05872H14.0391ZM14.3416 9.05872L14.4642 9.25493H14.7259L14.5215 9.05053H14.3416V9.05872ZM12.8291 9.51656C12.9599 9.38575 13.0498 9.27945 13.0498 9.12411H13.385C13.385 9.21405 13.4177 9.26311 13.4668 9.26311H13.802V9.05872H13.5567V7.97951C13.5485 7.59525 14.0227 7.37451 14.2108 7.37451H13.058V7.3418H15.4862V7.37451H14.3171C14.6605 7.37451 14.9957 7.70971 15.0038 7.98769V8.29019H14.9629V7.98769C14.9629 7.67701 14.5787 7.39904 14.2762 7.40722C14.0146 7.40722 13.5976 7.66883 13.6058 7.97951V8.07761H14.2353V8.1839L14.3252 8.24932L14.5215 8.31472V8.47824L14.6604 8.51911V8.68264L14.8321 8.75622V8.9279L14.9384 8.99332V9.16501L15.0774 9.2713H14.734L14.9466 9.50838H14.6277L14.4724 9.2713H14.268L14.3579 9.50838H14.1372L14.08 9.2713H13.8102V9.52474H12.8373L12.8291 9.51656ZM13.802 8.86251V9.05872H14.0391L13.99 8.86251H13.802Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.819 9.52546H12.8379C12.9687 9.3783 13.0504 9.28017 13.0504 9.12483H13.3938C13.3938 9.19841 13.4265 9.24749 13.4674 9.24749H13.8026L13.7862 9.05944H13.5573L13.5492 7.98023C13.5492 7.84941 13.5982 7.71861 13.7045 7.61233C13.8517 7.45699 14.0724 7.36704 14.2114 7.36704L13.0668 7.38341V7.34251L15.495 7.32617V7.37522L14.3749 7.38341C14.7183 7.39976 15.0208 7.7186 15.0208 7.98023V8.28273H14.9635L14.9554 7.98023C14.9554 7.67772 14.5875 7.40793 14.285 7.40793C14.007 7.40793 13.6064 7.66956 13.6146 7.97207V8.07017H14.2277V8.18462L14.3177 8.24186L14.5139 8.29909V8.47078L14.6529 8.50349V8.67517L14.8246 8.73241V8.91228L14.9309 8.96951V9.1412L15.0698 9.2393L14.7183 9.25565L14.939 9.47641L14.612 9.49275L14.4485 9.24749H14.2523L14.3504 9.47641L14.1214 9.49275L14.0561 9.24749H13.7944L13.8108 9.50909L13.819 9.52546ZM13.3775 9.12483L13.0586 9.1412C13.0586 9.28836 12.985 9.40282 12.846 9.52546L13.8026 9.50909V9.26383L14.0806 9.24749L14.0315 9.05944H13.8108V8.85504H14.007L14.0561 9.05944H14.2032L14.1214 8.87138L14.2277 8.85504L14.3586 9.05944L14.195 9.07578L14.2686 9.26383L14.0888 9.28017L14.146 9.50093H14.3586L14.2523 9.27201L14.4567 9.25565L14.334 9.06762L14.5302 9.05125L14.7346 9.24749L14.4812 9.26383L14.6365 9.49275H14.9472L14.7265 9.26383L15.078 9.24749L14.9227 9.16572V8.98586L14.8164 8.92862V8.74875L14.6447 8.69151V8.51983L14.5057 8.48712V8.31544L14.3177 8.2582L14.2196 8.1928V8.07833H13.5982V7.98023C13.5982 7.65319 14.007 7.39975 14.2768 7.39975C14.5956 7.39975 14.9799 7.66955 14.9799 7.98841V8.29091H15.0126V7.98841C15.0126 7.71861 14.6938 7.39157 14.334 7.39157H14.3749L15.5031 7.36704L15.4868 7.34251H13.0668L13.075 7.37522H14.2114C14.0888 7.3834 13.8598 7.47333 13.7209 7.62867C13.6146 7.73496 13.5655 7.84941 13.5655 7.98023V9.05944H13.8026L13.8108 9.25565L13.4674 9.27201C13.4102 9.27201 13.3775 9.21476 13.3775 9.12483ZM14.0479 9.06762L14.0888 9.25565H14.2604L14.1869 9.05944H14.3504L14.2196 8.85504H14.1296L14.2032 9.05125H14.0479V9.06762ZM14.5139 9.07578H14.3422L14.473 9.26383H14.7183L14.5139 9.07578ZM13.8108 8.87138V9.05944H14.0233H14.0315L13.9743 8.87138H13.8108Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.129 8.85432L14.1944 9.05872H14.3498L14.2271 8.85432H14.129ZM14.0391 9.05872L14.08 9.26311H14.2598L14.1944 9.05872H14.0391ZM14.3416 9.05872L14.4642 9.25493H14.7259L14.5215 9.05053H14.3416V9.05872ZM12.8291 9.51656C12.9599 9.38575 13.0498 9.27945 13.0498 9.12411H13.385C13.385 9.21405 13.4177 9.26311 13.4668 9.26311H13.802V9.05872H13.5567V7.97951C13.5485 7.59525 14.0227 7.37451 14.2108 7.37451H13.058V7.3418H15.4862V7.37451H14.3171C14.6605 7.37451 14.9957 7.70971 15.0038 7.98769V8.29019H14.9629V7.98769C14.9629 7.67701 14.5787 7.39904 14.2762 7.40722C14.0146 7.40722 13.5976 7.66883 13.6058 7.97951V8.07761H14.2353V8.1839L14.3252 8.24932L14.5215 8.31472V8.47824L14.6604 8.51911V8.68264L14.8321 8.75622V8.9279L14.9384 8.99332V9.16501L15.0774 9.2713H14.734L14.9466 9.50838H14.6277L14.4724 9.2713H14.268L14.3579 9.50838H14.1372L14.08 9.2713H13.8102V9.52474H12.8373L12.8291 9.51656ZM13.802 8.86251V9.05872H14.0391L13.99 8.86251H13.802Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.819 9.52546H12.8379C12.9687 9.3783 13.0504 9.28017 13.0504 9.12483H13.3938C13.3938 9.19841 13.4265 9.24749 13.4674 9.24749H13.8026L13.7862 9.05944H13.5573L13.5492 7.98023C13.5492 7.84941 13.5982 7.71861 13.7045 7.61233C13.8517 7.45699 14.0724 7.36704 14.2114 7.36704L13.0668 7.38341V7.34251L15.495 7.32617V7.37522L14.3749 7.38341C14.7183 7.39976 15.0208 7.7186 15.0208 7.98023V8.28273H14.9635L14.9554 7.98023C14.9554 7.67772 14.5875 7.40793 14.285 7.40793C14.007 7.40793 13.6064 7.66956 13.6146 7.97207V8.07017H14.2277V8.18462L14.3177 8.24186L14.5139 8.29909V8.47078L14.6529 8.50349V8.67517L14.8246 8.73241V8.91228L14.9309 8.96951V9.1412L15.0698 9.2393L14.7183 9.25565L14.939 9.47641L14.612 9.49275L14.4485 9.24749H14.2523L14.3504 9.47641L14.1214 9.49275L14.0561 9.24749H13.7944L13.8108 9.50909L13.819 9.52546ZM13.3775 9.12483L13.0586 9.1412C13.0586 9.28836 12.985 9.40282 12.846 9.52546L13.8026 9.50909V9.26383L14.0806 9.24749L14.0315 9.05944H13.8108V8.85504H14.007L14.0561 9.05944H14.2032L14.1214 8.87138L14.2277 8.85504L14.3586 9.05944L14.195 9.07578L14.2686 9.26383L14.0888 9.28017L14.146 9.50093H14.3586L14.2523 9.27201L14.4567 9.25565L14.334 9.06762L14.5302 9.05125L14.7346 9.24749L14.4812 9.26383L14.6365 9.49275H14.9472L14.7265 9.26383L15.078 9.24749L14.9227 9.16572V8.98586L14.8164 8.92862V8.74875L14.6447 8.69151V8.51983L14.5057 8.48712V8.31544L14.3177 8.2582L14.2196 8.1928V8.07833H13.5982V7.98023C13.5982 7.65319 14.007 7.39975 14.2768 7.39975C14.5956 7.39975 14.9799 7.66955 14.9799 7.98841V8.29091H15.0126V7.98841C15.0126 7.71861 14.6938 7.39157 14.334 7.39157H14.3749L15.5031 7.36704L15.4868 7.34251H13.0668L13.075 7.37522H14.2114C14.0888 7.3834 13.8598 7.47333 13.7209 7.62867C13.6146 7.73496 13.5655 7.84941 13.5655 7.98023V9.05944H13.8026L13.8108 9.25565L13.4674 9.27201C13.4102 9.27201 13.3775 9.21476 13.3775 9.12483ZM14.0479 9.06762L14.0888 9.25565H14.2604L14.1869 9.05944H14.3504L14.2196 8.85504H14.1296L14.2032 9.05125H14.0479V9.06762ZM14.5139 9.07578H14.3422L14.473 9.26383H14.7183L14.5139 9.07578ZM13.8108 8.87138V9.05944H14.0233H14.0315L13.9743 8.87138H13.8108Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.9737 8.84704H13.8184V8.50367L13.9655 8.4873V8.83888L13.9737 8.84704ZM13.9574 8.50367H13.8184L13.8265 8.83888H13.9492V8.50367H13.9574Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.0152 8.87085V8.60924C14.0152 8.50296 13.9417 8.41301 13.9008 8.41301C13.8599 8.41301 13.77 8.51929 13.77 8.6174V8.86269L13.6228 8.87903L13.6064 8.23314L14.1788 8.2168V8.86269L14.0152 8.87903V8.87085ZM14.1706 8.22498L13.6228 8.24132V8.85451H13.7618V8.6174C13.7536 8.51112 13.8517 8.39666 13.9008 8.38848C13.958 8.38848 14.0316 8.49478 14.0398 8.60924V8.85451H14.1869V8.23314H14.1788L14.1706 8.22498Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.923 9.14948H14.7432V9.0023L14.9148 8.99414V9.14948H14.923ZM14.9067 9.0023L14.7432 9.01867V9.1413L14.9067 9.13312V9.0023Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.8238 8.92094H14.6357V8.77378L14.8074 8.76562V8.92094H14.8156H14.8238ZM14.8074 8.77378H14.6439L14.6521 8.91278H14.8074V8.77378Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.6519 8.68269H14.4639V8.53553L14.6437 8.52734V8.69084H14.6519V8.68269ZM14.6274 8.53553H14.4639V8.6745H14.6192V8.53553H14.6274Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.5042 8.48735H14.3162L14.2998 8.34019H14.4879L14.496 8.48735H14.5042ZM14.4797 8.34019H14.3162V8.47919L14.4715 8.46282V8.33203L14.4797 8.34019Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7172 9.17496L14.3738 8.87243H14.2021V8.22656L14.2921 8.28377V8.48817L14.4474 8.52906V8.6844L14.6027 8.76617V8.90514L14.709 8.97872V9.17496H14.7172ZM14.382 8.85609L14.6927 9.12588V8.97872L14.5864 8.90514V8.76617L14.4311 8.6844V8.52906L14.2839 8.48817V8.28377L14.2021 8.22656V8.84791H14.382V8.85609Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0048 8.44531H14.9639V8.756H15.0048V8.44531Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.0129 8.7649H14.9639V8.44603L15.0048 8.42969V8.75671H15.0129V8.7649ZM14.9966 8.44603H14.9639L14.9721 8.75671H14.9966V8.44603Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8313 5.31445C11.8476 5.55973 11.7741 5.69054 11.6351 5.67419C11.6024 5.5352 11.6841 5.44527 11.8313 5.31445Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6669 5.67493H11.6423C11.6015 5.51959 11.6832 5.42964 11.8304 5.29883C11.8549 5.45417 11.8304 5.56863 11.7732 5.63404C11.7404 5.65857 11.7077 5.67493 11.6669 5.67493ZM11.8222 5.30701C11.7077 5.43782 11.6178 5.52775 11.6505 5.65856H11.6669C11.6669 5.65856 11.7323 5.64222 11.7568 5.6177C11.8059 5.56047 11.8304 5.45418 11.8222 5.30701Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5454 5.85508C11.4309 5.79785 11.5127 5.3482 11.5617 5.16016C11.5944 5.40543 11.6517 5.74879 11.5454 5.85508Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5453 5.86326C11.4145 5.79786 11.529 5.27462 11.5453 5.16016L11.5699 5.20921C11.6026 5.45448 11.6435 5.75698 11.5453 5.86326ZM11.5453 5.16016C11.5126 5.38908 11.4472 5.77333 11.5453 5.83874C11.6353 5.74063 11.5862 5.42995 11.5617 5.20103V5.16016H11.5453Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5877 5.87059C11.7839 5.936 11.9311 5.7316 11.9883 5.48633C11.8248 5.70707 11.5713 5.70708 11.5877 5.87059Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6602 5.89609C11.6602 5.89609 11.6112 5.8961 11.5785 5.87975C11.5621 5.78164 11.6357 5.74075 11.7256 5.6917C11.8074 5.65082 11.8973 5.59359 11.9709 5.4873C11.9463 5.6917 11.8237 5.89609 11.652 5.89609H11.6602ZM11.9709 5.4873C11.9136 5.60177 11.8156 5.65083 11.7338 5.69988C11.6439 5.74894 11.5784 5.78981 11.5866 5.87157C11.603 5.87157 11.6275 5.87975 11.652 5.87975C11.8074 5.87975 11.9218 5.68352 11.9627 5.4873H11.9709Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4393 6.09962C11.284 6.05874 11.3821 5.58453 11.4067 5.39648C11.4394 5.5927 11.5456 6.03421 11.4393 6.09962Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4395 6.1078C11.3005 6.06692 11.3578 5.69083 11.3905 5.4619L11.4068 5.39648L11.4395 5.50277C11.4804 5.7317 11.5458 6.05057 11.4477 6.1078H11.4395ZM11.3987 5.39648V5.4619C11.3741 5.6663 11.3087 6.05055 11.4395 6.09143C11.5131 6.0342 11.4559 5.69899 11.415 5.50277L11.3987 5.39648Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4873 6.0833C11.4955 5.91979 11.659 5.96884 11.7653 5.87891C11.7489 5.96884 11.6835 6.10783 11.4873 6.0833Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5282 6.09964C11.5282 6.09964 11.5037 6.09964 11.4873 6.09964C11.4873 5.98518 11.5609 5.96065 11.6345 5.93612C11.6835 5.91977 11.7244 5.90343 11.7653 5.87891C11.7653 5.93614 11.7162 6.09964 11.5282 6.09964ZM11.7653 5.87891C11.7326 5.91979 11.6835 5.93613 11.6426 5.9443C11.5691 5.96883 11.5037 5.98519 11.5037 6.0833C11.5037 6.07513 11.52 6.07512 11.5364 6.07512C11.7162 6.07512 11.7653 5.92796 11.7735 5.87891H11.7653Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3088 6.30429C11.1616 6.26341 11.2434 5.74834 11.2434 5.54395C11.2842 5.72381 11.4232 6.25523 11.3088 6.30429Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3091 6.3131C11.1947 6.2804 11.211 6.01059 11.2274 5.7735C11.2274 5.68356 11.2437 5.60996 11.2355 5.55273L11.2601 5.58544C11.3418 5.92883 11.4154 6.27221 11.3173 6.32126L11.3091 6.3131ZM11.2437 5.57726C11.2437 5.63449 11.2437 5.69173 11.2437 5.76531C11.2356 5.98606 11.211 6.26405 11.3091 6.28858C11.4072 6.23952 11.2846 5.7653 11.2437 5.57726Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.374 6.27985C11.4967 6.32073 11.6602 6.23896 11.6683 6.0918C11.5621 6.16538 11.3986 6.10816 11.374 6.27985Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4476 6.30438C11.4476 6.30438 11.3986 6.30437 11.374 6.29619C11.374 6.17355 11.4639 6.14904 11.5457 6.13269C11.5866 6.13269 11.6356 6.11632 11.6683 6.0918C11.6683 6.22261 11.5539 6.30438 11.4394 6.30438H11.4476ZM11.3985 6.28803C11.3985 6.28803 11.4231 6.28803 11.4476 6.28803C11.5457 6.28803 11.6602 6.21444 11.6683 6.09998C11.6356 6.13268 11.5948 6.14086 11.5539 6.14903C11.4721 6.16538 11.4067 6.18174 11.3904 6.27985H11.4067L11.3985 6.28803Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1949 6.53314C11.0477 6.54949 11.1131 6.10801 11.1131 5.69922C11.1622 6.07531 11.3093 6.42686 11.1949 6.53314Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1946 6.54132C11.1946 6.54132 11.1619 6.53315 11.1455 6.5168C11.0801 6.45139 11.0965 6.23882 11.1047 6.00172C11.1047 5.90361 11.1128 5.8055 11.1128 5.69922C11.1455 5.82186 11.1701 5.9363 11.1946 6.04259C11.2437 6.27969 11.2845 6.45956 11.1946 6.53314V6.54132ZM11.121 5.74009C11.121 5.83002 11.121 5.91994 11.121 6.00988C11.121 6.24698 11.1047 6.45139 11.1537 6.5168C11.1619 6.5168 11.1783 6.53314 11.1946 6.53314C11.2682 6.46773 11.2273 6.28786 11.1701 6.06711C11.1537 5.969 11.1292 5.86273 11.1128 5.74827L11.121 5.74009Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2441 6.50871C11.3422 6.54959 11.5139 6.47602 11.563 6.3125C11.3913 6.38608 11.2687 6.31249 11.2441 6.50871Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3095 6.53263C11.3095 6.53263 11.2605 6.53264 11.2441 6.51629C11.2605 6.36913 11.3259 6.36093 11.4077 6.34458C11.4485 6.34458 11.5057 6.32824 11.563 6.30371C11.5303 6.45088 11.4076 6.53263 11.3095 6.53263ZM11.5548 6.31189C11.5058 6.35277 11.4567 6.35275 11.4077 6.36911C11.3177 6.38546 11.2687 6.38548 11.2523 6.51629C11.2605 6.51629 11.285 6.51629 11.3095 6.51629C11.3995 6.51629 11.5139 6.44271 11.5548 6.31189Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8313 5.31445C11.8476 5.55973 11.7741 5.69054 11.6351 5.67419C11.6024 5.5352 11.6841 5.44527 11.8313 5.31445Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6669 5.67493H11.6423C11.6015 5.51959 11.6832 5.42964 11.8304 5.29883C11.8549 5.45417 11.8304 5.56863 11.7732 5.63404C11.7404 5.65857 11.7077 5.67493 11.6669 5.67493ZM11.8222 5.30701C11.7077 5.43782 11.6178 5.52775 11.6505 5.65856H11.6669C11.6669 5.65856 11.7323 5.64222 11.7568 5.6177C11.8059 5.56047 11.8304 5.45418 11.8222 5.30701Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5454 5.85508C11.4309 5.79785 11.5127 5.3482 11.5617 5.16016C11.5944 5.40543 11.6517 5.74879 11.5454 5.85508Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5453 5.86326C11.4145 5.79786 11.529 5.26644 11.5453 5.16016L11.5699 5.20921C11.6026 5.45448 11.6435 5.75698 11.5453 5.86326ZM11.5453 5.16832C11.5126 5.39724 11.4472 5.78151 11.5453 5.84692C11.6353 5.74881 11.5862 5.43813 11.5617 5.20921V5.16832H11.5453Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5877 5.87059C11.7839 5.936 11.9311 5.7316 11.9883 5.48633C11.8248 5.70707 11.5713 5.70708 11.5877 5.87059Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6602 5.89609C11.6602 5.89609 11.6112 5.8961 11.5785 5.87975C11.5621 5.78164 11.6357 5.74075 11.7256 5.6917C11.8074 5.65082 11.8973 5.59359 11.9709 5.4873C11.9463 5.6917 11.8237 5.89609 11.652 5.89609H11.6602ZM11.9709 5.4873C11.9136 5.60177 11.8156 5.65083 11.7338 5.69988C11.6439 5.74894 11.5784 5.78981 11.5866 5.87157C11.603 5.87157 11.6275 5.87975 11.652 5.87975C11.8074 5.87975 11.9218 5.68352 11.9627 5.4873H11.9709Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4393 6.09962C11.284 6.05874 11.3821 5.58453 11.4067 5.39648C11.4394 5.5927 11.5456 6.03421 11.4393 6.09962Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4395 6.10815C11.3005 6.06727 11.3578 5.68299 11.3905 5.45407L11.4068 5.38867L11.4395 5.49496C11.4804 5.72388 11.5458 6.04273 11.4477 6.09996L11.4395 6.10815ZM11.3987 5.39683V5.46225C11.3741 5.66665 11.3087 6.0509 11.4395 6.09178C11.5131 6.03455 11.4559 5.69934 11.415 5.50312L11.3987 5.39683Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4873 6.0833C11.4955 5.91979 11.659 5.96884 11.7653 5.87891C11.7489 5.96884 11.6835 6.10783 11.4873 6.0833Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5282 6.09964C11.5282 6.09964 11.5037 6.09964 11.4873 6.09964C11.4873 5.98518 11.5609 5.96065 11.6345 5.93612C11.6835 5.91977 11.7244 5.90343 11.7653 5.87891C11.7653 5.93614 11.7162 6.09964 11.5282 6.09964ZM11.7653 5.87891C11.7326 5.91979 11.6835 5.93613 11.6426 5.9443C11.5691 5.96883 11.5037 5.98519 11.5037 6.0833C11.5037 6.07513 11.52 6.07512 11.5364 6.07512C11.7162 6.07512 11.7653 5.92796 11.7735 5.87891H11.7653Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3088 6.30429C11.1616 6.26341 11.2434 5.74834 11.2434 5.54395C11.2842 5.72381 11.4232 6.25523 11.3088 6.30429Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3091 6.3131C11.1947 6.2804 11.211 6.01059 11.2274 5.7735C11.2274 5.68356 11.2437 5.60996 11.2355 5.55273L11.2601 5.58544C11.3418 5.92883 11.4154 6.27221 11.3173 6.32126L11.3091 6.3131ZM11.2437 5.57726C11.2437 5.63449 11.2437 5.69173 11.2437 5.76531C11.2356 5.98606 11.211 6.26405 11.3091 6.28858C11.4072 6.23952 11.2846 5.7653 11.2437 5.57726Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.374 6.27985C11.4967 6.32073 11.6602 6.23896 11.6683 6.0918C11.5621 6.16538 11.3986 6.10816 11.374 6.27985Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4476 6.30438C11.4476 6.30438 11.3986 6.30437 11.374 6.29619C11.374 6.17355 11.4639 6.14904 11.5457 6.13269C11.5866 6.13269 11.6356 6.11632 11.6683 6.0918C11.6683 6.22261 11.5539 6.30438 11.4394 6.30438H11.4476ZM11.3985 6.28803C11.3985 6.28803 11.4231 6.28803 11.4476 6.28803C11.5457 6.28803 11.6602 6.21444 11.6683 6.09998C11.6356 6.13268 11.5948 6.14086 11.5539 6.14903C11.4721 6.16538 11.4067 6.18174 11.3904 6.27985H11.4067L11.3985 6.28803Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1949 6.53314C11.0477 6.54949 11.1131 6.10801 11.1131 5.69922C11.1622 6.07531 11.3093 6.42686 11.1949 6.53314Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1946 6.54132C11.1946 6.54132 11.1619 6.53315 11.1455 6.5168C11.0801 6.45139 11.0965 6.23882 11.1047 6.00172C11.1047 5.90361 11.1128 5.8055 11.1128 5.69922C11.1455 5.82186 11.1701 5.9363 11.1946 6.04259C11.2437 6.27969 11.2845 6.45956 11.1946 6.53314V6.54132ZM11.121 5.74009C11.121 5.83002 11.121 5.91994 11.121 6.00988C11.121 6.24698 11.1047 6.45139 11.1537 6.5168C11.1619 6.5168 11.1783 6.53314 11.1946 6.53314C11.2682 6.46773 11.2273 6.28786 11.1701 6.06711C11.1537 5.969 11.1292 5.86273 11.1128 5.74827L11.121 5.74009Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2441 6.50871C11.3422 6.54959 11.5139 6.47602 11.563 6.3125C11.3913 6.38608 11.2687 6.31249 11.2441 6.50871Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3095 6.53263C11.3095 6.53263 11.2605 6.53264 11.2441 6.51629C11.2605 6.36913 11.3259 6.36093 11.4077 6.34458C11.4485 6.34458 11.5057 6.32824 11.563 6.30371C11.5303 6.45088 11.4076 6.53263 11.3095 6.53263ZM11.5548 6.31189C11.5058 6.35277 11.4567 6.35275 11.4077 6.36911C11.3177 6.38546 11.2687 6.38548 11.2523 6.51629C11.2605 6.51629 11.285 6.51629 11.3095 6.51629C11.3995 6.51629 11.5139 6.44271 11.5548 6.31189Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3716 5.53516C12.3471 5.74773 12.2572 5.87035 12.1263 5.854C12.0936 5.71501 12.1918 5.63327 12.3716 5.53516Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1499 5.86255H12.1254C12.0845 5.71539 12.1827 5.62545 12.3625 5.52734C12.3462 5.74809 12.2726 5.86255 12.1499 5.86255ZM12.3543 5.53553C12.1908 5.64181 12.0927 5.72356 12.1254 5.85437H12.1418C12.2481 5.85437 12.3217 5.73992 12.3462 5.53553H12.3543Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0266 6.08363C12.2391 6.11633 12.3209 5.9528 12.4681 5.74023C12.2637 5.8874 12.0184 5.91194 12.0266 6.08363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0778 6.10034C12.0778 6.10034 12.0451 6.10034 12.0288 6.10034C12.0206 5.97771 12.1187 5.92864 12.2577 5.86324C12.3231 5.83053 12.3967 5.78966 12.4621 5.74061L12.4212 5.83053C12.315 5.99404 12.2414 6.10853 12.0778 6.10853V6.10034ZM12.4539 5.73242C12.3967 5.79783 12.3231 5.83053 12.2577 5.86324C12.1269 5.92864 12.0288 5.97771 12.037 6.084C12.037 6.084 12.0615 6.084 12.0778 6.084C12.225 6.084 12.3068 5.96952 12.4049 5.81418L12.4539 5.73242Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9631 6.05975C11.8486 5.92076 11.9631 5.74091 12.053 5.59375C12.0367 5.8145 12.1103 5.93711 11.9631 6.05975Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.963 6.06722C11.8485 5.92823 11.9548 5.75654 12.0447 5.60938C11.963 5.77289 11.8812 5.92824 11.9793 6.05087C12.0692 5.97729 12.0611 5.89552 12.0529 5.78106C12.0529 5.732 12.0529 5.68296 12.0529 5.6339C12.0692 5.68296 12.0692 5.732 12.0692 5.78106C12.0692 5.9037 12.0774 5.98546 11.9793 6.06722H11.963Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9139 6.28826C11.8975 6.14927 12.1346 6.11655 12.2409 6.04297C12.2082 6.12473 12.151 6.33731 11.9139 6.28826Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9792 6.30399C11.9792 6.30399 11.9383 6.30399 11.9138 6.29581C11.8974 6.18953 12.0037 6.14048 12.11 6.0996C12.159 6.08325 12.1999 6.05871 12.2408 6.03418V6.07507C12.2081 6.16501 12.1509 6.30399 11.9874 6.30399H11.9792ZM12.2326 6.04236C12.2326 6.04236 12.1591 6.09959 12.1182 6.11594C12.0201 6.15682 11.9138 6.19772 11.9219 6.28765H11.9792C12.1345 6.28765 12.1836 6.15682 12.2245 6.06689V6.03418H12.2326V6.04236Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8652 6.29634C11.7017 6.27999 11.7671 6.00202 11.8897 5.84668C11.8407 6.05925 11.9797 6.2064 11.8652 6.29634Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8652 6.30392C11.8243 6.30392 11.7916 6.27122 11.7752 6.23034C11.7343 6.13223 11.7998 5.95235 11.8815 5.83789C11.8815 5.936 11.8897 6.01776 11.906 6.09134C11.9224 6.18127 11.9387 6.2385 11.8733 6.29573L11.8652 6.30392ZM11.8733 5.84607C11.8079 5.96054 11.7425 6.1404 11.7834 6.23034C11.7916 6.26304 11.8243 6.2794 11.857 6.28757C11.906 6.2467 11.8979 6.18946 11.8815 6.09952C11.8733 6.02594 11.8488 5.94418 11.8815 5.84607H11.8733Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.742 6.52583C11.5622 6.44407 11.6766 6.21516 11.742 6.07617C11.7093 6.25604 11.8565 6.39502 11.742 6.52583Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.741 6.53243C11.6919 6.51608 11.6674 6.47521 11.6429 6.43433C11.602 6.32804 11.6837 6.17269 11.741 6.06641C11.741 6.13999 11.7655 6.21357 11.7819 6.2708C11.8064 6.36073 11.8227 6.44249 11.7492 6.52425L11.741 6.53243ZM11.741 6.07459C11.7001 6.18088 11.6265 6.32804 11.6674 6.43433C11.6756 6.47521 11.7083 6.49974 11.7492 6.51609C11.8064 6.44251 11.79 6.36892 11.7737 6.27898C11.7573 6.21358 11.7328 6.14817 11.7492 6.07459H11.741Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7744 6.50078C11.8725 6.62341 12.0606 6.45989 12.1014 6.26367C11.9379 6.40266 11.8153 6.37814 11.7744 6.50078Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8644 6.54983C11.8644 6.54983 11.7989 6.53349 11.7744 6.50896C11.7908 6.4272 11.8398 6.41085 11.9134 6.37814C11.9625 6.35362 12.0279 6.32908 12.1014 6.26367C12.0851 6.41901 11.9625 6.54983 11.8644 6.54983ZM12.0933 6.26367C12.036 6.33725 11.9706 6.3618 11.9134 6.38633C11.848 6.41903 11.8071 6.43537 11.7826 6.50078C11.8071 6.51713 11.8316 6.53349 11.8562 6.53349C11.9461 6.53349 12.0606 6.40266 12.0851 6.26367H12.0933Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3716 5.53516C12.3471 5.74773 12.2572 5.87035 12.1263 5.854C12.0936 5.71501 12.1918 5.63327 12.3716 5.53516Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1499 5.86255H12.1254C12.0845 5.71539 12.1827 5.62545 12.3625 5.52734C12.3462 5.74809 12.2726 5.86255 12.1499 5.86255ZM12.3543 5.53553C12.1908 5.64181 12.0927 5.72356 12.1254 5.85437H12.1418C12.2481 5.85437 12.3217 5.73992 12.3462 5.53553H12.3543Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0266 6.08363C12.2391 6.11633 12.3209 5.9528 12.4681 5.74023C12.2637 5.8874 12.0184 5.91194 12.0266 6.08363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0778 6.10034C12.0778 6.10034 12.0451 6.10034 12.0288 6.10034C12.0206 5.97771 12.1187 5.92864 12.2577 5.86324C12.3231 5.83053 12.3967 5.78966 12.4621 5.74061L12.4212 5.83053C12.315 5.99404 12.2414 6.10853 12.0778 6.10853V6.10034ZM12.4539 5.73242C12.3967 5.79783 12.3231 5.83053 12.2577 5.86324C12.1269 5.92864 12.0288 5.97771 12.037 6.084C12.037 6.084 12.0615 6.084 12.0778 6.084C12.225 6.084 12.3068 5.96952 12.4049 5.81418L12.4539 5.73242Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9631 6.05975C11.8486 5.92076 11.9631 5.74091 12.053 5.59375C12.0367 5.8145 12.1103 5.93711 11.9631 6.05975Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.963 6.06759C11.8485 5.92042 11.9548 5.7569 12.0447 5.60156C11.963 5.76508 11.8812 5.92043 11.9793 6.04306C12.0692 5.96948 12.0611 5.88773 12.0529 5.77327C12.0529 5.72422 12.0529 5.67514 12.0529 5.62609C12.0692 5.67514 12.0692 5.72422 12.0692 5.77327C12.0692 5.89591 12.0774 5.97765 11.9793 6.0594L11.963 6.06759Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9139 6.28826C11.8975 6.14927 12.1346 6.11655 12.2409 6.04297C12.2082 6.12473 12.151 6.33731 11.9139 6.28826Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9792 6.30399C11.9792 6.30399 11.9383 6.30399 11.9138 6.29581C11.8974 6.18953 12.0037 6.14048 12.11 6.0996C12.159 6.08325 12.1999 6.05871 12.2408 6.03418V6.07507C12.2081 6.16501 12.1509 6.30399 11.9874 6.30399H11.9792ZM12.2326 6.04236C12.2326 6.04236 12.1591 6.09959 12.1182 6.11594C12.0201 6.15682 11.9138 6.19772 11.9219 6.28765H11.9792C12.1345 6.28765 12.1836 6.15682 12.2245 6.06689V6.03418H12.2326V6.04236Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8652 6.29634C11.7017 6.27999 11.7671 6.00202 11.8897 5.84668C11.8407 6.05925 11.9797 6.2064 11.8652 6.29634Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8652 6.30392C11.8243 6.30392 11.7916 6.27122 11.7752 6.23034C11.7343 6.13223 11.7998 5.95235 11.8815 5.83789C11.8815 5.936 11.8897 6.01776 11.906 6.09134C11.9224 6.18127 11.9387 6.2385 11.8733 6.29573L11.8652 6.30392ZM11.8733 5.84607C11.8079 5.96054 11.7425 6.1404 11.7834 6.23034C11.7916 6.26304 11.8243 6.2794 11.857 6.28757C11.906 6.2467 11.8979 6.18946 11.8815 6.09952C11.8733 6.02594 11.8488 5.94418 11.8815 5.84607H11.8733Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.742 6.52583C11.5622 6.44407 11.6766 6.21516 11.742 6.07617C11.7093 6.25604 11.8565 6.39502 11.742 6.52583Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.741 6.53243C11.6919 6.5079 11.6674 6.47521 11.6429 6.43433C11.602 6.32804 11.6837 6.17269 11.741 6.06641C11.741 6.13999 11.7655 6.21357 11.7819 6.2708C11.8064 6.36073 11.8227 6.44249 11.7492 6.52425L11.741 6.53243ZM11.741 6.07459C11.7001 6.18088 11.6265 6.32804 11.6674 6.43433C11.6756 6.47521 11.7083 6.49974 11.7492 6.51609C11.8064 6.44251 11.79 6.36892 11.7737 6.27898C11.7573 6.21358 11.7328 6.14817 11.7492 6.07459H11.741Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7744 6.50078C11.8725 6.62341 12.0606 6.45989 12.1014 6.26367C11.9379 6.40266 11.8153 6.37814 11.7744 6.50078Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8644 6.54983C11.8644 6.54983 11.7989 6.53349 11.7744 6.50896C11.7908 6.4272 11.8398 6.41085 11.9134 6.37814C11.9625 6.35362 12.0279 6.32908 12.1014 6.26367C12.0851 6.41901 11.9625 6.54983 11.8644 6.54983ZM12.0933 6.26367C12.036 6.33725 11.9706 6.3618 11.9134 6.38633C11.848 6.41903 11.8071 6.43537 11.7826 6.50078C11.8071 6.51713 11.8316 6.53349 11.8562 6.53349C11.9461 6.53349 12.0606 6.40266 12.0851 6.26367H12.0933Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2217 5.56055C16.2462 5.66683 16.2544 5.88758 16.4506 5.83852C16.4833 5.6423 16.3116 5.63413 16.2217 5.56055Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3937 5.85486C16.2547 5.85486 16.2302 5.71588 16.2139 5.6096V5.56055C16.2139 5.56055 16.2629 5.58506 16.2956 5.60142C16.3774 5.64229 16.4673 5.69136 16.4428 5.8467C16.4183 5.85488 16.4019 5.85486 16.3937 5.85486ZM16.2139 5.56055L16.2384 5.60142C16.2547 5.69953 16.2793 5.83852 16.4019 5.83852C16.4019 5.83852 16.4346 5.83852 16.4428 5.83852C16.4591 5.69953 16.3774 5.65866 16.2956 5.61778C16.2629 5.60143 16.2384 5.58508 16.2139 5.56873V5.56055Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5491 6.07544C16.5491 5.87105 16.3202 5.91193 16.124 5.74023C16.1813 5.9201 16.3693 6.14085 16.5491 6.07544Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.4841 6.0996C16.3206 6.0996 16.1734 5.91974 16.1244 5.74805C16.2143 5.80528 16.2961 5.83797 16.3697 5.86249C16.4759 5.91155 16.5577 5.94426 16.5659 6.07507C16.5332 6.09143 16.5168 6.0996 16.4841 6.0996ZM16.1244 5.74805C16.198 5.92791 16.386 6.12412 16.5495 6.06689C16.5413 5.95243 16.4596 5.92792 16.3533 5.87886C16.2797 5.84616 16.198 5.82163 16.1162 5.74805H16.1244Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5987 6.0594C16.7295 5.96947 16.6314 5.77325 16.5088 5.60156C16.5497 5.78961 16.4515 5.9613 16.5987 6.0594Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5971 6.06012C16.499 6.00289 16.5072 5.9048 16.5072 5.79852C16.5072 5.73311 16.5072 5.6677 16.499 5.59412C16.6298 5.75764 16.6789 5.88026 16.6625 5.96202C16.6625 6.0029 16.638 6.03561 16.6053 6.05196L16.5971 6.06012ZM16.499 5.59412C16.5317 5.65953 16.5235 5.72493 16.5235 5.79033C16.5235 5.88844 16.5154 5.97837 16.5971 6.0356C16.6217 6.01107 16.638 5.98656 16.6462 5.95386C16.6625 5.8721 16.6135 5.74945 16.499 5.58594V5.59412Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6545 6.28754C16.442 6.30389 16.4093 6.19758 16.3193 6.05859C16.4665 6.1567 16.6545 6.0995 16.6545 6.28754Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.614 6.30351C16.4505 6.30351 16.4015 6.21359 16.336 6.1073L16.3115 6.06641C16.3769 6.09093 16.426 6.09911 16.4832 6.11546C16.5813 6.13999 16.6631 6.15636 16.6631 6.28717H16.614V6.30351ZM16.3197 6.08277L16.3524 6.11546C16.4178 6.22174 16.4587 6.29533 16.614 6.29533H16.6549C16.6549 6.18904 16.5731 6.16452 16.4832 6.14817C16.4342 6.13182 16.3769 6.11546 16.3197 6.09093V6.08277Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7051 6.29599C16.607 6.21423 16.7296 6.03436 16.6887 5.85449C16.7623 5.96895 16.8931 6.23059 16.7051 6.29599Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7044 6.3032C16.6471 6.24597 16.6635 6.1724 16.6717 6.08246C16.6798 6.00888 16.6962 5.93527 16.6717 5.85352C16.7452 5.94345 16.827 6.10697 16.7943 6.21325C16.778 6.25413 16.7534 6.28685 16.6962 6.3032H16.7044ZM16.6798 5.85352C16.7126 5.9271 16.7044 6.00888 16.688 6.08246C16.6717 6.1724 16.6553 6.23779 16.7044 6.27867C16.7453 6.26232 16.7698 6.2378 16.7861 6.20509C16.8188 6.10698 16.7453 5.94345 16.6798 5.85352Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7952 6.51677C16.5826 6.56583 16.5172 6.45953 16.46 6.27148C16.6316 6.42682 16.7298 6.35326 16.7952 6.51677Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7056 6.5413C16.5584 6.5413 16.5012 6.435 16.4521 6.27148C16.5421 6.33689 16.6075 6.36142 16.6484 6.37777C16.7138 6.4023 16.7628 6.41866 16.8037 6.51677C16.7628 6.5413 16.7301 6.5413 16.7056 6.5413ZM16.4603 6.27148C16.5257 6.45135 16.5993 6.55765 16.7955 6.51677C16.7547 6.43502 16.7138 6.41864 16.6484 6.39412C16.5993 6.37776 16.5339 6.35325 16.4603 6.27967V6.27148Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8264 6.50912C16.9736 6.50912 16.9082 6.2148 16.8264 6.08398C16.8509 6.23932 16.7201 6.42736 16.8264 6.50912Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8271 6.52511C16.7617 6.47606 16.7862 6.37797 16.8026 6.28803C16.8189 6.22263 16.8353 6.1572 16.8271 6.0918C16.9007 6.18991 16.9579 6.39431 16.9007 6.48424C16.8843 6.51695 16.8598 6.52511 16.8271 6.52511ZM16.8271 6.0918C16.8516 6.14903 16.8353 6.22263 16.8271 6.28803C16.8026 6.37797 16.7862 6.45972 16.8435 6.50877C16.868 6.50877 16.8925 6.49241 16.9007 6.47606C16.9497 6.3943 16.9007 6.19809 16.8353 6.09998L16.8271 6.0918Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2217 5.56055C16.2462 5.66683 16.2544 5.88758 16.4506 5.83852C16.4833 5.6423 16.3116 5.63413 16.2217 5.56055Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3937 5.85486C16.2547 5.85486 16.2302 5.71588 16.2139 5.6096V5.56055C16.2139 5.56055 16.2629 5.58506 16.2956 5.60142C16.3774 5.64229 16.4673 5.69136 16.4428 5.8467C16.4183 5.85488 16.4019 5.85486 16.3937 5.85486ZM16.2139 5.56055L16.2384 5.60142C16.2547 5.69953 16.2793 5.83852 16.4019 5.83852C16.4019 5.83852 16.4346 5.83852 16.4428 5.83852C16.4591 5.69953 16.3774 5.65866 16.2956 5.61778C16.2629 5.60143 16.2384 5.58508 16.2139 5.56873V5.56055Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5491 6.07544C16.5491 5.87105 16.3202 5.91193 16.124 5.74023C16.1813 5.9201 16.3693 6.14085 16.5491 6.07544Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.4841 6.0996C16.3206 6.0996 16.1734 5.91974 16.1244 5.74805C16.2143 5.80528 16.2961 5.83797 16.3697 5.86249C16.4759 5.91155 16.5577 5.94426 16.5659 6.07507C16.5332 6.09143 16.5168 6.0996 16.4841 6.0996ZM16.1244 5.74805C16.198 5.92791 16.386 6.12412 16.5495 6.06689C16.5413 5.95243 16.4596 5.92792 16.3533 5.87886C16.2797 5.84616 16.198 5.82163 16.1162 5.74805H16.1244Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5987 6.0594C16.7295 5.96947 16.6314 5.77325 16.5088 5.60156C16.5497 5.78961 16.4515 5.9613 16.5987 6.0594Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5971 6.05975C16.499 5.99434 16.5072 5.89625 16.5072 5.79814C16.5072 5.73274 16.5072 5.66733 16.499 5.59375C16.6298 5.75727 16.6789 5.87989 16.6625 5.96165C16.6625 6.00252 16.638 6.03524 16.6053 6.05159L16.5971 6.05975ZM16.499 5.60191C16.5317 5.66732 16.5235 5.73274 16.5235 5.79814C16.5235 5.89625 16.5154 5.98618 16.5971 6.04341C16.6217 6.01888 16.638 5.99435 16.6462 5.96165C16.6625 5.87989 16.6135 5.75727 16.499 5.59375V5.60191Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6545 6.28754C16.442 6.30389 16.4093 6.19758 16.3193 6.05859C16.4665 6.1567 16.6545 6.0995 16.6545 6.28754Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.614 6.30351C16.4505 6.30351 16.4015 6.21359 16.336 6.1073L16.3115 6.06641C16.3769 6.09093 16.426 6.09911 16.4832 6.11546C16.5813 6.13999 16.6631 6.15636 16.6631 6.28717H16.614V6.30351ZM16.3197 6.08277L16.3524 6.11546C16.4178 6.22174 16.4587 6.29533 16.614 6.29533H16.6549C16.6549 6.18904 16.5731 6.16452 16.4832 6.14817C16.4342 6.13182 16.3769 6.11546 16.3197 6.09093V6.08277Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7051 6.29599C16.607 6.21423 16.7296 6.03436 16.6887 5.85449C16.7623 5.96895 16.8931 6.23059 16.7051 6.29599Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7044 6.3032C16.6471 6.24597 16.6635 6.1724 16.6717 6.08246C16.6798 6.00888 16.6962 5.93527 16.6717 5.85352C16.7452 5.94345 16.827 6.10697 16.7943 6.21325C16.778 6.25413 16.7534 6.28685 16.6962 6.3032H16.7044ZM16.6798 5.85352C16.7126 5.9271 16.7044 6.00888 16.688 6.08246C16.6717 6.1724 16.6553 6.23779 16.7044 6.27867C16.7453 6.26232 16.7698 6.2378 16.7861 6.20509C16.8188 6.10698 16.7453 5.94345 16.6798 5.85352Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7952 6.51677C16.5826 6.56583 16.5172 6.45953 16.46 6.27148C16.6316 6.42682 16.7298 6.35326 16.7952 6.51677Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7056 6.5413C16.5584 6.5413 16.5012 6.435 16.4521 6.27148C16.5421 6.33689 16.6075 6.36142 16.6484 6.37777C16.7138 6.4023 16.7628 6.41866 16.8037 6.51677C16.7628 6.5413 16.7301 6.5413 16.7056 6.5413ZM16.4603 6.27148C16.5257 6.45135 16.5993 6.55765 16.7955 6.51677C16.7547 6.43502 16.7138 6.41864 16.6484 6.39412C16.5993 6.37776 16.5339 6.35325 16.4603 6.27967V6.27148Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8264 6.50912C16.9736 6.50912 16.9082 6.2148 16.8264 6.08398C16.8509 6.23932 16.7201 6.42736 16.8264 6.50912Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8271 6.52511C16.7617 6.47606 16.7862 6.37797 16.8026 6.28803C16.8189 6.22263 16.8353 6.1572 16.8271 6.0918C16.9007 6.18991 16.9579 6.39431 16.9007 6.48424C16.8843 6.51695 16.8598 6.52511 16.8271 6.52511ZM16.8271 6.0918C16.8516 6.14903 16.8353 6.22263 16.8271 6.28803C16.8026 6.37797 16.7862 6.45972 16.8435 6.50877C16.868 6.50877 16.8925 6.49241 16.9007 6.47606C16.9497 6.3943 16.9007 6.19809 16.8353 6.09998L16.8271 6.0918Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7373 5.31445C16.7618 5.43709 16.7128 5.67419 16.909 5.67419C16.9907 5.5352 16.8109 5.40439 16.7373 5.31445Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9012 5.68235C16.754 5.68235 16.7377 5.53518 16.7377 5.42072C16.7377 5.37984 16.7377 5.34716 16.7295 5.31445C16.7622 5.32263 16.7786 5.34715 16.7949 5.36351C16.8848 5.45344 16.9829 5.56789 16.9175 5.68235H16.9012ZM16.7295 5.32261C16.7295 5.32261 16.754 5.37984 16.754 5.42072C16.754 5.54335 16.7622 5.66601 16.9012 5.66601C16.9584 5.5679 16.8603 5.4616 16.7785 5.37166C16.754 5.35531 16.7377 5.33898 16.7295 5.31445V5.32261Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0314 5.85399C17.1541 5.77223 17.0478 5.4861 17.0069 5.18359C16.9742 5.46157 16.9088 5.76406 17.0314 5.85399Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0318 5.86217C16.9255 5.78859 16.9582 5.55967 16.9827 5.32257L16.9991 5.18359C17.0236 5.27353 17.0481 5.35527 17.0563 5.4452C17.0972 5.64959 17.1299 5.81313 17.0318 5.87036V5.86217ZM16.9991 5.18359V5.32257C16.9664 5.55967 16.9419 5.77225 17.0318 5.84583C17.1054 5.7886 17.0808 5.64142 17.04 5.4452C17.0236 5.36344 17.0073 5.27353 16.9991 5.18359Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9657 5.87877C16.982 5.73161 16.7368 5.69072 16.5732 5.48633C16.6141 5.64984 16.7368 5.88695 16.9657 5.87877Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9497 5.88656C16.7453 5.88656 16.6145 5.68218 16.5654 5.49414C16.6472 5.5759 16.7371 5.62495 16.8107 5.67401C16.9088 5.73942 16.9824 5.78847 16.9742 5.8784H16.9497V5.88656ZM16.5654 5.5023C16.5981 5.55953 16.6962 5.8784 16.9497 5.8784H16.966C16.966 5.80482 16.8924 5.76394 16.8025 5.69854C16.7289 5.65766 16.639 5.60042 16.5736 5.51048L16.5654 5.5023Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1293 6.11596C16.9985 6.0015 17.1538 5.65811 17.162 5.39648C17.1865 5.64176 17.2929 6.0669 17.1293 6.11596Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1307 6.12414C17.0407 6.04238 17.0734 5.87887 17.1143 5.69083C17.1388 5.59272 17.1552 5.48642 17.1552 5.39648C17.1797 5.45371 17.1879 5.51095 17.1961 5.57635C17.2369 5.81345 17.2696 6.08325 17.1388 6.11596L17.1307 6.12414ZM17.1552 5.44554C17.1552 5.52729 17.1388 5.61725 17.1225 5.69901C17.0816 5.8707 17.0489 6.03422 17.1225 6.1078C17.2288 6.06692 17.1961 5.79711 17.1634 5.58454C17.1634 5.53548 17.147 5.48642 17.147 5.44554H17.1552Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0565 6.0833C16.8685 6.09965 16.8194 5.96066 16.7949 5.87891C16.893 5.95249 17.0565 5.91979 17.0565 6.0833Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0314 6.09146C16.8515 6.09146 16.8025 5.93614 16.7861 5.87891C16.827 5.89526 16.8761 5.90342 16.9088 5.91978C16.9823 5.9443 17.0641 5.96884 17.0641 6.0833H17.0314V6.09146ZM16.7861 5.89525C16.827 5.98518 16.8761 6.0833 17.0314 6.0833H17.0559C17.0477 5.98519 16.9823 5.96883 16.9006 5.9443C16.8597 5.92795 16.8188 5.91978 16.7861 5.89525Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2447 6.29636C17.3919 6.29636 17.3347 5.73224 17.3183 5.56055C17.302 5.74859 17.1548 6.22278 17.2447 6.29636Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2439 6.30455C17.1785 6.25549 17.2194 6.02656 17.2684 5.80581C17.2848 5.7077 17.3093 5.61778 17.3093 5.56055C17.342 5.74041 17.3829 6.17374 17.2929 6.28002C17.2766 6.29637 17.2602 6.30455 17.2439 6.31273V6.30455ZM17.3093 5.59326C17.3093 5.65049 17.2929 5.72405 17.2766 5.80581C17.2357 5.99385 17.1867 6.23097 17.2439 6.28002C17.2521 6.28002 17.2684 6.27183 17.2766 6.26365C17.3583 6.16554 17.3256 5.7813 17.3093 5.59326Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1797 6.27948C17.0571 6.30401 16.9263 6.22225 16.8936 6.09961C16.9998 6.14866 17.1879 6.10779 17.1797 6.27948Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1386 6.29643C17.0159 6.29643 16.9097 6.22286 16.877 6.1084C16.9178 6.1084 16.9587 6.11657 16.9914 6.12474C17.0895 6.14109 17.1795 6.15745 17.1795 6.28008C17.1631 6.29643 17.1468 6.29643 17.1304 6.29643H17.1386ZM16.8851 6.1084C16.9342 6.21468 17.0487 6.29643 17.1795 6.2719C17.1795 6.17379 17.0895 6.14926 16.9996 6.14108C16.9587 6.14108 16.926 6.12475 16.8933 6.1084H16.8851Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3676 6.52496C17.5229 6.59036 17.4657 5.87091 17.4412 5.69922C17.433 5.91179 17.2449 6.43502 17.3676 6.52496Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3829 6.54098H17.3584C17.2684 6.4674 17.3257 6.2221 17.3829 5.98501C17.4074 5.87872 17.432 5.78061 17.432 5.70703C17.4647 5.8542 17.5137 6.41832 17.4156 6.52461C17.4074 6.54096 17.3911 6.54914 17.3747 6.54914L17.3829 6.54098ZM17.4401 5.73156C17.4401 5.79696 17.4238 5.89507 17.3992 5.98501C17.3502 6.19758 17.293 6.4674 17.3665 6.51645H17.3829C17.3829 6.51645 17.3993 6.51644 17.4074 6.50827C17.4892 6.41016 17.4565 5.89507 17.4401 5.73156Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3257 6.52471C17.1704 6.54923 17.0559 6.45113 17.0068 6.32031C17.1703 6.37754 17.293 6.36119 17.3257 6.52471Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.277 6.5407C17.1462 6.5407 17.0399 6.45894 16.999 6.32812C17.0481 6.32812 17.089 6.34448 17.1298 6.35265C17.2279 6.37718 17.3097 6.39352 17.3342 6.52434C17.3097 6.54069 17.2933 6.5407 17.277 6.5407ZM16.999 6.32812C17.0563 6.45894 17.1789 6.5407 17.3179 6.51618C17.2852 6.40989 17.2198 6.38536 17.1135 6.36084C17.0808 6.35266 17.0399 6.34448 16.999 6.32812Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.211 7.37598C17.2355 7.18794 17.0884 6.84456 17.1865 6.66469C17.2028 6.63199 17.1538 6.57476 17.1293 6.61564C17.0884 6.68104 17.0393 6.86091 17.023 6.7955C16.9985 6.72192 16.9985 6.5911 16.933 6.5584C16.8922 6.54205 16.8268 6.53386 16.8431 6.59927C16.8595 6.66467 16.9003 6.74643 16.8595 6.75461C16.8349 6.75461 16.7695 6.67286 16.7123 6.63198C16.6633 6.5911 16.5979 6.64833 16.6633 6.70556C16.884 6.87725 17.0884 6.959 17.211 7.36779V7.37598Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2032 7.38312C17.1051 7.04791 16.9498 6.93344 16.7781 6.81081C16.7372 6.7781 16.6963 6.75359 16.6554 6.72088C16.6146 6.68818 16.6227 6.66363 16.6227 6.64728C16.6227 6.61458 16.68 6.60641 16.7127 6.63094C16.7372 6.64729 16.7617 6.67999 16.7863 6.70452C16.8108 6.72904 16.8353 6.76175 16.8517 6.76175C16.8762 6.73723 16.8517 6.69634 16.8517 6.65546V6.61459C16.8517 6.61459 16.8353 6.58189 16.8517 6.56554L16.8844 6.55736C16.9089 6.55736 16.9252 6.55736 16.9416 6.55736C16.9907 6.58189 17.007 6.66364 17.0234 6.72904C17.0234 6.75357 17.0234 6.77811 17.0397 6.79446C17.0561 6.79446 17.0724 6.75359 17.0806 6.72088C17.0969 6.68001 17.1133 6.63911 17.1296 6.60641C17.1705 6.59006 17.1869 6.6064 17.195 6.62275C17.195 6.63911 17.2114 6.65545 17.195 6.67181C17.1296 6.77809 17.1623 6.94979 17.195 7.11331C17.2114 7.21142 17.2277 7.30954 17.2196 7.38312H17.2032ZM16.6718 6.63912C16.6718 6.63912 16.6473 6.63911 16.6391 6.65546C16.6391 6.67182 16.6391 6.68816 16.6636 6.70452C16.7045 6.73722 16.7454 6.76176 16.7863 6.79446C16.9498 6.90892 17.0969 7.03156 17.2032 7.32588C17.2032 7.26048 17.1869 7.1869 17.1705 7.10515C17.146 6.94163 17.1133 6.76992 17.1705 6.65546L17.1378 6.59823C17.1378 6.59823 17.0888 6.67182 17.0724 6.7127C17.0479 6.77811 17.0315 6.81081 17.0152 6.81081C16.9906 6.76993 16.9906 6.74541 16.9825 6.72088C16.9661 6.65548 16.9579 6.58189 16.9089 6.55736C16.8925 6.55736 16.8762 6.54102 16.8598 6.54102C16.8271 6.55737 16.8271 6.57371 16.8353 6.58188V6.62275C16.8598 6.67181 16.8762 6.7127 16.8598 6.73723C16.819 6.7454 16.7944 6.72906 16.7617 6.69636C16.7372 6.66365 16.7127 6.63911 16.6882 6.62275C16.68 6.62275 16.6636 6.62275 16.6554 6.62275L16.6718 6.63912Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.211 7.37598C17.2355 7.18794 17.0884 6.84456 17.1865 6.66469C17.2028 6.63199 17.1538 6.57476 17.1293 6.61564C17.0884 6.68104 17.0393 6.86091 17.023 6.7955C16.9985 6.72192 16.9985 6.5911 16.933 6.5584C16.8922 6.54205 16.8268 6.53386 16.8431 6.59927C16.8595 6.66467 16.9003 6.74643 16.8595 6.75461C16.8349 6.75461 16.7695 6.67286 16.7123 6.63198C16.6633 6.5911 16.5979 6.64833 16.6633 6.70556C16.884 6.87725 17.0884 6.959 17.211 7.36779V7.37598Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2032 7.38312C17.1051 7.04791 16.9498 6.93344 16.7781 6.81081C16.7372 6.7781 16.6963 6.75359 16.6554 6.72088C16.6146 6.68818 16.6227 6.66363 16.6227 6.64728C16.6227 6.61458 16.68 6.60641 16.7127 6.63094C16.7372 6.64729 16.7617 6.67999 16.7863 6.70452C16.8108 6.72904 16.8353 6.76175 16.8517 6.76175C16.8762 6.73723 16.8517 6.69634 16.8517 6.65546V6.61459C16.8517 6.61459 16.8353 6.58189 16.8517 6.56554L16.8844 6.55736C16.9089 6.55736 16.9252 6.55736 16.9416 6.55736C16.9907 6.58189 17.007 6.66364 17.0234 6.72904C17.0234 6.75357 17.0234 6.77811 17.0397 6.79446C17.0561 6.79446 17.0724 6.75359 17.0806 6.72088C17.0969 6.68001 17.1133 6.63911 17.1296 6.60641C17.1705 6.59006 17.1869 6.6064 17.195 6.62275C17.195 6.63911 17.2114 6.65545 17.195 6.67181C17.1296 6.77809 17.1623 6.94979 17.195 7.11331C17.2114 7.21142 17.2277 7.30954 17.2196 7.38312H17.2032ZM16.6718 6.63912C16.6718 6.63912 16.6473 6.63911 16.6391 6.65546C16.6391 6.67182 16.6391 6.68816 16.6636 6.70452C16.7045 6.73722 16.7454 6.76176 16.7863 6.79446C16.9498 6.90892 17.0969 7.03156 17.2032 7.32588C17.2032 7.26048 17.1869 7.1869 17.1705 7.10515C17.146 6.94163 17.1133 6.76992 17.1705 6.65546L17.1378 6.59823C17.1378 6.59823 17.0888 6.67182 17.0724 6.7127C17.0479 6.77811 17.0315 6.81081 17.0152 6.81081C16.9906 6.76993 16.9906 6.74541 16.9825 6.72088C16.9661 6.65548 16.9579 6.58189 16.9089 6.55736C16.8925 6.55736 16.8762 6.54102 16.8598 6.54102C16.8271 6.55737 16.8271 6.57371 16.8353 6.58188V6.62275C16.8598 6.67181 16.8762 6.7127 16.8598 6.73723C16.819 6.7454 16.7944 6.72906 16.7617 6.69636C16.7372 6.66365 16.7127 6.63911 16.6882 6.62275C16.68 6.62275 16.6636 6.62275 16.6554 6.62275L16.6718 6.63912Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7373 5.31445C16.7618 5.43709 16.7128 5.67419 16.909 5.67419C16.9907 5.5352 16.8109 5.40439 16.7373 5.31445Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9012 5.68235C16.754 5.68235 16.7377 5.53518 16.7377 5.42072C16.7377 5.37984 16.7377 5.34716 16.7295 5.31445C16.7622 5.32263 16.7786 5.34715 16.7949 5.36351C16.8848 5.45344 16.9829 5.56789 16.9175 5.68235H16.9012ZM16.7295 5.32261C16.7295 5.32261 16.754 5.37984 16.754 5.42072C16.754 5.54335 16.7622 5.66601 16.9012 5.66601C16.9584 5.5679 16.8603 5.4616 16.7785 5.37166C16.754 5.35531 16.7377 5.33898 16.7295 5.31445V5.32261Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0314 5.85399C17.1541 5.77223 17.0478 5.4861 17.0069 5.18359C16.9742 5.46157 16.9088 5.76406 17.0314 5.85399Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0318 5.86254C16.9255 5.78079 16.9582 5.56005 16.9827 5.31478L16.9991 5.17578C17.0236 5.26571 17.0481 5.34748 17.0563 5.43741C17.0972 5.64181 17.1299 5.80531 17.0318 5.86254ZM16.9991 5.18397V5.32294C16.9664 5.56004 16.9419 5.77262 17.0318 5.8462C17.1054 5.78897 17.0808 5.64179 17.04 5.44557C17.0236 5.36381 17.0073 5.2739 16.9991 5.18397Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9657 5.87877C16.982 5.73161 16.7368 5.69072 16.5732 5.48633C16.6141 5.64984 16.7368 5.88695 16.9657 5.87877Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9497 5.88656C16.7453 5.88656 16.6145 5.68218 16.5654 5.49414C16.6472 5.5759 16.7371 5.62495 16.8107 5.67401C16.9088 5.73942 16.9824 5.78847 16.9742 5.8784H16.9497V5.88656ZM16.5654 5.5023C16.5981 5.55953 16.6962 5.8784 16.9497 5.8784H16.966C16.966 5.80482 16.8924 5.76394 16.8025 5.69854C16.7289 5.65766 16.639 5.60042 16.5736 5.51048L16.5654 5.5023Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1293 6.11596C16.9985 6.0015 17.1538 5.65811 17.162 5.39648C17.1865 5.64176 17.2929 6.0669 17.1293 6.11596Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1307 6.13195C17.0407 6.0502 17.0734 5.87851 17.1143 5.69864C17.1388 5.60053 17.1552 5.49423 17.1552 5.4043C17.1797 5.46153 17.1879 5.51876 17.1961 5.58417C17.2369 5.82126 17.2696 6.09107 17.1388 6.12377L17.1307 6.13195ZM17.1634 5.45335C17.1634 5.53511 17.147 5.62504 17.1307 5.7068C17.0898 5.87849 17.0571 6.042 17.1307 6.11559C17.237 6.07471 17.2042 5.80492 17.1715 5.59235C17.1715 5.54329 17.1552 5.49423 17.1552 5.45335H17.1634Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0565 6.0833C16.8685 6.09965 16.8194 5.96066 16.7949 5.87891C16.893 5.95249 17.0565 5.91979 17.0565 6.0833Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0314 6.09146C16.8515 6.09146 16.8025 5.93614 16.7861 5.87891C16.827 5.89526 16.8761 5.90342 16.9088 5.91978C16.9823 5.9443 17.0641 5.96884 17.0641 6.0833H17.0314V6.09146ZM16.7861 5.89525C16.827 5.98518 16.8761 6.0833 17.0314 6.0833H17.0559C17.0477 5.98519 16.9823 5.96883 16.9006 5.9443C16.8597 5.92795 16.8188 5.91978 16.7861 5.89525Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2447 6.29636C17.3919 6.29636 17.3347 5.73224 17.3183 5.56055C17.302 5.74859 17.1548 6.22278 17.2447 6.29636Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2439 6.30455C17.1785 6.24732 17.2194 6.01838 17.2684 5.80581C17.2848 5.7077 17.3093 5.61778 17.3093 5.56055C17.342 5.74041 17.3829 6.17374 17.2929 6.28002C17.2766 6.29637 17.2602 6.30455 17.2439 6.31273V6.30455ZM17.3175 5.59326C17.3175 5.65049 17.3011 5.72405 17.2847 5.80581C17.2439 5.99385 17.1948 6.23097 17.2521 6.28002C17.2602 6.28002 17.2766 6.27183 17.2847 6.26365C17.3665 6.16554 17.3338 5.7813 17.3175 5.59326Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1797 6.27948C17.0571 6.30401 16.9263 6.22225 16.8936 6.09961C16.9998 6.14866 17.1879 6.10779 17.1797 6.27948Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1386 6.29643C17.0159 6.29643 16.9097 6.22286 16.877 6.1084C16.9178 6.1084 16.9587 6.11657 16.9914 6.12474C17.0895 6.14109 17.1795 6.15745 17.1795 6.28008C17.1631 6.29643 17.1468 6.29643 17.1304 6.29643H17.1386ZM16.8851 6.1084C16.9342 6.21468 17.0487 6.29643 17.1795 6.2719C17.1795 6.17379 17.0895 6.14926 16.9996 6.14108C16.9587 6.14108 16.926 6.12475 16.8933 6.1084H16.8851Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3676 6.52496C17.5229 6.59036 17.4657 5.87091 17.4412 5.69922C17.433 5.91179 17.2449 6.43502 17.3676 6.52496Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3829 6.54098H17.3584C17.2684 6.4674 17.3257 6.2221 17.3829 5.98501C17.4074 5.87872 17.432 5.78061 17.432 5.70703C17.4647 5.8542 17.5137 6.41832 17.4156 6.52461C17.4074 6.54096 17.3911 6.54914 17.3747 6.54914L17.3829 6.54098ZM17.4401 5.73156C17.4401 5.79696 17.4238 5.89507 17.3992 5.98501C17.3502 6.19758 17.293 6.4674 17.3665 6.51645H17.3829C17.3829 6.51645 17.3993 6.51644 17.4074 6.50827C17.4892 6.41016 17.4565 5.89507 17.4401 5.73156Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3257 6.52471C17.1704 6.54923 17.0559 6.45113 17.0068 6.32031C17.1703 6.37754 17.293 6.36119 17.3257 6.52471Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.277 6.5407C17.1462 6.5407 17.0399 6.45894 16.999 6.32812C17.0481 6.32812 17.089 6.34448 17.1298 6.35265C17.2279 6.37718 17.3097 6.39352 17.3342 6.52434C17.3097 6.54069 17.2933 6.5407 17.277 6.5407ZM16.999 6.32812C17.0563 6.45894 17.1789 6.5407 17.3179 6.51618C17.2852 6.40989 17.2198 6.38536 17.1135 6.36084C17.0808 6.35266 17.0399 6.34448 16.999 6.32812Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7585 7.25311C17.8075 7.19588 17.7912 7.17135 17.7176 7.17135C17.6603 7.17135 17.5295 7.21223 17.4887 7.17135C17.4396 7.13865 17.456 7.00785 17.4396 6.95061C17.4396 6.91791 17.4069 6.86068 17.3497 6.95061C17.1943 7.20406 16.9981 7.50656 16.9082 7.80906C16.8673 7.98075 16.8837 8.25055 17.0635 8.38954L17.1943 8.02164C17.2516 7.84995 17.5786 7.42481 17.7585 7.25311Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7585 7.25311C17.8075 7.19588 17.7912 7.17135 17.7176 7.17135C17.6603 7.17135 17.5295 7.21223 17.4887 7.17135C17.4396 7.13865 17.456 7.00785 17.4396 6.95061C17.4396 6.91791 17.4069 6.86068 17.3497 6.95061C17.1943 7.20406 16.9981 7.50656 16.9082 7.80906C16.8673 7.98075 16.8837 8.25055 17.0635 8.38954L17.1943 8.02164C17.2516 7.84995 17.5786 7.42481 17.7585 7.25311Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.931 6.79492C17.8656 7.02384 17.8165 7.21187 17.931 7.2364C18.0372 7.22004 17.9882 6.99932 17.931 6.79492Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9308 7.24458C17.9308 7.24458 17.89 7.22822 17.8818 7.21187C17.8409 7.13829 17.8818 6.99114 17.939 6.79492C17.9962 6.95844 18.0371 7.13011 17.9881 7.21187C17.9799 7.22822 17.9635 7.24458 17.939 7.24458H17.9308ZM17.9308 6.79492C17.8981 6.96661 17.8491 7.13012 17.89 7.19553C17.89 7.21188 17.9063 7.22006 17.9308 7.22824C17.9472 7.22824 17.9635 7.21188 17.9635 7.19553C18.0044 7.13012 17.9635 6.95844 17.9308 6.79492Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9302 7.44098C18.0446 7.49821 18.1755 7.20389 18.1509 6.9668C18.0937 7.17119 17.8893 7.29382 17.9302 7.44098Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9631 7.45735L17.9304 7.44917C17.8977 7.35923 17.9549 7.27747 18.0203 7.18753C18.0612 7.12213 18.1184 7.04855 18.143 6.9668C18.1757 7.13031 18.1266 7.32652 18.0449 7.41646C18.0203 7.44916 17.9958 7.45735 17.9631 7.45735ZM18.1348 6.9668C18.1348 7.05673 18.0775 7.13032 18.0285 7.2039C17.9631 7.28566 17.914 7.3674 17.9304 7.44098H17.9549C17.9549 7.44098 17.9958 7.42465 18.0203 7.4083C18.0939 7.31836 18.1429 7.13032 18.1266 6.97498L18.1348 6.9668Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8821 7.43215C17.8985 7.26863 17.8331 7.26862 17.7432 7.11328C17.7513 7.29315 17.8004 7.44032 17.8821 7.43215Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8747 7.43994C17.8011 7.43994 17.7439 7.31731 17.7357 7.12109C17.7766 7.16197 17.8093 7.20286 17.8256 7.22738C17.8665 7.28461 17.8992 7.3173 17.8829 7.43994H17.8665H17.8747ZM17.7357 7.12928C17.7602 7.30914 17.8093 7.43178 17.8747 7.43178C17.8747 7.33367 17.8584 7.30096 17.8093 7.24373C17.7848 7.21102 17.7602 7.17833 17.7275 7.12928H17.7357Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9223 7.66972C18.0613 7.7106 18.2166 7.38358 18.2166 7.14648C18.1594 7.41629 17.8569 7.52256 17.9223 7.66972Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9463 7.67667H17.9218C17.8809 7.58674 17.9463 7.51316 18.0199 7.43141C18.0935 7.34965 18.1752 7.25972 18.1998 7.12891C18.2161 7.3006 18.1425 7.52134 18.0444 7.61127C18.0117 7.65215 17.979 7.66849 17.9463 7.66849V7.67667ZM18.1998 7.13707C18.1916 7.26788 18.1016 7.36599 18.0281 7.44775C17.9545 7.52951 17.8973 7.5949 17.9218 7.66849H17.9381C17.9381 7.66849 18.0035 7.65214 18.0281 7.61943C18.1262 7.52132 18.1998 7.30876 18.1916 7.14525L18.1998 7.13707Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.874 7.66138C17.9312 7.53875 17.8249 7.54692 17.7432 7.32617C17.7186 7.56327 17.7595 7.66138 17.874 7.66138Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8738 7.66894C17.8329 7.66894 17.8002 7.66077 17.7757 7.62807C17.7348 7.58719 17.7184 7.4809 17.7348 7.31738C17.7838 7.41549 17.8247 7.46456 17.8492 7.50543C17.8901 7.55449 17.9065 7.58719 17.8819 7.65259H17.8656L17.8738 7.66894ZM17.743 7.33375C17.743 7.48909 17.743 7.57901 17.792 7.62807C17.8165 7.65259 17.8411 7.66078 17.8738 7.66078C17.8983 7.60355 17.8738 7.57902 17.8411 7.52996C17.8084 7.48908 17.7757 7.44004 17.7348 7.33375H17.743Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.915 7.90714C18.0949 7.93984 18.1848 7.53924 18.2748 7.35938C18.1031 7.60465 17.8905 7.74362 17.915 7.90714Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9378 7.92388H17.9133C17.8887 7.80124 17.9786 7.70311 18.0849 7.5723C18.1422 7.50689 18.1994 7.4415 18.2566 7.35156C18.2566 7.40879 18.2321 7.45786 18.2157 7.51509C18.1422 7.70313 18.0604 7.91569 17.9296 7.91569L17.9378 7.92388ZM18.2648 7.35975C18.2239 7.44968 18.1585 7.52326 18.1013 7.58867C17.9868 7.7113 17.9051 7.80941 17.9214 7.91569H17.9296C18.0441 7.91569 18.134 7.69496 18.1994 7.51509C18.2239 7.45786 18.2403 7.4088 18.2648 7.35975Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8738 7.89843C17.9229 7.75126 17.7757 7.75945 17.7021 7.54688C17.7103 7.82485 17.7512 7.92296 17.8738 7.89843Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8497 7.90696C17.7352 7.90696 17.7107 7.77616 17.6943 7.53906C17.7434 7.629 17.7925 7.68621 17.8333 7.72709C17.8824 7.77614 17.9151 7.81702 17.8824 7.89877C17.8824 7.89877 17.8497 7.90696 17.8415 7.90696H17.8497ZM17.7025 7.53906C17.727 7.79251 17.7679 7.88243 17.8497 7.88243H17.8742C17.8987 7.80885 17.8742 7.78433 17.8251 7.73527C17.7843 7.69439 17.7352 7.63717 17.7025 7.53906Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9309 8.14327C18.0453 8.15144 18.2415 7.83257 18.2497 7.64453C18.1516 7.8571 17.8491 7.9961 17.9309 8.14327Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9311 8.15961C17.8738 8.0615 17.9638 7.97975 18.0537 7.88164C18.1273 7.80805 18.2009 7.73446 18.2417 7.64453C18.2499 7.84075 18.0537 8.15961 17.9311 8.15961ZM18.2417 7.65272C18.2172 7.75082 18.1436 7.8244 18.0701 7.89798C17.9801 7.99609 17.8984 8.06969 17.9392 8.15145C18.0455 8.15145 18.2417 7.84076 18.2417 7.65272Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8411 8.11181C17.8902 7.95647 17.7594 7.95648 17.7021 7.79297C17.7021 8.04642 17.743 8.13634 17.8411 8.11181Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8164 8.11939C17.8164 8.11939 17.7673 8.11938 17.7428 8.08668C17.7019 8.0458 17.6855 7.95587 17.6937 7.78418C17.7346 7.84959 17.7673 7.89048 17.8 7.92318C17.849 7.97223 17.8817 8.0131 17.849 8.11121H17.8164V8.11939ZM17.6937 7.79236C17.7019 7.95588 17.7264 8.03763 17.7591 8.08668C17.7755 8.10303 17.7918 8.11121 17.8164 8.11121H17.8409C17.8654 8.02945 17.8245 7.99676 17.7837 7.94771C17.7509 7.915 17.7182 7.86593 17.6855 7.80052L17.6937 7.79236Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8488 8.38118C18.045 8.41388 18.0941 8.16043 18.2167 7.89062C18.1023 8.1032 17.8406 8.21766 17.8488 8.38118Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8815 8.38971C17.8815 8.38971 17.8569 8.38971 17.8488 8.38971C17.8324 8.28342 17.9142 8.20168 18.0123 8.11992C18.0777 8.05451 18.1595 7.98092 18.2085 7.88281C18.2085 7.94004 18.184 7.99728 18.1595 8.04634C18.0859 8.23438 18.0205 8.39789 17.8815 8.39789V8.38971ZM18.1922 7.92371C18.1513 8.00546 18.0859 8.07087 18.0286 8.1281C17.9305 8.21803 17.857 8.29161 17.8651 8.37336C17.8651 8.37336 17.8815 8.37336 17.8897 8.37336C18.0205 8.37336 18.0777 8.2262 18.1513 8.03815C18.1676 7.99728 18.184 7.96459 18.1922 7.92371Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8325 8.3473C17.8979 8.20831 17.7425 8.2083 17.6689 8.00391C17.6689 8.29823 17.7098 8.38 17.8325 8.3473Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7916 8.36364C17.7916 8.36364 17.7425 8.35549 17.7262 8.33096C17.6853 8.29008 17.6689 8.18377 17.6689 8.00391C17.718 8.09384 17.7671 8.14291 17.7998 8.17562C17.8488 8.23285 17.8897 8.26554 17.8488 8.3473C17.8243 8.35548 17.808 8.36364 17.7916 8.36364ZM17.6689 8.01209C17.6853 8.18378 17.7017 8.29008 17.7425 8.33096C17.7671 8.35549 17.7916 8.35548 17.8407 8.3473C17.8734 8.27372 17.8407 8.2492 17.7916 8.20014C17.7507 8.15926 17.7016 8.11021 17.6689 8.02027V8.01209Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.931 6.79492C17.8656 7.02384 17.8165 7.21187 17.931 7.2364C18.0372 7.22004 17.9882 6.99932 17.931 6.79492Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9308 7.24458C17.9308 7.24458 17.89 7.22822 17.8818 7.21187C17.8409 7.13829 17.8818 6.99114 17.939 6.79492C17.9962 6.95844 18.0371 7.13011 17.9881 7.21187C17.9799 7.22822 17.9635 7.24458 17.939 7.24458H17.9308ZM17.9308 6.79492C17.8981 6.96661 17.8491 7.13012 17.89 7.19553C17.89 7.21188 17.9063 7.22006 17.9308 7.22824C17.9472 7.22824 17.9635 7.21188 17.9635 7.19553C18.0044 7.13012 17.9635 6.95844 17.9308 6.79492Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9302 7.44098C18.0446 7.49821 18.1755 7.20389 18.1509 6.9668C18.0937 7.17119 17.8893 7.29382 17.9302 7.44098Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9631 7.45735H17.9304C17.8977 7.35924 17.9549 7.27747 18.0203 7.18753C18.0612 7.12213 18.1184 7.04855 18.143 6.9668C18.1757 7.13031 18.1266 7.32652 18.0449 7.41646C18.0203 7.44916 17.9958 7.45735 17.9631 7.45735ZM18.1348 6.9668C18.1348 7.05673 18.0775 7.13032 18.0285 7.2039C17.9631 7.28566 17.914 7.3674 17.9304 7.44098H17.9549C17.9549 7.44098 17.9958 7.42465 18.0203 7.4083C18.0939 7.31836 18.1429 7.13032 18.1266 6.97498L18.1348 6.9668Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8821 7.43215C17.8985 7.26863 17.8331 7.26862 17.7432 7.11328C17.7513 7.29315 17.8004 7.44032 17.8821 7.43215Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8747 7.43994C17.8011 7.43994 17.7439 7.31731 17.7357 7.12109C17.7766 7.16197 17.8093 7.20286 17.8256 7.22738C17.8665 7.28461 17.8992 7.3173 17.8829 7.43994H17.8665H17.8747ZM17.7357 7.12928C17.7602 7.30914 17.8093 7.43178 17.8747 7.43178C17.8747 7.33367 17.8584 7.30096 17.8093 7.24373C17.7848 7.21102 17.7602 7.17833 17.7275 7.12928H17.7357Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9223 7.66972C18.0613 7.7106 18.2166 7.38358 18.2166 7.14648C18.1594 7.41629 17.8569 7.52256 17.9223 7.66972Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9463 7.67667H17.9218C17.8809 7.58674 17.9463 7.51316 18.0199 7.43141C18.0935 7.34965 18.1752 7.25972 18.1998 7.12891C18.2161 7.3006 18.1425 7.52134 18.0444 7.61127C18.0117 7.65215 17.979 7.66849 17.9463 7.66849V7.67667ZM18.1998 7.13707C18.1916 7.26788 18.1016 7.36599 18.0281 7.44775C17.9545 7.52951 17.8973 7.5949 17.9218 7.66849H17.9381C17.9381 7.66849 18.0035 7.65214 18.0281 7.61943C18.1262 7.52132 18.1998 7.30876 18.1916 7.14525L18.1998 7.13707Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.874 7.66138C17.9312 7.53875 17.8249 7.54692 17.7432 7.32617C17.7186 7.56327 17.7595 7.66138 17.874 7.66138Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8738 7.66894C17.8329 7.66894 17.8002 7.66077 17.7757 7.62807C17.7348 7.58719 17.7184 7.4809 17.7348 7.31738C17.7838 7.41549 17.8247 7.46456 17.8492 7.50543C17.8901 7.55449 17.9065 7.58719 17.8819 7.65259H17.8656L17.8738 7.66894ZM17.743 7.33375C17.743 7.48909 17.743 7.57901 17.792 7.62807C17.8165 7.65259 17.8411 7.66078 17.8738 7.66078C17.8983 7.60355 17.8738 7.57902 17.8411 7.52996C17.8084 7.48908 17.7757 7.44004 17.7348 7.33375H17.743Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.915 7.90714C18.0949 7.93984 18.1848 7.53924 18.2748 7.35938C18.1031 7.60465 17.8905 7.74362 17.915 7.90714Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9378 7.92388H17.9133C17.8887 7.80124 17.9786 7.70311 18.0849 7.5723C18.1422 7.50689 18.1994 7.4415 18.2566 7.35156C18.2566 7.40879 18.2321 7.45786 18.2157 7.51509C18.1422 7.70313 18.0604 7.91569 17.9296 7.91569L17.9378 7.92388ZM18.2648 7.35975C18.2239 7.44968 18.1585 7.52326 18.1013 7.58867C17.9868 7.7113 17.9051 7.80941 17.9214 7.91569H17.9296C18.0441 7.91569 18.134 7.69496 18.1994 7.51509C18.2239 7.45786 18.2403 7.4088 18.2648 7.35975Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8738 7.89843C17.9229 7.75126 17.7757 7.75945 17.7021 7.54688C17.7103 7.82485 17.7512 7.92296 17.8738 7.89843Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8497 7.90696C17.7352 7.90696 17.7107 7.77616 17.6943 7.53906C17.7434 7.629 17.7925 7.68621 17.8333 7.72709C17.8824 7.77614 17.9151 7.81702 17.8824 7.89877L17.8497 7.90696ZM17.7025 7.53906C17.727 7.79251 17.7679 7.88243 17.8497 7.88243H17.8742C17.8987 7.80885 17.8742 7.78433 17.8251 7.73527C17.7843 7.69439 17.7352 7.63717 17.7025 7.53906Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9309 8.14327C18.0453 8.15144 18.2415 7.83257 18.2497 7.64453C18.1516 7.8571 17.8491 7.9961 17.9309 8.14327Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.9311 8.15961C17.8738 8.0615 17.9638 7.97975 18.0537 7.88164C18.1273 7.80805 18.2009 7.73446 18.2417 7.64453C18.2499 7.84075 18.0537 8.15961 17.9311 8.15961ZM18.2417 7.65272C18.2172 7.75082 18.1436 7.8244 18.0701 7.89798C17.9801 7.99609 17.8984 8.06969 17.9392 8.15145C18.0455 8.15145 18.2417 7.84076 18.2417 7.65272Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8411 8.11181C17.8902 7.95647 17.7594 7.95648 17.7021 7.79297C17.7021 8.04642 17.743 8.13634 17.8411 8.11181Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8164 8.11939C17.8164 8.11939 17.7673 8.11938 17.7428 8.08668C17.7019 8.0458 17.6855 7.95587 17.6937 7.78418C17.7346 7.84959 17.7673 7.89048 17.8 7.92318C17.849 7.97223 17.8817 8.0131 17.849 8.11121H17.8164V8.11939ZM17.6937 7.79236C17.7019 7.95588 17.7264 8.03763 17.7591 8.08668C17.7755 8.10303 17.7918 8.11121 17.8164 8.11121H17.8409C17.8654 8.02945 17.8245 7.99676 17.7837 7.94771C17.7509 7.915 17.7182 7.86593 17.6855 7.80052L17.6937 7.79236Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8488 8.38118C18.045 8.41388 18.0941 8.16043 18.2167 7.89062C18.1023 8.1032 17.8406 8.21766 17.8488 8.38118Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8815 8.38971C17.8815 8.38971 17.8569 8.38971 17.8488 8.38971C17.8324 8.28342 17.9142 8.20168 18.0123 8.11992C18.0777 8.05451 18.1595 7.98092 18.2085 7.88281C18.2085 7.94004 18.184 7.99728 18.1595 8.04634C18.0859 8.23438 18.0205 8.39789 17.8815 8.39789V8.38971ZM18.1922 7.92371C18.1513 8.00546 18.0859 8.07087 18.0286 8.1281C17.9305 8.21803 17.857 8.29161 17.8651 8.37336C17.8651 8.37336 17.8815 8.37336 17.8897 8.37336C18.0205 8.37336 18.0777 8.2262 18.1513 8.03815C18.1676 7.99728 18.184 7.96459 18.1922 7.92371Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8325 8.3473C17.8979 8.20831 17.7425 8.2083 17.6689 8.00391C17.6689 8.29823 17.7098 8.38 17.8325 8.3473Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7916 8.36364C17.7916 8.36364 17.7425 8.35549 17.7262 8.33096C17.6853 8.29008 17.6689 8.18377 17.6689 8.00391C17.718 8.09384 17.7671 8.14291 17.7998 8.17562C17.8488 8.23285 17.8897 8.26554 17.8488 8.3473C17.8243 8.35548 17.808 8.36364 17.7916 8.36364ZM17.6689 8.01209C17.6853 8.18378 17.7017 8.29008 17.7425 8.33096C17.7671 8.35549 17.7916 8.35548 17.8407 8.3473C17.8734 8.27372 17.8407 8.2492 17.7916 8.20014C17.7507 8.15926 17.7016 8.11021 17.6689 8.02027V8.01209Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1139 8.59389C16.9423 8.59389 16.9014 8.34861 16.9014 8.2832C16.9913 8.29955 17.1466 8.4549 17.1139 8.59389Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1139 8.60988C16.9341 8.60988 16.9014 8.35642 16.9014 8.29102C16.9668 8.29102 17.0404 8.34825 17.0812 8.42183C17.1139 8.46271 17.1467 8.5363 17.1221 8.60988H17.1139ZM16.9096 8.2992C16.9177 8.35643 16.9504 8.59352 17.1139 8.59352C17.1139 8.55264 17.0976 8.49542 17.0649 8.43002C17.024 8.36461 16.9504 8.30738 16.9014 8.2992H16.9096Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1139 8.59389C16.9423 8.59389 16.9014 8.34861 16.9014 8.2832C16.9913 8.29955 17.1466 8.4549 17.1139 8.59389Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1139 8.60988C16.9341 8.60988 16.9014 8.35642 16.9014 8.29102C16.9668 8.29102 17.0404 8.34825 17.0812 8.42183C17.1139 8.46271 17.1467 8.5363 17.1221 8.60988H17.1139ZM16.9096 8.2992C16.9177 8.35643 16.9504 8.59352 17.1139 8.59352C17.1139 8.55264 17.0976 8.49542 17.0649 8.43002C17.024 8.36461 16.9504 8.30738 16.9014 8.2992H16.9096Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4651 7.47363C17.3915 7.71073 17.367 7.81702 17.4651 7.89061C17.5877 7.81702 17.5142 7.67803 17.4651 7.47363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4567 7.89876C17.3504 7.82518 17.3831 7.71073 17.4567 7.47363L17.4975 7.57174C17.5384 7.7189 17.5711 7.83338 17.4648 7.89061L17.4567 7.89876ZM17.4567 7.47363C17.3994 7.69438 17.3749 7.80066 17.4567 7.87424C17.5466 7.81701 17.5221 7.71073 17.4812 7.57174L17.4567 7.47363Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4235 8.07834C17.4726 7.90665 17.3499 7.86578 17.2764 7.67773C17.2764 7.93118 17.3009 8.11922 17.4235 8.07834Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3918 8.0869C17.3918 8.0869 17.3509 8.07054 17.3345 8.06237C17.2855 8.00514 17.261 7.87432 17.2691 7.66992C17.31 7.7435 17.3427 7.78439 17.3754 7.83345C17.4245 7.90703 17.4654 7.97243 17.4326 8.07871C17.4326 8.07871 17.3999 8.09508 17.3918 8.09508V8.0869ZM17.2691 7.67811C17.2691 7.87432 17.3018 7.99697 17.3427 8.04603C17.3591 8.06238 17.3754 8.07055 17.3918 8.07055H17.4163C17.4408 7.97244 17.4163 7.92337 17.3591 7.84979C17.3264 7.80891 17.2937 7.75987 17.2691 7.68629V7.67811Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4736 8.11936C17.5635 8.15206 17.678 7.9395 17.6207 7.71875C17.5553 7.91497 17.3918 7.96402 17.4736 8.11936Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4964 8.12754H17.4719C17.4147 8.02125 17.4555 7.96402 17.5128 7.89043C17.5455 7.84956 17.5864 7.79233 17.6109 7.71875C17.6681 7.86591 17.6354 8.00488 17.5782 8.07846C17.5537 8.11116 17.521 8.12754 17.4964 8.12754ZM17.6109 7.71875C17.6027 7.80051 17.5618 7.84954 17.5291 7.89859C17.4801 7.97218 17.4392 8.02124 17.4882 8.11117H17.5046C17.5046 8.11117 17.5537 8.08665 17.57 8.06212C17.6191 7.98854 17.66 7.85774 17.6109 7.71875Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3756 8.30821C17.4655 8.16105 17.3265 8.16106 17.2529 7.96484C17.2529 8.21829 17.2693 8.32456 17.3756 8.30821Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3495 8.31444C17.3495 8.31444 17.3087 8.30627 17.2923 8.28992C17.2514 8.24904 17.2351 8.15911 17.2433 7.96289C17.2841 8.03647 17.325 8.07735 17.3577 8.11823C17.4068 8.17546 17.4395 8.21633 17.3823 8.30626H17.3495V8.31444ZM17.2433 7.97107C17.2514 8.15912 17.2678 8.24903 17.3086 8.28173C17.3168 8.29809 17.3332 8.2981 17.3495 8.2981H17.3741C17.4149 8.22452 17.3904 8.19181 17.3414 8.13458C17.3087 8.0937 17.2678 8.04466 17.2433 7.97107Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3758 8.53604C17.4412 8.3807 17.294 8.4052 17.2041 8.20898C17.2041 8.50331 17.245 8.56056 17.3758 8.53604Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3333 8.55238C17.3333 8.55238 17.2761 8.53602 17.2516 8.51967C17.2107 8.47879 17.1943 8.38885 17.1943 8.20898C17.2434 8.28257 17.2925 8.33162 17.3333 8.36433C17.3906 8.41338 17.4233 8.44609 17.3824 8.54419C17.3579 8.54419 17.3497 8.55238 17.3333 8.55238ZM17.1943 8.21717C17.2107 8.38068 17.227 8.47878 17.2597 8.51148C17.2843 8.52784 17.317 8.53603 17.366 8.52785C17.3987 8.44609 17.366 8.42156 17.317 8.37251C17.2761 8.33981 17.227 8.29892 17.1943 8.20898V8.21717Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4413 8.31557C17.5149 8.31557 17.6703 8.17657 17.6294 8.00488C17.564 8.15205 17.3759 8.1357 17.4413 8.31557Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4493 8.32473C17.4002 8.20209 17.4574 8.16121 17.5146 8.12033C17.5555 8.08763 17.6046 8.06309 17.6209 8.00586C17.6618 8.11214 17.621 8.1939 17.5882 8.23478C17.5474 8.28384 17.4901 8.32473 17.4493 8.32473ZM17.6209 8.01404C17.6128 8.07945 17.5637 8.11215 17.5228 8.13668C17.4656 8.17755 17.4247 8.21025 17.4493 8.30836C17.4901 8.30836 17.5392 8.2675 17.5719 8.22662C17.6046 8.18574 17.6455 8.11215 17.6128 8.01404H17.6209Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4248 8.52027C17.5556 8.5448 17.6455 8.34859 17.6292 8.21777C17.5311 8.34041 17.3921 8.34858 17.4248 8.52027Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4488 8.52785H17.4242C17.3997 8.40522 17.4651 8.35614 17.5223 8.30709C17.5551 8.28256 17.5959 8.24986 17.6286 8.20898C17.6532 8.29892 17.6286 8.40521 17.5632 8.47062C17.5305 8.50332 17.4978 8.52785 17.457 8.52785H17.4488ZM17.6286 8.21717C17.6041 8.26622 17.5714 8.29075 17.5305 8.31527C17.4651 8.36433 17.4161 8.4052 17.4324 8.51148H17.4488C17.4488 8.51148 17.5142 8.48698 17.5469 8.45427C17.6041 8.39704 17.6368 8.29074 17.6286 8.20898V8.21717Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4651 7.47363C17.3915 7.71073 17.367 7.81702 17.4651 7.89061C17.5877 7.81702 17.5142 7.67803 17.4651 7.47363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4567 7.89876C17.3504 7.81701 17.3831 7.71073 17.4567 7.47363L17.4975 7.57174C17.5384 7.7189 17.5711 7.83338 17.4648 7.89061L17.4567 7.89876ZM17.4567 7.48182C17.3994 7.70256 17.3749 7.80884 17.4567 7.88242C17.5466 7.82519 17.5221 7.71891 17.4812 7.57992L17.4567 7.48182Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4235 8.07834C17.4726 7.90665 17.3499 7.86578 17.2764 7.67773C17.2764 7.93118 17.3009 8.11922 17.4235 8.07834Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3918 8.0869C17.3918 8.0869 17.3509 8.07054 17.3345 8.06237C17.2855 8.00514 17.261 7.87432 17.2691 7.66992C17.31 7.7435 17.3427 7.78439 17.3754 7.83345C17.4245 7.90703 17.4654 7.97243 17.4326 8.07871L17.3999 8.09508L17.3918 8.0869ZM17.2691 7.67811C17.2691 7.87432 17.3018 7.99697 17.3427 8.04603C17.3591 8.06238 17.3754 8.07055 17.3918 8.07055H17.4163C17.4408 7.97244 17.4163 7.92337 17.3591 7.84979C17.3264 7.80891 17.2937 7.75987 17.2691 7.68629V7.67811Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4736 8.11936C17.5635 8.15206 17.678 7.9395 17.6207 7.71875C17.5553 7.91497 17.3918 7.96402 17.4736 8.11936Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4964 8.12754H17.4719C17.4147 8.02125 17.4555 7.96402 17.5128 7.89043C17.5455 7.84956 17.5864 7.79233 17.6109 7.71875C17.6681 7.86591 17.6354 8.00488 17.5782 8.07846C17.5537 8.11116 17.521 8.12754 17.4964 8.12754ZM17.6109 7.71875C17.6027 7.80051 17.5618 7.84954 17.5291 7.89859C17.4801 7.97218 17.4392 8.02124 17.4882 8.11117H17.5046C17.5046 8.11117 17.5537 8.08665 17.57 8.06212C17.6191 7.98854 17.66 7.85774 17.6109 7.71875Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3756 8.30821C17.4655 8.16105 17.3265 8.16106 17.2529 7.96484C17.2529 8.21829 17.2693 8.32456 17.3756 8.30821Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3495 8.31444C17.3495 8.31444 17.3087 8.30627 17.2923 8.28992C17.2514 8.24904 17.2351 8.15911 17.2433 7.96289C17.2841 8.03647 17.325 8.07735 17.3577 8.11823C17.4068 8.17546 17.4395 8.21633 17.3823 8.30626H17.3495V8.31444ZM17.2433 7.97107C17.2514 8.15912 17.2678 8.24903 17.3086 8.28173C17.3168 8.29809 17.3332 8.2981 17.3495 8.2981H17.3741C17.4149 8.22452 17.3904 8.19181 17.3414 8.13458C17.3087 8.0937 17.2678 8.04466 17.2433 7.97107Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3758 8.53604C17.4412 8.3807 17.294 8.4052 17.2041 8.20898C17.2041 8.50331 17.245 8.56056 17.3758 8.53604Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3333 8.55238C17.3333 8.55238 17.2761 8.53602 17.2516 8.51967C17.2107 8.47879 17.1943 8.38885 17.1943 8.20898C17.2434 8.28257 17.2925 8.33162 17.3333 8.36433C17.3906 8.41338 17.4233 8.44609 17.3824 8.54419C17.3579 8.54419 17.3497 8.55238 17.3333 8.55238ZM17.1943 8.21717C17.2107 8.38068 17.227 8.47878 17.2597 8.51148C17.2843 8.52784 17.317 8.53603 17.366 8.52785C17.3987 8.44609 17.366 8.42156 17.317 8.37251C17.2761 8.33981 17.227 8.29892 17.1943 8.20898V8.21717Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4413 8.31557C17.5149 8.31557 17.6703 8.17657 17.6294 8.00488C17.564 8.15205 17.3759 8.1357 17.4413 8.31557Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4493 8.32473C17.4002 8.20209 17.4574 8.16121 17.5146 8.12033C17.5555 8.08763 17.6046 8.06309 17.6209 8.00586C17.6618 8.11214 17.621 8.1939 17.5882 8.23478C17.5474 8.28384 17.4901 8.32473 17.4493 8.32473ZM17.6209 8.01404C17.6128 8.07945 17.5637 8.11215 17.5228 8.13668C17.4656 8.17755 17.4247 8.21025 17.4493 8.30836C17.4901 8.30836 17.5392 8.2675 17.5719 8.22662C17.6046 8.18574 17.6455 8.11215 17.6128 8.01404H17.6209Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4248 8.52027C17.5556 8.5448 17.6455 8.34859 17.6292 8.21777C17.5311 8.34041 17.3921 8.34858 17.4248 8.52027Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4488 8.52785H17.4242C17.3997 8.40522 17.4651 8.35614 17.5223 8.30709C17.5551 8.28256 17.5959 8.24986 17.6286 8.20898C17.6532 8.29892 17.6286 8.40521 17.5632 8.47062C17.5305 8.50332 17.4978 8.52785 17.457 8.52785H17.4488ZM17.6286 8.21717C17.6041 8.26622 17.5714 8.29075 17.5305 8.31527C17.4651 8.36433 17.4161 8.4052 17.4324 8.51148H17.4488C17.4488 8.51148 17.5142 8.48698 17.5469 8.45427C17.6041 8.39704 17.6368 8.29074 17.6286 8.20898V8.21717Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M18.2162 8.19336C18.2162 8.19336 18.2734 8.19336 18.2571 8.24241C18.2571 8.30782 18.159 8.65121 17.9873 8.76567C17.8728 8.85561 17.2433 8.9864 16.9653 9.05181C16.81 9.08451 16.6792 9.15809 16.5811 9.28073C16.6219 9.11721 16.6546 9.00276 16.7119 8.8556C16.7609 8.72478 16.8999 8.57762 17.0471 8.57762C17.3169 8.56945 17.6684 8.54493 17.9218 8.43046C18.0527 8.37323 18.1344 8.29964 18.2162 8.19336Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M18.2162 8.19336C18.2162 8.19336 18.2734 8.19336 18.2571 8.24241C18.2571 8.30782 18.159 8.65121 17.9873 8.76567C17.8728 8.85561 17.2433 8.9864 16.9653 9.05181C16.81 9.08451 16.6792 9.15809 16.5811 9.28073C16.6219 9.11721 16.6546 9.00276 16.7119 8.8556C16.7609 8.72478 16.8999 8.57762 17.0471 8.57762C17.3169 8.56945 17.6684 8.54493 17.9218 8.43046C18.0527 8.37323 18.1344 8.29964 18.2162 8.19336Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8324 8.99307C17.8569 8.87861 17.8324 8.84588 17.8569 8.66602C17.6852 8.89494 17.7507 9.00124 17.8324 8.99307Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8247 9.00157C17.8247 9.00157 17.7675 8.98523 17.7593 8.9607C17.7266 8.8953 17.7593 8.78902 17.8574 8.6582C17.8574 8.75631 17.8574 8.81354 17.8574 8.8626C17.8574 8.90348 17.8574 8.94436 17.8574 8.99341H17.8329L17.8247 9.00157ZM17.8493 8.67455C17.7348 8.85441 17.7512 8.93618 17.7675 8.9607C17.7757 8.98523 17.8002 8.99341 17.8247 8.99341H17.8329C17.8329 8.94436 17.8329 8.91164 17.8329 8.87076C17.8329 8.8217 17.8329 8.76448 17.8411 8.67455H17.8493Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8483 9.02669C17.9628 9.0594 18.2571 8.79778 18.2653 8.60156C18.1917 8.73238 17.7911 8.88771 17.8483 9.02669Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8744 9.03488H17.8499C17.8009 8.94494 17.9235 8.86318 18.0543 8.77325C18.1442 8.71602 18.226 8.65879 18.2587 8.60156C18.2587 8.79778 17.9971 9.03488 17.8744 9.03488ZM18.2587 8.60975C18.2423 8.66698 18.1524 8.73238 18.0707 8.78961C17.9562 8.87137 17.8336 8.95311 17.8663 9.02669H17.8744C17.9971 9.02669 18.2505 8.78961 18.2587 8.60975Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6692 9.19045C17.751 9.14958 17.7265 8.9697 17.6529 8.9043C17.6365 9.07599 17.5302 9.18228 17.6692 9.19045Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6691 9.19864C17.6691 9.19864 17.6118 9.19864 17.6037 9.17411C17.5873 9.14958 17.6037 9.10869 17.6119 9.05964C17.6282 9.01876 17.6445 8.96153 17.6445 8.9043C17.7018 8.937 17.7345 9.02693 17.7263 9.10051C17.7263 9.14956 17.7018 9.18229 17.6773 9.19864H17.6691ZM17.6445 8.91248C17.6527 8.96971 17.6445 9.02694 17.62 9.06782C17.6037 9.1087 17.5955 9.14958 17.6119 9.16593C17.6119 9.18228 17.6364 9.18227 17.6609 9.18227C17.6854 9.16592 17.6936 9.14139 17.7018 9.10051C17.7018 9.02693 17.6854 8.94518 17.6445 8.91248Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7505 9.24037C17.8813 9.28125 18.0449 9.03597 18.1511 8.92969C18.0203 9.04415 17.6361 9.09321 17.7505 9.24037Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7839 9.25476H17.7512C17.7267 9.23023 17.7185 9.20571 17.7267 9.18118C17.7431 9.12395 17.8412 9.08308 17.9556 9.03402C18.0292 9.00132 18.1028 8.96861 18.1518 8.92773C18.1355 8.96861 18.1028 9.00133 18.0701 9.04221C17.9802 9.14032 17.882 9.26294 17.7839 9.26294V9.25476ZM18.111 8.96044C18.0701 8.99315 18.0128 9.01768 17.9556 9.04221C17.8575 9.08309 17.7512 9.12395 17.7349 9.18118C17.7349 9.19753 17.7349 9.22207 17.7512 9.23842H17.7758C17.8657 9.23842 17.9556 9.12396 18.0456 9.03402C18.0619 9.0095 18.0864 8.99316 18.1028 8.96863L18.111 8.96044Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5554 9.363C17.6535 9.2976 17.5554 9.17496 17.5554 8.92969C17.4573 9.10138 17.441 9.34665 17.5554 9.363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5548 9.37119C17.5548 9.37119 17.5058 9.35484 17.4894 9.32213C17.4485 9.24038 17.4731 9.06868 17.5467 8.92969C17.5712 9.0278 17.5794 9.10139 17.5957 9.16679C17.6121 9.2649 17.6284 9.33849 17.563 9.37937L17.5548 9.37119ZM17.5548 8.92969C17.4976 9.0605 17.4731 9.23218 17.5139 9.30577C17.5221 9.33029 17.5467 9.34666 17.563 9.34666C17.6121 9.30578 17.6039 9.24854 17.5875 9.15861C17.5712 9.10138 17.563 9.01962 17.5548 8.92969Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5792 9.42764C17.6283 9.49304 17.988 9.27228 18.0779 9.10059C17.7673 9.32951 17.4975 9.29682 17.5792 9.42764Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6122 9.44335C17.6122 9.44335 17.5795 9.43518 17.5713 9.42701C17.555 9.40248 17.5468 9.38612 17.555 9.36977C17.5631 9.33707 17.6204 9.31253 17.7021 9.27982C17.8002 9.24712 17.9311 9.18991 18.07 9.0918C18.0046 9.24714 17.7103 9.44335 17.604 9.44335H17.6122ZM18.0782 9.0918C17.9474 9.20626 17.8166 9.25531 17.7185 9.29619C17.6449 9.32889 17.5877 9.34525 17.5795 9.37795C17.5795 9.39431 17.5795 9.40247 17.5795 9.41882H17.604C17.7021 9.41882 17.9883 9.23079 18.07 9.0918H18.0782Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5393 9.63204C17.6292 9.56664 17.4657 9.39494 17.4248 9.16602C17.4248 9.44399 17.3839 9.65657 17.5393 9.63204Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5141 9.6402C17.5141 9.6402 17.4733 9.63203 17.4569 9.61567C17.416 9.5748 17.416 9.46851 17.416 9.31317C17.416 9.27229 17.416 9.21507 17.416 9.16602C17.4487 9.26413 17.4896 9.35406 17.5223 9.41946C17.5632 9.51757 17.5959 9.59115 17.5387 9.6402H17.5141ZM17.4324 9.23141C17.4324 9.23141 17.4324 9.28865 17.4324 9.31317C17.4324 9.45216 17.4324 9.55845 17.4651 9.59933C17.4732 9.61568 17.4896 9.61567 17.506 9.61567H17.5305C17.5714 9.58297 17.5387 9.51757 17.4978 9.41946C17.4733 9.36223 17.4487 9.29683 17.4242 9.22325L17.4324 9.23141Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.637 9.5591C17.6779 9.62451 17.9559 9.44463 18.0785 9.24023C17.8986 9.40375 17.588 9.44464 17.637 9.5591Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6693 9.57421C17.6693 9.57421 17.6366 9.55787 17.6284 9.55787C17.5957 9.47611 17.6938 9.42704 17.8165 9.36981C17.8982 9.32894 17.9963 9.27989 18.0699 9.22266C17.98 9.4107 17.7592 9.57421 17.6693 9.57421ZM18.0699 9.22266C18.0045 9.29624 17.9064 9.34528 17.8246 9.38616C17.7102 9.43521 17.6202 9.4761 17.6448 9.54968H17.6693C17.7592 9.55786 17.9718 9.39435 18.0699 9.22266Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3516 9.86872C17.4497 9.85236 17.4416 9.59893 17.3598 9.39453C17.2699 9.6398 17.2372 9.89324 17.3516 9.86872Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3413 9.87727C17.3413 9.87727 17.3086 9.87727 17.3004 9.85274C17.2513 9.77916 17.3004 9.56659 17.3576 9.38672C17.4394 9.55841 17.4557 9.75464 17.4067 9.8364C17.3903 9.86093 17.374 9.87727 17.3576 9.87727H17.3413ZM17.3576 9.3949C17.3004 9.60747 17.2677 9.78733 17.3085 9.84456C17.3085 9.85274 17.3331 9.86093 17.3413 9.86093H17.3576C17.374 9.86093 17.3903 9.85275 17.3985 9.82822C17.4394 9.75464 17.423 9.56659 17.3576 9.3949Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6044 9.72985C17.6371 9.77073 18.0459 9.48458 18.0377 9.37012C17.9069 9.55816 17.4736 9.59087 17.6044 9.72985Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6209 9.73741C17.6209 9.73741 17.6045 9.73742 17.6045 9.72925C17.5882 9.7129 17.58 9.68836 17.5882 9.66383C17.5882 9.61477 17.6781 9.58208 17.768 9.5412C17.8661 9.49214 17.9888 9.44309 18.0378 9.36133C18.0542 9.39403 18.0378 9.43491 17.9724 9.49214C17.8661 9.59843 17.6781 9.73741 17.6209 9.73741ZM18.0378 9.36133C17.9969 9.45126 17.8743 9.5085 17.7762 9.54938C17.6863 9.59026 17.6127 9.62295 17.6045 9.66383C17.6045 9.68018 17.6045 9.69653 17.6209 9.71288C17.6699 9.71288 17.858 9.59026 17.9642 9.4758C18.0133 9.42675 18.0378 9.38586 18.0378 9.36133Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1374 10.0975C17.2764 10.0402 17.211 9.81949 17.2355 9.57422C17.1292 9.81132 16.9984 10.0484 17.1374 10.0975Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1385 10.1135C17.1385 10.1135 17.0894 10.0807 17.0812 10.0562C17.0485 9.97446 17.1221 9.81094 17.1957 9.64743L17.2284 9.58203C17.2284 9.65561 17.2284 9.73736 17.2284 9.80277C17.2284 9.95811 17.2284 10.0726 17.1303 10.1135H17.1385ZM17.2284 9.58203L17.212 9.65561C17.1303 9.81913 17.0649 9.97446 17.0894 10.0562C17.0976 10.0726 17.114 10.0889 17.1303 10.0971C17.2202 10.0562 17.212 9.94176 17.212 9.80277C17.212 9.73736 17.212 9.65561 17.2202 9.58203H17.2284Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3916 9.90992C17.4161 9.9835 17.7432 9.84452 17.9067 9.60742C17.7105 9.76276 17.3344 9.77911 17.3916 9.90992Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4328 9.94298C17.4328 9.94298 17.392 9.92663 17.3838 9.91845C17.3838 9.9021 17.3838 9.88577 17.3838 9.86124C17.4083 9.81219 17.4901 9.78765 17.5963 9.74677C17.6944 9.70589 17.8171 9.67319 17.8988 9.59961C17.7844 9.804 17.5391 9.93482 17.4328 9.93482V9.94298ZM17.8988 9.60779C17.8253 9.68955 17.7108 9.72226 17.6045 9.76314C17.5064 9.79584 17.4165 9.82852 17.4001 9.8694C17.4001 9.88575 17.4001 9.89393 17.4001 9.90211C17.4001 9.91846 17.4165 9.91845 17.4328 9.91845C17.5309 9.91845 17.7762 9.78765 17.8988 9.59961V9.60779Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1787 10.1394C17.2441 10.2621 17.661 10.0413 17.7182 9.83691C17.5874 10.0168 17.1214 9.98407 17.1787 10.1394Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2527 10.1797C17.2527 10.1797 17.1872 10.1633 17.1709 10.1388C17.1709 10.1225 17.1709 10.0979 17.1709 10.0816C17.1954 10.0325 17.2935 10.008 17.3916 9.97528C17.5143 9.94258 17.6533 9.90988 17.7105 9.82812C17.6778 9.99982 17.3998 10.1797 17.2527 10.1797ZM17.7105 9.83631C17.6614 9.93442 17.5225 9.96711 17.3998 9.99981C17.3017 10.0243 17.2118 10.057 17.1872 10.0979C17.1872 10.1061 17.1872 10.1225 17.1872 10.1388C17.1954 10.1552 17.22 10.1715 17.2527 10.1715C17.3998 10.1715 17.6696 9.99981 17.7105 9.84447V9.83631Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3679 10.2282C17.4415 10.2364 17.6213 10.0974 17.6704 10.0156C17.5314 10.0892 17.3352 10.1873 17.3679 10.2282Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3744 10.2367H17.3662C17.3662 10.155 17.5134 10.0814 17.6605 10.0078C17.6197 10.0896 17.4562 10.2367 17.3744 10.2367ZM17.6605 10.016C17.5706 10.0732 17.3826 10.1713 17.3662 10.2204C17.4398 10.2204 17.6033 10.0978 17.6524 10.016H17.6605Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7443 9.34621C16.8342 9.35439 16.9487 9.19086 16.8751 9.02734C16.8342 9.19086 16.5726 9.31351 16.7443 9.34621Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7532 9.3544C16.7532 9.3544 16.696 9.33804 16.6878 9.32169C16.6796 9.28898 16.7123 9.25627 16.7532 9.2154C16.7941 9.15817 16.8513 9.10093 16.8677 9.02734C16.9249 9.1091 16.9167 9.20721 16.8677 9.28079C16.8349 9.32985 16.7941 9.3544 16.7532 9.3544ZM16.8677 9.03553C16.8677 9.10911 16.8104 9.16635 16.7614 9.22358C16.7287 9.26446 16.6959 9.29715 16.6959 9.3135C16.6959 9.32168 16.7205 9.33803 16.745 9.33803C16.745 9.33803 16.8186 9.31351 16.8431 9.27263C16.884 9.19905 16.8922 9.10911 16.8513 9.03553H16.8677Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.941 9.24796C17.0145 9.28884 17.1862 9.10079 17.1617 8.98633C17.0636 9.14167 16.8674 9.19073 16.941 9.24796Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.966 9.26467H16.9415C16.9252 9.24832 16.917 9.24016 16.917 9.2238C16.917 9.1911 16.9497 9.16656 16.9988 9.13386C17.0478 9.09298 17.1132 9.0521 17.1541 8.97852C17.1786 9.03575 17.1541 9.10935 17.0969 9.17475C17.056 9.23198 16.9987 9.26467 16.966 9.26467ZM17.1541 8.9867C17.1296 9.06028 17.0641 9.10935 17.0069 9.15023C16.966 9.18293 16.9333 9.19928 16.9333 9.2238V9.24833H16.966C16.9987 9.24833 17.0478 9.21562 17.0887 9.16657C17.1296 9.11751 17.1704 9.04393 17.1541 8.9867Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7375 9.52672C16.8029 9.59213 17.1381 9.24873 17.2362 9.10156C16.9501 9.34684 16.6557 9.41226 16.7375 9.52672Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7622 9.54146C16.7622 9.54146 16.7377 9.53329 16.7295 9.52511C16.7132 9.50876 16.705 9.48423 16.7132 9.46788C16.7213 9.41882 16.7949 9.36976 16.9012 9.31253C16.9993 9.2553 17.1056 9.18991 17.2282 9.0918C17.1465 9.23896 16.8603 9.54146 16.7622 9.54146ZM17.2282 9.09996C17.122 9.20624 17.0075 9.27165 16.9176 9.32888C16.8195 9.39428 16.7459 9.42701 16.7377 9.47606C16.7377 9.48424 16.7377 9.50058 16.7377 9.51693H16.754C16.844 9.51693 17.1219 9.23896 17.2201 9.0918L17.2282 9.09996Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6556 9.72141C16.7046 9.80317 16.9254 9.55791 17.0644 9.35352C16.8927 9.53338 16.5902 9.60695 16.6556 9.72141Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6882 9.74631C16.6882 9.74631 16.6637 9.74632 16.6555 9.72997C16.6146 9.65638 16.7045 9.59914 16.8272 9.53373C16.9089 9.48468 16.9989 9.42745 17.0725 9.36205C16.9825 9.52556 16.7863 9.75449 16.6964 9.75449L16.6882 9.74631ZM17.0643 9.35389C17.0071 9.43564 16.9089 9.49286 16.8272 9.54191C16.7209 9.60732 16.631 9.65637 16.6637 9.7136H16.6882C16.7618 9.72177 16.9416 9.53375 17.0643 9.3457V9.35389Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6791 9.5344C16.7363 9.39542 16.6464 9.37091 16.6055 9.19922C16.5238 9.28915 16.532 9.56711 16.6791 9.5344Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6648 9.54138C16.6239 9.54138 16.5912 9.51686 16.5667 9.47598C16.5258 9.39422 16.5421 9.24705 16.5993 9.18164C16.6239 9.24705 16.6484 9.2961 16.6648 9.3288C16.6975 9.39421 16.7138 9.4351 16.6893 9.52503H16.6648V9.54138ZM16.5993 9.19801C16.5666 9.26341 16.5503 9.4024 16.5912 9.47598C16.5994 9.50051 16.6239 9.53319 16.6648 9.53319H16.6811C16.7056 9.45144 16.6811 9.41876 16.6566 9.35335C16.6402 9.31247 16.6157 9.26341 16.5993 9.19801Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5895 9.73011C16.6876 9.69741 16.524 9.51753 16.4832 9.38672C16.4668 9.62382 16.4668 9.74646 16.5895 9.73011Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5659 9.73827C16.5659 9.73827 16.525 9.73827 16.5087 9.71375C16.4678 9.67287 16.4678 9.56659 16.476 9.38672C16.5087 9.4276 16.5332 9.47665 16.5659 9.53388C16.6068 9.60746 16.6476 9.67288 16.6231 9.70559C16.6231 9.72194 16.6068 9.7301 16.5904 9.73827H16.5659ZM16.476 9.38672C16.476 9.53388 16.476 9.65652 16.5168 9.6974C16.525 9.71375 16.5495 9.71375 16.5659 9.71375H16.5904C16.6313 9.66469 16.5904 9.59928 16.5495 9.53388C16.5168 9.48482 16.4923 9.43577 16.476 9.38672Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.4836 9.90125C16.5817 9.86854 16.4264 9.77044 16.4101 9.57422C16.361 9.6478 16.3365 9.92577 16.4836 9.90125Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.4674 9.9098C16.4674 9.9098 16.4101 9.89344 16.3938 9.85256C16.3529 9.77898 16.3693 9.61546 16.4102 9.56641C16.4347 9.66452 16.4674 9.72993 16.5001 9.77898C16.5246 9.81986 16.541 9.85256 16.5328 9.87709C16.5328 9.89344 16.5164 9.90162 16.5001 9.9098H16.4756H16.4674ZM16.4102 9.57459C16.3938 9.62364 16.3693 9.77898 16.4102 9.85256C16.4265 9.88527 16.4428 9.89343 16.4674 9.89343H16.4919C16.5246 9.86073 16.5082 9.82803 16.4919 9.79533C16.4592 9.74627 16.4265 9.67271 16.4183 9.58277L16.4102 9.57459Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3362 9.94144C16.4016 9.90874 16.3689 9.74523 16.2789 9.7207C16.2544 9.84334 16.2544 9.94144 16.3362 9.94144Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3371 9.95121C16.3371 9.95121 16.2962 9.95122 16.2798 9.93486C16.2553 9.90216 16.2471 9.83675 16.2716 9.73047C16.337 9.73047 16.3698 9.79586 16.3779 9.84492C16.3779 9.89397 16.3697 9.93485 16.3452 9.95121H16.3371ZM16.2798 9.73047C16.2798 9.7877 16.2635 9.87762 16.2962 9.9185C16.3043 9.93485 16.3207 9.93486 16.3371 9.93486C16.3534 9.92669 16.3698 9.8858 16.3616 9.84492C16.3616 9.79586 16.3289 9.74682 16.2716 9.73047H16.2798Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7443 9.34621C16.8342 9.35439 16.9487 9.19086 16.8751 9.02734C16.8342 9.19086 16.5726 9.31351 16.7443 9.34621Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7532 9.3544C16.7532 9.3544 16.696 9.33804 16.6878 9.32169C16.6796 9.28898 16.7123 9.25627 16.7532 9.2154C16.7941 9.15817 16.8513 9.10093 16.8677 9.02734C16.9249 9.1091 16.9167 9.20721 16.8677 9.28079C16.8349 9.32985 16.7941 9.3544 16.7532 9.3544ZM16.8677 9.03553C16.8677 9.10911 16.8104 9.16635 16.7614 9.22358C16.7287 9.26446 16.6959 9.29715 16.6959 9.3135C16.6959 9.32168 16.7205 9.33803 16.745 9.33803C16.745 9.33803 16.8186 9.31351 16.8431 9.27263C16.884 9.19905 16.8922 9.10911 16.8513 9.03553H16.8677Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.941 9.24796C17.0145 9.28884 17.1862 9.10079 17.1617 8.98633C17.0636 9.14167 16.8674 9.19073 16.941 9.24796Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.966 9.26467H16.9415C16.9415 9.26467 16.917 9.23198 16.917 9.2238C16.917 9.1911 16.9497 9.16656 16.9988 9.13386C17.0478 9.09298 17.1132 9.0521 17.1541 8.97852C17.1786 9.03575 17.1541 9.10935 17.0969 9.17475C17.056 9.23198 16.9987 9.26467 16.966 9.26467ZM17.1541 8.9867C17.1296 9.06028 17.0641 9.10935 17.0069 9.15023C16.966 9.18293 16.9333 9.19928 16.9333 9.2238V9.24833H16.966C16.9987 9.24833 17.0478 9.21562 17.0887 9.16657C17.1296 9.11751 17.1704 9.04393 17.1541 8.9867Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7375 9.52672C16.8029 9.59213 17.1381 9.24873 17.2362 9.10156C16.9501 9.34684 16.6557 9.41226 16.7375 9.52672Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7607 9.54146L16.728 9.52511C16.728 9.52511 16.7035 9.48423 16.7116 9.46788C16.7198 9.41882 16.7934 9.36976 16.8997 9.31253C16.9978 9.2553 17.1041 9.18991 17.2267 9.0918C17.1449 9.23896 16.8588 9.54146 16.7607 9.54146ZM17.2267 9.09996C17.1204 9.20624 17.006 9.27165 16.916 9.32888C16.8179 9.39428 16.7443 9.42701 16.7362 9.47606C16.7362 9.48424 16.7362 9.50058 16.7362 9.51693H16.7525C16.8424 9.51693 17.1204 9.23896 17.2185 9.0918L17.2267 9.09996Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6556 9.72141C16.7046 9.80317 16.9254 9.55791 17.0644 9.35352C16.8927 9.53338 16.5902 9.60695 16.6556 9.72141Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6882 9.74631C16.6882 9.74631 16.6637 9.74632 16.6555 9.72997C16.6146 9.65638 16.7045 9.59914 16.8272 9.53373C16.9089 9.48468 16.9989 9.42745 17.0725 9.36205C16.9825 9.52556 16.7863 9.75449 16.6964 9.75449L16.6882 9.74631ZM17.0643 9.35389C17.0071 9.43564 16.9089 9.49286 16.8272 9.54191C16.7209 9.60732 16.631 9.65637 16.6637 9.7136H16.6882C16.7618 9.72177 16.9416 9.53375 17.0643 9.3457V9.35389Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6791 9.5344C16.7363 9.39542 16.6464 9.37091 16.6055 9.19922C16.5238 9.28915 16.532 9.56711 16.6791 9.5344Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6648 9.54138C16.6239 9.54138 16.5912 9.51686 16.5667 9.47598C16.5258 9.39422 16.5421 9.24705 16.5993 9.18164C16.6239 9.24705 16.6484 9.2961 16.6648 9.3288C16.6975 9.39421 16.7138 9.4351 16.6893 9.52503H16.6648V9.54138ZM16.5993 9.19801C16.5666 9.26341 16.5503 9.4024 16.5912 9.47598C16.5994 9.50051 16.6239 9.53319 16.6648 9.53319H16.6811C16.7056 9.45144 16.6811 9.41876 16.6566 9.35335C16.6402 9.31247 16.6157 9.26341 16.5993 9.19801Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5895 9.73011C16.6876 9.69741 16.524 9.51753 16.4832 9.38672C16.4668 9.62382 16.4668 9.74646 16.5895 9.73011Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5659 9.73827C16.5659 9.73827 16.525 9.73827 16.5087 9.71375C16.4678 9.67287 16.4678 9.56659 16.476 9.38672C16.5087 9.4276 16.5332 9.47665 16.5659 9.53388C16.6068 9.60746 16.6476 9.67288 16.6231 9.70559C16.6231 9.72194 16.6068 9.7301 16.5904 9.73827H16.5659ZM16.476 9.38672C16.476 9.53388 16.476 9.65652 16.5168 9.6974C16.525 9.71375 16.5495 9.71375 16.5659 9.71375H16.5904C16.6313 9.66469 16.5904 9.59928 16.5495 9.53388C16.5168 9.48482 16.4923 9.43577 16.476 9.38672Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.4836 9.90125C16.5817 9.86854 16.4264 9.77044 16.4101 9.57422C16.361 9.6478 16.3365 9.92577 16.4836 9.90125Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.4674 9.9098C16.4674 9.9098 16.4101 9.89344 16.3938 9.85256C16.3529 9.77898 16.3693 9.61546 16.4102 9.56641C16.4347 9.66452 16.4674 9.72993 16.5001 9.77898C16.5246 9.81986 16.541 9.85256 16.5328 9.87709C16.5328 9.89344 16.5164 9.90162 16.5001 9.9098H16.4756H16.4674ZM16.4102 9.57459C16.3938 9.62364 16.3693 9.77898 16.4102 9.85256C16.4265 9.88527 16.4428 9.89343 16.4674 9.89343H16.4919C16.5246 9.86073 16.5082 9.82803 16.4919 9.79533C16.4592 9.74627 16.4265 9.67271 16.4183 9.58277L16.4102 9.57459Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3362 9.94144C16.4016 9.90874 16.3689 9.74523 16.2789 9.7207C16.2544 9.84334 16.2544 9.94144 16.3362 9.94144Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3371 9.95121C16.3371 9.95121 16.2962 9.95122 16.2798 9.93486C16.2553 9.90216 16.2471 9.83675 16.2716 9.73047C16.337 9.73047 16.3698 9.79586 16.3779 9.84492C16.3779 9.89397 16.3697 9.93485 16.3452 9.95121H16.3371ZM16.2798 9.73047C16.2798 9.7877 16.2635 9.87762 16.2962 9.9185C16.3043 9.93485 16.3207 9.93486 16.3371 9.93486C16.3534 9.92669 16.3698 9.8858 16.3616 9.84492C16.3616 9.79586 16.3289 9.74682 16.2716 9.73047H16.2798Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8324 8.99307C17.8569 8.87861 17.8324 8.84588 17.8569 8.66602C17.6852 8.89494 17.7507 9.00124 17.8324 8.99307Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8247 9.00157C17.8247 9.00157 17.7675 8.98523 17.7593 8.9607C17.7266 8.8953 17.7593 8.78902 17.8574 8.6582C17.8574 8.75631 17.8574 8.81354 17.8574 8.8626C17.8574 8.90348 17.8574 8.94436 17.8574 8.99341H17.8329L17.8247 9.00157ZM17.8493 8.67455C17.7348 8.85441 17.7512 8.93618 17.7675 8.9607C17.7757 8.98523 17.8002 8.99341 17.8247 8.99341H17.8329C17.8329 8.94436 17.8329 8.91164 17.8329 8.87076C17.8329 8.8217 17.8329 8.76448 17.8411 8.67455H17.8493Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8483 9.02669C17.9628 9.0594 18.2571 8.79778 18.2653 8.60156C18.1917 8.73238 17.7911 8.88771 17.8483 9.02669Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8744 9.03488H17.8499C17.8009 8.94494 17.9235 8.86318 18.0543 8.77325C18.1442 8.71602 18.226 8.65879 18.2587 8.60156C18.2587 8.79778 17.9971 9.03488 17.8744 9.03488ZM18.2587 8.60975C18.2423 8.66698 18.1524 8.73238 18.0707 8.78961C17.9562 8.87137 17.8336 8.95311 17.8663 9.02669H17.8744C17.9971 9.02669 18.2505 8.78961 18.2587 8.60975Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6692 9.19045C17.751 9.14958 17.7265 8.9697 17.6529 8.9043C17.6365 9.07599 17.5302 9.18228 17.6692 9.19045Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6691 9.19864C17.6691 9.19864 17.6118 9.19046 17.6037 9.17411C17.5873 9.14958 17.6037 9.10869 17.6119 9.05964C17.6282 9.01876 17.6445 8.96153 17.6445 8.9043C17.7018 8.937 17.7345 9.02693 17.7263 9.10051C17.7263 9.14956 17.7018 9.18229 17.6773 9.19864H17.6691ZM17.6445 8.91248C17.6527 8.96971 17.6445 9.02694 17.62 9.06782C17.6037 9.1087 17.5955 9.14958 17.6119 9.16593C17.6119 9.18228 17.6364 9.18227 17.6609 9.18227C17.6854 9.16592 17.6936 9.14139 17.7018 9.10051C17.7018 9.02693 17.6854 8.94518 17.6445 8.91248Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7505 9.24037C17.8813 9.28125 18.0449 9.03597 18.1511 8.92969C18.0203 9.04415 17.6361 9.09321 17.7505 9.24037Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.7841 9.25513H17.7514C17.7514 9.25513 17.7187 9.19792 17.7269 9.17339C17.7432 9.11616 17.8414 9.07527 17.9558 9.02621C18.0294 8.99351 18.103 8.9608 18.152 8.91992C18.1357 8.9608 18.103 8.99352 18.0703 9.03439C17.9804 9.1325 17.8822 9.25513 17.7841 9.25513ZM18.1112 8.96082C18.0703 8.99352 18.013 9.01805 17.9558 9.04258C17.8577 9.08346 17.7514 9.12432 17.7351 9.18155C17.7351 9.1979 17.7351 9.22244 17.7514 9.23879H17.776C17.8659 9.23879 17.9558 9.12433 18.0458 9.03439C18.0621 9.00987 18.0866 8.99353 18.103 8.969L18.1112 8.96082Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5554 9.363C17.6535 9.2976 17.5554 9.17496 17.5554 8.92969C17.4573 9.10138 17.441 9.34665 17.5554 9.363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5636 9.37021C17.5636 9.37021 17.5146 9.35386 17.4982 9.32116C17.4573 9.2394 17.4819 9.0677 17.5554 8.92871C17.58 9.02682 17.5881 9.10041 17.6045 9.16582C17.6208 9.26393 17.6372 9.33752 17.5718 9.37839L17.5636 9.37021ZM17.5554 8.92871C17.4982 9.05952 17.4737 9.23121 17.5145 9.30479C17.5227 9.32932 17.5473 9.34568 17.5636 9.34568C17.6127 9.30481 17.6045 9.24757 17.5882 9.15763C17.5718 9.1004 17.5636 9.01864 17.5554 8.92871Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5792 9.42764C17.6283 9.49304 17.988 9.27228 18.0779 9.10059C17.7673 9.32951 17.4975 9.29682 17.5792 9.42764Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6126 9.44335L17.5717 9.42701C17.5717 9.42701 17.5472 9.38612 17.5554 9.36977C17.5636 9.33707 17.6208 9.31253 17.7025 9.27982C17.8006 9.24712 17.9315 9.18991 18.0705 9.0918C18.005 9.24714 17.7107 9.44335 17.6044 9.44335H17.6126ZM18.0786 9.0918C17.9478 9.20626 17.817 9.25531 17.7189 9.29619C17.6453 9.32889 17.5881 9.34525 17.5799 9.37795C17.5799 9.39431 17.5799 9.40247 17.5799 9.41882H17.6044C17.7025 9.41882 17.9887 9.23079 18.0705 9.0918H18.0786Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5393 9.63204C17.6292 9.56664 17.4657 9.39494 17.4248 9.16602C17.4248 9.44399 17.3839 9.65657 17.5393 9.63204Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5141 9.6402C17.5141 9.6402 17.4733 9.63203 17.4569 9.61567C17.416 9.5748 17.416 9.46851 17.416 9.31317C17.416 9.27229 17.416 9.21507 17.416 9.16602C17.4487 9.26413 17.4896 9.35406 17.5223 9.41946C17.5632 9.51757 17.5959 9.59115 17.5387 9.6402H17.5141ZM17.4324 9.23141C17.4324 9.23141 17.4324 9.28865 17.4324 9.31317C17.4324 9.45216 17.4324 9.55845 17.4651 9.59933C17.4732 9.61568 17.4896 9.61567 17.506 9.61567H17.5305C17.5714 9.58297 17.5387 9.51757 17.4978 9.41946C17.4733 9.36223 17.4487 9.29683 17.4242 9.22325L17.4324 9.23141Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.637 9.5591C17.6779 9.62451 17.9559 9.44463 18.0785 9.24023C17.8986 9.40375 17.588 9.44464 17.637 9.5591Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6693 9.57421C17.6693 9.57421 17.6366 9.55787 17.6284 9.55787C17.5957 9.47611 17.6938 9.42704 17.8165 9.36981C17.8982 9.32894 17.9963 9.27989 18.0699 9.22266C17.98 9.4107 17.7592 9.57421 17.6693 9.57421ZM18.0699 9.22266C18.0045 9.29624 17.9064 9.34528 17.8246 9.38616C17.7102 9.43521 17.6202 9.4761 17.6448 9.54968H17.6693C17.7592 9.55786 17.9718 9.39435 18.0699 9.22266Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3516 9.86872C17.4497 9.85236 17.4416 9.59893 17.3598 9.39453C17.2699 9.6398 17.2372 9.89324 17.3516 9.86872Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3413 9.87727C17.3413 9.87727 17.3086 9.87727 17.3004 9.85274C17.2513 9.77916 17.3004 9.56659 17.3576 9.38672C17.4394 9.55841 17.4557 9.75464 17.4067 9.8364C17.3903 9.86093 17.374 9.87727 17.3576 9.87727H17.3413ZM17.3576 9.3949C17.3004 9.60747 17.2677 9.78733 17.3085 9.84456C17.3085 9.85274 17.3331 9.86093 17.3413 9.86093H17.3576C17.374 9.86093 17.3903 9.85275 17.3985 9.82822C17.4394 9.75464 17.423 9.56659 17.3576 9.3949Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6044 9.72985C17.6371 9.77073 18.0459 9.48458 18.0377 9.37012C17.9069 9.55816 17.4736 9.59087 17.6044 9.72985Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6213 9.73741H17.6049C17.6049 9.73741 17.5804 9.68836 17.5886 9.66383C17.5886 9.61477 17.6785 9.58208 17.7684 9.5412C17.8666 9.49214 17.9892 9.44309 18.0382 9.36133C18.0546 9.39403 18.0382 9.43491 17.9728 9.49214C17.8666 9.59843 17.6785 9.73741 17.6213 9.73741ZM18.0382 9.36133C17.9974 9.45126 17.8747 9.5085 17.7766 9.54938C17.6867 9.59026 17.6131 9.62295 17.6049 9.66383C17.6049 9.68018 17.6049 9.69653 17.6213 9.71288C17.6703 9.71288 17.8584 9.59026 17.9647 9.4758C18.0137 9.42675 18.0382 9.38586 18.0382 9.36133Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1374 10.0975C17.2764 10.0402 17.211 9.81949 17.2355 9.57422C17.1292 9.81132 16.9984 10.0484 17.1374 10.0975Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1385 10.1135C17.1385 10.1135 17.0894 10.0807 17.0812 10.0562C17.0485 9.97446 17.1221 9.81094 17.1957 9.64743L17.2284 9.58203C17.2284 9.65561 17.2284 9.73736 17.2284 9.80277C17.2284 9.95811 17.2284 10.0726 17.1303 10.1135H17.1385ZM17.2284 9.58203L17.212 9.65561C17.1303 9.81913 17.0649 9.97446 17.0894 10.0562C17.0976 10.0726 17.114 10.0889 17.1303 10.0971C17.2202 10.0562 17.212 9.94176 17.212 9.80277C17.212 9.73736 17.212 9.65561 17.2202 9.58203H17.2284Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3916 9.90992C17.4161 9.9835 17.7432 9.84452 17.9067 9.60742C17.7105 9.76276 17.3344 9.77911 17.3916 9.90992Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4328 9.94298C17.4328 9.94298 17.392 9.92663 17.3838 9.91845C17.3838 9.9021 17.3838 9.88577 17.3838 9.86124C17.4083 9.81219 17.4901 9.78765 17.5963 9.74677C17.6944 9.70589 17.8171 9.67319 17.8988 9.59961C17.7844 9.804 17.5391 9.93482 17.4328 9.93482V9.94298ZM17.8988 9.60779C17.8253 9.68955 17.7108 9.72226 17.6045 9.76314C17.5064 9.79584 17.4165 9.82852 17.4001 9.8694C17.4001 9.88575 17.4001 9.89393 17.4001 9.90211C17.4001 9.91846 17.4165 9.91845 17.4328 9.91845C17.5309 9.91845 17.7762 9.78765 17.8988 9.59961V9.60779Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1787 10.1394C17.2441 10.2621 17.661 10.0413 17.7182 9.83691C17.5874 10.0168 17.1214 9.98407 17.1787 10.1394Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.2527 10.1797C17.2527 10.1797 17.1872 10.1633 17.1709 10.1388C17.1709 10.1225 17.1709 10.0979 17.1709 10.0816C17.1954 10.0325 17.2935 10.008 17.3916 9.97528C17.5143 9.94258 17.6533 9.90988 17.7105 9.82812C17.6778 9.99982 17.3998 10.1797 17.2527 10.1797ZM17.7105 9.83631C17.6614 9.93442 17.5225 9.96711 17.3998 9.99981C17.3017 10.0243 17.2118 10.057 17.1872 10.0979C17.1872 10.1061 17.1872 10.1225 17.1872 10.1388C17.1954 10.1552 17.22 10.1715 17.2527 10.1715C17.3998 10.1715 17.6696 9.99981 17.7105 9.84447V9.83631Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3679 10.2282C17.4415 10.2364 17.6213 10.0974 17.6704 10.0156C17.5314 10.0892 17.3352 10.1873 17.3679 10.2282Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.3744 10.2367H17.3662C17.3662 10.155 17.5134 10.0814 17.6605 10.0078C17.6197 10.0896 17.4562 10.2367 17.3744 10.2367ZM17.6605 10.016C17.5706 10.0732 17.3826 10.1713 17.3662 10.2204C17.4398 10.2204 17.6033 10.0978 17.6524 10.016H17.6605Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5874 10.2279C17.5874 10.2279 17.6447 10.2115 17.612 10.2606C17.3667 10.5713 17.2931 10.653 16.9334 10.6121C16.5655 10.5631 16.4837 10.465 16.2303 10.3178C16.0913 10.236 15.8951 10.2197 15.7397 10.2688C15.6743 10.2933 15.6253 10.3015 15.6825 10.2442C15.7315 10.1952 15.7888 10.1298 15.8542 10.0807C15.9932 9.97442 16.2221 9.93354 16.4101 9.95807C16.6799 9.99895 16.8925 10.1706 17.1623 10.236C17.3013 10.2687 17.4566 10.2606 17.5956 10.236L17.5874 10.2279Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5874 10.2279C17.5874 10.2279 17.6447 10.2115 17.612 10.2606C17.3667 10.5713 17.2931 10.653 16.9334 10.6121C16.5655 10.5631 16.4837 10.465 16.2303 10.3178C16.0913 10.236 15.8951 10.2197 15.7397 10.2688C15.6743 10.2933 15.6253 10.3015 15.6825 10.2442C15.7315 10.1952 15.7888 10.1298 15.8542 10.0807C15.9932 9.97442 16.2221 9.93354 16.4101 9.95807C16.6799 9.99895 16.8925 10.1706 17.1623 10.236C17.3013 10.2687 17.4566 10.2606 17.5956 10.236L17.5874 10.2279Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4948 10.7763C15.4458 10.7763 15.4212 10.8744 15.3967 10.809C15.3558 10.7109 15.3885 10.6291 15.4294 10.6373C15.4785 10.6536 15.5684 10.7681 15.4948 10.7681V10.7763Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4209 10.8415L15.3963 10.8169C15.3718 10.7515 15.3718 10.6861 15.3963 10.6534C15.3963 10.6371 15.4209 10.6289 15.429 10.6289C15.4781 10.6453 15.5435 10.7107 15.5353 10.7515C15.5353 10.7515 15.5272 10.7761 15.4945 10.7842C15.4781 10.7842 15.4617 10.8006 15.4536 10.8169C15.4372 10.8333 15.429 10.8415 15.4209 10.8415ZM15.4372 10.6534C15.3963 10.6861 15.3882 10.7434 15.4127 10.8088V10.8251C15.4127 10.8251 15.4372 10.8088 15.4454 10.8006C15.4617 10.7842 15.4781 10.7679 15.5026 10.7679C15.5271 10.727 15.4699 10.6616 15.4372 10.6534Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4948 10.7763C15.4458 10.7763 15.4212 10.8744 15.3967 10.809C15.3558 10.7109 15.3885 10.6291 15.4294 10.6373C15.4785 10.6536 15.5684 10.7681 15.4948 10.7681V10.7763Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4209 10.8415L15.3963 10.8169C15.3718 10.7515 15.3718 10.6861 15.3963 10.6534C15.3963 10.6371 15.4209 10.6289 15.429 10.6289C15.4781 10.6453 15.5435 10.7107 15.5353 10.7515C15.5353 10.7515 15.5272 10.7761 15.4945 10.7842C15.4781 10.7842 15.4617 10.8006 15.4536 10.8169C15.4372 10.8333 15.429 10.8415 15.4209 10.8415ZM15.4372 10.6534C15.3963 10.6861 15.3882 10.7434 15.4127 10.8088V10.8251C15.4127 10.8251 15.4372 10.8088 15.4454 10.8006C15.4617 10.7842 15.4781 10.7679 15.5026 10.7679C15.5271 10.727 15.4699 10.6616 15.4372 10.6534Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0028 10.3751C16.1336 10.4078 16.1663 10.2606 16.1745 10.1543C16.0601 10.1788 15.9293 10.2442 16.0028 10.3751Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.9443 10.5065C15.9688 10.6128 16.2223 10.5065 16.2713 10.3594C16.0915 10.4657 15.9116 10.3512 15.9443 10.5065Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8547 10.4996C15.9691 10.516 15.9038 10.3361 15.8956 10.1562C15.8302 10.3034 15.7402 10.4833 15.8547 10.4996Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.7073 10.6698C15.8381 10.6861 15.7564 10.4409 15.7237 10.2773C15.6828 10.4245 15.5929 10.6534 15.7073 10.6698Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.781 10.6782C15.7974 10.8172 16.059 10.67 16.2144 10.5801C16.01 10.6128 15.7647 10.5474 15.781 10.6782Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.6424 10.8754C15.6587 11.0144 15.9203 10.8591 16.0757 10.7773C15.8713 10.81 15.626 10.7446 15.6424 10.8754Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5775 10.8662C15.6919 10.8662 15.6102 10.6127 15.5775 10.4492C15.5366 10.5964 15.4548 10.8662 15.5775 10.8662Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4696 11.0372C15.486 11.1762 15.7231 11.0372 15.8703 10.9473C15.6659 10.9881 15.4451 10.9064 15.4696 11.0372Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0028 10.3751C16.1336 10.4078 16.1663 10.2606 16.1745 10.1543C16.0601 10.1788 15.9293 10.2442 16.0028 10.3751Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0346 10.3846C16.0346 10.3846 16.01 10.3846 15.9937 10.3846C15.9692 10.3355 15.961 10.2946 15.9855 10.2619C16.0182 10.1884 16.1163 10.1556 16.1736 10.1475C16.1736 10.221 16.1572 10.3927 16.0346 10.3927V10.3846ZM16.0182 10.3682H16.0346C16.1081 10.3682 16.149 10.2946 16.1654 10.1475C16.1245 10.172 16.0346 10.1965 16.0019 10.2619C15.9855 10.2946 15.9937 10.3355 16.0019 10.3682H16.01H16.0182Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.9443 10.5065C15.9688 10.6128 16.2223 10.5065 16.2713 10.3594C16.0915 10.4657 15.9116 10.3512 15.9443 10.5065Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0091 10.555C16.0091 10.555 15.9437 10.5386 15.9355 10.5141C15.9355 10.4814 15.9356 10.4569 15.9437 10.4405C15.9683 10.416 16.001 10.4078 16.05 10.4078C16.1072 10.4078 16.189 10.4078 16.2626 10.3506C16.238 10.465 16.0991 10.555 16.0091 10.555ZM16.2626 10.3506C16.189 10.4078 16.1072 10.416 16.05 10.416C16.0091 10.416 15.9683 10.416 15.9519 10.4405C15.9437 10.4569 15.9437 10.4732 15.9519 10.4978C15.9764 10.5877 16.2135 10.4814 16.2626 10.3506Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8547 10.4996C15.9691 10.516 15.9038 10.3361 15.8956 10.1562C15.8302 10.3034 15.7402 10.4833 15.8547 10.4996Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8709 10.5062H15.8546C15.8546 10.5062 15.8137 10.4899 15.8055 10.4735C15.7728 10.4163 15.83 10.3018 15.8791 10.1874L15.9036 10.1465C15.92 10.2037 15.9282 10.2446 15.9282 10.2937C15.9363 10.3836 15.9527 10.4572 15.92 10.4817C15.92 10.498 15.8954 10.4981 15.8791 10.4981L15.8709 10.5062ZM15.8955 10.1547V10.1956C15.8464 10.2937 15.7974 10.4163 15.8219 10.4654C15.8219 10.4817 15.8464 10.4817 15.8628 10.4817H15.8791H15.9036C15.9282 10.4572 15.92 10.3836 15.9036 10.3018C15.9036 10.2609 15.8955 10.2119 15.8873 10.1547H15.8955Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.7073 10.6698C15.8381 10.6861 15.7564 10.4409 15.7237 10.2773C15.6828 10.4245 15.5929 10.6534 15.7073 10.6698Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.7225 10.678H15.7062C15.7062 10.678 15.6653 10.678 15.6571 10.6534C15.6244 10.5962 15.6571 10.4654 15.6898 10.3509L15.7143 10.2773L15.747 10.3591C15.7797 10.4817 15.8043 10.6126 15.7716 10.6616C15.7552 10.6698 15.747 10.678 15.7225 10.678ZM15.7225 10.2855V10.3591C15.6816 10.4654 15.6489 10.588 15.6816 10.6453C15.6898 10.6616 15.7062 10.6698 15.7225 10.6698H15.7307C15.7307 10.6698 15.7552 10.6698 15.7634 10.6534C15.7961 10.6126 15.7634 10.4817 15.7389 10.3591L15.7225 10.2773V10.2855Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.781 10.6782C15.7974 10.8172 16.059 10.67 16.2144 10.5801C16.01 10.6128 15.7647 10.5474 15.781 10.6782Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8539 10.7443C15.813 10.7443 15.7803 10.7198 15.7803 10.6789C15.7803 10.6544 15.7803 10.638 15.7885 10.6217C15.8457 10.5481 16.0419 10.589 16.2136 10.5645L16.1891 10.5972C16.0828 10.6626 15.9356 10.7443 15.8457 10.7443H15.8539ZM16.1891 10.5808C16.0991 10.6135 15.8539 10.5726 15.813 10.6299C15.7966 10.6462 15.7966 10.6626 15.7966 10.6707C15.813 10.7852 16.0337 10.6708 16.1891 10.5808Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.6424 10.8754C15.6587 11.0144 15.9203 10.8591 16.0757 10.7773C15.8713 10.81 15.626 10.7446 15.6424 10.8754Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.7074 10.9311C15.6583 10.9311 15.6338 10.9066 15.6338 10.8739C15.6338 10.8493 15.6338 10.833 15.6501 10.8166C15.6828 10.7758 15.7564 10.7758 15.8545 10.7758H15.8954C15.9526 10.7758 16.0099 10.7758 16.0753 10.7676L16.0508 10.8003C15.9445 10.8575 15.7973 10.9393 15.7156 10.9393L15.7074 10.9311ZM15.8464 10.7839C15.7564 10.7839 15.6828 10.7839 15.6583 10.8166C15.6501 10.833 15.642 10.8412 15.6501 10.8657C15.6583 10.972 15.8872 10.8575 16.0344 10.7758C16.0099 10.7839 15.9445 10.7921 15.8872 10.7921H15.8464V10.7839Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5775 10.8662C15.6919 10.8662 15.6102 10.6127 15.5775 10.4492C15.5366 10.5964 15.4548 10.8662 15.5775 10.8662Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5768 10.8736C15.5768 10.8736 15.5359 10.8655 15.5196 10.8491C15.4705 10.7755 15.5195 10.5957 15.5604 10.4648C15.5359 10.612 15.495 10.7755 15.5359 10.8409C15.5359 10.8491 15.5604 10.8573 15.5768 10.8573C15.5849 10.8573 15.6013 10.8573 15.6095 10.8409C15.6422 10.8 15.6095 10.6611 15.5849 10.5384V10.4894L15.6013 10.5302C15.634 10.6611 15.6585 10.7919 15.6258 10.8491C15.6176 10.8655 15.5931 10.8736 15.5768 10.8736Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4696 11.0372C15.486 11.1762 15.7231 11.0372 15.8703 10.9473C15.6659 10.9881 15.4451 10.9064 15.4696 11.0372Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5443 11.1033C15.5034 11.1033 15.4707 11.0788 15.4707 11.0379C15.4707 11.0134 15.4707 10.997 15.4871 10.9807C15.5116 10.9562 15.5525 10.948 15.6097 10.948H15.7242C15.7896 10.948 15.8386 10.948 15.8795 10.9316C15.7241 11.0461 15.6097 11.1033 15.5443 11.1033ZM15.6015 10.9643C15.5525 10.9643 15.5116 10.9643 15.4871 10.9889C15.4871 11.0052 15.4789 11.0134 15.4871 11.0297C15.4952 11.1279 15.6261 11.087 15.8713 10.9316C15.8304 10.9643 15.7814 10.9643 15.716 10.9643H15.6015Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8116 10.8004C16.8852 10.923 17.1468 10.7104 17.2939 10.6123C17.0896 10.6695 16.7625 10.6532 16.8116 10.8004Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8851 10.8507C16.8851 10.8507 16.8197 10.8344 16.8115 10.8099C16.8115 10.7772 16.8115 10.7608 16.8115 10.7363C16.8442 10.679 16.9587 10.6709 17.0813 10.6463C17.1549 10.63 17.2285 10.6218 17.2939 10.6055C17.2939 10.6055 17.2939 10.6055 17.2939 10.6136V10.6218L17.2775 10.6382C17.1631 10.7199 16.9914 10.8507 16.8933 10.8507H16.8851ZM17.253 10.63C17.1958 10.6463 17.1385 10.6545 17.0813 10.6627C16.9668 10.679 16.8524 10.6954 16.8197 10.7444C16.8197 10.7608 16.8115 10.7772 16.8197 10.8017C16.8361 10.8262 16.8524 10.8344 16.8851 10.8344C16.9832 10.8344 17.1467 10.7199 17.253 10.63Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5499 10.9232C16.5745 11.0622 17.0159 10.9477 17.0813 10.8496C16.877 10.9395 16.5172 10.8087 16.5499 10.9232Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.68 10.9971C16.5982 10.9971 16.5492 10.9726 16.541 10.9236C16.541 10.9236 16.541 10.8909 16.541 10.8827C16.5655 10.8582 16.6309 10.8581 16.7372 10.8663C16.8599 10.8663 16.9988 10.8663 17.0724 10.8418C17.0397 10.9236 16.8271 10.9971 16.6718 10.9971H16.68ZM16.6473 10.8827C16.6473 10.8827 16.5737 10.8827 16.5574 10.899C16.5574 10.9726 16.6228 10.9808 16.68 10.9808C16.819 10.9808 17.0316 10.9072 17.0724 10.8418C17.007 10.8909 16.868 10.8827 16.7454 10.8827C16.7127 10.8827 16.6718 10.8827 16.6473 10.8827Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3371 11.0296C16.3534 11.1032 16.6968 11.0704 16.8603 11.0214C16.6723 11.0377 16.2962 10.9069 16.3371 11.0296Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.491 11.0881C16.3847 11.0881 16.3275 11.0717 16.3193 11.0308V10.9981C16.3439 10.9654 16.4502 10.9736 16.581 10.9981C16.6791 11.0063 16.7772 11.0309 16.8507 11.0145C16.8507 11.0145 16.8262 11.0308 16.8099 11.0308C16.7118 11.0635 16.5891 11.0881 16.491 11.0881ZM16.4011 10.99C16.4011 10.99 16.3439 10.99 16.3357 11.0063C16.3357 11.1044 16.5973 11.0799 16.7854 11.039C16.7199 11.039 16.6464 11.0227 16.581 11.0145C16.5156 11.0145 16.4502 10.9981 16.4011 10.9981V10.99Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1567 11.1191C16.1567 11.1845 16.5573 11.2254 16.6881 11.1191C16.4265 11.16 16.1322 10.9556 16.1567 11.1191Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.411 11.1925C16.2802 11.1925 16.1576 11.1598 16.1494 11.1189C16.1494 11.0862 16.1494 11.078 16.1494 11.0617C16.1739 11.0372 16.2475 11.0453 16.3375 11.0698C16.4356 11.0944 16.5582 11.1271 16.6726 11.1107C16.5991 11.1925 16.4519 11.2007 16.3947 11.2007L16.411 11.1925ZM16.2148 11.0535C16.2148 11.0535 16.1821 11.0535 16.1739 11.0698C16.1739 11.078 16.1739 11.0944 16.1739 11.1107C16.1739 11.1434 16.2802 11.168 16.4192 11.168C16.5337 11.168 16.6236 11.1516 16.6808 11.1107C16.6645 11.1107 16.6399 11.1189 16.6236 11.1189C16.5255 11.1189 16.4356 11.0944 16.3538 11.078C16.2966 11.0617 16.2557 11.0535 16.223 11.0535H16.2148Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8462 11.1852C15.8298 11.2833 16.2549 11.2588 16.3939 11.2097C16.165 11.1933 15.8707 11.0462 15.8462 11.1852Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0756 11.2576C16.002 11.2576 15.8794 11.2576 15.8467 11.2085C15.8467 11.0614 15.9857 11.1104 16.1492 11.1513C16.2309 11.1677 16.3127 11.1922 16.3944 11.2004C16.329 11.2412 16.1901 11.2576 16.0756 11.2576ZM15.9366 11.1268C15.8875 11.1268 15.863 11.1431 15.8548 11.184C15.8875 11.2249 15.9611 11.2413 16.0756 11.2413C16.1901 11.2413 16.329 11.2249 16.3944 11.2085C16.3127 11.2085 16.2309 11.1922 16.1492 11.1758C16.0674 11.1595 15.9938 11.135 15.9366 11.135V11.1268Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.838 11.0947C15.9361 11.1846 16.1813 10.784 16.2713 10.6123C16.0832 10.8085 15.7317 11.0211 15.838 11.0947Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8711 11.1205C15.8711 11.1205 15.8384 11.1205 15.8302 11.1042C15.8138 11.096 15.8057 11.0797 15.8057 11.0633C15.8057 11.0061 15.912 10.908 16.0428 10.8017C16.1163 10.7363 16.1981 10.6709 16.2553 10.6055C16.1981 10.7608 15.9855 11.1205 15.8711 11.1205ZM16.2553 10.6136C16.2063 10.6872 16.1245 10.7608 16.0509 10.818C15.9283 10.9161 15.8139 11.0061 15.822 11.0633C15.822 11.0797 15.822 11.0878 15.8384 11.096L15.8711 11.1124C15.9774 11.1124 16.1818 10.7853 16.2553 10.6218V10.6136Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1244 11.0299C16.2388 11.1035 16.3451 10.8255 16.4105 10.6211C16.296 10.801 16.0181 10.9154 16.1244 11.0299Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1648 11.0462C16.1648 11.0462 16.1321 11.0462 16.1157 11.0381C16.0994 11.0135 16.083 10.9972 16.083 10.9726C16.083 10.9154 16.1484 10.8582 16.222 10.801C16.2792 10.7437 16.3446 10.6865 16.3855 10.6211C16.3446 10.8255 16.2547 11.0544 16.1566 11.0544L16.1648 11.0462ZM16.3937 10.6211C16.361 10.6947 16.2956 10.7519 16.2383 10.8091C16.1648 10.8746 16.1076 10.9236 16.0994 10.9726C16.0994 10.9972 16.0994 11.0054 16.1239 11.0299C16.1975 11.0708 16.3038 10.9318 16.3937 10.6211Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3453 10.9563C16.4597 11.0299 16.5252 10.7764 16.5579 10.6211C16.4761 10.7519 16.239 10.8418 16.3453 10.9563Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3851 10.9734C16.3851 10.9734 16.3524 10.9734 16.3442 10.957C16.3197 10.9325 16.3115 10.908 16.3115 10.8834C16.3115 10.8426 16.3687 10.7935 16.426 10.7444C16.4668 10.7036 16.5241 10.6627 16.5486 10.6136C16.5322 10.7853 16.4832 10.9734 16.3851 10.9734ZM16.5486 10.6136C16.5322 10.6709 16.4832 10.7117 16.4342 10.7526C16.3851 10.7935 16.3279 10.8426 16.3279 10.8834C16.3279 10.8998 16.336 10.9243 16.3524 10.9407C16.426 10.9815 16.5077 10.8671 16.5486 10.6055V10.6136Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5572 10.818C16.6716 10.8916 16.8188 10.679 16.7861 10.4746C16.7452 10.6872 16.4509 10.7035 16.5572 10.818Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6142 10.8409C16.6142 10.8409 16.5733 10.8409 16.557 10.8246C16.5406 10.8001 16.5243 10.7837 16.5324 10.7592C16.5324 10.7265 16.5733 10.7019 16.6224 10.6692C16.6878 10.6284 16.7695 10.5711 16.7859 10.4648C16.8268 10.5957 16.7859 10.7101 16.7205 10.7837C16.6878 10.8246 16.6469 10.8409 16.6142 10.8409ZM16.7777 10.473C16.7777 10.5875 16.6796 10.6447 16.6224 10.6856C16.5815 10.7183 16.5488 10.7428 16.5488 10.7673C16.5488 10.7837 16.5488 10.8001 16.5733 10.8082C16.5897 10.8164 16.606 10.8246 16.6224 10.8246C16.6224 10.8246 16.6878 10.8082 16.7123 10.7673C16.7614 10.7101 16.8022 10.5875 16.7859 10.4648L16.7777 10.473Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1249 11.4142C16.1821 11.5614 16.7789 11.2916 16.8852 11.1035C16.689 11.267 16.0758 11.2425 16.1249 11.4142Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2143 11.4633C16.1571 11.4633 16.1244 11.4469 16.1162 11.4142C16.1162 11.3978 16.1162 11.3815 16.1162 11.3651C16.1571 11.3079 16.2879 11.2752 16.4514 11.2425C16.6068 11.2098 16.7866 11.1689 16.8684 11.1035C16.803 11.2507 16.4024 11.4633 16.2143 11.4633ZM16.8684 11.1035C16.7948 11.1934 16.6068 11.218 16.4514 11.2589C16.3043 11.2916 16.1571 11.3161 16.1326 11.3733C16.1326 11.3897 16.1244 11.3978 16.1326 11.4142C16.1816 11.5368 16.7784 11.2752 16.8765 11.1035H16.8684Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8116 10.8004C16.8852 10.923 17.1468 10.7104 17.2939 10.6123C17.0896 10.6695 16.7625 10.6532 16.8116 10.8004Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8851 10.8507C16.8851 10.8507 16.8197 10.8344 16.8115 10.8099C16.8115 10.7772 16.8115 10.7608 16.8115 10.7363C16.8442 10.679 16.9587 10.6709 17.0813 10.6463C17.1549 10.63 17.2285 10.6218 17.2939 10.6055V10.6218C17.2939 10.6218 17.2857 10.63 17.2775 10.6382C17.1631 10.7281 16.9914 10.8589 16.8933 10.8589L16.8851 10.8507ZM17.253 10.63C17.1958 10.6463 17.1385 10.6545 17.0813 10.6627C16.9668 10.679 16.8524 10.6954 16.8197 10.7444C16.8197 10.7608 16.8115 10.7772 16.8197 10.8017C16.8361 10.8262 16.8524 10.8344 16.8851 10.8344C16.9832 10.8344 17.1467 10.7199 17.253 10.63Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5499 10.9232C16.5745 11.0622 17.0159 10.9477 17.0813 10.8496C16.877 10.9395 16.5172 10.8087 16.5499 10.9232Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.68 10.9971C16.5982 10.9971 16.5492 10.9726 16.541 10.9236V10.8827C16.5655 10.8582 16.6309 10.8581 16.7372 10.8663C16.8599 10.8663 16.9988 10.8663 17.0724 10.8418C17.0397 10.9236 16.8271 10.9971 16.6718 10.9971H16.68ZM16.6473 10.8827C16.6473 10.8827 16.5737 10.8827 16.5574 10.899C16.5574 10.9726 16.6228 10.9808 16.68 10.9808C16.819 10.9808 17.0316 10.9072 17.0724 10.8418C17.007 10.8909 16.868 10.8827 16.7454 10.8827C16.7127 10.8827 16.6718 10.8827 16.6473 10.8827Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3371 11.0296C16.3534 11.1032 16.6968 11.0704 16.8603 11.0214C16.6723 11.0377 16.2962 10.9069 16.3371 11.0296Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.491 11.0872C16.3847 11.0872 16.3275 11.0708 16.3193 11.0299V10.9972C16.3193 10.9972 16.4502 10.9727 16.581 10.9972C16.6791 11.0054 16.7772 11.0299 16.8507 11.0136C16.8507 11.0136 16.8262 11.0299 16.8099 11.0299C16.7118 11.0626 16.5891 11.0872 16.491 11.0872ZM16.4011 10.9891C16.4011 10.9891 16.3439 10.9891 16.3357 11.0054C16.3357 11.1035 16.5973 11.079 16.7854 11.0381C16.7199 11.0381 16.6464 11.0218 16.581 11.0136C16.5156 11.0136 16.4502 10.9972 16.4011 10.9972V10.9891Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1567 11.1191C16.1567 11.1845 16.5573 11.2254 16.6881 11.1191C16.4265 11.16 16.1322 10.9556 16.1567 11.1191Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.411 11.1925C16.2802 11.1925 16.1576 11.1598 16.1494 11.1189C16.1494 11.0862 16.1494 11.078 16.1494 11.0617C16.1739 11.0372 16.2475 11.0453 16.3375 11.0698C16.4356 11.0944 16.5582 11.1271 16.6726 11.1107C16.5991 11.1925 16.4519 11.2007 16.3947 11.2007L16.411 11.1925ZM16.2148 11.0535C16.2148 11.0535 16.1821 11.0535 16.1739 11.0698C16.1739 11.078 16.1739 11.0944 16.1739 11.1107C16.1739 11.1434 16.2802 11.168 16.4192 11.168C16.5337 11.168 16.6236 11.1516 16.6808 11.1107C16.6645 11.1107 16.6399 11.1189 16.6236 11.1189C16.5255 11.1189 16.4356 11.0944 16.3538 11.078C16.2966 11.0617 16.2557 11.0535 16.223 11.0535H16.2148Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8462 11.1852C15.8298 11.2833 16.2549 11.2588 16.3939 11.2097C16.165 11.1933 15.8707 11.0462 15.8462 11.1852Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0756 11.2576C16.002 11.2576 15.8794 11.2576 15.8467 11.2085C15.8467 11.0614 15.9857 11.1104 16.1492 11.1513C16.2309 11.1677 16.3127 11.1922 16.3944 11.2004C16.329 11.2412 16.1901 11.2576 16.0756 11.2576ZM15.9366 11.1268C15.8875 11.1268 15.863 11.1431 15.8548 11.184C15.8875 11.2249 15.9611 11.2413 16.0756 11.2413C16.1901 11.2413 16.329 11.2249 16.3944 11.2085C16.3127 11.2085 16.2309 11.1922 16.1492 11.1758C16.0674 11.1595 15.9938 11.135 15.9366 11.135V11.1268Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.838 11.0947C15.9361 11.1846 16.1813 10.784 16.2713 10.6123C16.0832 10.8085 15.7317 11.0211 15.838 11.0947Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.8711 11.1205C15.8711 11.1205 15.8384 11.1205 15.8302 11.1042C15.8138 11.096 15.8057 11.0797 15.8057 11.0633C15.8057 11.0061 15.912 10.908 16.0428 10.8017C16.1163 10.7363 16.1981 10.6709 16.2553 10.6055C16.1981 10.7608 15.9855 11.1205 15.8711 11.1205ZM16.2553 10.6136C16.2063 10.6872 16.1245 10.7608 16.0509 10.818C15.9283 10.9161 15.8139 11.0061 15.822 11.0633C15.822 11.0797 15.822 11.0878 15.8384 11.096L15.8711 11.1124C15.9774 11.1124 16.1818 10.7853 16.2553 10.6218V10.6136Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1244 11.0299C16.2388 11.1035 16.3451 10.8255 16.4105 10.6211C16.296 10.801 16.0181 10.9154 16.1244 11.0299Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1648 11.0462C16.1648 11.0462 16.1321 11.0462 16.1157 11.0381C16.0994 11.0135 16.083 10.9972 16.083 10.9726C16.083 10.9154 16.1484 10.8582 16.222 10.801C16.2792 10.7437 16.3446 10.6865 16.3855 10.6211C16.3446 10.8255 16.2547 11.0544 16.1566 11.0544L16.1648 11.0462ZM16.3937 10.6211C16.361 10.6947 16.2956 10.7519 16.2383 10.8091C16.1648 10.8746 16.1076 10.9236 16.0994 10.9726C16.0994 10.9972 16.0994 11.0054 16.1239 11.0299C16.1975 11.0708 16.3038 10.9318 16.3937 10.6211Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3453 10.9563C16.4597 11.0299 16.5252 10.7764 16.5579 10.6211C16.4761 10.7519 16.239 10.8418 16.3453 10.9563Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.3851 10.9734C16.3851 10.9734 16.3524 10.9734 16.3442 10.957C16.3197 10.9325 16.3115 10.908 16.3115 10.8834C16.3115 10.8426 16.3687 10.7935 16.426 10.7444C16.4668 10.7036 16.5241 10.6627 16.5486 10.6136C16.5322 10.7853 16.4832 10.9734 16.3851 10.9734ZM16.5486 10.6136C16.5322 10.6709 16.4832 10.7117 16.4342 10.7526C16.3851 10.7935 16.3279 10.8426 16.3279 10.8834C16.3279 10.8998 16.336 10.9243 16.3524 10.9407C16.426 10.9815 16.5077 10.8671 16.5486 10.6055V10.6136Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5572 10.818C16.6716 10.8916 16.8188 10.679 16.7861 10.4746C16.7452 10.6872 16.4509 10.7035 16.5572 10.818Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6142 10.8409C16.6142 10.8409 16.5733 10.8409 16.557 10.8246C16.5406 10.8001 16.5243 10.7837 16.5324 10.7592C16.5324 10.7265 16.5733 10.7019 16.6224 10.6692C16.6878 10.6284 16.7695 10.5711 16.7859 10.4648C16.8268 10.5957 16.7859 10.7101 16.7205 10.7837C16.6878 10.8246 16.6469 10.8409 16.6142 10.8409ZM16.7777 10.473C16.7777 10.5875 16.6796 10.6447 16.6224 10.6856C16.5815 10.7183 16.5488 10.7428 16.5488 10.7673C16.5488 10.7837 16.5488 10.8001 16.5733 10.8082C16.5897 10.8164 16.606 10.8246 16.6224 10.8246C16.6224 10.8246 16.6878 10.8082 16.7123 10.7673C16.7614 10.7101 16.8022 10.5875 16.7859 10.4648L16.7777 10.473Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1249 11.4142C16.1821 11.5614 16.7789 11.2916 16.8852 11.1035C16.689 11.267 16.0758 11.2425 16.1249 11.4142Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.2143 11.4633C16.1571 11.4633 16.1244 11.4469 16.1162 11.4142C16.1162 11.3978 16.1162 11.3815 16.1162 11.3651C16.1571 11.3079 16.2879 11.2752 16.4514 11.2425C16.6068 11.2098 16.7866 11.1689 16.8684 11.1035C16.803 11.2507 16.4024 11.4633 16.2143 11.4633ZM16.8684 11.1035C16.7948 11.1934 16.6068 11.218 16.4514 11.2589C16.3043 11.2916 16.1571 11.3161 16.1326 11.3733C16.1326 11.3897 16.1244 11.3978 16.1326 11.4142C16.1816 11.5368 16.7784 11.2752 16.8765 11.1035H16.8684Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3578 7.39123C11.3414 7.20319 11.4804 6.85981 11.3823 6.67994C11.3742 6.65541 11.415 6.59001 11.4396 6.63089C11.4804 6.6963 11.5295 6.87616 11.5458 6.81076C11.5704 6.73718 11.5704 6.60636 11.6358 6.58184C11.6767 6.56549 11.7339 6.5573 11.7175 6.62271C11.7012 6.68811 11.6685 6.76987 11.7094 6.77805C11.7339 6.77805 11.7993 6.68811 11.8565 6.64723C11.8974 6.61453 11.9628 6.67178 11.8974 6.72084C11.6848 6.9007 11.4804 6.97427 11.3578 7.39123Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.366 7.39191H11.3496C11.3496 7.31833 11.3578 7.22023 11.3823 7.12212C11.4068 6.9586 11.4395 6.79508 11.3823 6.68062C11.3823 6.66427 11.3823 6.64792 11.3823 6.63157C11.3986 6.61522 11.4068 6.59886 11.415 6.59886C11.4641 6.63974 11.4804 6.68064 11.4968 6.72151C11.5049 6.75422 11.5295 6.80326 11.5376 6.81144C11.5376 6.78691 11.5376 6.76238 11.554 6.73786C11.5704 6.67245 11.5785 6.5907 11.6358 6.56617C11.6521 6.56617 11.6684 6.5498 11.693 6.5498L11.7339 6.56617C11.7339 6.56617 11.7339 6.59887 11.7339 6.61522L11.7175 6.65609C11.7175 6.65609 11.693 6.73785 11.7012 6.7542C11.7175 6.7542 11.7502 6.7215 11.7747 6.70515C11.7993 6.67244 11.8238 6.64792 11.8483 6.63157C11.8728 6.61522 11.9219 6.62339 11.9301 6.65609C11.9301 6.67245 11.9383 6.69699 11.9055 6.72151C11.8647 6.75422 11.8238 6.78692 11.7829 6.81962C11.6194 6.94226 11.4641 7.0567 11.366 7.39191ZM11.4314 6.63157H11.3987C11.4477 6.79508 11.4232 6.95861 11.3987 7.1303C11.3823 7.21206 11.3741 7.28563 11.3741 7.34286C11.4722 7.04853 11.6194 6.9259 11.7829 6.81144C11.8238 6.77873 11.8647 6.75422 11.9055 6.72151C11.9301 6.70516 11.9382 6.68063 11.9301 6.66428C11.9301 6.64793 11.9137 6.63975 11.8974 6.63975C11.8483 6.67245 11.8238 6.69699 11.7993 6.72151C11.7666 6.76239 11.742 6.77873 11.7257 6.77873C11.693 6.74602 11.7012 6.70515 11.7257 6.65609V6.61522C11.7257 6.61522 11.742 6.59069 11.7257 6.58251C11.6848 6.57434 11.6685 6.58251 11.6521 6.58251C11.6112 6.59887 11.5949 6.67245 11.5867 6.73786C11.5867 6.76238 11.5867 6.7869 11.5703 6.80325C11.5376 6.82778 11.5213 6.80326 11.4968 6.72967C11.4804 6.69697 11.4559 6.65609 11.4477 6.63157H11.4314Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3578 7.39123C11.3414 7.20319 11.4804 6.85981 11.3823 6.67994C11.3742 6.65541 11.415 6.59001 11.4396 6.63089C11.4804 6.6963 11.5295 6.87616 11.5458 6.81076C11.5704 6.73718 11.5704 6.60636 11.6358 6.58184C11.6767 6.56549 11.7339 6.5573 11.7175 6.62271C11.7012 6.68811 11.6685 6.76987 11.7094 6.77805C11.7339 6.77805 11.7993 6.68811 11.8565 6.64723C11.8974 6.61453 11.9628 6.67178 11.8974 6.72084C11.6848 6.9007 11.4804 6.97427 11.3578 7.39123Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.366 7.39191H11.3496C11.3496 7.31833 11.3578 7.22023 11.3823 7.12212C11.4068 6.9586 11.4395 6.79508 11.3823 6.68062C11.3823 6.66427 11.3823 6.64792 11.3823 6.63157C11.3986 6.61522 11.4068 6.59886 11.415 6.59886C11.4641 6.63974 11.4804 6.68064 11.4968 6.72151C11.5049 6.75422 11.5295 6.80326 11.5376 6.81144C11.5376 6.78691 11.5376 6.76238 11.554 6.73786C11.5704 6.67245 11.5785 6.5907 11.6358 6.56617C11.6521 6.56617 11.6684 6.5498 11.693 6.5498L11.7339 6.56617C11.7339 6.56617 11.7339 6.59887 11.7339 6.61522L11.7175 6.65609C11.7175 6.65609 11.693 6.73785 11.7012 6.7542C11.7175 6.7542 11.7502 6.7215 11.7747 6.70515C11.7993 6.67244 11.8238 6.64792 11.8483 6.63157C11.8728 6.61522 11.9219 6.62339 11.9301 6.65609C11.9301 6.67245 11.9383 6.69699 11.9055 6.72151C11.8647 6.75422 11.8238 6.78692 11.7829 6.81962C11.6194 6.94226 11.4641 7.0567 11.366 7.39191ZM11.4314 6.63157H11.3987C11.4477 6.79508 11.4232 6.95861 11.3987 7.1303C11.3823 7.21206 11.3741 7.28563 11.3741 7.34286C11.4722 7.04853 11.6194 6.9259 11.7829 6.81144C11.8238 6.77873 11.8647 6.75422 11.9055 6.72151C11.9301 6.70516 11.9382 6.68063 11.9301 6.66428C11.9301 6.64793 11.9137 6.63975 11.8974 6.63975C11.8483 6.67245 11.8238 6.69699 11.7993 6.72151C11.7666 6.76239 11.742 6.77873 11.7257 6.77873C11.693 6.74602 11.7012 6.70515 11.7257 6.65609V6.61522C11.7257 6.61522 11.742 6.59069 11.7257 6.58251C11.6848 6.57434 11.6685 6.58251 11.6521 6.58251C11.6112 6.59887 11.5949 6.67245 11.5867 6.73786C11.5867 6.76238 11.5867 6.7869 11.5703 6.80325C11.5376 6.82778 11.5213 6.80326 11.4968 6.72967C11.4804 6.69697 11.4559 6.65609 11.4477 6.63157H11.4314Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9731 10.2203C10.9731 10.2203 10.9159 10.2121 10.9486 10.2529C11.1938 10.5636 11.2674 10.6454 11.6272 10.6045C11.9951 10.5555 12.085 10.4573 12.3466 10.3102C12.4856 10.2284 12.6818 10.2121 12.8372 10.2611C12.9026 10.2857 12.9434 10.2856 12.8944 10.2284C12.8453 10.1794 12.7881 10.114 12.7227 10.0649C12.5837 9.95863 12.3548 9.91774 12.1586 9.95044C11.897 9.99132 11.6681 10.163 11.4064 10.2284C11.2674 10.2611 11.1121 10.2611 10.9731 10.2284V10.2203Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9731 10.2203C10.9731 10.2203 10.9159 10.2121 10.9486 10.2529C11.1938 10.5636 11.2674 10.6454 11.6272 10.6045C11.9951 10.5555 12.085 10.4573 12.3466 10.3102C12.4856 10.2284 12.6818 10.2121 12.8372 10.2611C12.9026 10.2857 12.9434 10.2856 12.8944 10.2284C12.8453 10.1794 12.7881 10.114 12.7227 10.0649C12.5837 9.95863 12.3548 9.91774 12.1586 9.95044C11.897 9.99132 11.6681 10.163 11.4064 10.2284C11.2674 10.2611 11.1121 10.2611 10.9731 10.2284V10.2203Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.0738 10.7679C13.1228 10.7679 13.1555 10.866 13.1719 10.8006C13.2127 10.7025 13.1801 10.6289 13.1392 10.6289C13.0901 10.6453 13.0002 10.7597 13.0738 10.7597V10.7679Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.1486 10.8418C13.1486 10.8418 13.1241 10.8255 13.1159 10.8091C13.0996 10.7928 13.0832 10.7846 13.0669 10.7764C13.0424 10.7764 13.0342 10.7601 13.0342 10.7437C13.0342 10.7028 13.0914 10.6293 13.1323 10.6211C13.1568 10.6211 13.165 10.6211 13.1732 10.6374C13.1977 10.6701 13.1977 10.7356 13.1732 10.801L13.1486 10.8337V10.8418ZM13.165 10.662C13.0996 10.662 13.0505 10.7192 13.0505 10.7519C13.0914 10.7683 13.1159 10.7846 13.1323 10.801L13.1568 10.8337L13.1732 10.8091C13.1977 10.7437 13.1977 10.6865 13.1732 10.662H13.165Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.0738 10.7679C13.1228 10.7679 13.1555 10.866 13.1719 10.8006C13.2127 10.7025 13.1801 10.6289 13.1392 10.6289C13.0901 10.6453 13.0002 10.7597 13.0738 10.7597V10.7679Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.1486 10.8418C13.1486 10.8418 13.1241 10.8255 13.1159 10.8091C13.0996 10.7928 13.0832 10.7846 13.0669 10.7764C13.0424 10.7764 13.0342 10.7601 13.0342 10.7437C13.0342 10.7028 13.0914 10.6293 13.1323 10.6211C13.1568 10.6211 13.165 10.6211 13.1732 10.6374C13.1977 10.6701 13.1977 10.7356 13.1732 10.801L13.1486 10.8337V10.8418ZM13.165 10.662C13.0996 10.662 13.0505 10.7192 13.0505 10.7519C13.0914 10.7683 13.1159 10.7846 13.1323 10.801L13.1568 10.8337L13.1732 10.8091C13.1977 10.7437 13.1977 10.6865 13.1732 10.662H13.165Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.9684 10.8573C13.091 10.8818 13.091 10.5875 12.9684 10.4648C13.0256 10.6529 12.8784 10.8328 12.9684 10.8573Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.919 10.8496C12.919 10.9967 12.5675 10.8332 12.4775 10.7188C12.6901 10.8087 12.9108 10.7351 12.919 10.8496Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.7633 10.6544C12.7796 10.7934 12.4526 10.6707 12.3545 10.5645C12.5671 10.638 12.7469 10.5399 12.7633 10.6544Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.8203 10.6698C12.943 10.6943 12.9266 10.3836 12.804 10.2773C12.8612 10.4817 12.7222 10.6289 12.8203 10.6698Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6903 10.482C12.8129 10.5147 12.7394 10.245 12.6494 10.1387C12.6658 10.3349 12.6004 10.4657 12.6903 10.482Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6252 10.4809C12.6334 10.6281 12.3881 10.5136 12.29 10.3828C12.4944 10.4482 12.6089 10.3665 12.6252 10.4809Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.56 10.3764C12.6417 10.3192 12.56 10.1557 12.3965 10.172C12.4047 10.262 12.4619 10.4337 12.56 10.3764Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.174 11.0134C13.174 11.1606 12.8225 11.087 12.708 10.9316C12.9369 10.9725 13.1576 10.8989 13.174 11.0134Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8024 7.24372C10.7534 7.18649 10.7698 7.16196 10.8433 7.16196C10.9087 7.16196 11.0314 7.20284 11.0804 7.16196C11.1213 7.12925 11.105 6.99844 11.1213 6.93304C11.1213 6.90033 11.154 6.8431 11.2112 6.93304C11.3747 7.18649 11.571 7.49718 11.6527 7.79151C11.6936 7.95503 11.6527 8.22482 11.4974 8.39651C11.4974 8.24117 11.4483 8.15124 11.3748 8.02043C11.293 7.85691 10.9823 7.4154 10.7943 7.23554L10.8024 7.24372Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4558 8.57657C11.6275 8.57657 11.6602 8.33946 11.6602 8.28223C11.5703 8.29858 11.4231 8.43758 11.4558 8.57657Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8024 7.24372C10.7534 7.18649 10.7698 7.16196 10.8433 7.16196C10.9087 7.16196 11.0314 7.20284 11.0804 7.16196C11.1213 7.12925 11.105 6.99844 11.1213 6.93304C11.1213 6.90033 11.154 6.8431 11.2112 6.93304C11.3747 7.18649 11.571 7.49718 11.6527 7.79151C11.6936 7.95503 11.6527 8.22482 11.4974 8.39651C11.4974 8.24117 11.4483 8.15124 11.3748 8.02043C11.293 7.85691 10.9823 7.4154 10.7943 7.23554L10.8024 7.24372Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4558 8.57657C11.6275 8.57657 11.6602 8.33946 11.6602 8.28223C11.5703 8.29858 11.4231 8.43758 11.4558 8.57657Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.9684 10.8573C13.091 10.8818 13.091 10.5875 12.9684 10.4648C13.0256 10.6529 12.8784 10.8328 12.9684 10.8573Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.985 10.8654H12.9687C12.9114 10.8491 12.9278 10.7919 12.9441 10.7183C12.9687 10.6447 12.985 10.5548 12.9605 10.4648C13.0668 10.5466 13.0913 10.7265 13.0586 10.8164C13.0422 10.8573 13.0259 10.8736 12.9932 10.8736L12.985 10.8654ZM12.9523 10.4648C12.9932 10.5548 12.9768 10.6447 12.9523 10.7183C12.9278 10.8 12.9278 10.8409 12.9605 10.8491H12.9768C12.9768 10.8491 13.0177 10.8246 13.0259 10.8082C13.0586 10.7265 13.0341 10.5548 12.9441 10.473L12.9523 10.4648Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.919 10.8496C12.919 10.9967 12.5675 10.8332 12.4775 10.7188C12.6901 10.8087 12.9108 10.7351 12.919 10.8496Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.854 10.9146C12.7395 10.9146 12.5351 10.8001 12.4697 10.7266C12.576 10.7593 12.6659 10.7593 12.7477 10.7674C12.8458 10.7674 12.9194 10.7838 12.9276 10.8492C12.9276 10.8655 12.9276 10.8819 12.9112 10.8901C12.8949 10.9064 12.8785 10.9146 12.854 10.9146ZM12.4779 10.7266C12.5678 10.8001 12.854 10.9391 12.903 10.8819C12.903 10.8819 12.9112 10.8655 12.9112 10.8492C12.9112 10.8001 12.8458 10.792 12.7477 10.7838C12.6741 10.7838 12.576 10.7674 12.4779 10.7266Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.7633 10.6544C12.7796 10.7934 12.4526 10.6707 12.3545 10.5645C12.5671 10.638 12.7469 10.5399 12.7633 10.6544Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6897 10.7182C12.5916 10.7182 12.4199 10.6446 12.3545 10.5629C12.4444 10.5792 12.518 10.5792 12.5834 10.5792H12.6406C12.7142 10.5792 12.7633 10.5792 12.7796 10.6528C12.7796 10.6773 12.7796 10.6855 12.7633 10.6937C12.7469 10.71 12.7224 10.7182 12.6979 10.7182H12.6897ZM12.3545 10.5629C12.4526 10.6446 12.6979 10.7346 12.7469 10.6773C12.7551 10.6773 12.7633 10.661 12.7551 10.6446C12.7551 10.5956 12.7142 10.5874 12.6406 10.5874H12.5834C12.518 10.5874 12.4444 10.5874 12.3627 10.5547L12.3545 10.5629Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.8203 10.6698C12.943 10.6943 12.9266 10.3836 12.804 10.2773C12.8612 10.4817 12.7222 10.6289 12.8203 10.6698Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.8373 10.6786H12.8128C12.7555 10.6622 12.7719 10.605 12.7801 10.5396C12.7964 10.4742 12.8128 10.3842 12.7882 10.2861C12.8863 10.3515 12.9272 10.5396 12.8864 10.6295C12.8782 10.6622 12.8537 10.6786 12.8291 10.6786H12.8373ZM12.7964 10.2943C12.8373 10.3924 12.8128 10.4824 12.7964 10.5478C12.7801 10.6213 12.7719 10.654 12.8128 10.6622H12.8291C12.8291 10.6622 12.8618 10.6459 12.8782 10.6213C12.9109 10.5314 12.8782 10.3597 12.7964 10.2861V10.2943Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6903 10.482C12.8129 10.5147 12.7394 10.245 12.6494 10.1387C12.6658 10.3349 12.6004 10.4657 12.6903 10.482Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.7074 10.4906H12.691C12.6338 10.4742 12.6419 10.417 12.6419 10.3189C12.6419 10.2699 12.6501 10.2044 12.6419 10.1309C12.7237 10.2044 12.7891 10.3761 12.7564 10.4579C12.7482 10.4742 12.7319 10.4906 12.7074 10.4906ZM12.6501 10.139C12.6665 10.2044 12.6665 10.2698 12.6501 10.3271C12.6501 10.4252 12.6501 10.4661 12.6828 10.4743H12.6992C12.6992 10.4743 12.7319 10.4742 12.7319 10.4579C12.7564 10.4007 12.7074 10.229 12.6338 10.1472L12.6501 10.139Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6252 10.4809C12.6334 10.6281 12.3881 10.5136 12.29 10.3828C12.4944 10.4482 12.6089 10.3665 12.6252 10.4809Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.5684 10.5561C12.4866 10.5561 12.3476 10.4825 12.2822 10.3926C12.3803 10.4089 12.4539 10.4089 12.503 10.4089C12.5766 10.4089 12.6174 10.4089 12.6338 10.4825C12.6338 10.507 12.6338 10.5234 12.6174 10.5397C12.6093 10.5561 12.5847 10.5561 12.5684 10.5561ZM12.2904 10.3926C12.3803 10.4825 12.5684 10.5806 12.6092 10.5316C12.6092 10.5234 12.6256 10.507 12.6174 10.4907C12.6174 10.4335 12.5766 10.4334 12.503 10.4334C12.4539 10.4334 12.3803 10.4335 12.2904 10.4008V10.3926Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.56 10.3764C12.6417 10.3192 12.56 10.1557 12.3965 10.172C12.4047 10.262 12.4619 10.4337 12.56 10.3764Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.5273 10.3924C12.4537 10.3924 12.4047 10.2616 12.3965 10.1717C12.5109 10.1635 12.5763 10.2207 12.6009 10.2779C12.6172 10.3188 12.6009 10.3515 12.5682 10.3761C12.56 10.3761 12.5436 10.3842 12.5273 10.3842V10.3924ZM12.4128 10.1798C12.421 10.2534 12.4619 10.3761 12.5273 10.3761C12.5273 10.3761 12.5436 10.3761 12.56 10.3679C12.5845 10.3515 12.5927 10.3188 12.5845 10.2861C12.5682 10.2289 12.5028 10.1798 12.421 10.1798H12.4128Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.174 11.0134C13.174 11.1606 12.8225 11.087 12.708 10.9316C12.9369 10.9725 13.1576 10.8989 13.174 11.0134Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.0498 11.0951C12.9353 11.0951 12.7718 11.0379 12.6982 10.9316H13.0089C13.0907 10.9316 13.1642 10.9316 13.1724 11.0052C13.1724 11.0216 13.1724 11.0379 13.1561 11.0543C13.1315 11.0788 13.0988 11.087 13.0498 11.087V11.0951ZM12.7064 10.9398C12.8127 11.0461 13.0907 11.1197 13.1479 11.0543C13.1479 11.0461 13.1643 11.0298 13.1643 11.0134C13.1643 10.9643 13.107 10.9562 13.0171 10.9562H12.8944C12.8372 10.9562 12.7718 10.9562 12.7146 10.9398H12.7064Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7505 10.7604C11.7669 10.9076 11.3745 10.7523 11.2764 10.6133C11.4808 10.6787 11.7342 10.646 11.7505 10.7604Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6845 10.8255C11.5619 10.8255 11.3412 10.711 11.2676 10.6211C11.3575 10.6374 11.4393 10.6456 11.5128 10.6538C11.6436 10.6702 11.7499 10.6865 11.7581 10.7601C11.7581 10.7846 11.7581 10.801 11.7499 10.801C11.7336 10.8173 11.7172 10.8255 11.6845 10.8255ZM11.2758 10.6211C11.3657 10.7192 11.6845 10.85 11.7336 10.7928C11.7336 10.6947 11.6355 10.6783 11.5128 10.6701C11.4393 10.6538 11.3493 10.6456 11.2758 10.6211Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.987 10.8253C12.0687 10.7599 11.9052 10.6128 11.7744 10.5801C11.7908 10.6782 11.8971 10.8826 11.987 10.8253Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9547 10.8417C11.8647 10.8417 11.7748 10.6618 11.7666 10.5801C11.8811 10.5964 12.0037 10.6945 12.0201 10.7681C12.0201 10.8008 12.02 10.8172 11.9955 10.8335C11.9792 10.8335 11.971 10.8417 11.9628 10.8417H11.9547ZM11.7666 10.5882C11.783 10.6618 11.8729 10.8253 11.9547 10.8253C11.9547 10.8253 11.971 10.8253 11.9792 10.8172C11.9955 10.8008 12.0037 10.7926 11.9955 10.7763C11.9955 10.7191 11.8647 10.6209 11.7666 10.5882Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0109 10.9146C12.0109 11.0373 11.594 10.9719 11.4795 10.8574C11.8474 10.9228 11.9946 10.8083 12.0109 10.9146Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8723 10.9964C11.7415 10.9964 11.5453 10.9392 11.4717 10.8656C11.6597 10.8656 11.7824 10.8738 11.8641 10.8656C11.9541 10.8574 12.0031 10.8492 12.0113 10.9228C12.0113 10.9392 12.0113 10.9555 11.9949 10.9637C11.9704 10.9964 11.905 10.9964 11.8641 10.9964H11.8723ZM11.4799 10.8656C11.5943 10.9555 11.9295 11.0128 11.9868 10.9555C11.9949 10.8656 11.9541 10.8819 11.8641 10.8819C11.8232 10.8819 11.7742 10.8819 11.7169 10.8819C11.6515 10.8819 11.5698 10.8819 11.4799 10.8574V10.8656Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2159 11.0055C12.2567 11.1282 11.848 11.0955 11.709 11.03C11.9461 11.03 12.1832 10.9238 12.2159 11.0055Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0364 11.0953C11.9219 11.0953 11.7748 11.0708 11.7012 11.0381C11.7993 11.0217 11.8892 11.0054 11.971 10.9972C12.0364 10.9808 12.0936 10.9727 12.1345 10.9727C12.1672 10.9727 12.2081 10.9727 12.2162 11.0136C12.2162 11.0299 12.2162 11.0462 12.2162 11.0544C12.1917 11.0953 12.1018 11.1035 12.0364 11.1035V11.0953ZM12.1345 10.9808C12.0936 10.9808 12.0364 10.9972 11.971 11.0054C11.8892 11.0217 11.7993 11.0381 11.7012 11.0381C11.832 11.0708 12.159 11.0953 12.1999 11.0381C12.1999 10.989 12.1754 10.9808 12.1345 10.9808Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4047 11.0874C12.4537 11.1937 12.0695 11.1937 11.8896 11.1283C12.1349 11.1283 12.3638 10.9811 12.4047 11.0874Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1834 11.1856C12.0771 11.1856 11.9626 11.1692 11.8809 11.1447C11.9871 11.1283 12.0852 11.1038 12.1752 11.0793C12.306 11.0466 12.3959 11.0384 12.4123 11.0875C12.4123 11.1038 12.4123 11.1202 12.4123 11.1284C12.3796 11.1774 12.2569 11.1856 12.1834 11.1856ZM12.3305 11.063C12.3305 11.063 12.2406 11.0793 12.1752 11.0956C12.0934 11.1202 11.9871 11.1447 11.8809 11.1447C12.0444 11.161 12.355 11.1774 12.3877 11.1284C12.3877 11.0711 12.3632 11.063 12.3224 11.063H12.3305Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6824 11.1448C12.7478 11.2675 12.3554 11.2839 12.2246 11.2184C12.4535 11.1857 12.6334 11.0467 12.6824 11.1448Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4447 11.2671C12.3548 11.2671 12.2649 11.2508 12.2158 11.2262C12.3139 11.2017 12.3875 11.169 12.4611 11.1445C12.5755 11.1036 12.6573 11.0872 12.69 11.1445C12.6982 11.169 12.6982 11.1853 12.69 11.2017C12.6573 11.2508 12.5428 11.2671 12.4447 11.2671ZM12.6164 11.1199C12.6164 11.1199 12.5265 11.1363 12.4693 11.1608C12.3957 11.1854 12.3139 11.2099 12.224 11.2262C12.2731 11.2262 12.3548 11.2426 12.4447 11.2426C12.5592 11.2426 12.6573 11.2181 12.6737 11.1854C12.6737 11.169 12.6737 11.1608 12.6737 11.1445C12.6573 11.1199 12.6409 11.1118 12.6164 11.1118V11.1199Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.208 10.9321C12.0772 11.0139 12.0936 10.7768 11.9873 10.6133C12.1508 10.7604 12.298 10.8504 12.208 10.9321Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1672 10.9567C12.1181 10.9567 12.0936 10.8831 12.0609 10.7931C12.0445 10.7359 12.02 10.6705 11.9873 10.6133L12.0772 10.6705C12.1753 10.7523 12.2489 10.8259 12.2489 10.8749C12.2489 10.8994 12.2489 10.9158 12.2244 10.9321C12.2081 10.9485 12.1917 10.9485 12.1672 10.9485V10.9567ZM11.9873 10.6215C12.0364 10.6705 12.0609 10.7359 12.0772 10.8013C12.1099 10.8994 12.1426 10.973 12.208 10.9321C12.2244 10.9158 12.2326 10.8994 12.2326 10.8913C12.2326 10.8422 12.159 10.7768 12.0691 10.695L11.9873 10.6296V10.6215Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4369 11.0214C12.3306 11.1114 12.2407 10.7925 12.1426 10.6045C12.3061 10.7762 12.535 10.9397 12.4369 11.0214Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.396 11.0456C12.3306 11.0456 12.2734 10.9148 12.2162 10.7758C12.1916 10.7186 12.1671 10.6614 12.1426 10.6123C12.1998 10.645 12.2407 10.6941 12.2897 10.7349C12.3878 10.833 12.4696 10.9148 12.4696 10.9802C12.4696 11.0048 12.4614 11.0211 12.4451 11.0293C12.4369 11.0456 12.4124 11.0456 12.4042 11.0456H12.396ZM12.1507 10.6287C12.1834 10.6696 12.208 10.7186 12.2243 10.7758C12.2897 10.923 12.3551 11.0783 12.4205 11.0211C12.4369 11.0129 12.4451 10.9966 12.4451 10.9802C12.4451 10.923 12.3551 10.8412 12.2652 10.7513C12.2243 10.7104 12.1834 10.6777 12.1507 10.6368V10.6287Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.7397 11.1112C12.6498 11.2093 12.3881 10.8005 12.29 10.5879C12.4372 10.7514 12.8051 11.0212 12.7397 11.1112Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6992 11.1373C12.5847 11.1373 12.364 10.7857 12.2822 10.5977C12.3395 10.6385 12.4049 10.7039 12.4866 10.7693C12.6501 10.9165 12.7973 11.0555 12.7401 11.1209C12.7319 11.1372 12.7155 11.1373 12.6992 11.1373ZM12.2822 10.5977C12.3885 10.8021 12.6501 11.2027 12.7319 11.1046C12.7728 11.0473 12.6174 10.9002 12.4703 10.7775C12.3967 10.7121 12.3313 10.6467 12.2822 10.5977Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7505 10.7604C11.7669 10.9076 11.3745 10.7523 11.2764 10.6133C11.4808 10.6787 11.7342 10.646 11.7505 10.7604Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6845 10.8255C11.5619 10.8255 11.3412 10.711 11.2676 10.6211C11.3575 10.6374 11.4393 10.6456 11.5128 10.6538C11.6436 10.6702 11.7499 10.6865 11.7581 10.7601C11.7581 10.7846 11.7581 10.801 11.7499 10.801C11.7336 10.8173 11.7172 10.8255 11.6845 10.8255ZM11.2758 10.6211C11.3657 10.7192 11.6845 10.85 11.7336 10.7928C11.7336 10.6947 11.6355 10.6783 11.5128 10.6701C11.4393 10.6538 11.3493 10.6456 11.2758 10.6211Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.987 10.8253C12.0687 10.7599 11.9052 10.6128 11.7744 10.5801C11.7908 10.6782 11.8971 10.8826 11.987 10.8253Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9547 10.8417C11.8647 10.8417 11.7748 10.6618 11.7666 10.5801C11.8811 10.5964 12.0037 10.6945 12.0201 10.7681C12.0201 10.8008 12.02 10.8172 11.9955 10.8335C11.9792 10.8335 11.971 10.8417 11.9628 10.8417H11.9547ZM11.7666 10.5882C11.783 10.6618 11.8729 10.8253 11.9547 10.8253C11.9547 10.8253 11.971 10.8253 11.9792 10.8172C11.9955 10.8008 12.0037 10.7926 11.9955 10.7763C11.9955 10.7191 11.8647 10.6209 11.7666 10.5882Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0109 10.9146C12.0109 11.0373 11.594 10.9719 11.4795 10.8574C11.8474 10.9228 11.9946 10.8083 12.0109 10.9146Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8723 10.9964C11.7415 10.9964 11.5453 10.9392 11.4717 10.8656C11.6597 10.8656 11.7824 10.8738 11.8641 10.8656C11.9541 10.8574 12.0031 10.8492 12.0113 10.9228C12.0113 10.9392 12.0113 10.9555 11.9949 10.9637C11.9704 10.9964 11.905 10.9964 11.8641 10.9964H11.8723ZM11.4799 10.8656C11.5943 10.9555 11.9295 11.0128 11.9868 10.9555C11.9949 10.8656 11.9541 10.8819 11.8641 10.8819C11.8232 10.8819 11.7742 10.8819 11.7169 10.8819C11.6515 10.8819 11.5698 10.8819 11.4799 10.8574V10.8656Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2159 11.0055C12.2567 11.1282 11.848 11.0955 11.709 11.03C11.9461 11.03 12.1832 10.9238 12.2159 11.0055Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0364 11.0953C11.9219 11.0953 11.7748 11.0708 11.7012 11.0381C11.7993 11.0217 11.8892 11.0054 11.971 10.9972C12.0364 10.9808 12.0936 10.9727 12.1345 10.9727C12.1672 10.9727 12.2081 10.9727 12.2162 11.0136C12.2162 11.0299 12.2162 11.0462 12.2162 11.0544C12.1917 11.0953 12.1018 11.1035 12.0364 11.1035V11.0953ZM12.1345 10.9808C12.0936 10.9808 12.0364 10.9972 11.971 11.0054C11.8892 11.0217 11.7993 11.0381 11.7012 11.0381C11.832 11.0708 12.159 11.0953 12.1999 11.0381C12.1999 10.989 12.1754 10.9808 12.1345 10.9808Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4047 11.0874C12.4537 11.1937 12.0695 11.1937 11.8896 11.1283C12.1349 11.1283 12.3638 10.9811 12.4047 11.0874Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1834 11.1856C12.0771 11.1856 11.9626 11.1692 11.8809 11.1447C11.9871 11.1283 12.0852 11.1038 12.1752 11.0793C12.306 11.0466 12.3959 11.0384 12.4123 11.0875C12.4123 11.1038 12.4123 11.1202 12.4123 11.1284C12.3796 11.1774 12.2569 11.1856 12.1834 11.1856ZM12.3305 11.063C12.3305 11.063 12.2406 11.0793 12.1752 11.0956C12.0934 11.1202 11.9871 11.1447 11.8809 11.1447C12.0444 11.161 12.355 11.1774 12.3877 11.1284C12.3877 11.0711 12.3632 11.063 12.3224 11.063H12.3305Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6824 11.1448C12.7478 11.2675 12.3554 11.2839 12.2246 11.2184C12.4535 11.1857 12.6334 11.0467 12.6824 11.1448Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4447 11.2671C12.3548 11.2671 12.2649 11.2508 12.2158 11.2262C12.3139 11.2017 12.3875 11.169 12.4611 11.1445C12.5755 11.1036 12.6573 11.0872 12.69 11.1445C12.6982 11.169 12.6982 11.1853 12.69 11.2017C12.6573 11.2508 12.5428 11.2671 12.4447 11.2671ZM12.6164 11.1199C12.6164 11.1199 12.5265 11.1363 12.4693 11.1608C12.3957 11.1854 12.3139 11.2099 12.224 11.2262C12.2731 11.2262 12.3548 11.2426 12.4447 11.2426C12.5592 11.2426 12.6573 11.2181 12.6737 11.1854C12.6737 11.169 12.6737 11.1608 12.6737 11.1445C12.6573 11.1199 12.6409 11.1118 12.6164 11.1118V11.1199Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.208 10.9321C12.0772 11.0139 12.0936 10.7768 11.9873 10.6133C12.1508 10.7604 12.298 10.8504 12.208 10.9321Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1672 10.9567C12.1181 10.9567 12.0936 10.8831 12.0609 10.7931C12.0445 10.7359 12.02 10.6705 11.9873 10.6133L12.0772 10.6705C12.1753 10.7523 12.2489 10.8259 12.2489 10.8749C12.2489 10.8994 12.2489 10.9158 12.2244 10.9321C12.2081 10.9485 12.1917 10.9485 12.1672 10.9485V10.9567ZM11.9873 10.6215C12.0364 10.6705 12.0609 10.7359 12.0772 10.8013C12.1099 10.8994 12.1426 10.973 12.208 10.9321C12.2244 10.9158 12.2326 10.8994 12.2326 10.8913C12.2326 10.8422 12.159 10.7768 12.0691 10.695L11.9873 10.6296V10.6215Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4369 11.0214C12.3306 11.1114 12.2407 10.7925 12.1426 10.6045C12.3061 10.7762 12.535 10.9397 12.4369 11.0214Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.396 11.0456C12.3306 11.0456 12.2734 10.9148 12.2162 10.7758C12.1916 10.7186 12.1671 10.6614 12.1426 10.6123C12.1998 10.645 12.2407 10.6941 12.2897 10.7349C12.3878 10.833 12.4696 10.9148 12.4696 10.9802C12.4696 11.0048 12.4614 11.0211 12.4451 11.0293C12.4369 11.0456 12.4124 11.0456 12.4042 11.0456H12.396ZM12.1507 10.6287C12.1834 10.6696 12.208 10.7186 12.2243 10.7758C12.2897 10.923 12.3551 11.0783 12.4205 11.0211C12.4369 11.0129 12.4451 10.9966 12.4451 10.9802C12.4451 10.923 12.3551 10.8412 12.2652 10.7513C12.2243 10.7104 12.1834 10.6777 12.1507 10.6368V10.6287Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.7397 11.1112C12.6498 11.2093 12.3881 10.8005 12.29 10.5879C12.4372 10.7514 12.8051 11.0212 12.7397 11.1112Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.6992 11.1373C12.5847 11.1373 12.364 10.7857 12.2822 10.5977C12.3395 10.6385 12.4049 10.7039 12.4866 10.7693C12.6501 10.9165 12.7973 11.0555 12.7401 11.1209C12.7319 11.1372 12.7155 11.1373 12.6992 11.1373ZM12.2822 10.5977C12.3885 10.8021 12.6501 11.2027 12.7319 11.1046C12.7728 11.0473 12.6174 10.9002 12.4703 10.7775C12.3967 10.7121 12.3313 10.6467 12.2822 10.5977Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.486 11.422C12.437 11.5855 11.7748 11.2748 11.7012 11.1113C12.0854 11.3157 12.4942 11.2748 12.486 11.422Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.3968 11.4799C12.2006 11.4799 11.751 11.2509 11.6855 11.1201C11.8736 11.2019 12.0616 11.2428 12.2088 11.2755C12.3723 11.3163 12.4949 11.3409 12.4867 11.4308C12.4867 11.4553 12.4622 11.488 12.3886 11.488L12.3968 11.4799ZM11.6937 11.1201C11.7836 11.2591 12.4377 11.5453 12.4704 11.4226C12.4704 11.3491 12.3559 11.3245 12.2006 11.2918C12.0534 11.2591 11.8736 11.2182 11.6937 11.1201Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.3438 8.18359C10.3438 8.18359 10.2866 8.18359 10.2947 8.23265C10.3029 8.29805 10.401 8.63326 10.5645 8.74773C10.679 8.83766 11.3085 8.97665 11.5947 9.03388C11.75 9.06659 11.8808 9.14835 11.9789 9.27099C11.938 9.10747 11.9053 8.98482 11.8481 8.84583C11.7909 8.71502 11.6519 8.57603 11.5048 8.56786C11.235 8.55151 10.8834 8.53516 10.6299 8.4207C10.4991 8.36347 10.4174 8.28988 10.3356 8.18359H10.3438Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.3438 8.18359C10.3438 8.18359 10.2866 8.18359 10.2947 8.23265C10.3029 8.29805 10.401 8.63326 10.5645 8.74773C10.679 8.83766 11.3085 8.97665 11.5947 9.03388C11.75 9.06659 11.8808 9.14835 11.9789 9.27099C11.938 9.10747 11.9053 8.98482 11.8481 8.84583C11.7909 8.71502 11.6519 8.57603 11.5048 8.56786C11.235 8.55151 10.8834 8.53516 10.6299 8.4207C10.4991 8.36347 10.4174 8.28988 10.3356 8.18359H10.3438Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8976 9.5167C11.9793 9.58211 12.0774 9.3532 11.963 9.14062C11.963 9.3532 11.7994 9.41859 11.8976 9.5167Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9293 9.54123L11.8966 9.52489C11.8394 9.46766 11.8639 9.41043 11.8966 9.3532C11.9212 9.29597 11.9539 9.23873 11.9621 9.14062C12.052 9.27144 12.0356 9.4186 11.9947 9.49218C11.9784 9.52488 11.9539 9.53305 11.9293 9.53305V9.54123ZM11.9621 9.14881C11.9784 9.23874 11.9375 9.31231 11.913 9.36136C11.8803 9.41859 11.8558 9.46765 11.913 9.5167H11.9375C11.9375 9.5167 11.9702 9.5167 11.9866 9.48399C12.0275 9.41041 12.0356 9.27962 11.9702 9.14881H11.9621Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9793 9.72974C12.0938 9.77062 12.1347 9.55805 12.0529 9.39453C12.0693 9.5744 11.8649 9.68069 11.9793 9.72974Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0039 9.7379H11.9712C11.9712 9.7379 11.9385 9.71338 11.9385 9.69703C11.9385 9.66433 11.9548 9.6398 11.9793 9.59893C12.012 9.5417 12.0529 9.47629 12.0448 9.39453C12.1183 9.49264 12.1183 9.63163 12.0774 9.70522C12.0611 9.72974 12.0366 9.74608 12.0039 9.74608V9.7379ZM12.0448 9.39453C12.0693 9.47629 12.0202 9.54987 11.9875 9.59893C11.963 9.6398 11.9466 9.6725 11.9466 9.68885C11.9466 9.7052 11.963 9.71338 11.9712 9.72156H11.9957C11.9957 9.72156 12.0366 9.72155 12.0529 9.68885C12.0938 9.62344 12.0856 9.49264 12.0448 9.39453Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0681 9.89269C12.1826 9.94992 12.2235 9.73737 12.1417 9.58203C12.1499 9.77825 11.9782 9.84364 12.0681 9.89269Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1015 9.90906C12.1015 9.90906 12.077 9.90905 12.0607 9.90087C12.0443 9.88452 12.0361 9.87634 12.0361 9.86816C12.0361 9.85181 12.0443 9.82729 12.0688 9.79458C12.1015 9.74553 12.1424 9.68832 12.1342 9.58203C12.2078 9.68014 12.1996 9.81093 12.1669 9.86816C12.1506 9.89269 12.1342 9.90906 12.1015 9.90906ZM12.1342 9.58203C12.1506 9.68014 12.1097 9.75371 12.077 9.80277C12.0606 9.8273 12.0443 9.84365 12.0525 9.86001C12.0852 9.88453 12.0934 9.89269 12.1015 9.89269C12.1261 9.89269 12.1424 9.89271 12.1506 9.86001C12.1833 9.80277 12.1915 9.68832 12.1342 9.58203Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0205 9.91007C11.9715 10.0409 11.7098 9.78743 11.6689 9.64844C11.8325 9.81195 12.0532 9.79561 12.0205 9.91007Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9698 9.95094C11.8717 9.95094 11.7001 9.7629 11.6592 9.64844C11.7491 9.72202 11.8309 9.75473 11.9044 9.77925C11.9862 9.81196 12.0434 9.83648 12.0271 9.90188C12.0271 9.93459 11.9944 9.94275 11.9698 9.94275V9.95094ZM11.6592 9.65662C11.7164 9.77926 11.9698 10.0163 12.0107 9.90188C12.0271 9.85283 11.9862 9.83648 11.9044 9.80378C11.8309 9.77108 11.7409 9.73838 11.6673 9.65662H11.6592Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9061 9.69639C11.857 9.8272 11.5218 9.48383 11.4482 9.32031C11.6118 9.48383 11.947 9.60646 11.9061 9.69639Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8652 9.73763C11.7589 9.73763 11.5055 9.45967 11.4482 9.32068C11.53 9.37791 11.6199 9.43514 11.7099 9.49237C11.8407 9.57413 11.947 9.63953 11.9143 9.69676C11.9143 9.72129 11.8897 9.73763 11.8652 9.73763ZM11.4482 9.32068C11.5382 9.4842 11.857 9.80304 11.8979 9.68858C11.9142 9.63952 11.808 9.57413 11.6935 9.50055C11.6117 9.44332 11.5136 9.38608 11.4482 9.3125V9.32068Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8403 9.50024C11.7912 9.6474 11.4315 9.2386 11.3252 9.09961C11.4969 9.26313 11.873 9.39395 11.8403 9.50024Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7916 9.54306C11.6771 9.54306 11.4073 9.23238 11.3174 9.10156C11.3991 9.15062 11.4972 9.21603 11.5954 9.26509C11.7425 9.35502 11.8733 9.42044 11.8406 9.50219C11.8325 9.52672 11.8161 9.54306 11.7916 9.54306ZM11.3174 9.10156C11.44 9.24055 11.7834 9.62482 11.8243 9.49401C11.8488 9.43678 11.718 9.36319 11.5872 9.28143C11.4891 9.23238 11.391 9.16697 11.3174 9.10156Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8227 9.34547C11.9453 9.31277 11.8145 9.21466 11.6592 9.04297C11.6592 9.22284 11.6837 9.35364 11.8227 9.34547Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8168 9.35365C11.776 9.35365 11.7433 9.33729 11.7106 9.31276C11.6697 9.27188 11.6533 9.18196 11.6533 9.04297L11.7514 9.12471C11.8414 9.21464 11.8986 9.27188 11.8822 9.31276C11.8822 9.32911 11.8577 9.34547 11.825 9.34547H11.8087L11.8168 9.35365ZM11.6615 9.05113C11.6615 9.18194 11.686 9.25554 11.7269 9.29642C11.7514 9.32094 11.776 9.3291 11.8168 9.3291H11.8332C11.8577 9.3291 11.8659 9.31275 11.8741 9.30458C11.8822 9.27187 11.825 9.21465 11.7514 9.13289L11.6697 9.04297L11.6615 9.05113Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6103 9.23869C11.6593 9.18146 11.5612 9.14875 11.4222 9.00977C11.4059 9.10788 11.5449 9.28774 11.6103 9.23869Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5867 9.2554C11.5867 9.2554 11.5213 9.23088 11.4886 9.19001C11.4477 9.14095 11.4069 9.05918 11.4232 9.00195C11.4886 9.05101 11.5295 9.0919 11.5704 9.11643C11.6113 9.14913 11.6358 9.17366 11.6358 9.19819C11.6358 9.21454 11.6358 9.2227 11.6194 9.23087L11.5867 9.24724V9.2554ZM11.415 9.01014C11.415 9.05919 11.4559 9.13277 11.4968 9.18182C11.5295 9.2227 11.5622 9.23906 11.5867 9.23906H11.6031C11.6031 9.19818 11.5867 9.17366 11.5459 9.14095C11.5131 9.10825 11.4641 9.06738 11.415 9.01832V9.01014Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2256 9.91056C12.291 9.95144 12.34 9.80428 12.2582 9.68164C12.2419 9.81245 12.1683 9.85333 12.2256 9.91056Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2486 9.9269L12.2241 9.91872C12.1832 9.88602 12.1914 9.84515 12.2077 9.80427C12.2241 9.77157 12.2404 9.7307 12.2486 9.68164C12.314 9.7634 12.3222 9.85332 12.2977 9.89419C12.2895 9.91872 12.265 9.9269 12.2486 9.9269ZM12.2486 9.68164C12.2486 9.73887 12.2486 9.77157 12.2241 9.80427C12.2077 9.85333 12.1996 9.87785 12.2241 9.90238H12.2404C12.2404 9.90238 12.265 9.90239 12.2731 9.88604C12.2977 9.84516 12.2895 9.7634 12.2404 9.68164H12.2486Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8976 9.5167C11.9793 9.58211 12.0774 9.3532 11.963 9.14062C11.963 9.3532 11.7994 9.41859 11.8976 9.5167Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9293 9.54123L11.8966 9.52489C11.8394 9.46766 11.8639 9.41043 11.8966 9.3532C11.9212 9.29597 11.9539 9.23873 11.9621 9.14062C12.052 9.27144 12.0356 9.4186 11.9947 9.49218C11.9784 9.52488 11.9539 9.53305 11.9293 9.53305V9.54123ZM11.9621 9.14881C11.9784 9.23874 11.9375 9.31231 11.913 9.36136C11.8803 9.41859 11.8558 9.46765 11.913 9.5167H11.9375C11.9375 9.5167 11.9702 9.5167 11.9866 9.48399C12.0275 9.41041 12.0356 9.27962 11.9702 9.14881H11.9621Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9793 9.72974C12.0938 9.77062 12.1347 9.55805 12.0529 9.39453C12.0693 9.5744 11.8649 9.68069 11.9793 9.72974Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0039 9.7379H11.9712C11.9712 9.7379 11.9385 9.71338 11.9385 9.69703C11.9385 9.66433 11.9548 9.6398 11.9793 9.59893C12.012 9.5417 12.0529 9.47629 12.0448 9.39453C12.1183 9.49264 12.1183 9.63163 12.0774 9.70522C12.0611 9.72974 12.0366 9.74608 12.0039 9.74608V9.7379ZM12.0448 9.39453C12.0693 9.47629 12.0202 9.54987 11.9875 9.59893C11.963 9.6398 11.9466 9.6725 11.9466 9.68885C11.9466 9.7052 11.963 9.71338 11.9712 9.72156H11.9957C11.9957 9.72156 12.0366 9.72155 12.0529 9.68885C12.0938 9.62344 12.0856 9.49264 12.0448 9.39453Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0681 9.89269C12.1826 9.94992 12.2235 9.73737 12.1417 9.58203C12.1499 9.77825 11.9782 9.84364 12.0681 9.89269Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1015 9.90906C12.1015 9.90906 12.077 9.90905 12.0607 9.90087C12.0443 9.88452 12.0361 9.87634 12.0361 9.86816C12.0361 9.85181 12.0443 9.82729 12.0688 9.79458C12.1015 9.74553 12.1424 9.68832 12.1342 9.58203C12.2078 9.68014 12.1996 9.81093 12.1669 9.86816C12.1506 9.89269 12.1342 9.90906 12.1015 9.90906ZM12.1342 9.58203C12.1506 9.68014 12.1097 9.75371 12.077 9.80277C12.0606 9.8273 12.0443 9.84365 12.0525 9.86001C12.0852 9.88453 12.0934 9.89269 12.1015 9.89269C12.1261 9.89269 12.1424 9.89271 12.1506 9.86001C12.1833 9.80277 12.1915 9.68832 12.1342 9.58203Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.0205 9.91007C11.9715 10.0409 11.7098 9.78743 11.6689 9.64844C11.8325 9.81195 12.0532 9.79561 12.0205 9.91007Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9698 9.95094C11.8717 9.95094 11.7001 9.7629 11.6592 9.64844C11.7491 9.72202 11.8309 9.75473 11.9044 9.77925C11.9862 9.81196 12.0434 9.83648 12.0271 9.90188C12.0271 9.93459 11.9944 9.94275 11.9698 9.94275V9.95094ZM11.6592 9.65662C11.7164 9.77926 11.9698 10.0163 12.0107 9.90188C12.0271 9.85283 11.9862 9.83648 11.9044 9.80378C11.8309 9.77108 11.7409 9.73838 11.6673 9.65662H11.6592Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9061 9.69639C11.857 9.8272 11.5218 9.48383 11.4482 9.32031C11.6118 9.48383 11.947 9.60646 11.9061 9.69639Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8652 9.73763C11.7589 9.73763 11.5055 9.45967 11.4482 9.32068C11.53 9.37791 11.6199 9.43514 11.7099 9.49237C11.8407 9.57413 11.947 9.63953 11.9143 9.69676C11.9143 9.72129 11.8897 9.73763 11.8652 9.73763ZM11.4482 9.32068C11.5382 9.4842 11.857 9.80304 11.8979 9.68858C11.9142 9.63952 11.808 9.57413 11.6935 9.50055C11.6117 9.44332 11.5136 9.38608 11.4482 9.3125V9.32068Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8403 9.50024C11.7912 9.6474 11.4315 9.2386 11.3252 9.09961C11.4969 9.26313 11.873 9.39395 11.8403 9.50024Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7916 9.54306C11.6771 9.54306 11.4073 9.23238 11.3174 9.10156C11.3991 9.15062 11.4972 9.21603 11.5954 9.26509C11.7425 9.35502 11.8733 9.42044 11.8406 9.50219C11.8325 9.52672 11.8161 9.54306 11.7916 9.54306ZM11.3174 9.10156C11.44 9.24055 11.7834 9.62482 11.8243 9.49401C11.8488 9.43678 11.718 9.36319 11.5872 9.28143C11.4891 9.23238 11.391 9.16697 11.3174 9.10156Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8227 9.34547C11.9453 9.31277 11.8145 9.21466 11.6592 9.04297C11.6592 9.22284 11.6837 9.35364 11.8227 9.34547Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.8168 9.35365C11.776 9.35365 11.7433 9.33729 11.7106 9.31276C11.6697 9.27188 11.6533 9.18196 11.6533 9.04297L11.7514 9.12471C11.8414 9.21464 11.8986 9.27188 11.8822 9.31276C11.8822 9.32911 11.8577 9.34547 11.825 9.34547H11.8087L11.8168 9.35365ZM11.6615 9.05113C11.6615 9.18194 11.686 9.25554 11.7269 9.29642C11.7514 9.32094 11.776 9.3291 11.8168 9.3291H11.8332C11.8577 9.3291 11.8659 9.31275 11.8741 9.30458C11.8822 9.27187 11.825 9.21465 11.7514 9.13289L11.6697 9.04297L11.6615 9.05113Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6103 9.23869C11.6593 9.18146 11.5612 9.14875 11.4222 9.00977C11.4059 9.10788 11.5449 9.28774 11.6103 9.23869Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5867 9.2554C11.5867 9.2554 11.5213 9.23088 11.4886 9.19001C11.4477 9.14095 11.4069 9.05918 11.4232 9.00195C11.4886 9.05101 11.5295 9.0919 11.5704 9.11643C11.6113 9.14913 11.6358 9.17366 11.6358 9.19819C11.6358 9.21454 11.6358 9.2227 11.6194 9.23087L11.5867 9.24724V9.2554ZM11.415 9.01014C11.415 9.05919 11.4559 9.13277 11.4968 9.18182C11.5295 9.2227 11.5622 9.23906 11.5867 9.23906H11.6031C11.6031 9.19818 11.5867 9.17366 11.5459 9.14095C11.5131 9.10825 11.4641 9.06738 11.415 9.01832V9.01014Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2256 9.91056C12.291 9.95144 12.34 9.80428 12.2582 9.68164C12.2419 9.81245 12.1683 9.85333 12.2256 9.91056Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.2486 9.9269H12.2241C12.1832 9.88603 12.1914 9.84515 12.2077 9.80427C12.2241 9.77157 12.2404 9.7307 12.2486 9.68164C12.314 9.7634 12.3222 9.85332 12.2977 9.89419C12.2895 9.91872 12.265 9.9269 12.2486 9.9269ZM12.2486 9.68164C12.2486 9.73887 12.2486 9.77157 12.2241 9.80427C12.2077 9.85333 12.1996 9.87785 12.2241 9.90238H12.2404C12.2404 9.90238 12.265 9.90239 12.2731 9.88604C12.2977 9.84516 12.2895 9.7634 12.2404 9.68164H12.2486Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7198 9.01816C10.5726 9.1081 10.3355 8.75654 10.2783 8.60938C10.4091 8.77289 10.7443 8.92823 10.7198 9.01816Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6711 9.03451C10.5158 9.03451 10.3277 8.73201 10.2705 8.60938C10.3441 8.67478 10.4422 8.74019 10.5321 8.81377C10.6466 8.89553 10.7447 8.96093 10.7283 9.01816C10.7038 9.03452 10.6875 9.03451 10.6711 9.03451ZM10.2705 8.60938C10.3604 8.75654 10.5894 9.08356 10.712 9.00998C10.7202 8.9691 10.6221 8.89551 10.524 8.82193C10.434 8.75652 10.3277 8.69113 10.2705 8.60938Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8499 9.22329C10.7682 9.31322 10.5147 9.06795 10.4248 8.94531C10.5638 9.06795 10.8826 9.07612 10.8499 9.22329Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8012 9.24781C10.695 9.24781 10.4906 9.05977 10.417 8.94531C10.4824 8.97802 10.5642 9.01071 10.6459 9.04342C10.7685 9.0843 10.883 9.12518 10.8585 9.22329C10.8421 9.23964 10.8258 9.24781 10.8012 9.24781ZM10.417 8.94531C10.5151 9.0516 10.7686 9.28868 10.8421 9.2151C10.8585 9.13334 10.7604 9.10063 10.6378 9.05158C10.556 9.01887 10.4742 8.99437 10.417 8.94531Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9896 9.40335C10.965 9.52598 10.589 9.248 10.499 9.11719C10.6625 9.26435 11.0059 9.25618 10.9896 9.40335Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.949 9.44387C10.8346 9.44387 10.5648 9.23129 10.4994 9.125C10.5812 9.18223 10.6874 9.21495 10.7855 9.23947C10.9082 9.28035 11.0145 9.31307 10.9981 9.403C10.9981 9.41935 10.9817 9.43568 10.949 9.43568V9.44387ZM10.4994 9.125C10.5812 9.21493 10.8509 9.42753 10.949 9.42753C10.9736 9.42753 10.9818 9.41117 10.9818 9.403C10.9899 9.32942 10.9 9.29669 10.7774 9.25582C10.6793 9.22311 10.5648 9.19041 10.4912 9.125H10.4994Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9323 9.54115C10.8751 9.64744 10.5726 9.37763 10.499 9.23047C10.6871 9.39398 10.9814 9.42669 10.9323 9.54115Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8837 9.57386C10.7774 9.57386 10.5484 9.35311 10.4912 9.23865C10.5811 9.29588 10.6792 9.33676 10.7692 9.38581C10.8836 9.43487 10.9736 9.47575 10.9409 9.54934C10.9245 9.56569 10.9082 9.58205 10.8837 9.58205V9.57386ZM10.4912 9.23865C10.573 9.36129 10.8673 9.63108 10.9245 9.53297C10.949 9.48391 10.8837 9.44305 10.761 9.39399C10.6793 9.35312 10.573 9.30405 10.4994 9.23047L10.4912 9.23865Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7773 9.00209C10.8755 8.90398 10.8264 8.85492 10.761 8.69141C10.7201 8.85492 10.6629 8.92033 10.7773 9.00209Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7769 9.0099C10.6869 8.9445 10.7033 8.88727 10.736 8.78917C10.7442 8.75646 10.7523 8.73192 10.7605 8.69922L10.8014 8.74827C10.8504 8.86273 10.8831 8.91997 10.8014 9.0099H10.7769ZM10.7523 8.69922C10.7523 8.69922 10.7523 8.76464 10.7523 8.78917C10.7196 8.8791 10.7115 8.93632 10.785 8.98538C10.8586 8.90362 10.8341 8.86273 10.785 8.74827L10.7605 8.69922H10.7523Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9005 9.1909C11.0722 9.1909 10.9005 8.98651 10.8678 8.80664C10.8842 9.01104 10.8188 9.16638 10.9005 9.1909Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9082 9.19909H10.9C10.8428 9.18274 10.8428 9.10914 10.8509 9.01104C10.8509 8.9538 10.8509 8.88022 10.8509 8.80664C10.8836 8.86387 10.9082 8.92109 10.9327 8.97833C10.9736 9.06008 11.0063 9.13368 10.9736 9.17456C10.9654 9.19091 10.9409 9.19909 10.9082 9.19909ZM10.8591 8.83935C10.8755 8.89658 10.8673 8.96198 10.8591 9.01104C10.8591 9.10914 10.8591 9.17454 10.8918 9.18272C10.8918 9.18272 10.9327 9.18273 10.949 9.16638C10.9654 9.13367 10.9327 9.06009 10.9 8.98651C10.8755 8.93745 10.8591 8.88841 10.8428 8.83935H10.8591Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0145 9.3541C11.1371 9.3214 11.1044 9.15788 11.0145 8.94531C11.0309 9.17423 10.9082 9.29687 11.0145 9.3541Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0151 9.36973C10.9497 9.33702 10.966 9.2798 10.9824 9.19804C10.9987 9.13264 11.0151 9.05905 11.0069 8.96094C11.105 9.13263 11.1296 9.25527 11.0969 9.32067C11.0805 9.35338 11.0642 9.36156 11.0314 9.37791L11.0151 9.36973ZM10.9988 8.96094C11.0233 9.05905 10.9988 9.13264 10.9988 9.19804C10.9824 9.28798 10.9742 9.32884 11.0233 9.36154C11.0478 9.36154 11.0641 9.33703 11.0805 9.32067C11.1132 9.25527 11.0805 9.14081 11.0069 8.96912L10.9988 8.96094Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9737 9.68885C10.9328 9.82784 10.5895 9.51717 10.5322 9.39453C10.7039 9.5417 11.0064 9.59074 10.9737 9.68885Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.925 9.73753C10.8106 9.73753 10.5653 9.50045 10.5244 9.40234C10.6143 9.45957 10.7043 9.50044 10.7942 9.54132C10.9087 9.59855 10.9986 9.63944 10.9822 9.70484C10.9741 9.73755 10.9495 9.74571 10.925 9.74571V9.73753ZM10.5244 9.4105C10.598 9.51679 10.925 9.81112 10.9659 9.69666C10.9741 9.64761 10.8923 9.60674 10.786 9.55769C10.6961 9.51681 10.598 9.46773 10.5244 9.4105Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1781 9.90139C11.1291 10.0404 10.7694 9.7624 10.6631 9.61523C10.8757 9.78693 11.2108 9.77058 11.1781 9.90139Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1207 9.95105C10.9981 9.95105 10.7446 9.74666 10.6465 9.62402C10.7609 9.68943 10.8836 9.72214 10.9817 9.76302C11.1043 9.79573 11.1943 9.82842 11.1861 9.91018C11.1697 9.94288 11.1534 9.95105 11.1207 9.95105ZM10.6547 9.62402C10.7773 9.76301 11.1289 10.0165 11.1697 9.902C11.1779 9.83659 11.0961 9.80388 10.9735 9.77118C10.8754 9.73848 10.7446 9.69761 10.6465 9.62402H10.6547Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3827 10.1229C11.3255 10.311 10.9494 10.0085 10.835 9.86133C11.0721 10.0412 11.4072 9.98395 11.3827 10.1229Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3091 10.188C11.1702 10.188 10.9249 9.97543 10.835 9.86914C10.9576 9.94272 11.0966 9.97543 11.211 9.99996C11.3255 10.0245 11.4154 10.049 11.3991 10.1226C11.3827 10.1635 11.3582 10.188 11.3091 10.188ZM10.8431 9.86914C10.9658 9.99178 11.3337 10.2861 11.3827 10.1226C11.3991 10.0654 11.3337 10.049 11.211 10.0245C11.0966 9.99178 10.9576 9.96726 10.8431 9.87732V9.86914Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0299 9.63095C11.128 9.68001 11.1689 9.39385 11.1199 9.18945C11.1199 9.4102 10.9155 9.5819 11.0299 9.63095Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.056 9.64925H11.0314C11.0314 9.64925 10.9987 9.61656 10.9906 9.60838C10.9742 9.57568 10.9987 9.5266 11.0314 9.4612C11.0641 9.38761 11.1132 9.2977 11.1132 9.19959C11.1704 9.34675 11.1622 9.55932 11.1132 9.62472C11.0968 9.64107 11.0805 9.64925 11.0641 9.64925H11.056ZM11.1132 9.19959C11.1295 9.30588 11.0887 9.3958 11.0478 9.46938C11.0151 9.52661 10.9905 9.57567 11.0069 9.6002C11.0069 9.60837 11.0233 9.61655 11.0396 9.62472H11.0641C11.0641 9.62472 11.0887 9.62473 11.0968 9.60838C11.1459 9.54297 11.1622 9.34675 11.1214 9.19141L11.1132 9.19959Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2115 9.86093C11.3259 9.90181 11.2932 9.59111 11.1869 9.38672C11.1706 9.58294 11.0807 9.77099 11.2115 9.86093Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2274 9.87727H11.2028C11.1047 9.81186 11.1292 9.68924 11.1538 9.55843C11.1538 9.50937 11.1701 9.44396 11.1701 9.3949C11.2764 9.55842 11.3173 9.77917 11.2682 9.86093C11.2519 9.87728 11.2437 9.88545 11.2274 9.88545V9.87727ZM11.1783 9.3949C11.1946 9.44396 11.1783 9.5012 11.1783 9.55843C11.1538 9.68924 11.1293 9.79551 11.2192 9.85274H11.2355C11.2355 9.85274 11.2601 9.85275 11.2682 9.8364C11.3091 9.76282 11.2682 9.54206 11.1865 9.38672L11.1783 9.3949Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4232 10.0814C11.5622 10.0896 11.4641 9.81159 11.3496 9.65625C11.3741 9.86064 11.3087 10.0569 11.4232 10.0814Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4236 10.0902C11.3418 10.0738 11.3418 9.97573 11.35 9.85309C11.35 9.78768 11.35 9.73045 11.35 9.66504C11.4563 9.7795 11.5298 9.9839 11.4971 10.0575C11.489 10.082 11.4644 10.0902 11.4317 10.0902H11.4236ZM11.3418 9.66504C11.3663 9.73045 11.3663 9.78768 11.3581 9.85309C11.3581 9.96755 11.3582 10.0575 11.4236 10.0738C11.4236 10.0738 11.4644 10.0738 11.4726 10.0493C11.5053 9.97572 11.4317 9.7795 11.3418 9.66504Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1863 10.196C11.1454 10.2696 11.0473 10.1388 10.8838 10.0488C11.031 10.0897 11.2026 10.1388 11.1863 10.196Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1523 10.2205C11.1523 10.2205 11.0788 10.1878 11.0216 10.1469C10.9807 10.1142 10.9316 10.0815 10.8744 10.0488C11.0215 10.0652 11.1523 10.1061 11.185 10.1551V10.1878C11.1687 10.2042 11.1605 10.2124 11.1442 10.2124L11.1523 10.2205ZM10.8744 10.0488C10.9398 10.0652 10.9888 10.0979 11.0297 10.1306C11.1033 10.1878 11.1524 10.2205 11.1687 10.1878C11.136 10.1224 10.9725 10.0734 10.8662 10.0488H10.8744Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7198 9.01816C10.5726 9.1081 10.3355 8.75654 10.2783 8.60938C10.4091 8.77289 10.7443 8.92823 10.7198 9.01816Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6711 9.03451C10.5158 9.03451 10.3277 8.73201 10.2705 8.60938C10.3441 8.67478 10.4422 8.74019 10.5321 8.81377C10.6466 8.89553 10.7447 8.96093 10.7283 9.01816C10.7038 9.03452 10.6875 9.03451 10.6711 9.03451ZM10.2705 8.60938C10.3604 8.75654 10.5894 9.08356 10.712 9.00998C10.7202 8.9691 10.6221 8.89551 10.524 8.82193C10.434 8.75652 10.3277 8.69113 10.2705 8.60938Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8499 9.22329C10.7682 9.31322 10.5147 9.06795 10.4248 8.94531C10.5638 9.06795 10.8826 9.07612 10.8499 9.22329Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8012 9.24781C10.695 9.24781 10.4906 9.05977 10.417 8.94531C10.4824 8.97802 10.5642 9.01071 10.6459 9.04342C10.7685 9.0843 10.883 9.12518 10.8585 9.22329C10.8421 9.23964 10.8258 9.24781 10.8012 9.24781ZM10.417 8.94531C10.5151 9.0516 10.7686 9.28868 10.8421 9.2151C10.8585 9.13334 10.7604 9.10063 10.6378 9.05158C10.556 9.01887 10.4742 8.99437 10.417 8.94531Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9896 9.40335C10.965 9.52598 10.589 9.248 10.499 9.11719C10.6625 9.26435 11.0059 9.25618 10.9896 9.40335Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.949 9.44387C10.8346 9.44387 10.5648 9.23129 10.4994 9.125C10.5812 9.18223 10.6874 9.21495 10.7855 9.23947C10.9082 9.28035 11.0145 9.31307 10.9981 9.403C10.9981 9.41935 10.9817 9.43568 10.949 9.43568V9.44387ZM10.4994 9.125C10.5812 9.21493 10.8509 9.42753 10.949 9.42753C10.9736 9.42753 10.9818 9.41117 10.9818 9.403C10.9899 9.32942 10.9 9.29669 10.7774 9.25582C10.6793 9.22311 10.5648 9.19041 10.4912 9.125H10.4994Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9323 9.54115C10.8751 9.64744 10.5726 9.37763 10.499 9.23047C10.6871 9.39398 10.9814 9.42669 10.9323 9.54115Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8837 9.57386C10.7774 9.57386 10.5484 9.35311 10.4912 9.23865C10.5811 9.29588 10.6792 9.33676 10.7692 9.38581C10.8836 9.43487 10.9736 9.47575 10.9409 9.54934C10.9245 9.56569 10.9082 9.58205 10.8837 9.58205V9.57386ZM10.4912 9.23865C10.573 9.36129 10.8673 9.63108 10.9245 9.53297C10.949 9.48391 10.8837 9.44305 10.761 9.39399C10.6793 9.35312 10.573 9.30405 10.4994 9.23047L10.4912 9.23865Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7773 9.00209C10.8755 8.90398 10.8264 8.85492 10.761 8.69141C10.7201 8.85492 10.6629 8.92033 10.7773 9.00209Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7769 9.01027C10.6869 8.93669 10.7033 8.87946 10.736 8.78135C10.7442 8.74865 10.7523 8.72411 10.7605 8.69141L10.8014 8.74048C10.8504 8.85494 10.8831 8.91216 10.8014 9.00209L10.7769 9.01027ZM10.7523 8.69959C10.7523 8.69959 10.7523 8.76501 10.7523 8.78954C10.7196 8.87947 10.7115 8.93669 10.785 8.98575C10.8586 8.90399 10.8341 8.8631 10.785 8.74864L10.7605 8.69959H10.7523Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9005 9.1909C11.0722 9.1909 10.9005 8.98651 10.8678 8.80664C10.8842 9.01104 10.8188 9.16638 10.9005 9.1909Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9082 9.19909H10.9C10.8428 9.18274 10.8428 9.10914 10.8509 9.01104C10.8509 8.9538 10.8509 8.88022 10.8509 8.80664C10.8836 8.86387 10.9082 8.92109 10.9327 8.97833C10.9736 9.06008 11.0063 9.13368 10.9736 9.17456C10.9654 9.19091 10.9409 9.19909 10.9082 9.19909ZM10.8591 8.83935C10.8755 8.89658 10.8673 8.96198 10.8591 9.01104C10.8591 9.10914 10.8591 9.17454 10.8918 9.18272C10.8918 9.18272 10.9327 9.18273 10.949 9.16638C10.9654 9.13367 10.9327 9.06009 10.9 8.98651C10.8755 8.93745 10.8591 8.88841 10.8428 8.83935H10.8591Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0145 9.3541C11.1371 9.3214 11.1044 9.15788 11.0145 8.94531C11.0309 9.17423 10.9082 9.29687 11.0145 9.3541Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0063 9.3707C10.9409 9.338 10.9573 9.2726 10.9736 9.19902C10.99 9.13361 11.0063 9.06002 10.9982 8.96191C11.0963 9.13361 11.1208 9.25624 11.0881 9.32165C11.0717 9.35435 11.0554 9.36254 11.0227 9.37889L11.0063 9.3707ZM10.9982 8.96191C11.0227 9.06002 10.9982 9.13361 10.9982 9.19902C10.9818 9.28895 10.9736 9.32982 11.0227 9.36252C11.0472 9.36252 11.0635 9.338 11.0799 9.32165C11.1126 9.25624 11.0799 9.14179 11.0063 8.9701L10.9982 8.96191Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9737 9.68885C10.9328 9.82784 10.5895 9.51717 10.5322 9.39453C10.7039 9.5417 11.0064 9.59074 10.9737 9.68885Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.925 9.73753C10.8106 9.73753 10.5653 9.50045 10.5244 9.40234C10.6143 9.45957 10.7043 9.50044 10.7942 9.54132C10.9087 9.59855 10.9986 9.63944 10.9822 9.70484C10.9741 9.73755 10.9495 9.74571 10.925 9.74571V9.73753ZM10.5244 9.4105C10.598 9.51679 10.925 9.81112 10.9659 9.69666C10.9741 9.64761 10.8923 9.60674 10.786 9.55769C10.6961 9.51681 10.598 9.46773 10.5244 9.4105Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1781 9.90139C11.1291 10.0404 10.7694 9.7624 10.6631 9.61523C10.8757 9.78693 11.2108 9.77058 11.1781 9.90139Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1207 9.95105C10.9981 9.95105 10.7446 9.74666 10.6465 9.62402C10.7609 9.68943 10.8836 9.72214 10.9817 9.76302C11.1043 9.79573 11.1943 9.82842 11.1861 9.91018C11.1697 9.94288 11.1534 9.95105 11.1207 9.95105ZM10.6547 9.62402C10.7773 9.76301 11.1289 10.0165 11.1697 9.902C11.1779 9.83659 11.0961 9.80388 10.9735 9.77118C10.8754 9.73848 10.7446 9.69761 10.6465 9.62402H10.6547Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3827 10.1229C11.3255 10.311 10.9494 10.0085 10.835 9.86133C11.0721 10.0412 11.4072 9.98395 11.3827 10.1229Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.3091 10.188C11.1702 10.188 10.9249 9.97543 10.835 9.86914C10.9576 9.94272 11.0966 9.97543 11.211 9.99996C11.3255 10.0245 11.4154 10.049 11.3991 10.1226C11.3827 10.1635 11.3582 10.188 11.3091 10.188ZM10.8431 9.86914C10.9658 9.99178 11.3337 10.2861 11.3827 10.1226C11.3991 10.0654 11.3337 10.049 11.211 10.0245C11.0966 9.99178 10.9576 9.96726 10.8431 9.87732V9.86914Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0299 9.63095C11.128 9.68001 11.1689 9.39385 11.1199 9.18945C11.1199 9.4102 10.9155 9.5819 11.0299 9.63095Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.056 9.64925H11.0314C11.0314 9.64925 10.9987 9.61656 10.9906 9.60838C10.9742 9.57568 10.9987 9.5266 11.0314 9.4612C11.0641 9.38761 11.1132 9.2977 11.1132 9.19959C11.1704 9.34675 11.1622 9.55932 11.1132 9.62472C11.0968 9.64107 11.0805 9.64925 11.0641 9.64925H11.056ZM11.1132 9.19959C11.1295 9.30588 11.0887 9.3958 11.0478 9.46938C11.0151 9.52661 10.9905 9.57567 11.0069 9.6002C11.0069 9.60837 11.0233 9.61655 11.0396 9.62472H11.0641C11.0641 9.62472 11.0887 9.62473 11.0968 9.60838C11.1459 9.54297 11.1622 9.34675 11.1214 9.19141L11.1132 9.19959Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2115 9.86093C11.3259 9.90181 11.2932 9.59111 11.1869 9.38672C11.1706 9.58294 11.0807 9.77099 11.2115 9.86093Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2274 9.87727H11.2028C11.1047 9.81186 11.1292 9.68924 11.1538 9.55843C11.1538 9.50937 11.1701 9.44396 11.1701 9.3949C11.2764 9.55842 11.3173 9.77917 11.2682 9.86093C11.2519 9.87728 11.2437 9.88545 11.2274 9.88545V9.87727ZM11.1783 9.3949C11.1946 9.44396 11.1783 9.5012 11.1783 9.55843C11.1538 9.68924 11.1293 9.79551 11.2192 9.85274H11.2355C11.2355 9.85274 11.2601 9.85275 11.2682 9.8364C11.3091 9.76282 11.2682 9.54206 11.1865 9.38672L11.1783 9.3949Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4232 10.0814C11.5622 10.0896 11.4641 9.81159 11.3496 9.65625C11.3741 9.86064 11.3087 10.0569 11.4232 10.0814Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4236 10.0902C11.3418 10.0738 11.3418 9.97573 11.35 9.85309C11.35 9.78768 11.35 9.73045 11.35 9.66504C11.4563 9.7795 11.5298 9.9839 11.4971 10.0575C11.489 10.082 11.4644 10.0902 11.4317 10.0902H11.4236ZM11.3418 9.66504C11.3663 9.73045 11.3663 9.78768 11.3581 9.85309C11.3581 9.96755 11.3582 10.0575 11.4236 10.0738C11.4236 10.0738 11.4644 10.0738 11.4726 10.0493C11.5053 9.97572 11.4317 9.7795 11.3418 9.66504Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1863 10.196C11.1454 10.2696 11.0473 10.1388 10.8838 10.0488C11.031 10.0897 11.2026 10.1388 11.1863 10.196Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1523 10.2205C11.1523 10.2205 11.0788 10.1878 11.0216 10.1469C10.9807 10.1142 10.9316 10.0815 10.8744 10.0488C11.0215 10.0652 11.1523 10.1061 11.185 10.1551V10.1878C11.185 10.1878 11.1687 10.2124 11.1523 10.2124V10.2205ZM10.8744 10.0488C10.9398 10.0652 10.9888 10.0979 11.0297 10.1306C11.1033 10.1878 11.1524 10.2205 11.1687 10.1878C11.136 10.1224 10.9725 10.0734 10.8662 10.0488H10.8744Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1044 7.88156C11.2353 7.79162 11.1371 7.61176 11.1044 7.44824C11.0636 7.60358 10.9491 7.81615 11.1044 7.88156Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1035 7.89109C10.9727 7.83386 11.0299 7.67035 11.0708 7.53954C11.0708 7.50683 11.0953 7.47411 11.1035 7.44141C11.128 7.48229 11.1362 7.52318 11.1526 7.56406C11.1853 7.69488 11.218 7.80932 11.1199 7.88291L11.1035 7.89109ZM11.1035 7.45777C11.1035 7.45777 11.0953 7.50683 11.0872 7.53954C11.0463 7.67035 10.9972 7.81749 11.1117 7.87472C11.2016 7.80114 11.1689 7.68668 11.1362 7.57222C11.1199 7.53134 11.1117 7.49865 11.1117 7.45777H11.1035Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1043 8.11886C10.9081 8.09434 10.9408 7.84089 10.9326 7.68555C10.9898 7.89812 11.1534 7.93082 11.1043 8.11886Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1043 8.1267C10.9326 8.10217 10.9326 7.91412 10.9326 7.75878V7.69336C10.9735 7.78329 11.0144 7.84054 11.0552 7.8896C11.1043 7.96318 11.1452 8.02041 11.1207 8.1267C11.1207 8.1267 11.1207 8.1267 11.1125 8.1267H11.1043ZM10.9326 7.69336L10.949 7.75878C10.949 7.90594 10.949 8.08581 11.1043 8.11033C11.1288 8.01222 11.088 7.96316 11.0389 7.89775C10.998 7.84052 10.9571 7.79147 10.9326 7.69336Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1288 8.08604C11.2923 8.08604 11.2841 7.88983 11.2923 7.70996C11.2105 7.88165 11.1124 7.90617 11.1288 8.08604Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1292 8.08739C11.121 7.96475 11.1537 7.91571 11.2028 7.84212C11.2273 7.80942 11.26 7.76854 11.2927 7.71131V7.76855C11.2927 7.94024 11.2927 8.09555 11.1374 8.10373L11.1292 8.08739ZM11.2845 7.70312C11.2763 7.76853 11.2437 7.80125 11.2191 7.84212C11.1701 7.91571 11.1292 7.96474 11.1455 8.0792C11.2764 8.06285 11.2845 7.9157 11.2845 7.76036V7.71131V7.70312Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1211 8.31557C10.9985 8.32374 10.9249 8.2011 10.9004 8.00488C11.0148 8.18475 11.1293 8.12752 11.1211 8.31557Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1123 8.32473C10.9979 8.32473 10.9243 8.21843 10.8916 8.00586C10.957 8.07127 10.9979 8.10397 11.0388 8.13668C11.0878 8.16938 11.1369 8.20208 11.1287 8.31654H11.1123V8.32473ZM10.8916 8.01404C10.9407 8.20209 11.0061 8.30836 11.1123 8.30836H11.1205C11.1205 8.21025 11.0796 8.18574 11.0306 8.14486C10.9897 8.11216 10.9407 8.07944 10.8916 8.00586V8.01404Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.17 8.29897C11.3335 8.32349 11.3008 8.13545 11.3008 7.98828C11.2518 8.11909 11.1209 8.15998 11.17 8.29897Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1946 8.3075H11.1701C11.1292 8.20939 11.1701 8.16033 11.2191 8.1031C11.2436 8.0704 11.2763 8.02953 11.3009 7.98865L11.3172 8.02952C11.3172 8.11946 11.3172 8.22576 11.2763 8.27481C11.2518 8.29116 11.2355 8.3075 11.2028 8.3075H11.1946ZM11.2927 7.98865C11.2927 8.04588 11.26 8.07859 11.2354 8.11947C11.1864 8.16852 11.1537 8.21757 11.1782 8.29115H11.1946C11.1946 8.29115 11.2436 8.28297 11.26 8.25844C11.3009 8.21756 11.3009 8.1113 11.2927 8.02136V7.98047V7.98865Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.916 8.21777C10.9324 8.34041 11.0059 8.55299 11.1286 8.50393C11.1858 8.35677 11.0223 8.32406 10.916 8.21777Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0963 8.52027C10.99 8.52027 10.9164 8.34041 10.9082 8.21777C10.9573 8.2423 10.99 8.26683 11.0227 8.29135C11.1044 8.34858 11.178 8.39763 11.1371 8.51209C11.1208 8.52027 11.1044 8.52027 11.0963 8.52027ZM10.9082 8.22596C10.9409 8.34859 11.0227 8.53663 11.1289 8.50393C11.1616 8.40582 11.0962 8.36493 11.0145 8.31588C10.9818 8.29135 10.9409 8.26682 10.9082 8.23412V8.22596Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1699 8.51967C11.1127 8.40521 11.3007 8.35615 11.3334 8.20898C11.358 8.41338 11.3335 8.5442 11.1699 8.51967Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2186 8.52785C11.2186 8.52785 11.1859 8.52785 11.1777 8.52785C11.1368 8.45427 11.1777 8.4134 11.2349 8.35617C11.2758 8.31529 11.3167 8.27439 11.333 8.20898C11.3657 8.36432 11.3576 8.44609 11.3167 8.49514C11.2921 8.51967 11.2594 8.52785 11.2186 8.52785ZM11.333 8.21717C11.333 8.28257 11.284 8.33162 11.2431 8.36433C11.194 8.41338 11.1532 8.45425 11.1859 8.51148C11.194 8.51148 11.2104 8.51148 11.2186 8.51148C11.2513 8.51148 11.284 8.49515 11.3085 8.4788C11.3494 8.42157 11.3494 8.30709 11.333 8.20898V8.21717Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1044 7.88156C11.2353 7.79162 11.1371 7.61176 11.1044 7.44824C11.0636 7.60358 10.9491 7.81615 11.1044 7.88156Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1035 7.89109C10.9727 7.82568 11.0299 7.67035 11.0708 7.53954C11.0708 7.50683 11.0953 7.47411 11.1035 7.44141C11.128 7.48229 11.1362 7.52318 11.1526 7.56406C11.1853 7.69488 11.218 7.80932 11.1199 7.88291L11.1035 7.89109ZM11.1035 7.46593C11.1035 7.46593 11.0953 7.51499 11.0872 7.5477C11.0463 7.67851 10.9972 7.82568 11.1117 7.88291C11.2016 7.80932 11.1689 7.69487 11.1362 7.58041C11.1199 7.53953 11.1117 7.50681 11.1117 7.46593H11.1035Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1043 8.11886C10.9081 8.09434 10.9408 7.84089 10.9326 7.68555C10.9898 7.89812 11.1534 7.93082 11.1043 8.11886Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1037 8.12768C10.932 8.10315 10.932 7.9151 10.932 7.75976V7.69434C10.9729 7.78427 11.0138 7.84152 11.0546 7.89057C11.1037 7.96415 11.1446 8.02139 11.1201 8.12768H11.1037ZM10.9238 7.70252L10.9402 7.76794C10.9402 7.9151 10.9402 8.09497 11.0955 8.11949C11.1201 8.02138 11.0792 7.97232 11.0301 7.90691C10.9892 7.84968 10.9484 7.80063 10.9238 7.70252Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1288 8.08604C11.2923 8.08604 11.2841 7.88983 11.2923 7.70996C11.2105 7.88165 11.1124 7.90617 11.1288 8.08604Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1214 8.09557C11.1132 7.96476 11.1459 7.90752 11.1949 7.83394C11.2195 7.80124 11.2522 7.76036 11.2849 7.70312V7.76036C11.2849 7.93205 11.2849 8.0874 11.1295 8.09557H11.1214ZM11.2849 7.71131C11.2767 7.77672 11.244 7.8094 11.2195 7.85028C11.1704 7.92387 11.1295 7.97293 11.1459 8.08739C11.2767 8.07104 11.2849 7.92389 11.2849 7.76855V7.71949V7.71131Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1211 8.31557C10.9985 8.32374 10.9249 8.2011 10.9004 8.00488C11.0148 8.18475 11.1293 8.12752 11.1211 8.31557Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1123 8.32473C10.9979 8.32473 10.9243 8.21843 10.8916 8.00586C10.957 8.07127 10.9979 8.10397 11.0388 8.13668C11.0878 8.16938 11.1369 8.20208 11.1287 8.31654H11.1123V8.32473ZM10.8916 8.01404C10.9407 8.20209 11.0061 8.30836 11.1123 8.30836H11.1205C11.1205 8.21025 11.0796 8.18574 11.0306 8.14486C10.9897 8.11216 10.9407 8.07944 10.8916 8.00586V8.01404Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.17 8.29897C11.3335 8.32349 11.3008 8.13545 11.3008 7.98828C11.2518 8.11909 11.1209 8.15998 11.17 8.29897Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1946 8.3075H11.1701C11.1292 8.20939 11.1701 8.16033 11.2191 8.1031C11.2436 8.0704 11.2763 8.02953 11.3009 7.98865L11.3172 8.02952C11.3172 8.11946 11.3172 8.22576 11.2763 8.27481C11.2518 8.29116 11.2355 8.3075 11.2028 8.3075H11.1946ZM11.2927 7.98865C11.2927 8.04588 11.26 8.07859 11.2354 8.11947C11.1864 8.16852 11.1537 8.21757 11.1782 8.29115H11.1946C11.1946 8.29115 11.2436 8.28297 11.26 8.25844C11.3009 8.21756 11.3009 8.1113 11.2927 8.02136V7.98047V7.98865Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.916 8.21777C10.9324 8.34041 11.0059 8.55299 11.1286 8.50393C11.1858 8.35677 11.0223 8.32406 10.916 8.21777Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0963 8.52027C10.99 8.52027 10.9164 8.34041 10.9082 8.21777C10.9573 8.2423 10.99 8.26683 11.0227 8.29135C11.1044 8.34858 11.178 8.39763 11.1371 8.51209C11.1208 8.52027 11.1044 8.52027 11.0963 8.52027ZM10.9082 8.22596C10.9409 8.34859 11.0227 8.53663 11.1289 8.50393C11.1616 8.40582 11.0962 8.36493 11.0145 8.31588C10.9818 8.29135 10.9409 8.26682 10.9082 8.23412V8.22596Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.1699 8.51967C11.1127 8.40521 11.3007 8.35615 11.3334 8.20898C11.358 8.41338 11.3335 8.5442 11.1699 8.51967Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2186 8.52785C11.2186 8.52785 11.1859 8.52785 11.1777 8.52785C11.1368 8.45427 11.1777 8.4134 11.2349 8.35617C11.2758 8.31529 11.3167 8.27439 11.333 8.20898C11.3657 8.36432 11.3576 8.44609 11.3167 8.49514C11.2921 8.51967 11.2594 8.52785 11.2186 8.52785ZM11.333 8.21717C11.333 8.28257 11.284 8.33162 11.2431 8.36433C11.194 8.41338 11.1532 8.45425 11.1859 8.51148C11.194 8.51148 11.2104 8.51148 11.2186 8.51148C11.2513 8.51148 11.284 8.49515 11.3085 8.4788C11.3494 8.42157 11.3494 8.30709 11.333 8.20898V8.21717Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6469 7.23677C10.745 7.12231 10.655 6.95063 10.6223 6.78711C10.5814 6.94245 10.516 7.15501 10.6469 7.23677Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6471 7.24495C10.5245 7.17137 10.5736 6.98332 10.6145 6.82798V6.78711C10.6472 6.82799 10.6635 6.87704 10.6717 6.90974C10.7044 7.04055 10.7371 7.15502 10.6635 7.24495H10.6471ZM10.6226 6.78711V6.82798C10.5899 6.97514 10.5409 7.14684 10.6471 7.22043C10.7126 7.13867 10.688 7.03238 10.6471 6.90974C10.6308 6.86886 10.6226 6.82799 10.6145 6.78711H10.6226Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6463 7.44012C10.4664 7.45647 10.4255 7.08857 10.4092 6.94141C10.4664 7.15398 10.6708 7.25207 10.6463 7.44012Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6307 7.4483C10.459 7.4483 10.4181 7.09675 10.3936 6.94141C10.4344 7.03134 10.4917 7.09675 10.5407 7.17033C10.6061 7.25209 10.6633 7.33383 10.647 7.44012H10.6225L10.6307 7.4483ZM10.4017 6.94959C10.4344 7.0804 10.4753 7.44012 10.6307 7.44012H10.647C10.647 7.34201 10.598 7.2766 10.5326 7.18667C10.4835 7.11309 10.4263 7.0477 10.4017 6.94959Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6796 7.43957C10.8022 7.37416 10.7777 7.23519 10.8186 7.12891C10.7286 7.25972 10.655 7.27605 10.6796 7.43957Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6804 7.43994C10.6641 7.3173 10.7049 7.26825 10.754 7.21102C10.7785 7.18649 10.7949 7.16197 10.8194 7.12109C10.8194 7.16197 10.8194 7.19468 10.8194 7.22738C10.8031 7.30914 10.7949 7.39088 10.7049 7.43994H10.6804ZM10.7949 7.1538C10.7949 7.1538 10.7703 7.20284 10.754 7.21102C10.7049 7.26825 10.6723 7.30912 10.6886 7.41541C10.7622 7.37453 10.7704 7.30097 10.7867 7.22738C10.7867 7.20286 10.7949 7.17833 10.803 7.1538H10.7949Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6472 7.67044C10.4674 7.68679 10.3529 7.2862 10.3447 7.13086C10.402 7.34343 10.6717 7.45787 10.6472 7.67044Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6375 7.67862C10.4576 7.67862 10.3431 7.29438 10.3431 7.13086C10.384 7.22079 10.4494 7.29436 10.5148 7.36794C10.5966 7.45787 10.6784 7.5478 10.662 7.67044H10.6375V7.67862ZM10.3431 7.13902C10.3677 7.29436 10.474 7.67044 10.6375 7.67044H10.6456C10.6456 7.56415 10.5721 7.47424 10.4903 7.38431C10.4249 7.31072 10.3595 7.23713 10.335 7.13902H10.3431Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6797 7.66138C10.8514 7.6205 10.835 7.50604 10.8105 7.32617C10.7533 7.50604 10.6633 7.46516 10.6797 7.66138Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6799 7.67896C10.6636 7.5645 10.6881 7.5318 10.729 7.48275C10.7535 7.45005 10.7862 7.41733 10.8026 7.34375C10.8434 7.53179 10.868 7.64627 10.6881 7.68714L10.6799 7.67896ZM10.8026 7.35193C10.8026 7.41734 10.7617 7.45821 10.7372 7.49091C10.7045 7.53179 10.6799 7.56451 10.6963 7.66262C10.8434 7.62991 10.8353 7.5318 10.8107 7.35193H10.8026Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6465 7.90703C10.4421 7.93973 10.4584 7.62089 10.2949 7.38379C10.4339 7.55548 10.6873 7.77621 10.6465 7.90703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6142 7.91521C10.5079 7.91521 10.4588 7.80075 10.4098 7.66176C10.3771 7.57183 10.3443 7.47372 10.2871 7.38379C10.3362 7.41649 10.377 7.46555 10.4179 7.5146C10.5487 7.66177 10.6877 7.80892 10.655 7.90703C10.655 7.90703 10.6223 7.90703 10.6142 7.90703V7.91521ZM10.3198 7.43284C10.3689 7.50642 10.4016 7.58818 10.4261 7.66176C10.4752 7.79258 10.516 7.90703 10.6142 7.90703H10.6468C10.6714 7.81709 10.5406 7.67812 10.4098 7.53913C10.3771 7.50643 10.3525 7.4737 10.3198 7.441V7.43284Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6949 7.88918C10.8503 7.88918 10.8666 7.66025 10.8585 7.57031C10.8258 7.66025 10.6459 7.75019 10.6949 7.88918Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6948 7.89769C10.6457 7.79958 10.7193 7.72601 10.7765 7.66061C10.8093 7.61973 10.8338 7.5952 10.842 7.5625C10.8665 7.63608 10.8583 7.78323 10.7929 7.84863C10.7684 7.88134 10.7357 7.88953 10.6948 7.88953V7.89769ZM10.842 7.57066C10.842 7.57066 10.8174 7.63606 10.7847 7.66876C10.7275 7.73417 10.6703 7.7914 10.6948 7.87316C10.7275 7.87316 10.752 7.86499 10.7847 7.83229C10.842 7.76688 10.8501 7.62791 10.842 7.5625V7.57066Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.3271 7.65234C10.4007 7.90579 10.5152 8.15106 10.646 8.13471C10.7114 7.99572 10.5234 7.97938 10.3271 7.65234Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.63 8.1429C10.5237 8.1429 10.4174 7.97938 10.3193 7.65234C10.4174 7.79133 10.5074 7.87309 10.5646 7.93032C10.6382 8.0039 10.6872 8.04478 10.6545 8.13471H10.63V8.1429ZM10.3193 7.66053C10.4256 7.97121 10.5319 8.12655 10.63 8.12655H10.6464C10.6709 8.06115 10.6382 8.02025 10.5564 7.95484C10.4992 7.88944 10.4093 7.80769 10.3193 7.66053Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6953 8.09547C10.6381 7.98918 10.8262 7.93196 10.8589 7.79297C10.8834 7.99736 10.8588 8.12817 10.6953 8.09547Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7361 8.11181C10.7361 8.11181 10.7034 8.11181 10.6953 8.11181C10.6544 8.03823 10.6953 7.98918 10.7525 7.94013C10.7934 7.89925 10.8424 7.8502 10.8506 7.79297C10.8833 7.94831 10.8751 8.03006 10.8343 8.07094C10.8097 8.09547 10.7852 8.11181 10.7361 8.11181ZM10.8506 7.79297C10.8506 7.85838 10.8016 7.90743 10.7607 7.94831C10.7116 7.99737 10.6707 8.03824 10.7034 8.09547C10.7116 8.09547 10.728 8.09547 10.7443 8.09547C10.777 8.09547 10.8015 8.07911 10.8261 8.06276C10.8751 8.00553 10.867 7.89108 10.8588 7.79297H10.8506Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.377 7.93945C10.4832 8.1602 10.5323 8.42183 10.6876 8.38095C10.7449 8.20926 10.5159 8.16838 10.377 7.93945Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6631 8.38911C10.565 8.38911 10.5078 8.2583 10.4505 8.11114C10.426 8.05391 10.4015 7.99668 10.377 7.93945C10.4505 8.02939 10.5241 8.08662 10.5813 8.14385C10.6631 8.21743 10.7367 8.27467 10.704 8.38095C10.704 8.38095 10.6713 8.38911 10.6631 8.38911ZM10.4178 7.99669C10.4178 7.99669 10.4505 8.07027 10.4587 8.0948C10.5159 8.24196 10.565 8.36459 10.6549 8.36459H10.6794C10.704 8.27465 10.6468 8.22561 10.5568 8.15203C10.5159 8.11115 10.4587 8.0621 10.4097 7.99669H10.4178Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7197 8.3407C10.6543 8.22624 10.8424 8.17719 10.8833 8.01367C10.9078 8.23442 10.8833 8.38158 10.7197 8.3407Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7683 8.35707C10.7683 8.35707 10.7356 8.35706 10.7111 8.34888C10.6702 8.2753 10.7111 8.23443 10.7601 8.1772C10.801 8.13632 10.8501 8.08726 10.8664 8.02186C10.8991 8.18537 10.8909 8.28348 10.8419 8.33254C10.8174 8.34889 10.7928 8.36522 10.7601 8.36522L10.7683 8.35707ZM10.8746 8.02186C10.8746 8.09544 10.8255 8.14448 10.7765 8.18536C10.7274 8.24259 10.6865 8.27529 10.7192 8.3407C10.7601 8.3407 10.8092 8.34069 10.8337 8.30799C10.8746 8.26711 10.8828 8.16901 10.8664 8.01367L10.8746 8.02186Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6469 7.23677C10.745 7.12231 10.655 6.95063 10.6223 6.78711C10.5814 6.94245 10.516 7.15501 10.6469 7.23677Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6553 7.25276H10.6471C10.5245 7.17101 10.5736 6.98296 10.6145 6.83579V6.79492C10.6472 6.8358 10.6635 6.88485 10.6717 6.91755C10.7044 7.04837 10.7371 7.16283 10.6635 7.25276H10.6553ZM10.6226 6.80308V6.84397C10.5899 6.99114 10.5409 7.16281 10.6471 7.2364C10.7126 7.15464 10.688 7.04837 10.6471 6.92574C10.6308 6.88486 10.6226 6.84396 10.6145 6.80308H10.6226Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6463 7.44012C10.4664 7.45647 10.4255 7.08857 10.4092 6.94141C10.4664 7.15398 10.6708 7.25207 10.6463 7.44012Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6307 7.4483C10.459 7.4483 10.4181 7.09675 10.3936 6.94141C10.4344 7.03134 10.4917 7.09675 10.5407 7.17033C10.6061 7.25209 10.6633 7.33383 10.647 7.44012H10.6225L10.6307 7.4483ZM10.4017 6.94959C10.4344 7.0804 10.4753 7.44012 10.6307 7.44012H10.647C10.647 7.34201 10.598 7.2766 10.5326 7.18667C10.4835 7.11309 10.4263 7.0477 10.4017 6.94959Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6796 7.43957C10.8022 7.37416 10.7777 7.23519 10.8186 7.12891C10.7286 7.25972 10.655 7.27605 10.6796 7.43957Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6804 7.44812C10.6641 7.31731 10.7049 7.26825 10.754 7.21102C10.7785 7.18649 10.7949 7.16197 10.8194 7.12109C10.8194 7.16197 10.8194 7.19468 10.8194 7.22738C10.8031 7.30914 10.7949 7.39088 10.7049 7.43994L10.6804 7.44812ZM10.803 7.16196C10.803 7.16196 10.7785 7.21102 10.7622 7.2192C10.7131 7.27643 10.6804 7.31731 10.6968 7.42359C10.7703 7.38272 10.7785 7.30912 10.7949 7.23554C10.7949 7.21101 10.8031 7.18649 10.8112 7.16196H10.803Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6472 7.67044C10.4674 7.68679 10.3529 7.2862 10.3447 7.13086C10.402 7.34343 10.6717 7.45787 10.6472 7.67044Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6375 7.67862C10.4576 7.67862 10.3431 7.29438 10.3431 7.13086C10.384 7.22079 10.4494 7.29436 10.5148 7.36794C10.5966 7.45787 10.6784 7.5478 10.662 7.67044H10.6375V7.67862ZM10.3431 7.13902C10.3677 7.29436 10.474 7.67044 10.6375 7.67044H10.6456C10.6456 7.56415 10.5721 7.47424 10.4903 7.38431C10.4249 7.31072 10.3595 7.23713 10.335 7.13902H10.3431Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6797 7.66138C10.8514 7.6205 10.835 7.50604 10.8105 7.32617C10.7533 7.50604 10.6633 7.46516 10.6797 7.66138Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6799 7.67735C10.6636 7.55472 10.6881 7.52201 10.729 7.47296C10.7535 7.44026 10.7862 7.40757 10.8026 7.33398C10.8434 7.52203 10.868 7.63647 10.6881 7.67735H10.6799ZM10.8026 7.35033C10.8026 7.41573 10.7617 7.4566 10.7372 7.4893C10.7045 7.53018 10.6799 7.5629 10.6963 7.66101C10.8434 7.62831 10.8353 7.53019 10.8107 7.35033H10.8026Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6465 7.90703C10.4421 7.93973 10.4584 7.62089 10.2949 7.38379C10.4339 7.55548 10.6873 7.77621 10.6465 7.90703Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6142 7.91521C10.5079 7.91521 10.4588 7.80075 10.4098 7.66176C10.3771 7.57183 10.3443 7.47372 10.2871 7.38379C10.3362 7.41649 10.377 7.46555 10.4179 7.5146C10.5487 7.66177 10.6877 7.80892 10.655 7.90703H10.6142V7.91521ZM10.3198 7.43284C10.3689 7.50642 10.4016 7.58818 10.4261 7.66176C10.4752 7.79258 10.516 7.90703 10.6142 7.90703H10.6468C10.6714 7.81709 10.5406 7.67812 10.4098 7.53913C10.3771 7.50643 10.3525 7.4737 10.3198 7.441V7.43284Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6949 7.88918C10.8503 7.88918 10.8666 7.66025 10.8585 7.57031C10.8258 7.66025 10.6459 7.75019 10.6949 7.88918Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6948 7.89769C10.6457 7.79958 10.7193 7.72601 10.7765 7.66061C10.8093 7.61973 10.8338 7.5952 10.842 7.5625C10.8665 7.63608 10.8583 7.78323 10.7929 7.84863C10.7684 7.88134 10.7357 7.88953 10.6948 7.88953V7.89769ZM10.842 7.57066C10.842 7.57066 10.8174 7.63606 10.7847 7.66876C10.7275 7.73417 10.6703 7.7914 10.6948 7.87316C10.7275 7.87316 10.752 7.86499 10.7847 7.83229C10.842 7.76688 10.8501 7.62791 10.842 7.5625V7.57066Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.3271 7.65234C10.4007 7.90579 10.5152 8.15106 10.646 8.13471C10.7114 7.99572 10.5234 7.97938 10.3271 7.65234Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.63 8.1429C10.5237 8.1429 10.4174 7.97938 10.3193 7.65234C10.4174 7.79133 10.5074 7.87309 10.5646 7.93032C10.6382 8.0039 10.6872 8.04478 10.6545 8.13471H10.63V8.1429ZM10.3193 7.66053C10.4256 7.97121 10.5319 8.12655 10.63 8.12655H10.6464C10.6709 8.06115 10.6382 8.02025 10.5564 7.95484C10.4992 7.88944 10.4093 7.80769 10.3193 7.66053Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6953 8.09547C10.6381 7.98918 10.8262 7.93196 10.8589 7.79297C10.8834 7.99736 10.8588 8.12817 10.6953 8.09547Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7361 8.11181C10.7361 8.11181 10.7034 8.11181 10.6953 8.11181C10.6544 8.03823 10.6953 7.98918 10.7525 7.94013C10.7934 7.89925 10.8424 7.8502 10.8506 7.79297C10.8833 7.94831 10.8751 8.03006 10.8343 8.07094C10.8097 8.09547 10.7852 8.11181 10.7361 8.11181ZM10.8506 7.79297C10.8506 7.85838 10.8016 7.90743 10.7607 7.94831C10.7116 7.99737 10.6707 8.03824 10.7034 8.09547C10.7116 8.09547 10.728 8.09547 10.7443 8.09547C10.777 8.09547 10.8015 8.07911 10.8261 8.06276C10.8751 8.00553 10.867 7.89108 10.8588 7.79297H10.8506Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.377 7.93945C10.4832 8.1602 10.5323 8.42183 10.6876 8.38095C10.7449 8.20926 10.5159 8.16838 10.377 7.93945Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6631 8.38911C10.565 8.38911 10.5078 8.2583 10.4505 8.11114C10.426 8.05391 10.4015 7.99668 10.377 7.93945C10.4505 8.02939 10.5241 8.08662 10.5813 8.14385C10.6631 8.21743 10.7367 8.27467 10.704 8.38095L10.6713 8.38911H10.6631ZM10.4178 7.99669C10.4178 7.99669 10.4505 8.07027 10.4587 8.0948C10.5159 8.24196 10.565 8.36459 10.6549 8.36459H10.6794C10.704 8.27465 10.6468 8.22561 10.5568 8.15203C10.5159 8.11115 10.4587 8.0621 10.4097 7.99669H10.4178Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7197 8.3407C10.6543 8.22624 10.8424 8.17719 10.8833 8.01367C10.9078 8.23442 10.8833 8.38158 10.7197 8.3407Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7683 8.35707C10.7683 8.35707 10.7356 8.35706 10.7111 8.34888C10.6702 8.2753 10.7111 8.23443 10.7601 8.1772C10.801 8.13632 10.8501 8.08726 10.8664 8.02186C10.8991 8.18537 10.8909 8.28348 10.8419 8.33254C10.8174 8.34889 10.7928 8.36522 10.7601 8.36522L10.7683 8.35707ZM10.8746 8.02186C10.8746 8.09544 10.8255 8.14448 10.7765 8.18536C10.7274 8.24259 10.6865 8.27529 10.7192 8.3407C10.7601 8.3407 10.8092 8.34069 10.8337 8.30799C10.8746 8.26711 10.8828 8.16901 10.8664 8.01367L10.8746 8.02186Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0303 6.82838C11.1366 6.86109 11.251 6.73846 11.2101 6.55859C11.0875 6.5913 11.0303 6.70575 11.0303 6.82838Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.063 6.84317H11.0303C11.0303 6.67965 11.0957 6.57336 11.2101 6.54883C11.2428 6.63876 11.2265 6.72052 11.1774 6.77775C11.1447 6.81863 11.1039 6.84317 11.063 6.84317ZM11.202 6.55701C11.1039 6.59789 11.0466 6.68781 11.0385 6.8268H11.063C11.063 6.8268 11.1366 6.80229 11.1611 6.76959C11.202 6.72054 11.2183 6.63877 11.202 6.55701Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6881 6.72885C10.6962 6.78608 10.7616 6.78609 10.7453 6.71251C10.7289 6.65528 10.7289 6.60622 10.7453 6.55717C10.7698 6.49994 10.7616 6.39366 10.7453 6.36096C10.7289 6.3119 10.6635 6.34459 10.6881 6.3773C10.7126 6.41818 10.7208 6.50812 10.7044 6.54082C10.6799 6.59805 10.688 6.67162 10.6962 6.72885H10.6881Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7199 6.7872C10.7199 6.7872 10.6791 6.77085 10.6791 6.73815C10.6709 6.68092 10.6627 6.59915 10.6873 6.5501C10.7036 6.51739 10.7036 6.43563 10.6791 6.39476V6.36207C10.6791 6.36207 10.7363 6.33753 10.7526 6.37023C10.769 6.41111 10.7772 6.5174 10.7526 6.58281C10.7363 6.62369 10.7363 6.66456 10.7526 6.72997C10.7526 6.76267 10.7526 6.77085 10.7526 6.7872L10.7281 6.80355L10.7199 6.7872ZM10.7036 6.3457L10.6873 6.36207C10.72 6.4193 10.7199 6.50922 10.6954 6.5501C10.6709 6.60733 10.6791 6.68091 10.6954 6.72997C10.6954 6.75449 10.7118 6.76268 10.7199 6.76268C10.7199 6.76268 10.7281 6.74633 10.7199 6.72181C10.7036 6.6564 10.7036 6.61552 10.7199 6.56647C10.7445 6.50923 10.7363 6.41111 10.7199 6.37023L10.6954 6.3457H10.7036Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0303 6.82838C11.1366 6.86109 11.251 6.73846 11.2101 6.55859C11.0875 6.5913 11.0303 6.70575 11.0303 6.82838Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.063 6.84317H11.0303C11.0303 6.67965 11.0957 6.57336 11.2101 6.54883C11.2428 6.63876 11.2265 6.72052 11.1774 6.77775C11.1447 6.81863 11.1039 6.84317 11.063 6.84317ZM11.202 6.55701C11.1039 6.59789 11.0466 6.68781 11.0385 6.8268H11.063C11.063 6.8268 11.1366 6.80229 11.1611 6.76959C11.202 6.72054 11.2183 6.63877 11.202 6.55701Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.6881 6.72885C10.6962 6.78608 10.7616 6.78609 10.7453 6.71251C10.7289 6.65528 10.7289 6.60622 10.7453 6.55717C10.7698 6.49994 10.7616 6.39366 10.7453 6.36096C10.7289 6.3119 10.6635 6.34459 10.6881 6.3773C10.7126 6.41818 10.7208 6.50812 10.7044 6.54082C10.6799 6.59805 10.688 6.67162 10.6962 6.72885H10.6881Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.7199 6.7872C10.7199 6.7872 10.6791 6.77085 10.6791 6.73815C10.6709 6.68092 10.6627 6.59915 10.6873 6.5501C10.7036 6.51739 10.7036 6.43563 10.6791 6.39476V6.36207C10.6791 6.36207 10.7363 6.33753 10.7526 6.37023C10.769 6.41111 10.7772 6.5174 10.7526 6.58281C10.7363 6.62369 10.7363 6.66456 10.7526 6.72997C10.7526 6.76267 10.7526 6.77085 10.7526 6.7872L10.7281 6.80355L10.7199 6.7872ZM10.7036 6.3457L10.6873 6.36207C10.72 6.4193 10.7199 6.50922 10.6954 6.5501C10.6709 6.60733 10.6791 6.68091 10.6954 6.72997C10.6954 6.75449 10.7118 6.76268 10.7199 6.76268C10.7199 6.76268 10.7281 6.74633 10.7199 6.72181C10.7036 6.6564 10.7036 6.61552 10.7199 6.56647C10.7445 6.50923 10.7363 6.41111 10.7199 6.37023L10.6954 6.3457H10.7036Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0551 6.54143C11.0551 6.61501 10.9816 6.62318 10.9979 6.50872C11.0143 6.41879 11.0224 6.3452 10.9979 6.27162C10.9734 6.18168 10.9816 6.01818 10.9979 5.95277C11.0224 5.87919 11.0796 5.92007 11.0551 5.9773C11.0224 6.04271 11.0224 6.17352 11.047 6.23075C11.0715 6.32068 11.0633 6.44331 11.047 6.52506L11.0551 6.54143Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0228 6.61547L10.9983 6.59911C10.9983 6.59911 10.9819 6.55825 10.9901 6.51737C11.0064 6.42744 11.0146 6.36203 10.9901 6.28845C10.9656 6.19034 10.9737 6.02681 10.9901 5.96958C10.9983 5.94505 11.0146 5.92871 11.0391 5.92871L11.0637 5.94505C11.0637 5.94505 11.0718 5.98594 11.0637 6.00229C11.0391 6.05952 11.0391 6.19032 11.0555 6.24755C11.08 6.34566 11.08 6.4683 11.0637 6.55005C11.0637 6.59093 11.0391 6.61547 11.0146 6.61547H11.0228ZM11.0391 5.94505C11.0391 5.94505 11.0228 5.9614 11.0146 5.96958C10.9901 6.02681 10.9819 6.19033 11.0146 6.28026C11.0391 6.36202 11.031 6.42744 11.0146 6.51737C11.0146 6.56642 11.0146 6.58277 11.0146 6.59095C11.0146 6.59095 11.0391 6.5746 11.0473 6.5419C11.0555 6.46014 11.0637 6.33749 11.0473 6.24755C11.0228 6.19032 11.0228 6.05133 11.0555 5.98592C11.0555 5.96957 11.0555 5.95323 11.0555 5.94505C11.0555 5.94505 11.0473 5.94505 11.0391 5.94505Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5619 7.33386C11.521 7.39109 11.4556 7.35837 11.4883 7.26026C11.5211 7.19485 11.521 7.10492 11.5619 7.05586C11.611 6.98228 11.6927 6.91687 11.7418 6.876C11.7908 6.82694 11.8317 6.87601 11.7827 6.91689C11.7255 6.96594 11.6682 7.03952 11.6355 7.08857C11.5783 7.18668 11.6028 7.26846 11.5619 7.33386Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5132 7.37554L11.4887 7.35102C11.4887 7.35102 11.4724 7.29379 11.4887 7.25291C11.5051 7.22021 11.5051 7.18749 11.5214 7.16296C11.5296 7.12209 11.5459 7.08122 11.5623 7.04852C11.6032 6.99129 11.6604 6.94224 11.7013 6.90136L11.7422 6.86046C11.7422 6.86046 11.7749 6.83594 11.783 6.83594L11.8076 6.86046C11.8076 6.86046 11.8076 6.89317 11.783 6.9177C11.7258 6.97493 11.6686 7.04033 11.6359 7.08938C11.6032 7.14662 11.595 7.18749 11.595 7.23654C11.595 7.26925 11.5786 7.30197 11.5623 7.33467C11.5459 7.3592 11.5296 7.37554 11.5051 7.37554H11.5132ZM11.7749 6.86865C11.7749 6.86865 11.7585 6.86864 11.7503 6.88499L11.7095 6.92588C11.6686 6.96676 11.6114 7.01581 11.5705 7.07304C11.5459 7.09757 11.5378 7.13844 11.5296 7.17115C11.5214 7.20385 11.5132 7.23655 11.4969 7.26925C11.4805 7.30196 11.4805 7.33466 11.4969 7.35102H11.5132C11.5132 7.35102 11.5378 7.35103 11.5541 7.33467C11.5705 7.30197 11.5786 7.27742 11.5868 7.23654C11.595 7.19566 11.6032 7.13844 11.6359 7.08938C11.6686 7.04033 11.7258 6.97492 11.783 6.90952C11.7994 6.89317 11.7994 6.88498 11.7994 6.87681C11.7994 6.87681 11.7912 6.87681 11.783 6.87681L11.7749 6.86865Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6925 7.43283C11.6516 7.49006 11.5699 7.45735 11.6271 7.3756C11.6843 7.30201 11.7579 7.25297 11.7579 7.17939C11.7579 7.08945 11.8152 6.95863 11.8642 6.90957C11.9133 6.86869 11.9705 6.92593 11.9133 6.96681C11.856 7.00769 11.8152 7.16302 11.8152 7.22025C11.8152 7.31019 11.7252 7.37559 11.6843 7.44099L11.6925 7.43283Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6447 7.47396C11.6447 7.47396 11.612 7.46579 11.6039 7.44944C11.6039 7.44126 11.5957 7.41674 11.6202 7.37586C11.6365 7.35133 11.6529 7.33497 11.6774 7.31862C11.7183 7.27774 11.751 7.23686 11.7592 7.18781C11.7592 7.09787 11.8082 6.95889 11.8655 6.91802C11.9145 6.86896 11.939 6.90167 11.9472 6.9262C11.9472 6.94255 11.9472 6.96708 11.9227 6.97525C11.8655 7.01613 11.8246 7.16329 11.8246 7.2287C11.8246 7.29411 11.7755 7.34315 11.7347 7.3922C11.7183 7.40855 11.7019 7.43309 11.6938 7.44944C11.6774 7.46579 11.6611 7.48215 11.6366 7.48215L11.6447 7.47396ZM11.9063 6.90167C11.9063 6.90167 11.8818 6.90166 11.8736 6.91802C11.8246 6.95889 11.7755 7.08971 11.7755 7.17965C11.7755 7.2287 11.7347 7.26957 11.6856 7.31862C11.6693 7.33497 11.6529 7.35951 11.6366 7.37586C11.612 7.40856 11.612 7.4249 11.612 7.44125L11.6366 7.45762C11.6366 7.45762 11.6693 7.44945 11.6774 7.43309C11.6856 7.41674 11.7101 7.39221 11.7265 7.37586C11.7674 7.3268 11.8082 7.27775 11.8164 7.22052C11.8164 7.16329 11.8491 6.99976 11.9145 6.95888C11.9309 6.95071 11.939 6.93437 11.9309 6.9262C11.9309 6.90985 11.9145 6.90983 11.8982 6.90983L11.9063 6.90167Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6925 7.43283C11.6516 7.49006 11.5699 7.45735 11.6271 7.3756C11.6843 7.30201 11.7579 7.25297 11.7579 7.17939C11.7579 7.08945 11.8152 6.95863 11.8642 6.90957C11.9133 6.86869 11.9705 6.92593 11.9133 6.96681C11.856 7.00769 11.8152 7.16302 11.8152 7.22025C11.8152 7.31019 11.7252 7.37559 11.6843 7.44099L11.6925 7.43283Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.6447 7.47396C11.6447 7.47396 11.612 7.46579 11.6039 7.44944C11.6039 7.44126 11.5957 7.41674 11.6202 7.37586C11.6365 7.35133 11.6529 7.33497 11.6774 7.31862C11.7183 7.27774 11.751 7.23686 11.7592 7.18781C11.7592 7.09787 11.8082 6.95889 11.8655 6.91802C11.9145 6.86896 11.939 6.90167 11.9472 6.9262C11.9472 6.94255 11.9472 6.96708 11.9227 6.97525C11.8655 7.01613 11.8246 7.16329 11.8246 7.2287C11.8246 7.29411 11.7755 7.34315 11.7347 7.3922C11.7183 7.40855 11.7019 7.43309 11.6938 7.44944C11.6774 7.46579 11.6611 7.48215 11.6366 7.48215L11.6447 7.47396ZM11.9063 6.90167C11.9063 6.90167 11.8818 6.90166 11.8736 6.91802C11.8246 6.95889 11.7755 7.08971 11.7755 7.17965C11.7755 7.2287 11.7347 7.26957 11.6856 7.31862C11.6693 7.33497 11.6529 7.35951 11.6366 7.37586C11.612 7.40856 11.612 7.4249 11.612 7.44125L11.6366 7.45762C11.6366 7.45762 11.6693 7.44945 11.6774 7.43309C11.6856 7.41674 11.7101 7.39221 11.7265 7.37586C11.7674 7.3268 11.8082 7.27775 11.8164 7.22052C11.8164 7.16329 11.8491 6.99976 11.9145 6.95888C11.9309 6.95071 11.939 6.93437 11.9309 6.9262C11.9309 6.90985 11.9145 6.90983 11.8982 6.90983L11.9063 6.90167Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5619 7.33386C11.521 7.39109 11.4556 7.35837 11.4883 7.26026C11.5211 7.19485 11.521 7.10492 11.5619 7.05586C11.611 6.98228 11.6927 6.91687 11.7418 6.876C11.7908 6.82694 11.8317 6.87601 11.7827 6.91689C11.7255 6.96594 11.6682 7.03952 11.6355 7.08857C11.5783 7.18668 11.6028 7.26846 11.5619 7.33386Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5132 7.37554L11.4887 7.35102C11.4887 7.35102 11.4724 7.29379 11.4887 7.25291C11.5051 7.22021 11.5051 7.18749 11.5214 7.16296C11.5296 7.12209 11.5459 7.08122 11.5623 7.04852C11.6032 6.99129 11.6604 6.94224 11.7013 6.90136L11.7422 6.86046C11.7422 6.86046 11.7749 6.83594 11.783 6.83594L11.8076 6.86046C11.8076 6.86046 11.8076 6.89317 11.783 6.9177C11.7258 6.97493 11.6686 7.04033 11.6359 7.08938C11.6032 7.14662 11.595 7.18749 11.595 7.23654C11.595 7.26925 11.5786 7.30197 11.5623 7.33467C11.5459 7.3592 11.5296 7.37554 11.5051 7.37554H11.5132ZM11.7749 6.86865C11.7749 6.86865 11.7585 6.86864 11.7503 6.88499L11.7095 6.92588C11.6686 6.96676 11.6114 7.01581 11.5705 7.07304C11.5459 7.09757 11.5378 7.13844 11.5296 7.17115C11.5214 7.20385 11.5132 7.23655 11.4969 7.26925C11.4805 7.30196 11.4805 7.33466 11.4969 7.35102H11.5132C11.5132 7.35102 11.5378 7.35103 11.5541 7.33467C11.5705 7.30197 11.5786 7.27742 11.5868 7.23654C11.595 7.19566 11.6032 7.13844 11.6359 7.08938C11.6686 7.04033 11.7258 6.97492 11.783 6.90952C11.7994 6.89317 11.7994 6.88498 11.7994 6.87681C11.7994 6.87681 11.7912 6.87681 11.783 6.87681L11.7749 6.86865Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8759 7.02322C10.8759 7.10498 10.9413 7.12949 10.9331 7.00686C10.9331 6.87604 10.835 6.76159 10.8922 6.5572C10.9249 6.45909 10.9249 6.27921 10.9086 6.18928C10.8922 6.09117 10.8268 6.15659 10.8514 6.23017C10.8841 6.3201 10.8514 6.47544 10.8268 6.5572C10.7614 6.79429 10.8759 6.91694 10.8759 7.02322Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9 7.08937H10.8755C10.8755 7.08937 10.8591 7.04849 10.8591 7.01579C10.8591 6.97491 10.851 6.93403 10.8346 6.89315C10.8019 6.80322 10.7692 6.7051 10.8101 6.54976C10.8428 6.4353 10.8591 6.29632 10.8346 6.22273C10.8264 6.19003 10.8346 6.15732 10.8428 6.14097C10.8755 6.12462 10.8918 6.14099 10.9 6.18187C10.9245 6.2718 10.9164 6.45983 10.8919 6.54976C10.8592 6.68057 10.8755 6.77051 10.9 6.86044C10.9164 6.90132 10.9245 6.95039 10.9327 6.99944C10.9327 7.04032 10.9245 7.07301 10.9082 7.08937H10.8919H10.9ZM10.8755 6.14097C10.8755 6.14097 10.8428 6.19002 10.851 6.21455C10.8837 6.31266 10.8346 6.49253 10.8264 6.54976C10.7856 6.7051 10.8264 6.80321 10.851 6.88497C10.8673 6.92585 10.8837 6.97491 10.8837 7.01579C10.8837 7.04849 10.8837 7.06485 10.8919 7.07302H10.9082C10.9082 7.07302 10.9245 7.04849 10.9245 6.99126C10.9245 6.95038 10.9164 6.90132 10.9 6.86044C10.8755 6.77051 10.851 6.67241 10.8837 6.5416C10.9164 6.44349 10.9164 6.26362 10.9 6.17368C10.9 6.14098 10.8837 6.13281 10.8755 6.13281V6.14097Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.8759 7.02322C10.8759 7.10498 10.9413 7.12949 10.9331 7.00686C10.9331 6.87604 10.835 6.76159 10.8922 6.5572C10.9249 6.45909 10.9249 6.27921 10.9086 6.18928C10.8922 6.09117 10.8268 6.15659 10.8514 6.23017C10.8841 6.3201 10.8514 6.47544 10.8268 6.5572C10.7614 6.79429 10.8759 6.91694 10.8759 7.02322Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.9 7.08937H10.8755C10.8755 7.08937 10.8591 7.04849 10.8591 7.01579C10.8591 6.97491 10.851 6.93403 10.8346 6.89315C10.8019 6.80322 10.7692 6.7051 10.8101 6.54976C10.8428 6.4353 10.8591 6.29632 10.8346 6.22273C10.8264 6.19003 10.8346 6.15732 10.8428 6.14097C10.8755 6.12462 10.8918 6.14099 10.9 6.18187C10.9245 6.2718 10.9164 6.45983 10.8919 6.54976C10.8592 6.68057 10.8755 6.77051 10.9 6.86044C10.9164 6.90132 10.9245 6.95039 10.9327 6.99944C10.9327 7.04032 10.9245 7.07301 10.9082 7.08937H10.8919H10.9ZM10.8755 6.14097C10.8755 6.14097 10.8428 6.19002 10.851 6.21455C10.8837 6.31266 10.8346 6.49253 10.8264 6.54976C10.7856 6.7051 10.8264 6.80321 10.851 6.88497C10.8673 6.92585 10.8837 6.97491 10.8837 7.01579C10.8837 7.04849 10.8837 7.06485 10.8919 7.07302H10.9082C10.9082 7.07302 10.9245 7.04849 10.9245 6.99126C10.9245 6.95038 10.9164 6.90132 10.9 6.86044C10.8755 6.77051 10.851 6.67241 10.8837 6.5416C10.9164 6.44349 10.9164 6.26362 10.9 6.17368C10.9 6.14098 10.8837 6.13281 10.8755 6.13281V6.14097Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0551 6.54143C11.0551 6.61501 10.9816 6.62318 10.9979 6.50872C11.0143 6.41879 11.0224 6.3452 10.9979 6.27162C10.9734 6.18168 10.9816 6.01818 10.9979 5.95277C11.0224 5.87919 11.0796 5.92007 11.0551 5.9773C11.0224 6.04271 11.0224 6.17352 11.047 6.23075C11.0715 6.32068 11.0633 6.44331 11.047 6.52506L11.0551 6.54143Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.0228 6.61547L10.9983 6.59911C10.9983 6.59911 10.9819 6.55825 10.9901 6.51737C11.0064 6.42744 11.0146 6.36203 10.9901 6.28845C10.9656 6.19034 10.9737 6.02681 10.9901 5.96958C10.9983 5.94505 11.0146 5.92871 11.0391 5.92871L11.0637 5.94505C11.0637 5.94505 11.0718 5.98594 11.0637 6.00229C11.0391 6.05952 11.0391 6.19032 11.0555 6.24755C11.08 6.34566 11.08 6.4683 11.0637 6.55005C11.0637 6.59093 11.0391 6.61547 11.0146 6.61547H11.0228ZM11.0391 5.94505C11.0391 5.94505 11.0228 5.9614 11.0146 5.96958C10.9901 6.02681 10.9819 6.19033 11.0146 6.28026C11.0391 6.36202 11.031 6.42744 11.0146 6.51737C11.0146 6.56642 11.0146 6.58277 11.0146 6.59095C11.0146 6.59095 11.0391 6.5746 11.0473 6.5419C11.0555 6.46014 11.0637 6.33749 11.0473 6.24755C11.0228 6.19032 11.0228 6.05133 11.0555 5.98592C11.0555 5.96957 11.0555 5.95323 11.0555 5.94505C11.0555 5.94505 11.0473 5.94505 11.0391 5.94505Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.3775 8.15937C10.4102 8.20025 10.4674 8.17574 10.4184 8.11851C10.3775 8.07763 10.3939 8.06127 10.3693 8.01222C10.3448 7.95499 10.3448 7.92228 10.3121 7.8814C10.2876 7.84052 10.2467 7.88141 10.2712 7.91411C10.3039 7.95499 10.2958 7.97952 10.3121 8.0204C10.353 8.08581 10.3448 8.1185 10.3775 8.15937Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M10.4095 8.19324C10.4095 8.19324 10.3768 8.18506 10.3686 8.16871C10.3441 8.15236 10.3441 8.12782 10.3359 8.10329C10.3359 8.08694 10.3196 8.06241 10.3032 8.02971C10.2951 8.01336 10.2869 7.99702 10.2869 7.98884C10.2869 7.97249 10.2705 7.94796 10.2542 7.93161C10.246 7.91525 10.246 7.89891 10.2542 7.88255L10.2869 7.86621C10.2869 7.86621 10.3114 7.8662 10.3196 7.88255C10.3441 7.91526 10.3441 7.93161 10.3523 7.96432C10.3523 7.98067 10.3605 7.99703 10.3768 8.02155C10.3768 8.04608 10.385 8.05425 10.3932 8.07061C10.3932 8.08696 10.4013 8.10331 10.4259 8.12784C10.4586 8.16055 10.4504 8.17688 10.4504 8.18505L10.4177 8.20142L10.4095 8.19324ZM10.2705 7.90708C10.2705 7.90708 10.2951 7.95613 10.3032 7.98066C10.3032 7.99701 10.3032 8.0052 10.3196 8.02155C10.3359 8.05426 10.3441 8.07876 10.3523 8.10329C10.3523 8.12782 10.3686 8.14418 10.385 8.16053L10.4177 8.18505L10.434 8.16871C10.434 8.16871 10.434 8.15235 10.4177 8.136C10.3931 8.1033 10.385 8.08695 10.3768 8.06242C10.3768 8.04607 10.3768 8.02973 10.3604 8.02155C10.3523 7.99703 10.3441 7.98067 10.3359 7.96432C10.3359 7.93161 10.3196 7.91526 10.3032 7.89074L10.2705 7.92345V7.90708Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.2764 9.24805C11.3827 9.30528 11.4644 9.43608 11.4726 9.54236C11.4808 9.665 11.4971 9.77129 11.5543 9.85305C11.4644 9.82852 11.4235 9.68954 11.4153 9.55873C11.4072 9.41974 11.3254 9.35433 11.2845 9.24805H11.2764Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.5704 9.86878H11.5459C11.4315 9.82791 11.4069 9.6317 11.3988 9.54994C11.3906 9.46001 11.3579 9.40278 11.317 9.34555C11.2925 9.31284 11.2761 9.28014 11.2598 9.23926C11.3824 9.28014 11.4642 9.41094 11.4723 9.53357C11.4723 9.65621 11.4969 9.7625 11.5541 9.84426L11.5704 9.86878ZM11.2679 9.2556C11.2679 9.2556 11.317 9.31284 11.3333 9.34555C11.366 9.40278 11.4069 9.46002 11.4151 9.55813C11.4315 9.69711 11.4642 9.79522 11.5214 9.8361C11.4805 9.75434 11.4642 9.65622 11.456 9.54176C11.456 9.43547 11.3661 9.30466 11.2679 9.2556Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.4969 9.50195C11.5705 9.64094 11.6686 9.68998 11.6768 9.79627C11.685 9.91073 11.6932 9.91891 11.7259 10.0334C11.6359 10.0088 11.6196 10.0007 11.5951 9.82898C11.5787 9.70634 11.4806 9.6164 11.4969 9.51011V9.50195Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.7415 10.0478H11.7251C11.6352 10.0151 11.6107 10.0069 11.5861 9.82703C11.5861 9.7698 11.5534 9.72892 11.5371 9.67987C11.5125 9.62264 11.488 9.56541 11.488 9.5C11.5371 9.55723 11.578 9.59811 11.6107 9.63082C11.6516 9.67987 11.6924 9.72891 11.6924 9.79432C11.6924 9.88425 11.7088 9.9088 11.7251 9.96603L11.7496 10.0478H11.7415ZM11.4799 9.50816C11.4962 9.56539 11.5207 9.61445 11.5453 9.67168C11.5698 9.72074 11.5943 9.76979 11.6025 9.81884C11.627 9.97418 11.6434 9.99054 11.7088 10.0069L11.6924 9.96603C11.6761 9.9088 11.6679 9.88427 11.6597 9.78616C11.6597 9.72893 11.6188 9.68803 11.578 9.63897C11.5453 9.5981 11.5044 9.55723 11.4717 9.5L11.4799 9.50816Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("mask", {
            id: "mask3_841_19253",
            style: {
              maskType: "luminance"
            },
            maskUnits: "userSpaceOnUse",
            x: 12,
            y: 10,
            width: 5,
            height: 3,
            children: /*#__PURE__*/_jsx("path", {
              d: "M16.2033 10.8164H12.3525V12.0591H16.2033V10.8164Z",
              fill: "white"
            })
          }), /*#__PURE__*/_jsx("g", {
            mask: "url(#mask3_841_19253)",
            children: /*#__PURE__*/_jsx("path", {
              d: "M15.5429 11.7982C15.5429 11.8555 15.551 11.8964 15.5837 11.9291C15.4039 11.8555 15.1504 11.8964 14.9788 11.9781C14.9052 12.019 14.8071 11.9372 14.897 11.8636C15.0278 11.7574 15.3221 11.8228 15.5429 11.7982ZM13.0166 11.7982C13.0166 11.8473 13.0166 11.8964 12.9921 11.9291C13.1883 11.8555 13.3927 11.9209 13.5889 11.9945C13.7279 12.0517 13.736 11.9536 13.7115 11.9209C13.6706 11.8636 13.5889 11.7982 13.4908 11.7901C13.4254 11.7901 13.1719 11.7901 13.0084 11.7901L13.0166 11.7982ZM13.1801 10.8499C13.1229 10.8253 13.0656 10.8499 13.0084 10.9071C12.8204 11.0951 12.5915 11.275 12.4116 11.414C12.3462 11.4712 12.2726 11.5775 12.5669 11.6756C12.5751 11.6756 12.7877 11.7574 12.9185 11.7655C12.9675 11.7655 12.9675 11.8473 12.9594 11.8636C12.9348 11.9045 12.9594 11.9209 12.9103 11.9617C12.8613 12.0026 12.9103 12.0599 12.9512 12.019C13.1147 11.88 13.3763 11.9699 13.6298 12.0517C13.687 12.068 13.7933 12.068 13.7933 11.9781C13.7933 11.8882 13.8587 11.8228 13.8996 11.8228C13.9977 11.8391 14.5127 11.8473 14.6681 11.8228C14.758 11.8146 14.7662 11.9454 14.8152 12.0026C14.8479 12.0353 14.9787 12.0435 15.0687 12.0026C15.2404 11.9209 15.5102 11.9209 15.6246 12.0026C15.6655 12.0353 15.6982 12.0026 15.6737 11.9699C15.641 11.9209 15.641 11.8963 15.6246 11.8636C15.5837 11.7819 15.6246 11.7655 15.6573 11.7574C16.1397 11.7001 16.295 11.5284 16.1479 11.3895C15.9598 11.2259 15.7473 11.0543 15.5592 10.858C15.5102 10.809 15.4775 10.7844 15.3712 10.8253C15.0523 10.9725 14.6517 11.0706 14.2593 11.0788C13.8914 11.0788 13.3845 10.9153 13.1801 10.8253V10.8499Z",
              fill: "black"
            })
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5439 11.7992C15.5439 11.8565 15.552 11.8973 15.5847 11.93C15.4049 11.8565 15.1514 11.8973 14.9797 11.9791C14.9061 12.02 14.808 11.9382 14.898 11.8646C15.0288 11.7583 15.3231 11.8237 15.5439 11.7992ZM13.0176 11.7992C13.0176 11.8483 13.0176 11.8973 12.993 11.93C13.1892 11.8565 13.3936 11.9219 13.5899 11.9954C13.7288 12.0527 13.737 11.9546 13.7125 11.9219C13.6716 11.8646 13.5899 11.7992 13.4918 11.791C13.4263 11.791 13.1729 11.791 13.0094 11.791L13.0176 11.7992ZM13.1811 10.8508C13.1238 10.8263 13.0666 10.8508 13.0094 10.9081C12.8214 11.0961 12.5924 11.276 12.4126 11.415C12.3472 11.4722 12.2736 11.5785 12.5679 11.6766C12.5761 11.6766 12.7886 11.7583 12.9194 11.7665C12.9685 11.7665 12.9685 11.8483 12.9603 11.8646C12.9358 11.9055 12.9603 11.9218 12.9113 11.9627C12.8622 12.0036 12.9113 12.0608 12.9522 12.02C13.1157 11.881 13.3773 11.9709 13.6307 12.0527C13.688 12.069 13.7943 12.069 13.7943 11.9791C13.7943 11.8892 13.8597 11.8237 13.9005 11.8237C13.9986 11.8401 14.5137 11.8483 14.6691 11.8237C14.759 11.8156 14.7672 11.9464 14.8162 12.0036C14.8489 12.0363 14.9797 12.0445 15.0697 12.0036C15.2413 11.9219 15.5111 11.9219 15.6256 12.0036C15.6665 12.0363 15.6992 12.0036 15.6746 11.9709C15.6419 11.9219 15.6419 11.8973 15.6256 11.8646C15.5847 11.7829 15.6256 11.7665 15.6583 11.7583C16.1407 11.7011 16.296 11.5294 16.1488 11.3904C15.9608 11.2269 15.7482 11.0552 15.5602 10.859C15.5111 10.81 15.4784 10.7854 15.3721 10.8263C15.0533 10.9735 14.6527 11.0716 14.2603 11.0797C13.8924 11.0797 13.3855 10.9162 13.1811 10.8263V10.8508Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5412 9.91868C16.5657 9.99226 16.8682 9.85329 17.0154 9.55078C16.811 9.77153 16.4921 9.76334 16.5412 9.91868Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5746 9.95004C16.5746 9.95004 16.5337 9.93369 16.5256 9.92551C16.501 9.83558 16.591 9.79471 16.6972 9.75383C16.7953 9.71295 16.918 9.65573 17.0079 9.55762C16.8935 9.81924 16.6564 9.95822 16.5746 9.95822V9.95004ZM17.0079 9.55762C16.9262 9.6639 16.8035 9.72112 16.7054 9.77017C16.591 9.81923 16.5256 9.86011 16.5419 9.92551L16.5746 9.94186C16.6564 9.94186 16.8771 9.81105 17.0079 9.56578V9.55762Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5412 9.91868C16.5657 9.99226 16.8682 9.85329 17.0154 9.55078C16.811 9.77153 16.4921 9.76334 16.5412 9.91868Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.5746 9.95004C16.5746 9.95004 16.5337 9.93369 16.5256 9.92551C16.501 9.83558 16.591 9.79471 16.6972 9.75383C16.7953 9.71295 16.918 9.65573 17.0079 9.55762C16.8935 9.81924 16.6564 9.95822 16.5746 9.95822V9.95004ZM17.0079 9.55762C16.9262 9.6639 16.8035 9.72112 16.7054 9.77017C16.591 9.81923 16.5256 9.86011 16.5419 9.92551L16.5746 9.94186C16.6564 9.94186 16.8771 9.81105 17.0079 9.56578V9.55762Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0481 9.46094C16.9582 9.59175 16.8274 9.6817 16.8274 9.77981C16.8192 9.89427 16.8028 9.90245 16.7783 10.0169C16.8683 9.99238 16.8928 9.98421 16.9173 9.81252C16.9337 9.68988 17.0645 9.5754 17.0563 9.46094H17.0481Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7627 10.0251L16.7872 9.95149C16.8036 9.89426 16.8118 9.86974 16.8199 9.77981C16.8199 9.70622 16.8853 9.64899 16.9426 9.57541C16.9753 9.53453 17.008 9.50182 17.0407 9.46094C17.0652 9.52634 17.0243 9.59177 16.9916 9.65717C16.9589 9.7144 16.9262 9.77162 16.9262 9.82067C16.9017 9.99237 16.8771 10.0087 16.779 10.0333H16.7627V10.0251ZM17.0407 9.46094C17.0243 9.50999 16.9834 9.55089 16.9589 9.58359C16.8935 9.65718 16.8444 9.7144 16.8363 9.77981C16.8281 9.87791 16.8199 9.89427 16.8036 9.95967L16.7872 10.0087C16.8608 9.99237 16.8853 9.97603 16.9017 9.81252C16.9098 9.76346 16.9426 9.70622 16.9753 9.64899C17.008 9.58358 17.0488 9.52634 17.0407 9.46094Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0481 9.46094C16.9582 9.59175 16.8274 9.6817 16.8274 9.77981C16.8192 9.89427 16.8028 9.90245 16.7783 10.0169C16.8683 9.99238 16.8928 9.98421 16.9173 9.81252C16.9337 9.68988 17.0645 9.5754 17.0563 9.46094H17.0481Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.7627 10.0251L16.7872 9.95149C16.8036 9.89426 16.8118 9.86974 16.8199 9.77981C16.8199 9.70622 16.8853 9.64899 16.9426 9.57541C16.9753 9.53453 17.008 9.50182 17.0407 9.46094C17.0652 9.52634 17.0243 9.59177 16.9916 9.65717C16.9589 9.7144 16.9262 9.77162 16.9262 9.82067C16.9017 9.99237 16.8771 10.0087 16.779 10.0333H16.7627V10.0251ZM17.0407 9.46094C17.0243 9.50999 16.9834 9.55089 16.9589 9.58359C16.8935 9.65718 16.8444 9.7144 16.8363 9.77981C16.8281 9.87791 16.8199 9.89427 16.8036 9.95967L16.7872 10.0087C16.8608 9.99237 16.8853 9.97603 16.9017 9.81252C16.9098 9.76346 16.9426 9.70622 16.9753 9.64899C17.008 9.58358 17.0488 9.52634 17.0407 9.46094Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1957 9.28062C17.0813 9.33785 17.0567 9.41962 17.0567 9.52591C17.0567 9.64855 17.024 9.74666 16.9668 9.83659C17.0813 9.85294 17.1058 9.67306 17.114 9.53407C17.1303 9.39508 17.1467 9.38692 17.1957 9.27246V9.28062Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9744 9.85161H16.958C17.0071 9.7535 17.0398 9.64721 17.0398 9.53274C17.0398 9.43463 17.0643 9.33653 17.1869 9.2793L17.1624 9.3529C17.1379 9.41013 17.1215 9.44282 17.1133 9.54093C17.097 9.66356 17.0807 9.85161 16.9744 9.85161ZM17.1869 9.2793C17.0888 9.3447 17.0643 9.42646 17.0643 9.53274C17.0643 9.64721 17.0316 9.74534 16.9744 9.83527C17.0725 9.83527 17.0888 9.64721 17.1052 9.54093C17.1052 9.43464 17.1297 9.40195 17.1542 9.34472L17.1869 9.2793Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.1957 9.28062C17.0813 9.33785 17.0567 9.41962 17.0567 9.52591C17.0567 9.64855 17.024 9.74666 16.9668 9.83659C17.0813 9.85294 17.1058 9.67306 17.114 9.53407C17.1303 9.39508 17.1467 9.38692 17.1957 9.27246V9.28062Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9744 9.85161H16.958C17.0071 9.7535 17.0398 9.64721 17.0398 9.53274C17.0398 9.43463 17.0643 9.33653 17.1869 9.2793L17.1624 9.3529C17.1379 9.41013 17.1215 9.44282 17.1133 9.54093C17.097 9.66356 17.0807 9.85161 16.9744 9.85161ZM17.1869 9.2793C17.0888 9.3447 17.0643 9.42646 17.0643 9.53274C17.0643 9.64721 17.0316 9.74534 16.9744 9.83527C17.0725 9.83527 17.0888 9.64721 17.1052 9.54093C17.1052 9.43464 17.1297 9.40195 17.1542 9.34472L17.1869 9.2793Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5054 6.54087C17.5054 6.61446 17.579 6.62263 17.5626 6.51635C17.5463 6.42641 17.5381 6.35282 17.5626 6.27924C17.5871 6.18931 17.579 6.02578 17.5626 5.96037C17.5381 5.88679 17.4808 5.93585 17.5054 5.9849C17.5381 6.05031 17.5381 6.18112 17.5135 6.23835C17.489 6.32828 17.4972 6.45093 17.5135 6.53269L17.5054 6.54087Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.547 6.5985C17.547 6.5985 17.5061 6.58217 17.5061 6.54129C17.4979 6.45136 17.4816 6.33687 17.5061 6.23876C17.5306 6.18153 17.5306 6.05073 17.4979 5.9935C17.4979 5.97715 17.4979 5.95262 17.4979 5.93626L17.5225 5.91992C17.5225 5.91992 17.5552 5.91991 17.5634 5.96079C17.5879 6.01802 17.5961 6.18155 17.5634 6.27966C17.547 6.35324 17.547 6.41048 17.5634 6.51676C17.5715 6.55764 17.5634 6.58215 17.5634 6.5985H17.5388H17.547ZM17.5306 5.93626C17.5306 5.93626 17.5061 5.97714 17.5143 5.98532C17.547 6.05072 17.547 6.18972 17.5143 6.24695C17.4897 6.33688 17.4979 6.45953 17.5143 6.54129C17.5143 6.57399 17.5388 6.59034 17.547 6.59034H17.5552C17.5552 6.59034 17.5715 6.56582 17.5552 6.51676C17.5388 6.43501 17.5388 6.36142 17.5552 6.27966C17.5797 6.18972 17.5715 6.02621 17.5552 5.96897C17.5552 5.94445 17.5388 5.93626 17.5225 5.93626H17.5306Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5054 6.54087C17.5054 6.61446 17.579 6.62263 17.5626 6.51635C17.5463 6.42641 17.5381 6.35282 17.5626 6.27924C17.5871 6.18931 17.579 6.02578 17.5626 5.96037C17.5381 5.88679 17.4808 5.93585 17.5054 5.9849C17.5381 6.05031 17.5381 6.18112 17.5135 6.23835C17.489 6.32828 17.4972 6.45093 17.5135 6.53269L17.5054 6.54087Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.547 6.5985C17.547 6.5985 17.5061 6.58217 17.5061 6.54129C17.4979 6.45136 17.4816 6.33687 17.5061 6.23876C17.5306 6.18153 17.5306 6.05073 17.4979 5.9935C17.4979 5.97715 17.4979 5.95262 17.4979 5.93626L17.5225 5.91992C17.5225 5.91992 17.5552 5.91991 17.5634 5.96079C17.5879 6.01802 17.5961 6.18155 17.5634 6.27966C17.547 6.35324 17.547 6.41048 17.5634 6.51676C17.5715 6.55764 17.5634 6.58215 17.5634 6.5985H17.5388H17.547ZM17.5306 5.93626C17.5306 5.93626 17.5061 5.97714 17.5143 5.98532C17.547 6.05072 17.547 6.18972 17.5143 6.24695C17.4897 6.33688 17.4979 6.45953 17.5143 6.54129C17.5143 6.57399 17.5388 6.59034 17.547 6.59034H17.5552C17.5552 6.59034 17.5715 6.56582 17.5552 6.51676C17.5388 6.43501 17.5388 6.36142 17.5552 6.27966C17.5797 6.18972 17.5715 6.02621 17.5552 5.96897C17.5552 5.94445 17.5388 5.93626 17.5225 5.93626H17.5306Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6937 7.01637C17.6937 7.09813 17.6283 7.12266 17.6364 7.00003C17.6364 6.86921 17.7345 6.74656 17.6773 6.55034C17.6528 6.45223 17.6528 6.27238 17.6773 6.18245C17.6937 6.08434 17.7509 6.14973 17.7264 6.22332C17.7018 6.31325 17.7264 6.46859 17.7509 6.55853C17.8081 6.79563 17.6937 6.91009 17.7018 7.02455L17.6937 7.01637Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.661 7.09011H17.6446C17.6446 7.09011 17.6201 7.04107 17.6201 7.00019C17.6201 6.95113 17.6365 6.91024 17.6446 6.86119C17.6692 6.77125 17.6937 6.68132 17.661 6.5505C17.6283 6.45239 17.6283 6.26436 17.6446 6.17442C17.6528 6.12537 17.6692 6.11719 17.6774 6.11719C17.7101 6.14989 17.7182 6.17441 17.7101 6.21529C17.6774 6.3134 17.7264 6.50964 17.7346 6.54234C17.7755 6.69768 17.7346 6.79578 17.7101 6.88571C17.6937 6.92659 17.6855 6.96747 17.6855 7.00835C17.6855 7.04105 17.6855 7.06557 17.6692 7.08192H17.6528L17.661 7.09011ZM17.6855 6.1499C17.6855 6.1499 17.661 6.15806 17.661 6.19077C17.6447 6.2807 17.6447 6.46058 17.6774 6.55869C17.7101 6.6895 17.6855 6.77944 17.661 6.86937C17.6528 6.91843 17.6365 6.95929 17.6365 7.00835C17.6365 7.0574 17.6447 7.08192 17.6528 7.08192V7.09829L17.6692 7.08192C17.6692 7.07375 17.6855 7.04924 17.6855 7.02471C17.6855 6.98383 17.7019 6.94295 17.7101 6.8939C17.7346 6.81214 17.7755 6.71403 17.7346 6.55869C17.7182 6.51781 17.6774 6.32159 17.7101 6.22348C17.7264 6.19077 17.7101 6.16625 17.7101 6.1499H17.6937H17.6855Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.6937 7.01637C17.6937 7.09813 17.6283 7.12266 17.6364 7.00003C17.6364 6.86921 17.7345 6.74656 17.6773 6.55034C17.6528 6.45223 17.6528 6.27238 17.6773 6.18245C17.6937 6.08434 17.7509 6.14973 17.7264 6.22332C17.7018 6.31325 17.7264 6.46859 17.7509 6.55853C17.8081 6.79563 17.6937 6.91009 17.7018 7.02455L17.6937 7.01637Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.661 7.09011H17.6446C17.6446 7.09011 17.6201 7.04107 17.6201 7.00019C17.6201 6.95113 17.6365 6.91024 17.6446 6.86119C17.6692 6.77125 17.6937 6.68132 17.661 6.5505C17.6283 6.45239 17.6283 6.26436 17.6446 6.17442C17.6528 6.12537 17.6692 6.11719 17.6774 6.11719C17.7101 6.14989 17.7182 6.17441 17.7101 6.21529C17.6774 6.3134 17.7264 6.50964 17.7346 6.54234C17.7755 6.69768 17.7346 6.79578 17.7101 6.88571C17.6937 6.92659 17.6855 6.96747 17.6855 7.00835C17.6855 7.04105 17.6855 7.06557 17.6692 7.08192H17.6528L17.661 7.09011ZM17.6855 6.1499C17.6855 6.1499 17.661 6.15806 17.661 6.19077C17.6447 6.2807 17.6447 6.46058 17.6774 6.55869C17.7101 6.6895 17.6855 6.77944 17.661 6.86937C17.6528 6.91843 17.6365 6.95929 17.6365 7.00835C17.6365 7.0574 17.6447 7.08192 17.6528 7.08192V7.09829L17.6692 7.08192C17.6692 7.07375 17.6855 7.04924 17.6855 7.02471C17.6855 6.98383 17.7019 6.94295 17.7101 6.8939C17.7346 6.81214 17.7755 6.71403 17.7346 6.55869C17.7182 6.51781 17.6774 6.32159 17.7101 6.22348C17.7264 6.19077 17.7101 6.16625 17.7101 6.1499H17.6937H17.6855Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8741 6.72953C17.8741 6.77858 17.8005 6.78677 17.8251 6.71318C17.8414 6.65595 17.8414 6.61507 17.8251 6.55784C17.8005 6.50061 17.8087 6.39433 17.8251 6.35345C17.8496 6.31257 17.9068 6.33709 17.8741 6.36979C17.8496 6.41067 17.8496 6.49244 17.8741 6.53332C17.8986 6.59055 17.8905 6.66413 17.8741 6.71318V6.72953Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8414 6.76962L17.8251 6.75326C17.8251 6.75326 17.8087 6.72873 17.8251 6.7042C17.8414 6.6388 17.8414 6.59793 17.8251 6.55705C17.8005 6.49982 17.8087 6.39353 17.8251 6.35265C17.8332 6.3363 17.8496 6.32812 17.8659 6.32812L17.8905 6.34447C17.8905 6.34447 17.8905 6.36083 17.8905 6.37718C17.8659 6.41806 17.8659 6.49982 17.8823 6.53252C17.915 6.58975 17.8986 6.67969 17.8905 6.72057C17.8905 6.75328 17.8659 6.76144 17.8496 6.76144L17.8414 6.76962ZM17.8251 6.35265C17.8087 6.39353 17.8005 6.49981 17.8251 6.54886C17.8414 6.60609 17.8414 6.65516 17.8251 6.71239C17.8251 6.73692 17.8251 6.74508 17.8251 6.75326C17.8251 6.75326 17.8496 6.7451 17.8578 6.72057C17.8578 6.67969 17.8741 6.59793 17.8496 6.5407C17.825 6.49982 17.8251 6.40987 17.8578 6.36899L17.8169 6.35265H17.8251Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8741 6.72953C17.8741 6.77858 17.8005 6.78677 17.8251 6.71318C17.8414 6.65595 17.8414 6.61507 17.8251 6.55784C17.8005 6.50061 17.8087 6.39433 17.8251 6.35345C17.8496 6.31257 17.9068 6.33709 17.8741 6.36979C17.8496 6.41067 17.8496 6.49244 17.8741 6.53332C17.8986 6.59055 17.8905 6.66413 17.8741 6.71318V6.72953Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.8414 6.76962L17.8251 6.75326C17.8251 6.75326 17.8087 6.72873 17.8251 6.7042C17.8414 6.6388 17.8414 6.59793 17.8251 6.55705C17.8005 6.49982 17.8087 6.39353 17.8251 6.35265C17.8332 6.3363 17.8496 6.32812 17.8659 6.32812L17.8905 6.34447C17.8905 6.34447 17.8905 6.36083 17.8905 6.37718C17.8659 6.41806 17.8659 6.49982 17.8823 6.53252C17.915 6.58975 17.8986 6.67969 17.8905 6.72057C17.8905 6.75328 17.8659 6.76144 17.8496 6.76144L17.8414 6.76962ZM17.8251 6.35265C17.8087 6.39353 17.8005 6.49981 17.8251 6.54886C17.8414 6.60609 17.8414 6.65516 17.8251 6.71239C17.8251 6.73692 17.8251 6.74508 17.8251 6.75326C17.8251 6.75326 17.8496 6.7451 17.8578 6.72057C17.8578 6.67969 17.8741 6.59793 17.8496 6.5407C17.825 6.49982 17.8251 6.40987 17.8578 6.36899L17.8169 6.35265H17.8251Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5051 6.82689C17.4152 6.86777 17.3007 6.60617 17.3825 6.56529C17.4479 6.54894 17.6032 6.77784 17.5051 6.82689Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4821 6.84317C17.4249 6.84317 17.3677 6.7614 17.3513 6.67964C17.335 6.62241 17.3513 6.57336 17.3758 6.54883C17.4412 6.54883 17.5148 6.65511 17.5312 6.7287C17.5475 6.77775 17.5312 6.81045 17.4985 6.8268H17.4739L17.4821 6.84317ZM17.3922 6.57335C17.3922 6.57335 17.3513 6.63059 17.3677 6.67964C17.384 6.74505 17.4331 6.8268 17.4821 6.8268H17.4985C17.5312 6.81045 17.5312 6.76959 17.523 6.74506C17.5066 6.67148 17.4331 6.57335 17.3922 6.57335Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.5051 6.82689C17.4152 6.86777 17.3007 6.60617 17.3825 6.56529C17.4479 6.54894 17.6032 6.77784 17.5051 6.82689Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.4821 6.84317C17.4249 6.84317 17.3677 6.7614 17.3513 6.67964C17.335 6.62241 17.3513 6.57336 17.3758 6.54883C17.4412 6.54883 17.5148 6.65511 17.5312 6.7287C17.5475 6.77775 17.5312 6.81045 17.4985 6.8268H17.4739L17.4821 6.84317ZM17.3922 6.57335C17.3922 6.57335 17.3513 6.63059 17.3677 6.67964C17.384 6.74505 17.4331 6.8268 17.4821 6.8268H17.4985C17.5312 6.81045 17.5312 6.76959 17.523 6.74506C17.5066 6.67148 17.4331 6.57335 17.3922 6.57335Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9994 7.33386C17.0402 7.39109 17.1056 7.35837 17.0648 7.26026C17.0321 7.19485 17.0321 7.10492 16.9994 7.05586C16.9503 6.98228 16.8685 6.91687 16.8277 6.876C16.7786 6.82694 16.7377 6.87601 16.7868 6.91689C16.8358 6.96594 16.8931 7.03952 16.9258 7.08857C16.983 7.18668 16.9585 7.26846 16.9994 7.33386Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0482 7.36664C17.0482 7.36664 17.0073 7.35031 16.9991 7.33396C16.9746 7.30125 16.9746 7.26853 16.9664 7.23583C16.9582 7.19495 16.95 7.1459 16.9173 7.08867C16.8928 7.04779 16.8356 6.97421 16.7783 6.91698C16.762 6.90063 16.7538 6.87611 16.762 6.86793C16.8029 6.85158 16.811 6.85158 16.8274 6.86793L16.8683 6.9088C16.9092 6.94968 16.9664 6.99873 17.0073 7.05596C17.0236 7.08866 17.0318 7.12137 17.0482 7.16225C17.0482 7.19495 17.0645 7.22767 17.0808 7.25219C17.0972 7.29307 17.0972 7.32577 17.0808 7.3503L17.0482 7.36664ZM16.7865 6.85975C16.7865 6.85975 16.7702 6.89245 16.7865 6.9088C16.8438 6.96603 16.901 7.03961 16.9255 7.08867C16.9582 7.13772 16.9664 7.18677 16.9746 7.23583C16.9746 7.26853 16.9746 7.30125 17.0073 7.33396C17.0073 7.35031 17.0318 7.35848 17.0482 7.35848L17.0645 7.34211C17.0727 7.32576 17.0727 7.29306 17.0645 7.26035C17.0481 7.22765 17.04 7.19495 17.0318 7.16225C17.0236 7.12137 17.0073 7.08048 16.9909 7.05596C16.9582 6.99873 16.901 6.94968 16.8601 6.9088L16.8192 6.87609C16.8192 6.87609 16.7947 6.85156 16.7865 6.85156V6.85975Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9994 7.33386C17.0402 7.39109 17.1056 7.35837 17.0648 7.26026C17.0321 7.19485 17.0321 7.10492 16.9994 7.05586C16.9503 6.98228 16.8685 6.91687 16.8277 6.876C16.7786 6.82694 16.7377 6.87601 16.7868 6.91689C16.8358 6.96594 16.8931 7.03952 16.9258 7.08857C16.983 7.18668 16.9585 7.26846 16.9994 7.33386Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M17.0482 7.36664C17.0482 7.36664 17.0073 7.35031 16.9991 7.33396C16.9746 7.30125 16.9746 7.26853 16.9664 7.23583C16.9582 7.19495 16.95 7.1459 16.9173 7.08867C16.8928 7.04779 16.8356 6.97421 16.7783 6.91698C16.762 6.90063 16.7538 6.87611 16.762 6.86793C16.8029 6.85158 16.811 6.85158 16.8274 6.86793L16.8683 6.9088C16.9092 6.94968 16.9664 6.99873 17.0073 7.05596C17.0236 7.08866 17.0318 7.12137 17.0482 7.16225C17.0482 7.19495 17.0645 7.22767 17.0808 7.25219C17.0972 7.29307 17.0972 7.32577 17.0808 7.3503L17.0482 7.36664ZM16.7865 6.85975C16.7865 6.85975 16.7702 6.89245 16.7865 6.9088C16.8438 6.96603 16.901 7.03961 16.9255 7.08867C16.9582 7.13772 16.9664 7.18677 16.9746 7.23583C16.9746 7.26853 16.9746 7.30125 17.0073 7.33396C17.0073 7.35031 17.0318 7.35848 17.0482 7.35848L17.0645 7.34211C17.0727 7.32576 17.0727 7.29306 17.0645 7.26035C17.0481 7.22765 17.04 7.19495 17.0318 7.16225C17.0236 7.12137 17.0073 7.08048 16.9909 7.05596C16.9582 6.99873 16.901 6.94968 16.8601 6.9088L16.8192 6.87609C16.8192 6.87609 16.7947 6.85156 16.7865 6.85156V6.85975Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8839 7.39991C16.9248 7.46531 17.0066 7.42443 16.9494 7.34267C16.9003 7.27726 16.8267 7.22004 16.8186 7.14646C16.8186 7.05652 16.7695 6.92571 16.7204 6.88483C16.6714 6.83577 16.6141 6.90118 16.6714 6.93388C16.7286 6.97476 16.7613 7.1301 16.7613 7.19551C16.7613 7.28544 16.8513 7.34268 16.8921 7.40809L16.8839 7.39991Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9334 7.4326C16.9334 7.4326 16.8925 7.41624 16.8761 7.39989C16.8679 7.37536 16.8434 7.359 16.8353 7.34265C16.7944 7.30177 16.7535 7.25273 16.7453 7.17915C16.7453 7.11375 16.7126 6.95841 16.6554 6.9257C16.639 6.91753 16.6309 6.89298 16.6309 6.87663C16.639 6.84392 16.6636 6.8194 16.7126 6.86028C16.7617 6.90116 16.8107 7.04017 16.8189 7.1301C16.8189 7.17915 16.8598 7.22001 16.9006 7.26089C16.917 7.27724 16.9334 7.30177 16.9497 7.31813C16.9742 7.35083 16.9742 7.37536 16.9661 7.39989C16.9661 7.40806 16.9415 7.41623 16.9334 7.41623V7.4326ZM16.6799 6.86028C16.6799 6.86028 16.6554 6.86846 16.6472 6.88481C16.6472 6.90116 16.6472 6.90934 16.6636 6.91752C16.729 6.9584 16.7617 7.12192 16.7617 7.17915C16.7617 7.23638 16.8026 7.28544 16.8434 7.33449C16.8598 7.35085 16.8761 7.37535 16.8843 7.39171C16.8925 7.40806 16.917 7.41623 16.9252 7.41623C16.9252 7.41623 16.9497 7.41624 16.9497 7.39989C16.9497 7.38354 16.9497 7.35901 16.9334 7.32631C16.917 7.30996 16.9007 7.28542 16.8843 7.26907C16.8434 7.22819 16.8025 7.17915 16.8025 7.1301C16.8025 7.04017 16.7453 6.90935 16.7044 6.86847C16.6963 6.85212 16.6881 6.8521 16.6717 6.8521L16.6799 6.86028Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.8839 7.39991C16.9248 7.46531 17.0066 7.42443 16.9494 7.34267C16.9003 7.27726 16.8267 7.22004 16.8186 7.14646C16.8186 7.05652 16.7695 6.92571 16.7204 6.88483C16.6714 6.83577 16.6141 6.90118 16.6714 6.93388C16.7286 6.97476 16.7613 7.1301 16.7613 7.19551C16.7613 7.28544 16.8513 7.34268 16.8921 7.40809L16.8839 7.39991Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9334 7.4326C16.9334 7.4326 16.8925 7.41624 16.8761 7.39989C16.8679 7.37536 16.8434 7.359 16.8353 7.34265C16.7944 7.30177 16.7535 7.25273 16.7453 7.17915C16.7453 7.11375 16.7126 6.95841 16.6554 6.9257C16.639 6.91753 16.6309 6.89298 16.6309 6.87663C16.639 6.84392 16.6636 6.8194 16.7126 6.86028C16.7617 6.90116 16.8107 7.04017 16.8189 7.1301C16.8189 7.17915 16.8598 7.22001 16.9006 7.26089C16.917 7.27724 16.9334 7.30177 16.9497 7.31813C16.9742 7.35083 16.9742 7.37536 16.9661 7.39989C16.9661 7.40806 16.9415 7.41623 16.9334 7.41623V7.4326ZM16.6799 6.86028C16.6799 6.86028 16.6554 6.86846 16.6472 6.88481C16.6472 6.90116 16.6472 6.90934 16.6636 6.91752C16.729 6.9584 16.7617 7.12192 16.7617 7.17915C16.7617 7.23638 16.8026 7.28544 16.8434 7.33449C16.8598 7.35085 16.8761 7.37535 16.8843 7.39171C16.8925 7.40806 16.917 7.41623 16.9252 7.41623C16.9252 7.41623 16.9497 7.41624 16.9497 7.39989C16.9497 7.38354 16.9497 7.35901 16.9334 7.32631C16.917 7.30996 16.9007 7.28542 16.8843 7.26907C16.8434 7.22819 16.8025 7.17915 16.8025 7.1301C16.8025 7.04017 16.7453 6.90935 16.7044 6.86847C16.6963 6.85212 16.6881 6.8521 16.6717 6.8521L16.6799 6.86028Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.3691 10.2373C13.4836 10.3354 13.6062 10.4499 13.6389 10.5889C13.6716 10.7115 13.6962 10.8096 13.7779 10.9404C13.6471 10.8587 13.5981 10.736 13.5653 10.6052C13.5326 10.4744 13.4591 10.3763 13.3691 10.2455V10.2373Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.3691 10.2373C13.4836 10.3354 13.6062 10.4499 13.6389 10.5889C13.6716 10.7115 13.6962 10.8096 13.7779 10.9404C13.6471 10.8587 13.5981 10.736 13.5653 10.6052C13.5326 10.4744 13.4591 10.3763 13.3691 10.2455V10.2373Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2295 10.2367C13.344 10.3348 13.4175 10.4411 13.4503 10.5719C13.483 10.7027 13.5402 10.8008 13.6137 10.9153C13.4911 10.8335 13.4175 10.7191 13.3848 10.5801C13.3521 10.4493 13.3112 10.3512 13.2295 10.2285V10.2367Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.3475 10.2373C15.233 10.3354 15.1513 10.4417 15.1186 10.5807C15.0777 10.7115 15.0287 10.8096 14.9551 10.9241C15.0777 10.8423 15.1595 10.736 15.1922 10.597C15.2249 10.4662 15.2657 10.3599 15.3475 10.2455V10.2373Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.209 10.2363C15.0863 10.3344 14.9719 10.4489 14.931 10.5879C14.8983 10.7187 14.8737 10.8168 14.792 10.9394C14.9228 10.8577 14.98 10.7351 15.0127 10.5961C15.0454 10.4653 15.1272 10.3671 15.209 10.2363Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7995 10.5645C14.7995 10.5645 14.7831 10.5155 14.7668 10.5073C14.7259 10.4909 14.6932 10.4828 14.6523 10.4746C14.6114 10.4746 14.5869 10.491 14.5869 10.5155C14.5869 10.5482 14.5869 10.5809 14.5869 10.6054C14.5869 10.6381 14.5869 10.6381 14.6196 10.6463C14.6523 10.6463 14.6932 10.6627 14.7177 10.679C14.7423 10.6954 14.7668 10.679 14.7831 10.6626C14.7831 10.6381 14.7995 10.5972 14.7995 10.5727V10.5645Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.334 10.5638C14.334 10.5638 14.3422 10.5148 14.3585 10.5066C14.3912 10.4902 14.4239 10.4902 14.4648 10.4902C14.5057 10.4902 14.5138 10.4902 14.5138 10.5148V10.6129C14.5138 10.6129 14.5139 10.6456 14.4893 10.6538C14.4566 10.6538 14.4157 10.6538 14.383 10.6783C14.3585 10.6946 14.334 10.6783 14.334 10.6538C14.334 10.6292 14.334 10.5883 14.334 10.5638Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.7709 10.5548C13.7709 10.5548 13.7872 10.5139 13.8036 10.5057C13.8445 10.4894 13.8772 10.4812 13.918 10.4648C13.9589 10.4648 13.9835 10.4894 13.9835 10.5057V10.5957C13.9835 10.5957 13.9753 10.6284 13.9507 10.6365C13.918 10.6365 13.8772 10.6447 13.8445 10.6692C13.8199 10.6774 13.7954 10.6692 13.7791 10.6447C13.7709 10.6202 13.7627 10.5793 13.7627 10.5548H13.7709Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.2359 10.5556C14.2359 10.5556 14.2195 10.5148 14.2032 10.5066C14.1705 10.4902 14.1378 10.4902 14.0969 10.4902C14.056 10.4902 14.0479 10.4902 14.0479 10.5148C14.0479 10.5475 14.0479 10.5883 14.0479 10.6129C14.0479 10.6456 14.0479 10.6456 14.0724 10.6538C14.1051 10.6538 14.146 10.6619 14.1787 10.6783C14.2032 10.6946 14.2277 10.6783 14.2277 10.6538C14.2277 10.6292 14.2277 10.5883 14.2277 10.5556H14.2359Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7995 10.5645C14.7995 10.5645 14.7831 10.5155 14.7668 10.5073C14.7259 10.4909 14.6932 10.4828 14.6523 10.4746C14.6114 10.4746 14.5869 10.491 14.5869 10.5155C14.5869 10.5482 14.5869 10.5809 14.5869 10.6054C14.5869 10.6381 14.5869 10.6381 14.6196 10.6463C14.6523 10.6463 14.6932 10.6627 14.7177 10.679C14.7423 10.6954 14.7668 10.679 14.7831 10.6626C14.7831 10.6381 14.7995 10.5972 14.7995 10.5727V10.5645Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.334 10.5638C14.334 10.5638 14.3422 10.5148 14.3585 10.5066C14.3912 10.4902 14.4239 10.4902 14.4648 10.4902C14.5057 10.4902 14.5138 10.4902 14.5138 10.5148V10.6129C14.5138 10.6129 14.5139 10.6456 14.4893 10.6538C14.4566 10.6538 14.4157 10.6538 14.383 10.6783C14.3585 10.6946 14.334 10.6783 14.334 10.6538C14.334 10.6292 14.334 10.5883 14.334 10.5638Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.7709 10.5548C13.7709 10.5548 13.7872 10.5139 13.8036 10.5057C13.8445 10.4894 13.8772 10.4812 13.918 10.4648C13.9589 10.4648 13.9835 10.4894 13.9835 10.5057V10.5957C13.9835 10.5957 13.9753 10.6284 13.9507 10.6365C13.918 10.6365 13.8772 10.6447 13.8445 10.6692C13.8199 10.6774 13.7954 10.6692 13.7791 10.6447C13.7709 10.6202 13.7627 10.5793 13.7627 10.5548H13.7709Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.2359 10.5556C14.2359 10.5556 14.2195 10.5148 14.2032 10.5066C14.1705 10.4902 14.1378 10.4902 14.0969 10.4902C14.056 10.4902 14.0479 10.4902 14.0479 10.5148C14.0479 10.5475 14.0479 10.5883 14.0479 10.6129C14.0479 10.6456 14.0479 10.6456 14.0724 10.6538C14.1051 10.6538 14.146 10.6619 14.1787 10.6783C14.2032 10.6946 14.2277 10.6783 14.2277 10.6538C14.2277 10.6292 14.2277 10.5883 14.2277 10.5556H14.2359Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.8027 10.7686C13.8436 10.8503 13.8927 10.9648 13.9744 10.9484C13.9744 10.883 13.8845 10.8503 13.8027 10.7686Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.9326 10.8008C14.1043 10.8662 14.2433 10.8498 14.2678 10.9643C14.1043 10.9806 14.0553 10.9152 13.9326 10.8008Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.759 10.7852C14.7181 10.8587 14.669 10.9732 14.5791 10.9487C14.5791 10.8914 14.6772 10.8506 14.759 10.7852Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.635 10.8008C14.4633 10.8662 14.3162 10.8498 14.2998 10.9561C14.4551 10.9725 14.5206 10.9071 14.635 10.8008Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("mask", {
            id: "mask4_841_19253",
            style: {
              maskType: "luminance"
            },
            maskUnits: "userSpaceOnUse",
            x: 15,
            y: 9,
            width: 1,
            height: 1,
            children: /*#__PURE__*/_jsx("path", {
              d: "M15.708 9.12305H15.0049V9.49915H15.708V9.12305Z",
              fill: "white"
            })
          }), /*#__PURE__*/_jsx("g", {
            mask: "url(#mask4_841_19253)",
            children: /*#__PURE__*/_jsx("path", {
              d: "M15.1439 9.12305H15.5118C15.5118 9.26204 15.5935 9.41739 15.708 9.49915H15.0049C15.1112 9.40104 15.152 9.27839 15.1439 9.12305Z",
              fill: "white"
            })
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.7387 9.50926H15.0029C15.0929 9.40298 15.1337 9.29669 15.1337 9.125H15.5098C15.518 9.25581 15.5997 9.40299 15.7142 9.49292L15.7387 9.50926ZM15.5016 9.125H15.1501C15.1583 9.30487 15.1174 9.41933 15.0193 9.50926L15.6897 9.49292C15.5834 9.40299 15.5098 9.25581 15.5098 9.125H15.5016Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.1419 9.125H15.5098C15.5098 9.26399 15.5916 9.41935 15.706 9.5011H15.0029C15.1092 9.40299 15.1501 9.28034 15.1419 9.125Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.7387 9.50926H15.0029C15.0929 9.40298 15.1337 9.29669 15.1337 9.125H15.5098C15.518 9.25581 15.5997 9.40299 15.7142 9.49292L15.7387 9.50926ZM15.5016 9.125H15.1501C15.1583 9.30487 15.1174 9.41933 15.0193 9.50926L15.6897 9.49292C15.5834 9.40299 15.5098 9.25581 15.5098 9.125H15.5016Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.4541 10.8672C15.4541 10.8672 15.405 10.8754 15.3805 10.8836C14.9881 11.0225 14.6283 11.1206 14.2523 11.1206C13.8762 11.1206 13.5083 11.0225 13.1567 10.8754C13.1322 10.8672 13.1158 10.8672 13.0913 10.8754C13.0668 10.8754 13.0423 10.8917 13.0259 10.9081C12.8706 11.0634 12.6907 11.2188 12.5108 11.3577C12.4781 11.3741 12.4863 11.4313 12.5354 11.4558C12.8951 11.5867 13.2548 11.8238 14.2686 11.8238C15.2988 11.8156 15.6666 11.5785 15.9855 11.464C16.01 11.4559 16.0346 11.4395 16.0509 11.4232C16.0509 11.415 16.0509 11.3986 16.0509 11.3905C16.0509 11.3741 16.0427 11.3659 16.0264 11.3496C15.8383 11.2024 15.6421 11.0798 15.5113 10.8917C15.495 10.8754 15.4704 10.8672 15.4459 10.8754L15.4541 10.8672ZM15.4541 10.8836C15.4541 10.8836 15.495 10.8835 15.5031 10.8999C15.6339 11.0879 15.8383 11.2106 16.0182 11.3659C16.0345 11.3741 16.0427 11.3823 16.0427 11.3905C16.0427 11.3986 16.0427 11.4068 16.0427 11.415C16.0427 11.4232 16.0182 11.4395 16.0019 11.4477C15.6667 11.5621 15.3151 11.7911 14.285 11.7992C13.2712 11.8156 12.9196 11.5703 12.5517 11.4313C12.5108 11.415 12.519 11.3823 12.5354 11.3741C12.7234 11.2269 12.8951 11.0798 13.0504 10.9162C13.0668 10.9081 13.0831 10.8999 13.0995 10.8917C13.124 10.8917 13.1404 10.8917 13.1485 10.8917C13.4919 11.0389 13.8762 11.137 14.2523 11.137C14.6283 11.137 14.9962 11.0389 15.3805 10.8999C15.405 10.8917 15.4295 10.8835 15.4459 10.8754L15.4541 10.8836Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.9603 4.2354C12.9603 4.17817 13.0502 4.16999 13.0421 4.25174C13.0339 4.35803 13.2383 4.61967 13.2628 4.77501C13.271 4.88947 13.1974 4.97938 13.1238 5.03661C13.0339 5.10202 12.8867 5.10204 12.8295 5.06116C12.7886 5.02846 12.7477 4.92217 12.7804 4.87311C12.7886 4.85676 12.8377 5.03661 12.9439 5.03661C13.0829 5.03661 13.1974 4.93033 13.2056 4.83222C13.2056 4.66053 12.9685 4.39891 12.9685 4.22722L12.9603 4.2354Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.3774 4.65332C13.3774 4.65332 13.4346 4.71055 13.4101 4.7269C13.3856 4.74325 13.3447 4.66967 13.3774 4.65332Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4341 4.5053C13.4341 4.5053 13.4014 4.50531 13.4014 4.48896C13.4341 4.4399 13.5077 4.36632 13.5567 4.3418C13.5731 4.3418 13.5976 4.36631 13.5894 4.37448C13.5567 4.41536 13.4831 4.47261 13.4259 4.49714L13.4341 4.5053Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.9902 4.06439C13.9902 4.06439 14.0802 4.00714 14.1047 3.99078C14.1211 3.97443 14.1292 4.00714 14.1292 4.02349C14.1129 4.04802 14.0475 4.09707 14.0148 4.09707C13.9984 4.09707 13.9821 4.08074 13.9984 4.06439H13.9902Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.1869 4.07224C14.2032 4.02319 14.2605 3.94961 14.2932 3.92508C14.3177 3.91691 14.3422 3.92508 14.3422 3.94143C14.3259 3.98231 14.2605 4.05591 14.2114 4.08861C14.1951 4.10496 14.1787 4.08859 14.1787 4.07224H14.1869Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.0228 4.19399C14.0228 4.19399 14.0228 4.21852 14.0228 4.2267C14.0474 4.2267 14.0882 4.23487 14.1046 4.2267C14.1373 4.21035 14.1209 4.10407 14.0801 4.1613C14.0555 4.19401 14.0392 4.18581 14.0146 4.19399H14.0228Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.704 4.43997C13.6468 4.39909 13.7204 4.33368 13.7776 4.38274C13.8921 4.47267 13.5977 4.80787 13.4424 4.96321C13.4097 4.99591 13.3933 4.92235 13.426 4.88147C13.5405 4.78336 13.6468 4.6689 13.7204 4.54626C13.7367 4.52174 13.7531 4.47267 13.704 4.43179V4.43997Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.3662 4.14609C14.3662 4.10521 14.2926 4.14611 14.2926 4.08888C14.2926 4.05617 14.3744 4.03981 14.4152 4.07251C14.4725 4.12974 14.4316 4.23604 14.3253 4.24422C14.2435 4.24422 14.1045 4.36685 14.1209 4.39138C14.1454 4.4159 14.358 4.44043 14.4888 4.4159C14.5706 4.40773 14.5542 4.47313 14.4725 4.48948C14.3989 4.49766 14.3335 4.48948 14.2599 4.51401C14.1781 4.54671 14.1373 4.653 14.0964 4.69388C14.0882 4.69388 14.0555 4.65299 14.0637 4.63664C14.0964 4.57941 14.1536 4.50583 14.2108 4.4813C14.2517 4.46495 14.1046 4.46496 14.0637 4.44861C14.0228 4.44044 14.0391 4.39136 14.0473 4.37501C14.0637 4.33413 14.1945 4.20332 14.2517 4.20332C14.3008 4.20332 14.3498 4.18698 14.358 4.16245L14.3662 4.14609Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.5949 4.16225C14.5949 4.16225 14.6358 4.10501 14.6603 4.08049C14.6766 4.06413 14.7012 4.08048 14.693 4.12136C14.693 4.14588 14.6521 4.17041 14.6276 4.19493C14.6031 4.21129 14.5867 4.17858 14.5949 4.17041V4.16225Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.873 4.05664C14.873 4.05664 14.9221 4.12205 14.873 4.1384C14.8485 4.14658 14.824 4.06482 14.873 4.05664Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7842 4.2758C14.7842 4.33303 14.8169 4.33302 14.8741 4.32485C14.9314 4.32485 14.9804 4.32485 14.9804 4.2758C14.9804 4.21856 14.9477 4.16952 14.9395 4.2104C14.9313 4.2431 14.9232 4.30851 14.9068 4.28398C14.8823 4.25945 14.8905 4.25128 14.8578 4.28398C14.8332 4.30851 14.8332 4.2758 14.8251 4.25127C14.8169 4.23492 14.7924 4.25946 14.7924 4.26764L14.7842 4.2758Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.3831 4.59539C14.3749 4.67715 14.383 4.7916 14.4239 4.7916C14.473 4.7916 14.5793 4.61174 14.6365 4.52181C14.661 4.46458 14.7183 4.45639 14.6937 4.51362C14.661 4.59538 14.661 4.77525 14.6937 4.82431C14.7101 4.85701 14.8245 4.79977 14.8409 4.75889C14.8736 4.68531 14.8409 4.55451 14.8654 4.46457C14.8654 4.40734 14.9145 4.39917 14.9145 4.44823C14.9145 4.53816 14.8981 4.70983 14.9145 4.78342C14.9145 4.82429 15.0371 4.8897 15.0616 4.75889C15.0698 4.67713 15.1107 4.59537 15.0616 4.50544C15.0289 4.44821 15.1107 4.45639 15.1598 4.53815C15.1925 4.58721 15.1352 4.67714 15.1352 4.74255C15.1352 4.84883 15.0616 4.90607 15.0044 4.90607C14.9472 4.90607 14.9145 4.84065 14.8736 4.84065C14.8327 4.84065 14.7755 4.91423 14.7428 4.91423C14.5874 4.90605 14.6692 4.67715 14.6283 4.67715C14.5793 4.67715 14.5139 4.89788 14.4484 4.8897C14.383 4.88153 14.3177 4.70984 14.3422 4.63626C14.3667 4.57085 14.4076 4.55451 14.4076 4.59539H14.3831Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.1183 4.24416C15.0447 4.20329 15.1183 4.08063 15.1592 4.12151C15.2327 4.21144 15.2981 4.40767 15.3554 4.41585C15.3881 4.4322 15.3881 4.26868 15.4044 4.20327C15.4208 4.14604 15.4862 4.1624 15.4698 4.23598C15.4698 4.26051 15.3799 4.52212 15.3881 4.5303C15.4453 4.63658 15.5025 4.75105 15.5352 4.86551C15.5516 4.92274 15.4862 4.88186 15.478 4.86551C15.4371 4.80828 15.3717 4.57937 15.3717 4.59572C15.339 4.75106 15.3308 4.80012 15.2981 4.93093C15.2818 4.97181 15.2246 4.96362 15.2409 4.89003C15.2573 4.82463 15.3472 4.52213 15.339 4.51395C15.2655 4.39132 15.2 4.28504 15.1101 4.23598L15.1183 4.24416Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.2574 4.97219C15.2574 4.97219 15.2083 5.02123 15.3064 5.03758C15.4454 5.07029 15.6008 5.02126 15.6416 4.88227C15.6907 4.71875 15.7316 4.57158 15.7561 4.51435C15.7888 4.44894 15.8378 4.44893 15.8051 4.35082C15.7806 4.27724 15.7397 4.30178 15.7316 4.33448C15.707 4.44076 15.6171 4.77596 15.5844 4.83319C15.5353 4.94765 15.4209 4.98854 15.2574 4.97219Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.535 4.44058C15.535 4.44058 15.4778 4.44059 15.4941 4.47329C15.4941 4.50599 15.5269 4.52234 15.5432 4.52234C15.5759 4.52234 15.6413 4.52235 15.6413 4.47329C15.6413 4.44059 15.6168 4.40789 15.5923 4.44876C15.5677 4.48964 15.5432 4.48147 15.535 4.44876V4.44058Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5684 4.30089C15.5684 4.30089 15.5684 4.34995 15.5847 4.34995C15.6256 4.34995 15.691 4.3336 15.7237 4.30908C15.7319 4.3009 15.7237 4.27637 15.7237 4.27637C15.6828 4.27637 15.6092 4.27637 15.5765 4.30089H15.5684Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.9519 4.40701C15.9846 4.35795 16.0745 4.34977 16.0418 4.42335C16.0173 4.47241 15.7966 4.9139 15.7638 4.96296C15.7311 5.02836 15.7066 4.99567 15.723 4.94661C15.7557 4.88121 15.9355 4.41518 15.9519 4.40701Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.6077 5.05348C15.6077 5.05348 15.5423 4.96354 15.5505 5.05348C15.5587 5.22517 15.7958 5.16795 15.8612 5.11071C15.9266 5.05348 15.8612 5.29874 15.9593 5.32327C16.0002 5.33962 16.0901 5.27422 16.131 5.22516C16.2455 5.06982 16.3272 4.84909 16.4417 4.70193C16.4907 4.63652 16.4171 4.59563 16.3926 4.64469C16.2945 4.8082 16.1637 5.15157 16.0329 5.24151C15.9184 5.31509 15.9511 5.15159 15.9511 5.10253C15.9511 5.06983 15.9021 5.01261 15.8448 5.06166C15.804 5.09437 15.7386 5.11887 15.6895 5.11887C15.6568 5.11887 15.6241 5.11889 15.6077 5.06166V5.05348Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0266 4.74285C16.0266 4.74285 15.9775 4.7265 15.9775 4.77556C15.9775 4.80826 16.0184 4.81643 16.0347 4.81643C16.1002 4.7592 16.0184 4.78373 16.0347 4.74285H16.0266Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.9279 4.93945C15.9279 4.93945 15.9034 4.98033 15.9279 4.98851C15.9606 4.98851 16.0669 4.97217 16.0996 4.98035C16.1241 4.98035 16.1241 4.93945 16.0832 4.93945C16.0342 4.93945 15.9606 4.93945 15.9197 4.93945H15.9279Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6721 4.8902C16.7211 4.71851 16.8274 4.91472 16.7293 5.01283C16.574 5.16 16.5331 5.44616 16.2878 5.48704C16.2224 5.50339 16.108 5.46252 16.0753 5.43799C16.0671 5.42981 16.0835 5.36439 16.1243 5.3971C16.1816 5.43797 16.3042 5.45433 16.3696 5.3971C16.5086 5.26628 16.6149 5.08642 16.6721 4.8902Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.9603 4.2354C12.9603 4.17817 13.0502 4.16999 13.0421 4.25174C13.0339 4.35803 13.2383 4.61967 13.2628 4.77501C13.271 4.88947 13.1974 4.97938 13.1238 5.03661C13.0339 5.10202 12.8867 5.10204 12.8295 5.06116C12.7886 5.02846 12.7477 4.92217 12.7804 4.87311C12.7886 4.85676 12.8377 5.03661 12.9439 5.03661C13.0829 5.03661 13.1974 4.93033 13.2056 4.83222C13.2056 4.66053 12.9685 4.39891 12.9685 4.22722L12.9603 4.2354Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2052 4.20268C13.2052 4.20268 13.2706 4.2681 13.2706 4.28445C13.2706 4.28445 13.2134 4.28446 13.2052 4.2681C13.1889 4.25993 13.2052 4.20268 13.2052 4.20268ZM12.9681 4.66053C12.9272 4.68505 12.9681 4.73411 13.009 4.71776C13.1316 4.636 13.3197 4.54608 13.3605 4.39074C13.3769 4.33351 13.426 4.25174 13.475 4.22721C13.5159 4.21086 13.5894 4.31714 13.6303 4.22721C13.6549 4.18633 13.7448 4.25992 13.7693 4.21087C13.802 4.15364 13.7857 4.12094 13.7857 4.06371C13.7857 4.03101 13.753 4.02282 13.7366 4.08005C13.7203 4.11276 13.7366 4.13728 13.7285 4.15363C13.7285 4.16998 13.7039 4.16997 13.6876 4.16997C13.6794 4.1618 13.6876 4.13728 13.6549 4.1291C13.6385 4.1291 13.6303 4.12093 13.6222 4.1291C13.5895 4.18634 13.5731 4.23539 13.5322 4.17816C13.4913 4.1291 13.475 4.03918 13.4423 4.16182C13.4423 4.20269 13.3687 4.2681 13.3278 4.2681C13.2788 4.2681 13.2951 4.13729 13.1889 4.16182C13.1316 4.17817 13.1398 4.27628 13.148 4.31716C13.1561 4.37439 13.3197 4.33351 13.3115 4.36621C13.287 4.48885 13.1153 4.60331 12.9763 4.67689L12.9681 4.66053Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9707 5.24176C11.9707 5.24176 11.9953 5.31534 12.0198 5.32352C12.0443 5.33169 12.0606 5.26628 12.0525 5.24176C12.0525 5.2254 11.9789 5.2254 11.9707 5.24176Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1185 5.45497C12.1185 5.45497 12.045 5.48769 12.094 5.52039C12.1185 5.53674 12.2003 5.56945 12.2248 5.52039C12.2575 5.47134 12.1921 5.28329 12.2248 5.25876C12.2412 5.24241 12.3475 5.38956 12.3965 5.39774C12.511 5.41409 12.4864 5.19336 12.6091 5.20971C12.699 5.22606 12.7072 5.11159 12.6908 5.04618C12.6908 4.98078 12.5764 4.89084 12.5273 4.84179C12.4619 4.78456 12.4374 4.88266 12.4783 4.91537C12.5273 4.95625 12.6173 5.038 12.6336 5.09524C12.6418 5.11976 12.5682 5.16882 12.5518 5.15247C12.4864 5.11977 12.4374 4.98078 12.3801 4.94808C12.3638 4.9399 12.3147 4.96443 12.3393 5.00531C12.3638 5.05437 12.4619 5.11976 12.4701 5.16881C12.4701 5.21787 12.421 5.316 12.3883 5.316C12.3474 5.316 12.2575 5.20152 12.2248 5.14429C12.2085 5.11976 12.1594 5.11978 12.1512 5.16066C12.1512 5.21789 12.1512 5.33234 12.1757 5.40592C12.1839 5.4795 12.1349 5.4795 12.1104 5.45497H12.1185Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9383 5.07853C11.9383 5.07853 11.971 5.12757 11.9791 5.1194C12.0037 5.10305 12.0773 5.02129 12.0609 4.98858C12.0527 4.96405 11.9464 4.90683 11.9301 4.93953C11.8974 4.98858 12.0282 5.01312 12.0037 5.02948C11.9873 5.02948 11.9628 5.06219 11.9383 5.08671V5.07853Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.127 4.70996C12.127 4.70996 12.1597 4.81626 12.1842 4.77538C12.2005 4.74268 12.127 4.70996 12.127 4.70996Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1758 4.88228C12.1758 4.88228 12.135 4.91498 12.1513 4.93133C12.184 4.94768 12.2821 4.96402 12.2576 4.89862C12.2413 4.85774 12.3966 4.89861 12.3639 4.79233C12.3475 4.7678 12.3067 4.72693 12.2821 4.71875C12.2658 4.71875 12.2167 4.74328 12.2495 4.75146C12.274 4.76781 12.3394 4.80051 12.3148 4.82504C12.2903 4.85774 12.2658 4.81686 12.2331 4.82504C12.2167 4.82504 12.2331 4.88227 12.2167 4.89862C12.2167 4.90679 12.184 4.88228 12.1758 4.88228Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4211 4.46484C12.4211 4.46484 12.3721 4.53024 12.3721 4.55477C12.3721 4.57112 12.3802 4.58747 12.3966 4.57929C12.4129 4.57929 12.4456 4.52208 12.4456 4.49755C12.4456 4.48938 12.4375 4.46485 12.4211 4.47303V4.46484Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.5424 4.44822C12.5097 4.40734 12.5832 4.34192 12.616 4.43185C12.6405 4.48908 12.853 4.78342 12.9021 4.87335C12.9348 4.93876 12.9021 4.97146 12.8612 4.92241C12.755 4.77524 12.6568 4.60356 12.5424 4.44822Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.7644 4.45671C12.8053 4.41583 12.887 4.32591 12.8625 4.28503C12.8462 4.24415 12.8053 4.24414 12.7889 4.25232C12.7399 4.30955 12.8216 4.29321 12.8134 4.31774C12.7889 4.36679 12.7644 4.39131 12.748 4.43219C12.748 4.44854 12.7481 4.47307 12.7562 4.4649L12.7644 4.45671Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9707 5.24176C11.9707 5.24176 11.9953 5.31534 12.0198 5.32352C12.0443 5.33169 12.0606 5.26628 12.0525 5.24176C12.0525 5.2254 11.9789 5.2254 11.9707 5.24176Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1185 5.45497C12.1185 5.45497 12.045 5.48769 12.094 5.52039C12.1185 5.53674 12.2003 5.56945 12.2248 5.52039C12.2575 5.47134 12.1921 5.28329 12.2248 5.25876C12.2412 5.24241 12.3475 5.38956 12.3965 5.39774C12.511 5.41409 12.4864 5.19336 12.6091 5.20971C12.699 5.22606 12.7072 5.11159 12.6908 5.04618C12.6908 4.98078 12.5764 4.89084 12.5273 4.84179C12.4619 4.78456 12.4374 4.88266 12.4783 4.91537C12.5273 4.95625 12.6173 5.038 12.6336 5.09524C12.6418 5.11976 12.5682 5.16882 12.5518 5.15247C12.4864 5.11977 12.4374 4.98078 12.3801 4.94808C12.3638 4.9399 12.3147 4.96443 12.3393 5.00531C12.3638 5.05437 12.4619 5.11976 12.4701 5.16881C12.4701 5.21787 12.421 5.316 12.3883 5.316C12.3474 5.316 12.2575 5.20152 12.2248 5.14429C12.2085 5.11976 12.1594 5.11978 12.1512 5.16066C12.1512 5.21789 12.1512 5.33234 12.1757 5.40592C12.1839 5.4795 12.1349 5.4795 12.1104 5.45497H12.1185Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.9383 5.07853C11.9383 5.07853 11.971 5.12757 11.9791 5.1194C12.0037 5.10305 12.0773 5.02129 12.0609 4.98858C12.0527 4.96405 11.9464 4.90683 11.9301 4.93953C11.8974 4.98858 12.0282 5.01312 12.0037 5.02948C11.9873 5.02948 11.9628 5.06219 11.9383 5.08671V5.07853Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.127 4.70996C12.127 4.70996 12.1597 4.81626 12.1842 4.77538C12.2005 4.74268 12.127 4.70996 12.127 4.70996Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.1758 4.88228C12.1758 4.88228 12.135 4.91498 12.1513 4.93133C12.184 4.94768 12.2821 4.96402 12.2576 4.89862C12.2413 4.85774 12.3966 4.89861 12.3639 4.79233C12.3475 4.7678 12.3067 4.72693 12.2821 4.71875C12.2658 4.71875 12.2167 4.74328 12.2495 4.75146C12.274 4.76781 12.3394 4.80051 12.3148 4.82504C12.2903 4.85774 12.2658 4.81686 12.2331 4.82504C12.2167 4.82504 12.2331 4.88227 12.2167 4.89862C12.2167 4.90679 12.184 4.88228 12.1758 4.88228Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.4211 4.46484C12.4211 4.46484 12.3721 4.53024 12.3721 4.55477C12.3721 4.57112 12.3802 4.58747 12.3966 4.57929C12.4129 4.57929 12.4456 4.52208 12.4456 4.49755C12.4456 4.48938 12.4375 4.46485 12.4211 4.47303V4.46484Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.5424 4.44822C12.5097 4.40734 12.5832 4.34192 12.616 4.43185C12.6405 4.48908 12.853 4.78342 12.9021 4.87335C12.9348 4.93876 12.9021 4.97146 12.8612 4.92241C12.755 4.77524 12.6568 4.60356 12.5424 4.44822Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.7644 4.45671C12.8053 4.41583 12.887 4.32591 12.8625 4.28503C12.8462 4.24415 12.8053 4.24414 12.7889 4.25232C12.7399 4.30955 12.8216 4.29321 12.8134 4.31774C12.7889 4.36679 12.7644 4.39131 12.748 4.43219C12.748 4.44854 12.7481 4.47307 12.7562 4.4649L12.7644 4.45671Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.6077 5.05348C15.6077 5.05348 15.5423 4.96354 15.5505 5.05348C15.5587 5.22517 15.7958 5.16795 15.8612 5.11071C15.9266 5.05348 15.8612 5.29874 15.9593 5.32327C16.0002 5.33962 16.0901 5.27422 16.131 5.22516C16.2455 5.06982 16.3272 4.84909 16.4417 4.70193C16.4907 4.63652 16.4171 4.59563 16.3926 4.64469C16.2945 4.8082 16.1637 5.15157 16.0329 5.24151C15.9184 5.31509 15.9511 5.15159 15.9511 5.10253C15.9511 5.06983 15.9021 5.01261 15.8448 5.06166C15.804 5.09437 15.7386 5.11887 15.6895 5.11887C15.6568 5.11887 15.6241 5.11889 15.6077 5.06166V5.05348Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.3774 4.65332C13.3774 4.65332 13.4346 4.71055 13.4101 4.7269C13.3856 4.74325 13.3447 4.66967 13.3774 4.65332Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1816 4.60369C16.1816 4.60369 16.2062 4.47289 16.247 4.51377C16.3533 4.62823 16.4024 5.02068 16.4269 5.31501C16.4269 5.31501 16.3778 5.35587 16.3778 5.34769C16.3778 5.19235 16.3125 4.71816 16.1816 4.60369Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.4341 4.5053C13.4341 4.5053 13.4014 4.50531 13.4014 4.48896C13.4341 4.4399 13.5077 4.36632 13.5567 4.3418C13.5731 4.3418 13.5976 4.36631 13.5894 4.37448C13.5567 4.41536 13.4831 4.47261 13.4259 4.49714L13.4341 4.5053Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.1816 4.60369C16.1816 4.60369 16.2062 4.47289 16.247 4.51377C16.3533 4.62823 16.4024 5.02068 16.4269 5.31501C16.4269 5.31501 16.3778 5.35587 16.3778 5.34769C16.3778 5.19235 16.3125 4.71816 16.1816 4.60369Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.247 5.2827C16.2633 5.23364 16.5168 4.81668 16.5495 4.71857C16.5658 4.67769 16.6394 4.79216 16.5658 4.85757C16.5004 4.9148 16.3205 5.20912 16.2878 5.30723C16.2715 5.35628 16.2225 5.33175 16.247 5.27452V5.2827Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.3662 4.14609C14.3662 4.10521 14.2926 4.14611 14.2926 4.08888C14.2926 4.05617 14.3744 4.03981 14.4152 4.07251C14.4725 4.12974 14.4316 4.23604 14.3253 4.24422C14.2435 4.24422 14.1045 4.36685 14.1209 4.39138C14.1454 4.4159 14.358 4.44043 14.4888 4.4159C14.5706 4.40773 14.5542 4.47313 14.4725 4.48948C14.3989 4.49766 14.3335 4.48948 14.2599 4.51401C14.1781 4.54671 14.1373 4.653 14.0964 4.69388C14.0882 4.69388 14.0555 4.65299 14.0637 4.63664C14.0964 4.57941 14.1536 4.50583 14.2108 4.4813C14.2517 4.46495 14.1046 4.46496 14.0637 4.44861C14.0228 4.44044 14.0391 4.39136 14.0473 4.37501C14.0637 4.33413 14.1945 4.20332 14.2517 4.20332C14.3008 4.20332 14.3498 4.18698 14.358 4.16245L14.3662 4.14609Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.704 4.43997C13.6468 4.39909 13.7204 4.33368 13.7776 4.38274C13.8921 4.47267 13.5977 4.80787 13.4424 4.96321C13.4097 4.99591 13.3933 4.92235 13.426 4.88147C13.5405 4.78336 13.6468 4.6689 13.7204 4.54626C13.7367 4.52174 13.7531 4.47267 13.704 4.43179V4.43997Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.852 4.21911C13.8193 4.14552 13.901 4.121 13.9173 4.17005C13.9746 4.4235 14.1136 4.61973 14.2198 4.79142C14.2525 4.84865 14.2198 4.88136 14.1463 4.82413C14.0972 4.78325 14.04 4.65245 14.0155 4.65245C13.9664 4.64427 13.8519 4.87317 13.6149 4.80776C13.5576 4.79141 13.5576 4.61155 13.5576 4.52979C13.5576 4.48891 13.5985 4.48074 13.5985 4.52979C13.5985 4.60337 13.5985 4.75054 13.6966 4.75871C13.7702 4.75871 13.9419 4.66062 13.9828 4.57068C14.0155 4.48075 13.901 4.30904 13.8601 4.21911H13.852Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.2052 4.20268C13.2052 4.20268 13.2706 4.2681 13.2706 4.28445C13.2706 4.28445 13.2134 4.28446 13.2052 4.2681C13.1889 4.25993 13.2052 4.20268 13.2052 4.20268ZM12.9681 4.66053C12.9272 4.68505 12.9681 4.73411 13.009 4.71776C13.1316 4.636 13.3197 4.54608 13.3605 4.39074C13.3769 4.33351 13.426 4.25174 13.475 4.22721C13.5159 4.21086 13.5894 4.31714 13.6303 4.22721C13.6549 4.18633 13.7448 4.25992 13.7693 4.21087C13.802 4.15364 13.7857 4.12094 13.7857 4.06371C13.7857 4.03101 13.753 4.02282 13.7366 4.08005C13.7203 4.11276 13.7366 4.13728 13.7285 4.15363C13.7285 4.16998 13.7039 4.16997 13.6876 4.16997C13.6794 4.1618 13.6876 4.13728 13.6549 4.1291C13.6385 4.1291 13.6303 4.12093 13.6222 4.1291C13.5895 4.18634 13.5731 4.23539 13.5322 4.17816C13.4913 4.1291 13.475 4.03918 13.4423 4.16182C13.4423 4.20269 13.3687 4.2681 13.3278 4.2681C13.2788 4.2681 13.2951 4.13729 13.1889 4.16182C13.1316 4.17817 13.1398 4.27628 13.148 4.31716C13.1561 4.37439 13.3197 4.33351 13.3115 4.36621C13.287 4.48885 13.1153 4.60331 12.9763 4.67689L12.9681 4.66053Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.852 4.21911C13.8193 4.14552 13.901 4.121 13.9173 4.17005C13.9746 4.4235 14.1136 4.61973 14.2198 4.79142C14.2525 4.84865 14.2198 4.88136 14.1463 4.82413C14.0972 4.78325 14.04 4.65245 14.0155 4.65245C13.9664 4.64427 13.8519 4.87317 13.6149 4.80776C13.5576 4.79141 13.5576 4.61155 13.5576 4.52979C13.5576 4.48891 13.5985 4.48074 13.5985 4.52979C13.5985 4.60337 13.5985 4.75054 13.6966 4.75871C13.7702 4.75871 13.9419 4.66062 13.9828 4.57068C14.0155 4.48075 13.901 4.30904 13.8601 4.21911H13.852Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.9902 4.06439C13.9902 4.06439 14.0802 4.00714 14.1047 3.99078C14.1211 3.97443 14.1292 4.00714 14.1292 4.02349C14.1129 4.04802 14.0475 4.09707 14.0148 4.09707C13.9984 4.09707 13.9821 4.08074 13.9984 4.06439H13.9902Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.1869 4.07224C14.2032 4.02319 14.2605 3.94961 14.2932 3.92508C14.3177 3.91691 14.3422 3.92508 14.3422 3.94143C14.3259 3.98231 14.2605 4.05591 14.2114 4.08861C14.1951 4.10496 14.1787 4.08859 14.1787 4.07224H14.1869Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.0228 4.19399C14.0228 4.19399 14.0228 4.21852 14.0228 4.2267C14.0474 4.2267 14.0882 4.23487 14.1046 4.2267C14.1373 4.21035 14.1209 4.10407 14.0801 4.1613C14.0555 4.19401 14.0392 4.18581 14.0146 4.19399H14.0228Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.5949 4.16225C14.5949 4.16225 14.6358 4.10501 14.6603 4.08049C14.6766 4.06413 14.7012 4.08048 14.693 4.12136C14.693 4.14588 14.6521 4.17041 14.6276 4.19493C14.6031 4.21129 14.5867 4.17858 14.5949 4.17041V4.16225Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.873 4.05664C14.873 4.05664 14.9221 4.12205 14.873 4.1384C14.8485 4.14658 14.824 4.06482 14.873 4.05664Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7842 4.2758C14.7842 4.33303 14.8169 4.33302 14.8741 4.32485C14.9314 4.32485 14.9804 4.32485 14.9804 4.2758C14.9804 4.21856 14.9477 4.16952 14.9395 4.2104C14.9313 4.2431 14.9232 4.30851 14.9068 4.28398C14.8823 4.25945 14.8905 4.25128 14.8578 4.28398C14.8332 4.30851 14.8332 4.2758 14.8251 4.25127C14.8169 4.23492 14.7924 4.25946 14.7924 4.26764L14.7842 4.2758Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.3831 4.59539C14.3749 4.67715 14.383 4.7916 14.4239 4.7916C14.473 4.7916 14.5793 4.61174 14.6365 4.52181C14.661 4.46458 14.7183 4.45639 14.6937 4.51362C14.661 4.59538 14.661 4.77525 14.6937 4.82431C14.7101 4.85701 14.8245 4.79977 14.8409 4.75889C14.8736 4.68531 14.8409 4.55451 14.8654 4.46457C14.8654 4.40734 14.9145 4.39917 14.9145 4.44823C14.9145 4.53816 14.8981 4.70983 14.9145 4.78342C14.9145 4.82429 15.0371 4.8897 15.0616 4.75889C15.0698 4.67713 15.1107 4.59537 15.0616 4.50544C15.0289 4.44821 15.1107 4.45639 15.1598 4.53815C15.1925 4.58721 15.1352 4.67714 15.1352 4.74255C15.1352 4.84883 15.0616 4.90607 15.0044 4.90607C14.9472 4.90607 14.9145 4.84065 14.8736 4.84065C14.8327 4.84065 14.7755 4.91423 14.7428 4.91423C14.5874 4.90605 14.6692 4.67715 14.6283 4.67715C14.5793 4.67715 14.5139 4.89788 14.4484 4.8897C14.383 4.88153 14.3177 4.70984 14.3422 4.63626C14.3667 4.57085 14.4076 4.55451 14.4076 4.59539H14.3831Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.1183 4.24416C15.0447 4.20329 15.1183 4.08063 15.1592 4.12151C15.2327 4.21144 15.2981 4.40767 15.3554 4.41585C15.3881 4.4322 15.3881 4.26868 15.4044 4.20327C15.4208 4.14604 15.4862 4.1624 15.4698 4.23598C15.4698 4.26051 15.3799 4.52212 15.3881 4.5303C15.4453 4.63658 15.5025 4.75105 15.5352 4.86551C15.5516 4.92274 15.4862 4.88186 15.478 4.86551C15.4371 4.80828 15.3717 4.57937 15.3717 4.59572C15.339 4.75106 15.3308 4.80012 15.2981 4.93093C15.2818 4.97181 15.2246 4.96362 15.2409 4.89003C15.2573 4.82463 15.3472 4.52213 15.339 4.51395C15.2655 4.39132 15.2 4.28504 15.1101 4.23598L15.1183 4.24416Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.2574 4.97219C15.2574 4.97219 15.2083 5.02123 15.3064 5.03758C15.4454 5.07029 15.6008 5.02126 15.6416 4.88227C15.6907 4.71875 15.7316 4.57158 15.7561 4.51435C15.7888 4.44894 15.8378 4.44893 15.8051 4.35082C15.7806 4.27724 15.7397 4.30178 15.7316 4.33448C15.707 4.44076 15.6171 4.77596 15.5844 4.83319C15.5353 4.94765 15.4209 4.98854 15.2574 4.97219Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.535 4.44058C15.535 4.44058 15.4778 4.44059 15.4941 4.47329C15.4941 4.50599 15.5269 4.52234 15.5432 4.52234C15.5759 4.52234 15.6413 4.52235 15.6413 4.47329C15.6413 4.44059 15.6168 4.40789 15.5923 4.44876C15.5677 4.48964 15.5432 4.48147 15.535 4.44876V4.44058Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5684 4.30089C15.5684 4.30089 15.5684 4.34995 15.5847 4.34995C15.6256 4.34995 15.691 4.3336 15.7237 4.30908C15.7319 4.3009 15.7237 4.27637 15.7237 4.27637C15.6828 4.27637 15.6092 4.27637 15.5765 4.30089H15.5684Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.9519 4.40701C15.9846 4.35795 16.0745 4.34977 16.0418 4.42335C16.0173 4.47241 15.7966 4.9139 15.7638 4.96296C15.7311 5.02836 15.7066 4.99567 15.723 4.94661C15.7557 4.88121 15.9355 4.41518 15.9519 4.40701Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.0266 4.74285C16.0266 4.74285 15.9775 4.7265 15.9775 4.77556C15.9775 4.80826 16.0184 4.81643 16.0347 4.81643C16.1002 4.7592 16.0184 4.78373 16.0347 4.74285H16.0266Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.247 5.2827C16.2633 5.23364 16.5168 4.81668 16.5495 4.71857C16.5658 4.67769 16.6394 4.79216 16.5658 4.85757C16.5004 4.9148 16.3205 5.20912 16.2878 5.30723C16.2715 5.35628 16.2225 5.33175 16.247 5.27452V5.2827Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.9279 4.93945C15.9279 4.93945 15.9034 4.98033 15.9279 4.98851C15.9606 4.98851 16.0669 4.97217 16.0996 4.98035C16.1241 4.98035 16.1241 4.93945 16.0832 4.93945C16.0342 4.93945 15.9606 4.93945 15.9197 4.93945H15.9279Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.247 5.2827C16.2633 5.23364 16.5168 4.81668 16.5495 4.71857C16.5658 4.67769 16.6394 4.79216 16.5658 4.85757C16.5004 4.9148 16.3205 5.20912 16.2878 5.30723C16.2715 5.35628 16.2225 5.33175 16.247 5.27452V5.2827Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6721 4.8902C16.7211 4.71851 16.8274 4.91472 16.7293 5.01283C16.574 5.16 16.5331 5.44616 16.2878 5.48704C16.2224 5.50339 16.108 5.46252 16.0753 5.43799C16.0671 5.42981 16.0835 5.36439 16.1243 5.3971C16.1816 5.43797 16.3042 5.45433 16.3696 5.3971C16.5086 5.26628 16.6149 5.08642 16.6721 4.8902Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.6721 4.8902C16.7211 4.71851 16.8274 4.91472 16.7293 5.01283C16.574 5.16 16.5331 5.44616 16.2878 5.48704C16.2224 5.50339 16.108 5.46252 16.0753 5.43799C16.0671 5.42981 16.0835 5.36439 16.1243 5.3971C16.1816 5.43797 16.3042 5.45433 16.3696 5.3971C16.5086 5.26628 16.6149 5.08642 16.6721 4.8902Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.1705 5.44542C14.1705 5.44542 14.1297 5.46178 14.1215 5.47813C14.1051 5.54353 14.1215 5.57625 14.1051 5.64165C14.097 5.69888 14.0479 5.69887 14.0561 5.64981C14.0561 5.58441 14.1133 5.49449 14.0724 5.48631C14.0479 5.48631 14.0316 5.45361 14.0561 5.43726C14.1051 5.40456 14.1297 5.40454 14.1624 5.42089C14.1787 5.42089 14.1787 5.43725 14.1624 5.4536L14.1705 5.44542Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.1301 5.35611C14.0647 5.41334 14.0074 5.43786 13.9502 5.50327C13.9257 5.53597 13.9257 5.57685 13.9175 5.60956C13.9012 5.65043 13.8521 5.65042 13.8439 5.65042C13.8194 5.63407 13.8194 5.56049 13.7949 5.60137C13.7703 5.64225 13.754 5.68313 13.7213 5.68313C13.6886 5.68313 13.6314 5.62591 13.6641 5.61774C13.7622 5.60139 13.7622 5.52781 13.8031 5.51963C13.8439 5.51963 13.8439 5.58504 13.8685 5.56869C13.893 5.56051 13.9012 5.47056 13.9175 5.45421C13.9829 5.38063 14.032 5.34793 14.1056 5.29887C14.1383 5.26617 14.1628 5.31522 14.1301 5.34792V5.35611Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.3665 5.57607C14.3093 5.58425 14.3256 5.64966 14.3338 5.65783C14.3583 5.67419 14.3992 5.67418 14.4074 5.6006C14.4155 5.56789 14.4237 5.75594 14.4891 5.68236C14.53 5.64148 14.6281 5.68237 14.669 5.64149C14.7017 5.60061 14.7098 5.57607 14.6853 5.52702C14.6853 5.51067 14.6363 5.51885 14.6445 5.55973C14.6445 5.59243 14.6199 5.6333 14.5872 5.62512C14.5709 5.62512 14.5872 5.54337 14.5872 5.52702C14.5872 5.51067 14.5627 5.51884 14.5545 5.52702C14.5382 5.54337 14.5627 5.61695 14.53 5.62512C14.4728 5.64148 14.5055 5.56791 14.4809 5.56791C14.4073 5.52703 14.4073 5.5679 14.3746 5.58426L14.3665 5.57607Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7671 5.44624C14.7671 5.44624 14.7917 5.43809 14.8489 5.38903C14.8734 5.37268 14.8734 5.42173 14.8734 5.43809C14.8734 5.47079 14.8244 5.45443 14.8162 5.47896C14.7917 5.51983 14.7998 5.60978 14.7917 5.64248C14.7917 5.65883 14.7589 5.65883 14.7589 5.64248C14.7589 5.6016 14.7589 5.55255 14.7589 5.49532C14.7589 5.4708 14.7344 5.44626 14.7589 5.43809L14.7671 5.44624Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.5463 5.33041C14.5381 5.37129 14.5381 5.404 14.5381 5.4367C14.5381 5.46123 14.579 5.4367 14.579 5.4367C14.579 5.39582 14.579 5.34677 14.579 5.3386C14.579 5.3386 14.5544 5.32224 14.5463 5.33041Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.3665 5.57607C14.3093 5.58425 14.3256 5.64966 14.3338 5.65783C14.3583 5.67419 14.3992 5.67418 14.4074 5.6006C14.4155 5.56789 14.4237 5.75594 14.4891 5.68236C14.53 5.64148 14.6281 5.68237 14.669 5.64149C14.7017 5.60061 14.7098 5.57607 14.6853 5.52702C14.6853 5.51067 14.6363 5.51885 14.6445 5.55973C14.6445 5.59243 14.6199 5.6333 14.5872 5.62512C14.5709 5.62512 14.5872 5.54337 14.5872 5.52702C14.5872 5.51067 14.5627 5.51884 14.5545 5.52702C14.5382 5.54337 14.5627 5.61695 14.53 5.62512C14.4728 5.64148 14.5055 5.56791 14.4809 5.56791C14.4073 5.52703 14.4073 5.5679 14.3746 5.58426L14.3665 5.57607Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7671 5.44624C14.7671 5.44624 14.7917 5.43809 14.8489 5.38903C14.8734 5.37268 14.8734 5.42173 14.8734 5.43809C14.8734 5.47079 14.8244 5.45443 14.8162 5.47896C14.7917 5.51983 14.7998 5.60978 14.7917 5.64248C14.7917 5.65883 14.7589 5.65883 14.7589 5.64248C14.7589 5.6016 14.7589 5.55255 14.7589 5.49532C14.7589 5.4708 14.7344 5.44626 14.7589 5.43809L14.7671 5.44624Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.5463 5.33041C14.5381 5.37129 14.5381 5.404 14.5381 5.4367C14.5381 5.46123 14.579 5.4367 14.579 5.4367C14.579 5.39582 14.579 5.34677 14.579 5.3386C14.579 5.3386 14.5544 5.32224 14.5463 5.33041Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.1301 5.35611C14.0647 5.41334 14.0074 5.43786 13.9502 5.50327C13.9257 5.53597 13.9257 5.57685 13.9175 5.60956C13.9012 5.65043 13.8521 5.65042 13.8439 5.65042C13.8194 5.63407 13.8194 5.56049 13.7949 5.60137C13.7703 5.64225 13.754 5.68313 13.7213 5.68313C13.6886 5.68313 13.6314 5.62591 13.6641 5.61774C13.7622 5.60139 13.7622 5.52781 13.8031 5.51963C13.8439 5.51963 13.8439 5.58504 13.8685 5.56869C13.893 5.56051 13.9012 5.47056 13.9175 5.45421C13.9829 5.38063 14.032 5.34793 14.1056 5.29887C14.1383 5.26617 14.1628 5.31522 14.1301 5.34792V5.35611Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.1705 5.44542C14.1705 5.44542 14.1297 5.46178 14.1215 5.47813C14.1051 5.54353 14.1215 5.57625 14.1051 5.64165C14.097 5.69888 14.0479 5.69887 14.0561 5.64981C14.0561 5.58441 14.1133 5.49449 14.0724 5.48631C14.0479 5.48631 14.0316 5.45361 14.0561 5.43726C14.1051 5.40456 14.1297 5.40454 14.1624 5.42089C14.1787 5.42089 14.1787 5.43725 14.1624 5.4536L14.1705 5.44542Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M18.1517 8.11873C18.1517 8.11873 18.1926 8.15962 18.2008 8.15144C18.2417 8.09421 18.3071 7.98792 18.3152 7.92252C18.3152 7.90617 18.258 7.88162 18.2417 7.89797C18.2008 7.94702 18.1599 8.05332 18.1436 8.11873H18.1517Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M18.1922 8.15972C18.1922 8.15972 18.1595 8.15154 18.1514 8.13519C18.1595 8.04526 18.2004 7.93898 18.2413 7.88993C18.2822 7.88175 18.3149 7.88992 18.323 7.90627C18.323 7.98803 18.2576 8.09433 18.2086 8.15156H18.1922V8.15972ZM18.2658 7.90627C18.2168 7.95533 18.1759 8.06163 18.1677 8.12703C18.1677 8.12703 18.1922 8.15156 18.2004 8.15156C18.2413 8.09433 18.3067 7.9962 18.3149 7.9308C18.3149 7.9308 18.2903 7.91445 18.274 7.91445L18.2658 7.90627Z",
            fill: "#B06A1A"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.925 10.2611C13.925 10.2611 13.925 10.3184 13.9168 10.3756H13.8923C13.8923 10.3756 13.8923 10.3184 13.8923 10.302C13.8923 10.2775 13.8923 10.2611 13.876 10.2284C13.876 10.2121 13.8596 10.1876 13.8514 10.1794C13.8514 10.163 13.8351 10.1385 13.8105 10.1221L13.8514 10.0322C13.8514 10.0322 13.8841 10.0731 13.8841 10.0813C13.8841 10.0976 13.9005 10.114 13.9087 10.1303C13.9087 10.1467 13.9168 10.1712 13.925 10.1876C13.925 10.2121 13.925 10.2284 13.925 10.2611Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.2098 10.0889C14.2098 10.0889 14.2098 10.1379 14.1934 10.1461C14.1852 10.1624 14.1689 10.1706 14.1362 10.1788C14.1444 10.2033 14.1526 10.2197 14.1526 10.236C14.1526 10.2524 14.1526 10.2687 14.1526 10.2851V10.3178C14.1526 10.3178 14.1526 10.3505 14.1526 10.3668H14.1362C14.1362 10.3668 14.1362 10.3341 14.1362 10.3178C14.1362 10.3014 14.1362 10.2932 14.128 10.2769C14.128 10.2769 14.128 10.2605 14.1117 10.236C14.1117 10.2115 14.0953 10.1951 14.0872 10.1788C14.0872 10.1624 14.0626 10.1379 14.0381 10.1134L14.0708 10.0234C14.0708 10.0234 14.0953 10.0562 14.1117 10.0643C14.1199 10.0725 14.1362 10.0807 14.1526 10.0807C14.1853 10.0807 14.2016 10.0643 14.2016 10.0234H14.218V10.0807L14.2098 10.0889Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.4722 10.2851L14.4559 10.375C14.4559 10.375 14.4313 10.3587 14.4232 10.3423C14.415 10.326 14.4068 10.3096 14.4068 10.2851C14.4068 10.2605 14.4068 10.2442 14.4068 10.2197C14.3905 10.2197 14.3741 10.2197 14.3659 10.2197C14.3414 10.2197 14.3251 10.2197 14.3087 10.2033C14.3005 10.187 14.2842 10.1788 14.2842 10.1624C14.2842 10.1297 14.3005 10.097 14.3169 10.0643C14.3332 10.0316 14.3578 10.0234 14.3823 10.0234C14.3986 10.0234 14.415 10.0235 14.4232 10.0398C14.4232 10.0562 14.4313 10.0643 14.4395 10.0807C14.4395 10.097 14.4395 10.1216 14.4395 10.1624C14.4395 10.1951 14.4395 10.2197 14.4477 10.236C14.4477 10.2524 14.464 10.2605 14.4804 10.2769L14.4722 10.2851ZM14.3986 10.1379C14.3986 10.1379 14.3823 10.1052 14.3659 10.1052C14.3578 10.1052 14.3496 10.1052 14.3414 10.1134C14.3414 10.1134 14.3332 10.1216 14.3332 10.1297C14.3332 10.1379 14.3496 10.1461 14.3741 10.1461H14.3986V10.1379Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.7586 10.2619L14.7422 10.3682C14.7422 10.3682 14.7013 10.3273 14.685 10.2864C14.6686 10.2455 14.6441 10.1883 14.6277 10.1147C14.6114 10.1883 14.5951 10.2373 14.5869 10.27C14.5705 10.3028 14.5623 10.3273 14.5542 10.3436C14.5542 10.3436 14.5378 10.36 14.5215 10.3682V10.27C14.5215 10.27 14.5542 10.221 14.5624 10.2046C14.5624 10.1883 14.5869 10.1638 14.5869 10.131C14.5951 10.0983 14.6032 10.0657 14.6114 10.0166H14.6359C14.6441 10.0657 14.6605 10.0983 14.6686 10.131C14.6768 10.1556 14.6932 10.1719 14.7095 10.1965C14.7177 10.2128 14.734 10.2292 14.7586 10.2537V10.2619Z",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15.5601 11.2664C15.5601 11.2664 15.5847 11.2991 15.5928 11.3155C15.5928 11.3318 15.601 11.3563 15.6092 11.3808H15.5765C15.5765 11.3808 15.552 11.34 15.5356 11.3236C15.5274 11.3073 15.5111 11.2909 15.4866 11.2746C15.462 11.25 15.4457 11.2337 15.4211 11.2092C15.3966 11.1928 15.3721 11.1683 15.3394 11.1437C15.3231 11.1274 15.3149 11.1274 15.3149 11.1274C15.3149 11.1274 15.2985 11.1111 15.2985 11.0865C15.2985 11.0702 15.2985 11.0456 15.2985 11.0293L15.4048 11.1192C15.4457 11.1519 15.4866 11.1846 15.5111 11.2092C15.5356 11.2255 15.5438 11.2501 15.5683 11.2664H15.5601ZM15.1677 11.0293V11.1111H15.0287V11.0293H15.1677ZM15.5111 11.3972L15.2004 11.4953L15.1432 11.4217L15.413 11.34C15.413 11.34 15.3884 11.3073 15.3803 11.2991C15.3803 11.2991 15.3557 11.2827 15.3476 11.2746C15.3476 11.2909 15.3394 11.2991 15.3312 11.3155C15.3149 11.3318 15.2985 11.34 15.2822 11.34C15.2576 11.34 15.2331 11.3482 15.2086 11.34C15.1841 11.34 15.1677 11.3236 15.1595 11.3073C15.1432 11.2909 15.135 11.2501 15.135 11.2173C15.135 11.1765 15.1513 11.1519 15.1677 11.1437C15.2004 11.1274 15.2413 11.1437 15.2904 11.1683C15.3476 11.201 15.3803 11.2255 15.413 11.2664L15.5111 11.3972ZM15.274 11.2337C15.274 11.2337 15.2495 11.2173 15.2413 11.2173C15.2413 11.2173 15.2249 11.2173 15.2167 11.2173C15.2167 11.2173 15.2004 11.2173 15.2004 11.2337C15.2004 11.2419 15.2004 11.25 15.2004 11.25C15.2004 11.25 15.2086 11.2582 15.2167 11.2664C15.2249 11.2664 15.2331 11.2664 15.2413 11.2664C15.2495 11.2664 15.2576 11.2664 15.2658 11.2582C15.2658 11.2582 15.274 11.2419 15.2822 11.2337H15.274ZM14.9388 11.1765L14.9143 11.2582L14.7834 11.2419L14.7998 11.1601L14.9306 11.1765H14.9388ZM15.2495 11.4871L15.1841 11.5035C15.1841 11.5035 15.135 11.5035 15.1105 11.5035C15.086 11.5035 15.0696 11.4953 15.0451 11.4871C15.0369 11.5035 15.0124 11.5198 14.9878 11.5444C14.9633 11.5444 14.947 11.5607 14.9224 11.5607H14.8734L14.8325 11.4871L14.8816 11.4708C14.8816 11.4708 14.9224 11.4544 14.9306 11.4544C14.9388 11.4544 14.9551 11.4463 14.9715 11.4381C14.9551 11.4217 14.9388 11.4217 14.9306 11.4136C14.9224 11.4136 14.9143 11.4136 14.8979 11.4136C14.8979 11.4136 14.8979 11.4136 14.8897 11.4136C14.8897 11.4136 14.8897 11.4136 14.8897 11.4217H14.8652C14.8652 11.4217 14.8407 11.3645 14.8489 11.3481C14.8652 11.3318 14.8897 11.3073 14.9306 11.2991C14.9715 11.2909 15.0124 11.2909 15.0369 11.2991C15.0696 11.2991 15.0941 11.3155 15.1023 11.34C15.1023 11.3482 15.1105 11.3563 15.1023 11.3727C15.1023 11.3808 15.1023 11.3972 15.086 11.4136C15.086 11.4136 15.0941 11.4136 15.1105 11.4136H15.135L15.2004 11.3972L15.2495 11.479V11.4871ZM14.9143 11.5689H14.8489C14.8489 11.5689 14.7834 11.5689 14.7589 11.5689C14.7344 11.5526 14.7099 11.5117 14.6853 11.4626L14.6526 11.3727C14.6526 11.3727 14.6363 11.34 14.6199 11.3318C14.6199 11.3318 14.6036 11.3155 14.5872 11.3155L14.6118 11.2337C14.6118 11.2337 14.6526 11.2582 14.669 11.2746C14.6853 11.2909 14.7017 11.3154 14.7099 11.3481L14.7344 11.4054C14.7507 11.4463 14.7671 11.479 14.7834 11.4953C14.7916 11.5117 14.808 11.5117 14.8243 11.5117L14.8897 11.4953L14.9224 11.5852L14.9143 11.5689ZM14.6281 11.2582L14.5872 11.34L14.4646 11.3073L14.5055 11.2337L14.6281 11.2664V11.2582ZM14.7017 11.6098L14.391 11.6343L14.3747 11.5525L14.6363 11.528C14.6363 11.528 14.6199 11.5035 14.6118 11.4871C14.6118 11.4871 14.5872 11.4708 14.5709 11.4626L14.5954 11.3808C14.5954 11.3808 14.6445 11.4136 14.6608 11.4299C14.669 11.4544 14.6853 11.479 14.6935 11.5198L14.7099 11.6016L14.7017 11.6098ZM14.4564 11.6507C14.4564 11.6507 14.3828 11.6507 14.3665 11.6507C14.342 11.6507 14.3174 11.6425 14.2929 11.6343C14.2766 11.6425 14.252 11.6507 14.2438 11.6507C14.2275 11.6507 14.203 11.6507 14.1784 11.6507H14.0967C14.0967 11.6507 14.0558 11.6506 14.0476 11.6343C14.0313 11.6343 14.0231 11.6098 14.0149 11.5934C13.9986 11.6098 13.9741 11.6261 13.9495 11.6343C13.9332 11.6343 13.9087 11.6425 13.876 11.6425H13.8024L13.8105 11.5525H13.8841C13.8841 11.5525 13.9495 11.5525 13.9741 11.5362C14.0068 11.5198 14.0231 11.4953 14.0231 11.4626H14.0558C14.0558 11.4626 14.0558 11.479 14.0558 11.4871C14.0558 11.4953 14.0558 11.5117 14.0558 11.5198C14.0558 11.528 14.0558 11.5362 14.0722 11.5525C14.0803 11.5607 14.0967 11.5689 14.1131 11.5689H14.1703C14.1703 11.5689 14.2357 11.5689 14.2602 11.5689C14.2766 11.5607 14.2929 11.5444 14.2929 11.5198V11.5035C14.2929 11.5035 14.3011 11.5035 14.3093 11.4871H14.3256V11.5117C14.3256 11.5117 14.3256 11.5444 14.3093 11.5607C14.3256 11.5607 14.3338 11.5689 14.3501 11.5689C14.3665 11.5689 14.3828 11.5689 14.3992 11.5689C14.3992 11.5689 14.3992 11.5526 14.3828 11.5444C14.3828 11.528 14.3828 11.5198 14.3828 11.5198C14.3828 11.5198 14.3828 11.5117 14.3828 11.5035C14.3828 11.5035 14.3828 11.5035 14.391 11.4953L14.4401 11.4544C14.4401 11.4544 14.4482 11.4871 14.4564 11.4953C14.4564 11.5117 14.4564 11.5198 14.4564 11.5362V11.6507ZM13.9904 11.2909L13.9168 11.3481L13.8596 11.3073L13.8024 11.3481L13.7288 11.3073L13.8024 11.25L13.8678 11.2827L13.9332 11.2419L14.0068 11.2909H13.9904ZM13.8678 11.6261L13.5653 11.5771L13.598 11.4871L13.8514 11.528C13.8514 11.528 13.8514 11.4953 13.8514 11.4871C13.8514 11.4871 13.8433 11.4708 13.8269 11.4544L13.8923 11.389C13.8923 11.389 13.9168 11.4299 13.925 11.4463C13.925 11.4708 13.9168 11.4953 13.9005 11.5362L13.8678 11.618V11.6261ZM13.6143 11.5852L13.5489 11.5689C13.5489 11.5689 13.4917 11.5444 13.4835 11.5198C13.4835 11.4953 13.4835 11.4544 13.5162 11.4054L13.5653 11.3236C13.5653 11.3236 13.5816 11.2827 13.5816 11.2746C13.5816 11.2746 13.5735 11.2582 13.5653 11.2419L13.6634 11.1846C13.6634 11.1846 13.6716 11.2255 13.6716 11.2419C13.6716 11.2664 13.6552 11.2828 13.647 11.3155L13.6143 11.3727C13.5898 11.4135 13.5816 11.4463 13.5816 11.4626C13.5816 11.4708 13.5816 11.4871 13.6061 11.4871L13.6716 11.5035L13.6225 11.5852H13.6143ZM13.459 11.2664L13.3527 11.3073L13.2791 11.2337L13.3854 11.1928L13.459 11.2664ZM13.4181 11.5362C13.4181 11.5362 13.3772 11.5853 13.3527 11.5934C13.3282 11.6098 13.3118 11.6098 13.2791 11.618C13.2546 11.618 13.2219 11.618 13.181 11.618C13.1401 11.618 13.0993 11.6016 13.0666 11.5852C13.0012 11.5607 12.9521 11.5362 12.9276 11.5035C12.903 11.4708 12.903 11.4381 12.9276 11.4054C12.9521 11.3808 12.9766 11.3645 13.0012 11.3481C13.0339 11.3236 13.0911 11.3073 13.1565 11.2827L13.1728 11.3073C13.1156 11.3236 13.0747 11.3481 13.0584 11.3563C13.0339 11.3727 13.0175 11.3809 13.0093 11.3972C12.993 11.4136 12.993 11.4381 13.0093 11.4626C13.0339 11.4871 13.0666 11.5117 13.1156 11.528C13.1647 11.5525 13.2219 11.5607 13.2628 11.5607C13.3118 11.5607 13.3445 11.5444 13.3609 11.528C13.3691 11.5117 13.3772 11.5035 13.3772 11.4871C13.3772 11.4708 13.3854 11.4463 13.3854 11.4136L13.4917 11.3563C13.4917 11.3563 13.4917 11.4054 13.4917 11.4136C13.4917 11.4299 13.4754 11.4544 13.4508 11.479L13.4018 11.5362H13.4181Z",
            fill: "#AE0018"
          }), /*#__PURE__*/_jsx("path", {
            d: "M14.2677 4.93043L14.2023 5.17569L14.1124 5.01217V5.17569L13.9161 4.94677L13.9816 5.19204L13.8099 5.04488L13.8998 5.2084L13.5891 5.01217L13.7853 5.24109L13.5401 5.11846L13.7199 5.26564L13.3193 5.1103L13.7036 5.29833C13.8426 5.22474 14.0388 5.18388 14.2513 5.18388C14.4639 5.18388 14.6601 5.22474 14.8073 5.29833L15.1915 5.1103L14.7991 5.26564L14.9708 5.1103L14.7255 5.22475L14.9136 5.00401L14.6111 5.20022L14.701 5.03669L14.5293 5.18388L14.5947 4.93859L14.3985 5.16751V4.99583L14.3086 5.15935L14.2432 4.91406L14.2677 4.93043Z",
            fill: "white"
          })]
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ActivityStarIcon.tsx


function ActivityStarIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ActivityStarIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ActivityStarIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ActivityStarIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ActivityStarIcon = function ActivityStarIcon(props) {
  return /*#__PURE__*/_jsxs("svg", ActivityStarIcon_objectSpread(ActivityStarIcon_objectSpread({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 14.4011,
      cy: 2.48945,
      r: 0.8,
      fill: "url(#paint0_linear_841_8153)"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 2.53301,
      cy: 14.0926,
      r: 1.2,
      fill: "url(#paint1_linear_841_8153)"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 15.6014,
      cy: 15.691,
      r: 0.4,
      fill: "url(#paint2_linear_841_8153)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.38233 1.93811L10.501 5.52421C10.5603 5.71554 10.7317 5.84488 10.925 5.84488H14.5443C15.9517 5.84488 16.537 7.7216 15.3983 8.58362L12.4703 10.799C12.3137 10.9177 12.2483 11.1277 12.3083 11.319L13.4263 14.9045C13.8617 16.2992 12.3297 17.4585 11.191 16.5965L8.26233 14.3811C8.10633 14.2624 7.89433 14.2624 7.73767 14.3811L4.80967 16.5965C3.671 17.4585 2.139 16.2992 2.57366 14.9045L3.69233 11.319C3.75233 11.1277 3.68633 10.9177 3.53033 10.799L0.601662 8.58362C-0.537005 7.7216 0.0483286 5.84488 1.45566 5.84488H5.075C5.26833 5.84488 5.44033 5.71554 5.49967 5.52421L6.61833 1.93811C7.05367 0.544069 8.947 0.544069 9.38233 1.93811Z",
      fill: "url(#paint3_linear_841_8153)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.1404 7.4776L7.14142 10.5528L5.86169 9.24046C5.61903 8.9917 5.22559 8.9917 4.98302 9.24046C4.74036 9.48938 4.74036 9.89276 4.98302 10.1416L6.70208 11.9045C6.82337 12.0288 6.98243 12.091 7.14142 12.091C7.3004 12.091 7.45946 12.0288 7.58075 11.9045L11.019 8.37874C11.2617 8.1299 11.2617 7.72644 11.019 7.47769C10.7765 7.22885 10.383 7.22876 10.1404 7.4776Z",
      fill: "white"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_8153",
        x1: 13.6011,
        y1: 3.28945,
        x2: 15.2011,
        y2: 1.68945,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F3D452"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F09819"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_841_8153",
        x1: 1.33301,
        y1: 15.2926,
        x2: 3.73301,
        y2: 12.8926,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F3D452"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F09819"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_841_8153",
        x1: 15.2014,
        y1: 16.091,
        x2: 16.0014,
        y2: 15.291,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F3D452"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F09819"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_841_8153",
        x1: 2.38703e-7,
        y1: 16.8926,
        x2: 16,
        y2: 0.892577,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F3D452"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F09819"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ShieldCombo.tsx


function ShieldCombo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ShieldCombo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ShieldCombo_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ShieldCombo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ShieldCombo = function ShieldCombo(props) {
  return /*#__PURE__*/_jsxs("svg", ShieldCombo_objectSpread(ShieldCombo_objectSpread({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M18.9502 3.36384H18.4349C15.4817 3.36384 12.6223 2.45662 10.1648 0.740047C9.94492 0.586651 9.65926 0.586651 9.43941 0.740047C6.98329 2.45662 4.12248 3.36384 1.16925 3.36384H0.653939C0.292662 3.36384 0 3.67063 0 4.04901V12.2593C0 18.1205 4.17569 23.1636 9.71107 23.9919C9.74048 23.9992 9.77128 23.9992 9.80209 23.9992C9.8329 23.9992 9.8637 23.9978 9.89451 23.9919C15.4299 23.1636 19.6042 18.119 19.6042 12.2608V4.04901C19.6042 3.66917 19.3115 3.36384 18.9502 3.36384Z",
      fill: "#1E5C43"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0925 2.59437C12.3197 3.84484 14.7253 4.64581 17.2507 4.93847V4.93987C17.6224 4.98608 17.9042 5.30955 17.9042 5.71144V12.0142C17.9042 16.939 14.5334 21.1791 9.86921 22.0921C9.82428 22.1061 9.78072 22.1061 9.73579 22.1061C9.69086 22.1061 9.6473 22.1061 9.60237 22.0907C4.93821 21.1805 1.56738 16.9376 1.56738 12.0156V5.71004C1.56738 5.30955 1.84919 4.98608 2.22086 4.93987C4.74625 4.64581 7.15185 3.84484 9.3791 2.59437C9.60237 2.47115 9.86921 2.47115 10.0925 2.59437Z",
      fill: "#2B825E"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.70264 22.1078C9.7138 22.1081 9.72501 22.1081 9.73631 22.1081C9.78123 22.1081 9.8248 22.1081 9.86973 22.0941C14.5339 21.1811 17.9047 16.941 17.9047 12.0161V5.71339C17.9047 5.3115 17.6229 4.98804 17.2512 4.94183V4.94043C14.7258 4.64776 12.3202 3.84679 10.093 2.59633C9.97113 2.52907 9.83629 2.49852 9.70264 2.50468V22.1078Z",
      fill: "#1E5C43"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 19,
      cy: 6,
      r: 6,
      fill: "#F6F6F6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.7693 6.33V5.76923C21.7693 5.03481 21.4775 4.33038 20.9582 3.8111C20.4388 3.29174 19.7344 3 19 3C18.2656 3 17.5611 3.29174 17.0418 3.8111C16.5225 4.33041 16.2307 5.03481 16.2307 5.76923V6.33C16.0873 6.42146 16.0003 6.57977 16 6.74997V7.24997C16 7.38256 16.0527 7.50974 16.1464 7.60354C16.2402 7.69729 16.3674 7.74997 16.5 7.74997C16.5 7.88255 16.5527 8.00974 16.6464 8.10354C16.7402 8.19729 16.8674 8.24996 17 8.24996H17.25C17.3494 8.24996 17.4449 8.21046 17.5152 8.14014C17.5855 8.06983 17.625 7.9744 17.625 7.87497V6.12498C17.625 6.02554 17.5855 5.93011 17.5152 5.85981C17.4449 5.78951 17.3494 5.74999 17.25 5.74999H17C16.8674 5.74999 16.7402 5.80267 16.6464 5.89642C16.5527 5.99022 16.5 6.1174 16.5 6.24999C16.4934 6.24999 16.4875 6.25172 16.4807 6.252V5.76924C16.4808 5.29167 16.6176 4.8241 16.875 4.42187L17.0882 4.63527C17.1141 4.66156 17.1503 4.67484 17.187 4.67149C17.2237 4.66848 17.2572 4.64939 17.2785 4.61937C17.6751 4.06246 18.3163 3.73149 19 3.73076C19.5607 3.72886 20.0989 3.9519 20.4938 4.35001C20.5774 4.43288 20.6536 4.523 20.7213 4.61927C20.7426 4.6494 20.776 4.6686 20.8127 4.67178H20.8233H20.8234C20.8565 4.67178 20.8883 4.65861 20.9117 4.63512L21.125 4.42189C21.3824 4.82412 21.5192 5.2917 21.5192 5.76926V6.25201C21.5128 6.25201 21.5067 6.25 21.5 6.25C21.5 6.11742 21.4473 5.99023 21.3536 5.89643C21.2597 5.80268 21.1326 5.75001 21 5.75001H20.75C20.6505 5.75001 20.5551 5.78951 20.4848 5.85983C20.4145 5.93014 20.375 6.02557 20.375 6.125V7.87499C20.3752 7.97281 20.4136 8.06667 20.482 8.13655C20.5504 8.20647 20.6435 8.24681 20.7412 8.2491C20.7138 8.35636 20.6515 8.45139 20.5642 8.51941C20.4768 8.58744 20.3694 8.6246 20.2587 8.62499H19.875C19.875 8.52555 19.8355 8.43012 19.7652 8.35982C19.6949 8.28952 19.5994 8.25 19.5 8.25H19.25C19.116 8.25 18.9922 8.32149 18.9252 8.4375C18.8583 8.55352 18.8583 8.69649 18.9252 8.8125C18.9922 8.92852 19.116 9 19.25 9H19.5C19.6061 8.99966 19.707 8.95419 19.7775 8.875H20.2588C20.4359 8.87483 20.6072 8.81194 20.7424 8.6976C20.8776 8.5832 20.968 8.42462 20.9975 8.25H21C21.1326 8.25 21.2598 8.19732 21.3536 8.10357C21.4473 8.00977 21.5 7.88259 21.5 7.75C21.6326 7.75 21.7598 7.69733 21.8536 7.60358C21.9473 7.50977 22 7.38259 22 7.25001V6.75001C21.9997 6.57981 21.9127 6.4215 21.7693 6.33004V6.33ZM16.4999 7.49997C16.4337 7.49997 16.37 7.47363 16.3232 7.42675C16.2763 7.37988 16.2499 7.31626 16.2499 7.24997V6.74997C16.2499 6.68368 16.2763 6.62006 16.3232 6.57319C16.37 6.52631 16.4337 6.49997 16.4999 6.49997V7.49997ZM21.75 7.24997C21.75 7.31626 21.7236 7.37988 21.6768 7.42675C21.6299 7.47363 21.5663 7.49997 21.5 7.49997V6.49997C21.5663 6.49997 21.6299 6.52631 21.6768 6.57319C21.7236 6.62006 21.75 6.68368 21.75 6.74997V7.24997Z",
      fill: "#2B825E"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CovidIcon.tsx




var CovidIcon = function CovidIcon(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_jsxs("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "mask0_841_8100",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 19,
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.3802 0.962891H3.29617C1.73456 0.962891 0.468628 2.31889 0.468628 3.99161V15.8642C0.468628 17.5369 1.73456 18.8929 3.29617 18.8929H14.3802C15.9418 18.8929 17.2077 17.5369 17.2077 15.8642V3.99161C17.2077 2.31889 15.9418 0.962891 14.3802 0.962891Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_841_8100)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.3802 0.962891H3.29617C1.73456 0.962891 0.468628 2.31889 0.468628 3.99161V15.8642C0.468628 17.5369 1.73456 18.8929 3.29617 18.8929H14.3802C15.9418 18.8929 17.2077 17.5369 17.2077 15.8642V3.99161C17.2077 2.31889 15.9418 0.962891 14.3802 0.962891Z",
        fill: "url(#paint0_linear_841_8100)"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.95056 0.962891H14.4926C16.0542 0.962891 17.3201 2.31889 17.3201 3.99161V15.8642C17.3201 17.5369 16.0542 18.8929 14.4926 18.8929H8.95056V0.962891Z",
        fill: "url(#paint1_radial_841_8100)"
      })]
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.701 10.4209V9.58301C12.701 8.48565 12.2941 7.43312 11.5696 6.65723C10.8452 5.88122 9.86264 5.44531 8.83817 5.44531C7.81371 5.44531 6.83109 5.88122 6.10673 6.65723C5.38227 7.43317 4.97531 8.48565 4.97531 9.58301V10.4209C4.77518 10.5575 4.65382 10.7941 4.65344 11.0484V11.7955C4.65344 11.9936 4.72692 12.1836 4.8577 12.3238C4.98855 12.4638 5.16595 12.5426 5.3509 12.5426C5.3509 12.7407 5.42438 12.9307 5.55516 13.0708C5.68601 13.2109 5.86341 13.2896 6.04836 13.2896H6.39709C6.5358 13.2896 6.66892 13.2306 6.76698 13.1255C6.86504 13.0205 6.92017 12.8779 6.92017 12.7293V10.1146C6.92017 9.96597 6.86506 9.82338 6.76698 9.71835C6.6689 9.61331 6.53578 9.55425 6.39709 9.55425H6.04836C5.86341 9.55425 5.686 9.63296 5.55516 9.77304C5.42438 9.9132 5.3509 10.1032 5.3509 10.3013C5.34164 10.3013 5.33346 10.3039 5.32404 10.3043V9.58302C5.32412 8.86945 5.51491 8.17082 5.874 7.56983L6.17144 7.88868C6.20748 7.92795 6.25808 7.9478 6.30922 7.9428C6.36036 7.9383 6.40706 7.90978 6.43688 7.86492C6.9901 7.0328 7.8845 6.53828 8.83813 6.53719C9.62036 6.53436 10.371 6.86761 10.9219 7.46246C11.0385 7.58628 11.1448 7.72093 11.2393 7.86477C11.269 7.9098 11.3156 7.93848 11.3667 7.94323H11.3815H11.3816C11.4278 7.94323 11.4722 7.92356 11.5049 7.88845L11.8023 7.56986C12.1614 8.17085 12.3522 8.8695 12.3523 9.58304V10.3044C12.3433 10.3044 12.3348 10.3014 12.3254 10.3014C12.3254 10.1033 12.2519 9.91322 12.1212 9.77307C11.9903 9.63299 11.8129 9.55428 11.628 9.55428H11.2792C11.1405 9.55428 11.0074 9.61331 10.9093 9.71837C10.8113 9.82343 10.7562 9.96602 10.7562 10.1146V12.7294C10.7565 12.8755 10.81 13.0158 10.9055 13.1202C11.0009 13.2246 11.1307 13.2849 11.267 13.2883C11.2287 13.4486 11.1419 13.5906 11.02 13.6922C10.8982 13.7939 10.7484 13.8494 10.594 13.85H10.0587C10.0587 13.7014 10.0036 13.5588 9.90551 13.4538C9.80743 13.3487 9.67431 13.2897 9.53562 13.2897H9.18689C8.99999 13.2897 8.82734 13.3965 8.73386 13.5698C8.64045 13.7432 8.64045 13.9568 8.73386 14.1302C8.82735 14.3035 8.99999 14.4103 9.18689 14.4103H9.53562C9.68359 14.4098 9.82433 14.3419 9.92273 14.2235H10.594C10.8411 14.2233 11.0801 14.1293 11.2687 13.9585C11.4573 13.7876 11.5833 13.5506 11.6245 13.2897H11.628C11.8129 13.2897 11.9903 13.211 12.1212 13.0709C12.252 12.9307 12.3254 12.7407 12.3254 12.5426C12.5104 12.5426 12.6878 12.4639 12.8187 12.3238C12.9494 12.1837 13.0229 11.9936 13.0229 11.7955V11.0485C13.0225 10.7941 12.9012 10.5576 12.701 10.4209V10.4209ZM5.35082 12.169C5.25835 12.169 5.16961 12.1297 5.10422 12.0596C5.03883 11.9896 5.00209 11.8945 5.00209 11.7955V11.0484C5.00209 10.9493 5.03883 10.8543 5.10422 10.7842C5.16961 10.7142 5.25835 10.6749 5.35082 10.6749V12.169ZM12.6741 11.7955C12.6741 11.8945 12.6374 11.9896 12.572 12.0596C12.5066 12.1297 12.4179 12.169 12.3254 12.169V10.6749C12.4179 10.6749 12.5066 10.7142 12.572 10.7842C12.6374 10.8543 12.6741 10.9493 12.6741 11.0484V11.7955Z",
      fill: "white"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_841_8100",
        x1: 8.83817,
        y1: 0.96289,
        x2: 3.70278,
        y2: 19.1633,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#027863"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#163E36"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        id: "paint1_radial_841_8100",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(15.5228 0.962891) rotate(109.533) scale(19.8943 16.7719)",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00E6BC"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#01715D",
          stopOpacity: 0
        })]
      })]
    })]
  });
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/InsPlanIcon.tsx


function InsPlanIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsPlanIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsPlanIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsPlanIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var InsPlanIcon = function InsPlanIcon(props) {
  return /*#__PURE__*/_jsxs("svg", InsPlanIcon_objectSpread(InsPlanIcon_objectSpread({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      y: 0.962891,
      width: 24,
      height: 24,
      rx: 4,
      fill: "url(#pattern0)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: /*#__PURE__*/_jsx("use", {
          xlinkHref: "#image0_841_8059",
          transform: "translate(-0.0714286 -0.0714286) scale(0.00285714)"
        })
      }), /*#__PURE__*/_jsx("image", {
        id: "image0_841_8059",
        width: 400,
        height: 400,
        xlinkHref: "data:image/png;base64,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"
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/GreyBgChev.tsx


function GreyBgChev_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GreyBgChev_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GreyBgChev_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GreyBgChev_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var GreyBgChev = function GreyBgChev(props) {
  return /*#__PURE__*/_jsxs("svg", GreyBgChev_objectSpread(GreyBgChev_objectSpread({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 16,
      cy: 16,
      r: 16,
      transform: "matrix(1 0 0 -1 0 32)",
      fill: "#F4F4F4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.8585 17.3941C15.9366 17.4722 16.0633 17.4722 16.1414 17.3941L20.2426 13.2929C20.6331 12.9024 21.2663 12.9024 21.6568 13.2929C22.0473 13.6834 22.0473 14.3166 21.6568 14.7071L16.7071 19.6569C16.3165 20.0474 15.6834 20.0474 15.2928 19.6569L10.3431 14.7071C9.95257 14.3166 9.95257 13.6834 10.3431 13.2929C10.7336 12.9024 11.3668 12.9024 11.7573 13.2929L15.8585 17.3941Z",
      fill: "#008CFF"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/HeartCare.tsx


function HeartCare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HeartCare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HeartCare_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HeartCare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var HeartCare = function HeartCare(props) {
  return /*#__PURE__*/_jsxs("svg", HeartCare_objectSpread(HeartCare_objectSpread({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17.2565 11.0258C19.2031 9.0743 19.2017 5.91439 17.2521 3.96476C15.3767 2.08934 12.3814 2.01669 10.4191 3.74648C10.2884 3.8617 10.0935 3.8617 9.96283 3.74648C8.00051 2.01669 5.00519 2.08934 3.12978 3.96476C1.18018 5.91436 1.17878 9.0743 3.12538 11.0258L9.94838 17.849C10.0823 17.983 10.2995 17.983 10.4335 17.849L17.2565 11.0258Z",
      fill: "#FB4A59"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.2564 11.0256L10.4334 17.849C10.2996 17.9828 10.0822 17.9828 9.94836 17.849L9.26367 17.1643L15.9237 10.5043C17.8701 8.55272 17.8687 5.39268 15.9192 3.44321C15.5947 3.11872 15.2366 2.84807 14.8558 2.63159C15.734 2.83571 16.5672 3.27992 17.2519 3.96464C19.2018 5.91407 19.2031 9.07411 17.2564 11.0256Z",
      fill: "#F82F40"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.3335 13.1312C10.3335 12.6894 9.97532 12.3312 9.5335 12.3312H7.83554V10.6333C7.83554 10.1914 7.47737 9.83325 7.03554 9.83325H5.63145C5.18962 9.83325 4.83145 10.1914 4.83145 10.6333V12.3312H3.1335C2.69167 12.3312 2.3335 12.6894 2.3335 13.1312V14.5353C2.3335 14.9771 2.69167 15.3353 3.1335 15.3353H4.83145V17.0333C4.83145 17.4751 5.18962 17.8333 5.63145 17.8333H7.03554C7.47737 17.8333 7.83554 17.4751 7.83554 17.0333V15.3353H9.5335C9.97532 15.3353 10.3335 14.9771 10.3335 14.5353V13.1312Z",
      fill: "#F2CC98"
    }), /*#__PURE__*/_jsx("rect", {
      x: 5,
      y: 13.1667,
      width: 2.66667,
      height: 1.33333,
      rx: 0.4,
      fill: "#FFEBCF"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/FlightCancel.tsx


function FlightCancel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FlightCancel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FlightCancel_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FlightCancel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var FlightCancel = function FlightCancel(props) {
  return /*#__PURE__*/_jsxs("svg", FlightCancel_objectSpread(FlightCancel_objectSpread({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.5484 13.4537L12.8911 11.7964L14.5484 10.1391C15.006 9.68148 15.748 9.68148 16.2056 10.1391C16.6633 10.5968 16.6633 11.3388 16.2056 11.7964L14.5484 13.4537Z",
      fill: "#0095FF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.60457 5.16739L2.94727 3.51009L5.4332 1.02415C5.89086 0.566494 6.63285 0.566494 7.09047 1.02415C7.54813 1.48181 7.54813 2.2238 7.09047 2.68142L4.60457 5.16739Z",
      fill: "#4BB9EC"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.293 5.10817L2.43008 0.147072C1.9757 -0.106639 1.40074 -0.0261311 1.03215 0.342502L0 1.37465L7.50504 8.89617L11.293 5.10817Z",
      fill: "#C9C9C9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.0193 14.7528L12.1215 5.93677L8.3335 9.72474L15.7913 17.1825L16.8234 16.1504C17.1921 15.7817 17.2726 15.2068 17.0193 14.7528Z",
      fill: "#C9C9C9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.83422 15.3643L5.17695 17.0216L3.51969 13.707L0.205078 12.0498L1.86234 10.3925L4.62172 10.9477L13.5709 0.725744C14.3332 -0.152615 15.6673 -0.293435 16.5954 0.634651C17.5151 1.55442 17.3826 2.89684 16.5043 3.65914L6.27902 12.605L6.83422 15.3643Z",
      fill: "#9FACBA"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.9609 15.8594C19.9609 18.1211 18.1211 19.9609 15.8594 19.9609C13.5977 19.9609 11.7578 18.1211 11.7578 15.8594C11.7578 13.5977 13.5977 11.7578 15.8594 11.7578C18.1211 11.7578 19.9609 13.5977 19.9609 15.8594Z",
      fill: "#FF3838"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.7305 15.8985L17.4804 16.6602L16.6602 17.4805L15.8984 16.7305L15.1366 17.4805L14.3164 16.6602L15.0663 15.8985L14.3164 15.1367L15.1366 14.3164L15.8984 15.0664L16.6602 14.3164L17.4804 15.1367L16.7305 15.8985Z",
      fill: "white"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/DownArrow.tsx


function DownArrow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DownArrow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DownArrow_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DownArrow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var DownArrow_DownArrow = function DownArrow(props) {
  return /*#__PURE__*/_jsx("svg", DownArrow_objectSpread(DownArrow_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.8583 13.3941C11.9364 13.4722 12.063 13.4722 12.1411 13.3941L16.2423 9.29289C16.6329 8.90237 17.266 8.90237 17.6566 9.29289C18.0471 9.68342 18.0471 10.3166 17.6566 10.7071L12.7068 15.6569C12.3163 16.0474 11.6831 16.0474 11.2926 15.6569L6.34285 10.7071C5.95232 10.3166 5.95232 9.68342 6.34285 9.29289C6.73337 8.90237 7.36654 8.90237 7.75706 9.29289L11.8583 13.3941Z",
      fill: "#008CFF"
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/WarningIcon.tsx


function WarningIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WarningIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WarningIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WarningIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_jsxs("svg", WarningIcon_objectSpread(WarningIcon_objectSpread({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 16,
      cy: 16,
      r: 16,
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0004 6.78552C15.2054 6.78552 14.5686 7.44459 14.596 8.2392L14.9973 19.877C15.016 20.4176 15.4596 20.8461 16.0004 20.8461C16.5413 20.8461 16.9849 20.4176 17.0036 19.877L17.4049 8.2392C17.4323 7.44459 16.7955 6.78552 16.0004 6.78552ZM16.0004 25.2107C16.8038 25.2107 17.455 24.5595 17.455 23.7562C17.455 22.9529 16.8038 22.3017 16.0004 22.3017C15.1971 22.3017 14.5459 22.9529 14.5459 23.7562C14.5459 24.5595 15.1971 25.2107 16.0004 25.2107Z",
      fill: "#6B4300"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/NoInsIcon.tsx


function NoInsIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NoInsIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NoInsIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NoInsIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var NoInsIcon = function NoInsIcon(props) {
  return /*#__PURE__*/_jsxs("svg", NoInsIcon_objectSpread(NoInsIcon_objectSpread({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 40,
      cy: 40.9628,
      r: 40,
      fill: "black",
      fillOpacity: 0.08
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.0002 50.9953C33.7648 50.9953 28.7099 45.9404 28.7099 39.705H15.8066V59.0598H64.1937V39.705H51.2905C51.2905 45.9404 46.2356 50.9953 40.0002 50.9953Z",
      fill: "#BCBCBC"
    }), /*#__PURE__*/_jsx("path", {
      d: "M57.5 23.4628H22.5L17 38.9628H28.5V39.4628C28.5 45.8141 33.6487 50.9628 40 50.9628C46.3513 50.9628 51.5 45.8141 51.5 39.4628V38.9628H63.5L57.5 23.4628Z",
      fill: "#888888"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M64.9476 39.4177L58.496 22.4822C58.3767 22.1691 58.0766 21.9628 57.7419 21.9628H22.2581C21.9234 21.9628 21.6233 22.1691 21.504 22.4822L15.0524 39.4177C15.0228 39.5008 15.0071 39.5878 15.0055 39.6756C15.0055 39.6809 15.0041 39.6855 15.0028 39.6902C15.0014 39.6948 15 39.6994 15 39.7047V59.0596C15 59.5049 15.3611 59.866 15.8065 59.866H64.1936C64.6389 59.866 65 59.5049 65 59.0596V39.7047C65 39.6994 64.9986 39.6948 64.9972 39.6902C64.9959 39.6855 64.9945 39.6809 64.9945 39.6756C64.9929 39.5878 64.9772 39.5008 64.9476 39.4177ZM22.8137 23.5757H57.1863L63.0233 38.8983H51.2903C50.845 38.8983 50.4839 39.2594 50.4839 39.7047C50.4839 45.4948 45.7901 50.1886 40 50.1886C34.2099 50.1886 29.5161 45.4948 29.5161 39.7047C29.5161 39.2594 29.155 38.8983 28.7097 38.8983H16.9768L22.8137 23.5757ZM16.6129 40.5112V58.2531H63.3871V40.5112H52.07C51.6479 46.8667 46.3697 51.8058 40 51.8058C33.6303 51.8058 28.3521 46.8667 27.93 40.5112H16.6129Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.6449 55.0265H19.8385V52.6071C19.8385 52.1618 19.4774 51.8007 19.032 51.8007C18.5867 51.8007 18.2256 52.1618 18.2256 52.6071V55.8329C18.2256 56.2783 18.5867 56.6394 19.032 56.6394H20.6449C21.0903 56.6394 21.4514 56.2783 21.4514 55.8329C21.4514 55.3876 21.0903 55.0265 20.6449 55.0265Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25.4838 55.0273H23.8709C23.4255 55.0273 23.0645 55.3883 23.0645 55.8337C23.0645 56.2791 23.4255 56.6402 23.8709 56.6402H25.4838C25.9292 56.6402 26.2903 56.2791 26.2903 55.8337C26.2903 55.3883 25.9292 55.0273 25.4838 55.0273Z",
      fill: "white"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ToastIcon.tsx


function ToastIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ToastIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ToastIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ToastIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ToastIcon_ToastIcon = function ToastIcon(props) {
  return /*#__PURE__*/_jsxs("svg", ToastIcon_objectSpread(ToastIcon_objectSpread({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: 50,
      height: 50,
      fill: "url(#pattern0)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: /*#__PURE__*/_jsx("use", {
          xlinkHref: "#image0_841_26754",
          transform: "scale(0.000833333)"
        })
      }), /*#__PURE__*/_jsx("image", {
        id: "image0_841_26754",
        width: 1200,
        height: 1200,
        xlinkHref: "data:image/png;base64,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"
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/WhiteChev.tsx


function WhiteChev_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WhiteChev_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WhiteChev_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WhiteChev_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var WhiteChev = function WhiteChev(_ref, props) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#fff" : _ref$color;
  return /*#__PURE__*/_jsx("svg", WhiteChev_objectSpread(WhiteChev_objectSpread({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M1 1.0666L4.96642 5L9 1",
      stroke: color
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TMBlueLogo.tsx


function TMBlueLogo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TMBlueLogo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TMBlueLogo_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TMBlueLogo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var TMBlueLogo = function TMBlueLogo(props) {
  return /*#__PURE__*/_jsxs("svg", TMBlueLogo_objectSpread(TMBlueLogo_objectSpread({
    width: 115,
    height: 32,
    viewBox: "0 0 115 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.33961 8.46034V14.6648C5.33961 15.2289 5.52762 15.4169 5.64043 15.4921C5.86605 15.6049 6.12927 15.6801 6.46769 15.6801C6.73091 15.6801 7.52057 15.4545 7.97181 15.2665L8.46064 15.116V17.485L8.27263 17.5978C7.59578 17.9363 6.88132 18.1243 6.12927 18.1243C3.19624 18.1243 2.55699 16.3569 2.55699 14.8528V8.46034H0L5.33961 3.08313V6.01615H8.49825V8.46034H5.33961Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.2979 5.79099V8.42319H16.7338C15.9442 8.42319 15.1921 8.5736 14.4776 8.87442C13.8384 9.17524 13.3496 9.55127 12.9735 10.0401V17.8239H10.2285V6.0166H12.2215L12.7103 7.44551C13.7632 6.35503 15.1169 5.82859 16.6962 5.82859H17.2979V5.79099Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.6215 2.93303C21.6215 3.72269 20.9822 4.36194 20.1926 4.36194C19.4029 4.36194 18.7637 3.72269 18.7637 2.93303C18.7637 2.14337 19.4029 1.50412 20.1926 1.50412C20.9446 1.50412 21.6215 2.14337 21.6215 2.93303Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.5087 6.01645H18.7637V17.899H21.5087V6.01645Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M34.3666 7.44564C33.2385 6.31755 31.9224 5.75351 30.4183 5.75351C28.9142 5.75351 27.4853 6.65598 26.8461 7.14482L26.282 6.01673H24.2891V22.9004H27.0341V16.9216C28.0117 17.7112 29.1398 18.1249 30.3807 18.1249C31.8472 18.1249 33.1257 17.5984 34.2162 16.5455L34.329 16.4327C35.4571 15.3046 36.0212 13.8005 36.0212 11.958C36.0588 10.0778 35.4947 8.57372 34.3666 7.44564ZM30.1175 15.4927C28.9518 15.4927 27.9365 15.0414 27.0341 14.1013V9.77702C27.9365 8.83694 28.9142 8.38571 30.1175 8.38571C31.0952 8.38571 31.8472 8.68653 32.4489 9.28818C33.0505 9.88982 33.3138 10.7923 33.3138 11.9204C33.3138 13.0485 33.0129 13.9509 32.4489 14.5526C31.8472 15.1918 31.0952 15.4927 30.1175 15.4927Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M74.1152 7.48311C73.0247 6.35503 71.5582 5.79099 69.7909 5.79099C68.0235 5.79099 66.557 6.35503 65.4665 7.48311C64.3761 8.6112 63.8496 10.1153 63.8496 11.9203C63.8496 13.7628 64.4137 15.2293 65.4665 16.3574C66.557 17.4855 68.0235 18.0495 69.7909 18.0495C71.5582 18.0495 73.0247 17.4855 74.1152 16.3574C75.2057 15.2293 75.7697 13.7252 75.7697 11.9203C75.7321 10.1153 75.1681 8.6112 74.1152 7.48311ZM69.7909 15.5301C68.926 15.5301 68.1739 15.2293 67.5347 14.6277C66.8954 14.0636 66.557 13.1235 66.557 11.9203C66.557 10.717 66.8954 9.81449 67.4971 9.21285C68.1363 8.6112 68.8884 8.31038 69.7533 8.31038C70.6181 8.31038 71.3702 8.6112 72.0094 9.21285C72.6487 9.77689 72.9495 10.6794 72.9495 11.9203C72.9495 13.1235 72.6111 14.0636 72.0094 14.6277C71.4078 15.2293 70.6557 15.5301 69.7909 15.5301Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M88.4434 10.4161V17.8615H85.6984V10.6418C85.6984 9.06243 85.0591 8.34798 83.6678 8.34798C82.5397 8.34798 81.4869 8.98723 80.4716 10.1905V17.8615H77.7266V6.0166H79.7195L80.246 7.44551C81.4116 6.35503 82.6901 5.79099 84.1566 5.79099C85.4727 5.79099 86.5256 6.24222 87.3153 7.14469C88.0674 8.00955 88.4434 9.13764 88.4434 10.4161Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M100.211 14.4398C99.158 15.1166 98.0299 15.455 96.8266 15.455C95.6233 15.455 94.7208 15.1918 94.1568 14.703C93.6679 14.2894 93.3671 13.7253 93.2167 12.9733H101.565V11.5067C101.489 9.96503 101.038 8.64893 100.173 7.55845C99.2332 6.35516 97.8042 5.75351 95.9993 5.75351C94.1944 5.75351 92.8031 6.35516 91.8254 7.55845C90.8853 8.76174 90.3965 10.2659 90.3965 12.0708C90.3965 13.8757 90.9229 15.3422 92.0134 16.4327C93.0663 17.5232 94.4952 18.0496 96.2625 18.0496C97.9547 18.0496 99.4964 17.6736 100.775 16.9592L100.925 16.9216L100.775 14.1013L100.211 14.4398ZM93.1791 10.6419C93.2919 9.88982 93.5927 9.32578 94.044 8.94975C94.608 8.46092 95.2473 8.2353 95.9617 8.2353C96.6762 8.2353 97.3154 8.46092 97.8795 8.94975C98.3683 9.36338 98.6691 9.92743 98.7443 10.6419H93.1791Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M114.199 6.01648L114.011 6.50532L107.205 22.9002H104.385L106.416 17.6734L101.678 6.01648H104.611L107.882 14.2515L111.266 6.01648H114.199Z",
      fill: "#124680"
    }), /*#__PURE__*/_jsx("path", {
      d: "M38 6.09835C38 2.40238 40.4024 0 44.0983 0H55.9716C59.6676 0 62.07 2.40238 62.07 6.09835V17.9717C62.07 21.6676 59.6676 24.07 55.9716 24.07H44.0983C40.4024 24.07 38 21.6676 38 17.9717V6.09835Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_41_41366",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 38,
      y: 0,
      width: 25,
      height: 25,
      children: /*#__PURE__*/_jsx("path", {
        d: "M38 6.09835C38 2.40238 40.4024 0 44.0983 0H55.9716C59.6676 0 62.07 2.40238 62.07 6.09835V17.9717C62.07 21.6676 59.6676 24.07 55.9716 24.07H44.0983C40.4024 24.07 38 21.6676 38 17.9717V6.09835Z",
        fill: "#ED1C24"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_41_41366)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M54.8275 11.8541C54.595 12.9214 54.3921 15.7951 54.3648 16.4839C54.3375 17.1727 54.5614 17.5955 55.112 17.8681C55.583 18.1013 56.0273 18.0952 56.4557 17.7906C56.6163 17.6764 56.3713 15.8541 56.4557 14.6179C56.631 12.0489 57.8308 8.16922 57.8308 8.16922C57.8533 8.03564 57.8769 7.90226 57.8769 7.79098C57.8769 7.12387 57.5506 6.70142 56.8521 6.63473C56.1306 6.56784 55.7572 6.9017 55.1058 7.65759C53.6611 9.36966 51.9373 11.9272 51.1225 13.1061C51.0299 13.2387 50.8664 13.1947 50.8664 13.0168C50.8664 12.4832 52.8078 6.7918 52.8078 6.7918C52.8078 6.7918 53.0364 6.01202 52.3702 5.74207C52.3702 5.74207 51.37 5.14165 50.5216 6.33194L46.5828 11.4741C46.2736 11.8677 46.1202 11.722 46.1202 11.722C46.024 11.6752 46.086 11.3819 46.086 11.3819L46.7071 8.02987C47.2042 5.45281 46.2572 5.31724 45.6652 5.24119C45.0735 5.16514 44.3631 5.59057 44.3631 5.59057C43.1318 6.18064 42.2027 8.52836 42.2027 8.52836C42.2027 8.52836 41.9244 9.36369 42.5109 9.6858C42.5109 9.6858 42.7338 9.86258 43.1664 9.84745C44.0263 9.81719 44.2052 8.25204 44.8341 8.25204C44.9511 8.25204 44.9511 8.38542 44.9511 8.40772L42.9171 16.5798C42.9171 16.5798 42.684 17.3891 43.4256 17.8221C44.3739 18.3755 44.988 17.4556 44.988 17.4556L45.6992 16.3579C46.7853 14.5415 48.7536 11.9378 48.963 11.9378C49.033 11.9378 49.056 11.9607 49.056 12.0263L48.3606 16.8154C48.3606 16.8154 48.2105 17.6081 48.9448 17.8681C48.9448 17.8681 49.6615 18.108 50.0739 17.7906C50.0739 17.7906 50.5872 17.4586 51.0989 16.6573C51.4934 16.0394 53.4772 13.8103 54.6878 11.765C54.7814 11.6314 54.851 11.7425 54.8275 11.8541Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.5859 30.6083L26.0594 29.3298H24.4425L23.9537 30.6083H23.4648L25.0442 26.5847H25.4578L27.0371 30.6083H26.5859ZM25.9466 28.9161L25.4578 27.6376C25.4578 27.6 25.4202 27.5624 25.4202 27.4872C25.3826 27.412 25.3826 27.3368 25.345 27.2616C25.3074 27.1864 25.3074 27.1112 25.2698 27.0736C25.2698 27.1488 25.2322 27.224 25.1946 27.2992C25.157 27.3744 25.157 27.4496 25.1194 27.4872C25.0818 27.5624 25.0818 27.6 25.0818 27.6376L24.5929 28.9161H25.9466Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.9104 30.6083L29.5567 27.036H29.5191C29.5191 27.1112 29.5191 27.1864 29.5567 27.2992C29.5567 27.412 29.5567 27.5248 29.5567 27.6376C29.5567 27.7504 29.5567 27.9008 29.5567 28.0137V30.5707H29.1055V26.5847H29.8199L31.0984 29.9314H31.136L32.4521 26.5847H33.129V30.6083H32.6777V28.0137C32.6777 27.9008 32.6777 27.788 32.6777 27.6376C32.6777 27.5248 32.6777 27.412 32.6777 27.2992C32.6777 27.1864 32.6777 27.1112 32.6777 27.036H32.6401L31.2488 30.6083H30.9104Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M35.3088 27.5248C35.6848 27.5248 35.948 27.6 36.136 27.7504C36.3241 27.9008 36.3993 28.1641 36.3993 28.5401V30.6082H36.0608L35.9856 30.157H35.948C35.8728 30.2698 35.76 30.345 35.6848 30.4202C35.6096 30.4954 35.4968 30.533 35.3464 30.5706C35.2336 30.6082 35.0832 30.6082 34.8951 30.6082C34.7071 30.6082 34.5567 30.5706 34.4063 30.4954C34.2559 30.4202 34.1431 30.345 34.0679 30.1946C33.9927 30.0818 33.9551 29.8938 33.9551 29.7058C33.9551 29.405 34.0679 29.1793 34.3311 29.0289C34.5567 28.8785 34.9328 28.7657 35.4216 28.7657L35.948 28.7281V28.5401C35.948 28.2769 35.8728 28.0889 35.76 27.976C35.6472 27.8632 35.4968 27.8256 35.2712 27.8256C35.1208 27.8256 34.9704 27.8632 34.8199 27.9008C34.6695 27.9384 34.5567 28.0136 34.4063 28.0513L34.2559 27.7128C34.4063 27.6376 34.5567 27.6 34.7447 27.5248C34.9328 27.5624 35.1208 27.5248 35.3088 27.5248ZM35.9104 29.1041L35.4592 29.1417C35.0832 29.1417 34.8199 29.2169 34.6695 29.3297C34.5191 29.4426 34.4439 29.593 34.4439 29.781C34.4439 29.969 34.4815 30.0818 34.5943 30.157C34.7071 30.2322 34.8575 30.2698 35.008 30.2698C35.2712 30.2698 35.4968 30.1946 35.6848 30.0442C35.8728 29.8938 35.948 29.6682 35.948 29.3674V29.1041H35.9104Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M37.7911 26.3218V28.5404C37.7911 28.6156 37.7911 28.6908 37.7911 28.8036C37.7911 28.9164 37.7911 28.9916 37.7911 29.0668H37.8287C37.8663 29.0292 37.9415 28.954 38.0167 28.8412C38.0919 28.766 38.1671 28.6908 38.2047 28.6156L39.22 27.5627H39.7464L38.5055 28.8412L39.8216 30.5709H39.2576L38.1671 29.142L37.7911 29.4804V30.5709H37.3398V26.3218H37.7911Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.5134 27.5248C41.7766 27.5248 42.0022 27.6 42.1902 27.7128C42.3782 27.8256 42.5286 27.976 42.6038 28.2017C42.7167 28.3897 42.7543 28.6529 42.7543 28.9161V29.2169H40.6485C40.6485 29.5554 40.7613 29.8562 40.9117 30.0442C41.0997 30.2322 41.3254 30.3074 41.6262 30.3074C41.8142 30.3074 42.0022 30.3074 42.1526 30.2698C42.303 30.2322 42.4534 30.1946 42.6038 30.1194V30.4578C42.4534 30.533 42.303 30.5706 42.1526 30.6082C42.0022 30.6459 41.8142 30.6458 41.6262 30.6458C41.3254 30.6458 41.0621 30.5706 40.8741 30.4578C40.6485 30.345 40.4981 30.157 40.3853 29.9314C40.2725 29.7058 40.1973 29.405 40.1973 29.1041C40.1973 28.7657 40.2349 28.5025 40.3477 28.2769C40.4605 28.0513 40.6109 27.8632 40.7989 27.7128C40.9869 27.6 41.2125 27.5248 41.5134 27.5248ZM41.4758 27.9008C41.2125 27.9008 41.0245 27.976 40.8741 28.1265C40.7237 28.2769 40.6485 28.5025 40.6109 28.8033H42.2278C42.2278 28.6153 42.1902 28.4649 42.1526 28.3145C42.115 28.1641 42.0022 28.0889 41.8894 28.0136C41.8142 27.9384 41.6638 27.9008 41.4758 27.9008Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M45.387 30.6083L44.0333 27.036H43.9957C43.9957 27.1112 43.9957 27.1864 44.0333 27.2992C44.0333 27.412 44.0333 27.5248 44.0333 27.6376C44.0333 27.7504 44.0333 27.9008 44.0333 28.0137V30.5707H43.582V26.5847H44.2965L45.575 29.9314H45.6126L46.9287 26.5847H47.6055V30.6083H47.1543V28.0137C47.1543 27.9008 47.1543 27.788 47.1543 27.6376C47.1543 27.5248 47.1543 27.412 47.1543 27.2992C47.1543 27.1864 47.1543 27.1112 47.1543 27.036L45.763 30.6083H45.387Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M48.168 27.6005H48.6568L49.3337 29.3678C49.3713 29.4806 49.4089 29.5558 49.4465 29.6686C49.4841 29.7438 49.5217 29.8566 49.5217 29.9318C49.5217 30.007 49.5593 30.1199 49.5969 30.1951H49.6345C49.6721 30.1199 49.7097 29.9694 49.7473 29.819C49.7849 29.6686 49.8601 29.5182 49.8977 29.3678L50.537 27.6381H51.0258L49.7097 31.0975C49.6345 31.2855 49.5593 31.436 49.4465 31.5864C49.3713 31.7368 49.2585 31.812 49.108 31.8872C48.9576 31.9624 48.8072 32 48.6192 32C48.544 32 48.4688 32 48.3936 32C48.3184 32 48.2808 31.9624 48.2056 31.9624V31.5864C48.2432 31.5864 48.2808 31.5864 48.356 31.624C48.4312 31.624 48.4688 31.624 48.544 31.624C48.6568 31.624 48.7696 31.5864 48.8448 31.5488C48.92 31.5112 48.9952 31.436 49.0704 31.3608C49.1456 31.2855 49.1832 31.1727 49.2209 31.0599L49.3713 30.6463L48.168 27.6005Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M52.8318 30.6083H52.343V26.9984H51.0645V26.5847H54.1103V26.9984H52.8318V30.6083Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M56.028 27.5248C56.1032 27.5248 56.1408 27.5248 56.216 27.5248C56.2912 27.5248 56.3289 27.5248 56.4041 27.5624L56.3288 27.976C56.2912 27.976 56.216 27.9384 56.1784 27.9384C56.1032 27.9384 56.0656 27.9384 55.9904 27.9384C55.8776 27.9384 55.7648 27.976 55.652 28.0136C55.5392 28.0513 55.464 28.1265 55.3512 28.2393C55.276 28.3145 55.2008 28.4273 55.1632 28.5777C55.1256 28.6905 55.088 28.8409 55.088 28.9913V30.6082H54.6367V27.6H55.0127L55.0504 28.1641H55.088C55.1632 28.0513 55.2384 27.9384 55.3136 27.8632C55.3888 27.788 55.5016 27.7128 55.6144 27.6376C55.7648 27.5624 55.8776 27.5248 56.028 27.5248Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M57.4205 27.6005V30.6087H56.9692V27.6005H57.4205ZM57.1949 26.4724C57.2701 26.4724 57.3453 26.51 57.3829 26.5476C57.4205 26.5852 57.4581 26.6604 57.4581 26.7732C57.4581 26.886 57.4205 26.9612 57.3829 26.9988C57.3453 27.0364 57.2701 27.074 57.1949 27.074C57.1197 27.074 57.0444 27.0364 57.0068 26.9988C56.9692 26.9612 56.9316 26.886 56.9316 26.7732C56.9316 26.6604 56.9692 26.5852 57.0068 26.5476C57.0821 26.4724 57.1197 26.4724 57.1949 26.4724Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M59.8645 27.5248C60.2405 27.5248 60.5413 27.6376 60.7669 27.9009C60.9925 28.1641 61.1054 28.5401 61.1054 29.0666C61.1054 29.405 61.0677 29.7058 60.9549 29.9314C60.8421 30.157 60.6917 30.3451 60.5037 30.4579C60.3157 30.5707 60.0901 30.6459 59.8269 30.6459C59.6764 30.6459 59.526 30.6083 59.4132 30.5707C59.3004 30.5331 59.1876 30.4579 59.1124 30.3827C59.0372 30.3075 58.962 30.2322 58.8868 30.157H58.8492C58.8492 30.2322 58.8492 30.3075 58.8868 30.4203C58.8868 30.5331 58.8868 30.6083 58.8868 30.6835V31.962H58.4355V27.6H58.8116L58.8868 28.0513H58.9244C58.9996 27.9761 59.0372 27.8633 59.15 27.7881C59.2252 27.7129 59.338 27.6377 59.4508 27.6C59.526 27.5624 59.6764 27.5248 59.8645 27.5248ZM59.7516 27.9009C59.526 27.9009 59.3756 27.9385 59.2252 28.0137C59.1124 28.0889 58.9996 28.2017 58.962 28.3897C58.8868 28.5401 58.8868 28.7657 58.8492 28.9914V29.0666C58.8492 29.3298 58.8868 29.5554 58.9244 29.7058C58.9996 29.8938 59.0748 30.0066 59.1876 30.1194C59.338 30.1946 59.4884 30.2699 59.714 30.2699C59.9021 30.2699 60.0525 30.2322 60.2029 30.1194C60.3157 30.0066 60.4285 29.8938 60.4661 29.7058C60.5413 29.5178 60.5789 29.3298 60.5789 29.0666C60.5789 28.7281 60.5037 28.4273 60.3533 28.2017C60.2781 28.0137 60.0525 27.9009 59.7516 27.9009Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M65.2053 28.5028H66.6343V30.4581C66.4086 30.5333 66.183 30.5709 65.9574 30.6085C65.7318 30.6461 65.4686 30.6461 65.2053 30.6461C64.7917 30.6461 64.4157 30.5709 64.1525 30.3829C63.8516 30.2325 63.626 29.9693 63.4756 29.6685C63.3252 29.3676 63.25 28.9916 63.25 28.578C63.25 28.1644 63.3252 27.7883 63.5132 27.4875C63.6636 27.1867 63.9268 26.9235 64.2277 26.773C64.5285 26.585 64.9045 26.5098 65.3558 26.5098C65.5814 26.5098 65.807 26.5474 65.995 26.585C66.183 26.6226 66.371 26.6978 66.5591 26.773L66.371 27.1867C66.2206 27.1115 66.0702 27.0739 65.8822 27.0363C65.6942 26.9987 65.5062 26.9611 65.3182 26.9611C64.9797 26.9611 64.7165 27.0363 64.4533 27.1491C64.2277 27.2995 64.0397 27.4875 63.9269 27.7131C63.814 27.9763 63.7388 28.2396 63.7388 28.578C63.7388 28.9164 63.7764 29.2172 63.8892 29.4429C64.0021 29.7061 64.1525 29.8941 64.4157 30.0069C64.6413 30.1573 64.9421 30.1949 65.3182 30.1949C65.5062 30.1949 65.6566 30.1949 65.807 30.1573C65.9574 30.1197 66.0702 30.1197 66.183 30.0821V28.8412H65.2053V28.5028Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M68.9245 27.5248C68.9997 27.5248 69.0373 27.5248 69.1125 27.5248C69.1877 27.5248 69.2253 27.5248 69.3005 27.5624L69.2253 27.9761C69.1877 27.9761 69.1125 27.9385 69.0749 27.9385C68.9997 27.9385 68.9621 27.9385 68.8869 27.9385C68.7741 27.9385 68.6613 27.9761 68.5485 28.0137C68.4357 28.0513 68.3605 28.1265 68.2477 28.2393C68.1725 28.3145 68.0972 28.4273 68.0596 28.5777C68.022 28.6905 67.9844 28.8409 67.9844 28.9914V30.6083H67.5332V27.6H67.9092L67.9468 28.1641H67.9844C68.0596 28.0513 68.1349 27.9385 68.2101 27.8633C68.2853 27.7881 68.3981 27.7129 68.5109 27.6377C68.6237 27.5624 68.7741 27.5248 68.9245 27.5248Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M72.5004 29.1047C72.5004 29.368 72.4628 29.556 72.3876 29.7816C72.3124 29.9696 72.2372 30.1576 72.1244 30.2704C72.0116 30.4208 71.8611 30.496 71.6731 30.5712C71.4851 30.6465 71.2971 30.6841 71.0715 30.6841C70.8835 30.6841 70.6955 30.6465 70.5074 30.5712C70.357 30.496 70.2066 30.3832 70.0562 30.2704C69.9434 30.12 69.8306 29.9696 69.7554 29.7816C69.6802 29.5936 69.6426 29.368 69.6426 29.1047C69.6426 28.7663 69.7178 28.5031 69.8306 28.2775C69.9434 28.0519 70.0938 27.8638 70.3194 27.751C70.545 27.6382 70.7707 27.563 71.0715 27.563C71.3347 27.563 71.5979 27.6382 71.7859 27.751C72.0116 27.8638 72.162 28.0519 72.2748 28.2775C72.4252 28.4655 72.5004 28.7663 72.5004 29.1047ZM70.169 29.1047C70.169 29.3304 70.2066 29.556 70.2818 29.744C70.357 29.932 70.4322 30.0448 70.5826 30.1576C70.7331 30.2704 70.8835 30.308 71.1091 30.308C71.3347 30.308 71.4851 30.2704 71.6355 30.1576C71.7859 30.0448 71.8611 29.932 71.9363 29.744C72.0116 29.556 72.0492 29.368 72.0492 29.1047C72.0492 28.8791 72.0116 28.6535 71.9363 28.4655C71.8611 28.2775 71.7859 28.1647 71.6355 28.0519C71.4851 27.939 71.3347 27.9014 71.1091 27.9014C70.8083 27.9014 70.545 28.0143 70.3946 28.2023C70.2442 28.4279 70.169 28.7287 70.169 29.1047Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M75.807 27.6V30.6083H75.431L75.3558 30.1946C75.2806 30.3075 75.2054 30.3827 75.0925 30.4579C74.9797 30.5331 74.8669 30.5707 74.7541 30.6083C74.6413 30.6459 74.4909 30.6459 74.3405 30.6459C74.1149 30.6459 73.8892 30.6083 73.7388 30.5331C73.5884 30.4579 73.438 30.3451 73.3628 30.157C73.2876 30.0066 73.25 29.781 73.25 29.5178V27.5248H73.7012V29.4802C73.7012 29.7434 73.7764 29.9314 73.8893 30.0442C74.0021 30.157 74.1901 30.2322 74.4157 30.2322C74.6413 30.2322 74.8293 30.1946 74.9421 30.1194C75.0925 30.0442 75.1677 29.8938 75.243 29.7434C75.3182 29.593 75.3182 29.3674 75.3182 29.1418V27.5624H75.807V27.6Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M78.216 27.5248C78.592 27.5248 78.8929 27.6376 79.1185 27.9009C79.3441 28.1641 79.4569 28.5401 79.4569 29.0666C79.4569 29.405 79.4193 29.7058 79.3065 29.9314C79.1937 30.157 79.0433 30.3451 78.8553 30.4579C78.6673 30.5707 78.4416 30.6459 78.1784 30.6459C78.028 30.6459 77.8776 30.6083 77.7648 30.5707C77.652 30.5331 77.5392 30.4579 77.464 30.3827C77.3888 30.3075 77.3135 30.2322 77.2383 30.157H77.2007C77.2007 30.2322 77.2007 30.3075 77.2383 30.4203C77.2383 30.5331 77.2383 30.6083 77.2383 30.6835V31.962H76.7871V27.6H77.1631L77.2383 28.0513H77.2759C77.3512 27.9761 77.3888 27.8633 77.5016 27.7881C77.5768 27.7129 77.6896 27.6377 77.8024 27.6C77.9152 27.5624 78.0656 27.5248 78.216 27.5248ZM78.1408 27.9009C77.9152 27.9009 77.7648 27.9385 77.6144 28.0137C77.5016 28.0889 77.3888 28.2017 77.3512 28.3897C77.2759 28.5401 77.2759 28.7657 77.2383 28.9914V29.0666C77.2383 29.3298 77.2759 29.5554 77.3135 29.7058C77.3888 29.8938 77.464 30.0066 77.5768 30.1194C77.7272 30.1946 77.8776 30.2699 78.1032 30.2699C78.2912 30.2699 78.4416 30.2322 78.592 30.1194C78.7049 30.0066 78.8177 29.8938 78.8553 29.7058C78.9305 29.5178 78.9681 29.3298 78.9681 29.0666C78.9681 28.7281 78.8929 28.4273 78.7425 28.2017C78.6296 28.0137 78.4416 27.9009 78.1408 27.9009Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M83.5525 26.9235C83.3269 26.9235 83.1389 26.9611 82.9509 27.0363C82.7629 27.1115 82.6124 27.2243 82.4996 27.3747C82.3868 27.5251 82.274 27.6755 82.1988 27.9011C82.1236 28.0891 82.086 28.3524 82.086 28.578C82.086 28.9164 82.1236 29.2172 82.2364 29.4429C82.3492 29.7061 82.4996 29.8941 82.7253 30.0069C82.9509 30.1573 83.2141 30.1949 83.5149 30.1949C83.7029 30.1949 83.8533 30.1949 84.0414 30.1573C84.1918 30.1197 84.3422 30.0821 84.5302 30.0445V30.4581C84.3798 30.4957 84.2294 30.5709 84.079 30.5709C83.9285 30.6085 83.7405 30.6085 83.5149 30.6085C83.1013 30.6085 82.7629 30.5333 82.462 30.3453C82.1988 30.1573 81.9732 29.9317 81.8228 29.6309C81.6724 29.33 81.6348 28.954 81.6348 28.5404C81.6348 28.2396 81.6724 27.9763 81.7476 27.7131C81.8228 27.4499 81.9732 27.2243 82.1236 27.0739C82.274 26.8859 82.4996 26.7354 82.7253 26.6602C82.9509 26.5474 83.2517 26.5098 83.5525 26.5098C83.7405 26.5098 83.9661 26.5474 84.1542 26.585C84.3422 26.6226 84.5302 26.6978 84.6806 26.773L84.4926 27.1867C84.3798 27.1115 84.2294 27.0739 84.079 27.0363C83.8909 26.9611 83.7405 26.9235 83.5525 26.9235Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M87.9906 29.1047C87.9906 29.368 87.953 29.556 87.8778 29.7816C87.8026 29.9696 87.7274 30.1576 87.6146 30.2704C87.5018 30.4208 87.3514 30.496 87.1634 30.5712C86.9754 30.6465 86.7873 30.6841 86.5617 30.6841C86.3737 30.6841 86.1857 30.6465 85.9977 30.5712C85.8473 30.496 85.6969 30.3832 85.5464 30.2704C85.4336 30.12 85.3208 29.9696 85.2456 29.7816C85.1704 29.5936 85.1328 29.368 85.1328 29.1047C85.1328 28.7663 85.208 28.5031 85.3208 28.2775C85.4336 28.0519 85.584 27.8638 85.8097 27.751C86.0353 27.6382 86.2609 27.563 86.5617 27.563C86.8249 27.563 87.0882 27.6382 87.2762 27.751C87.5018 27.8638 87.6522 28.0519 87.765 28.2775C87.9154 28.4655 87.9906 28.7663 87.9906 29.1047ZM85.6593 29.1047C85.6593 29.3304 85.6969 29.556 85.7721 29.744C85.8473 29.932 85.9225 30.0448 86.0729 30.1576C86.2233 30.2704 86.3737 30.308 86.5993 30.308C86.8249 30.308 86.9754 30.2704 87.1258 30.1576C87.2762 30.0448 87.3514 29.932 87.4266 29.744C87.5018 29.556 87.5394 29.368 87.5394 29.1047C87.5394 28.8791 87.5018 28.6535 87.4266 28.4655C87.3514 28.2775 87.2762 28.1647 87.1258 28.0519C86.9754 27.939 86.8249 27.9014 86.5993 27.9014C86.2985 27.9014 86.0353 28.0143 85.8849 28.2023C85.7345 28.4279 85.6593 28.7287 85.6593 29.1047Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M92.0918 27.5248C92.4302 27.5248 92.6934 27.6 92.8438 27.7881C93.0318 27.9761 93.107 28.2393 93.107 28.6153V30.6083H92.6558V28.6529C92.6558 28.4273 92.6182 28.2393 92.5054 28.0889C92.3926 27.9761 92.2422 27.9009 92.0166 27.9009C91.7157 27.9009 91.4901 27.9761 91.3773 28.1641C91.2269 28.3145 91.1893 28.5777 91.1893 28.9161V30.6083H90.7381V28.6529C90.7381 28.5025 90.7005 28.3521 90.6629 28.2393C90.6252 28.1265 90.55 28.0513 90.4372 28.0137C90.362 27.9761 90.2116 27.9385 90.0988 27.9385C89.9108 27.9385 89.7228 27.9761 89.61 28.0513C89.4972 28.1265 89.3844 28.2393 89.3468 28.4273C89.3091 28.5777 89.2715 28.8033 89.2715 29.029V30.6083H88.8203V27.6H89.1963L89.2715 28.0137H89.3092C89.3844 27.9009 89.4596 27.8257 89.5348 27.7505C89.61 27.6753 89.7228 27.6377 89.8356 27.6C89.9484 27.5624 90.0612 27.5624 90.2116 27.5624C90.4372 27.5624 90.6252 27.6 90.7757 27.6753C90.9261 27.7505 91.0389 27.9009 91.1141 28.0513H91.1517C91.2645 27.8633 91.3773 27.7505 91.5653 27.6753C91.6781 27.5624 91.8661 27.5248 92.0918 27.5248Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M95.4719 27.5248C95.8479 27.5248 96.1487 27.6376 96.3743 27.9008C96.6 28.1641 96.7128 28.5401 96.7128 29.0665C96.7128 29.405 96.6752 29.7058 96.5624 29.9314C96.4496 30.157 96.2991 30.345 96.1111 30.4578C95.9231 30.5706 95.6975 30.6458 95.4343 30.6458C95.2839 30.6458 95.1335 30.6082 95.0206 30.5706C94.9078 30.533 94.795 30.4578 94.7198 30.3826C94.6446 30.3074 94.5694 30.2322 94.4942 30.157H94.4566C94.4566 30.2322 94.4566 30.3074 94.4942 30.4202C94.4942 30.533 94.4942 30.6082 94.4942 30.6835V31.962H94.043V27.6H94.419L94.4942 28.0513H94.5318C94.607 27.976 94.6822 27.8632 94.7574 27.788C94.8326 27.7128 94.9454 27.6376 95.0582 27.6C95.1711 27.5624 95.3215 27.5248 95.4719 27.5248ZM95.3967 27.9008C95.1711 27.9008 95.0206 27.9384 94.8702 28.0136C94.7574 28.0889 94.6446 28.2017 94.607 28.3897C94.5318 28.5401 94.5318 28.7657 94.4942 28.9913V29.0665C94.4942 29.3298 94.5318 29.5554 94.5694 29.7058C94.6446 29.8938 94.7198 30.0066 94.8326 30.1194C94.983 30.1946 95.1335 30.2698 95.3591 30.2698C95.5471 30.2698 95.6975 30.2322 95.8479 30.1194C95.9607 30.0066 96.0735 29.8938 96.1111 29.7058C96.1863 29.5178 96.2239 29.3298 96.2239 29.0665C96.2239 28.7281 96.1487 28.4273 95.9983 28.2017C95.8855 28.0136 95.6975 27.9008 95.3967 27.9008Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M98.6701 27.5248C99.0461 27.5248 99.3094 27.6 99.4974 27.7505C99.6854 27.9009 99.7606 28.1641 99.7606 28.5401V30.6083H99.4222L99.347 30.157H99.3094C99.2342 30.2699 99.1213 30.3451 99.0461 30.4203C98.9709 30.4955 98.8581 30.5331 98.7077 30.5707C98.5949 30.6083 98.4445 30.6083 98.2565 30.6083C98.0685 30.6083 97.9181 30.5707 97.7676 30.4955C97.6172 30.4203 97.5044 30.3451 97.4292 30.1946C97.354 30.0818 97.3164 29.8938 97.3164 29.7058C97.3164 29.405 97.4292 29.1794 97.6924 29.029C97.9181 28.8785 98.2941 28.7657 98.7829 28.7657L99.3094 28.7281V28.5401C99.3094 28.2769 99.2718 28.0889 99.1213 27.9761C99.0085 27.8633 98.8581 27.8257 98.6325 27.8257C98.4821 27.8257 98.3317 27.8633 98.1813 27.9009C98.0309 27.9385 97.8805 28.0137 97.7676 28.0513L97.6172 27.7129C97.7676 27.6376 97.9181 27.6 98.1061 27.5248C98.2941 27.5624 98.4821 27.5248 98.6701 27.5248ZM99.3094 29.1042L98.8581 29.1418C98.4821 29.1418 98.2189 29.217 98.0685 29.3298C97.9181 29.4426 97.8428 29.593 97.8428 29.781C97.8428 29.969 97.8805 30.0818 97.9933 30.157C98.1061 30.2322 98.2565 30.2699 98.4069 30.2699C98.6701 30.2699 98.8957 30.1946 99.0837 30.0442C99.2718 29.8938 99.347 29.6682 99.347 29.3674V29.1042H99.3094Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M102.13 27.5248C102.506 27.5248 102.769 27.6 102.957 27.7881C103.145 27.9761 103.22 28.2393 103.22 28.6153V30.5707H102.806V28.6529C102.806 28.3897 102.731 28.2017 102.618 28.0889C102.506 27.9761 102.318 27.9009 102.092 27.9009C101.754 27.9009 101.528 28.0137 101.378 28.2017C101.227 28.3897 101.19 28.6529 101.19 29.029V30.6083H100.738V27.6H101.114L101.19 28.0513H101.227C101.302 27.9385 101.378 27.8633 101.49 27.7881C101.603 27.7129 101.716 27.6753 101.829 27.6377C101.866 27.5624 102.017 27.5248 102.13 27.5248Z",
      fill: "#4A4A4A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M103.709 27.6005H104.198L104.875 29.3678C104.912 29.4806 104.95 29.5558 104.987 29.6686C105.025 29.7438 105.063 29.8566 105.063 29.9318C105.063 30.007 105.1 30.1199 105.138 30.1951H105.175C105.213 30.1199 105.251 29.9694 105.288 29.819C105.326 29.6686 105.401 29.5182 105.439 29.3678L106.078 27.6381H106.567L105.251 31.0975C105.175 31.2855 105.1 31.436 104.987 31.5864C104.912 31.7368 104.799 31.812 104.649 31.8872C104.499 31.9624 104.348 32 104.16 32C104.085 32 104.01 32 103.935 32C103.859 32 103.822 31.9624 103.747 31.9624V31.5864C103.784 31.5864 103.822 31.5864 103.897 31.624C103.972 31.624 104.01 31.624 104.085 31.624C104.198 31.624 104.311 31.5864 104.386 31.5488C104.461 31.5112 104.536 31.436 104.611 31.3608C104.687 31.2855 104.724 31.1727 104.762 31.0599L104.912 30.6463L103.709 27.6005Z",
      fill: "#4A4A4A"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BackIcon.tsx


var BackIcon_excluded = (/* unused pure expression or super */ null && (["color", "cursor"]));

function BackIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BackIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BackIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BackIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var BackIcon_BackIcon = function BackIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#808080" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = _objectWithoutProperties(_ref, BackIcon_excluded);

  return /*#__PURE__*/_jsx("svg", BackIcon_objectSpread(BackIcon_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      cursor: cursor
    }
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z",
      fill: color
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/GreenThumb.tsx


function GreenThumb_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GreenThumb_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GreenThumb_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GreenThumb_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var GreenThumb = function GreenThumb(_ref, props) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 68 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 68 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#B8F5E0" : _ref$color,
      _ref$strokeColor = _ref.strokeColor,
      strokeColor = _ref$strokeColor === void 0 ? "#2B825E" : _ref$strokeColor;
  return /*#__PURE__*/_jsxs("svg", GreenThumb_objectSpread(GreenThumb_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      opacity: 0.9,
      children: /*#__PURE__*/_jsx("circle", {
        cx: 34,
        cy: 34,
        r: 34,
        fill: color
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.9941 41.7929C26.9114 38.6018 26.7641 35.7716 26.6576 32.4186C26.6341 31.6768 26.4559 30.8953 26.5125 30.1551C26.5311 29.9116 26.6406 29.838 26.8678 29.8269C27.3625 29.8027 27.8573 29.768 28.3499 29.7177C29.2948 29.6211 29.9473 29.0633 30.4908 28.338C30.9359 27.7443 31.3279 27.0957 31.849 26.5774C32.7661 25.6656 33.7474 24.8157 34.7322 23.9753C35.7546 23.1026 36.8145 22.2754 37.5771 21.1426C38.1292 20.3225 38.395 19.4154 38.458 18.4396C38.4616 18.3826 38.4621 18.3253 38.464 18.2681C38.499 17.2409 38.923 16.7623 39.9539 16.6439C40.3108 16.6027 40.6799 16.6116 41.0378 16.6497C41.7315 16.7237 42.1872 17.1822 42.5548 17.7171C43.2321 18.7027 43.4639 19.8199 43.4117 20.9969C43.3307 22.8296 42.5845 24.3854 41.41 25.7702C40.9072 26.363 40.0648 27.5005 39.9939 27.6268C39.9231 27.7531 40.3041 27.7184 40.4401 27.7184C41.4893 27.7183 42.5405 27.6758 43.587 27.7291C44.5062 27.7759 45.4543 27.8099 46.3293 28.06C48.4391 28.6633 48.6169 30.9703 47.448 32.0797C47.2063 32.3091 46.9738 32.5483 46.7509 32.7693C46.5281 32.9903 47.4702 33.4524 47.7787 33.8427C48.4975 34.7517 48.3243 36.0824 47.4152 36.7991C47.0505 37.0866 46.6633 37.3454 46.2576 37.6378C45.8519 37.9303 47.2453 39.2953 46.9276 40.3103C46.5921 41.3814 45.7304 41.7705 44.6845 41.9156C43.6386 42.0606 45.497 43.5138 45.2821 44.1136C45.1757 44.4109 44.1464 44.8917 43.7459 45.0692C43.6406 45.1159 43.5322 45.1506 43.4195 45.1745C42.8085 45.3038 40.679 45.7234 39.469 45.5627C38.1811 45.3917 36.9022 45.1123 35.6408 44.7957C34.0333 44.392 32.4168 44.0987 30.7578 44.1533C29.7504 44.1866 29.1871 44.2321 28.095 44.3186C27.0029 44.4051 27.0382 43.495 26.9941 41.7929Z",
      fill: "white",
      stroke: strokeColor,
      strokeWidth: 2
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.7244 30.4868C16.789 32.41 17.1503 41.5624 17.2702 44.5907C17.2917 45.1356 17.7457 45.5566 18.2909 45.5446L22.1877 45.4595C22.7478 45.4473 23.1888 44.9839 23.1647 44.4242C23.032 41.3451 22.6293 32.2028 22.4542 30.4868C22.2428 28.4163 16.6468 28.174 16.7244 30.4868Z",
      fill: "#B8F5E0",
      stroke: strokeColor,
      strokeWidth: 2
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 59.4264,
      cy: 38.419,
      rx: 2.42616,
      ry: 2.42089,
      transform: "rotate(180 59.4264 38.419)",
      fill: "#2B825E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 16.9409,
      cy: 14.9344,
      rx: 1.94093,
      ry: 1.93671,
      transform: "rotate(180 16.9409 14.9344)",
      fill: "#2B825E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 32.469,
      cy: 55.6078,
      rx: 0.970464,
      ry: 0.968354,
      transform: "rotate(180 32.469 55.6078)",
      fill: "#2B825E"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 22.9409,
      cy: 58.9383,
      rx: 1.94093,
      ry: 1.93671,
      transform: "rotate(180 22.9409 58.9383)",
      fill: "#2B825E"
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ChevronDownIcon.tsx


function ChevronDownIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevronDownIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevronDownIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevronDownIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ChevronDownIcon_ChevronDownIcon = function ChevronDownIcon(props) {
  return /*#__PURE__*/_jsx("svg", ChevronDownIcon_objectSpread(ChevronDownIcon_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.8583 13.3941C11.9364 13.4722 12.063 13.4722 12.1411 13.3941L16.2423 9.29289C16.6329 8.90237 17.266 8.90237 17.6566 9.29289C18.0471 9.68342 18.0471 10.3166 17.6566 10.7071L12.7068 15.6569C12.3163 16.0474 11.6831 16.0474 11.2926 15.6569L6.34285 10.7071C5.95232 10.3166 5.95232 9.68342 6.34285 9.29289C6.73337 8.90237 7.36654 8.90237 7.75706 9.29289L11.8583 13.3941Z",
      fill: "#008CFF"
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/Confetti.tsx


function Confetti_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Confetti_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Confetti_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Confetti_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Confetti_Confetti = function Confetti(props) {
  return /*#__PURE__*/_jsxs("svg", Confetti_objectSpread(Confetti_objectSpread({
    width: 279,
    height: 186,
    viewBox: "0 0 279 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("ellipse", {
      cx: 167.047,
      cy: 57.6006,
      rx: 4.08312,
      ry: 4.14746,
      fill: "#052F11"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 96.0929,
      cy: 58.9172,
      rx: 2.05284,
      ry: 2.08519,
      fill: "#052F11"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 184.522,
      cy: 91.1717,
      rx: 2.47839,
      ry: 2.51745,
      fill: "#052F11"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: 86.4608,
      cy: 118.832,
      rx: 2.47839,
      ry: 2.51745,
      fill: "#052F11"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M141.11 65.0256C145.431 60.2392 153.37 63.527 153.041 69.9673C152.834 74.0228 156.179 77.368 160.234 77.1611C166.674 76.8318 169.963 84.7706 165.176 89.0914C162.162 91.8129 162.162 96.5429 165.176 99.2645C169.963 103.586 166.674 111.524 160.234 111.196C156.179 110.988 152.834 114.333 153.041 118.389C153.37 124.829 145.431 128.117 141.11 123.33C138.389 120.316 133.659 120.316 130.937 123.33C126.615 128.117 118.678 124.829 119.006 118.389C119.214 114.333 115.869 110.988 111.813 111.196C105.373 111.524 102.085 103.586 106.871 99.2645C109.885 96.5429 109.885 91.8129 106.871 89.0914C102.085 84.7706 105.373 76.8318 111.813 77.1611C115.869 77.368 119.214 74.0228 119.006 69.9673C118.678 63.527 126.615 60.2392 130.937 65.0256C133.659 68.0397 138.389 68.0397 141.11 65.0256Z",
      fill: "url(#paint0_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M141.11 65.0256V65.0256C145.431 60.2392 153.37 63.527 153.041 69.9673C152.834 74.0228 156.179 77.368 160.234 77.1611C166.674 76.8318 169.963 84.7706 165.176 89.0914C162.162 91.8129 162.162 96.5429 165.176 99.2645C169.963 103.586 166.674 111.524 160.234 111.196C156.179 110.988 152.834 114.333 153.041 118.389C153.37 124.829 145.431 128.117 141.11 123.33C138.389 120.316 133.659 120.316 130.937 123.33C126.615 128.117 118.678 124.829 119.006 118.389C119.214 114.333 115.869 110.988 111.813 111.196C105.373 111.524 102.085 103.586 106.871 99.2645C109.885 96.5429 109.885 91.8129 106.871 89.0914C102.085 84.7706 105.373 76.8318 111.813 77.1611C115.869 77.368 119.214 74.0228 119.006 69.9673C118.678 63.527 126.615 60.2392 130.937 65.0256C133.659 68.0397 138.389 68.0397 141.11 65.0256",
      stroke: "#052F11",
      strokeWidth: 3.84498
    }), /*#__PURE__*/_jsx("path", {
      d: "M121.699 95.1193L130.32 103.74L150.435 83.625",
      stroke: "#052F11",
      strokeWidth: 3.84498,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M219.806 11.7625C218.876 11.3514 217.919 11.0267 216.958 10.732C216.001 10.4355 215.032 10.1728 214.055 9.99866C214.179 10.0222 212.729 9.78728 212.793 9.99213C213.88 13.3471 212.352 17.234 210.728 19.8914C209.808 21.3937 208.602 22.5861 207.244 23.4084C206.661 23.7611 206.025 23.9713 205.392 24.1349C205.097 24.212 204.793 24.2482 204.489 24.2843C204.381 24.2979 204.272 24.295 204.161 24.2989C204.015 24.2635 203.873 24.2262 203.727 24.1909C203.129 24.0503 202.418 23.8357 201.797 23.9205C201.257 23.9935 202.173 24.4619 202.13 24.4381C202.896 24.8565 203.711 25.1323 204.516 25.4188C208.78 26.9319 213.235 28.1374 217.038 24.633C219.699 22.1824 222.277 16.6621 220.922 12.4817C220.801 12.0964 220.024 11.8579 219.804 11.7577L219.806 11.7625Z",
      fill: "url(#paint1_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M250.565 59.0618C250.927 59.222 251.3 59.3486 251.675 59.4635C252.048 59.579 252.425 59.6814 252.806 59.7493C252.758 59.7401 253.323 59.8317 253.298 59.7518C252.874 58.4442 253.47 56.9293 254.103 55.8935C254.462 55.308 254.932 54.8432 255.461 54.5227C255.688 54.3852 255.936 54.3033 256.183 54.2396C256.298 54.2095 256.416 54.1954 256.534 54.1813C256.577 54.176 256.619 54.1772 256.662 54.1757C256.719 54.1894 256.775 54.204 256.832 54.2178C257.065 54.2726 257.342 54.3562 257.584 54.3231C257.794 54.2947 257.437 54.1121 257.454 54.1214C257.156 53.9583 256.838 53.8508 256.524 53.7392C254.862 53.1494 253.126 52.6796 251.644 54.0455C250.606 55.0006 249.602 57.1522 250.13 58.7815C250.177 58.9317 250.48 59.0246 250.566 59.0637L250.565 59.0618Z",
      fill: "url(#paint2_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M214.489 103.654C215.178 106.788 215.864 109.923 216.553 113.057C216.475 112.707 220.813 110.797 220.718 110.365C220.029 107.231 219.344 104.096 218.655 100.962C218.733 101.312 214.394 103.222 214.489 103.654Z",
      fill: "url(#paint3_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M173.185 65.741C175.847 66.2212 178.509 66.7015 181.171 67.1817C180.875 67.1294 181.221 61.194 180.855 61.1314C178.193 60.6512 175.531 60.171 172.869 59.6907C173.165 59.743 172.819 65.6784 173.185 65.741Z",
      fill: "url(#paint4_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M59.1576 118.613C59.383 118.672 60.8262 115.349 60.9577 115.094C61.0742 114.862 62.5512 111.49 62.6988 111.53C59.7428 110.8 57.1597 109.105 54.9999 106.478C55.3043 106.847 51.087 113.108 51.4602 113.566C53.6201 116.194 56.2032 117.888 59.1592 118.618L59.1576 118.613Z",
      fill: "url(#paint5_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M250.592 107.131C253.176 110.107 256.208 112.201 259.598 113.354C259.8 113.424 260.835 112.793 260.933 112.745C262.003 112.238 263.068 111.717 264.133 111.195C265.199 110.674 265.03 111.617 266.091 111.081C266.122 111.066 267.266 110.348 267.402 110.394C264.012 109.241 260.979 107.148 258.395 104.171C258.093 103.824 255.47 104.675 255.092 104.86C254.756 105.024 250.809 107.379 250.592 107.131Z",
      fill: "url(#paint6_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M131.166 48.6691C130.889 48.546 129.33 48.1671 129.19 47.8361C130.364 50.6199 129.065 53.399 127.766 55.7004C126.695 57.5972 125.176 59.1399 123.352 59.352L126.264 61.0485C128.603 61.4168 130.365 59.6147 131.699 57.4089C133.053 55.182 134.273 52.267 133.123 49.5447C132.963 49.1619 131.467 48.7973 131.164 48.6642L131.166 48.6691Z",
      fill: "url(#paint7_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.0545 22.8896C12.4546 22.5164 11.832 22.1966 11.2065 21.8981C10.581 21.5995 9.94703 21.3188 9.29882 21.102C9.37842 21.1304 8.41748 20.8213 8.44875 20.967C8.95765 23.3409 7.6726 25.7966 6.39893 27.4171C5.67964 28.3304 4.78692 29.0092 3.82029 29.425C3.40521 29.6027 2.9617 29.6773 2.52387 29.7235C2.31917 29.7448 2.11163 29.7377 1.90694 29.7306C1.83302 29.7271 1.7591 29.7164 1.68518 29.7093C1.59136 29.6702 1.4947 29.6311 1.40088 29.592C1.00854 29.4356 0.542281 29.2189 0.121513 29.2082C-0.245238 29.2011 0.337583 29.6098 0.311995 29.592C0.800997 29.9509 1.33264 30.2246 1.85292 30.4982C4.62203 31.9588 7.54183 33.2346 10.3365 31.273C12.2925 29.9012 14.3935 26.4505 13.7595 23.4937C13.7027 23.2236 13.1966 22.9784 13.0545 22.8896Z",
      fill: "url(#paint8_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M78.8516 63.6931C80.3129 63.3377 82.2319 60.5231 82.1751 59.3681C82.0955 59.5671 79.7784 59.034 79.8665 58.8848C79.6704 59.9438 77.3732 61.6994 76 61.4044C76.0569 61.4435 77.1429 62.6696 77.285 62.7229C77.3703 62.8579 78.6895 63.7926 78.8516 63.6966V63.6931Z",
      fill: "url(#paint9_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M95.4083 9.33366C95.5334 9.09911 93.6627 6.20276 93.5234 5.96111C93.3983 5.74077 91.502 2.79113 91.5845 2.63477C89.9355 5.71945 87.7265 8.01875 85 9.48291C85.381 9.27679 88.3491 16.4377 88.821 16.1818C91.5475 14.7176 93.7565 12.4183 95.4055 9.33366H95.4083Z",
      fill: "url(#paint10_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.4083 115.584C14.5334 115.349 12.6627 112.453 12.5234 112.211C12.3983 111.991 10.502 109.041 10.5845 108.885C8.9355 111.969 6.72647 114.269 4 115.733C4.38097 115.527 7.34909 122.688 7.82103 122.432C10.5475 120.968 12.7565 118.668 14.4055 115.584H14.4083Z",
      fill: "url(#paint11_linear_1129_15509)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.333 69.7695C35.1903 68.4084 37.6751 66.2655 39.7078 63.4118C39.8301 63.2412 39.8386 61.9867 39.8471 61.873C39.9467 60.6327 40.0348 59.396 40.1258 58.1557C40.2139 56.9155 40.2992 55.6752 40.3788 54.4349C40.3788 54.3994 40.3788 53.0063 40.4584 52.8926C38.4256 55.7498 35.9408 57.8892 33.0836 59.2503C32.7481 59.4102 32.6969 64.0657 32.6656 64.5064C32.6372 64.8973 32.5747 69.6558 32.333 69.7695Z",
      fill: "url(#paint12_linear_1129_15509)"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1129_15509",
        x1: 130.576,
        y1: 35.5895,
        x2: 76.2584,
        y2: 95.5823,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#4AFFCD"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#7DBFCC"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_1129_15509",
        x1: 209.278,
        y1: 30.6128,
        x2: 216.802,
        y2: 6.36303,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#B4DF86"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#84C743"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_1129_15509",
        x1: 254.668,
        y1: 51.7148,
        x2: 251.736,
        y2: 61.1663,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#B4DF86"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#84C743"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_1129_15509",
        x1: 215.051,
        y1: 108.262,
        x2: 220.415,
        y2: 106.581,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F71873"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#C6211B"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint4_linear_1129_15509",
        x1: 172.315,
        y1: 62.2785,
        x2: 183.483,
        y2: 64.0504,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F71873"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F8A629"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint5_linear_1129_15509",
        x1: 60.9026,
        y1: 115.893,
        x2: 52.0739,
        y2: 111.483,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#BE1E68"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#B5188D"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint6_linear_1129_15509",
        x1: 260.738,
        y1: 114.32,
        x2: 254.675,
        y2: 101.936,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#B5188D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#4E69AE"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint7_linear_1129_15509",
        x1: 126.048,
        y1: 61.945,
        x2: 136.85,
        y2: 46.2851,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F71873"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#C6211B"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint8_linear_1129_15509",
        x1: 4.83046,
        y1: 34.4623,
        x2: 12.1426,
        y2: 19.2222,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F71873"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#C6211B"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint9_linear_1129_15509",
        x1: 80.4465,
        y1: 57.648,
        x2: 76.8863,
        y2: 62.6449,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#6DD0E7"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#01A7DB"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint10_linear_1129_15509",
        x1: 94.0188,
        y1: 6.24712,
        x2: 85.4772,
        y2: 11.1176,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FBE422"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#C8D92B"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint11_linear_1129_15509",
        x1: 13.0188,
        y1: 112.497,
        x2: 4.47722,
        y2: 117.368,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FBE422"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#C8D92B"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint12_linear_1129_15509",
        x1: 40.2976,
        y1: 61.8037,
        x2: 30.9061,
        y2: 61.1345,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#F8B54A"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#F8A629"
        })]
      })]
    })]
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CouponIcon.tsx




var CouponIcon = function CouponIcon(props) {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.93155 3.55772C9.60944 2.80629 10.8554 3.3227 10.8043 4.33313C10.7712 4.96945 11.2962 5.49492 11.933 5.46241C12.9435 5.41072 13.4599 6.65671 12.7084 7.33513C12.2352 7.76201 12.2352 8.50438 12.7084 8.93179C13.4599 9.60968 12.9435 10.8557 11.933 10.8045C11.2962 10.7715 10.7712 11.2964 10.8043 11.9333C10.8554 12.9437 9.60944 13.4601 8.93155 12.7092C8.50414 12.2354 7.76177 12.2354 7.33489 12.7092C6.65593 13.4601 5.41047 12.9437 5.46217 11.9333C5.49468 11.2964 4.96921 10.7715 4.33289 10.8045C3.32245 10.8557 2.80604 9.60968 3.55747 8.93179C4.03072 8.50438 4.03072 7.76201 3.55747 7.33513C2.80604 6.65671 3.32245 5.41072 4.33289 5.46241C4.96921 5.49492 5.49468 4.96945 5.46217 4.33313C5.41047 3.3227 6.65593 2.80629 7.33489 3.55772C7.76177 4.03096 8.50414 4.03096 8.93155 3.55772Z",
      fill: "url(#paint0_linear_743_3250)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.93155 3.55772V3.55772C9.60944 2.80629 10.8554 3.3227 10.8043 4.33313C10.7712 4.96945 11.2962 5.49492 11.933 5.46241C12.9435 5.41072 13.4599 6.65671 12.7084 7.33513C12.2352 7.76201 12.2352 8.50438 12.7084 8.93179C13.4599 9.60968 12.9435 10.8557 11.933 10.8045C11.2962 10.7715 10.7712 11.2964 10.8043 11.9333C10.8554 12.9437 9.60944 13.4601 8.93155 12.7092C8.50414 12.2354 7.76177 12.2354 7.33489 12.7092C6.65593 13.4601 5.41047 12.9437 5.46217 11.9333C5.49468 11.2964 4.96921 10.7715 4.33289 10.8045C3.32245 10.8557 2.80604 9.60968 3.55747 8.93179C4.03072 8.50438 4.03072 7.76201 3.55747 7.33513C2.80604 6.65671 3.32245 5.41072 4.33289 5.46241C4.96921 5.49492 5.49468 4.96945 5.46217 4.33313C5.41047 3.3227 6.65593 2.80629 7.33489 3.55772C7.76177 4.03096 8.50414 4.03096 8.93155 3.55772",
      stroke: "url(#paint1_linear_743_3250)",
      "stroke-width": "0.8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.71191 6.04314C9.86187 5.89317 10.105 5.89317 10.255 6.04314C10.3799 6.1681 10.4008 6.35777 10.3175 6.50431L10.255 6.58619L6.60279 10.2384C6.45283 10.3883 6.2097 10.3883 6.05974 10.2384C5.93477 10.1134 5.91394 9.92373 5.99725 9.77719L6.05974 9.69531L9.71191 6.04314Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.24"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.1895 5.93066C6.8627 5.93066 6.59802 6.19501 6.59802 6.52182C6.59802 6.84838 6.86278 7.11297 7.1895 7.11297C7.51598 7.11297 7.78066 6.84829 7.78066 6.52182C7.78066 6.19509 7.51606 5.93066 7.1895 5.93066Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.24"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.07659 9.16797C8.74979 9.16797 8.48511 9.43231 8.48511 9.75912C8.48511 10.0857 8.74987 10.3503 9.07659 10.3503C9.40307 10.3503 9.66774 10.0856 9.66774 9.75912C9.66774 9.43239 9.40315 9.16797 9.07659 9.16797Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.24"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_743_3250",
        x1: "4.64479",
        y1: "11.6215",
        x2: "11.6212",
        y2: "4.64517",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          "stop-color": "#43E1A8"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          "stop-color": "#219393"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_743_3250",
        x1: "4.64479",
        y1: "11.6215",
        x2: "11.6212",
        y2: "4.64517",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          "stop-color": "#43E1A8"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          "stop-color": "#219393"
        })]
      })]
    })]
  });
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/PinIcon.tsx


var PinIcon_excluded = (/* unused pure expression or super */ null && (["color", "width", "height", "cursor", "onClick", "style"]));

function PinIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PinIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PinIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PinIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var PinIcon = function PinIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#0C58B4" : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 15 : _ref$height,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      onClick = _ref.onClick,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, PinIcon_excluded);

  return /*#__PURE__*/_jsx("svg", PinIcon_objectSpread(PinIcon_objectSpread({
    style: PinIcon_objectSpread({
      cursor: cursor
    }, style),
    width: width,
    height: height,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: onClick
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.0269 6.458L9.90209 10.5828L9.90209 12.5863C9.90209 12.7041 9.87999 12.8146 9.8358 12.9177C9.79161 13.0208 9.73022 13.1117 9.65166 13.1902L9.31284 13.5291C9.14588 13.696 8.94946 13.7795 8.72358 13.7795C8.4977 13.7795 8.30128 13.696 8.13432 13.5291L5.7773 11.172L2.33016 14.6192C2.1632 14.7861 1.96678 14.8696 1.7409 14.8696C1.51502 14.8696 1.3186 14.7861 1.15164 14.6192C0.984688 14.4522 0.90121 14.2558 0.901211 14.0299C0.90121 13.8041 0.984688 13.6076 1.15164 13.4407L4.59879 9.99353L2.24177 7.63651C2.07481 7.46956 1.99133 7.27314 1.99133 7.04726C1.99133 6.82137 2.07481 6.62496 2.24177 6.458L2.58059 6.11918C2.65916 6.04061 2.75 5.97923 2.85312 5.93504C2.95624 5.89084 3.06673 5.86874 3.18458 5.86874L5.18805 5.86874L9.31284 1.74395C9.14588 1.577 9.0624 1.38058 9.0624 1.1547C9.0624 0.928818 9.14588 0.732399 9.31284 0.565444C9.47979 0.398488 9.67621 0.31501 9.90209 0.31501C10.128 0.31501 10.3244 0.398488 10.4913 0.565444L15.2054 5.27949C15.3723 5.44644 15.4558 5.64286 15.4558 5.86874C15.4558 6.09463 15.3723 6.29104 15.2054 6.458C15.0384 6.62496 14.842 6.70843 14.6161 6.70843C14.3903 6.70843 14.1938 6.62496 14.0269 6.458ZM4.5104 7.54812L8.22271 11.2604L8.22271 9.90515L12.8484 5.27949L10.4913 2.92247L5.86569 7.54812L4.5104 7.54812Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CopyIcon.tsx


var CopyIcon_excluded = (/* unused pure expression or super */ null && (["color", "width", "height", "cursor", "onClick", "style"]));

function CopyIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CopyIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CopyIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CopyIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var CopyIcon = function CopyIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#757575" : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 16 : _ref$height,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      onClick = _ref.onClick,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, CopyIcon_excluded);

  return /*#__PURE__*/_jsxs("svg", CopyIcon_objectSpread(CopyIcon_objectSpread({
    style: CopyIcon_objectSpread({
      cursor: cursor
    }, style),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: onClick
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("mask", {
      id: "mask0_3742_17158",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "16",
      height: "16",
      children: /*#__PURE__*/_jsx("rect", {
        width: "16",
        height: "16",
        fill: "#D9D9D9"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_3742_17158)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M6 12C5.63333 12 5.31944 11.8694 5.05833 11.6083C4.79722 11.3472 4.66667 11.0333 4.66667 10.6666V2.66665C4.66667 2.29998 4.79722 1.98609 5.05833 1.72498C5.31944 1.46387 5.63333 1.33331 6 1.33331H12C12.3667 1.33331 12.6806 1.46387 12.9417 1.72498C13.2028 1.98609 13.3333 2.29998 13.3333 2.66665V10.6666C13.3333 11.0333 13.2028 11.3472 12.9417 11.6083C12.6806 11.8694 12.3667 12 12 12H6ZM6 10.6666H12V2.66665H6V10.6666ZM3.33333 14.6666C2.96667 14.6666 2.65278 14.5361 2.39167 14.275C2.13056 14.0139 2 13.7 2 13.3333V3.99998H3.33333V13.3333H10.6667V14.6666H3.33333Z",
        fill: color
      })
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/index.ts











































































;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeader.tsx







var productLinks = (/* unused pure expression or super */ null && (["Foreign Currency", "Forex Cards", "Travel Insurance", "Travel Loan", "Foreign Money Trasfer"]));

var LandingHeader_LandingHeader = function LandingHeader(_ref) {
  var forexHeader = _ref.forexHeader,
      loginState = _ref.loginState,
      logoUrl = _ref.logoUrl;

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  var handleClick = function handleClick() {
    setShow(!show);
  };

  return /*#__PURE__*/_jsx(LandingHeaderStyle, {
    id: "header-id",
    children: /*#__PURE__*/_jsxs(LandingHeaderWrap, {
      id: "headerWrap-id",
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        children: /*#__PURE__*/_jsx(TripMoneyLogo, {})
      }), !loginState && /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsxs(LandingHeaderList, {
          children: [/*#__PURE__*/_jsxs(LandingHeaderItem, {
            opened: show,
            closed: !show,
            onClick: handleClick,
            children: [/*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              "aria-label": "products",
              children: "Products"
            }), show && /*#__PURE__*/_jsx(ProductLinks, {
              children: productLinks && productLinks.map(function (item, index) {
                return /*#__PURE__*/_jsx(AnchorTag, {
                  hrefProp: "#",
                  children: item
                }, index);
              })
            })]
          }), /*#__PURE__*/_jsx(LandingHeaderItem, {
            children: /*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              children: "Blogs"
            })
          }), /*#__PURE__*/_jsx(LandingHeaderItem, {
            children: /*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              children: "FAQ\u2019s"
            })
          }), /*#__PURE__*/_jsx(LandingHeaderItem, {
            children: /*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              children: "About Us"
            })
          })]
        }), /*#__PURE__*/_jsx(LandingHeaderBtn, {
          children: "LOGIN"
        })]
      }), loginState && /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(ImageIcon, {
          children: "C"
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xxs",
          color: theme.whiteText,
          fontWeight: "bold",
          children: "Hey Chavi"
        }), /*#__PURE__*/_jsx(ImageComponent, {
          width: "14px",
          height: "14px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/white_Chev_8257cb46d7.svg"
        })]
      })]
    })
  });
};

/* harmony default export */ var components_LandingHeader_LandingHeader = ((/* unused pure expression or super */ null && (LandingHeader_LandingHeader)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ArrowRight.tsx



var ArrowRight_ArrowRight = function ArrowRight(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_jsxs("svg", {
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 6.86518L21 6.86182L1 6.86518Z",
      fill: "#008CFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M1 6.86518L21 6.86182",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.8595 13L20.2086 7.65621C20.5731 7.29196 20.5731 6.70132 20.2075 6.33707L14.8595 1",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })]
  });
};

/* harmony default export */ var icons_ArrowRight = ((/* unused pure expression or super */ null && (ArrowRight_ArrowRight)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/utils/index.tsx + 2 modules
var static_utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.style.ts




var LandingButton_style_LandingButtonStyle = styled_components_browser_esm["default"].button.withConfig({
  displayName: "LandingButtonstyle__LandingButtonStyle",
  componentId: "sc-1ldh0sr-0"
})(["background-image:", ";border-radius:8px;box-shadow:0px 1px 7px rgba(0,0,0,0.21);color:#fff;width:", ";height:", ";border:none;outline:none;cursor:pointer;margin:", ";flex:", ";flex-shrink:", ";display:flex;align-items:center;gap:8px;justify-content:center;position:relative;padding:12px 20px;text-transform:uppercase;@media ", "{", " ", "}span{font-size:16px;font-weight:900;flex-shrink:0;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}", " ", ""], Global/* theme.blueGradient */.rS.blueGradient, function (p) {
  return p.customWidth ? p.customWidth : "fit-content";
}, function (p) {
  return p.customHeight ? p.customHeight : "fit-content";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.flex ? p.flex : "unset";
}, function (p) {
  return p.flexShrink ? p.flexShrink : "0";
}, static_utils/* deviceType.desktop */.vO.desktop, function (p) {
  return p.btnTheme === partner_PARTNER.MMT ? "\n    background-image:linear-gradient(to right,#53B2FE,#065AF3);\n    border-radius:38px;\n    " : p.btnTheme === partner_PARTNER.GI ? "border-radius: 30px;\n    background: #FF6E39;\n    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.14);" : "\n    background: linear-gradient(135deg, #000000 14.64%, #330e0e 85.36%);\n    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);\n    border-radius: 6px;\n    ";
}, function (props) {
  return props.disableState && "\n  background: #CBCBCB;\n  border-radius: 4px;\n  pointer-events:none;\n  span{ color: rgba(0, 0, 0, 0.3);}\n  ";
}, function (props) {
  return props.disableState && "\n  background: #CBCBCB;\n  border-radius: 4px;\n  pointer-events:none;\n  span{ color: rgba(0, 0, 0, 0.3);}\n  ";
}, function (p) {
  return p.txtClipIcon && "\n    span{max-width:78%;}\n    ";
});
var LandingButton_style_ShimmerWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingButtonstyle__ShimmerWrap",
  componentId: "sc-1ldh0sr-1"
})(["position:absolute;width:68px;height:48px;z-index:12;top:-43px;animation:shimmmer 2.9s ease-in;animation-iteration-count:infinite;animation-fill-mode:backwards;@keyframes shimmmer{0%{transform:translateX(-311px);}100%{transform:translateX(311px);}}"]);
var LandingButtonWhiteStyle = (0,styled_components_browser_esm["default"])(LandingButton_style_LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonWhiteStyle",
  componentId: "sc-1ldh0sr-2"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);color:", ";span{color:", ";font-size:16px;font-weight:700;}", ""], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, function (props) {
  return props.disableState && "\nbackground: ".concat(Global/* theme.greyText2 */.rS.greyText2, ";\ncolor: rgba(0, 0, 0, 0.3);\npointer-events:none;\nopacity: 0.7;\n");
});
var LandingButton_style_LandingButtonTertiaryStyle = (0,styled_components_browser_esm["default"])(LandingButton_style_LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonTertiaryStyle",
  componentId: "sc-1ldh0sr-3"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border:1px solid ", ";height:32px;padding:9px;color:", ";span{color:", ";font-size:12px;font-weight:700;}", ""], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, function (props) {
  return props.disableState && "\nbackground: ".concat(Global/* theme.greyText2 */.rS.greyText2, ";\ncolor: rgba(0, 0, 0, 0.3);\npointer-events:none;\nopacity: 0.7;\n");
});
var LandingButtonBlackOutlineStyle = (0,styled_components_browser_esm["default"])(LandingButton_style_LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonBlackOutlineStyle",
  componentId: "sc-1ldh0sr-4"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;color:", ";border:1px solid black;span{color:", ";}"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText, Global/* theme.blackText */.rS.blackText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DesktopLayout/DesktopLayout.style.ts




var DesktopLayout_style_DesktopLayoutStyleSectionWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSectionWrap",
  componentId: "ylfaze-0"
})(["position:relative;padding-top:6px;img,picture{flex-shrink:0;}&:after{position:fixed;width:100%;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/blue_Grad_Bg_563cf7d36a.png\");background-repeat:no-repeat;background-size:cover;content:\"\";top:0;left:0;height:87%;z-index:1;}", " @media ", "{padding-top:0px;&:after{height:0;background:transparent;background-image:none;}}"], function (p) {
  return p.pageTheme === partner_PARTNER.MMT && p.landingPageProp ? "\n        &:after {\n        background:transparent;\n        }\n        ".concat(LandingButton_style_LandingButtonStyle, "{\n            border-radius:38px;\n        }\n") : p.pageTheme === partner_PARTNER.GI && p.landingPageProp ? "\n    &:after {\n    background:transparent;\n    }\n    ".concat(LandingButton_style_LandingButtonStyle, "{\n        border-radius:30px;\n    }\n") : "";
}, utils/* deviceType.mobile */.vO.mobile);
var DesktopLayout_style_DesktopLayoutStyleSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSection",
  componentId: "ylfaze-1"
})(["width:", ";margin:0 auto;display:flex;gap:", ";height:100%;z-index:3;position:relative;justify-content:space-between;align-items:", ";flex-direction:", ";margin-bottom:", ";background:", ";", " @media ", "{background:#f2f2f2;width:100%;gap:24px;padding:56px 16px 0;margin-top:0;border-radius:0px;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/mob_Bg_76aceb3f35.png\");background-repeat:no-repeat;background-size:contain;flex-direction:column;", "}"], function (p) {
  return p.landingMargin ? "1200px" : "1230px";
}, function (p) {
  return p.landingMargin ? "88px" : "58px";
}, function (p) {
  return p.alignCenter ? "flex-start" : "baseline";
}, function (p) {
  return p.flexDirection ? "column" : "row";
}, function (p) {
  return p.landingMargin ? "70px" : "";
}, function (p) {
  return p.landingMargin ? "#fff" : "transparent";
}, function (p) {
  return p.pageTheme === partner_PARTNER.MMT && p.landingMargin ? "\n            padding:68px 40px 40px;\n            border-radius:10px;\n            margin-top:26px;\n" : p.pageTheme === partner_PARTNER.GI && p.landingMargin ? "\n            padding:38px 40px 40px;\n            border-radius:10px;\n            margin-top:26px;\n" : "";
}, utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.landingMargin && "\n            padding-bottom: 238px;\n            margin-bottom: -236px ;\n        ";
});
var DesktopLayout_style_DesktopLayoutBotttomSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutBotttomSection",
  componentId: "ylfaze-2"
})(["margin-top:20px;display:flex;gap:80px;height:100%;z-index:2;position:relative;align-items:flex-start;flex-direction:column;@media ", "{gap:56px;z-index:3;}"], utils/* deviceType.mobile */.vO.mobile);
var DesktopLayout_style_DesktopLayoutLeftSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutLeftSection",
  componentId: "ylfaze-3"
})(["display:flex;flex-direction:column;align-self:flex-start;padding-top:", ";gap:32px;margin:", ";height:", ";flex:1;margin-left:", ";position:sticky;top:155px;width:498px;", " @media ", "{margin-left:0;margin-top:11px;padding-top:0;height:unset;gap:10px;position:static;width:100%;}"], function (p) {
  return p.leftSectionHeight ? "" : "0px";
}, function (p) {
  return p.leftSectionMargin ? p.leftSectionMargin : "";
}, function (p) {
  return p.leftSectionHeight ? "100%" : "calc(708px - 130px)";
}, function (p) {
  return p.leftSectionHeight ? "" : "15px";
}, function (p) {
  return p.pageTheme === partner_PARTNER.MMT && p.leftSectionHeight ? "\n            margin-top:40px;\n" : p.pageTheme === partner_PARTNER.GI ? "\n            margin-top:40px;\n" : "";
}, utils/* deviceType.mobile */.vO.mobile);
var DesktopLayout_style_DesktopLayoutRightSection = styled_components_browser_esm["default"].section.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutRightSection",
  componentId: "ylfaze-4"
})(["width:", ";flex-shrink:0;padding-bottom:", ";display:flex;flex-direction:column;z-index:1;gap:16px;padding:", ";margin-right:", ";min-height:490px;&::-webkit-scrollbar{display:none;}@media ", "{width:100%;overflow-y:unset;padding:0;margin-right:0;height:unset;", "}"], function (p) {
  return p.rightSectionHeight ? "592px" : "622px";
}, function (p) {
  return p.rightSectionHeight ? "" : "40px";
}, function (p) {
  return p.rightSectionHeight ? "" : "56px 30px 0";
}, function (p) {
  return p.rightSectionHeight ? "" : "-15px";
}, utils/* deviceType.mobile */.vO.mobile, function (p) {
  return !p.rightSectionHeight && "\n        margin-right: -16px;\n        margin-left: -16px;\n        width: -webkit-fill-available;\n        overflow-y: scroll;\n        flex-shrink:unset;\n        ";
});
var DesktopLayoutHeading = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutHeading",
  componentId: "ylfaze-5"
})(["display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx



var PartnerContext = /*#__PURE__*/(0,react.createContext)(null);
var PartnerContextProvider_usePartnerContext = function usePartnerContext() {
  var context = (0,react.useContext)(PartnerContext);

  if (context === null) {
    console.error("usePartnerContext must be used within a PartnerContextProvider");
  }

  return context;
};
var PartnerContextProvider = function PartnerContextProvider(_ref) {
  var hostname = _ref.hostname,
      children = _ref.children,
      partnerType = _ref.partnerType;
  React.useEffect(function () {
    var element = document.getElementById("pageId");
    if (!element) return;
    element.classList.remove("mmtTheme", "giTheme");

    if (partnerType === PARTNER.MMT) {
      element.classList.add("mmtTheme");
    } else if (partnerType === PARTNER.GI) {
      element.classList.add("giTheme");
    }
  }, [partnerType]);
  return /*#__PURE__*/_jsx(PartnerContext.Provider, {
    value: partnerType,
    children: children
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DesktopLayout/DesktopLayout.tsx










var DesktopLayout = function DesktopLayout(_ref) {
  var title = _ref.title,
      leftComp = _ref.leftComp,
      rightComp = _ref.rightComp,
      bottomComp = _ref.bottomComp,
      headingComp = _ref.headingComp,
      height = _ref.height,
      alignCenter = _ref.alignCenter,
      leftSectionMargin = _ref.leftSectionMargin,
      rightSectionHeight = _ref.rightSectionHeight,
      leftSectionHeight = _ref.leftSectionHeight,
      landingMargin = _ref.landingMargin,
      subTitle = _ref.subTitle,
      shimmer = _ref.shimmer,
      landingPageProp = _ref.landingPageProp,
      goToMyOrders = _ref.goToMyOrders;
  var context = usePartnerContext();
  var device = useBreakpointV2(); // console.log(context);

  var _useState = useState(undefined),
      windowHeight = _useState[0],
      setWindowHeight = _useState[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      setWindowHeight(window.innerHeight);
    };

    if (true) {
      setWindowHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return function () {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/_jsxs(DesktopLayoutStyleSectionWrap, {
    id: "pageId",
    height: height,
    pageTheme: context ? context : undefined,
    landingPageProp: landingPageProp,
    children: [/*#__PURE__*/_jsxs(DesktopLayoutStyleSection, {
      landingMargin: landingMargin,
      alignCenter: alignCenter,
      pageTheme: context ? context : undefined,
      children: [/*#__PURE__*/_jsxs(DesktopLayoutLeftSection, {
        leftSectionHeight: leftSectionHeight,
        leftSectionMargin: leftSectionMargin,
        pageTheme: context ? context : undefined,
        children: [/*#__PURE__*/_jsx("div", {
          children: shimmer ? /*#__PURE__*/_jsxs(FlexComp, {
            flexDirection: "column",
            gap: "4px",
            children: [subTitle && /*#__PURE__*/_jsx(Shimmer, {
              width: "375px",
              height: "38px"
            }), /*#__PURE__*/_jsx(Shimmer, {
              width: "100%",
              height: "56px"
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [subTitle && (device == "lg" ? /*#__PURE__*/_jsx(H4Tag, {
              margin: device == "lg" ? "40px 0 0" : "",
              color: "#CF8100",
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: subTitle
              })
            }) : /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "md",
              fontWeight: "black",
              color: "#CF8100",
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: subTitle
              })
            })), device == "lg" ? /*#__PURE__*/_jsx(H2Tag, {
              children: title ? /*#__PURE__*/_jsx(FormattedText, {
                value: title
              }) : null
            }) : /*#__PURE__*/_jsx(H4Tag, {
              children: title ? /*#__PURE__*/_jsx(FormattedText, {
                value: title
              }) : null
            })]
          })
        }), leftComp]
      }), /*#__PURE__*/_jsxs(DesktopLayoutRightSection, {
        rightSectionHeight: rightSectionHeight,
        children: [context && landingPageProp && device == "lg" && /*#__PURE__*/_jsxs(FlexComp, {
          alignSelf: "flex-end",
          isCursorPointer: true,
          gap: "4px",
          alignItems: "center",
          margin: "0 0 8px",
          children: [/*#__PURE__*/_jsx(AnchorTag, {
            fontWeight: "bold",
            handleClick: goToMyOrders,
            children: "My Orders"
          }), /*#__PURE__*/_jsx(ArrowRight, {
            width: 16,
            height: 16
          })]
        }), rightComp]
      })]
    }), bottomComp && /*#__PURE__*/_jsx(DesktopLayoutBotttomSection, {
      children: bottomComp
    })]
  });
};

/* harmony default export */ var DesktopLayout_DesktopLayout = ((/* unused pure expression or super */ null && (DesktopLayout)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingTestimonials/LandingTestimonials.style.ts



var LandingTestimonials_style_LandingTestimonialsStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestimonialsStyle",
  componentId: "sc-1au5c5p-0"
})(["display:flex;background:#fff;flex-direction:column;margin-bottom:137px;width:100%;@media ", "{margin-bottom:40px;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_LandingTestTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestTitle",
  componentId: "sc-1au5c5p-1"
})(["font-family:\"Lato\";font-weight:500;font-size:56px;line-height:72px;color:#000000;margin-bottom:34px;display:flex;align-items:center;@media ", "{font-size:24px;line-height:32px;margin-bottom:12px;padding:0px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_TestimonialContent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialContent",
  componentId: "sc-1au5c5p-2"
})(["display:flex;margin-bottom:8px;> img{margin-right:17px;border-radius:8px;}"]);
var LandingTestimonials_style_LandingTest = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTest",
  componentId: "sc-1au5c5p-3"
})(["display:inline-block;img{object-fit:contain;}@media ", "{font-weight:400;color:#4a4a4a;align-items:flex-start;border-radius:10px;position:relative;background:#fff;z-index:1;width:100% !important;flex-direction:column !important;padding:4px 16px;font-size:14px;line-height:20px;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_LandingTestWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestWrap",
  componentId: "sc-1au5c5p-4"
})(["display:flex;width:575px;padding:32px 30px;background:#fff;position:relative;z-index:1;border-radius:10px;margin-right:20px;", "{white-space:initial;}@media ", "{width:unset;padding:16px;", "{font-size:14px;line-height:20px;}box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:10px;margin-right:unset;}"], ParaTagStyle, utils/* deviceType.mobile */.vO.mobile, ParaTagStyle);
var LandingTestimonials_style_LandingTestImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestImg",
  componentId: "sc-1au5c5p-5"
})(["width:150px;height:250px;flex-shrink:0;position:relative;margin-right:20px;z-index:1;> img{border-radius:20px;}@media ", "{width:84px;height:87px;display:flex;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_LandingTextCrd = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTextCrd",
  componentId: "sc-1au5c5p-6"
})(["padding:4px 8px 4px 8px;border-radius:19px;font-weight:700;font-size:12px;line-height:11px;color:#fff;position:absolute;bottom:-7px;left:25px;text-transform:uppercase;", " ", " @media ", "{position:static;width:fit-content;}"], function (p) {
  return p.cardType == "travelLoan" && "\n    background: linear-gradient(88.44deg, #43e1a8 0.02%, #28beb2 100.01%);\n    ";
}, function (p) {
  return p.cardType == "forexCard" && "\n    background: linear-gradient(85.23deg, #ff7f3f 0%, #ff3e5e 100%);\n    ";
}, utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_PersonName = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingTestimonialsstyle__PersonName",
  componentId: "sc-1au5c5p-7"
})(["font-weight:700;font-size:24px;line-height:36px;color:#012136;margin-bottom:2px;display:block;@media ", "{font-size:16px;line-height:20px;font-weight:900;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_Date = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingTestimonialsstyle__Date",
  componentId: "sc-1au5c5p-8"
})(["font-weight:400;font-size:14px;line-height:18px;color:#9b9b9b;@media ", "{font-size:12px;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_LandingTestCntnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestCntnt",
  componentId: "sc-1au5c5p-9"
})(["z-index:1;@media ", "{white-space:initial;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_Flex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__Flex",
  componentId: "sc-1au5c5p-10"
})(["display:flex;width:100%;margin-bottom:8px;"]);
var LandingTestimonials_style_SlideShowContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowContainer",
  componentId: "sc-1au5c5p-11"
})(["margin:0 auto;overflow:hidden;max-width:1200px;@media ", "{max-width:100%;cursor:grab;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_SlideShowSLider = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowSLider",
  componentId: "sc-1au5c5p-12"
})(["white-space:nowrap;transition:ease 1000ms;"]);
var LandingTestimonials_style_SlideDots = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideDots",
  componentId: "sc-1au5c5p-13"
})(["text-align:center;@media ", "{margin-top:12px;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_SlideShowDotItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowDotItem",
  componentId: "sc-1au5c5p-14"
})(["background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;", ""], function (p) {
  return p.active && "\n        width: 32px;\n        height: 12px;\n        background: #000000 !important;\n        opacity: 1;\n        border-radius: 6px;\n        ";
});
var LandingTestimonials_style_StarRating = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRating",
  componentId: "sc-1au5c5p-15"
})(["display:flex;gap:8px;", " @media ", "{gap:5px;}"], function (p) {
  return p.starRateFull && "\n    position: absolute;\n    top: 0;\n    ";
}, utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_StarRatingWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRatingWrap",
  componentId: "sc-1au5c5p-16"
})(["margin-bottom:12px;position:relative;"]);
var TestimonialTag = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialTag",
  componentId: "sc-1au5c5p-17"
})(["background:rgba(120,198,255,0.2);border:1px solid rgba(120,198,255,0.4);border-radius:8px;padding:2px 12px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts


var CommonStyles_style_InnerContentWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CommonStylesstyle__InnerContentWrap",
  componentId: "tfai8k-0"
})(["width:1200px;margin:0 auto;@media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx


function FormattedText_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FormattedText_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FormattedText_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FormattedText_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* Every text node can be of either of the three formats - 
1. string - "Hello"
2. text obj with value and styles - 
   text: {
    value: "Travel Assistance",
    styles: {
      color: "#000000",
      fontFamily: "fontSansBold",
    },
  }
3. Array of text objs with value and styles - 
   text: [
    {
      value: "Travel Assistance",
      styles: {
        color: "#000000",
        fontFamily: "fontSansBold",
      },
    },
  ]
*/


var getPlainText = function getPlainText(data) {
  if (!data) {
    return "";
  } else if (typeof data === "string") {
    return data;
  } else if (data !== null && data !== void 0 && data.text) {
    var text = data.text;

    if (Array.isArray(text)) {
      return text.map(function (node) {
        return node.value;
      }).join("");
    } else if (typeof text === "object") {
      return (text === null || text === void 0 ? void 0 : text.value) || "";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

var FormattedText_FormattedText = function FormattedText(_ref) {
  var value = _ref.value,
      baseStyle = _ref.baseStyle;
  var device = (0,ui_widgets_src.useBreakpointV2)();

  if (!value) {
    return null;
  }

  var returnValue = null;

  if (typeof value === "string") {
    returnValue = value;
  } else if (value !== null && value !== void 0 && value.text) {
    var text = value.text;

    if (Array.isArray(text)) {
      returnValue = text.map(function (node, index) {
        var _node$styles;

        var mobileStyle = (_node$styles = node.styles) === null || _node$styles === void 0 ? void 0 : _node$styles.mobile;

        var combinedStyles = FormattedText_objectSpread(FormattedText_objectSpread({}, node === null || node === void 0 ? void 0 : node.styles), device === "sm" && FormattedText_objectSpread({}, mobileStyle));

        return node.value ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: combinedStyles,
          children: node.value
        }, index) : null;
      });
    } else if (typeof text === "object") {
      var _text$styles;

      var mobileStyle = text === null || text === void 0 ? void 0 : (_text$styles = text.styles) === null || _text$styles === void 0 ? void 0 : _text$styles.mobile;

      var combinedStyles = FormattedText_objectSpread(FormattedText_objectSpread({}, text === null || text === void 0 ? void 0 : text.styles), device === "sm" && FormattedText_objectSpread({}, mobileStyle));

      returnValue = text !== null && text !== void 0 && text.value ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        style: combinedStyles,
        children: text.value
      }) : null;
    } else {
      returnValue = text;
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    style: baseStyle !== null && baseStyle !== void 0 ? baseStyle : {},
    children: returnValue
  });
};

/* harmony default export */ var components_FormattedText_FormattedText = (FormattedText_FormattedText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingTestimonials/LandingTestimonials.tsx











var LandingTestimonials = function LandingTestimonials(_ref) {
  var customTitle = _ref.customTitle,
      test = _ref.test;

  var _useState = useState(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var _useState2 = useState(test === null || test === void 0 ? void 0 : test.length),
      length = _useState2[0],
      setLength = _useState2[1];

  var _useState3 = useState(null),
      touchPosition = _useState3[0],
      setTouchPosition = _useState3[1];

  var device = useBreakpointV2();

  var _useState4 = useState(false),
      isHovered = _useState4[0],
      setIsHovered = _useState4[1];

  useEffect(function () {
    setLength(test === null || test === void 0 ? void 0 : test.length);
  }, [test]);

  var next = function next() {
    if (currentIndex < length - 1) {
      setCurrentIndex(function (prevState) {
        return prevState + 1;
      });
    }
  };

  var prev = function prev() {
    if (currentIndex > 0) {
      setCurrentIndex(function (prevState) {
        return prevState - 1;
      });
    }
  };

  var handleTouchStart = function handleTouchStart(e) {
    var touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  var handleTouchMove = function handleTouchMove(e) {
    var touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    var currentTouch = e.touches[0].clientX;
    var diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);

    if (isHovered) {
      resetTimeout();
    }
  };

  var timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(function () {
    resetTimeout();
    timeoutRef.current = window.setTimeout(function () {
      return setCurrentIndex(function (prevIndex) {
        return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
      });
    }, 2500);
    return function () {
      resetTimeout();
      timeoutRef.current = window.setTimeout(function () {
        return setCurrentIndex(function (prevIndex) {
          return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
        });
      }, 2500);
    };
  }, [currentIndex]);

  var handleMouseEnter = function handleMouseEnter() {
    setIsHovered(true);
    resetTimeout();
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
    resetTimeout();
    timeoutRef.current = window.setTimeout(function () {
      return setCurrentIndex(function (prevIndex) {
        return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
      });
    }, 2500);
  };

  return /*#__PURE__*/_jsx(LandingTestimonialsStyle, {
    children: /*#__PURE__*/_jsxs(InnerContentWrap, {
      children: [/*#__PURE__*/_jsxs(LandingTestTitle, {
        children: [customTitle && /*#__PURE__*/_jsx(FormattedText, {
          value: customTitle
        }), " ", /*#__PURE__*/_jsx(ImageComponent, {
          width: device == "lg" ? "66px" : "32px",
          height: device == "lg" ? "66px" : "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/heart_9289dd4a1d.svg"
        })]
      }), /*#__PURE__*/_jsxs(SlideShowContainer, {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [/*#__PURE__*/_jsx(SlideShowSLider, {
          style: {
            transform: "translateX(-".concat(currentIndex * (device === "lg" ? 50 : 100), "%)")
          },
          children: test && test.map(function (item, index) {
            return /*#__PURE__*/_jsx(LandingTest, {
              children: /*#__PURE__*/_jsxs(LandingTestWrap, {
                children: [device === "lg" && /*#__PURE__*/_jsxs(LandingTestImg, {
                  children: [item.personImg && /*#__PURE__*/_jsx(ImageComponent, {
                    width: "150",
                    height: "250",
                    alt: "hello",
                    src: item.personImg.src
                  }), /*#__PURE__*/_jsx(LandingTextCrd, {
                    cardType: item.personCrdClass,
                    children: item.personCard && /*#__PURE__*/_jsx(FormattedText, {
                      value: item.personCard
                    })
                  })]
                }), /*#__PURE__*/_jsxs(LandingTestCntnt, {
                  children: [/*#__PURE__*/_jsxs(TestimonialContent, {
                    children: [device !== "lg" && item.personImg && /*#__PURE__*/_jsx("img", {
                      width: "84",
                      height: "87",
                      alt: "",
                      src: item.personImg.src
                    }), /*#__PURE__*/_jsxs("div", {
                      children: [/*#__PURE__*/_jsx(PersonName, {
                        children: item.personName && /*#__PURE__*/_jsx(FormattedText, {
                          value: item.personName
                        })
                      }), /*#__PURE__*/_jsxs(StarRatingWrap, {
                        children: [/*#__PURE__*/_jsx(StarRating, {
                          children: Array.from({
                            length: 5
                          }, function (_, index) {
                            return /*#__PURE__*/_jsx(StarEmpty, {
                              height: device !== "lg" ? 16 : 25,
                              width: device !== "lg" ? 16 : 26
                            }, index);
                          })
                        }), /*#__PURE__*/_jsx(StarRating, {
                          starRateFull: true,
                          children: Array.from({
                            length: Number(item.personRating)
                          }, function (_, index) {
                            return /*#__PURE__*/_jsx(StarFull, {
                              height: device !== "lg" ? 16 : 25,
                              width: device !== "lg" ? 16 : 26
                            }, index);
                          })
                        })]
                      }), device !== "lg" && /*#__PURE__*/_jsx(LandingTextCrd, {
                        children: item.personCard && /*#__PURE__*/_jsx(FormattedText, {
                          value: item.personCard
                        })
                      })]
                    })]
                  }), /*#__PURE__*/_jsx(ParaTag, {
                    fontSize: "md",
                    color: theme.greyText,
                    children: item.testInfo && /*#__PURE__*/_jsx(FormattedText, {
                      value: item.testInfo
                    })
                  })]
                })]
              })
            }, index);
          })
        }), /*#__PURE__*/_jsx(SlideDots, {
          children: test === null || test === void 0 ? void 0 : test.map(function (_, idx) {
            return /*#__PURE__*/_jsx(SlideShowDotItem, {
              active: currentIndex === idx,
              onClick: function onClick() {
                setCurrentIndex(idx);
              }
            }, idx);
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var LandingTestimonials_LandingTestimonials = ((/* unused pure expression or super */ null && (LandingTestimonials)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFaq/LandingFaq.style.ts



var LandingFaq_style_LandingFaqStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingFaqstyle__LandingFaqStyle",
  componentId: "sc-1k4u026-0"
})(["", " display:flex;background:#fff;flex-direction:column;width:100%;", ""], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.customFaq && "";
});
var LandingFaq_style_LandingFaqTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqTitle",
  componentId: "sc-1k4u026-1"
})(["font-family:\"Lato\";font-weight:400;font-size:48px;line-height:56px;margin-left:", ";margin-bottom:", ";color:", ";@media screen and ", "{font-weight:500;font-size:24px;line-height:32px;margin-bottom:8px;margin-left:", ";}"], function (props) {
  return props.marginLeft ? props.marginLeft : "0px";
}, function (props) {
  return props.marginBottom ? props.marginBottom : "56px";
}, Global/* theme.blackText */.rS.blackText, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.marginLeft ? props.marginLeft : "0px";
});
var LandingFaq_style_LandingFaqList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingFaqstyle__LandingFaqList",
  componentId: "sc-1k4u026-2"
})(["width:1000px;gap:16px;li{margin-bottom:16px;position:relative;cursor:pointer;}li h5{padding:24px;@media screen and ", "{padding:16px;}}li p{padding:0 24px 24px;}li:after{content:\"\";position:absolute;border:solid black;border-width:0 3px 3px 0;display:inline-block;padding:3px;right:24px;top:33px;transition:0.3s ease-in;@media screen and ", "{top:16px;}}li.close:after{transform:rotate(45deg);-webkit-transform:rotate(45deg);}li.open:after{transform:rotate(-135deg);-webkit-transform:rotate(-135deg);}li:hover{background:#ffffff;box-shadow:0px 4px 16px rgba(0,0,0,0.16);border-radius:6px;}li:last-child{margin-bottom:unset;}", " @media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.customFaq && "\n            width:100%;\n            gap:8px;\n            margin-bottom: 24px;\n            li {\n                padding: 12px 16px;\n                background: #FFFFFF;\n                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);\n                border-radius: 6px;\n            }\n            li h5 {\n                padding: unset;\n            }\n            li p {\n                padding:unset;\n                font-size: 12px;\n                line-height: 16px;\n                color: #000000;\n            }\n            li:after {\n                border: solid #008CFF;\n                border-width: 0 2px 2px 0;\n                padding: 4px;\n                right: 24px;\n                top: 13px;\n            }\n    ";
}, utils/* deviceType.mobile */.vO.mobile);
var LandingFaq_style_LandingFaqQues = styled_components_browser_esm["default"].h5.withConfig({
  displayName: "LandingFaqstyle__LandingFaqQues",
  componentId: "sc-1k4u026-3"
})(["font-weight:700;font-size:22px;line-height:30px;color:#000;", " @media screen and ", "{font-weight:700;font-size:16px;line-height:20px;}"], function (props) {
  return props.customFaq && "\n        font-size: 12px;\n        line-height: 16px;\n        color: #000000;";
}, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFaq/LandingFaq.tsx








var LandingFaq_LandingFaq = function LandingFaq(_ref) {
  var customTitle = _ref.customTitle,
      customFaq = _ref.customFaq,
      faq = _ref.faq,
      margin = _ref.margin;

  var _useState = useState(-1),
      exp = _useState[0],
      setExp = _useState[1];

  var device = useBreakpointV2();

  var handleClick = function handleClick(index) {
    exp != index ? setExp(index) : setExp(-1);
  };

  return /*#__PURE__*/_jsx(LandingFaqStyle, {
    margin: margin,
    customFaq: customFaq,
    children: /*#__PURE__*/_jsxs(InnerContentWrap, {
      children: [customTitle && /*#__PURE__*/_jsx(LandingFaqTitle, {
        marginLeft: device === "sm" ? "16px" : "",
        marginBottom: "16px",
        children: customTitle && /*#__PURE__*/_jsx(FormattedText, {
          value: customTitle
        })
      }), /*#__PURE__*/_jsx(LandingFaqList, {
        customFaq: customFaq,
        children: faq.map(function (item, index) {
          return /*#__PURE__*/_jsxs("li", {
            className: "".concat(exp == index ? "open" : "close"),
            onClick: function onClick() {
              return handleClick(index);
            },
            children: [/*#__PURE__*/_jsx(LandingFaqQues, {
              customFaq: customFaq,
              children: item.ques && /*#__PURE__*/_jsx(FormattedText, {
                value: item.ques
              })
            }), exp == index && /*#__PURE__*/_jsx("p", {
              children: item.info && /*#__PURE__*/_jsx(FormattedText, {
                value: item.info
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var components_LandingFaq_LandingFaq = ((/* unused pure expression or super */ null && (LandingFaq_LandingFaq)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SectionDividers/SectionDividers.style.ts

var SectionDividers_style_SectionDividersStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionDividersstyle__SectionDividersStyle",
  componentId: "sc-1legtm0-0"
})(["background:", ";width:", ";height:", ";border-radius:", ";margin:", ";", ";", ";", ";flex-shrink:0;"], function (p) {
  return p.backgroundColor ? "".concat(p.backgroundColor) : "#f2f2f2";
}, function (p) {
  return p.width ? p.width : "unset";
}, function (p) {
  return p.height ? p.height : "4px";
}, function (p) {
  return p.borderRadius ? p.borderRadius : "0px";
}, function (p) {
  return p.margin ? p.margin : "0px";
}, function (p) {
  return p.xs && "height: 1px;";
}, function (p) {
  return p.small && "height: 10px;";
}, function (p) {
  return p.large && "height: 25px;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.style.ts


var TMFloatingInput_style_TMInputWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TMFloatingInputstyle__TMInputWrap",
  componentId: "l84rpp-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:700;font-size:14px;line-height:20px;color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:10px;top:18px;text-transform:uppercase;", " ", "}", " label span{font-weight:400;text-transform:lowercase;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inputWidth;
}, function (p) {
  return p.flex ? p.flex : "";
}, Global/* theme.greyText */.rS.greyText, function (props) {
  return props.placeholder && "\n    color: ".concat(Global/* theme.blueText */.rS.blueText, ";\n    background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 16px;\n    top: 5px;\n    ");
}, function (props) {
  return props.disableState && "\n        pointer-events: none;\n        color: ".concat(Global/* theme.lightBlack */.rS.lightBlack, ";\n    ");
}, function (props) {
  return props.clickable && "\n        cursor: pointer;\n        background:".concat(Global/* theme.whiteText */.rS.whiteText, ";\n        color: ").concat(Global/* theme.greyText */.rS.greyText, "\n    ");
});
var TMFloatingInput_style_TMInputStyle = styled_components_browser_esm["default"].input.withConfig({
  displayName: "TMFloatingInputstyle__TMInputStyle",
  componentId: "l84rpp-1"
})(["background:", ";border:1px solid ", ";border-radius:4px;padding:26px 10px 10px;font-weight:700;font-size:14px;line-height:19px;display:block;width:100%;", " &:focus + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", "}&:valid + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", " ", " ", " ", "}", " ", " ", " &:focus{outline:none;border:1px solid ", ";background:", ";}&:valid{outline:none;border:1px solid ", ";background:", ";", "}"], Global/* theme.gray97 */.rS.gray97, Global/* theme.lightGrey */.rS.lightGrey, function (props) {
  return props.verifiedTag && "\n        padding-right: 80px;\n    ";
}, Global/* theme.blueText */.rS.blueText, Global/* theme.blueLight */.rS.blueLight, function (props) {
  return props.errorState && "\n        color: ".concat(Global/* theme.redText2 */.rS.redText2, ";\n    ");
}, Global/* theme.greyText6 */.rS.greyText6, Global/* theme.smokeWhite */.rS.smokeWhite, function (props) {
  return props.isActive && "\n            color: ".concat(Global/* theme.blueText */.rS.blueText, ";\n            background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n        ");
}, function (props) {
  return props.placeholder && "\n            color: ".concat(Global/* theme.blueText */.rS.blueText, ";\n            background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n        ");
}, function (props) {
  return props.errorState && "\n             color: ".concat(Global/* theme.redText2 */.rS.redText2, ";\n     ");
}, function (props) {
  return props.clickable && "\n        background: ".concat(Global/* theme.whiteText */.rS.whiteText, ";\n    ");
}, function (props) {
  return props.disableState && "\n        pointer-events: none;\n        color:  ".concat(Global/* theme.lightBlack */.rS.lightBlack, ";\n        border: 1px solid ").concat(Global/* theme.lightSilver */.rS.lightSilver, ";\n        background: ").concat(Global/* theme.whiteText */.rS.whiteText, ";\n    ");
}, function (props) {
  return props.clickable && "\n        pointer-events: none;\n        background: ".concat(Global/* theme.whiteText */.rS.whiteText, "  !important;\n        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n    ");
}, function (props) {
  return props.errorState && "\n      border: 1px solid ".concat(Global/* theme.redText2 */.rS.redText2, " !important;\n      background: ").concat(Global/* theme.snowWhite */.rS.snowWhite, "  !important;\n    ");
}, Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText, Global/* theme.gainsBoro */.rS.gainsBoro, Global/* theme.smokeWhite */.rS.smokeWhite, function (props) {
  return props.isActive && "\n            border: 1px solid ".concat(Global/* theme.blueText */.rS.blueText, ";\n            background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n        ");
});
var TMFloatingInput_style_VerifiedContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TMFloatingInputstyle__VerifiedContainer",
  componentId: "l84rpp-2"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
var TMFloatingInput_style_InputWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TMFloatingInputstyle__InputWpr",
  componentId: "l84rpp-3"
})(["position:relative;"]);
var TMFloatingInput_style_IconContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TMFloatingInputstyle__IconContainer",
  componentId: "l84rpp-4"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionModalDweb.style.tsx





var modalAnim = (0,styled_components_browser_esm.keyframes)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var RegionModalDweb_style_CommonModalDwebStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalDwebStyle",
  componentId: "c6vrw8-0"
})(["position:fixed;width:", ";height:fit-content;max-height:600px;min-height:260px;overflow-y:scroll;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, SectionDividers_style_SectionDividersStyle, TMFloatingInput_style_TMInputWrap, utils/* deviceType.mobile */.vO.mobile, modalAnim, TMFloatingInput_style_TMInputWrap);
var RegionModalDweb_style_CommonModalHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalHeader",
  componentId: "c6vrw8-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;gap:10px;white-space:nowrap;overflow:hidden;align-items:center;justify-content:space-between;text-overflow:ellipsis;width:100%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], TextStyles_style_H5TagStyle, function (p) {
  return p.nonClipHeading && "\n     ".concat(TextStyles_style_H5TagStyle, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, utils/* deviceType.mobile */.vO.mobile);
var RegionModalDweb_style_CrossIconWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RegionModalDwebstyle__CrossIconWrap",
  componentId: "c6vrw8-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionModalDweb.tsx







var RegionModalDweb_RegionModalDweb = function RegionModalDweb(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      customSubTitle = _ref.customSubTitle,
      handleClick = _ref.handleClick,
      requiredField = _ref.requiredField,
      crossIcon = _ref.crossIcon,
      customWidth = _ref.customWidth,
      customIcon = _ref.customIcon,
      errorModal = _ref.errorModal,
      nonClipHeading = _ref.nonClipHeading;
  useEffect(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  useEffect(function () {
    // document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/_jsxs(ReactPortalComp, {
    children: [/*#__PURE__*/_jsxs(CommonModalDwebStyle, {
      customWidth: customWidth,
      children: [/*#__PURE__*/_jsx(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(H5Tag, {
            children: [/*#__PURE__*/_jsx(ImageComponent, {
              width: "28px",
              height: "28px",
              src: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_47_6c7992dd19.svg"
            }), /*#__PURE__*/_jsx(CrossIconWrap, {
              onClick: handleClick,
              children: /*#__PURE__*/_jsx(ImageComponent, {
                width: "28px",
                height: "28px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg"
              })
            })]
          }), /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "xlarge",
            fontWeight: "black",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: customTitle
            })
          })]
        })
      }), children]
    }), /*#__PURE__*/_jsx(BackDropComp, {
      onClose: handleClick
    })]
  });
};

/* harmony default export */ var components_RegionModalDweb_RegionModalDweb = ((/* unused pure expression or super */ null && (RegionModalDweb_RegionModalDweb)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DescriptionModal/DescriptionModal.style.tsx

var DescriptionModal_style_PopularDescriptionWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DescriptionModalstyle__PopularDescriptionWrap",
  componentId: "sc-7zo3r7-0"
})(["border-radius:4px;padding:12px;background-color:#f6f6f6;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DescriptionModal/DescriptionModal.tsx







var DescriptionModal_DescriptionModal = function DescriptionModal(_ref) {
  var handleDescriptionModal = _ref.handleDescriptionModal,
      value = _ref.value,
      title = _ref.title;
  return /*#__PURE__*/_jsx(RegionModalDweb, {
    handleClick: handleDescriptionModal,
    customTitle: title,
    children: /*#__PURE__*/_jsxs(PopularDescriptionWrap, {
      children: [/*#__PURE__*/_jsx(FormattedText, {
        value: "Countries Covered: ",
        baseStyle: {
          fontWeight: "bold",
          color: theme.greyText,
          fontSize: "xs"
        }
      }), /*#__PURE__*/_jsx(FormattedText, {
        value: value
      })]
    })
  });
};

/* harmony default export */ var components_DescriptionModal_DescriptionModal = ((/* unused pure expression or super */ null && (DescriptionModal_DescriptionModal)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.style.ts


var renderAlign = function renderAlign(alignItems) {
  switch (alignItems) {
    case "center":
      return "align-items: center;";

    case "baseline":
      return "align-items: baseline;";

    case "flex-start":
      return "align-items:flex-start;";

    case "flex-end":
      return "align-items:flex-end;";

    default:
      return "align-items:center;";
  }
};

var renderAlignSelf = function renderAlignSelf(alignSelf) {
  switch (alignSelf) {
    case "center":
      return "align-self: center;";

    case "baseline":
      return "align-self: baseline;";

    case "flex-start":
      return "align-self:flex-start;";

    case "flex-end":
      return "align-self:flex-end;";

    default:
      return "align-self:unset;";
  }
};

var renderJustify = function renderJustify(justifyContent) {
  switch (justifyContent) {
    case "center":
      return "justify-content:center;";

    case "flex-start":
      return "justify-content:flex-start;";

    case "end":
      return "justify-content:end;";

    case "space-between":
      return "justify-content:space-between;";

    case "inherit":
      return "justify-content:inherit;";

    case "right":
      return "justify-content:right;";

    default:
      return "justify-content:center;";
  }
};

var renderDir = function renderDir(flexDirection) {
  switch (flexDirection) {
    case "row":
      return "flex-direction:row;";

    case "column":
      return "flex-direction:column;";

    case "row-reverse":
      return "flex-direction:row-reverse;";

    case "column-reverse":
      return "flex-direction:column-reverse;";

    default:
      return "flex-direction:row;";
  }
};

var FlexCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FlexCompstyle__FlexCompStyle",
  componentId: "sc-11q208e-0"
})(["display:flex;position:relative;cursor:", ";", " ", " ", " ", " gap:", ";flex:", ";flex-shrink:", ";margin:", ";padding:", ";border-bottom:", ";border-top:", ";background:", ";border-radius:", ";height:", ";width:", ";box-shadow:", ";pointer-events:auto;flex-wrap:", ";"], function (props) {
  return props.isCursorPointer ? "pointer" : "default";
}, function (p) {
  return p.alignItems && "\n    ".concat(renderAlign(p.alignItems), "\n  ");
}, function (p) {
  return p.alignSelf && "\n    ".concat(renderAlignSelf(p.alignSelf), "\n  ");
}, function (p) {
  return p.justifyContent && "\n    ".concat(renderJustify(p.justifyContent), "\n  ");
}, function (p) {
  return p.flexDirection && "\n    ".concat(renderDir(p.flexDirection), "\n  ");
}, function (p) {
  return p.gap ? p.gap : "0";
}, function (p) {
  return p.flex ? p.flex : "unset";
}, function (p) {
  return p.flexShrink ? p.flexShrink : "unset";
}, function (p) {
  return p.margin ? p.margin : "unset";
}, function (p) {
  return p.padding ? p.padding : "0";
}, function (p) {
  return p.borderBottom ? p.borderBottom : "none";
}, function (p) {
  return p.borderTop ? p.borderTop : "none";
}, function (p) {
  return p.bgColor ? p.bgColor : "transparent";
}, function (p) {
  return p.borderRadius ? p.borderRadius : "0";
}, function (p) {
  return p.height ? p.height : "unset";
}, function (p) {
  return p.width ? p.width : "unset";
}, function (p) {
  return p.boxShadow ? p.boxShadow : "none";
}, function (p) {
  return p.flexWrap ? p.flexWrap : "";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx




var FlexComp_FlexComp = function FlexComp(_ref) {
  var children = _ref.children,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      margin = _ref.margin,
      borderBottom = _ref.borderBottom,
      borderTop = _ref.borderTop,
      padding = _ref.padding,
      flex = _ref.flex,
      bgColor = _ref.bgColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      flexShrink = _ref.flexShrink,
      handleClick = _ref.handleClick,
      boxShadow = _ref.boxShadow,
      width = _ref.width,
      _ref$isCursorPointer = _ref.isCursorPointer,
      isCursorPointer = _ref$isCursorPointer === void 0 ? false : _ref$isCursorPointer,
      flexWrap = _ref.flexWrap,
      alignSelf = _ref.alignSelf,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    id: id,
    flexDirection: flexDirection,
    alignItems: alignItems,
    justifyContent: justifyContent,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    gap: gap,
    margin: margin,
    borderBottom: borderBottom,
    borderTop: borderTop,
    padding: padding,
    flex: flex,
    bgColor: bgColor,
    borderRadius: borderRadius,
    height: height,
    flexShrink: flexShrink,
    width: width,
    boxShadow: boxShadow,
    onClick: handleClick,
    flexWrap: flexWrap,
    alignSelf: alignSelf,
    children: children
  });
};

/* harmony default export */ var components_FlexComp_FlexComp = (FlexComp_FlexComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.style.tsx



var WebToast_style_WebToastStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WebToaststyle__WebToastStyle",
  componentId: "sc-937kgh-0"
})(["position:", ";top:", ";left:", ";width:", ";height:", ";background:", ";display:flex;align-items:", ";z-index:200;justify-content:", ";box-shadow:0px 3px 30px rgba(0,0,0,0.16);", " padding:12px 16px 12px 16px;border-radius:6px;bottom:", ";right:", ";picture{height:19px;width:19px;padding:2px;}", "{flex-shrink:0;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], function (p) {
  return p.position ? "".concat(p.position) : "absolute";
}, function (p) {
  return "".concat(p.top);
}, function (p) {
  return "".concat(p.left);
}, function (p) {
  return "".concat(p.width);
}, function (p) {
  return "".concat(p.height);
}, function (p) {
  return p.background ? "".concat(p.background) : "#4a4a4a";
}, function (p) {
  return p.alignItems ? "".concat(p.alignItems) : "center";
}, function (p) {
  return p.justifyContent ? "".concat(p.justifyContent) : "space-between";
}, function (p) {
  return p.margin && "margin: ".concat(p.margin, ";");
}, function (p) {
  return "".concat(p.bottom);
}, function (p) {
  return "".concat(p.right);
}, SpanTagStyle, static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx






var TOAST_BG_COLOR = {
  error: "#FCDADB",
  success: "#B8F5E0",
  default: "#4A4A4A"
};

var WebToast_WebToast = function WebToast(_ref) {
  var iconUrl = _ref.iconUrl,
      position = _ref.position,
      toastTxt = _ref.toastTxt,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      toastTxtMargin = _ref.toastTxtMargin,
      top = _ref.top,
      left = _ref.left,
      margin = _ref.margin,
      width = _ref.width,
      bottom = _ref.bottom,
      right = _ref.right,
      height = _ref.height,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "default" : _ref$type,
      color = _ref.color;
  return /*#__PURE__*/_jsxs(WebToastStyle, {
    top: top,
    bottom: bottom,
    right: right,
    left: left,
    width: width,
    height: height,
    margin: margin,
    position: position,
    justifyContent: type === "success" ? "center" : "space-between",
    background: TOAST_BG_COLOR[type],
    children: [iconUrl && /*#__PURE__*/_jsx(ImageComponent, {
      height: "15px",
      width: "15px",
      src: iconUrl
    }), toastTxt && /*#__PURE__*/_jsx(FlexComp, {
      gap: "10px",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: toastTxt,
        baseStyle: {
          fontSize: fontSize ? fontSize : "12px",
          fontWeight: fontWeight ? fontWeight : "normal",
          color: color ? color : "#FFFFFF",
          margin: toastTxtMargin ? toastTxtMargin : "10px"
        }
      })
    })]
  });
};

/* harmony default export */ var Toast_WebToast = ((/* unused pure expression or super */ null && (WebToast_WebToast)));
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/routeConstants.ts
var ROUTE_CONSTANTS = {
  LANDING_PAGE: "/insurance",
  LISTING_SCREEN: "/insurance/listing",
  TRAVELLER_DETAILS: "/insurance/traveller-details",
  PAYMENT_SUCCESS: "/insurance/paymentSuccess",
  PAYMENT_FAILURE: "/insurance/payment-failure",
  ADD_PASSPORT: "/insurance/add-passport",
  ORDER_CONFIRMED: "/insurance/order-confirmed",
  ORDER_LISTING: "/insurance/order-listing",
  ORDER_DETAILS: "/insurance/order-details",
  EDIT_TRAVELLERS: "/insurance/edit-travellers",
  DOWNLOAD_POLICY: "/insurance/download-policy",
  WEBVIEW_SCREEN: "/insurance/webview-screen"
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/navigator.ts


function navigator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function navigator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? navigator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : navigator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var router;
var setRouter = function setRouter(routerInstance) {
  if (!routerInstance) {
    throw new Error("Couldn't set router,routerInstance object is null or undefined");
  }

  router = routerInstance;
};

function getURLFromRouteAndParams(route, params) {
  var searchParams = new URLSearchParams(params).toString();
  var queryJoin = searchParams.length > 0 ? "?" : "";
  return "".concat(route).concat(queryJoin).concat(searchParams);
}

function forceRedirectOnWwwSubdomain(pathName) {
  if (typeof location === "undefined") return;
  var host = new URL(location.href).host;

  switch (host) {
    case "insurance.makemytrip.com":
      location.href = "https://www.makemytrip.com".concat(pathName);
      break;

    case "insurance.goibibo.com":
      location.href = "https://www.goibibo.com".concat(pathName);
      break;

    default:
      router.push(pathName);
  }
}

function forceRedirectOnInsuranceSubdomain(pathName) {
  if (typeof location === "undefined") return;
  var host = new URL(location.href).host;

  switch (host) {
    case "www.makemytrip.com":
      location.href = "https://insurance.makemytrip.com".concat(pathName);
      break;

    case "www.goibibo.com":
      location.href = "https://insurance.goibibo.com".concat(pathName);
      break;

    default:
      router.push(pathName);
  }
}

function injectCmpInParams(params) {
  var cmpVal = sessionStorage.getItem("cmp");

  if (typeof cmpVal === "string" && cmpVal != "") {
    params = navigator_objectSpread(navigator_objectSpread({}, params), {}, {
      cmp: cmpVal
    });
  }

  return params;
}

var navigator_navigationActions = {
  navigateToLanding: function navigateToLanding(params) {
    var shouldForceRedirectOnWwwSubdomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    params = injectCmpInParams(params);
    var pathName = getURLFromRouteAndParams(ROUTE_CONSTANTS.LANDING_PAGE, params);
    shouldForceRedirectOnWwwSubdomain ? forceRedirectOnWwwSubdomain(pathName) : router.push(pathName);
  },
  navigateToListing: function navigateToListing(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.LISTING_SCREEN, params));
  },
  navigateToTravellerDetails: function navigateToTravellerDetails(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.TRAVELLER_DETAILS, params));
  },
  navigateToAddPassport: function navigateToAddPassport(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ADD_PASSPORT, params));
  },
  navigateToOrderConfirmed: function navigateToOrderConfirmed(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_CONFIRMED, params));
  },
  navigateToOrderListing: function navigateToOrderListing(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_LISTING, params));
  },
  navigateToOrderDetails: function navigateToOrderDetails(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_DETAILS, params));
  },
  navigateToDownloadPolicy: function navigateToDownloadPolicy(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.DOWNLOAD_POLICY, params));
  },
  goBack: function goBack() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        forceExit = _ref.forceExit;

    if (forceExit) {
      window.history.go(-(window.history.length - 2));
    } else {
      router.back();
    }
  },
  navigateToPageByRouteName: function navigateToPageByRouteName(route, params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(route, params));
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts

;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/utils.ts



function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var getPlatform = {
  WEB: "web"
};
var utils_setURLQueryParams = function setURLQueryParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var usp = new URLSearchParams();
  Object.keys(params).forEach(function (e) {
    if (params[e]) {
      usp.set(e, params[e].toString());
    }
  });
  return usp.toString();
};
var getUtmParams = function getUtmParams() {
  if (true) {
    var utm_source = sessionStorage.getItem(UTM_PARAMS.UTM_SOURCE);
    var utm_medium = sessionStorage.getItem(UTM_PARAMS.UTM_MEDIUM);
    var utm_ins_campaign = sessionStorage.getItem(UTM_PARAMS.UTM_INS_CAMPAIGN);
    return {
      utm_source: utm_source,
      utm_medium: utm_medium,
      utm_ins_campaign: utm_ins_campaign
    };
  }

  return;
};
var persistUtmParams = function persistUtmParams(queryParam) {
  var utm_source = queryParam.get(UTM_PARAMS.UTM_SOURCE);
  var utm_medium = queryParam.get(UTM_PARAMS.UTM_MEDIUM);
  var utm_campaign = queryParam.get(UTM_PARAMS.UTM_CAMPAIGN);

  if (utm_source) {
    sessionStorage.setItem(UTM_PARAMS.UTM_SOURCE, utm_source);
  }

  if (utm_medium) {
    sessionStorage.setItem(UTM_PARAMS.UTM_MEDIUM, utm_medium);
  }

  if (utm_campaign) {
    sessionStorage.setItem(UTM_PARAMS.UTM_INS_CAMPAIGN, utm_campaign);
  }
};
var utils_replaceHistory = function replaceHistory(param, value) {
  if (true) {
    var baseUrl = window.location.pathname;
    var searchParams = new URLSearchParams(window.location.search);
    (value === null || value === void 0 ? void 0 : value.length) > 0 ? searchParams.set(param, value) : null;
    var url = "".concat(baseUrl).concat(searchParams.toString().length > 0 ? "?" + searchParams : "");
    window.history.replaceState(utils_objectSpread(utils_objectSpread({}, window.history.state), {}, {
      as: url,
      url: url
    }), "", url);
  }
};
var utils_replaceHistoryRemoveParams = function replaceHistoryRemoveParams(param) {
  var baseUrl = window.location.pathname;
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(param);
  var url = "".concat(baseUrl).concat(searchParams.toString().length > 0 ? "?" + searchParams : "");
  window.history.replaceState(utils_objectSpread(utils_objectSpread({}, window.history.state), {}, {
    as: url,
    url: url
  }), "", url);
};
var getCookieByName = function getCookieByName(cookieName) {
  var cookie = {};
  document.cookie.split(";").forEach(function (el) {
    var _el$split = el.split("="),
        _el$split2 = _slicedToArray(_el$split, 2),
        key = _el$split2[0],
        value = _el$split2[1];

    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};
var truncateString = function truncateString(value, maxLength) {
  if (!value) {
    return "";
  }

  if (value.length > maxLength) {
    return value.substring(0, maxLength) + "...";
  }

  return value;
};
var generateSourceSetImageUrl = function generateSourceSetImageUrl(cdnUrlWidths, imgUrl, width) {
  var imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(function (width) {
    return "".concat(imgUrl, "?im=Resize=(").concat(width, ") ").concat(width, "w");
  }).join(",");
};
var utils_getFormFieldErrorMsg = function getFormFieldErrorMsg(field, errorMsg) {
  if (errorMsg) {
    return errorMsg;
  } else {
    var fieldName = FORM_FIELDS_MAP[field] || field;
    return "Please enter ".concat(fieldName);
  }
};
var utils_isDobValid = function isDobValid(value, regex) {
  var formattedDate = formatDate(value, DATE_FORMATS["DD/MM/YYYY"]);
  var isValidDate = new RegExp(regex || "").test(formattedDate);
  return isValidDate;
};
var utils_getPartnerOnClientSide = function getPartnerOnClientSide() {
  var hostname = (0,ui_widgets_src.getHostName)() || "";

  if (hostname.includes(PARTNER_DOMAIN_NAME.MMT)) {
    return partner_PARTNER.MMT;
  } else if (hostname.includes(PARTNER_DOMAIN_NAME.GI)) {
    return partner_PARTNER.GI;
  } else if (hostname.includes(PARTNER_DOMAIN_NAME.TRIPMONEY)) {
    return partner_PARTNER.TRIPMONEY;
  } else {
    console.error("Error detecting partner. Unsupported domain hostname - ".concat(hostname));
    return partner_PARTNER.TRIPMONEY;
  }
};
var getPartnerOnServerSide = function getPartnerOnServerSide(headers) {
  if (isOnServer()) {
    var host = getHost(headers);

    if (typeof host === "string") {
      if (TRIPMONEY_DOMAIN_NAME.GI.includes(host)) {
        return PARTNER.GI;
      } else {
        return PARTNER.MMT;
      }
    }
  }

  return PARTNER.MMT;
};
var isPartnerMMT = function isPartnerMMT() {
  return utils_getPartnerOnClientSide() === partner_PARTNER.MMT;
};
var isPartnerGI = function isPartnerGI() {
  return utils_getPartnerOnClientSide() === partner_PARTNER.GI;
};
var utils_isFieldValid = function isFieldValid(regex, updatedField) {
  try {
    var validator = new RegExp(regex || "");
    return validator === null || validator === void 0 ? void 0 : validator.test(updatedField);
  } catch (error) {
    return false;
  }
};
var utils_debounce = function debounce(func, delay) {
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6522);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(2765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(6700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(9785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays_addDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subDays/index.js



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays_subDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addDays_addDays(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths_addMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMonths_addMonths(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/sub/index.js





/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  if (!duration || (0,esm_typeof/* default */.Z)(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,toInteger/* default */.Z)(duration.years) : 0;
  var months = duration.months ? (0,toInteger/* default */.Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,toInteger/* default */.Z)(duration.weeks) : 0;
  var days = duration.days ? (0,toInteger/* default */.Z)(duration.days) : 0;
  var hours = duration.hours ? (0,toInteger/* default */.Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,toInteger/* default */.Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,toInteger/* default */.Z)(duration.seconds) : 0;

  // Subtract years and months
  var dateWithoutMonths = subMonths(date, months + years * 12);

  // Subtract weeks and days
  var dateWithoutDays = subDays_subDays(dateWithoutMonths, days + weeks * 7);

  // Subtract hours, minutes and seconds
  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/dateUtils.ts


var dateUtils_convertDateToUnix = function convertDateToUnix(date) {
  if (date) {
    return Math.floor(new Date(date).getTime() / 1000);
  }

  return;
};
var dateUtils_convertUnixToDate = function convertUnixToDate(unix) {
  if (unix) {
    return new Date(unix * 1000);
  }

  return;
};
var dateUtils_formatDate = function formatDate(date, dateFormat) {
  if (date) {
    try {
      date = new Date(date);
      return format(date, dateFormat);
    } catch (error) {
      console.log("Error in formatting given date", "".concat(date, " | ").concat(dateFormat));
    }
  }

  return "";
};
var dateUtils_addDaysToDate = function addDaysToDate(date) {
  var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  try {
    return addDays(date, days);
  } catch (error) {
    console.log("Error in adding given days to date", "".concat(date, " | ").concat(days));
  }

  return;
};
var subtractDurationFromDate = function subtractDurationFromDate(date, duration) {
  if (date) {
    try {
      date = new Date(date);
      return sub(date, duration);
    } catch (error) {
      console.log("Error in subtracting given duration from date", "".concat(date, " | ").concat(duration));
    }
  }

  return new Date();
};
var subtractYrsFromDate = function subtractYrsFromDate(date, years) {
  if (date && years) {
    try {
      return subtractDurationFromDate(date, {
        years: years
      });
    } catch (error) {
      console.log("Error in subtracting given years from date", "".concat(date, " | ").concat(years));
    }
  }

  return new Date();
};
var isValidDate = function isValidDate(dateString) {
  var dateRegex = /^(0?[1-9]|[1-2][0-9]|3[0-1])\/(0?[1-9]|1[0-2])\/\d{4}$/;

  if (!dateRegex.test(dateString)) {
    return false;
  }

  var _dateString$split$map = dateString.split("/").map(Number),
      _dateString$split$map2 = _slicedToArray(_dateString$split$map, 3),
      day = _dateString$split$map2[0],
      month = _dateString$split$map2[1],
      year = _dateString$split$map2[2];

  var isValidDay = day >= 1 && day <= 31;
  var isValidMonth = month >= 1 && month <= 12;
  var isValidYear = year >= 1000 && year <= 9999;
  return isValidDay && isValidMonth && isValidYear;
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/travellerDetails.ts
var travellerDetails = {};
var travellerDetails_setTravDetailsInMemory = function setTravDetailsInMemory(value) {
  travellerDetails = value;
};
var travellerDetails_getTravDetailsFromMemory = function getTravDetailsFromMemory() {
  return travellerDetails;
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts





// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/constants.ts

var LOB_NAME_TM_INS = isPartnerMMT() ? "desktop tripmoney insurance" : "tripmoney insurance";
var LOB_NAME_PS_INS = isPartnerMMT() ? "desktop ps tripmoney insurance" : "ps tripmoney insurance";
var FUNNEL_SITE_SECTION = isPartnerMMT() ? "desktop tripmoney insurance Funnel" : "tripmoney insurance Funnel";
var LANDING_SITE_SECTION = "landing";
var PAGE_NAMES_MAP_MMT = {
  LANDING: "desktop:landing:mmt_insurance:homepage",
  LISTING: "desktop:funnel:mmt_insurance:listing",
  REVIEW: "desktop:funnel:mmt_insurance:review",
  PAYMENT: "desktop:funnel:mmt_insurance:payment",
  THANK_YOU_POLICY: "desktop:funnel:mmt_insurance:TY_policy",
  THANK_YOU_PASSPORT: "desktop:funnel:mmt_insurance:TY_passport",
  ADD_PASSPORT: "desktop:funnel:mmt_insurance:add_passport",
  ORDER_SUMMARY: "desktop:post_Sales:mmt_insurance:order_summary",
  ORDER_DETAILS: "desktop:post_Sales:mmt_insurance:order_details"
};
var PAGE_NAMES_MAP_GI = {
  LANDING: "landing:tripmoney insurance:landing",
  LISTING: "funnel:tripmoney insurance:listing",
  REVIEW: "funnel:tripmoney insurance:review",
  PAYMENT: "funnel:tripmoney insurance:payment",
  THANK_YOU_POLICY: "funnel:tripmoney insurance:thankyoupolicy",
  THANK_YOU_PASSPORT: "funnel:tripmoney insurance:thankyoupassport",
  ADD_PASSPORT: "funnel:tripmoney insurance:addpassport",
  ORDER_SUMMARY: "post sales:ps_tripmoney insurance:order_summary",
  ORDER_DETAILS: "post sales:ps_tripmoney insurance:order_details"
};
var PAGE_NAMES_MAP = isPartnerMMT() ? PAGE_NAMES_MAP_MMT : PAGE_NAMES_MAP_GI;
var pageNameCategoryMap = {
  LANDING: {
    pageName: PAGE_NAMES_MAP["LANDING"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION
  },
  LISTING: {
    pageName: PAGE_NAMES_MAP["LISTING"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  REVIEW: {
    pageName: PAGE_NAMES_MAP["REVIEW"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  PAYMENT: {
    pageName: PAGE_NAMES_MAP["PAYMENT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  THANK_YOU_POLICY: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_POLICY"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  THANK_YOU_PASSPORT: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  ADD_PASSPORT: {
    pageName: PAGE_NAMES_MAP["ADD_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  ORDER_DETAILS: {
    pageName: PAGE_NAMES_MAP["ORDER_DETAILS"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA"
  },
  ORDER_SUMMARY: {
    pageName: PAGE_NAMES_MAP["ORDER_SUMMARY"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA"
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/MmtAnalytics.ts





function MmtAnalytics_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MmtAnalytics_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MmtAnalytics_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MmtAnalytics_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var omnitureMap = {
  pageName: "eVar15",
  lob: "eVar24",
  siteSection: "m_ch",
  destination: "eVar31",
  ctaAction: "prop52",
  departureDate: "prop4",
  arrivalDate: "prop5",
  noOftravellers: "eVar8",
  travelPurpose: "eVar12",
  sumInsured: "prop46",
  bookingId: "eVar16",
  bookingStatus: "eVar14",
  errorCode: "eVar22",
  cmp: "m_v81",
  experiment: "eVar120"
};
var MmtAnalytics = /*#__PURE__*/function () {
  function MmtAnalytics() {
    (0,classCallCheck/* default */.Z)(this, MmtAnalytics);
  }

  (0,createClass/* default */.Z)(MmtAnalytics, [{
    key: "trackEvent",
    value: function trackEvent(pageName, omniData) {
      if (true) {
        omniData = MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({}, omniData), {}, {
          pageName: pageName
        });

        if (window.omniscriptLoaded) {
          if (typeof window.s !== "undefined") {
            var _window$s, _window$s$t;

            for (var _i = 0, _Object$entries = Object.entries(omniData); _i < _Object$entries.length; _i++) {
              var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
                  key = _Object$entries$_i[0],
                  value = _Object$entries$_i[1];

              window.s[key] = value;
            }

            (_window$s = window.s) === null || _window$s === void 0 ? void 0 : (_window$s$t = _window$s.t) === null || _window$s$t === void 0 ? void 0 : _window$s$t.call(_window$s);
          }
        } else {
          var _window$omnidata, _window$omnidata$push;

          (_window$omnidata = window.omnidata) === null || _window$omnidata === void 0 ? void 0 : (_window$omnidata$push = _window$omnidata.push) === null || _window$omnidata$push === void 0 ? void 0 : _window$omnidata$push.call(_window$omnidata, omniData);
        }
      }
    }
  }, {
    key: "trackPageLoadEvent",
    value: function trackPageLoadEvent(event) {
      var _objectSpread2;

      var _pageNameCategoryMap$ = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName],
          pageName = _pageNameCategoryMap$.pageName,
          lob = _pageNameCategoryMap$.lob,
          siteSection = _pageNameCategoryMap$.siteSection;

      var omniData = MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread((_objectSpread2 = {}, (0,defineProperty/* default */.Z)(_objectSpread2, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_objectSpread2, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_objectSpread2, omnitureMap["siteSection"], siteSection), _objectSpread2), (event === null || event === void 0 ? void 0 : event.bookingId) && (0,defineProperty/* default */.Z)({}, omnitureMap["bookingId"], event.bookingId)), (event === null || event === void 0 ? void 0 : event.bookingStatus) && (0,defineProperty/* default */.Z)({}, omnitureMap["bookingStatus"], event.bookingStatus)), (event === null || event === void 0 ? void 0 : event.experiment) && (0,defineProperty/* default */.Z)({}, omnitureMap["experiment"], event.experiment));

      if (event.pageName === "LISTING") {
        omniData = MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({}, omniData), event.country && (0,defineProperty/* default */.Z)({}, omnitureMap["destination"], event.country)), event.startDate && (0,defineProperty/* default */.Z)({}, omnitureMap["departureDate"], event.startDate)), event.endDate && (0,defineProperty/* default */.Z)({}, omnitureMap["arrivalDate"], event.endDate)), event.purpose && (0,defineProperty/* default */.Z)({}, omnitureMap["travelPurpose"], event.purpose)), event.travellers && (0,defineProperty/* default */.Z)({}, omnitureMap["noOftravellers"], event.travellers));
      }

      this.trackEvent(pageName, MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({}, omniData), (event === null || event === void 0 ? void 0 : event.bookingId) && {
        purchaseID: event.bookingId
      }));
    }
  }, {
    key: "trackPageLoadErrorEvent",
    value: function trackPageLoadErrorEvent(event) {
      var _omniData;

      var pageName = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName].pageName;
      var omniData = (_omniData = {}, (0,defineProperty/* default */.Z)(_omniData, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData, omnitureMap["ctaAction"], event.actionType), (0,defineProperty/* default */.Z)(_omniData, omnitureMap["errorCode"], event.error), _omniData);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackLandingEvents",
    value: function trackLandingEvents(event) {
      var _omniData2;

      var _pageNameCategoryMap$2 = pageNameCategoryMap.LANDING,
          pageName = _pageNameCategoryMap$2.pageName,
          lob = _pageNameCategoryMap$2.lob;
      var omniData = (_omniData2 = {}, (0,defineProperty/* default */.Z)(_omniData2, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData2, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData2, omnitureMap["ctaAction"], event.actionType), _omniData2);

      if (event.actionType === "other_countries_clicked" || event.actionType === "popular_country_selected" || event.actionType === "searched_countries" || event.actionType === "selected_countries") {
        omniData[omnitureMap["destination"]] = event.payload;
      } else if (event.actionType === "travel_date_selected") {
        omniData[omnitureMap["departureDate"]] = event.payload.departure;
        omniData[omnitureMap["arrivalDate"]] = event.payload.arrival;
      } else if (event.actionType === "error_shown") {
        omniData[omnitureMap["errorCode"]] = event.payload;
      }

      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackListingEvents",
    value: function trackListingEvents(event) {
      var _omniData3;

      var _pageNameCategoryMap$3 = pageNameCategoryMap.LISTING,
          pageName = _pageNameCategoryMap$3.pageName,
          lob = _pageNameCategoryMap$3.lob;
      var omniData = (_omniData3 = {}, (0,defineProperty/* default */.Z)(_omniData3, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData3, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData3, omnitureMap["ctaAction"], event.actionType), _omniData3);

      if (event.actionType === "error_shown") {
        omniData[omnitureMap["errorCode"]] = event.payload;
      } else if (event.actionType === "sum_insured_selected") {
        omniData[omnitureMap["sumInsured"]] = event.payload;
      }

      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackTravDetailsEvents",
    value: function trackTravDetailsEvents(event) {
      var _omniData4;

      var _pageNameCategoryMap$4 = pageNameCategoryMap.REVIEW,
          pageName = _pageNameCategoryMap$4.pageName,
          lob = _pageNameCategoryMap$4.lob;
      var omniData = (_omniData4 = {}, (0,defineProperty/* default */.Z)(_omniData4, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData4, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData4, omnitureMap["ctaAction"], event.actionType), _omniData4);

      if (event.actionType === "error_shown") {
        omniData[omnitureMap["errorCode"]] = event.payload;
      }

      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackThankYouEvents",
    value: function trackThankYouEvents(event) {
      var _omniData5;

      var _pageNameCategoryMap$5 = pageNameCategoryMap[event.pageName],
          pageName = _pageNameCategoryMap$5.pageName,
          lob = _pageNameCategoryMap$5.lob;
      var omniData = (_omniData5 = {}, (0,defineProperty/* default */.Z)(_omniData5, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData5, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData5, omnitureMap["ctaAction"], event.actionType), _omniData5);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackAddPassportEvents",
    value: function trackAddPassportEvents(event) {
      var _omniData6;

      var _pageNameCategoryMap$6 = pageNameCategoryMap.ADD_PASSPORT,
          pageName = _pageNameCategoryMap$6.pageName,
          lob = _pageNameCategoryMap$6.lob;
      var omniData = (_omniData6 = {}, (0,defineProperty/* default */.Z)(_omniData6, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData6, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData6, omnitureMap["ctaAction"], event.actionType), _omniData6);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackOrderSummaryEvents",
    value: function trackOrderSummaryEvents(event) {
      var _omniData7;

      var _pageNameCategoryMap$7 = pageNameCategoryMap.ORDER_SUMMARY,
          pageName = _pageNameCategoryMap$7.pageName,
          lob = _pageNameCategoryMap$7.lob;
      var omniData = (_omniData7 = {}, (0,defineProperty/* default */.Z)(_omniData7, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData7, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData7, omnitureMap["ctaAction"], event.actionType), _omniData7);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackOrderDetailsEvents",
    value: function trackOrderDetailsEvents(event) {
      var _omniData8;

      var _pageNameCategoryMap$8 = pageNameCategoryMap.ORDER_DETAILS,
          pageName = _pageNameCategoryMap$8.pageName,
          lob = _pageNameCategoryMap$8.lob;
      var omniData = (_omniData8 = {}, (0,defineProperty/* default */.Z)(_omniData8, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData8, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData8, omnitureMap["ctaAction"], event.actionType), _omniData8);
      this.trackEvent(pageName, omniData);
    }
  }]);

  return MmtAnalytics;
}();
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/GIAnalytics.ts




function GIAnalytics_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GIAnalytics_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GIAnalytics_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GIAnalytics_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var GIAnalytics = /*#__PURE__*/function () {
  function GIAnalytics() {
    (0,classCallCheck/* default */.Z)(this, GIAnalytics);
  }

  (0,createClass/* default */.Z)(GIAnalytics, [{
    key: "trackPageLoadEvent",
    value: function trackPageLoadEvent(event) {
      var _pageNameCategoryMap$ = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName],
          pageName = _pageNameCategoryMap$.pageName,
          lob = _pageNameCategoryMap$.lob,
          siteSection = _pageNameCategoryMap$.siteSection;
      var omniData = {
        event: "pageView",
        page: {
          pageInfo: GIAnalytics_objectSpread({
            pageName: pageName,
            lob: lob,
            section: siteSection
          }, event.experiment && {
            abVariant: event.experiment
          })
        },
        booking: GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, event.bookingId && {
          bookingId: event.bookingId
        }), event.bookingStatus && {
          paymentStatus: event.bookingStatus
        })
      };

      if (event.pageName === "LISTING") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          event: "tm_ins_listing_view",
          booking: GIAnalytics_objectSpread(GIAnalytics_objectSpread(GIAnalytics_objectSpread(GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, event.country && {
            routeCity: event.country
          }), event.startDate && {
            departureDate: event.startDate
          }), event.endDate && {
            returnDate: event.endDate
          }), event.purpose && {
            purposeOfTravel: event.purpose
          }), event.travellers && {
            pax: event.travellers
          })
        });
      }

      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackPageLoadErrorEvent",
    value: function trackPageLoadErrorEvent(event) {
      var pageName = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName].pageName;
      var omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName: pageName
          }
        },
        cta: {
          name: event.actionType
        },
        error: event.error
      };
      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackLandingEvents",
    value: function trackLandingEvents(event) {
      var _pageNameCategoryMap$2 = pageNameCategoryMap.LANDING,
          pageName = _pageNameCategoryMap$2.pageName,
          lob = _pageNameCategoryMap$2.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };

      if (event.actionType === "other_countries_clicked" || event.actionType === "popular_country_selected" || event.actionType === "searched_countries" || event.actionType === "selected_countries") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          booking: {
            routeCity: event.payload
          }
        });
      } else if (event.actionType === "travel_date_selected") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          booking: {
            departureDate: event.payload.departure,
            returnDate: event.payload.arrival
          }
        });
      } else if (event.actionType === "error_shown") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          error: event.payload
        });
      }

      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackListingEvents",
    value: function trackListingEvents(event) {
      var _pageNameCategoryMap$3 = pageNameCategoryMap.LISTING,
          pageName = _pageNameCategoryMap$3.pageName,
          lob = _pageNameCategoryMap$3.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };

      if (event.actionType === "sum_insured_selected") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          booking: {
            sumInsuredValue: event.payload
          }
        });
      }

      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackTravDetailsEvents",
    value: function trackTravDetailsEvents(event) {
      var _pageNameCategoryMap$4 = pageNameCategoryMap.REVIEW,
          pageName = _pageNameCategoryMap$4.pageName,
          lob = _pageNameCategoryMap$4.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };

      if (event.actionType === "error_shown") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          error: event.payload
        });
      }

      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackThankYouEvents",
    value: function trackThankYouEvents(event) {
      var _pageNameCategoryMap$5 = pageNameCategoryMap[event.pageName],
          pageName = _pageNameCategoryMap$5.pageName,
          lob = _pageNameCategoryMap$5.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackAddPassportEvents",
    value: function trackAddPassportEvents(event) {
      var _pageNameCategoryMap$6 = pageNameCategoryMap.ADD_PASSPORT,
          pageName = _pageNameCategoryMap$6.pageName,
          lob = _pageNameCategoryMap$6.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackOrderSummaryEvents",
    value: function trackOrderSummaryEvents(event) {
      var _pageNameCategoryMap$7 = pageNameCategoryMap.ORDER_SUMMARY,
          pageName = _pageNameCategoryMap$7.pageName,
          lob = _pageNameCategoryMap$7.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }, {
    key: "trackOrderDetailsEvents",
    value: function trackOrderDetailsEvents(event) {
      var _pageNameCategoryMap$8 = pageNameCategoryMap.ORDER_DETAILS,
          pageName = _pageNameCategoryMap$8.pageName,
          lob = _pageNameCategoryMap$8.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      (0,analytics/* pushEvent */.AB)(omniData);
    }
  }]);

  return GIAnalytics;
}();
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/analyticsWrapper.ts



var analyticsWrapper_analytics = null;
function getAnalytics() {
  if (analyticsWrapper_analytics === null && isPartnerMMT()) {
    analyticsWrapper_analytics = new MmtAnalytics();
  } else if (analyticsWrapper_analytics === null && isPartnerGI()) {
    analyticsWrapper_analytics = new GIAnalytics();
  }

  return analyticsWrapper_analytics;
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravelDetails.style.ts





var TravelDetailsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__TravelDetailsStyle",
  componentId: "sc-4x930j-0"
})(["background:#ffffff;padding:30px;"]);
var TravelDetails_style_TravellingToStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyle",
  componentId: "sc-4x930j-1"
})(["background:#ffffff;padding:30px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;position:relative;@media ", "{padding:16px;margin-bottom:36px;}"], utils/* deviceType.mobile */.vO.mobile);
var TravelDetails_style_PopularCountry = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountry",
  componentId: "sc-4x930j-2"
})(["display:flex;flex-wrap:wrap;gap:8px;label{left:0 !important;position:absolute;bottom:8px;z-index:1;}@media ", "{margin-bottom:16px;display:grid;grid-template-columns:repeat(3,1fr);grid-gap:14px;width:calc(100vw - 64px);}"], utils/* deviceType.mobile */.vO.mobile);
var TravelDetails_style_PopularCountryItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountryItem",
  componentId: "sc-4x930j-3"
})(["background:linear-gradient(228.82deg,#43c6ac 2.05%,#191654 93.35%);border:1px solid #fff;border-radius:6px;z-index:1;padding:8px;overflow:hidden;width:80px;height:82px;position:relative;flex-shrink:0;cursor:pointer;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);", " > div{cursor:pointer;}picture{height:82px;}@media ", "{width:unset;height:82px;picture{height:82px;}}"], function (p) {
  return p.listSelected && "\n        border: 1px solid #008cff;\n        ";
}, utils/* deviceType.mobile */.vO.mobile);
var TravelDetails_style_OtherCountyBtn = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__OtherCountyBtn",
  componentId: "sc-4x930j-4"
})(["display:flex;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);flex-direction:column;gap:8px;width:80px;height:82px;background:#fff;border-radius:6px;padding:8px;cursor:pointer;@media ", "{width:unset;height:82px;gap:6px;}"], utils/* deviceType.mobile */.vO.mobile);
var TravelDetails_style_CountryImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__CountryImg",
  componentId: "sc-4x930j-5"
})(["position:absolute;top:0px;left:0px;bottom:0;z-index:-1;max-width:100%;max-height:100%;width:100%;picture{width:100%;}picture img{width:80px;height:80px;}:after{content:\"\";position:absolute;border-radius:0px 0px 6px 6px;background:linear-gradient( 180deg,rgba(106,106,106,0) 0%,rgba(0,0,0,0.7) 100% );width:100%;height:32px;bottom:1px;left:0;}@media ", "{picture img{width:100%;height:82px;}}"], utils/* deviceType.mobile */.vO.mobile);
var TravelDetails_style_TravelNote = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__TravelNote",
  componentId: "sc-4x930j-6"
})(["background:linear-gradient( 85.23deg,rgba(67,225,168,0.5) 0%,rgba(33,147,147,0.5) 100% );border-radius:8px 8px 0px 0px;padding:8px 78px;margin:0 auto;color:#fff;font-size:16px;width:550px;text-align:center;em{font-weight:600;color:#8beecd;font-style:normal;}@media ", "{width:92%;padding:12px;font-size:12px;text-align:center;padding-bottom:24px;margin-bottom:-12px;}@media ", "{", "}"], utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.desktop */.vO.desktop, function (p) {
  return p.pageTheme === partner_PARTNER.MMT ? "\n        background: linear-gradient(45deg, #43E1A8 0%, #219393 100%);\n    " : p.pageTheme === partner_PARTNER.GI ? "background: #18A160;" : "";
});
var TravelDetails_style_DiscountingNote = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__DiscountingNote",
  componentId: "sc-4x930j-7"
})(["border-radius:8px 8px 0px 0px;padding:8px 0px 8px 16px;margin:0 auto;color:", ";width:550px;display:flex;align-items:center;@media ", "{width:92%;padding:12px;padding-bottom:24px;margin-bottom:-12px;background:#e4fbf4;}@media ", "{background:#e4fbf4;}"], Global/* theme.greyText5 */.rS.greyText5, utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.desktop */.vO.desktop);
var TravelDetails_style_TravellingToStyleWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyleWrap",
  componentId: "sc-4x930j-8"
})([""]);
var TravelDetails_style_UpcomingTripStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripStyle",
  componentId: "sc-4x930j-9"
})(["display:flex;align-items:center;justify-content:space-between;background:#ffffff;border-radius:6px;padding:24px 12px 12px;margin-bottom:16px;position:relative;cursor:pointer;", " ", "{width:24px;height:24px;}&::before{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border:1px solid transparent;background:", ";-webkit-mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;border-radius:6px;}"], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n  ";
}, TextStyles_style_AnchorTagStyle, Global/* theme.purpleGradient */.rS.purpleGradient);
var TravelDetails_style_UpcomingTripTag = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripTag",
  componentId: "sc-4x930j-10"
})(["background:", ";padding:2px 6px;border-radius:6px 0px 6px 0px;width:fit-content;position:absolute;top:0;left:0;display:flex;"], Global/* theme.purpleGradient */.rS.purpleGradient);
var TravelDetails_style_BgText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "TravelDetailsstyle__BgText",
  componentId: "sc-4x930j-11"
})(["background:radial-gradient( 59.37% 231.91% at 3.11% 23.44%,rgba(255,255,255,0.24) 0%,rgba(255,255,255,0.144) 100% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-style:normal;font-weight:700;font-size:56px;line-height:64px;position:absolute;top:-59px;right:6px;"]);
var TravelDetails_style_TripUpcoming = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravelDetailsstyle__TripUpcoming",
  componentId: "sc-4x930j-12"
})(["background:linear-gradient( 91.22deg,#9c005e 1.88%,rgba(22,20,60,0.2) 100% );padding:2px 8px;color:#fff;position:absolute;bottom:24px;left:-10px;white-space:nowrap;width:100%;font-weight:400;font-size:9px;line-height:11px;text-transform:uppercase;text-wrap:wrap;"]);
var TravelDetails_style_CountryNameTxt = styled_components_browser_esm["default"].span.withConfig({
  displayName: "TravelDetailsstyle__CountryNameTxt",
  componentId: "sc-4x930j-13"
})(["display:-webkit-box;color:#ffffff;font-size:12px;-webkit-line-clamp:2;font-weight:700;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;white-space:normal;width:75%;text-shadow:0px 0px 8px rgba(0,0,0,0.8);"]);
// EXTERNAL MODULE: ../../libs/auth/src/lib/hooks/useDeviceContext.ts
var useDeviceContext = __webpack_require__(5766);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/PopularCountryCompV2.tsx









var PopularCountryCompV2_PopularCountryComp = function PopularCountryComp(_ref) {
  var popCountry = _ref.popCountry,
      handleShowOtherCountry = _ref.handleShowOtherCountry,
      otherCountryTxt = _ref.otherCountryTxt,
      handlePopularCountrySelect = _ref.handlePopularCountrySelect,
      setIsSelectedError = _ref.setIsSelectedError;
  var device = useBreakpointV2();
  var isCheckedHandler = useCallback(function (data) {
    return data === null || data === void 0 ? void 0 : data.isSelected;
  }, [popCountry]);
  var handleErrorToast = debounce(function () {
    setIsSelectedError(false);
  }, 3000);

  var handleCountrySelect = function handleCountrySelect(item) {
    if (item.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      handlePopularCountrySelect(item.code);
    }
  };

  return /*#__PURE__*/_jsxs(PopularCountry, {
    children: [popCountry && popCountry.map(function (item, index) {
      return /*#__PURE__*/_jsxs(PopularCountryItem, {
        listSelected: isCheckedHandler(item),
        onClick: function onClick() {
          return handleCountrySelect(item);
        },
        children: [index !== popCountry.length && /*#__PURE__*/_jsxs(CheckButton, {
          isDisabled: item.isDisabled,
          isChecked: item.isDisabled ? true : isCheckedHandler(item),
          children: [!item.img && item.name && /*#__PURE__*/_jsx(BgText, {
            children: item === null || item === void 0 ? void 0 : item.code
          }), item.upcomingTrip && /*#__PURE__*/_jsx(TripUpcoming, {
            children: "TRIP UPCOMING"
          }), (item === null || item === void 0 ? void 0 : item.name) && !item.subtitle && /*#__PURE__*/_jsx(CountryNameTxt, {
            title: item.name,
            children: item === null || item === void 0 ? void 0 : item.name
          }), (item === null || item === void 0 ? void 0 : item.name) && item.subtitle && /*#__PURE__*/_jsx(CountryNameTxt, {
            title: item.name + item.subtitle,
            children: (item === null || item === void 0 ? void 0 : item.name) + " " + item.subtitle
          })]
        }), (item === null || item === void 0 ? void 0 : item.img) && /*#__PURE__*/_jsx(CountryImg, {
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: device == "sm" ? "100%" : "80px",
            height: device == "lg" ? "80px" : "82px",
            src: item.img,
            loading: "eager"
          })
        })]
      }, index);
    }), /*#__PURE__*/_jsxs(OtherCountyBtn, {
      onClick: handleShowOtherCountry,
      children: [/*#__PURE__*/_jsx(ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
        loading: "eager"
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: theme.blueText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: otherCountryTxt
        })
      })]
    })]
  });
};

/* harmony default export */ var PopularCountryCompV2 = ((/* unused pure expression or super */ null && (PopularCountryCompV2_PopularCountryComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/UpcomingTrips.tsx









var UpcomingTrips_analytics = getAnalytics();

var UpcomingTrips_UpcomingTrips = function UpcomingTrips(_ref) {
  var country = _ref.country,
      travelDuration = _ref.travelDuration,
      travellerNum = _ref.travellerNum,
      travellerTitle = _ref.travellerTitle,
      handleUpcomingTripClick = _ref.handleUpcomingTripClick;
  var device = useBreakpointV2();

  var _useState = useState(false),
      isUpcomingTripSelected = _useState[0],
      setIsUpcomingTripSelected = _useState[1];

  useEffect(function () {
    var queryParams = new URLSearchParams(window.location.search);
    var isUpcomingTrip = queryParams.get("isUpcomingTrip");

    if (isUpcomingTrip) {
      setIsUpcomingTripSelected(true);
    }

    UpcomingTrips_analytics === null || UpcomingTrips_analytics === void 0 ? void 0 : UpcomingTrips_analytics.trackLandingEvents({
      actionType: "upcoming_trips_shown"
    });
  }, []);

  var showFormattedDate = function showFormattedDate(date) {
    if (date) {
      var dateValue = convertUnixToDate(date);
      return formatDate(dateValue, DATE_FORMATS["DD MMM YY"]);
    }

    return "";
  };

  return /*#__PURE__*/_jsxs(UpcomingTripStyle, {
    selected: isUpcomingTripSelected,
    onClick: handleUpcomingTripClick,
    children: [" ", /*#__PURE__*/_jsx(UpcomingTripTag, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xxs",
        color: theme.whiteText,
        children: "UPCOMING TRIP"
      })
    }), /*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsxs(SpanTag, {
        fontWeight: "bold",
        children: [/*#__PURE__*/_jsx(FormattedText, {
          value: country
        }), "\xA0"]
      }), /*#__PURE__*/_jsxs(SpanTag, {
        fontSize: "xs",
        color: theme.greyText,
        children: [" ".concat(showFormattedDate(travelDuration === null || travelDuration === void 0 ? void 0 : travelDuration.startDate), " - ").concat(showFormattedDate(travelDuration === null || travelDuration === void 0 ? void 0 : travelDuration.endDate)), " ", "| ", travellerNum, " ", /*#__PURE__*/_jsx(FormattedText, {
          value: travellerTitle
        })]
      })]
    }), /*#__PURE__*/_jsx(AnchorTag, {
      children: /*#__PURE__*/_jsx(ImageTag, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
        width: "16px",
        height: "16px"
      })
    })]
  });
};

/* harmony default export */ var TravelDetails_UpcomingTrips = ((/* unused pure expression or super */ null && (UpcomingTrips_UpcomingTrips)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravellingTo.tsx



function TravellingTo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravellingTo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravellingTo_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravellingTo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var TravellingTo_analytics = getAnalytics();

var TravellingTo = function TravellingTo(_ref) {
  var _upcomingTrip$travelD, _upcomingTrip$travelD2;

  var travellingToSection = _ref.travellingToSection,
      upcomingTrip = _ref.upcomingTrip,
      calendarDatesLimit = _ref.calendarDatesLimit,
      travelSearchBanner = _ref.travelSearchBanner,
      _ref$btnDisabledState = _ref.btnDisabledState,
      btnDisabledState = _ref$btnDisabledState === void 0 ? true : _ref$btnDisabledState,
      nextPageRoute = _ref.nextPageRoute;
  var device = useBreakpointV2();
  var context = usePartnerContext();

  var _ref2 = travellingToSection || {},
      otherCountryTxt = _ref2.otherCountryTxt,
      travelNote = _ref2.travelNote,
      travDateTitle = _ref2.travDateTitle,
      travCountTitle = _ref2.travCountTitle,
      travPurpTitle = _ref2.travPurpTitle,
      travelPurposeTxt = _ref2.travelPurposeTxt,
      popularCountryTxt = _ref2.popularCountryTxt,
      travelBtnTxt = _ref2.travelBtnTxt,
      travelSearchForm = _ref2.travelSearchForm;

  var _travelSearchForm$reg = travelSearchForm.regionCountryList,
      label = _travelSearchForm$reg.label,
      error_message = _travelSearchForm$reg.error_message,
      countrySelectErrMsg = _travelSearchForm$reg.countrySelectErrMsg,
      placeHolder = _travelSearchForm$reg.placeHolder,
      value = _travelSearchForm$reg.value;

  var _useState = useState([]),
      popularCountries = _useState[0],
      setPopularCountries = _useState[1];

  var _useState2 = useState([]),
      countryData = _useState2[0],
      setCountryData = _useState2[1];

  var _useState3 = useState(false),
      showOtherCountry = _useState3[0],
      setOtherCountry = _useState3[1];

  var _useState4 = useState(0),
      countValue = _useState4[0],
      setCountValue = _useState4[1];

  var _useState5 = useState(),
      calenderValue = _useState5[0],
      setCalenderValue = _useState5[1];

  var _useState6 = useState([]),
      showCountry = _useState6[0],
      setShowCountry = _useState6[1];

  var _useState7 = useState(false),
      isCountryError = _useState7[0],
      setIsCountryError = _useState7[1];

  var _useState8 = useState(""),
      descriptionTxt = _useState8[0],
      setDescriptionTxt = _useState8[1];

  var _useState9 = useState(false),
      isSelectedError = _useState9[0],
      setIsSelectedError = _useState9[1];

  var _useState10 = useState(""),
      descTitle = _useState10[0],
      setDescTitle = _useState10[1];

  useEffect(function () {
    var queryParams = new URLSearchParams(window.location.search);
    var selectedCountries = queryParams.get("countries");
    var selectedCountryCodes;

    if (selectedCountries) {
      selectedCountryCodes = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.split(",");
    } else if (upcomingTrip !== null && upcomingTrip !== void 0 && upcomingTrip.countryCode) {
      selectedCountryCodes = upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode;
      replaceHistory("countries", upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode);
    }

    var totalCountryData = value.map(function (data) {
      var _selectedCountryCodes;

      if ((_selectedCountryCodes = selectedCountryCodes) !== null && _selectedCountryCodes !== void 0 && _selectedCountryCodes.includes(data.code)) {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return TravellingTo_objectSpread({}, data);
    });
    var selectedRegionCodes = totalCountryData.filter(function (data) {
      return data.isSelected && data.type === "REGION";
    }).map(function (data) {
      return data.code;
    });
    selectedRegionCodes.map(function (code) {
      totalCountryData = totalCountryData.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(code)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    setCountryData(totalCountryData);
    var popularCountryData = totalCountryData.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    popularCountryData = [].concat(_toConsumableArray(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    })));
    setShowCountry(_toConsumableArray(popularCountryData));
    setPopularCountries(_toConsumableArray(popularCountryData));
  }, [value, upcomingTrip]);

  var populateTravelDetails = function populateTravelDetails(countryCodes, startDate, endDate, travellers) {
    if (countryCodes) {
      replaceHistory("countries", countryCodes);
    }

    if (startDate) {
      replaceHistory("startDate", startDate);
    }

    if (endDate) {
      replaceHistory("endDate", endDate);
    }

    if (travellers) {
      replaceHistory("travellers", travellers);
    }
  };

  var handleUpcomingTripClick = function handleUpcomingTripClick() {
    var _travelDuration$start, _travelDuration$endDa;

    replaceHistory("isUpcomingTrip", "true");
    removeSessionStorageItem(STORAGE_KEYS.TRAVELLER_DETAILS);
    TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
      actionType: "upcoming_trips_clicked"
    });

    var _ref3 = upcomingTrip || {},
        countryCode = _ref3.countryCode,
        travelDuration = _ref3.travelDuration,
        travellerNum = _ref3.travellerNum;

    var selectedCountry = countryData === null || countryData === void 0 ? void 0 : countryData.find(function (country) {
      return country.code === countryCode;
    });
    populateTravelDetails(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code, travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$start = travelDuration.startDate) === null || _travelDuration$start === void 0 ? void 0 : _travelDuration$start.toString(), travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$endDa = travelDuration.endDate) === null || _travelDuration$endDa === void 0 ? void 0 : _travelDuration$endDa.toString(), travellerNum === null || travellerNum === void 0 ? void 0 : travellerNum.toString());

    if (nextPageRoute) {
      navigationActions.navigateToPageByRouteName("".concat(nextPageRoute, "&isUpcomingTrip=true"));
    } else {
      var _travelDuration$start2, _travelDuration$endDa2, _travellerNum$toStrin;

      var data = {
        startDate: travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$start2 = travelDuration.startDate) === null || _travelDuration$start2 === void 0 ? void 0 : _travelDuration$start2.toString(),
        endDate: travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$endDa2 = travelDuration.endDate) === null || _travelDuration$endDa2 === void 0 ? void 0 : _travelDuration$endDa2.toString(),
        travellers: travellerNum === null || travellerNum === void 0 ? void 0 : (_travellerNum$toStrin = travellerNum.toString) === null || _travellerNum$toStrin === void 0 ? void 0 : _travellerNum$toStrin.call(travellerNum),
        countries: [countryCode],
        isUpcomingTrip: true
      };
      navigationActions.navigateToListing(data);
    }
  };

  var handleShowOtherCountry = function handleShowOtherCountry() {
    if (!showOtherCountry) {
      var countryDataArr = countryData === null || countryData === void 0 ? void 0 : countryData.map(function (country) {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: false
        });
      });
      popularCountries.map(function (data) {
        var _countryDataArr;

        countryDataArr = (_countryDataArr = countryDataArr) === null || _countryDataArr === void 0 ? void 0 : _countryDataArr.map(function (country) {
          if (country.code === data.code) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isSelected: data.isSelected
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });
      var selectedRegionCodes = countryDataArr.filter(function (data) {
        return data.isSelected && data.type === "REGION";
      }).map(function (data) {
        return data.code;
      });
      selectedRegionCodes.map(function (code) {
        countryDataArr = countryDataArr.map(function (country) {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isDisabled: true
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });
      setCountryData(countryDataArr);
    }

    setOtherCountry(!showOtherCountry);
  };

  var handleDescriptionModal = function handleDescriptionModal(country) {
    var clickedTime = getSessionStorageItem("clickedTime") ? getSessionStorageItem("clickedTime") : {};
    var currentTime = new Date().getTime();
    var code = country.code;

    if (!clickedTime[country.code] || currentTime - parseInt(clickedTime[country.code], 10) >= 1800000) {
      clickedTime[code] = currentTime.toString();
      setSessionStorageItem("clickedTime", TravellingTo_objectSpread({}, clickedTime));
      return country.description;
    }

    return "";
  };

  var handlePopularCountrySelect = function handlePopularCountrySelect(code) {
    setIsCountryError(false);
    var popularCountryArr = popularCountries === null || popularCountries === void 0 ? void 0 : popularCountries.map(function (country) {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return TravellingTo_objectSpread({}, country);
        }

        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }

        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var selectedPopRegionCodes = popularCountryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedPopRegionCodes.map(function (item) {
      popularCountryArr = popularCountryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    var countries = popularCountryArr.filter(function (data) {
      return data.isSelected && !data.isDisabled;
    }).map(function (data) {
      return data.code;
    }).join(",");

    if (countries) {
      replaceHistory("countries", countries);
    } else {
      replaceHistoryRemoveParams("countries");
    }
  };

  var onSubmit = function onSubmit() {
    var searchParams = new URLSearchParams(window.location.search);
    var queryParams = Object.fromEntries(searchParams.entries());
    var countries = searchParams.get("countries");
    var isUpcomingTrip = searchParams.get("isUpcomingTrip");
    var countryCodes = countries === null || countries === void 0 ? void 0 : countries.split(",");

    if (!countryCodes) {
      setIsCountryError(true);
      TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
        actionType: "error_shown",
        payload: error_message
      });
    }

    if (isUpcomingTrip) {
      replaceHistoryRemoveParams("isUpcomingTrip");
      removeSessionStorageItem(STORAGE_KEYS.TRAVELLER_DETAILS);
    }

    if (calenderValue && countValue && countryCodes !== null && countryCodes !== void 0 && countryCodes.length) {
      var selectedPopCountries = (popularCountries !== null && popularCountries !== void 0 ? popularCountries : []).filter(function (country) {
        return countryCodes === null || countryCodes === void 0 ? void 0 : countryCodes.includes(country.code);
      }).map(function (item) {
        return item.name;
      }).join("|");
      TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
        actionType: "popular_country_selected",
        payload: selectedPopCountries
      });

      var params = TravellingTo_objectSpread(TravellingTo_objectSpread({}, queryParams), {}, {
        startDate: convertDateToUnix(calenderValue.from).toString(),
        endDate: calenderValue.to ? convertDateToUnix(calenderValue.to).toString() : searchParams.get("endDate"),
        travellers: countValue,
        countries: countryCodes
      });

      TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
        actionType: "explore_plan_click"
      });
      navigationActions.navigateToListing(params);
    }
  };

  var _useState11 = useState(false),
      scrollPerformed = _useState11[0],
      setScrollPerformed = _useState11[1];

  var buttonRef = useRef(null);
  useEffect(function () {
    var button = buttonRef.current;

    if (button) {
      var isButtonInView = button.getBoundingClientRect().bottom < window.innerHeight; //button is in view returns true

      if (!isButtonInView && scrollPerformed == false) {
        var buttonVisible = device === "lg" ? 20 : 200;
        var scrollAmount = button.getBoundingClientRect().bottom - window.innerHeight + buttonVisible;
        button.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest"
        });
        window.scrollBy(0, scrollAmount);
        setScrollPerformed(true);
      }
    }
  }, []);
  return /*#__PURE__*/_jsxs(TravellingToStyleWrap, {
    children: [travelSearchBanner ? /*#__PURE__*/_jsxs(DiscountingNote, {
      pageTheme: context ? context : "mmt",
      children: [(travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.icon) && /*#__PURE__*/_jsx("img", {
        width: "24px",
        height: "24px",
        src: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.icon,
        style: {
          animation: "rotate 2s linear infinite"
        },
        loading: "eager"
      }), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: device === "sm" ? "column" : "row",
        margin: "0px 0px 0px 4px",
        gap: device === "lg" ? "4px" : "0px",
        children: [(travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.title) && /*#__PURE__*/_jsx(FormattedText, {
          value: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.title,
          baseStyle: {
            fontWeight: "bold",
            fontSize: device === "lg" ? "16px" : "12px",
            color: theme.greenText5
          }
        }), (travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.description) && /*#__PURE__*/_jsx(FormattedText, {
          value: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.description,
          baseStyle: {
            fontWeight: "regular",
            fontSize: device === "lg" ? "14px" : "12px",
            marginTop: device === "lg" ? "2px" : "0px",
            color: theme.greenText5
          }
        })]
      })]
    }) : /*#__PURE__*/_jsx(TravelNote, {
      pageTheme: context ? context : "mmt",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: travelNote
      })
    }), /*#__PURE__*/_jsxs(TravellingToStyle, {
      children: [/*#__PURE__*/_jsx(H5Tag, {
        color: theme.blackText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: label
        })
      }), /*#__PURE__*/_jsx(ParaTag, {
        margin: "0px 0px 20px 0px",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: placeHolder,
          baseStyle: {
            color: "#717171"
          }
        })
      }), upcomingTrip && /*#__PURE__*/_jsx(UpcomingTrips, {
        country: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.country,
        countryCode: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode,
        travelDuration: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travelDuration,
        travellerNum: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerNum,
        travellerTitle: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerTitle,
        handleUpcomingTripClick: handleUpcomingTripClick
      }), /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greyText7,
        fontWeight: "bold",
        fontSize: "xs",
        margin: "2px 0 8px",
        children: popularCountryTxt && /*#__PURE__*/_jsx(FormattedText, {
          value: "Popular Destination"
        })
      }), /*#__PURE__*/_jsx(PopularCountryComp, {
        otherCountryTxt: otherCountryTxt,
        handleShowOtherCountry: handleShowOtherCountry,
        popCountry: showCountry,
        setIsSelectedError: setIsSelectedError,
        handlePopularCountrySelect: handlePopularCountrySelect
      }), isCountryError && /*#__PURE__*/_jsx(ParaTag, {
        color: theme.redText2,
        fontSize: "xs",
        margin: device === "sm" ? "0 0 8px" : "8px 0 0",
        children: error_message
      }), device == "lg" && /*#__PURE__*/_jsx(SectionDividers, {
        margin: "14px -30px 14px",
        backgroundColor: "#FFFFFF",
        xs: true
      }), /*#__PURE__*/_jsx(TravellingToWidget, {
        travelPurposeTxt: travelPurposeTxt,
        travCountTitle: travCountTitle,
        travPurpTitle: travPurpTitle,
        travDateTitle: travDateTitle,
        btnDisabledState: btnDisabledState,
        setCountValue: setCountValue,
        calendarDatesLimit: calendarDatesLimit,
        setCalenderValue: setCalenderValue,
        upcomingTravellerNum: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerNum,
        upcomingFromDate: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : (_upcomingTrip$travelD = upcomingTrip.travelDuration) === null || _upcomingTrip$travelD === void 0 ? void 0 : _upcomingTrip$travelD.startDate,
        upcomingToDate: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : (_upcomingTrip$travelD2 = upcomingTrip.travelDuration) === null || _upcomingTrip$travelD2 === void 0 ? void 0 : _upcomingTrip$travelD2.endDate
      }), travelBtnTxt && /*#__PURE__*/_jsx(LandingButton, {
        buttonref: buttonRef,
        customWidth: "100%",
        customTitle: travelBtnTxt,
        onClick: onSubmit
      }), /*#__PURE__*/_jsx(ParaTag, {
        color: theme.greyText,
        margin: "16px 0 0",
        children: travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.disclaimer
      }), showOtherCountry && device == "lg" && /*#__PURE__*/_jsx(SelectCountryModalV2, {
        countryData: countryData,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        showCountry: showCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal
      }), showOtherCountry && device == "sm" && /*#__PURE__*/_jsx(SelectCountryModalSheetV2, {
        countryData: countryData,
        showCountry: showCountry,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal
      }), descriptionTxt && /*#__PURE__*/_jsx(DescriptionModal, {
        handleDescriptionModal: function handleDescriptionModal() {
          return setDescriptionTxt("");
        },
        value: descriptionTxt,
        title: descTitle
      }), isSelectedError && device === "lg" && /*#__PURE__*/_jsx(WebToast, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px"
      }), isSelectedError && device === "sm" && /*#__PURE__*/_jsx(WebToast, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "10px"
      })]
    })]
  });
};

/* harmony default export */ var TravelDetails_TravellingTo = ((/* unused pure expression or super */ null && (TravellingTo)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DomesticTravelDetail/DomesticTravelDetail.style.ts

var DomesticTravelDetail_style_DomesticTripStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DomesticTravelDetailstyle__DomesticTripStyle",
  componentId: "sc-813ho8-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:8px;"]);
var DomesticTravelDetail_style_ContainerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DomesticTravelDetailstyle__ContainerStyle",
  componentId: "sc-813ho8-1"
})(["display:flex;", ";", ";"], function (props) {
  return props.flexDirection && "flex-direction: ".concat(props.flexDirection);
}, function (props) {
  return props.gap && "gap: ".concat(props.gap);
});
var DomesticTravelDetail_style_TagStyle = styled_components_browser_esm["default"].span.withConfig({
  displayName: "DomesticTravelDetailstyle__TagStyle",
  componentId: "sc-813ho8-2"
})(["color:#ffffff;padding:2px 8px 2px 8px;font-weight:600;font-size:10px;align-items:center;border-radius:8px 0px 8px 0px;", ";"], function (props) {
  var _props$startColor, _props$endColor;

  return "background: linear-gradient(45deg, ".concat((_props$startColor = props === null || props === void 0 ? void 0 : props.startColor) !== null && _props$startColor !== void 0 ? _props$startColor : "#00d2ff", " 14.64%, ").concat((_props$endColor = props === null || props === void 0 ? void 0 : props.endColor) !== null && _props$endColor !== void 0 ? _props$endColor : "#3a7bd5", " 85.36%)");
});
var DomesticTravelDetail_style_ArrowButtonWrap = styled_components_browser_esm["default"].span.withConfig({
  displayName: "DomesticTravelDetailstyle__ArrowButtonWrap",
  componentId: "sc-813ho8-3"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var DomesticTravelDetail_style_BannerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DomesticTravelDetailstyle__BannerStyle",
  componentId: "sc-813ho8-4"
})(["display:flex;background:#eaf5ff;padding:8px 15px 12px 16px;border-radius:0px 0px 8px 8px;gap:8px;font-size:14px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DomesticTravelDetail/DomesticTrip.tsx


function DomesticTrip_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DomesticTrip_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DomesticTrip_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DomesticTrip_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var DomesticTrip_analytics = getAnalytics();

var DomesticTrip = function DomesticTrip(_ref) {
  var _tripData$tag, _tripData$tag2, _tripData$tag3, _tripData$banner;

  var trips = _ref.trips,
      title = _ref.title;
  var device = useBreakpointV2();
  var tripData = trips === null || trips === void 0 ? void 0 : trips[0];

  var handleDomesticClick = function handleDomesticClick() {
    var _trips$;

    var searchParams = new URLSearchParams(window.location.search);
    var queryParams = Object.fromEntries(searchParams.entries());

    var params = DomesticTrip_objectSpread(DomesticTrip_objectSpread({}, queryParams), {}, {
      isUpcomingTrip: true,
      bookingId: trips === null || trips === void 0 ? void 0 : (_trips$ = trips[0]) === null || _trips$ === void 0 ? void 0 : _trips$.bookingId
    });

    DomesticTrip_analytics === null || DomesticTrip_analytics === void 0 ? void 0 : DomesticTrip_analytics.trackLandingEvents({
      actionType: "upcoming_domestic_trips_clicked"
    });
    navigationActions.navigateToTravellerDetails(params);
  };

  return /*#__PURE__*/_jsxs(ContainerStyle, {
    flexDirection: "column",
    gap: "10px",
    children: [title && /*#__PURE__*/_jsx(FormattedText, {
      value: title,
      baseStyle: {
        color: theme.blackText
      }
    }), /*#__PURE__*/_jsxs(DomesticTripStyle, {
      children: [/*#__PURE__*/_jsx(ContainerStyle, {
        children: /*#__PURE__*/_jsx(TagStyle, {
          startColor: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag = tripData.tag) === null || _tripData$tag === void 0 ? void 0 : _tripData$tag.startColor,
          endColor: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag2 = tripData.tag) === null || _tripData$tag2 === void 0 ? void 0 : _tripData$tag2.endColor,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag3 = tripData.tag) === null || _tripData$tag3 === void 0 ? void 0 : _tripData$tag3.title
          })
        })
      }), /*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 15px 12px 16px",
        handleClick: handleDomesticClick,
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          children: [/*#__PURE__*/_jsx(FormattedText, {
            value: tripData === null || tripData === void 0 ? void 0 : tripData.description,
            baseStyle: {
              color: "#4A4A4A",
              fontWeight: "400px",
              fontSize: "12px"
            }
          }), /*#__PURE__*/_jsxs(FlexComp, {
            margin: "7px 0px 0px 0px",
            isCursorPointer: true,
            children: [/*#__PURE__*/_jsx(ImageComponent, {
              width: "32px",
              height: "32px",
              margin: "0px 8px 0px 0px",
              src: tripData === null || tripData === void 0 ? void 0 : tripData.image
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(FormattedText, {
                value: tripData === null || tripData === void 0 ? void 0 : tripData.title,
                baseStyle: {
                  color: "#000000",
                  fontWeight: "700",
                  fontSize: "14px"
                }
              }), /*#__PURE__*/_jsx(ContainerStyle, {
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: tripData === null || tripData === void 0 ? void 0 : tripData.subtitle,
                  baseStyle: {
                    color: "#4A4A4A",
                    fontWeight: "400",
                    fontSize: "12px"
                  }
                })
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(ArrowButtonWrap, {
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: "9px",
            height: "9px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg"
          })
        })]
      }), /*#__PURE__*/_jsx(BannerStyle, {
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: tripData === null || tripData === void 0 ? void 0 : (_tripData$banner = tripData.banner) === null || _tripData$banner === void 0 ? void 0 : _tripData$banner.description
        })
      })]
    })]
  });
};

/* harmony default export */ var DomesticTravelDetail_DomesticTrip = ((/* unused pure expression or super */ null && (DomesticTrip)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.style.ts





var CommonModalDweb_style_modalAnim = (0,styled_components_browser_esm.keyframes)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var CommonModalDweb_style_CommonModalDwebStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1s62ue-0"
})(["position:fixed;width:", ";height:fit-content;max-height:531px;min-height:260px;overflow-y:scroll;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, SectionDividers_style_SectionDividersStyle, TMFloatingInput_style_TMInputWrap, utils/* deviceType.mobile */.vO.mobile, CommonModalDweb_style_modalAnim, TMFloatingInput_style_TMInputWrap);
var CommonModalDweb_style_CommonModalHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalHeader",
  componentId: "sc-1s62ue-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:flex-start;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:80%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], TextStyles_style_H5TagStyle, function (p) {
  return p.nonClipHeading && "\n     ".concat(TextStyles_style_H5TagStyle, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, utils/* deviceType.mobile */.vO.mobile);
var CommonModalDweb_style_CrossIconWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CommonModalDwebstyle__CrossIconWrap",
  componentId: "sc-1s62ue-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/Toast.style.ts

var Toast_style_ToastStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Toaststyle__ToastStyle",
  componentId: "mow44r-0"
})(["display:flex;align-items:center;justify-content:space-between;padding:12px 16px;background:#4a4a4a;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:6px;width:calc(100% - 32px);position:fixed;bottom:30px;left:50%;right:16px;gap:14px;z-index:2;max-width:500px;transform:translateX(-50%);transition:opacity 0.3s ease;flex-direction:row;"]);
var Toast_style_CloseIconWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Toaststyle__CloseIconWrap",
  componentId: "mow44r-1"
})(["width:28px;height:28px;cursor:pointer;"]);
var Toast_style_ToastIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Toaststyle__ToastIcon",
  componentId: "mow44r-2"
})(["display:flex;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidget.style.ts





var TravellingToWidget_style_TravellingToWidgetStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellingToWidgetStyle",
  componentId: "sc-56hbau-0"
})(["display:flex;margin-bottom:24px;position:relative;@media ", "{flex-direction:column;", "{height:300px;}}", "{position:absolute;top:-20px;left:-20px;background:#005756;bottom:auto;}"], utils/* deviceType.mobile */.vO.mobile, CommonModalDweb_style_CommonModalDwebStyle, Toast_style_ToastStyle);
var TravelPurposeWigetStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelPurposeWigetStyle",
  componentId: "sc-56hbau-1"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;flex:2;cursor:pointer;position:relative;border-left:none;"]);
var TravellingToWidget_style_TravellerCountWigetStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetStyle",
  componentId: "sc-56hbau-2"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;flex:1.1;position:relative;display:flex;justify-content:space-between;gap:8px;align-items:center;@media ", "{border-radius:0 0 8px 8px;}"], utils/* deviceType.mobile */.vO.mobile);
var TravellingToWidget_style_TravellerCountWigetShimmerStyle = (0,styled_components_browser_esm["default"])(TravellingToWidget_style_TravellerCountWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetShimmerStyle",
  componentId: "sc-56hbau-3"
})(["display:flex;gap:20px;align-items:end;"]);
var TravellingToWidget_style_TravelDateWigetStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetStyle",
  componentId: "sc-56hbau-4"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;border-right:none;flex:1;cursor:pointer;position:relative;@media ", "{border-right:1px solid #e7e7e7;border-bottom:none;border-radius:8px 8px 0 0;}"], utils/* deviceType.mobile */.vO.mobile);
var TravellingToWidget_style_TravelDateWigetShimmerStyle = (0,styled_components_browser_esm["default"])(TravellingToWidget_style_TravelDateWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetShimmerStyle",
  componentId: "sc-56hbau-5"
})(["display:flex;gap:20px;align-items:end;"]);
var WidgetList = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__WidgetList",
  componentId: "sc-56hbau-6"
})(["background:#ffffff;box-shadow:0px 1px 6px rgba(0,0,0,0.2);border-radius:6px;width:", ";height:213px;overflow-y:scroll;position:absolute;top:30px;right:0;z-index:1;", ""], function (p) {
  return p.width ? p.width : "111px";
}, function (p) {
  return p.travelCount && "\nleft:250px;\n";
});
var TravellingToWidget_style_ListItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__ListItem",
  componentId: "sc-56hbau-7"
})(["padding:8px 16px;border-bottom:1px solid #ebebeb;cursor:pointer;display:flex;align-items:center;", " @media ", "{padding:12px 24px;display:flex;align-items:center;justify-content:center;&:last-child{margin-bottom:60px;}}"], function (p) {
  return p.selected && "\n    ".concat(SpanTagStyle, "{\n        color:#008CFF;\n        font-weight:700;\n    }\n    ");
}, utils/* deviceType.mobile */.vO.mobile);
var EmptySpace = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__EmptySpace",
  componentId: "sc-56hbau-8"
})(["width:100%;height:60px;padding:18px;"]);
var ChevWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevWrap",
  componentId: "sc-56hbau-9"
})(["margin-left:auto;"]);
var TravellingToWidget_style_DateSeparator = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "TravellingToWidgetstyle__DateSeparator",
  componentId: "sc-56hbau-10"
})(["flex-shrink:0;"]);
var TravellingToWidget_style_ChevStateWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevStateWrap",
  componentId: "sc-56hbau-11"
})(["transition:0.5s ease-in;", ""], function (p) {
  return p.open && "\ntransform:rotate(180deg);\n";
});
var TravellingToWidget_style_BtnWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__BtnWrap",
  componentId: "sc-56hbau-12"
})(["background:var(--base-white,#fff);box-shadow:0px -1px 8px 0px rgba(0,0,0,0.25);padding:16px;position:fixed;bottom:0;left:0px;right:0px;"]);
var TravellingToWidget_style_CounterWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravellingToWidgetstyle__CounterWrap",
  componentId: "sc-56hbau-13"
})(["border-radius:4px;background:#fff;box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);padding:0px 8px;display:flex;gap:14px;align-items:center;width:fit-content;height:40px;button{background:transparent;cursor:pointer;display:flex;padding:0;}span{word-break:unset;}"]);
var TravellingToWidget_style_CounterBtn = styled_components_browser_esm["default"].button.withConfig({
  displayName: "TravellingToWidgetstyle__CounterBtn",
  componentId: "sc-56hbau-14"
})(["", ""], function (p) {
  return p.isDiabled && "\npointer-events:none;\nopacity:0.5;\n";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidgetShimmer.tsx







var TravellingToWidgetShimmer_TravellingToWidgetShimmer = function TravellingToWidgetShimmer(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsxs(TravellingToWidgetStyle, {
    children: [/*#__PURE__*/_jsxs(TravelDateWigetShimmerStyle, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        gap: "4px",
        children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "76px",
          height: "16px"
        }), /*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "76px",
          height: "38px"
        })]
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "76px",
        height: "38px"
      })]
    }), /*#__PURE__*/_jsxs(TravellerCountWigetShimmerStyle, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        gap: "4px",
        children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "76px",
          height: "16px"
        }), /*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "76px",
          height: "38px"
        })]
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "76px",
        height: "38px"
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellingToWidgetShimmer = ((/* unused pure expression or super */ null && (TravellingToWidgetShimmer_TravellingToWidgetShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Shimmer/Shimmer.style.ts

var shimmer = (0,styled_components_browser_esm.keyframes)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
var Shimmer_style_ShimmerComp = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Shimmerstyle__ShimmerComp",
  componentId: "sc-1fovdgs-0"
})(["animation:", " 1s linear infinite;background:", ";background-size:800px 104px;position:relative;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;padding:", ";display:flex;align-items:flex-end;"], shimmer, function (p) {
  return p.background ? p.background : "linear-gradient(to right, #e2e2e2 8%, #f6f6f6 18%, #e2e2e2 33%)";
}, function (p) {
  return p.width ? p.width : "100%";
}, function (p) {
  return p.height ? p.height : "14px";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.padding ? p.padding : "";
});
var Shimmer_style_ShimmerVersion2Style = (0,styled_components_browser_esm["default"])(Shimmer_style_ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion2Style",
  componentId: "sc-1fovdgs-1"
})(["background:linear-gradient(to right,#f6f6f6 8%,#f9fafb 18%,#f6f6f6 33%);background-size:800px 104px;"]);
var Shimmer_style_ShimmerVersion3Style = (0,styled_components_browser_esm["default"])(Shimmer_style_ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion3Style",
  componentId: "sc-1fovdgs-2"
})(["background:linear-gradient(to right,#cbcbcb 8%,#f9fafb 18%,#cbcbcb 33%);background-size:800px 104px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Shimmer/ShimmerVersion2.tsx



function ShimmerVersion2_ShimmerVersion2(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      children = _ref.children,
      padding = _ref.padding;
  return /*#__PURE__*/_jsx(ShimmerVersion2Style, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Shimmer/ShimmerVersion3.tsx



function ShimmerVersion3_ShimmerVersion3(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      children = _ref.children,
      padding = _ref.padding;
  return /*#__PURE__*/_jsx(ShimmerVersion3Style, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravellingToShimmer.tsx










var TravellingToShimmer = function TravellingToShimmer() {
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(TravellingToStyleWrap, {
    children: [/*#__PURE__*/_jsx(TravelNote, {
      children: /*#__PURE__*/_jsx(ShimmerVersion3, {
        height: "22px"
      })
    }), /*#__PURE__*/_jsxs(TravellingToStyle, {
      children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
        margin: "0 0 16px",
        width: "100%",
        height: "28px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        margin: "0 0 8px",
        width: "80%",
        height: "16px"
      }), /*#__PURE__*/_jsx(FlexComp, {
        margin: device == "sm" ? "0 0 20px" : "",
        flexWrap: "wrap",
        gap: "8px",
        children: Array.from({
          length: 5
        }, function (_, index) {
          return /*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "89px",
            height: "79px"
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/_jsx(SectionDividers, {
        margin: "30px -30px 30px",
        xs: true
      }), /*#__PURE__*/_jsx(TravellingToWidgetShimmer, {}), /*#__PURE__*/_jsx(ShimmerVersion3, {
        width: "100%",
        height: "44px"
      })]
    })]
  });
};

/* harmony default export */ var TravelDetails_TravellingToShimmer = ((/* unused pure expression or super */ null && (TravellingToShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/SpanTag.tsx





var SpanTag_SpanTag = function SpanTag(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "black" : _ref$color,
      margin = _ref.margin,
      children = _ref.children,
      textTransform = _ref.textTransform,
      dangerousText = _ref.dangerousText,
      style = _ref.style;

  if (dangerousText && typeof dangerousText !== "string") {
    dangerousText = String(dangerousText);
  }

  var context = PartnerContextProvider_usePartnerContext();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTagStyle, {
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    context: context ? context : undefined
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTagStyle, {
    style: style,
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    textTransform: textTransform,
    context: context ? context : undefined,
    children: children
  });
};

/* harmony default export */ var TextStyles_SpanTag = (SpanTag_SpanTag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/ParaTag.tsx





var ParaTag_ParaTag = function ParaTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000000" : _ref$color,
      margin = _ref.margin,
      textAlign = _ref.textAlign,
      lineHeight = _ref.lineHeight,
      dangerousText = _ref.dangerousText,
      textTransform = _ref.textTransform,
      style = _ref.style;
  var context = PartnerContextProvider_usePartnerContext();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    textTransform: textTransform,
    context: context ? context : undefined,
    style: style
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    textTransform: textTransform,
    context: context ? context : undefined,
    style: style,
    children: children
  });
};

/* harmony default export */ var TextStyles_ParaTag = (ParaTag_ParaTag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H1Tag.tsx





var H1Tag = function H1Tag(_ref) {
  var children = _ref.children,
      color = _ref.color,
      margin = _ref.margin;
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(H1TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    children: children
  });
};

/* harmony default export */ var TextStyles_H1Tag = ((/* unused pure expression or super */ null && (H1Tag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H2Tag.tsx





var H2Tag_H2Tag = function H2Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(H2TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    children: children
  });
};

/* harmony default export */ var TextStyles_H2Tag = ((/* unused pure expression or super */ null && (H2Tag_H2Tag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H3Tag.tsx





var H3Tag_H3Tag = function H3Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = PartnerContextProvider_usePartnerContext();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H3TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    children: children
  });
};

/* harmony default export */ var TextStyles_H3Tag = (H3Tag_H3Tag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H4Tag.tsx





var H4Tag_H4Tag = function H4Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(H4TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    children: children
  });
};

/* harmony default export */ var TextStyles_H4Tag = ((/* unused pure expression or super */ null && (H4Tag_H4Tag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H5Tag.tsx





var H5Tag_H5Tag = function H5Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(H5TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    children: children
  });
};

/* harmony default export */ var TextStyles_H5Tag = ((/* unused pure expression or super */ null && (H5Tag_H5Tag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H6Tag.tsx





var H6Tag_H6Tag = function H6Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(H6TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    children: children
  });
};

/* harmony default export */ var TextStyles_H6Tag = ((/* unused pure expression or super */ null && (H6Tag_H6Tag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/AnchorTag.tsx





var AnchorTag_AnchorTag = function AnchorTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      color = _ref.color,
      handleClick = _ref.handleClick,
      hrefProp = _ref.hrefProp,
      textAlign = _ref.textAlign,
      margin = _ref.margin,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave,
      textTransform = _ref.textTransform,
      anchorTitle = _ref.anchorTitle,
      targetProp = _ref.targetProp,
      _ref$download = _ref.download,
      download = _ref$download === void 0 ? false : _ref$download,
      disableState = _ref.disableState,
      style = _ref.style;
  var context = PartnerContextProvider_usePartnerContext();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style_AnchorTagStyle, {
    context: context ? context : undefined,
    textAlign: textAlign,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    onClick: handleClick,
    href: hrefProp,
    margin: margin,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    textTransform: textTransform,
    title: anchorTitle,
    target: targetProp,
    download: download,
    disableState: disableState,
    style: style,
    children: children
  });
};

/* harmony default export */ var TextStyles_AnchorTag = (AnchorTag_AnchorTag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.tsx








var LandingButton_LandingButton = function LandingButton(_ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      shimmerBtn = _ref.shimmerBtn,
      flex = _ref.flex,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon,
      isLoading = _ref.isLoading,
      buttonref = _ref.buttonref;
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(LandingButtonStyle, {
    ref: buttonref,
    onClick: onClick,
    customWidth: customWidth,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    btnTheme: context ? context : undefined,
    txtClipIcon: btnLeftIcon !== "" && btnRightIcon !== "",
    children: isLoading ? /*#__PURE__*/_jsx(Spinner, {
      spinnerColor: "#fff"
    }) : /*#__PURE__*/_jsxs(React.Fragment, {
      children: [btnLeftIcon && /*#__PURE__*/_jsx(ImageComponent, {
        width: "24px",
        height: "24px",
        src: btnLeftIcon
      }), customTitle && /*#__PURE__*/_jsx(SpanTag, {
        color: theme.blueText,
        fontSize: "md",
        fontWeight: "black",
        children: customTitle
      }), shimmerBtn && /*#__PURE__*/_jsx(ShimmerWrap, {
        children: /*#__PURE__*/_jsx("img", {
          src: "../../../images/shimmerBtn.svg"
        })
      }), btnRightIcon && /*#__PURE__*/_jsx(ImageComponent, {
        width: "16px",
        height: "16px",
        margin: "0 0 0 auto",
        src: btnRightIcon
      })]
    })
  });
};

/* harmony default export */ var components_LandingButton_LandingButton = ((/* unused pure expression or super */ null && (LandingButton_LandingButton)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButtonWhite.tsx







var LandingButtonWhite_LandingButtonWhite = function LandingButtonWhite(_ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      customHeight = _ref.customHeight,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      flex = _ref.flex,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingButtonWhiteStyle, {
    onClick: onClick,
    customWidth: customWidth,
    customHeight: customHeight,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    children: [btnLeftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon
    }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      color: Global/* theme.blueText */.rS.blueText,
      fontSize: "md",
      fontWeight: "bold",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
        value: customTitle
      })
    }), btnRightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon
    })]
  });
};

/* harmony default export */ var LandingButton_LandingButtonWhite = (LandingButtonWhite_LandingButtonWhite);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButtonTertiary.tsx







var LandingButtonTertiary_LandingButtonTertiary = function LandingButtonTertiary(_ref) {
  var title = _ref.title,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon;
  return /*#__PURE__*/_jsxs(LandingButtonTertiaryStyle, {
    onClick: onClick,
    disableState: disableState,
    children: [btnLeftIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon
    }), title && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.blueText,
      fontSize: "xs",
      fontWeight: "bold",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }), btnRightIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon
    })]
  });
};

/* harmony default export */ var LandingButton_LandingButtonTertiary = ((/* unused pure expression or super */ null && (LandingButtonTertiary_LandingButtonTertiary)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ProcessSteps/ProcessSteps.style.ts


var ProcessStepsWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProcessStepsstyle__ProcessStepsWrap",
  componentId: "lhgcac-0"
})([""]);
var ProcessSteps_style_ProcessStepsStyle = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ProcessStepsstyle__ProcessStepsStyle",
  componentId: "lhgcac-1"
})(["display:flex;gap:4px;height:20px;margin:", ";list-style-type:none;", " ", " li{position:relative;min-width:85px;", " ", "}li:after{position:absolute;content:\"\";width:85px;height:4px;background:#ffffff;border-radius:4px;left:0;top:-7px;", " ", "}li.active:after{background:#008cff;}"], function (p) {
  return p.margin ? p.margin : "";
}, function (props) {
  return props.forHeader && "\n   height:2px;\n   ";
}, function (props) {
  return props.position && "\nposition:relative;\n";
}, function (props) {
  return props.forMweb && "\n   min-width:31px !important;\n   ";
}, function (props) {
  return props.forHeader && "\n   min-width:unset;\n   flex:1;\n   ";
}, function (props) {
  return props.forMweb && "\n   width:31px !important;\n   top: 12px!important;\n   ";
}, function (props) {
  return props.forHeader && "\n   width:100% !important;\n   background: #E2E2E2;\n   top: 0px!important;\n   ";
});
var ProcessSteps_style_ProcessStepsInfo = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "ProcessStepsstyle__ProcessStepsInfo",
  componentId: "lhgcac-2"
})(["white-space:nowrap;color:#afafaf;font-weight:700;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ProcessSteps/ProcessSteps.tsx





var ProcessSteps = function ProcessSteps(_ref) {
  var data = _ref.data,
      activeIndex = _ref.activeIndex,
      position = _ref.position,
      forMweb = _ref.forMweb,
      margin = _ref.margin,
      forHeader = _ref.forHeader;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [!forHeader && /*#__PURE__*/_jsx(ProcessStepsInfo, {
      children: data[activeIndex - 1]
    }), /*#__PURE__*/_jsx(ProcessStepsStyle, {
      position: position,
      forMweb: forMweb,
      margin: margin,
      forHeader: forHeader,
      children: data && data.map(function (item, index) {
        return /*#__PURE__*/_jsx("li", {
          className: "".concat(activeIndex >= index + 1 ? "active" : "")
        }, index);
      })
    })]
  });
};

/* harmony default export */ var ProcessSteps_ProcessSteps = ((/* unused pure expression or super */ null && (ProcessSteps)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LeftStickyRightScrollLayout/LeftStickyRightScrollLayout.style.ts

var LeftStickyRightScrollLayout_style_LeftContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LeftStickyRightScrollLayoutstyle__LeftContainer",
  componentId: "sc-1u1am3n-0"
})(["display:flex;width:1200px;justify-content:space-between;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LeftStickyRightScrollLayout/LeftStickyRightScrollLayout.tsx



var LeftStickyRightScrollLayout = function LeftStickyRightScrollLayout(_ref) {
  var leftSection = _ref.leftSection,
      rightSection = _ref.rightSection;
  return /*#__PURE__*/_jsxs(LeftContainer, {
    children: [leftSection, rightSection]
  });
};

/* harmony default export */ var LeftStickyRightScrollLayout_LeftStickyRightScrollLayout = ((/* unused pure expression or super */ null && (LeftStickyRightScrollLayout)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SectionDividers/SectionDividers.tsx



var SectionDividers_SectionDividers = function SectionDividers(_ref) {
  var small = _ref.small,
      large = _ref.large,
      xs = _ref.xs,
      width = _ref.width,
      height = _ref.height,
      borderRadius = _ref.borderRadius,
      margin = _ref.margin,
      backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/_jsx(SectionDividersStyle, {
    backgroundColor: backgroundColor,
    small: small,
    large: large,
    xs: xs,
    width: width,
    height: height,
    borderRadius: borderRadius,
    margin: margin
  });
};

/* harmony default export */ var components_SectionDividers_SectionDividers = ((/* unused pure expression or super */ null && (SectionDividers_SectionDividers)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ImageTag/ImageTag.style.ts

var ImageTag_style_ImageTagStyle = styled_components_browser_esm["default"].img.withConfig({
  displayName: "ImageTagstyle__ImageTagStyle",
  componentId: "sc-16jb4o3-0"
})(["display:inline-block;margin:", ";width:", ";", " flex-shrink:0;"], function (props) {
  return props.margin;
}, function (props) {
  return props.width;
}, function (props) {
  return props.showCursorPointer && " cursor: pointer;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ImageTag/ImageTag.tsx



var ImageTag_ImageTag = function ImageTag(_ref) {
  var src = _ref.src,
      width = _ref.width,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "image-tag" : _ref$alt,
      margin = _ref.margin,
      height = _ref.height,
      _ref$showCursorPointe = _ref.showCursorPointer,
      showCursorPointer = _ref$showCursorPointe === void 0 ? false : _ref$showCursorPointe,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return /*#__PURE__*/_jsx(ImageTagStyle, {
    src: src,
    width: width,
    margin: margin,
    height: height,
    showCursorPointer: showCursorPointer,
    alt: alt,
    onClick: onClick
  });
};

/* harmony default export */ var components_ImageTag_ImageTag = ((/* unused pure expression or super */ null && (ImageTag_ImageTag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DisplayInfoIconTag/DisplayInfoIcon.style.ts

var DisplayInfoIcon_style_DisplayInfoIconTagStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DisplayInfoIconstyle__DisplayInfoIconTagStyle",
  componentId: "sc-1xgmja1-0"
})(["display:flex;flex:1;margin:", ";align-items:center;justify-content:space-between;background:linear-gradient(93.36deg,#f2eae6 -17.08%,#ffffff 118.39%);border-radius:4px;padding:12px;"], function (props) {
  return props.margin;
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DisplayInfoIconTag/DisplayInfoIconTag.tsx







var DisplayInfoIconTag = function DisplayInfoIconTag(_ref) {
  var infoText = _ref.infoText,
      label = _ref.label,
      subLabel = _ref.subLabel,
      margin = _ref.margin,
      editBtnHandler = _ref.editBtnHandler,
      editIcon = _ref.editIcon;
  return /*#__PURE__*/_jsxs(DisplayInfoIconTagStyle, {
    margin: margin,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        children: infoText
      }), /*#__PURE__*/_jsxs(ParaTag, {
        children: [label && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "sm",
          fontWeight: "bold",
          children: label
        }), subLabel && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SpanTag, {
            margin: "0px 2px",
            fontSize: "sm",
            fontWeight: "bold",
            children: "|"
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            children: subLabel
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      onClick: editBtnHandler,
      children: editIcon ? /*#__PURE__*/_jsx(ImageTag, {
        src: editIcon,
        showCursorPointer: true
      }) : /*#__PURE__*/_jsx(EditIcon, {})
    })]
  });
};

/* harmony default export */ var DisplayInfoIconTag_DisplayInfoIconTag = ((/* unused pure expression or super */ null && (DisplayInfoIconTag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DeliveryPersuasion/DeliveryPersuasion.style.ts




var DeliveryPersuasion_style_DeliveryPersuasionStyle = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "DeliveryPersuasionstyle__DeliveryPersuasionStyle",
  componentId: "sc-1uli1hp-0"
})(["border-radius:4px;width:fit-content;color:", ";font-size:18px;line-height:24px;.boldText{font-weight:700;}.blueText{color:", ";}.greenText{color:", ";}@media ", "{font-size:14px;line-height:19px;}"], Global/* theme.greyText */.rS.greyText, Global/* theme.blueText */.rS.blueText, Global/* theme.greenText */.rS.greenText, utils/* deviceType.mobile */.vO.mobile);
var DeliveryPersuasion_style_DeliveryLocationStyle = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "DeliveryPersuasionstyle__DeliveryLocationStyle",
  componentId: "sc-1uli1hp-1"
})(["font-size:", ";color:", ";font-weight:bold;margin:0px 0px 0px 4px;@media ", "{max-width:120px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"], function (props) {
  return props !== null && props !== void 0 && props.fontSize ? props.fontSize : "18px";
}, Global/* theme.blueText */.rS.blueText, utils/* deviceType.mobile */.vO.mobile);
var DeliveryPersuasion_style_DeliveryPersuasionComp = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DeliveryPersuasionstyle__DeliveryPersuasionComp",
  componentId: "sc-1uli1hp-2"
})(["display:flex;padding:", ";margin:", ";background:", ";flex-direction:", ";align-items:", ";flex-wrap:wrap;"], function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.bgColor;
}, function (props) {
  return props.checkPincode ? "column" : "row";
}, function (props) {
  return props.checkPincode ? "flex-start" : "center";
});
var DeliveryPersuasion_style_Cta = styled_components_browser_esm["default"].a.withConfig({
  displayName: "DeliveryPersuasionstyle__Cta",
  componentId: "sc-1uli1hp-3"
})(["display:flex;align-items:center;margin:", ";"], function (props) {
  return props.margin;
});
var DeliveryPersuasion_style_ImgWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DeliveryPersuasionstyle__ImgWpr",
  componentId: "sc-1uli1hp-4"
})(["margin:0 0 0 6px;"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(7510);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DeliveryPersuasion/DeliveryPersuasion.tsx









var DeliveryPersuasion_DeliveryPersuasion = function DeliveryPersuasion(_ref) {
  var margin = _ref.margin,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "8px 12px" : _ref$padding,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "linear-gradient(90.01deg, #deedff 0%, rgba(230, 241, 255, 0) 108.89%)" : _ref$bgColor,
      text = _ref.text,
      editLocationHandler = _ref.editLocationHandler,
      upArrow = _ref.upArrow,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
      _ref$checkPincode = _ref.checkPincode,
      checkPincode = _ref$checkPincode === void 0 ? false : _ref$checkPincode,
      checkPincodeLabel = _ref.checkPincodeLabel,
      checkPincodeHandler = _ref.checkPincodeHandler,
      arrowIcon = _ref.arrowIcon,
      ctaText = _ref.ctaText,
      ctaMargin = _ref.ctaMargin,
      defaultIconComp = _ref.defaultIconComp;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: checkPincode ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [text && /*#__PURE__*/_jsx(DeliveryPersuasionComp, {
        padding: "Opx",
        margin: margin,
        checkPincode: checkPincode,
        children: /*#__PURE__*/_jsx(DeliveryPersuasionStyle, {
          dangerouslySetInnerHTML: {
            __html: text
          }
        })
      }), /*#__PURE__*/_jsxs(Cta, {
        margin: ctaMargin ? ctaMargin : checkPincode ? device === "lg" ? "16px 0px 0px 0px" : "8px 0px 0px 0px" : "0px",
        onClick: checkPincodeHandler,
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          fontSize: fontSize,
          color: theme.blueText,
          children: checkPincodeLabel
        }), " ", arrowIcon ? /*#__PURE__*/_jsx(ImgWpr, {
          children: /*#__PURE__*/_jsx(ImageTag, {
            src: arrowIcon
          })
        }) : /*#__PURE__*/_jsx(ImgWpr, {
          children: /*#__PURE__*/_jsx(ArrowIcon, {})
        })]
      })]
    }) : /*#__PURE__*/_jsxs(DeliveryPersuasionComp, {
      margin: margin,
      bgColor: bgColor,
      padding: padding,
      checkPincode: checkPincode,
      children: [text && /*#__PURE__*/_jsx(DeliveryPersuasionStyle, {
        dangerouslySetInnerHTML: {
          __html: text
        }
      }), /*#__PURE__*/_jsxs(Cta, {
        onClick: editLocationHandler,
        children: [/*#__PURE__*/_jsx(DeliveryLocationStyle, {
          fontSize: fontSize,
          children: ctaText
        }), showIcon && (upArrow ? /*#__PURE__*/_jsx(ImageTag, {
          src: upArrow
        }) : defaultIconComp ? defaultIconComp : /*#__PURE__*/_jsx(ChevronDownIcon, {}))]
      })]
    })
  });
};

/* harmony default export */ var components_DeliveryPersuasion_DeliveryPersuasion = ((/* unused pure expression or super */ null && (DeliveryPersuasion_DeliveryPersuasion)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/CliptextStyle.tsx




var CliptextStyle_CliptextStyle = function CliptextStyle(_ref) {
  var children = _ref.children,
      margin = _ref.margin;
  return /*#__PURE__*/_jsx(CliptextStyleComp, {
    margin: margin,
    children: children
  });
};

/* harmony default export */ var TextStyles_CliptextStyle = ((/* unused pure expression or super */ null && (CliptextStyle_CliptextStyle)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddressComp/AddressComp.style.ts

var AddressComp_style_AddressCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCompstyle__AddressCompStyle",
  componentId: "sc-1elb11q-0"
})(["display:flex;background:#f6faff;gap:4px;padding:20px 10px;flex-direction:column;border-radius:8px;border:1px solid #cce8ff;", ""], function (props) {
  return props.containerStyle;
});
var AddressComp_style_AddAddressContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCompstyle__AddAddressContainer",
  componentId: "sc-1elb11q-1"
})(["display:flex;flex-direction:column;padding:12px 0px;justify-content:center;align-items:center;"]);
var AddressComp_style_EditContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCompstyle__EditContainer",
  componentId: "sc-1elb11q-2"
})(["display:flex;flex-direction:column;"]);
var AddressComp_style_EditAddressContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCompstyle__EditAddressContainer",
  componentId: "sc-1elb11q-3"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
var AddressComp_style_EditAddressLeftStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCompstyle__EditAddressLeftStyle",
  componentId: "sc-1elb11q-4"
})(["flex-direction:column;"]);
var AddressComp_style_DeliveryDateContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCompstyle__DeliveryDateContainer",
  componentId: "sc-1elb11q-5"
})(["display:flex;flex-direction:row;align-items:center;margin-top:4px;"]);
var AddressComp_style_InfoIconWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCompstyle__InfoIconWpr",
  componentId: "sc-1elb11q-6"
})(["position:relative;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddressComp/AddressComp.tsx








var AddressComp = function AddressComp(_ref) {
  var addAddressHandler = _ref.addAddressHandler,
      _ref$editAddress = _ref.editAddress,
      editAddress = _ref$editAddress === void 0 ? false : _ref$editAddress,
      addressDetails = _ref.addressDetails,
      editAddressHandler = _ref.editAddressHandler,
      containerStyle = _ref.containerStyle,
      deliveryDate = _ref.deliveryDate,
      infoIconClick = _ref.infoIconClick,
      noAddressLabel = _ref.noAddressLabel,
      addAddressLabel = _ref.addAddressLabel,
      editIcon = _ref.editIcon,
      infoIcon = _ref.infoIcon,
      deliveryInfoTxt = _ref.deliveryInfoTxt,
      showTooltip = _ref.showTooltip,
      closeTooltip = _ref.closeTooltip,
      energyIcon = _ref.energyIcon;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(AddressCompStyle, {
    onClick: !editAddress ? addAddressHandler : function () {},
    containerStyle: containerStyle,
    children: !editAddress ? /*#__PURE__*/_jsxs(AddAddressContainer, {
      children: [noAddressLabel && /*#__PURE__*/_jsx(ParaTag, {
        color: theme.greyText6,
        textAlign: "center",
        fontSize: "sm",
        children: noAddressLabel
      }), addAddressLabel && /*#__PURE__*/_jsxs(ParaTag, {
        color: theme.blueText,
        textAlign: "center",
        fontSize: "sm",
        fontWeight: "bold",
        children: ["+ ", addAddressLabel]
      })]
    }) : /*#__PURE__*/_jsxs(EditContainer, {
      children: [/*#__PURE__*/_jsxs(EditAddressContainer, {
        children: [/*#__PURE__*/_jsxs(EditAddressLeftStyle, {
          children: [(addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressLine1) && /*#__PURE__*/_jsx(ParaTag, {
            color: theme.greyText,
            fontSize: "sm",
            children: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressLine1
          }), /*#__PURE__*/_jsxs(ParaTag, {
            color: theme.greyText,
            fontSize: "sm",
            children: [addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressLine2, " ", (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.pincode) && /*#__PURE__*/_jsxs(SpanTag, {
              color: theme.greyText,
              fontSize: "sm",
              fontWeight: "bold",
              children: [addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.pinLabel, " ", addressDetails.pincode]
            })]
          }), (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressLine3) && /*#__PURE__*/_jsx(ParaTag, {
            color: theme.greyText,
            fontSize: "sm",
            children: addressDetails.addressLine3
          })]
        }), editIcon ? /*#__PURE__*/_jsx("div", {
          onClick: editAddressHandler,
          children: /*#__PURE__*/_jsx(ImageTag, {
            src: editIcon,
            showCursorPointer: true
          })
        }) : /*#__PURE__*/_jsx("div", {
          onClick: editAddressHandler,
          children: /*#__PURE__*/_jsx(EditIcon, {})
        })]
      }), deliveryDate && /*#__PURE__*/_jsxs(DeliveryDateContainer, {
        children: [energyIcon ? /*#__PURE__*/_jsx(ImageTag, {
          src: energyIcon
        }) : /*#__PURE__*/_jsx(EnergyIcon, {}), /*#__PURE__*/_jsx(ParaTag, {
          color: theme.lightGreen,
          fontSize: "sm",
          margin: "0px 8px 0px 5px",
          children: deliveryDate
        }), /*#__PURE__*/_jsxs(InfoIconWpr, {
          onClick: infoIconClick,
          children: [infoIcon ? /*#__PURE__*/_jsx(ImageTag, {
            src: infoIcon,
            showCursorPointer: true
          }) : /*#__PURE__*/_jsx(InfoIcon, {}), showTooltip && deliveryInfoTxt && /*#__PURE__*/_jsx(ToolTip, {
            closeTooltip: closeTooltip,
            arrowPosition: "90%",
            style: {
              right: "-20px",
              bottom: "22px",
              width: device === "lg" ? "320px" : "280px"
            },
            children: /*#__PURE__*/_jsx(ParaTag, {
              color: theme.whiteText,
              fontWeight: "regular",
              children: deliveryInfoTxt
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var AddressComp_AddressComp = ((/* unused pure expression or super */ null && (AddressComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.tsx









var TMFloatingInput_TMFloatingInput = function TMFloatingInput(_ref) {
  var placeholderTxt = _ref.placeholderTxt,
      labelTxt = _ref.labelTxt,
      disableState = _ref.disableState,
      inputWidth = _ref.inputWidth,
      margin = _ref.margin,
      errorState = _ref.errorState,
      inputValue = _ref.inputValue,
      handleChange = _ref.handleChange,
      verifiedTag = _ref.verifiedTag,
      maxLength = _ref.maxLength,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      inputMode = _ref.inputMode,
      flex = _ref.flex,
      _ref$fieldType = _ref.fieldType,
      fieldType = _ref$fieldType === void 0 ? "text" : _ref$fieldType,
      _ref$showEdit = _ref.showEdit,
      showEdit = _ref$showEdit === void 0 ? false : _ref$showEdit,
      handleEditClick = _ref.handleEditClick,
      handleDropdownPress = _ref.handleDropdownPress;

  var _useState = useState(false),
      isFocus = _useState[0],
      setIsFocus = _useState[1];

  var inputFocusHandler = function inputFocusHandler(event) {
    if (fieldType === "select") {
      event.preventDefault();
      event.currentTarget.blur();
    }

    !(fieldType === "select") && setIsFocus(true);
    onFocus && onFocus();
  };

  var inputBlurHandler = function inputBlurHandler() {
    !(fieldType === "select") && setIsFocus(false);
    onBlur && onBlur();
  };

  var handleClick = function handleClick() {
    if (fieldType === "select" && handleDropdownPress) {
      handleDropdownPress();
    }
  };

  return /*#__PURE__*/_jsxs(TMInputWrap, {
    disableState: disableState,
    margin: margin,
    inputWidth: inputWidth,
    flex: flex,
    placeholder: placeholderTxt,
    clickable: fieldType === "select",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsxs(InputWpr, {
      children: [/*#__PURE__*/_jsx(TMInputStyle, {
        id: labelTxt,
        isActive: isFocus,
        inputMode: inputMode,
        onChange: fieldType === "select" ? function () {} : handleChange,
        value: inputValue,
        errorState: errorState,
        onBlur: inputBlurHandler,
        verifiedTag: verifiedTag,
        disableState: disableState,
        onFocus: inputFocusHandler,
        placeholder: placeholderTxt,
        spellCheck: "false",
        maxLength: maxLength,
        type: type,
        required: true,
        clickable: fieldType === "select"
      }), labelTxt && /*#__PURE__*/_jsx("label", {
        htmlFor: fieldType === "select" ? "" : labelTxt,
        className: "labelText",
        children: labelTxt
      }), fieldType === "text" && verifiedTag && /*#__PURE__*/_jsx(VerifiedContainer, {
        children: /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "xs",
          fontWeight: "bold",
          color: theme.darkGreen,
          children: verifiedTag
        })
      }), fieldType === "text" && showEdit && /*#__PURE__*/_jsx(IconContainer, {
        onClick: handleEditClick,
        children: /*#__PURE__*/_jsx(EditIcon, {})
      }), fieldType === "select" && /*#__PURE__*/_jsx(IconContainer, {
        children: /*#__PURE__*/_jsx(DownArrow, {})
      })]
    }), errorState && /*#__PURE__*/_jsx(ParaTag, {
      margin: "4px 0 0",
      color: theme.redText2,
      fontSize: "xs",
      dangerousText: errorState
    })]
  });
};

/* harmony default export */ var components_TMFloatingInput_TMFloatingInput = ((/* unused pure expression or super */ null && (TMFloatingInput_TMFloatingInput)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToggleBtn/ToggleBtn.style.ts


var ToggleBtn_style_ToggleBtnWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ToggleBtnstyle__ToggleBtnWrapper",
  componentId: "kyhav3-0"
})(["background:", ";border:2px solid rgba(0,0,0,0.12);border-radius:35px;padding:2px;width:52px;display:flex;", " cursor:pointer;"], Global/* theme.whiteText */.rS.whiteText, function (p) {
  return p.locked && "\n    background: ".concat(Global/* theme.blueText */.rS.blueText, ";\n    border: 2px solid ").concat(Global/* theme.blueText */.rS.blueText, ";\n");
});
var ToggleBtn_style_ToggleButton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ToggleBtnstyle__ToggleButton",
  componentId: "kyhav3-1"
})(["background:", ";border-radius:23px;width:24px;height:24px;transition:all 0.3s linear;", " ", ""], Global/* theme.lightBlack */.rS.lightBlack, function (p) {
  return p.locked && "\n  margin-left:20px;\n  background:".concat(Global/* theme.whiteText */.rS.whiteText, ";\n");
}, function (p) {
  return !p.locked && "\n  margin-right:auto;\n";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToggleBtn/ToggleBtn.tsx



var ToggleBtn_ToggleBtn = function ToggleBtn(_ref) {
  var locked = _ref.locked,
      onToggleClick = _ref.onToggleClick;
  return /*#__PURE__*/_jsx(ToggleBtnWrapper, {
    locked: locked,
    onClick: onToggleClick,
    children: /*#__PURE__*/_jsx(ToggleButton, {
      locked: locked
    })
  });
};

/* harmony default export */ var components_ToggleBtn_ToggleBtn = ((/* unused pure expression or super */ null && (ToggleBtn_ToggleBtn)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PANCardComp/PANCardComp.style.ts


var PANCardComp_style_PANCardWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PANCardCompstyle__PANCardWpr",
  componentId: "sc-1vygr1k-0"
})(["display:flex;background:linear-gradient(59.34deg,#dac6db 1.63%,#8ec5f2 102.73%);gap:16px;padding:24px 16px;flex-direction:column;border-radius:8px;align-self:stretch;", ""], function (props) {
  return props.containerStyle;
});
var PANCardComp_style_PANInputContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PANCardCompstyle__PANInputContainer",
  componentId: "sc-1vygr1k-1"
})(["display:flex;flex-direction:column;gap:8px;"]);
var PANCardComp_style_FetchedNameContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PANCardCompstyle__FetchedNameContainer",
  componentId: "sc-1vygr1k-2"
})(["display:flex;flex-direction:row;align-items:center;padding:8px;gap:4px;background:rgba(255,255,255,0.5);border-radius:4px;"]);
var PANCardComp_style_IconContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PANCardCompstyle__IconContainer",
  componentId: "sc-1vygr1k-3"
})(["width:14px;height:14px;border-radius:7px;background:", ";align-items:center;justify-content:center;display:flex;"], Global/* theme.persianGreen */.rS.persianGreen);
var PANCardComp_style_PANReqdContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PANCardCompstyle__PANReqdContainer",
  componentId: "sc-1vygr1k-4"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;"]);
var PANCardComp_style_InfoLeftContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PANCardCompstyle__InfoLeftContainer",
  componentId: "sc-1vygr1k-5"
})(["display:flex;flex-direction:row;align-items:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TickIcon.tsx


function TickIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TickIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TickIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TickIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var TickIcon_TickIcon = function TickIcon(props) {
  return /*#__PURE__*/_jsx("svg", TickIcon_objectSpread(TickIcon_objectSpread({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M1.4917 2.69399L3.02111 4.2234L6.58973 0.654785",
      stroke: "white",
      strokeLinecap: "round"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PANCardComp/PANCardComp.tsx








var PANCardComp = function PANCardComp(_ref) {
  var panInputDetails = _ref.panInputDetails,
      containerStyle = _ref.containerStyle,
      panReqdTxt = _ref.panReqdTxt,
      infoClickHandler = _ref.infoClickHandler,
      fetchedName = _ref.fetchedName,
      nameInputDetails = _ref.nameInputDetails,
      _ref$showNameDetails = _ref.showNameDetails,
      showNameDetails = _ref$showNameDetails === void 0 ? false : _ref$showNameDetails,
      safetyIcon = _ref.safetyIcon,
      infoIcon = _ref.infoIcon,
      fetchedFromPanTxt = _ref.fetchedFromPanTxt;
  return /*#__PURE__*/_jsxs(PANCardWpr, {
    containerStyle: containerStyle,
    children: [/*#__PURE__*/_jsxs(PANInputContainer, {
      children: [/*#__PURE__*/_jsx(TMFloatingInput, {
        labelTxt: panInputDetails.labelTxt,
        inputValue: panInputDetails === null || panInputDetails === void 0 ? void 0 : panInputDetails.panInputValue,
        handleChange: panInputDetails === null || panInputDetails === void 0 ? void 0 : panInputDetails.handlePanChange,
        errorState: panInputDetails === null || panInputDetails === void 0 ? void 0 : panInputDetails.panErrorState,
        verifiedTag: panInputDetails === null || panInputDetails === void 0 ? void 0 : panInputDetails.verifiedTag,
        maxLength: panInputDetails === null || panInputDetails === void 0 ? void 0 : panInputDetails.maxLength
      }), panReqdTxt && /*#__PURE__*/_jsxs(PANReqdContainer, {
        children: [/*#__PURE__*/_jsxs(InfoLeftContainer, {
          children: [safetyIcon ? /*#__PURE__*/_jsx(ImageTag, {
            src: safetyIcon
          }) : /*#__PURE__*/_jsx(SafetyIcon, {}), /*#__PURE__*/_jsx(ParaTag, {
            margin: "0px 4px",
            color: theme.greyText,
            children: panReqdTxt
          })]
        }), infoIcon ? /*#__PURE__*/_jsx("div", {
          onClick: infoClickHandler,
          children: /*#__PURE__*/_jsx(ImageTag, {
            src: infoIcon,
            showCursorPointer: true
          })
        }) : /*#__PURE__*/_jsx("div", {
          onClick: infoClickHandler,
          children: /*#__PURE__*/_jsx(InfoIcon, {
            color: theme.blueText
          })
        })]
      })]
    }), showNameDetails && (fetchedName ? /*#__PURE__*/_jsxs(FetchedNameContainer, {
      children: [/*#__PURE__*/_jsx(IconContainer, {
        children: /*#__PURE__*/_jsx(TickIcon, {})
      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        children: fetchedName
      }), fetchedFromPanTxt && /*#__PURE__*/_jsxs(ParaTag, {
        fontSize: "xs",
        color: theme.greyText6,
        children: ["-", fetchedFromPanTxt]
      })]
    }) : /*#__PURE__*/_jsx(TMFloatingInput, {
      labelTxt: nameInputDetails === null || nameInputDetails === void 0 ? void 0 : nameInputDetails.labelTxt,
      inputValue: nameInputDetails === null || nameInputDetails === void 0 ? void 0 : nameInputDetails.nameInputValue,
      handleChange: nameInputDetails === null || nameInputDetails === void 0 ? void 0 : nameInputDetails.handleNameChange,
      errorState: nameInputDetails === null || nameInputDetails === void 0 ? void 0 : nameInputDetails.nameErrorState,
      maxLength: nameInputDetails === null || nameInputDetails === void 0 ? void 0 : nameInputDetails.maxLength
    }))]
  });
};

/* harmony default export */ var PANCardComp_PANCardComp = ((/* unused pure expression or super */ null && (PANCardComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SnackBar/SnackBar.style.ts



var SnackBar_style_SnackbarContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SnackBarstyle__SnackbarContainer",
  componentId: "sc-968saj-0"
})(["background:var(--bgColor,", ");display:flex;justify-content:space-between;flex-direction:row;align-items:center;padding:12px 16px;gap:8px;border-radius:6px;z-index:1;width:100%;", " ", ";"], Global/* theme.lightRed */.rS.lightRed, function (props) {
  return props.isPosFixed && "\n    @media ".concat(utils/* deviceType.mobile */.vO.mobile, " {\n        position: fixed;\n        bottom:  ").concat(function (p) {
    return p.bottom ? p.bottom : "16px";
  }, ";\n        left: 16px;\n        width: calc(100% - 32px);\n    }\n    ");
}, function (props) {
  return props.containerStyle;
});
var SnackBar_style_SnackbarButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "SnackBarstyle__SnackbarButton",
  componentId: "sc-968saj-1"
})(["background-color:transparent;color:", ";border:none;margin-left:16px;cursor:pointer;font-weight:700;font-size:12px;line-height:16px;font-family:Open Sans;"], Global/* theme.greyText */.rS.greyText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SnackBar/SnackBar.tsx







var SnackBar_SnackBar = function SnackBar(_ref) {
  var message = _ref.message,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "OKAY" : _ref$buttonText,
      onButtonClick = _ref.onButtonClick,
      _ref$txtColor = _ref.txtColor,
      txtColor = _ref$txtColor === void 0 ? theme.redText : _ref$txtColor,
      bgColor = _ref.bgColor,
      containerStyle = _ref.containerStyle,
      _ref$showButton = _ref.showButton,
      showButton = _ref$showButton === void 0 ? true : _ref$showButton,
      bottomMargin = _ref.bottomMargin,
      closeIcon = _ref.closeIcon,
      _ref$isPosFixed = _ref.isPosFixed,
      isPosFixed = _ref$isPosFixed === void 0 ? true : _ref$isPosFixed;
  return /*#__PURE__*/_jsxs(SnackbarContainer, {
    containerStyle: containerStyle,
    style: {
      "--bgColor": bgColor
    },
    bottom: bottomMargin,
    isPosFixed: isPosFixed,
    children: [/*#__PURE__*/_jsx(SpanTag, {
      fontSize: "xs",
      color: txtColor,
      children: message
    }), showButton ? /*#__PURE__*/_jsx(SnackbarButton, {
      onClick: onButtonClick,
      children: buttonText
    }) : /*#__PURE__*/_jsx("div", {
      onClick: onButtonClick,
      children: closeIcon ? /*#__PURE__*/_jsx(ImageTag, {
        src: closeIcon,
        showCursorPointer: true
      }) : /*#__PURE__*/_jsx(CrossIcon, {})
    })]
  });
};

/* harmony default export */ var components_SnackBar_SnackBar = ((/* unused pure expression or super */ null && (SnackBar_SnackBar)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Modal/Modal.styles.ts

var Modal_styles_ModalWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Modalstyles__ModalWrapper",
  componentId: "sc-8yx8eq-0"
})(["overflow:hidden;width:", ";padding:", ";background-color:#fff;border-radius:12px;position:fixed;max-height:550px;overflow-y:auto;z-index:11;", " ", " ", ""], function (props) {
  return props.modalWidth ? "".concat(props.modalWidth, "px") : "420px";
}, function (props) {
  return props.padding ? "".concat(props.padding) : "20px 30px 30px 30px";
}, function (props) {
  return props.modalType === "centered" && "\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    ";
}, function (props) {
  return props.modalType === "bottomSheet" && "\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        animation: modalAnim 0.6s ;\n    @keyframes modalAnim {\n        from{bottom:-600px;}\n        to{bottom:0;}\n    }\n    ";
}, function (props) {
  return props.modalType === "fullPage" && "\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: 0;\n        \n        animation: fullModalAnim 0.8s;\n        @keyframes fullModalAnim {\n            from{top:".concat(window.innerHeight, "px;}\n            to{top:0;}\n        }\n    ");
});
var Modal_styles_ModalBackdrop = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Modalstyles__ModalBackdrop",
  componentId: "sc-8yx8eq-1"
})(["width:100%;height:100%;background-color:rgba(0,0,0,0.5);position:fixed;left:0;top:0;z-index:10;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Modal/Modal.tsx







var Modal_Modal = function Modal(_ref) {
  var children = _ref.children,
      modalWidth = _ref.modalWidth,
      modalHeading = _ref.modalHeading,
      modalHeadingComp = _ref.modalHeadingComp,
      modalSubHeading = _ref.modalSubHeading,
      _ref$modalHeadingCtrM = _ref.modalHeadingCtrMargin,
      modalHeadingCtrMargin = _ref$modalHeadingCtrM === void 0 ? "0 0 32px 0" : _ref$modalHeadingCtrM,
      closeButton = _ref.closeButton,
      onModalClose = _ref.onModalClose,
      padding = _ref.padding,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? "centered" : _ref$modalType,
      backBtn = _ref.backBtn,
      _ref$showBackBtn = _ref.showBackBtn,
      showBackBtn = _ref$showBackBtn === void 0 ? false : _ref$showBackBtn;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ModalWrapper, {
      padding: padding,
      modalType: modalType,
      modalWidth: modalWidth,
      children: [modalType === "fullPage" && showBackBtn ? /*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        margin: modalHeadingCtrMargin,
        children: [backBtn && /*#__PURE__*/_jsx("span", {
          onClick: onModalClose,
          children: backBtn
        }), (modalHeading || modalSubHeading) && (modalSubHeading ? /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "column",
          margin: "0px",
          children: [modalHeading && /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "md",
            margin: "0px 0px 0px 20px",
            color: theme.greyText,
            fontWeight: "bold",
            children: modalHeading
          }), /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "xs",
            margin: "0px 0px 0px 20px",
            color: theme.greyText6,
            children: modalSubHeading
          })]
        }) : /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          margin: "0px 0px 0px 20px",
          color: theme.greyText,
          fontWeight: "bold",
          children: modalHeading
        })), modalHeadingComp && modalHeadingComp]
      }) : (modalHeading || closeButton || modalHeadingComp) && /*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        margin: modalHeadingCtrMargin,
        children: [(modalHeading || modalSubHeading) && modalSubHeading ? /*#__PURE__*/_jsxs(FlexComp, {
          margin: "0px",
          flexDirection: "column",
          children: [modalHeading && /*#__PURE__*/_jsx(H5Tag, {
            children: modalHeading
          }), /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: modalSubHeading
          })]
        }) : modalHeading && /*#__PURE__*/_jsx(H5Tag, {
          children: modalHeading
        }), modalHeadingComp && modalHeadingComp, closeButton && /*#__PURE__*/_jsx("span", {
          onClick: onModalClose,
          children: closeButton
        })]
      }), children]
    }), /*#__PURE__*/_jsx(ModalBackdrop, {
      onClick: onModalClose
    })]
  });
};

/* harmony default export */ var components_Modal_Modal = ((/* unused pure expression or super */ null && (Modal_Modal)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LocationPermission/LocationPermission.styles.ts

var LocationPermission_styles_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LocationPermissionstyles__Container",
  componentId: "sc-1onzr5s-0"
})(["background:linear-gradient(98.48deg,#000000 2.53%,#260505 100%);border-radius:8px;padding:20px 16px;display:flex;justify-content:space-between;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LocationPermission/LocationPermission.tsx






var LocationPermission = function LocationPermission(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      subTitle = _ref.subTitle,
      switchButton = _ref.switchButton,
      onToggleClick = _ref.onToggleClick,
      locked = _ref.locked;
  return /*#__PURE__*/_jsxs(Container, {
    children: [icon && /*#__PURE__*/_jsx(FlexComp, {
      flexShrink: "0",
      margin: "0 8px 0 0",
      children: icon
    }), /*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: "column",
      flex: "1",
      children: [title && /*#__PURE__*/_jsx(ParaTag, {
        margin: "0 0 8px 0",
        fontSize: "md",
        fontWeight: "bold",
        color: theme.whiteText,
        children: title
      }), subTitle && /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "xs",
        color: "rgba(255,255,255,0.6)",
        children: subTitle
      })]
    }), switchButton && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ToggleBtn, {
        locked: locked,
        onToggleClick: onToggleClick
      })
    })]
  });
};

/* harmony default export */ var LocationPermission_LocationPermission = ((/* unused pure expression or super */ null && (LocationPermission)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/EditLocation/EditLocation.styles.ts


var EditLocation_styles_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditLocationstyles__Container",
  componentId: "sc-9piew7-0"
})([""]);
var EditLocation_styles_Cta = styled_components_browser_esm["default"].a.withConfig({
  displayName: "EditLocationstyles__Cta",
  componentId: "sc-9piew7-1"
})(["font-size:12px;line-height:16px;color:", ";font-weight:700;display:inline-flex;align-items:center;margin-left:5px;"], Global/* theme.blueText */.rS.blueText);
var EditLocation_styles_GpsIconWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditLocationstyles__GpsIconWpr",
  componentId: "sc-9piew7-2"
})(["margin:0 2px 0 0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/EditLocation/EditLocation.tsx









var EditLocation = function EditLocation(_ref) {
  var onModalClose = _ref.onModalClose,
      modalHeading = _ref.modalHeading,
      closeButton = _ref.closeButton,
      pinCodeLabel = _ref.pinCodeLabel,
      pinCodeDetails = _ref.pinCodeDetails,
      continueBtnTitle = _ref.continueBtnTitle,
      btnDisableState = _ref.btnDisableState,
      continueBtnHandler = _ref.continueBtnHandler,
      spinnerTxt = _ref.spinnerTxt,
      _ref$showLoader = _ref.showLoader,
      showLoader = _ref$showLoader === void 0 ? false : _ref$showLoader,
      detectLocationHandler = _ref.detectLocationHandler,
      detectLocationTxt = _ref.detectLocationTxt,
      gpsIcon = _ref.gpsIcon,
      showErrorSnackbar = _ref.showErrorSnackbar,
      errorDetails = _ref.errorDetails,
      citiesList = _ref.citiesList,
      showServicableCities = _ref.showServicableCities,
      citiesSectionTitle = _ref.citiesSectionTitle,
      showMoreBtnTxt = _ref.showMoreBtnTxt;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    modalHeading: modalHeading,
    onModalClose: onModalClose,
    closeButton: closeButton ? /*#__PURE__*/_jsx(ImageTag, {
      src: closeButton,
      showCursorPointer: true
    }) : /*#__PURE__*/_jsx(CloseIcon, {}),
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: /*#__PURE__*/_jsx(Container, {
      children: !showLoader ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [pinCodeLabel && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: device === "lg" ? "md" : "sm",
          lineHeight: device === "lg" ? "18px" : "20px",
          margin: "32px 0 16px 0",
          children: pinCodeLabel
        }), /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "row",
          flex: "1",
          justifyContent: "center",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(TMFloatingInput, {
            flex: 1,
            labelTxt: pinCodeDetails === null || pinCodeDetails === void 0 ? void 0 : pinCodeDetails.labelTxt,
            inputValue: pinCodeDetails === null || pinCodeDetails === void 0 ? void 0 : pinCodeDetails.inputValue,
            handleChange: pinCodeDetails === null || pinCodeDetails === void 0 ? void 0 : pinCodeDetails.handleChange,
            errorState: pinCodeDetails === null || pinCodeDetails === void 0 ? void 0 : pinCodeDetails.errorState,
            verifiedTag: pinCodeDetails === null || pinCodeDetails === void 0 ? void 0 : pinCodeDetails.verifiedTag,
            maxLength: pinCodeDetails === null || pinCodeDetails === void 0 ? void 0 : pinCodeDetails.maxLength
          }), /*#__PURE__*/_jsxs(Cta, {
            onClick: detectLocationHandler,
            children: [/*#__PURE__*/_jsx(GpsIconWpr, {
              children: gpsIcon ? /*#__PURE__*/_jsx(ImageTag, {
                src: gpsIcon
              }) : /*#__PURE__*/_jsx(GpsIcon, {})
            }), detectLocationTxt]
          })]
        }), showErrorSnackbar && /*#__PURE__*/_jsx(SnackBar, {
          containerStyle: {
            marginTop: 16
          },
          buttonText: errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.btnText,
          message: errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorMsg,
          onButtonClick: errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.snackbarCloseHandler,
          isPosFixed: false
        }), showServicableCities && /*#__PURE__*/_jsx(PincodeCities, {
          title: citiesSectionTitle,
          citiesList: citiesList,
          showMoreBtnTxt: showMoreBtnTxt
        }), /*#__PURE__*/_jsx(LandingButton, {
          customTitle: continueBtnTitle,
          margin: "24px 0 0 0",
          customWidth: "100%",
          disableState: btnDisableState,
          onClick: continueBtnHandler
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FlexComp, {
          justifyContent: "center",
          margin: "32px 0 16px 0",
          children: /*#__PURE__*/_jsx(Spinner, {
            thickness: 3,
            spinnerWidth: 30
          })
        }), spinnerTxt && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          lineHeight: "24px",
          margin: "12px 0 16px 0",
          color: theme.greyText,
          textAlign: "center",
          children: spinnerTxt
        })]
      })
    })
  });
};

/* harmony default export */ var EditLocation_EditLocation = ((/* unused pure expression or super */ null && (EditLocation)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Spinner/Spinner.styles.ts

var rotate = (0,styled_components_browser_esm.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var Spinner_styles_SpinnerCont = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Spinnerstyles__SpinnerCont",
  componentId: "sc-1pp3kmk-0"
})(["display:inline-block;height:22px;width:22px;animation:", " 1s linear infinite;border-right-color:transparent;border-radius:50%;margin:-2px auto;"], rotate);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Spinner/Spinner.tsx


function Spinner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Spinner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Spinner_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Spinner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Spinner_Spinner = function Spinner(_ref) {
  var _ref$spinnerWidth = _ref.spinnerWidth,
      spinnerWidth = _ref$spinnerWidth === void 0 ? 22 : _ref$spinnerWidth,
      _ref$spinnerColor = _ref.spinnerColor,
      spinnerColor = _ref$spinnerColor === void 0 ? "#0189d2" : _ref$spinnerColor,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? 2 : _ref$thickness,
      customStyle = _ref.customStyle;
  return /*#__PURE__*/_jsx(SpinnerCont, {
    style: Spinner_objectSpread({
      width: spinnerWidth,
      height: spinnerWidth,
      border: "".concat(thickness, "px solid ").concat(spinnerColor),
      borderRightColor: "transparent"
    }, customStyle)
  });
};

/* harmony default export */ var components_Spinner_Spinner = ((/* unused pure expression or super */ null && (Spinner_Spinner)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Loader/Loader.style.ts

var Loader_style_Overlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Loaderstyle__Overlay",
  componentId: "sc-1sxebod-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:9999;"]);
var Loader_style_SpinnerWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Loaderstyle__SpinnerWrapper",
  componentId: "sc-1sxebod-1"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:1;gap:12px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Loader/Loader.tsx






var Loader = function Loader(_ref) {
  var loaderTxt = _ref.loaderTxt;
  return /*#__PURE__*/_jsx(Overlay, {
    children: /*#__PURE__*/_jsxs(SpinnerWrapper, {
      children: [/*#__PURE__*/_jsx(Spinner, {
        spinnerWidth: 36,
        thickness: 4
      }), loaderTxt && /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: theme.whiteText,
        children: loaderTxt
      })]
    })
  });
};

/* harmony default export */ var Loader_Loader = ((/* unused pure expression or super */ null && (Loader)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/TravAddressForm/TravAddressForm.style.ts


var TravAddressForm_style_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravAddressFormstyle__Container",
  componentId: "sc-9olgg3-0"
})(["display:flex;gap:16px;flex-direction:column;"]);
var TravAddressForm_style_Cta = styled_components_browser_esm["default"].a.withConfig({
  displayName: "TravAddressFormstyle__Cta",
  componentId: "sc-9olgg3-1"
})(["font-size:14px;line-height:19px;color:", ";font-weight:800;display:inline-flex;align-items:center;margin-left:22px;cursor:pointer;"], Global/* theme.blackText */.rS.blackText);
var TravAddressForm_style_GpsIconWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravAddressFormstyle__GpsIconWpr",
  componentId: "sc-9olgg3-2"
})(["margin:0 5px 0 0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/TravAddressForm/TravAddressForm.tsx









var TravAddressForm = function TravAddressForm(_ref) {
  var onModalClose = _ref.onModalClose,
      modalHeading = _ref.modalHeading,
      closeButton = _ref.closeButton,
      backIcon = _ref.backIcon,
      _ref$locationEnabled = _ref.locationEnabled,
      locationEnabled = _ref$locationEnabled === void 0 ? true : _ref$locationEnabled,
      detectLocationLabel = _ref.detectLocationLabel,
      detectLocationHandler = _ref.detectLocationHandler,
      pincodeInput = _ref.pincodeInput,
      address1Input = _ref.address1Input,
      address2Input = _ref.address2Input,
      stateInput = _ref.stateInput,
      cityInput = _ref.cityInput,
      btnLabel = _ref.btnLabel,
      btnDisabledState = _ref.btnDisabledState,
      btnClickHandler = _ref.btnClickHandler,
      snackbarDetails = _ref.snackbarDetails,
      showSnackbar = _ref.showSnackbar,
      gpsIcon = _ref.gpsIcon;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    showBackBtn: true,
    modalHeading: modalHeading,
    onModalClose: onModalClose,
    backBtn: device === "sm" && (backIcon ? /*#__PURE__*/_jsx(ImageTag, {
      src: backIcon,
      showCursorPointer: true
    }) : /*#__PURE__*/_jsx(BackIcon, {})),
    closeButton: device === "lg" && (closeButton ? /*#__PURE__*/_jsx(ImageTag, {
      src: closeButton,
      showCursorPointer: true
    }) : /*#__PURE__*/_jsx(CloseIcon, {})),
    modalType: device === "lg" ? "centered" : "fullPage",
    padding: device === "sm" ? "16px" : "20px 30px 30px 30px",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "row",
        flex: "1",
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(TMFloatingInput, {
          flex: 1,
          labelTxt: pincodeInput === null || pincodeInput === void 0 ? void 0 : pincodeInput.labelTxt,
          inputValue: pincodeInput === null || pincodeInput === void 0 ? void 0 : pincodeInput.inputValue,
          handleChange: pincodeInput === null || pincodeInput === void 0 ? void 0 : pincodeInput.handleChange,
          errorState: pincodeInput === null || pincodeInput === void 0 ? void 0 : pincodeInput.errorState,
          verifiedTag: pincodeInput === null || pincodeInput === void 0 ? void 0 : pincodeInput.verifiedTag,
          maxLength: pincodeInput === null || pincodeInput === void 0 ? void 0 : pincodeInput.maxLength
        }), locationEnabled && /*#__PURE__*/_jsxs(Cta, {
          onClick: detectLocationHandler,
          children: [/*#__PURE__*/_jsx(GpsIconWpr, {
            children: gpsIcon ? /*#__PURE__*/_jsx(ImageTag, {
              src: gpsIcon
            }) : /*#__PURE__*/_jsx(GpsIcon, {
              color: theme.blackText
            })
          }), detectLocationLabel]
        })]
      }), /*#__PURE__*/_jsx(TMFloatingInput, {
        labelTxt: address1Input === null || address1Input === void 0 ? void 0 : address1Input.labelTxt,
        inputValue: address1Input === null || address1Input === void 0 ? void 0 : address1Input.inputValue,
        handleChange: address1Input === null || address1Input === void 0 ? void 0 : address1Input.handleChange,
        errorState: address1Input === null || address1Input === void 0 ? void 0 : address1Input.errorState,
        verifiedTag: address1Input === null || address1Input === void 0 ? void 0 : address1Input.verifiedTag,
        maxLength: address1Input === null || address1Input === void 0 ? void 0 : address1Input.maxLength
      }), /*#__PURE__*/_jsx(TMFloatingInput, {
        labelTxt: address2Input === null || address2Input === void 0 ? void 0 : address2Input.labelTxt,
        inputValue: address2Input === null || address2Input === void 0 ? void 0 : address2Input.inputValue,
        handleChange: address2Input === null || address2Input === void 0 ? void 0 : address2Input.handleChange,
        errorState: address2Input === null || address2Input === void 0 ? void 0 : address2Input.errorState,
        verifiedTag: address2Input === null || address2Input === void 0 ? void 0 : address2Input.verifiedTag,
        maxLength: address2Input === null || address2Input === void 0 ? void 0 : address2Input.maxLength
      }), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "row",
        gap: "12px",
        children: [/*#__PURE__*/_jsx(TMFloatingInput, {
          labelTxt: stateInput === null || stateInput === void 0 ? void 0 : stateInput.labelTxt,
          inputValue: stateInput === null || stateInput === void 0 ? void 0 : stateInput.inputValue,
          handleChange: stateInput === null || stateInput === void 0 ? void 0 : stateInput.handleChange,
          errorState: stateInput === null || stateInput === void 0 ? void 0 : stateInput.errorState,
          verifiedTag: stateInput === null || stateInput === void 0 ? void 0 : stateInput.verifiedTag,
          maxLength: stateInput === null || stateInput === void 0 ? void 0 : stateInput.maxLength,
          flex: 0.5
        }), /*#__PURE__*/_jsx(TMFloatingInput, {
          labelTxt: cityInput === null || cityInput === void 0 ? void 0 : cityInput.labelTxt,
          inputValue: cityInput === null || cityInput === void 0 ? void 0 : cityInput.inputValue,
          handleChange: cityInput === null || cityInput === void 0 ? void 0 : cityInput.handleChange,
          errorState: cityInput === null || cityInput === void 0 ? void 0 : cityInput.errorState,
          verifiedTag: cityInput === null || cityInput === void 0 ? void 0 : cityInput.verifiedTag,
          maxLength: cityInput === null || cityInput === void 0 ? void 0 : cityInput.maxLength,
          flex: 0.5
        })]
      }), /*#__PURE__*/_jsx(LandingButton, {
        margin: "4px 0px",
        customTitle: btnLabel,
        customWidth: "100%",
        disableState: btnDisabledState,
        onClick: btnClickHandler
      }), showSnackbar && /*#__PURE__*/_jsx(SnackBar, {
        containerStyle: {
          marginTop: 16
        },
        buttonText: snackbarDetails === null || snackbarDetails === void 0 ? void 0 : snackbarDetails.btnText,
        message: snackbarDetails === null || snackbarDetails === void 0 ? void 0 : snackbarDetails.snackbarMsg,
        onButtonClick: snackbarDetails === null || snackbarDetails === void 0 ? void 0 : snackbarDetails.snackbarCloseHandler,
        bgColor: snackbarDetails === null || snackbarDetails === void 0 ? void 0 : snackbarDetails.bgColor,
        txtColor: snackbarDetails === null || snackbarDetails === void 0 ? void 0 : snackbarDetails.txtColor
      })]
    })
  });
};

/* harmony default export */ var TravAddressForm_TravAddressForm = ((/* unused pure expression or super */ null && (TravAddressForm)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToolTip/ToolTip.styles.ts

var ToolTip_styles_ToolTipCont = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ToolTipstyles__ToolTipCont",
  componentId: "vfq5tw-0"
})(["width:", ";background-color:", ";padding:8px;border-radius:4px;position:absolute;", " ", " ", " ", ""], function (props) {
  return props.width ? props.width : "400px";
}, function (props) {
  return props.bgColor ? props.bgColor : "#005756";
}, function (props) {
  return props.arrowDirection === "up" && "\n        ::after {\n            bottom: 100%;\n            left: ".concat(props.arrowPosition ? props.arrowPosition : "50%", ";\n            border: solid transparent;\n            content: \"\";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-color: rgba(0, 87, 86, 0);\n            border-bottom-color: ").concat(props.bgColor ? props.bgColor : "#005756", ";\n            border-width: 8px;\n            margin-left: -8px;\n        }\n    ");
}, function (props) {
  return props.arrowDirection === "right" && "\n        ::after {\n            left: 100%;\n            top: ".concat(props.arrowPosition ? props.arrowPosition : "50%", ";\n            border: solid transparent;\n            content: \"\";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-color: rgba(0, 87, 86, 0);\n            border-left-color: ").concat(props.bgColor ? props.bgColor : "#005756", ";\n            border-width: 8px;\n            margin-top: -8px;\n        }\n    ");
}, function (props) {
  return props.arrowDirection === "down" && "\n        ::after {\n            top: 100%;\n            left: ".concat(props.arrowPosition ? props.arrowPosition : "50%", ";\n            border: solid transparent;\n            content: \"\";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-color: rgba(0, 87, 86, 0);\n            border-top-color: ").concat(props.bgColor ? props.bgColor : "#005756", ";\n            border-width: 8px;\n            margin-left: -8px;\n        }\n    ");
}, function (props) {
  return props.arrowDirection === "left" && "\n        ::after {\n            right: 100%;\n            top: ".concat(props.arrowPosition ? props.arrowPosition : "50%", ";\n            border: solid transparent;\n            content: \"\";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-color: rgba(0, 87, 86, 0);\n            border-right-color: ").concat(props.bgColor ? props.bgColor : "#005756", ";\n            border-width: 8px;\n            margin-top: -8px;\n        }\n    ");
});
var ToolTip_styles_ToolTipBackdrop = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ToolTipstyles__ToolTipBackdrop",
  componentId: "vfq5tw-1"
})(["width:100%;height:100%;position:fixed;left:0;top:0;z-index:-1;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToolTip/ToolTip.tsx






var ToolTip_ToolTip = function ToolTip(_ref) {
  var width = _ref.width,
      children = _ref.children,
      bgColor = _ref.bgColor,
      _ref$arrowDirection = _ref.arrowDirection,
      arrowDirection = _ref$arrowDirection === void 0 ? "down" : _ref$arrowDirection,
      arrowPosition = _ref.arrowPosition,
      style = _ref.style,
      closeTooltip = _ref.closeTooltip;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ToolTipCont, {
      width: width,
      arrowDirection: arrowDirection,
      arrowPosition: arrowPosition,
      bgColor: bgColor,
      style: style,
      children: children
    }), /*#__PURE__*/_jsx(ToolTipBackdrop, {
      onClick: function onClick(e) {
        return closeTooltip && closeTooltip(e);
      }
    })]
  });
};

/* harmony default export */ var components_ToolTip_ToolTip = ((/* unused pure expression or super */ null && (ToolTip_ToolTip)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/PanFaqs/PanFaqs.styles.ts



var PanFaqs_styles_PanHdr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PanFaqsstyles__PanHdr",
  componentId: "sc-1hjj42m-0"
})(["display:flex;justify-content:space-between;padding:26px 30px 22px 30px;align-items:center;@media ", "{padding:16px;}", ""], utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.shadow && "\n        box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);\n    ";
});
var PanFaqs_styles_PanDtl = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PanFaqsstyles__PanDtl",
  componentId: "sc-1hjj42m-1"
})(["padding:0 30px 30px 30px;max-height:390px;overflow-y:auto;@media ", "{padding:0 16px 16px 16px;max-height:unset;height:calc(100% - 66px);}"], utils/* deviceType.mobile */.vO.mobile);
var PanFaqs_styles_FaqItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PanFaqsstyles__FaqItem",
  componentId: "sc-1hjj42m-2"
})(["border-bottom:1px #e2e2e2 solid;", ";"], function (props) {
  return props.padding && "\n        padding-bottom: ".concat(props.padding, ";\n    ");
});
var PanFaqs_styles_FaqItemHdr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PanFaqsstyles__FaqItemHdr",
  componentId: "sc-1hjj42m-3"
})(["display:flex;flex-direction:row;align-items:center;padding:18px 0;padding-right:30px;cursor:pointer;position:relative;::after{content:\"\";display:inline-flex;border:solid #008cff;border-width:0 2px 2px 0;padding:3px;position:absolute;right:4px;top:50%;transform:translateY(-50%) ", ";}"], function (props) {
  return props.isActive ? "rotate(-135deg)" : "rotate(45deg)";
});
var PanFaqs_styles_AnswerList = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PanFaqsstyles__AnswerList",
  componentId: "sc-1hjj42m-4"
})(["display:grid;grid-template-columns:1fr;gap:20px;"]);
var PanFaqs_styles_Cta = styled_components_browser_esm["default"].a.withConfig({
  displayName: "PanFaqsstyles__Cta",
  componentId: "sc-1hjj42m-5"
})(["font-size:14px;line-height:20px;font-weight:700;color:", ";display:flex;align-items:center;cursor:pointer;"], Global/* theme.blueText */.rS.blueText);
var PanFaqs_styles_CtaIconWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PanFaqsstyles__CtaIconWpr",
  componentId: "sc-1hjj42m-6"
})(["margin:0 0 0 10px;"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useBreakpoint/index.tsx
var hooks_useBreakpoint = __webpack_require__(4484);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/PanFaqs/PanFaqs.tsx












var PanFaqs = function PanFaqs(_ref) {
  var _elementRef$current;

  var data = _ref.data,
      closeModal = _ref.closeModal,
      panFaqHeading = _ref.panFaqHeading,
      closeIcon = _ref.closeIcon,
      onCtaClick = _ref.onCtaClick,
      ctaIcon = _ref.ctaIcon;
  var device = useBreakpoint();
  var elementRef = useRef();

  var _useState = useState(null),
      selected = _useState[0],
      setSelected = _useState[1];

  var _useState2 = useState(0),
      scrollPosition = _useState2[0],
      setScrollPosition = _useState2[1];

  var handleFaqs = function handleFaqs(idx) {
    setSelected(selected === idx ? null : idx);
  };

  elementRef === null || elementRef === void 0 ? void 0 : (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.addEventListener("scroll", function (event) {
    setScrollPosition(elementRef === null || elementRef === void 0 ? void 0 : elementRef.current.scrollTop);
  });
  return /*#__PURE__*/_jsxs(Modal, {
    onModalClose: closeModal,
    padding: "0px",
    modalType: device === "lg" ? "centered" : "fullPage",
    children: [/*#__PURE__*/_jsx(PanHdr, {
      shadow: scrollPosition > 10,
      children: device === "lg" ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [panFaqHeading && /*#__PURE__*/_jsx(H5Tag, {
          children: panFaqHeading
        }), /*#__PURE__*/_jsx("div", {
          onClick: closeModal,
          children: closeIcon ? /*#__PURE__*/_jsx(ImageTag, {
            src: closeIcon,
            showCursorPointer: true
          }) : /*#__PURE__*/_jsx(CloseIcon, {})
        })]
      }) : /*#__PURE__*/_jsx("div", {
        onClick: closeModal,
        children: closeIcon ? /*#__PURE__*/_jsx(ImageTag, {
          src: closeIcon,
          showCursorPointer: true
        }) : /*#__PURE__*/_jsx(CloseIcon, {})
      })
    }), /*#__PURE__*/_jsxs(PanDtl, {
      ref: elementRef,
      children: [device === "sm" && panFaqHeading && /*#__PURE__*/_jsx(H5Tag, {
        margin: "0 0 16px 0",
        children: panFaqHeading
      }), data === null || data === void 0 ? void 0 : data.map(function (item, index) {
        return /*#__PURE__*/_jsxs(FaqItem, {
          padding: selected === index ? "18px" : "",
          children: [/*#__PURE__*/_jsx(FaqItemHdr, {
            onClick: function onClick() {
              return handleFaqs(index);
            },
            isActive: selected === index,
            children: /*#__PURE__*/_jsx(ParaTag, {
              fontWeight: selected === index ? "bold" : "regular",
              children: item.question
            })
          }), selected === index && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(AnswerList, {
              children: item.answers && item.answers.length > 0 && item.answers.map(function (answer, index) {
                return /*#__PURE__*/_jsx(ParaTag, {
                  children: answer
                }, "".concat(index));
              })
            }), item.cta && /*#__PURE__*/_jsx(ParaTag, {
              margin: "18px 0 0 0",
              children: /*#__PURE__*/_jsxs(Cta, {
                onClick: onCtaClick,
                children: [item.cta, " ", /*#__PURE__*/_jsx(CtaIconWpr, {
                  children: ctaIcon ? /*#__PURE__*/_jsx(ImageTag, {
                    src: ctaIcon
                  }) : /*#__PURE__*/_jsx(ArrowLarge, {})
                })]
              })
            })]
          })]
        }, "".concat(item.id));
      })]
    })]
  });
};

/* harmony default export */ var PanFaqs_PanFaqs = ((/* unused pure expression or super */ null && (PanFaqs)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OtpPlaceholder/OtpPlaceholder.style.ts


var OtpPlaceholder_style_InputContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OtpPlaceholderstyle__InputContainer",
  componentId: "sc-1s0jw9l-0"
})(["display:flex;justify-content:center;align-items:center;"]);
var OtpPlaceholder_style_Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "OtpPlaceholderstyle__Input",
  componentId: "sc-1s0jw9l-1"
})(["width:35px;padding:5px 0px;font-size:18px;line-height:28px;text-align:center;border:1px solid ", ";border-radius:4px;&:focus{outline:none;border-color:", ";}"], function (_ref) {
  var hasError = _ref.hasError;
  return hasError ? Global/* theme.redText2 */.rS.redText2 : Global/* theme.greyText4 */.rS.greyText4;
}, Global/* theme.blueText */.rS.blueText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OtpPlaceholder/OtpPlaceholder.tsx








var OtpPlaceholder_OtpPlaceholder = function OtpPlaceholder(_ref) {
  var numInputs = _ref.numInputs,
      onChange = _ref.onChange,
      error = _ref.error,
      loading = _ref.loading,
      setError = _ref.setError;

  var _useState = useState(new Array(numInputs).fill("")),
      otp = _useState[0],
      setOtp = _useState[1];

  var inputRefs = useRef(new Array(numInputs).fill(null));
  useEffect(function () {
    if (otp.length === numInputs) {
      for (var i = 0; i < numInputs; i++) {
        var _inputRefs$current$i;

        (_inputRefs$current$i = inputRefs.current[i]) === null || _inputRefs$current$i === void 0 ? void 0 : _inputRefs$current$i.blur();
      }
    }
  }, [loading]);

  var handleClick = function handleClick(idx) {
    if (setError) {
      setError("");
    }

    var otpString = otp.join("");

    if (idx + 1 > otpString.length && otpString.length < numInputs) {
      var _inputRefs$current$ot;

      (_inputRefs$current$ot = inputRefs.current[otpString.length]) === null || _inputRefs$current$ot === void 0 ? void 0 : _inputRefs$current$ot.focus();
    }
  };

  var handleChange = function handleChange(e, index) {
    var otpValue = e.target.value;

    var newOtp = _toConsumableArray(otp);

    newOtp[index] = otpValue;
    setOtp(newOtp);
    onChange(newOtp.join(""));

    if (otpValue && index < numInputs - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  var handleKeyDown = function handleKeyDown(e, index) {
    if (e.key === "Backspace" && !otp[index] && index > 0 && inputRefs.current[index - 1]) {
      var newOtp = _toConsumableArray(otp);

      newOtp[index - 1] = "";
      setOtp(newOtp);
      onChange(newOtp.join(""));
      inputRefs.current[index - 1].focus();
    }

    if (e.key === "ArrowLeft" && index > 0 && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus();
    }

    if (e.key === "ArrowRight" && index < numInputs - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }

    if (e.key.match(/[0-9]/)) {
      // clear the current and all subsequent inputs if the current input is not empty and a new value is entered
      var _newOtp = _toConsumableArray(otp);

      for (var i = index; i < numInputs; i++) {
        _newOtp[i] = "";
        inputRefs.current[i].value = "";
      }

      setOtp(_newOtp);
      onChange(_newOtp.join(""));
      inputRefs.current[index].value = "";
    }
  };

  var handlePaste = function handlePaste(e) {
    e.preventDefault();
    var pastedData = e.clipboardData.getData("Text");
    var pastedOtp = pastedData.slice(0, numInputs).split("");

    var newOtp = _toConsumableArray(otp);

    pastedOtp.forEach(function (digit, index) {
      newOtp[index] = digit;
    });
    setOtp(newOtp);
    onChange(newOtp.join(""));
  };

  var inputs = [];

  var _loop = function _loop(i) {
    inputs.push( /*#__PURE__*/_jsx(Input, {
      style: {
        marginRight: "".concat(i < numInputs - 1 ? 8 : 0, "px"),
        color: !!error ? theme.redText2 : theme.blackText
      },
      type: "text",
      id: "input-".concat(i),
      inputMode: "numeric",
      onPaste: handlePaste,
      value: otp[i],
      onChange: function onChange(e) {
        return handleChange(e, i);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, i);
      },
      maxLength: 1,
      pattern: "[0-9]",
      ref: function ref(_ref2) {
        return inputRefs.current[i] = _ref2;
      },
      hasError: !!error,
      onClick: function onClick() {
        return handleClick(i);
      },
      disabled: loading ? true : false
    }, "input-".concat(i)));
  };

  for (var i = 0; i < numInputs; i++) {
    _loop(i);
  }

  return /*#__PURE__*/_jsxs(FlexComp, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(InputContainer, {
      children: inputs
    }), !!error && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "xs",
      fontWeight: "regular",
      color: theme.redText2,
      margin: "8px 0px 0px 0px",
      children: error
    })]
  });
};

/* harmony default export */ var components_OtpPlaceholder_OtpPlaceholder = ((/* unused pure expression or super */ null && (OtpPlaceholder_OtpPlaceholder)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OtpComp/OtpComp.tsx





var OtpComp_OtpComp = function OtpComp(_ref) {
  var _ref$errorMsg = _ref.errorMsg,
      errorMsg = _ref$errorMsg === void 0 ? "" : _ref$errorMsg,
      setOtp = _ref.setOtp;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(""),
      error = _useState2[0],
      setError = _useState2[1];

  var handleOtpChange = function handleOtpChange(newOtp) {
    setOtp(newOtp);

    if (newOtp.length === 6) {
      setLoading(true);
    } else {
      setError("");
      setLoading(false);
    }
  };

  useEffect(function () {
    if (loading) {
      setError("");
    }

    var timer = setTimeout(function () {
      if (loading) {
        setError(errorMsg);
        setLoading(false);
      }
    }, 2000);
    return function () {
      clearTimeout(timer);
    };
  }, [loading]);
  return /*#__PURE__*/_jsxs(FlexComp, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(OtpPlaceholder, {
      numInputs: 6,
      onChange: handleOtpChange,
      error: error,
      setError: setError,
      loading: loading
    }), loading && /*#__PURE__*/_jsx(Spinner, {
      thickness: 2,
      spinnerWidth: 22,
      customStyle: {
        margin: "0px 20px"
      }
    })]
  });
};

/* harmony default export */ var components_OtpComp_OtpComp = ((/* unused pure expression or super */ null && (OtpComp_OtpComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/EditNumber/EditNumber.tsx









var EditNumber = function EditNumber(_ref) {
  var _editMobileNo$editInp, _editMobileNo$editInp2, _editMobileNo$editInp3, _editMobileNo$editInp4, _editMobileNo$editInp5, _editMobileNo$editInp6;

  var _ref$flowState = _ref.flowState,
      flowState = _ref$flowState === void 0 ? 1 : _ref$flowState,
      onModalClose = _ref.onModalClose,
      _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? /*#__PURE__*/_jsx(CloseIcon, {}) : _ref$closeButton,
      editMobileNo = _ref.editMobileNo,
      btnDisableState = _ref.btnDisableState,
      continueBtnHandler = _ref.continueBtnHandler,
      verifyMobileNo = _ref.verifyMobileNo,
      otpDetails = _ref.otpDetails,
      setOtp = _ref.setOtp;
  var device = useBreakpoint();

  var _useState = useState(true),
      resendOtp = _useState[0],
      setResendOtp = _useState[1];

  var _useState2 = useState(0),
      timer = _useState2[0],
      setTimer = _useState2[1];

  var resendTimer = useRef();

  var handleResendOtp = function handleResendOtp() {
    if (resendOtp) {
      setResendOtp(false);
      setTimer((verifyMobileNo === null || verifyMobileNo === void 0 ? void 0 : verifyMobileNo.resendOtpTimer) || 10);
    }
  };

  useEffect(function () {
    if (timer > 0) {
      resendTimer.current = setTimeout(function () {
        setTimer(timer - 1);
      }, 1000);
    } else {
      setResendOtp(true);
    }

    return function () {
      clearTimeout(resendTimer.current);
    };
  }, [timer]);
  return /*#__PURE__*/_jsxs(Modal, {
    modalHeading: flowState === 1 ? editMobileNo === null || editMobileNo === void 0 ? void 0 : editMobileNo.modalHeading : verifyMobileNo === null || verifyMobileNo === void 0 ? void 0 : verifyMobileNo.modalHeading,
    onModalClose: onModalClose,
    closeButton: closeButton,
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/_jsx(ParaTag, {
      fontSize: "sm",
      fontWeight: "regular",
      color: theme.greyText,
      children: flowState === 1 ? editMobileNo === null || editMobileNo === void 0 ? void 0 : editMobileNo.subHeading : verifyMobileNo === null || verifyMobileNo === void 0 ? void 0 : verifyMobileNo.subHeading
    }), flowState === 1 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TMFloatingInput, {
        labelTxt: editMobileNo === null || editMobileNo === void 0 ? void 0 : (_editMobileNo$editInp = editMobileNo.editInput) === null || _editMobileNo$editInp === void 0 ? void 0 : _editMobileNo$editInp.labelTxt,
        inputValue: editMobileNo === null || editMobileNo === void 0 ? void 0 : (_editMobileNo$editInp2 = editMobileNo.editInput) === null || _editMobileNo$editInp2 === void 0 ? void 0 : _editMobileNo$editInp2.inputValue,
        handleChange: editMobileNo === null || editMobileNo === void 0 ? void 0 : (_editMobileNo$editInp3 = editMobileNo.editInput) === null || _editMobileNo$editInp3 === void 0 ? void 0 : _editMobileNo$editInp3.handleChange,
        errorState: editMobileNo === null || editMobileNo === void 0 ? void 0 : (_editMobileNo$editInp4 = editMobileNo.editInput) === null || _editMobileNo$editInp4 === void 0 ? void 0 : _editMobileNo$editInp4.errorState,
        verifiedTag: editMobileNo === null || editMobileNo === void 0 ? void 0 : (_editMobileNo$editInp5 = editMobileNo.editInput) === null || _editMobileNo$editInp5 === void 0 ? void 0 : _editMobileNo$editInp5.verifiedTag,
        maxLength: editMobileNo === null || editMobileNo === void 0 ? void 0 : (_editMobileNo$editInp6 = editMobileNo.editInput) === null || _editMobileNo$editInp6 === void 0 ? void 0 : _editMobileNo$editInp6.maxLength,
        margin: "36px 0px 0px 0px",
        type: "tel",
        inputMode: "numeric"
      }), /*#__PURE__*/_jsx(LandingButton, {
        customTitle: editMobileNo === null || editMobileNo === void 0 ? void 0 : editMobileNo.btnLabel,
        margin: "24px 0 0 0",
        customWidth: "100%",
        disableState: btnDisableState,
        onClick: continueBtnHandler
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        margin: "36px 0px 8px 0px",
        children: otpDetails === null || otpDetails === void 0 ? void 0 : otpDetails.enterOtpLabel
      }), /*#__PURE__*/_jsx(OtpComp, {
        setOtp: setOtp,
        errorMsg: otpDetails === null || otpDetails === void 0 ? void 0 : otpDetails.errorMsg
      }), resendOtp && /*#__PURE__*/_jsx(AnchorTag, {
        fontSize: "xs",
        fontWeight: "bold",
        margin: "22px 0px 0px 0px",
        handleClick: handleResendOtp,
        children: otpDetails === null || otpDetails === void 0 ? void 0 : otpDetails.resendOtpLabel
      }), !resendOtp && /*#__PURE__*/_jsxs(ParaTag, {
        fontSize: "xs",
        fontWeight: "bold",
        margin: "22px 0px 0px 0px",
        color: "rgba(155,155,155,0.3)",
        children: [otpDetails === null || otpDetails === void 0 ? void 0 : otpDetails.resendOtpLabel, /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          color: theme.greyText4,
          margin: "0px 0px 0px 4px",
          children: "00:".concat(timer >= 10 ? timer : "0".concat(timer))
        })]
      })]
    })]
  });
};

/* harmony default export */ var EditNumber_EditNumber = ((/* unused pure expression or super */ null && (EditNumber)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BulletListItem/BulletListItem.style.ts


var BulletListItem_style_BulletListItemStyle = styled_components_browser_esm["default"].li.withConfig({
  displayName: "BulletListItemstyle__BulletListItemStyle",
  componentId: "unxr0c-0"
})(["margin-bottom:20px;padding-left:20px;position:relative;font-size:18px;line-height:22px;color:", ";&:last-child{margin-bottom:0px;}&:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}"], Global/* theme.greyText */.rS.greyText, function (props) {
  return props.bulletColor;
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBanner.style.tsx






var PersuasionBanner_style_PersuasionBannerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PersuasionBannerstyle__PersuasionBannerStyle",
  componentId: "sc-1a6nyyd-0"
})(["", " padding:30px 34px;border-radius:25px;background-image:", ";background-size:contain;background-repeat:no-repeat;display:flex;flex-direction:column;height:400px;gap:20px;em{color:", ";font-weight:700;font-style:normal;}", "{width:100%;}& ul{display:flex;flex-direction:column;gap:16px;}& li{position:relative;padding-left:16px;}& li:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}@media ", "{padding:32px 16px;background-size:cover;border:1px solid #fff;margin-bottom:16px;}", "{margin-bottom:16px;&:last-child{margin-bottom:0;}@media ", "{margin-bottom:8px;}}", "{padding:10px 40px;}"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return "url(".concat(props.bgImage, ")");
}, Global/* theme.greenText */.rS.greenText, H3TagStyle, Global/* theme.darkYellowText */.rS.darkYellowText, utils/* deviceType.mobile */.vO.mobile, BulletListItem_style_BulletListItemStyle, utils/* deviceType.mobile */.vO.mobile, LandingButton_style_LandingButtonStyle);
var PersuasionBanner_style_BulletListStyle = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "PersuasionBannerstyle__BulletListStyle",
  componentId: "sc-1a6nyyd-1"
})(["display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBanner.tsx






var PersuasionBanner = function PersuasionBanner(_ref) {
  var heading = _ref.heading,
      bgImage = _ref.bgImage,
      bulletPoints = _ref.bulletPoints,
      btnText = _ref.btnText,
      margin = _ref.margin,
      btnHandler = _ref.btnHandler,
      info = _ref.info;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(PersuasionBannerStyle, {
    margin: margin,
    bgImage: bgImage,
    children: [device == "lg" ? /*#__PURE__*/_jsx(H3Tag, {
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: heading
      })
    }) : /*#__PURE__*/_jsxs(H5Tag, {
      children: [" ", /*#__PURE__*/_jsx(FormattedText, {
        value: heading
      })]
    }), device === "sm" && /*#__PURE__*/_jsx(FlexComp, {
      gap: "6px",
      children: /*#__PURE__*/_jsx(ParaTag, {
        dangerousText: info
      })
    }), (bulletPoints === null || bulletPoints === void 0 ? void 0 : bulletPoints.length) > 0 && /*#__PURE__*/_jsx(BulletListStyle, {
      children: bulletPoints.map(function (item) {
        return /*#__PURE__*/_jsxs(BulletListItem, {
          children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
            fontWeight: "bold",
            children: item.boldText
          }), " ", /*#__PURE__*/_jsx(SpanTag, {
            children: item.normalText
          })]
        }, item.id);
      })
    }), /*#__PURE__*/_jsx(LandingButton, {
      customTitle: btnText,
      onClick: btnHandler,
      padding: "0px 40px",
      margin: "auto 0 0"
    })]
  });
};

/* harmony default export */ var PersuasionBanner_PersuasionBanner = ((/* unused pure expression or super */ null && (PersuasionBanner)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MarkdownText/MarkdownText.tsx




var MarkdownText_MarkdownText = function MarkdownText(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_jsx(ReactMarkdown, {
    components: {
      p: "span"
    },
    children: value
  });
};

/* harmony default export */ var components_MarkdownText_MarkdownText = ((/* unused pure expression or super */ null && (MarkdownText_MarkdownText)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBannerInsurance.tsx







var PersuasionBannerInsurance = function PersuasionBannerInsurance(_ref) {
  var crossSell = _ref.crossSell,
      btnHandler = _ref.btnHandler;
  var device = useBreakpointV2();

  if (!crossSell) {
    return null;
  }

  var title = crossSell.title,
      background = crossSell.background,
      description = crossSell.description,
      cta = crossSell.cta,
      info = crossSell.info;
  return /*#__PURE__*/_jsxs(PersuasionBannerStyle, {
    bgImage: background === null || background === void 0 ? void 0 : background.url,
    children: [title && /*#__PURE__*/_jsx(H3Tag, {
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }), device === "sm" && /*#__PURE__*/_jsx(FlexComp, {
      gap: "6px",
      children: /*#__PURE__*/_jsx(ParaTag, {
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info
        })
      })
    }), description && /*#__PURE__*/_jsx(MarkdownText, {
      value: description
    }), /*#__PURE__*/_jsx(LandingButton, {
      customTitle: cta === null || cta === void 0 ? void 0 : cta.title,
      onClick: btnHandler,
      padding: "0px 40px"
    })]
  });
};

/* harmony default export */ var PersuasionBanner_PersuasionBannerInsurance = ((/* unused pure expression or super */ null && (PersuasionBannerInsurance)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter.style.ts



var LandingFooter_style_LandingFooterStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingFooterstyle__LandingFooterStyle",
  componentId: "d0b0t6-0"
})(["background:", ";color:", ";padding-top:32px;padding-bottom:64px;width:100%;@media screen and ", "{padding-bottom:22px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.whiteText */.rS.whiteText, utils/* deviceType.mobile */.vO.mobile);
var LandingFooter_style_ChevronContainerIcon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingFooterstyle__ChevronContainerIcon",
  componentId: "d0b0t6-1"
})(["transform:", ";"], function (props) {
  return props.isInvert ? "rotate(180deg)" : "rotate(0deg)";
});
var LandingFooter_style_LinksContainer = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingFooterstyle__LinksContainer",
  componentId: "d0b0t6-2"
})(["margin-bottom:100px;& > li:not(:last-child){margin-bottom:24px;}@media screen and ", "{margin-bottom:40px;& > li{padding:16px;border-bottom:1px ", " solid;}& > li:not(:last-child){margin-bottom:unset;}}"], utils/* deviceType.mobile */.vO.mobile, Global/* theme.greyText */.rS.greyText);
var LandingFooter_style_FooterSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__FooterSection",
  componentId: "d0b0t6-3"
})(["width:964px;@media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingFooter_style_InnerLinksContainer = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingFooterstyle__InnerLinksContainer",
  componentId: "d0b0t6-4"
})(["display:flex;margin-top:10px;flex-wrap:wrap;& > li{position:relative;color:white;font-size:12px;line-height:16px;}& > li::after{content:\"\u2022\";margin-left:4px;margin-right:4px;}& > li:last-child:after{content:\"\";}"]);
var LandingFooter_style_LandingFooterWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterWrap",
  componentId: "d0b0t6-5"
})(["margin:0 auto;width:1200px;@media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter.tsx








var LandingFooter_LandingFooter = function LandingFooter(_ref) {
  var footerData = _ref.footerData,
      _ref$footerTextOne = _ref.footerTextOne,
      footerTextOne = _ref$footerTextOne === void 0 ? "An initiative" : _ref$footerTextOne,
      _ref$footerTextTwo = _ref.footerTextTwo,
      footerTextTwo = _ref$footerTextTwo === void 0 ? "towards solving Travel Finance" : _ref$footerTextTwo,
      _ref$followUsText = _ref.followUsText,
      followUsText = _ref$followUsText === void 0 ? "FOLLOW US" : _ref$followUsText,
      _ref$downloadText = _ref.downloadText,
      downloadText = _ref$downloadText === void 0 ? "DOWNLOAD" : _ref$downloadText,
      _ref$countryText = _ref.countryText,
      countryText = _ref$countryText === void 0 ? "Country" : _ref$countryText,
      _ref$locationText = _ref.locationText,
      locationText = _ref$locationText === void 0 ? "INDIA" : _ref$locationText,
      _ref$mmtText = _ref.mmtText,
      mmtText = _ref$mmtText === void 0 ? "MAKEMYTRIP PVT. LTD." : _ref$mmtText,
      playStoreImgURI = _ref.playStoreImgURI,
      appStoreImgURI = _ref.appStoreImgURI,
      linkedInImgURI = _ref.linkedInImgURI,
      facebookImgURI = _ref.facebookImgURI,
      twitterImgURI = _ref.twitterImgURI,
      mmtIcon = _ref.mmtIcon,
      downIcon = _ref.downIcon,
      footerHeartIcon = _ref.footerHeartIcon;
  var device = useBreakpointV2();

  var _useState = useState(-1),
      activeIdx = _useState[0],
      setActiveIdx = _useState[1];

  var optionsHandler = function optionsHandler(index) {
    if (activeIdx === index) {
      setActiveIdx(-1);
      return;
    }

    setActiveIdx(index);
  };

  return /*#__PURE__*/_jsx(LandingFooterStyle, {
    children: /*#__PURE__*/_jsxs(LandingFooterWrap, {
      children: [/*#__PURE__*/_jsxs(FooterSection, {
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          alignItems: "center",
          justifyContent: device === "sm" ? "center" : undefined,
          margin: "0px 0px 50px 0px",
          children: [/*#__PURE__*/_jsx(SpanTag, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 8px 4px 0px",
            color: "white",
            children: footerTextOne
          }), mmtIcon ? /*#__PURE__*/_jsx(ImageComponent, {
            width: "85px",
            height: "27px",
            src: mmtIcon
          }) : /*#__PURE__*/_jsx(MMTIcon, {}), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 0px 4px 8px",
            color: "white",
            children: footerTextTwo
          })]
        }), /*#__PURE__*/_jsx(LinksContainer, {
          children: footerData === null || footerData === void 0 ? void 0 : footerData.map(function (item, idx) {
            return (item === null || item === void 0 ? void 0 : item.label) && /*#__PURE__*/_jsxs("li", {
              onClick: device === "sm" ? function () {
                return optionsHandler(idx);
              } : undefined,
              children: [/*#__PURE__*/_jsxs(FlexComp, {
                justifyContent: device === "sm" ? "space-between" : undefined,
                gap: "8px",
                alignItems: "center",
                children: [/*#__PURE__*/_jsxs(FlexComp, {
                  gap: "10px",
                  children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/_jsx(ImageComponent, {
                    width: "18px",
                    height: "18px",
                    src: item.icon
                  }), /*#__PURE__*/_jsx(ParaTag, {
                    color: "white",
                    fontWeight: "black",
                    children: item.label
                  })]
                }), device === "sm" && /*#__PURE__*/_jsx(ChevronContainerIcon, {
                  isInvert: activeIdx !== idx,
                  children: downIcon ? /*#__PURE__*/_jsx(ImageTag, {
                    src: downIcon
                  }) : /*#__PURE__*/_jsx(ChevronUpIcon, {})
                })]
              }), device === "lg" ? /*#__PURE__*/_jsx(InnerLinksContainer, {
                children: item.listPoints.map(function (point) {
                  return /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx(AnchorTag, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      children: point.label
                    })
                  }, point.id);
                })
              }) : activeIdx === idx && /*#__PURE__*/_jsx(InnerLinksContainer, {
                children: item.listPoints.map(function (point) {
                  return /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx(AnchorTag, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      children: point.label
                    })
                  }, point.id);
                })
              })]
            }, item.id);
          })
        })]
      }), /*#__PURE__*/_jsx(FlexComp, {
        flexDirection: device === "sm" ? "column" : undefined,
        justifyContent: "space-between",
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(ParaTag, {
            textAlign: device === "lg" ? "left" : "center",
            color: "white",
            children: ["\xA9 ", new Date().getFullYear(), " ", mmtText]
          }), /*#__PURE__*/_jsxs(ParaTag, {
            textAlign: device === "lg" ? "right" : "center",
            children: [/*#__PURE__*/_jsx(SpanTag, {
              color: "white",
              children: countryText
            }), " ", /*#__PURE__*/_jsx(SpanTag, {
              color: "white",
              fontWeight: "bold",
              children: locationText
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var components_LandingFooter_LandingFooter = ((/* unused pure expression or super */ null && (LandingFooter_LandingFooter)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter2.style.ts

var LandingFooter2_style_LandingFooterStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingFooter2style__LandingFooterStyle",
  componentId: "sc-1fi2m66-0"
})(["background:#000;padding-top:32px;padding-bottom:64px;width:100%;"]);
var LandingFooter2_style_LandingFooterSub = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooter2style__LandingFooterSub",
  componentId: "sc-1fi2m66-1"
})(["display:flex;align-items:center;gap:10px;margin-bottom:14px;", ""], function (p) {
  return p.openedLink && "";
});
var LandingFooter2_style_LandingFooterWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooter2style__LandingFooterWrap",
  componentId: "sc-1fi2m66-2"
})(["margin:0 auto;width:1200px;"]);
var LandingFooter2_style_LandingFooterImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooter2style__LandingFooterImg",
  componentId: "sc-1fi2m66-3"
})(["width:325px;height:27px;margin-bottom:50px;"]);
var LandingFooter2_style_LandingFooterList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingFooter2style__LandingFooterList",
  componentId: "sc-1fi2m66-4"
})(["display:flex;gap:10px;margin-bottom:26px;width:964px;flex-wrap:wrap;margin:", ";li{position:relative;}li:last-child{position:static;}li:after{content:\"\";position:absolute;width:4px;height:4px;border-radius:100%;background:#fff;top:12px;right:-7px;}li:last-child:after{width:0;height:0;}li a{font-weight:400;font-size:12px;line-height:16px;color:#ffffff;}&:last-child{margin-bottom:100px;}", ""], function (props) {
  return props.margin ? props.margin : "";
}, function (props) {
  return props.flexWrap && "\n      height:198px;\n      flex-wrap:wrap;\n  ";
});
var LandingFooter2_style_LandingFooterFlex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooter2style__LandingFooterFlex",
  componentId: "sc-1fi2m66-5"
})(["display:flex;gap:95px;margin-top:100px;"]);
var LandingFooter2_style_LandingFooterCopyRight = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFooter2style__LandingFooterCopyRight",
  componentId: "sc-1fi2m66-6"
})(["display:flex;flex-direction:column;align-items:flex-end;margin-left:auto;align-self:center;span:nth-child(2){font-weight:600;margin-top:3px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/MmtInitiative.png
/* harmony default export */ var icons_MmtInitiative = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/MmtInitiative.3f9ab9c4.png","height":56,"width":652,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAKUlEQVR4nGP8+/WrOBMX16evmzf7/n3w0JovN6f076dPQky8vH8ZgAAAJNgPEW2QH28AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CitiesIcon.svg
/* harmony default export */ var icons_CitiesIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/CitiesIcon.c19a3538.svg","height":19,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/QuickLinks.svg
/* harmony default export */ var icons_QuickLinks = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/QuickLinks.db19e1dd.svg","height":21,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/FollowIcon.svg
/* harmony default export */ var icons_FollowIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/FollowIcon.4a0bda04.svg","height":20,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BlogIcon.svg
/* harmony default export */ var icons_BlogIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/BlogIcon.56d04790.svg","height":21,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/twitterIcon.png
/* harmony default export */ var twitterIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/twitterIcon.c163d894.png","height":53,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAYFBMVEUlJSUFBQUAAAD////7+/vs6+zc3NzZ2dm0s7QAAAD////7+/vn5+fm5ubl5OXQ0NG+vr62tra0tLWwsLCmpqaLiotzc3Q3Nzc1NTUrKiskJCUiIiIbGxsUFBQODg4AAACkAQV1AAAACnRSTlPm5ub+/v7+/v7+oMtKbgAAADxJREFUeNoNwYcBgCAQBMETIy/mHHD771JmlDknl4jtZQrzJV+XTZFXXixmra2IszfrbsQ+hPEgiu8BIj9b4gPJAqifVwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooterInsurance.tsx














var footerLinks = {
  cities: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  blog: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi", "Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi", "Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  quickLinks: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  others: ["About us", "Privacy Policy", "User Agreement", " Terms of Services", " Mail us"]
};

var LandingFooterInsurance_LandingFooter = function LandingFooter(_ref) {
  _objectDestructuringEmpty(_ref);

  var _useState = useState(-1),
      link = _useState[0],
      setLink = _useState[1];

  var handleClick = function handleClick(index) {
    index != index ? setLink(index) : setLink(-1);
  };

  return /*#__PURE__*/_jsx(LandingFooterStyle, {
    children: /*#__PURE__*/_jsx(InnerContentWrap, {
      children: /*#__PURE__*/_jsxs(LandingFooterWrap, {
        children: [/*#__PURE__*/_jsx(LandingFooterImg, {
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: "325px",
            height: "27px",
            src: MmtInitiative.src
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: CitiesIcon.src
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            children: "BUSINESS CITIES"
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          children: footerLinks.cities && footerLinks.cities.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                "aria-label": "cities",
                hrefProp: "#",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: BlogIcon.src
          }), /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            children: [" ", "BLOG"]
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          children: footerLinks.blog && footerLinks.blog.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                "aria-label": "blog",
                hrefProp: "#",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: QuickLinks.src
          }), /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            children: [" ", "QUICK LINKS"]
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          children: footerLinks.quickLinks && footerLinks.quickLinks.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                hrefProp: "#",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/other_Icon_5614215b70.png"
          }), /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            children: [" ", "OTHERS"]
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          children: footerLinks.others && footerLinks.others.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                hrefProp: "#",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterFlex, {
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs(LandingFooterSub, {
              children: [/*#__PURE__*/_jsx(ImageComponent, {
                width: "18px",
                height: "18px",
                src: FollowIcon.src
              }), /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                fontWeight: "bold",
                color: theme.whiteText,
                children: "FOLLOW US"
              })]
            }), /*#__PURE__*/_jsxs(FlexComp, {
              gap: "16px",
              children: [/*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: TwitterIcon.src
                })
              }), /*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png"
                })
              }), /*#__PURE__*/_jsx(AnchorTag, {
                "aria-label": "linkedin",
                hrefProp: "#",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs(LandingFooterSub, {
              children: [/*#__PURE__*/_jsx(ImageComponent, {
                width: "18px",
                height: "18px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/download_Icon_f3c8f1d5d2.png"
              }), /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                fontWeight: "bold",
                color: theme.whiteText,
                children: "DOWNLOAD"
              })]
            }), /*#__PURE__*/_jsxs(FlexComp, {
              gap: "10px",
              children: [/*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "128px",
                  height: "36px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/play_Store_Icon_ddbbe2de64.png"
                })
              }), /*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "128px",
                  height: "36px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/app_Store_Icon_07d258a1b2.png"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs(LandingFooterCopyRight, {
            children: [/*#__PURE__*/_jsxs(SpanTag, {
              fontSize: "xs",
              color: theme.whiteText,
              fontWeight: "bold",
              children: [" ", "\xA9 2022 MAKEMYTRIP PVT.LTD"]
            }), /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: theme.whiteText,
              fontWeight: "bold",
              children: "Country India"
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var LandingFooterInsurance = ((/* unused pure expression or super */ null && (LandingFooterInsurance_LandingFooter)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingCardCompare/LandingCardCompare.style.ts


var LandingCardCompare_style_LandingCrdCompareStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardComparestyle__LandingCrdCompareStyle",
  componentId: "hxj8au-0"
})(["display:flex;flex-direction:column;margin-bottom:90px;position:relative;background-color:", ";padding:100px 0px 120px 0px;"], Global/* theme.whiteText2 */.rS.whiteText2);
var LandingCardCompare_style_LandingCrdCompareTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingCardComparestyle__LandingCrdCompareTitle",
  componentId: "hxj8au-1"
})(["font-family:\"Lato\";font-weight:500;font-size:48px;line-height:64px;text-align:center;color:#000000;margin-bottom:20px;"]);
var LandingCardCompare_style_Flex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardComparestyle__Flex",
  componentId: "hxj8au-2"
})(["display:flex;justify-content:space-between;margin:210px auto 0px;width:1200px;"]);
var LandingCardCompare_style_LandingCrdCompareCrdList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingCardComparestyle__LandingCrdCompareCrdList",
  componentId: "hxj8au-3"
})(["display:flex;gap:16px;li{position:relative;}"]);
var LandingCardCompare_style_CardName = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingCardComparestyle__CardName",
  componentId: "hxj8au-4"
})(["font-family:\"Open Sans Light\",sans-serif;font-style:normal;font-weight:700;font-size:16px;line-height:32px;color:#000000;padding:16px 0;"]);
var LandingCardCompare_style_CardImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardComparestyle__CardImg",
  componentId: "hxj8au-5"
})(["width:288px;height:180px;flex-shrink:0;margin-bottom:10px;top:-195px;position:absolute;"]);
var LandingCardCompare_style_CardFeature = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardComparestyle__CardFeature",
  componentId: "hxj8au-6"
})(["background:#ffffff;border:1px solid #d3d9df;box-shadow:0px 4px 24px rgba(0,0,0,0.1);border-radius:8px;width:288px;display:flex;flex-direction:column;text-align:center;align-items:center;position:relative;padding:00px 16px 20px;", ""], function (props) {
  return props.lastItem && "\nbackground: unset;\nborder: none;\nbox-shadow: unset;\nborder-radius: unset;\n";
});
var LandingCardCompare_style_LabelList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingCardComparestyle__LabelList",
  componentId: "hxj8au-7"
})(["margin-top:66px;font-family:\"Open Sans Light\",sans-serif;font-style:normal;font-weight:400;font-size:18px;line-height:25px;li:nth-child(2n + 1):after{content:\"\";position:absolute;width:1200px;height:100%;background:rgba(0,0,0,0.04);top:0;left:0;z-index:1;}li{border-radius:2px;min-height:80px;display:flex;align-items:center;padding:0 16px;position:relative;color:", ";}li a{font-family:\"Open Sans Light\",sans-serif;font-weight:700;font-size:18px;line-height:20px;color:#008cff;}"], Global/* theme.blackText2 */.rS.blackText2);
var FlexColumn = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardComparestyle__FlexColumn",
  componentId: "hxj8au-8"
})(["display:flex;flex-direction:column;align-items:center;padding:18px 0;"]);
var LandingCardCompare_style_VideoPlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardComparestyle__VideoPlay",
  componentId: "hxj8au-9"
})(["align-self:center;background:#ffffff;border:1px solid #d9d9d9;border-radius:24px;display:flex;gap:8px;align-items:center;font-family:\"Open Sans Light\",sans-serif;font-style:normal;font-weight:600;font-size:16px;line-height:20px;color:#000000;margin-bottom:250px;padding:8px;cursor:pointer;.time{color:#979797;font-weight:400;font-size:14px;line-height:20px;margin-left:4px;}"]);
var LandingCardCompare_style_LabelWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardComparestyle__LabelWrap",
  componentId: "hxj8au-10"
})(["padding:", ";width:100%;display:flex;justify-content:center;min-height:80px;align-items:center;&:nth-child(2n){position:relative;z-index:1;}.subInfo{color:#000;margin-top:12px;opacity:0.7;font-family:\"Open Sans Light\",sans-serif;font-size:14px;line-height:19px;}.infoTitle{color:#000;font-family:\"Open Sans Light\",sans-serif;font-size:16px;line-height:20px;}.infoTitle:first-child{margin-bottom:8px;}", ""], function (props) {
  return props.isBothIconAndText ? "20px 0px;" : "20px 0px;";
}, function (props) {
  return props.flexColumn && "\n            flex-direction: column;\n            align-items: center;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingCardCompare/LandingCardCompare.tsx








var LandingCardCompare = function LandingCardCompare(_ref) {
  var data = _ref.data,
      title = _ref.title,
      playBtnText = _ref.playBtnText,
      _ref$applyBtnHandler = _ref.applyBtnHandler,
      applyBtnHandler = _ref$applyBtnHandler === void 0 ? function () {} : _ref$applyBtnHandler,
      rowLabelsArr = _ref.rowLabelsArr,
      tickIcon = _ref.tickIcon,
      crossIcon = _ref.crossIcon;
  useEffect(function () {
    equalHeights("equalHeight0");
    equalHeights("equalHeight1");
    equalHeights("equalHeight2");
    equalHeights("equalHeight3");
    equalHeights("equalHeight4");
  }, []);

  var equalHeights = function equalHeights(compName) {
    var findClass = document.getElementsByClassName(compName);
    var tallest = 0; // Loop over matching divs

    for (var i = 0; i < findClass.length; i++) {
      var ele = findClass[i];
      var eleHeight = ele.offsetHeight;
      tallest = eleHeight > tallest ? eleHeight : tallest;
    }

    for (var _i = 0; _i < findClass.length; _i++) {
      findClass[_i].style.height = tallest + "px";
    }
  };

  return /*#__PURE__*/_jsxs(LandingCrdCompareStyle, {
    children: [title && /*#__PURE__*/_jsx(LandingCrdCompareTitle, {
      dangerouslySetInnerHTML: {
        __html: insertBrOnNewLine(title)
      }
    }), playBtnText && /*#__PURE__*/_jsxs(VideoPlay, {
      onClick: playBtnText.onClick,
      children: [/*#__PURE__*/_jsx(RoundPlayIcon, {}), playBtnText.normalText, " ", /*#__PURE__*/_jsx("span", {
        className: "time",
        children: playBtnText.durationText
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      children: [rowLabelsArr && /*#__PURE__*/_jsx(LabelList, {
        children: rowLabelsArr.map(function (item, idx) {
          return /*#__PURE__*/_jsx("li", {
            className: "equalHeight".concat(idx),
            children: item
          }, idx);
        })
      }), data && /*#__PURE__*/_jsx(LandingCrdCompareCrdList, {
        children: data.map(function (item, index) {
          return /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx(CardImg, {
              children: item.crdImg && /*#__PURE__*/_jsx(ImageTag, {
                src: item.crdImg,
                alt: "card-img"
              })
            }), /*#__PURE__*/_jsxs(CardFeature, {
              lastItem: index == data.length - 1,
              children: [/*#__PURE__*/_jsx(CardName, {
                children: item.crdName
              }), /*#__PURE__*/_jsxs(LabelWrap, {
                className: "equalHeight0",
                greyBg: true,
                children: [item.onBoarding && (tickIcon ? /*#__PURE__*/_jsx(ImageTag, {
                  src: tickIcon
                }) : /*#__PURE__*/_jsx(RoundTickIcon, {})), !item.onBoarding && (crossIcon ? /*#__PURE__*/_jsx(ImageTag, {
                  src: crossIcon
                }) : /*#__PURE__*/_jsx(RoundCrossIcon, {}))]
              }), item.access && /*#__PURE__*/_jsxs(LabelWrap, {
                flexColumn: true,
                isBothIconAndText: item.access.icon && !!item.access.text,
                className: "equalHeight1",
                children: [item.access.icon ? /*#__PURE__*/_jsx(RoundTickIcon, {}) : /*#__PURE__*/_jsx(RoundCrossIcon, {}), item.access.text && /*#__PURE__*/_jsx("span", {
                  className: "subInfo",
                  children: item.access.text
                })]
              }), /*#__PURE__*/_jsxs(LabelWrap, {
                className: "equalHeight2",
                greyBg: true,
                flexColumn: true,
                children: [/*#__PURE__*/_jsx("span", {
                  className: "infoTitle",
                  children: item.forexRate.rate
                }), /*#__PURE__*/_jsx("span", {
                  className: "subInfo",
                  children: item.forexRate.info
                })]
              }), /*#__PURE__*/_jsx(LabelWrap, {
                className: "equalHeight3",
                children: item.delivery
              }), item.charges && /*#__PURE__*/_jsx(LabelWrap, {
                className: "equalHeight4",
                greyBg: true,
                flexColumn: true,
                children: item.charges && item.charges.map(function (item2, index2) {
                  return /*#__PURE__*/_jsx("span", {
                    className: "infoTitle",
                    children: item2
                  }, index2);
                })
              }), !item.charges && /*#__PURE__*/_jsx("span", {
                children: "--"
              }), item.btn && /*#__PURE__*/_jsx(LandingButton, {
                customWidth: "100%",
                margin: "20px 0 0",
                customTitle: item.btn,
                onClick: function onClick() {
                  return applyBtnHandler(item, index);
                }
              })]
            })]
          }, index);
        })
      })]
    })]
  });
};

/* harmony default export */ var LandingCardCompare_LandingCardCompare = ((/* unused pure expression or super */ null && (LandingCardCompare)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/HappyClientsBanner/HappyClientsBanner.style.ts


var HappyClientsBanner_style_PoweredByContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "HappyClientsBannerstyle__PoweredByContainer",
  componentId: "hp9vx0-0"
})(["border-left:1px #e2e2e2 solid;padding-left:32px;& > ul{display:flex;align-items:center;}& > ul > li{display:flex;align-items:center;}& > ul > li:not(:last-child){margin-right:4px;}@media screen and ", "{height:auto;overflow-y:unset;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/HappyClientsBanner/HappyClientsBanner.tsx







var HappyClientsBanner = function HappyClientsBanner(_ref) {
  var leftText = _ref.leftText,
      rightText = _ref.rightText,
      rightSubText = _ref.rightSubText,
      poweredByLogosArr = _ref.poweredByLogosArr,
      poweredByText = _ref.poweredByText;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(FlexComp, {
    justifyContent: "space-between",
    flexDirection: device === "lg" ? "row" : "column",
    alignItems: device === "lg" ? "center" : "flex-start",
    padding: device === "lg" ? "56px 0px" : "86px 16px 0px",
    children: [leftText && /*#__PURE__*/_jsx(LandingFaqTitle, {
      marginBottom: "0px",
      children: leftText
    }), /*#__PURE__*/_jsxs(FlexComp, {
      margin: device === "lg" ? "0px" : "16px 0px 0px",
      padding: "0px",
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        padding: "0",
        justifyContent: "center",
        flexDirection: "column",
        margin: device === "lg" ? "0px 130px 0px 0px" : "0px 20px 0px 0px",
        children: [device === "lg" ? rightText && /*#__PURE__*/_jsx(H3Tag, {
          children: rightText
        }) : rightText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          fontWeight: "bold",
          children: rightText
        }), rightSubText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: device === "lg" ? "md" : "xs",
          children: rightSubText
        })]
      }), /*#__PURE__*/_jsxs(PoweredByContainer, {
        children: [poweredByText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: device === "lg" ? "md" : "xs",
          children: poweredByText
        }), poweredByLogosArr && /*#__PURE__*/_jsx("ul", {
          children: poweredByLogosArr.map(function (item, idx) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(ImageTag, {
                src: item.logoSrc,
                width: "".concat(device === "lg" ? item.width : item.width * 0.7, "px")
              })
            }, idx);
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var HappyClientsBanner_HappyClientsBanner = ((/* unused pure expression or super */ null && (HappyClientsBanner)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MarqueeBar/Marquee.style.ts



var marqueeScroll = (0,styled_components_browser_esm.keyframes)(["from{transform:translateX(0);}to{transform:translateX(calc(-100% - 20px));}"]);
var Marquee_style_MarqueeBarStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Marqueestyle__MarqueeBarStyle",
  componentId: "macsh4-0"
})(["display:flex;align-items:center;border-radius:4px 0px 0px 4px;", " ", " ", ""], function (props) {
  return props.marqueeBarBgColor && "\n        background-color: ".concat(props.marqueeBarBgColor, ";\n    ");
}, function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.padding && "padding: ".concat(props.padding, ";");
});
var Marquee_style_Tag = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Marqueestyle__Tag",
  componentId: "macsh4-1"
})(["padding:12px 15px;border-radius:4px;position:relative;overflow:hidden;z-index:2;background-color:", ";&:after{content:\"\";position:absolute;width:100px;height:100px;top:-61px;z-index:-1;left:-60px;background-color:", ";transform:rotate(53deg);}"], Global/* theme.redText3 */.rS.redText3, Global/* theme.redText4 */.rS.redText4);
var Marquee_style_MarqueeContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Marqueestyle__MarqueeContainer",
  componentId: "macsh4-2"
})(["gap:20px;position:relative;display:flex;user-select:none;overflow:hidden;width:100%;", " @media screen and ", "{", "}"], function (props) {
  return props.marqueeCtrBgColor && "\n        background-color: ".concat(props.marqueeCtrBgColor, ";\n    ");
}, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.isOnBottom && "padding: 8px;";
});
var Marquee_style_MarqueeRibbon = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "Marqueestyle__MarqueeRibbon",
  componentId: "macsh4-3"
})(["flex-shrink:0;display:flex;justify-content:space-around;gap:20px;min-width:100%;animation:", " 20s linear infinite;& > li{flex:0 0 auto;margin:0px 10px;text-align:center;}", ""], marqueeScroll, function (props) {
  return props.isPaused && "animation-play-state: paused !important;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MarqueeBar/MarqueeBar.tsx








var MarqueeBar = function MarqueeBar(_ref) {
  var leftTagText = _ref.leftTagText,
      marqueeData = _ref.marqueeData,
      margin = _ref.margin,
      padding = _ref.padding,
      _ref$isOnBottom = _ref.isOnBottom,
      isOnBottom = _ref$isOnBottom === void 0 ? false : _ref$isOnBottom,
      marqueeCtrBgColor = _ref.marqueeCtrBgColor,
      _ref$marqueeBarBgColo = _ref.marqueeBarBgColor,
      marqueeBarBgColor = _ref$marqueeBarBgColo === void 0 ? "rgba(74, 74, 74, 0.3)" : _ref$marqueeBarBgColo;

  var _useState = useState(false),
      isPaused = _useState[0],
      setIsPaused = _useState[1];

  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(MarqueeBarStyle, {
    isOnBottom: isOnBottom,
    padding: padding,
    marqueeBarBgColor: marqueeBarBgColor,
    margin: margin,
    onMouseEnter: function onMouseEnter() {
      setIsPaused(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsPaused(false);
    },
    children: [leftTagText && /*#__PURE__*/_jsx(Tag, {
      children: /*#__PURE__*/_jsx(ParaTag, {
        color: "white",
        children: leftTagText
      })
    }), marqueeData && /*#__PURE__*/_jsxs(MarqueeContainer, {
      isOnBottom: isOnBottom,
      marqueeCtrBgColor: marqueeCtrBgColor,
      children: [/*#__PURE__*/_jsx(MarqueeRibbon, {
        isOnBottom: isOnBottom,
        isPaused: isPaused,
        children: marqueeData.map(function (item) {
          return /*#__PURE__*/_jsxs("li", {
            children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
              color: isOnBottom ? theme.blackText : theme.whiteText,
              fontWeight: "bold",
              margin: "0px 4px 0px 0px",
              fontSize: device === "sm" ? "xs" : "md",
              children: item.boldText
            }), item.text && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: device === "sm" ? "xs" : "md",
              color: isOnBottom ? theme.greyText6 : theme.whiteText,
              children: item.text
            }), item.blueText && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: device === "sm" ? "xs" : "md",
              color: theme.blueText,
              fontWeight: "bold",
              children: item.blueText
            })]
          }, item.id);
        })
      }), /*#__PURE__*/_jsx(MarqueeRibbon, {
        isPaused: isPaused,
        "aria-hidden": "true",
        isOnBottom: isOnBottom,
        children: marqueeData.map(function (item) {
          return /*#__PURE__*/_jsxs("li", {
            children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
              color: isOnBottom ? theme.blackText : theme.whiteText,
              margin: "0px 4px 0px 0px",
              fontWeight: "bold",
              fontSize: device === "sm" ? "xs" : "md",
              children: item.boldText
            }), item.text && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: device === "sm" ? "xs" : "md",
              color: isOnBottom ? theme.greyText6 : theme.whiteText,
              children: item.text
            }), item.blueText && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: device === "sm" ? "xs" : "md",
              color: theme.blueText,
              fontWeight: "bold",
              children: item.blueText
            })]
          }, item.id);
        })
      })]
    })]
  });
};

/* harmony default export */ var MarqueeBar_MarqueeBar = ((/* unused pure expression or super */ null && (MarqueeBar)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingCardFeature/LandingCardFeature.style.ts



var LandingCardFeature_style_NotLocationText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__NotLocationText",
  componentId: "xejtpy-0"
})(["border-radius:8px;background-color:", ";padding:8px;margin-top:24px;"], Global/* theme.yellowText2 */.rS.yellowText2);
var LandingCardFeature_style_LandingCardFeatureStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__LandingCardFeatureStyle",
  componentId: "xejtpy-1"
})(["display:flex;position:relative;flex:1;", " ", " flex-direction:column;", " ", " border-radius:4px;"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.padding && "padding: ".concat(props.padding, ";");
}, function (props) {
  return props.border && "border: ".concat(props.border, ";");
}, function (props) {
  return props.borderWidth && "border-width: ".concat(props.borderWidth, ";");
});
var LandingCardFeature_style_LogoContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__LogoContainer",
  componentId: "xejtpy-2"
})(["width:140px;@media screen and ", "{width:60px;}"], utils/* deviceType.mobile */.vO.mobile);
var LandingCardFeature_style_AbsTag = styled_components_browser_esm["default"].p.withConfig({
  displayName: "LandingCardFeaturestyle__AbsTag",
  componentId: "xejtpy-3"
})(["position:absolute;top:16px;right:16px;background-color:", ";padding:4px 12px;border-radius:20px;"], Global/* theme.greenText2 */.rS.greenText2);
var LandingCardFeatureInnerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingCardFeaturestyle__LandingCardFeatureInnerStyle",
  componentId: "xejtpy-4"
})(["display:flex;"]);
var LandingCardFeature_style_PointsContainer = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingCardFeaturestyle__PointsContainer",
  componentId: "xejtpy-5"
})(["margin-top:12px;font-size:14px;line-height:20px;display:flex;flex-wrap:wrap;color:", ";& > li:not(:last-child):after{content:\"\u2022\";color:", ";margin-left:2px;margin-right:2px;}@media screen and ", "{flex-direction:row;margin-bottom:0px;}"], Global/* theme.greyText */.rS.greyText, Global/* theme.greenText */.rS.greenText, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingCardFeature/LandingCardFeature.tsx


function LandingCardFeature_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LandingCardFeature_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LandingCardFeature_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LandingCardFeature_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var LandingCardFeature_LandingCardFeature = function LandingCardFeature(_ref) {
  var _loadCurrency$linkBtn, _loadCurrency$linkBtn2, _loadCurrency$btnOpti, _isUnavailableAtLoc$l;

  var margin = _ref.margin,
      padding = _ref.padding,
      border = _ref.border,
      borderWidth = _ref.borderWidth,
      data = _ref.data,
      idx = _ref.idx,
      loadCurrenyBtnHandler = _ref.loadCurrenyBtnHandler,
      recommendedBtnHandler = _ref.recommendedBtnHandler,
      startFromWhereLeftHandler = _ref.startFromWhereLeftHandler,
      docsPendingHandler = _ref.docsPendingHandler,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  var device = useBreakpoint();
  var logoSrc = data.logoSrc,
      arrowIconSrc = data.arrowIconSrc,
      label = data.label,
      subLabel = data.subLabel,
      featuresArr = data.featuresArr,
      loadCurrency = data.loadCurrency,
      isleftOffBefore = data.isleftOffBefore,
      isRecommended = data.isRecommended,
      logoDesc = data.logoDesc,
      isRecommendNotification = data.isRecommendNotification,
      deliveryLabel = data.deliveryLabel,
      docsPending = data.docsPending,
      isUnavailableAtLoc = data.isUnavailableAtLoc;
  var arrowIcon = arrowIconSrc ? /*#__PURE__*/_jsx(ImageTag, {
    src: arrowIconSrc
  }) : /*#__PURE__*/_jsx(ArrowIcon, {});
  return /*#__PURE__*/_jsxs(LandingCardFeatureStyle, {
    margin: margin,
    border: border,
    padding: padding,
    borderWidth: borderWidth,
    children: [isRecommendNotification && /*#__PURE__*/_jsx(AbsTag, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greenText,
        children: "Recommended"
      })
    }), /*#__PURE__*/_jsxs(FlexComp, {
      flex: "1",
      padding: "0px",
      gap: device === "lg" ? "0px" : "16px",
      flexDirection: device === "lg" ? "column" : "row",
      children: [/*#__PURE__*/_jsxs(LogoContainer, {
        children: [/*#__PURE__*/_jsx(ImageTag, {
          src: logoSrc,
          width: device === "lg" ? "120px" : "100%"
        }), logoDesc && /*#__PURE__*/_jsxs(ParaTag, {
          margin: device === "lg" ? "0px 0px 6px" : "0px",
          fontSize: device === "sm" ? "xxs" : "xs",
          color: theme.greyText,
          children: [logoDesc.normalText, " ", logoDesc.boldText && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: device === "sm" ? "xxs" : "xs",
            fontWeight: "bold",
            color: theme.greyText,
            children: logoDesc.boldText
          })]
        })]
      }), /*#__PURE__*/_jsxs(FlexComp, {
        padding: "0px",
        gap: "0px",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          handleClick: function handleClick() {
            return onClick(data, idx);
          },
          flex: "0",
          gap: "12px",
          justifyContent: device === "sm" ? "space-between" : "flex-start",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(ParaTag, {
            fontSize: "large",
            fontWeight: "bold",
            children: label
          }), !(loadCurrency !== null && loadCurrency !== void 0 && loadCurrency.isLoaded) && loadCurrency !== null && loadCurrency !== void 0 && loadCurrency.toAdd ? device === "lg" && arrowIcon : arrowIcon]
        }), !!subLabel && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "sm",
          children: subLabel
        }), featuresArr && /*#__PURE__*/_jsx(PointsContainer, {
          children: featuresArr.map(function (item) {
            return /*#__PURE__*/_jsx("li", {
              children: item.label
            }, item.id);
          })
        }), loadCurrency && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs(FlexComp, {
            margin: device === "lg" ? "12px 0px 0px" : "4px 0px 0px",
            flexDirection: "column",
            children: [!!loadCurrency.label && loadCurrency.isLoaded ? /*#__PURE__*/_jsxs(FlexComp, {
              gap: "4px",
              alignItems: "center",
              children: [/*#__PURE__*/_jsx(ParaTag, {
                fontSize: "xs",
                fontWeight: "bold",
                children: loadCurrency.label
              }), loadCurrency.isLoadedIcon ? /*#__PURE__*/_jsx(ImageTag, {
                src: loadCurrency.isLoadedIcon
              }) : /*#__PURE__*/_jsx(RoundTickIcon, {
                size: 12
              })]
            }) : /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "xs",
              fontWeight: "bold",
              children: loadCurrency.label
            }), !!loadCurrency.subLabel && /*#__PURE__*/_jsxs(ParaTag, {
              fontSize: "xs",
              color: theme.greyText,
              margin: "2px 0px 12px",
              children: [loadCurrency.subLabel, " ", !!loadCurrency.addText && /*#__PURE__*/_jsx(AnchorTag, {
                fontSize: "xs",
                fontWeight: "extraBold",
                children: loadCurrency.addText
              })]
            }), !!loadCurrency.linkBtnInMobile && /*#__PURE__*/_jsx(AnchorTag, {
              fontSize: "xs",
              fontWeight: "extraBold",
              margin: "auto 0px 0px",
              handleClick: loadCurrenyBtnHandler ? function () {
                return loadCurrenyBtnHandler(data);
              } : function () {},
              hrefProp: (_loadCurrency$linkBtn = loadCurrency.linkBtnInMobile) === null || _loadCurrency$linkBtn === void 0 ? void 0 : _loadCurrency$linkBtn.hrefProp,
              children: loadCurrency === null || loadCurrency === void 0 ? void 0 : (_loadCurrency$linkBtn2 = loadCurrency.linkBtnInMobile) === null || _loadCurrency$linkBtn2 === void 0 ? void 0 : _loadCurrency$linkBtn2.label
            })]
          })
        }), !!deliveryLabel && device === "sm" && /*#__PURE__*/_jsxs(FlexComp, {
          margin: "4px 0px 0px",
          alignItems: "center",
          padding: "0px",
          gap: "4px",
          children: [/*#__PURE__*/_jsx(LocationIcon, {}), /*#__PURE__*/_jsx(SpanTag, {
            color: theme.greenText,
            fontSize: "xs",
            fontWeight: "bold",
            children: deliveryLabel
          })]
        })]
      })]
    }), isleftOffBefore && /*#__PURE__*/_jsx(PersuasionTile, {
      margin: "24px 0px 0px",
      text: isleftOffBefore.text,
      bgColor: theme.yellowText2,
      linkBtn: LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({}, isleftOffBefore === null || isleftOffBefore === void 0 ? void 0 : isleftOffBefore.linkBtn), {}, {
        onClick: startFromWhereLeftHandler ? function () {
          return startFromWhereLeftHandler(data);
        } : function () {}
      }),
      leftIcon: isleftOffBefore.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
        src: isleftOffBefore.iconSrc
      }) : /*#__PURE__*/_jsx(RoundEcllipseIcon, {})
    }), isRecommended && /*#__PURE__*/_jsx(PersuasionTile, {
      margin: "24px 0px 0px",
      text: isRecommended.text,
      bgColor: theme.greenText2,
      linkBtn: LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({}, isRecommended === null || isRecommended === void 0 ? void 0 : isRecommended.linkBtn), {}, {
        onClick: recommendedBtnHandler ? function () {
          return recommendedBtnHandler(data);
        } : function () {}
      })
    }), loadCurrency && loadCurrency.btnOptions && device === "sm" ? /*#__PURE__*/_jsx(LandingButton, LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({}, loadCurrency.btnOptions), {}, {
      onClick: loadCurrenyBtnHandler ? function () {
        return loadCurrenyBtnHandler(data);
      } : function () {},
      fontSize: "12px",
      margin: "25px 0px 0px",
      customHeight: "32px",
      customWidth: "100%"
    })) : /*#__PURE__*/_jsx(AnchorTag, {
      fontSize: "xs",
      fontWeight: "extraBold" // margin="12px 0px 0px"
      ,
      handleClick: loadCurrenyBtnHandler ? function () {
        return loadCurrenyBtnHandler(data);
      } : function () {},
      children: loadCurrency === null || loadCurrency === void 0 ? void 0 : (_loadCurrency$btnOpti = loadCurrency.btnOptions) === null || _loadCurrency$btnOpti === void 0 ? void 0 : _loadCurrency$btnOpti.customTitle
    }), isUnavailableAtLoc &&
    /*#__PURE__*/
    // <PersuasionTile
    //     margin="24px 0px 0px"
    //     bgColor={theme.yellowText2}
    //     normalTextColor={theme.brownText}
    //     text={isUnavailableAtLoc.text}
    // />
    _jsx(NotLocationText, {
      children: isUnavailableAtLoc.normalText && /*#__PURE__*/_jsxs(ParaTag, {
        fontSize: "xs",
        color: theme.brownText,
        children: [isUnavailableAtLoc.normalText, " ", isUnavailableAtLoc.linkText && /*#__PURE__*/_jsx(AnchorTag, {
          fontSize: "xs",
          fontWeight: "bold",
          hrefProp: isUnavailableAtLoc.linkText.hrefLink,
          children: (_isUnavailableAtLoc$l = isUnavailableAtLoc.linkText) === null || _isUnavailableAtLoc$l === void 0 ? void 0 : _isUnavailableAtLoc$l.text
        })]
      })
    }), docsPending && /*#__PURE__*/_jsxs(FlexComp, {
      padding: "12px",
      borderRadius: "8px",
      margin: "24px 0px 0px",
      flexDirection: "column",
      bgColor: "linear-gradient(159.48deg, #FFF9ED 4.69%, rgba(255, 239, 236, 0.736176) 27.76%, #F8F9E7 92.13%)",
      children: [(docsPending.label || docsPending.iconSrc) && /*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        padding: "0px",
        margin: "0px 0px 16px",
        justifyContent: "space-between",
        children: [docsPending.label && /*#__PURE__*/_jsx(ParaTag, {
          fontWeight: "bold",
          color: theme.brownText,
          margin: "0px 20px 0px 0px",
          children: docsPending.label
        }), docsPending.iconSrc ? /*#__PURE__*/_jsx(ImageTag, {
          src: docsPending.iconSrc
        }) : /*#__PURE__*/_jsx(DocsUploadIcon, {})]
      }), docsPending.btnProps && /*#__PURE__*/_jsx(LandingButton, LandingCardFeature_objectSpread(LandingCardFeature_objectSpread({}, docsPending.btnProps), {}, {
        onClick: docsPendingHandler ? function () {
          return docsPendingHandler(data);
        } : function () {},
        customWidth: "100%"
      }))]
    })]
  });
};

/* harmony default export */ var components_LandingCardFeature_LandingCardFeature = ((/* unused pure expression or super */ null && (LandingCardFeature_LandingCardFeature)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ChooseLocationIcon/ChooseLocation.style.ts



var ChooseLocation_style_ChooseLocationStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ChooseLocationstyle__ChooseLocationStyle",
  componentId: "sc-1vckob3-0"
})(["display:flex;flex-direction:column;"]);
var ChooseLocation_style_ChooseLocationInrStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ChooseLocationstyle__ChooseLocationInrStyle",
  componentId: "sc-1vckob3-1"
})(["padding:0px 24px 0px 24px;min-height:400px;@media screen and ", "{min-height:unset;max-height:60vh;overflow-y:auto;}"], utils/* deviceType.mobile */.vO.mobile);
var ChooseLocation_style_ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ChooseLocationstyle__ButtonContainer",
  componentId: "sc-1vckob3-2"
})(["padding:16px;display:flex;@media screen and ", "{box-shadow:0px -1px 8px rgba(0,0,0,0.25);}"], utils/* deviceType.mobile */.vO.mobile);
var ChooseLocation_style_StepCounter = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ChooseLocationstyle__StepCounter",
  componentId: "sc-1vckob3-3"
})(["display:flex;gap:2px;& > li{width:35px;height:4px;border-radius:4px;background:#e2e2e2;}& > li.activeBar{background:", ";}"], Global/* theme.blueText */.rS.blueText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/SelectCountry/SelectCountry.style.ts
//import { symbol } from 'prop-types';



var SelectCountry_style_SelectCountryStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountrystyle__SelectCountryStyle",
  componentId: "sc-1wl8rlh-0"
})(["background:#fff;"]);
var SelectCountry_style_Scroller = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountrystyle__Scroller",
  componentId: "sc-1wl8rlh-1"
})(["overflow-y:scroll;height:379px;padding-bottom:50px;@media ", "{height:calc(100vh - 70px);}"], utils/* deviceType.mobile */.vO.mobile);
var SelectCountry_style_SelectCountryHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountrystyle__SelectCountryHeader",
  componentId: "sc-1wl8rlh-2"
})(["height:70px;display:flex;flex-direction:column;"]);
var SelectCountry_style_CountryList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "SelectCountrystyle__CountryList",
  componentId: "sc-1wl8rlh-3"
})(["li{display:flex;cursor:pointer;padding:16px 0px;border-bottom:1px solid #eee;}li .highlight{background-color:", ";}li:last-child{border-bottom:unset;}"], Global/* theme.yellowText3 */.rS.yellowText3);
var SelectCountry_style_FixedBtn = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountrystyle__FixedBtn",
  componentId: "sc-1wl8rlh-4"
})(["padding:16px;position:fixed;bottom:0;left:0;width:100%;"]);
var SelectCountrySearch = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountrystyle__SelectCountrySearch",
  componentId: "sc-1wl8rlh-5"
})(["padding:16px;width:100%;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/SelectCountry/SelectCountry.tsx


function SelectCountry_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountry_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountry_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var SelectCountry_SelectCountry = function SelectCountry(_ref) {
  var countryData = _ref.countryData,
      selectCountryInput = _ref.selectCountryInput,
      isFetchingRate = _ref.isFetchingRate,
      btnProps = _ref.btnProps,
      _ref$currencyItemHand = _ref.currencyItemHandler,
      currencyItemHandler = _ref$currencyItemHand === void 0 ? function () {} : _ref$currencyItemHand,
      _ref$showRadioButton = _ref.showRadioButton,
      showRadioButton = _ref$showRadioButton === void 0 ? false : _ref$showRadioButton;

  var searchQueryHighlighter = function searchQueryHighlighter(ele, nameToSearch) {
    var withSpecialCharsSupport = selectCountryInput === null || selectCountryInput === void 0 ? void 0 : selectCountryInput.inputValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele[nameToSearch].replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/_jsx(ParaTag, {
      dangerousText: highlighted,
      fontWeight: ele.isChecked ? "bold" : "regular",
      margin: nameToSearch === "leftLabel" ? "0px 8px 0px 0px" : "0px"
    });
  };

  var spinnerLoader = isFetchingRate ? /*#__PURE__*/_jsx(Spinner, {
    spinnerWidth: 20
  }) : /*#__PURE__*/_jsx(Fragment, {});
  return /*#__PURE__*/_jsxs(SelectCountryStyle, {
    children: [/*#__PURE__*/_jsx(SelectCountryHeader, {
      children: /*#__PURE__*/_jsx(TMFloatingInput // margin="7px 8px 0px"
      , {
        labelTxt: selectCountryInput === null || selectCountryInput === void 0 ? void 0 : selectCountryInput.labelTxt,
        inputValue: selectCountryInput === null || selectCountryInput === void 0 ? void 0 : selectCountryInput.inputValue,
        disableState: selectCountryInput === null || selectCountryInput === void 0 ? void 0 : selectCountryInput.disableState,
        handleChange: selectCountryInput === null || selectCountryInput === void 0 ? void 0 : selectCountryInput.handleChange
      })
    }), countryData && /*#__PURE__*/_jsx(Scroller, {
      children: countryData.map(function (item) {
        return item.currencyList.length > 0 && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            padding: "12px 0px",
            bgColor: "#fff",
            borderBottom: "1px solid #e8e8e8",
            justifyContent: "space-between",
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(SpanTag // color={theme.greyText6}
            , {
              fontSize: "xs",
              fontWeight: "bold",
              children: item.leftLabel
            }), /*#__PURE__*/_jsx(SpanTag // color={theme.greyText6}
            , {
              fontSize: "xs",
              fontWeight: "bold",
              children: item.rightLabel
            })]
          }), /*#__PURE__*/_jsx(CountryList, {
            children: item.currencyList.map(function (ele, index) {
              return /*#__PURE__*/_jsxs("li", {
                onClick: function onClick() {
                  return currencyItemHandler(ele, item.id, index);
                },
                children: [showRadioButton ? /*#__PURE__*/_jsx(RadioButton, {
                  inputId: "".concat(index),
                  activeBtn: ele.isChecked,
                  inputIndex: index,
                  showLabel: false
                }) : /*#__PURE__*/_jsx(CheckButton, {
                  margin: "2px 0px 0px",
                  inputId: index,
                  isChecked: ele.isChecked
                }), /*#__PURE__*/_jsxs(FlexComp, {
                  flex: "1",
                  isCursorPointer: true,
                  justifyContent: "space-between",
                  children: [ele.leftSubLabel ? /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsxs(FlexComp, {
                      alignItems: "center",
                      isCursorPointer: true,
                      children: [searchQueryHighlighter(ele, "leftLabel"), ele.isChecked && spinnerLoader]
                    }), /*#__PURE__*/_jsx(ParaTag, {
                      fontSize: "xs",
                      color: ele.leftSubLabel.type === "SUCCESS" ? theme.greenText4 : theme.redText,
                      children: ele.leftSubLabel.value
                    })]
                  }) : /*#__PURE__*/_jsxs(FlexComp, {
                    isCursorPointer: true,
                    alignItems: "center",
                    children: [searchQueryHighlighter(ele, "leftLabel"), ele.isChecked && spinnerLoader]
                  }), /*#__PURE__*/_jsx(SpanTag, {
                    color: theme.greyText,
                    fontSize: "xs",
                    fontWeight: ele.isChecked ? "bold" : "regular",
                    children: searchQueryHighlighter(ele, "rightLabel")
                  })]
                })]
              }, ele.id);
            })
          })]
        }, item.id);
      })
    }), btnProps && btnProps.customTitle && /*#__PURE__*/_jsx(FixedBtn, {
      children: /*#__PURE__*/_jsx(FlexComp, {
        padding: "0px 16px 16px",
        children: /*#__PURE__*/_jsx(LandingButton, SelectCountry_objectSpread({
          customWidth: "100%",
          margin: "auto 0px 0px"
        }, btnProps))
      })
    })]
  });
};

/* harmony default export */ var ModalComponents_SelectCountry_SelectCountry = ((/* unused pure expression or super */ null && (SelectCountry_SelectCountry)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ChooseLocationIcon/ChooseLocation.tsx


function ChooseLocation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChooseLocation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChooseLocation_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChooseLocation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // Country Selection Modal





var ChooseLocation = function ChooseLocation(_ref) {
  var _ref$onModalClose = _ref.onModalClose,
      onModalClose = _ref$onModalClose === void 0 ? function () {} : _ref$onModalClose,
      _ref$activeScreen = _ref.activeScreen,
      activeScreen = _ref$activeScreen === void 0 ? 0 : _ref$activeScreen,
      screensComponents = _ref.screensComponents,
      selectCountryData = _ref.selectCountryData,
      isSelectCountryModalOpen = _ref.isSelectCountryModalOpen;
  var device = useBreakpoint();

  var stepCounterRenderer = function stepCounterRenderer() {
    return screensComponents ? /*#__PURE__*/_jsx(StepCounter, {
      children: screensComponents.map(function (_, idx) {
        return /*#__PURE__*/_jsx("li", {
          className: idx <= activeScreen ? "activeBar" : ""
        }, idx);
      })
    }) : /*#__PURE__*/_jsx(Fragment, {});
  };

  return !isSelectCountryModalOpen ? /*#__PURE__*/_jsx(Modal, {
    padding: "0px",
    modalWidth: 480,
    closeButton: /*#__PURE__*/_jsx(CloseIcon, {}),
    onModalClose: onModalClose,
    modalHeadingComp: stepCounterRenderer(),
    modalHeadingCtrMargin: "24px 24px 32px 24px",
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: /*#__PURE__*/_jsxs(ChooseLocationStyle, {
      children: [screensComponents && screensComponents[activeScreen] && /*#__PURE__*/_jsx(ChooseLocationInrStyle, {
        children: screensComponents[activeScreen].component
      }), screensComponents && (screensComponents[activeScreen].previousBtnProps || screensComponents[activeScreen].nextBtnProps) && /*#__PURE__*/_jsx(ButtonContainer, {
        children: activeScreen !== 0 ? /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(LandingButtonWhite, ChooseLocation_objectSpread(ChooseLocation_objectSpread({}, screensComponents[activeScreen].previousBtnProps), {}, {
            padding: "0px 24px",
            customWidth: "100%",
            margin: "0px 16px 0px 0px"
          })), /*#__PURE__*/_jsx(LandingButton, ChooseLocation_objectSpread(ChooseLocation_objectSpread({}, screensComponents[activeScreen].nextBtnProps), {}, {
            padding: "0px 24px",
            customWidth: "100%"
          }))]
        }) : /*#__PURE__*/_jsx(LandingButton, ChooseLocation_objectSpread(ChooseLocation_objectSpread({}, screensComponents[activeScreen].nextBtnProps), {}, {
          padding: "0px 24px",
          customWidth: "100%"
        }))
      })]
    })
  }) : selectCountryData ? /*#__PURE__*/_jsx(Modal // padding="0px"
  , {
    modalWidth: 480,
    closeButton: /*#__PURE__*/_jsx(CloseIcon, {}),
    onModalClose: onModalClose,
    showBackBtn: true,
    backBtn: device === "sm" && /*#__PURE__*/_jsx(CrossIcon, {}),
    modalHeading: selectCountryData.title,
    modalSubHeading: selectCountryData.subTitle,
    modalHeadingCtrMargin: "0px 0px 20px",
    modalType: device === "lg" ? "centered" : "fullPage",
    children: /*#__PURE__*/_jsx(SelectCountry, {
      countryData: selectCountryData.selectCountryModalData,
      currencyItemHandler: selectCountryData.currencyItemHandler,
      isFetchingRate: selectCountryData.isFetchingRate,
      setIsFetchingRate: selectCountryData.setIsFetchingRate,
      selectCountryInput: {
        labelTxt: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.inputLabelTxt,
        placeholderTxt: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.inputPlaceholderTxt,
        inputValue: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.inputValue,
        disableState: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.inputDisableState,
        handleChange: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.inputHandleChange
      },
      selectCountryLabel: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.selectCountryLabel,
      currencyLabel: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.currencyLabel,
      btnProps: selectCountryData === null || selectCountryData === void 0 ? void 0 : selectCountryData.btnProps
    })
  }) : /*#__PURE__*/_jsx(Fragment, {});
};

/* harmony default export */ var ChooseLocationIcon_ChooseLocation = ((/* unused pure expression or super */ null && (ChooseLocation)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.style.ts

var CheckButton_style_CheckButtonStyle = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CheckButtonstyle__CheckButtonStyle",
  componentId: "sc-1v2zgji-0"
})(["display:flex;align-items:baseline;cursor:pointer;", " label{margin-left:10px;flex:1;width:100%;cursor:pointer;user-select:none;}}", " input[type=\"checkbox\"]{", " visibility:hidden;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;}@supports (-moz-appearance:none){input[type=\"checkbox\"]{visibility:visible;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;width:18px;height:18px;accent-color:#008CFF;}}input[type='checkbox']::before{width:20px;height:20px;display:flex;visibility:visible;flex-shrink:0;border:1px solid #4a4a4a;border-radius:4px;background:#fff;position:absolute;top:0px;left:-2px;content:'';}input[type='checkbox']::after{content:'';display:block;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);position:absolute;visibility:visible;top:2px;left:5px;z-index:1;}input[type='checkbox']:checked::before{", " border:unset;}"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.travellingTo && "\n label{\n  position:absolute;\n  left:8px;\n  bottom:8px;\n }\n";
}, function (props) {
  return !props.isDisabled && "cursor: pointer;";
}, function (props) {
  return props.isDisabled ? "background: #0000004D;" : "background: #008cff;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.tsx





var CheckButton_CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      inputId = _ref.inputId,
      travellingTo = _ref.travellingTo,
      handleChange = _ref.handleChange,
      inputIndex = _ref.inputIndex,
      isDisabled = _ref.isDisabled,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      margin = _ref.margin;
  return /*#__PURE__*/_jsxs(CheckButtonStyle, {
    margin: margin,
    travellingTo: travellingTo,
    isDisabled: isDisabled,
    children: [/*#__PURE__*/_jsx("input", {
      onChange: handleChange,
      type: "checkbox",
      id: inputId,
      checked: isChecked
    }), /*#__PURE__*/_jsx("label", {
      htmlFor: inputId,
      id: inputId,
      children: children
    })]
  });
};

/* harmony default export */ var components_CheckButton_CheckButton = ((/* unused pure expression or super */ null && (CheckButton_CheckButton)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.style.ts



var LandingInput_style_InputWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingInputstyle__InputWrap",
  componentId: "sc-1tw2ggf-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;width:100%;label{font-weight:700;font-size:14px;line-height:16px;color:#4a4a4a;display:block;margin-bottom:8px;transition:all 0.3s ease;display:inline-block;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inputWidth;
}, function (p) {
  return p.flex ? p.flex : "";
});
var LandingInput_style_ErrorTxt = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "LandingInputstyle__ErrorTxt",
  componentId: "sc-1tw2ggf-1"
})(["color:#eb2026;"]);
var LandingInput_style_LandingInputStyle = styled_components_browser_esm["default"].input.withConfig({
  displayName: "LandingInputstyle__LandingInputStyle",
  componentId: "sc-1tw2ggf-2"
})(["background:#ffffff;border:1px solid #d2d2d2;border-radius:4px;padding:10px;font-weight:900;font-size:14px;line-height:19px;width:100%;height:41px;&::placeholder{font-weight:400 !important;color:rgba(0,0,0,0.3) !important;}&:focus + label{color:#008cff;}", " ", " @media ", "{width:calc(100vw - 32px);}", " &:focus{outline:none;border:1px solid #008cff;background:#f9fcff;}&[type=\"number\"]::-webkit-outer-spin-button,&[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type=\"number\"]{-moz-appearance:textfield;}"], function (props) {
  return props.disableState && "\n      opacity: 0.3;\n      pointer-events: none;\n\t";
}, function (props) {
  return props.errorState && "\n      border: 1px solid #EB2026;\n\t";
}, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.Verify && "\n      color: #008CFF;\n      background: #F9FCFF;\n      border: 1px solid #008CFF;\n      pointer-events: none;\n\t";
});
var LandingInput_style_CalenderWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingInputstyle__CalenderWrap",
  componentId: "sc-1tw2ggf-3"
})(["cursor:pointer;position:absolute;right:16px;top:36px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.tsx







var LandingInput_LandingInput = function LandingInput(_ref) {
  var placeholderTxt = _ref.placeholderTxt,
      labelTxt = _ref.labelTxt,
      disableState = _ref.disableState,
      inputWidth = _ref.inputWidth,
      margin = _ref.margin,
      errorState = _ref.errorState,
      inputValue = _ref.inputValue,
      handleChange = _ref.handleChange,
      Verify = _ref.Verify,
      flex = _ref.flex,
      requiredField = _ref.requiredField,
      handleKeyDown = _ref.handleKeyDown,
      maxInputLength = _ref.maxInputLength,
      inputType = _ref.inputType,
      handleFocus = _ref.handleFocus,
      handleBlur = _ref.handleBlur,
      maxValue = _ref.maxValue,
      minValue = _ref.minValue,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? "on" : _ref$autoComplete,
      calender = _ref.calender,
      handleOpenCalender = _ref.handleOpenCalender,
      autofocus = _ref.autofocus,
      isDisabled = _ref.isDisabled;

  var handleMouseWheel = function handleMouseWheel(event) {
    event.preventDefault();
  };

  return /*#__PURE__*/_jsxs(InputWrap, {
    margin: margin,
    flex: flex,
    inputWidth: inputWidth,
    Verify: Verify,
    children: [labelTxt && /*#__PURE__*/_jsxs("label", {
      htmlFor: labelTxt,
      children: [labelTxt, requiredField && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        color: theme.redText2,
        children: "*"
      })]
    }), /*#__PURE__*/_jsx(LandingInputStyle, {
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      value: inputValue,
      errorState: errorState,
      id: labelTxt,
      disableState: disableState,
      placeholder: placeholderTxt,
      maxLength: maxInputLength,
      type: inputType,
      min: minValue,
      max: maxValue,
      onWheel: handleMouseWheel,
      autoComplete: autoComplete,
      autoFocus: autofocus,
      inputWidth: inputWidth,
      disabled: isDisabled
    }), errorState && /*#__PURE__*/_jsx(ErrorTxt, {
      txtfontSize: "xs",
      margin: "4px 0 0",
      txtcolor: theme.redText,
      txtfontWeight: "bold",
      children: errorState
    }), calender && /*#__PURE__*/_jsx(CalenderWrap, {
      onClick: handleOpenCalender,
      children: /*#__PURE__*/_jsx(ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Calendar_b8e9e22a64.svg"
      })
    })]
  });
};

/* harmony default export */ var components_LandingInput_LandingInput = ((/* unused pure expression or super */ null && (LandingInput_LandingInput)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BulletListItem/BulletListItem.tsx




var BulletListItem_BulletListItem = function BulletListItem(_ref) {
  var children = _ref.children,
      _ref$bulletColor = _ref.bulletColor,
      bulletColor = _ref$bulletColor === void 0 ? theme.darkYellowText : _ref$bulletColor;
  return /*#__PURE__*/_jsx(BulletListItemStyle, {
    bulletColor: bulletColor,
    children: children
  });
};

/* harmony default export */ var components_BulletListItem_BulletListItem = ((/* unused pure expression or super */ null && (BulletListItem_BulletListItem)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ForexOfferingCard/ForexOfferingCard.style.ts

var ForexOfferingCard_style_ForexOfferingsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexOfferingCardstyle__ForexOfferingsStyle",
  componentId: "sc-1afq4ny-0"
})(["width:285px;flex-shrink:0;background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:8px;margin:3px;margin:", ";"], function (p) {
  return p.margin ? p.margin : "";
});
var ForexOfferingCard_style_ForexOfferingCntnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexOfferingCardstyle__ForexOfferingCntnt",
  componentId: "sc-1afq4ny-1"
})(["padding:18px;"]);
var ForexOfferingList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ForexOfferingCardstyle__ForexOfferingList",
  componentId: "sc-1afq4ny-2"
})(["display:flex;flex-direction:column;gap:4px;margin-bottom:18px;li{position:relative;padding-left:18px;}li:before{content:\"\";position:absolute;background:#008cff;width:5px;height:14px;top:8px;left:0;border-radius:4px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ForexOfferingCard/ForexOfferingCard.tsx







var ForexOfferings = function ForexOfferings(_ref) {
  var data = _ref.data,
      margin = _ref.margin;
  return /*#__PURE__*/_jsxs(ForexOfferingsStyle, {
    margin: margin,
    children: [/*#__PURE__*/_jsx(ImageTag, {
      src: data.cardImg
    }), /*#__PURE__*/_jsxs(ForexOfferingCntnt, {
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "large",
        fontWeight: "bold",
        children: data.cardTitle
      }), /*#__PURE__*/_jsx(SpanTag, {
        margin: "0 0 48px",
        fontSize: "md",
        children: data.cardInfo
      }), /*#__PURE__*/_jsx("ul", {
        children: data.cardFeatList.map(function (item) {
          return /*#__PURE__*/_jsxs(BulletListItem, {
            bulletColor: theme.blueText,
            children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
              fontWeight: "bold",
              children: item.boldText
            }), " ", item.normalText]
          }, item.id);
        })
      }), /*#__PURE__*/_jsx(FlexComp, {
        margin: "22px 0px 0px",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(AnchorTag, {
          fontSize: "sm",
          fontWeight: "bold",
          textAlign: "center",
          hrefProp: data.ctaLink,
          children: data.ctaTxt
        })
      })]
    })]
  });
};

/* harmony default export */ var ForexOfferingCard_ForexOfferingCard = ((/* unused pure expression or super */ null && (ForexOfferings)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingOfferingContainer/LandingOfferingContainer.style.ts

var LandingOfferingContainer_style_LandingOfferingContainerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingOfferingContainerstyle__LandingOfferingContainerStyle",
  componentId: "sc-8ax21h-0"
})(["margin-top:86px;"]);
var LandingOfferingContainer_style_ForexOfferingWpr = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingOfferingContainerstyle__ForexOfferingWpr",
  componentId: "sc-8ax21h-1"
})(["", " width:100%;padding-top:4px;padding-left:16px;padding-right:16px;padding-bottom:6px;margin-bottom:40px;display:flex;overflow-x:scroll;"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingOfferingContainer/LandingOfferingContainer.tsx






var LandingOfferingContainer = function LandingOfferingContainer(_ref) {
  var heading = _ref.heading,
      data = _ref.data;
  return /*#__PURE__*/_jsxs(LandingOfferingContainerStyle, {
    children: [heading && /*#__PURE__*/_jsx(LandingFaqTitle, {
      marginLeft: "16px",
      children: heading
    }), /*#__PURE__*/_jsx(ForexOfferingWpr, {
      margin: "24px 0px 0px 0px",
      children: data.map(function (item, idx) {
        return /*#__PURE__*/_jsx(ForexOfferingCard, {
          data: item,
          margin: idx + 1 < data.length ? "0px 18px 0px 0px" : "0px"
        }, item.id);
      })
    })]
  });
};

/* harmony default export */ var LandingOfferingContainer_LandingOfferingContainer = ((/* unused pure expression or super */ null && (LandingOfferingContainer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingCardFeature/PersuasionTile.style.ts



var PersuasionTile_style_PersuasionTileStyles = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PersuasionTilestyle__PersuasionTileStyles",
  componentId: "kz7m8b-0"
})(["background:", ";border-radius:4px;display:flex;justify-content:space-between;align-items:center;padding:8px 12px 8px 8px;", ""], function (props) {
  return props.bgColor;
}, function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
});
var LabelTag = styled_components_browser_esm["default"].p.withConfig({
  displayName: "PersuasionTilestyle__LabelTag",
  componentId: "kz7m8b-1"
})(["font-size:12px;line-height:18px;margin-left:4px;color:", ";.blackBoldText{font-weight:700;}.greenBoldText{font-weight:700;color:", ";}@media screen and ", "{margin-left:0px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.greenText */.rS.greenText, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingCardFeature/PersuasionTile.tsx








var PersuasionTile_PersuasionTile = function PersuasionTile(_ref) {
  var bgColor = _ref.bgColor,
      leftIcon = _ref.leftIcon,
      text = _ref.text,
      margin = _ref.margin,
      _ref$normalTextColor = _ref.normalTextColor,
      normalTextColor = _ref$normalTextColor === void 0 ? "black" : _ref$normalTextColor,
      linkBtn = _ref.linkBtn;
  var device = useBreakpoint();

  var paraTagRenderer = function paraTagRenderer() {
    return /*#__PURE__*/_jsxs(ParaTag, {
      fontSize: "xs",
      children: [text && text.blackBoldText && /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: theme.blackText,
        children: text.blackBoldText
      }), " ", text && text.greenBoldText && /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greenText,
        fontSize: "xs",
        fontWeight: "bold",
        children: text.greenBoldText
      }), " ", text && /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        color: normalTextColor,
        children: text.normalText
      }), " "]
    });
  };

  return /*#__PURE__*/_jsx(PersuasionTileStyles, {
    margin: margin,
    bgColor: bgColor,
    children: device === "lg" ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        gap: "4px",
        alignItems: "center",
        flex: "1",
        padding: "0",
        children: [leftIcon && leftIcon, paraTagRenderer()]
      }), linkBtn && /*#__PURE__*/_jsx(AnchorTag, {
        margin: "0px 0px 0px 8px",
        fontSize: "xs",
        fontWeight: "bold",
        handleClick: linkBtn.onClick,
        children: linkBtn.label
      })]
    }) : /*#__PURE__*/_jsxs(FlexComp, {
      gap: "12px",
      flex: "1",
      alignItems: "center",
      padding: "0",
      children: [leftIcon && leftIcon, /*#__PURE__*/_jsxs(FlexComp, {
        gap: "0px",
        flexDirection: "column",
        flex: "1",
        padding: "0",
        children: [paraTagRenderer(), linkBtn && /*#__PURE__*/_jsx(AnchorTag, {
          handleClick: linkBtn.onClick,
          fontSize: "xs",
          fontWeight: "bold",
          children: linkBtn.label
        })]
      })]
    })
  });
};

/* harmony default export */ var LandingCardFeature_PersuasionTile = ((/* unused pure expression or super */ null && (PersuasionTile_PersuasionTile)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/IconTextTag/IconTextTag.style.ts

var IconTextTag_style_IconTextTagStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "IconTextTagstyle__IconTextTagStyle",
  componentId: "gaac7i-0"
})(["cursor:pointer;display:flex;padding:12px 16px;", " background:linear-gradient( 147.2deg,#fff6d8 4.79%,#fffaf3 43.98%,#f3f0e6 120.5% );justify-content:space-between;"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/IconTextTag/IconTextTag.tsx








var IconTextTag_IconTextTag = function IconTextTag(_ref) {
  var label = _ref.label,
      subLabel = _ref.subLabel,
      icon = _ref.icon,
      margin = _ref.margin,
      onClick = _ref.onClick;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(IconTextTagStyle, {
    onClick: onClick,
    margin: margin,
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: device === "lg" ? "row" : "column",
      gap: "4px",
      isCursorPointer: true,
      padding: "0px",
      children: [/*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.blackText,
        children: label
      }), subLabel && /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        color: theme.greyText,
        children: subLabel
      })]
    }), icon ? /*#__PURE__*/_jsx(ImageTag, {
      src: icon,
      showCursorPointer: true
    }) : /*#__PURE__*/_jsx(ArrowIcon, {})]
  });
};

/* harmony default export */ var components_IconTextTag_IconTextTag = ((/* unused pure expression or super */ null && (IconTextTag_IconTextTag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Header/Header.styles.ts


var Header_styles_HeaderCont = styled_components_browser_esm["default"].header.withConfig({
  displayName: "Headerstyles__HeaderCont",
  componentId: "znfanl-0"
})(["background-color:", ";position:sticky;top:0;z-index:10;box-shadow:", ";"], function (props) {
  return props.bgColor;
}, function (props) {
  return props.showShadow ? "0px 1px 7px rgba(0, 0, 0, 0.21)" : "unset";
});
var Header_styles_HeaderInner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Headerstyles__HeaderInner",
  componentId: "znfanl-1"
})(["width:1200px;padding:", ";margin:0 auto;display:flex;align-items:center;justify-content:space-between;@media ", "{width:100%;}"], function (props) {
  return props.headerType === "mobile" ? "16px" : "20px 0";
}, utils/* deviceType.mobile */.vO.mobile);
var Header_styles_HeaderLft = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Headerstyles__HeaderLft",
  componentId: "znfanl-2"
})(["flex:1;display:flex;align-items:center;"]);
var Header_styles_HeaderRht = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Headerstyles__HeaderRht",
  componentId: "znfanl-3"
})(["display:flex;align-items:center;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/UserInfo/UserInfo.styles.ts

var UserInfo_styles_UserCont = styled_components_browser_esm["default"].div.withConfig({
  displayName: "UserInfostyles__UserCont",
  componentId: "uwvcbl-0"
})(["display:inline-flex;align-items:center;position:relative;padding-right:30px;cursor:pointer;::after{display:inline-flex;border:solid white;border-width:0 2px 2px 0;padding:3px;content:\"\";transform:rotate(45deg);position:absolute;right:0;top:6px;}"]);
var UserInfo_styles_UserIcon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "UserInfostyles__UserIcon",
  componentId: "uwvcbl-1"
})(["width:21px;height:21px;background:linear-gradient(222.16deg,#ff684a 5.2%,#ff4959 96.35%);border-radius:50%;flex-shrink:0;margin-right:10px;display:flex;align-items:center;justify-content:center;font-size:10px;line-height:12px;font-weight:900;color:#fff;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/UserInfo/UserInfo.tsx






var UserInfo_UserInfo = function UserInfo(_ref) {
  var userName = _ref.userName,
      _ref$greetingText = _ref.greetingText,
      greetingText = _ref$greetingText === void 0 ? "Hey" : _ref$greetingText,
      onPress = _ref.onPress;
  return /*#__PURE__*/_jsxs(UserCont, {
    onClick: onPress,
    children: [/*#__PURE__*/_jsx(UserIcon, {
      children: userName.split("")[0]
    }), /*#__PURE__*/_jsxs(ParaTag, {
      color: "#fff",
      fontSize: "xs",
      children: [greetingText, " ", userName]
    })]
  });
};

/* harmony default export */ var components_UserInfo_UserInfo = ((/* unused pure expression or super */ null && (UserInfo_UserInfo)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Header/Header.tsx






var Header_Header = function Header(_ref) {
  var logo = _ref.logo,
      userName = _ref.userName,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "#000" : _ref$bgColor,
      titleText = _ref.titleText,
      backArrow = _ref.backArrow,
      headerType = _ref.headerType,
      children = _ref.children,
      userInfoHandler = _ref.userInfoHandler,
      greetingText = _ref.greetingText,
      _ref$showShadow = _ref.showShadow,
      showShadow = _ref$showShadow === void 0 ? false : _ref$showShadow,
      backBtnHandler = _ref.backBtnHandler,
      headerWprId = _ref.headerWprId,
      backBtnId = _ref.backBtnId;
  return /*#__PURE__*/_jsxs(HeaderCont, {
    id: headerWprId,
    bgColor: bgColor,
    showShadow: showShadow,
    children: [/*#__PURE__*/_jsxs(HeaderInner, {
      headerType: headerType,
      children: [/*#__PURE__*/_jsxs(HeaderLft, {
        children: [backArrow && /*#__PURE__*/_jsx("span", {
          id: backBtnId,
          onClick: backBtnHandler,
          children: backArrow
        }), logo && logo, titleText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          color: "#4a4a4a",
          fontWeight: "bold",
          margin: "0 0 0 15px",
          children: titleText
        })]
      }), userName && /*#__PURE__*/_jsx(HeaderRht, {
        children: /*#__PURE__*/_jsx(UserInfo, {
          userName: userName,
          onPress: userInfoHandler,
          greetingText: greetingText
        })
      })]
    }), children]
  });
};

/* harmony default export */ var components_Header_Header = ((/* unused pure expression or super */ null && (Header_Header)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ProductDescription/ProductDescription.style.ts


var ProductDescription_style_ProductDescriptionStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductDescriptionstyle__ProductDescriptionStyle",
  componentId: "sc-1b5lwnl-0"
})(["background:", ";padding:26px 16px 16px;@media screen and ", "{padding:28px 30px 46px;}"], function (props) {
  return "url(".concat(props.bgImg, ");");
}, utils/* deviceType.mobile */.vO.mobile);
var ProductDescription_style_CloseIconCtr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductDescriptionstyle__CloseIconCtr",
  componentId: "sc-1b5lwnl-1"
})(["text-align:right;text-align:-webkit-right;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ProductDescription/ProductDescription.tsx


function ProductDescription_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductDescription_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductDescription_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductDescription_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var ProductDescription = function ProductDescription(_ref) {
  var _ref$onModalClose = _ref.onModalClose,
      onModalClose = _ref$onModalClose === void 0 ? function () {} : _ref$onModalClose,
      label = _ref.label,
      subLabel = _ref.subLabel,
      bgImg = _ref.bgImg,
      solidBtn = _ref.solidBtn;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    padding: "0px",
    onModalClose: onModalClose,
    modalWidth: 480 // closeButton={<CloseIcon />}
    ,
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: /*#__PURE__*/_jsxs(ProductDescriptionStyle, {
      bgImg: bgImg,
      children: [device === "lg" && /*#__PURE__*/_jsx(CloseIconCtr, {
        children: /*#__PURE__*/_jsx(CloseIcon, {
          onPress: onModalClose
        })
      }), label && /*#__PURE__*/_jsx(ParaTag, {
        margin: "0px 0px 30px",
        fontSize: "xxlarge",
        fontWeight: "bold",
        children: label
      }), subLabel && /*#__PURE__*/_jsx(ParaTag, {
        margin: "0px 0px 70px",
        color: theme.greyText,
        children: subLabel
      }), solidBtn && /*#__PURE__*/_jsx(LandingButton, ProductDescription_objectSpread(ProductDescription_objectSpread({}, solidBtn), {}, {
        padding: "0px 24px",
        customWidth: "100%"
      }))]
    })
  });
};

/* harmony default export */ var ProductDescription_ProductDescription = ((/* unused pure expression or super */ null && (ProductDescription)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ChooseLocationIcon/ModalScreens/ModalScreen.style.ts



var ModalScreen_style_ModalContentEqualizer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ModalScreenstyle__ModalContentEqualizer",
  componentId: "ovz29s-0"
})(["min-height:300px;"]);
var ModalScreen_style_CountriesContainer = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ModalScreenstyle__CountriesContainer",
  componentId: "ovz29s-1"
})(["display:grid;gap:8px;margin-bottom:24px;grid-template-columns:repeat(3,1fr);& > li:last-child{cursor:pointer;display:flex;justify-content:center;align-items:center;background:none;box-shadow:0px 2px 7px rgba(0,0,0,0.24);& > div{display:flex;justify-content:center;align-items:center;flex-direction:column;}}& > li > span:nth-child(2){position:absolute;left:8px;bottom:8px;}"]);
var ModalScreen_style_CountryLiPoint = styled_components_browser_esm["default"].li.withConfig({
  displayName: "ModalScreenstyle__CountryLiPoint",
  componentId: "ovz29s-2"
})(["height:130px;cursor:pointer;position:relative;flex:0 0 32%;border-radius:6px;box-shadow:0px 2px 7px rgba(0,0,0,0.24);background:linear-gradient( 180deg,rgba(106,106,106,0) -2.78%,rgba(0,0,0,0.7) 95.83% );background-image:", ";background-size:100% 100%;"], function (props) {
  return "url(".concat(props.bgImage, ")");
});
var ModalScreen_style_OptionsContainer = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ModalScreenstyle__OptionsContainer",
  componentId: "ovz29s-3"
})(["display:grid;gap:12px;font-size:12px;line-height:16px;font-weight:700;margin-bottom:24px;grid-template-columns:repeat(2,1fr);& > li{display:flex;gap:8px;cursor:pointer;padding:20px 12px;border-radius:6px;align-items:center;justify-content:center;border:1px solid #e8e8e8;@media ", "{padding:8px 12px;}}& > li.active{border:1px solid ", ";}", ""], utils/* deviceType.mobile */.vO.mobile, Global/* theme.blueText */.rS.blueText, function (props) {
  return !props.isLastChildNormal && "\n        & > li:last-child {\n            grid-column: span 2;\n        }\n    ";
});
var ModalScreen_style_InfoText = styled_components_browser_esm["default"].p.withConfig({
  displayName: "ModalScreenstyle__InfoText",
  componentId: "ovz29s-4"
})(["padding:8px 16px;font-size:14px;line-height:20px;margin-bottom:32px;background:", ";border-radius:8px;"], Global/* theme.yellowText2 */.rS.yellowText2);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ChooseLocationIcon/ModalScreens/CountriesScreen.tsx









var CountriesScreen = function CountriesScreen(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      countriesData = _ref.countriesData,
      countriesDataItemHandler = _ref.countriesDataItemHandler,
      lastLiHandler = _ref.lastLiHandler,
      countrySearchText = _ref.countrySearchText,
      searchIcon = _ref.searchIcon;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [title && /*#__PURE__*/_jsx(H5Tag, {
      margin: "0px 0px 12px 0px",
      children: title
    }), subTitle && /*#__PURE__*/_jsx(ParaTag, {
      color: "gray",
      margin: "0px 0px 8px 0px",
      fontSize: "xs",
      children: subTitle
    }), countriesData && /*#__PURE__*/_jsx(ModalContentEqualizer, {
      children: /*#__PURE__*/_jsxs(CountriesContainer, {
        children: [countriesData.map(function (item, idx) {
          return /*#__PURE__*/_jsxs(CountryLiPoint, {
            bgImage: item.logoSrc,
            onClick: function onClick() {
              return countriesDataItemHandler(item, idx);
            },
            children: [/*#__PURE__*/_jsx(CheckButton, {
              margin: "8px 0px 0px 8px",
              isChecked: item.isSelected
            }), /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: "white",
              fontWeight: "bold",
              children: item.label
            })]
          }, item.id);
        }), /*#__PURE__*/_jsx(CountryLiPoint, {
          onClick: lastLiHandler,
          children: /*#__PURE__*/_jsxs("div", {
            children: [searchIcon ? /*#__PURE__*/_jsx(ImageComponent, {
              src: searchIcon
            }) : /*#__PURE__*/_jsx(RoundSearchIcon, {}), countrySearchText && /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "xs",
              color: theme.blueText,
              fontWeight: "bold",
              textAlign: "center",
              margin: "4px 0px 0px 0px",
              dangerousText: insertBrOnNewLine(countrySearchText)
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var ModalScreens_CountriesScreen = ((/* unused pure expression or super */ null && (CountriesScreen)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ChooseLocationIcon/ModalScreens/DaysScreen.tsx






var DaysScreen = function DaysScreen(_ref) {
  var optionsData = _ref.optionsData,
      title = _ref.title,
      _ref$itemClickCallbac = _ref.itemClickCallback,
      itemClickCallback = _ref$itemClickCallbac === void 0 ? function () {} : _ref$itemClickCallbac;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [title && /*#__PURE__*/_jsx(H5Tag, {
      margin: "0px 0px 24px 0px",
      children: title
    }), optionsData && /*#__PURE__*/_jsx(ModalContentEqualizer, {
      children: /*#__PURE__*/_jsx(OptionsContainer, {
        children: optionsData.map(function (item, idx) {
          return /*#__PURE__*/_jsx("li", {
            onClick: function onClick() {
              return itemClickCallback(item, idx);
            },
            className: item.isSelected ? "active" : "",
            children: item.label
          }, item.id);
        })
      })
    })]
  });
};

/* harmony default export */ var ModalScreens_DaysScreen = ((/* unused pure expression or super */ null && (DaysScreen)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ChooseLocationIcon/ModalScreens/PurposeScreen.tsx






var PurposesScreen = function PurposesScreen(_ref) {
  var purposesData = _ref.purposesData,
      title = _ref.title,
      infoBarData = _ref.infoBarData,
      _ref$itemClickCallbac = _ref.itemClickCallback,
      itemClickCallback = _ref$itemClickCallbac === void 0 ? function () {} : _ref$itemClickCallbac;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [title && /*#__PURE__*/_jsx(H5Tag, {
      margin: "0px 0px 24px 0px",
      children: title
    }), purposesData && /*#__PURE__*/_jsxs(ModalContentEqualizer, {
      children: [/*#__PURE__*/_jsx(OptionsContainer, {
        isLastChildNormal: true,
        children: purposesData.map(function (item, idx) {
          return /*#__PURE__*/_jsxs("li", {
            onClick: function onClick() {
              return itemClickCallback(item, idx);
            },
            className: item.isSelected ? "active" : "",
            children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/_jsx(ImageTag, {
              src: item.icon
            }), /*#__PURE__*/_jsx(SpanTag, {
              margin: "0px",
              fontSize: "xs",
              color: "gray",
              children: item.label
            })]
          }, item.id);
        })
      }), infoBarData && /*#__PURE__*/_jsx(InfoText, {
        children: infoBarData
      })]
    })]
  });
};

/* harmony default export */ var PurposeScreen = ((/* unused pure expression or super */ null && (PurposesScreen)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ChooseLocationIcon/ModalScreens/DeliveryScreen.tsx


function DeliveryScreen_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DeliveryScreen_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeliveryScreen_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeliveryScreen_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ScreenFour = function ScreenFour(_ref) {
  var title = _ref.title,
      pinCodeDetails = _ref.pinCodeDetails;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [title && /*#__PURE__*/_jsx(H5Tag, {
      margin: "0px 0px 24px 0px",
      children: title
    }), pinCodeDetails && /*#__PURE__*/_jsx(ModalContentEqualizer, {
      children: /*#__PURE__*/_jsx(TMFloatingInput, DeliveryScreen_objectSpread({}, pinCodeDetails))
    })]
  });
};

/* harmony default export */ var DeliveryScreen = ((/* unused pure expression or super */ null && (ScreenFour)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/CardCongrats/CardCongrats.style.ts


 // ANIMATIONS
// Scale confetti from 0.5x to 1x

var confettiScale = (0,styled_components_browser_esm.keyframes)(["0%{transform:scale(0.5);}100%{transform:scale(1);}"]); // Hide confetti

var hideConfetti = (0,styled_components_browser_esm.keyframes)(["0%{opacity:1;}100%{opacity:0;}"]); // Move up the rest of the container

var moveUpCtr = (0,styled_components_browser_esm.keyframes)(["0%{transform:translateY(0px);}100%{transform:translateY(-120px);}"]); // The main card transform

var envelopeCardAnim = (0,styled_components_browser_esm.keyframes)(["0%{transform:scale(1);}100%{border-radius:10px;transform:scale(1.2);border:0.5px solid rgba(255,255,255,0.4);}"]); // envelope animation

var moveCardToBottom = (0,styled_components_browser_esm.keyframes)(["100%{top:340px;height:0px;}"]); // show bottom info animation

var showBottomInfo = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0;};100%{opacity:1;};"]);
var cardUp = (0,styled_components_browser_esm.keyframes)(["0%{padding-top:30px;}100%{padding-top:0px;}"]); // COMPONENTS

var CardCongrats_style_CardCongratsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__CardCongratsStyle",
  componentId: "ryi4st-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:500px;background:linear-gradient(0deg,#454545 0%,rgba(0,0,0,1) 30%);@media ", "{height:100%;}"], utils/* deviceType.mobile */.vO.mobile);
var CardCongrats_style_CardInnerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__CardInnerStyle",
  componentId: "ryi4st-1"
})(["padding-top:30px;text-align:center;animation-fill-mode:forwards;"]);
var CardCongrats_style_Confetti = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__Confetti",
  componentId: "ryi4st-2"
})(["width:170px;margin:0px auto;animation:", " 0.7s ease-in,", " 0.5s linear 0.7s;animation-fill-mode:forwards;"], confettiScale, hideConfetti);
var CardCongrats_style_MoveUpContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__MoveUpContainer",
  componentId: "ryi4st-3"
})(["animation:", " 0.8s ease-in 1.2s;animation-fill-mode:forwards;"], moveUpCtr);
var CardCongrats_style_FeaturesCtr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__FeaturesCtr",
  componentId: "ryi4st-4"
})([""]);
var CardCongrats_style_PointTag = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CardCongratsstyle__PointTag",
  componentId: "ryi4st-5"
})(["color:", ";margin:0px 4px;"], Global/* theme.greenText */.rS.greenText);
var CardCongrats_style_EnvelopeCtr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__EnvelopeCtr",
  componentId: "ryi4st-6"
})(["margin:30px auto 75px;width:196px;position:relative;z-index:1;transition:0.1s all;.envFront{position:absolute;left:-1px;top:13px;z-index:3;animation:", " 1s ease-in 1.2s;animation-fill-mode:forwards;}.envBack{position:absolute;left:0;top:0;z-index:1;animation:", " 1s ease-in 1.2s;animation-fill-mode:forwards;}.envCard{position:absolute;z-index:2;animation-iteration-count:1;animation-fill-mode:both;top:6px;left:0px;animation:", " 3s ease 1.2s;animation-fill-mode:forwards;filter:drop-shadow(0px 3px 24px #121512);}"], moveCardToBottom, moveCardToBottom, envelopeCardAnim);
var CardCongrats_style_BulletListContainer = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "CardCongratsstyle__BulletListContainer",
  componentId: "ryi4st-7"
})(["list-style-type:none;text-align:left;& > li:not(:last-child){margin-bottom:4px;}"]);
var CardCongrats_style_CardInfoContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__CardInfoContainer",
  componentId: "ryi4st-8"
})(["margin-top:210px;max-width:370px;opacity:0;animation:", " 1s ease-in 2s;animation-fill-mode:forwards;"], showBottomInfo);
var CardCongrats_style_ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CardCongratsstyle__ButtonContainer",
  componentId: "ryi4st-9"
})(["position:absolute;text-align:center;bottom:0px;left:50%;transform:translateX(-50%);width:300px;bottom:16px;opacity:", ";", " @media ", "{width:calc(100% - 32px);}"], function (props) {
  return props.withAnimation ? 0 : 1;
}, function (props) {
  return props.withAnimation && (0,styled_components_browser_esm.css)(["animation:", " 1s ease-in 2s;animation-fill-mode:forwards;"], showBottomInfo);
}, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/CardCongrats/CardCongrats.tsx


function CardCongrats_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardCongrats_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardCongrats_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardCongrats_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var CardCongrats = function CardCongrats(_ref) {
  var _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$onModalClose = _ref.onModalClose,
      onModalClose = _ref$onModalClose === void 0 ? function () {} : _ref$onModalClose,
      loadingText = _ref.loadingText,
      preferenceText = _ref.preferenceText,
      globalCardText = _ref.globalCardText,
      linkBtn = _ref.linkBtn,
      solidBtn = _ref.solidBtn,
      featuresTextData = _ref.featuresTextData,
      confettiImgURI = _ref.confettiImgURI,
      envelopeImgData = _ref.envelopeImgData,
      newCardFeaturesModalData = _ref.newCardFeaturesModalData;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    padding: "0px",
    modalWidth: 480,
    onModalClose: onModalClose,
    modalType: device === "lg" ? "centered" : "fullPage",
    children: /*#__PURE__*/_jsx(CardCongratsStyle, {
      children: isLoading ? /*#__PURE__*/_jsx(ParaTag, {
        color: "white",
        children: loadingText
      }) : /*#__PURE__*/_jsxs(CardInnerStyle, {
        children: [confettiImgURI && /*#__PURE__*/_jsx(Confetti, {
          children: /*#__PURE__*/_jsx("img", {
            src: confettiImgURI
          })
        }), /*#__PURE__*/_jsxs(MoveUpContainer, {
          children: [preferenceText && /*#__PURE__*/_jsx(ParaTag, {
            margin: "0px 0px 6px 0px",
            fontSize: "xs",
            color: "gray",
            children: preferenceText
          }), globalCardText && /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "md",
            fontWeight: "bold",
            color: "white",
            margin: "0px 0px 5px 0px",
            children: globalCardText
          }), featuresTextData && /*#__PURE__*/_jsxs(FeaturesCtr, {
            children: [/*#__PURE__*/_jsx(ParaTag, {
              color: "white",
              children: featuresTextData.slice(0, -1).map(function (item, idx) {
                return /*#__PURE__*/_jsxs(Fragment, {
                  children: [/*#__PURE__*/_jsx(SpanTag, {
                    color: "white",
                    children: item
                  }), idx + 1 < featuresTextData.length - 1 && /*#__PURE__*/_jsx(PointTag, {
                    children: "\xB7"
                  })]
                }, idx);
              })
            }), /*#__PURE__*/_jsxs(ParaTag, {
              color: "white",
              children: [/*#__PURE__*/_jsx(PointTag, {
                children: "\xB7"
              }), featuresTextData.slice(-1)[0], /*#__PURE__*/_jsx(PointTag, {
                children: "\xB7"
              })]
            })]
          }), envelopeImgData && /*#__PURE__*/_jsx(EnvelopeCtr, {
            children: envelopeImgData.map(function (item, idx) {
              return /*#__PURE__*/_jsx("img", {
                src: item.src,
                alt: item.altTag,
                className: item.className
              }, idx);
            })
          }), newCardFeaturesModalData && /*#__PURE__*/_jsx(CardInfoContainer, {
            children: /*#__PURE__*/_jsx(BulletListContainer, {
              children: newCardFeaturesModalData.map(function (item) {
                return /*#__PURE__*/_jsxs(BulletListItem, {
                  bulletColor: theme.blueText,
                  children: [item.boldText && /*#__PURE__*/_jsx(SpanTag, {
                    color: "white",
                    fontWeight: "bold",
                    children: item.boldText
                  }), " ", item.normalText]
                }, item.id);
              })
            })
          })]
        }), (solidBtn || linkBtn) && /*#__PURE__*/_jsxs(ButtonContainer, {
          withAnimation: true,
          children: [linkBtn && /*#__PURE__*/_jsx(AnchorTag, {
            fontWeight: "bold",
            margin: "0px 0px 18px 0px",
            handleClick: linkBtn.handleClick,
            hrefProp: linkBtn.hrefValue,
            children: linkBtn.title
          }), /*#__PURE__*/_jsx(LandingButtonWhite, CardCongrats_objectSpread({
            customWidth: "100%"
          }, solidBtn))]
        })]
      })
    })
  });
};

/* harmony default export */ var CardCongrats_CardCongrats = ((/* unused pure expression or super */ null && (CardCongrats)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimYourInsurance.style.ts




var ClaimYourInsurance_style_ClaimYourInsuranceStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimYourInsuranceStyle",
  componentId: "uew8se-0"
})(["background:#f6f6f6;width:100%;padding:100px 0;@media ", "{padding:48px 16px;", "{> ", "{overflow-y:auto;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;-webkit-overflow-scrolling:touch;}}}"], utils/* deviceType.mobile */.vO.mobile, CommonStyles_style_InnerContentWrap, FlexCompStyle);
var ClaimYourInsurance_style_ClaimStructureStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimStructureStyle",
  componentId: "uew8se-1"
})(["background:#ffffff;border-radius:18.9111px;padding:30px 20px;display:flex;flex-direction:column;gap:16px;width:226px;position:relative;flex-shrink:0;> img{flex-shrink:0;position:absolute;right:-34%;top:40%;}@media ", "{padding:16px;width:180px;> img{right:-21%;}}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RichText/RichText.tsx





var RichText_RichText = function RichText(_ref) {
  var value = _ref.value;

  if (typeof value === "string") {
    return /*#__PURE__*/_jsx(MarkdownText, {
      value: value
    });
  }

  return /*#__PURE__*/_jsx(FormattedText, {
    value: value
  });
};

/* harmony default export */ var components_RichText_RichText = ((/* unused pure expression or super */ null && (RichText_RichText)));
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/constants/index.ts + 1 modules
var static_constants = __webpack_require__(6533);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimStructure.tsx











var ClaimStructure_ClaimStructure = function ClaimStructure(_ref) {
  var claimIndex = _ref.claimIndex,
      claimInfo = _ref.claimInfo,
      showSpiral = _ref.showSpiral;
  var device = useBreakpointV2();
  var context = usePartnerContext();
  return /*#__PURE__*/_jsxs(ClaimStructureStyle, {
    children: [context === PARTNER.MMT ? /*#__PURE__*/_jsx(H2Tag, {
      color: theme.prussianBlue,
      children: claimIndex
    }) : /*#__PURE__*/_jsx(H3Tag, {
      color: theme.prussianBlue,
      children: claimIndex
    }), /*#__PURE__*/_jsxs(SpanTag, {
      children: [" ", /*#__PURE__*/_jsx(RichText, {
        value: claimInfo
      })]
    }), !showSpiral && /*#__PURE__*/_jsx(ImageComponent, {
      width: device == "lg" ? "57px" : "24px",
      height: device == "lg" ? "57px" : "24px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/grey_Spiral_de40650b4c.svg"
    })]
  });
};

/* harmony default export */ var ClaimYourInsurance_ClaimStructure = ((/* unused pure expression or super */ null && (ClaimStructure_ClaimStructure)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimYourInsurance.tsx












var ClaimYourInsurance = function ClaimYourInsurance(_ref) {
  var data = _ref.data,
      title = _ref.title,
      info = _ref.info;
  var device = useBreakpointV2();
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(ClaimYourInsuranceStyle, {
    children: /*#__PURE__*/_jsxs(InnerContentWrap, {
      children: [device == "lg" ? /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(H2Tag, {
          children: title && /*#__PURE__*/_jsx(FormattedText, {
            value: title
          })
        }), /*#__PURE__*/_jsx(H2Tag, {
          color: theme.greenText,
          margin: "0 0 86px",
          children: info && /*#__PURE__*/_jsx(FormattedText, {
            value: info
          })
        })]
      }) : /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(H5Tag, {
          children: title && /*#__PURE__*/_jsx(FormattedText, {
            value: title
          })
        }), /*#__PURE__*/_jsx(H5Tag, {
          color: theme.greenText5,
          margin: "0 0 20px",
          children: info && /*#__PURE__*/_jsx(FormattedText, {
            value: info
          })
        })]
      }), /*#__PURE__*/_jsx(FlexComp, {
        gap: device == "lg" ? "100px" : "48px",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: /*#__PURE__*/_jsx(ClaimStructure, {
              claimInfo: item.claimInfo,
              claimIndex: item.claimIndex,
              showSpiral: index == data.length - 1
            }, index)
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var ClaimYourInsurance_ClaimYourInsurance = ((/* unused pure expression or super */ null && (ClaimYourInsurance)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuyTravIns/WhyBuyTravIns.style.ts




var WhyBuyTravIns_style_WhyBuyTravInsStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyTravInsStyle",
  componentId: "sc-1sprh6s-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}@media ", "{padding:0 16px;", "}"], function (p) {
  return p.pageTheme === partner_PARTNER.GI && "\n    background: #EFF3F8;\n    padding-bottom:80px;\n    ";
}, TextStyles_style_H2TagStyle, utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.pageTheme === partner_PARTNER.GI && "\n    background: #fff;\n    padding-top:16px;\n    ";
});
var WhyBuyTravIns_style_WhyFeatListWrap = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyFeatListWrap",
  componentId: "sc-1sprh6s-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:16px;flex-shrink:0;@media ", "{width:100%;grid-template-columns:repeat(1,1fr);}img{margin-top:4px;}"], utils/* deviceType.mobile */.vO.mobile);
var WhyBuyTravIns_style_WhyBuyItem = styled_components_browser_esm["default"].li.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyItem",
  componentId: "sc-1sprh6s-2"
})(["display:flex;gap:8px;padding:16px;background:#ffffff;border:1px solid #ececec;box-shadow:0px 3px 12px rgba(0,0,0,0.2);border-radius:10px;width:300px;flex-shrink:0;font-size:18px;line-height:25px;svg{flex-shrink:0;}@media ", "{width:100%;box-shadow:none;}"], utils/* deviceType.mobile */.vO.mobile);
var WhyBuyTravIns_style_ShieldWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WhyBuyTravInsstyle__ShieldWrap",
  componentId: "sc-1sprh6s-3"
})(["position:absolute;right:-60px;z-index:-1;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuyTravIns/WhyBuyTravIns.tsx











var WhyBuyTravIns = function WhyBuyTravIns(_ref) {
  var title = _ref.title,
      info = _ref.info,
      data = _ref.data;
  var device = useBreakpointV2();
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(WhyBuyTravInsStyle, {
    pageTheme: context ? context : undefined,
    children: /*#__PURE__*/_jsx(InnerContentWrap, {
      children: /*#__PURE__*/_jsxs(FlexComp // flexWrap="wrap"
      , {
        flexDirection: device == "lg" ? "row" : "column",
        alignItems: "center",
        gap: device == "lg" ? "74px" : "24px",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [device == "lg" ? /*#__PURE__*/_jsx(H2Tag, {
            margin: "0 0 60px",
            children: title && /*#__PURE__*/_jsx(FormattedText, {
              value: title
            })
          }) : /*#__PURE__*/_jsxs(H5Tag, {
            margin: "0 0 20px",
            children: [" ", title && /*#__PURE__*/_jsx(FormattedText, {
              value: title
            })]
          }), /*#__PURE__*/_jsx(ParaTag, {
            fontSize: device == "lg" ? "large" : "sm",
            color: theme.greyText,
            children: info && /*#__PURE__*/_jsx(FormattedText, {
              value: info
            })
          })]
        }), /*#__PURE__*/_jsx(WhyFeatListWrap, {
          children: data && data.map(function (item, index) {
            return /*#__PURE__*/_jsxs(WhyBuyItem, {
              children: [item.icon && /*#__PURE__*/_jsx(ImageComponent, {
                src: item.icon,
                height: "24",
                width: "24"
              }), /*#__PURE__*/_jsx(SpanTag, {
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: item === null || item === void 0 ? void 0 : item.info
                })
              })]
            }, index);
          })
        }), device == "lg" && /*#__PURE__*/_jsx(ShieldWrap, {
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: "286px",
            height: "320px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var WhyBuyTravIns_WhyBuyTravIns = ((/* unused pure expression or super */ null && (WhyBuyTravIns)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTrav.style.ts



var SafenSecureTrav_style_SafenSecureTravStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravStyle",
  componentId: "e1cu42-0"
})(["width:100%;background:#fff;position:relative;z-index:1;overflow:hidden;", "{width:64%;}@media ", "{padding:0 16px;}"], TextStyles_style_H2TagStyle, utils/* deviceType.mobile */.vO.mobile);
var SafenSecureTrav_style_SafenSecureTravCrdStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravCrdStyle",
  componentId: "e1cu42-1"
})(["background:linear-gradient( 128.03deg,rgba(227,247,245,0.36) 2.1%,rgba(230,237,255,0.441706) 49.06%,rgba(214,232,244,0.6) 80.75% ),#fcffff;border-radius:14px;padding:24px;flex:1;position:relative;display:flex;flex-direction:column;gap:24px;> img{position:absolute;right:30px;bottom:24px;}@media ", "{gap:12px;}"], utils/* deviceType.mobile */.vO.mobile);
var SafenSecureTrav_style_FeatList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "SafenSecureTravstyle__FeatList",
  componentId: "e1cu42-2"
})(["display:flex;flex-direction:column;gap:16px;max-width:80%;li{position:relative;padding-left:14px;}li:after{content:\"\";position:absolute;background:#000000;border-radius:2px;width:4px;height:14px;top:6px;left:0;}@media ", "{margin-bottom:12px;}"], utils/* deviceType.mobile */.vO.mobile);
var SafenSecureTrav_style_SafenSecureBgWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureBgWrap",
  componentId: "e1cu42-3"
})(["position:absolute;top:17px;right:-122px;width:100%;z-index:-1;height:558px;img{width:100%;height:558px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTravCrd.tsx








var SafenSecureTravCrd_SafenSecureTravCrd = function SafenSecureTravCrd(_ref) {
  var title = _ref.title,
      featList = _ref.featList,
      cardImg = _ref.cardImg,
      poweredBy = _ref.poweredBy;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(SafenSecureTravCrdStyle, {
    children: [device == "lg" ? /*#__PURE__*/_jsx(H5Tag, {
      children: title && /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }) : /*#__PURE__*/_jsx(ParaTag, {
      fontWeight: "black",
      fontSize: "large",
      margin: device == "sm" ? "" : "0 0 12px",
      children: title && /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }), /*#__PURE__*/_jsx(FeatList, {
      children: featList && (featList === null || featList === void 0 ? void 0 : featList.map(function (item, index) {
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: item
          })
        }, index);
      }))
    }), poweredBy && /*#__PURE__*/_jsxs(FlexComp, {
      margin: "auto 0 0",
      gap: "20px",
      alignItems: "Center",
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        children: "Powered By"
      }), poweredBy && poweredBy.map(function (item, index) {
        return /*#__PURE__*/_jsx(ImageComponent, {
          src: item,
          width: "32px",
          height: "22px"
        }, index);
      })]
    }), cardImg && /*#__PURE__*/_jsx(ImageComponent, {
      width: device == "lg" ? "92px" : "54px",
      height: device == "lg" ? "102px" : "60px",
      src: cardImg
    })]
  });
};

/* harmony default export */ var SafenSecureTrav_SafenSecureTravCrd = ((/* unused pure expression or super */ null && (SafenSecureTravCrd_SafenSecureTravCrd)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTrav.tsx


function SafenSecureTrav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SafenSecureTrav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SafenSecureTrav_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SafenSecureTrav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var SafenSecureTrav = function SafenSecureTrav(_ref) {
  var title = _ref.title,
      data = _ref.data;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(SafenSecureTravStyle, {
    children: [/*#__PURE__*/_jsx(SafenSecureBgWrap, {
      children: /*#__PURE__*/_jsx(ImageComponent, {
        width: "100%",
        height: "558px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/safen_Secure_Bg_200cfd8d5c.svg"
      })
    }), /*#__PURE__*/_jsxs(InnerContentWrap, {
      children: [device == "lg" ? /*#__PURE__*/_jsx(H2Tag, {
        margin: "0 0 60px",
        children: title && /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }) : /*#__PURE__*/_jsx(H5Tag, {
        margin: "0 0 20px",
        children: title && /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }), /*#__PURE__*/_jsx(FlexComp, {
        gap: device == "lg" ? "60px" : "20px",
        flexDirection: device == "sm" ? "column" : "row",
        flexWrap: "wrap",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/_jsx(SafenSecureTravCrd, SafenSecureTrav_objectSpread({}, item), index);
        })
      })]
    })]
  });
};

/* harmony default export */ var SafenSecureTrav_SafenSecureTrav = ((/* unused pure expression or super */ null && (SafenSecureTrav)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhatsCovered/WhatsCovered.style.ts






var WhatsCovered_style_WhatsCoveredStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "WhatsCoveredstyle__WhatsCoveredStyle",
  componentId: "sc-1tsmpyu-0"
})(["background:#fff;width:100%;", "{max-width:660px;font-weight:900;}", " @media ", "{padding:0 16px;", "{> ", "{overflow-y:auto;-webkit-overflow-scrolling:touch;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;}}}"], TextStyles_style_H2TagStyle, function (p) {
  return p.pageTheme === partner_PARTNER.MMT && "\n    ".concat(TextStyles_style_H4TagStyle, "{\n        font-size:24px;\n        font-weight:900;\n    }\n    ");
}, utils/* deviceType.mobile */.vO.mobile, CommonStyles_style_InnerContentWrap, FlexCompStyle);
var WhatsCovered_style_BenefitItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WhatsCoveredstyle__BenefitItem",
  componentId: "sc-1tsmpyu-1"
})(["flex:1;@media ", "{width:230px;flex-shrink:0;flex:none;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhatsCovered/WhatsCovered.tsx











var WhatsCovered = function WhatsCovered(_ref) {
  var data = _ref.data,
      title = _ref.title,
      info = _ref.info;
  var device = useBreakpointV2();
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(WhatsCoveredStyle, {
    pageTheme: context ? context : undefined,
    children: /*#__PURE__*/_jsxs(InnerContentWrap, {
      children: [device == "lg" ? /*#__PURE__*/_jsx(H2Tag, {
        children: title && /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }) : /*#__PURE__*/_jsx(H5Tag, {
        children: title && /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: device == "lg" ? "large" : "sm",
        color: theme.greyText,
        margin: "0 0 66px",
        children: info && /*#__PURE__*/_jsx(FormattedText, {
          value: info
        })
      }), /*#__PURE__*/_jsx(FlexComp, {
        gap: device == "lg" ? "82px" : "24px",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/_jsxs(BenefitItem, {
            children: [item.cardImg && /*#__PURE__*/_jsx(ImageComponent, {
              width: device == "lg" ? "164px" : "80px",
              height: device == "lg" ? "164px" : "80px",
              src: item.cardImg
            }), device == "lg" ? /*#__PURE__*/_jsx(H4Tag, {
              margin: "0 0 8px",
              children: item.title && /*#__PURE__*/_jsx(FormattedText, {
                value: item.title
              })
            }) : /*#__PURE__*/_jsxs(ParaTag, {
              fontSize: "large",
              fontWeight: "black",
              margin: "0 0 8px",
              children: [" ", item.title && /*#__PURE__*/_jsx(FormattedText, {
                value: item.title
              })]
            }), /*#__PURE__*/_jsx(ParaTag, {
              fontSize: device == "lg" ? "large" : "sm",
              color: device == "lg" ? theme.greyText7 : theme.blackText,
              children: item.info && /*#__PURE__*/_jsx(FormattedText, {
                value: item.info
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var WhatsCovered_WhatsCovered = ((/* unused pure expression or super */ null && (WhatsCovered)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceStats/InsuranceStats.style.ts



var InsuranceStats_style_InsuranceStatsWrap = styled_components_browser_esm["default"].section.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsWrap",
  componentId: "mtxv9q-0"
})(["width:100%;@media ", "{padding:0 16px;}"], utils/* deviceType.mobile */.vO.mobile);
var InsuranceStats_style_InsuranceStatsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsStyle",
  componentId: "mtxv9q-1"
})(["background:#fff;border-radius:16px;padding:40px 80px;display:flex;gap:114px;width:1200px;margin:0 auto;position:relative;z-index:1;display:grid;grid-template-columns:repeat(4,1fr);box-shadow:0px 3px 30px rgba(0,0,0,0.1);", " @media ", "{width:100%;gap:24px;padding:16px;grid-template-columns:repeat(2,1fr);box-shadow:none;", "}"], function (p) {
  return p.pageTheme === partner_PARTNER.GI && "\n    border-radius: 20px;\n    background: #FFF;\n    ";
}, utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.pageTheme === partner_PARTNER.GI && "\n    background: #fff;\n    box-shadow:none;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceStats/InsuranceStats.tsx








var InsuranceStats = function InsuranceStats(_ref) {
  var data = _ref.data;
  var context = usePartnerContext();
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsx(InsuranceStatsWrap, {
    id: "insurance-stats",
    children: /*#__PURE__*/_jsx(InsuranceStatsStyle, {
      pageTheme: context ? context : undefined,
      children: data && data.map(function (item, index) {
        return /*#__PURE__*/_jsxs("div", {
          children: [device == "lg" ? /*#__PURE__*/_jsx(H4Tag, {
            margin: "0 0 4px",
            children: item.title
          }) : /*#__PURE__*/_jsx(H5Tag, {
            margin: "0 0 4px",
            children: item.title
          }), /*#__PURE__*/_jsx(ParaTag, {
            fontSize: device == "lg" ? "md" : "xs",
            children: item.info
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ var InsuranceStats_InsuranceStats = ((/* unused pure expression or super */ null && (InsuranceStats)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravelDateWiget.tsx










var TravelDateWiget_TravelDateWiget = function TravelDateWiget(_ref) {
  var showTravDate = _ref.showTravDate,
      handleTravDate = _ref.handleTravDate,
      ref = _ref.ref,
      travDateTitle = _ref.travDateTitle,
      startDate = _ref.startDate,
      endDate = _ref.endDate;
  return /*#__PURE__*/_jsxs(TravelDateWigetStyle, {
    ref: ref,
    onClick: handleTravDate,
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "8px",
      children: [travDateTitle && /*#__PURE__*/_jsx(SpanTag, {
        textTransform: "uppercase",
        color: showTravDate ? theme.blueText : theme.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: travDateTitle
        })
      }), /*#__PURE__*/_jsx(ChevStateWrap, {
        open: showTravDate,
        children: /*#__PURE__*/_jsx(BlueChev, {})
      })]
    }), /*#__PURE__*/_jsxs(FlexComp, {
      gap: "4px",
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          fontSize: "md",
          fontWeight: "black",
          children: [startDate === null || startDate === void 0 ? void 0 : startDate.getDate(), " \xA0", startDate ? MONTHS[parseInt(startDate === null || startDate === void 0 ? void 0 : startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "regular",
            children: ["'", startDate === null || startDate === void 0 ? void 0 : startDate.getFullYear().toString().slice(-2)]
          })]
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          color: theme.greyText6,
          children: startDate && LONG_WEEK_DAYS[startDate.getDay()]
        })]
      }), /*#__PURE__*/_jsx(DateSeparator, {
        children: "-to-"
      }), /*#__PURE__*/_jsxs(FlexComp, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          fontSize: "md",
          fontWeight: "black",
          children: [endDate ? endDate.getDate() : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? 1 : startDate.getDate() + 1 : null, "\xA0", endDate ? MONTHS[parseInt(endDate.getMonth().toString().slice(-2))] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? MONTHS[parseInt((startDate.getMonth() + 1).toString().slice(-2))] : MONTHS[parseInt(startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "regular",
            children: ["'", endDate ? endDate.getFullYear().toString().slice(-2) : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? startDate.getMonth() === 11 ? (startDate.getFullYear() + 1).toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : null]
          })]
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          color: theme.greyText6,
          children: endDate ? LONG_WEEK_DAYS[endDate.getDay()] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? LONG_WEEK_DAYS[new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1).getDay()] : LONG_WEEK_DAYS[startDate.getDay()] : null
        })]
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravelDateWiget = ((/* unused pure expression or super */ null && (TravelDateWiget_TravelDateWiget)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellerCounterWiget.tsx








var TravellerCounterWiget_TravellerCounterWiget = function TravellerCounterWiget(_ref) {
  var showTravCount = _ref.showTravCount,
      handleCaptureCountIncr = _ref.handleCaptureCountIncr,
      handleCaptureCountDecr = _ref.handleCaptureCountDecr,
      captureCount = _ref.captureCount,
      ref = _ref.ref,
      travCountTitle = _ref.travCountTitle,
      travCountInfo = _ref.travCountInfo;
  return /*#__PURE__*/_jsxs(TravellerCountWigetStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(SpanTag, {
        textTransform: "uppercase",
        color: showTravCount ? theme.blueText : theme.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        children: travCountTitle && /*#__PURE__*/_jsx(FormattedText, {
          value: travCountTitle
        })
      }), /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greyText6,
        fontSize: "xs",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: "Senior citizens above 70yrs are not covered"
        })
      })]
    }), /*#__PURE__*/_jsxs(CounterWrap, {
      children: [/*#__PURE__*/_jsx(CounterBtn, {
        isDiabled: captureCount == 1,
        onClick: handleCaptureCountDecr,
        children: /*#__PURE__*/_jsxs("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/_jsx("rect", {
            width: "24",
            height: "24",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
            fill: "#008CFF"
          })]
        })
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: captureCount && captureCount <= 9 ? "0" + captureCount : captureCount
      }), /*#__PURE__*/_jsx(CounterBtn, {
        isDiabled: captureCount == 20,
        onClick: handleCaptureCountIncr,
        children: /*#__PURE__*/_jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [/*#__PURE__*/_jsx("rect", {
            width: "24",
            height: "24",
            fill: "white"
          }), /*#__PURE__*/_jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
            fill: "#008CFF"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellerCounterWiget = ((/* unused pure expression or super */ null && (TravellerCounterWiget_TravellerCounterWiget)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidget.tsx












var TravellingToWidget_analytics = getAnalytics();

var TravellingToWidget_TravellingToWidget = function TravellingToWidget(_ref) {
  var travelPurposeTxt = _ref.travelPurposeTxt,
      travCountTitle = _ref.travCountTitle,
      travPurpTitle = _ref.travPurpTitle,
      travDateTitle = _ref.travDateTitle,
      btnDisabledState = _ref.btnDisabledState,
      setCountValue = _ref.setCountValue,
      calendarDatesLimit = _ref.calendarDatesLimit,
      setCalenderValue = _ref.setCalenderValue,
      calenderRef = _ref.calenderRef,
      upcomingTravellerNum = _ref.upcomingTravellerNum,
      upcomingFromDate = _ref.upcomingFromDate,
      upcomingToDate = _ref.upcomingToDate;
  var defaultSelected = {
    from: new Date(),
    to: new Date(Date.now() + 3600 * 1000 * 24)
  };
  var endDateErrorMessage = calendarDatesLimit.endDateErrorMessage,
      insPurchaseDateLimitInDays = calendarDatesLimit.insPurchaseDateLimitInDays,
      insPurchaseEndDateLimitInDays = calendarDatesLimit.insPurchaseEndDateLimitInDays,
      insPurchaseStartDateLimitInDays = calendarDatesLimit.insPurchaseStartDateLimitInDays,
      insPurchaseStartDateMinLimitInDays = calendarDatesLimit.insPurchaseStartDateMinLimitInDays,
      startDateErrorMessage = calendarDatesLimit.startDateErrorMessage;
  var maxEndDate = addDaysToDate(new Date(), insPurchaseDateLimitInDays);
  var device = useBreakpointV2();
  var ref = useRef(null);
  var divRefs = useRef([]);

  var _useState = useState(1),
      captureCount = _useState[0],
      setCaptureCount = _useState[1];

  var _useState2 = useState(0),
      dateTab = _useState2[0],
      setDateTab = _useState2[1];

  var _useState3 = useState(defaultSelected),
      range = _useState3[0],
      setRange = _useState3[1];

  var _useState4 = useState(false),
      showToast = _useState4[0],
      setShowToast = _useState4[1];

  var _useState5 = useState(""),
      toastMessage = _useState5[0],
      setToastMessage = _useState5[1];

  var _useState6 = useState(new Date()),
      startDate = _useState6[0],
      setStartDate = _useState6[1];

  var _useState7 = useState(),
      endDate = _useState7[0],
      setEndDate = _useState7[1];

  var _useState8 = useState(-1),
      focusedIndex = _useState8[0],
      setFocusedIndex = _useState8[1];

  var prevFocusedIndexRef = useRef(focusedIndex);

  var handleClickOutside = function handleClickOutside(event) {
    var _ref$current;

    if (ref !== null && ref !== void 0 && ref.current && !(ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target))) {
      setFocusedIndex(-1);
    }
  };

  var addTravellerNumber = function addTravellerNumber(travNumber) {
    if (travNumber > TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS) {
      setCaptureCount(TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS);
      replaceHistory("travellers", TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS.toString());
    } else {
      setCaptureCount(travNumber);
      replaceHistory("travellers", travNumber.toString());
    }
  };

  var addTravellerDates = function addTravellerDates(travStartDate, travEndDate) {
    var tempFromDate = convertUnixToDate(travStartDate);
    var tempToDate = convertUnixToDate(travEndDate);
    replaceHistory("startDate", travStartDate.toString());
    replaceHistory("endDate", travEndDate.toString());
    setRange({
      from: tempFromDate,
      to: tempToDate
    });
  };

  useEffect(function () {
    document.addEventListener("click", handleClickOutside, false);
    return function () {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  useEffect(function () {
    var queryParameters = new URLSearchParams(window.location.search);
    var trav = queryParameters.get("travellers");
    var fromDate = queryParameters.get("startDate");
    var toDate = queryParameters.get("endDate");

    if (trav && !Number.isNaN(parseInt(trav))) {
      addTravellerNumber(parseInt(trav));
    } else if (upcomingTravellerNum) {
      addTravellerNumber(upcomingTravellerNum);
    }

    if (fromDate && toDate) {
      addTravellerDates(parseInt(fromDate), parseInt(toDate));
    } else if (upcomingFromDate && upcomingToDate) {
      addTravellerDates(upcomingFromDate, upcomingToDate);
    }
  }, []);
  useEffect(function () {
    setEndDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  }, []);
  useEffect(function () {
    if (captureCount >= TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCountValue(captureCount);
    }
  }, [captureCount]);
  useEffect(function () {
    if (range) {
      setCalenderValue(range);
    }
  }, [range]);
  useEffect(function () {
    var datePickerElement = document.getElementById("datePickerContainer");

    if (datePickerElement) {
      var rect = datePickerElement.getBoundingClientRect();
      var isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (prevFocusedIndexRef.current === 0 && focusedIndex !== 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (focusedIndex === 0 && !isInView) {
        var offset = rect.top + rect.height / 2 - window.innerHeight / 2;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    }

    prevFocusedIndexRef.current = focusedIndex;
  }, [focusedIndex]);
  useEffect(function () {
    if ((range === null || range === void 0 ? void 0 : range.to) === undefined && range !== null && range !== void 0 && range.from) {
      var tempToDate = new Date(range === null || range === void 0 ? void 0 : range.from);
      tempToDate.setDate(tempToDate.getDate() + 1);
      replaceHistory("endDate", convertDateToUnix(tempToDate).toString());
    }
  }, [range === null || range === void 0 ? void 0 : range.from]);

  var handleClick = function handleClick(index) {
    index == focusedIndex ? setFocusedIndex(-1) : setFocusedIndex(index);
  };

  var handleDayClick = function handleDayClick(selectedDate) {
    if (dateTab === 0) {
      var maxStartDate = addDaysToDate(new Date(), insPurchaseStartDateLimitInDays);

      if (maxStartDate && maxStartDate < selectedDate) {
        // alert(startDateErrorMessage);
        setShowToast(true);
        setToastMessage(startDateErrorMessage);
      } else if (range !== null && range !== void 0 && range.from && range !== null && range !== void 0 && range.to) {
        setRange({
          from: selectedDate,
          to: undefined
        });
        replaceHistory("startDate", convertDateToUnix(selectedDate).toString());
        setDateTab(1);
        setShowToast(false);
      }
    } else if (dateTab === 1) {
      if (range !== null && range !== void 0 && range.from) {
        var fromDate = new Date(range === null || range === void 0 ? void 0 : range.from);

        var _maxEndDate = addDaysToDate(fromDate, insPurchaseEndDateLimitInDays);

        if ((range === null || range === void 0 ? void 0 : range.from) > selectedDate) {
          setRange({
            from: selectedDate,
            to: undefined
          });
          setShowToast(false);
        } else if (_maxEndDate && _maxEndDate <= selectedDate) {
          setShowToast(true);
          setToastMessage(endDateErrorMessage);
        } else {
          var _range$from, _range$from$toLocaleD, _range$to, _range$to$toLocaleDat;

          setRange({
            from: range === null || range === void 0 ? void 0 : range.from,
            to: selectedDate
          });
          setShowToast(false);
          setDateTab(0);

          if (device == "lg") {
            setFocusedIndex(1);
          }

          replaceHistory("endDate", convertDateToUnix(selectedDate).toString());
          TravellingToWidget_analytics === null || TravellingToWidget_analytics === void 0 ? void 0 : TravellingToWidget_analytics.trackLandingEvents({
            actionType: "travel_date_selected",
            payload: {
              departure: (_range$from = range.from) === null || _range$from === void 0 ? void 0 : (_range$from$toLocaleD = _range$from.toLocaleDateString("en-GB")) === null || _range$from$toLocaleD === void 0 ? void 0 : _range$from$toLocaleD.replace(/\//gi, ":"),
              arrival: ((_range$to = range.to) === null || _range$to === void 0 ? void 0 : (_range$to$toLocaleDat = _range$to.toLocaleDateString("en-GB")) === null || _range$to$toLocaleDat === void 0 ? void 0 : _range$to$toLocaleDat.replace(/\//gi, ":")) || ""
            }
          });
        }
      }
    }
  };

  var handleCaptureCountIncr = function handleCaptureCountIncr() {
    captureCount < TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? setCaptureCount(captureCount + 1) : setCaptureCount(TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);
    replaceHistory("travellers", (captureCount + 1).toString());
  };

  var handleCaptureCountDecr = function handleCaptureCountDecr() {
    captureCount > TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? setCaptureCount(captureCount - 1) : setCaptureCount(TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS); // if (device == 'lg') {
    //     setFocusedIndex(2);
    // }

    replaceHistory("travellers", (captureCount - 1).toString());
  };

  var handleSubmit = function handleSubmit(chkIn, chkOut) {
    var _chkIn$toLocaleDateSt, _chkOut$toLocaleDateS;

    chkIn && setStartDate(chkIn);
    chkOut && setEndDate(chkOut);
    TravellingToWidget_analytics === null || TravellingToWidget_analytics === void 0 ? void 0 : TravellingToWidget_analytics.trackLandingEvents({
      actionType: "travel_date_selected",
      payload: {
        departure: (chkIn === null || chkIn === void 0 ? void 0 : (_chkIn$toLocaleDateSt = chkIn.toLocaleDateString("en-GB")) === null || _chkIn$toLocaleDateSt === void 0 ? void 0 : _chkIn$toLocaleDateSt.replace(/\//gi, ":")) || "",
        arrival: (chkOut === null || chkOut === void 0 ? void 0 : (_chkOut$toLocaleDateS = chkOut.toLocaleDateString("en-GB")) === null || _chkOut$toLocaleDateS === void 0 ? void 0 : _chkOut$toLocaleDateS.replace(/\//gi, ":")) || ""
      }
    });
    setFocusedIndex(-1);
  };

  var handleDayClick2 = function handleDayClick2(dateSelected) {
    if (range) {
      if (!startDate) {
        setStartDate(dateSelected);
      } else if (!endDate) {
        if (dateSelected && dateSelected >= startDate) {
          setEndDate(dateSelected);
        } else {
          setStartDate(dateSelected);
          setEndDate(undefined);
        }
      } else {
        setStartDate(dateSelected);
        setEndDate(undefined);
      }
    } else {
      setStartDate(dateSelected);
    }
  };

  return /*#__PURE__*/_jsxs(TravellingToWidgetStyle, {
    ref: device == "lg" ? ref : null,
    children: [/*#__PURE__*/_jsx(TravelDateWiget, {
      ref: divRefs.current[0],
      showTravDate: focusedIndex == 0,
      handleTravDate: function handleTravDate() {
        return handleClick(0);
      },
      travDateTitle: travDateTitle,
      startDate: range === null || range === void 0 ? void 0 : range.from,
      endDate: range === null || range === void 0 ? void 0 : range.to
    }), /*#__PURE__*/_jsx(TravellerCounterWiget // ref={divRefs.current[1]}
    // showTravCount={focusedIndex == 1}
    , {
      captureCount: captureCount,
      travCountTitle: travCountTitle,
      handleCaptureCountIncr: handleCaptureCountIncr,
      handleCaptureCountDecr: handleCaptureCountDecr
    }), focusedIndex == 0 && device == "lg" && /*#__PURE__*/_jsx(DatePickerComp, {
      startDateLabel: "Start Date",
      endDateLabel: "End Date",
      handleDayClick: handleDayClick,
      dateTab: dateTab,
      selected: range,
      from: range === null || range === void 0 ? void 0 : range.from,
      to: range === null || range === void 0 ? void 0 : range.to,
      maxEndDate: maxEndDate,
      toastMessage: toastMessage,
      showToast: showToast
    }), focusedIndex == 0 && device == "sm" && /*#__PURE__*/_jsx(ReactPortalComp, {
      children: /*#__PURE__*/_jsx(RangeDatePicker, {
        calendarFooter: true,
        calendarHeader: true,
        onBackPress: function onBackPress() {
          return handleClick(0);
        },
        onSubmitButtonPress: handleSubmit,
        range: true,
        calenderRef: calenderRef,
        from: range === null || range === void 0 ? void 0 : range.from,
        to: range === null || range === void 0 ? void 0 : range.to,
        toastMessage: toastMessage,
        showToast: showToast,
        selected: range,
        handleDayClick: handleDayClick
      })
    })]
  });
};

/* harmony default export */ var components_TravellingToWidget_TravellingToWidget = ((/* unused pure expression or super */ null && (TravellingToWidget_TravellingToWidget)));
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 31 modules
var esm_format = __webpack_require__(5027);
;// CONCATENATED MODULE: ../../node_modules/react-day-picker/dist/index.esm.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}

/** Returns true when the props are of type {@link DayPickerRangeProps}. */
function isDayPickerRange(props) {
    return props.mode === 'range';
}

/** Returns true when the props are of type {@link DayPickerSingleProps}. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}

/**
 * The name of the default CSS classes.
 */
var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};

/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return (0,esm_format/* default */.Z)(month, 'LLLL y', options);
}

/**
 * The default formatter for the Day button.
 */
function formatDay(day, options) {
    return (0,esm_format/* default */.Z)(day, 'd', options);
}

/**
 * The default formatter for the Month caption.
 */
function formatMonthCaption(month, options) {
    return (0,esm_format/* default */.Z)(month, 'LLLL', options);
}

/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}

/**
 * The default formatter for the name of the weekday.
 */
function formatWeekdayName(weekday, options) {
    return (0,esm_format/* default */.Z)(weekday, 'cccccc', options);
}

/**
 * The default formatter for the Year caption.
 */
function formatYearCaption(year, options) {
    return (0,esm_format/* default */.Z)(year, 'yyyy', options);
}

var formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});

/**
 * The default ARIA label for the day button.
 */
var labelDay = function (day, activeModifiers, options) {
    return (0,esm_format/* default */.Z)(day, 'do MMMM (EEEE)', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelMonthDropdown = function () {
    return 'Month: ';
};

/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

/**
 * The default ARIA label for previous month button in navigation
 */
var labelPrevious = function () {
    return 'Go to previous month';
};

/**
 * The default ARIA label for the Weekday element.
 */
var labelWeekday = function (day, options) {
    return (0,esm_format/* default */.Z)(day, 'cccc', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelYearDropdown = function () {
    return 'Year: ';
};

var labels = /*#__PURE__*/Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});

/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */
function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale = enUS;
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}

/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = endOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? startOfDay(fromDate) : undefined,
        toDate: toDate ? startOfDay(toDate) : undefined
    };
}

/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */
var DayPickerContext = (0,react.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */
function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) {
        // When no from/to dates are set, the caption is always buttons
        captionLayout = 'buttons';
    }
    var onSelect;
    if (isDayPickerSingle(initialProps) ||
        isDayPickerMultiple(initialProps) ||
        isDayPickerRange(initialProps)) {
        onSelect = initialProps.onSelect;
    }
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout: captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate: fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect: onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate });
    return (React__default.createElement(DayPickerContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */
function useDayPicker() {
    var context = (0,react.useContext)(DayPickerContext);
    if (!context) {
        throw new Error("useDayPicker must be used within a DayPickerProvider.");
    }
    return context;
}

/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (React__default.createElement("div", { className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id }, formatCaption(props.displayMonth, { locale: locale })));
}

/**
 * Render the icon in the styled drop-down.
 */
function IconDropdown(props) {
    return (React__default.createElement("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props),
        React__default.createElement("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" })));
}

/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (React__default.createElement("div", { className: className, style: style },
        React__default.createElement("span", { className: dayPicker.classNames.vhidden }, props['aria-label']),
        React__default.createElement("select", { name: props.name, "aria-label": props['aria-label'], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value: value, onChange: onChange }, children),
        React__default.createElement("div", { className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true" },
            caption,
            React__default.createElement(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon }))));
}

/** Render the dropdown to navigate between months. */
function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return React__default.createElement(React__default.Fragment, null);
    if (!toDate)
        return React__default.createElement(React__default.Fragment, null);
    var dropdownMonths = [];
    if (isSameYear(fromDate, toDate)) {
        // only display the months included in the range
        var date = startOfMonth(fromDate);
        for (var month = fromDate.getMonth(); month <= toDate.getMonth(); month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    else {
        // display all the 12 months
        var date = startOfMonth(new Date()); // Any date should be OK, as we just need the year
        for (var month = 0; month <= 11; month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    var handleChange = function (e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = setMonth(startOfMonth(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (React__default.createElement(DropdownComponent, { name: "months", "aria-label": labelMonthDropdown(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption(props.displayMonth, { locale: locale }) }, dropdownMonths.map(function (m) { return (React__default.createElement("option", { key: m.getMonth(), value: m.getMonth() }, formatMonthCaption(m, { locale: locale }))); })));
}

/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */
function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return React__default.createElement(React__default.Fragment, null);
    if (!toDate)
        return React__default.createElement(React__default.Fragment, null);
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for (var year = fromYear; year <= toYear; year++) {
        years.push(setYear(startOfYear(new Date()), year));
    }
    var handleChange = function (e) {
        var newMonth = setYear(startOfMonth(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (React__default.createElement(DropdownComponent, { name: "years", "aria-label": labelYearDropdown(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption(displayMonth, { locale: locale }) }, years.map(function (year) { return (React__default.createElement("option", { key: year.getFullYear(), value: year.getFullYear() }, formatYearCaption(year, { locale: locale }))); })));
}

/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */
function useControlledValue(defaultValue, controlledValue) {
    var _a = useState(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** Return the initial month according to the given options. */
function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && differenceInCalendarMonths(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && differenceInCalendarMonths(initialMonth, fromDate) < 0) {
        initialMonth = fromDate;
    }
    return startOfMonth(initialMonth);
}

/** Controls the navigation state. */
function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        var _a;
        if (context.disableNavigation)
            return;
        var month = startOfMonth(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 ? void 0 : _a.call(context, month);
    };
    return [month, goToMonth];
}

/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = startOfMonth(month);
    var end = startOfMonth(addMonths(start, numberOfMonths));
    var monthsDiff = differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = addMonths(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}

/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */
function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!toDate) {
        return addMonths(month, offset);
    }
    var monthsDiff = differenceInCalendarMonths(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return addMonths(month, offset);
}

/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */
function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!fromDate) {
        return addMonths(month, -offset);
    }
    var monthsDiff = differenceInCalendarMonths(month, fromDate);
    if (monthsDiff <= 0) {
        return undefined;
    }
    // Jump back as the number of months when paged navigation
    return addMonths(month, -offset);
}

/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */
var NavigationContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */
function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function (date) {
        return displayMonths.some(function (displayMonth) {
            return isSameMonth(date, displayMonth);
        });
    };
    var goToDate = function (date, refDate) {
        if (isDateDisplayed(date)) {
            return;
        }
        if (refDate && isBefore(date, refDate)) {
            goToMonth(addMonths(date, 1 + dayPicker.numberOfMonths * -1));
        }
        else {
            goToMonth(date);
        }
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (React__default.createElement(NavigationContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useNavigation() {
    var context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth(newMonth);
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (React__default.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (React__default.createElement("div", { className: classNames.caption_dropdowns, style: styles.caption_dropdowns },
        React__default.createElement("div", { className: classNames.vhidden }, captionLabel),
        React__default.createElement(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }),
        React__default.createElement(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })));
}

/**
 * Render the "previous month" button in the navigation.
 */
function IconLeft(props) {
    return (React__default.createElement("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props),
        React__default.createElement("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" })));
}

/**
 * Render the "next month" button in the navigation.
 */
function IconRight(props) {
    return (React__default.createElement("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props),
        React__default.createElement("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" })));
}

/** Render a button HTML element applying the reset class name. */
var Button = (0,react.forwardRef)(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (react.createElement("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

/** A component rendering the navigation buttons or the drop-downs. */
function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var previousLabel = labelPrevious(props.previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (React__default.createElement("div", { className: classNames.nav, style: styles.nav },
        !props.hidePrevious && (React__default.createElement(Button, { name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick }, dir === 'rtl' ? (React__default.createElement(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (React__default.createElement(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })))),
        !props.hideNext && (React__default.createElement(Button, { name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick }, dir === 'rtl' ? (React__default.createElement(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (React__default.createElement(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon }))))));
}

/**
 * Render a caption with a button-based navigation.
 */
function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function (month) {
        return isSameMonth(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function () {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function () {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
    };
    return (React__default.createElement(Navigation, { displayMonth: props.displayMonth, hideNext: hideNext, hidePrevious: hidePrevious, nextMonth: nextMonth, previousMonth: previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick }));
}

/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */
function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) {
        caption = (React__default.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    }
    else if (captionLayout === 'dropdown') {
        caption = (React__default.createElement(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }));
    }
    else if (captionLayout === 'dropdown-buttons') {
        caption = (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }),
            React__default.createElement(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })));
    }
    else {
        caption = (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }),
            React__default.createElement(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })));
    }
    return (React__default.createElement("div", { className: classNames.caption, style: styles.caption }, caption));
}

/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement("tfoot", { className: tfoot, style: styles.tfoot },
        React__default.createElement("tr", null,
            React__default.createElement("td", { colSpan: 8 }, footer))));
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek) {
    var start = ISOWeek
        ? startOfISOWeek(new Date())
        : startOfWeek(new Date(), { locale: locale, weekStartsOn: weekStartsOn });
    var days = [];
    for (var i = 0; i < 7; i++) {
        var day = addDays(start, i);
        days.push(day);
    }
    return days;
}

/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */
function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (React__default.createElement("tr", { style: styles.head_row, className: classNames.head_row },
        showWeekNumber && (React__default.createElement("td", { style: styles.head_cell, className: classNames.head_cell })),
        weekdays.map(function (weekday, i) { return (React__default.createElement("th", { key: i, scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday(weekday, { locale: locale }) }, formatWeekdayName(weekday, { locale: locale }))); })));
}

/** Render the table head. */
function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (React__default.createElement("thead", { style: styles.head, className: classNames.head },
        React__default.createElement(HeadRowComponent, null)));
}

/** Render the content of the day cell. */
function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return React__default.createElement(React__default.Fragment, null, formatDay(props.date, { locale: locale }));
}

/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */
var SelectMultipleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */
function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (React__default.createElement(SelectMultipleContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (React__default.createElement(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) {
            return;
        }
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function (selectedDay) {
                return isSameDay(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        }
        else {
            selectedDays.push(day);
        }
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) {
        modifiers.disabled.push(function (day) {
            var isMaxSelected = max && selected.length > max - 1;
            var isSelected = selected.some(function (selectedDay) {
                return isSameDay(selectedDay, day);
            });
            return Boolean(isMaxSelected && !isSelected);
        });
    }
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (React__default.createElement(SelectMultipleContext.Provider, { value: contextValue }, children));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectMultiple() {
    var context = useContext(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (!from) {
        return { from: day, to: undefined };
    }
    if (!to && isSameDay(from, day)) {
        return { from: from, to: day };
    }
    if (!to && isBefore(day, from)) {
        return { from: day, to: from };
    }
    if (!to) {
        return { from: from, to: day };
    }
    if (isSameDay(to, day) && isSameDay(from, day)) {
        return undefined;
    }
    if (isSameDay(to, day)) {
        return { from: to, to: undefined };
    }
    if (isSameDay(from, day)) {
        return undefined;
    }
    if (isAfter(from, day)) {
        return { from: day, to: to };
    }
    return { from: from, to: day };
}

/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */
var SelectRangeContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */
function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (React__default.createElement(SelectRangeContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (React__default.createElement(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [selectedFrom];
        if (!selectedTo) {
            modifiers.range_end = [selectedFrom];
        }
        else {
            modifiers.range_end = [selectedTo];
            if (!isSameDay(selectedFrom, selectedTo)) {
                modifiers.range_middle = [
                    {
                        after: selectedFrom,
                        before: selectedTo
                    }
                ];
            }
        }
    }
    if (min) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedFrom, min - 1),
                before: addDays(selectedFrom, min - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: selectedFrom,
                before: addDays(selectedFrom, min - 1)
            });
        }
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: addDays(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: addDays(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = differenceInCalendarDays(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: subDays(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: addDays(selectedTo, offset)
            });
        }
    }
    return (React__default.createElement(SelectRangeContext.Provider, { value: { selected: selected, onDayClick: onDayClick, modifiers: modifiers } }, children));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectRange() {
    var context = useContext(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}

/** Normalize to array a matcher input. */
function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}

/** Create CustomModifiers from dayModifiers */
function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}

/** The name of the modifiers that are used internally by DayPicker. */
var InternalModifier;
(function (InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */
    InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */
    InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */
    InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */
    InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */
    InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */
    InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */
    InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));

var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {},
        _a[Selected] = matcherToArray(dayPicker.selected),
        _a[Disabled] = matcherToArray(dayPicker.disabled),
        _a[Hidden] = matcherToArray(dayPicker.hidden),
        _a[Today] = [dayPicker.today],
        _a[RangeEnd] = [],
        _a[RangeMiddle] = [],
        _a[RangeStart] = [],
        _a[Outside] = [],
        _a);
    if (dayPicker.fromDate) {
        internalModifiers[Disabled].push({ before: dayPicker.fromDate });
    }
    if (dayPicker.toDate) {
        internalModifiers[Disabled].push({ after: dayPicker.toDate });
    }
    if (isDayPickerMultiple(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    }
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}

/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */
var ModifiersContext = (0,react.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */
function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (React__default.createElement(ModifiersContext.Provider, { value: modifiers }, props.children));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */
function useModifiers() {
    var context = useContext(ModifiersContext);
    if (!context) {
        throw new Error('useModifiers must be used within a ModifiersProvider');
    }
    return context;
}

/** Returns true if `matcher` is of type {@link DateInterval}. */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */
function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */
function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}

/** Return `true` whether `date` is inside `range`. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (!from) {
        return false;
    }
    if (!to && isSameDay(from, date)) {
        return true;
    }
    if (!to) {
        return false;
    }
    var isRangeInverted = differenceInCalendarDays(to, from) < 0;
    if (isRangeInverted) {
        _a = [to, from], from = _a[0], to = _a[1];
    }
    var isInRange = differenceInCalendarDays(date, from) >= 0 &&
        differenceInCalendarDays(to, date) >= 0;
    return isInRange;
}

/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return isDate(value);
}
/** Returns true if `value` is an array of valid dates. */
function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(isDate);
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */
function isMatch(day, matchers) {
    return matchers.some(function (matcher) {
        if (typeof matcher === 'boolean') {
            return matcher;
        }
        if (isDateType(matcher)) {
            return isSameDay(day, matcher);
        }
        if (isArrayOfDates(matcher)) {
            return matcher.includes(day);
        }
        if (isDateRange(matcher)) {
            return isDateInRange(day, matcher);
        }
        if (isDayOfWeekType(matcher)) {
            return matcher.dayOfWeek.includes(day.getDay());
        }
        if (isDateInterval(matcher)) {
            var diffBefore = differenceInCalendarDays(matcher.before, day);
            var diffAfter = differenceInCalendarDays(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return differenceInCalendarDays(day, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return differenceInCalendarDays(matcher.before, day) > 0;
        }
        if (typeof matcher === 'function') {
            return matcher(day);
        }
        return false;
    });
}

/** Return the active modifiers for the given day. */
function getActiveModifiers(day, 
/** The modifiers to match for the given date. */
modifiers, 
/** The month where the day is displayed, to add the "outside" modifiers.  */
displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function (result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) {
            result.push(key);
        }
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function (modifier) { return (activeModifiers[modifier] = true); });
    if (displayMonth && !isSameMonth(day, displayMonth)) {
        activeModifiers.outside = true;
    }
    return activeModifiers;
}

/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */
function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = startOfMonth(displayMonths[0]);
    var lastDayInMonth = endOfMonth(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while (date <= lastDayInMonth) {
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = addDays(date, 1);
            continue;
        }
        if (activeModifiers.selected) {
            return date;
        }
        if (activeModifiers.today && !today) {
            today = date;
        }
        if (!firstFocusableDay) {
            firstFocusableDay = date;
        }
        date = addDays(date, 1);
    }
    if (today) {
        return today;
    }
    else {
        return firstFocusableDay;
    }
}

var MAX_RETRY = 365;
/** Return the next date to be focused. */
function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: function (date) {
            return context.ISOWeek
                ? startOfISOWeek(date)
                : startOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        },
        endOfWeek: function (date) {
            return context.ISOWeek
                ? endOfISOWeek(date)
                : endOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) {
        newFocusedDay = max([fromDate, newFocusedDay]);
    }
    else if (direction === 'after' && toDate) {
        newFocusedDay = min([toDate, newFocusedDay]);
    }
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) {
        return newFocusedDay;
    }
    else {
        if (retry.count > MAX_RETRY) {
            return retry.lastFocused;
        }
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), { count: retry.count + 1 })
        });
    }
}

/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */
var FocusContext = (0,react.createContext)(undefined);
/** The provider for the {@link FocusContext}. */
function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = useState(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = useState(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : (lastFocused && navigation.isDateDisplayed(lastFocused)))
        ? lastFocused
        : initialFocusTarget;
    var blur = function () {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function (date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function (moveBy, direction) {
        if (!focusedDay)
            return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if (isSameDay(focusedDay, nextFocused))
            return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function () { return moveFocus('day', 'after'); },
        focusDayBefore: function () { return moveFocus('day', 'before'); },
        focusWeekAfter: function () { return moveFocus('week', 'after'); },
        focusWeekBefore: function () { return moveFocus('week', 'before'); },
        focusMonthBefore: function () { return moveFocus('month', 'before'); },
        focusMonthAfter: function () { return moveFocus('month', 'after'); },
        focusYearBefore: function () { return moveFocus('year', 'before'); },
        focusYearAfter: function () { return moveFocus('year', 'after'); },
        focusStartOfWeek: function () { return moveFocus('startOfWeek', 'before'); },
        focusEndOfWeek: function () { return moveFocus('endOfWeek', 'after'); }
    };
    return (React__default.createElement(FocusContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useFocusContext() {
    var context = useContext(FocusContext);
    if (!context) {
        throw new Error('useFocusContext must be used within a FocusProvider');
    }
    return context;
}

/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */
function useActiveModifiers(day, 
/**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */
displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}

/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */
var SelectSingleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */
function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (React__default.createElement(SelectSingleContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (React__default.createElement(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (React__default.createElement(SelectSingleContext.Provider, { value: contextValue }, children));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectSingle() {
    var context = useContext(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}

/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */
function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function (e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) {
            (_a = single.onDayClick) === null || _a === void 0 ? void 0 : _a.call(single, date, activeModifiers, e);
        }
        else if (isDayPickerMultiple(dayPicker)) {
            (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date, activeModifiers, e);
        }
        else if (isDayPickerRange(dayPicker)) {
            (_c = range.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range, date, activeModifiers, e);
        }
        else {
            (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date, activeModifiers, e);
        }
    };
    var onFocus = function (e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function (e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function (e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}

/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */
function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker)
        ? single.selected
        : isDayPickerMultiple(dayPicker)
            ? multiple.selected
            : isDayPickerRange(dayPicker)
                ? range.selected
                : undefined;
    return selectedDays;
}

function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */
function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [dayPicker.classNames.day];
    Object.keys(activeModifiers).forEach(function (modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) {
            classNames.push(customClassName);
        }
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) {
                classNames.push(internalClassName);
            }
        }
    });
    return classNames;
}

/** Return the style for the Day element, according to the given active modifiers. */
function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function (modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}

/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */
function useDayRender(
/** The date to render. */
day, 
/** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */
displayMonth, 
/** A ref to the button element that will be target of focus when rendered (if required). */
buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    useEffect(function () {
        var _a;
        if (activeModifiers.outside)
            return;
        if (!focusContext.focusedDay)
            return;
        if (!isButton)
            return;
        if (isSameDay(focusContext.focusedDay, day)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean((activeModifiers.outside && !dayPicker.showOutsideDays) ||
        activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (React__default.createElement(DayContentComponent, { date: day, displayMonth: displayMonth, activeModifiers: activeModifiers }));
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget &&
        isSameDay(focusContext.focusTarget, day) &&
        !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && isSameDay(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: 'gridcell' }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = useRef(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return React__default.createElement("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return React__default.createElement("div", __assign({}, dayRender.divProps));
    }
    return React__default.createElement(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}

/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), { locale: locale });
    if (!onWeekNumberClick) {
        return (React__default.createElement("span", { className: classNames.weeknumber, style: styles.weeknumber }, content));
    }
    var label = labelWeekNumber(Number(weekNumber), { locale: locale });
    var handleClick = function (e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (React__default.createElement(Button, { name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick }, content));
}

/** Render a row in the calendar, with the days and the week number. */
function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (React__default.createElement("td", { className: classNames.cell, style: styles.cell },
            React__default.createElement(WeeknumberComponent, { number: props.weekNumber, dates: props.dates })));
    }
    return (React__default.createElement("tr", { className: classNames.row, style: styles.row },
        weekNumberCell,
        props.dates.map(function (date) { return (React__default.createElement("td", { className: classNames.cell, style: styles.cell, key: getUnixTime(date), role: "presentation" },
            React__default.createElement(DayComponent, { displayMonth: props.displayMonth, date: date }))); })));
}

/** Return the weeks between two dates.  */
function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? endOfISOWeek(toDate)
        : endOfWeek(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? startOfISOWeek(fromDate)
        : startOfWeek(fromDate, options);
    var nOfDays = differenceInCalendarDays(toWeek, fromWeek);
    var days = [];
    for (var i = 0; i <= nOfDays; i++) {
        days.push(addDays(fromWeek, i));
    }
    var weeksInMonth = days.reduce(function (result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek)
            ? getISOWeek(date)
            : getWeek(date, options);
        var existingWeek = result.find(function (value) { return value.weekNumber === weekNumber; });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [date]
        });
        return result;
    }, []);
    return weeksInMonth;
}

/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */
function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks(startOfMonth(month), endOfMonth(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = getWeeksInMonth(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = addWeeks(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks(addWeeks(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}

/** Render the table with the calendar. */
function index_esm_Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (React__default.createElement("table", { className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props['aria-labelledby'] },
        !hideHead && React__default.createElement(HeadComponent, null),
        React__default.createElement("tbody", { className: classNames.tbody, style: styles.tbody, role: "rowgroup" }, weeks.map(function (week) { return (React__default.createElement(RowComponent, { displayMonth: props.displayMonth, key: week.weekNumber, dates: week.dates, weekNumber: week.weekNumber })); })),
        React__default.createElement(FooterComponent, { displayMonth: props.displayMonth })));
}

/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = canUseDOM()
    ? react.useLayoutEffect
    : react.useEffect;
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : (serverHandoffComplete ? genId() : null);
    var _b = React.useState(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function () {
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(function () {
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}

/** Render a month. */
function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var className = [classNames.month];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') {
        _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
    }
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (React__default.createElement("div", { key: props.displayIndex, className: className.join(' '), style: style },
        React__default.createElement(CaptionComponent, { id: captionId, displayMonth: props.displayMonth }),
        React__default.createElement(index_esm_Table, { "aria-labelledby": captionId, displayMonth: props.displayMonth })));
}

/** Render the container with the months according to the number of months to display. */
function Root(_a) {
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _b = useState(false), hasInitialFocus = _b[0], setHasInitialFocus = _b[1];
    // Focus the focus target when initialFocus is passed in
    useEffect(function () {
        if (!dayPicker.initialFocus)
            return;
        if (!focusContext.focusTarget)
            return;
        if (hasInitialFocus)
            return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [dayPicker.classNames.root, dayPicker.className];
    if (dayPicker.numberOfMonths > 1) {
        classNames.push(dayPicker.classNames.multiple_months);
    }
    if (dayPicker.showWeekNumber) {
        classNames.push(dayPicker.classNames.with_weeknumber);
    }
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps)
        .filter(function (key) { return key.startsWith('data-'); })
        .reduce(function (attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    return (React__default.createElement("div", __assign({ className: classNames.join(' '), style: style, dir: dayPicker.dir, id: dayPicker.id }, dataAttributes),
        React__default.createElement("div", { className: dayPicker.classNames.months, style: dayPicker.styles.months }, navigation.displayMonths.map(function (month, i) { return (React__default.createElement(Month, { key: i, displayIndex: i, displayMonth: month })); }))));
}

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (React__default.createElement(DayPickerProvider, { initialProps: initialProps },
        React__default.createElement(NavigationProvider, null,
            React__default.createElement(SelectSingleProvider, { initialProps: initialProps },
                React__default.createElement(SelectMultipleProvider, { initialProps: initialProps },
                    React__default.createElement(SelectRangeProvider, { initialProps: initialProps },
                        React__default.createElement(ModifiersProvider, null,
                            React__default.createElement(FocusProvider, null, children))))))));
}

/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */
function index_esm_DayPicker(props) {
    return (React__default.createElement(RootProvider, __assign({}, props),
        React__default.createElement(Root, { initialProps: props })));
}

/** @private */
function index_esm_isValidDate(day) {
    return !isNaN(day.getTime());
}

/** Return props and setters for binding an input field to DayPicker. */
function useInput(options) {
    if (options === void 0) { options = {}; }
    var _a = options.locale, locale = _a === void 0 ? enUS : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function (value) { return parse(value, format$1, today, { locale: locale }); };
    // Initialize states
    var _e = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = useState(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected
        ? format(defaultSelected, format$1, { locale: locale })
        : '';
    var _g = useState(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function () {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function (date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? format(date, format$1, { locale: locale }) : '');
    };
    var handleDayClick = function (day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? format(day, format$1, { locale: locale }) : '');
    };
    var handleMonthChange = function (month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function (e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && differenceInCalendarDays(fromDate, day) > 0;
        var isAfter = toDate && differenceInCalendarDays(day, toDate) > 0;
        if (!index_esm_isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function (e) {
        var day = parseValue(e.target.value);
        if (!index_esm_isValidDate(day)) {
            reset();
        }
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function (e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (index_esm_isValidDate(day)) {
            setMonth(day);
        }
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: format(new Date(), format$1, { locale: locale })
    };
    return { dayPickerProps: dayPickerProps, inputProps: inputProps, reset: reset, setSelected: setSelected };
}

/** Returns true when the props are of type {@link DayPickerDefaultProps}. */
function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DatePickerComp/DatePickerComp.style.ts



var DatePickerComp_style_DatePickerWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DatePickerCompstyle__DatePickerWrap",
  componentId: "sc-128qnt3-0"
})(["width:592px;background:#ffffff;box-sizing:border-box;display:flex;flex-direction:column;z-index:1;border-radius:4px;box-shadow:0px 1px 7px rgba(0,0,0,0.2);position:absolute;left:0;top:30px;", "{position:static;background:#fcdadb;width:fit-content;margin-bottom:16px;margin-left:16px;}", " span{font-size:14px;color:", ";}.rdp-cell{width:38px;height:38px;}.rdp-cell:hover{border-radius:0;}.rdp-weeknumber,.rdp-day{font-size:12px;width:38px;height:38px;}.rdp-day_selected,.rdp-day_selected:focus-visible{background:#eaf5ff;color:#000;border-radius:0;}.rdp-day_range_start,.rdp-day_range_end{background:#008cff;border-radius:0px 2px 2px 0px;color:#fff;}.rdp-head_cell{font-weight:700;font-size:12px;line-height:16px;color:#9b9b9b;}.rdp-caption_label{font-weight:400;font-size:18px;line-height:25px;color:#000;}.rdp-caption_label .boldText{font-weight:700;}.rdp-day_today{font-weight:400;}.rdp-button svg{display:none;}.rdp-button:hover:not([disabled]):not(.rdp-day_selected){background:#eaf5ff;border-radius:0;}.rdp-nav_button_previous:before,.rdp-nav_button_next:before{position:absolute;top:20px;content:\"\";width:20px;height:2px;background:#008cff;border-radius:2px;background-image:none;}.rdp-nav_button_previous:after{left:7px;transform:rotate(-45deg);}.rdp-nav_button_next:after{right:7px;transform:rotate(135deg);}.rdp-nav_button_previous:after,.rdp-nav_button_next:after{position:absolute;top:17px;content:\"\";width:8px;height:8px;background-image:none;border-top:solid 2px #008cff;border-left:solid 2px #008cff;}"], Toast_style_ToastStyle, Toast_style_ToastStyle, Global/* theme.redText */.rS.redText);
var DatePickerComp_style_DateLabel = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DatePickerCompstyle__DateLabel",
  componentId: "sc-128qnt3-1"
})(["background:#ffffff;border-radius:2px;padding:0 8px;", ""], function (p) {
  return p.activeTab && "\n    background: #eaf5ff;\n    border: 1px solid #008cff;\n    border-radius: 2px;\n    ";
});
var DatePickerComp_style_DateTab = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "DatePickerCompstyle__DateTab",
  componentId: "sc-128qnt3-2"
})(["display:flex;padding:10px 15px;border-radius:4px 4px 0px 0px;background-color:#f2f2f2;"]);
var DatePickerComp_style_DateTabList = styled_components_browser_esm["default"].li.withConfig({
  displayName: "DatePickerCompstyle__DateTabList",
  componentId: "sc-128qnt3-3"
})(["cursor:pointer;display:flex;align-items:center;gap:4px;margin-right:10px;&:last-child{margin-right:unset;}"]);
var DatePickerComp_style_ErrorToast = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DatePickerCompstyle__ErrorToast",
  componentId: "sc-128qnt3-4"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
var DobPickerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DatePickerCompstyle__DobPickerStyle",
  componentId: "sc-128qnt3-5"
})(["border-radius:4px;border:0px solid #979797;background:#fff;box-shadow:0px 1px 6px 0px rgba(0,0,0,0.2);width:300px;.rdp-dropdown_year,.rdp-dropdown_month{border-radius:4px;border:1px solid #4a4a4a;padding:0 8px;}.rdp-day_selected,.rdp-day_selected:focus-visible,.rdp-day_selected:hover{border-radius:2px 0px 0px 2px;background:#008cff;color:#fff;}.rdp-head{color:#9b9b9b;text-align:center;font-size:12px;font-weight:700;}.rdp-weeknumber,.rdp-day{font-size:12px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DatePickerComp/DatePickerComp.tsx









var DatePickerComp_MONTHS = (/* unused pure expression or super */ null && (["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]));

var DatePickerComp_DatePickerComp = function DatePickerComp(_ref) {
  var startDateLabel = _ref.startDateLabel,
      endDateLabel = _ref.endDateLabel,
      from = _ref.from,
      to = _ref.to,
      maxEndDate = _ref.maxEndDate,
      dateTab = _ref.dateTab,
      handleDateTab = _ref.handleDateTab,
      handleDayClick = _ref.handleDayClick,
      selected = _ref.selected,
      showToast = _ref.showToast,
      toastMessage = _ref.toastMessage;

  var weekDayNameFormatter = function weekDayNameFormatter(date) {
    return /*#__PURE__*/_jsx("span", {
      children: date.toDateString()[0]
    });
  };

  var monthNameFormatter = function monthNameFormatter(date) {
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx("b", {
        children: DatePickerComp_MONTHS[date.getMonth()]
      }), "\xA0", /*#__PURE__*/_jsx("span", {
        children: date.getFullYear().toString().slice(-2)
      })]
    });
  };

  var disabledDays = function disabledDays(date) {
    return isBefore(date, new Date()) || !!(maxEndDate && isAfter(date, maxEndDate));
  };

  return /*#__PURE__*/_jsxs(DatePickerWrap, {
    id: "datePickerContainer",
    children: [/*#__PURE__*/_jsxs(DateTab, {
      children: [/*#__PURE__*/_jsxs(DateTabList, {
        onClick: function onClick() {
          return handleDateTab === null || handleDateTab === void 0 ? void 0 : handleDateTab(0);
        },
        children: [/*#__PURE__*/_jsx("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/_jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "sm",
          children: startDateLabel
        }), /*#__PURE__*/_jsx(DateLabel, {
          activeTab: dateTab == 0,
          children: /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "sm",
            fontWeight: dateTab == 0 ? "bold" : "regular",
            color: dateTab == 0 ? theme.blueText : theme.greyText,
            children: from ? calendarLabelFormatter(from) : "Select"
          })
        })]
      }), /*#__PURE__*/_jsx(DateTabList, {
        children: "-"
      }), /*#__PURE__*/_jsxs(DateTabList, {
        onClick: function onClick() {
          return handleDateTab === null || handleDateTab === void 0 ? void 0 : handleDateTab(1);
        },
        children: [/*#__PURE__*/_jsx("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/_jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "sm",
          children: endDateLabel
        }), /*#__PURE__*/_jsx(DateLabel, {
          activeTab: dateTab == 0,
          children: /*#__PURE__*/_jsx(SpanTag, {
            fontWeight: dateTab == 1 ? "bold" : "regular",
            fontSize: "sm",
            color: dateTab == 1 ? theme.blueText : theme.greyText,
            children: to ? calendarLabelFormatter(to) : "Select"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(DayPicker, {
      mode: "range",
      numberOfMonths: 2,
      selected: selected,
      disabled: disabledDays,
      onDayClick: handleDayClick,
      formatters: {
        formatWeekdayName: weekDayNameFormatter,
        formatCaption: monthNameFormatter
      }
    }), showToast && /*#__PURE__*/_jsx(ErrorToast, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        color: theme.redText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: toastMessage
        })
      })
    })]
  });
};

/* harmony default export */ var components_DatePickerComp_DatePickerComp = ((/* unused pure expression or super */ null && (DatePickerComp_DatePickerComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SecureTravOffer/SecureTravOffer.style.ts




var SecureTravOffer_style_SecureTravOfferStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravOfferStyle",
  componentId: "pvlpoe-0"
})(["display:flex;flex-direction:column;gap:24px;svg{flex-shrink:0;}", "{font-size:22px;font-weight:900;}"], TextStyles_style_H5TagStyle);
var SecureTravOffer_style_SecureTravItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravItem",
  componentId: "pvlpoe-1"
})(["display:flex;gap:24px;@media ", "{gap:8px;}"], utils/* deviceType.mobile */.vO.mobile);
var SecureTravOffer_style_SecureTravImgWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravImgWrap",
  componentId: "pvlpoe-2"
})(["background:linear-gradient( 125.09deg,#474747 0%,rgba(255,255,255,0) 64.55% );border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:72px;height:80px;", ""], function (p) {
  return p.pageTheme === partner_PARTNER.MMT ? "\n     background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);\n    " : p.pageTheme === partner_PARTNER.GI ? "background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);" : "\n    ";
});
var SecureTravOffer_style_SecureTravContent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravContent",
  componentId: "pvlpoe-3"
})(["align-self:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SecureTravOffer/SecureTravOffer.tsx










var SecureTravOffer = function SecureTravOffer(_ref) {
  var data = _ref.data;
  var context = usePartnerContext();
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsx(SecureTravOfferStyle, {
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/_jsxs(SecureTravItem, {
        children: [/*#__PURE__*/_jsx(SecureTravImgWrap, {
          pageTheme: context ? context : undefined,
          children: item.travImg && /*#__PURE__*/_jsx(ImageComponent, {
            width: "48px",
            height: "48px",
            src: item.travImg,
            loading: "eager"
          })
        }), /*#__PURE__*/_jsxs(SecureTravContent, {
          children: [device == "lg" ? /*#__PURE__*/_jsx(H5Tag, {
            color: theme.greyText,
            children: item.title && /*#__PURE__*/_jsx(FormattedText, {
              value: item.title
            })
          }) : /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "md",
            color: theme.greyText,
            children: item.title && /*#__PURE__*/_jsx(FormattedText, {
              value: item.title
            })
          }), item.info && /*#__PURE__*/_jsx(ParaTag, {
            margin: device == "lg" ? "16px 0 0" : "8px 0 0",
            fontSize: device == "lg" ? "sm" : "xs",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.info
            })
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ var SecureTravOffer_SecureTravOffer = ((/* unused pure expression or super */ null && (SecureTravOffer)));
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function classCallCheck_classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js + 1 modules
var toPropertyKey = __webpack_require__(2802);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,toPropertyKey/* default */.Z)(o.key), o);
  }
}
function createClass_createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,esm_typeof/* default */.Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var esm_defineProperty = __webpack_require__(6666);
;// CONCATENATED MODULE: ../../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../../node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/calculateSizeAndPositionDataAndUpdateScrollOffset.js
/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1461);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function objectWithoutProperties_objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,objectWithoutPropertiesLoose/* default */.Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/types.js


var bpfrpt_proptype_CellPosition =  true ? null : 0;
var bpfrpt_proptype_CellRendererParams =  true ? null : 0;
var bpfrpt_proptype_CellRenderer =  true ? null : 0;
var bpfrpt_proptype_CellCache =  true ? null : 0;
var bpfrpt_proptype_StyleCache =  true ? null : 0;
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : 0;
var bpfrpt_proptype_CellRangeRenderer =  true ? null : 0;
var bpfrpt_proptype_CellSizeGetter =  true ? null : 0;
var bpfrpt_proptype_CellSize =  true ? null : 0;
var bpfrpt_proptype_NoContentRenderer =  true ? null : 0;
var bpfrpt_proptype_Scroll =  true ? null : 0;
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : 0;
var bpfrpt_proptype_RenderedSection =  true ? null : 0;
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : 0;
var bpfrpt_proptype_OverscanIndices =  true ? null : 0;
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : 0;
var bpfrpt_proptype_Alignment =  true ? null : 0;
var bpfrpt_proptype_VisibleCellRange =  true ? null : 0;



















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/CellSizeAndPositionManager.js




/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    classCallCheck_classCallCheck(this, CellSizeAndPositionManager);

    (0,esm_defineProperty/* default */.Z)(this, "_cellSizeAndPositionData", {});

    (0,esm_defineProperty/* default */.Z)(this, "_lastMeasuredIndex", -1);

    (0,esm_defineProperty/* default */.Z)(this, "_lastBatchedIndex", -1);

    (0,esm_defineProperty/* default */.Z)(this, "_cellCount", void 0);

    (0,esm_defineProperty/* default */.Z)(this, "_cellSizeGetter", void 0);

    (0,esm_defineProperty/* default */.Z)(this, "_estimatedCellSize", void 0);

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  createClass_createClass(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/maxElementSize.js
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/ScalingCellSizeAndPositionManager.js







/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? getMaxElementSize() : _ref$maxScrollSize,
        params = objectWithoutProperties_objectWithoutProperties(_ref, ["maxScrollSize"]);

    classCallCheck_classCallCheck(this, ScalingCellSizeAndPositionManager);

    (0,esm_defineProperty/* default */.Z)(this, "_cellSizeAndPositionManager", void 0);

    (0,esm_defineProperty/* default */.Z)(this, "_maxScrollSize", void 0);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new CellSizeAndPositionManager(params);
    this._maxScrollSize = maxScrollSize;
  }

  createClass_createClass(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/createCallbackMemoizer.js
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/defaultOverscanIndicesGetter.js
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/updateScrollIndexHelper.js

/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/defaultCellRangeRenderer.js
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {}

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {}
}


;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ var esm_canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (esm_canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/animationFrame.js
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/requestAnimationTimeout.js

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : 0;
var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return caf(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = raf(timeout);
    }
  };

  var frame = {
    id: raf(timeout)
  };
  return frame;
};


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/Grid.js









var _class, _temp;

function Grid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Grid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Grid_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Grid_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    classCallCheck_classCallCheck(this, Grid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Grid).call(this, props));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onGridRenderedMemoizer", createCallbackMemoizer());

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateColumnIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateRowIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_recomputeScrollLeftFlag", false);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_recomputeScrollTopFlag", false);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_horizontalScrollBarSize", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_verticalScrollBarSize", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_scrollbarPresenceChanged", false);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_scrollingContainer", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_childrenToDisplay", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStartIndex", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStopIndex", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStartIndex", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStopIndex", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedColumnStartIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedColumnStopIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedRowStartIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedRowStopIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_initialScrollTop", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_initialScrollLeft", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_disablePointerEventsTimeoutId", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_styleCache", {});

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellCache", {});

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });

    var columnSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  createClass_createClass(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = Grid_objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(Grid_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(Grid_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = Grid_objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return react.createElement("div", (0,esm_extends/* default */.Z)({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: clsx_m('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: Grid_objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && react.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: Grid_objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = requestAnimationTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return Grid_objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);

  return Grid;
}(react.PureComponent), (0,esm_defineProperty/* default */.Z)(_class, "propTypes",  true ? null : 0), _temp);

(0,esm_defineProperty/* default */.Z)(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: defaultCellRangeRenderer,
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: scrollbarSize,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});

polyfill(Grid);
/* harmony default export */ var Grid_Grid = (Grid);















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/accessibilityOverscanIndicesGetter.js
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_BACKWARD = (/* unused pure expression or super */ null && (-1));
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD = 1;
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/index.js





















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/types.js
var bpfrpt_proptype_ScrollIndices =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/ArrowKeyStepper.js








var ArrowKeyStepper_class, ArrowKeyStepper_temp;

function ArrowKeyStepper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ArrowKeyStepper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ArrowKeyStepper_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ArrowKeyStepper_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = (ArrowKeyStepper_temp = ArrowKeyStepper_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ArrowKeyStepper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStartIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStopIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStartIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStopIndex", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onKeyDown", function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;

      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow; // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;

        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;

        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;

        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onSectionRendered", function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });

    return _this;
  }

  createClass_createClass(ArrowKeyStepper, [{
    key: "setScrollIndexes",
    value: function setScrollIndexes(_ref2) {
      var scrollToColumn = _ref2.scrollToColumn,
          scrollToRow = _ref2.scrollToRow;
      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children;

      var _this$_getScrollState3 = this._getScrollState(),
          scrollToColumn = _this$_getScrollState3.scrollToColumn,
          scrollToRow = _this$_getScrollState3.scrollToRow;

      return react.createElement("div", {
        className: className,
        onKeyDown: this._onKeyDown
      }, children({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow
      }));
    }
  }, {
    key: "_getScrollState",
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function _updateScrollState(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;
      var _this$props3 = this.props,
          isControlled = _this$props3.isControlled,
          onScrollToChange = _this$props3.onScrollToChange;

      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }

      if (!isControlled) {
        this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return {};
      }

      if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
        return ArrowKeyStepper_objectSpread({}, prevState, {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow,
          instanceProps: {
            prevScrollToColumn: nextProps.scrollToColumn,
            prevScrollToRow: nextProps.scrollToRow
          }
        });
      }

      return {};
    }
  }]);

  return ArrowKeyStepper;
}(react.PureComponent), (0,esm_defineProperty/* default */.Z)(ArrowKeyStepper_class, "propTypes",  true ? null : 0), ArrowKeyStepper_temp);

(0,esm_defineProperty/* default */.Z)(ArrowKeyStepper, "defaultProps", {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
});

polyfill(ArrowKeyStepper);
/* harmony default export */ var ArrowKeyStepper_ArrowKeyStepper = ((/* unused pure expression or super */ null && (ArrowKeyStepper)));



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/index.js




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/detectElementResize.js
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = __webpack_require__.g;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/AutoSizer/AutoSizer.js








var AutoSizer_class, AutoSizer_temp;

function AutoSizer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AutoSizer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AutoSizer_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AutoSizer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var AutoSizer = (AutoSizer_temp = AutoSizer_class =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_parentNode", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_autoSizer", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_window", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_detectElementResize", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });

    return _this;
  }

  createClass_createClass(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = createDetectElementResize(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return react.createElement("div", {
        className: className,
        ref: this._setRef,
        style: AutoSizer_objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);

  return AutoSizer;
}(react.Component), (0,esm_defineProperty/* default */.Z)(AutoSizer_class, "propTypes",  true ? null : 0), AutoSizer_temp);

(0,esm_defineProperty/* default */.Z)(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/AutoSizer/index.js


// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/types.js
var bpfrpt_proptype_CellMeasureCache =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurer.js








var CellMeasurer_class, CellMeasurer_temp;




/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer_CellMeasurer = (CellMeasurer_temp = CellMeasurer_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, CellMeasurer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CellMeasurer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_child", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_measure", function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('CellMeasurer registerChild expects to be passed Element or null');
      }

      _this._child = element;

      if (element) {
        _this._maybeMeasureCell();
      }
    });

    return _this;
  }

  createClass_createClass(CellMeasurer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? children({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children;
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache = this.props.cache;
      var node = this._child || (0,react_dom.findDOMNode)(this); // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height; // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.

        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }

        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth); // Reset after measuring to avoid breaking styles; see #660

        if (styleWidth) {
          node.style.width = styleWidth;
        }

        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return {
          height: height,
          width: width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props,
          cache = _this$props2.cache,
          _this$props2$columnIn = _this$props2.columnIndex,
          columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn,
          parent = _this$props2.parent,
          _this$props2$rowIndex = _this$props2.rowIndex,
          rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;

      if (!cache.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(),
            height = _this$_getCellMeasure2.height,
            width = _this$_getCellMeasure2.width;

        cache.set(rowIndex, columnIndex, width, height); // If size has changed, let Grid know to re-render.

        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(react.PureComponent), (0,esm_defineProperty/* default */.Z)(CellMeasurer_class, "propTypes",  true ? null : 0), CellMeasurer_temp); // Used for DEV mode warning check

(0,esm_defineProperty/* default */.Z)(CellMeasurer_CellMeasurer, "__internalCellMeasurerFlag", false);



if (false) {}



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurerCache.js



var DEFAULT_HEIGHT = 30;
var DEFAULT_WIDTH = 100; // Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache_CellMeasurerCache =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CellMeasurerCache);

    _defineProperty(this, "_cellHeightCache", {});

    _defineProperty(this, "_cellWidthCache", {});

    _defineProperty(this, "_columnWidthCache", {});

    _defineProperty(this, "_rowHeightCache", {});

    _defineProperty(this, "_defaultHeight", void 0);

    _defineProperty(this, "_defaultWidth", void 0);

    _defineProperty(this, "_minHeight", void 0);

    _defineProperty(this, "_minWidth", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    _defineProperty(this, "_hasFixedHeight", void 0);

    _defineProperty(this, "_hasFixedWidth", void 0);

    _defineProperty(this, "_columnCount", 0);

    _defineProperty(this, "_rowCount", 0);

    _defineProperty(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
    });

    _defineProperty(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
    });

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;
    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;
    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {}
  }

  _createClass(CellMeasurerCache, [{
    key: "clear",
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }

      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      } // Size is cached per cell so we don't have to re-measure if cells are re-ordered.


      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;

        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }

        var columnKey = this._keyMapper(0, columnIndex);

        this._columnWidthCache[columnKey] = columnWidth;
      }

      if (!this._hasFixedHeight) {
        var rowHeight = 0;

        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }

        var rowKey = this._keyMapper(rowIndex, 0);

        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}()));



function defaultKeyMapper(rowIndex, columnIndex) {
  return "".concat(rowIndex, "-").concat(columnIndex);
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/index.js


/* harmony default export */ var es_CellMeasurer = ((/* unused pure expression or super */ null && (CellMeasurer)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/CollectionView.js








function CollectionView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CollectionView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CollectionView_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CollectionView_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var IS_SCROLLING_TIMEOUT = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var CollectionView_SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};
/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, CollectionView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollectionView)).call.apply(_getPrototypeOf2, [this].concat(args))); // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_calculateSizeAndPositionDataOnNextUpdate", false);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onSectionRenderedMemoizer", createCallbackMemoizer());

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invokeOnSectionRenderedHelper", function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;

      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_updateScrollPositionForScrollToCell", function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;

      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._enablePointerEventsAfterDelay(); // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.


      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;
      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop)); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? CollectionView_SCROLL_POSITION_CHANGE_REASONS.OBSERVED : CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED; // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)

        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    });

    _this._scrollbarSize = scrollbarSize();

    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }

    return _this;
  }
  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  createClass_createClass(CollectionView, [{
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          cellLayoutManager = _this$props4.cellLayoutManager,
          scrollLeft = _this$props4.scrollLeft,
          scrollToCell = _this$props4.scrollToCell,
          scrollTop = _this$props4.scrollTop; // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = scrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      } // Update onSectionRendered callback.


      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width; // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props,
          height = _this$props5.height,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToCell = _this$props5.scrollToCell,
          width = _this$props5.width;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollPositionChangeReason = _this$state2.scrollPositionChangeReason,
          scrollTop = _this$state2.scrollTop; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Update scroll offsets if the current :scrollToCell values requires it


      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoHeight = _this$props6.autoHeight,
          cellCount = _this$props6.cellCount,
          cellLayoutManager = _this$props6.cellLayoutManager,
          className = _this$props6.className,
          height = _this$props6.height,
          horizontalOverscanSize = _this$props6.horizontalOverscanSize,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          style = _this$props6.style,
          verticalOverscanSize = _this$props6.verticalOverscanSize,
          width = _this$props6.width;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollLeft = _this$state3.scrollLeft,
          scrollTop = _this$state3.scrollTop; // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;
        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width; // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];
      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      }; // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0; // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23

      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      return react.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Collection', className),
        id: id,
        onScroll: this._onScroll,
        role: "grid",
        style: CollectionView_objectSpread({}, collectionStyle, {}, style),
        tabIndex: 0
      }, cellCount > 0 && react.createElement("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: totalHeight,
          maxHeight: totalHeight,
          maxWidth: totalWidth,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          width: totalWidth
        }
      }, childrenToDisplay), cellCount === 0 && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;
        isScrollingChange(false);
        _this2._disablePointerEventsTimeoutId = null;

        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;

      var scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          totalHeight = _ref.totalHeight,
          totalWidth = _ref.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft = _ref2.scrollLeft,
              scrollTop = _ref2.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;
      var newState = {
        scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(react.PureComponent);

(0,esm_defineProperty/* default */.Z)(CollectionView, "defaultProps", {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});

CollectionView.propTypes =  false ? 0 : {};
polyfill(CollectionView);
/* harmony default export */ var Collection_CollectionView = (CollectionView);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/types.js
var bpfrpt_proptype_Index =  true ? null : 0;
var bpfrpt_proptype_PositionInfo =  true ? null : 0;
var bpfrpt_proptype_ScrollPosition =  true ? null : 0;
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : 0;
var bpfrpt_proptype_SizeInfo =  true ? null : 0;






;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/Section.js



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section =
/*#__PURE__*/
function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    classCallCheck_classCallCheck(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;
    this._indexMap = {};
    this._indices = [];
  }
  /** Add a cell to this section. */


  createClass_createClass(Section, [{
    key: "addCellIndex",
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;

        this._indices.push(index);
      }
    }
    /** Get all cell indices that have been added to this section. */

  }, {
    key: "getCellIndices",
    value: function getCellIndices() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);

  return Section;
}();




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/SectionManager.js



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */

var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager =
/*#__PURE__*/
function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    classCallCheck_classCallCheck(this, SectionManager);

    this._sectionSize = sectionSize;
    this._cellMetadata = [];
    this._sections = {};
  }
  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  createClass_createClass(SectionManager, [{
    key: "getCellIndices",
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;
      var indices = {};
      this.getSections({
        height: height,
        width: width,
        x: x,
        y: y
      }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      }); // Object keys are strings; this function returns numbers

      return Object.keys(indices).map(function (index) {
        return indices[index];
      });
    }
    /** Get size and position information for the cell specified. */

  }, {
    key: "getCellMetadata",
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;
      return this._cellMetadata[index];
    }
    /** Get all Sections overlapping the specified region. */

  }, {
    key: "getSections",
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;
      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = "".concat(sectionX, ".").concat(sectionY);

          if (!this._sections[key]) {
            this._sections[key] = new Section({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }
    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: "getTotalSectionCount",
    value: function getTotalSectionCount() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      var _this = this;

      return Object.keys(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: "registerCell",
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;
      this._cellMetadata[index] = cellMetadatum;
      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({
          index: index
        });
      });
    }
  }]);

  return SectionManager;
}();




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/utils/calculateSizeAndPositionData.js

function calculateSizeAndPositionData_calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;
  var cellMetadata = [];
  var sectionManager = new SectionManager(sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({
      index: index
    });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/getUpdatedOffsetForIndex.js
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;
  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;

    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/Collection.js














/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection_Collection =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Collection, _React$PureComponent);

  function Collection(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, Collection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collection).call(this, props, context));
    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = []; // Cell cache during scroll (for performance)

    _this._cellCache = [];
    _this._isScrollingChange = _this._isScrollingChange.bind(_assertThisInitialized(_this));
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(Collection, [{
    key: "forceUpdate",
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }
    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];

      this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */

  }, {
    key: "render",
    value: function render() {
      var props = (0,esm_extends/* default */.Z)({}, this.props);

      return react.createElement(Collection_CollectionView, (0,esm_extends/* default */.Z)({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }
    /** CellLayoutManager interface */

  }, {
    key: "calculateSizeAndPositionData",
    value: function calculateSizeAndPositionData() {
      var _this$props = this.props,
          cellCount = _this$props.cellCount,
          cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter,
          sectionSize = _this$props.sectionSize;

      var data = calculateSizeAndPositionData_calculateSizeAndPositionData({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: "getLastRenderedIndices",
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: "getScrollPositionForCell",
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;

      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];
        scrollLeft = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });
        scrollTop = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _this$props2 = this.props,
          cellGroupRenderer = _this$props2.cellGroupRenderer,
          cellRenderer = _this$props2.cellRenderer; // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });
      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({
            index: index
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: "_setCollectionViewRef",
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(react.PureComponent);

(0,esm_defineProperty/* default */.Z)(Collection_Collection, "defaultProps", {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
});


Collection_Collection.propTypes =  false ? 0 : {};

function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;
  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({
      index: index
    });
    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    }; // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.

    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/index.js

/* harmony default export */ var es_Collection = ((/* unused pure expression or super */ null && (Collection)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ColumnSizer/ColumnSizer.js








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer_ColumnSizer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, ColumnSizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColumnSizer).call(this, props, context));
    _this._registerChild = _this._registerChild.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(ColumnSizer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          columnMaxWidth = _this$props.columnMaxWidth,
          columnMinWidth = _this$props.columnMinWidth,
          columnCount = _this$props.columnCount,
          width = _this$props.width;

      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          columnMaxWidth = _this$props2.columnMaxWidth,
          columnMinWidth = _this$props2.columnMinWidth,
          columnCount = _this$props2.columnCount,
          width = _this$props2.width;
      var safeColumnMinWidth = columnMinWidth || 1;
      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);
      var adjustedWidth = Math.min(width, columnWidth * columnCount);
      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(react.PureComponent);


ColumnSizer_ColumnSizer.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ColumnSizer/index.js

/* harmony default export */ var es_ColumnSizer = ((/* unused pure expression or super */ null && (ColumnSizer)));

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/InfiniteLoader/InfiniteLoader.js











/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader_InfiniteLoader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, InfiniteLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InfiniteLoader).call(this, props, context));
    _this._loadMoreRowsMemoizer = createCallbackMemoizer();
    _this._onRowsRendered = _this._onRowsRendered.bind(_assertThisInitialized(_this));
    _this._registerChild = _this._registerChild.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(InfiniteLoader, [{
    key: "resetLoadMoreRowsCache",
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = createCallbackMemoizer();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;
      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);

        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;
      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: "_doStuff",
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
          _this3 = this;

      var _this$props = this.props,
          isRowLoaded = _this$props.isRowLoaded,
          minimumBatchSize = _this$props.minimumBatchSize,
          rowCount = _this$props.rowCount,
          threshold = _this$props.threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      }); // For memoize comparison

      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, toConsumableArray_toConsumableArray(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
            stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: {
          squashedUnloadedRanges: squashedUnloadedRanges
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(react.PureComponent);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


(0,esm_defineProperty/* default */.Z)(InfiniteLoader_InfiniteLoader, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});


InfiniteLoader_InfiniteLoader.propTypes =  false ? 0 : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
      startIndex = _ref4.startIndex,
      stopIndex = _ref4.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */

function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
      minimumBatchSize = _ref5.minimumBatchSize,
      rowCount = _ref5.rowCount,
      startIndex = _ref5.startIndex,
      stopIndex = _ref5.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({
      index: index
    });

    if (!loaded) {
      rangeStopIndex = index;

      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });
      rangeStartIndex = rangeStopIndex = null;
    }
  } // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.


  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({
        index: _index
      })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  } // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.


  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({
        index: _index2
      })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}
/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */

function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/InfiniteLoader/index.js

/* harmony default export */ var es_InfiniteLoader = ((/* unused pure expression or super */ null && (InfiniteLoader)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/types.js

var bpfrpt_proptype_RowRendererParams =  true ? null : 0;
var bpfrpt_proptype_RowRenderer =  true ? null : 0;
var bpfrpt_proptype_RenderedRows =  true ? null : 0;
var types_bpfrpt_proptype_Scroll =  true ? null : 0;





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/List.js









var List_class, List_temp;




/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List_List = (List_temp = List_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "Grid", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });

    return _this;
  }

  createClass_createClass(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = clsx_m('ReactVirtualized__List', className);
      return react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(react.PureComponent), (0,esm_defineProperty/* default */.Z)(List_class, "propTypes",  true ? null : 0), List_temp);

(0,esm_defineProperty/* default */.Z)(List_List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});














;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/index.js




;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function slicedToArray_slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/binarySearchBounds.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/
function _GEA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GEP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GTP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LTP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LEP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function _EQP(a, l, h, y, c) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);

    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ var binarySearchBounds = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/intervalTree.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);

  if (idx < 0) {
    return NOT_FOUND;
  }

  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);

  if (this.left) {
    this.left.intervals(result);
  }

  if (this.right) {
    this.right.intervals(result);
  }

  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;

  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin);
    var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;

  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }

    var rw = this.right ? this.right.count : 0;

    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.left.remove(interval);

    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }

    var lw = this.left ? this.left.count : 0;

    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.right.remove(interval);

    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }

    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;

        while (n.right) {
          p = n;
          n = n.right;
        }

        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }

        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }

      return SUCCESS;
    }

    for (var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }

      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);

        for (var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }

    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];

  if (d) {
    return d;
  }

  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];

  if (d) {
    return d;
  }

  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }

  var pts = [];

  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }

  pts.sort(compareNumbers);
  var mid = pts[pts.length >> 1];
  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];

  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];

    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  } //Split center intervals


  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);
  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
} //User friendly wrapper that makes it possible to support empty trees


function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);

    if (r === EMPTY) {
      this.root = null;
    }

    return r !== NOT_FOUND;
  }

  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }

    return 0;
  }
});
Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }

    return [];
  }
});
function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }

  return new IntervalTree(createIntervalTree(intervals));
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/PositionCache.js






// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache =
/*#__PURE__*/
function () {
  function PositionCache() {
    classCallCheck_classCallCheck(this, PositionCache);

    (0,esm_defineProperty/* default */.Z)(this, "_columnSizeMap", {});

    (0,esm_defineProperty/* default */.Z)(this, "_intervalTree", createWrapper());

    (0,esm_defineProperty/* default */.Z)(this, "_leftMap", {});
  }

  createClass_createClass(PositionCache, [{
    key: "estimateTotalHeight",
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    } // Render all cells visible within the viewport range defined.

  }, {
    key: "range",
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = slicedToArray_slicedToArray(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);

      this._leftMap[index] = left;
      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];

      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: "count",
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: "tallestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/Masonry.js








var Masonry_class, Masonry_temp;

function Masonry_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Masonry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Masonry_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Masonry_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var emptyObject = {};
/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry_Masonry = (Masonry_temp = Masonry_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Masonry, _React$PureComponent);

  function Masonry() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, Masonry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Masonry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      isScrolling: false,
      scrollTop: 0
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_debounceResetIsScrollingId", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invalidateOnUpdateStartIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invalidateOnUpdateStopIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_positionCache", new PositionCache());

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_startIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_startIndexMemoized", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_stopIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_stopIndexMemoized", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_debounceResetIsScrollingCallback", function () {
      _this.setState({
        isScrolling: false
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (event) {
      var height = _this.props.height;
      var eventScrollTop = event.currentTarget.scrollTop; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop); // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.

      if (eventScrollTop !== scrollTop) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._debounceResetIsScrolling(); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.


      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    });

    return _this;
  }

  createClass_createClass(Masonry, [{
    key: "clearCellPositions",
    value: function clearCellPositions() {
      this._positionCache = new PositionCache();
      this.forceUpdate();
    } // HACK This method signature was intended for Grid

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref) {
      var index = _ref.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: "recomputeCellPositions",
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;
      this._positionCache = new PositionCache();

      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          cellCount = _this$props.cellCount,
          cellMeasurerCache = _this$props.cellMeasurerCache,
          cellRenderer = _this$props.cellRenderer,
          className = _this$props.className,
          height = _this$props.height,
          id = _this$props.id,
          keyMapper = _this$props.keyMapper,
          overscanByPixels = _this$props.overscanByPixels,
          role = _this$props.role,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex,
          width = _this$props.width,
          rowDirection = _this$props.rowDirection;
      var _this$state = this.state,
          isScrolling = _this$state.isScrolling,
          scrollTop = _this$state.scrollTop;
      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;
      var startIndex = 0;
      var stopIndex;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, (0,esm_defineProperty/* default */.Z)(_style, rowDirection === 'ltr' ? 'left' : 'right', left), (0,esm_defineProperty/* default */.Z)(_style, "position", 'absolute'), (0,esm_defineProperty/* default */.Z)(_style, "top", top), (0,esm_defineProperty/* default */.Z)(_style, "width", cellMeasurerCache.getWidth(index)), _style)
        }));
      }); // We need to measure additional cells for this layout


      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;
          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;
      return react.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Masonry', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: Masonry_objectSpread({
          boxSizing: 'border-box',
          direction: 'ltr',
          height: autoHeight ? 'auto' : height,
          overflowX: 'hidden',
          overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
          position: 'relative',
          width: width,
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform'
        }, style),
        tabIndex: tabIndex
      }, react.createElement("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: '100%',
          height: estimateTotalHeight,
          maxWidth: '100%',
          maxHeight: estimateTotalHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }
      }, children));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var startIndex = this._invalidateOnUpdateStartIndex;
        var stopIndex = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null; // Query external layout logic for position of newly-measured cells

        this._populatePositionCache(startIndex, stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = requestAnimationTimeout(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function _getEstimatedTotalHeight() {
      var _this$props2 = this.props,
          cellCount = _this$props2.cellCount,
          cellMeasurerCache = _this$props2.cellMeasurerCache,
          width = _this$props2.width;
      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function _invokeOnScrollCallback() {
      var _this$props3 = this.props,
          height = _this$props3.height,
          onScroll = _this$props3.onScroll;
      var scrollTop = this.state.scrollTop;

      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });
        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var onCellsRendered = this.props.onCellsRendered;
        onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });
        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _this$props4 = this.props,
          cellMeasurerCache = _this$props4.cellMeasurerCache,
          cellPositioner = _this$props4.cellPositioner;

      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            left = _cellPositioner.left,
            top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(react.PureComponent), (0,esm_defineProperty/* default */.Z)(Masonry_class, "propTypes",  true ? null : 0), Masonry_temp);

(0,esm_defineProperty/* default */.Z)(Masonry_Masonry, "defaultProps", {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
});

function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : 0;
polyfill(Masonry_Masonry);
/* harmony default export */ var es_Masonry_Masonry = ((/* unused pure expression or super */ null && (Masonry_Masonry)));
var bpfrpt_proptype_Positioner =  true ? null : 0;




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/createCellPositioner.js
function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === void 0 ? 0 : _ref$spacer;
  var columnHeights;
  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;

    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;
    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];

    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;
    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;
  return cellPositioner;
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/index.js


/* harmony default export */ var es_Masonry = ((/* unused pure expression or super */ null && (Masonry)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/CellMeasurerCacheDecorator.js





/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator =
/*#__PURE__*/
function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck_classCallCheck(this, CellMeasurerCacheDecorator);

    (0,esm_defineProperty/* default */.Z)(this, "_cellMeasurerCache", void 0);

    (0,esm_defineProperty/* default */.Z)(this, "_columnIndexOffset", void 0);

    (0,esm_defineProperty/* default */.Z)(this, "_rowIndexOffset", void 0);

    (0,esm_defineProperty/* default */.Z)(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    });

    (0,esm_defineProperty/* default */.Z)(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    });

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  createClass_createClass(CellMeasurerCacheDecorator, [{
    key: "clear",
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/MultiGrid.js










function MultiGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MultiGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MultiGrid_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MultiGrid_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var SCROLLBAR_SIZE_BUFFER = 20;
/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid_MultiGrid =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, MultiGrid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiGrid).call(this, props, context));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateColumnIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateRowIndex", null);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_bottomLeftGridRef", function (ref) {
      _this._bottomLeftGrid = ref;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_bottomRightGridRef", function (ref) {
      _this._bottomRightGrid = ref;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRendererBottomLeftGrid", function (_ref) {
      var rowIndex = _ref.rowIndex,
          rest = objectWithoutProperties_objectWithoutProperties(_ref, ["rowIndex"]);

      var _this$props = _this.props,
          cellRenderer = _this$props.cellRenderer,
          fixedRowCount = _this$props.fixedRowCount,
          rowCount = _this$props.rowCount;

      if (rowIndex === rowCount - fixedRowCount) {
        return react.createElement("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          parent: _assertThisInitialized(_this),
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRendererBottomRightGrid", function (_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex,
          rest = objectWithoutProperties_objectWithoutProperties(_ref2, ["columnIndex", "rowIndex"]);

      var _this$props2 = _this.props,
          cellRenderer = _this$props2.cellRenderer,
          fixedColumnCount = _this$props2.fixedColumnCount,
          fixedRowCount = _this$props2.fixedRowCount;
      return cellRenderer(MultiGrid_objectSpread({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _assertThisInitialized(_this),
        rowIndex: rowIndex + fixedRowCount
      }));
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRendererTopRightGrid", function (_ref3) {
      var columnIndex = _ref3.columnIndex,
          rest = objectWithoutProperties_objectWithoutProperties(_ref3, ["columnIndex"]);

      var _this$props3 = _this.props,
          cellRenderer = _this$props3.cellRenderer,
          columnCount = _this$props3.columnCount,
          fixedColumnCount = _this$props3.fixedColumnCount;

      if (columnIndex === columnCount - fixedColumnCount) {
        return react.createElement("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: _assertThisInitialized(_this)
        }));
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnWidthRightGrid", function (_ref4) {
      var index = _ref4.index;
      var _this$props4 = _this.props,
          columnCount = _this$props4.columnCount,
          fixedColumnCount = _this$props4.fixedColumnCount,
          columnWidth = _this$props4.columnWidth;
      var _this$state = _this.state,
          scrollbarSize = _this$state.scrollbarSize,
          showHorizontalScrollbar = _this$state.showHorizontalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
        return scrollbarSize;
      }

      return typeof columnWidth === 'function' ? columnWidth({
        index: index + fixedColumnCount
      }) : columnWidth;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft,
          scrollTop = scrollInfo.scrollTop;

      _this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      var onScroll = _this.props.onScroll;

      if (onScroll) {
        onScroll(scrollInfo);
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollbarPresenceChange", function (_ref5) {
      var horizontal = _ref5.horizontal,
          size = _ref5.size,
          vertical = _ref5.vertical;
      var _this$state2 = _this.state,
          showHorizontalScrollbar = _this$state2.showHorizontalScrollbar,
          showVerticalScrollbar = _this$state2.showVerticalScrollbar;

      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
        _this.setState({
          scrollbarSize: size,
          showHorizontalScrollbar: horizontal,
          showVerticalScrollbar: vertical
        });

        var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;

        if (typeof onScrollbarPresenceChange === 'function') {
          onScrollbarPresenceChange({
            horizontal: horizontal,
            size: size,
            vertical: vertical
          });
        }
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollLeft", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;

      _this._onScroll({
        scrollLeft: scrollLeft,
        scrollTop: _this.state.scrollTop
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollTop", function (scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;

      _this._onScroll({
        scrollTop: scrollTop,
        scrollLeft: _this.state.scrollLeft
      });
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowHeightBottomGrid", function (_ref6) {
      var index = _ref6.index;
      var _this$props5 = _this.props,
          fixedRowCount = _this$props5.fixedRowCount,
          rowCount = _this$props5.rowCount,
          rowHeight = _this$props5.rowHeight;
      var _this$state3 = _this.state,
          scrollbarSize = _this$state3.scrollbarSize,
          showVerticalScrollbar = _this$state3.showVerticalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
        return scrollbarSize;
      }

      return typeof rowHeight === 'function' ? rowHeight({
        index: index + fixedRowCount
      }) : rowHeight;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_topLeftGridRef", function (ref) {
      _this._topLeftGrid = ref;
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_topRightGridRef", function (ref) {
      _this._topRightGrid = ref;
    });

    var deferredMeasurementCache = props.deferredMeasurementCache,
        _fixedColumnCount = props.fixedColumnCount,
        _fixedRowCount = props.fixedRowCount;

    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }

    return _this;
  }

  createClass_createClass(MultiGrid, [{
    key: "forceUpdateGrids",
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$columnIndex = _ref8.columnIndex,
          columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex,
          _ref8$rowIndex = _ref8.rowIndex,
          rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;

      var _this$props6 = this.props,
          fixedColumnCount = _this$props6.fixedColumnCount,
          fixedRowCount = _this$props6.fixedRowCount;
      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });
      this._leftGridWidth = null;
      this._topGridHeight = null;

      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          scrollLeft = _this$props7.scrollLeft,
          scrollTop = _this$props7.scrollTop;

      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }

      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          onScroll = _this$props8.onScroll,
          onSectionRendered = _this$props8.onSectionRendered,
          onScrollbarPresenceChange = _this$props8.onScrollbarPresenceChange,
          scrollLeftProp = _this$props8.scrollLeft,
          scrollToColumn = _this$props8.scrollToColumn,
          scrollTopProp = _this$props8.scrollTop,
          scrollToRow = _this$props8.scrollToRow,
          rest = objectWithoutProperties_objectWithoutProperties(_this$props8, ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"]);

      this._prepareForRender(); // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.


      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      } // scrollTop and scrollLeft props are explicitly filtered out and ignored


      var _this$state4 = this.state,
          scrollLeft = _this$state4.scrollLeft,
          scrollTop = _this$state4.scrollTop;
      return react.createElement("div", {
        style: this._containerOuterStyle
      }, react.createElement("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(rest), this._renderTopRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollLeft: scrollLeft
      }))), react.createElement("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollTop: scrollTop
      })), this._renderBottomRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        onSectionRendered: onSectionRendered,
        scrollLeft: scrollLeft,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow,
        scrollTop: scrollTop
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function _getBottomGridHeight(props) {
      var height = props.height;

      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;

      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({
              index: index
            });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function _getRightGridWidth(props) {
      var width = props.width;

      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: "_getTopGridHeight",
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;

      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({
              index: index
            });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: "_maybeCalculateCachedStyles",
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _this$props9 = this.props,
          columnWidth = _this$props9.columnWidth,
          enableFixedColumnScroll = _this$props9.enableFixedColumnScroll,
          enableFixedRowScroll = _this$props9.enableFixedRowScroll,
          height = _this$props9.height,
          fixedColumnCount = _this$props9.fixedColumnCount,
          fixedRowCount = _this$props9.fixedRowCount,
          rowHeight = _this$props9.rowHeight,
          style = _this$props9.style,
          styleBottomLeftGrid = _this$props9.styleBottomLeftGrid,
          styleBottomRightGrid = _this$props9.styleBottomRightGrid,
          styleTopLeftGrid = _this$props9.styleTopLeftGrid,
          styleTopRightGrid = _this$props9.styleTopRightGrid,
          width = _this$props9.width;
      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = MultiGrid_objectSpread({
          height: height,
          overflow: 'visible',
          // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };
        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible',
          // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: "_prepareForRender",
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;

      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return react.createElement("div", {
          className: "BottomLeftGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._bottomLeftGridStyle, {
            height: height,
            width: width,
            overflowY: 'hidden'
          })
        }, bottomLeftGrid);
      }

      return bottomLeftGrid;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;
      return react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;

      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _this$state5 = this.state,
          showHorizontalScrollbar = _this$state5.showHorizontalScrollbar,
          scrollbarSize = _this$state5.scrollbarSize;

      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = MultiGrid_objectSpread({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return react.createElement("div", {
          className: "TopRightGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._topRightGridStyle, {
            height: height,
            width: width,
            overflowX: 'hidden'
          })
        }, topRightGrid);
      }

      return topRightGrid;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(react.PureComponent);

(0,esm_defineProperty/* default */.Z)(MultiGrid_MultiGrid, "defaultProps", {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
});

MultiGrid_MultiGrid.propTypes =  false ? 0 : {};
polyfill(MultiGrid_MultiGrid);
/* harmony default export */ var es_MultiGrid_MultiGrid = ((/* unused pure expression or super */ null && (MultiGrid_MultiGrid)));
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/index.js

/* harmony default export */ var es_MultiGrid = ((/* unused pure expression or super */ null && (MultiGrid)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ScrollSync/ScrollSync.js








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync_ScrollSync =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, ScrollSync);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollSync).call(this, props, context));
    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };
    _this._onScroll = _this._onScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(ScrollSync, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          clientHeight = _this$state.clientHeight,
          clientWidth = _this$state.clientWidth,
          scrollHeight = _this$state.scrollHeight,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop,
          scrollWidth = _this$state.scrollWidth;
      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;
      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(react.PureComponent);


ScrollSync_ScrollSync.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ScrollSync/index.js

/* harmony default export */ var es_ScrollSync = ((/* unused pure expression or super */ null && (ScrollSync)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/types.js
var bpfrpt_proptype_CellDataGetterParams =  true ? null : 0;
var types_bpfrpt_proptype_CellRendererParams =  true ? null : 0;
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : 0;
var bpfrpt_proptype_HeaderRendererParams =  true ? null : 0;
var types_bpfrpt_proptype_RowRendererParams =  true ? null : 0;






;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultCellDataGetter.js
/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultCellRenderer.js
/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultHeaderRowRenderer.js

function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;
  return react.createElement("div", {
    className: className,
    role: "row",
    style: style
  }, columns);
}
defaultHeaderRowRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/SortDirection.js
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};
/* harmony default export */ var Table_SortDirection = (SortDirection);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/SortIndicator.js




/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */

function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;
  var classNames = clsx_m('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === Table_SortDirection.ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === Table_SortDirection.DESC
  });
  return react.createElement("svg", {
    className: classNames,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, sortDirection === Table_SortDirection.ASC ? react.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }) : react.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), react.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
SortIndicator.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultHeaderRenderer.js



/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;
  var showSortIndicator = sortBy === dataKey;
  var children = [react.createElement("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof label === 'string' ? label : null
  }, label)];

  if (showSortIndicator) {
    children.push(react.createElement(SortIndicator, {
      key: "SortIndicator",
      sortDirection: sortDirection
    }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultRowRenderer.js



/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;
  var a11yProps = {
    'aria-rowindex': index + 1
  };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
  }

  return react.createElement("div", (0,esm_extends/* default */.Z)({}, a11yProps, {
    className: className,
    key: key,
    role: "row",
    style: style
  }), columns);
}
defaultRowRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/Column.js











/**
 * Describes the header and cell contents of a table column.
 */

var Column =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Column, _React$Component);

  function Column() {
    classCallCheck_classCallCheck(this, Column);

    return _possibleConstructorReturn(this, _getPrototypeOf(Column).apply(this, arguments));
  }

  return Column;
}(react.Component);

(0,esm_defineProperty/* default */.Z)(Column, "defaultProps", {
  cellDataGetter: defaultCellDataGetter,
  cellRenderer: defaultCellRenderer,
  defaultSortDirection: Table_SortDirection.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: defaultHeaderRenderer,
  style: {}
});


Column.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/Table.js









function Table_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Table_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Table_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Table_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table_Table =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Table, _React$PureComponent);

  function Table(props) {
    var _this;

    classCallCheck_classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
    _this.state = {
      scrollbarWidth: 0
    };
    _this._createColumn = _this._createColumn.bind(_assertThisInitialized(_this));
    _this._createRow = _this._createRow.bind(_assertThisInitialized(_this));
    _this._onScroll = _this._onScroll.bind(_assertThisInitialized(_this));
    _this._onSectionRendered = _this._onSectionRendered.bind(_assertThisInitialized(_this));
    _this._setRef = _this._setRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(Table, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.Grid) {
        var _Grid = (0,react_dom.findDOMNode)(this.Grid);

        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }

      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disableHeader = _this$props.disableHeader,
          gridClassName = _this$props.gridClassName,
          gridStyle = _this$props.gridStyle,
          headerHeight = _this$props.headerHeight,
          headerRowRenderer = _this$props.headerRowRenderer,
          height = _this$props.height,
          id = _this$props.id,
          noRowsRenderer = _this$props.noRowsRenderer,
          rowClassName = _this$props.rowClassName,
          rowStyle = _this$props.rowStyle,
          scrollToIndex = _this$props.scrollToIndex,
          style = _this$props.style,
          width = _this$props.width;
      var scrollbarWidth = this.state.scrollbarWidth;
      var availableRowsHeight = disableHeader ? height : height - headerHeight;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: -1
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: -1
      }) : rowStyle; // Precompute and cache column styles before rendering rows and columns to speed things up

      this._cachedColumnStyles = [];
      react.Children.toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = Table_objectSpread({
          overflow: 'hidden'
        }, flexStyles);
      }); // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.

      return react.createElement("div", {
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-colcount": react.Children.toArray(children).length,
        "aria-rowcount": this.props.rowCount,
        className: clsx_m('ReactVirtualized__Table', className),
        id: id,
        role: "grid",
        style: style
      }, !disableHeader && headerRowRenderer({
        className: clsx_m('ReactVirtualized__Table__headerRow', rowClass),
        columns: this._getHeaderColumns(),
        style: Table_objectSpread({
          height: headerHeight,
          overflow: 'hidden',
          paddingRight: scrollbarWidth,
          width: width
        }, rowStyleObject)
      }), react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, this.props, {
        "aria-readonly": null,
        autoContainerWidth: true,
        className: clsx_m('ReactVirtualized__Table__Grid', gridClassName),
        cellRenderer: this._createRow,
        columnWidth: width,
        columnCount: 1,
        height: availableRowsHeight,
        id: undefined,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: scrollbarWidth,
        scrollToRow: scrollToIndex,
        style: Table_objectSpread({}, gridStyle, {
          overflowX: 'hidden'
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;
      var cellData = cellDataGetter({
        columnData: columnData,
        dataKey: dataKey,
        rowData: rowData
      });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({
          columnData: columnData,
          dataKey: dataKey,
          event: event
        });
      };

      var style = this._cachedColumnStyles[columnIndex];
      var title = typeof renderedCell === 'string' ? renderedCell : null; // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942

      return react.createElement("div", {
        "aria-colindex": columnIndex + 1,
        "aria-describedby": id,
        className: clsx_m('ReactVirtualized__Table__rowColumn', className),
        key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
        onClick: onClick,
        role: "gridcell",
        style: style,
        title: title
      }, renderedCell);
    }
  }, {
    key: "_createHeader",
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _this$props2 = this.props,
          headerClassName = _this$props2.headerClassName,
          headerStyle = _this$props2.headerStyle,
          onHeaderClick = _this$props2.onHeaderClick,
          sort = _this$props2.sort,
          sortBy = _this$props2.sortBy,
          sortDirection = _this$props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;
      var sortEnabled = !disableSort && sort;
      var classNames = clsx_m('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });

      var style = this._getFlexStyleForColumn(column, Table_objectSpread({}, headerStyle, {}, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });
      var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey; // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.

        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === Table_SortDirection.DESC ? Table_SortDirection.ASC : Table_SortDirection.DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({
            columnData: columnData,
            dataKey: dataKey,
            event: event
          });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === Table_SortDirection.ASC ? 'ascending' : 'descending';
      } // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942


      return react.createElement("div", {
        "aria-label": headerAriaLabel,
        "aria-sort": headerAriaSort,
        className: classNames,
        id: id,
        key: 'Header-Col' + index,
        onClick: headerOnClick,
        onKeyDown: headerOnKeyDown,
        role: "columnheader",
        style: style,
        tabIndex: headerTabIndex
      }, renderedHeader);
    }
  }, {
    key: "_createRow",
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _this$props3 = this.props,
          children = _this$props3.children,
          onRowClick = _this$props3.onRowClick,
          onRowDoubleClick = _this$props3.onRowDoubleClick,
          onRowRightClick = _this$props3.onRowRightClick,
          onRowMouseOver = _this$props3.onRowMouseOver,
          onRowMouseOut = _this$props3.onRowMouseOut,
          rowClassName = _this$props3.rowClassName,
          rowGetter = _this$props3.rowGetter,
          rowRenderer = _this$props3.rowRenderer,
          rowStyle = _this$props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: index
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: index
      }) : rowStyle;
      var rowData = rowGetter({
        index: index
      });
      var columns = react.Children.toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });
      var className = clsx_m('ReactVirtualized__Table__row', rowClass);

      var flattenedStyle = Table_objectSpread({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: "_getFlexStyleForColumn",
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");

      var style = Table_objectSpread({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: "_getHeaderColumns",
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          disableHeader = _this$props4.disableHeader;
      var items = disableHeader ? [] : react.Children.toArray(children);
      return items.map(function (column, index) {
        return _this4._createHeader({
          column: column,
          index: index
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;
      return typeof rowHeight === 'function' ? rowHeight({
        index: rowIndex
      }) : rowHeight;
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: "_setRef",
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: scrollbarWidth
      });
    }
  }]);

  return Table;
}(react.PureComponent);

(0,esm_defineProperty/* default */.Z)(Table_Table, "defaultProps", {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  rowRenderer: defaultRowRenderer,
  headerRowRenderer: defaultHeaderRowRenderer,
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});


Table_Table.propTypes =  false ? 0 : {};

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/index.js










/* harmony default export */ var es_Table = ((/* unused pure expression or super */ null && (Table)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/utils/onScroll.js

var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    cancelAnimationTimeout(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });
  disablePointerEventsTimeoutId = requestAnimationTimeout(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
  }

  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }

  mountedInstances.push(component);
}
function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });

  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);

    if (disablePointerEventsTimeoutId) {
      cancelAnimationTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/utils/dimensions.js
/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
// TODO Move this into WindowScroller and import from there
var isWindow = function isWindow(element) {
  return element === window;
};

var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;
    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}
/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */

function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);

    var _elementRect = getBoundingBox(element);

    var _containerRect = getBoundingBox(container);

    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}
/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */

function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/WindowScroller.js








var WindowScroller_class, WindowScroller_temp;

function WindowScroller_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WindowScroller_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WindowScroller_ownKeys(source, true).forEach(function (key) { (0,esm_defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WindowScroller_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var WindowScroller_IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller_WindowScroller = (WindowScroller_temp = WindowScroller_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, WindowScroller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WindowScroller)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_window", getWindow());

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_isMounted", false);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_positionFromTop", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_positionFromLeft", 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_detectElementResize", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_child", void 0);

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", WindowScroller_objectSpread({}, getDimensions(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }));

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }

      _this._child = element;

      _this.updatePosition();
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onChildScroll", function (_ref) {
      var scrollTop = _ref.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_registerResizeListener", function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_unregisterResizeListener", function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onResize", function () {
      _this.updatePosition();
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "__handleWindowScrollEvent", function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;
      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        var scrollOffset = getScrollOffset(scrollElement);
        var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        onScroll({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      }
    });

    (0,esm_defineProperty/* default */.Z)(_assertThisInitialized(_this), "__resetIsScrolling", function () {
      _this.setState({
        isScrolling: false
      });
    });

    return _this;
  }

  createClass_createClass(WindowScroller, [{
    key: "updatePosition",
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width;
      var thisNode = this._child || react_dom.findDOMNode(this);

      if (thisNode instanceof Element && scrollElement) {
        var offset = getPositionOffset(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = getDimensions(scrollElement, this.props);

      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;
      this._detectElementResize = createDetectElementResize();
      this.updatePosition(scrollElement);

      if (scrollElement) {
        registerScrollListener(this, scrollElement);

        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;

      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);
        unregisterScrollListener(this, prevScrollElement);
        registerScrollListener(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);

        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;

      if (scrollElement) {
        unregisterScrollListener(this, scrollElement);

        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state2 = this.state,
          isScrolling = _this$state2.isScrolling,
          scrollTop = _this$state2.scrollTop,
          scrollLeft = _this$state2.scrollLeft,
          height = _this$state2.height,
          width = _this$state2.width;
      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }
  }]);

  return WindowScroller;
}(react.PureComponent), (0,esm_defineProperty/* default */.Z)(WindowScroller_class, "propTypes",  true ? null : 0), WindowScroller_temp);

(0,esm_defineProperty/* default */.Z)(WindowScroller_WindowScroller, "defaultProps", {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: WindowScroller_IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
});



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/index.js

/* harmony default export */ var es_WindowScroller = ((/* unused pure expression or super */ null && (WindowScroller)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/index.js













;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToolTipComp/ToolTipComp.style.ts

var ToolTipComp_style_ToolTipCompWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ToolTipCompstyle__ToolTipCompWrapper",
  componentId: "sc-7xkig7-0"
})(["position:absolute;background:#1a7971;border:4px solid #1a7971;left:", ";right:", ";top:", ";bottom:", ";width:", ";font-size:14px;line-height:20px;padding:8px;border-radius:4px;gap:20px;z-index:1;color:#ffffff;&:after,&:before{border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(0,0,0,0);border-width:13px;}&:before{border-color:rgba(0,0,0,0);border-width:13px;}", " ", " ", " ", ""], function (props) {
  return props.left;
}, function (props) {
  return props.right;
}, function (props) {
  return props.top;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.width;
}, function (props) {
  return props.toolTipArrow == "top" && "\n&:after, &:before {\n\tbottom: 100%;\n\tleft: 50%;\n}\n\n&:after {\n\tborder-bottom-color: #1A7971;\n\tmargin-top: -30px;\n}\n&:before {\n\tborder-bottom-color: #1A7971;\n\tmargin-top: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "bottom" && "\n&:after, &:before {\n\ttop: 100%;\n\tleft: 50%;\n}\n\n&:after {\n\tborder-top-color: #1A7971;;\n\tmargin-left: -34px;\n}\n&:before {\n\tborder-top-color: #1A7971;\n\tmargin-left: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "right" && "\n&:after, &:before {\n\tleft: 100%;\n\ttop: 50%;\n}\n\n&:after {\n\tborder-left-color: #1A7971;\n\tmargin-top: -30px;\n}\n&:before {\n\tborder-left-color: #1A7971;\n\tmargin-top: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "left" && "\n&:after, &:before {\n\tright: 100%;\n\ttop: 50%;\n}\n\n&:after {\n\tborder-right-color: #1A7971;\n\tmargin-top: -17px;\n}\n&:before {\n\tborder-right-color: #1A7971;\n\tmargin-top: -19px;\n}\n\n";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModal.style.ts








var SelectCountryModalStyle = (0,styled_components_browser_esm["default"])(CommonModalDweb_style_CommonModalDwebStyle).withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryModalStyle",
  componentId: "one95n-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
var SelectCountryModal_style_CountryItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalstyle__CountryItem",
  componentId: "one95n-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;cursor:pointer;", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], LandingButton_style_LandingButtonStyle, CheckButton_style_CheckButtonStyle, Global/* theme.yellowText3 */.rS.yellowText3, ToolTipComp_style_ToolTipCompWrapper);
var SelectCountryModal_style_BtnWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalstyle__BtnWrap",
  componentId: "one95n-2"
})(["position:sticky;bottom:16px;left:16px;width:calc(100% - 32px);"]);
var SelectCountryModal_style_CountrySection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySection",
  componentId: "one95n-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
var SelectCountryModal_style_CountrySectionWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySectionWrap",
  componentId: "one95n-4"
})(["overflow-y:scroll;@media ", "{padding:16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var PopularRegionCountries = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalstyle__PopularRegionCountries",
  componentId: "one95n-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
var SelectCountryModal_style_SelectCountrySheetStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountrySheetStyle",
  componentId: "one95n-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], TMFloatingInput_style_TMInputWrap);
var SelectCountryModal_style_SelectCountryHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryHeader",
  componentId: "one95n-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModal.tsx











var SelectCountryModal_analytics = getAnalytics();

var SelectCountryModal = function SelectCountryModal(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      popularRegion = _ref.popularRegion,
      preSelectedCountry = _ref.preSelectedCountry,
      setShowCountry = _ref.setShowCountry,
      setIsCountryError = _ref.setIsCountryError,
      popularCountryProp = _ref.popularCountryProp,
      setPopularCountryProp = _ref.setPopularCountryProp;
  var device = useBreakpointV2();
  var windowWidth = window.innerWidth - 60;

  var _useState = useState(countryData),
      countriesData = _useState[0],
      setCountriesData = _useState[1];

  var _useState2 = useState([]),
      selectedCountries = _useState2[0],
      setSelectedCountries = _useState2[1];

  var _useState3 = useState(0),
      numOfCount = _useState3[0],
      setNumCount = _useState3[1];

  var _useState4 = useState(""),
      searchTxt = _useState4[0],
      setSearchTxt = _useState4[1];

  var rowHeight = 57;

  var calculateListHeight = function calculateListHeight() {
    var _countriesData$length;

    var rowCount = (_countriesData$length = countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) !== null && _countriesData$length !== void 0 ? _countriesData$length : 0;
    var height = rowCount * rowHeight;
    console.log("calHeight", height);
    return height;
  };

  useEffect(function () {
    setSelectedCountries(preSelectedCountry);
  }, []);
  useEffect(function () {
    if (countryData) {
      var count = countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (country) {
        return country.isSelected === true;
      });
      setNumCount(count === null || count === void 0 ? void 0 : count.length);
    }
  }, [countryData]);
  var debouncedCountryHandler = useCallback(SelectCountryModal_debounce(function (code) {
    var countryArr = [],
        tempPopularCountry = [];

    if (code) {
      countryArr = countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (country) {
        if (country.code === code && !country.isSelected) {
          country.isSelected = true;
        } else if (country.code === code && country.isSelected) {
          country.isSelected = false;
        }

        return country;
      });
      setSelectedCountries(countryArr);
      tempPopularCountry = popularCountryProp === null || popularCountryProp === void 0 ? void 0 : popularCountryProp.filter(function (country) {
        if (country.code === code && !country.isSelected) {
          country.isSelected = true;
        } else if (country.code === code && country.isSelected) {
          country.isSelected = false;
        }

        return country;
      });
      tempPopularCountry && setPopularCountryProp && setPopularCountryProp(tempPopularCountry);
      var count = countryArr.filter(function (country) {
        return country.isSelected === true;
      });
      setNumCount(count.length);
    }
  }, 300), [countryData, popularCountryProp]);
  useEffect(function () {
    debouncedCountryHandler(searchTxt);
  }, [searchTxt]);

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/_jsx(ParaTag, {
      dangerousText: highlighted
    });
  };

  useEffect(function () {
    var filteredDataList = searchTxt ? countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (items) {
      var _items$name;

      return (_items$name = items.name) === null || _items$name === void 0 ? void 0 : _items$name.toLowerCase().includes(searchTxt.toLowerCase());
    }) : countryData;
    setCountriesData(filteredDataList);
  }, [searchTxt]);
  var isCheckedHandler = useCallback(function (data) {
    return data.isSelected;
  }, [selectedCountries]);

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key;
    var item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    if (item.code) return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(CountryItem, {
        onClick: function onClick() {
          return debouncedCountryHandler(item.code);
        },
        children: /*#__PURE__*/_jsx(CheckButton, {
          isChecked: isCheckedHandler(item),
          children: /*#__PURE__*/_jsx(FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            children: item.name && searchQueryHighlighter(item.name)
          })
        })
      })
    }, key);
    return;
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _popularCountryProp$f, _popularCountryProp$f2;

    setIsCountryError(false); // selected popular countries

    var selectedPopCountries = (_popularCountryProp$f = popularCountryProp === null || popularCountryProp === void 0 ? void 0 : popularCountryProp.filter(function (item) {
      return item.isSelected;
    })) !== null && _popularCountryProp$f !== void 0 ? _popularCountryProp$f : []; // Popular countries that are not selected

    var unselectedPopCountries = (_popularCountryProp$f2 = popularCountryProp === null || popularCountryProp === void 0 ? void 0 : popularCountryProp.filter(function (item) {
      return !item.isSelected;
    })) !== null && _popularCountryProp$f2 !== void 0 ? _popularCountryProp$f2 : [];
    var selected = selectedCountries.filter(function (item) {
      return item.isSelected;
    });
    var selectedPopCntryCode = selectedPopCountries.map(function (item) {
      return item.code;
    }); // selected non-popular countries

    var selectedNonPopCountries = selected.filter(function (item) {
      return !selectedPopCntryCode.includes(item.code);
    });
    setShowCountry([].concat(_toConsumableArray(selectedPopCountries), _toConsumableArray(selectedNonPopCountries), _toConsumableArray(unselectedPopCountries)));
    var selectedCountryNames = selected.map(function (item) {
      return item.name;
    });
    replaceHistoryRemoveParams("countries");
    replaceHistory("countries", selectedCountryNames.join(","));
    SelectCountryModal_analytics === null || SelectCountryModal_analytics === void 0 ? void 0 : SelectCountryModal_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    });
    handleSelectCountry && handleSelectCountry();
  };

  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    handleClick: handleSelectCountry,
    customTitle: "Select Country",
    children: [/*#__PURE__*/_jsx(TMFloatingInput, {
      handleChange: function handleChange(e) {
        return setSearchTxt(e.target.value);
      },
      inputValue: searchTxt,
      labelTxt: "Search Country Name"
    }), /*#__PURE__*/_jsx(CountrySectionWrap, {
      children: countriesData !== null && countriesData !== void 0 && countriesData.length ? /*#__PURE__*/_jsx(List, {
        width: device == "lg" ? 360 : windowWidth,
        height: calculateListHeight(),
        rowHeight: rowHeight,
        rowCount: countriesData.length,
        rowRenderer: rowRenderer,
        style: {
          minHeight: calculateListHeight()
        }
      }) : /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        color: theme.greyText,
        margin: "16px 0 16px",
        children: "No Country Found! Please enter correct name"
      })
    }), /*#__PURE__*/_jsx(BtnWrap, {
      children: /*#__PURE__*/_jsx(LandingButton, {
        customWidth: "100%",
        customTitle: "Selected " + "".concat(numOfCount != 0 ? "(" + numOfCount + ")" : ""),
        onClick: onCountrySubmit
      })
    })]
  });
};

var SelectCountryModal_debounce = function debounce(func, delay) {
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};

/* harmony default export */ var SelectCountryModal_SelectCountryModal = ((/* unused pure expression or super */ null && (SelectCountryModal)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.style.tsx








var SelectCountryModalV2_style_SelectCountryModalStyle = (0,styled_components_browser_esm["default"])(CommonModalDweb_style_CommonModalDwebStyle).withConfig({
  displayName: "SelectCountryModalV2style__SelectCountryModalStyle",
  componentId: "sc-2hn0ay-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
var SelectCountryModalV2_style_CountryItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalV2style__CountryItem",
  componentId: "sc-2hn0ay-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;margin:", ";cursor:", ";", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], function (props) {
  return props.margin && "".concat(props.margin);
}, function (props) {
  return props.disableCursor ? "default" : "pointer";
}, LandingButton_style_LandingButtonStyle, CheckButton_style_CheckButtonStyle, Global/* theme.yellowText3 */.rS.yellowText3, ToolTipComp_style_ToolTipCompWrapper);
var SelectCountryModalV2_style_BtnWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalV2style__BtnWrap",
  componentId: "sc-2hn0ay-2"
})(["position:", ";", ";", ";width:100%;"], function (props) {
  return props.position ? "".concat(props.position) : "sticky";
}, function (props) {
  return props.bottom && "bottom:".concat(props.bottom);
}, function (props) {
  return props.background && "background:".concat(props.background);
});
var SelectCountryModalV2_style_CountrySection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalV2style__CountrySection",
  componentId: "sc-2hn0ay-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
var SelectCountryModalV2_style_CountrySectionWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalV2style__CountrySectionWrap",
  componentId: "sc-2hn0ay-4"
})(["overflow-y:scroll;@media ", "{padding:16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var SelectCountryModalV2_style_PopularRegionCountries = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalV2style__PopularRegionCountries",
  componentId: "sc-2hn0ay-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
var SelectCountryModalV2_style_SelectCountrySheetStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalV2style__SelectCountrySheetStyle",
  componentId: "sc-2hn0ay-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], TMFloatingInput_style_TMInputWrap);
var SelectCountryModalV2_style_SelectCountryHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCountryModalV2style__SelectCountryHeader",
  componentId: "sc-2hn0ay-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx



var ImageComponent_ImageComponent = function ImageComponent(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "lazy" : _ref$loading,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$cdnUrlWidths = _ref.cdnUrlWidths,
      cdnUrlWidths = _ref$cdnUrlWidths === void 0 ? [] : _ref$cdnUrlWidths,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? "" : _ref$sizes,
      margin = _ref.margin;
  var imgStyle = margin ? {
    margin: margin
  } : {};

  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith && src.endsWith(".svg")) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      style: imgStyle,
      className: className,
      id: id,
      width: width,
      height: height
    });
  }

  var srcsetUrl = (0,utils/* generateSourceSetImageUrl */.sI)(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height,
      style: imgStyle
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/CountryList.style.tsx

var CountryList_style_ArrowButtonWrap = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CountryListstyle__ArrowButtonWrap",
  componentId: "sc-10iz6l5-0"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var CountryList_style_DescriptionWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CountryListstyle__DescriptionWrap",
  componentId: "sc-10iz6l5-1"
})(["cursor:none;margin:10px 0px 0px 32px;border-radius:4px;padding:10px 6px 10px 10px;background-color:#f6f6f6;cursor:", ";"], function (props) {
  return props.isCursorPointer ? "pointer" : "default";
});
var CountryList_style_ColumnWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CountryListstyle__ColumnWrapper",
  componentId: "sc-10iz6l5-2"
})(["display:flex;flex-direction:column;& > span{margin-bottom:-6px;}"]);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/TextStyles/SpanTag.tsx
var ui_atoms_TextStyles_SpanTag = __webpack_require__(3634);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/CountryList.tsx
















var CountryList_CountryList = function CountryList(_ref) {
  var countryData = _ref.countryData,
      countryHandler = _ref.countryHandler,
      isCheckedHandler = _ref.isCheckedHandler,
      setCountryData = _ref.setCountryData,
      searchQueryHighlighter = _ref.searchQueryHighlighter,
      setIsSelectedError = _ref.setIsSelectedError;
  var device = useBreakpointV2();
  var windowWidth = window.innerWidth - 60;
  var cache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 58
  });

  var _useState = useState(false),
      showViewAllButton = _useState[0],
      setShowViewAllButton = _useState[1];

  useEffect(function () {
    var temp = countryData.map(function (data) {
      data["showDesc"] = false;
      return data;
    });
    setCountryData(temp);
  }, []);

  var calculateListHeight = function calculateListHeight(data) {
    var _data$length;

    var rowCount = (_data$length = data === null || data === void 0 ? void 0 : data.length) !== null && _data$length !== void 0 ? _data$length : 0;
    var height = rowCount * 100;
    return height;
  };

  var handleDescription = function handleDescription(code) {
    var data = countryData.filter(function (data) {
      return data.code === code;
    })[0];

    if (data.showAllDesc || data.description.length < 80) {
      setShowViewAllButton(false);
      console.log(data.description.length);
      return data.description;
    }

    setShowViewAllButton(true);
    var tempDescData = data.description.substring(0, 80).split(" ");
    tempDescData.pop();
    var descData = tempDescData.join(" ") + "...";
    return descData;
  };

  var handleRegionDescription = function handleRegionDescription(code) {
    var temp = countryData.map(function (data) {
      if (data.code === code && !data.showDesc) {
        data["showDesc"] = true;
        data["showAllDesc"] = false;
        return data;
      }

      data["showDesc"] = false;
      data["showAllDesc"] = false;
      return data;
    });
    setCountryData(temp);
  };

  var handleErrorToast = debounce(function () {
    setIsSelectedError(false);
  }, 3000);

  var handleCountrySelectError = function handleCountrySelectError(country) {
    if (country.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      {
        !country.isSelected && !country.showDesc && handleRegionDescription(country.code);
      }
      {
        country.isSelected && country.showDesc && handleRegionDescription(country.code);
      }
      countryHandler(country.code);
    }
  };

  var handleViewAll = function handleViewAll(code) {
    var temp = countryData.map(function (data) {
      if (data.code === code) {
        data["showAllDesc"] = !data["showAllDesc"];
      }

      return data;
    });
    setCountryData(temp);
  };

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key,
        parent = _ref2.parent;
    var item = countryData === null || countryData === void 0 ? void 0 : countryData[index];

    if (!item) {
      return null; // Return null if item is undefined
    } else if (item.type === "HEADER") {
      return /*#__PURE__*/_jsx(CellMeasurer, {
        cache: cache,
        parent: parent,
        rowIndex: index,
        children: /*#__PURE__*/_jsx(CountryItem, {
          disableCursor: true,
          margin: device === "lg" ? "0px 17px 0px 0px" : "",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: item.name,
            baseStyle: {
              fontWeight: "bold",
              fontSize: "14px"
            }
          })
        })
      }, key);
    } else if (item.code) {
      return /*#__PURE__*/_jsx(CellMeasurer, {
        cache: cache,
        parent: parent,
        rowIndex: index,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs(CountryItem, {
            disableCursor: true,
            margin: device === "lg" ? "0px 17px 0px 0px" : "",
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              children: [/*#__PURE__*/_jsx(CheckButton, {
                handleChange: function handleChange() {
                  return handleCountrySelectError(item);
                },
                isChecked: item.isDisabled ? true : isCheckedHandler(item),
                isDisabled: item.isDisabled,
                children: /*#__PURE__*/_jsxs(FlexComp, {
                  handleClick: function handleClick() {
                    return handleCountrySelectError(item);
                  },
                  alignItems: "center",
                  justifyContent: "space-between",
                  children: [item.subtitle ? /*#__PURE__*/_jsxs(ColumnWrapper, {
                    children: [/*#__PURE__*/_jsx(SpanTag, {
                      children: searchQueryHighlighter(item.name)
                    }), /*#__PURE__*/_jsx(SpanTag, {
                      children: /*#__PURE__*/_jsx(FormattedText, {
                        value: item.subtitle,
                        baseStyle: {
                          fontSize: "12px",
                          fontWeight: "400"
                        }
                      })
                    })]
                  }) : searchQueryHighlighter(item.name), /*#__PURE__*/_jsx(FormattedText, {
                    value: item.countryCount,
                    baseStyle: {
                      padding: "0px 10px 0px 0px",
                      fontSize: "12px",
                      color: "#4A4A4A"
                    }
                  }), /*#__PURE__*/_jsx(FormattedText, {
                    value: item.regionName,
                    baseStyle: {
                      fontSize: "12px",
                      color: "#0000004D"
                    }
                  })]
                })
              }), item.type === "REGION" && /*#__PURE__*/_jsx(ArrowButtonWrap, {
                onClick: function onClick() {
                  handleRegionDescription(item.code);
                },
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "9px",
                  height: "9px",
                  margin: "0px 0px 0px 0px",
                  src: item.showDesc ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg"
                })
              })]
            }), item.showDesc && item.type === "REGION" && /*#__PURE__*/_jsxs(DescriptionWrap, {
              children: [/*#__PURE__*/_jsx(FormattedText, {
                value: item.descTitle,
                baseStyle: {
                  fontWeight: "bold",
                  fontSize: "14px"
                }
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: handleDescription(item.code),
                  baseStyle: {
                    fontSize: "14px"
                  }
                })
              }), showViewAllButton && /*#__PURE__*/_jsx(AnchorTag, {
                handleClick: function handleClick() {
                  handleViewAll(item.code);
                },
                fontWeight: "bold",
                children: "View All"
              })]
            })]
          })
        }, key)
      }, key);
    }

    return;
  };

  return /*#__PURE__*/_jsx(List, {
    width: device == "lg" ? 360 : windowWidth,
    height: calculateListHeight(countryData),
    rowHeight: cache.rowHeight,
    autoHeight: true,
    rowCount: countryData.length,
    rowRenderer: rowRenderer,
    style: {
      minHeight: 600
    }
  });
};

/* harmony default export */ var SelectCountryModal_CountryList = ((/* unused pure expression or super */ null && (CountryList_CountryList)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionCountryModal.style.tsx





var RegionCountryModal_style_modalAnim = (0,styled_components_browser_esm.keyframes)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var RegionCountryModal_style_CommonModalDwebStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalDwebStyle",
  componentId: "h53l8r-0"
})(["position:fixed;width:", ";height:", ";max-height:600px;min-height:260px;overflow-y:scroll;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, function (p) {
  return p.customHeight ? p.customHeight : "420px";
}, SectionDividers_style_SectionDividersStyle, TMFloatingInput_style_TMInputWrap, utils/* deviceType.mobile */.vO.mobile, RegionCountryModal_style_modalAnim, TMFloatingInput_style_TMInputWrap);
var RegionCountryModal_style_CommonModalHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalHeader",
  componentId: "h53l8r-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:81%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], TextStyles_style_H5TagStyle, function (p) {
  return p.nonClipHeading && "\n     ".concat(TextStyles_style_H5TagStyle, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, utils/* deviceType.mobile */.vO.mobile);
var RegionCountryModal_style_CrossIconWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RegionCountryModalstyle__CrossIconWrap",
  componentId: "h53l8r-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionCountryModal.tsx







var RegionCountryModal_RegionCountryModal = function RegionCountryModal(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      customSubTitle = _ref.customSubTitle,
      handleClick = _ref.handleClick,
      requiredField = _ref.requiredField,
      crossIcon = _ref.crossIcon,
      customWidth = _ref.customWidth,
      customIcon = _ref.customIcon,
      errorModal = _ref.errorModal,
      customHeight = _ref.customHeight,
      nonClipHeading = _ref.nonClipHeading;
  useEffect(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  useEffect(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
    return function () {};
  }, []);
  return /*#__PURE__*/_jsxs(ReactPortalComp, {
    children: [/*#__PURE__*/_jsxs(CommonModalDwebStyle, {
      customHeight: customHeight,
      customWidth: customWidth,
      children: [/*#__PURE__*/_jsxs(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(H5Tag, {
            color: errorModal ? theme.redText : theme.blackText,
            children: [customIcon && /*#__PURE__*/_jsx(ImageComponent, {
              width: "40px",
              height: "40px",
              src: customIcon
            }), customTitle && /*#__PURE__*/_jsx(FormattedText, {
              value: customTitle
            })]
          }), customSubTitle && /*#__PURE__*/_jsx(FormattedText, {
            value: customSubTitle
          })]
        }), /*#__PURE__*/_jsx(CrossIconWrap, {
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg"
          })
        })]
      }), children]
    }), /*#__PURE__*/_jsx(BackDropComp, {
      onClose: handleClick
    })]
  });
};

/* harmony default export */ var RegionModalDweb_RegionCountryModal = ((/* unused pure expression or super */ null && (RegionCountryModal_RegionCountryModal)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.tsx



function SelectCountryModalV2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModalV2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModalV2_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModalV2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var SelectCountryModalV2_analytics = getAnalytics();

var SelectCountryModalV2_SelectCountryModalV2 = function SelectCountryModalV2(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      setShowCountry = _ref.setShowCountry,
      showCountry = _ref.showCountry,
      setCountryData = _ref.setCountryData,
      countrySelectErrMsg = _ref.countrySelectErrMsg,
      setIsCountryError = _ref.setIsCountryError,
      popularCountries = _ref.popularCountries,
      setPopularCountries = _ref.setPopularCountries,
      customSubTitle = _ref.customSubTitle,
      handleDescriptionModal = _ref.handleDescriptionModal;

  var _useState = useState([]),
      countriesData = _useState[0],
      setCountriesData = _useState[1];

  var _useState2 = useState(""),
      searchTxt = _useState2[0],
      setSearchTxt = _useState2[1];

  var _useState3 = useState([]),
      finalCountryData = _useState3[0],
      setFinalCountryData = _useState3[1];

  var _useState4 = useState(false),
      isSelectedError = _useState4[0],
      setIsSelectedError = _useState4[1];

  var searchedCountriesOmn = useRef([]);
  var selectedCountriesOmn = useRef([]);
  useEffect(function () {
    var selectedCountry = countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (data) {
      return data.isSelected && !data.isDisabled;
    });

    var modalData = _toConsumableArray(countryData.filter(function (data) {
      return !data.isSelected || data.isDisabled;
    }));

    if (selectedCountry.length) {
      var selectedHeader = {
        type: "HEADER",
        name: "Selected Countries",
        code: "SELECTED_COUNTRIES"
      };
      setFinalCountryData([SelectCountryModalV2_objectSpread({}, selectedHeader)].concat(_toConsumableArray(selectedCountry), _toConsumableArray(modalData)));
    } else {
      setFinalCountryData(_toConsumableArray(modalData));
    }
  }, [countryData]);
  var handleSearchtxt = debounce(function () {
    var filteredCountriesData = finalCountryData.filter(function (item) {
      var _item$name;

      return item.type !== "HEADER" && ((_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(searchTxt.toLowerCase()));
    });
    setCountriesData(_toConsumableArray(filteredCountriesData));
  }, 300);
  useEffect(function () {
    if (searchTxt) {
      handleSearchtxt();
    } else {
      var countriesDataArr = finalCountryData.map(function (data) {
        if (data.type !== "HEADER") {
          return SelectCountryModalV2_objectSpread({}, data);
        }
      });
      setCountriesData(countriesDataArr);
    }
  }, [searchTxt, finalCountryData]);

  var countryHandler = function countryHandler(code) {
    handleDescriptionModal(finalCountryData.filter(function (data) {
      return data.code === code;
    })[0]);
    var countryArr = finalCountryData === null || finalCountryData === void 0 ? void 0 : finalCountryData.map(function (country) {
      if (country.code === code) {
        var _selectedCountriesOmn;

        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModalV2_objectSpread({}, country);
        }

        if ((selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn = selectedCountriesOmn.current) === null || _selectedCountriesOmn === void 0 ? void 0 : _selectedCountriesOmn.length) >= 30) {
          selectedCountriesOmn.current = [selectedCountriesOmn.current.slice(1), country.code];
        } else {
          selectedCountriesOmn.current = [].concat(_toConsumableArray(selectedCountriesOmn.current), [country.code]);
        }

        return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var selectedCountryCodes = countryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedCountryCodes.map(function (item) {
      countryArr = countryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModalV2_objectSpread({}, country);
      });
    });
    setFinalCountryData(countryArr);
    var popularCountryData = countryArr.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    setPopularCountries([].concat(_toConsumableArray(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    }))));
    var selected = countryArr.filter(function (country) {
      return country.isSelected === true;
    });
  };

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/_jsx(ParaTag, {
      dangerousText: highlighted
    });
  };

  var isCheckedHandler = useCallback(function (data) {
    return data.isSelected;
  }, [finalCountryData]);

  var handleCrossClick = function handleCrossClick() {
    var _searchedCountriesOmn;

    setPopularCountries(showCountry);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn = searchedCountriesOmn.current) !== null && _searchedCountriesOmn !== void 0 && _searchedCountriesOmn.length) {
      var _searchedCountriesOmn2;

      SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn2 = searchedCountriesOmn.current) === null || _searchedCountriesOmn2 === void 0 ? void 0 : _searchedCountriesOmn2.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    var tempCountryData = finalCountryData.map(function (country) {
      return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(function (data) {
      tempCountryData = tempCountryData.map(function (country) {
        if (data.code === country.code) {
          return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalV2_objectSpread({}, country);
      });
    });
    setFinalCountryData(SelectCountryModalV2_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _searchedCountriesOmn3, _selectedCountriesOmn2;

    setIsCountryError(false);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn3 = searchedCountriesOmn.current) !== null && _searchedCountriesOmn3 !== void 0 && _searchedCountriesOmn3.length) {
      var _searchedCountriesOmn4;

      SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn4 = searchedCountriesOmn.current) === null || _searchedCountriesOmn4 === void 0 ? void 0 : _searchedCountriesOmn4.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn !== null && selectedCountriesOmn !== void 0 && (_selectedCountriesOmn2 = selectedCountriesOmn.current) !== null && _selectedCountriesOmn2 !== void 0 && _selectedCountriesOmn2.length) {
      var _selectedCountriesOmn3;

      SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn3 = selectedCountriesOmn.current) === null || _selectedCountriesOmn3 === void 0 ? void 0 : _selectedCountriesOmn3.join("|")
      });
      selectedCountriesOmn.current = [];
    }

    var countryDataArr = countryData.map(function (country) {
      return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    finalCountryData.map(function (data) {
      countryDataArr = countryDataArr.map(function (country) {
        if (country.code === data.code) {
          return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalV2_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    var selectedCountryCodes = finalCountryData.filter(function (item) {
      return item.isSelected && !item.isDisabled;
    }).map(function (item) {
      return item.code;
    });
    replaceHistoryRemoveParams("countries");
    replaceHistory("countries", selectedCountryCodes.join(","));
    var selectedNonPopCountries = finalCountryData.filter(function (data) {
      return data.isSelected && !data.isPopular;
    });
    SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    });
    handleSelectCountry && handleSelectCountry();
  };

  var handleSearchTxt = function handleSearchTxt(event) {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      var _searchedCountriesOmn5;

      if ((searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn5 = searchedCountriesOmn.current) === null || _searchedCountriesOmn5 === void 0 ? void 0 : _searchedCountriesOmn5.length) >= 30) {
        var _searchedCountriesOmn6;

        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn6 = searchedCountriesOmn.current) === null || _searchedCountriesOmn6 === void 0 ? void 0 : _searchedCountriesOmn6.slice(1)), [searchTxt]);
      } else {
        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : searchedCountriesOmn.current), [searchTxt]);
      }
    }

    setSearchTxt(function (_) {
      return event.target.value;
    });
  };

  return /*#__PURE__*/_jsxs(RegionCountryModal, {
    customHeight: "600px",
    handleClick: handleCrossClick,
    customTitle: "Select Destinations",
    customSubTitle: customSubTitle,
    children: [/*#__PURE__*/_jsx(TMFloatingInput, {
      handleChange: function handleChange(e) {
        return handleSearchTxt(e);
      },
      inputValue: searchTxt,
      labelTxt: "Search Country/Region"
    }), /*#__PURE__*/_jsx(CountrySectionWrap, {
      children: countriesData !== null && countriesData !== void 0 && countriesData.length ? /*#__PURE__*/_jsx(_Fragment, {
        children: searchTxt ? /*#__PURE__*/_jsx(CountryList, {
          countryData: countriesData,
          countryHandler: countryHandler,
          isCheckedHandler: isCheckedHandler,
          searchQueryHighlighter: searchQueryHighlighter,
          setCountryData: setCountriesData,
          setIsSelectedError: setIsSelectedError
        }) : /*#__PURE__*/_jsx(CountryList, {
          countryData: finalCountryData,
          countryHandler: countryHandler,
          isCheckedHandler: isCheckedHandler,
          searchQueryHighlighter: searchQueryHighlighter,
          setCountryData: setFinalCountryData,
          setIsSelectedError: setIsSelectedError
        })
      }) : /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        color: theme.greyText,
        margin: "30px 0px 0px 0px",
        children: "No Country Found! Please enter correct name"
      })
    }), isSelectedError && /*#__PURE__*/_jsx(WebToast, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px"
    }), countriesData.length && /*#__PURE__*/_jsx(BtnWrap, {
      children: /*#__PURE__*/_jsx(LandingButton, {
        margin: "16px 0px 0px 0px",
        customWidth: "100%",
        customTitle: "Add Destination",
        onClick: onCountrySubmit
      })
    })]
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryModalV2 = ((/* unused pure expression or super */ null && (SelectCountryModalV2_SelectCountryModalV2)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalSheet.tsx











var SelectCountryModalSheet_analytics = getAnalytics();

var SelectCountryModalSheet = function SelectCountryModalSheet(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      popularRegion = _ref.popularRegion,
      preSelectedCountry = _ref.preSelectedCountry,
      setShowCountry = _ref.setShowCountry,
      setIsCountryError = _ref.setIsCountryError,
      popularCountryProp = _ref.popularCountryProp,
      setPopularCountryProp = _ref.setPopularCountryProp;
  var device = useBreakpointV2();
  var windowWidth = window.innerWidth - 60;

  var _useState = useState(countryData),
      countriesData = _useState[0],
      setCountriesData = _useState[1];

  var _useState2 = useState([]),
      selectedCountries = _useState2[0],
      setSelectedCountries = _useState2[1];

  var _useState3 = useState(0),
      numOfCount = _useState3[0],
      setNumCount = _useState3[1];

  var _useState4 = useState(""),
      searchTxt = _useState4[0],
      setSearchTxt = _useState4[1];

  var rowHeight = 57.1;

  var calculateListHeight = function calculateListHeight() {
    var _countriesData$length;

    var rowCount = (_countriesData$length = countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) !== null && _countriesData$length !== void 0 ? _countriesData$length : 0;
    var height = rowCount * rowHeight;
    console.log("calHeight", height);
    return height;
  };

  useEffect(function () {
    setSelectedCountries(preSelectedCountry);
  }, []);
  useEffect(function () {
    if (countryData) {
      var count = countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (country) {
        return country.isSelected === true;
      });
      setNumCount(count === null || count === void 0 ? void 0 : count.length);
    }
  }, [countryData]);
  var debouncedCountryHandler = useCallback(SelectCountryModalSheet_debounce(function (code) {
    var countryArr = [],
        tempPopularCountry = [];

    if (code) {
      countryArr = countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (country) {
        if (country.code === code && !country.isSelected) {
          country.isSelected = true;
        } else if (country.code === code && country.isSelected) {
          country.isSelected = false;
        }

        return country;
      });
      setSelectedCountries(countryArr);
      tempPopularCountry = popularCountryProp === null || popularCountryProp === void 0 ? void 0 : popularCountryProp.filter(function (country) {
        if (country.code === code && !country.isSelected) {
          country.isSelected = true;
        } else if (country.code === code && country.isSelected) {
          country.isSelected = false;
        }

        return country;
      });
      tempPopularCountry && setPopularCountryProp && setPopularCountryProp(tempPopularCountry);
      var count = countryArr.filter(function (country) {
        return country.isSelected === true;
      });
      setNumCount(count.length);
    }
  }, 300), [countryData, popularCountryProp]);
  useEffect(function () {
    debouncedCountryHandler(searchTxt);
  }, [searchTxt]);

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/_jsx(ParaTag, {
      dangerousText: highlighted
    });
  };

  useEffect(function () {
    var filteredDataList = searchTxt ? countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (items) {
      var _items$name;

      return (_items$name = items.name) === null || _items$name === void 0 ? void 0 : _items$name.toLowerCase().includes(searchTxt.toLowerCase());
    }) : countryData;
    setCountriesData(filteredDataList);
  }, [searchTxt]);
  var isCheckedHandler = useCallback(function (data) {
    return data.isSelected;
  }, [selectedCountries]);

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key;
    var item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    if (item.code) return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(CountryItem, {
        onClick: function onClick() {
          return debouncedCountryHandler(item.code);
        },
        children: /*#__PURE__*/_jsx(CheckButton, {
          isChecked: isCheckedHandler(item),
          children: /*#__PURE__*/_jsx(FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            children: item.name && searchQueryHighlighter(item.name)
          })
        })
      })
    }, key);
    return;
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _popularCountryProp$f, _popularCountryProp$f2;

    setIsCountryError(false); // selected popular countries

    var selectedPopCountries = (_popularCountryProp$f = popularCountryProp === null || popularCountryProp === void 0 ? void 0 : popularCountryProp.filter(function (item) {
      return item.isSelected;
    })) !== null && _popularCountryProp$f !== void 0 ? _popularCountryProp$f : []; // Popular countries that are not selected

    var unselectedPopCountries = (_popularCountryProp$f2 = popularCountryProp === null || popularCountryProp === void 0 ? void 0 : popularCountryProp.filter(function (item) {
      return !item.isSelected;
    })) !== null && _popularCountryProp$f2 !== void 0 ? _popularCountryProp$f2 : [];
    var selected = selectedCountries.filter(function (item) {
      return item.isSelected;
    });
    var selectedPopCntryCode = selectedPopCountries.map(function (item) {
      return item.code;
    }); // selected non-popular countries

    var selectedNonPopCountries = selected.filter(function (item) {
      return !selectedPopCntryCode.includes(item.code);
    });
    setShowCountry([].concat(_toConsumableArray(selectedPopCountries), _toConsumableArray(selectedNonPopCountries), _toConsumableArray(unselectedPopCountries)));
    var selectedCountryNames = selected.map(function (item) {
      return item.name;
    });
    replaceHistoryRemoveParams("countries");
    replaceHistory("countries", selectedCountryNames.join(","));
    SelectCountryModalSheet_analytics === null || SelectCountryModalSheet_analytics === void 0 ? void 0 : SelectCountryModalSheet_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    });
    handleSelectCountry && handleSelectCountry();
  };

  return /*#__PURE__*/_jsx(ReactPortalComp, {
    children: /*#__PURE__*/_jsxs(SelectCountrySheetStyle, {
      children: [/*#__PURE__*/_jsxs(SelectCountryHeader, {
        children: [/*#__PURE__*/_jsx(AnchorTag, {
          handleClick: handleSelectCountry,
          children: /*#__PURE__*/_jsx("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/_jsx("path", {
              d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
              fill: "#808080"
            })
          })
        }), /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(ParaTag, {
            fontSize: "md",
            fontWeight: "black",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: "Select Destinations"
            })
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            color: theme.greyText6,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: "You can select multiple travel destination "
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(TMFloatingInput, {
        handleChange: function handleChange(e) {
          return setSearchTxt(e.target.value);
        },
        inputValue: searchTxt,
        labelTxt: "Search Country Name"
      }), /*#__PURE__*/_jsx(CountrySectionWrap, {
        children: countriesData !== null && countriesData !== void 0 && countriesData.length ? /*#__PURE__*/_jsx(List, {
          width: device == "lg" ? 360 : windowWidth,
          height: calculateListHeight(),
          rowHeight: rowHeight,
          rowCount: countriesData.length,
          rowRenderer: rowRenderer,
          style: {
            minHeight: calculateListHeight()
          }
        }) : /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "sm",
          color: theme.greyText,
          margin: "16px 0 16px",
          children: "No Country Found! Please enter correct name"
        })
      }), /*#__PURE__*/_jsx(BtnWrap, {
        children: /*#__PURE__*/_jsx(LandingButton, {
          customWidth: "100%",
          customTitle: "Selected " + "".concat(numOfCount != 0 ? "(" + numOfCount + ")" : ""),
          onClick: onCountrySubmit
        })
      })]
    })
  });
};

var SelectCountryModalSheet_debounce = function debounce(func, delay) {
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};

/* harmony default export */ var SelectCountryModal_SelectCountryModalSheet = ((/* unused pure expression or super */ null && (SelectCountryModalSheet)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalSheetV2.tsx



function SelectCountryModalSheetV2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModalSheetV2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModalSheetV2_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModalSheetV2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var SelectCountryModalSheetV2_analytics = getAnalytics();

var SelectCountryModalSheetV2_SelectCountryModalSheet = function SelectCountryModalSheet(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      setShowCountry = _ref.setShowCountry,
      setCountryData = _ref.setCountryData,
      showCountry = _ref.showCountry,
      countrySelectErrMsg = _ref.countrySelectErrMsg,
      setIsCountryError = _ref.setIsCountryError,
      popularCountries = _ref.popularCountries,
      setPopularCountries = _ref.setPopularCountries,
      handleDescriptionModal = _ref.handleDescriptionModal,
      customSubTitle = _ref.customSubTitle;

  var _useState = useState([]),
      countriesData = _useState[0],
      setCountriesData = _useState[1];

  var _useState2 = useState(""),
      searchTxt = _useState2[0],
      setSearchTxt = _useState2[1];

  var _useState3 = useState([]),
      finalCountryData = _useState3[0],
      setFinalCountryData = _useState3[1];

  var _useState4 = useState(false),
      isSelectedError = _useState4[0],
      setIsSelectedError = _useState4[1];

  var searchedCountriesOmn = useRef([]);
  var selectedCountriesOmn = useRef([]);
  useEffect(function () {
    var selectedCountry = countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (data) {
      return data.isSelected && !data.isDisabled;
    });

    var modalData = _toConsumableArray(countryData.filter(function (data) {
      return !data.isSelected || data.isDisabled;
    }));

    if (selectedCountry.length) {
      var selectedHeader = {
        type: "HEADER",
        name: "Selected Countries",
        code: "SELECTED_COUNTRIES"
      };
      setFinalCountryData([SelectCountryModalSheetV2_objectSpread({}, selectedHeader)].concat(_toConsumableArray(selectedCountry), _toConsumableArray(modalData)));
    } else {
      setFinalCountryData(_toConsumableArray(modalData));
    }
  }, [countryData]);
  var handleSearchtxt = debounce(function () {
    var filteredCountriesData = finalCountryData.filter(function (item) {
      var _item$name;

      return item.type !== "HEADER" && ((_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(searchTxt.toLowerCase()));
    });
    setCountriesData(_toConsumableArray(filteredCountriesData));
  }, 300);
  useEffect(function () {
    if (searchTxt) {
      handleSearchtxt();
    } else {
      var countriesDataArr = finalCountryData.map(function (data) {
        if (data.type !== "HEADER") {
          return SelectCountryModalSheetV2_objectSpread({}, data);
        }
      });
      setCountriesData(countriesDataArr);
    }
  }, [searchTxt, finalCountryData]);

  var countryHandler = function countryHandler(code) {
    handleDescriptionModal(finalCountryData.filter(function (data) {
      return data.code === code;
    })[0]);
    var countryArr = finalCountryData === null || finalCountryData === void 0 ? void 0 : finalCountryData.map(function (country) {
      if (country.code === code) {
        var _selectedCountriesOmn;

        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModalSheetV2_objectSpread({}, country);
        }

        if ((selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn = selectedCountriesOmn.current) === null || _selectedCountriesOmn === void 0 ? void 0 : _selectedCountriesOmn.length) >= 30) {
          var _selectedCountriesOmn2;

          selectedCountriesOmn.current = [].concat(_toConsumableArray(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn2 = selectedCountriesOmn.current) === null || _selectedCountriesOmn2 === void 0 ? void 0 : _selectedCountriesOmn2.slice(1)), [country.code]);
        } else {
          selectedCountriesOmn.current = [].concat(_toConsumableArray(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : selectedCountriesOmn.current), [country.code]);
        }

        return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var selectedCountryCodes = countryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedCountryCodes.map(function (item) {
      countryArr = countryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModalSheetV2_objectSpread({}, country);
      });
    });
    setFinalCountryData(countryArr);
    var popularCountryData = countryArr.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    setPopularCountries([].concat(_toConsumableArray(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    }))));
    var selected = countryArr.filter(function (country) {
      return country.isSelected === true;
    });
  };

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/_jsx(ParaTag, {
      dangerousText: highlighted
    });
  };

  var isCheckedHandler = useCallback(function (data) {
    return data.isSelected;
  }, [finalCountryData]);

  var handleCrossClick = function handleCrossClick() {
    var _searchedCountriesOmn;

    setPopularCountries(showCountry);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn = searchedCountriesOmn.current) !== null && _searchedCountriesOmn !== void 0 && _searchedCountriesOmn.length) {
      var _searchedCountriesOmn2;

      SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn2 = searchedCountriesOmn.current) === null || _searchedCountriesOmn2 === void 0 ? void 0 : _searchedCountriesOmn2.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    var tempCountryData = finalCountryData.map(function (country) {
      return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(function (data) {
      tempCountryData = tempCountryData.map(function (country) {
        if (data.code === country.code) {
          return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheetV2_objectSpread({}, country);
      });
    });
    setFinalCountryData(SelectCountryModalSheetV2_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _searchedCountriesOmn3, _selectedCountriesOmn3;

    setIsCountryError(false);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn3 = searchedCountriesOmn.current) !== null && _searchedCountriesOmn3 !== void 0 && _searchedCountriesOmn3.length) {
      var _searchedCountriesOmn4;

      SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn4 = searchedCountriesOmn.current) === null || _searchedCountriesOmn4 === void 0 ? void 0 : _searchedCountriesOmn4.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn !== null && selectedCountriesOmn !== void 0 && (_selectedCountriesOmn3 = selectedCountriesOmn.current) !== null && _selectedCountriesOmn3 !== void 0 && _selectedCountriesOmn3.length) {
      var _selectedCountriesOmn4;

      SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn4 = selectedCountriesOmn.current) === null || _selectedCountriesOmn4 === void 0 ? void 0 : _selectedCountriesOmn4.join("|")
      });
      selectedCountriesOmn.current = [];
    }

    var countryDataArr = countryData.map(function (country) {
      return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    finalCountryData.map(function (data) {
      countryDataArr = countryDataArr.map(function (country) {
        if (country.code === data.code) {
          return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheetV2_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    var selectedCountryCodes = finalCountryData.filter(function (item) {
      return item.isSelected && !item.isDisabled;
    }).map(function (item) {
      return item.code;
    });
    replaceHistoryRemoveParams("countries");
    replaceHistory("countries", selectedCountryCodes.join(","));
    var selectedNonPopCountries = finalCountryData.filter(function (data) {
      return data.isSelected && !data.isPopular;
    });
    SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    });
    handleSelectCountry && handleSelectCountry();
  };

  var handleSearchTxt = function handleSearchTxt(event) {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      var _searchedCountriesOmn5;

      if ((searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn5 = searchedCountriesOmn.current) === null || _searchedCountriesOmn5 === void 0 ? void 0 : _searchedCountriesOmn5.length) >= 30) {
        var _searchedCountriesOmn6;

        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn6 = searchedCountriesOmn.current) === null || _searchedCountriesOmn6 === void 0 ? void 0 : _searchedCountriesOmn6.slice(1)), [searchTxt]);
      } else {
        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : searchedCountriesOmn.current), [searchTxt]);
      }
    }

    setSearchTxt(function (_) {
      return event.target.value;
    });
  };

  return /*#__PURE__*/_jsx(ReactPortalComp, {
    children: /*#__PURE__*/_jsxs(SelectCountrySheetStyle, {
      children: [/*#__PURE__*/_jsxs(SelectCountryHeader, {
        children: [/*#__PURE__*/_jsx(AnchorTag, {
          handleClick: handleCrossClick,
          children: /*#__PURE__*/_jsx("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/_jsx("path", {
              d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
              fill: "#808080"
            })
          })
        }), /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(ParaTag, {
            fontSize: "md",
            fontWeight: "bold",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: "Select Destinations"
            })
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            color: theme.greyText6,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: customSubTitle
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(TMFloatingInput, {
        handleChange: function handleChange(e) {
          return handleSearchTxt(e);
        },
        inputValue: searchTxt,
        labelTxt: "Search Country/Region"
      }), /*#__PURE__*/_jsx(CountrySectionWrap, {
        children: countriesData !== null && countriesData !== void 0 && countriesData.length ? /*#__PURE__*/_jsx(_Fragment, {
          children: searchTxt ? /*#__PURE__*/_jsx(CountryList, {
            countryData: countriesData,
            countryHandler: countryHandler,
            isCheckedHandler: isCheckedHandler,
            searchQueryHighlighter: searchQueryHighlighter,
            setCountryData: setCountriesData,
            setIsSelectedError: setIsSelectedError
          }) : /*#__PURE__*/_jsx(CountryList, {
            countryData: finalCountryData,
            countryHandler: countryHandler,
            isCheckedHandler: isCheckedHandler,
            searchQueryHighlighter: searchQueryHighlighter,
            setCountryData: setFinalCountryData,
            setIsSelectedError: setIsSelectedError
          })
        }) : /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "sm",
          color: theme.greyText,
          margin: "30px 0px 0px 0px",
          children: "No Country Found! Please enter correct name"
        })
      }), isSelectedError && /*#__PURE__*/_jsx(WebToast, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "75px"
      }), /*#__PURE__*/_jsx(BtnWrap, {
        position: "fixed",
        bottom: "0px",
        background: "white",
        children: /*#__PURE__*/_jsx(LandingButton, {
          margin: "12px 16px 12px 16px",
          customWidth: "92%",
          customTitle: "Add Destination",
          onClick: onCountrySubmit
        })
      })]
    })
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryModalSheetV2 = ((/* unused pure expression or super */ null && (SelectCountryModalSheetV2_SelectCountryModalSheet)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlans.style.ts





var InsurancePlans_style_InsurancePlansStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlansStyle",
  componentId: "sc-1k7o2k3-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;padding:30px;picture{display:inherit;}@media ", "{padding:24px 16px;border-radius:16px 16px 0 0;}"], utils/* deviceType.mobile */.vO.mobile);
var InsurancePlans_style_InsurancePlansCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlansCompStyle",
  componentId: "sc-1k7o2k3-1"
})(["border:1px solid #e2e2e2;border-radius:8px;overflow:hidden;margin-bottom:24px;"]);
var InsurancePlans_style_PlanHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__PlanHeader",
  componentId: "sc-1k7o2k3-2"
})(["background:#f6f6f6;border-radius:8px 8px 0px 0px;padding:16px;display:flex;align-items:center;gap:12px;", "{flex-direction:row-reverse;gap:10px;}"], CheckButton_style_CheckButtonStyle);
var InsurancePlans_style_InsurancePlanSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanSection",
  componentId: "sc-1k7o2k3-3"
})(["background:#fff;padding:16px;"]);
var InsurancePlans_style_InsuranceTypeSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__InsuranceTypeSection",
  componentId: "sc-1k7o2k3-4"
})(["display:flex;flex-direction:column;gap:2px;flex-shrink:0;width:54%;@media ", "{flex-shrink:unset;width:80%;}"], utils/* deviceType.mobile */.vO.mobile);
var InsurancePlans_style_InsurancePlanTypeHd = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanTypeHd",
  componentId: "sc-1k7o2k3-5"
})(["background:linear-gradient( 0deg,rgba(0,140,255,0.04),rgba(0,140,255,0.04) ),#f6f8ff;border-radius:8px 8px 0px 0px;padding:12px 16px;display:flex;justify-content:space-between;align-items:center;", "{padding-bottom:10px;margin-bottom:-10px;}@media ", "{padding:12px 8px;}"], TextStyles_style_AnchorTagStyle, utils/* deviceType.mobile */.vO.mobile);
var InsurancePlans_style_InsurancePlanTypeSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanTypeSection",
  componentId: "sc-1k7o2k3-6"
})(["background:linear-gradient( 149.61deg,rgba(239,255,254,0.5) 0.83%,rgba(230,237,255,0.368088) 26.25%,rgba(234,246,255,0.5) 97.19% );border-radius:0 0 8px 8px;padding:12px 16px;"]);
var InsurancePlans_style_ActivityStatus = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__ActivityStatus",
  componentId: "sc-1k7o2k3-7"
})(["display:flex;align-items:center;gap:8px;padding-top:12px;border-top:1px solid #e2e2e2;margin-top:12px;"]);
var TravelAssistanceSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__TravelAssistanceSection",
  componentId: "sc-1k7o2k3-8"
})(["background:rgba(228,251,244,0.5);border-radius:4px;padding:8px;margin-top:16px;display:flex;align-items:center;gap:8px;"]);
var InsurancePlans_style_PopularTag = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__PopularTag",
  componentId: "sc-1k7o2k3-9"
})(["background:linear-gradient(87.29deg,#c86dd7 0%,#3023ae 100%);border-radius:0px 16px 16px 0px;padding:1px 8px 2px;margin-left:-16px;flex-shrink:0;@media ", "{border-radius:16px;margin-left:0;}"], utils/* deviceType.mobile */.vO.mobile);
var InsurancePlans_style_AmountWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__AmountWrap",
  componentId: "sc-1k7o2k3-10"
})(["display:flex;justify-content:space-between;background:#ffffff;box-shadow:", ";padding:16px 30px;position:sticky;bottom:-20px;margin:auto -30px -20px;@media ", "{padding:8px 20px;}"], function (p) {
  return p.boxShadow ? p.boxShadow : "0px 1px 7px rgba(0, 0, 0, 0.2)";
}, utils/* deviceType.mobile */.vO.mobile);
var InsurancePlans_style_EmptyBorder = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__EmptyBorder",
  componentId: "sc-1k7o2k3-11"
})(["width:100%;height:1px;background:#e2e2e2;"]);
var InsurancePlans_style_GreyChevWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__GreyChevWrap",
  componentId: "sc-1k7o2k3-12"
})(["cursor:pointer;flex-shrink:0;transition:0.5s ease-in;transform-origin:center;width:32px;height:32px;display:flex;", ""], function (p) {
  return p.chevOpen ? "\n    transform:rotate(180deg);\n   \n    " : "\n    transform:rotate(0deg);\n   \n    ";
});
var InsurancePlans_style_BenefitName = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "InsurancePlansstyle__BenefitName",
  componentId: "sc-1k7o2k3-13"
})(["flex-shrink:0;text-transform:uppercase;@media ", "{font-size:12px;font-weight:600;color:", ";}"], utils/* deviceType.mobile */.vO.mobile, Global/* theme.greyText6 */.rS.greyText6);
var InsurancePlans_style_BenefitPrice = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "InsurancePlansstyle__BenefitPrice",
  componentId: "sc-1k7o2k3-14"
})(["flex-shrink:0;"]);
var InsurancePlans_style_TravAssistWraning = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__TravAssistWraning",
  componentId: "sc-1k7o2k3-15"
})(["background:#ffedd1;border-radius:8px;padding:20px;display:flex;align-items:flex-start;gap:8px;svg{flex-shrink:0;}"]);
var InsurancePlans_style_PlanSectionItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__PlanSectionItem",
  componentId: "sc-1k7o2k3-16"
})(["display:grid;grid-template-columns:1fr 1fr 1fr 0.5fr;gap:30px;", "{width:\"max-content\";}@media ", "{grid-template-columns:repeat(1,1fr);gap:12px;}"], ParaTagStyle, utils/* deviceType.mobile */.vO.mobile);
var InsurancePlans_style_VendorWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__VendorWrap",
  componentId: "sc-1k7o2k3-17"
})(["display:flex;gap:8px;align-items:center;", " img{border-radius:4px;}"], function (p) {
  return p.margin && "margin:".concat(p.margin, ";");
});
var InsurancePlans_style_TagWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsurancePlansstyle__TagWrap",
  componentId: "sc-1k7o2k3-18"
})(["display:flex;background:linear-gradient(88.44deg,#12714f 0.02%,#1ca099 100.01%);padding:2px 8px 2px 8px;border-radius:16px;height:20px;color:#ffffff;align-items:center;font-size:12px;font-weight:700;width:fit-content;margin:0px 0px 10px 0px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlans.tsx



function InsurancePlans_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsurancePlans_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsurancePlans_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsurancePlans_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var InsurancePlans_analytics = getAnalytics();

var InsurancePlans = function InsurancePlans(_ref) {
  var title = _ref.title,
      sumInsTxt = _ref.sumInsTxt,
      data = _ref.data,
      tagData = _ref.tagData,
      filterData = _ref.filterData,
      compareToastData = _ref.compareToastData,
      comparePlan = _ref.comparePlan,
      setShowTagData = _ref.setShowTagData,
      showTagData = _ref.showTagData;
  var device = useBreakpointV2();

  var _useState = useState(false),
      showFilter = _useState[0],
      setShowFilter = _useState[1];

  var _useState2 = useState(new Set([])),
      comparisonIds = _useState2[0],
      setComparisonIds = _useState2[1];

  var _useState3 = useState("0/2 Products Selected"),
      comparePlanText = _useState3[0],
      setComparePlanText = _useState3[1];

  var _useState4 = useState(true),
      isDisable = _useState4[0],
      setIsDisable = _useState4[1];

  var handleShowFilter = function handleShowFilter() {
    setShowFilter(!showFilter);
  };

  var _useState5 = useState(-1),
      showBenefits = _useState5[0],
      setShowBenefits = _useState5[1];

  var toggleBenefitsModal = function toggleBenefitsModal(index) {
    showBenefits === index ? setShowBenefits(-1) : setShowBenefits(index);
  };

  var _useState6 = useState(-1),
      showTravAssist = _useState6[0],
      setshowTravAssist = _useState6[1];

  var _handleTravAssist = function handleTravAssist(index) {
    showTravAssist == index ? setshowTravAssist(-1) : setshowTravAssist(index);
  };

  var handleTabIndex = function handleTabIndex(id) {
    if (showTagData) {
      var tempTagData = _toConsumableArray(showTagData);

      tempTagData === null || tempTagData === void 0 ? void 0 : tempTagData.map(function (item) {
        if (item.id === id) {
          item.isSelected = true;
          InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
            actionType: "sum_insured_selected",
            payload: item.name
          });
        } else {
          item.isSelected = false;
        }
      });
      setShowTagData(tempTagData);
    }
  };

  var _useState7 = useState(data),
      planSelected = _useState7[0],
      setPlanSelected = _useState7[1];

  var _useState8 = useState(0),
      count = _useState8[0],
      setCount = _useState8[1];

  var _useState9 = useState([]),
      comparePlanData = _useState9[0],
      setComparePlanData = _useState9[1];

  var _useState10 = useState(""),
      quoteId1ForCompare = _useState10[0],
      setQuoteId1ForCompare = _useState10[1];

  var _useState11 = useState(""),
      quoteId2ForCompare = _useState11[0],
      setQuoteId2ForCompare = _useState11[1];

  var _useState12 = useState(""),
      productId1ForCompare = _useState12[0],
      setProductId1ForCompare = _useState12[1];

  var _useState13 = useState(""),
      productId2ForCompare = _useState13[0],
      setProductId2ForCompare = _useState13[1];

  var handlePlanSelected = function handlePlanSelected(productId) {
    setPlanSelected(planSelected === null || planSelected === void 0 ? void 0 : planSelected.map(function (item) {
      if (productId === item.productId) {
        if (!item.selectedForCompare && count === 2) {
          return item;
        } else {
          item.selectedForCompare = !item.selectedForCompare;
        }

        if (item.selectedForCompare) {
          setCount(count + 1);

          if (quoteId1ForCompare == "") {
            setQuoteId1ForCompare(item === null || item === void 0 ? void 0 : item.quoteId);
            setProductId1ForCompare(item === null || item === void 0 ? void 0 : item.productId);
          } else {
            setQuoteId2ForCompare(item === null || item === void 0 ? void 0 : item.quoteId);
            setProductId2ForCompare(item === null || item === void 0 ? void 0 : item.productId);
          }
        } else {
          setCount(count - 1);

          if ((item === null || item === void 0 ? void 0 : item.quoteId) == quoteId1ForCompare) {
            setQuoteId1ForCompare(quoteId2ForCompare);
            setProductId1ForCompare(productId2ForCompare);
          }

          setQuoteId2ForCompare("");
          setProductId2ForCompare("");
        }
      }

      return item;
    }));
  };

  useEffect(function () {
    if (count === 1) {
      setComparePlanText("1/2 Products Selected");
    } else if (count > 1) {
      setComparePlanText("2/2 Products Selected");
    } else {
      setComparePlanText("0/2 Products Selected");
    }
  }, [count]);

  var _useState14 = useState(false),
      showCompareNow = _useState14[0],
      setShowCompareNow = _useState14[1];

  var handleSelectCompare = function handleSelectCompare() {
    if (!showCompareNow) {
      InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
        actionType: "comparenow_opened"
      });
    }

    setShowCompareNow(!showCompareNow);
  };

  var buyProduct = function buyProduct(quoteId, productId) {
    var searchParams = new URLSearchParams(window.location.search);
    var queryParams = Object.fromEntries(searchParams.entries());

    var params = InsurancePlans_objectSpread(InsurancePlans_objectSpread({}, queryParams), {}, {
      countries: searchParams.get("countries"),
      startDate: searchParams.get("startDate"),
      endDate: searchParams.get("endDate"),
      travellers: searchParams.get("travellers"),
      isUpcomingTrip: searchParams.has("isUpcomingTrip") ? searchParams.get("isUpcomingTrip") : false,
      productId: productId,
      quoteId: quoteId
    });

    navigationActions.navigateToTravellerDetails(params);
  };

  useEffect(function () {
    if (showTagData) {
      setPlanSelected(data);
      var tempTagData = showTagData === null || showTagData === void 0 ? void 0 : showTagData.filter(function (tagData) {
        return (tagData === null || tagData === void 0 ? void 0 : tagData.isSelected) === true;
      }).map(function (item) {
        return item.plans;
      });
      var tempResult = [];
      tempTagData === null || tempTagData === void 0 ? void 0 : tempTagData.map(function (item) {
        item.map(function (tempItem) {
          return tempResult.push(tempItem);
        });
      });
      var result = data === null || data === void 0 ? void 0 : data.filter(function (plan) {
        return tempResult === null || tempResult === void 0 ? void 0 : tempResult.includes(Number(plan === null || plan === void 0 ? void 0 : plan.productId));
      });
      (result === null || result === void 0 ? void 0 : result.length) && setPlanSelected(result);
    }
  }, [showTagData]); // TODO: add logic to compare productId from comparisonIds

  var closeToast = function closeToast() {
    setComparePlanData([]);
    setPlanSelected(planSelected === null || planSelected === void 0 ? void 0 : planSelected.map(function (item) {
      item.selectedForCompare = false;
      return item;
    }));
    data === null || data === void 0 ? void 0 : data.map(function (item) {
      item.selectedForCompare = false;
    });
    return setCount(0);
  };

  useEffect(function () {
    if (count === 2) setIsDisable(false);else setIsDisable(true);
  }, [count]);
  return /*#__PURE__*/_jsxs(InsurancePlansStyle, {
    children: [/*#__PURE__*/_jsx(H5Tag, {
      margin: "0 0 16px",
      children: title && /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }), sumInsTxt && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.greyText,
      fontSize: "sm",
      fontWeight: "black",
      margin: "0 0 8px",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: sumInsTxt
      })
    }), tagData && /*#__PURE__*/_jsx(FlexComp, {
      alignItems: device == "lg" ? "center" : "flex-start",
      justifyContent: "space-between",
      margin: device == "lg" ? "0 0 40px" : "0 0 24px",
      gap: "10px",
      flexDirection: device == "lg" ? "row" : "column",
      children: /*#__PURE__*/_jsx(Tags, {
        handleClickTab: handleTabIndex,
        data: showTagData
      })
    }), planSelected === null || planSelected === void 0 ? void 0 : planSelected.map(function (item, index) {
      var _item$packName, _item$packName$text, _item$packName$text$v, _item$packName$text$v2;

      var productType = // @ts-ignore
      item === null || item === void 0 ? void 0 : (_item$packName = item.packName) === null || _item$packName === void 0 ? void 0 : (_item$packName$text = _item$packName.text) === null || _item$packName$text === void 0 ? void 0 : (_item$packName$text$v = _item$packName$text.value) === null || _item$packName$text$v === void 0 ? void 0 : (_item$packName$text$v2 = _item$packName$text$v.toLowerCase) === null || _item$packName$text$v2 === void 0 ? void 0 : _item$packName$text$v2.call(_item$packName$text$v);
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(InsurancePlansComp, {
          data: item,
          handleCompareSelect: function handleCompareSelect() {
            return handlePlanSelected(item === null || item === void 0 ? void 0 : item.productId);
          },
          handleMoreBenefits: function handleMoreBenefits() {
            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "View_details_".concat(productType)
            });
            toggleBenefitsModal(index);
          },
          handleTravAssist: function handleTravAssist() {
            _handleTravAssist(index);

            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "View_details_".concat(productType)
            });
          },
          handleBuyButton: function handleBuyButton(data) {
            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "buy_now_clicked_outside_".concat(productType)
            });
            buyProduct(data === null || data === void 0 ? void 0 : data.quoteId, data === null || data === void 0 ? void 0 : data.productId);
          }
        }, index), showBenefits === index && /*#__PURE__*/_jsx(MoreBenefits, {
          handleClose: function handleClose() {
            return toggleBenefitsModal(index);
          },
          moreBenfitsTitle: "".concat(item === null || item === void 0 ? void 0 : item.totalBenefits, " Benefits"),
          data: item,
          handleBuyButton: function handleBuyButton(data) {
            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "buy_now_clicked_details_".concat(productType)
            });
            buyProduct(data === null || data === void 0 ? void 0 : data.quoteId, data === null || data === void 0 ? void 0 : data.productId);
          }
        }), showTravAssist == index && /*#__PURE__*/_jsx(TravelAssistanceModal, {
          data: item,
          handleTravAssist: function handleTravAssist() {
            return _handleTravAssist(index);
          },
          travelAssistTitle: "Travel Assistance" // should come from CB

        })]
      }, index);
    }), showFilter && /*#__PURE__*/_jsx(FilterPlans, {
      tagData: tagData,
      btnText: "Apply Filter",
      filterData: filterData,
      title: "Filter Plan",
      filterPlanHandleClick: handleShowFilter
    }), count > 0 && /*#__PURE__*/_jsx(ToastCompare, {
      toastCloseIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
      toastIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/toast_Icon_4389f5385c.svg",
      planSelectedTxt: comparePlanText,
      toastCtaTxt: compareToastData === null || compareToastData === void 0 ? void 0 : compareToastData.toastCtaTxt,
      handleClickCta: handleSelectCompare,
      handleClose: closeToast,
      isDisable: isDisable // greyBgCross={} // add in CB

    }), showCompareNow && comparePlan && /*#__PURE__*/_jsx(ComparePlan, {
      modalTitle: compareToastData === null || compareToastData === void 0 ? void 0 : compareToastData.modalTitle,
      data: comparePlan,
      handleClose: handleSelectCompare,
      handleBuyButton: function handleBuyButton(quoteId, productId) {
        InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
          actionType: "buy_from_compare"
        });
        buyProduct(quoteId, productId);
      },
      productId1ForCompare: productId1ForCompare,
      quoteId1ForCompare: quoteId1ForCompare,
      productId2ForCompare: productId2ForCompare,
      quoteId2ForCompare: quoteId2ForCompare
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlans = ((/* unused pure expression or super */ null && (InsurancePlans)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansCompShimmer.tsx







var InsurancePlansCompShimmer_InsurancePlansCompShimmer = function InsurancePlansCompShimmer(_ref) {
  var data = _ref.data;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(InsurancePlansCompStyle, {
    children: [/*#__PURE__*/_jsx(PlanHeader, {
      children: (data === null || data === void 0 ? void 0 : data.packName) && /*#__PURE__*/_jsx(SpanTag // color={data?.packNameColor}
      , {
        fontSize: "sm",
        fontWeight: "bold",
        textTransform: "uppercase",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: data === null || data === void 0 ? void 0 : data.packName
        })
      })
    }), /*#__PURE__*/_jsxs(InsurancePlanSection, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        gap: "16px",
        margin: "0 0 16px",
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
            width: device == "lg" ? "248px" : "200px",
            height: "22px",
            margin: "0 0 6px"
          }), /*#__PURE__*/_jsx(ShimmerVersion2, {
            width: device == "lg" ? "248px" : "200px",
            height: "16px"
          })]
        }), /*#__PURE__*/_jsx(ShimmerVersion3, {
          width: device == "lg" ? "120px" : "100px",
          height: "40px"
        })]
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "100%",
        height: "150px"
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlansCompShimmer = ((/* unused pure expression or super */ null && (InsurancePlansCompShimmer_InsurancePlansCompShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansShimmer.tsx








var InsurancePlansShimmer = function InsurancePlansShimmer(_ref) {
  var data = _ref.data;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(InsurancePlansStyle, {
    children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
      width: "100%",
      height: "28px",
      margin: "0 0 16px"
    }), /*#__PURE__*/_jsx(ShimmerVersion2, {
      width: "100%",
      height: "20px",
      margin: "0 0 8px"
    }), /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      margin: "0 0 40px",
      gap: "8px",
      children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "90px",
        height: "32px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "90px",
        height: "32px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "90px",
        height: "32px"
      })]
    }), data && data.map(function (item, index) {
      return /*#__PURE__*/_jsx(React.Fragment, {
        children: /*#__PURE__*/_jsx(InsurancePlansCompShimmer, {
          data: item
        }, index)
      }, index);
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlansShimmer = ((/* unused pure expression or super */ null && (InsurancePlansShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingEditDetails/ListingEditDetails.style.ts





var ListingEditDetails_style_ListingEditDetailsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingEditDetailsstyle__ListingEditDetailsStyle",
  componentId: "sc-18qpjo8-0"
})(["background:#fff;border:1px solid rgba(242,242,242,0.16);border-radius:8px;padding:24px;& > ", ":first-child{margin-bottom:8px;}@media ", "{padding:12px 16px;& > ", ":first-child{margin-bottom:0px;}}"], FlexCompStyle, static_utils/* deviceType.mobile */.vO.mobile, FlexCompStyle);
var ListingWidgetDetails = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingEditDetailsstyle__ListingWidgetDetails",
  componentId: "sc-18qpjo8-1"
})(["background:#f6f6f6;border-radius:4px;padding:12px;"]);
var ListingEditDetails_style_ListingSpan = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "ListingEditDetailsstyle__ListingSpan",
  componentId: "sc-18qpjo8-2"
})(["font-size:14px;line-height:20px;color:", ";padding-right:12px;margin-right:12px;position:relative;flex-shrink:0;&:last-child{border:none;flex-shrink:unset;}&:after{content:\"\";position:absolute;right:0;top:4px;width:1px;height:14px;background:#000;}&:last-child:after{width:0;}@media ", "{font-size:12px;}"], Global/* theme.blackText */.rS.blackText, static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryFormatter/index.tsx





function CountryFormatter_CountryFormatter(_ref) {
  var title = _ref.title;

  var _useState = useState(),
      country = _useState[0],
      setCountry = _useState[1];

  var _useState2 = useState(),
      count = _useState2[0],
      setCount = _useState2[1];

  useEffect(function () {
    if (title && (title === null || title === void 0 ? void 0 : title.length) > 30) {
      var _title$substring;

      var tempCountry = title === null || title === void 0 ? void 0 : (_title$substring = title.substring(0, 30)) === null || _title$substring === void 0 ? void 0 : _title$substring.split(/[,&]/);

      if (tempCountry.length > 1) {
        tempCountry.pop();
      }

      setCountry(tempCountry === null || tempCountry === void 0 ? void 0 : tempCountry.join(", "));
      var tempCount = title && (title === null || title === void 0 ? void 0 : title.split(/[,&]/).length) - tempCountry.length;
      setCount(tempCount);
    } else {
      setCountry(title);
    }
  }, [title]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [country, title && (title === null || title === void 0 ? void 0 : title.length) > 30 ? /*#__PURE__*/_jsx("span", {
      style: {
        fontSize: 12,
        marginLeft: 0,
        color: "#9B9B9B"
      },
      children: " ...  +".concat(count, " more")
    }) : null]
  });
}

/* harmony default export */ var components_CountryFormatter = ((/* unused pure expression or super */ null && (CountryFormatter_CountryFormatter)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingEditDetails/ListingEditDetails.tsx












var ListingEditDetails_analytics = getAnalytics();

var ListingEditDetails = function ListingEditDetails(_ref) {
  var mode = _ref.mode,
      title = _ref.title,
      travelPurpose = _ref.travelPurpose,
      travelDates = _ref.travelDates,
      travellerCount = _ref.travellerCount,
      showEditIcon = _ref.showEditIcon;
  var device = useBreakpointV2();

  var _ref2 = travelDates || {},
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  var handleEditClick = function handleEditClick() {
    ListingEditDetails_analytics === null || ListingEditDetails_analytics === void 0 ? void 0 : ListingEditDetails_analytics.trackListingEvents({
      actionType: "edit_clicked"
    });
    var referrer = document.referrer;
    var hostname = referrer ? new URL(referrer).hostname : "";

    if (hostname === "www.makemytrip.com" || hostname === "www.goibibo.com") {
      navigationActions.goBack();
    }

    var queryParams = new URLSearchParams(window.location.search);
    var params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers")
    };
    navigationActions.navigateToLanding(params, false);
  };

  return /*#__PURE__*/_jsxs(ListingEditDetailsStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "enter",
      justifyContent: "space-between",
      flexWrap: "wrap",
      children: [device == "lg" ? /*#__PURE__*/_jsx(H5Tag, {
        color: theme.blackText,
        children: title && /*#__PURE__*/_jsx(CountryFormatter, {
          title: title
        })
      }) : /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "md",
        fontWeight: "black",
        color: theme.blackText,
        children: title && /*#__PURE__*/_jsx(CountryFormatter, {
          title: title
        })
      }), showEditIcon && /*#__PURE__*/_jsx(AnchorTag, {
        handleClick: handleEditClick,
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: "25px",
          height: "25px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg"
        })
      })]
    }), /*#__PURE__*/_jsxs(FlexComp, {
      children: [mode && /*#__PURE__*/_jsx(ListingSpan, {
        color: theme.blackText,
        children: /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "md",
          color: theme.blackText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: mode
          })
        })
      }), startDate && endDate && /*#__PURE__*/_jsxs(ListingSpan, {
        color: theme.blackText,
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          color: theme.blackText,
          fontSize: "md",
          fontWeight: "black",
          children: [formatDate(startDate, DATE_FORMATS["D MMM"]), "'"]
        }), formatDate(startDate, DATE_FORMATS.YY), " -To-", " ", /*#__PURE__*/_jsxs(SpanTag, {
          color: theme.blackText,
          fontSize: "md",
          fontWeight: "black",
          children: [formatDate(endDate, DATE_FORMATS["D MMM"]), "'"]
        }), formatDate(endDate, DATE_FORMATS.YY)]
      }), travellerCount && /*#__PURE__*/_jsxs(ListingSpan, {
        color: theme.blackText,
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          color: theme.blackText,
          fontSize: "md",
          fontWeight: "bold",
          children: [travellerCount, "\xA0"]
        }), /*#__PURE__*/_jsx(SpanTag, {
          color: theme.blackText,
          fontSize: "md",
          children: travellerCount > 1 ? "Travellers" : "Traveller"
        })]
      })]
    })]
  });
};

/* harmony default export */ var ListingEditDetails_ListingEditDetails = ((/* unused pure expression or super */ null && (ListingEditDetails)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RadioButton/RadioButton.style.ts

var RadioButton_style_RadioButtonStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RadioButtonstyle__RadioButtonStyle",
  componentId: "zyhzua-0"
})(["", " display:flex;", " label{user-select:none;}input{display:none;}[type=\"radio\"]:checked,[type=\"radio\"]:not(:checked){position:absolute;left:-9999px;}[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{position:relative;padding-left:24px;cursor:pointer;display:inline-flex;color:#666;width:100%;", "}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{content:\"\";position:absolute;left:0;top:0px;width:15px;height:15px;border:1px solid #008cff;border-radius:100%;background:#fff;", "}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{content:\"\";width:9px;height:9px;background:#008cff;position:absolute;top:3px;left:3px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;", "}[type=\"radio\"]:not(:checked) + label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}[type=\"radio\"]:checked + label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}"], function (p) {
  return p.isPadding && "\n    padding: 16px 10px;\n";
}, function (p) {
  return p.showLabel && "\n        width: 100%;\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlan.style.ts


var ShowInsPlan_style_ShowInsPlanStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsPlanStyle",
  componentId: "sc-1vtw87g-0"
})(["border:1px solid #e8e8e8;border-radius:8px;flex:1;background:#fff;margin:", ";display:flex;flex-direction:column;", "{text-align:end;[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{padding-right:30px;}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{right:0;left:auto;}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{right:3px;left:auto;}}"], function (p) {
  return p.margin ? p.margin : "";
}, RadioButton_style_RadioButtonStyle);
var ShowInsPlan_style_ShowInsPlanCntnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsPlanCntnt",
  componentId: "sc-1vtw87g-1"
})(["padding:12px;"]);
var ShowInsPlan_style_ShowInsSelect = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsSelect",
  componentId: "sc-1vtw87g-2"
})(["background:#f6f6f6;border-radius:0px 0px 8px 8px;border-top:1px solid transparent;padding:8px 12px;display:flex;align-items:flex-end;margin-top:auto;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlan.tsx







var ShowInsPlan = function ShowInsPlan(_ref) {
  var data = _ref.data,
      margin = _ref.margin;

  var _useState = useState(-1),
      selectPlan = _useState[0],
      setSelectPlan = _useState[1];

  var handleSelectPlan = function handleSelectPlan(index) {
    setSelectPlan(index);
  };

  return /*#__PURE__*/_jsx(FlexComp, {
    gap: "12px",
    margin: margin,
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/_jsx(ShowInsPlanStyle, {
        onClick: function onClick() {
          return handleSelectPlan(index);
        },
        planSelected: selectPlan == index,
        children: /*#__PURE__*/_jsxs(ShowInsPlanCntnt, {
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            gap: "8px",
            alignItems: "center",
            margin: "0 0 8px",
            children: [item.planIcon && /*#__PURE__*/_jsx(ImageComponent, {
              width: "24px",
              height: "24px",
              src: item.planIcon
            }), item.title && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              color: theme.blackText,
              margin: "0 0 0 8px",
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: item.title
              })
            })]
          }), item.planInfo && /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.planInfo
            })
          })]
        })
      }, index);
    })
  });
};

/* harmony default export */ var ShowInsPlan_ShowInsPlan = ((/* unused pure expression or super */ null && (ShowInsPlan)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlanShimmer.tsx






var ShowInsPlanShimmer = function ShowInsPlanShimmer(_ref) {
  var data = _ref.data,
      margin = _ref.margin;
  return /*#__PURE__*/_jsx(FlexComp, {
    gap: "12px",
    margin: margin,
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/_jsxs(ShowInsPlanStyle, {
        children: [/*#__PURE__*/_jsxs(ShowInsPlanCntnt, {
          children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
            margin: "0 0 8px",
            width: "100%",
            height: "32px"
          }), /*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "100%",
            height: "48px"
          })]
        }), item.radioBtnLabel && /*#__PURE__*/_jsx(ShowInsSelect, {
          children: /*#__PURE__*/_jsx(RadioButton, {
            children: /*#__PURE__*/_jsx(ShimmerVersion3, {
              width: "58px",
              height: "26px"
            })
          })
        })]
      }, index);
    })
  });
};

/* harmony default export */ var ShowInsPlan_ShowInsPlanShimmer = ((/* unused pure expression or super */ null && (ShowInsPlanShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/FilterPlans.style.ts

var FilterPlansStyle = styled_components_browser_esm["default"].span.withConfig({
  displayName: "FilterPlansstyle__FilterPlansStyle",
  componentId: "sc-1psxbt6-0"
})(["position:relative;"]);
var FilterPlans_style_PlanTypeStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterPlansstyle__PlanTypeStyle",
  componentId: "sc-1psxbt6-1"
})(["background:#ffffff;padding:16px 0px;"]);
var FilterPlans_style_BtnWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterPlansstyle__BtnWrap",
  componentId: "sc-1psxbt6-2"
})(["padding:16px 30px;background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:0px 0px 20px 20px;position:sticky;bottom:-20px;margin:auto -30px -20px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/PlanTypeComp.tsx







var PlanTypeComp_PlanTypeComp = function PlanTypeComp(_ref) {
  var title = _ref.title,
      data = _ref.data,
      tagData = _ref.tagData,
      handleClickTab = _ref.handleClickTab;

  var _useState = useState(data),
      planData = _useState[0],
      setPlanData = _useState[1];

  var planTypeHandler = function planTypeHandler(id) {
    setPlanData(planData === null || planData === void 0 ? void 0 : planData.map(function (item) {
      if (id === item.id) {
        item.isSelected = !item.isSelected;
      }

      return item;
    }));
  };

  return /*#__PURE__*/_jsxs(PlanTypeStyle, {
    children: [title && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "md",
      fontWeight: "bold",
      color: theme.blackText,
      margin: "0 0 16px",
      children: title
    }), tagData && /*#__PURE__*/_jsx(Tags, {
      handleClickTab: handleClickTab,
      data: tagData
    }), data && data.map(function (item, index) {
      return /*#__PURE__*/_jsx(CheckButton // inputIndex={item.id}
      , {
        inputId: item.id,
        margin: index != data.length - 1 ? "0 0 16px" : "",
        isChecked: item.isSelected,
        handleChange: function handleChange() {
          return planTypeHandler(item.id);
        },
        children: /*#__PURE__*/_jsxs(FlexComp, {
          gap: "10px",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            gap: "0",
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(ParaTag, {
              fontSize: "md",
              color: theme.blackText,
              margin: "0 0 4px",
              children: item.planTitle
            }), item.planInfo && /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "xs",
              color: theme.greyText7,
              children: item.planInfo
            })]
          }), item.planIcon && /*#__PURE__*/_jsx(ImageComponent, {
            width: "24px",
            height: "24px",
            src: item.planIcon
          })]
        })
      });
    })]
  });
};

/* harmony default export */ var FilterPlans_PlanTypeComp = ((/* unused pure expression or super */ null && (PlanTypeComp_PlanTypeComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/FilterPlans.tsx







var FilterPlans_FilterPlans = function FilterPlans(_ref) {
  var title = _ref.title,
      btnText = _ref.btnText,
      filterData = _ref.filterData,
      tagData = _ref.tagData,
      filterPlanHandleClick = _ref.filterPlanHandleClick;

  var _useState = useState(tagData),
      tabIndex = _useState[0],
      setTabIndex = _useState[1];

  var handleTabIndex = function handleTabIndex(id) {
    setTabIndex(tagData === null || tagData === void 0 ? void 0 : tagData.map(function (item) {
      if (id === item.id) {
        item.isSelected = true;
      } else item.isSelected = false;

      return item;
    }));
  };

  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    customTitle: title,
    handleClick: filterPlanHandleClick,
    children: [/*#__PURE__*/_jsx(PlanTypeComp, {
      data: filterData === null || filterData === void 0 ? void 0 : filterData.popularData
    }), /*#__PURE__*/_jsx(SectionDividers, {
      small: true
    }), /*#__PURE__*/_jsx(PlanTypeComp, {
      data: filterData === null || filterData === void 0 ? void 0 : filterData.planType,
      title: "Plan Type"
    }), /*#__PURE__*/_jsx(SectionDividers, {
      small: true
    }), /*#__PURE__*/_jsx(PlanTypeComp, {
      tagData: tagData,
      title: "Sum Insured Per Traveller",
      handleClickTab: handleTabIndex
    }), /*#__PURE__*/_jsx(SectionDividers, {
      small: true
    }), /*#__PURE__*/_jsx(PlanTypeComp, {
      data: filterData === null || filterData === void 0 ? void 0 : filterData.benefits,
      title: "Benefits Included"
    }), /*#__PURE__*/_jsx(BtnWrap, {
      children: /*#__PURE__*/_jsx(LandingButton, {
        customTitle: btnText
      })
    })]
  });
};

/* harmony default export */ var components_FilterPlans_FilterPlans = ((/* unused pure expression or super */ null && (FilterPlans_FilterPlans)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingPageComponents/ListingPageComponents.style.ts



var ListingPageComponents_style_BMFListingContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__BMFListingContainer",
  componentId: "x42f4e-0"
})(["width:1200px;margin:", ";", " background-color:", ";@media screen and ", "{width:100%;}"], function (props) {
  return props.margin ? props.margin : "0px auto";
}, function (props) {
  return props.padding && "padding: ".concat(props.padding, ";");
}, Global/* theme.whiteText */.rS.whiteText, utils/* deviceType.mobile */.vO.mobile);
var ListingPageComponents_style_ArrowIconContainer = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ListingPageComponentsstyle__ArrowIconContainer",
  componentId: "x42f4e-1"
})(["transform:scale(-1);"]);
var ListingPageComponents_style_ListingTopContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__ListingTopContainer",
  componentId: "x42f4e-2"
})(["background-color:", ";padding:100px 0px 0px;@media screen and ", "{background-image:", ";background-repeat:no-repeat;background-size:100%;padding-bottom:unset;padding:unset;}"], Global/* theme.blackText */.rS.blackText, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return "url(".concat(props.bgImage, ")");
});
var ListingPageComponents_style_LandingCardFeatureCtr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__LandingCardFeatureCtr",
  componentId: "x42f4e-3"
})(["display:flex;gap:6px;@media screen and ", "{flex-direction:column;}"], utils/* deviceType.mobile */.vO.mobile);
var ListingPageComponents_style_MarkerContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__MarkerContainer",
  componentId: "x42f4e-4"
})(["display:flex;flex-direction:column;gap:12px;@media screen and ", "{padding:0px 16px 0px;}"], utils/* deviceType.mobile */.vO.mobile);
var ListingPageComponents_style_SpecialAttention = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingPageComponentsstyle__SpecialAttention",
  componentId: "x42f4e-5"
})(["overflow:hidden;border-radius:16px;background:white;", ""], function (props) {
  return props.withShadow && "box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingPageComponents/ListingPageHeader.tsx


function ListingPageHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ListingPageHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ListingPageHeader_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ListingPageHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var ListingPageHeader_ListingPageHeader = function ListingPageHeader(_ref) {
  var arrowIcon = _ref.arrowIcon,
      _ref$isLoggedIn = _ref.isLoggedIn,
      isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
      userAvatarImgURI = _ref.userAvatarImgURI,
      loginBtnProps = _ref.loginBtnProps;
  return /*#__PURE__*/_jsxs(FlexComp, {
    padding: "16px",
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(ArrowIconContainer, {
      children: arrowIcon ? /*#__PURE__*/_jsx(ImageTag, {
        src: arrowIcon
      }) : /*#__PURE__*/_jsx(ArrowIcon, {
        color: theme.greyText
      })
    }), isLoggedIn ? /*#__PURE__*/_jsx(LandingButtonWhite, ListingPageHeader_objectSpread({}, loginBtnProps)) : userAvatarImgURI && /*#__PURE__*/_jsx(ImageTag, {
      width: "24px",
      src: userAvatarImgURI
    })]
  });
};

/* harmony default export */ var ListingPageComponents_ListingPageHeader = ((/* unused pure expression or super */ null && (ListingPageHeader_ListingPageHeader)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/LocationFetching/LocationFetching.style.ts

var fadeIn = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);
var LocationFetching_style_LocationFetchingStyles = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LocationFetchingstyle__LocationFetchingStyles",
  componentId: "sc-1l55osv-0"
})(["background-color:black;background-image:", ";background-repeat:no-repeat;background-size:cover;height:100%;display:flex;flex-direction:column;"], function (props) {
  return props.bgImg && "url(".concat(props.bgImg, ");");
});
var LocationFetching_style_LocationLoading = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LocationFetchingstyle__LocationLoading",
  componentId: "sc-1l55osv-1"
})(["margin-top:70px;position:relative;width:208px;height:208px;display:flex;align-items:center;justify-content:center;animation:", " linear 0.2s;opacity:0;animation-fill-mode:forwards;"], fadeIn);
var LocationFetching_style_AbsIconContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LocationFetchingstyle__AbsIconContainer",
  componentId: "sc-1l55osv-2"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-100%);"]);
var LocationFetching_style_ConditionsText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LocationFetchingstyle__ConditionsText",
  componentId: "sc-1l55osv-3"
})(["margin:auto 0px 50px;width:285px;text-align:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/LocationFetching/LocationFetching.tsx









var LocationFetching = function LocationFetching(_ref) {
  var _ref$onModalClose = _ref.onModalClose,
      onModalClose = _ref$onModalClose === void 0 ? function () {} : _ref$onModalClose,
      arrowIcon = _ref.arrowIcon,
      userAvatarImgURI = _ref.userAvatarImgURI,
      fetchingIcon = _ref.fetchingIcon,
      fetchedIcon = _ref.fetchedIcon,
      loadingText = _ref.loadingText,
      loadingDoneText = _ref.loadingDoneText,
      conditionsText = _ref.conditionsText,
      headingText = _ref.headingText,
      loadingGifURI = _ref.loadingGifURI,
      _ref$isFetchingDone = _ref.isFetchingDone,
      isFetchingDone = _ref$isFetchingDone === void 0 ? true : _ref$isFetchingDone,
      _ref$showDeliveryIcon = _ref.showDeliveryIcon,
      showDeliveryIcon = _ref$showDeliveryIcon === void 0 ? false : _ref$showDeliveryIcon,
      bgImg = _ref.bgImg;
  return /*#__PURE__*/_jsx(Modal, {
    padding: "0px",
    modalType: "fullPage",
    onModalClose: onModalClose,
    children: /*#__PURE__*/_jsxs(LocationFetchingStyles, {
      bgImg: bgImg,
      children: [/*#__PURE__*/_jsx(ListingPageHeader, {
        arrowIcon: arrowIcon,
        userAvatarImgURI: userAvatarImgURI
      }), /*#__PURE__*/_jsx(FlexComp, {
        padding: "0px 16px",
        children: /*#__PURE__*/_jsx(CliptextStyle, {
          children: /*#__PURE__*/_jsx(H4Tag, {
            children: headingText
          })
        })
      }), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        flex: "1",
        alignItems: "center",
        children: [/*#__PURE__*/_jsxs(LocationLoading, {
          children: [!isFetchingDone ? /*#__PURE__*/_jsx(AbsIconContainer, {
            children: fetchingIcon ? /*#__PURE__*/_jsx(ImageTag, {
              src: fetchingIcon
            }) : /*#__PURE__*/_jsx(LocationFetchingIcon, {})
          }) : /*#__PURE__*/_jsx(AbsIconContainer, {
            children: fetchedIcon ? /*#__PURE__*/_jsx(ImageTag, {
              src: fetchedIcon
            }) : /*#__PURE__*/_jsx(LocationMarkerWithCheck, {})
          }), loadingGifURI && !isFetchingDone && /*#__PURE__*/_jsx(ImageTag, {
            src: loadingGifURI
          })]
        }), !isFetchingDone ? !!loadingText && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          margin: "16px 0px 0px",
          color: theme.greyText,
          children: loadingText
        }) : !!loadingDoneText && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(DeliveryPersuasion, {
            bgColor: "",
            fontSize: "sm",
            padding: "0px",
            text: loadingDoneText,
            showIcon: showDeliveryIcon,
            margin: "16px 0px 12px 0px"
          }), conditionsText && /*#__PURE__*/_jsx(ConditionsText, {
            children: /*#__PURE__*/_jsxs(ParaTag, {
              fontSize: "xs",
              color: theme.greyText,
              children: [!!conditionsText.greenText && /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "xs",
                color: theme.greenText,
                children: conditionsText.greenText
              }), " ", !!conditionsText.normalText && conditionsText.normalText]
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var LocationFetching_LocationFetching = ((/* unused pure expression or super */ null && (LocationFetching)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/NoPincodeRecommendation/NoPincodeRecommendation.style.ts


var NoPincodeRecommendation_style_NoPincodeRecommendtnStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NoPincodeRecommendationstyle__NoPincodeRecommendtnStyle",
  componentId: "q1w4vy-0"
})(["display:flex;align-items:center;justify-content:center;background:linear-gradient(0deg,#454545 0%,rgba(0,0,0,1) 30%);height:500px;@media ", "{height:100%;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/NoPincodeRecommendation/NoPincodeRecommendation.tsx


function NoPincodeRecommendation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NoPincodeRecommendation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NoPincodeRecommendation_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NoPincodeRecommendation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var NoPincodeRecommendation = function NoPincodeRecommendation(_ref) {
  var label = _ref.label,
      _ref$onModalClose = _ref.onModalClose,
      onModalClose = _ref$onModalClose === void 0 ? function () {} : _ref$onModalClose,
      subLabel = _ref.subLabel,
      loadingText = _ref.loadingText,
      inputFieldOptions = _ref.inputFieldOptions,
      isLoading = _ref.isLoading,
      linkBtn = _ref.linkBtn,
      solidBtnProps = _ref.solidBtnProps;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    padding: "0px",
    modalWidth: 480,
    onModalClose: onModalClose,
    modalType: device === "lg" ? "centered" : "fullPage",
    children: /*#__PURE__*/_jsx(NoPincodeRecommendtnStyle, {
      children: isLoading ? loadingText && /*#__PURE__*/_jsx(ParaTag, {
        color: theme.greyText,
        textAlign: "center",
        children: loadingText
      }) : /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          width: "312px",
          alignItems: "center",
          flexDirection: "column",
          margin: device === "lg" ? "-50px 0px 0px" : "0px",
          children: [label && /*#__PURE__*/_jsx(ParaTag, {
            textAlign: "center",
            fontSize: "md",
            color: theme.whiteText,
            fontWeight: "bold",
            children: label
          }), subLabel && /*#__PURE__*/_jsx(ParaTag, {
            margin: "5px 0px 0px",
            fontSize: "xs",
            color: theme.whiteText,
            children: subLabel
          }), inputFieldOptions && /*#__PURE__*/_jsx(TMFloatingInput, NoPincodeRecommendation_objectSpread({
            margin: device === "sm" ? "50px 0px 0px" : "24px 0px 0px",
            inputWidth: "100%"
          }, inputFieldOptions))]
        }), (solidBtnProps || linkBtn) && /*#__PURE__*/_jsxs(ButtonContainer, {
          children: [linkBtn && /*#__PURE__*/_jsx(AnchorTag, {
            fontWeight: "bold",
            margin: "0px 0px 18px 0px",
            hrefProp: linkBtn.hrefValue,
            handleClick: linkBtn.onClick,
            children: linkBtn.title
          }), solidBtnProps && /*#__PURE__*/_jsx(LandingButtonWhite, NoPincodeRecommendation_objectSpread({
            customWidth: "100%"
          }, solidBtnProps))]
        })]
      })
    })
  });
};

/* harmony default export */ var NoPincodeRecommendation_NoPincodeRecommendation = ((/* unused pure expression or super */ null && (NoPincodeRecommendation)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/BenefitItem.tsx








var BenefitItem_BenefitItem = function BenefitItem(_ref) {
  var data = _ref.data,
      benefitName = _ref.benefitName,
      isAddOnBenefits = _ref.isAddOnBenefits;
  var device = useBreakpointV2();

  var _useState = useState(true),
      benefitOpen = _useState[0],
      setBenefit = _useState[1];

  var handleBenefit = function handleBenefit() {
    setBenefit(!benefitOpen);
  };

  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      gap: device == "lg" ? "24px" : "16px",
      handleClick: handleBenefit,
      children: [benefitName && isAddOnBenefits ? /*#__PURE__*/_jsx(BenefitName, {
        color: device == "lg" ? theme.greyText : theme.greyText7,
        children: benefitName
      }) : /*#__PURE__*/_jsxs(BenefitName, {
        color: device == "lg" ? theme.greyText : theme.greyText7,
        children: [data && data.length, " \xA0", benefitName]
      }), /*#__PURE__*/_jsx(EmptyBorder, {}), !isAddOnBenefits && /*#__PURE__*/_jsx(GreyChevWrap, {
        chevOpen: benefitOpen,
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: "32px",
          height: "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/Grey_Bg_Chev_81a870a4f8.svg"
        })
      })]
    }), benefitOpen && data && (data === null || data === void 0 ? void 0 : data.map(function (item2, index2) {
      return /*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "flex-start",
        gap: "20px",
        children: [item2.icon && /*#__PURE__*/_jsx(ImageComponent, {
          src: item2.icon,
          height: device == "lg" ? "30" : "20px",
          width: device == "lg" ? "30" : "20px"
        }), /*#__PURE__*/_jsxs(FlexComp, {
          width: "100%",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            justifyContent: "space-between",
            gap: "8px",
            children: [item2.title && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              color: theme.blackText,
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: item2.title
              })
            }), item2.price && /*#__PURE__*/_jsx(BenefitPrice, {
              txtfontSize: "xs",
              txtcolor: theme.greenText,
              txtfontWeight: "bold",
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: item2.price
              })
            })]
          }), item2.info && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item2.info
            })
          })]
        })]
      }, index2);
    }))]
  });
};

/* harmony default export */ var InsurancePlans_BenefitItem = ((/* unused pure expression or super */ null && (BenefitItem_BenefitItem)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Tags/Tags.style.ts

var Tags_style_TagsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Tagsstyle__TagsStyle",
  componentId: "c49c5y-0"
})(["display:flex;overflow-x:scroll;gap:8px;flex-shrink:0;&::-webkit-scrollbar{display:none;}"]);
var Tags_style_TagItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Tagsstyle__TagItem",
  componentId: "c49c5y-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:4px 10px;cursor:pointer;flex-shrink:0;", ""], function (p) {
  return p.isSelected && "\nbackground: #F8FBFF;\nborder: 1px solid #008CFF;\nborder-radius: 6px;\n";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Tags/Tags.tsx






var Tags_Tags = function Tags(_ref) {
  var data = _ref.data,
      handleClickTab = _ref.handleClickTab;
  return /*#__PURE__*/_jsx(TagsStyle, {
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/_jsx(TagItem, {
        isSelected: item.isSelected,
        onClick: handleClickTab ? function () {
          return handleClickTab(index);
        } : function () {},
        children: /*#__PURE__*/_jsx(SpanTag, {
          color: item.isSelected ? theme.blueText : theme.greyText,
          fontSize: "xs",
          fontWeight: "black",
          children: item.name
        })
      }, index);
    })
  });
};

/* harmony default export */ var components_Tags_Tags = ((/* unused pure expression or super */ null && (Tags_Tags)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/NoInsurancePlan/NoInsurancePlan.style.ts

var NoInsurancePlan_style_NoInsurancePlanStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NoInsurancePlanstyle__NoInsurancePlanStyle",
  componentId: "qwiuqk-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;padding:32px;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/NoInsurancePlan/NoInsurancePlan.tsx









var NoInsurancePlan = function NoInsurancePlan(_ref) {
  var title = _ref.title,
      info = _ref.info;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(NoInsurancePlanStyle, {
    children: ["\xA0\xA0", " ", /*#__PURE__*/_jsx(ImageComponent, {
      width: "80px",
      height: "80px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/No_Ins_Icon_55794fe5f5.svg"
    }), title && /*#__PURE__*/_jsx(ParaTag, {
      margin: device == "lg" ? "24px 0 8px" : "32px 0 32px",
      fontSize: "large",
      fontWeight: "bold",
      color: theme.blackText,
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }), info && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "sm",
      color: theme.greyText7,
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: info
      })
    })]
  });
};

/* harmony default export */ var NoInsurancePlan_NoInsurancePlan = ((/* unused pure expression or super */ null && (NoInsurancePlan)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx







var CommonModalDweb_CommonModalDweb = function CommonModalDweb(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      handleClick = _ref.handleClick,
      requiredField = _ref.requiredField,
      crossIcon = _ref.crossIcon,
      customWidth = _ref.customWidth,
      customIcon = _ref.customIcon,
      errorModal = _ref.errorModal,
      nonClipHeading = _ref.nonClipHeading;
  useEffect(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  useEffect(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
    return function () {};
  }, []);
  return /*#__PURE__*/_jsxs(ReactPortalComp, {
    children: [/*#__PURE__*/_jsxs(CommonModalDwebStyle, {
      customWidth: customWidth,
      children: [/*#__PURE__*/_jsxs(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        children: [/*#__PURE__*/_jsxs(H5Tag, {
          color: errorModal ? theme.redText : theme.blackText,
          children: [customIcon && /*#__PURE__*/_jsx(ImageComponent, {
            width: "40px",
            height: "40px",
            src: customIcon
          }), customTitle && /*#__PURE__*/_jsx(FormattedText, {
            value: customTitle
          })]
        }), /*#__PURE__*/_jsx(CrossIconWrap, {
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg"
          })
        })]
      }), children]
    }), /*#__PURE__*/_jsx(BackDropComp, {
      onClose: handleClick
    })]
  });
};

/* harmony default export */ var components_CommonModalDweb_CommonModalDweb = ((/* unused pure expression or super */ null && (CommonModalDweb_CommonModalDweb)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/ComparePlan.style.ts




var ComparePlan_style_BenefitRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ComparePlanstyle__BenefitRow",
  componentId: "sc-1pkokku-0"
})(["display:flex;border-bottom:1px solid #d3d9df;gap:10px;", " ", "{height:32px;}", " span{font-size:12px;}@media ", "{gap:0;}"], function (p) {
  return p.lastRow && "\n    border-bottom: none;\n    ";
}, LandingButton_style_LandingButtonStyle, LandingButton_style_LandingButtonStyle, static_utils/* deviceType.mobile */.vO.mobile);
var ComparePlan_style_BenefitCol1 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol1",
  componentId: "sc-1pkokku-1"
})(["display:flex;gap:10px;flex:1.5;padding:12px;@media ", "{padding:12px 4px;flex:1.7;}"], static_utils/* deviceType.mobile */.vO.mobile);
var ComparePlan_style_BenefitCol2 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol2",
  componentId: "sc-1pkokku-2"
})(["flex:1.2;display:flex;flex-direction:column;gap:10px;border-left:solid 1px #d3d9df;border-right:solid 1px #d3d9df;padding:12px;", " ", " @media ", "{border-right:none;padding:12px 10px;", "}"], function (p) {
  return p.firstRow && "\n    border-top:solid 1px #d3d9df;\n    border-radius:8px 8px 0 0;\n    ";
}, function (p) {
  return p.lastRow && "\n    border-bottom:solid 1px #d3d9df;\n    border-radius:0 0 8px 8px;\n    ";
}, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.firstRow && "\n    border-radius:8px 0px 0 0;\n    ";
});
var ComparePlan_style_BenefitCol3 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol3",
  componentId: "sc-1pkokku-3"
})(["flex:1.2;display:flex;flex-direction:column;gap:10px;border-left:solid 1px #d3d9df;border-right:solid 1px #d3d9df;padding:12px;", " ", " @media ", "{padding:12px 10px;", "}"], function (p) {
  return p.firstRow && "\n    border-top:solid 1px #d3d9df;\n    border-radius:8px 8px 0 0;\n    ";
}, function (p) {
  return p.lastRow && "\n    border-bottom:solid 1px #d3d9df;\n    border-radius:0 0 8px 8px;\n    ";
}, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.firstRow && "\n    border-top:solid 1px #d3d9df;\n    border-radius:0px 8px 0 0;\n    ";
});
var ComparePlan_style_BenefitDescHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ComparePlanstyle__BenefitDescHeader",
  componentId: "sc-1pkokku-4"
})(["background:rgba(0,0,0,0.04);border-radius:4px;display:flex;gap:10px;", "{flex-shrink:0;}@media ", "{gap:0;}"], SpanTagStyle, static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanBenefit.tsx








var PlanBenefit_PlanBenefit = function PlanBenefit(_ref) {
  var _benefitData$label, _benefitData$label2, _benefitData$label3, _benefitData$label4, _benefitData$data, _benefitData$data$quo, _benefitData$data2, _benefitData$data3, _benefitData$data4;

  var benefitData = _ref.benefitData,
      quoteID1 = _ref.quoteID1,
      quoteID2 = _ref.quoteID2;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(BenefitRow, {
    children: [/*#__PURE__*/_jsxs(BenefitCol1, {
      children: [(benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label = benefitData.label) === null || _benefitData$label === void 0 ? void 0 : _benefitData$label.icon) && /*#__PURE__*/_jsx(ImageComponent, {
        src: benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label2 = benefitData.label) === null || _benefitData$label2 === void 0 ? void 0 : _benefitData$label2.icon,
        height: "20",
        width: "20"
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        children: (benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label3 = benefitData.label) === null || _benefitData$label3 === void 0 ? void 0 : _benefitData$label3.text) && /*#__PURE__*/_jsx(FormattedText, {
          value: benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label4 = benefitData.label) === null || _benefitData$label4 === void 0 ? void 0 : _benefitData$label4.text
        })
      })]
    }), /*#__PURE__*/_jsx(BenefitCol2, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: device == "lg" ? "black" : "bold",
        color: benefitData !== null && benefitData !== void 0 && (_benefitData$data = benefitData.data) !== null && _benefitData$data !== void 0 && (_benefitData$data$quo = _benefitData$data[quoteID1]) !== null && _benefitData$data$quo !== void 0 && _benefitData$data$quo.text ? theme.blackText : theme.redText2,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: (benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$data2 = benefitData.data) === null || _benefitData$data2 === void 0 ? void 0 : _benefitData$data2[quoteID1]) || "NA"
        })
      })
    }), /*#__PURE__*/_jsx(BenefitCol3, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: device == "lg" ? "black" : "bold",
        color: benefitData !== null && benefitData !== void 0 && (_benefitData$data3 = benefitData.data) !== null && _benefitData$data3 !== void 0 && _benefitData$data3[quoteID2] ? theme.blackText : theme.redText2,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: (benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$data4 = benefitData.data) === null || _benefitData$data4 === void 0 ? void 0 : _benefitData$data4[quoteID2]) || "NA"
        })
      })
    })]
  });
};

/* harmony default export */ var ComparePlan_PlanBenefit = ((/* unused pure expression or super */ null && (PlanBenefit_PlanBenefit)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanTable.tsx










var PlanTable_PlanTable = function PlanTable(_ref) {
  var _data$header, _data$header2, _data$header3, _data$header4;

  var data = _ref.data,
      quoteID1 = _ref.quoteID1,
      quoteID2 = _ref.quoteID2;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.header) && /*#__PURE__*/_jsxs(BenefitRow, {
      lastRow: true,
      children: [/*#__PURE__*/_jsx(BenefitCol1, {}), /*#__PURE__*/_jsx(BenefitCol2, {
        firstRow: true,
        children: /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          fontWeight: "black",
          color: theme.purpleTxt,
          children: (data === null || data === void 0 ? void 0 : (_data$header = data.header) === null || _data$header === void 0 ? void 0 : _data$header[quoteID1]) && /*#__PURE__*/_jsx(FormattedText, {
            value: data === null || data === void 0 ? void 0 : (_data$header2 = data.header) === null || _data$header2 === void 0 ? void 0 : _data$header2[quoteID1]
          })
        })
      }), /*#__PURE__*/_jsx(BenefitCol3, {
        firstRow: true,
        children: /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          fontWeight: "black",
          color: theme.berryTxt,
          children: (data === null || data === void 0 ? void 0 : (_data$header3 = data.header) === null || _data$header3 === void 0 ? void 0 : _data$header3[quoteID2]) && /*#__PURE__*/_jsx(FormattedText, {
            value: data === null || data === void 0 ? void 0 : (_data$header4 = data.header) === null || _data$header4 === void 0 ? void 0 : _data$header4[quoteID2]
          })
        })
      })]
    }), (data === null || data === void 0 ? void 0 : data.body) && (data === null || data === void 0 ? void 0 : data.body.map(function (item, index) {
      return /*#__PURE__*/_jsx(React.Fragment, {
        children: item.type == "benefit" ? /*#__PURE__*/_jsx(PlanBenefit, {
          benefitData: item,
          quoteID1: quoteID1,
          quoteID2: quoteID2
        }, index) : /*#__PURE__*/_jsxs(BenefitDescHeader, {
          children: [/*#__PURE__*/_jsx(BenefitCol1, {
            children: /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: device == "lg" ? theme.blackText : theme.greyText7,
              fontWeight: device == "lg" ? "black" : "bold",
              textTransform: device == "sm" ? "uppercase" : undefined,
              children: item.label.text
            })
          }), /*#__PURE__*/_jsx(BenefitCol2, {}), /*#__PURE__*/_jsx(BenefitCol3, {})]
        })
      });
    }))]
  });
};

/* harmony default export */ var ComparePlan_PlanTable = ((/* unused pure expression or super */ null && (PlanTable_PlanTable)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanTableFooter.tsx







var PlanTableFooter_PlanTableFooter = function PlanTableFooter(_ref) {
  var _footerData$data, _footerData$data$quot, _footerData$data2, _footerData$data2$quo, _footerData$data3, _footerData$data3$quo, _footerData$data4, _footerData$data4$quo;

  var btn1Handler = _ref.btn1Handler,
      btn2Handler = _ref.btn2Handler,
      footerData = _ref.footerData,
      quoteID1 = _ref.quoteID1,
      quoteID2 = _ref.quoteID2;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(BenefitRow, {
    lastRow: true,
    children: [footerData && /*#__PURE__*/_jsx(BenefitCol1, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        children: (footerData === null || footerData === void 0 ? void 0 : footerData.label) && /*#__PURE__*/_jsx(FormattedText, {
          value: footerData === null || footerData === void 0 ? void 0 : footerData.label
        })
      })
    }), footerData && /*#__PURE__*/_jsxs(BenefitCol2, {
      lastRow: true,
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "black",
        children: /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          children: (footerData === null || footerData === void 0 ? void 0 : (_footerData$data = footerData.data) === null || _footerData$data === void 0 ? void 0 : (_footerData$data$quot = _footerData$data[quoteID1]) === null || _footerData$data$quot === void 0 ? void 0 : _footerData$data$quot.label) && /*#__PURE__*/_jsx(FormattedText, {
            value: footerData === null || footerData === void 0 ? void 0 : (_footerData$data2 = footerData.data) === null || _footerData$data2 === void 0 ? void 0 : (_footerData$data2$quo = _footerData$data2[quoteID1]) === null || _footerData$data2$quo === void 0 ? void 0 : _footerData$data2$quo.label
          })
        })
      }), /*#__PURE__*/_jsx(LandingButton, {
        onClick: btn1Handler,
        customTitle: device == "lg" ? "BUY PLAN" : "BUY",
        customWidth: "100%"
      })]
    }), footerData && /*#__PURE__*/_jsxs(BenefitCol3, {
      lastRow: true,
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        children: /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          children: (footerData === null || footerData === void 0 ? void 0 : (_footerData$data3 = footerData.data) === null || _footerData$data3 === void 0 ? void 0 : (_footerData$data3$quo = _footerData$data3[quoteID2]) === null || _footerData$data3$quo === void 0 ? void 0 : _footerData$data3$quo.label) && /*#__PURE__*/_jsx(FormattedText, {
            value: footerData === null || footerData === void 0 ? void 0 : (_footerData$data4 = footerData.data) === null || _footerData$data4 === void 0 ? void 0 : (_footerData$data4$quo = _footerData$data4[quoteID2]) === null || _footerData$data4$quo === void 0 ? void 0 : _footerData$data4$quo.label
          })
        })
      }), /*#__PURE__*/_jsx(LandingButton, {
        onClick: btn2Handler,
        customTitle: device == "lg" ? "BUY PLAN" : "BUY",
        customWidth: "100%"
      })]
    })]
  });
};

/* harmony default export */ var ComparePlan_PlanTableFooter = ((/* unused pure expression or super */ null && (PlanTableFooter_PlanTableFooter)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/ComparePlan.tsx







var ComparePlan_ComparePlan = function ComparePlan(_ref) {
  var handleClose = _ref.handleClose,
      modalTitle = _ref.modalTitle,
      data = _ref.data,
      handleBuyButton = _ref.handleBuyButton,
      productId1ForCompare = _ref.productId1ForCompare,
      quoteId1ForCompare = _ref.quoteId1ForCompare,
      productId2ForCompare = _ref.productId2ForCompare,
      quoteId2ForCompare = _ref.quoteId2ForCompare;
  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    customWidth: "524px",
    customTitle: modalTitle,
    handleClick: handleClose,
    children: [/*#__PURE__*/_jsx(PlanTable, {
      data: data,
      quoteID1: quoteId1ForCompare,
      quoteID2: quoteId2ForCompare
    }), /*#__PURE__*/_jsx(PlanTableFooter, {
      btn1Handler: function btn1Handler() {
        return handleBuyButton(quoteId1ForCompare, productId1ForCompare);
      },
      btn2Handler: function btn2Handler() {
        return handleBuyButton(quoteId2ForCompare, productId2ForCompare);
      },
      footerData: data === null || data === void 0 ? void 0 : data.footer,
      quoteID1: quoteId1ForCompare,
      quoteID2: quoteId2ForCompare
    })]
  });
};

/* harmony default export */ var components_ComparePlan_ComparePlan = ((/* unused pure expression or super */ null && (ComparePlan_ComparePlan)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/Toast.tsx








var Toast_Toast = function Toast(_ref) {
  var toastCtaTxt = _ref.toastCtaTxt,
      planSelectedTxt = _ref.planSelectedTxt,
      handleClickCta = _ref.handleClickCta,
      handleClose = _ref.handleClose,
      _ref$autoCloseDuratio = _ref.autoCloseDuration,
      autoCloseDuration = _ref$autoCloseDuratio === void 0 ? 3000 : _ref$autoCloseDuratio,
      toastCloseIcon = _ref.toastCloseIcon,
      toastIcon = _ref.toastIcon,
      isDisable = _ref.isDisable,
      showToast = _ref.showToast,
      width = _ref.width,
      height = _ref.height,
      _ref$onTimerEnd = _ref.onTimerEnd,
      onTimerEnd = _ref$onTimerEnd === void 0 ? function () {} : _ref$onTimerEnd;
  var device = useBreakpoint();

  var _useState = useState(true),
      visible = _useState[0],
      setVisible = _useState[1];

  useEffect(function () {
    var timer;

    if (autoCloseDuration) {
      timer = setTimeout(function () {
        if (visible) {
          setVisible(false);
          onTimerEnd();
        }
      }, autoCloseDuration);
    }

    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [autoCloseDuration, visible]);
  return visible ? /*#__PURE__*/_jsxs(ToastStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: device == "lg" ? "16px" : "4px",
      alignItems: "center",
      children: [toastIcon && /*#__PURE__*/_jsx(ToastIcon, {
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: width ? width : "24px",
          height: height ? height : "24px",
          src: toastIcon
        })
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: device == "lg" ? "md" : "xs",
        color: theme.whiteText,
        children: planSelectedTxt && /*#__PURE__*/_jsx(FormattedText, {
          value: planSelectedTxt
        })
      }), toastCtaTxt && /*#__PURE__*/_jsx(LandingButtonWhite, {
        customTitle: toastCtaTxt,
        onClick: handleClickCta,
        disableState: isDisable
      })]
    }), toastCloseIcon && /*#__PURE__*/_jsx(CloseIconWrap, {
      onClick: handleClose,
      children: typeof toastCloseIcon === "string" ? /*#__PURE__*/_jsx(ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon
      }) : toastCloseIcon
    })]
  }) : null;
};

/* harmony default export */ var components_Toast_Toast = ((/* unused pure expression or super */ null && (Toast_Toast)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/ToastCompare.tsx








var ToastCompare_ToastCompare = function ToastCompare(_ref) {
  var toastCtaTxt = _ref.toastCtaTxt,
      planSelectedTxt = _ref.planSelectedTxt,
      handleClickCta = _ref.handleClickCta,
      handleClose = _ref.handleClose,
      toastCloseIcon = _ref.toastCloseIcon,
      toastIcon = _ref.toastIcon,
      isDisable = _ref.isDisable,
      width = _ref.width,
      height = _ref.height;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(ToastStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "4px",
      alignItems: "center",
      children: [toastIcon && device == "lg" && /*#__PURE__*/_jsx(ToastIcon, {
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: width ? width : "50px",
          height: height ? height : "50px",
          src: toastIcon
        })
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: device == "lg" ? "md" : "xs",
        color: theme.whiteText,
        children: planSelectedTxt && /*#__PURE__*/_jsx(FormattedText, {
          value: planSelectedTxt
        })
      })]
    }), /*#__PURE__*/_jsx(LandingButtonTertiary, {
      title: toastCtaTxt,
      onClick: handleClickCta,
      disableState: isDisable
    }), toastCloseIcon && /*#__PURE__*/_jsx(CloseIconWrap, {
      onClick: handleClose,
      children: /*#__PURE__*/_jsx(ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon
      })
    })]
  });
};

/* harmony default export */ var Toast_ToastCompare = ((/* unused pure expression or super */ null && (ToastCompare_ToastCompare)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansComp.tsx








var InsurancePlansComp_analytics = getAnalytics();

var InsurancePlansComp_InsurancePlansComp = function InsurancePlansComp(_ref) {
  var _data$packName, _data$packName$text, _data$packName$text$v, _data$packName$text$v2, _data$insurerDetails, _data$insurerDetails2, _data$insurerDetails3, _data$insurerDetails4, _data$insurerDetails5, _data$insurerDetails6, _data$insurerDetails7, _data$insurerDetails8;

  var data = _ref.data,
      handleMoreBenefits = _ref.handleMoreBenefits,
      handleTravAssist = _ref.handleTravAssist,
      handleCompareSelect = _ref.handleCompareSelect,
      handleBuyButton = _ref.handleBuyButton;
  var device = useBreakpointV2();
  var productType = // @ts-ignore
  data === null || data === void 0 ? void 0 : (_data$packName = data.packName) === null || _data$packName === void 0 ? void 0 : (_data$packName$text = _data$packName.text) === null || _data$packName$text === void 0 ? void 0 : (_data$packName$text$v = _data$packName$text.value) === null || _data$packName$text$v === void 0 ? void 0 : (_data$packName$text$v2 = _data$packName$text$v.toLowerCase) === null || _data$packName$text$v2 === void 0 ? void 0 : _data$packName$text$v2.call(_data$packName$text$v);

  var _useState = useState(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var handleMouseEnter = function handleMouseEnter() {
    setIsHovered(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
  };

  return /*#__PURE__*/_jsxs(InsurancePlansCompStyle, {
    children: [/*#__PURE__*/_jsx(InsurancePlansHeader, {
      handleCompareSelect: handleCompareSelect ? function () {
        return handleCompareSelect(parseInt(data === null || data === void 0 ? void 0 : data.productId));
      } : function () {},
      data: data
    }), /*#__PURE__*/_jsxs(InsurancePlanSection, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        gap: "16px",
        justifyContent: "space-between",
        margin: "0 0 16px",
        children: [/*#__PURE__*/_jsxs(InsuranceTypeSection, {
          children: [(data === null || data === void 0 ? void 0 : data.insuranceType) && /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "md",
            fontWeight: "black",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: data === null || data === void 0 ? void 0 : data.insuranceType
            })
          }), /*#__PURE__*/_jsxs(FlexComp, {
            gap: "8px",
            alignItems: "center",
            children: [(data === null || data === void 0 ? void 0 : data.popularTag) && device == "sm" && /*#__PURE__*/_jsx(PopularTag, {
              children: /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "xs",
                fontWeight: "bold",
                color: theme.whiteText,
                textTransform: "uppercase",
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: "Popular"
                })
              })
            }), (data === null || data === void 0 ? void 0 : data.planExtraInfo) && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: theme.greyText,
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: data === null || data === void 0 ? void 0 : data.planExtraInfo
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs(FlexComp, {
          margin: "0 0 0 auto",
          gap: "0",
          flexDirection: "column",
          alignItems: "flex-end",
          flexShrink: "0",
          width: device == "lg" ? "16%" : "25%",
          children: [(data === null || data === void 0 ? void 0 : data.discountText) && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            fontWeight: "bold",
            color: theme.greenText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: data === null || data === void 0 ? void 0 : data.discountText
            })
          }), /*#__PURE__*/_jsxs(FlexComp, {
            gap: "2px",
            alignItems: "center",
            children: [(data === null || data === void 0 ? void 0 : data.originalPrice) && /*#__PURE__*/_jsx(FormattedText, {
              value: data === null || data === void 0 ? void 0 : data.originalPrice,
              baseStyle: {
                fontSize: 12,
                fontWeight: "regular",
                color: "".concat(theme.greyText6),
                textDecoration: "line-through",
                textDecorationThickness: 0.7,
                textAlign: "right",
                whiteSpace: "nowrap"
              }
            }), /*#__PURE__*/_jsx(FormattedText, {
              value: data === null || data === void 0 ? void 0 : data.insAmount,
              baseStyle: {
                fontSize: "md",
                fontWeight: "bold",
                color: "#000",
                textAlign: "right"
              }
            })]
          }), (data === null || data === void 0 ? void 0 : data.paxPerDay) && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: data === null || data === void 0 ? void 0 : data.paxPerDay
            })
          }), (data === null || data === void 0 ? void 0 : data.ctaLink) && device == "sm" && /*#__PURE__*/_jsx(AnchorTag, {
            color: theme.blueText,
            fontSize: "xs",
            hrefProp: data === null || data === void 0 ? void 0 : data.tncLink,
            targetProp: "_blank",
            handleClick: function handleClick() {
              InsurancePlansComp_analytics === null || InsurancePlansComp_analytics === void 0 ? void 0 : InsurancePlansComp_analytics.trackListingEvents({
                actionType: "TnC_clicked_".concat(productType)
              });
            },
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: data === null || data === void 0 ? void 0 : data.ctaLink
            })
          })]
        }), (data === null || data === void 0 ? void 0 : data.buyBtn) && device == "lg" && handleBuyButton && /*#__PURE__*/_jsx(LandingButton, {
          onClick: function onClick() {
            return handleBuyButton(data);
          },
          customWidth: "fit-content",
          customTitle: data === null || data === void 0 ? void 0 : data.buyBtn
        })]
      }), /*#__PURE__*/_jsxs(InsurancePlanTypeHd, {
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          gap: "8px",
          alignItems: "center",
          children: [(data === null || data === void 0 ? void 0 : data.insIcon) && /*#__PURE__*/_jsx(ImageComponent, {
            width: "24px",
            height: "24px",
            src: data === null || data === void 0 ? void 0 : data.insIcon
          }), /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "black",
            color: theme.greyText,
            children: [(data === null || data === void 0 ? void 0 : data.insPlanName) && /*#__PURE__*/_jsx(FormattedText, {
              value: data === null || data === void 0 ? void 0 : data.insPlanName
            }), (data === null || data === void 0 ? void 0 : data.insurerNumber) && /*#__PURE__*/_jsxs(AnchorTag, {
              handleMouseEnter: handleMouseEnter,
              handleMouseLeave: handleMouseLeave,
              fontSize: "sm",
              fontWeight: "black",
              children: [device == "lg" ? "&nbsp;" : "", /*#__PURE__*/_jsx(FormattedText, {
                value: data === null || data === void 0 ? void 0 : data.insurerNumber
              }), isHovered && /*#__PURE__*/_jsxs(ToolTipComp, {
                handleMouseEnter: handleMouseEnter,
                handleMouseLeave: handleMouseLeave,
                left: "40%",
                top: "23px",
                toolTipArrow: "top",
                width: "247px",
                children: [/*#__PURE__*/_jsx(SpanTag, {
                  fontSize: "sm",
                  color: theme.whiteText,
                  children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails = data.insurerDetails) === null || _data$insurerDetails === void 0 ? void 0 : _data$insurerDetails.insurer) && /*#__PURE__*/_jsx(FormattedText, {
                    value: data === null || data === void 0 ? void 0 : (_data$insurerDetails2 = data.insurerDetails) === null || _data$insurerDetails2 === void 0 ? void 0 : _data$insurerDetails2.insurer
                  })
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(SpanTag, {
                  fontSize: "sm",
                  color: theme.whiteText,
                  children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails3 = data.insurerDetails) === null || _data$insurerDetails3 === void 0 ? void 0 : _data$insurerDetails3.details) && /*#__PURE__*/_jsx(FormattedText, {
                    value: data === null || data === void 0 ? void 0 : (_data$insurerDetails4 = data.insurerDetails) === null || _data$insurerDetails4 === void 0 ? void 0 : _data$insurerDetails4.details
                  })
                })]
              })]
            }), isHovered && /*#__PURE__*/_jsxs(ToolTipComp, {
              handleMouseEnter: handleMouseEnter,
              handleMouseLeave: handleMouseLeave,
              left: "40%",
              top: "23px",
              toolTipArrow: "top",
              width: "247px",
              children: [/*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                color: theme.whiteText,
                children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails5 = data.insurerDetails) === null || _data$insurerDetails5 === void 0 ? void 0 : _data$insurerDetails5.insurer) && /*#__PURE__*/_jsx(FormattedText, {
                  value: data === null || data === void 0 ? void 0 : (_data$insurerDetails6 = data.insurerDetails) === null || _data$insurerDetails6 === void 0 ? void 0 : _data$insurerDetails6.insurer
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                color: theme.whiteText,
                children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails7 = data.insurerDetails) === null || _data$insurerDetails7 === void 0 ? void 0 : _data$insurerDetails7.details) && /*#__PURE__*/_jsx(FormattedText, {
                  value: data === null || data === void 0 ? void 0 : (_data$insurerDetails8 = data.insurerDetails) === null || _data$insurerDetails8 === void 0 ? void 0 : _data$insurerDetails8.details
                })
              })]
            })]
          })]
        }), (data === null || data === void 0 ? void 0 : data.ctaLink) && device == "lg" && /*#__PURE__*/_jsx(AnchorTag, {
          color: theme.blueText,
          fontSize: "xs",
          fontWeight: "black",
          hrefProp: data === null || data === void 0 ? void 0 : data.tncLink,
          targetProp: "_blank",
          handleClick: function handleClick() {
            InsurancePlansComp_analytics === null || InsurancePlansComp_analytics === void 0 ? void 0 : InsurancePlansComp_analytics.trackListingEvents({
              actionType: "TnC_clicked_".concat(productType)
            });
          },
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: data === null || data === void 0 ? void 0 : data.ctaLink
          })
        })]
      }), /*#__PURE__*/_jsx(InsurancePlanTypeSectionComp, {
        data: data,
        handleMoreBenefits: handleMoreBenefits,
        handleTravAssist: handleTravAssist
      }), (data === null || data === void 0 ? void 0 : data.buyBtn) && device == "sm" && handleBuyButton && /*#__PURE__*/_jsx(LandingButton, {
        onClick: function onClick() {
          return handleBuyButton(data);
        },
        customWidth: "100%",
        customTitle: data === null || data === void 0 ? void 0 : data.buyBtn,
        margin: "16px 0 0"
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlansComp = ((/* unused pure expression or super */ null && (InsurancePlansComp_InsurancePlansComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits.tsx








var MoreBenefits_analytics = getAnalytics();

var MoreBenefits_MoreBenefits = function MoreBenefits(_ref) {
  var _Object$keys;

  var moreBenfitsTitle = _ref.moreBenfitsTitle,
      data = _ref.data,
      tag = _ref.tag,
      handleClose = _ref.handleClose,
      handleBuyButton = _ref.handleBuyButton,
      isAddOnBenefits = _ref.isAddOnBenefits,
      customBtnTitle = _ref.customBtnTitle;
  var device = useBreakpointV2();
  useEffect(function () {
    var _data$packName, _data$packName$text, _data$packName$text$v, _data$packName$text$v2;

    var productType = // @ts-ignore
    data === null || data === void 0 ? void 0 : (_data$packName = data.packName) === null || _data$packName === void 0 ? void 0 : (_data$packName$text = _data$packName.text) === null || _data$packName$text === void 0 ? void 0 : (_data$packName$text$v = _data$packName$text.value) === null || _data$packName$text$v === void 0 ? void 0 : (_data$packName$text$v2 = _data$packName$text$v.toLowerCase) === null || _data$packName$text$v2 === void 0 ? void 0 : _data$packName$text$v2.call(_data$packName$text$v);
    MoreBenefits_analytics === null || MoreBenefits_analytics === void 0 ? void 0 : MoreBenefits_analytics.trackListingEvents({
      // @ts-ignore
      actionType: "details_pop_shown_".concat(productType)
    });
  }, []);
  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    handleClick: handleClose,
    customTitle: moreBenfitsTitle,
    children: [/*#__PURE__*/_jsx(InsPlanModalCommonInfo, {
      data: data,
      isAddOnBenefits: isAddOnBenefits,
      tag: tag
    }), /*#__PURE__*/_jsx(FlexComp, {
      flexDirection: "column",
      gap: "24px",
      margin: "0 0 20px",
      children: (data === null || data === void 0 ? void 0 : data.moreBenefits) && ((_Object$keys = Object.keys(data.moreBenefits)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (item, index) {
        var _data$moreBenefits;

        return /*#__PURE__*/_jsx(BenefitItem, {
          isAddOnBenefits: isAddOnBenefits,
          data: (_data$moreBenefits = data.moreBenefits) === null || _data$moreBenefits === void 0 ? void 0 : _data$moreBenefits[item],
          benefitName: item
        }, "".concat(index));
      }))
    }), isAddOnBenefits && /*#__PURE__*/_jsx(AmountWrap, {
      boxShadow: "0",
      children: (data === null || data === void 0 ? void 0 : data.buyBtn) && /*#__PURE__*/_jsx(LandingButton, {
        customWidth: "-webkit-fill-available",
        customTitle: customBtnTitle,
        onClick: function onClick() {
          return handleBuyButton === null || handleBuyButton === void 0 ? void 0 : handleBuyButton(data);
        }
      })
    }), (data === null || data === void 0 ? void 0 : data.insAmount) && /*#__PURE__*/_jsxs(AmountWrap, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        gap: "0",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          color: theme.blackText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: data === null || data === void 0 ? void 0 : data.insAmount
          })
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: data === null || data === void 0 ? void 0 : data.paxPerDay
          })
        })]
      }), (data === null || data === void 0 ? void 0 : data.buyBtn) && /*#__PURE__*/_jsx(LandingButton, {
        customWidth: device == "sm" ? "158px" : "unset",
        customTitle: data.buyBtn,
        onClick: function onClick() {
          return handleBuyButton === null || handleBuyButton === void 0 ? void 0 : handleBuyButton(data);
        }
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_MoreBenefits = ((/* unused pure expression or super */ null && (MoreBenefits_MoreBenefits)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RadioButton/RadioButton.tsx





var RadioButton_RadioButton = function RadioButton(_ref) {
  var children = _ref.children,
      activeBtn = _ref.activeBtn,
      handleChange = _ref.handleChange,
      inputIndex = _ref.inputIndex,
      inputId = _ref.inputId,
      isPadding = _ref.isPadding,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel;

  var handleRadioChange = function handleRadioChange() {
    if (handleChange && inputIndex !== undefined) {
      handleChange(inputIndex);
    }
  };

  return /*#__PURE__*/_jsxs(RadioButtonStyle, {
    isPadding: isPadding,
    onChange: handleRadioChange,
    showLabel: showLabel,
    children: [/*#__PURE__*/_jsx("input", {
      type: "radio",
      onChange: handleRadioChange,
      checked: activeBtn,
      id: inputId,
      name: "radio-group"
    }), /*#__PURE__*/_jsx("label", {
      htmlFor: inputId,
      children: children
    })]
  });
};

/* harmony default export */ var components_RadioButton_RadioButton = ((/* unused pure expression or super */ null && (RadioButton_RadioButton)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BackDropComp/BackDropComp.style.ts

var BackDropComp_style_BackDropCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BackDropCompstyle__BackDropCompStyle",
  componentId: "f3s9gn-0"
})(["position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.5);z-index:46;width:100%;height:", ";"], function (p) {
  return p.height ? "".concat(p.height, "px") : "100vh";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BackDropComp/BackDropComp.tsx




var BackDropComp_BackDropComp = function BackDropComp(_ref) {
  var onClose = _ref.onClose;

  var _useState = useState(undefined),
      height = _useState[0],
      setHeight = _useState[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      setHeight(window.innerHeight);
    };

    if (true) {
      setHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return function () {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/_jsx(BackDropCompStyle, {
    onClick: onClose,
    height: height
  });
};

/* harmony default export */ var components_BackDropComp_BackDropComp = ((/* unused pure expression or super */ null && (BackDropComp_BackDropComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/TravelAssistanceModal.tsx







var TravelAssistanceModal_TravelAssistanceModal = function TravelAssistanceModal(_ref) {
  var travelAssistTitle = _ref.travelAssistTitle,
      data = _ref.data,
      handleTravAssist = _ref.handleTravAssist;

  var travelAssistanceCover = function travelAssistanceCover() {
    for (var i in data === null || data === void 0 ? void 0 : data.travelAssistanceCovers) {
      var _data$travelAssistanc, _data$travelAssistanc2;

      return data === null || data === void 0 ? void 0 : (_data$travelAssistanc = data.travelAssistanceCovers) === null || _data$travelAssistanc === void 0 ? void 0 : (_data$travelAssistanc2 = _data$travelAssistanc[i]) === null || _data$travelAssistanc2 === void 0 ? void 0 : _data$travelAssistanc2.map(function (item, index) {
        return /*#__PURE__*/_jsxs(FlexComp, {
          alignItems: "flex-start",
          margin: "0 0 20px",
          gap: "20px",
          children: [item.icon && /*#__PURE__*/_jsx(ImageComponent, {
            src: item.icon
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(ParaTag, {
              margin: "0 0 8px",
              fontSize: "sm",
              fontWeight: "bold",
              children: item.title && /*#__PURE__*/_jsx(FormattedText, {
                value: item.title
              })
            }), /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "xs",
              color: theme.greyText7,
              children: item.info && /*#__PURE__*/_jsx(FormattedText, {
                value: item.info
              })
            })]
          })]
        }, index);
      });
    }

    return;
  };

  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    handleClick: handleTravAssist ? function () {
      var _parseInt;

      return handleTravAssist((_parseInt = parseInt(data === null || data === void 0 ? void 0 : data.productId)) !== null && _parseInt !== void 0 ? _parseInt : 0);
    } : function () {},
    customTitle: travelAssistTitle,
    children: [/*#__PURE__*/_jsx(InsPlanModalCommonInfo, {
      data: data
    }), travelAssistanceCover(), (data === null || data === void 0 ? void 0 : data.travelAssistanceWarning) && /*#__PURE__*/_jsxs(TravAssistWraning, {
      children: [data.travelAssistanceWarning.icon && /*#__PURE__*/_jsx(ImageComponent, {
        src: data.travelAssistanceWarning.icon
      }), /*#__PURE__*/_jsxs("div", {
        children: [data.travelAssistanceWarning.title && /*#__PURE__*/_jsx(ParaTag, {
          margin: "0 0 8px",
          fontSize: "large",
          fontWeight: "bold",
          color: theme.yellowText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: data.travelAssistanceWarning.title
          })
        }), /*#__PURE__*/_jsx(ParaTag, {
          color: theme.greyText,
          fontSize: "md",
          children: (data === null || data === void 0 ? void 0 : data.travelAssistanceWarning.info) && /*#__PURE__*/_jsx(FormattedText, {
            value: data === null || data === void 0 ? void 0 : data.travelAssistanceWarning.info
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_TravelAssistanceModal = ((/* unused pure expression or super */ null && (TravelAssistanceModal_TravelAssistanceModal)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansHeader.tsx








var InsurancePlansHeader_InsurancePlansHeader = function InsurancePlansHeader(_ref) {
  var data = _ref.data,
      handleCompareSelect = _ref.handleCompareSelect;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(PlanHeader, {
    children: [(data === null || data === void 0 ? void 0 : data.popularTag) && device == "lg" && /*#__PURE__*/_jsx(PopularTag, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: theme.whiteText,
        textTransform: "uppercase",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: data === null || data === void 0 ? void 0 : data.popularTag
        })
      })
    }), (data === null || data === void 0 ? void 0 : data.packName) && /*#__PURE__*/_jsx(SpanTag, {
      fontSize: device == "lg" ? "sm" : "xs",
      fontWeight: "bold",
      textTransform: "uppercase",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: data === null || data === void 0 ? void 0 : data.packName
      })
    }), data.comparePlans && /*#__PURE__*/_jsx(CheckButton, {
      inputIndex: data.productId,
      inputId: data.productId,
      handleChange: handleCompareSelect ? function () {
        return handleCompareSelect(parseInt(data.productId));
      } : function () {},
      isChecked: data.selectedForCompare,
      margin: "0 0 0 auto",
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "sm",
        color: theme.greyText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: data.comparePlans
        })
      })
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlansHeader = ((/* unused pure expression or super */ null && (InsurancePlansHeader_InsurancePlansHeader)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlanTypeSection.tsx








var InsurancePlanTypeSection_InsurancePlanTypeSectionComp = function InsurancePlanTypeSectionComp(_ref) {
  var data = _ref.data,
      handleMoreBenefits = _ref.handleMoreBenefits,
      handleTravAssist = _ref.handleTravAssist;
  var device = useBreakpointV2();
  var expertAssistanceInfo = data.expertAssistanceInfo,
      sportsActivity = data.sportsActivity,
      expertAssistanceIcon = data.expertAssistanceIcon,
      assistanceCovers = data.assistanceCovers,
      insBenefits = data.insBenefits;
  return /*#__PURE__*/_jsxs(InsurancePlanTypeSection, {
    children: [expertAssistanceInfo && /*#__PURE__*/_jsxs(FlexComp, {
      justifyContent: "space-between",
      margin: "0 0 12px",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: theme.greenText3,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: expertAssistanceInfo
        })
      }), expertAssistanceIcon && /*#__PURE__*/_jsx(ImageComponent, {
        width: device == "lg" ? "30px" : "24px",
        height: device == "lg" ? "30px" : "24px",
        src: expertAssistanceIcon
      })]
    }), /*#__PURE__*/_jsxs(PlanSectionItem, {
      children: [insBenefits && insBenefits.map(function (item, index) {
        return /*#__PURE__*/_jsxs(FlexComp, {
          gap: "0",
          width: device == "lg" ? "max-content" : "100%",
          flexDirection: device == "lg" ? "column" : "row",
          justifyContent: device == "sm" ? "space-between" : "unset",
          children: [/*#__PURE__*/_jsx(ParaTag, {
            fontWeight: index == 0 ? "bold" : "regular",
            fontSize: "xs",
            children: item.policyTitle
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontWeight: index == 0 ? "bold" : "regular",
            fontSize: "xs",
            children: item.policyAmt
          })]
        }, index);
      }), assistanceCovers && assistanceCovers.map(function (item, index) {
        return /*#__PURE__*/_jsx(ParaTag, {
          fontWeight: "bold",
          fontSize: "xs",
          children: item
        }, index);
      }), /*#__PURE__*/_jsxs(AnchorTag, {
        handleClick: insBenefits && handleMoreBenefits ? function () {
          return handleMoreBenefits(parseInt(data.productId));
        } : assistanceCovers && handleTravAssist ? function () {
          return handleTravAssist(parseInt(data.productId));
        } : function () {},
        fontSize: "xs",
        fontWeight: "bold",
        textAlign: device == "lg" ? "right" : "left",
        children: [insBenefits && "".concat(data === null || data === void 0 ? void 0 : data.totalBenefits, " More Benefits"), assistanceCovers && "View Details"]
      })]
    }), sportsActivity && /*#__PURE__*/_jsxs(ActivityStatus, {
      children: [(sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.icon) && /*#__PURE__*/_jsx(ImageComponent, {
        width: device == "lg" ? "24px" : "16px",
        height: device == "lg" ? "24px" : "16px",
        src: sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.icon
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        color: theme.blackText,
        children: (sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.title) && /*#__PURE__*/_jsx(FormattedText, {
          value: sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.title
        })
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlanTypeSection = ((/* unused pure expression or super */ null && (InsurancePlanTypeSection_InsurancePlanTypeSectionComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsPlanModalCommonInfo.tsx







var InsPlanModalCommonInfo_InsPlanModalCommonInfo = function InsPlanModalCommonInfo(_ref) {
  var data = _ref.data,
      isAddOnBenefits = _ref.isAddOnBenefits,
      tag = _ref.tag;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.packName) && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "xs",
      fontWeight: "black" // color={data?.packNameColor}
      ,
      margin: "0 0 4px",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: data === null || data === void 0 ? void 0 : data.packName
      })
    }), tag && /*#__PURE__*/_jsx(TagWrap, {
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: tag
      })
    }), data.insuranceType && /*#__PURE__*/_jsxs(VendorWrap, {
      margin: isAddOnBenefits ? "0px 0px 8px 0px" : "0",
      children: [(data === null || data === void 0 ? void 0 : data.vendorDisplayIcon) && /*#__PURE__*/_jsx(ImageComponent, {
        src: data === null || data === void 0 ? void 0 : data.vendorDisplayIcon,
        height: "34px",
        width: "32px" // margin="0px 0px 4px 0px"

      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: isAddOnBenefits ? "md" : "large",
        margin: "0 0 4px",
        color: theme.blackText,
        fontWeight: "black",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: data === null || data === void 0 ? void 0 : data.insuranceType
        })
      })]
    }), data.insPlanName && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "xs",
      margin: "0 0 4px",
      children: /*#__PURE__*/_jsxs(SpanTag, {
        fontSize: "xs",
        color: theme.greyText7,
        children: [data === null || data === void 0 ? void 0 : data.vendorDisplayPrefix, " ", /*#__PURE__*/_jsx(FormattedText, {
          value: data === null || data === void 0 ? void 0 : data.insPlanName
        })]
      })
    }), (data === null || data === void 0 ? void 0 : data.ctaLink) && /*#__PURE__*/_jsx(AnchorTag, {
      fontSize: "xs",
      margin: "0 0 16px",
      hrefProp: data === null || data === void 0 ? void 0 : data.tncLink,
      targetProp: "_blank",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: data === null || data === void 0 ? void 0 : data.ctaLink
      })
    }), (data === null || data === void 0 ? void 0 : data.planExtraInfo) && /*#__PURE__*/_jsx(SpanTag, {
      fontSize: "xs",
      color: theme.greyText7,
      margin: "0 0 14px",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: data === null || data === void 0 ? void 0 : data.planExtraInfo
      })
    }), (data === null || data === void 0 ? void 0 : data.service) && /*#__PURE__*/_jsx(SpanTag, {
      fontSize: "xs",
      color: theme.greyText7,
      margin: "0 0 14px",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: data === null || data === void 0 ? void 0 : data.service
      })
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsPlanModalCommonInfo = ((/* unused pure expression or super */ null && (InsPlanModalCommonInfo_InsPlanModalCommonInfo)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentStatusComp/PaymentStatusComp.style.ts

var PaymentStatusComp_style_PaymentStatusCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentStatusCompstyle__PaymentStatusCompStyle",
  componentId: "v9sidz-0"
})(["background:#fff;height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
var PaymentStatusComp_style_Confetti = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PaymentStatusCompstyle__Confetti",
  componentId: "v9sidz-1"
})(["width:278px;height:185px;animation:confetti 0.5s ease-in;@keyframes confetti{0%{transform:scale(0.5);}100%{transform:scale(1);}}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentStatusComp/PaymentStatusComp.tsx







var PaymentStatusComp = function PaymentStatusComp(_ref) {
  var title = _ref.title,
      infoTxt = _ref.infoTxt,
      subInfoTxt = _ref.subInfoTxt,
      imageIcon = _ref.imageIcon;
  return /*#__PURE__*/_jsxs(PaymentStatusCompStyle, {
    children: [imageIcon && /*#__PURE__*/_jsx(Confetti, {
      children: imageIcon
    }), title && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "large",
      fontWeight: "bold",
      margin: "0 0 8px",
      color: theme.blackText,
      children: title
    }), infoTxt && /*#__PURE__*/_jsx(SpanTag, {
      margin: "0 0 2px",
      fontSize: "xs",
      color: theme.greyText,
      children: infoTxt
    }), subInfoTxt && /*#__PURE__*/_jsx(SpanTag, {
      fontSize: "xs",
      color: theme.greyText,
      children: subInfoTxt
    })]
  });
};

/* harmony default export */ var PaymentStatusComp_PaymentStatusComp = ((/* unused pure expression or super */ null && (PaymentStatusComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoice.style.ts


var GreatChoice_style_GreatChoiceStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "GreatChoicestyle__GreatChoiceStyle",
  componentId: "sc-1njux19-0"
})(["", ";", ";", ";"], function (props) {
  return props.background && "background: ".concat(props.background);
}, function (props) {
  return props.radius && "border-radius: ".concat(props.radius);
}, function (props) {
  return props.padding && "padding: ".concat(props.padding);
});
var ChoiceText = styled_components_browser_esm["default"].p.withConfig({
  displayName: "GreatChoicestyle__ChoiceText",
  componentId: "sc-1njux19-1"
})(["position:relative;margin-top:16px;color:", ";"], Global/* theme.blackText */.rS.blackText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoice.tsx







var GreatChoice = function GreatChoice(_ref) {
  var title = _ref.title,
      info = _ref.info,
      icon = _ref.icon,
      background = _ref.background,
      padding = _ref.padding,
      radius = _ref.radius;
  var data = {
    text: [{
      value: "Over "
    }, {
      value: "15k",
      styles: {
        fontWeight: "bold"
      }
    }, {
      value: " Travellers insured in the last 3 months."
    }]
  };
  return /*#__PURE__*/_jsxs(GreatChoiceStyle, {
    background: background,
    padding: padding,
    radius: radius,
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      margin: "0 0 8px",
      alignItems: "center",
      gap: "12px",
      children: [icon && /*#__PURE__*/_jsx(ImageComponent, {
        src: icon,
        height: "32",
        width: "32"
      }), title && /*#__PURE__*/_jsx(H5Tag, {
        color: theme.greenText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      })]
    }), (info || data) && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.greyText,
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: info ? info : data
      })
    })]
  });
};

/* harmony default export */ var GreatChoice_GreatChoice = ((/* unused pure expression or super */ null && (GreatChoice)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoiceShimmer.tsx






var GreatChoiceShimmer = function GreatChoiceShimmer(_ref) {
  var title = _ref.title,
      info = _ref.info;
  return /*#__PURE__*/_jsxs(GreatChoiceStyle, {
    children: [/*#__PURE__*/_jsx(Shimmer, {
      width: "283px",
      height: "32px",
      margin: "0 0 8px"
    }), /*#__PURE__*/_jsx(Shimmer, {
      width: "100%",
      height: "22px"
    })]
  });
};

/* harmony default export */ var GreatChoice_GreatChoiceShimmer = ((/* unused pure expression or super */ null && (GreatChoiceShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingTravelDetails/ListingTravelDetails.style.ts


var ListingTravelDetails_style_ListingTravelDetailsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListingTravelDetailsstyle__ListingTravelDetailsStyle",
  componentId: "za921k-0"
})(["background:#fff;border:1px solid rgba(242,242,242,0.16);border-radius:8px;padding:24px;@media ", "{padding:12px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingTravelDetails/ListingTravelDetails.tsx









var ListingTravelDetails_analytics = getAnalytics();

var ListingTravelDetails = function ListingTravelDetails(_ref) {
  var _previewBenefits$bene, _previewBenefits$bene2, _previewBenefits$bene3;

  var data = _ref.data,
      tnc = _ref.tnc,
      handleTnc = _ref.handleTnc,
      handleAmountBreakup = _ref.handleAmountBreakup,
      handleViewBenefits = _ref.handleViewBenefits,
      previewBenefits = _ref.previewBenefits,
      vendorDisplayIcon = _ref.vendorDisplayIcon,
      addOnProductDetails = _ref.addOnProductDetails;
  var device = useBreakpointV2();

  var _ref2 = data || {},
      planType = _ref2.planType,
      planName = _ref2.planName,
      sumInsured = _ref2.sumInsured,
      amountToPay = _ref2.amountToPay,
      editEnabled = _ref2.editEnabled,
      priceDetails = _ref2.priceDetails;

  var handleEditClick = function handleEditClick() {
    ListingTravelDetails_analytics === null || ListingTravelDetails_analytics === void 0 ? void 0 : ListingTravelDetails_analytics.trackTravDetailsEvents({
      actionType: "edit_product_clicked"
    });
    var referrer = document.referrer;
    var hostname = referrer ? new URL(referrer).hostname : "";

    if (hostname === "www.makemytrip.com" || hostname === "www.goibibo.com") {
      navigationActions.goBack();
    }

    var queryParams = new URLSearchParams(window.location.search);
    var params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers")
    };
    navigationActions.navigateToListing(params);
  };

  return /*#__PURE__*/_jsxs(ListingTravelDetailsStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      margin: "0 0 4px",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [planType && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "xs",
          fontWeight: "black",
          margin: "0 0 4px",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: planType
          })
        }), addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.productTitle ? /*#__PURE__*/_jsx(ParaTag, {
          color: theme.blackText,
          fontWeight: "black",
          fontSize: "md",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.productTitle
          })
        }) : planName && /*#__PURE__*/_jsx(ParaTag, {
          color: theme.blackText,
          fontWeight: "black",
          fontSize: "md",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: planName
          })
        })]
      }), previewBenefits ? /*#__PURE__*/_jsx(ImageComponent, {
        width: "38px",
        height: "38px",
        src: vendorDisplayIcon
      }) : editEnabled && /*#__PURE__*/_jsx(AnchorTag, {
        handleClick: handleEditClick,
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: "25px",
          height: "25px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg"
        })
      })]
    }), /*#__PURE__*/_jsx(FlexComp, {
      borderBottom: previewBenefits ? "" : "1px solid rgba(242, 242, 242, 0.2)",
      alignItems: device == "lg" ? "center" : "flex-start",
      gap: "6px",
      margin: "0 0 8px",
      padding: "0 0 8px",
      flexDirection: device == "lg" ? "row" : "column",
      children: sumInsured && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SpanTag, {
          color: theme.blackText,
          fontSize: device == "lg" ? "sm" : "xs",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: sumInsured
          })
        })
      })
    }), previewBenefits && /*#__PURE__*/_jsxs(FlexComp, {
      borderBottom: "1px solid rgba(242, 242, 242, 0.2)",
      flexDirection: "column",
      margin: "-8px 0 4px",
      padding: "0 0 4px",
      children: [previewBenefits === null || previewBenefits === void 0 ? void 0 : (_previewBenefits$bene = previewBenefits.benefits) === null || _previewBenefits$bene === void 0 ? void 0 : (_previewBenefits$bene2 = _previewBenefits$bene[0].features) === null || _previewBenefits$bene2 === void 0 ? void 0 : (_previewBenefits$bene3 = _previewBenefits$bene2.map) === null || _previewBenefits$bene3 === void 0 ? void 0 : _previewBenefits$bene3.call(_previewBenefits$bene2, function (item) {
        return /*#__PURE__*/_jsxs(FlexComp, {
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(ImageComponent, {
              width: "16px",
              height: "16px",
              src: item === null || item === void 0 ? void 0 : item.icon,
              margin: "0 20px 4px 0"
            }), /*#__PURE__*/_jsx(SpanTag, {
              color: theme.blackText,
              fontSize: "xs",
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: item.name
              })
            })]
          }), /*#__PURE__*/_jsx(SpanTag, {
            color: theme.blackText,
            fontSize: "xs",
            fontWeight: "bold",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.cover
            })
          })]
        });
      }), /*#__PURE__*/_jsx(AnchorTag, {
        targetProp: "_blank",
        handleClick: handleViewBenefits,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: previewBenefits === null || previewBenefits === void 0 ? void 0 : previewBenefits.ctaText,
          baseStyle: {
            fontWeight: "700",
            fontSize: "12px"
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      gap: "4px",
      justifyContent: "space-between",
      children: [priceDetails ? /*#__PURE__*/_jsx(FlexComp, {
        alignItems: "center",
        gap: "4px",
        children: /*#__PURE__*/_jsxs(SpanTag, {
          color: theme.blackText,
          fontSize: device == "lg" ? "md" : "sm",
          children: [(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.title) && /*#__PURE__*/_jsx(FormattedText, {
            value: priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.title
          }), (priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.originalPrice) && /*#__PURE__*/_jsx(FormattedText, {
            value: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.originalAmountToPay ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.originalAmountToPay : priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.originalPrice,
            baseStyle: {
              textDecoration: "line-through",
              textDecorationThickness: 0.8
            }
          }), (priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.discountedPrice) && /*#__PURE__*/_jsx(FormattedText, {
            value: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.totalAmountToPay ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.totalAmountToPay : priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.discountedPrice,
            baseStyle: {
              fontWeight: 900
            }
          })]
        })
      }) : amountToPay && /*#__PURE__*/_jsx(FlexComp, {
        alignItems: "center",
        gap: "4px",
        children: /*#__PURE__*/_jsx(SpanTag, {
          color: theme.blackText,
          fontSize: device == "lg" ? "md" : "sm",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: amountToPay
          })
        })
      }), (tnc === null || tnc === void 0 ? void 0 : tnc.title) && /*#__PURE__*/_jsx(AnchorTag, {
        targetProp: "_blank",
        handleClick: handleTnc,
        hrefProp: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.tncLink ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.tncLink : tnc.url,
        fontSize: "xs",
        fontWeight: "black",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: tnc.title
        })
      })]
    })]
  });
};

/* harmony default export */ var ListingTravelDetails_ListingTravelDetails = ((/* unused pure expression or super */ null && (ListingTravelDetails)));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 9 modules
var utility_src = __webpack_require__(5537);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetail.style.ts





var AddTravellerDetail_style_AddTravellerDetailStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerDetailStyle",
  componentId: "sc-1vnwff6-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;@media ", "{border-radius:16px 16px 0 0;}"], static_utils/* deviceType.mobile */.vO.mobile);
var AddTravellerDetail_style_AddTravellerHd = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerHd",
  componentId: "sc-1vnwff6-1"
})(["padding:30px;@media ", "{padding:24px 16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var AddTravellerDetail_style_AddTravellerComp = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerComp",
  componentId: "sc-1vnwff6-2"
})(["padding:30px;@media ", "{padding:24px 16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var AddTravellerDetail_style_StickyBtnWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__StickyBtnWrap",
  componentId: "sc-1vnwff6-3"
})(["", "{width:100%;}@media ", "{position:fixed;bottom:0;width:100%;z-index:1;background:#fff;padding:8px 16px;left:0;box-shadow:0px 1px 16px rgba(0,0,0,0.2);}"], LandingButton_style_LandingButtonStyle, static_utils/* deviceType.mobile */.vO.mobile);
var AddTravellerDetail_style_TravellerDetailsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDetailsStyle",
  componentId: "sc-1vnwff6-4"
})(["padding:16px 30px;border-top:1px solid #e8e8e8;", "{span{font-size:12px;line-height:12px;}}@media ", "{padding:16px;}", "{position:absolute;top:0;right:0;}"], LandingButtonWhiteStyle, static_utils/* deviceType.mobile */.vO.mobile, DobPickerStyle);
var AddTravellerDetail_style_TravellerAddShimmer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerAddShimmer",
  componentId: "sc-1vnwff6-5"
})(["padding:24px 30px;border-top:1px solid #e8e8e8;display:flex;justify-content:space-between;"]);
var AddTravellerDetail_style_GenderTypeItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__GenderTypeItem",
  componentId: "sc-1vnwff6-6"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:10px 12px;cursor:pointer;", ""], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n    border-radius: 6px;\n";
});
var SelectInsurereItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__SelectInsurereItem",
  componentId: "sc-1vnwff6-7"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:10px 12px;margin-bottom:8px;cursor:pointer;", " ", "{[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{top:31%;}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{top:31%;}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{top:19px;}}"], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n    border-radius: 6px;\n";
}, RadioButton_style_RadioButtonStyle);
var AddTravellerDetail_style_TravellerDescpWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpWrap",
  componentId: "sc-1vnwff6-8"
})([""]);
var AddTravellerDetail_style_TravellerDescpStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpStyle",
  componentId: "sc-1vnwff6-9"
})(["display:flex;align-items:baseline;gap:8px;"]);
var AddTravellerDetail_style_TravellerIndexWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerIndexWrap",
  componentId: "sc-1vnwff6-10"
})(["background:#f6f6f6;border-radius:18px;width:20px;height:20px;flex-shrink:0;display:flex;align-items:center;justify-content:center;"]);
var AddTravellerDetail_style_TravellerDescpError = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpError",
  componentId: "sc-1vnwff6-11"
})(["background:#fcdadb;border-radius:4px;padding:4px 8px;text-align:center;margin-top:8px;"]);
var AddTravellerDetail_style_ConfirmTnc = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__ConfirmTnc",
  componentId: "sc-1vnwff6-12"
})(["background:#f6f6f6;border-radius:6px;padding:12px 16px;font-size:14px;line-height:20px;color:#4a4a4a;margin-bottom:8px;"]);
var AddTravellerDetail_style_PrimaryContactNote = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__PrimaryContactNote",
  componentId: "sc-1vnwff6-13"
})(["background:rgba(255,237,209,1);border-radius:8px;padding:12px 16px;margin-top:16px;display:flex;flex-direction:column;gap:8px;"]);
var AddTravellerDetail_style_ArrowButtonWrap = styled_components_browser_esm["default"].span.withConfig({
  displayName: "AddTravellerDetailstyle__ArrowButtonWrap",
  componentId: "sc-1vnwff6-14"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var ToastOfferWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__ToastOfferWrap",
  componentId: "sc-1vnwff6-15"
})(["display:flex;flex-direction:row;justify-content:center;padding:6px 16px 6px 16px;", " bottom:", ";background:#b8f5e0;position:", ";picture{", " ", " ", "}"], function (props) {
  return props.width && "width: ".concat(props.width, ";");
}, function (props) {
  return props.bottom ? "".concat(props.bottom) : "30px";
}, function (props) {
  return props.position ? "".concat(props.position, ";") : "sticky";
}, function (props) {
  return props.pictureHeight && "height: ".concat(props.pictureHeight, ";");
}, function (props) {
  return props.pictureWidth && "width: ".concat(props.pictureWidth, ";");
}, function (props) {
  return props.picturePadding && "padding: ".concat(props.picturePadding, ";");
});
var AddTravellerDetail_style_AddButtonWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__AddButtonWrap",
  componentId: "sc-1vnwff6-16"
})(["display:flex;", " align-item:baseline;margin:14px 0px 14px 33px;cursor:pointer;align-items:center;"], function (props) {
  return props.isDisabled ? "color: #0000004D;" : "color: #008cff;";
});
var AddTravellerDetail_style_AddOnPlanWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__AddOnPlanWrap",
  componentId: "sc-1vnwff6-17"
})(["display:flex;flex-direction:column;justify-content:space-between;border-radius:8px;padding:12px 16px 12px 16px;border:", ";background:", ";", " position:relative;a{font-size:12px;font-weight:700;}button{span{font-size:12px;}}picture{display:flex;align-items:center;}img{border-radius:4px;}", "{position:static;width:75px;height:32px;}"], function (props) {
  return props.isSelected ? "1px solid #008CFF" : "1px solid #e2e2e2";
}, function (props) {
  return props.isSelected ? "linear-gradient(0deg, #EAF5FF, #EAF5FF), linear-gradient(0deg, #008CFF, #008CFF)" : "linear-gradient(0deg, #f6f6f6, #f6f6f6),linear-gradient(0deg, #e2e2e2, #e2e2e2)";
}, function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, LandingButtonWhiteStyle);
var AddTravellerDetail_style_TagWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__TagWrap",
  componentId: "sc-1vnwff6-18"
})(["display:flex;background:linear-gradient(88.44deg,#12714f 0.02%,#1ca099 100.01%);padding:2px 8px 2px 8px;border-radius:16px;height:20px;color:#ffffff;align-items:center;font-size:12px;position:absolute;font-weight:700;top:-10px;transform:translateX(-50%);margin:0px 0px 0px 10px;z-index:1;@media ", "{left:11%;}@media ", "{left:16%;}"], static_utils/* deviceType.desktop */.vO.desktop, static_utils/* deviceType.mobile */.vO.mobile);
var AddTravellerDetail_style_VendorIconWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__VendorIconWrap",
  componentId: "sc-1vnwff6-19"
})(["@media ", "{picutre{align-items:flex-start;}}"], static_utils/* deviceType.mobile */.vO.mobile);
var AddTravellerDetail_style_WebToastWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddTravellerDetailstyle__WebToastWrap",
  componentId: "sc-1vnwff6-20"
})(["div{height:40px;}@media ", "{position:fixed;bottom:108px;width:100%;& >{width:100%;}div{}}@media ", "{& > div{margin-left:30px;}div{width:502px;}position:sticky;bottom:120px;}"], static_utils/* deviceType.mobile */.vO.mobile, static_utils/* deviceType.desktop */.vO.desktop);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDescpV2.tsx












var TravellerDescpV2_TravellerDescp = function TravellerDescp(_ref) {
  var _errors$travellerData, _error$name, _error$dob, _error$gender, _name$isRequired, _gender$isRequired, _dob$isRequired;

  var travellerIndex = _ref.travellerIndex,
      genderTypeSelected = _ref.genderTypeSelected,
      secondaryContactData = _ref.secondaryContactData,
      isSelected = _ref.isSelected,
      handleEditState = _ref.handleEditState,
      isDomesticBooking = _ref.isDomesticBooking;

  var _ref2 = secondaryContactData || {},
      name = _ref2.name,
      dob = _ref2.dob,
      gender = _ref2.gender;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var error = errors === null || errors === void 0 ? void 0 : (_errors$travellerData = errors.travellerData) === null || _errors$travellerData === void 0 ? void 0 : _errors$travellerData[travellerIndex];
  var errorMessage = (error === null || error === void 0 ? void 0 : (_error$name = error.name) === null || _error$name === void 0 ? void 0 : _error$name.message) || (error === null || error === void 0 ? void 0 : (_error$dob = error.dob) === null || _error$dob === void 0 ? void 0 : _error$dob.message) || (error === null || error === void 0 ? void 0 : (_error$gender = error.gender) === null || _error$gender === void 0 ? void 0 : _error$gender.message) || "";
  return /*#__PURE__*/_jsxs(TravellerDescpWrap, {
    children: [/*#__PURE__*/_jsx(TravellerDescpStyle, {
      children: /*#__PURE__*/_jsxs(FlexComp, {
        flex: "auto",
        alignItems: "baseline",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          children: [(name === null || name === void 0 ? void 0 : name.isEnabled) && /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".name"),
            rules: {
              required: {
                value: isSelected ? (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true : false,
                message: getFormFieldErrorMsg("name")
              },
              pattern: {
                value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
                message: getFormFieldErrorMsg("name", name === null || name === void 0 ? void 0 : name.errorMessage)
              }
            },
            render: function render(_ref3) {
              var value = _ref3.field.value;
              return /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                fontWeight: "black",
                margin: "0 0 2px",
                children: value || "Traveller " + (travellerIndex + 1).toString()
              });
            }
          }), /*#__PURE__*/_jsxs("div", {
            children: [(gender === null || gender === void 0 ? void 0 : gender.isEnabled) && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(Controller, {
                control: control,
                name: "travellerData.".concat(travellerIndex, ".gender"),
                rules: {
                  required: {
                    value: isSelected ? (_gender$isRequired = gender === null || gender === void 0 ? void 0 : gender.isRequired) !== null && _gender$isRequired !== void 0 ? _gender$isRequired : true : false,
                    message: getFormFieldErrorMsg("gender")
                  }
                },
                render: function render(_ref4) {
                  var value = _ref4.field.value;
                  return /*#__PURE__*/_jsxs(SpanTag, {
                    fontSize: "xs",
                    color: theme.greyText,
                    children: [isDomesticBooking && "GENDER: ", value ? value : "---"]
                  });
                }
              })
            }), (dob === null || dob === void 0 ? void 0 : dob.isEnabled) && /*#__PURE__*/_jsx(Controller, {
              control: control,
              name: "travellerData.".concat(travellerIndex, ".dob"),
              rules: {
                required: {
                  value: isSelected ? (_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : true : false,
                  message: getFormFieldErrorMsg("dob")
                },
                validate: isSelected ? function (value) {
                  return isDobValid(value, dob === null || dob === void 0 ? void 0 : dob.regex) || getFormFieldErrorMsg("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
                } : {}
              },
              render: function render(_ref5) {
                var value = _ref5.field.value;
                return /*#__PURE__*/_jsxs(SpanTag, {
                  fontSize: "xs",
                  color: theme.greyText,
                  children: [",DOB:", " ", formatDate(value, DATE_FORMATS["DD/MM/YYYY"]) || "---"]
                });
              }
            })]
          })]
        }), /*#__PURE__*/_jsx(ArrowButtonWrap, {
          onClick: handleEditState,
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: "9px",
            height: "9px",
            margin: "0px 0px 0px 0px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg"
          })
        })]
      })
    }), errorMessage && /*#__PURE__*/_jsx(TravellerDescpError, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        color: theme.redText2,
        children: errorMessage
      })
    })]
  });
};

/* harmony default export */ var TravellerDescpV2 = ((/* unused pure expression or super */ null && (TravellerDescpV2_TravellerDescp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsV2.tsx
















var minDate = subtractYrsFromDate(new Date(), 70).toISOString().split("T")[0];
var maxDate = new Date().toISOString().split("T")[0];
var TravellerDetailsV2_analytics = getAnalytics();

var TravellerDetailsV2_TravellerDetailsV2 = function TravellerDetailsV2(_ref) {
  var _errors$travellerData, _name$isRequired, _dob$isRequired, _gender$isRequired;

  var travellerIndex = _ref.travellerIndex,
      count = _ref.count,
      travellerRef = _ref.travellerRef,
      isLoading = _ref.isLoading,
      firstErrorIndex = _ref.firstErrorIndex,
      travellerNumber = _ref.travellerNumber,
      genderTypes = _ref.genderTypes,
      handleArrowButton = _ref.handleArrowButton,
      travellerSelected = _ref.travellerSelected,
      handleGenderChange = _ref.handleGenderChange,
      handleTravellerSelect = _ref.handleTravellerSelect,
      selectedGender = _ref.selectedGender,
      saveFormValuesOnBlur = _ref.saveFormValuesOnBlur,
      secondaryContactData = _ref.secondaryContactData,
      isSelected = _ref.isSelected,
      travellerCount = _ref.travellerCount,
      isSavedTravellers = _ref.isSavedTravellers,
      isValidForm = _ref.isValidForm,
      isEditable = _ref.isEditable,
      isDomesticBooking = _ref.isDomesticBooking;
  var device = useBreakpointV2();

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors,
      getValues = _useFormContext.getValues;

  var error = errors === null || errors === void 0 ? void 0 : (_errors$travellerData = errors.travellerData) === null || _errors$travellerData === void 0 ? void 0 : _errors$travellerData[travellerIndex];

  var _ref2 = secondaryContactData || {},
      name = _ref2.name,
      dob = _ref2.dob,
      gender = _ref2.gender;

  return /*#__PURE__*/_jsxs(TravellerDetailsStyle, {
    ref: travellerIndex === firstErrorIndex ? travellerRef : null,
    children: [travellerIndex === 0 && /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      margin: "0px 0px 20px 0px",
      children: [/*#__PURE__*/_jsx(FormattedText, {
        value: isSavedTravellers ? "Saved Travellers" : "Travellers",
        baseStyle: {
          color: "#4A4A4A",
          fontSize: "14px",
          fontWeight: "700"
        }
      }), /*#__PURE__*/_jsx(FormattedText, {
        value: (count === null || count === void 0 ? void 0 : count.toString()) + "/" + (travellerCount === null || travellerCount === void 0 ? void 0 : travellerCount.toString()) + " Added",
        baseStyle: {
          color: isValidForm ? "#2B825E" : "#757575",
          fontSize: "14px",
          fontWeight: "700"
        }
      })]
    }), /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "travellerData.".concat(travellerIndex, ".isSelected"),
      render: function render(_ref3) {
        var value = _ref3.field.value;
        return /*#__PURE__*/_jsx(CheckButton, {
          isChecked: value,
          isDisabled: !isEditable,
          handleChange: function handleChange() {
            if (!isEditable) return;

            if (!value && getValues("travellerData.".concat(travellerIndex, ".isSavedTraveller"))) {
              if (getValues("travellerData.".concat(travellerIndex, ".isEdited"))) {
                TravellerDetailsV2_analytics === null || TravellerDetailsV2_analytics === void 0 ? void 0 : TravellerDetailsV2_analytics.trackTravDetailsEvents({
                  actionType: "saved_traveller_edit_clicked"
                });
              } else {
                TravellerDetailsV2_analytics === null || TravellerDetailsV2_analytics === void 0 ? void 0 : TravellerDetailsV2_analytics.trackTravDetailsEvents({
                  actionType: "saved_traveller_clicked"
                });
              }
            }

            handleTravellerSelect && handleTravellerSelect(value, travellerIndex);
            saveFormValuesOnBlur();
          },
          children: !travellerSelected ? /*#__PURE__*/_jsx(TravellerDescp, {
            travellerIndex: travellerIndex,
            isSelected: isSelected,
            saveFormValuesOnBlur: saveFormValuesOnBlur,
            travellerNumber: travellerIndex + 1,
            genderTypeSelected: selectedGender,
            isDomesticBooking: isDomesticBooking,
            secondaryContactData: secondaryContactData,
            handleEditState: handleArrowButton
          }) : /*#__PURE__*/_jsxs(FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(H6Tag, {
              children: travellerNumber
            }), /*#__PURE__*/_jsx(ArrowButtonWrap, {
              onClick: handleArrowButton,
              children: /*#__PURE__*/_jsx(ImageComponent, {
                width: "9px",
                height: "9px",
                margin: "0px 0px 0px 0px",
                src: travellerSelected ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg"
              })
            })]
          })
        });
      }
    }), /*#__PURE__*/_jsx(_Fragment, {
      children: travellerSelected && /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: device == "lg" ? "row" : "column",
          margin: "16px 0 16px",
          gap: "16px",
          children: [(name === null || name === void 0 ? void 0 : name.isEnabled) && /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".name"),
            rules: {
              required: {
                value: isSelected ? (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true : false,
                message: getFormFieldErrorMsg("name")
              },
              pattern: {
                value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
                message: getFormFieldErrorMsg("name", name === null || name === void 0 ? void 0 : name.errorMessage)
              }
            },
            render: function render(_ref4) {
              var _error$name;

              var _ref4$field = _ref4.field,
                  value = _ref4$field.value,
                  onChange = _ref4$field.onChange,
                  onBlur = _ref4$field.onBlur;
              return /*#__PURE__*/_jsx(LandingInput, {
                flex: "1",
                requiredField: name === null || name === void 0 ? void 0 : name.isRequired,
                placeholderTxt: name === null || name === void 0 ? void 0 : name.placeholder,
                labelTxt: name === null || name === void 0 ? void 0 : name.title,
                inputValue: value,
                errorState: error === null || error === void 0 ? void 0 : (_error$name = error.name) === null || _error$name === void 0 ? void 0 : _error$name.message,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: function handleBlur() {
                  saveFormValuesOnBlur(travellerIndex);
                  onBlur();
                },
                autoComplete: "off",
                inputWidth: "100%",
                isDisabled: !isEditable
              });
            }
          }), (dob === null || dob === void 0 ? void 0 : dob.isEnabled) && /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".dob"),
            rules: {
              required: {
                value: isSelected ? (_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : true : false,
                message: getFormFieldErrorMsg("dob")
              },
              validate: isSelected ? function (value) {
                return isDobValid(value, dob === null || dob === void 0 ? void 0 : dob.regex) || getFormFieldErrorMsg("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
              } : {}
            },
            render: function render(_ref5) {
              var _error$dob;

              var _ref5$field = _ref5.field,
                  value = _ref5$field.value,
                  onChange = _ref5$field.onChange,
                  onBlur = _ref5$field.onBlur;
              return /*#__PURE__*/_jsx(LandingInput, {
                flex: "1",
                placeholderTxt: dob === null || dob === void 0 ? void 0 : dob.placeholder,
                requiredField: dob === null || dob === void 0 ? void 0 : dob.isRequired,
                labelTxt: dob === null || dob === void 0 ? void 0 : dob.title,
                inputType: "date",
                inputValue: formatDate(value, DATE_FORMATS["YYYY-MM-DD"]),
                minValue: minDate,
                maxValue: maxDate,
                errorState: error === null || error === void 0 ? void 0 : (_error$dob = error.dob) === null || _error$dob === void 0 ? void 0 : _error$dob.message,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: function handleBlur() {
                  saveFormValuesOnBlur(travellerIndex);
                  onBlur();
                },
                inputWidth: "100%"
              });
            }
          })]
        }), (gender === null || gender === void 0 ? void 0 : gender.isEnabled) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SpanTag, {
            margin: "0 0 8px",
            fontSize: "md",
            fontWeight: "bold",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: gender === null || gender === void 0 ? void 0 : gender.title
            })
          }), /*#__PURE__*/_jsx(FlexComp, {
            gap: "8px",
            children: /*#__PURE__*/_jsx(Controller, {
              control: control,
              name: "travellerData.".concat(travellerIndex, ".gender"),
              rules: {
                required: {
                  value: isSelected ? (_gender$isRequired = gender === null || gender === void 0 ? void 0 : gender.isRequired) !== null && _gender$isRequired !== void 0 ? _gender$isRequired : true : false,
                  message: getFormFieldErrorMsg("gender")
                }
              },
              render: function render(_ref6) {
                var value = _ref6.field.value;
                return /*#__PURE__*/_jsx(_Fragment, {
                  children: genderTypes === null || genderTypes === void 0 ? void 0 : genderTypes.map(function (item) {
                    return /*#__PURE__*/_jsx(GenderTypeItem, {
                      selected: item.label === value,
                      onClick: function onClick() {
                        handleGenderChange(item, travellerIndex);
                        saveFormValuesOnBlur(travellerIndex);
                      },
                      children: /*#__PURE__*/_jsx(RadioButton, {
                        activeBtn: item.label === value,
                        children: /*#__PURE__*/_jsx(SpanTag, {
                          fontSize: "xs",
                          fontWeight: "bold",
                          color: item.label === value ? theme.blueText : theme.greyText,
                          children: item.label
                        })
                      })
                    }, item.id);
                  })
                });
              }
            })
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerDetailsV2 = ((/* unused pure expression or super */ null && (TravellerDetailsV2_TravellerDetailsV2)));
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/apiConstants.ts
/* provided dependency */ var process = __webpack_require__(4406);
var API_BASE_URL_HTTP = process.env["API_BASE_URL_HTTP"];
var apiConstants_API_ROUTE_PREFIX = "/ext/api/v1/partners";
var apiConstants_API_ROUTE_PREFIX_HTTPS = "/insurance/ext/api/v1/partners";
var API_TIMEOUT_IN_MS = 10000;
var apiConstants_API_ROUTES;

(function (API_ROUTES) {
  API_ROUTES["GET_LANDING_PAGE_DETAILS"] = "insurance/cb/landing";
  API_ROUTES["GET_PRODUCT_LISTING"] = "insurance/cb/quotes";
  API_ROUTES["GET_TRAVEL_ATTRIBUTES"] = "insurance/cb/travelattributes";
  API_ROUTES["PAYMENT_CHECKOUT"] = "insurance/cb/checkout";
  API_ROUTES["GET_PASSPORT_DETAILS"] = "insurance/cb/passportDetails";
  API_ROUTES["EDIT_INSURANCE_DETAILS"] = "insurance/cb/endorsement";
  API_ROUTES["ORDER_CONFIRMED"] = "insurance/cb/thankyou";
  API_ROUTES["ORDER_LISTING"] = "insurance/cb/orders";
  API_ROUTES["ORDER_DETAIL"] = "insurance/cb/orderDetail";
  API_ROUTES["TRIGGER_EMAIL"] = "insurance/cb/email";
})(apiConstants_API_ROUTES || (apiConstants_API_ROUTES = {}));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(9644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/config.ts


var config_excluded = ["cookie", "mobile-device", "cmp"],
    _excluded2 = ["cookie"];



var RETRY_CONFIG = {
  retry: 1
};
var AXIOS_HTTP_CONFIG = {
  baseURL: API_BASE_URL_HTTP,
  timeout: API_TIMEOUT_IN_MS,
  withCredentials: true,
  retry: 1
};
var AXIOS_HTTPS_CONFIG = {
  timeout: API_TIMEOUT_IN_MS,
  withCredentials: true,
  retry: 1
};

if (false) {}

var config_API_HTTP = axios_default().create(AXIOS_HTTP_CONFIG);
var config_API_HTTPS = axios_default().create(AXIOS_HTTPS_CONFIG);

function enhanceRequestHeaders(headers) {
  var _ref = headers || {},
      _ref$cookie = _ref.cookie,
      cookie = _ref$cookie === void 0 ? "" : _ref$cookie,
      mobile_device = _ref["mobile-device"],
      cmp = _ref.cmp,
      ignoredHeaders = (0,objectWithoutProperties/* default */.Z)(_ref, config_excluded);

  var x_tm_device = mobile_device === "true" ? "mobile" : "desktop";

  if (typeof navigator !== "undefined") {
    x_tm_device = /Mobile|Android|BlackBerry/.test(navigator.userAgent) ? "mobile" : "desktop";
  }

  if (typeof cmp === "string" && cmp != "") {
    return {
      cmp: cmp,
      cookie: cookie,
      "x-tm-device": x_tm_device,
      "X-Tm-Client": "desktop"
    };
  }

  return {
    cookie: cookie,
    "x-tm-device": x_tm_device,
    "X-Tm-Client": "desktop"
  };
}

config_API_HTTP.interceptors.request.use(function (config) {
  config.headers = enhanceRequestHeaders(config.headers);
  return config;
});
config_API_HTTPS.interceptors.request.use(function (config) {
  var _enhanceRequestHeader = enhanceRequestHeaders(config.headers),
      cookie = _enhanceRequestHeader.cookie,
      headersWithoutCookie = (0,objectWithoutProperties/* default */.Z)(_enhanceRequestHeader, _excluded2);

  config.headers = headersWithoutCookie;
  return config;
});

if (false) {}

var retryAxiosRequest = function retryAxiosRequest(error) {
  var config = error.config,
      response = error.response,
      request = error.request;
  var url = config.url;
  console.error(["API RESPONSE ERROR:", JSON.stringify({
    url: url,
    status: response === null || response === void 0 ? void 0 : response.status,
    responseData: response === null || response === void 0 ? void 0 : response.data,
    responseHeaders: response === null || response === void 0 ? void 0 : response.headers,
    requestBody: config === null || config === void 0 ? void 0 : config.data,
    requestHeaders: config === null || config === void 0 ? void 0 : config.headers
  })].join(" | "));

  if (response !== null && response !== void 0 && response.status && response.status < 400 || !config || !config.retry) {
    return Promise.reject(error);
  } //decrease retry count by 1


  config.retry -= 1; // Return Promise to retry the request

  return config_API_HTTP.request(config);
};

config_API_HTTP.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(error) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", retryAxiosRequest(error));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());
config_API_HTTPS.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(error) {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", retryAxiosRequest(error));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}());
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/apiRoutes.ts



var apiRoutes_excluded = (/* unused pure expression or super */ null && (["partner", "headers", "cmp", "query"])),
    apiRoutes_excluded2 = (/* unused pure expression or super */ null && (["isUpcomingTrip", "bookingId", "countries", "startDate", "endDate", "travellers"]));


function apiRoutes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function apiRoutes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? apiRoutes_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : apiRoutes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var getLandingPageDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reqData) {
    var partner, headers, cmp, query, params, urlParams, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            partner = reqData.partner, headers = reqData.headers, cmp = reqData.cmp, query = reqData.query;
            params = apiRoutes_objectSpread(apiRoutes_objectSpread({}, {}), query);
            urlParams = setURLQueryParams(params);
            _context.next = 6;
            return API_HTTP.get("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.GET_LANDING_PAGE_DETAILS).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: apiRoutes_objectSpread(apiRoutes_objectSpread({}, headers), {}, {
                cmp: cmp
              })
            });

          case 6:
            response = _context.sent;
            console.log({
              response: response
            });
            return _context.abrupt("return", response);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.log({
              error: _context.t0
            });
            throw _context.t0;

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function getLandingPageDetails(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var getProductListing = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(reqData) {
    var _reqData$partner, partner, headers, cmp, query, data, params, urlParams, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _reqData$partner = reqData.partner, partner = _reqData$partner === void 0 ? PARTNER.MMT : _reqData$partner, headers = reqData.headers, cmp = reqData.cmp, query = reqData.query, data = _objectWithoutProperties(reqData, apiRoutes_excluded);
            params = apiRoutes_objectSpread({
              lob: LOB.STANDALONE,
              platform: PLATFORM.WEB,
              context: CONTEXT.STANDALONE_V2,
              isCountryCodesSupported: true,
              partner: partner
            }, query);
            urlParams = setURLQueryParams(params);
            _context2.next = 6;
            return API_HTTP.post("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.GET_PRODUCT_LISTING).concat(urlParams ? "?".concat(urlParams) : ""), data, {
              headers: apiRoutes_objectSpread(apiRoutes_objectSpread({}, headers), {}, {
                cmp: cmp
              })
            });

          case 6:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            console.log({
              error: _context2.t0
            });
            throw _context2.t0;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function getProductListing(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));
var getTravelAttributes = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(reqData) {
    var _ref4, _ref4$partner, partner, headers, cmp, query, _ref5, isUpcomingTrip, bookingId, countries, startDate, endDate, travellers, queryParams, params, urlParams, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _ref4 = reqData || {}, _ref4$partner = _ref4.partner, partner = _ref4$partner === void 0 ? PARTNER.MMT : _ref4$partner, headers = _ref4.headers, cmp = _ref4.cmp, query = _ref4.query;
            _ref5 = query || {}, isUpcomingTrip = _ref5.isUpcomingTrip, bookingId = _ref5.bookingId, countries = _ref5.countries, startDate = _ref5.startDate, endDate = _ref5.endDate, travellers = _ref5.travellers, queryParams = _objectWithoutProperties(_ref5, apiRoutes_excluded2);
            params = apiRoutes_objectSpread(apiRoutes_objectSpread(apiRoutes_objectSpread(apiRoutes_objectSpread(apiRoutes_objectSpread(apiRoutes_objectSpread(apiRoutes_objectSpread({
              lob: LOB.STANDALONE,
              platform: PLATFORM.WEB,
              context: CONTEXT.STANDALONE_V2,
              travelPurpose: "Leisure Trip"
            }, isUpcomingTrip && {
              upcomingTraveller: isUpcomingTrip === "true" ? true : false
            }), bookingId && {
              booking_id: bookingId.toString()
            }), countries && {
              countryCodes: countries.toString()
            }), startDate && {
              departureDateTime: Number(startDate)
            }), endDate && {
              arrivalDateTime: Number(endDate)
            }), travellers && {
              numberOfTravellers: Number(travellers)
            }), queryParams);
            urlParams = setURLQueryParams(params);
            _context3.next = 7;
            return API_HTTP.get("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.GET_TRAVEL_ATTRIBUTES).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: apiRoutes_objectSpread(apiRoutes_objectSpread({}, headers), {}, {
                cmp: cmp
              })
            });

          case 7:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            console.error("Error", {
              error: _context3.t0
            });
            throw _context3.t0;

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 11]]);
  }));

  return function getTravelAttributes(_x3) {
    return _ref3.apply(this, arguments);
  };
}()));
var apiRoutes_paymentCheckout = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(reqData) {
    var _reqData$partner2, partner, data, params, urlParams, response;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _reqData$partner2 = reqData.partner, partner = _reqData$partner2 === void 0 ? getPartnerOnClientSide() : _reqData$partner2, data = reqData.data;
            params = {
              context: CONTEXT.STANDALONE_V2,
              ins_new_flow: true
            };
            urlParams = setURLQueryParams(params);
            _context4.next = 6;
            return API_HTTPS.post("".concat(API_ROUTE_PREFIX_HTTPS, "/").concat(partner, "/").concat(API_ROUTES.PAYMENT_CHECKOUT).concat(urlParams ? "?".concat(urlParams) : ""), data, {
              headers: {
                cmp: sessionStorage.getItem("cmp") || undefined
              }
            });

          case 6:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error("Error", {
              error: _context4.t0
            });
            throw _context4.t0;

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }));

  return function paymentCheckout(_x4) {
    return _ref6.apply(this, arguments);
  };
}()));
var getPassportDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(reqData) {
    var bookingId, pageId, _reqData$partner3, partner, headers, cmp, query, params, urlParams, response;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            bookingId = reqData.bookingId, pageId = reqData.pageId, _reqData$partner3 = reqData.partner, partner = _reqData$partner3 === void 0 ? PARTNER.MMT : _reqData$partner3, headers = reqData.headers, cmp = reqData.cmp, query = reqData.query;
            params = apiRoutes_objectSpread({
              bookingId: bookingId,
              pageId: pageId
            }, query);
            urlParams = setURLQueryParams(params);
            _context5.next = 6;
            return API_HTTP.get("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.GET_PASSPORT_DETAILS).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: apiRoutes_objectSpread(apiRoutes_objectSpread({}, headers), {}, {
                cmp: cmp
              })
            });

          case 6:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            console.log("Error", {
              error: _context5.t0
            });
            throw _context5.t0;

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));

  return function getPassportDetails(_x5) {
    return _ref7.apply(this, arguments);
  };
}()));
var getOrderConfirmedDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(data) {
    var partner, bookingId, headers, cmp, query, params, urlParams, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            partner = data.partner, bookingId = data.bookingId, headers = data.headers, cmp = data.cmp, query = data.query;
            _context6.prev = 1;
            params = apiRoutes_objectSpread({
              tmBookingId: bookingId
            }, query);
            urlParams = setURLQueryParams(params);
            _context6.next = 6;
            return API_HTTP.get("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.ORDER_CONFIRMED).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: apiRoutes_objectSpread(apiRoutes_objectSpread({}, headers), {}, {
                cmp: cmp
              })
            });

          case 6:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](1);
            console.error("Error", {
              error: _context6.t0
            });
            throw _context6.t0;

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 10]]);
  }));

  return function getOrderConfirmedDetails(_x6) {
    return _ref8.apply(this, arguments);
  };
}()));
var getOrderListing = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(reqData) {
    var _reqData$partner4, partner, headers, cmp, query, params, urlParams, response;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _reqData$partner4 = reqData.partner, partner = _reqData$partner4 === void 0 ? PARTNER.MMT : _reqData$partner4, headers = reqData.headers, cmp = reqData.cmp, query = reqData.query;
            params = apiRoutes_objectSpread({
              context: CONTEXT.STANDALONE_V2,
              ins_new_flow: true
            }, query);
            urlParams = setURLQueryParams(params);
            _context7.next = 6;
            return API_HTTP.get("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.ORDER_LISTING).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: apiRoutes_objectSpread(apiRoutes_objectSpread({}, headers), {}, {
                cmp: cmp
              })
            });

          case 6:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](0);
            console.error("Error", {
              error: _context7.t0
            });
            throw _context7.t0;

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 10]]);
  }));

  return function getOrderListing(_x7) {
    return _ref9.apply(this, arguments);
  };
}()));
var getOrderDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
    var _ref11, partner, bookingId, headers, cmp, query, params, urlParams, response;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _ref11 = data || {}, partner = _ref11.partner, bookingId = _ref11.bookingId, headers = _ref11.headers, cmp = _ref11.cmp, query = _ref11.query;
            params = apiRoutes_objectSpread({
              bookingId: bookingId
            }, query);
            urlParams = setURLQueryParams(params);
            _context8.next = 6;
            return API_HTTP.get("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.ORDER_DETAIL).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: apiRoutes_objectSpread(apiRoutes_objectSpread({}, headers), {}, {
                cmp: cmp
              })
            });

          case 6:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](0);
            console.error("Error", {
              error: _context8.t0
            });
            throw _context8.t0;

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 10]]);
  }));

  return function getOrderDetails(_x8) {
    return _ref10.apply(this, arguments);
  };
}()));
var sendPolicyEmail = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(data) {
    var bookingId, partner, params, urlParams, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            bookingId = data.bookingId, partner = data.partner;
            params = {
              bookingID: bookingId
            };
            urlParams = setURLQueryParams(params);
            _context9.next = 6;
            return API_HTTPS.post("".concat(API_ROUTE_PREFIX, "/").concat(partner, "/").concat(API_ROUTES.TRIGGER_EMAIL).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: {
                cmp: sessionStorage.getItem("cmp")
              }
            });

          case 6:
            response = _context9.sent;
            return _context9.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](0);
            console.log("Error", {
              error: _context9.t0.message
            });
            throw _context9.t0;

          case 14:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 10]]);
  }));

  return function sendPolicyEmail(_x9) {
    return _ref12.apply(this, arguments);
  };
}()));
var apiRoutes_editInsuranceDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(reqData) {
    var bookingID, _reqData$partner5, partner, _reqData$data, data, urlParams, response;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            bookingID = reqData.bookingID, _reqData$partner5 = reqData.partner, partner = _reqData$partner5 === void 0 ? getPartnerOnClientSide() : _reqData$partner5, _reqData$data = reqData.data, data = _reqData$data === void 0 ? [] : _reqData$data;

            if (bookingID) {
              _context10.next = 4;
              break;
            }

            throw "editInsuranceDetails: Booking id not present or invalid";

          case 4:
            urlParams = setURLQueryParams({
              bookingID: bookingID
            });
            _context10.next = 7;
            return API_HTTPS.put("".concat(API_ROUTE_PREFIX_HTTPS, "/").concat(partner, "/").concat(API_ROUTES.EDIT_INSURANCE_DETAILS).concat(urlParams ? "?".concat(urlParams) : ""), data, {
              headers: {
                cmp: sessionStorage.getItem("cmp") || undefined
              }
            });

          case 7:
            response = _context10.sent;
            return _context10.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](0);
            console.error("Error", {
              error: _context10.t0
            });
            throw _context10.t0;

          case 15:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 11]]);
  }));

  return function editInsuranceDetails(_x10) {
    return _ref13.apply(this, arguments);
  };
}()));
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/index.ts


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerCommonComp.tsx










var TravellerCommonComp_analytics = getAnalytics();

var TravellerCommonComp_TravellerCommonComp = function TravellerCommonComp(_ref) {
  var _errors$tncs, _errors$tncs$find, _mobile$isRequired, _email$isRequired;

  var primaryContactData = _ref.primaryContactData,
      title = _ref.title,
      info = _ref.info,
      note = _ref.note,
      primaryContactDetails = _ref.primaryContactDetails,
      saveFormValuesOnBlur = _ref.saveFormValuesOnBlur,
      confirmTnC = _ref.confirmTnC,
      totalAmt = _ref.totalAmt,
      selectedCountry = _ref.selectedCountry,
      isLoading = _ref.isLoading,
      handleBuy = _ref.handleBuy,
      handleTncCheckbox = _ref.handleTncCheckbox,
      addOnPlans = _ref.addOnPlans,
      addOnfilters = _ref.addOnfilters,
      handleAddOnFilters = _ref.handleAddOnFilters,
      handleAddOnSelect = _ref.handleAddOnSelect,
      handleCountryCodeModal = _ref.handleCountryCodeModal,
      componentRef = _ref.componentRef;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var device = useBreakpointV2();

  var _ref2 = primaryContactData || {},
      email = _ref2.email,
      mobile = _ref2.mobile;

  var _useState = useState(-1),
      showAddOnBenefits = _useState[0],
      setShowAddOnBenefits = _useState[1];

  var tncError = (_errors$tncs = errors.tncs) === null || _errors$tncs === void 0 ? void 0 : (_errors$tncs$find = _errors$tncs.find) === null || _errors$tncs$find === void 0 ? void 0 : _errors$tncs$find.call(_errors$tncs, function (item) {
    return item === null || item === void 0 ? void 0 : item.message;
  });
  return /*#__PURE__*/_jsxs(AddTravellerComp, {
    ref: componentRef,
    children: [title && /*#__PURE__*/_jsx(H5Tag, {
      margin: "0 0 16px",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }), confirmTnC === null || confirmTnC === void 0 ? void 0 : confirmTnC.map(function (tnc, index) {
      return /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "tncs.".concat(index),
        rules: {
          required: {
            value: true,
            message: "Please confirm"
          }
        },
        render: function render(_ref3) {
          var value = _ref3.field.value;
          return /*#__PURE__*/_jsx(ConfirmTnc, {
            children: /*#__PURE__*/_jsx(CheckButton, {
              inputId: "confirmTnC",
              handleChange: function handleChange() {
                handleTncCheckbox === null || handleTncCheckbox === void 0 ? void 0 : handleTncCheckbox(index);
              },
              isChecked: value,
              children: /*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: tnc
                })
              })
            })
          });
        }
      }, index);
    }), confirmTnC && tncError && /*#__PURE__*/_jsx(ParaTag, {
      margin: "0px 0 0 4px",
      color: theme.redText2,
      fontSize: "xs",
      children: tncError.message
    }), /*#__PURE__*/_jsx(ParaTag, {
      margin: confirmTnC ? "16px 0 45px" : "16px 0",
      fontSize: "sm",
      color: theme.greyText7,
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: info
      })
    }), primaryContactDetails && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: device == "lg" ? "row" : "column",
        gap: "16px",
        children: [/*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "primaryContactData.mobile",
          rules: {
            required: {
              value: (_mobile$isRequired = mobile === null || mobile === void 0 ? void 0 : mobile.isRequired) !== null && _mobile$isRequired !== void 0 ? _mobile$isRequired : true,
              message: getFormFieldErrorMsg("mobile")
            },
            pattern: {
              value: new RegExp((mobile === null || mobile === void 0 ? void 0 : mobile.regex) || ""),
              message: getFormFieldErrorMsg("mobile", mobile === null || mobile === void 0 ? void 0 : mobile.errorMessage)
            }
          },
          render: function render(_ref4) {
            var _errors$primaryContac, _errors$primaryContac2;

            var _ref4$field = _ref4.field,
                onChange = _ref4$field.onChange,
                onBlur = _ref4$field.onBlur,
                value = _ref4$field.value;
            return /*#__PURE__*/_jsx(CountryCodeInput, {
              errorState: errors === null || errors === void 0 ? void 0 : (_errors$primaryContac = errors.primaryContactData) === null || _errors$primaryContac === void 0 ? void 0 : (_errors$primaryContac2 = _errors$primaryContac.mobile) === null || _errors$primaryContac2 === void 0 ? void 0 : _errors$primaryContac2.message,
              inputValue: value,
              handleChange: onChange,
              handleBlur: function handleBlur() {
                saveFormValuesOnBlur === null || saveFormValuesOnBlur === void 0 ? void 0 : saveFormValuesOnBlur();
                onBlur();
              },
              placeholderTxt: mobile === null || mobile === void 0 ? void 0 : mobile.placeholder,
              requiredField: mobile === null || mobile === void 0 ? void 0 : mobile.isRequired,
              labelTxt: mobile === null || mobile === void 0 ? void 0 : mobile.title,
              inputType: "tel",
              disableState: isLoading,
              autoComplete: "off",
              flex: "1",
              inputWidth: device == "lg" ? "50%" : "100%",
              handleCountryCodeModal: handleCountryCodeModal,
              countryFlag: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryFlag,
              countryCode: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryCode) || "+91"
            });
          }
        }), /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "primaryContactData.email",
          rules: {
            required: {
              value: (_email$isRequired = email === null || email === void 0 ? void 0 : email.isRequired) !== null && _email$isRequired !== void 0 ? _email$isRequired : true,
              message: getFormFieldErrorMsg("email")
            },
            pattern: {
              value: new RegExp((email === null || email === void 0 ? void 0 : email.regex) || ""),
              message: getFormFieldErrorMsg("email", email === null || email === void 0 ? void 0 : email.errorMessage)
            }
          },
          render: function render(_ref5) {
            var _errors$primaryContac3, _errors$primaryContac4;

            var _ref5$field = _ref5.field,
                onChange = _ref5$field.onChange,
                onBlur = _ref5$field.onBlur,
                value = _ref5$field.value;
            return /*#__PURE__*/_jsx(LandingInput, {
              inputValue: value,
              handleChange: onChange,
              handleBlur: function handleBlur() {
                saveFormValuesOnBlur === null || saveFormValuesOnBlur === void 0 ? void 0 : saveFormValuesOnBlur();
                onBlur();
              },
              placeholderTxt: email === null || email === void 0 ? void 0 : email.placeholder,
              requiredField: email === null || email === void 0 ? void 0 : email.isRequired,
              labelTxt: email === null || email === void 0 ? void 0 : email.title,
              errorState: errors === null || errors === void 0 ? void 0 : (_errors$primaryContac3 = errors.primaryContactData) === null || _errors$primaryContac3 === void 0 ? void 0 : (_errors$primaryContac4 = _errors$primaryContac3.email) === null || _errors$primaryContac4 === void 0 ? void 0 : _errors$primaryContac4.message,
              disableState: isLoading,
              autoComplete: "off",
              flex: "1",
              inputWidth: device == "lg" ? "50%" : "100%"
            });
          }
        })]
      }), note && /*#__PURE__*/_jsxs(PrimaryContactNote, {
        children: [/*#__PURE__*/_jsx(SpanTag, {
          color: theme.brownText,
          fontWeight: "bold",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: note.title
          })
        }), /*#__PURE__*/_jsx(SpanTag, {
          color: theme.brownText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: note === null || note === void 0 ? void 0 : note.info
          })
        })]
      })]
    }), confirmTnC && /*#__PURE__*/_jsx(StickyBtnWrap, {
      children: /*#__PURE__*/_jsx(LandingButton, {
        isLoading: isLoading,
        onClick: handleBuy,
        customTitle: "BUY FOR ".concat(totalAmt)
      })
    }), addOnfilters && /*#__PURE__*/_jsx(FlexComp, {
      alignItems: device == "lg" ? "center" : "flex-start",
      justifyContent: "space-between",
      margin: "0 0 30px",
      gap: "10px",
      flexDirection: device == "lg" ? "row" : "column",
      children: /*#__PURE__*/_jsx(Tags, {
        handleClickTab: handleAddOnFilters,
        data: addOnfilters
      })
    }), addOnPlans && addOnPlans.map(function (item, index) {
      var _item$comboProductDet, _item$modal, _item$primary, _item$primary2, _item$primary3, _item$primary3$cta, _item$secondary, _item$secondary2, _item$secondary3, _item$secondary3$cta, _item$secondary4, _item$secondary4$cta;

      return /*#__PURE__*/_jsxs(AddOnPlanWrap, {
        margin: item !== null && item !== void 0 && item.tag ? "20px 0px 14px 0px" : "0px 0px 14px 0px",
        isSelected: item === null || item === void 0 ? void 0 : item.isSelected,
        children: [showAddOnBenefits === index && /*#__PURE__*/_jsx(MoreBenefits, {
          data: item === null || item === void 0 ? void 0 : item.modal,
          tag: item === null || item === void 0 ? void 0 : item.tag,
          moreBenfitsTitle: "Add-Ons",
          customBtnTitle: item !== null && item !== void 0 && item.isSelected ? "Buy for ".concat(item === null || item === void 0 ? void 0 : (_item$comboProductDet = item.comboProductDetails) === null || _item$comboProductDet === void 0 ? void 0 : _item$comboProductDet.totalAmountToPay) : item === null || item === void 0 ? void 0 : (_item$modal = item.modal) === null || _item$modal === void 0 ? void 0 : _item$modal.buyBtn,
          isAddOnBenefits: true,
          handleClose: function handleClose() {
            setShowAddOnBenefits(-1);
          },
          handleBuyButton: function handleBuyButton() {
            if (item !== null && item !== void 0 && item.isSelected) {
              TravellerCommonComp_analytics === null || TravellerCommonComp_analytics === void 0 ? void 0 : TravellerCommonComp_analytics.trackTravDetailsEvents({
                actionType: "Buy_in_bs"
              });
              handleBuy === null || handleBuy === void 0 ? void 0 : handleBuy();
            } else {
              TravellerCommonComp_analytics === null || TravellerCommonComp_analytics === void 0 ? void 0 : TravellerCommonComp_analytics.trackTravDetailsEvents({
                actionType: "Added_in_bs"
              });
              handleAddOnSelect === null || handleAddOnSelect === void 0 ? void 0 : handleAddOnSelect(item === null || item === void 0 ? void 0 : item.planCode);
            }

            setShowAddOnBenefits(-1);
          }
        }), (item === null || item === void 0 ? void 0 : item.tag) && /*#__PURE__*/_jsx(TagWrap, {
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: item === null || item === void 0 ? void 0 : item.tag
          })
        }), /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "row",
          justifyContent: "space-between",
          margin: item !== null && item !== void 0 && item.tag ? "6px 0 0" : "0",
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            flexDirection: "row",
            gap: device === "lg" ? "14px" : "8px",
            children: [(item === null || item === void 0 ? void 0 : item.planIcon) && /*#__PURE__*/_jsx(VendorIconWrap, {
              children: /*#__PURE__*/_jsx(ImageComponent, {
                src: item === null || item === void 0 ? void 0 : item.planIcon,
                height: device === "lg" ? "48px" : "32px",
                width: device === "lg" ? "48px" : "32px"
              })
            }), /*#__PURE__*/_jsxs(FlexComp, {
              flexDirection: "column",
              children: [/*#__PURE__*/_jsx(FormattedText, {
                value: item === null || item === void 0 ? void 0 : (_item$primary = item.primary) === null || _item$primary === void 0 ? void 0 : _item$primary.title,
                baseStyle: {
                  fontSize: "14px",
                  fontWeight: "700",
                  color: theme.greyText
                }
              }), /*#__PURE__*/_jsxs(FlexComp, {
                flexDirection: device === "lg" ? "row" : "column",
                gap: device === "lg" ? "8px" : "0px",
                children: [/*#__PURE__*/_jsx(FormattedText, {
                  value: item === null || item === void 0 ? void 0 : (_item$primary2 = item.primary) === null || _item$primary2 === void 0 ? void 0 : _item$primary2.description
                }), /*#__PURE__*/_jsx(AnchorTag, {
                  margin: device === "lg" ? "3px 0px 0px 0px" : "-2px 0px 0px 0px",
                  handleClick: function handleClick() {
                    TravellerCommonComp_analytics === null || TravellerCommonComp_analytics === void 0 ? void 0 : TravellerCommonComp_analytics.trackTravDetailsEvents({
                      actionType: "View_detail_clicked"
                    });
                    setShowAddOnBenefits(index);
                  },
                  children: item === null || item === void 0 ? void 0 : (_item$primary3 = item.primary) === null || _item$primary3 === void 0 ? void 0 : (_item$primary3$cta = _item$primary3.cta) === null || _item$primary3$cta === void 0 ? void 0 : _item$primary3$cta.value
                })]
              })]
            })]
          }), /*#__PURE__*/_jsxs(FlexComp, {
            flexDirection: device === "lg" ? "row" : "column",
            gap: device === "lg" ? "12px" : "8px",
            alignItems: " center",
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              flexDirection: "column",
              children: [/*#__PURE__*/_jsxs(FlexComp, {
                justifyContent: "right",
                alignItems: "center",
                gap: "8px",
                children: [/*#__PURE__*/_jsx(FormattedText, {
                  value: item === null || item === void 0 ? void 0 : (_item$secondary = item.secondary) === null || _item$secondary === void 0 ? void 0 : _item$secondary.title,
                  baseStyle: {
                    fontSize: "14px",
                    fontWeight: "700",
                    padding: "1.5px 0px 1.5px 0px"
                  }
                }), (item === null || item === void 0 ? void 0 : item.isSelected) && /*#__PURE__*/_jsx(ImageComponent, {
                  src: item === null || item === void 0 ? void 0 : item.addedIcon,
                  height: "16px",
                  width: "16px"
                })]
              }), /*#__PURE__*/_jsx(FormattedText, {
                value: item === null || item === void 0 ? void 0 : (_item$secondary2 = item.secondary) === null || _item$secondary2 === void 0 ? void 0 : _item$secondary2.description,
                baseStyle: {
                  fontSize: "12px",
                  fontWeight: "400",
                  color: theme.greyText6
                }
              })]
            }), item !== null && item !== void 0 && item.isSelected ? /*#__PURE__*/_jsx(AnchorTag, {
              handleClick: function handleClick() {
                TravellerCommonComp_analytics === null || TravellerCommonComp_analytics === void 0 ? void 0 : TravellerCommonComp_analytics.trackTravDetailsEvents({
                  actionType: "Remove_clicked"
                });
                handleAddOnSelect === null || handleAddOnSelect === void 0 ? void 0 : handleAddOnSelect(item === null || item === void 0 ? void 0 : item.planCode);
              },
              margin: "6px 12.5px 6px 12.5px",
              children: item === null || item === void 0 ? void 0 : (_item$secondary3 = item.secondary) === null || _item$secondary3 === void 0 ? void 0 : (_item$secondary3$cta = _item$secondary3.cta) === null || _item$secondary3$cta === void 0 ? void 0 : _item$secondary3$cta.toggleValue
            }) : /*#__PURE__*/_jsx(LandingButtonWhite, {
              customTitle: item === null || item === void 0 ? void 0 : (_item$secondary4 = item.secondary) === null || _item$secondary4 === void 0 ? void 0 : (_item$secondary4$cta = _item$secondary4.cta) === null || _item$secondary4$cta === void 0 ? void 0 : _item$secondary4$cta.value,
              onClick: function onClick() {
                TravellerCommonComp_analytics === null || TravellerCommonComp_analytics === void 0 ? void 0 : TravellerCommonComp_analytics.trackTravDetailsEvents({
                  actionType: item === null || item === void 0 ? void 0 : item.addPlanEvent
                });
                TravellerCommonComp_analytics === null || TravellerCommonComp_analytics === void 0 ? void 0 : TravellerCommonComp_analytics.trackTravDetailsEvents({
                  actionType: "Add_button_clicked"
                });
                handleAddOnSelect === null || handleAddOnSelect === void 0 ? void 0 : handleAddOnSelect(item === null || item === void 0 ? void 0 : item.planCode);
              },
              customHeight: "32px",
              customWidth: "75px"
            })]
          })]
        })]
      });
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerCommonComp = ((/* unused pure expression or super */ null && (TravellerCommonComp_TravellerCommonComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetails.tsx





function AddTravellerDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AddTravellerDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AddTravellerDetails_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AddTravellerDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var AddTravellerDetails_analytics = getAnalytics();

var AddTravellerDetails = function AddTravellerDetails(_ref) {
  var _savedTravellers$leng, _concent$tnc$length, _concent$tnc, _widgets$formErrorToa, _widgets$addErrorToas, _widgets$offerToast, _widgets$offerToast2;

  var title = _ref.title,
      info = _ref.info,
      data = _ref.data,
      countryData = _ref.countryData,
      travellerCount = _ref.travellerCount,
      benefitsData = _ref.benefitsData,
      benefitsTitle = _ref.benefitsTitle,
      showBenefits = _ref.showBenefits,
      handleCountryCodeModal = _ref.handleCountryCodeModal,
      handleViewBenefits = _ref.handleViewBenefits,
      setAddOnProductDetails = _ref.setAddOnProductDetails,
      addOnProductDetails = _ref.addOnProductDetails;

  var _ref2 = data || {},
      primaryContact = _ref2.primaryContact,
      secondaryContact = _ref2.secondaryContact,
      upcomingTravellerDetails = _ref2.upcomingTravellerDetails,
      savedTravellers = _ref2.savedTravellers,
      note = _ref2.note,
      concent = _ref2.concent,
      totalAmt = _ref2.totalAmt,
      widgets = _ref2.widgets,
      isDomesticBooking = _ref2.isDomesticBooking,
      addOns = _ref2.addOns,
      experiment = _ref2.experiment,
      planInfo = _ref2.planInfo;

  var _ref3 = addOns || {},
      addOnPlans = _ref3.addOnPlans,
      filters = _ref3.filters;

  var _ref4 = (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.fields) || {},
      dob = _ref4.dob,
      name = _ref4.name,
      gender = _ref4.gender;

  var formErrorToast = constants.formErrorToast,
      addErrorToast = constants.addErrorToast;
  var device = useBreakpointV2();
  var travellerDataFromStore = getTravDetailsFromMemory();

  var _ref5 = travellerDataFromStore || {},
      travellerDetails = _ref5.travellerDetails,
      primaryContactDetails = _ref5.primaryContactDetails;

  var travellerRef = useRef(null);

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState(),
      checkoutError = _useState2[0],
      setCheckoutError = _useState2[1];

  var _useState3 = useState(-1),
      addTrav = _useState3[0],
      setAddTrav = _useState3[1];

  var _useState4 = useState(null),
      quoteId = _useState4[0],
      setQuoteId = _useState4[1];

  var _useState5 = useState(-1),
      firstErrorIndex = _useState5[0],
      setFirstErrorIndex = _useState5[1];

  var _useState6 = useState(false),
      isValidForm = _useState6[0],
      setIsValidForm = _useState6[1];

  var _useState7 = useState(false),
      isSelectedError = _useState7[0],
      setIsSelectedError = _useState7[1];

  var _useState8 = useState(false),
      isFieldError = _useState8[0],
      setIsFieldError = _useState8[1];

  var _useState9 = useState(true),
      showOfferToast = _useState9[0],
      setShowOfferToast = _useState9[1];

  var _useState10 = useState(filters),
      addOnFilters = _useState10[0],
      setAddOnFilters = _useState10[1];

  var _useState11 = useState(addOnPlans),
      addOnPlansData = _useState11[0],
      setAddOnPlansData = _useState11[1];

  var primaryContactRef = useRef(null);
  var tncRef = useRef(null);
  useEffect(function () {
    if (planInfo !== null && planInfo !== void 0 && planInfo.quoteId) {
      setQuoteId(planInfo.quoteId);
    } else {
      var queryParams = new URLSearchParams(window.location.search);

      var _quoteId = queryParams.get("quoteId");

      setQuoteId(_quoteId);
    }

    setTimeout(function () {
      setShowOfferToast(false);
    }, 3000);
  }, []);
  var methods = useForm({
    defaultValues: {
      travellerData: Array.from({
        length: ((_savedTravellers$leng = savedTravellers === null || savedTravellers === void 0 ? void 0 : savedTravellers.length) !== null && _savedTravellers$leng !== void 0 ? _savedTravellers$leng : 0) + travellerCount
      }).map(function () {
        return {
          name: "",
          dob: "",
          gender: "",
          isSelected: false
        };
      }),
      primaryContactData: {
        email: "",
        mobile: ""
      },
      tncs: Array.from({
        length: (_concent$tnc$length = concent === null || concent === void 0 ? void 0 : (_concent$tnc = concent.tnc) === null || _concent$tnc === void 0 ? void 0 : _concent$tnc.length) !== null && _concent$tnc$length !== void 0 ? _concent$tnc$length : 0
      }).map(function () {
        return true;
      })
    },
    mode: "onTouched"
  });
  var control = methods.control,
      getValues = methods.getValues,
      setValue = methods.setValue,
      getFieldState = methods.getFieldState,
      setError = methods.setError,
      handleSubmit = methods.handleSubmit,
      trigger = methods.trigger;
  var formValues = getValues();
  var travellerData = useWatch({
    control: control,
    name: "travellerData" // unique name for field array

  });

  var _useFieldArray = useFieldArray({
    control: control,
    name: "travellerData" // unique name for field array

  }),
      travellers = _useFieldArray.fields,
      append = _useFieldArray.append;

  var selectedCount = useMemo(function () {
    var _travellerData$filter, _travellerData$filter2;

    return (_travellerData$filter = travellerData === null || travellerData === void 0 ? void 0 : (_travellerData$filter2 = travellerData.filter(function (traveller) {
      return traveller.isSelected;
    })) === null || _travellerData$filter2 === void 0 ? void 0 : _travellerData$filter2.length) !== null && _travellerData$filter !== void 0 ? _travellerData$filter : 0;
  }, [travellerData]);
  useMemo(function () {
    if (selectedCount === travellerCount) {
      var isValid = true;
      travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (data) {
        if (data.isSelected) {
          var validName = name !== null && name !== void 0 && name.isEnabled ? data.name ? true : false : true;
          var validDob = dob !== null && dob !== void 0 && dob.isEnabled ? data.dob ? true : false : true;
          var validGender = gender !== null && gender !== void 0 && gender.isEnabled ? data !== null && data !== void 0 && data.gender ? true : false : true;

          if (!(validDob && validGender && validName)) {
            isValid = false;
          }
        }
      });
      setIsValidForm(isValid);
    } else {
      setIsValidForm(false);
    }
  }, [travellerData]); // To add saved travellers and upcoming travellers in memory

  useEffect(function () {
    var travellerDetail = [];
    var queryParams = new URLSearchParams(window.location.search);

    if (!(travellerDetails !== null && travellerDetails !== void 0 && travellerDetails.length) || queryParams.get("isUpcomingTrip") === "true") {
      if (queryParams.get("isUpcomingTrip") === "true" || (savedTravellers === null || savedTravellers === void 0 ? void 0 : savedTravellers.length) === 0) {
        upcomingTravellerDetails === null || upcomingTravellerDetails === void 0 ? void 0 : upcomingTravellerDetails.map(function (data) {
          travellerDetail.push(AddTravellerDetails_objectSpread(AddTravellerDetails_objectSpread({}, data), {}, {
            dob: parseInt(data.dob),
            gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1).toLowerCase(),
            isSelected: queryParams.get("isUpcomingTrip") === "true"
          }));
        });
      }

      savedTravellers === null || savedTravellers === void 0 ? void 0 : savedTravellers.map(function (data) {
        travellerDetail.push(AddTravellerDetails_objectSpread(AddTravellerDetails_objectSpread({}, data), {}, {
          gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1).toLowerCase(),
          isSelected: false,
          isSavedTraveller: true,
          isEdited: false
        }));
      });
      setTravDetailsInMemory(AddTravellerDetails_objectSpread(AddTravellerDetails_objectSpread({}, travellerDataFromStore), {}, {
        travellerDetails: travellerDetail,
        primaryContactDetails: primaryContact
      }));

      if (travellerDetail.length === 0) {
        setAddTrav(0);
      }
    } else {
      var selectedTravellersInMemory = travellerDetails === null || travellerDetails === void 0 ? void 0 : travellerDetails.filter(function (data) {
        return data.isSelected;
      });
      var remainingTravellersInMemory = travellerDetails === null || travellerDetails === void 0 ? void 0 : travellerDetails.filter(function (data) {
        return !data.isSelected;
      });

      var _queryParams = new URLSearchParams(window.location.search);

      var _travellers = Number(_queryParams.get("travellers"));

      travellerDetail.push.apply(travellerDetail, _toConsumableArray(selectedTravellersInMemory.slice(0, _travellers)).concat(_toConsumableArray(selectedTravellersInMemory.slice(_travellers).map(function (data) {
        return AddTravellerDetails_objectSpread(AddTravellerDetails_objectSpread({}, data), {}, {
          isSelected: false
        });
      })), _toConsumableArray(remainingTravellersInMemory)));
    }

    var length = travellerDetail !== null && travellerDetail !== void 0 && travellerDetail.length ? travellerDetail === null || travellerDetail === void 0 ? void 0 : travellerDetail.length : upcomingTravellerDetails !== null && upcomingTravellerDetails !== void 0 && upcomingTravellerDetails.length ? upcomingTravellerDetails === null || upcomingTravellerDetails === void 0 ? void 0 : upcomingTravellerDetails.length : 1;
    setValue("travellerData", Array.from({
      length: length
    }).map(function (_, index) {
      var _travellerDetail$inde, _travellerDetail$inde2, _travellerDetail$inde3, _travellerDetail$inde4, _travellerDetail$inde5, _travellerDetail$inde6, _travellerDetail$inde7, _travellerDetail$inde8, _travellerDetail$inde9, _travellerDetail$inde10, _travellerDetail$inde11, _travellerDetail$inde12;

      return {
        name: (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde = travellerDetail[index]) === null || _travellerDetail$inde === void 0 ? void 0 : _travellerDetail$inde.name) || "",
        dob: travellerDetail !== null && travellerDetail !== void 0 && (_travellerDetail$inde2 = travellerDetail[index]) !== null && _travellerDetail$inde2 !== void 0 && _travellerDetail$inde2.isSavedTraveller ? (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde3 = travellerDetail[index]) === null || _travellerDetail$inde3 === void 0 ? void 0 : _travellerDetail$inde3.dob) || "" : (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde4 = travellerDetail[index]) === null || _travellerDetail$inde4 === void 0 ? void 0 : _travellerDetail$inde4.dob) || "2000-01-01",
        gender: (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde5 = travellerDetail[index]) === null || _travellerDetail$inde5 === void 0 ? void 0 : _travellerDetail$inde5.gender) || "",
        passport: (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde6 = travellerDetail[index]) === null || _travellerDetail$inde6 === void 0 ? void 0 : _travellerDetail$inde6.passport) || "",
        isSelected: (_travellerDetail$inde7 = travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde8 = travellerDetail[index]) === null || _travellerDetail$inde8 === void 0 ? void 0 : _travellerDetail$inde8.isSelected) !== null && _travellerDetail$inde7 !== void 0 ? _travellerDetail$inde7 : true,
        isEdited: (_travellerDetail$inde9 = travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde10 = travellerDetail[index]) === null || _travellerDetail$inde10 === void 0 ? void 0 : _travellerDetail$inde10.isEdited) !== null && _travellerDetail$inde9 !== void 0 ? _travellerDetail$inde9 : true,
        isSavedTraveller: (_travellerDetail$inde11 = travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde12 = travellerDetail[index]) === null || _travellerDetail$inde12 === void 0 ? void 0 : _travellerDetail$inde12.isSavedTraveller) !== null && _travellerDetail$inde11 !== void 0 ? _travellerDetail$inde11 : false
      };
    }));
  }, [secondaryContact, savedTravellers, upcomingTravellerDetails]);
  useEffect(function () {
    var _primaryContact$field, _primaryContact$field2, _primaryContact$field3, _primaryContact$field4;

    setValue("primaryContactData", {
      mobile: (primaryContactDetails === null || primaryContactDetails === void 0 ? void 0 : primaryContactDetails.mobile) || (primaryContact === null || primaryContact === void 0 ? void 0 : (_primaryContact$field = primaryContact.fields) === null || _primaryContact$field === void 0 ? void 0 : (_primaryContact$field2 = _primaryContact$field.mobile) === null || _primaryContact$field2 === void 0 ? void 0 : _primaryContact$field2.value) || "",
      email: (primaryContactDetails === null || primaryContactDetails === void 0 ? void 0 : primaryContactDetails.email) || (primaryContact === null || primaryContact === void 0 ? void 0 : (_primaryContact$field3 = primaryContact.fields) === null || _primaryContact$field3 === void 0 ? void 0 : (_primaryContact$field4 = _primaryContact$field3.email) === null || _primaryContact$field4 === void 0 ? void 0 : _primaryContact$field4.value) || ""
    });
  }, [primaryContact]);
  var selectedCountry = useMemo(function () {
    return countryData === null || countryData === void 0 ? void 0 : countryData.find(function (item) {
      return item.isSelected;
    });
  }, [countryData]);

  var _handleArrowButton = function handleArrowButton(index) {
    if (addTrav === index) {
      setAddTrav(-1);

      if (travellerData !== null && travellerData !== void 0 && travellerData[index].isSelected) {
        trigger("travellerData.".concat(index));
      }
    } else {
      setAddTrav(index);
    }
  };

  var _handleGenderChange = function handleGenderChange(data, index) {
    setValue("travellerData.".concat(index, ".gender"), data.label);
  };

  var saveFormValuesOnBlur = function saveFormValuesOnBlur() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

    if (index != -1 && !getValues("travellerData.".concat(index, ".isEdited"))) {
      setValue("travellerData.".concat(index, ".isEdited"), true);
    }

    var travellerData = formValues.travellerData,
        primaryContactData = formValues.primaryContactData;
    setTravDetailsInMemory(AddTravellerDetails_objectSpread(AddTravellerDetails_objectSpread({}, travellerDataFromStore), {}, {
      travellerDetails: travellerData,
      primaryContactDetails: primaryContactData
    }));
  };

  var getTravellerDetailList = function getTravellerDetailList(data) {
    var _ref6 = data || {},
        travellerData = _ref6.travellerData,
        _ref6$primaryContactD = _ref6.primaryContactData;

    _ref6$primaryContactD = _ref6$primaryContactD === void 0 ? {} : _ref6$primaryContactD;
    var _ref6$primaryContactD2 = _ref6$primaryContactD.email,
        email = _ref6$primaryContactD2 === void 0 ? "" : _ref6$primaryContactD2,
        _ref6$primaryContactD3 = _ref6$primaryContactD.mobile,
        mobile = _ref6$primaryContactD3 === void 0 ? "" : _ref6$primaryContactD3;
    var travellerList = travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (traveller, index) {
      if (traveller.isSelected) {
        var _traveller$isEdited, _traveller$passport;

        return {
          travellerId: index.toString(),
          name: traveller.name.trim(),
          dob: formatDate(traveller.dob, DATE_FORMATS["DD/MM/YYYY"]),
          gender: traveller.gender,
          mobile: "".concat((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryCode) || "+91").concat(mobile.trim()),
          isEdited: (_traveller$isEdited = traveller === null || traveller === void 0 ? void 0 : traveller.isEdited) !== null && _traveller$isEdited !== void 0 ? _traveller$isEdited : false,
          passport: (_traveller$passport = traveller === null || traveller === void 0 ? void 0 : traveller.passport) !== null && _traveller$passport !== void 0 ? _traveller$passport : "",
          email: email,
          countryCode: ""
        };
      } else {
        return null;
      }
    }).filter(function (data) {
      return data != null;
    });
    return travellerList;
  };

  var handleTncCheckbox = function handleTncCheckbox(index) {
    var value = formValues.tncs[index];
    setValue("tncs.".concat(index), !value);
    trigger("tncs.".concat(index));
  };

  var handleServerErrors = function handleServerErrors(error) {
    var _ref7 = (error === null || error === void 0 ? void 0 : error.validationError) || {},
        _ref7$displayPrimaryM = _ref7.displayPrimaryMobileError,
        displayPrimaryMobileError = _ref7$displayPrimaryM === void 0 ? "" : _ref7$displayPrimaryM,
        _ref7$displayPrimaryE = _ref7.displayPrimaryEmailError,
        displayPrimaryEmailError = _ref7$displayPrimaryE === void 0 ? "" : _ref7$displayPrimaryE,
        _ref7$displaySecondar = _ref7.displaySecondaryError,
        displaySecondaryError = _ref7$displaySecondar === void 0 ? [] : _ref7$displaySecondar;

    if (displayPrimaryMobileError) {
      setError("primaryContactData.mobile", {
        message: displayPrimaryMobileError
      });
      AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
        actionType: "error_shown",
        payload: displayPrimaryMobileError
      });
    }

    if (displayPrimaryEmailError) {
      setError("primaryContactData.email", {
        message: displayPrimaryEmailError
      });
      AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
        actionType: "error_shown",
        payload: displayPrimaryEmailError
      });
    }

    displaySecondaryError.map(function (item, index) {
      var travellerId = item.travellerId;

      var _ref8 = (item === null || item === void 0 ? void 0 : item.displayError) || {},
          name = _ref8.name,
          dob = _ref8.dob,
          gender = _ref8.gender;

      if (name) {
        setError("travellerData.".concat(travellerId || index, ".name"), {
          message: name
        });
        AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
          actionType: "error_shown",
          payload: name
        });
      }

      if (dob) {
        setError("travellerData.".concat(travellerId || index, ".dob"), {
          message: dob
        });
        AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
          actionType: "error_shown",
          payload: dob
        });
      }

      if (gender) {
        setError("travellerData.".concat(travellerId || index, ".gender"), {
          message: gender
        });
        AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
          actionType: "error_shown",
          payload: gender
        });
      }
    });

    if (displaySecondaryError.length) {
      var _displaySecondaryErro;

      var firstError = Number((_displaySecondaryErro = displaySecondaryError[0]) === null || _displaySecondaryErro === void 0 ? void 0 : _displaySecondaryErro.travellerId);

      if (!Number.isNaN(firstError)) {
        var _primaryContactRef$cu;

        (_primaryContactRef$cu = primaryContactRef.current) === null || _primaryContactRef$cu === void 0 ? void 0 : _primaryContactRef$cu.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "center"
        });
      }
    }
  };

  var handleErrorToast = function handleErrorToast() {
    setTimeout(function () {
      setIsSelectedError(false);
      setIsFieldError(false);
    }, 3000);
  };

  var handleTravellerSelect = function handleTravellerSelect(value, index) {
    if (getValues("travellerData.".concat(index, ".isSelected"))) {
      setAddTrav(-1);
      setValue("travellerData.".concat(index, ".isSelected"), false);
    } else {
      if (selectedCount === travellerCount) {
        if (!isSelectedError) {
          setIsSelectedError(true);
          handleErrorToast();
        }
      } else {
        setAddTrav(index);
        setValue("travellerData.".concat(index, ".isSelected"), true);
      }
    }
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formData) {
      var partner, _travellerDetails, failureUrl, requestData, response, responseStatus, _data, checkoutUrl, _Error, error, _err$response, _ref10, _error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "traveller_name_filled"
              });
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "contact_details_filled"
              });
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "dob_selected"
              });
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "gender_selected"
              });
              partner = getPartnerOnClientSide();
              _travellerDetails = getTravellerDetailList(formData);
              failureUrl = new URL(window.location.href);
              failureUrl.searchParams.append("paymentSuccess", "false");
              requestData = {
                quoteId: quoteId,
                insurancePurchaseRequest: _travellerDetails,
                failureUrl: failureUrl
              };
              setIsLoading(true);
              _context.next = 13;
              return paymentCheckout({
                partner: partner,
                data: requestData
              });

            case 13:
              response = _context.sent;
              responseStatus = response.responseStatus, _data = response.data;

              if (responseStatus === RESPONSE_STATUS.SUCCESS && _data !== null && _data !== void 0 && _data.checkoutUrl) {
                checkoutUrl = _data.checkoutUrl;
                setIsLoading(false);
                openCheckoutPage(checkoutUrl);
              } else {
                setIsLoading(false);
                _Error = response.Error, error = response.error;

                if (_Error && (_Error === null || _Error === void 0 ? void 0 : _Error.code) === ERROR_CODES.DISPLAY_ERROR) {
                  handleServerErrors(_Error);
                } else {
                  setCheckoutError(error);
                }
              }

              _context.next = 24;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              console.error("CHECKOUT FAILURE ERROR ----", {
                err: _context.t0
              });
              _ref10 = (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data) || {}, _error = _ref10.error;
              setIsLoading(false);
              setCheckoutError(_error);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    }));

    return function onSubmit(_x) {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleAddTraveller = function handleAddTraveller() {
    if (selectedCount != travellerCount) {
      setAddTrav(travellers.length);
      append({
        name: "",
        dob: "2000-01-01",
        gender: "",
        isSelected: true
      });
    }
  };

  var onSubmitError = function onSubmitError(errors) {
    var _errors$travellerData, _errors$primaryContac, _errors$primaryContac2, _errors$tncs;

    if (!isFieldError) {
      setIsFieldError(true);
      handleErrorToast();
    }

    if ((_errors$travellerData = errors.travellerData) !== null && _errors$travellerData !== void 0 && _errors$travellerData.length) {
      var _errors$travellerData2, _errors$travellerData3;

      var errorIndex = (_errors$travellerData2 = errors.travellerData) === null || _errors$travellerData2 === void 0 ? void 0 : (_errors$travellerData3 = _errors$travellerData2.findIndex) === null || _errors$travellerData3 === void 0 ? void 0 : _errors$travellerData3.call(_errors$travellerData2, function (error) {
        return error;
      });

      if (errorIndex != null && errorIndex > -1) {
        setFirstErrorIndex(errorIndex);
      }
    } else if ((_errors$primaryContac = errors.primaryContactData) !== null && _errors$primaryContac !== void 0 && _errors$primaryContac.email || (_errors$primaryContac2 = errors.primaryContactData) !== null && _errors$primaryContac2 !== void 0 && _errors$primaryContac2.mobile) {
      var _primaryContactRef$cu2;

      (_primaryContactRef$cu2 = primaryContactRef.current) === null || _primaryContactRef$cu2 === void 0 ? void 0 : _primaryContactRef$cu2.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "center"
      });
    } else if ((_errors$tncs = errors.tncs) !== null && _errors$tncs !== void 0 && _errors$tncs.length) {
      var _tncRef$current;

      (_tncRef$current = tncRef.current) === null || _tncRef$current === void 0 ? void 0 : _tncRef$current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center"
      });
    }
  };

  useEffect(function () {
    if (firstErrorIndex > -1) {
      var _travellerRef$current;

      (_travellerRef$current = travellerRef.current) === null || _travellerRef$current === void 0 ? void 0 : _travellerRef$current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
      setAddTrav(-1);
    }

    setFirstErrorIndex(-1);
  }, [firstErrorIndex]);

  var _handleBuy = function handleBuy() {
    var fromBenefitModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (showBenefits) {
      handleViewBenefits();
    }

    if (selectedCount !== travellerCount) {
      if (!isFieldError) {
        setIsFieldError(true);
        setFirstErrorIndex(0);
        handleErrorToast();
      }
    } else {
      var _formValues$traveller;

      if (isDomesticBooking) {
        if (fromBenefitModal) {
          AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
            actionType: "buy_clicked_details_domestic"
          });
        } else {
          AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
            actionType: "buy_clicked_outside_domestic"
          });
        }
      } else {
        AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
          actionType: "buy_clicked"
        });
      }

      var _formValues = getValues();

      _formValues === null || _formValues === void 0 ? void 0 : (_formValues$traveller = _formValues.travellerData) === null || _formValues$traveller === void 0 ? void 0 : _formValues$traveller.map(function (item, index) {
        var _ref11 = item || {},
            fullName = _ref11.name,
            dobValue = _ref11.dob,
            genderType = _ref11.gender;

        var fieldState = getFieldState("travellerData.".concat(index));
        var isTouched = fieldState.isTouched;

        if (!isTouched) {
          if (name !== null && name !== void 0 && name.isEnabled && !fullName) {
            setError("travellerData.".concat(index, ".name"), {
              message: getFormFieldErrorMsg("name")
            });
          } else if (dob !== null && dob !== void 0 && dob.isEnabled && !dobValue) {
            setError("travellerData.".concat(index, ".dob"), {
              message: getFormFieldErrorMsg("dob")
            });
          } else if (gender !== null && gender !== void 0 && gender.isEnabled && !genderType) {
            setError("travellerData.".concat(index, ".gender"), {
              message: getFormFieldErrorMsg("gender")
            });
          }
        }
      });
      handleSubmit(onSubmit, onSubmitError)();
    }
  };

  if (checkoutError && true) {
    throw new ClientError(checkoutError);
  }

  var handleAddOnFilters = function handleAddOnFilters(id) {
    var _filterData$filter, _filterData$filter$, _addOnPlans$map;

    AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
      actionType: "Filter_selected"
    });
    var filterData = filters === null || filters === void 0 ? void 0 : filters.map(function (filter, index) {
      if (index === id) {
        filter.isSelected = true;
      } else {
        filter.isSelected = false;
      }

      return filter;
    });
    var selectedFilteredPlans = filterData === null || filterData === void 0 ? void 0 : (_filterData$filter = filterData.filter(function (filter) {
      return filter.isSelected;
    })) === null || _filterData$filter === void 0 ? void 0 : (_filterData$filter$ = _filterData$filter[0]) === null || _filterData$filter$ === void 0 ? void 0 : _filterData$filter$.plans;
    var currentAddOnPlans = addOnPlans === null || addOnPlans === void 0 ? void 0 : (_addOnPlans$map = addOnPlans.map(function (plan) {
      if (selectedFilteredPlans !== null && selectedFilteredPlans !== void 0 && selectedFilteredPlans.includes(plan === null || plan === void 0 ? void 0 : plan.planCode)) {
        return plan;
      } else {
        return null;
      }
    })) === null || _addOnPlans$map === void 0 ? void 0 : _addOnPlans$map.filter(function (plan) {
      return plan !== null;
    });
    setAddOnPlansData(currentAddOnPlans);
    setAddOnFilters(filterData);
  };

  var handleAddOnSelect = function handleAddOnSelect(planCode) {
    var _addOnFilters$filter, _addOnFilters$filter$, _addOnPlans$map2, _addOnPlans$filter, _addOnPlans$filter$;

    var selectedFilteredPlans = addOnFilters === null || addOnFilters === void 0 ? void 0 : (_addOnFilters$filter = addOnFilters.filter(function (filter) {
      return filter.isSelected;
    })) === null || _addOnFilters$filter === void 0 ? void 0 : (_addOnFilters$filter$ = _addOnFilters$filter[0]) === null || _addOnFilters$filter$ === void 0 ? void 0 : _addOnFilters$filter$.plans;
    var addOnData = addOnPlans === null || addOnPlans === void 0 ? void 0 : (_addOnPlans$map2 = addOnPlans.map(function (plan, index) {
      if ((plan === null || plan === void 0 ? void 0 : plan.planCode) === planCode) {
        if (plan.isSelected) {
          var queryParams = new URLSearchParams(window.location.search);

          var _quoteId2 = queryParams.get("quoteId");

          setQuoteId(_quoteId2);
          plan.isSelected = false;
        } else {
          setQuoteId(plan === null || plan === void 0 ? void 0 : plan.quoteId);
          plan.isSelected = true;
        }
      } else {
        plan.isSelected = false;
      }

      return plan;
    })) === null || _addOnPlans$map2 === void 0 ? void 0 : _addOnPlans$map2.filter(function (plan) {
      return selectedFilteredPlans === null || selectedFilteredPlans === void 0 ? void 0 : selectedFilteredPlans.includes(plan === null || plan === void 0 ? void 0 : plan.planCode);
    });
    var selectedAddOnProdDetails = addOnPlans === null || addOnPlans === void 0 ? void 0 : (_addOnPlans$filter = addOnPlans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isSelected;
    })) === null || _addOnPlans$filter === void 0 ? void 0 : (_addOnPlans$filter$ = _addOnPlans$filter[0]) === null || _addOnPlans$filter$ === void 0 ? void 0 : _addOnPlans$filter$.comboProductDetails;

    if (selectedAddOnProdDetails) {
      setAddOnProductDetails === null || setAddOnProductDetails === void 0 ? void 0 : setAddOnProductDetails(selectedAddOnProdDetails);
    } else {
      setAddOnProductDetails === null || setAddOnProductDetails === void 0 ? void 0 : setAddOnProductDetails(null);
    }

    setAddOnPlansData(addOnData);
  };

  return /*#__PURE__*/_jsxs(FormProvider, AddTravellerDetails_objectSpread(AddTravellerDetails_objectSpread({}, methods), {}, {
    children: [/*#__PURE__*/_jsxs(AddTravellerDetailStyle, {
      children: [/*#__PURE__*/_jsxs(AddTravellerHd, {
        children: [/*#__PURE__*/_jsx(H5Tag, {
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: title
          })
        }), /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "xs",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: info
          })
        })]
      }), travellers.map(function (traveller, index) {
        var _formValues$traveller2, _secondaryContact$fie, _secondaryContact$fie2;

        var _ref12 = (formValues === null || formValues === void 0 ? void 0 : (_formValues$traveller2 = formValues.travellerData) === null || _formValues$traveller2 === void 0 ? void 0 : _formValues$traveller2[index]) || {},
            gender = _ref12.gender,
            isSelected = _ref12.isSelected;

        return /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(TravellerDetailsV2, {
            handleTravellerSelect: handleTravellerSelect,
            travellerIndex: index,
            travellerRef: travellerRef,
            isLoading: isLoading,
            firstErrorIndex: firstErrorIndex,
            travellerSelected: addTrav == index,
            isSelected: isSelected,
            count: selectedCount,
            travellerNumber: "".concat(secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.title, " ").concat(index + 1),
            isSavedTravellers: savedTravellers !== null && savedTravellers !== void 0 && savedTravellers.length ? true : false,
            secondaryContactData: secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.fields,
            genderTypes: (secondaryContact === null || secondaryContact === void 0 ? void 0 : (_secondaryContact$fie = secondaryContact.fields) === null || _secondaryContact$fie === void 0 ? void 0 : (_secondaryContact$fie2 = _secondaryContact$fie.gender) === null || _secondaryContact$fie2 === void 0 ? void 0 : _secondaryContact$fie2.values) || GENDER_VALUES,
            selectedGender: gender,
            handleGenderChange: function handleGenderChange(item) {
              return _handleGenderChange(item, index);
            },
            handleArrowButton: function handleArrowButton() {
              return _handleArrowButton(index);
            },
            travellerCount: travellerCount,
            saveFormValuesOnBlur: saveFormValuesOnBlur,
            isDomesticBooking: isDomesticBooking,
            isValidForm: isValidForm,
            isEditable: (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.isEditable) === false ? false : true
          })
        }, traveller.id);
      }), /*#__PURE__*/_jsx(SectionDividers, {
        height: "1.2px"
      }), !isDomesticBooking && /*#__PURE__*/_jsxs(AddButtonWrap, {
        isDisabled: selectedCount === travellerCount,
        onClick: handleAddTraveller,
        children: [/*#__PURE__*/_jsx(ImageComponent, {
          width: "16px",
          height: "16px",
          margin: "0px 10px 0px 0px",
          src: selectedCount === travellerCount ? "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_529ac663fb.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_68e1489f3a.svg"
        }), /*#__PURE__*/_jsx(FormattedText, {
          value: "ADD ANOTHER TRAVELLER",
          baseStyle: {
            fontWeight: "800" // margin: '10px 0px 10px 0px',

          }
        })]
      }), /*#__PURE__*/_jsx(SectionDividers, {
        small: true
      }), addOns && /*#__PURE__*/_jsx(TravellerCommonComp, {
        title: addOns === null || addOns === void 0 ? void 0 : addOns.title,
        info: addOns === null || addOns === void 0 ? void 0 : addOns.subTitle,
        addOnPlans: addOnPlansData,
        addOnfilters: addOnFilters,
        handleBuy: _handleBuy,
        handleAddOnFilters: handleAddOnFilters,
        handleAddOnSelect: handleAddOnSelect
      }), addOns && /*#__PURE__*/_jsx(SectionDividers, {
        small: true
      }), /*#__PURE__*/_jsx(TravellerCommonComp, {
        componentRef: primaryContactRef,
        title: primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.title,
        info: primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.info,
        note: isDomesticBooking ? undefined : note,
        primaryContactDetails: true,
        primaryContactData: primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.fields,
        saveFormValuesOnBlur: saveFormValuesOnBlur,
        countryData: countryData,
        selectedCountry: selectedCountry,
        handleCountryCodeModal: handleCountryCodeModal
      }), /*#__PURE__*/_jsx(SectionDividers, {
        small: true
      }), /*#__PURE__*/_jsx(TravellerCommonComp, {
        componentRef: tncRef,
        confirmTnC: concent === null || concent === void 0 ? void 0 : concent.tnc,
        handleTncCheckbox: handleTncCheckbox,
        info: isDomesticBooking ? "" : concent === null || concent === void 0 ? void 0 : concent.info,
        totalAmt: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.totalAmountToPay ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.totalAmountToPay : totalAmt,
        handleBuy: function handleBuy() {
          _handleBuy();
        },
        isLoading: isLoading
      })]
    }), isSelectedError && /*#__PURE__*/_jsx(WebToast, {
      toastTxt: "Already selected ".concat(travellerCount, " ").concat(travellerCount === 1 ? "traveller" : "travellers", ", Remove before adding one."),
      position: "fixed",
      right: "50px",
      margin: device === "lg" ? "0px 0px 0px 28px" : "",
      height: "40px",
      bottom: device === "sm" ? "70px" : "50px"
    }), isFieldError && /*#__PURE__*/_jsx(WebToastWrap, {
      children: /*#__PURE__*/_jsx(WebToast, {
        type: "error",
        toastTxt: selectedCount === travellerCount ? widgets !== null && widgets !== void 0 && widgets.formErrorToast ? widgets === null || widgets === void 0 ? void 0 : (_widgets$formErrorToa = widgets.formErrorToast) === null || _widgets$formErrorToa === void 0 ? void 0 : _widgets$formErrorToa.message : formErrorToast : widgets !== null && widgets !== void 0 && widgets.addErrorToast ? widgets === null || widgets === void 0 ? void 0 : (_widgets$addErrorToas = widgets.addErrorToast) === null || _widgets$addErrorToas === void 0 ? void 0 : _widgets$addErrorToas.message : addErrorToast,
        color: "#6B4300"
      })
    }), (widgets === null || widgets === void 0 ? void 0 : widgets.offerToast) && showOfferToast && /*#__PURE__*/_jsx(WebToast, {
      type: "success",
      iconUrl: widgets === null || widgets === void 0 ? void 0 : (_widgets$offerToast = widgets.offerToast) === null || _widgets$offerToast === void 0 ? void 0 : _widgets$offerToast.iconUrl,
      toastTxt: widgets === null || widgets === void 0 ? void 0 : (_widgets$offerToast2 = widgets.offerToast) === null || _widgets$offerToast2 === void 0 ? void 0 : _widgets$offerToast2.message,
      position: "fixed",
      toastTxtMargin: "0px 0px 0px 5px",
      color: "#1E5C43",
      fontSize: "14px",
      fontWeight: "700",
      right: "50px",
      bottom: device === "sm" ? "70px" : "50px"
    }), showBenefits && /*#__PURE__*/_jsx(MoreBenefits, {
      data: benefitsData,
      moreBenfitsTitle: benefitsTitle,
      handleClose: handleViewBenefits,
      handleBuyButton: function handleBuyButton() {
        _handleBuy(true);
      }
    })]
  }));
};

/* harmony default export */ var AddTravellerDetail_AddTravellerDetails = ((/* unused pure expression or super */ null && (AddTravellerDetails)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsShimmer.tsx







var TravellerDetailsShimmer_TravellerDetailsShimmer = function TravellerDetailsShimmer(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsxs(TravellerDetailsStyle, {
    children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
      width: "266px",
      height: "20px",
      margin: "0 0 16px"
    }), /*#__PURE__*/_jsxs(FlexComp, {
      gap: "16px",
      margin: "0 0 16px",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "170px",
          height: "18px",
          margin: "0 0 8px"
        }), /*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "258px",
          height: "40px"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "170px",
          height: "18px",
          margin: "0 0 8px"
        }), /*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "258px",
          height: "40px"
        })]
      })]
    }), /*#__PURE__*/_jsx(ShimmerVersion2, {
      width: "170px",
      height: "24px",
      margin: "0 0 8px"
    }), /*#__PURE__*/_jsxs(FlexComp, {
      gap: "8px",
      children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "77px",
        height: "36px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "77px",
        height: "36px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "77px",
        height: "36px"
      })]
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerDetailsShimmer = ((/* unused pure expression or super */ null && (TravellerDetailsShimmer_TravellerDetailsShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetailShimmer.tsx








var AddTravellerDetailShimmer = function AddTravellerDetailShimmer(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsxs(AddTravellerDetailStyle, {
    children: [/*#__PURE__*/_jsxs(AddTravellerHd, {
      children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "100%",
        height: "28px",
        margin: "0 0 8px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "266px",
        height: "16px"
      })]
    }), /*#__PURE__*/_jsx(TravellerDetailsShimmer, {}), Array.from({
      length: 3
    }).map(function (_item, index) {
      return /*#__PURE__*/_jsxs(TravellerAddShimmer, {
        children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "75px",
          height: "20px"
        }), /*#__PURE__*/_jsx(ShimmerVersion3, {
          width: "60px",
          height: "32px"
        })]
      }, "".concat(index));
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_AddTravellerDetailShimmer = ((/* unused pure expression or super */ null && (AddTravellerDetailShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AmountBreakup/AmountBreakup.style.ts

var AmountBreakupStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AmountBreakupstyle__AmountBreakupStyle",
  componentId: "sc-1sh80ol-0"
})([""]);
var AmountBreakup_style_BreakupList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "AmountBreakupstyle__BreakupList",
  componentId: "sc-1sh80ol-1"
})(["border-bottom:1px solid #e2e2e2;padding-bottom:12px;margin-bottom:12px;display:flex;flex-direction:column;gap:8px;li{}"]);
var AmountBreakup_style_SubBreakupList = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AmountBreakupstyle__SubBreakupList",
  componentId: "sc-1sh80ol-2"
})(["position:relative;padding-left:10px;display:flex;justify-content:space-between;margin-top:4px;::before{content:\"\";position:absolute;width:4px;height:4px;border-radius:100%;background-color:#757575;left:0;top:10px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AmountBreakup/AmountBreakup.tsx







var AmountBreakup = function AmountBreakup(_ref) {
  var _data$amountBrkup;

  var amtBreakupTitle = _ref.amtBreakupTitle,
      data = _ref.data,
      handleClose = _ref.handleClose;
  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    customTitle: amtBreakupTitle,
    handleClick: handleClose,
    children: [/*#__PURE__*/_jsx(BreakupList, {
      children: data && ((_data$amountBrkup = data.amountBrkup) === null || _data$amountBrkup === void 0 ? void 0 : _data$amountBrkup.map(function (item, index) {
        return /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(SpanTag, {
              fontSize: index == 0 ? "md" : "sm",
              color: theme.blackText,
              children: item.label
            }), /*#__PURE__*/_jsx(SpanTag, {
              fontSize: index == 0 ? "md" : "sm",
              color: theme.blackText,
              children: item.amnt
            })]
          }), item.addBrkup && item.addBrkup.map(function (item2, index2) {
            return /*#__PURE__*/_jsxs(SubBreakupList, {
              children: [/*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                color: theme.greyText,
                children: item2.subLabel
              }), /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                color: theme.greyText,
                children: item2.amnt
              })]
            }, item2.id);
          })]
        }, item.id);
      }))
    }), /*#__PURE__*/_jsxs(FlexComp, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          fontWeight: "bold",
          color: theme.blackText,
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "sm",
          color: theme.greyText,
          children: data === null || data === void 0 ? void 0 : data.info
        })]
      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "md",
        fontWeight: "bold",
        color: theme.blackText,
        children: data === null || data === void 0 ? void 0 : data.totalAmt
      })]
    })]
  });
};

/* harmony default export */ var AmountBreakup_AmountBreakup = ((/* unused pure expression or super */ null && (AmountBreakup)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToolTipComp/ToolTipComp.tsx




var ToolTipComp_ToolTipComp = function ToolTipComp(_ref) {
  var message = _ref.message,
      top = _ref.top,
      left = _ref.left,
      right = _ref.right,
      bottom = _ref.bottom,
      width = _ref.width,
      toolTipArrow = _ref.toolTipArrow,
      children = _ref.children,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave;
  return /*#__PURE__*/_jsx(ToolTipCompWrapper, {
    width: width,
    top: top,
    left: left,
    right: right,
    bottom: bottom,
    toolTipArrow: toolTipArrow,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: children
  });
};

/* harmony default export */ var components_ToolTipComp_ToolTipComp = ((/* unused pure expression or super */ null && (ToolTipComp_ToolTipComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingPageComponents/TopShowcase.tsx


function TopShowcase_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TopShowcase_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TopShowcase_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TopShowcase_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var TopShowcase = function TopShowcase(_ref) {
  var sectionBgImgURI = _ref.sectionBgImgURI,
      otherProductsText = _ref.otherProductsText,
      iconTextTag = _ref.iconTextTag,
      deliveryPersuasion = _ref.deliveryPersuasion,
      landingTitle = _ref.landingTitle,
      marqueeData = _ref.marqueeData,
      otherShowcaseCardsData = _ref.otherShowcaseCardsData,
      pinnedShowcaseCardData = _ref.pinnedShowcaseCardData,
      _ref$isMarqueeOnBotto = _ref.isMarqueeOnBottom,
      isMarqueeOnBottom = _ref$isMarqueeOnBotto === void 0 ? false : _ref$isMarqueeOnBotto,
      mobileStickyHeadingData = _ref.mobileStickyHeadingData,
      mobileTitle = _ref.mobileTitle,
      isDeliveryPersuasionInsideSctn = _ref.isDeliveryPersuasionInsideSctn;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(ListingTopContainer, {
    bgImage: sectionBgImgURI,
    children: device === "lg" ?
    /*#__PURE__*/
    // ONLY IN DESKTOP
    _jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(BMFListingContainer, {
        children: /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "column",
          padding: "24px",
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            gap: "6px",
            padding: "0px",
            alignItems: "center",
            justifyContent: "center",
            margin: "0px 0px 24px 0px",
            children: [(landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textOne) && /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "xxlarge",
              children: landingTitle.textOne
            }), (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textTwo) && (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textThree) && (landingTitle === null || landingTitle === void 0 ? void 0 : landingTitle.textFour) && /*#__PURE__*/_jsxs(ParaTag, {
              margin: "4px 0px 0px",
              color: theme.greyText,
              fontSize: "large",
              children: [landingTitle.textTwo, " ", /*#__PURE__*/_jsx(SpanTag, {
                color: theme.greenText,
                fontSize: "large",
                fontWeight: "bold",
                children: landingTitle.textThree
              }), " ", landingTitle.textFour, " "]
            })]
          }), otherShowcaseCardsData && /*#__PURE__*/_jsx(LandingCardFeatureCtr, {
            children: otherShowcaseCardsData.data.map(function (item, index) {
              return /*#__PURE__*/_jsx(LandingCardFeature, {
                data: item,
                idx: index,
                padding: "16px",
                border: "1px #e2e2e2 solid",
                onClick: otherShowcaseCardsData.onClick,
                loadCurrenyBtnHandler: otherShowcaseCardsData.loadCurrenyBtnHandler,
                recommendedBtnHandler: otherShowcaseCardsData.recommendedBtnHandler,
                startFromWhereLeftHandler: otherShowcaseCardsData.startFromWhereLeftHandler,
                docsPendingHandler: otherShowcaseCardsData.docsPendingHandler
              }, index);
            })
          }), iconTextTag && /*#__PURE__*/_jsx(IconTextTag, {
            margin: "8px 0px 0px",
            label: iconTextTag.label,
            subLabel: iconTextTag.subLabel,
            onClick: iconTextTag.btnHandler
          })]
        })
      }), marqueeData && !isMarqueeOnBottom && /*#__PURE__*/_jsx(MarqueeBanner, {
        margin: "24px 0px 0px",
        marqueeData: marqueeData.data,
        leftTagText: marqueeData.leftTitle
      })]
    }) :
    /*#__PURE__*/
    // ONLY IN MOBILE VIEW
    _jsxs(Fragment, {
      children: [mobileStickyHeadingData && /*#__PURE__*/_jsx(ListingPageHeader, TopShowcase_objectSpread({}, mobileStickyHeadingData)), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        padding: "16px",
        children: [mobileTitle && /*#__PURE__*/_jsx(CliptextStyle, {
          children: /*#__PURE__*/_jsx(H4Tag, {
            children: mobileTitle
          })
        }), deliveryPersuasion && !isDeliveryPersuasionInsideSctn && /*#__PURE__*/_jsx(DeliveryPersuasion, TopShowcase_objectSpread({
          fontSize: "sm",
          padding: "0px",
          bgColor: "",
          margin: "16px 0px 12px 0px"
        }, deliveryPersuasion))]
      }), marqueeData && !isMarqueeOnBottom && /*#__PURE__*/_jsx(MarqueeBanner, {
        leftTagText: marqueeData.leftTitle,
        margin: device === "lg" ? "0px 0px 16px" : "0px 0px 16px",
        marqueeData: marqueeData.data
      }), /*#__PURE__*/_jsxs(MarkerContainer, {
        children: [pinnedShowcaseCardData && pinnedShowcaseCardData.data.map(function (item) {
          return /*#__PURE__*/_jsx(SpecialAttention, {
            children: /*#__PURE__*/_jsx(FlexComp, {
              padding: "24px",
              children: /*#__PURE__*/_jsx(LandingCardFeature, {
                data: item,
                onClick: pinnedShowcaseCardData.onClick,
                loadCurrenyBtnHandler: pinnedShowcaseCardData.loadCurrenyBtnHandler,
                recommendedBtnHandler: pinnedShowcaseCardData.recommendedBtnHandler,
                startFromWhereLeftHandler: pinnedShowcaseCardData.startFromWhereLeftHandler,
                docsPendingHandler: pinnedShowcaseCardData.docsPendingHandler
              })
            })
          }, item.id);
        }), /*#__PURE__*/_jsxs(SpecialAttention, {
          withShadow: true,
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            flexDirection: "column",
            padding: "24px",
            children: [otherProductsText && /*#__PURE__*/_jsx(ParaTag, {
              fontSize: "large",
              fontWeight: "bold",
              children: otherProductsText
            }), deliveryPersuasion && /*#__PURE__*/_jsx(DeliveryPersuasion, TopShowcase_objectSpread({
              fontSize: "sm",
              padding: "0px",
              bgColor: "",
              margin: "6px 0px 16px 0px"
            }, deliveryPersuasion)), otherShowcaseCardsData && otherShowcaseCardsData.data.map(function (item, idx) {
              return /*#__PURE__*/_jsx(LandingCardFeature, {
                data: item,
                border: idx + 1 < otherShowcaseCardsData.data.length ? "1px #e2e2e2 solid" : "",
                padding: idx + 1 < otherShowcaseCardsData.data.length ? "0px 0px 16px 0px" : "0px",
                margin: idx + 1 < otherShowcaseCardsData.data.length ? "0px 0px 16px 0px" : "0px",
                borderWidth: idx + 1 < otherShowcaseCardsData.data.length ? "0px 0px 1px 0px" : "0px",
                onClick: otherShowcaseCardsData.onClick,
                loadCurrenyBtnHandler: otherShowcaseCardsData.loadCurrenyBtnHandler,
                recommendedBtnHandler: otherShowcaseCardsData.recommendedBtnHandler,
                startFromWhereLeftHandler: otherShowcaseCardsData.startFromWhereLeftHandler,
                docsPendingHandler: otherShowcaseCardsData.docsPendingHandler
              });
            })]
          }), iconTextTag && /*#__PURE__*/_jsx(IconTextTag, {
            label: iconTextTag.label,
            subLabel: iconTextTag.subLabel,
            onClick: iconTextTag.btnHandler
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var ListingPageComponents_TopShowcase = ((/* unused pure expression or super */ null && (TopShowcase)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/InterBanking/InterBanking.tsx







var InterBanking = function InterBanking(_ref) {
  var onModalClose = _ref.onModalClose,
      _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? /*#__PURE__*/_jsx(CloseIcon, {}) : _ref$closeButton,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? /*#__PURE__*/_jsx(_Fragment, {}) : _ref$children,
      modalHeading = _ref.modalHeading;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    modalHeading: modalHeading,
    onModalClose: onModalClose,
    closeButton: closeButton,
    modalHeadingCtrMargin: device === "lg" ? "0px 0px 8px 0px" : "0px 0px 14px 0px",
    modalWidth: 610,
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: children
  });
};

/* harmony default export */ var InterBanking_InterBanking = ((/* unused pure expression or super */ null && (InterBanking)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/CurrenciesList/Currencies.style.ts


var Currencies_style_CurrenciesListStyle = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "Currenciesstyle__CurrenciesListStyle",
  componentId: "sc-12tdbe0-0"
})(["height:60vh;overflow-y:scroll;@media ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile);
var Currencies_style_ListItem = styled_components_browser_esm["default"].li.withConfig({
  displayName: "Currenciesstyle__ListItem",
  componentId: "sc-12tdbe0-1"
})(["display:flex;align-items:center;padding:16px 0px;border-bottom:1px solid #e8e8e8;"]);
var Currencies_style_LabelWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Currenciesstyle__LabelWpr",
  componentId: "sc-12tdbe0-2"
})(["flex:1;display:flex;align-items:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/CurrenciesList/CurrenciesList.tsx








var CurrenciesList = function CurrenciesList(_ref) {
  var listItems = _ref.listItems,
      modalHeading = _ref.modalHeading,
      onModalClose = _ref.onModalClose,
      _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? /*#__PURE__*/_jsx(CloseIcon, {}) : _ref$closeButton;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    modalHeading: modalHeading,
    onModalClose: onModalClose,
    closeButton: closeButton,
    modalWidth: 420,
    modalHeadingCtrMargin: device === "lg" ? "0px 0px 8px 0px" : "0px 0px 14px 0px",
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: /*#__PURE__*/_jsx(CurrenciesListStyle, {
      children: listItems === null || listItems === void 0 ? void 0 : listItems.map(function (item, idx) {
        return /*#__PURE__*/_jsxs(ListItem, {
          children: [/*#__PURE__*/_jsxs(LabelWpr, {
            children: [item.imgSrc && /*#__PURE__*/_jsx(ImageTag, {
              margin: "0px 8px 0px 0px",
              src: item.imgSrc
            }), /*#__PURE__*/_jsx(SpanTag, {
              fontWeight: idx === 0 ? "bold" : "regular",
              children: item.label
            })]
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontWeight: idx === 0 ? "bold" : "regular",
            margin: "0px 0px 0px 8px",
            children: item.subLabel
          })]
        }, item.id);
      })
    })
  });
};

/* harmony default export */ var CurrenciesList_CurrenciesList = ((/* unused pure expression or super */ null && (CurrenciesList)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ForexCardComp/ForexComp.style.ts


var ForexComp_style_CardImgStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexCompstyle__CardImgStyle",
  componentId: "sc-64c4ie-0"
})(["display:flex;justify-content:center;margin-top:-83px;@media ", "{margin-top:-95px;}"], utils/* deviceType.mobile */.vO.mobile); //Dweb

var ForexComp_style_ForexCardCompDwebStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexCompstyle__ForexCardCompDwebStyle",
  componentId: "sc-64c4ie-1"
})(["background:#fff;border-radius:12px;width:405px;position:relative;padding:24px;display:flex;flex-direction:column;margin-left:auto;margin-top:83px;"]);
var ForexComp_style_BottomContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexCompstyle__BottomContainer",
  componentId: "sc-64c4ie-2"
})(["border-radius:8px;background:#fff;margin-top:-6px;position:relative;padding-top:6px;> p{font-weight:400;font-size:14px;line-height:19px;text-align:center;padding:4px 16px;> span{font-weight:700;}}"]); //Dweb
//Mweb

var ForexComp_style_AnimationWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexCompstyle__AnimationWpr",
  componentId: "sc-64c4ie-3"
})(["@keyframes zeroOpacity{0%{opacity:0;}100%{opacity:0;}}@keyframes downUp{0%{transform:translateY(100vh);}100%{transform:translateY(0vh);}}position:relative;z-index:10;animation:zeroOpacity 2s,downUp 3s 2s;"]);
var ForexComp_style_ForexCardCompMwebStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ForexCompstyle__ForexCardCompMwebStyle",
  componentId: "sc-64c4ie-4"
})(["display:flex;flex-direction:column;align-items:center;padding:0px 16px;margin-top:14px;background:#fff;"]);
var ForexComp_style_Label = styled_components_browser_esm["default"].p.withConfig({
  displayName: "ForexCompstyle__Label",
  componentId: "sc-64c4ie-5"
})(["background-color:#eaf5ff;text-align:center;width:100%;border-radius:4px;margin-top:8px;font-weight:400;font-size:14px;line-height:19px;padding:4px 16px;> span{font-weight:700;}"]); //Mweb
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/bmf_card_img.png
/* harmony default export */ var bmf_card_img = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/bmf_card_img.890149a9.png","height":253,"width":406,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAsElEQVR4nAGlAFr/AXp5id4SFxshKCgg/yAeGgEQDwsAmJiT/7rA1AEjIyfoAUZMZ+JYRCUd+g0d/+He2QHt7OgAmpmW/2RoeAH09PXrASAhReBvTg8fstDt/b/BvwEAACYADBsdACEaDAIBAADpAR8VJekTKigWBvzyAN/h6wDw9fgALCQZAFVUUADg4OHzASARF7QqNi8i8vf6+cTDxwEGCwoAFBEPAE9NSwTu7u7nC19BtBm/nOsAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ForexCardComp/ForexCardCompDweb.tsx







var ForexCardCompDweb = function ForexCardCompDweb(_ref) {
  var label = _ref.label,
      btn = _ref.btn,
      imgSrc = _ref.imgSrc;
  return /*#__PURE__*/_jsxs(ForexCardCompDwebStyle, {
    children: [/*#__PURE__*/_jsx(CardImgStyle, {
      children: /*#__PURE__*/_jsx(ImageTag, {
        src: imgSrc ? imgSrc : BMFCardImg.src,
        width: "328px"
      })
    }), /*#__PURE__*/_jsxs(BottomContainer, {
      children: [label && /*#__PURE__*/_jsx("p", {
        dangerouslySetInnerHTML: {
          __html: label
        }
      }), /*#__PURE__*/_jsx(LandingButton, {
        customTitle: btn === null || btn === void 0 ? void 0 : btn.label,
        margin: "16px 0 0 0",
        customWidth: "100%",
        disableState: btn === null || btn === void 0 ? void 0 : btn.disabled,
        onClick: btn === null || btn === void 0 ? void 0 : btn.onClick
      })]
    })]
  });
};

/* harmony default export */ var ForexCardComp_ForexCardCompDweb = ((/* unused pure expression or super */ null && (ForexCardCompDweb)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ForexCardComp/ForexCardCompMweb.tsx







var ForexCardCompMweb = function ForexCardCompMweb(_ref) {
  var label = _ref.label,
      imgSrc = _ref.imgSrc;
  // const [visible, setVisible] = useState(1);
  // useEffect(() => {
  //     const timer = setTimeout(() => {
  //         setVisible(1);
  //     },2000);
  //     return () => {
  //         clearTimeout(timer);
  //     }
  // },[]);
  return /*#__PURE__*/_jsx(ForexCardCompMwebStyle, {
    children: /*#__PURE__*/_jsxs(AnimationWpr, {
      children: [/*#__PURE__*/_jsx(CardImgStyle, {
        children: /*#__PURE__*/_jsx(ImageTag, {
          src: imgSrc ? imgSrc : BMFCardImg.src,
          width: "100%"
        })
      }), label && /*#__PURE__*/_jsx(Label, {
        dangerouslySetInnerHTML: {
          __html: label
        }
      })]
    })
  });
};

/* harmony default export */ var ForexCardComp_ForexCardCompMweb = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(ForexCardCompMweb))));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PoweredBy/PoweredBy.style.ts

var PoweredBy_style_PoweredByStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PoweredBystyle__PoweredByStyle",
  componentId: "sc-13vk2aw-0"
})(["display:flex;flex-direction:row;align-items:center;margin-top:18px;margin:", ";"], function (props) {
  return props.margin;
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PoweredBy/PoweredBy.tsx






var PoweredBy = function PoweredBy(_ref) {
  var label = _ref.label,
      imgSrc = _ref.imgSrc,
      margin = _ref.margin,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "large" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$imgWidth = _ref.imgWidth,
      imgWidth = _ref$imgWidth === void 0 ? "61px" : _ref$imgWidth;
  return /*#__PURE__*/_jsxs(PoweredByStyle, {
    margin: margin,
    children: [label && /*#__PURE__*/_jsx(SpanTag, {
      fontWeight: fontWeight,
      fontSize: fontSize,
      color: "#fff",
      children: label
    }), imgSrc && /*#__PURE__*/_jsx(ImageTag, {
      src: imgSrc,
      width: imgWidth,
      margin: "0px 0px 0px 4px"
    })]
  });
};

/* harmony default export */ var PoweredBy_PoweredBy = ((/* unused pure expression or super */ null && (PoweredBy)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PersuasionCrawler/PersuasionCrawler.style.ts



var PersuasionCrawler_style_PersuasionCrawlerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PersuasionCrawlerstyle__PersuasionCrawlerStyle",
  componentId: "sc-1qznh05-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:40px 80px;background:#f6f6f6;border-radius:16px;@media ", "{border-radius:unset;padding:25px;&{overflow-x:scroll;scrollbar-width:none;-ms-overflow-style:none;}&::-webkit-scrollbar{width:0;height:0;}pointer-events:none;}"], utils/* deviceType.mobile */.vO.mobile);
var PersuasionCrawler_style_PersuasionItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PersuasionCrawlerstyle__PersuasionItem",
  componentId: "sc-1qznh05-1"
})(["&:not(:last-child){margin-right:20px;}"]);
var PersuasionCrawler_style_Label = (0,styled_components_browser_esm["default"])(ParaTagStyle).withConfig({
  displayName: "PersuasionCrawlerstyle__Label",
  componentId: "sc-1qznh05-2"
})(["width:max-content;font-family:\"Lato\";font-weight:500;font-size:32px;line-height:38px;@media ", "{font-size:24px;line-height:28px;}"], utils/* deviceType.mobile */.vO.mobile);
var PersuasionCrawler_style_SubLabel = (0,styled_components_browser_esm["default"])(ParaTagStyle).withConfig({
  displayName: "PersuasionCrawlerstyle__SubLabel",
  componentId: "sc-1qznh05-3"
})(["width:max-content;margin-top:4px;font-weight:400;font-size:16px;line-height:22px;@media ", "{font-size:12px;line-height:16px;margin-top:0px;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PersuasionCrawler/PersuasionCrawler.tsx





var PersuasionCrawler = function PersuasionCrawler(_ref) {
  var data = _ref.data;
  var scrollRef = useRef();
  var interval = useRef();
  var timeout = useRef();
  useEffect(function () {
    // prettier-ignore
    //@ts-ignore
    timeout.current = setTimeout(function () {
      //@ts-ignore
      interval.current = setInterval(function () {
        var _scrollRef$current, _scrollRef$current2, _scrollRef$current3, _scrollRef$current4;

        //@ts-ignore
        (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollBy({
          left: window.innerWidth,
          behavior: "smooth"
        }); //@ts-ignore

        if (((_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.scrollLeft) >= ((_scrollRef$current3 = scrollRef.current) === null || _scrollRef$current3 === void 0 ? void 0 : _scrollRef$current3.scrollWidth) - ((_scrollRef$current4 = scrollRef.current) === null || _scrollRef$current4 === void 0 ? void 0 : _scrollRef$current4.clientWidth) - 20) {
          var _scrollRef$current5;

          //@ts-ignore
          (_scrollRef$current5 = scrollRef.current) === null || _scrollRef$current5 === void 0 ? void 0 : _scrollRef$current5.scrollTo({
            left: 0,
            behavior: "smooth"
          });
        }
      }, 3000);
    }, 5000);
    return function () {
      clearInterval(interval.current);
      clearTimeout(timeout.current);
    };
  }, []);
  return /*#__PURE__*/_jsx(PersuasionCrawlerStyle, {
    ref: scrollRef,
    children: data.map(function (item) {
      return /*#__PURE__*/_jsxs(PersuasionItem, {
        children: [/*#__PURE__*/_jsx(Label, {
          children: item.label
        }), item.subLabel && /*#__PURE__*/_jsx(SubLabel, {
          children: item.subLabel
        })]
      }, item.id);
    })
  });
};

/* harmony default export */ var PersuasionCrawler_PersuasionCrawler = ((/* unused pure expression or super */ null && (PersuasionCrawler)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FeaturesListComp/FeaturesListComp.style.ts




var FeaturesListComp_style_FeaturesListCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturesListCompstyle__FeaturesListCompStyle",
  componentId: "sc-1ixqluv-0"
})(["display:flex;margin:", ";@media ", "{flex-direction:column-reverse;padding:32px 16px 56px 16px;}"], function (props) {
  return props.margin ? props.margin : "0px";
}, utils/* deviceType.mobile */.vO.mobile);
var FeaturesListComp_style_FeaturesList = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturesListCompstyle__FeaturesList",
  componentId: "sc-1ixqluv-1"
})(["flex:0.9;padding-top:50px;@media ", "{padding-top:unset;}"], utils/* deviceType.mobile */.vO.mobile);
var FeaturesListComp_style_Ul = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "FeaturesListCompstyle__Ul",
  componentId: "sc-1ixqluv-2"
})(["margin-top:40px;@media ", "{margin-top:32px;}"], utils/* deviceType.mobile */.vO.mobile);
var FeaturesListComp_style_Li = styled_components_browser_esm["default"].li.withConfig({
  displayName: "FeaturesListCompstyle__Li",
  componentId: "sc-1ixqluv-3"
})(["display:flex;&:not(:last-child){margin-bottom:16px;}"]);
var FeaturesListComp_style_YellowBox = styled_components_browser_esm["default"].span.withConfig({
  displayName: "FeaturesListCompstyle__YellowBox",
  componentId: "sc-1ixqluv-4"
})(["width:5px;height:14px;background:linear-gradient(45deg,#edd287 14.64%,#b8860b 85.36%);margin-right:12px;margin-top:5px;border-radius:3px;flex-shrink:0;"]);
var FeaturesListComp_style_ListLabel = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "FeaturesListCompstyle__ListLabel",
  componentId: "sc-1ixqluv-5"
})(["font-size:18px;line-height:24px;font-weight:400;flex:1;> span{font-weight:700;}@media ", "{font-size:", ";line-height:", ";}"], utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.small === true ? "14px" : "18px";
}, function (props) {
  return props.small === true ? "19px" : "24px";
});
var FeaturesListComp_style_FeatureCardsWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturesListCompstyle__FeatureCardsWpr",
  componentId: "sc-1ixqluv-6"
})(["flex:1;display:flex;align-items:center;position:relative;height:440px;margin-left:16px;@media ", "{height:unset;flex-direction:column;align-items:unset;margin-left:unset;}"], utils/* deviceType.mobile */.vO.mobile);
var FeaturesListComp_style_Image = (0,styled_components_browser_esm["default"])(ImageTag_style_ImageTagStyle).withConfig({
  displayName: "FeaturesListCompstyle__Image",
  componentId: "sc-1ixqluv-7"
})(["position:absolute;content:\"\";width:100%;height:100%;top:0px;right:-60px;object-fit:contain;@media only screen and (max-width:1260px){right:0px;}"]);
var FeaturesListComp_style_FeatureCards = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturesListCompstyle__FeatureCards",
  componentId: "sc-1ixqluv-8"
})(["display:flex;flex-wrap:wrap;gap:16px;position:relative;@media ", "{flex-wrap:unset;flex-direction:column;gap:unset;row-gap:16px;flex:1;margin-top:32px;}"], utils/* deviceType.mobile */.vO.mobile);
var FeaturesListComp_style_FeatureCard = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturesListCompstyle__FeatureCard",
  componentId: "sc-1ixqluv-9"
})(["background:#ffffff;border:1px solid #ececec;box-shadow:0px 3px 12px rgba(0,0,0,0.2);border-radius:10px;display:flex;align-items:center;padding:16px;width:calc(50% - 8px);@media ", "{width:unset;}"], utils/* deviceType.mobile */.vO.mobile);
var FeaturesListComp_style_InfoIconWpr = styled_components_browser_esm["default"].span.withConfig({
  displayName: "FeaturesListCompstyle__InfoIconWpr",
  componentId: "sc-1ixqluv-10"
})(["margin-left:8px;display:inline-block;margin-bottom:-4px;@media ", "{margin-left:4px;margin-bottom:-2px;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/flash_bg_img2.png
/* harmony default export */ var flash_bg_img2 = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/flash_bg_img2.dec1a622.png","height":960,"width":1304,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAh0lEQVR42mNABt9+/GJ++/kHG4j96O3X8gdvvuwFS/z584fx9+/fzDCFrz59d3j2/ttboKJUBqAE08dvPxlBEl9//Er+9O1nCdCUi68/fZdFNh2kcNaPn7+ufP7+8zgQy4NN+vidFWQ8M1ByKxBvRtYANIUZpvMoEG+ASXz5/pPp/dcfTDA+AIFvWnDsscC8AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FeaturesListComp/FeaturesListComp.tsx










var FeaturesListComp = function FeaturesListComp(_ref) {
  var data = _ref.data,
      margin = _ref.margin,
      _ref$handleInfoClick = _ref.handleInfoClick,
      handleInfoClick = _ref$handleInfoClick === void 0 ? function (id) {} : _ref$handleInfoClick;
  var featuresList = data.featuresList,
      featureCards = data.featureCards;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(FeaturesListCompStyle, {
    margin: margin,
    children: [featuresList && /*#__PURE__*/_jsxs(FeaturesList, {
      children: [device === "lg" && featuresList.label && /*#__PURE__*/_jsx(H2Tag, {
        children: featuresList.label
      }), featuresList.listItems && /*#__PURE__*/_jsx(Ul, {
        children: featuresList.listItems.map(function (item, idx) {
          return /*#__PURE__*/_jsxs(Li, {
            children: [/*#__PURE__*/_jsx(YellowBox, {}), /*#__PURE__*/_jsx(ListLabel, {
              small: true,
              dangerouslySetInnerHTML: {
                __html: item
              }
            })]
          }, "".concat(idx));
        })
      })]
    }), featureCards && /*#__PURE__*/_jsxs(FeatureCardsWpr, {
      children: [device === "lg" && /*#__PURE__*/_jsx(Image, {
        src: BMFFlashImg.src
      }), device !== "lg" && (featuresList === null || featuresList === void 0 ? void 0 : featuresList.label) && /*#__PURE__*/_jsx(H5Tag, {
        children: featuresList.label
      }), /*#__PURE__*/_jsx(FeatureCards, {
        children: featureCards.map(function (item) {
          return /*#__PURE__*/_jsxs(FeatureCard, {
            children: [item.imgSrc && /*#__PURE__*/_jsx(ImageTag, {
              margin: "0px 8px 0px 0px",
              src: item.imgSrc
            }), /*#__PURE__*/_jsx(ListLabel, {
              dangerouslySetInnerHTML: {
                __html: item.label
              }
            }), item.showIcon && /*#__PURE__*/_jsx(InfoIconWpr, {
              onClick: function onClick() {
                return handleInfoClick(item.id);
              },
              children: item.icon ? /*#__PURE__*/_jsx(ImageTag, {
                src: item.icon,
                showCursorPointer: true
              }) : /*#__PURE__*/_jsx(InfoIcon, {
                height: device === "lg" ? 20 : 12,
                width: device === "lg" ? 20 : 12,
                color: theme.blueText
              })
            })]
          }, item.id);
        })
      })]
    })]
  });
};

/* harmony default export */ var FeaturesListComp_FeaturesListComp = ((/* unused pure expression or super */ null && (FeaturesListComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FeaturesDemoList/FeaturesDemoList.style.ts



var FeaturesDemoList_style_FeaturesDemoListStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturesDemoListstyle__FeaturesDemoListStyle",
  componentId: "sc-1d00jlu-0"
})(["margin:", ";padding:40px 0px 0px 0px;margin-bottom:110px;@media ", "{padding:48px 0px 0px 0px;margin-bottom:56px;}"], function (props) {
  return props.margin;
}, utils/* deviceType.mobile */.vO.mobile);
var FeaturesDemoList_style_Label = (0,styled_components_browser_esm["default"])(TextStyles_style_H2TagStyle).withConfig({
  displayName: "FeaturesDemoListstyle__Label",
  componentId: "sc-1d00jlu-1"
})(["@media ", "{font-size:24px;line-height:28px;padding:0px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
var FeaturesDemoList_style_CardsWpr = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "FeaturesDemoListstyle__CardsWpr",
  componentId: "sc-1d00jlu-2"
})(["display:flex;margin-top:56px;justify-content:space-between;@media ", "{padding:0px 16px;margin-top:40px;&{overflow-x:scroll;scrollbar-width:none;-ms-overflow-style:none;}&::-webkit-scrollbar{width:0;height:0;}}"], utils/* deviceType.mobile */.vO.mobile);
var FeaturesDemoList_style_Card = styled_components_browser_esm["default"].li.withConfig({
  displayName: "FeaturesDemoListstyle__Card",
  componentId: "sc-1d00jlu-3"
})(["width:300px;flex-shrink:0;"]);
var FeaturesDemoList_style_CardLabel = (0,styled_components_browser_esm["default"])(ParaTagStyle).withConfig({
  displayName: "FeaturesDemoListstyle__CardLabel",
  componentId: "sc-1d00jlu-4"
})(["margin-top:17px;font-size:14px;line-height:19px;font-weight:400;> span{font-weight:700;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FeaturesDemoList/FeaturesDemoList.tsx






var FeaturesDemoList = function FeaturesDemoList(_ref) {
  var data = _ref.data,
      margin = _ref.margin;
  var label = data.label,
      demoList = data.demoList;
  return /*#__PURE__*/_jsxs(FeaturesDemoListStyle, {
    margin: margin,
    children: [label && /*#__PURE__*/_jsx(Label, {
      children: label
    }), demoList && /*#__PURE__*/_jsx(CardsWpr, {
      children: demoList.map(function (item) {
        return /*#__PURE__*/_jsxs(Card, {
          children: [/*#__PURE__*/_jsx(ImageTag, {
            src: item.imgSrc
          }), item.label && /*#__PURE__*/_jsx(CardLabel, {
            dangerouslySetInnerHTML: {
              __html: item.label
            }
          })]
        }, item.id);
      })
    })]
  });
};

/* harmony default export */ var FeaturesDemoList_FeaturesDemoList = ((/* unused pure expression or super */ null && (FeaturesDemoList)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ConversionRates/ConversionRates.style.ts




var ConversionRates_style_ConversionRatesStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__ConversionRatesStyle",
  componentId: "sc-7xe3lr-0"
})(["flex:1;margin-left:100px;background:#fff;padding:24px;border-radius:12px;@media ", "{flex:unset;margin:32px 16px 0px 16px;padding:24px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
var ConversionRates_style_HeadingWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__HeadingWpr",
  componentId: "sc-7xe3lr-1"
})(["max-width:200px;"]);
var ConversionRates_style_TimerLabel = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "ConversionRatesstyle__TimerLabel",
  componentId: "sc-7xe3lr-2"
})(["font-weight:700;color:#fff;background:", ";border-radius:16px;width:max-content;font-size:12px;line-height:16px;display:inline-block;flex-shrink:0;padding:2px 8px;margin-left:", ";@media ", "{margin-left:unset;margin-top:", ";}"], function (props) {
  return props.bg ? props.bg : "linear-gradient(90deg, #03BAE1 0%, #3A7BD5 100%)";
}, function (props) {
  return props.marginLeft ? props.marginLeft : "auto";
}, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.marginTop ? props.marginTop : "8px";
});
var ConversionRates_style_UpComingBannerBorder = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__UpComingBannerBorder",
  componentId: "sc-7xe3lr-3"
})(["padding:1px;background:linear-gradient(225deg,#3023ae 14.64%,#c86dd7 85.36%);border-radius:8px;overflow:hidden;margin-top:16px;"]);
var ConversionRates_style_UpComingTrip = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__UpComingTrip",
  componentId: "sc-7xe3lr-4"
})(["display:flex;flex-direction:column;position:relative;padding:26px 12px 16px 12px;background-color:#fff;border-radius:7px;"]);
var ConversionRates_style_UpComingBanner = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "ConversionRatesstyle__UpComingBanner",
  componentId: "sc-7xe3lr-5"
})(["position:absolute;top:0px;left:0px;font-weight:600;font-size:10px;line-height:14px;color:#fff;background:linear-gradient(225deg,#3023ae 14.64%,#c86dd7 85.36%);border-radius:0px 0px 8px 0px;padding:2px 8px;"]);
var ConversionRates_style_InputFieldsWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__InputFieldsWpr",
  componentId: "sc-7xe3lr-6"
})(["display:flex;margin-top:16px;"]);
var ConversionRates_style_ConvertedValLabel = (0,styled_components_browser_esm["default"])(ParaTagStyle).withConfig({
  displayName: "ConversionRatesstyle__ConvertedValLabel",
  componentId: "sc-7xe3lr-7"
})(["margin-top:8px;> span{font-weight:700;}"]);
var ConversionRates_style_SavedAmountBanner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__SavedAmountBanner",
  componentId: "sc-7xe3lr-8"
})(["display:flex;align-items:center;background:", ";padding:8px 16px;border-radius:4px;margin-top:16px;"], Global/* theme.greenText2 */.rS.greenText2);
var ConversionRates_style_SavedAmountLabelsWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__SavedAmountLabelsWpr",
  componentId: "sc-7xe3lr-9"
})(["display:flex;flex-direction:column;flex:1;"]);
var ConversionRates_style_SavedAmountLabel = (0,styled_components_browser_esm["default"])(ParaTagStyle).withConfig({
  displayName: "ConversionRatesstyle__SavedAmountLabel",
  componentId: "sc-7xe3lr-10"
})(["color:", ";> span{font-weight:700;}"], Global/* theme.darkGreen */.rS.darkGreen);
var ConversionRates_style_LinkLabel = (0,styled_components_browser_esm["default"])(TextStyles_style_AnchorTagStyle).withConfig({
  displayName: "ConversionRatesstyle__LinkLabel",
  componentId: "sc-7xe3lr-11"
})(["flex-shrink:0;margin-left:8px;font-size:14px;line-height:19px;font-weight:700;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ConversionRates/ConversionRates.tsx








var ConversionRates = function ConversionRates(_ref) {
  var data = _ref.data,
      _ref$dropDownClick = _ref.dropDownClick,
      dropDownClick = _ref$dropDownClick === void 0 ? function () {} : _ref$dropDownClick,
      converterInputs = _ref.converterInputs,
      _ref$savedAmountBtnCl = _ref.savedAmountBtnClick,
      savedAmountBtnClick = _ref$savedAmountBtnCl === void 0 ? function () {} : _ref$savedAmountBtnCl;
  var label = data.label,
      timerTxt = data.timerTxt,
      upComingTrip = data.upComingTrip,
      dropDownData = data.dropDownData,
      savedAmountBanner = data.savedAmountBanner;
  var input1 = converterInputs.input1,
      input2 = converterInputs.input2,
      convertedValTxt = converterInputs.convertedValTxt;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(ConversionRatesStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "flex-start",
      flexDirection: device === "lg" ? "row" : "column",
      children: [label && /*#__PURE__*/_jsx(HeadingWpr, {
        children: /*#__PURE__*/_jsx(H5Tag, {
          children: label
        })
      }), timerTxt && /*#__PURE__*/_jsx(TimerLabel, {
        children: timerTxt
      })]
    }), upComingTrip && /*#__PURE__*/_jsx(UpComingBannerBorder, {
      children: /*#__PURE__*/_jsxs(UpComingTrip, {
        children: [upComingTrip.label && /*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          children: upComingTrip.label
        }), upComingTrip.subLabel && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          margin: "2px 0px 0px 0px",
          children: upComingTrip.subLabel
        }), upComingTrip.bannerTxt && /*#__PURE__*/_jsx(UpComingBanner, {
          children: upComingTrip.bannerTxt
        })]
      })
    }), dropDownData && /*#__PURE__*/_jsx(TMFloatingInput, {
      labelTxt: dropDownData.label,
      handleDropdownPress: dropDownClick,
      fieldType: "select",
      inputValue: dropDownData.subLabel,
      handleChange: function handleChange() {},
      margin: "16px 0px 0px 0px"
    }), converterInputs && /*#__PURE__*/_jsxs(InputFieldsWpr, {
      children: [converterInputs.input1 && /*#__PURE__*/_jsx(TMFloatingInput, {
        labelTxt: input1 === null || input1 === void 0 ? void 0 : input1.labelTxt,
        inputValue: input1 === null || input1 === void 0 ? void 0 : input1.inputValue,
        handleChange: input1 === null || input1 === void 0 ? void 0 : input1.handleChange,
        errorState: input1 === null || input1 === void 0 ? void 0 : input1.errorState,
        verifiedTag: input1 === null || input1 === void 0 ? void 0 : input1.verifiedTag,
        maxLength: input1 === null || input1 === void 0 ? void 0 : input1.maxLength,
        inputWidth: "calc(50% - 4px)"
      }), converterInputs.input2 && /*#__PURE__*/_jsx(TMFloatingInput, {
        labelTxt: input2 === null || input2 === void 0 ? void 0 : input2.labelTxt,
        inputValue: input2 === null || input2 === void 0 ? void 0 : input2.inputValue,
        handleChange: input2 === null || input2 === void 0 ? void 0 : input2.handleChange,
        errorState: input2 === null || input2 === void 0 ? void 0 : input2.errorState,
        verifiedTag: input2 === null || input2 === void 0 ? void 0 : input2.verifiedTag,
        maxLength: input2 === null || input2 === void 0 ? void 0 : input2.maxLength,
        inputWidth: "calc(50% - 4px)",
        margin: "0px 0px 0px 8px"
      })]
    }), (converterInputs === null || converterInputs === void 0 ? void 0 : converterInputs.convertedValTxt) && /*#__PURE__*/_jsx(ConvertedValLabel, {
      dangerouslySetInnerHTML: {
        __html: convertedValTxt
      }
    }), savedAmountBanner && /*#__PURE__*/_jsxs(SavedAmountBanner, {
      children: [(savedAmountBanner.label || savedAmountBanner.subLabel) && /*#__PURE__*/_jsxs(SavedAmountLabelsWpr, {
        children: [savedAmountBanner.label && /*#__PURE__*/_jsx(SavedAmountLabel, {
          dangerouslySetInnerHTML: {
            __html: savedAmountBanner.label
          }
        }), savedAmountBanner.subLabel && /*#__PURE__*/_jsx(ParaTag, {
          color: theme.darkGreen,
          fontSize: "xs",
          children: savedAmountBanner.subLabel
        })]
      }), savedAmountBanner.btnTxt && /*#__PURE__*/_jsx(LinkLabel, {
        onClick: savedAmountBtnClick,
        margin: "0px 0px 0px auto",
        fontWeight: "bold",
        children: savedAmountBanner.btnTxt
      })]
    })]
  });
};

/* harmony default export */ var ConversionRates_ConversionRates = ((/* unused pure expression or super */ null && (ConversionRates)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ConversionRates/ConversionRates.style.ts



var ConversionRates_ConversionRates_style_ConversionRatesStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__ConversionRatesStyle",
  componentId: "di1dix-0"
})(["padding-top:12px;"]);
var ConversionRates_style_BlueBox = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__BlueBox",
  componentId: "di1dix-1"
})(["padding:16px;padding-right:150px;background:linear-gradient( 159.48deg,#edfbff 4.69%,rgba(236,241,255,0.736176) 27.76%,#e7f1f9 92.13% );border:1px solid #ffffff;border-radius:8px;@media ", "{padding-right:100px;}"], utils/* deviceType.mobile */.vO.mobile);
var ConversionRates_style_LabelsWpr = styled_components_browser_esm["default"].p.withConfig({
  displayName: "ConversionRatesstyle__LabelsWpr",
  componentId: "di1dix-2"
})(["display:flex;margin-top:16px;"]);
var ConversionRates_style_ListItems = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ConversionRatesstyle__ListItems",
  componentId: "di1dix-3"
})(["margin-top:10px;"]);
var ConversionRates_style_ListItem = styled_components_browser_esm["default"].li.withConfig({
  displayName: "ConversionRatesstyle__ListItem",
  componentId: "di1dix-4"
})(["display:flex;padding:8px;&:first-child{background:#e4fbf4;border-radius:8px;}&:not(:first-child){border-bottom:1px solid #f2f2f2;}&:last-child{border-bottom:unset;}"]);
var ConversionRates_style_LeftCont = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__LeftCont",
  componentId: "di1dix-5"
})(["flex:1;"]);
var ConversionRates_style_SubLabelWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ConversionRatesstyle__SubLabelWpr",
  componentId: "di1dix-6"
})(["display:flex;align-items:center;margin-top:4px;"]);
var ConversionRates_style_SubLabel = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "ConversionRatesstyle__SubLabel",
  componentId: "di1dix-7"
})(["font-size:12px;font-weight:700;> span{color:#4a4a4a;}"]);
var ConversionRates_style_Banner = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "ConversionRatesstyle__Banner",
  componentId: "di1dix-8"
})(["background:linear-gradient(45deg,#43e1a8 14.64%,#219393 85.36%);border-radius:16px;color:#fff;font-weight:700;font-size:12px;line-height:16px;padding:2px 8px;margin-left:4px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalComponents/ConversionRates/ConversionRates.tsx








var ConversionRates_ConversionRates_ConversionRates = function ConversionRates(_ref) {
  var modalHeading = _ref.modalHeading,
      onModalClose = _ref.onModalClose,
      _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? /*#__PURE__*/_jsx(CloseIcon, {}) : _ref$closeButton,
      data = _ref.data;
  var listLabels = data.listLabels,
      labelsList = data.labelsList,
      listItems = data.listItems;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsx(Modal, {
    modalHeading: modalHeading,
    onModalClose: onModalClose,
    closeButton: closeButton,
    modalWidth: 420,
    modalHeadingCtrMargin: device === "lg" ? "0px 0px 8px 0px" : "0px 0px 14px 0px",
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: /*#__PURE__*/_jsxs(ConversionRatesStyle, {
      children: [labelsList && /*#__PURE__*/_jsx(BlueBox, {
        children: labelsList.map(function (item, idx) {
          return /*#__PURE__*/_jsx(ParaTag, {
            margin: idx < labelsList.length - 1 ? "0px 0px 16px 0px" : "0px",
            fontSize: "xs",
            fontWeight: "bold",
            children: item
          }, "".concat(idx));
        })
      }), listLabels && /*#__PURE__*/_jsxs(LabelsWpr, {
        children: [listLabels.label && /*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          fontSize: "xs",
          color: "#4a4a4a",
          children: listLabels.label
        }), listLabels.subLabel && /*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          fontSize: "xs",
          margin: "0px 0px 0px auto",
          children: listLabels.subLabel
        })]
      }), listItems && /*#__PURE__*/_jsx(ListItems, {
        children: listItems.map(function (item) {
          return /*#__PURE__*/_jsxs(ListItem, {
            children: [/*#__PURE__*/_jsxs(LeftCont, {
              children: [/*#__PURE__*/_jsx(ParaTag, {
                fontWeight: "bold",
                fontSize: "xs",
                children: item.label
              }), /*#__PURE__*/_jsxs(SubLabelWpr, {
                children: [item.subLabel && /*#__PURE__*/_jsx(SubLabel, {
                  dangerouslySetInnerHTML: {
                    __html: item.subLabel
                  }
                }), item.banner && /*#__PURE__*/_jsx(Banner, {
                  children: item.banner
                }), item.icon && /*#__PURE__*/_jsx(ImageTag, {
                  src: item.icon
                })]
              })]
            }), item.price && /*#__PURE__*/_jsx(SpanTag, {
              fontWeight: "bold",
              fontSize: "xs",
              children: item.price
            })]
          });
        })
      })]
    })
  });
};

/* harmony default export */ var ModalComponents_ConversionRates_ConversionRates = ((/* unused pure expression or super */ null && (ConversionRates_ConversionRates_ConversionRates)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExpandableTnCCard/ExpandableTnCCard.style.ts


var ExpandableTnCCard_style_ExpandableTnCCardStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ExpandableTnCCardstyle__ExpandableTnCCardStyle",
  componentId: "sc-1g873qe-0"
})(["padding:24px 16px;border-radius:12px;background:linear-gradient( 159.48deg,#fff9ed 4.69%,rgba(255,239,236,0.736176) 27.76%,#f8f9e7 92.13% );", ""], function (props) {
  return props.isOpen ? "border: 1px ".concat(Global/* theme.yellowText4 */.rS.yellowText4, " solid;") : "box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);";
});
var ExpandableTnCCard_style_TnCLabel = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ExpandableTnCCardstyle__TnCLabel",
  componentId: "sc-1g873qe-1"
})(["padding:16px 11px;display:flex;align-items:center;cursor:pointer;margin-top:24px;border-radius:8px;background-color:", ";"], Global/* theme.whiteText */.rS.whiteText);
var ExpandableTnCCard_style_IconCtr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ExpandableTnCCardstyle__IconCtr",
  componentId: "sc-1g873qe-2"
})(["width:32px;height:32px;display:flex;border-radius:50%;align-items:center;justify-content:center;transform:rotate(90deg);background-color:", ";"], Global/* theme.whiteText */.rS.whiteText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExpandableTnCCard/ExpandableTnCCard.tsx








var ExpandableTnCCard = function ExpandableTnCCard(_ref) {
  var label = _ref.label,
      subLabel = _ref.subLabel,
      noteLabel = _ref.noteLabel,
      tncCheckbox = _ref.tncCheckbox,
      conditionLabel = _ref.conditionLabel,
      iconWhenCollapsed = _ref.iconWhenCollapsed,
      dangerousNoteSubLabel = _ref.dangerousNoteSubLabel;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  return /*#__PURE__*/_jsxs(ExpandableTnCCardStyle, {
    isOpen: isOpen,
    children: [!!label && /*#__PURE__*/_jsx(H5Tag, {
      children: label
    }), !!subLabel && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "sm",
      margin: "8px 0px 0px",
      children: subLabel
    }), isOpen ? /*#__PURE__*/_jsxs(Fragment, {
      children: [!!noteLabel && /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        fontWeight: "bold",
        margin: "24px 0px 0px",
        color: theme.brownText,
        children: noteLabel
      }), !!dangerousNoteSubLabel && /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "xs",
        margin: "4px 0px 0px",
        color: theme.greyText,
        dangerousText: dangerousNoteSubLabel
      }), !!tncCheckbox && /*#__PURE__*/_jsxs(TnCLabel, {
        onClick: tncCheckbox.onClick,
        children: [/*#__PURE__*/_jsx(CheckButton, {
          isChecked: tncCheckbox.isChecked
        }), tncCheckbox.label && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "xs",
          dangerousText: tncCheckbox.label
        }), tncCheckbox.linkLabel && /*#__PURE__*/_jsx(AnchorTag, {
          fontSize: "xs",
          margin: "0px 0px 0px 4px",
          hrefProp: tncCheckbox.linkLabel.hrefProp,
          handleClick: tncCheckbox.linkLabel.onClick,
          children: tncCheckbox.linkLabel.label
        })]
      })]
    }) : /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      margin: "16px 0px 0px",
      justifyContent: "space-between",
      children: [conditionLabel && /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "xs",
        color: theme.greyText,
        children: conditionLabel
      }), iconWhenCollapsed ? /*#__PURE__*/_jsx(ImageTag, {
        src: iconWhenCollapsed
      }) : /*#__PURE__*/_jsx(IconCtr, {
        onClick: function onClick() {
          return setIsOpen(true);
        },
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(ChevronUpIcon, {})
        })
      })]
    })]
  });
};

/* harmony default export */ var ExpandableTnCCard_ExpandableTnCCard = ((/* unused pure expression or super */ null && (ExpandableTnCCard)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CurrencyPageComponents/AddCurrencyCard/AddCurrencyCard.style.ts

var AddCurrencyCard_style_AddCurrencyCardStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddCurrencyCardstyle__AddCurrencyCardStyle",
  componentId: "l5s5of-0"
})(["padding:20px 12px;border-radius:8px;background:", ";"], function (props) {
  return props.isError ? "linear-gradient(159.48deg,#FFF9ED 4.69%,rgba(255,239,236,0.736176) 27.76%,#F8F9E7 92.13%)" : "linear-gradient(159.48deg, #EDFBFF 4.69%, rgba(236, 241, 255, 0.736176) 27.76%, #E7F1F9 92.13%)";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CurrencyPageComponents/AddCurrencyCard/AddCurrencyCard.tsx


function AddCurrencyCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AddCurrencyCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AddCurrencyCard_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AddCurrencyCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var AddCurrencyCard = function AddCurrencyCard(_ref) {
  var label = _ref.label,
      inputFieldData = _ref.inputFieldData,
      minimumQtyText = _ref.minimumQtyText,
      exchangeRate = _ref.exchangeRate,
      amountLeftLabel = _ref.amountLeftLabel,
      amountRightLabel = _ref.amountRightLabel;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(AddCurrencyCardStyle, {
    isError: !!(inputFieldData !== null && inputFieldData !== void 0 && inputFieldData.errorState),
    children: [label && /*#__PURE__*/_jsx(ParaTag, {
      fontWeight: "bold",
      fontSize: "md",
      children: label
    }), inputFieldData && /*#__PURE__*/_jsx(TMFloatingInput, AddCurrencyCard_objectSpread({
      margin: "16px 0px 0px"
    }, inputFieldData)), minimumQtyText && !!!(inputFieldData !== null && inputFieldData !== void 0 && inputFieldData.errorState) && /*#__PURE__*/_jsx(ParaTag, {
      color: inputFieldData !== null && inputFieldData !== void 0 && inputFieldData.errorState ? theme.redText : theme.greyText6,
      fontSize: "xs",
      margin: "4px 0px 0px",
      dangerousText: minimumQtyText
    }), exchangeRate && /*#__PURE__*/_jsxs(FlexComp, {
      margin: "16px 0px 0px",
      gap: "4px",
      children: [exchangeRate.label && /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greyText6,
        children: exchangeRate.label
      }), exchangeRate.rateLabel && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        color: theme.greenText,
        children: exchangeRate.rateLabel
      }), exchangeRate.persuasionLabel && /*#__PURE__*/_jsx(TimerLabel, {
        marginLeft: "0px",
        marginTop: device === "sm" ? "0px" : undefined,
        bg: "linear-gradient(87.29deg, #C86DD7 0%, #3023AE 100%)",
        children: exchangeRate.persuasionLabel
      })]
    }), (!!amountLeftLabel || !!amountRightLabel) && /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      margin: "16px 0px 0px",
      justifyContent: "space-between",
      children: [amountLeftLabel && /*#__PURE__*/_jsx(SpanTag, {
        children: amountLeftLabel
      }), amountRightLabel && /*#__PURE__*/_jsx(SpanTag, {
        color: theme.greyText,
        children: amountRightLabel
      })]
    })]
  });
};

/* harmony default export */ var AddCurrencyCard_AddCurrencyCard = ((/* unused pure expression or super */ null && (AddCurrencyCard)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/PassportNumComp.style.ts




var PassportNumComp_style_PassportNumCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PassportNumCompstyle__PassportNumCompStyle",
  componentId: "sc-4ddzx4-0"
})(["background:#ffffff;border-radius:16px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);flex:1;display:flex;flex-direction:column;@media ", "{border-radius:16px 16px 0 0;}"], utils/* deviceType.mobile */.vO.mobile);
var PassportNumComp_style_PassportHd = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PassportNumCompstyle__PassportHd",
  componentId: "sc-4ddzx4-1"
})(["padding:30px;border-bottom:1px solid #e8e8e8;display:flex;flex-direction:column;gap:8px;@media ", "{padding:24px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
var PassportNumComp_style_PassportItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PassportNumCompstyle__PassportItem",
  componentId: "sc-4ddzx4-2"
})(["display:grid;grid-template-columns:repeat(2,1fr);border-bottom:", ";padding:16px 30px;gap:8px;@media ", "{grid-template-columns:repeat(1,1fr);padding:16px;}"], function (p) {
  return p.itemIndex ? "none" : "1px solid #e8e8e8";
}, utils/* deviceType.mobile */.vO.mobile);
var PassportNumComp_style_ButtonWrap = (0,styled_components_browser_esm["default"])(FlexCompStyle).withConfig({
  displayName: "PassportNumCompstyle__ButtonWrap",
  componentId: "sc-4ddzx4-3"
})(["display:flex;align-items:center;padding:30px;margin-top:auto;", "{flex:1;}", "{flex:1;text-align:center;}@media ", "{padding:24px 16px;}"], LandingButton_style_LandingButtonStyle, FlexCompStyle, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/PassportNumComp.tsx










var PassportNumComp_analytics = getAnalytics();

var PassportNumComp = function PassportNumComp(_ref) {
  var isLoading = _ref.isLoading,
      title = _ref.title,
      info = _ref.info,
      travellerData = _ref.travellerData,
      submitCtaText = _ref.submitCtaText,
      skipCtaText = _ref.skipCtaText,
      passportFormData = _ref.passportFormData,
      handleSubmitClick = _ref.handleSubmitClick,
      handleAddPassportModal = _ref.handleAddPassportModal;

  var _ref2 = passportFormData || {},
      isRequired = _ref2.isRequired,
      label = _ref2.label,
      placeHolder = _ref2.placeHolder,
      pattern = _ref2.pattern,
      maxLength = _ref2.maxLength,
      error_message = _ref2.error_message;

  var travellerCount = (travellerData === null || travellerData === void 0 ? void 0 : travellerData.length) || 0;

  var _useForm = useForm({
    defaultValues: {
      //array name should match with field array name in useFieldAray()
      passportData: Array.from({
        length: travellerCount
      }).map(function (_, index) {
        var _travellerData$index, _travellerData$index2;

        return {
          name: (travellerData === null || travellerData === void 0 ? void 0 : (_travellerData$index = travellerData[index]) === null || _travellerData$index === void 0 ? void 0 : _travellerData$index.name) || "",
          passport: (travellerData === null || travellerData === void 0 ? void 0 : (_travellerData$index2 = travellerData[index]) === null || _travellerData$index2 === void 0 ? void 0 : _travellerData$index2.passportNum) || ""
        };
      })
    },
    mode: "onTouched"
  }),
      control = _useForm.control,
      formState = _useForm.formState,
      handleSubmit = _useForm.handleSubmit;

  var _useFieldArray = useFieldArray({
    control: control,
    name: "passportData" // unique name for field array

  }),
      fields = _useFieldArray.fields;

  var errors = formState.errors;

  var onSubmit = function onSubmit(formData) {
    PassportNumComp_analytics === null || PassportNumComp_analytics === void 0 ? void 0 : PassportNumComp_analytics.trackAddPassportEvents({
      actionType: "submit_clicked"
    });
    PassportNumComp_analytics === null || PassportNumComp_analytics === void 0 ? void 0 : PassportNumComp_analytics.trackAddPassportEvents({
      actionType: "details_filled"
    });

    var _ref3 = formData || {},
        passportData = _ref3.passportData;

    var reqData = travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (item, index) {
      var _ref4 = item || {},
          refId = _ref4.refId,
          name = _ref4.name,
          _ref4$dob = _ref4.dob,
          dob = _ref4$dob === void 0 ? "" : _ref4$dob,
          gender = _ref4.gender;

      return {
        refId: refId,
        FullName: name,
        Dob: formatDate(dob, DATE_FORMATS["YYYY-MM-DD"]),
        Gender: gender,
        PassportNo: passportData[index].passport
      };
    });
    handleSubmitClick(reqData);
  };

  return /*#__PURE__*/_jsxs(PassportNumCompStyle, {
    children: [/*#__PURE__*/_jsxs(PassportHd, {
      children: [/*#__PURE__*/_jsx(H5Tag, {
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }), /*#__PURE__*/_jsx(ParaTag, {
        fontSize: "sm",
        color: theme.greyText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info
        })
      })]
    }), fields.map(function (item, index) {
      var _errors$passportData;

      var error = errors === null || errors === void 0 ? void 0 : (_errors$passportData = errors.passportData) === null || _errors$passportData === void 0 ? void 0 : _errors$passportData[index];
      return /*#__PURE__*/_jsx(PassportItem, {
        itemIndex: index == fields.length - 1,
        children: /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "passportData.".concat(index, ".passport"),
          rules: {
            required: {
              value: isRequired !== null && isRequired !== void 0 ? isRequired : true,
              message: getFormFieldErrorMsg("passport")
            },
            pattern: {
              value: new RegExp(pattern || ""),
              message: getFormFieldErrorMsg("passport", error_message)
            }
          },
          render: function render(_ref5) {
            var _error$passport;

            var _ref5$field = _ref5.field,
                onChange = _ref5$field.onChange,
                onBlur = _ref5$field.onBlur,
                value = _ref5$field.value;
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(SpanTag, {
                fontSize: "md",
                fontWeight: "bold",
                color: theme.blackText,
                children: item.name
              }), /*#__PURE__*/_jsx(LandingInput, {
                requiredField: isRequired,
                placeholderTxt: placeHolder,
                labelTxt: label,
                errorState: error === null || error === void 0 ? void 0 : (_error$passport = error.passport) === null || _error$passport === void 0 ? void 0 : _error$passport.message,
                inputValue: value,
                maxInputLength: maxLength,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: onBlur
              })]
            });
          }
        })
      }, index);
    }), /*#__PURE__*/_jsxs(ButtonWrap, {
      alignItems: "center",
      gap: "24px",
      children: [/*#__PURE__*/_jsx(LandingButton, {
        isLoading: isLoading,
        customTitle: submitCtaText,
        onClick: handleSubmit(onSubmit)
      }), skipCtaText && /*#__PURE__*/_jsx(FlexComp, {
        children: /*#__PURE__*/_jsx(AnchorTag, {
          fontSize: "md",
          fontWeight: "bold",
          handleClick: handleAddPassportModal,
          children: skipCtaText
        })
      })]
    })]
  });
};

/* harmony default export */ var PassportNumComp_PassportNumComp = ((/* unused pure expression or super */ null && (PassportNumComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsurance.style.ts



var ManageInsurance_style_ManageInsuranceStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceStyle",
  componentId: "zxsmvf-0"
})(["background:linear-gradient(46.21deg,#f7f4ff 0.78%,#dceaff 97.21%),#ffffff;border:1px solid #ffffff;border-radius:16px;padding:10px 16px;position:relative;overflow:hidden;> img{position:absolute;top:-7px;right:-7px;}svg{fill:#fff;}"]);
var ManageInsuranceInfo = styled_components_browser_esm["default"].p.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceInfo",
  componentId: "zxsmvf-1"
})(["margin-bottom:8px;font-size:12px;line-height:16px;color:#4a4a4a;span{font-weight:800;}"]);
var ManageInsurance_style_ManageInsuranceStyleShimmer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceStyleShimmer",
  componentId: "zxsmvf-2"
})(["background:#e2e2e2;border-radius:4px;height:176px;padding:16px;display:flex;"]);
var ManageInsurance_style_TitleText = (0,styled_components_browser_esm["default"])(ParaTagStyle).withConfig({
  displayName: "ManageInsurancestyle__TitleText",
  componentId: "zxsmvf-3"
})(["max-width:200px;font-size:16px;font-weight:900;margin-bottom:8px;"]);
var ManageInsurance_style_InfoText = (0,styled_components_browser_esm["default"])(ParaTagStyle).withConfig({
  displayName: "ManageInsurancestyle__InfoText",
  componentId: "zxsmvf-4"
})(["width:95%;font-size:12px;margin-bottom:8px;color:#4a4a4a;@media ", "{width:80%;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsurance.tsx







var ManageInsurance = function ManageInsurance(_ref) {
  var title = _ref.title,
      info = _ref.info,
      orderBtn = _ref.orderBtn,
      handleManageOrder = _ref.handleManageOrder,
      goHomeText = _ref.goHomeText;

  var gotoHome = function gotoHome() {
    navigationActions.navigateToLanding();
  };

  return /*#__PURE__*/_jsxs(ManageInsuranceStyle, {
    children: [/*#__PURE__*/_jsx(ImageComponent, {
      width: "104px",
      height: "104px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/manage_Ins_Bg_410326bba8.svg"
    }), /*#__PURE__*/_jsx(TitleText, {
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title
      })
    }), info && /*#__PURE__*/_jsx(InfoText, {
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: info
      })
    }), /*#__PURE__*/_jsx(LandingButton, {
      btnRightIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/white_Chev_8257cb46d7.svg",
      customWidth: "100%",
      customTitle: orderBtn,
      onClick: handleManageOrder
    }), goHomeText && /*#__PURE__*/_jsxs(FlexComp, {
      margin: "16px 0 0",
      isCursorPointer: true,
      alignItems: "center",
      gap: "4px",
      handleClick: gotoHome,
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        textTransform: "uppercase",
        fontSize: "xs",
        fontWeight: "black",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: goHomeText
        })
      }), /*#__PURE__*/_jsx(ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/right_arrow_4a1f2bfef9.svg"
      })]
    })]
  });
};

/* harmony default export */ var ManageInsurance_ManageInsurance = ((/* unused pure expression or super */ null && (ManageInsurance)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderDetailRightComp.style.ts



var OrderDetailRightComp_style_OrderRightStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightStyle",
  componentId: "cex5w1-0"
})(["background:#ffffff;border-radius:16px;"]);
var OrderDetailRightComp_style_OrderRightHd = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightHd",
  componentId: "cex5w1-1"
})(["padding:20px 20px 12px;border-bottom:1px solid #f2f2f2;display:flex;justify-content:space-between;gap:10px;"]);
var OrderDetailRightComp_style_OrderRightCntnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightCntnt",
  componentId: "cex5w1-2"
})(["padding:12px 20px;"]);
var OrderDetailRightComp_style_PriceText = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "OrderDetailRightCompstyle__PriceText",
  componentId: "cex5w1-3"
})(["flex-shrink:0;"]);
var OrderDetailRightComp_style_MmtServiceFee = (0,styled_components_browser_esm["default"])(FlexCompStyle).withConfig({
  displayName: "OrderDetailRightCompstyle__MmtServiceFee",
  componentId: "cex5w1-4"
})(["margin-top:12px;padding-top:12px;margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid #f2f2f2;border-top:1px solid #f2f2f2;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderDetailRightCompShimmer.tsx







var OrderDetailRightCompShimmer = function OrderDetailRightCompShimmer(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsxs(OrderRightStyle, {
    children: [/*#__PURE__*/_jsx(OrderRightHd, {
      children: /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "100%",
        height: "22px",
        margin: "0 0 auto"
      })
    }), /*#__PURE__*/_jsx(OrderRightCntnt, {})]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderDetailRightCompShimmer = ((/* unused pure expression or super */ null && (OrderDetailRightCompShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsuranceShimmer.tsx






var ManageInsuranceShimmer = function ManageInsuranceShimmer(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsx(ManageInsuranceStyleShimmer, {
    children: /*#__PURE__*/_jsx(ShimmerVersion3, {
      margin: "auto 0 0",
      height: "44px",
      width: "100%"
    })
  });
};

/* harmony default export */ var ManageInsurance_ManageInsuranceShimmer = ((/* unused pure expression or super */ null && (ManageInsuranceShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetails.style.ts


var OrderDetails_style_OrderDetailsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsStyle",
  componentId: "jnokfb-0"
})(["background:#ffffff;box-shadow:0px 1px 8px rgba(0,0,0,0.179518);border-radius:16px;overflow:hidden;margin:", ";picture,img{flex-shrink:0;}@media ", "{padding-bottom:16px;}"], function (props) {
  return props.margin;
}, static_utils/* deviceType.mobile */.vO.mobile);
var OrderDetails_style_OrderDetailsSectionOne = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionOne",
  componentId: "jnokfb-1"
})(["padding:16px 30px;background:#fff;display:flex;align-items:center;justify-content:space-between;font-weight:700;font-size:14px;line-height:19px;text-transform:uppercase;color:#000000;"]);
var OrderDetails_style_OrderDetailsSectionTwo = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionTwo",
  componentId: "jnokfb-2"
})(["padding:16px 30px;background:linear-gradient(93.36deg,#f2eae6 -17.08%,#ffffff 118.39%);display:flex;align-items:center;gap:20px;margin-bottom:8px;min-height:90px;.imgWrap{width:145px;height:88px;}"]);
var OrderDetailsSectionThree = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionThree",
  componentId: "jnokfb-3"
})(["padding:16px 30px;background:#fff;display:flex;flex-direction:column;border:1px dashed #fafafa;background:#fafafa;margin:8px 0;"]);
var OrderDetails_style_OrderDetailsList = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsList",
  componentId: "jnokfb-4"
})(["border-top:1px dashed #d8d8d8;padding-top:16px;padding-bottom:2px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetails.tsx









var OrderDetails = function OrderDetails(_ref) {
  var orderDetails = _ref.orderDetails,
      margin = _ref.margin,
      downloadPolicy = _ref.downloadPolicy,
      navigateToDownloadPolicy = _ref.navigateToDownloadPolicy;
  var device = useBreakpointV2();

  var _ref2 = orderDetails !== null && orderDetails !== void 0 ? orderDetails : {},
      planName = _ref2.planName,
      packName = _ref2.packName,
      insPackName = _ref2.insPackName,
      packColor = _ref2.packColor,
      packImg = _ref2.packImg,
      orderDetailAmt = _ref2.orderDetailAmt;

  return /*#__PURE__*/_jsxs(OrderDetailsStyle, {
    margin: margin,
    children: [/*#__PURE__*/_jsxs(OrderDetailsSectionOne, {
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "black",
        children: "Plan details"
      }), insPackName && /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "black",
        color: packColor,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: insPackName
        })
      })]
    }), /*#__PURE__*/_jsxs(OrderDetailsSectionTwo, {
      children: [/*#__PURE__*/_jsx(ImageComponent, {
        width: "59px",
        height: "59px",
        src: packImg ? packImg : ""
      }), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        children: [planName && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "black",
          color: theme.blackText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: planName
          })
        }), packName && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: theme.greyText7,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: packName
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(OrderDetailsList, {
      children: orderDetailAmt && (orderDetailAmt === null || orderDetailAmt === void 0 ? void 0 : orderDetailAmt.map(function (item, index) {
        var _orderDetailAmt$lengt;

        return /*#__PURE__*/_jsxs(FlexComp, {
          justifyContent: "space-between",
          borderBottom: "1px dashed #dbdbdb",
          padding: index == ((_orderDetailAmt$lengt = orderDetailAmt === null || orderDetailAmt === void 0 ? void 0 : orderDetailAmt.length) !== null && _orderDetailAmt$lengt !== void 0 ? _orderDetailAmt$lengt : 0) - 1 ? "0 30px 8px" : "0 30px 8px",
          margin: "0 0 8px",
          children: [item.orderDetail && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: index == 0 ? "sm" : "xs",
            color: theme.greyText,
            fontWeight: index == 0 ? "black" : "regular",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.orderDetail
            })
          }), item.info && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: index == 0 ? "md" : "xs",
            color: theme.blackText,
            fontWeight: "black",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.info
            })
          })]
        }, index);
      }))
    }), device == "sm" && downloadPolicy && downloadPolicy !== null && downloadPolicy !== void 0 && downloadPolicy.isEnabled ? /*#__PURE__*/_jsx(LandingButtonWhite, {
      btnLeftIcon: downloadPolicy === null || downloadPolicy === void 0 ? void 0 : downloadPolicy.leftIconUrl,
      btnRightIcon: downloadPolicy === null || downloadPolicy === void 0 ? void 0 : downloadPolicy.rightIconUrl,
      customTitle: downloadPolicy === null || downloadPolicy === void 0 ? void 0 : downloadPolicy.buttonTitle,
      customWidth: "calc(100% - 24px)",
      margin: "0 auto",
      onClick: navigateToDownloadPolicy
    }) : null]
  });
};

/* harmony default export */ var OrderDetails_OrderDetails = ((/* unused pure expression or super */ null && (OrderDetails)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetailsShimmer.tsx






var OrderDetailsShimmer = function OrderDetailsShimmer(_ref) {
  var _orderDetails$orderDe;

  var orderDetails = _ref.orderDetails,
      margin = _ref.margin;
  return /*#__PURE__*/_jsxs(OrderDetailsStyle, {
    margin: margin,
    children: [/*#__PURE__*/_jsxs(OrderDetailsSectionOne, {
      children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "300px",
        height: "20px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "136px",
        height: "20px"
      })]
    }), /*#__PURE__*/_jsx(OrderDetailsSectionTwo, {}), /*#__PURE__*/_jsx(OrderDetailsList, {
      children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.orderDetailAmt) && (orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$orderDe = orderDetails.orderDetailAmt) === null || _orderDetails$orderDe === void 0 ? void 0 : _orderDetails$orderDe.map(function (item, index) {
        var _orderDetails$orderDe2, _orderDetails$orderDe3;

        return /*#__PURE__*/_jsxs(FlexComp, {
          justifyContent: "space-between",
          borderBottom: "1px dashed #dbdbdb",
          padding: index == ((_orderDetails$orderDe2 = orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$orderDe3 = orderDetails.orderDetailAmt) === null || _orderDetails$orderDe3 === void 0 ? void 0 : _orderDetails$orderDe3.length) !== null && _orderDetails$orderDe2 !== void 0 ? _orderDetails$orderDe2 : 0) - 1 ? "0 30px 16px" : "0 30px 8px",
          margin: "0 0 8px",
          children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "144px",
            height: "18px"
          }), /*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "144px",
            height: "18px"
          })]
        }, index);
      }))
    })]
  });
};

/* harmony default export */ var OrderDetails_OrderDetailsShimmer = ((/* unused pure expression or super */ null && (OrderDetailsShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingForeignCurr/LandingForeignCurr.style.ts

var LandingForeignCurr_style_LandingForeignCurrStyle = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingForeignCurrstyle__LandingForeignCurrStyle",
  componentId: "sc-1dbfn8f-0"
})(["background:linear-gradient( 147.2deg,#fff6d8 4.79%,#fffaf3 43.98%,#f3f0e6 120.5% );border-radius:25px;padding:40px 60px;position:relative;overflow:hidden;margin-bottom:163px;position:relative;z-index:1;overflow:hidden;", ""], function (props) {
  return props.currThankYou && "\nbackground: linear-gradient(95.21deg, #E8F0FF 15.84%, #6536C9 100%);\nbox-shadow: 0px 1px 8px rgba(0, 0, 0, 0.179518);\nborder-radius: 4px;\npadding:26px 30px;\n";
});
var LandingForeignCurr_style_BgImgWrap = styled_components_browser_esm["default"].img.withConfig({
  displayName: "LandingForeignCurrstyle__BgImgWrap",
  componentId: "sc-1dbfn8f-1"
})(["position:absolute;top:0;left:0;z-index:-1;height:100%;"]);
var LandingForeignCurr_style_LandingForeignCurrTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingForeignCurrstyle__LandingForeignCurrTitle",
  componentId: "sc-1dbfn8f-2"
})(["font-family:\"Lato\";font-weight:600;font-size:40px;line-height:72px;color:#000000;margin-bottom:24px;", ""], function (props) {
  return props.currThankYou && "\nwidth:443px;\nfont-weight: 800;\nfont-size: 22px;\nline-height: 28px;\ncolor: #000000;\nmargin-bottom:16px;\n";
});
var LandingForeignCurr_style_LandingForeignCurrList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingForeignCurrstyle__LandingForeignCurrList",
  componentId: "sc-1dbfn8f-3"
})(["font-weight:400;font-size:18px;line-height:32px;padding-left:18px;gap:10px;margin-bottom:40px;li{position:relative;}li:after{content:\"\";position:absolute;width:5px;height:14px;left:-18px;top:8px;background:#41454e;border-radius:14px;}", ""], function (props) {
  return props.currThankYou && "\n  display:flex;\n  gap:32px;\n  margin-bottom: 24px;\n\n  li:after {\n    background: #B48B28;\n  }\n ";
});
var LandingForeignCurr_style_ThankCurrInfo = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingForeignCurrstyle__ThankCurrInfo",
  componentId: "sc-1dbfn8f-4"
})(["display:inline-block;font-weight:800;font-size:14px;line-height:19px;text-transform:uppercase;color:#232222;margin-bottom:33px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingForeignCurr/LandingForeignCurr.tsx






var LandingForeignCurr = function LandingForeignCurr(_ref) {
  var currThankYou = _ref.currThankYou;
  return /*#__PURE__*/_jsxs(LandingForeignCurrStyle, {
    currThankYou: currThankYou,
    children: [currThankYou ? /*#__PURE__*/_jsx(BgImgWrap, {
      src: "../../images/forrCurrBg.png",
      alt: ""
    }) : /*#__PURE__*/_jsx("img", {
      src: "../../images/foreignCurrBg.png",
      alt: ""
    }), currThankYou && /*#__PURE__*/_jsx(ThankCurrInfo, {
      children: "FOREIGN CURRENCY AT YOUR DOOR STEP"
    }), /*#__PURE__*/_jsxs(LandingForeignCurrTitle, {
      currThankYou: currThankYou,
      children: [currThankYou ? "We can deliver some physical currency too if you need, Shall we ?" : "Looking for foreign currency", "?"]
    }), !currThankYou && /*#__PURE__*/_jsxs(LandingForeignCurrList, {
      children: [/*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          children: "100% Digital"
        }), " Control"]
      }), /*#__PURE__*/_jsx("li", {
        children: "No Mark-ups"
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          children: "Easy money loading"
        }), " in INR"]
      })]
    }), currThankYou && /*#__PURE__*/_jsxs(LandingForeignCurrList, {
      currThankYou: true,
      children: [/*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          children: "100% Digital"
        }), " Control"]
      }), /*#__PURE__*/_jsx("li", {
        children: "No Mark-ups"
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          children: "Easy money loading"
        }), " in INR"]
      })]
    }), /*#__PURE__*/_jsx(LandingButton, {
      customTitle: currThankYou ? "GET CURRENCIES" : "Explore Forex currency",
      customWidth: currThankYou ? "178px" : ""
    })]
  });
};

/* harmony default export */ var LandingForeignCurr_LandingForeignCurr = ((/* unused pure expression or super */ null && (LandingForeignCurr)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBooked.style.ts



var InsuranceBooked_style_InsuranceBookedStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsuranceBookedstyle__InsuranceBookedStyle",
  componentId: "sc-16uf35k-0"
})(["background-color:", ";border-radius:8px;padding:28px 26px;min-height:295px;@media ", "{min-height:0;padding:12px 16px;}"], Global/* theme.neonGreen */.rS.neonGreen, utils/* deviceType.mobile */.vO.mobile);
var InsuranceBooked_style_ListingSpan = styled_components_browser_esm["default"].span.withConfig({
  displayName: "InsuranceBookedstyle__ListingSpan",
  componentId: "sc-16uf35k-1"
})(["font-size:14px;line-height:20px;color:", ";padding-right:12px;margin-right:12px;position:relative;flex-shrink:0;&:last-child{border:none;flex-shrink:unset;}&:after{content:\"\";position:absolute;right:0;top:4px;width:1px;height:14px;background:#4a4a4a;}&:last-child:after{width:0;border:none;flex-shrink:unset;}@media ", "{font-size:12px;}"], Global/* theme.greyText */.rS.greyText, utils/* deviceType.mobile */.vO.mobile);
var InsuranceBooked_style_GreenArrowWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsuranceBookedstyle__GreenArrowWrap",
  componentId: "sc-16uf35k-2"
})(["transition:0.4s ease-in;transform-origin:center;flex-shrink:0;width:40px;height:40px;display:flex;", ""], function (p) {
  return p.showinsDetails && "\ntransform:rotate(180deg);\n";
});
var InsuranceBooked_style_InsuranceBookedPackStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsuranceBookedstyle__InsuranceBookedPackStyle",
  componentId: "sc-16uf35k-3"
})(["display:flex;flex-direction:column;border-bottom:1px solid ", ";padding-bottom:8px;margin-bottom:24px;@media ", "{padding-bottom:12px;margin-bottom:12px;}"], Global/* theme.lightSilver */.rS.lightSilver, utils/* deviceType.mobile */.vO.mobile);
var InsuranceBooked_style_ViewPlanBenefitStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsuranceBookedstyle__ViewPlanBenefitStyle",
  componentId: "sc-16uf35k-4"
})(["display:flex;align-items:center;justify-content:space-between;border-bottom:none;margin-bottom:20px;gap:8px;@media ", "{flex-direction:column;gap:4px;align-items:flex-start;margin-bottom:12px;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedTravel.tsx










var InsuranceBookedTravel_InsuranceBookedTravel = function InsuranceBookedTravel(_ref) {
  var selectedPlanData = _ref.selectedPlanData;
  var device = useBreakpoint();

  var _ref2 = selectedPlanData || {},
      countryTitle = _ref2.countryTitle,
      travelDate = _ref2.travelDate,
      travellerCount = _ref2.travellerCount,
      travelPurpose = _ref2.travelPurpose;

  var _ref3 = travelDate || {},
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  console.log({
    travelPurpose: travelPurpose,
    travellerCount: travellerCount
  });
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(H6Tag, {
      color: theme.greyText,
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: countryTitle
      })
    }), /*#__PURE__*/_jsxs(FlexComp, {
      margin: device == "lg" ? "8px 0 0" : "",
      children: [startDate && endDate && /*#__PURE__*/_jsxs(ListingSpan, {
        color: theme.greyText,
        children: [/*#__PURE__*/_jsxs(SpanTag, {
          color: theme.greyText,
          fontSize: "md",
          fontWeight: "bold",
          children: [formatDate(startDate, DATE_FORMATS["D MMM"]), "'"]
        }), formatDate(startDate, DATE_FORMATS.YY), " -To-", " ", /*#__PURE__*/_jsxs(SpanTag, {
          color: theme.greyText,
          fontSize: "md",
          fontWeight: "bold",
          children: [formatDate(endDate, DATE_FORMATS["D MMM"]), "'"]
        }), formatDate(endDate, DATE_FORMATS.YY)]
      }), travellerCount && /*#__PURE__*/_jsx(ListingSpan, {
        color: theme.greyText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: travellerCount
        })
      })]
    })]
  });
};

/* harmony default export */ var InsuranceBooked_InsuranceBookedTravel = ((/* unused pure expression or super */ null && (InsuranceBookedTravel_InsuranceBookedTravel)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedPack.tsx







var InsuranceBookedPack_InsuranceBookedPack = function InsuranceBookedPack(_ref) {
  var selectedPlanData = _ref.selectedPlanData,
      viewBenefitsCta = _ref.viewBenefitsCta,
      handleViewBenefits = _ref.handleViewBenefits;
  var device = useBreakpointV2();

  var _ref2 = selectedPlanData || {},
      planType = _ref2.planType,
      planName = _ref2.planName,
      vendorName = _ref2.vendorName,
      vendorIcon = _ref2.vendorIcon,
      settleMentRatio = _ref2.settleMentRatio,
      planTypeColor = _ref2.planTypeColor;

  return /*#__PURE__*/_jsxs(InsuranceBookedPackStyle, {
    children: [/*#__PURE__*/_jsx(ParaTag, {
      fontSize: "xs",
      fontWeight: "black",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: planType
      })
    }), /*#__PURE__*/_jsxs(ViewPlanBenefitStyle, {
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "black",
        fontSize: "md",
        color: theme.blackText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: planName
        })
      }), viewBenefitsCta && /*#__PURE__*/_jsx(AnchorTag, {
        fontSize: "sm",
        fontWeight: "black",
        handleClick: handleViewBenefits,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: viewBenefitsCta
        })
      })]
    }), /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      borderBottom: "none",
      padding: "0",
      gap: "14px",
      margin: "0",
      children: [vendorIcon && /*#__PURE__*/_jsx(ImageComponent, {
        width: "48px",
        height: "48px",
        src: vendorIcon
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ParaTag, {
          fontSize: "sm",
          fontWeight: "black",
          color: theme.blackText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: vendorName
          })
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          color: theme.blackText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: settleMentRatio
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var InsuranceBooked_InsuranceBookedPack = ((/* unused pure expression or super */ null && (InsuranceBookedPack_InsuranceBookedPack)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBooked.tsx










var InsuranceBooked = function InsuranceBooked(_ref) {
  var title = _ref.title,
      selectedPlanData = _ref.selectedPlanData,
      viewBenefitsCta = _ref.viewBenefitsCta,
      handleViewBenefits = _ref.handleViewBenefits;

  var _ref2 = selectedPlanData || {},
      payAmtTxt = _ref2.payAmtTxt,
      payAmt = _ref2.payAmt;

  var device = useBreakpointV2();

  var _useState = useState(false),
      insDetails = _useState[0],
      setInsDetails = _useState[1];

  var handleInsuranceExpand = function handleInsuranceExpand() {
    setInsDetails(!insDetails);
  };

  return /*#__PURE__*/_jsxs(InsuranceBookedStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      justifyContent: "space-between",
      alignItems: device == "lg" ? "center" : "flex-start",
      borderBottom: insDetails && device == "sm" ? "1px solid #d8d8d8" : device == "lg" ? "1px solid #d8d8d8" : "",
      padding: insDetails && device == "sm" ? "0 0 12px" : device == "lg" ? "0 0 24px" : "",
      margin: insDetails && device == "sm" ? "0 0 12px" : device == "lg" ? "0 0 8px" : "",
      handleClick: handleInsuranceExpand,
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        justifyContent: "space-between",
        width: "100%",
        alignItems: device === "lg" ? "center" : "",
        flexDirection: device === "lg" ? "row" : "column",
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          alignItems: "center",
          gap: "8px",
          padding: "0",
          margin: "0 10px 0 0",
          borderBottom: "none",
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "24px",
            height: "24px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_48_Copy_4b90426dd9.svg"
          }), device == "lg" ? /*#__PURE__*/_jsx(H5Tag, {
            color: theme.blackText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: title
            })
          }) : /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(H6Tag, {
              color: theme.blackText,
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: title
              })
            }), /*#__PURE__*/_jsxs(FlexComp, {
              flexShrink: "0",
              flexDirection: "row",
              gap: "2px",
              children: [/*#__PURE__*/_jsx(SpanTag, {
                color: theme.greenText5,
                fontSize: "xs",
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: payAmtTxt
                })
              }), /*#__PURE__*/_jsx(SpanTag, {
                color: theme.greenText5,
                fontSize: "xs",
                fontWeight: "black",
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: payAmt
                })
              })]
            })]
          })]
        }), device === "lg" && /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "row",
          gap: "4px",
          margin: device === "lg" ? "0 0 0 auto" : "",
          children: [/*#__PURE__*/_jsx(SpanTag, {
            color: theme.greenText5,
            fontSize: device == "lg" ? "md" : "xs",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: payAmtTxt
            })
          }), /*#__PURE__*/_jsx(SpanTag, {
            color: theme.greenText5,
            fontSize: device == "lg" ? "md" : "xs",
            fontWeight: "black",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: payAmt
            })
          })]
        })]
      }), device == "sm" && /*#__PURE__*/_jsx(GreenArrowWrap, {
        showinsDetails: insDetails,
        onClick: handleInsuranceExpand,
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: "40px",
          height: "40px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_1244832110_61908827b9.svg"
        })
      })]
    }), (insDetails && device == "sm" || device == "lg") && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(InsuranceBookedPack, {
        selectedPlanData: selectedPlanData,
        viewBenefitsCta: viewBenefitsCta,
        handleViewBenefits: handleViewBenefits
      }), /*#__PURE__*/_jsx(InsuranceBookedTravel, {
        selectedPlanData: selectedPlanData
      })]
    })]
  });
};

/* harmony default export */ var InsuranceBooked_InsuranceBooked = ((/* unused pure expression or super */ null && (InsuranceBooked)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedShimmer.tsx



var InsuranceBookedShimmer = function InsuranceBookedShimmer() {
  return /*#__PURE__*/_jsx(InsuranceBookedStyle, {});
};

/* harmony default export */ var InsuranceBooked_InsuranceBookedShimmer = ((/* unused pure expression or super */ null && (InsuranceBookedShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/AddPassportModal.tsx






var AddPassportModal = function AddPassportModal(_ref) {
  var handleSkip = _ref.handleSkip,
      handleClose = _ref.handleClose,
      data = _ref.data;

  var _ref2 = data || {},
      title = _ref2.title,
      info = _ref2.info,
      addBtnText = _ref2.addBtnText,
      skipBtnText = _ref2.skipBtnText;

  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    handleClick: handleClose,
    customTitle: title,
    customIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/Geeric_caution_b863e71f7f.svg",
    nonClipHeading: true,
    children: [/*#__PURE__*/_jsx(ParaTag, {
      fontSize: "md",
      color: theme.greyText,
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: info
      })
    }), /*#__PURE__*/_jsxs(FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "26px 0 0",
      gap: "10px",
      children: [addBtnText && /*#__PURE__*/_jsx(LandingButton, {
        onClick: handleClose,
        customWidth: "122px",
        customTitle: addBtnText
      }), skipBtnText && /*#__PURE__*/_jsx(AnchorTag, {
        handleClick: handleSkip,
        fontSize: "md",
        fontWeight: "bold",
        children: skipBtnText
      })]
    })]
  });
};

/* harmony default export */ var PassportNumComp_AddPassportModal = ((/* unused pure expression or super */ null && (AddPassportModal)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PincodeCities/PincodeCities.style.ts


var PincodeCities_style_CityListText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "PincodeCitiesstyle__CityListText",
  componentId: "sc-1phs33i-0"
})(["font-size:12px;font-weight:400;line-height:16px;color:", ";"], Global/* theme.greyText */.rS.greyText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PincodeCities/PincodeCities.tsx







var PincodeCities_PincodeCities = function PincodeCities(_ref) {
  var citiesList = _ref.citiesList,
      title = _ref.title,
      showMoreBtnTxt = _ref.showMoreBtnTxt;
  var device = useBreakpoint();

  var _useState = useState(false),
      showAllCities = _useState[0],
      setShowAllCities = _useState[1];

  var handleShowMore = function handleShowMore() {
    setShowAllCities(true);
  };

  var cityList = citiesList ? citiesList.join(" | ") : [];
  var characters = device === "lg" ? 100 : 85;
  var displayText = showAllCities ? cityList : "".concat(cityList === null || cityList === void 0 ? void 0 : cityList.slice(0, characters), "... ");
  return /*#__PURE__*/_jsxs(FlexComp, {
    margin: "12px 0px 24px 0px",
    flexDirection: "column",
    children: [title && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "xs",
      fontWeight: "bold",
      margin: "0px 0px 4px 0px",
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(CityListText, {
        children: displayText
      }), !showAllCities && /*#__PURE__*/_jsx(AnchorTag, {
        fontWeight: "bold",
        fontSize: "xs",
        handleClick: handleShowMore,
        children: showMoreBtnTxt
      })]
    })]
  });
};

/* harmony default export */ var components_PincodeCities_PincodeCities = ((/* unused pure expression or super */ null && (PincodeCities_PincodeCities)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LoginComp/LoginComp.style.ts


var LoginCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LoginCompstyle__LoginCompStyle",
  componentId: "sc-1g6olcx-0"
})([""]);
var LoginComp_style_LoginItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LoginCompstyle__LoginItem",
  componentId: "sc-1g6olcx-1"
})(["background:#f6faff;border-radius:8px;padding:20px;display:flex;gap:20px;align-items:center;margin-top:12px;@media ", "{padding:12px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
var LoginComp_style_AgreeTnCTxt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LoginCompstyle__AgreeTnCTxt",
  componentId: "sc-1g6olcx-2"
})(["border-top:1px solid #e2e2e2;padding-top:8px;margin-top:32px;"]);
var LoginComp_style_NotYourAccount = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LoginCompstyle__NotYourAccount",
  componentId: "sc-1g6olcx-3"
})(["padding:12px 20px;background:#f6f6f6;border-radius:8px;display:flex;align-items:center;margin-top:20px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/oneWayArrBlue.svg
/* harmony default export */ var oneWayArrBlue = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/oneWayArrBlue.a1f360c0.svg","height":15,"width":22});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/oneWayArrGrey.svg
/* harmony default export */ var oneWayArrGrey = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/oneWayArrGrey.204b84aa.svg","height":15,"width":22});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/crossIconGreyBg.svg
/* harmony default export */ var crossIconGreyBg = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/crossIconGreyBg.bde35c9a.svg","height":24,"width":24});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LoginComp/LoginComp.tsx











var LoginComp = function LoginComp(_ref) {
  var _loginWidgetData$logi, _loginWidgetData$tnCT, _loginWidgetData$tnCT2, _loginWidgetData$tnCT3, _loginWidgetData$tnCT4, _loginWidgetData$tnCT5;

  var loginWidgetData = _ref.loginWidgetData,
      handleTnC = _ref.handleTnC,
      handlePrivacyPolicy = _ref.handlePrivacyPolicy;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    crossIcon: CrossIcon.src,
    customTitle: loginWidgetData === null || loginWidgetData === void 0 ? void 0 : loginWidgetData.title,
    children: [/*#__PURE__*/_jsx(ParaTag, {
      color: theme.greyText,
      children: loginWidgetData === null || loginWidgetData === void 0 ? void 0 : loginWidgetData.info
    }), loginWidgetData === null || loginWidgetData === void 0 ? void 0 : (_loginWidgetData$logi = loginWidgetData.loginOptions) === null || _loginWidgetData$logi === void 0 ? void 0 : _loginWidgetData$logi.map(function (item, index) {
      return /*#__PURE__*/_jsxs(LoginItem, {
        children: [item.logoImg && /*#__PURE__*/_jsx(ImageTag, {
          width: device === "lg" ? "32px" : "24px",
          height: device === "lg" ? "32px" : "24px",
          src: item.logoImg
        }), /*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "column",
          gap: "4px",
          children: [/*#__PURE__*/_jsx(ParaTag, {
            fontSize: device === "lg" ? "md" : "sm",
            children: item.loginWith
          }), /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: item.accountDetails
          })]
        }), /*#__PURE__*/_jsx(AnchorTag, {
          margin: "0 0 0 auto",
          handleClick: function handleClick() {},
          children: /*#__PURE__*/_jsx(ImageTag, {
            src: OneWayArrBlue.src
          })
        })]
      }, index);
    }), /*#__PURE__*/_jsxs(NotYourAccount, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ParaTag, {
          fontSize: "sm",
          color: theme.greyText,
          children: loginWidgetData === null || loginWidgetData === void 0 ? void 0 : loginWidgetData.notYourAccount
        }), /*#__PURE__*/_jsx(AnchorTag, {
          fontSize: "sm",
          fontWeight: "bold",
          children: loginWidgetData === null || loginWidgetData === void 0 ? void 0 : loginWidgetData.loginCta
        })]
      }), /*#__PURE__*/_jsx(AnchorTag, {
        margin: "0 0 0 auto",
        handleClick: function handleClick() {},
        children: /*#__PURE__*/_jsx(ImageTag, {
          src: OneWayArrGrey.src
        })
      })]
    }), /*#__PURE__*/_jsx(AgreeTnCTxt, {
      children: /*#__PURE__*/_jsxs(SpanTag, {
        fontSize: "xs",
        color: theme.greyText7,
        children: [loginWidgetData === null || loginWidgetData === void 0 ? void 0 : (_loginWidgetData$tnCT = loginWidgetData.tnCTxt) === null || _loginWidgetData$tnCT === void 0 ? void 0 : _loginWidgetData$tnCT.txt1, " \xA0", /*#__PURE__*/_jsx(AnchorTag, {
          fontSize: "xs",
          handleClick: handleTnC,
          children: loginWidgetData === null || loginWidgetData === void 0 ? void 0 : (_loginWidgetData$tnCT2 = loginWidgetData.tnCTxt) === null || _loginWidgetData$tnCT2 === void 0 ? void 0 : _loginWidgetData$tnCT2.termsCta
        }), "\xA0", loginWidgetData === null || loginWidgetData === void 0 ? void 0 : (_loginWidgetData$tnCT3 = loginWidgetData.tnCTxt) === null || _loginWidgetData$tnCT3 === void 0 ? void 0 : _loginWidgetData$tnCT3.txt2, " \xA0", /*#__PURE__*/_jsx(AnchorTag, {
          fontSize: "xs",
          handleClick: handlePrivacyPolicy,
          children: loginWidgetData === null || loginWidgetData === void 0 ? void 0 : (_loginWidgetData$tnCT4 = loginWidgetData.tnCTxt) === null || _loginWidgetData$tnCT4 === void 0 ? void 0 : _loginWidgetData$tnCT4.privacyPolicyCta
        }), "\xA0", loginWidgetData === null || loginWidgetData === void 0 ? void 0 : (_loginWidgetData$tnCT5 = loginWidgetData.tnCTxt) === null || _loginWidgetData$tnCT5 === void 0 ? void 0 : _loginWidgetData$tnCT5.txt3]
      })
    })]
  });
};

/* harmony default export */ var LoginComp_LoginComp = ((/* unused pure expression or super */ null && (LoginComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddPassportDetail/AddPassportDetail.style.ts

var AddPassportDetail_style_AddPassportDetailStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddPassportDetailstyle__AddPassportDetailStyle",
  componentId: "sc-110cox0-0"
})(["background:#ffedd1;border:1px solid #cf8100;border-radius:16px;padding:24px 16px;gap:8px;display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddPassportDetail/AddPassportDetail.tsx






var AddPassportDetail = function AddPassportDetail(_ref) {
  var data = _ref.data,
      handlePassportBtn = _ref.handlePassportBtn;
  var addPasstitle = data.addPasstitle,
      addPassportBtn = data.addPassportBtn,
      addPassInfo = data.addPassInfo,
      addPassportCta = data.addPassportCta;
  return /*#__PURE__*/_jsxs(AddPassportDetailStyle, {
    children: [/*#__PURE__*/_jsx(ParaTag, {
      fontSize: "md",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: addPasstitle
      })
    }), /*#__PURE__*/_jsx(LandingButtonWhite, {
      btnLeftIcon: addPassportBtn.iconLeft,
      btnRightIcon: addPassportBtn.iconRight,
      customWidth: "100%",
      customTitle: addPassportBtn.title,
      onClick: handlePassportBtn,
      margin: "16px 0 0"
    })]
  });
};

/* harmony default export */ var AddPassportDetail_AddPassportDetail = ((/* unused pure expression or super */ null && (AddPassportDetail)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsFaqComp/InsFaqComp.style.ts

var InsFaqComp_style_InsFaqCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsFaqCompstyle__InsFaqCompStyle",
  componentId: "sc-1kul3qo-0"
})(["background:linear-gradient(45deg,#f7f5ff 14.64%,#e1ecff 85.36%);margin-top:82px;"]);
var InsFaqComp_style_InsCompWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsFaqCompstyle__InsCompWrap",
  componentId: "sc-1kul3qo-1"
})(["width:1200px;margin:0 auto;padding:32px 0;"]);
var InsFaqComp_style_SearchField = styled_components_browser_esm["default"].input.withConfig({
  displayName: "InsFaqCompstyle__SearchField",
  componentId: "sc-1kul3qo-2"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:4px;padding:14px 20px;width:530px;flex-shrink:0;"]);
var IfHelpFullStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsFaqCompstyle__IfHelpFullStyle",
  componentId: "sc-1kul3qo-3"
})(["background:linear-gradient(45deg,#f7f5ff 14.64%,#e1ecff 85.36%);border-radius:8px;padding:24px 16px;"]);
var SubmitRequestStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsFaqCompstyle__SubmitRequestStyle",
  componentId: "sc-1kul3qo-4"
})(["background:#f6f6f6;border-radius:8px;padding:14px;display:flex;gap:12px;"]);
var FeedBackCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InsFaqCompstyle__FeedBackCompStyle",
  componentId: "sc-1kul3qo-5"
})(["background:linear-gradient( 45deg,rgba(67,225,168,0.2) 14.64%,rgba(33,147,147,0.2) 85.36% );padding:16px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AccordianComp/AccordianComp.style.ts

var AccordianComp_style_AccordianCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AccordianCompstyle__AccordianCompStyle",
  componentId: "sc-16s5xm5-0"
})(["padding:16px 24px;border-bottom:1px solid #e2e2e2;display:flex;flex-direction:column;gap:20px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AccordianComp/AccordianComp.tsx








var AccordianComp_AccordianComp = function AccordianComp(_ref) {
  var title = _ref.title,
      subInfo = _ref.subInfo,
      info = _ref.info,
      handleClickAccordion = _ref.handleClickAccordion,
      accordionStatus = _ref.accordionStatus,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(AccordianCompStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      handleClick: handleClickAccordion,
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontSize: "large",
        fontWeight: accordionStatus ? "bold" : "regular",
        children: title
      }), /*#__PURE__*/_jsx(BlueChev, {})]
    }), subInfo && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.greyText,
      children: subInfo
    }), accordionStatus && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "md",
      color: theme.greyText,
      children: info
    }), children]
  });
};

/* harmony default export */ var components_AccordianComp_AccordianComp = ((/* unused pure expression or super */ null && (AccordianComp_AccordianComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsFaqComp/InsFaqComp.tsx







var InsFaqComp = function InsFaqComp(_ref) {
  var title = _ref.title,
      popularQues = _ref.popularQues,
      questionType = _ref.questionType,
      questionTypeIcon = _ref.questionTypeIcon;

  var _useState = useState(-1),
      accordion = _useState[0],
      setAccordion = _useState[1];

  var _handleClickAccordion = function handleClickAccordion(index) {
    accordion == index ? setAccordion(-1) : setAccordion(index);
  };

  return /*#__PURE__*/_jsx(InsFaqCompStyle, {
    children: /*#__PURE__*/_jsxs(InsCompWrap, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        margin: "0 0 60px",
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(H2Tag, {
          children: title
        }), /*#__PURE__*/_jsx(SearchField, {
          placeholder: "Enter your query"
        })]
      }), /*#__PURE__*/_jsxs(H5Tag, {
        margin: "0 0 32px",
        children: [questionTypeIcon && /*#__PURE__*/_jsx(ImageTag, {
          margin: "0 8px 0 0",
          src: questionTypeIcon
        }), questionType]
      }), popularQues && popularQues.map(function (item, index) {
        return /*#__PURE__*/_jsx(AccordianComp, {
          title: item.title,
          info: item.info,
          handleClickAccordion: function handleClickAccordion() {
            return _handleClickAccordion(index);
          },
          accordionStatus: accordion == index
        });
      })]
    })
  });
};

/* harmony default export */ var InsFaqComp_InsFaqComp = ((/* unused pure expression or super */ null && (InsFaqComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderWhite.tsx







var LandingHeaderWhite_productLinks = (/* unused pure expression or super */ null && (["Foreign Currency", "Forex Cards", "Travel Insurance", "Travel Loan", "Foreign Money Trasfer"]));

var LandingHeaderWhite = function LandingHeaderWhite(_ref) {
  var forexHeader = _ref.forexHeader,
      loginState = _ref.loginState,
      logoUrl = _ref.logoUrl;

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  var handleClick = function handleClick() {
    setShow(!show);
  };

  return /*#__PURE__*/_jsx(LandingHeaderWhiteStyle, {
    id: "header-id",
    children: /*#__PURE__*/_jsxs(LandingHeaderWrap, {
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        children: /*#__PURE__*/_jsx(TripMoneyLogo, {
          darkHeader: true
        })
      }), !loginState && /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsxs(LandingHeaderList, {
          children: [/*#__PURE__*/_jsxs(LandingHeaderItem, {
            opened: show,
            closed: !show,
            onClick: handleClick,
            children: [/*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              "aria-label": "products",
              children: "Products"
            }), show && /*#__PURE__*/_jsx(ProductLinks, {
              children: LandingHeaderWhite_productLinks && LandingHeaderWhite_productLinks.map(function (item, index) {
                return /*#__PURE__*/_jsx(AnchorTag, {
                  hrefProp: "#",
                  children: item
                }, index);
              })
            })]
          }), /*#__PURE__*/_jsx(LandingHeaderItem, {
            children: /*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              children: "Blogs"
            })
          }), /*#__PURE__*/_jsx(LandingHeaderItem, {
            children: /*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              children: "FAQ\u2019s"
            })
          }), /*#__PURE__*/_jsx(LandingHeaderItem, {
            children: /*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: "#",
              children: "About Us"
            })
          })]
        }), /*#__PURE__*/_jsx(LandingHeaderBtn, {
          children: "LOGIN"
        })]
      }), loginState && /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(ImageIcon, {
          children: "C"
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xxs",
          color: theme.blackText,
          fontWeight: "bold",
          children: "Hey Chavi"
        }), /*#__PURE__*/_jsx(ImageComponent, {
          width: "14px",
          height: "14px",
          margin: "0 0 0 8px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/black_Chev_30adf1ebb1.svg"
        })]
      })]
    })
  });
};

/* harmony default export */ var LandingHeader_LandingHeaderWhite = ((/* unused pure expression or super */ null && (LandingHeaderWhite)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailComp.style.ts



var OrderDetailComp_style_OrderDetailCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailCompStyle",
  componentId: "hdko8w-0"
})(["background:#ffffff;border-radius:16px;padding:20px;picture{display:inherit;flex-shrink:0;}@media ", "{padding:16px 16px 12px;border-radius:0px;}"], utils/* deviceType.mobile */.vO.mobile);
var OrderDetailComp_style_OrderDetailTravellerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailTravellerStyle",
  componentId: "hdko8w-1"
})(["border:1px solid #e2e2e2;@media ", "{border:none;padding-left:24px;}"], utils/* deviceType.mobile */.vO.mobile);
var OrderDetailComp_style_TravellerItem = (0,styled_components_browser_esm["default"])(FlexCompStyle).withConfig({
  displayName: "OrderDetailCompstyle__TravellerItem",
  componentId: "hdko8w-2"
})(["border-bottom:1px solid #e2e2e2;padding:12px 16px;:last-child{border-bottom:none;}@media ", "{padding:8px;}"], utils/* deviceType.mobile */.vO.mobile);
var OrderDetailComp_style_PlanDetailStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailCompstyle__PlanDetailStyle",
  componentId: "hdko8w-3"
})(["background:#f6faff;border-radius:8px;padding:16px;@media ", "{background:transparent;padding:0;min-height:100%;padding-left:32px;}"], utils/* deviceType.mobile */.vO.mobile);
var PlanDetailsInfo = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailCompstyle__PlanDetailsInfo",
  componentId: "hdko8w-4"
})(["background:#ffffff;margin-top:16px;display:grid;grid-template-columns:2fr 2fr 2fr 0.6fr;", "{border-right:1px solid #e8e8e8;padding:12px 16px;:last-child{border:none;}}@media ", "{display:flex;flex-direction:column;", "{border:none;border-bottom:1px solid #e8e8e8;padding:12px 0 12px 0px;}", ":last-child{border:none;}}"], FlexCompStyle, utils/* deviceType.mobile */.vO.mobile, FlexCompStyle, FlexCompStyle);
var OrderDetailComp_style_OrderDetailsTable = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailsTable",
  componentId: "hdko8w-5"
})(["display:grid;grid-template-columns:repeat(3,1fr);border:1px solid #e8e8e8;", "{:nth-child(n + 3){border-bottom:none;}:nth-child(3){border-right:none;border-bottom:1px solid #e8e8e8;}}@media ", "{display:flex;flex-direction:column;border:none;", "{border-bottom:1px solid #e8e8e8;padding:12px 0;border-right:none;:nth-child(n + 3){border-bottom:1px solid #e8e8e8;}:last-child{border-bottom:none;}}}"], FlexCompStyle, utils/* deviceType.mobile */.vO.mobile, FlexCompStyle);
var OrderDetailComp_style_OrderDetailsItem = (0,styled_components_browser_esm["default"])(FlexCompStyle).withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailsItem",
  componentId: "hdko8w-6"
})(["border-right:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;padding:12px 16px;:last-child{border-right:none;}@media ", "{display:flex;justify-content:space-between;}"], utils/* deviceType.mobile */.vO.mobile);
var OrderDetailComp_style_OrderMobCtaWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailCompstyle__OrderMobCtaWrap",
  componentId: "hdko8w-7"
})(["display:flex;align-items:center;justify-content:space-between;padding:16px 20px 16px 48px;background:#fff;border:1px solid rgba(232,232,232,1);box-shadow:0px 1px 4px 0px rgba(74,74,74,0.2);"]);
var OrderDetailComp_style_OrderMobAmtWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderDetailCompstyle__OrderMobAmtWrap",
  componentId: "hdko8w-8"
})(["display:flex;align-items:center;justify-content:space-between;padding:16px;background:#fff;border:1px solid rgba(232,232,232,1);"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailInsurance.tsx








var OrderDetailInsurance = function OrderDetailInsurance(_ref) {
  var _forInsuranceContaine;

  var insPlanName = _ref.insPlanName,
      orderDetailIcon = _ref.orderDetailIcon,
      orderDetails = _ref.orderDetails,
      insuranceType = _ref.insuranceType,
      insuranceInfo = _ref.insuranceInfo,
      insuranceTypeColor = _ref.insuranceTypeColor,
      forInsuranceContainer = _ref.forInsuranceContainer,
      handleClickInsurance = _ref.handleClickInsurance;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(OrderDetailCompStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: device == "lg" ? "row" : "row-reverse",
      justifyContent: device == "lg" ? "" : "space-between",
      alignItems: device == "lg" ? "" : "center",
      margin: device == "lg" ? "0 0 24px" : "0 0 14px",
      gap: "8px",
      children: [orderDetailIcon && /*#__PURE__*/_jsx(ImageComponent, {
        width: "56px",
        height: "56px",
        src: orderDetailIcon
      }), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        gap: "2px",
        margin: "0",
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "large" : "md",
          fontWeight: "bold",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: insPlanName
          })
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: insuranceInfo
          })
        })]
      }), device == "lg" && insuranceType && /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        textTransform: "uppercase",
        margin: "0 0 0 auto",
        color: insuranceTypeColor,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: insuranceType
        })
      })]
    }), /*#__PURE__*/_jsx(OrderDetailsTable, {
      children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.map(function (item, index) {
        return /*#__PURE__*/_jsxs(OrderDetailsItem, {
          gap: "16px",
          children: [item.label && /*#__PURE__*/_jsx(ParaTag, {
            textTransform: "uppercase",
            color: theme.greyText7,
            fontSize: "xs",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.label
            })
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            fontWeight: "bold",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.value
            })
          })]
        }, index);
      })
    }), device == "sm" && /*#__PURE__*/_jsx(FlexComp, {
      gap: "35px",
      borderTop: "1px solid #e2e2e2",
      margin: "16px -16px 0",
      padding: "16px 16px 0",
      justifyContent: "space-between",
      children: forInsuranceContainer === null || forInsuranceContainer === void 0 ? void 0 : (_forInsuranceContaine = forInsuranceContainer.forInsurance) === null || _forInsuranceContaine === void 0 ? void 0 : _forInsuranceContaine.map(function (item, index) {
        return /*#__PURE__*/_jsxs(FlexComp, {
          flex: "1",
          flexDirection: "column",
          alignItems: "center",
          gap: "6px",
          handleClick: function handleClick() {
            return handleClickInsurance(item);
          },
          children: [item.icon && /*#__PURE__*/_jsx(ImageComponent, {
            width: "36px",
            height: "36px",
            src: item.icon
          }), item.title && /*#__PURE__*/_jsx(AnchorTag, {
            fontSize: "xs",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.title
            })
          })]
        }, index);
      })
    })]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailInsurance = ((/* unused pure expression or super */ null && (OrderDetailInsurance)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailInsuranceShimmer.tsx






var OrderDetailInsuranceShimmer = function OrderDetailInsuranceShimmer() {
  return /*#__PURE__*/_jsxs(OrderDetailCompStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      margin: "0 0 24px",
      gap: "8px",
      children: [/*#__PURE__*/_jsx(ShimmerVersion3, {
        width: "56px",
        height: "56px"
      }), /*#__PURE__*/_jsxs(FlexComp, {
        flexDirection: "column",
        margin: "0",
        children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "532px",
          height: "28px"
        }), /*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "266px",
          height: "16px"
        })]
      })]
    }), /*#__PURE__*/_jsx(ShimmerVersion2, {
      height: "76px",
      width: "100%"
    })]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailInsuranceShimmer = ((/* unused pure expression or super */ null && (OrderDetailInsuranceShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailPlan.tsx








var OrderDetailPlan = function OrderDetailPlan(_ref) {
  var title = _ref.title,
      orderDetailIcon = _ref.orderDetailIcon,
      planBenefits = _ref.planBenefits,
      handleMoreBenefits = _ref.handleMoreBenefits,
      ctaLink = _ref.ctaLink,
      subTitle = _ref.subTitle,
      benefitsCTA = _ref.benefitsCTA;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(OrderDetailCompStyle, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        children: [orderDetailIcon && /*#__PURE__*/_jsx(ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon
        }), title && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: title
          })
        })]
      }), /*#__PURE__*/_jsx(PlanDetailStyle, {
        children: /*#__PURE__*/_jsx(ParaTag, {
          fontWeight: "bold",
          fontSize: "large",
          children: subTitle
        })
      })]
    })
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailPlan = ((/* unused pure expression or super */ null && (OrderDetailPlan)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailPlanShimmer.tsx






var OrderDetailPlanShimmer = function OrderDetailPlanShimmer() {
  return /*#__PURE__*/_jsxs(OrderDetailCompStyle, {
    children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
      width: "366px",
      height: "25px",
      margin: "0 0 24px"
    }), /*#__PURE__*/_jsx(PlanDetailStyle, {})]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailPlanShimmer = ((/* unused pure expression or super */ null && (OrderDetailPlanShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailTraveller.tsx





function OrderDetailTraveller_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OrderDetailTraveller_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OrderDetailTraveller_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OrderDetailTraveller_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var OrderDetailTraveller_analytics = getAnalytics();

var OrderDetailTraveller = function OrderDetailTraveller(_ref) {
  var title = _ref.title,
      orderDetailIcon = _ref.orderDetailIcon,
      travellerDetails = _ref.travellerDetails,
      editEnabled = _ref.editEnabled,
      editTraveller = _ref.editTraveller,
      updateOrderDetails = _ref.updateOrderDetails,
      handleClickEditDetailSheet = _ref.handleClickEditDetailSheet;
  var device = useBreakpointV2();

  var _useState = useState(-1),
      editTravellerIndex = _useState[0],
      setEditTravellerIndex = _useState[1];

  var _useState2 = useState([]),
      travellerData = _useState2[0],
      setTravellerData = _useState2[1];

  useEffect(function () {
    if (travellerDetails) {
      setTravellerData(travellerDetails);
    }
  }, [travellerDetails]);

  var handleClickEditDetails = function handleClickEditDetails(index) {
    setEditTravellerIndex(index);
  };

  var _handleUpdateDetails = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(updatedData, index) {
      var travellers;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              travellers = _toConsumableArray(travellerData);
              travellers[index] = OrderDetailTraveller_objectSpread(OrderDetailTraveller_objectSpread({}, travellers[index]), updatedData);
              setTravellerData(travellers);
              _context.next = 5;
              return updateOrderDetails === null || updateOrderDetails === void 0 ? void 0 : updateOrderDetails();

            case 5:
              setEditTravellerIndex(-1);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpdateDetails(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(OrderDetailCompStyle, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        children: [orderDetailIcon && /*#__PURE__*/_jsx(ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: title
          })
        })]
      }), /*#__PURE__*/_jsx(OrderDetailTravellerStyle, {
        children: travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (item, index) {
          return /*#__PURE__*/_jsxs(TravellerItem, {
            alignItems: "baseline",
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              gap: "4px",
              flexDirection: "column",
              children: [/*#__PURE__*/_jsx(ParaTag, {
                fontSize: device == "lg" ? "md" : "sm",
                fontWeight: "bold",
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: item.name
                })
              }), /*#__PURE__*/_jsxs("div", {
                children: [(item === null || item === void 0 ? void 0 : item.dob) && /*#__PURE__*/_jsxs(SpanTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: theme.greyText,
                  children: ["\xA0", /*#__PURE__*/_jsx(FormattedText, {
                    value: formatDate(item.dob, DATE_FORMATS["DD/MM/YYYY"])
                  }), " ", "|"]
                }), /*#__PURE__*/_jsxs(SpanTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: theme.greyText,
                  children: ["\xA0", /*#__PURE__*/_jsx(FormattedText, {
                    value: item.gender
                  })]
                })]
              })]
            }, index), device == "lg" && editEnabled && /*#__PURE__*/_jsx(AnchorTag, {
              handleClick: function handleClick() {
                OrderDetailTraveller_analytics === null || OrderDetailTraveller_analytics === void 0 ? void 0 : OrderDetailTraveller_analytics.trackOrderDetailsEvents({
                  actionType: "edit_details_clicked"
                });
                handleClickEditDetails(index);
              },
              children: /*#__PURE__*/_jsx(ImageComponent, {
                width: "16px",
                height: "16px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/Edit_Icon_9bd6098b75.svg"
              })
            }), editTravellerIndex === index && /*#__PURE__*/_jsx(EditTraveller, {
              index: index,
              title: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.title,
              travellerDetails: travellerData,
              travellerAttributes: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.travellerAttributes,
              fullName: item.name,
              dobValue: item.dob,
              passportValue: item.passport,
              genderValue: item.gender,
              refId: item.refId,
              goBackTxt: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.goBackBtnTxt,
              updateContactTxt: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.updateNowBtnTxt,
              handleUpdateDetails: function handleUpdateDetails(updatedData) {
                return _handleUpdateDetails(updatedData, index);
              },
              handleClose: function handleClose() {
                return setEditTravellerIndex(-1);
              }
            })]
          }, index);
        })
      })]
    }), device == "sm" && editEnabled && /*#__PURE__*/_jsxs(OrderMobCtaWrap, {
      onClick: handleClickEditDetailSheet,
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        fontWeight: "bold",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: "Edit Traveller Details"
        })
      }), /*#__PURE__*/_jsx(ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg"
      })]
    })]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailTraveller = ((/* unused pure expression or super */ null && (OrderDetailTraveller)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/PrimaryContact.tsx








var PrimaryContact = function PrimaryContact(_ref) {
  var title = _ref.title,
      orderDetailIcon = _ref.orderDetailIcon,
      contactDetails = _ref.contactDetails,
      handleAlternateContact = _ref.handleAlternateContact;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(OrderDetailCompStyle, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        children: [orderDetailIcon && /*#__PURE__*/_jsx(ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon
        }), title && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: title
          })
        })]
      }), (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.name) && /*#__PURE__*/_jsx(ParaTag, {
        margin: "0 0 10px 32px",
        fontSize: "md",
        fontWeight: "bold",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.name
        })
      }), /*#__PURE__*/_jsxs(FlexComp, {
        margin: "0 0 10px",
        alignItems: "center",
        gap: "6px",
        padding: "0 0 0 32px",
        children: [/*#__PURE__*/_jsx(ImageComponent, {
          width: "16px",
          height: "16px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/mail_Icon_cf3395e217.svg"
        }), (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email) && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email
          })
        })]
      }), /*#__PURE__*/_jsx(FlexComp, {
        justifyContent: "space-between",
        padding: "0 0 0 32px",
        children: /*#__PURE__*/_jsxs(FlexComp, {
          alignItems: "center",
          gap: "6px",
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "16px",
            height: "16px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/call_Icon_94b21de941.svg"
          }), (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.contactNo) && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: device == "lg" ? "sm" : "xs",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.contactNo
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var OrderDetailComp_PrimaryContact = ((/* unused pure expression or super */ null && (PrimaryContact)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderInsurance.tsx






var OrderInsurance = function OrderInsurance(_ref) {
  var title = _ref.title,
      info = _ref.info,
      forInsurance = _ref.forInsurance,
      handleClickInsurance = _ref.handleClickInsurance;
  return /*#__PURE__*/_jsxs(OrderRightStyle, {
    children: [/*#__PURE__*/_jsxs(OrderRightHd, {
      children: [title && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }), info && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info
        })
      })]
    }), /*#__PURE__*/_jsx(OrderRightCntnt, {
      children: /*#__PURE__*/_jsx(FlexComp, {
        flexDirection: "column",
        gap: "14px",
        children: forInsurance === null || forInsurance === void 0 ? void 0 : forInsurance.map(function (item, index) {
          return /*#__PURE__*/_jsxs(FlexComp, {
            alignItems: "center",
            gap: "16px",
            handleClick: function handleClick() {
              return handleClickInsurance(item);
            },
            children: [item.icon && /*#__PURE__*/_jsx(ImageComponent, {
              width: "20px",
              height: "20px",
              src: item.icon
            }), item.title && /*#__PURE__*/_jsx(AnchorTag, {
              fontWeight: "bold",
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: item.title
              })
            })]
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderInsurance = ((/* unused pure expression or super */ null && (OrderInsurance)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderPriceBreakup.tsx








var OrderPriceBreakup = function OrderPriceBreakup(_ref) {
  var title = _ref.title,
      info = _ref.info,
      priceBreakup = _ref.priceBreakup,
      totalPrice = _ref.totalPrice,
      mmtServiceFee = _ref.mmtServiceFee;
  return /*#__PURE__*/_jsxs(OrderRightStyle, {
    children: [/*#__PURE__*/_jsxs(OrderRightHd, {
      children: [title && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }), info && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info
        })
      })]
    }), /*#__PURE__*/_jsxs(OrderRightCntnt, {
      children: [priceBreakup && priceBreakup.map(function (item, index) {
        return /*#__PURE__*/_jsxs(FlexComp, {
          justifyContent: "space-between",
          children: [item.title && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            color: theme.greyText7,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.title
            })
          }), item.price && /*#__PURE__*/_jsx(PriceText, {
            txtfontSize: "xs",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.price
            })
          })]
        }, index);
      }), /*#__PURE__*/_jsxs(MmtServiceFee, {
        justifyContent: "space-between",
        children: [(mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.title) && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          color: theme.blackText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.title
          })
        }), (mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.price) && /*#__PURE__*/_jsx(PriceText, {
          txtfontSize: "xs",
          txtfontWeight: "bold",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.price
          })
        })]
      }), /*#__PURE__*/_jsxs(FlexComp, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          fontSize: "md",
          children: "Total Price"
        }), totalPrice && /*#__PURE__*/_jsx(PriceText, {
          txtfontWeight: "bold",
          txtfontSize: "md",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: totalPrice
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderPriceBreakup = ((/* unused pure expression or super */ null && (OrderPriceBreakup)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderGetHelp.tsx







var OrderGetHelp = function OrderGetHelp(_ref) {
  var title = _ref.title,
      info = _ref.info,
      getHelp = _ref.getHelp;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(OrderRightStyle, {
    children: [/*#__PURE__*/_jsxs(OrderRightHd, {
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info
        })
      })]
    }), /*#__PURE__*/_jsx(OrderRightCntnt, {
      children: /*#__PURE__*/_jsx(FlexComp, {
        justifyContent: device == "lg" ? "space-between" : "center",
        gap: device == "lg" ? "20px" : "42px",
        children: getHelp === null || getHelp === void 0 ? void 0 : getHelp.map(function (item, index) {
          return /*#__PURE__*/_jsxs(FlexComp, {
            gap: "8px",
            alignItems: "center",
            flexDirection: "column",
            children: [item.icon && /*#__PURE__*/_jsx(ImageComponent, {
              width: "27px",
              height: "27px",
              src: item.icon
            }), item.title && /*#__PURE__*/_jsx(AnchorTag, {
              fontSize: "xs",
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: item.title
              })
            })]
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderGetHelp = ((/* unused pure expression or super */ null && (OrderGetHelp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderAmtPaid.tsx







var OrderAmtPaid = function OrderAmtPaid(_ref) {
  var title = _ref.title,
      info = _ref.info,
      handleInvoice = _ref.handleInvoice,
      amountPaid = _ref.amountPaid;

  var _ref2 = amountPaid !== null && amountPaid !== void 0 ? amountPaid : {},
      breakupTxt = _ref2.breakupTxt,
      details = _ref2.details;

  var _ref3 = details !== null && details !== void 0 ? details : {},
      bank = _ref3.bank,
      accNo = _ref3.accNo,
      amt = _ref3.amt;

  return /*#__PURE__*/_jsxs(OrderRightStyle, {
    children: [/*#__PURE__*/_jsxs(OrderRightHd, {
      children: [title && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title
        })
      }), info && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info
        })
      })]
    }), /*#__PURE__*/_jsxs(OrderRightCntnt, {
      children: [breakupTxt && /*#__PURE__*/_jsx(ParaTag, {
        fontWeight: "bold",
        fontSize: "xs",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: breakupTxt
        })
      }), /*#__PURE__*/_jsxs(FlexComp, {
        justifyContent: "space-between",
        margin: "8px 0 16px",
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "column",
          margin: "unset",
          children: [bank && /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "xs",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: bank
            })
          }), accNo && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: accNo
            })
          })]
        }), amt && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: amt
          })
        })]
      }), /*#__PURE__*/_jsx(LandingButtonWhite, {
        customWidth: "100%",
        customTitle: "DOWNLOAD INVOICE",
        onClick: handleInvoice
      })]
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderAmtPaid = ((/* unused pure expression or super */ null && (OrderAmtPaid)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddAlternateContact/AddAlternateContact.style.ts

var AddAlternateContact_style_AccordianCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddAlternateContactstyle__AccordianCompStyle",
  componentId: "sc-1bmknqe-0"
})(["padding:16px 24px;border-bottom:1px solid #e2e2e2;display:flex;flex-direction:column;gap:20px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddAlternateContact/AddAlternateContact.tsx






var AddAlternateContact = function AddAlternateContact(_ref) {
  var title = _ref.title,
      emailAddress = _ref.emailAddress,
      goBackTxt = _ref.goBackTxt,
      handleEmailChange = _ref.handleEmailChange,
      addContactTxt = _ref.addContactTxt,
      handleAlternateContact = _ref.handleAlternateContact,
      handleAddContact = _ref.handleAddContact,
      handleGoBack = _ref.handleGoBack;
  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    handleClick: handleAlternateContact,
    customTitle: title,
    children: [/*#__PURE__*/_jsx(LandingInput, {
      flex: "1",
      placeholderTxt: "Enter 10 digit mobile number",
      requiredField: true,
      labelTxt: "10 Digit Mobile No.",
      inputType: "number",
      margin: "0 0 16px"
    }), /*#__PURE__*/_jsx(LandingInput, {
      inputValue: emailAddress,
      handleChange: handleEmailChange,
      flex: "1",
      placeholderTxt: "Enter Email Id",
      requiredField: true,
      labelTxt: "Email ID"
    }), /*#__PURE__*/_jsxs(FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "32px 0 0",
      gap: "10px",
      children: [/*#__PURE__*/_jsx(LandingButton, {
        onClick: handleAddContact,
        customWidth: "210px",
        customTitle: addContactTxt
      }), /*#__PURE__*/_jsx(AnchorTag, {
        handleClick: handleGoBack,
        fontSize: "md",
        fontWeight: "bold",
        textTransform: "uppercase",
        children: goBackTxt
      })]
    })]
  });
};

/* harmony default export */ var AddAlternateContact_AddAlternateContact = ((/* unused pure expression or super */ null && (AddAlternateContact)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/ui-atoms/LandingButton/LandingButton.style.ts
var LandingButton_style = __webpack_require__(8721);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTraveller.style.ts



var EditTraveller_style_AccordianCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__AccordianCompStyle",
  componentId: "sc-1wc3syu-0"
})(["padding:16px 24px;border-bottom:1px solid #e2e2e2;display:flex;flex-direction:column;gap:20px;"]);
var EditTraveller_style_GenderTypeItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__GenderTypeItem",
  componentId: "sc-1wc3syu-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:5px 12px;cursor:pointer;", ""], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n    border-radius: 6px;\n";
});
var EditTraveller_style_EditTravelSheetStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__EditTravelSheetStyle",
  componentId: "sc-1wc3syu-2"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#f2f2f2;overflow-y:scroll;"]);
var EditTraveller_style_BtnWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__BtnWrap",
  componentId: "sc-1wc3syu-3"
})(["background:#fff;padding:8px 16px;position:fixed;bottom:0;left:0;right:0;"]);
var EditTraveller_style_TravllerNum = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__TravllerNum",
  componentId: "sc-1wc3syu-4"
})(["border-radius:18px;background:#f6f6f6;width:20px;height:20px;display:flex;justify-content:center;align-items:center;font-size:12px;font-weight:700;flex-shrink:0;"]);
var EditTraveller_style_EditTravllerItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__EditTravllerItem",
  componentId: "sc-1wc3syu-5"
})(["border-bottom:1px solid #e2e2e2;padding:12px 16px;background:#fff;"]);
var EditTraveller_style_TravellerDetailsStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__TravellerDetailsStyle",
  componentId: "sc-1wc3syu-6"
})(["padding:16px 30px;border-top:1px solid #e8e8e8;", "{span{font-size:12px;line-height:12px;}}@media ", "{padding:24px 16px;}"], LandingButton_style/* LandingButtonWhiteStyle */.aA, static_utils/* deviceType.mobile */.vO.mobile);
var EditTraveller_style_TravellerAddShimmer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EditTravellerstyle__TravellerAddShimmer",
  componentId: "sc-1wc3syu-7"
})(["padding:24px 30px;border-top:1px solid #e8e8e8;display:flex;justify-content:space-between;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTraveller.tsx














var EditTraveller_minDate = "1970-01-01";
var EditTraveller_maxDate = new Date().toISOString().split("T")[0];

var EditTraveller_EditTraveller = function EditTraveller(_ref) {
  var _name$isRequired, _dob$isRequired, _passport$isRequired, _gender$isRequired;

  var index = _ref.index,
      title = _ref.title,
      refId = _ref.refId,
      fullName = _ref.fullName,
      dobValue = _ref.dobValue,
      passportValue = _ref.passportValue,
      genderValue = _ref.genderValue,
      travellerDetails = _ref.travellerDetails,
      travellerAttributes = _ref.travellerAttributes,
      goBackTxt = _ref.goBackTxt,
      updateContactTxt = _ref.updateContactTxt,
      handleUpdateDetails = _ref.handleUpdateDetails,
      handleClose = _ref.handleClose;

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState(),
      editError = _useState2[0],
      setEditError = _useState2[1];

  var _ref2 = travellerAttributes || {},
      name = _ref2.name,
      dob = _ref2.dob,
      passport = _ref2.passport,
      gender = _ref2.gender;

  var _useForm = useForm({
    defaultValues: {
      name: fullName || "",
      dob: dobValue || "",
      passport: passportValue || "",
      gender: genderValue || ""
    },
    mode: "onTouched"
  }),
      control = _useForm.control,
      errors = _useForm.formState.errors,
      setValue = _useForm.setValue,
      setError = _useForm.setError,
      handleSubmit = _useForm.handleSubmit;

  var handleGenderChange = function handleGenderChange(value) {
    if (value) {
      setValue("gender", value);
    }
  };

  var handleServerErrors = function handleServerErrors(error) {
    var _ref3 = (error === null || error === void 0 ? void 0 : error.validationError) || {},
        _ref3$displaySecondar = _ref3.displaySecondaryError,
        displaySecondaryError = _ref3$displaySecondar === void 0 ? [] : _ref3$displaySecondar;

    displaySecondaryError.map(function (item) {
      var travellerId = item.travellerId;

      if (travellerId === refId) {
        var _item$displayError = item === null || item === void 0 ? void 0 : item.displayError,
            _name = _item$displayError.name,
            _dob = _item$displayError.dob,
            _passport = _item$displayError.passport;

        if (_name) {
          setError("name", {
            message: _name
          });
        }

        if (_dob) {
          setError("dob", {
            message: _dob
          });
        }

        if (_passport) {
          setError("passport", {
            message: _passport
          });
        }
      }
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formData) {
      var travellerData, queryParams, bookingId, partner, response, responseStatus, error, _err$response, _err$response$data, _Error, _error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              travellerData = travellerDetails.map(function (item, i) {
                var _formData$name;

                var refId = item.refId,
                    name = item.name,
                    dob = item.dob,
                    passport = item.passport,
                    gender = item.gender;
                return {
                  refId: refId,
                  FullName: i === index ? (_formData$name = formData.name) === null || _formData$name === void 0 ? void 0 : _formData$name.trim() : name,
                  Dob: i === index ? formData.dob : dob,
                  Gender: i === index ? formData.gender : gender,
                  PassportNo: i === index ? formData.passport : passport
                };
              });
              queryParams = new URLSearchParams(window.location.search);
              bookingId = queryParams.get("bookingId");
              partner = getPartnerOnClientSide();
              setIsLoading(true);
              _context.next = 8;
              return editInsuranceDetails({
                partner: partner,
                bookingID: bookingId,
                data: travellerData
              });

            case 8:
              response = _context.sent;
              responseStatus = response.responseStatus;

              if (!(responseStatus === RESPONSE_STATUS.SUCCESS)) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return handleUpdateDetails(formData);

            case 13:
              _context.next = 19;
              break;

            case 15:
              error = response.Error;

              if (error) {
                _context.next = 18;
                break;
              }

              throw new Error("Something went wrong");

            case 18:
              handleServerErrors(error);

            case 19:
              setIsLoading(false);
              _context.next = 28;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](0);
              console.log("ERROR IN UPDATING TRAVELLER DETAILS----", {
                err: _context.t0
              });
              setIsLoading(false);
              _err$response$data = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data, _Error = _err$response$data.Error, _error = _err$response$data.error;

              if (_Error && (_Error === null || _Error === void 0 ? void 0 : _Error.code) === ERROR_CODES.DISPLAY_ERROR) {
                handleServerErrors(_Error);
              } else {
                setEditError(_error);
              }

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 22]]);
    }));

    return function onSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  if (editError && true) {
    throw new ClientError(editError);
  }

  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    customTitle: title,
    handleClick: handleClose,
    children: [(name === null || name === void 0 ? void 0 : name.isEnabled) && /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "name",
      rules: {
        required: {
          value: (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true,
          message: getFormFieldErrorMsg("name")
        },
        pattern: {
          value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
          message: getFormFieldErrorMsg("name", name === null || name === void 0 ? void 0 : name.errorMessage)
        }
      },
      render: function render(_ref5) {
        var _errors$name;

        var _ref5$field = _ref5.field,
            value = _ref5$field.value,
            onChange = _ref5$field.onChange,
            onBlur = _ref5$field.onBlur;
        return /*#__PURE__*/_jsx(LandingInput, {
          requiredField: name === null || name === void 0 ? void 0 : name.isRequired,
          placeholderTxt: name === null || name === void 0 ? void 0 : name.placeholder,
          labelTxt: name === null || name === void 0 ? void 0 : name.title,
          inputValue: value,
          errorState: (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
          disableState: isLoading,
          handleChange: onChange,
          handleBlur: onBlur,
          inputWidth: "100%",
          margin: "0 0 16px"
        });
      }
    }), (dob === null || dob === void 0 ? void 0 : dob.isEnabled) && /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "dob",
      rules: {
        required: {
          value: (_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : true,
          message: getFormFieldErrorMsg("dob")
        },
        validate: function validate(value) {
          return isDobValid(value || "", dob === null || dob === void 0 ? void 0 : dob.regex) || getFormFieldErrorMsg("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
        }
      },
      render: function render(_ref6) {
        var _errors$dob;

        var _ref6$field = _ref6.field,
            value = _ref6$field.value,
            onChange = _ref6$field.onChange,
            onBlur = _ref6$field.onBlur;
        return /*#__PURE__*/_jsx(LandingInput, {
          requiredField: dob === null || dob === void 0 ? void 0 : dob.isRequired,
          placeholderTxt: " ",
          labelTxt: dob === null || dob === void 0 ? void 0 : dob.title,
          inputType: "date",
          inputValue: value,
          minValue: EditTraveller_minDate,
          maxValue: EditTraveller_maxDate,
          errorState: (_errors$dob = errors.dob) === null || _errors$dob === void 0 ? void 0 : _errors$dob.message,
          disableState: isLoading,
          handleChange: onChange,
          handleBlur: onBlur,
          inputWidth: "100%",
          margin: "0 0 16px"
        });
      }
    }), (passport === null || passport === void 0 ? void 0 : passport.isEnabled) && /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "passport",
      rules: {
        required: {
          value: (_passport$isRequired = passport === null || passport === void 0 ? void 0 : passport.isRequired) !== null && _passport$isRequired !== void 0 ? _passport$isRequired : true,
          message: getFormFieldErrorMsg("passport")
        },
        pattern: {
          value: new RegExp((passport === null || passport === void 0 ? void 0 : passport.regex) || ""),
          message: getFormFieldErrorMsg("passport", passport === null || passport === void 0 ? void 0 : passport.errorMessage)
        }
      },
      render: function render(_ref7) {
        var _errors$passport;

        var _ref7$field = _ref7.field,
            value = _ref7$field.value,
            onChange = _ref7$field.onChange,
            onBlur = _ref7$field.onBlur;
        return /*#__PURE__*/_jsx(LandingInput, {
          requiredField: passport === null || passport === void 0 ? void 0 : passport.isRequired,
          placeholderTxt: passport === null || passport === void 0 ? void 0 : passport.placeholder,
          labelTxt: passport === null || passport === void 0 ? void 0 : passport.title,
          inputValue: value,
          errorState: (_errors$passport = errors.passport) === null || _errors$passport === void 0 ? void 0 : _errors$passport.message,
          disableState: isLoading,
          handleChange: onChange,
          handleBlur: onBlur,
          inputWidth: "100%",
          margin: "0 0 16px"
        });
      }
    }), (gender === null || gender === void 0 ? void 0 : gender.isEnabled) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SpanTag, {
        margin: "0 0 8px",
        fontSize: "md",
        fontWeight: "bold",
        color: theme.greyText,
        children: "Gender"
      }), /*#__PURE__*/_jsx(FlexComp, {
        gap: "8px",
        children: /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "gender",
          rules: {
            required: {
              value: (_gender$isRequired = gender === null || gender === void 0 ? void 0 : gender.isRequired) !== null && _gender$isRequired !== void 0 ? _gender$isRequired : true,
              message: getFormFieldErrorMsg("gender")
            }
          },
          render: function render(_ref8) {
            var _gender$values;

            var value = _ref8.field.value;
            return /*#__PURE__*/_jsx(_Fragment, {
              children: gender === null || gender === void 0 ? void 0 : (_gender$values = gender.values) === null || _gender$values === void 0 ? void 0 : _gender$values.map(function (item, index) {
                var _item$label, _item$label2, _item$label3;

                return /*#__PURE__*/_jsx(GenderTypeItem, {
                  selected: ((_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()),
                  onClick: function onClick() {
                    handleGenderChange(item.label);
                  },
                  children: /*#__PURE__*/_jsx(RadioButton, {
                    activeBtn: ((_item$label2 = item.label) === null || _item$label2 === void 0 ? void 0 : _item$label2.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()),
                    children: /*#__PURE__*/_jsx(SpanTag, {
                      fontSize: "xs",
                      fontWeight: "bold",
                      color: ((_item$label3 = item.label) === null || _item$label3 === void 0 ? void 0 : _item$label3.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()) ? theme.blueText : theme.greyText,
                      children: item.label
                    })
                  })
                }, item.id);
              })
            });
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "32px 0 0",
      gap: "10px",
      children: [/*#__PURE__*/_jsx(LandingButton, {
        onClick: handleSubmit(onSubmit),
        customWidth: "210px",
        customTitle: updateContactTxt,
        isLoading: isLoading
      }), /*#__PURE__*/_jsx(AnchorTag, {
        handleClick: handleClose,
        fontSize: "md",
        fontWeight: "bold",
        textTransform: "uppercase",
        children: goBackTxt
      })]
    })]
  });
};

/* harmony default export */ var components_EditTraveller_EditTraveller = ((/* unused pure expression or super */ null && (EditTraveller_EditTraveller)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTravellerSheet.tsx













var EditTravellerSheet_minDate = "1970-01-01";
var EditTravellerSheet_maxDate = new Date().toISOString().split("T")[0];

var EditTravellerSheet = function EditTravellerSheet(_ref) {
  var handleClose = _ref.handleClose,
      travellerData = _ref.travellerData,
      editTraveller = _ref.editTraveller,
      updateOrderDetails = _ref.updateOrderDetails;

  var _useState = useState(-1),
      editTravller = _useState[0],
      setEditTraveller = _useState[1];

  var _useState2 = useState(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(false),
      isError = _useState3[0],
      setIsError = _useState3[1];

  var travellers = travellerData.map(function (item, i) {
    var refId = item.refId,
        name = item.name,
        dob = item.dob,
        passport = item.passport,
        gender = item.gender;
    return {
      refId: refId,
      FullName: name,
      Dob: dob,
      Gender: gender,
      PassportNo: passport
    };
  });

  var _useState4 = useState(_toConsumableArray(travellers)),
      travellerDataState = _useState4[0],
      setTravellerDataState = _useState4[1];

  var emptyErrorList = travellerData.map(function () {
    return {
      nameError: "",
      dobError: "",
      passportError: ""
    };
  });

  var _useState5 = useState(_toConsumableArray(emptyErrorList)),
      errorMessages = _useState5[0],
      setErrorMessages = _useState5[1];

  var handleEditTravller = function handleEditTravller(index) {
    setEditTraveller(index);
  };

  var handleServerErrors = function handleServerErrors(error) {
    setIsError(true);

    var _ref2 = (error === null || error === void 0 ? void 0 : error.validationError) || {},
        _ref2$displaySecondar = _ref2.displaySecondaryError,
        displaySecondaryError = _ref2$displaySecondar === void 0 ? [] : _ref2$displaySecondar;

    displaySecondaryError.map(function (item, index) {
      var _item$displayError = item === null || item === void 0 ? void 0 : item.displayError,
          name = _item$displayError.name,
          dob = _item$displayError.dob,
          passport = _item$displayError.passport;

      if (name) {
        var updatedErrorMessages = _toConsumableArray(errorMessages);

        updatedErrorMessages[index].nameError = name;
        setErrorMessages(updatedErrorMessages);
        setEditTraveller(index);
      }

      if (dob) {
        var _updatedErrorMessages = _toConsumableArray(errorMessages);

        _updatedErrorMessages[index].dobError = dob;
        setErrorMessages(_updatedErrorMessages);
        setEditTraveller(index);
      }

      if (passport) {
        var _updatedErrorMessages2 = _toConsumableArray(errorMessages);

        _updatedErrorMessages2[index].passportError = passport;
        setErrorMessages(_updatedErrorMessages2);
        setEditTraveller(index);
      }
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var queryParams, bookingId, partner, response, responseStatus, error, _err$response, _err$response$data, _Error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              queryParams = new URLSearchParams(window.location.search);
              bookingId = queryParams.get("bookingId");
              partner = getPartnerOnClientSide();
              setIsLoading(true);
              _context.next = 7;
              return editInsuranceDetails({
                partner: partner,
                bookingID: bookingId,
                data: travellerDataState
              });

            case 7:
              response = _context.sent;
              responseStatus = response.responseStatus;

              if (!(responseStatus === RESPONSE_STATUS.SUCCESS)) {
                _context.next = 14;
                break;
              }

              _context.next = 12;
              return updateOrderDetails === null || updateOrderDetails === void 0 ? void 0 : updateOrderDetails();

            case 12:
              _context.next = 18;
              break;

            case 14:
              error = response.Error;

              if (error) {
                _context.next = 17;
                break;
              }

              throw new Error("Something went wrong");

            case 17:
              handleServerErrors(error);

            case 18:
              setEditTraveller(-1);
              _context.next = 26;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              console.log("ERROR IN UPDATING TRAVELLER DETAILS----", {
                err: _context.t0
              });
              _err$response$data = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data, _Error = _err$response$data.Error;

              if (_Error && (_Error === null || _Error === void 0 ? void 0 : _Error.code) === ERROR_CODES.DISPLAY_ERROR) {
                handleServerErrors(_Error);
              }

            case 26:
              setIsLoading(false);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 21]]);
    }));

    return function onSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  var onNameChange = function onNameChange(updatedName, index) {
    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].FullName = updatedName;
    setTravellerDataState(updatedTravellerDataState);
    validateName(updatedName, index);
  };

  var validateName = function validateName(updatedName, index) {
    var _editTraveller$travel, _editTraveller$travel2, _editTraveller$travel3;

    var isNameValid = isFieldValid((_editTraveller$travel = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel2 = editTraveller.travellerAttributes) === null || _editTraveller$travel2 === void 0 ? void 0 : (_editTraveller$travel3 = _editTraveller$travel2.name) === null || _editTraveller$travel3 === void 0 ? void 0 : _editTraveller$travel3.regex) !== null && _editTraveller$travel !== void 0 ? _editTraveller$travel : "", updatedName);

    if (!isNameValid) {
      var _editTraveller$travel4, _editTraveller$travel5, _editTraveller$travel6;

      setIsError(true);

      var updatedErrorMessages = _toConsumableArray(errorMessages);

      updatedErrorMessages[index].nameError = (_editTraveller$travel4 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel5 = editTraveller.travellerAttributes) === null || _editTraveller$travel5 === void 0 ? void 0 : (_editTraveller$travel6 = _editTraveller$travel5.name) === null || _editTraveller$travel6 === void 0 ? void 0 : _editTraveller$travel6.errorMessage) !== null && _editTraveller$travel4 !== void 0 ? _editTraveller$travel4 : "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages(_toConsumableArray(emptyErrorList));
    }
  };

  var onPassportChange = function onPassportChange(updatedPassport, index) {
    var _updatedPassport$trim;

    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].PassportNo = updatedPassport === null || updatedPassport === void 0 ? void 0 : (_updatedPassport$trim = updatedPassport.trim) === null || _updatedPassport$trim === void 0 ? void 0 : _updatedPassport$trim.call(updatedPassport);
    setTravellerDataState(updatedTravellerDataState);
    validatePassport(updatedPassport, index);
  };

  var validatePassport = function validatePassport(updatedPassport, index) {
    var _editTraveller$travel7, _editTraveller$travel8, _editTraveller$travel9;

    var isPassportValid = isFieldValid((_editTraveller$travel7 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel8 = editTraveller.travellerAttributes) === null || _editTraveller$travel8 === void 0 ? void 0 : (_editTraveller$travel9 = _editTraveller$travel8.passport) === null || _editTraveller$travel9 === void 0 ? void 0 : _editTraveller$travel9.regex) !== null && _editTraveller$travel7 !== void 0 ? _editTraveller$travel7 : "", updatedPassport);

    if (!isPassportValid) {
      var _editTraveller$travel10, _editTraveller$travel11, _editTraveller$travel12;

      setIsError(true);

      var updatedErrorMessages = _toConsumableArray(errorMessages);

      updatedErrorMessages[index].passportError = (_editTraveller$travel10 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel11 = editTraveller.travellerAttributes) === null || _editTraveller$travel11 === void 0 ? void 0 : (_editTraveller$travel12 = _editTraveller$travel11.passport) === null || _editTraveller$travel12 === void 0 ? void 0 : _editTraveller$travel12.errorMessage) !== null && _editTraveller$travel10 !== void 0 ? _editTraveller$travel10 : "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages(_toConsumableArray(emptyErrorList));
    }
  };

  var onDobChange = function onDobChange(updatedDob, index) {
    var _updatedDob$trim;

    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].Dob = updatedDob === null || updatedDob === void 0 ? void 0 : (_updatedDob$trim = updatedDob.trim) === null || _updatedDob$trim === void 0 ? void 0 : _updatedDob$trim.call(updatedDob);
    setTravellerDataState(updatedTravellerDataState);
    validateDob(updatedDob, index);
  };

  var validateDob = function validateDob(updatedDob, index) {
    var _editTraveller$travel13, _editTraveller$travel14, _editTraveller$travel15;

    var isDobValid = isFieldValid((_editTraveller$travel13 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel14 = editTraveller.travellerAttributes) === null || _editTraveller$travel14 === void 0 ? void 0 : (_editTraveller$travel15 = _editTraveller$travel14.dob) === null || _editTraveller$travel15 === void 0 ? void 0 : _editTraveller$travel15.regex) !== null && _editTraveller$travel13 !== void 0 ? _editTraveller$travel13 : "", formatDate(updatedDob, DATE_FORMATS["DD/MM/YYYY"]));

    if (!isDobValid) {
      var _editTraveller$travel16, _editTraveller$travel17, _editTraveller$travel18;

      setIsError(true);

      var updatedErrorMessages = _toConsumableArray(errorMessages);

      updatedErrorMessages[index].dobError = (_editTraveller$travel16 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel17 = editTraveller.travellerAttributes) === null || _editTraveller$travel17 === void 0 ? void 0 : (_editTraveller$travel18 = _editTraveller$travel17.dob) === null || _editTraveller$travel18 === void 0 ? void 0 : _editTraveller$travel18.errorMessage) !== null && _editTraveller$travel16 !== void 0 ? _editTraveller$travel16 : "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages(_toConsumableArray(emptyErrorList));
    }
  };

  var onGenderChange = function onGenderChange(updatedGender, index) {
    var _updatedGender$trim;

    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].Gender = updatedGender === null || updatedGender === void 0 ? void 0 : (_updatedGender$trim = updatedGender.trim) === null || _updatedGender$trim === void 0 ? void 0 : _updatedGender$trim.call(updatedGender);
    setTravellerDataState(updatedTravellerDataState);
  };

  return /*#__PURE__*/_jsx(ReactPortalComp, {
    children: /*#__PURE__*/_jsxs(EditTravelSheetStyle, {
      children: [/*#__PURE__*/_jsx(LandingHeaderMobile, {
        displayWhiteHeader: true,
        headerTitle: "Edit Traveller Details",
        handleBackBtn: handleClose
      }), travellerDataState === null || travellerDataState === void 0 ? void 0 : travellerDataState.map(function (item, index) {
        var _errorMessages$index, _errorMessages$index2, _editTraveller$travel19, _editTraveller$travel20, _editTraveller$travel21, _errorMessages$index3;

        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs(EditTravllerItem, {
            children: [editTravller != index && /*#__PURE__*/_jsxs(FlexComp, {
              justifyContent: "space-between",
              children: [/*#__PURE__*/_jsxs(FlexComp, {
                gap: "10px",
                children: [/*#__PURE__*/_jsx(TravllerNum, {
                  children: /*#__PURE__*/_jsx(FormattedText, {
                    value: "".concat(index + 1)
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx(ParaTag, {
                    fontWeight: "bold",
                    children: /*#__PURE__*/_jsx(FormattedText, {
                      value: item.FullName
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx(SpanTag, {
                      fontSize: "xs",
                      color: theme.greyText,
                      children: (item === null || item === void 0 ? void 0 : item.Dob) && /*#__PURE__*/_jsx(FormattedText, {
                        value: formatDate(item.Dob, DATE_FORMATS["DD/MM/YYYY"])
                      })
                    }), "\xA0", /*#__PURE__*/_jsx(SpanTag, {
                      fontSize: "xs",
                      color: theme.greyText,
                      children: /*#__PURE__*/_jsx(FormattedText, {
                        value: item.Gender
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsx(AnchorTag, {
                textTransform: "uppercase",
                fontSize: "xs",
                fontWeight: "bold",
                handleClick: function handleClick() {
                  return handleEditTravller(index);
                },
                children: "Edit"
              })]
            }), editTravller == index && /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs(ParaTag, {
                margin: "0 0 18px",
                fontWeight: "bold",
                color: theme.greyText,
                children: ["Traveller ", index + 1]
              }), /*#__PURE__*/_jsx(LandingInput, {
                flex: "1",
                requiredField: true,
                placeholderTxt: "FULL NAME",
                labelTxt: "FULL NAME",
                inputValue: item.FullName,
                errorState: errorMessages === null || errorMessages === void 0 ? void 0 : (_errorMessages$index = errorMessages[index]) === null || _errorMessages$index === void 0 ? void 0 : _errorMessages$index.nameError // disableState={isLoading}
                ,
                handleChange: function handleChange(event) {
                  return onNameChange(event.target.value, index);
                },
                handleBlur: function handleBlur(event) {
                  validateName(event.target.value, index);
                },
                autoComplete: "off",
                margin: "0 0 8px"
              }), /*#__PURE__*/_jsx(LandingInput, {
                flex: "1",
                placeholderTxt: "Date of birth",
                requiredField: true,
                labelTxt: "Date of birth",
                inputType: "date",
                inputValue: item.Dob,
                minValue: EditTravellerSheet_minDate,
                maxValue: EditTravellerSheet_maxDate,
                errorState: errorMessages === null || errorMessages === void 0 ? void 0 : (_errorMessages$index2 = errorMessages[index]) === null || _errorMessages$index2 === void 0 ? void 0 : _errorMessages$index2.dobError // disableState={isLoading}
                ,
                handleChange: function handleChange(event) {
                  onDobChange(event.target.value, index); // saveFormValuesOnBlur();
                },
                handleBlur: function handleBlur(event) {
                  validateDob(event.target.value, index);
                },
                margin: "0 0 8px"
              }), /*#__PURE__*/_jsx(SpanTag, {
                margin: "0 0 8px",
                fontSize: "md",
                fontWeight: "bold",
                color: theme.greyText,
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: "Gender"
                })
              }), /*#__PURE__*/_jsx(FlexComp, {
                gap: "8px",
                margin: "0 0 10px",
                children: editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel19 = editTraveller.travellerAttributes) === null || _editTraveller$travel19 === void 0 ? void 0 : (_editTraveller$travel20 = _editTraveller$travel19.gender) === null || _editTraveller$travel20 === void 0 ? void 0 : (_editTraveller$travel21 = _editTraveller$travel20.values) === null || _editTraveller$travel21 === void 0 ? void 0 : _editTraveller$travel21.map(function (gender) {
                  var _gender$label, _item$Gender, _gender$label2, _item$Gender2, _gender$label3, _item$Gender3;

                  return /*#__PURE__*/_jsx(GenderTypeItem, {
                    selected: ((_gender$label = gender.label) === null || _gender$label === void 0 ? void 0 : _gender$label.toLowerCase()) == ((_item$Gender = item.Gender) === null || _item$Gender === void 0 ? void 0 : _item$Gender.toLowerCase()),
                    onClick: function onClick() {
                      onGenderChange(gender.label, index); // saveFormValuesOnBlur();
                    },
                    children: /*#__PURE__*/_jsx(RadioButton, {
                      activeBtn: ((_gender$label2 = gender.label) === null || _gender$label2 === void 0 ? void 0 : _gender$label2.toLowerCase()) == ((_item$Gender2 = item.Gender) === null || _item$Gender2 === void 0 ? void 0 : _item$Gender2.toLowerCase()),
                      children: /*#__PURE__*/_jsx(SpanTag, {
                        fontSize: "xs",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        color: ((_gender$label3 = gender.label) === null || _gender$label3 === void 0 ? void 0 : _gender$label3.toLowerCase()) == ((_item$Gender3 = item.Gender) === null || _item$Gender3 === void 0 ? void 0 : _item$Gender3.toLowerCase()) ? theme.blueText : theme.greyText,
                        children: gender.label
                      })
                    })
                  }, gender.id);
                })
              }), /*#__PURE__*/_jsx(LandingInput, {
                flex: "1",
                placeholderTxt: "PASSPORT NO.",
                labelTxt: "PASSPORT NO.",
                inputValue: item.PassportNo,
                errorState: errorMessages === null || errorMessages === void 0 ? void 0 : (_errorMessages$index3 = errorMessages[index]) === null || _errorMessages$index3 === void 0 ? void 0 : _errorMessages$index3.passportError // disableState={isLoading}
                ,
                handleChange: function handleChange(event) {
                  onPassportChange(event.target.value, index); // saveFormValuesOnBlur();
                },
                handleBlur: function handleBlur(event) {
                  validatePassport(event.target.value, index);
                }
              })]
            })]
          }, index)
        });
      }), /*#__PURE__*/_jsx(BtnWrap, {
        children: editTravller >= 0 && /*#__PURE__*/_jsx(LandingButton, {
          customTitle: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.updateNowBtnTxt,
          customWidth: "100%",
          onClick: onSubmit,
          isLoading: isLoading,
          disableState: isError
        })
      })]
    })
  });
};

/* harmony default export */ var EditTraveller_EditTravellerSheet = ((/* unused pure expression or super */ null && (EditTravellerSheet)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/PassportNumCompShimmer.tsx





var PassportNumCompShimmer = function PassportNumCompShimmer(_ref) {
  var title = _ref.title,
      info = _ref.info,
      travellerData = _ref.travellerData,
      handleAddPassportModal = _ref.handleAddPassportModal;
  return /*#__PURE__*/_jsxs(PassportNumCompStyle, {
    children: [/*#__PURE__*/_jsxs(PassportHd, {
      children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "100%",
        height: "28px",
        margin: "0 0 8px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "100%",
        height: "18px",
        margin: "0 0 4px"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "315px",
        height: "18px",
        margin: "0 0 4px"
      })]
    }), Array.from({
      length: 5
    }, function (_, index) {
      return /*#__PURE__*/_jsxs(PassportItem, {
        children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
          width: "158px",
          height: "22px"
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "170px",
            height: "18px",
            margin: "0 0 8px"
          }), /*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "258px",
            height: "40px"
          })]
        })]
      }, index);
    })]
  });
};

/* harmony default export */ var PassportNumComp_PassportNumCompShimmer = ((/* unused pure expression or super */ null && (PassportNumCompShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Shimmer/Shimmer.tsx



function Shimmer_Shimmer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      padding = _ref.padding,
      children = _ref.children,
      background = _ref.background;
  return /*#__PURE__*/_jsxs(ShimmerComp, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    background: background,
    children: [" ", children]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.style.ts


var CountryCodeInput_style_InputWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CountryCodeInputstyle__InputWrap",
  componentId: "sc-18gzilo-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:900;font-size:14px;line-height:16px;color:#4a4a4a;display:block;margin-bottom:8px;transition:all 0.3s ease;display:inline-block;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inputWidth;
}, function (p) {
  return p.flex ? p.flex : "";
});
var CountryCodeInput_style_ErrorTxt = (0,styled_components_browser_esm["default"])(SpanTagStyle).withConfig({
  displayName: "CountryCodeInputstyle__ErrorTxt",
  componentId: "sc-18gzilo-1"
})(["color:#eb2026;"]);
var CountryCodeInput_style_LandingInputStyle = styled_components_browser_esm["default"].input.withConfig({
  displayName: "CountryCodeInputstyle__LandingInputStyle",
  componentId: "sc-18gzilo-2"
})(["background:#ffffff;border:1px solid #d2d2d2;border-radius:4px;padding:10px 10px 10px 64px;font-weight:900;font-size:14px;line-height:19px;display:block;&::placeholder{font-weight:400;}&:focus + label{color:#008cff;}", " ", " ", " &:focus{outline:none;border:1px solid #008cff;background:#f9fcff;}&[type=\"number\"]::-webkit-outer-spin-button,&[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type=\"number\"]{-moz-appearance:textfield;}"], function (props) {
  return props.disableState && "\n      opacity: 0.3;\n      pointer-events: none;\n\t";
}, function (props) {
  return props.errorState && "\n      border: 1px solid #EB2026;\n\t";
}, function (props) {
  return props.Verify && "\n      color: #008CFF;\n      background: #F9FCFF;\n      border: 1px solid #008CFF;\n      pointer-events: none;\n\t";
});
var CountryCodeInput_style_CounryCodeWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CountryCodeInputstyle__CounryCodeWrap",
  componentId: "sc-18gzilo-3"
})(["display:flex;align-items:center;gap:8px;position:absolute;left:16px;top:39px;z-index:1;cursor:pointer;&:after{content:\"\";position:absolute;top:5px;right:-13px;border:solid #008cff;border-width:0 2px 2px 0;display:inline-block;padding:3px;transform:rotate(45deg);-webkit-transform:rotate(45deg);}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.tsx







var CountryCodeInput_CountryCodeInput = function CountryCodeInput(_ref) {
  var placeholderTxt = _ref.placeholderTxt,
      labelTxt = _ref.labelTxt,
      disableState = _ref.disableState,
      inputWidth = _ref.inputWidth,
      margin = _ref.margin,
      errorState = _ref.errorState,
      inputValue = _ref.inputValue,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      Verify = _ref.Verify,
      flex = _ref.flex,
      requiredField = _ref.requiredField,
      handleKeyDown = _ref.handleKeyDown,
      maxInputLength = _ref.maxInputLength,
      inputType = _ref.inputType,
      handleCountryCodeModal = _ref.handleCountryCodeModal,
      countryCode = _ref.countryCode,
      countryFlag = _ref.countryFlag,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? "on" : _ref$autoComplete;
  return /*#__PURE__*/_jsxs(InputWrap, {
    margin: margin,
    flex: flex,
    inputWidth: inputWidth,
    Verify: Verify,
    children: [/*#__PURE__*/_jsxs(CounryCodeWrap, {
      onClick: handleCountryCodeModal,
      children: [countryFlag && /*#__PURE__*/_jsx(ImageComponent, {
        src: countryFlag
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "black",
        children: countryCode
      })]
    }), labelTxt && /*#__PURE__*/_jsxs("label", {
      htmlFor: labelTxt,
      children: [labelTxt, requiredField && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        color: theme.redText2,
        children: "*"
      })]
    }), /*#__PURE__*/_jsx(LandingInputStyle, {
      onChange: handleChange,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      value: inputValue,
      errorState: errorState,
      id: labelTxt,
      disableState: disableState,
      placeholder: placeholderTxt,
      maxLength: maxInputLength,
      type: inputType,
      autoComplete: autoComplete
    }), errorState && /*#__PURE__*/_jsx(ErrorTxt, {
      txtfontSize: "xs",
      margin: "4px 0 0",
      color: theme.redText,
      txtfontWeight: "bold",
      children: errorState
    })]
  });
};

/* harmony default export */ var components_CountryCodeInput_CountryCodeInput = ((/* unused pure expression or super */ null && (CountryCodeInput_CountryCodeInput)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryCodeModal.tsx









var SelectCountryCodeModal = function SelectCountryCodeModal(_ref) {
  var countryData = _ref.countryData,
      handleSelectCountry = _ref.handleSelectCountry,
      handleClose = _ref.handleClose;
  var device = useBreakpointV2();
  var windowWidth = window.innerWidth - 60;

  var _useState = useState(countryData),
      countriesData = _useState[0],
      setCountriesData = _useState[1];

  var _useState2 = useState(""),
      searchTxt = _useState2[0],
      setInputValue = _useState2[1];

  var rowHeight = 60;

  var calculateListHeight = function calculateListHeight() {
    var _countriesData$length;

    var rowCount = (_countriesData$length = countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) !== null && _countriesData$length !== void 0 ? _countriesData$length : 0; // Replace with your actual data length

    var height = rowCount * rowHeight;
    return height;
  };

  var countryHandler = function countryHandler(id) {
    if (id) {
      setCountriesData(countryData === null || countryData === void 0 ? void 0 : countryData.map(function (item) {
        if (id === item.id) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      }));
    }
  };

  useEffect(function () {
    if (searchTxt !== null && searchTxt !== void 0 && searchTxt.length) {
      var filteredDataList = searchTxt ? countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (items) {
        var _items$countryName;

        return (_items$countryName = items.countryName) === null || _items$countryName === void 0 ? void 0 : _items$countryName.toLowerCase().includes(searchTxt.toLowerCase());
      }) : countryData;
      setCountriesData(filteredDataList);
    }
  }, [searchTxt]);

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key;
    var item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(CountryItem, {
        onClick: function onClick() {
          return countryHandler(item.id);
        },
        children: /*#__PURE__*/_jsx(RadioButton, {
          handleChange: function handleChange() {
            return countryHandler(item.id);
          },
          activeBtn: item.isSelected,
          children: /*#__PURE__*/_jsxs(FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              alignItems: "center",
              gap: "8px",
              children: [item.countryFlag && /*#__PURE__*/_jsx(ImageComponent, {
                src: item.countryFlag
              }), /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                color: theme.blackText,
                children: item.countryName
              })]
            }), /*#__PURE__*/_jsx(SpanTag, {
              fontWeight: "bold",
              fontSize: "xs",
              color: theme.blackText,
              children: item.countryCode
            })]
          })
        })
      })
    }, key);
  };

  return /*#__PURE__*/_jsxs(CommonModalDweb, {
    handleClick: handleClose,
    customTitle: "Select Country",
    children: [/*#__PURE__*/_jsx(TMFloatingInput, {
      handleChange: function handleChange(e) {
        return setInputValue(e.target.value);
      },
      inputValue: searchTxt,
      labelTxt: "Search Country Name"
    }), (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) > 0 && /*#__PURE__*/_jsxs(CountrySection, {
      children: [/*#__PURE__*/_jsx(SpanTag, {
        fontSize: "sm",
        fontWeight: "bold",
        children: "Country Name"
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "sm",
        fontWeight: "bold",
        children: "Code"
      })]
    }), countriesData && (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) > 0 ? /*#__PURE__*/_jsx(List, {
      width: device === "lg" ? 360 : windowWidth,
      height: calculateListHeight(),
      style: {
        minHeight: calculateListHeight()
      },
      autoHeight: true,
      rowHeight: rowHeight,
      rowCount: countriesData.length,
      rowRenderer: rowRenderer
    }) : /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "sm",
      color: theme.greyText,
      margin: "16px 0 16px",
      children: "No Country Found! Please enter correct name"
    }), (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) != 0 && /*#__PURE__*/_jsx(BtnWrap, {
      children: /*#__PURE__*/_jsx(LandingButton, {
        customWidth: "100%",
        customTitle: "Select",
        onClick: function onClick() {
          return handleSelectCountry(countriesData);
        }
      })
    })]
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryCodeModal = ((/* unused pure expression or super */ null && (SelectCountryCodeModal)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravAssistant/TravAssistant.style.ts


var TravAssistant_style_TravAssistantStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TravAssistantstyle__TravAssistantStyle",
  componentId: "iorioc-0"
})(["border-radius:16px;border:1px solid #e2e2e2;background:#fff;padding:16px;@media ", "{border-radius:0;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravAssistant/TravAssistant.tsx








var TravAssistant = function TravAssistant(_ref) {
  var cardTitle = _ref.cardTitle,
      cardInfo = _ref.cardInfo,
      helpLineNo = _ref.helpLineNo,
      cardIcon = _ref.cardIcon;
  return /*#__PURE__*/_jsxs(TravAssistantStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "8px",
      borderBottom: "1px solid #e2e2e2",
      padding: "0 0 8px",
      margin: "0 0 10px",
      children: [/*#__PURE__*/_jsx(ImageComponent, {
        width: "24px",
        height: "24px",
        src: cardIcon
      }), /*#__PURE__*/_jsxs("div", {
        children: [cardTitle && /*#__PURE__*/_jsx(ParaTag, {
          fontSize: "md",
          fontWeight: "bold",
          color: theme.greenText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: cardTitle
          })
        }), cardInfo && /*#__PURE__*/_jsx(SpanTag, {
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: cardInfo
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      gap: "8px",
      children: [/*#__PURE__*/_jsx(ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Phone_8b0592cec7.svg"
      }), helpLineNo && /*#__PURE__*/_jsx(AnchorTag, {
        fontWeight: "bold",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: helpLineNo
        })
      })]
    })]
  });
};

/* harmony default export */ var TravAssistant_TravAssistant = ((/* unused pure expression or super */ null && (TravAssistant)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/utils/index.js

// Holidays array
var holidays = [{
  date: "2023-03-08",
  name: "Holi"
}, {
  date: "2023-03-30",
  name: "Ram Navami"
}, {
  date: "2023-04-04",
  name: "Mahavir Jayanti"
}, {
  date: "2023-04-07",
  name: "Good Friday"
}, {
  date: "2023-04-22",
  name: "Eid-ul-fitr"
}, {
  date: "2023-05-01",
  name: "Labor Day"
}, {
  date: "2023-05-05",
  name: "Budhha Purnima"
}, {
  date: "2023-07-29",
  name: "Muharram"
}, {
  date: "2023-08-15",
  name: "Independence Day"
}, {
  date: "2023-08-29",
  name: "Onam"
}, {
  date: "2023-08-30",
  name: "Raksha Bandhan"
}, {
  date: "2023-09-07",
  name: "Ganesh Chaturthi"
}, {
  date: "2023-10-02",
  name: "Gandhi Jayanti"
}, {
  date: "2023-10-24",
  name: "Dussehra"
}, {
  date: "2023-10-28",
  name: "Valmiki Jayanti"
}, {
  date: "2023-11-12",
  name: "Diwali"
}, {
  date: "2023-11-27",
  name: "Guru Nanak Jayanti"
}, {
  date: "2023-12-25",
  name: "Christmas"
}, {
  date: "2024-01-01",
  name: "New Year's Day"
}]; // Get all days in a month

function getDaysInMonth(year, month, showHolidays) {
  var daysInMonth = new Date(year, month + 1, 0).getDate();
  var days = [];
  var holidaysCount = 0;

  for (var i = 1; i <= daysInMonth; i++) {
    if (showHolidays) {
      (function () {
        var dateTimestamp = Date.UTC(year, month, i);
        var isHoliday = false;
        var holidayName = "";
        holidays.forEach(function (holiday) {
          var holidayDate = new Date(holiday.date);
          var holidayTimestamp = Date.UTC(holidayDate.getFullYear(), holidayDate.getMonth(), holidayDate.getDate());

          if (dateTimestamp === holidayTimestamp) {
            isHoliday = true;
            holidayName = holiday.name;
            holidaysCount++;
          }
        });
        days.push({
          date: new Date(year, month, i),
          isHoliday: isHoliday,
          holidayName: holidayName
        });
      })();
    } else {
      days.push({
        date: new Date(year, month, i)
      });
    }
  }

  return {
    days: days,
    holidaysCount: holidaysCount
  };
} // Get all calendar data

function utils_getCalendarData(startDate, endDate, showHolidays) {
  var currentDate = startDate ? new Date(startDate) : new Date();
  var lastDate = endDate ? new Date(endDate) : new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
  var monthData = [];

  while (currentDate <= lastDate) {
    var year = currentDate.getFullYear();
    var month = currentDate.getMonth();
    var firstDay = new Date(year, month, 1).getDay();
    var lastDay = new Date(year, month + 1, 0).getDate();
    var daysInMonth = getDaysInMonth(year, month, showHolidays);
    monthData.push({
      month: month,
      year: year,
      daysInMonth: daysInMonth,
      firstDayOfWeek: firstDay
    });
    currentDate.setMonth(month + 1);
    currentDate.setDate(1);
  }

  return monthData;
} // Generate empty cell before start date

function utils_emptyCellBefore(data, daysInMonth) {
  var daysBefore = new Array(data).fill(null).map(function (_, i) {
    return /*#__PURE__*/_jsx("div", {
      className: "empty"
    }, "empty-".concat(i));
  });
  return daysBefore;
} // Generate empty cell after end date

function utils_emptyCellAfter(data, daysInMonth) {
  var emptyDaysAfter = new Array(7 - (utils_emptyCellBefore().length + daysInMonth.days.length) % 7).fill(null).map(function (_, i) {
    return /*#__PURE__*/_jsx("div", {
      className: "empty"
    }, "empty-after-".concat(i));
  });
  return emptyDaysAfter;
}
var utils_formatDate = function formatDate(dateString) {
  var date = new Date(dateString);
  var day = date.getDate();
  var month = date.getMonth() + 1; // Month starts from 0, so we add 1 to get the correct month.

  var year = date.getFullYear() % 100; // Get the last two digits of the year.

  return "".concat(day, "/").concat(month, "/").concat(year);
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.style.ts

var Calendar_style_CalenderWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calendarstyle__CalenderWrap",
  componentId: "qjvs5t-0"
})(["flex:1;overflow-y:auto;padding-bottom:10px;"]);
var Calendar_style_CalenderMonthName = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calendarstyle__CalenderMonthName",
  componentId: "qjvs5t-1"
})(["background-color:#fff;padding:20px 16px;font-size:16px;font-weight:700;color:#4a4a4a;display:flex;align-items:center;"]);
var Calendar_style_CalenderDays = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calendarstyle__CalenderDays",
  componentId: "qjvs5t-2"
})(["display:grid;grid-template-columns:repeat(7,1fr);border-bottom:1px solid #e7e7e7;background-color:#f2f2f2;"]);
var Calendar_style_CalenderDate = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Calendarstyle__CalenderDate",
  componentId: "qjvs5t-3"
})(["border-left:1px solid #e7e7e7;border-top:1px solid #e7e7e7;padding:20px 5px;display:flex;align-items:center;justify-content:center;background-color:#fff;position:relative;", " ", " ", ""], function (p) {
  return p.isSelected && " background-color: #008cff;";
}, function (p) {
  return p.isWithinRange && "background-color: #f0f8ff;";
}, function (p) {
  return p.isDisabled && " pointer-events: none;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.tsx








var Calendar_Calendar = function Calendar(_ref) {
  var handleDayClick = _ref.handleDayClick,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      monthNameType = _ref.monthNameType,
      yearType = _ref.yearType,
      selected = _ref.selected,
      _ref$numberOfMonth = _ref.numberOfMonth,
      numberOfMonth = _ref$numberOfMonth === void 0 ? 13 : _ref$numberOfMonth;
  // const [sDate, setSDate] = useState(startDate);
  // const [eDate, setEDate] = useState(endDate);
  var calendarData = getCalendarData(new Date(), new Date(new Date().setDate(new Date().getDate() + 365 + 180)));
  return /*#__PURE__*/_jsx(CalenderWrap, {
    children: calendarData.map(function (_ref2, index) {
      var month = _ref2.month,
          year = _ref2.year,
          daysInMonth = _ref2.daysInMonth,
          firstDayOfWeek = _ref2.firstDayOfWeek;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(CalenderMonthName, {
          children: [new Date(year, month).toLocaleString("en-us", {
            month: monthNameType
          }), " ", "\xA0", new Date(year, month).toLocaleString("en-us", {
            year: yearType
          })]
        }), /*#__PURE__*/_jsxs(CalenderDays, {
          children: [emptyCellBefore(firstDayOfWeek, daysInMonth), daysInMonth.days.map(function (day) {
            var d = new Date();
            var curDate = d.getDate();
            var curMonth = d.getMonth();
            var curYear = d.getFullYear();
            var isSelected = day.date.getTime() === ((selected === null || selected === void 0 ? void 0 : selected.from) && (selected === null || selected === void 0 ? void 0 : selected.from.getTime())) || day.date.getTime() === ((selected === null || selected === void 0 ? void 0 : selected.to) && (selected === null || selected === void 0 ? void 0 : selected.to.getTime()));
            var isWithinRange = selected && day.date > selected.from && day.date < selected.to;
            var isDisabled = month == curMonth && year == curYear && day.date.getDate() < curDate || day.date > new Date(Date.now() + (365 - 1) * 24 * 60 * 60 * 1000);
            return /*#__PURE__*/_jsx(CalenderDate, {
              isSelected: isSelected,
              isWithinRange: isWithinRange,
              isDisabled: isDisabled,
              onClick: handleDayClick ? function () {
                return handleDayClick(day.date);
              } : function () {},
              children: /*#__PURE__*/_jsx(SpanTag, {
                color: isSelected ? theme.whiteText : isDisabled ? theme.greyText7 : theme.blackText,
                children: day.date.getDate()
              })
            }, "".concat(day));
          }), emptyCellAfter(firstDayOfWeek, daysInMonth)]
        })]
      }, "".concat(index));
    })
  });
};

/* harmony default export */ var components_Calendar_Calendar = ((/* unused pure expression or super */ null && (Calendar_Calendar)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.style.ts

var CalendarFooter_style_CalenderFooterWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFooterWrap",
  componentId: "fnv5ae-0"
})(["background-color:#fff;padding:16px;box-shadow:0 0 6px rgba(0,0,0,0.2);position:relative;"]);
var CalendarFooter_style_CalenderFootRange = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFootRange",
  componentId: "fnv5ae-1"
})(["display:flex;align-items:center;gap:8px;margin-bottom:16px;"]);
var CalendarFooter_style_CalFootRangeCol = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalendarFooterstyle__CalFootRangeCol",
  componentId: "fnv5ae-2"
})(["flex:1;background-color:#f7f7f7;border:1px solid #e7e7e7;border-radius:2px;padding:8px 10px;height:54px;position:relative;", " &:last-child{padding:8px 10px 8px 16px;}"], function (p) {
  return p.selected && "\n        border: 1px solid #008CFF;\n        background: #F9FCFF;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.tsx









var CalendarFooter_CalendarFooter = function CalendarFooter(_ref) {
  var checkinDate = _ref.checkinDate,
      checkoutDate = _ref.checkoutDate,
      onSubmitButtonPress = _ref.onSubmitButtonPress;

  var _useState = useState(0),
      selected = _useState[0],
      setSelected = _useState[1];

  useEffect(function () {
    checkinDate && setSelected(1);
    checkinDate && checkoutDate && setSelected(0);
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/_jsxs(CalenderFooterWrap, {
    children: [/*#__PURE__*/_jsxs(CalenderFootRange, {
      children: [/*#__PURE__*/_jsxs(CalFootRangeCol, {
        selected: selected === 0,
        children: [/*#__PURE__*/_jsx(ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 0 ? theme.blueText : theme.greyText7,
          children: "start date"
        }), /*#__PURE__*/_jsx(ParaTag, {
          fontWeight: "bold",
          children: checkinDate ? formatDate(checkinDate) : "-"
        })]
      }), /*#__PURE__*/_jsxs(CalFootRangeCol, {
        selected: selected === 1,
        children: [/*#__PURE__*/_jsx(ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 1 ? theme.blueText : theme.greyText7,
          children: "end date"
        }), /*#__PURE__*/_jsx(ParaTag, {
          fontWeight: "bold",
          children: checkoutDate ? formatDate(checkoutDate) : "-"
        })]
      })]
    }), /*#__PURE__*/_jsx(LandingButton, {
      customWidth: "100%",
      onClick: onSubmitButtonPress ? function () {
        return onSubmitButtonPress(checkinDate, checkoutDate);
      } : function () {},
      customTitle: "Confirm",
      disableState: !checkinDate || !checkoutDate
    })]
  });
};

/* harmony default export */ var components_CalendarFooter_CalendarFooter = ((/* unused pure expression or super */ null && (CalendarFooter_CalendarFooter)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.style.ts

var CalendarHeader_style_CalenderHeaderWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalendarHeaderstyle__CalenderHeaderWrap",
  componentId: "sc-1hfcczo-0"
})(["background-color:#fff;padding:12px 16px;position:sticky;display:flex;align-items:center;top:0;z-index:6;"]);
var CalendarHeader_style_CalHeaderBackBtn = styled_components_browser_esm["default"].button.withConfig({
  displayName: "CalendarHeaderstyle__CalHeaderBackBtn",
  componentId: "sc-1hfcczo-1"
})(["width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;background:transparent;outline:0;border:0;position:relative;flex-shrink:0;margin-right:15px;&:after{content:\"\";border:solid #000;border-width:0 2px 2px 0;padding:5px;transform:rotate(135deg);position:absolute;left:2;}&:before{width:16px;height:2px;background-color:#000;content:\"\";flex-shrink:0;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.tsx






var CalendarHeader_CalendarHeader = function CalendarHeader(_ref) {
  var checkinDate = _ref.checkinDate,
      checkoutDate = _ref.checkoutDate,
      onBackPress = _ref.onBackPress;

  var _useState = useState("Select Travel Dates"),
      text = _useState[0],
      setText = _useState[1];

  useEffect(function () {
    checkinDate && setText("Select Travel Dates");
    checkinDate && checkoutDate && setText("Select Travel Dates");
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/_jsxs(CalenderHeaderWrap, {
    children: [/*#__PURE__*/_jsx(CalHeaderBackBtn, {
      onClick: onBackPress
    }), /*#__PURE__*/_jsx(SpanTag, {
      fontWeight: "bold",
      fontSize: "md",
      children: text
    })]
  });
};

/* harmony default export */ var components_CalendarHeader_CalendarHeader = ((/* unused pure expression or super */ null && (CalendarHeader_CalendarHeader)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.style.ts

var WeekDays_style_WeekDayWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WeekDaysstyle__WeekDayWrap",
  componentId: "rgj0qq-0"
})(["background-color:#fff;padding:2px 0;position:sticky;top:49px;z-index:1;box-shadow:0 2px 6px rgba(0,0,0,0.2);display:grid;grid-template-columns:repeat(7,1fr);span{font-size:12px;font-weight:400;color:#000;display:flex;align-items:center;justify-content:center;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.tsx

 // import './WeekDays.css';




var WeekDays_WeekDays = function WeekDays(_ref) {
  var top = _ref.top;
  return /*#__PURE__*/_jsxs(WeekDayWrap, {
    style: {
      top: top
    },
    children: [/*#__PURE__*/_jsx("span", {
      children: "Sun"
    }), /*#__PURE__*/_jsx("span", {
      children: "Mon"
    }), /*#__PURE__*/_jsx("span", {
      children: "Tue"
    }), /*#__PURE__*/_jsx("span", {
      children: "Wed"
    }), /*#__PURE__*/_jsx("span", {
      children: "Thu"
    }), /*#__PURE__*/_jsx("span", {
      children: "Fri"
    }), /*#__PURE__*/_jsx("span", {
      children: "Sat"
    })]
  });
};

/* harmony default export */ var components_WeekDays_WeekDays = ((/* unused pure expression or super */ null && (WeekDays_WeekDays)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/styles/styles.style.ts

var calenderAnim = (0,styled_components_browser_esm.keyframes)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var styles_style_RangeDatePickerStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "stylesstyle__RangeDatePickerStyle",
  componentId: "r5aesx-0"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;bottom:-100%;z-index:10;background-color:#fff;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;"], calenderAnim);
var styles_style_ErrorToast = styled_components_browser_esm["default"].div.withConfig({
  displayName: "stylesstyle__ErrorToast",
  componentId: "r5aesx-1"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/RangeDatePicker.tsx











// import './styles/styles.css';
var RangeDatePicker_RangeDatePicker = function RangeDatePicker(_ref) {
  var calendarHeader = _ref.calendarHeader,
      _ref$calendarWeekdays = _ref.calendarWeekdays,
      calendarWeekdays = _ref$calendarWeekdays === void 0 ? true : _ref$calendarWeekdays,
      _ref$monthNameType = _ref.monthNameType,
      monthNameType = _ref$monthNameType === void 0 ? "short" : _ref$monthNameType,
      _ref$yearType = _ref.yearType,
      yearType = _ref$yearType === void 0 ? "numeric" : _ref$yearType,
      calendarFooter = _ref.calendarFooter,
      onBackPress = _ref.onBackPress,
      onSubmitButtonPress = _ref.onSubmitButtonPress,
      range = _ref.range,
      from = _ref.from,
      to = _ref.to,
      showToast = _ref.showToast,
      toastMessage = _ref.toastMessage,
      handleDayClick = _ref.handleDayClick,
      selected = _ref.selected;

  var _useState = useState(from),
      startDate = _useState[0],
      setStartDate = _useState[1];

  var _useState2 = useState(to),
      endDate = _useState2[0],
      setEndDate = _useState2[1];

  return /*#__PURE__*/_jsxs(RangeDatePickerStyle, {
    className: "cal__container",
    children: [calendarHeader && /*#__PURE__*/_jsx(CalendarHeader, {
      checkinDate: startDate,
      checkoutDate: endDate,
      onBackPress: onBackPress
    }), calendarWeekdays && /*#__PURE__*/_jsx(WeekDays, {
      top: calendarHeader ? 49 : 0
    }), /*#__PURE__*/_jsx(Calendar, {
      handleDayClick: handleDayClick,
      startDate: startDate,
      endDate: endDate,
      monthNameType: monthNameType,
      yearType: yearType,
      selected: selected
    }), calendarFooter && /*#__PURE__*/_jsx(CalendarFooter, {
      checkinDate: selected === null || selected === void 0 ? void 0 : selected.from,
      checkoutDate: selected === null || selected === void 0 ? void 0 : selected.to,
      onSubmitButtonPress: onSubmitButtonPress ? function () {
        return onSubmitButtonPress(selected === null || selected === void 0 ? void 0 : selected.from, selected === null || selected === void 0 ? void 0 : selected.to);
      } : function () {}
    }), showToast && /*#__PURE__*/_jsx(ErrorToast, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        color: theme.redText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: toastMessage
        })
      })
    })]
  });
};

/* harmony default export */ var components_RangeDatePicker_RangeDatePicker = ((/* unused pure expression or super */ null && (RangeDatePicker_RangeDatePicker)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterBottomComp/FilterBottomComp.style.ts

var FilterBottomComp_style_FilterBottomCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterBottomCompstyle__FilterBottomCompStyle",
  componentId: "sc-1tibgkx-0"
})(["border-radius:6px;background:rgba(9,18,32,0.95);box-shadow:0px 0px 7px 0px rgba(0,0,0,0.43);position:fixed;bottom:16px;left:16px;right:16px;display:flex;align-items:center;z-index:3;overflow:hidden;max-height:68px;"]);
var FilterBottomComp_style_FilterLeftSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterBottomCompstyle__FilterLeftSection",
  componentId: "sc-1tibgkx-1"
})(["display:flex;gap:6px;overflow-x:scroll;padding:8px;div{border-radius:4px;background:#202e3c;padding:6px;text-align:center;flex:1;}"]);
var FilterBottomComp_style_FilterRightSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterBottomCompstyle__FilterRightSection",
  componentId: "sc-1tibgkx-2"
})(["width:72px;height:68px;flex-shrink:0;background:#008cff;align-self:flex-end;display:flex;flex-direction:column;gap:6px;align-items:center;justify-content:center;margin-left:auto;position:relative;"]);
var FilterBottomComp_style_FilterNumber = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterBottomCompstyle__FilterNumber",
  componentId: "sc-1tibgkx-3"
})(["width:14px;height:14px;border-radius:100%;background:#fff;color:#008cff;text-align:center;font-size:10px;font-weight:700;line-height:14px;position:absolute;top:8px;left:43px;"]);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var css_Global = __webpack_require__(4575);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterBottomComp/FilterBottomComp.tsx







var FilterBottomComp = function FilterBottomComp(_ref) {
  var filtersList = _ref.filtersList,
      handleFilterClick = _ref.handleFilterClick;
  return /*#__PURE__*/_jsxs(FilterBottomCompStyle, {
    children: [/*#__PURE__*/_jsx(FilterLeftSection, {
      children: filtersList === null || filtersList === void 0 ? void 0 : filtersList.map(function (item, index) {
        return /*#__PURE__*/_jsxs("div", {
          children: [item.title && /*#__PURE__*/_jsx(ParaTag, {
            color: theme.whiteText,
            fontWeight: "bold",
            fontSize: "xs",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.title
            })
          }), item.planInfoMob && /*#__PURE__*/_jsxs(SpanTag, {
            color: theme.whiteText,
            fontSize: "xs",
            children: ["(", /*#__PURE__*/_jsx(FormattedText, {
              value: item.planInfoMob
            }), ")"]
          })]
        }, "".concat(index));
      })
    }), /*#__PURE__*/_jsxs(FilterRightSection, {
      onClick: handleFilterClick,
      children: [/*#__PURE__*/_jsx(ImageComponent, {
        width: "28px",
        height: "28px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/filter_Icon_eab36b44ec.svg"
      }), /*#__PURE__*/_jsx(FilterNumber, {
        children: filtersList === null || filtersList === void 0 ? void 0 : filtersList.length
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: theme.whiteText,
        children: "Filter"
      })]
    })]
  });
};

/* harmony default export */ var FilterBottomComp_FilterBottomComp = ((/* unused pure expression or super */ null && (FilterBottomComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DnldPolicyComponent/DnldPolicyComponent.style.ts


var DnldPolicyComponent_style_DnldPolicyComponentStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DnldPolicyComponentstyle__DnldPolicyComponentStyle",
  componentId: "sc-10opecw-0"
})(["border-radius:6px;background:#fff;padding:20px;@media ", "{padding:16px;}"], utils/* deviceType.mobile */.vO.mobile);
var DnldPolicyComponent_style_TravNumber = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DnldPolicyComponentstyle__TravNumber",
  componentId: "sc-10opecw-1"
})(["border-radius:100%;background:#f6f6f6;width:16px;height:16px;font-size:12px;font-weight:700;display:flex;justify-content:center;align-items:center;"]);
var DnldPolicyComponent_style_PolicyItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DnldPolicyComponentstyle__PolicyItem",
  componentId: "sc-10opecw-2"
})(["display:flex;gap:18px;align-items:baseline;padding:12px 16px;border:1px solid #e2e2e2;border-top:none;", ""], function (p) {
  return p.firstChild && "border-top: 1px solid #e2e2e2;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DnldPolicyComponent/DnldPolicyComponent.tsx








var DnldPolicyComponent = function DnldPolicyComponent(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs(DnldPolicyComponentStyle, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "8px",
      alignItems: "center",
      margin: "0 0 24px",
      children: [/*#__PURE__*/_jsx(ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/people_Group_Icon_d97975a5cb.svg"
      }), /*#__PURE__*/_jsxs(SpanTag, {
        fontWeight: "black",
        fontSize: "large",
        color: theme.greyText,
        children: ["Travellers Insured (", data === null || data === void 0 ? void 0 : data.length, ")"]
      })]
    }), data === null || data === void 0 ? void 0 : data.map(function (item, index) {
      var _item$Link;

      return /*#__PURE__*/_jsxs(PolicyItem, {
        firstChild: index == 0,
        children: [/*#__PURE__*/_jsx(TravNumber, {
          children: index + 1
        }), /*#__PURE__*/_jsxs("div", {
          children: [item.Title && /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "md",
            fontWeight: "black",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.Title
            })
          }), /*#__PURE__*/_jsx("div", {
            children: item.Description && /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: theme.greyText7,
              children: /*#__PURE__*/_jsx(FormattedText, {
                value: item.Description
              })
            })
          })]
        }), /*#__PURE__*/_jsx(AnchorTag, {
          margin: "0 0 0 auto",
          textTransform: "uppercase",
          fontWeight: "black",
          hrefProp: item === null || item === void 0 ? void 0 : (_item$Link = item.Link) === null || _item$Link === void 0 ? void 0 : _item$Link.DownloadUrl,
          download: true,
          targetProp: "_blank",
          children: "Download"
        })]
      }, index);
    })]
  });
};

/* harmony default export */ var DnldPolicyComponent_DnldPolicyComponent = ((/* unused pure expression or super */ null && (DnldPolicyComponent)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderListingComp/OrderListingComp.style.ts


var OrderListingComp_style_OrderListingCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderListingCompstyle__OrderListingCompStyle",
  componentId: "sc-1wp0u3b-0"
})(["background:#fff;padding:16px;display:flex;justify-content:space-between;align-items:baseline;gap:16px;border-radius:16px;cursor:pointer;div:last-child{}img{display:inline-block;margin-bottom:auto;}@media ", "{max-height:100%;gap:12px;border-radius:0;}"], utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderListingComp/OrderListingComp.tsx










var OrderListingComp_analytics = getAnalytics();

var OrderListingComp = function OrderListingComp(_ref) {
  var data = _ref.data;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: data === null || data === void 0 ? void 0 : data.map(function (item, index) {
      var icon = item.icon,
          orderDate = item.orderDate,
          bookingId = item.bookingId,
          amount = item.amount,
          insurerName = item.insurerName,
          countries = item.countries,
          currency = item.currency,
          validity = item.validity,
          status = item.status,
          isPassportDetailsAvailable = item.isPassportDetailsAvailable,
          sumInsured = item.sumInsured,
          addPassportCta = item.addPassportCta;
      return /*#__PURE__*/_jsxs(OrderListingCompStyle, {
        onClick: function onClick() {
          OrderListingComp_analytics === null || OrderListingComp_analytics === void 0 ? void 0 : OrderListingComp_analytics.trackOrderSummaryEvents({
            actionType: "order_clicked"
          });
          navigationActions.navigateToOrderDetails({
            bookingId: item.bookingId
          });
        },
        children: [/*#__PURE__*/_jsx(ImageComponent, {
          width: "20px",
          height: "20px",
          src: icon
        }), /*#__PURE__*/_jsxs(FlexComp, {
          gap: "12px",
          flexDirection: "column",
          flex: "1",
          children: [/*#__PURE__*/_jsxs(FlexComp, {
            children: [/*#__PURE__*/_jsxs(FlexComp, {
              flex: "2",
              gap: "8px",
              flexDirection: device == "lg" ? "row" : "column",
              children: [/*#__PURE__*/_jsxs(FlexComp, {
                flex: "1",
                flexDirection: "column",
                gap: "0px",
                children: [insurerName && /*#__PURE__*/_jsx(ParaTag, {
                  fontSize: device == "lg" ? "md" : "sm",
                  fontWeight: "black",
                  children: /*#__PURE__*/_jsx(FormattedText, {
                    value: insurerName
                  })
                }), countries && /*#__PURE__*/_jsx(ParaTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: theme.greyText,
                  children: /*#__PURE__*/_jsx(FormattedText, {
                    value: countries
                  })
                })]
              }), /*#__PURE__*/_jsxs(FlexComp, {
                flex: "1",
                flexDirection: "column",
                gap: "2px",
                children: [sumInsured && /*#__PURE__*/_jsx(ParaTag, {
                  fontSize: device == "lg" ? "md" : "xs",
                  children: /*#__PURE__*/_jsx(FormattedText, {
                    value: sumInsured
                  })
                }), validity && /*#__PURE__*/_jsxs(ParaTag, {
                  fontSize: "xs",
                  color: theme.greyText,
                  children: [/*#__PURE__*/_jsx(FormattedText, {
                    value: validity
                  }), status && /*#__PURE__*/_jsxs(SpanTag, {
                    fontWeight: "black",
                    color: status == "EXPIRED" ? theme.yellowText : theme.greenText,
                    fontSize: "xs",
                    children: ["\xA0 (", status, ")"]
                  })]
                }), bookingId && /*#__PURE__*/_jsxs(ParaTag, {
                  fontSize: "xs",
                  color: theme.greyText,
                  children: ["Order ID: \xA0", /*#__PURE__*/_jsx(FormattedText, {
                    value: bookingId
                  })]
                })]
              })]
            }), /*#__PURE__*/_jsxs(FlexComp, {
              alignItems: "flex-end",
              flexDirection: "column",
              gap: "8px",
              flex: "1",
              children: [amount && /*#__PURE__*/_jsxs(ParaTag, {
                fontSize: "md",
                fontWeight: "black",
                children: [/*#__PURE__*/_jsx(FormattedText, {
                  value: amount
                }), currency && /*#__PURE__*/_jsx(SpanTag, {
                  fontSize: "md",
                  fontWeight: "black",
                  color: theme.greyText,
                  children: /*#__PURE__*/_jsx(FormattedText, {
                    value: currency
                  })
                }), "\xA0"]
              }), orderDate && /*#__PURE__*/_jsx(ParaTag, {
                fontSize: "xs",
                color: theme.greyText,
                margin: device == "sm" ? "auto 0 0" : "",
                children: /*#__PURE__*/_jsx(FormattedText, {
                  value: orderDate
                })
              })]
            }), /*#__PURE__*/_jsx(AnchorTag, {
              margin: "2px 4px 4px",
              children: /*#__PURE__*/_jsx(ImageComponent, {
                width: "12px",
                height: "12px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg"
              })
            })]
          }), isPassportDetailsAvailable && item.bookingId && /*#__PURE__*/_jsx(OrderStatusComp, {
            ctatText: addPassportCta,
            orderStatus: "Pending",
            orderPending: true,
            bookingId: item === null || item === void 0 ? void 0 : item.bookingId
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ var OrderListingComp_OrderListingComp = ((/* unused pure expression or super */ null && (OrderListingComp)));
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var lib_hooks = __webpack_require__(5289);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderBackButton.tsx





var LandingHeaderBackButton = function LandingHeaderBackButton(props) {
  var serverReferrer = (0,lib_hooks/* useReferrerContext */.uO)();
  var handleBackButton = serverReferrer ? function () {
    return navigator_navigationActions.goBack();
  } : function () {
    return history.back();
  };
  var _props$handleBackBtn = props.handleBackBtn,
      handleBackBtn = _props$handleBackBtn === void 0 ? handleBackButton : _props$handleBackBtn,
      displayWhiteHeader = props.displayWhiteHeader;
  return handleBackBtn ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
    handleClick: handleBackBtn,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z",
        fill: "#4A4A4A"
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: {
      width: "24px",
      height: "24px"
    }
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderMobile.tsx











var LandingHeaderMobile_LandingHeaderMobile = function LandingHeaderMobile(_ref) {
  var handleBackBtn = _ref.handleBackBtn,
      headerTitle = _ref.headerTitle,
      children = _ref.children,
      myOrders = _ref.myOrders,
      goToMyOrders = _ref.goToMyOrders,
      displayWhiteHeader = _ref.displayWhiteHeader,
      partnerType = _ref.partnerType,
      insuranceHeader = _ref.insuranceHeader;

  var _useState = (0,react.useState)(0),
      scrollPos = _useState[0],
      setScrollPos = _useState[1];

  var device = (0,ui_widgets_src.useBreakpointV2)();
  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      setScrollPos(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  var blackHeaderStyle = {
    display: scrollPos > 40 ? "none" : "block"
  };
  var whiteHeaderStyle = {
    display: scrollPos > 40 ? "block" : "none"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeaderMobBlack, {
      displayWhiteHeader: displayWhiteHeader,
      id: "blackHeader",
      style: blackHeaderStyle,
      insuranceHeader: insuranceHeader,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        gap: "12px",
        alignItems: "center",
        justifyContent: displayWhiteHeader ? "flex-start" : "space-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderBackButton, {
          handleBackBtn: handleBackBtn
        }), headerTitle && displayWhiteHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
            value: headerTitle
          })
        }), device == "sm" && myOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "75px",
          height: "24px",
          src: partnerType === partner_PARTNER.MMT ? "https://tripmoneycmsimgak.mmtcdn.com/img/Group_46_699159e12c.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/gi_logo_512_6736e70735.png"
        }), myOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          color: css_Global/* theme.blueText */.rS.blueText,
          fontWeight: "bold",
          handleClick: goToMyOrders,
          children: "My Orders"
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeaderMob, {
      id: "whiteHeader",
      style: whiteHeaderStyle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        gap: "12px",
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderBackButton, {
          handleBackBtn: handleBackBtn,
          displayWhiteHeader: true
        }), headerTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
            value: headerTitle
          })
        }), myOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          margin: "0 0 0 auto",
          fontWeight: "bold",
          handleClick: goToMyOrders,
          children: "My Orders"
        })]
      }), children]
    })]
  });
};

/* harmony default export */ var LandingHeader_LandingHeaderMobile = (LandingHeaderMobile_LandingHeaderMobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailMobPriceComp.tsx







var OrderDetailMobPriceComp = function OrderDetailMobPriceComp(_ref) {
  var handlePayment = _ref.handlePayment,
      handleDnldInvoice = _ref.handleDnldInvoice;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(OrderMobAmtWrap, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        gap: "8px",
        children: [/*#__PURE__*/_jsx(ImageComponent, {
          width: "24px",
          height: "24px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/people_Group_Icon_d97975a5cb.svg"
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "sm",
          fontWeight: "bold",
          color: theme.greyText,
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: "Total Price"
          })
        })]
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "sm",
        fontWeight: "bold",
        color: theme.greyText,
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: "₹ 600"
        })
      })]
    }), /*#__PURE__*/_jsxs(OrderMobCtaWrap, {
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        handleClick: handlePayment,
        fontWeight: "bold",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: "View Payment Breakup"
        })
      }), /*#__PURE__*/_jsx(ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg"
      })]
    }), /*#__PURE__*/_jsxs(OrderMobCtaWrap, {
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        handleClick: handleDnldInvoice,
        fontWeight: "bold",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: "Download Invoice"
        })
      }), /*#__PURE__*/_jsx(ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg"
      })]
    })]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailMobPriceComp = ((/* unused pure expression or super */ null && (OrderDetailMobPriceComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderStatusComp/OrderStatusComp.style.ts

var OrderStatusComp_style_OrderStatusCompStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderStatusCompstyle__OrderStatusCompStyle",
  componentId: "sc-1e3p997-0"
})(["display:flex;align-items:center;justify-content:space-between;gap:10px;border-radius:2px;padding:4px 8px;background:", ";"], function (p) {
  return p.pending ? "#FFEDD1" : p.failed ? "#FCDADB" : "#fff";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderStatusComp/OrderStatusComp.tsx









var OrderStatusComp_OrderStatusComp = function OrderStatusComp(_ref) {
  var orderStatus = _ref.orderStatus,
      orderFailed = _ref.orderFailed,
      orderPending = _ref.orderPending,
      ctatText = _ref.ctatText,
      bookingId = _ref.bookingId;
  return /*#__PURE__*/_jsxs(OrderStatusCompStyle, {
    pending: orderPending,
    failed: orderFailed,
    children: [orderStatus && /*#__PURE__*/_jsxs(SpanTag, {
      fontSize: "xs",
      fontWeight: "bold",
      color: orderFailed ? theme.redText : orderPending ? theme.brownText : theme.blackText,
      children: [orderPending && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "regular",
        children: "Documents:"
      }), /*#__PURE__*/_jsx(FormattedText, {
        value: orderStatus
      })]
    }), "\xA0\xA0", /*#__PURE__*/_jsxs(FlexComp, {
      handleClick: function handleClick() {
        return navigationActions.navigateToAddPassport({
          bookingId: bookingId,
          pageId: PASSPORT_DETAILS_PAGE_ID.ORDER_CONFIRMED
        });
      },
      alignItems: "center",
      gap: "4px",
      children: [ctatText && /*#__PURE__*/_jsx(AnchorTag, {
        fontWeight: "bold",
        fontSize: "xs",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: ctatText
        })
      }), /*#__PURE__*/_jsx(ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/right_arrow_4a1f2bfef9.svg"
      })]
    })]
  });
};

/* harmony default export */ var components_OrderStatusComp_OrderStatusComp = ((/* unused pure expression or super */ null && (OrderStatusComp_OrderStatusComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ReactPortalComp.tsx




var ReactPortalComp_ReactPortalComp = function ReactPortalComp(props) {
  var ref = useRef(null);

  var _useState = useState(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  useEffect(function () {
    ref.current = document.querySelector("#portal");
    setMounted(true);
  }, []);
  useEffect(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return mounted && ref.current ? /*#__PURE__*/createPortal( /*#__PURE__*/_jsx("div", {
    children: props.children
  }), ref.current) : null;
};

/* harmony default export */ var components_ReactPortalComp = ((/* unused pure expression or super */ null && (ReactPortalComp_ReactPortalComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDescp.tsx










var TravellerDescp_TravellerDescp = function TravellerDescp(_ref) {
  var _errors$travellerData, _error$name, _error$dob, _error$gender, _name$isRequired, _dob$isRequired;

  var travellerIndex = _ref.travellerIndex,
      genderTypeSelected = _ref.genderTypeSelected,
      secondaryContactData = _ref.secondaryContactData,
      travellerNumber = _ref.travellerNumber,
      handleEditState = _ref.handleEditState;

  var _ref2 = secondaryContactData || {},
      name = _ref2.name,
      dob = _ref2.dob,
      gender = _ref2.gender;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var error = errors === null || errors === void 0 ? void 0 : (_errors$travellerData = errors.travellerData) === null || _errors$travellerData === void 0 ? void 0 : _errors$travellerData[travellerIndex];
  var errorMessage = (error === null || error === void 0 ? void 0 : (_error$name = error.name) === null || _error$name === void 0 ? void 0 : _error$name.message) || (error === null || error === void 0 ? void 0 : (_error$dob = error.dob) === null || _error$dob === void 0 ? void 0 : _error$dob.message) || (error === null || error === void 0 ? void 0 : (_error$gender = error.gender) === null || _error$gender === void 0 ? void 0 : _error$gender.message) || "";
  return /*#__PURE__*/_jsxs(TravellerDescpWrap, {
    children: [/*#__PURE__*/_jsxs(TravellerDescpStyle, {
      children: [/*#__PURE__*/_jsx(TravellerIndexWrap, {
        children: /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          fontWeight: "black",
          color: theme.blackText,
          children: travellerNumber
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [(name === null || name === void 0 ? void 0 : name.isEnabled) && /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "travellerData.".concat(travellerIndex, ".name"),
          rules: {
            required: {
              value: (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true,
              message: getFormFieldErrorMsg("name")
            },
            pattern: {
              value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
              message: getFormFieldErrorMsg("name", name === null || name === void 0 ? void 0 : name.errorMessage)
            }
          },
          render: function render(_ref3) {
            var value = _ref3.field.value;
            return /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              margin: "0 0 2px",
              children: value || "---"
            });
          }
        }), /*#__PURE__*/_jsxs("div", {
          children: [(gender === null || gender === void 0 ? void 0 : gender.isEnabled) && /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: [genderTypeSelected ? genderTypeSelected : "---", ","]
          }), (dob === null || dob === void 0 ? void 0 : dob.isEnabled) && /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".dob"),
            rules: {
              required: {
                value: (_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : true,
                message: getFormFieldErrorMsg("dob")
              },
              validate: function validate(value) {
                return isDobValid(value, dob === null || dob === void 0 ? void 0 : dob.regex) || getFormFieldErrorMsg("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
              }
            },
            render: function render(_ref4) {
              var value = _ref4.field.value;
              return /*#__PURE__*/_jsxs(SpanTag, {
                fontSize: "xs",
                color: theme.greyText,
                children: ["DOB:", " ", formatDate(value, DATE_FORMATS["DD/MM/YYYY"]) || "---"]
              });
            }
          })]
        })]
      }), /*#__PURE__*/_jsx(AnchorTag, {
        margin: "0 0 0 auto",
        fontSize: "xs",
        fontWeight: "black",
        handleClick: handleEditState,
        children: "Edit"
      })]
    }), errorMessage && /*#__PURE__*/_jsx(TravellerDescpError, {
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        color: theme.redText2,
        children: errorMessage
      })
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerDescp = ((/* unused pure expression or super */ null && (TravellerDescp_TravellerDescp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetails.tsx











var TravellerDetails_minDate = subtractYrsFromDate(new Date(), 70).toISOString().split("T")[0];
var TravellerDetails_maxDate = new Date().toISOString().split("T")[0];

var TravellerDetails = function TravellerDetails(_ref) {
  var _errors$travellerData, _name$isRequired, _dob$isRequired, _gender$isRequired;

  var travellerIndex = _ref.travellerIndex,
      travellerRef = _ref.travellerRef,
      isLoading = _ref.isLoading,
      firstErrorIndex = _ref.firstErrorIndex,
      travellerNumber = _ref.travellerNumber,
      genderTypes = _ref.genderTypes,
      handleAddBtn = _ref.handleAddBtn,
      travellerSelected = _ref.travellerSelected,
      editTravellerState = _ref.editTravellerState,
      handleGenderChange = _ref.handleGenderChange,
      selectedGender = _ref.selectedGender,
      saveFormValuesOnBlur = _ref.saveFormValuesOnBlur,
      secondaryContactData = _ref.secondaryContactData;
  var device = useBreakpointV2();

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var error = errors === null || errors === void 0 ? void 0 : (_errors$travellerData = errors.travellerData) === null || _errors$travellerData === void 0 ? void 0 : _errors$travellerData[travellerIndex];

  var _ref2 = secondaryContactData || {},
      name = _ref2.name,
      dob = _ref2.dob,
      gender = _ref2.gender;

  return /*#__PURE__*/_jsxs(TravellerDetailsStyle, {
    ref: travellerIndex === firstErrorIndex ? travellerRef : null,
    children: [!editTravellerState && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(H6Tag, {
          children: travellerNumber
        }), !travellerSelected && /*#__PURE__*/_jsx(LandingButtonWhite, {
          onClick: handleAddBtn,
          customHeight: "32px",
          customTitle: "ADD"
        })]
      }), travellerSelected && /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: device == "lg" ? "row" : "column",
          margin: "16px 0 16px",
          gap: "16px",
          children: [(name === null || name === void 0 ? void 0 : name.isEnabled) && /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".name"),
            rules: {
              required: {
                value: (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true,
                message: getFormFieldErrorMsg("name")
              },
              pattern: {
                value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
                message: getFormFieldErrorMsg("name", name === null || name === void 0 ? void 0 : name.errorMessage)
              }
            },
            render: function render(_ref3) {
              var _error$name;

              var _ref3$field = _ref3.field,
                  value = _ref3$field.value,
                  onChange = _ref3$field.onChange,
                  onBlur = _ref3$field.onBlur;
              return /*#__PURE__*/_jsx(LandingInput, {
                flex: "1",
                requiredField: name === null || name === void 0 ? void 0 : name.isRequired,
                placeholderTxt: name === null || name === void 0 ? void 0 : name.placeholder,
                labelTxt: name === null || name === void 0 ? void 0 : name.title,
                inputValue: value,
                errorState: error === null || error === void 0 ? void 0 : (_error$name = error.name) === null || _error$name === void 0 ? void 0 : _error$name.message,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: function handleBlur() {
                  saveFormValuesOnBlur();
                  onBlur();
                },
                autoComplete: "off",
                inputWidth: "100%"
              });
            }
          }), (dob === null || dob === void 0 ? void 0 : dob.isEnabled) && /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".dob"),
            rules: {
              required: {
                value: (_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : true,
                message: getFormFieldErrorMsg("dob")
              },
              validate: function validate(value) {
                return isDobValid(value, dob === null || dob === void 0 ? void 0 : dob.regex) || getFormFieldErrorMsg("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
              }
            },
            render: function render(_ref4) {
              var _error$dob;

              var _ref4$field = _ref4.field,
                  value = _ref4$field.value,
                  onChange = _ref4$field.onChange,
                  onBlur = _ref4$field.onBlur;
              return /*#__PURE__*/_jsx(LandingInput, {
                flex: "1",
                placeholderTxt: dob === null || dob === void 0 ? void 0 : dob.placeholder,
                requiredField: dob === null || dob === void 0 ? void 0 : dob.isRequired,
                labelTxt: dob === null || dob === void 0 ? void 0 : dob.title,
                inputType: "date",
                inputValue: value,
                minValue: TravellerDetails_minDate,
                maxValue: TravellerDetails_maxDate,
                errorState: error === null || error === void 0 ? void 0 : (_error$dob = error.dob) === null || _error$dob === void 0 ? void 0 : _error$dob.message,
                disableState: isLoading,
                handleChange: function handleChange(event) {
                  onChange(event.target.value);
                  saveFormValuesOnBlur();
                },
                handleBlur: onBlur,
                inputWidth: "100%"
              });
            }
          })]
        }), (gender === null || gender === void 0 ? void 0 : gender.isEnabled) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SpanTag, {
            margin: "0 0 8px",
            fontSize: "md",
            fontWeight: "bold",
            color: theme.greyText,
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: gender === null || gender === void 0 ? void 0 : gender.title
            })
          }), /*#__PURE__*/_jsx(FlexComp, {
            gap: "8px",
            children: /*#__PURE__*/_jsx(Controller, {
              control: control,
              name: "travellerData.".concat(travellerIndex, ".gender"),
              rules: {
                required: {
                  value: (_gender$isRequired = gender === null || gender === void 0 ? void 0 : gender.isRequired) !== null && _gender$isRequired !== void 0 ? _gender$isRequired : true,
                  message: getFormFieldErrorMsg("gender")
                }
              },
              render: function render(_ref5) {
                var value = _ref5.field.value;
                return /*#__PURE__*/_jsx(_Fragment, {
                  children: genderTypes === null || genderTypes === void 0 ? void 0 : genderTypes.map(function (item) {
                    return /*#__PURE__*/_jsx(GenderTypeItem, {
                      selected: item.label === value,
                      onClick: function onClick() {
                        handleGenderChange(item, travellerIndex);
                        saveFormValuesOnBlur();
                      },
                      children: /*#__PURE__*/_jsx(RadioButton, {
                        activeBtn: item.label === value,
                        children: /*#__PURE__*/_jsx(SpanTag, {
                          fontSize: "xs",
                          fontWeight: "bold",
                          color: item.label === value ? theme.blueText : theme.greyText,
                          children: item.label
                        })
                      })
                    }, item.id);
                  })
                });
              }
            })
          })]
        })]
      })]
    }), editTravellerState && /*#__PURE__*/_jsx(TravellerDescp, {
      travellerIndex: travellerIndex,
      travellerNumber: travellerIndex + 1,
      genderTypeSelected: selectedGender,
      secondaryContactData: secondaryContactData,
      handleEditState: handleAddBtn
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerDetails = ((/* unused pure expression or super */ null && (TravellerDetails)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/types/index.ts


var _CASHBACK_TEXT;

var types_CASHBACK_STATUS;

(function (CASHBACK_STATUS) {
  CASHBACK_STATUS["COMMITTED"] = "COMMITTED";
  CASHBACK_STATUS["CANCELLED"] = "CANCELLED";
  CASHBACK_STATUS["CREDITED"] = "CREDITED";
  CASHBACK_STATUS["AVAILABLE"] = "AVAILABLE";
})(types_CASHBACK_STATUS || (types_CASHBACK_STATUS = {}));

var types_CASHBACK_TEXT = (_CASHBACK_TEXT = {}, (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, types_CASHBACK_STATUS.COMMITTED, "Applied"), (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, types_CASHBACK_STATUS.CANCELLED, "Invalid"), (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, types_CASHBACK_STATUS.CREDITED, "Credited"), (0,defineProperty/* default */.Z)(_CASHBACK_TEXT, types_CASHBACK_STATUS.AVAILABLE, "Available"), _CASHBACK_TEXT);
var DASHBOARD_STATUS = {
  DOCUMENT_PENDING: "DOCUMENT_PENDING",
  ORDER_SUBMITTED: "ORDER_SUBMITTED",
  ORDER_CANCELLED: "ORDER_CANCELLED",
  PAYMENT_DECLINED: "PAYMENT_DECLINED",
  DEAL_DONE: "DEAL_DONE"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CashBackComp/CashBackComp.style.ts


var CashBackComp_style_CashBackStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CashBackCompstyle__CashBackStyle",
  componentId: "sc-1ksr0o1-0"
})(["border-radius:4px;padding:8px 12px;display:flex;flex-direction:column;gap:4px;background:", ";& a{flex-shrink:0;}", ""], function (p) {
  return p.cashbackStatus === types_CASHBACK_STATUS.CREDITED ? "#E4FBF4" : p.cashbackStatus === types_CASHBACK_STATUS.CANCELLED ? "#FCDADB" : p.cashbackStatus === types_CASHBACK_STATUS.COMMITTED ? "#E4FBF4" : "#E4FBF4";
}, function (p) {
  return !p.showComp && "\n  display:none;\n  ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Forex/style/Global.style.ts
var Global_style_theme = {
  blackText: "#000",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText2: "#38A97A",
  greenText3: "#137351",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "rgba(74, 74, 74, 0.6)",
  redText: "#960D11",
  redText2: "#EB2026",
  redText3: "#C51217",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  yellowLight: "#FFEDD1",
  darkGreen: "#1E5C43"
};
var fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
var fontSize = {
  sm: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
var lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight22: "22px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CashBackComp/CashBackComp.tsx








var CashBackComp = function CashBackComp(_ref) {
  var cashBackAmt = _ref.cashBackAmt,
      info = _ref.info,
      cashbackStatus = _ref.cashbackStatus,
      statusCta = _ref.statusCta,
      showComp = _ref.showComp;
  return cashBackAmt && cashbackStatus && /*#__PURE__*/_jsxs(CashBackStyle, {
    showComp: showComp,
    cashbackStatus: cashbackStatus,
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "20px",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        flexWrap: "wrap",
        gap: "4px",
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          children: cashBackAmt
        }), /*#__PURE__*/_jsx(SpanTag, {
          color: cashbackStatus === CASHBACK_STATUS.CANCELLED ? theme.redText : theme.darkGreen,
          fontSize: "xs",
          fontWeight: "bold",
          children: cashbackStatus ? CASHBACK_TEXT[cashbackStatus] || "" : ""
        })]
      }), statusCta && /*#__PURE__*/_jsx(AnchorTag, {
        fontSize: "xs",
        fontWeight: "bold",
        children: statusCta
      })]
    }), info && /*#__PURE__*/_jsx(ParaTag, {
      color: theme.greyText,
      fontSize: "xs",
      children: info
    })]
  });
};

/* harmony default export */ var CashBackComp_CashBackComp = ((/* unused pure expression or super */ null && (CashBackComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/StatusTrack/StatusTrack.style.ts


var StatusTrack_style_StatusTrackStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "StatusTrackstyle__StatusTrackStyle",
  componentId: "ppc766-0"
})(["padding:8px 12px;display:flex;align-items:center;gap:8px;justify-content:space-between;margin-bottom:8px;border-radius:16px;border:1px solid #fff;img{width:20px;height:20px;flex-shrink:0;display:inline-block;}background:", ";@media ", "{box-shadow:0px 8px 16px 0px rgba(0,0,0,0.16);}"], function (p) {
  return p.crdStatus === "SUCCESS" ? "#E4FBF4" : p.crdStatus === "CANCELLED" ? "#FCDADB" : p.crdStatus === "UNAVAILABLE" ? "#FFEDD1" : "#EAF5FF";
}, static_utils/* deviceType.desktop */.vO.desktop);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/StatusTrack/StatusTrack.tsx








var StatusTrack_StatusTrack = function StatusTrack(_ref) {
  var statusIcon = _ref.statusIcon,
      statusTitle = _ref.statusTitle,
      statusInfo = _ref.statusInfo,
      statusCta = _ref.statusCta,
      handleClick = _ref.handleClick,
      crdStatus = _ref.crdStatus;
  var device = useBreakpoint();
  return /*#__PURE__*/_jsxs(StatusTrackStyle, {
    crdStatus: crdStatus,
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      gap: "8px",
      children: [statusIcon && /*#__PURE__*/_jsx(ImageTag, {
        src: statusIcon,
        width: "24px",
        height: "24px"
      }), /*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "flex-start",
        gap: "0",
        flexDirection: "column",
        children: [statusTitle && /*#__PURE__*/_jsx(SpanTag, {
          color: crdStatus == "SUCCESS" ? theme.darkGreen : crdStatus == "CANCELLED" ? theme.redText : crdStatus === "UNAVAILABLE" ? theme.brownText : theme.blackText,
          fontSize: device == "lg" ? "md" : "xs",
          fontWeight: "bold",
          children: statusTitle
        }), statusInfo && /*#__PURE__*/_jsx(SpanTag, {
          color: crdStatus == "SUCCESS" ? theme.greyText : crdStatus == "CANCELLED" ? theme.redText : crdStatus === "UNAVAILABLE" ? theme.brownText : theme.blackText,
          fontSize: device == "lg" ? "sm" : "xs",
          children: statusInfo
        })]
      })]
    }), statusCta && /*#__PURE__*/_jsx(AnchorTag, {
      fontSize: "xs",
      fontWeight: "bold",
      handleClick: handleClick,
      children: statusCta
    })]
  });
};

/* harmony default export */ var components_StatusTrack_StatusTrack = ((/* unused pure expression or super */ null && (StatusTrack_StatusTrack)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CurrentTripOrder/CurrentTripOrder.style.ts

var CurrentTripOrder_style_CurrentTripOrderStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CurrentTripOrderstyle__CurrentTripOrderStyle",
  componentId: "sc-1tv7buh-0"
})(["background:#fff;padding:24px 16px;display:flex;flex-direction:column;gap:16px;"]);
var CurrentTripOrder_style_LoadInstantly = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CurrentTripOrderstyle__LoadInstantly",
  componentId: "sc-1tv7buh-1"
})(["border-radius:8px;background:linear-gradient( 93deg,#fff8e1 11.79%,rgba(255,255,255,0.99) 66.72%,rgba(255,255,255,0) 98.34% ),#fff;padding:8px;display:flex;flex-direction:column;gap:10px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CurrentTripOrder/CurrentTripOrder.tsx







var CurrentTripOrder = function CurrentTripOrder(_ref) {
  var pageTitle = _ref.pageTitle,
      pageInfo = _ref.pageInfo,
      loadInstantly = _ref.loadInstantly;

  var _useState = useState(false),
      concent = _useState[0],
      setConcent = _useState[1];

  var handleConcentChange = function handleConcentChange(e) {
    setConcent(e.target.checked);
  };

  return /*#__PURE__*/_jsxs(CurrentTripOrderStyle, {
    children: [/*#__PURE__*/_jsxs(LoadInstantly, {
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        gap: "8px",
        children: [(loadInstantly === null || loadInstantly === void 0 ? void 0 : loadInstantly.icon) && /*#__PURE__*/_jsx(ImageTag, {
          src: loadInstantly === null || loadInstantly === void 0 ? void 0 : loadInstantly.icon
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          dangerousText: loadInstantly === null || loadInstantly === void 0 ? void 0 : loadInstantly.title
        })]
      }), /*#__PURE__*/_jsx(ParaTag, {
        color: theme.greyText,
        fontSize: "xs",
        dangerousText: loadInstantly === null || loadInstantly === void 0 ? void 0 : loadInstantly.desc
      })]
    }), /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "sm",
      fontWeight: "bold",
      children: pageTitle
    }), /*#__PURE__*/_jsx(ParaTag, {
      color: theme.greyText,
      fontSize: "xs",
      dangerousText: pageInfo
    }), /*#__PURE__*/_jsx(CheckButton, {
      inputId: "confirmTnC",
      handleChange: handleConcentChange,
      isChecked: concent,
      children: /*#__PURE__*/_jsxs(ParaTag, {
        color: theme.greyText,
        fontSize: "xs",
        children: ["I agree to all ", /*#__PURE__*/_jsx(AnchorTag, {
          children: "T&C"
        }), " including that my travel purpose is ", /*#__PURE__*/_jsx("b", {
          children: "Leisure/Medical/Education"
        })]
      })
    })]
  });
};

/* harmony default export */ var CurrentTripOrder_CurrentTripOrder = ((/* unused pure expression or super */ null && (CurrentTripOrder)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddOrSelectTicket/utils.ts
var utils_DOCUMENTS_TYPE = {
  passFP: "passFP",
  passLP: "passLP",
  ticket: "ticket",
  panCard: "panCard",
  visa: "visa",
  itrBankStatement: "itrBankStatement",
  opt_ticket: "opt_ticket"
};
var utils_AddOrSelectDocData = {
  heading: "Select or Upload Ticket",
  subHeading: "Displaying air tickets booked on MakeMyTrip with travel date within next 60 days. Select maximum of 2 air tickets.",
  toastMsg: "To add another ticket, please remove or edit any existing uploaded ticket",
  toastMsg2: "Select your ticket to view details"
};
var utils_GoIbibo = "gi";
var utils_openOutsideUriGi = function openOutsideUriGi(link) {
  if (!link) {
    return;
  } // 744 for opening outside the webview
  // 710 for opening inside the webview (this needs to be tested)


  var obj = {
    tg: "744",
    gd: {
      url: link
    }
  };
  window.webkit.messageHandlers.openNativePage.postMessage(obj);
};
var utils_getRedirectionUrl = function getRedirectionUrl(url) {
  var suffix = "";
  var OPEN_OUTSIDE = "open=outside";

  if ((url === null || url === void 0 ? void 0 : url.indexOf("".concat(OPEN_OUTSIDE))) > -1) {
    suffix = "";
  } else if ((url === null || url === void 0 ? void 0 : url.indexOf("?")) > -1) {
    suffix = "&".concat(OPEN_OUTSIDE);
  } else {
    suffix = "?".concat(OPEN_OUTSIDE);
  }

  return "".concat(url).concat(suffix);
};
var utils_getDocNameBasedOnType = function getDocNameBasedOnType(doc) {
  if ((doc === null || doc === void 0 ? void 0 : doc.type) === utils_DOCUMENTS_TYPE.ticket) {
    return "Air Ticket 1";
  } else if ((doc === null || doc === void 0 ? void 0 : doc.type) === utils_DOCUMENTS_TYPE.opt_ticket) {
    return "Air Ticket 2";
  }

  return doc === null || doc === void 0 ? void 0 : doc.desc;
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/Warning.svg
/* harmony default export */ var icons_Warning = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/Warning.b2415b0b.svg","height":24,"width":24});
// EXTERNAL MODULE: ../../libs/auth/src/lib/constants/index.ts
var lib_constants = __webpack_require__(4823);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddOrSelectTicket/AddOrSelectTicket.style.ts

var AddOrSelectTicket_style_FlightInfoWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddOrSelectTicketstyle__FlightInfoWpr",
  componentId: "aojz38-0"
})(["padding:12px;background-color:#ffffff;border-radius:8px;margin-bottom:21px;position:relative;"]);
var ButtonWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddOrSelectTicketstyle__ButtonWpr",
  componentId: "aojz38-1"
})(["padding:8px 30px 24px;background-color:#f6f6f6;margin:0 -30px -30px;position:fixed;bottom:24px;left:30px;width:100%;z-index:999;"]);
var AddOrSelectTicket_style_ImageWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddOrSelectTicketstyle__ImageWpr",
  componentId: "aojz38-2"
})(["display:flex;align-items:center;"]);
var AddOrSelectTicket_style_UploadWpr = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddOrSelectTicketstyle__UploadWpr",
  componentId: "aojz38-3"
})(["background:#fff;border-radius:12px;margin-bottom:40px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/Swap.svg
/* harmony default export */ var icons_Swap = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/Swap.e7dd35af.svg","height":11,"width":14});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ArrowRight.svg
/* harmony default export */ var static_icons_ArrowRight = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/ArrowRight.a54241c0.svg","height":7,"width":14});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddOrSelectTicket/FlightInfo.tsx












var FlightInfo_FlightInfo = function FlightInfo(_ref) {
  var ticket = _ref.ticket,
      disabledText = _ref.disabledText,
      _ref$onSelectClick = _ref.onSelectClick,
      onSelectClick = _ref$onSelectClick === void 0 ? function () {} : _ref$onSelectClick,
      selectedTicketCount = _ref.selectedTicketCount;
  var device = useBreakpoint();

  var _useState = useState(false),
      showToast = _useState[0],
      setShowToast = _useState[1];

  return /*#__PURE__*/_jsxs(FlightInfoWpr, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      margin: "0 0 4px 0",
      children: [/*#__PURE__*/_jsxs(FlexComp, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontSize: "sm",
          fontWeight: "bold",
          children: ticket === null || ticket === void 0 ? void 0 : ticket.from
        }), /*#__PURE__*/_jsx(ImageTag, {
          width: "14px",
          height: "11px",
          src: ticket !== null && ticket !== void 0 && ticket.isRoundTrip ? Swap.src : ArrowRight.src,
          margin: "0 4px 0"
        }), /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "sm",
          fontWeight: "bold",
          children: ticket === null || ticket === void 0 ? void 0 : ticket.to
        }), (ticket === null || ticket === void 0 ? void 0 : ticket.viaCities) && /*#__PURE__*/_jsxs(SpanTag, {
          color: theme.greyText,
          children: ["\xA0via\xA0", ticket === null || ticket === void 0 ? void 0 : ticket.viaCities]
        })]
      }), ticket !== null && ticket !== void 0 && ticket.isLoading ? /*#__PURE__*/_jsx(Spinner, {
        customStyle: {
          margin: 0
        }
      }) : /*#__PURE__*/_jsx(AnchorTag, {
        fontWeight: "bold",
        fontSize: "xs",
        handleClick: function handleClick() {
          return onSelectClick(ticket === null || ticket === void 0 ? void 0 : ticket.id);
        },
        color: disabledText ? "rgba(0, 0, 0, 0.3)" : "",
        children: "SELECT"
      })]
    }), /*#__PURE__*/_jsx(ParaTag, {
      color: theme.greyText,
      fontSize: "xs",
      margin: "0 0 4px 0",
      children: ticket === null || ticket === void 0 ? void 0 : ticket.time
    }), /*#__PURE__*/_jsx(AnchorTag, {
      color: theme.greyText,
      fontSize: "xs",
      handleClick: function handleClick() {
        return setShowToast(true);
      },
      style: {
        textDecoration: "underline"
      },
      children: ticket === null || ticket === void 0 ? void 0 : ticket.fileName
    }), (ticket === null || ticket === void 0 ? void 0 : ticket.showTooltip) && !disabledText && selectedTicketCount > 0 && /*#__PURE__*/_jsx(ToolTip, {
      closeTooltip: function closeTooltip() {},
      arrowPosition: "90%",
      style: {
        width: "307px",
        borderRadius: "12px",
        padding: "4px 8px",
        right: 0,
        zIndex: 1,
        marginTop: "3px"
      },
      arrowDirection: "up",
      bgColor: theme.greenText3,
      children: /*#__PURE__*/_jsx(ParaTag, {
        color: theme.whiteText,
        fontWeight: "regular",
        children: ticket === null || ticket === void 0 ? void 0 : ticket.tooltipMsg
      })
    }), showToast && /*#__PURE__*/_jsx(Toast, {
      planSelectedTxt: AddOrSelectDocData.toastMsg2,
      toastIcon: Warning.src,
      onTimerEnd: function onTimerEnd() {
        return setShowToast(false);
      }
    })]
  });
};

/* harmony default export */ var AddOrSelectTicket_FlightInfo = ((/* unused pure expression or super */ null && (FlightInfo_FlightInfo)));
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Forex/TextStylesForex/TextStyles.style.ts
var TextStyles_style = __webpack_require__(6291);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Forex/TextStylesForex/AnchorTag.tsx




var TextStylesForex_AnchorTag_AnchorTag = function AnchorTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      color = _ref.color,
      handleClick = _ref.handleClick,
      hrefProp = _ref.hrefProp,
      textAlign = _ref.textAlign,
      margin = _ref.margin,
      target = _ref.target,
      flexShrink = _ref.flexShrink,
      id = _ref.id;
  return /*#__PURE__*/_jsx(AnchorTagStyle, {
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    onClick: handleClick,
    href: hrefProp,
    margin: margin,
    target: target,
    flexShrink: flexShrink,
    id: id,
    children: children
  });
};

/* harmony default export */ var TextStylesForex_AnchorTag = ((/* unused pure expression or super */ null && (TextStylesForex_AnchorTag_AnchorTag)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/RightTick.svg
/* harmony default export */ var icons_RightTick = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/RightTick.cf1fad1e.svg","height":16,"width":16});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/Close.svg
/* harmony default export */ var icons_Close = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/Close.fab64928.svg","height":20,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/images/PreviewEyeSvg.tsx



var PreviewEyeSvg = function PreviewEyeSvg() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      "clip-path": "url(#clip0_625_7721)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.0667 5C6.4 5 3.26867 7.28067 2 10.5C3.26867 13.7193 6.4 16 10.0667 16C13.7333 16 16.8647 13.7193 18.1333 10.5C16.8647 7.28067 13.7333 5 10.0667 5ZM10.0667 14.1667C8.04267 14.1667 6.4 12.524 6.4 10.5C6.4 8.476 8.04267 6.83333 10.0667 6.83333C12.0907 6.83333 13.7333 8.476 13.7333 10.5C13.7333 12.524 12.0907 14.1667 10.0667 14.1667ZM10.0667 8.3C8.84933 8.3 7.86667 9.28267 7.86667 10.5C7.86667 11.7173 8.84933 12.7 10.0667 12.7C11.284 12.7 12.2667 11.7173 12.2667 10.5C12.2667 9.28267 11.284 8.3 10.0667 8.3Z",
        fill: "#757575"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_625_7721",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })]
  });
};

/* harmony default export */ var images_PreviewEyeSvg = (PreviewEyeSvg);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Forex/Icon/PreviewEye.tsx


var PreviewEye_PreviewEye = (0,styled_components_browser_esm["default"])(images_PreviewEyeSvg).withConfig({
  displayName: "PreviewEye",
  componentId: "sc-12m95q1-0"
})(["width:", ";height:", ";margin:", ";flex-shrink:0;cursor:pointer;"], function (props) {
  return props.width || "";
}, function (props) {
  return props.height || "";
}, function (props) {
  return props.margin;
});
/* harmony default export */ var Icon_PreviewEye = ((/* unused pure expression or super */ null && (PreviewEye_PreviewEye)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddOrSelectTicket/SelectedFile.tsx










var SelectedFile_SelectedFile = function SelectedFile(_ref) {
  var id = _ref.id,
      fileName = _ref.fileName,
      _ref$onCloseClick = _ref.onCloseClick,
      onCloseClick = _ref$onCloseClick === void 0 ? function () {} : _ref$onCloseClick,
      documentLink = _ref.documentLink,
      handlePreiewEyeClick = _ref.handlePreiewEyeClick,
      ticketData = _ref.ticketData;
  return /*#__PURE__*/_jsxs(FlexComp, {
    padding: "12px",
    bgColor: theme.blueText2,
    borderRadius: "12px",
    margin: "0 0 8px 0",
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: "row",
      alignItems: "center",
      padding: "0",
      margin: "0",
      children: [/*#__PURE__*/_jsx(ImageTag, {
        width: "16px",
        height: "16px",
        src: RightTick.src,
        margin: "0 8px 0 0"
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        children: fileName
      })]
    }), /*#__PURE__*/_jsxs(FlexComp, {
      flexDirection: "row",
      alignItems: "center",
      padding: "0",
      margin: "0",
      children: [/*#__PURE__*/_jsx(AnchorTag, {
        hrefProp: documentLink(ticketData),
        target: "_blank",
        handleClick: handlePreiewEyeClick(ticketData),
        children: /*#__PURE__*/_jsx(PreviewEye, {})
      }), /*#__PURE__*/_jsx(ImageWpr, {
        onClick: function onClick() {
          return onCloseClick(id);
        },
        children: /*#__PURE__*/_jsx(ImageTag, {
          width: "20px",
          height: "20px",
          src: Close.src,
          margin: "0 0 0 20px"
        })
      })]
    })]
  });
};

/* harmony default export */ var AddOrSelectTicket_SelectedFile = ((/* unused pure expression or super */ null && (SelectedFile_SelectedFile)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddOrSelectTicket/UploadTicketImage.tsx


function UploadTicketImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UploadTicketImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UploadTicketImage_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UploadTicketImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var UploadTicketImage_UploadTicketImage = function UploadTicketImage(_ref) {
  var onUploadClick = _ref.onUploadClick,
      disabledText = _ref.disabledText,
      onError = _ref.onError,
      documentLink = _ref.documentLink,
      handlePreiewEyeClick = _ref.handlePreiewEyeClick,
      handleDisabledText = _ref.handleDisabledText,
      ticketsData = _ref.ticketsData,
      onEditClick = _ref.onEditClick,
      renderUploadImage = _ref.renderUploadImage;

  var _useState = useState(ticketsData || []),
      ticketListState = _useState[0],
      setTicketListState = _useState[1];

  var _useState2 = useState(""),
      error = _useState2[0],
      setError = _useState2[1];

  useEffect(function () {
    if (ticketsData !== null && ticketsData !== void 0 && ticketsData.length) {
      var tickets = ticketsData.sort(function (a, b) {
        if ((a === null || a === void 0 ? void 0 : a.type) === DOCUMENTS_TYPE.ticket) return -1;
        if ((b === null || b === void 0 ? void 0 : b.type) === DOCUMENTS_TYPE.ticket) return 1;
        return 0;
      }).map(function (item) {
        return UploadTicketImage_objectSpread(UploadTicketImage_objectSpread({}, item), {}, {
          document_name: (item === null || item === void 0 ? void 0 : item.document_name) || getDocNameBasedOnType(item)
        });
      });
      setTicketListState(tickets);
    }
  }, [ticketsData]);

  var getUnUploadedTicketData = function getUnUploadedTicketData() {
    var unUploadedTickets = ticketListState === null || ticketListState === void 0 ? void 0 : ticketListState.filter(function (ticket) {
      return !(ticket !== null && ticket !== void 0 && ticket.url);
    });
    return unUploadedTickets[0];
  };

  return /*#__PURE__*/_jsxs(UploadWpr, {
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      padding: "12px",
      borderRadius: "12px",
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(ParaTag, {
        color: theme.greyText,
        fontSize: "xs",
        fontWeight: "bold",
        children: "Add Ticket from Device"
      }), /*#__PURE__*/_jsx(FlexComp, {
        alignItems: "center",
        justifyContent: "end",
        gap: "20px",
        children: !disabledText && renderUploadImage ? renderUploadImage({
          isEdit: false,
          docData: getUnUploadedTicketData(),
          onError: function onError(msg) {
            return setError(msg);
          },
          onUpload: function onUpload(response) {
            return onUploadClick(response);
          },
          documentsList: ticketListState
        }) : /*#__PURE__*/_jsx(AnchorTag, {
          fontWeight: "bold",
          fontSize: "xs",
          color: "rgba(0, 0, 0, 0.3)",
          handleClick: handleDisabledText,
          children: "UPLOAD"
        })
      })]
    }), ticketListState && ticketListState.map(function (ticketUploaded, index) {
      return (ticketUploaded === null || ticketUploaded === void 0 ? void 0 : ticketUploaded.url) && (ticketUploaded === null || ticketUploaded === void 0 ? void 0 : ticketUploaded.isUploaded) && /*#__PURE__*/_jsxs(FlexComp, {
        padding: "0 12px 12px",
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "row",
          alignItems: "center",
          padding: "0",
          margin: "0",
          children: [/*#__PURE__*/_jsx(ImageTag, {
            width: "16px",
            height: "16px",
            src: RightTick.src,
            margin: "0 8px 0 0"
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            children: ticketUploaded === null || ticketUploaded === void 0 ? void 0 : ticketUploaded.document_name
          })]
        }), /*#__PURE__*/_jsxs(FlexComp, {
          alignItems: "center",
          justifyContent: "end",
          gap: "10px",
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(AnchorTag, {
              hrefProp: documentLink(ticketUploaded),
              target: "_blank",
              handleClick: handlePreiewEyeClick(ticketUploaded),
              children: /*#__PURE__*/_jsx(PreviewEye, {})
            })
          }), renderUploadImage && renderUploadImage({
            isEdit: true,
            docData: ticketUploaded,
            onError: function onError(msg) {
              return setError(msg);
            },
            onUpload: function onUpload(response) {
              return onEditClick(response);
            },
            documentsList: ticketListState
          })]
        })]
      }, index);
    }), error && /*#__PURE__*/_jsx(FlexComp, {
      justifyContent: "end",
      padding: "12px",
      borderRadius: "12px",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xxs",
        color: theme === null || theme === void 0 ? void 0 : theme.redText,
        children: error
      })
    })]
  });
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/LandingButton/LandingButton.tsx + 1 modules
var ui_container_LandingButton_LandingButton = __webpack_require__(1893);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddOrSelectTicket/AddOrSelectTicket.tsx

















var AddOrSelectTicket = function AddOrSelectTicket(_ref) {
  var onClose = _ref.onClose,
      onSubmitClick = _ref.onSubmitClick,
      selectedTicketCount = _ref.selectedTicketCount,
      ticketData = _ref.ticketData,
      partner = _ref.partner,
      prefetchedTickets = _ref.prefetchedTickets,
      onRemoveImage = _ref.onRemoveImage,
      onTicketSelect = _ref.onTicketSelect,
      _onUploadClick = _ref.onUploadClick,
      onEditClick = _ref.onEditClick,
      handleDisabledTextClick = _ref.handleDisabledTextClick,
      showToast = _ref.showToast,
      setShowToast = _ref.setShowToast,
      renderUploadImage = _ref.renderUploadImage;
  var device = useBreakpoint();

  var _useState = useState(false),
      showingMoreItems = _useState[0],
      setShowingMoreItems = _useState[1];

  var documentLink = function documentLink(item) {
    var _getMobileOperatingSy;

    var url = getRedirectionUrl((item === null || item === void 0 ? void 0 : item.absolute_url) || (item === null || item === void 0 ? void 0 : item.url));
    return partner === GoIbibo && ((_getMobileOperatingSy = getMobileOperatingSystem()) === null || _getMobileOperatingSy === void 0 ? void 0 : _getMobileOperatingSy.toLowerCase()) === IOS ? "" : url;
  };

  var handlePreiewEyeClick = function handlePreiewEyeClick(item) {
    var _getMobileOperatingSy2;

    var url = (item === null || item === void 0 ? void 0 : item.absolute_url) || (item === null || item === void 0 ? void 0 : item.url);
    return partner === GoIbibo && ((_getMobileOperatingSy2 = getMobileOperatingSystem()) === null || _getMobileOperatingSy2 === void 0 ? void 0 : _getMobileOperatingSy2.toLowerCase()) === IOS ? openOutsideUriGi(url) : null;
  };

  var upcomingTripTickets = prefetchedTickets === null || prefetchedTickets === void 0 ? void 0 : prefetchedTickets.slice(0, showingMoreItems ? prefetchedTickets === null || prefetchedTickets === void 0 ? void 0 : prefetchedTickets.length : 2);
  return /*#__PURE__*/_jsxs(Modal, {
    onModalClose: onClose,
    modalType: device === "lg" ? "centered" : "bottomSheet",
    modalHeading: AddOrSelectDocData.heading,
    closeButton: /*#__PURE__*/_jsx(CloseIcon, {}),
    modalHeadingCtrMargin: "0 0 20px 0",
    children: [/*#__PURE__*/_jsx(ParaTag, {
      color: theme.greyText,
      margin: "0 0 20px 0",
      children: AddOrSelectDocData.subHeading
    }), upcomingTripTickets.map(function (upcomingTripTicket) {
      return /*#__PURE__*/_jsx("div", {
        children: upcomingTripTicket !== null && upcomingTripTicket !== void 0 && upcomingTripTicket.isSelected ? /*#__PURE__*/_jsx(SelectedFile, {
          id: upcomingTripTicket === null || upcomingTripTicket === void 0 ? void 0 : upcomingTripTicket.id,
          fileName: upcomingTripTicket === null || upcomingTripTicket === void 0 ? void 0 : upcomingTripTicket.fileName,
          onCloseClick: function onCloseClick(id) {
            return onRemoveImage(id);
          },
          handlePreiewEyeClick: handlePreiewEyeClick,
          documentLink: documentLink,
          ticketData: upcomingTripTicket
        }) : /*#__PURE__*/_jsx(FlightInfo, {
          ticket: upcomingTripTicket,
          disabledText: selectedTicketCount === 2,
          onSelectClick: function onSelectClick(id) {
            return onTicketSelect(id);
          },
          selectedTicketCount: selectedTicketCount
        })
      }, upcomingTripTicket === null || upcomingTripTicket === void 0 ? void 0 : upcomingTripTicket.id);
    }), (prefetchedTickets === null || prefetchedTickets === void 0 ? void 0 : prefetchedTickets.length) > 2 && /*#__PURE__*/_jsx(AnchorTag, {
      fontWeight: "bold",
      fontSize: "xs",
      handleClick: function handleClick() {
        return setShowingMoreItems(!showingMoreItems);
      },
      children: showingMoreItems ? "VIEW LESS" : "VIEW MORE"
    }), /*#__PURE__*/_jsx(ParaTag, {
      color: theme.greyText6,
      fontSize: "xs",
      textAlign: "center",
      margin: "30px 0px 20px",
      children: "-OR-"
    }), /*#__PURE__*/_jsx(UploadTicketImage, {
      disabledText: selectedTicketCount === 2,
      onUploadClick: function onUploadClick(response) {
        return _onUploadClick(response);
      },
      handlePreiewEyeClick: handlePreiewEyeClick,
      documentLink: documentLink,
      handleDisabledText: handleDisabledTextClick,
      ticketsData: ticketData,
      onEditClick: onEditClick,
      renderUploadImage: renderUploadImage
    }), /*#__PURE__*/_jsx(LandingButton, {
      customTitle: "SUBMIT DOCUMENTS",
      handleClick: onSubmitClick,
      customWidth: "100%",
      disableState: selectedTicketCount == 0
    }), showToast && /*#__PURE__*/_jsx(Toast, {
      planSelectedTxt: AddOrSelectDocData.toastMsg,
      toastIcon: Warning.src,
      onTimerEnd: function onTimerEnd() {
        return setShowToast(false);
      }
    })]
  });
};

/* harmony default export */ var AddOrSelectTicket_AddOrSelectTicket = ((/* unused pure expression or super */ null && (AddOrSelectTicket)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/deliveryInProgressNew.svg
/* harmony default export */ var deliveryInProgressNew = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/deliveryInProgressNew.6faed5c8.svg","height":20,"width":18});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/orderUnavaiable.svg
/* harmony default export */ var orderUnavaiable = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/orderUnavaiable.c2eab3a5.svg","height":24,"width":24});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/orderCancelled.svg
/* harmony default export */ var orderCancelled = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/orderCancelled.0e762d41.svg","height":24,"width":24});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/orderSuccess.svg
/* harmony default export */ var orderSuccess = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/orderSuccess.e99c5624.svg","height":24,"width":24});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/StatusTrack/StatusTrackContainer.tsx


function StatusTrackContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StatusTrackContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StatusTrackContainer_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StatusTrackContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









function getIcon(type) {
  switch (type) {
    case "delivery-in-progress":
      return DeliveryInProgressIconSvg.src;

    case "order-unavailable":
      return OrderUnavailable.src;

    case "order-cancelled":
      return OrderCancelled.src;

    case "order-success":
      return OrderSuccess.src;

    case "activation-done":
      return "https://tripmoneycmsimgak.mmtcdn.com/img/green_Oval_8ec7190974.svg";

    default:
      return null;
  }
}

function StatusTrackContainer(props) {
  var icon = getIcon(props.type);

  if (!icon) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx(StatusTrack, StatusTrackContainer_objectSpread(StatusTrackContainer_objectSpread({}, props), {}, {
    statusIcon: icon
  }));
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CashBackAvailableComp/CashBackAvailableComp.style.ts


var CashBackAvailableComp_style_CashBackAvailStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CashBackAvailableCompstyle__CashBackAvailStyle",
  componentId: "vt6hje-0"
})(["background:", ";margin-top:8px;padding:", ";border-radius:4px;display:flex;flex-direction:column;gap:5px;"], function (props) {
  return props.background || Global/* theme.greenText2 */.rS.greenText2;
}, function (props) {
  return props.padding || "8px";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CashBackAvailableComp/CashBackAvailableComp.tsx








var CashBackAvailableComp = function CashBackAvailableComp(_ref) {
  var _ref$descTxt = _ref.descTxt,
      descTxt = _ref$descTxt === void 0 ? "" : _ref$descTxt,
      cashBackIcon = _ref.cashBackIcon,
      title = _ref.title,
      isBlackTitle = _ref.isBlackTitle,
      status = _ref.status,
      couponCashback = _ref.couponCashback;
  if (!couponCashback) return null;
  return /*#__PURE__*/_jsxs(CashBackAvailStyle, {
    style: (descTxt === null || descTxt === void 0 ? void 0 : descTxt.length) === 0 ? {
      background: "transparent",
      padding: "0px"
    } : undefined,
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "2px",
      children: [cashBackIcon && [CASHBACK_STATUS.COMMITTED, CASHBACK_STATUS.AVAILABLE, CASHBACK_STATUS.CREDITED].includes(status) && /*#__PURE__*/_jsx(ImageTag, {
        width: "16px",
        height: "16px",
        src: cashBackIcon
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "black",
        color: isBlackTitle ? theme.blackText : theme.greenText,
        children: title
      })]
    }), descTxt && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "xs",
      color: theme.greyText6,
      dangerousText: descTxt
    })]
  });
};

/* harmony default export */ var CashBackAvailableComp_CashBackAvailableComp = ((/* unused pure expression or super */ null && (CashBackAvailableComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/index.tsx


































































 //export { default as LandingFooter } from './LandingFooter/LandingFooter';














































 // export { default as Calender } from './Calender/calender';

































































// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var ui_container_Image = __webpack_require__(8863);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ErrorPage/index.tsx








var ErrorImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ErrorPage__ErrorImg",
  componentId: "lynp6-0"
})(["width:230px;height:230px;margin-bottom:16px;align-self:center;"]);
var ErrorPageStyle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ErrorPage__ErrorPageStyle",
  componentId: "lynp6-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;height:100vh;width:100vw;"]);
var ErrorPage = function ErrorPage(_ref) {
  var errorImg = _ref.errorImg,
      title = _ref.title,
      info = _ref.info,
      errorEvent = _ref.errorEvent,
      headerComponent = _ref.headerComponent,
      button1 = _ref.button1,
      button2 = _ref.button2;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [headerComponent || /*#__PURE__*/(0,jsx_runtime.jsx)(Header404, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(ErrorPageStyle, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ErrorImg, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui_container_Image/* Image */.E, {
          src: errorImg,
          width: "230",
          height: "230",
          alt: "Error"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H3Tag, {
        color: Global/* theme.blackText */.rS.blackText,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        textAlign: "center",
        color: Global/* theme.greyText */.rS.greyText,
        fontSize: "md",
        lineHeight: "32px",
        children: info
      }), button1 && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButtonWhite, {
        customTitle: button1,
        customWidth: "100%",
        margin: "32px 0 0"
      }), button2 && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButtonWhite, {
        customTitle: button2,
        customWidth: "100%",
        margin: "32px 0 0"
      })]
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(129);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(9017);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(8200);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ErrorBoundary/index.tsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      //   @TODO: Replace this with Sentry
      //   logErrorToMyService(error, info.componentStack);
      console.error("componentDidCatch", error);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        var _this$props$onError, _this$props;

        // You can render any custom fallback UI
        var error = this.state.error.getErrorMessage ? this.state.error.getErrorMessage() : this.state.error;
        return ((_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props, error)) || /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorScreen_ErrorScreen, {
          error: error
        });
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true,
        error: error
      };
    }
  }]);

  return ErrorBoundary;
}(react.Component);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withError.tsx


function withError(component, error, pageName) {
  return error ? /*#__PURE__*/_jsx(ErrorScreen, {
    error: error,
    pageName: pageName,
    trackError: true
  }) : component;
}
// EXTERNAL MODULE: ../../node_modules/pwa-mmt-ui-header/ssr/header.css
var header = __webpack_require__(4766);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MMTInsuranceHeader/index.tsx


function MMTInsuranceHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MMTInsuranceHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MMTInsuranceHeader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MMTInsuranceHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 //import { Header as MMTHeader } from 'pwa-mmt-ui-header/ssr/header';







var DynamicMMTHeader = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9575), __webpack_require__.e(4329)]).then(__webpack_require__.t.bind(__webpack_require__, 8972, 23)).then(function (module) {
    return module.Header;
  });
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8972)];
    }
  }
});
function MMTInsuranceHeader_MMTInsuranceHeader(_ref) {
  var _headerPropsWithDefau;

  var _ref$headerProps = _ref.headerProps,
      headerProps = _ref$headerProps === void 0 ? {} : _ref$headerProps,
      _ref$mobileTitle = _ref.mobileTitle,
      mobileTitle = _ref$mobileTitle === void 0 ? "" : _ref$mobileTitle,
      myOrders = _ref.myOrders,
      goToMyOrders = _ref.goToMyOrders,
      displayWhiteHeader = _ref.displayWhiteHeader;
  var device = (0,ui_widgets_src.useBreakpointV2)();

  var headerPropsWithDefaults = MMTInsuranceHeader_objectSpread({
    type: "singleHeader",
    forceLogin: false,
    activeModal: undefined,
    showMyBizFormSwitcher: true,
    profile: "PERSONAL",
    displayLanguageDropdown: false,
    selectedTabName: "Travel Insurance",
    displayCurrencyDropdown: false,
    onLogin: function onLogin() {
      return router_default().reload();
    },
    onLoginFlowComplete: function onLoginFlowComplete() {
      return void 0;
    },
    onModalChange: function onModalChange() {
      return void 0;
    },
    showMoreButton: true,
    showLoginPersuasionSlider: false,
    multiLingualData: {
      "header.login.signup.for.best.prices": "Please login to purchase your travel insurance"
    }
  }, headerProps);

  if (headerPropsWithDefaults.type === "dualHeader") {
    headerPropsWithDefaults.showMoreButton = false;
  }

  if ((_headerPropsWithDefau = headerPropsWithDefaults) !== null && _headerPropsWithDefau !== void 0 && _headerPropsWithDefau.forceLogin) {
    headerPropsWithDefaults = MMTInsuranceHeader_objectSpread(MMTInsuranceHeader_objectSpread({}, headerPropsWithDefaults), {}, {
      activeModal: "LOGIN"
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMMTHeader, MMTInsuranceHeader_objectSpread({}, headerPropsWithDefaults));
  }

  return device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMMTHeader, MMTInsuranceHeader_objectSpread({}, headerPropsWithDefaults)) : /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeader_LandingHeaderMobile, {
    headerTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    partnerType: partner_PARTNER.MMT,
    insuranceHeader: true
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withMMTInsuranceHeader.tsx

var withMMTInsuranceHeader_excluded = (/* unused pure expression or super */ null && (["Wrapper"]));




function withMMTInsuranceHeader(component) {
  var headerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mobileTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var myOrders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var goToMyOrders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return void 0;
  };
  var displayWhiteHeader = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var Wrapper = headerOptions.Wrapper,
      headerProps = _objectWithoutProperties(headerOptions, withMMTInsuranceHeader_excluded);

  var authComponent = /*#__PURE__*/_jsx(MMTInsuranceHeader, {
    headerProps: headerProps,
    mobileTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader
  });

  if (headerProps !== null && headerProps !== void 0 && headerProps.forceLogin) {
    return authComponent;
  }

  if (Wrapper) {
    return /*#__PURE__*/_jsxs(Wrapper, {
      children: [authComponent, component]
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [authComponent, component]
  });
}
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(2390);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(3377);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 1 modules
var growth_auth_helpers_esm = __webpack_require__(7263);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
// EXTERNAL MODULE: ../../node_modules/@growth/fetch-request/dist/growth-fetch-request.esm.js
var growth_fetch_request_esm = __webpack_require__(6963);
;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/node_modules/@growth/api-configs/dist/index-d83b01ac.esm.js
var hosts = {
  goibibo: '//www.goibibo.com',
  pokus: '//pokus.goibibo.com',
  recommendEarnUrl: '//influencer.goibibo.com',
  skywalker: '//mapi.goibibo.com',
  voyagerX: '//voyagerx.goibibo.com',
  voyager: '//voyager.goibibo.com',
  recentSearchPush: '//pdt.goibibo.com',
  gdpr: '//consentmgmt.makemytrip.com',
  appBannerUrl: "//userservice.goibibo.com",
  userGeoLocation: '//mapi.goibibo.com',
  configStore: '//configstore.goibibo.com',
  argus: '//www.goibibo.com',
  loyaltyUserInfo: '//membership-service.goibibo.com',
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: '//www.goibibo.com',
  amigoSyncUp: '//mitra.goibibo.com'
};

var PP = 'pp';
var LOCAL = 'local';
var PROD_PP = 'prodpp';
var PROD = 'prod';
var envs = [PROD, PP, PROD_PP, LOCAL];

var index_d83b01ac_esm_filterConfigForEnv = function filterConfigForEnv(configs, env) {
  if (env === void 0) {
    env = 'prod';
  }

  var normalizeEnvVar = function normalizeEnvVar(v) {
    var validEnvVar = function validEnvVar(ve) {
      return envs.includes(ve);
    };

    if (!validEnvVar(v)) {
      throw new Error("getConfig:normalizeEnvVar:validEnvVar error, " + v + " is not a valid env");
    } // pp & local will get the local hosts.
    // prodpp & prod will get the prod hosts.


    var e = [PP, LOCAL].includes(env) ? LOCAL : PROD;
    return e.toLowerCase();
  };

  var BuildEnv = normalizeEnvVar(env);
  return configs[BuildEnv];
};

var index_d83b01ac_esm_getConfigValueFromEnv = function getConfigValueFromEnv(key) {
  if (typeof GROWTH_API_CONFIG !== 'undefined') {
    var value = GROWTH_API_CONFIG[key];
    if (value) return value;
  }

  return hosts[key];
};

var index_d83b01ac_esm_endpoints = {
  appBannerUrlGuest: '/ext/web/pwa/send/token/DEEP_LINK',
  appBannerUrlLoggedIn: '/ext/web/pwa/send/token/LINK',
  pokusAssignVariant: '/experiment/assignVariant',
  userWidget: "/common/userwidget/?random=+" + Math.random(),
  // random to avoid browser cache
  recommendEarnUrl: "/recEarn/infl/details",
  skywalkerV1: '/empeiria/api/v1',
  dsdVoyager: '/api/v1/hotels_search/find_node_by_name',
  appContext: '/api/v2/utils/get_context/',
  recentSearchPush: '/fs/w',
  gdpr: '/ext/hcs/cmp/userconsents/get',
  userGdpr: '/ext/hcs/cmp/userconsents/save',
  userGeoLocation: '/locus/web/v2/graphQl',
  voyagerPagemake: '/pagemaker',
  argus: '/argus/pwa/login_details/save',
  configStore: '/get/configKey',
  getRecentSearch: '/empeiria/api/v1/recentSearchResponseByLob',
  loyaltyUserInfo: '/loyalty/userInfoWrapper',
  gocashBalance: '/gocash/v2/get_balance/',
  bookingSummary: '/tripsbackend/v2/bookingsummary',
  pokusImpressionAndHonour: '/measurement/impressionAndHonourConditions',
  pokusDynamicConfigs: '/measurement/getDynamicConfigs',
  amigoGetSyncUp: '/v1/say_thanks/get_privacy_data',
  amigoSetSyncUp: '/v1/say_thanks/post_privacy_data',
  amigoSetSyncUpStatus: '/api/v1/user/status/optin'
};



;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/node_modules/@growth/api-configs/dist/growth-api-configs.esm.js



/** Will reverse proxy/mock all local & pp api via moxy */
var moxy = 'https://newprodpp.goibibo.com/moxy';
var growth_api_configs_esm_hosts = {
  goibibo: '//www.goibibo.com',
  pokus: moxy,
  recommendEarnUrl: moxy,
  skywalker: moxy,
  voyagerX: moxy,
  voyager: moxy,
  recentSearchPush: moxy,
  gdpr: moxy,
  appBannerUrl: moxy,
  userGeoLocation: moxy,
  configStore: moxy,
  argus: moxy,
  loyaltyUserInfo: moxy,
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: moxy,
  amigoSyncUp: moxy
};

/**
 * Default index gives the client side api configs
 * eg:
 * import getConfig from '@growth/api-configs'
 */
var configs = {
  local: growth_api_configs_esm_hosts,
  prod: hosts
};

var getConfig = function getConfig(env) {
  var c = filterConfigForEnv(configs, env);
  return c;
};



// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-utils/dist/growth-auth-utils.esm.js
var growth_auth_utils_esm = __webpack_require__(8132);
;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/node_modules/@growth/api-calls/dist/growth-api-calls.esm.js







var fetchAppOpenUrl = function fetchAppOpenUrl(opts) {
  var isLoggedIn = !!getAuthToken();
  var apiPayload = (opts == null ? void 0 : opts.apiPayload) || {};
  var vid = getVisitorIdBrowser();
  var payload = {
    /*
     * keep the timeout small for this api,
     */
    body: {
      type: '18',
      "deepLink": {
        "data": {
          "c": apiPayload == null ? void 0 : apiPayload.campaign,
          "pid": "mweb2app",
          "deep_link_value": apiPayload == null ? void 0 : apiPayload.tagid,
          "af_web_dp": "https://www.goibibo.com/",
          "af_android_url": "https://play.google.com/store/apps/details?id=com.goibibo",
          "af_ios_url": "https://apps.apple.com/in/app/goibibo-hotel-flight-train/id631927169",
          "deep_link_sub1": _extends({}, apiPayload == null ? void 0 : apiPayload.godata, {
            login_req: (apiPayload == null ? void 0 : apiPayload.loginReq) || false,
            "referral_flow": (apiPayload == null ? void 0 : apiPayload.referral_flow) || false,
            "traffic_source": (apiPayload == null ? void 0 : apiPayload.trafficSource) || undefined,
            "~campaign": apiPayload == null ? void 0 : apiPayload.campaign,
            web_vid: vid
          }),
          "brand_domain": "app.goibibo.com"
        }
      }
    },
    credentials: 'omit',
    headers: getEssentialHeader({
      platform: 'mweb'
    })
  };
  var appBannerHost = getConfigValueFromEnv('appBannerUrl');
  var appBannerEndpoint = isLoggedIn ? endpoints.appBannerUrlLoggedIn : endpoints.appBannerUrlGuest;
  return fetchRequest("" + appBannerHost + appBannerEndpoint, payload).post();
};

var fetchPokusAssignVariantData = function fetchPokusAssignVariantData(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob || 'COMMON';
  var _generatePokusAssignV = generatePokusAssignVariantBodyRequest({
      isMobile: pokusOptions.isMobile,
      lob: lobName,
      deviceId: deviceId,
      extraOptions: pokusOptions
    }),
    request = _generatePokusAssignV.request;
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {};
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusAssignVariant, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post().then(function (res) {
    var _res$perLobMap;
    return (_res$perLobMap = res.perLobMap) == null ? void 0 : _res$perLobMap[lobName].metadataValues;
  });
};

var fetchUserDetails = function fetchUserDetails(_ref) {
  var timeout = _ref.timeout;
  var host = getConfigValueFromEnv('goibibo');
  return fetchRequest("" + host + endpoints.userWidget, {
    timeout: timeout
  }).post();
};

var fetchRecommendEarnDetails = function fetchRecommendEarnDetails(details) {
  var recommendEarnUrl = getConfigValueFromEnv('recommendEarnUrl');
  var token = getAuthToken$1();
  var headers = {
    auth: token,
    os: details == null ? void 0 : details.flavour
  };
  return fetchRequest("" + recommendEarnUrl + endpoints.recommendEarnUrl, {
    headers: headers,
    body: {
      hotelId: details.hotelId,
      source: details.source
    },
    credentials: 'omit'
  }).post();
};

var fetchSkywalkerClientData = function fetchSkywalkerClientData(skywalkerOptions, extraHeaders) {
  if (extraHeaders === void 0) {
    extraHeaders = {};
  }
  var endpointPath = skywalkerOptions.endpointPath,
    extraReqBody = skywalkerOptions.extraReqBody;
  var request = generateSkywalkerBodyRequest({
    extraReqBody: extraReqBody
  });
  var skywalkerUrl = getConfigValueFromEnv('skywalker');
  var headers = {
    brand: 'gi',
    deviceid: String
  };
  if (isUserTokenPresent()) {
    headers.auth = getAuthToken$1();
  }
  var dvid = getVisitorIdBrowser();
  if (dvid) {
    headers.deviceid = dvid;
  }
  return fetchRequest("" + skywalkerUrl + endpoints.skywalkerV1 + endpointPath, {
    body: request,
    credentials: 'omit',
    query: 'language=eng&currency=inr&region=in&brand=GI',
    headers: _extends({}, headers, extraHeaders)
  }).post();
};

var fetchAutoSuggetDailyStealDeal = function fetchAutoSuggetDailyStealDeal(userLocation) {
  var dsdVoyagerUrl = getConfigValueFromEnv('voyagerX');
  var userSelectedLocation = userLocation.userVal;
  return fetchRequest("" + dsdVoyagerUrl + endpoints.dsdVoyager, {
    credentials: 'omit',
    query: "search_query=" + userSelectedLocation + "&limit=10&include_t=[\"voy.city\"]"
  }).post();
};

var fetchPushRecentSearch = function fetchPushRecentSearch(searchCollection) {
  var url = getConfigValueFromEnv('recentSearchPush');
  var token = getAuthToken$1();
  var deviceid = getVisitorIdBrowser();
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };
  if (token) headers['oauth-goibibo'] = token;
  if (deviceid) headers.deviceid = deviceid;
  return fetchRequest("" + url + endpoints.recentSearchPush, {
    headers: headers,
    body: JSON.stringify(searchCollection),
    credentials: 'omit',
    extraOptions: {
      keepalive: true
    }
  }).post();
};

var fetchAppContext = function fetchAppContext(link) {
  var url = getConfigValueFromEnv('voyager') || prod.voyager;
  var raw = "url=" + (link || '');
  return fetchRequest("" + url + endpoints.appContext, {
    body: raw,
    credentials: 'omit'
  }).post();
};

var fetchGdprData = function fetchGdprData() {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.gdpr, {
    headers: headers,
    body: {
      org: 'GI',
      consent_id: 1,
      profile_type: 0,
      show_meta: true
    },
    credentials: 'omit'
  }).post();
};

var pushUserGdprData = function pushUserGdprData(gdpConsents) {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.userGdpr, {
    headers: headers,
    body: {
      org: 'GI',
      author: 'USER',
      consents: [_extends({
        status_active: true
      }, gdpConsents)]
    },
    credentials: 'omit'
  }).post();
};

var fetchUserGeoLocation = function fetchUserGeoLocation(_ref) {
  _ref.timeout;
  var host = getConfigValueFromEnv('userGeoLocation');
  return fetchRequest("" + host + endpoints.userGeoLocation, {
    body: "{ locationHierarchy(lat:,lng:) { country { id name centre } state { id name centre } city { id name centre postal_code } area { id name primary_area centre postal_code } } }",
    headers: {
      'Api-key': 'GROWTH-MMTGROWTH-71815232081313207181523208'
    }
  }).post();
};

var fetchConfigStoreData = function fetchConfigStoreData(opts) {
  var fetchOpts = opts.fetchOpts;
  var headers = fetchOpts.headers,
    timeout = fetchOpts.timeout;
  var host = getConfigValueFromEnv('configStore');
  return fetchRequest("" + host + endpoints.configStore, {
    headers: _extends({
      authorization: 'Tect685j8xMpLJF'
    }, headers),
    body: {
      isAbKey: opts.isAbKey,
      lobList: opts.lobList,
      cfgKeyList: opts.cfgKeyList
      /**
       * below three options helps on more granular query on bacnkend
       * these keys are not part of v1(present) api. Keep it commented
       * */
      // status: string,
      // submodule: string,
      // pgname: string,
    },

    credentials: 'omit',
    timeout: timeout
  }).post();
};

var fetchArgusFingerPrinting = function fetchArgusFingerPrinting(_ref) {
  var asyToken = _ref.asyToken,
    additionalData = _ref.additionalData;
  var url = getConfigValueFromEnv('argus');
  var token = getAuthToken();
  var headers = {
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
  if (token) headers['oauth-goibibo'] = token;
  fetchRequest("" + url + endpoints.argus, {
    headers: _extends({
      Authorization: 'P0s6jZGIkwMrnS2',
      'X-Request-Tracker': generateVid()
    }, headers),
    credentials: 'omit',
    body: {
      asyToken: asyToken,
      additionalData: additionalData
    }
  }).post();
};

var fetchRecentSearch = function fetchRecentSearch(_ref) {
  var lob = _ref.lob,
    strategy = _ref.strategy;
  var url = getConfigValueFromEnv('skywalker');
  return fetchRequest("" + url + endpoints.getRecentSearch + "?lob=" + lob + "&strategy=" + strategy, {
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      user: {
        profile_type: 'PERSONAL',
        uuid: getUuidFromCookie(),
        device_id: getVisitorIdBrowser(),
        domain: {
          country: 'in',
          language: 'eng',
          currency: 'inr'
        }
      }
    })
  }).post();
};

var fetchLoyaltyUserInfo = function fetchLoyaltyUserInfo() {
  var url = index_d83b01ac_esm_getConfigValueFromEnv('loyaltyUserInfo');
  var token = (0,growth_auth_utils_esm/* getAuthToken */.bW)();
  var headers = {
    'Content-Type': 'application/json',
    authorization: '7NP82fpV0TsA9JrK',
    org: 'GI'
  };
  if (token) headers.auth = token;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_d83b01ac_esm_endpoints.loyaltyUserInfo, {
    headers: headers,
    body: JSON.stringify({}),
    // empty data object is require for this endpoint
    credentials: 'omit'
  }).post();
};

var fetchGoCashBalance = function fetchGoCashBalance() {
  var url = index_d83b01ac_esm_getConfigValueFromEnv('gocashBalance');
  var headers = {
    'oauth-goibibo': (0,growth_auth_utils_esm/* getAuthToken */.bW)()
  };
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_d83b01ac_esm_endpoints.gocashBalance, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

/** List of all bookings */
var fetchBookingSummary = function fetchBookingSummary() {
  var url = index_d83b01ac_esm_getConfigValueFromEnv('bookingSummary');
  var headers = {
    auth: (0,growth_auth_utils_esm/* getAuthToken */.bW)()
  };
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_d83b01ac_esm_endpoints.bookingSummary, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

var fetchPokusImpressionAndHonourDetails = function fetchPokusImpressionAndHonourDetails(opts) {
  var _ref = opts || {},
    analyticsNode = _ref.analyticsNode;
  var host = getConfigValueFromEnv('pokus');
  return fetchRequest("" + host + endpoints.pokusImpressionAndHonour, {
    body: {
      analyticsNode: analyticsNode
    },
    credentials: 'omit'
  }).post();
};

var fetchPokusDynamicConfigs = function fetchPokusDynamicConfigs(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob;
  var request = generatePokusDynamicConfigBodyRequest({
    isMobile: pokusOptions.isMobile,
    lob: lobName,
    deviceId: deviceId,
    extraOptions: pokusOptions
  });
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {
    region: 'IN',
    language: 'EN'
  };
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusDynamicConfigs, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post();
};

var fetchAmigoSyncUpContacts = function fetchAmigoSyncUpContacts(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken()
  };
  return fetchRequest("" + url + endpoints.amigoGetSyncUp, {
    headers: headers,
    credentials: 'omit',
    query: "bookingId=" + bookingId + "&Lob=" + lob + "&context=TYP"
  }).get();
};

var pushAmigoSyncUpChoice = function pushAmigoSyncUpChoice(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob,
    isConsentGiven = _ref.isConsentGiven,
    reasonId = _ref.reasonId,
    reason = _ref.reason;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken(),
    'Content-Type': 'application/json'
  };
  return fetchRequest("" + url + endpoints.amigoSetSyncUp, {
    headers: headers,
    credentials: 'omit',
    body: {
      bookingId: bookingId,
      Lob: lob,
      isConsentGiven: isConsentGiven,
      reasonId: reasonId,
      reason: reason
    }
  }).post();
};



;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/dist/growth-data-store.esm.js




function growth_data_store_esm_extends() {
  growth_data_store_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return growth_data_store_esm_extends.apply(this, arguments);
}

var useBookingSummaryStore = (0,esm/* create */.Ue)()(function (set) {
  return growth_data_store_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchBookingSummary,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});
/** Filter the 'UPCOMING' bookings */

var selectUpcomingBookingsCount = function selectUpcomingBookingsCount(state) {
  var _state$data;

  var bookingList = (state == null ? void 0 : (_state$data = state.data) == null ? void 0 : _state$data.bookingDetails) || [];
  var upcomingList = bookingList.filter(function (item) {
    return (item == null ? void 0 : item.status) === 'UPCOMING';
  });
  return upcomingList.length;
};

function growth_data_store_esm_regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  growth_data_store_esm_regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function growth_data_store_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchFun = /*#__PURE__*/function () {
  var _ref = growth_data_store_esm_asyncToGenerator( /*#__PURE__*/growth_data_store_esm_regeneratorRuntime().mark(function _callee() {
    var resp, _ref2, success, balance;

    return growth_data_store_esm_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchGoCashBalance();

          case 2:
            resp = _context.sent;
            _ref2 = resp || {}, success = _ref2.success, balance = _ref2.total_credits;

            if (!(success || typeof balance !== 'undefined')) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              balance: balance
            });

          case 6:
            return _context.abrupt("return", 0);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun() {
    return _ref.apply(this, arguments);
  };
}();

var useGoCashBalanceStore = (0,esm/* create */.Ue)()(function (set) {
  return growth_data_store_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {
      balance: 0
    },
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var useLoyaltyUserInfoStore = (0,esm/* create */.Ue)(function (set) {
  return growth_data_store_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchLoyaltyUserInfo,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
}); // https://github.com/pmndrs/zustand/discussions/387#discussioncomment-6339994

var selectLoyaltyMemberType = function selectLoyaltyMemberType(state) {
  var _state$tribe_header;

  return (state == null ? void 0 : (_state$tribe_header = state.tribe_header) == null ? void 0 : _state$tribe_header.type) || 'non_member';
};



// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(2532);
// EXTERNAL MODULE: ../../node_modules/@growth/pdt-push/dist/growth-pdt-push.esm.js
var growth_pdt_push_esm = __webpack_require__(3488);
// EXTERNAL MODULE: ../../node_modules/@growth/design-system/dist/growth-design-system.esm.js
var growth_design_system_esm = __webpack_require__(3767);
// EXTERNAL MODULE: ../../node_modules/@growth/custom-hooks/useHasMounted/dist/growth-custom-hooks-useHasMounted.esm.js
var growth_custom_hooks_useHasMounted_esm = __webpack_require__(3509);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/dom-events-c707d33c.esm.js


var dom_events_c707d33c_esm_DOM_EVENT_NAME = {
  LOGOUT: 'hr_l',
  LOGOUT_SUCCESS: 'hr_lls',
  START_LOGIN_FLOW: 'hr_slf',
  HEADER_ITEM_CLICK: 'hr_hic',
  IS_NEW_USER: 'hr_inu',
  SHOW_LOGIN_POP_OVER: 'hr_slpo',
  HIDE_LOGIN_POP_OVER: 'hr_hlpo',
  REFRESH_HEADER_DATA: 'hr_rhr',
  LOGIN_SUCCESS: growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP
};



// EXTERNAL MODULE: ../../node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js + 1 modules
var growth_gi_dweb_auth_esm = __webpack_require__(3858);
// EXTERNAL MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 7 modules
var growth_config_store_browser_esm = __webpack_require__(4162);
;// CONCATENATED MODULE: ../../node_modules/@growth/modal/dist/index-0b639158.esm.js





function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var index_0b639158_esm_ModalWrapper = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tmin-width: 560px;\n\tmax-width: 1024px;\n\tposition: fixed;\n\tleft: 50vw;\n\ttop: 50vh;\n\ttransform: translate(-50%, -50%);\n\tbackground-color: #fff;\n\tborder-radius: 16px;\n\tz-index: 1026;\n"])));
var ModalCont = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\toverflow: hidden;\n\tposition: relative;\n"])));
var index_0b639158_esm_ModalBackdrop = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 1024;\n\tbackground: rgba(20, 24, 35, 0.7);\n"])));
var ModalBody = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tmax-height: 800px;\n\toverflow-y: auto;\n\t", "\n\n"])), function (p) {
  return p.onClick ? "cursor:pointer" : '';
});
var CloseBtn = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 28.8px;\n\theight: 28.8px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 32px;\n\tright: 32px;\n\tcursor: pointer;\n\tz-index: 1030;\n\n\t&::before,\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: ' ';\n\t\theight: 20px;\n\t\twidth: 2px;\n\t\tbackground-color: #647a97;\n\t}\n\n\t&::before {\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&::after {\n\t\ttransform: rotate(-45deg);\n\t}\n"])));

var WithoutPortalModal = function WithoutPortalModal(_ref) {
  var onClose = _ref.onClose,
    rootStyle = _ref.rootStyle,
    contentStyle = _ref.contentStyle,
    children = _ref.children,
    shouldCloseOutSideClick = _ref.shouldCloseOutSideClick,
    closeBtnStyle = _ref.closeBtnStyle,
    closeBtnShow = _ref.closeBtnShow,
    onBodyClick = _ref.onBodyClick;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(index_0b639158_esm_ModalWrapper, {
    className: "modal-wrapper",
    style: rootStyle,
    "data-id": "dweb-modal"
  }, closeBtnShow && /*#__PURE__*/react.createElement(CloseBtn, {
    style: closeBtnStyle,
    onClick: onClose
  }), /*#__PURE__*/react.createElement(ModalCont, {
    style: contentStyle
  }, /*#__PURE__*/react.createElement(ModalBody, {
    onClick: onBodyClick
  }, children))), /*#__PURE__*/react.createElement(index_0b639158_esm_ModalBackdrop, {
    onClick: shouldCloseOutSideClick ? onClose : function () {}
  }));
};
var index_0b639158_esm_Modal = function Modal(props) {
  var clientOnly = (0,growth_custom_hooks_useHasMounted_esm/* useHasMounted */.f)();
  (0,react.useEffect)(function () {
    // fixed scrolling when bottom modal is opened
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.removeProperty('overflow');
    };
  }, []);
  var Com = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(WithoutPortalModal, props));
  return clientOnly ? /*#__PURE__*/(0,react_dom.createPortal)(Com, document.body) : null;
};
WithoutPortalModal.defaultProps = {
  rootStyle: {},
  contentStyle: {},
  shouldCloseOutSideClick: true,
  closeBtnStyle: undefined,
  onBodyClick: undefined,
  closeBtnShow: true,
  onClose: undefined
};



;// CONCATENATED MODULE: ../../node_modules/@growth/modal/dist/growth-modal.esm.js






// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(2019);
// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(1917);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js + 2 modules
var growth_analytics_plugin_pdt_esm = __webpack_require__(1080);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js
var growth_analytics_plugin_adobe_esm = __webpack_require__(6401);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/growth-dweb-header.esm.js




















function growth_dweb_header_esm_regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  growth_dweb_header_esm_regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function growth_dweb_header_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function growth_dweb_header_esm_taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$c, _templateObject2$a, _templateObject3$8, _templateObject4$5, _templateObject5$4, _templateObject6$4, _templateObject7$4, _templateObject8$2;
var bdrAni = (0,styled_components_browser_esm.keyframes)(_templateObject$c || (_templateObject$c = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t\t0% {\n\t\t\twidth: 0;\n\t\t\tleft: 60%; /* Start from the center */\n\t\t\ttransform: translateX(-50%); /* Center the element horizontally */\n\t\t}\n\t\t50% {\n\t\t\twidth: 100%; /* Expand to the right */\n\t\t\tleft: 0; /* Move to the left edge */\n\t\t\ttransform: translateX(0%);\n\t\t}\n\t\t100% {\n\t\t\twidth: 100%; /* Collapse back to the center */\n\t\t\tleft: 50%; /* End at the center */\n\t\t\ttransform: translateX(-50%);\n\t\t}\n"])));
var HappyNav = styled_components_browser_esm["default"].ul(_templateObject2$a || (_templateObject2$a = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\theight: 100%;\n"])));
var HappyNavItem = styled_components_browser_esm["default"].li(_templateObject3$8 || (_templateObject3$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: transparent;\n\tcursor: pointer;\n\theight: 100%;\n\tposition: relative;\n\t", ";\n\n\t&.active,\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? '#2274e0' : '#777';
});
var NavLink$1 = styled_components_browser_esm["default"].a(_templateObject4$5 || (_templateObject4$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tcolor: #717171 !important;\n\talign-items: center;\n\tmargin-right: 30px;\n\tpadding: 20px 0px;\n\tposition: relative;\n\theight: 100%;\n\n\t&:visited {\n\t\tcolor: #717171;\n\t}\n\n\t&.active {\n\t\tcolor: #2274e0;\n\t\t&::after {\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tcontent: '';\n\t\t\theight: 3px;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: #2274e0;\n\t\t\tborder-radius: 2px;\n\t\t\tanimation: ", " 0.4s 1;\n\t\t}\n\t}\n"])), bdrAni);
var NewLob = styled_components_browser_esm["default"].div(_templateObject5$4 || (_templateObject5$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder-radius: 8px;\n\tfont-size: 10px;\n\tpadding: 2px 6px;\n\tcolor: #fff;\n\ttop: -8px;\n\tright: 19px;\n\tbackground: #ff5656;\n\tmargin-left: 5px;\n\tposition: absolute;\n"])));
var NavText = styled_components_browser_esm["default"].span(_templateObject6$4 || (_templateObject6$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var NavLinkSvg = styled_components_browser_esm["default"].div(_templateObject7$4 || (_templateObject7$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n"])));
var NavIcon$1 = styled_components_browser_esm["default"].span(_templateObject8$2 || (_templateObject8$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 5px;\n"])));

function growth_dweb_header_esm_extends() {
  growth_dweb_header_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return growth_dweb_header_esm_extends.apply(this, arguments);
}

// We use 'W_' as prefix for writing text constants
var W_GENERICS = {
  loginSignup: 'Login / Sign Up',
  loginSignup2: 'Login/Sign Up',
  internetError: 'Internet is not available. Check your connection.',
  apiErrorMsg: 'Some error occurred, please try again.'
};
var W_LOGIN_POPOVER_PERSUASION_GENERICS = {
  loginSignup: W_GENERICS.loginSignup2,
  coupon: 'Use Coupon : WELCOME'
};
var W_LOGIN_POPOVER_PERSUASION_FLIGHT = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 12% OFF*',
  offerSubTitle: 'on your first Flight booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_HOTEL = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 25% OFF* ',
  offerSubTitle: 'on your first Hotel booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_BUS = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 10% OFF*',
  offerSubTitle: 'on your first Bus booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_CAB = growth_dweb_header_esm_extends({
  offerTitle: ' Upto 10% OFF*',
  offerSubTitle: 'on your first Cab booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_TRAIN = growth_dweb_header_esm_extends({
  offerTitle: 'Zero service fees',
  offerSubTitle: 'on your first Train booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_BANNER_DEFAULT = {
  theme: 'gr-home',
  heading: 'Unlock these benefits',
  subHeading: '',
  benefits: [{
    id: 1,
    heading: 'Earn goCash',
    subHeading: '₹100 on Sign Up & Cashback on Bookings',
    iconClass: 'icGoCash'
  }, {
    id: 2,
    heading: 'Loyalty Benefits',
    subHeading: 'Extra Discounts, Free Seat Selection etc.',
    iconClass: 'icGoTribe'
  }, {
    id: 3,
    heading: 'Exclusive Offers',
    subHeading: 'Daily Steal Deals & Special Discounts',
    iconClass: 'icGiftBlue'
  }],
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
};
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_HOTEL
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_BUS
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_TRAIN
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_CAB
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
});
var W_USER_PROFILE_DROPDOWN = function W_USER_PROFILE_DROPDOWN(origin) {
  if (origin === void 0) {
    origin = '';
  }

  return {
    login: {
      label: 'Hey Traveller',
      subLabel: 'Get exclusive deals & Manage your trips',
      ctaText: W_GENERICS.loginSignup2
    },
    view_profile: {
      label: 'View your profile',
      url: origin + "/profile/"
    },
    offers: {
      label: 'Offers',
      subLabel: 'Handpicked best deals',
      icon: 'offers',
      url: origin + "/offers/"
    },
    myTrips: {
      label: 'My Trips',
      subLabel: {
        singular: 'Upcoming Trip',
        plural: "Upcoming Trips"
      },
      icon: 'mytrip',
      url: origin + "/travelhistory"
    },
    gotTribe: {
      label: '',
      subLabel: {
        member: 'View membership benefits',
        nonMember: 'Travel more to get enrolled!'
      },
      icon: 'gotribe',
      goTribeIcon: 'gotribeLogo',
      url: origin + "/loyalty/"
    },
    goCash: {
      label: 'goCash',
      subLabel: 'Current Balance : ',
      subLabelGuest: 'Signup to get ₹100 goCash',
      icon: 'gocash',
      url: origin + "/gocash/"
    },
    logout: {
      label: 'Logout',
      icon: 'logout-icon'
    }
  };
};
var W_RUPEE_SIGN = '₹';
var W_MY_TRIPS = function W_MY_TRIPS(origin) {
  if (origin === void 0) {
    origin = '';
  }

  return {
    label: 'My Trips',
    icon: 'mytrip-icon',
    tooltip: 'Access your bookings, easy cancellation, date change and much more',
    manageBooking: 'Manage Booking',
    url: W_USER_PROFILE_DROPDOWN(origin).myTrips.url
  };
};
var W_LOGIN_WIDGET_CTA = [{
  text: 'LOGIN / SIGNUP',
  id: 'text_1'
}, {
  text: 'Exclusive Offers',
  id: 'text_2'
}, {
  text: 'Earn goCash',
  id: 'text_3'
}, {
  text: 'Manage Your Trips',
  id: 'text_4'
}];

var LOBS_NAME = {
  FLIGHTS: 'Flights',
  HOTELS: 'Hotels',
  HOLIDAYS: 'Holidays',
  BUS: 'Bus',
  CABS: 'Cabs',
  TRAINS: 'Trains',
  VISA: 'Visa',
  FOREX: 'Forex',
  INSURANCE: 'Insurance'
};
var LOBS_CATG = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
  BUS: 'bus',
  CABS: 'cabs',
  TRAINS: 'trains',
  HOLIDAYS: 'holidays',
  ACTIVITIES: 'activities',
  GROWTH: 'growth',
  COMMON: 'common',
  METRO: 'metro',
  VISA: 'visa',
  FOREX: 'forex',
  INSURANCE: 'Insurance'
};
var GOTRIBE_MEMBER_TYPES = {
  non_member: {
    value: 'non_member',
    label: ''
  },
  member: {
    value: 'member'
  },
  star: {
    value: 'star',
    label: 'Star'
  },
  superstar: {
    value: 'superstar',
    label: 'SuperStar'
  }
};
var DEFAULT_PROFILE_NAME = 'Traveller';

var isActiveLink = function isActiveLink(navLabel, lobName) {
  if (navLabel && lobName) {
    return navLabel.toLowerCase() === lobName.toLowerCase();
  }

  return false;
};

var goTribeMembers = [GOTRIBE_MEMBER_TYPES.star.value, GOTRIBE_MEMBER_TYPES.superstar.value, GOTRIBE_MEMBER_TYPES.member.value];

var isGoTribeMember = function isGoTribeMember(memberType) {
  return goTribeMembers.includes(memberType);
};

var getUserNameInitials = function getUserNameInitials(name) {
  return name.toString().charAt(0).toUpperCase();
};

var NavBar = function NavBar(_ref) {
  var navList = _ref.navList,
      lobName = _ref.lobName;
  var activeClass = (0,react.useCallback)(function (label, lob) {
    return !!isActiveLink(label, lob);
  }, [lobName]);

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;
      var adobe = _useAnalytics.adobe;

  function navBarGaEvent(item) {
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click", {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: item.category,
        type: 'itemClick',
        destination: item.url,
        componentName: 'header'
      }
    });
  }
  /** Hide the last item in nav if viewport is smaller than  1440px */


  var _useState = (0,react.useState)(true),
      hideLastItem = _useState[0],
      setShowLastItem = _useState[1];

  (0,react.useEffect)(function () {
    var viewport = window.matchMedia('(max-width: 1440px)');
    setShowLastItem(viewport.matches);
    viewport.addEventListener('change', function (e) {
      return setShowLastItem(e.matches);
    });
    return function () {
      viewport.removeEventListener('change', function (e) {
        return setShowLastItem(e.matches);
      });
    };
  }, []);
  var currentNavList = hideLastItem ? navList.slice(0, navList.length - 1) : navList.slice(0, navList.length);
  return /*#__PURE__*/react.createElement(HappyNav, null, currentNavList.map(function (item) {
    var _item$icon, _item$icon2;

    return /*#__PURE__*/react.createElement(HappyNavItem, {
      key: item.label,
      isActive: activeClass(item.category, lobName)
    }, /*#__PURE__*/react.createElement(NavLink$1, {
      href: item.url,
      target: "" + (item.targetBlank ? '_blank' : '_self'),
      className: activeClass(item.category, lobName) ? 'active' : '',
      onClick: function onClick() {
        return navBarGaEvent(item);
      }
    }, ((_item$icon = item.icon) == null ? void 0 : _item$icon.type) === 'svg' ? /*#__PURE__*/react.createElement(NavLinkSvg, null, /*#__PURE__*/react.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: (_item$icon2 = item.icon) == null ? void 0 : _item$icon2.source
      }
    })) : /*#__PURE__*/react.createElement(NavIcon$1, {
      className: "header-sprite nav-icon-" + item.icon
    }), /*#__PURE__*/react.createElement(NavText, null, item.label), item["new"] && /*#__PURE__*/react.createElement(NewLob, null, "NEW")));
  }));
};

var _templateObject$b, _templateObject2$9;
var LogoLink = styled_components_browser_esm["default"].a(_templateObject$b || (_templateObject$b = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\twidth: 151px;\n\tmargin-right: 55px;\n\n\t.special-logo {\n\t\tmargin-left: 0;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: contain;\n\t}\n\t.gi-logo {\n\t\tmargin-left: 32px;\n\t}\n"])));
var growth_dweb_header_esm_Logo = styled_components_browser_esm["default"].span(_templateObject2$9 || (_templateObject2$9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: inherit;\n\theight: 65px;\n"])));

var HeaderLogo = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var homeURL = _ref.homeURL,
      lobName = _ref.lobName;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      adobe = _useAnalytics.adobe;

  var addAnalyticsEvent = function addAnalyticsEvent() {
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_logo", {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: 'logo',
        destination: homeURL,
        type: 'itemClick',
        componentName: 'header'
      }
    });
  };

  return /*#__PURE__*/react.createElement(LogoLink, {
    href: homeURL,
    onClick: addAnalyticsEvent
  }, /*#__PURE__*/react.createElement(growth_dweb_header_esm_Logo, {
    className: "header-sprite logo gi-logo",
    ref: ref
  }));
});
HeaderLogo.displayName = 'HeaderLogo';

var _templateObject$a, _templateObject2$8, _templateObject3$7, _templateObject4$4, _templateObject5$3, _templateObject6$3, _templateObject7$3;
var TabContainer = styled_components_browser_esm["default"].div(_templateObject$a || (_templateObject$a = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tposition: relative;\n\tmin-height: 40px;\n\twidth: 108px;\n\tmargin-right: 20px;\n\n\t&:hover .tooltip {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n"])));
var MyTripTab = (0,styled_components_browser_esm["default"])(TabContainer)(_templateObject2$8 || (_templateObject2$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 148px;\n"])));
var NavLink = styled_components_browser_esm["default"].a(_templateObject3$7 || (_templateObject3$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose([""])));
var Tooltip = styled_components_browser_esm["default"].div(_templateObject4$4 || (_templateObject4$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 250px;\n\tpadding: 10px 12px 10px 30px;\n\ttop: 52px;\n\tleft: -66px;\n\tdisplay: none;\n\tcolor: #46484d;\n\n\t", ":hover & {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n\n\t&::after,\n\t&::before {\n\t\tbottom: 100%;\n\t\tleft: 50%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t}\n\n\t&::after {\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n\n\t&::before {\n\t\tborder-color: rgba(227, 227, 227, 0);\n\t\tborder-bottom-color: #e3e3e3;\n\t\tborder-width: 9px;\n\t\tmargin-left: -9px;\n\t}\n\n\tp::before {\n\t\tcontent: '';\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder-radius: 100%;\n\t\tbackground: #50e3c2;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 12px;\n\t\ttop: 12px;\n\t}\n"])), MyTripTab);
var NavIcon = styled_components_browser_esm["default"].span(_templateObject5$3 || (_templateObject5$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 10px;\n"])));
var NotificationTag = styled_components_browser_esm["default"].div(_templateObject6$3 || (_templateObject6$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 100%;\n\tbackground: #ffea67;\n\tborder: solid 1px #fba707;\n\tfont-size: 10px;\n\tcolor: #000;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 17px;\n\tleft: 12px;\n"])));
styled_components_browser_esm["default"].div(_templateObject7$3 || (_templateObject7$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tbackground: url(https://gos3.ibcdn.com/gocash-1656061010.png);\n\theight: 24px;\n\twidth: 30px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n"])));

var NavWidgets = function NavWidgets(props) {
  var upcomingTrip = props.upcomingTrip,
      isLoggedIn = props.isLoggedIn,
      navOrigin = props.navOrigin,
      lobName = props.lobName;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;
      var adobe = _useAnalytics.adobe;

  function sendGAEvent(linkName, url) {
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: linkName,
        type: 'itemClick',
        componentName: 'header',
        destination: url
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_" + linkName, {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
  }

  var mytrip = W_MY_TRIPS(navOrigin);
  return /*#__PURE__*/react.createElement(NavLink, {
    href: mytrip.url,
    onClick: function onClick() {
      return sendGAEvent('my_trips', mytrip.url);
    }
  }, /*#__PURE__*/react.createElement(MyTripTab, {
    role: "presentation"
  }, /*#__PURE__*/react.createElement(NavIcon, {
    className: "header-sprite " + mytrip.icon
  }), isLoggedIn && upcomingTrip ? /*#__PURE__*/react.createElement(NotificationTag, null, upcomingTrip) : null, /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW2",
    style: {
      color: isLoggedIn ? '#0074eb' : '#666'
    }
  }, mytrip.label), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2",
    style: {
      color: '#333'
    }
  }, mytrip.manageBooking))), /*#__PURE__*/react.createElement(Tooltip, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1"
  }, mytrip.tooltip))));
};

/*
 * You can change the LOBS nav item in header by changing the below array
 * item order
 *
 * If you are adding a new LOB in this list, make sure 'HeaderUrlConfig'
 * must have the require config for that new LOB.
 */

var lobsListInOrder = ['FLIGHTS', 'HOTELS', 'TRAINS', 'CABS', 'BUS', 'HOLIDAYS', 'FOREX', 'INSURANCE'];
var lobsPathName = {
  HOME: '/',
  FLIGHTS: '/flights/',
  HOTELS: '/hotels/',
  TRAINS: '/trains/',
  CABS: '/cars/',
  BUS: '/bus/',
  VISA: '/visa/',
  HOLIDAYS: '/giholidays/',
  INSURANCE: '/insurance?cmp=desktop_header',
  FOREX: 'https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=header_goibibo&utm_medium=desktop'
};
var lobOffersPath = {
  flights: 'flight-offers/',
  hotels: 'hotel-offers/',
  cabs: 'gocar-offers/',
  trains: 'train-offers/',
  bus: 'bus-offers/'
};
/*
 * Assuming as LOBs pages will be in `/`  path of origin(https://goibibo.com/<lobpage>) if not then lobs can
 pass navOrigin as prop to replace it.
 eg:
 navOrigin: "https://www.goibibo.com" if header is integrated in subdomain or other domain than goibibo.com
 */
// @private

function getNavListUrls(origin) {
  if (origin === void 0) {
    origin = '';
  }

  var urls = {
    FLIGHTS: {
      URL: origin + lobsPathName.FLIGHTS,
      LABEL: LOBS_NAME.FLIGHTS,
      CATEGORY: LOBS_CATG.FLIGHTS,
      ICON: 'flights' // sprite icons class name

    },
    HOTELS: {
      URL: origin + lobsPathName.HOTELS,
      LABEL: LOBS_NAME.HOTELS,
      CATEGORY: LOBS_CATG.HOTELS,
      ICON: 'hotels'
    },
    TRAINS: {
      URL: origin + lobsPathName.TRAINS,
      LABEL: LOBS_NAME.TRAINS,
      CATEGORY: LOBS_CATG.TRAINS,
      ICON: 'trains'
    },
    CABS: {
      URL: origin + lobsPathName.CABS,
      LABEL: LOBS_NAME.CABS,
      CATEGORY: LOBS_CATG.CABS,
      ICON: 'cabs'
    },
    BUS: {
      URL: origin + lobsPathName.BUS,
      LABEL: LOBS_NAME.BUS,
      CATEGORY: LOBS_CATG.BUS,
      ICON: 'bus'
    },
    VISA: {
      URL: origin + lobsPathName.VISA,
      LABEL: LOBS_NAME.VISA,
      CATEGORY: LOBS_CATG.VISA,
      ICON: 'visa',
      NEW: false
    },
    FOREX: {
      URL: lobsPathName.FOREX,
      LABEL: LOBS_NAME.FOREX,
      CATEGORY: LOBS_CATG.FOREX,
      ICON: 'forex',
      TARGET_BLANK: true
    },
    HOLIDAYS: {
      URL: origin + lobsPathName.HOLIDAYS,
      LABEL: LOBS_NAME.HOLIDAYS,
      CATEGORY: LOBS_CATG.HOLIDAYS,
      ICON: 'holiday',
      TARGET_BLANK: true
    },
    INSURANCE: {
      URL: origin + lobsPathName.INSURANCE,
      LABEL: LOBS_NAME.INSURANCE,
      CATEGORY: LOBS_CATG.INSURANCE,
      ICON: 'insurance',
      TARGET_BLANK: false
    }
  };
  return urls;
}

function generateMainNavList(list, navUrls) {
  var finalList = [];
  list.forEach(function (item) {
    var l = {
      url: navUrls[item].URL,
      path: navUrls[item].PATHNAME,
      label: navUrls[item].LABEL,
      icon: navUrls[item].ICON,
      "new": navUrls[item].NEW || false,
      targetBlank: navUrls[item].TARGET_BLANK || false,
      category: navUrls[item].CATEGORY
    };
    finalList.push(l);
  });
  return finalList;
}

var lobsNavList = function lobsNavList(origin) {
  return generateMainNavList(lobsListInOrder, getNavListUrls(origin));
};

var _templateObject$9, _templateObject2$7, _templateObject3$6;
var AvatarWrap = styled_components_browser_esm["default"].span(_templateObject$9 || (_templateObject$9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tborder-radius: 100%;\n\toverflow: hidden;\n\tmargin-right: 5px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n\t", "\n"])), function (_ref) {
  var image = _ref.image;
  return !image ? (0,styled_components_browser_esm.css)(_templateObject2$7 || (_templateObject2$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\t  "]))) : '';
});
var ProfileNameChar = styled_components_browser_esm["default"].span(_templateObject3$6 || (_templateObject3$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tletter-spacing: normal;\n\tcolor: #fff;\n\ttext-align: center;\n\tposition: absolute;\n\ttop: 4px;\n"])));

var _templateObject$8, _templateObject2$6, _templateObject3$5, _templateObject4$3;
var placeHolderShimmer = (0,styled_components_browser_esm.keyframes)(_templateObject$8 || (_templateObject$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n0% {\n\tbackground-position: -468px 0;\n}\n\n100% {\n\tbackground-position: 468px 0;\n}\n"])));
var growth_dweb_header_esm_Shimmer = styled_components_browser_esm["default"].div(_templateObject2$6 || (_templateObject2$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tanimation-duration: 1s;\n\tanimation-fill-mode: forwards;\n\tanimation-iteration-count: infinite;\n\tanimation-name: ", ";\n\tanimation-timing-function: linear;\n\tbackground: #f6f7f8;\n\tbackground: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n\tbackground-size: 800px 104px;\n\tposition: relative;\n"])), placeHolderShimmer);
var HorizontalShimmer = (0,styled_components_browser_esm["default"])(growth_dweb_header_esm_Shimmer)(_templateObject3$5 || (_templateObject3$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 80%;\n\theight: 15px;\n"])));
var CircularShimmer = (0,styled_components_browser_esm["default"])(growth_dweb_header_esm_Shimmer)(_templateObject4$3 || (_templateObject4$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder-radius: 50%;\n\twidth: 30px;\n\theight: 30px;\n"])));

var UserAvatar = function UserAvatar(props) {
  var image = props.image,
      firstName = props.firstName,
      isLoggedIn = props.isLoggedIn,
      loading = props.loading;
  var getNameFirstChar = (0,react.useCallback)(function () {
    return getUserNameInitials(firstName);
  }, [firstName]);

  if (isLoggedIn) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, image ? /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: getNameFirstChar()
    }) : /*#__PURE__*/react.createElement(ProfileNameChar, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
      size: "MediumW3"
    }, getNameFirstChar())));
  }

  if (loading) {
    return /*#__PURE__*/react.createElement(CircularShimmer, null);
  }

  if (image) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: "avatar"
    }));
  }

  return /*#__PURE__*/react.createElement("span", {
    className: "header-sprite user-icon",
    style: {
      marginRight: '5px'
    }
  });
};

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
var LoginDropdown = styled_components_browser_esm["default"].div(_templateObject$7 || (_templateObject$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 250px;\n\tpadding: 10px 20px;\n\tfont-size: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 1000;\n\tcolor: #46484d;\n"])));
styled_components_browser_esm["default"].div(_templateObject2$5 || (_templateObject2$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex-direction: column;\n\talign-items: flex-start !important;\n"])));
styled_components_browser_esm["default"].div(_templateObject3$4 || (_templateObject3$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-bottom: 1px !important;\n\tcolor: #4e525b;\n"])));
styled_components_browser_esm["default"].div(_templateObject4$2 || (_templateObject4$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #4e525b;\n\tmargin-bottom: 12px !important;\n"])));
var DropdownListItem = styled_components_browser_esm["default"].a(_templateObject5$2 || (_templateObject5$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: solid 1px #efefef;\n\tpadding: 8px 0;\n\tcursor: pointer;\n\tcolor: #46484d !important;\n\t&:first-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:last-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:visited {\n\t\tcolor: #46484d;\n\t}\n"])));
var DropdownLoginWrap = styled_components_browser_esm["default"].li(_templateObject6$2 || (_templateObject6$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tmargin: 8px 0px;\n"])));
var DropdownLinkUser = styled_components_browser_esm["default"].a(_templateObject7$2 || (_templateObject7$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var DropdownLink = styled_components_browser_esm["default"].a(_templateObject8$1 || (_templateObject8$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var DropdownLinkWrapLoyalty = styled_components_browser_esm["default"].div(_templateObject9$1 || (_templateObject9$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
styled_components_browser_esm["default"].a(_templateObject10$1 || (_templateObject10$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #2276e3;\n"])));
styled_components_browser_esm["default"].div(_templateObject11$1 || (_templateObject11$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n"])));
styled_components_browser_esm["default"].div(_templateObject12$1 || (_templateObject12$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 22px;\n\theight: 22px;\n\ttop: 1px;\n\tfont-size: 14px;\n"])));
styled_components_browser_esm["default"].div(_templateObject13 || (_templateObject13 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 8px;\n\twidth: 32px;\n\tdisplay: inline-block;\n\tbackground: #e3e3e3;\n"])));
var DropdownMenuWrap = styled_components_browser_esm["default"].div(_templateObject14 || (_templateObject14 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex: 1;\n"])));
var DropdownSprite = styled_components_browser_esm["default"].div(_templateObject15 || (_templateObject15 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 20px;\n"])));
var LoginButton = styled_components_browser_esm["default"].button(_templateObject16 || (_templateObject16 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\t", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ProfileItemWrap = styled_components_browser_esm["default"].div(_templateObject17 || (_templateObject17 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex: 1 1 0%;\n\tmargin-left: 8px;\n"])));
var ItemLabel = styled_components_browser_esm["default"].p(_templateObject18 || (_templateObject18 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 3px;\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ItemSubLabel = styled_components_browser_esm["default"].p(_templateObject19 || (_templateObject19 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4e525b;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);

var DropDownItemUserProfile = function DropDownItemUserProfile(_ref) {
  var onViewProfileClick = _ref.onViewProfileClick,
      userImage = _ref.userImage,
      fullName = _ref.fullName,
      isLoggedIn = _ref.isLoggedIn,
      onLoginCtaClick = _ref.onLoginCtaClick,
      navOrigin = _ref.navOrigin;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);
  return /*#__PURE__*/react.createElement(DropdownLoginWrap, null, !isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "MediumW2",
    style: {
      marginBottom: '1px',
      color: '#4e525b'
    }
  }, dropDownList.login.label), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      marginBottom: '12px',
      color: '#4e525b'
    }
  }, dropDownList.login.subLabel), /*#__PURE__*/react.createElement(LoginButton, {
    onClick: function onClick() {
      return onLoginCtaClick('login-cta-dropdown');
    },
    type: "button"
  }, dropDownList.login.ctaText)) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(DropdownLinkUser, {
    href: dropDownList.view_profile.url,
    onClick: onViewProfileClick
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: userImage,
    firstName: fullName,
    isLoggedIn: true
  }), /*#__PURE__*/react.createElement(ProfileItemWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#4e525b",
    size: "MediumW2",
    style: {
      marginBottom: '3px',
      textTransform: 'capitalize'
    }
  }, fullName), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      color: '#2276e3'
    }
  }, dropDownList.view_profile.label, ' ')))));
};

var _templateObject$6, _templateObject2$4, _templateObject3$3;
var HappyGiHeader = styled_components_browser_esm["default"].header(_templateObject$6 || (_templateObject$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbackground: #fff;\n\tdisplay: flex !important;\n\talign-items: center;\n\tpadding: 0px 32px 0 0;\n\tbox-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n\tz-index: 900;\n\tposition: relative;\n\theight: 64px;\n\n\t&.header-sticky {\n\t\tposition: fixed !important;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t.logo {\n\t\tmargin-right: 35px;\n\t}\n\n\t@media (max-width: 640px) {\n\t\tdisplay: none !important;\n\t}\n"])));
var LoginWidgetWrapper = styled_components_browser_esm["default"].div(_templateObject2$4 || (_templateObject2$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: auto;\n"])));
var GotribeBadge$1 = styled_components_browser_esm["default"].span(_templateObject3$3 || (_templateObject3$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 1px 5px;\n\tborder-radius: 7px;\n\tbackground-image: ", ";\n\tcolor: #fff;\n\t", "\n"])), function (_ref) {
  var memberType = _ref.memberType;
  return memberType === GOTRIBE_MEMBER_TYPES.superstar.value ? 'linear-gradient(to right, #e63148 40%, #ff4e00)' : 'linear-gradient(to right, #fa961a 19%, #ffb305 95%)';
}, growth_design_system_esm/* textSizes.SmallW3 */.iH.SmallW3);

var DropDownItemLoyalty = function DropDownItemLoyalty(_ref) {
  var _ref$control = _ref.control,
      control = _ref$control === void 0 ? true : _ref$control,
      memberType = _ref.memberType,
      navOrigin = _ref.navOrigin,
      sendEvent = _ref.sendEvent;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);

  var _useState = (0,react.useState)(true),
      show = _useState[0],
      setShow = _useState[1];
  /* GROW-2765
   * to check blacklist gotribe option
   * control true blacklist, control false normal user
   * if there is no cards then it's a control/whitlisted gotribeuser
   */


  (0,react.useEffect)(function () {
    setShow(!!control);
  }, [control]);
  if (!show) return /*#__PURE__*/react.createElement(react.Fragment, null);
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    as: "span"
  }, /*#__PURE__*/react.createElement(DropdownLink, {
    href: dropDownList.gotTribe.url,
    onClick: function onClick() {
      return sendEvent({
        link: 'go_tribe',
        memberType: memberType
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + dropDownList.gotTribe.icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(DropdownLinkWrapLoyalty, null, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + dropDownList.gotTribe.goTribeIcon,
    style: {
      marginLeft: 0,
      marginRight: 0
    }
  }), memberType !== GOTRIBE_MEMBER_TYPES.non_member.value && /*#__PURE__*/react.createElement(GotribeBadge$1, {
    memberType: memberType
  }, GOTRIBE_MEMBER_TYPES[memberType].label)), /*#__PURE__*/react.createElement(ItemSubLabel, null, memberType !== GOTRIBE_MEMBER_TYPES.non_member.value ? dropDownList.gotTribe.subLabel.member : dropDownList.gotTribe.subLabel.nonMember))));
};

var DropDownItemGeneric = function DropDownItemGeneric(_ref) {
  var sendEvent = _ref.sendEvent,
      listItem = _ref.listItem,
      itemChild = _ref.itemChild;
  var url = listItem.url,
      label = listItem.label,
      subLabel = listItem.subLabel,
      icon = listItem.icon;
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    href: url,
    onClick: function onClick() {
      return sendEvent({
        link: label
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(ItemLabel, null, label), /*#__PURE__*/react.createElement(ItemSubLabel, null, itemChild || subLabel)));
};

DropDownItemGeneric.defaultProps = {
  itemChild: undefined
};

var UserDropDown = function UserDropDown(props) {
  var _loyaltyUserInfoData$;

  var userInfo = props.userInfo,
      hideDropDown = props.hideDropDown,
      memberType = props.memberType,
      upcomingTripCount = props.upcomingTripCount,
      isLoggedIn = props.isLoggedIn,
      _onLoginCtaClick = props.onLoginCtaClick,
      lobName = props.lobName,
      navOrigin = props.navOrigin,
      positionStyle = props.positionStyle;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);
  var loyaltyUserInfoData = useLoyaltyUserInfoStore(function (s) {
    return s.data;
  }, shallow/* shallow */.X);

  var _useGoCashBalanceStor = useGoCashBalanceStore(),
      gocashData = _useGoCashBalanceStor.data,
      gocashLoading = _useGoCashBalanceStor.loading;

  var balance = gocashData.balance;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;
  /* GROW-2765
   * to check blacklist gotribe option
   * control true blacklist, control false normal user
   * if there is no cards then it's a control/whitlisted gotribeuser
   */


  var control = loyaltyUserInfoData == null ? void 0 : (_loyaltyUserInfoData$ = loyaltyUserInfoData.cards) == null ? void 0 : _loyaltyUserInfoData$.length;

  var handleOutsideClick = function handleOutsideClick(e) {
    var el = e.target;
    var dropdownContainer = el.closest('ul.login__dropdown');

    if (!dropdownContainer) {
      hideDropDown();
    }
  };

  var sendEvent = function sendEvent(eventObj) {
    pdt.track('HAPPY_HEADER_WEBA__CLICK_DROPDOWN_LINK', {
      item_selected: eventObj.link
    });
    adobe.track('ctaClick', {
      cta: {
        name: eventObj.link,
        type: 'itemClick',
        componentName: 'Header Dropdown'
      }
    });
  };

  var handleViewProfile = function handleViewProfile() {
    sendEvent({
      link: 'view_profile'
    });
  };

  (0,react.useEffect)(function () {
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  var getOffersUrl = function getOffersUrl() {
    var offersUrl = dropDownList.offers.url;

    if (lobName && lobOffersPath[lobName]) {
      return "" + offersUrl + lobOffersPath[lobName];
    }

    return offersUrl;
  };

  var fullName = userInfo != null && userInfo.firstName ? (userInfo == null ? void 0 : userInfo.firstName) + " " + ((userInfo == null ? void 0 : userInfo.lastName) || '') : DEFAULT_PROFILE_NAME;
  return /*#__PURE__*/react.createElement(LoginDropdown, {
    style: positionStyle,
    "data-id": "header-dropdown"
  }, /*#__PURE__*/react.createElement(DropDownItemUserProfile, {
    onViewProfileClick: handleViewProfile,
    userImage: userInfo == null ? void 0 : userInfo.profileImage,
    fullName: fullName,
    isLoggedIn: isLoggedIn,
    onLoginCtaClick: function onLoginCtaClick() {
      return _onLoginCtaClick({
        name: 'login-cta-dropdown',
        componentName: 'Header Dropdown'
      });
    },
    navOrigin: navOrigin
  }), /*#__PURE__*/react.createElement(DropDownItemLoyalty, {
    control: control,
    memberType: memberType,
    navOrigin: navOrigin,
    sendEvent: sendEvent
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: growth_dweb_header_esm_extends({}, dropDownList.offers, {
      url: getOffersUrl()
    })
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: dropDownList.myTrips,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, upcomingTripCount ? upcomingTripCount + "\n                " + (upcomingTripCount > 1 ? dropDownList.myTrips.subLabel.plural : dropDownList.myTrips.subLabel.singular) : 'Manage your bookings')
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: dropDownList.goCash,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, dropDownList.goCash.subLabel, /*#__PURE__*/react.createElement("span", {
      className: "gr-bold"
    }, gocashLoading ? /*#__PURE__*/react.createElement("span", {
      className: "gocashLoading"
    }) : /*#__PURE__*/react.createElement(react.Fragment, null, W_RUPEE_SIGN, balance))) : /*#__PURE__*/react.createElement(react.Fragment, null, dropDownList.goCash.subLabelGuest))
  }));
};

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var LoginTab = styled_components_browser_esm["default"].div(_templateObject$5 || (_templateObject$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 186px;\n\tposition: relative;\n\theight: 44px;\n\tbackground-color: #fff;\n\ttransition: all 0.4s ease;\n\n\t.gr-user {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 100%;\n\t\toverflow: hidden;\n\n\t\timg {\n\t\t\twidth: 28px;\n\t\t\theight: 28px;\n\t\t\tborder-radius: 50%;\n\t\t}\n\n\t\t&.name__text {\n\t\t\tbackground-image: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\tfont-size: 16px;\n\t\t\tcolor: #fff;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n\n\t.you-are {\n\t\tvertical-align: bottom;\n\t}\n\n\t.horizontal_shimmer {\n\t\tmargin-left: 12px;\n\t}\n"])));
var UserNameWrap = styled_components_browser_esm["default"].div(_templateObject2$3 || (_templateObject2$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var UserNameText = styled_components_browser_esm["default"].span(_templateObject3$2 || (_templateObject3$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n\ttext-transform: capitalize;\n\tmargin-left: 4px;\n"])));
var LoginTabWrapper = styled_components_browser_esm["default"].div(_templateObject4$1 || (_templateObject4$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\tborder-radius: 8px;\n\tborder: solid 1px #2276e3;\n\tpadding: 0 8px;\n\tcursor: pointer;\n    overflow: hidden;\n"])));
var ScrollItemWrap = styled_components_browser_esm["default"].div(_templateObject5$1 || (_templateObject5$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var SignUpCtaTextWrap = styled_components_browser_esm["default"].div(_templateObject6$1 || (_templateObject6$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose([""])));
styled_components_browser_esm["default"].div(_templateObject7$1 || (_templateObject7$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 1px;\n\theight: 29px;\n\tborder-right: solid 1px #eff3f8;\n"])));
styled_components_browser_esm["default"].div(_templateObject8 || (_templateObject8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 2px 5px;\n\tborder-radius: 7px;\n\tcolor: #fff;\n\tfont-size: 8px;\n\tbackground-image: linear-gradient(to right, #e63148 40%, #ff4e00);\n\n\t&.super {\n\t\tbackground-image: linear-gradient(to right, #fa961a 19%, #ffb305 95%);\n\t}\n"])));
styled_components_browser_esm["default"].div(_templateObject9 || (_templateObject9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tmax-width: 50px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
styled_components_browser_esm["default"].div(_templateObject10 || (_templateObject10 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n"])));
styled_components_browser_esm["default"].div(_templateObject11 || (_templateObject11 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n\tmargin-left: 4px;\n"])));
var growth_dweb_header_esm_ArrowIcon = styled_components_browser_esm["default"].div(_templateObject12 || (_templateObject12 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder: solid #2274e0;\n\tborder-width: 0 2px 2px 0;\n\tdisplay: inline-block;\n\tpadding: 2px;\n\tmargin-left: auto;\n\n\t&.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t&.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t&.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t&.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var _templateObject$4, _templateObject2$2, _templateObject3$1;
var MainWrapper = styled_components_browser_esm["default"].div(_templateObject$4 || (_templateObject$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n    position: relative;\n    overflow: hidden;\n    width: 100vw;\n    max-width: 100%;\n"])));
var growth_dweb_header_esm_List = styled_components_browser_esm["default"].ul(_templateObject2$2 || (_templateObject2$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  /* overflow: hidden; */\n  transform: ", ";\n    transition: transform 300ms ease-in-out;\n    -webkit-transition: transform 300ms ease-in-out;\n"])), function (props) {
  return "translateY(-" + props.height + ")";
});
var growth_dweb_header_esm_ListItem = styled_components_browser_esm["default"].li(_templateObject3$1 || (_templateObject3$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  width: 200px;\n"])));

var Carousal = function Carousal(_ref) {
  var _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      contentHeight = _ref.contentHeight,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$loopCount = _ref.loopCount,
      loopCount = _ref$loopCount === void 0 ? 1 : _ref$loopCount;
  var listCount = list.length;
  var listRef = (0,react.useRef)(null);
  var positionRef = (0,react.useRef)(-contentHeight);
  var duration = 0.5;
  var endPosition = listCount * -contentHeight;
  var RotationCount = (0,react.useRef)(1);
  var timeoutId = (0,react.useRef)();

  function nextSlide() {
    if (!listRef.current) {
      return;
    }

    positionRef.current -= contentHeight;

    if (listRef.current) {
      listRef.current.style.transform = "translateY(" + positionRef.current + "px)";
      listRef.current.style.transitionDuration = duration + "s";
    }
  }

  function rotateSlide() {
    if (!listRef.current) {
      return;
    }

    positionRef.current = -contentHeight;
    setTimeout(function () {
      if (listRef.current) {
        listRef.current.style.transform = "translateY(-" + contentHeight + "px)";
        listRef.current.style.transitionDuration = '0s';
      }
    }, 1000);
  }

  var rotate = function rotate() {
    if (!listRef.current) {
      return;
    }

    if (positionRef.current === endPosition) {
      nextSlide();
      rotateSlide();
      RotationCount.current += 1;
    } else {
      nextSlide();
    }

    if (RotationCount.current <= loopCount) {
      timeoutId.current = setTimeout(function () {
        rotate();
      }, 2000);
    }
  };

  (0,react.useEffect)(function () {
    // if list length is greater than 1 and loop is true make loop 2 times otherwise only once
    if (listCount > 1) {
      if (loop) {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      } else {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      }
    }

    return function () {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [loop, listCount]);

  var isTextItem = function isTextItem(item) {
    return typeof item === 'object' && 'text' in item;
  };

  var lastItem = list[listCount - 1];
  var firstItem = list[0];
  return /*#__PURE__*/react.createElement(MainWrapper, {
    style: {
      height: contentHeight + "px"
    }
  }, /*#__PURE__*/react.createElement(growth_dweb_header_esm_List, {
    ref: listRef,
    height: contentHeight + "px"
  }, /*#__PURE__*/react.createElement(growth_dweb_header_esm_ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(lastItem) ? lastItem.text : /*#__PURE__*/react.createElement(lastItem.component, lastItem.props)), list.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      react.createElement(growth_dweb_header_esm_ListItem, {
        key: "txt_para_" + index,
        style: {
          height: contentHeight + "px"
        }
      }, isTextItem(item) ? item.text : /*#__PURE__*/react.createElement(item.component, item.props))
    );
  }), /*#__PURE__*/react.createElement(growth_dweb_header_esm_ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(firstItem) ? firstItem.text : /*#__PURE__*/react.createElement(firstItem.component, firstItem.props))));
};

var GuestDetails = function GuestDetails() {
  var contentToScroll = [].concat(W_LOGIN_WIDGET_CTA);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(UserAvatar, null), /*#__PURE__*/react.createElement(SignUpCtaTextWrap, {
    role: "presentation",
    id: "get_sign_in"
  }, /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 16,
    loop: false,
    loopCount: 1
  })));
};

var _templateObject$3, _templateObject2$1;
var GotribeInfoWrap = styled_components_browser_esm["default"].div(_templateObject$3 || (_templateObject$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var GotribeBadge = styled_components_browser_esm["default"].span(_templateObject2$1 || (_templateObject2$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 2px 5px;\n\tborder-radius: 7px;\n\tbackground-image: ", ";\n\n\tcolor: #fff;\n\t", "\n"])), function (_ref) {
  var memberType = _ref.memberType;
  return memberType === GOTRIBE_MEMBER_TYPES.superstar.value ? 'linear-gradient(to right, #fa961a 19%, #ffb305 95%)' : 'linear-gradient(to right, #e63148 40%, #ff4e00)';
}, growth_design_system_esm/* textSizes.SmallW3 */.iH.SmallW3);

var GoTribeMember = function GoTribeMember(props) {
  var memberType = props.memberType;
  return /*#__PURE__*/react.createElement(react.Fragment, null, isGoTribeMember(memberType) ? /*#__PURE__*/react.createElement(GotribeInfoWrap, null, /*#__PURE__*/react.createElement("span", {
    className: "dropdown-sprite gotribeLogo"
  }), /*#__PURE__*/react.createElement(GotribeBadge, {
    memberType: memberType
  }, GOTRIBE_MEMBER_TYPES[memberType].label)) : null);
};

var UserDetails = function UserDetails(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
      loading = _ref.loading,
      profileImage = _ref.profileImage,
      firstName = _ref.firstName,
      loyaltyMemberType = _ref.loyaltyMemberType;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: profileImage,
    firstName: firstName,
    isLoggedIn: isLoggedIn,
    loading: loading
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement("span", null, "Hey"), /*#__PURE__*/react.createElement(UserNameText, null, firstName)), /*#__PURE__*/react.createElement(GoTribeMember, {
    memberType: loyaltyMemberType
  })));
};

var GocashDetails = function GocashDetails(_ref) {
  var balance = _ref.balance,
      gocashLoading = _ref.gocashLoading;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: "https://go-assets.ibcdn.com/u/GI/images/1710408879842-gocash-gold.png"
  }), /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#000",
    size: "SmallW2"
  }, "Gocash"), !gocashLoading && /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW1",
    as: "span"
  }, "Balance:", /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW3",
    as: "span"
  }, "\u20B9", balance))));
};

var LoggedInDetails = function LoggedInDetails(_ref) {
  var loading = _ref.loading,
      profileImage = _ref.profileImage,
      firstName = _ref.firstName,
      loyaltyMemberType = _ref.loyaltyMemberType;

  var _useGoCashBalanceStor = useGoCashBalanceStore(),
      gocashData = _useGoCashBalanceStor.data,
      gocashLoaded = _useGoCashBalanceStor.loaded,
      gocashLoading = _useGoCashBalanceStor.loading,
      gocashError = _useGoCashBalanceStor.error;

  var balance = gocashData.balance;
  var content = [{
    component: UserDetails,
    props: {
      isLoggedIn: true,
      firstName: firstName,
      loading: loading,
      profileImage: profileImage,
      loyaltyMemberType: loyaltyMemberType
    }
  }];
  /* add items in animation content */
  // Gocash

  if (gocashLoaded && !gocashError) {
    content.push({
      component: GocashDetails,
      props: {
        balance: balance,
        gocashLoading: gocashLoading
      }
    });
  }

  var contentToScroll = [].concat(content);
  return /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 32,
    loop: true,
    loopCount: 2
  });
};

var UserLoginWidget = function UserLoginWidget(props) {
  var _useProfileStore = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return {
      $userDetails: s.data,
      loading: s.loading
    };
  }, shallow/* shallow */.X),
      $userDetails = _useProfileStore.$userDetails,
      loading = _useProfileStore.loading;

  var showLogin = props.showLogin,
      onLogoutSuccess = props.onLogoutSuccess,
      reloadAfterLogout = props.reloadAfterLogout,
      isLoginPopoverVisible = props.isLoginPopoverVisible,
      lobName = props.lobName,
      navOrigin = props.navOrigin,
      upComingTripCounts = props.upComingTripCounts;

  var _useState = (0,react.useState)(false),
      showUserDropDown = _useState[0],
      updateShowUserDropDown = _useState[1];

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;
      var adobe = _useAnalytics.adobe;

  (0,react.useRef)('');
  var dropDownTimer;
  var hasMounted = (0,growth_custom_hooks_useHasMounted_esm/* useHasMounted */.f)();
  var loyaltyUserInfoData = useLoyaltyUserInfoStore(function (s) {
    return s.data;
  });
  var loyaltyMemberType = selectLoyaltyMemberType(loyaltyUserInfoData);

  var handleLogout = function handleLogout() {
    updateShowUserDropDown(false);
    (0,growth_auth_helpers_esm/* fetchLogoutUser */.hM)({
      platform: 'dweb'
    }).then(function () {
      updateShowUserDropDown(false);
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);

      if (onLogoutSuccess) {
        growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);
        onLogoutSuccess();
      } else if (reloadAfterLogout) window.location.reload();
    });
  };

  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
      handleLogout();
    });
    return function () {
      return growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
        handleLogout();
      });
    };
  }, []);
  var toggleUserDropDown = (0,react.useCallback)(function () {
    updateShowUserDropDown(!showUserDropDown);
  }, [showUserDropDown]);

  var handleOnLoginWidgetClick = function handleOnLoginWidgetClick(_ref) {
    var name = _ref.name,
        componentName = _ref.componentName;
    if (loading) return;

    if (!$userDetails.isLoggedIn) {
      (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_login_btn", {
        event_detail: {
          event_type: "click_event",
          event_value: lobName
        }
      });
      adobe.track('ctaClick', {
        cta: {
          name: "" + name,
          type: 'itemClick',
          componentName: componentName
        }
      });
      showLogin();
    } else {
      (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_nav_widget", {
        event_detail: {
          event_type: "click_event|shopper_click",
          event_value: lobName + "|" + name
        }
      });
      toggleUserDropDown();
    }
  }; // using this function to show dropdown on hover


  var showDropDown = function showDropDown() {
    if (!isLoginPopoverVisible && !loading) {
      clearTimeout(dropDownTimer);
      updateShowUserDropDown(true);
    }
  }; // function to hide dropdown on mouse leave and
  // adding delay so that when mouse leave user can focus on dropdown list


  var hideDropDown = function hideDropDown() {
    dropDownTimer = setTimeout(function () {
      if (!loading) {
        updateShowUserDropDown(false);
      }
    }, 200);
  };

  var firstName = ($userDetails == null ? void 0 : $userDetails.firstName) || DEFAULT_PROFILE_NAME;
  return /*#__PURE__*/react.createElement(LoginTab, {
    onFocus: showDropDown,
    onMouseOver: showDropDown,
    onMouseLeave: hideDropDown,
    "data-id": "user-info-tab"
  }, /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LoginTabWrapper, {
    role: "presentation",
    onClick: function onClick() {
      return handleOnLoginWidgetClick({
        name: 'login',
        componentName: 'header'
      });
    }
  }, !hasMounted || loading ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CircularShimmer, null), /*#__PURE__*/react.createElement(HorizontalShimmer, null)) : /*#__PURE__*/react.createElement(react.Fragment, null, $userDetails.isLoggedIn ? /*#__PURE__*/react.createElement(LoggedInDetails, {
    loading: loading,
    profileImage: $userDetails == null ? void 0 : $userDetails.profileImage,
    firstName: firstName,
    loyaltyMemberType: loyaltyMemberType
  }) : /*#__PURE__*/react.createElement(GuestDetails, null), /*#__PURE__*/react.createElement(growth_dweb_header_esm_ArrowIcon, {
    className: "" + (showUserDropDown ? 'up' : 'down')
  }))), showUserDropDown && /*#__PURE__*/react.createElement(UserDropDown, {
    lobName: lobName,
    handleLogout: handleLogout,
    userInfo: $userDetails,
    isLoggedIn: $userDetails.isLoggedIn,
    hideDropDown: function hideDropDown() {
      return updateShowUserDropDown(false);
    },
    memberType: loyaltyMemberType,
    upcomingTripCount: upComingTripCounts,
    onLoginCtaClick: handleOnLoginWidgetClick,
    navOrigin: navOrigin,
    positionStyle: {
      top: '53px',
      left: '-66px'
    }
  })));
};

var _templateObject$2, growth_dweb_header_esm_templateObject2, growth_dweb_header_esm_templateObject3, growth_dweb_header_esm_templateObject4, growth_dweb_header_esm_templateObject5, _templateObject6, _templateObject7;
var bounce = (0,styled_components_browser_esm.keyframes)(_templateObject$2 || (_templateObject$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-30px);\n  }\n  60% {\n    transform: translateY(-15px);\n  }\n"])));
var HappyLsPop = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject2 || (growth_dweb_header_esm_templateObject2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 250px;\n\tposition: absolute;\n\ttop: 65px;\n\tright: 60px;\n\tpadding: 15px 10px;\n\tborder-radius: 10px;\n\tbox-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);\n\tbackground-color: #fff;\n\tz-index: 11;\n\tanimation: ", " 2s 2;\n\n\t&::after {\n\t\tbottom: 100%;\n\t\tleft: 90%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n"])), bounce);
var LsPopOffer = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject3 || (growth_dweb_header_esm_templateObject3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tpadding: 11px 10px;\n\tborder-radius: 8px;\n\tbackground-color: rgba(80, 227, 194, 0.1);\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 7px 0 0;\n"])));
var LsPopOfferIcon = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject4 || (growth_dweb_header_esm_templateObject4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\tflex-shrink: 0;\n\tmargin-right: 16px;\n\n\timg {\n\t\tmax-width: 100%;\n\t}\n"])));
var LsPopOfferTitle = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject5 || (growth_dweb_header_esm_templateObject5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #268570;\n\tfont-size: 14px;\n\n\t> span:nth-child(1) {\n\t\tvertical-align: middle;\n\t}\n"])));
var LsPopOfferSubtitle = styled_components_browser_esm["default"].div(_templateObject6 || (_templateObject6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 3px;\n"])));
var SignUpButton = styled_components_browser_esm["default"].button(_templateObject7 || (_templateObject7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", ";\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);

var LoginSignupPopup = function LoginSignupPopup(_ref) {
  var _persuationsText$sign;

  var onLogin = _ref.onLogin,
      closePopOver = _ref.closePopOver,
      persuationsText = _ref.persuationsText;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  function closePopup(event) {
    if (!event.target.closest('.happy-lsPop')) {
      if (closePopOver) closePopOver();
    }
  }

  (0,react.useEffect)(function () {
    /**
     * this listeners check if popover is shown then if click is outside the popover
     * it closes the popover
     */
    document.addEventListener('click', closePopup);
    pdt.track('growth_non_int_HEADER_POPOVER_LOGIN_VISIBLES');
    return function () {
      document.removeEventListener('click', closePopup);
    };
  }, []);

  var handleCtaClick = function handleCtaClick() {
    pdt.track('growth_int_HEADER_POPOVER_CTA_CLICK');
    adobe.track('ctaClick', {
      cta: {
        name: "Login Popover",
        type: 'itemClick',
        componentName: 'Login Popover',
        destination: 'Login Popup'
      }
    });
    onLogin();
  };

  return /*#__PURE__*/react.createElement(HappyLsPop, {
    "data-id": "header-popover"
  }, /*#__PURE__*/react.createElement(SignUpButton, {
    onClick: handleCtaClick,
    type: "button"
  }, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2"
  }, persuationsText == null ? void 0 : (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText)), /*#__PURE__*/react.createElement(LsPopOffer, null, /*#__PURE__*/react.createElement(LsPopOfferIcon, null, /*#__PURE__*/react.createElement("img", {
    src: "https://gos3.ibcdn.com/login-gift-1607962961.png",
    alt: "Offer"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(LsPopOfferTitle, null, /*#__PURE__*/react.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: persuationsText == null ? void 0 : persuationsText.title
    }
  })), /*#__PURE__*/react.createElement(LsPopOfferSubtitle, null, persuationsText == null ? void 0 : persuationsText.subTitle))));
};

function growth_dweb_header_esm_setPrototypeOf(o, p) {
  growth_dweb_header_esm_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return growth_dweb_header_esm_setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  growth_dweb_header_esm_setPrototypeOf(subClass, superClass);
}

var growth_dweb_header_esm_ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBoundary, _Component);

  function ErrorBoundary(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {// You can also log the error to an error reporting service
    // console.log('Error', error, errorInfo)
  };

  _proto.render = function render() {
    var hasError = this.state.hasError;
    var children = this.props.children;

    if (hasError) {
      // You can render any custom fallback UI
      return null;
    }

    return children;
  };

  return ErrorBoundary;
}(react.Component);

/** Create a new configStore instance for desktop header */

var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var hasTimeExpired = function hasTimeExpired(expDate) {
  var xDate = new Date(expDate);

  if (!Number.isNaN(xDate.getDate())) {
    var cDate = new Date();
    if (cDate > xDate) return true;
    return false;
  }

  return false;
};

var useFestivalTheme = function useFestivalTheme(_ref) {
  var headerLogoRef = _ref.headerLogoRef;

  var _useConfigStore = useConfigStore(function (s) {
    return s;
  }),
      configStoreData = _useConfigStore.data,
      configStoreDataLoaded = _useConfigStore.loaded;

  (0,react.useEffect)(function () {
    var _configStoreData$COMM, _configData$data;

    var configData = configStoreData == null ? void 0 : (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm.CONFIG_KEY_DWEB_AUTH];

    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.festivalTheme) {
      var _themes$date;

      var themes = configData.data.festivalTheme; // we keep expire date for special theme.
      // check if theme is still valid for today
      // date format: MM/DD/YYYY

      var expireTime = themes == null ? void 0 : (_themes$date = themes.date) == null ? void 0 : _themes$date.expire;
      if (expireTime && hasTimeExpired(expireTime)) return; // apply special theme to dom direclty, to avoid rerender
      // goibibo image

      if (themes != null && themes.gi_logo && headerLogoRef.current) {
        var giLogoElm = headerLogoRef.current;
        giLogoElm.style.backgroundImage = "url(" + themes.gi_logo + ")";
        giLogoElm.classList.remove('header-sprite', 'logo', 'gi-logo');
        giLogoElm.classList.add('special-logo');
      }
    }
  }, [configStoreData, configStoreDataLoaded, headerLogoRef]);
};

var LOGIN_POPOVER_TIMEOUT = 10000; // 10sec

var useLoginPopover = function useLoginPopover(_ref) {
  var _configStoreData$COMM;

  var loginPersuation = _ref.loginPersuation,
      loginPersuationTimeout = _ref.loginPersuationTimeout,
      sticky = _ref.sticky,
      lobName = _ref.lobName;

  var _useConfigStore = useConfigStore(function (s) {
    return s;
  }),
      configStoreData = _useConfigStore.data,
      configStoreDataLoaded = _useConfigStore.loaded;

  var configData = configStoreData == null ? void 0 : (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm.CONFIG_KEY_DWEB_AUTH];

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShowLoginPopover = _useState[1];

  var popoverTimerTimeout = (0,react.useRef)(0);

  var closeLogInPopover = function closeLogInPopover() {
    setShowLoginPopover(false);
  };

  var setLoginPopoverTimer = function setLoginPopoverTimer(time) {
    if (popoverTimerTimeout.current) {
      // Exception?
      return;
    } // Remember the timer handle


    popoverTimerTimeout.current = setTimeout(function () {
      closeLogInPopover();
    }, time);
  };

  var showLoginPopOver = function showLoginPopOver(persuationsText) {
    setShowLoginPopover(persuationsText);
    var timeout = loginPersuationTimeout || LOGIN_POPOVER_TIMEOUT;
    setLoginPopoverTimer(timeout);
  };

  var clearLoginPopoverTimer = function clearLoginPopoverTimer() {
    // Is our timer running?
    if (popoverTimerTimeout.current) {
      // Yes, clear it
      clearTimeout(popoverTimerTimeout.current);
    }
  };

  var setLoginPopoverVisiblity = (0,react.useCallback)(function () {
    var _configData$data, _configData$data2;

    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.loginPopover && configData != null && (_configData$data2 = configData.data) != null && _configData$data2.bookingOffers) {
      var _configData$data3 = configData.data,
          _configData$data3$boo = _configData$data3.bookingOffers,
          bookingOffers = _configData$data3$boo === void 0 ? {} : _configData$data3$boo,
          _configData$data3$log = _configData$data3.loginPopover,
          loginPopover = _configData$data3$log === void 0 ? {} : _configData$data3$log; // lob wise offers text comes from api, select only offer that need to
      // display on current lob

      var persuationsText = growth_dweb_header_esm_extends({}, bookingOffers == null ? void 0 : bookingOffers[lobName], loginPopover);

      if (loginPersuation) {
        var _persuationsText$sign;

        var mandatoryTextToDisplayUI = (persuationsText == null ? void 0 : persuationsText.title) && (persuationsText == null ? void 0 : persuationsText.subTitle) && (persuationsText == null ? void 0 : (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText);

        if (!(0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)() && mandatoryTextToDisplayUI) {
          showLoginPopOver(persuationsText);
        } else {
          closeLogInPopover();
        }
      }
    }
  }, [configStoreDataLoaded, lobName, loginPersuation, sticky]);
  (0,react.useEffect)(function () {
    /**
     * on load don't show login popover in "non sticky" header. It does not fit when user scrolls
     * the page when popover is visible in header
     *
     * NOTE: we allow to show popover for no sticky header also via 'SHOW_LOGIN_POP_OVER' dom event
     */
    if (sticky) {
      setLoginPopoverVisiblity();
    }

    return function () {
      clearLoginPopoverTimer();
    };
  }, [setLoginPopoverVisiblity]);
  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    };
  }, [setLoginPopoverVisiblity]);
  return {
    closeLogInPopover: closeLogInPopover,
    show: show
  };
};

var Header$1 = function Header(props) {
  var handleOnLoginModalOpen = props.handleOnLoginModalOpen,
      onLogoutSuccess = props.onLogoutSuccess,
      sticky = props.sticky,
      lobName = props.lobName,
      reloadAfterLogout = props.reloadAfterLogout,
      _props$loginPersuatio = props.loginPersuation,
      loginPersuation = _props$loginPersuatio === void 0 ? true : _props$loginPersuatio,
      loginPersuationTimeout = props.loginPersuationTimeout,
      headerStyle = props.headerStyle,
      _props$navOrigin = props.navOrigin,
      navOrigin = _props$navOrigin === void 0 ? '' : _props$navOrigin;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;

  var isLoggedIn = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.data.isLoggedIn;
  });
  var bookingSummaryState = useBookingSummaryStore(function (s) {
    return s;
  });
  var upComingTripCounts = selectUpcomingBookingsCount(bookingSummaryState);
  var headerLogoRef = (0,react.useRef)(null);
  var headerLeftThemeRef = (0,react.useRef)(null);
  /**
   * For any special occasions we change gi logo and few theme images.
   * we get this images from api, right now and apply in client side.
   */

  useFestivalTheme({
    headerLogoRef: headerLogoRef
  });

  var _useLoginPopover = useLoginPopover({
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    sticky: sticky,
    lobName: lobName
  }),
      loginPopover = _useLoginPopover.show,
      closeLogInPopover = _useLoginPopover.closeLogInPopover;

  function popoverLoginHandler() {
    // pdt.track('HAPPY_HEADER_WEBA__CLICK_POPOVER_LOGIN_BTN');
    handleOnLoginModalOpen();
  }

  var giLogoClickTargetUrl = navOrigin + lobsPathName.HOME;
  return /*#__PURE__*/react.createElement(HappyGiHeader, {
    ref: headerLeftThemeRef,
    "data-id": "dweb-header-root",
    className: sticky ? 'header-sticky' : 'header-sticky-nope',
    style: headerStyle
  }, /*#__PURE__*/react.createElement(HeaderLogo, {
    homeURL: giLogoClickTargetUrl,
    ref: headerLogoRef,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(NavBar, {
    navList: lobsNavList(navOrigin),
    lobName: lobName
  }), ' ', /*#__PURE__*/react.createElement(LoginWidgetWrapper, null, /*#__PURE__*/react.createElement(NavWidgets, {
    isLoggedIn: isLoggedIn || false,
    upcomingTrip: upComingTripCounts,
    navOrigin: navOrigin,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(growth_dweb_header_esm_ErrorBoundary, null, /*#__PURE__*/react.createElement(UserLoginWidget, {
    lobName: lobName,
    onLogoutSuccess: onLogoutSuccess,
    showLogin: handleOnLoginModalOpen,
    reloadAfterLogout: reloadAfterLogout,
    isLoginPopoverVisible: loginPopover,
    navOrigin: navOrigin,
    upComingTripCounts: upComingTripCounts
  }))), loginPopover && /*#__PURE__*/react.createElement(LoginSignupPopup, {
    closePopOver: function closePopOver() {
      return closeLogInPopover();
    },
    onLogin: function onLogin() {
      return popoverLoginHandler();
    },
    persuationsText: loginPopover
  }));
};

var AuthFlowModal = function AuthFlowModal(props) {
  var onLoginClose = props.onLoginClose,
      onLoginSuccess = props.onLoginSuccess,
      lobName = props.lobName,
      modalStyle = props.modalStyle,
      shouldShowCloseButton = props.shouldShowCloseButton;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  var handleModalClose = function handleModalClose() {
    onLoginClose();
  };

  (0,react.useEffect)(function () {
    pdt.track('HAPPY_AUTH_WEBA__UX_LOGIN_DIALOG_OPEN', {
      ab_experiment: 'happy-auth'
    });
    adobe.track('Login_Popup_Load');
  }, []);
  return /*#__PURE__*/react.createElement(index_0b639158_esm_Modal, {
    rootStyle: growth_dweb_header_esm_extends({
      background: 'transparent'
    }, modalStyle)
    /** dweb-auth have a close button, hide the close button of modal */
    ,
    closeBtnStyle: {
      display: 'none'
    },
    onClose: handleModalClose
  }, /*#__PURE__*/react.createElement(growth_gi_dweb_auth_esm["default"], {
    onClose: handleModalClose,
    lobName: lobName,
    onLoginSuccess: onLoginSuccess,
    showCloseButton: shouldShowCloseButton
  }));
};

var _templateObject$1;
var HeaderContainer$1 = styled_components_browser_esm["default"].div(_templateObject$1 || (_templateObject$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\theight: 64px;\n\twidth: 100%;\n"])));

var HeaderContainer = function HeaderContainer(props) {
  var onLoginSuccess = props.onLoginSuccess,
      lobName = props.lobName,
      onLogoutSuccess = props.onLogoutSuccess,
      sticky = props.sticky,
      reloadAfterLogout = props.reloadAfterLogout,
      loginPersuation = props.loginPersuation,
      loginPersuationTimeout = props.loginPersuationTimeout,
      hideHeader = props.hideHeader,
      headerStyle = props.headerStyle,
      modalStyle = props.modalStyle,
      shouldShowCloseButton = props.shouldShowCloseButton,
      navOrigin = props.navOrigin;

  var _useState = (0,react.useState)(false),
      loginModal = _useState[0],
      toggleLoginModal = _useState[1];

  var fetchProfileDetails = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchBookingSummary = useBookingSummaryStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchLoyaltyInfo = useLoyaltyUserInfoStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchGocash = useGoCashBalanceStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;

  var onProfileDetailsError = function onProfileDetailsError(err) {
    if ((err == null ? void 0 : err.status) === 404) {
      (0,growth_auth_helpers_esm/* clearUserTokens */.H)();
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT);
    }
  };

  var fetchAllHeaderData = (0,react.useCallback)(function () {
    var token = (0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)();

    if (token) {
      var userDetail = fetchProfileDetails({
        platform: 'dweb',
        onError: onProfileDetailsError
      });
      Promise.all([fetchLoyaltyInfo(), fetchBookingSummary(), fetchGocash()]);
      return userDetail;
    }

    return Promise.resolve({});
  }, []); // close the login modal

  var handleOnLoginModalClose = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return false;
    });
  }, []); // open the login modal

  var handleOnLoginModalOpen = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return true;
    });
  }, []);
  var handleOnLoginSuccess = (0,react.useCallback)(function () {
    if (onLoginSuccess) onLoginSuccess();
    fetchAllHeaderData();
  }, [onLoginSuccess, fetchAllHeaderData]);
  (0,react.useEffect)(function () {
    /** allow refresh the header data from outside
     * usecases:
     * - when new profile image or details are updated in profile page by user we would want to see the
     *   updated info in header as well
     * - when logout happens from somewhere outside the header, we would refresh the data again
     */
    // put all global Header/Auth event listners here.
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
      fetchAllHeaderData();
    });
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
        fetchAllHeaderData();
      });
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    };
  }, []);
  (0,react.useEffect)(function () {
    // hydrate store with require data and trigger load events
    function loadInitialData() {
      return _loadInitialData.apply(this, arguments);
    }

    function _loadInitialData() {
      _loadInitialData = growth_dweb_header_esm_asyncToGenerator( /*#__PURE__*/growth_dweb_header_esm_regeneratorRuntime().mark(function _callee() {
        return growth_dweb_header_esm_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  fetchAllHeaderData(); // pdt.setUserVars({
                  // 	user: {
                  // 		uuid: window?.atob(getEncryptedUuid() || ''),
                  // 	},
                  // 	lob: lobName,
                  // });
                  // pdt.track('HEADER_LOADED', {
                  // 	item_position: sticky ? 'sticky' : 'scroll',
                  // });
                } catch (e) {// pdt.setUserVars({
                  // 	user: {
                  // 		uuid: 'error',
                  // 	},
                  // 	lob: lobName,
                  // });
                  // pdt.track('HEADER_LOADED', {
                  // 	item_position: sticky ? 'sticky' : 'scroll',
                  // });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadInitialData.apply(this, arguments);
    }

    loadInitialData();
  }, []);
  return /*#__PURE__*/react.createElement(react.Fragment, null, !hideHeader && /*#__PURE__*/react.createElement(HeaderContainer$1, null, /*#__PURE__*/react.createElement(Header$1, {
    handleOnLoginModalOpen: handleOnLoginModalOpen,
    lobName: lobName,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLogoutSuccess: onLogoutSuccess,
    sticky: sticky,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    navOrigin: navOrigin
  })), loginModal && /*#__PURE__*/react.createElement(AuthFlowModal, {
    shouldShowCloseButton: shouldShowCloseButton,
    lobName: lobName,
    onLoginSuccess: handleOnLoginSuccess,
    onLoginClose: handleOnLoginModalClose,
    modalStyle: modalStyle
  }));
};

var growth_dweb_header_esm_templateObject;
var Style = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject || (growth_dweb_header_esm_templateObject = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t.header-sprite,\n\t.dropdown-sprite {\n\t\tbackground: url(https://gos3.ibcdn.com/giHeaderSprite-1697090884.png) 0 0 no-repeat;\n\t\tbackground-size: 125px 200px;\n\t\tdisplay: block;\n\t\tflex-shrink: 0;\n\t}\n\n\t.header-sprite.logo {\n\t\twidth: 104px;\n\t\theight: 30px;\n\t\tbackground-position: -2px -1px;\n\t}\n\n\t.header-sprite.nav-icon-flights {\n\t\twidth: 32px;\n\t\theight: 20px;\n\t\tbackground-position: -69px -33px;\n\t}\n\n\t.header-sprite.nav-icon-hotels {\n\t\twidth: 24px;\n\t\theight: 22px;\n\t\tbackground-position: -4px -178px;\n\t}\n\n\t.header-sprite.nav-icon-bus {\n\t\twidth: 32px;\n\t\theight: 14px;\n\t\tbackground-position: -3px -89px;\n\t}\n\n\t.header-sprite.nav-icon-trains {\n\t\twidth: 36px;\n\t\theight: 16px;\n\t\tbackground-position: -3px -52px;\n\t}\n\n\t.header-sprite.nav-icon-cabs {\n\t\twidth: 34px;\n\t\theight: 16px;\n\t\tbackground-position: -1px -69px;\n\t}\n\n\t.header-sprite.nav-icon-holiday {\n\t\twidth: 26px;\n\t\theight: 21px;\n\t\tbackground-position: -3px -105px;\n\t}\n\n\t.header-sprite.nav-icon-forex {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -131px;\n\t}\n\n\t.header-sprite.nav-icon-insurance {\n\t\twidth: 20px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -153px;\n\t}\n\n\t.header-sprite.user-icon {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tbackground-position: -41px -56px;\n\t}\n\n\t.header-sprite.mytrip-icon {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -43px -33px;\n\t}\n\t/* -- DropDown Icons sprites -- */\n\t.dropdown-sprite.gotribeLogo {\n\t\twidth: 50px;\n\t\theight: 14px;\n\t\tbackground-position: -38px -86px;\n\t}\n\t.dropdown-sprite.gotribe {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -2px -33px;\n\t}\n\t.dropdown-sprite.offers {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -19px;\n\t}\n\t.dropdown-sprite.mytrip {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -1px;\n\t}\n\t.dropdown-sprite.gocash {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -22px -33px;\n\t}\n\t/* -- CSS Icons -- */\n\t.arrow-icon {\n\t\tborder: solid #2274e0;\n\t\tborder-width: 0 2px 2px 0;\n\t\tdisplay: inline-block;\n\t\tpadding: 2px;\n\t\tmargin-left: auto;\n\t}\n\n\t.arrow-icon.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t.arrow-icon.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t.arrow-icon.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t.arrow-icon.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var RootHoc = function RootHoc(Component) {
  var WithHOC = function WithHOC(props) {
    var headerEnv = props.headerEnv,
        lobName = props.lobName,
        adobeLobName = props.adobeLobName,
        configData = props.configData;
    /** Memorize b/c we don't want to call the setData again if there in no change in configData */

    (0,react.useMemo)(function () {
      if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
    }, [configData]);
    var fetchConfigStoreData = useConfigStore(function (s) {
      return s.fetch;
    }, shallow/* shallow */.X);
    (0,react.useEffect)(function () {
      fetchConfigStoreData({
        keys: 'growth-dweb-header-config',
        lobs: 'COMMON',
        cacheOpts: {
          ttl: 15 // min

        },
        initData: configData
      });
    }, []); // Analytics plugin initialization

    var pdtInstance = {};
    var adobeInstance = {};

    if (growth_ssr_utils_esm/* isOnClient */.BK) {
      var _window$adobeDataLaye, _window$adobeDataLaye2;

      pdtInstance = new growth_web_analytics_esm/* default */.Z();
      adobeInstance = new growth_web_analytics_esm/* default */.Z();
      pdtInstance.initialize({
        plugin: (0,growth_analytics_plugin_pdt_esm/* default */.Z)({
          debug: false
        }),
        globalProperties: {
          context: {
            environment: headerEnv || 'error'
          },
          eventProperties: {
            lob: lobName
          }
        },
        debug: false
      });
      var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
      var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
      adobeInstance.initialize({
        plugin: (0,growth_analytics_plugin_adobe_esm/* default */.Z)({
          page: {
            pageInfo: growth_dweb_header_esm_extends({}, pageInfo, {
              lob: adobeLobName || lobName
            })
          },
          account: {
            accountInfo: growth_dweb_header_esm_extends({}, accountInfo, {
              website: 'goibibo'
            })
          }
        }, false),
        debug: false
      });
    }

    return /*#__PURE__*/react.createElement(Style, null, /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      pdtInstance: pdtInstance,
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(Component, props)));
  };

  return WithHOC;
};

var HeaderComponent = function HeaderComponent(_ref) {
  var onLoginSuccess = _ref.onLoginSuccess,
      sticky = _ref.sticky,
      onLogoutSuccess = _ref.onLogoutSuccess,
      lobName = _ref.lobName,
      reloadAfterLogout = _ref.reloadAfterLogout,
      headerEnv = _ref.headerEnv,
      loginPersuation = _ref.loginPersuation,
      loginPersuationTimeout = _ref.loginPersuationTimeout,
      hideHeader = _ref.hideHeader,
      headerStyle = _ref.headerStyle,
      modalStyle = _ref.modalStyle,
      shouldShowCloseButton = _ref.shouldShowCloseButton,
      adobeLobName = _ref.adobeLobName,
      navOrigin = _ref.navOrigin,
      configData = _ref.configData;
  return /*#__PURE__*/react.createElement(HeaderContainer, {
    headerEnv: headerEnv,
    adobeLobName: adobeLobName,
    sticky: sticky,
    lobName: lobName,
    hideHeader: hideHeader,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLoginSuccess: onLoginSuccess,
    onLogoutSuccess: onLogoutSuccess,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    modalStyle: modalStyle,
    shouldShowCloseButton: shouldShowCloseButton,
    configData: configData,
    navOrigin: navOrigin
  });
};

var growth_dweb_header_esm_Header = RootHoc(HeaderComponent);

var showLoginPopOverEvent = function showLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER);
};

var hideLoginPopOverEvent = function hideLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER);
};



;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GIInsuranceHeader/index.tsx


function GIInsuranceHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GIInsuranceHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GIInsuranceHeader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GIInsuranceHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var GiDwebAuth = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3858)).then(function (p) {
    return p.default;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(3858)];
    }
  }
});
var GiMwebAuth = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4258).then(__webpack_require__.bind(__webpack_require__, 4258)).then(function (p) {
    return p.MwebAuth;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4258)];
    }
  }
});
function GIInsuranceHeader_GIInsuranceHeader(_ref) {
  var _ref$headerProps = _ref.headerProps,
      headerProps = _ref$headerProps === void 0 ? {} : _ref$headerProps,
      _ref$mobileTitle = _ref.mobileTitle,
      mobileTitle = _ref$mobileTitle === void 0 ? "" : _ref$mobileTitle,
      _ref$forceLogin = _ref.forceLogin,
      forceLogin = _ref$forceLogin === void 0 ? false : _ref$forceLogin,
      myOrders = _ref.myOrders,
      goToMyOrders = _ref.goToMyOrders,
      displayWhiteHeader = _ref.displayWhiteHeader;
  var device = (0,ui_widgets_src.useBreakpointV2)();

  var headerPropsWithDefaults = GIInsuranceHeader_objectSpread({
    lobName: "insurance",
    sticky: true,
    shouldShowCloseButton: true,
    navOrigin: "https://www.goibibo.com"
  }, headerProps);

  var authComponent = null;

  var _useState = (0,react.useState)(forceLogin),
      isAuthComponentVisible = _useState[0],
      setIsAuthComponentVisible = _useState[1];

  if (isAuthComponentVisible) {
    authComponent = device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(GiDwebAuth, {
      prefillMobileNumber: undefined,
      showCloseButton: false,
      onClose: function onClose() {
        return console.log("Closed");
      },
      lobName: "insurance",
      onLoginSuccess: function onLoginSuccess() {
        return router_default().reload();
      },
      configData: undefined
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(GiMwebAuth, {
      prefillMobileNumber: undefined,
      showCloseButton: false,
      onClose: function onClose() {
        return console.log("Closed");
      },
      lobName: "",
      onLoginSuccess: function onLoginSuccess() {
        setIsAuthComponentVisible(false);
        setTimeout(function () {
          router_default().reload();
        }, 100);
      },
      showAuth: true
    });
    authComponent = /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.7)"
      },
      children: authComponent
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [authComponent, device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(growth_dweb_header_esm_Header, GIInsuranceHeader_objectSpread({}, headerPropsWithDefaults)) : /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeader_LandingHeaderMobile, {
      headerTitle: mobileTitle,
      myOrders: myOrders,
      goToMyOrders: goToMyOrders,
      displayWhiteHeader: displayWhiteHeader,
      partnerType: partner_PARTNER.GI,
      insuranceHeader: true
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withGIInsuranceHeader.tsx

var withGIInsuranceHeader_excluded = (/* unused pure expression or super */ null && (["Wrapper", "forceLogin"]));




function withGIInsuranceHeader(component) {
  var headerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mobileTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var myOrders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var goToMyOrders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return void 0;
  };
  var displayWhiteHeader = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var Wrapper = headerOptions.Wrapper,
      _headerOptions$forceL = headerOptions.forceLogin,
      forceLogin = _headerOptions$forceL === void 0 ? false : _headerOptions$forceL,
      headerProps = _objectWithoutProperties(headerOptions, withGIInsuranceHeader_excluded);

  var giHeaderWithAuth = /*#__PURE__*/_jsx(GIInsuranceHeader, {
    headerProps: headerProps,
    mobileTitle: mobileTitle,
    forceLogin: forceLogin,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader
  });

  if (forceLogin) {
    return giHeaderWithAuth;
  }

  if (Wrapper) {
    return /*#__PURE__*/_jsxs(Wrapper, {
      children: [giHeaderWithAuth, component]
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [giHeaderWithAuth, component]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withPartnerInsuranceHeader.tsx








function withPartnerInsuranceHeader(component) {
  var headerComponent = null;

  var _useState = (0,react.useState)(""),
      partnerHeader = _useState[0],
      setPartnerHeader = _useState[1];

  (0,react.useEffect)(function () {
    var partner = utils_getPartnerOnClientSide();
    setPartnerHeader(partner);
  }, []);

  if (partnerHeader === partner_PARTNER.MMT) {
    headerComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(MMTInsuranceHeader_MMTInsuranceHeader, {});
  } else if (partnerHeader === partner_PARTNER.GI) {
    headerComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(GIInsuranceHeader_GIInsuranceHeader, {});
  }

  if (headerComponent) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [headerComponent, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: component
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/index.ts




;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ErrorScreen/index.tsx










var ErrorScreen_analytics = getAnalytics();
var ErrorScreen_ErrorScreen = function ErrorScreen(_ref) {
  var _error$message3, _error$message4, _error$message5;

  var error = _ref.error,
      _ref$trackError = _ref.trackError,
      trackError = _ref$trackError === void 0 ? false : _ref$trackError,
      pageName = _ref.pageName;
  (0,react.useEffect)(function () {
    if (trackError && pageName && error && typeof error !== "string") {
      var _error$message, _error$message2;

      ErrorScreen_analytics === null || ErrorScreen_analytics === void 0 ? void 0 : ErrorScreen_analytics.trackPageLoadErrorEvent({
        pageName: pageName,
        actionType: "page_load_error",
        error: "".concat(error === null || error === void 0 ? void 0 : (_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.title, "|\n                  ").concat(error === null || error === void 0 ? void 0 : (_error$message2 = error.message) === null || _error$message2 === void 0 ? void 0 : _error$message2.description)
      });
    }
  }, [error, pageName, trackError]);
  var title = typeof error !== "string" && (error === null || error === void 0 ? void 0 : (_error$message3 = error.message) === null || _error$message3 === void 0 ? void 0 : _error$message3.title) || "Sorry!";
  var description = typeof error !== "string" && (error === null || error === void 0 ? void 0 : (_error$message4 = error.message) === null || _error$message4 === void 0 ? void 0 : _error$message4.description) || "We are having trouble communicating with the servers. Please try again.";
  var icon = typeof error !== "string" && (error === null || error === void 0 ? void 0 : (_error$message5 = error.message) === null || _error$message5 === void 0 ? void 0 : _error$message5.icon) || "https://tripmoneycmsimgak.mmtcdn.com/img/error_Img_1e80a42832.svg";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Tripmoney Error"
      })
    }), (0,ui_widgets_src.withDeviceProvider)(withPartnerInsuranceHeader( /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorPage, {
      title: title,
      info: description,
      errorImg: icon,
      headerComponent: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    })), (0,utility_src/* akamaiGetDevice */.tZ)({}))]
  });
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/header/index.style.ts
var index_style = __webpack_require__(6440);
// EXTERNAL MODULE: ../../libs/utility/src/lib/constants/index.ts + 2 modules
var src_lib_constants = __webpack_require__(9753);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/TMLogo/index.tsx






var TMLogo_Logo = function Logo(_ref) {
  var _ref$isLight = _ref.isLight,
      isLight = _ref$isLight === void 0 ? true : _ref$isLight;

  var _useState = useState(false),
      isClient = _useState[0],
      setIsClient = _useState[1];

  useEffect(function () {
    setIsClient(true);
  }, []);

  if (isClient) {
    if (isHostMakemytrip()) {
      if (!isLight) {
        return /*#__PURE__*/_jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "140",
          height: "39",
          fill: "none",
          viewBox: "0 0 266 86",
          children: [/*#__PURE__*/_jsx("mask", {
            id: "mask0_914_2",
            style: {
              maskType: "luminance"
            },
            width: "85",
            height: "86",
            x: "109",
            y: "0",
            maskUnits: "userSpaceOnUse",
            children: /*#__PURE__*/_jsx("path", {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M193.71 85.1V0h-84.499v85.1h84.499z",
              clipRule: "evenodd"
            })
          }), /*#__PURE__*/_jsxs("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            mask: "url(#mask0_914_2)",
            children: [/*#__PURE__*/_jsx("path", {
              fill: "#EB2226",
              d: "M193.707 19.267C193.707 8.64 185.191 0 174.691 0h-46.46c-10.504 0-19.019 8.64-19.019 19.267l.01 46.555c0 10.624 8.514 19.278 19.017 19.278h46.459c10.502 0 19.013-8.652 19.013-19.278l-.004-46.555z"
            }), /*#__PURE__*/_jsx("path", {
              fill: "#fff",
              d: "M186.738 29.11c-4.016 6.918-11.19 21.794-11.19 21.794s-3.614 8.03-5.142 16.236c-.679 3.65.633 7.888.633 7.888.981 4.186-3.668 3.036-3.668 3.036-3.396-1.122-3.302-5.684-3.302-5.684 0-6.733 2.979-13.24 4.725-17.596-6.134 2.431-9.003-3.565-7.257-9.62l-7.011 9.511c-2.257 2.667-4.479 2.144-4.479 2.144-.113 0-2.811-.33-2.674-3.95.066-1.752.556-9.065 1.117-11.78.057-.284-.111-.567-.337-.227-2.924 5.204-7.715 10.876-8.668 12.448-1.236 2.04-2.476 2.884-2.476 2.884-.996.808-2.726.197-2.726.197-1.774-.661-1.411-2.678-1.411-2.678l1.679-12.186c0-.167-.055-.225-.225-.225-.505 0-5.259 6.625-7.882 11.247l-1.718 2.793s-1.483 2.34-3.773.932c-1.791-1.102-1.228-3.16-1.228-3.16l4.912-20.794c0-.057 0-.396-.283-.396-1.518 0-1.95 3.982-4.027 4.059-1.045.038-1.583-.411-1.583-.411-1.417-.82-.745-2.946-.745-2.946s2.244-5.973 5.218-7.475c0 0 1.716-1.082 3.145-.889 1.429.194 3.717.539 2.516 7.096l-1.5 8.53s-.15.746.083.865c0 0 .37.37 1.117-.631l9.513-13.084c2.049-3.029 4.464-1.501 4.464-1.501 1.609.687 1.057 2.67 1.057 2.67s-4.688 14.483-4.688 15.84c0 .453.394.565.618.228 1.968-3 6.131-9.508 9.62-13.864 1.574-1.924 2.476-2.773 4.218-2.603 1.687.17 2.475 1.245 2.475 2.942 0 .283-.057.623-.111.963 0 0-3.095 10.694-3.321 16.408 0 0-.048.822.168.988.417.32.932-.4.932-.4 1.731-1.92 7.269-10.724 8.52-13.036l4.006-8.2s1.7-3.73 3.971-3.15c0 0 3.612.367 1.867 4.323-.286.647-3.037 5.144-5.4 14.426-.394 1.412-.901 5.544 1.63 5.544 1.125 0 2.589-.907 4.107-3.68l9.956-17.992c.843-.907 1.511-1.407 2.691-1.407 3.686 0 1.867 3.572 1.867 3.572z"
            })]
          }), /*#__PURE__*/_jsx("mask", {
            id: "mask1_914_2",
            style: {
              maskType: "luminance"
            },
            width: "32",
            height: "23",
            x: "0",
            y: "31",
            maskUnits: "userSpaceOnUse",
            children: /*#__PURE__*/_jsx("path", {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M0 53.217h31.918V31.534H0v21.683z",
              clipRule: "evenodd"
            })
          }), /*#__PURE__*/_jsx("g", {
            mask: "url(#mask1_914_2)",
            children: /*#__PURE__*/_jsx("path", {
              fill: "#124680",
              fillRule: "evenodd",
              d: "M18.593 53.217h-5.268V41.29c0-1.7-.269-2.969-.804-3.806-.536-.836-1.441-1.256-2.72-1.256-.93 0-1.782.231-2.556.694-.776.465-1.434 1.124-1.977 1.978v14.318H0V31.555h3l1.98 2.913c.426-.39 1.072-.88 1.595-1.22.523-.34 1.075-.639 1.657-.893a10.46 10.46 0 011.83-.6 8.721 8.721 0 011.966-.221c.774 0 1.456.082 2.042.25a5.008 5.008 0 011.56.725c.45.318.846.7 1.182 1.148a8.3 8.3 0 01.89 1.526c.413-.416.88-.84 1.404-1.276.523-.435 1.101-.829 1.734-1.181a10.19 10.19 0 012.072-.86 8.582 8.582 0 012.441-.332c1.187 0 2.196.244 3.03.73a5.763 5.763 0 012.035 2.022c.523.862.901 1.887 1.141 3.076.239 1.19.359 2.485.359 3.887v11.968H26.65V41.29c0-1.7-.265-2.969-.795-3.806-.528-.836-1.414-1.256-2.652-1.256-.93 0-1.783.218-2.558.653-.774.435-1.457 1.106-2.052 2.02v14.317z",
              clipRule: "evenodd"
            })
          }), /*#__PURE__*/_jsx("path", {
            fill: "#124680",
            fillRule: "evenodd",
            d: "M49.292 43.372h-4.726c-1.265 0-2.189.3-2.77.788-.58.487-.871 1.169-.871 2.04 0 .833.245 1.474.736 1.926.49.448 1.24.676 2.245.676.609 0 1.185-.082 1.735-.244a6.693 6.693 0 001.52-.659 5.75 5.75 0 001.24-.988c.36-.382.657-.785.891-1.21v-2.33zm-.002 7.46c-.608.666-1.563 1.288-2.642 1.737-1.079.446-2.367.671-3.863.671-1.046 0-1.989-.168-2.83-.506a6.233 6.233 0 01-2.157-1.419 6.295 6.295 0 01-1.387-2.16c-.321-.834-.482-1.742-.482-2.731 0-4.036 3.102-6.602 8.073-6.602h5.25v-1.197c0-.74-.37-1.322-1.114-1.743-.741-.422-1.88-.635-3.417-.635-1.434 0-2.76.152-3.98.455-1.219.3-1.895.555-2.941.988l-.651-4.521c.386-.171.858-.352 1.414-.542.553-.191 1.175-.367 1.858-.532a22.609 22.609 0 012.228-.402c.799-.108 1.64-.16 2.517-.16 3.047 0 5.336.75 6.867 2.253 1.528 1.5 2.293 3.634 2.293 6.4v13.031h-3.753l-1.282-2.385zM79.243 31.23l-8.59 10.837 9.77 11.148h-6.622l-9.035-10.999v11H59.5V23.481h5.267v18.734l8.047-10.986h6.43zM90.96 36.206c-.697 0-1.33.086-1.9.26a4.837 4.837 0 00-1.49.74 4.04 4.04 0 00-1.046 1.156c-.27.455-.457.953-.561 1.497h9.355c0-.488-.088-.954-.263-1.4a3.036 3.036 0 00-.804-1.165c-.36-.332-.816-.596-1.364-.793-.55-.196-1.19-.295-1.927-.295m.986 12.362c.93 0 1.773-.076 2.528-.224a12.123 12.123 0 002.062-.584 9.88 9.88 0 001.686-.838c.503-.32.327-.168.74-.496l1.016 4.68c-.93.597-2.244 1.125-3.568 1.527-1.323.404-2.83.607-4.521.607-1.846 0-3.48-.26-4.9-.779-1.42-.52-2.62-1.248-3.595-2.19a9.217 9.217 0 01-2.216-3.398c-.503-1.325-.756-2.793-.756-4.403 0-1.489.23-2.895.688-4.22a10.217 10.217 0 012.014-3.481c.885-.997 1.979-1.785 3.283-2.366 1.305-.578 2.81-.87 4.513-.87 1.718 0 3.198.276 4.446.827 1.243.551 2.271 1.285 3.077 2.2a8.927 8.927 0 011.794 3.159c.387 1.188.529 2.42.529 3.696 0 .344-.02.74-.059 1.184a9.605 9.605 0 01-.154 1.126H85.866c.077.75.27 1.423.58 2.017.31.596.726 1.102 1.25 1.519.523.417 1.142.74 1.858.966.716.228 1.515.34 2.392.34M198.89 34.627l7.117-8.52h1.561v5.447h6.081v4.716h-6.081v8.878c0 .617.073 1.132.222 1.544.147.41.353.737.612.985.256.246.553.419.888.524.336.102.693.153 1.066.153.697 0 1.314-.067 1.848-.202a7.17 7.17 0 001.426-.506v4.72c-.57.286-1.166.502-1.792.65-.626.15-1.391.224-2.296.224-1.277 0-2.375-.151-3.291-.457-.917-.305-1.666-.745-2.245-1.326a5.3 5.3 0 01-1.29-2.118c-.277-.83-.418-1.77-.418-2.822V36.27h-3.408v-1.643zM222.632 36.018c.71-1.298 1.982-2.548 3.035-3.323 1.051-.774 2.315-1.161 3.785-1.161.503 0 .915.025 1.231.075.316.05.557.1.726.142 0 0-.169 1.226-.969 4.967a5.419 5.419 0 00-1.163-.108c-.994 0-1.88.172-2.662.518a5.402 5.402 0 00-1.984 1.492c-.541.65-.959 1.447-1.249 2.386-.293.94-.437 2.004-.437 3.192v9.02h-5.268V31.553h3.375l1.58 4.464z",
            clipRule: "evenodd"
          }), /*#__PURE__*/_jsx("mask", {
            id: "mask2_914_2",
            style: {
              maskType: "luminance"
            },
            width: "21",
            height: "31",
            x: "245",
            y: "31",
            maskUnits: "userSpaceOnUse",
            children: /*#__PURE__*/_jsx("path", {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M265.852 61.967V31.532h-20.759v30.435h20.759z",
              clipRule: "evenodd"
            })
          }), /*#__PURE__*/_jsx("g", {
            mask: "url(#mask2_914_2)",
            children: /*#__PURE__*/_jsx("path", {
              fill: "#124680",
              fillRule: "evenodd",
              d: "M255.358 36.27c-.67 0-1.279.1-1.82.3a5.294 5.294 0 00-2.498 1.87 6.092 6.092 0 00-.716 1.249v6.151c.205.371.474.724.801 1.056.33.332.7.623 1.115.876.414.252.873.454 1.385.608.51.152 1.055.228 1.637.228.889 0 1.662-.146 2.313-.44a4.41 4.41 0 001.628-1.222 5.082 5.082 0 00.958-1.895c.206-.737.309-1.552.309-2.443 0-.93-.122-1.783-.368-2.561-.245-.778-.592-1.445-1.045-2.004a4.856 4.856 0 00-1.617-1.305 4.595 4.595 0 00-2.082-.468m5.468-3.828a8.307 8.307 0 012.838 2.439c.749 1.017 1.301 2.19 1.657 3.524.354 1.328.532 2.712.532 4.144 0 1.462-.188 2.836-.562 4.127-.374 1.29-.939 2.423-1.694 3.4a8.184 8.184 0 01-2.819 2.313c-1.122.568-2.439.85-3.951.85-1.471 0-2.713-.215-3.728-.65a7.545 7.545 0 01-2.661-1.9l-.078.046v11.233h-5.267V31.553h3.15l2.013 2.639c.763-.785 1.848-1.547 2.902-1.992 1.053-.445 2.241-.668 3.573-.668 1.588 0 2.955.306 4.095.91z",
              clipRule: "evenodd"
            })
          }), /*#__PURE__*/_jsx("path", {
            fill: "#124680",
            fillRule: "evenodd",
            d: "M236.833 22.637a2.75 2.75 0 00-2.743 2.762 2.752 2.752 0 002.743 2.762 2.753 2.753 0 002.745-2.762 2.752 2.752 0 00-2.745-2.762zm-2.632 30.578h5.267V31.553h-5.267v21.662z",
            clipRule: "evenodd"
          })]
        });
      }

      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "140",
        height: "39",
        fill: "none",
        viewBox: "0 0 266 86",
        children: [/*#__PURE__*/_jsx("mask", {
          id: "mask0_914_28",
          style: {
            maskType: "luminance"
          },
          width: "85",
          height: "86",
          x: "109",
          y: "0",
          maskUnits: "userSpaceOnUse",
          children: /*#__PURE__*/_jsx("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M193.71 85.1V0h-84.499v85.1h84.499z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsxs("g", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          mask: "url(#mask0_914_28)",
          children: [/*#__PURE__*/_jsx("path", {
            fill: "#EB2226",
            d: "M193.707 19.267C193.707 8.64 185.191 0 174.691 0h-46.46c-10.504 0-19.019 8.64-19.019 19.267l.01 46.555c0 10.624 8.514 19.278 19.017 19.278h46.459c10.502 0 19.013-8.652 19.013-19.278l-.004-46.555z"
          }), /*#__PURE__*/_jsx("path", {
            fill: "#fff",
            d: "M186.738 29.11c-4.016 6.918-11.19 21.794-11.19 21.794s-3.614 8.03-5.142 16.236c-.679 3.65.633 7.888.633 7.888.981 4.186-3.668 3.036-3.668 3.036-3.396-1.122-3.302-5.684-3.302-5.684 0-6.733 2.979-13.24 4.725-17.596-6.134 2.431-9.003-3.565-7.257-9.62l-7.011 9.511c-2.257 2.667-4.479 2.144-4.479 2.144-.113 0-2.811-.33-2.674-3.95.066-1.752.556-9.065 1.117-11.78.057-.284-.111-.567-.337-.227-2.924 5.204-7.715 10.876-8.668 12.448-1.236 2.04-2.476 2.884-2.476 2.884-.996.808-2.726.197-2.726.197-1.774-.661-1.411-2.678-1.411-2.678l1.679-12.186c0-.167-.055-.225-.225-.225-.505 0-5.259 6.625-7.882 11.247l-1.718 2.793s-1.483 2.34-3.773.932c-1.791-1.102-1.228-3.16-1.228-3.16l4.912-20.794c0-.057 0-.396-.283-.396-1.518 0-1.95 3.982-4.027 4.059-1.045.038-1.583-.411-1.583-.411-1.417-.82-.745-2.946-.745-2.946s2.244-5.973 5.218-7.475c0 0 1.716-1.082 3.145-.889 1.429.194 3.717.539 2.516 7.096l-1.5 8.53s-.15.746.083.865c0 0 .37.37 1.117-.631l9.513-13.084c2.049-3.029 4.464-1.501 4.464-1.501 1.609.687 1.057 2.67 1.057 2.67s-4.688 14.483-4.688 15.84c0 .453.394.565.618.228 1.968-3 6.131-9.508 9.62-13.864 1.574-1.924 2.476-2.773 4.218-2.603 1.687.17 2.475 1.245 2.475 2.942 0 .283-.057.623-.111.963 0 0-3.095 10.694-3.321 16.408 0 0-.048.822.168.988.417.32.932-.4.932-.4 1.731-1.92 7.269-10.724 8.52-13.036l4.006-8.2s1.7-3.73 3.971-3.15c0 0 3.612.367 1.867 4.323-.286.647-3.037 5.144-5.4 14.426-.394 1.412-.901 5.544 1.63 5.544 1.125 0 2.589-.907 4.107-3.68l9.956-17.992c.843-.907 1.511-1.407 2.691-1.407 3.686 0 1.867 3.572 1.867 3.572z"
          })]
        }), /*#__PURE__*/_jsx("mask", {
          id: "mask1_914_28",
          style: {
            maskType: "luminance"
          },
          width: "32",
          height: "23",
          x: "0",
          y: "31",
          maskUnits: "userSpaceOnUse",
          children: /*#__PURE__*/_jsx("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M0 53.217h31.918V31.534H0v21.683z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("g", {
          mask: "url(#mask1_914_28)",
          children: /*#__PURE__*/_jsx("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M18.593 53.217h-5.268V41.29c0-1.7-.269-2.969-.804-3.806-.536-.836-1.441-1.256-2.72-1.256-.93 0-1.782.231-2.556.694-.776.465-1.434 1.124-1.977 1.978v14.318H0V31.555h3l1.98 2.913c.426-.39 1.072-.88 1.595-1.22.523-.34 1.075-.639 1.657-.893a10.46 10.46 0 011.83-.6 8.721 8.721 0 011.966-.221c.774 0 1.456.082 2.042.25a5.008 5.008 0 011.56.725c.45.318.846.7 1.182 1.148a8.3 8.3 0 01.89 1.526c.413-.416.88-.84 1.404-1.276.523-.435 1.101-.829 1.734-1.181a10.19 10.19 0 012.072-.86 8.582 8.582 0 012.441-.332c1.187 0 2.196.244 3.03.73a5.763 5.763 0 012.035 2.022c.523.862.901 1.887 1.141 3.076.239 1.19.359 2.485.359 3.887v11.968H26.65V41.29c0-1.7-.265-2.969-.795-3.806-.528-.836-1.414-1.256-2.652-1.256-.93 0-1.783.218-2.558.653-.774.435-1.457 1.106-2.052 2.02v14.317z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M49.292 43.372h-4.726c-1.265 0-2.189.3-2.77.788-.58.487-.871 1.169-.871 2.04 0 .833.245 1.474.736 1.926.49.448 1.24.676 2.245.676.609 0 1.185-.082 1.735-.244a6.693 6.693 0 001.52-.659 5.75 5.75 0 001.24-.988c.36-.382.657-.785.891-1.21v-2.33zm-.002 7.46c-.608.666-1.563 1.288-2.642 1.737-1.079.446-2.367.671-3.863.671-1.046 0-1.989-.168-2.83-.506a6.233 6.233 0 01-2.157-1.419 6.295 6.295 0 01-1.387-2.16c-.321-.834-.482-1.742-.482-2.731 0-4.036 3.102-6.602 8.073-6.602h5.25v-1.197c0-.74-.37-1.322-1.114-1.743-.741-.422-1.88-.635-3.417-.635-1.434 0-2.76.152-3.98.455-1.219.3-1.895.555-2.941.988l-.651-4.521c.386-.171.858-.352 1.414-.542.553-.191 1.175-.367 1.858-.532a22.609 22.609 0 012.228-.402c.799-.108 1.64-.16 2.517-.16 3.047 0 5.336.75 6.867 2.253 1.528 1.5 2.293 3.634 2.293 6.4v13.031h-3.753l-1.282-2.385zM79.243 31.23l-8.59 10.837 9.77 11.148h-6.622l-9.035-10.999v11H59.5V23.481h5.267v18.734l8.047-10.986h6.43zM90.96 36.206c-.697 0-1.33.086-1.9.26a4.837 4.837 0 00-1.49.74 4.04 4.04 0 00-1.046 1.156c-.27.455-.457.953-.561 1.497h9.355c0-.488-.088-.954-.263-1.4a3.036 3.036 0 00-.804-1.165c-.36-.332-.816-.596-1.364-.793-.55-.196-1.19-.295-1.927-.295m.986 12.362c.93 0 1.773-.076 2.528-.224a12.123 12.123 0 002.062-.584 9.88 9.88 0 001.686-.838c.503-.32.327-.168.74-.496l1.016 4.68c-.93.597-2.244 1.125-3.568 1.527-1.323.404-2.83.607-4.521.607-1.846 0-3.48-.26-4.9-.779-1.42-.52-2.62-1.248-3.595-2.19a9.217 9.217 0 01-2.216-3.398c-.503-1.325-.756-2.793-.756-4.403 0-1.489.23-2.895.688-4.22a10.217 10.217 0 012.014-3.481c.885-.997 1.979-1.785 3.283-2.366 1.305-.578 2.81-.87 4.513-.87 1.718 0 3.198.276 4.446.827 1.243.551 2.271 1.285 3.077 2.2a8.927 8.927 0 011.794 3.159c.387 1.188.529 2.42.529 3.696 0 .344-.02.74-.059 1.184a9.605 9.605 0 01-.154 1.126H85.866c.077.75.27 1.423.58 2.017.31.596.726 1.102 1.25 1.519.523.417 1.142.74 1.858.966.716.228 1.515.34 2.392.34M198.89 34.627l7.117-8.52h1.561v5.447h6.081v4.716h-6.081v8.878c0 .617.073 1.132.222 1.544.147.41.353.737.612.985.256.246.553.419.888.524.336.102.693.153 1.066.153.697 0 1.314-.067 1.848-.202a7.17 7.17 0 001.426-.506v4.72c-.57.286-1.166.502-1.792.65-.626.15-1.391.224-2.296.224-1.277 0-2.375-.151-3.291-.457-.917-.305-1.666-.745-2.245-1.326a5.3 5.3 0 01-1.29-2.118c-.277-.83-.418-1.77-.418-2.822V36.27h-3.408v-1.643zM222.632 36.018c.71-1.298 1.982-2.548 3.035-3.323 1.051-.774 2.315-1.161 3.785-1.161.503 0 .915.025 1.231.075.316.05.557.1.726.142 0 0-.169 1.226-.969 4.967a5.419 5.419 0 00-1.163-.108c-.994 0-1.88.172-2.662.518a5.402 5.402 0 00-1.984 1.492c-.541.65-.959 1.447-1.249 2.386-.293.94-.437 2.004-.437 3.192v9.02h-5.268V31.553h3.375l1.58 4.464z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("mask", {
          id: "mask2_914_28",
          style: {
            maskType: "luminance"
          },
          width: "21",
          height: "31",
          x: "245",
          y: "31",
          maskUnits: "userSpaceOnUse",
          children: /*#__PURE__*/_jsx("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M265.852 61.967V31.532h-20.759v30.435h20.759z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("g", {
          mask: "url(#mask2_914_28)",
          children: /*#__PURE__*/_jsx("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M255.358 36.27c-.67 0-1.279.1-1.82.3a5.294 5.294 0 00-2.498 1.87 6.092 6.092 0 00-.716 1.249v6.151c.205.371.474.724.801 1.056.33.332.7.623 1.115.876.414.252.873.454 1.385.608.51.152 1.055.228 1.637.228.889 0 1.662-.146 2.313-.44a4.41 4.41 0 001.628-1.222 5.082 5.082 0 00.958-1.895c.206-.737.309-1.552.309-2.443 0-.93-.122-1.783-.368-2.561-.245-.778-.592-1.445-1.045-2.004a4.856 4.856 0 00-1.617-1.305 4.595 4.595 0 00-2.082-.468m5.468-3.828a8.307 8.307 0 012.838 2.439c.749 1.017 1.301 2.19 1.657 3.524.354 1.328.532 2.712.532 4.144 0 1.462-.188 2.836-.562 4.127-.374 1.29-.939 2.423-1.694 3.4a8.184 8.184 0 01-2.819 2.313c-1.122.568-2.439.85-3.951.85-1.471 0-2.713-.215-3.728-.65a7.545 7.545 0 01-2.661-1.9l-.078.046v11.233h-5.267V31.553h3.15l2.013 2.639c.763-.785 1.848-1.547 2.902-1.992 1.053-.445 2.241-.668 3.573-.668 1.588 0 2.955.306 4.095.91z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M236.833 22.637a2.75 2.75 0 00-2.743 2.762 2.752 2.752 0 002.743 2.762 2.753 2.753 0 002.745-2.762 2.752 2.752 0 00-2.745-2.762zm-2.632 30.578h5.267V31.553h-5.267v21.662z",
          clipRule: "evenodd"
        })]
      });
    } else {
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "140",
        height: "39",
        fill: "none",
        viewBox: "0 0 225 69",
        children: [/*#__PURE__*/_jsxs("g", {
          fillRule: "evenodd",
          clipPath: "url(#clip0_915_2)",
          clipRule: "evenodd",
          children: [/*#__PURE__*/_jsx("path", {
            fill: "#FF6D38",
            d: "M55.892 49.728c-5.758 0-10.281-1.552-13.575-4.653-3.295-3.097-4.942-7.306-4.942-12.623 0-5.49 1.71-9.781 5.127-12.884 3.419-3.1 8.04-4.65 13.866-4.65 5.733 0 10.232 1.55 13.49 4.65 3.263 3.1 4.892 7.202 4.892 12.301 0 5.51-1.683 9.864-5.043 13.062-3.365 3.198-7.966 4.797-13.815 4.797zm-25.744 9.833c3.684-3.394 5.527-8.176 5.527-14.35V15.728H25.09V19.6h-.134c-2.075-3.12-5.203-4.68-9.377-4.68-4.666 0-8.43 1.657-11.292 4.973C1.431 23.208 0 27.682 0 33.315c0 5.026 1.286 9.034 3.853 12.022 2.57 2.994 6.041 4.487 10.42 4.487 4.71 0 8.272-1.865 10.683-5.59h.134v2.636c0 3.14-.98 5.627-2.946 7.459-1.966 1.827-4.736 2.743-8.31 2.743-3.594 0-7.155-.993-10.683-2.99v8.648c2.7 1.276 6.362 1.917 10.986 1.917 6.986 0 12.325-1.697 16.011-5.086zm-6.364-29.123v2.502c0 2.555-.635 4.61-1.905 6.166-1.27 1.555-2.93 2.333-4.985 2.333-2.075 0-3.713-.77-4.91-2.302-1.192-1.535-1.791-3.624-1.791-6.26 0-3.07.628-5.449 1.887-7.14 1.26-1.687 2.989-2.53 5.193-2.53 1.927 0 3.496.7 4.706 2.114 1.204 1.413 1.805 3.116 1.805 5.117zm25.823-4.856c1.359-1.585 3.266-2.375 5.722-2.375h-.002c5.02 0 7.532 2.952 7.532 8.868 0 6.243-2.49 9.364-7.465 9.364-5.217 0-7.826-3.04-7.826-9.118 0-2.901.677-5.148 2.039-6.739z"
          }), /*#__PURE__*/_jsx("path", {
            fill: "#2274E0",
            d: "M79.814 8.493c1.112.969 2.539 1.453 4.279 1.453 1.765 0 3.198-.466 4.299-1.404 1.096-.94 1.649-2.145 1.649-3.616 0-1.448-.549-2.628-1.65-3.549C87.292.461 85.859 0 84.094 0c-1.745 0-3.167.46-4.279 1.38-1.11.916-1.667 2.098-1.667 3.548 0 1.409.553 2.598 1.667 3.565zm-1.667 39.576H88.34V14.92H78.147v33.15zm27.708-2.992h-.133v3.839H95.137V0h10.585v20.847h.133c2.614-3.85 6.331-5.778 11.158-5.778 4.419 0 7.824 1.462 10.215 4.39 2.391 2.92 3.583 6.922 3.583 12.003 0 5.508-1.395 9.928-4.189 13.264-2.79 3.332-6.518 5.002-11.184 5.002-4.221-.003-7.417-1.553-9.583-4.651zm-.526-10.716v-3.245c0-2.346.658-4.252 1.972-5.718 1.317-1.46 2.978-2.19 4.979-2.19 2.128 0 3.766.735 4.913 2.206 1.153 1.477 1.727 3.52 1.727 6.135 0 3.152-.626 5.587-1.88 7.31-1.257 1.72-3.018 2.58-5.297 2.58-1.872 0-3.41-.67-4.613-2.007-1.203-1.342-1.801-3.03-1.801-5.07zm33.128-24.415c-1.742 0-3.169-.484-4.278-1.453-1.117-.97-1.667-2.156-1.667-3.565 0-1.45.55-2.632 1.665-3.548C135.291.46 136.712 0 138.455 0c1.767 0 3.2.461 4.296 1.377 1.104.92 1.652 2.1 1.652 3.55 0 1.47-.548 2.674-1.652 3.615-1.096.938-2.529 1.404-4.294 1.404zm-5.945 38.123h10.193V14.92h-10.193v33.15zm27.708-2.992h-.134v3.839h-10.585V0h10.585v20.847h.134c2.612-3.85 6.331-5.778 11.158-5.778 4.421 0 7.826 1.462 10.217 4.39 2.389 2.92 3.581 6.922 3.581 12.003 0 5.508-1.393 9.928-4.187 13.264-2.79 3.332-6.523 5.002-11.187 5.002-4.223-.003-7.416-1.553-9.582-4.651zm-.528-10.716v-3.245c0-2.346.662-4.252 1.974-5.718 1.315-1.46 2.977-2.19 4.978-2.19 2.128 0 3.769.735 4.916 2.206 1.148 1.477 1.723 3.52 1.723 6.135 0 3.152-.624 5.592-1.879 7.31-1.254 1.72-3.021 2.58-5.295 2.58-1.871 0-3.416-.67-4.612-2.007-1.204-1.342-1.805-3.03-1.805-5.07zm45.698 15.367c-5.756 0-10.28-1.552-13.576-4.653-3.293-3.096-4.94-7.306-4.94-12.623 0-5.49 1.711-9.781 5.128-12.884 3.42-3.1 8.04-4.649 13.862-4.649 5.739 0 10.234 1.548 13.493 4.649 3.262 3.1 4.892 7.202 4.892 12.3 0 5.51-1.677 9.865-5.043 13.063-3.364 3.198-7.969 4.797-13.816 4.797zm-6.28-24.145c1.362-1.586 3.265-2.376 5.723-2.376 5.016 0 7.525 2.952 7.525 8.868 0 6.243-2.489 9.364-7.463 9.364-5.221 0-7.828-3.04-7.828-9.118 0-2.901.684-5.148 2.043-6.738z"
          }), /*#__PURE__*/_jsx("path", {
            fill: "#4A4A4A",
            d: "M184.619 56.673c1.363 0 2.351.182 2.961.55V60.3a4.038 4.038 0 00-2.498-.85c-1.025 0-1.838.304-2.438.912-.597.61-.898 1.448-.898 2.52 0 1.042.288 1.858.86 2.45.573.593 1.36.89 2.362.89.89 0 1.761-.284 2.612-.85v2.917c-.806.474-1.972.71-3.494.71-1.778 0-3.218-.546-4.316-1.642-1.101-1.093-1.652-2.506-1.652-4.236 0-1.996.591-3.571 1.77-4.722 1.178-1.151 2.756-1.726 4.731-1.726zm-10.434 8.54c.611 0 1.11.177 1.497.531.388.355.582.806.582 1.349 0 .559-.198 1.016-.593 1.373-.396.355-.909.532-1.544.532-.586 0-1.076-.181-1.468-.55a1.784 1.784 0 01-.589-1.353c0-.552.201-1.004.606-1.355.401-.353.905-.528 1.509-.528zm25.93-6.894c-1.094-1.098-2.601-1.646-4.522-1.646-1.952 0-3.501.548-4.646 1.646-1.145 1.098-1.718 2.62-1.718 4.562 0 1.883.553 3.374 1.656 4.472 1.105 1.098 2.62 1.646 4.55 1.646 1.959 0 3.501-.566 4.628-1.697 1.128-1.134 1.69-2.675 1.69-4.627 0-1.805-.546-3.258-1.638-4.356zm18.56-1.646c2.516 0 3.775 1.575 3.775 4.729v7.31h-3.56V62.01c0-1.708-.618-2.56-1.854-2.56-.589 0-1.065.255-1.436.77-.37.51-.555 1.15-.555 1.916v6.577h-3.569V61.94c0-1.661-.609-2.49-1.821-2.49-.611 0-1.099.243-1.464.733-.366.488-.548 1.156-.548 1.996v6.533h-3.572V56.957h3.572v1.839h.044a4.302 4.302 0 011.556-1.533 4.208 4.208 0 012.186-.59c1.635 0 2.754.73 3.358 2.191.88-1.461 2.178-2.19 3.888-2.19zm-25.116 3.66c.465-.588 1.123-.883 1.965-.883 1.727 0 2.59 1.097 2.59 3.293 0 2.318-.856 3.478-2.566 3.478-1.793 0-2.691-1.129-2.691-3.387 0-1.078.234-1.912.702-2.502z"
          })]
        }), /*#__PURE__*/_jsx("defs", {
          children: /*#__PURE__*/_jsx("clipPath", {
            id: "clip0_915_2",
            children: /*#__PURE__*/_jsx("path", {
              fill: "#fff",
              d: "M0 0H224.25V69H0z"
            })
          })
        })]
      });
    }
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
};

/* harmony default export */ var ui_container_TMLogo = ((/* unused pure expression or super */ null && (TMLogo_Logo)));
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/header/index.tsx











var header_Header = function Header(_ref) {
  var tmLogo = _ref.tmLogo,
      forexHeader = _ref.forexHeader,
      faq = _ref.faq,
      faqCTAEvent = _ref.faqCTAEvent,
      aboutUs = _ref.aboutUs,
      onClickFaqLink = _ref.onClickFaqLink,
      faqRedirectionUrl = _ref.faqRedirectionUrl;

  var _useState = useState(true),
      isLight = _useState[0],
      setIsLight = _useState[1];

  useHeaderAnimation(setIsLight);

  var onClickFaq = function onClickFaq() {
    if (faqCTAEvent) pushEvent(faqCTAEvent);

    if (typeof onClickFaqLink === "function") {
      onClickFaqLink();
    }
  };

  return /*#__PURE__*/_jsx(LandingHeader, {
    forexHeader: forexHeader,
    id: "header_ref",
    isLight: isLight,
    children: /*#__PURE__*/_jsxs(LandingHeaderWrap, {
      children: [/*#__PURE__*/_jsx(TMLogo // href={tmLogo?.redirectUrl}
      , {
        "aria-label": tmLogo === null || tmLogo === void 0 ? void 0 : tmLogo.name,
        id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.TM_LOGO),
        className: "darkRef",
        children: /*#__PURE__*/_jsx(Logo, {
          isLight: isLight
        })
      }), /*#__PURE__*/_jsxs(LandingHeaderList, {
        children: [faq && /*#__PURE__*/_jsx("li", {
          id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.FAQ),
          children: faqRedirectionUrl ? /*#__PURE__*/_jsx(Link, {
            href: faqRedirectionUrl,
            children: faq.title
          }) : /*#__PURE__*/_jsx(ActiveLink, {
            href: LINKS.FAQ,
            "aria-label": faq.title,
            onClick: onClickFaq,
            children: faq.title
          })
        }), aboutUs && /*#__PURE__*/_jsx("li", {
          id: getElementUniqueIds(PageNameMapping.LISTING_PAGE, SectionNameMapping.HEADER, ElementNameMapping.ABOUT_US),
          children: /*#__PURE__*/_jsx(ActiveLink, {
            href: aboutUs.redirectUrl,
            "aria-label": aboutUs.title,
            children: aboutUs.title
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var ui_container_header = ((/* unused pure expression or super */ null && (header_Header)));
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/LandingFooter/LandingFooter.tsx + 1 modules
var ui_container_LandingFooter_LandingFooter = __webpack_require__(7583);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOCommonUI/index.tsx + 5 modules
var CurrencySEOCommonUI = __webpack_require__(4326);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/BMFLogo/index.tsx
var BMFLogo = __webpack_require__(2684);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOMarkdown/index.tsx + 1 modules
var CurrencySEOMarkdown = __webpack_require__(2558);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/CurrencyFooter.tsx
var CurrencyFooter = __webpack_require__(8545);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/CurrencyDocumet.tsx




var CurrencyDocumet = function CurrencyDocumet(_ref) {
  var _currency$forex_solut, _currency$forex_solut2;

  var currency = _ref.currency,
      hasHeroImage = _ref.hasHeroImage,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      httpEquiv: "Content-Type",
      content: "text/html; charset=UTF-8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      httpEquiv: "X-UA-Compatible",
      content: "IE=edge"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), currency !== null && currency !== void 0 && currency.allow_indexing ? null : /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: "none"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "apple-itunes-app",
      content: "app-id=123456789, app-argument=mmyt://app/forex?code=PC&page=forexListing"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "alternate",
      href: "android-app://com.makemytrip/mmyt/app/forex?code=PC&page=forexListing"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: currency === null || currency === void 0 ? void 0 : currency.meta_desc
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: currency === null || currency === void 0 ? void 0 : currency.keywords
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjx4wXiWtFCc.woff2",
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: "https://www.makemytrip.com/tripmoney/currency/".concat(id)
    }), hasHeroImage ? /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: currency === null || currency === void 0 ? void 0 : (_currency$forex_solut = currency.forex_solution) === null || _currency$forex_solut === void 0 ? void 0 : (_currency$forex_solut2 = _currency$forex_solut.forex_sol) === null || _currency$forex_solut2 === void 0 ? void 0 : _currency$forex_solut2.src
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: currency === null || currency === void 0 ? void 0 : currency.title
    })]
  });
};

/* harmony default export */ var CurrencyPageTemplate_CurrencyDocumet = (CurrencyDocumet);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/DeepLinkAnchor.tsx


function DeepLinkAnchor_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DeepLinkAnchor_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeepLinkAnchor_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeepLinkAnchor_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var DeeplinkMetaAnchor = function DeeplinkMetaAnchor(_ref) {
  var name = _ref.name,
      content = _ref.content,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {
    display: "none"
  } : _ref$style;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", DeepLinkAnchor_objectSpread(DeepLinkAnchor_objectSpread({
    style: style,
    className: className
  }, (0,defineProperty/* default */.Z)({}, "data-meta-".concat(name), true)), {}, {
    href: content
  }));
};
var DeeplinkLinkAnchor = function DeeplinkLinkAnchor(_ref3) {
  var rel = _ref3.rel,
      href = _ref3.href,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? "" : _ref3$className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {
    display: "none"
  } : _ref3$style;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", DeepLinkAnchor_objectSpread(DeepLinkAnchor_objectSpread({
    style: style,
    className: className
  }, (0,defineProperty/* default */.Z)({}, "data-link-".concat(rel), true)), {}, {
    href: href
  }));
}; // Keep the old component for backward compatibility if needed

var DeepLinkAnchor = function DeepLinkAnchor() {
  return null;
};

/* harmony default export */ var ui_container_DeepLinkAnchor = ((/* unused pure expression or super */ null && (DeepLinkAnchor)));
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRootPageTemplate/CurrencyConverter.tsx
var CurrencyConverter = __webpack_require__(9235);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/HeroV2.tsx
var HeroV2 = __webpack_require__(4760);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/HeroWebV2.tsx
var HeroWebV2 = __webpack_require__(1594);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Faqs.tsx + 1 modules
var Faqs = __webpack_require__(9116);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/ForexProducts.tsx + 1 modules
var ForexProducts = __webpack_require__(922);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencySEOContext/index.ts

var CurrencySEOContext = /*#__PURE__*/react.createContext({
  refreshBtn: "",
  currencyCode: "",
  exchangeRateApi: null,
  inrRate: "",
  setInrRate: function setInrRate() {
    return;
  }
});
// EXTERNAL MODULE: ../../node_modules/@forex/listing-ui/index.cjs.js
var index_cjs = __webpack_require__(5348);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/CurrencyPageTemplate.styles.ts


var CurrencyPageTemplate_styles_templateObject;


var CurrencyPageStyle = (0,styled_components_browser_esm.createGlobalStyle)(CurrencyPageTemplate_styles_templateObject || (CurrencyPageTemplate_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n\n/* Background color classes */\n.bg-light-grey {\n  background-color: #F2F2F2;\n}\n\n/* Desktop styles - all desktop-specific overrides */\n@media (min-width: 1024px) {\n  ", "\n}\n"])), function (props) {
  return props.deviceType === "lg" ? "\n    /* Top banner section styling for lg deviceType */\n    #top-banner {\n        background: url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/bg6.jpg) !important;\n        background-repeat: no-repeat !important;\n        padding-bottom: 40px !important;\n        min-height: auto !important;\n        padding: 0 !important;\n        margin: 0 !important;\n    }\n\n    /* Top banner container styles */\n    .top-banner__container {\n        margin: 0 auto !important;\n        padding-top: 32px !important;\n        max-width: 1200px !important;\n    }\n\n    .top-banner__wrapper {\n        padding-bottom: 40px;\n        padding-top: 16px;\n    }\n\n    .top-banner__title {\n        font-size: 36px !important;\n        line-height: 43.2px !important; /* 1.2em of 36px */\n        font-weight: 900 !important;\n        color: #FFFFFF !important;\n        margin: 0 !important;\n    }\n\n    .top-banner__description {\n        color: white;\n        margin-top: 8px;\n        font-weight: 700;\n        line-height: 24px;\n        margin-bottom: 0;\n        font-size: 16px;\n    }\n\n    .top-banner__breadcrumb {\n        margin-top: 16px !important;\n    }\n\n    /* Header styling for lg deviceType */\n    header {\n        position: sticky !important;\n        top: 0 !important;\n        z-index: 10 !important;\n        background-color: #fff !important;\n        padding: 18px 0 !important;\n    }\n\n    .currencyFacts__list::after {\n        display: none !important;\n    }\n\n    /* Remove negative margins for lg deviceType */\n    .container.negativeMargin {\n        margin-top: 0 !important;\n    }\n\n    .pageContainer.pageContainer_margin {\n        margin-top: 0 !important;\n    }\n\n    /* Container margin-top for lg deviceType */\n    .container--margin-top-24 {\n        margin-top: 24px !important;\n    }\n\n    /* Section wrapper styling for lg deviceType */\n    .sectionWrapper {\n        background-color: #fff;\n        border-radius: 16px;\n        padding: 32px 24px;\n        margin-bottom: 48px;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    }\n\n    /* Remove pageContent margin for desktop to prevent empty space */\n    .pageContent {\n        margin: 0 auto;\n    }\n\n    /* Typography improvements for lg deviceType */\n    .tripMoneySection h2 {\n        font-size: 22px !important;\n        line-height: 26.4px !important;\n        font-weight: 900 !important;\n        color: #000 !important;\n    }\n\n    .tripMoneySection p,\n    .tripMoneySection .description {\n        font-size: 16px !important;\n        line-height: 19.2px !important;\n        font-weight: 400 !important;\n        color: #4A4A4A !important;\n    }\n\n    /* Container card improvements */\n    .container__card {\n        background-color: #fff;\n        border-radius: 8px;\n        padding: 24px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        margin-bottom: 16px;\n    }\n\n    .container__card.container__cardAlign {\n        border: 1px solid #D8D8D8 !important;\n        border-radius: 8px !important;\n        padding: 16px 8px !important;\n    }\n\n    .tripmoneyImgWrap::after {\n        content: '' !important;\n        position: absolute !important;\n        top: -55px !important;\n        right: -33px !important;\n        width: 1px !important;\n        border-right: 1px dotted #d5d5d5 !important;\n        height: 160px !important;    \n    }\n\n    /* Hide separators on desktop by default */\n    .separator {\n        display: none !important;\n    }\n\n    /* Identification section specific styling - no extra card styling */\n    .identification-section {\n        background-color: transparent;\n        padding: 0;\n        margin: 0;\n        box-shadow: none;\n        border-radius: 0;\n    }\n\n    .identification-section .tripMoneySection {\n        background-color: transparent;\n        padding: 0;\n        margin: 0;\n        box-shadow: none;\n        border-radius: 0;\n    }\n\n    .identification-section h2 {\n        font-size: 22px !important;\n        line-height: 26.4px !important;\n        font-weight: 900 !important;\n        color: #000 !important;\n        margin-bottom: 24px !important;\n    }\n\n    /* UL section styling to match Figma */\n    .identification-section ul {\n        max-width: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        list-style: none !important;\n    }\n\n    .identification-section ul li {\n        font-size: 16px !important;\n        line-height: 24px !important;\n        font-weight: 400 !important;\n        color: #333333 !important;\n        margin-bottom: 40px !important;\n        padding-bottom: 0 !important;\n        border-bottom: none !important;\n    }\n\n    /* Enhanced styling for list item content */\n    .identification-section ul li span {\n        font-size: 16px !important;\n        line-height: 24px !important;\n        font-weight: 400 !important;\n        color: #333333 !important;\n    }\n\n    .identification-section ul li:last-child {\n        margin-bottom: 0 !important;\n    }\n\n    /* Image styling for identification section - improved spacing */\n    .identification-section .counterFietImgWrap {\n        display: flex !important;\n        align-items: flex-start !important;\n        justify-content: center !important;\n        flex: 0 0 auto !important;\n        width: 280px !important;\n        min-width: 280px !important;\n        padding-left: 24px !important;\n    }\n\n    .identification-section .counterFietImgWrap img {\n        max-width: 100% !important;\n        height: auto !important;\n        object-fit: contain !important;\n        border-radius: 8px !important;\n    }\n\n    /* Green check icon styling */\n    .identification-section .greenCheckImg {\n        width: 16px !important;\n        height: 16px !important;\n        margin-right: 12px !important;\n        flex-shrink: 0 !important;\n    }\n\n    /* List item flex styling */\n    .identification-section ul li.makeFlex {\n        display: flex !important;\n        align-items: flex-start !important;\n        gap: 12px !important;\n        margin-bottom\n    }\n\n    .identification-section ul li span {\n        flex: 1 !important;\n    }\n\n    /* Mobile image wrapper - hide on desktop */\n    .identification-section .counterFietImgWrapMweb {\n        display: none !important;\n    }\n\n    /* Identification section header styling - reduced spacing */\n    .identification-section h2.appendBottom30 {\n        font-size: 22px !important;\n        line-height: 26.4px !important;\n        font-weight: 900 !important;\n        color: #000 !important;\n        margin-bottom: 12px !important;\n    }\n\n    /* CurrencySEOMarkdown with divider line */\n    .identification-section .appendBottom20 {\n        font-size: 16px !important;\n        line-height: 19.2px !important;\n        font-weight: 400 !important;\n        color: #4A4A4A !important;\n        margin-bottom: 16px !important;\n        padding-bottom: 16px !important;\n        border-bottom: 1px dashed #D8D8D8 !important;\n    }\n\n    /* Section flex layout - improved spacing */\n    .identification-section .tripMoneySection.makeFlex {\n        display: flex !important;\n        gap: 32px !important;\n        align-items: flex-start !important;\n        justify-content: space-between !important;\n    }\n\n    .identification-section .tripMoneySection.makeFlex > div:first-child {\n        flex: 1 1 auto !important;\n        max-width: calc(100% - 320px) !important;\n        padding-right: 16px !important;\n    }\n\n    .identification-section .tripMoneySection.makeFlex > div:last-child {\n        flex: 0 0 auto !important;\n        width: 280px !important;\n    }\n\n    /* Identification section specific styling for lg deviceType */\n    .identification-wrapper--lg .sectionWrapper {\n        padding: 0 !important;\n    }\n\n    .identification-container--lg {\n        display: flex !important;\n        padding: 32px 24px !important;\n        gap: 20px !important;\n        align-items: flex-start !important;\n        justify-content: space-between !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .identification-container--lg > .tripMoneySection {\n        display: flex !important;\n        width: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n    }\n\n    .identification-container--lg .tripMoneySection > div:first-child {\n        flex: 1 1 auto !important;\n        max-width: 60% !important;\n        min-width: 0 !important;\n        padding-right: 16px !important;\n    }\n\n    .identification-container--lg .tripMoneySection > div:last-child {\n        flex: 0 0 auto !important;\n        width: 35% !important;\n        max-width: 300px !important;\n        min-width: 250px !important;\n        padding-left: 16px !important;\n    }\n\n    /* UL and image styling within the flex container */\n    .identification-container--lg ul {\n        max-width: 100% !important;\n        width: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        list-style: none !important;\n    }\n\n    .identification-container--lg ul li {\n        font-size: 16px !important;\n        line-height: 24px !important;\n        font-weight: 400 !important;\n        color: #333333 !important;\n        margin-bottom: 40px !important;\n        padding-bottom: 0 !important;\n        border-bottom: none !important;\n    }\n\n    .identification-container--lg ul li:last-child {\n        margin-bottom: 0 !important;\n    }\n\n    .identification-container--lg ul li.makeFlex {\n        display: flex !important;\n        align-items: flex-start !important;\n        gap: 12px !important;\n    }\n\n    .identification-container--lg ul li span {\n        flex: 1 !important;\n        font-size: 16px !important;\n        line-height: 24px !important;\n        font-weight: 400 !important;\n        color: #333333 !important;\n    }\n\n    .identification-container--lg .greenCheckImg {\n        width: 16px !important;\n        height: 16px !important;\n        margin-right: 0 !important;\n        flex-shrink: 0 !important;\n    }\n\n    .identification-container--lg .counterFietImgWrap {\n        display: flex !important;\n        align-items: flex-start !important;\n        justify-content: center !important;\n        height: auto !important;\n    }\n\n    .identification-container--lg .counterFietImgWrap img {\n        max-width: 100% !important;\n        height: auto !important;\n        object-fit: contain !important;\n        border-radius: 8px !important;\n    }\n\n    /* Remove box shadow from container__card for lg deviceType */\n    .container__card {\n        box-shadow: none !important;\n        background-color: transparent !important;\n        border-radius: 0 !important;\n        padding: 0 !important;\n        margin-bottom: 0 !important;\n    }\n\n    /* Currency Converter styling for lg deviceType */\n    .sectionWrapper .h2 {\n        font-size: 22px !important;\n        line-height: 26.4px !important;\n        font-weight: 900 !important;\n        color: #000 !important;\n        margin-bottom: 24px !important;\n    }\n\n    .sectionWrapper .capSulesList {\n        display: grid !important;\n        grid-template-columns: repeat(4, 1fr) !important;\n        gap: 16px !important;\n        margin-bottom: 24px !important;\n        list-style: none !important;\n        padding: 0 !important;\n    }\n\n    .sectionWrapper .capSulesList li {\n        box-shadow: none !important;\n    }\n\n    .sectionWrapper .capSulesList.grid5 {\n        grid-template-columns: repeat(4, 1fr) !important;\n    }\n\n    .sectionWrapper .capsule {\n        background-color: #F5F5F5 !important;\n        border-radius: 5px !important;\n        padding: 16px 20px !important;\n        text-align: center !important;\n        transition: all 0.2s ease !important;\n        min-height: 48px !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        border: 1px solid #D8D8D8 !important;\n    }\n\n\n    /* Alternative approach: Hide capsules beyond the first 4 */\n    .sectionWrapper .capSulesList:not(.showAll) .capsule:nth-child(n+5) {\n        display: none !important;\n    }\n\n    .sectionWrapper .capSulesList.grid5:not(.showAll) .capsule:nth-child(n+5) {\n        display: none !important;\n    }\n\n    .sectionWrapper .capsule a {\n        color: #008CFF !important;\n        text-decoration: none !important;\n        font-size: 12px !important;\n        font-weight: 900 !important;\n        line-height: 17px !important;\n        display: block !important;\n        width: 100% !important;\n    }\n\n\n    .sectionWrapper .viewMore {\n        text-align: left !important;\n        margin-top: 24px !important;\n        margin-bottom: 0 !important;\n    }\n\n    .sectionWrapper .viewMore__cta {\n        color: #008CFF !important;\n        text-decoration: none !important;\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        cursor: pointer !important;\n        padding: 8px 16px !important;\n        border-radius: 6px !important;\n        transition: all 0.2s ease !important;\n        display: inline-block !important;\n        background-color: transparent !important;\n        border: none !important;\n    }\n\n    .tripMoneySection__bestRateBuy li {\n        width: 320px !important;\n    }\n\n    .productRangeList li {\n        border-bottom: none !important;\n    }\n\n    /* Hide containerImg for lg deviceType */\n    .containerImg {\n        display: none !important;\n    }\n\n    /* Quick Facts section styling for lg deviceType */\n    .container__card--yellow {\n        background-color: transparent !important;\n        border: none !important;\n        box-shadow: none !important;\n        padding: 0 !important;\n    }\n\n    .currencyFacts__heaading {\n        display: flex !important;\n        align-items: center !important;\n        gap: 12px !important;\n        margin-bottom: 24px !important;\n    }\n\n    .currencyFacts__heaading .quickfactsImg {\n        width: 24px !important;\n        height: 24px !important;\n        flex-shrink: 0 !important;\n    }\n\n    .currencyFacts__heaading h2 {\n        font-size: 20px !important;\n        font-weight: 600 !important;\n        line-height: 24px !important;\n        color: #333333 !important;\n        margin: 0 !important;\n    }\n\n    /* Header row styling for lg deviceType */\n    .currencyFacts__header-row {\n        background-color: #F5F5F5 !important;\n        border-bottom: 2px solid #E0E0E0 !important;\n    }\n\n    .currencyFacts__header-cell {\n        text-align: center !important;\n        padding: 20px !important;\n        border: none !important;\n    }\n\n    .currencyFacts__heaading--table {\n        justify-content: center !important;\n        align-items: center !important;\n        gap: 12px !important;\n        margin-bottom: 0 !important;\n    }\n\n    .currencyFacts__heaading--table .quickfactsImg {\n        width: 28px !important;\n        height: 28px !important;\n    }\n\n    .currencyFacts__heaading--table h2 {\n        font-size: 18px !important;\n        font-weight: 900 !important;\n        line-height: 22px !important;\n        color: #333333 !important;\n        margin: 0 !important;\n        text-align: center !important;\n    }\n\n    /* Hide the regular header for lg devices */\n    .currencyFacts__heaading:not(.currencyFacts__heaading--table) {\n        display: none !important;\n    }\n\n    .currencyFacts__list {\n        width: 100% !important;\n        border-collapse: collapse !important;\n        border: none !important;\n        border-radius: 8px !important;\n        overflow: hidden !important;\n    }\n\n    .currencyFacts__list tbody tr {\n        border: none !important;\n        border-bottom: none !important;\n    }\n\n    /* Alternating row colors - 1st row (odd) */\n    .currencyFacts__list tbody tr:nth-child(odd) {\n        background-color: #FFF7DD !important;\n    }\n\n    /* Alternating row colors - 2nd row (even) */\n    .currencyFacts__list tbody tr:nth-child(even) {\n        background-color: #FFFBEC !important;\n    }\n\n    .currencyFacts__list tbody tr td {\n        padding: 16px 20px !important;\n        border: none !important;\n        border-bottom: none !important;\n        vertical-align: middle !important;\n    }\n\n    .currencyFacts__list tbody tr td:first-child {\n        width: 45% !important;\n        padding-right: 20px !important;\n        font-weight: 900 !important;\n    }\n\n    .currencyFacts__list tbody tr td:last-child {\n        width: 55% !important;\n    }\n\n    /* Left column (labels) styling */\n    .currencyFacts__list tbody tr td span.latoBold {\n        font-size: 14px !important;\n        font-weight: 500 !important;\n        line-height: 20px !important;\n        color: #666666 !important;\n        font-family: 'Lato', sans-serif !important;\n    }\n\n    /* Right column (values) styling */\n    .currencyFacts__list tbody tr td span {\n        font-size: 14px !important;\n        font-weight: 400 !important;\n        line-height: 20px !important;\n        color: #333333 !important;\n        font-family: 'Lato', sans-serif !important;\n    }\n\n    /* Ensure CurrencySEOMarkdown doesn't override our styles */\n    .currencyFacts__list tbody tr td span p {\n        font-size: 14px !important;\n        font-weight: 400 !important;\n        line-height: 20px !important;\n        color: #333333 !important;\n        margin: 0 !important;\n    }\n\n    /* Show all capsules when showAll class is applied - nth-child approach handles this */\n\n    /* Hide separator in SectionWrapper */\n    .sectionWrapper .separator {\n        display: none !important;\n    }\n\n    /* Container width override for lg deviceType to match Figma design */\n    .container {\n        width: 1200px !important;\n    }\n\n    /* greySection padding override for lg deviceType */\n    .greySection {\n        padding: 20px 0 !important;\n    }\n\n    /* Remove padding-bottom and border-bottom from tripMoneySection for lg deviceType */\n    .tripMoneySection {\n        padding-bottom: 0 !important;\n        border-bottom: none !important;\n    }\n\n    /* Add 44px padding-top to description section as per Figma design for lg deviceType */\n    .tripMoneySection .about-description {\n        padding-top: 44px !important;\n    }\n\n    /* Country list styling for lg deviceType as per Figma design */\n    .countryList {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        gap: 16px !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        list-style: none !important;\n    }\n\n    .countryList li {\n        display: flex !important;\n        align-items: center !important;\n        gap: 12px !important;\n        padding: 8px !important;\n        background: #FFFFFF !important;\n        border: 1px solid #D8D8D8 !important;\n        border-radius: 16px !important;\n        box-shadow: none !important;\n        transition: none !important;\n        flex: 0 0 calc((100% - 80px) / 6) !important;\n        min-width: 0 !important;\n        width: calc((100% - 80px) / 6) !important;\n    }\n\n    .countryList li:hover {\n        box-shadow: none !important;\n        border-color: #D8D8D8 !important;\n        background: #FFFFFF !important;\n        transform: none !important;\n    }\n\n    .countryList .countryImg {\n        width: 40px !important;\n        height: 40px !important;\n        border-radius: 20px !important;\n        object-fit: cover !important;\n        flex-shrink: 0 !important;\n    }\n\n    .countryList .font16.latosemiBold,\n    .countryList a.font16.latosemiBold {\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        line-height: 1.2 !important;\n        color: #022135 !important;\n        text-decoration: none !important;\n        margin: 0 !important;\n        padding: 0 !important;\n    }\n\n    .countryList a.font16.latosemiBold:hover {\n        color: #022135 !important;\n        text-decoration: none !important;\n    }\n\n    /* FAQ section styles for lg deviceType - copied from CurrencyRatePageTemplate */\n    .faqList {\n        margin-top: 16px !important;\n    }\n\n    .faqList li h4.question {\n        font-size: 16px !important;\n        line-height: 16px !important;\n        padding: 12px 0px !important;\n        font-weight: 400 !important;\n    }\n\n    .faqList li h4.question::after {\n        top: 12px !important;\n    }\n\n    .faqList li:hover {\n        box-shadow: none !important;\n        border-color: transparent !important;\n        background-color: transparent !important;\n    }\n\n    .faqList li:hover h4.question {\n        background-color: transparent !important;\n        box-shadow: none !important;\n        border-radius: none !important;\n    }\n\n    .faqList li div.answer {\n        font-size: 14px !important;\n        margin-bottom: 16px !important;\n    }\n\n    /* Add 24px padding-top to text below country cards as per Figma design */\n    .countries-accepting-desc {\n        padding-top: 24px !important;\n    }\n\n    /* Process of exchanging section styling for lg deviceType as per Figma design */\n    .process-divider {\n        width: 100% !important;\n        height: 1px !important;\n        border-top: 1px dashed #D8D8D8 !important;\n        margin: 24px 0 !important;\n    }\n\n    .process-list {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 40px !important;\n        padding: 0 12px !important;\n        box-shadow: none !important;\n        border: none !important;\n        background: transparent !important;\n    }\n\n    .process-item {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 8px !important;\n    }\n\n    .process-item-header {\n        display: flex !important;\n        align-items: flex-start !important;\n        gap: 12px !important;\n    }\n\n    .process-icon {\n        width: 5px !important;\n        height: 12px !important;\n        background-color: #16477F !important;\n        border-radius: 2px !important;\n        margin-top: 8px !important;\n        flex-shrink: 0 !important;\n    }\n\n    .process-title {\n        font-family: Lato !important;\n        font-size: 22px !important;\n        font-weight: 900 !important;\n        line-height: 1.2 !important;\n        color: #000000 !important;\n        margin: 0 !important;\n        flex: 1 !important;\n    }\n\n    .process-item .appendBottom10 {\n        margin-bottom: 8px !important;\n        font-family: Lato !important;\n        font-size: 16px !important;\n        font-weight: 400 !important;\n        line-height: 1.2 !important;\n        color: #4A4A4A !important;\n    }\n\n    .process-item ul {\n        margin: 0 !important;\n        padding: 0 !important;\n        list-style: none !important;\n    }\n\n    .process-item ul li {\n        margin-bottom: 8px !important;\n        display: flex !important;\n        align-items: flex-start !important;\n        gap: 8px !important;\n    }\n\n    .process-item ul li:last-child {\n        margin-bottom: 0 !important;\n    }\n\n    .process-item ul li span {\n        font-family: Lato !important;\n        font-size: 16px !important;\n        font-weight: 400 !important;\n        line-height: 1.2 !important;\n        color: #4A4A4A !important;\n    }\n\n    /* Hide green check image for lg deviceType */\n    .process-item .greenCheckImg {\n        display: none !important;\n    }\n  " : "";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/CurrencyPageTemplate.tsx


function CurrencyPageTemplate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CurrencyPageTemplate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CurrencyPageTemplate_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CurrencyPageTemplate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















 // Wrapper component to handle deviceType logic





var SectionWrapper = function SectionWrapper(_ref) {
  var children = _ref.children,
      deviceType = _ref.deviceType;

  if (deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "sectionWrapper",
      children: children
    });
  }

  return children;
}; // Specialized wrapper for quick facts header responsive logic


var QuickFactsHeaderWrapper = function QuickFactsHeaderWrapper(_ref2) {
  var _currency$quick_facts, _currency$quick_facts2, _currency$quick_facts3;

  var currency = _ref2.currency,
      deviceType = _ref2.deviceType,
      children = _ref2.children;

  var headerContent = /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "currencyFacts__heaading",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
      className: "quickfactsImg"
    }, currency === null || currency === void 0 ? void 0 : (_currency$quick_facts = currency.quick_facts) === null || _currency$quick_facts === void 0 ? void 0 : _currency$quick_facts.quick_facts_logo), {}, {
      loading: "eager",
      alt: (currency === null || currency === void 0 ? void 0 : (_currency$quick_facts2 = currency.quick_facts) === null || _currency$quick_facts2 === void 0 ? void 0 : _currency$quick_facts2.title) || "Quick facts"
    })), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: currency === null || currency === void 0 ? void 0 : (_currency$quick_facts3 = currency.quick_facts) === null || _currency$quick_facts3 === void 0 ? void 0 : _currency$quick_facts3.title
    })]
  });

  if (deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE) {
    var _currency$quick_facts4, _currency$quick_facts5, _currency$quick_facts6;

    // Large devices: header goes inside table as first row
    return /*#__PURE__*/(0,jsx_runtime.jsx)("table", {
      className: "currencyFacts__list",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
          className: "currencyFacts__header-row",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            colSpan: 2,
            className: "currencyFacts__header-cell",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "currencyFacts__heaading currencyFacts__heaading--table",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                className: "quickfactsImg"
              }, currency === null || currency === void 0 ? void 0 : (_currency$quick_facts4 = currency.quick_facts) === null || _currency$quick_facts4 === void 0 ? void 0 : _currency$quick_facts4.quick_facts_logo), {}, {
                loading: "eager",
                alt: (currency === null || currency === void 0 ? void 0 : (_currency$quick_facts5 = currency.quick_facts) === null || _currency$quick_facts5 === void 0 ? void 0 : _currency$quick_facts5.title) || "Quick facts"
              })), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: currency === null || currency === void 0 ? void 0 : (_currency$quick_facts6 = currency.quick_facts) === null || _currency$quick_facts6 === void 0 ? void 0 : _currency$quick_facts6.title
              })]
            })
          })
        }), children]
      })
    });
  } // Non-large devices: header outside table


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [headerContent, /*#__PURE__*/(0,jsx_runtime.jsx)("table", {
      className: "currencyFacts__list",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
        children: children
      })
    })]
  });
};

var CurrencyPageTemplate = function CurrencyPageTemplate(_ref3) {
  var _currency$forex_solut, _currency$forex_solut2, _currency$common_imag, _currency$forex_solut3, _currency$header, _currency$forex_solut4, _PAGE_NAMES$SEO_CURRE2, _currency$flag, _currency$flag$curren, _currency$about, _Object, _currency$quick_facts7, _currency$about2, _currency$about3, _currency$quick_facts8, _Object2, _currency$quick_facts9, _currency$quick_facts10, _currency$quick_facts11, _currency$about4, _currency$history, _currency$history2, _currency$history3, _currency$countries_a, _currency$countries_a2, _currency$countries_a3, _currency$countries_a4, _currency$countries_a5, _currency$countries_a6, _currency$countries_a7, _currency$countries_a8, _currency$countries_a9, _currency$countries_a10, _Object3, _currency$countries_a11, _currency$countries_a12, _currency$countries_a13, _currency$countries_a14, _currency$amount_for_, _currency$amount_for_2, _currency$amount_for_3, _currency$identificat, _currency$identificat2, _currency$identificat3, _currency$identificat4, _currency$identificat5, _currency$identificat6, _currency$identificat7, _currency$identificat8, _currency$identificat9, _currency$process_of_, _currency$process_of_2, _currency$process_of_3, _currency$process_of_4, _currency$exchange, _currency$exchange2, _currency$primary_val, _currency$primary_val2, _currency$primary_val3, _currency$primary_val4, _currency$secondary_v, _currency$best_rates_, _currency$best_rates_2, _currency$best_ways_t, _currency$best_ways_t2, _currency$best_ways_t3, _currency$best_ways_t4, _currency$best_ways_t5, _currency$how_to_buy, _currency$how_to_buy2, _currency$how_to_buy3, _currency$how_to_buy4, _currency$documents_r, _currency$documents_r2, _currency$documents_r3, _currency$documents_r4, _currency$purposes_fo, _currency$purposes_fo2, _currency$purposes_fo3, _currency$buy_sell_on, _currency$buy_sell_on2, _currency$home_delive, _currency$home_delive2;

  var currency = _ref3.currency,
      isMmtHost = _ref3.isMmtHost,
      id = _ref3.id,
      deviceType = _ref3.deviceType,
      page_name = _ref3.page_name;

  var _useState = (0,react.useState)(false),
      scrolled = _useState[0],
      setScrolled = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showViewMore = _useState2[0],
      setShowViewMore = _useState2[1];

  var _useState3 = (0,react.useState)(4),
      cardsToBeShown = _useState3[0],
      setCardsToBeShown = _useState3[1];

  var hasHeroImage = currency === null || currency === void 0 ? void 0 : (_currency$forex_solut = currency.forex_solution) === null || _currency$forex_solut === void 0 ? void 0 : (_currency$forex_solut2 = _currency$forex_solut.forex_sol) === null || _currency$forex_solut2 === void 0 ? void 0 : _currency$forex_solut2.src;
  var isBot = (0,hooks/* useBotDetection */.Um)();

  var _useContext = (0,react.useContext)(CurrencySEOContext),
      refreshBtn = _useContext.refreshBtn,
      currencyCode = _useContext.currencyCode,
      exchangeRateApi = _useContext.exchangeRateApi,
      inrRate = _useContext.inrRate,
      setInrRate = _useContext.setInrRate;

  (0,react.useEffect)(function () {
    var _PAGE_NAMES$SEO_CURRE;

    var handleScroll = function handleScroll() {
      if (window.scrollY > 60) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    (0,analytics/* trackSeoPageLoad */.XE)({
      pageName: (_PAGE_NAMES$SEO_CURRE = analytics/* PAGE_NAMES.SEO_CURRENCY_NAME */.a3.SEO_CURRENCY_NAME) === null || _PAGE_NAMES$SEO_CURRE === void 0 ? void 0 : _PAGE_NAMES$SEO_CURRE.replace("NAME", currency === null || currency === void 0 ? void 0 : currency.name),
      currency: currency === null || currency === void 0 ? void 0 : currency.name
    });
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  var _ref4 = (currency === null || currency === void 0 ? void 0 : currency.forex_solution) || {},
      btn_link = _ref4.btn_link,
      btn_text = _ref4.btn_text,
      img_link = _ref4.img_link,
      desc = _ref4.desc,
      title = _ref4.title,
      list = _ref4.list,
      forex_sol = _ref4.forex_sol,
      forex_sol_mobile = _ref4.forex_sol_mobile;

  var heroProps = {
    btn_link: btn_link,
    btn_text: btn_text,
    img_link: img_link,
    desc: desc,
    title: title,
    list: list,
    forex_sol: forex_sol,
    forex_sol_mobile: forex_sol_mobile,
    green_check: currency === null || currency === void 0 ? void 0 : (_currency$common_imag = currency.common_images) === null || _currency$common_imag === void 0 ? void 0 : _currency$common_imag.green_check
  };

  var handleOnClick = function handleOnClick() {
    setShowViewMore(false);
    setCardsToBeShown(14);
  };

  var renderIfExchangeRateIsNotZero = function renderIfExchangeRateIsNotZero(fact) {
    if (fact === "INR_Exchange_Rate" && parseFloat("".concat(inrRate)) <= 0) {
      return false;
    }

    return true;
  }; // Define heading1 for top banner title


  var heading1 = (currency === null || currency === void 0 ? void 0 : (_currency$forex_solut3 = currency.forex_solution) === null || _currency$forex_solut3 === void 0 ? void 0 : _currency$forex_solut3.title) || "";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* FontStyles */.B2, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* BaseStyles */.xR, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* TripMoneyStyles */.KL, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyPageStyle, {
      deviceType: deviceType
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyPageTemplate_CurrencyDocumet, {
      currency: currency,
      hasHeroImage: hasHeroImage,
      id: id
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DeeplinkLinkAnchor, {
          rel: "alternate",
          href: "android-app://com.makemytrip/mmyt/app/forex?code=PC&page=forexListing"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeeplinkMetaAnchor, {
          name: "apple-itunes-app",
          content: "app-id=123456789, app-argument=mmyt://app/forex?code=PC&page=forexListing"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "header__inner",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: currency === null || currency === void 0 ? void 0 : (_currency$header = currency.header) === null || _currency$header === void 0 ? void 0 : _currency$header.image_link,
            children: isMmtHost ? /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* MMTLogo */.X, {
              isLight: false
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(BMFLogo/* default */.Z, {
              isLight: scrolled ? false : true
            })
          })
        })]
      }), deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "topBlueSection"
      }), deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroWebV2/* HeroWebV2 */.F, {
        title: heading1,
        desc: currency === null || currency === void 0 ? void 0 : (_currency$forex_solut4 = currency.forex_solution) === null || _currency$forex_solut4 === void 0 ? void 0 : _currency$forex_solut4.desc,
        breadcrumb: (currency === null || currency === void 0 ? void 0 : currency.breadcrumb) || [],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_cjs/* ListingUiWrapper */.ev, {
          source_type: "seo",
          isBot: isBot,
          deviceType: deviceType,
          page_name: page_name
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "greySection ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "bg-light-grey" : ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container negativeMargin",
          children: [deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroV2/* HeroV2 */.n, CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({}, heroProps), {}, {
            breadcrumb: currency === null || currency === void 0 ? void 0 : currency.breadcrumb
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pageContainer pageContainer_margin sectionGapping",
            children: deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(ForexProducts/* default */.Z, {
              currencyData: currency,
              pageName: (_PAGE_NAMES$SEO_CURRE2 = analytics/* PAGE_NAMES.SEO_CURRENCY_NAME */.a3.SEO_CURRENCY_NAME) === null || _PAGE_NAMES$SEO_CURRE2 === void 0 ? void 0 : _PAGE_NAMES$SEO_CURRE2.replace("NAME", currency === null || currency === void 0 ? void 0 : currency.name)
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: "tripMoneySection makeFlex hrtlCenter",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              width: 104,
              height: 48,
              className: "currencyLogoImg",
              src: currency === null || currency === void 0 ? void 0 : (_currency$flag = currency.flag) === null || _currency$flag === void 0 ? void 0 : (_currency$flag$curren = _currency$flag[currency === null || currency === void 0 ? void 0 : currency.country_code]) === null || _currency$flag$curren === void 0 ? void 0 : _currency$flag$curren.src,
              alt: "country flag",
              loading: "eager"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              children: currency === null || currency === void 0 ? void 0 : currency.name
            })]
          }), currency !== null && currency !== void 0 && (_currency$about = currency.about) !== null && _currency$about !== void 0 && _currency$about.desc || ((_Object = Object(currency === null || currency === void 0 ? void 0 : (_currency$quick_facts7 = currency.quick_facts) === null || _currency$quick_facts7 === void 0 ? void 0 : _currency$quick_facts7.facts)) === null || _Object === void 0 ? void 0 : _Object.length) !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
                className: "appendBottom30",
                children: [currency === null || currency === void 0 ? void 0 : (_currency$about2 = currency.about) === null || _currency$about2 === void 0 ? void 0 : _currency$about2.title, currency === null || currency === void 0 ? void 0 : (_currency$about3 = currency.about) === null || _currency$about3 === void 0 ? void 0 : _currency$about3.title_text]
              }), currency !== null && currency !== void 0 && (_currency$quick_facts8 = currency.quick_facts) !== null && _currency$quick_facts8 !== void 0 && _currency$quick_facts8.facts && ((_Object2 = Object(currency === null || currency === void 0 ? void 0 : (_currency$quick_facts9 = currency.quick_facts) === null || _currency$quick_facts9 === void 0 ? void 0 : _currency$quick_facts9.facts)) === null || _Object2 === void 0 ? void 0 : _Object2.length) !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "container__card container__card--yellow",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuickFactsHeaderWrapper, {
                  currency: currency,
                  deviceType: deviceType,
                  children: currency === null || currency === void 0 ? void 0 : (_currency$quick_facts10 = currency.quick_facts) === null || _currency$quick_facts10 === void 0 ? void 0 : (_currency$quick_facts11 = _currency$quick_facts10.list) === null || _currency$quick_facts11 === void 0 ? void 0 : _currency$quick_facts11.map(function (fact) {
                    var _currency$quick_facts12, _currency$quick_facts13, _currency$quick_facts14, _currency$quick_facts15;

                    return currency !== null && currency !== void 0 && (_currency$quick_facts12 = currency.quick_facts) !== null && _currency$quick_facts12 !== void 0 && (_currency$quick_facts13 = _currency$quick_facts12.facts) !== null && _currency$quick_facts13 !== void 0 && _currency$quick_facts13[fact] && renderIfExchangeRateIsNotZero(fact) ? /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "latoBold",
                          children: (0,utility_src.t)(fact, {
                            _: " "
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                            children: currency === null || currency === void 0 ? void 0 : (_currency$quick_facts14 = currency.quick_facts) === null || _currency$quick_facts14 === void 0 ? void 0 : (_currency$quick_facts15 = _currency$quick_facts14.facts) === null || _currency$quick_facts15 === void 0 ? void 0 : _currency$quick_facts15[fact]
                          })
                        })
                      })]
                    }, fact) : null;
                  })
                })
              }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "about-description",
                children: currency === null || currency === void 0 ? void 0 : (_currency$about4 = currency.about) === null || _currency$about4 === void 0 ? void 0 : _currency$about4.desc
              })]
            })
          }) : null, currency !== null && currency !== void 0 && (_currency$history = currency.history) !== null && _currency$history !== void 0 && _currency$history.desc ? /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$history2 = currency.history) === null || _currency$history2 === void 0 ? void 0 : _currency$history2.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                children: currency === null || currency === void 0 ? void 0 : (_currency$history3 = currency.history) === null || _currency$history3 === void 0 ? void 0 : _currency$history3.desc
              })]
            })
          }) : null, currency !== null && currency !== void 0 && (_currency$countries_a = currency.countries_accepting) !== null && _currency$countries_a !== void 0 && _currency$countries_a.desc_1 || currency !== null && currency !== void 0 && (_currency$countries_a2 = currency.countries_accepting) !== null && _currency$countries_a2 !== void 0 && _currency$countries_a2.desc_2 || currency !== null && currency !== void 0 && (_currency$countries_a3 = currency.countries_accepting) !== null && _currency$countries_a3 !== void 0 && _currency$countries_a3.list && (currency === null || currency === void 0 ? void 0 : (_currency$countries_a4 = currency.countries_accepting) === null || _currency$countries_a4 === void 0 ? void 0 : (_currency$countries_a5 = _currency$countries_a4.list) === null || _currency$countries_a5 === void 0 ? void 0 : _currency$countries_a5.length) !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$countries_a6 = currency.countries_accepting) === null || _currency$countries_a6 === void 0 ? void 0 : _currency$countries_a6.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$countries_a7 = currency.countries_accepting) === null || _currency$countries_a7 === void 0 ? void 0 : _currency$countries_a7.desc_1
              }), currency !== null && currency !== void 0 && (_currency$countries_a8 = currency.countries_accepting) !== null && _currency$countries_a8 !== void 0 && _currency$countries_a8.list && (currency === null || currency === void 0 ? void 0 : (_currency$countries_a9 = currency.countries_accepting) === null || _currency$countries_a9 === void 0 ? void 0 : (_currency$countries_a10 = _currency$countries_a9.list) === null || _currency$countries_a10 === void 0 ? void 0 : _currency$countries_a10.length) !== 0 && currency !== null && currency !== void 0 && currency.flag && ((_Object3 = Object(currency === null || currency === void 0 ? void 0 : currency.flag)) === null || _Object3 === void 0 ? void 0 : _Object3.length) !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "appendBottom20",
                  children: currency === null || currency === void 0 ? void 0 : (_currency$countries_a11 = currency.countries_accepting) === null || _currency$countries_a11 === void 0 ? void 0 : _currency$countries_a11.list_title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "countryList",
                  children: currency === null || currency === void 0 ? void 0 : (_currency$countries_a12 = currency.countries_accepting) === null || _currency$countries_a12 === void 0 ? void 0 : (_currency$countries_a13 = _currency$countries_a12.list) === null || _currency$countries_a13 === void 0 ? void 0 : _currency$countries_a13.map(function (country_code) {
                    var _currency$flag2, _currency$flag3, _currency$flag4, _currency$flag4$count, _currency$flag5, _currency$flag5$defau, _currency$flag6, _currency$flag6$count, _currency$flag7, _currency$flag7$count, _currency$flag8, _currency$flag8$count, _currency$flag9, _currency$flag9$count, _currency$flag10, _currency$flag10$coun, _currency$flag11, _currency$flag11$coun, _currency$flag12, _currency$flag12$coun;

                    return currency !== null && currency !== void 0 && (_currency$flag2 = currency.flag) !== null && _currency$flag2 !== void 0 && _currency$flag2[country_code] ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                        className: "countryImg"
                      }, currency === null || currency === void 0 ? void 0 : (_currency$flag3 = currency.flag) === null || _currency$flag3 === void 0 ? void 0 : _currency$flag3.common), {}, {
                        src: currency === null || currency === void 0 ? void 0 : (_currency$flag4 = currency.flag) === null || _currency$flag4 === void 0 ? void 0 : (_currency$flag4$count = _currency$flag4[country_code]) === null || _currency$flag4$count === void 0 ? void 0 : _currency$flag4$count.src,
                        alt: (0,utility_src.t)(currency === null || currency === void 0 ? void 0 : (_currency$flag5 = currency.flag) === null || _currency$flag5 === void 0 ? void 0 : (_currency$flag5$defau = _currency$flag5.default) === null || _currency$flag5$defau === void 0 ? void 0 : _currency$flag5$defau.alt, {
                          "{country_name}": currency !== null && currency !== void 0 && (_currency$flag6 = currency.flag) !== null && _currency$flag6 !== void 0 && (_currency$flag6$count = _currency$flag6[country_code]) !== null && _currency$flag6$count !== void 0 && _currency$flag6$count.name ? currency === null || currency === void 0 ? void 0 : (_currency$flag7 = currency.flag) === null || _currency$flag7 === void 0 ? void 0 : (_currency$flag7$count = _currency$flag7[country_code]) === null || _currency$flag7$count === void 0 ? void 0 : _currency$flag7$count.name : "country"
                        }),
                        loading: "lazy"
                      })), (currency === null || currency === void 0 ? void 0 : (_currency$flag8 = currency.flag) === null || _currency$flag8 === void 0 ? void 0 : (_currency$flag8$count = _currency$flag8[country_code]) === null || _currency$flag8$count === void 0 ? void 0 : _currency$flag8$count.url) === "/#" || (currency === null || currency === void 0 ? void 0 : (_currency$flag9 = currency.flag) === null || _currency$flag9 === void 0 ? void 0 : (_currency$flag9$count = _currency$flag9[country_code]) === null || _currency$flag9$count === void 0 ? void 0 : _currency$flag9$count.url) === "/" ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "font16 latosemiBold",
                        children: currency === null || currency === void 0 ? void 0 : (_currency$flag10 = currency.flag) === null || _currency$flag10 === void 0 ? void 0 : (_currency$flag10$coun = _currency$flag10[country_code]) === null || _currency$flag10$coun === void 0 ? void 0 : _currency$flag10$coun.name
                      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        className: "font16 latosemiBold",
                        href: currency === null || currency === void 0 ? void 0 : (_currency$flag11 = currency.flag) === null || _currency$flag11 === void 0 ? void 0 : (_currency$flag11$coun = _currency$flag11[country_code]) === null || _currency$flag11$coun === void 0 ? void 0 : _currency$flag11$coun.url,
                        children: currency === null || currency === void 0 ? void 0 : (_currency$flag12 = currency.flag) === null || _currency$flag12 === void 0 ? void 0 : (_currency$flag12$coun = _currency$flag12[country_code]) === null || _currency$flag12$coun === void 0 ? void 0 : _currency$flag12$coun.name
                      })]
                    }, country_code) : null;
                  })
                })]
              }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "countries-accepting-desc",
                children: currency === null || currency === void 0 ? void 0 : (_currency$countries_a14 = currency.countries_accepting) === null || _currency$countries_a14 === void 0 ? void 0 : _currency$countries_a14.desc_2
              })]
            })
          }) : null, currency !== null && currency !== void 0 && (_currency$amount_for_ = currency.amount_for_trip) !== null && _currency$amount_for_ !== void 0 && _currency$amount_for_.desc ? /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$amount_for_2 = currency.amount_for_trip) === null || _currency$amount_for_2 === void 0 ? void 0 : _currency$amount_for_2.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                children: currency === null || currency === void 0 ? void 0 : (_currency$amount_for_3 = currency.amount_for_trip) === null || _currency$amount_for_3 === void 0 ? void 0 : _currency$amount_for_3.desc
              })]
            })
          }) : null, currency !== null && currency !== void 0 && (_currency$identificat = currency.identification) !== null && _currency$identificat !== void 0 && _currency$identificat.list && (currency === null || currency === void 0 ? void 0 : (_currency$identificat2 = currency.identification) === null || _currency$identificat2 === void 0 ? void 0 : (_currency$identificat3 = _currency$identificat2.list) === null || _currency$identificat3 === void 0 ? void 0 : _currency$identificat3.length) !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "identification-wrapper ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "identification-wrapper--lg" : ""),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "identification-section",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "container ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "identification-container--lg" : ""),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
                    className: "tripMoneySection makeFlex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                        className: "appendBottom30",
                        children: currency === null || currency === void 0 ? void 0 : (_currency$identificat4 = currency.identification) === null || _currency$identificat4 === void 0 ? void 0 : _currency$identificat4.title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "counterFietImgWrapMweb",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({}, currency === null || currency === void 0 ? void 0 : (_currency$identificat5 = currency.identification) === null || _currency$identificat5 === void 0 ? void 0 : _currency$identificat5.counterfiet_mobile_logo), {}, {
                          loading: "lazy"
                        }))
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        className: "appendBottom20",
                        children: currency === null || currency === void 0 ? void 0 : (_currency$identificat6 = currency.identification) === null || _currency$identificat6 === void 0 ? void 0 : _currency$identificat6.list_title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                        children: currency === null || currency === void 0 ? void 0 : (_currency$identificat7 = currency.identification) === null || _currency$identificat7 === void 0 ? void 0 : (_currency$identificat8 = _currency$identificat7.list) === null || _currency$identificat8 === void 0 ? void 0 : _currency$identificat8.map(function (item, index) {
                          var _currency$common_imag2;

                          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                            className: "makeFlex ".concat(index < currency.identification.list.length - 1 ? "dashedBorder" : ""),
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                              className: "greenCheckImg"
                            }, currency === null || currency === void 0 ? void 0 : (_currency$common_imag2 = currency.common_images) === null || _currency$common_imag2 === void 0 ? void 0 : _currency$common_imag2.green_check), {}, {
                              loading: "lazy"
                            })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                                children: item
                              })
                            })]
                          }, item);
                        })
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "counterFietImgWrap",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({}, currency === null || currency === void 0 ? void 0 : (_currency$identificat9 = currency.identification) === null || _currency$identificat9 === void 0 ? void 0 : _currency$identificat9.counterfiet_logo), {}, {
                        loading: "lazy"
                      }))
                    })]
                  })
                })
              })
            })
          }) : null]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "container--margin-top-24" : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$process_of_ = currency.process_of_exchanging) === null || _currency$process_of_ === void 0 ? void 0 : _currency$process_of_.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "appendBottom35 process-desc",
                children: currency === null || currency === void 0 ? void 0 : (_currency$process_of_2 = currency.process_of_exchanging) === null || _currency$process_of_2 === void 0 ? void 0 : _currency$process_of_2.desc
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "process-divider"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "container__card process-list",
                children: currency === null || currency === void 0 ? void 0 : (_currency$process_of_3 = currency.process_of_exchanging) === null || _currency$process_of_3 === void 0 ? void 0 : (_currency$process_of_4 = _currency$process_of_3.list) === null || _currency$process_of_4 === void 0 ? void 0 : _currency$process_of_4.map(function (item, index) {
                  var _item$list, _item$list2;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "process-item",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "process-item-header",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "process-icon"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                        className: "appendBottom18 process-title",
                        children: item === null || item === void 0 ? void 0 : item.title
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      className: "appendBottom10",
                      children: item === null || item === void 0 ? void 0 : item.desc
                    }), (item === null || item === void 0 ? void 0 : (_item$list = item.list) === null || _item$list === void 0 ? void 0 : _item$list.length) !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: item === null || item === void 0 ? void 0 : (_item$list2 = item.list) === null || _item$list2 === void 0 ? void 0 : _item$list2.map(function (ele) {
                        var _currency$common_imag3;

                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "makeFlex appendBottom15",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                            className: "greenCheckImg"
                          }, currency === null || currency === void 0 ? void 0 : (_currency$common_imag3 = currency.common_images) === null || _currency$common_imag3 === void 0 ? void 0 : _currency$common_imag3.green_check), {}, {
                            loading: "lazy"
                          })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                              children: ele
                            })
                          })]
                        }, ele);
                      })
                    }) : null]
                  }, index);
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$exchange = currency.exchange) === null || _currency$exchange === void 0 ? void 0 : _currency$exchange.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: deviceType === "lg" ? "" : "appendBottom60",
                children: currency === null || currency === void 0 ? void 0 : (_currency$exchange2 = currency.exchange) === null || _currency$exchange2 === void 0 ? void 0 : _currency$exchange2.desc
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "dashedBorder"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "container__card appendBottom80",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                  className: "containerImg"
                }, currency === null || currency === void 0 ? void 0 : (_currency$primary_val = currency.primary_value_proposition) === null || _currency$primary_val === void 0 ? void 0 : _currency$primary_val.img), {}, {
                  loading: "lazy"
                })), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "appendBottom30",
                  children: currency === null || currency === void 0 ? void 0 : (_currency$primary_val2 = currency.primary_value_proposition) === null || _currency$primary_val2 === void 0 ? void 0 : _currency$primary_val2.title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "productRangeList",
                  children: currency === null || currency === void 0 ? void 0 : (_currency$primary_val3 = currency.primary_value_proposition) === null || _currency$primary_val3 === void 0 ? void 0 : (_currency$primary_val4 = _currency$primary_val3.list) === null || _currency$primary_val4 === void 0 ? void 0 : _currency$primary_val4.map(function (product) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: product
                      })
                    }, product);
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "exchangeRateWrap",
                children: currency === null || currency === void 0 ? void 0 : (_currency$secondary_v = currency.secondary_value_proposition) === null || _currency$secondary_v === void 0 ? void 0 : _currency$secondary_v.map(function (value) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "container__card",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                      className: "containerImg"
                    }, value === null || value === void 0 ? void 0 : value.img), {}, {
                      loading: "lazy"
                    })), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "appendBottom8",
                      children: value === null || value === void 0 ? void 0 : value.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      children: value === null || value === void 0 ? void 0 : value.desc
                    })]
                  }, value === null || value === void 0 ? void 0 : value.title);
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$best_rates_ = currency.best_rates_of_exchange) === null || _currency$best_rates_ === void 0 ? void 0 : _currency$best_rates_.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                children: currency === null || currency === void 0 ? void 0 : (_currency$best_rates_2 = currency.best_rates_of_exchange) === null || _currency$best_rates_2 === void 0 ? void 0 : _currency$best_rates_2.desc
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$best_ways_t = currency.best_ways_to_carry) === null || _currency$best_ways_t === void 0 ? void 0 : _currency$best_ways_t.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "appendBottom24",
                children: currency === null || currency === void 0 ? void 0 : (_currency$best_ways_t2 = currency.best_ways_to_carry) === null || _currency$best_ways_t2 === void 0 ? void 0 : _currency$best_ways_t2.desc
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "container__card container__cardAlign",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "tripmoneyImgWrap",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                    className: "tripMoneyImg"
                  }, currency === null || currency === void 0 ? void 0 : (_currency$best_ways_t3 = currency.best_ways_to_carry) === null || _currency$best_ways_t3 === void 0 ? void 0 : _currency$best_ways_t3.tripmoney_logo), {}, {
                    loading: "lazy"
                  }))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: currency === null || currency === void 0 ? void 0 : (_currency$best_ways_t4 = currency.best_ways_to_carry) === null || _currency$best_ways_t4 === void 0 ? void 0 : (_currency$best_ways_t5 = _currency$best_ways_t4.list) === null || _currency$best_ways_t5 === void 0 ? void 0 : _currency$best_ways_t5.map(function (way, index) {
                    var _currency$best_ways_t6, _currency$best_ways_t7;

                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                        className: "blackText appendBottom10",
                        children: way === null || way === void 0 ? void 0 : way.title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: way === null || way === void 0 ? void 0 : way.desc
                      }), index < (currency === null || currency === void 0 ? void 0 : (_currency$best_ways_t6 = currency.best_ways_to_carry) === null || _currency$best_ways_t6 === void 0 ? void 0 : (_currency$best_ways_t7 = _currency$best_ways_t6.list) === null || _currency$best_ways_t7 === void 0 ? void 0 : _currency$best_ways_t7.length) - 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "dashedBorder"
                      }) : null]
                    }, way === null || way === void 0 ? void 0 : way.title);
                  })
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              className: "tripMoneySection",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "appendBottom20",
                children: currency === null || currency === void 0 ? void 0 : (_currency$how_to_buy = currency.how_to_buy) === null || _currency$how_to_buy === void 0 ? void 0 : _currency$how_to_buy.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "appendBottom24",
                children: currency === null || currency === void 0 ? void 0 : (_currency$how_to_buy2 = currency.how_to_buy) === null || _currency$how_to_buy2 === void 0 ? void 0 : _currency$how_to_buy2.desc
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "tripMoneySection__bestRateBuy",
                children: currency === null || currency === void 0 ? void 0 : (_currency$how_to_buy3 = currency.how_to_buy) === null || _currency$how_to_buy3 === void 0 ? void 0 : (_currency$how_to_buy4 = _currency$how_to_buy3.list) === null || _currency$how_to_buy4 === void 0 ? void 0 : _currency$how_to_buy4.map(function (item, index) {
                  var _currency$how_to_buy5;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "stepCount",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "font16",
                        children: currency === null || currency === void 0 ? void 0 : (_currency$how_to_buy5 = currency.how_to_buy) === null || _currency$how_to_buy5 === void 0 ? void 0 : _currency$how_to_buy5.common
                      }), " ", index + 1 < 9 ? "0" + (index + 1) : index + 1]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      children: item
                    })]
                  }, index);
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "container__card",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "appendBottom10",
                  children: currency === null || currency === void 0 ? void 0 : (_currency$documents_r = currency.documents_required) === null || _currency$documents_r === void 0 ? void 0 : _currency$documents_r.title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                  className: "appendBottom20",
                  children: currency === null || currency === void 0 ? void 0 : (_currency$documents_r2 = currency.documents_required) === null || _currency$documents_r2 === void 0 ? void 0 : _currency$documents_r2.desc
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "documentList",
                  children: currency === null || currency === void 0 ? void 0 : (_currency$documents_r3 = currency.documents_required) === null || _currency$documents_r3 === void 0 ? void 0 : (_currency$documents_r4 = _currency$documents_r3.list) === null || _currency$documents_r4 === void 0 ? void 0 : _currency$documents_r4.map(function (doc) {
                    var _currency$common_imag4;

                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", CurrencyPageTemplate_objectSpread(CurrencyPageTemplate_objectSpread({
                        className: "greenCheckImg"
                      }, currency === null || currency === void 0 ? void 0 : (_currency$common_imag4 = currency.common_images) === null || _currency$common_imag4 === void 0 ? void 0 : _currency$common_imag4.green_check), {}, {
                        loading: "lazy"
                      })), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                        children: doc
                      })]
                    }, doc);
                  })
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
              className: "tripMoneySection",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "exchangeRateWrap appendBottom35",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "container__card flexOne",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    className: "appendBottom22",
                    children: currency === null || currency === void 0 ? void 0 : (_currency$purposes_fo = currency.purposes_for_exchanging) === null || _currency$purposes_fo === void 0 ? void 0 : _currency$purposes_fo.title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                    className: "productRangeList",
                    children: currency === null || currency === void 0 ? void 0 : (_currency$purposes_fo2 = currency.purposes_for_exchanging) === null || _currency$purposes_fo2 === void 0 ? void 0 : (_currency$purposes_fo3 = _currency$purposes_fo2.list) === null || _currency$purposes_fo3 === void 0 ? void 0 : _currency$purposes_fo3.map(function (purpose, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        className: index < currency.purposes_for_exchanging.list.length - 1 ? "dashedBorder" : "",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                          children: purpose
                        })
                      }, purpose);
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flexOne makeFlex column",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "container__card appendBottom30",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                      className: "appendBottom22",
                      children: currency === null || currency === void 0 ? void 0 : (_currency$buy_sell_on = currency.buy_sell_online) === null || _currency$buy_sell_on === void 0 ? void 0 : _currency$buy_sell_on.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      children: currency === null || currency === void 0 ? void 0 : (_currency$buy_sell_on2 = currency.buy_sell_online) === null || _currency$buy_sell_on2 === void 0 ? void 0 : _currency$buy_sell_on2.desc
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "container__card",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                      className: "appendBottom22",
                      children: currency === null || currency === void 0 ? void 0 : (_currency$home_delive = currency.home_delivery) === null || _currency$home_delive === void 0 ? void 0 : _currency$home_delive.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                      children: currency === null || currency === void 0 ? void 0 : (_currency$home_delive2 = currency.home_delivery) === null || _currency$home_delive2 === void 0 ? void 0 : _currency$home_delive2.desc
                    })]
                  })]
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverter/* default */.Z, {
              currConversion: currency === null || currency === void 0 ? void 0 : currency.currency_conversions
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
              currencyData: currency
            })
          })]
        })]
      }), currency !== null && currency !== void 0 && currency.footer ? /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyFooter/* CurrencyFooter */.H, {
        footer: currency.footer
      }) : null]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/currencyData.ts
var currencyData=[{id:1,internalName:"seo_currency_default",type:"seo_currency_default",data:{common_images:{green_check:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/green_Check_d5c6a3c98c.png",alt:"green check",width:18,height:18}},title:"{currency_name} - {currency_code} Price, Currency Exchange Rate In India|MakeMyTrip",meta_desc:"Get the latest exchange rate for the {currency_name} ({currency_code}) and learn about the AUD currency, its history, and its use in international transactions.",allow_indexing:true,refresh_btn:"🔄",mmt_logo_visible:false,forex_solution:{title:"Easy Forex Solutions for Int’l Trips!",desc:"We offer the best foreign exchange rates, full digital order placement and home-delivered forex options.",list:["Get foreign currency notes at the lowest exchange rates","Load in INR and spend in currency with TripMoney’s Global Cash Card","Avail 0% forex mark-up &amp; same-day delivery with BookMyForex Card"],btn_text:"Get Started",btn_link:"https://lending.makemytrip.com/ext/api/v1/partners/mmt/initOTU?product=forex&utm_source={domain_name}&utm_medium=currency-seo",forex_sol_mobile:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/forex_Sol_Img_ee53c24f53.png",alt:"forex solution",width:224,height:160},forex_sol:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/forex_Sol_Img_ee53c24f53.png",alt:"forex solution",width:392,height:279}},about:{title:"About The {currency_name}: "},quick_facts:{title:"Quick Facts About the {currency_name} Notes",list:["Country_of_Origin","Symbol","Currency_Code","Nick_Names","Minor_units","Denominations_(Banknotes)","Motto","Identification_Feature","Issuing_Bank","In_Circulation_Since","INR_Exchange_Rate"],quick_facts_logo:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/quick_Facts_8525dbd4b1.png",alt:"quick facts",width:48,height:48}},history:{title:"History of he {currency_name}"},countries_accepting:{title:"Countries Accepting the {currency_name}",list_title:"Here is a list of the countries where the {currency_name} is used as the official currency:"},amount_for_trip:{title:"Amount in the {currency_name} You Should Carry for Your Trip"},identification:{title:"Best Ways to Identify Counterfeit {currency_name} Notes",list_title:"There are a few ways through which you can spot the counterfeit **{currency_name}** notes:",counterfiet_mobile_logo:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/counterfiet_Img_9c1c9605f5.png",alt:"counterfiet",width:330,height:448},counterfiet_logo:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/counterfiet_Img_9c1c9605f5.png",alt:"counterfiet",width:427,height:579}},process_of_exchanging:{title:"Process of Exchanging the {currency_name}",desc:"The process of converting the **{currency_name} to Indian Rupee** is immensely easy. Please note that the **1 {currency_name} to INR** value is subject to change so keep an eye on the **{currency_name} rate alert**. Below, we have mentioned some of the popular ways to convert **{currency_name}s to Rupees**.",list:[{title:"Internationally-Accepted Cards",desc:"A multi-currency forex card and a global cash card are counted among the most economical and safest ways of carrying the **{currency_name}**.",list:["The BookMyForex Multi-Currency card can be loaded in 14 currencies and features zero forex mark-up.","On the other hand, the TripMoney Global Cash Card can be loaded in INR, and the money can be spent globally. There is no forex mark-up for an INR card."]},{title:"Online Forex Marketplace",desc:"The simplest and most cost-efficient way of converting your {currency_name} is using an online forex marketplace such as TripMoney, a platform by MakeMyTrip, offering the best conversion rates and currency exchange service. The platform offers a 5-minute fully-digital online process for currency exchange.",list:[]},{title:"Visiting Your Bank",desc:"The most traditional way of converting the {currency_name} to Rupee is by visiting a bank and standing in long queues. It is not only time-consuming but you also end up paying a high cost for making the {currency_name} convert to Indian Rupees.",list:[]},{title:"Local Money Changers",desc:"You can look for an Authorised Dealer Category II or someone who has a money changers licence. Money exchangers offer competitive {currency_name} exchange rates, and you’d not need a bank account in this case. However, the process of rate haggling can be quite frustrating for those who are looking for an easy way to convert {currency_name} to INR.\n\n &nbsp; \n\n On the other hand, TripMoney, the online marketplace, offers internationally-accepted forex card, global cash card and currency notes at the best rates via a convenient online process.",list:[]},{title:"Airport",desc:"If you would like to convert the {currency_name} in India, one of the costliest ways to do so would be to get the {currency_name} exchanged at an airport due to the exorbitantly high {currency_code} exchange rates. Currency exchange at the airport will prove to be 5%-15% costlier than TripMoney.",list:[]}]},exchange:{title:"Exchange the {currency_name} with TripMoney",desc:"TripMoney, the online forex marketplace by MakeMyTrip, makes it a hassle-free affair for you to convert the {currency_code} to Indian Rupees as well as Indian Rupee to {currency_name}. Please note that the 1 {currency_name} to INR value is subject to change so keep an eye on the {currency_name} rate alert. You should choose MakeMyTrip for currency exchange for the following reasons:"},primary_value_proposition:{title:"Wide Range of Products",img:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/wide_Range_c7a39320df.png",alt:"wide range products",width:80,height:80},list:["**Forex (Currency Notes)** - Available in 100+ cities across India, TripMoney allows you to get your currency notes delivered on the same day or the next day after 100% digital booking.","**TripMoney Global Cash Card** - You can load this card in INR and spend the money globally. This card comes with no forex mark-up.","**BookMyForex Multi-Currency** - You can load this card in 14 currencies with 0% Forex Mark-up. Once you have booked this card, you can receive it the same day (if booking is made before 1 PM) or the next.","**International Travel Insurance** - TripMoney also offers international travel insurance at cheapest rates in the market. Also, you can opt for this product if you’d like TripMoney to handle your mandatory travel insurance requirements along with a VISA application.","**Travel Loan** - With TripMoney, you can avail a travel loan of up to INR 1,00,000 (lifetime limit) for all your travel and holiday needs."]},secondary_value_proposition:[{title:"Best Exchange Rates",img:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/exchange_Rate_bcb4a00f7d.png",alt:"Best Exchange Rates",width:80,height:80},desc:"TripMoney makes it easy for you to buy **{currency_name}** or sell {currency_name} at live and best exchange rates."},{title:"Quick Money Transfer",img:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/quick_Transfer_e1f0f0e9cc.png",alt:"Quick Money Transfer",width:80,height:80},desc:"You can also enjoy quick international money transfers on TripMoney. The 5-minute digital process offers the best forex rates, and you can receive funds abroad within 12 to 48 hours."},{title:"Home Delivery",img:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/home_Delivery_f537472f52.png",alt:"Home Delivery",width:80,height:80},desc:"TripMoney delivers the {currency_name}s at your doorstep. So, you can simply order and receive your currency from the comfort of your home."}],best_rates_of_exchange:{title:"Best Rates to Exchange the {currency_name}",desc:"You’d need to keep an eye on the current **currency rates**, if you’d like to know the exact value you’d get on converting **1 {currency_name} in Rupees**. The exchange rates keep on fluctuating. TripMoney, an online forex marketplace by MakeMyTrip, keeps you updated with the live currency exchange rates. You can keep up with the changing value of **1 {currency_name} in India** in real-time on the platform and get the best deal. Currently, 1 {currency_code} is equivalent to `inr_exchange_rate` INR ."},best_ways_to_carry:{title:"Best Ways to Carry the {currency_name}",desc:"TripMoney allows you to convert INR to the {currency_name} at the best exchange rates so that you can carry the {currency_name}s without any hassle. Some of the best ways to carry the {currency_name} are mentioned below:",list:[{title:"Currency Notes",desc:"You can buy the US Dollar notes at live and best exchange rates on TripMoney so that you can be ready for your trip with sufficient cash in your hand."},{title:"TripMoney Global Cash Card With No Forex Mark-Up",desc:"You can opt for a TripMoney Global Cash Card issued by VISA. Savings can be mapped at up to 5% on Bank cards and 5-15% on airport kiosk rates."},{title:"BookMyForex Multi-Currency Card - 0% Forex Mark-Up",desc:"The Multi-Currency Forex Travel Card available on MakeMyTrip with BookMyForex as the co-branding partner comes with 0% forex mark-up over interbank rates."}],tripmoney_logo:{src:"https://tripmoneycmsimgak.mmtcdn.com/img/tripmoney_Img_4f2278b2f9.png",alt:"tripmoney image",width:228,height:48}},how_to_buy:{title:"How to Buy the {currency_name} at Best Rates - Currency Notes and Cards",common:"STEP",list:["Select your city from the drop-down list.","Select your city from the drop-down list.","Opt for a forex card or currency notes from the list.","Mention the forex amount. The live currency exchange rate will show up next to it.","The **converted currency** amount according to the exchange rate will show up automatically.","Then proceed with booking your order."]},documents_required:{title:"Documents Required to Buy or Sell the {currency_name}",desc:"Here are some important documents mandated by the RBI that you must submit in order to buy or sell the **{currency_name} in India**.",list:["Copies of your valid Indian passport","PAN Card","Confirmed air ticket indicating your plan to travel within 60 days","Valid visa (it may not be required for every country)"]},purposes_for_exchanging:{title:"Different Purposes for Exchanging the {currency_name}",list:["**Private Travel:** You can avail of up to {currency_code} 10,000 for a private trip to the {travel_country}.","**Studying Abroad:** You can purchase foreign exchange of up to {currency_code} 30,000 or up to the estimate shared by your educational institute.","**Employment Purpose:** In case you have a letter of employment, you can buy foreign exchange of up to {currency_code} 5,000.","**Emigration:** If you have an emigration visa, you can buy foreign exchange for up to {currency_code} 5,000.","**Gift and Donation:** You can gift or donate up to {currency_code} 5,000 annually on the basis of self-certification","**Medical Treatment:** On the basis of self-certification, you can buy foreign exchange of up to {currency_code} 50,000 for medical treatments outside of India. Once the limit is surpassed, you have to provide the estimated expense that would be incurred at the hospital."]},buy_sell_online:{title:"Buy and Sell the {currency_name} Online at Best Exchange Rates",desc:"With TripMoney, the online forex marketplace by MakeMyTrip, you can easily convert your currency. Enjoy unbeatable currency exchange rates and opt for TripMoney Global Cash Cards with no forex mark-up. Alternatively, you can also get BookMyForex Multi-Currency Cards as well as foreign currency notes. MakeMyTrip also present the real-time value of one **{currency_name}** in Indian Rupees so that you can stay updated with the ever-changing **{currency_name}** value when converting your money to other currencies."},home_delivery:{title:"Home Delivery of the {currency_name}",desc:"In addition to a smooth online process, TripMoney also delivers the **{currency_name}s** right at your doorstep. In fact, you can enjoy same-day door delivery. So, you do not have to waste any time visiting a local money exchanger and picking up your money."}}},{id:2,internalName:"seo_currency_default_header",type:"seo_currency_default_header",data:{image_link:"//www.{header_image_host}.com"}},{id:3,internalName:"seo_currency_default_footer",type:"seo_currency_default_footer",data:{section_footer:[{title:"Top Reviewed Currencies",list:[{key:"US Dollar",url:"/tripmoney/currency/us-dollar"},{key:"Euro",url:"/tripmoney/currency/euro"},{key:"UAE Dirham",url:"/tripmoney/currency/uae-dirham"},{key:"Canadian Dollar",url:"/tripmoney/currency/canadian-dollar"},{key:"Pound",url:"/tripmoney/currency/pound"},{key:"Saudi Riyal",url:"/tripmoney/currency/saudi-arabian-riyal"},{key:"Australian Dollar",url:"/tripmoney/currency/australian-dollar"},{key:"Bahraini Dinar",url:"/tripmoney/currency/bahraini-dinar"},{key:"Singapore Dollar",url:"/tripmoney/currency/singapore-dollar"},{key:"Omani Rial",url:"/tripmoney/currency/omani-rial"}]}],bottom_footer:[{title:"Product Offering",list:[{key:"Flights",url:"https://www.makemytrip.com/flights/"},{key:"Flight+Hotel Deals",url:"https://www.makemytrip.com/flights-hotels"},{key:"International Flights",url:"https://www.makemytrip.com/international-flights/"},{key:"Hotels",url:"https://www.makemytrip.com/hotels/"},{key:"International Hotels",url:"https://www.makemytrip.com/hotels-international"},{key:"Holidays in India",url:"https://www.makemytrip.com/holidays-india"},{key:"International Holidays",url:"https://www.makemytrip.com/holidays-international"},{key:"Bus",url:"https://www.makemytrip.com/bus-tickets/"},{key:"Rail",url:"https://www.makemytrip.com/railways/"},{key:"Cab Booking",url:"https://www.makemytrip.com/cabs/"},{key:"Airlines",url:"https://www.makemytrip.com/flights/airlines.html"},{key:"Cheap Flights",url:"https://www.makemytrip.com/flights/cheap.html"},{key:"Flight Status",url:"https://www.makemytrip.com/flights/flight-status.html"},{key:"Flight Cancellation",url:"https://www.makemytrip.com/flights/flight_cancellation.html"},{key:"MICE",url:"http://www.makemytrip.com/offsites/mice.html"},{key:"B2B",url:"http://b2b.makemytrip.com/makemytrip/AffiliateLoginHome.do"},{key:"Cheap Flight Bookings",url:"https://play.google.com/store/apps/details?id=com.makemytrip&hl=en_IN&gl=ae "},{key:"MakeMyTrip UAE",url:"https://apps.apple.com/ae/app/makemytrip-travel-booking-app/id530488359 "}]},{title:"MakeMyTrip",list:[{key:"About Us",url:"https://www.makemytrip.com/about-us/company_profile.php"},{key:"Investor Relations",url:"http://investors.makemytrip.com"},{key:"Testimonial",url:"https://www.makemytrip.com/about-us/testimonials.html"},{key:"Careers",url:"https://www.makemytrip.com/about-us/jobs.php"},{key:"Social Responsibility",url:"https://www.makemytrip.com/about-us/social_resp.php"},{key:"Travel Community",url:"http://www.oktatabyebye.com/"},{key:"Corporate Travel",url:"https://www.makemytrip.com/offsites/corporatetravel.html"},{key:"Travel Guide",url:"https://www.makemytrip.com/travel-guide/"},{key:"Promotions",url:"http://www.makemytrip.com/blog/"},{key:"Explore India",url:"http://explore.makemytrip.com"},{key:"Udan Yojana Flights",url:"https://makemytrip.com/flights/udan-yojana-flight.html"},{key:"Flight Offers",url:"https://www.makemytrip.com/coupons/flights.html"},{key:"MakeMyTrip Coupons",url:"https://www.makemytrip.com/coupons/"}]},{title:"About the Site",list:[{key:"FAQs",url:"http://makemytrip.custhelp.com/"},{key:"Site Map",url:"https://www.makemytrip.com/support/sitemap.html"},{key:"Complaints",url:"https://support.makemytrip.com/customer_complaint/new_complaint.aspx?pcode=Footer"},{key:"Contact Us",url:"https://www.makemytrip.com/support/contact_us.html"},{key:"Payment Security",url:"https://www.makemytrip.com/legal/payment_security.html"},{key:"Privacy Policy",url:"https://www.makemytrip.com/legal/privacy_policy.html"},{key:"User Agreement",url:"https://www.makemytrip.com/legal/user_agreement.html"},{key:"Visa Information",url:"https://www.makemytrip.com/holidays-international/visa-information.html"},{key:"Flight Cancellation",url:"https://www.makemytrip.com/flights/flight_cancellation.html"},{key:"Branch Offices",url:"https://www.makemytrip.com/support/branch-offices.php"}]}]}},{id:4,internalName:"country_flags",type:"country_flags",data:{default:{alt:"{country_name} Flag"},common:{width:43,height:43},AD:{name:"Andorra",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ad_ee7ad21ccc.svg"},AE:{name:"United Arab Emirates",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ae_f00b2b3821.svg"},AF:{name:"Afghanistan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/af_65f35b67e6.svg"},AG:{name:"Antigua and Barbuda",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ag_450e12ec7d.svg"},AI:{name:"Anguilla",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ai_32b586c5d9.svg"},AL:{name:"Albania",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/al_efd1cbc0cf.svg"},AM:{name:"Armenia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/am_15cbae413a.svg"},AO:{name:"Angola",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ao_9a43a6bf98.svg"},AQ:{name:"Antarctica",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/aq_fd9751cdf5.svg"},AR:{name:"Argentina",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ar_706cd7342f.svg"},AS:{name:"American Samoa",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/as_aac4597df8.svg"},AT:{name:"Austria",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/at_96cc217bd8.svg"},AU:{name:"Australia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/au_7474aabf80.svg"},AW:{name:"Aruba",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/aw_ca8d081fe1.svg"},AX:{name:"Åland Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ax_f4cd25e58e.svg"},AZ:{name:"Azerbaijan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/az_0e3c127cd1.svg"},BA:{name:"Bosnia and Herzegovina",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ba_e1998bdb13.svg"},BB:{name:"Barbados",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bb_a02354692c.svg"},BD:{name:"Bangladesh",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bd_80b416760b.svg"},BE:{name:"Belgium",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/be_94a5e50a91.svg"},BF:{name:"Burkina Faso",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bf_4acadb2297.svg"},BG:{name:"Bulgaria",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bg_79ac5b390d.svg"},BH:{name:"Bahrain",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bh_8c2b019d76.svg"},BI:{name:"Burundi",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bi_d8b29d3aa1.svg"},BJ:{name:"Benin",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bj_e6e008dfd4.svg"},BL:{name:"Saint Barthélemy",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bl_aba350a1ac.svg"},BM:{name:"Bermuda",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bm_458200c646.svg"},BN:{name:"Brunei Darussalam",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bn_92143678e9.svg"},BO:{name:"Bolivia (Plurinational State of)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bo_0e60075fbc.svg"},BQ:{name:"Bonaire, Sint Eustatius and Saba",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bq_b2f727f71f.svg"},BR:{name:"Brazil",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/br_1fe146de4e.svg"},BS:{name:"Bahamas",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bs_bc1577c877.svg"},BT:{name:"Bhutan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bt_ba21028115.svg"},BV:{name:"Bouvet Island",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bv_7a89b5c113.svg"},BW:{name:"Botswana",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bw_7272b3d014.svg"},BY:{name:"Belarus",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/by_918d226010.svg"},BZ:{name:"Belize",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/bz_0e195f14bd.svg"},CA:{name:"Canada",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ca_7c2a04bb45.svg"},CC:{name:"Cocos (Keeling) Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cc_731c7e23b7.svg"},CD:{name:"Congo, the Democratic Republic of the",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cd_7b8e417a4f.svg"},CF:{name:"Central African Republic",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cf_fecb8f9c8b.svg"},CG:{name:"Congo",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cg_c853f729b6.svg"},CH:{name:"Switzerland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ch_459b3eed4c.svg"},CI:{name:"Côte d'Ivoire",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ci_8ee96372c9.svg"},CK:{name:"Cook Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ck_fc224db93c.svg"},CL:{name:"Chile",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cl_e9e9a97ad9.svg"},CM:{name:"Cameroon",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cm_a3907a170a.svg"},CN:{name:"China",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cn_33b59784bb.svg"},CO:{name:"Colombia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/co_152ac395e7.svg"},CR:{name:"Costa Rica",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cr_57627495fc.svg"},CU:{name:"Cuba",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cu_e332c87a81.svg"},CV:{name:"Cabo Verde",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cv_13ae8f4d67.svg"},CW:{name:"Curaçao",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cw_0fdd42aed3.svg"},CX:{name:"Christmas Island",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cx_344ee795ff.svg"},CY:{name:"Cyprus",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cy_afb08885c9.svg"},CZ:{name:"Czechia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/cz_7035ec1bd9.svg"},DE:{name:"Germany",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/de_5fb2a7c256.svg"},DJ:{name:"Djibouti",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/dj_676213b03b.svg"},DK:{name:"Denmark",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/dk_487217c50c.svg"},DM:{name:"Dominica",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/dm_fe586a0f63.svg"},DO:{name:"Dominican Republic",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/do_46e1422e61.svg"},DZ:{name:"Algeria",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/dz_80cc45045a.svg"},EC:{name:"Ecuador",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ec_67f5dbde8d.svg"},EE:{name:"Estonia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ee_1826a08425.svg"},EG:{name:"Egypt",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/eg_6d5ac443d6.svg"},EH:{name:"Western Sahara",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/eh_c03f70605c.svg"},ER:{name:"Eritrea",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/er_dc80e9841d.svg"},ES:{name:"Spain",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/es_0db5cb4322.svg"},ET:{name:"Ethiopia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/et_dbab9acf6b.svg"},EU:{name:"European Union",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/eu_3fbca58d5b.svg"},FI:{name:"Finland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/fi_9b37346e32.svg"},FJ:{name:"Fiji",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/fj_08aaf54283.svg"},FK:{name:"Falkland Islands (Malvinas)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/fk_12d2044901.svg"},FM:{name:"Micronesia (Federated States of)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/fm_1ec8cafdf5.svg"},FO:{name:"Faroe Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/fo_f61d135882.svg"},FR:{name:"France",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/fr_0663283b13.svg"},GA:{name:"Gabon",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ga_530720306d.svg"},GB:{name:"United Kingdom of Great Britain and Northern Ireland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gb_c8e421182a.svg"},"GB-ENG":{name:"England",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gb_eng_50e335b171.svg"},"GB-NIR":{name:"Northern Ireland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gb_nir_bfdf735ba7.svg"},"GB-SCT":{name:"Scotland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gb_sct_79ea5325d8.svg"},"GB-WLS":{name:"Wales",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gb_wls_e60e161bd4.svg"},GD:{name:"Grenada",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gd_d1d3c1c6b9.svg"},GE:{name:"Georgia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ge_7b4c229160.svg"},GF:{name:"French Guiana",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gf_3e60518c3d.svg"},GG:{name:"Guernsey",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gg_358f910197.svg"},GH:{name:"Ghana",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gh_40ee8faf3c.svg"},GI:{name:"Gibraltar",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gi_05aa9d68dc.svg"},GL:{name:"Greenland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gl_026cda8383.svg"},GM:{name:"Gambia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gm_ea3eab33b2.svg"},GN:{name:"Guinea",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gn_7c0f219f21.svg"},GP:{name:"Guadeloupe",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gp_60d79be444.svg"},GQ:{name:"Equatorial Guinea",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gq_08155b266d.svg"},GR:{name:"Greece",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gr_dfe4ee6fc9.svg"},GS:{name:"South Georgia and the South Sandwich Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gs_b7d9082616.svg"},GT:{name:"Guatemala",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gt_18d9ec63d3.svg"},GU:{name:"Guam",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gu_628a9b336f.svg"},GW:{name:"Guinea-Bissau",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gw_bb218e6b17.svg"},GY:{name:"Guyana",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/gy_e71eefe6a6.svg"},HK:{name:"Hong Kong",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/hk_4195f6a637.svg"},HM:{name:"Heard Island and McDonald Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/hm_53c993556c.svg"},HN:{name:"Honduras",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/hn_9c31f7da0b.svg"},HR:{name:"Croatia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/hr_bda4a07bfc.svg"},HT:{name:"Haiti",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ht_db13a25aa3.svg"},HU:{name:"Hungary",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/hu_0dc1f03d76.svg"},ID:{name:"Indonesia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/id_2de6fc17db.svg"},IE:{name:"Ireland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ie_df16b1d6b1.svg"},IL:{name:"Israel",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/il_6f3aab6780.svg"},IM:{name:"Isle of Man",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/im_9b579950d5.svg"},IN:{name:"India",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/in_2f348ca223.svg"},IO:{name:"British Indian Ocean Territory",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/io_c624bb6f61.svg"},IQ:{name:"Iraq",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/iq_75dffc9293.svg"},IR:{name:"Iran (Islamic Republic of)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ir_f2d77d064a.svg"},IS:{name:"Iceland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/is_982f90ac4c.svg"},IT:{name:"Italy",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/it_9dec37662a.svg"},JE:{name:"Jersey",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/je_65fd297923.svg"},JM:{name:"Jamaica",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/jm_47f97932d4.svg"},JO:{name:"Jordan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/jo_ab7eab6a9b.svg"},JP:{name:"Japan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/jp_0ca60607df.svg"},KE:{name:"Kenya",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ke_fe19dcfb3f.svg"},KG:{name:"Kyrgyzstan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/kg_63f5ce41ff.svg"},KH:{name:"Cambodia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/kh_22d6e77ab8.svg"},KI:{name:"Kiribati",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ki_72b5dad29f.svg"},KM:{name:"Comoros",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/km_ccccd27093.svg"},KN:{name:"Saint Kitts and Nevis",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/kn_add6ab96ee.svg"},KP:{name:"Korea (Democratic People's Republic of)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/kp_56eb4d2b2f.svg"},KR:{name:"Korea, Republic of",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/kr_629c402040.svg"},KW:{name:"Kuwait",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/kw_d618a241d6.svg"},KY:{name:"Cayman Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ky_284d914a38.svg"},KZ:{name:"Kazakhstan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/kz_7ca26a1797.svg"},LA:{name:"Lao People's Democratic Republic",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/la_94932d558c.svg"},LB:{name:"Lebanon",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/lb_5b989a3874.svg"},LC:{name:"Saint Lucia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/lc_f17ac78364.svg"},LI:{name:"Liechtenstein",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/li_6cfab8e596.svg"},LK:{name:"Sri Lanka",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/lk_bd4f014503.svg"},LR:{name:"Liberia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/lr_1b7facc87c.svg"},LS:{name:"Lesotho",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ls_20424a3147.svg"},LT:{name:"Lithuania",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/lt_760e0db821.svg"},LU:{name:"Luxembourg",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/lu_3430d312e6.svg"},LV:{name:"Latvia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/lv_72f2ef9654.svg"},LY:{name:"Libya",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ly_c73dbbe19a.svg"},MA:{name:"Morocco",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ma_f4e0c85e21.svg"},MC:{name:"Monaco",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mc_947ce3c758.svg"},MD:{name:"Moldova, Republic of",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/md_43399ff3b7.svg"},ME:{name:"Montenegro",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/me_b706d7ae7a.svg"},MF:{name:"Saint Martin (French part)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mf_93af7cb897.svg"},MG:{name:"Madagascar",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mg_25b9f79094.svg"},MH:{name:"Marshall Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mh_b697ee26c9.svg"},MK:{name:"North Macedonia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mk_3b0db18547.svg"},ML:{name:"Mali",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ml_102d51da19.svg"},MM:{name:"Myanmar",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mm_dabd0c76c1.svg"},MN:{name:"Mongolia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mn_76b62fbb32.svg"},MO:{name:"Macao",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mo_ce442c9a20.svg"},MP:{name:"Northern Mariana Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mp_76f9cc05ed.svg"},MQ:{name:"Martinique",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mq_db3457b144.svg"},MR:{name:"Mauritania",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mr_bc2eaad7b5.svg"},MS:{name:"Montserrat",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ms_9010c2d84e.svg"},MT:{name:"Malta",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mt_1b7ef26bca.svg"},MU:{name:"Mauritius",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mu_522c39a86d.svg"},MV:{name:"Maldives",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mv_d37ac91ee5.svg"},MW:{name:"Malawi",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mw_1d5c9a75a5.svg"},MX:{name:"Mexico",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mx_efd4edb50f.svg"},MY:{name:"Malaysia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/my_01642481af.svg"},MZ:{name:"Mozambique",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/mz_1c967de0df.svg"},NA:{name:"Namibia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/na_f6a916f1a0.svg"},NC:{name:"New Caledonia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/nc_bd4f7782e4.svg"},NE:{name:"Niger",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ne_03e4003d07.svg"},NF:{name:"Norfolk Island",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/nf_751a7607f2.svg"},NG:{name:"Nigeria",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ng_f7ba0fee41.svg"},NI:{name:"Nicaragua",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ni_36da7af5f5.svg"},NL:{name:"Netherlands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/nl_94d823f692.svg"},NO:{name:"Norway",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/no_09622db0f8.svg"},NP:{name:"Nepal",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/np_68159406f1.svg"},NR:{name:"Nauru",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/nr_cedbc24937.svg"},NU:{name:"Niue",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/nu_1158e9e356.svg"},NZ:{name:"New Zealand",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/nz_3b7d223d93.svg"},OM:{name:"Oman",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/om_40d63e31e0.svg"},PA:{name:"Panama",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pa_d03161a3fb.svg"},PE:{name:"Peru",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pe_304060789b.svg"},PF:{name:"French Polynesia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pf_33544370be.svg"},PG:{name:"Papua New Guinea",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pg_15c9c0849b.svg"},PH:{name:"Philippines",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ph_0c6517658e.svg"},PK:{name:"Pakistan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pk_243f9b996c.svg"},PL:{name:"Poland",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pl_59003a0441.svg"},PM:{name:"Saint Pierre and Miquelon",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pm_d818181846.svg"},PN:{name:"Pitcairn",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pn_8cda9520f4.svg"},PR:{name:"Puerto Rico",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pr_b5898f74e9.svg"},PS:{name:"Palestine, State of",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ps_a21a219fd7.svg"},PT:{name:"Portugal",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pt_4f355c972d.svg"},PW:{name:"Palau",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/pw_687f71d510.svg"},PY:{name:"Paraguay",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/py_aa5374ee0c.svg"},QA:{name:"Qatar",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/qa_f4b77b4796.svg"},RE:{name:"Réunion",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/re_c545f18901.svg"},RO:{name:"Romania",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ro_96930c11c6.svg"},RS:{name:"Serbia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/rs_abb13a0976.svg"},RU:{name:"Russian Federation",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ru_cb98a2e7cd.svg"},RW:{name:"Rwanda",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/rw_4d811df706.svg"},SA:{name:"Saudi Arabia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sa_86c1673d4c.svg"},SB:{name:"Solomon Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sb_aac5b7df9e.svg"},SC:{name:"Seychelles",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sc_dfe921906f.svg"},SD:{name:"Sudan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sd_273748b57d.svg"},SE:{name:"Sweden",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/se_e95610f345.svg"},SG:{name:"Singapore",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sg_d7e5f5c7a1.svg"},SH:{name:"Saint Helena, Ascension and Tristan da Cunha",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sh_c40f34d68a.svg"},SI:{name:"Slovenia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/si_4738fb6e13.svg"},SJ:{name:"Svalbard and Jan Mayen",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sj_a8dea40936.svg"},SK:{name:"Slovakia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sk_4b012c3a02.svg"},SL:{name:"Sierra Leone",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sl_9cf3f36dde.svg"},SM:{name:"San Marino",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sm_cd9411d1fe.svg"},SN:{name:"Senegal",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sn_0112ea7aad.svg"},SO:{name:"Somalia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/so_f921cd173e.svg"},SR:{name:"Suriname",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sr_9321eba2cd.svg"},SS:{name:"South Sudan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ss_5a3947cdd6.svg"},ST:{name:"Sao Tome and Principe",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/st_ce4addf4f5.svg"},SV:{name:"El Salvador",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sv_9e0c3ca21d.svg"},SX:{name:"Sint Maarten (Dutch part)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sx_74a3417756.svg"},SY:{name:"Syrian Arab Republic",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sy_ade744b21f.svg"},SZ:{name:"Eswatini",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/sz_bacdda09b8.svg"},TC:{name:"Turks and Caicos Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tc_96943da753.svg"},TD:{name:"Chad",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/td_8fc1d12782.svg"},TF:{name:"French Southern Territories",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tf_9f916550e1.svg"},TG:{name:"Togo",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tg_9f8762516f.svg"},TH:{name:"Thailand",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/th_5a7eaa3694.svg"},TJ:{name:"Tajikistan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tj_81b475f0fe.svg"},TK:{name:"Tokelau",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tk_1886606d8e.svg"},TL:{name:"Timor-Leste",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tl_3e2fb59693.svg"},TM:{name:"Turkmenistan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tm_995d608c9b.svg"},TN:{name:"Tunisia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tn_419dee44b6.svg"},TO:{name:"Tonga",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/to_3b57ec3d01.svg"},TR:{name:"Türkiye",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tr_8688d44b48.svg"},TT:{name:"Trinidad and Tobago",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tt_aca657a286.svg"},TV:{name:"Tuvalu",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tv_84f64355d7.svg"},TW:{name:"Taiwan, Province of China",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tw_fbef2f7e67.svg"},TZ:{name:"Tanzania, United Republic of",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/tz_f1d5f7d3e9.svg"},UA:{name:"Ukraine",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ua_9bf9143175.svg"},UG:{name:"Uganda",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ug_f230242c97.svg"},UM:{name:"United States Minor Outlying Islands",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/um_6d8673672b.svg"},US:{name:"United States of America",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/us_54f9a75482.svg"},UY:{name:"Uruguay",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/uy_599b5709fb.svg"},UZ:{name:"Uzbekistan",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/uz_12f12ac802.svg"},VA:{name:"Holy See",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/va_7dfceb4751.svg"},VC:{name:"Saint Vincent and the Grenadines",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/vc_55285c563d.svg"},VE:{name:"Venezuela (Bolivarian Republic of)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ve_86c2cba559.svg"},VG:{name:"Virgin Islands (British)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/vg_500ed1aeb1.svg"},VI:{name:"Virgin Islands (U.S.)",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/vi_d5f6b6fefc.svg"},VN:{name:"Viet Nam",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/vn_0ec5fe6681.svg"},VU:{name:"Vanuatu",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/vu_b1e2ff57ed.svg"},WF:{name:"Wallis and Futuna",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/wf_a9041c6cb9.svg"},WS:{name:"Samoa",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ws_9c343ef1f6.svg"},YE:{name:"Yemen",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/ye_20d7839f98.svg"},YT:{name:"Mayotte",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/yt_ff3676b3df.svg"},ZA:{name:"South Africa",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/za_f6bc68a503.svg"},ZM:{name:"Zambia",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/zm_8c322e0acb.svg"},ZW:{name:"Zimbabwe",url:"/#",src:"https://tripmoneycmsimgak.mmtcdn.com/img/zw_eb8cbe08b8.svg"}}},{id:5,internalName:"seo_currency_page_us-dollar",type:"seo_currency_page_us-dollar",data:{name:"US Dollar",code:"USD",country_code:"US",travel_country:"The United States",keywords:"US Dollar, 1 us dollar in rupees, USD, us dollar to indian rupee, us dollar price, US dollar to rupee, us dollar rate, US DOLLAR CURRENCY, us dollar in india, converted currency, currency rates, USD exchange rates, Buy US dollar, Sell US Dollar, US Dollar rate alert, US Dollar exchange rates, 1 us dollar to inr, indian rupee to us dollar, us dollar in india, us dollar convert to indian rupees, inr to us dollar, one us dollar in indian rupees, convert us dollar to inr, us dollar to ruble, us dollar value, 1 us dollar in india, convert us dollars to rupees, US Dollar Rates in Other Cities",about:{title_text:"The World’s Reserve Currency",desc:"The **US Dollar** is currently the official currency of the United States and various other countries besides being the de facto currency in many parts of the world. In fact, the US Dollar is one of the strongest currencies around the globe and started gaining ground post World War II."},quick_facts:{facts:{Country_of_Origin:"United States of America",Symbol:"$",Currency_Code:"USD",Nick_Names:"Buck (1 USD), C-Note (100 USD)",Minor_units:"Cent","Denominations_(Banknotes)":"1, 2, 5, 10, 20, 50 and 100 dollars",Motto:"In God We Trust",Identification_Feature:"The new 100 Dollar note boasts an image of Independence Hall.",Issuing_Bank:"Bureau of Engraving and Printing (Currency Notes), U.S Mint (Coins)",In_Circulation_Since:"July 6, 1785",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The **U.S Congress** passed the Coinage Act of 1792, authorising the production of the **US Dollar** which was valued at par with the Spanish silver dollar. And the current **US Dollar** that is being used widely by the public was first printed in 1914.\n\n &nbsp; \n\nAs per the Bretton Woods Agreement of 1944, the **US Dollar** was then established as the world’s reserve currency. Under this system while most of the currencies were pegged to the Dollar, the Dollar was pegged to gold."},countries_accepting:{desc_1:"About 65 countries in the world peg their currencies to the **US Dollar**. In fact, the **US Dollar** is easily accepted in most of the countries.",list:["US","SV","EC","VG","PA","TC","ZW","BQ","TL","PW","MH","FM"],desc_2:"Also, there are a few countries that allow you to use the **US Dollar** for transactions instead of the local currency. These countries include Canada, Bahamas, Belize, Bermuda, Barbados, Costa Rica, Burma, Caribbean Netherlands, Cayman Islands, Cambodia,, Haiti, Jamaica, Dominican Republic, Lebanon, Liberia, Laos, The Maldives, Mexico (mostly in tourist areas), Peru, Uruguay, Nicaragua and Vietnam."},amount_for_trip:{desc:"The amount of **US Dollars** you need to carry for your trip depends on the place you are visiting.Moreover, your travel expenditure also depends on how much you are spending on transportation and flight tickets, your accommodation option as well as the food options available in the country you are visiting. \n\n &nbsp; \n\n On an average, it costs about USD 75 per person per day if you are embarking on a budget trip to the US. The cost can go as high as USD 225 per person per day if you choose to travel via private transportation, visit renowned restaurants for meals instead of budget eateries and stay in 3-star or above accommodation options. \n\n &nbsp; \n\n On average, accommodation in the US costs USD 50 to USD 102 per night (single occupancy). Also, transportation may cost USD 15 to USD 36 per day, depending on your choice between public and private transportation options."},identification:{list:["Hold a US Dollar note up to the light and take a look at its bottom-right corner, a real note will have colour-shifting ink.","Keep an eye on the watermark. An authentic watermark will be visible as you would hold the US Dollar note in the light. And it should be on the right side of the bill.","Counterfeit US Dollar notes will not have raised printing, unlike the real ones. Moreover, make sure that there is no blurred printing or texts on the notes which is a dead giveaway of the notes being counterfeits.","Counterfeit US Dollar notes will not have a security thread with microprinting.","Fake US Dollar bills will not have the micro red and blue threads woven deep into the notes."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **US Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **US Dollar to Ruble** or **INR to US dollar**, you only need to follow the below-written steps:"}}},{id:6,internalName:"seo_currency_page_euro",type:"seo_currency_page_euro",data:{name:"Euro",code:"EUR",country_code:"EU",travel_country:"Europe",keywords:"Euro, Euro Currency, euro rate today, euro to rupee, euro to dollar, euro rate, convert euro to INR,euro to INR, euro symbol, exchange rate, currency exchange, Buy, Sell, forex cards Live Euro rate, euro price",about:{title_text:"The Second Most Widely Used Currency",desc:"Euro is the second most actively traded currency and the second most widely used reserve currency in the world. Euro is the official currency of the (EU) European Union. Although the European Union currently has 27 member states, only 19 of those states use the euro. The **Euro symbol** is €.\n\n &nbsp; \n\nDue to Euro's contribution to the simplification of European trade and travel as well as the advancement of EU political integration, the currency enjoys widespread support among the states that make up the EU.\n\n &nbsp; \n\n**The live Euro** rate is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Euro price**."},quick_facts:{facts:{Country_of_Origin:"European Union (EU)",Symbol:"€",Currency_Code:"EUR",Nick_Names:"Fiber or Single Currency",Minor_units:"Cent","Denominations_(Banknotes)":"5, 10, 20, 50, 100, 200 and 500 Euro",Motto:"-",Identification_Feature:'The fresh new five euro note was introduced into circulation on May 2, 2013, signalling the start of the production of the second series of euro banknotes. The series, which has been given the name "Europa" after the Greek princess, features her portrait on each note.',Issuing_Bank:"The national central banks of the Eurosystem or the European Central Bank.",In_Circulation_Since:"January 1, 1999",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The Delors Report recommended a three-year transition phase between 1990 and 1999 to ease people into the new financial system of the Euro and the economic and monetary unity it would bring. The Delors Report was adopted by European leaders.\n\n &nbsp; \n\nAfter a decade of planning, on January 1, 1999, Euro was introduced. For the first three years, it was an ‘invisible’ currency, used primarily in book-keeping and digital transactions. On January 1, 2002, Euro coins and banknotes were first introduced in 12 European Union nations, marking the largest monetary transition in history. It quickly replaced the old national currencies but expanded more slowly than the rest of the EU. The Lisbon Treaty established the Eurogroup as the treaty's political authority in 2009."},countries_accepting:{desc_1:"As of 2015, 19 of the 28 member states of the European Union (EU) had already adopted the **Euro** as their only currency. The Euro Area, or Eurozone, consists of the member states of the European Union.",list:["AT","CY","DE","GR","EE","BE","FI","FR","IE","LV","LT","IT","LU","NL","PT","SK","MT","SI","ES"],desc_2:""},amount_for_trip:{desc:"A few of the factors that go into determining the final cost of a vacation include the mode(s) of transportation taken to get there, the type of accommodation reserved, and the amount of money spent while on vacation.\n\n &nbsp; \n\nYou can check the **Euro rate today** in order to have a cost-efficient vacation. Here is a breakdown of the money you'd need to carry in some of the popular countries of Europe:\n\n &nbsp; \n\n**France**: Everyday budget can range between €64 to €611, depending on if you are embarking on a budget trip or would like a lavish experience in France.The cost per person, per night, at an accommodation would range between €39 to €445. Also, the transportation will cost you about €9 to €60.\n\n &nbsp; \n\n**Germany**: Daily costs in Germany might be as low as €49 or as high as €293, depending on whether you want to travel on a tight budget or splurge throughout your stay. There are also options to choose from in terms of the cost of a hotel room, from €25 to €135 per night, per guest. In addition, you may be expected to pay between €7 to €48 for transportation.\n\n &nbsp; \n\n**Austria**: Depending on your travel style and budget, you could spend as little as €47 or as much as €290 every day in Austria. The cost of a hotel room can vary widely as well, from €25 to €152 per night (per person). In addition, the cost of transportation could range from €7 to €54.\n\n &nbsp; \n\n**Italy**: Daily costs in Italy can range from €52 to €334, based on your travel preferences and level of luxury. As an additional example, the price of a hotel room can range anywhere from €27 to €167 per night. Transportation costs could add another €8 to €55 to the total.\n\n &nbsp; \n\n**Spain**: The average daily budget can be anywhere from €47 to €309, depending on whether you are travelling on a tight budget or would like to have a luxurious experience in Spain. In addition, the cost of accommodation ranges from €21 to €131 per person, per night. In addition, the cost of the transportation will range between €8 and €53."},identification:{list:["Touch the banknote to feel its material. Cotton is used to make an authentic banknote paper; so it will be crisp and firm to the touch.","The ECB initials, the gateway or window, the value number, and the writing are all printed in a raised texture on an authentic banknote paper, creating a tactile sensation.","Microprinting on both sides of the bill must be examined. An authentic note has a very clear microprinting, not blurred.","See if the paper itself glows when exposed to UV light. Paper fibres of various colours—green, blue, and red—appear in the first batch of authentic notes. In the Europa series, each fibre displays three distinct hues.","Examine the bill in direct sunlight. Notes from the Europa series (€20, €50, €100, and €200) have a portrait window, a watermark, a security thread, and a see-through number (although only in the first series)."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Euro**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Euro to Dollar** or **INR to Euro**, you only need to follow the below-written steps:"}}},{id:7,internalName:"seo_currency_page_uae-dirham",type:"seo_currency_page_uae-dirham",data:{name:"UAE Dirham",code:"AED",country_code:"AE",travel_country:"UAE",keywords:"dirham, UAE Dirham, dirham Currency, UAE dirham to INR, UAE dirham rate, UAE dirham to Indian rupee, dirham rate today, dirham to INR,exchange rate, currency exchange, Buy, Sell, forex cards, Live dirham rate, dirham price",about:{title_text:"The Currency of United Arab Emirates",desc:'The Central Bank of the United Arab Emirates has released a number of commemorative coins honouring various events and UAE presidents since 1976. The Greek word drachmae, meaning "handful," is where the term ‘dirham’ is derived from. The dirham survived the Ottoman Empire because of its long history of trade and use.\n\n &nbsp; \n\nThe **live Dirham rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Dirham price**.'},quick_facts:{facts:{Country_of_Origin:"United Arab Emirates (UAE)",Symbol:"د.إ",Currency_Code:"AED",Nick_Names:"-",Minor_units:"Fils","Denominations_(Banknotes)":"5, 10, 20, 50, 100, 200, and 500 AED",Motto:"In Tansourou Allaha Yansouroukoum (If you glorify God, He will glorify you)",Identification_Feature:"There are a great number of coins struck specifically to honour the rulers of the United Arab Emirates and to commemorate special occasions and their images are featured on these coins.",Issuing_Bank:"Central Bank of the United Arab Emirates",In_Circulation_Since:"March 19, 1973",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"From 19th of May, 1973, this currency came into circulation, having replaced the Qatari riyal.\n\n &nbsp; \n\nOn May 20, 1973, the UAE Currency Board issued the first banknotes in the denominations of 1 dirham, 5 dirhams, 10 dirhams, and 100 dirhams.\n\n &nbsp; \n\nOn January 3, 1976, a banknote in the denomination of 1,000 dirhams was introduced. In 1982, a new series of notes was issued, but it did not include the Dirham 1 note or the Dirham 1,000 note. The bills looked very much like current bills. In 1983, 500-dirham bills entered circulation, and in 1989, their smaller-denomination counterparts appeared. In the year 2000, the circulation of 1000 dirham banknotes resumed.\n\n &nbsp; \n\nIn 1973, the first coins were produced, and their values were 1, 5, 10, 25, and 50 fils, in addition to 1 dirham. The 1 fils note and the 5 fils note are both struck with bronze, while the higher denomination notes are struck with cupro-nickel. The weight of the coins of the fils denomination, as well as the percentage of metal they contained, were the same as their counterparts in Qatar and Dubai. The size of the coins worth 5, 10, and 50 fils was reduced in 1995, and the shape of the coin worth 50 fils was altered to be in the shape of a curve-equilateral-heptagon.\n\n &nbsp; \n\nThe inscriptions on the coins are written in Arabic, while the values are represented by numerals based on Eastern Arabic script. Since 1976, the Currency Board of the United Arab Emirates has issued a number of commemorative coins honouring a variety of UAE landmarks and dynasties. These coins have been produced in limited quantities."},countries_accepting:{desc_1:"The **UAE Dirham** is the legal tender in the United Arab Emirates and is used as the sole currency for all kinds of transactions here.",list:[],desc_2:""},amount_for_trip:{desc:"In an effort to combat money laundering, the Central Bank of the UAE has set the amount of undeclared money to be brought into or out of the country at AED 100,000.\n\n &nbsp; \n\nTravellers arriving in the UAE are needed to declare cash or other monetary instruments including travellers' cheques carried along in an amount exceeding AED 100,000 or its equivalent in other foreign currencies.\n\n &nbsp; \n\nDepending on various factors such as accommodation options and transportation, a tourist may have to spend anywhere between AED 300 to AED 2,000 per person per day. On the other hand, the cost for two tourists will be somewhere around AED 800 to AED 5,000.\n\n &nbsp; \n\nIf you are on a budget trip, then the accommodation will cost you around AED 200 per person, but if you would like to stay in a lavish accommodation option, then it can stretch up to AED 2,500 per person per day. Depending on whether you’d like to hire a taxi or ride a bus, the cost of your everyday transportation will be around AED 30 to AED 150 per day.\n\n &nbsp; \n\nYou can check the **Dirham rate today** in order to plan a cost-effective vacation."},identification:{list:["Each denomination's face value should showcase brilliant red, gold, and green colour when examined with ultraviolet light.","There can also be a metallic thread across the note that you want to inspect in order to check the note’s authenticity. There is a good possibility that this thread is real if it appears as a single, continuous dark line.","One warning sign of a counterfeit dirham is if the bill is completely flat with no raised areas."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **UAE Dirham**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **UAE Dirham to USD** or ** INR to UAE Dirham**, you only need to follow the below-written steps:"}}},{id:8,internalName:"seo_currency_page_canadian-dollar",type:"seo_currency_page_canadian-dollar",data:{name:"Canadian Dollar",code:"CAD",country_code:"CA",travel_country:"Canada",keywords:"Canadian Dollar,  Canadian dollar rate, Canadian dollar rate today, Canadian dollar price, Canadian dollar to rupee, Canadian dollar to INR, exchange rate, currency exchange, Buy, Sell, forex cards, Live Canadian dollar rate, Canadian dollar price",about:{title_text:"The Fifth-Most Held Reserve Currency",desc:'The Canadian dollar is the only money that can be used in Canada. It is commonly abbreviated using the dollar sign ($). The letter CAD is used to indicate the value of one Canadian dollar, which is also colloquially referred to as a "loonie." There are a total of 100 pennies in 1 CAD. Because of its widespread acceptance as a benchmark currency, many national central banks throughout the world keep Canadian dollars in their reserves along with their own currencies. This is due to the fact that the Canadian dollar is widely regarded as one of the most stable currencies in the world.\n\n &nbsp; \n\nThe **live Canadian Dollar rate** is INR (`inr_exchange_rate`) . You can keep an eye on real-time **Canadian dollar price**.'},quick_facts:{facts:{Country_of_Origin:"Canada (CAN)",Symbol:"$, CA$, Can$, C$",Currency_Code:"CAD",Nick_Names:"The loonie",Minor_units:"Cent","Denominations_(Banknotes)":"1, 2, 5, 10, 20, 50, 100, 200, 500 and 1000  CAD",Motto:"A Mari Usque Ad Mare (from Sea to Sea)",Identification_Feature:"On the reverse of each bill is a picture of a Canadian bird set against a landscape that is meant to evoke the natural habitat of that bird.",Issuing_Bank:"Bank of Canada",In_Circulation_Since:"March 11, 1935",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The **Canadian Dollar** (CAD) is the country's legal tender; it was first introduced in 1858. In addition to the more common $, the Canadian dollar is also occasionally represented by CA$, Can$, and C$ to differentiate it from other dollar-denominated currencies.\n\n &nbsp; \n\nIn January 1858, the Canadian province announced that all financial transactions would be conducted in dollars and issued the first official Canadian Dollar. A gradual transition to the decimal system occurred over the subsequent years throughout the colonies that would eventually become a part of the Canadian Confederation.\n\n &nbsp; \n\nIn 1871, the federal government of Canada passed the Uniform Currency Act, which resulted in the creation of a single national currency known as the **Canadian dollar**. The value of the Canadian dollar has been allowed to freely fluctuate against that of other currencies ever since it was first authorised to do so in the year 1950.\n\n &nbsp; \n\nThe year 2012 saw the end of the production of Canadian pennies, and the year 2013 saw the distribution of the last last ones. In spite of this, the coin can still be used as legal tender. Because it is no longer in circulation, companies are required to round up payments made by customers in cash to the next five cents."},countries_accepting:{desc_1:"After the US Dollar, the Euro, the British Pound, and the Japanese yen, the **Canadian Dollar** is the world's fifth most-held reserve currency.The **Canadian Dollar** is the sixth most traded currency in the world due to the country's extensive exports of raw materials and abundant natural resources. The **Canadian Dollar** is used as the official currency in Canada.",list:[],desc_2:""},amount_for_trip:{desc:"A few of the factors that go into determining the final cost of a vacation include the location of the excursion, the mode(s) of transportation taken to get there, the type of lodging reserved, and the amount of money spent while on vacation. A visitor in Canada might very well spend about CA$150 per person per day on a day's worth of activities and entertainment if they choose to do so. It is likely that you will need a daily budget that is greater than CA$500 per person per day in order to cover the costs connected with private transportation, gourmet eating, and staying in hotels with a rating of five stars or more. When going to Canada, the price of a vacation for two can easily exceed CA$1,200.\n\n &nbsp; \n\nThe cost of a night's stay in a hotel in Canada can range anywhere from CA$40 to CA$300 per person per day. Your daily transportation costs could run anywhere from CA$10 to CA$70 per day, depending on if you walk, take the bus, or hail a cab.\n\n &nbsp; \n\nKeep a tab on the **Canadian Dollar rate today** for enjoying a cost-effective holiday."},identification:{list:['The raised ink on the real note should be palpable if you run your fingernail across it. Money that has no bumps or ridges on it is more likely to be fake. The words "BANQUE DU CANADA" and "BANK OF CANADA" are raised and printed in ink both above and below the translucent strip that is located on the right-hand side of the document.',"A transparent strip on which the holographic strip is printed, has been added to a more recent series of Canadian banknotes.","Below the lettering that reads “CANADA” on the authentic note which is partially see-through, are a series of very little digits."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Canadian Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Canadian Dollar to USD** or **INR to Canadian Dollar**, you only need to follow the below-written steps:"}}},{id:9,internalName:"seo_currency_page_pound",type:"seo_currency_page_pound",data:{name:"Pound",code:"GBP",country_code:"GB",travel_country:"Great Britain",meta_description:"Get the latest exchange rate for the Pound Sterling (GBP) and learn about the GBP currency, its history, and use in international transactions.",keywords:"pound, pound currency, pound rate, pound rate today, pound rate today in India, UK pound rate,pound to INR, pound to Euro, pound to pound,exchange rate, currency exchange, Buy, Sell, forex cards, Live pound rate, British pound",about:{title_text:"The Currency of the Great Britain",desc:'The United Kingdom and nine of its dependent territories all use the British pound sterling, which is abbreviated as GBP,  as their official currency. The pound is the most common denomination in sterling, and the word "pound" is also used to refer to the British currency in general, but the term "pound" is usually qualified as "the British pound currency" or "the pound sterling" when used outside of the United Kingdom. The Euro and the US dollar are the most common trading partners for the British pound.\n\n &nbsp; \n\nThe **live Pound rate** is INR (`inr_exchange_rate`) . You can keep an eye on the pound **rate today**.'},quick_facts:{facts:{Country_of_Origin:"Great Britain",Symbol:"£",Currency_Code:"GBP",Nick_Names:"Sterling or quid",Minor_units:"penny","Denominations_(Banknotes)":"5, 10, 20 and 50 pounds",Motto:"ELIZABETH II D G REG (Dei Gratia Regina) F D (Fidei defensor)",Identification_Feature:"There are currently banknotes issued by the Bank of England in the Series G format with denominations of £5, £10, £20, and £50 in circulation. On the front of each of these bills is a portrait of Queen Elizabeth II, which was introduced onto banknotes for the very first time in the year 1990.",Issuing_Bank:"Bank of England (Currency Notes), Royal Mint (Coins)",In_Circulation_Since:"1694",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"When the Bank of England was first established in 1694, handwritten pound notes began to circulate. Until the decimal system was adopted in 1971, the pound was used successfully with its intricate system of pennies and shillings.\n\n &nbsp; \n\nIn 1660, the production of coins was automated, and features like side writing were adopted to aid prevent clipping. In spite of the widespread adoption of the euro as a single currency throughout Europe, the **pound sterling (GBP)** maintains its separate existence as of the present day.\n\n &nbsp; \n\nThe United Kingdom decided not to adopt the euro after it had become the common currency of the European Union member states in 2002. The United Kingdom, however, has stuck with the **pound sterling** as its official currency."},countries_accepting:{desc_1:"After the US dollar, the EUR, and the JPY, it is the fourth most traded currency in the world. The Sterling Pound, formerly known as Sterling Silver, was introduced in 1158 under the reign of King Henry II. Here is a list of the countries where the British Pound is used as the official currency:",list:["GB","IM","GS","GI","IO"],desc_2:""},amount_for_trip:{desc:"The entire cost of your vacation to Britain will be determined by a number of aspects, including how you intend to get around the country, where you will be staying, and the number of times you anticipate eating in restaurants. A visitor should prepare to spend approximately £47 per person per day while they are there. A luxury vacation might easily cost more than £350 per person per day if you spend money on things like private transportation, meals at restaurants with Michelin stars, and five-star hotels, all of which are examples of luxury dining and lodging options. However, if you and your significant other are considering taking a trip, you should be aware that the entire price could range anywhere from £150 to £700 depending on the specifics of the trip.\n\n &nbsp; \n\nThe price of a night's stay in a hotel room in Britain can range anywhere from £25 to £200 per person per day. This much, on average, is how much it comes out to. Your daily transportation expenses could range anywhere from £10 to £60 per day or possibly be higher, depending on whether you choose to walk, ride the bus, or call a cab to go around town.\n\n &nbsp; \n\nCheck out the **pound rate today in India** for starting to plan a vacation in Britain."},identification:{list:["Make sure the £5 and £10 notes have gold foil, while the £20 and £50 notes have gold and blue foil, and the £50 note has gold and green foil. All of the authentic banknotes' backs are covered with silver foil.",'Polymer, a thin and flexible plastic, is what the real note is printed on. The words "Bank of England" and the area around the number in the lower right corner of the face of the note are printed in raised print.',"The number of an authentic note glows brilliant red and green under UV light while the backdrop glows a duller colour.","No smudges or blurring should occur to the printed lines or colours on the real note.","Examining the real note with a magnifying lens reveals the face value, which is inscribed in tiny characters and numbers beneath the picture of the Queen."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Pound**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Pound to Euro, Pound to Pound** or **INR to Pound**, you only need to follow the below-written steps:"}}},{id:10,internalName:"seo_currency_page_saudi-arabian-riyal",type:"seo_currency_page_saudi-arabian-riyal",data:{name:"Saudi Riyal",code:"SAR",country_code:"SA",travel_country:"Saudi Arabia",keywords:"Saudi riyal, riyal, riyal currency, Saudi riyal rate, riyal rate, riyal to INR, Saudi riyal to INR, Qatar riyal, Omani riyal rate, exchange rate, currency exchange, Buy, Sell, forex cards, Live Saudi riyal",about:{title_text:"The Currency of Saudi Arabia",desc:"In Saudi Arabia, the Riyal is the country's standard unit of currency. They have abbreviated this term as SR for the sake of convenience. In fact, 1 riyal is equivalent to one 100 halalas. The exchange rate of this currency for the United States dollar is unmovable and unchangeable. Since 1986, the value of one Saudi riyal (SAR) has been pegged at a rate of 3.75 Saudi riyals to one dollar (USD). When it comes to printing and regulating the Saudi Riyal, the Saudi Arabian Monetary Authority (SAMA) is the oldest in the Arab world. \n\n &nbsp; \n\nThe current **Live Saudi riyal** rate is INR (`inr_exchange_rate`) . You can also check out **Qatar riyal** and **Omani riyal rates**."},quick_facts:{facts:{Country_of_Origin:"Saudi Arabia",Symbol:"ر.س (Arabic)",Currency_Code:"SAR",Nick_Names:"None",Minor_units:"Halala","Denominations_(Banknotes)":"1, 5, 10, 20, 50, 100, 200 and 500 riyals",Motto:"Lā ʾilāha illā l-Lāh; Muḥammadu r-rasūlu l-Lāh",Identification_Feature:"On the front of these banknotes, made of paper, there are depictions of well-known landmarks and public buildings; and on the back, the official emblem of the nation is shown.",Issuing_Bank:"Saudi Central Bank",In_Circulation_Since:"June 15, 1961",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The Saudi Arabian Monetary Agency was set up in 1952, however it was forbidden at the time to issue physical currency. Officials at SAMA sidestepped this rule in 1953 by producing Haj Pilgrim Receipts. Initiated for the exclusive use of pilgrims, these receipts eventually replaced silver coinage in transactions across Saudi Arabia.\n\n &nbsp; \n\nOn June 15, 1961, the first standard banknotes were issued in denominations of 1, 5, 10, 50, and 100 riyals. The front of these paper banknotes depicts well-known landmarks and public buildings, while the back features the country's official insignia.\n\n &nbsp; \n\n Arabia started releasing banknotes with monarchs on them in 1976. Notes from 1976 feature King Faisal, with the exception of the 100 Riyal bill, which features King Abdul Aziz ibn Saud. However, King Fahd is featured on majority of the 1984 banknotes.\n\n &nbsp; \n\nIn the year 2000, in order to mark the 100th anniversary of the establishment of the Kingdom of Saudi Arabia, fresh banknotes in the denominations of 20 and 200 riyals were introduced. These bills featured images of King Abdul Aziz, the founder monarch of the Kingdom of Saudi Arabia.\n\n &nbsp; \n\n The **current rate of Saudi Riyal** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Saudi Riyal** value."},countries_accepting:{desc_1:"Since the country's inception, the Saudi riyal (SAR) has been used as legal tender of Saudi Arabia.",list:[],desc_2:""},amount_for_trip:{desc:"The entire cost of your vacation to Saudi Arabia will be determined in part by a number of factors, including how you intend to commute around the country, where you will be staying, and how frequently you will eat in restaurants. You should plan on spending approximately SAR 200 each day in order to cover your overall living expenses while you are on vacation. If you indulge in things like private transportation, meals at Michelin-starred restaurants, and stays at five-star hotels, you may easily spend more than SAR 1,400 per day on a deluxe holiday. Nevertheless, if you and your significant other are considering taking a trip, you should be aware that the overall cost of the vacation might range anywhere from SAR 500 to SAR 3,000, depending on the specifics of the trip that you choose.\n\n &nbsp; \n\nPrices for a night's stay at a hotel in Saudi Arabia can range anywhere from SAR 100 to SAR 800 per person per day. This much, on average, is how much it amounts to. Your daily transportation costs could range anywhere from SAR 40 to SAR 250 per day or even more, depending on whether you opt to walk, ride the bus, or call a taxi."},identification:{list:["Make sure the £5 and £10 notes have gold foil, while the £20 and £50 notes have gold and blue foil, and the £50 note has gold and green foil. All of the authentic banknotes' backs are covered with silver foil.",'Polymer, a thin and flexible plastic, is what the real note is printed on. The words "Bank of England" and the area around the number in the lower right corner of the face of the note are printed in raised print.',"The number of an authentic note glows brilliant red and green under UV light while the backdrop glows a duller colour.","No smudges or blurring should occur to the printed lines or colours on the real note.","Examining the real note with a magnifying lens reveals the face value, which is inscribed in tiny characters and numbers beneath the picture of the Queen."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Saudi Riyal**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Saudi Riyal to USD** or **INR to Saudi Riyal**, you only need to follow the below-written steps:"}}},{id:11,internalName:"seo_currency_page_australian-dollar",type:"seo_currency_page_australian-dollar",data:{name:"Australian Dollar",code:"AUD",country_code:"AU",travel_country:"Australia",keywords:"Saudi riyal, riyal, riyal currency, Saudi riyal rate, riyal rate, riyal to INR, Saudi riyal to INR, Qatar riyal, Omani riyal rate, exchange rate, currency exchange, Buy, Sell, forex cards, Live Saudi riyal",about:{title_text:"The Strong Currency of Australia",desc:"The Australian Dollar, also abbreviated as AUD, is the national currency of Australia. On the international currency market, the Australian dollar is also known as a few other names. In 1966, the Australian pound was changed over to the Australian dollar as the country's official currency. The Australian dollar serves as the primary currency for a number of nations and territories across the world.\n\n &nbsp; \n\nThe **current rate of the Australian Dollar** is INR (`inr_exchange_rate`) . You can keep an eye on the live **Australian Dollar** value."},quick_facts:{facts:{Country_of_Origin:"Australia",Symbol:"$, A$, AUD",Currency_Code:"AUD",Nick_Names:"Buck, Dough, Aussie",Minor_units:"Cent","Denominations_(Banknotes)":"5, 10, 20, 50 and 100 dollars",Motto:"-",Identification_Feature:"Her Majesty Queen Elizabeth II has reigned as Queen of the United Kingdom for the greatest length of time compared to any other monarch. Since the day of her coronation, her portrait has been included on each new series of Australian banknotes.",Issuing_Bank:"Reserve Bank of Australia",In_Circulation_Since:"February 14, 1966",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Although the first banknotes were not printed in Australia until after the turn of the twentieth century, the country had its own currency for much of that time. In 1910, the Australian Notes Act was enacted, making the National Treasury responsible for printing banknotes and designating the Australian pound as the country's official currency. Paper decimal banknotes were introduced in Australia in 1966.\n\n &nbsp; \n\nThe first series of paper Australian banknotes with decimal denominations (1, 2, 10, and 20 **Australian dollars**) was released in 1966, with the 5 Australian dollar note following in 1967. The 50 and 100-dollar bills were reissued in 1973 and 1984, respectively.\n\n &nbsp; \n\n In 1988, in honour of Australia's bicentennial, the government produced a polymer version of its 10-dollar banknote. This was made possible by the Reserve Bank's work in developing new technology for printing banknotes in Australia. To replace the initial decimal banknotes, a new series of banknotes was manufactured in polymer between 1992 and 1996.\n\n &nbsp; \n\nOn September 27, 2012, the Reserve Bank of Australia announced that it had issued a project order to improve the nation's current banknotes. So,  in the second instalment of the Polymer series, the notes were released with more security features. In fact, those who struggle with their vision would find using the new and improved banknotes much less of a challenge if they featured tactile elements such as Braille dots."},countries_accepting:{desc_1:"",list:["AU","PG","CX","CC","NR","TV"],desc_2:""},amount_for_trip:{desc:"The total price of your vacation to Australia will be determined in part by the form of transportation you choose, the location of your accommodations, and the dining options, amongst other factors.\n\n &nbsp; \n\nIf you want to go on vacation and satisfy all of your essential requirements, you should set up approximately AU$85 per day in your budget. If you indulge in things like private transportation, dinners at Michelin-starred restaurants, and stays at five-star hotels, a luxury vacation might easily cost more than AU$600 per day. Nevertheless, if you and your significant other are considering taking a trip, you should be aware that the entire cost of the vacation could range anywhere from AU$175 to AU$1,200, depending on the specifics of the trip.\n\n &nbsp; \n\nOne night's stay at a hotel in Australia can cost anything from AU$45 to AU$300 per person per day, depending on the establishment. On a yearly basis, it amounts to approximately this much. Your daily transportation costs could range anywhere from AU$20 to AU$105 per day, depending on whether you opt to walk, ride the bus, or call a cab.\n\n &nbsp; \n\nYou can check out **the Australian dollar price** today in order to start planning your vacation."},identification:{list:["Polymer, a form of plastic, is used to print Australian banknotes, giving them a unique texture. If a real banknote gets twisted up, it should spring back into shape.It shouldn't be possible to scratch the white image that's printed on the window of an authentic 20 AUD, 50 AUD, or 100 AUD bill.","You may see a three-dimensional picture framed by bright colours when you tilt the bill. Depending on how you look at it, the picture will be either elevated or recessed.","If you tilt an authentic bill, the colours will appear to roll over the note. It's a large, obvious spot in the upper left corner of one side of the bill and part of a bird design on the other.","When held up to the light, the Australian Coat of Arms should be easily discernible on the banknote. ",'Examine the two patterns that resemble diamonds and are printed inside of circles on both sides of the bill in order to locate the "star." Holding the patterns up to the light should cause them to align into the shape of a seven-pointed star.',"The text on an authentic note ought to have a clean and clear printout.","When trying to spot a mistake, keep an eye out for things like lines that are inconsistent in thickness or colour.","Authentic banknotes, with the exception of the serial number and security patches, do not emit a glow in the dark when illuminated by UV light."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Australian Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Australian Dollar to USD, Australian dollar to AUD* or **INR to Australian Dollar**, you only need to follow the below-written steps:"}}},{id:12,internalName:"seo_currency_page_bahraini-dinar",type:"seo_currency_page_bahraini-dinar",data:{name:"Bahraini dinar",code:"BHD",country_code:"BH",travel_country:"Bahrain",keywords:"Bahraini dinar, bahraini dinar country, bahraini dinar to inr today, bahraini dinar symbol, bahraini dinar to inr, bahraini dinar currency, bahraini dinar to usd,exchange rate, currency exchange, Buy, Sell, forex cards, Live bahraini dinar, current rate of bahraini dinar",about:{title_text:"The Currency of Bahrain",desc:"Located in the Persian Gulf next to Saudi Arabia, the island country of Bahrain is affluent due to its thriving oil and gas sector. The dinar is Bahrain's national currency, and all financial transactions are conducted using it. The currency code for it is BD or BHD. The Central Bank of Bahrain issues banknotes and coins. In banknotes, you can find these denominations: 1/2 dinar, 1 dinar, 5 dinars, 10 dinars, 20 dinars. When it comes to coins, these denominations are available: 1 fil, 5 fils, 10 fils, and 100 fils, respectively. The bahraini dinar symbol is .د.ب.\n\n &nbsp; \n\nThe **current rate of Bahraini Dinar** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Bahraini Dinar** value."},quick_facts:{facts:{Country_of_Origin:"Bahrain",Symbol:".د.ب (Arabic), BD (Latin)",Currency_Code:"BHD",Nick_Names:"None",Minor_units:"Fils","Denominations_(Banknotes)":"½, 1, 5, 10 and 20 dinars",Motto:"-",Identification_Feature:"The 20 dinar note features the image of King Hamad ibn Isa Al Khalifah.",Issuing_Bank:"Central Bank of Bahrain",In_Circulation_Since:"1965",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"In 1965, the Gulf rupee was replaced by the Bahraini dinar, with a conversion rate of 10 rupees to 1 dinar. At first, it was worth around 3/4 of a pound (15 shillings). To coincide with this, the first Bahraini currency and paper currency were issued.\n\n &nbsp; \n\nTIn 1965, the Bahraini Dinar became the country's official currency (BHD). Since 1980, the value of one dinar has been fixed at 0.376 dinars to one dollar in accordance with the Special Drawing Rights (SDR) of the International Monetary Fund. The fluctuations in the currency have been largely caused by instability in the region, although the peg has been maintained so far.\n\n &nbsp; \n\n In the year 2006, the Bahrain Agency transitioned into its new role as the Central Bank of Bahrain (CBB). Both conventional and Islamic financial institutions are subject to the CBB's oversight. It has jurisdiction over a wide range of financial institutions, including investors, brokers, and insurers, amongst others.\n\n &nbsp; \n\nIn 2008, the Central Bank of Bahrain issued a new series of notes to honour the development and history of the island nation. When travelling to Bahrain, you can use any Saudi Riyal except the 500 Riyal.\n\n &nbsp; \n\nIn 2016, after a period of delay, new notes issued by the Central Bank including enhanced security measures were introduced into circulation. The newly updated notes include raised lines, which were added for the benefit of people who have trouble seeing."},countries_accepting:{desc_1:"The **Bahraini dinar** is the legal tender of Bahrain and is used for all kind of financial transactions in this **Bahraini dinar country**.",list:[],desc_2:""},amount_for_trip:{desc:"The total cost of your trip to the Bahrain will be determined by a number of factors, including the mode of transportation you choose, the hotel you choose and where you choose to dine out. If you want to go on vacation and meet all of your needs, budget around BHD 25 per day. If you indulge on things like private transportation, meals at Michelin-starred restaurants, and stays at five-star hotels, a luxury vacation may easily cost more than BHD 150 per day.\n\n &nbsp; \n\nHowever, if you and your partner are considering taking a vacation, you should be aware that the overall cost of the trip could range from BHD 60 to BHD 400, depending on the details of the trip. A single night's stay in the Bahrain can range from BHD 15 to 70 per person per day, depending on the hotel. Your daily transportation costs could range from BHD 4 to BHD 30 per day depending on whether you walk, ride the bus, or call a cab.\n\n &nbsp; \n\nYou can check out the **Bahraini dinar to inr today** to start planning your trip."},identification:{list:["The central banknote feature is a security thread that displays the banknote's value and a single or double security ring whose colours change.","The security thread comes with highly developed aesthetic qualities, such that tilting the paper causes blocks to move and reveal the bill's denomination.","When held up to the light, the Australian Coat of Arms should be easily discernible on the banknote. ","The face value of an authentic banknote is denoted by a series of small, raised lines in the centre of the front, near the right side.","The Arabic numeral for an authentic 20 BHD bill is shown to be one colour during the day and two bright colours when viewed in the ultraviolet light produced by the Gemini function."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Bahraini dinar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Bahraini dinar to USD** or **INR to Bahraini dinar**, you only need to follow the below-written steps:"}}},{id:13,internalName:"seo_currency_page_singapore-dollar",type:"seo_currency_page_singapore-dollar",data:{name:"Singapore Dollar",code:"SGD",country_code:"SG",travel_country:"Singapore",keywords:"Singapore Dollar,  Singapore dollar rate, Singapore dollar rate today, 1 Singapore dollar, Singapore dollar price, Singapore dollar symbol,Singapore dollar to INR, Singapore dollar to SGD, exchange rate, currency exchange, Buy, Sell, forex cards, Live Singapore dollar, current rate of Singapore dollar",about:{title_text:"The Strong Currency of Singapore",desc:"Republic of Singapore, a sovereign island nation in Southeast Asia, issues its own currency, known as the Singapore Dollar (SGD). To differentiate it from other dollar currencies like the US dollar or the Canadian dollar, the Singapore dollar symbol is S$. The Singapore Dollar is widely regarded as one of the world's safest and most secure currencies.\n\n &nbsp; \n\nThe current rate of Singapore Dollar is INR (`inr_exchange_rate`) . You can keep an eye on the live Singapore Dollar value."},quick_facts:{facts:{Country_of_Origin:"Singapore",Symbol:"S$",Currency_Code:"SGD",Nick_Names:"Cent",Minor_units:"Sing","Denominations_(Banknotes)":"2, 5, 10, 20, 25, 50, 100, 1000 and 10,000 dollars",Motto:"Majulah Singapura (Onward Singapore)",Identification_Feature:"The new 100 Dollar note boasts an image of Independence Hall.",Issuing_Bank:"Monetary Authority of Singapore",In_Circulation_Since:"June 12, 1967",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"From 1845 to 1939, Singapore had a currency called the Straits Dollar. The Malayan dollar succeeded it, and in 1953, the Malaya and British Borneo dollar took its place. Singapore used this currency until the 1965 breakdown of the currency union between Malaysia, Singapore, and Brunei.\n\n &nbsp; \n\nAs of April 7, 1967, Singapore had its own currency after gaining independence from Malaysia in 1965. It wasn't until 1973 that the **Singapore Dollar** stopped being pegged to the Malaysian ringgit.\n\n &nbsp; \n\nTo protect Singapore against imported inflation and keep its exports competitive, the Monetary Authority of Singapore (MAS) is responsible for the **Singapore Dollar** to allow the currency to float since 1985."},countries_accepting:{desc_1:"Singapore's legal tender is the **Singapore Dollar**. As a result of Singapore's rise to prominence, the Singapore dollar has become a major international currency.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of money you spend on your trip to Singapore will depend on a number of factors, including the number of times you dine at restaurants outside of your hotel, the level of luxury of the hotel you stay in, and the amount of money you spend on transportation. If you want to go on vacation and still be able to satisfy all of your demands, you should set aside approximately SG$65 per day in your budget. You may easily spend more than SG$450 per day on an opulent vacation if you splurge on items like private transportation, lunches at restaurants with Michelin stars, and stays at five-star hotels. Keep in mind that the entire cost of your vacation with your significant other could range anywhere from SG$140 to SG$1,000, depending on the particulars of your trip, if the two of you are considering taking a trip together.\n\n &nbsp; \n\nThere is a wide range of prices that can be paid on a nightly basis for a single hotel room in Singapore, from SG$40 to SG$290 per person per day. This is an approximation of the total amount per year that is in question. Your daily transportation costs could range anywhere from SG$7 to SG$30 per day, depending on whether you walk, ride the bus, or call a cab. This would be determined by your choice of transportation.\n\n &nbsp; \n\nYou can check out the **Singapore dollar rate today** to start planning your trip to this modern tourist destination as per the **Singapore dollar price**."},identification:{list:["When the authentic bill is held up to the light, a multicoloured image of the late Encik Yusof bin Ishak appears as a watermark. The watermark seems three-dimensional, with sections of light and dark colouration.",'Holding the thread up to the light reveals a succession of writing that includes the denomination number of the note and the word "SINGAPORE" in the four official languages.',"The Singapore Lion insignia on the front of the authentic note lines up exactly with the picture on the back when held up to the light.",'At a higher magnification, the micro-lettering reading "BCCS" or "MAS" in the denomination numeral\'s shadow of the authentic note becomes legible.',"Under ultraviolet light, the serial numbers and front seal on the authentic note emit a vivid glow due to the fluorescent pigment used. This element is also included on both the front and back designs of the note.","Asymmetrical serial numbers are written with greater digits in successive spots on the authentic notes. The serial numbers are shown in a horizontal and a vertical format, respectively. Both of the serial numbers are UV-luminescent."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Singapore dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the ** Singapore dollar to SGD* or **INR to Singapore dollar**, you only need to follow the below-written steps:"}}},{id:14,internalName:"seo_currency_page_omani-rial",type:"seo_currency_page_omani-rial",data:{name:"Omani Rial",code:"OMR",country_code:"OM",travel_country:"Oman",keywords:"Omani rial, omani rial to indian rupees last 7 days, omani rial country, omani rial exchange rate, omani rial rate in indian rupee,  omani rial to rupee, omani rial to usd, exchange rate, currency exchange, Buy, Sell, forex cards, Live omani rial, current rate of omani rial",about:{title_text:"The Currency of Oman",desc:"The Sultanate of Oman maintains its own monetary system, which is known as the Omani rial. The Omani rial was initially known as the rial Saidi, and it was linked to the value of the British pound. Following the successful overthrow of his father in a military coup in 1970, Sultan Qaboos bin Said renamed the country the Sultanate of Oman and replaced the Saidi rial with the Omani rial as the country's official currency.\n\n &nbsp; \n\nThe **current rate of Omani Rial** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Omani Rial** value. One Omani rial is equivalent to 100 baisa."},quick_facts:{facts:{Country_of_Origin:"Oman of America",Symbol:"ر.ع",Currency_Code:"OMR",Nick_Names:"-",Minor_units:"Baisa","Denominations_(Banknotes)":"100, 200 baisa. ½, 1, 5, 10, 20, 50 rials",Motto:"-",Identification_Feature:"The 50 rial note that was released under 2010 series features the image of Sultan Qaboos bin Said Al Said, Ministry of Finance and Economy Building (Muscat)",Issuing_Bank:"Central Bank of Oman",In_Circulation_Since:"May 7, 1970",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Prior to World War II, the most common forms of payment in Muscat and Oman were the Indian rupee and the Maria Theresa thaler (often known as the rial owing to its comparable size to the Spanish eight-real coin).\n\n &nbsp; \n\nFirst issued in 1940 for usage in Dhofar, coins for Oman did not enter circulation until 1946. Since 1959, both the Indian rupee and the Gulf rupee have been in use. On June 6, 1966, the Gulf Rupee was devalued by India by a factor of ten against the Indian Rupee. Several of the states that had been using the Gulf rupee after the devaluation switched to utilising their own currencies.\n\n &nbsp; \n\nOn May 7th, 1970, Oman switched from using the Gulf rupee to using the Saidi rial, which resulted in a devaluation of the Gulf rupee. Back in those days, one Saidi rial was equivalent to twenty-one rupees from the Gulf. The name of the nation and the denomination of its currency were both changed in 1970 after a change in the country's leadership. The Saidi rial was officially replaced with the Omani rial on November 11, 1972, when the Omani rial was launched as a straight successor for the Saidi rial."},countries_accepting:{desc_1:"The **Omani Rial** is the official currency of Oman. This is the only **Omani Rial country** using this currency for all kinds of financial transactions.",list:[],desc_2:""},amount_for_trip:{desc:"The total cost of your vacation in Oman is determined by a number of factors, some of which are how a person travels to their destination, the type of accommodations they reserve, and the amount of money they spend while they are there. If you are on a budget, you can spend about ﷼35 in a single day on the various forms of entertainment and activities available there. A daily budget of more than ﷼140 is required if you intend to take taxis, eat at upscale restaurants, and stay in hotels that are rated five stars or higher. When travelling to a location that is extremely popular among tourists, the price of a vacation for two people can range between ﷼70 and ﷼300. A single night's stay in an Omani hotel room can set you back anywhere from ﷼10 to ﷼40 per person per day. Depending on whether you walk, ride the bus, or hail a cab to get around each day, your transportation costs could range anywhere from ﷼10 to ﷼40.\n\n &nbsp; \n\nYou can check out the Omani Rial to Indian Rupees in the last 7 days in order to get an idea about the Omani Rial price."},identification:{list:["Look for the hologram on a banknote by holding it up to the light.","You can check for the raised texture which is generally hard to reproduce in the fake notes.","The material of a real note is usually sturdier than a fake one.","Make sure that your minor texts written on the note are completely legible without any blurring."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Omani rial** , MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Omani Rial to USD** or **INR to Omani rial** , you only need to follow the below-written steps:"}}},{id:15,internalName:"seo_currency_page_sri-lankan-rupee",type:"seo_currency_page_sri-lankan-rupee",data:{name:"Sri Lankan Rupee",code:"LKR",country_code:"LK",travel_country:"Sri Lanka",keywords:"sri lankan rupee, Sri Lankan rupee symbol, Sri Lankan rupee rate, indian rupee to sri lankan currency, sri lankan rupee to inr, sri lankan rupee to LKR, inr to sri lankan rupee,  exchange rate, currency exchange, Buy, Sell, forex cards, Live sri lankan rupee, current rate of sri lankan rupee",about:{title_text:"The Currency of Sri Lanka",desc:"The currency of Sri Lanka is the **Sri Lankan Rupee**. It is divisible into 100 cents, however, because of its low value, cents are rarely used in everyday transactions. Since there are several other currencies with the same name, the World Bank recommends using the completely disambiguating acronym SL Rs to avoid confusion. The Sri Lankan rupee symbol is Rs.\n\n &nbsp; \n\nThe **current rate of Sri Lankan Rupee** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Sri Lankan Rupee** value."},quick_facts:{facts:{Country_of_Origin:"Sri Lanka",Symbol:"Rs",Currency_Code:"LKR",Nick_Names:"-",Minor_units:"Rupee (Re)","Denominations_(Banknotes)":"2o, 50, 100, 200, 500, 1,000, 2,000 and 5,000 rupees",Motto:"-",Identification_Feature:"The Sri Lankan Hanging Parrot (Loriculus beryllinus) can be seen on the note's right side, while the White Four Ring Admiral butterfly can be seen on the note's left side (Ypthima ceylonica).",Issuing_Bank:"Central Bank of Sri Lanka",In_Circulation_Since:"1895",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"In 1825, the rixdollar Ceylon was replaced by the British Pound at a rate of 1 Pound = 13 13 Rixdollars, and British silver coins entered circulation.\n\n &nbsp; \n\nSince Ceylon had previously been part of the Indian currency region, the Indian Rupee was adopted as the country's official coin on September 26, 1836. However, Treasury bonds denominated in British pounds continued to circulate alongside the Rupee. In 1844, the Bank of Ceylon began printing banknotes in Sri Lanka, and by 1856, these had completely replaced the previous Treasury notes.\n\n &nbsp; \n\nAfter achieving autonomy in 1948, Ceylon established its Central Bank in 1950. After Ceylon's rebranding as Sri Lanka in 1972, the local currency also changed its name to reflect the new moniker. In the previous 100 years, several series of banknotes have been issued, the most recent being in 2011. The 11th series of **Sri Lankan rupee** notes, in six different denominations, was released by the Central Bank of Sri Lanka (CBSL) on February 4, 2011."},countries_accepting:{desc_1:"The **Sri Lanka Rupee** is the legal tender and official currency of Sri Lanka and is used for everyday financial transactions.",list:[],desc_2:""},amount_for_trip:{desc:"The cost of your trip to Sri Lanka will depend on a number of things, like how often you eat out, how nice your hotel is, and how often you take public transportation. If you want to go on vacation and still get everything you want, you'll need about LKR 2,500 per day. On a luxury vacation, it's not unusual to spend more than LKR 23,000 per day on things like private transportation, meals with Michelin stars, and stays at five-star hotels. If you and your partner want to take a trip, keep in mind that the total cost of the trip could be anywhere from LKR 5,000 to LKR 50,000, depending on what you do.\n\n &nbsp; \n\nIn Sri Lanka, a single hotel room can cost anywhere from LKR 1,300 to LKR 15,000 per person per day. Your daily transportation costs could be anywhere from LKR 215 to LKR 2,000 per day, depending on whether you walk, take the bus, or call a cab. This would depend a lot on how you get around."},identification:{list:["The watermark, which is depicted on the authentic note, is a different bird for each denomination. There's also a vertical watermark highlighting the monetary worth.","Each corner of an authentic banknote features a Cornerstone® watermark in the shape of a pair of diagonal bars.","When held up to the light, the front and back of the bill's numerical value align perfectly.",'A close inspection of any authentic note reveals the letters "CBSL" and the numerical value.',"To aid the visually handicapped, the denomination is printed in a vertical order of densely written dots (beginning with one dot for Rs 20 currency note) on the left side of the note. Feel the raised printing with your fingers as you run them across the authentic note (such as the title Central Bank, tactile bars, and primary graphics)."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Sri Lankan rupee**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Sri Lankan rupee to LKR** or **INR to Sri Lankan rupee**, you only need to follow the below-written steps:"}}},{id:16,internalName:"seo_currency_page_bangladeshi-taka",type:"seo_currency_page_bangladeshi-taka",data:{name:"Bangladeshi Taka",code:"BDT",country_code:"BD",travel_country:"Bangladesh",keywords:"bangladeshi taka, bangladeshi taka currency, bangladesh taka rate, bangladeshi taka to inr, bangladeshi taka to dollar, exchange rate, currency exchange, Buy, Sell, forex cards, Live bangladeshi taka, current rate of bangladeshi taka",about:{title_text:"The Currency of Bangladesh",desc:'Bangladesh, nestled in South Asia, has a population of over 165 million people and uses taka as its national currency. The symbols "৳" and "Tk" are by far the most common representations of the taka.\n\n &nbsp; \n\nThe take is a very recent addition to the world of currencies. It is the responsibility of the Bangladesh Bank to issue banknotes with a face value of ten or more, whereas it is the responsibility of the Ministry of Finance to produce banknotes with a face value of between two and five.\n\n &nbsp; \n\nIn fact, the **Bangladeshi taka currency** is subdivided into poishas, with 1 taka being equal to 100 poishas.\n\n &nbsp; \n\nThe **current rate of Bangladeshi taka** is INR `inr_exchange_rate`.'},quick_facts:{facts:{Country_of_Origin:"Bangladesh",Symbol:"৳ or Tk",Currency_Code:"BDT",Nick_Names:"-",Minor_units:"Poisha","Denominations_(Banknotes)":"৳5, ৳10, ৳20, ৳50, ৳100, ৳200, ৳500 and ৳1000",Motto:"-",Identification_Feature:"The ৳5, ৳10 and ৳100 notes feature the map of Bangladesh and Bangabandhu Sheikh Mujibur Rahman on the obverse side.",Issuing_Bank:"Bangladesh Bank",In_Circulation_Since:"March 4, 1972",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"In 1972, Bangladesh began using its current currency, the taka, which was pegged to the Pakistani rupee at the time. The Bangladesh Bank started issuing its own banknotes in 1972, with denominations of 1, 5, and 100 Bangladeshi taka. The year 1977 saw the release of the first fifty banknotes, followed by five hundred in 1979 and twenty bills in 1982. 2008 was the first year that banknotes with a face value of one thousand were put into circulation. And 2011 saw the introduction of a whole new series of banknotes by the Bangladesh Bank, which featured denominations of 2, 5, 100, 500, and 1000. All of them have a watermark and a picture of Bangabandhu Sheikh Mujibur Rahman, the father of the nation, standing in front of the National Martyr's Monument in Savar, and all of them have the year 2011 written on them. And finally, on March 17, 2020, the brand new 200 taka banknotes were issued by the Bangladesh Bank."},countries_accepting:{desc_1:"Bangladesh started issuing its own currency post-independence. Since then, the **Bangladeshi taka currency** is used exclusively in the country. If you’d like to explore Bangladesh, make sure that you exchange your currency notes for Bangladeshi taka by keeping an eye on the **Bangladeshi taka rate**.",list:[],desc_2:""},amount_for_trip:{desc:"On your trip, you can require Bangladeshi taka, depending on what kind of activities you are planning to undertake on your trip. The cost of getting to your destination, transportation, accommodation, as well as the cost of the food that is available there, will all have an effect on your overall travel budget. Travelers to Bangladesh who are on a tight budget should anticipate spending close to BDT 4,000 per day, per person, while they are there. The price of a day's vacation for two people can easily reach BDT 10,000 if they choose to take advantage of private transportation, dine at restaurants with Michelin stars rather than eating at less expensive local joints, and stay in hotels with three stars or more.\n\n &nbsp; \n\nBetween BDT 1,000 and BDT 2,500 per person per day is the average cost of a night's stay across the country. The cost of transportation on a daily basis can range anywhere from BDT 500 to BDT 1,000 per day depending on whether or not you want to take public or private transportation. You can also convert your **Bangladeshi taka to Dollar** for the ease of travelling outside of Bangladesh by keeping an eye on the **live Bangladeshi taka** rate."},identification:{list:["The Bengali inscription on the real notes is written with OVI, which stands for optically variable ink, and the colour of the numerals shifts based on the viewer's viewing angle. When looked at directly, the inscription appears golden, while when looked sideways, it appears green.","There is a security thread that runs through the real Bangladeshi taka notes with a wide holographic window and a diameter of 4 millimetres.",'An iridescent stripe running vertically on the real note that reads "BANGLADESH BANK" in variable colour.',"Intaglio printing is used for real Bangladesh take notes which is a type of printing in which the image is carved into the surface of the paper.","The watermark used on the real notes depicts a water lily, the monogram of the Bangladesh Bank, and the English inscription 1000.","The real Bangladesh take notes boast borderless printing."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Bangladeshi taka**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Bangladeshi taka to Ruble** or **INR to Bangladeshi taka**, you only need to follow the below-written steps:"}}},{id:17,internalName:"seo_currency_page_japanese-yen",type:"seo_currency_page_japanese-yen",data:{name:"Japanese Yen",code:"JPY",country_code:"JP",travel_country:"Japan",keywords:"japanese yen,japanese yen symbol, japanese yen to indian rupee, japanese yen currency, japanese yen to inr, japanese yen to usd,exchange rate, currency exchange, Buy, Sell, forex cards, Live japanese yen (1), current rate of japanese yen",about:{title_text:"The Strong Currency of Japan",desc:'The yen is the name of the unit of currency used in Japan. In the international currency market, it is the currency that is traded in the third-highest volume, after the US dollar (USD) and the euro (EUR). Alongside the United States dollar and the European Union euro, the official currency of Japan, the yen, is frequently kept in reserve as well. The **Japanese yen symbol** is ¥. In spite of the massive devastation the country suffered during World War II, Japan was able to experience an economic miracle in the latter half of the 20th century, and the yen has emerged as a strong competitor to the pound sterling and the dollar as a major currency used across international borders. In Japan, the Bank of Japan is the sole entity authorised to issue banknotes and coins. Banknotes range in value from one thousand yen all the way up to ten thousand yen. In fact, the word "yuan," which is used for Chinese round coins, is where the name "yen" comes from (yuan).\n\n &nbsp; \n\nThe **current rate of Japanese yen** is INR (`inr_exchange_rate`) .'},quick_facts:{facts:{Country_of_Origin:"Japan",Symbol:"¥",Currency_Code:"JPY",Nick_Names:"-",Minor_units:"Rin","Denominations_(Banknotes)":"¥1,000, ¥2,000, ¥5,000 and ¥10,000",Motto:"-",Identification_Feature:"On the reverse side of each of the banknotes circulating in Japan, there is a portrait of a historical or cultural figure chosen to represent Japan.",Issuing_Bank:"Bank of Japan",In_Circulation_Since:"June 27, 1871",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'After the Meiji Restoration in 1868, the first yen was minted in 1869, and in 1871, during the reform of the monetary system, the yen was formally acknowledged as the primary unit of currency. Clan notes were a form of paper currency that had been manufactured and circulated by feudal lords since the late 1600s. In that year, the government ceased to recognise clan notes. 1879 was the year that marked the end of the changeover from clan notes to government notes based on the yen.\n\n &nbsp; \n\nFollowing a period of economic instability, Japan\'s economy was finally brought under control on April 25, 1949, when the government of the occupying United States of America put into action a plan supported by the Bretton Woods system that established the value of the yen at 360 to the dollar.\n\n &nbsp; \n\nSince 1973, the Japanese government has maintained a consistent presence in the currency market, which has resulted in the yen being subject to a policy known as "dirty float." In order to keep the value of the yen relatively stable, the Japanese government placed a high priority on the development of a competitive export market.'},countries_accepting:{desc_1:"The currency used in Japan is abbreviated as JPY, which stands for the Japanese yen. On the international currency exchange market, the dollar and the euro are the two most actively traded currencies. The yen is the third most actively traded currency. While the Japanese yen is only used in Japan, it is still accepted in certain Japan-centric tourist sites of its former colony, South Korea.",list:[],desc_2:""},amount_for_trip:{desc:"There are several factors that affect the amount of money you may need while travelling in the incredible city of Japan. The amount spent on transportation to and around your location, the cost of the accommodation, and the cost of food will all have an effect on the total cost of your vacation.\n\n &nbsp; \n\nOn a budgeted trip, a tourist's daily expenses in Japan can be about JPY 3,500. On the other hand, when you factor in the expense of lavish transportation, dining at Michelin-starred restaurants and staying in top-rated hotels only, the cost of a day of vacation can easily exceed JPY 18,000. Meanwhile, the cost of travelling for two people can range anywhere between JPY 7,000 to JPY 28,000.\n\n &nbsp; \n\nThe cost of a night's stay in Japan can fluctuate anywhere from JPY 2,000 to JPY 15,000 per person per day. On the other hand, the typical cost of a day's worth of transportation can range anywhere from JPY 1,000 to JPY 2,500 each day, depending on whether or not you choose to take public transit or private transportation. While highway buses and the Japan Bus Pass offer the cheapest way of travelling in the country, the cost-saving Seishun 18 Kippu railway ticket is available at only certain times of the year.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **Live Japanese yen** value in order to exchange your currency notes."},identification:{list:["When you tilt this currency note, you should notice a subtle change in both the colour and appearance of its holograms: cherry blossom, face value and logo of the bank.",'When viewed from a particular angle, the denomination is displayed in the bottom left corner of the front of the note, while the word "NIPPON" (which means "Japan" in Japanese) is displayed in the top right corner of the reverse side of the note.',"Under ultraviolet light, the Governor's seal that is printed on the face of the note ought to emit an orange glow if the note is genuine. In addition, the pattern that makes up the background emits a yellowish-green glow in specific locations.","When the currency is held up to the light, it is simple to make out all three of the watermark bars that run vertically along the note; there are two bars on the 5,000 yen note and one bar on the 1,000 yen note.","The blank left and right margins on the front of the real note have a semi-transparent design printed with pink pearl ink which can be seen from a variety of angles.","Intaglio printing which is a kind of raised printing is used in certain parts of the design."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Japanese Yen**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Japanese yen to USD** or **INR to Japanese Yen**, you only need to follow the below-written steps:"}}},{id:18,internalName:"seo_currency_page_kuwaiti-dinar",type:"seo_currency_page_kuwaiti-dinar",data:{name:"Kuwaiti Dinar",code:"KWD",country_code:"KW",travel_country:"Kuwait",keywords:"kuwaiti dinar, kuwaiti dinar country, kuwaiti dinar currency, kuwaiti dinar indian price, kuwaiti dinar symbol, kuwaiti dinar currency rate, kuwaiti dinar to inr, kuwaiti dinar to usd,  exchange rate, currency exchange, Buy, Sell, forex cards, Live kuwaiti dinar, current rate of kuwaiti dinar",about:{title_text:"The Strong Currency of Kuwait",desc:'The Kuwaiti dinar is the official currency in Kuwait which is located at the top of the Gulf. The oil sector is a significant contributor to Kuwait\'s economy, making it one of the wealthiest countries in the world. The word "dinar" originates from the Latin word "denarius”. Currently, the Kuwaiti Dinar is the most valuable currency in the world. The **Kuwaiti dinar symbol** is د.ك.\n\n &nbsp; \n\nThe **current rate of Kuwaiti dinar** is INR (`inr_exchange_rate`) . You can keep an eye on the **live kuwaiti dinar** value in order to know **Kuwaiti dinar Indian price**.'},quick_facts:{facts:{Country_of_Origin:"Kuwait",Symbol:"د.ك",Currency_Code:"KWD",Nick_Names:"-",Minor_units:"Fils","Denominations_(Banknotes)":"KD 1⁄4, KD 1⁄2, KD 1, KD 5, KD 10 and KD 20",Motto:"-",Identification_Feature:"The sixth series notes feature main tourist attractions of Kuwait on the obverse side",Issuing_Bank:"Central Bank of Kuwait",In_Circulation_Since:"July 6, 1785",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The Gulf Rupee was officially phased out in 1961 and replaced with the Kuwaiti Dinar. After the Iraqi invasion of Kuwait in 1990, the Kuwaiti dinar was replaced by the Iraqi dinar as the country's currency. The occupying forces stole a significant amount of cash, both coins and bills, before they left. After the liberation of the country, the Kuwaiti dinar was reintroduced as the official currency of Kuwait, and a new series of banknotes was printed to accompany it.\n\n &nbsp; \n\nThe first series of Kuwaiti dinars was issued by the Kuwaiti Currency Board in 1960, shortly after the Kuwaiti Currency Law was passed. This series of bills were in circulation from April 1, 1961, all the way through February 1, 1982, and included denominations of quarter dinars, half dinars, one dinar, five dinars, and ten dinars.\n\n &nbsp; \n\nThe Kuwaiti dinar was tied to a wide variety of currencies between 1975 and 2003. The Kuwaiti Currency Board was responsible for determining which currencies will be included in the currency basket. A rate of 0.29963 USD per dinar was established for the Kuwaiti dinar in the year 2003. This valuation remained in effect until 2007. Then the Kuwaiti dinar was re-pegged to a different basket of currencies."},countries_accepting:{desc_1:"The Kuwaiti dinar is pegged to a basket of currencies as opposed to being pegged to just one single currency. Since it is the official currency of the country of Kuwait, it is the only **Kuwaiti dinar country**.",list:[],desc_2:""},amount_for_trip:{desc:"It's possible that you'll wind up needing more or less money than you thought while you're exploring Kuwait, and it all depends on what you ultimately want to do there. The total cost of your vacation will be determined by a number of different aspects, such as the price of your transportation to and around your destination, the price of your hotel room, and the cost of the food you consume while you are there.\n\n &nbsp; \n\nIf you are travelling on a limited budget, you should plan to spend close to 35 KWD per day per person. When you include the cost of private transportation, dining at Michelin-starred restaurants, and staying in hotels with three stars or more, taking a luxury vacation can easily cost more than 175 KWD each day. On the other hand, a trip for two can range anywhere between 70 KWD to 350 KWD.\n\n &nbsp; \n\nDuring any given year, the cost of a single night's stay in Kuwait might fluctuate anywhere from 28 KWD to 112 KWD per person per day. It's possible that your daily transportation costs could range anywhere from 0.30 KWD to 35 KWD per day, depending on whether or not you utilise public transportation or a cab.\n\n &nbsp; \n\nKeep an eye on the **Kuwaiti dinar currency rate** as well as **Kuwaiti dinar to USD value** in order to have a cost-efficient vacation here."},identification:{list:['When you "scrub" the paper with your finger, the colours on genuine dinar bills will not bleed, however on counterfeit ones, the colours could bleed.',"By analysing the various security aspects of authentic and counterfeit currency, you can acquire the skills necessary to identify the differences between the two.","Keep a tight eye on bills of a larger value, especially the 20 KWD, as counterfeiters target these bills in an attempt to pass them off as real and collect real money in return."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Kuwaiti Dinar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Kuwaiti Dinar to Ruble** or **INR to Kuwaiti Dinar**, you only need to follow the below-written steps:"}}},{id:19,internalName:"seo_currency_page_new-zealand-dollar",type:"seo_currency_page_new-zealand-dollar",data:{name:"New Zealand Dollar",code:"NZD",country_code:"NZ",travel_country:"New Zealand",keywords:"new zealand dollar, new zealand dollar rate, new zealand dollar price, new zealand dollar rate india, new zealand dollar symbol,new zealand dollar to inr, new zealand dollar to usd, :exchange rate, currency exchange, Buy, Sell, forex cards, Live new zealand dollar, current rate of new zealand dollar",about:{title_text:"The Legal Tender of New Zealand",desc:'The New Zealand dollar is the official currency and the only form of legal cash in New Zealand. It is usually abbreviated with the dollar sign ($) when it is being used within New Zealand. The **New Zealand dollar symbol** "$NZ" or "NZ$" is sometimes used to distinguish the New Zealand dollar from other currencies that are denominated in dollars. The name "Kiwi" or "Kiwi dollar" is sometimes used to refer to the money of New Zealand. This is because the kiwi, which is a flightless bird, is shown on the dollar coin of the country.\n\n &nbsp; \n\nSince the introduction of the dollar in 1967, one dollar is equivalent to one hundred cents. The following bank notes are accepted in the monetary form: $5, $10, $20, and $50 and $100.\n\n &nbsp; \n\nThe **current rate of New Zealand dollar** is INR (`inr_exchange_rate`) . You can keep an eye on the **live New Zealand dollar** value to get an idea about the **New Zealand dollar rate India**.'},quick_facts:{facts:{Country_of_Origin:"New Zealand",Symbol:"$",Currency_Code:"NZD",Nick_Names:"Kiwi, Kiwi Dollar",Minor_units:"Cent","Denominations_(Banknotes)":"5, 10, 20, 50 and 100 Dollars",Motto:"‘Te Putea Matua’ on the front, ‘Aotearoa’ on the back",Identification_Feature:"The Series 7 notes feature text in Māori language: Aotearoa, Te Pūtea Matua and the name of the birds",Issuing_Bank:"CReserve Bank of New Zealand",In_Circulation_Since:"July 10, 1967",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"In the year 1957, the government established a committee with the mission of investigating the benefits and drawbacks of utilising decimal money. The idea was favourably embraced, and in 1963, the decimalization of New Zealand's currency was put into practice.\n\n &nbsp; \n\nThe Congress of the United States approved the Decimal Currency Act in 1964, which established the day of transition as July 10th, 1967. On Monday, July 10, 1967, the pound was replaced by the New Zealand dollar.\n\n &nbsp; \n\nIn order to make the transition as smooth as possible, roughly 165 million new coins and 27 million new banknotes were manufactured. On March 4, 1985, the first time that the New Zealand dollar was allowed to be freely traded, the original exchange rate was 44 cents US."},countries_accepting:{desc_1:"While the New Zealand dollar is the official currency of New Zealand, it is also the legal tender of 4 other places. They have been mentioned below:",list:["CK","NU","TK","PN"],desc_2:""},amount_for_trip:{desc:"While planning to explore the natural landscape of New Zealand, you should keep in mind all the activities you’d like to undertake. The cost of transportation, accommodation and meals, while you're there, will all have an impact on the budget you set aside for your vacation.\n\n &nbsp; \n\nTo account for the typical expenses of a tourist in New Zealand, travellers on a shoestring budget should set aside close to 80 NZD per day in their spending money. The average daily cost of a luxury vacation can easily exceed 200 NZD when private transportation, meals at Michelin-starred restaurants rather than less expensive local establishments, and lodging in hotels rated three stars or higher are all factored in. In fact, the cost for two people travelling in New Zealand can range anywhere from 160 NZD to 400 NZD.\n\n &nbsp; \n\nIn New Zealand, the price of a single night's hotel can range anywhere from 36 NZD to 100 NZD per person per day. Your daily transportation costs could range anywhere from 20 NZD to 50 NZD depending on whether or not you take the bus or a taxi to go around.\n\n &nbsp; \n\nKeep an eye on the **New Zealand dollar price** for a cost-effective vacation in this scenic country."},identification:{list:["The real note has a hologram of a fern and a map of New Zealand. The illustration is of the same bird that can be found on the left side of the bill. Below the hologram, there is writing that has been embossed and it indicates the denomination.","When they are exposed to moisture, the inks that are utilized on polymer notes do not bleed or run. The inks should not smudge or run under any circumstances.",'The denomination of the note is printed in extremely fine micro-print, but if you have a powerful magnifying lens, you should be able to read it. On the enormous numerical are tiny, micro printed versions of the letters "RBNZ."',"When you run your fingertips over polymer notes, you will be able to feel the printing because it is raised slightly above the background.","The serial numbers that appear along the horizontal and vertical axes of each note are an exact match for one another. If the notes have lost their serial numbers or all have the same serial number, this is a strong indicator that they are counterfeit.","The Reserve Bank notes are printed with a special kind of ink that makes everything look dull except for the ultraviolet-sensitive features. Because of this, it is difficult to counterfeit them.","The bird's colour changes as the note is rolled, and the change occurs along the diagonal bar.","When the bill is held up to the light and the front and back irregular forms are allowed to align with one another like pieces in a puzzle, the denomination can be deduced.","Even though polymer banknotes are extremely difficult to fake, most counterfeiters are unable to pass paper bills off as authentic."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **New Zealand Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **New Zealand Dollar to USD** or **INR to New Zealand Dollar**, you only need to follow the below-written steps:"}}},{id:20,internalName:"seo_currency_page_philippine-peso",type:"seo_currency_page_philippine-peso",data:{name:"Philippine Peso",code:"PHP",country_code:"PH",travel_country:"Philippines",keywords:"philippine peso, inr to philippine peso, philippine peso symbol, philippine peso rate, philippine peso currency, philippine peso to inr, philippine peso to usd, exchange rate, currency exchange, Buy, Sell, forex cards, Live philippine peso, current rate of philippine peso",about:{title_text:"The Currency of Philippines",desc:'The Philippine peso, sometimes known as the piso (its Filipino name), is the national currency of the Philippines. There are 100 sentimo, or centavos, in a dollar. The **Philippine peso symbol** "₱" was chosen to serve as the official representative of the Philippine peso when it was taken over by the Americans from the Spanish. Because the nation had been ruled by the United States in the past, the text on its currency was written in English. As a result, the word "peso" remained on the currency notes until the year 1967. The letters "P," "PHP," "Php," and even "P" can all be used interchangeably in this context.\n\n &nbsp; \n\nThe word "peso" can be found in both the Filipino and Tagalog languages. The letter represents the Philippine peso, which is divided into 100 smaller units of currency known as “sentimos”.\n\n &nbsp; \n\nAt the moment, there are several banknotes in circulation that have values of 20, 50, 100, 200, 500, and 1,000 pesos respectively.\n\n &nbsp; \n\nThe **current rate of Philippine Peso** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Philippine peso** value.'},quick_facts:{facts:{Country_of_Origin:"Philippines",Symbol:"₱",Currency_Code:"PHP",Nick_Names:"Piso",Minor_units:"Sentimo","Denominations_(Banknotes)":"₱20, ₱50, ₱100, ₱200, ₱500 and ₱1,000",Motto:"-",Identification_Feature:"The front and back of each banknote has a unique design; the front design depicts significant people, buildings, and events from the nation's history, while the back design depicts landmarks and animals.",Issuing_Bank:"Bangko Sentral ng Pilipinas (Central Bank of the Philippines)",In_Circulation_Since:"June 12, 1985",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Large quantities of Spanish pesos or pieces of eight, which later served as the foundation for the Philippine peso, were transported to the Philippines by the Manila galleons that travelled between Spain and the Philippines from the 16th to the 19th centuries.\n\n &nbsp; \n\nIn the year 1898, the Philippines started printing its own money, and it was backed by the nation's many natural resources. In 1902, when the United States of America acquired control of the Philippines, they introduced a new currency that was pegged to gold at a rate that was approximately equal to half the value of the dollar in use today.\n\n &nbsp; \n\nThe Philippine Central Bank was created in 1949, and during the 1950s, one of its primary objectives was to keep the value of the Philippine peso relative to the United States dollar at a rate of 2:1.\n\n &nbsp; \n\nIn 1967, the bank first started printing money using the Filipino language. Two years later, in 1969, a series of notes with denominations of 1, 5, 10, 20, 50, and 100 pesos was launched.\n\n &nbsp; \n\nIn 1991, the first 1,000 Philippine Peso note was printed. In 1993, free market forces were finally given the opportunity to determine the value of the Philippine peso. And in 2002, the first 200 Philippine Peso bill was printed.\n\n &nbsp; \n\nThe new purple or purple-coloured 100 peso bills were launched by the central bank in February 2016. And in fact, it was announced that coins would completely replace paper currency by the end of 2021 or the beginning of 2022 at the latest."},countries_accepting:{desc_1:"The Philippine peso is the official national currency of the Philippines, and it is used only in the Philippines.",list:[],desc_2:""},amount_for_trip:{desc:"You need to have your complete Philippines itinerary in mind if you’d like to estimate an accurate cost of your vacation. Your vacation budget will be affected by many factors, including the cost of transportation, the cost of your hotel, and the cost of your meals while you are there.\n\n &nbsp; \n\nTourists on a tight budget should set aside close to ₱1,000 a day in spending money to cover the standard costs of a trip to the United States. When you factor in the cost of private transportation, meals at Michelin-starred restaurants rather than less expensive local establishments, and accommodations in hotels rated three stars or higher, the average daily cost of a luxury vacation can easily exceed ₱4,000. On the other hand, a vacation for two costs about ₱2,000 to ₱8,000.\n\n &nbsp; \n\nThe accommodation option in the Philippines typically ranges from ₱400 to ₱1,200 per night per person. Depending on whether you walk, take the bus, or hail a taxi, your daily transportation costs could be anywhere from ₱185 to ₱500."},identification:{list:["When viewed with ultraviolet light, the red or blue threads that authentic bills contain become more visible. These are scattered everywhere across the bill like confetti, and their shape is similar to that of confetti as well.","Examine the Symbol of Nature to see if it responds to UV light by emitting a glow. Alternatively, you can flip the bill over and use a UV light to determine whether or not the Symbol of Nature that is located on the lower left side of the bill is lit up.","When the bills are held up to the light, the security threads that are embedded throughout them become quite obvious. There is a single horizontal line on both the twenty peso bill and the fifty peso bill.","When the bill is held up to the light, a shadow of the portrait form on the front of the bill (right side, where the bill has a white vacant space).","Check to see whether or not the Optically Variable Device (OVD) Patch is present on your 500 and 1000 peso notes.","On this reflective foil OVD patch, the Blue-Naped Parrot would stand in for the Philippine Peso 500 bill, while the South Sea Pearl would stand in for the Philippine Peso 1,000 bill.","When a finger is run over the text of an authentic note, it should have a slightly elevated sensation to it. Moreover, the current NGC banknotes are constructed of abaca fibres, and they are designed to have a rough texture to the touch."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Philippine Peso**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Philippine Peso to USD** or **INR to Philippine Peso**, you only need to follow the below-written steps:"}}},{id:21,internalName:"seo_currency_page_turkish-lira",type:"seo_currency_page_turkish-lira",data:{name:"Turkish Lira",code:"TRY",country_code:"TR",travel_country:"Turkey",keywords:"lira, turkish lira symbol, turkish lira, lira currency, italian lira,  lira to inr, lira to usd, exchange rate, currency exchange, Buy, Sell, forex cards, Live lira, current rate of lira",about:{title_text:"The Currency of Turkey",desc:"In spite of the many times throughout history that it has been devalued, the Turkish lira continues to serve as the official currency of Turkey which is nestled on Anatolian Peninsula in Western Asia. The code of Turkish lira is TRY.\n\n &nbsp; \n\nThe rate of inflation in Turkey is relatively high when compared to that of its contemporaries. In order to combat the effects of inflation, multiple revaluations of the currency have been implemented. The **Turkish lira symbol** is ₺. Between the years 1861 and 2002, Italy's official currency was the **Italian lira**.\n\n &nbsp; \n\nThe **current rate of lira** is INR (`inr_exchange_rate`) . You can keep an eye on the **live lira** value."},quick_facts:{facts:{Country_of_Origin:"Turkey",Symbol:"₺",Currency_Code:"TRY",Nick_Names:"-",Minor_units:"Kuruş","Denominations_(Banknotes)":"₺5, ₺10, ₺20, ₺50, ₺100 and ₺200",Motto:"-",Identification_Feature:'The ₺200 notes feature the image of Yunus\'s mausoleum, rose, pigeon and the line "Sevelim, sevilelim".',Issuing_Bank:"Central Bank of the Republic of Turkey",In_Circulation_Since:"January 1, 2005",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'In 1844, Turkey became the first country in the world to use the lira as its official currency. Between the years 1844 and 1881, the value of one lira was determined by either pure gold or pure silver. However, beginning in 1881 and continuing until 1914, the value was determined only by gold. During the First World War, Turkey moved away from the gold standard, which led to a continued decline in the value of the lira until 1920.\n\n &nbsp; \n\nIn 1946, the lira was set to the US dollar at an exchange rate of TRL 2.80 = USD 1, a parity that was maintained until 1960, when the currency was depreciated to 9 liras to a dollar. This occurred after several periods of fixing the lira to the pound sterling and the French franc.\n\n &nbsp; \n\nBecause of Turkey\'s persistent inflation from the 1970s through the 1990s, the lira saw a significant devaluation during that time period. Although the ottoman nation\'s inflation rate was relatively high in comparison to those of other developing countries, it had not yet experienced hyperinflation. The Turkish lira has been able to maintain its stability and has even gained some value over the past several years when compared to the dollar or the euro.\n\n &nbsp; \n\nAfter yet another depreciation of the Turkish lira in 2005, the New Turkish lira was introduced into circulation. This currency continued to be used until the first of January 2009, when it was once more dubbed the "Turkish lira." On January 1, 2009, a new series of banknotes known as the "E-9 Emission Group" went into circulation. In order to combat counterfeiting, the new banknotes come in a variety of sizes. This new series is distinguished from previous iterations primarily by the fact that each denomination portrays a well-known figure from Turkish history rather than geographic locations or architectural elements of Turkey.'},countries_accepting:{desc_1:"The Turkish lira was ranked as the world's third least valuable currency by the Guinness Book of Records during the years 1995 and 1996, and then again between the years 1999 and 2004. Currently, the lira is the official currency in both Turkey and Northern Cyprus.",list:[],desc_2:""},amount_for_trip:{desc:"If you want an accurate estimate of how much money you will need to spend on your vacation in the bustling country of Turkey, you will need to have every detail of your itinerary planned out beforehand. The amount of money you have set aside for your vacation will be impacted by a variety of factors, including how you plan to get there, where you will stay, and what you will eat while you are there.\n\n &nbsp; \n\nA visitor spending one day in Turkey should expect to spend close to TRY 300 if they are on a shoestring budget. It is not difficult to spend more than TRY 800 per day on a luxury vacation if you choose to opt for private transportation, dinners at five-star restaurants and stay at an opulent property. On the other hand, the cost of a weekend getaway for two people might range anywhere from TRY 800 to TRY 1,800.\n\n &nbsp; \n\nThe cost of a single night's stay in a Turkey hotel typically ranges anywhere from TRY 175 to TRY 350 per individual. Depending on whether you walk, use the bus, or hail a taxi, your daily transportation costs can range anywhere from TRY 65 to TRY 120 and even more."},identification:{list:["When exposed to UV light, banknotes that have been printed on genuine banknote paper, which is composed wholly of cotton fibre, do not emit a glowing effect.","When a genuine banknote is held up to the light from either the obverse or the reverse, a watermark of Atatürk's image and the denomination numeral will appear in the unprinted white part of the currency.","When creating counterfeit banknotes, the watermark is either completely fabricated or represented by an imprint on the paper.","Authentic banknotes are manufactured with security fibres inserted into them by the Central Bank throughout the production process. However, when exposed to UV light, the bright blue and red colours in their pigments become plainly apparent.","Imprints or highlighters are frequently used on counterfeit banknotes in an attempt to simulate these security threads.",'When a genuine banknote is examined under a bright light, the security thread will display the denominational numeral together with the letters and numbers "TL" in a continuous line on the thread. In the presence of ultraviolet light, this thread will emit a glow that is either blue, red, or yellow, depending on the value of the bill.',"Notes that are legitimately printed will have a holographic stripe foil on the right side of the obverse. This stripe will reflect different colours and sheens depending on the angle at which the note is viewed.","Some of the text and numeral blocks, as well as the graphics, on the obverse of a real banknote are made using a particular printing technique that provides an embossed impression that can be felt with the fingertips.","Even with a magnifying glass, the micro writing on counterfeit bills is unintelligible because it has been distorted. However, some counterfeit banknotes utilise printing methods that render the tiny script more legible, and others do not.","Authentic banknotes have two serial and sequence numbers printed on the back, one in black and the other in red. The one that was printed with black ink fluoresces green when exposed to UV light, whereas the one that was printed with red ink fluoresces a different colour when exposed to UV light.","The counterfeit bills are designed to be visually identical to the real ones. However, there is a possibility that some are somewhat longer or thinner than others."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Turkish Lira**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Turkish Lira to USD** or **INR to Turkish Lira**, you only need to follow the below-written steps:"}}},{id:22,internalName:"seo_currency_page_chinese-yuan-renminbi",type:"seo_currency_page_chinese-yuan-renminbi",data:{name:"Chinese Yuan",code:"CNY",country_code:"CN",travel_country:"China",keywords:"yuan, chinese yuan, yuan currency, yuan symbol, yuan to inr, yuan to usd, exchange rate, currency exchange, Buy, Sell, forex cards, Live yuan, current rate of yuan",about:{title_text:"The Legal Tender of China",desc:"The People's Republic of China uses the renminbi as its official currency. The renminbi was the sixth most actively traded currency in the world as of April 2022, making it one of the most commonly used currencies in the world. The Chinese currency is referred to as the yuan when it is spoken about outside of China. The People's Bank of China (PBOC), also known simply as the People's Bank, is responsible for issuing the renminbi (RMB). The **yuan symbol** is ¥.\n\n &nbsp; \n\nIn circulation are bills worth one yuan, two yuans, five jiao, ten yuans, twenty yuans, fifty yuans, and a hundred yuans. There are also banknotes worth one hundred yuans. The production of two-fen and five-fen coins is also included in the minting operations of the central bank. In addition to the currency costing one yuan, there are also coins worth one jiao and five jiao that are now in circulation.\n\n &nbsp; \n\nThe **current rate of yuan** is INR (`inr_exchange_rate`) . You can keep an eye on the **live yuan** value."},quick_facts:{facts:{Country_of_Origin:"China",Symbol:"¥",Currency_Code:"CNY",Nick_Names:"Redback",Minor_units:"jiǎo","Denominations_(Banknotes)":"¥1 RMB, ¥5 RMB, ¥10 RMB, ¥20 RMB, ¥50 RMB, and ¥100 RMB",Motto:"-",Identification_Feature:"Mao Zedong, a former chairman of the Chinese Communist Party, is featured on each and every one of the banknotes in the fifth series.",Issuing_Bank:"People's Bank of China",In_Circulation_Since:"December 1, 1948",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The silver dollar of the Spanish American Empire, which China imported in large quantities from the 16th to the 20th centuries, served as the basis for the yuan and the dollar currencies of mainland China, Taiwan, Hong Kong, Macau, and Singapore.\n\n &nbsp; \n\nOn December 1, 1948, approximately one year before the People's Republic of China was legally constituted, the People's Bank of China gave the renminbi its official introduction into circulation. In the beginning, it was only accessible in the form of paper, and it was designed to replace the many other currencies that were being used across the territory that was under Communist authority.\n\n &nbsp; \n\nOne of the initial responsibilities of the newly installed administration was to address China's hyperinflation, which had become a problem in the final years of the Kuomintang (KMT) regime. As soon as that objective was accomplished, a revaluation was carried out in 1955, and the new exchange rate was established to be 1 new yuan for every 10,000 old yuan.\n\n &nbsp; \n\nAt the conclusion of the Chinese Civil War in 1948, the Chinese Communist Party began consolidating its authority over more and more territory. In response, the People's Bank of China started producing a unified currency, which was also denominated in yuan, that could be used throughout all areas governed by the Communist party."},countries_accepting:{desc_1:"The renminbi, sometimes known as the Chinese yuan, is the de facto currency used in the People's Republic of China. Despite the fact that people frequently use the terms interchangeably, they actually refer to two distinct concepts. The yuan is the currency that is used the most frequently throughout China's whole monetary system and economy. On the other side, the currency is referred to by its official name, which is the renminbi.",list:[],desc_2:"As its official unit of currency, the People's Republic of China employs the Chinese yuan renminbi, which is also extensively used and acknowledged in other parts of the world."},amount_for_trip:{desc:"The amount of money you have set aside for your vacation in China will be impacted in a variety of ways including transportation, where you intend to stay, and the amount you will spend on meals. Because of the high cost of living, a tourist who visits China anticipates spending close to ¥459 per day. A luxury vacation might easily cost more than ¥1,000 per day if the traveller chooses to spend their money on things such as private transportation, dinners at restaurants with Michelin stars and upscale accommodation options. On the other hand, the cost of a vacation for two may range anywhere from ¥1,000 to ¥1,900, depending on the destination.\n\n &nbsp; \n\nYou may expect to pay between ¥195 and ¥400 for one night's stay in a hotel room in China. This is the average cost. It is possible for your daily transportation costs to range anywhere from ¥92 to ¥150 or even higher, depending on whether you choose to walk, take the bus, or call a cab."},identification:{list:["Holding an RMB bill up to the light and observing whether or not the image of Chairman Mao that is printed in the white area on the left side is legible is one method of determining whether or not a bill is genuine. On counterfeit bills, his image is generally twisted in some way.","In addition to this, the serial number is followed by a red circle that contains a red and blue insignia within it. The symbol on real banknotes has a clear demarcation between the red and blue borders on the symbol. They completely overlap one another or are aligned in the correct manner. On counterfeit bills, the logo is often deformed in an unnatural way.",'On a note for one hundred Yuan (or fifty Yuan, or twenty Yuan, etc.), there is a green sign that says "one hundred" next to the symbol that is red and blue. If the logo is only visible in a dark green colour when the bill is flipped over, then the currency in question is almost certainly counterfeit. When viewed from any angle, the colour of the symbol will never become brown if the note is a fake.',"Scrub the colossal photograph of Chairman Mao by running your finger over the collar. If you can feel any texture on his collar, the note is authentic; if not, it is most certainly a fake.","Give the note a little ruffle while you are holding it in your hands with the longer side facing up. The sound should be clear and recognisable; knockoffs made with low-grade materials typically have a muffled quality. However, the fact that many of the bills are so old and worn, which modifies the sound they create, is the factor that makes this the most difficult aspect to identify."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Chinese Yuan**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Chinese Yuan to USD** or **INR to Chinese Yuan**, you only need to follow the below-written steps:"}}},{id:23,internalName:"seo_currency_page_thai-baht",type:"seo_currency_page_thai-baht",data:{name:"Thai Baht",code:"THB",country_code:"TH",travel_country:"Thailand",keywords:"thai baht, thai baht rate, thai baht currency, thai baht symbol, today thai baht rate, thai baht rate today in indian, thai baht to inr, thai baht to usd, exchange rate, currency exchange, Buy, Sell, forex cards, Live thai baht, current rate of thai baht",about:{title_text:"The Currency of Thailand",desc:"The baht is Thailand's official and de facto national currency. One dollar is equal to one hundred satang. According to data provided by SWIFT as of January 2019, the Thai baht is now ranked as the world's tenth most often used payment currency. The Thai baht is abbreviated as THB. The **Thai Baht symbol** is ฿.\n\n &nbsp; \n\nIt may come as a surprise to learn that in the country of Thailand, stepping on a coin or a banknote is considered to be an act of disrespect directed toward the monarchy. It is deemed rude to carry coins in the back pocket of one's pants for the same reason that one would be considered disrespectful if they sat on the King.\n\n &nbsp; \n\nThe Bank of Thailand, which serves as the country's central bank, is responsible for managing the currency and producing banknotes in the following denominations: 20, 50, 100, 500, and 1,000. There are coins with the values of 25, 50, 1, 2, 5, and 10 satangs, as well as 1, 2, and 5 satangs.\n\n &nbsp; \n\nThe **current rate of Thai Baht** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Thai Baht** value."},quick_facts:{facts:{Country_of_Origin:"Thailand",Symbol:"฿",Currency_Code:"THB",Nick_Names:"-",Minor_units:"Satang","Denominations_(Banknotes)":"฿20, ฿50, ฿100, ฿500, ฿1000",Motto:"-",Identification_Feature:"The 20 Baht to 1,000 Baht notes feature the image of King Maha Vajiralongkorn on the obverse side.",Issuing_Bank:"Bank of Thailand",In_Circulation_Since:"September 19, 1902",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'When a local medium of trade was first introduced in the first century B.C., the roots of the currency that is used today in Thailand may be traced all the way back to that time period. The structure of the Thai baht as it exists today, on the other hand, can be traced back to the beginning of the 20th century, when Chulalongkorn initiated a number of different reforms.\n\n &nbsp; \n\nThe term "Baht" has been used to refer to the money of Thailand ever since the nineteenth century. Both the tical and the baht were originally conceived of as weight-based units of exchange. Although it wasn\'t officially adopted as the nation\'s currency until the year 1897, the Baht had been in circulation for the majority of the preceding century.\n\n &nbsp; \n\nThe baht, much like the pound, was formed from a system of weights and measures that existed prior to the modern era. The value of bullet coins, known as phot duang in Thai, was first determined relative to the price of silver of a weight that was comparable to the value of the coin. These coins were in circulation as early as the Sukhothai era. These silver coins were cast to their precise weights in order to correspond with the baht, which is one of the traditional units of measurement used in Thailand. On October 28, 1904, Prince Jayanta Mongkol introduced a decimal monetary system in which one baht was equal to one hundred satang. Silver bullet coins ceased to be legal tender in the country the following year.\n\n &nbsp; \n\nBefore the redesign of the series 2 banknotes in 1925, the baht was sometimes referred to as the "tical" in the English language text that appeared on the banknotes. This English name was still printed on Thai banknotes all the way up until the year 1925, when the word was finally removed.'},countries_accepting:{desc_1:"The baht became Thailand's official currency in 1889, and to this day, it is the only currency that can be spent legally within the country. In Thailand, the satang serves as the country's subunit currency, and one baht is equivalent to one hundred satang.",list:[],desc_2:""},amount_for_trip:{desc:"If you’d like to enjoy a memorable vacation in the picture-perfect landscape of Thailand, then you must consider different aspects: meals, accommodation as well as transportation.\n\n &nbsp; \n\nIf you are on a budgeted trip, then you can spend about 2,000 THB per day per person. On the other hand, spending money on private transportation, dinners at high-end restaurants and staying at luxurious hotels may cost 10,000 THB. However, the amount that you spend on a scenic getaway for two might easily reach between 7000 THB and 15,000 THB or even higher depending on where you travel.\n\n &nbsp; \n\nFor a single night's stay in a hotel room in Thailand, you can anticipate paying anywhere from 500 THB to 1,000 THB per person. Your daily transportation costs could range anywhere from 150 THB to 400 THB per person per day, or even more, depending on whether you opt to walk, ride the bus, or call a cab.\n\n &nbsp; \n\nKeep an eye on **today Thai baht rate** including the **Thai baht rate today in Indian** for a cost-effective holiday."},identification:{list:["The authentic Banknote paper is a specialised kind of paper that is manufactured from cotton fibre, which makes it considerably more robust and long-lasting than regular paper.","The intaglio method used on authentic notes produces a print that has a raised surface, is of good quality, and is clearly defined.","When held up to the light from either side, the watermark of His Majesty the King's image and the indication of transparent are both plainly distinguishable.","In the bottom left corner of each bill are a series of Arabic numbers that are hidden within the intricate design. You can decipher these concealed numerals on the note if you start in the bottom left corner and move your gaze towards the middle.","The thread of alternating colours that serves as a security feature is embedded in each and every banknote. Holding the thread up to the light enables one to view the entirety of the thread. In addition to that, it features letters and numbers that stand for the value of the banknote.","A vertical stripe of metallic hologram foil is inserted in the left margin of banknotes valued 100, 500, and 1,000 baht. This stripe is located on the front of each of these bills. When flipped over and viewed from a variety of angles, the foil stripe that is displaying the value gives the impression of altering its colour and taking on new shapes."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Thai Baht**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Thai Baht to USD** or **INR to Thai Baht**, you only need to follow the below-written steps:"}}},{id:24,internalName:"seo_currency_page_vietnamese-dong",type:"seo_currency_page_vietnamese-dong",data:{name:"Vietnamese Dong",code:"VND",country_code:"VN",travel_country:"Vietnam",keywords:"dong, convert vietnamese dong to inr, dong rate, vietnamese dong to usd, vietnamese dong to inr, exchange rate, currency exchange, Buy, Sell, forex cards, Live dong, current rate of dong",about:{title_text:"The Currency of Vietnam",desc:"Since May 3, 1978, the Vietnamese government has used the dong as the country's official currency. It was initially conceived upon and developed by the State Bank of Vietnam. The Vietnamese dong ultimately succeeded the French Indochinese piastre as the official unit of currency for North Vietnam and the territory of South Vietnam.\n\n &nbsp; \n\nThe **current rate of dong** is INR (`inr_exchange_rate`) . You can keep an eye on the **live dong** value."},quick_facts:{facts:{Country_of_Origin:"Vietnam",Symbol:"₫",Currency_Code:"VND",Nick_Names:"-",Minor_units:"Hao","Denominations_(Banknotes)":"1,000, 2,000, 5,000, 10,000, 20,000, 50,000, 100,000, 200,000, 500,000 dongs",Motto:"-",Identification_Feature:"The 5,000 to 1,00,000 dong notes feature the image of Ho Chi Minh on the obverse side.",Issuing_Bank:"State Bank of Vietnam",In_Circulation_Since:"May 3, 1978",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The Vietnamese dong made its way into the country in stages, first making its way to the Northern Region and then later making its way to the Southern Region. This currency was initially established by the government of North Vietnam in 1946 to take the place of the French Indochina piastra. After then, there were two additional reevaluations carried out, one in 1951 and the other in 1958.\n\n &nbsp; \n\nSouth Vietnam began issuing banknotes in the form of piastras and dongs in the year 1953. On September 22, 1975, after Saigon had been overthrown, South Vietnam began using the new dong as their currency. Following the reunification of Vietnam on May 3, 1978, the dong was adopted as the country's sole currency.\n\n &nbsp; \n\nIn South Vietnam, one new dong was equal to an exchange rate of 0.80 old dong. Following a revaluation that took place on September 14, 1985, the value of one old dong was equivalent to ten new dongs. Following that, an inflationary cycle occurred that lasted until approximately the middle of the 1990s.\n\n &nbsp; \n\nIn 1985, the Vietnamese government issued new units of currency with the following denominations: 5 hao, 1, 2, 5, 10, 20, 30, 50, and 100 dong. 1987 saw the release of banknotes with face values of 200, 1,000, 2,000, and 5,000 dong; 1990 saw the release of banknotes with face values of 10,000 and 50,000 dong; 1991 saw the release of a note with a face value of 20,000 dong; 1994 saw the release of a note with a face value of 100,000 dong; 2003 saw the release of a note with a face value of 500,000 dong; and 2006 saw the release of a note with a face Despite the fact that production of banknotes with denominations of 5,000 dong or less was stopped in 2015, the notes continue to be widely recognised as of 2015. There have been five completely separate series of coinage that has been released up until this point."},countries_accepting:{desc_1:"The Vietnamese dong came in different stages to the country, first entering the North Area and then to the South. Currently, Vietnamese dong is the legal tender of Vietnam.",list:[],desc_2:""},amount_for_trip:{desc:"It can be difficult to estimate how much money you will need for a vacation to Vietnam if you don't first create a comprehensive schedule of all the things you want to do there. Because you do not know what your future financial requirements will be, it is impossible for you to allocate sufficient resources. Your plans for where you want to go, how you want to stay, and what kinds of things you want to buy on your trip will all have a significant impact on the total amount of money you have set aside for your holiday.\n\n &nbsp; \n\nOn average, a tourist may need to spend about d12,00,000. Your daily budget may easily reach around d35,00,000 if you chose to indulge on items like as private transportation, dinners at restaurants with Michelin stars rather than less expensive local locations, and hotels with three stars or more. If you want to travel to an expensive location, however, the price of a weekend getaway for two that is meant to be romantic might easily reach between d25,00,000 to d75,00,000.\n\n &nbsp; \n\nA single night's stay in a hotel room in Vietnam will run you between d5,00,000 and d12,00,000 per person. This price range is quite standard across the country. After this point, the price will almost never go any higher. Your daily transportation costs could range anywhere from d2,50,000 to d7,00,000 or even more, depending on whether you choose to walk, take the bus, or hail a cab."},identification:{list:["The central bank maintains that counterfeit notes are not nearly as well made as the authentic ones they compare them to.","Genuine banknotes include a narrow strip running vertically across the width of the note that displays the denomination in a visible manner, but counterfeit bills do not have this feature.","The genuine note contains sections printed with optically variable ink, which, when rotated slightly, enables the colour to transition from yellow to green and back again.","In the presence of infrared red light, the image on the real note would be seen through the smaller of the two transparent windows that are located on the opposite corners of the note. However, the picture would not be visible through the window on the fake note.","When exposed to ultraviolet light, the serial digits on the genuine note glow brilliantly, whilst the serial digits on the counterfeit note either do not light up at all or just light up very weakly.","According to the nation's central bank, the majority of counterfeit polymer notes are made from regular plastic and have the potential to be easily broken in the manner that you may anticipate (ripped, stretched, and scratched).","Holding the Vietnamese banknotes up to the light will allow you to examine the watermarks that are printed on them. The watermark of Ho Chi Minh's portrait that can be seen on the left side of the banknote is an exact reproduction of the watermark that can be found on the right side of the note.","Scrubbing the Vietnamese banknotes with your fingers will allow you to examine the intricacies that are embossed and printed on them. It is straightforward to determine whether or not a banknote is real and to determine whether or not it possesses additional security elements, such as a printed embossing.","When the banknotes are tilted, the yellow thread that runs around the back of the bills displays a metallic sheen and sparkles."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Vietnamese Dong**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Vietnamese Dong to USD** or **INR to Vietnamese Dong**, you only need to follow the below-written steps:"}}},{id:25,internalName:"seo_currency_page_indonesian-rupiah",type:"seo_currency_page_indonesian-rupiah",data:{name:"Indonesian Rupiah",code:"IDR",country_code:"ID",travel_country:"Indonesia",keywords:"indonesian rupiah,indonesian rupiah symbol, indian rupee to indonesian rupiah, indonesian rupiah exchange rate,indonesian rupiah to inr, usd to indonesian rupiah, indonesian rupiah to usd,exchange rate, currency exchange, Buy, Sell, forex cards, Live indonesian rupiah, current rate indonesian rupiah",about:{title_text:"The Legal Tender of Indonesia",desc:'The rupiah is the legal tender of the picturesque city of Indonesia. It is the responsibility of Central Bank of Indonesia to issue and manage the currency. The name "rupiah" can be traced back to the Sanskrit word "rupyakam," which translates to "silver." The Indonesian rupiah is abbreviated as IDR. After the war in 1945, Indonesia made a formal proclamation of its independence from the Netherlands. The Rupiah was selected to serve as Indonesia\'s primary currency in 1946. The indonesian rupiah symbol is Rp.\n\n &nbsp; \n\nThe following denominations of IDR banknotes are currently in circulation: one thousand, two thousand, five thousand, ten thousand, fifty thousand, and one hundred thousand. There are coins with denominations of fifty, one hundred, two hundred, five hundred, and one thousand IDR that can be purchased.\n\n &nbsp; \n\nThe **current rate of Indonesian rupiah** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Indonesian rupiah** value.'},quick_facts:{facts:{Country_of_Origin:"Indonesia",Symbol:"Rp",Currency_Code:"IDR",Nick_Names:"-",Minor_units:"Sen","Denominations_(Banknotes)":"Rp1,000, Rp2,000, Rp5,000, Rp10,000, Rp20,000, Rp50,000 and Rp100,000",Motto:"-",Identification_Feature:"The Rp100,000 note features the image of Sukarno and Mohammad Hatta on the obverse side.",Issuing_Bank:"Bangko Sentral ng Pilipinas (Central Bank of the Philippines)",In_Circulation_Since:"October 3, 1946",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The Indonesian rupiah was one of the numerous currencies that were in circulation when it was first presented to the public in October of 1946. A number of other currencies, including the Japanese yen, the gulden of the Netherlands Indies, and others, were utilised. The Indonesian rupiah (IDR) steadily superseded all other currencies after the country earned its independence from the Dutch in 1950, and by 1951, it was the only currency that could be used as legal tender.\n\n &nbsp; \n\nFollowing the Dutch government's formal acknowledgement of the nation's independence in 1950, the federal government assumed full responsibility and immediately began enacting reforms to the monetary system the following year. Rupiah was made the only legal currency, and other currencies could only be exchanged for it at rates that were typically unfavourable to the owners of those currencies."},countries_accepting:{desc_1:"The Indonesian rupiah is the legal tender of Indonesia and is used exclusively in the country.",list:[],desc_2:""},amount_for_trip:{desc:"Budgeting for a trip is notoriously difficult since there are so many aspects to it, including where you want to go, how you want to stay, and what you want to buy. An international visitor spends close to Rp2,50,000 per day if they are on a shoestring trip. If you want to indulge in things like private transportation, dinners at high-end restaurants and top-class hotels, your daily budget may easily reach over Rp22,00,000. A memorable vacation for two might easily cost Rp44,00,000.\n\n &nbsp; \n\nThe average price of a hotel room in Indonesia ranges from around Rp1,40,000 to Rp15,00,000 for a single night's stay per person. Depending on whether you walk, take the bus, or hail a cab, your daily transportation costs might be as little as Rp35,00,000 or as high as Rp3,15,000."},identification:{list:["The printing on official banknotes denominated in Rupiah is visible and crystal clear.","When attempting to identify a counterfeit note is to search for printing that is blurry. Notes that have printing that is unclear are almost certainly counterfeit. The printing on authentic Rupiah bills cannot be mistaken for anything else.","Embossing of the denomination numerals, watermark artwork commemorating revolutionary heroes, and tighter security threads are some additional characteristics that should be looked out for to prevent counterfeiting.","Simply running your fingertips along the bill's face value will give you a sense of its genuineness. It is essential that the surface be slightly rough, and that the numerical denominations be embossed.","Examine several Indonesian currencies under a bright light. All authentic banknotes issued by the Bank of Indonesia have a portrait of a revolutionary hero from Indonesia on the banknote's watermark."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Indonesian Rupiah**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Indonesian Rupiah to USD, USD to Indonesian Rupiah** or **INR to Indonesian Rupiah**, you only need to follow the below-written steps:"}}},{id:26,internalName:"seo_currency_page_malaysian-ringgit",type:"seo_currency_page_malaysian-ringgit",data:{name:"Malaysian Ringgit",code:"MYR",country_code:"MY",travel_country:"Malaysia",keywords:"malaysian ringgit,ringgit, malaysia ringgit rate, ringgit rate, ringgit currency, ringgit to inr, usd to ringgit, ringgit to usd, exchange rate, currency exchange, Buy, Sell, forex cards, Live malaysian ringgit, current rate malaysian ringgit",about:{title_text:"The Currency of Malaysia",desc:'The ringgit is Malaysia\'s national currency, and it is referred to by that name. It is divisible into 100 different smaller units and has a value of one hundred sen. The ringgit is a currency that is issued by the Central Bank of Malaysia. The abbreviation for the Malaysian ringgit is RM, and the currency code for it is MYR. The Malay word for cash is "ringgit," which literally translates to "jagged." Ringgit is also an allusion to the Spanish colonial era.\n\n &nbsp; \n\nThe denominations issued by the banks are RM100, RM20, RM5, RM50, RM10 and RM1 for banknotes and 20 sen, 50 sen, 5 sen and 10 sen for coins. At any one of a variety of currency exchanges, travellers will be able to convert part of the cash on hand into ringgits either before travelling to Malaysia or while they are there.\n\n &nbsp; \n\nThe **current rate Malaysian ringgit** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Malaysian ringgit** value.'},quick_facts:{facts:{Country_of_Origin:"Malaysia",Symbol:"RM",Currency_Code:"MYR",Nick_Names:"-",Minor_units:"Sen","Denominations_(Banknotes)":"RM1, RM5, RM10, RM20, RM50 and RM100",Motto:"-",Identification_Feature:"All the notes feature the image of Tuanku Abdul Rahman with the national flower, hibiscus, and patterns of the traditional fabric – the songket.",Issuing_Bank:"Central Bank of Malaysia",In_Circulation_Since:"June 12, 1967",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'On June 12, 1967, the Malasiyan dollar and the British Borneo dollar were both converted into the new currency known as the Malaysian dollar. The Central Bank of Malaysia is responsible for the release of this brand-new currency. The colours of the old dollar were maintained. Minor modifications were made to the notes and coins that were issued throughout the subsequent decades. In 1993, the "RM" (Ringgit Malaysia) symbol was eventually adopted after many years of using the dollar sign "$" (or "M$") as the currency\'s symbol.\n\n &nbsp; \n\nThe exchange rate had increased to 3.08 United States dollars per unit by the year 2008, up from 3.08 dollars before the peg was removed in 2005. It reached a new all-time low of 3.73 in the year 2009. After then, it kept going up for a few more years, until it eventually reached a rate of approximately 3 ringgits to 1 US dollar between 2011 and the first part of 2013. The value of the ringgit continued its downward trend till it hit 4.47 in the year 2016. At the beginning of 2022, the exchange rate for USD/MYR was between 4.17 and 4.21.'},countries_accepting:{desc_1:"While Malaysia is the official user of Malaysian ringgits, there are other countries that are unofficial users of Malaysian ringgits. Their names are mentioned below:",list:["PH","TH","VN"],desc_2:""},amount_for_trip:{desc:"Creating a travel budget that is both reasonable and flexible can be difficult because there are so many factors to take into consideration, including where you want to go, how you want to stay, and what you want to buy. In Malaysia, a day's expenses for a visitor from outside the country will run up to RM105, even on a limited budget. If you have costly needs such as private transportation, gourmet dinners, and stays in five-star hotels, you can need a daily budget that is higher than RM1,000. It is possible that you will spend RM250 to RM2,000 on a vacation for two people to a popular location.\n\n &nbsp; \n\nA single night's stay in a hotel in Malaysia will cost you an average of between RM60 and RM600 per person. Whether you walk, ride the bus, or hail a cab to go about, your daily transportation costs might be anywhere from RM20 to RM150.\n\n &nbsp; \n\nKeep an eye on the **Malaysia ringgit rate** for a cost-saving vacation."},identification:{list:["In virtually all cases, counterfeit RM100 notes printed on a regular inkjet printer feature a colour scheme that is brighter than the one used on the genuine bills. The counterfeiters are unable to recreate the original banknotes' colours because the inkjet printers they use are of such poor quality.","There is a possibility that the banknote's overall colour would look different from the original, or that a particular region of the note will not have the same level of colour brightness as the original. Both of these options are possible. If you are familiar with the colour pattern of Malaysian banknotes, you will be able to recognise counterfeit ones.","The paper that is utilised in the production of counterfeit bills is normally of worse quality than the material that is utilised in the production of genuine banknotes. You should become used to handling real bills so that you will be able to recognise a fake bill when you see one. Authentic banknotes have a somewhat grainier texture and are crafted from a material other than the pulp paper that is typically used.","The printing process known as intaglio makes a raised impression on the front and back of the notes with the application of multiple layers of texturally distinct inks. Touching the raised printed area of a banknote allows one to verify the note's authenticity. It is highly possible that low-quality counterfeit notes will not have any raised printing effect at all.",'The words "Bank Negara" are printed in the upper left corner of every authentic note.',"On a counterfeit banknote, the following features are unlikely to be visible when illuminated by white light: The numeral 100 formed in its whole and without any obstructions; portrait bearing a watermark; numeral 100.",'If you tilt an authentic RM100 banknote and look at the Micro-lens security thread, you\'ll see that the image of "Bunga Raya" within the thread alters. This is because the thread has microlens.',"Other concealed safety features, such as those that are only discernible with the aid of a magnifying glass or an ultraviolet light, were also incorporated by BNM."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Malaysian Ringgits**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Malaysian Ringgits to USD, Ringgit to INR, USD to Ringgit** or **INR to Malaysian Ringgits**, you only need to follow the below-written steps:"}}},{id:27,internalName:"seo_currency_page_mauritian-rupee",type:"seo_currency_page_mauritian-rupee",data:{name:"Mauritian Rupee",code:"MUR",country_code:"MU",travel_country:"Mauritius",keywords:"Mauritian Rupee, mauritius currency in india rupees, Mauritian Rupee to inr today, Mauritian Rupee to inr, exchange rate, currency exchange, Buy, Sell, forex cards, Live Mauritian Rupee, current rate Mauritian Rupee",about:{title_text:"The Legal Tender of Mauritius",desc:"The rupee is the official currency used in Mauritius, which is a small island nation located in the Indian Ocean to the southeast of the coast of Africa. One hundred Mauritian cents are denoted as one Mauritian Rupee. The rupee can be represented by the sign Rs., whereas the currency's code is MUR. The Bank of Mauritius is responsible for issuing the Mauritian Rupee.\n\n &nbsp; \n\nThe **current Mauritian Rupee rate** is INR (`inr_exchange_rate`) . You can keep an eye on the **live Mauritian Rupee** value."},quick_facts:{facts:{Country_of_Origin:"Mauritius",Symbol:"₨",Currency_Code:"MUR",Nick_Names:"-",Minor_units:"Sentimo","Denominations_(Banknotes)":"₨ 25, ₨ 50, ₨ 100, ₨ 200, ₨ 500, ₨ 1000, and ₨ 2000",Motto:"Stella Clavisque Maris Indici",Identification_Feature:"On the left side of each denomination is a hand-engraved picture of a noteworthy person from the island of Mauritius.",Issuing_Bank:"Bank of Mauritius",In_Circulation_Since:"1967",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Since 1994, the Bank of Mauritius has used a method known as a \"filthy float\" to determine the value of one MUR in relation to the values of other currencies. In times of market unpredictability, the Bank of Mauritius will step into the foreign currency markets to protect the country's reserves by regulating the exchange rate and maintaining the value of the mauritian dollar. This is done by intervening in the markets themselves.\n\n &nbsp; \n\nIn 1820, the United Kingdom produced the Mauritius dollar in response to a request from the colony. Despite being tied to the value of the Spanish dollar, the Mauritius dollar circulated in parallel with the Indian rupee (INR) and the British pound. In the middle of the 1800s, when there was a flood of Indian immigrants to Mauritius, a lot of Indian rupees flowed into the country. This is because the number of Indian immigrants was at an all-time high. As a direct result of this migration, the Indian rupee, the Mauritius dollar, and the British pound (GBP) were all removed from circulation and replaced with the Mauritian Rupee in the year 1877.\n\n &nbsp; \n\nIn 1934, the government of India decided to peg the value of the Indian rupee to the value of the British pound by devaluing the rupee and setting the exchange rate at 13.3 MUR to 1 GBP. Late in 1967, the Board of Commissioners of Currency was supplanted by the Bank of Mauritius as part of preparations for the country's eventual independence from Britain. In 1972, the government decided to ditch its pound sterling peg in favour of an exchange rate that tracked in a creeping band behind the value of the United States dollar (USD). 1979 was a difficult year for the economy of Mauritius as a result of a decline in global sugar prices and an increase in oil prices. In October of that year, an agreement was reached to devalue the rupee by 22.9%, which was a requirement for receiving the loan from the IMF.\n\n &nbsp; \n\nIn 1982, the central bank decided to re-peg the currency to a basket of currencies that were together intended to reflect the country's most significant trading partners.\n\n &nbsp; \n\nAs a direct result of the greater liberalisation of fiscal policy, the central bank decided to adopt the managed float method that it has been using since 1994."},countries_accepting:{desc_1:"The Mauritian rupee is the legal tender and official currency of Mauritius and is used exclusively by the citizens of this country for their transactions.",list:[],desc_2:""},amount_for_trip:{desc:"When creating a budget for travelling in Mauritius, there are a lot of moving aspects to take into consideration, such as where you want to go, how you want to stay, and what you want to buy. Because of this, it can be difficult to develop a budget that is both reasonable and adaptable to changing circumstances. A visitor on a limited budget might easily spend more than Rs 3207 in one day's worth of expenses in Mauritius. For costly wants like private transportation, gourmet dinners, and stays at five-star hotels, it is possible that a daily budget of more than Rs 6414 will be required to meet the costs. It is possible that you will spend up to Rs 13363 on a vacation for two people to a popular location.\n\n &nbsp; \n\nThe cost of a single night's stay in a hotel room in Mauritius will normally range anywhere from Rs 1,122 per person per day to Rs 2,672 per person per day. Your daily transportation costs could run anywhere from Rs 267 to Rs 801 if you walk, take the bus, or hire a cab, depending on whatever mode of transportation you choose."},identification:{list:["The security threads used in an authentic note are infamously difficult to manufacture without the assistance of expensive and specialised equipment. These are included in the paper while the banknote is still in the process of being made from raw cellulose. Also, the foil that is used to generate the diving threads may often be seen glinting on the face sides of banknotes. This is done in order to deter counterfeiters. If you hold these threads up to the light, you should be able to read the writing that is included in them.","Watermarks, which can only be seen when the paper currency is held up to the light, is one of the most widespread and well-known forms of security features that can be used to check an authentic Mauritian rupee.","The text on some areas of a banknote is extremely small, and you will need a magnifying glass to be able to read it. Even though the sizes of the texts vary slightly, it is not difficult to read any of them. On the other hand, a fake note will have blurred content.","The intaglio printing enables around sixty layers of paint to be applied to the same area on the note using an amount of pressure that is equivalent to sixty tonnes of weight. This provides the letters (or drawings) with a three-dimensional quality that can be felt through the act of touching them. In addition to this, the paint is applied in such a thick layer that it is very hard to scratch.","When subjected to UV light, the Mauritian rupees exhibit a luminosity that is both interesting and unique. It is possible to find paints that, when subjected to these rays, will create a glow that will show images that cannot be seen by the human eye.","In addition, when exposed to UV light, the colour of the paper used for banknotes changes significantly."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Mauritian Rupee**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Mauritian Rupee to USD** or **INR to Mauritian Rupee**, you only need to follow the below-written steps:"}}},{id:28,internalName:"seo_currency_page_danish-krone",type:"seo_currency_page_danish-krone",data:{name:"Danish Krone",code:"DKK",country_code:"DK",travel_country:"Denmark",keywords:"krone, danish krone,  krone currency, where to buy danish krone, value of danish krone, danish krone symbol, danish krone currency, krone to inr, danish krone to usd, danish krone to euro,exchange rate, currency exchange, Buy, Sell, forex cards Live krone rate, krone price",about:{title_text:"The Currency of Denmark",desc:"Since it was initially issued on January 1, 1875, people of Denmark, Greenland, and the Faroe Islands have used the krone as their primary currency. The Danish krone is abbreviated as This currency is pegged to the euro at a rate of 7.46 and must remain within a band of 2.25 percent around that level. Denmark continues to use its own currency in spite of the fact that it is a member state of the European Union. The Danish krone symbol is kr.\n\n &nbsp; \n\nThe current rate of Krone is INR (`inr_exchange_rate`) . You can keep an eye on the **live krone rate** for getting the exact **Krone pric**e."},quick_facts:{facts:{Country_of_Origin:"Denmark",Symbol:"Kr.",Currency_Code:"DKK",Nick_Names:"The Danish crown",Minor_units:"øre","Denominations_(Banknotes)":"50, 100, 200, 500, 1000 kroner",Motto:"-",Identification_Feature:"When it comes to 1000 kroner, they boast the image of Anna & Michael Ancher on the obverse side as well as a Tournament scene and Bislev Church on the reverse side.",Issuing_Bank:"Danmarks Nationalbank",In_Circulation_Since:"January 1, 1875",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The first krone was issued somewhere during the 1800s. The Danish monarch sponsored the creation of the Danish krone and gave the currency its name; the name literally translates to \"crown.\" In 1873, the rigsdaler was replaced by the new Danish krone, which came into circulation the same year. Prior to the start of World War I, the Monetary Union included the krone as one of its currencies. In 1914, the Union was dissolved, and the period of the gold standard came to an end. In 1924, Denmark decided to re-adopt the gold standard, but just four years later, they abandoned it again.\n\n &nbsp; \n\nBetween the years 1940 and 1945, the Danish krone and the German reichsmark were used interchangeably as a single currency. Following the end of World War II, one pound was equal to twenty-four krone. Following the implementation of the Brentwood system in 1949, the value of the krone decreased to 6.91 kr for every 1 dollar in American currency.\n\n &nbsp; \n\n1997 saw the introduction of a whole new series of banknotes. The first year the thematic coins were made accessible to the public was 2001, which was also the first year that they were produced. 2009 and 2011 saw the introduction of wholly original designs for banknotes.\n\n &nbsp; \n\nFrom it's all-time low in 2009 to it's all-time high in 2019, the Euro to Danish Krone exchange rate has ranged between 7.45 and 7.47, with the majority of those fluctuations occurring within that narrow band.\n\n &nbsp; \n\nBanknotes in the denominations of 50, 100, 200, 500, and 1,000 krona can currently be found in circulation. There are coins valued at ½ krone, 1 krone, 10 krone, and 20 krone.\n\n &nbsp; \n\nAfter making the decision in 2014 to outsource the printing of the currency, the National Bank of Denmark printed its final batch of Danish krone notes on December 20, 2016, marking the end of the bank's printing operations."},countries_accepting:{desc_1:"In addition to the krone being the official currency in Denmark, it is also used as a legal tender in Greenland and the Faroe Islands.",list:[],desc_2:""},amount_for_trip:{desc:"When calculating the cost of a vacation in Denmark, it is necessary to take a number of factors into account, including the location of the excursion, the mode of transportation, the housing, and the shopping. A visitor in Denmark could very well spend more than kr475 on a single day's worth of activities and entertainment. It is probable that a daily budget of more than kr2,600 will be necessary to fulfil the costs of lavish aspirations such as traveling in a private vehicle, indulging in gourmet meals, and staying in hotels that are rated five stars or higher. It is possible for the cost of travel for two people to reach between kr1,000 and kr6,000 when going to a popular place.\n\n &nbsp; \n\nAn overnight stay in a Danish hotel will set you back anything from kr205 to kr1,200 per person, on average. You may pay anything from kr80 to kr500 every day on your mode of transportation, depending on whether you opt to walk, use the bus, or call a cab."},identification:{list:["The window thread has been made more noticeable, making it the most straightforward method for recognising the new 500 krona banknotes. The red dotted line that was on the back of the bill with the bridge has been moved to the front of the bill where it can now be found.","The quickest and easiest way to determine whether or not a bill is genuine is to tilt it while holding it in your hand. In the upper right-hand corner of each banknote is a revolving image that changes colour. When the banknote is tilted, the image on the note and the figure that represents the denomination change from gold to green."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Danish Krone**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Danish Krone to USD, Danish krone to Euro** or **INR to Danish Krone**, you only need to follow the below-written steps:"}}},{id:29,internalName:"seo_currency_page_hong-kong-dollar",type:"seo_currency_page_hong-kong-dollar",data:{name:"Hong Kong Dollar",code:"HKD",country_code:"HK",travel_country:"Hong Kong",keywords:"Hong Kong dollar, hong kong dollar rate, hong kong dollar symbol, hong kong dollar price, hong kong dollar rate today,hong kong dollar to inr, hong kong dollar to HKD, exchange rate, currency exchange, Buy, Sell, forex cards Live hong kong dollar rate, hong kong dollar price",about:{title_text:"The Strong Currency of Hong Kong",desc:"Since its inaugural minting in 1863 by the British Empire, the **Hong Kong dollar** has served as the currency of Hong Kong, China's special administrative area. The local currency was reinstated after being taken out of circulation in the former British colony and is now used as legal cash. The unit of currency of the Hong **Kong dollar** is 100 cents.\n\n &nbsp; \n\nThe **Hong Kong dollar**, or HKD, was introduced as the official currency of Hong Kong in 1863. The **Hong Kong dollar symbol** is HK$ which is used to differentiate the **Hong Kong dollar** from other dollar-denominated currencies.\n\n &nbsp; \n\nThe **live Hong Kong Dollar rate** is INR (`inr_exchange_rate`) ."},quick_facts:{facts:{Country_of_Origin:"Hong Kong - China",Symbol:"$, HK$",Currency_Code:"HKD",Nick_Names:"Honkie",Minor_units:"Cent","Denominations_(Banknotes)":"10, 20, 50, 100, 500 and 1,000 dollars",Motto:"-",Identification_Feature:"The HK$1,000 notes are based on the theme of Skyline of Hong Kong.",Issuing_Bank:"HSBC, the Standard Chartered Bank and the Bank of China (Currency Notes), Hong Kong government (Coins)",In_Circulation_Since:"1863",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"When the United Kingdom sought to impose a pound-based system on Hong Kong (since the region was a British colony from 1841 to 1941 and a British overseas territory from 1941 to 1997), it failed. People in Hong Kong were hesitant to adopt the strategy, hence it was unsuccessful. So, in 1860, they opened the Hong Kong Mint and issued the first Hong Kong dollars. Beginning in 1863, production halted five years later due to Chinese disapproval of the coins' resemblance to those used by Mexico and Spain 50 years before.\n\n &nbsp; \n\nHong Kong's government formally adopted the usage of the British trade dollar as the city's official currency. A number of British Empire colonies began printing their own money in 1906. Around 1935, Hong Kong and China saw a significant increase in the outflow of silver dollars.\n\n &nbsp; \n\nAfter the Second World War, when Japan conquered Hong Kong, the Japanese yen became the official currency. However, the yen was eventually devalued and replaced by the **Hong Kong dollar**, which was then pegged to the U.S. dollar in 1972.\n\n &nbsp; \n\nIn addition to the lower guaranteed limit, on May 18, 2005, the higher guaranteed limit for the Hong Kong dollar was set at HK$7.75 to the US dollar. This was in addition to the lower guaranteed limit. This modification, as stated by the Hong Kong Monetary Authority, was carried out with the intention of bringing Hong Kong's interest rates closer to those of Hong Kong.\n\n &nbsp; \n\nThe **Hong Kong dollar** is not a floating currency despite being the ninth most traded currency in the world. It has a fixed, restricted range of exchange rates relative to the US dollar."},countries_accepting:{desc_1:"The **Hong Kong dollar** is the official currency of Hong Kong, and it is used by the citizens of Hong Kong for carrying out everyday financial activities.",list:[],desc_2:""},amount_for_trip:{desc:"The total price of your vacation to Hong Kong will be influenced by a number of variables, including where you stay, how often you eat out, and how often you take public transit. Spend an average of HK$500 every day on your trip and you'll have enough money left over to buy souvenirs and explore new places. When you factor in the expense of private transportation, meals prepared by Michelin-starred chefs, and stays in five-star hotels, the daily cost of a luxury trip can easily exceed HK$2,706. Depending on where you go and what you do while on vacation, the total cost for you and your companion might be anything from HK$1,000 to HK$6,000.\n\n &nbsp; \n\nHong Kong hotel rooms can cost anything from HK$200 to HK$1,200 per person per night, with the exact cost depending on the room's location, size, and amenities. This seems like a fair estimate of the annual amount in question. Your daily transportation charges may run you anywhere from HK$20 to HK$175, depending on whether you walk, ride the bus, or hail a taxi. The situation would be greatly affected by the mode of transportation you use.\n\n &nbsp; \n\nYou can check out the **Hong Kong dollar rate today** in order to enjoy a cost-saving vacation as per the **Hong Kong dollar price.**"},identification:{list:["Large and tiny rings on the metallic thread shift position as the authentic note is tilted at different angles.","The real note has a distinct embossed texture due to the raised printing.","The denomination number is buried in the background but can be revealed when the real note is angled slightly under a bright light.","When held up to the light, details like the bauhinia's flower, leaves, bud, and denomination number emerge in an authentic note.","If you hold a real note up to a UV light source, the front and back designs, which are monochromatic under regular illumination, will glow in two different fluorescent hues. When held up to the light, the denomination number is formed by the intersection of the patterns on the front and back of the note."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Hong Kong dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Hong Kong dollar to USD, Hong Kong Dollar to HKD** or **INR to Hong Kong dollar**, you only need to follow the below-written steps:"}}},{id:30,internalName:"seo_currency_page_swiss-franc",type:"seo_currency_page_swiss-franc",data:{name:"Swiss Franc",code:"CHF",country_code:"CH",travel_country:"Switzerland",keywords:"Swiss-franc, swiss franc symbol, swiss franc rate, swiss franc currency, swiss franc rate today, swiss franc coins, swiss franc to inr, swiss franc to CHF, swiss franc to euro, exchange rate, currency exchange, Buy, Sell, forex cards, Live swiss franc rate, swiss franc price",about:{title_text:"The Legal Tender of Switzerland",desc:"The Swiss franc serves as the nation's primary currency and medium of trade, not only in Switzerland but also in Liechtenstein. The Swiss National Bank and the Swiss Mint are responsible for the production of banknotes and **Swiss franc coins**, respectively, in Switzerland. The **Swiss franc symbol** is SFr in addition to CHF and Fr. CHF is held by many governments and financial institutions as a protection against market and investment risk.\n\n &nbsp; \n\nBanknotes denominated in Swiss francs are printed by the Swiss National Bank (SNB) and exist in the following denominations: 10, 20, 50, 100, 200, and 1,000. The Swiss franc is divisible into 100 smaller units named Rappen (Rp. ), centime (c. ), centesimo (ct. ), and rap (rp. ), each of which is the name for one-hundredth of a franc in German, French, Italian, and Romansh, respectively. 5 centimes, 10 centimes, 20 centimes, ½ franc, 1 franc, 2 franc and 5-franc coins are all minted by the Swiss federal mint, Swissmint.\n\n &nbsp; \n\nThe **live Swiss Franc rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Swiss Franc price**."},quick_facts:{facts:{Country_of_Origin:"Switzerland",Symbol:"$",Currency_Code:"CHF",Nick_Names:"Swissie",Minor_units:"Rappen (German), centime (French), centesimo (Italian) or rap (Romansh)","Denominations_(Banknotes)":"10, 20, 50, 100, 200 and 1000 francs",Motto:"-",Identification_Feature:"The 1000 francs notes feature the image of Jacob Burckhardt on the obverse side.",Issuing_Bank:"Swiss National Bank, Swissmint",In_Circulation_Since:"May 1850",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The franc was established in 1798 and used until 1803 alongside other foreign currencies; by 1803 there were over 8,000 distinct types of coins and banknotes in circulation. The Swiss federal government assumed responsibility for minting legal tender in 1848.\n\n &nbsp; \n\nAs of 1850, the Federal Coinage Act established the Swiss franc as the country's official currency, pegged to the French franc. In 1865, Switzerland and four other countries (France, Italy, Switzerland, and Belgium) formed the Latin Monetary Union, in which they formally committed to staying on the gold standard until the year 2000.\n\n &nbsp; \n\nThe Swiss National Bank unexpectedly lifted its peg on the Euro and allowed the currency to float in 2015, triggering a widespread sell-off that wiped away the wealth of some individuals and companies."},countries_accepting:{desc_1:"Switzerland has 26 territories and 4 official languages (German, Italian, French, and Romansh). The Swiss franc is a symbol of national solidarity. The Federal Constitution of Switzerland from 1848 states that the Federal Government is the exclusive issuer of the CHF currency.",list:["CH","LI"],desc_2:""},amount_for_trip:{desc:"The overall price of your vacation to Switzerland will be determined by a wide variety of aspects, including how lavish your accommodation is, the number of times you dine in restaurants, and the amount of time you spend travelling by public transit. During your trip, you can have everything you desire for an average daily cost of approximately Sfr90. A luxury trip might easily cost more than Sfr600 per day if you choose to indulge in activities and amenities such as private transportation, meals prepared by Michelin-starred chefs, and accommodations in five-star hotels. It is possible that the entire cost of a vacation for you and your significant other might range anywhere from Sfr200 to Sfr1,300, depending on the activities that you and your partner decide to indulge in during your time away.\n\n &nbsp; \n\nThe price of a room at a Swiss hotel can range anywhere from Sfr60 to Sfr300 per person per night depending on the room's amenities. Your daily transportation costs could run anywhere from Sfr15 to Sfr70, depending on whether you opt to walk, ride the bus, or hail a taxi. Your mode of transportation would have a considerable bearing on this situation.\n\n &nbsp; \n\nYou can check out the **Swiss Franc rate today** for planning your journey."},identification:{list:["Touching the note's edges will reveal distinct raised lines. The authentic 100-franc note features four sections of these raised lines for the sense of touch.","Under UV light, the globe will stand out vividly while the rest of the authentic note will appear muted in comparison.","A magnifying glass will reveal the micro lettering on the Swiss flag. There are sections with black writing on a white backdrop and others with white text on a black background.","Put the bill under ultraviolet light and you'll notice tiny specks of colour all over the bill.","Take a look at the authentic note with an infrared lens, and you'll see that its appearance shifts, with some details becoming monochromatic and others disappearing entirely.","If you hold the authentic note up to the light, you can see the Swiss cross perforations very clearly. The cross consists of squares with equal distances between them.","When you rock the real note from left to right, a violet arc sweeps across the planet. Now, turn the note around so that the globe is facing away from you; the colour will shift."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Swiss Franc**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Swiss Franc to Euro, Swiss Franc to CHF** or **INR to Swiss Franc**, you only need to follow the below-written steps:"}}},{id:31,internalName:"seo_currency_page_south-korean-won",type:"seo_currency_page_south-korean-won",data:{name:"Korean Won",code:"KRW",country_code:"KR",travel_country:"South Korea",keywords:"south korean won,  buy south korean won , currency converter south korean won, south korean won currency symbol, south korean won exchange rate history, south korean won value in india, south korean won sign, south korean won to inr, korean won to usd, exchange rate, currecy exchange, Buy, Sell, forex cards, Live korean won rate, korean won price",about:{title_text:"The Currency of South Korea",desc:"Korean Won is the official currency of South Korea. The jeon, equivalent to one hundred won, is the lowest currency value that can be obtained in South Korea. The won can be traded for any other currency in the globe at any time, including the U.S. dollar, the Japanese yen, and the European Union euro (EUR). Throughout the course of the last century, the won has undergone a series of transformations and adjustments in order to counteract the impacts of devaluations as well as the consequences of war. In recent years, the won has established itself as a reliable and extensively traded currency thanks in large part to South Korea's expansive and highly developed economy. The **South Korean won currency symbol** is ₩**.**\n\n &nbsp; \n\nThe **live Korean Won rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Korean Won price**."},quick_facts:{facts:{Country_of_Origin:"South Korea",Symbol:"₩",Currency_Code:"KRW",Nick_Names:"-",Minor_units:"Jeon","Denominations_(Banknotes)":"₩1,000, ₩2,000, ₩5,000, ₩10,000 and ₩50,000",Motto:"-",Identification_Feature:"On the note worth 5,000 won is a portrait of Yi I, while on the note worth 10,000 won is a portrait of King Sejong.",Issuing_Bank:"Bank of Korea",In_Circulation_Since:"August 16, 1966",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Let’s learn about the **South Korean won exchange rate history**. The won has served as the standard unit of currency for the Korean people for literally thousands of years. During the period of Japanese colonial rule over the country from 1910 until 1945, the won was temporarily substituted for the Korean yen, a currency used by the Japanese.\n\n &nbsp; \n\nThe Korean won was initially pegged at a rate of 15 won to 1 dollar, but due to the economic toll of the Korean War, the won was subsequently devalued multiple times.\n\n &nbsp; \n\nIn the 1980s, South Korea moved away from having its currency pegged to the dollar in favour of using a basket of currencies. This was done in the hopes of increasing the value of its currency in international trade. In addition, as a response to the Asian Financial Crisis, the government devalued the won and allowed it to float freely on foreign exchange markets. This action resulted in additional changes being implemented in the late 1990s.\n\n &nbsp; \n\nThe Bank of Joseon did not issue its first paper money until 1946 when it did so in denominations of 10 and 100 won. The Bank of Korea now prints banknotes ranging in value from 1,000 won to 50,000 won. These banknotes can be found in circulation. The **South Korean won sign** is ₩."},countries_accepting:{desc_1:"The “North Korean won” and the “South Korean won” are two different currencies that both North and South Korea use, despite the fact that they both use the term “Korean won”. In this article, we are talking about the **Korean Won** which is South Korea's official currency and is accepted everywhere in the country.",list:[],desc_2:""},amount_for_trip:{desc:"It is reasonable for vacationers to anticipate spending anywhere from ₩46,655 to ₩300,559 per person, per day while exploring South Korea. However, if there are two of you travelling, you should anticipate spending between ₩1,00,000 and ₩6,00,000.\n\n &nbsp; \n\nWhen it comes to lodging, travellers can anticipate spending somewhere around ₩21,996 per person, per night, while those on a more lavish holiday could anticipate spending upwards of ₩1,22,862 per person, per night. Depending on whether you take taxis or buses to explore this charming country, the cost of your commute will range anywhere from ₩6,173 to ₩52,782.\n\n &nbsp; \n\nYou can check the **Korean Won rate today** in order to plan a cost-effective vacation. You can make use of **currency converter South Korean won** to get an idea of how much money you’ll need to convert. You can also keep an eye on **South Korean won to INR** exchange rate."},identification:{list:["When the note is tilted in a particular direction, each one of the images (map of Korea, Taegeuk and the four trigrams) will become visible.",'When it comes to the 50,000 won note, on the strip, the denomination “50000” is printed in the vertical centre, in between each group of images that is displayed in a different order. The words "BANK OF KOREA 50,000" are printed in a vertical format on the top and bottom left-hand corners of the holographic strip.',"The hologram on bills of 10,000 won has a square shape, whilst the one on bills worth 5,000 won has a round shape.","The note worth 50,000 won is easily identifiable because of the distinctive blue and grey film that features a variety of Taegeuk designs. When the pitch of the note is raised or lowered, the patterns of Taeguek change to the left and right, and when the note is tilted to the left or right, the patterns shift upwards and downwards. You may be able to see the movement of the Taegeuk patterns more clearly on the note if you hold it up to the light.","When read from left to right, the digits (numbers and letters) that make up the serial number get progressively larger. This occurs as you move from the beginning to the end of the number. The serial numbers on the 10,000 won bill, the 5,000 won bill, and the 1,000 won bill all use a font with the same size and weight.",'The number "50000" that appears in magenta at the upper right on the reverse of the note will transform into a green number when the note is tilted, and vice versa. The face value numerals on the 10,000 won note, the 5,000 won note, and the 1,000 won note will all change from gold to green when the notes are tilted, while the face value number on the 1,000 won note will move from green to blue.','When the note is held horizontally and tilted at eye level, a pentagon containing the value "5" that is printed intaglio becomes visible within the pentagon of a 50,000 won note. There is no difference between the intaglio latent images that are located at the bottom of the obverses of the 10,000 won, 5,000 won, and 1,000 won notes. These bills can be tilted in just the right way for you to make out the letters "WON" that are hidden somewhere on them.']},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Korean Won**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Korean Won to USD** or **INR to Korean Won**, you only need to follow the below-written steps:"}}},{id:32,internalName:"seo_currency_page_norwegian-krone",type:"seo_currency_page_norwegian-krone",data:{name:"Norwegian Krone",code:"NOK",country_code:"NO",travel_country:"Norway",keywords:"norwegian krone,  convert norwegian krone, denominations of norwegian krone, norwegian krone exchange rate history, norwegian krone chart, best rate for norwegian krone, norwegian krone exchange rate today, norwegian krone notes, norwegian krone to inr, norwegian krone to usd,exchange rate, currecy exchange, Buy, Sell, forex cards, Live norwegian krone rate, norwegian krone price",about:{title_text:"The Currency of Norway",desc:'The official unit of currency in the Kingdom of Norway is known as the krone (sometimes written as kroner). Historically and commonly, it is referred to in English as the Norwegian crown. Formally, it was divided into 100 re, but as of 2012, re coins were no longer in circulation and could not be used. The Norges Bank, which is the central bank of Norway, is responsible for overseeing the currency\'s value and ensuring that it is widely used. Since 1875, the Norwegian krone has served as the country\'s primary unit of currency. The Norwegian krone is denoted by the letter "kr," whereas the currency code "NOK" is the abbreviation for the currency. There are coins with values of one, five, ten, and twenty krone, as well as bills with values of fifty, one hundred, two hundred, five hundred, and one thousand krone.\n\n &nbsp; \n\nThe **live Norwegian Krone rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Norwegian Krone price** as per the **Norwegian krone chart**.'},quick_facts:{facts:{Country_of_Origin:"Norway",Symbol:"kr",Currency_Code:"NOK",Nick_Names:"-",Minor_units:"øre","Denominations_(Banknotes)":"50, 100, 200, 500 and 1,000 kroner",Motto:"ALT FOR NORGE (All for Norway)",Identification_Feature:"The 1000 kr note portrays wave in the sea on the obverse side",Issuing_Bank:"Norges Bank",In_Circulation_Since:"1875",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Let’s learn more about this currency and **Norwegian krone exchange rate history**. After the speciedaler was taken out of circulation, the krone was put into use as the primary currency. Back in those days, one speciedaler could be purchased for a total of four kroner. After the shift, Norway became a member of the Scandinavian Monetary Union, which was a monetary union that existed right up until the beginning of World War I.\n\n &nbsp; \n\nDuring the time of the Union, the Norwegian krone was a gold-backed currency; this status lasted until 1931 when it was replaced by a peg to the British pound.\n\n &nbsp; \n\nIn the year 1877, the Norges Bank issued paper currency in the following **denominations of Norwegian krone**: 5, 10, 50, 100, 500, and 1000 kroner. Banknotes costing 1 krone were issued for circulation beginning in 1917, whereas those worth 2 kroner did not enter circulation until 1918 and remained in circulation until 1922.\n\n &nbsp; \n\nThe demonetisation of the five krone notes occurred in 1963, while the demonetisation of the ten krone notes occurred in 1984. The value of one Norwegian krone was first fixed in relation to one United States dollar in 1939; however, when Germany occupied Norway during World War II, the value of one Norwegian krone was fixed in relation to one Reichsmark. In 1971, the Norwegian krone was decoupled from the dollar and allowed to float freely on the market. Subsequently, it was pegged to a currency basket.\n\n &nbsp; \n\nIn 1992, the central bank did away with the practice of maintaining a constant exchange rate, instead allowing the value of the currency to fluctuate according to the exchange rate at which it was traded in relation to other currencies."},countries_accepting:{desc_1:"The **Norwegian Krone** is the only currency that can be used for purchasing goods and services in Norway because it is the country's sole legal tender.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of money you on flights to Norway, staying there, and dining, while you're there, will all have an impact on the budget you set aside for your vacation. To meet the normal costs of a trip to Norway, visitors on a limited budget should set aside close to kr444 per day in spending money in order to prepare for their vacation adequately. When you factor in the cost of private transportation, meals at high-end restaurants and staying in top-rated properties, the average daily cost of a luxury vacation can easily approach kr2,300. Between kr1,000 and kr4,000 is what you can expect to spend on a holiday in Norway for two people on average.\n\n &nbsp; \n\nPrices for a night's stay in a Norway hotel can range anywhere from kr220 to kr1,176 per individual, depending on the hotel. If you take the bus wherever you go or pay for pricey taxi rides, the amount that you spend on transportation on a daily basis could range anywhere from kr65 to kr436 depending on which option you choose.\n\n &nbsp; \n\nYou can check the **Norwegian krone exchange rate today** in order to plan a cost-effective vacation."},identification:{list:["A ring is incorporated within the rectangle that can be found in the bottom left corner of the note. When rotated in a variety of directions, the ring gives the impression that it is floating, and a parade of colours runs across the face of the banknote. In addition to that, the denomination of the currency is shown.","On the right side of the bill, there is a print of three links of an anchor chain embedded into the paper. Altering the note's angle gives the impression that the chain is moving about. Every note, with the exception of the 50-krone note, features an anchor chain.","When the note is held up to the light, a watermark that depicts the head of a puffin flying over the Atlantic Ocean as well as the denomination can be seen. The design of an Atlantic puffin can be found on each denomination.","When held up to the light, a dark line will appear on banknotes that include security threads.","There is a design on banknotes that is iridescent and printed in two colours, but it can only be seen when the note is tilted at a certain angle. On the note for 100 krone, a globe can be seen, while on the note worth 200 krone, a seamark can be seen. Additionally, the component can be found in the bottom right corner of the banknote, where it is printed in the primary colour of the denomination.","When examined with UV light, certain previously concealed design elements of the banknote are brought into view. On this coin, there is a representation of an Atlantic puffin in addition to the denominational value.","It is necessary to use a magnifying lens in order to read certain areas of the banknote because the numerals and text are quite small."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Norwegian Krone**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Norwegian Krone to USD** or **INR to Norwegian Krone**, you only need to follow the below-written steps:"}}},{id:33,internalName:"seo_currency_page_qatari-riyal",type:"seo_currency_page_qatari-riyal",data:{name:"Qatari Riyal",code:"QAR",country_code:"QA",travel_country:"Qatar",keywords:"qatari riyal, qatari riyal today, buy qatari riyal online, qatari riyal symbol, qatari riyal history, riyal to inr, usd to qatari riyal, qatari riyal to usd, euro to qatari riyal, rate of qatari riyal today,exchange rate, currecy exchange, Buy, Sell, forex cards, Live Qatari Riyal rate, Qatari Riyal price",about:{title_text:"The Currency of Qatar",desc:"The Qatari Riyal (QAR) is the country's official currency, and it is used by the State of Qatar, which is located on the southwestern coast of the Arabian Peninsula. The sign for this currency in English is ‘QR’. It is the responsibility of the Central Bank of Qatar to issue all of the coins and paper currency that are in circulation within the nation of Qatar. In Qatar, the following denominations of currency are legal tender: 1, 5, 10, 50, 100, and 500 rial bills. The following denominations of coins are available: 1, 5, 10, 25, and 50 Qatari Riyal pieces. The **Qatari riyal symbol** is QR and ر.ق.\n\n &nbsp; \n\nThe **live Qatari Riyal rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Qatari Riyal price**."},quick_facts:{facts:{Country_of_Origin:"Qatar",Symbol:"QR and ر.ق",Currency_Code:"QAR",Nick_Names:"-",Minor_units:"Dirham","Denominations_(Banknotes)":"QR 1, QR 5, QR 10, QR 22, QR 50, QR 100, QR 200 and QR 500",Motto:"-",Identification_Feature:"The front of each bill from the 5th series features the same design elements, including geometric patterns, the Qatari flag, native plants and animals, and a gate that is reminiscent of Qatar's architectural history.",Issuing_Bank:"Qatar Central Bank",In_Circulation_Since:"May 19, 1973",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Let’s learn about **Qatari riyal history**. On May 19, 1973, Dubai was accepted into Qatar, and a few years later, on May 19, 1973, Qatar began issuing its own currency, known as the Qatari Riyal. Both the new and the old notes were in circulation concurrently for a period of ninety days until the old notes were taken out of circulation.\n\n &nbsp; \n\nAfter the Indian government devalued its currency in 1966, the rial of Qatar and Dubai eventually took its place as the dominant currency in those two countries. A rial (QAR) to the dollar exchange rate of 3.64 rials (QAR) has been established as the standard (USD). In 2001, the peg was made into official law by a royal decree. It is permitted to exchange rial for dollars at a rate ranging from 3.6385 to 3.6415 rial per dollar.\n\n &nbsp; \n\nDue to the fact that Qatar's currency, the rial, is tied to the dollar, the country's economy is shielded from the effects of swings in the pricing of global commodities, which are expressed in dollars. The great majority of Qatar's Gross Domestic Product (GDP) comes from its petroleum and natural gas industry (GDP).\n\n &nbsp; \n\nThe Qatar Monetary Agency began issuing new banknotes on May 19, 1973, in denominations of 1, 5, 10, 100, and 500 rials. In 1976, a note for 50 rials was introduced. The Central Bank of Qatar was officially established on August 5, 1973.\n\n &nbsp; \n\nThe Central Bank of Qatar released the fifth series of banknotes on December 13, 2020, marking the beginning of the series' circulation. This series includes the 200 rial note as one of its denominations."},countries_accepting:{desc_1:"In order to make a purchase in the country of Qatar, you must use the local currency, which is the Qatari Riyal.",list:[],desc_2:""},amount_for_trip:{desc:"When planning a trip to Qatar, there are several aspects to think about, including how much the flight will cost, how much your accommodation options will cost, how much it will cost to get around, and what you can eat while you're there.\n\n &nbsp; \n\nAn average traveller requires QAR280 to have a pleasant trip on a tight budget. Spending up to QAR1,206 may be necessary if you plan on dining at Michelin-starred restaurants and staying at posh hotels. A trip to Qatar for two persons might cost anything from QAR500 to QAR2,500. Daily lodging in Qatar can cost anything from QAR151 to QAR681. Meanwhile, depending on whether you use a cab, a bus, or any other mode of transportation, the total cost of your trip might be anywhere from QAR30 to QAR129.\n\n &nbsp; \n\nYou can check the **rate of Qatari riyal today** in order to plan a cost-effective vacation."},identification:{list:["The value of each security thread is presented in a manner that is unmistakable regardless of the denominator.","The printed numbers and horizontal lines have been raised so that they are easier to see for people who are blind or have other visual impairments.","You need to hold the banknote up to the light and wait for the incomplete shapes on both sides to come together before you can find out how much it's worth.","Hold the bill up to the light in order to see the crest of the State of Qatar and the denomination numerals that are printed as a watermark on the currency. When the bill is rotated in different directions, different visual effects caused by the hologram can be seen.","Tilt the bill and watch as the look of the security thread changes from different angles.","If you tilt an authentic bill, the Dreama flower on the gate will change colours, and a light circle will move inside the flower."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Qatari Riyal**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Qatari Riyal to USD, USD to Qatari Riyal, Euro to Qatari Riyal** or **INR to Qatari Riyal**, you only need to follow the below-written steps:"}}},{id:34,internalName:"seo_currency_page_russian-ruble",type:"seo_currency_page_russian-ruble",data:{name:"Russian Ruble",code:"RUB",country_code:"RU",travel_country:"Russia",keywords:"russian ruble,russian ruble symbol, russian ruble price, russian ruble chart, russian ruble currency, russian ruble rate, russian ruble value, russian ruble coin, russian ruble banknotes, russian ruble news, russian ruble devaluation, russian ruble images,russian ruble to inr, russian ruble to usd,exchange rate, currecy exchange, Buy, Sell, forex cards, Live russian ruble rate, russian ruble price",about:{title_text:"The Currency of Russian Federation",desc:"The Russian national currency is the ruble, which may alternatively be spelt as the rouble. One ruble is equal to one hundred kopecks. In September 1993, the first Russian ruble was issued as a straight replacement for the Soviet ruble. Following the pound sterling as the second-oldest currency that is still in circulation today is the ruble. As a result of the fact that Russia is one of the main exporters of oil and natural gas in the world, the value of the ruble tends to rise and decrease in unison with the price of oil on the global market. In the winter of 2021, the Bank of Russia began conducting tests on a digital ruble prototype in order to prepare for its eventual introduction. The **Russian ruble symbol** is ₽.\n\n &nbsp; \n\nThe **live Russian Ruble rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Russian Ruble price** as per the **Russian ruble news**."},quick_facts:{facts:{Country_of_Origin:"Russia",Symbol:"₽",Currency_Code:"RUB",Nick_Names:"Som/sum and manat",Minor_units:"Kopeyka","Denominations_(Banknotes)":"5₽, 10₽, 50₽, 100₽, 200₽, 500₽, 1,000₽, 2,000₽ and 5,000₽",Motto:"-",Identification_Feature:"500 rubles show a statue of Peter I, while 1,000 rubles have a statue of Yaroslav.",Issuing_Bank:"Bank of Russia",In_Circulation_Since:"August 17, 1998",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"When the Soviet Union ceased to exist in 1991, the Russian Federation continued to utilise the Soviet ruble as its currency. The Bank of Russia issued a new set of coins in 1992, and in 1993, it printed new banknotes. Both sets of **Russian ruble coin** can be found in circulation today.\n\n &nbsp; \n\nThe exchange rate of the ruble versus the United States dollar saw a significant **Russian ruble devaluation** between July 1992, when one US dollar was equivalent to 125 RUR, and July 1998, when one US dollar was equivalent to 6,000 RUR as a result of redenomination. Since its inception in the 13th century, the ruble (RUB) has gone through a number of transformations before arriving at its current form. These transformations have included a number of evaluations as well as devaluations.\n\n &nbsp; \n\nThe most recent instances of this happening were just before the fall of the Soviet Union in 1992 and again during the redenomination in 1998. The value of the ruble was reassessed in 1998, and at that time, one new ruble was equivalent to 1,000 old rubles.\n\n &nbsp; \n\nAs a result of the widespread collapse in the price of oil, the value of the ruble plummeted dramatically in the second half of 2014, falling by more than fifty per cent in comparison to the dollar. The United States and the European Union imposed economic and financial sanctions against Russia in July 2014 as a response to Russia's invasion of Ukraine. These sanctions were a direct consequence of Russia's invasion of Ukraine. At the end of April 2017, the National Bank of Ukraine issued an order that made it illegal for any Ukrainian bank or other financial institution to circulate Russian banknotes that featured images of Crimea, a region of Ukraine that Russia has occupied since 2014.\n\n &nbsp; \n\nSince the dissolution of the Soviet Union in 1991, banknotes and coins minted in Russia under the ruble currency have become noteworthy for their lack of images on the obverse side of the note or coin. This was the situation even throughout the time of the Tsars and the Communists who ruled the country. The lack of immediately recognisable faces on the currency has been slightly alleviated by the issuance of two new banknotes: one for 500 rubles showing a statue of Peter I, and another for 1,000 rubles having a statue of Yaroslav."},countries_accepting:{desc_1:'As of the year 2022, there are three distinct currencies with the name "ruble" in circulation around the world: the Belarusian rubel (BYN, Rbl) in Belarus, the Russian ruble (RUB,) in Russia, the Abkhazian and South Ossetian rubles in Georgia, and the Transnistrian rubla in the portion of Moldova that is under Russian control. In this article, we are talking about Russian Ruble being the only currency that can be used for any kind of transaction in the country of Russia.',list:[],desc_2:""},amount_for_trip:{desc:"If you are thinking of going on a trip to Russia, then there are a few things that you need to take into consideration, such as the expense of the flight, the accommodations available, the mode of transportation, and the kinds of food that are available in Russia.\n\n &nbsp; \n\nTo travel on a shoestring budget, a person requires, on average, ₽1,759 every day. On the other hand, if you prefer to stay in luxurious accommodations and savour delectable meals at upscale restaurants, then the total cost of your trip might reach up to ₽14,038. A vacation in Russia might cost anything from ₽3,500 to ₽30,000 for a couple travelling together to the country.\n\n &nbsp; \n\nIn Russia, the cost of staying in a hotel for each day can range anywhere from ₽865 to ₽5,587. Also, the price of transportation in this could range anywhere from ₽131 to ₽1,161, depending on whether you use a cab, a bus, or some other mode of transit.\n\n &nbsp; \n\nYou can check the **Russian Ruble rate today** via the **Russian Ruble chart** in order to plan a cost-effective vacation."},identification:{list:[" A fast approach to determine whether or not **Russian ruble banknotes** are authentic or counterfeit is to look for ink that shifts colour in the denominational information located on the bill.","The characteristic security feature known as a watermark can be found on genuine banknotes at all times.","When it comes to banknotes that have a recognisable face serving as their watermark, that face has to be an exact match for the one that is printed on the bill. Blurry **Russian ruble images** are a dead giveaway that the notes are counterfeit. Because counterfeiters can bleach lower denomination banknotes and reissue them with higher values, there is a possibility that the face and the watermark will not match.","On a banknote, if the borders, lettering, or writing are blurry, this is an obvious giveaway that the bill is counterfeit. Genuine banknotes are easily identifiable by the extremely tiny lines that are printed on them. Examine the bill very carefully, paying particular attention to the margins, to ensure that they have not become smudged in any way.","Genuine banknotes feature microprinting, which refers to writing that is written very delicately and can be found in a number of key areas on the notes. The presence of microprinting that cannot be read, even when viewed via a microscope, is a strong indication that the item in question is a fake.","The raised printing that may be found on real banknotes is notoriously difficult for counterfeiters to duplicate. It is possible to recognise raised printing on a banknote by slowly sliding a fingernail down the surface of the note. When you run your finger along the raised printing, your nail should give off a tiny vibrating sensation. If you don't feel anything rough about the bill, you should check it out again.","Because it offers a definitive method of identifying counterfeit money, ultraviolet light is utilised in the equipment and technology utilised in the detection of counterfeiting. The ultraviolet and fluorescent colours listed below can be found in the security thread of authentic banknotes.","On a bill, the serial number is the very last piece of information that needs to be validated. It is a forgery if the initial letter of the serial number does not correspond to the year that is printed on the bill. The list of years, in alphabetical order, is provided here, along with the letters that correlate to those years.","The Bank of Russia offers an app called Banknotes that allows users to verify the legitimacy of banknotes and gain insight into the security features they have."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Russian Ruble**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Russian Ruble to USD** or **INR to Russian Ruble**, you only need to follow the below-written steps:"}}},{id:35,internalName:"seo_currency_page_swedish-krona",type:"seo_currency_page_swedish-krona",data:{name:"Swedish Krona",code:"SEK",country_code:"SE",travel_country:"Sweden",keywords:"swedish krona, swedish krona currency, swedish krona rate today, swedish krona symbol, swedish krona in norway, swedish krona value, swedish krona chart, swedish krona exchange, swedish krona history, swedish krona value, best place to buy swedish krona,swedish krona to inr, swedish krona to usd, swedish krona to euro,exchange rate, currecy exchange, Buy, Sell, forex cards, Live swedish krona rate, swedish krona price",about:{title_text:"The Currency of Sweden",desc:'The Swedish krona is the country\'s official unit of currency. The ISO code "SEK" is used quite frequently, and it can appear either before or after the value; the **Swedish krona symbol** "kr" normally appears after the value. On the global foreign exchange (Forex) market, it is one of the currencies that sees the largest volume of daily trading activity. The Swedish riksdaler was Sweden\'s official currency until 1873 when it was replaced by the krona, which literally translates to "crown."\n\n &nbsp; \n\nThe **live Swedish Krona rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Swedish Krona price**.'},quick_facts:{facts:{Country_of_Origin:"Sweden",Symbol:"kr",Currency_Code:"SEK",Nick_Names:"Swedish crown",Minor_units:"öre","Denominations_(Banknotes)":"20 kr, 50 kr, 100 kr, 200 kr, 500 kr and 1000 kr",Motto:"-",Identification_Feature:"The 1,000 kronor features an obverse side with the images of following: Dag Hammarskjöld, United Nations Secretariat building, the flag of the United Nations and three crowns",Issuing_Bank:"Sveriges Riksbank",In_Circulation_Since:"1873",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Let’s learn about **Swedish Krona history**. The introduction of the krona in 1873 to replace the riksdaler was a direct consequence of the Scandinavian Monetary Union, which began in 1876 and continued until the beginning of World War I. This union lasted until 1914. The members of the union all utilised their respective versions of the krone as their currency. The Swedish krona and the Danish and Norwegian krone both have names that literally translate to \"crown.\"\n\n &nbsp; \n\nThe monetary practices of Sweden have a significant impact on the value of the country's currency, which is called the crown. The Sveriges Riksbank, which serves as both the country's and the world's central bank, is the oldest such institution in existence. Since 1992, when Sweden initially implemented a floating exchange rate for the SEK, the Sveriges Riksbank has only seldom intervened, allowing the currency to freely fluctuate against other foreign currencies. This policy has been in place ever since.\n\n &nbsp; \n\nSweden is one of the few member states of the European Union that has decided to keep its previous currency rather than adopt the euro. Despite the fact that the Treaty of Maastricht holds Sweden responsible for future conversion to the euro, a referendum in 2003 revealed that 56% of respondents were opposed to the new currency. Since then, the Swedish government has delayed joining by avoiding particular necessary monetary requirements that would mandate adoption."},countries_accepting:{desc_1:"The **Swedish Krona** is the legal tender in Sweden and is used as the sole currency for all kinds of transactions here. Also, keep an eye on **Swedish Krona in Norway** rates as well as other countries via the real-time **Swedish Krona chart**.",list:[],desc_2:""},amount_for_trip:{desc:"If you are thinking of taking a trip to Sweden for holiday, there are a few specifics that you need to keep in mind. These include the prices of flights and accommodations, as well as the many modes of public transportation and cuisines that are available in Sweden.\n\n &nbsp; \n\nWhen travelling on a limited budget, a person will need an average of kr494 each day. On the other hand, the total cost of your trip may go as high as kr2,827 if you chose to stay in luxurious accommodations and eat at upscale restaurants throughout your travels. The expense of a trip to Sweden for a couple might range anywhere from kr1,000 to kr7,000 on average.\n\n &nbsp; \n\nThe nightly rate of a hotel room in Sweden for 1 person can range anywhere from kr244 to kr1,320. Depending on whether you take a taxi, the bus, or some other type of public transportation, the cost of commuting in this area might range anywhere from kr67 to kr340.\n\n &nbsp; \n\nYou can check the **Swedish Krona rate today** in order to plan a cost-effective vacation. Let’s move on to learn about the **best place to buy Swedish Krona**."},identification:{list:["The watermark is visible on the bill when it is held up to the light at an angle.","You can experience the raised surface of the intaglio print on an authentic note by running your thumb over the paper or gently scraping it with your fingernail.","When held up to the light, the security thread becomes visible. The embedded thread is found within the paper used to make the currency.","There are micro texts printed on an authentic banknote. Although the texts are readable, you might find it helpful to use a magnifying glass. A counterfeit note generally has blurred text.","When UV light is shone on either side of the bill, it causes certain fibres in the bill to glow."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Swedish Krona**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Swedish Krona to USD, INR to Swedish Krona** or **Swedish Krona to Euro**, you only need to follow the below-written steps:"}}},{id:36,internalName:"seo_currency_page_brazilian-real",type:"seo_currency_page_brazilian-real",data:{name:"Brazilian Real",code:"BRL",country_code:"BR",travel_country:"Brazil",keywords:"brazilian real,brazilian real symbol, brazilian real currency code, brazilian real notes, brazilian real outlook, brazilian real currency symbol, buy brazilian real, brazilian real coins, brazilian real denominations, brazilian real history,brazilian real to inr, brazilian real to usd, brazilian real to euro.exchange rate, currecy exchange, Buy, Sell, forex cards, Live brazilian real rate, brazilian real price",about:{title_text:"The Currency of Brazil",desc:"Real is the official currency of Brazil. The Central Bank of Brazil is the entity responsible for printing the country's currency. The real was introduced in 1994 as a replacement for the cruzeiro real. In April 2019, the Brazilian real occupied the twenty-first spot on the list of most-traded currencies. BRL is the **Brazilian Real currency code** and can be denoted with this **Brazilian Real symbol**: R$. One real is equivalent to one hundred centavos.\n\n &nbsp; \n\nA variety of commemorative **Brazilian real coins**, such as a coin honouring the 2016 Summer Olympics with a face value of 1 real and a coin honouring the 50th anniversary of the Brazilian central bank with a face value of 5 real, have been released by the central bank.\n\n &nbsp; \n\nThe **live Brazilian Real rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Brazilian Real price**."},quick_facts:{facts:{Country_of_Origin:"Brazil",Symbol:"R$",Currency_Code:"BRL",Nick_Names:"Pila, Mango, Pau and Conto",Minor_units:"Centavo","Denominations_(Banknotes)":"R$2, R$5, R$10, R$20, R$50, R$100 and R$200",Motto:"-",Identification_Feature:"The 100 real notes have an image of The Republic's Effigy, portrayed as a bust, on the obverse side and the image of dusky grouper on the reverse side.",Issuing_Bank:"Central Bank of Brazil",In_Circulation_Since:"July 1994",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Let’s talk about **Brazilian real history**. The value of the Brazilian real is determined by a committee of the Central Bank of Brazil (BCB) that is in charge of monetary policy (COPOM). The **Brazilian real currency symbol** is R$.\n\n &nbsp; \n\nAt a rate of 1 real to 2,750 cruzeiro real, Brazilian real took its position as the country's official currency in July of 1994. The real has maintained a consistent value relative to the dollar since 1994 when its value was pegged to that of the dollar through a fixed exchange rate.\n\n &nbsp; \n\nAs a result of the fast-growing economy in the country, the value of the real swiftly increased after it was first introduced, eventually reaching a rate of 1 BRL to 1.20 USD. As a response, the government took action and linked the value of the currency to that of the US dollar in order to prevent a significant increase in the value of the currency. This condition remained right up to the Russian debt crisis of 1999.\n\n &nbsp; \n\nInvestors from other countries withdrew their capital from economies of emerging markets, including Brazil's, which had a negative impact on both economies. As a consequence of this, the value of the real as well as the currencies of other developing markets fell, which pushed COPOM to partially float the BRL in relation to the dollar.\n\n &nbsp; \n\nOn December 23, 2003, the 1-real coins that were first issued in 1994 and were only valid for that year were demonetized because they were so easy to fake. 1998 saw the launch of a second coin series for circulation. The 1 centavo, the 5 centavo, the 10 centavo, and the 25 centavo coins were all made of copper-plated steel, the 50 centavo coin was made of cupronickel, and the 1 real coin was made of brass and cupronickel. All of these coins were part of the currency system. However, as of the year 2002, steel was used for the production of coins worth 50 centavos and the centre portion of one real.\n\n &nbsp; \n\nIn November 2005, the Central Bank put an end to the production of one centavo coins; however, those that were already in circulation can still be used as payment. Retail establishments frequently round up prices to the nearest five or ten centavos these days."},countries_accepting:{desc_1:"In Brazil, the Brazilian real is the only currency accepted for any kind of transaction. You can keep an eye on **Brazilian Real outlook** if you are planning to visit the country.",list:[],desc_2:""},amount_for_trip:{desc:"When planning a trip to Brazil for holiday, it is critical to keep a few things in mind that will make the trip more enjoyable. You will need to make a budget in order to account for the many various expenses that you will incur while in Brazil. Some of these expenses will include the cost of eating out, lodging, and travelling throughout the country.\n\n &nbsp; \n\nIf you are travelling through Brazil on a very tight budget, you will need approximately R$129 for one day's worth of expenses. If you splurged on everything from your hotel room to your meals, the cost per day might easily reach or even surpass R$978, depending on how extravagant your vacation was. It is reasonable to anticipate that a trip to Brazil for two persons will require a total spending budget of anywhere between R$300 and R$2,000. A single night's stay at a hotel in Brazil can cost anywhere from R$63 all the way up to R$489, depending on the hotel and the room's amenities. It is possible that the amount of money it will cost you to move around the city will range anywhere from R$19 to R$137, but this will depend on whether or not you take a cab, a bus, or some other form of public transit.\n\n &nbsp; \n\nYou can check the **Brazilian Real rate today** in order to plan a cost-effective vacation."},identification:{list:["The face value of the note and an image of an animal in tones ranging from light to dark are both visible through the clear area of the note when it is held up to the light.","When a banknote is held horizontally at chest level in a well-lit room, the face value can be read in the shaded sections of the bill if the room is bright enough.","Examining the letter in the presence of a strong source of light will reveal the thread that was used to bind the paper together. Through the thread, it is possible to read the **Brazilian real denominations** as well as the word REAIS that is printed on the R$10, R$20, R$50, and R$100 bills; however, the R$200 note has no printing on the backside.","When the banknote is held up to the light, the front and back combine to generate a value number that is both complete and error-free.","The numerical values of the notes are displayed as an illuminated number in the area that has been tagged with UV light. The serial number on the note abruptly changes from red to yellow, and colourful fibres begin to sprout all over the front and back of the currency. The fibres in the R$200 note have red, light blue, and dark blue tones, while the R$2, R$5, R$10, R$20, R$50, and R$100 bills all have a violet tint to them."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Brazilian Real**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Brazilian Real to USD, INR to Brazilian Real** or **Brazilian Real to Euro**, you only need to follow the below-written steps:"}}},{id:37,internalName:"seo_currency_page_czech-koruna",type:"seo_currency_page_czech-koruna",data:{name:"Czech Koruna",code:"CZK",country_code:"CZ",travel_country:"Czech Republic",keywords:"czech koruna, best way to get czech koruna, buy czech koruna, currency exchange czech koruna, best place to buy czech koruna, best exchange rate czech koruna, czech koruna banknotes, czech koruna currency, czech koruna denominations, czech koruna rate, czech koruna symbol, where to buy czech koruna, czech koruna to inr, czech koruna to euro,exchange rate, currecy exchange, Buy, Sell, forex cards, Live czech koruna rate, czech koruna price",about:{title_text:"The Currency of Czech Republic",desc:"Since 1993, the Czech Republic has used the koruna, which is also referred to as a crown in various contexts. The crown is one of the nine currencies that are used in the European Union. The correct name for the Czech currency is the koruna eská. The Czech koruna, also shortened as CZK, is the country's official currency and can be abbreviated as CZ. The Czech koruna symbol is Kč.\n\n &nbsp; \n\nOne koruna is equal to one hundred hales. The Czechoslovak koruna was replaced with the CZK in 1993 due to the collapse of the Soviet Union in 1991. In spite of the fact that it is a member state of the European Union, the Czech Republic has not yet adopted the euro as its official currency, and there are currently no plans to do so in the near future.\n\n &nbsp; \n\nThe Czech National Bank in Prague is currently in charge of the issuance and management of the currency used in the Czech Republic. The Czech Mint issues banknotes of **Czech koruna denominations** of 100, 200, 500, 1,000, 2,000, and 5,000 koruna and coins with face values of 1, 2, 5, 10, 20, and 50 koruna. The Czech Mint also issues coins with face values of 1, 2, 5, 10, and 20 koruna.\n\n &nbsp; \n\nThe **live Czech Koruna rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Czech Koruna price**."},quick_facts:{facts:{Country_of_Origin:"Czech Republic",Symbol:"Kč",Currency_Code:"CZK",Nick_Names:"-",Minor_units:"Haléřa","Denominations_(Banknotes)":"100 Kč, 200 Kč, 500 Kč, 1,000 Kč, 2,000 Kč and 5,000 Kč",Motto:"-",Identification_Feature:"When it comes to the upgraded 5000 Kč, there is an image of Tomáš Garrigue Masaryk on the obverse side as well as images of gothic and baroque buildings in Prague St. Vitus Cathedral on the reverse side.",Issuing_Bank:"Czech National Bank",In_Circulation_Since:"February 8, 1993",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"By the 1920s, the Czechoslovak crown gained a well-deserved reputation for being the most resilient currency in all of Europe. During their occupation of the Czech Republic during World War II, the Nazis brought about a devaluation of the Czech crown. Following the conclusion of the war, the Czechoslovak crown was brought back into use. Its revamping of the monetary system in 1953 was met with widespread criticism.\n\n &nbsp; \n\nThe Czech koruna took the place of the Czechoslovak koruna as the country's official currency on February 8, 1993, following the dissolution of Czechoslovakia into the Czech Republic and the Slovak Republic, which was supported by the Soviet Union.\n\n &nbsp; \n\nIn spite of the fact that it has been a member of the European Union since 2004, the Czech Republic has not yet adopted the euro (EUR) as its primary currency. Even while preparations for membership in the common currency continue, the country has not established a hard timeline for the entire transition from the koruna to the common currency.\n\n &nbsp; \n\nA vote in 2007 put an end to plans to become the euro the official currency of the Czech Republic in the year 2012; nevertheless, those plans were never implemented."},countries_accepting:{desc_1:"The **Czech Koruna** is the legal tender in the Czech Republic and is used for a variety of transactions involving the purchase and sell of goods and services inside the country. You can find out the **best way to get Czech koruna** in order to enjoy a wonderful trip in the country.",list:[],desc_2:""},amount_for_trip:{desc:"It is essential to keep a few things in mind when making travel arrangements to the Czech Republic for a vacation. You will need to create a budget in order to account for many different items, some of which include the cost of eating out, lodging, and travelling around in the Czech Republic.\n\n &nbsp; \n\nA day's cost of travelling in the Czech Republic on a shoestring budget will run you about Kč845. If you splurged on everything from your hotel room to your meals, the daily cost might easily go up to or even beyond Kč5,075. A trip to the Czech Republic for two people can be expected to cost anywhere from Kč1,700 to Kč12,000 in total spending money. The cost of a single night's stay in a hotel in the Czech Republic can range anywhere from Kč437 all the way up to Kč2,861. Depending on whether you take a taxi, a bus, or some other kind of public transit, the amount of money it will cost you to move around can range anywhere from Kč70 to Kč453. Taking the bus is frequently the most fiscally responsible course of action to pursue.\n\n &nbsp; \n\nYou can check the **Czech Koruna rate today** in order to plan a cost-effective vacation. Below, we’ll also learn about the **best place to buy Czech koruna**."},identification:{list:["These fakes have been observed in the shape of the Czech Republic's CZK 500 banknote from the year 2009 and the Czech Republic's CZK 1,000 banknote from the year 2008. These counterfeit bills have windowed threads that are actually assembled parts of authentic windowed threads from lower values that have been fused together.","Genuine banknotes can be identified by their use of direct colours, in contrast to counterfeit banknotes, which include a print pattern that is made up of cyan, yellow, black ink and magenta.","The banknote design is printed at the same time as the most significant security elements, which include a watermark, a latent image, and an iridescent strip, however, these characteristics are either absent or badly duplicated in fake notes.","Although the fakes have only been found in a select few sites in and around Moravia (Olomouc, Umperk, Brno, and Ostrava), this could quickly change. The quality of the counterfeit bills is poor in most other ways. On a scale that ranges from 1 to 5, with 1 representing the highest level of safety, just one variety was rated as having a quality equivalent to a grade 3 (good quality)."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Czech Koruna**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Czech Koruna to USD, INR to Czech Koruna** or **Czech Koruna to Euro**, you only need to follow the below-written steps:"}}},{id:38,internalName:"seo_currency_page_egyptian-pound",type:"seo_currency_page_egyptian-pound",data:{name:"Egyptian Pound",code:"EGP",country_code:"EG",travel_country:"Egypt",keywords:"egyptian pound, buy egyptian pounds, egyptian pound symbol, value of egyptian pound, best rate for egyptian pound, egyptian pound notes, egyptian pound rate, convert egyptian pounds,egyptian pound to inr, egyptian pound to usd,exchange rate, currecy exchange, Buy, Sell, forex cards, Live egyptian pound rate, egyptian pound price",about:{title_text:"The Currency of Egypt",desc:"The Egyptian Pound, also written as E£ and abbreviated as EGP, is the official currency of the Arab Republic of Egypt. In 2001, the Central Bank of Egypt took action and initiated a controlled float. This float continued to be supported by precious metals until 2016, after which point it transitioned into a free float. Before the float, the value of one United States dollar was equivalent to 8.8 Egyptian pounds. After this devaluation, one dollar in US currency was equivalent to around 15 Egyptian pounds. Alongside Egypt, several countries and territories, such as Sudan and the Gaza Strip, have adopted the Egyptian Pound as their official currency. The **Egyptian pound symbol** is E£.\n\n &nbsp; \n\nThe **live Egyptian Pound rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Egyptian Pound price**."},quick_facts:{facts:{Country_of_Origin:"Egypt",Symbol:"E£, ج.م",Currency_Code:"EGP",Nick_Names:"Baku and Arnab",Minor_units:"Millieme","Denominations_(Banknotes)":"LE 1, LE 5, LE 10, LE 20, LE 50, LE 100, LE 200",Motto:"-",Identification_Feature:"On an LE 200 note, the obverse side has an image of Mosque of Qani-Bay and the reverse side has an image of the Seated Scribe.",Issuing_Bank:"Central Bank of Egypt",In_Circulation_Since:"1834",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"In 1834, the Egyptian piastre was replaced by the Egyptian pound (EGP), which became the country's official currency. When the new currency was first issued, a rate of exchange between gold and silver was established. This rate has remained unchanged since then.\n\n &nbsp; \n\nDespite the introduction of the pound, the piastre continued to be used as a unit of currency; its function was comparable to that of the one-cent coin that is employed in our modern economy. After the coin had been renamed and redivided, the millime was finally released the following year in 1916.\n\n &nbsp; \n\nIn 1961, the Egyptian government decided to establish a central bank. The Central Bank of Egypt in Cairo, which served as the monetary authority for the Arab Republic, was in charge of managing the circulation of the Egyptian pound.\n\n &nbsp; \n\nIn 1962, Egypt linked its currency to the US dollar and devalued its own currency, the pound. The **value of Egyptian pound** was allowed to deteriorate on its own in 1978 after having been tied to the value of the US dollar since 1973. In the years leading up to 2016, when the government made the decision to untie some of its ties to the dollar in order to become eligible for support from the IMF, the currency was pegged."},countries_accepting:{desc_1:"The **Egyptian Pound** is the legal tender in Egypt and is used as the sole currency for all kinds of transactions here. The Gaza Strip and many districts in Sudan both make unofficial use of the Egyptian pound as their primary currency.",list:[],desc_2:""},amount_for_trip:{desc:"There are a few things to remember before organising a trip to Egypt. The cuisine, lodging, and transportation possibilities in Egypt are only a few of these.\n\n &nbsp; \n\nTo go around the world on a restricted budget, one needs, on average, E£246 every day. On the other side, if you chose to indulge in luxurious lodgings and dining establishments, your trip might easily cost as much as E£1,683. A trip to Egypt for two people will typically run between E£600 to E£3,500.\n\n &nbsp; \n\nThe price range for a single night at an Egyptian hotel can be anywhere between E£111 and E£686. Depending on whether you opt for a taxi, the bus, or some other kind of public transit, your total cost for getting around town might be anywhere from E£40 to E£305 per day.\n\n &nbsp; \n\nYou can check the **Egyptian Pound rate today** in order to plan a cost-effective vacation."},identification:{list:["If you have ever looked at **Egyptian pound notes**, you would have noticed that there is a long series of numbers on each note. Even though they aren't particularly important to us, they can be helpful in identifying fake invoices. Pay close attention to these digits; if they are not aligned correctly, the note is most likely a forgery.","Pay close attention to these numbers. Look for discrepancies, such as ones in the spacing between the figures or the size of the figures themselves.","Additionally, rigorous inspection needs to be performed on currency ink. The printing on the vast majority of genuine banknotes is perfect. If you suspect that a note has been forged, look for telltale characteristics such as smudged ink or uneven lines.","The actual fabric of the coin is sewn with security thread so that it cannot be removed. Because of this, you can use this quality to determine whether or not a note is genuine."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Egyptian Pound**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Egyptian Pound to USD** or **INR to Egyptian Pound**, you only need to follow the below-written steps:"}}},{id:39,internalName:"seo_currency_page_israeli-new-shekel",type:"seo_currency_page_israeli-new-shekel",data:{name:"Israeli Shekel",code:"ILS",country_code:"IL",travel_country:"Israel",keywords:"israeli shekel,israeli new shekel, shekel israeli currency, currency exchange rates israeli shekel, israeli shekel symbol, israeli shekel conversion, palestine currencies israeli new shekel, old israeli shekel, nis new israeli shekel, israeli new shekel symbol, israeli new shekel currency code, israeli new shekel denominations, israeli new shekel notes, israeli new shekel pronunciation,israeli new shekel to inr, dollar to israeli shekel,exchange rate, currecy exchange, Buy, Sell, forex cards, Live israeli shekel rate, israeli shekel price",about:{title_text:"The Currency of Israel",desc:"The new Israeli shekel is Israel's official currency. The value of one new shekel is equal to one hundred agorot. Since the year 1986, the Israeli Shekel has served as the country's primary unit of currency. The **old Israeli shekel**, which had been overvalued in the past, was eventually replaced by the **nis new Israeli shekel**. ILS is the **Israeli new shekel currency code**. The **Israeli Shekel symbol** is ₪. The Israeli new shekel denominations for bank notes include ₪20, ₪50, ₪100 and ₪200.\n\n &nbsp; \n\nThe **live Israeli Shekel rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Israeli Shekel price**."},quick_facts:{facts:{Country_of_Origin:"Israel",Symbol:"₪",Currency_Code:"ILS",Nick_Names:"-",Minor_units:"Shekel","Denominations_(Banknotes)":"₪20, ₪50, ₪100 and ₪200",Motto:"-",Identification_Feature:"On a ₪200 note, there is an image of Zalman Shazar, an Israeli politician, author and poet, on the obverse side.",Issuing_Bank:"Bank of Israel",In_Circulation_Since:"September 4, 1985",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The **Israeli New Shekel** is the country of Israel's newly introduced fourth currency (ILS). In 1952, the Palestine Pound was dethroned as the nation's official currency and succeeded by the Israeli Pound. Both were at one time connected to the pound sterling of the United Kingdom (GBP). However, the connection between the Israeli pound and sterling was severed in 1954.\n\n &nbsp; \n\nAlthough there was a lot of public support for a Hebrew-sounding currency in Israel, it wasn't until 1980 that the government formally abandoned the pound note in favour of the shekel. The fact that the word \"shekel\" appears in the Bible raises the possibility that it was originally a grain measurement unit.\n\n &nbsp; \n\nAs a direct consequence of a severe economic downturn that occurred in the 1980s, inflation rates shot through the roof. After a period of time, the Israeli government took steps to stabilise the economy, including enacting free-market reforms and releasing a new shekel into circulation in the year 1986. After that event, the ILS rose to prominence as one of the most reliable currencies in use across the world. The Israeli new shekel symbol is ₪, and the **Israeli new shekel pronunciation** is pretty easy as well.\n\n &nbsp; \n\nIn 2003, it completed the process of being fully convertible, and in the same year, trading in derivatives began on the Chicago Mercantile Exchange (CME). The state of Israel used the shekel as its official currency from February 24, 1980 to December 31, 1985. This version of the shekel is now referred to as the old shekel. Throughout the 1960s and 1970s, devaluations of the Israeli Shekel and its predecessor, the Israeli pound, were rather common when measured against other currencies. This pattern reached its zenith at the beginning of the 1980s with the hyperinflation of the old shekel.\n\n &nbsp; \n\nAt a rate of 1,000 Israeli Shekels to one New Shekel, the old shekel was phased out and replaced with the new shekel on January 1, 1986. Also **Palestine currencies Israeli new shekel** was established.\n\n &nbsp; \n\n**Countries Accepting the Israeli Shekel**\n\n &nbsp; \n\nThe **Israeli Shekel** is the legal tender in Israel and is used as the sole currency for all kinds of transactions here. The Israeli shekel is also recognised as legitimate money in the West Bank and the Gaza Strip."},countries_accepting:{desc_1:"The **Israeli Shekel** is the legal tender in Israel and is used as the sole currency for all kinds of transactions here. The Israeli shekel is also recognised as legitimate money in the West Bank and the Gaza Strip.",list:[],desc_2:""},amount_for_trip:{desc:"Before beginning the planning process for a trip to Israel, there are a few things that are important to keep in mind. The country of Israel offers a wide variety of experiences, some of which include its cuisine, housing, and transportation options.\n\n &nbsp; \n\nOn average, one needs ₪142 per day to explore Israel on a shoestring budget. If, on the other hand, you decided to splurge on luxurious accommodations and dining venues throughout your trip, the total cost of your vacation might easily reach ₪813 per day. Generally speaking, the cost of travel to Israel for two persons will range anywhere from ₪300 to ₪1,700.\n\n &nbsp; \n\nA single night's stay in an Israeli hotel can cost anywhere from ₪80 to ₪457, with the average cost falling somewhere in the middle. Your total cost for going around town could range anywhere from ₪10 to ₪70 depending on whether you take a cab, a bus, or some other form of public transportation. The bus is likely to be the cheapest option.\n\n &nbsp; \n\nYou can check the **Israeli Shekel rate today** in order to plan a cost-effective vacation."},identification:{list:["When the **Israeli new shekel notes** are held up to the light, a watermark picture of the portrait appears, which is the same as the image portrayed on the obverse of the banknote, along with the denomination.","banknote's denomination is made by a series of tiny holes punched through the middle of the top portion of the note. These holes are referred to as perforated numerals. Bring the bill into the light, and make sure to pay attention to the specifics.","A green security thread that is embedded in the bill and can be seen via one of the three windows on the rear. It is possible to read the bill once it has been held up to the light. The colour of the thread will alter depending on the angle at which the bill is held.","Intaglio, also known as raised ink, is used to write the portrait of the Governor, his signature, the Hebrew and Gregorian years, messages in three languages, and Braille identifiers on the sides of the banknote. If you run your finger over the characteristics on either side of the bill, you will be able to detect the raised ink that is present.","Several characteristics of an authentic banknote are only discernible when seen with ultraviolet light.","The serial digits on the bill appear and disappear at unpredictable intervals when seen at eye level or when the bill is tilted.",'On this bill, the denomination, a poem, and the Hebrew words that translate to "Bank of Israel" are all printed in a very small font. To make out these letters and numbers with your bare eyes or with the assistance of a magnifying glass is completely unnecessary.','The seven-branched menorah as well as its individual components are depicted on the **Shekel Israeli currency**. When held up to the light, the design on the bill creates the shape of a complete "Menorah."',"Banknotes of the most recent generation come in a variety of sizes. There is a difference of 7 millimetres in size between the various denominations.","On a white background, smaller numerals that are lighter in colour are printed in raised ink, whilst larger digits that are darker are printed on a black background.",'A transparent and glittering stripe that runs vertically next to the image on banknotes can be seen through the paper. This component of the design is referred to as the "glittering stripe".']},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Israeli Shekel**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Israeli Shekel to USD,** **INR to Israeli Shekel** or **dollar to Israeli shekel**, you only need to follow the below-written steps:"}}},{id:40,internalName:"seo_currency_page_kenyan-shilling",type:"seo_currency_page_kenyan-shilling",data:{name:"Kenyan Shilling",code:"KES",country_code:"KE",travel_country:"Kenya",keywords:"kenyan shilling,kenyan shilling currency, shilling conversion, kenyan shilling currency symbol, kenyan shilling denominations, kenyan shilling coins, kenyan shilling notes, kenyan shilling sign, kenyan shilling symbol,kenyan shilling to inr, kenyan shilling to usd,exchange rate, currecy exchange, Buy, Sell, forex cards, Live kenyan shilling rate, kenyan shilling price",about:{title_text:"The Currency of Kenya",desc:"The Kenyan shilling is the official unit of money in the Republic of Kenya (KES). The Kenyan shilling (KES) is the official currency of Kenya, Sudan, and Somalia, each of which also uses a variation of the KES as their currency. The Kenyan shilling (KES) has demonstrated exceptionally high levels of predictability in comparison to other currencies used in east Africa. The **Kenyan shilling currency symbol** is /- or /=. Another popular **Kenyan shilling sign** is K or Ksh. Because it is more stable than the local currencies, the Kenyan shilling (KES) is used in the countries that border Kenya as a de facto international reserve currency. The **Kenyan shilling denominations** include 5/=, 10/=, 20/=, 50/=, 100/=, 200/=, 500/= and 1,000/= for banknotes. On the other hand, **Kenyan shilling coins** denominations include 1 shilling, 20 shillings, 10 shillings, 40 shillings, 5 shillings.\n\n &nbsp; \n\nThe **live Kenyan Shilling rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Kenyan Shilling price**."},quick_facts:{facts:{Country_of_Origin:"Kenya",Symbol:"/-, /=, K and Ksh",Currency_Code:"KES",Nick_Names:"-",Minor_units:"Cent","Denominations_(Banknotes)":"5/=, 10/=, 20/=, 50/=, 100/=, 200/=, 500/= and 1,000/=",Motto:"-",Identification_Feature:"The 1,000/= note features images of President Daniel Toroitich arap Moi and Coat of arms of Kenya on the obverse side.",Issuing_Bank:"Central Bank of Kenya",In_Circulation_Since:"September 14, 1996",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The Kenyan Shilling was introduced in 1966 as a replacement for the East African shilling. That currency saw widespread use in the areas of east Africa that were under British administration up to the early 1960s when Kenya and several other African countries won their independence from the United Kingdom. The Kenyan shilling was introduced in the year 1967. And the **Kenyan shilling symbo**l decided was /-, /=, K or Ksh.\n\n &nbsp; \n\nThe exchange rate for the Kenyan shilling to the United States dollar reached its all-time high in 2009 when it was trading at approximately 75 shillings to the dollar However, since then, it has fallen to approximately 104 shillings to the dollar in both 2015 and 2017. Since 2016, the Kenyan shilling's value has remained relatively unchanged at roughly 100 dollars per 1 shilling. This is despite growing concerns regarding Kenya's growing state debt.\n\n &nbsp; \n\nThe Kenyan shilling's value versus the United States dollar has been on the slide over the course of the last decade, despite the fact that its volatility is lower than that of some of its regional competitors. The exchange rate for the Kenyan shilling is determined by the Central Bank of Kenya; however, the Central Bank of Kenya permits the rate to freely fluctuate in reference to other currencies on the global currency market.\n\n &nbsp; \n\nAs a direct result of constitutional modifications that were passed in 2018, Kenya started producing new banknotes and coins. These amendments make it illegal to portray specific people on the currency.\n\n &nbsp; \n\nThe Central Bank of Kenya released a new series of banknotes on May 31, 2019, in accordance with the provisions of Kenya's constitution from 2010, which mandated that images of notable Kenyans be removed from the banknotes."},countries_accepting:{desc_1:"The Kenyan shilling is the official currency of Kenya, Sudan, and Somalia, each of which also uses a variation of the KES as their currency.",list:[],desc_2:""},amount_for_trip:{desc:"There are a few things to keep in mind when you start making preparations for a trip to Kenya. Kenyan cuisine, housing, and transportation option are just a few examples of the many expenses you have to make while exploring Kenya.\n\n &nbsp; \n\nIf you want to see as much as possible in Kenya on a tight budget, you'll need KES5,351 per day. On the other hand, if you splurged on everything from your hotel to your meals, your daily cost might easily approach KES26,587. The average cost of a trip to Kenya for two people is between KES12,000 and KES55,000.\n\n &nbsp; \n\nThe average cost of a hotel room for one night in Kenya is around KES1,446, and it can go as high as KES7,057. Depending on whether you use a taxi, a bus, or some other type of public transit, your total cost for getting around the city might be anywhere from KES1,406 to KES8,033. In most cases, taking the bus will be the most cost-effective choice.\n\n &nbsp; \n\nYou can check the **Kenyan Shilling rate today** to plan a cost-effective vacation."},identification:{list:["Examine the ink that changes colour when you hold the bill against the light. This can be used to differentiate real money from counterfeit currency notes.","The characteristic security feature known as a watermark is always present on genuine banknotes.","Notes that are difficult to read due to blurry printing, writing, or borders are a dead giveaway that they are counterfeit. Genuine bills can be identified by the extremely fine lines that are printed on them. Pay careful attention to the margins of the bill to ensure that they are not cluttered in any way.",'The term "microprinting" refers to the little, fine print that may be found in a variety of key positions on authentic banknotes. This feature can only be found on genuine banknotes. Microprinting that is illegible without the use of a microscope is one of the most reliable ways to spot counterfeit notes. This microprinting is only visible under magnification.',"The final stage in the verification procedure involves checking the authenticity of a bill's serial number."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Kenyan Shilling**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Kenyan Shilling to USD** or **INR to Kenyan Shilling**, you only need to follow the below-written steps:"}}},{id:41,internalName:"seo_currency_page_macanese-pataca",type:"seo_currency_page_macanese-pataca",data:{name:"Macau Pataca",code:"MOP",country_code:"MO",travel_country:"Macau",keywords:"macau pataca, macanese pataca, pataca symbol, macau pataca currency, macau pataca currency symbol, macau pataca denominations, macau pataca images, macau pataca notes, macau pataca pronunciation,macau pataca in inr, usd to macau pataca, hkd to macau pataca,exchange rate, currecy exchange, Buy, Sell, forex cards, Live macau pataca rate, macau pataca price",about:{title_text:"The Currency of Macau",desc:"Macau, a territory that had been under Portuguese colonial rule until 1999, was officially recognised by China as a special administrative area in the same year. As a Special Administrative Region of China, Macau makes use of the Macau pataca (MOP) as its official form of currency. The currency is referred to by a few different names, including the Macanese pataca. The **Macanese Pataca symbol** is MOP$, and the **Macau Pataca pronunciation** is pretty straightforward as well.\n\n &nbsp; \n\nMacau was a Portuguese territory up until 1999 when it was transferred to the Chinese administration. In spite of the fact that it is now a part of China, it continues to preserve a significant amount of its economic autonomy. Its value is based on a 1:1 ratio with the Hong Kong Dollar (HKD), which is the currency of Hong Kong. It is completely backed by foreign exchange reserves denominated in HKD.\n\n &nbsp; \n\nThe **live Macau Pataca rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **macau pataca in INR** price."},quick_facts:{facts:{Country_of_Origin:"Macau",Symbol:"MOP$",Currency_Code:"MOP",Nick_Names:"Macanese pataca",Minor_units:"Avo (Portuguese)","Denominations_(Banknotes)":"$10, $20, $50, $100, $500 and $1,000",Motto:"-",Identification_Feature:"The 200 series banknotes feature an image of Bank of China, Macau branch on the obverse side.",Issuing_Bank:"Autoridade Monetária de Macau",In_Circulation_Since:"1995"}},history:{desc:'In the year 1901, efforts to create a unified currency that was recognised on a national level got underway in Macau. For the purposes of this endeavour, the authorization to print pataca banknotes was delegated to the Banco Nacional Ultramarino, which had its beginnings in Lisbon in 1864.\n\n &nbsp; \n\nAfter this point, patacas ceased to be regarded as a distinct variety of the peso currency used in Mexico (or "Mexican patacas"). The usage of the Mexican peso and any other foreign currency was made illegal not long after the issuance of these brand-new banknotes of the pataca currency. It wasn\'t until 1952 that actual coins of the Macanese pataca were introduced into circulation, which is far later than the norm for most currencies. This is due to the fact that, despite efforts by the government to eradicate the use of foreign currency in circulation, Chinese coins from the neighbouring Canton Province were already widely used over the entirety of Macau.\n\n &nbsp; \n\nThe **Macau Pataca denominations** of notes are available as 10, 20, 50, 100, 500, and 1,000 patacas, while coins come in denominations of 10, 20, and 50 avos. There are also larger coins in circulation, with values ranging from one pataca up to twenty patacas. These larger coins have a diameter of twenty patacas. The **Macau Pataca currency symbol** is MOP$.\n\n &nbsp; \n\nSince 2009, the value of one Mozambican franc (MOP) relative to one US dollar (USD) has remained relatively stable, with the exchange rate ranging between 7.80 and 8.10 MOP per USD between 2019 and the present. Over the course of that time span, inflation has been relatively moderate, coming in at an annual average of less than 4%.'},countries_accepting:{desc_1:"The **Macau Pataca** is the official currency of Macau and is used for all kinds of transactions here. You can also keep an eye on real-time **Macau Pataca price.**",list:[],desc_2:""},amount_for_trip:{desc:"To cover their day-to-day costs of living, a tourist needs approximately MOP814 each day in Macau. If you plan to travel in Macau in style by renting a private vehicle, eating at restaurants with Michelin stars, and staying in hotels with three stars or more, you should anticipate spending more than MOP1,224 each day there. For two people, this trip can cost somewhere around MOP1,600 to MOP2,500 each day.\n\n &nbsp; \n\nIf you want to live comfortably in Macau, then a stay option here can range somewhere between MOP730 and MOP 1,500.\n\n &nbsp; \n\nYour daily transportation costs in Macau could range anywhere from MOP2 to MOP7, depending on whether you opt to ride the bus and save money or pay cash for one of the costly cabs that are available.\n\n &nbsp; \n\nYou can check the **Macau Pataca rate today** in order to plan a cost-effective vacation."},identification:{list:["If you are familiar with an authentic note, you are aware that each bill has a long string of numerals. They can help in identifying fraudulent currency notes. Keep an eye on these digits; if they are not properly aligned, the bill is probably a forgery. Pay attention to how they are arranged. Keep your whole attention on these digits.","Examining a message for telltale indicators such as smudged writing or uneven lines might help one determine whether or not it is genuine. Also, keep an eye on **Macau Pataca images** and how crisp they are.","You will be able to determine the authenticity of a note by looking at the security thread and the material used for creating a note. Someone who does not have the necessary level of competence can get the impression that the security thread on a counterfeit bill was drawn or printed there."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Macau Pataca**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **USD to Macau Pataca, INR to Macau Pataca** or **HKD to Macau Pataca**, you only need to follow the below-written steps:"}}},{id:42,internalName:"seo_currency_page_polish-zloty",type:"seo_currency_page_polish-zloty",data:{name:"Polish Zloty",code:"PLN",country_code:"PL",travel_country:"Poland",keywords:"polish zloty, polish zloty currency code, polish zloty symbol, polish zloty forecast, buy polish zloty online, polish zloty coins, best exchange rate for polish zloty, best place to buy polish zloty, polish zloty denominations, polish zloty notes, polish zloty sign,polish zloty to inr, polish zloty to euro,exchange rate, currecy exchange, Buy, Sell, forex cards, Live polish zloty rate, polish zloty price",about:{title_text:"The Currency of Poland",desc:"The zloty is Poland's national currency and serves as the country's legal tender. It is the 22nd most actively traded currency in the world, measured in terms of the volume of trade that takes place on the foreign exchange market. On the currency exchange market, the **Polish zloty symbol** is zł, and the **Polish zloty currency code** PLN. The Polish zloty is the official currency of Poland.\n\n &nbsp; \n\nThere are ten different **Polish zloty denominations** of notes, ranging from z10 to z500. It is possible to purchase **Polish zloty coins** with values ranging from 1 groszy to 50 groszy as well as 1 zloty to 5 zloty. The Zloty is issued and managed by the National Bank of Poland, which serves as Poland's central bank. Although the origins of the currency may be traced back to the early part of the 20th century, the money itself has been redesigned numerous times in reaction to the shifting political and economic atmosphere of the country.\n\n &nbsp; \n\nThe **live Polish Zloty rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Polish Zloty price** as per the **Polish zloty forecast**."},quick_facts:{facts:{Country_of_Origin:"Poland",Symbol:"zł",Currency_Code:"PLN",Nick_Names:"-",Minor_units:"Grosz","Denominations_(Banknotes)":"10zł, 20zł, 50zł, 100zł, 200zł and 500zł",Motto:"-",Identification_Feature:"The 500 złoty has an image of John III Sobieski on the obverse side as well as images of Polish white eagle and Wilanów Palace on the reverse side.",Issuing_Bank:"National Bank of Poland",In_Circulation_Since:"1924",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The zloty is the currency that can be spent legally in Poland. The origin of the current zloty can be traced back to 1919, however, it wasn't extensively used until the year 1924.\n\n &nbsp; \n\nBoth the issuance of money and its management are the responsibility of the Narodowy Bank Polski (Central Bank of Poland). And the **Polish zloty sign** is zł. Since 1997, Poland has maintained its position as the sole holder of manufacturing rights for the zloty currency.\n\n &nbsp; \n\nIn 1950, all banknotes issued prior to 1948 were exchanged for one hundred of the brand new Third Zoty (PLZ), and all bank assets were redenominated at a rate of 100 to 3. In 1948, all banknotes were redeemed for 100 PLZ. The years 1948 and 1949 were printed on the new banknotes and coins that were issued. According to the legislation in place in Poland from 1950 onward, the value of one zloty, which derives from the word zlotyty, was initially fixed at 0.222168 grammes of gold.\n\n &nbsp; \n\nAfter the fall of communism in 1989, which was followed by hyperinflation, the zoty was forced to undergo a revaluation. On May 11th, 1994, the NBP redenomination project was approved, and on July 7th, 1994, the necessary law was passed. As a direct consequence of this event, on January 1, 1995, 10,000 PLZ was converted into 1 PLN.\n\n &nbsp; \n\nSince the beginning of the 2000s, the value of one US Dollar in Polish Zloty has typically ranged between two and four and a half Polish Zloty. On the other hand, even since the start of the Great Recession in 2008, the exchange rate for the PLN has never been lower than three PLN to one dollar.\n\n &nbsp; \n\nIn the time span between 2013 and 2014, the security features of the banknotes were improved. The coins have the same general appearance as those from the 1994 series, with the exception of a white field and marking on the reverse of each piece. In addition, the new notes feature a peculiar dotted pattern.\n\n &nbsp; \n\nSince the 10th of February in 2017, a currency of 500 zlotys depicting a portrait of John III Sobieski has been in circulation."},countries_accepting:{desc_1:"The **Polish Zloty** is the legal tender in Poland and is used for the sale and purchase of goods and services within the boundary of the country.",list:[],desc_2:""},amount_for_trip:{desc:"If you are planning to explore Poland, then there are different factors you must consider: the cost of the flight, how expensive the stay options are, transportation as well as what you can eat in Poland.\n\n &nbsp; \n\nOn average, a person needs zł81 for a comfortable trip on a shoestring budget. On the other hand, if you choose to stay in opulent properties or relish delicious meals at high-end restaurants, then this cost can extend up to zł564. The total cost for two people on a trip to Poland can range between zł175 to z3,500.\n\n &nbsp; \n\nThe cost of staying in a property in Poland every day ranges between zł45 to zł326. Meanwhile, the transportation cost here can be anywhere around zł8 to zł43, depending on whether you are using a taxi, a bus or any other means of transport.\n\n &nbsp; \n\nYou can check the **Polish Zloty rate today** in order to plan a cost-effective vacation."},identification:{list:["Along with a numeric number that corresponds to the denomination, the image of the Sovereign is watermarked on the front of each freshly redesigned banknote. In the region occupied by the watermark, printing is not permitted.",'Under ultraviolet illumination, the value number and the abbreviation "Z" are readable since they are inscribed on a security thread on the reverse side of each banknote.',"When the perspective of the viewer is changed, the graphic element that is located to the right of the portrait of the sovereign on the fifty zloty, one hundred zloty, two hundred zloty, and five hundred zloty notes progressively changes colour.",'The "K" in a crown pattern that appears on the 50 zloty bill transitions from green to blue as it moves from left to right.',"The rosette on the 100-zloty note transitions from gold to green as it moves up in value.","The shield of the two hundred zloty bill changes colour from golden to green, and the chessboard design that is printed on it appears to move.","The design on the 500 z bill depicts a lobster tail that changes colour from green to blue and appears to move in time with a pattern of wavy lines.","Pieces of the security thread can be found on both the front and back of banknotes denominated 200 zloty and 500 zloty. Notes of currency feature a security thread that, when the note is tilted, progressively alters both its colour and its appearance.","The colour of the 200 zloty bill, which features a checkerboard design, goes from golden to green in a seamless transition.","The banknote for 500 zlotys has a design that consists of a gradation from gold to green as well as two ribbons that intertwine with each other.",'On the back side of the banknotes worth 10 zloty and 20 zloty, there is an iridescent stripe that features the value numeral and the abbreviation "Z."']},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Polish Zloty**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Polish Zloty to USD, INR to Polish Zloty** or **Polish zloty to Euro**, you only need to follow the below-written steps:"}}},{id:43,internalName:"seo_currency_page_indian-rupee",type:"seo_currency_page_indian-rupee",data:{name:"Indian Rupee",code:"INR",country_code:"IN",travel_country:"India",keywords:"Indian rupee,Indian rupee Currency, Indian rupee rate today, Indian rupee rate, Indian rupee price, Indian rupee price today, Indian rupee symbol,indian rupee to dollar, indian rupee to usd, indian rupee to pakistani rupee, indian rupee to us dollar, indian rupee to sri lankan rupee, saudi riyal to indian rupee today, indian rupee to pkr, indian rupee to bangladeshi taka, indian rupee to euro, indian rupee to canadian dollar, indian rupee to nepal currency, indian rupee to dirham, indian rupee to korean won, indian rupee to philippine peso, indian rupee to pound, indian rupee to sri lanka, indian rupee to vietnam currency, indian rupee to australian dollar, indian rupee to japan currency, indian rupee to thailand currency, indian rupee to aed, indian rupee to bhutan currency, indian rupee to japanese yen, indian rupee to nepal, indian rupee to ruble, indian rupee to kuwait dinar, indian rupee to nepal rupee, indian rupee to russian ruble",about:{title_text:"The Strong Currency of India",desc:"The Indian Rupee is the currency that can be spent legally inside the boundaries of India. The Reserve Bank of India is the institution in charge of issuing the new currency. There is also a three-letter ISO currency code for the Indian rupee, which is INR. is the symbol for Indian rupee. The **Indian rupee symbol** is ₹.\n\n &nbsp; \n\nThere are many denominations of banknotes that can be printed, ranging from 5 rupees all the way up to 2,000 rupees. On one side of paper rupees, the denominations are printed in Hindi and English, while on the other side, they are printed in a total of 15 different languages.\n\n &nbsp; \n\nAs the **Indian rupee price** keeps fluctuating, you can check the **Indian rupee rate today** for further information."},quick_facts:{facts:{Country_of_Origin:"India",Symbol:"₹",Currency_Code:"INR",Nick_Names:"-",Minor_units:"Paisa","Denominations_(Banknotes)":"₹1, ₹2, ₹5, ₹10, ₹20, ₹50, ₹100, ₹200, ₹500 and ₹2,000",Motto:"-",Identification_Feature:"On the reverse side of the ₹500 note, you will find the image of the majestic Red Fort",Issuing_Bank:"Reserve Bank of India",In_Circulation_Since:"1949",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Along with the Chinese wen and the Lydian staters, ancient India was one of the earliest issuers of coins in the globe in the sixth century BCE. This is where the history of the Indian rupee began. The silver rupiya was minted during the reign of Sultan Sher Shah Suri, which lasted from 1540 to 1545 and consisted of five years.\n\n &nbsp; \n\nThe Imperial Order in Council of 1825, which was issued with the intention of extending the use of British sterling coinage to the colonies of the British Empire, was completely ineffective in India. During this time, the British East India Company had almost complete control over India. Even after the British Empire had been abolished, the silver rupee continued to be used as currency across the entirety of India. The decision made by British India in 1835 to adopt a silver standard based on the rupee coin was influenced by a letter written in 1805 by Lord Liverpool advocating the benefits of mono-metallism. The letter was sent in 1805. The First War of Indian Independence, which took place in 1857, marked the beginning of direct British rule of India. The production of gold sovereigns in vast quantities did not begin until 1851 at the Royal Mint in Sydney.\n\n &nbsp; \n\nThe British government eventually gave up on its goal of replacing the rupee in India with the pound sterling. As a direct result of the silver crisis that occurred in 1873, a number of countries, including India in the 1890s, adopted a gold exchange standard. Around the year 1875 was the first recorded year when Britain paid India for its exports utilising India Council (paper) Bills.\n\n &nbsp; \n\nThe panic of 1873, which was triggered by the discovery of vast quantities of silver in the United States and other European territories, resulted in the devaluation of India's national currency, the rupee. As a direct consequence of this, the value of the rupee experienced a dramatic decline. During the Long Depression, which lasted from 1873 until 1897 in Britain, there were several bankruptcies, a rise in the unemployment rate, a stop in the construction of public works, and a considerable decrease in trade.\n\n &nbsp; \n\nIndependent India has been freely using the Indian rupee for transactions. Since the year 2010, the rupee has been represented by its new symbol. On July 8, 2011, the first coins with the new symbol for the rupee were released into circulation for general use."},countries_accepting:{desc_1:"In addition to India, there are various countries where the Indian Rupee is accepted on certain conditions.",list:["BT","NP","BD","MV","ZW"],desc_2:""},amount_for_trip:{desc:"The sum of money that you could require in order to go about the beautiful country of India is contingent on a number of different elements. The cost of getting to your destination, the cost of your lodging, and the cost of your meals will all have an impact on the holiday spending budget you set aside for yourself. It is possible for a traveller to India on a limited budget to spend roughly INR 2,000 each day there. To put that into perspective, the cost of a single day of vacation can easily surpass INR 10,000 if you choose to travel by expensive modes of transportation, dine at restaurants with Michelin stars, and stay in only the finest hotels. The cost of a trip for two people might range anywhere from INR 4,000 to INR 20,000.\n\n &nbsp; \n\nThe typical cost of a hotel room in India can range anywhere from INR 1,000 to INR 3,039 per night, depending on the time of year. On the other hand, whether you utilise public transportation or hire a vehicle service, the typical cost of one day's worth of transportation could range anywhere from INR 200 to INR 1,325.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **Live Indian Rupee** **rate** in order to exchange your currency notes. Keep a track of **Indian rupee price today** for converting the Indian rupee to dollar, Indian rupee to Pakistani rupee, Indian rupee to Sri Lankan rupee, Saudi riyal to Indian rupee today, Indian rupee to Bangladeshi taka, Indian rupee to Canadian dollar, Indian rupee to Nepal currency, Indian rupee to dirham, Indian rupee to Korean won, Indian rupee to philippine peso, Indian rupee to pound, Indian rupee to Sri Lanka, Indian rupee to Vietnam currency, Indian rupee to Australian dollar, Indian rupee to japan currency, Indian rupee to Thailand currency, Indian rupee to AED, Indian rupee to ruble, Indian rupee to Kuwait dinar and Indian rupee to Bhutan currency."},identification:{list:["The profile of Gandhiji is used as a watermark on currency that is minted in India. This watermark allows for the straightforward detection of a counterfeit note. Criminals frequently use thick oils or grease to create fake watermarks on counterfeit currency. As a consequence of this, the watermark takes on an appreciably more substantial appearance. As a result, it is essential to keep one's attention on the watermark. Holding the note up to the light will allow one to determine whether or not the ink used on it is authentic.","If you look closely at this note and see that the numbers aren't lined up properly, you can safely assume that it's a fake. Check to see that all of the numbers are the same size and that there is not a significant amount of space between any of them.","Additionally, the ink that is utilised in the printing process of a currency note ought to be investigated. Authentic banknotes typically have printing that is of the highest quality. Writing that is smudged or lines that are crooked are two examples of telltale evidence that a document has been forged. As a result, you ought to examine the printed information on a note very carefully in order to guarantee that it is genuine.","A banknote often has a row of squares going down the middle of the paper. An encrypted line is precisely what it sounds like a security thread is: a line that is encrypted. In point of fact, the thread of security is woven into the very fabric of the currency that is being used. As a consequence of this, you can use this quality to determine whether or not a note has been forged. On a counterfeit bill, the security thread will have the appearance of being drawn or printed on it.",'The typography on a note that claims to be issued by the Reserve Bank of India can be used to determine whether or not the note is genuine. If you examine a genuine banknote alongside a fake one, you will see that the genuine note has text that is written in a much smoother font. In addition, there is micro-lettering on display that connects Gandhiji\'s face to the words "Reserve Bank of India." The text is very condensed and is shown on a very thin strip. To determine whether or not this print is accurate, you will need to use a magnifying glass.']},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Indian Rupee**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Indian rupee to US dollar, Indian rupee to PKR**, **Indian rupee to Japanese yen, Indian rupee to Nepal, Indian rupee to Nepal rupee, Indian rupee to Russian ruble and INR to Indian Rupee** or **Indian Rupee to Euro**, you only need to follow the below-written steps:"}}},{id:44,internalName:"seo_currency_page_pound-sterling",type:"seo_currency_page_pound-sterling",data:{name:"Pound Sterling",code:"GBP",country_code:"GB",travel_country:"The United Kingdom",keywords:"Pound sterling,Pound sterling Currency, Pound sterling rate today, Pound sterling rate, Pound sterling price, Pound sterling price today, Pound sterling symbol,pound sterling to inr, pound sterling to rupee, pound sterling to usd, pound sterling to euro, pound sterling to dollar,Pound sterling exchange rate, Pound sterling currency exchange, buy Pound sterling, sell Pound sterling, Pound sterling forex cards, live Pound sterling rate, Pound sterling price",about:{title_text:"The Strong Currency of The United Kingdom",desc:"The United Kingdom and its nine dependent overseas territories all use the same official currency, which is the pound sterling. The pound sign ‘£’ is the most common representation of sterling. The sterling is considered to be the oldest money in the world because it has been in continuous use ever since it was created. At the moment, it holds the position of the fourth most-traded currency on the foreign exchange market, falling behind the US dollar, the Euro, and the The United Kingdomese yen respectively. The British pound sterling is abbreviated as GBP. The Pound sterling symbol is £.\n\n &nbsp; \n\nThe **Pound sterling rate today** is INR (`inr_exchange_rate`) . You can keep an eye on the fluctuating Pound **sterling price today**."},quick_facts:{facts:{Country_of_Origin:"The United Kingdom",Symbol:"£",Currency_Code:"GBP",Nick_Names:"Quid",Minor_units:"Rin","Denominations_(Banknotes)":"£1, £5, £10, £20, £50 and £100",Motto:"-",Identification_Feature:"When it comes to series G banknotes, the £50 bill features a 1951 photographic portrait of Alan Turing who was a mathematician.",Issuing_Bank:"Bank of England",In_Circulation_Since:"1489",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The British pound was adopted as the country's primary unit of currency in 1707, following the union that brought together England and Scotland. However, the first recorded use of the pound sterling as a kind of currency was not until the year 760. £ represents the Pound sterling symbol.\n\n &nbsp; \n\nThe British pound is the currency with the longest history of use as a legal tender in its current form. During the height of the British Empire, many of Britain's former colonies, including Canada, Australia, and New Zealand, made use of the British pound as their primary form of currency.\n\n &nbsp; \n\nThe first printed British pound bills did not appear until the year 1855; prior to that, the Bank of England only created the bills by handwriting them out. During the latter part of the 19th century and the early part of the 20th century, a number of countries have policies in place that peg their currencies to the price of gold. Because of the gold standard, the values of currencies in every region of the world were able to be measured in the same way.\n\n &nbsp; \n\nIn 1971, the United Kingdom started the practise of letting the value of the pound float freely against other countries' currencies. Instead of using arbitrary pegs to control the value of the currency, market forces were allowed to determine it. In 1990, the United Kingdom investigated the possibility of fixing the value of the pound to that of the German mark but ultimately decided against doing so.\n\n &nbsp; \n\nThe United Kingdom made the decision in 2002 to maintain the pound sterling (GBP) as its official currency, despite the fact that the majority of nations in the European Union accepted the euro as their common currency at that time. In a referendum that was held in June 2016, British voters accepted a plan to withdraw completely from the European Union. This decision was the catalyst for the process that is now known as Brexit (British Exit from the European Union). The value of the pound took a significant hit after the United Kingdom's decision to withdraw from the European Union (EU), and subsequent trade talks produced additional price changes."},countries_accepting:{desc_1:"The Pound Sterling is the official currency of the United Kingdom. It is also the legal tender of the British Antarctic Territory, South Georgia and the South Sandwich Islands, and the crown dependencies of the United Kingdom, which include the Isle of Man and the Channel Islands. The pound sterling is used as the foundation for a number of other currencies around the world, such as the pound of the Falkland Islands, the pound of Saint Helena, the pound of Gibraltar, the pound of Guernsey, the pound of Jersey, the pound of Manx, the pound of Northern Ireland and the pound of Scotland.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of money you may need to go around the United Kingdom depends on a number of factors. Your holiday budget will be affected by the price of getting to your destination, the price of your lodging, and the price of your meals. Daily costs for a visitor on a tight budget in the United Kingdom can be around £47. However, the cost of a day of vacation can easily reach £317 if you use expensive modes of transportation, eat at Michelin-starred restaurants, and stay in only the best hotels. However, the price of a trip for two individuals can vary from £90 to £670.\n\n &nbsp; \n\nDepending on the season, the average cost of a hotel room in the United Kingdom ranges from £24 to £154. However, if you take public transit or hire a car service, the average daily cost of transportation might be anywhere from £9.00 to £61.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **Live Pound Sterling** **rate** in order to exchange your currency notes."},identification:{list:["The words \"Bank of England\" are printed in raised ink on the note's front, and the number of the nominal value as well as the area surrounding it are also printed in raised ink in the note's bottom right corner. The note's nominal value is also printed in raised ink.","Examine the area directly under the portrait of the Queen with a magnifying glass to read the face value of the note, which is printed in tiny characters and numbers in that area. This security feature can be found on every single banknote, regardless of whether it is made of polymer or paper.","When viewed under UV light, the face of the note's nominal value number will glow red and green, while the background will not change colour.","The written wording and colours on the note need to be clear and sharp to be legible. Documents that have smudges on them or fuzzy edges will be produced by faulty printing equipment that is utilised for forgery.","It is imperative that the written text on the note, in addition to its colours, be clear and sharp. These pictures were taken from flickr.com and saved to my computer.",'When the note is tilted, the crowning crown in the upper patch takes on the appearance of a three-dimensional object, while the digits "5" and "10" in the lower patch produce the word "Pounds," which is the name of the currency. Both locations are going to be filled with colours from the rainbow.',"Printing on the new currency is done with polymer, which is a lightweight and pliable type of plastic.","The ordinary £20 offering and the premium £50 offering both share a number of features. Place the note where the light can reach it, and read it. A photograph of the Queen and an illustrative figure of twenty or fifty pounds will be printed on both the front and back of the note.","A thread that is created out of metal. On the back of the note, there is a dashed-off silver metallic thread that may be seen. When the piece of paper is held up to a source of light, the thread will show as a thin, dark line.","As you tilt the note, the purple border that surrounds the window that you can look through should turn green. This colour is also represented by the pound sign (£). There is an equal amount of this effect on both sides of the note.","This conversation is currently in progress. The moving thread that runs through the fifty-pound note is embedded in the paper. In each of the five little windows of the casing are representations of the number 50 and the symbol for the pound sign. As you tilt the note from side to side, the photographs that are displayed on it scroll vertically. When you tilt the bill from side to side, the images on the note change laterally, and the 50 and the GBP symbol switch places."]},how_to_buy:{desc:"Whether you want to buy **Pound Sterling forex cards** and currency notes or sell the **Pound Sterling**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Pound Sterling to USD, INR to Pound Sterling, Pound Sterling to Dollar** or **Pound Sterling to Euro**, you only need to follow the below-written steps:"}}},{id:45,internalName:"seo_currency_page_bhutanese-ngultrum",type:"seo_currency_page_bhutanese-ngultrum",data:{name:"Bhutanese Ngultrum",code:"BTN",country_code:"BT",travel_country:"Bhutan",keywords:"Bhutanese ngultrum, ngultrum Currency,bhutanese ngultrum to inr, bhutanese ngultrum to usd, bhutanese ngultrum to aud,Bhutanese ngultrum exchange rate, Bhutanese ngultrum currency exchange, buy Bhutanese ngultrum, sell Bhutanese ngultrum, Bhutanese ngultrum forex cards, live Bhutanese ngultrum rate, Bhutanese ngultrum price",about:{title_text:"The Strong Currency of Bhutan",desc:'The Royal Monetary Authority of Bhutan, which serves as the country\'s central bank, is responsible for issuing both banknotes and coins in the national currency of Bhutan, which is denominated in ngultrum. The Bhutanese ngultrum, abbreviated as BTN, is the country\'s legal tender and the currency of the Kingdom of Bhutan. The kingdom of Bhutan is located in central Asia and is characterised by its hilly terrain.\n\n &nbsp; \n\nThe name of the currency is composed of two words: ngul, which means "silver" in the native Dzongkha language of Bhutan, and trum, which means "money" in the Hindi language. Together, these words make its full name. "Nu" is the abbreviation that is used in the country of Bhutan for the ngultrum, and one ngultrum is equal to one hundred chetrums. The Indian rupee is the only other international currency that can be easily exchanged for the ngultrum, which was introduced in 1974 and is still linked to it.\n\n &nbsp; \n\nThere are paper bills for the amounts of 1, 5, 10, 20, 50, and 100 Nu, as well as a bill for the value of 500 Nu. The current **Bhutanese ngultrum price** is INR (`inr_exchange_rate`) .'},quick_facts:{facts:{Country_of_Origin:"Bhutan",Symbol:"Nu.",Currency_Code:"BTN",Nick_Names:"-",Minor_units:"Chhertum","Denominations_(Banknotes)":"Nu.1, Nu.5, Nu.10, Nu.20, Nu.50, Nu.100, Nu.500 and Nu.1000",Motto:'The words "Food for All" can be found engraved on a BTN 0.2.',Identification_Feature:"On the obverse side of Nu.500, you can find Norbu Rimpochhe encircled by two Dragons and Ugyen Wangchuck.",Issuing_Bank:"Royal Monetary Authority of Bhutan",In_Circulation_Since:"1929"}},history:{desc:"After a period of economic reform, the Kingdom of Bhutan's central bank, the Bank of Bhutan, was founded in 1968. From that year until 1982, it was in charge of handling the country's currency. In 1982, the Royal Monetary Authority of Bhutan was given the responsibility of taking control of the country's monetary system and the manufacture of currency.\n\n &nbsp; \n\nUp until the year 1789, the majority of coins in circulation in Bhutan were produced from the Cooch Behar mint in the Indian state of West Bengal. Following the occupation of the mint by British colonial soldiers, Bhutan began producing its own currency, initially denominated in chetrum and initially composed of copper and silver. Blacksmiths with years of experience used hammers and dies to craft these items in the traditional manner. It wasn't until 1929 that Bhutan began producing its first modern coinage, and this was largely due to the country's limited interaction with modern industry.\n\n &nbsp; \n\nIn order to replace the Indian rupee, Bhutan began minting its own currency known as the chetrum. This money was mostly made up of halves of silver coins. Only hammered silver and copper coins were legal tender in circulation in India prior to the introduction of the silver half rupee and the bronze one paisa in the years 1929 and 1931, respectively (dated 1928). Half rupees composed of nickel were introduced into circulation in 1950.\n\n &nbsp; \n\nDespite the fact that coins from the Cooch Behar mint circulated alongside Bhutanese coinage, the first issuing of coins priced in naya paisa signified the advent of decimalization in 1957. This was the year that Bhutanese coins were first valued in naya paisa. 1966 saw the release of rupee coins made of cupro-nickel, in denominations of 25, 50, and 1 rupee respectively.\n\n &nbsp; \n\nAfter the government of Bhutan had begun the process of creating the country's economy in 1968, the country's currency was minted, and the Bank of Bhutan was established. The introduction of the Ngultrum was a part of the monetary reforms that took place in the country in 1974. At the time of its official launch, the Ngultrum had a value equivalent to one hundred Chhetrum. Ngultrums have consistently been issued at the same value as their Indian rupee equivalents since the currency's inception.\n\n &nbsp; \n\nThe Ministry of Finance issued brand new banknotes in 1974, including denominations of 1, 5, 10, and 100 New Guinea dollars respectively. In 1983, the role of issuing banknotes was transferred from the Ministry of Finance to the Royal Monetary Authority of Bhutan, which became Bhutan's central bank in the same year."},countries_accepting:{desc_1:"Unfortunately, you won't be able to use your Ngultrum anyplace else in the world if you leave Bhutan. It's only valid in Bhutan.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of money that you will need to explore the lovely country of Bhutan may vary depending on a variety of different factors. The cost of getting to your destination, the cost of your lodging, and the cost of your meals will all have an impact on the holiday spending budget you set aside for yourself. A traveller to Bhutan on a limited budget should plan to spend approximately BTN2,661 per day while they are there. When you factor in the costs of fancy transportation, dining at restaurants with Michelin stars, and staying in only the highest-rated hotels, however, the cost of a single day of vacation can easily reach BTN11,621. For two people, a trip to Bhutan can range anywhere from BTN5,000 to BTN23,000.\n\n &nbsp; \n\nThe price of a hotel room in Bhutan can range anywhere from BTN963 to BTN4,204 per night and per person. On the other hand, the cost of one day's worth of transportation might range anywhere from BTN820 to BTN3,582, depending on whether you take public transit or a private automobile.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Bhutanese ngultrum rate** in order to exchange your currency notes. You can also easily check out the **Bhutanese Ngultrum to AUD** rate."},identification:{list:["When held up to the light, it is possible to make out a water mark on every single note printed in Bhutan, with the exception of the Nu 1 and Nu 5 bills.","On all of the other banknotes, His Majesty the Fourth King is featured, but only The King is depicted on the Nu 1,000 and Nu 50 bills."," The RMA and the accompanying numerical value are woven into a special security thread that is present on all three different denominations of the Nu currency (100, 500, and 1,000). This thread is very small and uses a repetitive pattern.","Because every piece of cash has raised print, it is extremely difficult to produce a fake version of it.","The RMA is composed of a variety of elements, including but not limited to language written in Dzongkha, monetary values, a signature, and a seal.","All of the Nu 50, 100, and 1,000 notes have shimmering stripes on the backs of their respective bills.",'The words "Royal Monetary Authority of Bhutan" are printed in extremely fine micro type along the right and left edges of the note, as well as in the top centre of the note.',"In contrast to paper currency, the Nu 500 and Nu 1,000 banknotes are made entirely of cotton and can be folded multiple times without ripping. These characteristics set them apart from paper cash.","A dark line can be seen running nearly down the middle of Nu 5, 10, 20, and 50 bills when they are held up to the light in this manner."]},how_to_buy:{desc:"Whether you want to buy **Bhutanese ngultrum forex cards** and currency notes or sell the **Bhutanese Ngultrum**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Bhutanese Ngultrum to USD, INR to Bhutanese Ngultrum** or **Bhutanese Ngultrum to Euro**, you only need to follow the below-written steps:"}}},{id:46,internalName:"seo_currency_page_pakistani-rupee",type:"seo_currency_page_pakistani-rupee",data:{name:"Pakistani Rupee",code:"PKR",country_code:"PK",travel_country:"Pakistan",keywords:"Pakistani rupee,Pakistani rupee Currency, Pakistani rupee rate today, Pakistani rupee rate, Pakistani rupee price, , Pakistani rupee symbol,pakistani rupee to inr, pakistani rupee to usd, pakistani rupee to dollar, pakistani rupee to taka, pakistani rupees to pounds,Pakistani rupee exchange rate, Pakistani rupee currency exchange, buy Pakistani rupee, sell Pakistani rupee, Pakistani rupee forex cards, live Pakistani rupee rate, Pakistani rupee price",about:{title_text:"The Strong Currency of Pakistan",desc:"Since it was first introduced in 1948, the Pakistani rupee has served as the country of Pakistan's official currency. The State Bank of Pakistan is Pakistan's central bank and the body that is in charge of the issuance of money as well as the regulation of its use. All financial dealings in Pakistan are conducted in the nation's PKR currency, which is an abbreviation. Locally, the sign for the Pakistani rupee, which is denoted by either the Rp or Rs letter combination, is commonly used. The rupee is subdivided into 100 paise. Rupees, rupaya, and rupaye are all common names for the Pakistani Rupee. The **Pakistani rupee symbol** is Re. or Rs.\n\n &nbsp; \n\nThere are now nine different denominations of currency in circulation in Pakistan: 10, 20, 50, 75, 100, 500, 1000, and 5000 rupees.\n\n &nbsp; \n\nThe **Pakistani rupee rate today** is INR (`inr_exchange_rate`) . Please keep this in mind that the **Pakistani rupee price** keeps fluctuating."},quick_facts:{facts:{Country_of_Origin:"Pakistan",Symbol:"Re. or Rs.",Currency_Code:"PKR",Nick_Names:"-",Minor_units:"Paisa","Denominations_(Banknotes)":"Rs. 10/-, Rs. 20/-, Rs. 50/-, Rs. 75/-, Rs. 100/-, Rs. 500/-, Rs. 1,000/- and Rs. 5,000/-",Motto:"-",Identification_Feature:"On the reverse side of Rs. 1,000 note, you will find the image of the Islamia College in Peshawar.",Issuing_Bank:"State Bank of Pakistan",In_Circulation_Since:"1948"}},history:{desc:'In 1947, with the end of British control in Pakistan, the Pakistani rupee was officially introduced. In the beginning, Pakistani currency was nothing more than British Indian coinage that had the word "Pakistan" printed on it. In 1948, a brand new set of monetary denominations, both coins and bills, was introduced into circulation.\n\n &nbsp; \n\nIn 1948, the following coin denominations were introduced: one pice, one half an anna, one anna, two anna, one quarter of a rupee, and half a rupee. In 1951, a coin worth one pie was first circulated. In 1961, the first coins with denominations of 1, 5, and 10 pice were issued. Later that same year, coins with denominations of 1, 5, and 10 paise were produced. Coins for 10 and 25 paise were issued for the first time in 1963, while the 2 paise coin came into circulation the year after that. The one rupee currency was issued again in 1979, and then the two rupee coin was issued again in 1998, and the five rupee coin was issued in 2002.\n\n &nbsp; \n\nThe minting of coins for 1 paisa and 2 paise was discontinued in the years 1979 and 1976, respectively. After the year 1996, the 5, 10, 25, and 50 paise notes ceased to be used for circulation.'},countries_accepting:{desc_1:"Pakistani Rupee is the legal tender of the country of Pakistan. This currency is used by people for transactions as well as the sale and purchase of various products and services.",list:[],desc_2:""},amount_for_trip:{desc:"The sum of money you'll need to explore Pakistan's wonderful country varies according to a number of things. Your holiday budget will be affected by the price of getting to your destination, the price of your lodging, and the price of your meals. A visitor to Pakistan should expect to spend around PKR 4,622 per day on a tight budget. However, the cost of a day of vacation can easily exceed PKR 29,275 when you include in the costs of luxurious transportation, dining at Michelin-starred restaurants, and staying in only the top-rated hotels. In the meantime, the price of a vacation for two individuals can range from PKR 9,200 to PKR 60,550.\n\n &nbsp; \n\nA hotel room in Pakistan can cost anywhere from PKR 2,133 to PKR 12,906 per night, per person. In contrast, daily transportation costs might vary from PKR 720 to PKR 3,610, depending on whether you go for public transit or private vehicle.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **Live Pakistani Rupee** **rate** in order to exchange your currency notes. You can keep an eye on the ever-changing Pakistani rupee rate to convert your **Pakistani Rupee to Dollar, Pakistani Rupee to Taka** and **Pakistani Rupees to Pounds.**"},identification:{list:["The banknote paper has a security thread that is partially implanted into it. This thread is designed to resemble a window. It runs all the way down the left-hand side of the front, all the way to the bottom. A second security thread, which cannot be removed, can be found partially inserted in the front left side of each banknote. When held up to the light that is emitted, this thread appears to be whole and unbroken. However, when the thread is spread down flat, it gives the appearance of being sloppy and broken. This is a significant red flag that the money in question might be fake.","The pattern that is found on the banknotes is not printed, but rather etched into the surface that is coated, which gives the design a form that is slightly raised.","The image of Quaid e Azam is printed as a watermark on the front of each banknote, on the left-hand side. This particular watermark does not appear elsewhere on the note at any time. Instead, in order to get the intended look, it was created by cutting and scratching through many layers of paper. When a note is placed on a level surface, the authenticity of the note can be determined by searching for a little white outline that surrounds the watermark, and when the note is held up to transmitted light, the currency value can be seen in the picture.","When the authentic notes are exposed to transmitted light, the denomination numerals that are located on the left top of the obverse and the right top of the reverse do not fade away as you might anticipate they would.","Due to the anti-scan and anti-copy line patterns on the note, it is not feasible to directly scan or photocopy the note.","There is a security thread that has the appearance of a window on the top and bottom left corners of the front left side of the bill. When viewed in both regular light and ultraviolet light, it has a distinct change in hue.","The front of the note features a design that consists of a series of geometric shapes.","The denominational numeral is printed in Urdu on the right and left upper sides of the note, however, it is written in English on the right lower side of the note. Both sides of the note bear the same design.","Intaglio lines can be found at the extreme left and right corners of a banknote.","The paper that is used to create banknotes is a unique type of paper that cannot tear or curl in any way. In addition to being more robust than tissue paper, it also cannot be folded in half like paper towels.","Genuine currency, when subjected to excessive force, has the potential to shred, but you will never observe it breaking. However, most counterfeiters in Pakistan print two sides of bogus notes and glue them together with a forged security thread in the middle, which eventually causes the two sides to separate.","Bills that have been tampered with can be identified as such by rubbing your finger across the watermark on the bill. If you sense a shift in texture beneath your skin, it is quite likely that the note is genuine. However, you should most likely go ahead and accept it if the zone around the watermark is even and unbroken.","The ink that is used on Pakistani banknotes is one of a kind and is designed to withstand being wet without spreading. In the meanwhile, the ink on the counterfeit bills will become illegible very rapidly if they become moist. A simple rubbing motion combined with a drop of water placed anywhere on the surface of the note will expose any attempts at counterfeiting. The smearing of the ink is a clear indication that the note cannot be trusted.","It is important to keep in mind that actual bills, when held up to a black light, will not emit a glow in the dark. However, when counterfeit Pakistani banknotes are subjected to UV light, the paper will frequently change colour and sometimes even sparkle.","In Pakistan, counterfeit banknotes are frequently identifiable by their colour, which is identical to the colour of the national flag. The 500, 1000, and 5000 banknotes all have flags, and depending on the angle at which the note is seen, each of the flags will exhibit a different colour. If they don't, you have every reason to believe that the money is fake, and you should decline to accept it.","The Urdu value of the note is printed in the upper left-hand corner of the face of the money. If you place it on a level surface, all that will be visible from the figures is their shadows. However, if you hold the note up to the transmitted light, you will be able to read all of the figures on the note."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Pakistani Rupee**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Pakistani Rupee to USD, INR to Pakistani Rupee** or **Pakistani Rupee to Euro**, you only need to follow the below-written steps:"}}},{id:47,internalName:"seo_currency_page_nepalese-rupee",type:"seo_currency_page_nepalese-rupee",data:{name:"Nepalese Rupee",code:"NPR",country_code:"NP",travel_country:"Nepal",keywords:"Nepalese rupee,Nepalese rupee Currency, Nepalese rupee symbol,nepalese rupee to gbp1, nepalese rupee to inr,Nepalese rupee exchange rate, Nepalese rupee currency exchange, buy Nepalese rupee, sell Nepalese rupee, Nepalese rupee forex cards, live Nepalese rupee rate, Nepalese rupee price",about:{title_text:"The Strong Currency of Nepal",desc:"The Nepalese rupee (NPR) is the currency that can be exchanged for goods and services in the Federal Democratic Republic of Nepal. The lowest value that can be purchased with one Nepalese rupee is one hundred paisa. The Nepal Rastra Bank, which serves as the central bank for the country, is in charge of overseeing the production of brand new Nepalese rupees. It is common practise to denote the NPR with Rs; however, Rp is also a suitable representation.vThere is a fixed exchange rate between the Nepalese franc (NPR) and the Indian rupee (INR), which is 1.6 NPR for every 1 INR. The Nepalese rupee symbol is रु.\n\n &nbsp; \n\nThe NPR has, up until this point in time, issued coins with face values of 1, 5, 10, 25, and 50 paisa each. Coins of 1, 2, 5, and 10 rupees are also considered valid tender. There are banknotes available for denominations of 1, 2, 5, 10, 20, 50, 100, 500, and 1,000 rupees.\n\n &nbsp; \n\nThe **Nepalese Rupee price** is INR (`inr_exchange_rate`) ."},quick_facts:{facts:{Country_of_Origin:"Nepal",Symbol:"रु.",Currency_Code:"NPR",Nick_Names:"-",Minor_units:"Paisa","Denominations_(Banknotes)":"रु1, रु2, रु5, रु10, रु20, रु25, रु50, रु100, रु250, रु500 and रु1000",Motto:"-",Identification_Feature:"On the obverse side of the 1,000 rupees note, you will find the images of Swayambhunath Stupa, Mount Everest and Harati Temple.",Issuing_Bank:"Nepal Rastra Bank",In_Circulation_Since:"September 17, 1945",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"In 1932, the Nepalese Mohar was dethroned as the nation's primary unit of currency, and it was succeeded by the Nepali Rupee (NPR). The Indian rupee is used as a point of reference for the peg that governs the country's exchange rate (INR). In 1993, the Nepalese currency was finally allowed to be freely converted. The new exchange rate for the Nepali Rupee is one NPR to one hundred and sixty Indian Rupees.\n\n &nbsp; \n\nIn 1955, the rifle cartridge boxes of the Gurkha soldiers who fought against the Imperial Japanese throughout the Pacific theatre of World War II were recycled into coins for their 4 Paisa currency. These coins were used in the country of Nepal. In recognition of their bravery and success in combat, the primers were removed from the shell casings, and the resulting empty shells were repurposed as coins worth four Paisa each.\n\n &nbsp; \n\nDue to the limited frequency with which these incidents occur, it was judged that continuing to produce these coins for longer than a year would be a waste of resources.\n\n &nbsp; \n\nDuring the reign of King Birendra, two completely separate series of banknotes were published. On the first series of notes, the monarch is depicted wearing a military uniform. On the second series of notes, however, he is wearing a traditional Nepalese crown that is decorated with feathers from a bird of paradise. New denominations of banknotes, including the normal 2 and 20 rupee notes as well as the exceptional 25 and 250 rupee notes, were issued at this time as well.\n\n &nbsp; \n\nMount Everest was featured on a 500 rupee note that was introduced in October of 2007, replacing the usual image of the king. In May of 2008, Nepal made the historic transition from a monarchy to a republic, and this represents that shift.\n\n &nbsp; \n\nIn 2008, new banknotes of 5, 10, 20, 50, and 100 rupees showing Mount Everest were introduced into circulation. These new banknotes did not have any reference to the king. The first 500 and 1000 rupee banknotes were produced on paper with a watermark depicting a crowned portrait of the king in the \"window\" on the right side of the faces of the notes. These portraits were placed on the paper during the printing process. Also, the Nepalese rupee symbol is रु.\n\n &nbsp; \n\nA new series of banknotes was issued by the Nepal Rastra Bank in 2012, which was quite similar to the series that was issued in 2007, except the back of each note featured English inscriptions and the year that it was issued."},countries_accepting:{desc_1:"The Nepalese rupee is the legal tender of Nepal and is used by citizens and tourists for any kind of transaction within the country.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of money that you will need to explore the lovely country of Nepal may vary depending on a variety of different factors. The cost of getting to your destination, the cost of your lodging, and the cost of your meals will all have an impact on the holiday spending budget you set aside for yourself. A traveller to Nepal on a limited budget should plan to spend approximately NP 1,474 per day while they are there. When you factor in the costs of fancy transportation, dining at restaurants with Michelin stars, and staying in only the highest-rated hotels, however, the cost of a single day of vacation can easily reach NP 11,545. On the other hand, the cost of travel for two people can range anywhere from NPR 3,474 to NPR 23,545.\n\n &nbsp; \n\nThe price of a hotel room in Nepal can range anywhere from NPR 536 to NPR 4,311 per night and per person. To put that in perspective, the cost of one day's worth of transportation might range anywhere from NPR 440 to NPR 3,361, depending on whether you take public transit or a private automobile.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Nepalese Rupee rate** in order to exchange your currency notes."},identification:{list:["When real and counterfeit money are shaken together, the actual bills produce a louder sound, whereas the counterfeit bills become less audible as they approach your ear.","Genuine note paper has a texture that is uniform, somewhat gritty, and firm to the touch, in stark contrast to the feel of counterfeit note paper, which is slick, lumpy, and thick. False banknotes do not have the same lustre as their legal tender equivalents.","The genuine note has a dark and deep tone, while the counterfeit bill is lighter in appearance.","When viewed in bright light, the watermark that is located on the right side of the original note is easy to make out; but, on the fake note, it just appears as a collection of black dots.","Notes that feature security threads that are authentic can be read by just holding them up to the light, but notes that are counterfeit have security threads that conceal the text.","The name of the Nepal Rastra Bank is printed in colour on the left half of the white space that is located on the right side of the note; however, the wording on the counterfeit is difficult to make out.","When viewed from the left and right, the step features of the true note display a small tick, whereas the step features of fake notes do not."]},how_to_buy:{desc:"Whether you want to buy **Nepalese Rupee forex cards** and currency notes or sell the **Nepalese Rupee**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Nepalese Rupee to USD, INR to Nepalese Rupee, Nepalese Rupee to GBPL** or **Nepalese Rupee to Euro**, you only need to follow the below-written steps:"}}},{id:48,internalName:"seo_currency_page_myanmar-kyat",type:"seo_currency_page_myanmar-kyat",data:{name:"Myanmar Kyat",code:"MMK",country_code:"MM",travel_country:"Myanmar",keywords:"Myanmar kyat,Myanmar kyat rate, , Myanmar kyat symbol,1000 myanmar kyat to indian rupee, 1 indian rupee to myanmar kyat,Myanmar kyat exchange rate, Myanmar kyat currency exchange, buy Myanmar kyat, sell Myanmar kyat, Myanmar kyat forex cards, live Myanmar kyat rate, Myanmar kyat price",about:{title_text:"The Strong Currency of Myanmar",desc:'Myanmar is formerly known as Burma, and its official currency is called the Myanmar Kyat (MMK). The kyat was initially derived from the ancient Burmese unit of measurement known as the kyattha, which was equivalent to 16.3 grammes of silver. One kyat is equal to one hundred pyas (also written as pyat). This currency is represented by the letter "K." The Myanmar kyat symbol is Pya.\n\n &nbsp; \n\nIt wasn\'t until 1952 that MMK was finally put into effect, following a series of political and economic changes.\n\n &nbsp; \n\nThe **Myanmar kyat rate** is INR (`inr_exchange_rate`) .'},quick_facts:{facts:{Country_of_Origin:"Myanmar",Symbol:"Pya",Currency_Code:"MMK",Nick_Names:"-",Minor_units:"Pya","Denominations_(Banknotes)":"Ks. 50/-, Ks. 100/-, Ks. 200/-, Ks. 500/-, Ks. 1,000/-, Ks. 5,000/- and Ks. 10,000/-",Motto:"-",Identification_Feature:"When it comes to Ks. 1,000/- note, you will find the image of Aung San, the Burmese politician and activist, on the obverse side of the note.",Issuing_Bank:"Central Bank of Myanmar",In_Circulation_Since:"July 1, 1952",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"At the present time, the issuance and distribution of kyat is solely the responsibility of the Central Bank of Myanmar, which is recognised by law as Myanmar's monetary authority. Gold and silver pieces were included in the initial circulation of the kyat currency, which took place in 1852. Because of the shared heritage of the British Empire and the Indian rupee during that time period, silver coins that were struck in the country between the years 1824 and 1948 were recognised as valid tender in India throughout that period.\n\n &nbsp; \n\nBy the year 1948, the Union Bank of Burma was the institution in charge of determining the nation's monetary policy. On the other hand, the bank did not start issuing its own money until the year 1952.\n\n &nbsp; \n\nThe present iteration of the kyat currency was introduced into use for the first time in 1952. Its initial value was based on the rupee, however, the value of that currency has significantly decreased since then. In 1962, the government took over all of the nation's banks and combined them into a single institution so that the transition to a socialist monetary system would be easier. The Central Bank of Burma was renamed the Central Bank of Myanmar in 1988, the same year that Burma returned to an economic structure that was based on free market principles."},countries_accepting:{desc_1:"The Myanmar Kyat is the legal tender of Myanmar and is used within the country for various kinds of transactions.",list:[],desc_2:""},amount_for_trip:{desc:"There are a lot of factors that go into determining how much money you will need to move around in the beautiful country of Myanmar, so it is important to keep all of these things in mind. The amount that you spend on transportation to and around your location, the cost of hotel, and the cost of food will all have an impact on the total price that you pay for your trip. When travelling to Myanmar on a limited budget, the average daily cost for a tourist can amount to about MMK70,198. If you choose to travel in style, dine at Michelin-starred restaurants, and only stay in five-star hotels throughout your whole trip, the cost of a single day of your vacation might easily surpass MMK136,032. Between now and then, the cost of travel for two people can range anywhere from MMK145,000 to MMK270,000.\n\n &nbsp; \n\nIn Myanmar, the cost of a room for the night can range anywhere from MMK8,047 to MMK48,045 per person, each day. Alternately, the daily cost of transportation could range anywhere fromMMK4,391 to MMK8,067 on average, depending on whether you travel by public transit or a private vehicle.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Myanmar kyat rate** in order to exchange your currency notes. You can also keep an eye on the **Myanmar kyat price** for various exchange rates including **1000 Myanmar kyat to Indian rupee** and **Indian rupee to Myanmar kyat.**"},identification:{list:["If the written denomination does not contain colour-changing ink, the bill is likely counterfeit. When you hold an authentic banknote and tilt it to the left or right, a colour shift happens.","All authentic banknotes contain the watermark, a specialised security feature.","Any blurring of a banknote's borders, lettering, or text is a dead giveaway that it is counterfeit. Due to the printing dies used, the early banknotes feature intricately textured motifs and lines. In most instances, fake printers cannot produce the same degree of realism.","Additionally, valid banknotes include micro printing.","If the microprinting cannot be read under a magnifying glass, it is likely a fake. Banknotes with raised printing are difficult for counterfeiters to copy. By slowly dragging your fingertips along the note, you can detect any raised printing.","A short embedded strip, known as a security thread, runs across the front of banknotes. The microprinting in the security thread will provide an additional degree of security for authentic banknotes."]},how_to_buy:{desc:"Whether you want to buy **Myanmar kyat forex cards** and currency notes or sell the **Myanmar Kyat**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Myanmar Kyat to USD, INR to Myanmar Kyat** or **Myanmar Kyat to Euro**, you only need to follow the below-written steps:"}}},{id:49,internalName:"seo_currency_page_iranian-rial",type:"seo_currency_page_iranian-rial",data:{name:"Iranian Rial",code:"IRR",country_code:"IR",travel_country:"Iran",keywords:"Iranian rial, rial Currency, Iranian rial rate today, Iranian rial symbol, rial to inr, iranian rial to usd, iranian rial to kuwaiti dinar, iranian rial to dollar, 5000 iranian rial to aed, iranian rial to aud, iranian rial to saudi riyal, rial exchange rate, Iranian rial currency exchange, buy Iranian rial, sell Iranian rial, Iranian rial forex cards, live Iranian rial rate, Iranian rial price",about:{title_text:"The Strong Currency of Iran",desc:"Iran has its own national currency, which is known as the rial. IRR is the currency exchange sign for the Iranian rial. The Islamic Republic of Iran's Central Bank is responsible for issuing and managing the rial currency. This currency was initially used in 1798 and was named after the Spanish real. Despite the fact that the value of the rial is not technically linked to any other currency, it has maintained a value that is quite stable over the past few years at approximately 42,000 IRR for each United States dollar. Iran's economy is dependent on the refining and export of oil; however, sanctions placed in reaction to the country's nuclear programme have caused a reduction in Iran's position in international finance and trade. The **Iranian rial symbol** is ﷼ or Rl/Rls.\n\n &nbsp; \n\nSince IRR is not freely traded on the world foreign exchange market, it is frequently referred to as a prohibited or inconvertible currency. The following face values are used for coins in circulation: fifty, one hundred, two hundred, five hundred, one thousand, two thousand, and five thousand rials; the following face values are used for banknotes: one hundred, two hundred, five hundred, one thousand, two thousand, five thousand, ten thousand, twenty thousand, and fifty thousand rials.\n\n &nbsp; \n\nThe **Iranian rial rate today** is INR (`inr_exchange_rate`) . Please note that the **Iranian rial price** keeps fluctuating."},quick_facts:{facts:{Country_of_Origin:"Iran",Symbol:"﷼ or Rl/Rls",Currency_Code:"IRR",Nick_Names:"-",Minor_units:"Dinar","Denominations_(Banknotes)":"Rls 1,000, Rls 2,000, Rls 5,000, Rls 10,000, Rls 20,000, Rls 50,000, Rls 100,000, Rls 500,000 and Rls 1,000,000",Motto:"-",Identification_Feature:"In the intergenerational series, you will find the image of Ruhollah Khomeini on the obverse side of the Rls 10,000 note.",Issuing_Bank:"Central Bank of Iran (since 1960)",In_Circulation_Since:"1798"}},history:{desc:"In the year 1798, Iran began minting its own currency, the rial, which had an initial value of 1,250 dinars (now equivalent to one-eighth of a toman). The rial was replaced in 1825 by the qiran as part of a transition to a decimal monetary system. The qiran was divided into 20 shahi or 1,000 dinars and was valued at one tenth of a toman. The rial had been worth one tenth of a toman. The rial, which was introduced in 1932 as a replacement for the qiran and had the same value as the qiran, was afterwards subdivided into 100 new dinars.\n\n &nbsp; \n\nIn 1932, Iran once again began using the rial as its official currency. Value plummeted during the Islamic revolution that occurred in 1979.\n\n &nbsp; \n\nBefore reaching a level of stability at Rls 17,000 by the end of the week in January 2012, the unofficial rial/US dollar exchange rate experienced significant volatility. This was caused by the rial losing half of its value in a matter of days as a result of fresh international sanctions levied against the CBI. In spite of the overall adverse effects on the economy, this helped Iran's indigenous sector become more competitive on a worldwide scale.\n\n &nbsp; \n\nCBI announced on January 28, 2012 that it would seek to meet all demand for foreign currency through banks in light of President Mahmoud Ahmadinejad's decision to liberalise the mechanism by which banks set their interest rates. In addition, CBI stated that it would fix the official rate of the rial against the dollar at Rls 12,260 beginning on January 28, 2012. CBI also stated that it would fix the official rate of the rial against the dollar at Rls 12,260 beginning on January 28, 2012.\n\n &nbsp; \n\nThe value of the Iranian rial has decreased around fivefold since the beginning of 2018, culminating in unprecedented inflation as of June 2020."},countries_accepting:{desc_1:"Only in Iran will you be able to use Iranian rials, the official currency of the country, for all kinds of monetary transactions.",list:[],desc_2:""},amount_for_trip:{desc:"There are several factors that affect the amount of money you may need while travelling in the incredible city of Iran. The amount spent on transportation to and around your location, the cost of the accommodation, and the cost of food will all have an effect on the total cost of your vacation.\n\n &nbsp; \n\nOn a budgeted trip, a tourist's daily expenses in Iran can be about ﷼745,345. On the other hand, when you factor in the expense of lavish transportation, dining at Michelin-starred restaurants and staying in top-rated hotels only, the cost of a day of vacation can easily exceed ﷼5,351,157. Meanwhile, the cost of travelling for two people can range anywhere between ﷼15,00,000 to ﷼10,000,000.\n\n &nbsp; \n\nThe cost of a night's stay in Iran can fluctuate anywhere from ﷼543,942 to ﷼4,187,743 per person per day. On the other hand, the typical cost of a day's worth of transportation can range anywhere from ﷼21,112 to ﷼227,976 each day, depending on whether or not you choose to take public transit or private transportation.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Iranian rial rate** in order to exchange your currency notes. You can check out the conversion rate of **Iranian rial to Kuwaiti dinar, Iranian rial to Dollar, 5000 Iranian rial to AED, Iranian rial to AUD** and **Iranian rial to Saudi riyal.**"},identification:{list:["Fake bills are more likely to be printed without colour-changing ink. When viewed from a different position, the hue of a banknote shifts subtly.","All authentic banknotes have a watermark, a special security feature.","The borders, font, or lettering on a counterfeit currency will be smudged. Copies printed by forgers rarely look like the original. Be sure to examine the bill carefully, paying special attention to the margins, to ensure it has not been tampered with in any way.","Microprinting can be found on genuine banknotes as well. If the microprinting cannot be read when held up to a microscope, it is likely to be a fake.","Raised printing on genuine banknotes makes them easy to spot and is challenging for counterfeiters to imitate. You can detect any raised printing by moving your fingers slowly down the note. By rubbing your nail against the raised printing, you should feel a tiny vibration if it was done properly. If you can't feel this texture, you should examine the bill more closely.","There is a tiny strip embedded across the face of genuine banknotes called a security thread. Authentic banknotes will be more secure thanks to microprinting in the security thread.","The use of ultraviolet light in the fight against counterfeiting is widespread because it allows for the rapid and reliable detection of phoney banknotes."]},how_to_buy:{desc:"Whether you want to buy **Iranian rial forex cards** and currency notes or sell the **Iranian Rial**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Iranian Rial to USD, INR to Iranian Rial** or **Iranian Rial to Euro**, you only need to follow the below-written steps:"}}},{id:50,internalName:"seo_currency_page_mexican-peso",type:"seo_currency_page_mexican-peso",data:{name:"Mexican Peso",code:"MXN",country_code:"MX",travel_country:"Mexico",keywords:"Mexican peso,Mexican peso Currency, Mexican peso rate today, Mexican peso rate, Mexican peso symbol ,mexican peso to inr, mexican peso to usd, mexican peso to dollar,Mexican peso exchange rate, Mexican peso currency exchange, buy Mexican peso, sell Mexican peso, Mexican peso forex cards, live Mexican peso rate, Mexican peso price",about:{title_text:"The Strong Currency of Mexico",desc:'Pesos is the name of the currency used in Mexico. The majority of contemporary currencies, which can trace their origins back to the Spanish dollar in use between the 16th and 19th centuries, continue to utilise the dollar sign "$." The code for the peso was MXP prior to the revaluation that took place in 1993; however, since then, it has been changed to MXN. The Mexican peso symbol is $ or Mex$.\n\n &nbsp; \n\nThe Mexican peso has risen to become the most traded currency in Latin America, and by 2022, it is projected to become the sixth most traded currency in the entire globe.\n\n &nbsp; \n\nThe **Mexican peso rate today** is INR (`inr_exchange_rate`) . Please note that the **Mexican peso rate** keeps fluctuating.'},quick_facts:{facts:{Country_of_Origin:"Mexico",Symbol:"$ or Mex$",Currency_Code:"MXN",Nick_Names:"-",Minor_units:"Centavo","Denominations_(Banknotes)":"$20, $50, $100, $200, $500 and $1,000",Motto:"-",Identification_Feature:"On the obverse side of MXP $1,000, you will find the image of Cuauhtémoc, the Aztec ruler of Tenochtitlan",Issuing_Bank:"Bank of Mexico",In_Circulation_Since:"January 1, 1993",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'The real, a silver dollar that served as Spain\'s legal currency at the time, served as the basis for the creation of the peso. The origin of the name "Mexican" can be traced back to the silver 8-real coin, which was the most common denomination of the currency up until approximately the middle of the nineteenth century.\n\n &nbsp; \n\nIn 1863, the first centavo coins, with a value equivalent to one hundredth of a peso, were introduced into circulation. However, despite their continued circulation long into the 20th century, these coins contained less and less gold over time.\n\n &nbsp; \n\nIn 1993, the Mexican government issued a new peso, also known as a nuevo peso, to replace the original peso. This was done as a response to the hyperinflation and currency depreciation that occurred in the 1980s as a result of Mexico\'s default on its foreign debt due to the oil crisis that occurred in the 1970s. The old currency was totally phased out, and the new currency was introduced in its place.\n\n &nbsp; \n\nThe years that followed the Great Recession are a good illustration of how well the peso performs in times when there is less volatility on a global scale. As a result of the Central Bank of Mexico\'s (Banxico) implementation of a variety of policy steps, the value of the peso has been steadily going up while at the same time the market\'s volatility has been going down. After Donald Trump was elected president in 2016, there was a period of greater volatility and increasing uncertainty around the North American Free Trade Agreement. This resulted in the peso experiencing a value loss of approximately twenty percent in just three months (NAFTA).\n\n &nbsp; \n\nThe value of the Mexican peso, both locally and internationally, cannot be matched by any other currency. Although the United States began dividing their dollar into 100 cents in 1793, Mexico did not begin doing so until 1863, when the Second Mexican Empire, led by Emperor Maximillan, began minting pesos divided into 100 centavos. During this time, the United States began dividing their dollar into 100 cents. In 1873, as a result of East Asian merchants rejecting or devaluing the newly designed peso coins, the Mexican government under Benito Juarez and Porfirio Diaz reverted the silver 1-peso denomination to the "cap-and-ray design" that had been used for the eight reales prior to 1873. This design remained in use until 1897.\n\n &nbsp; \n\nMexico\'s economy avoided the hyperinflation that plagued many other Latin American countries for the entirety of the 20th century, which helped to retain the peso as one of the region\'s more stable currencies. This was in contrast to the economies of many other Latin American countries.\n\n &nbsp; \n\nThe Bank of Mexico adopted the nuevo peso as the country\'s official currency on January 1, 1993. The nuevo peso is often referred to as the "new peso" or "MXN."'},countries_accepting:{desc_1:"Being the legal tender of Mexico, this currency is only used in this country for transactions of goods and services.",list:[],desc_2:""},amount_for_trip:{desc:"The sum of money you'll need to explore Mexico's wonderful country varies according to a number of things. Your holiday budget will be affected by the price of getting to your destination, the price of your lodging, and the price of your meals. A visitor to Mexico should expect to spend around M$1,735 per day on a tight budget. However, the cost of a day of vacation can easily exceed M$5,404 when you include the costs of luxurious transportation, dining at Michelin-starred restaurants, and staying in only the top-rated hotels. In the meantime, the price of a vacation for two individuals can range from M$3,500 to M$11,000.\n\n &nbsp; \n\nA hotel room in Mexico can cost anywhere from M$674 to M$1,967 per night, per person. In contrast, daily transportation costs might vary from M$275 to M$825, depending on whether you go for public transit or a private vehicle.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Mexican Peso rate** in order to exchange your currency notes. You can check out **Mexican Peso to Dollar** rate today and exchange your notes as per the **Mexican peso price**."},identification:{list:["Paper and polymer are the two materials that are used to print banknotes. The most recent series of Mexican banknotes are printed on polymer, which is a one-of-a-kind sort of plastic paper. The polymer is used for the production of the notes with the lowest denominations: $20, $50, and $100 pesos. The remaining three banknotes are printed on traditional banknote paper. They are of these denominations: $200, $500, and $1,000","When placed under an ultra-violet lamp, banknote paper glows in a manner that is distinct from the fluorescence of regular paper. This is due to the fact that banknote paper is made from fabric fibres rather than wood pulp and that it does not include any china clay or other colours.",'Be sure to run your hands over the banknotes to examine the quality of the paper they are printed on; it should be equivalent to the paper quality of other major currencies. Because the paper used for counterfeit notes is typically thicker than the paper used for genuine banknotes, you should check for additional security elements if the note does not "feel" properly.','Paper banknotes in Mexico all have a "watermark" that, when examined with a black light, displays a silhouetted image. Banknotes made of polymer plastic do not include a watermark since they instead use an embossed security feature that may be viewed through the perforations.','There is a holographic optical thread on the obverse side of each banknote worth 200, 500, and 1000 pesos. The picture on the thread shifts depending on the angle at which the note is seen. This "holographic" design approach can also be seen applied to the denominational number, which can be found in the upper right corner of the note.',"Polymer notes may contain embossments that are crisply pressed into the plastic paper or holographic ink on vital aspects of the artwork, both of which are visible when the note is tilted in the light. Additionally, polymer notes may have holographic ink on essential elements of the artwork.",'The printing of bills is produced by banks using a special printing method that involves pressing the images onto the note. Because of this method, the printing has a "raised" quality, which is most noticeable on paper that has recently been printed.',"Regardless of how often a note has been used or what kind of material it is composed of (polymer or traditional banknote paper), the printing on the note should always be crisp, clear, and indisputable, with lines that are continuous and colours that are consistent with one another."]},how_to_buy:{desc:"Whether you want to buy **Mexican peso forex cards** and currency notes or sell the **Mexican Peso**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Mexican Peso to USD, INR to Mexican Peso** or **Mexican Peso to Euro**, you only need to follow the below-written steps:"}}},{id:51,internalName:"seo_currency_page_new-taiwan-dollar",type:"seo_currency_page_new-taiwan-dollar",data:{name:"New Taiwan Dollar",code:"TWD",country_code:"TW",travel_country:"Taiwan",keywords:"New Taiwan dollar, Taiwan dollar Currency, new taiwan dollar notes, buy new taiwan dollar in India , taiwan dollar to inr, new taiwan dollar to euro, new taiwan dollar to GBP, Taiwan dollar exchange rate, New Taiwan dollar currency exchange, buy New Taiwan dollar, sell New Taiwan dollar, New Taiwan dollar forex cards, live New Taiwan dollar rate, New Taiwan dollar price",about:{title_text:"The Strong Currency of Taiwan",desc:"Taiwan adopted the New Taiwan dollar as its official currency in 1949, when it replaced the Old Taiwan dollar. Since that time, Taiwan has utilised the New Taiwan dollar as its primary means of exchange. The New Taiwan dollar, which serves as Taiwan's official form of money, is issued by the Central Bank of the Republic of China (Taiwan), which is the country's central bank.\n\n &nbsp; \n\nTWD is the ISO code for the Taiwanese dollar, and NT$ is the international symbol for the currency. The **New Taiwan Dollar notes** come in denominations of 100 NTD, 500 NTD, and 1,000 NTD respectively. Even less frequently utilised are bills with a value of NT$200 and NT$2,000 respectively. There are coins with denominations of 1, 5, 10, and 50 New Taiwan Dollars (NT$), in addition to the 20 New Taiwan Dollar coin, which is used somewhat less frequently.\n\n &nbsp; \n\nThe current **New Taiwan dollar price** is INR (`inr_exchange_rate`) . You can **buy New Taiwan Dollar in India** for a hassle-free trip."},quick_facts:{facts:{Country_of_Origin:"Taiwan",Symbol:"NT$, 圓, $",Currency_Code:"TWD",Nick_Names:"Yúan, kuài, kho and ngiùn",Minor_units:"Jiao","Denominations_(Banknotes)":"NT$100, NT$200, NT$500, NT$1000, and NT$2000",Motto:"-",Identification_Feature:"On the reverse side of NT$2000, you will find the images of Formosan landlocked salmon and Mount Nanhu",Issuing_Bank:"Central Bank of the Republic of China (Taiwan)",In_Circulation_Since:"July 3, 2000"}},history:{desc:'The island is officially known as the Republic of China, although the majority of people simply refer to it as "Taiwan." The Republic of China was established in China in 1912.\n\n &nbsp; \n\nFollowing the establishment of Qing Dynasty authority in Taiwan in 1662, 7 Chinese silver taels were used interchangeably with silver from other countries. There were other coins made of copper that originated in the Kingdom of Tungning that were used throughout Taiwan at the time.\n\n &nbsp; \n\nWhen the Bank of Taiwan was first established in 1899, one of the first jobs it was given was to issue silver and gold certificates that could be redeemed for currency. As of the second quarter of the year 2021, one United States dollar was equivalent to 28.38 New Taiwan Dollars. In 1992, one dollar could buy twenty-four New Taiwan Dollars, but by 1998, that value had decreased to thirty-four New Taiwan Dollars (NT$).\n\n &nbsp; \n\nOver the course of the preceding two decades, the Taiwanese dollar\'s value relative to the US dollar has vacillated wildly between the ranges of NT$28 and NT$35.\n\n &nbsp; \n\nThe Taiwan dollar is the official currency of Taiwan. It was first circulated on May 20, 1946. (which later became known as the Old Taiwan dollar). The new money features Dr. Sun Yat-sen, who is widely regarded as the father of modern China. The new bills come in denominations of both one dollar and five hundred dollars.\n\n &nbsp; \n\nAs a direct result of hyperinflation, a note with a face value of $10,000 was printed in 1948, and by 1949, promissory notes with face values of up to one million dollars were being printed.\n\n &nbsp; \n\nInitially, the New Taiwan dollar was only used on Taiwan. Even though it operated as a government in exile, the Republic of China did not make use of the New Taiwan dollar as its official currency. The Central Bank of China continued to have the same role in the issuance of currency (first established in Guangzhou, China, in 1924).\n\n &nbsp; \n\nUp to the year 1992, the silver dollar was acknowledged in theory but not in practice as a valid form of payment within the Republic of China. However, Chiang held out hope that his Nationalist Party would one day reclaim control of the mainland; as a result, the New Taiwan dollar was viewed more like a provincial currency than a national currency during Chiang\'s time in power.\n\n &nbsp; \n\nThe Republic of China did not have an "official" currency for a period of time beginning in 1992 and lasting until the middle of the year 2000. On July 1, 2000, the Central Bank of the Republic of China (Taiwan) took over from the Bank of Taiwan as the institution responsible for the issuance of New Taiwan dollars. As a direct consequence of this, the New Taiwan dollar emerged victorious in its bid to become Taiwan\'s official currency.'},countries_accepting:{desc_1:"The New Taiwan dollar was once only used on Taiwan, but it has since expanded to other territories that are still ruled by the Republic of China. These territories include the outlying islands of Kinmen, Matsu, and Dachen.",list:[],desc_2:""},amount_for_trip:{desc:"There are a lot of things that can change how much money you may need to travel in the amazing country of Taiwan. The total cost of your trip will depend on how much you spend on transportation to and around your destination, where you stay, and how much you spend on food. On a trip with a budget, a tourist can spend about NT$1,068 a day in Taiwan. On the other hand, a day of vacation can easily cost more than NT$8,626 if you use expensive transportation, eat at Michelin-starred restaurants, and only stay in the best hotels. The price of travel for two people can be anywhere from NT$2,168 to NT$17,226.\n\n &nbsp; \n\nA night's stay in Taiwan can cost between NT$643 and NT$5,621 per person, per day. On the other hand, the average cost of transportation for a day can be anywhere from NT$108 to NT$849, depending on whether you take public transportation or a private car.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live New Taiwan dollar rate** in order to exchange your currency notes. You can also check out the exchange rate of **New Taiwan Dollar to GBP** or US Dollar."},identification:{list:["Banknotes now in circulation for the New Taiwan dollar make use of a wide range of security features, including intaglio printing, watermarks, optical variable ink, window threads, latent texts, metallic ink, and optical variable device (OVD) foil, among others.",'In addition, the Central Bank offers straightforward instructions (known as the "Look-Feel-Tilt" method) to the general public on how to identify counterfeit cash.',"A number of different types of security features, such as recessed writing, latent pictures, and tactile markers for those who are blind or visually impaired have been integrated into modern coins.","If you hold a banknote up to the light, you'll be able to see the watermark that is printed on the note.","If you tilt the bill, you should be able to see the security thread as well as the colour-changing ink and foil patch.","You can feel the raised spots on the banknote with your fingers."]},how_to_buy:{desc:"Whether you want to buy **New Taiwan dollar forex card**s and currency notes or sell the **New Taiwan Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **New Taiwan Dollar to USD, INR to New Taiwan Dollar** or **New Taiwan Dollar to Euro**, you only need to follow the below-written steps:"}}},{id:52,internalName:"seo_currency_page_argentine-peso",type:"seo_currency_page_argentine-peso",data:{name:"Argentine Peso",code:"ARS",country_code:"AR",travel_country:"Argentina",keywords:"Argentine peso,Argentine peso symbol,argentine peso to inr, argentine peso to usd, argentine peso to euro, argentine peso to american dollar, argentine peso to canadian dollar,Argentine peso exchange rate, Argentine peso currency exchange, buy Argentine peso, sell Argentine peso, Argentine peso forex cards, live Argentine peso rate, Argentine peso price",about:{title_text:"The Strong Currency of Argentina",desc:"In Argentina, the peso is the country's official currency. The **Argentine peso symbol** is the dollar sign ($), just as it is in many other countries that use either the peso or the dollar as their primary currency. It has been given the code ARS in ISO 4217. The Argentine peso (ARP) was Argentina's official currency back when the country was still a republic. After a period of significant hyperinflation and currency devaluation, it was phased down in 1985 after having been founded in June 1983. However, the austral (ASA) wasn't put into circulation until the year 1992 after it was first introduced. It was later replaced by the Argentine nuevo peso, which is the currency that is in use today in the country (ARS). Argentina has since moved on from the Argentine peso, which was formerly the only unit of money in use throughout the country.\n\n &nbsp; \n\nThe following Argentine peso banknotes—AR$10, AR$20, AR$50, AR$100, AR$200, AR$500, and AR$1000—may be used as payment in any establishment in the country beginning this coming July 2020.\n\n &nbsp; \n\nThe smallest coin is worth 5 centavos, and the largest is worth 10 pesos. However, coins with values of five cents, ten cents, twenty-five cents, and fifty cents have almost completely disappeared from circulation.\n\n &nbsp; \n\nThe current **Argentine peso price** is INR (`inr_exchange_rate`) ."},quick_facts:{facts:{Country_of_Origin:"Argentina",Symbol:"$ or Arg$",Currency_Code:"ARS",Nick_Names:"-",Minor_units:"Centavo","Denominations_(Banknotes)":"20, 50, 100, 200, 500 and 1,000 pesos",Motto:"-",Identification_Feature:"When it comes to the 4th series, you will find the image of Hornero on the obverse side of the $1,000 note.",Issuing_Bank:"Central Bank of the Argentine Republic",In_Circulation_Since:"June 1, 1983"}},history:{desc:"The ARP was introduced in 1983 as a replacement for the peso ley, and the exchange rate at the time was 1 ARP for every 10,000 peso ley. One ARP dollar was equivalent to one hundred units called centavos when it was first introduced. There were coins for one peso, five pesos, ten pesos, and fifty pesos available.\n\n &nbsp; \n\nWhen the peso was first launched as a currency in 1983, banknotes were printed in denominations of 1, 5, 10, 50, and 100 pesos. These were the inaugural banknotes issued for the ARP. On the other hand, the banknotes for 500 and 5,000 pesos were not introduced until 1984. In the year 1985, a bank note for an additional 10,000 pesos was printed.\n\n &nbsp; \n\nThe Argentine austral was introduced in 1985 as a replacement for the Argentine peso (ARA). The Argentine Nuevo peso, which is Argentina's current national currency, succeeded the austral as the country's primary unit of currency in 1992.\n\n &nbsp; \n\nThe eight-real silver coin was commonly referred to as the peso when it was used as currency in Spain. As soon as Argentina achieved its independence, it started minting its own currencies in reales, soles, and escudos. One of these currencies was the silver eight-real (or sol) pieces, which are now often referred to as pesos.\n\n &nbsp; \n\nUp until the year 1881, this currency, along with those of the countries that were nearby, was in circulation. Intense Beginning in the year 1826, two distinct series of peso-denominated paper money were distributed throughout circulation. In 1881, the national currency, the peso, totally supplanted it at a rate of one peso to one nacional peso.\n\n &nbsp; \n\nThe Argentine Confederation minted coins for 1, 2, and 4 centavos in the year 1854. At the time, 100 centavos were equivalent to 1 peso, which was then equal to 8 reales. However, Argentina did not completely adopt a decimal monetary system until the year 1881.\n\n &nbsp; \n\nDuring the time that the austral was the country's official currency, Argentina experienced hyperinflation. In 1989, during the last several months of President Raul Alfonsn's term in office, prices steadily increased (by 200 percent in July alone), which resulted in a declining exchange rate. Emergency banknotes in the amounts of 10,000, 50,000, and 500,000 australes were printed by the various provincial governments for the first time in several decades. This marked the beginning of the provinces' return to issuing their own currency. The value of the currency returned to its previous state once Carlos Menem was elected president. It wasn't until 1992 that ARS was introduced."},countries_accepting:{desc_1:"Argentine Peso is the legal tender of Argentina and is only used within the boundary of the country for all kinds of transactions.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of money that you'll need to travel to the magnificent country of Argentina may vary depending on a variety of factors. The amount of money you spend on transportation to and around your destination, the cost of your accommodation, and the cost of your meals will all have an impact on the total cost of your vacation. A visitor to Argentina should be prepared to spend approximately AR$2,788 per day on average while they are there. On the other hand, if you insist on travelling in style, dining at restaurants with Michelin stars, and staying at only the finest hotels, the price of a single day of vacation might easily surpass AR$19,862. On the other hand, the cost of a vacation for two people might range anywhere from AR$5,000 to AR$40,000.\n\n &nbsp; \n\nThe cost of accommodation in Argentina can range anywhere from AR$902 to AR$5,920 per person, per day. The cost of your transportation, on the other hand, can range anywhere from AR$608 to AR$4,384 each day depending on whether you take public transit or a private mode of transportation.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Argentine Peso rate** in order to exchange your currency notes. You can check out the Argentine peso to American dollar and Argentine peso to Canadian dollar."},identification:{list:["An authentic note is marked with a watermark. It is visible on the banknote if it is held up to the light in the right way. When you do so, the image that is printed on the banknote will become visible. The hornero, a native bird, is shown on the notes worth one thousand pesos (AR$).","The note's paper is perforated along the length with a thin ribbon of silver that runs vertically.","When a person runs their finger over the raised printing on a banknote, there should be a distinct and memorable sensation of texture. Additionally, the image on the banknote can be scraped with a fingernail to expose raised elements on the design."]},how_to_buy:{desc:"Whether you want to buy **Argentine peso forex cards** and currency notes or sell the **Argentine Peso**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Argentine Peso to USD, INR to Argentine Peso** or **Argentine Peso to Euro**, you only need to follow the below-written steps:"}}},{id:53,internalName:"seo_currency_page_naira",type:"seo_currency_page_naira",data:{name:"Naira",code:"NGN",country_code:"NG",travel_country:"Nigeria",keywords:"Naira,Naira Currency, Naira rate today, Naira rate, Naira symbol,Naira to rupee, Naira to indian rupee, Naira to dollar, naira to inr, naira to usd, naira to rupees,Naira exchange rate, Naira currency exchange, buy Naira, sell Naira, Naira forex cards, live Naira rate, Naira price",about:{title_text:"The Strong Currency of Nigeria",desc:"Nigeria is a nation that is a part of the Commonwealth of Nations, and their national currency is called the naira (NGN). It takes one hundred kobo to equal one naira in Nigeria's monetary system, which is based on the naira. Only the Central Bank of Nigeria is authorised to issue currency that can be used within the Federal Republic of Nigeria. It does this by regulating the flow of currency into the economy, which helps keep inflation and unemployment from getting out of control. The **Naira symbol** is ₦.\n\n &nbsp; \n\nSince its introduction in 1973 till the present day (2019), the value of the naira has been steadily eroded, and inflation remains higher than 10%.\n\n &nbsp; \n\nSince 2007, circulation has been maintained for the 50 kobos, 1 naira, and 2 naira coins respectively. Banknotes for the naira come in denominations of 5, 10, 20, 50, 100, 200, and 500; the banknotes for the 50 kobo and the 1 naira are no longer valid forms of payment.\n\n &nbsp; \n\nThe **Naira rate today** is INR (`inr_exchange_rate`) . Please note that **Naira rate** keeps on fluctuating so you can check the **Naira price** on the platform."},quick_facts:{facts:{Country_of_Origin:"Nigeria",Symbol:"₦",Currency_Code:"NGN",Nick_Names:"-",Minor_units:"Kobo","Denominations_(Banknotes)":"₦5, ₦10, ₦20, ₦50, ₦100, ₦200, ₦500 and ₦1000",Motto:"-",Identification_Feature:"The inclusion of a woman's signature on a naira note in 2019 was a historic first for the country's currency. Priscilla Ekwere Eleje, who serves as the Director of Currency Operations at the Central Bank of Nigeria, was given the honour of receiving this achievement.",Issuing_Bank:"Central Bank of Nigeria",In_Circulation_Since:"July 1, 1959",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The Nigerian pound was replaced by the naira on January 1, 1973, and the exchange rate for one naira to one dollar was set at 1:1. The name of Queen Elizabeth II appeared on the obverse of every single Nigerian pound coin that was put into circulation before to the year 1960. These coins were minted by the colonial government of the Federation of Nigeria.\n\n &nbsp; \n\nThe new currency coins were the first coins to be struck by an independent Nigeria after the country gained its independence in 1960. Because of this, Nigeria was the very last country to make the transition from the pound sterling to the decimal system.\n\n &nbsp; \n\nThe Nigerian naira became the country's official currency in 1973, succeeding the British pound as the nation's previous unit of account. The value of one naira was determined to be equivalent to two pounds sterling when determining an exchange rate between the two currencies.\n\n &nbsp; \n\nBy the year 2008, the value of the money had been drastically diminished due to inflation. The government eventually decided to shelve its plans to establish the exchange rate at 100 old nairas for every new naira; nevertheless, these plans had been in the works for some time.\n\n &nbsp; \n\nBecause of the political upheaval in the country in 2008, the redenomination of the naira at a rate of 100:1 was put on hold.\n\n &nbsp; \n\nOn June 20th, 2016, the naira was finally allowed to float after having its value pegged at 197 dollars to one naira for some time. A number of market participants anticipated that the equilibrium rate of the naira would be somewhere in the range of 280 and 350 per dollar. Also, the introduction of the eNaira, Nigeria's digital currency, was scheduled for October 2021 in the country."},countries_accepting:{desc_1:"Naira is the official currency of Nigeria. Due to this reason, it is used in this country for various transactions as well as the sale and purchase of goods and services.",list:[],desc_2:""},amount_for_trip:{desc:"There are a lot of factors that go into determining how much spending money you'll need for a vacation to the lovely country of Nigeria. The cost of getting to your destination, the cost of your lodging, and the cost of your meals will all have an impact on the holiday spending budget you set aside for yourself.\n\n &nbsp; \n\nIt is possible to get by in Nigeria on as little as NGN 30,000 a day, even for those who are on a tight schedule. On the other hand, the cost of a single day of vacation can easily surpass NGN 40,000 if you utilise premium forms of transportation, dine at restaurants with Michelin stars, and stay in only the finest hotels. Also, the cost of a vacation for two people can reach over NGN 60,000 to NGN 1,00,000.\n\n &nbsp; \n\nThe cost of accommodation in Nigeria can range anywhere from approximately NGN 12,000 to NGN 20,000 per person, per day. On the other hand, the cost of transportation on a daily basis could range anywhere from NGN 3,000 to NGN 7,000, and this figure is contingent on whether you take public transit or a private vehicle.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Naira rate** in order to exchange your currency notes. You can check **Naira to dollar** and **Naira to rupees** on the platform."},identification:{list:["A counterfeit note's surface feels squishy and the image on the front appears to be faded.","Signature of the governor of the Central Bank of Nigeria (CBN) and a gold foil seal can be found on the right side of the N1,000 note. If you scratch a counterfeit note, the gold foil will peel off instantly, whereas the gold foil on the genuine article will not come off at all.","The use of water or another liquid, in addition to this method, is helpful in detecting counterfeit money. Because the inks that are used to make counterfeit bills are easily erased by water and other substances, criminals put these notes back into circulation.","Soaking a Naira bill in water or gasoline and then lightly scraping it will allow you to determine whether or not it is genuine. If it is a fake, you can immediately tell since the colours will be different. Because the ink on counterfeit bills is water-based, it will wear off over time, just like a watercolour painting would.","There is a thin, ribbon-like thread that runs vertically from the top to the bottom of each and every Naira banknote. This thread can be physically felt in authentic notes. Older banknotes of the Naira are where you'll truly see it, so look for those. On the other hand, fake notes have a thread that, despite its apparent similarity to the real one, does not actually exist.",'When a genuine N1000 bill is held up to the light, the numeral "1000" that is printed across the bill will be revealed to be in dazzling relief throughout the note.']},how_to_buy:{desc:"Whether you want to buy **Naira forex cards** and currency notes or sell the **Naira**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Naira to USD, INR to Naira** or **Naira to Euro**, you only need to follow the below-written steps:"}}},{id:54,internalName:"seo_currency_page_south-african-rand",type:"seo_currency_page_south-african-rand",data:{name:"South African Rand",code:"ZAR",country_code:"ZA",travel_country:"South Africa",keywords:"South African rand, African rand Currency, South African rand rate today, South African rand rate, South African rand price, South African rand symbol, African rand to rupee, South African rand to indian rupee, South African rand to dollar, south african rand to inr, south african rand to us dollar, 1 south african rand to pakistani rupee,South African rand exchange rate, South African rand currency exchange, buy South African rand, sell South African rand, South African rand forex cards, live South African rand rate, South African rand price",about:{title_text:"The Strong Currency of South Africa",desc:"South Africa's official unit of money is called the rand. The symbol for the rand is the letter R, and one rand is equal to one hundred cents. The value of the rand remained essentially unchanged in comparison to that of the US dollar from the time it was first introduced in February 1961 until the end of apartheid in 1994. The value of the rand has significantly decreased since then as a result of the increased integration of the South African economy into global markets. Several of the neighbouring nations have decided to peg their currencies to the rand in order to be more competitive. Because gold was South Africa's most important commodity at the time, its currency, the rand, had its value initially set relative to the price of gold. The **South African rand symbol** is R.\n\n &nbsp; \n\nThe **South African rand rate today** is INR (`inr_exchange_rate`) . Please note that the **South African rand price** keeps fluctuating."},quick_facts:{facts:{Country_of_Origin:"South Africa",Symbol:"R",Currency_Code:"ZAR",Nick_Names:"-",Minor_units:"Cent","Denominations_(Banknotes)":"R10, R20, R50, R100 and R200",Motto:"‘Ex Unitate Vires’ which means ‘unity is Strength’",Identification_Feature:"The 200 rand note of the sixth series has the image of leopards on the obverse side.",Issuing_Bank:"South African Reserve Bank",In_Circulation_Since:"February 14, 1961",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The South African rand (ZAR) is the country's official currency. It was first introduced in February 1961, just a few months before the founding of the Republic of South Africa, and it has been in circulation ever since.\n\n &nbsp; \n\nWhen the rand was first introduced as the official currency of South Africa, one pound of South African currency was equivalent to two rand. Until the early 1970s, its value was always around R1.5 when measured against the dollar (USD). However, due to the fact that the value of the rand has declined over the course of the decades that have passed since then, it is currently more expensive to exchange one rand for one single US dollar.\n\n &nbsp; \n\nIn the year 1990, one rand could be traded in for approximately $2.55 in US dollars; however, by the year 1999, the rate of exchange had increased to $6.14. The rand was chosen to be the official currency of South Africa in 1961, barely three months before the country transitioned from a union to a republic.\n\n &nbsp; \n\nIn the year 1956, a Decimal Coinage Commission was founded with the purpose of examining the prospect of doing away with the pound, the shilling, and the penny. On August 8, 1958, it presented its report and recommendations to the appropriate parties. Because one rand was equivalent to one pound, or ten shillings, the rand became the de facto legal money in South Africa, thereby replacing the pound. Decimal Dan, also known as \"the rand-cent person,\" was developed to serve as the official mascot of the government (known in Afrikaans as Daan Desimaal). In addition to this, a catchy radio jingle was broadcast to inform people about the new currency.\n\n &nbsp; \n\nThe 15th of March in 1982 was the first day that the dollar was worth more than the rand. After that, its value shifted since the government of South Africa implemented a variety of exchange rate concessions at various points in time. In the early 1980s, the country's value started to decrease as a result of high inflation, growing political pressure, and international sanctions imposed on the country as a result of international opposition to the apartheid system. Sanctions were imposed on the country because of international resistance to the apartheid system. The first time that the rand was worth more than one dollar was in March of 1982, and it remained there until June of 1984, when it started to swiftly devalue against the dollar.\n\n &nbsp; \n\nAfter it became clear in the early 1990s that the country was heading for Black majority rule and one reform after the other was proclaimed, uncertainty about the future of the country accelerated the depreciation of the currency until the threshold of R 3 to the dollar was exceeded in November 1992. Since then, the value of the rand as measured against the dollar has been influenced by a variety of local and international occurrences. These include the country's general election in 1994 (which caused the rand to fall to more than R3.60 to the dollar), the appointment of Tito Mboweni as governor of the South African Reserve Bank, and the inauguration of President Thabo Mbeki in 1999."},countries_accepting:{desc_1:"The Southern African Common Monetary Area (which consists of South Africa, Lesotho, Namibia and Eswatini) uses the South African rand (or simply the rand) as its official currency.",list:["AO","MW","ZM","ZW"],desc_2:""},amount_for_trip:{desc:"Many factors determine how much money you'll need to spend on a vacation to South Africa. The cost of getting to your destination, the cost of your lodging, and the cost of your meals will all have an impact on your holiday budget. A budget-conscious traveller visiting South Africa can get by with as little as R521 per day. A day of vacation, on the other hand, can easily cost more than R3,501 if you utilise premium forms of transportation, dine at Michelin-starred restaurants, and stay solely in the finest hotels. The cost of a vacation for two people, on the other hand, can range from R1100 to R7,701.\n\n &nbsp; \n\nIn South Africa, housing costs between R256 to R2,064 per person every day. However, the daily cost of transportation might range from R95 to R526 depending on whether you use public transportation or private transportation.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live South African rand rate** in order to exchange your currency notes. You can easily check S**outh African rand to US dollar, 1 South African rand to Pakistani rupee** or South African rand to INR on the platform."},identification:{list:['When examined under magnification, the metallic strip that is located on the front of the bill produces a continuous opaque line, which is known as the security thread. It is important that the South African Reserve Bank, the word "Rand," the denomination, and the coat of arms of South Africa all be easily readable.','The face of Nelson Mandela is imprinted on the watermark of the banknotes. On the front of the note, the image of Nelson Mandela will be slightly raised. You can also feel the same sensation when you rub your finger on the words "South African Reserve Bank".',"The bottom left and right raised lines on the notes are intended to assist visually impaired users in accessing and utilising the cash. On the R10, there is only one line, however on the R20, there are two lines, on the R50, there are three lines, on the R100, there are four lines, and on the R200, there are five lines.","When light is reflected off of the metallic thread, the colour of the thread will subtly shift as a result of this interaction.","The numerals in the lower right corner of the money are printed with a special ink that changes colour. Banknotes denominated in R10 and R20 have a barely discernible shift in colour, whereas bills denominated in R50, R100, and R200 have a line that appears to be moving."]},how_to_buy:{desc:"Whether you want to buy **South African rand forex cards** and currency notes or sell the **South African Rand**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **South African Rand to USD, INR to South African Rand** or **South African Rand to Euro**, you only need to follow the below-written steps:"}}},{id:55,internalName:"seo_currency_page_colombian-peso",type:"seo_currency_page_colombian-peso",data:{name:"Colombian Peso",code:"COP",country_code:"CO",travel_country:"Colombia",keywords:"Colombian peso, peso Currency, Colombian peso symbol,Colombian peso to rupee, Colombian peso to indian rupee, Colombian peso to dollar, colombian peso to usd, 1 colombian peso to inr,Colombian peso exchange rate, Colombian peso currency exchange, buy Colombian peso, sell Colombian peso, Colombian peso forex cards, live Colombian peso rate, Colombian peso price",about:{title_text:"The Strong Currency of Colombia",desc:"The peso is the currency that is used in Colombia. While its code is COP, the Colombian peso symbol is $ or Col$. Even though the 5, 10, 20, and 50 peso coins are still known to be valid tender, the vast majority of monetary transactions are counted to the closest hundred pesos due to the low value and high circulation of these pieces. The **Colombian Peso price** is INR (`inr_exchange_rate`) ."},quick_facts:{facts:{Country_of_Origin:"Colombia",Symbol:"$",Currency_Code:"COP",Nick_Names:"-",Minor_units:"Centavo","Denominations_(Banknotes)":"$1,000, $2,000, $5,000, $10,000, $20,000, $50,000 and $100,000",Motto:"-",Identification_Feature:"When it comes to 10,000 pesos note, you will find the image of Policarpa Salavarrieta on the obverse side.",Issuing_Bank:"Banco de la República",In_Circulation_Since:"1810",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Following its proclamation of independence from Spain in 1820, Colombia made the decision to adopt the United States dollar as its primary form of currency. The Colombian Real has replaced all other currencies as the official currency in use. The real was the currency used in Colombia until 1837, when it was replaced by the present-day peso, which could initially be divided into 8 reales.\n\n &nbsp; \n\n1847 saw the beginning of the decimalization of the Colombian peso, with each peso being subdivided into ten reales (later renamed centavos). The real was rechristened the décimo in 1853, despite the fact that it was still in circulation until as late as 1880.\n\n &nbsp; \n\nThe current system of 100 centavos to the peso only came back in the early 1860s, and it was not utilised on the coins until 1872. The current system was first used on banknotes in 1819, but it was not used again until 1872. In 1871, Colombia made the changeover from using silver to gold as its primary form of currency, and the value of the peso was set at 5 French francs to 1 peso. This standard was only valid up until the year 1886.\n\n &nbsp; \n\nIn 1888, the value of Colombian paper currency, which had been pegged to the British pound at the rate of 5 pesos = 1 pound, began to decline as a result of inflation caused by printing presses. As a result, the official exchange rate between paper money and coins was set at 100 pesos moneda corriente = 1 coinage peso. This rate has remained in place to this day.\n\n &nbsp; \n\nThe value of one peso in paper form was equivalent to the value of one peso in coins struck between 1907 and 1914. In 1910, the Conversion Board was the entity that initially printed banknotes denominated in peso oro. After the United Kingdom abandoned the gold standard in 1931, the peso was tied to the United States dollar at a rate of 1.05 pesos to 1 dollar. This was a little depreciation from its previous peg, which lasted until 1949. The peg was maintained until 1949. Despite this, banknotes with the value of peso oro continued to be issued right up until the year 1993.\n\n &nbsp; \n\nIn 2018, the Colombian Congress debated whether or not to redenominate the peso at a rate of 1,000 pesos = 1 new peso, which would include removing three zeroes from the face value of the currency. This would simplify banking and accounting procedures.\n\n &nbsp; \n\n$ or Col represents the **Colombian peso symbol**."},countries_accepting:{desc_1:"The official national currency of Colombia is called the peso, and it has been in circulation since 1872. The peso is only accepted inside the borders of Colombia.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of money that you will need to spend on a trip to Colombia's magnificent capital city is dependent on a number of different things. Your vacation spending plan will be affected in many ways by the costs of travelling to and staying at your location, as well as the costs of food and beverages while you are there. It is possible for a traveller to Colombia to get by on as low as CO$48,968 a day if they are careful with their spending. On the other hand, a single day of vacation can easily cost more than CO$456,254 if you make use of only the most luxurious modes of transportation, dine at restaurants with Michelin stars, and only stay in the most opulent hotels. The cost of a vacation in Colombia for two individuals, on the other hand, can range anywhere between CO$100,000 and CO$10,00,000.\n\n &nbsp; \n\nAccommodation in Colombia can cost anything from CO$16,288 to CO$140,741 per day for each individual. On the other hand, the cost of transportation on a daily basis might be anywhere from CO$8,689 and CO$76,576, depending on whether you choose public transit or private transportation.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Colombian Peso rate** in order to exchange your currency notes."},identification:{list:["In Colombia, counterfeit banknotes frequently do not have the same weight or texture as real money. In addition, each and every one of Colombia's banknotes comes equipped with its own unique set of anti-counterfeiting measures.","When seen at an acute angle, the golden hexagon that appears on the front of the bill takes on a green hue. On none of the fakes does this hexagon take on a different colour.","One other feature is a security strip that, depending on the angle from which it is viewed, changes colour from green to violet.","Depending on the angle at which you see it, the large 50 that is printed on the face of the 50,000 pesos note can appear either gold or green. On the counterfeit, the huge 50 did not cause any colour changes.","A bird whose colour changes from green to blue depending on the viewer's perspective is featured on the brand new 50,000 peso notes that were issued in 2016. On the back, there is a chameleon strip that may change from copper to green, providing an additional layer of defence. The newly issued banknotes in Colombia in 2016 are far more secure than the ones that came before them."]},how_to_buy:{desc:"Whether you want to buy **Colombian Peso forex cards** and currency notes or sell the **Colombian Peso**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Colombian Peso to USD, INR to Colombian Peso** or **Colombian Peso to Euro**, you only need to follow the below-written steps:"}}},{id:56,internalName:"seo_currency_page_chilean-peso",type:"seo_currency_page_chilean-peso",data:{name:"Chilean Peso",code:"CLP",country_code:"CL",travel_country:"Chile",keywords:"Chilean peso, peso Currency, Chilean peso symbol, chilean peso conversion, chilean peso country, chilean peso exchange rate history,Chilean peso Currency, Chilean peso to dollar, Chilean peso symbol, chilean peso to inr, chilean peso to usd, chilean peso to philippine peso, chilean peso to colombian peso, peso exchange rate, Chilean peso currency exchange, buy Chilean peso, sell Chilean peso, Chilean peso forex cards, live Chilean peso rate, Chilean peso price",about:{title_text:"The Strong Currency of Chile",desc:"The peso is the Chile’s official unit of currency. The former version of the peso was in circulation from 1817 to 1960, and the current version has been in use continuously since 1975. It is the responsibility of the Banco Central de Chile to issue the peso. On the markets for the exchange of currencies around the world, it is represented by the sign CLP. The **Chilean peso symbol** is $.\n\n &nbsp; \n\nIn Chile, one peso is equal to 100 centavos. In common usage in Chile, the note worth 500 pesos is referred to as a quina, whilst the note for 100 pesos is referred to as a gamba. Since 1999, Chile has permitted the CLP to float freely against other currencies; however, the government does occasionally intervene in the markets to minimise widespread volatility. This policy has been in place. The economy of Chile is consistently ranked among the most\n\n &nbsp; \n\nIf you want to undertake **Chilean Peso conversion**, the current **Chilean Peso price** is INR (`inr_exchange_rate`) ."},quick_facts:{facts:{Country_of_Origin:"Chile",Symbol:"$",Currency_Code:"CLP",Nick_Names:"-",Minor_units:"Centavo","Denominations_(Banknotes)":"500, 1000, 2000, 5000, 10,000 and 20,000 pesos",Motto:"-",Identification_Feature:"The polymer banknote has been used exclusively for the issuance of the 2000 peso note since September 2004.",Issuing_Bank:"Banco Central de Chile",In_Circulation_Since:"September 29, 1975",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'The Chilean peso country is Chile which is also referred to by a number of colloquial names (CLP). Two instances of this include the Quina design for the 500 peso note, which was introduced in 1977, and the Gamba design for the 100 peso note.\n\n &nbsp; \n\nWhen it was first introduced in 1817, the value of one Chilean peso was equal to eight Spanish colonial reales. Up to 1851, one escudo was equivalent to two pesos, and one peso was subdivided into eight reales. Reales were the currency used in Spain. Although the era of real and escudo currency came to an end in 1851, the first creation of centavos and décimos did not begin until 1835. This was due to the fact that real and escudo coins were made of copper (10 centavo coins). In the same year, 1851, the value of one peso was determined to be equal to five francs per sild (or 22.5 grammes of pure silver).\n\n &nbsp; \n\nThe first paper currency in Chile was created in the province of Valdivia between the years 1840 and 1844 by the provincial treasury. These bills were written in four and eight reales respectively as their face value.\n\n &nbsp; \n\nIn the year 1881, the government of Mexico issued paper currency that could be traded in for silver or gold at a rate of 1:1.1, with the exchange rates increasing for amounts of $2, $5, $10, $20, $50, $100, and $1,000 respectively. In the year 1891, banknotes for 50 centavos and 500 pesos were first circulated in Mexico. In the year 1898, the government issued temporary bills that were made up of private bank notes that had the words "Emisión Fiscal" overprinted on them. As a direct result of this, there would be no more private paper money issued. In 1925, the Banco Central de Chile began producing banknotes with the printing press. The initial series consisted of overprints of previously issued government notes, and they were distributed in denominations of 5, 10, 50, 100, and 1,000 pesos each. Between the years 1931 and 1933, the first paper bills with denominations of 1, 5, 10, 20, 50, 100, 500, 1000, 5000, and 10,000 pesos were created. These bills were made of paper.\n\n &nbsp; \n\nThe printing of the 1 peso note and the 20 peso note was discontinued in 1943 and 1947, respectively. The printing of all subsequent denominations continued until the year 1959, and in 1958, the first 50,000 peso note was issued.\n\n &nbsp; \n\nIn 1976, the following denominations of currency were introduced: 5 pesos, 10 pesos, 50 pesos, and 100 pesos. The backs of the two lowest denominations of currency resembled the backs of the 5000 and 10,000 escudo notes that they had replaced. As inflation took hold, a new challenge presented itself in the form of increasingly higher denominations. The first bill for 500 pesos was printed in May of 1977, and subsequent bills for 1,000, 5,000, 10,000, 2,000, and 20,000 pesos were introduced in June 1978, June 1981, December 1997, and December 1998, respectively.\n\n &nbsp; \n\nSince September 2004, all banknotes, including those for the 2000 peso denomination, have been made out of polymer. In September 2009, circulation of the 5000 peso note began, while in May 2011, the polymer version of the 1000 peso note was introduced. This marked the first time in the history of the Chilean economy that a new series of banknotes was launched for a reason other than inflation.\n\n &nbsp; \n\nThe new banknote for the 1000 pesos was introduced on May 11, 2011, and it has become increasingly popular since then.\n\n &nbsp; \n\nBy January 2012, the only banknotes that were still printed on cotton paper are the 10,000 and 20,000 peso notes. You can take a look at the **Chilean peso exchange rate history** in order to see how this currency has fluctuated over the past few years.'},countries_accepting:{desc_1:"Since 1975, Chile has used the peso as its national currency. The peso has been in use since that year. Tourists and locals alike can use Chilean Peso only within the boundary of Chile.",list:[],desc_2:""},amount_for_trip:{desc:"A trip to the beautiful country of Chile could end up costing more or less money based on a number of different considerations. Your vacation budget will be significantly impacted by the prices of travelling to and lodging at your location, as well as the prices of food and beverages that you purchase while you are there. A traveller to Chile who sets a daily spending limit for himself of CL$29,809 can save costs significantly by adhering to this limit. You may easily spend more than CL$227,746 in a single day if you travel in style and dine at restaurants that have been awarded Michelin stars and stay in hotels that have received five stars while you are on your vacation. On the other hand, the amount of money required for the trip of two individuals can range anywhere from CL$60,000 to CL$450,000.\n\n &nbsp; \n\nWhen looking for a place to stay in Chile, you should be prepared to spend anything from CL$16,482 to CL$136,303 every day. On the other side, the costs of transportation could range anywhere from CL$4,281 per day to CL$30,463 per day depending on whether you choose to take public transit or private vehicle.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **Live Chilean Peso** **rate** in order to exchange your currency notes."},identification:{list:["If the denomination printed on the note does not contain ink that changes colour when exposed to ultraviolet light, the bill is very certainly a fake. When you hold a banknote in your hand and tilt it to the left or right, a slight colour change takes place.","There is a specialised security feature known as the watermark, and it can be found on authentic banknotes. If the borders, letters, or text on a banknote are blurry in any manner, this is a dead giveaway that the currency is counterfeit. Most of the time, fake printers are unable to produce the same level of realism as real ones.","If the microprinting cannot be read when placed under a magnifying glass, there is a good chance that it is a fake.","Banknotes that are authentic will have raised printing, which is notoriously difficult for counterfeiters to imitate. You can detect any raised printing on the note by moving your fingertips slowly along the note's surface.","A security thread is a thin embedded strip that runs across the face of banknotes. This strip is located in the centre of the bill. Genuine banknotes will have an additional layer of security provided by the microprinting that is included in the security thread."]},how_to_buy:{desc:"Whether you want to buy **Chilean peso forex cards** and currency notes or sell the **Chilean Peso**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Chilean Peso to USD, INR to Chilean Peso** or **Chilean Peso to Euro**, you only need to follow the below-written steps:"}}},{id:57,internalName:"seo_currency_page_romanian-leu",type:"seo_currency_page_romanian-leu",data:{name:"Romanian Leu",code:"RON",country_code:"RO",travel_country:"Romania",keywords:"Romanian leu,Romanian leu Currency, Romanian leu symbol, romanian leu exchange rate,Romanian leu Currency, Romanian leu to dollar, Romanian leu symbol, 1 romanian leu to inr, romanian leu to sterling, romanian leu to cad, romanian leu to USD, leu exchange rate, Romanian leu currency exchange, buy Romanian leu, sell Romanian leu, Romanian leu forex cards, live Romanian leu rate, Romanian leu price",about:{title_text:"The Strong Currency of Romania",desc:'The Romanian new leu, also abbreviated as RON, is the official currency used across the country. You will make the majority of your purchases with a single leu, which is denoted on the exchange as the plural with the symbol lei but is actually just a single unit of currency. The abbreviation for the Romanian currency is "RON." The use of Old Leu was discontinued in 2005 and was replaced by New Leu; this is where the "N" in RON comes from. There is not a predetermined exchange rate in place between the currency and the euro or any other currency as of right now, but that is expected to change in 2024 when the euro is scheduled to become the de facto standard. The Romanian leu symbol is lei.\n\n &nbsp; \n\nThe coins with the lowest denominations in Romanian new lei are the ones with values of 1 ban, 5 bani, 10 bani, and 50 bani. There are several different denominations of the new lei currency, beginning with one lei and continuing up to five, ten, fifty, one hundred, and five hundred.\n\n &nbsp; \n\nThe **Romanian leu exchange rate** is INR (`inr_exchange_rate`) .'},quick_facts:{facts:{Country_of_Origin:"Romania",Symbol:"lei",Currency_Code:"RON",Nick_Names:"-",Minor_units:"Ban","Denominations_(Banknotes)":"1 leu, 5 lei, 10 lei, 20 lei, 50 lei, 100 lei, 200 lei and 500 lei",Motto:"-",Identification_Feature:"On the obverse side of 500 lei note, you will find the image of Mihai Eminescu and tilia.",Issuing_Bank:"National Bank of Romania",In_Circulation_Since:"1867",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'Despite the extensive use and exchange of euros and U.S. dollars in Bucharest, the Romanian lei are used as the principal standard throughout the rest of the country. The Romanian leu symbol is lei.\n\n &nbsp; \n\nSince 1867, the value of one leu has been revised multiple times, resulting in four distinct iterations. In July of 2005, the Romanian government decided to switch from the old leu (ROL) to the new leu (LOU), with the exchange rate being 10,000 ROL to 1 LEU. The present version and the previous leu were both in circulation throughout the changeover phase, which lasted from March 2005 until December 2006.\n\n &nbsp; \n\nOn July 1, 2005, the leu underwent a revaluation in which 10,000 "old" lei (ROL) were exchanged for one "new" leu (RON). This brought the leu\'s purchasing power back into line with that of other major Western currencies.\n\n &nbsp; \n\nAfter suffering significant losses as a result of the global financial crisis that began in 2008 and the ensuing European economic recession, the Romanian new leu has been steadily making strides toward a full recovery.\n\n &nbsp; \n\nBeginning on July 1, 2005, all accounts were updated, but the previous ROL banknotes continued to be used until December 31, 2006. (coins stayed in circulation only until 31 December 2005). When it comes to exchanging currencies, time is not a factor in any way. Retail establishments were required to display prices in both currencies beginning March 1, 2005 and continuing until June 30, 2006.\n\n &nbsp; \n\nThroughout the course of its existence, the leu has been pegged to a number of different currencies, including the reichsmark of Germany, the dollar of the United States, and the ruble of Russia. Even though Romania is widely anticipated to fully adopt the euro by the year 2024, please note that the leu is not pegged to the euro at this point.'},countries_accepting:{desc_1:"The Romanian Leu is the legal tender of Romania and is only used in this country. The citizens can indulge in all kinds of legal transactions.",list:[],desc_2:""},amount_for_trip:{desc:"There are many aspects that might have a significant impact on the total cost of a trip to breathtaking Romania. Your vacation spending plan will be significantly impacted by the prices of travelling to and staying at your location, as well as the costs of purchasing food and beverages while you are there. A traveller visiting Romania who sets a daily budget of just lei144 will end up saving a considerable amount of money at the end of their trip. It is not difficult to spend more than lei647 in a single day on a luxury vacation, which includes dining at restaurants with Michelin stars and staying in hotels with five stars or higher. In contrast, the cost of a vacation for two individuals might range anywhere from lei350 to lei1350.\n\n &nbsp; \n\nThe price of your room per night in Romania could be anywhere between lei47 and lei252. On the other hand, the cost of your transportation each day could range anywhere from lei33 to lei170, and this figure is independent of whether or not you take public transportation or a private automobile.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Romanian leu rate** in order to exchange your currency notes."},identification:{list:["There is a strong chance that the money is counterfeit if the denomination printed does not contain colour-changing ink. If you hold a bill and tilt it to the left or right, you will notice some change in the colour.","Authentic banknotes all have a security feature known as a watermark, which is a distinctive security characteristic.","On a banknote, if the borders, lettering, or writing are blurry, this is an obvious giveaway that the bill is counterfeit. The dies used to print the original banknotes results in the notes having extremely fine lines and textures. Generally speaking, fake printers are unable to provide the same level of realism. Examine the bill very carefully, paying particular attention to the margins, to ensure that they have not become smudged in any way.","Microprinting is an additional characteristic of authentic banknotes. If the microprinting cannot be read, even with a magnifying glass, then it is most likely a fake.","The raised printing that can be found on real banknotes is notoriously difficult for counterfeiters to duplicate. You can detect raised printing on the note by running your fingers slowly along the note. You should be able to feel a tiny vibration on your nail as a result of the raised printing if it has been done correctly. If you don't feel this texture, you should perform a more in-depth inspection of the bill.","The security thread of a banknote is a very thin embedded strip that runs vertically across the front of the bill. Authentic banknotes will have an additional layer of protection in the form of microprinting in the security thread.","As it offers a definitive method of identifying counterfeit money, ultraviolet light is utilised in the equipment and technology utilised in the detection of counterfeiting."]},how_to_buy:{desc:"Whether you want to buy **Romanian leu forex cards** and currency notes or sell the **Romanian Leu**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Romanian Leu to USD, INR to Romanian Leu** or **Romanian Leu to CAD**, you only need to follow the below-written steps:"}}},{id:58,internalName:"seo_currency_page_iraqi-dinar",type:"seo_currency_page_iraqi-dinar",data:{name:"Iraqi Dinar",code:"IQD",country_code:"IQ",travel_country:"Iraq",keywords:" Iraqi dinar, dinar Currency, Iraqi dinar rate today, Iraqi dinar rate, Iraqi dinar price, Iraqi dinar price today, Iraqi dinar symbol,Iraqi dinar to rupee, Iraqi dinar to indian rupee, Iraqi dinar to dollar, iraqi dinar to inr, iraqi dinar to usd, iraqi dinar to jod,Iraqi dinar exchange rate, Iraqi dinar currency exchange, buy Iraqi dinar, sell Iraqi dinar, Iraqi dinar forex cards, live Iraqi dinar rate, Iraqi dinar price",about:{title_text:"The Strong Currency of Iraq",desc:"The Iraqi dinar is Iraq’s official unit of currency. It is issued by the Central Bank of Iraq and has a face value of 1,000 fils. The currency code for the Iraqi dinar is IQD. As a result of years of inflation, dinars have recently taken the position of fils as the lowest denomination of money. The dinar is not widely accepted outside of Iraq due to the fact that the primary commodity exported by Iraq, oil, is priced in US dollars. The Iraqi dinar symbol is ID or د.ع.\n\n &nbsp; \n\nThe **Iraqi dinar rate today** is INR (`inr_exchange_rate`) . Please note that **Iraqi dinar rate** keeps fluctuating."},quick_facts:{facts:{Country_of_Origin:"Iraq",Symbol:"ID or د.ع",Currency_Code:"IQD",Nick_Names:"-",Minor_units:"Fils","Denominations_(Banknotes)":"ID 250, ID 500, ID 1,000, ID 5,000, ID 10,000, ID 25,000 and ID 50,000",Motto:"-",Identification_Feature:"On the obverse side of the ID 100 note, you will find the image of King Faisal II as a child.",Issuing_Bank:"Central Bank of Iraq",In_Circulation_Since:"April 1, 1932"}},history:{desc:"At the time of the dinar's introduction into circulation in 1932, the exchange rate was predetermined to be 11 Indian rupees for each dinar. Before the year 1959, the dinar was pegged to the British pound (GBP), but beginning in that year, it was pegged to the United States dollar instead (USD).\n\n &nbsp; \n\nBefore the Gulf War in the early 1990s, the exchange rate didn't experience much of a significant shift in either direction. Prior to the Gulf War that took place in 1990–1991, one dinar was equivalent to more than three dollars in modern American currency. After the Gulf War, the government issued new money; however, there was a shortage of printing equipment as a result of sanctions imposed because of the war, thus the quality of the newly printed bills was lower. As a direct consequence of this, the value of the currency dropped precipitously, reaching an average of 1,950 dinars to one dollar in 2003.\n\n &nbsp; \n\nAs a result of the liquidity crisis that was caused by low oil prices, the Central Bank of Iraq has announced that it will be devaluing the currency of the Iraqi dinar by more than 20% in December 2020. This move has caused outrage as the government tries to meet its expenses."},countries_accepting:{desc_1:"The Iraqi Dinar is only used in Iraq, and both locals and tourists use this currency within the country for various kinds of transactions. You can check out the **Iraqi dinar price today** for exchanging your money.",list:[],desc_2:""},amount_for_trip:{desc:"Visiting the stunning city of Iraq could be very expensive depending on a wide variety of factors. Costs associated with getting to and staying at your destination, as well as the price of food and drink you consume while there, will have a substantial impact on your holiday budget.\n\n &nbsp; \n\nA visitor to Iraq on a tight budget of IQD 1,00,000 a day will still have enough money left over at the trip's end. A day of luxury travel, with meals at Michelin-starred restaurants and stays in five-star hotels, can easily cost more than IQD 3,00,000. Alternatively, the price of a vacation for two people could be anywhere from IQD 2,00,000 to IQD 6,00,000.\n\n &nbsp; \n\nNightly accommodation rates in Iraq can cost anywhere from IQD 80,000 to IQD 1,00,000. However, depending on whether you rely on public transit or a private vehicle, you could spend anywhere from IQD 30,000 to IQD 60,000 on transportation expenses every day.\n\n &nbsp; \n\nYou can exchange your currency notes as per the current **Iraqi dinar price**. All in all, you can keep an eye on the **Live Iraqi Dinar** **rate** in order to exchange **Iraqi dinar to dollar** and **iraqi dinar to JOD**."},identification:{list:["The De La Rue machine is utilised rather frequently in the process of validating the authenticity of the notes. When ran through De La Rue counting equipment that uses ultraviolet light for certification, real Dinar bills will flash neon green. This can be seen when the bills are passed through the machine.","When examined with an ultraviolet light, the watermarks on authentic bills become visible. The head of a horse is frequently used for the watermark on Iraqi dinars, although other designs have been used.","If you make your mark on the bills with one of the specialised pens that can be purchased at any store that sells office supplies, the colour of your mark will be distinct from the other bills. By holding the bills up to the light, you can examine the bills to determine whether or not they contain holograms.","Additional telltale indicators of a counterfeit Iraqi dinar include the following: A watermark is not present on the counterfeit Dinar. Falsified Dinars do not have a security thread on them. There is no raised lettering on Iraqi bill in any of its denominations. There is a possibility that counterfeit Dinars will not use metallic ink."]},how_to_buy:{desc:"Whether you want to buy **Iraqi dinar forex cards** and currency notes or sell the **Iraqi Dinar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Iraqi Dinar to USD, INR to Iraqi Dinar** or **Iraqi Dinar to Euro**, you only need to follow the below-written steps:"}}},{id:59,internalName:"seo_currency_page_nuevo-sol",type:"seo_currency_page_nuevo-sol",data:{name:"Nuevo Sol",code:"PEN",country_code:"PE",travel_country:"Peru",keywords:"nuevo sol,sol Currency, sol price, sol symbol ,sol to dollar, sol to inr, 1 sol to USD,sol exchange rate, sol currency exchange, buy sol, sell sol, sol forex cards, live sol rate, sol price",about:{title_text:"The Strong Currency of Peru",desc:'The Peruvian inti was the country\'s official currency up until 1991 when it was succeeded by the sol. Its name is a reference to the pre-Columbian currency that was used in Peru; the sol was the official currency of Peru from 1863 until 1985. The Nuevo Sol was first made available to consumers in the market in the month of January in the year 1991 which is the legal tender of Peru now. The "Sol" was formally adopted as the new name for the monetary unit on December 15, 2015, the same day as a new law made the change. The sole is the unit of money used across all of Peru. Throughout its history, Peru has used a variety of currencies, such as the escudo, peso, real, and inti, in addition to its current currency, the Nuevo Sol. The sol symbol is S/.\n\n &nbsp; \n\nThe **current sol price** is INR (`inr_exchange_rate`) .'},quick_facts:{facts:{Country_of_Origin:"Peru",Symbol:"S/",Currency_Code:"PEN",Nick_Names:"-",Minor_units:"Céntimo","Denominations_(Banknotes)":"S/10, S/20, S/50, S/100 and S/200",Motto:"‘Firme y feliz por la unión’ which means ‘firm and happy for the union",Identification_Feature:"When it comes to S/100 notes that are in circulation since 2021, you will find the image of Pedro Paulet, a Peruvian polymath, on their reverse side.",Issuing_Bank:"Central Reserve Bank of Peru",In_Circulation_Since:"July 1, 1991",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"In the past, the escudo, the peso, and the real were all valid forms of payment throughout the territory that is now known as Peru. In spite of the fact that it achieved independence in 1821, it did not adopt the sol as its official currency until the year 1863. Prior to it, they utilised the escudo as their currency.\n\n &nbsp; \n\nIn 1985, Peru introduced a new currency called the inti as a response to the country's high inflation. At the time, one inti was equivalent to one thousand soles. Once again, in 1991, the government was compelled to give up its currency because of the chronic hyperinflation and severe economic crisis that it was experiencing. A brand new currency known as the Nuevo Sol was introduced by the government; the value of one Nuevo Sol was equal to one million intis. The political history of Peru serves as an illustration of the challenges that can be encountered when attempting to do so.\n\n &nbsp; \n\nThe year 1991 saw the introduction of brand new coins with denominations of 1, 5, 10, 20, and 50 centimos, in addition to the S/1. In the year 1994, the S/2 and S/5 coins were introduced into circulation.\n\n &nbsp; \n\nAlthough the centimo 1 and centimo 5 coins are recognised as valid money under the law, in actuality very few people use them to transact business. Because of this, on May 1, 2011, the aluminium coin for one centimo that had been in circulation since it was first issued in December 2005 was withdrawn from circulation. Along with the one-centimo denomination, the five-centimo coin was removed from circulation on January 1, 2019. [11] Businesses that accept cash payments are required to round their pricing down to the next 10 or five centimo."},countries_accepting:{desc_1:"The currency of nuevo sol is used in Peru, and it is the legal tender for all kinds of transactions taking place within the country.",list:[],desc_2:""},amount_for_trip:{desc:"The stunning country of Peru is also a destination that, depending on a variety of factors, may be prohibitively expensive to visit. Your holiday spending plan will be heavily impacted by the cost of travelling to your destination, the cost of lodging there, as well as the cost of food and drink that you purchase while you are there.\n\n &nbsp; \n\nIt is possible to travel around Peru with a limited budget of S/.64 per day and yet have enough money left over to buy souvenirs and other miscellaneous items. The cost of a day of luxury travel, including meals at restaurants with Michelin stars and stays at hotels, rated five stars, can easily approach S/.543. For two people, a trip to Peru can range between S/.150 and S/.1,200.\n\n &nbsp; \n\nThe average cost of a night's stay at a hotel in Peru might range anywhere from S/.26 to S/.244 per person. To put it into perspective, the cost of daily transportation might be anywhere from S/.8.36 and S/.85, depending on whether you utilise public transportation or a private vehicle.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Sol** **rate** in order to exchange your currency notes."},identification:{list:["Put your hand on the bill. Cotton is utilised in the production of Peruvian banknotes, which gives each bill a unique texture and makes them exceptionally long-lasting. The banknotes appear to have a few rough places here and there.",'Banknotes have relief printing on certain design elements, such as the words "Banco Central de la Reserva," the short black strip(s) at the top and bottom of each note, and the collars of the featured personalities. Other design elements that have relief printing include the serial numbers on the back of the notes. When you run your finger along these locations, you might be able to feel the raised ink. Because of the short, black strips that are printed with raised ink at the top and bottom of each Peruvian banknote, the authenticity of the currency can be established just by touching the note.',"There is one strip printed on the bill for 10 (Nuevos) Soles. On the twenty (Nuevos) Sol note, there are two strips of currency. On the fifty Nuevos Soles bill, there are three horizontal stripes. The note for one hundred Nuevos Soles has four strips printed on it. The two hundred Nuevos Soles bill has five stripes all the way around it. Remember that the security features on the bills can be difficult to see or may have a different texture as a result of their age or use.","Pay attention to the note. When a Peruvian banknote is held up to the light, it is simple to make out the watermark, which can be found in the blank region of each bill, the security stripe, which can be found almost exactly in the middle of each dollar, and the number alignment.","Turn the bill over and look at it. You can see a hidden security feature on a bill if you tilt it in just the right way. The bill only needs to be gently raised and lowered for the trick to work. For example, the principal number on the note, which indicates the face value of the note, is printed with a special ink that, as the note is rotated, changes the colour of the ink.","Microprinting and fluorescent elements are also incorporated into Peruvian banknotes.","The watermark serves as one of the security measures on each and every one of Peru's banknotes. When the blank side of Peruvian banknotes is viewed under direct illumination, a crisp and clear three-dimensional, multi-tone watermark that is composed of three distinct portions is revealed. Authentic banknotes have watermarks that are produced by the varying thicknesses of the paper, which results in a multi-toned and three-dimensional image. Counterfeit banknotes, on the other hand, have watermarks that are printed on, which causes them to appear flat and pixelated. Watermarks can be used to identify counterfeit banknotes.","In the upper right corner of the back, the reverse features the number printed in a different colour in the lighter areas of the number that appear on the front. When the bill is held up to the light, the printings on the front and back, which are each a different colour, will precisely align to make a complete number. The colours on counterfeit bills are misaligned and frequently run together."]},how_to_buy:{desc:"Whether you want to buy **Sol forex cards** and currency notes or sell the **Nuevo Sol**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Nuevo Sol to USD, INR to Nuevo Sol** or **Nuevo Sol to Euro**, you only need to follow the below-written steps:"}}},{id:60,internalName:"seo_currency_page_kazakhstani-tenge",type:"seo_currency_page_kazakhstani-tenge",data:{name:"Kazakhstani Tenge",code:"KZT",country_code:"KZ",travel_country:"Kazakhstan",keywords:"Kazakhstani tenge, tenge symbol, tenge, tenge currency,kazakhstani tenge to euro, kazakhstani tenge to USD, tenge exchange rate, Kazakhstani tenge currency exchange, buy Kazakhstani tenge, sell Kazakhstani tenge, Kazakhstani tenge forex cards, live Kazakhstani tenge rate, Kazakhstani tenge price",about:{title_text:"The Strong Currency of Kazakhstan",desc:"Tenge is the name of Kazakhstan's monetary unit of account. To make up a whole, there are one hundred tiyn. It was introduced in 1993 as a replacement for the Russian ruble. Prior to its declaration of independence in 1991, Kazakhstan was a constituent republic of the Soviet Union. Kazakhstan's economy relies heavily on the export of several types of natural resources. The Kazakhstani tenge symbol is ₸.\n\n &nbsp; \n\nThe KZT has 100 smaller components called tiyn. The country's mint produces coins with face values of 1, 2, 3, 5, 10, 20, 50, 100, and 200 tenge, and 2, 5, 10, 20, and 50 tiyn. Meanwhile, banknotes are issued in denominations ranging from 200 tenge to 20,000 tenge. While Germany and the United Kingdom were responsible for minting its coins and banknotes in the past, the National Bank of Kazakhstan is in charge of that process now.\n\n &nbsp; \n\nThe current **Kazakhstani tenge price** is INR (`inr_exchange_rate`) ."},quick_facts:{facts:{Country_of_Origin:"Kazakhstan",Symbol:"₸",Currency_Code:"KZT",Nick_Names:"-",Minor_units:"Tiyn","Denominations_(Banknotes)":"₸200, ₸500, ₸1,000, ₸2,000, ₸5,000, ₸10,000 and ₸20,000",Motto:"‘Firme y feliz por la unión’ which means ‘firm and happy for the union",Identification_Feature:"On the obverse side of the ₸10,000 note, you will find the portrait of Al-Farabi, a popular Islamic philosopher and jurist.",Issuing_Bank:"National Bank of Kazakhstan",In_Circulation_Since:"November 15, 1993",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'After the fall of the Soviet Union in December of 1991, the majority of the countries that once were part of the Soviet Union made attempts to maintain the stability of their currencies.\n\n &nbsp; \n\nThe Central Bank of Russia was granted authorization on January 1, 1992, to take control of the State Bank of the USSR (Gosbank). Even after their countries gained their freedom, the eleven countries that had been supported by regional branches of Gosbank continued to receive supplies of Soviet currency. In any event, the political environment was not one that would support the maintenance of a single currency being in circulation.\n\n &nbsp; \n\nIn the first half of the year 1992, fifteen different states came together to form a monetary union, with the rouble serving as the union\'s standard unit of currency. In response, the Russian Central Bank issued restrictions in July 1992 that restricted the amount of foreign credit that could be moved to Russia. These laws were intended to limit the amount of money that might be used in Russia. At the end of July 1993, when the Central Bank of Russia began exchanging banknotes on Russian territory, Russia officially withdrew, marking the beginning of the end of the rouble zone. This event also marked the beginning of the collapse of the gold standard. Because of this, Kazakhstan and the other nations that were "pushed out" of the rouble zone.\n\n &nbsp; \n\nOn November 12, 1993, the decree that officially introduced the national currency of the Republic of Kazakhstan was signed by the country\'s president. The decree\'s official title was "On Introducing the National Currency of the Republic of Kazakhstan." On November 15, 1993, the tenge was introduced as a replacement for Soviet money at a rate of T 1 = Rbls 500. This occurred at the same time as the collapse of the Soviet Union.\n\n &nbsp; \n\nIn the year 1991, the fashion designers Mendybay Alin, Asimsaly Duzelkhanov, Timur Suleymenov and Khayrulla Gabzhalilov came together to form what they called a "unique group." The "Day of National Currency of the Republic of Kazakhstan" is celebrated annually on November 15 as a result.\n\n &nbsp; \n\nNot until 1995 did Kazakhstan even have a factory that was solely dedicated to printing the tenge currency. The first tenge banknotes were produced in the United Kingdom, whereas the first tenge coins were struck in Germany. The United Kingdom was also responsible for the printing of the first batch of tenge banknotes. Following the signing of a measure into law by Kazakh President Nursultan Nazarbayev in February 2019, banknotes and coins issued in the future using the tenge currency no longer include Russian captions.'},countries_accepting:{desc_1:"The Kazakhstani Tenge is only used in Kazakhstan for various kinds of transactions including the sale and purchase of a variety of products and services.",list:[],desc_2:""},amount_for_trip:{desc:"The cost of transportation to your vacation spot, the cost of lodging, and the cost of food and drink purchased while you're there will all have significant impacts on your overall Kazakhstan’s holiday budget. Even on a tight budget of KZT3,312 per day, you'll have enough of money to explore Kazakhstan and pick up souvenirs and other small gifts. A day of luxury travel can cost as much as KZT19,010 due to expenses like eating at Michelin-starred restaurants and staying in five-star hotels. The cost of a vacation for two persons can be somewhere from KZT7,000 and KZT40,010.\n\n &nbsp; \n\nA hotel room in Kazakhstan could cost anywhere from KZT1,224 to KZT5,727 per night, on average. Also, a person who takes public transportation to work and drives to work may spend anywhere from KZT96 to KZT887 per day on transportation costs.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Kazakhstani tenge rate** in order to exchange your currency notes."},identification:{list:["If the denomination printed does not contain colour-changing ink, it is most likely to be counterfeit. A slight colour shift occurs when you hold a banknote at an angle, either to the left or right.","A watermark, a unique security feature, may be found on all genuine banknotes. A counterfeit banknote can be easily identified by smeared borders, typography, or writing.","In most cases, counterfeit printers simply cannot produce authentic-looking copies. Check the bill meticulously to make sure it hasn't been tampered with in any manner, paying close attention to the margins.","Banknotes that are legitimate also feature microprinting. It is likely to be counterfeit if the microprinting cannot be read under a microscope.","Real banknotes can be identified by the raised printing found on them, which is difficult for forgers to replicate. By running your fingertips slowly along the note, you can feel any raised printing. If the raised printing is done correctly, you should feel a slight vibration when you rub your nail against it. You need to give the bill a closer look if you can't feel this texture.","Authentic banknotes feature a small embedded strip called a security thread that runs vertically across the face of the bill. Microprinting in the security thread will give an extra layer of protection for genuine banknotes.","Ultraviolet light is used to detect counterfeiting because it provides a surefire way to spot fake currency."]},how_to_buy:{desc:"Whether you want to buy K**azakhstani tenge forex cards** and currency notes or sell the **Kazakhstani Tenge**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Kazakhstani Tenge to USD, INR to Kazakhstani Tenge** or **Kazakhstani Tenge to Euro**, you only need to follow the below-written steps:"}}},{id:61,internalName:"seo_currency_page_ukrainian-hryvnia",type:"seo_currency_page_ukrainian-hryvnia",data:{name:"Kazakhstani Tenge",code:"UAH",country_code:"UA",travel_country:"Ukraine",keywords:"Ukrainian hryvnia, hryvnia Currency, hryvnia currency,Ukrainian hryvnia to indian rupee, Ukrainian hryvnia to inr, Ukrainian hryvnia to usd, Ukrainian hryvnia to euro, Ukrainian hryvnia to gbp,Ukrainian hryvnia exchange rate, Ukrainian hryvnia currency exchange, buy Ukrainian hryvnia, sell Ukrainian hryvnia, Ukrainian hryvnia forex cards, live Ukrainian hryvnia rate, Ukrainian hryvnia price",about:{title_text:"The Strong Currency of Ukraine",desc:"Since September 2, 1996, the hryvnia, which is also spelled hryvnya, has served as the Ukraine’s primary currency. One hundred kopiyok make up one hryvnia. It got its name from a weight measurement system used in Kievan Rus' that originated in the Middle Ages. 1996 was the year that formally marked the adoption of the currency by the country's government. There are several acceptable variations of the name, including hryvnya, grivna, and kopiyka. On the foreign exchange market, the abbreviation for the hryvnia is UAH.\n\n &nbsp; \n\nThe National Bank of Ukraine, which serves as the country's central bank, is in charge of monetary policy and the economy. It is also responsible for issuing the currency. In circulation currently are banknotes with the following face values: 10, 20, 50, 100, 200, and 500.\n\n &nbsp; \n\nThe current **Ukrainian Hryvnia price** is INR (`inr_exchange_rate`) ."},quick_facts:{facts:{Country_of_Origin:"Ukraine",Symbol:"₴ or грн",Currency_Code:"UAH",Nick_Names:"-",Minor_units:"kopiyka","Denominations_(Banknotes)":"₴1, ₴2, ₴5, ₴10, ₴20, ₴50, ₴100, ₴200, ₴500, ₴1,000",Motto:"-",Identification_Feature:"On the obverse side of ₴1,000 note, you will find the watermark of Volodymyr Vernadskyi who was a historian and scientist.",Issuing_Bank:"National Bank of Ukraine",In_Circulation_Since:"September 2, 1996",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Agriculture and heavy industries helped propel Ukraine to the position of having one of the largest economies in the former Soviet Union.\n\n &nbsp; \n\nIn 1917, when the Ukrainian National Republic declared its independence from the Russian Empire, the new currency of the country, which was a renamed version of the Kievan Rus' hryvnia, was given the name hryvnia. The karbovanets were exchanged for the hryvnia at a rate of 1 hryvnia to 100,000 karbovantsiv between September 2 and September 16, 1996.\n\n &nbsp; \n\nAfter the collapse of the Soviet Union in the early 1990s, hyperinflation swept over the karbovanets. The introduction of the hryvnia occurred in relative obscurity for the most part. According to a Presidential Decree dated August 26, 1996, the Hryvnia was formally introduced into circulation on August 29, 1996.\n\n &nbsp; \n\nAfter September 16, 1996, any karbovanets that are still in circulation can potentially be exchanged for hryvnia at financial institutions.\n\n &nbsp; \n\nStarting in January 2023, the National Bank of Ukraine will begin the process of discontinuing the circulation of paper banknotes for the denominations 5, 10, 20, and 100 hryvnia. These banknotes were developed between the years 2003 and 2007. Newly designed coins and banknotes of a more recent generation will take their place when they are phased out."},countries_accepting:{desc_1:"Since September 2, 1996, the hryvnia (sometimes spelled hryvnya) has been the official currency of Ukraine. This currency is used for all kinds of transactions within the country.",list:[],desc_2:""},amount_for_trip:{desc:"The money you spend going to Ukraine, sleeping there, and eating and drinking, while you're there, will all have a big impact on the total cost of your trip. While in Ukraine, your daily budget of ₴304 will allow you to explore the sights and buy souvenirs and other small goods. Travelling in elegance can cost up to ₴1,936 per day, including meals at Michelin-starred restaurants and stay at five-star hotels. For two persons, the trip should cost between ₴750 and ₴4,580.\n\n &nbsp; \n\nIn Ukraine, the average cost of a hotel room ranges from ₴200 to ₴1,132. The average commuter spends between ₴11 and ₴85, depending on whether they drive or take public transportation.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Ukrainian Hryvnia rate** value in order to exchange your currency notes."},identification:{list:["Each denomination of banknote has its own distinct colour of paper that is used in the printing process so that it can be easily distinguished from other denominations of banknotes. One colour predominated throughout this picture. The note for one hundred hryvnia is olive green, the note for two hundred hryvnia is pale pink, and the note for five hundred hryvnia is beige.","When a banknote is held up to the light, the image that is revealed is one that is created by the internal structure of the paper. T. Shevchenko, Lesia Ukraineka, and Grigory Skovoroda appear on the 100, 200, and 500 hryvnia bills, respectively.","Some of the images on the front of the bill are created with a special stamp that is only available for that purpose. The paint has been lifted off the paper, which makes the uneven surface of the notes more apparent.","When a banknote is held at an acute angle to the light source, an image of the denomination's digital value shows on the note.","The banknote contains a number of different visual components, all of which are printed with ink that, depending on the angle at which the observer is looking at it, changes colour. If you rotate your head so that it is perpendicular to the orientation of the photo, you will notice that the image has a lilac (or crimson-purple) cast to it. The colour shifts to an olive tone when viewed from a perspective that is so far off from the original scene.","This one-of-a-kind printing technique makes it possible to create multi-coloured images in which the change from one hue to the next is smooth and unbroken.",'The bill for one hundred hryvnia displays the letter "U," the bills for two hundred and five hundred and one thousand hryvnia display the value of the nominal "200" and "500," respectively, and the bill for one thousand hryvnia displays a distinct picture that is only obscured when it is viewed in the dark.']},how_to_buy:{desc:"Whether you want to buy **Ukrainian Hryvnia forex cards** and currency notes or sell the **Ukrainian Hryvnia**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Ukrainian Hryvnia to GBP, INR to Ukrainian Hryvnia** or **Ukrainian Hryvnia to Euro**, you only need to follow the below-written steps:"}}},{id:62,internalName:"seo_currency_page_algerian-dinar",type:"seo_currency_page_algerian-dinar",data:{name:"Algerian Dinar",code:"DZD",country_code:"DZ",travel_country:"Algeria",keywords:" Algerian dinar,Algerian dinar Currency, Algerian dinar symbol,Algerian dinar to indian rupee, Algerian dinar to dollar, algerian dinar to inr, algerian dinar to gbp, algerian dinar to pkr, algerian dinar to usd, algerian dinar to eur, algerian dinar to aed, dinar exchange rate, Algerian dinar currency exchange, buy Algerian dinar, sell Algerian dinar, Algerian dinar forex cards, live Algerian dinar rate, Algerian dinar price",about:{title_text:"The Strong Currency of Algeria",desc:'Algeria\'s official unit of money is known as the dinar, and one dinar is equivalent to one hundred centimes. Centimes are no longer used as currency because of their extremely low value. The word "dinar" originates from the Latin word for a denarius, which was a coin made of silver that was used by the Romans. The **Algerian dinar symbol** is DA or دج.\n\n &nbsp; \n\nAs a result of France\'s occupation of Algeria between the years 1830 and 1962, the word "santm" in Arabic originated from the French word "centime." In place of the dinar, the franc and the doro are the most common units of currency used by the general populace. Prices are typically listed in francs at more traditional markets such as the vegetable market or with street vendors, while they are listed in dinars at more modern stores.\n\n &nbsp; \n\nThe **Algerian dinar price** is INR (`inr_exchange_rate`) .'},quick_facts:{facts:{Country_of_Origin:"Algeria",Symbol:"DA or دج",Currency_Code:"DZD",Nick_Names:"-",Minor_units:"Centime","Denominations_(Banknotes)":"200 DA, 500 DA, 1000 DA, 100 DA and 2000 DA",Motto:"-",Identification_Feature:"The 1000 DA note has the image of Grand mosque of Algiers on the obverse side.",Issuing_Bank:"Bank of Algeria",In_Circulation_Since:"April 1, 1964",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'The Algerian new franc was replaced by the dinar on its first day of formal circulation, which was April 1, 1964. In 1964, the 1, 2, 5, 10, 20, and 50 centimes, as well as the 1 dinar, were all issued. The lower denominations were struck in aluminium, the larger ones in aluminium bronze, and the larger one in cupro-nickel.\n\n &nbsp; \n\nThe manufacturing of coins for one centime and two centimes was discontinued forever, and in the 1980s, production of coins worth five, ten, and twenty centimes came to an end. In 1992, a brand new series of coins was introduced. These coins were priced in fractions of a dinar, ranging from a quarter dinar to one hundred dinars.\n\n &nbsp; \n\nThe issue of a bimetallic 200 dinar coin in 2012 was timed to coincide with the celebration of the 50th anniversary of Algeria\'s independence. There are bimetallic coins ranging in value from 10 dinars up to 200 dinars for every denomination.\n\n &nbsp; \n\nBecause of the massive inflation that occurred concurrently with the gradual transition to a more capitalist economic system in the late 1990s, the dinar centime and fractional dinar coins are no longer commonly used in day-to-day transactions. Because prices are typically rounded up to the nearest 5 dinars, the 1 dinar and 2 dinar coins are not commonly used either.\n\n &nbsp; \n\nHowever, centimes are frequently used when expressing prices in informal situations; for instance, a price of 100 dinars can be read as "ten thousand." Centimes are commonly used when quoting prices in France. As part of the "first series," Dinar banknotes were issued in 1964 in values of 5, 10, 50, and 100. These notes were all part of the "first series." The first note of 500 dinars was issued in 1970, and the first note of 1000 dinars was issued in 1992. DA and دج represent the A**lgerian dinar symbol.**'},countries_accepting:{desc_1:"The Algerian dinar is a national currency used exclusively in Algeria. It was introduced in 1964.",list:[],desc_2:""},amount_for_trip:{desc:"The amount that you spend on things like travel, hotel, and activities during your trip will have a significant impact on how much money you have to spend on the overall trip. In Algeria, if you have a daily budget of 20,000 DA, you will have enough money to move around, see the attractions, and buy some souvenirs. The cost of a luxury vacation can reach up to 41,226 DA per day if it includes dining at restaurants with Michelin stars and staying in five-star hotels. A reasonable estimate for the vacation of two individuals would be between 45,000 DA and 85,000.\n\n &nbsp; \n\nFrom 7,000 DA all the way up to 15,000, this is the typical cost of a night's stay in a hotel room in Algeria. The daily cost of transportation for the average commuter falls somewhere in the range of 150 DA to $ 10 1,500 DA.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **live Algerian Dinar rate** in order to exchange your currency notes. You can check Algerian dinar to Dollar, Algerian dinar to GBP, Algerian dinar to PKR, and Algerian dinar to AED."},identification:{list:["There is a high likelihood that the currency in question is fake if the denomination printed on it does not use colour-changing ink. The colour of a bill will somewhat alter if you hold it in your hand and tilt it to the left or right.","A watermark, a recognisable security element and one of the security characteristics included on genuine banknotes shall be present on all authentic banknotes.","It is obvious that a banknote is phoney and should not be used when the borders, typography, or text are unclear. The lines and textures on the original banknotes are incredibly delicate due to the dies that were used to create them. False printers typically are unable to produce work with the same level of realism as their actual counterparts.","Another clue that the cash in question is authentic is microprinting. When microprinting cannot be read under a magnifying glass, it is quite likely that the information on the paper is false.","Raised printing, which is unique to genuine banknotes, is notoriously challenging for counterfeiters to imitate. By slowly and carefully tracing your fingers over the note, you can find raised printing.","A banknote's security thread is a vertical strip of an incredibly thin embedded thread that spans the top to bottom of the bill's front. Microprinting on the security thread on genuine banknotes will act as an extra line of defence against counterfeiting."]},how_to_buy:{desc:"Whether you want to buy **Algerian Dinar forex cards** and currency notes or sell the **Algerian Dinar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Algerian Dinar to USD, INR to Algerian Dinar** or **Algerian Dinar to Euro**, you only need to follow the below-written steps:"}}},{id:63,internalName:"seo_currency_page_hungarian-forint",type:"seo_currency_page_hungarian-forint",data:{name:"Hungarian Forint",code:"HUF",country_code:"HU",travel_country:"Hungary",keywords:"Hungarian forint,Hungarian forint Currency, Hungarian forint rate, Hungarian forint symbol,Hungarian forint to rupee, Hungarian forint to dollar, hungarian forint to inr, convert hungarian forint to canadian dollars, 1 hungarian forint to euro, hungarian forint to usd, Hungarian forint exchange rate, Hungarian forint currency exchange, buy Hungarian forint, sell Hungarian forint, Hungarian forint forex cards, live Hungarian forint rate, Hungarian forint price",about:{title_text:"The Currency of Hungary",desc:"Hungary's official currency is the **Hungarian forint**. The **Hungarian forint symbol** is Ft. It used to be divisible into 100 fillér, but there are no longer any fillér coins in use. The **Hungarian forint** was introduced on August 1, 1946, and it remained mostly steady until the 1980s. This was an important step in the post-World War II stabilisation of the Hungarian economy. As a direct consequence of the transition to a market economy that took place in the early 1990s, inflation skyrocketed to a record high of 35% in 1991. The value of the Hungarian forint can be exchanged for any other currency, and the country's overall inflation rate was less than 10% between the years 2001 and 2022. Inflation skyrocketed to a rate of 10.7 percent in May of 2022 as a direct result of the Ukrainian War and the accompanying economic upheaval. Although the present Hungarian administration has not set a timeframe for the adoption of the euro, it is possible that doing so in the long term as a member of the European Union is a long-term goal.\n\n &nbsp; \n\nThe **live Hungarian forint rate** falls and rises all the time. However, the **Hungarian forint price** has remained relatively constant recently. The current rate for the **Hungarian forint to INR** is `inr_exchange_rate`."},quick_facts:{facts:{Country_of_Origin:"Hungary",Symbol:"Ft",Currency_Code:"HUF (numeric- 348)",Nick_Names:"-",Minor_units:"Fillér (defunct)","Denominations_(Banknotes)":"500 Ft, 1,000 Ft, 2,000 Ft, 5,000 Ft, 10,000 Ft, 20,000 Ft",Motto:"-",Identification_Feature:"Each Hungarian forint banknote has an image of a well-known Hungarian politician or leader on the obverse and a location or event connected to him on the reverse. The banknotes are entirely watermarked, have a vertical security strip inserted in them, and are accessible to those who are blind. An interwoven holographic security strip is used to secure notes worth 1,000 Hungarian forints and above. The dimensions of all the notes are 154 mm by 70 mm (6.1 in x 2.8 in).",Issuing_Bank:"Magyar Nemzeti Bank (Hungarian National Bank)",In_Circulation_Since:"1st  August, 1946",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Between 1868 and 1892, the **Hungarian forint** was initially introduced. But the current forint wasn't established until 1946. Following World War II, it was intended to stabilise the economy of the country. The name of the **Hungarian forint** is derived from Florence's fiorino d'oro gold coins, which were minted starting in 1252 and circulated all across the Austro-Hungarian empire. In certain ways, the **Hungarian forint exchange rate** has remained steady. However, the **Hungarian Forint rate** in the foreign currency market has been hampered by the nation's economic uncertainty. Consider the following:\n\n &nbsp; \n\nFollowing World War I, the Trianon Treaty was accepted. This had a number of disastrous impacts on the economy. More than 70% of its pre-war area and more than 60% of its pre-war inhabitants were lost as a result.\n\n &nbsp; \n\nPrior to World War I, five of Hungary's top ten cities were annexed by nearby nations. The **Hungarian Forint** lost virtually all of its value due to the burden of war reparations and the reduction in its tax base. Annualized inflation peaked in 1923 and was close to 1,200%.\n\n &nbsp; \n\nCurrently, the **Hungarian Forint to Dollar** (USD) stands at 0.0026, while **1 Hungarian Forint to Euro** is 0.0025."},countries_accepting:{desc_1:"The **Hungarian Forint** is accepted only in Hungary itself and no other country.",list:[],desc_2:""},amount_for_trip:{desc:"The **Hungarian forint** is used as the local currency. Forget that there are alternative currencies. **Buy Hungarian Forint** as much as you determine is required for the trip. Yes, they would accept Euros, especially at the cafés and restaurants centred around the major tourist attractions, but the exchange rate would be whatever the vendor determined to be profitable that day. Why would they, given that it is not the native currency? It also won’t help if you **convert Hungarian Forint to Canadian Dollars**.\n\n &nbsp; \n\nAlmost everything can be purchased with a credit card. It would be ideal if you had one with the **Hungarian Forint Forex Cards** option. If you wish to have cash on hand, there are several ATMs that you may use to withdraw a small sum. The national currency is the only form of legal money.\n\n &nbsp; \n\nFor your trip to Hungary, you should budget around 24,259 **Hungarian Forint** ($63) per day, which is the average daily price based on what previous tourists have spent there. Past visitors have spent, on average, Ft 3,450 ($9.00) on local transportation and Ft 6,425 ($17) on meals in one day. Additionally, a couple may stay at a hotel for Ft 24,244 ($63) on average in Hungary. Therefore, the average cost of a weeklong trip to Hungary for two individuals is **Hungarian Forint** 339,620 ($886).\n\n &nbsp; \n\nHowever, don’t hope to **sell Hungarian forint** at a good rate, as that will surely be at your loss."},identification:{list:["The banknotes are entirely watermarked, have a vertical security strip inserted in them, and are accessible to those who are blind.","An interwoven holographic security strip is used to secure notes worth 1,000 forints and above.","The 200 Ft coin features a silver inside and an outside ring that is gold in colour. This is not to be confused with the 100 Ft, which has a silver ring on the outside and a gold ring within. All the other coins are substantially smaller than the 200 Ft. Additionally, there are 50, 20, 10 and 5 Ft coins.","Moreover, collector's edition coins and commemorative notes have been produced. In 2000, special edition 2000 Ft banknotes were produced to commemorate the century, and in 2006, a 500 Ft note with a unique design was produced to mark the 50th anniversary of the 1956 Hungarian Revolution.","**Hungarian Forint** banknotes include several anti-fraud design elements, including concealed images, holographic strips, and images are that only visible under specific UV lamps or when magnified. You may view some of the Central Bank of Hungary's anti-fraud measures on its website, which includes an interesting feature. The notes are 154mm x 70mm in size and are composed of cotton."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Hungarian Forint**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Hungarian Forint to USD, INR to Hungarian Forint** or **Hungarian Forint to Euro**, you only need to follow the below-written steps:"}}},{id:64,internalName:"seo_currency_page_moroccan-dirham",type:"seo_currency_page_moroccan-dirham",data:{name:"Moroccan Dirham",code:"MAD",country_code:"MA",travel_country:"Morocco",keywords:"Moroccan dirham, dirham Currency, Moroccan dirham rate, Moroccan dirham symbol,Moroccan dirham to indian rupee, Moroccan dirham to dollar, moroccan dirham to inr, moroccan dirham to cad, moroccan dirham to usd conversion, convert moroccan dirham to euro, Moroccan dirham exchange rate, Moroccan dirham currency exchange, buy Moroccan dirham, sell Moroccan dirham, Moroccan dirham forex cards, live Moroccan dirham rate, Moroccan dirham price",about:{title_text:"The Currency of Morocco",desc:"The official money of Morocco is the **Moroccan dirham** (MAD). The **Moroccan Dirham symbol** is DH. The issue and circulation of the **Moroccan dirham** are under the jurisdiction of Bank al-Maghrib, the country's central bank. It is possible to split a **Moroccan dirham** into 100 centimes (or cents). A santim is the name of each unit.\n\n &nbsp; \n\nMohammed VI, the King of Morocco, has legislative and executive authority over monetary, foreign, and religious matters. He is in power thanks to an elected legislature. Since attempts to remove the King have been unsuccessful, the nation is still a constitutional monarchy. Demonstrators continue to strive for reform that would ultimately reduce the King's influence, including those during the Arab Spring upheavals.\n\n &nbsp; \n\nThe current rate for **Moroccan Dirham** **to** **INR** is `inr_exchange_rate`."},quick_facts:{facts:{Country_of_Origin:"Morocco",Symbol:"DH",Currency_Code:"MAD (Numeric- 504)",Nick_Names:"-",Minor_units:"Santim","Denominations_(Banknotes)":"20, 50, 100, 200 dirhams and 25 dirhams (rarely used)",Motto:"-",Identification_Feature:"A picture of King Mohammed VI and the imperial crown may be seen on the most recent banknotes of Moroccan dirham. An illustration of a Moroccan entryway is also included in the notes as a homage to the nation's rich architectural history.",Issuing_Bank:"Al-Maghrib (Central Bank of Morocco)",In_Circulation_Since:"1882"}},history:{desc:'The Greek drachma is where the term "dirham" comes from. From the eighth to the tenth century, Morocco\'s Idrisid dynasty produced the silver Idrissid dirham.\n\n &nbsp; \n\nMorocco used to issue copper coins in falus, silver coins in dirham, and gold coins in benduqi until the adoption of a modern coinage in 1882. As of 1882, the Moroccan rial was subdivided into 500 Mazunas, 10 dirham, and 1 rial.\n\n &nbsp; \n\nMorocco moved to the Moroccan franc in 1912, when the majority of the country became a protectorate of France. A new **Moroccan dirham** was issued on October 16, 1960. The franc was replaced as the primary unit of currency, but it was nevertheless in use up until 1974, with a parity of 1 dirham for every 100 francs. The centime took the place of the franc in 1974.\n\n &nbsp; \n\nThe **live Moroccan Dirham rate** has faced various ups and downs, but it has stood the test of time. The **Moroccan Dirham price** has been relatively constant in recent times.\n\n &nbsp; \n\nThe value of the **Moroccan Dirham to Dollar** (USD) is 0.09 currently while the value of **Moroccan Dirham to Indian rupee** is 7.88.'},countries_accepting:{desc_1:"The **Moroccan Dirham** is accepted officially only in Morocco. It is, however, seen in use in certain other states locally, such as Ceuta, Melilla, and Western Sahara.",list:[],desc_2:""},amount_for_trip:{desc:"You can only **buy Moroccan Dirham** after you are in Morocco because it is a closed currency. You may bring in or remove up to 1000 DH (about £65), but you must exchange the remaining funds when you arrive.\n\n &nbsp; \n\nYou may convert your pounds to **Moroccan dirham** at a Bureau de Change in the airport or port, at a bank, or in most hotels (though avoid bringing Scottish, Gibraltar, or Northern Irish Sterling notes). Keep your receipt; you may need it to exchange your dirhams back before you depart at a decent rate at the airport. Since you cannot carry the money home, it is wise to withdraw or change only as much as you need. The **Moroccan Dirham exchange rate** will be significantly worse when you **sell Moroccan Dirham** back to pounds or **convert Moroccan Dirham to Euro**. The preferred currency to take back is usually a **Moroccan Dirham to USD conversion**.\n\n &nbsp; \n\nCash is favoured as a payment option in the majority of Morocco because few merchants accept credit cards. However, larger lodging establishments, eateries, and shops are more likely to accept Visa and MasterCard, frequently for a nominal fee. Amex is accepted only seldom. **Moroccan Dirham Forex Cards** are also useful.\n\n &nbsp; \n\nA week in Morocco should cost two people about 7,900 **Moroccan Dirham**.\n\n &nbsp; \n\nThe aforementioned price assumes that you would stay in decent, midrange lodging and eat out a few times a week in addition to some home cooking. It accounts for a few leisurely sightseeing activities but excludes pricey pursuits like adventure sports or deluxe excursions.\n\n &nbsp; \n\nIn general, the cost of travel decreases with the distance travelled, with fly-in, and fly-out excursions occasionally costing more."},identification:{list:["There are two series of banknotes in circulation in Morocco; the current series, printed during King Mohammed VI's reign, and another series issued during the reign of Mohammed VI's father, King Hassan II.","A picture of King Mohammed VI and the imperial crown may be seen on the most recent banknotes. An illustration of a Moroccan entryway is also included in the notes as a homage to the nation's rich architectural history.","Both coins and banknotes are available for the **Moroccan dirham**. There are 20, 50, 100, and 200 dirham banknotes available. The current coinage includes 5, 10, and 20 centimes as well as 0.5, 1, 2, 5, and 10 dirhams."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Moroccan Dirham**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Moroccan Dirham to USD, INR to Moroccan Dirham** or **Moroccan Dirham to Euro**, you only need to follow the below-written steps:"}}},{id:65,internalName:"seo_currency_page_angolan-kwanza",type:"seo_currency_page_angolan-kwanza",data:{name:"Angolan Kwanza",code:"AOA",country_code:"AO",travel_country:"Angola",keywords:"Angolan Kwanza, Currency, Kwanza symbol,Kwanza symbol, Kwanza to indian rupee, kwanza to inr, Kwanza exchange rate, Kwanza currency exchange, buy Kwanza, sell Kwanza, Kwanza forex cards, live Kwanza rate, Kwanza price",about:{title_text:"The Currency of Angola",desc:"The **Angolan Kwanza**, which is abbreviated as AOA, is the legal tender of Angola, a country located in southwestern Africa. One **Angolan Kwanza** is divided into 100 centimos. It is issued by the Central Bank of Angola and is available in both physical and electronic form. The **Kwanza symbol** is Kz.\n\n &nbsp; \n\nThe value of the **Angolan Kwanza** has fluctuated significantly over the years due to a variety of economic and political factors. Inflation has been a persistent problem in Angola, and the **Kwanza price** has depreciated significantly against major currencies like the US dollar.\n\n &nbsp; \n\nThe Kwanza is widely used in Angola for daily transactions and is accepted as a form of payment in many businesses. It is also used in international trade with other countries in the region. The National Bank of Angola is responsible for setting monetary policy and issuing the **Kwanza forex cards**.\n\n &nbsp; \n\nThe current **Kwanza exchange rate** for the Angolan **Kwanza to Indian Rupee** is (`inr_exchange_rate`) . This means that when you convert **Kwanza to Rupee,** you receive around 160 INR for 1000 Kz. The **Kwanza currency exchange** rate against the major currencies is -\n\n &nbsp; \n\n &nbsp;1.  1 USD = 500 AOA\n\n &nbsp;2.  1 Euro = 530 AOA\n\n &nbsp;3.  1 Pound Sterling = 600 AOA\n\n &nbsp;4.  1 JPY = 3.8 AOA\n\n &nbsp; \n\nYou can find more about the **live Kwanza rate** against other international countries with a simple Google search."},quick_facts:{facts:{Country_of_Origin:"Angola",Symbol:"The Kwanza symbol is Kz",Currency_Code:"AOA",Nick_Names:"-",Minor_units:"centimo","Denominations_(Banknotes)":"200 Kz, 500 Kz, 1000 Kz, 2000 Kz, 5000 Kz",Motto:"-",Identification_Feature:"The 2020 series of Kwanza currency banknotes have Natural and Geographical features of the country on the reverse side with the notes from 200 to 2000 denominations being printed on a polymer substrate. The 2012 series have the waterfalls of the country on its backside with the 5000 denomination bearing the Kapanda hydroelectric dam.",Issuing_Bank:"Banco Nacional de Angola (National Bank of Angola)",In_Circulation_Since:"December 1, 1999."}},history:{desc:"**Angolan Kwanza** was introduced in 1977, replacing the escudo as the official currency of Angola. At the time, Angola was undergoing significant political and economic changes following its independence from Portugal in 1975. The **Angolan Kwanza** was intended to symbolize the country's new independence and stabilize the economy after years of conflict and instability.\n\n &nbsp; \n\nThe **Angolan Kwanza** was initially pegged to the US dollar at a fixed exchange rate, but this system was eventually abandoned in favour of a floating exchange rate system. The value of the **Angolan Kwanza** has fluctuated significantly since its introduction, with periods of both appreciation and depreciation against the US dollar and other major currencies.\n\n &nbsp; \n\nInflation has been a persistent problem in Angola, and the kwanza has devalued significantly against major currencies like the US dollar over time. The National Bank of Angola has implemented various measures to try to stabilize the value of the kwanza and curb inflation, including setting interest rates and controlling the money supply.\n\n &nbsp; \n\nDespite these challenges, the **Angolan Kwanza** remains the official currency of Angola and is widely used for daily transactions and international trade."},countries_accepting:{desc_1:"The **Angolan Kwanza** is not considered a strong currency in the international market. As such, there are not any countries accepting **Angolan Kwanza**. The currency is not traded on the international market. Whether you want to **buy Kwanza** or **Sell Kwanza**, you will have to find someone who is willing to trade in Kwanza as the currency is not accepted in international transactions.",list:[],desc_2:""},amount_for_trip:{desc:"The Angolan National Bank's Regulation 1/2016 controls the circumstances for the entry and exit of local and foreign money in Angola by citizens and non-residents alike. In terms of foreign currency entry and exit, non-residents may carry up to USD $5000. On your trip to Angola, you can carry a higher currency value as long as the Entry and Exit of Foreign Currency Statement is in compliance with the terms of the form provided under the regulation. The Regulation allows non-residents to enter or leave the country with a maximum amount of 50,000 Kz."},identification:{list:["**Look for security features:** Most modern banknotes have security features that are designed to make them difficult to counterfeit. These features may include watermarks, holograms, and special inks that change colour when viewed from different angles. If you notice that a banknote is missing these features or that it appears to be poorly printed, it could be counterfeit.","**Check the feel and texture of the banknote:** Genuine banknotes are usually printed on high-quality paper that has a distinct feel and texture. If a banknote feels rough or cheap, it could be counterfeit.","**Compare the banknote to a genuine one:** If you have a genuine **Angolan Kwanza**, you can compare it to the suspected counterfeit to look for differences in colour, size, or other details.","**Check the serial number:** Each genuine banknote has a unique serial number that is printed on it. If the serial numbers on two banknotes are the same, they are counterfeit."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Angolan Kwanza**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Angolan Kwanza to USD, INR to Angolan Kwanza** or **Angolan Kwanza to Euro**, you only need to follow the below-written steps:"}}},{id:66,internalName:"seo_currency_page_dominican-peso",type:"seo_currency_page_dominican-peso",data:{name:"Dominican Peso",code:"DOP",country_code:"DO",travel_country:"Dominican Republic",keywords:"Dominican Peso, peso Currency, Dominican peso rate, Dominican peso symbol, dominican republic peso,Dominican peso to dollar, dominican peso to inr, dominican peso to pound, dominican peso to cad, Dominican peso exchange rate, Dominican peso currency exchange, buy Dominican peso, sell Dominican peso, Dominican peso forex cards, live Dominican peso rate, Dominican peso price",about:{title_text:"The Currency of the Dominican Republic",desc:"The South American country of the Dominican Republic uses its very own currency called the **Dominican Peso**. The country has adopted multiple currencies over the years with only a handful still being considered legal tender in 2022. All **Dominican peso symbol** is RD$ with the currency code being DOP. Being a Fiat currency, the **Dominican Peso** is a sturdy participant in the international currency market with the **Dominican Peso** **Exchange rate** being subjected to frequent changes. The Central Bank of the Dominican Republic is responsible for the storage and distribution of the **Dominican Peso**. The US Dollar is used as a reserve currency for the **Dominican Peso** with the current exchange rate of **Dominican Peso** to Dollar going at around 56.8 **Dominican Peso** for one US dollar. The “Polish Security Printing Works” is responsible for printing the **Dominican Peso currency**. Most modern **Dominican Republic Peso** is made of cotton while some older polymer-based variants are also used.\n\n &nbsp; \n\nAs of 2022, The **Dominican Republic Peso** has five types of bank notes in circulation with the denominations being 50, 100, 200, 500, 1000, and 2000 DOP respectively. The older Peso Oro (Now denominated as “Pesos Dominicanos”) is still in circulation and uses 10 and 20 Peso notes as well. Apart from notes, coins of denominations 1, 5, 10, and 25 are also in circulation. Older 1, 5, 10, 25 centavos and ½ Peso coins are discontinued but still accepted as legal tender. The minor unit of the **Dominican** **Peso** is the centavo, with one centavo being equal to around 1/100 Pesos."},quick_facts:{facts:{Country_of_Origin:"Dominican Republic",Symbol:"$, RD$ (When used with other currencies that use “$”)",Currency_Code:"DOP",Nick_Names:"-",Minor_units:"Centavos","Denominations_(Banknotes)":"RD$ 50, RD$ 100, RD$ 200, RD$ 500, RD$ 1000, RD$ 2000",Motto:"-",Identification_Feature:"Watermark with the three-dimensional image of Juan Pablo Duarte",Issuing_Bank:"Central Bank of Dominican Republic",In_Circulation_Since:"1844"}},history:{desc:"The **Dominican Peso,** bearing the **Dominican peso symbol,** was first introduced in the year 1844 following the country’s independence from Haiti, replacing the Haitian gourde as the standard currency and legal tender in the country. The **Dominican Peso** saw decimalization in 1877, subdividing the Peso into 100 Centavos. The newly formed Dominican Republic distributed its currency to traders at major ports and cities like Santo Domingo to make way for early adoption and boost its participation in currency exchange.\n\n &nbsp; \n\nFollowing the country’s entry into the “Latin Monetary Union” in 1891, a secondary currency named “Franco” was introduced with the goal of replacing the **Dominican Peso currency**. That goal however was never achieved, and the Franco was soon decommissioned in 1897 after 6 years.\n\n &nbsp; \n\nThe **Dominican Peso** was briefly replaced by the USD in 1905. The USD still holds its place as legal tender in the country (**Dominican Peso to Dollar**: 0.018) although the **Dominican Peso rate** has dropped significantly."},countries_accepting:{desc_1:"The **Dominican Peso** was created primarily to be used as legal tender inside the country of the Dominican Republic. While the Peso might be unofficially used as currency in neighbouring countries like Haiti, it’s not legal tender.\n\n nbsp; \n\nIt is not recommended to use the **Dominican Peso** outside of the Dominican Republic owing to the low **Dominican Peso rate**. **Dominican Peso to CAD** is 0.24, and **Dominican Peso to pound** is 0.015 while **Dominican Peso to INR** is `inr_exchange_rate`.",list:[],desc_2:""},amount_for_trip:{desc:"Owing to the low **Dominican Peso price** you don’t need to carry a lot of **Dominican Peso** to get by comfortably in the Dominican Republic, depending on your kind of stay, food choices, and travel options. Moderate accommodation with transportation and food should cost around 3000 to 5000 **Dominican Peso** per day. If you’re limiting your stay options to only the most luxurious hotels and restaurants, your cost can go up to 13000 **Dominican Peso** a day.\n\n &nbsp; \n\nIt is always recommended to carry **Dominican Peso Forex cards**. You should also keep an eye on the **live Dominican Peso rate** before you **buy Dominican Peso** or **sell Dominican Peso** at a **Dominican Peso currency exchange** centre."},identification:{list:["The **Dominican Peso** notes have a three-dimensional watermark bearing the image of Juan Pablo Duarte, considered to be the father of the modern Dominican Republic. The watermark is present on both the front and back sides of the note.","The **Dominican Peso** notes boast a glossy stripe on the back of the note which appears to have a golden colour when the note is placed flat on a surface. The golden colour changes if the note is viewed from any other angle."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Dominican Peso**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Dominican Peso to USD, INR to Dominican Peso** or **Dominican Peso to Euro**, you only need to follow the below-written steps:"}}},{id:67,internalName:"seo_currency_page_ethopian-birr",type:"seo_currency_page_ethopian-birr",data:{name:"Ethiopian Birr",code:"ETB",country_code:"ET",travel_country:"Ethiopia",keywords:"Ethiopian birr, birr Currency, Ethiopian birr symbol,Ethiopian birr to rupee, Ethiopian birr to indian rupee, Ethiopian birr to dollar, ethiopian birr to inr, convert ethiopian birr to pounds, convert ethiopian birr to usd, Ethiopian birr exchange rate, Ethiopian birr currency exchange, buy Ethiopian birr, sell Ethiopian birr, Ethiopian birr forex cards, live Ethiopian birr rate, Ethiopian birr price",about:{title_text:"The Currency of the Ethiopia",desc:'The Federal Democratic Republic of Ethiopia\'s official currency, the **Ethiopian Birr**, is issued by the National Bank of Ethiopia, which controls its value through a filthy float.\n\n &nbsp; \n\nA birr has 100 santims within it. The name of the **Ethiopian Birr** comes from a regional term for silver. The **Ethiopian Birr symbol** is "Br," and its currency code is ETB.\n\n &nbsp; \n\nThe current rate for **Ethiopian Birr to INR** is `inr_exchange_rate`.'},quick_facts:{facts:{Country_of_Origin:"Ethiopia",Symbol:"Br (Latin Script) ብር (Ethiopic Script)",Currency_Code:"ETB (numeric- 230)",Nick_Names:"-",Minor_units:"Santim","Denominations_(Banknotes)":"1, 5, 10, 50, 100, 200 birr",Motto:"-",Identification_Feature:"**Ethiopian Birr** banknotes come in variety of colours- Green (10 birr), Vermilion (50 birr), Indigo (100 birr), Violet (200 birr)",Issuing_Bank:"National Bank of Ethiopia",In_Circulation_Since:"1931 AD",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Ethiopia, formerly known as Abyssinia, officially accepted the Maria Theresa Thaler as its national currency until 1894. It was named after the Empress of the Holy Roman Empire. 16 guerches or piastres made up a thaler. The talari or Melenik dollar, named after Emperor Melenik II, took its place.\n\n &nbsp; \n\nThe Bank of Abyssinia was founded in 1905 by Menelik II and a European financial organisation, and it began issuing banknotes in 1915. The National Bank of Ethiopia was founded in 1931 after the Ethiopian Emperor Haile Selassie acquired and reorganised the Bank of Abyssinia.The bank split the thaler into 100 centimes at this point. Also in 1931, the Emperor asked for the new constitution to change the name of the nation from Abyssinia to Ethiopia.\n\n &nbsp; \n\nThe creation of the Italian lira in 1936 was prompted by Italy's annexation of Ethiopia. The East African shilling was introduced in 1941 with the advent of British soldiers, replacing the Turkish lira and serving as the country's legal coinage from 1941 until 1945.\n\n &nbsp; \n\nIn 1945, the current birr was reinstated as the nation's legal tender at a rate of one cent. Up until 1976, the official English translation of the currency on banknotes was the \"Ethiopian dollar.\" Then Ethiopia stated in all languages that the birr, not the dollar, was its official currency. The birr just means birr, even when translated.\n\n &nbsp; \n\nThe **live Ethiopian Birr rate** has faced various ups and downs, but it has stood the test of time. The **Ethiopian Birr price** has been relatively constant in recent times."},countries_accepting:{desc_1:"The **Ethiopian Birr** is accepted only in Ethiopia itself and no other country.",list:[],desc_2:""},amount_for_trip:{desc:"**Buy Ethiopian Birr** as much as you calculate to be required. For your trip to Ethiopia, you will need **Ethiopian Birr** 2,588 ($48) each day approximately, which is the average daily price based on what previous tourists spent there. Previous visitors have, on average, spent ETB 287 ($5.34) on local transportation and ETB 672 ($13) on meals for one day. Additionally, a couple may stay in a hotel for an average cost of ETB 2,734 ($51). Therefore, the average cost of a weeklong trip to Ethiopia for two individuals is ETB 36,230 ($675). These average travel costs were compiled from feedback from previous travellers to assist you in creating your own trip budget. **Ethiopian Birr Forex Cards** are also useful.\n\n &nbsp; \n\nTypically, one person's trip to Ethiopia for a week costs about ETB 18,115. Therefore, a weeklong vacation to Ethiopia for two people would cost about ETB 36,230. In Ethiopia, a two-week trip for two individuals costs ETB 72,461. When a family of three or four takes a trip, the cost can frequently be reduced since child tickets are less expensive and hotel rooms can be shared. Your daily budget will decrease if you drive more slowly over a longer distance. A month's worth of shared travel in Ethiopia between two individuals can frequently result in a cheaper daily budget per person than a week's worth of solo travel. The **Ethiopian Birr exchange rate** will be significantly worse when you **sell Ethiopian Birr** back to euros or **convert Ethiopian Birr to pounds**. The preferred currency to take back is usually **to convert Ethiopian Birr to USD**."},identification:{list:[]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Ethiopian Birr**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Ethiopian Birr to USD, INR to Ethiopian Birr** or **Ethiopian Birr to Euro**, you only need to follow the below-written steps:"}}},{id:68,internalName:"seo_currency_page_guatemalan-quetzal",type:"seo_currency_page_guatemalan-quetzal",data:{name:"Guatemalan Quetzal",code:"GTQ",country_code:"GT",travel_country:"Guatemala",keywords:"Guatemalan quetzal,Guatemalan quetzal symbol, quetzal to usd, Guatemalan quetzal exchange rate, Guatemalan quetzal currency exchange, buy Guatemalan quetzal, sell Guatemalan quetzal, Guatemalan quetzal forex cards, live Guatemalan quetzal rate, Guatemalan quetzal price",about:{title_text:"The Currency of the Guatemala",desc:"The official money of Guatemala is the **Guatemalan quetzal** (GTQ). The **Guatemalan quetzal symbol** is Q. The issue and circulation of the **Guatemalan quetzal** are under the jurisdiction of the Bank of Guatemala, the country's central bank. It is possible to split a **Guatemalan quetzal** into 100 centavos.\n\n &nbsp; \n\nGuatemala is a nation in Central America with a colourful past. Tourists swarm there yearly to see its historic Mayan ruins and picturesque towns and cities, like Antigua. Numerous emigrants to the little country have made the United States, Canada, and Spain their new homes. Here is the information you need to know about the **Guatemalan quetzal** (GTQ), which is the currency of Guatemala, whether you're sending an international money transfer, relocating there, or travelling there."},quick_facts:{facts:{Country_of_Origin:"Guatemala",Symbol:"Q",Currency_Code:"GTQ (Numeric- 320)",Nick_Names:"-",Minor_units:"Centavo","Denominations_(Banknotes)":"1, 5, 10, 20, 50, 100, 200 quetzales",Motto:"-",Identification_Feature:"Each banknote's value is displayed in Mayan numerals on the upper-right corner, signifying Guatemala's cultural heritage.",Issuing_Bank:"Bank of Guatemala",In_Circulation_Since:"1925 AD"}},history:{desc:"The **Guatemalan quetzal** was created in 1924 and was given its name in honour of the quetzal bird, whose feathers were once used as payment by the prehistoric Mayans. These long-tailed birds are prominently seen on contemporary banknotes. The Guatemalan peso, which had been introduced in 1859 to replace the Central American real, was officially replaced by the currency in 1925.\n\n &nbsp; \n\nWhen the Central Bank of Guatemala was first created in 1926, the exchange rate for currency was 1 quetzal to 60 pesos. The currency was first tied to the gold standard and then fixed at par with the US dollar by the government. Guatemala underwent a political revolution in 1944, ending its dictatorship and establishing more democratic government structures. The Central Bank of Guatemala ceased issuing money in 1946, and the new Bank of Guatemala, which the government had founded in 1945, took over. The newly established bank took over coin production and released a new series of banknotes.\n\n &nbsp; \n\nThe quetzal's exchange rate has been permitted to fluctuate freely against international currencies by the central bank since 1987. Nevertheless, the value of the quetzal has been quite constant since 2000, ranging between 7 and 8 quetzals per U.S. dollar after a brief increase following the withdrawal of its peg.\n\n &nbsp; \n\nThe **live Guatemalan quetzal rate** has faced various fluctuations in terms of value, but it has stood the test of time. The **Guatemalan quetzal price** has been relatively constant in recent times."},countries_accepting:{desc_1:"The **Guatemalan quetzal** is accepted officially only in Guatemala.",list:[],desc_2:""},amount_for_trip:{desc:"**Buy Guatemalan quetzal** as much as you determine will be required. For your trip to Guatemala, you should budget Q304 ($39) a day, which is the average daily price based on what earlier travel enthusiasts spent there. Average daily meal costs for previous passengers were Q87 ($11) and Q55 ($7.02), respectively. Additionally, a hotel room in Guatemala costs Q203 ($26) for a couple. Thus, the average cost of a weeklong trip for two individuals to Guatemala is Q4,259 ($539). These average travel costs were compiled from feedback from previous travellers to assist you in creating your own trip budget. The **Guatemalan quetzal exchange rate** will be significantly worse if you decide to **sell Guatemalan quetzal** back to euros. Using **Guatemalan quetzal Forex Cards** is a safer option."},identification:{list:["The 50-centavo currency features Tecn Umán, the quetzal legend's hero. This banknote is still in use even though it is no longer produced. An image of the eighth-century Temple I pyramid at Tikal may be found on the object's back.",'The quetzal commemorates the peace negotiations that brought an end to Guatemala\'s civil war. The Guatemalan government and the Unidad Revolucionaria Nacional Guatemalteca, an alliance of several revolutionary factions, engaged in this conflict from 1960 until 1996. On December 29, 1996, the Accord for a Firm and Lasting Peace brought it to an end. The coin has a dove design with the Spanish word for peace, "paz." As a reflection of the losses and sacrifices made by the Guatemalan people, the words "Firm and Lasting Peace" and the date the peace agreement was signed are written around the edge',"The value of each quetzal banknote is written in Mayan writing in the top-right corner, even though indigenous people may not frequently appear on Guatemalan money.","The marimba, Guatemala's national instrument, is honoured on the 200 quetzal banknote."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Guatemalan Quetzals**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Guatemalan Quetzals to USD, INR to Guatemalan Quetzals** or **Guatemalan Quetzals to Euro**, you only need to follow the below-written steps:"}}},{id:69,internalName:"seo_currency_page_bulgarian-lev",type:"seo_currency_page_bulgarian-lev",data:{name:"Bulgarian Lev",code:"BGN",country_code:"BG",travel_country:"Bulgaria",keywords:"Bulgarian Lev,Bulgarian lev Currency, Bulgarian lev rate today, Bulgarian lev symbol,Bulgarian lev to indian rupee, Bulgarian lev to dollar, bulgarian lev to inr, bulgarian lev to aud, bulgarian lev to euro, bulgarian lev to pound, Bulgarian lev exchange rate, Bulgarian lev currency exchange, buy Bulgarian lev, sell Bulgarian lev, Bulgarian lev forex cards, live Bulgarian lev rate, Bulgarian lev price",about:{title_text:"The Currency of the Bulgaria",desc:'The **Bulgarian Lev**, which is abbreviated as BGN, is the legal tender of Bulgaria. It is denoted by the **Bulgarian Lev symbol** "лв" and can be broken down into 100 stotinki. The **Bulgarian Lev** was first used in 1880, shortly after Bulgaria declared independence from the Ottoman Empire. The new country required a currency that reflected its newly obtained status and was named after the then-popular term for "lion," which was also the principal emblem of the Bulgarian independence struggle.\n\n &nbsp; \n\nTo identify **Bulgarian Lev**, you can look for coins and banknotes that have the symbol "лв" or "BGN" and the value of the currency written in Bulgarian. **Bulgarian Lev** comes in denominations of 1, 2, 5, 10, 20, and 50 stotinki and 1, 2, 5, 10, 20, 50, and 100 Lev. The banknotes feature images of Bulgarian cultural and historical figures, such as writers, artists, and politicians.\n\n &nbsp; \n\nThe Bulgarian National Bank issues the **Bulgarian** **Lev,** and the currency is mostly used for domestic transactions. The national bank keeps a tight economic policy to maintain the viability of the Lev against international currencies and is also responsible for issuing **Bulgarian Lev Forex cards**.\n\n &nbsp; \n\nThe **Bulgarian Lev exchange rate** against the major world currencies is presented below. These values represent the **Bulgarian Lev rate today.**\n\n &nbsp; \n\n &nbsp;1.  1 Bulgarian Lev to Indian Rupee: `inr_exchange_rate` INR\n\n &nbsp;2.  1 Bulgarian Lev to Dollar: 0.54 USD\n\n &nbsp;3.  1 Bulgarian Lev to AUD: 0.81 AUD\n\n &nbsp;4.  1 Bulgarian Lev to Euro: 0.51 Euro\n\n &nbsp;5.  1 Bulgarian Lev to Pound: 0.45 Pound\n\n &nbsp; \n\nYou can find the **live Bulgarian Lev rate** in the international market with a simple search on a search engine and get the latest **Bulgarian Lev currency exchange.**'},quick_facts:{facts:{Country_of_Origin:"Bulgaria",Symbol:"The Bulgarian Lev symbol is лв",Currency_Code:"BGN",Nick_Names:"-",Minor_units:"Stotinka, Stotinki (Plural)","Denominations_(Banknotes)":"1лв, 2лв, 5лв, 10лв, 20лв, 50лв, 100лв",Motto:"-",Identification_Feature:"To identify a genuine **Bulgarian Lev** currency banknote, you need to:\n\n &nbsp; \n\n &nbsp;1. Run your finger or fingernail along the surface to feel the intaglio print\n\n &nbsp;2. Look for the watermark, security thread, and the value inscribed.\n\n &nbsp;3.  Tilt the banknote to see the holographic strip and gradient colour elements",Issuing_Bank:"Bulgarian National Bank",In_Circulation_Since:"July 5, 1999",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The **Bulgarian Lev** has a complicated history. It was originally used in 1881 to replace the Bulgarian peseta at a rate of 1 Lev = 4 Pesetas. Initially, the Lev was tied to the French franc at a rate of 1 Lev = 0.554 Francs. Bulgaria joined the gold standard in 1912, with the **Bulgarian Lev** linked to the British pound at a rate of 1 **Bulgarian** **Lev** equaling 0.375 Pounds.\n\n &nbsp; \n\nBulgaria developed a planned economy following WWII, and the **Bulgarian Lev** was tied to the Soviet ruble at a rate of 1 Lev = 0.15 Rubles. The **Bulgarian** **Lev** was not freely convertible, and the government regulated its value. Following the fall of communism in the 1990s, Bulgaria established a market-based economy, with the Lev tied to the German Mark at a rate of 1 Lev = 0.51 Marks. Bulgaria joined the Exchange Rate Mechanism II (ERM II) in 1999, and the Lev was tied to the Euro at 1.95583 Lev = 1 Euro. The lev is completely convertible and permitted to freely float against other currencies.\n\n &nbsp; \n\nBulgaria entered the European Union in 2007, and the **Bulgarian Lev price** was formally tied to the euro at 1.95583 Lev = 1 Euro. This peg has stayed in place until now. As such, the **Bulgarian Lev rate today** is tied to the value of the Euro."},countries_accepting:{desc_1:"The **Bulgarian Lev** is pegged to the Euro, and as such, it can be exchanged for Euros in the European Union or by countries that want to trade in the **Bulgarian Lev**. The Lev is closely controlled and is set to be supplanted by the Euro in 2024. Whether to **buy Bulgarian Lev** or **sell Bulgarian Lev**, you will most probably have to deal with government institutions, banks, or financial institutions dealing in international currencies.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of **Bulgarian Lev** you will need for your trip varies depending on the kind of trip you are going to take. You can easily tour and live in the country from anywhere between 50 BGN to 200-300 BGN. There are also ATMs that accept international cards."},identification:{list:["**Examine the security features: Bulgarian Lev** contains a variety of security measures that aid in the prevention of counterfeiting. Watermarks, security threads, holograms, and microprinting are examples of these. Examine the banknote to ensure that these elements are present and correctly positioned.","**Look for the following symptoms of poor quality:** Counterfeit **Bulgarian Lev** may be manufactured of inferior materials or have printing or other flaws. Poor quality can be identified by blurry or smeared printing, wrong colours, or rough or uneven edges.","**When compared to a real banknote:** Compare it to the banknote in question if you have a genuine **Bulgarian Lev**. Check for variations in size, texture, and printing quality."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Bulgarian Lev**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Bulgarian Lev to USD, INR to Bulgarian Lev** or **Bulgarian Lev to Euro**, you only need to follow the below-written steps:"}}},{id:70,internalName:"seo_currency_page_venezuelan-bolivar",type:"seo_currency_page_venezuelan-bolivar",data:{name:"Venezuelan Bolivar",code:"VED",country_code:"VE",travel_country:"Venezuela",keywords:"Bulgarian Lev,Bulgarian lev Currency, Bulgarian lev rate today, Bulgarian lev symbol,Bulgarian lev to indian rupee, Bulgarian lev to dollar, bulgarian lev to inr, bulgarian lev to aud, bulgarian lev to euro, bulgarian lev to pound, Bulgarian lev exchange rate, Bulgarian lev currency exchange, buy Bulgarian lev, sell Bulgarian lev, Bulgarian lev forex cards, live Bulgarian lev rate, Bulgarian lev price",about:{title_text:"The Currency of the Venezuela",desc:"Venezuela's currency is the **Venezuelan Bolivar**. It's abbreviated as VED and is split into 100 centimos. The **Venezuelan Bolivar symbol** is Bs.D. Simón Bolivar, one of the important commanders in the Spanish-American wars of independence and the founder of the Republic of Gran Colombia, which covered present-day Venezuela, Colombia, Panama, and Ecuador, inspired the Bolivar.\n\n &nbsp; \n\nPeople of indigenous and African descent, as well as the first woman to appear on a **Venezuelan Bolivar** banknote (Luisa Cáceres de Arismendi, who appears on the 20 Bolivar Fuerte note), are among the historical figures featured on Venezuelan Bolivar banknotes. She was a national heroine for standing by her husband, military officer Juan Bautista Arismendi, during Venezuela's independence struggle. The 10-bolivar Fuerte note depicts Guaicaipuro, an Indian chief who fought against European domination in the middle of the 16th century. Simón Bolivar, a soldier from the 19th century who led revolutions against Spanish control in South America, is depicted on the 100 Bolivar Fuerte note.\n\n &nbsp; \n\nThe value of the **Venezuelan Bolivar** has changed dramatically in recent years as a result of Venezuela's economic and political turmoil. The **Venezuelan Bolivar** has lost value versus other currencies because of excessive inflation. To try to stabilise the currency, the government has adopted many measures, including currency restrictions and the issuance of new banknotes and coins.\n\n &nbsp; \n\nThe Central Bank of Venezuela issues the **Venezuelan Bolivar** and the currency is only used for domestic transactions. The central bank is also responsible for issuing **Venezuelan Bolivar Forex cards** for tourists and businesses.\n\n &nbsp; \n\nThe **Venezuelan Bolivar exchange rate** against the major world currencies is presented below. These values represent the **Venezuelan Bolivar rate today.**\n\n &nbsp; \n\n &nbsp;1.  1 **Venezuelan Bolivar to INR:** `inr_exchange_rate` INR\n\n &nbsp;2.  1 **Venezuelan Bolivar to USD:** 0.061 USD\n\n &nbsp; \n\nAs is clear from the rates of conversions for **Venezuelan Bolivar to Indian rupee** and **Venezuelan Bolivar to Dollar**, the currency has a very low value, with the currency losing more and more value every day due to hyperinflation.\n\n &nbsp; \n\nYou can find the **live Venezuelan Bolivar rate** in the international forex market and exchanges with a simple Google search and be updated with the latest **Venezuelan Bolivar currency exchange**."},quick_facts:{facts:{Country_of_Origin:"Venezuela",Symbol:"The Venezuelan Bolivar symbol is Bs.D",Currency_Code:"VED",Nick_Names:"-",Minor_units:"Centimo","Denominations_(Banknotes)":"Bs. 5, Bs. 10, Bs. 20, Bs. 50, Bs. 100",Motto:"-",Identification_Feature:"To identify a genuine Venezuelan Bolivar currency banknote, you need to look for:\n\n &nbsp; \n\n &nbsp;1. Color Shifting ink\n\n &nbsp;2. Watermark\n\n &nbsp;3. Raised markings\n\n &nbsp;4. Micro text\n\n &nbsp;5. Fluorescent fibres",Issuing_Bank:"Banco Central de Venezuela (Central Bank of Venezuela)",In_Circulation_Since:"1 October 2021"}},history:{desc:'The **Venezuelan Bolivar** was introduced as the official currency of Venezuela in 1879, replacing the Venezuelan peso. It was initially pegged to the U.S. dollar at a rate of 1 **Venezuelan Bolivar** = 1 USD. However, the **Venezuelan Bolivar** has experienced significant devaluation over the years due to economic and political instability in the country.\n\n &nbsp; \n\nIn the early 21st century, the **Venezuelan Bolivar** underwent several rounds of redenomination, where the value of the currency was adjusted and new banknotes were introduced. The most recent redenomination occurred in 2018 when the Bolivar was redenominated at a rate of 1 **Venezuelan Bolivar** Soberano = 100,000 Venezuelan Bolivares Fuertes. The **Venezuelan Bolivar** Soberano has since lost value against other currencies due to high inflation and a shortage of foreign exchange in Venezuela.\n\n &nbsp; \n\nThe **Venezuelan Bolivar** is not a freely traded currency, and its exchange rate is controlled by the government of Venezuela. This has led to a black market for foreign exchange, where the **Venezuelan Bolivar** can be traded at a much higher rate than the official rate. The use of non-official exchange rates, known as "paralelo," is common in Venezuela and has contributed to the devaluation of the **Venezuelan Bolivar**.'},countries_accepting:{desc_1:"In most cases, the **Venezuelan Bolivar** cannot be used to make payments in other nations. Outside of Venezuela, the **Venezuelan Bolivar** is not commonly regarded or recognised as a currency, and it is not traded on foreign currency exchanges. As a result, merchants and financial institutions in other nations do not commonly accept it.\n\n &nbsp; \n\nWhether to **buy Venezuelan Bolivar** or **sell Venezuelan Bolivar**, you will most probably have to deal with government institutions, Banks, or financial institutions dealing in international currencies. The **Venezuelan Bolivar price** in the international forex market is very low and it is not considered a good currency to trade in.",list:[],desc_2:""},amount_for_trip:{desc:"The **Venezuelan Bolivar** is a highly volatile currency. As such, it is advised that when you visit Venezuela, carry US dollars which you can exchange for equivalent money or just use USD to pay for things. You can also carry the Colombian Peso."},identification:{list:["The original currency uses colour-shifting ink.","There is a watermark on the bank notes.","There are raised markings on the notes for the visually impaired.","The currency value can be seen on the note at certain angles on the borders.","The banknote contains micro-text.","The notes have a security thread.","They contain fluorescent fibres that glow in various colours."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Venezuelan Bolivar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Venezuelan Bolivar to USD, INR to Venezuelan Bolivar** or **Venezuelan Bolivar to Euro**, you only need to follow the below-written steps:"}}},{id:71,internalName:"seo_currency_page_belarusian-ruble",type:"seo_currency_page_belarusian-ruble",data:{name:"Belarusian Ruble",code:"BYN",country_code:"BY",travel_country:"Belarus",keywords:"Belarusian ruble,Belarusian ruble Currency, currency converter belarusian ruble, belarusian ruble country,Belarusian ruble to indian rupee, Belarusian ruble to dollar, belarusian ruble to inr, belarusian ruble to euro, belarusian ruble to russian ruble, Belarusian ruble exchange rate, Belarusian ruble currency exchange, buy Belarusian ruble, sell Belarusian ruble, Belarusian ruble forex cards, live Belarusian ruble rate, Belarusian ruble price",about:{title_text:"The Currency of the Belarus",desc:"*Belarusian ruble currency** is the official currency of the country of Belarus. An estimated 9 million people (approx.) use this currency. This makes the **Belarusian ruble currency** the 18th most popular currency in the world. All circulating **Belarusian ruble** notes have a representation of a national landmark on their front side. The front side of the 20 **Belarusian ruble** note features the Tower of Kamyenyets, also called the White Tower. The banknote of 500 rubles is the note of the largest denomination. The Belarusian currency is a closed currency system, which means one cannot get it outside the **Belarusian ruble country.** Forex trading is legal in Belarus. one can **buy Belarusian ruble** and **sell Belarusian ruble** through licensed brokers. The **Belarusian ruble price** for forex trading is available online."},quick_facts:{facts:{Country_of_Origin:"Belarus",Symbol:"Br",Currency_Code:"BYN",Nick_Names:"-",Minor_units:"Copeck","Denominations_(Banknotes)":"Bills: 10, 20, 50, 100, 200, 500,\n\nCoins: 5 cop, 10 cop, 20 cop, 50 cop, 1 rbls, 2 rbls",Motto:"Belarus is my country",Identification_Feature:"Security Thread",Issuing_Bank:"National Bank of the Republic of Belarus",In_Circulation_Since:"1992",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The country known as Belarus in the present time was once a part of the Soviet Union before the Russian Revolution. During the Russian Revolution, like many other countries within the Soviet Union, the country of Belarus tried to establish itself as an independent nation. After experiencing some initial hurdles and, more importantly, after the Soviet Union's collapse, it was able to establish itself as a sovereign nation. After its inception, however, it found itself in urgent need of banknotes but without the legal power to issue Soviet Union currency. Finally, in 1992, the country of Belarus introduced its own currency, the **Belarusian Ruble**. The banknotes introduced in 1992 had very few security features. During the early years, Belarus's economy was unstable and the inflation rate was very high. The **Belarusian ruble country** was forced to introduce notes of high denomination (20,000, 50,000, 100,000) during this period. The banknotes introduced in 1992 were in circulation till 2000. In 2000, the Belarusian government introduced new banknotes which were in circulation till 2016. In 2016, the government again introduced new notes at the rate of 1 BYN = 10,000 BYR."},countries_accepting:{desc_1:"As mentioned earlier, the **Belarusian ruble** is a closed currency so the **Belarusian ruble currency exchange** happens only within the country. Euros and dollars are easily exchanged at the **Belarusian ruble exchange rate.** Most international currencies can be exchanged in a similar manner. There are exchange offices all throughout the country for exchanging currency.\n\n &nbsp; \n\nAlmost all countries exchange **Belarusian rubles** at different exchange rates. Here’s a list below accounting for the **Belarusian ruble**’s exchange rate:\n\n &nbsp; \n\n**Currency Converter Belarusian Ruble**\n\n &nbsp; \n\n &nbsp;*   **Belarusian Ruble** **to Indian Rupee** - 1 **Belarusian Ruble** = `inr_exchange_rate` INR\n\n &nbsp;*   **Belarusian Ruble to Dollar** - 1 **Belarusian Ruble =** 0.40 USD\n\n &nbsp;*   **Belarusian Ruble** t**o Euro -** 1 **Belarusian Ruble** = 0.37 Euro\n\n &nbsp;*   **Belarusian Ruble to Russian Ruble** - **1 Belarusian Ruble** = 27.33 RUB.\n\n &nbsp; \n\nUsing the **currency converter Belarusian ruble** rate can be seen against any currency online.\n\n &nbsp; \n\nFor the most updated exchange rate, follow the **‘live Belarusian Ruble rate’** online.",list:[],desc_2:""},amount_for_trip:{desc:"What is a safe amount of money to carry for a trip to Belarus? The answer to this depends on various factors, including: What is the purpose of your trip? How long is your trip for? Are you on a tight budget or can you spend lavishly? Are you travelling alone or with your family?\n\n &nbsp; \n\nIf you are travelling alone, the expense per day would be around 90 USD per day (which is 227 BYN) if you plan to go on a budget trip. On the other hand, if you wish to spend exuberantly on your trip to Belarus, the cost for that would come around anywhere between 490 USD (1236 BYN) (for a mid-level budget) and 550 USD (1387 BYN) (for a luxury budget). As an estimate, a family of four should have a budget of 130 USD for a one-day stay in Belarus. One could carry **Belarusian ruble forex cards** or multi-currency forex cards for their trip to Belarus."},identification:{list:["**Security thread:** Security thread is a type of anti-counterfeiting feature used in most currencies around the world. The **Belarusian ruble,** too, uses this feature as a protection against counterfeit notes.","**Watermark:** Watermarking again is a universal method of protection against counterfeit products. Here a translucent image is produced which acts as an authentication feature. Every currency has its own unique watermark which helps in identifying its notes. The **Bulgarian ruble** too employs this technique to protect against counterfeit notes."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Belarusian Ruble**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Belarusian Ruble to USD, INR to Belarusian Ruble** or **Belarusian Ruble to Euro**, you only need to follow the below-written steps:"}}},{id:72,internalName:"seo_currency_page_tanzania-shilling",type:"seo_currency_page_tanzania-shilling",data:{name:"Tanzania Shilling",code:"TZS",country_code:"TZ",travel_country:"Tanzania",keywords:"Tanzanian shilling,Tanzanian shilling Currency, Tanzanian shilling rate, Tanzanian shilling symbol, shilling currency,Tanzanian shilling to indian rupee, Tanzanian shilling to dollar, tanzanian shilling to usd, Tanzanian shilling exchange rate, Tanzanian shilling currency exchange, buy Tanzanian shilling, sell Tanzanian shilling, Tanzanian shilling forex cards, live Tanzanian shilling rate, Tanzanian shilling price",about:{title_text:"The Currency of the United Republic of Tanzania",desc:"The **Tanzanian shilling** is the official currency of the Republic of Tanzania, which is located in Eastern Africa. It is a developing country, so the **Tanzanian shilling rate** is not that high. The **Tanzanian shilling** is a free-floating currency, where the **live Tanzanian shilling rate** or value is set up by the forex markets without any intervention from the government. Each **Tanzanian shilling** is worth 100 senti, or cents, in Swahili. The **Tanzanian shilling symbol** is often written or denoted in the ‘x/y’ form, where x is the number of shillings and y is the number of cents. Commonly, however, TSh is also quite frequently used.\n\n &nbsp; \n\nThe value of the **Tanzanian shilling to Indian rupee** is `inr_exchange_rate` INR, and the **Tanzanian shilling to Dollar** is $0.00043."},quick_facts:{facts:{Country_of_Origin:"United Republic of Tanzania",Symbol:"TSh",Currency_Code:"TZS",Nick_Names:"Shilling",Minor_units:"-","Denominations_(Banknotes)":"50, 100, 200, 500 shilingi coins and 500, 1000, 2000, 5000, 10,000 shilingi notes",Motto:"-",Identification_Feature:"Each note has pictures on both sides from Tanzania and are in different colours.",Issuing_Bank:"Bank of Tanzania",In_Circulation_Since:"2011",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The currency, which is currently known as the **Tanzanian shilling,** has come into circulation since 1966. The **shilling currency** substituted the East African shilling after Tanganyika and Zanzibar united and gained independence from the British, and the **Tanzanian shilling rate** has been low ever since. But before the **Tanzanian Shilling**, there were other currencies that circulated throughout the country. The two areas experienced various different types of colonial rule from different regions of Europe. The areas were used by them as a major source of food and resources. Like most other African colonies under British rule, the East African Rupee was also accepted in the two regions that now make up Tanzania. Initially, the **Tanzanian shilling** was circulated mainly in the form of coins with the denotations of 5, 10, 20 senti, and 1 shilling. Eventually, the values of the coins in the **Tanzanian Shilling currency** increased, and now coins of 50, 100, 200, and 500 shillings are available. The **Tanzanian shilling symbol** used is also quite unique. There also exist banknotes of 500, 1000, 2000, 5000, and 10000 along with coins in **shilling currency.**"},countries_accepting:{desc_1:"The **Tanzanian shilling** is recognized across the world but is used and accepted only in Tanzania. But tourist sites often accept US dollars. The current exchange rate for the **Tanzanian shilling to USD** is $0.00043.",list:[],desc_2:""},amount_for_trip:{desc:"Tanzania is a very popular tourist site in Africa for its numerous national parks. It can be quite cheap for most people from abroad to visit the country since the **Tanzanian shilling exchange rate** is quite low. The amount of **Tanzanian Shilling** one needs on a trip can be considered quite subjective since the amount spent in a day would depend a lot on the chosen type of accommodation, transport, food items, etc. However, on a budget trip, it is expected to spend an average of about TZS 200,000, which, turning from **Tanzanian shilling to dollar** is about $86 a day. Since the price varies, it will be safe to carry roughly $100 a day. While travelling, be careful of the **Tanzanian shilling symbol** since there are various versions that are used. Before visiting, always remember to check the current **Tanzanian shilling price.** If all this seems like a hassle to you, you can easily make **Tanzanian shilling forex cards** that make the process of **Tanzanian shilling currency exchange** a lot easier."},identification:{list:["The TZS500 note of the **Tanzanian shilling** is green in colour. On the front, there's a picture of Sheikh Abeid Amani Karume.","**Tanzanian Shilling's** 1000 note is blue in colour with a picture of President Julius Kambarage Nyere on the front.","The TZS2000 note is orange with a Lion on the front.","The TZS500 of the **Tanzanian Shilling** is purple with a Rhinoceros in the front.","The **Tanzanian shilling** note of 10,000 is red with an Elephant on the front."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Tanzanian Shilling**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Tanzanian Shilling to USD, INR to Tanzanian Shilling** or **Tanzanian Shilling to Euro**, you only need to follow the below-written steps:"}}},{id:73,internalName:"seo_currency_page_ghana-cedi",type:"seo_currency_page_ghana-cedi",data:{name:"Ghana Cedi",code:"GHS",country_code:"GH",travel_country:"Ghana",keywords:"Ghana cedi,cedi currency, Ghana cedi Currency, Ghana cedi symbol,Ghana cedi to rupee, Ghana cedi to dollar, ghana cedi to inr, ghana cedi to usd, ghana cedi to us dollar rate today, Ghana cedi exchange rate, Ghana cedi currency exchange, buy Ghana cedi, sell Ghana cedi, Ghana cedi forex cards, live Ghana cedi rate, Ghana cedi price",about:{title_text:"The Currency of the Ghana",desc:"The **Ghana Cedi** is the official currency and legal tender of the West African nation of Ghana. The **Ghana cedi** has been through multiple iterations over the years, with the current **Ghana cedi currency** being the third to bear the **Ghana Cedi symbol**, starting circulation in the year 2007. The **Ghana Cedi** followed decimalization can be subdivided into minor units called Pesewas, with each Pesewa representing 1/100 **Ghana Cedi.** The **Cedi currency** battled high inflation and, as such, has lost over 90% of its value since its circulation in the year 2007.\n\n &nbsp; \n\nThe current **Ghana Cedi** or the Third Cedi is managed and distributed by the Bank of Ghana and is available in banknotes of denominations GH₵1, GH₵2, GH₵5, GH₵10, GH₵20, GH₵50, GH₵100, GH₵200 and coins of denominations 1Gp, 5Gp, 10Gp, 20Gp, 50Gp, GH₵1, GH₵2. Despite high inflation and low exchange rates, the **Ghana cedi symbol** ranks high among other currencies in the region. The **Ghana Cedi** is an active participator in currency exchange with people that buy or **sell Ghana Cedi** on a regular basis.\n\n &nbsp; \n\n**Ghana Cedi to rupee** rate currently goes for `inr_exchange_rate`."},quick_facts:{facts:{Country_of_Origin:"Ghana",Symbol:"GH₵",Currency_Code:"GHS",Nick_Names:"Third Cedi",Minor_units:"Pesewas","Denominations_(Banknotes)":"GH₵1, GH₵2, GH₵5, GH₵10, GH₵20, GH₵50, GH₵100, GH₵200",Motto:"-",Identification_Feature:"All current Ghana Cedis have portraits of six distinguished Ghanaians who spearheaded Ghana’s struggle for independence.",Issuing_Bank:"Bank of Ghana",In_Circulation_Since:"2007"}},history:{desc:"The Cedi was first introduced in the year 1965 following Ghana’s adoption of the decimal system, abandoning its predecessor the Ghanaian Pound based on the British Monetary System. The word “Cedi” comes from the native word for cowry shells, which were often used as currency by Arab traders in the older days of Ghana.\n\n &nbsp; \n\nThe **Ghana Cedi** has been subjected to frequent changes over the decades due to reasons ranging from changes in the political system to a drop-in **Ghana cedi exchange rate** caused by high inflation. Following its independence from the British in 1957, Ghana has changed its currency four times over, three of them being the Cedi, with the modern **Ghana Cedi** becoming legal tender in the year 2007."},countries_accepting:{desc_1:"The **Cedi currency** is the official currency of Ghana and is used as the legal tender in the West African country of Ghana. Due to high inflation and dynamic exchange rates, the **Ghana cedi price** is frequently subjected to change, and as such, the **Ghana Cedi to US dollar rate today** is marginally low compared to **Ghana Cedi to USD** rates in the early 2010s. No other country apart from Ghana uses the **Ghana Cedi** as legal tender.",list:[],desc_2:""},amount_for_trip:{desc:"A lot of factors determine the amount of **Ghana Cedi** you should carry on your trip to Ghana. While the country is cheaper compared to European and American countries, your references for accommodation, food, and travel can drastically impact your spending. It is recommended to carry **Ghana Cedi forex cards** along with local **Cedi currency**.\n\n &nbsp; \n\nReasonable accommodation with food and transport should be covered within GH₵ 300 a day, while a high-end experience at luxury inns and diners can cost as much as GH₵ 900. On the contrary, a well-planned budget can have you spending as low as GH₵ 100 a day. The **Ghana Cedi** is subject to high inflation, so it is always recommended that you stay aware of the **Live Ghana Cedi rate** before you **buy Ghana Cedi** at a **Ghana Cedi currency exchange**.\n\n &nbsp; \n\nThe current **Ghana cedi to INR** rate is around 9.17, while the **Ghana cedi to dollar** rate is around 0.11."},identification:{list:["All **Ghana Cedi** in circulation has a metallic security strip running through the middle of the note that appears broken in parts. Holding the note in sunlight or any other form of direct light reveals the strip to be unbroken. Any **Cedi currency** without this feature is not considered legal tender.","On the left side of the metallic strip inside the star there is a watermark, which when held towards direct light reveals a picture of “Tetteh Quarshie”, the first man to bring cocoa to Ghana. There is also a picture of a Cocoa pod along with a white circle with the denomination of the note partially visible (fully visible when viewed in direct sunlight).","The centre of the note has an Independence Insignia with the words “Freedom and Justice” and “AD 1957” inscribed on it.","The backside of every **Ghana Cedi** note has a picture of a monument or institution that contributed to the growth of Ghana.","All current **Ghana Cedi** banknotes have portraits of six distinguished Ghanaians who led to the Independence of Ghana."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Ghana Cedi**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Ghana Cedi to USD, INR to Ghana Cedi** or **Ghana Cedi to Euro**, you only need to follow the below-written steps:"}}},{id:74,internalName:"seo_currency_page_uruguayan-peso",type:"seo_currency_page_uruguayan-peso",data:{name:"Uruguayan Peso",code:"UYU",country_code:"UY",travel_country:"Uruguay",keywords:"Uruguayan peso,Uruguayan peso symbol,uruguayan peso to inr, uruguayan peso to dollar, Uruguayan peso exchange rate, Uruguayan peso currency exchange, buy Uruguayan peso, sell Uruguayan peso, Uruguayan peso forex cards, live Uruguayan peso rate, Uruguayan peso price",about:{title_text:"The Currency of the Uruguay",desc:"The **Uruguayan Peso** is the currency of Uruguay and legal tender in the South American country of Uruguay. The **Uruguayan peso symbol** is $U with the Centésimo being a minor unit. The Peso has been a standard currency in the region since colonial times and underwent several iterations over the years, with the current **Uruguayan Peso** starting circulation in the year 1993.\n\n &nbsp; \n\nWhen it comes to the act of buy and **sell** **Uruguayan Peso** is used in most cases involving regular commodities, for high ticket transactions like “Real Estate”, however, the USD is preferred over the **Uruguayan Peso** owing to the Peso’s high inflation and faltering currency rate (the **Uruguayan Peso to dollar** is around 0.026)."},quick_facts:{facts:{Country_of_Origin:"Uruguay",Symbol:"$ or $U",Currency_Code:"UYU",Nick_Names:"-",Minor_units:"Centésimo","Denominations_(Banknotes)":"$20, $50, $100, $200, $500, $1000, $2000",Motto:"-",Identification_Feature:"All current Uruguayan Peso notes should have “Banco Central Del Uruguay” inscribed on the front and back.",Issuing_Bank:"Central Bank of Uruguay",In_Circulation_Since:"1993"}},history:{desc:"The Peso has been a common currency for Uruguay ever since the first European settlers arrived in the country. The country has been under the influence of many foreign powers over its brief colonial history. While the Spanish Peso remained the standard currency through most of its colonial history, at times currencies from other European colonies like Brazil and Argentina also circulated during its annexation and struggle over the region.\n\n &nbsp; \n\nFollowing its independence in 1828, the first Uruguayan Pesos were minted, known as “Silver Pesos” whose value was equivalent to that of 8 Reales. The first paper Pesos however did not appear until much later in 1857.\n\n &nbsp; \n\nThrough most of the 20th century following the world wars, the Uruguayan economy had struggled to maintain a stable currency value as the **Uruguayan Peso** **price** was subjected to frequent falls and devaluation. The **Uruguayan Peso symbol** went through multiple changes and iterations over the years, with the current **Uruguayan Peso** starting circulation in the year 1993."},countries_accepting:{desc_1:"The **Uruguayan Peso** is the national currency and legal tender of the South American country of Uruguay. The **Uruguayan** **peso** is issued by the Central Bank of Uruguay for use inside the country of Uruguay and as such no other countries accept **Uruguayan Peso.**",list:[],desc_2:""},amount_for_trip:{desc:"The amount required to comfortably get by on your trip to Uruguay depends on several factors, ranging from accommodations to transportation. The cost of living is generally quite low in Uruguay as compared to some other American and European countries, with 2.14 being the current **Uruguayan Peso to INR** rate. A modest stay on a strict budget with public transport can cost as little as 1000 **Uruguayan Peso** per day, while a moderate stay with complimentary transport and dining can easily go up to $U 2400 per day. If you fancy the top shelf and luxury, then your daily cost can go upwards of $U 5000 per day. Carrying **Uruguayan Peso forex cards** is a great way to ensure a smooth stay in the country.\n\n &nbsp; \n\nThe economy of Uruguay has been subjected to high inflation. Although much more stable over the recent decades, the **Uruguayan Peso exchange rate** is subject to frequent changes. As such, you should monitor the **live Uruguayan Peso rate** before you **buy Uruguayan Peso** at the **Uruguayan Peso currency exchange.**"},identification:{list:["All **Uruguayan Peso** banknotes will have a security metallic strip running roughly through the middle of the note. The strip would appear broken at regular intervals when viewed in low lighting conditions, holding the note in sunlight or some other direct source of light will show the strip to be unbroken and whole, this is a security feature of the **Uruguayan Peso.**","The real **Uruguayan Peso** notes would have a watermark on the right side of the note just below the number showing the denomination of the note. The watermark will be visible when the note is held in sunlight or other direct sources of light.","The **Uruguayan Peso** has portraits of famous and distinguished Uruguayans who helped build the country in its recent history.","The back side of the note should have an inscription saying, “Banco Central Del Uruguay”, which translates to “Central Bank of Uruguay”.","The front sides of the notes should have the signatures of “Secretaria general” and “Presidente”.","Every **Uruguayan Peso** note comes with a serial number that’s unique to that single note only."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Uruguayan Peso**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Uruguayan Peso to USD, INR to Uruguayan Peso** or **Uruguayan Peso to Euro**, you only need to follow the below-written steps:"}}},{id:75,internalName:"seo_currency_page_azerbaijani-manat",type:"seo_currency_page_azerbaijani-manat",data:{name:"Azerbaijani Manat",code:"AZN",country_code:"AZ",travel_country:"Azerbaijan",keywords:"Azerbaijani manat,Azerbaijani manat Currency, azerbaijani manat country,Azerbaijani manat to indian rupee, azerbaijani manat to inr, 1 azerbaijani manat to pkr, Azerbaijani manat exchange rate, Azerbaijani manat currency exchange, buy Azerbaijani manat, sell Azerbaijani manat, Azerbaijani manat forex cards, live Azerbaijani manat rate, Azerbaijani manat price",about:{title_text:"The Currency of the Azerbaijan",desc:"**Azerbaijani Manat** is the currency of Azerbaijan. Between 1919 and 1923 is when the **Azerbaijani Manat** is thought to have been introduced. During this time period, specifically in 1918, the Transcaucasian Commissariat introduced the ruble, which is what we now refer to. Manat replaced it concurrently until the Ruble was officially proclaimed the national currency in 1924.\n\n &nbsp; \n\nThe Soviet ruble was replaced by the manat when Azerbaijan declared its independence from the Soviet Union. The **Azerbaijani Manat** experienced rapid inflation in its early years, making the coinage outdated at that time.\n\n &nbsp; \n\n**Azerbaijani Manat**, the most recent currency in use since February 2005, replaced Azeri money when Azerbaijan gained independence in 1992. Three Manats have been released so far. The new **Azerbaijani Manat** is the money of today. The most recent **Azerbaijani Manat** was unveiled in 2006. Redesigned notes of the denominations ₼1, ₼5, and ₼50 came in 2021, having the same motifs but with different designs. A new commemorative ₼500 banknotes were introduced in 2021.\n\n &nbsp; \n\nThe **live Azerbaijani Manat rate** rises and falls with time in accordance with its strength compared to other currencies in circulation, especially with regard to the dollar with which it is pegged. The current **Azerbaijani Manat price,** as of writing is 0.59 INR. The **Azerbaijani Manat to Indian rupee** current rate is `inr_exchange_rate` INR."},quick_facts:{facts:{Country_of_Origin:"Azerbaijan",Symbol:"₼",Currency_Code:"AZN (numeric: 944)",Nick_Names:"-",Minor_units:"Gapik","Denominations_(Banknotes)":"₼1, ₼5, ₼10, ₼20, ₼50, ₼100, ₼200, ₼500",Motto:"-",Identification_Feature:"The front of the banknote features a magical number (from green to dark red), specific exact lines, a raised nominal, elements visible at UV light, and a hidden nominal number (watermark).",Issuing_Bank:"Central Bank of Azerbaijan",In_Circulation_Since:"1919-1923 (First iterations)"}},history:{desc:"In 1919, Azerbaijan began issuing its own money. The new Azerbaijan Democratic Republic made an effort to offer its national currency to the international market; the biggest value, 500 manats, was inscribed in French.\n\n &nbsp; \n\nThe next time money was printed, it had the name Azerbaijan Soviet Socialist Republic. However, in 1923, Azerbaijan joined the Transcaucasian Soviet Federal Socialist Republic, and Moscow took over control of the country's banking system. Azerbaijan joined the Soviet Union in 1936, and the ruble replaced all other currencies, as stated in the USSR Constitution.\n\n &nbsp; \n\nAs soon as Azerbaijan regained its independence, a new chapter in the history of currency circulation in the nation began.\n\n &nbsp; \n\nOn July 15, 1992, the President of the Republic of Azerbaijan issued a decree establishing the national currency.\n\n &nbsp; \n\nThe first national currency, the **Azerbaijani Manat,** entered use on August 15, 1992, and President Heydar Aliev declared it the only legal tender authorised for use in the entire nation as of January 1, 1994.\n\n &nbsp; \n\nCurrently, Azerbaijan is issuing banknotes in the following denominations: 1, 5, 10, 20, 50, and 100.\n\n &nbsp; \n\n100 qapiks are equal to one **Azerbaijani Manat**. Metal coins are available in the following values: 1, 3, 5, 10, 20, and 50 qapiks. With the help of the National Bank of Switzerland, technical specifications for a new generation of banknotes were produced. The new generation of banknotes includes a four-pillar protection scheme, with Level I established by the general public without the use of any special tools."},countries_accepting:{desc_1:"The **Azerbaijani Manat** is accepted only in Azerbaijan. Alternatively, you may **buy Azerbaijani Manat** as a souvenir. The **Azerbaijani Manat country** is thus limited only to the host country itself.\n\n &nbsp; \n\nCountries like Pakistan have a warm relationship with Azerbaijan, and the exchange rate of **1 Azerbaijani Manat to PKR** currently stands at 132.65 PKR.",list:[],desc_2:""},amount_for_trip:{desc:"**Azerbaijani manat exchange rate** varies with the global market, and you can buy or **sell Azerbaijani Manat** accordingly.\n\n &nbsp; \n\nYou may do **Azerbaijani Manat currency exchange** at the nation’s exchange terminal in accordance with the current exchange values. Most of the country is cash-dependent, but you may find major cities accepting **Azerbaijani manat forex cards.**\n\n &nbsp; \n\nDepending on your choices, Azerbaijani hotels range from 23 AZN for cheap hotels to 334 AZN for luxury hotels per night. So, for a week-long trip, you would ideally need to carry 600-1000 AZN.\n\n &nbsp; \n\nFood prices range from 16 to 30 AZN per day, so you can calculate accordingly for the same. Alcohol prices range from 30 to 200 AZN per bottle.\n\n &nbsp; \n\nThus, you can adjust the amount that you carry in **Azerbaijani Manat** for your trip**.** The **Azerbaijani Manat country** has plenty to offer, and you should plan your trip accordingly."},identification:{list:["The hidden nominal number","The watermark visible at light",'The word "MANAT" visible against the light',"The number changing from the green colour to dark red","Raised numbers","elements visible under the UV light","A metal thread and UV components can be seen on the reverse side of the note"]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Azerbaijani Manat**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Azerbaijani Manat to USD, INR to Azerbaijani Manat** or **Azerbaijani Manat to Euro**, you only need to follow the below-written steps:"}}},{id:76,internalName:"seo_currency_page_croatian-kuna",type:"seo_currency_page_croatian-kuna",data:{name:"Croatian Kuna",code:"HRK",country_code:"HR",travel_country:"Croatia",keywords:"Croatian kuna,Croatian kuna Currency, Croatian kuna rate, Croatian kuna symbol,Croatian kuna to indian rupee, Croatian kuna to dollar, croatian kuna to inr, croatian kuna to nzd, croatian kuna to sterling, croatian kuna to cad, Croatian kuna exchange rate, Croatian kuna currency exchange, buy Croatian kuna, sell Croatian kuna, Croatian kuna forex cards, live Croatian kuna rate, Croatian kuna price",about:{title_text:"The Currency of the Croatia",desc:'Croatia\'s currency, the **Croatian Kuna**, has been in use since 1994. (sign: kn; code: HRK). Each **Croatian Kuna** is divided into 100 lipa. The Croatian National Bank issues the **Croatian Kuna**, and the Croatian Mint produces the coins. The word "kuna" in Croatian can be used as "kuna" or "kune" if you want to write in plural. The **Croatian Kuna** will cease to exist in 2022 as Croatia will switch to the euro (€, EUR) on January 1, 2023. The current **Croatian Kuna price** is 0.13 Euros. Cash in **Croatian Kuna** may be exchanged for euros at no cost, and all Croatian bank accounts and credit cards will be instantly converted to euros.\n\n &nbsp; \n\nThe **Croatian Kuna symbol** is KN on an international basis. The **Croatian Kuna to Indian Rupee** currently stands at `inr_exchange_rate` INR.'},quick_facts:{facts:{Country_of_Origin:"Croatia",Symbol:"KN",Currency_Code:"HRK (numeric: 191)",Nick_Names:"-",Minor_units:"Lipa","Denominations_(Banknotes)":"5, 10, 20, 50, 100, 200, 500, 1000",Motto:"-",Identification_Feature:"The fronts all depict well-known Coatians, while the backs contain various architectural motifs. On all notes save the 5 kuna note, the geometric figures written in the lower left corner of the front are intaglio printed so that the visually impaired can easily identify them. Lijepa naa domovino, the Croatian national song, is microprinted to the right of the coat of arms on the front (Our Beautiful Homeland). The overall look is similar to the fourth series of German Mark banknotes",Issuing_Bank:"Croatian National Bank",In_Circulation_Since:"30 May 1994",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:'The word "kuna" stands for "marten”. Taxes were paid in the then-highly prized marten skins in the Roman provinces of upper and lower Pannonia (modern-day Hungary and Slavonia). Deriving from the Medieval Latin word for "marten," martus, which comes from Proto-Germanic *maruz, the Croatian word marturina ("tax") was thus created. Up until the early 15th century, various Slavic nations, most notably Kievan Rus and its successors, used the **Croatian Kuna** as their primary unit of money. 1/25 (and later 1/50) gryvnas of silver were equivalent to it. In Croatian, kune is the plural of the **Croatian Kuna**.\n\n &nbsp; \n\nThe concept of Kuna vanished during the Middle Ages. When Banovina of Croatia, an autonomous region founded inside the Kingdom of Yugoslavia, attempted to issue its own currency in addition to the Yugoslav dinar in 1939, the concept of a kuna currency was revived. The Independent State of **Croatian Kuna** was created by the Ustae government in 1941 when they founded the country. This money was in use until 1945, when the foundation of FPR Yugoslavia led to its replacement by the Yugoslav dinar, along with competing issuance by the communist Partisans. It was again replaced by the current **Croatian Kuna currency** in 1994.\n\n &nbsp; \n\n**Croatian Kuna to dollar** currently stands at 0.14 USD. **Croatian Kuna to NZD** is currently 0.22 NZD.\n\n &nbsp; \n\nOn the other hand, **Croatian Kuna to Sterling** currently is 0.12 Pound Sterling, Great Britain’s currency. **Croatian kuna to CAD** is now at 0.19 CAD.'},countries_accepting:{desc_1:"The **Croatian Kuna currency** is accepted only in Croatia. You may also **buy Croatian Kuna** as a souvenir for your trip. Also, as it is due to be changed to Euro as the official currency, it will be a collector’s item pretty soon, and you may be able to **sell Croatian Kuna** at an inflated rate in the future.",list:[],desc_2:""},amount_for_trip:{desc:"Depending on your expectations, a single traveller to Croatia will pay anywhere from 32 USD (224 **Croatian Kuna**) for a hostel to 355 USD (2,500 **Croatian Kuna**) for an overnight stay at a five-star hotel.\n\n &nbsp; \n\nIf you want to spend a week in Croatia, the cost of your stay will be close to 850-1000 **Croatian Kuna** for your trip.\n\n &nbsp; \n\nFuel prices are very expensive in Croatia, and thus you are advised to use public transport for exploration. A family travelling with two kids needs 380 USD for one day in Croatia.\n\n &nbsp; \n\nThe simplest method to experience local specialities when visiting Croatia is to place an order at a restaurant there. In a middle-class restaurant, a two-person supper typically costs USD 35 (250 **Croatian Kuna**). In Croatia, there are many different hotels and hostels. Accommodations are just as vital as food. In Croatia, hotel rates are based on quality. The average hotel fee is 32 USD (224 **Croatian Kuna**). The cost of a 3-star hotel is 86 USD (608 **Croatian Kuna**).\n\n &nbsp; \n\nIn all, you should keep an eye on the **live Croatian kuna rate** for its currency exchange rates. If you want to use credit cards, make sure to use **Croatian kuna forex cards.**\n\n &nbsp; \n\nThe current **Croatian kuna exchange rate** depends on its strength against pegged currencies like Euro or Dollar. You can do the **Croatian Kuna currency exchange** at the Croatian Exchange office or embassy. The **Croatian Kuna rate** may vary according to the time. The **Croatian Kuna Rate** compared to the dollar is now at 0.14 USD."},identification:{list:["FEEL - the paper and print quality of the banknotes (mechanical qualities of the paper, intaglio print). Cotton paper is a lot more durable and wear-resistant than industrial cellulose paper.","LOOK - Examine the banknote by holding it up to the light and looking at the watermark, security thread, and transparent register.","TILT - the banknote to view the elements printed in iridescent ink and the shifting image in the hologram/kinegram.","CHECK - Authentication devices carry out comprehensive checks of all security aspects (UV lamp, magnifier, IR camera, etc.)."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Croatian Kuna**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Croatian Kuna to USD, INR to Croatian Kuna** or **Croatian Kuna to Euro**, you only need to follow the below-written steps:"}}},{id:77,internalName:"seo_currency_page_costa-rican-colon",type:"seo_currency_page_costa-rican-colon",data:{name:"Costa Rican Colón",code:"CRC",country_code:"CR",travel_country:"Costa Rica",keywords:"Costa Rican Colón,Costa Rican colon Currency, Costa Rican colon symbol,Costa Rican colon to dollar, costa rican colon to euro, 1 costa rican colon to usd, Costa Rican colon exchange rate, Costa Rican colon currency exchange, buy Costa Rican colon, sell Costa Rican colon, Costa Rican colon forex cards, live Costa Rican colon rate, Costa Rican colon price",about:{title_text:"The Currency of the Costa Rica",desc:"The currency used in Costa Rica is the colon (plural: colones; **Costa Rican Colón symbol**: ₡; code: CRC). It was given the name Cristóbal Colón in honour of Christopher Columbus. There are one hundred céntimos in a **Costa Rican Colón**."},quick_facts:{facts:{Country_of_Origin:"Costa Rica",Symbol:"₡",Currency_Code:"CRC (numeric: 188)",Nick_Names:"peso",Minor_units:"céntimo (out of circulation)","Denominations_(Banknotes)":"1,000, 2,000, 5,000, 10,000, 20,000 colones",Motto:"-",Identification_Feature:"The Costa Rica map pictured on the changes in colour. When you turn the bill and let the light glint off it, the map changes from purple to green.",Issuing_Bank:"Central Bank of Costa Rica",In_Circulation_Since:"1897 (First iteration)"}},history:{desc:"A little more than 70 years after Costa Rica and its Central American neighbours proclaimed their independence from Spain, the **Costa Rican Colón** was accepted as the country's official currency. With a 1:1 exchange rate, the **Costa Rican Colón** took the place of the Costa Rican peso. Eight Spanish reales were equal to one peso in the former currency, a holdover from the colonial era.\n\n &nbsp; \n\nThe **Costa Rican Colón** and peso coexisted for a while after being introduced at par value. Initially, silver 50 centimos and gold coins with denominations ranging from two to twenty **Costa Rican Colón** were produced. At the time, one centimo was equivalent to one **Costa Rican Colón** and one peso. The national government's initials, \"G.C.R,\" were inscribed on these coins. In the early half of the 20th century, a number of banks issued **Costa Rican Colón**, but since 1951, the Central Bank of Costa Rica has been the sole producer of them. From 2006 to 2015, the **Costa Rican Colón Currency** was crawlingly pegged to the US dollar; however, it has been floating since that time.\n\n &nbsp; \n\nThe **Costa Rican Colón to euro** is currently at 0.0016 euro. **1 Costa Rican Colón to USD** is 0.0017 USD after it was changed to floating currency."},countries_accepting:{desc_1:"**Costa Rican Colón** is accepted only in Costa Rica. Similarly, US Dollars are accepted in the country. **Costa Rican Colón to dollar** is currently at 0.0017 USD.",list:[],desc_2:""},amount_for_trip:{desc:"The suggested daily budget is between 30,000 and 35,000 **Costa Rican Colón** for budget saving. With this amount, you can travel around using public transit, stay in a hostel, make the majority of your meals, eat some inexpensive street cuisine, and take part in basically free activities like climbing and going to the beach. Although you won't be able to go on any lengthy excursions, you can take in as much unrestricted nature as you like.\n\n &nbsp; \n\nExpect to spend closer to 65,000 **Costa Rican Colón** per day if you wish to stay in finer accommodations, partake in more drinks and dining out, and participate in some expensive activities like ziplining or surfing lessons.\n\n &nbsp; \n\nA luxury stay will cost in the region of 140,000 **Costa Rican Colón** per day.\n\n &nbsp; \n\nIf you are a couple with 1 child, expect to pay 500,000 **Costa Rican Colón** for a comfortable stay with all the fun activities.\n\n &nbsp; \n\nYou should keep an eye on the **live Costa Rican Colón rate** for its currency exchange rates. Want to use credit cards on your trip? Then make sure to use **Costa Rican Colón forex cards.**\n\n &nbsp; \n\nThe current **Costa Rican Colón exchange rate** depends on its strength against pegged currencies like Euro or Dollar. You can do the **Costa Rican Colón currency exchange** at public banks including Banco de Costa Rica and Banco Nacional, or at the country’s private banks, although the public banks are known to have a better exchange rate. You can **buy Costa Rican Colón** at the airport or exchange it for all your needs. Similarly, you can also **sell** **Costa Rican Colón** that you no longer need or change it to your own currency there.\n\n &nbsp; \n\nThe **Costa Rican Colón rate** varies with international economies, as is with other currencies. The **Costa Rican Colón price** right now is `inr_exchange_rate` INR, for the convenience of Indian travellers."},identification:{list:["Most **Costa Rican Colón** notes have a prominent personality image and an animal’s picture on the backside.",'Due to its colour, the previous 500 colones note was known as "morado" (purple), however, it is no longer in use.','Due to its colour, the 1,000 colones note is referred to as "un rojo" (one red). This also holds true for sums that are multiples of a thousand colones (for instance, 20,000 colones equals veinte rojos).','The name "tucán" (toucan), which refers to the toucan image it originally featured, is given to the five thousand colones note (it now features a monkey). It can alternatively be referred to as "una libra," which means "one pound," though this term is no longer frequently used.','Due to the puma shown on one of its faces, the 10,000 colones note is also known as "un puma."']},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Costa Rican Colón**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Costa Rican Colón to USD, INR to Costa Rican Colón** or **Costa Rican Colón to Euro**, you only need to follow the below-written steps:"}}},{id:78,internalName:"seo_currency_page_serbian-dinar",type:"seo_currency_page_serbian-dinar",data:{name:"Serbian Dinar",code:"RSD",country_code:"RS",travel_country:"Serbia",keywords:"Serbian dinar,Serbian dinar Currency, Serbian dinar rate, Serbian dinar symbol,Serbian dinar to dollar, serbian dinar to inr, serbian dinar to euro, serbian dinar to sek, 1 serbian dinar to usd, Serbian dinar exchange rate, Serbian dinar currency exchange, buy Serbian dinar, sell Serbian dinar, Serbian dinar forex cards, live Serbian dinar rate, Serbian dinar price",about:{title_text:"The Currency of Serbia",desc:"The **Serbian Dinar currency** is the official currency and legal tender of the Republic of Serbia since the year 2003. Issued and maintained by the National bank of Serbia, the **Serbian Dinar exchange rate** has been relatively stable over the years with the **Serbian dinar price** not changing much compared to similar currencies. Serbia, not being a member of the European Union, does not use the euro and as such **Serbian Dinar to Euro** is about 0.0085, while **Serbian Dinar to SEK** is about 0.095. You can **sell Serbian Dinar** at a **Serbian Dinar to INR** rate of around `inr_exchange_rate`."},quick_facts:{facts:{Country_of_Origin:"Republic of Serbia",Symbol:"DIN / дин",Currency_Code:"RSD",Nick_Names:"Post-Yugoslavia Dinar",Minor_units:"Para","Denominations_(Banknotes)":"DIN 10, DIN 20, DIN 50, DIN 100, DIN 200, DIN 500, DIN 1,000, DIN 2,000, DIN 5,000 (Rarely Used)",Motto:"-",Identification_Feature:"All current banknotes issued by the Republic of Serbia have portraits of renowned and notable Serbians on them.",Issuing_Bank:"National Bank of Serbia",In_Circulation_Since:"2003"}},history:{desc:"The **Serbian Dinar currency** has a long and complex history tracing back to the Middle Ages, with the first mentions of the **Serbian Dinar** dating back to the year 1214 AD. The first modern **Serbian dinar,** however, did not appear until 1868, following the withdrawal of Ottoman troops from the region in 1867. The **Serbian Dinar symbol** did not come to be until the 20th century.\n\n &nbsp; \n\nThe **Serbian Dinar symbol,** however, was briefly replaced by the Yugoslavian Dinar and Yugoslavian Krone in 1920 before being replaced by the **Serbian Dinar** again in 1941 German Occupied Serbia at a Reichsmark to **Serbian Dinar rate** of 250. The current **Serbian Dinar** also known as the post-Yugoslavia Dinar came into circulation in the year 2003. Currently, the **Serbian Dinar to dollar** rate is around 0.0091."},countries_accepting:{desc_1:"The **Serbian Dinar** is only used as legal tender in the Republic of Serbia. The disputed state of Kosovo maintains an autonomous status and does not use the **Serbian Dinar.**",list:[],desc_2:""},amount_for_trip:{desc:"Determining the ideal amount of **Serbian Dinar** that you should carry for your trip to the country depends heavily on several factors, with accommodation, food, transportation, and planned activities being the most prominent ones. The Republic of Serbia is relatively cheaper compared to other European countries. Finding **Serbian Dinar Forex cards** can be hard as most travel cards don’t operate in Serbia.\n\n &nbsp; \n\nA moderately adjusted trip avoiding luxury hotels costs anywhere from 3,300-5,500 RSD a day in Serbia; however, an experience with luxury dining, extravagant accommodation, and similar amenities can easily cost upwards of 12,000 RSD. A well-planned trip with certain adjustments can cost less than 2000 RSD, and with **1 Serbian Dinar to USD** being currently valued at 0.0091, this comes to less than 20 USD.\n\n &nbsp; \n\nEven though the **Serbian Dinar rate** is quite stable, it is still recommended that you check the **live Serbian Dinar rate** before you **buy Serbian Dinar** at a **Serbian Dinar currency exchange.**"},identification:{list:["The top left corner of the front side of **Serbian Dinar** banknotes has a tactile block that is sensitive to touch. Apart from just providing aid for the Visually impaired this also acts as an anti-forgery measure.","Throughout the note there are various sections that have “micro texts” that are not visible to the naked eye but with the right optical instruments, they can be magnified enough to read.","Real **Serbian Dinar** notes have portraits of renowned and notable Serbians/People of Serbian descent.","At the bottom of the **Serbian Dinar** banknotes, around the middle, there is a “Kinegram” showing the denomination of the note.","**Serbian Dinar** banknotes have a watermark on the left side that can be checked by exposing the note to sunlight or any direct source of light.","The notes are made of “Toned Paper” and the various fibres of the paper are clearly visible.","The serial numbering on the backside of banknotes glows/changes colour when observed under UV light.","On the backside a security metallic tape runs through the middle of the note, appearing broken but is seen as unbroken when viewed under sunlight or any other direct source of light. The metallic tape also has “micro texts” running along its length."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Serbian Dinar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Serbian Dinar to USD, INR to Serbian Dinar** or **Serbian Dinar to Euro**, you only need to follow the below-written steps:"}}},{id:79,internalName:"seo_currency_page_ugandan-shilling",type:"seo_currency_page_ugandan-shilling",data:{name:"Ugandan Shilling",code:"UGX",country_code:"UG",travel_country:"Uganda",keywords:"Ugandan shilling,Ugandan shilling rate, Ugandan shilling symbol,Ugandan shilling to rupee, Ugandan shilling to dollar, ugandan shilling to inr, ugandan shilling to euro, ugandan shilling to pkr, Ugandan shilling exchange rate, Ugandan shilling currency exchange, buy Ugandan shilling, sell Ugandan shilling, Ugandan shilling forex cards, live Ugandan shilling rate, Ugandan shilling price",about:{title_text:"The Currency of Uganda",desc:"The **Ugandan Shilling** is the official currency and legal tender of the West African nation of Uganda. Formerly, the **Ugandan Shilling** had a subunit called the cent. High inflation and drops in the **Ugandan Shilling rate** caused Shilling to be the smallest in use unit. All banknotes and coins bearing the **Ugandan shilling symbol** are managed and circulated by the Bank of Uganda. Ever since 2013, **Ugandan Shilling** notes have been printed in denominations of 1,000, 2,000, 5,000, 10,000, 20,000, and 50,000.\n\n &nbsp; \n\nAlthough the **Ugandan Shilling** is widely accepted in Uganda, unofficial currencies like the USD and Euro are also used in the country. The current **Ugandan Shilling to dollar** rate is 0.00027, while the **Ugandan Shilling** **to Euro** rate is 0.00026.\n\n &nbsp; \n\nCurrently, you can **sell Ugandan Shilling** at the **Ugandan Shilling to Rupee** rate of around `inr_exchange_rate`."},quick_facts:{facts:{Country_of_Origin:"Uganda",Symbol:"Sh",Currency_Code:"UGX",Nick_Names:"Second Shilling",Minor_units:"Cents (till 2013)","Denominations_(Banknotes)":"UGX 1,000, UGX 2,000, UGX 5,000, UGX 10,000, UGX 20,000, UGX 50,000",Motto:"-",Identification_Feature:"All current Ugandan Shilling banknotes have “Bank of Uganda” inscribed on them.",Issuing_Bank:"Bank of Uganda",In_Circulation_Since:"1987",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Like most African currencies the **Ugandan shilling symbol** traces back its origin to the 20th century. The **Ugandan Shilling** began circulation in 1966 replacing the former East African Shilling, following Uganda’s independence from Great Britain in 1962.\n\n &nbsp; \n\nThe **Ugandan Shilling rate** was initially pegged to the British pound, but the exchange rate was later adjusted to reflect market forces. The current **Ugandan Shilling to INR** rate is around 0.023, while the **Ugandan Shilling exchange rate** for **Ugandan Shilling to PKR** is around 0.062. The steady drop in the **Ugandan Shilling price** over the years can be attributed to its high inflation and various embezzlement charges faced by the country.\n\n &nbsp; \n\nIn 1987, the Bank of Uganda introduced new **Ugandan Shilling** notes and coins to replace the old currency, which had become worn and difficult to use. In 2013, the central bank had to re-introduce new **Ugandan Shilling** notes and coins removing the sub-unit cents after severe inflation and devaluation featuring enhanced security features to help deter counterfeiting."},countries_accepting:{desc_1:"The **Ugandan Shilling** is used as legal tender and official currency only in the West African country of Uganda. While the currency has been relatively stable in recent years, no other country uses it as a legal tender.",list:[],desc_2:""},amount_for_trip:{desc:"Stocking up on **Ugandan Shilling** banknotes on your trip to Uganda is a good idea, as Uganda, for the most part, is a cash-based economy and credit cards are not widely accepted. However, the amount of **Ugandan Shilling** you should carry will vastly depend on your individual needs, travel, and food preferences as well as activities.\n\n &nbsp; \n\nA moderately expensive trip to Uganda with food, accommodation and transport factored in, comes up to around 180,000 UGX a day, while a high-ticket luxury trip with similar culinary and transport experiences can cost upwards of 400,000 UGX a day. A well-planned and budgeted trip with certain compromises, however, can cost as low as 100,000 UGX.\n\n &nbsp; \n\nAs **Ugandan Shilling Forex cards** can only be used in major cities, it is recommended that you **buy Ugandan Shilling** from a **Ugandan Shilling currency exchange** as soon as you arrive in the country. Checking the **live Ugandan Shilling rate** beforehand is also a great idea."},identification:{list:["When exposed to sunlight or any other form of direct light, **Ugandan Shilling** banknotes show a picture of Uganda’s National bird, a crane. The watermark features a light area near the eye and a dark area above the beak, along with the denomination of the note below the beak.","A silvery security thread runs through the middle of the **Ugandan Shilling** banknotes. The thread appears broken when not exposed to direct light. When exposed to direct light the thread appears as a continuous line and changes colour from red to green.","The lower denomination notes of 1000, 2000, and 5000 have their purple pattern change to green when the note is tilted.","The higher denomination notes of 10,000, 20,0000, and 50,000 have a prominent green pattern that changes colour to blue when the note is tilted away from the holder. The pattern also contains a bright line that moves when the note is tilted side to side."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Ugandan Shilling**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Ugandan Shilling to USD, INR to Ugandan Shilling** or **Ugandan Shilling to Euro**, you only need to follow the below-written steps:"}}},{id:80,internalName:"seo_currency_page_jordanian-dinar",type:"seo_currency_page_jordanian-dinar",data:{name:"Jordanian Dinar",code:"JOD",country_code:"JO",travel_country:"Jordan",keywords:"Jordanian Dinar, Dinar Currency, Jordanian Dinar rate, Jordanian Dinar symbol, dinar to rupee, Jordanian dinar to dollar, jordanian dinar to usd, 1 jordanian dinar to indian rupees, Jordanian dinar exchange rate, Jordanian dinar currency exchange, buy Jordanian dinar, sell Jordanian dinar, Jordanian dinar forex cards, live Jordanian dinar rate, Jordanian dinar price",about:{title_text:"The Currency of Jordan",desc:"Jordan's official currency is the **Jordanian dinar**. It is issued by Jordan's Central Bank and is abbreviated as JOD or JD. The **Jordanian dinar** is denoted by 1000 fulus. In Jordan, the **Jordanian dinar** is used for all financial activities, including the purchase of goods and services as well as the payment of bills and taxes.\n\n &nbsp; \n\nThe Central Bank of Jordan has the authority to issue the **Jordanian Dinar**. The central bank is also responsible for issuing **Jordanian Dinar Forex cards** for tourists and businesses.\n\n &nbsp; \n\nThe **Jordanian Dinar exchange rate** against the major world currencies is presented below. These values represent the **live** **Jordanian Dinar rate.**\n\n &nbsp; \n\nThe current **Jordanian Dinar to dollar** rate is 1.41. The **Jordanian dinar to USD** exchange rate is what ensures the stability of the **Jordanian dinar.** This means that the **Jordanian dinar to rupee** exchange rate is 1 JOD to `inr_exchange_rate` INR. The **Jordanian dinar rate** for other major currencies is:\n\n &nbsp; \n\n1 Euro = 0.75 **Jordanian dinar**\n\n &nbsp; \n\n1 Pound = 0.85 **Jordanian dinar**\n\n &nbsp; \n\nThe **Jordanian Dinar currency exchange** makes it one of the most highly valued currencies in the world with the Central Bank closely monitoring the exchange rate. It intervenes in the Forex market to maintain its stability. If you want to **buy Jordanian dinar** or **sell Jordanian dinar** you will have to follow the regulations set by the Central Bank."},quick_facts:{facts:{Country_of_Origin:"Jordan",Symbol:"The Jordanian Dinar symbol is د.ا",Currency_Code:"JOD/ JD",Nick_Names:"-",Minor_units:"Dirhams, Qirsh, Fulus","Denominations_(Banknotes)":"1 JOD, 5 JOD, 10 JOD, 20 JOD, 50 JOD",Motto:"-",Identification_Feature:"To identify a genuine **Jordanian Dinar currency** banknote, you need to look for:\n\n &nbsp;\n\n &nbsp;1. **Jordanian Dinar Symbol**\n\n &nbsp;2. Watermark\n\n &nbsp;3. Jordanian National Symbol\n\n &nbsp;4. Jordanian historical figures",Issuing_Bank:"Central Bank of Jordan",In_Circulation_Since:"1949",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Jordan's currency, the **Jordanian** **dinar**, was created in 1950, replacing the Palestinian pound. The first series of **Jordanian** **dinar** notes featured an image of Ruler Abdullah I, the founder and first king of Jordan's Hashemite Kingdom.\n\n &nbsp; \n\nIn the 1960s, Jordan's Central Bank began minting **Jordanian dinar** coins in addition to paper notes. The **Jordanian dinar** coins were issued in the denominations of 1/2, 1, 2.5, 5, 10, piastres/qirsh, 1/4, 1/2, and 1 **Jordanian dinar**. Because of the high **Jordanian dinar rate** the currency denominations used in the country are low in value.\n\n &nbsp; \n\nIn the 1980s, Jordan's Central Bank issued a new generation of **Jordanian** **dinar** notes with increased security measures to assist prevent counterfeiting. The new series also included fresh designs and themes, as well as photos of historical locations, cultural landmarks, and natural settings.\n\n &nbsp; \n\nIn the 1990s, Jordan's Central Bank issued a new generation of **Jordanian dinar** coins composed of brass-plated steel. The new **Jordanian dinar** coins were introduced to replace the earlier aluminium-bronze coins that had been in use since the 1960s.\n\n &nbsp; \n\nIn the 2000s, Jordan's Central Bank issued a new generation of **Jordanian dinar** notes with even more advanced security measures, including colour-shifting ink, a security thread, and a latent image. The new series also included photos of modern structures, cultural people, and natural settings, as well as revised designs and themes.\n\n &nbsp; \n\nThe **Jordanian dinar** is now a widely acknowledged currency across the Middle East, and it is used in all financial activities in Jordan. Jordan's Central Bank continues to produce new dinar notes and coins, with the most recent series depicting His Majesty King Abdullah II's picture."},countries_accepting:{desc_1:"The **Jordanian Dinar** is a currency used by the country of Jordan as well as the people living in the West Bank.",list:[],desc_2:""},amount_for_trip:{desc:"Jordan is a beautiful country that has great restaurants, entertainment venues, and historical sites that are popular with tourists.\n\n &nbsp; \n\nA typical Petra vacation might begin in Madaba. You may then visit the 950-meter-deep Wadi Mujeb Canyon. After passing over the canyon, you will arrive in Karak, where you may explore a Crusader fortress. You may then go across the highlands to the famous Petra. You will need around 1000 Jordanian dinars per week for a 2 people vacation. Converting the **Jordanian dinar price** into INR means you will need around INR 1,16,000 for a week."},identification:{list:["Examine the denomination: Check that the denomination of the note corresponds to the value printed on it. A 1 dinar note, for example, should not be confused with a 50 dinar note.","Examine the size: Compare the note's size to those of other authentic notes. Counterfeit notes are frequently somewhat larger than genuine ones.","Examine the colour: Contrast the hue of the note with that of other real notes. Counterfeit notes may have somewhat different colour hues than genuine notes.","Examine the watermark: Look for the watermark by holding the note up to the light. A weak yet clear image of His Majesty King Abdullah II's visage should be used as the watermark.","Examine the security features: Look for security elements such as the latent image, security thread, and microprint that are printed on the note. These details should be distinct and not fuzzy or faded."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Jordanian Dinar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Jordanian Dinar to USD, INR to Jordanian Dinar** or **Jordanian Dinar to Euro**, you only need to follow the below-written steps:"}}},{id:81,internalName:"seo_currency_page_bolivian-boliviano",type:"seo_currency_page_bolivian-boliviano",data:{name:"Bolivian Boliviano",code:"BOB",country_code:"BO",travel_country:"Bolivia",keywords:"Bolivian Boliviano,Bolivian Boliviano symbol,bolivian boliviano to usd, Bolivian boliviano exchange rate, Bolivian boliviano currency exchange, buy Bolivian boliviano, sell Bolivian boliviano, Bolivian boliviano forex cards, live Bolivian boliviano rate, Bolivian boliviano price",about:{title_text:"The Currency of Bolivia",desc:"Bolivia's national currency is the **Bolivian boliviano** (BOB). One boliviano is equal to 100 centavos. Bolivia's currency, the **Bolivian boliviano**, has been in use since 1864 when it replaced the peso. The boliviano is issued and regulated by the Central Bank of Bolivia. The **Bolivian boliviano exchange rate** to other currencies varies according to market conditions.\n\n &nbsp; \n\nThe Central Bank of Bolivia is also responsible for regulating **Bolivian boliviano Forex cards**. The **live** **Bolivian boliviano rate** can be tracked through major Forex and currency exchange sites.\n\n &nbsp; \n\nThe **Bolivian boliviano to USD** exchange rate is 0.14**.** The **Bolivian boliviano currency exchange** rate for other major currencies is:\n\n &nbsp; \n\n1 Euro = 7.36 **Bolivian boliviano**\n\n &nbsp; \n\n1 Pound = 8.32 **Bolivian boliviano**\n\n &nbsp; \n\nTo **buy Bolivian boliviano** or **sell Bolivian boliviano** you will have to follow the laws and rules set by the central bank."},quick_facts:{facts:{Country_of_Origin:"Bolivia",Symbol:"The Bolivian boliviano symbol is Bs",Currency_Code:"BOB",Nick_Names:"-",Minor_units:"Centavo","Denominations_(Banknotes)":"Bs 10, Bs 20, Bs 50, Bs 100, Bs 200",Motto:"-",Identification_Feature:"To identify a genuine **Bolivian boliviano currency** banknote, you need to look for:\n\n &nbsp; \n\n &nbsp;1.  Every **Bolivian boliviano** has a distinct colour\n\n &nbsp;2.  They feature prominent Bolivian Individuals\n\n &nbsp;3.  They carry a watermark",Issuing_Bank:"Banco Central de Bolivia/ Central bank of Bolivia",In_Circulation_Since:"1987"}},history:{desc:"In Bolivia, the **Bolivian boliviano** has a lengthy history. It was initially adopted in 1864, replacing the peso as the country's official currency. The **Bolivian boliviano** was initially linked to the gold standard, which meant that its value was related to the value of gold and that it could be exchanged for a predetermined quantity of gold.\n\n &nbsp; \n\nHowever, the boliviano's value has fluctuated significantly throughout the years. Bolivia suffered a period of economic instability and severe inflation in the early 1900s, which resulted in the depreciation of the **Bolivian boliviano**. The government enacted a number of economic changes in the 1930s, including a stabilisation plan that tied the **Bolivian boliviano price** to the US dollar.\n\n &nbsp; \n\nBolivia had another era of economic instability and severe inflation in the 1980s, leading to the devaluation of the **Bolivian boliviano** once more. In the 1990s, the government adopted a new set of economic reforms, including the introduction of a new currency known as the boliviano fuerte (strong boliviano), in an effort to stabilise the currency and reduce inflation."},countries_accepting:{desc_1:"The **Bolivian boliviano** is only accepted in Bolivia. You can exchange the currency for Forex while leaving the country and vice-versa",list:[],desc_2:""},amount_for_trip:{desc:"When visiting a new country, it's usually a good idea to bring some local currency with you, since it may be more convenient and save you money than using your credit card or converting money at a higher rate.\n\n &nbsp; \n\nIt's impossible to specify how many **Bolivian bolivianos** (BOB) you should bring to Bolivia because it will depend on your particular spending patterns and the length of your trip. When deciding how much money to bring, consider your lodging, transportation, meals, activities, and any souvenirs or other goods you may wish to purchase.\n\n &nbsp; \n\nIn general, for your vacation to Bolivia, bring a mix of cash and a credit or debit card. You can use your card to withdraw cash from ATMs or make purchases at merchants that accept card payments, but you may also use cash for smaller transactions in circumstances where card payments are not accepted. It's also a good idea to keep a few small denominations of **Bolivian boliviano** on hand in case you need to make a minor transaction or tip. To give a rough estimate, you will need around 3000 BOB for a week-long stay in Bolivia."},identification:{list:["Look for security features: The **Bolivian boliviano** has many security elements integrated into its design to aid in the identification of counterfeits. Watermarks, security threads, and holograms are examples of these characteristics. To establish authenticity, check the security elements on the bill to those presented on the Central Bank of Bolivia's website.","Examine the printing and paper quality: Fake **Bolivian boliviano** banknotes may have poor printing quality or be manufactured on different paper than genuine bolivianos. To check for inconsistencies, compare the printing and paper quality of the bill to those of other authentic bolivianos.","Feel the bill's feel: Genuine **Bolivian bolivianos** are printed on a specific paper with a particular texture."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Bolivian Boliviano**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Bolivian Boliviano to USD, INR to Bolivian Boliviano** or **Bolivian Boliviano to Euro**, you only need to follow the below-written steps:"}}},{id:82,internalName:"seo_currency_page_libyan-dinar",type:"seo_currency_page_libyan-dinar",data:{name:"Libyan Dinar",code:"LYD",country_code:"LY",travel_country:"Libya",keywords:"Libyan dinar,Libyan dinar rate, Libyan dinar symbol,Libyan dinar to indian rupee, Libyan dinar to dollar, libyan dinar to inr, libyan dinar to rand, libyan dinar to usd, Libyan dinar exchange rate, Libyan dinar currency exchange, buy Libyan dinar, sell Libyan dinar, Libyan dinar forex cards, live Libyan dinar rate, Libyan dinar price",about:{title_text:"The Currency of Libya",desc:"Libya's national currency is the dinar (**Libyan Dinar symbol**: LD in Latin, ل.د in Arabic; code: LYD). One thousand dirhams equal one **Libyan Dinar**. It is issued by the Libyan Central Bank, which also controls credit and oversees the banking industry.\n\n &nbsp; \n\nThe name of British Guinea is the source of the common names for the **Libyan dinar**, jni or jneh. Outside of formal circles, the term dinar is hardly ever used. In normal speech, the approved fractional unit, the dirham, is never brought up. Instead, the word “garsh”, a variation of “qirsh”, is used, with 1 garsh equaling 10 dirhams. A kilo is a fashionable term for one thousand dinars. Similar to how five and ten dinar notes are sometimes referred to as fiver and tenner for five and ten-pound notes, respectively, in the younger generation, the nicknames for five and ten dinar notes are faifa and tsena. These playful feminizations of the English words “five” and “ten” are also possible traces of British slang words."},quick_facts:{facts:{Country_of_Origin:"Libya",Symbol:"LD and ل.د",Currency_Code:"LYD (numeric: 434)",Nick_Names:"jni",Minor_units:"dirham (dh.)","Denominations_(Banknotes)":"LD 1, LD 5, LD 10, LD 20, LD 50",Motto:"-",Identification_Feature:"Different features on different notes:\n\n &nbsp; \n\n &nbsp;**LD 1**: Anti-Gaddafi protesters on front and flag of love and peace dove on bank\n\n &nbsp;**LD 5**: Ottoman Clock Tower on front and Zeus Temple on back\n\n &nbsp;**LD 10**: Omar al-Mukhtar on front and Al Mukhtar horsemen on the back,etc.",Issuing_Bank:"Central Bank of Libya",In_Circulation_Since:"1971"}},history:{desc:"The old Italian Lira was replaced in 1951 by the Libyan Pound before the **Libyan Dinar** was introduced. They replicated the traditional style found on numerous Arabic banknotes from the time. On the front, they are printed in Arabic, and on the back, in English. King Idris is depicted on the front of the 1952 1 pound coin, which is coloured blue and white. Until the new **Libyan Dinar** was launched in 1971, the Libyan pound was still in use. They were available in 1/4, 1/2, 1, 5, and 10 dinar denominations.\n\n &nbsp; \n\nAfter the new banknotes had been in circulation for a few years, fresh versions with Muammar Gaddafi started appearing on the **Libyan Dinar** notes. Along with pictures of mosques and national structures like buildings and monuments, the banknotes also had pictures of the leader. This batch of the **Libyan Dinar** had a lot of colours and features Omar El Mukhtar, who is well-known in Libyan history for his opposition to Italian occupation, is also depicted on them. When Gaddafi was overthrown in 2011, his likeness was also taken from the coinage. The 2013 1 **Libyan Dinar** has images that stand for emancipation and freedom. On the front are protesters holding the Libyan flag, and on the back are white doves with a picture of the flag of Libya.\n\n &nbsp; \n\nThe current **Libyan Dinar rate** is `inr_exchange_rate` INR. The **Libyan Dinar to Dollar** currently stands at 0.21 USD, and the **Libyan Dinar to Rand** is 3.57 ZAR."},countries_accepting:{desc_1:"Only in Libya is the **Libyan Dinar** recognised as payment. As a memento of your journey, you can also **buy Libyan Dinar**. You may **sell Libyan Dinar** which has been surplus from your trip. The **Libyan dinar price** varies with world economics and rises and falls accordingly. **Libyan dinar rate** can be viewed on Google for up to date pricing. The current rate for **Libyan Dinar to USD** is 0.21 USD. Similarly, the **Libyan dinar to Indian Rupee** is at `inr_exchange_rate` INR.",list:[],desc_2:""},amount_for_trip:{desc:"Libya is a cash society. Credit cards are not widely used, although a few major hotels and restaurants may accept them. Make sure to use **Libyan Dinar forex cards** there.\n\n &nbsp; \n\nThere are about 10 major banks in the country: the National Commercial Bank, the Central Bank of Libya, the Agriculture Bank, the Arab Foreign Bank, the Commerce & Development Bank, the Sahara Bank, the Savings and Real Estate Investment Bank, the Umma Bank, al-Jamahiriya Bank and the Wahda Bank. You can visit any of these banks to perform a **Libyan dinar currency exchange**. You can also learn about the live **Libyan Dinar exchange rate** here.\n\n &nbsp; \n\nMeals at inexpensive restaurants range from 20 to 30 **Libyan Dinar,** while a meal for 2 people at a mid-range restaurant for a three-course meal, on average, costs 120 to 150 **Libyan Dinar**.\n\n &nbsp; \n\nYou may have to carry 900 to 1100 **Libyan Dinar** for a backpacker's budget for a weekend. A mid-range traveller may have to expend between 2500 and 3000 **Libyan Dinar** for a weekend trip. These are generally at the **live Libyan Dinar rate** and may vary with time. Transportation prices are generally low."},identification:{list:["The LD 1 is purple and features Anti-Gaddafa protesters on the front and the flag of Libya and peace doves on the back.","The LD 5 notes are brown in colour and feature the Ottoman Clock Tower on the front and the Zeus temple in Cyrene at the back.","The LD 10 note is blue in colour and features Omar-al-Mukhtar on the front and the horsemen of Al Mukhtar on the back.","The LD 20 is orange and features the majestic Al Ateeq mosque in Oujlah on the observe and a traditional school on the reverse.","The LD 50 features the Italian Lighthouse on the front and the Stone arch in Tadrart Acacus on the reverse side.","You may look and compare these features to separate true notes from counterfeit."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Libyan Dinar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Libyan Dinar to USD, INR to Libyan Dinar** or **Libyan Dinar to Euro**, you only need to follow the below-written steps:"}}},{id:83,internalName:"seo_currency_page_honduran-lempira",type:"seo_currency_page_honduran-lempira",data:{name:"Honduran Lempira",code:"HNL",country_code:"HN",travel_country:"Republic of Honduras",keywords:"Honduran lempira,Honduran lempira symbol ,Honduran lempira exchange rate, Honduran lempira currency exchange, buy Honduran lempira, sell Honduran lempira, Honduran lempira forex cards, live Honduran lempira rate, Honduran lempira price",about:{title_text:"The Currency of Republic of Honduras",desc:"The Honduran lempira (HNL) is the currency that is used inside the borders of the Republic of Honduras. In ordinary usage, it is denoted by the letter L. The Honduran lempira, the country's official currency gets its name from an indigenous Honduran leader who fought against the Spanish colonisers in the 16th century. The Honduran lempira (HNL), which is the country's current currency, replaced the Honduran peso at a rate of one to one when it was first issued in 1931. The **Honduran lempira symbol** is L.\n\n &nbsp; \n\nDue to the fact that it can be converted to any other currency at any time, its value has steadily decreased in comparison to the dollar over the course of the past five years, going from approximately $0.06 to approximately $0.04. Because Honduras's economy is so dependent on the export of commodities like bananas, it is vulnerable to the devastation that can be caused by natural disasters.\n\n &nbsp; \n\nThe **live Honduran Lempira rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Honduran Lempira price**."},quick_facts:{facts:{Country_of_Origin:"Republic of Honduras (UAE)",Symbol:"L",Currency_Code:"HNL",Nick_Names:"-",Minor_units:"Centavos","Denominations_(Banknotes)":"L1, L2, L5, L10, L20, L50, L100, L200 and L500",Motto:"-",Identification_Feature:"On the L500 note, the image of Ramón Rosa is printed on the obverse side and San Juancito on the reverse side.",Issuing_Bank:"Central Bank of Honduras",In_Circulation_Since:"1932"}},history:{desc:"The Honduran peso was officially replaced by the lempira in 1931, despite maintaining the same value as before. It wasn't until 1932 that coins and paper bills began to circulate together as currency. 4 By the year 1950, the Honduran monetary system had already taken the shape it maintains today, with the establishment of the Central Bank of Honduras and the nationalisation of the Honduran payments system respectively.\n\n &nbsp; \n\nEven though the Honduran Lempira was declared by the National Congress as the country's official currency as early as 1950, it wasn't until the foundation of the central bank that it actually started to be used as such. This was despite the fact that the designation occurred in 1950. Before this, the majority of Hondurans had very limited access to banking services, with the exception of these two organisations.\n\n &nbsp; \n\nIn order to strengthen security, a polymer-printed twenty-lempira note was placed into circulation in the year 2010. The Central Bank of Honduras, which is also in charge of the Honduran currency, is responsible for printing banknotes with denominations of 1, 2, 5, 10, 20, 50, 100, and 500 lempiras.\n\n &nbsp; \n\nIn recent years, the Honduran government has made efforts to encourage economic growth through privatisation and free trade agreements. Despite the fact that Honduras remains one of the poorest countries in the world, these efforts have been made."},countries_accepting:{desc_1:"The **Honduran Lempira** is the legal tender in the Republic of Honduras and is used as the sole currency for all kinds of transactions here.",list:[],desc_2:""},amount_for_trip:{desc:"When travelling to the Republic of Honduras, tourists should anticipate spending approximately L443 per day on activities and entertainment while they are there. More than L2,896 will need to be spent each day on each individual if you choose to partake in luxurious activities and luxuries such as riding in a private car, employing a personal chef, and staying in five-star hotels. A vacation for two in the Republic of Honduras will almost surely set you back more than L900.\n\n &nbsp; \n\nThe price of a night's stay in a hotel room in the Republic of Honduras normally ranges from L104 to L814, with the average cost being approximately L281. Your daily transportation costs in the Republic of Honduras could run anywhere from L238 to L1,563, depending on whether or not you choose to walk, ride the bus, or hail a cab.\n\n &nbsp; \n\nYou can check the **Honduran Lempira rate today** in order to plan a cost-effective vacation."},identification:{list:["If the denomination printed on the note does not contain ink that changes colour when exposed to ultraviolet light, the bill is very certainly a fake. When you hold a banknote at an angle, either to the left or to the right, there is a subtle change in the note's colour.","Genuine banknotes will each have their own distinctive security feature, known as a watermark, printed on them.","Smudged borders, font, or text are telltale signs of a counterfeit banknote, making it easy to spot. In the vast majority of instances, counterfeit printers are unable to make reproductions that look legitimate.","Microprinting can be found on genuine banknotes, proving their authenticity. If the microprinting cannot be read when placed under a microscope, there is a good chance that it is a fake.","The raised printing present on authentic banknotes makes it difficult for counterfeiters to recreate the design, making it possible to determine which bills are genuine. You can detect any raised printing on the note by moving your fingertips slowly along the note's surface.","Banknotes that are genuine will have what is termed a security thread, which is a thin embedded strip that runs vertically across the face of the bill. Genuine banknotes will have an additional layer of protection thanks to the inclusion of microprinting in the security thread."]},how_to_buy:{desc:"Whether you want to buy **Honduran lempira forex cards** and currency notes or sell the **Honduran Lempira**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Honduran Lempira to USD, INR to Honduran Lempira** or **Honduran Lempira to Euro**, you only need to follow the below-written steps:"}}},{id:84,internalName:"seo_currency_page_cambodian-riel",type:"seo_currency_page_cambodian-riel",data:{name:"Cambodian Riel",code:"KHR",country_code:"KH",travel_country:"Cambodia",keywords:"Cambodian riel,Cambodian riel Currency, Cambodian riel symbol,Cambodian riel to indian rupee, Cambodian riel to dollar, cambodian riel to inr, cambodian riel to pound,Cambodian riel exchange rate, Cambodian riel currency exchange, buy Cambodian riel, sell Cambodian riel, Cambodian riel forex cards, live Cambodian riel rate, Cambodian riel price",about:{title_text:"The Currency of Cambodia",desc:"The riel is the most common unit of money use across Cambodia. The first form of the riel was put into circulation in 1953 and remained in use until May of 1975. Between the years 1975 and 1980, the nation did not have a currency that was able to function properly. A second form of currency with the same name, the riel, has been in circulation ever since the 20th of March in the year 1980. When engaging in monetary transactions, it is imperative that the currency code for the riel, which is KHR, be utilised. The sen, which is equal to one hundredth of a riel, and the kak, which is equal to one tenth of a riel, are its subdivisions. The Cambodian riel symbol is **៛.**\n\n &nbsp; \n\nThis currency is allowed to float freely against other currencies, but during the past few decades, it has experienced a significant loss of value when compared to international currencies. As a result, the United States dollar has become the de facto means of exchange.\n\n &nbsp; \n\nThe **live Cambodian Riel rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Cambodian Riel price**."},quick_facts:{facts:{Country_of_Origin:"Cambodia",Symbol:"៛",Currency_Code:"KHR",Nick_Names:"-",Minor_units:"Kak","Denominations_(Banknotes)":"100៛, 200៛, 500៛, 1,000៛, 2,000៛, 5,000៛, 10,000៛, 20,000៛ and 50,000៛",Motto:"-",Identification_Feature:"On the reverse side of 20,000 riels notes, you will find the image of Angkor Wat and four faces of the Bodhisattva Avalokitesvara",Issuing_Bank:"National Bank of Cambodia",In_Circulation_Since:"March 20, 1980"}},history:{desc:"The piastre de commerce, the currency of French Indochina, was replaced by the riel in 1953, the same year that Cambodia gained its independence from France. The riel was valued at the same amount as the piastre de commerce. The Khmer Rouge carried out a coup d'état in 1975, which resulted in the abolition of the riel and the destruction of all newly produced banknotes.\n\n &nbsp; \n\nIn 1975, during the rule of the communist Khmer Rouge dictatorship, all types of cash in Cambodia were made illegal. It was not until 1980 that Cambodia issued a new currency. In the immediate aftermath of the overthrow of Pol Pot's dictatorship in Cambodia in 1980, the riel was reintroduced into circulation at a rate of four riel to one dollar. Since then, there has been a gradual deterioration in the correlation between the values of the two currencies. At the moment, one riel is equivalent to approximately one quarter of one hundred twenty-fourths of a dollar.\n\n &nbsp; \n\nIn 1970, as part of the United Nations Food and Agriculture Organization's coin programme, a 1 riel coin that was scheduled to be made was supposed to be around the size of a United States nickel. However, the coin was never distributed, possibly as a result of Lon Nol toppling the government of Norodom Sihanouk. Following the invasion of Cambodia by Vietnam in 1978, which toppled the government of the Khmer Rouge, the riel was reintroduced as Cambodia's official currency in 1980, with an initial exchange rate of four riels to one dollar of the United States.\n\n &nbsp; \n\n1979 was the year that saw the introduction of the first aluminium 5 sen coins into circulation. It wasn't until 1994 that a brand new series of coins for 50, 100, 200, and 500 riel was issued."},countries_accepting:{desc_1:"You are required to use the **Cambodian Riel**, which is the country's official currency, whenever you are making a purchase in Cambodia.",list:[],desc_2:""},amount_for_trip:{desc:"Many factors influence vacation expenses in Cambodia, including travel distance, travel speed, mode of transportation, lodging type, and overall spending while away from home. A tourist in Cambodia might spend roughly KHR 70,302 each day on entertainment and relaxation. Using high-end services and facilities such as limousine transportation, chef-prepared meals, and five-star hotels would set you back more than KHR 648,046 per person every day. A trip to Cambodia for two people can easily cost over KHR 140,000 to KHR 12,00,000. Hotels in Cambodia can cost anywhere from KHR 24,659 per night to KHR 249,755 per day. Your daily transportation costs in Canada could range from KHR 9,225 to KHR 66,882 depending on whether you walk, take the bus, or hail a taxi.\n\n &nbsp; \n\nYou can check the **Cambodian Riel rate today** in order to plan a cost-effective vacation. You can also keep an eye on **Cambodian Riel to Dollar** and **Cambodian Riel to Pound rate**."},identification:{list:["In addition, the most recent version of the riel, which was released in 2013, features certain brand-new, understated security aspects that were introduced by the bank. While smaller banknotes have watermarks and distinct textural patterns, larger bills have holograms, light-changing strips, and secret patterns. Larger bills also feature light-changing strips.","There are 37 different security features on the one hundred thousand bill, whereas the ten thousand, twenty thousand, and fifty thousand dollar bills each contain more than thirty of these features. Images of Cambodian royals as well as historical and cultural events that are instantly recognisable to all Cambodians are featured on the country's banknotes, rather than the foreign symbols that do not resonate with Cambodians."]},how_to_buy:{desc:"Whether you want to buy **Cambodian riel forex cards** and currency notes or sell the **Cambodian Riel**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Cambodian Riel to USD, INR to Cambodian Riel** or **Cambodian Riel to Euro**, you only need to follow the below-written steps:"}}},{id:85,internalName:"seo_currency_page_yemeni-rial",type:"seo_currency_page_yemeni-rial",data:{name:"Yemeni Rial",code:"YER",country_code:"YE",travel_country:"Yemen",keywords:"Yemeni rial, rial Currency, Yemeni rial symbol,yemeni rial to indian rupee, yemeni rial to inr, yemeni rial to gbp, yemeni rial to pkr, yemeni rial to sar, yemeni rial to saudi riyal, rial exchange rate, Yemeni rial currency exchange, buy Yemeni rial, sell Yemeni rial, Yemeni rial forex cards, live Yemeni rial rate, Yemeni rial price",about:{title_text:"The Currency of Yemen",desc:"The rial is the official currency of the Republic of Yemen. The Yemeni riyal is technically divisible into 100 fils, despite the fact that coins with the fils denomination have not been struck since Yemen's unification. Since 2014, the value of the Yemeni rial has been gradually deteriorating as a consequence of the persistent political unrest that occurs in the country. As a direct consequence of the ongoing civil conflict in Yemen, the country's two official currencies now trade at separate values. The Yemeni rial symbol is **﷼.**\n\n &nbsp; \n\nCurrency in southern Yemen, which is primarily controlled by separatists backed by the UAE and the old government backed by Saudi Arabia, has gone into freefall despite the fact that printing is still going on. This is because the old administration is backed by Saudi Arabia. The fact that banknotes printed after 2017 are not recognised as legitimate forms of payment in northern Yemen, a territory primarily controlled by Ansar Allah with support from Iran, has contributed to the currency market's ability to remain relatively steady. The relative sizes of banknotes printed before and after 2017 can be used to differentiate between the two.\n\n &nbsp; \n\nThe **live Yemeni rial rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Yemeni rial price**."},quick_facts:{facts:{Country_of_Origin:"Yemen",Symbol:"﷼",Currency_Code:"YER",Nick_Names:"-",Minor_units:"Fils","Denominations_(Banknotes)":"YRls 50, YRls 100, YRls 200, YRls 250, YRls 500 and YRls 1,000",Motto:"-",Identification_Feature:"When it comes to YRls 1,000 note, the images of Seiyun Palace and Hadhramaut are featured on the obverse side.",Issuing_Bank:"Central Bank of Yemen",In_Circulation_Since:"June 11, 1996"}},history:{desc:"Yemen created its very own currency to use for transactions within the country. Following the union of North and South Yemen in 1990, both the rial and the dinar were used as the country's official currency, with 1 dinar being equivalent to 26 rials. On June 11, 1996, dinars were finally converted into their final amount of dollars. The first coins to circulate in the Republic of Yemen did so in the year 1993. The Yemeni rial's value in relation to the US dollar has dropped significantly in comparison to its all-time high of 12.01 rials per dollar, which it reached in the early 1990s.\n\n &nbsp; \n\nSince the middle of the 1990s, the Yemeni rial has been completely convertible into other currencies. In comparison to the US dollar, the value of the rial has remained virtually unchanged over the course of the previous few years, despite falling from YRls 20 to somewhere about YRls 215. However, since 2010, the Central Bank of Yemen has been forced to intervene on many times in order to stop a precipitous decline in the country's holdings of foreign reserve currency.\n\n &nbsp; \n\nAt the time of Yemen's unification, the northern region had already begun minting coins denominated 1 rial, 5 fil, 10 fil, 25 fil, and 50 fil. There is no longer any currency denominated in fils that is in circulation. The Central Bank of Yemen minted brand new coins for the 1 rial and the 5 rial denominations in the year 1993. 1995 saw the introduction of a coin with a value of 10 rials, while 2004 saw the launch of a coin with a value of 20 rials. At the time of unification, the Central Bank of Yemen had notes in circulation with denominations of 1, 5, 10, 20, and 100 rials. These notes were in circulation. In 1993, the 1 rial note and the 5 rial note were converted into coins; in 1995, the 10 rial note was removed from circulation and never replaced.\n\n &nbsp; \n\nThe 200 rial note was issued for the first time in 1996, followed by the 500 rial note in 1997, and then the 1,000 rial note in 1998. Coins were introduced in 2004, taking the place of the earlier 20-rial notes. On the same day, November 14, 2009, a banknote with a value of 250 rials was made available. In 2017, as a result of the ongoing civil war in Yemen, the Central Bank of the country was forced to relocate to the temporary capital of Aden. There, it issued brand new banknotes with updated safety features and new physical dimensions. These banknotes were issued in denominations of 500 and 1,000 rials. In 2018, the Central Bank of Yemen introduced a new banknote for 100 rials, and in the same year, it also brought back banknotes for 200 rials."},countries_accepting:{desc_1:"The **Yemeni Rial** is the legal tender in Yemen and is used as the sole currency for all kinds of transactions here.",list:[],desc_2:""},amount_for_trip:{desc:"Visitors to Yemen may expect to spend about YER 9,012 per day on sightseeing and entertainment. Spending more than YER 40,000 a day per person is required if you plan on indulging in things like private transportation, a personal chef, and staying at five-star hotels. Spending between YER 20,000 to YER 80,000 on a trip for two to Yemen is a safe bet.\n\n &nbsp; \n\nYemen hotels often charge anywhere from YER 3,700 to YER 12,000 per night. Depending on whether you plan to walk, take the bus, or call a cab, your daily transportation costs in Yemen could range from YER 1,000 to YER 5,000.\n\n &nbsp; \n\nYou can check the **Yemeni Rial rate today** in order to plan a cost-effective vacation. You can also take a look at **Yemeni rial to GBP, Yemeni rial to PKR, Yemeni rial to SAR** and **Yemeni rial to Saudi riyal.**"},identification:{list:["Notes are easily spotted as counterfeit if the denominations printed on them do not contain ink that changes colour when exposed to ultraviolet light. The hue of the banknote shifts subtly depending on whether it is tilted to the left or right.","Each genuine banknote will contain a unique watermark, a security feature used to prevent counterfeiting. Fake banknotes are easy to recognise because of their smudged borders, typeface, or writing.","Authentic banknotes feature microprinting that verifies their legitimacy. Microprinting is likely false if it is unreadable under a magnifying glass.","Genuine banknotes can be identified by their raised printing, which is difficult to replicate by forgers. Move your fingertips slowly across the note's surface to feel for any raised printing.","Security threads, or thin embedded strips that run vertically across the face of authentic banknotes, are a telltale sign that a bill is a real deal."]},how_to_buy:{desc:"Whether you want to buy **Yemeni rial forex cards** and currency notes or sell the **Yemeni Rial**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Yemeni Rial to USD, INR to Yemeni Rial** or **Yemeni Rial to Euro**, you only need to follow the below-written steps:"}}},{id:86,internalName:"seo_currency_page_zambian-kwacha",type:"seo_currency_page_zambian-kwacha",data:{name:"Zambian Kwacha",code:"ZMW",country_code:"ZM",travel_country:"Zambia",keywords:"Zambian kwacha,Zambian kwacha Currency, Zambian kwacha rate, Zambian kwacha symbol,Zambian kwacha to indian rupee, Zambian kwacha to dollar, zambian kwacha to inr, zambian kwacha to USD,Zambian kwacha exchange rate, Zambian kwacha currency exchange, buy Zambian kwacha, sell Zambian kwacha, Zambian kwacha forex cards, live Zambian kwacha rate, Zambian kwacha price",about:{title_text:"The Currency of Zambia",desc:'The Kwacha is Zambia\'s national currency, and it is referred to simply as the Kwacha. One Ngwee is equal to one hundred Ngwee. The Zambian kwacha is issued by the Bank of Zambia, which serves as the country\'s central bank. The name "kwacha" comes from the Nyanja word for "dawn," and one kwacha is equal to one hundred ngwee. The Zambian kwacha is abbreviated as ZMK. In 1967, the Zambian pound was replaced by the Zambian kwacha as the country\'s official currency. Prior to this, Zambia had been a British colony known as Northern Rhodesia. The value of the Kwacha, which was originally pegged to the dollar and the pound of the United Kingdom but now floats freely against other international currencies as a result of inflation, has been dramatically eroded in recent years. The Zambian kwacha symbol is K or ZK.\n\n &nbsp; \n\nThe **live Zambian Kwacha rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Zambian Kwacha price**.'},quick_facts:{facts:{Country_of_Origin:"Zambia",Symbol:"K, ZK",Currency_Code:"ZMW",Nick_Names:"-",Minor_units:"Ngwee","Denominations_(Banknotes)":"2, 5, 10, 20, 50 and 100 kwacha",Motto:"-",Identification_Feature:"When it comes to YRls 1,000 note, the images of Seiyun Palace and Hadhramaut are featured on the obverse side.",Issuing_Bank:"Bank of Zambia",In_Circulation_Since:"January 16, 1968",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"Northern Rhodesia was the former name of the country that is now known as Zambia. Northern Rhodesia was a British colony that changed its name and declared its independence in 1964. Along with the introduction of the Zambian pound in 1964 by the Bank of Zambia, The Zambian pound was a currency that ran concurrently with the British pound that had been in use before. The Zambian kwacha was legally adopted in 1967 under the Currency Act of that year.\n\n &nbsp; \n\nThe Zambian pound and the kwacha were both legal tender in the country until the year 1974. The value of one Kwacha was fixed in relation to both the British pound and the US dollar by the state bank of Zambia right up until 1971. As a direct consequence of what came to be known as the \"Nixon Shock,\" the United States gave up using the gold standard, so calling an end to the Bretton Woods accord that had been in place after World War II. The new value of the kwacha in relation to the pound is a direct consequence of the devaluation of the US dollar.\n\n &nbsp; \n\nAs a direct response to the sustained depreciation of the value of the United States dollar in February 1973, the Bank of Zambia implemented a crawling peg for the kwacha that was set at a rate of 4.5 percent against the dollar. In the 1980s, Zambia experienced high inflation as a consequence of the country's deteriorating economic situation, which was brought on by a combination of factors including falling global copper prices and rising gasoline costs.\n\n &nbsp; \n\nIn 1996, the Bank of Zambia issued new notes in the following denominations: 5,000, 10,000, 20,000, and 50,000. 3 The value of the Zambian Kwacha reached an all-time low in 2006 when it was worth approximately 4,800 kwacha to one U.S. dollar. In recent years, the value of the Kwacha has maintained a level of consistency that is largely attributable to the country's continued economic progress. In 2013, the government implemented a revaluation of its currency that was equivalent to a factor of 1,000. 2014 was another year that saw exchange rates that were generally stable in comparison to the US dollar. In 2015, the value of the yuan fell by 42% against the dollar as a result of a slowdown in the Chinese economy and a reduction in the demand for copper. After that point, the exchange rate between the kwacha and the dollar settled between 10 and 20."},countries_accepting:{desc_1:"The **Zambian Kwacha** is the legal tender in Zambia and is used as the sole currency for all kinds of transactions here.",list:[],desc_2:""},amount_for_trip:{desc:"There are a lot of things that can change how much money you may need to travel to the amazing country of Zambia. The total cost of your trip will depend on how much you spend on transportation to and around your destination, where you stay, and how much you spend on food. On a trip with a budget, a tourist can spend about ZK 2,536,285 a day in Zambia. On the other hand, a day of vacation can easily cost more than ZK 19,549,887 if you use expensive transportation, eat at Michelin-starred restaurants, and only stay in the best hotels. The price of travel for two people can be anywhere from ZK 5,000,000 to ZK 41,249,000. A night's stay in Zambia can cost between ZK 2,431,229 and ZK 18,893,541 per person, per day.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **Live Zambian Kwacha** value in order to exchange your currency notes. You can also check out the **Zambian kwacha to dollar** rate."},identification:{list:["On each and every bill that is printed in the united states, there is a watermark that depicts the head of a fish eagle. This watermark is only visible when the money is held up to the light.","A metallic stripe with a colour-changing feature that depicts a bird in flight, a coat of arms, and the denominational value is known as the hologram.","Fish eagle's head printed in raised ink that has a rough texture when fingers are run over it; utilised in the peak pixel (k100 and k50).","When the security thread is tipped, it reveals the inscription along with the denomination and a flock of flying birds. When the thread is held up to the light, it creates the illusion of a single line that extends indefinitely.","A gold iridescent stripe may be found in both the front and back right corners of each bill. This distinctive pattern is made up of a single line of birds flying in opposite directions."]},how_to_buy:{desc:"Whether you want to buy **Zambian kwacha forex cards** and currency notes or sell the **Zambian kwacha**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Zambian kwacha to USD, INR to Zambian kwacha** or **Zambian kwacha to Euro**, you only need to follow the below-written steps:"}}},{id:87,internalName:"seo_currency_page_georgian-lari",type:"seo_currency_page_georgian-lari",data:{name:"Georgian Lari",code:"GEL",country_code:"GE",travel_country:"Georgia",keywords:"Georgian lari,Georgian lari symbol, Georgian lari to indian rupee, georgian lari to inr, georgian lari to aed, georgian lari to USD,Georgian lari exchange rate, Georgian lari currency exchange, buy Georgian lari, sell Georgian lari, Georgian lari forex cards, live Georgian lari rate, Georgian lari price",about:{title_text:"The Currency of Georgia",desc:'The lari is Georgia\'s official currency, and it is the country\'s sole form of legal tender. In total, there are a hundred of these tetris. The word "tetri" refers to a unit of cash in ancient Colchis that dates back to the sixth century BC. The ancient Georgian word "lari" denotes "hoard" or "property," but the word "tetri" refers to a unit of currency in ancient Georgia. The rouble, the abazi, and the Georgian coupon were all early forms of currency in Georgia (also known as a kuponi). The Georgian lari symbol is ლ.\n\n &nbsp; \n\nThe **Georgian lari price** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Georgian Lari price**.'},quick_facts:{facts:{Country_of_Origin:"Georgia",Symbol:"ლ",Currency_Code:"GEL",Nick_Names:"-",Minor_units:"Tetri","Denominations_(Banknotes)":"₾1, ₾2, ₾5, ₾10, ₾20, ₾50, ₾100 and ₾200",Motto:"-",Identification_Feature:"When it comes to the ₾100 note, you will find the image of Zakaria Paliashvili Georgian National Opera Theater on the reverse side.",Issuing_Bank:"National Bank of Georgia",In_Circulation_Since:"April 5, 1993"}},history:{desc:"On April 5, 1993, the Georgian kuponi became the country's official currency, succeeding the Russian ruble in that role. Hyperinflation was common during this time period, and there were no coins or other denominations available for use with this money. Banknotes were issued in sizes ranging from one kuponi to one million kuponi, with the more uncommon sizes of three, three thousand, thirty thousand, and one hundred fifty thousand also being available.\n\n &nbsp; \n\nOn October 2, 1995, the kuponi was replaced by the Lari at an exchange rate of one million to one. This occurred while Eduard Shevardnadze was president of Georgia. Giorgi Kadagidze, the Governor of the National Bank of Georgia, made the announcement that the winning design for Georgia's currency would be announced on July 8, 2014.\n\n &nbsp; \n\nThe National Bank of Georgia released a whole new complete set of banknotes with values ranging from $5, $10, $20, $50, and $100 between the months of November 2016 and October 2019."},countries_accepting:{desc_1:"The **Georgian Lari** is the legal tender in the Georgia and is used as the sole currency for all kinds of transactions here.",list:[],desc_2:""},amount_for_trip:{desc:"There are a lot of things that can change how much money you may need to travel in the amazing country of Georgia. The total cost of your trip will depend on how much you spend on transportation to and around your destination, where you stay, and how much you spend on food. On a trip with a budget, a tourist can spend about GEL26 a day in Taiwan. On the other hand, a day of vacation can easily cost more than GEL209 if you use expensive transportation, eat at Michelin-starred restaurants, and only stay in the best hotels. The price of travel for two people can be anywhere from GEL60 to GEL420.\n\n &nbsp; \n\nA night's stay in Georgia can cost between GEL8.42 and GEL87 per person, per day. On the other hand, the average cost of transportation for a day can be anywhere from GEL4.36 to GEL39, depending on whether you take public transportation or a private car.\n\n &nbsp; \n\nAll in all, you can keep an eye on the **Live New Taiwan Dollar** value in order to exchange your currency notes.\n\n &nbsp; \n\nYou can check the **live Georgian lari rate** in order to plan a cost-effective vacation."},identification:{list:["Each denomination's face value should showcase brilliant red, gold, and green colour when examined with ultraviolet light.","There can also be a metallic thread across the note that you want to inspect in order to check the note’s authenticity. There is a good possibility that this thread is real if it appears as a single, continuous dark line.","One warning sign of a counterfeit Georgian Lari is if the bill is completely flat with no raised areas."]},how_to_buy:{desc:"Whether you want to buy **Georgian lari forex cards** and currency notes or sell the **Georgian Lari**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Georgian Lari to USD, INR to Georgian Lari, Georgian Lari to AED** or **Georgian Lari to Euro**, you only need to follow the below-written steps:"}}},{id:88,internalName:"seo_currency_page_lebanese-pound",type:"seo_currency_page_lebanese-pound",data:{name:"Lebanese Pound",code:"LBP",country_code:"LB",travel_country:"Lebanon",keywords:"Lebanese pound,Lebanese pound Currency, Lebanese pound symbol ,Lebanese pound to dollar, lebanese pound to inr, lebanese pound to USD, pound exchange rate, Lebanese pound currency exchange, buy Lebanese pound, sell Lebanese pound, Lebanese pound forex cards, live Lebanese pound rate, Lebanese pound price",about:{title_text:"The Currency of Lebanon",desc:"The currency used in Lebanon is abbreviated as LBP, which stands for the Lebanese pound. In the 1930s, it succeeded the Syrian pound as the country's primary unit of currency. The value of the currency plummeted all the way through the length of the civil war, which lasted from 1975 until 1990. The recent political and economic unrest in the country has resulted in a considerable devaluation of the local currency, the pound, relative to its official peg of 1507.5 pounds to one US dollar. The Lebanese Pound symbol is LL or ل.ل..\n\n &nbsp; \n\nThe **Lebanese Pound price** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Lebanese Pound price**."},quick_facts:{facts:{Country_of_Origin:"Lebanon",Symbol:"LL or ل.ل",Currency_Code:"LBP",Nick_Names:"-",Minor_units:"Piastre","Denominations_(Banknotes)":"LL 1,000, LL 5,000, LL 10,000, LL 20,000, LL 50,000 and LL 100,000",Motto:"-",Identification_Feature:"The main colour used on the LL 100,000 note is green with the value written in Arabic script.",Issuing_Bank:"Banque du Liban",In_Circulation_Since:"August 1, 1963"}},history:{desc:'Since 1939, the Central Bank of Lebanon, also known as the Banque du Liban, has been in charge of issuing all banknotes. The denominations of the banknotes ranged from one pound to two hundred. They were issued. There are now banknotes in circulation for denominations including 1,000 pounds, 5,000 pounds, 10,000 pounds, 20,000 pounds, 50,000 pounds, and 100,000 pounds, amongst others. There are coins available in denominations of fifty pounds, one hundred pounds, and five hundred pounds.\n\n &nbsp; \n\nThe history of Lebanon\'s currency is long and eventful, beginning with the Ottoman lira and continuing on through the Egyptian pound, French franc, and Syrian pound before ultimately settling on the Lebanese pound in 1939.\n\n &nbsp; \n\nThe LBP is the current currency of Lebanon. Lebanon began producing coins in denominations of 2 and 5 piastres for circulation for the first time in 1924.\n\n &nbsp; \n\nThe first banknotes for the country were manufactured in 1925 by the Banque de Syrie et du Grand-Liban (also known as the Bank of Syria and Greater Lebanon). The smallest bill was twenty-five piastres, while the largest bill was one hundred lek. 1939 was the year when it became known as the Bank of Syria and Lebanon after undergoing a name change. This is the first year that the LL 250 bill was issued.\n\n &nbsp; \n\nEven after the end of World War II, the Bank of Syria and Lebanon continued to produce banknotes for Lebanon. These banknotes, which were now known as "Lebanese pounds" (, livre libanaise), were differentiated from Syrian banknotes by using a different name.\n\n &nbsp; \n\nIn accordance with the Code of Money and Credit, the Banque du Liban (also known as the Bank of Lebanon) was formally established on April 1, 1964. The Bank of Lebanon was given the exclusive issuing rights for banknotes with Arabic fronts and French backs on August 1, 1963.\n\n &nbsp; \n\nIn order to compensate for the value of the currency being eroded by inflation during the 1980s and 1990s, new notes with a higher denomination were created and circulated.'},countries_accepting:{desc_1:"The **Lebanese Pound** is the legal tender in Lebanon and is used as the sole currency for all kinds of transactions here.",list:[],desc_2:""},amount_for_trip:{desc:"The cost of a vacation is determined by a number of factors, including the distance travelled, the speed at which it is travelled, the modes of transportation utilised, the location of accommodations, and the total amount of money spent while on vacation. A tourist in Lebanon may expect to spend approximately L£72,180 every day on their entertainment while they are here. It will cost you more than L£320,122 per day, per person, to take use of high-end services and luxuries like riding in a private vehicle, having meals cooked by a chef, and staying in hotels with five stars.\n\n &nbsp; \n\nIt is very likely that the entire cost of a trip for two people in Lebanon will be more than L£145,180. The cost of a standard hotel room in Lebanon can range anywhere from L£39,049 to L£176,982 per night. Your daily transportation costs in Canada could run anywhere from L£13,911 to L£59,241, depending on whether or not you choose to walk, ride the bus, or hail a cab.\n\n &nbsp; \n\nYou can check the **live Lebanese Pound rate** in order to plan a cost-effective vacation. You can also check out the **Lebanese Pound to dollar** rate."},identification:{list:["Check the entire amount of the bill by using the square marked with a cedar and the square marked with a white to the right of it. The holographic cedar can be found on the right-hand side of the brand new one hundred thousand dollars.","When viewed from behind with a light, the vertical stripe must have a holographic quality and remain continuous.","A horizontal wave pattern that reflects light is printed on the English side of bills worth fifty thousand dollars.","Letters BDL are printed in three dimensions on the left-hand side of each banknote."]},how_to_buy:{desc:"Whether you want to buy **Lebanese pound forex cards** and currency notes or sell the **Lebanese Pound**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Lebanese Pound to USD, INR to Lebanese Pound** or **Lebanese Pound to Euro**, you only need to follow the below-written steps:"}}},{id:89,internalName:"seo_currency_page_afghan-afghani",type:"seo_currency_page_afghan-afghani",data:{name:"Afghan Afghani",code:"AFN",country_code:"AF",travel_country:"Afghanistan",keywords:"Afghan afghani,Afghan afghani Currency, Afghan afghani symbol,Afghan afghani to dollar, afghan afghani to inr, afghan afghani to pkr, afghan afghani to USD,Afghan afghani exchange rate, Afghan afghani currency exchange, buy Afghan afghani, sell Afghan afghani, Afghan afghani forex cards, live Afghan afghani rate, Afghan afghani price",about:{title_text:"The Currency of Afghanistan",desc:"The Afghan afghani Currency, which is the country's official currency, is printed by the Central Bank of Afghanistan, which is known as Da Afghanistan Bank. After reforms were implemented in 2002 to standardise the country's currency and bring it into line with international practise, the AFN was introduced as a result of these reforms. In September of 2021, one dollar was equivalent to approximately 88 afghanis. The Afghani is the country's primary unit of currency and the name by which it is commonly known (AFN). The ISO 4217 code AFN was implemented in 2003. Before the change, it was traded under the ticker symbol AFA on financial markets. The Afghan afghani symbol is Af or ؋.\n\n &nbsp; \n\nThe **Afghan Afghani price** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Afghan Afghani price**."},quick_facts:{facts:{Country_of_Origin:"Afghanistan",Symbol:"Af or ؋",Currency_Code:"AFN",Nick_Names:"-",Minor_units:"Pul","Denominations_(Banknotes)":"Af. 1, Afs. 2, Afs. 5, Afs. 10, Afs. 20, Afs. 50, Afs. 100, Afs. 500 and Afs. 1,000",Motto:"-",Identification_Feature:"On the obverse side of the Afs. 10,000 note, you can find the images of Seal of Da Afghanistan Bank and Great Mosque of Herat.",Issuing_Bank:"Da Afghanistan Bank",In_Circulation_Since:"September 4, 2002 (new currency)"}},history:{desc:"The national currency of Afghanistan has been subjected to a number of different iterations throughout the course of the last few decades. In 1925, the Afghani currency that we use today succeeded the Afghan rupee; in 2002, it was subjected to a revision, and in 2003, it was introduced into circulation as the Afghani (AFN).\n\n &nbsp; \n\nThe former Afghani currency was based on a fixed exchange rate, but the new Afghani uses a managed variable exchange rate. The economy of Afghanistan has been through a lot recently. Following the conclusion of the Soviet-Afghan War, which began in 1979 and lasted for more than a decade, Afghanistan has been wracked by a variety of violent civil wars ever since.\n\n &nbsp; \n\nThe Afghanistan Financial Network is currently managed by Da Afghanistan Bank, which is Afghanistan's central bank. The objective of the central bank is to maintain monetary exchange rate flexibility while simultaneously lowering inflationary pressures. Since 2005, when they were first brought to the market as a replacement for the AFN one, two, and five banknotes, coins have been in use as currency. The Afghan rupee, which had been in use as a currency in Afghanistan since 1891, was finally replaced by the original afghani in the year 1925. One afghani can be further subdivided into 100 puls, and one amani can be purchased for every 20 afghanis that are traded in exchange for it.\n\n &nbsp; \n\nIn 1952, 25 pul and 50 pul were the first aluminium alloys to be produced. Two years later, in 1958, Afs. 2 and Afs. 5 were introduced. In 1961, the Af. 1, Afs. 2, and Afs. 5 coins were created with nickel-clad steel.\n\n &nbsp; \n\nAdditionally, the Islamic State of Afghanistan issued a number of commemorative coins between the years 1995 and 2001. These pieces were circulated throughout the country."},countries_accepting:{desc_1:"The **Afghani** is the legal tender in Afghanistan and is used as the sole currency for all kinds of transactions here.",list:[],desc_2:""},amount_for_trip:{desc:"Numerous factors, such as mode of transportation and accommodation options play a role in determining vacation costs. A visitor in Afghanistan might spend about 3,858 Afs each day on entertainment and other forms of recreation. It will cost you more than 20,000 Afs Canadian Dollars per day, per person, to make use of high-end services and facilities such as private vehicle trips, meals cooked by chefs, and rooms in five-star hotels. It is not uncommon for the overall cost of a vacation to Afghanistan for two people to range between 8,000 Afs to 40,000 Afs.\n\n &nbsp; \n\nThe cost of a night's stay in a standard room at a hotel in Afghanistan can range anywhere from roughly 2,000 Afs to as much as 7,000 Afs each day. Your daily transportation costs in Canada could run anywhere from 300 Afs to 3,250 Afs, depending on whether you choose to walk, ride the bus, or use a cab to go around.\n\n &nbsp; \n\nYou can check the **live Afghan Afghani rate** in order to plan a cost-effective vacation. You can also check out the conversion rate of Afghan Afghani to Dollar and Afghan Afghani to PKR."},identification:{list:["If the denomination printed on the currency does not contain colour-changing ink, there is a significant possibility that the currency in question is fake. If you take a bill in your hand and tilt it to the left or right, you will see that the colour shifts slightly in response.","Authentic banknotes all have a security feature that is known as a watermark, which is a distinctive security characteristic. Authentic banknotes can be easily identified by this security feature.","If the borders, letters, or text on a banknote are smeared, this is a clear indication that the bill is a fake and should be avoided. Because of the dies that were utilised during the printing process of the initial banknotes, the notes feature exceedingly delicate lines and textures. In general, bogus printers are unable to deliver the same level of realism as their legitimate counterparts.","Authentic banknotes will also have microprinting, which is an additional distinguishing feature. Even with a magnifying glass, if the microprinting cannot be read, then the item in question is almost certainly a fake. It is famously difficult for forgers to replicate the raised printing that may be found on authentic banknotes.","A banknote's security thread is a very thin embedded strip that runs vertically across the front of the bill. Microprinting in the security thread will be an additional layer of protection that will be present on genuine banknotes."]},how_to_buy:{desc:"Whether you want to buy **Afghan Afghani forex cards** and currency notes or sell the **Afghan Afghani**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Afghan Afghani to USD, INR to Afghan Afghani** or **Afghan Afghani to Euro**, you only need to follow the below-written steps:"}}},{id:90,internalName:"seo_currency_page_brunei-dollar",type:"seo_currency_page_brunei-dollar",data:{name:"Brunei Dollar",code:"BND",country_code:"BN",travel_country:"Brunei",keywords:"Brunei dollar, dollar Currency, Brunei dollar rate today, Brunei dollar rate, Brunei dollar symbol , dollar to rupee, Brunei dollar to indian rupee, brunei dollar to indian rupees, brunei dollar to peso, 1 brunei dollar to philippine peso, brunei dollar to canadian dollar, Bruneidollar exchange rate, Brunei dollar currency exchange, buy Brunei dollar, sell Brunei dollar, Brunei dollar forex cards, live Brunei dollar rate, Brunei dollar price",about:{title_text:"The Currency of Brunei",desc:"The Bruneian shilling was the previous national currency of the Sultanate of Brunei until 1967, when it was replaced by the Brunei dollar. The symbol representing the dollar is frequently abbreviated as $, or sometimes as B$ in order to distinguish it from other currencies with a dollar-based value. One sen is equal to one hundred cents. The printing of Brunei dollars is the responsibility of the Central Bank of Brunei Darussalam, which is also known as the Autoriti Monetari Brunei Darussalam.\n\n &nbsp; \n\nThe **live Brunei dollar rate** is INR (`inr_exchange_rate`) . You can keep an eye on the real-time **Brunei dollar price**."},quick_facts:{facts:{Country_of_Origin:"Brunei",Symbol:"$ and B$",Currency_Code:"BND",Nick_Names:"-",Minor_units:"Sen","Denominations_(Banknotes)":"$1, $5, $10, $20, $25, $50, $100, $500, $1000 and $10,000",Motto:"-",Identification_Feature:"On the obverse side of $10,000 note, you can find the image of Sultan Hassanal Bolkiah.",Issuing_Bank:"Autoriti Monetari Brunei Darussalam",In_Circulation_Since:"June 12, 1967"}},history:{desc:'In Brunei, the use of coins stretches all the way back to the 10th century. Brunei has adopted the use of the Straits dollar as its official currency since from the year 1906. Because of the close ties that Brunei had with China at the time, the country\'s currency was originally made of Chinese coins. This condition was formerly known by the name "Pitis."\n\n &nbsp; \n\nIn Brunei, duit besi, a type of coin, was also used, which literally translates to "iron money." Iron was once considered to have such a great value that it was even used as a form of payment in earlier times.\n\n &nbsp; \n\nThe Bruneian government (Kerajaan Brunei) first began producing bills with face values of 1, 5, 10, 50, and 100 dollars on June 12, 1967. These bills were initially printed in Brunei. In 1979, 500 and 1000-dollar banknotes were first introduced into circulation.\n\n &nbsp; \n\nThe Malayan and British Borneo dollars were succeeded by the Brunei dollar in 1967, the same year that Malaysia and Singapore became independent nations. Up to the 23rd of June in 1973, the Malaysian ringgit was fixed in relation to the Singapore dollar as well as the Brunei dollar. The efforts of the Monetary Authority of Singapore and the Authoriti Monetari Brunei Darussalam have ensured that the Singapore Dollar and the Brunei Dollar can continue to be freely exchanged with one another. The Currency Interchangeability Agreement allows for the United States dollar to be accepted as "customary tender," despite the fact that it is not officially recognised as a form of currency in Singapore.\n\n &nbsp; \n\nThe name of the nation was changed formally in 1989 to the Malay phrase for "State of Brunei, Abode of Peace," and this new name is now represented on the paper money of the nation. Around the same time, the first banknotes for $10,000 were printed. On each note, the denomination is printed in English as well as the two different scripts used in Malay: Rumi and Jawi.\n\n &nbsp; \n\nUnlike the previous series, in which the English denomination was placed below the Malay denomination on the reverse of the coin, the new series places the English denomination on the back of the coin, next to the Jawi script.'},countries_accepting:{desc_1:"The **Brunei Dollar** is the only currency that can be used for any form of transaction in Brunei because it is the country's official currency and the only one that is the legal tender.",list:[],desc_2:""},amount_for_trip:{desc:"The overall cost of a vacation is determined by a number of different factors, such as the location of the trip, the mode of transportation taken to get there, the type of lodging that is reserved, and the amount of money spent while at the destination.\n\n &nbsp; \n\nA visitor in Brunei might spend approximately B$60 per day on entertainment and leisure activities. Plan on spending more than B$200 Canadian dollars per person, per day in order to take advantage of luxury amenities and services such as private transportation, gourmet meals, and lodging in hotels with a rating of five stars or higher. It is not uncommon for the total cost of a vacation in Brunei for two people to range between B$120 to B$400.\n\n &nbsp; \n\nThere are certain hotels in Brunei that charge as much as B$17 per day for a standard room, but the average cost of a hotel stay in this country is approximately B$50 per night. Your daily transportation costs in Brunei could run anywhere from B$15 to B$30, depending on whether you choose to walk, ride the bus, or call a cab.\n\n &nbsp; \n\nYou can check the **Brunei dollar rate today** in order to plan a cost-effective vacation."},identification:{list:["Rub the paper and see if it's composed of polymer. The majority of the contemporary banknotes in Brunei Darussalam are printed on polymer substrate, which gives them a distinctive feel. It's possible that certain counterfeit bills will feel unnaturally thick or thin to the touch.","As a result of the intaglio printing technique, a genuine banknote, regardless of whether it was printed on paper or polymer, would have a little grainy texture.","The elaborate clear window that is featured on the banknote ought not to be an afterthought but rather an essential component of the design. Take precautions to prevent the white and gold print on the window from being easily removed.","Investigate any inconsistencies you see when it comes to the printing on the notes, such as lines that are thicker or different colours, or patterns with less defined boundaries.","Examine the Bill Under an Ultraviolet Light Source. Both the state seal and the denomination patch, which are incorporated into the design of the banknotes, emit a neon glow when subjected to ultraviolet light."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Brunei Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Brunei Dollar to USD, INR to Brunei Dollar** or **Brunei Dollar to Euro**, you only need to follow the below-written steps:"}}},{id:91,internalName:"seo_currency_page_jamaican-dollar",type:"seo_currency_page_jamaican-dollar",data:{name:"Jamaican Dollar",code:"JMD",country_code:"JM",travel_country:"Jamaica",keywords:"Jamaican dollar,Jamaican dollar Currency, Jamaican dollar rate today, Jamaican dollar rate, Jamaican dollar symbol, Jamaican dollar to rupee, Jamaican dollar to indian rupee, jamaican dollar to inr, jamaican dollar to usd, Jamaican dollar exchange rate, Jamaican dollar currency exchange, buy Jamaican dollar, sell Jamaican dollar, Jamaican dollar forex cards, live Jamaican dollar rate, Jamaican dollar price",about:{title_text:"The Currency of Jamaica",desc:"The **Jamaican Dollar** is the currency of Jamaica. The **Jamaican Dollar symbol** is J$ in order to distinguish the **Jamaican Dollar symbol** from US Dollar and other Dollar denominated currencies. The currency is divided into 100 cents although the cent denominations are not being used after 2018. The name dollar was inspired by the decreased value of the new unit corresponding to the value of USD than it did to the Pound sterling. The **Jamaican Dollar currency** was the first dollar to be based on half-pound sterling instead of the US or Spanish Dollars.\n\n &nbsp; \n\nMake sure you check the **live Jamaican Dollar rate** in order to **buy Jamaican Dollar** or **Sell Jamaican Dollar** during your visit to Jamaica. The **Jamaican Dollar price** may fluctuate and differ from currency to currency so you should be aware of the exact price and exchange rates. For example, the **Jamaican dollar to rupee** price is different from the Jamaican dollar to other currencies. 1 **Jamaican Dollar to Indian rupee** equals `inr_exchange_rate`Indian Rupee and 1 Jamaican Dollar to USD equals 0.0065 United State Dollars."},quick_facts:{facts:{Country_of_Origin:"Jamaica",Symbol:"JM$",Currency_Code:"JMD",Nick_Names:"-",Minor_units:"Cent","Denominations_(Banknotes)":"J$ 50, J$ 100, J$ 500 and J$ 1000",Motto:"-",Identification_Feature:"-",Issuing_Bank:"Bank of Jamaica",In_Circulation_Since:"1969"}},history:{desc:"The first money in Jamaica was the maravedis Spanish copper coins. The pound sterling was the first currency of Jamaica. The **Jamaican Dollar currency** is different from other dollars in the British West Indies. Its value was half a pound sterling while other dollars took as the US or Spanish dollar unit. In 1994, the Council of Ministers permitted a new monetary structure as the $5 banknotes would be swapped by a coin, $ 1 by 25 cent dollars, 10 cents would get a new look and 5 cents would be abandoned. In 1999, the other coin and banknote of 10 were included. In march 2000, J$ 1000 bill was brought into circulation and in July J$ 20 note was replaced by the coin. It was the first bimetallic coin produced by Jamaica that bore the portrait of national hero Marcus Garvey. The **Jamaican Dollar rate** fluctuates from time to time, for example, if the **Jamaican Dollar rate today** is 0.0065 USD over time it may go up or down."},countries_accepting:{desc_1:"The **Jamaican dollar** is the currency of Jamaica but it was also used by the former dependencies of Jamaica, the Cayman Islands until 1972 and the Turks and Caicos Islands until 1973. In 1972, the Cayman Islands stopped using JMD and adopted its own currency, the Cayman Islands Dollar. Similarly, in 1973, Turks and Caicos Islands replaced the JMD with the United State Dollar. In order to convert the **Jamaican Dollar to INR** or to know the **Jamaican Dollar exchange rate**, you can use a currency converter.",list:[],desc_2:""},amount_for_trip:{desc:"If you are planning a trip to Jamaica you may need to spend around 15,989 **Jamaican Dollars** per day. It is the average per-day expense in Jamaica. You may need to spend an average of J$ 3,038 on meals per day and J$ 1673 on local transportation. The average price for Hotels in Jamaica is around J$ 20, 402. So, a one-week trip for two people may accost you around J$ 223, 851. Many tourist places in Jamaica also accept USD but businesses situated away from the major tourist hubs mostly take **Jamaican Dollars**. Merchants established in Jamaica may establish their own **Jamaican dollar currency exchange** so people using foreign currencies may encounter unfavourable **Jamaican Dollar rates** during conversion depending on the policy of a particular merchant. You can also use **Jamaican dollar forex cards** for certain transactions in Jamaica."},identification:{list:["Checking the security thread and tilting the note to see if the colour changes from red to green are the best techniques to spot a counterfeit Jamaican dollar. With the banknote held up to the light, the strip's text, which reads BOJ, and the note's denomination, such as BOJ 500, merge into a single line.","**For a J$ 500 note**, feel the note to check the familiar feel of banknote paper and to feel the thicker ink in some places. The iridescent coating consists of a vertical colour that changes when observed at a certain angle. The image features a band of clubs. Each note has a unique symbol on the front side of the note to aid partially sighted. Hold the note in light and see the image of Nanny of the Maroons. If you place the banknote on a dark surface you can see the shadow of 500 and a crocodile and a butterfly.","**For a J$ 1000 note**, feel the note to find the thicker ink at certain places. The iridescent coating includes a vertical band of colour that changes when you see at a certain angle. On the number 1000, you can see a band of butterflies. Look and feel the unique symbol on the front side to aid the partially sighted. Hold the note in light and see the image of Michale Manley on the J$ 1000.","**For J$ 5000**, on the front side of the note, observe the finely engraved lines on the portrait. Look at the black vertical serial number that increases in size, it should match the red horizontal number on the right side. When you see in the light the thread with BOJ 5000 is present vertically on both sides. On the back side of the note, check the honeycomb pattern that is smooth and has one colour. Look at the highway 2000 image."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Jamaican Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Jamaican Dollar to USD, INR to Jamaican Dollar** or **Jamaican Dollar to Euro**, you only need to follow the below-written steps:"}}},{id:92,internalName:"seo_currency_page_east-caribbean-dollar",type:"seo_currency_page_east-caribbean-dollar",data:{name:"East Caribbean Dollar",code:"XCD",country_code:"XC",travel_country:"Eastern Caribbean States",keywords:"East Caribbean dollar, East Caribbean dollar symbol, east caribbean dollar to inr, East Caribbean dollar exchange rate, East Caribbean dollar currency exchange, buy East Caribbean dollar, sell East Caribbean dollar, East Caribbean dollar forex cards, live East Caribbean dollar rate, East Caribbean dollar price",about:{title_text:"The Strong Currency of Eastern Caribbean States",desc:"The **Eastern Caribbean dollar** can be broken into 100 cents and has been in circulation since the year 1965. Then, it was replaced by the British West Indies dollar. It makes it one of the oldest currencies in the region. Eastern Caribbean Dollar currency is the official currency of Eastern Caribbean States. The currency is used by Antigua and Barbuda, Dominica, Grenada, Anguilla, Saint Lucia, Saint Kitts, Nevis, Montserrat, Saint Vincent, and Grenadines. \n\n &nbsp; \n\n The **East Caribbean Dollar symbol** is EC$ and it is managed by the **Eastern Caribbean** Bank. The **East Caribbean Dollar** has been pegged to US Dollars since 1976 at a rate of 2.7 XCD to 1 USD. The Eastern Caribbean Bank was established in 1983, and later took over the authority of the currency leaving the US dollar peg in place. The bank considers its dollar peg as a prime means to uphold price stability all over the region and keep inflation in check.\n\n &nbsp; \n\n The value of the 1 **East Caribbean dollar to INR** is INR `inr_exchange_rate`."},quick_facts:{facts:{Country_of_Origin:"Eastern Caribbean States",Symbol:"EC$",Currency_Code:"XCD",Nick_Names:"-",Minor_units:"Cent = 1/100 of a Dollar","Denominations_(Banknotes)":"EC$ 5, EC$ 10, EC$ 20, EC$ 50, and EC$ 100",Motto:"-",Identification_Feature:"-",Issuing_Bank:"Eastern Caribbean Central Bank",In_Circulation_Since:"1965"}},history:{desc:"Before 1965, the Organisation of Eastern Caribbean States was part of the West Indies Federation (WIF) and was using BWI$ as their currency. In 1965 the British West Indies Dollar currency was replaced at parity by the **East Caribbean Dollar**. Between 1965 to 1983,  the authority of Eastern Caribbean currency issued the EC$ with coins and notes. Eastern Caribbean Central Bank is responsible of the issuance of **East Caribbean dollar**. The bank was founded on 5th July 1983 by an agreement signed (The Eastern Caribbean Central bank Agreement) at Port of Spain."},countries_accepting:{desc_1:"The East Caribbean Dollar is accepted by eight independent states including Antigua and Barbuda, Grenada, Barbados, St, Vincent, and the Grenadines, Saint Lucia, St. Kitts, and Nevis, the Commonwealth of Dominica, and Trinidad and Tobago.",list:[],desc_2:""},amount_for_trip:{desc:"Generally, the Caribbean countries use the East Caribbean dollars, though many tourist destinations across the islands accept US dollars to encourage American traveller visits. Common types of credit cards such as Master Card, Visa, and American Express also work there. However, most credit card purchases occur in the local currency, with the **East Caribbean dollar exchange rate** handled by your bank.\n\n &nbsp; \n\n In many places, it is better to **buy East Caribbean dollar** for small purchases, transportation, etc. you can easily find an **East Caribbean dollar currency exchange** window at Caribbean airports where you can buy and **sell East Caribbean Dollar** at live **East Caribbean dollar rate**. Other than that you can also exchange your money at local banks at **East Caribbean dollar price**.\n\n &nbsp; \n\n **East Caribbean Dollar exchange rates** may vary but generally, banks offer a  better rate than hotels, retailers, and airport outlets. Caribbean ATMs also hand out local currency where you have to pay an additional fee to get an ideal exchange rate on the amount you withdraw. You can also use **East Caribbean dollar forex cards** as well."},identification:{list:["Carry the bill up to the light and see the security thread which is a plastic strip running from the top to the bottom of the bill.","Look at the security thread in Ultraviolet light to observe the security threads. In high-denomination bills, the plastic strips should glow a particular colour.","Check the watermarks in natural light. In natural light, see if the bill bears an image of the portrait of the person on the bill.","Observe the portrait of the person on the bill. Look at the image carefully, some specific differences in the portrait will show that the bill is not real.","Tilt your bill to observe the colour-shifting ink that appears to change its colour when you tilt the bill.","Look into the micro printing of the bill. It includes small numbers or words that are hardly visible to the naked eye. Microprinting can not be read without a magnifying glass"]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **East Caribbean Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **East Caribbean Dollar to USD, INR to East Caribbean Dollar or East Caribbean Dollar to Euro**, you only need to follow the below-written steps:"}}},{id:93,internalName:"seo_currency_page_maldivian-rufiyaa",type:"seo_currency_page_maldivian-rufiyaa",data:{name:"Maldivian Rufiyaa",code:"MVR",country_code:"MV",travel_country:"Maldives",keywords:"Maldivian rufiyaa, Maldivian rufiyaa Currency, Maldivian rufiyaa symbol, Maldivian rufiyaa to indian rupee, 1 maldivian rufiyaa to inr, maldivian rufiyaa to dollar, 1 maldivian rufiyaa to pkr, maldivian rufiyaa to pounds, Maldivian rufiyaa exchange rate, Maldivian rufiyaa currency exchange, buy Maldivian rufiyaa, sell Maldivian rufiyaa, Maldivian rufiyaa forex cards, live Maldivian rufiyaa rate, Maldivian rufiyaa price",about:{title_text:"The Currency of Maldives",desc:"The **Maldivian rufiyaa** is the currency of the Maldives. The issuance of **Maldivian rufiyaa currency** is regulated by Maldives Monetary Authority. There is more than one **Maldivian rufiyaa symbol** MVR and Rf but the most commonly used **Maldivian rufiyaa symbol** is Rf. The Maldivian rufiyaa is subdivided into 100 laari. The name rufiyaa is derived from the Hindi word rupiya or the Sanskrit word rupya. It replaced the Sri Lankan rupee and came into circulation in 1947.\n\n &nbsp; \n\nThe Maldivian Monetary Authority is the only issuer of the **Maldivian rufiyaa currency** and is responsible for making sure that currency demand is met adequately. The authority is also responsible for safeguarding the quality and integrity of Maldivian currency. That is why the authority oversees the whole life cycle of banknotes which involves issuing new banknotes, adding new security features, and printing and minting new coins and banknotes timely to ensure that the money circulation is secure against counterfeiting.\n\n &nbsp; \n\n**Maldivian rufiyaa price** is different for various currencies. For example, **1 Maldivian rufiyaa to INR** equals `inr_exchange_rate`Indian rupees, 1 **Maldivian rufiyaa to dollar** equals 0.065 United State Dollars, 1 **Maldivian rufiyaa to pkr** equals 14.75 Pakistani rupees, and 1 **Maldivian rufiyaa to pounds** equals 0.054 Pound Sterling."},quick_facts:{facts:{Country_of_Origin:"Maldives",Symbol:"Rf, MVR, ރ",Currency_Code:"MVR",Nick_Names:"-",Minor_units:"Maldivian Laari","Denominations_(Banknotes)":"Rf 10, Rf 20, Rf 50, Rf 100, Rf 500, Rf 1000",Motto:"-",Identification_Feature:"",Issuing_Bank:"Maldives Monetary Authority",In_Circulation_Since:"1947",INR_Exchange_Rate:"`inr_exchange_rate`"}},history:{desc:"The very first Maldivian currency was cowry shells which were derived from sea snails. In the 1600s strips of silver were used with the earliest coins. The first coins were introduced by Sultan Ibrahim Iskandar. In the 17th and 18th centuries, Larin was imported and used as a currency for trading purposes. At that time Larin was also used as currency in India, Ceylon, and far eastern countries. The modern **Maldivian rufiyaa** came into circulation in 1947 replacing the Sri Lankan rupee at a value of 1 to 1. Initially, the change applied only to the rufiyaa's banknotes. Today the most common forms of rufiyaa are Rf 1, Rf 2, Rf 5, Rf 10, Rf 25, and Rf 50 denomination coins. Popular forms of rufiyaa banknotes are Rf 5, Rf 10, Rf 20, Rf 50, Rf 100, Rf 100, and Rf 500 denominations"},countries_accepting:{desc_1:"The **Maldivian rufiyaa** currency is only accepted in the Maldives.",list:[],desc_2:""},amount_for_trip:{desc:"For a 7 days trip to the Maldives, you may need an average of Rf 50, 208 to Rf 58, 576. 1 **Maldivian rufiyaa to Indian rupee** equals `inr_exchange_rate` INR. It means one week's trip to Maldives may cost you between INR2, 70, 000 to INR 3, 15, 000. It includes airfare, transfers, meals, sightseeing and stays, etc. **Maldivian rufiyaa** is a non-convertible currency, you can not **buy** **Maldivian rufiyaa** in advance. Moreover, USD is accepted as a legal tender throughout the Maldives so if you are travelling from the US you do not need to visit the **Maldivian rufiyaa currency exchange**. If you carry US dollars anyhow, you can use them in the Maldives. If you are going to use USD for transactions, make sure you do not carry defaced or old notes because some businesses may not accept that. Also, the change you will get back will be Rufiyaa not dollars.\n\n &nbsp; \n\nThe **Maldivian rufiyaa exchange rate** depends on where you are exchanging your money. You can buy or **sell Maldivian rufiyaa** or exchange currency at the airport Bank of Maldives Foreign Exchange counter. This is dedicated to the foreign exchange counter only. You can also make transactions by using **Maldivian rufiyaa forex cards**, credit cards, or debit cards by paying some additional taxes. Before you head out for the Maldives make sure you check the **live Maldivian rufiyaa rate** and foreign exchange in order to get the best advice."},identification:{list:["Modern rufiyaa notes are illustrated with symbols and scenes representing the history and culture of Maldives. For example, the Rf 5 note features people playing soccer, the popular pastime in the Maldives. The Rf 10 note features women and men dancing and playing the drums. The Rf 100 note depicts local people wearing traditional clothes. The security features in Maldivian rufiyaa banknotes can be checked by look, feel and tilt method. The notes feel different from counterfeits and they do not tear easily.","The substrate for all rufiyaa banknotes is a polymer.","All the banknotes are identical in size 150mm, and 70mm.","The prefix of the vertical serial number of the note is a Dhivehi letter.","The prefix of the horizontal serial number is an English letter."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Maldivian Rufiyaa**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Maldivian Rufiyaa to USD**, **INR to Maldivian Rufiyaa** or **Maldivian Rufiyaa to Euro**, you only need to follow the below-written steps:"}}},{id:94,internalName:"seo_currency_page_fiji-dollar",type:"seo_currency_page_fiji-dollar",data:{name:"Fiji Dollar",code:"FJD",country_code:"FJ",travel_country:"Fiji",keywords:"Fiji dollar, Fiji dollar rate, fiji dollar rate in india, fiji dollar conversion, new fiji dollar notes, Fiji dollar to rupee, Fiji dollar to indian rupee, fiji dollar to inr, 1 fiji dollar to inr, fiji dollar to euro, fiji dollar to aud, Fiji dollar exchange rate, Fiji dollar currency exchange, buy Fiji dollar, sell Fiji dollar, Fiji dollar forex cards, live Fiji dollar rate, Fiji dollar price",about:{title_text:"The Currency of the Republic of Fiji",desc:"**Fiji Dollar** is the official currency of Fiji, an archipelago nation with more than 300 islands. The **Fiji Dollar symbol** is $. FJ$ is used as the **Fiji Dollar symbol** in order to distinguish it from the US dollar. The **Fiji dollar** is broken into 100 cents. The selection of the dollar was inspired by the reduced value of the new unit corresponding to the value of USD rather than the pound sterling. The **Fiji Dollar price** may go up and down from time to time so you need to be aware of the price in order to buy or **sell Fiji Dollar**.\n\n &nbsp; \n\nThe modern **Fiji Dollar conversion** has been in circulation since 1969, after its independence from Britain. The **Fiji Dollar rate in India** is INR `inr_exchange_rate`. In case you are planning to visit Fiji from India you should check the value of **1 Fiji Dollar to INR**. You should be aware of the **Fiji Dollar price** and the **Fiji Dollar currency exchange** rate. The value of 1 **Fiji Dollar to AUD** equals o.67 Australian Dollars and the value of 1 **Fiji Dollar to Euro** equals 0.43 Euro."},quick_facts:{facts:{Country_of_Origin:"Fiji",Symbol:"FJ$",Currency_Code:"FJD",Nick_Names:"-",Minor_units:"Cent","Denominations_(Banknotes)":"FJ$ 2, FJ$ 5, FJ$ 10, FJ$ 20, FJ$ 50, FJ$ 100",Motto:"-",Identification_Feature:"-",Issuing_Bank:"Reserve Bank of Fiji",In_Circulation_Since:"1969"}},history:{desc:"Typically, the **Fiji dollar** was introduced in 1867 and it was used until 1873. Later in 1969 **new Fiji Dollar notes** were introduced with values of 1, 5, 10, and 20 cents. The **Fiji dollar** had the same dimensions and materials as the Australian Dollar. In 1974, the Central Monetary Authority was chosen as the official producer of paper money. In 1987, the Reserve Bank of Fiji began issuing **Fiji Dollar banknotes**. In 1995, the FJ$ 1 bill was replaced with the coin currency and the FJ$ 50 note was introduced.\n\n &nbsp; \n\nThe Reserve Bank of Fiji, the year 2006, announced the **new Fiji Dollar notes** which were plastic-coated notes featuring images of culture, local people, industry, and trade. Later in 2007, the bank introduced FJ$ 100 banknotes. In 2009, the circulation of the two smallest coins was removed and smaller coins of 5, 10, 20, and 50 cents were minted. In 2013, the series of **Fiji Dollar** currencies was renewed completely, adding a 2-dollar currency to the monetary cone. They have on their obverse as a motif the fauna of the islands in replacement of the bust of Queen Elizabeth II."},countries_accepting:{desc_1:"Fiji Dollar is used in Fiji.",list:[],desc_2:""},amount_for_trip:{desc:"The amount of **Fiji Dollars** you should carry for a Fiji trip depends on the level of comfort you want to experience. You may need about per day FJ$ 360 to FJ$ 400 per person if you have a limited budget. If you are planning a midrange trip you may need around FJ$ 400 to FJ$ 700 per day. For a luxury trip per person, you may need to spend an average of FJ$ 800 onwards per day. If you are living in India make sure you check the **Fiji Dollar rate in India** and the conversion fee in **Fiji Dollar conversion** before you leave for Fiji.\n\n &nbsp; \n\nAt airport exchange offices and hotels then you may have to pay a higher **Fiji Dollar exchange rate** in order to convert **Fiji Dollar to rupee**. If you are looking to convert **Fiji Dollar to Indian rupee** at a reasonable and **live Fiji Dollar rate** you can consider Banks for conversion. If you are travelling from the US you can use US Dollars at certain places in Fiji. Still, it’s the best option to exchange dollars for use in street shops and restaurants, etc. Generally, it's cheaper to **buy Fiji Dollar** before you leave Australia. **Fiji Dollar Forex Cards** can also be used for transactions in Fiji."},identification:{list:["The Reserve Bank of Fiji reveals that they have observed the counterfeits are of poor quality and can be distinguished easily with a quick examination. Counterfeit Fiji Banknotes can be easily detected through basic security features. For FJ$ 1, the counterfeit seals may have blunt, uneven, or broken saw-tooth points. In the real bill, the fine lines are unbroken and clear. Moreover, on the genuine bill, the serial numbers are evenly placed and have distinctive styles.","**Security threads for FJ$ 10, FJ$ 20, FJ$ 50, and FJ$ 100**:Hold the **Fiji Dollar** notes against the light and see the watermark of an iTaukei man and the denomination. You can see the thread appearing as a continuous line with the letters RBF, the RBF logo, and the domination numeral mentioned on the thread. The thread appears as metallic dashes.","**Foil for FJ$ 10**:The note features a foil with a star printed on it. Tilt the note and see a movement inside the star.","**Holographic Stripes FJ$ 50 and 100**:In 50 and 100 **Fiji Dollar** notes the front side features a dual-image holographic stripe. When you tilt the note to different angles you can see the Fiji Coat of Arms, the letters RBF, the RBF logo, the denomination numeral, and flora and fauna decorations. You can also see the thread displays bright colours as you tilt the note."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Fiji Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Fiji Dollar to USD, INR to Fiji Dollar** or **Fiji Dollar to Euro**, you only need to follow the below-written steps:"}}},{id:95,internalName:"seo_currency_page_bahamian-dollar",type:"seo_currency_page_bahamian-dollar",data:{name:"Bahamian Dollar",code:"BSD",country_code:"BS",travel_country:"the Bahamas",keywords:"Bahamian Dollar, Bahamian Dollar symbol, bahamian Dollar country, bahamian Dollar value, bahamian Dollar to inr, bahamian Dollar to cad, bahamian Dollar to naira, bahamian Dollar to usd, bahamian Dollar to gbp, Bahamian Dollar exchange rate, Bahamian Dollar currency exchange, buy Bahamian Dollar, sell Bahamian Dollar, Bahamian Dollar forex cards, live Bahamian Dollar rate, Bahamian Dollar price",about:{title_text:"The official currency of the Bahamas",desc:"The **Bahamian Dollar** **country** is the Bahamas. It is the national currency of the Commonwealth of Bahamas and also the official currency of the Caicos, and Turks Islands. The **Bahamian Dollar symbol** is B$ and the code is BSD. The other currency accepted in the Bahamas is the US Dollar. The **Bahamian Dollar symbol** B$ distinguishes the currency from US $. The **Bahamian Dollar** is made of 100 cents and pegged on a 1-to-1 basis to the US Dollar.\n\n &nbsp; \n\nTypically the **Bahamian Dollar** **value** is at parity with the US Dollar exchange rate. The Central Bank of the Bahamas aims to uphold stability in order to keep equivalence between the **Bahamian Dollar** and the US Dollar. The Central Bank of Bahamas issues the banknotes in denominations of B$ 0.50, B$1, B$5, B$10, B$20, B$ 50, and B$ 100. The coins come in denominations from 1 cent to 1 Dollar. All of the **Bahamian Dollar Currency** banknotes have been undergoing various changes over recent years to prevent forgery.\n\n &nbsp; \n\nThe **Bahamian Dollar country** banknotes depict prominent figures and scenes from the culture and history of the Bahamas. These include important places including the headquarters of the Central Bank of the Bahamas and Nassau Harbour as well as the politicians such as Sir Lynden O. Pindling (independence leader).\n\n &nbsp; \n\n**Bahamian Dollar price** in other currencies,1 **Bahamian Dollar to INR** equals `inr_exchange_rate`Indian Rupees.1 **Bahamian Dollar to CAD** equals 1.35 Canadian Dollars. 1 **Bahamian Dollar to Naira** equals 446.08 Nigerian Naira. 1 **Bahamian Dollar to USD** equals 1.00 US Dollars which means the **Bahamian Dollar value** is similar to USD. 1 **Bahamian Dollar to GBP** equals 0.83 Pound Sterling."},quick_facts:{facts:{Country_of_Origin:"Bahamas",Symbol:"B$",Currency_Code:"BSD",Nick_Names:"-",Minor_units:"Cent","Denominations_(Banknotes)":"B$ 1/2, B$ 1, B$ 3, B$ 5, B$ 10, B$ 20, B$ 50, and B$ 100",Motto:"-",Identification_Feature:"-",Issuing_Bank:"Central Bank of the Bahamas",In_Circulation_Since:"1966"}},history:{desc:"After the Second World War, the British government started losing its colonial empire. In 1964, the Bahamas turned into self-governing. Later in 1966, the Bahamas issued the **Bahamian Dollar**. The Bahamas got completely independent in 1973. At that time, the **Bahamian Dollar** replaced the pound. It was done at a rate of 1 Dollar to 7 British Shillings. This rate permitted the establishment of parity with the US Dollar. In 2020, the Bahamas became the very first country to own a legal digital currency as it introduced the Sand Dollar as an alternative to the traditional currency. **Bahamian Dollar value** is the same as Sand Dollar and the only difference is the digital format."},countries_accepting:{desc_1:"Bahamas, Turks and Caicos Islands accept **Bahamian Dollars**. You can also use **Bahamian Dollar forex cards** for transactions in these countries. Make sure you check with the **live Bahamian Dollar rate** while exchanging your currency.",list:[],desc_2:""},amount_for_trip:{desc:"You can use US Dollars for transactions in addition to the **Bahamian Dollar currency exchange** in the Bahamas. Both currencies are tied and hold exactly the same value so both are interchangeable in the Bahamas. In the Bahamas, the casinos only accept US Dollars through their in-house ATMs that dispense American Currency. You can easily find the ATMs throughout the island that are dispensing Bahamian Dollars.\n\n &nbsp; \n\nBased on the average trip expenses you may need around B$ 200 per day during a trip to the Bahamas. It includes meals and local transportation. The average hotel rate in the Bahamas is around B$ 197. So a one-week trip for two people may cost around B$ 2794. So check the **Bahamian Dollar exchange rate** with your bank and get the amount accordingly.\n\n &nbsp; \n\nYou can **buy Bahamian Dollar** as much or as little as you want. If you still have some Bahamian Dollars at the end of your trip, it's better to spend or **sell Bahamian Dollar** because exchanging them back once you are home is mostly not an option. However, people are restricted to exit the Bahamas with more than B$ 200."},identification:{list:["Each **Bahamian Dollar currency** banknote has diverse features to distinguish. B$ 0.50, B$ 10, and B$ 100 banknotes all have the image of Queen Elizabeth II","Other people featured on **Bahamian Dollar Banknotes** include Roland Theodore Symonette and Milo Butler, the political figures of the Bahamas. The watermarks on **Bahamian Dollar currency** are printed as electrotypes, which specially incise the banknotes.","The watermarks on the **Bahamian Dollar** include national landmarks like Nassau Harbor and The Central Bank of Bahamas building. B$ 100 banknotes also feature blue marlin, one of the national animals of the Bahamas."]},how_to_buy:{desc:"Whether you want to buy forex cards and currency notes or sell the **Bahamian Dollar**, MakeMyTrip makes the entire process quite easy. It doesn’t matter whether you want to convert the **Bahamian Dollar to USD, INR to Bahamian Dollar** or **Bahamian Dollar to Euro**, you only need to follow the below-written steps:"}}}];
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyPageTemplate/index.tsx


;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ActiveLink/index.tsx


var ActiveLink_excluded = ["children", "href"];

function ActiveLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ActiveLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ActiveLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ActiveLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function ActiveLink_ActiveLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ActiveLink_excluded);

  var _useState = (0,react.useState)("normal"),
      fontWeight = _useState[0],
      setFontWeight = _useState[1];

  (0,react.useEffect)(function () {
    var fontWeight = window.location.href.indexOf(href.replace("/", "")) !== -1 ? 800 : "normal";
    setFontWeight(fontWeight);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", ActiveLink_objectSpread(ActiveLink_objectSpread({
    href: href
  }, rest), {}, {
    style: {
      fontWeight: fontWeight
    },
    children: children
  }));
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/NewRelicSnippet/index.tsx


var NewRelicSnippet = function NewRelicSnippet(_ref) {
  var _ref$isProd = _ref.isProd,
      isProd = _ref$isProd === void 0 ? false : _ref$isProd;
  return isProd ? /*#__PURE__*/_jsx("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: ";window.NREUM||(NREUM={});NREUM.init={distributed_tracing:{enabled:true},privacy:{cookies_enabled:true},ajax:{deny_list:[\"bam.nr-data.net\"]}};\n      \n    ;NREUM.loader_config={accountID:\"75783\",trustKey:\"2096051\",agentID:\"718335454\",licenseKey:\"ae504947bb\",applicationID:\"718335454\"}\n    ;NREUM.info={beacon:\"bam.nr-data.net\",errorBeacon:\"bam.nr-data.net\",licenseKey:\"ae504947bb\",applicationID:\"718335454\",sa:1}\n    window.NREUM||(NREUM={}),__nr_require=function(t,e,n){function r(n){if(!e[n]){var o=e[n]={exports:{}};t[n][0].call(o.exports,function(e){var o=t[n][1][e];return r(o||e)},o,o.exports)}return e[n].exports}if(\"function\"==typeof __nr_require)return __nr_require;for(var o=0;o<n.length;o++)r(n[o]);return r}({1:[function(t,e,n){function r(t){try{s.console&&console.log(t)}catch(e){}}var o,i=t(\"ee\"),a=t(31),s={};try{o=localStorage.getItem(\"__nr_flags\").split(\",\"),console&&\"function\"==typeof console.log&&(s.console=!0,o.indexOf(\"dev\")!==-1&&(s.dev=!0),o.indexOf(\"nr_dev\")!==-1&&(s.nrDev=!0))}catch(c){}s.nrDev&&i.on(\"internal-error\",function(t){r(t.stack)}),s.dev&&i.on(\"fn-err\",function(t,e,n){r(n.stack)}),s.dev&&(r(\"NR AGENT IN DEVELOPMENT MODE\"),r(\"flags: \"+a(s,function(t,e){return t}).join(\", \")))},{}],2:[function(t,e,n){function r(t,e,n,r,s){try{l?l-=1:o(s||new UncaughtException(t,e,n),!0)}catch(f){try{i(\"ierr\",[f,c.now(),!0])}catch(d){}}return\"function\"==typeof u&&u.apply(this,a(arguments))}function UncaughtException(t,e,n){this.message=t||\"Uncaught error with no additional information\",this.sourceURL=e,this.line=n}function o(t,e){var n=e?null:c.now();i(\"err\",[t,n])}var i=t(\"handle\"),a=t(32),s=t(\"ee\"),c=t(\"loader\"),f=t(\"gos\"),u=window.onerror,d=!1,p=\"nr@seenError\";if(!c.disabled){var l=0;c.features.err=!0,t(1),window.onerror=r;try{throw new Error}catch(h){\"stack\"in h&&(t(14),t(13),\"addEventListener\"in window&&t(7),c.xhrWrappable&&t(15),d=!0)}s.on(\"fn-start\",function(t,e,n){d&&(l+=1)}),s.on(\"fn-err\",function(t,e,n){d&&!n[p]&&(f(n,p,function(){return!0}),this.thrown=!0,o(n))}),s.on(\"fn-end\",function(){d&&!this.thrown&&l>0&&(l-=1)}),s.on(\"internal-error\",function(t){i(\"ierr\",[t,c.now(),!0])})}},{}],3:[function(t,e,n){var r=t(\"loader\");r.disabled||(r.features.ins=!0)},{}],4:[function(t,e,n){function r(){U++,L=g.hash,this[u]=y.now()}function o(){U--,g.hash!==L&&i(0,!0);var t=y.now();this[h]=~~this[h]+t-this[u],this[d]=t}function i(t,e){E.emit(\"newURL\",[\"\"+g,e])}function a(t,e){t.on(e,function(){this[e]=y.now()})}var s=\"-start\",c=\"-end\",f=\"-body\",u=\"fn\"+s,d=\"fn\"+c,p=\"cb\"+s,l=\"cb\"+c,h=\"jsTime\",m=\"fetch\",v=\"addEventListener\",w=window,g=w.location,y=t(\"loader\");if(w[v]&&y.xhrWrappable&&!y.disabled){var x=t(11),b=t(12),E=t(9),R=t(7),O=t(14),T=t(8),S=t(15),P=t(10),M=t(\"ee\"),C=M.get(\"tracer\"),N=t(23);t(17),y.features.spa=!0;var L,U=0;M.on(u,r),b.on(p,r),P.on(p,r),M.on(d,o),b.on(l,o),P.on(l,o),M.buffer([u,d,\"xhr-resolved\"]),R.buffer([u]),O.buffer([\"setTimeout\"+c,\"clearTimeout\"+s,u]),S.buffer([u,\"new-xhr\",\"send-xhr\"+s]),T.buffer([m+s,m+\"-done\",m+f+s,m+f+c]),E.buffer([\"newURL\"]),x.buffer([u]),b.buffer([\"propagate\",p,l,\"executor-err\",\"resolve\"+s]),C.buffer([u,\"no-\"+u]),P.buffer([\"new-jsonp\",\"cb-start\",\"jsonp-error\",\"jsonp-end\"]),a(T,m+s),a(T,m+\"-done\"),a(P,\"new-jsonp\"),a(P,\"jsonp-end\"),a(P,\"cb-start\"),E.on(\"pushState-end\",i),E.on(\"replaceState-end\",i),w[v](\"hashchange\",i,N(!0)),w[v](\"load\",i,N(!0)),w[v](\"popstate\",function(){i(0,U>1)},N(!0))}},{}],5:[function(t,e,n){function r(){var t=new PerformanceObserver(function(t,e){var n=t.getEntries();s(v,[n])});try{t.observe({entryTypes:[\"resource\"]})}catch(e){}}function o(t){if(s(v,[window.performance.getEntriesByType(w)]),window.performance[\"c\"+p])try{window.performance[h](m,o,!1)}catch(t){}else try{window.performance[h](\"webkit\"+m,o,!1)}catch(t){}}function i(t){}if(window.performance&&window.performance.timing&&window.performance.getEntriesByType){var a=t(\"ee\"),s=t(\"handle\"),c=t(14),f=t(13),u=t(6),d=t(23),p=\"learResourceTimings\",l=\"addEventListener\",h=\"removeEventListener\",m=\"resourcetimingbufferfull\",v=\"bstResource\",w=\"resource\",g=\"-start\",y=\"-end\",x=\"fn\"+g,b=\"fn\"+y,E=\"bstTimer\",R=\"pushState\",O=t(\"loader\");if(!O.disabled){O.features.stn=!0,t(9),\"addEventListener\"in window&&t(7);var T=NREUM.o.EV;a.on(x,function(t,e){var n=t[0];n instanceof T&&(this.bstStart=O.now())}),a.on(b,function(t,e){var n=t[0];n instanceof T&&s(\"bst\",[n,e,this.bstStart,O.now()])}),c.on(x,function(t,e,n){this.bstStart=O.now(),this.bstType=n}),c.on(b,function(t,e){s(E,[e,this.bstStart,O.now(),this.bstType])}),f.on(x,function(){this.bstStart=O.now()}),f.on(b,function(t,e){s(E,[e,this.bstStart,O.now(),\"requestAnimationFrame\"])}),a.on(R+g,function(t){this.time=O.now(),this.startPath=location.pathname+location.hash}),a.on(R+y,function(t){s(\"bstHist\",[location.pathname+location.hash,this.startPath,this.time])}),u()?(s(v,[window.performance.getEntriesByType(\"resource\")]),r()):l in window.performance&&(window.performance[\"c\"+p]?window.performance[l](m,o,d(!1)):window.performance[l](\"webkit\"+m,o,d(!1))),document[l](\"scroll\",i,d(!1)),document[l](\"keypress\",i,d(!1)),document[l](\"click\",i,d(!1))}}},{}],6:[function(t,e,n){e.exports=function(){return\"PerformanceObserver\"in window&&\"function\"==typeof window.PerformanceObserver}},{}],7:[function(t,e,n){function r(t){for(var e=t;e&&!e.hasOwnProperty(u);)e=Object.getPrototypeOf(e);e&&o(e)}function o(t){s.inPlace(t,[u,d],\"-\",i)}function i(t,e){return t[1]}var a=t(\"ee\").get(\"events\"),s=t(\"wrap-function\")(a,!0),c=t(\"gos\"),f=XMLHttpRequest,u=\"addEventListener\",d=\"removeEventListener\";e.exports=a,\"getPrototypeOf\"in Object?(r(document),r(window),r(f.prototype)):f.prototype.hasOwnProperty(u)&&(o(window),o(f.prototype)),a.on(u+\"-start\",function(t,e){var n=t[1];if(null!==n&&(\"function\"==typeof n||\"object\"==typeof n)){var r=c(n,\"nr@wrapped\",function(){function t(){if(\"function\"==typeof n.handleEvent)return n.handleEvent.apply(n,arguments)}var e={object:t,\"function\":n}[typeof n];return e?s(e,\"fn-\",null,e.name||\"anonymous\"):n});this.wrapped=t[1]=r}}),a.on(d+\"-start\",function(t){t[1]=this.wrapped||t[1]})},{}],8:[function(t,e,n){function r(t,e,n){var r=t[e];\"function\"==typeof r&&(t[e]=function(){var t=i(arguments),e={};o.emit(n+\"before-start\",[t],e);var a;e[m]&&e[m].dt&&(a=e[m].dt);var s=r.apply(this,t);return o.emit(n+\"start\",[t,a],s),s.then(function(t){return o.emit(n+\"end\",[null,t],s),t},function(t){throw o.emit(n+\"end\",[t],s),t})})}var o=t(\"ee\").get(\"fetch\"),i=t(32),a=t(31);e.exports=o;var s=window,c=\"fetch-\",f=c+\"body-\",u=[\"arrayBuffer\",\"blob\",\"json\",\"text\",\"formData\"],d=s.Request,p=s.Response,l=s.fetch,h=\"prototype\",m=\"nr@context\";d&&p&&l&&(a(u,function(t,e){r(d[h],e,f),r(p[h],e,f)}),r(s,\"fetch\",c),o.on(c+\"end\",function(t,e){var n=this;if(e){var r=e.headers.get(\"content-length\");null!==r&&(n.rxSize=r),o.emit(c+\"done\",[null,e],n)}else o.emit(c+\"done\",[t],n)}))},{}],9:[function(t,e,n){var r=t(\"ee\").get(\"history\"),o=t(\"wrap-function\")(r);e.exports=r;var i=window.history&&window.history.constructor&&window.history.constructor.prototype,a=window.history;i&&i.pushState&&i.replaceState&&(a=i),o.inPlace(a,[\"pushState\",\"replaceState\"],\"-\")},{}],10:[function(t,e,n){function r(t){function e(){f.emit(\"jsonp-end\",[],l),t.removeEventListener(\"load\",e,c(!1)),t.removeEventListener(\"error\",n,c(!1))}function n(){f.emit(\"jsonp-error\",[],l),f.emit(\"jsonp-end\",[],l),t.removeEventListener(\"load\",e,c(!1)),t.removeEventListener(\"error\",n,c(!1))}var r=t&&\"string\"==typeof t.nodeName&&\"script\"===t.nodeName.toLowerCase();if(r){var o=\"function\"==typeof t.addEventListener;if(o){var a=i(t.src);if(a){var d=s(a),p=\"function\"==typeof d.parent[d.key];if(p){var l={};u.inPlace(d.parent,[d.key],\"cb-\",l),t.addEventListener(\"load\",e,c(!1)),t.addEventListener(\"error\",n,c(!1)),f.emit(\"new-jsonp\",[t.src],l)}}}}}function o(){return\"addEventListener\"in window}function i(t){var e=t.match(d);return e?e[1]:null}function a(t,e){var n=t.match(l),r=n[1],o=n[3];return o?a(o,e[r]):e[r]}function s(t){var e=t.match(p);return e&&e.length>=3?{key:e[2],parent:a(e[1],window)}:{key:t,parent:window}}var c=t(23),f=t(\"ee\").get(\"jsonp\"),u=t(\"wrap-function\")(f);if(e.exports=f,o()){var d=/[?&](?:callback|cb)=([^&#]+)/,p=/(.*)\\.([^.]+)/,l=/^(\\w+)(\\.|$)(.*)$/,h=[\"appendChild\",\"insertBefore\",\"replaceChild\"];Node&&Node.prototype&&Node.prototype.appendChild?u.inPlace(Node.prototype,h,\"dom-\"):(u.inPlace(HTMLElement.prototype,h,\"dom-\"),u.inPlace(HTMLHeadElement.prototype,h,\"dom-\"),u.inPlace(HTMLBodyElement.prototype,h,\"dom-\")),f.on(\"dom-start\",function(t){r(t[0])})}},{}],11:[function(t,e,n){var r=t(\"ee\").get(\"mutation\"),o=t(\"wrap-function\")(r),i=NREUM.o.MO;e.exports=r,i&&(window.MutationObserver=function(t){return this instanceof i?new i(o(t,\"fn-\")):i.apply(this,arguments)},MutationObserver.prototype=i.prototype)},{}],12:[function(t,e,n){function r(t){var e=i.context(),n=s(t,\"executor-\",e,null,!1),r=new f(n);return i.context(r).getCtx=function(){return e},r}var o=t(\"wrap-function\"),i=t(\"ee\").get(\"promise\"),a=t(\"ee\").getOrSetContext,s=o(i),c=t(31),f=NREUM.o.PR;e.exports=i,f&&(window.Promise=r,[\"all\",\"race\"].forEach(function(t){var e=f[t];f[t]=function(n){function r(t){return function(){i.emit(\"propagate\",[null,!o],a,!1,!1),o=o||!t}}var o=!1;c(n,function(e,n){Promise.resolve(n).then(r(\"all\"===t),r(!1))});var a=e.apply(f,arguments),s=f.resolve(a);return s}}),[\"resolve\",\"reject\"].forEach(function(t){var e=f[t];f[t]=function(t){var n=e.apply(f,arguments);return t!==n&&i.emit(\"propagate\",[t,!0],n,!1,!1),n}}),f.prototype[\"catch\"]=function(t){return this.then(null,t)},f.prototype=Object.create(f.prototype,{constructor:{value:r}}),c(Object.getOwnPropertyNames(f),function(t,e){try{r[e]=f[e]}catch(n){}}),o.wrapInPlace(f.prototype,\"then\",function(t){return function(){var e=this,n=o.argsToArray.apply(this,arguments),r=a(e);r.promise=e,n[0]=s(n[0],\"cb-\",r,null,!1),n[1]=s(n[1],\"cb-\",r,null,!1);var c=t.apply(this,n);return r.nextPromise=c,i.emit(\"propagate\",[e,!0],c,!1,!1),c}}),i.on(\"executor-start\",function(t){t[0]=s(t[0],\"resolve-\",this,null,!1),t[1]=s(t[1],\"resolve-\",this,null,!1)}),i.on(\"executor-err\",function(t,e,n){t[1](n)}),i.on(\"cb-end\",function(t,e,n){i.emit(\"propagate\",[n,!0],this.nextPromise,!1,!1)}),i.on(\"propagate\",function(t,e,n){this.getCtx&&!e||(this.getCtx=function(){if(t instanceof Promise)var e=i.context(t);return e&&e.getCtx?e.getCtx():this})}),r.toString=function(){return\"\"+f})},{}],13:[function(t,e,n){var r=t(\"ee\").get(\"raf\"),o=t(\"wrap-function\")(r),i=\"equestAnimationFrame\";e.exports=r,o.inPlace(window,[\"r\"+i,\"mozR\"+i,\"webkitR\"+i,\"msR\"+i],\"raf-\"),r.on(\"raf-start\",function(t){t[0]=o(t[0],\"fn-\")})},{}],14:[function(t,e,n){function r(t,e,n){t[0]=a(t[0],\"fn-\",null,n)}function o(t,e,n){this.method=n,this.timerDuration=isNaN(t[1])?0:+t[1],t[0]=a(t[0],\"fn-\",this,n)}var i=t(\"ee\").get(\"timer\"),a=t(\"wrap-function\")(i),s=\"setTimeout\",c=\"setInterval\",f=\"clearTimeout\",u=\"-start\",d=\"-\";e.exports=i,a.inPlace(window,[s,\"setImmediate\"],s+d),a.inPlace(window,[c],c+d),a.inPlace(window,[f,\"clearImmediate\"],f+d),i.on(c+u,r),i.on(s+u,o)},{}],15:[function(t,e,n){function r(t,e){d.inPlace(e,[\"onreadystatechange\"],\"fn-\",s)}function o(){var t=this,e=u.context(t);t.readyState>3&&!e.resolved&&(e.resolved=!0,u.emit(\"xhr-resolved\",[],t)),d.inPlace(t,y,\"fn-\",s)}function i(t){x.push(t),m&&(E?E.then(a):w?w(a):(R=-R,O.data=R))}function a(){for(var t=0;t<x.length;t++)r([],x[t]);x.length&&(x=[])}function s(t,e){return e}function c(t,e){for(var n in t)e[n]=t[n];return e}t(7);var f=t(\"ee\"),u=f.get(\"xhr\"),d=t(\"wrap-function\")(u),p=t(23),l=NREUM.o,h=l.XHR,m=l.MO,v=l.PR,w=l.SI,g=\"readystatechange\",y=[\"onload\",\"onerror\",\"onabort\",\"onloadstart\",\"onloadend\",\"onprogress\",\"ontimeout\"],x=[];e.exports=u;var b=window.XMLHttpRequest=function(t){var e=new h(t);try{u.emit(\"new-xhr\",[e],e),e.addEventListener(g,o,p(!1))}catch(n){try{u.emit(\"internal-error\",[n])}catch(r){}}return e};if(c(h,b),b.prototype=h.prototype,d.inPlace(b.prototype,[\"open\",\"send\"],\"-xhr-\",s),u.on(\"send-xhr-start\",function(t,e){r(t,e),i(e)}),u.on(\"open-xhr-start\",r),m){var E=v&&v.resolve();if(!w&&!v){var R=1,O=document.createTextNode(R);new m(a).observe(O,{characterData:!0})}}else f.on(\"fn-end\",function(t){t[0]&&t[0].type===g||a()})},{}],16:[function(t,e,n){function r(t){if(!s(t))return null;var e=window.NREUM;if(!e.loader_config)return null;var n=(e.loader_config.accountID||\"\").toString()||null,r=(e.loader_config.agentID||\"\").toString()||null,f=(e.loader_config.trustKey||\"\").toString()||null;if(!n||!r)return null;var h=l.generateSpanId(),m=l.generateTraceId(),v=Date.now(),w={spanId:h,traceId:m,timestamp:v};return(t.sameOrigin||c(t)&&p())&&(w.traceContextParentHeader=o(h,m),w.traceContextStateHeader=i(h,v,n,r,f)),(t.sameOrigin&&!u()||!t.sameOrigin&&c(t)&&d())&&(w.newrelicHeader=a(h,m,v,n,r,f)),w}function o(t,e){return\"00-\"+e+\"-\"+t+\"-01\"}function i(t,e,n,r,o){var i=0,a=\"\",s=1,c=\"\",f=\"\";return o+\"@nr=\"+i+\"-\"+s+\"-\"+n+\"-\"+r+\"-\"+t+\"-\"+a+\"-\"+c+\"-\"+f+\"-\"+e}function a(t,e,n,r,o,i){var a=\"btoa\"in window&&\"function\"==typeof window.btoa;if(!a)return null;var s={v:[0,1],d:{ty:\"Browser\",ac:r,ap:o,id:t,tr:e,ti:n}};return i&&r!==i&&(s.d.tk=i),btoa(JSON.stringify(s))}function s(t){return f()&&c(t)}function c(t){var e=!1,n={};if(\"init\"in NREUM&&\"distributed_tracing\"in NREUM.init&&(n=NREUM.init.distributed_tracing),t.sameOrigin)e=!0;else if(n.allowed_origins instanceof Array)for(var r=0;r<n.allowed_origins.length;r++){var o=h(n.allowed_origins[r]);if(t.hostname===o.hostname&&t.protocol===o.protocol&&t.port===o.port){e=!0;break}}return e}function f(){return\"init\"in NREUM&&\"distributed_tracing\"in NREUM.init&&!!NREUM.init.distributed_tracing.enabled}function u(){return\"init\"in NREUM&&\"distributed_tracing\"in NREUM.init&&!!NREUM.init.distributed_tracing.exclude_newrelic_header}function d(){return\"init\"in NREUM&&\"distributed_tracing\"in NREUM.init&&NREUM.init.distributed_tracing.cors_use_newrelic_header!==!1}function p(){return\"init\"in NREUM&&\"distributed_tracing\"in NREUM.init&&!!NREUM.init.distributed_tracing.cors_use_tracecontext_headers}var l=t(28),h=t(18);e.exports={generateTracePayload:r,shouldGenerateTrace:s}},{}],17:[function(t,e,n){function r(t){var e=this.params,n=this.metrics;if(!this.ended){this.ended=!0;for(var r=0;r<p;r++)t.removeEventListener(d[r],this.listener,!1);return e.protocol&&\"data\"===e.protocol?void g(\"Ajax/DataUrl/Excluded\"):void(e.aborted||(n.duration=a.now()-this.startTime,this.loadCaptureCalled||4!==t.readyState?null==e.status&&(e.status=0):i(this,t),n.cbTime=this.cbTime,s(\"xhr\",[e,n,this.startTime,this.endTime,\"xhr\"],this)))}}function o(t,e){var n=c(e),r=t.params;r.hostname=n.hostname,r.port=n.port,r.protocol=n.protocol,r.host=n.hostname+\":\"+n.port,r.pathname=n.pathname,t.parsedOrigin=n,t.sameOrigin=n.sameOrigin}function i(t,e){t.params.status=e.status;var n=v(e,t.lastSize);if(n&&(t.metrics.rxSize=n),t.sameOrigin){var r=e.getResponseHeader(\"X-NewRelic-App-Data\");r&&(t.params.cat=r.split(\", \").pop())}t.loadCaptureCalled=!0}var a=t(\"loader\");if(a.xhrWrappable&&!a.disabled){var s=t(\"handle\"),c=t(18),f=t(16).generateTracePayload,u=t(\"ee\"),d=[\"load\",\"error\",\"abort\",\"timeout\"],p=d.length,l=t(\"id\"),h=t(24),m=t(22),v=t(19),w=t(23),g=t(25).recordSupportability,y=NREUM.o.REQ,x=window.XMLHttpRequest;a.features.xhr=!0,t(15),t(8),u.on(\"new-xhr\",function(t){var e=this;e.totalCbs=0,e.called=0,e.cbTime=0,e.end=r,e.ended=!1,e.xhrGuids={},e.lastSize=null,e.loadCaptureCalled=!1,e.params=this.params||{},e.metrics=this.metrics||{},t.addEventListener(\"load\",function(n){i(e,t)},w(!1)),h&&(h>34||h<10)||t.addEventListener(\"progress\",function(t){e.lastSize=t.loaded},w(!1))}),u.on(\"open-xhr-start\",function(t){this.params={method:t[0]},o(this,t[1]),this.metrics={}}),u.on(\"open-xhr-end\",function(t,e){\"loader_config\"in NREUM&&\"xpid\"in NREUM.loader_config&&this.sameOrigin&&e.setRequestHeader(\"X-NewRelic-ID\",NREUM.loader_config.xpid);var n=f(this.parsedOrigin);if(n){var r=!1;n.newrelicHeader&&(e.setRequestHeader(\"newrelic\",n.newrelicHeader),r=!0),n.traceContextParentHeader&&(e.setRequestHeader(\"traceparent\",n.traceContextParentHeader),n.traceContextStateHeader&&e.setRequestHeader(\"tracestate\",n.traceContextStateHeader),r=!0),r&&(this.dt=n)}}),u.on(\"send-xhr-start\",function(t,e){var n=this.metrics,r=t[0],o=this;if(n&&r){var i=m(r);i&&(n.txSize=i)}this.startTime=a.now(),this.listener=function(t){try{\"abort\"!==t.type||o.loadCaptureCalled||(o.params.aborted=!0),(\"load\"!==t.type||o.called===o.totalCbs&&(o.onloadCalled||\"function\"!=typeof e.onload))&&o.end(e)}catch(n){try{u.emit(\"internal-error\",[n])}catch(r){}}};for(var s=0;s<p;s++)e.addEventListener(d[s],this.listener,w(!1))}),u.on(\"xhr-cb-time\",function(t,e,n){this.cbTime+=t,e?this.onloadCalled=!0:this.called+=1,this.called!==this.totalCbs||!this.onloadCalled&&\"function\"==typeof n.onload||this.end(n)}),u.on(\"xhr-load-added\",function(t,e){var n=\"\"+l(t)+!!e;this.xhrGuids&&!this.xhrGuids[n]&&(this.xhrGuids[n]=!0,this.totalCbs+=1)}),u.on(\"xhr-load-removed\",function(t,e){var n=\"\"+l(t)+!!e;this.xhrGuids&&this.xhrGuids[n]&&(delete this.xhrGuids[n],this.totalCbs-=1)}),u.on(\"xhr-resolved\",function(){this.endTime=a.now()}),u.on(\"addEventListener-end\",function(t,e){e instanceof x&&\"load\"===t[0]&&u.emit(\"xhr-load-added\",[t[1],t[2]],e)}),u.on(\"removeEventListener-end\",function(t,e){e instanceof x&&\"load\"===t[0]&&u.emit(\"xhr-load-removed\",[t[1],t[2]],e)}),u.on(\"fn-start\",function(t,e,n){e instanceof x&&(\"onload\"===n&&(this.onload=!0),(\"load\"===(t[0]&&t[0].type)||this.onload)&&(this.xhrCbStart=a.now()))}),u.on(\"fn-end\",function(t,e){this.xhrCbStart&&u.emit(\"xhr-cb-time\",[a.now()-this.xhrCbStart,this.onload,e],e)}),u.on(\"fetch-before-start\",function(t){function e(t,e){var n=!1;return e.newrelicHeader&&(t.set(\"newrelic\",e.newrelicHeader),n=!0),e.traceContextParentHeader&&(t.set(\"traceparent\",e.traceContextParentHeader),e.traceContextStateHeader&&t.set(\"tracestate\",e.traceContextStateHeader),n=!0),n}var n,r=t[1]||{};\"string\"==typeof t[0]?n=t[0]:t[0]&&t[0].url?n=t[0].url:window.URL&&t[0]&&t[0]instanceof URL&&(n=t[0].href),n&&(this.parsedOrigin=c(n),this.sameOrigin=this.parsedOrigin.sameOrigin);var o=f(this.parsedOrigin);if(o&&(o.newrelicHeader||o.traceContextParentHeader))if(\"string\"==typeof t[0]||window.URL&&t[0]&&t[0]instanceof URL){var i={};for(var a in r)i[a]=r[a];i.headers=new Headers(r.headers||{}),e(i.headers,o)&&(this.dt=o),t.length>1?t[1]=i:t.push(i)}else t[0]&&t[0].headers&&e(t[0].headers,o)&&(this.dt=o)}),u.on(\"fetch-start\",function(t,e){this.params={},this.metrics={},this.startTime=a.now(),this.dt=e,t.length>=1&&(this.target=t[0]),t.length>=2&&(this.opts=t[1]);var n,r=this.opts||{},i=this.target;if(\"string\"==typeof i?n=i:\"object\"==typeof i&&i instanceof y?n=i.url:window.URL&&\"object\"==typeof i&&i instanceof URL&&(n=i.href),o(this,n),\"data\"!==this.params.protocol){var s=(\"\"+(i&&i instanceof y&&i.method||r.method||\"GET\")).toUpperCase();this.params.method=s,this.txSize=m(r.body)||0}}),u.on(\"fetch-done\",function(t,e){if(this.endTime=a.now(),this.params||(this.params={}),\"data\"===this.params.protocol)return void g(\"Ajax/DataUrl/Excluded\");this.params.status=e?e.status:0;var n;\"string\"==typeof this.rxSize&&this.rxSize.length>0&&(n=+this.rxSize);var r={txSize:this.txSize,rxSize:n,duration:a.now()-this.startTime};s(\"xhr\",[this.params,r,this.startTime,this.endTime,\"fetch\"],this)})}},{}],18:[function(t,e,n){var r={};e.exports=function(t){if(t in r)return r[t];if(0===(t||\"\").indexOf(\"data:\"))return{protocol:\"data\"};var e=document.createElement(\"a\"),n=window.location,o={};e.href=t,o.port=e.port;var i=e.href.split(\"://\");!o.port&&i[1]&&(o.port=i[1].split(\"/\")[0].split(\"@\").pop().split(\":\")[1]),o.port&&\"0\"!==o.port||(o.port=\"https\"===i[0]?\"443\":\"80\"),o.hostname=e.hostname||n.hostname,o.pathname=e.pathname,o.protocol=i[0],\"/\"!==o.pathname.charAt(0)&&(o.pathname=\"/\"+o.pathname);var a=!e.protocol||\":\"===e.protocol||e.protocol===n.protocol,s=e.hostname===document.domain&&e.port===n.port;return o.sameOrigin=a&&(!e.hostname||s),\"/\"===o.pathname&&(r[t]=o),o}},{}],19:[function(t,e,n){function r(t,e){var n=t.responseType;return\"json\"===n&&null!==e?e:\"arraybuffer\"===n||\"blob\"===n||\"json\"===n?o(t.response):\"text\"===n||\"\"===n||void 0===n?o(t.responseText):void 0}var o=t(22);e.exports=r},{}],20:[function(t,e,n){function r(){}function o(t,e,n,r){return function(){return u.recordSupportability(\"API/\"+e+\"/called\"),i(t+e,[f.now()].concat(s(arguments)),n?null:this,r),n?void 0:this}}var i=t(\"handle\"),a=t(31),s=t(32),c=t(\"ee\").get(\"tracer\"),f=t(\"loader\"),u=t(25),d=NREUM;\"undefined\"==typeof window.newrelic&&(newrelic=d);var p=[\"setPageViewName\",\"setCustomAttribute\",\"setErrorHandler\",\"finished\",\"addToTrace\",\"inlineHit\",\"addRelease\"],l=\"api-\",h=l+\"ixn-\";a(p,function(t,e){d[e]=o(l,e,!0,\"api\")}),d.addPageAction=o(l,\"addPageAction\",!0),d.setCurrentRouteName=o(l,\"routeName\",!0),e.exports=newrelic,d.interaction=function(){return(new r).get()};var m=r.prototype={createTracer:function(t,e){var n={},r=this,o=\"function\"==typeof e;return i(h+\"tracer\",[f.now(),t,n],r),function(){if(c.emit((o?\"\":\"no-\")+\"fn-start\",[f.now(),r,o],n),o)try{return e.apply(this,arguments)}catch(t){throw c.emit(\"fn-err\",[arguments,this,t],n),t}finally{c.emit(\"fn-end\",[f.now()],n)}}}};a(\"actionText,setName,setAttribute,save,ignore,onEnd,getContext,end,get\".split(\",\"),function(t,e){m[e]=o(h,e)}),newrelic.noticeError=function(t,e){\"string\"==typeof t&&(t=new Error(t)),u.recordSupportability(\"API/noticeError/called\"),i(\"err\",[t,f.now(),!1,e])}},{}],21:[function(t,e,n){function r(t){if(NREUM.init){for(var e=NREUM.init,n=t.split(\".\"),r=0;r<n.length-1;r++)if(e=e[n[r]],\"object\"!=typeof e)return;return e=e[n[n.length-1]]}}e.exports={getConfiguration:r}},{}],22:[function(t,e,n){e.exports=function(t){if(\"string\"==typeof t&&t.length)return t.length;if(\"object\"==typeof t){if(\"undefined\"!=typeof ArrayBuffer&&t instanceof ArrayBuffer&&t.byteLength)return t.byteLength;if(\"undefined\"!=typeof Blob&&t instanceof Blob&&t.size)return t.size;if(!(\"undefined\"!=typeof FormData&&t instanceof FormData))try{return JSON.stringify(t).length}catch(e){return}}}},{}],23:[function(t,e,n){var r=!1;try{var o=Object.defineProperty({},\"passive\",{get:function(){r=!0}});window.addEventListener(\"testPassive\",null,o),window.removeEventListener(\"testPassive\",null,o)}catch(i){}e.exports=function(t){return r?{passive:!0,capture:!!t}:!!t}},{}],24:[function(t,e,n){var r=0,o=navigator.userAgent.match(/Firefox[\\/\\s](\\d+\\.\\d+)/);o&&(r=+o[1]),e.exports=r},{}],25:[function(t,e,n){function r(t,e){var n=[a,t,{name:t},e];return i(\"storeMetric\",n,null,\"api\"),n}function o(t,e){var n=[s,t,{name:t},e];return i(\"storeEventMetrics\",n,null,\"api\"),n}var i=t(\"handle\"),a=\"sm\",s=\"cm\";e.exports={constants:{SUPPORTABILITY_METRIC:a,CUSTOM_METRIC:s},recordSupportability:r,recordCustom:o}},{}],26:[function(t,e,n){function r(){return s.exists&&performance.now?Math.round(performance.now()):(i=Math.max((new Date).getTime(),i))-a}function o(){return i}var i=(new Date).getTime(),a=i,s=t(33);e.exports=r,e.exports.offset=a,e.exports.getLastTimestamp=o},{}],27:[function(t,e,n){function r(t,e){var n=t.getEntries();n.forEach(function(t){\"first-paint\"===t.name?l(\"timing\",[\"fp\",Math.floor(t.startTime)]):\"first-contentful-paint\"===t.name&&l(\"timing\",[\"fcp\",Math.floor(t.startTime)])})}function o(t,e){var n=t.getEntries();if(n.length>0){var r=n[n.length-1];if(f&&f<r.startTime)return;var o=[r],i=a({});i&&o.push(i),l(\"lcp\",o)}}function i(t){t.getEntries().forEach(function(t){t.hadRecentInput||l(\"cls\",[t])})}function a(t){var e=navigator.connection||navigator.mozConnection||navigator.webkitConnection;if(e)return e.type&&(t[\"net-type\"]=e.type),e.effectiveType&&(t[\"net-etype\"]=e.effectiveType),e.rtt&&(t[\"net-rtt\"]=e.rtt),e.downlink&&(t[\"net-dlink\"]=e.downlink),t}function s(t){if(t instanceof w&&!y){var e=Math.round(t.timeStamp),n={type:t.type};a(n),e<=h.now()?n.fid=h.now()-e:e>h.offset&&e<=Date.now()?(e-=h.offset,n.fid=h.now()-e):e=h.now(),y=!0,l(\"timing\",[\"fi\",e,n])}}function c(t){\"hidden\"===t&&(f=h.now(),l(\"pageHide\",[f]))}if(!(\"init\"in NREUM&&\"page_view_timing\"in NREUM.init&&\"enabled\"in NREUM.init.page_view_timing&&NREUM.init.page_view_timing.enabled===!1)){var f,u,d,p,l=t(\"handle\"),h=t(\"loader\"),m=t(30),v=t(23),w=NREUM.o.EV;if(\"PerformanceObserver\"in window&&\"function\"==typeof window.PerformanceObserver){u=new PerformanceObserver(r);try{u.observe({entryTypes:[\"paint\"]})}catch(g){}d=new PerformanceObserver(o);try{d.observe({entryTypes:[\"largest-contentful-paint\"]})}catch(g){}p=new PerformanceObserver(i);try{p.observe({type:\"layout-shift\",buffered:!0})}catch(g){}}if(\"addEventListener\"in document){var y=!1,x=[\"click\",\"keydown\",\"mousedown\",\"pointerdown\",\"touchstart\"];x.forEach(function(t){document.addEventListener(t,s,v(!1))})}m(c)}},{}],28:[function(t,e,n){function r(){function t(){return e?15&e[n++]:16*Math.random()|0}var e=null,n=0,r=window.crypto||window.msCrypto;r&&r.getRandomValues&&(e=r.getRandomValues(new Uint8Array(31)));for(var o,i=\"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx\",a=\"\",s=0;s<i.length;s++)o=i[s],\"x\"===o?a+=t().toString(16):\"y\"===o?(o=3&t()|8,a+=o.toString(16)):a+=o;return a}function o(){return a(16)}function i(){return a(32)}function a(t){function e(){return n?15&n[r++]:16*Math.random()|0}var n=null,r=0,o=window.crypto||window.msCrypto;o&&o.getRandomValues&&Uint8Array&&(n=o.getRandomValues(new Uint8Array(t)));for(var i=[],a=0;a<t;a++)i.push(e().toString(16));return i.join(\"\")}e.exports={generateUuid:r,generateSpanId:o,generateTraceId:i}},{}],29:[function(t,e,n){function r(t,e){if(!o)return!1;if(t!==o)return!1;if(!e)return!0;if(!i)return!1;for(var n=i.split(\".\"),r=e.split(\".\"),a=0;a<r.length;a++)if(r[a]!==n[a])return!1;return!0}var o=null,i=null,a=/Version\\/(\\S+)\\s+Safari/;if(navigator.userAgent){var s=navigator.userAgent,c=s.match(a);c&&s.indexOf(\"Chrome\")===-1&&s.indexOf(\"Chromium\")===-1&&(o=\"Safari\",i=c[1])}e.exports={agent:o,version:i,match:r}},{}],30:[function(t,e,n){function r(t){function e(){t(s&&document[s]?document[s]:document[i]?\"hidden\":\"visible\")}\"addEventListener\"in document&&a&&document.addEventListener(a,e,o(!1))}var o=t(23);e.exports=r;var i,a,s;\"undefined\"!=typeof document.hidden?(i=\"hidden\",a=\"visibilitychange\",s=\"visibilityState\"):\"undefined\"!=typeof document.msHidden?(i=\"msHidden\",a=\"msvisibilitychange\"):\"undefined\"!=typeof document.webkitHidden&&(i=\"webkitHidden\",a=\"webkitvisibilitychange\",s=\"webkitVisibilityState\")},{}],31:[function(t,e,n){function r(t,e){var n=[],r=\"\",i=0;for(r in t)o.call(t,r)&&(n[i]=e(r,t[r]),i+=1);return n}var o=Object.prototype.hasOwnProperty;e.exports=r},{}],32:[function(t,e,n){function r(t,e,n){e||(e=0),\"undefined\"==typeof n&&(n=t?t.length:0);for(var r=-1,o=n-e||0,i=Array(o<0?0:o);++r<o;)i[r]=t[e+r];return i}e.exports=r},{}],33:[function(t,e,n){e.exports={exists:\"undefined\"!=typeof window.performance&&window.performance.timing&&\"undefined\"!=typeof window.performance.timing.navigationStart}},{}],ee:[function(t,e,n){function r(){}function o(t){function e(t){return t&&t instanceof r?t:t?f(t,c,a):a()}function n(n,r,o,i,a){if(a!==!1&&(a=!0),!l.aborted||i){t&&a&&t(n,r,o);for(var s=e(o),c=m(n),f=c.length,u=0;u<f;u++)c[u].apply(s,r);var p=d[y[n]];return p&&p.push([x,n,r,s]),s}}function i(t,e){g[t]=m(t).concat(e)}function h(t,e){var n=g[t];if(n)for(var r=0;r<n.length;r++)n[r]===e&&n.splice(r,1)}function m(t){return g[t]||[]}function v(t){return p[t]=p[t]||o(n)}function w(t,e){l.aborted||u(t,function(t,n){e=e||\"feature\",y[n]=e,e in d||(d[e]=[])})}var g={},y={},x={on:i,addEventListener:i,removeEventListener:h,emit:n,get:v,listeners:m,context:e,buffer:w,abort:s,aborted:!1};return x}function i(t){return f(t,c,a)}function a(){return new r}function s(){(d.api||d.feature)&&(l.aborted=!0,d=l.backlog={})}var c=\"nr@context\",f=t(\"gos\"),u=t(31),d={},p={},l=e.exports=o();e.exports.getOrSetContext=i,l.backlog=d},{}],gos:[function(t,e,n){function r(t,e,n){if(o.call(t,e))return t[e];var r=n();if(Object.defineProperty&&Object.keys)try{return Object.defineProperty(t,e,{value:r,writable:!0,enumerable:!1}),r}catch(i){}return t[e]=r,r}var o=Object.prototype.hasOwnProperty;e.exports=r},{}],handle:[function(t,e,n){function r(t,e,n,r){o.buffer([t],r),o.emit(t,e,n)}var o=t(\"ee\").get(\"handle\");e.exports=r,r.ee=o},{}],id:[function(t,e,n){function r(t){var e=typeof t;return!t||\"object\"!==e&&\"function\"!==e?-1:t===window?0:a(t,i,function(){return o++})}var o=1,i=\"nr@id\",a=t(\"gos\");e.exports=r},{}],loader:[function(t,e,n){function r(){if(!T++){var t=O.info=NREUM.info,e=m.getElementsByTagName(\"script\")[0];if(setTimeout(f.abort,3e4),!(t&&t.licenseKey&&t.applicationID&&e))return f.abort();c(E,function(e,n){t[e]||(t[e]=n)});var n=a();s(\"mark\",[\"onload\",n+O.offset],null,\"api\"),s(\"timing\",[\"load\",n]);var r=m.createElement(\"script\");0===t.agent.indexOf(\"http://\")||0===t.agent.indexOf(\"https://\")?r.src=t.agent:r.src=l+\"://\"+t.agent,e.parentNode.insertBefore(r,e)}}function o(){\"complete\"===m.readyState&&i()}function i(){s(\"mark\",[\"domContent\",a()+O.offset],null,\"api\")}var a=t(26),s=t(\"handle\"),c=t(31),f=t(\"ee\"),u=t(29),d=t(21),p=t(23),l=d.getConfiguration(\"ssl\")===!1?\"http\":\"https\",h=window,m=h.document,v=\"addEventListener\",w=\"attachEvent\",g=h.XMLHttpRequest,y=g&&g.prototype,x=!1;NREUM.o={ST:setTimeout,SI:h.setImmediate,CT:clearTimeout,XHR:g,REQ:h.Request,EV:h.Event,PR:h.Promise,MO:h.MutationObserver};var b=\"\"+location,E={beacon:\"bam.nr-data.net\",errorBeacon:\"bam.nr-data.net\",agent:\"js-agent.newrelic.com/nr-spa-1216.min.js\"},R=g&&y&&y[v]&&!/CriOS/.test(navigator.userAgent),O=e.exports={offset:a.getLastTimestamp(),now:a,origin:b,features:{},xhrWrappable:R,userAgent:u,disabled:x};if(!x){t(20),t(27),m[v]?(m[v](\"DOMContentLoaded\",i,p(!1)),h[v](\"load\",r,p(!1))):(m[w](\"onreadystatechange\",o),h[w](\"onload\",r)),s(\"mark\",[\"firstbyte\",a.getLastTimestamp()],null,\"api\");var T=0}},{}],\"wrap-function\":[function(t,e,n){function r(t,e){function n(e,n,r,c,f){function nrWrapper(){var i,a,u,p;try{a=this,i=d(arguments),u=\"function\"==typeof r?r(i,a):r||{}}catch(l){o([l,\"\",[i,a,c],u],t)}s(n+\"start\",[i,a,c],u,f);try{return p=e.apply(a,i)}catch(h){throw s(n+\"err\",[i,a,h],u,f),h}finally{s(n+\"end\",[i,a,p],u,f)}}return a(e)?e:(n||(n=\"\"),nrWrapper[p]=e,i(e,nrWrapper,t),nrWrapper)}function r(t,e,r,o,i){r||(r=\"\");var s,c,f,u=\"-\"===r.charAt(0);for(f=0;f<e.length;f++)c=e[f],s=t[c],a(s)||(t[c]=n(s,u?c+r:r,o,c,i))}function s(n,r,i,a){if(!h||e){var s=h;h=!0;try{t.emit(n,r,i,e,a)}catch(c){o([c,n,r,i],t)}h=s}}return t||(t=u),n.inPlace=r,n.flag=p,n}function o(t,e){e||(e=u);try{e.emit(\"internal-error\",t)}catch(n){}}function i(t,e,n){if(Object.defineProperty&&Object.keys)try{var r=Object.keys(t);return r.forEach(function(n){Object.defineProperty(e,n,{get:function(){return t[n]},set:function(e){return t[n]=e,e}})}),e}catch(i){o([i],n)}for(var a in t)l.call(t,a)&&(e[a]=t[a]);return e}function a(t){return!(t&&t instanceof Function&&t.apply&&!t[p])}function s(t,e){var n=e(t);return n[p]=t,i(t,n,u),n}function c(t,e,n){var r=t[e];t[e]=s(r,n)}function f(){for(var t=arguments.length,e=new Array(t),n=0;n<t;++n)e[n]=arguments[n];return e}var u=t(\"ee\"),d=t(32),p=\"nr@original\",l=Object.prototype.hasOwnProperty,h=!1;e.exports=r,e.exports.wrapFunction=s,e.exports.wrapInPlace=c,e.exports.argsToArray=f},{}]},{},[\"loader\",2,17,5,3,4]);"
    }
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/GlobalStyle/index.style.ts


var index_style_templateObject;


var GlobalStyles = (0,styled_components_browser_esm.createGlobalStyle)(index_style_templateObject || (index_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)([" \nhtml,\nbody {\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  background: #fff;\n  color: #022135;\n  font-size: 16px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n}\n\n*,\nhtml {\n  box-sizing: border-box;\n  scroll-behavior: auto !important;\n}\nimg {\n  max-width: 100%;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\na {\n  color: #008cff;\n  text-decoration: none;\n  cursor: pointer;\n}\na:hover,\na:focus {\n  text-decoration: none;\n  outline: none;\n}\ncode {\n  font-family: lato;\n}\n\ninput, textarea, button {font-family: inherit; border: none; outline: none;}\n\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v28/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: 100%;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-stretch: 100%;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-stretch: 100%;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXiWtFCc.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n  @font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwiPGQ3q5d0.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFV0U1dYPFkZVO.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-4I-FV0U1dYPFkZVO.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* @font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-ro-FV0U1dYPFkZVO.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n} */\n"])));
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/CurrencyCityTemplate/index.tsx + 5 modules
var CurrencyCityTemplate = __webpack_require__(2534);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingPageDocument/index.tsx






var _serverRuntimeConfig = (0,utility_src/* serverRuntimeConfig */._g)(),
    adobeDtmScriptURL = _serverRuntimeConfig.adobeDtmScriptURL;

var LandingPageDocument = function LandingPageDocument(_ref) {
  var metaTags = _ref.metaTags,
      preloadedImages = _ref.preloadedImages,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [metaTags.map(function (tag) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: tag.name,
          content: tag.content
        }, tag.name);
      }), preloadedImages.map(function (img, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "preload",
          href: img,
          as: "image"
        }, img + "-" + index);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preload",
        href: "https://fonts.gstatic.com/s/raleway/v28/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2",
        as: "font",
        crossOrigin: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preload",
        href: "https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2",
        as: "font",
        crossOrigin: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        src: adobeDtmScriptURL,
        async: true
      })]
    }), children]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/CurrencyDocument.tsx




var CurrencyDocument = function CurrencyDocument(_ref) {
  var _currencyData$curr_co, _currencyData$meta, _currencyData$meta2, _currencyData$meta3;

  var currencyData = _ref.currencyData;
  var currencyCode = (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co = currencyData.curr_code) === null || _currencyData$curr_co === void 0 ? void 0 : _currencyData$curr_co.toLowerCase()) || "";
  var denomination = currencyData !== null && currencyData !== void 0 && currencyData.heroCurrencyDenominationVal ? "/".concat(currencyData.heroCurrencyDenominationVal, "-").concat(currencyCode) : "";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      "http-equiv": "Content-Type",
      content: "text/html; charset=UTF-8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      "http-equiv": "X-UA-Compatible",
      content: "IE=edge"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$meta = currencyData.meta) === null || _currencyData$meta === void 0 ? void 0 : _currencyData$meta.desc
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$meta2 = currencyData.meta) === null || _currencyData$meta2 === void 0 ? void 0 : _currencyData$meta2.keywords
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$meta3 = currencyData.meta) === null || _currencyData$meta3 === void 0 ? void 0 : _currencyData$meta3.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://fonts.googleapis.com/css?family=Lato:wght@400;500;600;700;900&display=swap",
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: "https://www.makemytrip.com/tripmoney/currency-converter/".concat(currencyCode, "-to-inr").concat(denomination)
    })]
  });
};

/* harmony default export */ var CurrencyConverterPageTemplate_CurrencyDocument = (CurrencyDocument);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/CurrencyConverterPage.styles.ts


var CurrencyConverterPage_styles_templateObject;


var CurrencyConverterPageStyle = (0,styled_components_browser_esm.createGlobalStyle)(CurrencyConverterPage_styles_templateObject || (CurrencyConverterPage_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n\nhtml,\nbody {\n  background: #f6f6f6;\n  padding: 0;\n  margin: 0;\n  color: #4a4a4a;\n  font-size: 14px;\n  font-family: lato;\n  font-weight: 400;\n}\nhtml {\n  box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul {\n  margin: 0;\n  list-style: none;\n  padding: 0;\n}\na {\n  color: #008cff;\n  text-decoration: none;\n  cursor: pointer;\n}\na:hover,\na:focus {\n  text-decoration: none;\n  outline: none;\n}\nimg {\n  max-width: 100%;\n}\n\n\n/* Global */\n.mt10{\n    margin-top: 10px;\n}\n.mt20{\n    margin-top: 20px;\n}\n.h2{\n    font-size: 36px;\n    line-height: 44px;\n    font-weight: 900;\n    color: #000;\n}\n.h3{\n    font-size: 24px;\n    line-height: 40px;\n    font-weight: 900;\n    color: #000;\n}\n.description{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n}\n.description span{\n    font-weight: 900;\n}\n\nheader{\n    background-color: #fff;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    padding: 18px 0;\n}\n.headerInner{\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.header__right{\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n}\n.topNav{\n    display: flex;\n}\n.topNav li{\n    margin-right: 30px;\n}\n.topNav li a{\n    color: #fff;\n}\n.loginBtn{\n    display: inline-flex;\n    border-radius: 30px;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: 700;\n    color: #008cff;\n    outline: 0;\n    border: 0;\n    cursor: pointer;\n    font-family: 'Lato';\n}\n/* Top Section */\n.heroSection{\n    background: #000;\n}\n.heroSection__inner{\n    max-width: 1200px;\n    margin: 0 auto;\n    // background: url('../assets/hero-bg.png') top right no-repeat;\n    background-size: 557px 155px;\n    padding: 40px 0 80px 0;\n}\n.breadCrumb{\n    display: flex;\n}\n.breadCrumb li{\n    font-size: 14px;\n    font-weight: 700;\n}\n.breadCrumb li::after{\n    content: \"\";\n    display: inline-block;\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    padding: 2px;\n    transform: rotate(-45deg);\n    margin: 0 10px;\n}\n.breadCrumb li:last-child:after{\n    display: none;\n}\n.breadCrumb li a{\n    color: #fff;\n}\n.breadCrumb li:last-child a{\n    pointer-events: none;\n}\n.heroContent{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 75px;\n}\n.heroContent__left{\n    width: 460px;\n    flex-shrink: 0;\n}\n.heroContent__left h1{\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n}\n.heroContent__left .h1 {\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n}\n\nh1.inline {\n    display: inline;\n}\n.heroContent__left p{\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    color: #fff;\n    margin-top: 5px;\n}\n\n.hero_cashback {\n    margin-top: 35px;\n    padding: 10px 24px;\n    background-image: linear-gradient(to bottom, #f2fffc, #dbfff4);\n    border-radius: 4px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n}\n\n.hero_cashback img {\n    height: 44px;\n    width: 44px;\n}\n\n.hero_cashback_text p {\n    font-size: 20px;\n    color: #000;\n    font-weight: 400;\n}\n\n.heroContent_container {\n max-width: 390px;\n}\n\n.exchange{\n    background-color: #3d3d3d;\n    border-radius: 4px;\n    padding: 10px 20px;\n    font-size: 22px;\n    color: #85e5be;\n    display: inline-flex;\n    margin-top: 25px;\n}\n.exchange span{\n    font-weight: 900;\n}\n.heroContent__right{\n    width: 560px;\n    flex-shrink: 0;\n    background-color: #fff;\n    padding: 25px;\n    border-radius: 12px;\n}\n.heroContent__title{\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 30px;\n    font-weight: 400;\n    color: #000;\n}\n.heroContent__option{\n    display: flex;\n}\n.heroContent__option .radioBox:first-child{\n    margin-right: 40px;\n}\n.optionText{\n    font-size: 12px;\n    font-weight: 700;\n    color: #757575;\n    text-transform: uppercase;\n}\n.radioBox [type=\"radio\"]:checked + label.optionText{\n    color: #008cff;\n}\n.inputContainer{\n    display: flex;\n    margin-top: 20px;\n}\n.inputContainer__col{\n    flex: 1;\n}\n.inputContainer__separator{\n    flex-shrink: 0;\n    margin: 0 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.form-group {\n    position: relative;\n}\n.form-group input {\n    width: 100%;\n    padding: 18px 12px 10px 12px;\n    border: 1px solid #e2e2e2;\n    border-radius: 2px;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Lato';\n    color: #000000;\n    background-color: #f6f6f6;\n    transition: border-color 0.3s ease;\n}\n.form-group label {\n    position: absolute;\n    left: 12px;\n    top: 17px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #757575;\n    transition: top 0.3s ease, font-size 0.3s ease, color 0.3s ease;\n}\n.form-group input:focus {\n    outline: none;\n}\n.form-group input:focus + label,\n.form-group input:not(:placeholder-shown) + label {\n    top: 5px;\n}\n.btnSubmit{\n    background-color: #280e0e;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 900;\n    color: #fff;\n    text-transform: uppercase;\n    font-family: 'Lato';\n    outline: 0;\n    border: 0;\n    cursor: pointer;\n    margin-top: 30px;\n    width: 100%;\n}\n\n\n.floatingSelect {\n    position: relative;\n    margin-top: 25px;\n}\n.floatingSelect::after {\n    content: \"\";\n    border: solid #008cff;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    position: absolute;\n    right: 15px;\n    top: 17px;\n    transform: rotate(45deg);\n    pointer-events: none;\n}\n\n.floatingSelect__label {\n    color: #757575;\n    font-size: 12px;\n    font-weight: 700;\n    position: absolute;\n    pointer-events: none;\n    left: 12px;\n    top: 16px;\n    text-transform: uppercase;\n    transition: 0.2s ease all;\n    -moz-transition: 0.2s ease all;\n    -webkit-transition: 0.2s ease all;\n}\n\n.floatingSlctBox {\n    font-size: 12px;\n    display: block;\n    font-weight: 700;\n    font-family: 'Lato';\n    width: 100%;\n    height: 48px;\n    padding: 14px 12px 0 12px;\n    border-radius: 2px;\n    background-color: #f6f6f6;\n    border: 1px solid #e2e2e2;\n    outline: 0;\n    box-sizing: border-box;\n}\n.floatingSlctBox:focus {\n    outline: none;\n}\n.floatingSlctBox:focus ~ .floatingSelect__label {\n    top: 5px;\n}\n\nselect.floatingSlctBox {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\nselect.floatingSlctBox::-ms-expand {\n    display: none;\n}\n\n.floatingSlctBox:not([value=\"\"]):valid ~ .floatingSelect__label {\n    top: 5px;\n}\n\n.floatingSlctBox[value=\"\"]:focus ~ .floatingSelect__label {\n    top: 5px;\n}\n\n.pageContainer{\n    max-width: 1200px;\n    margin: 56px auto;\n}\n.getForex{\n    padding: 56px 24px 44px;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.getForex__title{\n    margin-bottom: 40px;\n}\n.getForex__title .big{\n    font-size: 18px;\n    color: #000;\n    font-weight: 700;\n    margin-right: 10px;\n}\n.getForex__title .small{\n    font-size: 18px;\n    color: #4a4a4a;\n    font-weight: 400;\n}\n.getForex__title .medium{\n    font-size: 18px;\n    color: #2b825e;\n    font-weight: 900;\n}\n.getForex__list{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n.getForex__listItem{\n    border: solid 1px #e2e2e2;\n    padding: 10px 13px;\n    border-radius: 4px;\n    display: flex;\n    cursor: pointer;\n}\n.getForex__listItemImg{\n    width: 140px;\n    flex-shrink: 0;\n    margin-right: 10px;\n}\n.getForex__listItemDesc{\n    flex: 1;\n}\n.getForex__listItemDesc h3.title{\n    font-size: 18px;\n    font-weight: 900;\n    color: #000;\n    display: flex;\n    align-items: center;\n}\n.getForex__listItemDesc p.title{\n    font-size: 18px;\n    font-weight: 900;\n    color: #000;\n    display: flex;\n    align-items: center;\n}\n.getForex__listItemDesc h3.title .arrow{\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin-left: 10px;\n    position: relative;\n}\n.getForex__listItemDesc h3.title .arrow::after{\n    content: \"\";\n    display: inline-block;\n    border: solid #008cff;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: 2px;\n    top: 4px;\n}\n.getForex__listItemDesc h3.title .arrow::before{\n    content: \"\";\n    display: inline-block;\n    width: 10px;\n    height: 2px;\n    background-color: #008cff;\n    position: absolute;\n    right: 3px;\n    top: 7px;\n}\n.getForex__listItemDesc p.desc{\n    font-size: 14px;\n    line-height: 22px;\n    margin-top: 10px;\n}\n.getForex__listItemDesc p.desc span{\n    position: relative;\n    padding: 0 5px 0 10px;\n}\n.getForex__listItemDesc p.desc span::after{\n    width: 4px;\n    height: 4px;\n    background-color: #2b825e;\n    content: \"\";\n    border-radius: 50%;\n    position: absolute;\n    left: 0;\n    top: 8px;\n}\n.getForex__listItemDesc p.desc span:first-child::after{\n    display: none;\n}\n.getForex__listItemDesc p.desc span:first-child{\n    padding: 0 5px 0 0;\n}\n.deliveryBy{\n    font-size: 12px;\n    font-weight: 700;\n    color: #2b825e;\n    margin-top: 8px;\n    display: none;\n    align-items: center;\n}\n.deliveryBy img{ width: 8px; flex-shrink: 0; margin-right: 5px;}\n.pageContent{\n    margin: 35px auto;\n}\n.offer_banner{\n    margin-bottom: 36px;\n    cursor: pointer;\n}\n.offer_banner .offer_bannerDt {\n    width: 100%;\n    height: 253px;\n    object-fit: contain;\n}\n.offer_banner .offer_bannerMobile {\n    width: 100%;\n    height: 340px;\n    object-fit: contain;\n    display: none;\n}\n.planTrip{\n    margin-bottom: 28px;\n}\n.planTrip p{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n}\n.planTrip p span{\n    font-weight: 900;\n}\n.separator{\n    height: 1px;\n    background-color: #979797;\n    margin: 50px 0;\n}\n.convertCurrency{\n    padding: 48px 60px;\n    border-radius: 8px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    margin-top: 30px;\n}\n.ccList__item{\n    border-bottom: 1px #c7c7c7 dashed;\n    padding: 36px 25px;\n}\n.ccList__item:first-child{\n    padding-top: 0;\n}\n.ccList__item:last-child{\n    padding-bottom: 0;\n    border-bottom: 0;\n}\n.ccList__item h4.heading{\n    font-size: 24px;\n    line-height: 26px;\n    color: #2f2f2f;\n    font-weight: 900;\n    position: relative;\n}\n.ccList__item p.heading{\n    font-size: 24px;\n    line-height: 26px;\n    color: #2f2f2f;\n    font-weight: 900;\n    position: relative;\n}\n.ccList__item p.heading::before{\n    content: \"\";\n    width: 7px;\n    height: 19px;\n    border-radius: 4px;\n    background-image: linear-gradient(to bottom, #b68f38, #e5cf8b);\n    position: absolute;\n    left: -25px;\n    top: 4px;\n}\n.ccList__item div.desc{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n    margin-top: 13px;\n}\n.ccList__item p.desc span{\n    font-weight: 900;\n}\n.benifitsList{\n    margin-top: 20px;\n}\n.benifitsList li{\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 15px;\n    color: #000;\n    padding-left: 25px;\n    position: relative;\n}\n.benifitsList li span{\n    font-weight: 900;\n}\n.benifitsList li::before{\n    content: \"\";\n    width: 7px;\n    height: 15px;\n    border-radius: 4px;\n    background-image: linear-gradient(to bottom, #b68f38, #e5cf8b);\n    position: absolute;\n    left: 0;\n    top: 5px;\n}\n.exploreBtnWrap { display: flex; justify-content: flex-start;}\n.exploreBtn {\n    padding: 10px 16px; \n    background-color: #008cff;\n    border-radius: 20px;\n    display: inline-block;\n    margin: 26px 0px;\n    cursor: pointer;\n}\n.exploreBtn_text {\n    font-size: 16px;\n    font-weight: 900;\n    color: #fff;\n    text-align: center;\n}\n\n.forexServices{\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 50px;\n    margin-top: 20px;\n}\n.forexServices__item{\n    border-radius: 8px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    padding: 25px;\n}\n.forexServices__itemHdr{\n    display: flex;\n    margin-bottom: 20px;\n}\n.forexServices__itemImg{\n    flex-shrink: 0;\n    margin-right: 15px;\n}\n.forexServices__itemTitle{\n    font-size: 28px;\n    line-height: 32px;\n    max-width: 130px;\n    color: #000;\n    font-weight: 900;\n}\n\n.conversionRate{\n    margin-top: 50px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 67px;\n}\n.conversionTbl{\n    border-collapse: collapse;\n    width: 100%;\n}\n.conversionTbl th{\n    padding: 20px 40px;\n    background-color: #000000;\n    font-size: 18px;\n    font-weight: 900;\n    color: #fff;\n    text-align: left;\n    border: 1px #979797 solid;\n}\n.conversionTbl td{\n    padding: 20px 40px;\n    font-size: 18px;\n    color: #000;\n    border: 1px #979797 solid;\n    background-color: #fff;\n}\n\n.conversionTbl td.stateBg{\n    background-color: #f6f6f6;\n}\n.states{\n    margin-top: 47px;\n}\n.capSulesList{\n    display: grid;\n    margin-top: 30px;\n    gap: 15px;\n}\n.capSulesList.grid5{\n    grid-template-columns: repeat(5, 1fr);\n}\n.capSulesList.grid4{\n    grid-template-columns: repeat(4, 1fr);\n}\n.capSulesList li{\n    padding: 19px;\n    border-radius: 6px;\n    cursor: pointer;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    font-size: 16px;\n    font-weight: 700;\n    color: #005cbc;\n    text-align: center;\n}\n.capSulesList li:nth-child(n+5){\n    display: none;\n}\n.capSulesList.showAll li:nth-child(n+5){\n    display: block;\n}\n\n.viewMore{\n    margin-top: 30px;\n}\n.viewMore__cta{\n    font-size: 16px;\n    font-weight: 700;\n    color: #005cbc;\n}\n\n.separator {\n    height: 1px;\n    background-color: #979797;\n    margin: 30px 0;\n}\n\n.faqList{\n    margin-top: 50px;\n}\n.answer{\n    display:none;\n}\n.toggleAnswer .answer{\n    display:block;\n}\n.faqList li h4.question{\n    font-size: 24px;\n    line-height: 26px;\n    font-weight: 900;\n    color: #000;\n    padding: 30px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.faqList li h4.question::after{\n    content: \"\";\n    border: solid #2f2f2f;\n    display: inline-block;\n    border-width: 0 3px 3px 0;\n    padding: 6px;\n    transform: rotate(45deg);\n    position: absolute;\n    right: 40px;\n    top: 32px;\n}\n.faqList li div.answer{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n    padding: 0 0 0 30px;\n    margin-bottom: 30px;\n}\n.faqList li div.answer span{\n    font-weight: 900;\n}\n.faqList li:hover h4.question{\n    border-radius: 6px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n}\n.faqList li.active h4.question::after{\n    transform: rotate(-135deg);\n    top: 42px;\n}\n\n.currencyList{\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 30px;\n    margin-top: 30px;\n}\n.currencyList li a{\n    display: flex;\n    border-radius: 6px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    padding: 16px 15px;\n    align-items: center;\n}\n.currency__icon{\n    width: 65px;\n    flex-shrink: 0;\n    margin-right: 14px;\n}\n.currency__text{\n    font-size: 16px;\n    font-weight: 700;\n    color: #005cbc;\n    text-decoration: underline;\n}\nfooter{\n    background-color: #000;\n    padding: 50px 0 30px 0;\n}\n.footer__cont{\n    max-width: 1200px;\n    margin: 0 auto;\n}\n.footer__hdr{\n    padding: 3px 0;\n    background-color: #4f4f4f;\n    font-size: 14px;\n    font-weight: 900;\n    color: #fff;\n    text-align: center;\n    margin-bottom: 40px;\n}\n\n.footernavCont{\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 40px;\n}\n.footerNavTitle{\n    font-size: 14px;\n    font-weight: 700;\n    color: #fff;\n    text-transform: uppercase;\n    margin-bottom: 10px;\n}\n.footerNavList li{\n    margin-bottom: 8px;\n}\n.footerNavList li a{\n    color: #d8d8d8;\n    font-size: 12px;\n}\n.footerBottom{\n    border-top: 1px #707070 solid;\n    margin-top: 40px;\n    padding: 20px 0 0 0;\n    text-align: center;\n}\n\n.container {\n    max-width: 1100px;\n    margin: 0 auto;\n    font-size: 18px;\n    line-height: 22px;\n  }\n.reviewedCurrencies {\n    background-color: #e0e0e0;\n    padding: 46px 0;\n  }\n\n  .reviewedCurrencies .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n  }\n\n  .footerLink{\n    padding:6px 0;\n  }\n\n  .footerLinkCol{\n        margin-left: 26px;\n  }\n\n  footer .linkTitle {\n    margin-bottom: 20px;\n    font-size: 20px;\n    line-height: 20px;\n  }\n\n  footer .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    color: #fff;\n    font-size: 16px;\n  }\n  \n  .footerLinkCol:first-child{\n    margin-left: 0;\n  }\n\n  .reviewedCurrencies h3{\n    font-size:28px;\n    margin-bottom: 16px;\n  }\n\n/*-- Radio Box --*/\n.radioBox {\n    display: inline-flex;\n    position: relative;\n  }\n  .radioBox [type=\"radio\"]:checked,\n  .radioBox [type=\"radio\"]:not(:checked) {\n    position: absolute;\n    left: -9999px;\n  }\n  .radioBox [type=\"radio\"]:checked + label,\n  .radioBox [type=\"radio\"]:not(:checked) + label {\n    position: relative;\n    padding-left: 28px;\n    cursor: pointer;\n    line-height: 20px;\n    display: inline-flex;\n  }\n  .radioBox [type=\"radio\"]:checked + label:before,\n  .radioBox [type=\"radio\"]:not(:checked) + label:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #9b9b9b;\n    border-radius: 100%;\n    background: #fff;\n  }\n  .radioBox [type=\"radio\"]:checked + label:before {\n    border: 1px solid #008cff;\n  }\n  .radioBox [type=\"radio\"]:checked + label:after,\n  .radioBox [type=\"radio\"]:not(:checked) + label:after {\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    background: #008cff;\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    border-radius: 100%;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n  }\n  .radioBox [type=\"radio\"]:not(:checked) + label:after {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  .radioBox [type=\"radio\"]:checked + label:after {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n\n  /* New Styles - header.html */\n .heroSection__inner.heroPadding {\n    padding: 0 16px 200px 16px;\n  }\n\n  .heroSection .heroSection_info {\n    padding: 38px 0 0;\n  }\n\n  .heroPadding h2{\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n  }\n\n  .heroPadding p{\n    font-size: 22px;\n    line-height: 52px;\n    font-weight: 600;\n    line-height: 30px;\n    color: #fff;\n    margin-top: 10px;\n  }\n\n  .pageContainer.pageContainer_margin {\n    margin: 0 auto;\n    margin-top: -170px;\n  }\n\n  @media (min-width: 320px) and (max-width: 767px) {\n    .heroPadding h2{\n        font-size: 24px;\n        line-height: 28px;\n    }\n    .heroPadding p{\n        font-size: 16px;\n        line-height: 20px;\n    }\n  }\n\n\n  /* Mobile devices */\n@media (min-width: 320px) and (max-width: 767px) {\n    body{ background-color: #ffffff;}\n    .header__right{ display: none;}\n    .headerInner{ justify-content: center; align-items: center;}\n    .heroSection__inner{ padding: 0 12px 30px 12px; background-size: 320px 167px;}\n    .heroContent{ flex-direction: column; margin-top: 0;}\n    .heroContent__left{ width: 100%; display: flex; flex-direction: column;}\n    .heroContent__right{ width: 100%; padding: 20px 16px 30px 16px;}\n    .heroContent__left h1{ font-size: 28px; line-height: 32px; text-align: center;}\n    .heroContent__left .h1{ font-size: 28px; line-height: 32px; text-align: center;}\n    .heroContent__left p{ font-size: 14px; line-height: 18px; text-align: center;}\n    .exchange{ font-size: 15px; margin-left: auto; margin-right: auto; margin-bottom: 25px; padding: 15px 25px;}\n    .hero_cashback {\n        margin-bottom: 25px;\n        margin-top: unset;\n        margin-left: auto; margin-right: auto;\n        width: 100%;\n    }\n\n    .hero_cashback img {\n        height: 30px;\n        width: 30px;\n    }\n\n    .hero_cashback_text p {\n        text-align: left;\n        font-size: 16px;\n        color: #000;\n        font-weight: 400;\n    }\n    .offer_banner{\n        margin-bottom: 30px;\n    }\n    .offer_banner .offer_bannerDt {\n        display: none;\n    }\n    .offer_banner .offer_bannerMobile {\n        display: block;\n    }    \n    .h2{ font-size: 30px; line-height: 34px;}\n    .h3{ font-size: 20px; line-height: 24px;}\n    .pageContainer{ padding: 0 12px; margin: 30px auto;}\n    .getForex{ box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16); border: solid 1px #e8e8e8; padding: 25px 12px; border-radius: 12px;}\n    .getForex__title{ display: none;}\n    .getForex__list{ grid-template-columns: 1fr;}\n    .getForex__listItem{ border: 0; padding: 0; border-radius: 0;}\n    .getForex__listItem:first-child{ border-bottom: 1px #f2f2f2 solid; padding-bottom: 15px;}\n    .getForex__listItemImg{ width: 64px;}\n    .getForex__listItemImg img{ width: 64px; height: unset;}\n    .getForex__listItemDesc p.desc{ margin-top: 5px; font-size: 12px; line-height: 18px;}\n    .getForex__listItemDesc p.desc span::after{ top: 6px;}\n    .getForex__listItemDesc p.title .arrow{ margin-left: auto;}\n    .deliveryBy{ display: flex;}\n    .planTrip p{ font-size: 16px; line-height: 24px;}\n    .description{ font-size: 16px; line-height: 24px;}\n    .separator{ margin: 30px 0;}\n    .convertCurrency{ padding: 30px 20px;}\n    .ccList__item p.heading{ font-size: 18px; line-height: 22px;}\n    .ccList__item p.desc{ font-size: 16px; line-height: 24px;}\n    .ccList__item{ padding: 16px 20px;}\n    .benifitsList li{ font-size: 16px;}\n    .forexServices{ display: flex; gap: unset; flex-wrap: nowrap; overflow-x: auto; padding: 6px 12px; margin: 20px -12px 0 -12px;}\n    .forexServices::-webkit-scrollbar{ display: none;}\n    .forexServices__item{ width: 258px; flex-shrink: 0; margin-right: 12px; padding: 20px 20px 20px 29px;}\n    .forexServices__itemHdr{ flex-direction: column; margin-bottom: 10px;}\n    .forexServices__itemImg{ margin-right: 0;}\n    .forexServices__itemImg img{ width: 102px; height: auto;}\n    .forexServices__itemTitle{ max-width: unset; font-size: 18px; line-height: 22px; margin-top: 10px;}\n    .conversionRate{ grid-template-columns: 1fr; gap: 26px; margin-top: 30px;}\n    .conversionTbl th{ padding: 14px 25px; }\n    .conversionTbl td{ padding: 14px 25px; font-size: 16px;}\n    .states{ margin-top: 30px;}\n    .capSulesList.grid5, .capSulesList.grid4{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n    .currencyList{ grid-template-columns: repeat(2, 1fr); gap: 10px;}\n    .capSulesList{ margin-top: 20px;}\n    // .capSulesList li:nth-child(n+5), .currencyList li:nth-child(n+5){display: none;}\n    .viewMore{ text-align: center; margin-top: 20px;}\n    .faqList li{ border-radius: 6px; box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22); background-color: #fff; padding: 20px 10px; margin-bottom: 40px;}\n    .faqList li:last-child{ margin-bottom: 0;}\n    .faqList li:hover h4.question{ border-radius: unset; box-shadow: unset; background-color: unset;}\n    .faqList li h4.question{ padding: 0 60px 0 0; font-size: 18px; line-height: 22px;}\n    .faqList li h4.question::after{ padding: 4px; right: 10px; top: 5px;}\n    .faqList li.active h4.question::after{ top: 10px;}\n    .faqList li div.answer{ margin-bottom: unset; padding: 10px 0 0 0; font-size: 16px;}\n    .faqList li.active{ box-shadow: unset;}\n    .pageContent{ margin-bottom: 0;}\n    footer{ padding: 30px 12px;}\n    .footernavCont{ grid-template-columns: repeat(2, 1fr);}\n    .footerBottom{ text-align: left;}\n\n    footer .container{\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 20px;\n        width: 100%;\n        padding: 0 16px;\n      }\n      footer .item{\n        margin-bottom: 50px;\n      }\n      .reviewedCurrencies{\n        padding: 30px 16px;\n      }\n      .reviewedCurrencies .container{\n        flex-direction: column;\n      }\n  \n      .reviewedCurrencies h3{\n        margin-bottom: 0;\n        line-height:1.3;\n      }\n  \n      .footerLinkCol{\n        margin-left:0;\n      }\n\n      footer {\n        background-color: #16223e;\n        padding: 46px 0 46px;\n      }\n      \n      footer .container {\n        margin-top: 0;\n        color: #fff;\n        font-size: 16px;\n      }\n      \n      footer a {\n        font-size: 16px;\n        color: #fff;\n      }\n      \n      footer .linkTitle {\n        margin-bottom: 20px;\n        font-size: 20px;\n        line-height: 20px;\n      }\n\n        .breadcrumb_container{\n            display:flex;\n            justify-content:center;\n            align-items:center;\n        }\n}\n\n/* Ipad and above */\n@media (min-width: 768px) and (max-width: 1280px) {\n    header{ padding: 10px 16px;}\n    .heroSection{ padding: 0 16px;}\n    .heroContent__left{ width: 48%;}\n    .heroContent__right{ width: 48%;}\n    .pageContainer{ margin: 30px auto; padding: 0 16px;}\n    .convertCurrency{ padding: 20px 30px;}\n    .forexServices__itemHdr{ flex-direction: column;}\n    .conversionRate{ gap: 30px;}\n    .capSulesList.grid5, .capSulesList.grid4, .currencyList{ grid-template-columns: repeat(3, 1fr);}\n    footer{ padding: 30px 16px;}\n    .faqList li h4.question{ padding-right: 50px;}\n}\n\n", "\n\n"])), function (props) {
  return props.deviceType === "lg" ? "\n    /* Desktop styles for lg deviceType */\n    @media (min-width: 1024px) {\n        /* Top banner styles */\n        #top-banner {\n            background-image: url('https://imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/header/header-sprite.png');\n            background-position: 0 -141px;\n            background-repeat: repeat-x;\n            background-size: auto 200px;\n            padding: 32px 0 40px;\n            position: relative;\n        }\n\n        .top-banner__container {\n            max-width: 1200px;\n            margin: 0 auto;\n            padding: 0 24px;\n            position: relative;\n            z-index: 2;\n        }\n\n        .top-banner__title {\n            font-size: 32px;\n            font-weight: 700;\n            line-height: 40px;\n            color: #ffffff;\n            margin: 0 0 16px 0;\n        }\n\n        .top-banner__description {\n            color: white;\n            margin-top: 8px;\n            font-weight: 700;\n            line-height: 24px;\n            margin-bottom: 0;\n            font-size: 16px;\n        }\n\n        .top-banner__breadcrumb {\n            margin-bottom: 24px;\n        }\n\n        /* Header styling for lg deviceType */\n        header {\n            position: sticky !important;\n            top: 0 !important;\n            z-index: 10 !important;\n            background-color: #fff !important;\n            padding: 18px 0 !important;\n        }\n\n        /* Remove negative margins for lg deviceType */\n        .container.negativeMargin {\n            margin-top: 0 !important;\n        }\n\n        .pageContainer.pageContainer_margin {\n            margin-top: 0 !important;\n        }\n\n        /* Section wrapper styling for lg deviceType */\n        .sectionWrapper {\n            background-color: #fff;\n            border-radius: 16px;\n            padding: 32px;\n            margin-bottom: 48px;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n        }\n\n        /* Typography improvements for lg deviceType */\n        .sectionWrapper .tripMoneySection h2 {\n            font-size: 24px !important;\n            font-weight: 600 !important;\n            line-height: 32px !important;\n            color: #333333 !important;\n            margin-bottom: 16px !important;\n        }\n\n        .sectionWrapper .tripMoneySection p,\n        .sectionWrapper .tripMoneySection .description {\n            font-size: 16px !important;\n            line-height: 24px !important;\n            color: #666666 !important;\n        }\n\n        /* Container card improvements */\n        .container__card {\n            background-color: #fff;\n            border-radius: 8px;\n            padding: 24px;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n            margin-bottom: 16px;\n        }\n\n        /* Page container wrapper */\n        .pageContainerWrapper--large {\n            max-width: 1200px;\n            margin: 0 auto;\n            padding: 0px;\n        }\n\n        .pageContainerWrapper--small {\n            padding: 16px;\n        }\n\n        /* Hide separators on desktop by default */\n        .sectionWrapper .separator {\n            display: none !important;\n        }\n\n        /* Page container wrapper styles - controlled by component logic */\n        .pageContainerWrapper {\n            width: 100%;\n        }\n\n        .pageContainerWrapper--large {\n            background-color: #F2F2F2;\n            min-height: 100vh;\n        }\n\n        .pageContainerWrapper--small {\n            background-color: transparent;\n            min-height: auto;\n        }\n\n        /* Typography overrides */\n        .h2{\n            font-size: 32px;\n            line-height: 40px;\n        }\n        .description{\n            font-size: 16px;\n            line-height: 22px;\n        }\n        \n        /* Update other 18px text to 16px for desktop */\n        .getForex__title .big,\n        .getForex__title .small,\n        .getForex__title .medium,\n        .getForex__listItemDesc p.title,\n        .getForex__listItemDesc h3.title,\n        .planTrip p,\n        .ccList__item p.heading,\n        .ccList__item h4.heading,\n        .benifitsList li,\n        .bestRate li,\n        .ccList__item div.desc,\n        .conversionTbl th,\n        .conversionTbl td,\n        .faqList li div.answer,\n        .faqList li h4.question {\n            font-size: 16px;\n            line-height: 22px;\n        }\n        \n        /* Specific typography for conversion rate headings */\n        .conversionRate_heading {\n            font-size: 18px !important;\n            line-height: 22px !important;\n            font-weight: 900 !important;\n            margin-bottom: 16px !important;\n            color: #000 !important;\n        }\n\n        .convertCurrency {\n            padding: 0px !important;\n            box-shadow: none !important;\n            margin-top: 20px !important;\n            padding-top: 20px !important;\n            border-top: 1px dashed #D8D8D8 !important;\n        }\n\n        .ccList__item:first-child {\n            padding-top: 0px !important;\n        }\n\n        .ccList__item {\n            position: relative !important;\n            padding: 40px 5px 40px 25px !important;\n            border-bottom: none !important;\n        }\n\n        .ccList__item::before {\n            content: \"\";\n            width: 7px;\n            height: 15px;\n            border-radius: 4px;\n            background-image: linear-gradient(to bottom, #16477F, #16477F) !important;\n            position: absolute;\n            left: 0;\n            top: 5px;\n        }            \n\n        /* Other Forex Services section styling for lg deviceType */\n        .forexServices {\n            display: grid !important;\n            grid-template-columns: repeat(2, 1fr) !important;\n            gap: 24px !important;\n            margin-top: 32px !important;\n        }\n\n        .forexServices__item {\n            background-color: #fff !important;\n            border-radius: 16px !important;\n            padding: 20px !important;\n            box-shadow: none !important;\n            border: 1px solid #E5E5E5 !important;\n            width: 100% !important;\n            box-sizing: border-box !important;\n        }\n\n        .forexServices__itemHdr {\n            display: flex !important;\n            flex-direction: row !important;\n            align-items: center !important;\n            margin-bottom: 0px !important;\n            gap: 16px !important;\n        }\n\n        .forexServices__itemImg {\n            flex-shrink: 0 !important;\n            margin-right: 0 !important;\n            width: 80px !important;\n            height: 80px !important;\n            display: flex !important;\n            align-items: center !important;\n            justify-content: center !important;\n        }\n\n        .forexServices__itemImg img {\n            width: 80px !important;\n            height: 80px !important;\n            object-fit: contain !important;\n        }\n\n        .forexServices__itemTitle {\n            font-size: 24px !important;\n            line-height: 28.8px !important; /* 1.2em of 24px */\n            font-weight: 900 !important;\n            color: #000 !important;\n            margin: 0 !important;\n            max-width: none !important;\n        }\n\n        .forexServices__item p {\n            font-size: 16px !important;\n            line-height: 24px !important;\n            font-weight: 400 !important;\n            color: #666666 !important;\n            margin: 0 !important;\n        }\n        \n        /* Update specific elements that need different line heights */\n        .ccList__item p.heading,\n        .ccList__item h4.heading {\n            line-height: 24px;\n        }\n        \n        .faqList li h4.question {\n            line-height: 26px;\n        }\n\n        /* Remove pageContent margin for desktop to prevent empty space */\n        .pageContent {\n            margin: 0 auto;\n        }\n        \n        /* Hide separators on desktop by default */\n        .separator {\n            display: none !important;\n        }\n\n        /* Show dotted separator only between description.mt10 and benifitsList (WhyToBuy and HowToBuy sections) */\n        .description.mt10 + .separator {\n            display: block !important;\n            height: 1px !important;\n            background: none !important;\n            border: none !important;\n            border-top: 1px dashed #D8D8D8 !important;\n            margin: 24px 0 !important;\n            width: 100% !important;\n        }\n        \n        /* Ensure top banner doesn't create empty space */\n        #top-banner {\n            min-height: auto;\n            padding: 0;\n            margin: 0;\n        }\n        \n        /* Remove any unwanted margins from first section */\n        .pageContent > .sectionWrapper:first-child {\n            margin-top: 0;\n        }\n        \n        /* Ensure no empty space before first content */\n        .pageContent {\n            padding-top: 0;\n        }\n        \n        /* Popular Denominations section improvements */\n        .conversionRate {\n            margin-top: 0;\n            gap: 40px;\n        }\n        \n        .conversionTbl {\n            border: 1px solid #e0e0e0;\n            border-radius: 8px;\n            overflow: hidden;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n            background-color: #fff;\n        }\n        \n        .conversionTbl th {\n            padding: 16px 20px !important;\n            font-size: 16px !important;\n            font-weight: 700 !important;\n            background-color: #16477F !important;\n            color: #fff !important;\n            border: none !important;\n            text-align: center !important;\n        }\n        \n        .conversionTbl th h3 {\n            font-size: 16px !important;\n            font-weight: 900 !important;\n            color: #fff !important;\n            margin: 0 !important;\n        }\n        \n        .conversionTbl td {\n            padding: 12px 20px !important;\n            font-size: 20px !important;\n            font-weight: 900 !important;\n            color: #000 !important;\n            border-bottom: 1px solid #e0e0e0 !important;\n            background-color: #fff !important;\n            border-left: none !important;\n            border-right: none !important;\n            border-top: none !important;\n            text-align: center !important;\n        }\n        \n        .conversionTbl tbody tr:last-child td {\n            border-bottom: none !important;\n        }\n        \n        .conversionTbl td a {\n            color: #008CFF !important;\n            text-decoration: none !important;\n            font-weight: 900 !important;\n        }\n        \n        .conversionTbl td a:hover {\n            text-decoration: underline !important;\n        }\n         \n        /* Other Conversions section - capSulesList styles for lg deviceType */\n        .capSulesList,\n        .capSulesList.grid5,\n        .capSulesList.grid4 {\n            display: grid !important;\n            grid-template-columns: repeat(4, 1fr) !important;\n            gap: 16px !important;\n            margin-top: 32px !important;\n        }\n       \n        .capSulesList li {\n            padding: 16px 20px;\n            border-radius: 8px;\n            background-color: #F6F6F6 !important;\n            border: none;\n            box-shadow: none;\n            cursor: pointer;\n            text-align: center;\n            transition: all 0.2s ease;\n        }\n       \n        .capSulesList li:hover {\n            background-color: #E8E8E8;\n        }\n       \n        .capSulesList li a {\n            color: #008CFF !important;\n            font-size: 12px !important;\n            font-weight: 900 !important;\n            text-decoration: none !important;\n            display: block;\n            line-height: 1.4;\n        }\n       \n        .capSulesList li a:hover {\n            text-decoration: none !important;\n        }\n       \n        .viewMore {\n            margin-top: 24px;\n            text-align: left;\n        }\n       \n        .viewMore__cta {\n            color: #008CFF !important;\n            font-size: 16px !important;\n            font-weight: 700 !important;\n            cursor: pointer;\n            text-decoration: none !important;\n        }\n       \n        .viewMore__cta:hover {\n            text-decoration: underline !important;\n        }\n       \n        /* Top Reviewed Currencies section - currencyList styles for lg deviceType */\n        .currencyList {\n            display: grid;\n            grid-template-columns: repeat(4, 1fr) !important;\n            gap: 16px;\n            margin-top: 32px;\n            width: 100%;\n        }\n       \n        .currencyList li {\n            width: 100%;\n            display: flex;\n        }\n       \n        .currencyList li a {\n            padding: 16px 20px;\n            border-radius: 16px !important;\n            background-color: #FFFFFF !important;\n            border: 1px solid #D8D8D8 !important;\n            box-shadow: none !important;\n            cursor: pointer;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: flex-start;\n            text-decoration: none;\n            transition: all 0.2s ease;\n            min-height: 64px;\n            color: #008CFF !important;\n            font-size: 18px !important;\n            font-weight: 700 !important;\n            line-height: 22px !important; /* 1.2em of 18px rounded */\n            width: 100%;\n            box-sizing: border-box;\n        }\n       \n        .currencyList li a:hover {\n            background-color: #F8F8F8;\n            border-color: #008CFF;\n            text-decoration: none;\n        }\n       \n        .currency__icon {\n            width: 48px !important;\n            height: 48px !important;\n            flex-shrink: 0;\n            margin-right: 12px !important;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n       \n        .currency__icon img {\n            width: 48px !important;\n            height: 48px !important;\n            object-fit: contain;\n        }\n\n        /* Update benifitsList li::before gradient for lg deviceType */\n        .benifitsList li::before {\n            background-image: linear-gradient(to bottom, #16477F, #16477F) !important;\n        }\n\n        /* Update bestRate li styling to match Figma specifications for lg deviceType */\n        .bestRate li {\n            font-size: 16px !important;\n            line-height: 19.2px !important; /* 1.2em of 16px */\n            font-weight: 400 !important;\n            color: #4A4A4A !important;\n            margin-bottom: 18px !important;\n        }\n\n        /* Update WhyToBuy section styling to match Figma specifications for lg deviceType */\n        .description {\n            font-size: 16px !important;\n            line-height: 19.2px !important; /* 1.2em of 16px */\n            font-weight: 400 !important;\n            color: #4A4A4A !important;\n        }\n\n        .benifitsList li {\n            font-size: 16px !important;\n            line-height: 19.2px !important; /* 1.2em of 16px */\n            font-weight: 400 !important;\n            color: #4A4A4A !important;\n            margin-bottom: 24px !important;\n            padding-left: 25px !important;\n        }\n\n        /* Fix h3 styling for CurrencyInformation section */\n        .h3 {\n            font-size: 22px !important;\n            line-height: 26.4px !important; /* 1.2em of 22px */\n            font-weight: 900 !important;\n            color: #000 !important;\n        }\n\n        /* Fix explore button styling to match Figma */\n        .exploreBtn {\n            width: 120px !important;\n            height: 32px !important;\n            padding: 12px 16px !important;\n            background: linear-gradient(135deg, rgba(83, 178, 254, 1) 0%, rgba(6, 90, 243, 1) 100%) !important;\n            border-radius: 8px !important;\n            display: inline-flex !important;\n            align-items: center !important;\n            justify-content: center !important;\n            margin: 24px 0 !important;\n            cursor: pointer !important;\n            box-sizing: border-box !important;\n        }\n\n        .exploreBtn_text {\n            font-size: 12px !important;\n            line-height: 14.4px !important; /* 1.2em of 12px */\n            font-weight: 900 !important;\n            color: #fff !important;\n            text-align: center !important;\n            text-transform: uppercase !important;\n        }\n\n        /* Top banner section styling for lg deviceType */\n        #top-banner {\n            background: url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/bg6.jpg) !important;\n            background-repeat: no-repeat !important;\n            padding-bottom: 40px !important;\n            min-height: auto !important;\n            padding: 0 !important;\n            margin: 0 !important;\n        }\n\n        .top-banner__container {\n            margin: 0 auto !important;\n            padding-top: 32px !important;\n            max-width: 1200px !important;\n        }\n\n        .top-banner__wrapper {\n            padding-bottom: 40px;\n            padding-top: 16px;\n        }\n\n        .top-banner__title {\n            font-size: 36px !important;\n            line-height: 43.2px !important; /* 1.2em of 36px */\n            font-weight: 900 !important;\n            color: #FFFFFF !important;\n            margin: 0 !important;\n        }\n\n        .top-banner__description {\n            color: white;\n            margin-top: 8px;\n            font-weight: 700;\n            line-height: 24px;\n            margin-bottom: 0;\n            font-size: 16px;\n        }\n\n        .top-banner__breadcrumb {\n            margin-top: 16px !important;\n        }\n\n        /* FAQ styling for lg deviceType */\n        .faqList {\n            margin-top: 16px !important;\n        }\n\n        .faqList li h4.question {\n            font-size: 16px !important;\n            line-height: 16px !important;\n            padding: 12px 0px !important;\n            font-weight: 400 !important;\n        }\n\n        .faqList li h4.question::after {\n            top: 12px !important;\n        }\n\n        .faqList li:hover {\n            box-shadow: none !important;\n            border-color: transparent !important;\n            background-color: transparent !important;\n        }\n\n        .faqList li:hover h4.question {\n            background-color: transparent !important;\n            box-shadow: none !important;\n            border-radius: none !important;\n        }\n\n        .faqList li div.answer {\n            font-size: 14px !important;\n            margin-bottom: 16px !important;\n        }\n\n        /* Remove pageContainer margin for lg deviceType */\n        .pageContainer {\n            margin: 48px auto 80px !important;\n        }\n    }\n  " : "";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Header.tsx


function CurrencyConverterPageTemplate_Header_Header(_ref) {
  var _currencyData$header;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headerInner",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$header = currencyData.header) === null || _currencyData$header === void 0 ? void 0 : _currencyData$header.logo_redirection,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* MMTLogo */.X, {
          isLight: false
        })
      })
    })
  });
}
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Forex/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(290);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/ForexCalculator.tsx







function ForexCalculator(_ref) {
  var _currencyData$forex_c3, _currencyData$forex_c4;

  var currencyData = _ref.currencyData,
      inrExchangeRate = _ref.inrExchangeRate,
      currCodeToCurrRate = _ref.currCodeToCurrRate,
      switchInrExchnageRate = _ref.switchInrExchnageRate,
      _ref$templateType = _ref.templateType,
      templateType = _ref$templateType === void 0 ? "" : _ref$templateType;

  var _useState = (0,react.useState)(currencyData.currencyDenominationVal || 1),
      amountToBeConvert = _useState[0],
      setAmountToBeConvert = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isForexCardSelected = _useState2[0],
      setIsForexCardSelected = _useState2[1];

  var _useState3 = (0,react.useState)(),
      convertedAmonutInInr = _useState3[0],
      setConvertedAmonutInInr = _useState3[1];

  var _useState4 = (0,react.useState)("USD"),
      selectedCurrency = _useState4[0],
      setSelectedCurrency = _useState4[1];

  (0,react.useEffect)(function () {
    updateStatesBasedOnCurrency(currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code);
  }, [currencyData]);

  var checkCurrencyExistInProductType = function checkCurrencyExistInProductType(currency, isForexCard) {
    var _currencyData$forex_c, _currencyData$forex_c2, _currentCurrencyObj$p, _currentCurrencyObj$p2;

    var currentCurrencyObj = currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$forex_c = currencyData.forex_calculator) === null || _currencyData$forex_c === void 0 ? void 0 : (_currencyData$forex_c2 = _currencyData$forex_c.currencies_map) === null || _currencyData$forex_c2 === void 0 ? void 0 : _currencyData$forex_c2.find(function (e) {
      return e.currency_code === currency;
    });

    if (isForexCard && currentCurrencyObj !== null && currentCurrencyObj !== void 0 && (_currentCurrencyObj$p = currentCurrencyObj.product_type) !== null && _currentCurrencyObj$p !== void 0 && _currentCurrencyObj$p.includes(static_constants/* PRODUCT_CODE.CARD */.GW.CARD)) {
      return true;
    } else if (!isForexCard && currentCurrencyObj !== null && currentCurrencyObj !== void 0 && (_currentCurrencyObj$p2 = currentCurrencyObj.product_type) !== null && _currentCurrencyObj$p2 !== void 0 && _currentCurrencyObj$p2.includes(static_constants/* PRODUCT_CODE.CURRENCY */.GW.CURRENCY)) {
      return true;
    }

    return false;
  };

  var updateStatesBasedOnCurrency = function updateStatesBasedOnCurrency(currency) {
    var _currCodeToCurrRate$c;

    var currencyExistInCard = checkCurrencyExistInProductType(currency, true);
    var currencyExistInCurrency = checkCurrencyExistInProductType(currency, false);
    setIsForexCardSelected(currencyExistInCard);

    if (currencyExistInCard) {
      setSelectedCurrency(currency);
    } else if (currencyExistInCurrency) {
      setSelectedCurrency(currency);
    }

    var rate = currCodeToCurrRate === null || currCodeToCurrRate === void 0 ? void 0 : (_currCodeToCurrRate$c = currCodeToCurrRate[currency]) === null || _currCodeToCurrRate$c === void 0 ? void 0 : _currCodeToCurrRate$c[currencyExistInCard ? 0 : 1];
    setConvertedAmonutInInr((rate * amountToBeConvert).toFixed(rate > 1 ? 2 : 4));
  };

  var handleRedirection = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isForexCardSelected) {
                window.open("".concat(static_constants/* SEO_REDIRECTIONS */.Y9 === null || static_constants/* SEO_REDIRECTIONS */.Y9 === void 0 ? void 0 : static_constants/* SEO_REDIRECTIONS.CARD_BUY */.Y9.CARD_BUY).concat((0,utils/* getUtmParamsForCalculatorCta */.GB)(static_constants/* PRODUCT_TYPE.CARD */.fY.CARD, templateType)));
              } else {
                window.open("".concat(static_constants/* SEO_REDIRECTIONS */.Y9 === null || static_constants/* SEO_REDIRECTIONS */.Y9 === void 0 ? void 0 : static_constants/* SEO_REDIRECTIONS.CURRENCY_BUY */.Y9.CURRENCY_BUY).concat((0,utils/* getUtmParamsForCalculatorCta */.GB)(static_constants/* PRODUCT_TYPE.CURRENCY */.fY.CURRENCY, templateType)));
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleRedirection() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRadioClick = function handleRadioClick(_ref3) {
    var isForexCard = _ref3.isForexCard;
    setIsForexCardSelected(isForexCard);
    switchInrExchnageRate(isForexCard);
    var currencyExistInCard = checkCurrencyExistInProductType(selectedCurrency, true);

    if (isForexCard && !currencyExistInCard) {
      var _currCodeToCurrRate$U;

      setSelectedCurrency("USD");
      setAmountToBeConvert(amountToBeConvert);
      var rate = currCodeToCurrRate === null || currCodeToCurrRate === void 0 ? void 0 : (_currCodeToCurrRate$U = currCodeToCurrRate["USD"]) === null || _currCodeToCurrRate$U === void 0 ? void 0 : _currCodeToCurrRate$U[isForexCard ? 0 : 1];
      setConvertedAmonutInInr((amountToBeConvert * rate).toFixed(rate > 1 ? 2 : 4));
    } else {
      var _currCodeToCurrRate$s;

      setAmountToBeConvert(amountToBeConvert);

      var _rate = currCodeToCurrRate === null || currCodeToCurrRate === void 0 ? void 0 : (_currCodeToCurrRate$s = currCodeToCurrRate[selectedCurrency]) === null || _currCodeToCurrRate$s === void 0 ? void 0 : _currCodeToCurrRate$s[isForexCard ? 0 : 1];

      setConvertedAmonutInInr((amountToBeConvert * _rate).toFixed(_rate > 1 ? 2 : 4));
    }
  };

  var handleOnChangeOfAmount = function handleOnChangeOfAmount(e) {
    var _currCodeToCurrRate$s2;

    setAmountToBeConvert(e.target.value);
    var rate = currCodeToCurrRate === null || currCodeToCurrRate === void 0 ? void 0 : (_currCodeToCurrRate$s2 = currCodeToCurrRate[selectedCurrency]) === null || _currCodeToCurrRate$s2 === void 0 ? void 0 : _currCodeToCurrRate$s2[isForexCardSelected ? 0 : 1];
    setConvertedAmonutInInr((e.target.value * rate).toFixed(rate > 1 ? 2 : 4));
  };

  var handleSelectionOfCurrency = function handleSelectionOfCurrency(curr_code) {
    var _currCodeToCurrRate$c2;

    setSelectedCurrency(curr_code);
    var rate = currCodeToCurrRate === null || currCodeToCurrRate === void 0 ? void 0 : (_currCodeToCurrRate$c2 = currCodeToCurrRate[curr_code]) === null || _currCodeToCurrRate$c2 === void 0 ? void 0 : _currCodeToCurrRate$c2[isForexCardSelected ? 0 : 1];
    setConvertedAmonutInInr(amountToBeConvert ? (amountToBeConvert * rate).toFixed(rate > 1 ? 2 : 4) : "0");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "heroContent__right",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      action: "#",
      onSubmit: function onSubmit(e) {
        return e.preventDefault();
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        className: "heroContent__title",
        children: ["Our Live ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Conversion Rates"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "heroContent__option",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "radioBox",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "radio",
            name: "r1",
            id: "r1",
            checked: isForexCardSelected,
            onClick: function onClick() {
              handleRadioClick({
                isForexCard: true
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: "optionText",
            htmlFor: "r1",
            children: "Forex card"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "radioBox",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "radio",
            name: "r1",
            id: "r2",
            checked: !isForexCardSelected,
            onClick: function onClick() {
              handleRadioClick({
                isForexCard: false
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: "optionText",
            htmlFor: "r2",
            children: "Currency notes"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "floatingSelect",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
          className: "floatingSlctBox",
          onChange: function onChange(event) {
            var _event$target;

            return handleSelectionOfCurrency(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
          },
          value: selectedCurrency,
          id: "slect",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
            value: "",
            children: "Select Currency"
          }), currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$forex_c3 = currencyData.forex_calculator) === null || _currencyData$forex_c3 === void 0 ? void 0 : (_currencyData$forex_c4 = _currencyData$forex_c3.currencies_map) === null || _currencyData$forex_c4 === void 0 ? void 0 : _currencyData$forex_c4.map(function (item, index) {
            var _item$product_type, _item$product_type2;

            if (isForexCardSelected && item !== null && item !== void 0 && (_item$product_type = item.product_type) !== null && _item$product_type !== void 0 && _item$product_type.includes(static_constants/* PRODUCT_CODE.CARD */.GW.CARD)) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                value: item === null || item === void 0 ? void 0 : item.currency_code,
                children: [item === null || item === void 0 ? void 0 : item.currency_code, " (", item === null || item === void 0 ? void 0 : item.currency_name, ")"]
              }, index);
            } else if (!isForexCardSelected && item !== null && item !== void 0 && (_item$product_type2 = item.product_type) !== null && _item$product_type2 !== void 0 && _item$product_type2.includes(static_constants/* PRODUCT_CODE.CURRENCY */.GW.CURRENCY)) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
                value: item === null || item === void 0 ? void 0 : item.currency_code,
                children: [item === null || item === void 0 ? void 0 : item.currency_code, " (", item === null || item === void 0 ? void 0 : item.currency_name, ")"]
              }, index);
            }

            return null;
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          htmlFor: "slect",
          className: "floatingSelect__label",
          children: "currency"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "inputContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "inputContainer__col",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "form-group",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "text",
              placeholder: "",
              id: "AmountInGEL",
              style: {
                marginTop: "6px"
              },
              value: amountToBeConvert || "",
              onChange: function onChange(e) {
                var value = e.target.value;

                if (value === "" || /^\d+$/.test(value)) {
                  handleOnChangeOfAmount(e);
                }
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
              htmlFor: "AmountInGEL",
              children: ["Amount in ", selectedCurrency]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "inputContainer__separator",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/grey_arrow_98b3fc0a80.png",
            alt: "arrow",
            width: "14",
            height: "11"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "inputContainer__col",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "form-group",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "text",
              placeholder: "",
              id: "AmountInINR",
              value: convertedAmonutInInr,
              style: {
                marginTop: "6px"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              htmlFor: "AmountInINR",
              children: "Amount in INR"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "btnSubmit",
        type: "submit",
        onClick: function onClick() {
          return handleRedirection();
        },
        children: isForexCardSelected ? "BUY FOREX CARD NOW" : "BUY CURRENCY NOTES NOW"
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Hero.tsx





function Hero_Hero(_ref) {
  var _currencyData$hero, _currencyData$hero$ti, _currencyData$hero2, _currencyData$hero3, _currencyData$hero4, _currencyData$hero5;

  var currencyData = _ref.currencyData,
      inrExchangeRate = _ref.inrExchangeRate,
      currCodeToCurrRate = _ref.currCodeToCurrRate,
      switchInrExchnageRate = _ref.switchInrExchnageRate,
      breadcrumb = _ref.breadcrumb,
      _ref$templateType = _ref.templateType,
      templateType = _ref$templateType === void 0 ? "" : _ref$templateType;
  var heading1 = currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero = currencyData.hero) === null || _currencyData$hero === void 0 ? void 0 : (_currencyData$hero$ti = _currencyData$hero.title) === null || _currencyData$hero$ti === void 0 ? void 0 : _currencyData$hero$ti.split("Currency Converter")[0];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "heroSection",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "heroSection__inner",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "breadcrumb_container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
          breadCrumbData: breadcrumb || []
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "heroContent",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "heroContent__left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "inline",
            children: heading1
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "h1",
            children: "Currency Converter"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero2 = currencyData.hero) === null || _currencyData$hero2 === void 0 ? void 0 : _currencyData$hero2.desc
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "heroContent_container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "exchange",
              children: ["Exchange Rate \xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "1\xA0"
              }), currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code, " = \xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: [Number(inrExchangeRate).toFixed(Number(inrExchangeRate) > 1 ? 2 : 4), "\xA0"]
              }), " ", "INR"]
            }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero3 = currencyData.hero) === null || _currencyData$hero3 === void 0 ? void 0 : _currencyData$hero3.offer_text) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "hero_cashback",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero4 = currencyData.hero) === null || _currencyData$hero4 === void 0 ? void 0 : _currencyData$hero4.offer_icon,
                alt: "cashback"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "hero_cashback_text",
                children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero5 = currencyData.hero) === null || _currencyData$hero5 === void 0 ? void 0 : _currencyData$hero5.offer_text
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ForexCalculator, {
          currencyData: currencyData,
          inrExchangeRate: inrExchangeRate,
          currCodeToCurrRate: currCodeToCurrRate,
          switchInrExchnageRate: switchInrExchnageRate,
          templateType: templateType
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Introduction.tsx


function Introduction(_ref) {
  var _currencyData$introdu;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "planTrip",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$introdu = currencyData.introduction) === null || _currencyData$introdu === void 0 ? void 0 : _currencyData$introdu.para
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/HowToConvert.tsx




function HowToConvert(_ref) {
  var _currencyData$how_to_, _currencyData$how_to_2, _currencyData$how_to_3, _currencyData$how_to_4;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$how_to_ = currencyData.how_to_convert) === null || _currencyData$how_to_ === void 0 ? void 0 : _currencyData$how_to_.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$how_to_2 = currencyData.how_to_convert) === null || _currencyData$how_to_2 === void 0 ? void 0 : _currencyData$how_to_2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "convertCurrency",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "ccList",
        children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$how_to_3 = currencyData.how_to_convert) === null || _currencyData$how_to_3 === void 0 ? void 0 : (_currencyData$how_to_4 = _currencyData$how_to_3.list) === null || _currencyData$how_to_4 === void 0 ? void 0 : _currencyData$how_to_4.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "ccList__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                className: "heading",
                children: item === null || item === void 0 ? void 0 : item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "desc",
                children: item === null || item === void 0 ? void 0 : item.desc
              })]
            }, index)
          });
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/Benefits.tsx




function Benefits(_ref) {
  var _currencyData$benefit, _currencyData$benefit2, _currencyData$benefit3, _currencyData$benefit4, _currencyData$benefit5;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$benefit = currencyData.benefits) === null || _currencyData$benefit === void 0 ? void 0 : _currencyData$benefit.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$benefit2 = currencyData.benefits) === null || _currencyData$benefit2 === void 0 ? void 0 : _currencyData$benefit2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "benifitsList",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$benefit3 = currencyData.benefits) === null || _currencyData$benefit3 === void 0 ? void 0 : (_currencyData$benefit4 = _currencyData$benefit3.list) === null || _currencyData$benefit4 === void 0 ? void 0 : _currencyData$benefit4.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
            children: item
          })
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$benefit5 = currencyData.benefits) === null || _currencyData$benefit5 === void 0 ? void 0 : _currencyData$benefit5.end_para
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/OtherServices.tsx




function OtherServices(_ref) {
  var _currencyData$other_f, _currencyData$other_f2, _currencyData$other_f3, _currencyData$other_f4;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_f = currencyData.other_forex_services) === null || _currencyData$other_f === void 0 ? void 0 : _currencyData$other_f.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_f2 = currencyData.other_forex_services) === null || _currencyData$other_f2 === void 0 ? void 0 : _currencyData$other_f2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "forexServices",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_f3 = currencyData.other_forex_services) === null || _currencyData$other_f3 === void 0 ? void 0 : (_currencyData$other_f4 = _currencyData$other_f3.cards) === null || _currencyData$other_f4 === void 0 ? void 0 : _currencyData$other_f4.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "forexServices__item",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "forexServices__itemHdr",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "forexServices__itemImg",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item === null || item === void 0 ? void 0 : item.img,
                alt: item === null || item === void 0 ? void 0 : item.title,
                width: "112",
                height: "70"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "forexServices__itemTitle",
              children: item === null || item === void 0 ? void 0 : item.title
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
            className: "description",
            children: item === null || item === void 0 ? void 0 : item.desc
          })]
        }, index);
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/PopularDenominations.tsx



function PopularDenomitations(_ref) {
  var _currencyData$popular, _currencyData$popular2, _currencyData$popular3, _currencyData$popular4, _currencyData$popular5, _currencyData$popular6, _currencyData$popular7, _currencyData$popular8, _currencyData$popular9, _currencyData$popular10, _currencyData$popular11, _currencyData$popular12, _currencyData$popular13, _currencyData$popular14, _currencyData$popular15, _currencyData$popular16, _currencyData$popular17, _currencyData$popular18, _currencyData$popular19;

  var currencyData = _ref.currencyData,
      inrExchageRate = _ref.inrExchageRate;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular = currencyData.popular_denominations) === null || _currencyData$popular === void 0 ? void 0 : _currencyData$popular.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "conversionRate",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "conversionRate__col",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
          className: "conversionTbl",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular2 = currencyData.popular_denominations) === null || _currencyData$popular2 === void 0 ? void 0 : (_currencyData$popular3 = _currencyData$popular2.table) === null || _currencyData$popular3 === void 0 ? void 0 : (_currencyData$popular4 = _currencyData$popular3.col_name) === null || _currencyData$popular4 === void 0 ? void 0 : _currencyData$popular4[0]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular5 = currencyData.popular_denominations) === null || _currencyData$popular5 === void 0 ? void 0 : (_currencyData$popular6 = _currencyData$popular5.table) === null || _currencyData$popular6 === void 0 ? void 0 : (_currencyData$popular7 = _currencyData$popular6.col_name) === null || _currencyData$popular7 === void 0 ? void 0 : _currencyData$popular7[1]
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
            children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular8 = currencyData.popular_denominations) === null || _currencyData$popular8 === void 0 ? void 0 : (_currencyData$popular9 = _currencyData$popular8.table) === null || _currencyData$popular9 === void 0 ? void 0 : (_currencyData$popular10 = _currencyData$popular9.row_value_left_side) === null || _currencyData$popular10 === void 0 ? void 0 : _currencyData$popular10.map(function (item, index) {
              var _currencyData$curr_co, _currencyData$curr_co2, _currencyData$curr_co3, _currencyData$curr_co4;

              var href = "/tripmoney/currency-converter/".concat(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co = currencyData.curr_code) === null || _currencyData$curr_co === void 0 ? void 0 : (_currencyData$curr_co2 = _currencyData$curr_co.toLowerCase) === null || _currencyData$curr_co2 === void 0 ? void 0 : _currencyData$curr_co2.call(_currencyData$curr_co), "-to-inr/").concat(item, "-").concat(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co3 = currencyData.curr_code) === null || _currencyData$curr_co3 === void 0 ? void 0 : (_currencyData$curr_co4 = _currencyData$curr_co3.toLowerCase) === null || _currencyData$curr_co4 === void 0 ? void 0 : _currencyData$curr_co4.call(_currencyData$curr_co3));
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    href: href,
                    target: "_self",
                    children: [item, " ", currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                  children: [(item * inrExchageRate).toFixed(2), " INR"]
                })]
              }, index);
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "conversionRate__col",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
          className: "conversionTbl",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular11 = currencyData.popular_denominations) === null || _currencyData$popular11 === void 0 ? void 0 : (_currencyData$popular12 = _currencyData$popular11.table) === null || _currencyData$popular12 === void 0 ? void 0 : (_currencyData$popular13 = _currencyData$popular12.col_name) === null || _currencyData$popular13 === void 0 ? void 0 : _currencyData$popular13[0]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular14 = currencyData.popular_denominations) === null || _currencyData$popular14 === void 0 ? void 0 : (_currencyData$popular15 = _currencyData$popular14.table) === null || _currencyData$popular15 === void 0 ? void 0 : (_currencyData$popular16 = _currencyData$popular15.col_name) === null || _currencyData$popular16 === void 0 ? void 0 : _currencyData$popular16[1]
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
            children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular17 = currencyData.popular_denominations) === null || _currencyData$popular17 === void 0 ? void 0 : (_currencyData$popular18 = _currencyData$popular17.table) === null || _currencyData$popular18 === void 0 ? void 0 : (_currencyData$popular19 = _currencyData$popular18.row_value_right_side) === null || _currencyData$popular19 === void 0 ? void 0 : _currencyData$popular19.map(function (item, index) {
              var _currencyData$curr_co5, _currencyData$curr_co6;

              var href = "/tripmoney/currency-converter/".concat(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co5 = currencyData.curr_code) === null || _currencyData$curr_co5 === void 0 ? void 0 : _currencyData$curr_co5.toLowerCase(), "-to-inr/").concat(item, "-").concat(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co6 = currencyData.curr_code) === null || _currencyData$curr_co6 === void 0 ? void 0 : _currencyData$curr_co6.toLowerCase());
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    href: href,
                    target: "_self",
                    children: [item, " ", currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                  children: [(item * inrExchageRate).toFixed(2), " INR"]
                })]
              }, index);
            })
          })]
        })
      })]
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/CurrencyInformation.tsx




function CurrencyInformation(_ref) {
  var _currencyData$curr_in, _currencyData$curr_in2, _currencyData$curr_in3, _currencyData$curr_in4;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in = currencyData.curr_information) === null || _currencyData$curr_in === void 0 ? void 0 : _currencyData$curr_in.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "h3 mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in2 = currencyData.curr_information) === null || _currencyData$curr_in2 === void 0 ? void 0 : _currencyData$curr_in2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in3 = currencyData.curr_information) === null || _currencyData$curr_in3 === void 0 ? void 0 : _currencyData$curr_in3.desc
    }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in4 = currencyData.curr_information) === null || _currencyData$curr_in4 === void 0 ? void 0 : _currencyData$curr_in4.link) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "exploreBtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "exploreBtn",
        onClick: function onClick() {
          var _currencyData$curr_in5;

          window.open(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in5 = currencyData.curr_information) === null || _currencyData$curr_in5 === void 0 ? void 0 : _currencyData$curr_in5.link, "_self");
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "exploreBtn_text",
          children: "Explore"
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/OtherConversions.tsx




function OtherConversions(_ref) {
  var _currencyData$other_c, _currencyData$other_c2, _currencyData$other_c3;

  var currencyData = _ref.currencyData;

  var _useState = (0,react.useState)(true),
      showViewMore = _useState[0],
      setShowViewMore = _useState[1];

  var handleOnClick = function handleOnClick() {
    setShowViewMore(!showViewMore);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_c = currencyData.other_conversions) === null || _currencyData$other_c === void 0 ? void 0 : _currencyData$other_c.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "capSulesList grid4 ".concat(!showViewMore ? "showAll" : ""),
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_c2 = currencyData.other_conversions) === null || _currencyData$other_c2 === void 0 ? void 0 : (_currencyData$other_c3 = _currencyData$other_c2.cards) === null || _currencyData$other_c3 === void 0 ? void 0 : _currencyData$other_c3.map(function (card, index) {
        var cardTitleCurrency = card === null || card === void 0 ? void 0 : card.title.split(" ")[1];

        if ((currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code) !== cardTitleCurrency) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "capsule",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: card === null || card === void 0 ? void 0 : card.href,
              children: card === null || card === void 0 ? void 0 : card.title
            })
          }, "".concat(card === null || card === void 0 ? void 0 : card.title).concat(index));
        }

        return null;
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "viewMore",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "viewMore__cta",
        onClick: function onClick() {
          return handleOnClick();
        },
        children: showViewMore ? "View More" : "View Less"
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/ConvertOnline.tsx




function ConvertOnline(_ref) {
  var _currencyData$convert, _currencyData$convert2;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$convert = currencyData.convert_curr_to_inr_online) === null || _currencyData$convert === void 0 ? void 0 : _currencyData$convert.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description mt20",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$convert2 = currencyData.convert_curr_to_inr_online) === null || _currencyData$convert2 === void 0 ? void 0 : _currencyData$convert2.para
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/Banner.tsx


function Banner_Banner(_ref) {
  var currencyData = _ref.currencyData;
  if (!currencyData.offer_banner_dt && !currencyData.offer_banner_mob) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "offer_banner",
    onClick: function onClick() {
      if (currencyData !== null && currencyData !== void 0 && currencyData.offer_link) window.open(currencyData === null || currencyData === void 0 ? void 0 : currencyData.offer_link, "_blank");
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: "offer_bannerDt",
      src: currencyData.offer_banner_dt,
      alt: "banner",
      width: "100%",
      height: 253
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: "offer_bannerMobile",
      src: currencyData.offer_banner_mob,
      alt: "banner",
      width: "100%",
      height: 340
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/CurrencyConverterPageTemplate.tsx






















 // Wrapper component to handle deviceType logic





var CurrencyConverterPageTemplate_SectionWrapper = function SectionWrapper(_ref) {
  var children = _ref.children,
      deviceType = _ref.deviceType;

  if (deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "sectionWrapper",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: children
  });
};

var CurrencyConverterPageTemplate = function CurrencyConverterPageTemplate(_ref2) {
  var _currencyData$hero, _currencyData$hero$ti, _currencyData$hero2, _PAGE_NAMES$SEO_CURRE2, _currencyData$introdu, _currencyData$benefit, _currencyData$faqs, _currencyData$faqs$li;

  var id = _ref2.id,
      currencyData = _ref2.currencyData,
      inrExchangeRate = _ref2.inrExchangeRate,
      currCodeToCurrRate = _ref2.currCodeToCurrRate,
      switchInrExchnageRate = _ref2.switchInrExchnageRate,
      _ref2$templateType = _ref2.templateType,
      templateType = _ref2$templateType === void 0 ? "" : _ref2$templateType,
      deviceType = _ref2.deviceType,
      page_name = _ref2.page_name;
  var isBot = (0,hooks/* useBotDetection */.Um)();
  (0,react.useEffect)(function () {
    var _PAGE_NAMES$SEO_CURRE;

    (0,analytics/* trackSeoPageLoad */.XE)({
      pageName: (_PAGE_NAMES$SEO_CURRE = analytics/* PAGE_NAMES.SEO_CURRENCY_CONVERTER */.a3.SEO_CURRENCY_CONVERTER) === null || _PAGE_NAMES$SEO_CURRE === void 0 ? void 0 : _PAGE_NAMES$SEO_CURRE.replace("NAME", "".concat(currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code, "_to_INR")),
      currency: currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code,
      denomination: currencyData === null || currencyData === void 0 ? void 0 : currencyData.heroCurrencyDenominationVal
    });
  }, []);
  var heading1 = currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero = currencyData.hero) === null || _currencyData$hero === void 0 ? void 0 : (_currencyData$hero$ti = _currencyData$hero.title) === null || _currencyData$hero$ti === void 0 ? void 0 : _currencyData$hero$ti.split("Currency Converter")[0];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      backgroundColor: "#F2F2F2"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* FontStyles */.B2, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* BaseStyles */.xR, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageStyle, {
      deviceType: deviceType
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_CurrencyDocument, {
      currencyData: currencyData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_Header_Header, {
      currencyData: currencyData
    }), deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(Hero_Hero, {
      currencyData: currencyData,
      inrExchangeRate: inrExchangeRate,
      currCodeToCurrRate: currCodeToCurrRate,
      switchInrExchnageRate: switchInrExchnageRate,
      breadcrumb: currencyData === null || currencyData === void 0 ? void 0 : currencyData.breadcrumb,
      templateType: templateType
    }), deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroWebV2/* HeroWebV2 */.F, {
      title: heading1,
      desc: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero2 = currencyData.hero) === null || _currencyData$hero2 === void 0 ? void 0 : _currencyData$hero2.desc,
      breadcrumb: (currencyData === null || currencyData === void 0 ? void 0 : currencyData.breadcrumb) || [],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_cjs/* ListingUiWrapper */.ev, {
        source_type: "seo",
        isBot: isBot,
        deviceType: deviceType,
        page_name: page_name
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "pageContainerWrapper ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "pageContainerWrapper--large" : "pageContainerWrapper--small"),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "pageContainer",
        children: [deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(ForexProducts/* default */.Z, {
          currencyData: currencyData,
          pageName: (_PAGE_NAMES$SEO_CURRE2 = analytics/* PAGE_NAMES.SEO_CURRENCY_CONVERTER */.a3.SEO_CURRENCY_CONVERTER) === null || _PAGE_NAMES$SEO_CURRE2 === void 0 ? void 0 : _PAGE_NAMES$SEO_CURRE2.replace("NAME", "".concat(currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code, "_to_INR")),
          templateType: templateType
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pageContent",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner_Banner, {
            currencyData: currencyData
          }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$introdu = currencyData.introduction) === null || _currencyData$introdu === void 0 ? void 0 : _currencyData$introdu.para) && /*#__PURE__*/(0,jsx_runtime.jsx)(Introduction, {
            currencyData: currencyData
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConvertOnline, {
              currencyData: currencyData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(HowToConvert, {
              currencyData: currencyData
            })
          }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$benefit = currencyData.benefits) === null || _currencyData$benefit === void 0 ? void 0 : _currencyData$benefit.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Benefits, {
              currencyData: currencyData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(OtherServices, {
              currencyData: currencyData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(PopularDenomitations, {
              currencyData: currencyData,
              inrExchageRate: inrExchangeRate
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyInformation, {
              currencyData: currencyData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(OtherConversions, {
              currencyData: currencyData
            })
          }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$faqs = currencyData.faqs) === null || _currencyData$faqs === void 0 ? void 0 : (_currencyData$faqs$li = _currencyData$faqs.list) === null || _currencyData$faqs$li === void 0 ? void 0 : _currencyData$faqs$li.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyConverterPageTemplate_SectionWrapper, {
            deviceType: deviceType,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
              currencyData: currencyData
            })
          })]
        })]
      })
    }), currencyData !== null && currencyData !== void 0 && currencyData.footer ? /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyFooter/* CurrencyFooter */.H, {
      footer: currencyData === null || currencyData === void 0 ? void 0 : currencyData.footer
    }) : null]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyConverterPageTemplate/index.tsx

;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/CurrencyDocument.tsx




var CurrencyDocument_CurrencyDocument = function CurrencyDocument(_ref) {
  var _currencyData$curr_co, _currencyData$meta, _currencyData$meta2, _currencyData$meta3;

  var currencyData = _ref.currencyData,
      canonicalHref = _ref.canonicalHref;
  var canHref = canonicalHref || "https://www.makemytrip.com/tripmoney/currency-converter/".concat(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co = currencyData.curr_code) === null || _currencyData$curr_co === void 0 ? void 0 : _currencyData$curr_co.toLowerCase(), "-to-inr");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      "http-equiv": "Content-Type",
      content: "text/html; charset=UTF-8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      "http-equiv": "X-UA-Compatible",
      content: "IE=edge"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$meta = currencyData.meta) === null || _currencyData$meta === void 0 ? void 0 : _currencyData$meta.desc
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$meta2 = currencyData.meta) === null || _currencyData$meta2 === void 0 ? void 0 : _currencyData$meta2.keywords
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$meta3 = currencyData.meta) === null || _currencyData$meta3 === void 0 ? void 0 : _currencyData$meta3.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://fonts.googleapis.com/css?family=Lato:wght@400;500;600;700;900&display=swap",
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: canHref
    })]
  });
};

/* harmony default export */ var CurrencyRatePageTemplate_CurrencyDocument = (CurrencyDocument_CurrencyDocument);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/CurrencyRatePageTemplate.styles.ts


var CurrencyRatePageTemplate_styles_templateObject;


var CurrencyRatePageStyle = (0,styled_components_browser_esm.createGlobalStyle)(CurrencyRatePageTemplate_styles_templateObject || (CurrencyRatePageTemplate_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n\nhtml,\nbody {\n  background: #f6f6f6;\n  padding: 0;\n  margin: 0;\n  color: #4a4a4a;\n  font-size: 14px;\n  font-family: lato;\n  font-weight: 400;\n}\nhtml {\n  box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul {\n  margin: 0;\n  list-style: none;\n  padding: 0;\n}\na {\n  color: #008cff;\n  text-decoration: none;\n  cursor: pointer;\n}\na:hover,\na:focus {\n  text-decoration: none;\n  outline: none;\n}\nimg {\n  max-width: 100%;\n}\n\n\n/* Global */\n.mt10{\n    margin-top: 10px;\n}\n.mt20{\n    margin-top: 20px;\n}\n.h2{\n    font-size: 36px;\n    line-height: 44px;\n    font-weight: 900;\n    color: #000;\n}\n.h3{\n    font-size: 24px;\n    line-height: 40px;\n    font-weight: 900;\n    color: #000;\n}\n.description{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n}\n\n/* Page container wrapper styles - controlled by component logic */\n.pageContainerWrapper {\n  width: 100%;\n}\n\n.pageContainerWrapper--large {\n  background-color: #F2F2F2;\n  min-height: 100vh;\n}\n\n.pageContainerWrapper--small {\n  background-color: transparent;\n  min-height: auto;\n}\n\n/* Desktop styles - all desktop-specific overrides */\n@media (min-width: 1024px) {\n  ", "\n}\n\n.description span{\n    font-weight: 900;\n}\n\nheader{\n    background-color: #fff;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    padding: 18px 0;\n}\n.headerInner{\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.header__right{\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n}\n.topNav{\n    display: flex;\n}\n.topNav li{\n    margin-right: 30px;\n}\n.topNav li a{\n    color: #fff;\n}\n.loginBtn{\n    display: inline-flex;\n    border-radius: 30px;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: 700;\n    color: #008cff;\n    outline: 0;\n    border: 0;\n    cursor: pointer;\n    font-family: 'Lato';\n}\n/* Top Section */\n.heroSection{\n    background: #000;\n}\n.heroSection__inner{\n    max-width: 1200px;\n    margin: 0 auto;\n    background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_2e6e787a77.png') top right no-repeat;\n    background-size: 557px 155px;\n    padding: 40px 0 80px 0;\n}\n.breadCrumb{\n    display: flex;\n}\n.breadCrumb li{\n    font-size: 14px;\n    font-weight: 700;\n}\n.breadCrumb li::after{\n    content: \"\";\n    display: inline-block;\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    padding: 2px;\n    transform: rotate(-45deg);\n    margin: 0 10px;\n}\n.breadCrumb li:last-child:after{\n    display: none;\n}\n.breadCrumb li a{\n    color: #fff;\n}\n.breadCrumb li:last-child a{\n    pointer-events: none;\n}\n.heroContent{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 75px;\n}\n.heroContent__left{\n    width: 460px;\n    flex-shrink: 0;\n}\n.heroContent__left h1{\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n}\n.heroContent__left .h1 {\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n}\n\nh1.inline {\n    display: inline;\n}\n.heroContent__left p{\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    color: #fff;\n    margin-top: 5px;\n}\n\n.hero_cashback {\n    margin-top: 35px;\n    padding: 10px 24px;\n    background-image: linear-gradient(to bottom, #f2fffc, #dbfff4);\n    border-radius: 4px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n}\n\n.hero_cashback img {\n    height: 44px;\n    width: 44px;\n}\n\n.hero_cashback_text p {\n    font-size: 20px;\n    color: #000;\n    font-weight: 400;\n}\n\n.heroContent_container {\n max-width: 390px;\n}\n\n.exchange{\n    background-color: #3d3d3d;\n    border-radius: 4px;\n    padding: 10px 20px;\n    font-size: 22px;\n    color: #85e5be;\n    display: inline-flex;\n    margin-top: 25px;\n    width: 100%;\n}\n.exchange span{\n    font-weight: 900;\n}\n.heroContent__right{\n    width: 560px;\n    flex-shrink: 0;\n    background-color: #fff;\n    padding: 25px;\n    border-radius: 12px;\n}\n.heroContent__title{\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 30px;\n    font-weight: 400;\n    color: #000;\n}\n.heroContent__option{\n    display: flex;\n}\n.heroContent__option .radioBox:first-child{\n    margin-right: 40px;\n}\n.optionText{\n    font-size: 12px;\n    font-weight: 700;\n    color: #757575;\n    text-transform: uppercase;\n}\n.radioBox [type=\"radio\"]:checked + label.optionText{\n    color: #008cff;\n}\n.inputContainer{\n    display: flex;\n    margin-top: 20px;\n}\n.inputContainer__col{\n    flex: 1;\n}\n.inputContainer__separator{\n    flex-shrink: 0;\n    margin: 0 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.form-group {\n    position: relative;\n}\n.form-group input {\n    width: 100%;\n    padding: 18px 12px 10px 12px;\n    border: 1px solid #e2e2e2;\n    border-radius: 2px;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Lato';\n    color: #000000;\n    background-color: #f6f6f6;\n    transition: border-color 0.3s ease;\n}\n.form-group label {\n    position: absolute;\n    left: 12px;\n    top: 17px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #757575;\n    transition: top 0.3s ease, font-size 0.3s ease, color 0.3s ease;\n}\n.form-group input:focus {\n    outline: none;\n}\n.form-group input:focus + label,\n.form-group input:not(:placeholder-shown) + label {\n    top: 5px;\n}\n.btnSubmit{\n    background-color: #280e0e;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 900;\n    color: #fff;\n    text-transform: uppercase;\n    font-family: 'Lato';\n    outline: 0;\n    border: 0;\n    cursor: pointer;\n    margin-top: 30px;\n    width: 100%;\n}\n\n\n.floatingSelect {\n    position: relative;\n    margin-top: 25px;\n}\n.floatingSelect::after {\n    content: \"\";\n    border: solid #008cff;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    position: absolute;\n    right: 15px;\n    top: 17px;\n    transform: rotate(45deg);\n    pointer-events: none;\n}\n\n.floatingSelect__label {\n    color: #757575;\n    font-size: 12px;\n    font-weight: 700;\n    position: absolute;\n    pointer-events: none;\n    left: 12px;\n    top: 16px;\n    text-transform: uppercase;\n    transition: 0.2s ease all;\n    -moz-transition: 0.2s ease all;\n    -webkit-transition: 0.2s ease all;\n}\n\n.floatingSlctBox {\n    font-size: 12px;\n    display: block;\n    font-weight: 700;\n    font-family: 'Lato';\n    width: 100%;\n    height: 48px;\n    padding: 14px 12px 0 12px;\n    border-radius: 2px;\n    background-color: #f6f6f6;\n    border: 1px solid #e2e2e2;\n    outline: 0;\n    box-sizing: border-box;\n}\n.floatingSlctBox:focus {\n    outline: none;\n}\n.floatingSlctBox:focus ~ .floatingSelect__label {\n    top: 5px;\n}\n\nselect.floatingSlctBox {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\nselect.floatingSlctBox::-ms-expand {\n    display: none;\n}\n\n.floatingSlctBox:not([value=\"\"]):valid ~ .floatingSelect__label {\n    top: 5px;\n}\n\n.floatingSlctBox[value=\"\"]:focus ~ .floatingSelect__label {\n    top: 5px;\n}\n\n.pageContainer{\n    max-width: 1200px;\n    margin: 56px auto;\n}\n.getForex{\n    padding: 56px 24px 44px;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.getForex__title{\n    margin-bottom: 40px;\n}\n.getForex__title .big{\n    font-size: 18px;\n    color: #000;\n    font-weight: 700;\n    margin-right: 10px;\n}\n.getForex__title .small{\n    font-size: 18px;\n    color: #4a4a4a;\n    font-weight: 400;\n}\n.getForex__title .medium{\n    font-size: 18px;\n    color: #2b825e;\n    font-weight: 900;\n}\n.getForex__list{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n.getForex__listItem{\n    border: solid 1px #e2e2e2;\n    padding: 10px 13px;\n    border-radius: 4px;\n    display: flex;\n}\n.getForex__listItemImg{\n    width: 140px;\n    flex-shrink: 0;\n    margin-right: 10px;\n}\n.getForex__listItemDesc{\n    flex: 1;\n}\n.getForex__listItemDesc h3.title{\n    font-size: 18px;\n    font-weight: 900;\n    color: #000;\n    display: flex;\n    align-items: center;\n}\n.getForex__listItemDesc p.title{\n    font-size: 18px;\n    font-weight: 900;\n    color: #000;\n    display: flex;\n    align-items: center;\n}\n.getForex__listItemDesc h3.title .arrow{\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin-left: 10px;\n    position: relative;\n}\n.getForex__listItemDesc h3.title .arrow::after{\n    content: \"\";\n    display: inline-block;\n    border: solid #008cff;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: 2px;\n    top: 4px;\n}\n.getForex__listItemDesc h3.title .arrow::before{\n    content: \"\";\n    display: inline-block;\n    width: 10px;\n    height: 2px;\n    background-color: #008cff;\n    position: absolute;\n    right: 3px;\n    top: 7px;\n}\n.getForex__listItemDesc p.desc{\n    font-size: 14px;\n    line-height: 22px;\n    margin-top: 10px;\n}\n.getForex__listItemDesc p.desc span{\n    position: relative;\n    padding: 0 5px 0 10px;\n}\n.getForex__listItemDesc p.desc span::after{\n    width: 4px;\n    height: 4px;\n    background-color: #2b825e;\n    content: \"\";\n    border-radius: 50%;\n    position: absolute;\n    left: 0;\n    top: 8px;\n}\n.getForex__listItemDesc p.desc span:first-child::after{\n    display: none;\n}\n.getForex__listItemDesc p.desc span:first-child{\n    padding: 0 5px 0 0;\n}\n.deliveryBy{\n    font-size: 12px;\n    font-weight: 700;\n    color: #2b825e;\n    margin-top: 8px;\n    display: none;\n    align-items: center;\n}\n.deliveryBy img{ width: 8px; flex-shrink: 0; margin-right: 5px;}\n.pageContent{\n    margin: 20px auto 35px;\n}\n.offer_banner{\n    margin-bottom: 36px;\n    cursor: pointer;\n}\n.offer_banner .offer_bannerDt {\n    width: 100%;\n    height: 253px;\n    object-fit: contain;\n}\n.offer_banner .offer_bannerMobile {\n    width: 100%;\n    height: 340px;\n    object-fit: contain;\n    display: none;\n}\n.planTrip{\n    margin-bottom: 28px;\n}\n.planTrip p{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n}\n.planTrip p span{\n    font-weight: 900;\n}\n\n.convertCurrency{\n    padding: 48px 60px;\n    border-radius: 8px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    margin-top: 30px;\n}\n.ccList__item{\n    border-bottom: 1px #c7c7c7 dashed;\n    padding: 36px 25px;\n}\n.ccList__item:first-child{\n    padding-top: 0;\n}\n.ccList__item:last-child{\n    padding-bottom: 0;\n    border-bottom: 0;\n}\n.ccList__item h4.heading{\n    font-size: 24px;\n    line-height: 26px;\n    color: #2f2f2f;\n    font-weight: 900;\n    position: relative;\n}\n.ccList__item p.heading{\n    font-size: 24px;\n    line-height: 26px;\n    color: #2f2f2f;\n    font-weight: 900;\n    position: relative;\n}\n.ccList__item p.heading::before{\n    content: \"\";\n    width: 7px;\n    height: 19px;\n    border-radius: 4px;\n    background-image: linear-gradient(to bottom, #b68f38, #e5cf8b);\n    position: absolute;\n    left: -25px;\n    top: 4px;\n}\n.ccList__item div.desc{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n    margin-top: 13px;\n}\n.ccList__item p.desc span{\n    font-weight: 900;\n}\n\n.bestRate {\n    margin-top: 20px;\n}\n\n.bestRate li{\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 18px;\n    color: #000;\n}\n\n.benifitsList{\n    margin-top: 20px;\n}\n.benifitsList li{\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 15px;\n    color: #000;\n    padding-left: 25px;\n    position: relative;\n}\n.benifitsList li span{\n    font-weight: 900;\n}\n.benifitsList li::before{\n    content: \"\";\n    width: 7px;\n    height: 15px;\n    border-radius: 4px;\n    background-image: linear-gradient(to bottom, #b68f38, #e5cf8b);\n    position: absolute;\n    left: 0;\n    top: 5px;\n}\n\n.forexServices{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n    margin-top: 26px;\n}\n.forexServices__item{\n    border-radius: 8px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    padding: 25px;\n}\n.forexServices__itemHdr{\n    display: flex;\n    margin-bottom: 15px;\n    align-items: center;\n}\n.forexServices__itemImg{\n    flex-shrink: 0;\n    margin-right: 15px;\n}\n.forexServices__itemTitle{\n    font-size: 28px;\n    line-height: 32px;\n    color: #000;\n    font-weight: 900;\n}\n\n.conversionRate{\n    margin-top: 50px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 67px;\n}\n.statsTableWrapper {\n    border: 1px #979797 solid;\n}\n.statsTableHeader {\n    background-color: #000000;\n    padding: 20px 40px;\n    align-items: center;\n}\n.statsTableHeader p {\n    font-size: 18px;\n    line-height: 22px;\n    color: #fff;\n    font-weight: 900;\n    text-align: center;\n}\n.statsTable th{\n    border-bottom: 1px #979797 solid;\n    padding: 12px;\n    text-align: center;\n    font-size: 18px;\n    font-weight: 800;\n    color: #000;\n}\n.statsTable td{\n    padding: 12px;\n    text-align: center;\n    font-size: 18px;\n    color: #000;\n}\n.statsTable tbody tr:not(:last-child) td{  \n    border-bottom: 1px #979797 solid;\n}\n.statsTable tbody td:not(:last-child){  \n    border-right: 1px #979797 solid;\n}\n.statsTable thead th:not(:last-child){  \n    border-right: 1px #979797 solid;\n}\n.conversionRate_heading {\n    font-size: 28px;\n    font-weight: 900;\n    color: #000;\n    line-height: 32px;\n    margin-bottom: 24px;\n}    \n.conversionTbl{\n    border-collapse: collapse;\n    width: 100%;\n}\n.conversionTbl th{\n    padding: 20px 40px;\n    background-color: #000000;\n    font-size: 18px;\n    font-weight: 900;\n    color: #fff;\n    text-align: left;\n    border: 1px #979797 solid;\n}\n.conversionTbl td{\n    padding: 14px 40px;\n    font-size: 18px;\n    color: #000;\n    border: 1px #979797 solid;\n    background-color: #fff;\n}\n\n.conversionTbl td.stateBg{\n    background-color: #f6f6f6;\n}\n.states{\n    margin-top: 47px;\n}\n.capSulesList{\n    display: grid;\n    margin-top: 30px;\n    gap: 15px;\n}\n.capSulesList.grid5{\n    grid-template-columns: repeat(5, 1fr);\n}\n.capSulesList.grid4{\n    grid-template-columns: repeat(4, 1fr);\n}\n.capSulesList li{\n    padding: 19px;\n    border-radius: 6px;\n    cursor: pointer;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    font-size: 16px;\n    font-weight: 700;\n    color: #005cbc;\n    text-align: center;\n}\n.capSulesList li:nth-child(n+5){\n    display: none;\n}\n.capSulesList.showAll li:nth-child(n+5){\n    display: block;\n}\n\n.viewMore{\n    margin-top: 30px;\n}\n.viewMore__cta{\n    font-size: 16px;\n    font-weight: 700;\n    color: #005cbc;\n}\n\n.exploreBtn{\n    padding: 10px 16px; \n    background-color: #008cff;\n    border-radius: 20px;\n    display: inline-block;\n    margin: 26px 0px;\n    cursor: pointer;\n}\n\n.exploreBtn_text{\n    font-size: 16px;\n    font-weight: 900;\n    color: #fff;\n    text-align: center;\n}\n\n\n.separator{\n    height: 1px;\n    background-color: #979797;\n    margin: 50px 0;\n}\n\n.faqList{\n    margin-top: 50px;\n}\n.answer{\n    display:none;\n}\n.toggleAnswer .answer{\n    display:block;\n}\n.faqList li h4.question{\n    font-size: 24px;\n    line-height: 26px;\n    font-weight: 900;\n    color: #000;\n    padding: 30px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.faqList li h4.question::after{\n    content: \"\";\n    border: solid #2f2f2f;\n    display: inline-block;\n    border-width: 0 3px 3px 0;\n    padding: 6px;\n    transform: rotate(45deg);\n    position: absolute;\n    right: 40px;\n    top: 32px;\n}\n.faqList li div.answer{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n    padding: 0 0 0 30px;\n    margin-bottom: 30px;\n}\n.faqList li div.answer span{\n    font-weight: 900;\n}\n.faqList li:hover h4.question{\n    border-radius: 6px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n}\n.faqList li.active h4.question::after{\n    transform: rotate(-135deg);\n    top: 42px;\n}\n\n\n.currencyList{\n    display: grid;\n    gap: 15px;\n    margin-top: 30px;\n}\n\n.currencyList.grid5{\n    grid-template-columns: repeat(5, 1fr);\n}\n.currencyList.grid4{\n    grid-template-columns: repeat(4, 1fr);\n}\n\n.currencyList li a{\n    padding: 19px;\n    border-radius: 6px;\n    cursor: pointer;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n    font-size: 16px;\n    font-weight: 700;\n    color: #005cbc;\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    text-decoration: underline;\n\n}\n.currencyList li:nth-child(n+5){\n    display: none;\n}\n.currencyList.showAll li:nth-child(n+5){\n    display: block;\n}\n.currency__icon{\n    width: 65px;\n    flex-shrink: 0;\n    margin-right: 14px;\n}\nfooter{\n    background-color: #16223e;\n    padding: 50px 0 30px 0;\n}\n.footer__cont{\n    max-width: 1200px;\n    margin: 0 auto;\n}\n.footer__hdr{\n    padding: 3px 0;\n    background-color: #4f4f4f;\n    font-size: 14px;\n    font-weight: 900;\n    color: #fff;\n    text-align: center;\n    margin-bottom: 40px;\n}\n\n.footernavCont{\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 40px;\n}\n.footerNavTitle{\n    font-size: 14px;\n    font-weight: 700;\n    color: #fff;\n    text-transform: uppercase;\n    margin-bottom: 10px;\n}\n.footerNavList li{\n    margin-bottom: 8px;\n}\n.footerNavList li a{\n    color: #d8d8d8;\n    font-size: 12px;\n}\n.footerBottom{\n    border-top: 1px #707070 solid;\n    margin-top: 40px;\n    padding: 20px 0 0 0;\n    text-align: center;\n}\n\n.container {\n    max-width: 1100px;\n    margin: 0 auto;\n    font-size: 18px;\n    line-height: 22px;\n  }\n.reviewedCurrencies {\n    background-color: #e0e0e0;\n    padding: 46px 0;\n  }\n\n  .reviewedCurrencies .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n  }\n\n  .footerLink{\n    padding:6px 0;\n  }\n\n  .footerLinkCol{\n        margin-left: 26px;\n  }\n\n  footer .linkTitle {\n    margin-bottom: 20px;\n    font-size: 20px;\n    line-height: 20px;\n  }\n\n  footer .container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    color: #fff;\n    font-size: 16px;\n  }\n\n  footer a {\n    color: #fff;\n  }\n  \n  .footerLinkCol:first-child{\n    margin-left: 0;\n  }\n\n  .reviewedCurrencies h3{\n    font-size:28px;\n    margin-bottom: 16px;\n  }\n\n/*-- Radio Box --*/\n.radioBox {\n    display: inline-flex;\n    position: relative;\n  }\n  .radioBox [type=\"radio\"]:checked,\n  .radioBox [type=\"radio\"]:not(:checked) {\n    position: absolute;\n    left: -9999px;\n  }\n  .radioBox [type=\"radio\"]:checked + label,\n  .radioBox [type=\"radio\"]:not(:checked) + label {\n    position: relative;\n    padding-left: 28px;\n    cursor: pointer;\n    line-height: 20px;\n    display: inline-flex;\n  }\n  .radioBox [type=\"radio\"]:checked + label:before,\n  .radioBox [type=\"radio\"]:not(:checked) + label:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #9b9b9b;\n    border-radius: 100%;\n    background: #fff;\n  }\n  .radioBox [type=\"radio\"]:checked + label:before {\n    border: 1px solid #008cff;\n  }\n  .radioBox [type=\"radio\"]:checked + label:after,\n  .radioBox [type=\"radio\"]:not(:checked) + label:after {\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    background: #008cff;\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    border-radius: 100%;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n  }\n  .radioBox [type=\"radio\"]:not(:checked) + label:after {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  .radioBox [type=\"radio\"]:checked + label:after {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n\n  /* New Styles - header.html */\n .heroSection__inner.heroPadding {\n    padding: 0 16px 200px 16px;\n  }\n\n  .heroSection .heroSection_info {\n    padding: 38px 0 0;\n  }\n\n  .heroPadding h2{\n    font-size: 45px;\n    line-height: 52px;\n    font-weight: 900;\n    color: #fff;\n  }\n\n  .heroPadding p{\n    font-size: 22px;\n    line-height: 52px;\n    font-weight: 600;\n    line-height: 30px;\n    color: #fff;\n    margin-top: 10px;\n  }\n\n  .pageContainer.pageContainer_margin {\n    margin: 0 auto;\n    margin-top: -170px;\n  }\n\n  @media (min-width: 320px) and (max-width: 767px) {\n    .heroPadding h2{\n        font-size: 24px;\n        line-height: 28px;\n    }\n    .heroPadding p{\n        font-size: 16px;\n        line-height: 20px;\n    }\n  }\n\n  /* Mobile devices */\n@media (min-width: 320px) and (max-width: 767px) {\n    body{ background-color: #ffffff;}\n    .header__right{ display: none;}\n    .headerInner{ justify-content: center; align-items: center;}\n    .heroSection__inner{ \n        padding: 0 12px 30px 12px; \n        background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_mob_bffdba7329.png') top center no-repeat;\n        background-size: 320px 167px;\n    }\n    .heroContent{ flex-direction: column; margin-top: 32px;}\n    .heroContent__left{ width: 100%; display: flex; flex-direction: column;}\n    .heroContent__right{ width: 100%; padding: 20px 16px 30px 16px;}\n    .heroContent__left h1{ font-size: 28px; line-height: 32px; text-align: center;}\n    .heroContent__left .h1{ font-size: 28px; line-height: 32px; text-align: center;}\n    .heroContent__left p{ font-size: 14px; line-height: 18px; text-align: center;}\n    .heroContent_container{padding: 0px 20px; max-width: 100%;}\n    .exchange{ font-size: 15px; margin-left: auto; margin-right: auto; margin-bottom: 9px; padding: 15px 25px; width: 100%;}\n    .hero_cashback {\n        margin-bottom: 25px;\n        margin-top: unset;\n        margin-left: auto; margin-right: auto;\n        width: 100%;\n    }\n\n    .hero_cashback img {\n        height: 30px;\n        width: 30px;\n    }\n\n    .hero_cashback_text p {\n        text-align: left;\n        font-size: 16px;\n        color: #000;\n        font-weight: 400;\n    }\n    .offer_banner{\n        margin-bottom: 30px;\n    }\n    .offer_banner .offer_bannerDt {\n        display: none;\n    }\n    .offer_banner .offer_bannerMobile {\n        display: block;\n    }\n    .exploreBtnWrap{ display: flex; justify-content: center;}\n    .currencyList li a{padding: 10px;}\n    .currency__icon{ width: 43px; margin-right: 10px;}\n    .currency__icon > img{ width: 43px !important; height: 43px !important;}\n    .h2{ font-size: 30px; line-height: 34px;}\n    .h3{ font-size: 20px; line-height: 24px;}\n    .pageContainer{ padding: 0 12px; margin: 30px auto;}\n    .getForex{ box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16); border: solid 1px #e8e8e8; padding: 25px 12px; border-radius: 12px;}\n    .getForex__title{ display: none;}\n    .getForex__list{ grid-template-columns: 1fr;}\n    .getForex__listItem{ border: 0; padding: 0; border-radius: 0;}\n    .getForex__listItem:first-child{ border-bottom: 1px #f2f2f2 solid; padding-bottom: 15px;}\n    .getForex__listItemImg{ width: 64px;}\n    .getForex__listItemImg img{ width: 64px; height: unset;}\n    .getForex__listItemDesc p.desc{ margin-top: 5px; font-size: 12px; line-height: 18px;}\n    .getForex__listItemDesc p.desc span::after{ top: 6px;}\n    .getForex__listItemDesc p.title .arrow{ margin-left: auto;}\n    .deliveryBy{ display: flex;}\n    .planTrip p{ font-size: 16px; line-height: 24px;}\n    .description{ font-size: 16px; line-height: 24px;}\n    .separator{ margin: 30px 0;}\n    .convertCurrency{ padding: 30px 20px;}\n    .ccList__item p.heading{ font-size: 18px; line-height: 22px;}\n    .ccList__item p.desc{ font-size: 16px; line-height: 24px;}\n    .ccList__item{ padding: 16px 20px;}\n    .benifitsList li{ font-size: 16px;}\n    .forexServices{ display: flex; gap: unset; flex-wrap: nowrap; overflow-x: auto; padding: 6px 12px; margin: 20px -12px 0px -12px;}\n    .forexServices::-webkit-scrollbar{ display: none;}\n    .forexServices__item{ width: 258px; flex-shrink: 0; margin-right: 12px; padding: 20px 20px 20px 29px;}\n    .forexServices__itemHdr{ flex-direction: column; margin-bottom: 10px;}\n    .forexServices__itemImg{ margin-right: 0;}\n    .forexServices__itemImg img{ width: 102px; height: auto;}\n    .forexServices__itemTitle{ max-width: unset; font-size: 18px; line-height: 22px; margin-top: 10px;}\n    .conversionRate{ grid-template-columns: 1fr; gap: 26px; margin-top: 30px;}\n    .conversionRate_heading{font-size: 18px; line-height: 22px; margin-bottom: 20px;}\n    .conversionTbl th{ padding: 14px 25px; font-size: 16px;}\n    .conversionTbl td{ padding: 14px 25px; font-size: 16px;}\n    .statsTable th {font-size: 16px;}\n    .statsTable td {font-size: 16px;}\n    .states{ margin-top: 30px;}\n    .capSulesList.grid5, .capSulesList.grid4{ \n        grid-template-columns: repeat(2, 1fr) !important; \n        gap: 10px !important;\n    }\n    .currencyList.grid5, .currencyList.grid4{ \n        grid-template-columns: repeat(2, 1fr) !important; \n        gap: 10px !important;\n    }\n    .currencyList {\n        margin-top: 20px !important;\n    }\n    .currencyList li a {\n        padding: 10px !important;\n        background-color: #fff !important;\n        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        color: #005cbc !important;\n        border-radius: 6px !important;\n        border: none !important;\n        min-height: auto !important;\n    }\n    .currency__icon { \n        width: 43px !important; \n        margin-right: 10px !important;\n    }\n    .currency__icon img { \n        width: 43px !important; \n        height: 43px !important;\n    }\n    .capSulesList{ \n        margin-top: 20px !important;\n    }\n    .capSulesList li {\n        padding: 19px !important;\n        border-radius: 6px !important;\n        background-color: #fff !important;\n        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        color: #005cbc !important;\n    }\n    // .capSulesList li:nth-child(n+5), .currencyList li:nth-child(n+5){display: none;}\n    .viewMore{ \n        text-align: center !important; \n        margin-top: 20px !important;\n    }\n    .viewMore__cta {\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        color: #005cbc !important;\n    }\n    .faqList {\n        margin-top: 50px !important;\n    }\n    .faqList li{ \n        border-radius: 6px !important; \n        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important; \n        background-color: #fff !important; \n        padding: 20px 10px !important; \n        margin-bottom: 40px !important;\n        border: none !important;\n    }\n    .faqList li:last-child{ margin-bottom: 0 !important;}\n    .faqList li:hover { \n        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;\n        border-color: transparent !important;\n    }\n    .faqList li:hover h4.question{ \n        border-radius: unset !important; \n        box-shadow: unset !important; \n        background-color: unset !important;\n    }\n    .faqList li h4.question{ \n        padding: 0 60px 0 0 !important; \n        font-size: 18px !important; \n        line-height: 22px !important;\n        font-weight: 900 !important;\n        color: #000 !important;\n    }\n    .faqList li h4.question::after{ \n        padding: 4px !important; \n        right: 10px !important; \n        top: 5px !important;\n        border: solid #2f2f2f !important;\n        border-width: 0 3px 3px 0 !important;\n        padding: 6px !important;\n        margin-top: 0 !important;\n    }\n    .faqList li.toggleAnswer h4.question::after{ \n        top: 10px !important;\n        transform: rotate(-135deg) !important;\n    }\n    .faqList li div.answer{ \n        margin-bottom: unset !important; \n        padding: 10px 0 0 0 !important; \n        font-size: 16px !important;\n        color: #000 !important;\n    }\n    .faqList li.active{ box-shadow: unset !important;}\n    .pageContent{ margin-bottom: 0;}\n    .footernavCont{ grid-template-columns: repeat(2, 1fr);}\n    .footerBottom{ text-align: left;}\n\n    footer .footernavCont{\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 20px;\n        width: 100%;\n        padding: 0 16px;\n      }\n      .reviewedCurrencies{\n        padding: 30px 16px;\n      }\n      .reviewedCurrencies .container{\n        flex-direction: column;\n      }\n  \n      .reviewedCurrencies h3{\n        margin-bottom: 0;\n        line-height:1.3;\n      }\n  \n      .footerLinkCol{\n        margin-left:0;\n      }\n\n      footer {\n        background-color: #000;\n        padding: 46px 30px 46px;\n      }\n      \n      footer .container {\n        margin-top: 0;\n        color: #fff;\n        font-size: 16px;\n        flex-direction: column;\n      }  \n      footer .item{\n        margin-bottom: 50px;\n      }\n      footer a {\n        font-size: 16px;\n        color: #fff;\n      }\n      \n      footer .linkTitle {\n        margin-bottom: 20px;\n        font-size: 20px;\n        line-height: 20px;\n      }\n      .footerNavList li{\n        margin-bottom: 0;\n      }\n}\n\n/* Ipad and above */\n@media (min-width: 768px) and (max-width: 1280px) {\n  ", "\n}\n"])), function (props) {
  return props.deviceType === "lg" ? "\n    /* Typography overrides */\n    .h2{\n        font-size: 32px;\n        line-height: 40px;\n    }\n    .description{\n        font-size: 16px;\n        line-height: 22px;\n    }\n    \n    /* Update other 18px text to 16px for desktop */\n    .getForex__title .big,\n    .getForex__title .small,\n    .getForex__title .medium,\n    .getForex__listItemDesc p.title,\n    .getForex__listItemDesc h3.title,\n    .planTrip p,\n    .ccList__item p.heading,\n    .ccList__item h4.heading,\n    .benifitsList li,\n    .bestRate li,\n    .ccList__item div.desc,\n    .conversionTbl th,\n    .conversionTbl td,\n    .faqList li div.answer,\n    .faqList li h4.question {\n        font-size: 16px;\n        line-height: 22px;\n    }\n    \n    /* Specific typography for conversion rate headings */\n    .conversionRate_heading {\n        font-size: 18px !important;\n        line-height: 22px !important;\n        font-weight: 900 !important;\n        margin-bottom: 16px !important;\n        color: #000 !important;\n    }\n    \n    /* Update specific elements that need different line heights */\n    .ccList__item p.heading,\n    .ccList__item h4.heading {\n        line-height: 24px;\n    }\n    \n    .faqList li h4.question {\n        line-height: 26px;\n    }\n    .sectionWrapper {\n        background-color: #fff;\n        border-radius: 16px;\n        padding: 32px 24px;\n        margin-bottom: 24px;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    }\n    \n    .sectionWrapper:last-child {\n        margin-bottom: 0;\n    }\n    \n    /* Remove pageContent margin for desktop to prevent empty space */\n    .pageContent {\n        margin: 0 auto;\n    }\n    \n    /* Hide separators on desktop by default */\n    .separator {\n        display: none !important;\n    }\n\n    /* Show dotted separator only between description.mt10 and benifitsList (WhyToBuy and HowToBuy sections) */\n    .description.mt10 + .separator {\n        display: block !important;\n        height: 1px !important;\n        background: none !important;\n        border: none !important;\n        border-top: 1px dashed #D8D8D8 !important;\n        margin: 24px 0 !important;\n        width: 100% !important;\n    }\n    \n    /* Ensure top banner doesn't create empty space */\n    #top-banner {\n        min-height: auto;\n        padding: 0;\n        margin: 0;\n    }\n    \n    /* Remove any unwanted margins from first section */\n    .pageContent > .sectionWrapper:first-child {\n        margin-top: 0;\n    }\n    \n    /* Ensure no empty space before first content */\n    .pageContent {\n        padding-top: 0;\n    }\n    \n    /* Popular Denominations section improvements */\n    .conversionRate {\n        margin-top: 0;\n        gap: 40px;\n    }\n    \n    .conversionTbl {\n        border: 1px solid #e0e0e0;\n        border-radius: 8px;\n        overflow: hidden;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        background-color: #fff;\n    }\n    \n    .conversionTbl th {\n        padding: 16px 20px !important;\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        background-color: #16477F !important;\n        color: #fff !important;\n        border: none !important;\n        text-align: center !important;\n    }\n    \n    .conversionTbl th h3 {\n        font-size: 16px !important;\n        font-weight: 900 !important;\n        color: #fff !important;\n        margin: 0 !important;\n    }\n    \n    .conversionTbl td {\n        padding: 12px 20px !important;\n        font-size: 20px !important;\n        font-weight: 900 !important;\n        color: #000 !important;\n        border-bottom: 1px solid #e0e0e0 !important;\n        background-color: #fff !important;\n        border-left: none !important;\n        border-right: none !important;\n        border-top: none !important;\n        text-align: center !important;\n    }\n    \n    .conversionTbl tbody tr:last-child td {\n        border-bottom: none !important;\n    }\n    \n    .conversionTbl td a {\n        color: #008CFF !important;\n        text-decoration: none !important;\n        font-weight: 900 !important;\n    }\n    \n    .conversionTbl td a:hover {\n        text-decoration: underline !important;\n    }\n     \n           /* Other Conversions section - capSulesList styles for lg deviceType */\n      .capSulesList,\n      .capSulesList.grid5,\n      .capSulesList.grid4 {\n          display: grid !important;\n          grid-template-columns: repeat(4, 1fr) !important;\n          gap: 16px !important;\n          margin-top: 32px !important;\n      }\n     \n     .capSulesList li {\n         padding: 16px 20px;\n         border-radius: 8px;\n         background-color: #F6F6F6 !important;\n         border: none;\n         box-shadow: none;\n         cursor: pointer;\n         text-align: center;\n         transition: all 0.2s ease;\n     }\n     \n     .capSulesList li:hover {\n         background-color: #E8E8E8;\n     }\n     \n     .capSulesList li a {\n         color: #008CFF !important;\n         font-size: 12px !important;\n         font-weight: 900 !important;\n         text-decoration: none !important;\n         display: block;\n         line-height: 1.4;\n     }\n     \n     .capSulesList li a:hover {\n         text-decoration: none !important;\n     }\n     \n     .viewMore {\n         margin-top: 24px;\n         text-align: left;\n     }\n     \n     .viewMore__cta {\n         color: #008CFF !important;\n         font-size: 16px !important;\n         font-weight: 700 !important;\n         cursor: pointer;\n         text-decoration: none !important;\n     }\n     \n     .viewMore__cta:hover {\n         text-decoration: underline !important;\n     }\n     \n     /* Top Reviewed Currencies section - currencyList styles for lg deviceType */\n     .currencyList {\n         display: grid;\n         grid-template-columns: repeat(4, 1fr) !important;\n         gap: 16px;\n         margin-top: 32px;\n         width: 100%;\n     }\n     \n     .currencyList li {\n         width: 100%;\n         display: flex;\n     }\n     \n     .currencyList li a {\n         padding: 16px 20px;\n         border-radius: 16px !important;\n         background-color: #FFFFFF !important;\n         border: 1px solid #D8D8D8 !important;\n         box-shadow: none !important;\n         cursor: pointer;\n         display: flex;\n         flex-direction: row;\n         align-items: center;\n         justify-content: flex-start;\n         text-decoration: none;\n         transition: all 0.2s ease;\n         min-height: 64px;\n         color: #008CFF !important;\n         font-size: 18px !important;\n         font-weight: 700 !important;\n         line-height: 22px !important; /* 1.2em of 18px rounded */\n         width: 100%;\n         box-sizing: border-box;\n     }\n     \n     .currencyList li a:hover {\n         background-color: #F8F8F8;\n         border-color: #008CFF;\n         text-decoration: none;\n     }\n     \n     .currency__icon {\n         width: 48px !important;\n         height: 48px !important;\n         flex-shrink: 0;\n         margin-right: 12px !important;\n         display: flex;\n         align-items: center;\n         justify-content: center;\n     }\n     \n     .currency__icon img {\n         width: 48px !important;\n         height: 48px !important;\n         object-fit: contain;\n     }\n     \n    /* FAQ section styles for lg deviceType */\n     .faqList {\n         margin-top: 16px !important;\n     }\n    \n     .faqList li h4.question {\n        font-size: 16px !important;\n        line-height: 16px !important;\n        padding: 12px 0px !important;\n        font-weight: 400 !important;\n     }\n    \n     .faqList li h4.question::after {\n         top: 12px !important;\n      }\n      \n      .faqList li:hover {\n          box-shadow: none !important;\n          border-color: transparent !important;\n          background-color: transparent !important;\n      }\n      \n      .faqList li:hover h4.question {\n          background-color: transparent !important;\n          box-shadow: none !important;\n          border-radius: none !important;\n      }\n    \n      .faqList li div.answer {\n          font-size: 14px !important;\n          margin-bottom: 16px !important;\n      }\n\n    /* Update benifitsList li::before gradient for lg deviceType */\n    .benifitsList li::before {\n        background-image: linear-gradient(to bottom, #16477F, #16477F) !important;\n    }\n\n    /* Update bestRate li styling to match Figma specifications for lg deviceType */\n    .bestRate li {\n        font-size: 16px !important;\n        line-height: 19.2px !important; /* 1.2em of 16px */\n        font-weight: 400 !important;\n        color: #4A4A4A !important;\n        margin-bottom: 18px !important;\n    }\n\n    /* Update WhyToBuy section styling to match Figma specifications for lg deviceType */\n    .description {\n        font-size: 16px !important;\n        line-height: 19.2px !important; /* 1.2em of 16px */\n        font-weight: 400 !important;\n        color: #4A4A4A !important;\n    }\n\n    .benifitsList li {\n        font-size: 16px !important;\n        line-height: 19.2px !important; /* 1.2em of 16px */\n        font-weight: 400 !important;\n        color: #4A4A4A !important;\n        margin-bottom: 15px !important;\n        padding-left: 25px !important;\n    }\n\n    /* Fix h3 styling for CurrencyInformation section */\n    .h3 {\n        font-size: 22px !important;\n        line-height: 26.4px !important; /* 1.2em of 22px */\n        font-weight: 900 !important;\n        color: #000 !important;\n    }\n\n    /* Fix explore button styling to match Figma */\n    .exploreBtn {\n        width: 120px !important;\n        height: 32px !important;\n        padding: 12px 16px !important;\n        background: linear-gradient(135deg, rgba(83, 178, 254, 1) 0%, rgba(6, 90, 243, 1) 100%) !important;\n        border-radius: 8px !important;\n        display: inline-flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        margin: 24px 0 !important;\n        cursor: pointer !important;\n        box-sizing: border-box !important;\n    }\n\n    .exploreBtn_text {\n        font-size: 12px !important;\n        line-height: 14.4px !important; /* 1.2em of 12px */\n        font-weight: 900 !important;\n        color: #fff !important;\n        text-align: center !important;\n        text-transform: uppercase !important;\n    }\n\n    /* Top banner section styling for lg deviceType */\n    #top-banner {\n        background: url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/bg6.jpg) !important;\n        background-repeat: no-repeat !important;\n        padding-bottom: 40px !important;\n        min-height: auto !important;\n        padding: 0 !important;\n        margin: 0 !important;\n    }\n\n    .top-banner__container {\n        margin: 0 auto !important;\n        padding-top: 32px !important;\n        max-width: 1200px !important;\n    }\n\n    .top-banner__wrapper {\n        padding-bottom: 40px;\n        padding-top: 16px;\n    }\n\n    .top-banner__title {\n        font-size: 36px !important;\n        line-height: 43.2px !important; /* 1.2em of 36px */\n        font-weight: 900 !important;\n        color: #FFFFFF !important;\n        margin: 0 !important;\n    }\n\n    .top-banner__description {\n        color: white;\n        margin-top: 8px;\n        font-weight: 700;\n        line-height: 24px;\n        margin-bottom: 0;\n        font-size: 16px;\n    }\n\n    .top-banner__breadcrumb {\n        margin-top: 16px !important;\n    }\n\n//     /* Add down arrow to Show More section for lg deviceType only */\n//     .viewMore__cta {\n//         display: inline-flex !important;\n//         align-items: center !important;\n//         gap: 4px !important;\n//     }\n\n//     .viewMore__cta::after {\n//         content: \"\";\n//         width: 0;\n//         height: 0;\n//         border-left: 4px solid transparent;\n//         border-right: 4px solid transparent;\n//         border-top: 5px solid #008CFF;\n//         transition: transform 0.2s ease;\n//     }\n\n//     /* Rotate arrow when expanded (Show Less state) */\n//     .showAll .viewMore__cta::after {\n//         transform: rotate(180deg);\n//     }\n//   " : "";
}, function (props) {
  return props.deviceType !== "lg" ? "\n    header{ padding: 10px 16px;}\n    .heroSection{ padding: 0 16px;}\n    .heroContent__left{ width: 48%;}\n    .heroContent__right{ width: 48%;}\n    .pageContainer{ margin: 30px auto; padding: 0 16px;}\n    .convertCurrency{ padding: 20px 30px;}\n    .forexServices__itemHdr{ flex-direction: column;}\n    .conversionRate{ gap: 30px;}\n    .capSulesList.grid5, .capSulesList.grid4{ \n        grid-template-columns: repeat(3, 1fr) !important;\n        gap: 16px !important;\n    }\n    .capSulesList li {\n        padding: 16px 18px !important;\n        background-color: #fff !important;\n        font-size: 14px !important;\n        font-weight: 700 !important;\n        color: #005cbc !important;\n        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;\n    }\n    .currencyList.grid5, .currencyList.grid4{ \n        grid-template-columns: repeat(3, 1fr) !important;\n        gap: 16px !important;\n    }\n    .currencyList li a {\n        padding: 14px 16px !important;\n        background-color: #fff !important;\n        font-size: 14px !important;\n        font-weight: 700 !important;\n        color: #005cbc !important;\n        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;\n        border: none !important;\n        border-radius: 6px !important;\n        min-height: auto !important;\n    }\n    .currency__icon {\n        width: 40px !important;\n        margin-right: 10px !important;\n    }\n    .currency__icon img {\n        width: 40px !important;\n        height: 40px !important;\n    }\n    .currencyList{ grid-template-columns: repeat(3, 1fr);}\n    .faqList li {\n        border-radius: 8px !important;\n        margin-bottom: 24px !important;\n        padding: 16px !important;\n        border: 1px solid #E5E5E5 !important;\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;\n    }\n    .faqList li h4.question{ \n        padding: 16px 50px 16px 0 !important;\n        font-size: 18px !important;\n        line-height: 24px !important;\n        font-weight: 700 !important;\n    }\n    .faqList li h4.question::after {\n        right: 16px !important;\n        top: 50% !important;\n        margin-top: -6px !important;\n    }\n    .faqList li div.answer {\n        padding: 12px 0 0 0 !important;\n        font-size: 15px !important;\n        line-height: 22px !important;\n    }\n    footer{ padding: 30px 16px;}\n  " : "";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/Header.tsx


function CurrencyRatePageTemplate_Header_Header(_ref) {
  var _currencyData$header;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headerInner",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$header = currencyData.header) === null || _currencyData$header === void 0 ? void 0 : _currencyData$header.logo_redirection,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* MMTLogo */.X, {
          isLight: false
        })
      })
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/Hero.tsx






function CurrencyRatePageTemplate_Hero_Hero(_ref) {
  var _currencyData$hero, _currencyData$hero$ti, _currencyData$hero2, _currencyData$hero3, _currencyData$hero4, _currencyData$hero5;

  var currencyData = _ref.currencyData,
      inrExchangeRate = _ref.inrExchangeRate,
      currCodeToCurrRate = _ref.currCodeToCurrRate,
      switchInrExchnageRate = _ref.switchInrExchnageRate,
      breadcrumb = _ref.breadcrumb;
  var heading1 = currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero = currencyData.hero) === null || _currencyData$hero === void 0 ? void 0 : (_currencyData$hero$ti = _currencyData$hero.title) === null || _currencyData$hero$ti === void 0 ? void 0 : _currencyData$hero$ti.split("Currency Converter")[0];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "heroSection",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "heroSection__inner",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
        breadCrumbData: breadcrumb || []
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "heroContent",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "heroContent__left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "inline",
            children: heading1
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero2 = currencyData.hero) === null || _currencyData$hero2 === void 0 ? void 0 : _currencyData$hero2.desc
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "heroContent_container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "exchange",
              children: ["Exchange Rate \xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "1\xA0"
              }), currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code, " = \xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: [Number(inrExchangeRate).toFixed(Number(inrExchangeRate) > 1 ? 2 : 4), "\xA0"]
              }), " ", "INR"]
            }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero3 = currencyData.hero) === null || _currencyData$hero3 === void 0 ? void 0 : _currencyData$hero3.offer_text) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "hero_cashback",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero4 = currencyData.hero) === null || _currencyData$hero4 === void 0 ? void 0 : _currencyData$hero4.offer_icon,
                alt: "cashback"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
                className: "hero_cashback_text",
                children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero5 = currencyData.hero) === null || _currencyData$hero5 === void 0 ? void 0 : _currencyData$hero5.offer_text
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ForexCalculator, {
          currencyData: currencyData,
          inrExchangeRate: inrExchangeRate,
          currCodeToCurrRate: currCodeToCurrRate,
          switchInrExchnageRate: switchInrExchnageRate,
          templateType: utils/* SEO_TEMPLATE_TYPE.CURRENCY_RATE */.nk.CURRENCY_RATE
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/Introduction.tsx


function Introduction_Introduction(_ref) {
  var _currencyData$introdu;

  var currencyData = _ref.currencyData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "planTrip",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$introdu = currencyData.introduction) === null || _currencyData$introdu === void 0 ? void 0 : _currencyData$introdu.para
    })
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/BestRate.tsx




function BestRate(_ref) {
  var _currencyData$best_cu, _currencyData$best_cu2, _currencyData$best_cu3;

  var currencyData = _ref.currencyData;

  if (!(currencyData !== null && currencyData !== void 0 && currencyData.best_currency_rate_today)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$best_cu = currencyData.best_currency_rate_today) === null || _currencyData$best_cu === void 0 ? void 0 : _currencyData$best_cu.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "bestRate mt20",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$best_cu2 = currencyData.best_currency_rate_today) === null || _currencyData$best_cu2 === void 0 ? void 0 : (_currencyData$best_cu3 = _currencyData$best_cu2.paraList) === null || _currencyData$best_cu3 === void 0 ? void 0 : _currencyData$best_cu3.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
            children: item
          })
        }, index);
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/WhyToBuy.tsx




function WhyToBuy(_ref) {
  var _currencyData$whyToBu, _currencyData$whyToBu2, _currencyData$whyToBu3, _currencyData$whyToBu4, _currencyData$whyToBu5;

  var currencyData = _ref.currencyData;

  if (!(currencyData !== null && currencyData !== void 0 && currencyData.whyToBuy)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$whyToBu = currencyData.whyToBuy) === null || _currencyData$whyToBu === void 0 ? void 0 : _currencyData$whyToBu.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$whyToBu2 = currencyData.whyToBuy) === null || _currencyData$whyToBu2 === void 0 ? void 0 : _currencyData$whyToBu2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "benifitsList",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$whyToBu3 = currencyData.whyToBuy) === null || _currencyData$whyToBu3 === void 0 ? void 0 : (_currencyData$whyToBu4 = _currencyData$whyToBu3.list) === null || _currencyData$whyToBu4 === void 0 ? void 0 : _currencyData$whyToBu4.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
            children: item
          })
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$whyToBu5 = currencyData.whyToBuy) === null || _currencyData$whyToBu5 === void 0 ? void 0 : _currencyData$whyToBu5.end_para
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/HowToBuy.tsx




function HowToBuy(_ref) {
  var _currencyData$howToBu, _currencyData$howToBu2, _currencyData$howToBu3, _currencyData$howToBu4, _currencyData$howToBu5;

  var currencyData = _ref.currencyData;

  if (!(currencyData !== null && currencyData !== void 0 && currencyData.whyToBuy)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$howToBu = currencyData.howToBuy) === null || _currencyData$howToBu === void 0 ? void 0 : _currencyData$howToBu.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$howToBu2 = currencyData.howToBuy) === null || _currencyData$howToBu2 === void 0 ? void 0 : _currencyData$howToBu2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "benifitsList",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$howToBu3 = currencyData.howToBuy) === null || _currencyData$howToBu3 === void 0 ? void 0 : (_currencyData$howToBu4 = _currencyData$howToBu3.list) === null || _currencyData$howToBu4 === void 0 ? void 0 : _currencyData$howToBu4.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
            children: item
          })
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$howToBu5 = currencyData.howToBuy) === null || _currencyData$howToBu5 === void 0 ? void 0 : _currencyData$howToBu5.end_para
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/HowBestPrice.tsx




function HowBestPrice(_ref) {
  var _currencyData$bestRat, _currencyData$bestRat2, _currencyData$bestRat3;

  var currencyData = _ref.currencyData;

  if (!(currencyData !== null && currencyData !== void 0 && currencyData.bestRateComparison)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$bestRat = currencyData.bestRateComparison) === null || _currencyData$bestRat === void 0 ? void 0 : _currencyData$bestRat.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "bestRate mt20",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$bestRat2 = currencyData.bestRateComparison) === null || _currencyData$bestRat2 === void 0 ? void 0 : (_currencyData$bestRat3 = _currencyData$bestRat2.paraList) === null || _currencyData$bestRat3 === void 0 ? void 0 : _currencyData$bestRat3.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
            children: item
          })
        }, index);
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/OtherServices.tsx




function OtherServices_OtherServices(_ref) {
  var _currencyData$other_f, _currencyData$other_f2, _currencyData$other_f3, _currencyData$other_f4;

  var currencyData = _ref.currencyData;

  if (!(currencyData !== null && currencyData !== void 0 && currencyData.other_forex_services)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_f = currencyData.other_forex_services) === null || _currencyData$other_f === void 0 ? void 0 : _currencyData$other_f.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_f2 = currencyData.other_forex_services) === null || _currencyData$other_f2 === void 0 ? void 0 : _currencyData$other_f2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "forexServices",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_f3 = currencyData.other_forex_services) === null || _currencyData$other_f3 === void 0 ? void 0 : (_currencyData$other_f4 = _currencyData$other_f3.cards) === null || _currencyData$other_f4 === void 0 ? void 0 : _currencyData$other_f4.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "forexServices__item",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "forexServices__itemHdr",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "forexServices__itemImg",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item === null || item === void 0 ? void 0 : item.img,
                alt: item === null || item === void 0 ? void 0 : item.title,
                width: "112",
                height: "70"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "forexServices__itemTitle",
              children: item === null || item === void 0 ? void 0 : item.title
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
            className: "description",
            children: item === null || item === void 0 ? void 0 : item.desc
          })]
        }, index);
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/CurrencyInformation.tsx




function CurrencyInformation_CurrencyInformation(_ref) {
  var _currencyData$curr_in, _currencyData$curr_in2, _currencyData$curr_in3;

  var currencyData = _ref.currencyData;

  if (!(currencyData !== null && currencyData !== void 0 && currencyData.curr_information)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in = currencyData.curr_information) === null || _currencyData$curr_in === void 0 ? void 0 : _currencyData$curr_in.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "h3 mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in2 = currencyData.curr_information) === null || _currencyData$curr_in2 === void 0 ? void 0 : _currencyData$curr_in2.sub_title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
      className: "description mt10",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in3 = currencyData.curr_information) === null || _currencyData$curr_in3 === void 0 ? void 0 : _currencyData$curr_in3.desc
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "exploreBtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "exploreBtn",
        onClick: function onClick() {
          var _currencyData$curr_in4;

          window.open(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_in4 = currencyData.curr_information) === null || _currencyData$curr_in4 === void 0 ? void 0 : _currencyData$curr_in4.link, "_self");
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "exploreBtn_text",
          children: "Explore"
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/CurrencyExchangeInformation.tsx




function CurrencyExchangeInformation(_ref) {
  var _currencyData$footer, _currencyData$footer$, _currencyData$footer2, _currencyData$footer3, _currencyData$footer4, _currencyData$footer5, _currencyData$footer6, _currencyData$footer7, _currencyData$footer8;

  var currencyData = _ref.currencyData;

  var _useState = (0,react.useState)(true),
      showViewMore = _useState[0],
      setShowViewMore = _useState[1];

  var handleOnClick = function handleOnClick() {
    setShowViewMore(!showViewMore);
  };

  if (!(currencyData !== null && currencyData !== void 0 && (_currencyData$footer = currencyData.footer) !== null && _currencyData$footer !== void 0 && (_currencyData$footer$ = _currencyData$footer.section_footer) !== null && _currencyData$footer$ !== void 0 && _currencyData$footer$[1])) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$footer2 = currencyData.footer) === null || _currencyData$footer2 === void 0 ? void 0 : (_currencyData$footer3 = _currencyData$footer2.section_footer) === null || _currencyData$footer3 === void 0 ? void 0 : (_currencyData$footer4 = _currencyData$footer3[1]) === null || _currencyData$footer4 === void 0 ? void 0 : _currencyData$footer4.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "capSulesList grid4 ".concat(!showViewMore ? "showAll" : ""),
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$footer5 = currencyData.footer) === null || _currencyData$footer5 === void 0 ? void 0 : (_currencyData$footer6 = _currencyData$footer5.section_footer) === null || _currencyData$footer6 === void 0 ? void 0 : (_currencyData$footer7 = _currencyData$footer6[1]) === null || _currencyData$footer7 === void 0 ? void 0 : (_currencyData$footer8 = _currencyData$footer7.links) === null || _currencyData$footer8 === void 0 ? void 0 : _currencyData$footer8.map(function (card, index) {
        return card === null || card === void 0 ? void 0 : card.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "capsule",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item === null || item === void 0 ? void 0 : item.href,
              target: "_self",
              rel: "noreferrer",
              children: item === null || item === void 0 ? void 0 : item.title
            })
          }, "".concat(item === null || item === void 0 ? void 0 : item.title).concat(index));
        });
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "viewMore",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "viewMore__cta",
        onClick: function onClick() {
          return handleOnClick();
        },
        children: showViewMore ? "Show More" : "Show Less"
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/TopReviewedCurrencies.tsx




function TopReviewedCurrencies(_ref) {
  var _currencyData$footer, _currencyData$footer$, _currencyData$footer$2, _currencyData$footer2, _currencyData$footer3, _currencyData$footer4, _currencyData$footer5;

  var currencyData = _ref.currencyData;

  var _useState = (0,react.useState)(true),
      showViewMore = _useState[0],
      setShowViewMore = _useState[1];

  var handleOnClick = function handleOnClick() {
    setShowViewMore(!showViewMore);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$footer = currencyData.footer) === null || _currencyData$footer === void 0 ? void 0 : (_currencyData$footer$ = _currencyData$footer.section_footer) === null || _currencyData$footer$ === void 0 ? void 0 : (_currencyData$footer$2 = _currencyData$footer$[0]) === null || _currencyData$footer$2 === void 0 ? void 0 : _currencyData$footer$2.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "currencyList grid5 ".concat(!showViewMore ? "showAll" : ""),
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$footer2 = currencyData.footer) === null || _currencyData$footer2 === void 0 ? void 0 : (_currencyData$footer3 = _currencyData$footer2.section_footer) === null || _currencyData$footer3 === void 0 ? void 0 : (_currencyData$footer4 = _currencyData$footer3[0]) === null || _currencyData$footer4 === void 0 ? void 0 : (_currencyData$footer5 = _currencyData$footer4.links) === null || _currencyData$footer5 === void 0 ? void 0 : _currencyData$footer5.map(function (card, index) {
        return card === null || card === void 0 ? void 0 : card.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: item === null || item === void 0 ? void 0 : item.href,
              target: "_self",
              rel: "noreferrer",
              children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "currency__icon",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item === null || item === void 0 ? void 0 : item.icon,
                  alt: "currency",
                  width: "65",
                  height: "65"
                })
              }), item === null || item === void 0 ? void 0 : item.title]
            })
          }, "".concat(item === null || item === void 0 ? void 0 : item.title).concat(index));
        });
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "viewMore",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "viewMore__cta",
        onClick: function onClick() {
          return handleOnClick();
        },
        children: showViewMore ? "Show More" : "Show Less"
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/OtherConversions.tsx




function OtherConversions_OtherConversions(_ref) {
  var _currencyData$other_c, _currencyData$other_c2, _currencyData$other_c3, _currencyData$other_c4, _currencyData$other_c5;

  var currencyData = _ref.currencyData;

  var _useState = (0,react.useState)(true),
      showViewMore = _useState[0],
      setShowViewMore = _useState[1];

  var handleOnClick = function handleOnClick() {
    setShowViewMore(!showViewMore);
  }; // Don't render if no content


  if (!(currencyData !== null && currencyData !== void 0 && (_currencyData$other_c = currencyData.other_conversions) !== null && _currencyData$other_c !== void 0 && _currencyData$other_c.title) || !(currencyData !== null && currencyData !== void 0 && (_currencyData$other_c2 = currencyData.other_conversions) !== null && _currencyData$other_c2 !== void 0 && _currencyData$other_c2.cards)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_c3 = currencyData.other_conversions) === null || _currencyData$other_c3 === void 0 ? void 0 : _currencyData$other_c3.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "capSulesList grid5 ".concat(!showViewMore ? "showAll" : ""),
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_c4 = currencyData.other_conversions) === null || _currencyData$other_c4 === void 0 ? void 0 : (_currencyData$other_c5 = _currencyData$other_c4.cards) === null || _currencyData$other_c5 === void 0 ? void 0 : _currencyData$other_c5.map(function (card, index) {
        var cardTitleCurrency = card === null || card === void 0 ? void 0 : card.title.split(" ")[1];

        if ((currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code) !== cardTitleCurrency) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "capsule",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: card === null || card === void 0 ? void 0 : card.href,
              target: "_self",
              rel: "noreferrer",
              children: card === null || card === void 0 ? void 0 : card.title
            })
          }, "".concat(card === null || card === void 0 ? void 0 : card.title).concat(index));
        }

        return null;
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "viewMore",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "viewMore__cta",
        onClick: function onClick() {
          return handleOnClick();
        },
        children: showViewMore ? "Show More" : "Show Less"
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/Faqs.styles.ts


var Faqs_styles_templateObject;


var FaqsStyle = (0,styled_components_browser_esm.createGlobalStyle)(Faqs_styles_templateObject || (Faqs_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)([".faqList{\n    margin-top: 50px;\n}\n.answer{\n    display:none;\n}\n.toggleAnswer .answer{\n    display:block;\n}\n.faqList li h4.question{\n    font-size: 24px;\n    line-height: 26px;\n    font-weight: 900;\n    color: #000;\n    padding: 30px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.faqList li h4.question::after{\n    content: \"\";\n    border: solid #2f2f2f;\n    display: inline-block;\n    border-width: 0 3px 3px 0;\n    padding: 6px;\n    transform: rotate(45deg);\n    position: absolute;\n    right: 40px;\n    top: 32px;\n}\n.faqList li div.answer{\n    font-size: 18px;\n    line-height: 24px;\n    color: #000;\n    padding: 0 0 0 30px;\n    margin-bottom: 30px;\n}\n.faqList li div.answer span{\n    font-weight: 900;\n}\n.faqList li:hover h4.question{\n    border-radius: 6px;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);\n    background-color: #fff;\n}\n.faqList li.active h4.question::after{\n    transform: rotate(-135deg);\n    top: 42px;\n}\n\n/* Mobile devices */\n@media (min-width: 320px) and (max-width: 767px) {\n    .faqList li{ border-radius: 6px; box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22); background-color: #fff; padding: 20px 10px; margin-bottom: 40px;}\n    .faqList li:last-child{ margin-bottom: 0;}\n    .faqList li:hover h4.question{ border-radius: unset; box-shadow: unset; background-color: unset;}\n    .faqList li h4.question{ padding: 0 60px 0 0; font-size: 18px; line-height: 22px;}\n    .faqList li h4.question::after{ padding: 4px; right: 10px; top: 5px;}\n    .faqList li.active h4.question::after{ top: 10px;}\n    .faqList li div.answer{ margin-bottom: unset; padding: 10px 0 0 0; font-size: 16px;}\n    .faqList li.active{ box-shadow: unset;}\n}\n"])));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/Faqs.tsx






function Faqs_Faqs(_ref) {
  var _currencyData$faqs, _currencyData$faqs2, _currencyData$faqs2$l;

  var currencyData = _ref.currencyData;

  var _useState = (0,react.useState)(-1),
      open = _useState[0],
      setOpen = _useState[1];

  var handleFaq = function handleFaq(index) {
    if (open === index) {
      setOpen(-1);
    } else {
      setOpen(index);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaqsStyle, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$faqs = currencyData.faqs) === null || _currencyData$faqs === void 0 ? void 0 : _currencyData$faqs.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "faqList",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$faqs2 = currencyData.faqs) === null || _currencyData$faqs2 === void 0 ? void 0 : (_currencyData$faqs2$l = _currencyData$faqs2.list) === null || _currencyData$faqs2$l === void 0 ? void 0 : _currencyData$faqs2$l.map(function (faq, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          onClick: function onClick() {
            return handleFaq(index);
          },
          className: "".concat(open === index ? "toggleAnswer" : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: "question",
            children: faq === null || faq === void 0 ? void 0 : faq.ques
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "answer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOMarkdown/* CurrencySEOMarkdown */.O, {
              children: faq === null || faq === void 0 ? void 0 : faq.ans
            })
          })]
        }, index);
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/PopularDenominations.tsx



function PopularDenominations_PopularDenomitations(_ref) {
  var _currencyData$popular, _currencyData$popular2, _currencyData$popular3, _currencyData$popular4;

  var currencyData = _ref.currencyData,
      inrExchageRate = _ref.inrExchageRate;

  // Don't render if no content
  if (!(currencyData !== null && currencyData !== void 0 && (_currencyData$popular = currencyData.popular_denominations) !== null && _currencyData$popular !== void 0 && _currencyData$popular.title)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular2 = currencyData.popular_denominations) === null || _currencyData$popular2 === void 0 ? void 0 : _currencyData$popular2.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "conversionRate",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular3 = currencyData.popular_denominations) === null || _currencyData$popular3 === void 0 ? void 0 : (_currencyData$popular4 = _currencyData$popular3.table) === null || _currencyData$popular4 === void 0 ? void 0 : _currencyData$popular4.map(function (item, tableIndex) {
        var _item$col_name, _item$col_name2, _item$row_value_left_;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "conversionRate__col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: "conversionRate_heading",
            children: item === null || item === void 0 ? void 0 : item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
            className: "conversionTbl",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: item === null || item === void 0 ? void 0 : (_item$col_name = item.col_name) === null || _item$col_name === void 0 ? void 0 : _item$col_name[0]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: item === null || item === void 0 ? void 0 : (_item$col_name2 = item.col_name) === null || _item$col_name2 === void 0 ? void 0 : _item$col_name2[1]
                  })
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
              children: item === null || item === void 0 ? void 0 : (_item$row_value_left_ = item.row_value_left_side) === null || _item$row_value_left_ === void 0 ? void 0 : _item$row_value_left_.map(function (val, index) {
                if (tableIndex === 0) {
                  var _currencyData$curr_co, _currencyData$curr_co2, _currencyData$curr_co3, _currencyData$curr_co4;

                  var href = "/tripmoney/currency-converter/".concat(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co = currencyData.curr_code) === null || _currencyData$curr_co === void 0 ? void 0 : (_currencyData$curr_co2 = _currencyData$curr_co.toLowerCase) === null || _currencyData$curr_co2 === void 0 ? void 0 : _currencyData$curr_co2.call(_currencyData$curr_co), "-to-inr/").concat(val, "-").concat(currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$curr_co3 = currencyData.curr_code) === null || _currencyData$curr_co3 === void 0 ? void 0 : (_currencyData$curr_co4 = _currencyData$curr_co3.toLowerCase) === null || _currencyData$curr_co4 === void 0 ? void 0 : _currencyData$curr_co4.call(_currencyData$curr_co3));
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                        href: href,
                        target: "_self",
                        children: [val, " ", currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      children: [(val * inrExchageRate).toFixed(2), " INR"]
                    })]
                  }, index);
                } else if (tableIndex === 1) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      children: [val, " INR"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      children: [(val / inrExchageRate).toFixed(2), " ", currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code]
                    })]
                  }, index);
                } else {
                  return null;
                }
              })
            })]
          })]
        }, tableIndex);
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/CurrencyExchangeInCity.tsx




function CurrencyExchangeInCity(_ref) {
  var _currencyData$footer, _currencyData$footer$, _currencyData$footer2, _currencyData$footer3, _currencyData$footer4, _currencyData$footer5, _currencyData$footer6, _currencyData$footer7, _currencyData$footer8;

  var currencyData = _ref.currencyData;

  var _useState = (0,react.useState)(true),
      showViewMore = _useState[0],
      setShowViewMore = _useState[1];

  var handleOnClick = function handleOnClick() {
    setShowViewMore(!showViewMore);
  };

  if (!(currencyData !== null && currencyData !== void 0 && (_currencyData$footer = currencyData.footer) !== null && _currencyData$footer !== void 0 && (_currencyData$footer$ = _currencyData$footer.section_footer) !== null && _currencyData$footer$ !== void 0 && _currencyData$footer$[2])) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "h2",
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$footer2 = currencyData.footer) === null || _currencyData$footer2 === void 0 ? void 0 : (_currencyData$footer3 = _currencyData$footer2.section_footer) === null || _currencyData$footer3 === void 0 ? void 0 : (_currencyData$footer4 = _currencyData$footer3[2]) === null || _currencyData$footer4 === void 0 ? void 0 : _currencyData$footer4.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "capSulesList grid4 ".concat(!showViewMore ? "showAll" : ""),
      children: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$footer5 = currencyData.footer) === null || _currencyData$footer5 === void 0 ? void 0 : (_currencyData$footer6 = _currencyData$footer5.section_footer) === null || _currencyData$footer6 === void 0 ? void 0 : (_currencyData$footer7 = _currencyData$footer6[2]) === null || _currencyData$footer7 === void 0 ? void 0 : (_currencyData$footer8 = _currencyData$footer7.links) === null || _currencyData$footer8 === void 0 ? void 0 : _currencyData$footer8.map(function (card, index) {
        return card === null || card === void 0 ? void 0 : card.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "capsule",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item === null || item === void 0 ? void 0 : item.href,
              target: "_self",
              rel: "noreferrer",
              children: item === null || item === void 0 ? void 0 : item.title
            })
          }, "".concat(item === null || item === void 0 ? void 0 : item.title).concat(index));
        });
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "viewMore",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "viewMore__cta",
        onClick: function onClick() {
          return handleOnClick();
        },
        children: showViewMore ? "Show More" : "Show Less"
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/CurrencyRatePageTemplate.tsx
















 // import { CurrencyFooter } from "./CurrencyFooter";










 // Wrapper component to handle deviceType logic





var CurrencyRatePageTemplate_SectionWrapper = function SectionWrapper(_ref) {
  var children = _ref.children,
      deviceType = _ref.deviceType;

  if (deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "sectionWrapper",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: children
  });
};

var CurrencyRatePageTemplate = function CurrencyRatePageTemplate(_ref2) {
  var _currencyData$hero, _currencyData$hero$ti, _currencyData$hero2, _PAGE_NAMES$SEO_CURRE2, _currencyData$introdu, _currencyData$popular, _currencyData$other_c, _currencyData$other_c2;

  var id = _ref2.id,
      currencyData = _ref2.currencyData,
      inrExchangeRate = _ref2.inrExchangeRate,
      currCodeToCurrRate = _ref2.currCodeToCurrRate,
      switchInrExchnageRate = _ref2.switchInrExchnageRate,
      canonicalHref = _ref2.canonicalHref,
      deviceType = _ref2.deviceType;
  var isBot = (0,hooks/* useBotDetection */.Um)();
  (0,react.useEffect)(function () {
    var _PAGE_NAMES$SEO_CURRE;

    (0,analytics/* trackSeoPageLoad */.XE)({
      pageName: (_PAGE_NAMES$SEO_CURRE = analytics/* PAGE_NAMES.SEO_CURRENCY_RATE */.a3.SEO_CURRENCY_RATE) === null || _PAGE_NAMES$SEO_CURRE === void 0 ? void 0 : _PAGE_NAMES$SEO_CURRE.replace("NAME", "".concat(currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code)),
      currency: currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code
    });
  }, []);
  var heading1 = currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero = currencyData.hero) === null || _currencyData$hero === void 0 ? void 0 : (_currencyData$hero$ti = _currencyData$hero.title) === null || _currencyData$hero$ti === void 0 ? void 0 : _currencyData$hero$ti.split("Currency Converter")[0];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* FontStyles */.B2, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencySEOCommonUI/* BaseStyles */.xR, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageStyle, {
      deviceType: deviceType
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_CurrencyDocument, {
      currencyData: currencyData,
      canonicalHref: canonicalHref
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_Header_Header, {
        currencyData: currencyData
      }), deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_Hero_Hero, {
        currencyData: currencyData,
        inrExchangeRate: inrExchangeRate,
        currCodeToCurrRate: currCodeToCurrRate,
        switchInrExchnageRate: switchInrExchnageRate,
        breadcrumb: currencyData === null || currencyData === void 0 ? void 0 : currencyData.breadcrumb
      }), deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroWebV2/* HeroWebV2 */.F, {
        title: heading1,
        desc: currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$hero2 = currencyData.hero) === null || _currencyData$hero2 === void 0 ? void 0 : _currencyData$hero2.desc,
        breadcrumb: (currencyData === null || currencyData === void 0 ? void 0 : currencyData.breadcrumb) || [],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_cjs/* ListingUiWrapper */.ev, {
          source_type: "seo",
          isBot: isBot,
          deviceType: deviceType,
          page_name: "currency_rate"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "pageContainerWrapper ".concat(deviceType === utils/* DEVICE_SIZES.LARGE */.Ts.LARGE ? "pageContainerWrapper--large" : "pageContainerWrapper--small"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pageContainer",
          children: [deviceType === utils/* DEVICE_SIZES.SMALL */.Ts.SMALL && /*#__PURE__*/(0,jsx_runtime.jsx)(ForexProducts/* default */.Z, {
            currencyData: currencyData,
            pageName: (_PAGE_NAMES$SEO_CURRE2 = analytics/* PAGE_NAMES.SEO_CURRENCY_RATE */.a3.SEO_CURRENCY_RATE) === null || _PAGE_NAMES$SEO_CURRE2 === void 0 ? void 0 : _PAGE_NAMES$SEO_CURRE2.replace("NAME", "".concat(currencyData === null || currencyData === void 0 ? void 0 : currencyData.curr_code)),
            templateType: utils/* SEO_TEMPLATE_TYPE.CURRENCY_RATE */.nk.CURRENCY_RATE
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "pageContent",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner_Banner, {
              currencyData: currencyData
            }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$introdu = currencyData.introduction) === null || _currencyData$introdu === void 0 ? void 0 : _currencyData$introdu.para) && /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Introduction_Introduction, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BestRate, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhyToBuy, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(HowToBuy, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(HowBestPrice, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(OtherServices_OtherServices, {
                currencyData: currencyData
              })
            }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$popular = currencyData.popular_denominations) === null || _currencyData$popular === void 0 ? void 0 : _currencyData$popular.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PopularDenominations_PopularDenomitations, {
                currencyData: currencyData,
                inrExchageRate: inrExchangeRate
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyInformation_CurrencyInformation, {
                currencyData: currencyData
              })
            }), (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_c = currencyData.other_conversions) === null || _currencyData$other_c === void 0 ? void 0 : _currencyData$other_c.title) && (currencyData === null || currencyData === void 0 ? void 0 : (_currencyData$other_c2 = currencyData.other_conversions) === null || _currencyData$other_c2 === void 0 ? void 0 : _currencyData$other_c2.cards) && /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(OtherConversions_OtherConversions, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs_Faqs, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TopReviewedCurrencies, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyExchangeInformation, {
                currencyData: currencyData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyRatePageTemplate_SectionWrapper, {
              deviceType: deviceType,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyExchangeInCity, {
                currencyData: currencyData
              })
            })]
          })]
        })
      }), currencyData !== null && currencyData !== void 0 && currencyData.footer ? /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyFooter/* CurrencyFooter */.H, {
        footer: currencyData === null || currencyData === void 0 ? void 0 : currencyData.footer,
        hideTopLinks: true
      }) : null]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/CurrencyRatePageTemplate/index.tsx

;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/index.ts

















/***/ }),

/***/ 5537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tZ": function() { return /* reexport */ akamaiGetDevice; },
  "cB": function() { return /* reexport */ utils/* checkIsBot */.cB; },
  "JA": function() { return /* reexport */ utils/* convertToPascalCase */.JA; },
  "_i": function() { return /* reexport */ utils/* fetcher */._i; },
  "O8": function() { return /* reexport */ utils/* getFutureDate */.O8; },
  "yL": function() { return /* reexport */ utils/* isHostMMT */.yL; },
  "_g": function() { return /* reexport */ utils/* serverRuntimeConfig */.nL; },
  "t": function() { return /* reexport */ utils.t; }
});

// UNUSED EXPORTS: ClientError, SHORT_WEEK_DAYS, TRIPMONEY_MMT_DOMAIN_NAMES, addDaysToDate, convertDateToUnix, convertEpochToDate, convertEpochToDateFullMonth, convertToSnakeCase, convertUnixToDate, dateFormator, dateSeprationHandler, deleteLocalStorage, detectDeviceFromAkamaiHeader, disableEncrytionInWeb, domainRedirect, doubleDigitCreator, fetchApi, fetchutmParamsFromCookie, filterByType, fontWeight, formUrlForRedirection, formatDate, generateRandomIndex, generateRandomNum, getAttributesByType, getCookie, getCurrCodeToCurrRate, getDeviceModelType, getDeviceType, getHost, getHostName, getLocalStorage, getMobileOperatingSystem, getSessionStorageItem, getUtilOptions, getWordsMap, gsspAkamaiGetDevice, hasValidData, isHostMakemytrip, isMobile, isNullOrUndefined, isObject, isOnServer, isValidDate, isValidPage, isValidUrl, loadGTM, mergeDeep, permanentRedirectToUrl, persistutmParamsInCookie, randomizeCurrencyCards, randomizeFaqs, randomizeFooterSections, redirectInterceptHref, redirectWithDeferredTime, removeCookie, removeSessionStorageItem, setCookie, setLocalStorage, setSessionStorageItem, subtractDurationFromDate, subtractYrsFromDate, template, thankYouGtmPageLoadedEvent

;// CONCATENATED MODULE: ../../libs/utility/src/lib/theme/font-weight/index.ts
var fontWeight = {
  regular: 400,
  bold: 700,
  black: 900
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/index.ts + 2 modules
var utils = __webpack_require__(4270);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/api/index.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function fetchApi(_x) {
  return _fetchApi.apply(this, arguments);
}

function _fetchApi() {
  _fetchApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var options,
        _options$maxRetries,
        maxRetries,
        _options$retryDelay,
        retryDelay,
        _options$headers,
        headers,
        _options$method,
        method,
        _options$data,
        data,
        retries,
        controller,
        signal,
        response,
        responseData,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _options$maxRetries = options.maxRetries, maxRetries = _options$maxRetries === void 0 ? 1 : _options$maxRetries, _options$retryDelay = options.retryDelay, retryDelay = _options$retryDelay === void 0 ? 1000 : _options$retryDelay, _options$headers = options.headers, headers = _options$headers === void 0 ? {} : _options$headers, _options$method = options.method, method = _options$method === void 0 ? "GET" : _options$method, _options$data = options.data, data = _options$data === void 0 ? null : _options$data;
            retries = 1;

          case 3:
            if (!(retries <= maxRetries)) {
              _context.next = 34;
              break;
            }

            _context.prev = 4;
            controller = new AbortController();
            signal = controller.signal;
            _context.next = 9;
            return fetch(url, {
              method: method,
              headers: _objectSpread({
                "Content-Type": "application/json"
              }, headers),
              body: data && JSON.stringify(data),
              signal: signal
            });

          case 9:
            response = _context.sent;

            if (!(response.status === 500)) {
              _context.next = 12;
              break;
            }

            throw new Error("Internal Server Error");

          case 12:
            if (!(response.status === 404)) {
              _context.next = 14;
              break;
            }

            throw new Error("Resource Not Found");

          case 14:
            if (response.ok) {
              _context.next = 16;
              break;
            }

            throw new Error("Something went wrong. Please try again later.");

          case 16:
            _context.next = 18;
            return response.json();

          case 18:
            responseData = _context.sent;
            return _context.abrupt("return", responseData);

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](4);

            if (!(_context.t0.name === "AbortError")) {
              _context.next = 27;
              break;
            }

            console.error("Request cancelled");
            throw new Error("Request cancelled");

          case 27:
            console.error(_context.t0);
            retries++;
            _context.next = 31;
            return new Promise(function (resolve) {
              return setTimeout(resolve, retryDelay);
            });

          case 31:
            return _context.abrupt("continue", 3);

          case 32:
            _context.next = 3;
            break;

          case 34:
            throw new Error("Failed to fetch API after ".concat(maxRetries, " attempts."));

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 22]]);
  }));
  return _fetchApi.apply(this, arguments);
}
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(3815);
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(9128);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/akamaiGetDevice/index.ts
function akamaiGetDevice() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isTabletHeader = headers["tablet-device"];
  var isMobileHeader = headers["mobile-device"];
  var device = "desktop";

  switch ("true") {
    case isTabletHeader:
      device = "tablet";
      break;

    case isMobileHeader:
      device = "mobile";
      break;

    default:
      device = "desktop";
  }

  return device;
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(129);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(9017);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(8200);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(303);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/ClientError/index.ts







function _createSuper(Derived) { var hasNativeReflectConstruct = ClientError_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ClientError_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ClientError = /*#__PURE__*/function (_Error) {
  (0,inherits/* default */.Z)(ClientError, _Error);

  var _super = _createSuper(ClientError);

  function ClientError(message) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ClientError);

    _this = _super.call(this);
    _this.message = message;
    return _this;
  }

  (0,createClass/* default */.Z)(ClientError, [{
    key: "getErrorMessage",
    value: function getErrorMessage() {
      return this.message;
    }
  }]);

  return ClientError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
;// CONCATENATED MODULE: ../../libs/utility/src/lib/deviceDetection/index.ts
/**
 * Device detection utilities for server-side rendering
 */
// Device size constants - keeping local to avoid circular dependencies
var DEVICE_SIZES = {
  LARGE: "lg",
  SMALL: "sm"
};

/**
 * Detects device type from Akamai x-akamai-device-characteristics header
 *
 * @param headers - Request headers object
 * @returns Device size ("lg" | "sm") or null if header not present
 *
 * @example
 * ```typescript
 * import { detectDeviceFromAkamaiHeader } from "@tm/utility";
 *
 * export async function getServerSideProps(context) {
 *   const { req } = context;
 *   const deviceType = detectDeviceFromAkamaiHeader(req.headers);
 *
 *   return {
 *     props: { deviceType }
 *   };
 * }
 * ```
 */
function detectDeviceFromAkamaiHeader() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var akamaiDeviceHeader = headers["x-akamai-device-characteristics"];

  if (!akamaiDeviceHeader) {
    return null;
  } // Handle both string and string[] cases


  var headerValue = Array.isArray(akamaiDeviceHeader) ? akamaiDeviceHeader[0] : akamaiDeviceHeader;

  if (headerValue !== null && headerValue !== void 0 && headerValue.includes("is_mobile=true")) {
    return DEVICE_SIZES.SMALL;
  } else {
    return DEVICE_SIZES.LARGE;
  }
} // Export the constants for convenience


;// CONCATENATED MODULE: ../../libs/utility/src/index.ts














/***/ }),

/***/ 8217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a3": function() { return /* reexport */ constants_PAGE_NAMES; },
  "AB": function() { return /* binding */ pushEvent; },
  "XE": function() { return /* reexport */ trackSeoPageLoad; }
});

// UNUSED EXPORTS: CN, COOKIES, CURRENCY_PAGE_AND_CATEGORY_MAP, LOGGED_IN, NOT_LOGGED_IN, OMNITURE_MAP, OMNI_EVENTS_MAP, PAGE_AND_CATEGORY_MAP, PAGE_NAME_MAP, USER_LOCATION_LOCAL_STORAGE_KEY, trackListingClickEvents, trackPageLoad

;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/internal.ts
function injectPlatform(eventObj) {
  var _eventObj$page, _eventObj$page2, _eventObj$page2$pageI;

  var isPageViewEvent = ["pageView", "errorScreen"].includes(eventObj === null || eventObj === void 0 ? void 0 : eventObj.event);
  var missingPlatform = (eventObj === null || eventObj === void 0 ? void 0 : (_eventObj$page = eventObj.page) === null || _eventObj$page === void 0 ? void 0 : _eventObj$page.pageInfo) && !(eventObj !== null && eventObj !== void 0 && (_eventObj$page2 = eventObj.page) !== null && _eventObj$page2 !== void 0 && (_eventObj$page2$pageI = _eventObj$page2.pageInfo) !== null && _eventObj$page2$pageI !== void 0 && _eventObj$page2$pageI.platform);

  if (isPageViewEvent && missingPlatform) {
    eventObj.page.pageInfo.platform = /Mobile|Android|BlackBerry/.test(navigator.userAgent) ? "mweb" : "desktop";
  }
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/forexEvents/constants.ts


var _OMNITURE_MAP;

var constants_USER_LOCATION_LOCAL_STORAGE_KEY = "user_location";
var constants_PAGE_NAMES = {
  LISTING: "LISTING",
  FOREX_DASHBOARD: "FOREX_DASHBOARD",
  FOREX_THANKS: "FOREX_THANKS",
  SEO_CURRENCY: "seo:tripmoney forex:currency",
  SEO_CURRENCY_NAME: "seo:tripmoney forex:currency:details",
  SEO_CURRENCY_CONVERTER: "seo:tripmoney forex:currency:converter",
  SEO_CURRENCY_EXCHANGE_CITY: "seo:tripmoney forex:currency:exchange",
  SEO_CURRENCY_EXCHANGE_AIRPORT: "seo:tripmoney forex:currency:exchange:airport",
  SEO_CURRENCY_EXCHANGE_AREA: "seo:tripmoney forex:currency:exchange:area",
  SEO_CURRENCY_RATE: "seo:tripmoney forex:currency:rate"
};
var PAGE_NAME_MAP = {
  LISTING: "landing:tripmoney forex:landing",
  FOREX_DASHBOARD: "funnel:tripmoney forex:dashboard",
  FOREX_THANKS: "funnel:tripmoney forex:thankyou",
  FOREX_AWAITING_PAYMENT_STATUS: "funnel:tripmoney forex:awaitingPaymentStatus"
};
var OMNI_EVENTS_MAP = {
  PAGE_NAME: "pageName",
  LOB: "lob",
  SITE_SECTION: "siteSection",
  BOTTOM_SHEET_TRIGGER: "bottomSheetTrigger",
  FUNNEL_TYPE: "funnelType",
  USER_LOC: "userLocation",
  CTA_INFO: "ctaInfo",
  INTERACTION_ID: "interactionID",
  LOGIN_STATUS: "loginStatus",
  BOOKING_STATUS: "bookingStatus",
  DASHBOARD_STATES: "dashboardStates",
  PLATFORM: "platform",
  AMOUNT: "amount",
  ERROR_CODE: "errorCode",
  CURRIENCIES_SELECTED: "currienciesSelected",
  EVENTS: "events",
  PURCHASE_ID: "purchaseID",
  DESTINATION: "destination",
  TRAVEL_START_DATE: "travel_start_date",
  TRAVEL_END_DATE: "travel_end_date",
  UPCOMING_TRIP_DETECTED: "upcoming_trip_detected"
};
var constants_OMNITURE_MAP = (_OMNITURE_MAP = {}, (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.PAGE_NAME, "eVar15"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.LOB, "eVar24"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.SITE_SECTION, "channel"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.BOTTOM_SHEET_TRIGGER, "event327"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.FUNNEL_TYPE, "eVar108"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.USER_LOC, "eVar32"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "ApWindow", "eVar7"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.CTA_INFO, "prop67"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "previousPageName", "prop23"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.INTERACTION_ID, "eVar16"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.LOGIN_STATUS, "eVar39"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "uuid", "eVar20"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "travelPurpose", "eVar9"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, "freeCardOpted", "prop52"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.BOOKING_STATUS, "eVar14"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.DASHBOARD_STATES, "prop67"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.PLATFORM, "eVar75"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.AMOUNT, "event328"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.ERROR_CODE, "eVar22"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.CURRIENCIES_SELECTED, "eVar46"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.EVENTS, "events"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.PURCHASE_ID, "purchaseID"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.DESTINATION, "eVar31"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.TRAVEL_START_DATE, "eVar4"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.TRAVEL_END_DATE, "eVar5"), (0,defineProperty/* default */.Z)(_OMNITURE_MAP, OMNI_EVENTS_MAP.UPCOMING_TRIP_DETECTED, "eVar70"), _OMNITURE_MAP);
var LOB_NAME = {
  FOREX_CARDS: "tripmoney forex card",
  PS_FOREX_CARDS: "ps tripmoney forex card",
  FOREX_CURRENCY: "tripmoney forex currency"
};
var SITE_SECTION = {
  LANDING: "landing",
  FUNNEL: " tripmoney forex funnel card",
  NA: "",
  CN_FUNNEL: "tripmoney forex funnel currency"
};
var constants_PAGE_AND_CATEGORY_MAP = {
  LISTING: {
    pageName: PAGE_NAME_MAP.LISTING,
    lob: LOB_NAME.FOREX_CARDS,
    siteSection: SITE_SECTION.LANDING
  },
  FOREX_DASHBOARD: {
    pageName: PAGE_NAME_MAP.FOREX_DASHBOARD,
    lob: LOB_NAME.PS_FOREX_CARDS,
    siteSection: SITE_SECTION.NA
  },
  FOREX_THANKS: {
    pageName: PAGE_NAME_MAP.FOREX_THANKS,
    lob: LOB_NAME.FOREX_CARDS,
    siteSection: SITE_SECTION.FUNNEL
  }
};
var constants_CURRENCY_PAGE_AND_CATEGORY_MAP = {
  LISTING: {
    pageName: PAGE_NAME_MAP.LISTING,
    lob: LOB_NAME.FOREX_CURRENCY,
    siteSection: SITE_SECTION.LANDING
  },
  FOREX_DASHBOARD: {
    pageName: PAGE_NAME_MAP.FOREX_DASHBOARD,
    lob: LOB_NAME.FOREX_CURRENCY,
    siteSection: SITE_SECTION.NA
  },
  FOREX_THANKS: {
    pageName: PAGE_NAME_MAP.FOREX_THANKS,
    lob: LOB_NAME.FOREX_CURRENCY,
    siteSection: SITE_SECTION.CN_FUNNEL
  }
};
var constants_COOKIES = {
  TM_AUTH_KEY: "x-tm-auth"
};
var constants_LOGGED_IN = "Loggedin";
var constants_NOT_LOGGED_IN = "Not Loggedin";
var constants_CN = "CN";
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/common.ts

function common_trackEventMweb(omniData) {
  var _window;

  if ((_window = window) !== null && _window !== void 0 && _window.omniscriptLoaded && typeof window.s !== "undefined") {
    for (var _i = 0, _Object$entries = Object.entries(omniData); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      window.s[key] = value;
    }

    window.s.t();
  } else {
    var _window$omnidata;

    (_window$omnidata = window.omnidata) === null || _window$omnidata === void 0 ? void 0 : _window$omnidata.push(omniData);
  }
}
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/index.ts + 2 modules
var utils = __webpack_require__(4270);
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(9128);
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(3815);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/forexEvents/utils.ts




function utils_getLogInStatus() {
  var isLoggedInCookie = getCookie(COOKIES.TM_AUTH_KEY, true);
  var status = isLoggedInCookie ? LOGGED_IN : NOT_LOGGED_IN;
  return status;
}
function utils_getUserCityAndLocation() {
  var _getSessionStorageIte;

  if (isOnServer()) return "";
  var userLocation = "";

  var _ref = (_getSessionStorageIte = getSessionStorageItem(USER_LOCATION_LOCAL_STORAGE_KEY, true, {
    isPiiData: true,
    shouldParseJson: true
  })) !== null && _getSessionStorageIte !== void 0 ? _getSessionStorageIte : {},
      _ref$city = _ref.city,
      city = _ref$city === void 0 ? "" : _ref$city,
      _ref$pincode = _ref.pincode,
      pincode = _ref$pincode === void 0 ? "" : _ref$pincode;

  userLocation = city && pincode ? "".concat(city, ",").concat(pincode) : "";
  return userLocation;
}
function getDevice() {
  var _navigator;

  if (isOnServer() || !navigator) return "";
  var ua = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) || "";
  var device = getDeviceType(ua) || "";
  return device;
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts
var src = __webpack_require__(9666);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/forexEvents/impression.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var DASHBOARD_STATES = OMNI_EVENTS_MAP.DASHBOARD_STATES,
    INTERACTION_ID = OMNI_EVENTS_MAP.INTERACTION_ID,
    BOOKING_STATUS = OMNI_EVENTS_MAP.BOOKING_STATUS,
    EVENTS = OMNI_EVENTS_MAP.EVENTS,
    PURCHASE_ID = OMNI_EVENTS_MAP.PURCHASE_ID;
var CITY = src.OMNI_EVENTS_MAP.CITY,
    CURRENCY = src.OMNI_EVENTS_MAP.CURRENCY,
    DENOMINATION = src.OMNI_EVENTS_MAP.DENOMINATION; // function for page load events

function trackPageLoad(deps) {
  try {
    var _ref5;

    var page = deps.pageName,
        partner = deps.partner,
        orderStatus = deps.orderStatus,
        orderID = deps.orderID,
        bookingStatus = deps.bookingStatus,
        _deps$code = deps.code,
        code = _deps$code === void 0 ? "PC" : _deps$code,
        events = deps.events,
        purchaseID = deps.purchaseID,
        upcomingTrip = deps.upcomingTrip;

    var _ref = code === CN ? CURRENCY_PAGE_AND_CATEGORY_MAP[page] : PAGE_AND_CATEGORY_MAP[page],
        pageName = _ref.pageName,
        lob = _ref.lob,
        siteSection = _ref.siteSection;

    var location = getUserCityAndLocation();
    var platform = getDeviceTypeForOmniture() || "";
    var loginStatus = getLogInStatus();
    var commonOmniData = getCommonOmniData({
      pageName: pageName,
      lob: lob,
      siteSection: siteSection,
      partner: partner,
      location: location,
      platform: platform,
      loginStatus: loginStatus,
      code: code,
      upcomingTrip: upcomingTrip
    });

    var omniData = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, commonOmniData), orderStatus && _defineProperty({}, OMNITURE_MAP[DASHBOARD_STATES], orderStatus)), orderID && _defineProperty({}, OMNITURE_MAP[INTERACTION_ID], orderID)), bookingStatus && _defineProperty({}, OMNITURE_MAP[BOOKING_STATUS], bookingStatus)), events && purchaseID && (_ref5 = {}, _defineProperty(_ref5, OMNITURE_MAP[EVENTS], events), _defineProperty(_ref5, OMNITURE_MAP[PURCHASE_ID], purchaseID), _ref5));

    trackEventMweb(_objectSpread(_objectSpread({}, omniData), {}, {
      pageName: pageName
    }));
  } catch (e) {
    console.error(e);
  }
} // function for seo page load events

function trackSeoPageLoad(deps) {
  try {
    var pageName = deps.pageName,
        city = deps.city,
        currency = deps.currency,
        denomination = deps.denomination,
        cardClicked = deps.cardClicked;
    var commonOmniData = (0,src.getCommonSeoOmniData)({
      pageName: pageName
    });

    var omniData = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, commonOmniData), city && (0,defineProperty/* default */.Z)({}, src.OMNITURE_MAP[CITY], city)), currency && (0,defineProperty/* default */.Z)({}, src.OMNITURE_MAP[CURRENCY], currency)), denomination && (0,defineProperty/* default */.Z)({}, src.OMNITURE_MAP[DENOMINATION], denomination)), cardClicked && (0,defineProperty/* default */.Z)({}, src.OMNITURE_MAP.freeCardOpted, cardClicked));

    common_trackEventMweb(_objectSpread(_objectSpread({}, omniData), {}, {
      pageName: pageName
    }));
  } catch (e) {
    console.error(e);
  }
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/forexEvents/click.ts


function click_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function click_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? click_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : click_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var CTA_INFO = OMNI_EVENTS_MAP.CTA_INFO; //  listing click events

function trackListingClickEvents(deps) {
  try {
    var actionType = deps.actionType,
        partner = deps.partner;
    var _PAGE_AND_CATEGORY_MA = PAGE_AND_CATEGORY_MAP[PAGE_NAMES["LISTING"]],
        pageName = _PAGE_AND_CATEGORY_MA.pageName,
        lob = _PAGE_AND_CATEGORY_MA.lob,
        siteSection = _PAGE_AND_CATEGORY_MA.siteSection;
    var location = getUserCityAndLocation();
    var platform = getDeviceTypeForOmniture() || "";
    var loginStatus = getLogInStatus();
    var commonOmniData = getCommonOmniData({
      pageName: pageName,
      lob: lob,
      siteSection: siteSection,
      partner: partner,
      location: location,
      platform: platform,
      loginStatus: loginStatus
    });

    var omniData = click_objectSpread(click_objectSpread({}, commonOmniData), {}, _defineProperty({}, OMNITURE_MAP[CTA_INFO], actionType));

    trackEventMweb(click_objectSpread(click_objectSpread({}, omniData), {}, {
      pageName: pageName
    }));
  } catch (e) {
    console.error(e);
  }
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/forexEvents/index.ts
/* Use impression for load/view  events. 
   click for onclick an other events 
 */



;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/index.ts


var pushEvent = function pushEvent(eventObj) {
  var isClientSide = typeof navigator !== "undefined" && true;
  if (!isClientSide) return;
  injectPlatform(eventObj); // @ts-ignore

  window.adobeDataLayer = window.adobeDataLayer || []; // @ts-ignore

  window.adobeDataLayer.push(eventObj);
};

/***/ }),

/***/ 9753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* binding */ API; },
  "vT": function() { return /* binding */ ElementNameMapping; },
  "BA": function() { return /* reexport */ LINKS; },
  "XH": function() { return /* binding */ PageNameMapping; },
  "Rw": function() { return /* binding */ SectionNameMapping; },
  "J6": function() { return /* binding */ UTM_PARAMS_KEY; },
  "cA": function() { return /* binding */ cities; },
  "zh": function() { return /* binding */ getCamelCaseStr; },
  "QB": function() { return /* binding */ getElementUniqueIds; }
});

// UNUSED EXPORTS: API_NAME, BASE_URL, BREAKPOINT, DATE_FORMATS, LISTING_API_PATH, cityCSSPosition, foreignCities

;// CONCATENATED MODULE: ../../libs/utility/src/lib/constants/cityCSSPosition.ts
var cityCSSPosition = {
  "new delhi": [733, 632],
  gurugram: [733, 632],
  noida: [733, 632],
  ghaziabad: [733, 632],
  lucknow: [816, 677],
  mumbai: [636, 865],
  bengaluru: [741, 1006],
  hyderabad: [761, 904],
  chennai: [800, 1003],
  kolkata: [981, 781],
  ahmedabad: [629, 771],
  pune: [656, 877],
  cochin: [713, 1077],
  goa: [660, 951],
  jaipur: [701, 675],
  guwahati: [1055, 694],
  chandigarh: [723, 580],
  patna: [912, 708],
  trivandrum: [726, 1106],
  varanasi: [859, 714],
  leh: [742, 490],
  allahabad: [837, 709],
  kochi: [714, 1078],
  dubai: [234, 717],
  sharjah: [234, 717],
  sydney: [2396, 2105],
  "abu dhabi": [234, 717],
  bhopal: [734, 768],
  vijaywada: [805, 929],
  ranchi: [912, 768],
  nagpur: [773, 819],
  haldwani: [781, 623],
  kozhikode: [698, 1050],
  "north 24 parganas": [992, 784],
  salem: [750, 1039],
  raipur: [829, 815],
  coimbatore: [726, 1058],
  surat: [634, 823],
  indore: [702, 784],
  meerut: [742, 631],
  jhajjar: [718, 635],
  jetpur: [583, 807],
  bhubaneswar: [928, 843],
  faridabad: [734, 643],
  udaipur: [650, 737],
  "dakshina kannada": [686, 1015],
  "gautam buddha nagar": [738, 643],
  "kamrup metropolitan": [1063, 698],
  kelambakkam: [793, 1015],
  visakhapatnam: [865, 901],
  madurai: [746, 1078],
  quilon: [718, 1102],
  vadodara: [635, 792],
  thane: [635, 867],
  guntur: [802, 933],
  thiruvananthapuram: [722, 1110],
  "nong prue sub": [1266, 1016],
  jabalpur: [790, 769],
  kannur: [690, 1035],
  darjeeling: [976, 675],
  "pimpri chinchwad": [655, 878],
  ramachandrapuram: [837, 922],
  bijnor: [754, 620],
  munger: [940, 718],
  dhampur: [762, 620],
  thiruvallur: [790, 1008],
  bangkok: [1254, 992],
  "ho chi minh city": [1397, 1059],
  phuket: [1210, 1125],
  badung: [1583, 1494],
  amsterdam: [-901, -75],
  denpasar: [1587, 1498],
  "da nang": [1429, 941],
  chonburi: [1270, 1000],
  krabi: [1222, 1118],
  gianyar: [1587, 1494],
  singapore: [1329, 1275],
  sepang: [1282, 1243],
  "ha noi": [1381, 820],
  "nong prue": [1262, 996],
  "patong kathu": [1206, 1125],
  "ao nang": [1218, 1122],
  "borough of spelthorne": [-1028, -43],
  doha: [151, 722],
  frankfurt: [-817, 4],
  badgam: [675, 494],
  firozpur: [675, 573],
  tirupati: [786, 996],
  avadi: [794, 1004],
  chittoor: [798, 1008],
  amritsar: [679, 557],
  vijayawada: [810, 929],
  gorakhpur: [869, 682],
  jalandhar: [694, 565],
  dibrugarh: [1131, 663],
  gajuwaka: [865, 898],
  "port blair": [1079, 1043],
  rudrapur: [782, 627],
  warangal: [782, 894],
  barddhaman: [972, 769],
  panchkula: [722, 584],
  tiruchirappalli: [766, 1043],
  dimapur: [1107, 702],
  "hoan kiem": [1377, 824],
  jakarta: [1401, 1439],
  bonn: [-853, -16],
  darbhanga: [925, 698],
  rajkot: [587, 792],
  agartala: [1044, 753],
  renon: [1587, 1498],
  "lombok utara": [1611, 1490],
  dammam: [119, 690],
  kancheepuram: [790, 1020],
  guduvancheri: [790, 1012],
  imphal: [1107, 733],
  alwar: [718, 663],
  "madhubani district": [929, 694],
  himatnagar: [635, 761],
  chengalpattu: [794, 1020],
  dehradun: [750, 592],
  chakkarpur: [782, 682],
  bathinda: [679, 596],
  jammu: [679, 529],
  malappuram: [702, 1055],
  kolhapur: [663, 925],
  "sri ganganagar": [655, 604],
  jagtial: [770, 878],
  mukandpurct: [702, 573],
  kota: [702, 722],
  jodhpur: [635, 698],
  "samut prakan province": [1262, 996],
  berlin: [-710, -82],
  cairo: [-290, 565],
  muscat: [306, 761],
  "kiên giang": [1361, 1086],
  gampaha: [794, 1145],
  muharraq: [131, 698],
  bali: [1591, 1490],
  jeddah: [-123, 812],
  farwaniya: [71, 620],
  malé: [655, 1216],
  turkey: [-206, 361],
  islands: [1556, 788],
  ahmednagar: [675, 871],
  "hội an": [1437, 627]
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/constants/links.ts
var LINKS = {
  FAQ: "/#landing_faq_section"
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/constants/index.ts
/* provided dependency */ var process = __webpack_require__(4406);


var BASE_URL = process.env["NX_ENV"] === "local" ? "http://localhost:4400/api" : "";
var LISTING_API_PATH = "".concat(BASE_URL, "/card-management/api/v1/card/query/listing");
var BREAKPOINT = 766;
var API_NAME = {
  MAP_DATA: "map_data",
  PINCODES: "pincodes",
  PAGES: "pages"
};
var API = {
  GET_PINCODES: "/api/pincodeData",
  GET_MAP_DATA: "/api/mapdata"
};
var foreignCities = [{
  city: "dubai",
  country: "United Arab Emirates"
}, {
  city: "sydney",
  country: "Australia"
}, {
  city: "sharjah",
  country: "United Arab Emirates"
}, {
  city: "abu dhabi",
  country: "United Arab Emirates"
}, {
  city: "nong prue sub",
  country: "Thailand"
}, {
  city: "ho chi minh city",
  country: "Viet Nam"
}, {
  city: "phuket",
  country: "Thailand"
}, {
  city: "badung",
  country: "Indonesia"
}, {
  city: "amsterdam",
  country: "Netherlands"
}, {
  city: "denpasar",
  country: "Indonesia"
}, {
  city: "da nang",
  country: "Viet Nam"
}, {
  city: "chonburi",
  country: "Thailand"
}, {
  city: "krabi",
  country: "Thailand"
}, {
  city: "gianyar",
  country: "Indonesia"
}, {
  city: "singapore",
  country: "Republic of Singapore"
}, {
  city: "sepang",
  country: "Malaysia"
}, {
  city: "ha noi",
  country: "Viet Nam"
}, {
  city: "nong prue",
  country: "Thailand"
}, {
  city: "ao nang",
  country: "Thailand"
}, {
  city: "borough of spelthorne",
  country: "England"
}, {
  city: "doha",
  country: "Qatar"
}, {
  city: "frankfurt",
  country: "Germany"
}, {
  city: "hoan kiem",
  country: "Viet Nam"
}, {
  city: "bonn",
  country: "Germany"
}, {
  city: "lombok utara",
  country: "dammam"
}, {
  city: "samut prakan province",
  country: "Thailand"
}, {
  city: "berlin",
  country: "Germany"
}, {
  city: "cairo",
  country: "Egypt"
}, {
  city: "muscat",
  country: "Oman"
}, {
  city: "kiên giang",
  country: "Viet Nam"
}, {
  city: "gampaha",
  country: "Sri Lanka"
}, {
  city: "muharraq",
  country: "Bahrain"
}, {
  city: "bali",
  country: "Indonesia"
}, {
  city: "jeddah",
  country: "United Arab Emirates"
}, {
  city: "farwaniya",
  country: "Kuwait"
}, {
  city: "malé",
  country: "Maldives"
}, {
  city: "hội an",
  country: "Viet Nam"
}, {
  city: "patong kathu",
  country: "Thailand"
}];
var cities = {
  coimbatore: [726, 1059],
  surat: [635, 824],
  indore: [702, 784],
  meerut: [742, 631],
  jhajjar: [718, 635],
  jetpur: [583, 808],
  bhubaneswar: [929, 843],
  "gautam buddha nagar": [738, 643],
  kancheepuram: [790, 1020],
  guduvancheri: [790, 1012],
  imphal: [1107, 733],
  alwar: [718, 663],
  "madhubani district": [929, 694],
  himatnagar: [635, 761],
  chengalpattu: [794, 1020],
  dehradun: [750, 592],
  chakkarpur: [782, 682],
  agartala: [1048, 757],
  bathinda: [679, 596],
  darbhanga: [925, 698],
  jammu: [679, 529],
  malappuram: [702, 1055],
  kolhapur: [663, 925],
  "sri ganganagar": [655, 604],
  jagtial: [770, 878],
  mukandpurct: [702, 573],
  kota: [702, 722],
  jodhpur: [635, 698],
  "samut prakan province": [1262, 996],
  berlin: [-710, -82],
  cairo: [-290, 565],
  muscat: [306, 761],
  visakhapatnam: [861, 902],
  "kiên giang": [1361, 1086],
  gampaha: [930, 1350],
  muharraq: [131, 698],
  bali: [1591, 1490],
  jeddah: [-123, 812],
  darjeeling: [984, 678],
  farwaniya: [71, 620],
  malé: [655, 1216],
  turkey: [-206, 361],
  islands: [1556, 788],
  ahmednagar: [675, 871],
  "hội an": [1437, 827],
  thiruvananthapuram: [722, 1110],
  adilabad: [758, 855],
  bareilly: [782, 643],
  cuttack: [929, 835],
  medak: [754, 894],
  nagaur: [651, 675],
  sikar: [687, 663],
  sirsa: [683, 612],
  haridwar: [754, 600],
  kottayam: [718, 1090],
  medchal: [762, 906],
  bhavnagar: [619, 804],
  muzaffarnagar: [742, 616],
  nadia: [988, 765],
  navi: [635, 871],
  pali: [647, 710],
  thanjavur: [778, 1063],
  bharuch: [635, 808],
  bikaner: [643, 655],
  karimnagar: [774, 886],
  "new delhi": [733, 632],
  gurugram: [733, 632],
  noida: [733, 632],
  ghaziabad: [733, 632],
  lucknow: [816, 677],
  mumbai: [636, 865],
  bengaluru: [741, 1006],
  hyderabad: [761, 904],
  chennai: [800, 1003],
  kolkata: [981, 781],
  ahmedabad: [629, 771],
  pune: [656, 877],
  cochin: [713, 1077],
  goa: [660, 951],
  jaipur: [701, 675],
  guwahati: [1055, 694],
  chandigarh: [723, 580],
  patna: [912, 708],
  trivandrum: [726, 1106],
  varanasi: [859, 714],
  leh: [742, 490],
  allahabad: [837, 709],
  kochi: [714, 1078],
  dubai: [234, 717],
  sharjah: [234, 717],
  sydney: [2000, 1905],
  "abu dhabi": [234, 717],
  bhopal: [734, 768],
  vijaywada: [805, 929],
  ranchi: [912, 768],
  nagpur: [773, 819],
  haldwani: [781, 623],
  kozhikode: [698, 1050],
  "north 24 parganas": [992, 784],
  salem: [750, 1039],
  raipur: [829, 815],
  faridabad: [734, 643],
  udaipur: [650, 737],
  "dakshina kannada": [686, 1015],
  "kamrup metropolitan": [1063, 698],
  kelambakkam: [793, 1015],
  madurai: [746, 1078],
  quilon: [718, 1102],
  vadodara: [635, 792],
  thane: [635, 867],
  guntur: [802, 933],
  "nong prue sub": [1266, 1016],
  jabalpur: [790, 769],
  kannur: [690, 1035],
  "pimpri chinchwad": [655, 878],
  ramachandrapuram: [837, 922],
  bijnor: [754, 620],
  munger: [940, 718],
  dhampur: [762, 620],
  thiruvallur: [790, 1008],
  bangkok: [1254, 992],
  "ho chi minh city": [1397, 1059],
  phuket: [1210, 1125],
  badung: [1583, 1494],
  amsterdam: [-500, -75],
  denpasar: [1587, 1498],
  "da nang": [1429, 941],
  chonburi: [1270, 1000],
  krabi: [1222, 1118],
  gianyar: [1587, 1494],
  singapore: [1329, 1275],
  sepang: [1282, 1243],
  "ha noi": [1381, 820],
  "nong prue": [1262, 996],
  "patong kathu": [1206, 1125],
  "ao nang": [1218, 1122],
  "borough of spelthorne": [-600, -43],
  doha: [151, 722],
  frankfurt: [-617, 4],
  badgam: [675, 494],
  firozpur: [675, 573],
  tirupati: [786, 996],
  avadi: [794, 1004],
  chittoor: [798, 1008],
  amritsar: [679, 557],
  vijayawada: [810, 929],
  gorakhpur: [869, 682],
  jalandhar: [694, 565],
  dibrugarh: [1131, 663],
  gajuwaka: [865, 898],
  "port blair": [1079, 1043],
  rudrapur: [782, 627],
  warangal: [782, 894],
  barddhaman: [972, 769],
  panchkula: [722, 584],
  tiruchirappalli: [766, 1043],
  dimapur: [1107, 702],
  "hoan kiem": [1377, 824],
  jakarta: [1401, 1439],
  bonn: [-603, -16],
  rajkot: [587, 792],
  renon: [1587, 1498],
  "lombok utara": [1611, 1490],
  dammam: [119, 690],
  vellore: [770, 1008],
  kollam: [718, 1102],
  palakkad: [718, 1059],
  thrissur: [710, 1063],
  khorda: [917, 843],
  nashik: [651, 847],
  howrah: [976, 784],
  kanchipuram: [786, 1016],
  aurangabad: [690, 851],
  agra: [746, 671],
  hooghly: [976, 780],
  tiruvallur: [790, 1004],
  nellore: [794, 976],
  rangareddy: [758, 918],
  patiala: [714, 592],
  kanpur: [802, 690],
  ernakulam: [710, 1078],
  gautam: [730, 639],
  krishna: [-4829, -2565],
  ludhiana: [734, 639],
  kurnool: [750, 945],
  nalgonda: [778, 918],
  ambala: [722, 592],
  cuddapah: [770, 980],
  hisar: [698, 624],
  valsad: [635, 831],
  mohali: [718, 580],
  anand: [635, 784],
  jalgaon: [698, 824],
  kurukshetra: [722, 604],
  muzaffarpur: [921, 694],
  ajmer: [675, 694],
  mysore: [718, 1027],
  alappuzha: [710, 1090],
  dakshina: [687, 1016],
  karnal: [726, 608],
  panipat: [726, 616],
  prakasam: [794, 949],
  bardhaman: [972, 773],
  saharanpur: [738, 600],
  central: [-4829, -2565]
};
var PageNameMapping = {
  LISTING_PAGE: "listingPage"
};
var SectionNameMapping = {
  HEADER: "header",
  FOOTER: "footer"
};
var ElementNameMapping = {
  FAQ: "faq",
  ABOUT_US: "aboutUs",
  TM_LOGO: "tmLogo",
  TWITTER_Link: "twitterLink",
  LINKEDIN_Link: "linkedInLink",
  FB_Link: "facebookLink"
};
var getElementUniqueIds = function getElementUniqueIds(page, section) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return [page, section, element].filter(Boolean).join("_");
};
var getCamelCaseStr = function getCamelCaseStr(text) {
  var ans = text.toLowerCase();
  return ans.split(" ").reduce(function (s, c) {
    return s + (c.charAt(0).toUpperCase() + c.slice(1));
  });
};
var UTM_PARAMS_KEY = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_CONTENT: "utm_content",
  UTM_LOGIN: "utm_login",
  UTM_LENDER: "utm_lender",
  UTM_FLOW: "utm_flow"
};
var DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM'yy";
  DATE_FORMATS["dd MMM, yyyy"] = "dd MMM, yyyy";
  DATE_FORMATS["YYYY-MM-DD"] = "yyyy-MM-dd";
})(DATE_FORMATS || (DATE_FORMATS = {}));

/***/ }),

/***/ 9330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rS": function() { return /* binding */ theme; }
/* harmony export */ });
/* unused harmony exports fontWeight, fontSize, lineHeight */
var theme = {
  blackText: "#000",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#007E7D",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "#717171",
  greyText10: "#c8c2c2",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  blueText2: "#F6FAFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  greenBg: "rgba(43, 130, 94, 0.5)",
  purpleGradient: "linear-gradient(91.22deg, #3023ae 1.88%, #c86dd7 100%)",
  blueGradient: "linear-gradient(to right,#53B2FE,#065AF3)",
  neonGreen: "#E6FFF9",
  orange: "#FF6E39"
};
var fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
var fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
var lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};

/***/ }),

/***/ 2193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VR": function() { return /* binding */ BG_COLOR; },
/* harmony export */   "Y": function() { return /* binding */ WHITE_COLOR; },
/* harmony export */   "dS": function() { return /* binding */ BORDER_COLOR; },
/* harmony export */   "oi": function() { return /* binding */ GRADIENT_COLOR; },
/* harmony export */   "ou": function() { return /* binding */ TEXT_COLOR; },
/* harmony export */   "vX": function() { return /* binding */ BLUE_COLOR; },
/* harmony export */   "wC": function() { return /* binding */ BLACK_COLOR; }
/* harmony export */ });
/* unused harmony exports ICON_COLOR, SUCCESS_COLOR, WARNING_COLOR, ERROR_COLOR, NEUTRAL_COLOR */
var BLUE_COLOR = {
  "50": "#CCE8FF",
  "75": "#99D1FF",
  "100": "#66BAFF",
  "200": "#33A3FF",
  "300": "#008CFF",
  "400": "#0070CC",
  "500": "#005499",
  lightSkyBlue: "#6abcff"
};
var WHITE_COLOR = {
  "60": "rgba(255, 255, 255, 0.6)"
};
var BLACK_COLOR = {
  "16": "rgba(0, 0, 0, 0.16)",
  "21": "rgba(0, 0, 0, 0.21)",
  "60": "rgba(0, 0, 0, 0.6)"
};
var TEXT_COLOR = {
  high: "#000000",
  medium: "#4A4A4A",
  low: "#757575",
  disabled: "rgba(0, 0, 0, 0.3)",
  error: "#960D11",
  warning: "#6B4300",
  success: "#1E5C43",
  white: "#fff",
  aquamarine: "#85d8ba",
  illuminatingEmerald: "#22936a"
};
var BG_COLOR = {
  primary: "#FFFFFF",
  secondary: "#F6F6F6",
  inputfield: "#F6F6F6",
  disabled: "#CBCBCB",
  error: "#FCDADB",
  warning: "#FFEDD1",
  success: "#B8F5E0",
  blue: "#EAF5FF",
  black: "#000",
  vividBlack: "#010101",
  white: "#fff",
  bistreBrown: "#a07419",
  lightSilver: "#d9d9d9"
};
var ICON_COLOR = {
  high: "#000000",
  medium: "#4A4A4A",
  low: "#757575",
  neutral: "#808080",
  disabled: "rgba(0, 0, 0, 0.3)"
};
var SUCCESS_COLOR = {
  "50": "#E4FBF4",
  "75": "#B8F5E0",
  "100": "#8BEECD",
  "200": "#5EE8BA",
  "300": "#4FC594",
  "400": "#38A97A",
  "500": "#2B825E",
  "600": "#1E5C43"
};
var WARNING_COLOR = {
  "50": "#FFEDD1",
  "75": "#FFDA9E",
  "100": "#FFC76B",
  "200": "#FFB438",
  "300": "#FFA105",
  "400": "#CF8100",
  "500": "#9E6300",
  "600": "#6B4300"
};
var ERROR_COLOR = {
  "50": "#FCDADB",
  "75": "#F7ABAD",
  "100": "#F37C7F",
  "200": "#EF4D52",
  "300": "#EB2026",
  "400": "#C51217",
  "500": "#960D11"
};
var NEUTRAL_COLOR = {
  "0": "#FFFFFF",
  "50": "#F6F6F6",
  "100": "#EEEEEE",
  "200": "#E2E2E2",
  "300": "#CBCBCB",
  "400": "#AFAFAF",
  "500": "#6B6B6B",
  "600": "#545454",
  "700": "#333333",
  "800": "#1F1F1F",
  "900": "#141414",
  "1000": "#000000"
};
var BORDER_COLOR = {
  container: "#E2E2E2",
  divider: "#F2F2F2",
  dimGrey: "#717171",
  lightGrey: "#d2d2d2"
};
var GRADIENT_COLOR = {
  white: "#ffffff",
  black: "#000000",
  lightPink: "#ffe2e8",
  snow: "#fffcfc",
  skyBlue: "#8cc8ea",
  lightCyan: "#e3fffd",
  lightSalmon: "rgba(230, 237, 255, 0.736176)",
  lightBlue0: "#d6e8f4",
  metallicSunBurst: "#9d8523",
  mustardYellow: "#dab90b",
  celladonGreen: "#249083",
  seaGreen: "#249054",
  zinnwalditeBrown: "#330e0e"
};

/***/ }),

/***/ 3815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports setLocalStorage, getLocalStorage, deleteLocalStorage, setSessionStorageItem, getSessionStorageItem, removeSessionStorageItem */
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(156);
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4270);
// prettier-ignore
//@ts-ignore
 // prettier-ignore
//@ts-ignore



/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.ES,
    N_ES = MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
} // local storage utils


function setLocalStorage(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = getUtilOptions(options);
  setLocalStorageItem(key, value, options, getEssentialItemType(isEssential));
}
function getLocalStorage(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = getUtilOptions(options);
  return getLocalStorageItem(key, options, getEssentialItemType(isEssential));
}
function deleteLocalStorage(key) {
  removeLocalStorageItem(key);
} // sesstion storage utils

function setSessionStorageItem(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = getUtilOptions(options);
  setItemBySession(key, value, options, getEssentialItemType(isEssential));
}
function getSessionStorageItem(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = getUtilOptions(options);
  return getItemBySession(key, options, getEssentialItemType(isEssential));
}
function removeSessionStorageItem(key) {
  removeItemBySession(key);
}

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports setCookie, getCookie, removeCookie */
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8131);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4270);
// prettier-ignore
//@ts-ignore


/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.ES,
    N_ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
}

function setCookie(name, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  options = getUtilOptions(options);
  setGdprCookie(name, value, options, getEssentialItemType(isEssential));
}
function getCookie(name) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = getUtilOptions(options);
  return getGdprCookie(name, options, getEssentialItemType(isEssential));
}
function removeCookie(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  removeGdprCookie(name, options);
}

/***/ }),

/***/ 4270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cB": function() { return /* binding */ checkIsBot; },
  "JA": function() { return /* binding */ convertToPascalCase; },
  "_i": function() { return /* binding */ fetcher; },
  "O8": function() { return /* binding */ getFutureDate; },
  "yL": function() { return /* binding */ isHostMMT; },
  "nL": function() { return /* reexport */ serverRuntimeConfig; },
  "t": function() { return /* binding */ t; }
});

// UNUSED EXPORTS: SHORT_WEEK_DAYS, TRIPMONEY_MMT_DOMAIN_NAMES, addDaysToDate, convertDateToUnix, convertEpochToDate, convertEpochToDateFullMonth, convertToSnakeCase, convertUnixToDate, dateFormator, dateSeprationHandler, disableEncrytionInWeb, domainRedirect, doubleDigitCreator, fetchutmParamsFromCookie, formUrlForRedirection, formatDate, generateRandomIndex, generateRandomNum, getAttributesByType, getDeviceModelType, getDeviceType, getHostName, getMobileOperatingSystem, getUtilOptions, hasValidData, isHostMakemytrip, isNullOrUndefined, isOnServer, isValidDate, isValidUrl, loadGTM, persistutmParamsInCookie, redirectInterceptHref, redirectWithDeferredTime, subtractDurationFromDate, subtractYrsFromDate, template, thankYouGtmPageLoadedEvent

// EXTERNAL MODULE: ../../libs/types/src/index.ts + 1 modules
var src = __webpack_require__(9707);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(8879);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/utils/server.ts
/* provided dependency */ var process = __webpack_require__(4406);
var serverRuntimeConfig = function serverRuntimeConfig() {
  var adobeDtmScriptURL = process.env["SERVER_ADOBE_DTM_SCRIPT_URL"];
  var cmsBaseUrl = process.env["SERVER_CMS_BASE_URL"];

  if (false) {}

  return {
    cmsBaseUrl: cmsBaseUrl,
    adobeDtmScriptURL: adobeDtmScriptURL
  };
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(9128);
// EXTERNAL MODULE: ../../libs/utility/src/lib/constants/index.ts + 2 modules
var constants = __webpack_require__(9753);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/utils/redirectionUtils.ts
//@ts-ignore


var UTM_SOURCE = constants/* UTM_PARAMS_KEY.UTM_SOURCE */.J6.UTM_SOURCE,
    UTM_CAMPAIGN = constants/* UTM_PARAMS_KEY.UTM_CAMPAIGN */.J6.UTM_CAMPAIGN,
    UTM_MEDIUM = constants/* UTM_PARAMS_KEY.UTM_MEDIUM */.J6.UTM_MEDIUM,
    UTM_CONTENT = constants/* UTM_PARAMS_KEY.UTM_CONTENT */.J6.UTM_CONTENT,
    UTM_LENDER = constants/* UTM_PARAMS_KEY.UTM_LENDER */.J6.UTM_LENDER,
    UTM_LOGIN = constants/* UTM_PARAMS_KEY.UTM_LOGIN */.J6.UTM_LOGIN,
    UTM_FLOW = constants/* UTM_PARAMS_KEY.UTM_FLOW */.J6.UTM_FLOW;
var persistutmParamsInCookie = function persistutmParamsInCookie(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, utm_flow) {
  if (!!utm_source && utm_source != null && utm_source !== "video-kycookieCutter.happay.in") {
    setCookie(UTM_SOURCE, utm_source, false, {
      path: "/"
    });
  }

  if (!!utm_medium && utm_medium != null && utm_medium !== "referral") {
    setCookie(UTM_MEDIUM, utm_medium, false, {
      path: "/"
    });
  }

  if (!!utm_campaign && utm_campaign != null) {
    setCookie(UTM_CAMPAIGN, utm_campaign, false, {
      path: "/"
    });
  }

  if (!!utm_lender && utm_lender != null) {
    setCookie(UTM_LENDER, utm_lender, false, {
      path: "/"
    });
  }

  if (!!utm_login && utm_login != null) {
    setCookie(UTM_LOGIN, utm_login, false, {
      path: "/"
    });
  }

  if (!!utm_content && utm_content != null) {
    setCookie(UTM_CONTENT, utm_content, false, {
      path: "/"
    });
  }

  if (!!utm_flow && utm_flow != null) {
    setCookie(UTM_FLOW, utm_flow, false, {
      path: "/"
    });
  }
};
var fetchutmParamsFromCookie = function fetchutmParamsFromCookie() {
  var utm_medium = getCookie(UTM_MEDIUM, false, {
    path: "/"
  });
  var utm_source = getCookie(UTM_SOURCE, false, {
    path: "/"
  });
  var utm_campaign = getCookie(UTM_CAMPAIGN, false, {
    path: "/"
  });
  var utm_lender = getCookie(UTM_LENDER, false, {
    path: "/"
  });
  var utm_login = getCookie(UTM_LOGIN, false, {
    path: "/"
  });
  var utm_content = getCookie(UTM_CONTENT, false, {
    path: "/"
  });
  var utm_flow = getCookie(UTM_FLOW, false, {
    path: "/"
  });
  return {
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaign: utm_campaign,
    utm_lender: utm_lender,
    utm_login: utm_login,
    utm_content: utm_content,
    utm_flow: utm_flow
  };
};
var formUrlForRedirection = function formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, utm_flow) {
  var urlParam = "";

  if (utm_source) {
    if (!urlParam) {
      urlParam = urlParam + "utm_source=" + utm_source;
    } else {
      urlParam = urlParam + "utm_source=" + utm_source;
    }
  }

  if (utm_medium) {
    if (!urlParam) {
      urlParam = urlParam + "utm_medium=" + utm_medium;
    } else {
      urlParam = urlParam + "&utm_medium=" + utm_medium;
    }
  }

  if (utm_campaign) {
    if (!urlParam) {
      urlParam = urlParam + "utm_campaign=" + utm_campaign;
    } else {
      urlParam = urlParam + "&utm_campaign=" + utm_campaign;
    }
  }

  if (utm_lender) {
    if (!urlParam) {
      urlParam = urlParam + "utm_lender=" + utm_lender;
    } else {
      urlParam = urlParam + "&utm_lender=" + utm_lender;
    }
  }

  if (utm_login) {
    if (!urlParam) {
      urlParam = urlParam + "utm_login=" + utm_login;
    } else {
      urlParam = urlParam + "&utm_login=" + utm_login;
    }
  }

  if (utm_content) {
    if (!urlParam) {
      urlParam = urlParam + "utm_content=" + utm_content;
    } else {
      urlParam = urlParam + "&utm_content=" + utm_content;
    }
  }

  if (utm_flow) {
    if (!urlParam) {
      urlParam = urlParam + "utm_flow=" + utm_flow;
    } else {
      urlParam = urlParam + "&utm_flow=" + utm_flow;
    }
  }

  return urlParam;
};
var redirectInterceptHref = function redirectInterceptHref(url) {
  var _fetchutmParamsFromCo = fetchutmParamsFromCookie(),
      utm_source = _fetchutmParamsFromCo.utm_source,
      utm_medium = _fetchutmParamsFromCo.utm_medium,
      utm_campaign = _fetchutmParamsFromCo.utm_campaign,
      utm_lender = _fetchutmParamsFromCo.utm_lender,
      utm_login = _fetchutmParamsFromCo.utm_login,
      utm_content = _fetchutmParamsFromCo.utm_content,
      utm_flow = _fetchutmParamsFromCo.utm_flow;

  var urlParam = formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, utm_flow);

  if (url) {
    if (url.includes("?")) {
      url = url + "&" + urlParam;
    } else {
      url = url + "?" + urlParam;
    }
  }

  window.location.href = url;
};
var domainRedirect = function domainRedirect(context) {
  var _context$req, _context$req$headers;

  var host = context === null || context === void 0 ? void 0 : (_context$req = context.req) === null || _context$req === void 0 ? void 0 : (_context$req$headers = _context$req.headers) === null || _context$req$headers === void 0 ? void 0 : _context$req$headers.host;
  if (!host) return;
  var adminHost = ["forexexpert.makemytrip.com", "forexexpert.goibibo.com"];
  var partner = host !== null && host !== void 0 && host.includes("makemytrip") ? "mmt" : "gi"; // Redirect to forex listing page for forex experts.

  if (adminHost.includes(host)) {
    context.res.writeHead(301, {
      Location: "https://".concat(host, "/partners/").concat(partner, "/forex/listing")
    });
    context.res.end();
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/utils/index.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getAttributesByType = function getAttributesByType(buttons, type) {
  var _buttons$data;

  return (_buttons$data = buttons.data) === null || _buttons$data === void 0 ? void 0 : _buttons$data.find(function (button) {
    return button.attributes.type === type;
  });
};
var t = function t(sentence, wordsToReplace) {
  return Object.keys(wordsToReplace).reduce(function (f, s) {
    return "".concat(f).replace(new RegExp(s, "ig"), wordsToReplace[s]);
  }, sentence);
};
var fetcher = function fetcher(resource, init) {
  return fetch(resource, init).then(function (res) {
    return res.json();
  });
};

var getSuffix = function getSuffix(dayNo) {
  if (dayNo > 3 && dayNo < 21) return "th";

  switch (dayNo % 10) {
    case 1:
      return "st";

    case 2:
      return "nd";

    case 3:
      return "rd";

    default:
      return "th";
  }
};

var SHORT_WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var getFutureDate = function getFutureDate() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; // Get today's date

  var today = new Date();
  var tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + count); // Get the month name from the monthNames array

  var monthName = monthNames[tomorrow.getMonth()]; // Output the date in the desired format

  var date = tomorrow.getDate();
  var year = tomorrow.getFullYear();
  var suffix = getSuffix(date);
  return {
    date: date,
    year: year,
    monthName: monthName,
    suffix: suffix,
    day: SHORT_WEEK_DAYS[tomorrow.getDay()]
  };
};
function convertToPascalCase() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  str = str.toLowerCase();
  var result = "";
  var nextUpper = true;

  for (var i = 0; i < str.length; i++) {
    var char = str[i];

    if (char === "_" || char === " ") {
      nextUpper = true;
      result += char;
    } else if (nextUpper) {
      result += char.toUpperCase();
      nextUpper = false;
    } else {
      result += char;
    }
  }

  return result;
}
function generateRandomIndex(finalEvents, result) {
  var _randomEvent$src3, _randomEvent$src4;

  var attempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var debug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var random = Math.random() * result.length;
  var randomIndex = Math.round(random);
  var randomEvent = result[randomIndex];
  var failedRandomEvents = 0;
  var locationIsClose = false;
  var last = [];

  for (var i = 0; i < 4; i++) {
    var lastEvent = finalEvents[finalEvents.length - 1 - i];

    if (lastEvent) {
      var _randomEvent$src, _lastEvent$src, _randomEvent$src2, _lastEvent$src2;

      var latIsClose = Math.abs((randomEvent === null || randomEvent === void 0 ? void 0 : (_randomEvent$src = randomEvent.src) === null || _randomEvent$src === void 0 ? void 0 : _randomEvent$src.lat) - (lastEvent === null || lastEvent === void 0 ? void 0 : (_lastEvent$src = lastEvent.src) === null || _lastEvent$src === void 0 ? void 0 : _lastEvent$src.lat)) < 5;
      var longIsClose = Math.abs((randomEvent === null || randomEvent === void 0 ? void 0 : (_randomEvent$src2 = randomEvent.src) === null || _randomEvent$src2 === void 0 ? void 0 : _randomEvent$src2.long) - (lastEvent === null || lastEvent === void 0 ? void 0 : (_lastEvent$src2 = lastEvent.src) === null || _lastEvent$src2 === void 0 ? void 0 : _lastEvent$src2.long)) < 5;
      locationIsClose = latIsClose && longIsClose;

      if (locationIsClose) {
        break;
      }

      debug && last.push("".concat(lastEvent.src.lat, ":").concat(lastEvent.src.long));
    }
  }

  debug && console.log({
    current: "".concat(randomEvent.src.lat, ":").concat(randomEvent.src.long),
    lastLats: last
  });

  if (randomEvent !== null && randomEvent !== void 0 && (_randomEvent$src3 = randomEvent.src) !== null && _randomEvent$src3 !== void 0 && _randomEvent$src3.lat && randomEvent !== null && randomEvent !== void 0 && (_randomEvent$src4 = randomEvent.src) !== null && _randomEvent$src4 !== void 0 && _randomEvent$src4.long && attempts <= 10 && finalEvents.length > 0 && locationIsClose) {
    return generateRandomIndex(finalEvents, result, attempts + 1);
  }

  if (attempts > 11) {
    failedRandomEvents++;
  }

  return {
    randomIndex: randomIndex,
    failedRandomEvents: failedRandomEvents
  };
}
var generateRandomNum = function generateRandomNum(start, end) {
  if (start <= end) {
    return Math.floor(Math.random() * (end - start + 1)) + start;
  }

  return null;
};
var defaultTemplateValues = {
  "{year}": new Date().getFullYear().toString()
};
/**
 *
 * @param object : Object contains interpolated string.
 * @param values Object with key - value pair where key - replaceable text and value - replaced text.
 * @returns Input Object with all the interpolated values replaced with value provided in the "values".
 */

var template = function template(object, values) {
  var newValues = values ? _objectSpread(_objectSpread({}, defaultTemplateValues), values) : defaultTemplateValues;
  object = JSON.stringify(object, function (_, objValue) {
    if (typeof objValue === "string") {
      for (var _i = 0, _Object$entries = Object.entries(newValues); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (objValue.includes(key)) {
          return objValue.replace(key, value);
        }
      }
    }

    return objValue;
  });
  return JSON.parse(object);
};
function getDeviceType(userAgent) {
  var mobileRegex = new RegExp(/Mobile|Android|BlackBerry/);
  var tabletRegex = new RegExp(/iPad|(Android(?!.*Mobile))|Tablet|PlayBook|Kindle|GT-P1000|SCH-I800|sholes|Xoom|Libero|\b4G\b/);

  if (userAgent.match(mobileRegex)) {
    return DEVICE_TYPE.MOBILE;
  } else if (userAgent.match(tabletRegex)) {
    return DEVICE_TYPE.TABLET;
  }

  return DEVICE_TYPE.DESKTOP;
}
var doubleDigitCreator = function doubleDigitCreator(number) {
  if (number < 10) {
    return "0".concat(number);
  }

  return number;
};
var dateSeprationHandler = function dateSeprationHandler(date) {
  var monthLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var weekLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var weeks = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var dateObj = "";

  try {
    dateObj = new Date(date);
  } catch (e) {
    return null;
  }

  if (!dateObj || !date) {
    return null;
  }

  var currentMonth = months[dateObj.getMonth()];
  var currentDay = weeks[dateObj.getDay()];
  return {
    day: weekLength ? currentDay.substr(0, weekLength) : currentDay,
    date: doubleDigitCreator(dateObj.getDate()),
    month: monthLength ? currentMonth.substr(0, monthLength) : currentMonth,
    monthNumber: dateObj.getMonth() + 1,
    year: dateObj.getFullYear(),
    hours: dateObj.getHours() > 12 ? doubleDigitCreator(dateObj.getHours() - 12) : doubleDigitCreator(dateObj.getHours()),
    minutes: doubleDigitCreator(dateObj.getMinutes()),
    format: dateObj.getHours() >= 12 ? "PM" : "AM"
  };
};
var dateFormator = function dateFormator(dateObject) {
  var date = dateObject.date,
      monthNumber = dateObject.monthNumber,
      year = dateObject.year;
  return "".concat(date, " / ").concat(monthNumber, " / ").concat(year);
};
var getMobileOperatingSystem = function getMobileOperatingSystem() {
  if (isOnServer()) return "unknown";
  var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710


  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};
var isOnServer = function isOnServer() {
  if (false) {}

  return false;
};
var getDeviceModelType = function getDeviceModelType() {
  if (isOnServer()) return null; // @ts-ignore

  if (window.mmt_android_bridge || window.app_bridge) {
    return DEVICE_MODEL_TYPE.APP;
  }

  return DEVICE_MODEL_TYPE.WEB;
};
function getHostName() {
  if (isOnServer()) {
    return null;
  }

  return window.location.hostname;
}
function disableEncrytionInWeb() {
  return getDeviceModelType() === DEVICE_MODEL_TYPE.WEB && isHostMMT();
}
function getUtilOptions(options) {
  return disableEncrytionInWeb() ? _objectSpread(_objectSpread({}, options), {}, {
    isPiiData: false
  }) : options;
}
var TRIPMONEY_MMT_DOMAIN_NAMES = (/* unused pure expression or super */ null && (["forex.makemytrip.com", "www.makemytrip.com", "tripmoney.makemytrip.com"]));
var isHostMakemytrip = function isHostMakemytrip() {
  if (isOnServer()) return false;
  var url = new URL(window.location.href);
  return TRIPMONEY_MMT_DOMAIN_NAMES.includes(url.hostname);
};

var getGtmScript = function getGtmScript(gtmId) {
  return "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer', '".concat(gtmId, "');\n  ");
};

var loadGTM = function loadGTM() {
  if (isHostMakemytrip()) {
    var script = document.createElement("script");
    script.innerHTML = getGtmScript("GTM-NWV3K7C");
    script.defer = true;
    document.head.appendChild(script);
  }
};

function gtmDataLayerPush(data) {
  var _window;

  if ((_window = window) !== null && _window !== void 0 && _window.dataLayer) {
    var eventData = _objectSpread({}, data);

    window.dataLayer.push(eventData);
  } else {
    console.warn("GTM dataLayer is not available");
  }
} // Thank You Page Loaded Event


function thankYouGtmPageLoadedEvent(data) {
  gtmDataLayerPush(data);
}
function convertToSnakeCase(input) {
  // Handle camelCase
  var snakeCase = input.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase(); // Handle kebab-case

  snakeCase = snakeCase.replace(/-/g, "_");
  return snakeCase;
}
function isHostMMT() {
  var _window2, _window2$location, _window2$location$hos;

  if (isOnServer()) {
    return null;
  }

  if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$location = _window2.location) !== null && _window2$location !== void 0 && (_window2$location$hos = _window2$location.hostname) !== null && _window2$location$hos !== void 0 && _window2$location$hos.includes("makemytrip")) {
    return true;
  }

  return false;
}
/**
 * Checks if an object exists and has properties
 * @param obj - The object to check
 * @returns true if object exists and has properties, false otherwise
 */

var hasValidData = function hasValidData(obj) {
  return obj && Object.keys(obj).length > 0;
};
function convertEpochToDate(epoch, format) {
  return dayjs.unix(epoch).format(format);
}
function convertEpochToDateFullMonth(epoch) {
  return convertEpochToDate(epoch, "Do MMMM");
}
/**
 * Validates if a string is a valid URL
 * @param url - The URL string to validate
 * @returns true if the URL is valid, false otherwise
 */

var isValidUrl = function isValidUrl(url) {
  return /^(https?:\/\/)([\w.-]+)+(:\d+)?(\/[^\s]*)?$/.test(url);
};
/**
 * Checks if a value is null or undefined
 * @param value - The value to check
 * @returns true if the value is null or undefined, false otherwise
 */

var isNullOrUndefined = function isNullOrUndefined(value) {
  return value === null || value === undefined;
};
var redirectWithDeferredTime = function redirectWithDeferredTime(redirectTo, redirectionDeferTime) {
  if (redirectionDeferTime) {
    var timerId = setTimeout(function () {
      redirectTo();
      clearTimeout(timerId);
    }, redirectionDeferTime);
  } else {
    redirectTo();
  }
};



/**
 * Checks if the user agent indicates a bot
 * @param userAgent - The user agent string
 * @param checkBot - The bot detection function from isbot library
 * @returns true if the user agent is a bot, false otherwise
 */

var checkIsBot = function checkIsBot(userAgent, checkBot) {
  if (userAgent) {
    return checkBot(userAgent) || userAgent.includes("Google-InspectionTool");
  }

  return false;
};

/***/ }),

/***/ 6570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(5525);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4766:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5153:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 5237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2795)


/***/ }),

/***/ 7729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3233)


/***/ }),

/***/ 9097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2817)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5876)


/***/ }),

/***/ 4406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 8262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 3980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(8262)();
}


/***/ }),

/***/ 3586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 6866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=b;exports.ForwardRef=l;exports.Fragment=d;exports.Lazy=q;exports.Memo=p;exports.Portal=c;exports.Profiler=f;exports.StrictMode=e;exports.Suspense=m;
exports.SuspenseList=n;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};exports.isContextProvider=function(a){return v(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};exports.isLazy=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
exports.isPortal=function(a){return v(a)===c};exports.isProfiler=function(a){return v(a)===f};exports.isStrictMode=function(a){return v(a)===e};exports.isSuspense=function(a){return v(a)===m};exports.isSuspenseList=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 8570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(6866);
} else {}


/***/ }),

/***/ 6772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(6299);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;
module.exports["default"] = StyleToObject; // ESM support


/***/ }),

/***/ 4607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _react=_interopRequireWildcard(__webpack_require__(2784));var _excluded=["placeholder","separator","isLastChild","inputStyle","focus","isDisabled","hasErrored","errorStyle","focusStyle","disabledStyle","shouldAutoFocus","isInputNum","index","value","className","isInputSecure"];function _getRequireWildcardCache(nodeInterop){if(typeof WeakMap!=="function")return null;var cacheBabelInterop=new WeakMap();var cacheNodeInterop=new WeakMap();return(_getRequireWildcardCache=function _getRequireWildcardCache(nodeInterop){return nodeInterop?cacheNodeInterop:cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj,nodeInterop){if(!nodeInterop&&obj&&obj.__esModule){return obj;}if(obj===null||_typeof(obj)!=="object"&&typeof obj!=="function"){return{"default":obj};}var cache=_getRequireWildcardCache(nodeInterop);if(cache&&cache.has(obj)){return cache.get(obj);}var newObj={};var hasPropertyDescriptor=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var key in obj){if(key!=="default"&&Object.prototype.hasOwnProperty.call(obj,key)){var desc=hasPropertyDescriptor?Object.getOwnPropertyDescriptor(obj,key):null;if(desc&&(desc.get||desc.set)){Object.defineProperty(newObj,key,desc);}else{newObj[key]=obj[key];}}}newObj["default"]=obj;if(cache){cache.set(obj,newObj);}return newObj;}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}var BACKSPACE=8;var LEFT_ARROW=37;var RIGHT_ARROW=39;var DELETE=46;var SPACEBAR=32;var isStyleObject=function isStyleObject(obj){return _typeof(obj)==='object';};var SingleOtpInput=function(_PureComponent){_inherits(SingleOtpInput,_PureComponent);var _super=_createSuper(SingleOtpInput);function SingleOtpInput(props){var _this;_classCallCheck(this,SingleOtpInput);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getClasses",function(){for(var _len=arguments.length,classes=new Array(_len),_key=0;_key<_len;_key++){classes[_key]=arguments[_key];}return classes.filter(function(c){return!isStyleObject(c)&&c!==false;}).join(' ');});_defineProperty(_assertThisInitialized(_this),"getType",function(){var _this$props=_this.props,isInputSecure=_this$props.isInputSecure,isInputNum=_this$props.isInputNum;if(isInputSecure){return'password';}if(isInputNum){return'tel';}return'text';});_this.input=_react["default"].createRef();return _this;}_createClass(SingleOtpInput,[{key:"componentDidMount",value:function componentDidMount(){var _this$props2=this.props,focus=_this$props2.focus,shouldAutoFocus=_this$props2.shouldAutoFocus;var inputEl=this.input.current;if(inputEl&&focus&&shouldAutoFocus){inputEl.focus();}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var focus=this.props.focus;var inputEl=this.input.current;if(prevProps.focus!==focus&&inputEl&&focus){inputEl.focus();inputEl.select();}}},{key:"render",value:function render(){var _this$props3=this.props,placeholder=_this$props3.placeholder,separator=_this$props3.separator,isLastChild=_this$props3.isLastChild,inputStyle=_this$props3.inputStyle,focus=_this$props3.focus,isDisabled=_this$props3.isDisabled,hasErrored=_this$props3.hasErrored,errorStyle=_this$props3.errorStyle,focusStyle=_this$props3.focusStyle,disabledStyle=_this$props3.disabledStyle,shouldAutoFocus=_this$props3.shouldAutoFocus,isInputNum=_this$props3.isInputNum,index=_this$props3.index,value=_this$props3.value,className=_this$props3.className,isInputSecure=_this$props3.isInputSecure,rest=_objectWithoutProperties(_this$props3,_excluded);return _react["default"].createElement("div",{className:className,style:{display:'flex',alignItems:'center'}},_react["default"].createElement("input",_extends({"aria-label":"".concat(index===0?'Please enter verification code. ':'').concat(isInputNum?'Digit':'Character'," ").concat(index+1),autoComplete:"off",style:Object.assign({width:'1em',textAlign:'center'},isStyleObject(inputStyle)&&inputStyle,focus&&isStyleObject(focusStyle)&&focusStyle,isDisabled&&isStyleObject(disabledStyle)&&disabledStyle,hasErrored&&isStyleObject(errorStyle)&&errorStyle),placeholder:placeholder,className:this.getClasses(inputStyle,focus&&focusStyle,isDisabled&&disabledStyle,hasErrored&&errorStyle),type:this.getType(),maxLength:"1",ref:this.input,disabled:isDisabled,value:value?value:''},rest)),!isLastChild&&separator);}}]);return SingleOtpInput;}(_react.PureComponent);var OtpInput=function(_Component){_inherits(OtpInput,_Component);var _super2=_createSuper(OtpInput);function OtpInput(){var _this2;_classCallCheck(this,OtpInput);for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}_this2=_super2.call.apply(_super2,[this].concat(args));_defineProperty(_assertThisInitialized(_this2),"state",{activeInput:0});_defineProperty(_assertThisInitialized(_this2),"getOtpValue",function(){return _this2.props.value?_this2.props.value.toString().split(''):[];});_defineProperty(_assertThisInitialized(_this2),"getPlaceholderValue",function(){var _this2$props=_this2.props,placeholder=_this2$props.placeholder,numInputs=_this2$props.numInputs;if(typeof placeholder==='string'){if(placeholder.length===numInputs){return placeholder;}if(placeholder.length>0){console.error('Length of the placeholder should be equal to the number of inputs.');}}});_defineProperty(_assertThisInitialized(_this2),"handleOtpChange",function(otp){var onChange=_this2.props.onChange;var otpValue=otp.join('');onChange(otpValue);});_defineProperty(_assertThisInitialized(_this2),"isInputValueValid",function(value){var isTypeValid=_this2.props.isInputNum?!isNaN(parseInt(value,10)):typeof value==='string';return isTypeValid&&value.trim().length===1;});_defineProperty(_assertThisInitialized(_this2),"focusInput",function(input){var numInputs=_this2.props.numInputs;var activeInput=Math.max(Math.min(numInputs-1,input),0);_this2.setState({activeInput:activeInput});});_defineProperty(_assertThisInitialized(_this2),"focusNextInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput+1);});_defineProperty(_assertThisInitialized(_this2),"focusPrevInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput-1);});_defineProperty(_assertThisInitialized(_this2),"changeCodeAtFocus",function(value){var activeInput=_this2.state.activeInput;var otp=_this2.getOtpValue();otp[activeInput]=value[0];_this2.handleOtpChange(otp);});_defineProperty(_assertThisInitialized(_this2),"handleOnPaste",function(e){e.preventDefault();var activeInput=_this2.state.activeInput;var _this2$props2=_this2.props,numInputs=_this2$props2.numInputs,isDisabled=_this2$props2.isDisabled;if(isDisabled){return;}var otp=_this2.getOtpValue();var nextActiveInput=activeInput;var pastedData=e.clipboardData.getData('text/plain').slice(0,numInputs-activeInput).split('');for(var pos=0;pos<numInputs;++pos){if(pos>=activeInput&&pastedData.length>0){otp[pos]=pastedData.shift();nextActiveInput++;}}_this2.setState({activeInput:nextActiveInput},function(){_this2.focusInput(nextActiveInput);_this2.handleOtpChange(otp);});});_defineProperty(_assertThisInitialized(_this2),"handleOnChange",function(e){var value=e.target.value;if(_this2.isInputValueValid(value)){_this2.changeCodeAtFocus(value);}});_defineProperty(_assertThisInitialized(_this2),"handleOnKeyDown",function(e){if(e.keyCode===BACKSPACE||e.key==='Backspace'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}else if(e.keyCode===DELETE||e.key==='Delete'){e.preventDefault();_this2.changeCodeAtFocus('');}else if(e.keyCode===LEFT_ARROW||e.key==='ArrowLeft'){e.preventDefault();_this2.focusPrevInput();}else if(e.keyCode===RIGHT_ARROW||e.key==='ArrowRight'){e.preventDefault();_this2.focusNextInput();}else if(e.keyCode===SPACEBAR||e.key===' '||e.key==='Spacebar'||e.key==='Space'){e.preventDefault();}});_defineProperty(_assertThisInitialized(_this2),"handleOnInput",function(e){if(_this2.isInputValueValid(e.target.value)){_this2.focusNextInput();}else{if(!_this2.props.isInputNum){var nativeEvent=e.nativeEvent;if(nativeEvent.data===null&&nativeEvent.inputType==='deleteContentBackward'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}}}});_defineProperty(_assertThisInitialized(_this2),"renderInputs",function(){var activeInput=_this2.state.activeInput;var _this2$props3=_this2.props,numInputs=_this2$props3.numInputs,inputStyle=_this2$props3.inputStyle,focusStyle=_this2$props3.focusStyle,separator=_this2$props3.separator,isDisabled=_this2$props3.isDisabled,disabledStyle=_this2$props3.disabledStyle,hasErrored=_this2$props3.hasErrored,errorStyle=_this2$props3.errorStyle,shouldAutoFocus=_this2$props3.shouldAutoFocus,isInputNum=_this2$props3.isInputNum,isInputSecure=_this2$props3.isInputSecure,className=_this2$props3.className;var inputs=[];var otp=_this2.getOtpValue();var placeholder=_this2.getPlaceholderValue();var dataCy=_this2.props['data-cy'];var dataTestId=_this2.props['data-testid'];var _loop=function _loop(i){inputs.push(_react["default"].createElement(SingleOtpInput,{placeholder:placeholder&&placeholder[i],key:i,index:i,focus:activeInput===i,value:otp&&otp[i],onChange:_this2.handleOnChange,onKeyDown:_this2.handleOnKeyDown,onInput:_this2.handleOnInput,onPaste:_this2.handleOnPaste,onFocus:function onFocus(e){_this2.setState({activeInput:i});e.target.select();},onBlur:function onBlur(){return _this2.setState({activeInput:-1});},separator:separator,inputStyle:inputStyle,focusStyle:focusStyle,isLastChild:i===numInputs-1,isDisabled:isDisabled,disabledStyle:disabledStyle,hasErrored:hasErrored,errorStyle:errorStyle,shouldAutoFocus:shouldAutoFocus,isInputNum:isInputNum,isInputSecure:isInputSecure,className:className,"data-cy":dataCy&&"".concat(dataCy,"-").concat(i),"data-testid":dataTestId&&"".concat(dataTestId,"-").concat(i)}));};for(var i=0;i<numInputs;i++){_loop(i);}return inputs;});return _this2;}_createClass(OtpInput,[{key:"render",value:function render(){var containerStyle=this.props.containerStyle;return _react["default"].createElement("div",{style:Object.assign({display:'flex'},isStyleObject(containerStyle)&&containerStyle),className:!isStyleObject(containerStyle)?containerStyle:''},this.renderInputs());}}]);return OtpInput;}(_react.Component);_defineProperty(OtpInput,"defaultProps",{numInputs:4,onChange:function onChange(otp){return console.log(otp);},isDisabled:false,shouldAutoFocus:false,value:'',isInputSecure:false});var _default=OtpInput;exports.Z=_default;

/***/ }),

/***/ 8665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 5505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ServerStyleSheet": function() { return /* binding */ Ue; },
  "StyleSheetConsumer": function() { return /* binding */ ue; },
  "StyleSheetContext": function() { return /* binding */ ce; },
  "StyleSheetManager": function() { return /* binding */ me; },
  "ThemeConsumer": function() { return /* binding */ Ge; },
  "ThemeContext": function() { return /* binding */ Me; },
  "ThemeProvider": function() { return /* binding */ Le; },
  "__PRIVATE__": function() { return /* binding */ Ze; },
  "createGlobalStyle": function() { return /* binding */ $e; },
  "css": function() { return /* binding */ Ae; },
  "default": function() { return /* binding */ styled_components_browser_esm; },
  "isStyledComponent": function() { return /* binding */ _; },
  "keyframes": function() { return /* binding */ We; },
  "useTheme": function() { return /* binding */ Xe; },
  "version": function() { return /* binding */ A; },
  "withTheme": function() { return /* binding */ Je; }
});

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(8570);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(8665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_esm = (isPropValid);

// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(3463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(4406);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=(0,react.useContext)(Me),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,emotion_is_prop_valid_esm,b):!_||emotion_is_prop_valid_esm(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=react.forwardRef((function(t,n){var o=(0,react.useContext)(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,react.createElement(e,y({},t,{theme:a,ref:n}))}));return hoist_non_react_statics_cjs_default()(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return (0,react.useContext)(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 6353:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.38
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.38',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 500;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bop(?:rg)?x\/([\w\.]+)/i                                          // Opera GX
            ], [VERSION, [NAME, OPERA+' GX']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
            ], [VERSION, [NAME, 'Baidu']], [
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /\bddg\/([\w\.]+)/i                                                 // DuckDuckGo
            ], [VERSION, [NAME, 'DuckDuckGo']], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 ' + BROWSER]], [
            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
            ], [VERSION, [NAME, 'Sogou Explorer']], [
            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
            ], [[NAME, 'Sogou Mobile'], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
            ], [NAME, VERSION], [
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,                               // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
            /\b(opd2\d{3}a?) bui/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, TABLET]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
                
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( \d| pro)?)/i                                               // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /windows nt 6\.2; (arm)/i,                                        // Windows RT
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 402:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(2784),n=__webpack_require__(3100);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 3100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(452);
} else {}


/***/ }),

/***/ 1110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(402);
} else {}


/***/ }),

/***/ 6364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 5348:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(4406);


var jsxRuntime = __webpack_require__(2322);
var React = __webpack_require__(2784);
var styled = __webpack_require__(5505);
var designSystem = __webpack_require__(5618);
var pdtUtils = __webpack_require__(5697);
var coreUtils = __webpack_require__(6003);
var designTokens = __webpack_require__(8772);
var commonUi = __webpack_require__(9984);
var toolkit = __webpack_require__(8496);
var auth = __webpack_require__(4178);
var Fuse = __webpack_require__(3629);
var myraChatbot = __webpack_require__(3157);

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n.default = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefault(styled);
var Fuse__default = /*#__PURE__*/_interopDefault(Fuse);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$A = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$z = fails$A;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$z(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$y = fails$A;

var functionBindNative = !fails$y(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$s = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = NATIVE_BIND$3 ? call$s.bind(call$s) : function () {
  return call$s.apply(call$s, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$6 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$r = FunctionPrototype$2.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$r, call$r);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$r.apply(fn, arguments);
  };
};

var uncurryThis$B = functionUncurryThis;

var toString$f = uncurryThis$B({}.toString);
var stringSlice$8 = uncurryThis$B(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$8(toString$f(it), 8, -1);
};

var uncurryThis$A = functionUncurryThis;
var fails$x = fails$A;
var classof$d = classofRaw$2;

var $Object$5 = Object;
var split$1 = uncurryThis$A(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$x(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$d(it) === 'String' ? split$1(it, '') : $Object$5(it);
} : $Object$5;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$5 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$4 = isNullOrUndefined$5;

var $TypeError$k = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$8 = function (it) {
  if (isNullOrUndefined$4(it)) throw new $TypeError$k("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$3 = indexedObject;
var requireObjectCoercible$7 = requireObjectCoercible$8;

var toIndexedObject$7 = function (it) {
  return IndexedObject$3(requireObjectCoercible$7(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$p = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$o = isCallable$p;

var isObject$l = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$o(it);
};

var globalThis$q = globalThis_1;
var isCallable$n = isCallable$p;

var aFunction = function (argument) {
  return isCallable$n(argument) ? argument : undefined;
};

var getBuiltIn$9 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$q[namespace]) : globalThis$q[namespace] && globalThis$q[namespace][method];
};

var uncurryThis$z = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$z({}.isPrototypeOf);

var globalThis$p = globalThis_1;

var navigator$1 = globalThis$p.navigator;
var userAgent$2 = navigator$1 && navigator$1.userAgent;

var environmentUserAgent = userAgent$2 ? String(userAgent$2) : '';

var globalThis$o = globalThis_1;
var userAgent$1 = environmentUserAgent;

var process$1 = globalThis$o.process;
var Deno$1 = globalThis$o.Deno;
var versions = process$1 && process$1.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$1) {
  match = userAgent$1.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$1.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = environmentV8Version;
var fails$w = fails$A;
var globalThis$n = globalThis_1;

var $String$6 = globalThis$n.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$w(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$6(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$3 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$3 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$8 = getBuiltIn$9;
var isCallable$m = isCallable$p;
var isPrototypeOf$6 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$4 = Object;

var isSymbol$4 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$8('Symbol');
  return isCallable$m($Symbol) && isPrototypeOf$6($Symbol.prototype, $Object$4(it));
};

var $String$5 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$l = isCallable$p;
var tryToString$3 = tryToString$4;

var $TypeError$j = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$d = function (argument) {
  if (isCallable$l(argument)) return argument;
  throw new $TypeError$j(tryToString$3(argument) + ' is not a function');
};

var aCallable$c = aCallable$d;
var isNullOrUndefined$3 = isNullOrUndefined$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$6 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$3(func) ? undefined : aCallable$c(func);
};

var call$q = functionCall;
var isCallable$k = isCallable$p;
var isObject$k = isObject$l;

var $TypeError$i = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$k(fn = input.toString) && !isObject$k(val = call$q(fn, input))) return val;
  if (isCallable$k(fn = input.valueOf) && !isObject$k(val = call$q(fn, input))) return val;
  if (pref !== 'string' && isCallable$k(fn = input.toString) && !isObject$k(val = call$q(fn, input))) return val;
  throw new $TypeError$i("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var isPure = false;

var globalThis$m = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$8 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$8(globalThis$m, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$m[key] = value;
  } return value;
};

var globalThis$l = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$l[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.43.0',
  mode: 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.43.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$6 = requireObjectCoercible$8;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$9 = function (argument) {
  return $Object$3(requireObjectCoercible$6(argument));
};

var uncurryThis$y = functionUncurryThis;
var toObject$8 = toObject$9;

var hasOwnProperty = uncurryThis$y({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$8(it), key);
};

var uncurryThis$x = functionUncurryThis;

var id$2 = 0;
var postfix = Math.random();
var toString$e = uncurryThis$x(1.1.toString);

var uid$3 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$e(++id$2 + postfix, 36);
};

var globalThis$k = globalThis_1;
var shared$3 = shared$4;
var hasOwn$g = hasOwnProperty_1;
var uid$2 = uid$3;
var NATIVE_SYMBOL$2 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = globalThis$k.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$2;

var wellKnownSymbol$m = function (name) {
  if (!hasOwn$g(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$2 && hasOwn$g(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$p = functionCall;
var isObject$j = isObject$l;
var isSymbol$3 = isSymbol$4;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$l = wellKnownSymbol$m;

var $TypeError$h = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$l('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$j(input) || isSymbol$3(input)) return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$p(exoticToPrim, input, pref);
    if (!isObject$j(result) || isSymbol$3(result)) return result;
    throw new $TypeError$h("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol$2 = isSymbol$4;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol$2(key) ? key : key + '';
};

var globalThis$j = globalThis_1;
var isObject$i = isObject$l;

var document$1 = globalThis$j.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$i(document$1) && isObject$i(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$m = descriptors;
var fails$v = fails$A;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$m && !fails$v(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$l = descriptors;
var call$o = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$5 = createPropertyDescriptor$6;
var toIndexedObject$6 = toIndexedObject$7;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$f = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$l ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$6(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$f(O, P)) return createPropertyDescriptor$5(!call$o(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$k = descriptors;
var fails$u = fails$A;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$k && fails$u(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$h = isObject$l;

var $String$4 = String;
var $TypeError$g = TypeError;

// `Assert: Type(argument) is Object`
var anObject$p = function (argument) {
  if (isObject$h(argument)) return argument;
  throw new $TypeError$g($String$4(argument) + ' is not an object');
};

var DESCRIPTORS$j = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$o = anObject$p;
var toPropertyKey = toPropertyKey$2;

var $TypeError$f = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$j ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$o(O);
  P = toPropertyKey(P);
  anObject$o(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$o(O);
  P = toPropertyKey(P);
  anObject$o(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$f('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$i = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$4 = createPropertyDescriptor$6;

var createNonEnumerableProperty$a = DESCRIPTORS$i ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$4(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$h = descriptors;
var hasOwn$e = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$h && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$e(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$h || (DESCRIPTORS$h && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$w = functionUncurryThis;
var isCallable$j = isCallable$p;
var store$1 = sharedStoreExports;

var functionToString = uncurryThis$w(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$j(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var globalThis$i = globalThis_1;
var isCallable$i = isCallable$p;

var WeakMap$2 = globalThis$i.WeakMap;

var weakMapBasicDetection = isCallable$i(WeakMap$2) && /native code/.test(String(WeakMap$2));

var shared$2 = shared$4;
var uid$1 = uid$3;

var keys$2 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$2[key] || (keys$2[key] = uid$1(key));
};

var hiddenKeys$5 = {};

var NATIVE_WEAK_MAP$1 = weakMapBasicDetection;
var globalThis$h = globalThis_1;
var isObject$g = isObject$l;
var createNonEnumerableProperty$9 = createNonEnumerableProperty$a;
var hasOwn$d = hasOwnProperty_1;
var shared$1 = sharedStoreExports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$4 = hiddenKeys$5;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = globalThis$h.TypeError;
var WeakMap$1 = globalThis$h.WeakMap;
var set, get, has$6;

var enforce = function (it) {
  return has$6(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$g(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP$1 || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has$6 = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$4[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$d(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$9(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$d(it, STATE) ? it[STATE] : {};
  };
  has$6 = function (it) {
    return hasOwn$d(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$6,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$v = functionUncurryThis;
var fails$t = fails$A;
var isCallable$h = isCallable$p;
var hasOwn$c = hasOwnProperty_1;
var DESCRIPTORS$g = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$1 = inspectSource$2;
var InternalStateModule$4 = internalState;

var enforceInternalState$2 = InternalStateModule$4.enforce;
var getInternalState$3 = InternalStateModule$4.get;
var $String$3 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;
var stringSlice$7 = uncurryThis$v(''.slice);
var replace$7 = uncurryThis$v(''.replace);
var join$2 = uncurryThis$v([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$g && !fails$t(function () {
  return defineProperty$7(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$7($String$3(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$7($String$3(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$c(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$g) defineProperty$7(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$c(options, 'arity') && value.length !== options.arity) {
    defineProperty$7(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$c(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$g) defineProperty$7(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$2(value);
  if (!hasOwn$c(state, 'source')) {
    state.source = join$2(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$h(this) && getInternalState$3(this).source || inspectSource$1(this);
}, 'toString');

var makeBuiltInExports = makeBuiltIn$3.exports;

var isCallable$g = isCallable$p;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$b = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$g(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$2 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$8 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$7 = toIntegerOrInfinity$8;

var max$2 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toIntegerOrInfinity$7(index);
  return integer < 0 ? max$2(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$6 = toIntegerOrInfinity$8;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  var len = toIntegerOrInfinity$6(argument);
  return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$8 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$5 = toIndexedObject$7;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;
var lengthOfArrayLike$7 = lengthOfArrayLike$8;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$5($this);
    var length = lengthOfArrayLike$7(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$u = functionUncurryThis;
var hasOwn$b = hasOwnProperty_1;
var toIndexedObject$4 = toIndexedObject$7;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$5;

var push$5 = uncurryThis$u([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$4(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$b(hiddenKeys$3, key) && hasOwn$b(O, key) && push$5(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$b(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$5(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$2 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$2);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$7 = getBuiltIn$9;
var uncurryThis$t = functionUncurryThis;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$n = anObject$p;

var concat$2 = uncurryThis$t([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$6 = getBuiltIn$7('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule$1.f(anObject$n(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$a = hasOwnProperty_1;
var ownKeys$5 = ownKeys$6;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$3 = function (target, source, exceptions) {
  var keys = ownKeys$5(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$a(target, key) && !(exceptions && hasOwn$a(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$s = fails$A;
var isCallable$f = isCallable$p;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$f(detection) ? fails$s(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var globalThis$g = globalThis_1;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$a;
var defineBuiltIn$a = defineBuiltIn$b;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$2 = copyConstructorProperties$3;
var isForced$2 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$g;
  } else if (STATIC) {
    target = globalThis$g[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$g[TARGET] && globalThis$g[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$2(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$8(sourceProperty, 'sham', true);
    }
    defineBuiltIn$a(target, key, sourceProperty, options);
  }
};

var isPrototypeOf$5 = objectIsPrototypeOf;

var $TypeError$e = TypeError;

var anInstance$4 = function (it, Prototype) {
  if (isPrototypeOf$5(Prototype, it)) return it;
  throw new $TypeError$e('Incorrect invocation');
};

var fails$r = fails$A;

var correctPrototypeGetter = !fails$r(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$9 = hasOwnProperty_1;
var isCallable$e = isCallable$p;
var toObject$7 = toObject$9;
var sharedKey$1 = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO$1 = sharedKey$1('IE_PROTO');
var $Object$2 = Object;
var ObjectPrototype = $Object$2.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$2.getPrototypeOf : function (O) {
  var object = toObject$7(O);
  if (hasOwn$9(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable$e(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$2 ? ObjectPrototype : null;
};

var makeBuiltIn = makeBuiltInExports;
var defineProperty$6 = objectDefineProperty;

var defineBuiltInAccessor$7 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$6.f(target, name, descriptor);
};

var DESCRIPTORS$f = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$6;

var createProperty$2 = function (object, key, value) {
  if (DESCRIPTORS$f) definePropertyModule$1.f(object, key, createPropertyDescriptor$3(0, value));
  else object[key] = value;
};

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$e = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$m = anObject$p;
var toIndexedObject$3 = toIndexedObject$7;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$e && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$m(O);
  var props = toIndexedObject$3(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$6 = getBuiltIn$9;

var html$1 = getBuiltIn$6('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$l = anObject$p;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$1 = hiddenKeys$5;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$1[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$l(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var fails$q = fails$A;
var isCallable$d = isCallable$p;
var isObject$f = isObject$l;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$9 = defineBuiltIn$b;
var wellKnownSymbol$k = wellKnownSymbol$m;

var ITERATOR$8 = wellKnownSymbol$k('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$f(IteratorPrototype$4) || fails$q(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$8].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$d(IteratorPrototype$4[ITERATOR$8])) {
  defineBuiltIn$9(IteratorPrototype$4, ITERATOR$8, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var $$y = _export;
var globalThis$f = globalThis_1;
var anInstance$3 = anInstance$4;
var anObject$k = anObject$p;
var isCallable$c = isCallable$p;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltInAccessor$6 = defineBuiltInAccessor$7;
var createProperty$1 = createProperty$2;
var fails$p = fails$A;
var hasOwn$8 = hasOwnProperty_1;
var wellKnownSymbol$j = wellKnownSymbol$m;
var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS$d = descriptors;

var CONSTRUCTOR = 'constructor';
var ITERATOR$7 = 'Iterator';
var TO_STRING_TAG$4 = wellKnownSymbol$j('toStringTag');

var $TypeError$d = TypeError;
var NativeIterator = globalThis$f[ITERATOR$7];

// FF56- have non-standard global helper `Iterator`
var FORCED$a = !isCallable$c(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype$3
  // FF44- non-standard `Iterator` passes previous tests
  || !fails$p(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance$3(this, IteratorPrototype$3);
  if (getPrototypeOf$1(this) === IteratorPrototype$3) throw new $TypeError$d('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS$d) {
    defineBuiltInAccessor$6(IteratorPrototype$3, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$k(this);
        if (this === IteratorPrototype$3) throw new $TypeError$d("You can't redefine this property");
        if (hasOwn$8(this, key)) this[key] = replacement;
        else createProperty$1(this, key, replacement);
      }
    });
  } else IteratorPrototype$3[key] = value;
};

if (!hasOwn$8(IteratorPrototype$3, TO_STRING_TAG$4)) defineIteratorPrototypeAccessor(TO_STRING_TAG$4, ITERATOR$7);

if (FORCED$a || !hasOwn$8(IteratorPrototype$3, CONSTRUCTOR) || IteratorPrototype$3[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype$3;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$$y({ global: true, constructor: true, forced: FORCED$a }, {
  Iterator: IteratorConstructor
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$8 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var defineBuiltIn$8 = defineBuiltIn$b;

var defineBuiltIns$4 = function (target, src, options) {
  for (var key in src) defineBuiltIn$8(target, key, src[key], options);
  return target;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$3 = function (value, done) {
  return { value: value, done: done };
};

var call$n = functionCall;
var anObject$j = anObject$p;
var getMethod$4 = getMethod$6;

var iteratorClose$d = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$j(iterator);
  try {
    innerResult = getMethod$4(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$n(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$j(innerResult);
  return value;
};

var iteratorClose$c = iteratorClose$d;

var iteratorCloseAll$1 = function (iters, kind, value) {
  for (var i = iters.length - 1; i >= 0; i--) {
    if (iters[i] === undefined) continue;
    try {
      value = iteratorClose$c(iters[i].iterator, kind, value);
    } catch (error) {
      kind = 'throw';
      value = error;
    }
  }
  if (kind === 'throw') throw value;
  return value;
};

var call$m = functionCall;
var create$5 = objectCreate;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$a;
var defineBuiltIns$3 = defineBuiltIns$4;
var wellKnownSymbol$i = wellKnownSymbol$m;
var InternalStateModule$3 = internalState;
var getMethod$3 = getMethod$6;
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var createIterResultObject$2 = createIterResultObject$3;
var iteratorClose$b = iteratorClose$d;
var iteratorCloseAll = iteratorCloseAll$1;

var TO_STRING_TAG$3 = wellKnownSymbol$i('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var NORMAL = 'normal';
var THROW = 'throw';
var setInternalState$3 = InternalStateModule$3.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule$3.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns$3(create$5(IteratorPrototype$2), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject$2(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject$2(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod$3(iterator, 'return');
        return returnMethod ? call$m(returnMethod, iterator) : createIterResultObject$2(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$b(state.inner.iterator, NORMAL);
      } catch (error) {
        return iteratorClose$b(iterator, THROW, error);
      }
      if (state.openIters) try {
        iteratorCloseAll(state.openIters, NORMAL);
      } catch (error) {
        return iteratorClose$b(iterator, THROW, error);
      }
      if (iterator) iteratorClose$b(iterator, NORMAL);
      return createIterResultObject$2(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty$7(IteratorHelperPrototype, TO_STRING_TAG$3, 'Iterator Helper');

var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState$3(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};

var anObject$i = anObject$p;
var iteratorClose$a = iteratorClose$d;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$2 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$i(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$a(iterator, 'throw', error);
  }
};

// Should throw an error on invalid iterator
// https://issues.chromium.org/issues/336839115
var iteratorHelperThrowsOnInvalidIterator$2 = function (methodName, argument) {
  // eslint-disable-next-line es/no-iterator -- required for testing
  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
  if (method) try {
    method.call({ next: null }, argument).next();
  } catch (error) {
    return true;
  }
};

var globalThis$e = globalThis_1;

// https://github.com/tc39/ecma262/pull/3467
var iteratorHelperWithoutClosingOnEarlyError$7 = function (METHOD_NAME, ExpectedError) {
  var Iterator = globalThis$e.Iterator;
  var IteratorPrototype = Iterator && Iterator.prototype;
  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];

  var CLOSED = false;

  if (method) try {
    method.call({
      next: function () { return { done: true }; },
      'return': function () { CLOSED = true; }
    }, -1);
  } catch (error) {
    // https://bugs.webkit.org/show_bug.cgi?id=291195
    if (!(error instanceof ExpectedError)) CLOSED = false;
  }

  if (!CLOSED) return method;
};

var $$x = _export;
var call$l = functionCall;
var aCallable$b = aCallable$d;
var anObject$h = anObject$p;
var getIteratorDirect$7 = getIteratorDirect$8;
var createIteratorProxy$1 = iteratorCreateProxy;
var callWithSafeIterationClosing$1 = callWithSafeIterationClosing$2;
var iteratorClose$9 = iteratorClose$d;
var iteratorHelperThrowsOnInvalidIterator$1 = iteratorHelperThrowsOnInvalidIterator$2;
var iteratorHelperWithoutClosingOnEarlyError$6 = iteratorHelperWithoutClosingOnEarlyError$7;

var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator$1('map', function () { /* empty */ });
var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR
  && iteratorHelperWithoutClosingOnEarlyError$6('map', TypeError);

var FORCED$9 = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;

var IteratorProxy$1 = createIteratorProxy$1(function () {
  var iterator = this.iterator;
  var result = anObject$h(call$l(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing$1(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
$$x({ target: 'Iterator', proto: true, real: true, forced: FORCED$9 }, {
  map: function map(mapper) {
    anObject$h(this);
    try {
      aCallable$b(mapper);
    } catch (error) {
      iteratorClose$9(this, 'throw', error);
    }

    if (mapWithoutClosingOnEarlyError) return call$l(mapWithoutClosingOnEarlyError, this, mapper);

    return new IteratorProxy$1(getIteratorDirect$7(this), {
      mapper: mapper
    });
  }
});

var DESCRIPTORS$c = descriptors;
var uncurryThis$s = functionUncurryThis;
var call$k = functionCall;
var fails$o = fails$A;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$6 = toObject$9;
var IndexedObject$2 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$5 = Object.defineProperty;
var concat$1 = uncurryThis$s([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$o(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$c && $assign({ b: 1 }, $assign(defineProperty$5({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$5(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$6(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$2(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$c || call$k(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$w = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$w({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var lib = {};

var slider = {};

var innerSlider = {};

var initialState$3 = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	var _default = initialState;
	exports["default"] = _default; 
} (initialState$3));

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$e(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$e(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$e(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$e(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;

var innerSliderUtils = {};

Object.defineProperty(innerSliderUtils, "__esModule", {
  value: true
});
innerSliderUtils.checkSpecKeys = innerSliderUtils.checkNavigable = innerSliderUtils.changeSlide = innerSliderUtils.canUseDOM = innerSliderUtils.canGoNext = void 0;
innerSliderUtils.clamp = clamp;
innerSliderUtils.swipeStart = innerSliderUtils.swipeMove = innerSliderUtils.swipeEnd = innerSliderUtils.slidesOnRight = innerSliderUtils.slidesOnLeft = innerSliderUtils.slideHandler = innerSliderUtils.siblingDirection = innerSliderUtils.safePreventDefault = innerSliderUtils.lazyStartIndex = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.keyHandler = innerSliderUtils.initializedState = innerSliderUtils.getWidth = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackCSS = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTotalSlides = innerSliderUtils.getSwipeDirection = innerSliderUtils.getSlideCount = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getPreClones = innerSliderUtils.getPostClones = innerSliderUtils.getOnDemandLazySlides = innerSliderUtils.getNavigableIndexes = innerSliderUtils.getHeight = innerSliderUtils.extractObject = void 0;

var _react$4 = _interopRequireDefault$4(React__namespace.default);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

innerSliderUtils.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


innerSliderUtils.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


innerSliderUtils.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

innerSliderUtils.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

innerSliderUtils.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

innerSliderUtils.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


innerSliderUtils.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

innerSliderUtils.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

innerSliderUtils.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


innerSliderUtils.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


innerSliderUtils.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


innerSliderUtils.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react$4["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

innerSliderUtils.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

innerSliderUtils.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

innerSliderUtils.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

innerSliderUtils.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

innerSliderUtils.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread$4(_objectSpread$4({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

innerSliderUtils.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

innerSliderUtils.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

innerSliderUtils.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

innerSliderUtils.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

innerSliderUtils.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

innerSliderUtils.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread$4(_objectSpread$4({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

innerSliderUtils.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

innerSliderUtils.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

innerSliderUtils.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

innerSliderUtils.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

innerSliderUtils.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

innerSliderUtils.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

innerSliderUtils.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

innerSliderUtils.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

innerSliderUtils.slidesOnLeft = slidesOnLeft;

var canUseDOM$1 = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

innerSliderUtils.canUseDOM = canUseDOM$1;

var track = {};

function _typeof$3(obj) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$3(obj); }

Object.defineProperty(track, "__esModule", {
  value: true
});
track.Track = void 0;

var _react$3 = _interopRequireDefault$3(React__namespace.default);

var _classnames$3 = _interopRequireDefault$3(classnamesExports);

var _innerSliderUtils$3 = innerSliderUtils;

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$3(self); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react$3["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils$3.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils$3.lazyEndIndex)(spec);

  _react$3["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react$3["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames$3["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread$3(_objectSpread$3({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils$3.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$3(Track, _React$PureComponent);

  var _super = _createSuper$3(Track);

  function Track() {
    var _this;

    _classCallCheck$3(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$3(_assertThisInitialized$3(_this), "node", null);

    _defineProperty$3(_assertThisInitialized$3(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass$3(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react$3["default"].createElement("div", _extends$2({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react$3["default"].PureComponent);

track.Track = Track;

var dots = {};

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }

Object.defineProperty(dots, "__esModule", {
  value: true
});
dots.Dots = void 0;

var _react$2 = _interopRequireDefault$2(React__namespace.default);

var _classnames$2 = _interopRequireDefault$2(classnamesExports);

var _innerSliderUtils$2 = innerSliderUtils;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$2(self); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$2(Dots, _React$PureComponent);

  var _super = _createSuper$2(Dots);

  function Dots() {
    _classCallCheck$2(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass$2(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils$2.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils$2.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames$2["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react$2["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react$2["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react$2["default"].cloneElement(this.props.appendDots(dots), _objectSpread$2({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react$2["default"].PureComponent);

dots.Dots = Dots;

var arrows = {};

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }

Object.defineProperty(arrows, "__esModule", {
  value: true
});
arrows.PrevArrow = arrows.NextArrow = void 0;

var _react$1 = _interopRequireDefault$1(React__namespace.default);

var _classnames$1 = _interopRequireDefault$1(classnamesExports);

var _innerSliderUtils$1 = innerSliderUtils;

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$1(PrevArrow, _React$PureComponent);

  var _super = _createSuper$1(PrevArrow);

  function PrevArrow() {
    _classCallCheck$1(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass$1(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames$1["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.prevArrow, _objectSpread$1(_objectSpread$1({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$1({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react$1["default"].PureComponent);

arrows.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits$1(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper$1(NextArrow);

  function NextArrow() {
    _classCallCheck$1(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass$1(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils$1.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames$1["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.nextArrow, _objectSpread$1(_objectSpread$1({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$1({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react$1["default"].PureComponent);

arrows.NextArrow = NextArrow;

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index$1 = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var ResizeObserver_es = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: index$1
});

var require$$8 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

Object.defineProperty(innerSlider, "__esModule", {
  value: true
});
innerSlider.InnerSlider = void 0;

var _react = _interopRequireDefault(React__namespace.default);

var _initialState = _interopRequireDefault(initialState$3);

var _lodash = _interopRequireDefault(lodash_debounce);

var _classnames = _interopRequireDefault(classnamesExports);

var _innerSliderUtils = innerSliderUtils;

var _track = track;

var _dots = dots;

var _arrows = arrows;

var _resizeObserverPolyfill = _interopRequireDefault(require$$8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

innerSlider.InnerSlider = InnerSlider;

var camel2hyphen$1 = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen$1;

var camel2hyphen = camel2hyphen_1;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var defaultProps = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _react = _interopRequireDefault(React__namespace.default);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default; 
} (defaultProps));

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */

var QueryHandler_1;
var hasRequiredQueryHandler;

function requireQueryHandler () {
	if (hasRequiredQueryHandler) return QueryHandler_1;
	hasRequiredQueryHandler = 1;
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}

	QueryHandler.prototype = {

	    constructor : QueryHandler,

	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },

	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },

	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },

	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },

	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }

	};

	QueryHandler_1 = QueryHandler;
	return QueryHandler_1;
}

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */

var Util;
var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return Util;
	hasRequiredUtil = 1;
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;

	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}

	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}

	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}

	Util = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};
	return Util;
}

var MediaQuery_1;
var hasRequiredMediaQuery;

function requireMediaQuery () {
	if (hasRequiredMediaQuery) return MediaQuery_1;
	hasRequiredMediaQuery = 1;
	var QueryHandler = requireQueryHandler();
	var each = requireUtil().each;

	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);

	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}

	MediaQuery.prototype = {

	    constuctor : MediaQuery,

	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);

	        this.matches() && qh.on();
	    },

	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },

	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },

	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },

	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';

	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};

	MediaQuery_1 = MediaQuery;
	return MediaQuery_1;
}

var MediaQueryDispatch_1;
var hasRequiredMediaQueryDispatch;

function requireMediaQueryDispatch () {
	if (hasRequiredMediaQueryDispatch) return MediaQueryDispatch_1;
	hasRequiredMediaQueryDispatch = 1;
	var MediaQuery = requireMediaQuery();
	var Util = requireUtil();
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;

	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }

	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}

	MediaQueryDispatch.prototype = {

	    constructor : MediaQueryDispatch,

	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;

	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }

	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });

	        return this;
	    },

	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];

	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }

	        return this;
	    }
	};

	MediaQueryDispatch_1 = MediaQueryDispatch;
	return MediaQueryDispatch_1;
}

var src;
var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;
	var MediaQueryDispatch = requireMediaQueryDispatch();
	src = new MediaQueryDispatch();
	return src;
}

(function (exports) {

	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _react = _interopRequireDefault(React__namespace.default);

	var _innerSlider = innerSlider;

	var _json2mq = _interopRequireDefault(json2mq_1);

	var _defaultProps = _interopRequireDefault(defaultProps);

	var _innerSliderUtils = innerSliderUtils;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var enquire = (0, _innerSliderUtils.canUseDOM)() && requireSrc();

	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);

	  var _super = _createSuper(Slider);

	  function Slider(props) {
	    var _this;

	    _classCallCheck(this, Slider);

	    _this = _super.call(this, props);

	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });

	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });

	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }

	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);

	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints

	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;

	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value

	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;

	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering


	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string

	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;

	      var settings;
	      var newProps;

	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      } // force scrolling by one if centerMode is on


	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && "production" !== "production") {}

	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on


	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && "production" !== "production") {}

	        if (settings.slidesToScroll > 1 && "production" !== "production") {}

	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child


	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }

	        return !!child;
	      }); // rows and slidesPerRow logic is handled here

	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }

	      var newChildren = [];
	      var currentWidth = null;

	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];

	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];

	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }

	            if (k >= children.length) break;
	            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }

	          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }

	        if (settings.variableWidth) {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }

	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }

	      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);

	  return Slider;
	}(_react["default"].Component);

	exports["default"] = Slider; 
} (slider));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _slider = _interopRequireDefault(slider);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	var _default = _slider["default"];
	exports["default"] = _default; 
} (lib));

var Slider = /*@__PURE__*/getDefaultExportFromCjs(lib);

const BannerSliderWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BannerSliderstyles__BannerSliderWrapper",
  componentId: "sc-1idf2af-0"
})(["margin:", ";.slick-dots{bottom:-20px;}.slick-dots li{width:8px;height:8px;margin:0 0 0 3px;}.slick-dots li button{width:8px;height:8px;outline:none;border:0;background-color:#d9d9d9;border-radius:50%;padding:0;&::before{display:none;}}.slick-dots li.slick-active button{background-color:", ";}"], ({
  margin
}) => margin, ({
  theme
}) => theme.colors.primaryAccent);
const BannerItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BannerSliderstyles__BannerItem",
  componentId: "sc-1idf2af-1"
})(["width:100%;height:245px;outline:none;border-radius:16px;overflow:hidden;> a{width:100%;}> a > img{max-height:245px !important;width:100%;object-fit:cover;}> img{width:100%;height:100%;object-fit:cover;max-height:245px !important;border-radius:16px;}cursor:pointer;"]);

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$4 = FunctionPrototype.apply;
var call$j = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$j.bind(apply$4) : function () {
  return call$j.apply(apply$4, arguments);
});

var uncurryThis$r = functionUncurryThis;
var aCallable$a = aCallable$d;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$r(aCallable$a(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$d = isObject$l;

var isPossiblePrototype$1 = function (argument) {
  return isObject$d(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$2 = String;
var $TypeError$c = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$c("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor$1 = functionUncurryThisAccessor;
var isObject$c = isObject$l;
var requireObjectCoercible$5 = requireObjectCoercible$8;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor$1(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$5(O);
    aPossiblePrototype(proto);
    if (!isObject$c(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$4 = objectDefineProperty.f;

var proxyAccessor$2 = function (Target, Source, key) {
  key in Target || defineProperty$4(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var isCallable$b = isCallable$p;
var isObject$b = isObject$l;
var setPrototypeOf$2 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$3 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$2 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$b(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$b(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$2($this, NewTargetPrototype);
  return $this;
};

var wellKnownSymbol$h = wellKnownSymbol$m;

var TO_STRING_TAG$2 = wellKnownSymbol$h('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$a = isCallable$p;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$g = wellKnownSymbol$m;

var TO_STRING_TAG$1 = wellKnownSymbol$g('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$c = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$a(O.callee) ? 'Arguments' : result;
};

var classof$b = classof$c;

var $String$1 = String;

var toString$d = function (argument) {
  if (classof$b(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var toString$c = toString$d;

var normalizeStringArgument$1 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$c(argument);
};

var isObject$a = isObject$l;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$a;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$a(options) && 'cause' in options) {
    createNonEnumerableProperty$6(O, 'cause', options.cause);
  }
};

var uncurryThis$q = functionUncurryThis;

var $Error = Error;
var replace$6 = uncurryThis$q(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$6(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var fails$n = fails$A;
var createPropertyDescriptor$2 = createPropertyDescriptor$6;

var errorStackInstallable = !fails$n(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor$2(1, 7));
  return error.stack !== 7;
});

var createNonEnumerableProperty$5 = createNonEnumerableProperty$a;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
// eslint-disable-next-line es/no-nonstandard-error-properties -- safe
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty$5(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};

var getBuiltIn$5 = getBuiltIn$9;
var hasOwn$7 = hasOwnProperty_1;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$a;
var isPrototypeOf$4 = objectIsPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var copyConstructorProperties$1 = copyConstructorProperties$3;
var proxyAccessor$1 = proxyAccessor$2;
var inheritIfRequired$2 = inheritIfRequired$3;
var normalizeStringArgument = normalizeStringArgument$1;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var DESCRIPTORS$b = descriptors;

var wrapErrorConstructorWithCause$1 = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn$5.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (hasOwn$7(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn$5('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty$4(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf$4(OriginalErrorPrototype, this)) inheritIfRequired$2(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf$1) setPrototypeOf$1(WrappedError, BaseError);
    else copyConstructorProperties$1(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS$b && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor$1(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor$1(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties$1(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty$4(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $$v = _export;
var globalThis$d = globalThis_1;
var apply$3 = functionApply;
var wrapErrorConstructorWithCause = wrapErrorConstructorWithCause$1;

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = globalThis$d[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$8 = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$8);
  $$v({ global: true, constructor: true, arity: 1, forced: FORCED$8 }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$8);
    $$v({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED$8 }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply$3(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply$3(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply$3(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply$3(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply$3(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply$3(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply$3(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply$3(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply$3(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply$3(init, this, arguments); };
});

var classof$a = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$4 = Array.isArray || function isArray(argument) {
  return classof$a(argument) === 'Array';
};

var DESCRIPTORS$a = descriptors;
var isArray$3 = isArray$4;

var $TypeError$b = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$a && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray$3(O) && !getOwnPropertyDescriptor$1(O, 'length').writable) {
    throw new $TypeError$b('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$a = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$2 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$a('Maximum allowed index exceeded');
  return it;
};

var $$u = _export;
var toObject$5 = toObject$9;
var lengthOfArrayLike$6 = lengthOfArrayLike$8;
var setArrayLength$1 = arraySetLength;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
var fails$m = fails$A;

var INCORRECT_TO_LENGTH = fails$m(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength$1 = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED$7 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength$1();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$u({ target: 'Array', proto: true, arity: 1, forced: FORCED$7 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$5(this);
    var len = lengthOfArrayLike$6(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger$1(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength$1(O, len);
    return len;
  }
});

// Inline slick CSS content
const SLICK_CSS = `.slick-list,.slick-slider,.slick-track{position:relative;display:block}.slick-loading .slick-slide,.slick-loading .slick-track{visibility:hidden}.slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:0}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);-o-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.slick-track{top:0;left:0}.slick-track:after,.slick-track:before{display:table;content:''}.slick-track:after{clear:both}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}`;
const SLICK_THEME_CSS = `@charset 'UTF-8';.slick-dots,.slick-next,.slick-prev{position:absolute;display:block;padding:0}.slick-dots li button:before,.slick-next:before,.slick-prev:before{font-family:slick;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-loading .slick-list{}.slick-next,.slick-prev{font-size:0;line-height:0;top:50%;width:20px;height:20px;-webkit-transform:translate(0,-50%);-ms-transform:translate(0,-50%);transform:translate(0,-50%);cursor:pointer;color:transparent;border:none;outline:0;background:0 0}.slick-next:focus,.slick-next:hover,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:0;background:0 0}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-size:20px;line-height:1;opacity:.75;color:#fff}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:'←'}.slick-next:before,[dir=rtl] .slick-prev:before{content:'→'}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}[dir=rtl] .slick-next:before{content:'←'}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{bottom:-25px;width:100%;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;width:20px;height:20px;margin:0 5px;padding:0;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;width:20px;height:20px;padding:5px;cursor:pointer;color:transparent;border:0;outline:0;background:0 0}.slick-dots li button:focus,.slick-dots li button:hover{outline:0}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:'•';text-align:center;opacity:.25;color:#000}.slick-dots li.slick-active button:before{opacity:.75;color:#000}`;
/**
 * Injects CSS content directly into the document head
 * @param css - CSS content to inject
 * @param id - Unique ID for the style element
 * @returns Cleanup function to remove the injected CSS
 */
function injectCSS(css, id) {
  // Check if CSS is already injected
  const existingStyle = document.getElementById(id);
  if (existingStyle) {
    return () => {
      // No cleanup needed if already injected
    };
  }
  const style = document.createElement('style');
  style.id = id;
  style.type = 'text/css';
  style.textContent = css;
  document.head.appendChild(style);
  // Return cleanup function
  return () => {
    try {
      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    } catch (error) {
      console.warn('Error removing inline CSS:', error);
    }
  };
}
/**
 * Loads slick CSS inline for carousel components
 * Uses inline CSS injection to avoid network calls and path issues
 * @returns Cleanup function to remove injected CSS
 */
function loadSlickCSS() {
  const cleanupFunctions = [];
  // Use a timeout to ensure DOM is ready and avoid the parentNode error
  const loadSlickStyles = () => {
    // Check if we're in a browser environment
    if (coreUtils.isOnServer()) {
      return;
    }
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadSlickStyles);
      return;
    }
    console.log('🚀 loadSlickCSS: Injecting inline Slick CSS...');
    // Inject slick.min.css inline
    const slickCleanup = injectCSS(SLICK_CSS, 'slick-css-inline');
    cleanupFunctions.push(slickCleanup);
    console.log('✅ Slick CSS injected successfully');
    // Inject slick-theme.min.css inline
    const themeCleanup = injectCSS(SLICK_THEME_CSS, 'slick-theme-css-inline');
    cleanupFunctions.push(themeCleanup);
    console.log('✅ Slick theme CSS injected successfully');
  };
  // Use setTimeout to ensure this runs after the module loading phase
  setTimeout(loadSlickStyles, 0);
  // Return combined cleanup function
  return () => {
    cleanupFunctions.forEach(cleanup => cleanup());
  };
}

const BannerSlider = ({
  componentData,
  margin
}) => {
  var _a;
  const settings = {
    arrows: false,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };
  const {
    nodeId,
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  // Load slick CSS dynamically to avoid DOM access issues in federated modules
  React.useEffect(() => {
    const cleanup = loadSlickCSS();
    return cleanup;
  }, []);
  // const bannerClickHandler = (item: any) => {
  //   if (item.cta.deeplink) redirectTo(item.cta.deeplink);
  // };
  const handleBannerClick = item => {
    var _a, _b;
    pdtUtils.trackEvent({
      eventData: (_b = (_a = item === null || item === void 0 ? void 0 : item.cta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
  };
  return jsxRuntime.jsx(BannerSliderWrapper, {
    margin: margin,
    id: nodeId,
    children: (data === null || data === void 0 ? void 0 : data.items) && ((_a = data === null || data === void 0 ? void 0 : data.items) === null || _a === void 0 ? void 0 : _a.length) > 0 && jsxRuntime.jsx(Slider, Object.assign({}, settings, {
      children: data.items.map((item, index) => {
        var _a, _b, _c;
        return jsxRuntime.jsx(BannerItem, {
          children: (item === null || item === void 0 ? void 0 : item.image) && jsxRuntime.jsx(designSystem.Anchor, {
            href: (_a = item === null || item === void 0 ? void 0 : item.cta) === null || _a === void 0 ? void 0 : _a.deeplink,
            target: (_b = item === null || item === void 0 ? void 0 : item.cta) === null || _b === void 0 ? void 0 : _b.target,
            onClick: () => handleBannerClick(item),
            children: jsxRuntime.jsx(designSystem.Image, {
              src: (_c = item.image) === null || _c === void 0 ? void 0 : _c.url,
              alt: "banner",
              showCursorPointer: true
            })
          })
        }, index);
      })
    }))
  }, nodeId);
};

var wellKnownSymbol$f = wellKnownSymbol$m;
var create$4 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$f('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$4(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$6 = hasOwnProperty_1;
var wellKnownSymbol$e = wellKnownSymbol$m;

var TO_STRING_TAG = wellKnownSymbol$e('toStringTag');

var setToStringTag$5 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$6(target, TO_STRING_TAG)) {
    defineProperty$2(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$3 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$6;
var setToStringTag$4 = setToStringTag$5;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$3(IteratorPrototype$1, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$4(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$t = _export;
var call$i = functionCall;
var FunctionName = functionName;
var isCallable$9 = isCallable$p;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$5;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$a;
var defineBuiltIn$7 = defineBuiltIn$b;
var wellKnownSymbol$d = wellKnownSymbol$m;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$6 = wellKnownSymbol$d('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$6]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$9(CurrentIteratorPrototype[ITERATOR$6])) {
          defineBuiltIn$7(CurrentIteratorPrototype, ITERATOR$6, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$3(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$3(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$i(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$7(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$t({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$6] !== defaultIterator) {
    defineBuiltIn$7(IterablePrototype, ITERATOR$6, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject$2 = toIndexedObject$7;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$2 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$3;
var DESCRIPTORS$9 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState$2 = InternalStateModule$2.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$2(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$2(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$9 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$c = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$a;
var setToStringTag$2 = setToStringTag$5;
var wellKnownSymbol$c = wellKnownSymbol$m;

var ITERATOR$5 = wellKnownSymbol$c('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$5] !== ArrayValues) try {
      createNonEnumerableProperty$2(CollectionPrototype, ITERATOR$5, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$5] = ArrayValues;
    }
    setToStringTag$2(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$2(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$c[COLLECTION_NAME] && globalThis$c[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const CcNudgeWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CreditCardNudgestyles__CcNudgeWrapper",
  componentId: "sc-1cdug0n-0"
})(["padding:20px 16px;background-color:", ";border-radius:", ";margin:", ";@media ", "{display:flex;flex-direction:row;gap:40px;align-items:flex-start;padding:30px 40px;}"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br16, ({
  margin
}) => margin, commonUi.deviceType.desktop);
const TitleWrapper$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CreditCardNudgestyles__TitleWrapper",
  componentId: "sc-1cdug0n-1"
})(["@media ", "{display:flex;flex-direction:column;gap:8px;}"], commonUi.deviceType.desktop);
const ComparisonSection$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CreditCardNudgestyles__ComparisonSection",
  componentId: "sc-1cdug0n-2"
})(["display:flex;justify-content:space-between;background:", ";padding:16px;border-radius:", ";margin:12px 0px;@media ", "{margin:0px;flex:1;padding:12px 16px;}"], ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => theme.borderRadius.br8, commonUi.deviceType.desktop);
const Card$2 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CreditCardNudgestyles__Card",
  componentId: "sc-1cdug0n-3"
})(["display:flex;flex-direction:column;align-items:center;flex:1;flex-shrink:0;text-align:center;"]);
const CardSeparator$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CreditCardNudgestyles__CardSeparator",
  componentId: "sc-1cdug0n-4"
})(["width:24px;flex-shrink:0;margin:0 16px;position:relative;display:flex;align-items:center;::before{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:1px;height:100%;border-left:1px dashed ", ";}"], ({
  theme
}) => theme.colors.disabledBg);
const CardSeparatorCircle$1 = /*#__PURE__*/styled__default.default.span.withConfig({
  displayName: "CreditCardNudgestyles__CardSeparatorCircle",
  componentId: "sc-1cdug0n-5"
})(["width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:", ";position:relative;"], ({
  theme
}) => theme.colors.mediumEmphasis);
const CircleImage = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "CreditCardNudgestyles__CircleImage",
  componentId: "sc-1cdug0n-6"
})(["z-index:10;"]);
const BottomBanner$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CreditCardNudgestyles__BottomBanner",
  componentId: "sc-1cdug0n-7"
})(["display:flex;flex-direction:row;align-items:center;gap:8px;@media ", "{background:", ";padding:8px;border-radius:", ";}"], commonUi.deviceType.mobile, ({
  theme
}) => theme.colors.positiveBg, ({
  theme
}) => theme.borderRadius.br8);
const CardTitle$1 = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "CreditCardNudgestyles__CardTitle",
  componentId: "sc-1cdug0n-8"
})(["@media ", "{max-width:90px;}text-align:center;"], commonUi.deviceType.mobile);
const Item$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CreditCardNudgestyles__Item",
  componentId: "sc-1cdug0n-9"
})(["min-height:", ";"], ({
  minHeight
}) => `${minHeight}px`);

const CardComponent$1 = ({
  title,
  infoItems,
  color,
  refs,
  maxHeights
}) => {
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  return jsxRuntime.jsxs(Card$2, {
    children: [jsxRuntime.jsx(CardTitle$1, {
      typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.baseW2 : designTokens.TYPOGRAPHY_KEYS.largeW3,
      color: theme.colors.mediumEmphasis,
      text: title
    }), infoItems === null || infoItems === void 0 ? void 0 : infoItems.map((item, index) => jsxRuntime.jsx(Item$1, {
      ref: el => {
        if (refs.current && el) {
          refs.current[index] = el;
        }
      },
      minHeight: maxHeights[index],
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.baseW1 : designTokens.TYPOGRAPHY_KEYS.mediumW1,
        color: color,
        text: item === null || item === void 0 ? void 0 : item.text,
        margin: "4px 0 0px"
      })
    }, index))]
  });
};

const BannerComponent$1 = ({
  bottomBanner,
  onClick
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  return jsxRuntime.jsxs(BottomBanner$1, {
    children: [jsxRuntime.jsx(designSystem.Image, {
      src: (_a = bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.icon) === null || _a === void 0 ? void 0 : _a.url,
      width: "16px"
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.largeW1 : designTokens.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.highEmphasis,
      text: bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.title,
      onClick: item => onClick === null || onClick === void 0 ? void 0 : onClick(item)
    })]
  });
};

const CouponDetailsWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CouponDetailsWrapper",
  componentId: "sc-1audkfb-0"
})([""]);
const CouponListWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CouponListWrapper",
  componentId: "sc-1audkfb-1"
})(["display:flex;flex-direction:column;margin:8px 0px 0px;gap:8px;"]);
const CouponItemWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__CouponItemWrapper",
  componentId: "sc-1audkfb-2"
})(["display:flex;flex-direction:column;padding:12px;gap:4px;border-radius:", ";border:1px solid ", ";"], ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.cardBorder);
const InfoSectionWrapper$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__InfoSectionWrapper",
  componentId: "sc-1audkfb-3"
})(["margin:24px 0px 0px;"]);
const InfoList = /*#__PURE__*/styled__default.default.ul.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__InfoList",
  componentId: "sc-1audkfb-4"
})(["display:flex;flex-direction:column;gap:8px;margin-top:12px;"]);
const InfoItem = /*#__PURE__*/styled__default.default.li.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__InfoItem",
  componentId: "sc-1audkfb-5"
})(["position:relative;padding-left:10px;::before{content:'';position:absolute;left:0;top:6px;width:4px;height:4px;border-radius:50%;background-color:", ";}"], ({
  theme
}) => theme.colors.cardBorder);
const OfferSlabTable$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__OfferSlabTable",
  componentId: "sc-1audkfb-6"
})(["border-radius:", ";border:1px solid ", ";overflow:hidden;margin:8px 0px 0px;"], ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.cardBorder);
const Table$1 = /*#__PURE__*/styled__default.default.table.withConfig({
  displayName: "CouponDetailsBottomSheetstyles__Table",
  componentId: "sc-1audkfb-7"
})(["border-collapse:collapse;width:100%;th{border-bottom:1px solid ", ";padding:12px;background:", ";}td{padding:10px;}tbody tr:not(:last-child) td{border-bottom:1px solid ", ";}thead tr th:not(:last-child){border-right:1px solid ", ";}tbody tr td:not(:last-child){border-right:1px solid ", ";}"], ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.cardBorder);

var globalThis$b = globalThis_1;
var fails$l = fails$A;

// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp$1 = globalThis$b.RegExp;

var FLAGS_GETTER_IS_CORRECT = !fails$l(function () {
  var INDICES_SUPPORT = true;
  try {
    RegExp$1('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {};
  // modern V8 bug
  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, { get: function () {
      calls += chr;
      return true;
    } });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };

  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]);

  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  var result = Object.getOwnPropertyDescriptor(RegExp$1.prototype, 'flags').get.call(O);

  return result !== expected || calls !== expected;
});

var regexpFlagsDetection = { correct: FLAGS_GETTER_IS_CORRECT };

var anObject$g = anObject$p;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$g(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$h = functionCall;
var hasOwn$5 = hasOwnProperty_1;
var isPrototypeOf$3 = objectIsPrototypeOf;
var regExpFlagsDetection$1 = regexpFlagsDetection;
var regExpFlagsGetterImplementation$1 = regexpFlags$1;

var RegExpPrototype$4 = RegExp.prototype;

var regexpGetFlags = regExpFlagsDetection$1.correct ? function (it) {
  return it.flags;
} : function (it) {
  return (!regExpFlagsDetection$1.correct && isPrototypeOf$3(RegExpPrototype$4, it) && !hasOwn$5(it, 'flags'))
    ? call$h(regExpFlagsGetterImplementation$1, it)
    : it.flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$6 = defineBuiltIn$b;
var anObject$f = anObject$p;
var $toString$1 = toString$d;
var fails$k = fails$A;
var getRegExpFlags$2 = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$3 = RegExp.prototype;
var nativeToString = RegExpPrototype$3[TO_STRING];

var NOT_GENERIC = fails$k(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$6(RegExpPrototype$3, TO_STRING, function toString() {
    var R = anObject$f(this);
    var pattern = $toString$1(R.source);
    var flags = $toString$1(getRegExpFlags$2(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const CouponItem = ({
  coupon
}) => {
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(CouponItemWrapper, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.title,
      color: theme.colors.highEmphasis,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW3
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.label,
      color: theme.colors.lowEmphasis,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: coupon === null || coupon === void 0 ? void 0 : coupon.subLabel,
      color: theme.colors.lowEmphasis,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1
    })]
  });
};

const CouponList = ({
  couponList
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const theme = React.useContext(styled.ThemeContext);
  if (!(couponList === null || couponList === void 0 ? void 0 : couponList.length)) {
    return null;
  }
  const toggleShowMore = () => {
    setIsExpanded(prev => !prev);
  };
  const displayedCoupons = isExpanded ? couponList : couponList.slice(0, 1);
  return jsxRuntime.jsxs(CouponListWrapper, {
    children: [displayedCoupons === null || displayedCoupons === void 0 ? void 0 : displayedCoupons.map((coupon, index) => jsxRuntime.jsx(CouponItem, {
      coupon: coupon
    }, index.toString())), couponList.length > 1 ? jsxRuntime.jsx(designSystem.Anchor, {
      color: theme.colors.primaryAccent,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
      onClick: toggleShowMore,
      margin: "8px 0px  0px",
      children: isExpanded ? 'Show less' : `+ ${couponList.length - 1} More Coupon`
    }) : null]
  });
};

const InfoSection = ({
  data
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  if (!data) {
    return null;
  }
  return jsxRuntime.jsxs(InfoSectionWrapper$1, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: data === null || data === void 0 ? void 0 : data.title,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.lowEmphasis
    }), jsxRuntime.jsx(InfoList, {
      children: (_a = data === null || data === void 0 ? void 0 : data.list) === null || _a === void 0 ? void 0 : _a.map((item, index) => jsxRuntime.jsx(InfoItem, {
        children: jsxRuntime.jsx(designSystem.FormattedText, {
          text: item,
          color: theme.colors.mediumEmphasis,
          typography: designTokens.TYPOGRAPHY_KEYS.baseW1
        })
      }, index.toString()))
    })]
  });
};

const OfferSlabs$1 = ({
  data
}) => {
  var _a, _b, _c, _d;
  const theme = React.useContext(styled.ThemeContext);
  if (!data) {
    return null;
  }
  return jsxRuntime.jsxs(InfoSectionWrapper$1, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: data === null || data === void 0 ? void 0 : data.title,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.lowEmphasis
    }), jsxRuntime.jsx(OfferSlabTable$1, {
      children: jsxRuntime.jsxs(Table$1, {
        border: 0,
        width: "100%",
        cellPadding: "",
        cellSpacing: "0",
        children: [jsxRuntime.jsx("thead", {
          children: jsxRuntime.jsx("tr", {
            children: (_a = data === null || data === void 0 ? void 0 : data.offerList) === null || _a === void 0 ? void 0 : _a.map(offer => jsxRuntime.jsx("th", {
              children: jsxRuntime.jsx(designSystem.FormattedText, {
                text: offer === null || offer === void 0 ? void 0 : offer.title,
                color: theme.colors.mediumEmphasis,
                typography: designTokens.TYPOGRAPHY_KEYS.baseW2
              })
            }, offer.id))
          })
        }), jsxRuntime.jsx("tbody", {
          children: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.offerList) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.list) === null || _d === void 0 ? void 0 : _d.map((_, rowIndex) => {
            var _a;
            return jsxRuntime.jsx("tr", {
              children: (_a = data === null || data === void 0 ? void 0 : data.offerList) === null || _a === void 0 ? void 0 : _a.map(offer => {
                var _a;
                return jsxRuntime.jsx("td", {
                  align: "center",
                  children: jsxRuntime.jsx(designSystem.FormattedText, {
                    text: (_a = offer === null || offer === void 0 ? void 0 : offer.list) === null || _a === void 0 ? void 0 : _a[rowIndex],
                    color: theme.colors.mediumEmphasis,
                    typography: designTokens.TYPOGRAPHY_KEYS.baseW1
                  })
                }, offer.id);
              })
            }, rowIndex);
          })
        })]
      })
    })]
  });
};

const CouponDetailsBottomSheet = ({
  data,
  onModalClose
}) => {
  const device = commonUi.useDevice();
  const theme = React.useContext(styled.ThemeContext);
  React.useEffect(() => {
    var _a;
    pdtUtils.trackEvent({
      eventData: (_a = data === null || data === void 0 ? void 0 : data.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
  }, []);
  return jsxRuntime.jsx(designSystem.Modal, {
    modalType: device === commonUi.DEVICE.DESKTOP ? 'centered' : 'bottomSheet',
    onModalClose: onModalClose,
    heading: data === null || data === void 0 ? void 0 : data.title,
    modalMaxHeight: device === commonUi.DEVICE.MOBILE ? 'calc(100vh - 200px)' : '371px',
    children: jsxRuntime.jsxs(CouponDetailsWrapper, {
      children: [jsxRuntime.jsx(designSystem.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.label,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.mediumEmphasis
      }), jsxRuntime.jsx(CouponList, {
        couponList: data === null || data === void 0 ? void 0 : data.couponList
      }), jsxRuntime.jsx(OfferSlabs$1, {
        data: data === null || data === void 0 ? void 0 : data.offerSlabs
      }), jsxRuntime.jsx(InfoSection, {
        data: data === null || data === void 0 ? void 0 : data.howToApply
      }), jsxRuntime.jsx(InfoSection, {
        data: data === null || data === void 0 ? void 0 : data.tnc
      })]
    })
  });
};

const BannerWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CcComparisonBottomSheetstyles__BannerWrapper",
  componentId: "we5d8h-0"
})(["display:flex;flex-direction:row;align-items:center;gap:8px;background:", ";padding:8px;border-radius:", ";"], ({
  theme
}) => theme.colors.positiveBg, ({
  theme
}) => theme.borderRadius.br8);
const ComparisonSection = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CcComparisonBottomSheetstyles__ComparisonSection",
  componentId: "we5d8h-1"
})(["display:flex;justify-content:space-between;background:", ";border-radius:", ";margin:24px 0px;"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br8);
const Card$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CcComparisonBottomSheetstyles__Card",
  componentId: "we5d8h-2"
})(["display:flex;flex-direction:column;align-items:center;flex:1;flex-shrink:0;"]);
const CardTitle = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "CcComparisonBottomSheetstyles__CardTitle",
  componentId: "we5d8h-3"
})(["max-width:130px;text-align:center;"]);
const CardContainer$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CcComparisonBottomSheetstyles__CardContainer",
  componentId: "we5d8h-4"
})(["border-radius:8px;gap:4px;padding:12px;display:flex;flex-direction:column;align-items:center;background:", ";border:1px solid ", ";margin:24px 0px 0px;text-align:center;"], props => props.bgColor, props => props.borderColor);
const CardSeparator = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CcComparisonBottomSheetstyles__CardSeparator",
  componentId: "we5d8h-5"
})(["width:24px;flex-shrink:0;position:relative;display:flex;align-items:flex-start;"]);
const CardSeparatorLine = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CcComparisonBottomSheetstyles__CardSeparatorLine",
  componentId: "we5d8h-6"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:1px;height:100%;border-left:1px dashed ", ";"], ({
  theme
}) => theme.colors.disabledBg);
const CardSeparatorCircle = /*#__PURE__*/styled__default.default.span.withConfig({
  displayName: "CcComparisonBottomSheetstyles__CardSeparatorCircle",
  componentId: "we5d8h-7"
})(["width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:", ";position:relative;top:10px;z-index:10;"], ({
  theme
}) => theme.colors.mediumEmphasis);
const FeatureList = /*#__PURE__*/styled__default.default.ul.withConfig({
  displayName: "CcComparisonBottomSheetstyles__FeatureList",
  componentId: "we5d8h-8"
})(["margin-top:24px;display:flex;flex-direction:column;row-gap:8px;"]);
const Item = /*#__PURE__*/styled__default.default.li.withConfig({
  displayName: "CcComparisonBottomSheetstyles__Item",
  componentId: "we5d8h-9"
})(["min-height:", ";position:relative;padding-left:10px;::before{content:'';position:absolute;left:0;top:10px;width:4px;height:4px;border-radius:50%;background-color:", ";}"], ({
  minHeight
}) => `${minHeight}px`, ({
  bulletColor
}) => bulletColor);

const BannerComponent = ({
  banner
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(BannerWrapper, {
    children: [jsxRuntime.jsx(designSystem.Image, {
      src: (_a = banner === null || banner === void 0 ? void 0 : banner.icon) === null || _a === void 0 ? void 0 : _a.url,
      width: "16px"
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
      color: theme.colors.highEmphasis,
      text: banner === null || banner === void 0 ? void 0 : banner.title
    })]
  });
};

const ConversionRateBox = ({
  boxTheme,
  conversionInfo
}) => {
  return jsxRuntime.jsxs(CardContainer$1, {
    borderColor: boxTheme === null || boxTheme === void 0 ? void 0 : boxTheme.borderColor,
    bgColor: boxTheme === null || boxTheme === void 0 ? void 0 : boxTheme.bgColor,
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: conversionInfo === null || conversionInfo === void 0 ? void 0 : conversionInfo.text,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      color: boxTheme.textColor
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: conversionInfo === null || conversionInfo === void 0 ? void 0 : conversionInfo.subtext,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      color: boxTheme.subtextColor
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: conversionInfo === null || conversionInfo === void 0 ? void 0 : conversionInfo.markup,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
      color: boxTheme.markupColor
    })]
  });
};

const CardComponent = ({
  data,
  refs,
  maxHeights,
  conversionBoxTheme
}) => {
  var _a, _b;
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(Card$1, {
    children: [jsxRuntime.jsx(CardTitle, {
      text: data === null || data === void 0 ? void 0 : data.title,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
      color: theme.colors.highEmphasis
    }), jsxRuntime.jsx(designSystem.Image, {
      src: typeof (data === null || data === void 0 ? void 0 : data.icon) === 'string' ? data === null || data === void 0 ? void 0 : data.icon : (_a = data === null || data === void 0 ? void 0 : data.icon) === null || _a === void 0 ? void 0 : _a.url,
      width: "56px",
      height: "12px"
    }), jsxRuntime.jsx(ConversionRateBox, {
      conversionInfo: data === null || data === void 0 ? void 0 : data.conversionInfo,
      boxTheme: conversionBoxTheme
    }), jsxRuntime.jsx(FeatureList, {
      children: (_b = data === null || data === void 0 ? void 0 : data.featureList) === null || _b === void 0 ? void 0 : _b.map((item, index) => jsxRuntime.jsx(Item, {
        ref: el => {
          if (refs.current && el) {
            refs.current[index] = el;
          }
        },
        minHeight: maxHeights[index],
        bulletColor: data === null || data === void 0 ? void 0 : data.bulletColor,
        children: jsxRuntime.jsx(designSystem.FormattedText, {
          typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
          color: theme.colors.mediumEmphasis,
          text: item === null || item === void 0 ? void 0 : item.text,
          margin: "4px 0 0px"
        })
      }, index))
    })]
  });
};

var $$s = _export;
var $includes = arrayIncludes.includes;
var fails$j = fails$A;
var addToUnscopables$1 = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$j(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$s({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var $$r = _export;
var call$g = functionCall;
var aCallable$9 = aCallable$d;
var anObject$e = anObject$p;
var getIteratorDirect$6 = getIteratorDirect$8;
var createIteratorProxy = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$2;
var iteratorClose$8 = iteratorClose$d;
var iteratorHelperThrowsOnInvalidIterator = iteratorHelperThrowsOnInvalidIterator$2;
var iteratorHelperWithoutClosingOnEarlyError$5 = iteratorHelperWithoutClosingOnEarlyError$7;

var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('filter', function () { /* empty */ });
var filterWithoutClosingOnEarlyError = !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR
  && iteratorHelperWithoutClosingOnEarlyError$5('filter', TypeError);

var FORCED$6 = FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject$e(call$g(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
$$r({ target: 'Iterator', proto: true, real: true, forced: FORCED$6 }, {
  filter: function filter(predicate) {
    anObject$e(this);
    try {
      aCallable$9(predicate);
    } catch (error) {
      iteratorClose$8(this, 'throw', error);
    }

    if (filterWithoutClosingOnEarlyError) return call$g(filterWithoutClosingOnEarlyError, this, predicate);

    return new IteratorProxy(getIteratorDirect$6(this), {
      predicate: predicate
    });
  }
});

var classofRaw = classofRaw$2;
var uncurryThis$p = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$p(fn);
};

var uncurryThis$o = functionUncurryThisClause;
var aCallable$8 = aCallable$d;
var NATIVE_BIND = functionBindNative;

var bind$3 = uncurryThis$o(uncurryThis$o.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$8(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$3(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$b = wellKnownSymbol$m;
var Iterators$1 = iterators;

var ITERATOR$4 = wellKnownSymbol$b('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$4] === it);
};

var classof$9 = classof$c;
var getMethod$2 = getMethod$6;
var isNullOrUndefined$2 = isNullOrUndefined$5;
var Iterators = iterators;
var wellKnownSymbol$a = wellKnownSymbol$m;

var ITERATOR$3 = wellKnownSymbol$a('iterator');

var getIteratorMethod$3 = function (it) {
  if (!isNullOrUndefined$2(it)) return getMethod$2(it, ITERATOR$3)
    || getMethod$2(it, '@@iterator')
    || Iterators[classof$9(it)];
};

var call$f = functionCall;
var aCallable$7 = aCallable$d;
var anObject$d = anObject$p;
var tryToString$2 = tryToString$4;
var getIteratorMethod$2 = getIteratorMethod$3;

var $TypeError$9 = TypeError;

var getIterator$2 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$2(argument) : usingIterator;
  if (aCallable$7(iteratorMethod)) return anObject$d(call$f(iteratorMethod, argument));
  throw new $TypeError$9(tryToString$2(argument) + ' is not iterable');
};

var bind$2 = functionBindContext;
var call$e = functionCall;
var anObject$c = anObject$p;
var tryToString$1 = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$5 = lengthOfArrayLike$8;
var isPrototypeOf$2 = objectIsPrototypeOf;
var getIterator$1 = getIterator$2;
var getIteratorMethod$1 = getIteratorMethod$3;
var iteratorClose$7 = iteratorClose$d;

var $TypeError$8 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$a = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$2(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$7(iterator, 'normal');
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$c(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw new $TypeError$8(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$5(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$2(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$1(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$e(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$7(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$2(ResultPrototype, result)) return result;
  } return new Result(false);
};

var $$q = _export;
var iterate$9 = iterate$a;
var createProperty = createProperty$2;

// `Object.fromEntries` method
// https://tc39.es/ecma262/#sec-object.fromentries
$$q({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate$9(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});

var fails$i = fails$A;
var globalThis$a = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis$a.RegExp;

var UNSUPPORTED_Y$2 = fails$i(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$2 || fails$i(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$i(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var fails$h = fails$A;
var globalThis$9 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis$9.RegExp;

var regexpUnsupportedDotAll = fails$h(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$g = fails$A;
var globalThis$8 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis$8.RegExp;

var regexpUnsupportedNcg = fails$g(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$d = functionCall;
var uncurryThis$n = functionUncurryThis;
var toString$b = toString$d;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4;
var create$2 = objectCreate;
var getInternalState$1 = internalState.get;
var UNSUPPORTED_DOT_ALL$2 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$7 = uncurryThis$n(''.charAt);
var indexOf = uncurryThis$n(''.indexOf);
var replace$5 = uncurryThis$n(''.replace);
var stringSlice$6 = uncurryThis$n(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$d(nativeExec, re1, 'a');
  call$d(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL$2 || UNSUPPORTED_NCG$1;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString$b(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$d(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$d(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$5(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$6(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$7(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$d(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$6(match.input, charsAdded);
        match[0] = stringSlice$6(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$d(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$p = _export;
var exec$4 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$p({ target: 'RegExp', proto: true, forced: /./.exec !== exec$4 }, {
  exec: exec$4
});

var isObject$9 = isObject$l;
var classof$8 = classofRaw$2;
var wellKnownSymbol$9 = wellKnownSymbol$m;

var MATCH$2 = wellKnownSymbol$9('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$9(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$8(it) === 'RegExp');
};

var isRegExp$1 = isRegexp;

var $TypeError$7 = TypeError;

var notARegexp = function (it) {
  if (isRegExp$1(it)) {
    throw new $TypeError$7("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$8 = wellKnownSymbol$m;

var MATCH$1 = wellKnownSymbol$8('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$o = _export;
var uncurryThis$m = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$4 = requireObjectCoercible$8;
var toString$a = toString$d;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf$2 = uncurryThis$m(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$o({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$2(
      toString$a(requireObjectCoercible$4(this)),
      toString$a(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$c = functionCall;
var defineBuiltIn$5 = defineBuiltIn$b;
var regexpExec$1 = regexpExec$2;
var fails$f = fails$A;
var wellKnownSymbol$7 = wellKnownSymbol$m;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$a;

var SPECIES$2 = wellKnownSymbol$7('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$7(KEY);

  var DELEGATES_TO_SYMBOL = !fails$f(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$f(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$c(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$c(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$5(String.prototype, KEY, methods[0]);
    defineBuiltIn$5(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$1(RegExpPrototype$2[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call$b = functionCall;
var anObject$b = anObject$p;
var isCallable$8 = isCallable$p;
var classof$7 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$6 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$8(exec)) {
    var result = call$b(exec, R, S);
    if (result !== null) anObject$b(result);
    return result;
  }
  if (classof$7(R) === 'RegExp') return call$b(regexpExec, R, S);
  throw new $TypeError$6('RegExp#exec called on incompatible receiver');
};

var call$a = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$a = anObject$p;
var isObject$8 = isObject$l;
var requireObjectCoercible$3 = requireObjectCoercible$8;
var sameValue = sameValue$1;
var toString$9 = toString$d;
var getMethod$1 = getMethod$6;
var regExpExec$1 = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$3(this);
      var searcher = isObject$8(regexp) ? getMethod$1(regexp, SEARCH) : undefined;
      return searcher ? call$a(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$9(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$a(this);
      var S = toString$9(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec$1(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var $$n = _export;
var uncurryThis$l = functionUncurryThis;
var toAbsoluteIndex = toAbsoluteIndex$2;

var $RangeError$2 = RangeError;
var fromCharCode$1 = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join$1 = uncurryThis$l([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$$n({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError$2(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode$1(code)
        : fromCharCode$1(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join$1(elements, '');
  }
});

var globalThis$7 = globalThis_1;
var DESCRIPTORS$8 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS$8) return globalThis$7[name];
  var descriptor = getOwnPropertyDescriptor(globalThis$7, name);
  return descriptor && descriptor.value;
};

var fails$e = fails$A;
var wellKnownSymbol$6 = wellKnownSymbol$m;
var DESCRIPTORS$7 = descriptors;
var IS_PURE = isPure;

var ITERATOR$2 = wellKnownSymbol$6('iterator');

var urlConstructorDetection = !fails$e(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'https://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS$7))
    || !params.sort
    || url.href !== 'https://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$2]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('https://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('https://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('https://x', undefined).host !== 'x';
});

var $TypeError$5 = TypeError;

var validateArgumentsLength$3 = function (passed, required) {
  if (passed < required) throw new $TypeError$5('Not enough arguments');
  return passed;
};

var uncurryThis$k = functionUncurryThis;

var arraySlice$3 = uncurryThis$k([].slice);

var arraySlice$2 = arraySlice$3;

var floor$1 = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor$1(length / 2);
    var left = sort(arraySlice$2(array, 0, middle), comparefn);
    var right = sort(arraySlice$2(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort$1 = sort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`


var $$m = _export;
var globalThis$6 = globalThis_1;
var safeGetBuiltIn = safeGetBuiltIn$1;
var getBuiltIn$4 = getBuiltIn$9;
var call$9 = functionCall;
var uncurryThis$j = functionUncurryThis;
var DESCRIPTORS$6 = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var defineBuiltIn$4 = defineBuiltIn$b;
var defineBuiltInAccessor$5 = defineBuiltInAccessor$7;
var defineBuiltIns$2 = defineBuiltIns$4;
var setToStringTag$1 = setToStringTag$5;
var createIteratorConstructor = iteratorCreateConstructor;
var InternalStateModule$1 = internalState;
var anInstance$2 = anInstance$4;
var isCallable$7 = isCallable$p;
var hasOwn$4 = hasOwnProperty_1;
var bind$1 = functionBindContext;
var classof$6 = classof$c;
var anObject$9 = anObject$p;
var isObject$7 = isObject$l;
var $toString = toString$d;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$6;
var getIterator = getIterator$2;
var getIteratorMethod = getIteratorMethod$3;
var createIterResultObject = createIterResultObject$3;
var validateArgumentsLength$2 = validateArgumentsLength$3;
var wellKnownSymbol$5 = wellKnownSymbol$m;
var arraySort = arraySort$1;

var ITERATOR$1 = wellKnownSymbol$5('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalParamsState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var TypeError$1 = globalThis$6.TypeError;
var encodeURIComponent = globalThis$6.encodeURIComponent;
var fromCharCode = String.fromCharCode;
var fromCodePoint = getBuiltIn$4('String', 'fromCodePoint');
var $parseInt = parseInt;
var charAt$6 = uncurryThis$j(''.charAt);
var join = uncurryThis$j([].join);
var push$4 = uncurryThis$j([].push);
var replace$4 = uncurryThis$j(''.replace);
var shift = uncurryThis$j([].shift);
var splice$1 = uncurryThis$j([].splice);
var split = uncurryThis$j(''.split);
var stringSlice$5 = uncurryThis$j(''.slice);
var exec$3 = uncurryThis$j(/./.exec);

var plus = /\+/g;
var FALLBACK_REPLACER = '\uFFFD';
var VALID_HEX = /^[0-9a-f]+$/i;

var parseHexOctet = function (string, start) {
  var substr = stringSlice$5(string, start, start + 2);
  if (!exec$3(VALID_HEX, substr)) return NaN;

  return $parseInt(substr, 16);
};

var getLeadingOnes = function (octet) {
  var count = 0;
  for (var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1) {
    count++;
  }
  return count;
};

var utf8Decode = function (octets) {
  var codePoint = null;

  switch (octets.length) {
    case 1:
      codePoint = octets[0];
      break;
    case 2:
      codePoint = (octets[0] & 0x1F) << 6 | (octets[1] & 0x3F);
      break;
    case 3:
      codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | (octets[2] & 0x3F);
      break;
    case 4:
      codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | (octets[3] & 0x3F);
      break;
  }

  return codePoint > 0x10FFFF ? null : codePoint;
};

var decode = function (input) {
  input = replace$4(input, plus, ' ');
  var length = input.length;
  var result = '';
  var i = 0;

  while (i < length) {
    var decodedChar = charAt$6(input, i);

    if (decodedChar === '%') {
      if (charAt$6(input, i + 1) === '%' || i + 3 > length) {
        result += '%';
        i++;
        continue;
      }

      var octet = parseHexOctet(input, i + 1);

      // eslint-disable-next-line no-self-compare -- NaN check
      if (octet !== octet) {
        result += decodedChar;
        i++;
        continue;
      }

      i += 2;
      var byteSequenceLength = getLeadingOnes(octet);

      if (byteSequenceLength === 0) {
        decodedChar = fromCharCode(octet);
      } else {
        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
          result += FALLBACK_REPLACER;
          i++;
          continue;
        }

        var octets = [octet];
        var sequenceIndex = 1;

        while (sequenceIndex < byteSequenceLength) {
          i++;
          if (i + 3 > length || charAt$6(input, i) !== '%') break;

          var nextByte = parseHexOctet(input, i + 1);

          // eslint-disable-next-line no-self-compare -- NaN check
          if (nextByte !== nextByte) {
            i += 3;
            break;
          }
          if (nextByte > 191 || nextByte < 128) break;

          push$4(octets, nextByte);
          i += 2;
          sequenceIndex++;
        }

        if (octets.length !== byteSequenceLength) {
          result += FALLBACK_REPLACER;
          continue;
        }

        var codePoint = utf8Decode(octets);
        if (codePoint === null) {
          result += FALLBACK_REPLACER;
        } else {
          decodedChar = fromCodePoint(codePoint);
        }
      }
    }

    result += decodedChar;
    i++;
  }

  return result;
};

var find$1 = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$4(encodeURIComponent(it), find$1, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$7(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$6(init, 0) === '?' ? stringSlice$5(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$9(next, iterator)).done) {
        entryIterator = getIterator(anObject$9(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$9(entryNext, entryIterator)).done ||
          (second = call$9(entryNext, entryIterator)).done ||
          !call$9(entryNext, entryIterator).done
        ) throw new TypeError$1('Expected sequence with length 2');
        push$4(entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn$4(object, key)) {
      push$4(entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push$4(entries, {
            key: decode(shift(entry)),
            value: decode(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$4(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$2(this, URLSearchParamsPrototype$3);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$1(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS$6) this.size = state.entries.length;
};

var URLSearchParamsPrototype$3 = URLSearchParamsConstructor.prototype;

defineBuiltIns$2(URLSearchParamsPrototype$3, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$2(arguments.length, 2);
    push$4(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS$6) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength$2(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice$1(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS$6) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$2(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$2(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$4(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength$2(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$2(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice$1(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$4(entries, { key: key, value: val });
    if (!DESCRIPTORS$6) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$1(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$4(URLSearchParamsPrototype$3, ITERATOR$1, URLSearchParamsPrototype$3.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$4(URLSearchParamsPrototype$3, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS$6) defineBuiltInAccessor$5(URLSearchParamsPrototype$3, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$m({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable$7(Headers)) {
  var headersHas = uncurryThis$j(HeadersPrototype.has);
  var headersSet = uncurryThis$j(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$7(init)) {
      var body = init.body;
      var headers;
      if (classof$6(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create$1(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable$7(nativeFetch)) {
    $$m({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable$7(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$2(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$m({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var defineBuiltIn$3 = defineBuiltIn$b;
var uncurryThis$i = functionUncurryThis;
var toString$8 = toString$d;
var validateArgumentsLength$1 = validateArgumentsLength$3;

var $URLSearchParams$1 = URLSearchParams;
var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
var append = uncurryThis$i(URLSearchParamsPrototype$2.append);
var $delete = uncurryThis$i(URLSearchParamsPrototype$2['delete']);
var forEach$2 = uncurryThis$i(URLSearchParamsPrototype$2.forEach);
var push$3 = uncurryThis$i([].push);
var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');

params$1['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params$1['delete']('b', undefined);

if (params$1 + '' !== 'a=2') {
  defineBuiltIn$3(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach$2(this, function (v, k) { // also validates `this`
      push$3(entries, { key: k, value: v });
    });
    validateArgumentsLength$1(length, 1);
    var key = toString$8(name);
    var value = toString$8($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}

var defineBuiltIn$2 = defineBuiltIn$b;
var uncurryThis$h = functionUncurryThis;
var toString$7 = toString$d;
var validateArgumentsLength = validateArgumentsLength$3;

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
var getAll = uncurryThis$h(URLSearchParamsPrototype$1.getAll);
var $has = uncurryThis$h(URLSearchParamsPrototype$1.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn$2(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString$7($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}

var DESCRIPTORS$5 = descriptors;
var uncurryThis$g = functionUncurryThis;
var defineBuiltInAccessor$4 = defineBuiltInAccessor$7;

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach$1 = uncurryThis$g(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS$5 && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor$4(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach$1(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}

const BFF_BASE_URL = coreUtils.isHostGI() ? 'https://forex-gw.goibibo.com/bff' : 'https://forex-gw.makemytrip.com/bff';
// export const BFF_BASE_URL = isHostMMT()
//   ? 'http://localhost:3333/bff'
//   : 'http://localhost:3333/bff';
var LOCATION_DETECTION_SOURCE;
(function (LOCATION_DETECTION_SOURCE) {
  LOCATION_DETECTION_SOURCE["COORDINATES"] = "LATLNG";
  LOCATION_DETECTION_SOURCE["PINCODE"] = "PINCODE";
  LOCATION_DETECTION_SOURCE["CITY_FALLBACK"] = "CITY_FALLBACK";
})(LOCATION_DETECTION_SOURCE || (LOCATION_DETECTION_SOURCE = {}));
const HEADERS = {
  REQUEST_ID: 'request-id'
};
const SESSION_STORAGE_KEYS_OPTIONS = {
  ESSENTIAL: true};

/**
 * Retrieves the user's location from the query parameters in the URL.
 *
 * This function parses the URL's query string to extract the value associated with the `USER_LOCATION` key.
 * If the `USER_LOCATION` parameter is found, it decodes and parses the JSON string to return the user's location object.
 * If the parameter is not found, it returns `null`.
 *
 * @returns {object | null} The user's location object if present, otherwise `null`.
 */
function getUserLocationFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const userLocation = urlParams.get(coreUtils.QUERY_PARAM_KEYS.USER_LOCATION);
  if (userLocation) {
    return JSON.parse(decodeURIComponent(userLocation));
  }
  return null;
}
function setUserLocationFromQueryParamsInSessionStorage() {
  const userLocation = getUserLocationFromQueryParams();
  if (userLocation) {
    coreUtils.setSessionStorageItem(coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY, userLocation, true, coreUtils.setSessionPiiDataOpts);
  }
}
/**
 * Redirects to a URL with optional query parameters
 * @param url - The base URL to redirect to
 * @param queryParams - Optional object containing query parameters to append
 */
const redirectTo = (url, queryParams) => {
  if (!queryParams || Object.keys(queryParams).length === 0) {
    window.location.href = url;
    return;
  }
  // Filter out empty values
  const filteredParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value]) => value));
  if (Object.keys(filteredParams).length === 0) {
    window.location.href = url;
    return;
  }
  // Create search params string
  const searchParams = new URLSearchParams(filteredParams).toString();
  // Determine separator based on whether URL already has query params
  const separator = url.includes('?') ? '&' : '?';
  // Combine URL + separator + new params
  window.location.href = `${url}${separator}${searchParams}`;
};
const redirectWithDeferredTime = (redirectTo, redirectionDeferTime) => {
  if (redirectionDeferTime) {
    const timerId = setTimeout(() => {
      redirectTo();
      clearTimeout(timerId);
    }, redirectionDeferTime);
  } else {
    redirectTo();
  }
};
const getMinOrderInfo = (productType, apiData, selectedCurrencyCode) => {
  let productItemsInfo;
  if (productType === commonUi.PRODUCT_TYPE.CARD) {
    productItemsInfo = apiData === null || apiData === void 0 ? void 0 : apiData.cardMinQtyConfig;
  } else if (productType === commonUi.PRODUCT_TYPE.CURRENCY) {
    productItemsInfo = apiData === null || apiData === void 0 ? void 0 : apiData.currencyMinQuantity;
  } else {
    productItemsInfo = apiData === null || apiData === void 0 ? void 0 : apiData.currencyMinQuantity;
  }
  const productItemInfo = productItemsInfo === null || productItemsInfo === void 0 ? void 0 : productItemsInfo[selectedCurrencyCode];
  return productItemInfo;
};
const getMaxAmountErrorMessage = (productType, apiData) => {
  var _a, _b, _c, _d;
  if (productType === commonUi.PRODUCT_TYPE.CARD) {
    return (_b = (_a = apiData === null || apiData === void 0 ? void 0 : apiData.errorMessages) === null || _a === void 0 ? void 0 : _a[productType]) === null || _b === void 0 ? void 0 : _b.maxAmountError;
  } else {
    return (_d = (_c = apiData === null || apiData === void 0 ? void 0 : apiData.errorMessages) === null || _c === void 0 ? void 0 : _c[commonUi.PRODUCT_TYPE.CURRENCY]) === null || _d === void 0 ? void 0 : _d.maxAmountError;
  }
};
const storeSearchContextToSessionStorage = searchContext => {
  coreUtils.setSessionStorageItem(commonUi.SESSION_STORAGE_KEYS.FUNNEL_FORM_DATA, Object.assign({}, searchContext), SESSION_STORAGE_KEYS_OPTIONS.ESSENTIAL,
  // isEssential
  {
    shouldStringifyJson: true
  });
};

const CcComparisonBottomSheet = ({
  onModalClose,
  data,
  onCtaClick,
  modalWidth
}) => {
  var _a, _b, _c, _d;
  const device = commonUi.useDevice();
  const theme = React.useContext(styled.ThemeContext);
  const currencyRef = React.useRef([]);
  const creditRef = React.useRef([]);
  const [maxHeights, setMaxHeights] = React.useState([]);
  React.useEffect(() => {
    var _a;
    pdtUtils.trackEvent({
      eventData: (_a = data === null || data === void 0 ? void 0 : data.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
  }, []);
  React.useEffect(() => {
    var _a, _b, _c, _d;
    if (!data) return;
    const rowCount = Math.max(((_b = (_a = data.currencyCard) === null || _a === void 0 ? void 0 : _a.featureList) === null || _b === void 0 ? void 0 : _b.length) || 0, ((_d = (_c = data.creditCard) === null || _c === void 0 ? void 0 : _c.featureList) === null || _d === void 0 ? void 0 : _d.length) || 0);
    const heights = Array.from({
      length: rowCount
    }, (_, i) => {
      var _a, _b;
      const currencyHeight = ((_a = currencyRef.current[i]) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
      const creditHeight = ((_b = creditRef.current[i]) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
      return Math.max(currencyHeight, creditHeight);
    });
    setMaxHeights(heights);
  }, [data]);
  /*Start: Event Handlers */
  const buyCardCtaHandler = () => {
    var _a, _b, _c;
    pdtUtils.trackEvent({
      eventData: (_b = (_a = data === null || data === void 0 ? void 0 : data.cta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
    redirectTo(((_c = data === null || data === void 0 ? void 0 : data.cta) === null || _c === void 0 ? void 0 : _c.deeplink) || '');
    onCtaClick === null || onCtaClick === void 0 ? void 0 : onCtaClick(data === null || data === void 0 ? void 0 : data.cta);
  };
  /*End: Event Handlers */
  return jsxRuntime.jsxs(designSystem.Modal, {
    modalType: device === commonUi.DEVICE.DESKTOP ? 'centered' : 'bottomSheet',
    onModalClose: onModalClose,
    heading: data === null || data === void 0 ? void 0 : data.title,
    modalMaxHeight: 'calc(100vh - 200px)',
    modalWidth: modalWidth,
    children: [jsxRuntime.jsx(BannerComponent, {
      banner: data === null || data === void 0 ? void 0 : data.banner
    }), jsxRuntime.jsxs(ComparisonSection, {
      children: [jsxRuntime.jsx(CardComponent, {
        data: data === null || data === void 0 ? void 0 : data.currencyCard,
        conversionBoxTheme: {
          textColor: theme.colors.highEmphasis,
          subtextColor: theme.colors.positive,
          markupColor: theme.colors.positive,
          borderColor: theme.colors.positive,
          bgColor: 'radial-gradient(75.36% 140.35% at 100% 0%, #CEF1EB 0.01%, #FFFFFF 100%)',
          bulletColor: theme.colors.positive
        },
        refs: currencyRef,
        maxHeights: maxHeights
      }), jsxRuntime.jsxs(CardSeparator, {
        children: [jsxRuntime.jsx(CardSeparatorLine, {}), jsxRuntime.jsx(CardSeparatorCircle, {
          children: jsxRuntime.jsx(designSystem.Image, {
            src: (_b = (_a = data === null || data === void 0 ? void 0 : data.comparison) === null || _a === void 0 ? void 0 : _a.imageUrl) === null || _b === void 0 ? void 0 : _b.url
          })
        })]
      }), jsxRuntime.jsx(CardComponent, {
        data: data === null || data === void 0 ? void 0 : data.creditCard,
        conversionBoxTheme: {
          textColor: theme.colors.mediumEmphasis,
          subtextColor: theme.colors.lowEmphasis,
          markupColor: theme.colors.error,
          borderColor: theme.colors.cardBorder,
          bgColor: theme.colors.screenBg,
          bulletColor: theme.colors.error
        },
        refs: creditRef,
        maxHeights: maxHeights
      })]
    }), jsxRuntime.jsx(designSystem.Button, {
      id: (_c = data === null || data === void 0 ? void 0 : data.cta) === null || _c === void 0 ? void 0 : _c.id,
      label: (_d = data === null || data === void 0 ? void 0 : data.cta) === null || _d === void 0 ? void 0 : _d.text,
      onClick: buyCardCtaHandler,
      margin: "24px 0 0"
    })]
  });
};

var $$l = _export;
var DESCRIPTORS$4 = descriptors;
var globalThis$5 = globalThis_1;
var uncurryThis$f = functionUncurryThis;
var hasOwn$3 = hasOwnProperty_1;
var isCallable$6 = isCallable$p;
var isPrototypeOf$1 = objectIsPrototypeOf;
var toString$6 = toString$d;
var defineBuiltInAccessor$3 = defineBuiltInAccessor$7;
var copyConstructorProperties = copyConstructorProperties$3;

var NativeSymbol = globalThis$5.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$4 && isCallable$6(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$6(arguments[0]);
    var result = isPrototypeOf$1(SymbolPrototype, this)
      // eslint-disable-next-line sonarjs/inconsistent-function-call -- ok
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL$1 = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$f(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$f(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$3 = uncurryThis$f(''.replace);
  var stringSlice$4 = uncurryThis$f(''.slice);

  defineBuiltInAccessor$3(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$3(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL$1 ? stringSlice$4(string, 7, -1) : replace$3(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$l({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const TextFieldContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__TextFieldContainer",
  componentId: "sc-1xeelgx-1"
})(["column-gap:12px;display:flex;margin-top:12px;"]);
const FloatingPincodeTextField = /*#__PURE__*/styled__default.default(designSystem.FloatingTextField).withConfig({
  displayName: "PincodeBottomSheetstyles__FloatingPincodeTextField",
  componentId: "sc-1xeelgx-2"
})(["& input{width:158px;@media ", "{width:221px;}}"], commonUi.deviceType.desktop);
const DetectLocationButton = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "PincodeBottomSheetstyles__DetectLocationButton",
  componentId: "sc-1xeelgx-3"
})(["align-items:center;width:unset;padding:4px 12px;@media ", "{padding:12px 0px 12px 12px;}"], commonUi.deviceType.desktop);
const CityListContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__CityListContainer",
  componentId: "sc-1xeelgx-4"
})(["overflow:auto;margin-top:10px;max-height:256px;"]);
const ListItem$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__ListItem",
  componentId: "sc-1xeelgx-5"
})(["border-bottom:", ";display:flex;padding:15px 8px;justify-content:space-between;@media ", "{border-bottom:none;transition:background-color 0.3s ease;&:hover{background-color:", ";border-radius:", ";}}"], ({
  isLast,
  theme
}) => isLast ? 'none' : `1px solid ${theme.colors.borderBottomGreyColor}`, commonUi.deviceType.desktop, ({
  theme
}) => theme.colors.bodyBg, ({
  theme
}) => theme.borderRadius.br2);
const CitySelectionContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__CitySelectionContainer",
  componentId: "sc-1xeelgx-6"
})(["display:flex;"]);
const ShowMoreButton = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "PincodeBottomSheetstyles__ShowMoreButton",
  componentId: "sc-1xeelgx-7"
})(["padding:0;width:unset;margin-top:16px;"]);
const ErrorSnackBarCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__ErrorSnackBarCont",
  componentId: "sc-1xeelgx-8"
})(["padding:12px 16px;display:flex;justify-content:space-between;column-gap:16px;background-color:", ";border-radius:", ";margin-top:12px;@media ", "{background-color:", ";padding:30px 54px 44px;}"], ({
  theme
}) => theme.colors.errorSnackBg, ({
  theme
}) => theme.borderRadius.br6, commonUi.deviceType.desktop, ({
  theme
}) => theme.colors.white);
const ConfirmSnackButton = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "PincodeBottomSheetstyles__ConfirmSnackButton",
  componentId: "sc-1xeelgx-9"
})(["padding:0;width:unset;& ", "{color:", ";}"], designSystem.LabelWrapper, ({
  theme
}) => theme.colors.mediumEmphasis);
const SpinnerContainer$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__SpinnerContainer",
  componentId: "sc-1xeelgx-10"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;width:100%;padding:20px 60px 102px;@media ", "{flex-direction:row;padding:30px 60px 34px;}"], commonUi.deviceType.desktop);
const PincodeFormCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__PincodeFormCont",
  componentId: "sc-1xeelgx-11"
})(["@media ", "{box-shadow:0px 2px 3px 0px #0000001a;padding:12px 16px;}"], commonUi.deviceType.desktop);
const CityListCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__CityListCont",
  componentId: "sc-1xeelgx-12"
})(["@media ", "{padding:", ";}"], commonUi.deviceType.desktop, ({
  citiesLength
}) => citiesLength === 0 ? '34px 54px 44px' : '0px 16px 28px 16px');
const PincodePopupCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PincodeBottomSheetstyles__PincodePopupCont",
  componentId: "sc-1xeelgx-13"
})(["background:", ";width:393px;box-shadow:0px 1px 5px #00000033;border-radius:4px;"], ({
  theme
}) => theme.colors.white);

const PincodeForm = ({
  inputPlaceholder,
  errorStateText,
  cta,
  onPincodeChange,
  onDetectLocationClick,
  pincodeValue
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  const inputRef = React.useRef(null);
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return jsxRuntime.jsxs(PincodeFormCont, {
    children: [jsxRuntime.jsxs(TextFieldContainer, {
      children: [jsxRuntime.jsx(FloatingPincodeTextField, {
        ref: inputRef,
        labelTxt: inputPlaceholder,
        errorState: !!errorStateText,
        inputMode: "numeric",
        onChange: onPincodeChange,
        value: pincodeValue
      }), jsxRuntime.jsx(DetectLocationButton, {
        label: cta === null || cta === void 0 ? void 0 : cta.text,
        variant: "text",
        startIcon: (_a = cta === null || cta === void 0 ? void 0 : cta.icon) === null || _a === void 0 ? void 0 : _a.url,
        id: cta === null || cta === void 0 ? void 0 : cta.id,
        leftImageWidth: "16px",
        typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
        onClick: onDetectLocationClick
      })]
    }), errorStateText && jsxRuntime.jsx(designSystem.FormattedText, {
      text: errorStateText,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.error,
      margin: "4px 0px 0px"
    })]
  });
};

const ErrorSnackBar = ({
  text
}) => {
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  return jsxRuntime.jsxs(ErrorSnackBarCont, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: text,
      typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.baseW1 : designTokens.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.error
    }), device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(ConfirmSnackButton, {
      label: "OKAY",
      variant: "text",
      typography: designTokens.TYPOGRAPHY_KEYS.baseW3
    })]
  });
};

const CitySelectionList = ({
  title,
  subTitle,
  cities,
  selectedCity,
  showAllCities,
  toggleCityDisplay,
  onCityOptionClick
}) => {
  const device = commonUi.useDevice();
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsx(CityListCont, {
    citiesLength: cities === null || cities === void 0 ? void 0 : cities.length,
    children: cities && (cities === null || cities === void 0 ? void 0 : cities.length) ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [jsxRuntime.jsxs("div", {
        style: {
          padding: '0 8px'
        },
        children: [jsxRuntime.jsx(designSystem.FormattedText, {
          text: title,
          typography: designTokens.TYPOGRAPHY_KEYS.smallW3,
          color: theme.colors.highEmphasis,
          margin: "32px 0px 0px"
        }), jsxRuntime.jsx(designSystem.FormattedText, {
          text: subTitle,
          typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
          color: theme.colors.mediumEmphasis,
          margin: "2px 0px 0px"
        })]
      }), jsxRuntime.jsx(CityListContainer, {
        children: cities === null || cities === void 0 ? void 0 : cities.map((city, index) => jsxRuntime.jsxs(ListItem$1, {
          isLast: index === cities.length - 1,
          onClick: () => onCityOptionClick === null || onCityOptionClick === void 0 ? void 0 : onCityOptionClick(city),
          children: [jsxRuntime.jsxs(CitySelectionContainer, {
            children: [device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(designSystem.RadioButton, {
              id: city.cityCode,
              showLabel: false,
              isChecked: selectedCity === city.cityCode
            }), jsxRuntime.jsx(designSystem.FormattedText, {
              text: city === null || city === void 0 ? void 0 : city.name,
              typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.smallW1 : designTokens.TYPOGRAPHY_KEYS.smallW1,
              color: device === commonUi.DEVICE.MOBILE ? theme.colors.mediumEmphasis : theme.colors.highEmphasis
            })]
          }), (city === null || city === void 0 ? void 0 : city.text) && jsxRuntime.jsx(designSystem.FormattedText, {
            text: city === null || city === void 0 ? void 0 : city.text,
            typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
            color: theme.colors.positive
          })]
        }, city === null || city === void 0 ? void 0 : city.cityCode))
      }), jsxRuntime.jsx("div", {
        style: {
          padding: '0 8px'
        },
        children: jsxRuntime.jsx(ShowMoreButton, {
          typography: designTokens.TYPOGRAPHY_KEYS.mediumW2,
          onClick: toggleCityDisplay,
          label: showAllCities ? 'Show Less Cities' : 'Show More Cities',
          variant: "text"
        })
      })]
    }) : null
  });
};

const SpinnerLoader = ({
  spinnerColor,
  text
}) => {
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  return jsxRuntime.jsxs(SpinnerContainer$1, {
    children: [jsxRuntime.jsx(designSystem.Spinner, {
      spinnerWidth: device === commonUi.DEVICE.MOBILE ? 32 : 24,
      thickness: 3,
      spinnerColor: spinnerColor
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: text,
      typography: designTokens.TYPOGRAPHY_KEYS.mediumW1,
      color: theme.colors.mediumEmphasis,
      margin: device === commonUi.DEVICE.MOBILE ? '12px 0px 0px' : '0px 0px 0px 8px'
    })]
  });
};

const PincodeContent = ({
  bottomSheetData,
  errorStateText,
  errorSnackBarText,
  cities,
  onPincodeChange,
  onDetectLocationClick,
  selectedCity,
  onCityOptionClick,
  pincodeValue,
  isLoading,
  requestId
}) => {
  var _a, _b;
  const {
    subtitle,
    inputPlaceholder,
    cta,
    cityFallback
  } = bottomSheetData !== null && bottomSheetData !== void 0 ? bottomSheetData : {};
  const [showAllCities, setShowAllCities] = React.useState(false);
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  const citiesToDisplay = showAllCities ? cities : cities === null || cities === void 0 ? void 0 : cities.slice(0, cityFallback === null || cityFallback === void 0 ? void 0 : cityFallback.showCities);
  React.useEffect(() => {
    var _a, _b;
    if (((_a = cityFallback === null || cityFallback === void 0 ? void 0 : cityFallback.analytics) === null || _a === void 0 ? void 0 : _a.pdtData) && (citiesToDisplay === null || citiesToDisplay === void 0 ? void 0 : citiesToDisplay.length) && (citiesToDisplay === null || citiesToDisplay === void 0 ? void 0 : citiesToDisplay.length) > 0) {
      pdtUtils.trackEvent({
        eventData: (_b = cityFallback === null || cityFallback === void 0 ? void 0 : cityFallback.analytics) === null || _b === void 0 ? void 0 : _b.pdtData,
        requestId: requestId
      });
    }
  }, [citiesToDisplay, cityFallback, requestId]);
  const handleCityToggle = () => setShowAllCities(prev => !prev);
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(designSystem.FormattedText, {
      text: subtitle,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.highEmphasis,
      margin: "12px 0px 0px"
    }), jsxRuntime.jsx(PincodeForm, {
      inputPlaceholder: inputPlaceholder,
      errorStateText: errorStateText,
      cta: cta,
      onPincodeChange: onPincodeChange,
      onDetectLocationClick: onDetectLocationClick,
      pincodeValue: pincodeValue
    }), isLoading && device === commonUi.DEVICE.DESKTOP ? jsxRuntime.jsx(SpinnerLoader, {
      text: (_a = bottomSheetData === null || bottomSheetData === void 0 ? void 0 : bottomSheetData.loader) === null || _a === void 0 ? void 0 : _a.description,
      spinnerColor: (_b = bottomSheetData === null || bottomSheetData === void 0 ? void 0 : bottomSheetData.loader) === null || _b === void 0 ? void 0 : _b.loaderColor
    }) : errorSnackBarText ? jsxRuntime.jsx(ErrorSnackBar, {
      text: errorSnackBarText
    }) : jsxRuntime.jsx(CitySelectionList, {
      title: cityFallback === null || cityFallback === void 0 ? void 0 : cityFallback.title,
      subTitle: cityFallback === null || cityFallback === void 0 ? void 0 : cityFallback.subTitle,
      cities: citiesToDisplay,
      selectedCity: selectedCity,
      showAllCities: showAllCities,
      toggleCityDisplay: handleCityToggle,
      onCityOptionClick: onCityOptionClick
    })]
  });
};

var withSelector = {exports: {}};

var useSyncExternalStoreWithSelector_production = {};

/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreWithSelector_production;

function requireUseSyncExternalStoreWithSelector_production () {
	if (hasRequiredUseSyncExternalStoreWithSelector_production) return useSyncExternalStoreWithSelector_production;
	hasRequiredUseSyncExternalStoreWithSelector_production = 1;
	var React = React__namespace.default;
	function is(x, y) {
	  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
	}
	var objectIs = "function" === typeof Object.is ? Object.is : is,
	  useSyncExternalStore = React.useSyncExternalStore,
	  useRef = React.useRef,
	  useEffect = React.useEffect,
	  useMemo = React.useMemo,
	  useDebugValue = React.useDebugValue;
	useSyncExternalStoreWithSelector_production.useSyncExternalStoreWithSelector = function (
	  subscribe,
	  getSnapshot,
	  getServerSnapshot,
	  selector,
	  isEqual
	) {
	  var instRef = useRef(null);
	  if (null === instRef.current) {
	    var inst = { hasValue: false, value: null };
	    instRef.current = inst;
	  } else inst = instRef.current;
	  instRef = useMemo(
	    function () {
	      function memoizedSelector(nextSnapshot) {
	        if (!hasMemo) {
	          hasMemo = true;
	          memoizedSnapshot = nextSnapshot;
	          nextSnapshot = selector(nextSnapshot);
	          if (void 0 !== isEqual && inst.hasValue) {
	            var currentSelection = inst.value;
	            if (isEqual(currentSelection, nextSnapshot))
	              return (memoizedSelection = currentSelection);
	          }
	          return (memoizedSelection = nextSnapshot);
	        }
	        currentSelection = memoizedSelection;
	        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
	        var nextSelection = selector(nextSnapshot);
	        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
	          return (memoizedSnapshot = nextSnapshot), currentSelection;
	        memoizedSnapshot = nextSnapshot;
	        return (memoizedSelection = nextSelection);
	      }
	      var hasMemo = false,
	        memoizedSnapshot,
	        memoizedSelection,
	        maybeGetServerSnapshot =
	          void 0 === getServerSnapshot ? null : getServerSnapshot;
	      return [
	        function () {
	          return memoizedSelector(getSnapshot());
	        },
	        null === maybeGetServerSnapshot
	          ? void 0
	          : function () {
	              return memoizedSelector(maybeGetServerSnapshot());
	            }
	      ];
	    },
	    [getSnapshot, getServerSnapshot, selector, isEqual]
	  );
	  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
	  useEffect(
	    function () {
	      inst.hasValue = true;
	      inst.value = value;
	    },
	    [value]
	  );
	  useDebugValue(value);
	  return value;
	};
	return useSyncExternalStoreWithSelector_production;
}

var useSyncExternalStoreWithSelector_development = {};

/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreWithSelector_development;

function requireUseSyncExternalStoreWithSelector_development () {
	if (hasRequiredUseSyncExternalStoreWithSelector_development) return useSyncExternalStoreWithSelector_development;
	hasRequiredUseSyncExternalStoreWithSelector_development = 1;
	 false &&
	  0;
	return useSyncExternalStoreWithSelector_development;
}

if (true) {
  withSelector.exports = requireUseSyncExternalStoreWithSelector_production();
} else {}

var withSelectorExports = withSelector.exports;

// src/utils/react.ts

// src/utils/batch.ts
function defaultNoopBatch(callback) {
  callback();
}

// src/utils/Subscription.ts
function createListenerCollection() {
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },
    notify() {
      defaultNoopBatch(() => {
        let listener = first;
        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get() {
      const listeners = [];
      let listener = first;
      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }
      return listeners;
    },
    subscribe(callback) {
      let isSubscribed = true;
      const listener = last = {
        callback,
        next: null,
        prev: last
      };
      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }
      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;
        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }
        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}
var nullListeners = {
  notify() {
  },
  get: () => []
};
function createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners;
  let subscriptionsAmount = 0;
  let selfSubscribed = false;
  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener);
    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }
  function notifyNestedSubs() {
    listeners.notify();
  }
  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }
  function isSubscribed() {
    return selfSubscribed;
  }
  function trySubscribe() {
    subscriptionsAmount++;
    if (!unsubscribe) {
      unsubscribe = store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }
  function tryUnsubscribe() {
    subscriptionsAmount--;
    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = void 0;
      listeners.clear();
      listeners = nullListeners;
    }
  }
  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }
  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }
  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}

// src/utils/useIsomorphicLayoutEffect.ts
var canUseDOM = () => !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM();
var isRunningInReactNative = () => typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = () => isDOM || isReactNative ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var useIsomorphicLayoutEffect = /* @__PURE__ */ getUseIsomorphicLayoutEffect();

// src/components/Context.ts
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function getContext() {
  if (!React__namespace.createContext) return {};
  const contextMap = gT[ContextKey] ??= /* @__PURE__ */ new Map();
  let realContext = contextMap.get(React__namespace.createContext);
  if (!realContext) {
    realContext = React__namespace.createContext(
      null
    );
    if (false) {}
    contextMap.set(React__namespace.createContext, realContext);
  }
  return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();

// src/components/Provider.tsx
function Provider(providerProps) {
  const { children, context, serverState, store } = providerProps;
  const contextValue = React__namespace.useMemo(() => {
    const subscription = createSubscription(store);
    const baseContextValue = {
      store,
      subscription,
      getServerState: serverState ? () => serverState : void 0
    };
    if (true) {
      return baseContextValue;
    } else {}
  }, [store, serverState]);
  const previousState = React__namespace.useMemo(() => store.getState(), [store]);
  useIsomorphicLayoutEffect(() => {
    const { subscription } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }
    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = void 0;
    };
  }, [contextValue, previousState]);
  const Context = context || ReactReduxContext;
  return /* @__PURE__ */ React__namespace.createElement(Context.Provider, { value: contextValue }, children);
}
var Provider_default = Provider;

// src/hooks/useReduxContext.ts
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext2() {
    const contextValue = React__namespace.useContext(context);
    if (false) {}
    return contextValue;
  };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();

// src/hooks/useStore.ts
function createStoreHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : (
    // @ts-ignore
    createReduxContextHook(context)
  );
  const useStore2 = () => {
    const { store } = useReduxContext2();
    return store;
  };
  Object.assign(useStore2, {
    withTypes: () => useStore2
  });
  return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();

// src/hooks/useDispatch.ts
function createDispatchHook(context = ReactReduxContext) {
  const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
  const useDispatch2 = () => {
    const store = useStore2();
    return store.dispatch;
  };
  Object.assign(useDispatch2, {
    withTypes: () => useDispatch2
  });
  return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b) => a === b;
function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
  const useSelector2 = (selector, equalityFnOrOptions = {}) => {
    const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? { equalityFn: equalityFnOrOptions } : equalityFnOrOptions;
    if (false) {}
    const reduxContext = useReduxContext2();
    const { store, subscription, getServerState } = reduxContext;
    const firstRun = React__namespace.useRef(true);
    const wrappedSelector = React__namespace.useCallback(
      {
        [selector.name](state) {
          const selected = selector(state);
          if (false) {}
          return selected;
        }
      }[selector.name],
      [selector]
    );
    const selectedState = withSelectorExports.useSyncExternalStoreWithSelector(
      subscription.addNestedSub,
      store.getState,
      getServerState || store.getState,
      wrappedSelector,
      equalityFn
    );
    React__namespace.useDebugValue(selectedState);
    return selectedState;
  };
  Object.assign(useSelector2, {
    withTypes: () => useSelector2
  });
  return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();

// Use throughout your app instead of plain `useDispatch` and `useSelector`
const useAppDispatch = () => useDispatch();
const useAppSelector = useSelector;

var getBuiltIn$3 = getBuiltIn$9;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$7;
var wellKnownSymbol$4 = wellKnownSymbol$m;
var DESCRIPTORS$3 = descriptors;

var SPECIES$1 = wellKnownSymbol$4('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$3 && Constructor && !Constructor[SPECIES$1]) {
    defineBuiltInAccessor$2(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var DESCRIPTORS$2 = descriptors;
var globalThis$4 = globalThis_1;
var uncurryThis$e = functionUncurryThis;
var isForced$1 = isForced_1;
var inheritIfRequired$1 = inheritIfRequired$3;
var createNonEnumerableProperty = createNonEnumerableProperty$a;
var create = objectCreate;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isPrototypeOf = objectIsPrototypeOf;
var isRegExp = isRegexp;
var toString$5 = toString$d;
var getRegExpFlags$1 = regexpGetFlags;
var stickyHelpers = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$2;
var defineBuiltIn$1 = defineBuiltIn$b;
var fails$d = fails$A;
var hasOwn$2 = hasOwnProperty_1;
var enforceInternalState$1 = internalState.enforce;
var setSpecies = setSpecies$1;
var wellKnownSymbol$3 = wellKnownSymbol$m;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol$3('match');
var NativeRegExp = globalThis$4.RegExp;
var RegExpPrototype$1 = NativeRegExp.prototype;
var SyntaxError = globalThis$4.SyntaxError;
var exec$2 = uncurryThis$e(RegExpPrototype$1.exec);
var charAt$5 = uncurryThis$e(''.charAt);
var replace$2 = uncurryThis$e(''.replace);
var stringIndexOf$1 = uncurryThis$e(''.indexOf);
var stringSlice$3 = uncurryThis$e(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$2 &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG || fails$d(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$5(string, index);
    if (chr === '\\') {
      result += chr + charAt$5(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = create(null);
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$5(string, index);
    if (chr === '\\') {
      chr += charAt$5(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        result += chr;
        // ignore non-capturing groups
        if (stringSlice$3(string, index + 1, index + 3) === '?:') {
          continue;
        }
        if (exec$2(IS_NCG, stringSlice$3(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn$2(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced$1('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype$1, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype$1, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags$1(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$5(pattern);
    flags = flags === undefined ? '' : toString$5(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL$1 && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$2(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace$2(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired$1(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$1, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState$1(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys$1 = getOwnPropertyNames(NativeRegExp), index = 0; keys$1.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys$1[index++]);
  }

  RegExpPrototype$1.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$1;
  defineBuiltIn$1(globalThis$4, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var DESCRIPTORS$1 = descriptors;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var classof$5 = classofRaw$2;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$7;
var getInternalState = internalState.get;

var RegExpPrototype = RegExp.prototype;
var $TypeError$4 = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS$1 && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor$1(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof$5(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw new $TypeError$4('Incompatible receiver, RegExp required');
    }
  });
}

// TODO: Remove from `core-js@4` since it's moved to entry points

var $$k = _export;
var call$8 = functionCall;
var isCallable$5 = isCallable$p;
var anObject$8 = anObject$p;
var toString$4 = toString$d;

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$$k({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject$8(this);
    var string = toString$4(S);
    var exec = R.exec;
    if (!isCallable$5(exec)) return call$8(nativeTest, R, string);
    var result = call$8(exec, R, string);
    if (result === null) return false;
    anObject$8(result);
    return true;
  }
});

class FormValidation {
  // Method to check if a value contains only digits
  static isDigitsOnly(value) {
    return /^\d*$/.test(value);
  }
  // Method to validate Indian pincode
  static validIndianPincode(value) {
    return /^\d{6}$/.test(value);
  }
  static isValidInrAmount(value) {
    return value <= 25000000;
  }
  // Method to check if input length is greater than a specified length and contains only numbers
  static isInValidPincode(value, length) {
    const regex = new RegExp(`^\\d{${length + 1},}$`);
    return regex.test(value);
  }
}

var uncurryThis$d = functionUncurryThis;
var isArray$2 = isArray$4;
var isCallable$4 = isCallable$p;
var classof$4 = classofRaw$2;
var toString$3 = toString$d;

var push$2 = uncurryThis$d([].push);

var getJsonReplacerFunction = function (replacer) {
  if (isCallable$4(replacer)) return replacer;
  if (!isArray$2(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push$2(keys, element);
    else if (typeof element == 'number' || classof$4(element) === 'Number' || classof$4(element) === 'String') push$2(keys, toString$3(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray$2(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

var $$j = _export;
var getBuiltIn$2 = getBuiltIn$9;
var apply$2 = functionApply;
var call$7 = functionCall;
var uncurryThis$c = functionUncurryThis;
var fails$c = fails$A;
var isCallable$3 = isCallable$p;
var isSymbol = isSymbol$4;
var arraySlice$1 = arraySlice$3;
var getReplacerFunction = getJsonReplacerFunction;
var NATIVE_SYMBOL = symbolConstructorDetection;

var $String = String;
var $stringify = getBuiltIn$2('JSON', 'stringify');
var exec$1 = uncurryThis$c(/./.exec);
var charAt$4 = uncurryThis$c(''.charAt);
var charCodeAt$1 = uncurryThis$c(''.charCodeAt);
var replace$1 = uncurryThis$c(''.replace);
var numberToString = uncurryThis$c(1.1.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails$c(function () {
  var symbol = getBuiltIn$2('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails$c(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice$1(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable$3($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable$3($replacer)) value = call$7($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply$2($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt$4(string, offset - 1);
  var next = charAt$4(string, offset + 1);
  if ((exec$1(low, match) && !exec$1(hi, next)) || (exec$1(hi, match) && !exec$1(low, prev))) {
    return '\\u' + numberToString(charCodeAt$1(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $$j({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice$1(arguments);
      var result = apply$2(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$1(result, tester, fixIllFormed) : result;
    }
  });
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var $$i = _export;
var toObject$4 = toObject$9;
var lengthOfArrayLike$4 = lengthOfArrayLike$8;
var toIntegerOrInfinity$5 = toIntegerOrInfinity$8;
var addToUnscopables = addToUnscopables$3;

// `Array.prototype.at` method
// https://tc39.es/ecma262/#sec-array.prototype.at
$$i({ target: 'Array', proto: true }, {
  at: function at(index) {
    var O = toObject$4(this);
    var len = lengthOfArrayLike$4(O);
    var relativeIndex = toIntegerOrInfinity$5(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : O[k];
  }
});

addToUnscopables('at');

var aCallable$6 = aCallable$d;
var toObject$3 = toObject$9;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$3 = lengthOfArrayLike$8;

var $TypeError$3 = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject$3(that);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$3(O);
    aCallable$6(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError$3(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$3(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false)};

var fails$b = fails$A;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$b(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

/* global Bun, Deno -- detection */
var globalThis$3 = globalThis_1;
var userAgent = environmentUserAgent;
var classof$3 = classofRaw$2;

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

var environment = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis$3.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis$3.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof$3(globalThis$3.process) === 'process') return 'NODE';
  if (globalThis$3.window && globalThis$3.document) return 'BROWSER';
  return 'REST';
})();

var ENVIRONMENT = environment;

var environmentIsNode = ENVIRONMENT === 'NODE';

var $$h = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = environmentV8Version;
var IS_NODE = environmentIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$5 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$h({ target: 'Array', proto: true, forced: FORCED$5 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var $$g = _export;
var call$6 = functionCall;
var iterate$8 = iterate$a;
var aCallable$5 = aCallable$d;
var anObject$7 = anObject$p;
var getIteratorDirect$5 = getIteratorDirect$8;
var iteratorClose$6 = iteratorClose$d;
var iteratorHelperWithoutClosingOnEarlyError$4 = iteratorHelperWithoutClosingOnEarlyError$7;

var forEachWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$4('forEach', TypeError);

// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
$$g({ target: 'Iterator', proto: true, real: true, forced: forEachWithoutClosingOnEarlyError }, {
  forEach: function forEach(fn) {
    anObject$7(this);
    try {
      aCallable$5(fn);
    } catch (error) {
      iteratorClose$6(this, 'throw', error);
    }

    if (forEachWithoutClosingOnEarlyError) return call$6(forEachWithoutClosingOnEarlyError, this, fn);

    var record = getIteratorDirect$5(this);
    var counter = 0;
    iterate$8(record, function (value) {
      fn(value, counter++);
    }, { IS_RECORD: true });
  }
});

var $$f = _export;
var iterate$7 = iterate$a;
var aCallable$4 = aCallable$d;
var anObject$6 = anObject$p;
var getIteratorDirect$4 = getIteratorDirect$8;
var iteratorClose$5 = iteratorClose$d;
var iteratorHelperWithoutClosingOnEarlyError$3 = iteratorHelperWithoutClosingOnEarlyError$7;
var apply$1 = functionApply;
var fails$a = fails$A;

var $TypeError$2 = TypeError;

// https://bugs.webkit.org/show_bug.cgi?id=291651
var FAILS_ON_INITIAL_UNDEFINED = fails$a(function () {
  // eslint-disable-next-line es/no-iterator-prototype-reduce, es/no-array-prototype-keys, array-callback-return -- required for testing
  [].keys().reduce(function () { /* empty */ }, undefined);
});

var reduceWithoutClosingOnEarlyError = !FAILS_ON_INITIAL_UNDEFINED && iteratorHelperWithoutClosingOnEarlyError$3('reduce', $TypeError$2);

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
$$f({ target: 'Iterator', proto: true, real: true, forced: FAILS_ON_INITIAL_UNDEFINED || reduceWithoutClosingOnEarlyError }, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject$6(this);
    try {
      aCallable$4(reducer);
    } catch (error) {
      iteratorClose$5(this, 'throw', error);
    }

    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    if (reduceWithoutClosingOnEarlyError) {
      return apply$1(reduceWithoutClosingOnEarlyError, this, noInitial ? [reducer] : [reducer, accumulator]);
    }
    var record = getIteratorDirect$4(this);
    var counter = 0;
    iterate$7(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, { IS_RECORD: true });
    if (noInitial) throw new $TypeError$2('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});

var DESCRIPTORS = descriptors;
var defineBuiltInAccessor = defineBuiltInAccessor$7;
var regExpFlagsDetection = regexpFlagsDetection;
var regExpFlagsGetterImplementation = regexpFlags$1;

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (DESCRIPTORS && !regExpFlagsDetection.correct) {
  defineBuiltInAccessor(RegExp.prototype, 'flags', {
    configurable: true,
    get: regExpFlagsGetterImplementation
  });

  regExpFlagsDetection.correct = true;
}

var uncurryThis$b = functionUncurryThis;

// eslint-disable-next-line es/no-set -- safe
var SetPrototype$1 = Set.prototype;

var setHelpers = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis$b(SetPrototype$1.add),
  has: uncurryThis$b(SetPrototype$1.has),
  remove: uncurryThis$b(SetPrototype$1['delete']),
  proto: SetPrototype$1
};

var has$5 = setHelpers.has;

// Perform ? RequireInternalSlot(M, [[SetData]])
var aSet$7 = function (it) {
  has$5(it);
  return it;
};

var call$5 = functionCall;

var iterateSimple$7 = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
  var next = record.next;
  var step, result;
  while (!(step = call$5(next, iterator)).done) {
    result = fn(step.value);
    if (result !== undefined) return result;
  }
};

var uncurryThis$a = functionUncurryThis;
var iterateSimple$6 = iterateSimple$7;
var SetHelpers$5 = setHelpers;

var Set$3 = SetHelpers$5.Set;
var SetPrototype = SetHelpers$5.proto;
var forEach = uncurryThis$a(SetPrototype.forEach);
var keys = uncurryThis$a(SetPrototype.keys);
var next = keys(new Set$3()).next;

var setIterate = function (set, fn, interruptible) {
  return interruptible ? iterateSimple$6({ iterator: keys(set), next: next }, fn) : forEach(set, fn);
};

var SetHelpers$4 = setHelpers;
var iterate$6 = setIterate;

var Set$2 = SetHelpers$4.Set;
var add$3 = SetHelpers$4.add;

var setClone = function (set) {
  var result = new Set$2();
  iterate$6(set, function (it) {
    add$3(result, it);
  });
  return result;
};

var uncurryThisAccessor = functionUncurryThisAccessor;
var SetHelpers$3 = setHelpers;

var setSize = uncurryThisAccessor(SetHelpers$3.proto, 'size', 'get') || function (set) {
  return set.size;
};

var aCallable$3 = aCallable$d;
var anObject$5 = anObject$p;
var call$4 = functionCall;
var toIntegerOrInfinity$4 = toIntegerOrInfinity$8;
var getIteratorDirect$3 = getIteratorDirect$8;

var INVALID_SIZE = 'Invalid size';
var $RangeError$1 = RangeError;
var $TypeError$1 = TypeError;
var max$1 = Math.max;

var SetRecord = function (set, intSize) {
  this.set = set;
  this.size = max$1(intSize, 0);
  this.has = aCallable$3(set.has);
  this.keys = aCallable$3(set.keys);
};

SetRecord.prototype = {
  getIterator: function () {
    return getIteratorDirect$3(anObject$5(call$4(this.keys, this.set)));
  },
  includes: function (it) {
    return call$4(this.has, this.set, it);
  }
};

// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
var getSetRecord$7 = function (obj) {
  anObject$5(obj);
  var numSize = +obj.size;
  // NOTE: If size is undefined, then numSize will be NaN
  // eslint-disable-next-line no-self-compare -- NaN check
  if (numSize !== numSize) throw new $TypeError$1(INVALID_SIZE);
  var intSize = toIntegerOrInfinity$4(numSize);
  if (intSize < 0) throw new $RangeError$1(INVALID_SIZE);
  return new SetRecord(obj, intSize);
};

var aSet$6 = aSet$7;
var SetHelpers$2 = setHelpers;
var clone$2 = setClone;
var size$4 = setSize;
var getSetRecord$6 = getSetRecord$7;
var iterateSet$2 = setIterate;
var iterateSimple$5 = iterateSimple$7;

var has$4 = SetHelpers$2.has;
var remove$1 = SetHelpers$2.remove;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
var setDifference = function difference(other) {
  var O = aSet$6(this);
  var otherRec = getSetRecord$6(other);
  var result = clone$2(O);
  if (size$4(O) <= otherRec.size) iterateSet$2(O, function (e) {
    if (otherRec.includes(e)) remove$1(result, e);
  });
  else iterateSimple$5(otherRec.getIterator(), function (e) {
    if (has$4(result, e)) remove$1(result, e);
  });
  return result;
};

var getBuiltIn$1 = getBuiltIn$9;

var createSetLike = function (size) {
  return {
    size: size,
    has: function () {
      return false;
    },
    keys: function () {
      return {
        next: function () {
          return { done: true };
        }
      };
    }
  };
};

var createSetLikeWithInfinitySize = function (size) {
  return {
    size: size,
    has: function () {
      return true;
    },
    keys: function () {
      throw new Error('e');
    }
  };
};

var setMethodAcceptSetLike$7 = function (name, callback) {
  var Set = getBuiltIn$1('Set');
  try {
    new Set()[name](createSetLike(0));
    try {
      // late spec change, early WebKit ~ Safari 17 implementation does not pass it
      // https://github.com/tc39/proposal-set-methods/pull/88
      // also covered engines with
      // https://bugs.webkit.org/show_bug.cgi?id=272679
      new Set()[name](createSetLike(-1));
      return false;
    } catch (error2) {
      if (!callback) return true;
      // early V8 implementation bug
      // https://issues.chromium.org/issues/351332634
      try {
        new Set()[name](createSetLikeWithInfinitySize(-Infinity));
        return false;
      } catch (error) {
        var set = new Set();
        set.add(1);
        set.add(2);
        return callback(set[name](createSetLikeWithInfinitySize(Infinity)));
      }
    }
  } catch (error) {
    return false;
  }
};

var $$e = _export;
var difference = setDifference;
var fails$9 = fails$A;
var setMethodAcceptSetLike$6 = setMethodAcceptSetLike$7;

var SET_LIKE_INCORRECT_BEHAVIOR = !setMethodAcceptSetLike$6('difference', function (result) {
  return result.size === 0;
});

var FORCED$4 = SET_LIKE_INCORRECT_BEHAVIOR || fails$9(function () {
  // https://bugs.webkit.org/show_bug.cgi?id=288595
  var setLike = {
    size: 1,
    has: function () { return true; },
    keys: function () {
      var index = 0;
      return {
        next: function () {
          var done = index++ > 1;
          if (baseSet.has(1)) baseSet.clear();
          return { done: done, value: 2 };
        }
      };
    }
  };
  // eslint-disable-next-line es/no-set -- testing
  var baseSet = new Set([1, 2, 3, 4]);
  // eslint-disable-next-line es/no-set-prototype-difference -- testing
  return baseSet.difference(setLike).size !== 3;
});

// `Set.prototype.difference` method
// https://tc39.es/ecma262/#sec-set.prototype.difference
$$e({ target: 'Set', proto: true, real: true, forced: FORCED$4 }, {
  difference: difference
});

var aSet$5 = aSet$7;
var SetHelpers$1 = setHelpers;
var size$3 = setSize;
var getSetRecord$5 = getSetRecord$7;
var iterateSet$1 = setIterate;
var iterateSimple$4 = iterateSimple$7;

var Set$1 = SetHelpers$1.Set;
var add$2 = SetHelpers$1.add;
var has$3 = SetHelpers$1.has;

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
var setIntersection = function intersection(other) {
  var O = aSet$5(this);
  var otherRec = getSetRecord$5(other);
  var result = new Set$1();

  if (size$3(O) > otherRec.size) {
    iterateSimple$4(otherRec.getIterator(), function (e) {
      if (has$3(O, e)) add$2(result, e);
    });
  } else {
    iterateSet$1(O, function (e) {
      if (otherRec.includes(e)) add$2(result, e);
    });
  }

  return result;
};

var $$d = _export;
var fails$8 = fails$A;
var intersection = setIntersection;
var setMethodAcceptSetLike$5 = setMethodAcceptSetLike$7;

var INCORRECT$3 = !setMethodAcceptSetLike$5('intersection', function (result) {
  return result.size === 2 && result.has(1) && result.has(2);
}) || fails$8(function () {
  // eslint-disable-next-line es/no-array-from, es/no-set, es/no-set-prototype-intersection -- testing
  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
});

// `Set.prototype.intersection` method
// https://tc39.es/ecma262/#sec-set.prototype.intersection
$$d({ target: 'Set', proto: true, real: true, forced: INCORRECT$3 }, {
  intersection: intersection
});

var aSet$4 = aSet$7;
var has$2 = setHelpers.has;
var size$2 = setSize;
var getSetRecord$4 = getSetRecord$7;
var iterateSet = setIterate;
var iterateSimple$3 = iterateSimple$7;
var iteratorClose$4 = iteratorClose$d;

// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
var setIsDisjointFrom = function isDisjointFrom(other) {
  var O = aSet$4(this);
  var otherRec = getSetRecord$4(other);
  if (size$2(O) <= otherRec.size) return iterateSet(O, function (e) {
    if (otherRec.includes(e)) return false;
  }, true) !== false;
  var iterator = otherRec.getIterator();
  return iterateSimple$3(iterator, function (e) {
    if (has$2(O, e)) return iteratorClose$4(iterator, 'normal', false);
  }) !== false;
};

var $$c = _export;
var isDisjointFrom = setIsDisjointFrom;
var setMethodAcceptSetLike$4 = setMethodAcceptSetLike$7;

var INCORRECT$2 = !setMethodAcceptSetLike$4('isDisjointFrom', function (result) {
  return !result;
});

// `Set.prototype.isDisjointFrom` method
// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
$$c({ target: 'Set', proto: true, real: true, forced: INCORRECT$2 }, {
  isDisjointFrom: isDisjointFrom
});

var aSet$3 = aSet$7;
var size$1 = setSize;
var iterate$5 = setIterate;
var getSetRecord$3 = getSetRecord$7;

// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
var setIsSubsetOf = function isSubsetOf(other) {
  var O = aSet$3(this);
  var otherRec = getSetRecord$3(other);
  if (size$1(O) > otherRec.size) return false;
  return iterate$5(O, function (e) {
    if (!otherRec.includes(e)) return false;
  }, true) !== false;
};

var $$b = _export;
var isSubsetOf = setIsSubsetOf;
var setMethodAcceptSetLike$3 = setMethodAcceptSetLike$7;

var INCORRECT$1 = !setMethodAcceptSetLike$3('isSubsetOf', function (result) {
  return result;
});

// `Set.prototype.isSubsetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
$$b({ target: 'Set', proto: true, real: true, forced: INCORRECT$1 }, {
  isSubsetOf: isSubsetOf
});

var aSet$2 = aSet$7;
var has$1 = setHelpers.has;
var size = setSize;
var getSetRecord$2 = getSetRecord$7;
var iterateSimple$2 = iterateSimple$7;
var iteratorClose$3 = iteratorClose$d;

// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
var setIsSupersetOf = function isSupersetOf(other) {
  var O = aSet$2(this);
  var otherRec = getSetRecord$2(other);
  if (size(O) < otherRec.size) return false;
  var iterator = otherRec.getIterator();
  return iterateSimple$2(iterator, function (e) {
    if (!has$1(O, e)) return iteratorClose$3(iterator, 'normal', false);
  }) !== false;
};

var $$a = _export;
var isSupersetOf = setIsSupersetOf;
var setMethodAcceptSetLike$2 = setMethodAcceptSetLike$7;

var INCORRECT = !setMethodAcceptSetLike$2('isSupersetOf', function (result) {
  return !result;
});

// `Set.prototype.isSupersetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
$$a({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  isSupersetOf: isSupersetOf
});

var aSet$1 = aSet$7;
var SetHelpers = setHelpers;
var clone$1 = setClone;
var getSetRecord$1 = getSetRecord$7;
var iterateSimple$1 = iterateSimple$7;

var add$1 = SetHelpers.add;
var has = SetHelpers.has;
var remove = SetHelpers.remove;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
var setSymmetricDifference = function symmetricDifference(other) {
  var O = aSet$1(this);
  var keysIter = getSetRecord$1(other).getIterator();
  var result = clone$1(O);
  iterateSimple$1(keysIter, function (e) {
    if (has(O, e)) remove(result, e);
    else add$1(result, e);
  });
  return result;
};

// Should get iterator record of a set-like object before cloning this
// https://bugs.webkit.org/show_bug.cgi?id=289430
var setMethodGetKeysBeforeCloningDetection = function (METHOD_NAME) {
  try {
    // eslint-disable-next-line es/no-set -- needed for test
    var baseSet = new Set();
    var setLike = {
      size: 0,
      has: function () { return true; },
      keys: function () {
        // eslint-disable-next-line es/no-object-defineproperty -- needed for test
        return Object.defineProperty({}, 'next', {
          get: function () {
            baseSet.clear();
            baseSet.add(4);
            return function () {
              return { done: true };
            };
          }
        });
      }
    };
    var result = baseSet[METHOD_NAME](setLike);

    return result.size !== 1 || result.values().next().value !== 4;
  } catch (error) {
    return false;
  }
};

var $$9 = _export;
var symmetricDifference = setSymmetricDifference;
var setMethodGetKeysBeforeCloning$1 = setMethodGetKeysBeforeCloningDetection;
var setMethodAcceptSetLike$1 = setMethodAcceptSetLike$7;

var FORCED$3 = !setMethodAcceptSetLike$1('symmetricDifference') || !setMethodGetKeysBeforeCloning$1('symmetricDifference');

// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
$$9({ target: 'Set', proto: true, real: true, forced: FORCED$3 }, {
  symmetricDifference: symmetricDifference
});

var aSet = aSet$7;
var add = setHelpers.add;
var clone = setClone;
var getSetRecord = getSetRecord$7;
var iterateSimple = iterateSimple$7;

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
var setUnion = function union(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = clone(O);
  iterateSimple(keysIter, function (it) {
    add(result, it);
  });
  return result;
};

var $$8 = _export;
var union = setUnion;
var setMethodGetKeysBeforeCloning = setMethodGetKeysBeforeCloningDetection;
var setMethodAcceptSetLike = setMethodAcceptSetLike$7;

var FORCED$2 = !setMethodAcceptSetLike('union') || !setMethodGetKeysBeforeCloning('union');

// `Set.prototype.union` method
// https://tc39.es/ecma262/#sec-set.prototype.union
$$8({ target: 'Set', proto: true, real: true, forced: FORCED$2 }, {
  union: union
});

var $$7 = _export;
var uncurryThis$9 = functionUncurryThis;
var requireObjectCoercible$2 = requireObjectCoercible$8;
var toIntegerOrInfinity$3 = toIntegerOrInfinity$8;
var toString$2 = toString$d;
var fails$7 = fails$A;

var charAt$3 = uncurryThis$9(''.charAt);

var FORCED$1 = fails$7(function () {
  // eslint-disable-next-line es/no-string-prototype-at -- safe
  return '𠮷'.at(-2) !== '\uD842';
});

// `String.prototype.at` method
// https://tc39.es/ecma262/#sec-string.prototype.at
$$7({ target: 'String', proto: true, forced: FORCED$1 }, {
  at: function at(index) {
    var S = toString$2(requireObjectCoercible$2(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity$3(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : charAt$3(S, k);
  }
});

var uncurryThis$8 = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$8;
var toString$1 = toString$d;
var requireObjectCoercible$1 = requireObjectCoercible$8;

var charAt$2 = uncurryThis$8(''.charAt);
var charCodeAt = uncurryThis$8(''.charCodeAt);
var stringSlice$2 = uncurryThis$8(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$1(requireObjectCoercible$1($this));
    var position = toIntegerOrInfinity$2(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$7 = functionUncurryThis;
var toObject$2 = toObject$9;

var floor = Math.floor;
var charAt = uncurryThis$7(''.charAt);
var replace = uncurryThis$7(''.replace);
var stringSlice$1 = uncurryThis$7(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$2(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply = functionApply;
var call$3 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$6 = fails$A;
var anObject$4 = anObject$p;
var isCallable$2 = isCallable$p;
var isObject$6 = isObject$l;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$8;
var toLength = toLength$2;
var toString = toString$d;
var requireObjectCoercible = requireObjectCoercible$8;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$6;
var getSubstitution = getSubstitution$1;
var getRegExpFlags = regexpGetFlags;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol$2 = wellKnownSymbol$m;

var REPLACE = wellKnownSymbol$2('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis$6([].concat);
var push$1 = uncurryThis$6([].push);
var stringIndexOf = uncurryThis$6(''.indexOf);
var stringSlice = uncurryThis$6(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$6(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isObject$6(searchValue) ? getMethod(searchValue, REPLACE) : undefined;
      return replacer
        ? call$3(replacer, searchValue, O, replaceValue)
        : call$3(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$4(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$2(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var flags = toString(getRegExpFlags(rx));
      var global = stringIndexOf(flags, 'g') !== -1;
      var fullUnicode;
      if (global) {
        fullUnicode = stringIndexOf(flags, 'u') !== -1;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push$1(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity$1(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$1(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var fails$5 = fails$A;

var freezing = !fails$5(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var internalMetadata = {exports: {}};

var objectGetOwnPropertyNamesExternal = {};

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof$2 = classofRaw$2;
var toIndexedObject$1 = toIndexedObject$7;
var $getOwnPropertyNames = objectGetOwnPropertyNames.f;
var arraySlice = arraySlice$3;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
  return windowNames && classof$2(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject$1(it));
};

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails$4 = fails$A;

var arrayBufferNonExtensible = fails$4(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

var fails$3 = fails$A;
var isObject$5 = isObject$l;
var classof$1 = classofRaw$2;
var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails$3(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var objectIsExtensible = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject$5(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof$1(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

var $$6 = _export;
var uncurryThis$5 = functionUncurryThis;
var hiddenKeys = hiddenKeys$5;
var isObject$4 = isObject$l;
var hasOwn$1 = hasOwnProperty_1;
var defineProperty = objectDefineProperty.f;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
var isExtensible$1 = objectIsExtensible;
var uid = uid$3;
var FREEZING$1 = freezing;

var REQUIRED = false;
var METADATA = uid('meta');
var id$1 = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id$1++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject$4(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn$1(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible$1(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData$1 = function (it, create) {
  if (!hasOwn$1(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible$1(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING$1 && REQUIRED && isExtensible$1(it) && !hasOwn$1(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis$5([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $$6({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = internalMetadata.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData$1,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;

var internalMetadataExports = internalMetadata.exports;

var wellKnownSymbol$1 = wellKnownSymbol$m;

var ITERATOR = wellKnownSymbol$1('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var $$5 = _export;
var globalThis$2 = globalThis_1;
var uncurryThis$4 = functionUncurryThis;
var isForced = isForced_1;
var defineBuiltIn = defineBuiltIn$b;
var InternalMetadataModule$1 = internalMetadataExports;
var iterate$4 = iterate$a;
var anInstance$1 = anInstance$4;
var isCallable$1 = isCallable$p;
var isNullOrUndefined$1 = isNullOrUndefined$5;
var isObject$3 = isObject$l;
var fails$2 = fails$A;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var setToStringTag = setToStringTag$5;
var inheritIfRequired = inheritIfRequired$3;

var collection$1 = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = globalThis$2[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis$4(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY === 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === 'delete' ? function (key) {
        return IS_WEAK && !isObject$3(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'get' ? function get(key) {
        return IS_WEAK && !isObject$3(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'has' ? function has(key) {
        return IS_WEAK && !isObject$3(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable$1(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails$2(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule$1.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails$2(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails$2(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance$1(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined$1(iterable)) iterate$4(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $$5({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

var uncurryThis$3 = functionUncurryThis;
var fails$1 = fails$A;
var isCallable = isCallable$p;
var classof = classof$c;
var getBuiltIn = getBuiltIn$9;
var inspectSource = inspectSource$2;

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$3(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$1(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray$1 = isArray$4;
var isConstructor = isConstructor$1;
var isObject$2 = isObject$l;
var wellKnownSymbol = wellKnownSymbol$m;

var SPECIES = wellKnownSymbol('species');
var $Array$1 = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$1(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array$1 || isArray$1(C.prototype))) C = undefined;
    else if (isObject$2(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array$1 : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind = functionBindContext;
var uncurryThis$2 = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject$1 = toObject$9;
var lengthOfArrayLike$2 = lengthOfArrayLike$8;
var arraySpeciesCreate = arraySpeciesCreate$1;

var push = uncurryThis$2([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$1($this);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$2(self);
    var boundFunction = bind(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)};

var uncurryThis$1 = functionUncurryThis;
var defineBuiltIns$1 = defineBuiltIns$4;
var getWeakData = internalMetadataExports.getWeakData;
var anInstance = anInstance$4;
var anObject$3 = anObject$p;
var isNullOrUndefined = isNullOrUndefined$5;
var isObject$1 = isObject$l;
var iterate$3 = iterate$a;
var ArrayIterationModule = arrayIteration;
var hasOwn = hasOwnProperty_1;
var InternalStateModule = internalState;

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis$1([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

var collectionWeak$1 = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: null
      });
      if (!isNullOrUndefined(iterable)) iterate$3(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject$3(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns$1(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject$1(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject$1(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns$1(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject$1(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          if (data) return data[state.id];
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};

var FREEZING = freezing;
var globalThis$1 = globalThis_1;
var uncurryThis = functionUncurryThis;
var defineBuiltIns = defineBuiltIns$4;
var InternalMetadataModule = internalMetadataExports;
var collection = collection$1;
var collectionWeak = collectionWeak$1;
var isObject = isObject$l;
var enforceInternalState = internalState.enforce;
var fails = fails$A;
var NATIVE_WEAK_MAP = weakMapBasicDetection;

var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;

var IS_IE11 = !globalThis$1.ActiveXObject && 'ActiveXObject' in globalThis$1;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);

// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function () {
  return FREEZING && fails(function () {
    var frozenArray = freeze([]);
    nativeSet(new $WeakMap(), frozenArray, 1);
    return !isFrozen(frozenArray);
  });
};

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) if (IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
// Chakra Edge frozen keys fix
} else if (hasMSEdgeFreezingBug()) {
  defineBuiltIns(WeakMapPrototype, {
    set: function set(key, value) {
      var arrayIntegrityLevel;
      if (isArray(key)) {
        if (isFrozen(key)) arrayIntegrityLevel = freeze;
        else if (isSealed(key)) arrayIntegrityLevel = seal;
      }
      nativeSet(this, key, value);
      if (arrayIntegrityLevel) arrayIntegrityLevel(key);
      return this;
    }
  });
}

var Brand;
(function (Brand) {
  Brand["MMT"] = "MMT";
  Brand["GI"] = "GI";
})(Brand || (Brand = {}));
let requestId = null;
const getRequestId = () => {
  if (requestId) {
    return requestId;
  }
  resetRequestId();
  return requestId;
};
const resetRequestId = () => {
  requestId = coreUtils.generateUUID();
};
var StorageKeys;
(function (StorageKeys) {
  StorageKeys["TM_TOKEN"] = "TM_TOKEN";
})(StorageKeys || (StorageKeys = {}));
/**
 * Calculates the net effective exchange rate after applying cashback.
 *
 * @param exchangeRate - The original exchange rate.
 * @param cashbackAmt - The amount of cashback received (in INR).
 * @param totalAmountInInr - The total amount of currency (in INR).
 * @returns The net effective exchange rate after applying cashback. Returns 0 if the currency amount is 0.
 */
function getNetEffectiveRate(exchangeRate, cashbackAmt, totalAmountInInr) {
  if (totalAmountInInr) {
    return exchangeRate - exchangeRate * (cashbackAmt / totalAmountInInr);
  }
  return 0;
}
/**
 * Calculates the net effective exchange rate using total amount, cashback, and forex amount.
 *
 * @param totalAmountInInr - The total amount in INR.
 * @param cashbackAmt - The amount of cashback received (in INR).
 * @param amountInForex - The amount in foreign currency.
 * @returns The net effective exchange rate. Returns 0 if the forex amount is 0.
 */
function getNetEffectiveRateByForexAmount(totalAmountInInr, cashbackAmt, amountInForex) {
  if (amountInForex) {
    return (totalAmountInInr - cashbackAmt) / amountInForex;
  }
  return 0;
}
/**
 * Function to calculate the cashback applicable  based on the amount entered.
 * @param value Rupee value of amount entered.
 * @param slabs Array of slabs with range and cashback offered.
 * @returns Returns the effective cashback amount.
 */
function getCashbackAmount(amount, slabs) {
  var _a, _b, _c;
  // If slabs array is empty, return 0 cashback
  if (!slabs || slabs.length === 0) {
    return 0;
  }
  // Check if value is less than the minAmount of the first slab
  if (Math.round(amount) < slabs[0].min_order_amount) {
    return 0;
  }
  // Iterate through each slab to find the appropriate cashback
  for (let i = 0; i < slabs.length; i++) {
    const slab = slabs[i];
    if (Math.round(amount) >= slab.min_order_amount && Math.round(amount) < slab.max_order_amount) {
      return (_a = slab.offer_amount) !== null && _a !== void 0 ? _a : 0;
    }
  }
  // If value is greater than or equal to maxAmount of the last slab, return the last cashback
  return (_c = (_b = slabs.at(-1)) === null || _b === void 0 ? void 0 : _b.offer_amount) !== null && _c !== void 0 ? _c : 0;
}
function maxCashbackAmount(slabs) {
  var _a, _b;
  if (!slabs || slabs.length === 0) {
    return 0;
  }
  return (_b = (_a = slabs.at(-1)) === null || _a === void 0 ? void 0 : _a.offer_amount) !== null && _b !== void 0 ? _b : 0;
}
function getMinOrderAmount(slabs, minOrderAmount) {
  var _a, _b;
  if (!slabs || slabs.length === 0) {
    return 0;
  }
  return (_b = (_a = slabs[0].min_order_amount) !== null && _a !== void 0 ? _a : minOrderAmount) !== null && _b !== void 0 ? _b : 0;
}
function getBestNetEffectiveRate(currencyRate, slabs) {
  const maxCashback = maxCashbackAmount(slabs);
  return getNetEffectiveRate(currencyRate, maxCashback, slabs === null || slabs === void 0 ? void 0 : slabs[slabs.length - 1].min_order_amount);
}
/**
 * Retrieves the exchange rate for a given currency code.
 *
 * @param currencyInfo - The object containing currency information.
 * @param currencyCode - The currency code for which to get the exchange rate.
 * @param selectedProduct - (Optional) The selected product type to prioritize in the search.
 * @returns The exchange rate for the given currency code, or 0 if not found.
 */
function getExchangeRate(currencyInfo, currencyCode, selectedProduct) {
  var _a, _b, _c, _d, _e, _f;
  if (!currencyInfo) {
    return 0;
  }
  // Check if the selected product has the exchange rate for the given currency code
  if (selectedProduct && ((_b = (_a = currencyInfo[selectedProduct]) === null || _a === void 0 ? void 0 : _a[currencyCode]) === null || _b === void 0 ? void 0 : _b.rate)) {
    return currencyInfo[selectedProduct][currencyCode].rate;
  }
  // Check if the 'PC' product has the exchange rate for the given currency code
  if ((_d = (_c = currencyInfo.PC) === null || _c === void 0 ? void 0 : _c[currencyCode]) === null || _d === void 0 ? void 0 : _d.rate) {
    return currencyInfo.PC[currencyCode].rate;
  }
  // Check if the 'CN' product has the exchange rate for the given currency code
  if ((_f = (_e = currencyInfo.CN) === null || _e === void 0 ? void 0 : _e[currencyCode]) === null || _f === void 0 ? void 0 : _f.rate) {
    return currencyInfo.CN[currencyCode].rate;
  }
  // Return 0 if the exchange rate is not found
  return 0;
}
function deepCopy(value, seen = new WeakMap()) {
  // Handle null, undefined, and primitive values
  if (value === null || typeof value !== 'object') {
    return value;
  }
  // Handle circular references
  if (seen.has(value)) {
    return seen.get(value);
  }
  // Handle Date
  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  // Handle RegExp
  if (value instanceof RegExp) {
    return new RegExp(value.source, value.flags);
  }
  // Handle Map
  if (value instanceof Map) {
    const _copy = new Map();
    seen.set(value, _copy);
    value.forEach((val, key) => {
      _copy.set(deepCopy(key, seen), deepCopy(val, seen));
    });
    return _copy;
  }
  // Handle Set
  if (value instanceof Set) {
    const _copy2 = new Set();
    seen.set(value, _copy2);
    value.forEach(val => {
      _copy2.add(deepCopy(val, seen));
    });
    return _copy2;
  }
  // Handle Arrays
  if (Array.isArray(value)) {
    const _copy3 = [];
    seen.set(value, _copy3);
    value.forEach((item, index) => {
      _copy3[index] = deepCopy(item, seen);
    });
    return _copy3;
  }
  // Handle Objects
  const copy = {};
  seen.set(value, copy);
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      copy[key] = deepCopy(value[key], seen);
    }
  }
  return copy;
}

function getPdtLoggerMethods(pdtLoggerData) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const state = pdtLoggerData === null || pdtLoggerData === void 0 ? void 0 : pdtLoggerData.state;
  const {
    userId,
    puid
  } = (state === null || state === void 0 ? void 0 : state.userData) || {};
  const {
    sendPdtDataV2
  } = pdtUtils.getPdtLoggerMethodsV2({
    userId,
    puid,
    lobFunnelType: 'Listing',
    pdtEvents: {},
    funnelStep: pdtLoggerData === null || pdtLoggerData === void 0 ? void 0 : pdtLoggerData.funnelStep
  });
  return {
    sendPdtData: (pdtData, shouldFlushEvents) => {
      var _a, _b;
      const listingApiData = (_a = state === null || state === void 0 ? void 0 : state.listingApi) === null || _a === void 0 ? void 0 : _a.data;
      const mergedPdtData = coreUtils.mergeObjects(((_b = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.analytics) === null || _b === void 0 ? void 0 : _b.pdtData) || {}, pdtData || {});
      sendPdtDataV2(Object.assign(Object.assign({}, mergedPdtData), {
        shouldFlushEvents
      }));
    }
  };
}

/**
 * SEO Headers Utility for Listing API
 * Provides reusable functions for SEO-specific header configurations
 */
/**
 * Gets SEO-specific headers for bot crawling and SEO pages
 * Overrides authentication headers to ensure proper SEO indexing
 * @param page_name - Optional page name to include in headers
 * @returns Headers object with SEO-specific overrides
 */
function getSeoHeaders(page_name) {
  const seoHeaders = {
    'x-tm-auth': '',
    credentials: 'omit',
    'mmt-auth': ''
  };
  // Add page name header if provided
  if (page_name) {
    seoHeaders['x-pn'] = page_name;
  }
  return seoHeaders;
}
/**
 * Applies SEO headers to an existing headers object using Object.assign
 * Mutates the original headers object for better performance
 * @param headers - Existing headers object to modify
 * @param page_name - Optional page name to include in headers
 * @returns The modified headers object (same reference)
 */
function applySeoHeaders(headers, page_name) {
  return Object.assign(headers, getSeoHeaders(page_name));
}

var success$1 = true;
var apiData$1 = {
	cardMinQtyConfig: {
		USD: {
			order_type_code: "B",
			currency_code: "USD",
			base_currency_code: "INR",
			product_code: "PC",
			forex_item_code: "USDBPC",
			min_amount: 10,
			min_denomination: 1
		}
	},
	location: {
		cityCode: "DHR",
		pincode: "248001",
		detectionSource: "PINCODE",
		locusCityCode: ""
	},
	pdtData: {
		delivery_details: {
			pincode: "248001",
			city: "Dehradun",
			city_code: "DHR"
		},
		upcoming_trip: {
			intl_travel: false,
			trip_details: [
				{
					country_code: "",
					currency_code: "",
					start_end: ""
				}
			]
		},
		user_details: {
			partner: "mmt"
		},
		user_context: {
			is_logged_in: false
		}
	}
};
var headerData$1 = {
	bgColors: [
		"#FFFFFF",
		"#FFFFFF"
	],
	templateId: "HEADER_SECTION",
	nodeId: "header-section",
	title: "Forex Card & Currency",
	bgImg: "",
	navActions: [
		{
			icon: {
				type: "static",
				url: "https://go-assets.ibcdn.com/u/MMT/images/1733566333478-bag-icon.png"
			},
			cta: {
				type: "navigate",
				deeplink: "mmyt://lending?cta=webview&ctaurl=https%3A%2F%2Ftripmoney.makemytrip.com%2Fpartners%2Fmmt%2Fforex%2Fbmf%2Fcurrency%2Fpost-sales%2Forders-listing%3Frn%3Dtrue&minver=1&mmtauthkey=mmt-auth&showHeader=false&login_required=false"
			}
		}
	],
	analytics: {
		trackingKey: "hdr"
	}
};
var cardData$1 = [
	{
		templateId: "CURRENCY_PRODUCT_SELECTION",
		nodeId: "currency-product-selection",
		data: {
			deliverAtSelection: {
				"default": "Delhi",
				title: "Deliver AT",
				placeholder: "Select Currency",
				cta: {
					id: "PINCODE_BOTTOMSHEET",
					type: "handler",
					nodeId: "currency-selection-bottomsheet",
					modalId: "PINCODE_BOTTOMSHEET"
				},
				bottomBanner: {
					title: ""
				},
				bottomText: "110011"
			},
			currencySelection: {
				"default": "US Dollar",
				title: "CURRENCY",
				placeholder: "Select Currency",
				cta: {
					id: "CURRENCY_SEARCH_BOTTOMSHEET",
					type: "handler",
					nodeId: "currency-selection-bottomsheet",
					modalId: "CURRENCY_SEARCH_BOTTOMSHEET"
				},
				bottomBanner: {
					title: ""
				},
				bottomText: "USD"
			},
			amountSelectionForex: {
				defaultCurrency: "USD",
				title: "FOREX AMOUNT",
				hint: "Enter Amount",
				bottomBanner: {
					title: ""
				},
				disabled: true
			},
			amountSelectionInr: {
				defaultCurrency: "INR",
				title: "INR AMOUNT",
				hint: "Enter Amount",
				disabled: true
			},
			productSelection: {
				title: "CARD/CURRENCY",
				hint: "Select",
				bottomText: "Multi Currency Card / Foreign Currency Notes"
			},
			productItems: [
				{
					title: "",
					productType: "PC",
					icon: {
						url: "https://go-assets.ibcdn.com/u/MMT/images/1730788343204-ic_forex_card.png",
						type: "static"
					},
					iconNote: [
						{
							type: "text",
							typography: "labelSmallW1",
							text: "",
							color: "#000000"
						}
					],
					cta: {
						id: "PC_BUY_NOW",
						text: "Buy Now",
						type: "navigate",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/onboarding/load-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}"
					},
					currency: {
						USD: {
							disabled: true,
							selected: false,
							title: [
								{
									type: "text",
									typography: "labelMediumW3",
									text: "Multi Currency Card",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							subtitle: [
								{
									type: "text",
									typography: "labelSmallW1",
									text: "Lifetime Free, Zero Markup",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							recommendedQty: 1000,
							bottomText: [
								{
									type: "text",
									typography: "labelSmallW3",
									text: "Unavailable! ",
									color: "#CF8100"
								},
								{
									type: "text",
									typography: "labelSmallW1",
									text: "Try different location Pincode",
									color: "#CF8100"
								}
							]
						}
					}
				},
				{
					title: "",
					productType: "CN",
					icon: {
						url: "https://go-assets.ibcdn.com/u/MMT/images/1732622423157-ic_foreign_currency.png",
						type: "static"
					},
					cta: {
						id: "CN_BUY_NOW",
						text: "Buy Now",
						type: "navigate",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/currency/onboarding/load-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}"
					},
					currency: {
						USD: {
							disabled: true,
							selected: false,
							title: [
								{
									type: "text",
									typography: "labelMediumW3",
									text: "Foreign Currency Notes",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							subtitle: [
								{
									type: "text",
									typography: "labelSmallW1",
									text: "RBI approved notes, Best Rates",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							bottomText: [
								{
									type: "text",
									typography: "labelSmallW3",
									text: "Unavailable! ",
									color: "#CF8100"
								},
								{
									type: "text",
									typography: "labelSmallW1",
									text: "Try different location Pincode",
									color: "#CF8100"
								}
							],
							recommendedQty: 1000
						}
					}
				}
			],
			cta: {
				deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/onboarding/load-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}",
				id: "BUY_NOW_BTN",
				isDisabled: true,
				text: "Buy Now",
				type: "navigate"
			}
		}
	},
	{
		templateId: "DELIVERY_PERSUASION",
		nodeId: "delivery-persuasion",
		analytics: {
			trackingKey: "dlv_p_unbl"
		},
		data: {
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1733233500129-ic_forex_delivery.gif"
			},
			title: [
				{
					type: "text",
					typography: "labelSmallW3",
					text: "Temporarily not serviceable ",
					color: "#EC2127",
					clickable: false
				},
				{
					type: "text",
					clickable: false,
					color: "#000000",
					typography: "labelSmallW2",
					text: "in "
				},
				{
					type: "text",
					clickable: false,
					color: "#000000",
					typography: "labelSmallW3",
					text: "110011, Delhi "
				}
			]
		}
	},
	{
		templateId: "PRODUCT_INFO_SCROLLER",
		nodeId: "product-info-scroller",
		analytics: {
			trackingKey: "pc_info"
		},
		data: {
			title: "Know more about our product",
			items: [
				{
					image: {
						type: "image",
						url: "https://tripmoneycmsimgak.mmtcdn.com/img/mcc_web_41a7d8dde0.png"
					},
					bottomCta: {
						id: "know_more_cta_products",
						type: "navigate",
						text: "KNOW MORE",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/onboarding/landing"
					},
					title: "Multi Currency Card",
					infoItems: [
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "Zero forex markup. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "Get actual interbank rates",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "No hidden charges. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "Zero reload, unload & annual fee",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "Save upto 5% ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "over your Credit/Debit cards",
									color: "#4a4a4a"
								}
							]
						}
					]
				},
				{
					image: {
						type: "image",
						url: "https://tripmoneycmsimgak.mmtcdn.com/img/fcn_web_2d4305f713.png"
					},
					bottomCta: {
						id: "know_more_cta_products_2",
						type: "navigate",
						text: "ORDER NOW",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/currency/onboarding/load-currency"
					},
					title: "Foreign Currency Notes",
					infoItems: [
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "40+ currencies available. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "RBI approved currency notes",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "Best exchange rates. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "Lowest rates in the market",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "100+ RBI-licensed money changers ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "across 50+ cities",
									color: "#4a4a4a"
								}
							]
						}
					]
				}
			]
		}
	},
	{
		templateId: "STATIC_TITLE_SUBTITLE",
		nodeId: "powered-by",
		data: {
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1757592077254-rate-ticker-arrow-icon.png"
			},
			text: [
				{
					type: "text",
					clickable: false,
					color: "#757575",
					typography: "labelSmallW1",
					text: "BookMyForex Pvt. Ltd. is a MakeMyTrip group company, is a currency exchange service provider authorised by the Reserve Bank of India (RBI). License number : FE.DEL.FFMC/ U070/2013"
				}
			]
		}
	},
	{
		templateId: "FREQUENTLY_ASKED_QUESTION",
		nodeId: "frequenty_asked_questions",
		analytics: {
			trackingKey: "faqs"
		},
		data: {
			title: "Frequently Asked Questions",
			tabs: [
				{
					id: "mcc",
					title: "Multi Currency Card",
					accordion: [
						{
							q: "What is a Multicurrency Card?",
							a: "A Multicurrency Card is a prepaid card designed specifically for international travelers. It is fully compliant with RBI regulations and provides peace of mind with 100% acceptance at all merchants in over 150 countries. It also provides digital controls within the app, allowing you to lock/unlock the card instantly and offers several benefits, without the need to link your bank account to the card."
						},
						{
							q: "Who should use Multicurrency Card?",
							a: "Multicurrency Card is ideal for anyone who values peace of mind during international trips and wants to avoid all forex markups and hidden charges."
						},
						{
							q: "Is there any documentation or KYC required?",
							a: "Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket after making payment for forex transactions on Makemytrip. These will be verified before processing the order."
						},
						{
							q: "Why should I not use a Debit/Credit card instead?",
							a: "Using a Debit/Credit card for international transactions may come with several drawbacks such as high markups (up to 5%), additional service charges, hidden fees, low acceptance at certain places, higher risk of scams, potential misuse in case of loss, negative impact on your CIBIL score, and fluctuating exchange rates. You can avoid all these by opting for Multicurrency Card."
						},
						{
							q: "Does this card give reward points?",
							a: "No, this card does not offer reward points. However, it is still the most rewarding option due to its lowest forex rates and cashback offers."
						},
						{
							q: "How do I get this card?",
							a: "You can easily order this card online within 2 minutes. Simply enter your PAN (Permanent Account Number) and delivery address, and the card will be delivered to your doorstep within 48 hours."
						},
						{
							q: "How can I load money into my card?",
							a: "You can load money instantly using UPI, NetBanking, and Debit Card. You can top up your card anytime, even during your international trip."
						},
						{
							q: "What if I don’t want to use the card later?",
							a: "If you no longer wish to use the card, you have the option to withdraw the unused money instantly. Additionally, you can choose to temporarily lock the card or close it anytime."
						}
					]
				},
				{
					id: "fcn",
					title: "Foreign Currency Notes",
					accordion: [
						{
							q: "Who should buy foreign currency notes?",
							a: "Every international traveller should purchase some foreign currency notes, before their trip. Currency notes are always a good option to prevent any potential inconvenience while spending in a foreign country, especially in case your forex or credit card are not accepted in some outlets or for local conveyance."
						},
						{
							q: "Why should I buy foreign currency notes from Makemytrip?",
							a: "We offer best exchange rates, genuine notes from RBI licensed companies, doorstep delivery across 50+ cities, 40+ currencies available, instant customer support and many more."
						},
						{
							q: "How can I place the order for currency notes?",
							a: "Ordering foreign currency notes through MakeMyTrip takes just two minutes. All you need to do is provide the currency and amount required, along with your PAN and address details. That's it! Your currency notes will be delivered to your address within the specified time."
						},
						{
							q: "How many days before travel should I buy currency notes?",
							a: "Purchasing foreign currency notes well in advance of your travel is a prudent practice to prevent potential stock shortages, unforeseen delays, or fluctuations in exchange rates. You can buy foreign currency notes within 60 days of your trip start date. Advance purchase prior to this 60-day period is not allowed."
						},
						{
							q: "What’s my foreign exchange entitlement (limit) for personal / leisure travel?",
							a: "Not exceeding US Dollars 2,50,000 in a financial year. If not consumed any part of it for any other purpose stated as per RBI's guidelines covering the new liberalized Remittance Scheme (LRS). Limit can be utilized in one or more visits abroad for personal/leisure purposes. If an individual has already remitted any amount under the Liberalized Remittance Scheme in a financial year, then the applicable limit for traveling purposes for such an individual would be reduced from USD 250,000 by the amount so remitted."
						},
						{
							q: "Is there a separate limit for carrying currency notes?",
							a: "Travelers are allowed to purchase foreign currency notes/coins only up to US$ 3000 individually. Exceptions to this rule are the following: (a) travellers proceeding to Iraq and Libya can draw foreign exchange in the form of foreign currency notes and coins not exceeding US$ 5000 or its equivalent. (b) travellers proceeding to the Islamic Republic of Iran, the Russian Federation, and other Republics of the Commonwealth of Independent States who can draw entire foreign exchange in the form of foreign currency notes or coins. (c) For travelers proceeding for Haj/Umrah pilgrimage, the full amount of BTQ entitlement (USD 250,000) in cash or up to the cash limit as specified by the Haj Committee of India, may be released by the ADs and FFMCs. Minimum order limit for foreign currency is set at INR 3000."
						},
						{
							q: "Is there any documentation or KYC required?",
							a: "Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket and Visa (if not on arrival), after making payment for forex transactions on Makemytrip. These will be verified before processing the order."
						},
						{
							q: "Can I sell back my left over foreign currency notes?",
							a: "Any remaining foreign currency notes that you have after your international trip can be conveniently exchanged through the BookMyForex app or website. This allows you to convert your leftover foreign currency back into your home currency, ensuring that your funds don't go to waste."
						},
						{
							q: "Is there anything else I should be aware of while purchasing foreign currency notes?",
							a: "Yes, you should make payment for forex transactions from traveller’s bank account, whose PAN number is provided. As per RBI guidelines, name in PAN should match with the Bank account holder name."
						}
					]
				}
			]
		}
	}
];
var bottomSheets$1 = {
	COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET: {
		title: "Coupon Details",
		couponList: [
			{
				title: "UPTO INR 7500 CASHBACK",
				type: "FOREX_SALE",
				subLabel: [
					{
						type: "text",
						text: "LIMITED TIME OFFER",
						typography: "labelSmallW1",
						color: "#757575"
					}
				],
				bookingId: "FOREXCASHBACK",
				label: [
					{
						type: "text",
						clickable: false,
						color: "#4A4A4A",
						typography: "labelSmallW1",
						text: "Get upto "
					},
					{
						type: "text",
						clickable: false,
						color: "#007E7D",
						typography: "labelSmallW3",
						text: "INR 7500 "
					},
					{
						type: "text",
						clickable: false,
						color: "#4A4A4A",
						typography: "labelSmallW1",
						text: "cashback in your myCash wallet on delivery of your forex. Validity: 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website."
					}
				]
			}
		],
		tnc: {
			title: "Terms & Condition",
			list: [
				"Offer is valid from 2nd Dec to 31st December 2024.",
				"Cashback is applicable on order values exceeding INR 10,000.",
				"Offer is applicable on forex card and currency orders only. Offer is not applicable on card reload or unload orders.",
				"Cashback will only be processed if the offer is applied by the user while ordering.",
				"The Customer, upon successful completion of their transaction for ordering a forex card or currency, shall receive the cashback amount in the wallet as per the slabs, after delivery (and activation in the case of a card) by BookMyForex.",
				"myCash credited will be valid for 1 year from when it has been credited into the user's account.",
				"Cashback can only be credited to the wallet of the customer who purchased the Forex card or currency notes as per the terms of the offer and not to any third party's account.",
				"If the Customer cancels the order of the Forex card or currency, the Customer shall not be eligible to receive the cashback under the Offer and the terms of cancellation as provided on the BookMyForex platform shall be applicable.",
				[
					{
						type: "text",
						text: "To know more about Wallet usage Terms and conditions, \n visit https://www.makemytrip.com/mywallet/",
						color: "#4A4A4A",
						typography: "labelSmallW1"
					}
				],
				"Lowest Exchange Rate Guarantee : Get 2x the Price Difference in case you find a better price online.",
				"Offer applies to the net effective price (i.e., the price paid after adjusting any applicable cashback) paid by the Customer for placing the Forex Product order.",
				"The Offer is valid only for the same product, currency and amount for the same city or location.",
				"After purchasing the Forex Product, if you find a lower price for the same product on the website or app of any other authorized money changer, the Customer may raise a claim request via sending an email to ForexClaims@go-mmt.com.",
				"The claim must be submitted by the Customer using their registered email ID or phone number with relevant proofs."
			]
		},
		offerSlabs: {
			title: [
				{
					type: "text",
					clickable: false,
					color: "#757575",
					typography: "labelSmallW2",
					text: "Cashback Slabs"
				}
			],
			offerList: [
				{
					id: 1,
					title: "Slabs (in INR)",
					list: [
						"10k - 30k",
						"30k - 50k",
						"50k - 1 Lakh",
						"1 Lakh - 1.5 Lakh",
						"1.5 Lakh - 2.25 Lakh",
						"More than 2.25 Lakh"
					]
				},
				{
					id: 2,
					title: "Cashback (INR)",
					list: [
						"INR 100",
						"INR 450",
						"INR 900",
						"INR 2,000",
						"INR 4,000",
						"INR 7,500"
					]
				}
			]
		}
	},
	PINCODE_BOTTOMSHEET: {
		title: "Edit Location",
		subtitle: "Enter pincode of your delivery location",
		inputPlaceholder: "PINCODE",
		analytics: {
			trackingKey: "bms_loc"
		},
		closeCta: {
			id: "CLOSE",
			type: "CLOSE",
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png"
			}
		},
		cta: {
			id: "DETECT_LOCATION_CTA",
			type: "handler",
			text: "Detect Location",
			icon: {
				type: "static",
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732610465878-detect_location.png"
			}
		},
		loader: {
			title: "Fetching Location",
			loaderColor: "#008CFF",
			description: "Fetching location details..."
		},
		cityFallback: {
			title: "Select Delivery City",
			subTitle: "We are currently delivering to below cities in India",
			showCities: 5,
			cta: {
				id: "SHOW_MORE_CITIES",
				text: "show more cities",
				textColor: "#008CFF"
			}
		}
	},
	AMOUNT_CALCULATOR_BOTTOMSHEET: {
		title: "Enter Amount",
		closeCta: {
			id: "CLOSE",
			type: "CLOSE",
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png"
			}
		},
		comparisonIcon: {
			url: "https://go-assets.ibcdn.com/u/MMT/images/1732610060135-compare_icon.png"
		},
		infoIcon: {
			url: "https://go-assets.ibcdn.com/u/MMT/images/1730193523876-ic_forex_bulb.png",
			type: "static"
		},
		fromHint: [
			{
				type: "text",
				typography: "labelSmallW3",
				text: "{{VARS_FROM_CURRENCY}} amount",
				color: "#FFFFFF",
				vars: {
					VARS_FROM_CURRENCY: "USD"
				}
			}
		],
		toHint: "INR Amount",
		cta: {
			id: "add_currency",
			type: "close",
			text: "ADD"
		},
		bestRatePersuasion: [
			{
				type: "text",
				color: "#4a4a4a",
				typography: "labelSmallW1",
				text: ""
			}
		],
		maxINRAmount: 25000000,
		bottomText: [
			{
				type: "text",
				typography: "labelSmallW1",
				text: "",
				color: "#757575"
			}
		],
		analytics: {
			trackingKey: "bms_amtCl"
		}
	},
	CURRENCY_SEARCH_BOTTOMSHEET: {
		title: "Select Currency",
		allCurrencyHeader: "All Currencies",
		popularCurrencyHeader: "Popular Currencies",
		suggestionSection: {
			title: [
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW1",
					text: "Can't find what you are looking for? We recommend you to add "
				},
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW2",
					color: "#000000",
					text: "{{VARS_SUGGESTED_CURRENCY}}",
					vars: {
						VARS_SUGGESTED_CURRENCY: "US Dollar"
					}
				}
			],
			label: [
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW1",
					color: "#4A4A4A",
					text: "Why {{VARS_SUGGESTED_CURRENCY}}?",
					vars: {
						VARS_SUGGESTED_CURRENCY: "US Dollar"
					}
				}
			],
			featList: [
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Globally"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " Accepted"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Easily exchangable"
					},
					{
						type: "text",
						clickable: false,
						color: "#000000",
						typography: "labelSmallW1",
						text: " at airports and local vendors"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: "Exchangable at"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: " lowest rate"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " vs other currencies"
					}
				]
			]
		},
		currencyUnavailableSection: {
			title: [
				{
					type: "text",
					clickable: false,
					typography: "labelBaseW1",
					color: "#000000",
					text: "{{VARS_SEARCHED_CURRENCY}} is not in the market, hence we recommend you to",
					vars: {
						VARS_SEARCHED_CURRENCY: ""
					}
				},
				{
					type: "text",
					clickable: false,
					typography: "labelBaseW3",
					color: "#000000",
					text: " select {{VARS_SUGGESTED_CURRENCY}}",
					vars: {
						VARS_SUGGESTED_CURRENCY: ""
					}
				}
			],
			label: [
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW1",
					color: "#4A4A4A",
					text: "Why {{VARS_SUGGESTED_CURRENCY}}?",
					vars: {
						VARS_SUGGESTED_CURRENCY: ""
					}
				}
			],
			featList: [
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Globally"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " Accepted"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Easily exchangable"
					},
					{
						type: "text",
						clickable: false,
						color: "#000000",
						typography: "labelSmallW1",
						text: " at airports and local vendors"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: "Exchangable at"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: " lowest rate"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " vs other currencies"
					}
				]
			]
		},
		analytics: {
			trackingKey: "bms_curSh"
		}
	},
	SPECIAL_CASHBACK_BOTTOMSHEET: {
		title: "Net Effective Cost",
		closeCta: {
			id: "CLOSE",
			type: "CLOSE",
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png"
			}
		},
		taxInfo: [
			{
				type: "text",
				typography: "labelSmallW1",
				text: "",
				color: "#757575"
			}
		],
		analytics: {
			trackingKey: "bms_amtCl"
		}
	}
};
var fallbackResponseDT = {
	success: success$1,
	apiData: apiData$1,
	headerData: headerData$1,
	cardData: cardData$1,
	bottomSheets: bottomSheets$1
};

var success = true;
var apiData = {
	cardMinQtyConfig: {
		USD: {
			order_type_code: "B",
			currency_code: "USD",
			base_currency_code: "INR",
			product_code: "PC",
			forex_item_code: "USDBPC",
			min_amount: 10,
			min_denomination: 1
		}
	},
	location: {
		cityCode: "DHR",
		pincode: "248001",
		detectionSource: "PINCODE",
		locusCityCode: ""
	},
	pdtData: {
		delivery_details: {
			pincode: "248001",
			city: "Dehradun",
			city_code: "DHR"
		},
		upcoming_trip: {
			intl_travel: false,
			trip_details: [
				{
					country_code: "",
					currency_code: "",
					start_end: ""
				}
			]
		},
		user_details: {
			partner: "mmt"
		},
		user_context: {
			is_logged_in: false
		}
	}
};
var headerData = {
	bgColors: [
		"#FFFFFF",
		"#FFFFFF"
	],
	templateId: "HEADER_SECTION",
	nodeId: "header-section",
	title: "Forex Card & Currency",
	bgImg: "",
	navActions: [
		{
			icon: {
				type: "static",
				url: "https://go-assets.ibcdn.com/u/MMT/images/1733566333478-bag-icon.png"
			},
			cta: {
				type: "navigate",
				deeplink: "mmyt://lending?cta=webview&ctaurl=https%3A%2F%2Ftripmoney.makemytrip.com%2Fpartners%2Fmmt%2Fforex%2Fbmf%2Fcurrency%2Fpost-sales%2Forders-listing%3Frn%3Dtrue&minver=1&mmtauthkey=mmt-auth&showHeader=false&login_required=false"
			}
		}
	],
	analytics: {
		trackingKey: "hdr"
	}
};
var cardData = [
	{
		templateId: "CURRENCY_PRODUCT_SELECTION",
		nodeId: "currency-product-selection",
		data: {
			deliverAtSelection: {
				"default": "Delhi",
				title: "Deliver AT",
				placeholder: "Select Currency",
				cta: {
					id: "PINCODE_BOTTOMSHEET",
					type: "handler",
					nodeId: "currency-selection-bottomsheet",
					modalId: "PINCODE_BOTTOMSHEET"
				},
				bottomBanner: {
					title: ""
				},
				bottomText: "110011"
			},
			currencySelection: {
				"default": "US Dollar",
				title: "CURRENCY",
				placeholder: "Select Currency",
				bottomBanner: {
					title: ""
				},
				bottomText: "USD"
			},
			amountSelectionForex: {
				defaultCurrency: "USD",
				title: "FOREX AMOUNT",
				hint: "Enter Amount",
				bottomBanner: {
					title: ""
				},
				disabled: true
			},
			amountSelectionInr: {
				defaultCurrency: "INR",
				title: "INR AMOUNT",
				hint: "Enter Amount",
				disabled: true
			},
			productSelection: {
				title: "CARD/CURRENCY",
				hint: "Select",
				bottomText: "Multi Currency Card / Foreign Currency Notes"
			},
			productItems: [
				{
					title: "",
					productType: "PC",
					icon: {
						url: "https://go-assets.ibcdn.com/u/MMT/images/1730788343204-ic_forex_card.png",
						type: "static"
					},
					iconNote: [
						{
							type: "text",
							typography: "labelSmallW1",
							text: "",
							color: "#000000"
						}
					],
					cta: {
						id: "PC_BUY_NOW",
						text: "Buy Now",
						type: "navigate",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/onboarding/load-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}"
					},
					currency: {
						USD: {
							disabled: true,
							selected: false,
							title: [
								{
									type: "text",
									typography: "labelMediumW3",
									text: "Multi Currency Card",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							subtitle: [
								{
									type: "text",
									typography: "labelSmallW1",
									text: "Lifetime Free, Zero Markup",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							recommendedQty: 1000,
							bottomText: [
								{
									type: "text",
									typography: "labelSmallW3",
									text: "Unavailable! ",
									color: "#CF8100"
								},
								{
									type: "text",
									typography: "labelSmallW1",
									text: "Try different location Pincode",
									color: "#CF8100"
								}
							]
						}
					}
				},
				{
					title: "",
					productType: "CN",
					icon: {
						url: "https://go-assets.ibcdn.com/u/MMT/images/1732622423157-ic_foreign_currency.png",
						type: "static"
					},
					cta: {
						id: "CN_BUY_NOW",
						text: "Buy Now",
						type: "navigate",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/currency/onboarding/load-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}"
					},
					currency: {
						USD: {
							disabled: true,
							selected: false,
							title: [
								{
									type: "text",
									typography: "labelMediumW3",
									text: "Foreign Currency Notes",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							subtitle: [
								{
									type: "text",
									typography: "labelSmallW1",
									text: "RBI approved notes, Best Rates",
									color: "rgba(0, 0, 0, 0.3)"
								}
							],
							bottomText: [
								{
									type: "text",
									typography: "labelSmallW3",
									text: "Unavailable! ",
									color: "#CF8100"
								},
								{
									type: "text",
									typography: "labelSmallW1",
									text: "Try different location Pincode",
									color: "#CF8100"
								}
							],
							recommendedQty: 1000
						}
					}
				}
			],
			cta: {
				deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/onboarding/load-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}",
				id: "BUY_NOW_BTN",
				isDisabled: true,
				text: "Buy Now",
				type: "navigate"
			}
		}
	},
	{
		templateId: "DELIVERY_PERSUASION",
		nodeId: "delivery-persuasion",
		analytics: {
			trackingKey: "dlv_p_unbl"
		},
		data: {
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1733233500129-ic_forex_delivery.gif"
			},
			title: [
				{
					type: "text",
					typography: "labelSmallW3",
					text: "Temporarily not serviceable ",
					color: "#EC2127",
					clickable: false
				},
				{
					type: "text",
					clickable: false,
					color: "#000000",
					typography: "labelSmallW2",
					text: "in "
				},
				{
					type: "text",
					clickable: false,
					color: "#000000",
					typography: "labelSmallW3",
					text: "110011, Delhi "
				}
			]
		}
	},
	{
		templateId: "STATIC_TITLE_SUBTITLE",
		nodeId: "powered-by",
		data: {
			title: "Powered by",
			icon: {
				url: "https://tripmoneycmsimgak.mmtcdn.com/img/bmf_white_logo_5428e8a416.png",
				type: "static"
			},
			text: [
				{
					type: "text",
					clickable: false,
					color: "#FFFFFF",
					typography: "labelSmallW1",
					text: "License number : FE.DEL.FFMC/ U070/2013"
				}
			]
		}
	},
	{
		templateId: "PAGER_1",
		nodeId: "marketing-banners",
		analytics: {
			trackingKey: "mkr_bns"
		},
		data: {
			title: "",
			items: [
				{
					aspectRatio: 1.78,
					image: {
						type: "image",
						url: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8aG90ZWx8ZW58MHx8MHx8fDA%3D"
					},
					cta: {
						id: "marketing_banner_cta",
						type: "navigate",
						deeplink: "https://promos.makemytrip.com/lowest-exchange-rate-tncs-170924.html"
					}
				},
				{
					aspectRatio: 1.78,
					image: {
						type: "image",
						url: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8aG90ZWx8ZW58MHx8MHx8fDA%3D"
					},
					cta: {
						id: "marketing_banner_cta",
						type: "navigate",
						deeplink: "https://promos.makemytrip.com/lowest-exchange-rate-tncs-170924.html"
					}
				},
				{
					aspectRatio: 1.78,
					image: {
						type: "image",
						url: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8aG90ZWx8ZW58MHx8MHx8fDA%3D"
					},
					cta: {
						id: "marketing_banner_cta",
						type: "navigate",
						deeplink: "https://promos.makemytrip.com/lowest-exchange-rate-tncs-170924.html"
					}
				}
			]
		}
	},
	{
		templateId: "PRODUCT_INFO_SCROLLER",
		nodeId: "product-info-scroller",
		analytics: {
			trackingKey: "pc_info"
		},
		data: {
			title: "Know more about our product",
			items: [
				{
					image: {
						type: "image",
						url: "https://tripmoneycmsimgak.mmtcdn.com/img/mcc_web_41a7d8dde0.png"
					},
					bottomCta: {
						id: "know_more_cta_products",
						type: "navigate",
						text: "KNOW MORE",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/onboarding/landing"
					},
					title: "Multi Currency Card",
					infoItems: [
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "Zero forex markup. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "Get actual interbank rates",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "No hidden charges. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "Zero reload, unload & annual fee",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "Save upto 5% ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "over your Credit/Debit cards",
									color: "#4a4a4a"
								}
							]
						}
					]
				},
				{
					image: {
						type: "image",
						url: "https://tripmoneycmsimgak.mmtcdn.com/img/fcn_web_2d4305f713.png"
					},
					bottomCta: {
						id: "know_more_cta_products_2",
						type: "navigate",
						text: "ORDER NOW",
						deeplink: "https://forex.makemytrip.com/partners/mmt/forex/bmf/currency/onboarding/load-currency"
					},
					title: "Foreign Currency Notes",
					infoItems: [
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "40+ currencies available. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "RBI approved currency notes",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "Best exchange rates. ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "Lowest rates in the market",
									color: "#4a4a4a"
								}
							]
						},
						{
							text: [
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW2",
									text: "100+ RBI-licensed money changers ",
									color: "#4a4a4a"
								},
								{
									type: "text",
									clickable: false,
									typography: "labelSmallW1",
									text: "across 50+ cities",
									color: "#4a4a4a"
								}
							]
						}
					]
				}
			]
		}
	},
	{
		templateId: "FREQUENTLY_ASKED_QUESTION",
		nodeId: "frequenty_asked_questions",
		analytics: {
			trackingKey: "faqs"
		},
		data: {
			title: "Frequently Asked Questions",
			tabs: [
				{
					id: "mcc",
					title: "Multi Currency Card",
					accordion: [
						{
							q: "What is a Multicurrency Card?",
							a: "A Multicurrency Card is a prepaid card designed specifically for international travelers. It is fully compliant with RBI regulations and provides peace of mind with 100% acceptance at all merchants in over 150 countries. It also provides digital controls within the app, allowing you to lock/unlock the card instantly and offers several benefits, without the need to link your bank account to the card."
						},
						{
							q: "Who should use Multicurrency Card?",
							a: "Multicurrency Card is ideal for anyone who values peace of mind during international trips and wants to avoid all forex markups and hidden charges."
						},
						{
							q: "Is there any documentation or KYC required?",
							a: "Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket after making payment for forex transactions on Makemytrip. These will be verified before processing the order."
						},
						{
							q: "Why should I not use a Debit/Credit card instead?",
							a: "Using a Debit/Credit card for international transactions may come with several drawbacks such as high markups (up to 5%), additional service charges, hidden fees, low acceptance at certain places, higher risk of scams, potential misuse in case of loss, negative impact on your CIBIL score, and fluctuating exchange rates. You can avoid all these by opting for Multicurrency Card."
						},
						{
							q: "Does this card give reward points?",
							a: "No, this card does not offer reward points. However, it is still the most rewarding option due to its lowest forex rates and cashback offers."
						},
						{
							q: "How do I get this card?",
							a: "You can easily order this card online within 2 minutes. Simply enter your PAN (Permanent Account Number) and delivery address, and the card will be delivered to your doorstep within 48 hours."
						},
						{
							q: "How can I load money into my card?",
							a: "You can load money instantly using UPI, NetBanking, and Debit Card. You can top up your card anytime, even during your international trip."
						},
						{
							q: "What if I don’t want to use the card later?",
							a: "If you no longer wish to use the card, you have the option to withdraw the unused money instantly. Additionally, you can choose to temporarily lock the card or close it anytime."
						}
					]
				},
				{
					id: "fcn",
					title: "Foreign Currency Notes",
					accordion: [
						{
							q: "Who should buy foreign currency notes?",
							a: "Every international traveller should purchase some foreign currency notes, before their trip. Currency notes are always a good option to prevent any potential inconvenience while spending in a foreign country, especially in case your forex or credit card are not accepted in some outlets or for local conveyance."
						},
						{
							q: "Why should I buy foreign currency notes from Makemytrip?",
							a: "We offer best exchange rates, genuine notes from RBI licensed companies, doorstep delivery across 50+ cities, 40+ currencies available, instant customer support and many more."
						},
						{
							q: "How can I place the order for currency notes?",
							a: "Ordering foreign currency notes through MakeMyTrip takes just two minutes. All you need to do is provide the currency and amount required, along with your PAN and address details. That's it! Your currency notes will be delivered to your address within the specified time."
						},
						{
							q: "How many days before travel should I buy currency notes?",
							a: "Purchasing foreign currency notes well in advance of your travel is a prudent practice to prevent potential stock shortages, unforeseen delays, or fluctuations in exchange rates. You can buy foreign currency notes within 60 days of your trip start date. Advance purchase prior to this 60-day period is not allowed."
						},
						{
							q: "What’s my foreign exchange entitlement (limit) for personal / leisure travel?",
							a: "Not exceeding US Dollars 2,50,000 in a financial year. If not consumed any part of it for any other purpose stated as per RBI's guidelines covering the new liberalized Remittance Scheme (LRS). Limit can be utilized in one or more visits abroad for personal/leisure purposes. If an individual has already remitted any amount under the Liberalized Remittance Scheme in a financial year, then the applicable limit for traveling purposes for such an individual would be reduced from USD 250,000 by the amount so remitted."
						},
						{
							q: "Is there a separate limit for carrying currency notes?",
							a: "Travelers are allowed to purchase foreign currency notes/coins only up to US$ 3000 individually. Exceptions to this rule are the following: (a) travellers proceeding to Iraq and Libya can draw foreign exchange in the form of foreign currency notes and coins not exceeding US$ 5000 or its equivalent. (b) travellers proceeding to the Islamic Republic of Iran, the Russian Federation, and other Republics of the Commonwealth of Independent States who can draw entire foreign exchange in the form of foreign currency notes or coins. (c) For travelers proceeding for Haj/Umrah pilgrimage, the full amount of BTQ entitlement (USD 250,000) in cash or up to the cash limit as specified by the Haj Committee of India, may be released by the ADs and FFMCs. Minimum order limit for foreign currency is set at INR 3000."
						},
						{
							q: "Is there any documentation or KYC required?",
							a: "Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket and Visa (if not on arrival), after making payment for forex transactions on Makemytrip. These will be verified before processing the order."
						},
						{
							q: "Can I sell back my left over foreign currency notes?",
							a: "Any remaining foreign currency notes that you have after your international trip can be conveniently exchanged through the BookMyForex app or website. This allows you to convert your leftover foreign currency back into your home currency, ensuring that your funds don't go to waste."
						},
						{
							q: "Is there anything else I should be aware of while purchasing foreign currency notes?",
							a: "Yes, you should make payment for forex transactions from traveller’s bank account, whose PAN number is provided. As per RBI guidelines, name in PAN should match with the Bank account holder name."
						}
					]
				}
			]
		}
	}
];
var bottomSheets = {
	COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET: {
		title: "Coupon Details",
		couponList: [
			{
				title: "UPTO INR 7500 CASHBACK",
				type: "FOREX_SALE",
				subLabel: [
					{
						type: "text",
						text: "LIMITED TIME OFFER",
						typography: "labelSmallW1",
						color: "#757575"
					}
				],
				bookingId: "FOREXCASHBACK",
				label: [
					{
						type: "text",
						clickable: false,
						color: "#4A4A4A",
						typography: "labelSmallW1",
						text: "Get upto "
					},
					{
						type: "text",
						clickable: false,
						color: "#007E7D",
						typography: "labelSmallW3",
						text: "INR 7500 "
					},
					{
						type: "text",
						clickable: false,
						color: "#4A4A4A",
						typography: "labelSmallW1",
						text: "cashback in your myCash wallet on delivery of your forex. Validity: 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website."
					}
				]
			}
		],
		tnc: {
			title: "Terms & Condition",
			list: [
				"Offer is valid from 2nd Dec to 31st December 2024.",
				"Cashback is applicable on order values exceeding INR 10,000.",
				"Offer is applicable on forex card and currency orders only. Offer is not applicable on card reload or unload orders.",
				"Cashback will only be processed if the offer is applied by the user while ordering.",
				"The Customer, upon successful completion of their transaction for ordering a forex card or currency, shall receive the cashback amount in the wallet as per the slabs, after delivery (and activation in the case of a card) by BookMyForex.",
				"myCash credited will be valid for 1 year from when it has been credited into the user's account.",
				"Cashback can only be credited to the wallet of the customer who purchased the Forex card or currency notes as per the terms of the offer and not to any third party's account.",
				"If the Customer cancels the order of the Forex card or currency, the Customer shall not be eligible to receive the cashback under the Offer and the terms of cancellation as provided on the BookMyForex platform shall be applicable.",
				[
					{
						type: "text",
						text: "To know more about Wallet usage Terms and conditions, \n visit https://www.makemytrip.com/mywallet/",
						color: "#4A4A4A",
						typography: "labelSmallW1"
					}
				],
				"Lowest Exchange Rate Guarantee : Get 2x the Price Difference in case you find a better price online.",
				"Offer applies to the net effective price (i.e., the price paid after adjusting any applicable cashback) paid by the Customer for placing the Forex Product order.",
				"The Offer is valid only for the same product, currency and amount for the same city or location.",
				"After purchasing the Forex Product, if you find a lower price for the same product on the website or app of any other authorized money changer, the Customer may raise a claim request via sending an email to ForexClaims@go-mmt.com.",
				"The claim must be submitted by the Customer using their registered email ID or phone number with relevant proofs."
			]
		},
		offerSlabs: {
			title: [
				{
					type: "text",
					clickable: false,
					color: "#757575",
					typography: "labelSmallW2",
					text: "Cashback Slabs"
				}
			],
			offerList: [
				{
					id: 1,
					title: "Slabs (in INR)",
					list: [
						"10k - 30k",
						"30k - 50k",
						"50k - 1 Lakh",
						"1 Lakh - 1.5 Lakh",
						"1.5 Lakh - 2.25 Lakh",
						"More than 2.25 Lakh"
					]
				},
				{
					id: 2,
					title: "Cashback (INR)",
					list: [
						"INR 100",
						"INR 450",
						"INR 900",
						"INR 2,000",
						"INR 4,000",
						"INR 7,500"
					]
				}
			]
		}
	},
	PINCODE_BOTTOMSHEET: {
		title: "Edit Location",
		subtitle: "Enter pincode of your delivery location",
		inputPlaceholder: "PINCODE",
		analytics: {
			trackingKey: "bms_loc"
		},
		closeCta: {
			id: "CLOSE",
			type: "CLOSE",
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png"
			}
		},
		cta: {
			id: "DETECT_LOCATION_CTA",
			type: "handler",
			text: "Detect Location",
			icon: {
				type: "static",
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732610465878-detect_location.png"
			}
		},
		loader: {
			title: "Fetching Location",
			loaderColor: "#008CFF",
			description: "Fetching location details..."
		},
		cityFallback: {
			title: "Select Delivery City",
			subTitle: "We are currently delivering to below cities in India",
			showCities: 5,
			cta: {
				id: "SHOW_MORE_CITIES",
				text: "show more cities",
				textColor: "#008CFF"
			}
		}
	},
	AMOUNT_CALCULATOR_BOTTOMSHEET: {
		title: "Enter Amount",
		closeCta: {
			id: "CLOSE",
			type: "CLOSE",
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png"
			}
		},
		comparisonIcon: {
			url: "https://go-assets.ibcdn.com/u/MMT/images/1732610060135-compare_icon.png"
		},
		infoIcon: {
			url: "https://go-assets.ibcdn.com/u/MMT/images/1730193523876-ic_forex_bulb.png",
			type: "static"
		},
		fromHint: [
			{
				type: "text",
				typography: "labelSmallW3",
				text: "{{VARS_FROM_CURRENCY}} amount",
				color: "#FFFFFF",
				vars: {
					VARS_FROM_CURRENCY: "USD"
				}
			}
		],
		toHint: "INR Amount",
		cta: {
			id: "add_currency",
			type: "close",
			text: "ADD"
		},
		bestRatePersuasion: [
			{
				type: "text",
				color: "#4a4a4a",
				typography: "labelSmallW1",
				text: ""
			}
		],
		maxINRAmount: 25000000,
		bottomText: [
			{
				type: "text",
				typography: "labelSmallW1",
				text: "",
				color: "#757575"
			}
		],
		analytics: {
			trackingKey: "bms_amtCl"
		}
	},
	CURRENCY_SEARCH_BOTTOMSHEET: {
		title: "Select Currency",
		allCurrencyHeader: "All Currencies",
		popularCurrencyHeader: "Popular Currencies",
		suggestionSection: {
			title: [
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW1",
					text: "Can't find what you are looking for? We recommend you to add "
				},
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW2",
					color: "#000000",
					text: "{{VARS_SUGGESTED_CURRENCY}}",
					vars: {
						VARS_SUGGESTED_CURRENCY: "US Dollar"
					}
				}
			],
			label: [
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW1",
					color: "#4A4A4A",
					text: "Why {{VARS_SUGGESTED_CURRENCY}}?",
					vars: {
						VARS_SUGGESTED_CURRENCY: "US Dollar"
					}
				}
			],
			featList: [
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Globally"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " Accepted"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Easily exchangable"
					},
					{
						type: "text",
						clickable: false,
						color: "#000000",
						typography: "labelSmallW1",
						text: " at airports and local vendors"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: "Exchangable at"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: " lowest rate"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " vs other currencies"
					}
				]
			]
		},
		currencyUnavailableSection: {
			title: [
				{
					type: "text",
					clickable: false,
					typography: "labelBaseW1",
					color: "#000000",
					text: "{{VARS_SEARCHED_CURRENCY}} is not in the market, hence we recommend you to",
					vars: {
						VARS_SEARCHED_CURRENCY: ""
					}
				},
				{
					type: "text",
					clickable: false,
					typography: "labelBaseW3",
					color: "#000000",
					text: " select {{VARS_SUGGESTED_CURRENCY}}",
					vars: {
						VARS_SUGGESTED_CURRENCY: ""
					}
				}
			],
			label: [
				{
					type: "text",
					clickable: false,
					typography: "labelSmallW1",
					color: "#4A4A4A",
					text: "Why {{VARS_SUGGESTED_CURRENCY}}?",
					vars: {
						VARS_SUGGESTED_CURRENCY: ""
					}
				}
			],
			featList: [
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Globally"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " Accepted"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: "Easily exchangable"
					},
					{
						type: "text",
						clickable: false,
						color: "#000000",
						typography: "labelSmallW1",
						text: " at airports and local vendors"
					}
				],
				[
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: "Exchangable at"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW2",
						color: "#000000",
						text: " lowest rate"
					},
					{
						type: "text",
						clickable: false,
						typography: "labelSmallW1",
						color: "#000000",
						text: " vs other currencies"
					}
				]
			]
		},
		analytics: {
			trackingKey: "bms_curSh"
		}
	},
	SPECIAL_CASHBACK_BOTTOMSHEET: {
		title: "Net Effective Cost",
		closeCta: {
			id: "CLOSE",
			type: "CLOSE",
			icon: {
				url: "https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png"
			}
		},
		taxInfo: [
			{
				type: "text",
				typography: "labelSmallW1",
				text: "",
				color: "#757575"
			}
		],
		analytics: {
			trackingKey: "bms_amtCl"
		}
	}
};
var fallbackResponsePWA = {
	success: success,
	apiData: apiData,
	headerData: headerData,
	cardData: cardData,
	bottomSheets: bottomSheets
};

/* eslint-disable no-irregular-whitespace */
const listingResponseMock = {
  success: true,
  pageConfig: {
    name: 'forex-search',
    date: 'DD-MM-YYYY',
    time: 'HH:mm',
    MSGS: {
      INVALID_PINCODE: 'Invalid pincode, please enter valid pincode'
    }
  },
  chatbot: {
    templateId: 'CHATBOT',
    nodeId: 'chatbot',
    chatUrl: 'https://myra.makemytrip.com/chat-expert?lob=FOREX&lobCategory=card&project=forex_chatbot&page=LISTING',
    scrollerAnimation: {
      text: ['Have forex doubts?', 'COD, delivery, offer', 'Ask an expert!']
    },
    tooltip: {
      text: 'Ask about rates, delivery, benefits etc. or talk to our Forex experts'
    },
    analytics: {
      pdtData: {
        event_detail: {
          event_name: 'myra_icon-shown'
        }
      }
    },
    myraIconOpenCta: {
      analytics: {
        pdtData: {
          event_detail: {
            event_name: 'myra_bot_opened'
          }
        }
      }
    },
    myraIconCloseCta: {
      analytics: {
        pdtData: {
          event_detail: {
            event_name: 'myra_bot_closed'
          }
        }
      }
    },
    showChatBot: true
  },
  apiData: {
    cardMinQtyConfig: {
      AUD: {
        order_type_code: 'B',
        currency_code: 'AUD',
        base_currency_code: 'INR',
        product_code: 'PC',
        forex_item_code: 'AUDBPC',
        min_amount: 15,
        min_denomination: 1
      }
    },
    currenciesRate: {
      AED: '22.95',
      USD: '84.06',
      RUB: '0.86',
      THB: '2.53'
    },
    pdtData: {
      upcoming_trip_details: {
        intl_travel: true,
        trip_details: [{
          dependent_lob: '',
          country_code: '',
          currency_code: '',
          start_end: '',
          end_date: '',
          no_of_travellers: 2,
          opportunity_type: ''
        }],
        itinerary_id: ''
      },
      user_details: {
        tm_uuid: '',
        partner: '',
        vendor_user_id: '',
        multi_cx_card_cust: true,
        currency_cust: false,
        travel_card_cust: false,
        is_session_id: false,
        user_type: '',
        is_pan_verified: true
      },
      delivery_details: {
        eta: 0,
        pincode: 201309,
        city: 'Noida',
        is_deliverable: '',
        is_prefetched: true,
        detection_source: '',
        location_permission_given: '',
        deliverable: true,
        city_code: '',
        locus_city_code: '',
        state: 'UP',
        state_code: 'UP',
        fallback_to_city: false,
        is_valid: true,
        is_card_deliverable: true,
        is_currency_deliverable: true,
        mode: '',
        address_is: ''
      }
    },
    couponDetails: {
      title: 'Net effective rates and cashback is applicable only after applying a valid coupon',
      couponList: [{
        type: 'SALES_COUPON',
        title: 'FOREX CASHBACK',
        description: 'Get upto INR 1000 cashback. Add Currency to know final cashback.',
        validity: 'Valid till: 10 NOv, 2023',
        offerSlabs: {
          title: 'Offer Slabs',
          slabs: [{
            minAmount: 10000,
            maxAmount: 30000,
            range: '10K - 30K',
            cashback: 75
          }, {
            minAmount: 30000,
            maxAmount: 50000,
            range: '30K - 50K',
            cashback: 300
          }]
        },
        howToApply: {
          title: 'How to Apply',
          steps: [{
            text: 'step one, two-three line of content to be finalised'
          }, {
            text: 'step one, two-three line of content to be finalised'
          }, {
            text: 'step one, two-three line of content to be finalised'
          }]
        },
        tnc: {
          title: 'Terms & Condition',
          tncs: [{
            text: 'step one, two-three line of content to be finalised'
          }, {
            text: 'step one, two-three line of content to be finalised'
          }, {
            text: 'step one, two-three line of content to be finalised'
          }]
        }
      }]
    },
    slabsData: [{
      id: 'sale_coupon_1',
      min_order_amount: 10000,
      max_order_amount: 30000,
      offer_amount: 100
    }, {
      id: 'sale_coupon_2',
      min_order_amount: 30000,
      max_order_amount: 50000,
      offer_amount: 450
    }, {
      id: 'sale_coupon_3',
      min_order_amount: 50000,
      max_order_amount: 100000,
      offer_amount: 900
    }, {
      id: 'sale_coupon_4',
      min_order_amount: 100000,
      max_order_amount: 150000,
      offer_amount: 2000
    }, {
      id: 'sale_coupon_5',
      min_order_amount: 150000,
      max_order_amount: 225000,
      offer_amount: 4000
    }, {
      id: 'sale_coupon_6',
      min_order_amount: 225000,
      max_order_amount: -1,
      offer_amount: 7500
    }],
    currencyInfo: {
      PC: {
        AED: {
          rate: 33.09832
        }
      },
      CN: {
        USD: {
          rate: 84.5608
        },
        AED: {
          rate: 34.09832
        }
      }
    }
  },
  bottomSheets: {
    // SPECIAL_CASHBACK_BOTTOMSHEET: {
    //   title: 'Special Cashback Offer for New Customers',
    //   comparePrice: [
    //     {
    //       type: 'text',
    //       color: '#000000',
    //       typography: 'mediumW3',
    //       text: '500 AED = ₹11,597',
    //     },
    //   ],
    //   netEffectiveCard: {
    //     infoItem1: {
    //       left: [
    //         {
    //           type: 'text',
    //           color: '#4a4a4a',
    //           typography: 'smallW1',
    //           text: 'Exchange rate: 1 AED:',
    //         },
    //       ],
    //       right: [
    //         {
    //           type: 'text',
    //           color: '#4a4a4a',
    //           typography: 'baseW2',
    //           text: '₹23.95*',
    //           vars: {
    //             VARS_NER_RATE: '40',
    //           },
    //         },
    //         {
    //           type: 'text',
    //           color: '#4a4a4a',
    //           typography: 'smallW1',
    //           text: ' for card only',
    //         },
    //       ],
    //     },
    //     infoItem2: {
    //       left: [
    //         {
    //           type: 'text',
    //           color: '#4a4a4a',
    //           typography: 'smallW1',
    //           text: 'Your net effective cost for after cashback will be:',
    //         },
    //       ],
    //       right: {
    //         icon: {
    //           type: 'icon',
    //           url: 'https://go-assets.ibcdn.com/u/MMT/images/1730196567070-ic_forex_star.png',
    //         },
    //         amount: {
    //           type: 'gradientText',
    //           gradient: ['#3023AE', '#C86DD7'],
    //           color: '#8A50C7',
    //           typography: 'mediumW3',
    //           text: [
    //             {
    //               type: 'text',
    //               typography: 'smallW3',
    //               text: '4378hgbbf',
    //               color: '#000',
    //             },
    //           ],
    //         },
    //       },
    //     },
    //     infoItem3: [
    //       {
    //         type: 'text',
    //         color: '#4a4a4a',
    //         typography: 'smallW1',
    //         text: 'You get a cash back of ₹43 on this purchase, which will be credited to the payment within 3-4 days of making the payment.',
    //         vars: {
    //           '{{VARS_CASHBACK}}': '',
    //         },
    //       },
    //     ],
    //     footerText: [
    //       {
    //         type: 'text',
    //         color: '#757575',
    //         typography: 'smallW1',
    //         text: 'Tax & Convenience fee not included ',
    //       },
    //     ],
    //   },
    // },
    SPECIAL_CASHBACK_BOTTOMSHEET: {
      title: 'Net Effective Cost',
      closeCta: {
        id: 'CLOSE',
        type: 'CLOSE',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png'
        }
      },
      netEffectiveCard: {
        infoItem1: {
          left: [{
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelSmallW1',
            text: 'Exchange rate of 1 {{VARS_CURRENCY_CODE}}:',
            vars: {
              VARS_CURRENCY_CODE: 'USD'
            }
          }],
          right: [{
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelBaseW2',
            text: '₹{{VARS_NER_RATE}}*',
            vars: {
              VARS_NER_RATE: '82.5047'
            }
          }, {
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelSmallW1',
            text: ''
          }]
        },
        infoItem2: {
          left: [{
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelSmallW1',
            text: 'Net effective price after cashback:'
          }],
          right: {
            icon: {
              type: 'icon',
              url: 'https://go-assets.ibcdn.com/u/MMT/images/1730196567070-ic_forex_star.png'
            },
            amount: {
              type: 'gradientText',
              gradient: ['#3023AE', '#C86DD7'],
              color: '#8A50C7',
              typography: 'labelMediumW3',
              text: [{
                type: 'text',
                typography: 'labelSmallW3',
                text: '₹{{VARS_NER}}',
                color: '#4a4a4a',
                vars: {
                  VARS_NER: ''
                }
              }]
            }
          }
        },
        infoItem3: [{
          type: 'text',
          color: '#4a4a4a',
          typography: 'labelSmallW1',
          text: 'Cashback of ₹{{VARS_CASHBACK}} will be credited to myCash wallet on delivery of your forex. Validity 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.',
          vars: {
            VARS_CASHBACK: ''
          }
        }]
      },
      taxInfo: [{
        type: 'text',
        typography: 'labelSmallW1',
        text: '',
        color: '#757575'
      }],
      analytics: {
        trackingKey: 'bms_amtCl'
      }
    },
    COUPON_DETAIL_FOREX_SALE_1_BOTTOMSHEET: {
      title: 'Coupon Details',
      label: [{
        type: 'text',
        clickable: false,
        color: '#4A4A4A',
        typography: 'smallW1',
        text: 'Net effective rates and cashback is applicable only after '
      }, {
        type: 'text',
        clickable: false,
        color: '#4A4A4A',
        typography: 'smallW2',
        text: 'applying a valid coupon'
      }],
      couponList: [{
        title: 'Forex sale',
        type: 'FOREX_SALE',
        subLabel: 'Not valid for new user',
        label: [{
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'baseW1',
          text: 'Get upto '
        }, {
          type: 'text',
          clickable: false,
          color: '#007E7D',
          typography: 'baseW3',
          text: 'INR 111 s'
        }, {
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'baseW1',
          text: 'cashback. Add Currency to know final cashback.'
        }]
      }, {
        title: 'Forex sale 2',
        type: 'FOREX_SALE',
        subLabel: 'Not valid for new user',
        label: [{
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'baseW1',
          text: 'Get upto '
        }, {
          type: 'text',
          clickable: false,
          color: '#007E7D',
          typography: 'baseW3',
          text: 'INR 222 s'
        }, {
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'baseW1',
          text: 'cashback. Add Currency to know final cashback.'
        }]
      }],
      howToApply: {
        title: 'How to Apply',
        list: ['step one, two-three line of content to be finalised', 'step one, two-three line of content to be finalised', 'step one, two-three line of content to be finalised']
      },
      tnc: {
        title: 'Terms & Condition',
        list: ['step one, two-three line of content to be finalised', 'step one, two-three line of content to be finalised', 'step one, two-three line of content to be finalised']
      },
      offerSlabs: {
        title: 'Offer slabs - forex sale',
        offerList: [{
          id: 1,
          title: 'Quantity Required - mmt sale',
          list: ['Less than 50k']
        }, {
          id: 2,
          title: 'Cashback - mmt sale',
          list: ['INR 100']
        }]
      }
    },
    PINCODE_BOTTOMSHEET: {
      title: 'Edit Location',
      subtitle: 'Enter Pin-code for Card Delivery Location',
      inputPlaceholder: 'PINCODE',
      cta: {
        id: 'DETECT_LOCATION_CTA',
        type: 'handler',
        text: 'Detect Location',
        icon: {
          type: 'static',
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/location_Detector_3549762278.png'
        }
      },
      loader: {
        title: 'Fetching Location',
        loaderColor: '#008CFF',
        description: 'Locating Card Delivery Area...'
      },
      cityFallback: {
        title: 'Select Delivery Cities',
        subTitle: 'We are currently delivering to below cities in India',
        showCities: 4
      }
    },
    CURRENCY_SEARCH_BOTTOMSHEET: {
      title: 'Select Currency',
      allCurrencyHeader: 'All Currencies',
      popularCurrencyHeader: 'Popular Currencies',
      suggestionSection: {
        title: [{
          type: 'text',
          clickable: false,
          typography: 'smallW1',
          text: "Can't find what you are looking for? We suggest to add"
        }, {
          type: 'text',
          clickable: false,
          typography: 'smallW1',
          color: '#000',
          text: ' {{VARS_SUGGESTED_CURRENCY}}',
          vars: {
            VARS_SUGGESTED_CURRENCY: 'USD'
          }
        }],
        label: [{
          type: 'text',
          clickable: false,
          typography: 'smallW1',
          color: '#4A4A4A',
          text: 'Why {{VARS_SUGGESTED_CURRENCY}}?',
          vars: {
            VARS_SUGGESTED_CURRENCY: 'AED'
          }
        }],
        featList: [[{
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          color: '#000',
          text: 'Globally'
        }, {
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'Accepted'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          color: '#000',
          text: 'Easily exchangable'
        }, {
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'at airports and local vendors'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'Exchangable at'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000',
          text: 'lowest rate'
        }, {
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'vs other currencies'
        }]]
      },
      currencyUnavailableSection: {
        title: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          text: '{{VARS_SEARCHED_CURRENCY}} is not in the market, hence we recommend you to',
          vars: {
            VARS_SEARCHED_CURRENCY: 'USD-Suggested'
          }
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#FFFFFF',
          text: 'select {{VARS_SUGGESTED_CURRENCY}}',
          vars: {
            VARS_SUGGESTED_CURRENCY: ''
          }
        }],
        label: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#4A4A4A',
          text: 'Why {{VARS_SUGGESTED_CURRENCY}}?',
          vars: {
            VARS_SUGGESTED_CURRENCY: 'USD-Test'
          }
        }],
        featList: [[{
          type: 'text',
          clickable: false,
          typography: 'baseW2',
          color: '#000',
          text: 'Globally'
        }, {
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'Accepted'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          color: '#000',
          text: 'Easily exchangable'
        }, {
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'at airports and local vendors'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'Exchangable at'
        }, {
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          color: '#000',
          text: 'lowest rate'
        }, {
          type: 'text',
          clickable: false,
          typography: 'baseW1',
          text: 'vs other currencies'
        }]]
      }
    },
    COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET: {
      title: 'Coupon Details',
      couponList: [{
        title: 'UPTO INR 7500 CASHBACK',
        type: 'FOREX_SALE',
        subLabel: [{
          type: 'text',
          text: 'LIMITED TIME OFFER',
          typography: 'labelSmallW1',
          color: '#757575'
        }],
        bookingId: 'FOREXCASHBACK',
        label: [{
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'labelSmallW1',
          text: 'Get upto '
        }, {
          type: 'text',
          clickable: false,
          color: '#007E7D',
          typography: 'labelSmallW3',
          text: 'INR 7500 '
        }, {
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'labelSmallW1',
          text: 'cashback in your myCash wallet on delivery of your forex. Validity: 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.'
        }]
      }, {
        title: 'UPTO INR 22227500 CASHBACK',
        type: 'FOREX_SALE',
        subLabel: [{
          type: 'text',
          text: 'test LIMITED TIME OFFER',
          typography: 'labelSmallW1',
          color: '#757575'
        }],
        bookingId: 'FOREXCASHBACK',
        label: [{
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'labelSmallW1',
          text: 'Get upto '
        }, {
          type: 'text',
          clickable: false,
          color: '#007E7D',
          typography: 'labelSmallW3',
          text: 'INR 7500 '
        }, {
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'labelSmallW1',
          text: 'cashback in your myCash wallet on delivery of your forex. Validity: 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.'
        }]
      }],
      tnc: {
        title: 'Terms & Condition',
        list: ['Offer is valid from 2nd Dec to 31st December 2024.', 'Cashback is applicable on order values exceeding INR 10,000.', 'Offer is applicable on forex card and currency orders only. Offer is not applicable on card reload or unload orders.', 'Cashback will only be processed if the offer is applied by the user while ordering.', 'The Customer, upon successful completion of their transaction for ordering a forex card or currency, shall receive the cashback amount in the wallet as per the slabs, after delivery (and activation in the case of a card) by BookMyForex.', "myCash credited will be valid for 1 year from when it has been credited into the user's account.", "Cashback can only be credited to the wallet of the customer who purchased the Forex card or currency notes as per the terms of the offer and not to any third party's account.", 'If the Customer cancels the order of the Forex card or currency, the Customer shall not be eligible to receive the cashback under the Offer and the terms of cancellation as provided on the BookMyForex platform shall be applicable.', [{
          type: 'text',
          text: 'To know more about Wallet usage Terms and conditions, \n visit https://www.makemytrip.com/mywallet/',
          color: '#4A4A4A',
          typography: 'labelSmallW1'
        }], 'Lowest Exchange Rate Guarantee : Get 2x the Price Difference in case you find a better price online.', 'Offer applies to the net effective price (i.e., the price paid after adjusting any applicable cashback) paid by the Customer for placing the Forex Product order.', 'The Offer is valid only for the same product, currency and amount for the same city or location.', 'After purchasing the Forex Product, if you find a lower price for the same product on the website or app of any other authorized money changer, the Customer may raise a claim request via sending an email to ForexClaims@go-mmt.com.', 'The claim must be submitted by the Customer using their registered email ID or phone number with relevant proofs.']
      },
      offerSlabs: {
        title: [{
          type: 'text',
          clickable: false,
          color: '#757575',
          typography: 'labelSmallW2',
          text: 'Cashback Slabs'
        }],
        offerList: [{
          id: 1,
          title: 'Slabs (in INR)',
          list: ['10k - 30k', '30k - 50k', '50k - 1 Lakh', '1 Lakh - 1.5 Lakh', '1.5 Lakh - 2.25 Lakh', 'More than 2.25 Lakh']
        }, {
          id: 2,
          title: 'Cashback (INR)',
          list: ['INR 100', 'INR 450', 'INR 900', 'INR 2,000', 'INR 4,000', 'INR 7,500']
        }]
      }
    },
    CURRENCY_AMOUNT_BOTTOMSHEET: {},
    CC_COMPARISON_BOTTOMSHEET: {
      title: 'Save on Forex',
      banner: {
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1730712464633-glitter.png',
          type: 'static/gif/lottie'
        },
        title: [{
          type: 'text',
          clickable: false,
          typography: 'smallW2',
          text: 'Save INR {{VARS_SAVINGS}}',
          vars: {
            VARS_SAVINGS: '5500'
          }
        }, {
          type: 'text',
          clickable: false,
          typography: 'smallW1',
          text: 'on load of {{VARS_CURRENCY_AMT}} NZD',
          vars: {
            VARS_CURRENCY_AMT: '1000'
          }
        }]
      },
      currencyCard: {
        title: 'Our multicurrency forex card',
        icon: 'https://tripmoneycmsimgak.mmtcdn.com/img/bmf_transaprent_2_2x_10d9e723a5.png',
        conversionInfo: {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'baseW1',
            text: '{{VARS_CURRENCY_AMT}} NZD = :',
            vars: {
              VARS_CURRENCY_AMT: '1000'
            }
          }, {
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: ' ₹ {{VARS_INR_VALUE}}',
            vars: {
              VARS_INR_VALUE: '15000'
            }
          }],
          subtext: [{
            type: 'text',
            clickable: false,
            color: '#007E7D',
            typography: 'baseW1',
            text: 'Inc all tax'
          }],
          markup: [{
            type: 'text',
            clickable: false,
            color: '#007E7D',
            typography: 'baseW2',
            text: 'No Forex Markup'
          }],
          borderColor: '#007E7D',
          bgColor: ['#CEF1EB', '#FFFFFF']
        },
        bulletColor: '#007E7D',
        featureList: [{
          text: [{
            type: 'text',
            clickable: false,
            typography: 'baseW1',
            text: 'No impact on '
          }, {
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: 'Cibil score'
          }]
        }, {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: 'Widely '
          }, {
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: 'Accepted'
          }]
        }]
      },
      comparison: {
        imageUrl: 'https://go-assets.ibcdn.com/u/MMT/images/1730711044843-vsimg.png'
      },
      creditCard: {
        title: 'HDFC multicurrency forex card',
        icon: 'https://tripmoneycmsimgak.mmtcdn.com/img/bmf_transaprent_2_2x_10d9e723a5.png',
        conversionInfo: {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'baseW1',
            text: '{{VARS_CURRENCY_AMT}} NZD = :',
            vars: {
              VARS_CURRENCY_AMT: '1000'
            }
          }, {
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: ' ₹ {{VARS_COST}}',
            vars: {
              VARS_COST: '10000'
            }
          }],
          subtext: [{
            type: 'text',
            clickable: false,
            color: '#EC2127',
            typography: 'baseW1',
            text: 'Inc all tax'
          }],
          markup: [{
            type: 'text',
            clickable: false,
            color: '#EC2127',
            typography: 'baseW2',
            text: '{{VARS_MARKUP}} Forex Markup',
            vars: {
              VARS_MARKUP: '3.5'
            }
          }],
          borderColor: '#D8D8D8',
          bgColor: ['#F6F6F6', '#F6F6F6']
        },
        bulletColor: '#EC2127',
        featureList: [{
          text: [{
            type: 'text',
            clickable: false,
            typography: 'baseW1',
            text: 'High impact on '
          }, {
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: 'Cibil score'
          }]
        }, {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: 'Widely not '
          }, {
            type: 'text',
            clickable: false,
            typography: 'baseW2',
            text: 'Accepted'
          }]
        }]
      },
      cta: {
        id: 'buymulticccard',
        type: 'Deeplink/Modal',
        text: 'BUY MULTICURRENCY CARD',
        deeplink: 'mmyt://webUrl=https://goToOrder.com'
      },
      markup: 3.5
    }
  },
  chatFloatingButton: {
    templateId: 'CHAT_FLOATING_BUTTON',
    nodeId: 'chat-floating-button',
    analytics: {},
    data: {
      icon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158036400-offer_icon.png',
        type: 'static'
      },
      cta: {
        id: 'CHAT_BUTTON',
        type: 'handler',
        text: 'TALK TO US'
      }
    }
  },
  dashboardDiscovery: {
    templateId: 'DASHBOARD_DISCOVERY',
    nodeId: 'dashboard-discovery',
    analytics: {},
    data: {
      title: 'Manage your multy currecny card',
      subtitle: 'Quickly load currencues',
      cta: {
        id: 'DASHBOARD_DISCOVERY_BUTTON',
        type: 'handler',
        text: 'OK, GOT IT Now'
      }
    }
  },
  headerData: {
    bgColors: ['#FFFFFF', '#FFFFFF'],
    nodeId: 'header-section',
    title: 'Forex Card & Currency',
    bgImg: '',
    navActions: [{
      icon: {
        type: 'static',
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png'
      },
      cta: {
        id: 'MY_ORDERS',
        type: 'handler',
        text: 'Orders (nullable)',
        url: 'mmyt://webUrl=https://goToOrder.com',
        nodeId: 'header-my-orders',
        analytics: {}
      }
    }]
  },
  cardData: [
  // {
  //   templateId: 'BEST_RATES',
  //   nodeId: 'best-rates',
  //   analytics: {},
  //   data: {
  //     title: 'Best LIVE Rates',
  //     toolTip: {
  //       icon: {
  //         type: 'static',
  //         url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png',
  //       },
  //       text: 'The rates are updated every 10 minutes. The rates are indicative and may vary as per the market conditions',
  //     },
  //     currencies: [
  //       {
  //         name: 'UAE Dirham',
  //         price: '₹ 22.95*',
  //       },
  //       {
  //         name: 'US Dollar',
  //         price: '₹ 84.06*',
  //       },
  //       {
  //         name: 'Russian Ruble',
  //         price: '₹ 0.86*',
  //       },
  //       {
  //         name: 'Thai Bath',
  //         price: '₹ 2.53*',
  //       },
  //     ],
  //   },
  // },
  // {
  //   templateId: 'INSTANT_LOAD_NUDGE',
  //   nodeId: 'instant-load-nudge',
  //   analytics: {},
  //   data: {
  //     title: 'Load instantly for your trip to Dubai',
  //     subText1: 'No documents required',
  //     subText2: 'Load within 30 minutes',
  //     bgColors: ['#FFFFFF', '#FFFFFF'],
  //     icon: {
  //       url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158036400-offer_icon.png',
  //       type: 'static/gif/lottie',
  //     },
  //     cta: {
  //       id: 'ARROW_BUTTON',
  //       type: 'navigate',
  //       deeplink: 'mmyt://webUrl=https://goToOrder.com',
  //     },
  //   },
  // },
  // {
  //   templateId: 'ORDER_STATUS_SCROLLER',
  //   nodeId: 'order-status-scroller',
  //   analytics: {},
  //   data: {
  //     seperator: 'CREATE A NEW ORDER BELOW',
  //     orders: [
  //       {
  //         title: 'Delivery Status Unavialable',
  //         subtitle: 'Please ignore if card is already delivered',
  //         subText1: 'Currency: 2500 AED, 100 USD',
  //         subText2: 'Destination: Dubai, Florida',
  //         bgColors: ['#FFFFFF', '#FFFFFF'],
  //         cta: {
  //           id: 'ARROW_CTA',
  //           type: 'navigate',
  //           deeplink: 'mmyt://webUrl=https://goToOrder.com',
  //         },
  //       },
  //       {
  //         title: 'Currency',
  //         subtitle: 'Please ignore if card is already delivered',
  //         subText1: 'Currency: 2500 AED, 100 USD',
  //         subText2: 'Destination: Dubai, Florida',
  //         bottomText:
  //           'Expected delivery by Today, 9 PM in 560103, Vishakhapatnam',
  //         bgColors: ['#FFFFFF', '#FFFFFF'],
  //         cta: {
  //           id: 'BUTTON_CTA',
  //           type: 'navigate',
  //           deeplink: 'mmyt://webUrl=https://goToOrder.com',
  //           text: 'UPLOAD',
  //         },
  //       },
  //     ],
  //   },
  // },
  {
    templateId: 'RATE_TICKER_DT',
    nodeId: 'rate-ticker-dt',
    analytics: {
      abKeys: 'testKey123',
      omniture: {
        first: 'omnitureKey1',
        second: 'omnitureKey2'
      },
      trackingKey: 'trackKey456',
      cardVariantId: 'variant789',
      lob: 'forex',
      hydraUserSegments: 'premium_user'
    },
    data: {
      ticker: [{
        name: 'UAE Dirham',
        price: '₹ 22.95*',
        banner: {
          text: 'UPCOMING TRIP',
          textColor: '#007E7D',
          nodeId: 'rate-ticker-upcoming-trip',
          bgColors: ['#D5FCEE', '#FFFFFF']
        },
        label: {
          text: 'lowest in 2 days',
          nodeId: 'rate-ticker-label'
        }
      }, {
        name: 'US Dollar',
        price: '₹ 84.06*'
      }, {
        name: 'Russian Ruble',
        price: '₹ 0.86*'
      }, {
        name: 'Thai Bath',
        price: '₹ 2.53*'
      }],
      bannerImg: {
        nodeId: 'currency-rates-ticker-offer-image',
        url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Group_1321318082_261626f0ca.png'
      },
      toolTip: {
        text: [{
          type: 'text',
          color: '#fff',
          typography: 'baseW1',
          text: 'Rates are dynamic in nature, Refreshes in every 14 sec'
        }]
      }
    },
    navActions: {
      title: 'Forex Orders',
      subTitle: 'ongoing Orders 2',
      icon: {
        type: 'static',
        url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Shape_c0ca55736f.png'
      },
      previousOrders: {
        icon: {
          type: 'static',
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Shape_c0ca55736f.png'
        },
        cta: {
          id: 'PREVIOUS_ORDERS',
          type: 'navigate',
          text: 'Previous Orders',
          url: 'https://goToOrder.com',
          nodeId: 'header-my-orders',
          analytics: {}
        }
      },
      ongoingOrders: [
      // {
      //   icon: {
      //     type: 'static',
      //     url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Shape_c0ca55736f.png',
      //   },
      //   cta: {
      //     id: 'MY_ORDERS',
      //     type: 'handler',
      //     text: 'Foreign Currency Notes ',
      //     subText: '200 USD, 1000 THB, 500 AED',
      //     statusText: 'Delivery by Mon, 7th November',
      //     status: 'Document Upload Pending',
      //     url: 'https://goToOrder.com',
      //     nodeId: 'header-my-orders',
      //     analytics: {},
      //   },
      // },
      {
        cta: {
          id: 'MY_ORDERS',
          type: 'handler',
          url: 'https://goToOrder.com',
          nodeId: 'header-my-orders',
          analytics: {}
        },
        icon: {
          url: "https://tripmoneycmsimgak.mmtcdn.com/img/Shape_c0ca55736f.png'",
          type: 'static'
        },
        text: 'Forex Currency Notes',
        subText: '200 USD',
        statusText: 'Delivery by Mon, 7th November',
        status: 'Document Upload Pending'
      }]
    }
  }, {
    templateId: 'OFFER_PERSUASION',
    nodeId: 'offer-persuasion',
    analytics: {},
    data: {
      icon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158036400-offer_icon.png',
        type: 'static'
      },
      title: '₹10,900* Net effective cost after cashback',
      subtitle: 'Order Card @ ₹0',
      info: {
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png',
          type: 'static/gif/lottie'
        },
        cta: {
          id: 'COUPON_BOTTOMSHEET',
          type: 'handler',
          deeplink: 'mmyt://webUrl=https://goToOrder.com'
        }
      }
    }
  }, {
    templateId: 'PRICING_NUDGE',
    data: {
      leftIcon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1734609871161-ic_trending.png',
        type: 'static'
      },
      bgColors: ['#D3E7FF', '#FFFFFF'],
      borderColor: '#CCE8FF',
      text: [{
        type: 'text',
        typography: 'labelSmallW1',
        text: 'weekend/Diwali/Christmas rates are usually higher. Order your forex now. ',
        color: '#4A4A4A'
      }],
      info: {
        analytics: {
          trackingKey: 'st_pn_close'
        },
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png'
        },
        cta: {
          id: 'sticky_pricing_bottom_sheet',
          type: 'modal',
          modalId: 'STICKY_PRICING_NUDGE_BOTTOMSHEET'
        }
      },
      analytics: {
        trackingKey: 'st_pn_show'
      }
    }
  }, {
    templateId: 'CURRENCY_PRODUCT_SELECTION',
    nodeId: 'currency-product-selection',
    analytics: {},
    data: {
      deliverAtSelection: {
        default: 'Banglore',
        title: 'Deliver AT',
        placeholder: 'Select Currency',
        cta: {
          id: 'DELIVER_SELECTION_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-selection-bottomsheet'
        },
        bottomBanner: {
          title: 'For your trip to Dubai'
        },
        bottomText: '561013'
      },
      currencySelection: {
        default: 'AED',
        title: 'CURRENCY',
        placeholder: 'Select Currency',
        cta: {
          id: 'CURRENCY_SELECTION_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-selection-bottomsheet'
        },
        bottomBanner: {
          title: 'For your trip to Dubai'
        },
        bottomText: 'AED'
      },
      amountSelectionForex: {
        disabled: false,
        //NEW
        defaultCurrency: 'AED',
        title: 'FOREX AMOUNT',
        hint: 'Enter Amount',
        toolTip: {
          text: [{
            type: 'text',
            color: '#fff',
            typography: 'baseW1',
            text: 'Travellers usually carry'
          }, {
            type: 'text',
            color: '#fff',
            clickable: true,
            typography: 'baseW3',
            text: 'AED 1000',
            vars: {
              VARS_CURRENCY_CODE: 'USD',
              VARS_RECOMMENDED_AMOUNT: '1000'
            }
          }, {
            type: 'text',
            color: '#fff',
            typography: 'baseW1',
            text: ' or more for a hassle free trip'
          }]
        },
        cta: {
          id: 'CURRENCY_AMOUNT_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-amount-bottomsheet'
        }
      },
      amountSelectionInr: {
        disabled: false,
        // NEW
        defaultCurrency: 'INR',
        title: 'INR AMOUNT',
        hint: 'Enter Amount',
        cta: {
          id: 'CURRENCY_AMOUNT_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-amount-bottomsheet'
        },
        bottomBanner: {
          title: [{
            type: 'text',
            typography: 'labelSmallW1',
            text: 'Net effective price after cashback',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: '₹{{VARS_NER_AMOUNT}}   ',
            color: '#8A50C7',
            typography: 'labelBaseW3',
            vars: {
              VARS_NER_AMOUNT: ''
            }
          }],
          info: {
            icon: {
              url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png',
              type: 'static/gif/lottie'
            },
            cta: {
              id: 'COUPON_BOTTOMSHEET',
              type: 'handler',
              nodeId: 'listing-coupon-bottomsheet'
            }
          },
          bgColors: ['#FFFFFF', '#FFFFFF']
        }
      },
      productSelection: {
        title: 'CARD/CURRENCY',
        hint: 'Select',
        bottomText: 'Multi Currency Card / Foreign Currency Notes'
      },
      productItems: [{
        disabled: true,
        productType: 'PC',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1730788343204-ic_forex_card.png',
          type: 'static/gif/lottie'
        },
        currency: {
          AED: {
            selectedSubtextNode: 'subtext2',
            //new
            disabled: true,
            title: [{
              type: 'text',
              color: '#000000',
              typography: 'smallW2',
              text: 'Multi Currency Forex Card'
            }],
            subtitle: [{
              type: 'text',
              color: '#4a4a4a',
              typography: 'baseW1',
              text: 'Lifetime Free, Zero Markup'
            }],
            subtext1: [{
              type: 'text',
              color: '#007E7D',
              typography: 'baseW3',
              text: 'Order @₹0'
            }],
            subtext2: [{
              type: 'text',
              typography: 'labelSmallW1',
              text: '{{VARS_QTY}} {{VARS_CURRENCY_CODE}} {{VARS_OPERATOR}} ₹{{VARS_NER_RATE}}*',
              color: '#4A4A4A',
              vars: {
                VARS_OPERATOR: 'upto',
                VARS_QTY: '1',
                VARS_CURRENCY_CODE: 'AUD',
                VARS_NER_RATE: '52.5173'
              }
            }],
            rate: 54.3283,
            recommendedQty: 1000,
            bottomText: 'Unavailable! Try different location Pincode',
            minimumQuantityWarning: [{
              type: 'text',
              typography: 'labelSmallW1',
              text: 'Minimum 10 USD Required',
              color: '#CF8100'
            }]
          },
          USD: {
            selectedSubtextNode: 'subtext2',
            disabled: false,
            title: 'Multi Currency Card',
            subTitle: 'Lifetime Free, Zero Markup',
            subtext1: 'Order @₹0',
            subtext2: "Card doesn't support VND",
            bottomText: [{
              type: 'text',
              typography: 'labelSmallW1',
              text: 'You may ',
              color: '#4A4A4A'
            }, {
              type: 'text',
              clickable: true,
              typography: 'labelSmallW1',
              text: 'choose USD',
              vars: {},
              color: '#008CFF',
              underline: true,
              actionType: 'dispatch',
              dispatchArgs: {
                type: 'SET_CURRENCY',
                data: {
                  currency: 'USD'
                }
              }
            }, {
              type: 'text',
              typography: 'labelSmallW1',
              text: ' to proceed.',
              color: '#4A4A4A'
            }],
            // bottomText: 'You may choose USD to proceed',
            rate: 54.3283,
            recommendedQty: 1000,
            minimumQuantityWarning: [{
              type: 'text',
              typography: 'labelSmallW1',
              text: 'Minimum 10 USD Required',
              color: '#CF8100'
            }]
          }
        },
        cta: {
          id: 'PC_BUY_NOW',
          disabled: false,
          text: 'Buy Now-PC',
          type: 'navigate',
          deeplink: 'mmyt://lending?cta=webview&ctaurl=https%3A%2F%2Ftripmoney.makemytrip.com%2Fpartners%2Fmmt%2Fforex%2Fbmf%2Fonboarding%2Fload-currency%3FselectedCurr%3DUSD%26currQty%3D{{VARS_CURR_QTY}}%26utm_source%3Dbottom_bar_new_secondaryicon%26utm_medium%3Dmmtapp%26cmp%3Dtm_card_bottombar_new%26rn%3Dtrue&minver=1&mmtauthkey=mmt-auth&showHeader=false&login_required=false'
        }
      }, {
        disabled: false,
        productType: 'CN',
        title: 'Forex Currency Notes',
        subTitle: 'RBI approved notes',
        subtext1: [{
          type: 'text',
          typography: 'labelSmallW1',
          text: '{{VARS_QTY}} {{VARS_CURRENCY_CODE}} {{VARS_OPERATOR}} ₹{{VARS_NER_RATE}}*',
          color: '#4A4A4A',
          vars: {
            VARS_OPERATOR: 'upto',
            VARS_QTY: '1',
            VARS_CURRENCY_CODE: 'AUD',
            VARS_NER_RATE: '52.5173'
          }
        }],
        // subtext2: '1 AED upto ₹22.96*',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1730788198734-ic_forex_funnel.png',
          type: 'static/gif/lottie'
        },
        cta: {
          disabled: true,
          id: 'CN_BUY_NOW',
          text: 'Buy Now-CN',
          type: 'navigate',
          deeplink: 'mmyt://lending?cta=webview&ctaurl=https%3A%2F%2Ftripmoney.makemytrip.com%2Fpartners%2Fmmt%2Fforex%2Fbmf%2Fcurrency%2Fonboarding%2Fload-currency%3FselectedCurr%3DUSD%26currQty%3D{{VARS_CURR_QTY}}%26utm_source%3Dbottom_bar_new_secondaryicon%26utm_medium%3Dmmtapp%26cmp%3Dtm_card_bottombar_new%26rn%3Dtrue&minver=1&mmtauthkey=mmt-auth&showHeader=false&login_required=false'
        },
        currency: {
          AED: {
            disabled: false,
            title: 'Forex Currency Notes',
            subTitle: 'RBI approved notes',
            subtext1: [{
              type: 'text',
              typography: 'labelSmallW1',
              text: '{{VARS_QTY}} {{VARS_CURRENCY_CODE}} {{VARS_OPERATOR}} ₹{{VARS_NER_RATE}}*',
              color: '#4A4A4A',
              vars: {
                VARS_OPERATOR: 'upto',
                VARS_QTY: '1',
                VARS_CURRENCY_CODE: 'AUD',
                VARS_NER_RATE: '52.5173'
              }
            }]
          },
          USD: {
            disabled: false,
            title: 'Forex Currency Notes',
            subTitle: 'RBI approved notes',
            bottomText: 'Unavailable! Try different location Pincode'
          }
        }
      }],
      cta: {
        isDisabled: false,
        id: 'BUY_NOW_BTN',
        text: 'Buy Now',
        type: 'navigate',
        deeplink: 'mmyt://lending?cta=webview&ctaurl=https%3A%2F%2Ftripmoney.makemytrip.com%2Fpartners%2Fmmt%2Fforex%2Fbmf%2Fonboarding%2Fload-currency%3FselectedCurr%3DUSD%26currQty%3D{{VARS_CURR_QTY}}%26utm_source%3Dbottom_bar_new_secondaryicon%26utm_medium%3Dmmtapp%26cmp%3Dtm_card_bottombar_new%26rn%3Dtrue&minver=1&mmtauthkey=mmt-auth&showHeader=false&login_required=false'
      }
    }
  }, {
    templateId: 'DELIVERY_PERSUASION',
    nodeId: 'delivery-persuasion',
    analytics: {},
    data: {
      icon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158036400-offer_icon.png',
        type: 'static/gif/lottie'
      },
      title: 'Delivery by Today, 9 PM in 560103, Vishakhapatnam,',
      subtitle: 'order by 01:00 PM',
      cta: {
        id: 'PINCODE_BOTTOMSHEET',
        type: 'handler'
      },
      toolTip: {
        icon: {
          type: 'static',
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png'
        },
        text: 'For forex orders placed before 1 PM on a working day, delivery is scheduled on the same day. In all other instances, delivery will be attempted on the next working day'
      }
    }
  }, {
    templateId: 'DELIVERY_ASSISTANCE_BANNER',
    data: {
      title: [{
        type: 'text',
        clickable: false,
        color: '#757575',
        typography: 'labelSmallW1',
        text: 'Order now and get a dedicated contact number to track your delivery.'
      }],
      icon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1733902636965-delivery-headset.png'
      },
      bgColors: ['#E0F0FF', '#FFFFFF']
    }
  }, {
    templateId: 'STATIC_TITLE_SUBTITLE',
    nodeId: 'powered-by',
    data: {
      title: 'Powered By',
      icon: {
        type: 'static',
        url: 'https://tripmoneycmsimgak.mmtcdn.com/img/bmf_white_logo_5428e8a416.png'
      },
      text: 'License number : FE.DEL.FFMC/ U070/2013',
      cta: {}
    }
  }, {
    templateId: 'CENTER_WIDGET_DT',
    nodeId: 'center-widget-dt',
    analytics: {},
    data: {
      title: 'Your Multi Currency Card',
      subtitle: 'Manage & Re-Load Card',
      cardNumber: '**1234',
      icon: {
        url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Group_1321318095_2x_a46e8501c0.png',
        type: 'static/gif/lottie'
      },
      cta: {
        id: 'DASHBOARD',
        type: 'navigate',
        text: 'Dashboard',
        url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Shape_c0ca55736f.png'
      }
    }
  }, {
    templateId: 'SCROLLABLE_INFO_ITEMS',
    nodeId: 'resume-order',
    data: {
      title: 'Resume Order:',
      orderItems: [{
        title: 'Forex Card',
        subtext1: 'Currency: 2500 AED',
        subtext2: 'Destination: Dubia, Florida'
      }, {
        title: 'Currency Notes',
        subtext1: 'Currency: 2500 AED, 100 USD',
        subtext2: 'Destination: Dubia, Florida'
      }]
    }
  }, {
    templateId: 'ORDER_STATUS_SCROLLER_DESKTOP',
    nodeId: 'order-status-scroller_desktop',
    analytics: {},
    data: {
      heading: 'Action pending of 2 orders',
      icon: {
        type: 'static',
        url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Page_1_251c2744de.png'
      },
      orders: [{
        title: 'Upload documents by 4th Jan to initiate delivery',
        subtitle: 'Foreign Currency Notes:200 USD, 1000 THB',
        icon: {
          type: 'static',
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Forward_i_OS_f77360c5fc.png'
        }
      }, {
        title: 'Upload documents by 4th Jan to initiate delivery',
        subtitle: 'Foreign Currency Notes:200 USD, 1000 THB',
        icon: {
          type: 'static',
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Forward_i_OS_f77360c5fc.png'
        }
      }]
    }
  },
  // {
  //   templateId: 'FREE_DELIVERY',
  //   nodeId: 'free-delivery',
  //   data: {
  //     title: 'Order Card @ ₹0',
  //     subtitle: '',
  //     infoItems: [
  //       {
  //         text: 'Assured Cashback',
  //       },
  //       {
  //         text: 'Free Same day Delivery',
  //       },
  //     ],
  //   },
  // },
  {
    templateId: 'CC_COMPARISON',
    nodeId: 'cc-comparison',
    data: {
      title: 'Save More with Multi Currency Card',
      currencyCard: {
        title: 'Our Multi Currency Card',
        infoItems: [{
          text: 'No Forex Mark up'
        }, {
          text: '1% off every txn'
        }]
      },
      creditCard: {
        title: 'Your HDFC Credit Card',
        infoItems: [{
          text: '3.5% Forex Mark up'
        }, {
          text: 'No Cashback'
        }]
      },
      comparison: {
        text: 'VS'
      },
      bottomBanner: {
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158036400-offer_icon.png',
          type: 'static/gif/lottie'
        },
        // "title": "Save 5500 on load of 1000 AED know more",
        title: [{
          type: 'text',
          text: 'Save 5500',
          typography: 'largeW2',
          color: '#000'
        }, {
          type: 'text',
          text: 'on load of 1000 AED',
          typography: 'largeW1',
          color: '#000'
        }, {
          type: 'text',
          text: 'know more',
          typography: 'largeW1',
          color: '#008cff',
          clickable: true
        }],
        bgColors: ['#FFFFFF', '#FFFFFF']
      }
    }
  }, {
    templateId: 'AUTO_SCROLL_CAROUSEL',
    nodeId: 'offers-carousel',
    data: {
      title: 'Offers',
      icon: {
        type: 'static',
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png'
      },
      items: [{
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1730107923887-percent.png'
        },
        bottomText: 'T&C Apply',
        description: 'For new to forex users, cashback will be credited to your myCash wallet on delivery of your forex. Validity: 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.',
        subtitle: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW3',
          text: 'UPTO INR 7500 CASHBACK',
          color: '#000000'
        }],
        title: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW1',
          text: 'FOREX CARD & CURRENCY',
          color: '#4A4A4A'
        }],
        info: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          text: 'Know more',
          color: '#008CFF',
          actionType: 'modal',
          modalId: 'COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET'
        }],
        cta: {
          type: 'handler',
          modalId: 'COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET'
        }
      }, {
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1730107923887-percent.png'
        },
        bottomText: 'T&C Apply',
        description: 'For new to forex users, cashback will be credited to your myCash wallet on delivery of your forex. Validity: 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.',
        subtitle: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW3',
          text: 'UPTO INR 7500 CASHBACK',
          color: '#000000'
        }],
        title: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW1',
          text: 'FOREX CARD & CURRENCY',
          color: '#4A4A4A'
        }],
        info: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          text: 'Know more',
          color: '#008CFF',
          actionType: 'modal',
          modalId: 'COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET'
        }],
        cta: {
          type: 'handler',
          modalId: 'COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET'
        }
      }, {
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1730107923887-percent.png'
        },
        bottomText: 'T&C Apply',
        description: 'For new to forex users, cashback will be credited to your myCash wallet on delivery of your forex. Validity: 1 year. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.',
        subtitle: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW3',
          text: 'UPTO INR 7500 CASHBACK',
          color: '#000000'
        }],
        title: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW1',
          text: 'FOREX CARD & CURRENCY',
          color: '#4A4A4A'
        }],
        info: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          text: 'Know more',
          color: '#008CFF',
          actionType: 'modal',
          modalId: 'COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET'
        }],
        cta: {
          type: 'handler',
          modalId: 'COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET'
        }
      }]
    }
  }, {
    templateId: 'PAGER_1',
    nodeId: 'marketing-banners',
    analytics: {
      trackingKey: 'mkr_bns'
    },
    data: {
      title: '',
      items: [{
        aspectRatio: 1.78,
        image: {
          type: 'image',
          url: 'https://promos.makemytrip.com/notification/xhdpi/Forex-Adtech-banner-1200x280.jpg'
        },
        cta: {
          id: 'marketing_banner_cta',
          type: 'navigate',
          deeplink: 'https://promos.makemytrip.com/lowest-exchange-rate-tncs-170924.html'
        }
      }]
    }
  }, {
    templateId: 'PRODUCT_INFO_SCROLLER',
    nodeId: 'product-info-scroller',
    data: {
      title: 'Know More About Our Products',
      icon: {
        type: 'static',
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png'
      },
      items: [{
        image: 'https://tripmoneycmsimgak.mmtcdn.com/img/mcc_web_41a7d8dde0.png',
        bottomCta: {
          text: 'Know More'
        },
        title: 'Multicurrency Card',
        infoItems: [{
          text: [{
            type: 'text',
            text: 'Globally accepted',
            typography: 'mediumW2',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'card with industry-best exchange rates',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            text: 'No extra fee',
            typography: 'mediumW2',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'for reloading/unloading money',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            text: 'Live, interbank linked',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'lowest forex rate',
            typography: 'mediumW2',
            color: '#4a4a4a'
          }]
        }]
      }, {
        image: 'https://tripmoneycmsimgak.mmtcdn.com/img/fcn_web_2d4305f713.png',
        bottomCta: {
          text: 'Know More'
        },
        title: 'Foreign Currency Notes',
        infoItems: [{
          text: [{
            type: 'text',
            text: 'Collection from',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'RBI verified',
            typography: 'mediumW2',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'vendors',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            text: 'Guaranteed',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'next-day delivery',
            typography: 'mediumW2',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'across 150+ cities',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            text: 'Up to',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: '10% more savings',
            typography: 'mediumW2',
            color: '#4a4a4a'
          }, {
            type: 'text',
            text: 'over airport counter rates',
            typography: 'mediumW1',
            color: '#4a4a4a'
          }]
        }]
      }]
    }
  }, {
    templateId: 'FREQUENTLY_ASKED_QUESTION',
    nodeId: 'frequenty_asked_questions',
    data: {
      title: 'Frequently Asked Questions',
      icon: {
        type: 'static',
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158074873-ic_forex_infoicon.png'
      },
      tabs: [{
        id: 'mcc',
        title: 'Multi Currency Card',
        accordion: [{
          q: 'What is a Multi Currency Card and does it work? (multi currency card) ',
          a: "A Multicurrency Forex card is a pre-paid card that you can use to make purchases or withdraw cash in foreign countries at no forex mark-up. It works like a debit card, but you load it with foreign currency before you travel, so you don't have to worry about exchange rates or carrying cash. It can be loaded with up to 14 different currencies and can be used in over 150 countries."
        }, {
          q: 'What is a Multi Currency Card and does it work?  ',
          a: "A Multicurrency Forex card is a pre-paid card that you can use to make purchases or withdraw cash in foreign countries at no forex mark-up. It works like a debit card, but you load it with foreign currency before you travel, so you don't have to worry about exchange rates or carrying cash. It can be loaded with up to 14 different currencies and can be used in over 150 countries."
        }, {
          q: 'How Multi Currency Card works? ',
          a: "A Multicurrency Forex card is a pre-paid card that you can use to make purchases or withdraw cash in foreign countries at no forex mark-up. It works like a debit card, but you load it with foreign currency before you travel, so you don't have to worry about exchange rates or carrying cash. It can be loaded with up to 14 different currencies and can be used in over 150 countries."
        }]
      }, {
        id: 'fcn',
        title: 'Foreign Currency Notes',
        accordion: [{
          id: 'fcn1',
          q: 'What is a Multi Currency Card and does it work?',
          a: 'What is a Multi Currency Card and does it work?,What is a Multi Currency Card and does it work?'
        }]
      }]
    }
  }]
};

/**
 * Source Type Constants
 * Centralized constants for different source types used throughout the listing-ui library
 *
 * These constants define the different ways the listing page can be accessed:
 * - SEO: For search engine optimization and bot crawling
 * - FOREX_LISTING: For regular forex listing page access
 */
const SOURCE_TYPES = {
  SEO: 'seo',
  FOREX_LISTING: 'forex-listing'
};

function getListingApiFallbackResponse() {
  if (process.env['NX_ENV'] === 'local') {
    return listingResponseMock;
  }
  return coreUtils.isMobile() ? fallbackResponsePWA : fallbackResponseDT;
}
const getCCBankAmount = (amount, gstAdjustedMarkup) => {
  return amount * ((100 + gstAdjustedMarkup) / 100);
};
const getMMTAmount = (amount, cashback) => {
  return amount + commonUi.calculateForexTaxes(amount) - cashback;
};
const getSavedAmount = (bankAmount, ourAmount) => {
  return bankAmount - ourAmount;
};
const getDeliveryData = () => {
  const deliveryData = commonUi.getTransformedLocationDataFromSessionStorage({
    key: commonUi.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
    isEssential: true,
    options: {
      shouldParseJson: true
    }
  });
  return deliveryData;
};
const getOfferBannerVariant = (isOfferBannerVariantChanged, variant1, variant2, variant3, minOfferSlab, totalAmountInInr) => {
  // Default to variant1 if no variant change
  if (!isOfferBannerVariantChanged) {
    return variant1;
  }
  // Use variant3 if amount is less than minimum offer slab
  if (minOfferSlab && totalAmountInInr && minOfferSlab > Math.round(totalAmountInInr)) {
    return variant3;
  }
  // Use variant2 for changed offer banner
  return variant2;
};
/**
 * Source Type Utilities
 */
/**
 * Checks if the source type is SEO
 * @param sourceType - The source type string to check
 * @returns boolean indicating if the source type is 'seo'
 */
const isSeoSourceType = sourceType => {
  return sourceType === SOURCE_TYPES.SEO;
};

const fetchLocationApiData = toolkit.createAsyncThunk('locationApi/fetchLocationApiData', (_a, thunkAPI_1) => __awaiter(void 0, [_a, thunkAPI_1], void 0, function* ({
  requestBody,
  onSuccess,
  reqHeaders
}, thunkAPI) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  const {
    sendPdtData
  } = getPdtLoggerMethods({
    state: thunkAPI.getState()
  });
  const apiUrl = `${BFF_BASE_URL}/api/v1/page/listing/delivery-details`;
  const reqId = getRequestId();
  // Extract source_type and page_name from Redux state (same as listingApiSlice)
  const source_type = (_b = thunkAPI.getState().pageContext) === null || _b === void 0 ? void 0 : _b.source_type;
  const page_name = (_c = thunkAPI.getState().pageContext) === null || _c === void 0 ? void 0 : _c.page_name;
  try {
    const defaultHeaders = coreUtils.getDefaultHeaders();
    // Apply SEO headers if this is a SEO source type
    if (isSeoSourceType(source_type)) {
      applySeoHeaders(defaultHeaders, page_name);
    }
    const response = yield coreUtils.fetchWithTimeout(apiUrl, {
      method: 'POST',
      headers: Object.assign(Object.assign(Object.assign({}, defaultHeaders), {
        [HEADERS.REQUEST_ID]: reqId
      }), reqHeaders),
      body: JSON.stringify(requestBody)
    });
    const responseObj = yield response.json();
    if ((responseObj === null || responseObj === void 0 ? void 0 : responseObj.success) && ((_e = (_d = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.delivery) && typeof ((_g = (_f = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.delivery) === 'object') {
      commonUi.setTransformedLocationDataToSessionStorage({
        key: coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
        value: (_j = (_h = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.delivery,
        isEssential: true
      });
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(responseObj);
      return responseObj;
    } else {
      const pdtData = {
        event_detail: {
          vendor_error_details: pdtUtils.getVendorErrorDetails({
            error_code: (_k = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error) === null || _k === void 0 ? void 0 : _k.code,
            error_message_shown: ((_l = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error) === null || _l === void 0 ? void 0 : _l.message) || 'Something went wrong',
            api_url: apiUrl
          })
        },
        event_tracking_context: pdtUtils.getEventTrackingContext({
          request_id: (reqHeaders === null || reqHeaders === void 0 ? void 0 : reqHeaders[HEADERS.REQUEST_ID]) || reqId
        })
      };
      sendPdtData(pdtData);
      return thunkAPI.rejectWithValue(responseObj !== null && responseObj !== void 0 ? responseObj : 'Something went wrong');
    }
  } catch (error) {
    const pdtData = {
      event_detail: {
        vendor_error_details: pdtUtils.getVendorErrorDetails({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: error === null || error === void 0 ? void 0 : error.message,
          api_url: apiUrl
        })
      },
      event_tracking_context: pdtUtils.getEventTrackingContext({
        request_id: (reqHeaders === null || reqHeaders === void 0 ? void 0 : reqHeaders[HEADERS.REQUEST_ID]) || reqId
      })
    };
    sendPdtData(pdtData);
    return thunkAPI.rejectWithValue((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong');
  }
}));
const initialStateForLocation = {
  apiState: coreUtils.States.PRELOADING,
  data: null,
  error: null
};
const locationApiSlice = toolkit.createSlice({
  name: 'locationApi',
  initialState: initialStateForLocation,
  reducers: {
    resetLocationApiData: () => {
      return initialStateForLocation;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchLocationApiData.pending, state => {
      state.apiState = coreUtils.States.LOADING;
      state.error = '';
      state.data = null;
    }).addCase(fetchLocationApiData.fulfilled, (state, action) => {
      state.apiState = coreUtils.States.SUCCESS;
      state.data = action.payload;
      state.error = '';
    }).addCase(fetchLocationApiData.rejected, (state, action) => {
      state.apiState = coreUtils.States.FAILURE;
      state.error = action.payload;
      state.data = null;
    });
  }
});
const {
  resetLocationApiData
} = locationApiSlice.actions;
const locationApiReducer = locationApiSlice.reducer;

/* ============================================================================
 * BOT LISTING DATA
 * Large static data object for bot crawling scenarios
 * Contains comprehensive forex listing data for SEO and bot consumption
 * Total lines: ~2300
 * ============================================================================ */
const botListingData = {
  success: true,
  apiData: {
    cardMinQtyConfig: {
      USD: {
        order_type_code: 'B',
        currency_code: 'USD',
        base_currency_code: 'INR',
        product_code: 'PC',
        forex_item_code: 'USDBPC',
        min_amount: 10,
        min_denomination: 1,
        VARS_CURR_MULTIPLE: 1,
        VARS_CURR_MIN: 10,
        VARS_CURR_CODE: 'USD'
      }
    },
    currencyMinQuantity: {
      USD: {
        product_code: 'CN',
        order_type_code: 'B',
        currency_code: 'USD',
        base_currency_code: 'INR',
        forex_item_code: 'USDBCN',
        min_amount: 1,
        min_denomination: 1,
        VARS_CURR_MULTIPLE: 1,
        VARS_CURR_MIN: 1,
        VARS_CURR_CODE: 'USD'
      }
    },
    niumMinQuantity: {
      USD: {
        product_code: 'NC',
        order_type_code: 'B',
        currency_code: 'USD',
        base_currency_code: 'INR',
        forex_item_code: 'USDBCN',
        min_amount: 10,
        min_denomination: 1,
        VARS_CURR_MULTIPLE: 1,
        VARS_CURR_MIN: 10,
        VARS_CURR_CODE: 'USD'
      }
    },
    location: {
      cityCode: 'DEL',
      pincode: '110001'
    },
    pdtData: {
      delivery_details: {
        pincode: '110001',
        city: 'Delhi',
        city_code: 'DEL'
      },
      upcoming_trip: {
        intl_travel: false,
        trip_details: [{
          country_code: '',
          currency_code: '',
          start_date: '',
          end_date: ''
        }]
      },
      user_details: {
        partner: 'mmt',
        tmAuth: '',
        appOS: 'web'
      },
      user_context: {
        partner: 'mmt',
        tmAuth: '',
        appOS: 'web'
      }
    },
    topOfferData: null,
    slabsData: [{
      id: 'sale_coupon_1',
      min_order_amount: 10000,
      max_order_amount: 30000,
      offer_amount: 100
    }, {
      id: 'sale_coupon_2',
      min_order_amount: 30000,
      max_order_amount: 50000,
      offer_amount: 450
    }, {
      id: 'sale_coupon_3',
      min_order_amount: 50000,
      max_order_amount: 100000,
      offer_amount: 900
    }, {
      id: 'sale_coupon_4',
      min_order_amount: 100000,
      max_order_amount: 150000,
      offer_amount: 2000
    }, {
      id: 'sale_coupon_5',
      min_order_amount: 150000,
      max_order_amount: 225000,
      offer_amount: 4000
    }, {
      id: 'sale_coupon_6',
      min_order_amount: 225000,
      max_order_amount: -1,
      offer_amount: 7500
    }],
    user: {
      name: ' ',
      has_completed_order: false,
      is_card_holder: false,
      is_nium_card_holder: false,
      is_tm_auth_expired: false
    },
    currencyInfo: {
      PC: {
        USD: {
          currency: 'USD',
          rate: 87.5796,
          ner_rate: 84.6602,
          recommended_qty: 1000,
          persuasions: [{
            category: 'PRODUCT',
            type: 'PRODUCT_AVAILABLE_PC',
            variables: {
              CURRENCY: {
                value: 'USD'
              }
            }
          }]
        }
      },
      CN: {
        USD: {
          currency: 'USD',
          rate: 88.0697,
          ner_rate: 85.134,
          recommended_qty: 1000,
          persuasions: [{
            category: 'PRODUCT',
            type: 'PRODUCT_AVAILABLE_CN',
            variables: {
              CURRENCY: {
                value: 'USD'
              }
            }
          }]
        }
      }
    },
    errorMessages: {
      quantityError: [{
        type: 'text',
        typography: 'labelBaseW1',
        text: 'Quantity to be multiple of {{VARS_CURR_MULTIPLE}}',
        color: '#EC2127',
        vars: {
          VARS_CURR_MULTIPLE: ''
        }
      }],
      currencyAmountError: [{
        type: 'text',
        typography: 'labelSmallW1',
        text: 'Min. {{VARS_CURR_MIN}} {{VARS_CURR_CODE}} required',
        color: '#EC2127',
        vars: {
          VARS_CURR_MIN: '',
          VARS_CURR_CODE: ''
        }
      }],
      CN: {
        orderAmountError: [{
          type: 'text',
          typography: 'labelBaseW1',
          text: 'please add min of ₹3000 or equivalent to proceed',
          color: '#EC2127'
        }],
        maxAmountError: [{
          type: 'text',
          typography: 'labelBaseW1',
          text: 'As per regulations, you can carry a maximum of USD 3,000 (or equivalent) in physical currency. Please reduce the amount and try again',
          color: '#fff'
        }]
      },
      PC: {
        orderAmountError: [{
          type: 'text',
          typography: 'labelBaseW1',
          text: 'please add min of ₹-1 or equivalent to proceed',
          color: '#EC2127'
        }],
        maxAmountError: [{
          type: 'text',
          typography: 'labelBaseW1',
          text: 'As per regulations, you can carry a maximum of USD 250,000 (or equivalent) per financial year. Please reduce the amount and try again.',
          color: '#fff'
        }]
      }
    },
    'x-jo-id': '',
    maxAmount: {
      PC: 21250000,
      NC: 21250000,
      CN: 255000
    }
  },
  headerData: {
    bgColors: ['#FFFFFF', '#FFFFFF'],
    templateId: 'HEADER_SECTION',
    nodeId: 'header-section',
    title: 'Forex Card & Currency',
    bgImg: '',
    navActions: [{
      cta: {
        type: 'handler',
        id: 'LOGIN',
        text: 'LOGIN',
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'content_cta-clicked',
              components: {
                content_details: [{
                  id: 'login',
                  type: 'cta',
                  description: ''
                }]
              },
              event_value: 'login_cta'
            }
          }
        }
      }
    }],
    analytics: {
      trackingKey: 'hdr'
    }
  },
  chatbot: {
    templateId: 'CHATBOT',
    nodeId: 'chatbot',
    chatUrl: 'https://myra.makemytrip.com/chat-expert?lob=FOREX&lobCategory=card&project=forex_chatbot&page=LISTING',
    scrollerAnimation: {
      text: ['Have forex doubts?', 'COD, delivery, offer', 'Ask an expert!']
    },
    tooltip: {
      text: 'Ask about rates, delivery, benefits etc. or talk to our Forex experts'
    },
    analytics: {
      pdtData: {
        event_detail: {
          event_name: 'component-loaded',
          components: {
            content_details: [{
              id: 'gen_ai',
              type: 'icon',
              description: 'myra'
            }]
          },
          event_value: 'myra'
        }
      }
    },
    myraIconOpenCta: {
      analytics: {
        pdtData: {
          event_detail: {
            event_name: 'component-loaded',
            components: {
              content_details: [{
                id: 'bms_gen_ai',
                type: 'bottomsheet',
                description: 'myra'
              }]
            },
            event_value: 'myra_bottomsheet'
          }
        }
      }
    },
    myraIconCloseCta: {
      analytics: {
        pdtData: {
          event_detail: {
            event_name: 'component-loaded',
            components: {
              content_details: [{
                id: 'bms_gen_ai',
                type: 'bottomsheet'
              }]
            },
            event_value: 'myra_closed'
          }
        }
      }
    },
    myraIconClicked: {
      analytics: {
        pdtData: {
          event_detail: {
            event_name: 'content_cta-clicked',
            components: {
              content_details: [{
                id: 'gen_ai',
                type: 'cta'
              }]
            },
            event_value: 'myra'
          }
        }
      }
    },
    showChatBot: true
  },
  cardData: [{
    templateId: 'CURRENCY_PRODUCT_SELECTION',
    nodeId: 'currency-product-selection',
    analytics: {},
    pageExitContentId: 'cs_itms',
    data: {
      deliverAtSelection: {
        default: 'Delhi',
        title: 'DELIVER AT',
        placeholder: 'Select Currency',
        cta: {
          id: 'PINCODE_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-selection-bottomsheet',
          modalId: 'PINCODE_BOTTOMSHEET'
        },
        bottomBanner: {
          title: ''
        },
        bottomText: '110001'
      },
      currencySelection: {
        default: 'US Dollar',
        title: 'CURRENCY',
        placeholder: 'Select Currency',
        cta: {
          id: 'CURRENCY_SEARCH_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-selection-bottomsheet',
          modalId: 'CURRENCY_SEARCH_BOTTOMSHEET',
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'content_menu-clicked',
                event_value: 'currency_search',
                components: {
                  content_details: [{
                    id: 'cs_itms',
                    type: 'cta',
                    description: ''
                  }]
                }
              }
            }
          }
        },
        bottomBanner: {
          title: ''
        },
        bottomText: 'USD'
      },
      amountSelectionForex: {
        defaultCurrency: 'USD',
        title: 'FOREX AMOUNT',
        hint: 'Enter Amount',
        bottomBanner: {
          title: ''
        },
        cta: {
          id: 'CURRENCY_AMOUNT_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-amount-bottomsheet'
        },
        toolTip: {
          text: [{
            type: 'text',
            color: '#fff',
            typography: 'labelSmallW1',
            text: 'Travellers usually carry'
          }, {
            type: 'text',
            color: '#fff',
            clickable: true,
            typography: 'labelSmallW3',
            text: 'USD 1000',
            actionType: 'dispatch',
            dispatchArgs: {
              type: 'SET_CURRENCY',
              data: {
                currencyCode: 'USD',
                recommendedAmount: 1000
              }
            }
          }, {
            type: 'text',
            color: '#fff',
            typography: 'labelSmallW1',
            text: ' or more for a hassle free trip'
          }]
        },
        disabled: false
      },
      amountSelectionInr: {
        defaultCurrency: 'INR',
        title: 'INR AMOUNT',
        hint: 'Enter Amount',
        bottomBanner: {
          title: [{
            color: '#4a4a4a',
            text: 'Net effective amount',
            type: 'text',
            typography: 'labelBaseW1'
          }, {
            color: '#8A50C7',
            text: '₹{{VARS_NER_AMOUNT}}   ',
            type: 'text',
            typography: 'labelBaseW3',
            vars: {
              VARS_NER_AMOUNT: ''
            }
          }],
          info: {
            icon: {
              url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Info_1_68885bd960.png',
              type: 'static/gif/lottie'
            },
            cta: {
              id: 'COUPON_BOTTOMSHEET',
              type: 'handler',
              nodeId: 'listing-coupon-bottomsheet',
              modalId: 'SPECIAL_CASHBACK_BOTTOMSHEET'
            }
          },
          bgColors: ['#FFFFFF', '#FFFFFF']
        },
        cta: {
          id: 'CURRENCY_AMOUNT_BOTTOMSHEET',
          type: 'handler',
          nodeId: 'currency-amount-bottomsheet'
        },
        disabled: false
      },
      productSelection: {
        title: 'CARD/CURRENCY',
        hint: [{
          color: 'rgba(0,0,0,0.3)',
          text: 'Select',
          type: 'text',
          typography: 'medium'
        }],
        bottomText: 'Forex Card / Foreign Currency Notes',
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'listing_product-selected'
            }
          }
        }
      },
      productItems: [{
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'content_cta-clicked',
              components: {
                content_details: [{
                  id: 'cs_itms',
                  type: 'cta',
                  description: 'PC_BUY'
                }]
              },
              event_value: 'product_tile_pc'
            }
          }
        },
        title: '',
        productType: 'PC',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1730788343204-ic_forex_card.png',
          type: 'static'
        },
        iconNote: null,
        cta: {
          id: 'PC_BUY_NOW',
          text: 'BUY NOW',
          type: 'navigate',
          deeplink: 'https://www.makemytrip.com/forex/pc/funnel/add-currency',
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'component_cta-clicked',
                components: {
                  content_details: [{
                    id: 'cs_itms',
                    type: 'cta',
                    description: 'PC_BUY_NOW'
                  }]
                },
                event_value: '{{LV_CTA_TEXT}}'
              }
            }
          }
        },
        currency: {
          USD: {
            disabled: false,
            selected: true,
            title: [{
              type: 'text',
              typography: 'labelMediumW3',
              text: 'Multi Currency Card',
              color: '#000000'
            }],
            subtitle: [{
              type: 'text',
              typography: 'labelSmallW1',
              text: 'Lifetime Free, Zero Forex Markup​',
              color: '#4A4A4A'
            }],
            selectedSubtextNode: 'subtext2',
            subtext1: [{
              type: 'text',
              typography: 'labelSmallW3',
              text: 'Load as low as 10 USD, top up later',
              color: '#007E7D'
            }],
            rate: 87.5796,
            recommendedQty: 1000
          }
        },
        selected: false
      }, {
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'content_cta-clicked',
              components: {
                content_details: [{
                  id: 'cs_itms',
                  type: 'cta',
                  description: 'CN_BUY'
                }]
              },
              event_value: 'product_tile_cn'
            }
          }
        },
        title: '',
        productType: 'CN',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1732622423157-ic_foreign_currency.png',
          type: 'static'
        },
        iconNote: null,
        cta: {
          id: 'CN_BUY_NOW',
          text: 'BUY NOW',
          type: 'navigate',
          deeplink: 'https://www.makemytrip.com/forex/cn/funnel/add-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}',
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'component_cta-clicked',
                components: {
                  content_details: [{
                    id: 'cs_itms',
                    type: 'cta',
                    description: 'CN_BUY_NOW'
                  }]
                },
                event_value: 'buy_now'
              }
            }
          }
        },
        currency: {
          USD: {
            disabled: false,
            selected: false,
            title: [{
              type: 'text',
              typography: 'labelMediumW3',
              text: '{{VARS_SELECTED_CURR}} Currency Notes',
              color: '#000000'
            }],
            subtitle: [{
              type: 'text',
              typography: 'labelSmallW1',
              text: 'Genuine notes from RBI licensed companies​',
              color: '#4A4A4A'
            }],
            rate: 88.0697,
            recommendedQty: 1000
          }
        },
        selected: false
      }],
      cta: {
        deeplink: 'https://www.makemytrip.com/forex/pc/funnel/add-currency?selectedCurr=USD&currQty={{VARS_CURR_QTY}}',
        id: 'BUY_NOW_BTN',
        isDisabled: false,
        text: 'BUY NOW',
        type: 'navigate',
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'listing_buy_now-clicked'
            }
          }
        }
      }
    }
  }, {
    templateId: 'OFFER_PERSUASION',
    nodeId: 'offer-persuasion',
    pageExitContentId: '',
    analytics: {
      trackingKey: 'ofr_p_sl',
      pdtData: {
        event_detail: {
          event_name: 'page-rendered',
          components: {
            content_details: [{
              id: 'ofr_p_sl',
              type: 'card',
              description: 'forex_sale_offer'
            }]
          },
          event_value: ''
        }
      }
    },
    data: {
      icon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1729158036400-offer_icon.png'
      },
      subtitle: '',
      info: {
        icon: {
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Info_1_68885bd960.png'
        },
        cta: {
          id: 'FOREXSALE',
          type: 'modal',
          modalId: 'AMOUNT_BASED_COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET',
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'content_cta-clicked',
                components: {
                  content_details: [{
                    id: 'ofr_p_sl',
                    type: 'card',
                    description: 'FOREXSALE'
                  }]
                },
                event_value: 'forex_offer_persuasion'
              }
            }
          }
        }
      },
      variant1: {
        subtitle: [{
          type: 'text',
          typography: 'labelSmallW1',
          text: 'Upto',
          color: '#000'
        }, {
          type: 'text',
          typography: 'labelBaseW3',
          text: '₹7500 Cashback,',
          color: '#3543BF'
        }, {
          type: 'text',
          clickable: false,
          color: '#000000',
          typography: 'labelSmallW1',
          text: 'for new forex customers'
        }]
      },
      variant2: {
        subtitle: [{
          type: 'text',
          typography: 'labelSmallW1',
          text: 'Net effective price after cashback ',
          color: '#4A4A4A'
        }, {
          type: 'text',
          clickable: false,
          color: '#3543BF',
          typography: 'labelBaseW3',
          text: '₹{{VARS_CASHBACK_AMOUNT}} | Rate ₹{{VARS_NER_RATE}}',
          vars: {
            VARS_CASHBACK_AMOUNT: '',
            VARS_NER_RATE: ''
          }
        }]
      }
    }
  }, {
    templateId: 'STATIC_TITLE_SUBTITLE',
    nodeId: 'powered-by',
    data: {
      title: 'Fulfilled by',
      icon: {
        url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147223265_1_f051c7f067.png',
        type: 'static'
      },
      text: [{
        type: 'text',
        clickable: false,
        color: '#FFFFFF',
        typography: 'labelSmallW1',
        text: 'License number : FE.DEL.FFMC/ U070/2013'
      }]
    }
  }, {
    templateId: 'PRODUCT_INFO_SCROLLER',
    nodeId: 'product-info-scroller',
    pageExitContentId: 'product_info',
    analytics: {
      trackingKey: 'pc_info'
    },
    data: {
      title: 'Know more about our product',
      items: [{
        image: {
          type: 'image',
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/mcc_web_41a7d8dde0.png'
        },
        bottomCta: {
          id: 'know_more_cta_products',
          type: 'navigate',
          text: 'KNOW MORE',
          deeplink: 'https://makemytrip.com/forex/partners/mmt/forex/bmf/onboarding/landing',
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'content_cta-clicked',
                components: {
                  content_details: [{
                    id: 'product_info',
                    type: 'cta',
                    description: 'PC'
                  }]
                },
                event_value: 'know_more'
              }
            }
          }
        },
        title: 'Multi Currency Card',
        infoItems: [{
          text: [{
            type: 'text',
            clickable: false,
            typography: 'labelSmallW2',
            text: 'Zero forex markup. ',
            color: '#4a4a4a'
          }, {
            type: 'text',
            clickable: false,
            typography: 'labelSmallW1',
            text: 'Get actual interbank rates',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'labelSmallW2',
            text: 'No hidden charges. ',
            color: '#4a4a4a'
          }, {
            type: 'text',
            clickable: false,
            typography: 'labelSmallW1',
            text: 'Zero reload, unload & annual fee',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'labelSmallW2',
            text: 'Save upto 5% ',
            color: '#4a4a4a'
          }, {
            type: 'text',
            clickable: false,
            typography: 'labelSmallW1',
            text: 'over your Credit/Debit cards',
            color: '#4a4a4a'
          }]
        }]
      }, {
        image: {
          type: 'image',
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/fcn_web_2d4305f713.png'
        },
        bottomCta: {
          id: 'know_more_cta_products_2',
          type: 'navigate',
          text: 'KNOW MORE',
          deeplink: 'https://makemytrip.com/forex/partners/mmt/forex/bmf/currency/onboarding/landing',
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'content_cta-clicked',
                components: {
                  content_details: [{
                    id: 'product_info',
                    type: 'cta',
                    description: 'CN'
                  }]
                },
                event_value: 'know_more'
              }
            }
          }
        },
        title: 'Foreign Currency Notes',
        infoItems: [{
          text: [{
            type: 'text',
            clickable: false,
            typography: 'labelSmallW2',
            text: '40+ currencies available. ',
            color: '#4a4a4a'
          }, {
            type: 'text',
            clickable: false,
            typography: 'labelSmallW1',
            text: 'RBI approved currency notes',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'labelSmallW2',
            text: 'Best exchange rates. ',
            color: '#4a4a4a'
          }, {
            type: 'text',
            clickable: false,
            typography: 'labelSmallW1',
            text: 'Lowest rates in the market',
            color: '#4a4a4a'
          }]
        }, {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'labelSmallW2',
            text: '100+ RBI-licensed money changers ',
            color: '#4a4a4a'
          }, {
            type: 'text',
            clickable: false,
            typography: 'labelSmallW1',
            text: 'across 50+ cities',
            color: '#4a4a4a'
          }]
        }]
      }]
    }
  }, {
    templateId: 'PAGER_1',
    nodeId: 'marketing-banners',
    pageExitContentId: 'mkr_bns',
    analytics: {
      trackingKey: 'mkr_bns'
    },
    data: {
      title: '',
      items: [{
        aspectRatio: 1.78,
        image: {
          type: 'image',
          url: 'https://promos.makemytrip.com/notification/xhdpi/Forex-Adtech-banner-1200x280.jpg'
        },
        cta: {
          id: 'marketing_banner_cta',
          type: 'navigate',
          target: '_blank',
          deeplink: 'https://promos.makemytrip.com/lowest-exchange-rate-tncs-170924.html',
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'content_cta-clicked',
                components: {
                  content_details: [{
                    id: 'mkr_bns',
                    type: 'cta',
                    description: ''
                  }]
                },
                event_value: 'marketing_banner'
              }
            }
          }
        }
      }]
    }
  }, {
    templateId: 'FREQUENTLY_ASKED_QUESTION',
    nodeId: 'frequenty_asked_questions',
    pageExitContentId: 'faqs',
    analytics: {
      trackingKey: 'faqs',
      pdtData: {
        event_detail: {
          event_name: 'content_cta-clicked',
          components: {
            content_details: [{
              id: 'faqs',
              type: 'cta',
              description: ''
            }]
          },
          event_value: 'faq_question'
        }
      }
    },
    data: {
      title: 'Frequently Asked Questions',
      tabs: [{
        id: 'mcc',
        title: 'Multi Currency Card',
        accordion: [{
          q: 'What is a Forex Card?',
          a: 'A Forex Card is a prepaid card designed specifically for international travelers. It is fully compliant with RBI regulations and provides peace of mind with 100% acceptance at all merchants in over 150 countries. It also provides digital controls within the app, allowing you to lock/unlock the card instantly and offers several benefits, without the need to link your bank account to the card.'
        }, {
          q: 'Who should use Forex Card?',
          a: 'Forex Card is ideal for anyone who values peace of mind during international trips and wants to avoid all forex markups and hidden charges.'
        }, {
          q: 'Is there any documentation or KYC required?',
          a: 'Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket after making payment for forex transactions on Makemytrip. These will be verified before processing the order.'
        }, {
          q: 'Why should I not use a Debit/Credit card instead?',
          a: 'Using a Debit/Credit card for international transactions may come with several drawbacks such as high markups (up to 5%), additional service charges, hidden fees, low acceptance at certain places, higher risk of scams, potential misuse in case of loss, negative impact on your CIBIL score, and fluctuating exchange rates. You can avoid all these by opting for Forex Card.'
        }, {
          q: 'Does this card give reward points?',
          a: 'No, this card does not offer reward points. However, it is still the most rewarding option due to its lowest forex rates and cashback offers.'
        }, {
          q: 'How do I get this card?',
          a: 'You can easily order this card online within 2 minutes. Simply enter your PAN (Permanent Account Number) and delivery address, and the card will be delivered to your doorstep within 48 hours.'
        }, {
          q: 'How can I load money into my card?',
          a: 'You can load money instantly using UPI, NetBanking, and Debit Card. You can top up your card anytime, even during your international trip.'
        }, {
          q: "What if I don't want to use the card later?",
          a: 'If you no longer wish to use the card, you have the option to withdraw the unused money instantly. Additionally, you can choose to temporarily lock the card or close it anytime.'
        }]
      }, {
        id: 'fcn',
        title: 'Foreign Currency Notes',
        accordion: [{
          q: 'Who should buy foreign currency notes?',
          a: 'Every international traveller should purchase some foreign currency notes, before their trip. Currency notes are always a good option to prevent any potential inconvenience while spending in a foreign country, especially in case your forex or credit card are not accepted in some outlets or for local conveyance.'
        }, {
          q: 'Why should I buy foreign currency notes from Makemytrip?',
          a: 'We offer best exchange rates, genuine notes from RBI licensed companies, doorstep delivery across 50+ cities, 40+ currencies available, instant customer support and many more.'
        }, {
          q: 'How can I place the order for currency notes?',
          a: "Ordering foreign currency notes through MakeMyTrip takes just two minutes. All you need to do is provide the currency and amount required, along with your PAN and address details. That's it! Your currency notes will be delivered to your address within the specified time."
        }, {
          q: 'How many days before travel should I buy currency notes?',
          a: 'Purchasing foreign currency notes well in advance of your travel is a prudent practice to prevent potential stock shortages, unforeseen delays, or fluctuations in exchange rates. You can buy foreign currency notes within 60 days of your trip start date. Advance purchase prior to this 60-day period is not allowed.'
        }, {
          q: "What's my foreign exchange entitlement (limit) for personal / leisure travel?",
          a: "Not exceeding US Dollars 2,50,000 in a financial year. If not consumed any part of it for any other purpose stated as per RBI's guidelines covering the new liberalized Remittance Scheme (LRS). Limit can be utilized in one or more visits abroad for personal/leisure purposes. If an individual has already remitted any amount under the Liberalized Remittance Scheme in a financial year, then the applicable limit for traveling purposes for such an individual would be reduced from USD 250,000 by the amount so remitted."
        }, {
          q: 'Is there a separate limit for carrying currency notes?',
          a: 'Travelers are allowed to purchase foreign currency notes/coins only up to US$ 3000 individually. Exceptions to this rule are the following: (a) travellers proceeding to Iraq and Libya can draw foreign exchange in the form of foreign currency notes and coins not exceeding US$ 5000 or its equivalent. (b) travellers proceeding to the Islamic Republic of Iran, the Russian Federation, and other Republics of the Commonwealth of Independent States who can draw entire foreign exchange in the form of foreign currency notes or coins. (c) For travelers proceeding for Haj/Umrah pilgrimage, the full amount of BTQ entitlement (USD 250,000) in cash or up to the cash limit as specified by the Haj Committee of India, may be released by the ADs and FFMCs. Minimum order limit for foreign currency is set at INR 3000.'
        }, {
          q: 'Is there any documentation or KYC required?',
          a: 'Yes, as per RBI guidelines the traveller needs to upload his/her PAN card, Indian passport (front & back), Air ticket and Visa (if not on arrival), after making payment for forex transactions on Makemytrip. These will be verified before processing the order.'
        }, {
          q: 'Can I sell back my left over foreign currency notes?',
          a: "Any remaining foreign currency notes that you have after your international trip can be conveniently exchanged through the BookMyForex app or website. This allows you to convert your leftover foreign currency back into your home currency, ensuring that your funds don't go to waste."
        }, {
          q: 'Is there anything else I should be aware of while purchasing foreign currency notes?',
          a: "Yes, you should make payment for forex transactions from traveller's bank account, whose PAN number is provided. As per RBI guidelines, name in PAN should match with the Bank account holder name."
        }]
      }]
    }
  }],
  bottomSheets: {
    COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET: {
      title: 'Coupon Details',
      couponList: [{
        title: 'FOREXCASHBACK',
        type: 'FOREX_SALE',
        subLabel: [{
          type: 'text',
          text: 'LIMITED TIME OFFER',
          typography: 'labelBaseW1',
          color: '#757575'
        }],
        bookingId: 'FOREXCASHBACK',
        label: [{
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'labelBaseW1',
          text: 'Get upto '
        }, {
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'labelBaseW3',
          text: 'INR 7500 '
        }, {
          type: 'text',
          clickable: false,
          color: '#4A4A4A',
          typography: 'labelBaseW1',
          text: 'cashback in your myCash wallet on delivery of your forex. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.'
        }]
      }],
      tnc: {
        title: 'Terms & Condition',
        list: ['Offer is valid till 30th September, 2025.', 'Cashback is applicable on order values exceeding INR 10,000.', 'Offer is applicable on forex card and currency orders only. Offer is not applicable on card reload or unload orders.', 'Cashback will only be processed if the offer is applied by the user while ordering.', 'The Customer, upon successful completion of their transaction for ordering a forex card or currency, shall receive the cashback amount in the wallet as per the slabs, after delivery (and activation in the case of a card) by BookMyForex.', "myCash credited will be valid for 6 months from when it has been credited into the user's account.", "Cashback can only be credited to the wallet of the customer who purchased the Forex card or currency notes as per the terms of the offer and not to any third party's account.", 'If the Customer cancels the order of the Forex card or currency, the Customer shall not be eligible to receive the cashback under the Offer and the terms of cancellation as provided on the BookMyForex platform shall be applicable.', [{
          type: 'text',
          text: 'To know more about Wallet usage Terms and conditions, visit https://www.makemytrip.com/mywallet/',
          color: '#4A4A4A'
        }], 'Lowest Exchange Rate Guarantee : Get 2x the Price Difference in case you find a better price online.', 'Offer applies to the net effective price (i.e., the price paid after adjusting any applicable cashback) paid by the Customer for placing the Forex Product order.', 'The Offer is valid only for the same product, currency and amount for the same city or location.', 'After purchasing the Forex Product, if you find a lower price for the same product on the website or app of any other authorized money changer, the Customer may raise a claim request via sending an email to ForexClaims@go-mmt.com.', 'The claim must be submitted by the Customer using their registered email ID or phone number with relevant proofs.']
      },
      offerSlabs: {
        title: [{
          type: 'text',
          clickable: false,
          color: '#757575',
          typography: 'labelSmallW2',
          text: 'Cashback Slabs'
        }],
        offerList: [{
          id: 1,
          title: 'Slabs (in INR)',
          list: ['10k - 30k', '30k - 50k', '50k - 1 Lakh', '1 Lakh - 1.5 Lakh', '1.5 Lakh - 2.25 Lakh', 'More than 2.25 Lakh']
        }, {
          id: 2,
          title: 'Cashback (INR)',
          list: ['₹ 100', '₹ 450', '₹ 900', '₹ 2,000', '₹ 4,000', '₹ 7,500']
        }]
      }
    },
    AMOUNT_BASED_COUPON_DETAIL_FOREXCASHBACK_BOTTOMSHEET: {
      title: 'Offer Detail',
      currencyInfo: {
        currencyName: [{
          text: '{{VARS_CURRENCY_NAME}}',
          vars: {
            VARS_CURRENCY_NAME: ''
          },
          typography: 'labelLargeW2',
          color: '#000000',
          clickable: false,
          type: 'text'
        }],
        conversionInfo: {
          text: [{
            type: 'text',
            clickable: false,
            typography: 'labelLargeW2',
            text: '{{VARS_AMOUNT}} {{VARS_CURRENCY_CODE}} = ',
            color: '#000000',
            vars: {
              VARS_AMOUNT: '',
              VARS_CURRENCY_CODE: ''
            }
          }, {
            type: 'text',
            clickable: false,
            typography: 'labelLargeW2',
            text: '₹{{VARS_INR_AMOUNT}}',
            color: '#000000',
            vars: {
              VARS_INR_AMOUNT: ''
            }
          }],
          liveRate: [{
            type: 'text',
            clickable: false,
            typography: 'labelSmallW1',
            text: 'LIVE Rate: ₹{{VARS_RATE}}',
            color: '#757575',
            vars: {
              VARS_RATE: ''
            }
          }],
          bgColor: '#F5F5F5',
          borderRadius: 12
        }
      },
      netEffectivePrice: {
        text: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW1',
          text: 'Net effective price after cashback ',
          color: '#4A4A4A'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelBaseW3',
          text: '₹{{VARS_NER_EFFECTIVE_PRICE}} | Rate ₹{{VARS_NER_RATE}}',
          color: '#3543BF',
          vars: {
            VARS_NER_EFFECTIVE_PRICE: ''
          }
        }]
      },
      offerBanner: {
        topText: {
          text: 'NEW CUSTOMER OFFER',
          bgColor: '#4285F4',
          textColor: '#FFFFFF',
          typography: 'labelSmallW2'
        },
        variant1: {
          title: [{
            typography: 'labelLargeW3',
            color: '#4a4a4a',
            type: 'text',
            text: 'Upto ₹{{VARS_MAX_CASHBACK}} Cashback!',
            vars: {
              VARS_MAX_CASHBACK: ''
            }
          }],
          subtitle: [{
            typography: 'labelBaseW1',
            color: '#4a4a4a',
            type: 'text',
            text: 'Enter the amount to find out your cashback'
          }]
        },
        variant2: {
          title: [{
            typography: 'labelLargeW3',
            color: '#4a4a4a',
            type: 'text',
            text: 'You get ₹{{VARS_CASHBACK_AMOUNT}} cashback',
            vars: {
              VARS_CASHBACK_AMOUNT: ''
            }
          }],
          subtitle: [{
            typography: 'labelBaseW1',
            color: '#4a4a4a',
            type: 'text',
            text: 'Coupon '
          }, {
            typography: 'labelBaseW2',
            color: '#4a4a4a',
            type: 'text',
            text: '"FOREXCASHBACK"'
          }, {
            typography: 'labelBaseW1',
            color: '#4a4a4a',
            type: 'text',
            text: ' pre-applied'
          }]
        },
        variant3: {
          title: [{
            typography: 'labelLargeW3',
            color: '#4a4a4a',
            type: 'text',
            text: 'Upto ₹7500 Cashback!'
          }],
          subtitle: [{
            typography: 'labelBaseW1',
            color: '#4a4a4a',
            type: 'text',
            text: 'For best rate, we recommend adding ₹10,000 or more'
          }]
        },
        icon: {
          url: 'https://tripmoneycmsimgak.mmtcdn.com/img/Group_1321318099_1_e44e99765e.png',
          type: 'image'
        },
        bgColor: '#F8F9FA'
      },
      disclaimer: {
        text: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW1',
          text: '*Cashback will be credited to MMT wallet as myCash after order is completed.',
          color: '#757575'
        }]
      },
      analytics: {
        trackingKey: 'offer_detail_bottomsheet'
      },
      offerSlabs: {
        title: [{
          type: 'text',
          clickable: false,
          color: '#757575',
          typography: 'labelSmallW2',
          text: 'Cashback Slabs'
        }],
        offerList: [{
          id: 1,
          title: 'Slabs (in INR)',
          list: ['10k - 30k', '30k - 50k', '50k - 1 Lakh', '1 Lakh - 1.5 Lakh', '1.5 Lakh - 2.25 Lakh', 'More than 2.25 Lakh']
        }, {
          id: 2,
          title: 'Cashback (INR)',
          list: ['₹ 100', '₹ 450', '₹ 900', '₹ 2,000', '₹ 4,000', '₹ 7,500']
        }]
      }
    },
    PINCODE_BOTTOMSHEET: {
      title: 'Edit Location',
      subtitle: 'Enter pincode of your delivery location',
      inputPlaceholder: 'PINCODE',
      analytics: {
        trackingKey: 'bms_loc',
        pdtData: {
          event_detail: {
            event_name: 'component-loaded',
            components: {
              content_details: [{
                id: 'bms_loc',
                type: 'bottomsheet'
              }]
            },
            event_value: 'pincode_bottomsheet'
          }
        }
      },
      closeCta: {
        id: 'CLOSE',
        type: 'CLOSE',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png'
        },
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'content_cta-clicked',
              components: {
                content_details: [{
                  id: 'bms_loc',
                  type: 'bottomsheet'
                }]
              },
              event_value: 'close_pincode_bottomsheet'
            }
          }
        }
      },
      cta: {
        id: 'DETECT_LOCATION_CTA',
        type: 'handler',
        text: 'Detect Location',
        icon: {
          type: 'static',
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1732610465878-detect_location.png'
        },
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'content_cta-clicked',
              components: {
                content_details: [{
                  id: 'bms_loc',
                  type: 'cta'
                }]
              },
              event_value: 'detect_location_cta'
            }
          }
        }
      },
      loader: {
        title: 'Fetching Location',
        loaderColor: '#008CFF',
        description: 'Fetching location details...'
      },
      cityFallback: {
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'component-loaded',
              components: {
                content_details: [{
                  id: 'bms_loc',
                  type: 'bottomsheet',
                  description: 'fallback_city_option'
                }]
              },
              event_value: 'fallback_city_option'
            }
          }
        },
        title: 'Select Delivery City',
        subTitle: 'We are currently delivering to below cities in India',
        showCities: 5,
        cta: {
          id: 'SHOW_MORE_CITIES',
          text: 'show more cities',
          textColor: '#008CFF'
        },
        citySelectCta: {
          analytics: {
            pdtData: {
              event_detail: {
                event_name: 'content_cta-clicked',
                components: {
                  content_details: [{
                    id: 'bms_loc',
                    type: 'cta',
                    description: ''
                  }]
                },
                event_value: 'fallback_city'
              }
            }
          }
        }
      }
    },
    AMOUNT_CALCULATOR_BOTTOMSHEET: {
      title: 'Enter Amount',
      closeCta: {
        id: 'CLOSE',
        type: 'CLOSE',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png'
        }
      },
      comparisonIcon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1732610060135-compare_icon.png'
      },
      infoIcon: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1730193523876-ic_forex_bulb.png',
        type: 'static'
      },
      subtext: [{
        type: 'text',
        color: '#000000',
        typography: 'labelBaseW1',
        text: 'Travellers usually carry'
      }, {
        type: 'text',
        color: '#008CFF',
        typography: 'labelBaseW3',
        clickable: true,
        actionType: 'handler',
        text: ' {{VARS_CURRENCY_CODE}} {{VARS_RECOMMENDED_AMOUNT}}',
        vars: {
          VARS_CURRENCY_CODE: 'USD',
          VARS_RECOMMENDED_AMOUNT: '1,000'
        }
      }, {
        type: 'text',
        color: '#000000',
        typography: 'labelBaseW1',
        text: ' or more for a hassle free trip'
      }],
      fromHint: [{
        type: 'text',
        typography: 'labelSmallW3',
        text: '{{VARS_FROM_CURRENCY}} amount',
        color: '#FFFFFF',
        vars: {
          VARS_FROM_CURRENCY: 'USD'
        }
      }],
      toHint: 'INR Amount',
      cta: {
        id: 'add_currency',
        type: 'close',
        text: 'ADD',
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'component_cta-clicked',
              components: {
                content_details: [{
                  id: 'bms_amtCl',
                  type: 'cta',
                  description: ''
                }]
              },
              event_value: 'add_amount'
            }
          }
        }
      },
      bestRatePersuasion: [{
        type: 'text',
        color: '#4a4a4a',
        typography: 'labelSmallW1',
        text: ''
      }],
      netEffectiveCard: {
        infoItem1: {
          left: [{
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelSmallW1',
            text: 'Exchange rate of 1 {{VARS_CURRENCY_CODE}}:',
            vars: {
              VARS_CURRENCY_CODE: 'USD'
            }
          }],
          right: [{
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelBaseW2',
            text: '₹{{VARS_NER_RATE}}*',
            vars: {
              VARS_NER_RATE: 84.6602
            }
          }, {
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelSmallW1',
            text: ''
          }]
        },
        infoItem2: {
          left: [{
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelSmallW1',
            text: 'Net effective price after cashback:'
          }],
          right: {
            icon: {
              type: 'icon',
              url: 'https://go-assets.ibcdn.com/u/MMT/images/1730196567070-ic_forex_star.png'
            },
            amount: {
              type: 'gradientText',
              gradient: ['#3023AE', '#C86DD7'],
              color: '#8A50C7',
              typography: 'labelMediumW3',
              text: [{
                type: 'text',
                typography: 'labelSmallW3',
                text: '₹{{VARS_NER}}',
                color: '#4a4a4a',
                vars: {
                  VARS_NER: ''
                }
              }]
            }
          }
        },
        infoItem3: [{
          type: 'text',
          color: '#4a4a4a',
          typography: 'labelSmallW1',
          text: 'Cashback of ₹{{VARS_CASHBACK}} will be credited to myCash wallet on delivery of your forex. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.',
          vars: {
            VARS_CASHBACK: ''
          }
        }],
        footerText: [{
          type: 'text',
          color: '#757575',
          typography: 'labelSmallW1',
          text: ''
        }]
      },
      maxINRAmount: 25000000,
      bottomText: [{
        type: 'text',
        typography: 'labelSmallW1',
        text: '',
        color: '#757575'
      }],
      analytics: {
        trackingKey: 'bms_amtCl',
        pdtData: {
          event_detail: {
            event_name: 'component-loaded',
            components: {
              content_details: [{
                id: 'bms_amtCl',
                type: 'bottomsheet',
                description: ''
              }]
            },
            event_value: 'add_amount_bottomsheet'
          }
        }
      },
      slabs: [{
        id: 'sale_coupon_1',
        minAmount: 10000,
        maxAmount: 30000,
        cashback: 100
      }, {
        id: 'sale_coupon_2',
        minAmount: 30000,
        maxAmount: 50000,
        cashback: 450
      }, {
        id: 'sale_coupon_3',
        minAmount: 50000,
        maxAmount: 100000,
        cashback: 900
      }, {
        id: 'sale_coupon_4',
        minAmount: 100000,
        maxAmount: 150000,
        cashback: 2000
      }, {
        id: 'sale_coupon_5',
        minAmount: 150000,
        maxAmount: 225000,
        cashback: 4000
      }, {
        id: 'sale_coupon_6',
        minAmount: 225000,
        maxAmount: -1,
        cashback: 7500
      }]
    },
    AMOUNT_CALCULATOR_BOTTOMSHEET_V2: {
      slabs: [{
        id: 'sale_coupon_1',
        minAmount: 10000,
        maxAmount: 30000,
        cashback: 100
      }, {
        id: 'sale_coupon_2',
        minAmount: 30000,
        maxAmount: 50000,
        cashback: 450
      }, {
        id: 'sale_coupon_3',
        minAmount: 50000,
        maxAmount: 100000,
        cashback: 900
      }, {
        id: 'sale_coupon_4',
        minAmount: 100000,
        maxAmount: 150000,
        cashback: 2000
      }, {
        id: 'sale_coupon_5',
        minAmount: 150000,
        maxAmount: 225000,
        cashback: 4000
      }, {
        id: 'sale_coupon_6',
        minAmount: 225000,
        maxAmount: -1,
        cashback: 7500
      }]
    },
    CURRENCY_SEARCH_BOTTOMSHEET: {
      title: 'Select Currency',
      allCurrencyHeader: 'All Currencies',
      popularCurrencyHeader: 'POPULAR CURRENCIES',
      currencySelectCta: {
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'content_cta-clicked',
              components: {
                content_details: [{
                  id: 'bms_curSh',
                  type: 'cta',
                  description: ''
                }]
              },
              event_value: 'currency_selected'
            }
          }
        }
      },
      suggestionSection: {
        title: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          text: "Can't find what you are looking for? We recommend you to add "
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#000000',
          text: '{{VARS_SUGGESTED_CURRENCY}}',
          vars: {
            VARS_SUGGESTED_CURRENCY: 'US Dollar'
          }
        }],
        label: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#4A4A4A',
          text: 'Why {{VARS_SUGGESTED_CURRENCY}}?',
          vars: {
            VARS_SUGGESTED_CURRENCY: 'US Dollar'
          }
        }],
        featList: [[{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#000000',
          text: 'Globally'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000000',
          text: ' Accepted'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#000000',
          text: 'Easily exchangable'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000000',
          text: ' at airports and local vendors'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000000',
          text: 'Exchangable at'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#000000',
          text: ' lowest rate'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000000',
          text: ' vs other currencies'
        }]]
      },
      currencyUnavailableSection: {
        title: [{
          type: 'text',
          clickable: false,
          typography: 'labelBaseW1',
          color: '#000000',
          text: '{{VARS_SEARCHED_CURRENCY}} usually have limited availability in the market. We recommend you to',
          vars: {
            VARS_SEARCHED_CURRENCY: ''
          }
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelBaseW3',
          color: '#000000',
          text: ' add {{VARS_SUGGESTED_CURRENCY}}',
          vars: {
            VARS_SUGGESTED_CURRENCY: ''
          }
        }],
        label: [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#4A4A4A',
          text: 'Why {{VARS_SUGGESTED_CURRENCY}}?',
          vars: {
            VARS_SUGGESTED_CURRENCY: ''
          }
        }],
        featList: [[{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#000000',
          text: 'Globally'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000000',
          text: ' Accepted'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#000000',
          text: 'Easily exchangable'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000000',
          text: ' at airports and local vendors'
        }], [{
          type: 'text',
          clickable: false,
          typography: 'labelSmallW2',
          color: '#000000',
          text: ' Lowest exchange rate'
        }, {
          type: 'text',
          clickable: false,
          typography: 'labelSmallW1',
          color: '#000000',
          text: ' vs other currencies'
        }]]
      },
      analytics: {
        trackingKey: 'bms_curSh',
        pdtData: {
          event_detail: {
            event_name: 'component-loaded',
            components: {
              content_details: [{
                id: 'bms_curSh',
                type: 'bottomsheet'
              }]
            },
            event_value: 'currency_search_modal'
          }
        }
      }
    },
    SPECIAL_CASHBACK_BOTTOMSHEET: {
      title: 'Net Effective Amount',
      closeCta: {
        id: 'CLOSE',
        type: 'CLOSE',
        icon: {
          url: 'https://go-assets.ibcdn.com/u/MMT/images/1732609937931-close_icon.png'
        }
      },
      netEffectiveCard: {
        infoItem2: {
          left: [{
            type: 'text',
            color: '#4a4a4a',
            typography: 'labelSmallW1',
            text: 'Net effective amount after cashback:'
          }],
          right: {
            icon: {
              type: 'icon',
              url: 'https://go-assets.ibcdn.com/u/MMT/images/1730196567070-ic_forex_star.png'
            },
            amount: {
              type: 'gradientText',
              gradient: ['#3023AE', '#C86DD7'],
              color: '#8A50C7',
              typography: 'labelMediumW3',
              text: [{
                type: 'text',
                typography: 'labelSmallW3',
                text: '₹{{VARS_NER}}',
                color: '#8A50C7',
                vars: {
                  VARS_NER: ''
                }
              }]
            }
          }
        },
        infoItem3: [{
          type: 'text',
          color: '#4a4a4a',
          typography: 'labelSmallW1',
          text: 'Cashback of ₹{{VARS_CASHBACK}} will be credited to myCash wallet on delivery of your forex. No restriction on usage. Use it to book flights, hotels, bus, cab, insurance and more on Makemytrip app/website.',
          vars: {
            VARS_CASHBACK: ''
          }
        }]
      },
      taxInfo: [{
        type: 'text',
        typography: 'labelSmallW1',
        text: '',
        color: '#757575'
      }],
      analytics: {
        trackingKey: 'bms_amtCl'
      }
    }
  },
  pageConfig: {
    pageName: 'listing',
    redirectionDeferTime: 300
  },
  analytics: {
    pageLoad: {
      analytics: {
        pdtData: {
          event_detail: {
            event_name: 'page-rendered',
            components: {
              content_details: [{
                id: 'tkr',
                type: 'ticker',
                description: 'ner'
              }, {
                id: 'cs_itms',
                type: 'card',
                description: 'USD | null | BUY_NOW_BTN'
              }, {
                id: 'dlv_p_dlvTm',
                type: 'card',
                description: '110001, DEL'
              }, {
                id: 'product_info',
                type: 'info',
                description: '|'
              }, {
                id: 'mkr_bns',
                type: 'card',
                description: ''
              }, {
                id: 'faqs',
                type: 'card',
                description: 'mcc|fcn'
              }]
            }
          }
        }
      }
    },
    pageExit: {
      analytics: {
        pdtData: {
          event_detail: {
            event_name: 'page-exit',
            components: {
              content_details: [{
                id: 'tkr',
                type: 'ticker',
                description: 'ner'
              }, {
                id: 'cs_itms',
                type: 'card',
                description: 'USD | null | BUY_NOW_BTN'
              }, {
                id: 'dlv_p_dlvTm',
                type: 'card',
                description: '110001, DEL'
              }, {
                id: 'product_info',
                type: 'info',
                description: '|'
              }, {
                id: 'mkr_bns',
                type: 'card',
                description: ''
              }, {
                id: 'faqs',
                type: 'card',
                description: 'mcc|fcn'
              }]
            }
          }
        }
      }
    },
    pdtData: {
      user_context: {
        is_logged_in: false
      },
      event_detail: {
        upcoming_trip: {
          intl_travel: false,
          trip_details: []
        },
        delivery_details: {
          is_deliverable: 'true',
          eta: 0,
          is_card_deliverable: true,
          is_currency_deliverable: true,
          detection_source: 'DEFAULT',
          fallback_to_city: false,
          city: 'Delhi',
          city_code: 'DEL',
          state: 'Delhi',
          state_code: 'DEL',
          locus_city_code: 'RGDEL',
          pincode: 110001
        },
        components: {
          content_details: null
        },
        user_details: {
          partner: 'mmt',
          tm_uuid: ''
        }
      },
      page_context: {
        lob: 'forex',
        lob_funnel: 'presales',
        page_name: 'seo-fallback',
        lob_category: 'seo-fallback'
      },
      event_tracking_context: {
        template_id: 154111,
        topic_name: 'tripmoney_forex_b2c_pdt_client_logging',
        bu: 'tripmoney',
        affiliate_id: 'advance_pdt'
      }
    },
    tracking: {
      loginFail: {
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'login-failed',
              components: {
                content_details: [{
                  id: 'login',
                  type: '',
                  description: ''
                }]
              },
              event_value: 'failure'
            }
          }
        }
      },
      loginSuccess: {
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'login-succeeded',
              components: {
                content_details: [{
                  id: 'login',
                  type: '',
                  description: ''
                }]
              },
              event_value: 'success'
            }
          }
        }
      },
      loginBottomSheetLoaded: {
        analytics: {
          pdtData: {
            event_detail: {
              event_name: 'component-loaded',
              components: {
                content_details: [{
                  id: 'bms_login',
                  type: 'bottomsheet',
                  description: ''
                }]
              },
              event_value: 'login_bottomsheet'
            }
          }
        }
      }
    }
  }
};
/* ============================================================================
 * END OF BOT LISTING DATA
 * ============================================================================ */

const initialToastState$1 = {
  userId: null,
  puid: null
};
const userDataSlice = toolkit.createSlice({
  name: 'userSlice',
  initialState: initialToastState$1,
  reducers: {
    setUserData: (state, action) => {
      state.userId = action.payload.userId;
      state.puid = action.payload.puid;
    },
    clearUserData: state => {
      state.userId = null;
      state.puid = null;
    }
  }
});
const {
  setUserData,
  clearUserData
} = userDataSlice.actions;
const userDataReducer = userDataSlice.reducer;

const initialListingApiState = {
  isLoading: false,
  apiState: coreUtils.States.PRELOADING,
  data: {}
};
function createListingRequest(source_type, ...selectedCurrencies) {
  return __awaiter(this, void 0, void 0, function* () {
    const request = {};
    try {
      const deliveryData = commonUi.getTransformedLocationDataFromSessionStorage({
        key: coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
        isEssential: true,
        options: coreUtils.getSessionPiiDataOpts
      });
      if (deliveryData) {
        request.delivery = Object.assign({}, deliveryData);
      } else {
        //@TODO: Get it from navigator api
        // const deliveryFromCache = await bridges.getCachedLocation();
        // if (deliveryFromCache) {
        //   request.delivery = {
        //     latitude: deliveryFromCache.lat.toString(),
        //     longitude: deliveryFromCache.lng.toString(),
        //     detectionSource: 'LATLNG',
        //   };
        // } else {
        //   request.delivery = {};
        // }
      }
    } catch (error) {
      console.error(error);
      request.delivery = {};
    }
    request.products = {};
    if (selectedCurrencies && selectedCurrencies.length > 0) {
      request.products.selectedCurrency = selectedCurrencies;
    } else {
      request.products = {};
    }
    // Add isSeo flag when source_type is 'seo'
    if (isSeoSourceType(source_type)) {
      request.isSeo = true;
    }
    return request;
  });
}
// Async thunk to fetch data from API
const fetchListingData = toolkit.createAsyncThunk('listingApi/fetchListingData', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  const {
    sendPdtData
  } = getPdtLoggerMethods({
    state: thunkAPI.getState()
  });
  const {
    selectedCurrencyCodes = [],
    onSuccess,
    onLoading,
    onError,
    retries = 0,
    reqHeaders,
    isBot = false
  } = payload;
  // Early return for bots with static data
  if (isBot) {
    onLoading === null || onLoading === void 0 ? void 0 : onLoading(coreUtils.States.SUCCESS);
    const staticResponse = botListingData;
    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(staticResponse);
    return staticResponse;
  }
  // Get source_type from store state
  const source_type = (_a = thunkAPI.getState().pageContext) === null || _a === void 0 ? void 0 : _a.source_type;
  const page_name = (_b = thunkAPI.getState().pageContext) === null || _b === void 0 ? void 0 : _b.page_name;
  resetRequestId();
  const fallbackListingData = getListingApiFallbackResponse();
  let finalResponse = fallbackListingData;
  const reqId = getRequestId();
  const apiUrl = `${BFF_BASE_URL}/api/v1/page/listing`;
  try {
    // @TODO: Add page specific headers like x-rq-id, x-jo-id etc.
    onLoading === null || onLoading === void 0 ? void 0 : onLoading(coreUtils.States.LOADING);
    const isUserLoggedIn = yield auth.isUserLoggedin();
    if (!isUserLoggedIn) {
      yield auth.loginIfPartnerLoggedin();
    }
    const headers = coreUtils.getDefaultHeaders();
    if (isSeoSourceType(source_type)) {
      applySeoHeaders(headers, page_name);
    }
    const response = yield coreUtils.fetchWithTimeout(apiUrl, {
      method: 'POST',
      headers: Object.assign(Object.assign(Object.assign({}, headers), {
        [HEADERS.REQUEST_ID]: reqId
      }), reqHeaders),
      body: JSON.stringify(yield createListingRequest(source_type, ...selectedCurrencyCodes))
    });
    const responseObj = yield response.json();
    // sendPageLoadPdtData(responseObj, thunkAPI.getState(), reqId);
    if ((_c = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _c === void 0 ? void 0 : _c['x-jo-id']) {
      coreUtils.setJourneyIdCookie({
        partner: coreUtils.getPartner(),
        journeyId: (_d = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _d === void 0 ? void 0 : _d['x-jo-id']
      });
    }
    thunkAPI.dispatch(setUserData({
      userId: (_f = (_e = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f['x-tm-user-id'],
      puid: (_h = (_g = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _g === void 0 ? void 0 : _g.user) === null || _h === void 0 ? void 0 : _h['x-puid']
    }));
    if (((_k = (_j = responseObj.apiData) === null || _j === void 0 ? void 0 : _j.user) === null || _k === void 0 ? void 0 : _k.is_tm_auth_expired) && retries === 0) {
      yield auth.loginIfPartnerLoggedin();
      payload.retries = payload.retries ? payload.retries + 1 : 1;
      thunkAPI.dispatch(fetchListingData(payload));
      return;
    }
    if (response.ok && responseObj.cardData && ((_l = responseObj.cardData) === null || _l === void 0 ? void 0 : _l.length) > 0) {
      responseObj.selectedCurrency = selectedCurrencyCodes === null || selectedCurrencyCodes === void 0 ? void 0 : selectedCurrencyCodes[0];
      const locationFromBackend = (_m = responseObj === null || responseObj === void 0 ? void 0 : responseObj.apiData) === null || _m === void 0 ? void 0 : _m.location;
      if (locationFromBackend && coreUtils.isObject(locationFromBackend)) {
        commonUi.setTransformedLocationDataToSessionStorage({
          key: coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
          value: locationFromBackend,
          isEssential: true
        });
      }
      onLoading === null || onLoading === void 0 ? void 0 : onLoading(coreUtils.States.SUCCESS);
      finalResponse = responseObj; // = responseObj;
      // return responseObj; // @TODO: Remove this line
      // return responseObj;
    } else {
      //Show fallback response
      //@TODO: ADD Web pdt.
      // pdtTracker.updatePDTData(requestId, null);
      // pdtTracker.trackErrorScreen(responseObj?.error);
      onLoading === null || onLoading === void 0 ? void 0 : onLoading(coreUtils.States.FAILURE);
      finalResponse = fallbackListingData;
      // return fallbackListingData as unknown as ListingResponse;
      const pdtData = {
        event_detail: {
          vendor_error_details: pdtUtils.getVendorErrorDetails({
            error_code: (_o = finalResponse === null || finalResponse === void 0 ? void 0 : finalResponse.error) === null || _o === void 0 ? void 0 : _o.code,
            error_message_shown: ((_p = finalResponse === null || finalResponse === void 0 ? void 0 : finalResponse.error) === null || _p === void 0 ? void 0 : _p.message) || 'Something went wrong',
            api_url: apiUrl
          })
        },
        event_tracking_context: pdtUtils.getEventTrackingContext({
          request_id: (reqHeaders === null || reqHeaders === void 0 ? void 0 : reqHeaders[HEADERS.REQUEST_ID]) || reqId
        })
      };
      sendPdtData(pdtData);
    }
  } catch (error) {
    //Show fallback response
    //@TODO: ADD Web pdt.
    // pdtTracker.updatePDTData(requestId, null);
    // pdtTracker.trackErrorScreen(getListingError(error));
    // return thunkAPI.rejectWithValue(error.message)
    onLoading === null || onLoading === void 0 ? void 0 : onLoading(coreUtils.States.FAILURE);
    finalResponse = fallbackListingData;
    // return fallbackListingData as unknown as ListingResponse;
    const pdtData = {
      event_detail: {
        vendor_error_details: pdtUtils.getVendorErrorDetails({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: error === null || error === void 0 ? void 0 : error.message,
          api_url: apiUrl
        })
      },
      event_tracking_context: pdtUtils.getEventTrackingContext({
        request_id: (reqHeaders === null || reqHeaders === void 0 ? void 0 : reqHeaders[HEADERS.REQUEST_ID]) || reqId
      })
    };
    sendPdtData(pdtData);
  }
  onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(finalResponse);
  return finalResponse;
}));
const listingApiSlice = toolkit.createSlice({
  name: 'listingApi',
  initialState: initialListingApiState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchListingData.pending, (state, action) => {
      state.apiState = action.meta.arg.showLoader ? coreUtils.States.LOADING : coreUtils.States.PRELOADING;
      state.isLoading = true;
    }).addCase(fetchListingData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.apiState = coreUtils.States.SUCCESS;
      state.data = action.payload;
    }).addCase(fetchListingData.rejected, (state, action) => {
      state.isLoading = false;
      state.apiState = coreUtils.States.FAILURE;
      state.data = {};
    });
  },
  selectors: {
    selectListingApiData: state => state === null || state === void 0 ? void 0 : state.data
  }
});
const {
  selectListingApiData
} = listingApiSlice.selectors;
var listingApiSlice$1 = listingApiSlice.reducer;

const initialToastState = {
  showToast: false,
  message: '',
  showCrossIcon: false,
  duration: 3000,
  // default duration in milliseconds
  rightText: ''
};
const toastSlice = toolkit.createSlice({
  name: 'toastData',
  initialState: initialToastState,
  reducers: {
    showToastMessage: (state, action) => {
      state.showToast = true;
      state.message = action.payload.message;
      state.showCrossIcon = action.payload.showCrossIcon;
      state.duration = action.payload.duration;
      state.rightText = action.payload.rightText;
    },
    hideToastMessage: state => {
      state.showToast = false;
      state.message = '';
      state.showCrossIcon = false;
      state.duration = 3000;
    }
  }
});
const {
  showToastMessage,
  hideToastMessage
} = toastSlice.actions;
const toastSliceDataReducer = toastSlice.reducer;

var $$4 = _export;
var call$2 = functionCall;
var iterate$2 = iterate$a;
var aCallable$2 = aCallable$d;
var anObject$2 = anObject$p;
var getIteratorDirect$2 = getIteratorDirect$8;
var iteratorClose$2 = iteratorClose$d;
var iteratorHelperWithoutClosingOnEarlyError$2 = iteratorHelperWithoutClosingOnEarlyError$7;

var findWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$2('find', TypeError);

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
$$4({ target: 'Iterator', proto: true, real: true, forced: findWithoutClosingOnEarlyError }, {
  find: function find(predicate) {
    anObject$2(this);
    try {
      aCallable$2(predicate);
    } catch (error) {
      iteratorClose$2(this, 'throw', error);
    }

    if (findWithoutClosingOnEarlyError) return call$2(findWithoutClosingOnEarlyError, this, predicate);

    var record = getIteratorDirect$2(this);
    var counter = 0;
    return iterate$2(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, { IS_RECORD: true, INTERRUPTED: true }).result;
  }
});

const initialAmountDetails = {
  internationalCurrencyAmount: 0,
  totalAmountInInr: 0,
  netEffectiveRate: 0,
  netEffectiveAmountOnTotalValue: 0,
  cashbackAmount: 0 //Initial it will be 0, or else based on the entered amount and slab it will be calculated.
};
const initialProductData = {
  selectedCurrencyCode: '',
  selectedCurrencyName: '',
  selectedProductType: '',
  searchCurrencyContext: {
    suggestionVisible: false,
    associatedCurrency: [],
    showCurrencySuggestion: false
  },
  searchQueryText: '',
  exchangeRate: 0,
  bestNetEffectiveRate: 0,
  // when user hasn't any entered amount, it will be calculated based on 1 unit of international currency and highest cashback amoount will taken into considerations.
  amountDetails: initialAmountDetails,
  isInternationalCurrencyLoader: false,
  currencyChanged: false
};
const productDataSlice = toolkit.createSlice({
  name: 'forexProductData',
  initialState: initialProductData,
  reducers: {
    setSelectedCurrency: (state, action) => {
      state.selectedCurrencyCode = action.payload.selectedCurrencyCode;
      state.selectedCurrencyName = action.payload.selectedCurrencyName;
    },
    setProductType: (state, action) => {
      state.selectedProductType = action.payload;
    },
    setCurrencyChanged: (state, action) => {
      state.currencyChanged = action.payload;
    },
    setSearchCurrencyContext: (state, action) => {
      state.searchCurrencyContext = action.payload;
    },
    setSearchQueryText: (state, action) => {
      state.searchQueryText = action.payload;
    },
    setInternationalCurrencyAmount: (state, action) => {
      state.amountDetails.internationalCurrencyAmount = action.payload;
    },
    setInternationalCurrencyLoader: (state, action) => {
      state.isInternationalCurrencyLoader = action.payload;
    },
    setAmountDetails: (state, action) => {
      state.amountDetails = action.payload;
    },
    setExchangeRate: (state, action) => {
      state.exchangeRate = action.payload;
    },
    setBestNetEffectiveRate: (state, action) => {
      state.bestNetEffectiveRate = action.payload;
    },
    resetAmountDetails: state => {
      state.amountDetails = initialProductData.amountDetails;
    },
    resetProductType: state => {
      state.selectedProductType = '';
    },
    resetProductsData: state => {
      state.amountDetails = initialAmountDetails;
      // commented this to avoid resetting the product type when the user changes the pincode to keep the product type selected
      // state.selectedProductType = '';
      state.searchQueryText = '';
      state.exchangeRate = 0;
      state.bestNetEffectiveRate = 0;
    }
  },
  selectors: {
    selectForexProductData: state => state
  }
});
// Create a selector that determines which product should be selected based on priority
const selectRecommendedProduct = toolkit.createDraftSafeSelector([state => state.forexProductData.selectedCurrencyCode, state => state.forexProductData.currencyChanged, (state, productItems) => productItems, state => state.forexProductData.selectedProductType], (selectedCurrencyCode, currencyChanged, productItems, selectedProductType) => {
  var _a, _b, _c, _d, _e, _f;
  if (!productItems || !selectedCurrencyCode) {
    return null;
  }
  // Find CARD and CURRENCY products
  const cardProduct = productItems.find(item => (item === null || item === void 0 ? void 0 : item.productType) === commonUi.PRODUCT_TYPE.CARD);
  const currencyProduct = productItems.find(item => (item === null || item === void 0 ? void 0 : item.productType) === commonUi.PRODUCT_TYPE.CURRENCY);
  const isCardDisabled = (_c = (_b = (_a = cardProduct === null || cardProduct === void 0 ? void 0 : cardProduct.currency) === null || _a === void 0 ? void 0 : _a[selectedCurrencyCode]) === null || _b === void 0 ? void 0 : _b.disabled) !== null && _c !== void 0 ? _c : true;
  const isCurrencyDisabled = (_f = (_e = (_d = currencyProduct === null || currencyProduct === void 0 ? void 0 : currencyProduct.currency) === null || _d === void 0 ? void 0 : _d[selectedCurrencyCode]) === null || _e === void 0 ? void 0 : _e.disabled) !== null && _f !== void 0 ? _f : true;
  const isCardSelected = cardProduct === null || cardProduct === void 0 ? void 0 : cardProduct.selected;
  const isCurrencySelected = currencyProduct === null || currencyProduct === void 0 ? void 0 : currencyProduct.selected;
  const isCurrencyPreviouslySelected = selectedProductType === commonUi.PRODUCT_TYPE.CURRENCY;
  const isCardPreviouslySelected = selectedProductType === commonUi.PRODUCT_TYPE.CARD;
  // Priority logic: producte selected from backend, then previous selected product by user, then nothing
  if (!isCardDisabled && cardProduct && (isCardSelected && !isCurrencySelected || !isCardDisabled && isCardPreviouslySelected)) {
    return cardProduct;
  } else if (!isCurrencyDisabled && currencyProduct && isCurrencySelected && !isCardSelected || !isCurrencyDisabled && isCurrencyPreviouslySelected) {
    return currencyProduct;
  } else {
    return null; // Both are disabled
  }
});
const {
  selectForexProductData
} = productDataSlice.selectors;
const productDataSliceReducer = productDataSlice.reducer;
const {
  setSelectedCurrency,
  setProductType,
  setSearchCurrencyContext,
  setSearchQueryText,
  setInternationalCurrencyAmount,
  setInternationalCurrencyLoader,
  setAmountDetails,
  setExchangeRate,
  setBestNetEffectiveRate,
  resetAmountDetails,
  resetProductType,
  setCurrencyChanged,
  resetProductsData
} = productDataSlice.actions;

const PincodeBottomSheet = ({
  onModalClose,
  data,
  setShowPincodePopup
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const [selectedCity, setSelectedCity] = React.useState(undefined);
  const [enteredPincode, setEnteredPincode] = React.useState('');
  // const { sendPdtData } = getPdtLoggerMethods({
  //   state: useAppSelector(state => state),
  // });
  const {
    isLoading: isLoadingGeoLocationCoordinated,
    isError: isErrorGeolocationCoordinate,
    location: geoLocationData,
    error: errorGeolocationCoordinate,
    setUserLocation,
    resetGeoLocationState
  } = commonUi.useGeoLocation();
  const dispatch = useAppDispatch();
  const {
    error: locationApiError,
    data: locationApiData,
    apiState: locationApiState
  } = useAppSelector(state => state.locationApi);
  const {
    selectedCurrencyCode
  } = useAppSelector(state => state.forexProductData);
  const device = commonUi.useDevice();
  React.useEffect(() => {
    var _a;
    pdtUtils.trackEvent({
      eventData: (_a = data === null || data === void 0 ? void 0 : data.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
    return () => {
      var _a, _b;
      pdtUtils.trackEvent({
        eventData: (_b = (_a = data === null || data === void 0 ? void 0 : data.closeCta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
      });
    };
  }, []);
  function callListingApi(locationApiResponse) {
    var _a, _b, _c;
    const fallbackToCity = (_c = (_b = (_a = locationApiResponse === null || locationApiResponse === void 0 ? void 0 : locationApiResponse.apiData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.delivery) === null || _c === void 0 ? void 0 : _c.fallbackToCity;
    if (!fallbackToCity) {
      setShowPincodePopup === null || setShowPincodePopup === void 0 ? void 0 : setShowPincodePopup(false);
      setEnteredPincode('');
      dispatch(fetchListingData({
        showLoader: false,
        selectedCurrencyCodes: [selectedCurrencyCode],
        onLoading: state => {
          if (state === coreUtils.States.LOADING) {
            dispatch(showToastMessage({
              message: commonUi.TOAST_MESSAGES.LOCATION_UPDATE,
              duration: 10000
            }));
          } else if (state === coreUtils.States.FAILURE) {
            dispatch(dispatch(resetProductsData()));
          }
        },
        onSuccess: () => {
          // commented this to avoid resetting the product type when the user changes the pincode to keep the product type selected
          // dispatch(resetProductType());
          dispatch(hideToastMessage());
        }
      }));
    }
  }
  function onSuccessFetchingGeolocationCoordinates(latitude, longitude) {
    const reqId = coreUtils.generateUUID();
    dispatch(fetchLocationApiData({
      reqHeaders: {
        [HEADERS.REQUEST_ID]: reqId
      },
      requestBody: {
        latitude: String(latitude),
        longitude: String(longitude),
        detectionSource: LOCATION_DETECTION_SOURCE.COORDINATES
      },
      onSuccess: locationApiResponse => {
        var _a, _b;
        if ((_a = locationApiResponse === null || locationApiResponse === void 0 ? void 0 : locationApiResponse.apiData) === null || _a === void 0 ? void 0 : _a.pdtData) {
          const pdtData = deepCopy((_b = locationApiResponse === null || locationApiResponse === void 0 ? void 0 : locationApiResponse.apiData) === null || _b === void 0 ? void 0 : _b.pdtData);
          if (pdtData.event_tracking_context) {
            pdtData.event_tracking_context.request_id = reqId;
          } else {
            pdtData.event_tracking_context = {
              request_id: reqId
            };
          }
          pdtUtils.trackEvent({
            eventData: pdtData
          });
        }
        callListingApi(locationApiResponse);
      }
    }));
  }
  function getSnackBarErrorTextForLocation() {
    var _a, _b;
    if (locationApiError) {
      return (_b = (_a = locationApiError === null || locationApiError === void 0 ? void 0 : locationApiError.apiData) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message;
    }
    if (isErrorGeolocationCoordinate) {
      return errorGeolocationCoordinate === null || errorGeolocationCoordinate === void 0 ? void 0 : errorGeolocationCoordinate.message;
    }
  }
  function isLoadingStatus() {
    return isLoadingGeoLocationCoordinated || locationApiState === coreUtils.States.LOADING;
  }
  /* Start Event Handlers */
  const onCityOptionClick = city => {
    var _a, _b, _c, _d, _e, _f;
    const reqId = coreUtils.generateUUID();
    setSelectedCity(city === null || city === void 0 ? void 0 : city.cityCode);
    if (((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.cityFallback) === null || _a === void 0 ? void 0 : _a.citySelectCta) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.pdtData) && (city === null || city === void 0 ? void 0 : city.cityCode)) {
      const pdtData = pdtUtils.updatePdtDataDescription((_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.cityFallback) === null || _d === void 0 ? void 0 : _d.citySelectCta) === null || _e === void 0 ? void 0 : _e.analytics) === null || _f === void 0 ? void 0 : _f.pdtData, city === null || city === void 0 ? void 0 : city.cityCode);
      pdtUtils.trackEvent({
        eventData: pdtData
      });
    }
    dispatch(fetchLocationApiData({
      reqHeaders: {
        [HEADERS.REQUEST_ID]: reqId
      },
      requestBody: {
        pincode: enteredPincode,
        cityCode: city === null || city === void 0 ? void 0 : city.cityCode,
        locusCityCode: city === null || city === void 0 ? void 0 : city.locusCityCode,
        detectionSource: LOCATION_DETECTION_SOURCE.CITY_FALLBACK
      },
      onSuccess: locationApiResponse => {
        var _a, _b;
        if ((_a = locationApiResponse === null || locationApiResponse === void 0 ? void 0 : locationApiResponse.apiData) === null || _a === void 0 ? void 0 : _a.pdtData) {
          const pdtData = deepCopy((_b = locationApiResponse === null || locationApiResponse === void 0 ? void 0 : locationApiResponse.apiData) === null || _b === void 0 ? void 0 : _b.pdtData);
          if (pdtData.event_tracking_context) {
            pdtData.event_tracking_context.request_id = reqId;
          } else {
            pdtData.event_tracking_context = {
              request_id: reqId
            };
          }
          pdtUtils.trackEvent({
            eventData: pdtData
          });
        }
        callListingApi(locationApiResponse);
      }
    }));
  };
  const detectLoctionHandler = () => {
    var _a, _b;
    pdtUtils.trackEvent({
      eventData: (_b = (_a = data === null || data === void 0 ? void 0 : data.cta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
    if (locationApiError || locationApiData) dispatch(resetLocationApiData());
    if (geoLocationData) resetGeoLocationState();
    setUserLocation(onSuccessFetchingGeolocationCoordinates);
  };
  const pincodeChangeHandler = e => {
    const reqId = coreUtils.generateUUID();
    if (FormValidation.isInValidPincode(e.target.value, 6)) {
      return;
    }
    if (FormValidation.isDigitsOnly(e.target.value)) {
      if (geoLocationData) resetGeoLocationState();
      if (locationApiError || locationApiData) dispatch(resetLocationApiData());
      setEnteredPincode(e.target.value);
      const isValidPincode = FormValidation.validIndianPincode(e.target.value);
      if (isValidPincode) {
        dispatch(fetchLocationApiData({
          reqHeaders: {
            [HEADERS.REQUEST_ID]: reqId
          },
          requestBody: {
            pincode: e.target.value,
            detectionSource: LOCATION_DETECTION_SOURCE.PINCODE
          },
          onSuccess: locationApiResponse => {
            var _a, _b;
            if ((_a = locationApiResponse === null || locationApiResponse === void 0 ? void 0 : locationApiResponse.apiData) === null || _a === void 0 ? void 0 : _a.pdtData) {
              const pdtData = deepCopy((_b = locationApiResponse === null || locationApiResponse === void 0 ? void 0 : locationApiResponse.apiData) === null || _b === void 0 ? void 0 : _b.pdtData);
              if (pdtData.event_tracking_context) {
                pdtData.event_tracking_context.request_id = reqId;
              } else {
                pdtData.event_tracking_context = {
                  request_id: reqId
                };
              }
              const pdtDataToSend = {
                event_detail: Object.assign(Object.assign({}, pdtData === null || pdtData === void 0 ? void 0 : pdtData.event_detail), {
                  components: {
                    content_details: [{
                      description: e.target.value,
                      id: 'bms_loc',
                      type: 'cta'
                    }]
                  }
                })
              };
              pdtUtils.trackEvent({
                eventData: pdtDataToSend
              });
            }
            callListingApi(locationApiResponse);
          }
        }));
      }
    }
  };
  /* End Event Handlers*/
  return device === commonUi.DEVICE.MOBILE ? jsxRuntime.jsx(designSystem.Modal, {
    modalType: "bottomSheet",
    heading: isLoadingStatus() ? (_a = data === null || data === void 0 ? void 0 : data.loader) === null || _a === void 0 ? void 0 : _a.title : data === null || data === void 0 ? void 0 : data.title,
    onModalClose: onModalClose,
    showCloseButton: true,
    children: isLoadingStatus() ? jsxRuntime.jsx(SpinnerLoader, {
      text: (_b = data === null || data === void 0 ? void 0 : data.loader) === null || _b === void 0 ? void 0 : _b.description,
      spinnerColor: (_c = data === null || data === void 0 ? void 0 : data.loader) === null || _c === void 0 ? void 0 : _c.loaderColor
    }) : jsxRuntime.jsx(PincodePopupCont, {
      children: jsxRuntime.jsx(PincodeContent, {
        bottomSheetData: data,
        // errorStateText={errorStateText}
        errorSnackBarText: getSnackBarErrorTextForLocation(),
        cities: (_e = (_d = locationApiData === null || locationApiData === void 0 ? void 0 : locationApiData.apiData) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.fallbackCityList,
        requestId: locationApiData === null || locationApiData === void 0 ? void 0 : locationApiData.requestId,
        onPincodeChange: pincodeChangeHandler,
        onDetectLocationClick: detectLoctionHandler,
        selectedCity: selectedCity,
        onCityOptionClick: onCityOptionClick,
        pincodeValue: enteredPincode,
        isLoading: isLoadingStatus()
      })
    })
  }) : jsxRuntime.jsx(PincodePopupCont, {
    children: jsxRuntime.jsx(PincodeContent, {
      bottomSheetData: data,
      // errorStateText={errorStateText}
      errorSnackBarText: getSnackBarErrorTextForLocation(),
      requestId: locationApiData === null || locationApiData === void 0 ? void 0 : locationApiData.requestId,
      cities: (_g = (_f = locationApiData === null || locationApiData === void 0 ? void 0 : locationApiData.apiData) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.fallbackCityList,
      onPincodeChange: pincodeChangeHandler,
      onDetectLocationClick: detectLoctionHandler,
      selectedCity: selectedCity,
      onCityOptionClick: onCityOptionClick,
      pincodeValue: enteredPincode,
      isLoading: isLoadingStatus()
    })
  });
};

var $$3 = _export;
var call$1 = functionCall;
var iterate$1 = iterate$a;
var aCallable$1 = aCallable$d;
var anObject$1 = anObject$p;
var getIteratorDirect$1 = getIteratorDirect$8;
var iteratorClose$1 = iteratorClose$d;
var iteratorHelperWithoutClosingOnEarlyError$1 = iteratorHelperWithoutClosingOnEarlyError$7;

var everyWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$1('every', TypeError);

// `Iterator.prototype.every` method
// https://tc39.es/ecma262/#sec-iterator.prototype.every
$$3({ target: 'Iterator', proto: true, real: true, forced: everyWithoutClosingOnEarlyError }, {
  every: function every(predicate) {
    anObject$1(this);
    try {
      aCallable$1(predicate);
    } catch (error) {
      iteratorClose$1(this, 'throw', error);
    }

    if (everyWithoutClosingOnEarlyError) return call$1(everyWithoutClosingOnEarlyError, this, predicate);

    var record = getIteratorDirect$1(this);
    var counter = 0;
    return !iterate$1(record, function (value, stop) {
      if (!predicate(value, counter++)) return stop();
    }, { IS_RECORD: true, INTERRUPTED: true }).stopped;
  }
});

const SelectCurrencyWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SelectCurrencyWrapper",
  componentId: "sc-1lrne7g-0"
})(["background:", ";"], ({
  theme
}) => theme.colors.white);
const SelectCurrencyHeader = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SelectCurrencyHeader",
  componentId: "sc-1lrne7g-1"
})(["height:70px;display:flex;flex-direction:column;"]);
const Scroller = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__Scroller",
  componentId: "sc-1lrne7g-2"
})(["overflow-y:scroll;height:379px;padding:12px 24px;@media ", "{padding:12px 16px;box-shadow:1px 1px 6px #00000033;}@media ", "{height:calc(100vh - 200px);padding:0;}"], commonUi.deviceType.desktop, commonUi.deviceType.mobile);
const CurrencyListHeader = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__CurrencyListHeader",
  componentId: "sc-1lrne7g-3"
})(["display:flex;flex-direction:row;padding:12px 8px;background:", ";justify-content:space-between;align-items:flex-start;@media ", "{border-bottom:1px solid ", ";padding:12px 0px;}"], ({
  theme
}) => theme.colors.white, commonUi.deviceType.mobile, ({
  theme
}) => theme.colors.borderBottomGreyColor);
const CountryList = /*#__PURE__*/styled__default.default.ul.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__CountryList",
  componentId: "sc-1lrne7g-4"
})(["li{display:flex;cursor:pointer;padding:16px 8px;@media ", "{border-bottom:1px solid ", ";padding:16px 0px;}@media ", "{&:hover{background-color:", ";border-radius:", ";}}}li .highlight{background-color:", ";}li:last-child{border-bottom:unset;}"], commonUi.deviceType.mobile, ({
  theme
}) => theme.colors.borderBottomGreyColor, commonUi.deviceType.desktop, ({
  theme
}) => theme.colors.bodyBg, ({
  theme
}) => theme.borderRadius.br2, ({
  theme
}) => theme.colors.bgLight);
const CurrencyDetailsWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__CurrencyDetailsWrapper",
  componentId: "sc-1lrne7g-5"
})(["display:flex;flex-direction:row;gap:10px;cursor:pointer;justify-content:space-between;align-items:flex-start;flex:1;"]);
const LeftLabelWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__LeftLabelWrapper",
  componentId: "sc-1lrne7g-6"
})(["gap:0px;display:flex;flex-direction:row;align-items:center;cursor:pointer;"]);
const SubLabel = /*#__PURE__*/styled__default.default.p.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SubLabel",
  componentId: "sc-1lrne7g-7"
})(["", ""], props => {
  const {
    theme,
    typography = designTokens.TYPOGRAPHY_KEYS.baseW1,
    color,
    textAlign
  } = props;
  const fontStyles = designTokens.getTypographyStyles(typography, theme.partner);
  return styled.css(["", " ", " font-family:", ";color:", ";text-align:", ";"], designTokens.getFontSizeStyles(fontStyles.fontSize, designTokens.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, color || theme.colors.mediumW3, textAlign);
});
const Span = /*#__PURE__*/styled__default.default.span.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__Span",
  componentId: "sc-1lrne7g-8"
})(["", ""], props => {
  const {
    theme,
    typography = designTokens.TYPOGRAPHY_KEYS.baseW1,
    color
  } = props;
  const fontStyles = designTokens.getTypographyStyles(typography, theme.partner);
  return styled.css(["", " ", " font-family:", ";color:", ";"], designTokens.getFontSizeStyles(fontStyles.fontSize, designTokens.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, color || theme.colors.mediumW3);
});
const TagContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__TagContainer",
  componentId: "sc-1lrne7g-9"
})(["max-width:200px;word-break:break-word;"]);
const SelectCurrencyWebCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__SelectCurrencyWebCont",
  componentId: "sc-1lrne7g-11"
})(["background:", ";width:393px;max-height:390px;border-radius:4px;box-shadow:0px 1px 5px #00000033;"], ({
  theme
}) => theme.colors.white);
const CurrencySearchCont = /*#__PURE__*/styled__default.default(designSystem.SearchInput).withConfig({
  displayName: "SelectCurrencyBottomSheetstyles__CurrencySearchCont",
  componentId: "sc-1lrne7g-12"
})(["@media ", "{box-shadow:0px 2px 3px 0px #0000001a;padding:11px;position:sticky;top:0;z-index:1;}"], commonUi.deviceType.desktop);

var lengthOfArrayLike$1 = lengthOfArrayLike$8;
var toIntegerOrInfinity = toIntegerOrInfinity$8;

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
var arrayWith$1 = function (O, C, index, value) {
  var len = lengthOfArrayLike$1(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};

var $$2 = _export;
var arrayWith = arrayWith$1;
var toIndexedObject = toIndexedObject$7;

var $Array = Array;

// Firefox bug
var INCORRECT_EXCEPTION_ON_COERCION_FAIL = (function () {
  try {
    // eslint-disable-next-line es/no-array-prototype-with, no-throw-literal -- needed for testing
    []['with']({ valueOf: function () { throw 4; } }, null);
  } catch (error) {
    return error !== 4;
  }
})();

// `Array.prototype.with` method
// https://tc39.es/ecma262/#sec-array.prototype.with
$$2({ target: 'Array', proto: true, forced: INCORRECT_EXCEPTION_ON_COERCION_FAIL }, {
  'with': function (index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
});

const CurrencySuggestionWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySuggestionstyle__CurrencySuggestionWrapper",
  componentId: "sc-1l26o7p-0"
})(["border:1px solid ", ";border-radius:", ";margin:12px 0px;"], ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.borderRadius.br8);
const USDInfo = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySuggestionstyle__USDInfo",
  componentId: "sc-1l26o7p-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;background:", ";padding:12px;border-radius:8px 8px 0px 0px;margin:0px 0px 16px;"], ({
  theme
}) => theme.colors.screenBg);
const WhyInfoWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySuggestionstyle__WhyInfoWrapper",
  componentId: "sc-1l26o7p-2"
})(["padding:0px 12px 12px;margin:2px 0px 0px;"]);
const LabelBar = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySuggestionstyle__LabelBar",
  componentId: "sc-1l26o7p-3"
})(["width:2px;height:8px;border-radius:2px;background:#084373;"]);
const FeatureWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySuggestionstyle__FeatureWrapper",
  componentId: "sc-1l26o7p-4"
})(["margin:6px 0px 0px;"]);
const InnerWrapper$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySuggestionstyle__InnerWrapper",
  componentId: "sc-1l26o7p-5"
})(["flex-direction:row;align-items:center;gap:10px;padding:0;display:flex;"]);

const CurrencySuggestion = ({
  recommendedCurrencyInfo
}) => {
  var _a, _b;
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(CurrencySuggestionWrapper, {
    children: [jsxRuntime.jsx(USDInfo, {
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: recommendedCurrencyInfo === null || recommendedCurrencyInfo === void 0 ? void 0 : recommendedCurrencyInfo.title,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.highEmphasis
      })
    }), jsxRuntime.jsxs(WhyInfoWrapper, {
      children: [jsxRuntime.jsx(designSystem.FormattedText, {
        text: recommendedCurrencyInfo === null || recommendedCurrencyInfo === void 0 ? void 0 : recommendedCurrencyInfo.label,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
        color: theme.colors.lowEmphasis
      }), (_b = (_a = recommendedCurrencyInfo === null || recommendedCurrencyInfo === void 0 ? void 0 : recommendedCurrencyInfo.featList) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, (item, index) => jsxRuntime.jsx(FeatureWrapper, {
        children: jsxRuntime.jsxs(InnerWrapper$1, {
          children: [jsxRuntime.jsx(LabelBar, {}), jsxRuntime.jsx(designSystem.FormattedText, {
            color: theme.colors.highEmphasis,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
            text: item
          })]
        })
      }, index.toString()))]
    })]
  });
};

const UncommonCurrency = ({
  data
}) => {
  const {
    searchCurrencyContext: {
      associatedCurrency,
      showCurrencySuggestion
    }
  } = useAppSelector(state => state.forexProductData);
  const getRecommendedCurrencyInfo = () => {
    var _a, _b, _c, _d;
    const currName = (_b = (_a = associatedCurrency === null || associatedCurrency === void 0 ? void 0 : associatedCurrency[0]) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.leftLabel;
    const withName = (_d = (_c = associatedCurrency === null || associatedCurrency === void 0 ? void 0 : associatedCurrency[0]) === null || _c === void 0 ? void 0 : _c.with) === null || _d === void 0 ? void 0 : _d.currencyName;
    return coreUtils.hydrateVars(data === null || data === void 0 ? void 0 : data.currencyUnavailableSection, {
      [commonUi.RTVars.SEARCHED_CURRENCY]: withName !== null && withName !== void 0 ? withName : '',
      [commonUi.RTVars.SUGGESTED_CURRENCY]: currName !== null && currName !== void 0 ? currName : ''
    });
  };
  if (associatedCurrency.length >= 1) {
    // Shown in case of currency not available
    const recommendedCurrencyInfo = getRecommendedCurrencyInfo();
    return jsxRuntime.jsx(CurrencySuggestion, {
      recommendedCurrencyInfo: recommendedCurrencyInfo
    });
  } else if (showCurrencySuggestion) {
    // Shown when no currency is matched.
    const suggestionSectionHydrated = coreUtils.hydrateVars(data === null || data === void 0 ? void 0 : data.suggestionSection, {});
    return jsxRuntime.jsx(CurrencySuggestion, {
      recommendedCurrencyInfo: suggestionSectionHydrated
    });
  }
  return null;
};

const SelectCurrency = ({
  value,
  onChange,
  currencyItemHandler,
  currencyData,
  showHighlighter: _showHighlighter = true,
  isFetchingRate,
  notFoundText,
  data
}) => {
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  const {
    searchCurrencyContext: {
      suggestionVisible
    }
  } = useAppSelector(state => state.forexProductData);
  const searchQueryHighlighter = (ele, nameToSearch) => {
    var _a;
    const withSpecialCharsSupport = value === null || value === void 0 ? void 0 : value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const searchRegex = new RegExp(`(${withSpecialCharsSupport})`, 'ig');
    const highlighted = (_a = ele[nameToSearch]) === null || _a === void 0 ? void 0 : _a.replace(searchRegex, match => `<span class=${_showHighlighter ? 'highlight' : ''}>${match}</span>`);
    return jsxRuntime.jsx(TagContainer, {
      children: jsxRuntime.jsx(SubLabel, {
        dangerouslySetInnerHTML: {
          __html: `${highlighted}`
        },
        typography: nameToSearch === 'rightLabel' ? designTokens.TYPOGRAPHY_KEYS.baseW1 : designTokens.TYPOGRAPHY_KEYS.smallW2,
        color: nameToSearch === 'rightLabel' ? theme.colors.mediumEmphasis : theme.colors.highEmphasis,
        textAlign: nameToSearch === 'rightLabel' ? 'right' : 'left'
      })
    });
  };
  const spinnerLoader = isFetchingRate ? jsxRuntime.jsx(designSystem.Spinner, {
    spinnerWidth: 20
  }) : jsxRuntime.jsx(React.Fragment, {});
  return jsxRuntime.jsxs(SelectCurrencyWrapper, {
    children: [device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(SelectCurrencyHeader, {
      children: jsxRuntime.jsx(designSystem.FloatingTextField, {
        value: value,
        labelTxt: "Search Currency",
        onChange: onChange,
        inputId: "select-currency-dropdown"
      })
    }), device === commonUi.DEVICE.DESKTOP && jsxRuntime.jsx(CurrencySearchCont, {
      value: value,
      onChange: onChange,
      placeholder: 'Enter Currency name',
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/ic_search_d1a7160d93.png",
      ImageHeight: "9px",
      ImageWidth: "9px",
      autoFocus: true
    }), currencyData && jsxRuntime.jsx(Scroller, {
      children: (currencyData === null || currencyData === void 0 ? void 0 : currencyData.every(item => {
        var _a;
        return !(item === null || item === void 0 ? void 0 : item.currencyList) || ((_a = item === null || item === void 0 ? void 0 : item.currencyList) === null || _a === void 0 ? void 0 : _a.length) === 0;
      })) ? jsxRuntime.jsx(designSystem.FormattedText, {
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
        text: notFoundText,
        color: theme.colors.mediumEmphasis,
        margin: "0 0 16px"
      }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [currencyData === null || currencyData === void 0 ? void 0 : currencyData.map(item => {
          var _a;
          return item.currencyList.length > 0 && jsxRuntime.jsxs(React.Fragment, {
            children: [jsxRuntime.jsxs(CurrencyListHeader, {
              id: "currency-section-id",
              children: [jsxRuntime.jsx(designSystem.FormattedText, {
                text: item === null || item === void 0 ? void 0 : item.leftLabel,
                typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.smallW3 : designTokens.TYPOGRAPHY_KEYS.baseW2,
                color: device === commonUi.DEVICE.MOBILE ? theme.colors.highEmphasis : theme.colors.mediumEmphasis
              }), jsxRuntime.jsx(designSystem.FormattedText, {
                text: item === null || item === void 0 ? void 0 : item.rightLabel,
                typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.smallW3 : designTokens.TYPOGRAPHY_KEYS.baseW2,
                color: device === commonUi.DEVICE.MOBILE ? theme.colors.highEmphasis : theme.colors.mediumEmphasis
              })]
            }), jsxRuntime.jsx(CountryList, {
              id: "country-list-wpr-id",
              children: (_a = item === null || item === void 0 ? void 0 : item.currencyList) === null || _a === void 0 ? void 0 : _a.map((ele, index) => {
                var _a;
                return jsxRuntime.jsxs("li", {
                  onClick: e => {
                    e.stopPropagation();
                    currencyItemHandler === null || currencyItemHandler === void 0 ? void 0 : currencyItemHandler(ele, item.id, index);
                  },
                  children: [device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(designSystem.RadioButton, {
                    inputId: index.toString(),
                    isChecked: !!ele.isChecked,
                    inputIndex: index,
                    showLabel: false
                  }), jsxRuntime.jsxs(CurrencyDetailsWrapper, {
                    children: [ele.leftSubLabel ? jsxRuntime.jsxs("div", {
                      children: [jsxRuntime.jsxs(LeftLabelWrapper, {
                        children: [searchQueryHighlighter(ele, 'leftLabel'), ele.isChecked && spinnerLoader]
                      }), jsxRuntime.jsx(SubLabel, {
                        dangerouslySetInnerHTML: {
                          __html: (_a = ele.leftSubLabel) === null || _a === void 0 ? void 0 : _a.value
                        }
                      })]
                    }) : jsxRuntime.jsxs(LeftLabelWrapper, {
                      children: [searchQueryHighlighter(ele, 'leftLabel'), ele.isChecked && spinnerLoader]
                    }), jsxRuntime.jsx(Span, {
                      children: searchQueryHighlighter(ele, 'rightLabel')
                    })]
                  })]
                }, ele.id);
              })
            })]
          }, item.id);
        }), suggestionVisible && jsxRuntime.jsx(UncommonCurrency, {
          data: data
        })]
      })
    })]
  });
};

const SelectCurrencyBottomSheet = ({
  onModalClose,
  data,
  value,
  onChange,
  currencyItemHandler,
  currencyData,
  isFetchingRate,
  notFoundText
}) => {
  return jsxRuntime.jsx(designSystem.Modal, {
    modalType: 'fullPage',
    onModalClose: onModalClose,
    heading: (data === null || data === void 0 ? void 0 : data.title) || 'Select Currency',
    backBtn: jsxRuntime.jsx(designSystem.Image, {
      src: 'https://tripmoneycmsimgak.mmtcdn.com/img/Close_c959c0738b.png'
    }),
    "data-testid": "CURRENCY_SEARCH_BOTTOMSHEET",
    children: jsxRuntime.jsx(SelectCurrency, {
      value: value,
      onChange: onChange,
      showHighlighter: true,
      currencyItemHandler: currencyItemHandler,
      isFetchingRate: isFetchingRate,
      currencyData: currencyData,
      notFoundText: notFoundText,
      data: data
    })
  });
};

const SelectCurrencyDweb = ({
  onModalClose,
  data,
  value,
  onChange,
  currencyItemHandler,
  currencyData,
  isFetchingRate,
  notFoundText
}) => {
  return jsxRuntime.jsx(SelectCurrencyWebCont, {
    children: jsxRuntime.jsx(SelectCurrency, {
      value: value,
      onChange: onChange,
      showHighlighter: true,
      currencyItemHandler: currencyItemHandler,
      isFetchingRate: isFetchingRate,
      currencyData: currencyData,
      notFoundText: notFoundText,
      data: data
    })
  });
};

const SelectCurrencyModal = ({
  onModalClose,
  data,
  currencyData,
  isFetchingRate,
  notFoundText,
  currencyItemHandler,
  onChange,
  inputValue
}) => {
  const device = commonUi.useDevice();
  React.useEffect(() => {
    var _a;
    pdtUtils.trackEvent({
      eventData: (_a = data === null || data === void 0 ? void 0 : data.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
  }, []);
  // const [selectedOptionsCounter, setSelectedOptionsCounter] = useState(0);
  // const [selectCountryData, setSelectCountryData] = useState(currencyData);
  // const dispatch = useAppDispatch();
  // // Update this according to the requirement
  // const currencyItemHandler = (
  //   item: CurrencyListProps,
  //   type: string,
  //   idx: number
  // ) => {
  //   const newData = selectCountryData.map(outerListPoint => {
  //     if (outerListPoint.id === type) {
  //       const newList = outerListPoint.currencyList.map(ele => {
  //         if (ele.id === item.id) {
  //           if (ele.isChecked) {
  //             ele.isChecked = false;
  //             setSelectedOptionsCounter(selectedOptionsCounter - 1);
  //           } else {
  //             ele.isChecked = true;
  //             ele.leftSubLabel = {
  //               type: 'SUCCESS',
  //               value: 'Exchange Rate: 100',
  //             };
  //             setSelectedOptionsCounter(selectedOptionsCounter + 1);
  //           }
  //         }
  //         return ele;
  //       });
  //       outerListPoint.currencyList = newList;
  //     }
  //     return outerListPoint;
  //   });
  //   setSelectCountryData(newData);
  // };
  return device === commonUi.DEVICE.MOBILE ? jsxRuntime.jsx(SelectCurrencyBottomSheet, {
    isFetchingRate: isFetchingRate,
    value: inputValue,
    onChange: onChange,
    currencyData: currencyData,
    notFoundText: notFoundText,
    onModalClose: onModalClose,
    currencyItemHandler: (ele, id, index) => currencyItemHandler === null || currencyItemHandler === void 0 ? void 0 : currencyItemHandler(ele, id, index),
    data: data
  }) : jsxRuntime.jsx(SelectCurrencyDweb, {
    isFetchingRate: isFetchingRate,
    value: inputValue,
    onChange: e => {
      onChange === null || onChange === void 0 ? void 0 : onChange(e);
    },
    currencyData: currencyData,
    notFoundText: notFoundText,
    onModalClose: onModalClose,
    currencyItemHandler: (ele, id, index) => currencyItemHandler === null || currencyItemHandler === void 0 ? void 0 : currencyItemHandler(ele, id, index),
    data: data
  });
};

const CustomTextField = /*#__PURE__*/styled__default.default(designSystem.FloatingTextField).withConfig({
  displayName: "AmountBottomSheetstyles__CustomTextField",
  componentId: "sc-3fssdd-0"
})(["flex:1;& input{width:100%;}"]);
const Headline = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__Headline",
  componentId: "sc-3fssdd-1"
})(["display:flex;column-gap:8px;"]);
const CustomFormattedText = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "AmountBottomSheetstyles__CustomFormattedText",
  componentId: "sc-3fssdd-2"
})(["max-width:230px;"]);
const StyledHr = /*#__PURE__*/styled__default.default.hr.withConfig({
  displayName: "AmountBottomSheetstyles__StyledHr",
  componentId: "sc-3fssdd-3"
})(["width:165px;margin-top:12px;border:none;border-top:", ";"], ({
  theme
}) => `1px solid ${theme.colors.greyBorder}`);
const CompareIconImage = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "AmountBottomSheetstyles__CompareIconImage",
  componentId: "sc-3fssdd-4"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:10;pointer-events:none;"]);
const AmountCalContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__AmountCalContainer",
  componentId: "sc-3fssdd-5"
})(["display:flex;flex-direction:column;"]);
const Row$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__Row",
  componentId: "sc-3fssdd-6"
})(["display:flex;align-items:center;justify-content:space-between;margin:12px 0;position:relative;gap:12px;"]);
const Card = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__Card",
  componentId: "sc-3fssdd-7"
})(["background:", ";padding:12px;border-radius:8px;"], ({
  theme
}) => theme.colors.lightPurple);
const FlexRow = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__FlexRow",
  componentId: "sc-3fssdd-8"
})(["display:flex;gap:4px;margin:", ";"], ({
  margin
}) => margin);
const AmountTextRow = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__AmountTextRow",
  componentId: "sc-3fssdd-9"
})(["display:flex;gap:2px;margin:", ";align-items:center;"], ({
  margin
}) => margin);
const CardFooter = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__CardFooter",
  componentId: "sc-3fssdd-10"
})(["margin:12px 0 0;"]);
const ButtonCont$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountBottomSheetstyles__ButtonCont",
  componentId: "sc-3fssdd-11"
})(["@media ", "{display:flex;justify-content:flex-end;box-shadow:0px 1px 6px 0px #00000033;}"], commonUi.deviceType.desktop);
const AddButton = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "AmountBottomSheetstyles__AddButton",
  componentId: "sc-3fssdd-12"
})(["@media ", "{margin:19px 0px;border-radius:30px;width:auto;}"], commonUi.deviceType.desktop);

const AmountRow = ({
  fromHint,
  toHint,
  onFromHintChange,
  onToHintChange,
  fromHintValue,
  toHintValue
}) => {
  return jsxRuntime.jsxs(Row$1, {
    children: [jsxRuntime.jsx(CompareIconImage, {
      src: 'https://tripmoneycmsimgak.mmtcdn.com/img/equal_f79a49ccd5.png',
      height: "24px",
      width: "24px"
    }), jsxRuntime.jsx(CustomTextField, {
      labelTxt: fromHint,
      value: fromHintValue,
      onChange: onFromHintChange
    }), jsxRuntime.jsx(CustomTextField, {
      labelTxt: toHint,
      value: toHintValue,
      onChange: onToHintChange
    })]
  });
};

const NetEffectiveCard = ({
  infoItem1,
  infoItem2,
  infoItem3
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(Card, {
    children: [jsxRuntime.jsxs(FlexRow, {
      children: [jsxRuntime.jsx(CustomFormattedText, {
        text: infoItem1 === null || infoItem1 === void 0 ? void 0 : infoItem1.left,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.mediumEmphasis
      }), jsxRuntime.jsx(designSystem.FormattedText, {
        text: infoItem1 === null || infoItem1 === void 0 ? void 0 : infoItem1.right,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
        color: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.mediumEmphasis
      })]
    }), jsxRuntime.jsxs(FlexRow, {
      children: [jsxRuntime.jsx(CustomFormattedText, {
        text: infoItem2 === null || infoItem2 === void 0 ? void 0 : infoItem2.left,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.mediumEmphasis
      }), jsxRuntime.jsxs(AmountTextRow, {
        margin: '0 0 0 8px',
        children: [jsxRuntime.jsx(designSystem.Image, {
          src: (_e = (_d = infoItem2 === null || infoItem2 === void 0 ? void 0 : infoItem2.right) === null || _d === void 0 ? void 0 : _d.icon) === null || _e === void 0 ? void 0 : _e.url,
          height: "12px",
          width: "12px"
        }), jsxRuntime.jsx(designSystem.FormattedText, {
          text: (_g = (_f = infoItem2 === null || infoItem2 === void 0 ? void 0 : infoItem2.right) === null || _f === void 0 ? void 0 : _f.amount) === null || _g === void 0 ? void 0 : _g.text,
          margin: "0 0 0 4px",
          typography: designTokens.TYPOGRAPHY_KEYS.smallW3,
          color: theme.colors.violetColor
        })]
      })]
    }), jsxRuntime.jsx(StyledHr, {}), jsxRuntime.jsx(CardFooter, {
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: infoItem3,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: (_h = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _h === void 0 ? void 0 : _h.mediumEmphasis
      })
    })]
  });
};

const AmountCalculatorContainer = ({
  amountCalculatorData,
  onFromHintChange,
  onToHintChange,
  onAddButtonClick,
  fromHintValue,
  toHintValue
}) => {
  var _a;
  const {
    infoIcon,
    subtext,
    fromHint,
    toHint,
    netEffectiveCard,
    cta,
    bestRatePersuasion
  } = amountCalculatorData !== null && amountCalculatorData !== void 0 ? amountCalculatorData : {};
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(AmountCalContainer, {
    children: [jsxRuntime.jsxs(Headline, {
      children: [jsxRuntime.jsx(designSystem.Image, {
        src: infoIcon === null || infoIcon === void 0 ? void 0 : infoIcon.url,
        height: "20px",
        width: "20px"
      }), jsxRuntime.jsx(designSystem.FormattedText, {
        text: subtext,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
        color: theme.colors.highEmphasis
      })]
    }), jsxRuntime.jsx(AmountRow, {
      onFromHintChange: onFromHintChange,
      onToHintChange: onToHintChange,
      fromHint: (_a = fromHint === null || fromHint === void 0 ? void 0 : fromHint[0]) === null || _a === void 0 ? void 0 : _a.text,
      toHint: toHint,
      fromHintValue: fromHintValue,
      toHintValue: toHintValue
    }), netEffectiveCard && jsxRuntime.jsx(NetEffectiveCard, {
      infoItem1: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.infoItem1,
      infoItem2: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.infoItem2,
      infoItem3: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.infoItem3
    }), bestRatePersuasion && jsxRuntime.jsx(designSystem.FormattedText, {
      text: bestRatePersuasion,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.mediumEmphasis,
      margin: "16px 0px 24px "
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.footerText,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.lowEmphasis,
      margin: "16px 0 24px"
    }), jsxRuntime.jsx(ButtonCont$1, {
      children: jsxRuntime.jsx(AddButton, {
        variant: "contained",
        label: cta === null || cta === void 0 ? void 0 : cta.text,
        id: cta === null || cta === void 0 ? void 0 : cta.id,
        onClick: onAddButtonClick
      })
    })]
  });
};

const AmountBottomSheet = ({
  onModalClose,
  onFromHintChange,
  onToHintChange,
  onAddButtonClick,
  fromHintValue,
  toHintValue,
  data
}) => {
  return jsxRuntime.jsx(designSystem.Modal, {
    modalType: "bottomSheet",
    heading: data === null || data === void 0 ? void 0 : data.title,
    onModalClose: onModalClose,
    showCloseButton: true,
    "data-testid": "AMOUNT_CALCULATOR_BOTTOMSHEET",
    children: jsxRuntime.jsx(AmountCalculatorContainer, {
      amountCalculatorData: data,
      onFromHintChange: onFromHintChange,
      onToHintChange: onToHintChange,
      onAddButtonClick: onAddButtonClick,
      fromHintValue: fromHintValue,
      toHintValue: toHintValue
    })
  });
};

const SpecialCashbackContent = ({
  comparePrice,
  netEffectiveCard
}) => {
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: comparePrice,
      typography: designTokens.TYPOGRAPHY_KEYS.mediumW3,
      color: theme.colors.highEmphasis,
      margin: "0px 0px 12px 0px"
    }), jsxRuntime.jsx(NetEffectiveCard, {
      infoItem1: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.infoItem1,
      infoItem2: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.infoItem2,
      infoItem3: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.infoItem3
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: netEffectiveCard === null || netEffectiveCard === void 0 ? void 0 : netEffectiveCard.footerText,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.lowEmphasis,
      margin: "32px 0 32px"
    })]
  });
};

const SpecialCashbackBottomSheet = ({
  onModalClose,
  data
}) => {
  const {
    selectedCurrencyCode,
    amountDetails: {
      cashbackAmount,
      netEffectiveAmountOnTotalValue,
      netEffectiveRate
    }
  } = useAppSelector(state => state.forexProductData);
  const device = commonUi.useDevice();
  const netEffectiveCard = coreUtils.hydrateVars(data === null || data === void 0 ? void 0 : data.netEffectiveCard, {
    [commonUi.RTVars.CURRENCY_CODE]: selectedCurrencyCode,
    [commonUi.RTVars.NER_RATE]: coreUtils.toLocaleStringINRFormat(netEffectiveRate, 4, 4),
    [commonUi.RTVars.CASHBACK]: cashbackAmount,
    [commonUi.RTVars.NER]: coreUtils.toIndianLocaleFormat(coreUtils.roundWithoutDecimal(netEffectiveAmountOnTotalValue))
  });
  return jsxRuntime.jsx(designSystem.Modal, {
    modalType: device === commonUi.DEVICE.MOBILE ? 'bottomSheet' : 'centered',
    heading: data === null || data === void 0 ? void 0 : data.title,
    onModalClose: onModalClose,
    showCloseButton: true,
    "data-testid": "SPECIAL_CASHBACK_BOTTOMSHEET",
    children: jsxRuntime.jsx(SpecialCashbackContent, {
      comparePrice: data === null || data === void 0 ? void 0 : data.comparePrice,
      netEffectiveCard: netEffectiveCard
    })
  });
};

const InfoSectionWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__InfoSectionWrapper",
  componentId: "sc-14x0v8t-2"
})(["margin:24px 0px 0px;"]);
const DisclaimerSectionWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__DisclaimerSectionWrapper",
  componentId: "sc-14x0v8t-3"
})(["font-family:Lato,sans-serif;font-size:12px;font-weight:400;margin-top:12px;"]);
const OfferSlabTable = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__OfferSlabTable",
  componentId: "sc-14x0v8t-4"
})(["border-radius:", ";border:1px solid ", ";overflow:hidden;margin:8px 0px 0px;"], ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.cardBorder);
const PriceDetailsCard = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__PriceDetailsCard",
  componentId: "sc-14x0v8t-5"
})(["background:", ";border:1px solid ", ";border-radius:", "px;padding:12px;display:flex;flex-direction:column;gap:12px;min-width:260px;"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.colors.cardBorder, ({
  borderRadius
}) => borderRadius);
const Row = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__Row",
  componentId: "sc-14x0v8t-6"
})(["display:flex;align-items:flex-end;gap:8px;"]);
const SubRow = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__SubRow",
  componentId: "sc-14x0v8t-7"
})(["display:flex;align-items:center;gap:2px;"]);
const CurrencyLabel = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__CurrencyLabel",
  componentId: "sc-14x0v8t-8"
})(["font-family:Lato,sans-serif;font-weight:700;font-size:16px;color:", ";"], ({
  theme
}) => theme.colors.highEmphasis);
const Amount = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__Amount",
  componentId: "sc-14x0v8t-9"
})(["font-family:Lato,sans-serif;font-weight:400;font-size:16px;color:", ";"], ({
  theme
}) => theme.colors.mediumEmphasis);
const Equal = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__Equal",
  componentId: "sc-14x0v8t-10"
})(["font-family:Lato,sans-serif;font-weight:400;font-size:16px;color:", ";"], ({
  theme
}) => theme.colors.mediumEmphasis);
const INR = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__INR",
  componentId: "sc-14x0v8t-11"
})(["font-family:Lato,sans-serif;font-weight:700;font-size:16px;color:", ";"], ({
  theme
}) => theme.colors.mediumEmphasis);
const LiveRate = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__LiveRate",
  componentId: "sc-14x0v8t-12"
})(["font-family:Lato,sans-serif;font-weight:400;font-size:12px;color:", ";"], ({
  theme
}) => theme.colors.mediumEmphasis);
const TopRow = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__TopRow",
  componentId: "sc-14x0v8t-13"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;"]);
const NerInfoBox = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__NerInfoBox",
  componentId: "sc-14x0v8t-14"
})(["background:#f3f4fe;border-radius:8px;padding:4px 12px;display:flex;flex-direction:row;align-items:center;gap:4px;height:30px;margin-top:12px;"]);
const Table = /*#__PURE__*/styled__default.default.table.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__Table",
  componentId: "sc-14x0v8t-15"
})(["border-collapse:collapse;width:100%;th{border-bottom:1px solid ", ";padding:12px;background:", ";}td{padding:10px;}tbody tr:not(:last-child) td{border-bottom:1px solid ", ";}thead tr th:not(:last-child){border-right:1px solid ", ";}tbody tr td:not(:last-child){border-right:1px solid ", ";}"], ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.colors.cardBorder);
const OfferBannerRoot = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__OfferBannerRoot",
  componentId: "sc-14x0v8t-16"
})(["background:", ";border-radius:16px;padding:12px;display:flex;flex-direction:row;align-items:center;width:100%;box-sizing:border-box;height:96px;margin-top:12px;"], ({
  $backgroundColor
}) => $backgroundColor || '#F6F6F6');
const OfferBannerTextSection = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferePersuasionBottomSheetstyles__OfferBannerTextSection",
  componentId: "sc-14x0v8t-17"
})(["display:flex;flex-direction:column;gap:4px;flex:1;"]);

const OfferSlabs = ({
  data
}) => {
  var _a, _b, _c, _d;
  const theme = React.useContext(styled.ThemeContext);
  if (!data) {
    return null;
  }
  return jsxRuntime.jsxs(InfoSectionWrapper, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: data === null || data === void 0 ? void 0 : data.title,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.lowEmphasis
    }), jsxRuntime.jsx(OfferSlabTable, {
      children: jsxRuntime.jsxs(Table, {
        border: 0,
        width: "100%",
        cellPadding: "",
        cellSpacing: "0",
        children: [jsxRuntime.jsx("thead", {
          children: jsxRuntime.jsx("tr", {
            children: (_a = data === null || data === void 0 ? void 0 : data.offerList) === null || _a === void 0 ? void 0 : _a.map(offer => jsxRuntime.jsx("th", {
              children: jsxRuntime.jsx(designSystem.FormattedText, {
                text: offer === null || offer === void 0 ? void 0 : offer.title,
                color: theme.colors.mediumEmphasis,
                typography: designTokens.TYPOGRAPHY_KEYS.baseW2
              })
            }, offer.id))
          })
        }), jsxRuntime.jsx("tbody", {
          children: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.offerList) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.list) === null || _d === void 0 ? void 0 : _d.map((_, rowIndex) => {
            var _a;
            return jsxRuntime.jsx("tr", {
              children: (_a = data === null || data === void 0 ? void 0 : data.offerList) === null || _a === void 0 ? void 0 : _a.map(offer => {
                var _a;
                return jsxRuntime.jsx("td", {
                  align: "center",
                  children: jsxRuntime.jsx(designSystem.FormattedText, {
                    text: (_a = offer === null || offer === void 0 ? void 0 : offer.list) === null || _a === void 0 ? void 0 : _a[rowIndex],
                    color: theme.colors.mediumEmphasis,
                    typography: designTokens.TYPOGRAPHY_KEYS.baseW1
                  })
                }, offer.id);
              })
            }, rowIndex);
          })
        })]
      })
    })]
  });
};

const PriceDetailsInfo = ({
  currencyLabel,
  currencyCode,
  amount,
  convertedAmount,
  rate
}) => {
  const theme = React.useContext(styled.ThemeContext);
  const hasFullDetails = amount && convertedAmount && currencyCode && rate;
  const borderRadius = hasFullDetails ? 16 : 8;
  return jsxRuntime.jsxs(PriceDetailsCard, {
    borderRadius: borderRadius,
    theme: theme,
    children: [jsxRuntime.jsx(CurrencyLabel, {
      theme: theme,
      children: currencyLabel
    }), !!hasFullDetails && jsxRuntime.jsxs(TopRow, {
      children: [jsxRuntime.jsxs(Row, {
        children: [jsxRuntime.jsxs(SubRow, {
          children: [jsxRuntime.jsx(Amount, {
            theme: theme,
            children: coreUtils.toLocaleStringINRFormat(amount, 0, 0)
          }), jsxRuntime.jsxs(Amount, {
            theme: theme,
            children: [" ", currencyCode]
          })]
        }), jsxRuntime.jsx(Equal, {
          theme: theme,
          children: "="
        }), jsxRuntime.jsxs(INR, {
          theme: theme,
          children: ["\u20B9", convertedAmount]
        })]
      }), jsxRuntime.jsxs(LiveRate, {
        theme: theme,
        children: ["LIVE Rate: \u20B9", rate]
      })]
    })]
  });
};

const EffectivePriceInfo = ({
  netEffectivePrice,
  totalEffectivePrice,
  effectiveRate
}) => {
  const effectivePriceInfo = coreUtils.hydrateVars(netEffectivePrice === null || netEffectivePrice === void 0 ? void 0 : netEffectivePrice.text, {
    [commonUi.RTVars.VARS_NER_EFFECTIVE_PRICE]: coreUtils.roundAndIndianFormat(totalEffectivePrice),
    [commonUi.RTVars.NER_RATE]: coreUtils.formatRateForDisplay(Number(effectiveRate))
  });
  return jsxRuntime.jsx(NerInfoBox, {
    children: jsxRuntime.jsx(designSystem.FormattedText, {
      text: effectivePriceInfo,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW2
    })
  });
};

const OfferBanner = ({
  offerBanner,
  isOfferBannerVariantChanged,
  cashbackAmount,
  maxCashback,
  minOfferSlab
}) => {
  const theme = React.useContext(styled.ThemeContext);
  const {
    amountDetails: {
      totalAmountInInr
    }
  } = useAppSelector(selectForexProductData);
  const {
    bgColor,
    topText,
    variant1,
    variant2,
    variant3,
    icon
  } = offerBanner || {};
  const offerBannerDetails = getOfferBannerVariant(isOfferBannerVariantChanged || false, variant1, variant2, variant3, minOfferSlab, totalAmountInInr);
  const hydratedOfferBannerDetails = coreUtils.hydrateVars(offerBannerDetails, {
    [commonUi.RTVars.VARS_CASHBACK_AMOUNT]: cashbackAmount > 0 ? coreUtils.toIndianLocaleFormat(cashbackAmount) : '0',
    [commonUi.RTVars.VARS_MAX_CASHBACK]: maxCashback > 0 ? coreUtils.toIndianLocaleFormat(maxCashback) : '0'
  });
  const {
    title,
    subtitle
  } = hydratedOfferBannerDetails || {};
  return jsxRuntime.jsxs(OfferBannerRoot, {
    "$backgroundColor": bgColor || '#F6F6F6',
    "data-testid": "coupon-details-root",
    children: [jsxRuntime.jsxs(OfferBannerTextSection, {
      children: [(topText === null || topText === void 0 ? void 0 : topText.text) && jsxRuntime.jsx(designSystem.FormattedText, {
        text: topText === null || topText === void 0 ? void 0 : topText.text,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW3,
        color: theme.colors.royalBlue
      }), jsxRuntime.jsx(designSystem.FormattedText, {
        text: title,
        typography: designTokens.TYPOGRAPHY_KEYS.largeW3,
        color: theme.colors.mediumEmphasis,
        margin: "1px 0px"
      }), jsxRuntime.jsx(designSystem.FormattedText, {
        text: subtitle,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
        color: theme.colors.mediumEmphasis
      })]
    }), (icon === null || icon === void 0 ? void 0 : icon.url) && jsxRuntime.jsx(designSystem.Image, {
      src: icon === null || icon === void 0 ? void 0 : icon.url,
      alt: "offer-banner-icon",
      width: "57px",
      height: "60px"
    })]
  });
};

const OfferPersuasionBottomSheet = ({
  data,
  cashbackAmount,
  netEffectiveRate,
  totalEffectivePrice,
  onModalClose,
  maxCashback
}) => {
  var _a, _b, _c;
  const device = commonUi.useDevice();
  const theme = React.useContext(styled.ThemeContext);
  const {
    exchangeRate,
    selectedCurrencyName,
    selectedCurrencyCode,
    selectedProductType,
    amountDetails: {
      internationalCurrencyAmount,
      totalAmountInInr
    }
  } = useAppSelector(selectForexProductData);
  const {
    apiData: listingApiData
  } = useAppSelector(selectListingApiData);
  const minOrderInfo = getMinOrderInfo(selectedProductType, listingApiData || {}, selectedCurrencyCode);
  const isOfferBannerVariantChanged = !!internationalCurrencyAmount && internationalCurrencyAmount >= ((minOrderInfo === null || minOrderInfo === void 0 ? void 0 : minOrderInfo.min_amount) || 0) && !!((_a = data === null || data === void 0 ? void 0 : data.offerBanner) === null || _a === void 0 ? void 0 : _a.variant2);
  const minOfferSlab = getMinOrderAmount(listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.slabsData);
  const isShowNetEffectivePrice = minOfferSlab <= Math.round(totalAmountInInr) && isOfferBannerVariantChanged;
  React.useEffect(() => {
    var _a;
    pdtUtils.trackEvent({
      eventData: (_a = data === null || data === void 0 ? void 0 : data.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
  }, []);
  return jsxRuntime.jsx(designSystem.Modal, {
    modalType: device === commonUi.DEVICE.DESKTOP ? 'centered' : 'bottomSheet',
    onModalClose: onModalClose,
    heading: data === null || data === void 0 ? void 0 : data.title,
    modalMaxHeight: device === commonUi.DEVICE.MOBILE ? 'calc(100vh - 200px)' : 'auto',
    "data-testid": "OFFER_PERSUASION_BOTTOMSHEET",
    children: jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [jsxRuntime.jsx(designSystem.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.label,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.mediumEmphasis
      }), jsxRuntime.jsx(PriceDetailsInfo, {
        currencyLabel: selectedCurrencyName,
        currencyCode: selectedCurrencyCode,
        convertedAmount: coreUtils.roundAndIndianFormat(totalAmountInInr),
        rate: exchangeRate,
        amount: internationalCurrencyAmount
      }), (data === null || data === void 0 ? void 0 : data.netEffectivePrice) && isShowNetEffectivePrice && jsxRuntime.jsx(EffectivePriceInfo, {
        netEffectivePrice: data === null || data === void 0 ? void 0 : data.netEffectivePrice,
        totalEffectivePrice: totalEffectivePrice,
        effectiveRate: netEffectiveRate
      }), (data === null || data === void 0 ? void 0 : data.offerBanner) && jsxRuntime.jsx(OfferBanner, {
        offerBanner: data === null || data === void 0 ? void 0 : data.offerBanner,
        cashbackAmount: cashbackAmount,
        isOfferBannerVariantChanged: isOfferBannerVariantChanged,
        minOfferSlab: minOfferSlab,
        maxCashback: maxCashback
      }), (data === null || data === void 0 ? void 0 : data.offerSlabs) && jsxRuntime.jsx(OfferSlabs, {
        data: data === null || data === void 0 ? void 0 : data.offerSlabs
      }), ((_b = data === null || data === void 0 ? void 0 : data.disclaimer) === null || _b === void 0 ? void 0 : _b.text) && jsxRuntime.jsx(DisclaimerSectionWrapper, {
        children: jsxRuntime.jsx(designSystem.FormattedText, {
          text: (_c = data === null || data === void 0 ? void 0 : data.disclaimer) === null || _c === void 0 ? void 0 : _c.text,
          typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
          color: theme.colors.mediumEmphasis,
          margin: "12px 0px"
        })
      })]
    })
  });
};

const useGetCCSectionCalculationDetails = ({
  componentData
}) => {
  const {
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const {
    amountDetails: {
      internationalCurrencyAmount
    },
    selectedCurrencyCode
  } = useAppSelector(state => state.forexProductData);
  const {
    currencyInfo,
    slabsData
  } = useAppSelector(state => {
    var _a;
    return ((_a = state.listingApi.data) === null || _a === void 0 ? void 0 : _a.apiData) || {};
  });
  const totalAmountForMXCardCC = React.useMemo(() => {
    const exchangeRate = getExchangeRate(currencyInfo, selectedCurrencyCode, commonUi.PRODUCT_TYPE.CARD);
    const totalAmountInInr = internationalCurrencyAmount * exchangeRate;
    const cashback = getCashbackAmount(totalAmountInInr, slabsData);
    return getMMTAmount(totalAmountInInr, cashback);
  }, [currencyInfo, selectedCurrencyCode, internationalCurrencyAmount, slabsData]);
  const totalAmountForBanksCC = React.useMemo(() => {
    const exchangeRate = getExchangeRate(currencyInfo, selectedCurrencyCode, commonUi.PRODUCT_TYPE.CARD);
    const totalAmountInInr = internationalCurrencyAmount * exchangeRate;
    const adjustedMarkup = (data === null || data === void 0 ? void 0 : data.gstAdjustedMarkupValue) || 0;
    return getCCBankAmount(totalAmountInInr, adjustedMarkup);
  }, [currencyInfo, selectedCurrencyCode, internationalCurrencyAmount, data]);
  const saveAmount = coreUtils.roundAndIndianFormat(getSavedAmount(totalAmountForBanksCC, totalAmountForMXCardCC));
  return {
    saveAmount,
    totalAmountForBanksCC: coreUtils.toIndianLocaleFormat(coreUtils.roundWithoutDecimal(totalAmountForBanksCC)),
    totalAmountForMXCardCC: coreUtils.toIndianLocaleFormat(coreUtils.roundWithoutDecimal(totalAmountForMXCardCC))
  };
};

const CreditCardNudge = ({
  margin,
  componentData,
  bottomSheets,
  onClick
}) => {
  var _a, _b, _c, _d, _e, _f;
  const state = useAppSelector(state => state);
  const {
    amountDetails: {
      internationalCurrencyAmount
    }
  } = state.forexProductData;
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  const {
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const [selectedModalId, setSelectedModalId] = React.useState(null);
  const currencyRefs = React.useRef([]);
  const creditRefs = React.useRef([]);
  const [maxHeights, setMaxHeights] = React.useState([]);
  const {
    saveAmount,
    totalAmountForBanksCC,
    totalAmountForMXCardCC
  } = useGetCCSectionCalculationDetails({
    componentData
  });
  const {
    sendPdtData
  } = getPdtLoggerMethods({
    state
  });
  React.useEffect(() => {
    var _a, _b, _c, _d;
    if (!data) return;
    const rowCount = Math.max(((_b = (_a = data.currencyCard) === null || _a === void 0 ? void 0 : _a.infoItems) === null || _b === void 0 ? void 0 : _b.length) || 0, ((_d = (_c = data.creditCard) === null || _c === void 0 ? void 0 : _c.infoItems) === null || _d === void 0 ? void 0 : _d.length) || 0);
    const heights = Array.from({
      length: rowCount
    }, (_, i) => {
      var _a, _b;
      const currencyHeight = ((_a = currencyRefs.current[i]) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
      const creditHeight = ((_b = creditRefs.current[i]) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
      return Math.max(currencyHeight, creditHeight);
    });
    setMaxHeights(heights);
  }, [data]);
  function getVarsForCCSection() {
    if ((data === null || data === void 0 ? void 0 : data.updateOnAmountChange) && (data === null || data === void 0 ? void 0 : data.minAmount) && internationalCurrencyAmount > (data === null || data === void 0 ? void 0 : data.minAmount)) {
      return {
        [commonUi.RTVars.SAVINGS]: saveAmount,
        [commonUi.RTVars.CURRENCY_AMT]: coreUtils.toIndianLocaleFormat(coreUtils.roundWithoutDecimal(internationalCurrencyAmount)),
        [commonUi.RTVars.INR_VALUE]: totalAmountForMXCardCC,
        [commonUi.RTVars.COST]: totalAmountForBanksCC
      };
    }
  }
  const hydratedData = coreUtils.hydrateVars(data, getVarsForCCSection());
  const hydratedKnowMoreCCBottomSheetData = selectedModalId ? coreUtils.hydrateVars(bottomSheets[selectedModalId], getVarsForCCSection()) : null;
  /*Start: Event handlers */
  const knowMoreHandler = item => {
    var _a;
    if ((_a = item === null || item === void 0 ? void 0 : item.analytics) === null || _a === void 0 ? void 0 : _a.pdtData) sendPdtData(item.analytics.pdtData);
    setSelectedModalId(item === null || item === void 0 ? void 0 : item.modalId);
  };
  const closeKnowMoreCCHandler = () => {
    setSelectedModalId(null);
  };
  /*End: Event handlers */
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(CcNudgeWrapper, {
      margin: margin,
      id: componentData === null || componentData === void 0 ? void 0 : componentData.nodeId,
      children: [jsxRuntime.jsxs(TitleWrapper$1, {
        children: [jsxRuntime.jsx(designSystem.FormattedText, {
          text: hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.title,
          typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.mediumW3 : designTokens.TYPOGRAPHY_KEYS.xLarge,
          color: theme.colors.highEmphasis
        }), device === commonUi.DEVICE.DESKTOP && jsxRuntime.jsx(BannerComponent$1, {
          bottomBanner: hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.bottomBanner,
          onClick: knowMoreHandler
        })]
      }), jsxRuntime.jsxs(ComparisonSection$1, {
        children: [jsxRuntime.jsx(CardComponent$1, {
          title: (_a = hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.currencyCard) === null || _a === void 0 ? void 0 : _a.title,
          infoItems: (_b = hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.currencyCard) === null || _b === void 0 ? void 0 : _b.infoItems,
          color: theme.colors.positive,
          refs: currencyRefs,
          maxHeights: maxHeights
        }), jsxRuntime.jsx(CardSeparator$1, {
          children: jsxRuntime.jsx(CardSeparatorCircle$1, {
            children: jsxRuntime.jsx(CircleImage, {
              src: (_d = (_c = hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.comparison) === null || _c === void 0 ? void 0 : _c.imageUrl) === null || _d === void 0 ? void 0 : _d.url
            })
          })
        }), jsxRuntime.jsx(CardComponent$1, {
          title: (_e = hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.creditCard) === null || _e === void 0 ? void 0 : _e.title,
          infoItems: (_f = hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.creditCard) === null || _f === void 0 ? void 0 : _f.infoItems,
          color: theme.colors.error,
          refs: creditRefs,
          maxHeights: maxHeights
        })]
      }), device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(BannerComponent$1, {
        bottomBanner: hydratedData === null || hydratedData === void 0 ? void 0 : hydratedData.bottomBanner,
        onClick: closeKnowMoreCCHandler
      })]
    }), selectedModalId && bottomSheets[selectedModalId] && jsxRuntime.jsx(CcComparisonBottomSheet, {
      data: hydratedKnowMoreCCBottomSheetData,
      onCtaClick: () => void 0,
      onModalClose: closeKnowMoreCCHandler,
      modalWidth: 475
    })]
  });
};

const FaqWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Faqsstyles__FaqWrapper",
  componentId: "sc-16ag6wd-0"
})(["padding:30px 40px;background-color:", ";border-radius:", ";margin:", ";@media ", "{background-color:transparent;padding:0;}"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br16, ({
  margin
}) => margin || '0', commonUi.deviceType.mobile);
const FaqTab = /*#__PURE__*/styled__default.default.ul.withConfig({
  displayName: "Faqsstyles__FaqTab",
  componentId: "sc-16ag6wd-1"
})(["display:flex;gap:24px;@media ", "{background-color:", ";border-radius:", ";overflow:hidden;gap:0;}"], commonUi.deviceType.mobile, ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br8);
const FaqTabItem = /*#__PURE__*/styled__default.default.li.withConfig({
  displayName: "Faqsstyles__FaqTabItem",
  componentId: "sc-16ag6wd-2"
})(["display:inline-flex;align-items:center;justify-content:center;padding:8px 40px;", ";cursor:pointer;border:1px solid ", ";color:", ";", " @media ", "{padding:8px 0;flex:1;}"], designTokens.getFontSizeStyles(designTokens.FONT_SIZE_KEYS.FONT12, designTokens.DEVICE.WEB), ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.colors.mediumEmphasis, ({
  activeTab,
  theme
}) => activeTab && `
        background-color: ${theme.colors.lightBlue};
        border-radius: ${theme.borderRadius.br8};
        border: 1px solid ${theme.colors.primaryAccent};
        color: ${theme.colors.primaryAccent};
        font-weight: ${theme.fontWeight.bold};
    `, commonUi.deviceType.mobile);
const AccordionCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Faqsstyles__AccordionCont",
  componentId: "sc-16ag6wd-3"
})(["margin-top:36px;display:grid;grid-template-columns:1fr;gap:32px;@media ", "{margin-top:24px;background-color:", ";border-radius:", ";padding:12px;gap:20px;}"], commonUi.deviceType.mobile, ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br16);
const AccordionItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Faqsstyles__AccordionItem",
  componentId: "sc-16ag6wd-4"
})(["p:first-child{cursor:pointer;position:relative;&::after{content:'';border:1px solid ", ";border-width:0 2px 2px 0;padding:3px;display:inline-block;transform:rotate(45deg);position:absolute;right:2px;top:4px;transition:transform 0.3s;}}", ""], ({
  theme
}) => theme.colors.lowEmphasis, ({
  activeQuestion,
  theme
}) => activeQuestion && `
        p:first-child {
            &::after {
                transform: rotate(-135deg);
                top: 8px;
            }
        }
    `);
const FaqQuestion = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "Faqsstyles__FaqQuestion",
  componentId: "sc-16ag6wd-5"
})(["padding:0 20px 0 0;"]);

const Faqs = ({
  componentData,
  margin
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const device = commonUi.useDevice();
  const theme = React.useContext(styled.ThemeContext);
  const [activeTab, setActiveTab] = React.useState(0);
  const [activeQuestion, setActiveQuestion] = React.useState(null);
  const {
    nodeId,
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const handleAccordion = index => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };
  const handleTab = index => {
    setActiveTab(index);
    setActiveQuestion(null);
  };
  const handleFaqClick = (item, index) => {
    var _a, _b, _c;
    const description = `${(_b = (_a = data === null || data === void 0 ? void 0 : data.tabs) === null || _a === void 0 ? void 0 : _a[activeTab]) === null || _b === void 0 ? void 0 : _b.id}|${item === null || item === void 0 ? void 0 : item.q}`;
    const pdtData = pdtUtils.updatePdtDataDescription((_c = componentData === null || componentData === void 0 ? void 0 : componentData.analytics) === null || _c === void 0 ? void 0 : _c.pdtData, description);
    pdtUtils.trackEvent({
      eventData: pdtData
    });
    handleAccordion(index);
  };
  return jsxRuntime.jsxs(FaqWrapper, {
    id: nodeId,
    margin: margin,
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      color: theme.colors.highEmphasis,
      typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.mediumW3 : designTokens.TYPOGRAPHY_KEYS.xLarge,
      margin: "0 0 24px 0",
      text: data === null || data === void 0 ? void 0 : data.title
    }), ((_b = (_a = data === null || data === void 0 ? void 0 : data.tabs) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) && jsxRuntime.jsx(FaqTab, {
      children: (_c = data === null || data === void 0 ? void 0 : data.tabs) === null || _c === void 0 ? void 0 : _c.map((item, index) => jsxRuntime.jsx(FaqTabItem, {
        activeTab: activeTab === index,
        onClick: () => handleTab(index),
        children: item.title
      }, `${item.id}-${index}`))
    }), ((_e = (_d = data === null || data === void 0 ? void 0 : data.tabs) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) && jsxRuntime.jsx(AccordionCont, {
      children: (data === null || data === void 0 ? void 0 : data.tabs) && ((_g = (_f = data.tabs[activeTab]) === null || _f === void 0 ? void 0 : _f.accordion) === null || _g === void 0 ? void 0 : _g.map((item, index) => jsxRuntime.jsxs(AccordionItem, {
        activeQuestion: activeQuestion === index,
        children: [jsxRuntime.jsx(FaqQuestion, {
          text: item === null || item === void 0 ? void 0 : item.q,
          onClick: () => handleFaqClick(item, index),
          color: theme.colors.highEmphasis,
          typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.smallW3 : designTokens.TYPOGRAPHY_KEYS.largeW1
        }), activeQuestion === index && (item === null || item === void 0 ? void 0 : item.a) && jsxRuntime.jsx(designSystem.FormattedText, {
          text: item.a,
          typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.smallW1 : designTokens.TYPOGRAPHY_KEYS.mediumW1,
          color: theme.colors.mediumEmphasis,
          margin: '10px 0 0 0'
        })]
      }, `${item.id}-${index}`)))
    })]
  });
};

const FreeDeliveryWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "FreeDeliverystyles__FreeDeliveryWrapper",
  componentId: "sc-1q5o9xi-0"
})(["border-radius:16px;padding:12px;display:flex;flex-direction:column;gap:8px;background:url('https://tripmoneycmsimgak.mmtcdn.com/img/free_Delivery_Mweb_9d654e8540.png') 0 0 no-repeat;background-size:100% 100%;@media ", "{background:url('https://tripmoneycmsimgak.mmtcdn.com/img/free_Delivery_Dweb_88acfb9c5d.png') 0 0 no-repeat;background-size:100% 100%;padding:8px 12px;gap:12px;flex-direction:row;align-items:center;margin:50px 0 0 0;}margin:", ";"], commonUi.deviceType.desktop, props => (props === null || props === void 0 ? void 0 : props.margin) ? props.margin : '0px');
const OrderZeroWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "FreeDeliverystyles__OrderZeroWrapper",
  componentId: "sc-1q5o9xi-1"
})(["width:fit-content;border-radius:", ";padding:2px 8px;background:", ";"], ({
  theme
}) => theme.borderRadius.br16, props => (props === null || props === void 0 ? void 0 : props.bgColor) ? `linear-gradient(${props.bgColor.join(',')})` : 'linear-gradient(225deg, #3023ae 0%, #c86dd7 100%)');
const Details = /*#__PURE__*/styled__default.default.ul.withConfig({
  displayName: "FreeDeliverystyles__Details",
  componentId: "sc-1q5o9xi-2"
})(["display:flex;flex-direction:row;gap:8px;align-items:center;"]);
const DetailItem = /*#__PURE__*/styled__default.default.li.withConfig({
  displayName: "FreeDeliverystyles__DetailItem",
  componentId: "sc-1q5o9xi-3"
})(["position:relative;padding-left:12px;align-items:center;display:flex;::before{content:'';position:absolute;height:6px;width:6px;border-radius:100%;background-color:", ";left:0;top:8px;}"], ({
  theme
}) => theme.colors.highEmphasis);

const FreeDelivery = ({
  componentData,
  margin
}) => {
  var _a, _b;
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  const {
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  return jsxRuntime.jsxs(FreeDeliveryWrapper, {
    id: componentData === null || componentData === void 0 ? void 0 : componentData.nodeId,
    margin: margin,
    children: [(data === null || data === void 0 ? void 0 : data.title) && jsxRuntime.jsx(OrderZeroWrapper, {
      bgColor: ['#3023AE', '#C86DD7'],
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: data.title,
        color: theme.colors.white,
        typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.baseW2 : designTokens.TYPOGRAPHY_KEYS.mediumW2
      })
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: data === null || data === void 0 ? void 0 : data.subtitle,
      color: theme.colors.highEmphasis,
      typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.baseW1 : designTokens.TYPOGRAPHY_KEYS.mediumW1
    }), (data === null || data === void 0 ? void 0 : data.infoItems) && ((_a = data === null || data === void 0 ? void 0 : data.infoItems) === null || _a === void 0 ? void 0 : _a.length) > 0 && jsxRuntime.jsx(Details, {
      children: (_b = data === null || data === void 0 ? void 0 : data.infoItems) === null || _b === void 0 ? void 0 : _b.map((item, index) => jsxRuntime.jsx(DetailItem, {
        children: jsxRuntime.jsx(designSystem.FormattedText, {
          text: item === null || item === void 0 ? void 0 : item.text,
          color: theme.colors.highEmphasis,
          typography: device === commonUi.DEVICE.MOBILE ? designTokens.TYPOGRAPHY_KEYS.baseW1 : designTokens.TYPOGRAPHY_KEYS.mediumW1
        })
      }, index))
    })]
  });
};

const OfferPersuasionWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferPersuasionstyles__OfferPersuasionWrapper",
  componentId: "sc-1rhkom-0"
})(["", ";@media ", "{position:relative;display:inline-flex;padding:6px 36px 6px 12px;display:flex;-webkit-box-pack:justify;justify-content:end;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;margin-top:-16px;margin-right:-10px;align-items:center;}"], ({
  margin
}) => margin && `margin: ${margin};`, commonUi.deviceType.desktop);
const OfferPersuasionContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferPersuasionstyles__OfferPersuasionContainer",
  componentId: "sc-1rhkom-1"
})(["display:flex;flex-direction:row;align-items:center;gap:8px;@media ", "{position:relative;background:", ";border-radius:0px 0px 16px 16px;padding:4px 12px 8px 12px;}"], commonUi.deviceType.desktop, ({
  theme
}) => theme.colors.lightPurple);
const OfferTextWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferPersuasionstyles__OfferTextWrapper",
  componentId: "sc-1rhkom-3"
})(["display:flex;flex-direction:column;"]);
const InfoIconWrapper$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OfferPersuasionstyles__InfoIconWrapper",
  componentId: "sc-1rhkom-4"
})(["cursor:pointer;flex-shrink:0;width:20px;height:20px;@media ", "{margin-left:auto;}"], commonUi.deviceType.mobile);

const OfferPersuasion = ({
  componentData,
  margin,
  onClick,
  bottomSheets
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  const theme = React.useContext(styled.ThemeContext);
  const [isOpen, setIsOpen] = React.useState(false);
  const {
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const {
    exchangeRate,
    amountDetails: {
      totalAmountInInr,
      internationalCurrencyAmount
    }
  } = useAppSelector(state => state.forexProductData);
  const {
    data: listingApiData
  } = useAppSelector(state => state.listingApi);
  const slabsData = ((_a = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.apiData) === null || _a === void 0 ? void 0 : _a.slabsData) || [];
  // const { sendPdtData } = getPdtLoggerMethods({
  //   state: useAppSelector(state => state),
  // });
  const cashbackAmount = getCashbackAmount(totalAmountInInr, slabsData);
  const maxCashback = maxCashbackAmount(slabsData);
  const netEffectiveRate = getNetEffectiveRateByForexAmount(Math.round(totalAmountInInr), cashbackAmount, internationalCurrencyAmount);
  const totalEffectivePrice = totalAmountInInr - cashbackAmount;
  const isOfferVariantChanged = getMinOrderAmount(slabsData) <= Math.round(totalAmountInInr) && !!(data === null || data === void 0 ? void 0 : data.variant2);
  let offerBannerText = isOfferVariantChanged ? (_b = data === null || data === void 0 ? void 0 : data.variant2) === null || _b === void 0 ? void 0 : _b.subtitle : (_c = data === null || data === void 0 ? void 0 : data.variant1) === null || _c === void 0 ? void 0 : _c.subtitle;
  offerBannerText = coreUtils.hydrateVars(offerBannerText, {
    [commonUi.RTVars.VARS_CASHBACK_AMOUNT]: coreUtils.roundAndIndianFormat(totalEffectivePrice),
    [commonUi.RTVars.NER_RATE]: coreUtils.formatRateForDisplay(netEffectiveRate)
  });
  // useEffect(() => {
  //   if (componentData?.analytics?.pdtData) {
  //     sendPdtData(componentData?.analytics?.pdtData);
  //   }
  // }, []);
  const handleClick = () => {
    var _a, _b, _c, _d;
    pdtUtils.trackEvent({
      eventData: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.info) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.pdtData
    });
    onClick === null || onClick === void 0 ? void 0 : onClick((_d = data === null || data === void 0 ? void 0 : data.info) === null || _d === void 0 ? void 0 : _d.cta);
    setIsOpen(true);
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsx(OfferPersuasionWrapper, {
      id: componentData === null || componentData === void 0 ? void 0 : componentData.nodeId,
      margin: margin,
      children: jsxRuntime.jsxs(OfferPersuasionContainer, {
        theme: theme,
        children: [jsxRuntime.jsx(designSystem.Image, {
          src: (_d = data === null || data === void 0 ? void 0 : data.icon) === null || _d === void 0 ? void 0 : _d.url,
          width: '24px',
          height: '24px'
        }), jsxRuntime.jsxs(OfferTextWrapper, {
          children: [(data === null || data === void 0 ? void 0 : data.title) && jsxRuntime.jsx(designSystem.FormattedText, {
            text: data === null || data === void 0 ? void 0 : data.title,
            color: theme.colors.highEmphasis,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW2
          }), offerBannerText && jsxRuntime.jsx(designSystem.FormattedText, {
            text: offerBannerText,
            color: theme.colors.mediumEmphasis,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1
          })]
        }), jsxRuntime.jsx(InfoIconWrapper$1, {
          onClick: handleClick,
          id: (_f = (_e = data === null || data === void 0 ? void 0 : data.info) === null || _e === void 0 ? void 0 : _e.cta) === null || _f === void 0 ? void 0 : _f.nodeId,
          children: jsxRuntime.jsx(designSystem.Image, {
            src: (_h = (_g = data === null || data === void 0 ? void 0 : data.info) === null || _g === void 0 ? void 0 : _g.icon) === null || _h === void 0 ? void 0 : _h.url,
            width: '20px',
            height: '20px'
          })
        })]
      })
    }), ((_k = (_j = data === null || data === void 0 ? void 0 : data.info) === null || _j === void 0 ? void 0 : _j.cta) === null || _k === void 0 ? void 0 : _k.modalId) && bottomSheets[data.info.cta.modalId] && isOpen && jsxRuntime.jsx(OfferPersuasionBottomSheet, {
      data: bottomSheets[data.info.cta.modalId],
      maxCashback: maxCashback,
      onModalClose: () => setIsOpen(false),
      cashbackAmount: cashbackAmount,
      netEffectiveRate: netEffectiveRate,
      totalEffectivePrice: totalEffectivePrice
    })]
  });
};

const PoweredByMwebCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PoweredByMwebstyles__PoweredByMwebCont",
  componentId: "sc-1kppgq0-0"
})(["background-color:", ";padding:20px 16px;border-radius:", ";margin:", ";@media ", "{display:flex;justify-content:space-between;padding:20px 40px 40px 40px;margin:0;background-color:#fff;margin-top:-40px;margin-bottom:40px;}"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br16, ({
  margin
}) => margin, commonUi.deviceType.desktop);
const TitleContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "PoweredByMwebstyles__TitleContainer",
  componentId: "sc-1kppgq0-1"
})(["display:flex;@media ", "{flex-direction:column;row-gap:4px;align-items:center;}@media ", "{flex-direction:column;row-gap:4px;border-right:1px solid #ececec;width:130px;align-items:flex-start;margin-right:20px;}"], commonUi.deviceType.mobile, commonUi.deviceType.desktop);
const ImageWrapper = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "PoweredByMwebstyles__ImageWrapper",
  componentId: "sc-1kppgq0-2"
})(["@media ", "{margin:0 0 0 4px;}"], commonUi.deviceType.mobile);

const PoweredByMweb = ({
  componentData,
  margin
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  if (!componentData) return null;
  const {
    nodeId,
    data
  } = componentData;
  return jsxRuntime.jsxs(PoweredByMwebCont, {
    id: nodeId,
    margin: margin,
    children: [((data === null || data === void 0 ? void 0 : data.title) || (data === null || data === void 0 ? void 0 : data.icon)) && jsxRuntime.jsxs(TitleContainer, {
      children: [(data === null || data === void 0 ? void 0 : data.title) && jsxRuntime.jsx(designSystem.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.title,
        color: device === commonUi.DEVICE.MOBILE ? theme.colors.highEmphasis : theme.colors.white,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1
      }), jsxRuntime.jsx(ImageWrapper, {
        height: device === commonUi.DEVICE.MOBILE ? '20px' : '31px',
        src: (_a = data === null || data === void 0 ? void 0 : data.icon) === null || _a === void 0 ? void 0 : _a.url,
        alt: "icon"
      })]
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      margin: device === commonUi.DEVICE.MOBILE ? '12px 0 0 0' : '0',
      color: device === commonUi.DEVICE.MOBILE ? theme.colors.lowEmphasis : theme.colors.white,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      text: data === null || data === void 0 ? void 0 : data.text
    })]
  });
};

const PoweredBy = ({
  componentData,
  margin
}) => {
  return jsxRuntime.jsx(PoweredByMweb, {
    componentData: componentData,
    margin: margin
  });
};

const ResumeOrderWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "ResumeOrderstyles__ResumeOrderWrapper",
  componentId: "sc-1cj7a6a-0"
})(["@media ", "{display:flex;align-items:center;}", ""], commonUi.deviceType.desktop, ({
  margin
}) => margin && `margin: ${margin};`);
const CardContainer = /*#__PURE__*/styled__default.default.ul.withConfig({
  displayName: "ResumeOrderstyles__CardContainer",
  componentId: "sc-1cj7a6a-1"
})(["list-style:none;display:flex;gap:8px;@media ", "{overflow-x:auto;padding:0 16px;margin:0 -16px;}"], commonUi.deviceType.mobile);
const CardItem = /*#__PURE__*/styled__default.default.li.withConfig({
  displayName: "ResumeOrderstyles__CardItem",
  componentId: "sc-1cj7a6a-2"
})(["background:", ";padding:8px 12px;white-space:nowrap;@media ", "{box-shadow:0px 1px 4px 0px ", ";border-radius:", ";cursor:pointer;max-width:250px;}@media ", "{border:1px solid ", ";border-radius:", ";}"], ({
  theme
}) => theme.colors.white, commonUi.deviceType.desktop, ({
  theme
}) => theme.colors.shadow, ({
  theme
}) => theme.borderRadius.br8, commonUi.deviceType.mobile, ({
  theme
}) => theme.colors.primaryAccent, ({
  theme
}) => theme.borderRadius.br16);
const CurrencyCityList = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "ResumeOrderstyles__CurrencyCityList",
  componentId: "sc-1cj7a6a-3"
})(["display:inline-block;align-items:baseline;max-width:226px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
const CustomText = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "ResumeOrderstyles__CustomText",
  componentId: "sc-1cj7a6a-4"
})(["display:inline;"]);

const ResumeOrder = ({
  componentData,
  onClick,
  margin
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  const {
    data,
    nodeId
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const handleCardClick = item => {
    var _a, _b, _c;
    pdtUtils.trackEvent({
      eventData: (_b = (_a = item === null || item === void 0 ? void 0 : item.cta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
    onClick === null || onClick === void 0 ? void 0 : onClick(item === null || item === void 0 ? void 0 : item.cta);
    const url = (_c = item === null || item === void 0 ? void 0 : item.cta) === null || _c === void 0 ? void 0 : _c.deeplink;
    if (url) {
      redirectTo(url);
    }
  };
  return jsxRuntime.jsxs(ResumeOrderWrapper, {
    id: nodeId,
    margin: margin,
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.baseW2 : designTokens.TYPOGRAPHY_KEYS.largeW3,
      color: device === commonUi.DEVICE.DESKTOP ? theme.colors.mediumEmphasis : theme.colors.highEmphasis,
      margin: device === commonUi.DEVICE.DESKTOP ? '0 8px 0 0' : '0 0 16px 0',
      text: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : data.orderItems) && ((_a = data === null || data === void 0 ? void 0 : data.orderItems) === null || _a === void 0 ? void 0 : _a.length) > 0 && jsxRuntime.jsx(CardContainer, {
      children: data.orderItems.map((item, index) => {
        var _a;
        return jsxRuntime.jsxs(CardItem, {
          onClick: () => handleCardClick(item),
          id: (_a = item === null || item === void 0 ? void 0 : item.cta) === null || _a === void 0 ? void 0 : _a.nodeId,
          children: [jsxRuntime.jsx(designSystem.FormattedText, {
            typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.smallW1 : designTokens.TYPOGRAPHY_KEYS.baseW3,
            color: theme.colors.primaryAccent,
            text: item === null || item === void 0 ? void 0 : item.title
          }), jsxRuntime.jsx(CurrencyCityList, {
            children: jsxRuntime.jsx(CustomText, {
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
              color: theme.colors.highEmphasis,
              margin: "4px 0 0",
              text: item === null || item === void 0 ? void 0 : item.subtext1
            })
          })]
        }, index.toString());
      })
    })]
  });
};

const InstantLoadNudgeWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "InstantLoadNudgestyles__InstantLoadNudgeWrapper",
  componentId: "sc-1rf1mot-0"
})(["", " background:linear-gradient(45deg,#43E1A8 0%,#219393 100%);padding:1px;border-radius:", ";"], props => props.margin && `margin: ${props.margin};`, ({
  theme
}) => theme.borderRadius.br16);
const InnerWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "InstantLoadNudgestyles__InnerWrapper",
  componentId: "sc-1rf1mot-1"
})(["padding:12px;border-radius:15px;background:", ";display:flex;flex-direction:row;align-items:flex-start;gap:4px;"], ({
  bgColor
}) => bgColor ? `linear-gradient(${bgColor.join(',')})` : 'linear-gradient(22deg, rgba(255, 255, 255, 1) 0%,rgba(255, 255, 255, 1) 50%,rgba(210, 242, 237, 1) 100%)');
const DetailsWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "InstantLoadNudgestyles__DetailsWrapper",
  componentId: "sc-1rf1mot-2"
})(["display:flex;flex-direction:column;gap:4px;"]);
const CtaWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "InstantLoadNudgestyles__CtaWrapper",
  componentId: "sc-1rf1mot-3"
})(["cursor:pointer;margin-left:auto;@media ", "{display:flex;flex-direction:row;align-items:center;gap:2px;}"], commonUi.deviceType.desktop);
const NudgeDwebWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "InstantLoadNudgestyles__NudgeDwebWrapper",
  componentId: "sc-1rf1mot-4"
})(["padding:12px;display:flex;background:url('https://tripmoneycmsimgak.mmtcdn.com/img/free_Delivery_Dweb_88acfb9c5d.png') 0 0 no-repeat;background-size:100% 100%;padding:8px 12px;gap:12px;flex-direction:row;align-items:center;border-radius:", ";", " margin:50px 0 0 0;"], ({
  theme
}) => theme.borderRadius.br16, props => props.margin && `margin: ${props.margin};`);
const DetailsDweb = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "InstantLoadNudgestyles__DetailsDweb",
  componentId: "sc-1rf1mot-5"
})(["position:relative;padding-left:12px;align-items:center;display:flex;::before{content:'';position:absolute;height:6px;width:6px;border-radius:100%;background-color:", ";left:0;top:8px;}"], ({
  theme
}) => theme.colors.highEmphasis);
const CtaDweb = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "InstantLoadNudgestyles__CtaDweb",
  componentId: "sc-1rf1mot-6"
})(["text-transform:uppercase;"]);

const backArrow = 'https://tripmoneycmsimgak.mmtcdn.com/img/Back_Arrow_3d873a52c1.png';
const rightArrowBlue = 'https://tripmoneycmsimgak.mmtcdn.com/img/Right_Arrow_Blue_377ac9e970.png';
const bgImage = 'https://tripmoneycmsimgak.mmtcdn.com/img/listing_bg_eb91ec7074.png';
const LOADER_TIMER = 800;
const AMOUNT_ROUND_OFF_TEXT = 'Amount will be rounded off..';

const InstantLoadNudgeMweb = ({
  componentData,
  margin,
  onClick
}) => {
  var _a, _b;
  const theme = React.useContext(styled.ThemeContext);
  const {
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  return jsxRuntime.jsx(InstantLoadNudgeWrapper, {
    id: componentData === null || componentData === void 0 ? void 0 : componentData.nodeId,
    margin: margin,
    children: jsxRuntime.jsxs(InnerWrapper
    // bgColor={data?.bgColors} //@TODO: Uncomment this line
    , {
      children: [jsxRuntime.jsx(designSystem.Image, {
        src: (_a = data === null || data === void 0 ? void 0 : data.icon) === null || _a === void 0 ? void 0 : _a.url,
        height: '24px',
        width: '24px'
      }), jsxRuntime.jsxs(DetailsWrapper, {
        children: [jsxRuntime.jsx(designSystem.FormattedText, {
          text: data === null || data === void 0 ? void 0 : data.title,
          color: theme.colors.positive,
          typography: designTokens.TYPOGRAPHY_KEYS.baseW2
        }), jsxRuntime.jsx(designSystem.FormattedText, {
          text: data === null || data === void 0 ? void 0 : data.subText1,
          color: theme.colors.lowEmphasis,
          typography: designTokens.TYPOGRAPHY_KEYS.baseW1
        }), jsxRuntime.jsx(designSystem.FormattedText, {
          text: data === null || data === void 0 ? void 0 : data.subText2,
          color: theme.colors.lowEmphasis,
          typography: designTokens.TYPOGRAPHY_KEYS.baseW1
        })]
      }), jsxRuntime.jsx(CtaWrapper, {
        onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(data === null || data === void 0 ? void 0 : data.cta),
        id: (_b = data === null || data === void 0 ? void 0 : data.cta) === null || _b === void 0 ? void 0 : _b.nodeId,
        children: jsxRuntime.jsx(designSystem.Image, {
          src: rightArrowBlue,
          height: '24px',
          width: '24px'
        })
      })]
    })
  });
};

const InstantLoadNudgeDweb = ({
  componentData,
  margin,
  onClick
}) => {
  var _a, _b, _c, _d, _e;
  const theme = React.useContext(styled.ThemeContext);
  const {
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  /*Start: Event Handlers */
  const instantLoadCtaHandler = () => {
    var _a, _b;
    if ((_a = data === null || data === void 0 ? void 0 : data.cta) === null || _a === void 0 ? void 0 : _a.deeplink) {
      redirectTo((_b = data === null || data === void 0 ? void 0 : data.cta) === null || _b === void 0 ? void 0 : _b.deeplink);
    }
  };
  /*End: Event Handlers */
  return jsxRuntime.jsxs(NudgeDwebWrapper, {
    id: componentData === null || componentData === void 0 ? void 0 : componentData.nodeId,
    margin: margin,
    children: [jsxRuntime.jsx(designSystem.Image, {
      src: (_a = data === null || data === void 0 ? void 0 : data.icon) === null || _a === void 0 ? void 0 : _a.url,
      width: ((_b = data === null || data === void 0 ? void 0 : data.icon) === null || _b === void 0 ? void 0 : _b.width) || '24px',
      height: ((_c = data === null || data === void 0 ? void 0 : data.icon) === null || _c === void 0 ? void 0 : _c.height) || '24px'
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: data === null || data === void 0 ? void 0 : data.title,
      color: theme.colors.positive,
      typography: designTokens.TYPOGRAPHY_KEYS.mediumW2
    }), jsxRuntime.jsx(DetailsDweb, {
      text: data === null || data === void 0 ? void 0 : data.subText1,
      color: theme.colors.mediumEmphasis,
      typography: designTokens.TYPOGRAPHY_KEYS.mediumW1
    }), jsxRuntime.jsx(DetailsDweb, {
      text: data === null || data === void 0 ? void 0 : data.subText2,
      color: theme.colors.mediumEmphasis,
      typography: designTokens.TYPOGRAPHY_KEYS.mediumW1
    }), jsxRuntime.jsxs(CtaWrapper, {
      onClick: instantLoadCtaHandler,
      id: (_d = data === null || data === void 0 ? void 0 : data.cta) === null || _d === void 0 ? void 0 : _d.nodeId,
      children: [jsxRuntime.jsx(CtaDweb, {
        text: ((_e = data === null || data === void 0 ? void 0 : data.cta) === null || _e === void 0 ? void 0 : _e.text) || 'LOAD NOW',
        typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
        color: theme.colors.primaryAccent
      }), jsxRuntime.jsx(designSystem.Image, {
        src: rightArrowBlue,
        height: '24px',
        width: '24px'
      })]
    })]
  });
};

const InstantLoadNudge = ({
  componentData,
  margin,
  onClick
}) => {
  const device = commonUi.useDevice();
  return device === commonUi.DEVICE.MOBILE ? jsxRuntime.jsx(InstantLoadNudgeMweb, {
    componentData: componentData,
    margin: margin,
    onClick: onClick
  }) : jsxRuntime.jsx(InstantLoadNudgeDweb, {
    componentData: componentData,
    margin: margin,
    onClick: onClick
  });
};

/* Mweb */
const RateTickerMwebWrap = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerMwebWrap",
  componentId: "sc-8f9h2u-0"
})(["", ";display:flex;justify-content:space-between;align-items:center;position:relative;"], ({
  margin
}) => margin && `margin: ${margin};`);
const RateTickerItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerItem",
  componentId: "sc-8f9h2u-1"
})([""]);
const RateTickerItemLft = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerItemLft",
  componentId: "sc-8f9h2u-2"
})(["width:", ";flex-shrink:0;.slick-dots{top:-20px;bottom:unset;text-align:left;left:0;display:flex !important;gap:4px;margin:0;padding:0;list-style:none;}.slick-dots li{width:unset;height:unset;margin:0;}.slick-dots li button{width:4px;height:4px;background:", ";border-radius:50%;padding:0;transition:all 0.3s;::before{display:none;}}.slick-dots li.slick-active button{background:", ";width:13px;border-radius:", ";}"], props => props.dynamicWidth ? 'calc(100% - 110px)' : '100%', ({
  theme
}) => theme.colors.disabled, ({
  theme
}) => theme.colors.highEmphasis, ({
  theme
}) => theme.borderRadius.br4);
const RateTickerItemHdr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerItemHdr",
  componentId: "sc-8f9h2u-3"
})(["display:flex;align-items:center;gap:4px;"]);
const RateTickerItemTag = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerItemTag",
  componentId: "sc-8f9h2u-4"
})(["display:inline-flex;align-items:center;justify-content:center;background:", ";border-radius:", ";padding:0 6px;height:21px;"], ({
  bgColor
}) => bgColor ? `linear-gradient(${bgColor.join(',')})` : 'linear-gradient(90deg, #D5FCEE 0%, #FFFFFF 100%)', ({
  theme
}) => theme.borderRadius.br12);
const RateTickerItemFtr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerItemFtr",
  componentId: "sc-8f9h2u-5"
})(["display:flex;align-items:baseline;gap:4px;margin-top:8px;"]);
const RateTickerItemRht = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerItemRht",
  componentId: "sc-8f9h2u-6"
})(["width:110px;flex-shrink:0;"]);
/* Dweb */
const RateTickerDwebWrap = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerDwebWrap",
  componentId: "sc-8f9h2u-7"
})(["margin:", ";display:flex;justify-content:space-between;align-items:center;position:relative;min-height:52px;"], props => {
  var _a;
  return (_a = props.margin) !== null && _a !== void 0 ? _a : '0';
});
const RateTickerLft = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerLft",
  componentId: "sc-8f9h2u-8"
})(["display:flex;align-items:center;width:580px;"]);
const RateTickerRht = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerRht",
  componentId: "sc-8f9h2u-9"
})(["display:flex;position:absolute;right:0;top:50%;transform:translateY(-50%);z-index:5;"]);
const NavActionItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__NavActionItem",
  componentId: "sc-8f9h2u-11"
})(["display:inline-flex;align-items:center;gap:4px;cursor:pointer;"]);
const RateTickerDwebBnr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerDwebBnr",
  componentId: "sc-8f9h2u-12"
})(["width:48px;flex-shrink:0;margin-right:10px;"]);
const RateTickerDwebSldr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerDwebSldr",
  componentId: "sc-8f9h2u-13"
})(["width:550px;flex-shrink:0;position:relative;overflow:hidden;"]);
const RateTickerDwebContent = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerDwebContent",
  componentId: "sc-8f9h2u-14"
})(["display:flex;flex-direction:column;width:100%;"]);
const RateTickerDwebBottomInfoBar = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerDwebBottomInfoBar",
  componentId: "sc-8f9h2u-15"
})(["display:flex;align-items:center;width:100%;height:16px;margin-top:9px;font-style:italic;"]);
const RateTickerBottomInfoImg = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerBottomInfoImg",
  componentId: "sc-8f9h2u-16"
})(["height:100%;margin-left:4px;cursor:pointer;"]);
const SliderWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__SliderWrapper",
  componentId: "sc-8f9h2u-17"
})(["position:relative;"]);
const RightBlur = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RightBlur",
  componentId: "sc-8f9h2u-18"
})(["width:20px;height:20px;content:'';position:absolute;right:0;top:0;background:linear-gradient( 270deg,rgb(255,255,255),rgb(255,255,255),rgba(255,255,255,0.5) );z-index:1;"]);
const TickerSlider = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__TickerSlider",
  componentId: "sc-8f9h2u-19"
})(["display:flex;gap:20px;overflow-x:auto;padding-right:20px;position:relative;&::-webkit-scrollbar{display:none;}scrollbar-width:none;-ms-overflow-style:none;"]);
const TickerSliderItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__TickerSliderItem",
  componentId: "sc-8f9h2u-20"
})(["display:flex;align-items:center;position:relative;flex-shrink:0;gap:4px;&:not(:last-child)::after{content:'';width:1px;height:17px;background:", ";display:inline-block;position:absolute;right:-10px;top:50%;transform:translateY(-50%);}"], ({
  theme
}) => theme.colors.cardBorder);
const TickerSliderItemTag = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__TickerSliderItemTag",
  componentId: "sc-8f9h2u-21"
})(["display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(45deg,#00d2ff 0%,#3a7bd5 100%);border-radius:12px;padding:0 8px;height:20px;"]);
const RateTickerBtns = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__RateTickerBtns",
  componentId: "sc-8f9h2u-22"
})(["width:54px;height:24px;box-shadow:0px 0.8px 4.8px 0px rgba(0,0,0,0.3);flex-shrink:0;display:flex;align-items:center;justify-content:space-between;border-radius:16px;margin-left:4px;button{background:transparent;border:none;position:relative;cursor:pointer;flex:1;display:flex;align-items:center;justify-content:center;}button:first-child::before{content:'';display:block;border:solid ", ";border-width:0 2px 2px 0;padding:3px;transform:rotate(135deg);}button:last-child::before{content:'';display:block;border:solid ", ";border-width:0 2px 2px 0;padding:3px;transform:rotate(-45deg);}button:disabled{opacity:0.5;pointer-events:none;}"], props => props.theme.colors.primaryAccent, props => props.theme.colors.primaryAccent);
const OrderButton = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerMwebstyles__OrderButton",
  componentId: "sc-8f9h2u-23"
})(["cursor:pointer;position:relative;padding:8px;border-radius:8px;&:hover{background:", ";}&:hover .ongoing-orders{display:block;}"], props => props.theme.colors.lightBlue);
const RateTickerTooltip = /*#__PURE__*/styled__default.default(designSystem.ToolTip).withConfig({
  displayName: "RateTickerMwebstyles__RateTickerTooltip",
  componentId: "sc-8f9h2u-24"
})(["left:", ";top:", ";display:flex;gap:16px;z-index:10;position:fixed;"], ({
  leftPosition
}) => `${leftPosition.x - 116}px`, ({
  leftPosition
}) => `${leftPosition.y < 220 ? leftPosition.y + 40 : leftPosition.y + 20}px`);

const RateTickerMweb = ({
  componentData,
  margin
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const theme = React.useContext(styled.ThemeContext);
  const sliderRef = React.useRef(null);
  const [autoplay, setAutoplay] = React.useState(true);
  const {
    nodeId,
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  // Load slick CSS dynamically to avoid DOM access issues in federated modules
  React.useEffect(() => {
    const cleanup = loadSlickCSS();
    return cleanup;
  }, []);
  const settings = {
    arrows: false,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: autoplay,
    afterChange: function (index) {
      var _a;
      if (index === 0) {
        (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickPause();
        setAutoplay(false);
      }
    }
  };
  React.useEffect(() => {
    var _a;
    if (autoplay) {
      (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickPlay();
    }
  }, [autoplay]);
  return jsxRuntime.jsxs(RateTickerMwebWrap, {
    margin: margin,
    id: nodeId,
    children: [jsxRuntime.jsx(RateTickerItemLft, {
      dynamicWidth: !!((_a = data === null || data === void 0 ? void 0 : data.bannerImg) === null || _a === void 0 ? void 0 : _a.url),
      children: ((_c = (_b = data === null || data === void 0 ? void 0 : data.ticker) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) && jsxRuntime.jsx(Slider, Object.assign({}, settings, {
        ref: sliderRef,
        children: (_d = data === null || data === void 0 ? void 0 : data.ticker) === null || _d === void 0 ? void 0 : _d.map((item, index) => {
          var _a, _b, _c, _d;
          return jsxRuntime.jsxs(RateTickerItem, {
            children: [jsxRuntime.jsxs(RateTickerItemHdr, {
              children: [jsxRuntime.jsx(designSystem.FormattedText, {
                text: item === null || item === void 0 ? void 0 : item.name,
                color: theme.colors.highEmphasis,
                typography: designTokens.TYPOGRAPHY_KEYS.mediumW3
              }), (item === null || item === void 0 ? void 0 : item.banner) && ((_a = item === null || item === void 0 ? void 0 : item.banner) === null || _a === void 0 ? void 0 : _a.text) && jsxRuntime.jsx(RateTickerItemTag, {
                id: (_b = item === null || item === void 0 ? void 0 : item.banner) === null || _b === void 0 ? void 0 : _b.nodeId,
                children: jsxRuntime.jsx(designSystem.FormattedText, {
                  text: (_c = item === null || item === void 0 ? void 0 : item.banner) === null || _c === void 0 ? void 0 : _c.text,
                  color: theme.colors.positive,
                  typography: designTokens.TYPOGRAPHY_KEYS.smallW2
                })
              })]
            }), jsxRuntime.jsxs(RateTickerItemFtr, {
              children: [jsxRuntime.jsx(designSystem.FormattedText, {
                text: item === null || item === void 0 ? void 0 : item.price,
                color: theme.colors.highEmphasis,
                typography: designTokens.TYPOGRAPHY_KEYS.medium
              }), jsxRuntime.jsx(designSystem.FormattedText, {
                text: (_d = item === null || item === void 0 ? void 0 : item.label) === null || _d === void 0 ? void 0 : _d.text,
                color: theme.colors.mediumEmphasis,
                typography: designTokens.TYPOGRAPHY_KEYS.smallW1
              })]
            })]
          }, index.toString());
        })
      }))
    }), !!((data === null || data === void 0 ? void 0 : data.bannerImg) && ((_e = data === null || data === void 0 ? void 0 : data.bannerImg) === null || _e === void 0 ? void 0 : _e.url)) && jsxRuntime.jsx(RateTickerItemRht, {
      id: (_f = data === null || data === void 0 ? void 0 : data.bannerImg) === null || _f === void 0 ? void 0 : _f.nodeId,
      children: jsxRuntime.jsx(designSystem.Image, {
        src: (_g = data === null || data === void 0 ? void 0 : data.bannerImg) === null || _g === void 0 ? void 0 : _g.url,
        alt: "banner"
      })
    })]
  });
};

const OngoingOrdersWrap = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OngoingOrdersstyles__OngoingOrdersWrap",
  componentId: "sc-1gx0b9j-0"
})(["position:absolute;right:0;top:24px;width:240px;border-radius:12px;background:#fff;box-shadow:0px 0px 6px 0px rgba(0,0,0,0.12),0px 6px 6px 0px rgba(0,0,0,0.24),0px 0px 12px 0px rgba(0,0,0,0.12),0px 12px 12px 0px rgba(0,0,0,0.24);border-radius:12px;padding:12px 14px;z-index:10;display:none;&.ongoing-orders{display:none;}"]);
const OngoingOrdersList = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OngoingOrdersstyles__OngoingOrdersList",
  componentId: "sc-1gx0b9j-1"
})(["display:grid;grid-template-columns:1fr;gap:8px;"]);
const OngoingOrdersListItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OngoingOrdersstyles__OngoingOrdersListItem",
  componentId: "sc-1gx0b9j-2"
})(["background:", ";border-radius:12px;padding:12px;"], ({
  theme
}) => theme.colors.screenBg);
const OngoingOrdersListItemHdr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OngoingOrdersstyles__OngoingOrdersListItemHdr",
  componentId: "sc-1gx0b9j-3"
})(["display:flex;"]);
const OngoingOrderAnchor = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OngoingOrdersstyles__OngoingOrderAnchor",
  componentId: "sc-1gx0b9j-4"
})(["a{display:flex;align-items:center;}"]);

const OngoingOrders = ({
  navActions
}) => {
  var _a, _b, _c, _d, _e, _f;
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(OngoingOrdersWrap, {
    className: "ongoing-orders",
    children: [jsxRuntime.jsx(OngoingOrdersList, {
      children: (_a = navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) === null || _a === void 0 ? void 0 : _a.map((item, index) => {
        var _a, _b, _c;
        return jsxRuntime.jsxs(OngoingOrdersListItem, {
          onClick: () => {
            var _a;
            if ((_a = item === null || item === void 0 ? void 0 : item.cta) === null || _a === void 0 ? void 0 : _a.deeplink) redirectTo(item.cta.deeplink);
          },
          children: [jsxRuntime.jsxs(OngoingOrdersListItemHdr, {
            children: [(item === null || item === void 0 ? void 0 : item.text) && jsxRuntime.jsx(designSystem.FormattedText, {
              text: item === null || item === void 0 ? void 0 : item.text,
              color: theme.colors.highEmphasis,
              typography: designTokens.TYPOGRAPHY_KEYS.baseW2
            }), ((_a = item === null || item === void 0 ? void 0 : item.icon) === null || _a === void 0 ? void 0 : _a.url) && jsxRuntime.jsx(designSystem.Image, {
              width: "12px",
              height: "12px",
              src: (_b = item.icon) === null || _b === void 0 ? void 0 : _b.url,
              alt: (_c = item.icon) === null || _c === void 0 ? void 0 : _c.type,
              margin: "0px 0px 0px auto"
            }, index)]
          }), (item === null || item === void 0 ? void 0 : item.subText) && jsxRuntime.jsx(designSystem.FormattedText, {
            text: item === null || item === void 0 ? void 0 : item.subText,
            color: theme.colors.highEmphasis,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
            margin: "3px 0 0 0"
          }), (item === null || item === void 0 ? void 0 : item.statusText) && jsxRuntime.jsx(designSystem.FormattedText, {
            text: item === null || item === void 0 ? void 0 : item.statusText,
            color: theme.colors.mediumEmphasis,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
            margin: "3px 0 0 0"
          }), (item === null || item === void 0 ? void 0 : item.status) && jsxRuntime.jsx(designSystem.FormattedText, {
            text: item === null || item === void 0 ? void 0 : item.status,
            color: theme.colors.warning,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
            margin: "3px 0 0 0"
          })]
        }, index);
      })
    }), (navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders) && Object.keys(navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders).length > 0 && jsxRuntime.jsx(OngoingOrderAnchor, {
      children: jsxRuntime.jsxs(designSystem.Anchor, {
        color: theme.colors.primaryAccent,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
        onClick: () => {
          var _a, _b;
          const url = (_b = (_a = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.deeplink;
          if (url) {
            redirectTo(url);
          }
        },
        margin: "10px 0 0 0",
        children: [(_c = (_b = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders) === null || _b === void 0 ? void 0 : _b.cta) === null || _c === void 0 ? void 0 : _c.text, ((_d = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders.icon) === null || _d === void 0 ? void 0 : _d.url) && jsxRuntime.jsx(designSystem.Image, {
          width: "12px",
          height: "12px",
          src: (_e = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders.icon) === null || _e === void 0 ? void 0 : _e.url,
          alt: (_f = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders.icon) === null || _f === void 0 ? void 0 : _f.type,
          margin: "0 0 0 5px"
        })]
      })
    })]
  });
};

const RateTickerDweb = ({
  componentData,
  margin,
  bottomSheets
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
  const theme = React.useContext(styled.ThemeContext);
  const sliderRef = React.useRef(null);
  const [autoplay, setAutoplay] = React.useState(true);
  const [isAtStart, setIsAtStart] = React.useState(true);
  const [isAtEnd, setIsAtEnd] = React.useState(true);
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [hasAutoplayRun, setHasAutoplayRun] = React.useState(false);
  const [arrowPosition, setArrowPosition] = React.useState({
    x: 0,
    y: 0
  });
  const [isOpen, setIsOpen] = React.useState(false);
  const {
    data,
    navActions
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  React.useEffect(() => {
    let interval;
    if (autoplay && !hasAutoplayRun) {
      interval = setInterval(() => {
        if (sliderRef.current) {
          const maxScrollLeft = sliderRef.current.scrollWidth - sliderRef.current.clientWidth;
          if (Math.ceil(sliderRef.current.scrollLeft) >= maxScrollLeft) {
            clearInterval(interval);
            setHasAutoplayRun(true);
            setTimeout(() => {
              sliderRef.current.scrollTo({
                left: 0,
                behavior: 'smooth'
              });
              setTimeout(() => {
                updateButtonStates();
              }, 500);
              setAutoplay(false);
            }, 500);
          } else {
            sliderRef.current.scrollBy({
              left: 3,
              behavior: 'smooth'
            });
            updateButtonStates();
          }
        }
      }, 30);
    }
    return () => clearInterval(interval);
  }, [autoplay, hasAutoplayRun]);
  const handleNext = () => {
    var _a, _b, _c;
    if (sliderRef.current) {
      const maxScrollLeft = sliderRef.current.scrollWidth - sliderRef.current.clientWidth;
      const targetScrollLeft = Math.min(sliderRef.current.scrollLeft + 150, maxScrollLeft);
      pdtUtils.trackEvent({
        eventData: (_c = (_b = (_a = componentData === null || componentData === void 0 ? void 0 : componentData.tracking) === null || _a === void 0 ? void 0 : _a.tickerScroll) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.pdtData
      });
      sliderRef.current.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    }
  };
  const handlePrev = () => {
    var _a, _b, _c;
    if (sliderRef.current) {
      const targetScrollLeft = Math.max(sliderRef.current.scrollLeft - 150, 0);
      pdtUtils.trackEvent({
        eventData: (_c = (_b = (_a = componentData === null || componentData === void 0 ? void 0 : componentData.tracking) === null || _a === void 0 ? void 0 : _a.tickerScroll) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.pdtData
      });
      sliderRef.current.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    }
  };
  const updateButtonStates = () => {
    if (sliderRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = sliderRef.current;
      const maxWidth = scrollWidth - clientWidth;
      setIsAtStart(scrollLeft <= 0);
      setIsAtEnd(Math.ceil(scrollLeft) >= maxWidth);
    }
  };
  React.useEffect(() => {
    const slider = sliderRef.current;
    if (slider) {
      updateButtonStates();
      slider.addEventListener('scroll', updateButtonStates);
      return () => {
        slider.removeEventListener('scroll', updateButtonStates);
      };
    }
  }, []);
  const handleBottomInfoBarClick = () => {
    var _a, _b, _c, _d;
    pdtUtils.trackEvent({
      eventData: (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.bottomInfoBar) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.cta) === null || _c === void 0 ? void 0 : _c.analytics) === null || _d === void 0 ? void 0 : _d.pdtData
    });
    setIsOpen(true);
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(RateTickerDwebWrap, {
      margin: margin,
      children: [(data === null || data === void 0 ? void 0 : data.ticker) && ((_a = data === null || data === void 0 ? void 0 : data.ticker) === null || _a === void 0 ? void 0 : _a.length) > 0 ? jsxRuntime.jsxs(RateTickerLft, {
        children: [((_b = data === null || data === void 0 ? void 0 : data.bannerImg) === null || _b === void 0 ? void 0 : _b.url) && jsxRuntime.jsx(RateTickerDwebBnr, {
          children: jsxRuntime.jsx(designSystem.Image, {
            src: (_c = data === null || data === void 0 ? void 0 : data.bannerImg) === null || _c === void 0 ? void 0 : _c.url,
            alt: "banner"
          })
        }), jsxRuntime.jsxs(RateTickerDwebContent, {
          children: [jsxRuntime.jsxs(RateTickerDwebSldr, {
            dynamicWidth: !!((data === null || data === void 0 ? void 0 : data.bannerImg) && ((_d = data === null || data === void 0 ? void 0 : data.bannerImg) === null || _d === void 0 ? void 0 : _d.url)),
            onMouseEnter: e => {
              setArrowPosition(Object.assign(Object.assign({}, arrowPosition), {
                x: e.clientX,
                y: e.clientY
              }));
              setShowTooltip(true);
              setAutoplay(false);
            },
            onMouseLeave: () => {
              setShowTooltip(false);
              setArrowPosition(Object.assign(Object.assign({}, arrowPosition), {
                x: 0,
                y: 0
              }));
              if (!hasAutoplayRun) setAutoplay(true);
            },
            children: [jsxRuntime.jsxs(SliderWrapper, {
              children: [showTooltip && jsxRuntime.jsx(RateTickerTooltip, {
                width: "233px",
                arrowDirection: "up",
                leftPosition: arrowPosition,
                children: jsxRuntime.jsx(designSystem.FormattedText, {
                  text: (_e = data === null || data === void 0 ? void 0 : data.toolTip) === null || _e === void 0 ? void 0 : _e.text,
                  typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
                  color: theme.colors.white
                })
              }), ((_f = data === null || data === void 0 ? void 0 : data.ticker) === null || _f === void 0 ? void 0 : _f.length) > 0 && jsxRuntime.jsx(TickerSlider, {
                ref: sliderRef,
                children: (_g = data === null || data === void 0 ? void 0 : data.ticker) === null || _g === void 0 ? void 0 : _g.map((item, index) => {
                  var _a;
                  return jsxRuntime.jsxs(TickerSliderItem, {
                    children: [((_a = item === null || item === void 0 ? void 0 : item.banner) === null || _a === void 0 ? void 0 : _a.text) && jsxRuntime.jsx(TickerSliderItemTag, {
                      children: jsxRuntime.jsx(designSystem.FormattedText, {
                        text: item.banner.text,
                        color: theme.colors.white,
                        typography: designTokens.TYPOGRAPHY_KEYS.smallW2
                      })
                    }), (item === null || item === void 0 ? void 0 : item.name) && jsxRuntime.jsx(designSystem.FormattedText, {
                      text: item.name,
                      color: theme.colors.mediumEmphasis,
                      typography: designTokens.TYPOGRAPHY_KEYS.mediumW1
                    }), (item === null || item === void 0 ? void 0 : item.price) && jsxRuntime.jsx(designSystem.FormattedText, {
                      text: item.price,
                      color: theme.colors.mediumEmphasis,
                      typography: designTokens.TYPOGRAPHY_KEYS.mediumW3
                    })]
                  }, index);
                })
              })]
            }), jsxRuntime.jsx(RightBlur, {})]
          }), (data === null || data === void 0 ? void 0 : data.bottomInfoBar) && jsxRuntime.jsxs(RateTickerDwebBottomInfoBar, {
            children: [jsxRuntime.jsx(designSystem.FormattedText, {
              text: (_h = data === null || data === void 0 ? void 0 : data.bottomInfoBar) === null || _h === void 0 ? void 0 : _h.text,
              color: theme.colors.mediumEmphasis,
              typography: designTokens.TYPOGRAPHY_KEYS.smallW1
            }), ((_l = (_k = (_j = data === null || data === void 0 ? void 0 : data.bottomInfoBar) === null || _j === void 0 ? void 0 : _j.info) === null || _k === void 0 ? void 0 : _k.icon) === null || _l === void 0 ? void 0 : _l.url) && jsxRuntime.jsx(RateTickerBottomInfoImg, {
              onClick: handleBottomInfoBarClick,
              children: jsxRuntime.jsx(designSystem.Image, {
                src: (_p = (_o = (_m = data === null || data === void 0 ? void 0 : data.bottomInfoBar) === null || _m === void 0 ? void 0 : _m.info) === null || _o === void 0 ? void 0 : _o.icon) === null || _p === void 0 ? void 0 : _p.url,
                alt: "bottomInfoBar",
                width: "16px",
                height: "16px"
              })
            })]
          })]
        }), jsxRuntime.jsxs(RateTickerBtns, {
          children: [jsxRuntime.jsx("button", {
            onClick: handlePrev,
            disabled: isAtStart
          }), jsxRuntime.jsx("button", {
            onClick: handleNext,
            disabled: isAtEnd
          })]
        })]
      }) : jsxRuntime.jsx(RateTickerLft, {}), navActions && Object.keys(navActions).length > 0 && jsxRuntime.jsx(RateTickerRht, {
        children: jsxRuntime.jsxs(OrderButton, {
          children: [jsxRuntime.jsxs(NavActionItem, {
            children: [jsxRuntime.jsx(designSystem.FormattedText, {
              text: navActions.title,
              color: theme.colors.primaryAccent,
              typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
              onClick: () => {
                var _a, _b, _c, _d, _e, _f;
                const url = (_b = (_a = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.deeplink;
                pdtUtils.trackEvent({
                  eventData: (_e = (_d = (_c = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders) === null || _c === void 0 ? void 0 : _c.cta) === null || _d === void 0 ? void 0 : _d.analytics) === null || _e === void 0 ? void 0 : _e.pdtData
                });
                if (!((_f = navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) === null || _f === void 0 ? void 0 : _f.length) && url) {
                  redirectTo(url);
                }
              }
            }), ((_q = navActions === null || navActions === void 0 ? void 0 : navActions.icon) === null || _q === void 0 ? void 0 : _q.url) && jsxRuntime.jsx(designSystem.Image, {
              width: "12px",
              height: "12px",
              src: (_r = navActions.icon) === null || _r === void 0 ? void 0 : _r.url,
              alt: (_s = navActions.icon) === null || _s === void 0 ? void 0 : _s.type
            })]
          }), ((_u = (_t = navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) === null || _t === void 0 ? void 0 : _t.length) !== null && _u !== void 0 ? _u : 0) > 0 && jsxRuntime.jsx(designSystem.FormattedText, {
            text: navActions === null || navActions === void 0 ? void 0 : navActions.subTitle,
            color: theme.colors.warning,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1
          }), (navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) && ((_v = navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) === null || _v === void 0 ? void 0 : _v.length) > 0 && jsxRuntime.jsx(OngoingOrders, {
            navActions: {
              ongoingOrders: navActions.ongoingOrders,
              previousOrders: navActions.previousOrders
            }
          })]
        })
      })]
    }), ((_y = (_x = (_w = data === null || data === void 0 ? void 0 : data.bottomInfoBar) === null || _w === void 0 ? void 0 : _w.info) === null || _x === void 0 ? void 0 : _x.cta) === null || _y === void 0 ? void 0 : _y.modalId) && bottomSheets[data.bottomInfoBar.info.cta.modalId] && isOpen && jsxRuntime.jsx(CouponDetailsBottomSheet, {
      data: bottomSheets[data.bottomInfoBar.info.cta.modalId],
      onModalClose: () => setIsOpen(false)
    })]
  });
};

const BottomSheetContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__BottomSheetContainer",
  componentId: "sc-17jlsuy-1"
})(["background:#ffffff;width:100%;max-height:80vh;display:flex;flex-direction:column;margin-bottom:30px;overflow:hidden;"]);
const ColumnHeaders = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__ColumnHeaders",
  componentId: "sc-17jlsuy-6"
})(["display:flex;align-items:center;padding:0 0px 12px;border-bottom:1px solid #d8d8d8;"]);
const ColumnHeader = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__ColumnHeader",
  componentId: "sc-17jlsuy-7"
})(["font-family:'Lato',sans-serif;font-weight:700;font-size:14px;line-height:1.2;color:#000000;text-align:", ";flex:1;"], props => props.textAlign || 'center');
const CurrencyList = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__CurrencyList",
  componentId: "sc-17jlsuy-8"
})(["flex:1;overflow-y:auto;max-height:266px;padding:0 0px;"]);
const CurrencyItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__CurrencyItem",
  componentId: "sc-17jlsuy-9"
})(["display:flex;align-items:center;gap:12px;padding:8px 0;border-bottom:1px solid #f2f2f2;&:last-child{border-bottom:none;}"]);
const CurrencyInfo = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__CurrencyInfo",
  componentId: "sc-17jlsuy-10"
})(["display:flex;align-items:center;gap:8px;width:100px;flex-shrink:0;"]);
const CurrencyDetails = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__CurrencyDetails",
  componentId: "sc-17jlsuy-11"
})(["display:flex;flex-direction:column;gap:2px;"]);
const CurrencyName = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__CurrencyName",
  componentId: "sc-17jlsuy-12"
})(["font-family:'Open Sans',sans-serif;font-weight:400;font-size:12px;line-height:1.36;color:#000000;"]);
const CurrencyCode = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__CurrencyCode",
  componentId: "sc-17jlsuy-13"
})(["font-family:'Open Sans',sans-serif;font-weight:400;font-size:12px;line-height:1.36;color:#757575;"]);
const RatesContainer$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__RatesContainer",
  componentId: "sc-17jlsuy-14"
})(["display:flex;flex:1;gap:1px;"]);
const RateColumn = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__RateColumn",
  componentId: "sc-17jlsuy-15"
})(["display:flex;flex-direction:column;justify-content:center;align-items:", ";flex:1;padding:0 8px;gap:1px;"], props => props.alignItems || 'flex-end');
const RateValue = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__RateValue",
  componentId: "sc-17jlsuy-16"
})(["font-family:'Open Sans',sans-serif;font-weight:400;font-size:12px;line-height:1.36;color:#000000;text-align:center;"]);
const Footer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__Footer",
  componentId: "sc-17jlsuy-17"
})(["background:#eaf5ff;padding:10px 30px;display:flex;align-items:center;justify-content:center;width:100%;position:absolute;left:0;width:100%;bottom:0;"]);
const FooterText = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerBottomSheetstyles__FooterText",
  componentId: "sc-17jlsuy-18"
})(["font-family:'Lato',sans-serif;font-weight:400;font-size:12px;line-height:1.2;color:#4a4a4a;text-align:left;max-width:387px;"]);

const RateTickerBottomSheet = ({
  isOpen,
  onClose,
  currencies,
  title: _title = 'Offer Detail',
  columnHeaders,
  footerText
}) => {
  if (!isOpen) return null;
  // Default column headers
  const defaultColumnHeaders = {
    currency: 'Currency',
    card: 'Card (₹)',
    currencyNotes: 'Currency Notes (₹)'
  };
  const headers = columnHeaders || defaultColumnHeaders;
  // Default footer text
  const defaultFooterText = 'Place forex order with required amount to know rates of desired currencies';
  const footerContent = (footerText === null || footerText === void 0 ? void 0 : footerText.text) || defaultFooterText;
  return jsxRuntime.jsxs(designSystem.Modal, {
    modalType: "centered",
    heading: _title,
    onModalClose: onClose,
    showCloseButton: true,
    modalMaxHeight: "80vh",
    children: [jsxRuntime.jsxs(BottomSheetContainer, {
      children: [jsxRuntime.jsxs(ColumnHeaders, {
        children: [jsxRuntime.jsx(ColumnHeader, {
          textAlign: "left",
          children: headers.currency
        }), jsxRuntime.jsx(ColumnHeader, {
          children: headers.card
        }), jsxRuntime.jsx(ColumnHeader, {
          children: headers.currencyNotes
        })]
      }), jsxRuntime.jsx(CurrencyList, {
        children: currencies.map(currency => jsxRuntime.jsxs(CurrencyItem, {
          children: [jsxRuntime.jsx(CurrencyInfo, {
            children: jsxRuntime.jsxs(CurrencyDetails, {
              children: [jsxRuntime.jsx(CurrencyName, {
                children: currency.name
              }), jsxRuntime.jsx(CurrencyCode, {
                children: currency.code
              })]
            })
          }), jsxRuntime.jsxs(RatesContainer$1, {
            children: [jsxRuntime.jsx(RateColumn, {
              alignItems: "center",
              children: jsxRuntime.jsx(RateValue, {
                children: currency.cardRate
              })
            }), jsxRuntime.jsx(RateColumn, {
              alignItems: "center",
              children: jsxRuntime.jsx(RateValue, {
                children: currency.currencyNotesRate
              })
            })]
          })]
        }, currency.id))
      })]
    }), jsxRuntime.jsx(Footer, {
      children: jsxRuntime.jsx(FooterText, {
        children: footerContent
      })
    })]
  });
};

// Main container
const RateTickerDwebNewWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__RateTickerDwebNewWrapper",
  componentId: "sc-1p16dz7-0"
})(["margin:", ";position:relative;display:flex;align-items:center;width:100%;max-width:1160px;"], props => {
  var _a;
  return (_a = props.margin) !== null && _a !== void 0 ? _a : '0';
});
// Left side container
const LeftSection = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__LeftSection",
  componentId: "sc-1p16dz7-1"
})(["display:flex;align-items:center;justify-content:center;gap:-12px;width:100%;"]);
// Lowest Rate Guarantee Badge
const LowestRateBadge = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__LowestRateBadge",
  componentId: "sc-1p16dz7-2"
})(["display:flex;align-items:center;gap:4px;padding:0px 21px 0px 16px;height:60px;background:linear-gradient(90deg,rgb(255,255,255),rgb(250,241,251));border-radius:9px;position:relative;z-index:2;&::before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;border-radius:9px;padding:1px;background:linear-gradient( 90deg,rgba(249,240,251,1) 0%,rgba(234,233,247,1) 100% );mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite:xor;-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;}"]);
const RupeeIcon = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__RupeeIcon",
  componentId: "sc-1p16dz7-3"
})(["width:16px;height:16px;background:linear-gradient( 225deg,rgba(48,35,174,1) 0%,rgba(200,109,215,1) 100% );border-radius:50%;display:flex;align-items:center;justify-content:center;position:relative;&::before{content:'\u20B9';color:white;font-size:8px;font-weight:bold;}"]);
const BadgeText = /*#__PURE__*/styled__default.default.span.withConfig({
  displayName: "RateTickerDwebNewstyles__BadgeText",
  componentId: "sc-1p16dz7-4"
})(["font-family:Lato;font-weight:700;font-size:14px;line-height:1.2;background:linear-gradient( 225deg,rgba(48,35,174,1) 0%,rgba(200,109,215,1) 100% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;"]);
// Rates container
const RatesContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__RatesContainer",
  componentId: "sc-1p16dz7-5"
})(["display:flex;justify-content:center;align-items:center;gap:16px;padding:0px 16px;background:#ffffff;border-radius:8px;height:60px;position:relative;z-index:2;margin-left:-12px;overflow:hidden;&::before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;border-radius:8px;padding:1px;background:linear-gradient( 90deg,rgba(249,240,251,1) 0%,rgba(234,233,247,1) 100% );mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);mask-composite:xor;-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;}"]);
// Animated rates wrapper
const AnimatedRatesWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__AnimatedRatesWrapper",
  componentId: "sc-1p16dz7-6"
})(["width:201px;height:50px;position:relative;overflow:hidden;"]);
const RatesSlider = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__RatesSlider",
  componentId: "sc-1p16dz7-7"
})(["display:flex;flex-direction:column;height:", "px;width:283px;position:absolute;top:0px;left:8px;transform:translateY(", "px);transition:", ";"], props => props.totalItems * 2 * 50, props => -props.currentIndex * 50, props => props.isTransitioning ? 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)' : 'none');
const RateItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__RateItem",
  componentId: "sc-1p16dz7-8"
})(["display:flex;align-items:center;gap:4px;width:283px;height:50px;position:relative;flex-shrink:0;", ""], props => props.isUpcoming && `
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    min-height: 50px;
    overflow: hidden;
  `);
const AtSymbol = /*#__PURE__*/styled__default.default.span.withConfig({
  displayName: "RateTickerDwebNewstyles__AtSymbol",
  componentId: "sc-1p16dz7-10"
})(["font-family:Lato;font-weight:400;font-size:16px;line-height:1.2;color:#757575;"]);
const UpcomingText = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__UpcomingText",
  componentId: "sc-1p16dz7-12"
})(["font-family:Lato;font-weight:400;font-size:14px;line-height:1.2;color:#4a4a4a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;max-width:195px;min-width:0;flex-shrink:1;display:block;"]);
// Arrow button
const ArrowButton = /*#__PURE__*/styled__default.default.button.withConfig({
  displayName: "RateTickerDwebNewstyles__ArrowButton",
  componentId: "sc-1p16dz7-13"
})(["display:flex;justify-content:center;align-items:center;width:24px;height:24px;background:#eaf5ff;border:none;border-radius:50%;cursor:pointer;position:relative;margin-left:6.86px;&:hover{background:#d1e7ff;}&:active{transform:scale(0.95);}"]);
const ArrowIcon = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "RateTickerDwebNewstyles__ArrowIcon",
  componentId: "sc-1p16dz7-14"
})(["width:100%;height:100%;"]);
// New styled components for inline divs
const RateItemContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__RateItemContainer",
  componentId: "sc-1p16dz7-19"
})(["display:flex;flex-direction:column;align-items:flex-start;direction:ltr;text-align:left;width:100%;max-width:283px;min-width:0;"]);
const CurrencyRateContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "RateTickerDwebNewstyles__CurrencyRateContainer",
  componentId: "sc-1p16dz7-20"
})(["display:flex;align-items:center;justify-content:flex-start;gap:4px;direction:ltr;width:100%;"]);

// Fallback dummy data for the bottom sheet
const fallbackCurrencies = [{
  id: 'usd',
  name: 'US Dollar',
  code: 'USD',
  cardRate: '81.0012',
  currencyNotesRate: '81.4611'
}, {
  id: 'eur',
  name: 'Euro',
  code: 'EUR',
  cardRate: '103.3113',
  currencyNotesRate: '103.3261'
}, {
  id: 'gbp',
  name: 'British Pound',
  code: 'GBP',
  cardRate: '119.4576',
  currencyNotesRate: '119.4529'
}];
const RateTickerDwebNew = ({
  componentData,
  margin,
  bottomSheets
}) => {
  var _a, _b, _c, _d, _e, _f;
  const theme = React.useContext(styled.ThemeContext);
  const [currentRateIndex, setCurrentRateIndex] = React.useState(0);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isTransitioning, setIsTransitioning] = React.useState(false);
  const {
    data,
    navActions
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const {
    ticker,
    bottomInfoBar,
    leftText
  } = data !== null && data !== void 0 ? data : {};
  // Extract dynamic bottom sheet data
  const rateTickerBottomSheetData = bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.RATE_TICKER_BOTTOMSHEET;
  const currencies = (rateTickerBottomSheetData === null || rateTickerBottomSheetData === void 0 ? void 0 : rateTickerBottomSheetData.currencies) || fallbackCurrencies;
  const bottomSheetTitle = (rateTickerBottomSheetData === null || rateTickerBottomSheetData === void 0 ? void 0 : rateTickerBottomSheetData.title) || 'Offer Detail';
  const columnHeaders = rateTickerBottomSheetData === null || rateTickerBottomSheetData === void 0 ? void 0 : rateTickerBottomSheetData.columnHeaders;
  const footerText = rateTickerBottomSheetData === null || rateTickerBottomSheetData === void 0 ? void 0 : rateTickerBottomSheetData.footerText;
  // Auto-rotate through rates with seamless loop
  React.useEffect(() => {
    if (!ticker || ticker.length <= 1) return;
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setCurrentRateIndex(prev => {
        const nextIndex = prev + 1;
        // When we reach the end of the first set, reset to 0 for seamless loop
        if (nextIndex >= ticker.length) {
          // Reset without transition for seamless loop
          setTimeout(() => {
            setCurrentRateIndex(0);
            setIsTransitioning(false);
          }, 800); // Wait for transition to complete
          return nextIndex;
        }
        return nextIndex;
      });
    }, 2500); // Change rate every 2.5 seconds for smooth animation
    return () => clearInterval(interval);
  }, [ticker]);
  const handleArrowClick = () => {
    var _a, _b;
    if ((_b = (_a = bottomInfoBar === null || bottomInfoBar === void 0 ? void 0 : bottomInfoBar.info) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.analytics) {
      pdtUtils.trackEvent({
        eventData: bottomInfoBar.info.cta.analytics.pdtData
      });
    }
    setIsOpen(true);
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(RateTickerDwebNewWrapper, {
      margin: margin,
      children: [jsxRuntime.jsxs(LeftSection, {
        children: [jsxRuntime.jsxs(LowestRateBadge, {
          children: [jsxRuntime.jsx(RupeeIcon, {}), jsxRuntime.jsx(BadgeText, {
            children: leftText
          })]
        }), ticker && ticker.length > 0 && jsxRuntime.jsxs(RatesContainer, {
          children: [jsxRuntime.jsx(AnimatedRatesWrapper, {
            children: jsxRuntime.jsx(RatesSlider, {
              currentIndex: currentRateIndex,
              totalItems: ticker.length,
              isTransitioning: isTransitioning,
              children: [...ticker, ...ticker].map((item, index) => {
                var _a, _b;
                return jsxRuntime.jsx(RateItem, {
                  isUpcoming: ((_a = item.banner) === null || _a === void 0 ? void 0 : _a.text) ? true : false,
                  children: jsxRuntime.jsxs(RateItemContainer, {
                    children: [((_b = item.banner) === null || _b === void 0 ? void 0 : _b.text) && jsxRuntime.jsx(UpcomingText, {
                      children: typeof item.banner.text === 'string' ? item.banner.text : Array.isArray(item.banner.text) ? item.banner.text.map(t => typeof t === 'string' ? t : 'text' in t ? t.text : '').join('') : 'text' in item.banner.text ? item.banner.text.text : ''
                    }), jsxRuntime.jsxs(CurrencyRateContainer, {
                      children: [jsxRuntime.jsx(designSystem.FormattedText, {
                        text: item === null || item === void 0 ? void 0 : item.name,
                        typography: designTokens.TYPOGRAPHY_KEYS.largeW3,
                        color: '#000000'
                      }), jsxRuntime.jsx(AtSymbol, {
                        children: "@"
                      }), jsxRuntime.jsx(designSystem.FormattedText, {
                        text: item.price,
                        typography: designTokens.TYPOGRAPHY_KEYS.largeW3,
                        color: '#007E7D'
                      }), item.showNER && jsxRuntime.jsx(designSystem.FormattedText, {
                        text: "*",
                        typography: designTokens.TYPOGRAPHY_KEYS.largeW3,
                        color: '#EC2127'
                      })]
                    })]
                  })
                }, `${index}-${item.name}`);
              })
            })
          }), jsxRuntime.jsx(ArrowButton, {
            onClick: handleArrowClick,
            children: jsxRuntime.jsx(ArrowIcon, {
              src: "https://go-assets.ibcdn.com/u/MMT/images/1757485658263-rate-ticker-bottom-sheet-design.png",
              alt: "arrow"
            })
          })]
        })]
      }), navActions && Object.keys(navActions).length > 0 && jsxRuntime.jsx(RateTickerRht, {
        children: jsxRuntime.jsxs(OrderButton, {
          children: [jsxRuntime.jsxs(NavActionItem, {
            children: [jsxRuntime.jsx(designSystem.FormattedText, {
              text: navActions.title,
              color: theme.colors.primaryAccent,
              typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
              onClick: () => {
                var _a, _b, _c, _d, _e, _f;
                const url = (_b = (_a = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.deeplink;
                pdtUtils.trackEvent({
                  eventData: (_e = (_d = (_c = navActions === null || navActions === void 0 ? void 0 : navActions.previousOrders) === null || _c === void 0 ? void 0 : _c.cta) === null || _d === void 0 ? void 0 : _d.analytics) === null || _e === void 0 ? void 0 : _e.pdtData
                });
                if (!((_f = navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) === null || _f === void 0 ? void 0 : _f.length) && url) {
                  redirectTo(url);
                }
              }
            }), ((_a = navActions === null || navActions === void 0 ? void 0 : navActions.icon) === null || _a === void 0 ? void 0 : _a.url) && jsxRuntime.jsx(designSystem.Image, {
              width: "12px",
              height: "12px",
              src: (_b = navActions.icon) === null || _b === void 0 ? void 0 : _b.url,
              alt: (_c = navActions.icon) === null || _c === void 0 ? void 0 : _c.type
            })]
          }), ((_e = (_d = navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0 && jsxRuntime.jsx(designSystem.FormattedText, {
            text: navActions === null || navActions === void 0 ? void 0 : navActions.subTitle,
            color: theme.colors.warning,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1
          }), (navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) && ((_f = navActions === null || navActions === void 0 ? void 0 : navActions.ongoingOrders) === null || _f === void 0 ? void 0 : _f.length) > 0 && jsxRuntime.jsx(OngoingOrders, {
            navActions: {
              ongoingOrders: navActions.ongoingOrders,
              previousOrders: navActions.previousOrders
            }
          })]
        })
      })]
    }), jsxRuntime.jsx(RateTickerBottomSheet, {
      isOpen: isOpen,
      onClose: () => setIsOpen(false),
      currencies: currencies,
      title: bottomSheetTitle,
      columnHeaders: columnHeaders,
      footerText: footerText
    })]
  });
};

const Wrapper$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__Wrapper",
  componentId: "sc-1n13k54-0"
})(["", ";"], ({
  margin
}) => margin && `margin: ${margin};`);
const OrderStatusMwebWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__OrderStatusMwebWrapper",
  componentId: "sc-1n13k54-1"
})(["display:flex;flex:1;flex-direction:row;overflow-x:scroll;padding:0 16px;margin:0 -16px;gap:16px;"]);
const OrderItemWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__OrderItemWrapper",
  componentId: "sc-1n13k54-2"
})(["display:flex;flex-shrink:0;flex-direction:column;max-width:300px;padding:12px 16px;border-radius:", ";border:1px solid;border-color:", ";background:", ";align-self:flex-start;"], ({
  theme
}) => theme.borderRadius.br16, ({
  borderColor
}) => borderColor ? borderColor : '#F9D293', ({
  bgColor
}) => bgColor ? `linear-gradient(${bgColor.join(',')})` : '#FCEDD4');
const Section = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__Section",
  componentId: "sc-1n13k54-3"
})(["display:flex;align-items:flex-start;gap:12px;flex-direction:row;", ";"], ({
  margin
}) => margin && `margin: ${margin};`);
const TitleWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__TitleWrapper",
  componentId: "sc-1n13k54-4"
})(["display:flex;flex-direction:column;gap:2px;"]);
const ArrowCta = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__ArrowCta",
  componentId: "sc-1n13k54-5"
})(["cursor:pointer;margin-left:auto;flex-shrink:0;"]);
const ButtonWrapper = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "OrderStatusMwebstyles__ButtonWrapper",
  componentId: "sc-1n13k54-6"
})(["padding:8px 12px;text-transform:uppercase;width:82px;"]);
const SeparatorContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__SeparatorContainer",
  componentId: "sc-1n13k54-7"
})(["display:flex;align-items:center;justify-content:center;margin:24px 0;"]);
const Line = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusMwebstyles__Line",
  componentId: "sc-1n13k54-8"
})(["flex:1;height:1px;background:", ";"], ({
  theme
}) => theme.colors.disabled);

const OrderTitle$1 = ({
  title,
  subtitle,
  theme
}) => jsxRuntime.jsxs(TitleWrapper, {
  children: [jsxRuntime.jsx(designSystem.FormattedText, {
    text: title,
    color: theme.colors.highEmphasis,
    typography: designTokens.TYPOGRAPHY_KEYS.smallW3
  }), jsxRuntime.jsx(designSystem.FormattedText, {
    text: subtitle,
    color: theme.colors.mediumEmphasis,
    typography: designTokens.TYPOGRAPHY_KEYS.baseW1
  })]
});
const OrderCTA = ({
  cta,
  onClick
}) => {
  var _a;
  if (!cta) return null;
  const isArrowCta = cta.id === 'ARROW_CTA';
  return isArrowCta ? jsxRuntime.jsx(ArrowCta, {
    onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(cta),
    id: cta === null || cta === void 0 ? void 0 : cta.nodeId,
    children: jsxRuntime.jsx(designSystem.Image, {
      src: ((_a = cta === null || cta === void 0 ? void 0 : cta.icon) === null || _a === void 0 ? void 0 : _a.url) || rightArrowBlue,
      height: "24px",
      width: "24px"
    })
  }) : jsxRuntime.jsx(ButtonWrapper, {
    label: cta === null || cta === void 0 ? void 0 : cta.text,
    onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(cta),
    typography: designTokens.TYPOGRAPHY_KEYS.baseW3,
    margin: "0px 0px 0px auto",
    id: cta === null || cta === void 0 ? void 0 : cta.nodeId
  });
};
const OrderSubText = ({
  subText1,
  subText2,
  theme
}) => jsxRuntime.jsxs(TitleWrapper, {
  children: [jsxRuntime.jsx(designSystem.FormattedText, {
    text: subText1,
    color: theme.colors.mediumEmphasis,
    typography: designTokens.TYPOGRAPHY_KEYS.baseW1
  }), jsxRuntime.jsx(designSystem.FormattedText, {
    text: subText2,
    color: theme.colors.mediumEmphasis,
    typography: designTokens.TYPOGRAPHY_KEYS.baseW2
  })]
});
const OrderItem = ({
  item,
  onClick
}) => {
  var _a, _b;
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(OrderItemWrapper, {
    bgColor: item === null || item === void 0 ? void 0 : item.bgColors,
    borderColor: item === null || item === void 0 ? void 0 : item.borderColors,
    children: [jsxRuntime.jsxs(Section, {
      children: [jsxRuntime.jsx(OrderTitle$1, {
        title: item === null || item === void 0 ? void 0 : item.title,
        subtitle: item === null || item === void 0 ? void 0 : item.subtitle,
        theme: theme
      }), ((_a = item === null || item === void 0 ? void 0 : item.cta) === null || _a === void 0 ? void 0 : _a.id) === 'ARROW_CTA' && jsxRuntime.jsx(OrderCTA, {
        cta: item === null || item === void 0 ? void 0 : item.cta,
        onClick: onClick
      })]
    }), jsxRuntime.jsxs(Section, {
      margin: "8px 0px 0px",
      children: [jsxRuntime.jsx(OrderSubText, {
        subText1: item === null || item === void 0 ? void 0 : item.subText1,
        subText2: item === null || item === void 0 ? void 0 : item.subText2,
        theme: theme
      }), ((_b = item === null || item === void 0 ? void 0 : item.cta) === null || _b === void 0 ? void 0 : _b.id) === 'BUTTON_CTA' && jsxRuntime.jsx(OrderCTA, {
        cta: item === null || item === void 0 ? void 0 : item.cta,
        onClick: onClick
      })]
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: item === null || item === void 0 ? void 0 : item.bottomText,
      color: theme.colors.mediumEmphasis,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      margin: "16px 0px 0px"
    })]
  });
};

const SeparatorComp = ({
  text
}) => {
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(SeparatorContainer, {
    children: [jsxRuntime.jsx(Line, {}), jsxRuntime.jsx(designSystem.FormattedText, {
      text: text,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.disabled,
      margin: '0px 10px'
    }), jsxRuntime.jsx(Line, {})]
  });
};

const OrderStatusMweb = ({
  componentData,
  margin,
  onClick
}) => {
  var _a;
  const {
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  return jsxRuntime.jsxs(Wrapper$1, {
    id: componentData === null || componentData === void 0 ? void 0 : componentData.nodeId,
    margin: margin,
    children: [jsxRuntime.jsx(OrderStatusMwebWrapper, {
      children: (_a = data === null || data === void 0 ? void 0 : data.orders) === null || _a === void 0 ? void 0 : _a.map((item, index) => jsxRuntime.jsx(OrderItem, {
        item: item,
        onClick: onClick
      }, index.toString()))
    }), (data === null || data === void 0 ? void 0 : data.seperator) && jsxRuntime.jsx(SeparatorComp, {
      text: data.seperator
    })]
  });
};

const OffersCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__OffersCont",
  componentId: "sc-1n0cq11-0"
})(["padding:30px 40px;border-radius:", ";margin:", ";@media ", "{padding:0;}@media ", "{background-color:", ";.slick-slider{margin:0 -40px 0 0;}.slick-list{padding:6px;margin:0 0 0 -6px;overflow:hidden !important;}.slick-initialized .slick-slide > div{margin:0 20px 0 0;height:100%;}}.slick-dots{display:flex !important;width:auto;bottom:unset;top:0;right:0;}.slick-dots li{width:4px;height:4px;margin:0 0 0 3px;}.slick-dots li button{width:4px;height:4px;outline:none;border:0;background-color:#848484;border-radius:50%;padding:0;&::before{display:none;}}.slick-dots li.slick-active button{background-color:", ";}.slick-track{display:flex !important;margin-left:0 !important;}.slick-slide{height:inherit !important;}"], ({
  theme
}) => theme.borderRadius.br16, ({
  margin
}) => margin, commonUi.deviceType.mobile, commonUi.deviceType.desktop, ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.colors.highEmphasis);
const OfferHeadingWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__OfferHeadingWrapper",
  componentId: "sc-1n0cq11-1"
})(["display:flex;justify-content:space-between;align-items:center;margin:0 0 18px 0;@media ", "{margin:0 0 16px 0;}"], commonUi.deviceType.mobile);
const SliderSwapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__SliderSwapper",
  componentId: "sc-1n0cq11-2"
})(["@media ", "{background-color:", ";border-radius:", ";padding:12px;}"], commonUi.deviceType.mobile, ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br16);
const TopLine = /*#__PURE__*/styled__default.default.span.withConfig({
  displayName: "Offersstyles__TopLine",
  componentId: "sc-1n0cq11-3"
})(["display:block;width:33px;height:1px;background-color:", ";margin:16px 0 0 0;"], ({
  theme
}) => theme.colors.danger);
const OfferCardItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__OfferCardItem",
  componentId: "sc-1n0cq11-4"
})(["height:100%;cursor:pointer;@media ", "{background-color:", ";padding:8px 16px 16px 8px;border-radius:", ";box-shadow:0px 0 6px rgba(0,0,0,0.1);display:flex !important;flex-direction:column;justify-content:space-between;}"], commonUi.deviceType.desktop, ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br16);
const CardItemWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__CardItemWrapper",
  componentId: "sc-1n0cq11-5"
})(["display:flex;"]);
const OfferCardItemLft = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__OfferCardItemLft",
  componentId: "sc-1n0cq11-6"
})(["flex-shrink:0;margin-right:16px;@media ", "{width:40px;margin-right:8px;> img{width:40px;}}"], commonUi.deviceType.mobile);
const OfferCardItemRht = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__OfferCardItemRht",
  componentId: "sc-1n0cq11-7"
})(["flex:1;"]);
const BottomSection = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__BottomSection",
  componentId: "sc-1n0cq11-9"
})(["display:flex;justify-content:space-between;align-items:center;margin:16px 0 0 0;@media ", "{margin:0;}"], commonUi.deviceType.mobile);
const BottomText$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "Offersstyles__BottomText",
  componentId: "sc-1n0cq11-10"
})(["width:140px;"]);

const Offers = ({
  componentData,
  margin,
  bottomSheets,
  onCtaClick
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const device = commonUi.useDevice();
  const theme = React.useContext(styled.ThemeContext);
  // Load slick CSS dynamically to avoid DOM access issues in federated modules
  React.useEffect(() => {
    const cleanup = loadSlickCSS();
    return cleanup;
  }, []);
  const sliderRef = React.useRef(null);
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [showCouponDetailBottomSheet, setShowCouponDetailBottomSheet] = React.useState(false);
  const [offerBottomsheetId, setOfferBottomsheetId] = React.useState('');
  const {
    nodeId,
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const settings = {
    arrows: false,
    dots: device === commonUi.DEVICE.MOBILE ? true : false,
    infinite: device === commonUi.DEVICE.MOBILE ? true : false,
    speed: 500,
    slidesToShow: device === commonUi.DEVICE.MOBILE ? 1 : 2.5,
    slidesToScroll: device === commonUi.DEVICE.MOBILE ? 1 : 2.5,
    touchMove: false,
    afterChange: current => setCurrentSlide(current)
  };
  const isFirstSlide = currentSlide === 0;
  const isLastSlide = currentSlide >= ((_b = (_a = data === null || data === void 0 ? void 0 : data.items) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) - settings.slidesToShow;
  const handleClick = cta => {
    var _a;
    if (onCtaClick && cta) {
      onCtaClick(cta);
    }
    pdtUtils.trackEvent({
      eventData: (_a = cta === null || cta === void 0 ? void 0 : cta.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
    if (cta.modalId) {
      setOfferBottomsheetId(cta.modalId);
      setShowCouponDetailBottomSheet(true);
    } else {
      setOfferBottomsheetId('');
      setShowCouponDetailBottomSheet(false);
    }
  };
  return jsxRuntime.jsxs(OffersCont, {
    id: nodeId,
    margin: margin,
    children: [jsxRuntime.jsxs(OfferHeadingWrapper, {
      children: [jsxRuntime.jsx(designSystem.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.title,
        typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.xLarge : designTokens.TYPOGRAPHY_KEYS.mediumW3,
        color: theme.colors.highEmphasis
      }), ((_d = (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 2 && device === commonUi.DEVICE.DESKTOP && jsxRuntime.jsx(designSystem.SlickArrow, {
        sliderRef: sliderRef,
        isFirstSlide: isFirstSlide,
        isLastSlide: isLastSlide
      })]
    }), jsxRuntime.jsxs(SliderSwapper, {
      children: [((_f = (_e = data === null || data === void 0 ? void 0 : data.items) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0 && jsxRuntime.jsx(Slider, Object.assign({}, settings, {
        ref: sliderRef,
        children: (_g = data === null || data === void 0 ? void 0 : data.items) === null || _g === void 0 ? void 0 : _g.map((item, index) => {
          var _a;
          return jsxRuntime.jsxs(OfferCardItem, {
            onClick: () => {
              var _a, _b;
              if ((_a = item === null || item === void 0 ? void 0 : item.cta) === null || _a === void 0 ? void 0 : _a.deeplink) redirectTo((_b = item === null || item === void 0 ? void 0 : item.cta) === null || _b === void 0 ? void 0 : _b.deeplink);
              handleClick === null || handleClick === void 0 ? void 0 : handleClick(item === null || item === void 0 ? void 0 : item.cta);
            },
            children: [jsxRuntime.jsxs(CardItemWrapper, {
              children: [(item === null || item === void 0 ? void 0 : item.icon) && jsxRuntime.jsx(OfferCardItemLft, {
                children: jsxRuntime.jsx(designSystem.Image, {
                  src: (_a = item === null || item === void 0 ? void 0 : item.icon) === null || _a === void 0 ? void 0 : _a.url,
                  height: "80px",
                  width: "80px",
                  alt: "icon"
                })
              }), jsxRuntime.jsxs(OfferCardItemRht, {
                children: [jsxRuntime.jsx(designSystem.FormattedText, {
                  text: item === null || item === void 0 ? void 0 : item.title,
                  color: device === commonUi.DEVICE.DESKTOP ? theme.colors.disabledBg : theme.colors.highEmphasis,
                  typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.baseW2 : designTokens.TYPOGRAPHY_KEYS.baseW3,
                  margin: "0"
                }), jsxRuntime.jsx(designSystem.FormattedText, {
                  text: item === null || item === void 0 ? void 0 : item.subtitle,
                  typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.largeW3 : designTokens.TYPOGRAPHY_KEYS.baseW1,
                  color: device === commonUi.DEVICE.DESKTOP ? theme.colors.highEmphasis : theme.colors.mediumEmphasis,
                  margin: "2px 0 0 0"
                }), device === commonUi.DEVICE.DESKTOP && jsxRuntime.jsx(TopLine, {}), jsxRuntime.jsx(designSystem.FormattedText, {
                  text: item === null || item === void 0 ? void 0 : item.description,
                  color: theme.colors.mediumEmphasis,
                  margin: "5px 0 0 0",
                  typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.smallW1 : designTokens.TYPOGRAPHY_KEYS.baseW1
                })]
              })]
            }), jsxRuntime.jsxs(BottomSection, {
              children: [device === commonUi.DEVICE.DESKTOP && jsxRuntime.jsx(BottomText$1, {}), (item === null || item === void 0 ? void 0 : item.info) ? jsxRuntime.jsx(designSystem.FormattedText, {
                text: item === null || item === void 0 ? void 0 : item.info,
                color: device === commonUi.DEVICE.DESKTOP ? theme.colors.disabledBg : theme.colors.highEmphasis,
                typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.baseW2 : designTokens.TYPOGRAPHY_KEYS.baseW3,
                margin: device !== commonUi.DEVICE.DESKTOP ? '5px 0 0 48px' : undefined
              }) : jsxRuntime.jsx(jsxRuntime.Fragment, {})]
            })]
          }, index);
        })
      })), (bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets[offerBottomsheetId]) && showCouponDetailBottomSheet && jsxRuntime.jsx(CouponDetailsBottomSheet, {
        data: bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets[offerBottomsheetId],
        onModalClose: () => setShowCouponDetailBottomSheet(false)
      })]
    })]
  });
};

const searcIconAnimation = /*#__PURE__*/styled.keyframes(["from{opacity:1;}to{opacity:0;}"]);
const deliveryPersIconAnimation = /*#__PURE__*/styled.keyframes(["0%{right:-24px;opacity:0;}20%{right:-24px;opacity:1;}70%{right:-24px;opacity:1;}100%{right:0;opacity:1;}"]);
const deliveryPersDescAnimation = /*#__PURE__*/styled.keyframes(["from{opacity:0;}to{opacity:1;}"]);
const DeliveryPersCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersCont",
  componentId: "sc-1qa72hu-0"
})(["display:flex;align-items:center;margin:", ";position:relative;z-index:1;"], ({
  margin
}) => margin || '0');
const DeliveryPersDesc = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersDesc",
  componentId: "sc-1qa72hu-1"
})(["flex:1;opacity:0;animation:", " 1s ease-in-out forwards;animation-delay:5.5s;@media ", "{display:flex;column-gap:6px;animation-delay:0s;}"], deliveryPersDescAnimation, commonUi.deviceType.desktop);
const DeliveryPersSearchIconWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersSearchIconWrapper",
  componentId: "sc-1qa72hu-2"
})(["display:flex;animation:", " 0.3s ease-in-out forwards;animation-delay:5s;position:absolute;height:36px;width:36px;align-items:center;justify-content:center;border-radius:100%;background-color:", ";"], searcIconAnimation, ({
  theme
}) => theme.colors.white);
const DeliveryPersIcon = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersIcon",
  componentId: "sc-1qa72hu-3"
})(["display:flex;align-items:center;position:relative;right:-24px;opacity:0;animation:", " 1s ease-in-out forwards;animation-delay:5s;transform:scaleX(-1);"], deliveryPersIconAnimation);
const DeliveryPersTitle = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersTitle",
  componentId: "sc-1qa72hu-4"
})(["display:flex;align-items:center;"]);
const DeliveryPersSubTitleWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersSubTitleWrapper",
  componentId: "sc-1qa72hu-5"
})(["position:relative;z-index:100;display:flex;gap:4px;"]);
const DeliveryPersSubTitle = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersSubTitle",
  componentId: "sc-1qa72hu-6"
})(["display:flex;align-items:center;"]);
const InfoIconWrap = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__InfoIconWrap",
  componentId: "sc-1qa72hu-7"
})(["position:relative;width:16px;height:16px;"]);
const TooltipContainer$2 = /*#__PURE__*/styled__default.default(designSystem.ToolTip).withConfig({
  displayName: "DeliveryPersuasionstyles__TooltipContainer",
  componentId: "sc-1qa72hu-8"
})(["left:-22px;top:22px;display:flex;gap:16px;z-index:100;"]);
const CloseIcon$1 = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "DeliveryPersuasionstyles__CloseIcon",
  componentId: "sc-1qa72hu-9"
})(["align-self:center;cursor:pointer;"]);
const DeliveryPersuasionWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersuasionWrapper",
  componentId: "sc-1qa72hu-10"
})(["display:flex;flex-direction:column;gap:6px;"]);
const DeliveryPersuasionMessage = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__DeliveryPersuasionMessage",
  componentId: "sc-1qa72hu-11"
})(["padding:2px 4px;border-radius:4px;background:linear-gradient( 90deg,#e0f0ff 33.5%,rgba(255,255,255,0) 100% );"]);
const TooltipWrapper$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliveryPersuasionstyles__TooltipWrapper",
  componentId: "sc-1qa72hu-12"
})([""]);

const DeliveryPersuasion = ({
  componentData,
  margin,
  bottomSheets
}) => {
  var _a, _b, _c, _d, _e;
  const theme = React.useContext(styled.ThemeContext);
  const {
    nodeId,
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [showBottomsheet, setShowBottomsheet] = React.useState(false);
  const device = commonUi.useDevice();
  const tooltipRef = React.useRef(null);
  const infoIconRef = React.useRef(null);
  commonUi.useOutsideClick(tooltipRef, () => {
    if (showTooltip) {
      setShowTooltip(false);
    }
  }, showTooltip);
  const handleTooltip = () => {
    var _a, _b;
    setShowTooltip(!showTooltip);
    pdtUtils.trackEvent({
      eventData: (_b = (_a = data === null || data === void 0 ? void 0 : data.toolTip) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(DeliveryPersuasionWrapper, {
      children: [jsxRuntime.jsxs(DeliveryPersCont, {
        id: nodeId,
        margin: margin,
        children: [device === commonUi.DEVICE.MOBILE && jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [jsxRuntime.jsx(DeliveryPersSearchIconWrapper, {
            children: jsxRuntime.jsx(designSystem.Image, {
              src: 'https://tripmoneycmsimgak.mmtcdn.com/img/Search_849af3a598.gif',
              alt: 'search',
              width: "36px"
            })
          }), jsxRuntime.jsx(DeliveryPersIcon, {
            src: (_a = data === null || data === void 0 ? void 0 : data.icon) === null || _a === void 0 ? void 0 : _a.url,
            alt: (_b = data === null || data === void 0 ? void 0 : data.icon) === null || _b === void 0 ? void 0 : _b.type,
            width: "32px",
            height: "32px"
          })]
        }), jsxRuntime.jsxs(DeliveryPersDesc, {
          children: [jsxRuntime.jsx(DeliveryPersTitle, {
            text: data === null || data === void 0 ? void 0 : data.title,
            color: theme.colors.highEmphasis,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
            onClick: () => {
              setShowBottomsheet(true);
            },
            numberOfLines: 1
          }), jsxRuntime.jsxs(DeliveryPersSubTitleWrapper, {
            children: [jsxRuntime.jsx(DeliveryPersSubTitle, {
              text: data === null || data === void 0 ? void 0 : data.subtitle,
              color: theme.colors.mediumEmphasis,
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1
            }), jsxRuntime.jsxs(InfoIconWrap, {
              ref: infoIconRef,
              children: [jsxRuntime.jsx(designSystem.Image, {
                src: (_d = (_c = data === null || data === void 0 ? void 0 : data.toolTip) === null || _c === void 0 ? void 0 : _c.icon) === null || _d === void 0 ? void 0 : _d.url,
                height: "16px",
                width: "16px",
                onClick: handleTooltip,
                showCursorPointer: true
              }), showTooltip && jsxRuntime.jsx(TooltipWrapper$1, {
                ref: tooltipRef,
                children: jsxRuntime.jsxs(TooltipContainer$2, {
                  width: "320px",
                  arrowDirection: "up",
                  arrowPosition: device === commonUi.DEVICE.MOBILE ? '140px' : '30px',
                  children: [jsxRuntime.jsx(designSystem.FormattedText, {
                    text: (_e = data === null || data === void 0 ? void 0 : data.toolTip) === null || _e === void 0 ? void 0 : _e.text,
                    typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
                    color: theme.colors.white
                  }), jsxRuntime.jsx(CloseIcon$1, {
                    src: `https://tripmoneycmsimgak.mmtcdn.com/img/Close_ef36e1a467.png`,
                    width: "24px",
                    height: "24px",
                    onClick: () => setShowTooltip(false)
                  })]
                })
              })]
            })]
          })]
        })]
      }), !!(data === null || data === void 0 ? void 0 : data.bottomText) && jsxRuntime.jsx(DeliveryPersuasionMessage, {
        children: jsxRuntime.jsx(designSystem.FormattedText, {
          text: data === null || data === void 0 ? void 0 : data.bottomText,
          typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
          color: theme.colors.highEmphasis
        })
      })]
    }), (bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.PINCODE_BOTTOMSHEET) && showBottomsheet && device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(PincodeBottomSheet, {
      onModalClose: () => setShowBottomsheet(false),
      isLoading: false,
      data: bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.PINCODE_BOTTOMSHEET
    })]
  });
};

const CurrencyWidgetsMwebContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyWidgetsMwebstyles__CurrencyWidgetsMwebContainer",
  componentId: "sc-1qjt9qt-0"
})(["margin:", ";padding:0 16px;background-color:", ";"], ({
  margin
}) => margin, ({
  theme
}) => theme.colors.white);

const TopBannerWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopBannerstyles__TopBannerWrapper",
  componentId: "bebe72-0"
})(["display:flex;justify-content:center;padding:0 16px;margin-bottom:-8px;"]);
const TopBannerContent = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopBannerstyles__TopBannerContent",
  componentId: "bebe72-1"
})(["background:", ";padding:8px 12px 16px;display:flex;justify-content:center;align-items:center;border-radius:", ";width:100%;"], ({
  theme
}) => theme.colors.lightBlue, ({
  theme
}) => theme.borderRadius.br8);

const TopBanner = ({
  title
}) => {
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsx(TopBannerWrapper, {
    children: jsxRuntime.jsx(TopBannerContent, {
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
        text: title,
        color: theme.colors.highEmphasis
      })
    })
  });
};

const CurrencySelection$1 = ({
  title,
  icon,
  selectedCurrency,
  adjacentText,
  onClick
}) => {
  return jsxRuntime.jsx(designSystem.Dropdown, {
    labelTxt: title,
    leftIcon: icon === null || icon === void 0 ? void 0 : icon.url,
    value: selectedCurrency,
    adjacentText: adjacentText,
    handleDropdownPress: onClick,
    rightIcon: 'https://tripmoneycmsimgak.mmtcdn.com/img/down_Arrow_7c7fbc5e08.png'
  });
};

const AmountSelection = ({
  title,
  hint,
  rightCta,
  icon,
  onClick,
  onAmountRightClick
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsx(designSystem.Dropdown, {
    labelTxt: title,
    leftIcon: icon === null || icon === void 0 ? void 0 : icon.url,
    placeholderTxt: hint,
    rightEndText: rightCta,
    rightEndTextColor: (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.primaryAccent,
    margin: "8px 0px 0px 0px",
    handleDropdownPress: onClick,
    onRightElementClick: onAmountRightClick
  });
};

// Styled component for the outer wrapper of the Bottom Banner
const BottomBannerWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BottomBannerstyles__BottomBannerWrapper",
  componentId: "sc-159gf95-0"
})(["padding:4px 12px;display:flex;background:", ";border-radius:", ";margin:8px 0px;align-items:center;justify-content:space-between;"], ({
  theme
}) => theme.colors.lightPurple, ({
  theme
}) => theme.borderRadius.br8);
const ImageTextContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BottomBannerstyles__ImageTextContainer",
  componentId: "sc-159gf95-1"
})(["display:flex;"]);

const BottomBanner = ({
  title,
  icon,
  info,
  onClickIcon,
  bottomSheets
}) => {
  var _a;
  const [showSpecialCashback, setShowSpecialCashback] = React.useState(false);
  return jsxRuntime.jsxs(BottomBannerWrapper, {
    children: [jsxRuntime.jsxs(ImageTextContainer, {
      children: [jsxRuntime.jsx(designSystem.Image, {
        src: icon === null || icon === void 0 ? void 0 : icon.url,
        width: "24px",
        height: "24px"
      }), jsxRuntime.jsx(designSystem.FormattedText, {
        text: title,
        margin: '4px 12px',
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1
      })]
    }), jsxRuntime.jsx(designSystem.Image, {
      src: (_a = info === null || info === void 0 ? void 0 : info.icon) === null || _a === void 0 ? void 0 : _a.url,
      width: "16px",
      height: "16px",
      onClick: () => {
        onClickIcon === null || onClickIcon === void 0 ? void 0 : onClickIcon(info === null || info === void 0 ? void 0 : info.cta);
        setShowSpecialCashback(true);
      }
    }), (bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.SPECIAL_CASHBACK_BOTTOMSHEET) && showSpecialCashback && jsxRuntime.jsx(SpecialCashbackBottomSheet, {
      onModalClose: () => setShowSpecialCashback(false),
      data: bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.SPECIAL_CASHBACK_BOTTOMSHEET
    })]
  });
};

const CurrencySelectionContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__CurrencySelectionContainer",
  componentId: "sc-1n7rxxs-0"
})(["margin-top:16px;display:flex;flex-direction:column;gap:8px;"]);
const SelectionCard = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__SelectionCard",
  componentId: "sc-1n7rxxs-1"
})(["display:flex;justify-content:space-between;padding:12px;border-radius:", ";background-color:", ";border:", ";pointer-events:", ";"], ({
  theme
}) => theme.borderRadius.br12, ({
  theme,
  isChecked,
  disabled
}) => disabled ? theme.colors.screenBg : isChecked ? theme.colors.lightBlue : 'transparent', ({
  theme,
  isChecked,
  disabled
}) => disabled ? 'none' : `1px solid ${isChecked ? theme.colors.blueCardBorder : theme.colors.cardBorder}`, ({
  disabled
}) => disabled ? 'none' : 'all');
const TextContainer$2 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__TextContainer",
  componentId: "sc-1n7rxxs-2"
})(["display:flex;flex-direction:column;row-gap:2px;"]);
const RadioTextContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__RadioTextContainer",
  componentId: "sc-1n7rxxs-3"
})(["display:flex;"]);
const ImageContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__ImageContainer",
  componentId: "sc-1n7rxxs-4"
})(["display:flex;flex-direction:column;align-items:flex-end;"]);

const CurrencyTypeSelection$1 = ({
  productItems,
  selectedCurrency: _selectedCurrency = '',
  selectedProduct,
  onClick
}) => {
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(CurrencySelectionContainer, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: 'SELECT ITEM',
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.lowEmphasis
    }), productItems === null || productItems === void 0 ? void 0 : productItems.map(productItem => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
      return jsxRuntime.jsxs(SelectionCard, {
        disabled: productItem === null || productItem === void 0 ? void 0 : productItem.disabled,
        onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(productItem),
        isChecked: selectedProduct === productItem.productType,
        children: [jsxRuntime.jsxs(RadioTextContainer, {
          children: [jsxRuntime.jsx(designSystem.RadioButton, {
            showLabel: false,
            isChecked: selectedProduct === productItem.productType,
            onClick: () => {
              onClick === null || onClick === void 0 ? void 0 : onClick(productItem);
            }
          }), jsxRuntime.jsxs(TextContainer$2, {
            children: [jsxRuntime.jsx(designSystem.FormattedText, {
              color: theme.colors.highEmphasis,
              typography: designTokens.TYPOGRAPHY_KEYS.smallW3,
              text: (_b = (_a = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _a === void 0 ? void 0 : _a[_selectedCurrency]) === null || _b === void 0 ? void 0 : _b.title
            }), jsxRuntime.jsx(designSystem.FormattedText, {
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
              color: theme.colors.lowEmphasis,
              text: (_d = (_c = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _c === void 0 ? void 0 : _c[_selectedCurrency]) === null || _d === void 0 ? void 0 : _d.subTitle
            }), jsxRuntime.jsx(designSystem.FormattedText, {
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
              color: theme.colors.lowEmphasis,
              text: (_f = (_e = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _e === void 0 ? void 0 : _e[_selectedCurrency]) === null || _f === void 0 ? void 0 : _f.subtext1
            }), jsxRuntime.jsx(designSystem.FormattedText, {
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
              color: theme.colors.lowEmphasis,
              text: (_h = (_g = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _g === void 0 ? void 0 : _g[_selectedCurrency]) === null || _h === void 0 ? void 0 : _h.subtext2
            }), jsxRuntime.jsx(designSystem.FormattedText, {
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
              color: theme.colors.lowEmphasis,
              text: (_k = (_j = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _j === void 0 ? void 0 : _j[_selectedCurrency]) === null || _k === void 0 ? void 0 : _k.bottomText
            })]
          })]
        }), jsxRuntime.jsxs(ImageContainer, {
          children: [jsxRuntime.jsx(designSystem.Image, {
            src: (_l = productItem === null || productItem === void 0 ? void 0 : productItem.icon) === null || _l === void 0 ? void 0 : _l.url,
            width: "32px",
            height: "32px"
          }), jsxRuntime.jsx(designSystem.FormattedText, {
            text: '**4918',
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
            color: theme.colors.highEmphasis
          })]
        })]
      });
    })]
  });
};

const currencyMockData = [{
  id: 'POPULAR',
  leftLabel: 'Popular Currency',
  rightLabel: 'Country',
  currencyList: [{
    id: '1',
    isChecked: false,
    leftLabel: 'Afghani',
    leftSubLabel: undefined,
    rightLabel: 'Afghanistan'
  }, {
    id: '2',
    isChecked: false,
    leftLabel: 'Lek',
    leftSubLabel: undefined,
    rightLabel: 'Albania'
  }, {
    id: '3',
    isChecked: false,
    leftLabel: 'Dinar',
    leftSubLabel: undefined,
    rightLabel: 'Algeria'
  }, {
    id: '4',
    isChecked: false,
    leftLabel: 'Euro',
    leftSubLabel: undefined,
    rightLabel: 'Andorra'
  }]
}, {
  id: 'OTHER',
  leftLabel: 'Other Currencies',
  rightLabel: 'Country',
  currencyList: [{
    id: '1',
    isChecked: false,
    leftLabel: 'Afghanistan',
    leftSubLabel: undefined,
    rightLabel: 'Afghani'
  }, {
    id: '2',
    isChecked: false,
    leftLabel: 'Albania',
    leftSubLabel: undefined,
    rightLabel: 'Lek'
  }, {
    id: '3',
    isChecked: false,
    leftLabel: 'Algeria',
    leftSubLabel: undefined,
    rightLabel: 'Dinar'
  }, {
    id: '4',
    isChecked: false,
    leftLabel: 'Andorra',
    leftSubLabel: undefined,
    rightLabel: 'Euro'
  }, {
    id: '5',
    isChecked: false,
    leftLabel: 'New Zealand',
    leftSubLabel: undefined,
    rightLabel: 'NZD'
  }, {
    id: '6',
    isChecked: false,
    leftLabel: 'Azerbaijan',
    leftSubLabel: undefined,
    rightLabel: 'AZN'
  }]
}];

const CurrencyWidgetsMweb = ({
  componentData,
  bottomSheets,
  margin
}) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    topBanner,
    bottomBanner,
    amountSelection,
    currencySelection,
    cta
  } = (_a = componentData === null || componentData === void 0 ? void 0 : componentData.data) !== null && _a !== void 0 ? _a : {};
  const defaultCurrency = (_c = (_b = currencySelection === null || currencySelection === void 0 ? void 0 : currencySelection.defaultCurrency) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : '';
  const [selectedCurrency, setSelectedCurrency] = React.useState(defaultCurrency);
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [showBottomSheet, setShowBottomSheet] = React.useState(false);
  const [showCurrencySelectionModal, setShowCurrencySelectionModal] = React.useState(false);
  const handleProductSelect = productItem => {
    var _a;
    setSelectedProduct((_a = productItem === null || productItem === void 0 ? void 0 : productItem.productType) !== null && _a !== void 0 ? _a : null);
  };
  const filteredProductItems = (_e = (_d = componentData === null || componentData === void 0 ? void 0 : componentData.data) === null || _d === void 0 ? void 0 : _d.productItems) === null || _e === void 0 ? void 0 : _e.reduce((acc, item) => {
    var _a;
    const currencyDetail = (_a = item === null || item === void 0 ? void 0 : item.currency) === null || _a === void 0 ? void 0 : _a[defaultCurrency];
    if (currencyDetail) {
      acc.push(Object.assign(Object.assign({}, item), {
        currency: {
          [defaultCurrency]: currencyDetail
        }
      }));
    }
    return acc;
  }, []);
  const onModalClose = () => {
    setShowBottomSheet(false);
  };
  return jsxRuntime.jsxs(CurrencyWidgetsMwebContainer, {
    margin: margin,
    children: [jsxRuntime.jsx(TopBanner, {
      title: topBanner === null || topBanner === void 0 ? void 0 : topBanner.title
    }), jsxRuntime.jsx(CurrencySelection$1, {
      selectedCurrency: selectedCurrency,
      icon: currencySelection === null || currencySelection === void 0 ? void 0 : currencySelection.icon,
      title: currencySelection === null || currencySelection === void 0 ? void 0 : currencySelection.title,
      adjacentText: (_f = currencySelection === null || currencySelection === void 0 ? void 0 : currencySelection.defaultCurrency) === null || _f === void 0 ? void 0 : _f.code,
      onClick: () => {
        setShowCurrencySelectionModal(true);
      }
    }), jsxRuntime.jsx(AmountSelection, {
      title: amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.title,
      hint: amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.hint,
      rightCta: amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.rightCta,
      icon: amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.icon,
      onClick: () => setShowBottomSheet(true),
      onAmountRightClick: () => void 0
    }), jsxRuntime.jsx(BottomBanner, {
      title: bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.title,
      icon: bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.icon,
      info: bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.info,
      bottomSheets: bottomSheets,
      onClickIcon: () => void 0
    }), jsxRuntime.jsx(CurrencyTypeSelection$1, {
      productItems: filteredProductItems,
      selectedCurrency: selectedCurrency,
      selectedProduct: selectedProduct,
      onClick: handleProductSelect
    }), jsxRuntime.jsx(designSystem.Button, {
      onClick: () => void 0,
      label: cta === null || cta === void 0 ? void 0 : cta.title,
      margin: "16px 0px"
    }), (bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.AMOUNT_CALCULATOR_BOTTOMSHEET) && showBottomSheet && jsxRuntime.jsx(AmountBottomSheet, {
      onModalClose: onModalClose,
      data: bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.AMOUNT_CALCULATOR_BOTTOMSHEET
    }), (bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets.CURRENCY_SEARCH_BOTTOMSHEET) && showCurrencySelectionModal && jsxRuntime.jsx(SelectCurrencyModal, {
      data: bottomSheets.CURRENCY_SEARCH_BOTTOMSHEET,
      onModalClose: () => {
        setShowCurrencySelectionModal(false);
      },
      currencyData: currencyMockData
    })]
  });
};

const BestLiveContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BestLiveRatesstyles__BestLiveContainer",
  componentId: "fqbi55-0"
})(["", ";"], ({
  margin
}) => `margin: ${margin}`);
const Heading = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BestLiveRatesstyles__Heading",
  componentId: "fqbi55-1"
})(["display:flex;align-items:center;gap:5px;position:relative;"]);
const InfoIconWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BestLiveRatesstyles__InfoIconWrapper",
  componentId: "fqbi55-3"
})(["position:relative;display:flex;"]);
const CurrencyCard = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BestLiveRatesstyles__CurrencyCard",
  componentId: "fqbi55-4"
})(["display:flex;padding:8px;overflow-x:auto;margin-top:8px;background-color:", ";border-radius:", ";"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br12);
const CurrencyDetail = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BestLiveRatesstyles__CurrencyDetail",
  componentId: "fqbi55-5"
})(["display:flex;flex-shrink:0;"]);
const CurrencyDetailCard = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BestLiveRatesstyles__CurrencyDetailCard",
  componentId: "fqbi55-6"
})(["display:flex;flex-direction:column;width:100%;"]);
const VerticalDivider = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "BestLiveRatesstyles__VerticalDivider",
  componentId: "fqbi55-7"
})(["width:0px;height:22px;border-left:", ";margin:6px 12px;border-radius:", ";", ":last-child &{display:none;}"], ({
  theme
}) => `1px solid ${theme.colors.verticalDividerLightBlue}`, ({
  theme
}) => theme.borderRadius.br4, CurrencyDetail);
const TooltipContainer$1 = /*#__PURE__*/styled__default.default(designSystem.ToolTip).withConfig({
  displayName: "BestLiveRatesstyles__TooltipContainer",
  componentId: "fqbi55-8"
})(["left:0;top:22px;display:flex;gap:16px;z-index:1;"]);
const CloseIcon = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "BestLiveRatesstyles__CloseIcon",
  componentId: "fqbi55-9"
})(["align-self:center;cursor:pointer;"]);

const BestLiveRates = ({
  componentData,
  margin
}) => {
  var _a, _b;
  const infoIconRef = React.useRef(null);
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [infoIconPositon, setInfoIconPositon] = React.useState(0);
  const theme = React.useContext(styled.ThemeContext);
  const {
    title,
    toolTip,
    currencies
  } = (_a = componentData === null || componentData === void 0 ? void 0 : componentData.data) !== null && _a !== void 0 ? _a : {};
  const handleTooltip = () => {
    var _a;
    const pos = (_a = infoIconRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    if (pos) setInfoIconPositon(pos.x);
    setShowTooltip(!showTooltip);
  };
  return jsxRuntime.jsxs(BestLiveContainer, {
    margin: margin,
    children: [jsxRuntime.jsxs(Heading, {
      children: [jsxRuntime.jsx(designSystem.FormattedText, {
        text: title,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
        color: theme.colors.mediumEmphasis
      }), jsxRuntime.jsx(InfoIconWrapper, {
        ref: infoIconRef,
        onClick: handleTooltip,
        children: jsxRuntime.jsx(designSystem.Image, {
          height: "16px",
          width: "16px",
          src: (_b = toolTip === null || toolTip === void 0 ? void 0 : toolTip.icon) === null || _b === void 0 ? void 0 : _b.url
        })
      }), showTooltip && jsxRuntime.jsxs(TooltipContainer$1, {
        width: "230px",
        arrowDirection: "up",
        arrowPosition: `${infoIconPositon - 9}px`,
        children: [jsxRuntime.jsx(designSystem.FormattedText, {
          text: toolTip === null || toolTip === void 0 ? void 0 : toolTip.text,
          typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
          color: theme.colors.white
        }), jsxRuntime.jsx(CloseIcon, {
          src: `https://tripmoneycmsimgak.mmtcdn.com/img/Close_ef36e1a467.png`,
          width: "24px",
          height: "24px",
          onClick: () => setShowTooltip(false)
        })]
      })]
    }), jsxRuntime.jsx(CurrencyCard, {
      children: currencies === null || currencies === void 0 ? void 0 : currencies.map(currencyItem => jsxRuntime.jsxs(CurrencyDetail, {
        children: [jsxRuntime.jsxs(CurrencyDetailCard, {
          children: [jsxRuntime.jsx(designSystem.FormattedText, {
            text: currencyItem === null || currencyItem === void 0 ? void 0 : currencyItem.price,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
            color: theme.colors.highEmphasis
          }), jsxRuntime.jsx(designSystem.FormattedText, {
            text: currencyItem === null || currencyItem === void 0 ? void 0 : currencyItem.name,
            typography: designTokens.TYPOGRAPHY_KEYS.smallW3,
            color: theme.colors.highEmphasis,
            margin: "4px 0px 0px"
          })]
        }), jsxRuntime.jsx(VerticalDivider, {})]
      }, currencyItem === null || currencyItem === void 0 ? void 0 : currencyItem.name))
    })]
  });
};

const HeaderWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "HeaderMwebstyles__HeaderWrapper",
  componentId: "sc-4taawx-0"
})(["width:100%;position:fixed;left:0;top:0;display:flex;flex-direction:row;align-items:center;flex:1;padding:12px 16px;gap:16px;z-index:10;", ";"], ({
  sticky
}) => sticky && `
    background-color: white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  `);
const HeaderTitle = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "HeaderMwebstyles__HeaderTitle",
  componentId: "sc-4taawx-1"
})(["flex:1;"]);
const RightSection = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "HeaderMwebstyles__RightSection",
  componentId: "sc-4taawx-2"
})(["display:flex;flex-direction:row-reverse;justify-content:space-between;align-self:flex-end;margin-left:auto;gap:12px;align-items:center;"]);
const NavIcon = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "HeaderMwebstyles__NavIcon",
  componentId: "sc-4taawx-3"
})(["display:flex;align-items:center;justify-content:center;&.elevation{pointer-events:none;position:relative;z-index:101;::before{width:48px;height:48px;border-radius:50%;background-color:#fff;content:'';position:absolute;z-index:-1;}}"]);

const DashboardCoachmark = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DashboardDiscoverystyles__DashboardCoachmark",
  componentId: "sc-1q9tqc6-0"
})(["width:260px;background-color:#fff;padding:24px 24px 40px 24px;border-radius:16px;position:fixed;right:24px;top:24px;text-align:center;z-index:12;"]);
const DashboardCoachmarkOverlay = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DashboardDiscoverystyles__DashboardCoachmarkOverlay",
  componentId: "sc-1q9tqc6-1"
})(["width:100%;height:100%;position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.7);z-index:11;"]);
const DashboardCoachmarkImgCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DashboardDiscoverystyles__DashboardCoachmarkImgCont",
  componentId: "sc-1q9tqc6-2"
})(["width:170px;height:160px;margin:0 auto;margin-bottom:24px;video{width:100%;height:100%;object-fit:cover;}"]);
const DashboardCoachmarkBtn = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "DashboardDiscoverystyles__DashboardCoachmarkBtn",
  componentId: "sc-1q9tqc6-3"
})(["display:inline-flex;width:auto;height:32px;font-size:12px;margin-top:54px;span{font-size:12px;}"]);
const CoachmarkImage = /*#__PURE__*/styled__default.default.img.withConfig({
  displayName: "DashboardDiscoverystyles__CoachmarkImage",
  componentId: "sc-1q9tqc6-4"
})(["width:78px;height:104px;position:absolute;left:-90px;top:40%;@media ", "{left:120px;top:-110px;}"], commonUi.deviceType.mobile);
const CoachmarkCircleMweb = /*#__PURE__*/styled__default.default.img.withConfig({
  displayName: "DashboardDiscoverystyles__CoachmarkCircleMweb",
  componentId: "sc-1q9tqc6-5"
})(["width:48px;height:48px;position:fixed;top:-156px;left:200px;"]);

const DashboardDiscovery = ({
  componentData,
  buttonPositionDT,
  buttonPositionMweb,
  onClose
}) => {
  var _a, _b, _c, _d;
  const device = commonUi.useDevice();
  const {
    templateId,
    nodeId,
    analytics,
    data
  } = componentData !== null && componentData !== void 0 ? componentData : {};
  const theme = React.useContext(styled.ThemeContext);
  const styleDT = {
    top: ((_a = buttonPositionDT === null || buttonPositionDT === void 0 ? void 0 : buttonPositionDT.top) !== null && _a !== void 0 ? _a : 0) - 300,
    left: ((_b = buttonPositionDT === null || buttonPositionDT === void 0 ? void 0 : buttonPositionDT.left) !== null && _b !== void 0 ? _b : 0) + 480
  };
  const styleMweb = {
    top: ((_c = buttonPositionMweb === null || buttonPositionMweb === void 0 ? void 0 : buttonPositionMweb.top) !== null && _c !== void 0 ? _c : 0) + 150,
    left: '50%',
    transform: 'translateX(-50%)'
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(DashboardCoachmark, {
      style: buttonPositionDT ? styleDT : styleMweb,
      children: [device === commonUi.DEVICE.MOBILE && jsxRuntime.jsx(CoachmarkCircleMweb, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_1244831913_acf0826f3a.png",
        alt: ""
      }), jsxRuntime.jsx(CoachmarkImage, {
        src: 'https://tripmoneycmsimgak.mmtcdn.com/img/Vector_3271_744548b857.png',
        alt: ""
      }), jsxRuntime.jsx(DashboardCoachmarkImgCont, {
        children: jsxRuntime.jsx("video", {
          src: 'https://tripmoneycmsimgak.mmtcdn.com/img/card_discovery_video_1_27e803316a.mp4',
          width: '170px',
          height: '160px',
          autoPlay: true,
          muted: true,
          playsInline: true
        })
      }), jsxRuntime.jsx(designSystem.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.title,
        typography: designTokens.TYPOGRAPHY_KEYS.medium,
        color: theme.colors.highEmphasis
      }), jsxRuntime.jsx(designSystem.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.subtitle,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.mediumEmphasis,
        margin: "10px 0 0 0"
      }), jsxRuntime.jsx(DashboardCoachmarkBtn, {
        onClick: onClose,
        label: (_d = data === null || data === void 0 ? void 0 : data.cta) === null || _d === void 0 ? void 0 : _d.text
      })]
    }), jsxRuntime.jsx(DashboardCoachmarkOverlay, {})]
  });
};

const mockDataMweb = {
  dashboardDiscovery: {
    templateId: 'DASHBOARD_DISCOVERY',
    nodeId: 'dashboard-discovery',
    analytics: {},
    data: {
      img: {
        url: 'https://go-assets.ibcdn.com/u/MMT/images/1731047038134-forex_multicurrency.webp',
        type: 'image'
      },
      title: 'Manage Your \nMulti Currency Card',
      subtitle: 'Quickly Load Currencies, View card transactions, Lock/ Unlock Card, & more',
      cta: {
        id: 'DASHBOARD_DISCOVERY_BUTTON',
        type: 'handler',
        text: 'OK, GOT IT Now'
      }
    }
  }};

const HeaderMweb = ({
  data,
  onBackClick,
  onRightClick
}) => {
  var _a;
  const theme = React.useContext(styled.ThemeContext);
  const [sticky, setSticky] = React.useState(false);
  const buttonRef = React.useRef(null);
  const device = commonUi.useDevice();
  const [buttonPosition, setButtonPosition] = React.useState({
    top: 0,
    left: 0
  });
  const [showCoachmark, setShowCoachmark] = React.useState(true);
  React.useEffect(() => {
    const handleScroll = () => {
      if (typeof window === 'undefined') return;
      if (window.scrollY > 10) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  React.useEffect(() => {
    if (buttonRef.current) {
      const {
        top,
        left
      } = buttonRef.current.getBoundingClientRect();
      setButtonPosition({
        top,
        left
      });
    }
  }, [buttonRef.current]);
  React.useEffect(() => {
    if (device === commonUi.DEVICE.MOBILE && showCoachmark) {
      document.body.style.overflow = 'hidden';
    }
  }, [device]);
  const closeCoachmark = () => {
    setShowCoachmark(false);
    document.body.removeAttribute('style');
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(HeaderWrapper, {
      id: data === null || data === void 0 ? void 0 : data.nodeId,
      sticky: sticky,
      children: [jsxRuntime.jsx(designSystem.Image, {
        src: backArrow,
        alt: "back arrow",
        width: "24px",
        height: "24px",
        onClick: onBackClick
      }), jsxRuntime.jsx(HeaderTitle, {
        text: data === null || data === void 0 ? void 0 : data.title,
        typography: designTokens.TYPOGRAPHY_KEYS.mediumW2,
        color: theme.colors.mediumEmphasis,
        numberOfLines: 1
      }), jsxRuntime.jsx(RightSection, {
        children: (_a = data === null || data === void 0 ? void 0 : data.navActions) === null || _a === void 0 ? void 0 : _a.map(navAction => {
          var _a, _b, _c, _d, _e;
          if (navAction === null || navAction === void 0 ? void 0 : navAction.icon) {
            return jsxRuntime.jsx(NavIcon, {
              ref: buttonRef,
              children: jsxRuntime.jsx(designSystem.Image, {
                id: (_a = navAction === null || navAction === void 0 ? void 0 : navAction.cta) === null || _a === void 0 ? void 0 : _a.nodeId,
                src: (_b = navAction === null || navAction === void 0 ? void 0 : navAction.icon) === null || _b === void 0 ? void 0 : _b.url,
                onClick: () => onRightClick === null || onRightClick === void 0 ? void 0 : onRightClick(navAction === null || navAction === void 0 ? void 0 : navAction.cta),
                height: "32px",
                width: "32px"
              }, (_c = navAction === null || navAction === void 0 ? void 0 : navAction.cta) === null || _c === void 0 ? void 0 : _c.nodeId)
            }, (_d = navAction === null || navAction === void 0 ? void 0 : navAction.cta) === null || _d === void 0 ? void 0 : _d.nodeId);
          } else if (navAction === null || navAction === void 0 ? void 0 : navAction.text) {
            return jsxRuntime.jsx(designSystem.FormattedText, {
              text: navAction === null || navAction === void 0 ? void 0 : navAction.text,
              typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
              color: theme.colors.primaryAccent,
              onClick: () => onRightClick === null || onRightClick === void 0 ? void 0 : onRightClick(navAction === null || navAction === void 0 ? void 0 : navAction.cta)
            }, (_e = navAction === null || navAction === void 0 ? void 0 : navAction.cta) === null || _e === void 0 ? void 0 : _e.nodeId);
          }
          return null;
        })
      })]
    }), device === commonUi.DEVICE.MOBILE && showCoachmark && jsxRuntime.jsx(DashboardDiscovery, {
      componentData: mockDataMweb.dashboardDiscovery,
      buttonPositionMweb: buttonPosition,
      onClose: closeCoachmark
    })]
  });
};

const AboutProductDiv = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AboutProductstyles__AboutProductDiv",
  componentId: "satqpu-0"
})(["padding:30px 40px 40px 40px;background:", ";border-radius:20px;@media ", "{padding:0;background:transparent;border-radius:0;}", ""], ({
  theme
}) => theme.colors.white, commonUi.deviceType.mobile, ({
  margin
}) => margin && `margin: ${margin};`);
const CardList = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AboutProductstyles__CardList",
  componentId: "satqpu-1"
})(["display:flex;gap:20px;position:relative;@media ", "{gap:16px;overflow-x:auto;margin:0 -16px;padding:6px 16px;}"], commonUi.deviceType.mobile);
const CardListItem = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AboutProductstyles__CardListItem",
  componentId: "satqpu-2"
})(["background-color:", ";display:flex;box-shadow:", ";border-radius:12px;overflow:hidden;flex:1;@media ", "{flex-direction:column;width:263px;flex-shrink:0;flex:none;}"], ({
  theme
}) => theme.colors.white, ({
  theme
}) => `0 0 6px ${theme.colors.shadow}`, commonUi.deviceType.mobile);
const Lists = /*#__PURE__*/styled__default.default.ul.withConfig({
  displayName: "AboutProductstyles__Lists",
  componentId: "satqpu-3"
})(["gap:10px;display:grid;grid-template-columns:1fr;margin:15px 0;"]);
const ListItem = /*#__PURE__*/styled__default.default.li.withConfig({
  displayName: "AboutProductstyles__ListItem",
  componentId: "satqpu-4"
})(["position:relative;padding-left:14px;&::before{content:'';position:absolute;top:3.5px;left:0;width:4.6px;height:13px;border-radius:", ";background-color:", ";}"], ({
  theme
}) => theme.borderRadius.br4, ({
  theme
}) => theme.colors.bulletPointBlueColor);
const TextContainer$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AboutProductstyles__TextContainer",
  componentId: "satqpu-5"
})(["padding:24px 24px 0px;display:flex;flex-direction:column;justify-content:space-between;@media ", "{padding:11px 15px;}"], commonUi.deviceType.mobile);
const BottomText = /*#__PURE__*/styled__default.default(designSystem.Anchor).withConfig({
  displayName: "AboutProductstyles__BottomText",
  componentId: "satqpu-6"
})(["margin-bottom:24px;@media ", "{margin-bottom:13px;}"], commonUi.deviceType.mobile);

const AboutProduct = ({
  componentData,
  margin
}) => {
  var _a, _b, _c;
  const theme = React.useContext(styled.ThemeContext);
  const device = commonUi.useDevice();
  /*Start: Event Handlers */
  const knowMoreClickHandler = cta => {
    var _a;
    if (cta === null || cta === void 0 ? void 0 : cta.deeplink) redirectTo(cta === null || cta === void 0 ? void 0 : cta.deeplink);
    pdtUtils.trackEvent({
      eventData: (_a = cta === null || cta === void 0 ? void 0 : cta.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
  };
  /*End: Event Handlers */
  return jsxRuntime.jsxs(AboutProductDiv, {
    id: componentData === null || componentData === void 0 ? void 0 : componentData.nodeId,
    margin: margin,
    "data-component": "PRODUCT_INFO_SCROLLER",
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      margin: "0px 0px 15px 0px",
      color: theme.colors.highEmphasis,
      typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.xLarge : designTokens.TYPOGRAPHY_KEYS.base,
      text: (_a = componentData === null || componentData === void 0 ? void 0 : componentData.data) === null || _a === void 0 ? void 0 : _a.title
    }), jsxRuntime.jsx(CardList, {
      children: (_c = (_b = componentData === null || componentData === void 0 ? void 0 : componentData.data) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map(cardItem => {
        var _a, _b, _c;
        return jsxRuntime.jsxs(CardListItem, {
          children: [jsxRuntime.jsx(designSystem.Image, {
            width: device === commonUi.DEVICE.DESKTOP ? '195px' : '263px',
            height: device === commonUi.DEVICE.DESKTOP ? '242px' : '135px',
            src: (_a = cardItem === null || cardItem === void 0 ? void 0 : cardItem.image) === null || _a === void 0 ? void 0 : _a.url
          }), jsxRuntime.jsxs(TextContainer$1, {
            children: [jsxRuntime.jsx(designSystem.FormattedText, {
              color: theme.colors.highEmphasis,
              typography: device === commonUi.DEVICE.DESKTOP ? designTokens.TYPOGRAPHY_KEYS.large : designTokens.TYPOGRAPHY_KEYS.base,
              text: cardItem.title
            }), jsxRuntime.jsx(Lists, {
              children: (_b = cardItem === null || cardItem === void 0 ? void 0 : cardItem.infoItems) === null || _b === void 0 ? void 0 : _b.map(infoTextItem => jsxRuntime.jsx(ListItem, {
                children: jsxRuntime.jsx(designSystem.FormattedText, {
                  text: infoTextItem === null || infoTextItem === void 0 ? void 0 : infoTextItem.text,
                  typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
                  color: theme.colors.mediumEmphasis
                })
              }))
            }), jsxRuntime.jsx(BottomText, {
              color: theme.colors.primaryAccent,
              typography: designTokens.TYPOGRAPHY_KEYS.baseW2,
              children: (_c = cardItem === null || cardItem === void 0 ? void 0 : cardItem.bottomCta) === null || _c === void 0 ? void 0 : _c.text,
              onClick: () => knowMoreClickHandler(cardItem === null || cardItem === void 0 ? void 0 : cardItem.bottomCta)
            })]
          })]
        });
      })
    })]
  });
};

const fetchSearchApiData = toolkit.createAsyncThunk('searchApi/fetchSearchApiData', (...args_1) => __awaiter(void 0, [...args_1], void 0, function* ({
  reqHeaders
} = {}, thunkAPI) {
  var _a, _b, _c, _d;
  const {
    sendPdtData
  } = getPdtLoggerMethods({
    state: thunkAPI.getState()
  });
  let queryParams = '';
  const apiUrl = `${BFF_BASE_URL}/api/v1/page/listing/search-currencies`;
  const reqId = getRequestId();
  // Extract source_type and page_name from Redux state (same as listingApiSlice)
  const source_type = (_a = thunkAPI.getState().pageContext) === null || _a === void 0 ? void 0 : _a.source_type;
  const page_name = (_b = thunkAPI.getState().pageContext) === null || _b === void 0 ? void 0 : _b.page_name;
  try {
    const deliveryData = commonUi.getTransformedLocationDataFromSessionStorage({
      key: coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
      isEssential: true,
      options: coreUtils.getSessionPiiDataOpts
    });
    if (deliveryData) {
      queryParams = `?city_code=${(_c = deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.cityCode) !== null && _c !== void 0 ? _c : commonUi.DEFAULT_CITY_CODE}`;
    } else {
      queryParams = `?city_code=${commonUi.DEFAULT_CITY_CODE}`;
    }
    const defaultHeaders = coreUtils.getDefaultHeaders();
    // Apply SEO headers if this is a SEO source type
    if (isSeoSourceType(source_type)) {
      applySeoHeaders(defaultHeaders, page_name);
    }
    const response = yield coreUtils.fetchWithTimeout(`${apiUrl}${queryParams}`, {
      method: 'GET',
      headers: Object.assign(Object.assign(Object.assign({}, defaultHeaders), {
        [HEADERS.REQUEST_ID]: reqId
      }), reqHeaders)
    });
    const responseObj = yield response.json();
    let currenciesArr = Array.from(Object.values(responseObj));
    currenciesArr = currenciesArr === null || currenciesArr === void 0 ? void 0 : currenciesArr.map(currency => {
      return Object.assign(Object.assign({}, currency), {
        isChecked: true
      });
    });
    let popularCurrencyList = (_d = currenciesArr === null || currenciesArr === void 0 ? void 0 : currenciesArr.filter(value => value === null || value === void 0 ? void 0 : value.isPopular)) === null || _d === void 0 ? void 0 : _d.slice(0, 5);
    if (!popularCurrencyList.length) {
      popularCurrencyList = currenciesArr === null || currenciesArr === void 0 ? void 0 : currenciesArr.slice(0, 5);
    }
    let otherCurrencies = currenciesArr === null || currenciesArr === void 0 ? void 0 : currenciesArr.filter(value => (value === null || value === void 0 ? void 0 : value.isPopular) === false);
    if (!otherCurrencies.length) {
      otherCurrencies = currenciesArr === null || currenciesArr === void 0 ? void 0 : currenciesArr.slice(5);
    }
    return {
      popularCurrencyList,
      otherCurrencies
    };
  } catch (error) {
    const pdtData = {
      event_detail: {
        vendor_error_details: pdtUtils.getVendorErrorDetails({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: (error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong',
          api_url: `${apiUrl}${queryParams}`
        })
      },
      event_tracking_context: pdtUtils.getEventTrackingContext({
        request_id: (reqHeaders === null || reqHeaders === void 0 ? void 0 : reqHeaders[HEADERS.REQUEST_ID]) || reqId
      })
    };
    sendPdtData(pdtData);
    return thunkAPI.rejectWithValue((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong');
  }
}));
const initialCurrencyData = {
  popularCurrencyList: [],
  otherCurrencies: []
};
const initialStateSearchCurrency = {
  apiState: coreUtils.States.PRELOADING,
  data: initialCurrencyData,
  error: ''
};
const searchApiSlice = toolkit.createSlice({
  name: 'searchApi',
  initialState: initialStateSearchCurrency,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchSearchApiData.pending, state => {
      state.apiState = coreUtils.States.LOADING;
      state.data = initialCurrencyData;
      state.error = '';
    }).addCase(fetchSearchApiData.fulfilled, (state, action) => {
      state.apiState = coreUtils.States.SUCCESS;
      state.data = action.payload;
    }).addCase(fetchSearchApiData.rejected, (state, action) => {
      state.apiState = coreUtils.States.FAILURE;
      state.error = action.payload;
      state.data = initialCurrencyData;
    });
  }
});
const searchCurrencyApiReducer = searchApiSlice.reducer;

const initialState$2 = {
  apiState: coreUtils.States.PRELOADING,
  data: null,
  error: null
};
const fetchExpressRTData = toolkit.createAsyncThunk('expressRT/fetchExpressRTData', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({
  requestBody
}, {
  rejectWithValue,
  getState
}) {
  var _c, _d, _e;
  const {
    sendPdtData
  } = getPdtLoggerMethods({
    state: getState()
  });
  const apiUrl = `${BFF_BASE_URL}/api/v1/expressRT`;
  const reqId = getRequestId();
  try {
    const defaultHeaders = coreUtils.getDefaultHeaders();
    const response = yield coreUtils.fetchWithTimeout(apiUrl, {
      method: 'POST',
      headers: Object.assign(Object.assign({}, defaultHeaders), {
        [HEADERS.REQUEST_ID]: reqId
      }),
      body: JSON.stringify(requestBody)
    });
    const responseObj = yield response.json();
    if ((responseObj === null || responseObj === void 0 ? void 0 : responseObj.success) && ((_c = responseObj === null || responseObj === void 0 ? void 0 : responseObj.data) === null || _c === void 0 ? void 0 : _c.success)) {
      return responseObj;
    } else {
      const pdtData = {
        event_detail: {
          vendor_error_details: pdtUtils.getVendorErrorDetails({
            error_code: (_d = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error) === null || _d === void 0 ? void 0 : _d.code,
            error_message_shown: ((_e = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error) === null || _e === void 0 ? void 0 : _e.message) || 'Something went wrong',
            api_url: apiUrl
          })
        },
        event_tracking_context: pdtUtils.getEventTrackingContext({
          request_id: reqId
        })
      };
      sendPdtData(pdtData);
      return rejectWithValue(responseObj !== null && responseObj !== void 0 ? responseObj : 'Something went wrong');
    }
  } catch (error) {
    const pdtData = {
      event_detail: {
        vendor_error_details: pdtUtils.getVendorErrorDetails({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: (error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong',
          api_url: apiUrl
        })
      },
      event_tracking_context: pdtUtils.getEventTrackingContext({
        request_id: reqId
      })
    };
    sendPdtData(pdtData);
    return rejectWithValue((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong');
  }
}));
const expressRTSlice = toolkit.createSlice({
  name: 'expressRT',
  initialState: initialState$2,
  reducers: {
    resetExpressRTData: () => {
      return initialState$2;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchExpressRTData.pending, state => {
      state.apiState = coreUtils.States.LOADING;
      state.error = null;
      state.data = null;
    }).addCase(fetchExpressRTData.fulfilled, (state, action) => {
      state.apiState = coreUtils.States.SUCCESS;
      state.data = action.payload;
      state.error = null;
    }).addCase(fetchExpressRTData.rejected, (state, action) => {
      state.apiState = coreUtils.States.FAILURE;
      state.error = action.payload;
      state.data = null;
    });
  }
});
const {
  resetExpressRTData
} = expressRTSlice.actions;
const expressRTReducer = expressRTSlice.reducer;

const initialState$1 = {
  source_type: null,
  page_name: null,
  deviceType: null
};
const createPageContextSlice = () => {
  return toolkit.createSlice({
    name: 'pageContext',
    initialState: initialState$1,
    reducers: {}
  });
};

const makeStore = preloadedState => {
  const pageContextSlice = createPageContextSlice();
  return toolkit.configureStore({
    reducer: {
      listingApi: listingApiSlice$1,
      searchCurrenciesApi: searchCurrencyApiReducer,
      expressRTData: expressRTReducer,
      locationApi: locationApiReducer,
      forexProductData: productDataSliceReducer,
      toastData: toastSliceDataReducer,
      userData: userDataReducer,
      pageContext: pageContextSlice.reducer
    },
    preloadedState
  });
};

function StoreProvider({
  children,
  initialData
}) {
  const storeRef = React.useRef();
  if (!storeRef.current) {
    // Pass initialData directly as preloadedState
    storeRef.current = makeStore(initialData);
  }
  return jsxRuntime.jsx(Provider_default, {
    store: storeRef.current,
    children: children
  });
}

const StyledListingUi = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "listing-uistyles__StyledListingUi",
  componentId: "z5vc8l-0"
})(["max-width:1200px;margin:0 auto;@media ", "{background:url(", ") 0 0 no-repeat;background-size:100% 100vh;}background-size:100% 100vh;padding-top:", ";"], commonUi.deviceType.mobile, bgImage, ({
  source_type
}) => isSeoSourceType(source_type) ? '0px' : '65px');

const getMarginForTemplate = templateName => {
  const marginMapping = {
    BEST_RATES: '0px 0px 16px',
    INSTANT_LOAD_NUDGE: '0 0 16px 0',
    ORDER_STATUS_SCROLLER: '0 0 16px 0',
    RATE_TICKER: '0 0 16px 0',
    RATE_TICKER_DT: '0 0 16px 0',
    OFFER_PERSUASION: '0 0 0 0',
    FREE_DELIVERY: '0 0 16px 0',
    DELIVERY_PERSUASION: '12px 0 8px 0',
    CURRENCY_SEARCH_ITEMS: '16px -16px 16px -16px',
    SCROLLABLE_INFO_ITEMS: '0px 0px 16px',
    CC_COMPARISON: '0px 0px 16px',
    STATIC_TITLE_SUBTITLE: '0 0 16px 0',
    AUTO_SCROLL_CAROUSEL: '0 0 24px',
    PAGER_1: '0 0 40px 0',
    PRODUCT_INFO_SCROLLER: '0 0 16px',
    FREQUENTLY_ASKED_QUESTION: '0 0 16px'
  };
  return marginMapping[templateName] || '0';
};

const TEMPLATE_KEYS = {
  BEST_RATES: 'BEST_RATES',
  INSTANT_LOAD_NUDGE: 'INSTANT_LOAD_NUDGE',
  ORDER_STATUS_SCROLLER: 'ORDER_STATUS_SCROLLER',
  RATE_TICKER: 'RATE_TICKER',
  RATE_TICKER_DT: 'RATE_TICKER_DT',
  RATE_TICKER_VERTICAL_SCROLL: 'RATE_TICKER_VERTICAL_SCROLL',
  OFFER_PERSUASION: 'OFFER_PERSUASION',
  FREE_DELIVERY: 'FREE_DELIVERY',
  DELIVERY_PERSUASION: 'DELIVERY_PERSUASION',
  CURRENCY_SEARCH_ITEMS: 'CURRENCY_SEARCH_ITEMS',
  SCROLLABLE_INFO_ITEMS: 'SCROLLABLE_INFO_ITEMS',
  CC_COMPARISON: 'CC_COMPARISON',
  STATIC_TITLE_SUBTITLE: 'STATIC_TITLE_SUBTITLE',
  AUTO_SCROLL_CAROUSEL: 'AUTO_SCROLL_CAROUSEL',
  PAGER_1: 'PAGER_1',
  PRODUCT_INFO_SCROLLER: 'PRODUCT_INFO_SCROLLER',
  FREQUENTLY_ASKED_QUESTION: 'FREQUENTLY_ASKED_QUESTION',
  CURRENCY_PRODUCT_SELECTION: 'CURRENCY_PRODUCT_SELECTION',
  CENTER_WIDGET_DT: 'CENTER_WIDGET_DT',
  ADD_DETAILED_ADDRESS: 'ADD_DETAILED_ADDRESS',
  ADD_TRAVELLER_DETAILS: 'ADD_TRAVELLER_DETAILS',
  PAN_DETAILS: 'PAN_DETAILS',
  IMPORTANT_NOTE_CARD: 'IMPORTANT_NOTE_CARD',
  POD_SELECT_PAY_OPTIONS: 'POD_SELECT_PAY_OPTIONS',
  AUTO_FETCH_LOADER: 'AUTO_FETCH_LOADER',
  CURRENCY_ADDED_CARD: 'CURRENCY_ADDED_CARD'
};

var $$1 = _export;
var call = functionCall;
var iterate = iterate$a;
var aCallable = aCallable$d;
var anObject = anObject$p;
var getIteratorDirect = getIteratorDirect$8;
var iteratorClose = iteratorClose$d;
var iteratorHelperWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$7;

var someWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('some', TypeError);

// `Iterator.prototype.some` method
// https://tc39.es/ecma262/#sec-iterator.prototype.some
$$1({ target: 'Iterator', proto: true, real: true, forced: someWithoutClosingOnEarlyError }, {
  some: function some(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }

    if (someWithoutClosingOnEarlyError) return call(someWithoutClosingOnEarlyError, this, predicate);

    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop();
    }, { IS_RECORD: true, INTERRUPTED: true }).stopped;
  }
});

const AmountContainerForex = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountSelectionForexstyles__AmountContainerForex",
  componentId: "g8moij-0"
})(["border-right:", ";display:flex;flex-direction:column;width:207px;padding:12px 20px;position:relative;flex-shrink:0;"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`);
const TooltipContainer = /*#__PURE__*/styled__default.default(designSystem.ToolTip).withConfig({
  displayName: "AmountSelectionForexstyles__TooltipContainer",
  componentId: "g8moij-1"
})(["right:40px;top:77px;display:flex;gap:16px;z-index:10;"]);
const TooltipWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountSelectionForexstyles__TooltipWrapper",
  componentId: "g8moij-2"
})([""]);
const CompareAmountIcon = /*#__PURE__*/styled__default.default(designSystem.Image).withConfig({
  displayName: "AmountSelectionForexstyles__CompareAmountIcon",
  componentId: "g8moij-3"
})(["position:absolute;top:50%;right:-25px;transform:translate(-50%,-50%);z-index:2;pointer-events:none;"]);
const SpinnerContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountSelectionForexstyles__SpinnerContainer",
  componentId: "g8moij-4"
})(["display:flex;align-items:center;.spinner-margin-forex{margin-top:18px;padding-left:8px;}"]);

const ForexInputStyles = /*#__PURE__*/styled__default.default.input.withConfig({
  displayName: "ForexInputstyles__ForexInputStyles",
  componentId: "sc-118rtbp-0"
})(["width:", ";margin:", ";color:", ";background-color:transparent;caret-color:", ";border:0;outline:none;", " &::placeholder{color:", ";}"], props => props.width || '100%', props => props.margin || '18px 0px 0px', ({
  theme,
  value
}) => value ? theme.colors.highEmphasis : theme.colors.disabled, ({
  theme
}) => theme.colors.primaryAccent, ({
  theme
}) => {
  const fontStyles = designTokens.getTypographyStyles(designTokens.TYPOGRAPHY_KEYS.medium, theme.partner);
  return `
      ${designTokens.getFontSizeStyles(fontStyles.fontSize, designTokens.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
    `;
}, ({
  theme
}) => theme.colors.disabled);

const ForexInput = /*#__PURE__*/React.forwardRef(({
  value,
  onChange,
  placeholder,
  width,
  disabled,
  readonly,
  onFocus,
  onBlur,
  onClick
}, ref) => {
  return jsxRuntime.jsx(ForexInputStyles, {
    type: "text",
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    width: width,
    disabled: disabled,
    readOnly: readonly,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: ref,
    onClick: onClick
  });
});

const AmountSelectionForex = ({
  amountSelectionData,
  // isDisabled,
  isError,
  setAmountError,
  errorMessage,
  showProductSelectionCard
}) => {
  const [showToolTip, setShowToolTip] = React.useState(false);
  const theme = React.useContext(styled.ThemeContext);
  const [maxAmountError, setMaxAmountError] = React.useState('');
  const [previousModalState, setPreviousModalState] = React.useState(undefined);
  const {
    title,
    hint,
    toolTip,
    disabled,
    tracking
  } = amountSelectionData !== null && amountSelectionData !== void 0 ? amountSelectionData : {};
  const {
    selectedCurrencyCode,
    exchangeRate,
    selectedProductType,
    amountDetails: {
      internationalCurrencyAmount
    },
    isInternationalCurrencyLoader
  } = useAppSelector(state => state.forexProductData);
  const internationalAmountRef = React.useRef(null);
  const {
    isLoading: listingApiLoading,
    data
  } = useAppSelector(state => state.listingApi);
  const {
    apiData: listingApiData
  } = data || {};
  const dispatch = useAppDispatch();
  const tooltipRef = React.useRef(null);
  commonUi.useOutsideClick(tooltipRef, () => setShowToolTip(false), showToolTip);
  /*Start: Event Handler */
  const internationalCurrencyAmountOnChangeHandler = e => {
    var _a;
    setShowToolTip(false);
    setMaxAmountError('');
    const amount = e.target.value.replace(/[^0-9]/g, '');
    const amountInInt = Number(amount);
    const amountInInr = amountInInt * exchangeRate;
    if (selectedProductType && ((_a = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.maxAmount) === null || _a === void 0 ? void 0 : _a[selectedProductType]) && (listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.maxAmount[selectedProductType]) < amountInInr) {
      const maxAmountErrorMessage = getMaxAmountErrorMessage(selectedProductType, listingApiData);
      dispatch(showToastMessage({
        showToast: true,
        message: maxAmountErrorMessage,
        showCrossIcon: true,
        duration: 6000,
        rightText: 'OKAY'
      }));
      setMaxAmountError(commonUi.ERROR_MSGS.MAX_AMOUNT_ERROR);
    }
    if (FormValidation.isValidInrAmount(amountInInr)) {
      dispatch(setInternationalCurrencyAmount(amountInInt));
    }
  };
  const internationalCurrencyAmountOnFocusHandler = () => {
    var _a, _b;
    if (disabled) return;
    setShowToolTip(true);
    setAmountError === null || setAmountError === void 0 ? void 0 : setAmountError(false);
    pdtUtils.trackEvent({
      eventData: (_b = (_a = tracking === null || tracking === void 0 ? void 0 : tracking.amountSelection) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
  };
  const recommendedAmountHandler = item => {
    var _a, _b;
    const recommendedAmount = Number((_b = (_a = item === null || item === void 0 ? void 0 : item.dispatchArgs) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.recommendedAmount);
    if (recommendedAmount) dispatch(setInternationalCurrencyAmount(recommendedAmount));
  };
  const forexAmountBoxClickHandler = () => {
    if (disabled) {
      dispatch(showToastMessage({
        showToast: true,
        message: commonUi.TOAST_MESSAGES.LOCATION_NOT_SERVICEABLE,
        showCrossIcon: true,
        duration: 6000,
        // default duration in milliseconds
        rightText: 'OKAY'
      }));
      return;
    }
  };
  /*End: Event Handler */
  /* Start: useEffect */
  // Focus amount field when product selection modal is closed
  React.useEffect(() => {
    // Check if modal was open and is now closed
    if (previousModalState === true && showProductSelectionCard === false) {
      setTimeout(() => {
        var _a;
        (_a = internationalAmountRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      });
    }
    // Update previous state
    setPreviousModalState(showProductSelectionCard);
  }, [showProductSelectionCard, previousModalState]);
  React.useEffect(() => {
    if (internationalCurrencyAmount) {
      // reset local max amount error state whenever internationalCurrencyAmount is changed either on forex amount input or inr amount input
      setMaxAmountError('');
    }
  }, [internationalCurrencyAmount]);
  return jsxRuntime.jsxs(AmountContainerForex, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: title,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
      color: isError || maxAmountError ? theme.colors.error : theme.colors.mediumEmphasis
    }), jsxRuntime.jsxs(SpinnerContainer, {
      children: [jsxRuntime.jsx(ForexInput, {
        placeholder: hint,
        // disabled={disabled}
        readonly: disabled,
        value: coreUtils.roundWithoutDecimal(internationalCurrencyAmount) > 0 ? coreUtils.toIndianLocaleFormat(coreUtils.roundWithoutDecimal(internationalCurrencyAmount)) : '',
        onChange: internationalCurrencyAmountOnChangeHandler,
        onFocus: internationalCurrencyAmountOnFocusHandler,
        onClick: forexAmountBoxClickHandler,
        ref: internationalAmountRef
      }), isInternationalCurrencyLoader && jsxRuntime.jsx(designSystem.Spinner, {
        spinnerWidth: 16,
        thickness: 2,
        spinnerColor: theme.colors.primaryAccent,
        className: "spinner-margin-forex"
      })]
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: isError || maxAmountError ? errorMessage || maxAmountError || commonUi.ERROR_MSGS.REQUIRED_FIELD : selectedCurrencyCode,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: disabled ? theme.colors.disabled : isError || maxAmountError ? theme.colors.error : theme.colors.mediumEmphasis,
      margin: '2px 0px 0px'
    }), showToolTip && !internationalCurrencyAmount && !isInternationalCurrencyLoader && jsxRuntime.jsx(TooltipWrapper, {
      ref: tooltipRef,
      children: jsxRuntime.jsx(TooltipContainer, {
        width: "273px",
        arrowDirection: "up",
        dismissDuration: 5000,
        autoDismiss: true,
        children: jsxRuntime.jsx(designSystem.FormattedText, {
          text: toolTip === null || toolTip === void 0 ? void 0 : toolTip.text,
          typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
          color: theme.colors.white,
          onClick: item => recommendedAmountHandler(item)
        })
      })
    }), jsxRuntime.jsx(CompareAmountIcon, {
      src: 'https://tripmoneycmsimgak.mmtcdn.com/img/equal_f79a49ccd5.png',
      height: "24px",
      width: "24px"
    })]
  });
};

const AmountContainerInr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "AmountSelectionInrstyles__AmountContainerInr",
  componentId: "tvstj9-0"
})(["display:flex;flex-direction:column;width:207px;padding:12px 20px;position:relative;flex-shrink:0;"]);

const AmountSelectionInr = ({
  amountSelectionData,
  isError,
  bottomSheets,
  setAmountError
}) => {
  var _a, _b;
  const [isCurrencyLoader, setIsCurrencyLoader] = React.useState(false);
  const [amountInInr, setAmountInInr] = React.useState(0);
  const timeoutRef = React.useRef();
  const [maxAmountError, setMaxAmountError] = React.useState('');
  const theme = React.useContext(styled.ThemeContext);
  const {
    totalAmountInInr,
    netEffectiveAmountOnTotalValue,
    internationalCurrencyAmount,
    cashbackAmount
  } = useAppSelector(state => state.forexProductData.amountDetails);
  const {
    apiData: listingApiData
  } = useAppSelector(selectListingApiData);
  const {
    exchangeRate,
    selectedProductType
  } = useAppSelector(state => state.forexProductData);
  const {
    title,
    defaultCurrency,
    hint,
    bottomBanner,
    disabled,
    tracking
  } = amountSelectionData !== null && amountSelectionData !== void 0 ? amountSelectionData : {};
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  React.useEffect(() => {
    if (totalAmountInInr) {
      // reset local max amount error state whenever totalAmountInInr is changed either on forex amount input or inr amount input
      setMaxAmountError('');
      setAmountInInr(totalAmountInInr);
    } else {
      setAmountInInr(0);
    }
  }, [totalAmountInInr]);
  const specialCashbackModalId = (_b = (_a = bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.info) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.modalId;
  specialCashbackModalId ? bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets[specialCashbackModalId] : null;
  /*Start: Event Handler */
  const forexAmountINRBoxClickHandler = () => {
    if (disabled) {
      dispatch(showToastMessage({
        showToast: true,
        message: commonUi.TOAST_MESSAGES.LOCATION_NOT_SERVICEABLE,
        showCrossIcon: true,
        duration: 6000,
        // default duration in milliseconds
        rightText: 'OKAY'
      }));
      return;
    }
  };
  const blurForexAmountInrHandler = () => {
    if (internationalCurrencyAmount) {
      dispatch(setInternationalCurrencyAmount(coreUtils.floorWithoutDecimal(Number(internationalCurrencyAmount))));
    }
  };
  const clearToastMessage = () => {
    dispatch(showToastMessage({
      showToast: false,
      message: '',
      showCrossIcon: false,
      duration: 0,
      // default duration in milliseconds
      rightText: ''
    }));
  };
  const forexAmountInrChangeHandler = e => {
    var _a;
    clearToastMessage();
    setMaxAmountError('');
    const amount = e.target.value.replace(/[^0-9]/g, '');
    const inputAmount = Number(amount);
    dispatch(setInternationalCurrencyLoader(true));
    setIsCurrencyLoader(true);
    if (selectedProductType && ((_a = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.maxAmount) === null || _a === void 0 ? void 0 : _a[selectedProductType]) && (listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.maxAmount[selectedProductType]) < inputAmount) {
      const maxAmountErrorMessage = getMaxAmountErrorMessage(selectedProductType, listingApiData);
      dispatch(showToastMessage({
        showToast: true,
        message: maxAmountErrorMessage,
        showCrossIcon: true,
        duration: 6000,
        rightText: 'OKAY'
      }));
      setMaxAmountError(commonUi.ERROR_MSGS.MAX_AMOUNT_ERROR);
    }
    if (exchangeRate && FormValidation.isValidInrAmount(inputAmount)) {
      setAmountInInr(inputAmount);
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setIsCurrencyLoader(false);
      const calculatedAmount = coreUtils.floorWithoutDecimal(Number(inputAmount / exchangeRate));
      if (exchangeRate && FormValidation.isValidInrAmount(inputAmount)) {
        dispatch(setInternationalCurrencyAmount(calculatedAmount));
      } else if (exchangeRate && FormValidation.isValidInrAmount(amountInInr)) {
        const _calculatedAmount = coreUtils.floorWithoutDecimal(Number(amountInInr / exchangeRate));
        dispatch(setInternationalCurrencyAmount(_calculatedAmount));
      }
      dispatch(setInternationalCurrencyLoader(false));
      if (calculatedAmount === 0) {
        setAmountInInr(0);
      }
    }, LOADER_TIMER);
  };
  const onFocusHandler = () => {
    var _a, _b;
    setAmountError === null || setAmountError === void 0 ? void 0 : setAmountError(false);
    pdtUtils.trackEvent({
      eventData: (_b = (_a = tracking === null || tracking === void 0 ? void 0 : tracking.amountSelection) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
  };
  /*End: Event Handler */
  return jsxRuntime.jsxs(AmountContainerInr, {
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: title,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
      color: isError || maxAmountError ? theme.colors.error : theme.colors.mediumEmphasis
    }), jsxRuntime.jsx(ForexInput, {
      placeholder: hint,
      readonly: disabled,
      value: amountInInr > 0 ? coreUtils.toIndianLocaleFormat(coreUtils.roundWithoutDecimal(amountInInr)) : '',
      onChange: forexAmountInrChangeHandler,
      onFocus: onFocusHandler,
      onBlur: blurForexAmountInrHandler,
      onClick: forexAmountINRBoxClickHandler
    }), isCurrencyLoader ? jsxRuntime.jsx(designSystem.FormattedText, {
      text: AMOUNT_ROUND_OFF_TEXT,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.primaryAccent,
      margin: '2px 0px 0px'
    }) : jsxRuntime.jsx(designSystem.FormattedText, {
      text: isError || maxAmountError ? maxAmountError || commonUi.ERROR_MSGS.REQUIRED_FIELD : defaultCurrency,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: disabled ? theme.colors.disabled : isError || maxAmountError ? theme.colors.error : theme.colors.mediumEmphasis,
      margin: '2px 0px 0px'
    })]
  });
};

const HintTextWrapper$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySelectionstyles__HintTextWrapper",
  componentId: "sc-1el05bo-0"
})(["position:absolute;top:85%;left:20px;background-color:", ";padding:8px 12px;font-size:14px;border-radius:4px;white-space:nowrap;box-shadow:0px 1px 7px 0px #00000033;display:none;z-index:2;"], ({
  theme
}) => theme.colors.lightBlue);
const CurrencyContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySelectionstyles__CurrencyContainer",
  componentId: "sc-1el05bo-1"
})(["border-right:", ";display:flex;flex-direction:column;width:230px;padding:12px 20px;position:relative;background:", ";cursor:pointer;flex-shrink:0;&:hover{background-color:", ";}position:relative;&:hover ", "{display:block;}"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`, ({
  theme,
  showCurrencyPopup
}) => showCurrencyPopup && theme.colors.lightBlue, ({
  theme
}) => theme.colors.lightBlue, HintTextWrapper$1);
const CurrencyBottomBanner = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySelectionstyles__CurrencyBottomBanner",
  componentId: "sc-1el05bo-2"
})(["display:flex;justify-content:center;padding:4px 20px 8px;position:absolute;top:calc(100% + 1px);right:-1px;background:radial-gradient( 75.36% 140.35% at 100% 0%,#d3e7ff 0%,#ffffff 100% );border-radius:0 0 16px 0;width:260px;cursor:default;pointer-events:none;"]);
const SelectCurrencyPopupCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencySelectionstyles__SelectCurrencyPopupCont",
  componentId: "sc-1el05bo-3"
})(["position:absolute;z-index:5;left:20px;top:44px;"]);
const SelectedCurrencyText = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "CurrencySelectionstyles__SelectedCurrencyText",
  componentId: "sc-1el05bo-4"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

var tryToString = tryToString$4;

var $TypeError = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var $ = _export;
var toObject = toObject$9;
var lengthOfArrayLike = lengthOfArrayLike$8;
var setArrayLength = arraySetLength;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return setArrayLength(O, len + argCount);
  }
});

const useCurrencySearchQuery = () => {
  const {
    data: searchCurrencyData
  } = useAppSelector(state => state.searchCurrenciesApi);
  const {
    popularCurrencyList,
    otherCurrencies
  } = searchCurrencyData;
  const [searchedPopularList, setSearchedPopularList] = React.useState(popularCurrencyList !== null && popularCurrencyList !== void 0 ? popularCurrencyList : []);
  const [searchedAllCurrencyList, setSearchedAllCurrencyList] = React.useState(otherCurrencies !== null && otherCurrencies !== void 0 ? otherCurrencies : []);
  const [associatedCurrency, setAssociatedCurrency] = React.useState([]);
  const [showCurrencySuggestion, setSetCurrencySuggestion] = React.useState(false);
  const [suggestionVisible, setSuggestionVisible] = React.useState(false);
  /**
   * Function to process entered query text.
   * @param text Search query text.
   */
  const userSearched = React.useCallback(text => {
    var _a;
    if (text === '') {
      setSuggestionVisible(false);
      setSetCurrencySuggestion(false);
      setSearchedPopularList(popularCurrencyList !== null && popularCurrencyList !== void 0 ? popularCurrencyList : []);
      setSearchedAllCurrencyList(otherCurrencies !== null && otherCurrencies !== void 0 ? otherCurrencies : []);
    } else {
      const currenciesArr = popularCurrencyList.concat(otherCurrencies);
      const [popular, others, fuzzyPopular, fuzzyOthers, associated] = searchCurrency(text, popularCurrencyList, otherCurrencies, currenciesArr);
      setAssociatedCurrency(associated);
      setSearchedPopularList(popular);
      if (fuzzyOthers.length === 0 && fuzzyOthers.length === 0) {
        setSetCurrencySuggestion(false);
      }
      if (others.length == 0 && popular.length == 0) {
        setSuggestionVisible(true);
        setSetCurrencySuggestion(true);
        if (fuzzyPopular.length === 0) {
          setSearchedPopularList((_a = popularCurrencyList === null || popularCurrencyList === void 0 ? void 0 : popularCurrencyList.slice(0, 1)) !== null && _a !== void 0 ? _a : []);
        } else {
          setSearchedPopularList(fuzzyPopular !== null && fuzzyPopular !== void 0 ? fuzzyPopular : []);
        }
      } else {
        setSuggestionVisible(true);
      }
      if (others.length > 0) {
        setSearchedAllCurrencyList(others);
      } else if (fuzzyOthers.length > 0) {
        setSearchedAllCurrencyList(fuzzyOthers);
      } else {
        setSearchedAllCurrencyList([]);
      }
    }
  }, [otherCurrencies, popularCurrencyList]);
  return {
    searchedPopularList,
    searchedAllCurrencyList,
    associatedCurrency,
    showCurrencySuggestion,
    suggestionVisible,
    userSearched
  };
};
/* Reference from RN Listing page*/
const searchCurrency = (query, popularCurrencyList, otherCurrencyList, allCurrencies) => {
  const associatedCurrencyResult = [];
  const searchedPopular = popularCurrencyList.filter(currItem => {
    var _a, _b, _c;
    if (query.length > 3) {
      let associateFound = false;
      (_a = currItem.associatedCurrencies) === null || _a === void 0 ? void 0 : _a.map(associateCurrItem => {
        var _a, _b, _c;
        if ((_a = associateCurrItem.country) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_b = associateCurrItem.currencyCode) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_c = associateCurrItem.currencyName) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
      });
      if (associateFound) {
        return true;
      }
    }
    if (currItem.leftLabel.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if (currItem.currencyCode.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if (currItem.homeCountryCode.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    let found = false;
    (_b = currItem.supportedCities) === null || _b === void 0 ? void 0 : _b.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
    });
    (_c = currItem.supportedCountries) === null || _c === void 0 ? void 0 : _c.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
    });
    return found;
  });
  const searchedOthers = otherCurrencyList.filter(currItem => {
    var _a, _b, _c;
    if (query.length > 3) {
      let associateFound = false;
      (_a = currItem.associatedCurrencies) === null || _a === void 0 ? void 0 : _a.map(associateCurrItem => {
        var _a, _b, _c;
        if ((_a = associateCurrItem.country) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_b = associateCurrItem.currencyCode) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
        if ((_c = associateCurrItem.currencyName) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(query.toLowerCase())) {
          associateFound = true;
          associatedCurrencyResult.unshift({
            currency: currItem,
            with: associateCurrItem
          });
          return true;
        }
      });
      if (associateFound) {
        return true;
      }
    }
    if (currItem.leftLabel.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if (currItem.currencyCode.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if (currItem.homeCountryCode.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    let found = false;
    (_b = currItem.supportedCities) === null || _b === void 0 ? void 0 : _b.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
    });
    (_c = currItem.supportedCountries) === null || _c === void 0 ? void 0 : _c.map(item => {
      if (item.toLowerCase().includes(query.toLowerCase())) {
        found = true;
      }
    });
    return found;
  });
  let fuzzyPopular = [];
  let fuzzyOthers = [];
  if (searchedPopular.length === 0 && searchedOthers.length === 0) {
    const options = {
      keys: ['associatedCurrencies', 'supportedCities', 'supportedCountries', 'currencyCode', 'leftLabel']
    };
    const fuse = new Fuse__default.default(allCurrencies, options);
    const fuzzyResults = fuse.search(query).slice(0, 3).map(item => item.item);
    fuzzyPopular = fuzzyResults.filter(item => {
      var _a;
      return (_a = item === null || item === void 0 ? void 0 : item.isPopular) !== null && _a !== void 0 ? _a : false;
    });
    fuzzyOthers = fuzzyResults.filter(item => {
      return !(item === null || item === void 0 ? void 0 : item.isPopular);
    });
  }
  return [searchedPopular, searchedOthers, fuzzyPopular, fuzzyOthers, associatedCurrencyResult];
};

const CurrencySelection = ({
  currencySelectionData,
  bottomSheets
}) => {
  const dispatch = useAppDispatch();
  const {
    selectedCurrencyCode,
    selectedCurrencyName,
    searchQueryText
  } = useAppSelector(state => state.forexProductData);
  const [showCurrencyPopup, setShowCurrencyPopup] = React.useState(false);
  const theme = React.useContext(styled.ThemeContext);
  const popupRef = React.useRef(null);
  const {
    title,
    bottomText,
    bottomBanner,
    default: defaultCurrencySelected,
    cta
  } = currencySelectionData !== null && currencySelectionData !== void 0 ? currencySelectionData : {};
  const currencySearchBottomSheetModelId = cta === null || cta === void 0 ? void 0 : cta.modalId;
  const currencySearchBottomSheetData = currencySearchBottomSheetModelId ? bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets[currencySearchBottomSheetModelId] : null;
  React.useEffect(() => {
    dispatch(setSelectedCurrency({
      selectedCurrencyCode: bottomText,
      selectedCurrencyName: defaultCurrencySelected
    }));
  }, [defaultCurrencySelected, bottomText, dispatch]);
  commonUi.useOutsideClick(popupRef, () => setShowCurrencyPopup(false), showCurrencyPopup);
  const {
    suggestionVisible,
    associatedCurrency,
    showCurrencySuggestion,
    searchedPopularList,
    searchedAllCurrencyList,
    userSearched
  } = useCurrencySearchQuery();
  React.useEffect(() => {
    userSearched(searchQueryText || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSearched, searchQueryText]);
  React.useEffect(() => {
    dispatch(setSearchCurrencyContext({
      suggestionVisible,
      associatedCurrency,
      showCurrencySuggestion
    }));
  }, [suggestionVisible, associatedCurrency, showCurrencySuggestion, dispatch]);
  const currencyData = [{
    id: 'POPULAR',
    leftLabel: currencySearchBottomSheetData === null || currencySearchBottomSheetData === void 0 ? void 0 : currencySearchBottomSheetData.popularCurrencyHeader,
    rightLabel: 'Country',
    currencyList: searchedPopularList
  }, {
    id: 'OTHER',
    leftLabel: currencySearchBottomSheetData === null || currencySearchBottomSheetData === void 0 ? void 0 : currencySearchBottomSheetData.allCurrencyHeader,
    rightLabel: 'Country',
    currencyList: searchedAllCurrencyList
  }];
  function onCurrencySelected(el) {
    var _a, _b;
    const pdtData = pdtUtils.updatePdtDataDescription((_b = (_a = currencySearchBottomSheetData === null || currencySearchBottomSheetData === void 0 ? void 0 : currencySearchBottomSheetData.currencySelectCta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData, el === null || el === void 0 ? void 0 : el.currencyCode);
    pdtUtils.trackEvent({
      eventData: pdtData
    });
    dispatch(setSelectedCurrency({
      selectedCurrencyCode: el.currencyCode,
      selectedCurrencyName: el.leftLabel
    }));
    if (el.currencyCode !== selectedCurrencyCode) {
      dispatch(setCurrencyChanged(true));
    }
    dispatch(fetchListingData({
      showLoader: false,
      selectedCurrencyCodes: [el.currencyCode],
      onLoading: state => {
        if (state === coreUtils.States.LOADING) {
          dispatch(resetProductsData());
          dispatch(showToastMessage({
            message: commonUi.TOAST_MESSAGES.CURRENCY_UPDATE,
            duration: 10000
          }));
        }
      },
      onSuccess: response => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const currencySelectionData = (_a = response === null || response === void 0 ? void 0 : response.cardData) === null || _a === void 0 ? void 0 : _a.find(data => {
          if ((data === null || data === void 0 ? void 0 : data.templateId) === TEMPLATE_KEYS.CURRENCY_PRODUCT_SELECTION) {
            return data;
          }
        });
        if ((_e = (_d = (_c = (_b = currencySelectionData === null || currencySelectionData === void 0 ? void 0 : currencySelectionData.data) === null || _b === void 0 ? void 0 : _b.currencySelection) === null || _c === void 0 ? void 0 : _c.cta) === null || _d === void 0 ? void 0 : _d.analytics) === null || _e === void 0 ? void 0 : _e.pdtData) {
          pdtUtils.trackEvent({
            eventData: (_j = (_h = (_g = (_f = currencySelectionData === null || currencySelectionData === void 0 ? void 0 : currencySelectionData.data) === null || _f === void 0 ? void 0 : _f.currencySelection) === null || _g === void 0 ? void 0 : _g.cta) === null || _h === void 0 ? void 0 : _h.analytics) === null || _j === void 0 ? void 0 : _j.pdtData
          });
        }
        dispatch(hideToastMessage());
      }
    }));
    setShowCurrencyPopup(false);
  }
  function searchInputChangeHandler(e) {
    dispatch(setSearchQueryText(e.target.value));
  }
  return jsxRuntime.jsxs(CurrencyContainer, {
    showCurrencyPopup: showCurrencyPopup,
    onClick: () => setShowCurrencyPopup(true),
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: title,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
      color: theme.colors.mediumEmphasis
    }), jsxRuntime.jsx(SelectedCurrencyText, {
      text: selectedCurrencyName,
      typography: designTokens.TYPOGRAPHY_KEYS.large30,
      color: theme.colors.highEmphasis,
      margin: '10px 0px 0px'
    }), jsxRuntime.jsx(HintTextWrapper$1, {
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: selectedCurrencyName,
        color: theme.colors.mediumEmphasis,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1
      })
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: selectedCurrencyCode,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.mediumEmphasis
    }), (bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.title) && jsxRuntime.jsx(CurrencyBottomBanner, {
      onClick: event => {
        event.stopPropagation();
        setShowCurrencyPopup(false);
      },
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.title,
        color: theme.colors.highEmphasis,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW1
      })
    }), showCurrencyPopup && currencySearchBottomSheetData && jsxRuntime.jsx(SelectCurrencyPopupCont, {
      ref: popupRef,
      children: jsxRuntime.jsx(SelectCurrencyModal, {
        inputValue: searchQueryText,
        data: currencySearchBottomSheetData,
        currencyData: currencyData,
        currencyItemHandler: onCurrencySelected,
        onChange: searchInputChangeHandler
      })
    })]
  });
};

const CurrencyTypeContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__CurrencyTypeContainer",
  componentId: "sc-1d50e6l-0"
})(["display:flex;flex-direction:column;width:295px;padding:8px 20px 11px;position:relative;border-right:", ";background:", ";&:hover{background-color:", ";}cursor:pointer;flex-shrink:0;&:hover ", "{display:block;}"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`, ({
  theme,
  showProductSelectionCard
}) => showProductSelectionCard && theme.colors.lightBlue, ({
  theme
}) => theme.colors.lightBlue, HintTextWrapper$1);
const HeaderContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__HeaderContainer",
  componentId: "sc-1d50e6l-1"
})(["display:flex;align-items:center;"]);
const OptionContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__OptionContainer",
  componentId: "sc-1d50e6l-2"
})(["display:flex;align-items:center;column-gap:9px;margin-top:10px;"]);
const ProductSelectionModalCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__ProductSelectionModalCont",
  componentId: "sc-1d50e6l-3"
})(["background:", ";position:absolute;top:44px;left:20px;z-index:3;width:340px;overflow:auto;box-shadow:0px 1px 5px #00000033;padding:12px 14px;border-radius:4px;"], ({
  theme
}) => theme.colors.white);
const SelectionCardCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__SelectionCardCont",
  componentId: "sc-1d50e6l-4"
})(["display:flex;justify-content:space-between;padding:12px 10px;background-color:", ";cursor:", ";pointer-events:", ";"], ({
  theme,
  isChecked
}) => isChecked ? theme.colors.lightBlue : 'transparent', ({
  disabled
}) => disabled ? 'default' : 'pointer', ({
  disabled
}) => disabled ? 'none' : 'all');
const ProductCard = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__ProductCard",
  componentId: "sc-1d50e6l-5"
})(["display:flex;"]);
const TextCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__TextCont",
  componentId: "sc-1d50e6l-6"
})(["display:flex;flex-direction:column;row-gap:2px;margin-left:12px;"]);
const DividerCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__DividerCont",
  componentId: "sc-1d50e6l-7"
})(["padding:12px 10px;hr{border:none;border-top:", ";margin:0;}"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`);
const SelectedTitle = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "CurrencyTypeSelectionstyles__SelectedTitle",
  componentId: "sc-1d50e6l-8"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
const SelectedTitleWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyTypeSelectionstyles__SelectedTitleWrapper",
  componentId: "sc-1d50e6l-9"
})(["display:flex;flex-direction:column;gap:4px;max-width:calc(100% - 60px);"]);

const unselectedProductIcons = [{
  type: 'static',
  url: 'https://tripmoneycmsimgak.mmtcdn.com/img/card_Faded_0fd3aa9296.png'
}, {
  type: 'static',
  url: 'https://tripmoneycmsimgak.mmtcdn.com/img/currency_Faded_02a7038489.png'
}];
const CurrencyTypeSelection = ({
  productSelectionData,
  productTypeData,
  selectedCurrency: _selectedCurrency = '',
  selectedProduct,
  showProductSelectionCard,
  setShowProductSelectionCard,
  onClick
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  const dispatch = useAppDispatch();
  const theme = React.useContext(styled.ThemeContext);
  const modalRef = React.useRef(null);
  const {
    selectedCurrencyCode,
    selectedProductType,
    amountDetails: {
      internationalCurrencyAmount
    }
  } = useAppSelector(state => state.forexProductData);
  const {
    data: listingApiData
  } = useAppSelector(state => state.listingApi);
  const {
    data: searchCurrencyData
  } = useAppSelector(state => state.searchCurrenciesApi);
  const {
    title,
    hint,
    bottomText
  } = productSelectionData !== null && productSelectionData !== void 0 ? productSelectionData : {};
  commonUi.useOutsideClick(modalRef, () => setShowProductSelectionCard(false), showProductSelectionCard);
  const isEmpty = value => {
    if (value == null) return true;
    if (Array.isArray(value) || typeof value === 'string') return value.length === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
  };
  const selectedCurrencyTitle = selectedProductType === commonUi.PRODUCT_TYPE.CURRENCY ? 'Currency Notes' : 'Forex Card';
  const selectedCurrencyTitleText = Array.isArray(selectedCurrencyTitle) ? selectedCurrencyTitle[0] && 'text' in selectedCurrencyTitle[0] && selectedCurrencyTitle[0].text : selectedCurrencyTitle;
  const selectedSubtextNode = ((_b = (_a = selectedProduct['currency']) === null || _a === void 0 ? void 0 : _a[_selectedCurrency]) === null || _b === void 0 ? void 0 : _b.selectedSubtextNode) || 'subtext1';
  const minInternationalCurrencyAmount = (_e = (_d = (_c = listingApiData.apiData) === null || _c === void 0 ? void 0 : _c.cardMinQtyConfig) === null || _d === void 0 ? void 0 : _d[_selectedCurrency]) === null || _e === void 0 ? void 0 : _e.min_amount;
  const memoizedProductTypeData = React.useMemo(() => {
    return productTypeData === null || productTypeData === void 0 ? void 0 : productTypeData.map(productItem => {
      var _a, _b, _c, _d, _e, _f;
      const exchangeRate = (_e = (_d = (_b = (_a = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.apiData) === null || _a === void 0 ? void 0 : _a.currencyInfo) === null || _b === void 0 ? void 0 : _b[(_c = productItem === null || productItem === void 0 ? void 0 : productItem.productType) !== null && _c !== void 0 ? _c : ''][_selectedCurrency]) === null || _d === void 0 ? void 0 : _d.rate) !== null && _e !== void 0 ? _e : 0;
      const totalAmountInInr = exchangeRate * internationalCurrencyAmount;
      const cashbackAmount = getCashbackAmount(totalAmountInInr, (_f = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.apiData) === null || _f === void 0 ? void 0 : _f.slabsData);
      const ner = getNetEffectiveRate(exchangeRate, cashbackAmount, totalAmountInInr);
      return coreUtils.hydrateVars(productItem, {
        [commonUi.RTVars.CURRENCY_CODE]: selectedCurrencyCode,
        [commonUi.RTVars.NER_RATE]: internationalCurrencyAmount > 0 ? coreUtils.toLocaleStringINRFormat(ner, 4, 4) : exchangeRate
      });
    });
  }, [productTypeData, listingApiData, _selectedCurrency, internationalCurrencyAmount, selectedCurrencyCode]);
  React.useEffect(() => {
    memoizedProductTypeData === null || memoizedProductTypeData === void 0 ? void 0 : memoizedProductTypeData.forEach(item => {
      if ((item === null || item === void 0 ? void 0 : item.productType) === selectedProductType) {
        onClick === null || onClick === void 0 ? void 0 : onClick(item);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internationalCurrencyAmount]);
  /* Start: Event Handlers */
  const chooseCurrencyHandler = item => {
    var _a, _b, _c;
    if ((item === null || item === void 0 ? void 0 : item.actionType) !== 'dispatch') {
      return;
    }
    const currencyCode = (_b = (_a = item === null || item === void 0 ? void 0 : item.dispatchArgs) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.currency;
    if (!currencyCode) {
      return;
    }
    const selectedCurrencyName = (_c = [...searchCurrencyData.popularCurrencyList, ...searchCurrencyData.otherCurrencies].find(currency => currency.currencyCode === currencyCode)) === null || _c === void 0 ? void 0 : _c.leftLabel;
    dispatch(setSelectedCurrency({
      selectedCurrencyCode: currencyCode,
      selectedCurrencyName: selectedCurrencyName
    }));
    if (currencyCode !== selectedCurrencyCode) {
      dispatch(setCurrencyChanged(true));
    }
    dispatch(fetchListingData({
      showLoader: false,
      selectedCurrencyCodes: [currencyCode],
      onLoading: state => {
        if (state === coreUtils.States.LOADING) {
          dispatch(showToastMessage({
            message: commonUi.TOAST_MESSAGES.CURRENCY_UPDATE,
            duration: 10000
          }));
        }
      },
      onSuccess: () => {
        dispatch(hideToastMessage());
      }
    }));
    setShowProductSelectionCard(false);
  };
  const handleProductSelectionClick = () => {
    setShowProductSelectionCard(true);
  };
  /* End: Event Handlers */
  const hintText = coreUtils.hydrateVars((_g = (_f = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.currency) === null || _f === void 0 ? void 0 : _f[_selectedCurrency]) === null || _g === void 0 ? void 0 : _g.title, {
    VARS_SELECTED_CURR: _selectedCurrency
  });
  return jsxRuntime.jsxs(CurrencyTypeContainer, {
    showProductSelectionCard: showProductSelectionCard,
    onClick: handleProductSelectionClick,
    children: [jsxRuntime.jsxs(HeaderContainer, {
      children: [jsxRuntime.jsx(designSystem.FormattedText, {
        text: title,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
        color: theme.colors.mediumEmphasis,
        margin: "0px 4px 0px 0px"
      }), jsxRuntime.jsx(designSystem.Image, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/down_Arrow_7c7fbc5e08.png",
        height: "24px",
        width: "24px"
      })]
    }), jsxRuntime.jsxs(OptionContainer, {
      children: [!isEmpty(selectedProduct) ? jsxRuntime.jsx(designSystem.Image, {
        src: (_h = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.icon) === null || _h === void 0 ? void 0 : _h.url,
        width: "38px",
        height: "36px"
      }) : unselectedProductIcons === null || unselectedProductIcons === void 0 ? void 0 : unselectedProductIcons.map((image, index) => jsxRuntime.jsx(designSystem.Image, {
        src: image === null || image === void 0 ? void 0 : image.url,
        width: "38px",
        height: "36px"
      }, index.toString())), jsxRuntime.jsxs(SelectedTitleWrapper, {
        children: [jsxRuntime.jsx(SelectedTitle, {
          text: !isEmpty(selectedProduct) ? selectedCurrencyTitleText === null || selectedCurrencyTitleText === void 0 ? void 0 : selectedCurrencyTitleText.toString() : hint,
          typography: designTokens.TYPOGRAPHY_KEYS.medium,
          color: theme.colors.highEmphasis,
          numberOfLines: 1
        }), !isEmpty(selectedProduct) && jsxRuntime.jsx(designSystem.FormattedText, {
          text: (_k = (_j = selectedProduct['currency']) === null || _j === void 0 ? void 0 : _j[_selectedCurrency]) === null || _k === void 0 ? void 0 : _k[selectedSubtextNode],
          typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
          color: theme.colors.mediumEmphasis
        })]
      })]
    }), isEmpty(selectedProduct) && jsxRuntime.jsx(designSystem.FormattedText, {
      text: bottomText,
      typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.mediumEmphasis,
      margin: "4px 0px 0px"
    }), showProductSelectionCard && jsxRuntime.jsx(ProductSelectionModalCont, {
      ref: modalRef,
      children: memoizedProductTypeData === null || memoizedProductTypeData === void 0 ? void 0 : memoizedProductTypeData.map((productItem, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const hydratedTitle = coreUtils.hydrateVars((_b = (_a = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _a === void 0 ? void 0 : _a[_selectedCurrency]) === null || _b === void 0 ? void 0 : _b.title, {
          VARS_SELECTED_CURR: _selectedCurrency
        });
        return jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [jsxRuntime.jsx(SelectionCardCont, {
            disabled: (_d = (_c = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _c === void 0 ? void 0 : _c[_selectedCurrency]) === null || _d === void 0 ? void 0 : _d.disabled,
            onClick: event => {
              var _a, _b, _c;
              event.stopPropagation();
              if (productItem && !((_b = (_a = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _a === void 0 ? void 0 : _a[_selectedCurrency]) === null || _b === void 0 ? void 0 : _b.disabled)) {
                dispatch(showToastMessage({
                  message: commonUi.TOAST_MESSAGES.RATE_UPDATE,
                  duration: 2000
                }));
                pdtUtils.trackEvent({
                  eventData: (_c = productItem === null || productItem === void 0 ? void 0 : productItem.analytics) === null || _c === void 0 ? void 0 : _c.pdtData
                });
                onClick === null || onClick === void 0 ? void 0 : onClick(productItem);
                setShowProductSelectionCard(false);
              }
            },
            isChecked: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productType) === (productItem === null || productItem === void 0 ? void 0 : productItem.productType),
            children: jsxRuntime.jsxs(ProductCard, {
              children: [jsxRuntime.jsx(designSystem.Image, {
                src: (_e = productItem === null || productItem === void 0 ? void 0 : productItem.icon) === null || _e === void 0 ? void 0 : _e.url,
                width: "40px",
                height: "40px"
              }), jsxRuntime.jsxs(TextCont, {
                children: [jsxRuntime.jsx(designSystem.FormattedText, {
                  color: theme.colors.highEmphasis,
                  typography: designTokens.TYPOGRAPHY_KEYS.smallW3,
                  text: hydratedTitle
                }), jsxRuntime.jsx(designSystem.FormattedText, {
                  typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
                  color: theme.colors.lowEmphasis,
                  text: (_g = (_f = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _f === void 0 ? void 0 : _f[_selectedCurrency]) === null || _g === void 0 ? void 0 : _g.subtitle
                }), internationalCurrencyAmount > 0 && minInternationalCurrencyAmount !== undefined && minInternationalCurrencyAmount > internationalCurrencyAmount && jsxRuntime.jsx(designSystem.FormattedText, {
                  typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
                  color: theme.colors.lowEmphasis,
                  text: (_j = (_h = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _h === void 0 ? void 0 : _h[_selectedCurrency]) === null || _j === void 0 ? void 0 : _j.minimumQuantityWarning
                }), jsxRuntime.jsx(designSystem.FormattedText, {
                  typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
                  color: theme.colors.lowEmphasis,
                  text: (_l = (_k = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _k === void 0 ? void 0 : _k[_selectedCurrency]) === null || _l === void 0 ? void 0 : _l.subtext1
                }), jsxRuntime.jsx(designSystem.FormattedText, {
                  typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
                  color: theme.colors.lowEmphasis,
                  text: (_o = (_m = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _m === void 0 ? void 0 : _m[_selectedCurrency]) === null || _o === void 0 ? void 0 : _o.subtext2
                }), jsxRuntime.jsx(designSystem.FormattedText, {
                  onClick: (item, event) => {
                    chooseCurrencyHandler(item);
                  },
                  typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
                  color: theme.colors.lowEmphasis,
                  text: (_q = (_p = productItem === null || productItem === void 0 ? void 0 : productItem.currency) === null || _p === void 0 ? void 0 : _p[_selectedCurrency]) === null || _q === void 0 ? void 0 : _q.bottomText
                })]
              })]
            })
          }), index !== (memoizedProductTypeData === null || memoizedProductTypeData === void 0 ? void 0 : memoizedProductTypeData.length) - 1 && jsxRuntime.jsx(DividerCont, {
            children: jsxRuntime.jsx("hr", {})
          })]
        });
      })
    }), hintText && jsxRuntime.jsx(HintTextWrapper$1, {
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: hintText,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1
      })
    })]
  });
};

const WidgetsContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyWidgetsDwebstyles__WidgetsContainer",
  componentId: "sc-6bp0qz-0"
})(["display:flex;border:", ";border-radius:", ";margin:", ";"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`, ({
  theme
}) => theme.borderRadius.br10, ({
  margin
}) => margin);
const ButtonCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyWidgetsDwebstyles__ButtonCont",
  componentId: "sc-6bp0qz-1"
})(["display:flex;justify-content:center;position:absolute;left:0;bottom:-21px;width:100%;"]);
const BuyNowButton = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "CurrencyWidgetsDwebstyles__BuyNowButton",
  componentId: "sc-6bp0qz-2"
})(["width:239px;border-radius:", ";"], ({
  theme
}) => theme.borderRadius.br20);
const DeliveryWraper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyWidgetsDwebstyles__DeliveryWraper",
  componentId: "sc-6bp0qz-3"
})(["display:flex;align-items:flex-start;justify-content:space-between;margin:", ";"], ({
  margin
}) => margin);
const RightAlignedContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CurrencyWidgetsDwebstyles__RightAlignedContainer",
  componentId: "sc-6bp0qz-5"
})(["display:flex;flex-direction:column;align-items:flex-end;gap:8px;flex-shrink:0;"]);

const HintTextWrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliverAtSelectionstyles__HintTextWrapper",
  componentId: "fna0uc-0"
})(["position:absolute;top:85%;left:20px;background-color:", ";padding:8px 12px;font-size:14px;border-radius:4px;white-space:nowrap;box-shadow:0px 1px 7px 0px #00000033;display:none;z-index:2;"], ({
  theme
}) => theme.colors.lightBlue);
const DeliverAtContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliverAtSelectionstyles__DeliverAtContainer",
  componentId: "fna0uc-1"
})(["border-right:", ";display:flex;flex-direction:column;width:187px;padding:12px 20px;position:relative;background:", ";flex-shrink:0;&:hover{background-color:", ";}cursor:pointer;position:relative;&:hover ", "{display:block;}border-radius:7px 0 0 7px;"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`, ({
  theme,
  showPincodePopup
}) => showPincodePopup && theme.colors.lightBlue, ({
  theme
}) => theme.colors.lightBlue, HintTextWrapper);
const DeliverAtPincodeModal = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "DeliverAtSelectionstyles__DeliverAtPincodeModal",
  componentId: "fna0uc-2"
})(["position:absolute;top:44px;left:20px;z-index:3;"]);
const SelectedLocationText = /*#__PURE__*/styled__default.default(designSystem.FormattedText).withConfig({
  displayName: "DeliverAtSelectionstyles__SelectedLocationText",
  componentId: "fna0uc-3"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

const DeliverAtSelection = ({
  deliverAtSelectionData,
  bottomSheets
}) => {
  const dispatch = useAppDispatch();
  const {
    error: locationApiError,
    data: locationApiData
  } = useAppSelector(state => state.locationApi);
  const [showPincodePopup, setShowPincodePopup] = React.useState(false);
  const {
    bottomText,
    title,
    cta
  } = deliverAtSelectionData !== null && deliverAtSelectionData !== void 0 ? deliverAtSelectionData : {};
  const theme = React.useContext(styled.ThemeContext);
  const pincodeBottomSheetModalId = cta === null || cta === void 0 ? void 0 : cta.modalId;
  const pincodeBottomSheetData = pincodeBottomSheetModalId ? bottomSheets === null || bottomSheets === void 0 ? void 0 : bottomSheets[pincodeBottomSheetModalId] : null;
  const modalRef = React.useRef(null);
  commonUi.useOutsideClick(modalRef, () => {
    if (locationApiData || locationApiError) dispatch(resetLocationApiData());
    setShowPincodePopup(false);
  }, showPincodePopup);
  return jsxRuntime.jsxs(DeliverAtContainer, {
    showPincodePopup: showPincodePopup,
    onClick: () => setShowPincodePopup(true),
    children: [jsxRuntime.jsx(designSystem.FormattedText, {
      text: title,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
      color: theme.colors.mediumEmphasis
    }), jsxRuntime.jsx(SelectedLocationText, {
      text: deliverAtSelectionData === null || deliverAtSelectionData === void 0 ? void 0 : deliverAtSelectionData.default,
      typography: designTokens.TYPOGRAPHY_KEYS.large30,
      color: theme.colors.highEmphasis,
      margin: '10px 0px 0px'
    }), jsxRuntime.jsx(HintTextWrapper, {
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: deliverAtSelectionData === null || deliverAtSelectionData === void 0 ? void 0 : deliverAtSelectionData.default,
        color: theme.colors.mediumEmphasis,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1
      })
    }), jsxRuntime.jsx(designSystem.FormattedText, {
      text: bottomText,
      typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
      color: theme.colors.mediumEmphasis
    }), showPincodePopup && pincodeBottomSheetData && jsxRuntime.jsx(DeliverAtPincodeModal, {
      ref: modalRef,
      children: jsxRuntime.jsx(PincodeBottomSheet, {
        data: pincodeBottomSheetData,
        setShowPincodePopup: setShowPincodePopup
      })
    })]
  });
};

const useUpdateExchangeRateAndAmountDetails = () => {
  const dispatch = useAppDispatch();
  const {
    data: listingData
  } = useAppSelector(state => state.listingApi);
  const {
    selectedCurrencyCode,
    exchangeRate,
    selectedProductType,
    amountDetails: {
      internationalCurrencyAmount
    }
  } = useAppSelector(state => state.forexProductData);
  const {
    slabsData,
    currencyInfo
  } = (listingData === null || listingData === void 0 ? void 0 : listingData.apiData) || {};
  React.useEffect(() => {
    if (currencyInfo && selectedCurrencyCode) {
      const rate = getExchangeRate(currencyInfo, selectedCurrencyCode, selectedProductType);
      dispatch(setExchangeRate(rate));
    }
  }, [dispatch, currencyInfo, selectedCurrencyCode, selectedProductType]);
  React.useEffect(() => {
    if (exchangeRate && slabsData && (slabsData === null || slabsData === void 0 ? void 0 : slabsData.length) > 0) {
      const bestNer = getBestNetEffectiveRate(exchangeRate, slabsData);
      dispatch(setBestNetEffectiveRate(bestNer));
    }
  }, [dispatch, slabsData, exchangeRate]);
  React.useEffect(() => {
    const totalAmountInInr = internationalCurrencyAmount * exchangeRate;
    const cashbackAmount = getCashbackAmount(totalAmountInInr, slabsData);
    const ner = getNetEffectiveRate(exchangeRate, cashbackAmount, totalAmountInInr);
    const nefAmountOnTotalValue = totalAmountInInr - cashbackAmount;
    dispatch(setAmountDetails({
      internationalCurrencyAmount: exchangeRate > 0 ? internationalCurrencyAmount : 0,
      totalAmountInInr,
      netEffectiveRate: ner,
      netEffectiveAmountOnTotalValue: nefAmountOnTotalValue,
      cashbackAmount
    }));
  }, [internationalCurrencyAmount, exchangeRate, slabsData, dispatch]);
};

const StickyNudgeBody = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "StickyPricingNudgestyles__StickyNudgeBody",
  componentId: "oafq5l-0"
})(["display:flex;gap:4px;margin:16px 0px 9px 0px;align-items:center;"]);

const StickyPricingNudgeBottomSheet = ({
  data,
  onModalClose
}) => {
  var _a;
  const device = commonUi.useDevice();
  const theme = React.useContext(styled.ThemeContext);
  React.useEffect(() => {
    var _a;
    pdtUtils.trackEvent({
      eventData: (_a = data === null || data === void 0 ? void 0 : data.analytics) === null || _a === void 0 ? void 0 : _a.pdtData
    });
  }, []);
  return jsxRuntime.jsx(designSystem.Modal, {
    modalType: device === commonUi.DEVICE.DESKTOP ? 'centered' : 'bottomSheet',
    onModalClose: onModalClose,
    heading: data === null || data === void 0 ? void 0 : data.title,
    modalMaxHeight: device === commonUi.DEVICE.MOBILE ? 'calc(100vh - 200px)' : 'auto',
    children: jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [jsxRuntime.jsx(designSystem.FormattedText, {
        text: data === null || data === void 0 ? void 0 : data.description,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
        color: theme.colors.mediumEmphasis
      }), jsxRuntime.jsx(designSystem.Button, {
        label: (_a = data === null || data === void 0 ? void 0 : data.cta) === null || _a === void 0 ? void 0 : _a.text,
        onClick: onModalClose,
        variant: "contained",
        margin: "12px 0px 0px"
      })]
    })
  });
};

const StickyPricingNudge = ({
  nudgeData,
  bottomSheets
}) => {
  var _a, _b, _c, _d;
  const [isInfoModalOpen, setIsInfoModalOpen] = React.useState(false);
  const {
    leftIcon,
    text,
    info
  } = nudgeData || {};
  const handleInfoIconClick = () => {
    var _a, _b;
    pdtUtils.trackEvent({
      eventData: (_b = (_a = info === null || info === void 0 ? void 0 : info.cta) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.pdtData
    });
    setIsInfoModalOpen(true);
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(StickyNudgeBody, {
      children: [jsxRuntime.jsx(designSystem.Image, {
        src: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.url,
        alt: "static",
        width: "24px",
        height: "24px"
      }), text && jsxRuntime.jsx(designSystem.FormattedText, {
        text: text,
        typography: designTokens.TYPOGRAPHY_KEYS.smallW1
      }), jsxRuntime.jsx(designSystem.Image, {
        src: (_a = info === null || info === void 0 ? void 0 : info.icon) === null || _a === void 0 ? void 0 : _a.url,
        alt: "info",
        width: "16px",
        height: "16px",
        onClick: handleInfoIconClick,
        showCursorPointer: true
      })]
    }), isInfoModalOpen && ((_b = info === null || info === void 0 ? void 0 : info.cta) === null || _b === void 0 ? void 0 : _b.modalId) && bottomSheets[(_c = info === null || info === void 0 ? void 0 : info.cta) === null || _c === void 0 ? void 0 : _c.modalId] && jsxRuntime.jsx(StickyPricingNudgeBottomSheet, {
      data: bottomSheets[(_d = info === null || info === void 0 ? void 0 : info.cta) === null || _d === void 0 ? void 0 : _d.modalId],
      onModalClose: () => setIsInfoModalOpen(false)
    })]
  });
};

const initialState = {
  apiState: coreUtils.States.PRELOADING,
  data: null,
  error: null
};
const fetchSearchContextData = toolkit.createAsyncThunk('searchContext/fetchSearchContextData', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({
  requestBody
}, {
  rejectWithValue,
  getState
}) {
  var _c, _d, _e;
  const {
    sendPdtData
  } = getPdtLoggerMethods({
    state: getState()
  });
  const apiUrl = `${BFF_BASE_URL}/api/v1/page/listing/search-context`;
  const reqId = getRequestId();
  try {
    const defaultHeaders = coreUtils.getDefaultHeaders();
    const response = yield coreUtils.fetchWithTimeout(apiUrl, {
      method: 'POST',
      headers: Object.assign(Object.assign({}, defaultHeaders), {
        [HEADERS.REQUEST_ID]: reqId
      }),
      body: JSON.stringify(requestBody)
    });
    const responseObj = yield response.json();
    if ((responseObj === null || responseObj === void 0 ? void 0 : responseObj.success) && ((_c = responseObj === null || responseObj === void 0 ? void 0 : responseObj.data) === null || _c === void 0 ? void 0 : _c.success)) {
      return responseObj;
    } else {
      const pdtData = {
        event_detail: {
          vendor_error_details: pdtUtils.getVendorErrorDetails({
            error_code: (_d = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error) === null || _d === void 0 ? void 0 : _d.code,
            error_message_shown: ((_e = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error) === null || _e === void 0 ? void 0 : _e.message) || 'Something went wrong',
            api_url: apiUrl
          })
        },
        event_tracking_context: pdtUtils.getEventTrackingContext({
          request_id: reqId
        })
      };
      sendPdtData(pdtData);
      return rejectWithValue(responseObj !== null && responseObj !== void 0 ? responseObj : 'Something went wrong');
    }
  } catch (error) {
    const pdtData = {
      event_detail: {
        vendor_error_details: pdtUtils.getVendorErrorDetails({
          error_code: error === null || error === void 0 ? void 0 : error.code,
          error_message_shown: (error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong',
          api_url: apiUrl
        })
      },
      event_tracking_context: pdtUtils.getEventTrackingContext({
        request_id: reqId
      })
    };
    sendPdtData(pdtData);
    return rejectWithValue((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong');
  }
}));
const searchContextSlice = toolkit.createSlice({
  name: 'searchContext',
  initialState,
  reducers: {
    resetSearchContextData: () => {
      return initialState;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchSearchContextData.pending, state => {
      state.apiState = coreUtils.States.LOADING;
      state.error = null;
      state.data = null;
    }).addCase(fetchSearchContextData.fulfilled, (state, action) => {
      state.apiState = coreUtils.States.SUCCESS;
      state.data = action.payload;
      state.error = null;
    }).addCase(fetchSearchContextData.rejected, (state, action) => {
      state.apiState = coreUtils.States.FAILURE;
      state.error = action.payload;
      state.data = null;
    });
  }
});
const {
  resetSearchContextData
} = searchContextSlice.actions;
searchContextSlice.reducer;

const CurrencyWidgetsDweb = ({
  componentData,
  bottomSheets,
  deliveryPersuasionData,
  resumeOrderData,
  stickyPricingNudge,
  margin,
  offerPersuasionData
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  const {
    deliverAtSelection,
    currencySelection,
    amountSelectionForex,
    amountSelectionInr,
    productSelection,
    productItems,
    cta
  } = (_a = componentData === null || componentData === void 0 ? void 0 : componentData.data) !== null && _a !== void 0 ? _a : {};
  const [selectedProduct, setSelectedProduct] = React.useState({});
  const [isAmountError, setAmountError] = React.useState(false);
  const [isQuantityEmptyError, setQuantityEmptyError] = React.useState(false);
  const [forexErrorMessage, setForexErrorMessage] = React.useState('');
  const [isAmountReset, setIsAmountReset] = React.useState(false);
  const [showProductSelectionCard, setShowProductSelectionCard] = React.useState(false);
  const {
    redirectionDeferTime
  } = useAppSelector(state => {
    var _a;
    return ((_a = state.listingApi.data) === null || _a === void 0 ? void 0 : _a.pageConfig) || {};
  });
  const {
    apiData: listingApiData
  } = useAppSelector(selectListingApiData);
  const analyticsData = useAppSelector(state => {
    var _a;
    return (_a = state.listingApi.data) === null || _a === void 0 ? void 0 : _a.analytics;
  });
  const {
    source_type
  } = useAppSelector(state => state.pageContext);
  const listingErrorMessages = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.errorMessages;
  useUpdateExchangeRateAndAmountDetails();
  const dispatch = useAppDispatch();
  const {
    selectedCurrencyCode,
    selectedProductType,
    exchangeRate,
    amountDetails: {
      internationalCurrencyAmount,
      totalAmountInInr
    }
  } = useAppSelector(selectForexProductData);
  const recommendedProduct = useAppSelector(state => selectRecommendedProduct(state, productItems));
  const buyNowCta = (_b = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.cta) !== null && _b !== void 0 ? _b : cta;
  const minOrderInfo = getMinOrderInfo(selectedProductType, listingApiData || {}, selectedCurrencyCode);
  const filteredProductItems = productItems === null || productItems === void 0 ? void 0 : productItems.map(item => {
    var _a;
    const currencyDetail = (_a = item === null || item === void 0 ? void 0 : item.currency) === null || _a === void 0 ? void 0 : _a[selectedCurrencyCode];
    if (currencyDetail) {
      return Object.assign(Object.assign({}, item), {
        currency: {
          [selectedCurrencyCode]: currencyDetail
        }
      });
    }
    return item;
  });
  getPdtLoggerMethods({
    state: useAppSelector(state => state)
  });
  React.useEffect(() => {
    if ((amountSelectionForex === null || amountSelectionForex === void 0 ? void 0 : amountSelectionForex.amount) && !isAmountReset) {
      dispatch(setInternationalCurrencyAmount(amountSelectionForex === null || amountSelectionForex === void 0 ? void 0 : amountSelectionForex.amount));
    }
  }, [amountSelectionForex === null || amountSelectionForex === void 0 ? void 0 : amountSelectionForex.amount, exchangeRate, isAmountReset]);
  React.useEffect(() => {
    if (!selectedProductType) {
      setSelectedProduct({});
    }
    if (selectedProductType) {
      setForexErrorMessage('');
    }
  }, [selectedProductType]);
  React.useEffect(() => {
    if (recommendedProduct) {
      handleProductSelect(coreUtils.hydrateVars(recommendedProduct), true); // preserve amount for recommended product
    } else {
      setSelectedProduct({});
      setAmountError(false);
      setQuantityEmptyError(false);
      setForexErrorMessage('');
    }
  }, [recommendedProduct]);
  /*Start: Event Handlers */
  const handleProductSelect = (productItem, preserveAmount = false) => {
    dispatch(setProductType(productItem === null || productItem === void 0 ? void 0 : productItem.productType));
    if (!preserveAmount) {
      dispatch(resetAmountDetails());
      setIsAmountReset(true);
    }
    setSelectedProduct(productItem !== null && productItem !== void 0 ? productItem : {});
  };
  const storeSearchContext = source => {
    storeSearchContextToSessionStorage({
      source,
      timestamp: Date.now(),
      selectedCards: [{
        currency: selectedCurrencyCode,
        inrValue: totalAmountInInr,
        quantity: internationalCurrencyAmount
      }]
    });
  };
  const onResumeOrderClickHandler = () => {
    storeSearchContext(commonUi.REDIRECTION_SOURCE.LISTING_RESUME_ORDER);
  };
  const fallbackCurrency = ((_j = (_h = (_g = (_f = (_e = (_d = (_c = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.currencyInfo) === null || _c === void 0 ? void 0 : _c[selectedProductType || 'PC']) === null || _d === void 0 ? void 0 : _d[selectedCurrencyCode]) === null || _e === void 0 ? void 0 : _e.persuasions) === null || _f === void 0 ? void 0 : _f.find(item => item.type === commonUi.PERSUASION_TYPE.UNSUPPORTED_PRODUCT_WITH_FWD_ACTION_PC)) === null || _g === void 0 ? void 0 : _g.variables) === null || _h === void 0 ? void 0 : _h.FALLBACK_CURRENCY) === null || _j === void 0 ? void 0 : _j.value) || commonUi.FALLBACK_CURRENCY.USD;
  const isTemporarilyUnavailable = ((_o = (_m = (_l = (_k = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.currencyInfo) === null || _k === void 0 ? void 0 : _k[selectedProductType || 'PC']) === null || _l === void 0 ? void 0 : _l[selectedCurrencyCode]) === null || _m === void 0 ? void 0 : _m.persuasions) === null || _o === void 0 ? void 0 : _o.some(item => item.type === commonUi.PERSUASION_TYPE.UNAVAILABLE_PRODUCT_PC || item.type === commonUi.PERSUASION_TYPE.UNSUPPORTED_PRODUCT_PC)) || false;
  const onBuyClickHandler = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const bookingInfo = {
      orders_items: [{
        exchange_rate: exchangeRate,
        product_code: selectedProductType,
        to_amount: internationalCurrencyAmount === null || internationalCurrencyAmount === void 0 ? void 0 : internationalCurrencyAmount.toString(),
        total_amount_inr: totalAmountInInr === null || totalAmountInInr === void 0 ? void 0 : totalAmountInInr.toString(),
        to_curr_code: selectedCurrencyCode
      }]
    };
    let isValidProduct = false;
    if (buyNowCta === null || buyNowCta === void 0 ? void 0 : buyNowCta.isDisabled) {
      dispatch(showToastMessage({
        showToast: true,
        message: coreUtils.hydrateVars(commonUi.TOAST_MESSAGES.CURRENCY_NOT_SERVICEABLE, {
          FALLBACK_CURRENCY: fallbackCurrency
        }),
        showCrossIcon: true,
        duration: 6000,
        // default duration in milliseconds
        rightText: 'OKAY'
      }));
    } else if (!selectedProductType) {
      setShowProductSelectionCard(true);
    } else if (internationalCurrencyAmount <= 0) {
      setQuantityEmptyError(true);
      setAmountError(false);
    } else if (internationalCurrencyAmount < ((minOrderInfo === null || minOrderInfo === void 0 ? void 0 : minOrderInfo.min_amount) || 0) && selectedProductType === commonUi.PRODUCT_TYPE.CARD) {
      setAmountError(true);
      setQuantityEmptyError(false);
      setForexErrorMessage(coreUtils.hydrateVars(listingErrorMessages === null || listingErrorMessages === void 0 ? void 0 : listingErrorMessages.currencyAmountError, Object.assign({}, minOrderInfo)));
    } else if (internationalCurrencyAmount % ((minOrderInfo === null || minOrderInfo === void 0 ? void 0 : minOrderInfo.min_denomination) || 0) !== 0 && selectedProductType === commonUi.PRODUCT_TYPE.CURRENCY) {
      setAmountError(true);
      setQuantityEmptyError(false);
      setForexErrorMessage(coreUtils.hydrateVars(listingErrorMessages === null || listingErrorMessages === void 0 ? void 0 : listingErrorMessages.quantityError, Object.assign({}, minOrderInfo)));
    } else if (selectedProductType && ((_a = listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.maxAmount) === null || _a === void 0 ? void 0 : _a[selectedProductType]) && (listingApiData === null || listingApiData === void 0 ? void 0 : listingApiData.maxAmount[selectedProductType]) < totalAmountInInr) {
      const maxAmountErrorMessage = getMaxAmountErrorMessage(selectedProductType, listingApiData);
      dispatch(showToastMessage({
        showToast: true,
        message: maxAmountErrorMessage,
        showCrossIcon: true,
        duration: 6000,
        rightText: 'OKAY'
      }));
    } else {
      const {
        cityCode
      } = getDeliveryData();
      isValidProduct = true;
      yield dispatch(fetchExpressRTData({
        requestBody: {
          source: commonUi.REDIRECTION_SOURCE.LISTING_BUY_NOW,
          current_city: cityCode,
          product: selectedProductType,
          trip_details: {
            country: '',
            currency: selectedCurrencyCode,
            amount: internationalCurrencyAmount === null || internationalCurrencyAmount === void 0 ? void 0 : internationalCurrencyAmount.toString()
          }
        }
      }));
      yield dispatch(fetchSearchContextData({
        requestBody: {
          productType: selectedProductType,
          currenciesContext: [{
            currency: selectedCurrencyCode,
            quantity: internationalCurrencyAmount === null || internationalCurrencyAmount === void 0 ? void 0 : internationalCurrencyAmount.toString()
          }]
        }
      }));
      storeSearchContext(commonUi.REDIRECTION_SOURCE.LISTING_BUY_NOW);
      const buyNowCtaDeeplink = (_b = buyNowCta === null || buyNowCta === void 0 ? void 0 : buyNowCta.deeplink) !== null && _b !== void 0 ? _b : cta === null || cta === void 0 ? void 0 : cta.deeplink;
      if (buyNowCtaDeeplink && internationalCurrencyAmount) {
        redirectWithDeferredTime(() => {
          var _a;
          const urlWithQuantity = buyNowCtaDeeplink.replace(`{{${commonUi.RTVars.CURR_QTY}}}`, coreUtils.roundWithoutDecimal(internationalCurrencyAmount));
          // Extract UTM params from analytics data
          const pageContext = (_a = analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.pdtData) === null || _a === void 0 ? void 0 : _a.page_context;
          const queryParams = {};
          if (pageContext) {
            if (pageContext.utm_source) queryParams.utm_source = pageContext.utm_source;
            if (pageContext.utm_medium) queryParams.utm_medium = pageContext.utm_medium;
            // Only add utm_campaign for SEO source types
            if (isSeoSourceType(source_type)) {
              queryParams.utm_campaign = coreUtils.getLastUrlSegment();
            }
          }
          redirectTo(urlWithQuantity, queryParams);
        }, redirectionDeferTime);
      }
    }
    const pdtData = Object.assign(Object.assign(Object.assign({}, (_d = (_c = buyNowCta === null || buyNowCta === void 0 ? void 0 : buyNowCta.analytics) === null || _c === void 0 ? void 0 : _c.pdtData) === null || _d === void 0 ? void 0 : _d.event_detail), !isValidProduct && {
      flow: selectedProductType ? 'amount_required' : 'product_required'
    }), {
      booking_info: bookingInfo
    });
    pdtUtils.trackEvent({
      eventData: {
        event_detail: pdtData
      },
      shouldFlushEvents: true
    });
  });
  const handleAmountError = error => {
    setAmountError(error);
    setQuantityEmptyError(error);
  };
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [stickyPricingNudge ? jsxRuntime.jsx(StickyPricingNudge, {
      nudgeData: stickyPricingNudge,
      bottomSheets: bottomSheets
    }) : jsxRuntime.jsx(jsxRuntime.Fragment, {}), jsxRuntime.jsxs(WidgetsContainer, {
      margin: margin,
      children: [deliverAtSelection && jsxRuntime.jsx(DeliverAtSelection, {
        deliverAtSelectionData: deliverAtSelection,
        bottomSheets: bottomSheets
      }), currencySelection && jsxRuntime.jsx(CurrencySelection, {
        currencySelectionData: currencySelection,
        bottomSheets: bottomSheets
      }), !!productSelection && jsxRuntime.jsx(CurrencyTypeSelection, {
        productSelectionData: productSelection,
        productTypeData: filteredProductItems,
        selectedCurrency: selectedCurrencyCode,
        selectedProduct: selectedProduct,
        showProductSelectionCard: showProductSelectionCard,
        setShowProductSelectionCard: setShowProductSelectionCard,
        onClick: handleProductSelect
      }), amountSelectionForex && jsxRuntime.jsx(AmountSelectionForex, {
        amountSelectionData: amountSelectionForex,
        errorMessage: isQuantityEmptyError ? '' : forexErrorMessage,
        isError: isAmountError || isQuantityEmptyError,
        setAmountError: handleAmountError,
        showProductSelectionCard: showProductSelectionCard
      }), amountSelectionInr && jsxRuntime.jsx(AmountSelectionInr, {
        amountSelectionData: amountSelectionInr,
        bottomSheets: bottomSheets,
        isError: isQuantityEmptyError,
        setAmountError: handleAmountError
      })]
    }), jsxRuntime.jsxs(DeliveryWraper, {
      margin: "10px 0 0 0",
      children: [jsxRuntime.jsx(DeliveryPersuasion, {
        componentData: deliveryPersuasionData,
        bottomSheets: bottomSheets
      }), jsxRuntime.jsxs(RightAlignedContainer, {
        children: [offerPersuasionData && jsxRuntime.jsx(OfferPersuasion, {
          componentData: offerPersuasionData,
          bottomSheets: bottomSheets
        }), jsxRuntime.jsx(ResumeOrder, {
          componentData: resumeOrderData,
          onClick: onResumeOrderClickHandler
        })]
      })]
    }), jsxRuntime.jsx(ButtonCont, {
      children: jsxRuntime.jsx(BuyNowButton, {
        variant: "contained",
        label: buyNowCta === null || buyNowCta === void 0 ? void 0 : buyNowCta.text,
        disabled: isTemporarilyUnavailable,
        onClick: onBuyClickHandler
      })
    })]
  });
};

const CenterWidgetCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CenterWidgetstyles__CenterWidgetCont",
  componentId: "sc-1hr5jzj-0"
})(["display:flex;align-items:center;justify-content:center;width:100%;"]);
const IconContainer$1 = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CenterWidgetstyles__IconContainer",
  componentId: "sc-1hr5jzj-1"
})(["position:relative;"]);
const IconBadge = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CenterWidgetstyles__IconBadge",
  componentId: "sc-1hr5jzj-2"
})(["position:absolute;right:0;bottom:0;background:", ";padding:0px 3px;border-radius:12px;"], ({
  theme
}) => theme.colors.white);
const TextContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CenterWidgetstyles__TextContainer",
  componentId: "sc-1hr5jzj-3"
})(["display:flex;flex-direction:column;margin:0px 16px 0px 6px;"]);
const CenterWidgetButton = /*#__PURE__*/styled__default.default(designSystem.Button).withConfig({
  displayName: "CenterWidgetstyles__CenterWidgetButton",
  componentId: "sc-1hr5jzj-4"
})(["padding:0;width:unset;cursor:pointer;"]);
const OrderStatusCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CenterWidgetstyles__OrderStatusCont",
  componentId: "sc-1hr5jzj-5"
})(["position:fixed;z-index:10;"]);
// Base styles shared by all variants
const BaseCenterWidgetContInnr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "CenterWidgetstyles__BaseCenterWidgetContInnr",
  componentId: "sc-1hr5jzj-6"
})(["padding:16px 40px;border-radius:36px;display:flex;align-items:center;background:", ";position:relative;&.elevation{z-index:12;pointer-events:none;}"], ({
  theme,
  hasData
}) => hasData ? theme.colors.white : 'transparent');
// Normal (non-SEO) view
const NormalCenterWidgetContInnr = /*#__PURE__*/styled__default.default(BaseCenterWidgetContInnr).withConfig({
  displayName: "CenterWidgetstyles__NormalCenterWidgetContInnr",
  componentId: "sc-1hr5jzj-7"
})(["margin:", ";"], ({
  hasData
}) => hasData ? '60px auto 40px' : '60px auto 0');
// SEO view (covers both SEO and bot cases)
const SeoCenterWidgetContInnr = /*#__PURE__*/styled__default.default(BaseCenterWidgetContInnr).withConfig({
  displayName: "CenterWidgetstyles__SeoCenterWidgetContInnr",
  componentId: "sc-1hr5jzj-8"
})(["margin:0px auto;"]);
// Clean React component that selects the appropriate styled component
const CenterWidgetContInnr = /*#__PURE__*/React__namespace.default.forwardRef((_a, ref) => {
  var {
      source_type,
      hasData,
      children
    } = _a,
    props = __rest(_a, ["source_type", "hasData", "children"]);
  if (isSeoSourceType(source_type)) {
    return jsxRuntime.jsx(SeoCenterWidgetContInnr, Object.assign({
      ref: ref,
      hasData: hasData
    }, props, {
      children: children
    }));
  }
  return jsxRuntime.jsx(NormalCenterWidgetContInnr, Object.assign({
    ref: ref,
    hasData: hasData
  }, props, {
    children: children
  }));
});
CenterWidgetContInnr.displayName = 'CenterWidgetContInnr';

const Wrapper = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__Wrapper",
  componentId: "sc-1ae5z2n-0"
})(["width:340px;border-radius:16px;overflow:hidden;"]);
const Header = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__Header",
  componentId: "sc-1ae5z2n-1"
})(["padding:4px 0px 4px 16px;background:linear-gradient(45deg,#f5cf51 0%,#9f4504 100%);"]);
const Content = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__Content",
  componentId: "sc-1ae5z2n-2"
})(["padding:16px 11px;background:#fff7e4;display:flex;border:1px solid #ffd590;border-bottom-left-radius:16px;border-bottom-right-radius:16px;"]);
const IconContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__IconContainer",
  componentId: "sc-1ae5z2n-3"
})(["position:relative;width:32px;"]);
const Badge = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__Badge",
  componentId: "sc-1ae5z2n-4"
})(["position:absolute;right:-2px;top:-6px;background:", ";padding:0px 4px 1px 4px;border-radius:3px;"], ({
  theme
}) => '#EB2226');
const OrdersContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__OrdersContainer",
  componentId: "sc-1ae5z2n-5"
})(["margin-top:-10px;margin-left:8px;"]);
const OrderTitle = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__OrderTitle",
  componentId: "sc-1ae5z2n-6"
})(["display:flex;column-gap:12px;margin-top:", ";"], props => props.hasMargin ? '8px' : '0px');
const OrderRow = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "OrderStatusstyles__OrderRow",
  componentId: "sc-1ae5z2n-7"
})(["&:hover{background-color:", ";border-radius:8px;}padding:8px 4px;cursor:pointer;"], ({
  theme
}) => '#FFEDD1');

const OrderStatus = ({
  componentData,
  margin
}) => {
  var _a;
  const {
    heading,
    orders,
    icon
  } = (_a = componentData === null || componentData === void 0 ? void 0 : componentData.data) !== null && _a !== void 0 ? _a : {};
  const theme = React.useContext(styled.ThemeContext);
  return jsxRuntime.jsxs(Wrapper, {
    children: [jsxRuntime.jsx(Header, {
      children: jsxRuntime.jsx(designSystem.FormattedText, {
        text: heading,
        color: theme.colors.white,
        typography: designTokens.TYPOGRAPHY_KEYS.baseW3
      })
    }), jsxRuntime.jsxs(Content, {
      children: [jsxRuntime.jsxs(IconContainer, {
        children: [jsxRuntime.jsx(designSystem.Image, {
          src: icon === null || icon === void 0 ? void 0 : icon.url,
          height: "21px",
          width: "20px"
        }), jsxRuntime.jsx(Badge, {
          children: jsxRuntime.jsx(designSystem.FormattedText, {
            text: orders === null || orders === void 0 ? void 0 : orders.length.toString(),
            color: theme.colors.white,
            typography: designTokens.TYPOGRAPHY_KEYS.baseW2
          })
        })]
      }), jsxRuntime.jsx(OrdersContainer, {
        children: orders === null || orders === void 0 ? void 0 : orders.map((order, index) => {
          var _a;
          return jsxRuntime.jsxs(OrderRow, {
            onClick: () => {
              var _a, _b;
              if ((_a = order === null || order === void 0 ? void 0 : order.cta) === null || _a === void 0 ? void 0 : _a.deeplink) redirectTo((_b = order === null || order === void 0 ? void 0 : order.cta) === null || _b === void 0 ? void 0 : _b.deeplink);
            },
            children: [jsxRuntime.jsxs(OrderTitle, {
              hasMargin: index > 0,
              children: [jsxRuntime.jsx(designSystem.FormattedText, {
                text: order === null || order === void 0 ? void 0 : order.title,
                color: theme.colors.warning,
                typography: designTokens.TYPOGRAPHY_KEYS.smallW3
              }), jsxRuntime.jsx(designSystem.Image, {
                src: (_a = order === null || order === void 0 ? void 0 : order.icon) === null || _a === void 0 ? void 0 : _a.url,
                height: "16px",
                width: "16px"
              })]
            }), jsxRuntime.jsx(designSystem.FormattedText, {
              text: order === null || order === void 0 ? void 0 : order.subtitle,
              color: theme.colors.mediumEmphasis,
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
              margin: "4px 0px 0px"
            })]
          });
        })
      })]
    })]
  });
};

const mockDataDT = {
  dashboardDiscovery: {
    templateId: 'DASHBOARD_DISCOVERY',
    nodeId: 'dashboard-discovery',
    analytics: {},
    data: {
      title: 'Manage Your \nMulti Currency Card',
      subtitle: 'Quickly Load Currencies, View card transactions, Lock/ Unlock Card, & more',
      cta: {
        id: 'DASHBOARD_DISCOVERY_BUTTON',
        type: 'handler',
        text: 'OK, GOT IT'
      }
    }
  }};

const CenterWidget = ({
  componentData,
  margin,
  cardData,
  source_type
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  const device = commonUi.useDevice();
  const buttonRef = React.useRef(null);
  const {
    title,
    subtitle,
    cardNumber,
    icon,
    cta
  } = (_a = componentData === null || componentData === void 0 ? void 0 : componentData.data) !== null && _a !== void 0 ? _a : {};
  const theme = React.useContext(styled.ThemeContext);
  const userData = useAppSelector(state => state.userData);
  const analyticsData = useAppSelector(state => {
    var _a;
    return (_a = state.listingApi.data) === null || _a === void 0 ? void 0 : _a.analytics;
  });
  const [buttonPosition, setButtonPosition] = React.useState({
    top: 0,
    left: 0
  });
  const [showCoachmark, setShowCoachmark] = React.useState(false);
  const orderStatusScroller = (_b = cardData === null || cardData === void 0 ? void 0 : cardData.cardData) === null || _b === void 0 ? void 0 : _b.find(item => item.templateId === 'ORDER_STATUS_SCROLLER_DESKTOP');
  const chatbotData = cardData === null || cardData === void 0 ? void 0 : cardData.chatbot;
  const canShowChatBot = chatbotData === null || chatbotData === void 0 ? void 0 : chatbotData.showChatBot;
  const showAssistanceBot = Boolean(chatbotData === null || chatbotData === void 0 ? void 0 : chatbotData.chatUrl);
  const hasOrders = ((_d = (_c = orderStatusScroller === null || orderStatusScroller === void 0 ? void 0 : orderStatusScroller.data) === null || _c === void 0 ? void 0 : _c.orders) === null || _d === void 0 ? void 0 : _d.length) > 0;
  React.useEffect(() => {
    if (buttonRef.current) {
      const {
        top,
        left
      } = buttonRef.current.getBoundingClientRect();
      setButtonPosition({
        top,
        left
      });
    }
  }, []);
  React.useEffect(() => {
    var _a;
    if (device === commonUi.DEVICE.DESKTOP && showCoachmark && componentData) {
      (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('elevation');
      document.body.style.overflow = 'hidden';
    }
  }, [device]);
  const closeCoachmark = () => {
    var _a;
    setShowCoachmark(false);
    (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('elevation');
    document.body.removeAttribute('style');
  };
  // Extract common PDT data from analytics if available
  const commonPdtData = analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.pdtData;
  // Only pass userData if both userId and puid are available as strings
  const validUserData = (userData === null || userData === void 0 ? void 0 : userData.userId) && (userData === null || userData === void 0 ? void 0 : userData.puid) ? {
    userId: userData.userId,
    puid: userData.puid
  } : undefined;
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(CenterWidgetCont, {
      margin: margin,
      children: [jsxRuntime.jsxs(CenterWidgetContInnr, {
        ref: buttonRef,
        hasData: componentData ? true : false,
        source_type: source_type,
        children: [jsxRuntime.jsxs(IconContainer$1, {
          children: [jsxRuntime.jsx(designSystem.Image, {
            src: icon === null || icon === void 0 ? void 0 : icon.url,
            width: "58px",
            height: "36px"
          }), jsxRuntime.jsx(IconBadge, {
            children: jsxRuntime.jsx(designSystem.FormattedText, {
              text: cardNumber,
              typography: designTokens.TYPOGRAPHY_KEYS.baseW1,
              color: theme.colors.highEmphasis
            })
          })]
        }), jsxRuntime.jsxs(TextContainer, {
          children: [jsxRuntime.jsx(designSystem.FormattedText, {
            text: title,
            typography: designTokens.TYPOGRAPHY_KEYS.smallW2,
            color: theme.colors.highEmphasis
          }), jsxRuntime.jsx(designSystem.FormattedText, {
            text: subtitle,
            typography: designTokens.TYPOGRAPHY_KEYS.smallW1,
            color: theme.colors.mediumEmphasis
          })]
        }), jsxRuntime.jsx(CenterWidgetButton, {
          variant: "text",
          endIcon: ((_e = cta === null || cta === void 0 ? void 0 : cta.icon) === null || _e === void 0 ? void 0 : _e.url) || '',
          label: cta === null || cta === void 0 ? void 0 : cta.text,
          rightImageWidth: "16px",
          onClick: () => {
            if (cta === null || cta === void 0 ? void 0 : cta.deeplink) redirectTo(cta.deeplink);
          },
          typography: designTokens.TYPOGRAPHY_KEYS.smallW3
        })]
      }), jsxRuntime.jsx(OrderStatusCont, {
        style: {
          right: 30,
          bottom: 30
        },
        children: hasOrders && jsxRuntime.jsx(OrderStatus, {
          componentData: orderStatusScroller
        })
      })]
    }), device === commonUi.DEVICE.DESKTOP && componentData && showCoachmark && jsxRuntime.jsx(DashboardDiscovery, {
      componentData: mockDataDT.dashboardDiscovery,
      buttonPositionDT: buttonPosition,
      onClose: closeCoachmark
    }), showAssistanceBot && canShowChatBot && jsxRuntime.jsx(myraChatbot.AssistanceBot, {
      chatUrl: chatbotData === null || chatbotData === void 0 ? void 0 : chatbotData.chatUrl,
      userData: validUserData,
      commonPdtData: commonPdtData,
      myraIconShownPdtData: (_f = chatbotData === null || chatbotData === void 0 ? void 0 : chatbotData.analytics) === null || _f === void 0 ? void 0 : _f.pdtData,
      myraChatWindowOpenPdtData: (_h = (_g = chatbotData === null || chatbotData === void 0 ? void 0 : chatbotData.myraIconOpenCta) === null || _g === void 0 ? void 0 : _g.analytics) === null || _h === void 0 ? void 0 : _h.pdtData,
      myraIconClickedPdtData: (_k = (_j = chatbotData === null || chatbotData === void 0 ? void 0 : chatbotData.myraIconClicked) === null || _j === void 0 ? void 0 : _j.analytics) === null || _k === void 0 ? void 0 : _k.pdtData,
      myraChatWindowClosedPdtData: (_m = (_l = chatbotData === null || chatbotData === void 0 ? void 0 : chatbotData.myraIconCloseCta) === null || _l === void 0 ? void 0 : _l.analytics) === null || _m === void 0 ? void 0 : _m.pdtData,
      style: Object.assign({
        bottom: '30px',
        right: '30px',
        zIndex: 12
      }, hasOrders && {
        offsetFromElement: {
          width: '360px',
          position: 'left',
          gap: '30px'
        }
      })
    })]
  });
};

const componentRegistry = {
  BEST_RATES: BestLiveRates,
  INSTANT_LOAD_NUDGE: InstantLoadNudge,
  ORDER_STATUS_SCROLLER: OrderStatusMweb,
  RATE_TICKER: RateTickerMweb,
  RATE_TICKER_DT: RateTickerDweb,
  OFFER_PERSUASION: OfferPersuasion,
  FREE_DELIVERY: FreeDelivery,
  DELIVERY_PERSUASION: DeliveryPersuasion,
  CURRENCY_PRODUCT_SELECTION: CurrencyWidgetsDweb,
  SCROLLABLE_INFO_ITEMS: ResumeOrder,
  CC_COMPARISON: CreditCardNudge,
  STATIC_TITLE_SUBTITLE: PoweredBy,
  AUTO_SCROLL_CAROUSEL: Offers,
  PAGER_1: BannerSlider,
  PRODUCT_INFO_SCROLLER: AboutProduct,
  FREQUENTLY_ASKED_QUESTION: Faqs,
  CENTER_WIDGET_DT: CenterWidget
};

const componentMapper = Object.keys(componentRegistry).reduce((mapper, key) => {
  mapper[key] = props => jsxRuntime.jsx(ComponentWrapper, Object.assign({
    keyName: key
  }, props));
  return mapper;
}, {});
const ComponentWrapper = _a => {
  var {
      keyName,
      componentData,
      bottomSheets,
      cardData
    } = _a,
    rest = __rest(_a, ["keyName", "componentData", "bottomSheets", "cardData"]);
  const Component = componentRegistry[keyName];
  const margin = getMarginForTemplate(TEMPLATE_KEYS[keyName]);
  const device = commonUi.useDevice();
  const excludedDesktopTemplates = ['RATE_TICKER_DT', 'OFFER_PERSUASION', 'DELIVERY_PERSUASION', 'CURRENCY_PRODUCT_SELECTION', 'SCROLLABLE_INFO_ITEMS', 'FREE_DELIVERY', 'INSTANT_LOAD_NUDGE', 'CENTER_WIDGET_DT'];
  if (device === commonUi.DEVICE.DESKTOP && excludedDesktopTemplates.includes(keyName)) {
    return null;
  }
  return jsxRuntime.jsx(Component, Object.assign({
    componentData: componentData,
    margin: margin,
    bottomSheets: bottomSheets,
    cardData: cardData
  }, rest));
};

const TemplateComponentMapper = ({
  cardData,
  extraProps
}) => {
  const renderCards = cardData === null || cardData === void 0 ? void 0 : cardData.cardData;
  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: renderCards === null || renderCards === void 0 ? void 0 : renderCards.map(item => {
      if (!item.templateId) return null;
      const Component = componentMapper[item.templateId];
      if (Component) {
        return jsxRuntime.jsx(Component, Object.assign({
          componentData: item,
          cardData: cardData,
          bottomSheets: cardData === null || cardData === void 0 ? void 0 : cardData.bottomSheets
        }, (extraProps === null || extraProps === void 0 ? void 0 : extraProps[item.templateId]) || {}), item.templateId);
      }
      return null;
    })
  });
};

// Base styles shared by all variants
const BaseTopSectionLoaderCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__BaseTopSectionLoaderCont",
  componentId: "sc-5fkr6b-0"
})(["max-width:1200px;margin:0 auto;background-color:", ";border-radius:8px;padding-right:20px;padding-bottom:40px;padding-left:20px;position:relative;"], ({
  theme
}) => theme.colors.white);
// Styled component for normal (non-SEO) view
const NormalTopSectionLoaderCont = /*#__PURE__*/styled__default.default(BaseTopSectionLoaderCont).withConfig({
  displayName: "TopSectionLoaderstyles__NormalTopSectionLoaderCont",
  componentId: "sc-5fkr6b-1"
})(["padding-top:64px;margin-top:-70px;"]);
// Styled component for SEO pages
const SeoTopSectionLoaderCont = /*#__PURE__*/styled__default.default(BaseTopSectionLoaderCont).withConfig({
  displayName: "TopSectionLoaderstyles__SeoTopSectionLoaderCont",
  componentId: "sc-5fkr6b-2"
})(["padding-top:16px;margin-top:0px;"]);
// Clean React component that selects the appropriate styled component
const TopSectionLoaderCont = _a => {
  var {
      source_type,
      children
    } = _a,
    props = __rest(_a, ["source_type", "children"]);
  if (isSeoSourceType(source_type)) {
    return jsxRuntime.jsx(SeoTopSectionLoaderCont, Object.assign({}, props, {
      children: children
    }));
  }
  return jsxRuntime.jsx(NormalTopSectionLoaderCont, Object.assign({}, props, {
    children: children
  }));
};
const TopSectionHeader = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__TopSectionHeader",
  componentId: "sc-5fkr6b-3"
})(["display:flex;justify-content:center;align-items:center;"]);
const WidgetsLoadingCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__WidgetsLoadingCont",
  componentId: "sc-5fkr6b-4"
})(["display:flex;border:", ";border-radius:", ";"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`, ({
  theme
}) => theme.borderRadius.br10);
const DeliverAtLoadingCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__DeliverAtLoadingCont",
  componentId: "sc-5fkr6b-5"
})(["border-right:", ";display:flex;flex-direction:column;width:187px;padding:12px 20px;"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`);
const CurrencyLoadingCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__CurrencyLoadingCont",
  componentId: "sc-5fkr6b-6"
})(["border-right:", ";display:flex;flex-direction:column;width:260px;padding:12px 20px;"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`);
const AmountContainerLoadingForexCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__AmountContainerLoadingForexCont",
  componentId: "sc-5fkr6b-7"
})(["border-right:", ";display:flex;flex-direction:column;width:207px;padding:12px 20px;position:relative;"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`);
const AmountContainerLoadingInr = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__AmountContainerLoadingInr",
  componentId: "sc-5fkr6b-8"
})(["border-right:", ";display:flex;flex-direction:column;width:207px;padding:12px 20px;"], ({
  theme
}) => `1px solid ${theme.colors.borderColor}`);
const CurrencyTypeLoadingCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__CurrencyTypeLoadingCont",
  componentId: "sc-5fkr6b-9"
})(["display:flex;flex-direction:column;width:313px;padding:12px 20px 11px;"]);
const CurrencyTypeIcons = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__CurrencyTypeIcons",
  componentId: "sc-5fkr6b-10"
})(["display:flex;column-gap:9px;margin-top:10px;align-items:center;"]);
const ButtonLoadingCont = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__ButtonLoadingCont",
  componentId: "sc-5fkr6b-11"
})(["display:flex;justify-content:center;position:absolute;left:0;bottom:-21px;width:100%;"]);
const LoadingButton = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__LoadingButton",
  componentId: "sc-5fkr6b-12"
})(["width:239px;height:48px;border-radius:60px;background:", ";"], ({
  theme
}) => theme.colors.disabledBg);
// Base styles shared by all variants
const BaseFooterContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__BaseFooterContainer",
  componentId: "sc-5fkr6b-13"
})(["display:flex;justify-content:space-between;margin-top:8px;"]);
// Normal (non-SEO) view
const NormalFooterContainer = /*#__PURE__*/styled__default.default(BaseFooterContainer).withConfig({
  displayName: "TopSectionLoaderstyles__NormalFooterContainer",
  componentId: "sc-5fkr6b-14"
})(["height:50px;"]);
// SEO view
const SeoFooterContainer = /*#__PURE__*/styled__default.default(BaseFooterContainer).withConfig({
  displayName: "TopSectionLoaderstyles__SeoFooterContainer",
  componentId: "sc-5fkr6b-15"
})(["height:20px;"]);
// Clean React component that selects the appropriate styled component
const FooterContainer = _a => {
  var {
      source_type,
      children
    } = _a,
    props = __rest(_a, ["source_type", "children"]);
  if (isSeoSourceType(source_type)) {
    return jsxRuntime.jsx(SeoFooterContainer, Object.assign({}, props, {
      children: children
    }));
  }
  return jsxRuntime.jsx(NormalFooterContainer, Object.assign({}, props, {
    children: children
  }));
};
const HeaderRightContainer = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionLoaderstyles__HeaderRightContainer",
  componentId: "sc-5fkr6b-18"
})(["float:right;position:absolute;right:30px;"]);

const TopSectionLoader = ({
  source_type
}) => {
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(TopSectionLoaderCont, {
      source_type: source_type,
      children: [jsxRuntime.jsxs(TopSectionHeader, {
        children: [jsxRuntime.jsx(designSystem.Shimmer, {
          height: "60px",
          width: "424px",
          margin: "12px 0px 12px"
        }), jsxRuntime.jsx(HeaderRightContainer, {
          children: jsxRuntime.jsx(designSystem.Shimmer, {
            height: "24px",
            width: "140px"
          })
        })]
      }), jsxRuntime.jsxs(WidgetsLoadingCont, {
        children: [jsxRuntime.jsxs(DeliverAtLoadingCont, {
          children: [jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "80px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "32px",
            width: "147px",
            margin: "10px 0px 0px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "80px",
            margin: "4px 0px 0px"
          })]
        }), jsxRuntime.jsxs(CurrencyLoadingCont, {
          children: [jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "80px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "32px",
            width: "190px",
            margin: "10px 0px 0px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "80px",
            margin: "4px 0px 0px"
          })]
        }), jsxRuntime.jsxs(AmountContainerLoadingForexCont, {
          children: [jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "115px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "32px",
            width: "137px",
            margin: "10px 0px 0px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "45px",
            margin: "4px 0px 0px"
          }), jsxRuntime.jsx(CompareAmountIcon, {
            src: 'https://tripmoneycmsimgak.mmtcdn.com/img/equal_f79a49ccd5.png',
            height: "24px",
            width: "24px"
          })]
        }), jsxRuntime.jsxs(AmountContainerLoadingInr, {
          children: [jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "115px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "32px",
            width: "137px",
            margin: "10px 0px 0px"
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "45px",
            margin: "4px 0px 0px"
          })]
        }), jsxRuntime.jsxs(CurrencyTypeLoadingCont, {
          children: [jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "145px"
          }), jsxRuntime.jsxs(CurrencyTypeIcons, {
            children: [jsxRuntime.jsx(designSystem.Shimmer, {
              height: "36px",
              width: "36px"
            }), jsxRuntime.jsx(designSystem.Shimmer, {
              height: "36px",
              width: "36px"
            }), jsxRuntime.jsx(designSystem.Shimmer, {
              height: "32px",
              width: "60px"
            })]
          }), jsxRuntime.jsx(designSystem.Shimmer, {
            height: "17px",
            width: "240px",
            margin: "4px 0px 0px"
          })]
        })]
      }), jsxRuntime.jsx(designSystem.Shimmer, {
        height: "24px",
        width: "421px",
        margin: "12px 0px 0px"
      }), jsxRuntime.jsx(ButtonLoadingCont, {
        children: jsxRuntime.jsx(LoadingButton, {})
      })]
    }), jsxRuntime.jsx(FooterContainer, {
      source_type: source_type
    })]
  });
};

const ShowGlobalToast = ({
  onClose
}) => {
  const dispatch = useAppDispatch();
  const {
    message,
    duration,
    showToast,
    showCrossIcon,
    rightText
  } = useAppSelector(state => state.toastData);
  function closeHandler() {
    dispatch(hideToastMessage());
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }
  function onRightTextActionHandler() {
    closeHandler();
  }
  return showToast ? jsxRuntime.jsx(designSystem.Toast, {
    message: message,
    duration: duration,
    showCrossIcon: showCrossIcon,
    onClose: closeHandler,
    rightText: rightText,
    onRightTextActionClick: onRightTextActionHandler
  }) : null;
};

const useCallListingApiOnPageLoad = ({
  isBot,
  isSeoPage: _isSeoPage = false,
  selectedCurrencyCodes
}) => {
  const dispatch = useAppDispatch();
  const {
    data: listingData,
    apiState
  } = useAppSelector(state => state.listingApi);
  const {
    isLoading: isLoadingGeoLocation,
    setUserLocationIfPermitted
  } = commonUi.useGeoLocation();
  React.useEffect(() => {
    if (isBot === null) return;
    // For SEO pages or bot pages: skip geolocation and return data immediately
    if (isBot) {
      dispatch(fetchListingData({
        showLoader: false,
        isBot: true,
        selectedCurrencyCodes
      }));
      return;
    }
    /* First set userlocation if there, from query params in session storage */
    setUserLocationFromQueryParamsInSessionStorage();
    /* Check if anything is there in session storage, if not then fetch current user location or else call listing api */
    const deliveryData = commonUi.getTransformedLocationDataFromSessionStorage({
      key: coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
      isEssential: true,
      options: coreUtils.getSessionPiiDataOpts
    });
    if (!deliveryData) setUserLocationIfPermitted((latitude, longitude) => {
      commonUi.setTransformedLocationDataToSessionStorage({
        key: coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
        value: {
          latitude,
          longitude
        },
        isEssential: true
      });
      dispatch(fetchListingData({
        showLoader: true,
        isBot: false,
        selectedCurrencyCodes
      }));
    }, () => {
      dispatch(fetchListingData({
        showLoader: true,
        isBot: false,
        selectedCurrencyCodes
      }));
    });else {
      dispatch(fetchListingData({
        showLoader: true,
        isBot: false,
        selectedCurrencyCodes
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBot, _isSeoPage, selectedCurrencyCodes]);
  React.useEffect(() => {
    // Don't call search API if it's a bot scenario or SEO page
    if (isBot || isBot === null) {
      return; // Exit early for bots or SEO pages
    }
    dispatch(fetchSearchApiData({}));
  }, [dispatch, isBot, _isSeoPage]);
  return {
    listingData,
    listingApiState: apiState,
    isLoading: isLoadingGeoLocation || apiState === coreUtils.States.LOADING
  };
};

// Base styles shared by all variants
const BaseTopSection = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionDwebstyles__BaseTopSection",
  componentId: "sc-1g1c66b-0"
})(["max-width:1200px;margin:0 auto;background-color:#fff;border-radius:8px;padding-right:20px;padding-left:20px;position:relative;"]);
// Styled component for normal (non-SEO, non-bot) view
const NormalTopSection = /*#__PURE__*/styled__default.default(BaseTopSection).withConfig({
  displayName: "TopSectionDwebstyles__NormalTopSection",
  componentId: "sc-1g1c66b-1"
})(["padding-top:64px;padding-bottom:40px;margin-top:-70px;"]);
// Styled component for SEO pages
const SeoTopSection = /*#__PURE__*/styled__default.default(BaseTopSection).withConfig({
  displayName: "TopSectionDwebstyles__SeoTopSection",
  componentId: "sc-1g1c66b-2"
})(["padding-top:1px;padding-bottom:40px;margin-top:0px;"]);
// Styled component for bot pages
const BotTopSection = /*#__PURE__*/styled__default.default(BaseTopSection).withConfig({
  displayName: "TopSectionDwebstyles__BotTopSection",
  componentId: "sc-1g1c66b-3"
})(["padding-top:63px;padding-bottom:63px;margin-top:0px;"]);
// Clean React component that selects the appropriate styled component
const TopSection = _a => {
  var {
      source_type,
      isBot,
      children
    } = _a,
    props = __rest(_a, ["source_type", "isBot", "children"]);
  // Priority: Bot > SEO > Normal
  if (isBot) {
    return jsxRuntime.jsx(BotTopSection, Object.assign({}, props, {
      children: children
    }));
  }
  if (isSeoSourceType(source_type)) {
    return jsxRuntime.jsx(SeoTopSection, Object.assign({}, props, {
      children: children
    }));
  }
  return jsxRuntime.jsx(NormalTopSection, Object.assign({}, props, {
    children: children
  }));
};
const HeightCalWrap = /*#__PURE__*/styled__default.default.div.withConfig({
  displayName: "TopSectionDwebstyles__HeightCalWrap",
  componentId: "sc-1g1c66b-4"
})([""]);

const TopSectionDweb = ({
  data,
  setHeight,
  isBot
}) => {
  const sectionRef = React.useRef(null);
  // Get source_type from Redux store instead of usePageInfo
  const {
    source_type
  } = useAppSelector(state => state.pageContext);
  const currentSourceType = source_type || SOURCE_TYPES.FOREX_LISTING;
  const {
    cardData = [],
    bottomSheets,
    stickyPricingNudge
  } = data !== null && data !== void 0 ? data : {};
  const {
    deliveryPersuasionData,
    resumeOrderData,
    poweredByData,
    freeDeliveryData,
    instantNudgeData,
    centerWidgetData,
    offerPersuasionData
  } = React.useMemo(() => {
    const findTemplate = id => cardData.find(item => item.templateId === id);
    return {
      deliveryPersuasionData: findTemplate(TEMPLATE_KEYS.DELIVERY_PERSUASION),
      resumeOrderData: findTemplate(TEMPLATE_KEYS.SCROLLABLE_INFO_ITEMS),
      poweredByData: findTemplate(TEMPLATE_KEYS.STATIC_TITLE_SUBTITLE),
      freeDeliveryData: findTemplate(TEMPLATE_KEYS.FREE_DELIVERY),
      instantNudgeData: findTemplate(TEMPLATE_KEYS.INSTANT_LOAD_NUDGE),
      centerWidgetData: findTemplate(TEMPLATE_KEYS.CENTER_WIDGET_DT),
      offerPersuasionData: findTemplate(TEMPLATE_KEYS.OFFER_PERSUASION)
    };
  }, [cardData]);
  React.useEffect(() => {
    if (sectionRef.current && setHeight) {
      setHeight(sectionRef.current.offsetHeight);
    }
  }, [cardData, setHeight]);
  const renderComponent = React.useMemo(() => cardData.map((item, index) => {
    switch (item === null || item === void 0 ? void 0 : item.templateId) {
      case TEMPLATE_KEYS.RATE_TICKER_VERTICAL_SCROLL:
        return jsxRuntime.jsx(RateTickerDwebNew, {
          componentData: item,
          margin: '12px 0 12px',
          bottomSheets: bottomSheets
        }, item === null || item === void 0 ? void 0 : item.nodeId);
      case TEMPLATE_KEYS.RATE_TICKER_DT:
        return jsxRuntime.jsx(RateTickerDweb, {
          componentData: item,
          margin: '12px 0 12px',
          bottomSheets: bottomSheets
        }, item === null || item === void 0 ? void 0 : item.nodeId);
      case TEMPLATE_KEYS.CURRENCY_PRODUCT_SELECTION:
        return jsxRuntime.jsx(CurrencyWidgetsDweb, {
          componentData: item,
          bottomSheets: bottomSheets,
          margin: !(offerPersuasionData === null || offerPersuasionData === void 0 ? void 0 : offerPersuasionData.data) ? '12px 0 0' : '0',
          offerPersuasionData: offerPersuasionData,
          deliveryPersuasionData: deliveryPersuasionData,
          resumeOrderData: resumeOrderData,
          stickyPricingNudge: stickyPricingNudge
        }, item === null || item === void 0 ? void 0 : item.nodeId);
      default:
        return null;
    }
  }), [cardData, bottomSheets, deliveryPersuasionData, resumeOrderData]);
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsxs(HeightCalWrap, {
      ref: sectionRef,
      children: [jsxRuntime.jsx(TopSection, {
        source_type: currentSourceType,
        isBot: isBot,
        children: renderComponent
      }), freeDeliveryData && jsxRuntime.jsx(FreeDelivery, {
        componentData: freeDeliveryData,
        margin: "0 0 16px 0"
      }), instantNudgeData && jsxRuntime.jsx(InstantLoadNudge, {
        componentData: instantNudgeData,
        margin: "0 0 16px 0"
      })]
    }), jsxRuntime.jsx(CenterWidget, {
      componentData: centerWidgetData,
      cardData: data,
      source_type: currentSourceType
    })]
  });
};

function ForexListing({
  isBot
}) {
  const {
    source_type
  } = useAppSelector(state => state.pageContext);
  const serverDeviceType = useAppSelector(state => state.pageContext.deviceType);
  const device = commonUi.useDevice(serverDeviceType);
  // Memoize SEO page detection and currency extraction to prevent repeated API calls
  const seoPageData = React.useMemo(() => {
    const isSeoPage = isSeoSourceType(source_type);
    const seoUrlResult = isSeoPage ? coreUtils.parseSeoUrl() : null;
    const currencyCode = (seoUrlResult === null || seoUrlResult === void 0 ? void 0 : seoUrlResult.currencyCode) || null;
    const pincode = (seoUrlResult === null || seoUrlResult === void 0 ? void 0 : seoUrlResult.pincode) || null;
    const selectedCurrencyCodes = currencyCode ? [currencyCode] : undefined;
    // OVERRIDE location data in session storage when we have a pincode from SEO URL
    if (isSeoPage && pincode) {
      commonUi.setTransformedLocationDataToSessionStorage({
        key: coreUtils.SESSION_STORAGE_KEYS.USER_LOCATION_SESSION_KEY,
        value: {
          pincode: pincode,
          detectionSource: commonUi.LOCATION_DETECTION_SOURCE.PINCODE
        },
        isEssential: true
      });
    }
    return {
      isSeoPage,
      currencyCode,
      pincode,
      selectedCurrencyCodes
    };
  }, [source_type]); // Empty dependency array since URL doesn't change during component lifecycle
  // Call the hook with clear SEO distinction
  const {
    listingData,
    isLoading
  } = useCallListingApiOnPageLoad({
    isBot,
    isSeoPage: seoPageData.isSeoPage,
    selectedCurrencyCodes: seoPageData.selectedCurrencyCodes,
    pincode: seoPageData.pincode
  });
  const stateData = useAppSelector(state => state);
  const currentSourceType = source_type || SOURCE_TYPES.FOREX_LISTING;
  const [canInitPdtTracking, setCanInitPdtTracking] = React.useState(false);
  const [topSectionHeight, setTopSectionHeight] = React.useState(400);
  const scrollTrackingRef = React.useRef({
    '25': false,
    '50': false,
    '75': false,
    '100': false
  });
  const productInfoVisibilityRef = React.useRef(false);
  const isAboutProductVisible = () => {
    const aboutProductElement = document.querySelector('[data-component="PRODUCT_INFO_SCROLLER"]');
    if (!aboutProductElement) return false;
    const rect = aboutProductElement.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < windowHeight && rect.bottom > 0;
  };
  const checkAndTrackProductInfoVisibility = () => {
    if (productInfoVisibilityRef.current) {
      return false;
    }
    const isVisible = isAboutProductVisible();
    if (isVisible) {
      productInfoVisibilityRef.current = true;
      return true;
    }
    return false;
  };
  const createScrollEventData = (scrollValue, includeProductInfo) => {
    const baseEventData = {
      event_detail: {
        event_name: 'page_scroll',
        event_value: scrollValue
      }
    };
    if (includeProductInfo) {
      return Object.assign(Object.assign({}, baseEventData), {
        event_detail: Object.assign(Object.assign({}, baseEventData.event_detail), {
          components: {
            content_details: [{
              type: '',
              id: 'product_info_scroller',
              description: 'PRODUCT_INFO_SCROLLER'
            }]
          }
        })
      });
    }
    return baseEventData;
  };
  const handleScrollTracking = (percentage, scrollPercentage, threshold) => {
    if (scrollPercentage >= threshold && !scrollTrackingRef.current[percentage]) {
      scrollTrackingRef.current[percentage] = true;
      const shouldIncludeProductInfo = checkAndTrackProductInfoVisibility();
      const eventData = createScrollEventData(`page_scroll_${percentage}`, shouldIncludeProductInfo);
      pdtUtils.trackEvent({
        eventData
      });
    }
  };
  const getElementTopPosition = id => {
    const element = document.getElementById(id);
    if (element) {
      const rect = element.getBoundingClientRect();
      return rect.top; // Distance from top of viewport
    }
    return null;
  };
  const initUserInfo = () => __awaiter(this, void 0, void 0, function* () {
    yield pdtUtils.initSessionStorageUserInfo();
    setCanInitPdtTracking(true);
  });
  // This is workaround added to set userInfo in sessionStorage
  // before pdt tracking is initialized.
  // Once the commons team will update sendPdtDataV2 function to accomodate this
  // then we can remove this useEffect
  React.useEffect(() => {
    initUserInfo();
  }, []);
  React.useEffect(() => {
    var _a, _b, _c, _d;
    if (listingData && Object.keys(listingData).length > 0 && Object.keys(stateData).length > 0 && canInitPdtTracking) {
      const pdtParams = pdtUtils.extractPdtTrackingParams(listingData, stateData, 'Listing', isSeoSourceType(currentSourceType));
      pdtUtils.initPdtTracking(pdtParams);
      if (((_a = listingData === null || listingData === void 0 ? void 0 : listingData.chatbot) === null || _a === void 0 ? void 0 : _a.showChatBot) && ((_b = listingData === null || listingData === void 0 ? void 0 : listingData.chatbot) === null || _b === void 0 ? void 0 : _b.chatUrl)) {
        pdtUtils.trackEvent({
          eventData: (_d = (_c = listingData === null || listingData === void 0 ? void 0 : listingData.chatbot) === null || _c === void 0 ? void 0 : _c.analytics) === null || _d === void 0 ? void 0 : _d.pdtData
        });
      }
    }
    return () => {
      pdtUtils.cleanupPdtTracking();
    };
  }, [listingData, stateData, currentSourceType, canInitPdtTracking]);
  const findTemplate = id => {
    var _a;
    return (_a = listingData === null || listingData === void 0 ? void 0 : listingData.cardData) === null || _a === void 0 ? void 0 : _a.find(item => item.templateId === id);
  };
  const isCenterWidgetVisible = () => {
    return findTemplate(TEMPLATE_KEYS.CENTER_WIDGET_DT);
  };
  React.useLayoutEffect(() => {
    if (device === commonUi.DEVICE.DESKTOP && topSectionHeight) {
      console.log('topSectionHeight', getElementTopPosition('product-info-scroller'));
      const productInfoTopPosition = getElementTopPosition('product-info-scroller');
      const topBanner = document.getElementById('top-banner');
      if (topBanner) {
        // keep this height same as commons top-banner height
        let height = 540;
        if (productInfoTopPosition) {
          height = productInfoTopPosition - (isCenterWidgetVisible() ? 75 : 40);
        }
        topBanner.style.setProperty('background-size', `100% ${height}px`, 'important');
      }
    }
  }, [device, topSectionHeight]);
  React.useEffect(() => {
    if (topSectionHeight) {
      window.scrollTo(0, 0);
    }
  }, [topSectionHeight]);
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (documentHeight <= 0) {
        return;
      }
      const scrollPercentage = scrollTop / documentHeight * 100;
      handleScrollTracking('25', scrollPercentage, 25);
      handleScrollTracking('50', scrollPercentage, 50);
      handleScrollTracking('75', scrollPercentage, 75);
      handleScrollTracking('100', scrollPercentage, 99);
    };
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', throttledHandleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, []);
  if (device === null) {
    return null;
  }
  // Show loading when data is not available or still being fetched
  if (!listingData || Object.keys(listingData).length === 0 || isLoading) {
    return jsxRuntime.jsxs(StyledListingUi, {
      source_type: currentSourceType,
      children: [jsxRuntime.jsx(TopSectionLoader, {
        source_type: currentSourceType
      }), jsxRuntime.jsx(MobileHeader, {
        headerData: listingData === null || listingData === void 0 ? void 0 : listingData.headerData
      })]
    });
  }
  return jsxRuntime.jsxs(StyledListingUi, {
    source_type: currentSourceType,
    children: [jsxRuntime.jsx(MobileHeader, {
      headerData: listingData === null || listingData === void 0 ? void 0 : listingData.headerData
    }), device === commonUi.DEVICE.DESKTOP && jsxRuntime.jsx(TopSectionDweb, {
      data: listingData,
      setHeight: setTopSectionHeight,
      isBot: isBot
    }), !isSeoSourceType(currentSourceType) && jsxRuntime.jsx(TemplateComponentMapper, {
      cardData: listingData
    }), jsxRuntime.jsx(ShowGlobalToast, {})]
  });
}
function MobileHeader({
  headerData
}) {
  const serverDeviceType = useAppSelector(state => state.pageContext.deviceType);
  const device = commonUi.useDevice(serverDeviceType);
  return device === commonUi.DEVICE.MOBILE ? jsxRuntime.jsx(HeaderMweb, {
    data: headerData
  }) : null;
}

const ThemeProviderWrapper = ({
  children,
  theme
}) => {
  return jsxRuntime.jsx(styled.ThemeProvider, {
    theme: theme,
    children: children
  });
};

class SeoErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error('SeoErrorBoundary caught an error:', error, errorInfo);
    // Log additional context for SEO error boundary activation
    if (this.shouldShowFallback()) {
      console.log('🔄 SEO Error Boundary: Falling back to static data', {
        source_type: this.props.source_type,
        page_name: this.props.page_name,
        error_message: error.message
      });
    }
    // Optional: Add analytics/monitoring integration here
    // Example: sendErrorToAnalytics(error, errorInfo, this.props);
  }
  shouldShowFallback() {
    const {
      source_type
    } = this.props;
    const {
      hasError
    } = this.state;
    // Only show fallback for SEO pages when:
    // 1. There's an error
    // 2. source_type is 'seo'
    // Note: Bot detection is now handled client-side, so we show fallback for all users
    return hasError && isSeoSourceType(source_type);
  }
  renderFallback() {
    const {
      source_type,
      page_name,
      deviceType
    } = this.props;
    console.log('🔄 SeoErrorBoundary: Rendering fallback with static data');
    // Replicate the same logic as ListingUiWrapper but with isBot=true
    const partner = isSeoSourceType(source_type) || coreUtils.isHostMMT() ? designTokens.PARTNER.MMT : designTokens.PARTNER.GI;
    const theme = designTokens.getTheme(partner, designTokens.DEVICE.WEB);
    const staticData = botListingData; // Always use bot data for error fallback
    console.log('🔄 SeoErrorBoundary: Static data for fallback:', {
      source_type,
      staticData: !!staticData,
      hasStaticData: !!staticData
    });
    const initialData = {
      pageContext: {
        source_type: SOURCE_TYPES.SEO || null,
        page_name: 'seo-fallback',
        deviceType: 'lg'
      }
    };
    return jsxRuntime.jsx(ThemeProviderWrapper, {
      theme: theme,
      children: jsxRuntime.jsxs(StoreProvider, {
        initialData: initialData,
        children: [jsxRuntime.jsx(designSystem.GlobalStyles, {}), jsxRuntime.jsx(ForexListing, {
          isBot: true
        })]
      })
    });
  }
  render() {
    if (this.shouldShowFallback()) {
      return this.renderFallback();
    }
    // If not SEO page or no error, render children normally
    return this.props.children;
  }
}

function ListingUiWrapper({
  source_type = SOURCE_TYPES.FOREX_LISTING,
  page_name,
  deviceType,
  isBot = false
} = {}) {
  const partner = coreUtils.isHostMMT() ? designTokens.PARTNER.MMT : designTokens.PARTNER.GI;
  const theme = designTokens.getTheme(partner, designTokens.DEVICE.WEB);
  // Create preloaded state in the exact structure needed
  const preloadedState = {
    pageContext: {
      source_type: source_type !== null && source_type !== void 0 ? source_type : null,
      page_name: page_name !== null && page_name !== void 0 ? page_name : null,
      deviceType: deviceType || 'lg'
    }
  };
  return jsxRuntime.jsx(SeoErrorBoundary, {
    source_type: source_type,
    page_name: page_name,
    deviceType: deviceType,
    children: jsxRuntime.jsx(ThemeProviderWrapper, {
      theme: theme,
      children: jsxRuntime.jsxs(StoreProvider, {
        initialData: preloadedState,
        children: [jsxRuntime.jsx(designSystem.GlobalStyles, {}), jsxRuntime.jsx(ForexListing, {
          isBot: isBot
        })]
      })
    })
  });
}

__webpack_unused_export__ = AboutProduct;
__webpack_unused_export__ = BannerSlider;
__webpack_unused_export__ = BestLiveRates;
__webpack_unused_export__ = CenterWidget;
__webpack_unused_export__ = CreditCardNudge;
__webpack_unused_export__ = CurrencyWidgetsDweb;
__webpack_unused_export__ = CurrencyWidgetsMweb;
__webpack_unused_export__ = DeliveryPersuasion;
__webpack_unused_export__ = Faqs;
__webpack_unused_export__ = FreeDelivery;
__webpack_unused_export__ = HeaderMweb;
__webpack_unused_export__ = InstantLoadNudge;
exports.ev = ListingUiWrapper;
__webpack_unused_export__ = OfferPersuasion;
__webpack_unused_export__ = Offers;
__webpack_unused_export__ = OrderStatus;
__webpack_unused_export__ = OrderStatusMweb;
__webpack_unused_export__ = PoweredBy;
__webpack_unused_export__ = RateTickerBottomSheet;
__webpack_unused_export__ = RateTickerDweb;
__webpack_unused_export__ = RateTickerDwebNew;
__webpack_unused_export__ = RateTickerMweb;
__webpack_unused_export__ = ResumeOrder;
__webpack_unused_export__ = SOURCE_TYPES;
__webpack_unused_export__ = SeoErrorBoundary;
__webpack_unused_export__ = TopSectionLoader;
__webpack_unused_export__ = botListingData;


/***/ }),

/***/ 3205:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4406);
var Pe=Object.defineProperty;var Nt=Object.getOwnPropertyDescriptor;var jt=Object.getOwnPropertyNames;var Ft=Object.prototype.hasOwnProperty;var Vt=(e,t)=>{for(var r in t)Pe(e,r,{get:t[r],enumerable:!0})},Me=(e,t,r,n)=>{if(t&&typeof t=="object"||typeof t=="function")for(let o of jt(t))!Ft.call(e,o)&&o!==r&&Pe(e,o,{get:()=>t[o],enumerable:!(n=Nt(t,o))||n.enumerable});return e},R=(e,t,r)=>(Me(e,t,"default"),r&&Me(r,t,"default"));var _t=e=>Me(Pe({},"__esModule",{value:!0}),e);var x={};Vt(x,{ReducerType:()=>We,SHOULD_AUTOBATCH:()=>ce,TaskAbortError:()=>b,Tuple:()=>j,addListener:()=>Re,asyncThunkCreator:()=>ut,autoBatchEnhancer:()=>de,buildCreateSlice:()=>ze,clearAllListeners:()=>qe,combineSlices:()=>Ot,configureStore:()=>st,createAction:()=>P,createActionCreatorInvariantMiddleware:()=>Qe,createAsyncThunk:()=>ye,createDraftSafeSelector:()=>ne,createDraftSafeSelectorCreator:()=>be,createDynamicMiddleware:()=>vt,createEntityAdapter:()=>At,createImmutableStateInvariantMiddleware:()=>Ze,createListenerMiddleware:()=>bt,createNextState:()=>D.produce,createReducer:()=>le,createSelector:()=>W.createSelector,createSelectorCreator:()=>W.createSelectorCreator,createSerializableStateInvariantMiddleware:()=>nt,createSlice:()=>lt,current:()=>D.current,findNonSerializableValue:()=>Ne,formatProdErrorMessage:()=>k,freeze:()=>D.freeze,isActionCreator:()=>oe,isAllOf:()=>G,isAnyOf:()=>V,isAsyncThunkAction:()=>_e,isDraft:()=>D.isDraft,isFluxStandardAction:()=>ae,isFulfilled:()=>Ve,isImmutableDefault:()=>Ye,isPending:()=>je,isPlain:()=>Oe,isRejected:()=>q,isRejectedWithValue:()=>Fe,lruMemoize:()=>W.lruMemoize,miniSerializeError:()=>Le,nanoid:()=>v,original:()=>D.original,prepareAutoBatched:()=>at,removeListener:()=>we,unwrapResult:()=>Ue,weakMapMemoize:()=>W.weakMapMemoize});module.exports=_t(x);R(x,__webpack_require__(2274),module.exports);var D=__webpack_require__(7476),W=__webpack_require__(6562);var ee=__webpack_require__(7476),te=__webpack_require__(6562),be=(...e)=>{let t=(0,te.createSelectorCreator)(...e),r=Object.assign((...n)=>{let o=t(...n),a=(s,...u)=>o((0,ee.isDraft)(s)?(0,ee.current)(s):s,...u);return Object.assign(a,o),a},{withTypes:()=>r});return r},ne=be(te.weakMapMemoize);var I=__webpack_require__(2274);var Ie=__webpack_require__(2274),Je=typeof window<"u"&&window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__:function(){if(arguments.length!==0)return typeof arguments[0]=="object"?Ie.compose:Ie.compose.apply(null,arguments)},gn=typeof window<"u"&&window.__REDUX_DEVTOOLS_EXTENSION__?window.__REDUX_DEVTOOLS_EXTENSION__:function(){return function(e){return e}};var se=__webpack_require__(3330);var ve=__webpack_require__(2274);var re=e=>e&&typeof e.match=="function";function P(e,t){function r(...n){if(t){let o=t(...n);if(!o)throw new Error(k(0));return{type:e,payload:o.payload,..."meta"in o&&{meta:o.meta},..."error"in o&&{error:o.error}}}return{type:e,payload:n[0]}}return r.toString=()=>`${e}`,r.type=e,r.match=n=>(0,ve.isAction)(n)&&n.type===e,r}function oe(e){return typeof e=="function"&&"type"in e&&re(e)}function ae(e){return(0,ve.isAction)(e)&&Object.keys(e).every(Lt)}function Lt(e){return["type","payload","error","meta"].indexOf(e)>-1}function Ut(e){let t=e?`${e}`.split("/"):[],r=t[t.length-1]||"actionCreator";return`Detected an action creator with type "${e||"unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${r}())\` instead of \`dispatch(${r})\`. This is necessary even if the action has no payload.`}function Qe(e={}){return()=>r=>n=>r(n)}var ie=__webpack_require__(7476);var j=class e extends Array{constructor(...t){super(...t),Object.setPrototypeOf(this,e.prototype)}static get[Symbol.species](){return e}concat(...t){return super.concat.apply(this,t)}prepend(...t){return t.length===1&&Array.isArray(t[0])?new e(...t[0].concat(this)):new e(...t.concat(this))}};function De(e){return(0,ie.isDraftable)(e)?(0,ie.produce)(e,()=>{}):e}function F(e,t,r){return e.has(t)?e.get(t):e.set(t,r(t)).get(t)}function Ye(e){return typeof e!="object"||e==null||Object.isFrozen(e)}function Ze(e={}){if(true)return()=>n=>o=>n(o);var t,r}var et=__webpack_require__(2274);function Oe(e){let t=typeof e;return e==null||t==="string"||t==="boolean"||t==="number"||Array.isArray(e)||(0,et.isPlainObject)(e)}function Ne(e,t="",r=Oe,n,o=[],a){let s;if(!r(e))return{keyPath:t||"<root>",value:e};if(typeof e!="object"||e===null||a?.has(e))return!1;let u=n!=null?n(e):Object.entries(e),c=o.length>0;for(let[A,i]of u){let d=t?t+"."+A:A;if(!(c&&o.some(g=>g instanceof RegExp?g.test(d):d===g))){if(!r(i))return{keyPath:d,value:i};if(typeof i=="object"&&(s=Ne(i,d,r,n,o,a),s))return s}}return a&&tt(e)&&a.add(e),!1}function tt(e){if(!Object.isFrozen(e))return!1;for(let t of Object.values(e))if(!(typeof t!="object"||t===null)&&!tt(t))return!1;return!0}function nt(e={}){return()=>t=>r=>t(r)}function Wt(e){return typeof e=="boolean"}var rt=()=>function(t){let{thunk:r=!0,immutableCheck:n=!0,serializableCheck:o=!0,actionCreatorCheck:a=!0}=t??{},s=new j;return r&&(Wt(r)?s.push(se.thunk):s.push((0,se.withExtraArgument)(r.extraArgument))),s};var ce="RTK_autoBatch",at=()=>e=>({payload:e,meta:{[ce]:!0}}),ot=e=>t=>{setTimeout(t,e)},de=(e={type:"raf"})=>t=>(...r)=>{let n=t(...r),o=!0,a=!1,s=!1,u=new Set,c=e.type==="tick"?queueMicrotask:e.type==="raf"?typeof window<"u"&&window.requestAnimationFrame?window.requestAnimationFrame:ot(10):e.type==="callback"?e.queueNotification:ot(e.timeout),A=()=>{s=!1,a&&(a=!1,u.forEach(i=>i()))};return Object.assign({},n,{subscribe(i){let d=()=>o&&i(),T=n.subscribe(d);return u.add(i),()=>{T(),u.delete(i)}},dispatch(i){try{return o=!i?.meta?.[ce],a=!o,a&&(s||(s=!0,c(A))),n.dispatch(i)}finally{o=!0}}})};var it=e=>function(r){let{autoBatch:n=!0}=r??{},o=new j(e);return n&&o.push(de(typeof n=="object"?n:void 0)),o};function st(e){let t=rt(),{reducer:r=void 0,middleware:n,devTools:o=!0,preloadedState:a=void 0,enhancers:s=void 0}=e||{},u;if(typeof r=="function")u=r;else if((0,I.isPlainObject)(r))u=(0,I.combineReducers)(r);else throw new Error(k(1));let c;typeof n=="function"?c=n(t):c=t();let A=I.compose;o&&(A=Je({trace:!1,...typeof o=="object"&&o}));let i=(0,I.applyMiddleware)(...c),d=it(i),T=typeof s=="function"?s(d):d(),g=A(...T);return(0,I.createStore)(u,a,g)}var z=__webpack_require__(7476);function ue(e){let t={},r=[],n,o={addCase(a,s){let u=typeof a=="string"?a:a.type;if(!u)throw new Error(k(28));if(u in t)throw new Error(k(29));return t[u]=s,o},addMatcher(a,s){return r.push({matcher:a,reducer:s}),o},addDefaultCase(a){return n=a,o}};return e(o),[t,r,n]}function zt(e){return typeof e=="function"}function le(e,t){let[r,n,o]=ue(t),a;if(zt(e))a=()=>De(e());else{let u=De(e);a=()=>u}function s(u=a(),c){let A=[r[c.type],...n.filter(({matcher:i})=>i(c)).map(({reducer:i})=>i)];return A.filter(i=>!!i).length===0&&(A=[o]),A.reduce((i,d)=>{if(d)if((0,z.isDraft)(i)){let g=d(i,c);return g===void 0?i:g}else{if((0,z.isDraftable)(i))return(0,z.produce)(i,T=>d(T,c));{let T=d(i,c);if(T===void 0){if(i===null)return i;throw Error("A case reducer on a non-draftable value must not return undefined")}return T}}return i},u)}return s.getInitialState=a,s}var ct=(e,t)=>re(e)?e.match(t):e(t);function V(...e){return t=>e.some(r=>ct(r,t))}function G(...e){return t=>e.every(r=>ct(r,t))}function pe(e,t){if(!e||!e.meta)return!1;let r=typeof e.meta.requestId=="string",n=t.indexOf(e.meta.requestStatus)>-1;return r&&n}function $(e){return typeof e[0]=="function"&&"pending"in e[0]&&"fulfilled"in e[0]&&"rejected"in e[0]}function je(...e){return e.length===0?t=>pe(t,["pending"]):$(e)?V(...e.map(t=>t.pending)):je()(e[0])}function q(...e){return e.length===0?t=>pe(t,["rejected"]):$(e)?V(...e.map(t=>t.rejected)):q()(e[0])}function Fe(...e){let t=r=>r&&r.meta&&r.meta.rejectedWithValue;return e.length===0?G(q(...e),t):$(e)?G(q(...e),t):Fe()(e[0])}function Ve(...e){return e.length===0?t=>pe(t,["fulfilled"]):$(e)?V(...e.map(t=>t.fulfilled)):Ve()(e[0])}function _e(...e){return e.length===0?t=>pe(t,["pending","fulfilled","rejected"]):$(e)?V(...e.flatMap(t=>[t.pending,t.rejected,t.fulfilled])):_e()(e[0])}var Gt="ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW",v=(e=21)=>{let t="",r=e;for(;r--;)t+=Gt[Math.random()*64|0];return t};var Bt=["name","message","stack","code"],X=class{constructor(t,r){this.payload=t;this.meta=r}_type},fe=class{constructor(t,r){this.payload=t;this.meta=r}_type},Le=e=>{if(typeof e=="object"&&e!==null){let t={};for(let r of Bt)typeof e[r]=="string"&&(t[r]=e[r]);return t}return{message:String(e)}},ye=(()=>{function e(t,r,n){let o=P(t+"/fulfilled",(c,A,i,d)=>({payload:c,meta:{...d||{},arg:i,requestId:A,requestStatus:"fulfilled"}})),a=P(t+"/pending",(c,A,i)=>({payload:void 0,meta:{...i||{},arg:A,requestId:c,requestStatus:"pending"}})),s=P(t+"/rejected",(c,A,i,d,T)=>({payload:d,error:(n&&n.serializeError||Le)(c||"Rejected"),meta:{...T||{},arg:i,requestId:A,rejectedWithValue:!!d,requestStatus:"rejected",aborted:c?.name==="AbortError",condition:c?.name==="ConditionError"}}));function u(c){return(A,i,d)=>{let T=n?.idGenerator?n.idGenerator(c):v(),g=new AbortController,p,h;function l(y){h=y,g.abort()}let f=async function(){let y;try{let S=n?.condition?.(c,{getState:i,extra:d});if(Kt(S)&&(S=await S),S===!1||g.signal.aborted)throw{name:"ConditionError",message:"Aborted due to condition callback returning false."};let M=new Promise((C,E)=>{p=()=>{E({name:"AbortError",message:h||"Aborted"})},g.signal.addEventListener("abort",p)});A(a(T,c,n?.getPendingMeta?.({requestId:T,arg:c},{getState:i,extra:d}))),y=await Promise.race([M,Promise.resolve(r(c,{dispatch:A,getState:i,extra:d,requestId:T,signal:g.signal,abort:l,rejectWithValue:(C,E)=>new X(C,E),fulfillWithValue:(C,E)=>new fe(C,E)})).then(C=>{if(C instanceof X)throw C;return C instanceof fe?o(C.payload,T,c,C.meta):o(C,T,c)})])}catch(S){y=S instanceof X?s(null,T,c,S.payload,S.meta):s(S,T,c)}finally{p&&g.signal.removeEventListener("abort",p)}return n&&!n.dispatchConditionRejection&&s.match(y)&&y.meta.condition||A(y),y}();return Object.assign(f,{abort:l,requestId:T,arg:c,unwrap(){return f.then(Ue)}})}}return Object.assign(u,{pending:a,rejected:s,fulfilled:o,settled:V(s,o),typePrefix:t})}return e.withTypes=()=>e,e})();function Ue(e){if(e.meta&&e.meta.rejectedWithValue)throw e.payload;if(e.error)throw e.error;return e.payload}function Kt(e){return e!==null&&typeof e=="object"&&typeof e.then=="function"}var dt=Symbol.for("rtk-slice-createasyncthunk"),ut={[dt]:ye},We=(n=>(n.reducer="reducer",n.reducerWithPrepare="reducerWithPrepare",n.asyncThunk="asyncThunk",n))(We||{});function Ht(e,t){return`${e}/${t}`}function ze({creators:e}={}){let t=e?.asyncThunk?.[dt];return function(n){let{name:o,reducerPath:a=o}=n;if(!o)throw new Error(k(11));typeof process<"u";let s=(typeof n.reducers=="function"?n.reducers($t()):n.reducers)||{},u=Object.keys(s),c={sliceCaseReducersByName:{},sliceCaseReducersByType:{},actionCreators:{},sliceMatchers:[]},A={addCase(y,m){let S=typeof y=="string"?y:y.type;if(!S)throw new Error(k(12));if(S in c.sliceCaseReducersByType)throw new Error(k(13));return c.sliceCaseReducersByType[S]=m,A},addMatcher(y,m){return c.sliceMatchers.push({matcher:y,reducer:m}),A},exposeAction(y,m){return c.actionCreators[y]=m,A},exposeCaseReducer(y,m){return c.sliceCaseReducersByName[y]=m,A}};u.forEach(y=>{let m=s[y],S={reducerName:y,type:Ht(o,y),createNotation:typeof n.reducers=="function"};Jt(m)?Yt(S,m,A,t):Xt(S,m,A)});function i(){let[y={},m=[],S=void 0]=typeof n.extraReducers=="function"?ue(n.extraReducers):[n.extraReducers],M={...y,...c.sliceCaseReducersByType};return le(n.initialState,C=>{for(let E in M)C.addCase(E,M[E]);for(let E of c.sliceMatchers)C.addMatcher(E.matcher,E.reducer);for(let E of m)C.addMatcher(E.matcher,E.reducer);S&&C.addDefaultCase(S)})}let d=y=>y,T=new Map,g;function p(y,m){return g||(g=i()),g(y,m)}function h(){return g||(g=i()),g.getInitialState()}function l(y,m=!1){function S(C){let E=C[y];return typeof E>"u"&&m&&(E=h()),E}function M(C=d){let E=F(T,m,()=>new WeakMap);return F(E,C,()=>{let O={};for(let[Y,Z]of Object.entries(n.selectors??{}))O[Y]=qt(Z,C,h,m);return O})}return{reducerPath:y,getSelectors:M,get selectors(){return M(S)},selectSlice:S}}let f={name:o,reducer:p,actions:c.actionCreators,caseReducers:c.sliceCaseReducersByName,getInitialState:h,...l(a),injectInto(y,{reducerPath:m,...S}={}){let M=m??a;return y.inject({reducerPath:M,reducer:p},S),{...f,...l(M,!0)}}};return f}}function qt(e,t,r,n){function o(a,...s){let u=t(a);return typeof u>"u"&&n&&(u=r()),e(u,...s)}return o.unwrapped=e,o}var lt=ze();function $t(){function e(t,r){return{_reducerDefinitionType:"asyncThunk",payloadCreator:t,...r}}return e.withTypes=()=>e,{reducer(t){return Object.assign({[t.name](...r){return t(...r)}}[t.name],{_reducerDefinitionType:"reducer"})},preparedReducer(t,r){return{_reducerDefinitionType:"reducerWithPrepare",prepare:t,reducer:r}},asyncThunk:e}}function Xt({type:e,reducerName:t,createNotation:r},n,o){let a,s;if("reducer"in n){if(r&&!Qt(n))throw new Error(k(17));a=n.reducer,s=n.prepare}else a=n;o.addCase(e,a).exposeCaseReducer(t,a).exposeAction(t,s?P(e,s):P(e))}function Jt(e){return e._reducerDefinitionType==="asyncThunk"}function Qt(e){return e._reducerDefinitionType==="reducerWithPrepare"}function Yt({type:e,reducerName:t},r,n,o){if(!o)throw new Error(k(18));let{payloadCreator:a,fulfilled:s,pending:u,rejected:c,settled:A,options:i}=r,d=o(e,a,i);n.exposeAction(t,d),s&&n.addCase(d.fulfilled,s),u&&n.addCase(d.pending,u),c&&n.addCase(d.rejected,c),A&&n.addMatcher(d.settled,A),n.exposeCaseReducer(t,{fulfilled:s||he,pending:u||he,rejected:c||he,settled:A||he})}function he(){}function Zt(){return{ids:[],entities:{}}}function pt(e){function t(r={},n){let o=Object.assign(Zt(),r);return n?e.setAll(o,n):o}return{getInitialState:t}}function ft(){function e(t,r={}){let{createSelector:n=ne}=r,o=d=>d.ids,a=d=>d.entities,s=n(o,a,(d,T)=>d.map(g=>T[g])),u=(d,T)=>T,c=(d,T)=>d[T],A=n(o,d=>d.length);if(!t)return{selectIds:o,selectEntities:a,selectAll:s,selectTotal:A,selectById:n(a,u,c)};let i=n(t,a);return{selectIds:n(t,o),selectEntities:i,selectAll:n(t,s),selectTotal:n(t,A),selectById:n(i,u,c)}}return{getSelectors:e}}var Ae=__webpack_require__(7476);var en=Ae.isDraft;function yt(e){let t=w((r,n)=>e(n));return function(n){return t(n,void 0)}}function w(e){return function(r,n){function o(s){return ae(s)}let a=s=>{o(n)?e(n.payload,s):e(n,s)};return en(r)?(a(r),r):(0,Ae.produce)(r,a)}}var Te=__webpack_require__(7476);function _(e,t){return t(e)}function N(e){return Array.isArray(e)||(e=Object.values(e)),e}function J(e){return(0,Te.isDraft)(e)?(0,Te.current)(e):e}function me(e,t,r){e=N(e);let n=J(r.ids),o=new Set(n),a=[],s=[];for(let u of e){let c=_(u,t);o.has(c)?s.push({id:c,changes:u}):a.push(u)}return[a,s,n]}function Se(e){function t(p,h){let l=_(p,e);l in h.entities||(h.ids.push(l),h.entities[l]=p)}function r(p,h){p=N(p);for(let l of p)t(l,h)}function n(p,h){let l=_(p,e);l in h.entities||h.ids.push(l),h.entities[l]=p}function o(p,h){p=N(p);for(let l of p)n(l,h)}function a(p,h){p=N(p),h.ids=[],h.entities={},r(p,h)}function s(p,h){return u([p],h)}function u(p,h){let l=!1;p.forEach(f=>{f in h.entities&&(delete h.entities[f],l=!0)}),l&&(h.ids=h.ids.filter(f=>f in h.entities))}function c(p){Object.assign(p,{ids:[],entities:{}})}function A(p,h,l){let f=l.entities[h.id];if(f===void 0)return!1;let y=Object.assign({},f,h.changes),m=_(y,e),S=m!==h.id;return S&&(p[h.id]=m,delete l.entities[h.id]),l.entities[m]=y,S}function i(p,h){return d([p],h)}function d(p,h){let l={},f={};p.forEach(m=>{m.id in h.entities&&(f[m.id]={id:m.id,changes:{...f[m.id]?.changes,...m.changes}})}),p=Object.values(f),p.length>0&&p.filter(S=>A(l,S,h)).length>0&&(h.ids=Object.values(h.entities).map(S=>_(S,e)))}function T(p,h){return g([p],h)}function g(p,h){let[l,f]=me(p,e,h);d(f,h),r(l,h)}return{removeAll:yt(c),addOne:w(t),addMany:w(r),setOne:w(n),setMany:w(o),setAll:w(a),updateOne:w(i),updateMany:w(d),upsertOne:w(T),upsertMany:w(g),removeOne:w(s),removeMany:w(u)}}function tn(e,t,r){let n=0,o=e.length;for(;n<o;){let a=n+o>>>1,s=e[a];r(t,s)>=0?n=a+1:o=a}return n}function nn(e,t,r){let n=tn(e,t,r);return e.splice(n,0,t),e}function ht(e,t){let{removeOne:r,removeMany:n,removeAll:o}=Se(e);function a(l,f){return s([l],f)}function s(l,f,y){l=N(l);let m=new Set(y??J(f.ids)),S=l.filter(M=>!m.has(_(M,e)));S.length!==0&&h(f,S)}function u(l,f){return c([l],f)}function c(l,f){if(l=N(l),l.length!==0){for(let y of l)delete f.entities[e(y)];h(f,l)}}function A(l,f){l=N(l),f.entities={},f.ids=[],s(l,f,[])}function i(l,f){return d([l],f)}function d(l,f){let y=!1,m=!1;for(let S of l){let M=f.entities[S.id];if(!M)continue;y=!0,Object.assign(M,S.changes);let C=e(M);if(S.id!==C){m=!0,delete f.entities[S.id];let E=f.ids.indexOf(S.id);f.ids[E]=C,f.entities[C]=M}}y&&h(f,[],y,m)}function T(l,f){return g([l],f)}function g(l,f){let[y,m,S]=me(l,e,f);m.length&&d(m,f),y.length&&s(y,f,S)}function p(l,f){if(l.length!==f.length)return!1;for(let y=0;y<l.length;y++)if(l[y]!==f[y])return!1;return!0}let h=(l,f,y,m)=>{let S=J(l.entities),M=J(l.ids),C=l.entities,E=M;m&&(E=new Set(M));let O=[];for(let H of E){let Xe=S[H];Xe&&O.push(Xe)}let Y=O.length===0;for(let H of f)C[e(H)]=H,Y||nn(O,H,t);Y?O=f.slice().sort(t):y&&O.sort(t);let Z=O.map(e);p(M,Z)||(l.ids=Z)};return{removeOne:r,removeMany:n,removeAll:o,addOne:w(a),updateOne:w(i),upsertOne:w(T),setOne:w(u),setMany:w(c),setAll:w(A),addMany:w(s),updateMany:w(d),upsertMany:w(g)}}function At(e={}){let{selectId:t,sortComparer:r}={sortComparer:!1,selectId:s=>s.id,...e},n=r?ht(t,r):Se(t),o=pt(n),a=ft();return{selectId:t,sortComparer:r,...o,...a,...n}}var wt=__webpack_require__(2274);var rn="task",Tt="listener",mt="completed",Ge="cancelled",St=`task-${Ge}`,gt=`task-${mt}`,ge=`${Tt}-${Ge}`,kt=`${Tt}-${mt}`,b=class{constructor(t){this.code=t;this.message=`${rn} ${Ge} (reason: ${t})`}name="TaskAbortError";message};var ke=(e,t)=>{if(typeof e!="function")throw new TypeError(k(32))},B=()=>{},xe=(e,t=B)=>(e.catch(t),e),Ce=(e,t)=>(e.addEventListener("abort",t,{once:!0}),()=>e.removeEventListener("abort",t)),L=(e,t)=>{let r=e.signal;r.aborted||("reason"in r||Object.defineProperty(r,"reason",{enumerable:!0,value:t,configurable:!0,writable:!0}),e.abort(t))};var U=e=>{if(e.aborted){let{reason:t}=e;throw new b(t)}};function Be(e,t){let r=B;return new Promise((n,o)=>{let a=()=>o(new b(e.reason));if(e.aborted){a();return}r=Ce(e,a),t.finally(()=>r()).then(n,o)}).finally(()=>{r=B})}var xt=async(e,t)=>{try{return await Promise.resolve(),{status:"ok",value:await e()}}catch(r){return{status:r instanceof b?"cancelled":"rejected",error:r}}finally{t?.()}},Q=e=>t=>xe(Be(e,t).then(r=>(U(e),r))),Ke=e=>{let t=Q(e);return r=>t(new Promise(n=>setTimeout(n,r)))};var{assign:K}=Object,Ct={},Ee="listenerMiddleware",on=(e,t)=>{let r=n=>Ce(e,()=>L(n,e.reason));return(n,o)=>{ke(n,"taskExecutor");let a=new AbortController;r(a);let s=xt(async()=>{U(e),U(a.signal);let u=await n({pause:Q(a.signal),delay:Ke(a.signal),signal:a.signal});return U(a.signal),u},()=>L(a,gt));return o?.autoJoin&&t.push(s.catch(B)),{result:Q(e)(s),cancel(){L(a,St)}}}},an=(e,t)=>{let r=async(n,o)=>{U(t);let a=()=>{},u=[new Promise((c,A)=>{let i=e({predicate:n,effect:(d,T)=>{T.unsubscribe(),c([d,T.getState(),T.getOriginalState()])}});a=()=>{i(),A()}})];o!=null&&u.push(new Promise(c=>setTimeout(c,o,null)));try{let c=await Be(t,Promise.race(u));return U(t),c}finally{a()}};return(n,o)=>xe(r(n,o))},Mt=e=>{let{type:t,actionCreator:r,matcher:n,predicate:o,effect:a}=e;if(t)o=P(t).match;else if(r)t=r.type,o=r.match;else if(n)o=n;else if(!o)throw new Error(k(21));return ke(a,"options.listener"),{predicate:o,type:t,effect:a}},Pt=K(e=>{let{type:t,predicate:r,effect:n}=Mt(e);return{id:v(),effect:n,type:t,predicate:r,pending:new Set,unsubscribe:()=>{throw new Error(k(22))}}},{withTypes:()=>Pt}),Et=(e,t)=>{let{type:r,effect:n,predicate:o}=Mt(t);return Array.from(e.values()).find(a=>(typeof r=="string"?a.type===r:a.predicate===o)&&a.effect===n)},He=e=>{e.pending.forEach(t=>{L(t,ge)})},sn=e=>()=>{e.forEach(He),e.clear()},Rt=(e,t,r)=>{try{e(t,r)}catch(n){setTimeout(()=>{throw n},0)}},Re=K(P(`${Ee}/add`),{withTypes:()=>Re}),qe=P(`${Ee}/removeAll`),we=K(P(`${Ee}/remove`),{withTypes:()=>we}),cn=(...e)=>{console.error(`${Ee}/error`,...e)},bt=(e={})=>{let t=new Map,{extra:r,onError:n=cn}=e;ke(n,"onError");let o=i=>(i.unsubscribe=()=>t.delete(i.id),t.set(i.id,i),d=>{i.unsubscribe(),d?.cancelActive&&He(i)}),a=i=>{let d=Et(t,i)??Pt(i);return o(d)};K(a,{withTypes:()=>a});let s=i=>{let d=Et(t,i);return d&&(d.unsubscribe(),i.cancelActive&&He(d)),!!d};K(s,{withTypes:()=>s});let u=async(i,d,T,g)=>{let p=new AbortController,h=an(a,p.signal),l=[];try{i.pending.add(p),await Promise.resolve(i.effect(d,K({},T,{getOriginalState:g,condition:(f,y)=>h(f,y).then(Boolean),take:h,delay:Ke(p.signal),pause:Q(p.signal),extra:r,signal:p.signal,fork:on(p.signal,l),unsubscribe:i.unsubscribe,subscribe:()=>{t.set(i.id,i)},cancelActiveListeners:()=>{i.pending.forEach((f,y,m)=>{f!==p&&(L(f,ge),m.delete(f))})},cancel:()=>{L(p,ge),i.pending.delete(p)},throwIfCancelled:()=>{U(p.signal)}})))}catch(f){f instanceof b||Rt(n,f,{raisedBy:"effect"})}finally{await Promise.all(l),L(p,kt),i.pending.delete(p)}},c=sn(t);return{middleware:i=>d=>T=>{if(!(0,wt.isAction)(T))return d(T);if(Re.match(T))return a(T.payload);if(qe.match(T)){c();return}if(we.match(T))return s(T.payload);let g=i.getState(),p=()=>{if(g===Ct)throw new Error(k(23));return g},h;try{if(h=d(T),t.size>0){let l=i.getState(),f=Array.from(t.values());for(let y of f){let m=!1;try{m=y.predicate(T,l,g)}catch(S){m=!1,Rt(n,S,{raisedBy:"predicate"})}m&&u(y,T,i,p)}}}finally{g=Ct}return h},startListening:a,stopListening:s,clearListeners:c}};var It=__webpack_require__(2274);var dn=e=>({middleware:e,applied:new Map}),un=e=>t=>t?.meta?.instanceId===e,vt=()=>{let e=v(),t=new Map,r=Object.assign(P("dynamicMiddleware/add",(...u)=>({payload:u,meta:{instanceId:e}})),{withTypes:()=>r}),n=Object.assign(function(...c){c.forEach(A=>{F(t,A,dn)})},{withTypes:()=>n}),o=u=>{let c=Array.from(t.values()).map(A=>F(A.applied,u,A.middleware));return(0,It.compose)(...c)},a=G(r,un(e));return{middleware:u=>c=>A=>a(A)?(n(...A.payload),u.dispatch):o(u)(c)(A),addMiddleware:n,withMiddleware:r,instanceId:e}};var Dt=__webpack_require__(2274);var ln=e=>"reducerPath"in e&&typeof e.reducerPath=="string",pn=e=>e.flatMap(t=>ln(t)?[[t.reducerPath,t.reducer]]:Object.entries(t)),$e=Symbol.for("rtk-state-proxy-original"),fn=e=>!!e&&!!e[$e],yn=new WeakMap,hn=(e,t)=>F(yn,e,()=>new Proxy(e,{get:(r,n,o)=>{if(n===$e)return r;let a=Reflect.get(r,n,o);if(typeof a>"u"){let s=t[n.toString()];if(s){let u=s(void 0,{type:v()});if(typeof u>"u")throw new Error(k(24));return u}}return a}})),An=e=>{if(!fn(e))throw new Error(k(25));return e[$e]},Tn=(e={})=>e;function Ot(...e){let t=Object.fromEntries(pn(e)),r=()=>Object.keys(t).length?(0,Dt.combineReducers)(t):Tn,n=r();function o(u,c){return n(u,c)}o.withLazyLoadedSlices=()=>o;let a=(u,c={})=>{let{reducerPath:A,reducer:i}=u,d=t[A];return!c.overrideExisting&&d&&d!==i?(typeof process<"u",o):(t[A]=i,n=r(),o)},s=Object.assign(function(c,A){return function(d,...T){return c(hn(A?A(d,...T):d,t),...T)}},{original:An});return Object.assign(o,{inject:a,selector:s})}function k(e){return`Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `}0&&(0);
//# sourceMappingURL=redux-toolkit.production.min.cjs.map

/***/ }),

/***/ 3330:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  thunk: () => thunk,
  withExtraArgument: () => withExtraArgument
});
module.exports = __toCommonJS(src_exports);
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 2274:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  __DO_NOT_USE__ActionTypes: () => actionTypes_default,
  applyMiddleware: () => applyMiddleware,
  bindActionCreators: () => bindActionCreators,
  combineReducers: () => combineReducers,
  compose: () => compose,
  createStore: () => createStore,
  isAction: () => isAction,
  isPlainObject: () => isPlainObject,
  legacy_createStore: () => legacy_createStore
});
module.exports = __toCommonJS(src_exports);

// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/utils/kindOf.ts
function miniKindOf(val) {
  if (val === void 0)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate(val))
    return "date";
  if (isError(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (false) {}
  return typeOfVal;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }
    if (typeof action.type === "undefined") {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }
    if (typeof action.type !== "string") {
      throw new Error( true ? formatProdErrorMessage(17) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
  return createStore(reducer, preloadedState, enhancer);
}

// src/utils/warning.ts
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}

// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!isPlainObject(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (false) {}
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (false) {}
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (false) {}
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
  return function(...args) {
    return dispatch(actionCreator.apply(this, args));
  };
}
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === "function") {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== "object" || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }
  const boundActionCreators = {};
  for (const key in actionCreators) {
    const actionCreator = actionCreators[key];
    if (typeof actionCreator === "function") {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

// src/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error( true ? formatProdErrorMessage(15) : 0);
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/utils/isAction.ts
function isAction(action) {
  return isPlainObject(action) && "type" in action && typeof action.type === "string";
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=redux.cjs.map

/***/ }),

/***/ 6562:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createSelector: () => createSelector,
  createSelectorCreator: () => createSelectorCreator,
  createStructuredSelector: () => createStructuredSelector,
  lruMemoize: () => lruMemoize,
  referenceEqualityCheck: () => referenceEqualityCheck,
  setGlobalDevModeChecks: () => setGlobalDevModeChecks,
  unstable_autotrackMemoize: () => autotrackMemoize,
  weakMapMemoize: () => weakMapMemoize
});
module.exports = __toCommonJS(src_exports);

// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult) => {
  if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
    let isInputSameAsOutput = false;
    try {
      const emptyObject = {};
      if (resultFunc(emptyObject) === emptyObject)
        isInputSameAsOutput = true;
    } catch {
    }
    if (isInputSameAsOutput) {
      let stack = void 0;
      try {
        throw new Error();
      } catch (e) {
        ;
        ({ stack } = e);
      }
      console.warn(
        "The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.",
        { stack }
      );
    }
  }
};

// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs) => {
  const { memoize, memoizeOptions } = options;
  const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
  const createAnEmptyObject = memoize(() => ({}), ...memoizeOptions);
  const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
  if (!areInputSelectorResultsEqual) {
    let stack = void 0;
    try {
      throw new Error();
    } catch (e) {
      ;
      ({ stack } = e);
    }
    console.warn(
      "An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`",
      {
        arguments: inputSelectorArgs,
        firstInputs: inputSelectorResults,
        secondInputs: inputSelectorResultsCopy,
        stack
      }
    );
  }
};

// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks) => {
  Object.assign(globalDevModeChecks, devModeChecks);
};

// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
  if (!array.every((item) => typeof item === "function")) {
    const itemTypes = array.map(
      (item) => typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item
    ).join(", ");
    throw new TypeError(`${errorMessage}[${itemTypes}]`);
  }
}
var ensureIsArray = (item) => {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(
    dependencies,
    `createSelector expects all input-selectors to be functions, but received the following types: `
  );
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  const inputSelectorResults = [];
  const { length } = dependencies;
  for (let i = 0; i < length; i++) {
    inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks) => {
  const { identityFunctionCheck, inputStabilityCheck } = {
    ...globalDevModeChecks,
    ...devModeChecks
  };
  return {
    identityFunctionCheck: {
      shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
      run: runIdentityFunctionCheck
    },
    inputStabilityCheck: {
      shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
      run: runInputStabilityCheck
    }
  };
};

// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
  revision = $REVISION;
  _value;
  _lastValue;
  _isEqual = tripleEq;
  constructor(initialValue, isEqual = tripleEq) {
    this._value = this._lastValue = initialValue;
    this._isEqual = isEqual;
  }
  // Whenever a storage value is read, it'll add itself to the current tracker if
  // one exists, entangling its state with that cache.
  get value() {
    CURRENT_TRACKER?.add(this);
    return this._value;
  }
  // Whenever a storage value is updated, we bump the global revision clock,
  // assign the revision for this storage to the new value, _and_ we schedule a
  // rerender. This is important, and it's what makes autotracking  _pull_
  // based. We don't actively tell the caches which depend on the storage that
  // anything has happened. Instead, we recompute the caches when needed.
  set value(newValue) {
    if (this.value === newValue)
      return;
    this._value = newValue;
    this.revision = ++$REVISION;
  }
};
function tripleEq(a, b) {
  return a === b;
}
var TrackingCache = class {
  _cachedValue;
  _cachedRevision = -1;
  _deps = [];
  hits = 0;
  fn;
  constructor(fn) {
    this.fn = fn;
  }
  clear() {
    this._cachedValue = void 0;
    this._cachedRevision = -1;
    this._deps = [];
    this.hits = 0;
  }
  get value() {
    if (this.revision > this._cachedRevision) {
      const { fn } = this;
      const currentTracker = /* @__PURE__ */ new Set();
      const prevTracker = CURRENT_TRACKER;
      CURRENT_TRACKER = currentTracker;
      this._cachedValue = fn();
      CURRENT_TRACKER = prevTracker;
      this.hits++;
      this._deps = Array.from(currentTracker);
      this._cachedRevision = this.revision;
    }
    CURRENT_TRACKER?.add(this);
    return this._cachedValue;
  }
  get revision() {
    return Math.max(...this._deps.map((d) => d.revision), 0);
  }
};
function getValue(cell) {
  if (!(cell instanceof Cell)) {
    console.warn("Not a valid cell! ", cell);
  }
  return cell.value;
}
function setValue(storage, value) {
  if (!(storage instanceof Cell)) {
    throw new TypeError(
      "setValue must be passed a tracked store created with `createStorage`."
    );
  }
  storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
  return new Cell(initialValue, isEqual);
}
function createCache(fn) {
  assertIsFunction(
    fn,
    "the first parameter to `createCache` must be a function"
  );
  return new TrackingCache(fn);
}

// src/autotrackMemoize/tracking.ts
var neverEq = (a, b) => false;
function createTag() {
  return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
  setValue(tag, value);
}
var consumeCollection = (node) => {
  let tag = node.collectionTag;
  if (tag === null) {
    tag = node.collectionTag = createTag();
  }
  getValue(tag);
};
var dirtyCollection = (node) => {
  const tag = node.collectionTag;
  if (tag !== null) {
    dirtyTag(tag, null);
  }
};

// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
  constructor(value) {
    this.value = value;
    this.value = value;
    this.tag.value = value;
  }
  proxy = new Proxy(this, objectProxyHandler);
  tag = createTag();
  tags = {};
  children = {};
  collectionTag = null;
  id = nextId++;
};
var objectProxyHandler = {
  get(node, key) {
    function calculateResult() {
      const { value } = node;
      const childValue = Reflect.get(value, key);
      if (typeof key === "symbol") {
        return childValue;
      }
      if (key in proto) {
        return childValue;
      }
      if (typeof childValue === "object" && childValue !== null) {
        let childNode = node.children[key];
        if (childNode === void 0) {
          childNode = node.children[key] = createNode(childValue);
        }
        if (childNode.tag) {
          getValue(childNode.tag);
        }
        return childNode.proxy;
      } else {
        let tag = node.tags[key];
        if (tag === void 0) {
          tag = node.tags[key] = createTag();
          tag.value = childValue;
        }
        getValue(tag);
        return childValue;
      }
    }
    const res = calculateResult();
    return res;
  },
  ownKeys(node) {
    consumeCollection(node);
    return Reflect.ownKeys(node.value);
  },
  getOwnPropertyDescriptor(node, prop) {
    return Reflect.getOwnPropertyDescriptor(node.value, prop);
  },
  has(node, prop) {
    return Reflect.has(node.value, prop);
  }
};
var ArrayTreeNode = class {
  constructor(value) {
    this.value = value;
    this.value = value;
    this.tag.value = value;
  }
  proxy = new Proxy([this], arrayProxyHandler);
  tag = createTag();
  tags = {};
  children = {};
  collectionTag = null;
  id = nextId++;
};
var arrayProxyHandler = {
  get([node], key) {
    if (key === "length") {
      consumeCollection(node);
    }
    return objectProxyHandler.get(node, key);
  },
  ownKeys([node]) {
    return objectProxyHandler.ownKeys(node);
  },
  getOwnPropertyDescriptor([node], prop) {
    return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
  },
  has([node], prop) {
    return objectProxyHandler.has(node, prop);
  }
};
function createNode(value) {
  if (Array.isArray(value)) {
    return new ArrayTreeNode(value);
  }
  return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
  const { value, tags, children } = node;
  node.value = newValue;
  if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) {
    dirtyCollection(node);
  } else {
    if (value !== newValue) {
      let oldKeysSize = 0;
      let newKeysSize = 0;
      let anyKeysAdded = false;
      for (const _key in value) {
        oldKeysSize++;
      }
      for (const key in newValue) {
        newKeysSize++;
        if (!(key in value)) {
          anyKeysAdded = true;
          break;
        }
      }
      const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
      if (isDifferent) {
        dirtyCollection(node);
      }
    }
  }
  for (const key in tags) {
    const childValue = value[key];
    const newChildValue = newValue[key];
    if (childValue !== newChildValue) {
      dirtyCollection(node);
      dirtyTag(tags[key], newChildValue);
    }
    if (typeof newChildValue === "object" && newChildValue !== null) {
      delete tags[key];
    }
  }
  for (const key in children) {
    const childNode = children[key];
    const newChildValue = newValue[key];
    const childValue = childNode.value;
    if (childValue === newChildValue) {
      continue;
    } else if (typeof newChildValue === "object" && newChildValue !== null) {
      updateNode(childNode, newChildValue);
    } else {
      deleteNode(childNode);
      delete children[key];
    }
  }
}
function deleteNode(node) {
  if (node.tag) {
    dirtyTag(node.tag, null);
  }
  dirtyCollection(node);
  for (const key in node.tags) {
    dirtyTag(node.tags[key], null);
  }
  for (const key in node.children) {
    deleteNode(node.children[key]);
  }
}

// src/lruMemoize.ts
function createSingletonCache(equals) {
  let entry;
  return {
    get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put(key, value) {
      entry = { key, value };
    },
    getEntries() {
      return entry ? [entry] : [];
    },
    clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  let entries = [];
  function get(key) {
    const cacheIndex = entries.findIndex((entry) => equals(key, entry.key));
    if (cacheIndex > -1) {
      const entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      entries.unshift({ key, value });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return { get, put, getEntries, clear };
}
var referenceEqualityCheck = (a, b) => a === b;
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    }
    const { length } = prev;
    for (let i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }
    return true;
  };
}
function lruMemoize(func, equalityCheckOrOptions) {
  const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : { equalityCheck: equalityCheckOrOptions };
  const {
    equalityCheck = referenceEqualityCheck,
    maxSize = 1,
    resultEqualityCheck
  } = providedOptions;
  const comparator = createCacheKeyComparator(equalityCheck);
  let resultsCount = 0;
  const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    let value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const entries = cache.getEntries();
        const matchingEntry = entries.find(
          (entry) => resultEqualityCheck(entry.value, value)
        );
        if (matchingEntry) {
          value = matchingEntry.value;
          resultsCount !== 0 && resultsCount--;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = () => {
    cache.clear();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
  const node = createNode(
    []
  );
  let lastArgs = null;
  const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
  const cache = createCache(() => {
    const res = func.apply(null, node.proxy);
    return res;
  });
  function memoized() {
    if (!shallowEqual(lastArgs, arguments)) {
      updateNode(node, arguments);
      lastArgs = arguments;
    }
    return cache.value;
  }
  memoized.clearCache = () => {
    return cache.clear();
  };
  return memoized;
}

// src/weakMapMemoize.ts
var StrongRef = class {
  constructor(value) {
    this.value = value;
  }
  deref() {
    return this.value;
  }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func, options = {}) {
  let fnNode = createCacheNode();
  const { resultEqualityCheck } = options;
  let lastResult;
  let resultsCount = 0;
  function memoized() {
    let cacheNode = fnNode;
    const { length } = arguments;
    for (let i = 0, l = length; i < l; i++) {
      const arg = arguments[i];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        let objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
        }
        const objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        let primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
        }
        const primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    const terminatedNode = cacheNode;
    let result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const lastResultValue = lastResult?.deref?.() ?? lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = () => {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
  const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  const createSelector2 = (...createSelectorArgs) => {
    let recomputations = 0;
    let dependencyRecomputations = 0;
    let lastResult;
    let directlyPassedOptions = {};
    let resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(
      resultFunc,
      `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`
    );
    const combinedOptions = {
      ...createSelectorCreatorOptions,
      ...directlyPassedOptions
    };
    const {
      memoize,
      memoizeOptions = [],
      argsMemoize = weakMapMemoize,
      argsMemoizeOptions = [],
      devModeChecks = {}
    } = combinedOptions;
    const finalMemoizeOptions = ensureIsArray(memoizeOptions);
    const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    const dependencies = getDependencies(createSelectorArgs);
    const memoizedResultFunc = memoize(function recomputationWrapper() {
      recomputations++;
      return resultFunc.apply(
        null,
        arguments
      );
    }, ...finalMemoizeOptions);
    let firstRun = true;
    const selector = argsMemoize(function dependenciesChecker() {
      dependencyRecomputations++;
      const inputSelectorResults = collectInputSelectorResults(
        dependencies,
        arguments
      );
      lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
      if (false) {}
      return lastResult;
    }, ...finalArgsMemoizeOptions);
    return Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      dependencyRecomputations: () => dependencyRecomputations,
      resetDependencyRecomputations: () => {
        dependencyRecomputations = 0;
      },
      lastResult: () => lastResult,
      recomputations: () => recomputations,
      resetRecomputations: () => {
        recomputations = 0;
      },
      memoize,
      argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: () => createSelector2
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);

// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign(
  (inputSelectorsObject, selectorCreator = createSelector) => {
    assertIsObject(
      inputSelectorsObject,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`
    );
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map(
      (key) => inputSelectorsObject[key]
    );
    const structuredSelector = selectorCreator(
      dependencies,
      (...inputSelectorResults) => {
        return inputSelectorResults.reduce((composition, value, index) => {
          composition[inputSelectorKeys[index]] = value;
          return composition;
        }, {});
      }
    );
    return structuredSelector;
  },
  { withTypes: () => createStructuredSelector }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=reselect.cjs.map

/***/ }),

/***/ 3629:
/***/ (function(module) {

"use strict";
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function isArray(value) {
  return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
}

// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
var INFINITY = 1 / 0;
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
function toString(value) {
  return value == null ? '' : baseToString(value);
}
function isString(value) {
  return typeof value === 'string';
}
function isNumber(value) {
  return typeof value === 'number';
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
}
function isObject(value) {
  return _typeof(value) === 'object';
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return isObject(value) && value !== null;
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
function isBlank(value) {
  return !value.trim().length;
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}

var EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
var INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
var LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key) {
  return "Invalid value for key ".concat(key);
};
var PATTERN_LENGTH_TOO_LARGE = function PATTERN_LENGTH_TOO_LARGE(max) {
  return "Pattern length exceeds max of ".concat(max, ".");
};
var MISSING_KEY_PROPERTY = function MISSING_KEY_PROPERTY(name) {
  return "Missing ".concat(name, " property in key");
};
var INVALID_KEY_WEIGHT_VALUE = function INVALID_KEY_WEIGHT_VALUE(key) {
  return "Property 'weight' in key '".concat(key, "' must be a positive integer");
};

var hasOwn = Object.prototype.hasOwnProperty;
var KeyStore = /*#__PURE__*/function () {
  function KeyStore(keys) {
    var _this = this;
    _classCallCheck(this, KeyStore);
    this._keys = [];
    this._keyMap = {};
    var totalWeight = 0;
    keys.forEach(function (key) {
      var obj = createKey(key);
      _this._keys.push(obj);
      _this._keyMap[obj.id] = obj;
      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach(function (key) {
      key.weight /= totalWeight;
    });
  }
  _createClass(KeyStore, [{
    key: "get",
    value: function get(keyId) {
      return this._keyMap[keyId];
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._keys;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return JSON.stringify(this._keys);
    }
  }]);
  return KeyStore;
}();
function createKey(key) {
  var path = null;
  var id = null;
  var src = null;
  var weight = 1;
  var getFn = null;
  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'));
    }
    var name = key.name;
    src = name;
    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;
      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
      }
    }
    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }
  return {
    path: path,
    id: id,
    weight: weight,
    src: src,
    getFn: getFn
  };
}
function createKeyPath(key) {
  return isArray(key) ? key : key.split('.');
}
function createKeyId(key) {
  return isArray(key) ? key.join('.') : key;
}

function get(obj, path) {
  var list = [];
  var arr = false;
  var deepGet = function deepGet(obj, path, index) {
    if (!isDefined(obj)) {
      return;
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      var key = path[index];
      var value = obj[key];
      if (!isDefined(value)) {
        return;
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (var i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);
  return arr ? list : list[0];
}

var MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};
var BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: function sortFn(a, b) {
    return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
  }
};
var FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};
var AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var Config = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, BasicOptions), MatchOptions), FuzzyOptions), AdvancedOptions);

var SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var mantissa = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var cache = new Map();
  var m = Math.pow(10, mantissa);
  return {
    get: function get(value) {
      var numTokens = value.match(SPACE).length;
      if (cache.has(numTokens)) {
        return cache.get(numTokens);
      }

      // Default function is 1/sqrt(x), weight makes that variable
      var norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      var n = parseFloat(Math.round(norm * m) / m);
      cache.set(numTokens, n);
      return n;
    },
    clear: function clear() {
      cache.clear();
    }
  };
}

var FuseIndex = /*#__PURE__*/function () {
  function FuseIndex() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getFn = _ref.getFn,
      getFn = _ref$getFn === void 0 ? Config.getFn : _ref$getFn,
      _ref$fieldNormWeight = _ref.fieldNormWeight,
      fieldNormWeight = _ref$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref$fieldNormWeight;
    _classCallCheck(this, FuseIndex);
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;
    this.setIndexRecords();
  }
  _createClass(FuseIndex, [{
    key: "setSources",
    value: function setSources() {
      var docs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.docs = docs;
    }
  }, {
    key: "setIndexRecords",
    value: function setIndexRecords() {
      var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.records = records;
    }
  }, {
    key: "setKeys",
    value: function setKeys() {
      var _this = this;
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.keys = keys;
      this._keysMap = {};
      keys.forEach(function (key, idx) {
        _this._keysMap[key.id] = idx;
      });
    }
  }, {
    key: "create",
    value: function create() {
      var _this2 = this;
      if (this.isCreated || !this.docs.length) {
        return;
      }
      this.isCreated = true;

      // List is Array<String>
      if (isString(this.docs[0])) {
        this.docs.forEach(function (doc, docIndex) {
          _this2._addString(doc, docIndex);
        });
      } else {
        // List is Array<Object>
        this.docs.forEach(function (doc, docIndex) {
          _this2._addObject(doc, docIndex);
        });
      }
      this.norm.clear();
    }
    // Adds a doc to the end of the index
  }, {
    key: "add",
    value: function add(doc) {
      var idx = this.size();
      if (isString(doc)) {
        this._addString(doc, idx);
      } else {
        this._addObject(doc, idx);
      }
    }
    // Removes the doc at the specified index of the index
  }, {
    key: "removeAt",
    value: function removeAt(idx) {
      this.records.splice(idx, 1);

      // Change ref index of every subsquent doc
      for (var i = idx, len = this.size(); i < len; i += 1) {
        this.records[i].i -= 1;
      }
    }
  }, {
    key: "getValueForItemAtKeyId",
    value: function getValueForItemAtKeyId(item, keyId) {
      return item[this._keysMap[keyId]];
    }
  }, {
    key: "size",
    value: function size() {
      return this.records.length;
    }
  }, {
    key: "_addString",
    value: function _addString(doc, docIndex) {
      if (!isDefined(doc) || isBlank(doc)) {
        return;
      }
      var record = {
        v: doc,
        i: docIndex,
        n: this.norm.get(doc)
      };
      this.records.push(record);
    }
  }, {
    key: "_addObject",
    value: function _addObject(doc, docIndex) {
      var _this3 = this;
      var record = {
        i: docIndex,
        $: {}
      };

      // Iterate over every key (i.e, path), and fetch the value at that key
      this.keys.forEach(function (key, keyIndex) {
        var value = key.getFn ? key.getFn(doc) : _this3.getFn(doc, key.path);
        if (!isDefined(value)) {
          return;
        }
        if (isArray(value)) {
          var subRecords = [];
          var stack = [{
            nestedArrIndex: -1,
            value: value
          }];
          while (stack.length) {
            var _stack$pop = stack.pop(),
              nestedArrIndex = _stack$pop.nestedArrIndex,
              _value = _stack$pop.value;
            if (!isDefined(_value)) {
              continue;
            }
            if (isString(_value) && !isBlank(_value)) {
              var subRecord = {
                v: _value,
                i: nestedArrIndex,
                n: _this3.norm.get(_value)
              };
              subRecords.push(subRecord);
            } else if (isArray(_value)) {
              _value.forEach(function (item, k) {
                stack.push({
                  nestedArrIndex: k,
                  value: item
                });
              });
            } else ;
          }
          record.$[keyIndex] = subRecords;
        } else if (isString(value) && !isBlank(value)) {
          var _subRecord = {
            v: value,
            n: _this3.norm.get(value)
          };
          record.$[keyIndex] = _subRecord;
        }
      });
      this.records.push(record);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        keys: this.keys,
        records: this.records
      };
    }
  }]);
  return FuseIndex;
}();
function createIndex(keys, docs) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$getFn = _ref2.getFn,
    getFn = _ref2$getFn === void 0 ? Config.getFn : _ref2$getFn,
    _ref2$fieldNormWeight = _ref2.fieldNormWeight,
    fieldNormWeight = _ref2$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref2$fieldNormWeight;
  var myIndex = new FuseIndex({
    getFn: getFn,
    fieldNormWeight: fieldNormWeight
  });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex;
}
function parseIndex(data) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$getFn = _ref3.getFn,
    getFn = _ref3$getFn === void 0 ? Config.getFn : _ref3$getFn,
    _ref3$fieldNormWeight = _ref3.fieldNormWeight,
    fieldNormWeight = _ref3$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref3$fieldNormWeight;
  var keys = data.keys,
    records = data.records;
  var myIndex = new FuseIndex({
    getFn: getFn,
    fieldNormWeight: fieldNormWeight
  });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex;
}

function computeScore$1(pattern) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? 0 : _ref$errors,
    _ref$currentLocation = _ref.currentLocation,
    currentLocation = _ref$currentLocation === void 0 ? 0 : _ref$currentLocation,
    _ref$expectedLocation = _ref.expectedLocation,
    expectedLocation = _ref$expectedLocation === void 0 ? 0 : _ref$expectedLocation,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
    _ref$ignoreLocation = _ref.ignoreLocation,
    ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
  var accuracy = errors / pattern.length;
  if (ignoreLocation) {
    return accuracy;
  }
  var proximity = Math.abs(expectedLocation - currentLocation);
  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
  }
  return accuracy + proximity / distance;
}

function convertMaskToIndices() {
  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Config.minMatchCharLength;
  var indices = [];
  var start = -1;
  var end = -1;
  var i = 0;
  for (var len = matchmask.length; i < len; i += 1) {
    var match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }
  return indices;
}

// Machine word size
var MAX_BITS = 32;

function search(text, pattern, patternAlphabet) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? Config.location : _ref$location,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
    _ref$findAllMatches = _ref.findAllMatches,
    findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
    _ref$minMatchCharLeng = _ref.minMatchCharLength,
    minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
    _ref$includeMatches = _ref.includeMatches,
    includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
    _ref$ignoreLocation = _ref.ignoreLocation,
    ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
  }
  var patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  var textLen = text.length;
  // Handle the case when location > text.length
  var expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  var currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  var bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  var computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  var matchMask = computeMatches ? Array(textLen) : [];
  var index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    var score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });
    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;
    if (computeMatches) {
      var i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;
  var lastBitArr = [];
  var finalScore = 1;
  var binMax = patternLen + textLen;
  var mask = 1 << patternLen - 1;
  for (var _i = 0; _i < patternLen; _i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    var binMin = 0;
    var binMid = binMax;
    while (binMin < binMid) {
      var _score = computeScore$1(pattern, {
        errors: _i,
        currentLocation: expectedLocation + binMid,
        expectedLocation: expectedLocation,
        distance: distance,
        ignoreLocation: ignoreLocation
      });
      if (_score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }
      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;
    var start = Math.max(1, expectedLocation - binMid + 1);
    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    var bitArr = Array(finish + 2);
    bitArr[finish + 1] = (1 << _i) - 1;
    for (var j = finish; j >= start; j -= 1) {
      var currentLocation = j - 1;
      var charMatch = patternAlphabet[text.charAt(currentLocation)];
      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (_i) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }
      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: _i,
          currentLocation: currentLocation,
          expectedLocation: expectedLocation,
          distance: distance,
          ignoreLocation: ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break;
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    var _score2 = computeScore$1(pattern, {
      errors: _i + 1,
      currentLocation: expectedLocation,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });
    if (_score2 > currentThreshold) {
      break;
    }
    lastBitArr = bitArr;
  }
  var result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };
  if (computeMatches) {
    var indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }
  return result;
}

function createPatternAlphabet(pattern) {
  var mask = {};
  for (var i = 0, len = pattern.length; i < len; i += 1) {
    var _char = pattern.charAt(i);
    mask[_char] = (mask[_char] || 0) | 1 << len - i - 1;
  }
  return mask;
}

var BitapSearch = /*#__PURE__*/function () {
  function BitapSearch(pattern) {
    var _this = this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? Config.location : _ref$location,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
      _ref$includeMatches = _ref.includeMatches,
      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
      _ref$isCaseSensitive = _ref.isCaseSensitive,
      isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
      _ref$ignoreLocation = _ref.ignoreLocation,
      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
    _classCallCheck(this, BitapSearch);
    this.options = {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreLocation: ignoreLocation
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.chunks = [];
    if (!this.pattern.length) {
      return;
    }
    var addChunk = function addChunk(pattern, startIndex) {
      _this.chunks.push({
        pattern: pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex: startIndex
      });
    };
    var len = this.pattern.length;
    if (len > MAX_BITS) {
      var i = 0;
      var remainder = len % MAX_BITS;
      var end = len - remainder;
      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }
      if (remainder) {
        var startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }
  _createClass(BitapSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var _this$options = this.options,
        isCaseSensitive = _this$options.isCaseSensitive,
        includeMatches = _this$options.includeMatches;
      if (!isCaseSensitive) {
        text = text.toLowerCase();
      }

      // Exact match
      if (this.pattern === text) {
        var _result = {
          isMatch: true,
          score: 0
        };
        if (includeMatches) {
          _result.indices = [[0, text.length - 1]];
        }
        return _result;
      }

      // Otherwise, use Bitap algorithm
      var _this$options2 = this.options,
        location = _this$options2.location,
        distance = _this$options2.distance,
        threshold = _this$options2.threshold,
        findAllMatches = _this$options2.findAllMatches,
        minMatchCharLength = _this$options2.minMatchCharLength,
        ignoreLocation = _this$options2.ignoreLocation;
      var allIndices = [];
      var totalScore = 0;
      var hasMatches = false;
      this.chunks.forEach(function (_ref2) {
        var pattern = _ref2.pattern,
          alphabet = _ref2.alphabet,
          startIndex = _ref2.startIndex;
        var _search = search(text, pattern, alphabet, {
            location: location + startIndex,
            distance: distance,
            threshold: threshold,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            includeMatches: includeMatches,
            ignoreLocation: ignoreLocation
          }),
          isMatch = _search.isMatch,
          score = _search.score,
          indices = _search.indices;
        if (isMatch) {
          hasMatches = true;
        }
        totalScore += score;
        if (isMatch && indices) {
          allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
        }
      });
      var result = {
        isMatch: hasMatches,
        score: hasMatches ? totalScore / this.chunks.length : 1
      };
      if (hasMatches && includeMatches) {
        result.indices = allIndices;
      }
      return result;
    }
  }]);
  return BitapSearch;
}();

var BaseMatch = /*#__PURE__*/function () {
  function BaseMatch(pattern) {
    _classCallCheck(this, BaseMatch);
    this.pattern = pattern;
  }
  _createClass(BaseMatch, [{
    key: "search",
    value: function search( /*text*/) {}
  }], [{
    key: "isMultiMatch",
    value: function isMultiMatch(pattern) {
      return getMatch(pattern, this.multiRegex);
    }
  }, {
    key: "isSingleMatch",
    value: function isSingleMatch(pattern) {
      return getMatch(pattern, this.singleRegex);
    }
  }]);
  return BaseMatch;
}();
function getMatch(pattern, exp) {
  var matches = pattern.match(exp);
  return matches ? matches[1] : null;
}

var ExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(ExactMatch, _BaseMatch);
  var _super = _createSuper(ExactMatch);
  function ExactMatch(pattern) {
    _classCallCheck(this, ExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(ExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text === this.pattern;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^="(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^=(.*)$/;
    }
  }]);
  return ExactMatch;
}(BaseMatch);

var InverseExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(InverseExactMatch, _BaseMatch);
  var _super = _createSuper(InverseExactMatch);
  function InverseExactMatch(pattern) {
    _classCallCheck(this, InverseExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(InverseExactMatch, [{
    key: "search",
    value: function search(text) {
      var index = text.indexOf(this.pattern);
      var isMatch = index === -1;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)$/;
    }
  }]);
  return InverseExactMatch;
}(BaseMatch);

var PrefixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(PrefixExactMatch, _BaseMatch);
  var _super = _createSuper(PrefixExactMatch);
  function PrefixExactMatch(pattern) {
    _classCallCheck(this, PrefixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(PrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^\^(.*)$/;
    }
  }]);
  return PrefixExactMatch;
}(BaseMatch);

var InversePrefixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(InversePrefixExactMatch, _BaseMatch);
  var _super = _createSuper(InversePrefixExactMatch);
  function InversePrefixExactMatch(pattern) {
    _classCallCheck(this, InversePrefixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(InversePrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!\^(.*)$/;
    }
  }]);
  return InversePrefixExactMatch;
}(BaseMatch);

var SuffixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(SuffixExactMatch, _BaseMatch);
  var _super = _createSuper(SuffixExactMatch);
  function SuffixExactMatch(pattern) {
    _classCallCheck(this, SuffixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(SuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [text.length - this.pattern.length, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)\$$/;
    }
  }]);
  return SuffixExactMatch;
}(BaseMatch);

var InverseSuffixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(InverseSuffixExactMatch, _BaseMatch);
  var _super = _createSuper(InverseSuffixExactMatch);
  function InverseSuffixExactMatch(pattern) {
    _classCallCheck(this, InverseSuffixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(InverseSuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)\$$/;
    }
  }]);
  return InverseSuffixExactMatch;
}(BaseMatch);

var FuzzyMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(FuzzyMatch, _BaseMatch);
  var _super = _createSuper(FuzzyMatch);
  function FuzzyMatch(pattern) {
    var _this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? Config.location : _ref$location,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
      _ref$includeMatches = _ref.includeMatches,
      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
      _ref$isCaseSensitive = _ref.isCaseSensitive,
      isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
      _ref$ignoreLocation = _ref.ignoreLocation,
      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
    _classCallCheck(this, FuzzyMatch);
    _this = _super.call(this, pattern);
    _this._bitapSearch = new BitapSearch(pattern, {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreLocation: ignoreLocation
    });
    return _this;
  }
  _createClass(FuzzyMatch, [{
    key: "search",
    value: function search(text) {
      return this._bitapSearch.searchIn(text);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'fuzzy';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)$/;
    }
  }]);
  return FuzzyMatch;
}(BaseMatch);

var IncludeMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(IncludeMatch, _BaseMatch);
  var _super = _createSuper(IncludeMatch);
  function IncludeMatch(pattern) {
    _classCallCheck(this, IncludeMatch);
    return _super.call(this, pattern);
  }
  _createClass(IncludeMatch, [{
    key: "search",
    value: function search(text) {
      var location = 0;
      var index;
      var indices = [];
      var patternLen = this.pattern.length;

      // Get all exact matches
      while ((index = text.indexOf(this.pattern, location)) > -1) {
        location = index + patternLen;
        indices.push([index, location - 1]);
      }
      var isMatch = !!indices.length;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: indices
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'include';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^'"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^'(.*)$/;
    }
  }]);
  return IncludeMatch;
}(BaseMatch);

// ❗Order is important. DO NOT CHANGE.
var searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
var searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
var SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
var OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return pattern.split(OR_TOKEN).map(function (item) {
    var query = item.trim().split(SPACE_RE).filter(function (item) {
      return item && !!item.trim();
    });
    var results = [];
    for (var i = 0, len = query.length; i < len; i += 1) {
      var queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      var found = false;
      var idx = -1;
      while (!found && ++idx < searchersLen) {
        var searcher = searchers[idx];
        var token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }
      if (found) {
        continue;
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        var _searcher = searchers[idx];
        var _token = _searcher.isSingleMatch(queryItem);
        if (_token) {
          results.push(new _searcher(_token, options));
          break;
        }
      }
    }
    return results;
  });
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
var MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
var ExtendedSearch = /*#__PURE__*/function () {
  function ExtendedSearch(pattern) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$isCaseSensitive = _ref.isCaseSensitive,
      isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
      _ref$includeMatches = _ref.includeMatches,
      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
      _ref$ignoreLocation = _ref.ignoreLocation,
      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? Config.location : _ref$location,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? Config.distance : _ref$distance;
    _classCallCheck(this, ExtendedSearch);
    this.query = null;
    this.options = {
      isCaseSensitive: isCaseSensitive,
      includeMatches: includeMatches,
      minMatchCharLength: minMatchCharLength,
      findAllMatches: findAllMatches,
      ignoreLocation: ignoreLocation,
      location: location,
      threshold: threshold,
      distance: distance
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }
  _createClass(ExtendedSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var query = this.query;
      if (!query) {
        return {
          isMatch: false,
          score: 1
        };
      }
      var _this$options = this.options,
        includeMatches = _this$options.includeMatches,
        isCaseSensitive = _this$options.isCaseSensitive;
      text = isCaseSensitive ? text : text.toLowerCase();
      var numMatches = 0;
      var allIndices = [];
      var totalScore = 0;

      // ORs
      for (var i = 0, qLen = query.length; i < qLen; i += 1) {
        var searchers = query[i];

        // Reset indices
        allIndices.length = 0;
        numMatches = 0;

        // ANDs
        for (var j = 0, pLen = searchers.length; j < pLen; j += 1) {
          var searcher = searchers[j];
          var _searcher$search = searcher.search(text),
            isMatch = _searcher$search.isMatch,
            indices = _searcher$search.indices,
            score = _searcher$search.score;
          if (isMatch) {
            numMatches += 1;
            totalScore += score;
            if (includeMatches) {
              var type = searcher.constructor.type;
              if (MultiMatchSet.has(type)) {
                allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
              } else {
                allIndices.push(indices);
              }
            }
          } else {
            totalScore = 0;
            numMatches = 0;
            allIndices.length = 0;
            break;
          }
        }

        // OR condition, so if TRUE, return
        if (numMatches) {
          var result = {
            isMatch: true,
            score: totalScore / numMatches
          };
          if (includeMatches) {
            result.indices = allIndices;
          }
          return result;
        }
      }

      // Nothing was matched
      return {
        isMatch: false,
        score: 1
      };
    }
  }], [{
    key: "condition",
    value: function condition(_, options) {
      return options.useExtendedSearch;
    }
  }]);
  return ExtendedSearch;
}();

var registeredSearchers = [];
function register() {
  registeredSearchers.push.apply(registeredSearchers, arguments);
}
function createSearcher(pattern, options) {
  for (var i = 0, len = registeredSearchers.length; i < len; i += 1) {
    var searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options);
    }
  }
  return new BitapSearch(pattern, options);
}

var LogicalOperator = {
  AND: '$and',
  OR: '$or'
};
var KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};
var isExpression = function isExpression(query) {
  return !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
};
var isPath = function isPath(query) {
  return !!query[KeyType.PATH];
};
var isLeaf = function isLeaf(query) {
  return !isArray(query) && isObject(query) && !isExpression(query);
};
var convertToExplicit = function convertToExplicit(query) {
  return _defineProperty({}, LogicalOperator.AND, Object.keys(query).map(function (key) {
    return _defineProperty({}, key, query[key]);
  }));
};

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$auto = _ref3.auto,
    auto = _ref3$auto === void 0 ? true : _ref3$auto;
  var next = function next(query) {
    var keys = Object.keys(query);
    var isQueryPath = isPath(query);
    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query));
    }
    if (isLeaf(query)) {
      var key = isQueryPath ? query[KeyType.PATH] : keys[0];
      var pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
      }
      var obj = {
        keyId: createKeyId(key),
        pattern: pattern
      };
      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }
      return obj;
    }
    var node = {
      children: [],
      operator: keys[0]
    };
    keys.forEach(function (key) {
      var value = query[key];
      if (isArray(value)) {
        value.forEach(function (item) {
          node.children.push(next(item));
        });
      }
    });
    return node;
  };
  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }
  return next(query);
}

// Practical scoring function
function computeScore(results, _ref) {
  var _ref$ignoreFieldNorm = _ref.ignoreFieldNorm,
    ignoreFieldNorm = _ref$ignoreFieldNorm === void 0 ? Config.ignoreFieldNorm : _ref$ignoreFieldNorm;
  results.forEach(function (result) {
    var totalScore = 1;
    result.matches.forEach(function (_ref2) {
      var key = _ref2.key,
        norm = _ref2.norm,
        score = _ref2.score;
      var weight = key ? key.weight : null;
      totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
    });
    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  var matches = result.matches;
  data.matches = [];
  if (!isDefined(matches)) {
    return;
  }
  matches.forEach(function (match) {
    if (!isDefined(match.indices) || !match.indices.length) {
      return;
    }
    var indices = match.indices,
      value = match.value;
    var obj = {
      indices: indices,
      value: value
    };
    if (match.key) {
      obj.key = match.key.src;
    }
    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }
    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format(results, docs) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$includeMatches = _ref.includeMatches,
    includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
    _ref$includeScore = _ref.includeScore,
    includeScore = _ref$includeScore === void 0 ? Config.includeScore : _ref$includeScore;
  var transformers = [];
  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);
  return results.map(function (result) {
    var idx = result.idx;
    var data = {
      item: docs[idx],
      refIndex: idx
    };
    if (transformers.length) {
      transformers.forEach(function (transformer) {
        transformer(result, data);
      });
    }
    return data;
  });
}

var Fuse$1 = /*#__PURE__*/function () {
  function Fuse(docs) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var index = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, Fuse);
    this.options = _objectSpread2(_objectSpread2({}, Config), options);
    if (this.options.useExtendedSearch && !true) {}
    this._keyStore = new KeyStore(this.options.keys);
    this.setCollection(docs, index);
  }
  _createClass(Fuse, [{
    key: "setCollection",
    value: function setCollection(docs, index) {
      this._docs = docs;
      if (index && !(index instanceof FuseIndex)) {
        throw new Error(INCORRECT_INDEX_TYPE);
      }
      this._myIndex = index || createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
    }
  }, {
    key: "add",
    value: function add(doc) {
      if (!isDefined(doc)) {
        return;
      }
      this._docs.push(doc);
      this._myIndex.add(doc);
    }
  }, {
    key: "remove",
    value: function remove() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function /* doc, idx */ () {
        return false;
      };
      var results = [];
      for (var i = 0, len = this._docs.length; i < len; i += 1) {
        var doc = this._docs[i];
        if (predicate(doc, i)) {
          this.removeAt(i);
          i -= 1;
          len -= 1;
          results.push(doc);
        }
      }
      return results;
    }
  }, {
    key: "removeAt",
    value: function removeAt(idx) {
      this._docs.splice(idx, 1);
      this._myIndex.removeAt(idx);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this._myIndex;
    }
  }, {
    key: "search",
    value: function search(query) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$limit = _ref.limit,
        limit = _ref$limit === void 0 ? -1 : _ref$limit;
      var _this$options = this.options,
        includeMatches = _this$options.includeMatches,
        includeScore = _this$options.includeScore,
        shouldSort = _this$options.shouldSort,
        sortFn = _this$options.sortFn,
        ignoreFieldNorm = _this$options.ignoreFieldNorm;
      var results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
      computeScore(results, {
        ignoreFieldNorm: ignoreFieldNorm
      });
      if (shouldSort) {
        results.sort(sortFn);
      }
      if (isNumber(limit) && limit > -1) {
        results = results.slice(0, limit);
      }
      return format(results, this._docs, {
        includeMatches: includeMatches,
        includeScore: includeScore
      });
    }
  }, {
    key: "_searchStringList",
    value: function _searchStringList(query) {
      var searcher = createSearcher(query, this.options);
      var records = this._myIndex.records;
      var results = [];

      // Iterate over every string in the index
      records.forEach(function (_ref2) {
        var text = _ref2.v,
          idx = _ref2.i,
          norm = _ref2.n;
        if (!isDefined(text)) {
          return;
        }
        var _searcher$searchIn = searcher.searchIn(text),
          isMatch = _searcher$searchIn.isMatch,
          score = _searcher$searchIn.score,
          indices = _searcher$searchIn.indices;
        if (isMatch) {
          results.push({
            item: text,
            idx: idx,
            matches: [{
              score: score,
              value: text,
              norm: norm,
              indices: indices
            }]
          });
        }
      });
      return results;
    }
  }, {
    key: "_searchLogical",
    value: function _searchLogical(query) {
      var _this = this;
      var expression = parse(query, this.options);
      var evaluate = function evaluate(node, item, idx) {
        if (!node.children) {
          var keyId = node.keyId,
            searcher = node.searcher;
          var matches = _this._findMatches({
            key: _this._keyStore.get(keyId),
            value: _this._myIndex.getValueForItemAtKeyId(item, keyId),
            searcher: searcher
          });
          if (matches && matches.length) {
            return [{
              idx: idx,
              item: item,
              matches: matches
            }];
          }
          return [];
        }
        var res = [];
        for (var i = 0, len = node.children.length; i < len; i += 1) {
          var child = node.children[i];
          var result = evaluate(child, item, idx);
          if (result.length) {
            res.push.apply(res, _toConsumableArray(result));
          } else if (node.operator === LogicalOperator.AND) {
            return [];
          }
        }
        return res;
      };
      var records = this._myIndex.records;
      var resultMap = {};
      var results = [];
      records.forEach(function (_ref3) {
        var item = _ref3.$,
          idx = _ref3.i;
        if (isDefined(item)) {
          var expResults = evaluate(expression, item, idx);
          if (expResults.length) {
            // Dedupe when adding
            if (!resultMap[idx]) {
              resultMap[idx] = {
                idx: idx,
                item: item,
                matches: []
              };
              results.push(resultMap[idx]);
            }
            expResults.forEach(function (_ref4) {
              var _resultMap$idx$matche;
              var matches = _ref4.matches;
              (_resultMap$idx$matche = resultMap[idx].matches).push.apply(_resultMap$idx$matche, _toConsumableArray(matches));
            });
          }
        }
      });
      return results;
    }
  }, {
    key: "_searchObjectList",
    value: function _searchObjectList(query) {
      var _this2 = this;
      var searcher = createSearcher(query, this.options);
      var _this$_myIndex = this._myIndex,
        keys = _this$_myIndex.keys,
        records = _this$_myIndex.records;
      var results = [];

      // List is Array<Object>
      records.forEach(function (_ref5) {
        var item = _ref5.$,
          idx = _ref5.i;
        if (!isDefined(item)) {
          return;
        }
        var matches = [];

        // Iterate over every key (i.e, path), and fetch the value at that key
        keys.forEach(function (key, keyIndex) {
          matches.push.apply(matches, _toConsumableArray(_this2._findMatches({
            key: key,
            value: item[keyIndex],
            searcher: searcher
          })));
        });
        if (matches.length) {
          results.push({
            idx: idx,
            item: item,
            matches: matches
          });
        }
      });
      return results;
    }
  }, {
    key: "_findMatches",
    value: function _findMatches(_ref6) {
      var key = _ref6.key,
        value = _ref6.value,
        searcher = _ref6.searcher;
      if (!isDefined(value)) {
        return [];
      }
      var matches = [];
      if (isArray(value)) {
        value.forEach(function (_ref7) {
          var text = _ref7.v,
            idx = _ref7.i,
            norm = _ref7.n;
          if (!isDefined(text)) {
            return;
          }
          var _searcher$searchIn2 = searcher.searchIn(text),
            isMatch = _searcher$searchIn2.isMatch,
            score = _searcher$searchIn2.score,
            indices = _searcher$searchIn2.indices;
          if (isMatch) {
            matches.push({
              score: score,
              key: key,
              value: text,
              idx: idx,
              norm: norm,
              indices: indices
            });
          }
        });
      } else {
        var text = value.v,
          norm = value.n;
        var _searcher$searchIn3 = searcher.searchIn(text),
          isMatch = _searcher$searchIn3.isMatch,
          score = _searcher$searchIn3.score,
          indices = _searcher$searchIn3.indices;
        if (isMatch) {
          matches.push({
            score: score,
            key: key,
            value: text,
            norm: norm,
            indices: indices
          });
        }
      }
      return matches;
    }
  }]);
  return Fuse;
}();

Fuse$1.version = '7.0.0';
Fuse$1.createIndex = createIndex;
Fuse$1.parseIndex = parseIndex;
Fuse$1.config = Config;
{
  Fuse$1.parseQuery = parse;
}
{
  register(ExtendedSearch);
}
var Fuse = Fuse$1;

module.exports = Fuse;


/***/ }),

/***/ 6666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2802);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 1461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 2802:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 6522:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 2137:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BrowserNetworkClient": function() { return /* binding */ I; },
/* harmony export */   "PdtNetworkConstants": function() { return /* binding */ he; },
/* harmony export */   "getDeviceInfo": function() { return /* binding */ x; },
/* harmony export */   "initAndGetAnalyticsSdk": function() { return /* binding */ ye; },
/* harmony export */   "runtimeContextProvider": function() { return /* binding */ O; }
/* harmony export */ });
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6353);
function B(){let t="",e="abcdefghijklmnopqrstuvwxyz0123456789";for(let n=0;n<36;n++)Math.random()>.8&&n!==0&&n!==35&&t[n-1]!=="-"?t+="-":t+=e.charAt(Math.floor(Math.random()*e.length));return t}var ne=()=>{let t=new Date().getTime();return typeof performance<"u"&&typeof performance.now=="function"&&(t+=performance.now()),"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,e=>{let n=(t+Math.random()*16)%16|0;return t=Math.floor(t/16),(e==="x"?n:n&3|8).toString(16)})},y=()=>{try{let t=ne();return t||B()}catch(t){console.error(t)}return B()},J=()=>y(),j=()=>y(),q=()=>y();var f={GI:"GI",MMT:"MMT"};var A=class t{constructor(){this.settings={}}static getInstance(){return t.instance||(t.instance=new t,Object.freeze(t.instance)),t.instance}setSetting(e,n){this.settings[e]=n}getSetting(e){return this.settings[e]}},S=A.getInstance();function H(){return typeof window<"u"}function l(t,e){let n=t.split("; ");for(let r=0;r<n.length;r++){let o=n[r];if(o.indexOf(e+"=")===0)return o.substring(e.length+1)}return null}function Q(t,e){try{let n="",r=0;if(!e)throw new Error("Key is empty");for(let o=0;o<t.length;o+=1){let i=t.charCodeAt(o),s=e.charCodeAt(r),a=i^s;n+=String.fromCharCode(a),r=(r+1)%e.length}return n}catch(n){return console.error("An error occurred during the decryption process:",n),null}}function M(){let t=sessionStorage.getItem("userInfo");if(!t)return console.log("userInfo is not found in sessionStorage"),null;let e=new RegExp("^enct-"),n=t.replace(e,""),r=Q(n,"awefewfuihewfhewfuhiebc");if(!r)return console.error("Decryption failed"),null;try{return JSON.parse(r)}catch(o){return console.error("Error parsing JSON:",o),null}}function re(){let t=localStorage.getItem("userInfo");if(!t)return console.log("userInfo is not found in localStorage"),null;let e=new RegExp("^enct-"),n=t.replace(e,""),r=Q(n,"awefewfuihewfhewfuhiebc");if(!r)return console.error("Decryption failed"),null;try{return JSON.parse(r)}catch(o){return console.error("Error parsing JSON:",o),null}}function L(){let t="marketingCloudVisitorID",e=window?.s?.marketingCloudVisitorID,n=localStorage.getItem(t);return e?(e!=n&&localStorage.setItem(t,e),e):n||"NA"}function F(){return M()||re()}function w(t){if(!t)return null;let{uuid:e="",profile_type:n="PERSONAL"}=t;return n&&e?`${e}/${n.toUpperCase()}`:null}function oe(t){let n=window.location.search.substring(1).split("&");for(let r=0;r<n.length;r++){let o=n[r].split("="),i=decodeURIComponent(o[0]),s=decodeURIComponent(o[1]);if(i===t)return s}}function z(){let t=oe("cmp");return t?{campaign_name:t}:null}var $="2.0.8";var u="NA",x=t=>{let{screen:e,navigator:n}=t,r="",o=u,i=u;e&&e.width&&(o=e.width?`${e.width}`:u,i=e.height?`${e.height}`:u,r+=`${o}*${i}`);let s=l(document.cookie,"dvid")||l(document.cookie,"__gi_vid")||u,a=u;"connection"in t.navigator&&typeof t.navigator.connection=="object"&&t.navigator.connection&&"effectiveType"in t.navigator.connection&&typeof t.navigator.connection.effectiveType=="string"&&(a=t.navigator.connection.effectiveType);let{browser:g,os:c,device:p}=ua_parser_js__WEBPACK_IMPORTED_MODULE_0__(n.userAgent),m;switch(p.type?.toLowerCase()){case"mobile":case"tablet":m="pwa";break;default:m="desktop";break}return{deviceId:s,os:c.name||u,osVersion:c.version||u,browser:g.name||u,version:$||u,userAgent:n.userAgent,screenSize:r,screenWidth:o,screenHeight:i,networkType:a,platform:m,model:p.model||u,manufacturer:p.vendor||u}};var W="session_info";async function C(t,e){await e.setItem(W,JSON.stringify(t))}async function ae(t){let e=await t.getItem(W);return e?JSON.parse(e):null}var G={inActiveThresholdInMins:30,expiryInMins:120};function ce(t){if(!t)return!1;let e=Date.now(),n=(e-t.createdAt)/6e4>G.expiryInMins,r=(e-t.lastUsed)/6e4>G.inActiveThresholdInMins;return!n&&!r}async function ue(t){let e=Date.now(),n={createdAt:e,lastUsed:e,id:q(),isSynced:!1,retry:0};return await C(n,t),setTimeout(async()=>{await T(!0,void 0,t)},0),n}async function h(t){let e=await ae(t);return ce(e)?e:ue(t)}var v=class{constructor(e){this.storage=e}async getCurrentSessionId(){return(await h(this.storage)).id}async updateLastUsed(){let e=await h(this.storage);await C({...e,lastUsed:Date.now()},this.storage)}async lastUsed(){return(await h(this.storage)).lastUsed}async updateSyncStatus(){let e=await h(this.storage);await C({...e,isSynced:!e?.isSynced},this.storage)}async getSyncStatus(){return(await h(this.storage)).isSynced}async getRetryStatus(){return(await h(this.storage)).retry}async updateRetryStatus(){let e=await h(this.storage);await C({...e,retry:e?.retry+1},this.storage)}};var de="https://pdt.makemytrip.com",le="/fs/w",ge={"Content-Type":"application/json","Request-Data-Encoding":"json"},pe="NA",me="mmt_session_aero_store";async function fe({userId:t,sessionManager:e,deviceDetails:n}){let r=typeof sessionStorage<"u"?M():null,o=t;if(r!==null&&typeof r=="object"){let{uuid:g,profileType:c}=r,p=w({uuid:g,profile_type:c});o=t||p}let i=n?.device_id||l(document.cookie,"dvid")||pe,s=n?.platform||x(window)?.platform,a=await e.getCurrentSessionId();return JSON.stringify([{uuidPT:o,deviceId:i,value:{session_id:a},column:s==="pwa"?"pwa":"desktop",datasetName:me}])}var T=async(t,e,n)=>{if(!t)return"success";let r=n||R(),o=e||new v(r),i=await o.getSyncStatus(),s=await o.getRetryStatus(),a=S.getSetting("userIdPt"),g=S.getSetting("deviceContext");if(i||s>6)return"success";try{let c=`${de}${le}`,p=await fe({userId:a,sessionManager:o,deviceDetails:g}),m=await fetch(c,{method:"POST",body:p,headers:ge,keepalive:!0});if(!m.ok)throw new Error(`HTTP error! status: ${m.status}`);return await o.updateSyncStatus(),"success"}catch(c){return console.log("Failed to sync session ID to PDT DB:",c),o.updateRetryStatus(),"failure"}};var b=class{constructor(e){this.validators=[];this.newCorrelationId=()=>Promise.resolve(J());this.newRequestId=()=>Promise.resolve(j());this.getSessionId=()=>Promise.resolve(this.sessionManager.getCurrentSessionId());this.setOptOutStatus=e=>this.optInStateManager.updateOptInStatus(e);this.getOptOutStatus=()=>this.optInStateManager.readOptInStatus();this.track=async(e,n)=>{let r=await this.enrichBaseEventArg(e,n);for await(let o of this.validators)await o.assertValidSchema(r,n);this.jobQueue.pushEvent(r),this.sessionManager.updateLastUsed()};this.flushEvents=()=>{this.jobQueue.flushNow("terminal")};this.stopAutoFlush=()=>{this.flushEvents(),this.jobQueue.shutdown()};this.onAppVisibilityChange=e=>{e==="hidden"&&this.flushEvents()};this.enrichBaseEventArg=async(e,n)=>{let r=await this.getSessionId(),o=await this.newRequestId(),i=this.runtimeContextProvider?.getDeviceContext(),s=this.runtimeContextProvider?.getUserContext(this.org),a=this.runtimeContextProvider?.getUserDetailsContextExtended?.(),g=this.runtimeContextProvider?.getDeviceDetailsContextExtended?.(),c=this.sdkRuntimeProvider?.getDeviceContext(),p=this.sdkRuntimeProvider?.getUserContext(this.org),m=this.sdkRuntimeProvider?.getEventTrackingContext?.(),ee=z();if(S.setSetting("deviceContext",i),s?.uuid&&s?.profile_type){let D=w({uuid:s?.uuid,profile_type:s?.profile_type});S.setSetting("userIdPt",D)}let N=await this.sessionManager.getRetryStatus();!await this.sessionManager.getSyncStatus()&&N>0&&N<6&&setTimeout(async()=>{await T(!0,this.sessionManager,void 0)},10);let V=Object.freeze({...e,event_detail:{event_id:o,event_timestamp:Date.now(),device_details_extended:{...g},user_details_extended:{...a},...e.event_detail},event_tracking_context:{...m,...e.event_tracking_context,session_id:r},user_context:{...p,...s,...e?.user_context},device_context:{...c,...i,...e?.device_context},campaign_details:e.campaign_details||ee}),te=this.validators.map(D=>D.assertValidSchema(V,n));return await Promise.all(te),V};let{sessionManager:n,optInStateManager:r,runtimeContextProvider:o,jobQueue:i,sdkRuntimeProvider:s,org:a}=e;this.runtimeContextProvider=o,this.sdkRuntimeProvider=s,this.sessionManager=n,this.optInStateManager=r,this.jobQueue=i,this.jobQueue.start(),this.org=a||f.MMT}addValidator(e){this.validators.push(e)}setRuntimeContextProvider(e){this.runtimeContextProvider=e}};var K="analytics_opt_in",_=class{constructor(e){this.storage=e}async readOptInStatus(){let e=await this.storage.getItem(K);return Promise.resolve(e!==null&&JSON.parse(e))}async updateOptInStatus(e){await this.storage.setItem(K,`${e}`)}};var Y="https://pdt.makemytrip.com",Z="/dts/s/da/n",X={"Content-Type":"application/json","Request-Data-Encoding":"json","Accept-Encoding":"gzip"},he={PDT_HOST:Y,SEND_EVENT_ENDPOINT:Z,PDT_REQ_HEADERS:X},I=class{constructor(e){this._host=e?.host||Y,this._sendEndpoint=`${this._host}${e?.sendEndpoint||Z}`,this._baseHeaders=e?.baseHeaders||X}async sendEvents(e,n,r){if(r)return r({events:e,priority:n,headers:this._baseHeaders,endpoint:this._sendEndpoint});let o=JSON.stringify(e);return await fetch(this._sendEndpoint,{method:"POST",body:o,headers:this._baseHeaders,keepalive:!0}),Promise.resolve("success")}};var P=class{getItem(e){return localStorage.getItem(e)}setItem(e,n){localStorage.setItem(e,String(n))}};var d="NA";function Se(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch{return d}}function U(){if(!H())throw new Error("only browser environment not supported")}var O={getDeviceContext(){U();let{os:t,osVersion:e,networkType:n,version:r,browser:o,platform:i,deviceId:s,model:a,manufacturer:g,userAgent:c}=x(window);return{app_ver:r,vendor_id:o,device_id:s,os:t,os_version:e,network_type:n,platform:i,time_zone:Se(),build_ver:d,ip_addr:d,model:a,manufacturer:g,user_agent:c}},getUserContext(t){U();let e=l(document.cookie,"mmt-auth")||l(document.cookie,"OAUTH-GOIBIBO")||d,n=l(document.cookie,"gitokenid")||void 0,r=F(),o=L();return{uuid:t===f.GI?n:r?.uuid,profile_type:t===f.MMT?r?.profileType:"",is_logged_in:e!==d,marketing_cloud_id:o??"NA",login_channel:t===f.GI?f.GI:null,login_type:t===f.GI?"OTP":null}},getEventTrackingContext(){U();let t=l(document.cookie,"ccde"),e=(t==="US"?"AE":t)||d,n=l(document.cookie,"userCurrency")||d;return{template_id:0,topic_name:d,env:d,timezone:d,session_id:d,funnel_source:d,session_visit_number:0,region:e,user_preferred_currency:n}}};var k=class{constructor(){this._store={}}getItem(e){return this._store[e]||null}setItem(e,n){this._store[e]=String(n)}};var ve=60*1e3,E=class t{constructor(e,n,r){this.jobs=[];this._timer=-1;this.networkClient=e,this.storage=n,this.config=r,this.restoreState()}start(){this._timer===-1&&(this._timer=setInterval(()=>this.execute(),this.config.autoFlushIntervalInMs))}shutdown(){clearInterval(this._timer),this._timer=-1}flushNow(e="normal"){this.execute(e)}saveState(){this.storage.setItem("@events/job-queue",JSON.stringify(this.jobs))}restoreState(){let e=this.storage.getItem("@events/job-queue");e&&(this.jobs=JSON.parse(e),this.jobs=this.jobs.map(n=>({...n,status:"pending"})))}static findLast(e,n){for(let r=e.length-1;r>=0;r--){let o=e[r];if(n(o,r))return o}}pushEvent(e){let n=t.findLast(this.jobs,r=>r.status==="pending"&&r.events.length<this.config.maxBatchSize);(!n||n.events.length>=this.config.maxBatchSize)&&(n={events:[],status:"pending",id:y(),retryCount:0},this.jobs.push(n)),n.events.push(e),this.saveState()}execute(e="normal"){let n=this.jobs.filter(r=>r.status==="pending");for(let r of n)this.updateJobStatus(r,"running"),this.networkClient.sendEvents(r.events,e,null).then(o=>{o==="success"?this.updateJobStatus(r,"done"):o==="failed"&&this.updateJobStatus(r,"failed")})}updateJobStatus(e,n){let r=this.jobs.map(o=>{if(o.id!==e.id)return o;switch(n){case"done":return{...o,status:"done"};case"running":return{...o,start:Date.now(),status:"running"};case"failed":return{...o,status:o.retryCount<2?"pending":"done",retryCount:o.retryCount+1};default:return o}});r=r.filter(o=>o.status!=="done").filter(o=>!(o.status==="running"&&Date.now()-(o.start||0)>ve)),this.jobs=r,this.saveState()}};function ye(t){let e=R(),n=t.networkClient||new I,r=t.runtimeContextProvider,o=new _(e),i=new v(e),s={assertSchema:!1,autoFlushIntervalInMs:5e3,maxBatchSize:5},a=new b({optInStateManager:o,sessionManager:i,runtimeContextProvider:r,sdkRuntimeProvider:O,jobQueue:new E(n,e,s),...t});return typeof window<"u"&&document.addEventListener("visibilitychange",()=>{document.visibilityState==="hidden"&&a.onAppVisibilityChange("hidden")}),a}function R(){return(()=>{try{if(typeof window?.localStorage<"u")return!0}catch{}return!1})()?new P:new k}
//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 1512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 1701:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 406:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 6412:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 3089:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 5235:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 8200:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 129:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(303);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 2269:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 9017:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4280);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1701);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 303:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 8529:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(7211);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 7328:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),

/***/ 2746:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(1512);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(7211);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 7211:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1512);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 843:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ ReactMarkdown; }
});

// NAMESPACE OBJECT: ../../node_modules/micromark/lib/constructs.js
var constructs_namespaceObject = {};
__webpack_require__.r(constructs_namespaceObject);
__webpack_require__.d(constructs_namespaceObject, {
  "attentionMarkers": function() { return attentionMarkers; },
  "contentInitial": function() { return contentInitial; },
  "disable": function() { return disable; },
  "document": function() { return constructs_document; },
  "flow": function() { return constructs_flow; },
  "flowInitial": function() { return flowInitial; },
  "insideSpan": function() { return insideSpan; },
  "string": function() { return constructs_string; },
  "text": function() { return constructs_text; }
});

// NAMESPACE OBJECT: ../../node_modules/react-markdown/node_modules/property-information/lib/util/types.js
var types_namespaceObject = {};
__webpack_require__.r(types_namespaceObject);
__webpack_require__.d(types_namespaceObject, {
  "boolean": function() { return types_boolean; },
  "booleanish": function() { return booleanish; },
  "commaOrSpaceSeparated": function() { return commaOrSpaceSeparated; },
  "commaSeparated": function() { return commaSeparated; },
  "number": function() { return number; },
  "overloadedBoolean": function() { return overloadedBoolean; },
  "spaceSeparated": function() { return spaceSeparated; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/is-buffer/index.js
var is_buffer = __webpack_require__(3335);
;// CONCATENATED MODULE: ../../node_modules/unist-util-stringify-position/index.js
/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */

/**
 * Stringify one point, a position (start and end points), or a node’s
 * positional information.
 *
 * @param {Node|NodeLike|Position|Point|null} [value]
 * @returns {string}
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return point(value)
  }

  // ?
  return ''
}

/**
 * @param {Point|undefined} point
 * @returns {string}
 */
function point(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position|undefined} pos
 * @returns {string}
 */
function position(pos) {
  return point(pos && pos.start) + '-' + point(pos && pos.end)
}

/**
 * @param {number|undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/vfile-message/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */



class VFileMessage extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string|Error|VFileMessage} reason
   *   Reason for message.
   *   Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place at which the message occurred in a file.
   * @param {string} [origin]
   *   Place in code the message originates from (example `'my-package:my-rule-name'`)
   */
  constructor(reason, place, origin) {
    /** @type {[string|null, string|null]} */
    const parts = [null, null]
    /** @type {Position} */
    let position = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: {line: null, column: null},
      // @ts-expect-error: "
      end: {line: null, column: null}
    }

    super()

    if (typeof place === 'string') {
      origin = place
      place = undefined
    }

    if (typeof origin === 'string') {
      const index = origin.indexOf(':')

      if (index === -1) {
        parts[1] = origin
      } else {
        parts[0] = origin.slice(0, index)
        parts[1] = origin.slice(index + 1)
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          // @ts-expect-error: looks like a position.
          position = place.position
        }
      }
      // Position.
      else if ('start' in place || 'end' in place) {
        // @ts-expect-error: looks like a position.
        position = place
      }
      // Point.
      else if ('line' in place || 'column' in place) {
        position.start = place
      }
    }

    // Fields from `Error`
    this.name = stringifyPosition(place) || '1:1'
    /** @type {string} */
    this.message = typeof reason === 'object' ? reason.message : reason
    /** @type {string} */
    this.stack = ''

    if (typeof reason === 'object' && reason.stack) {
      this.stack = reason.stack
    }

    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.reason = this.message

    /* eslint-disable no-unused-expressions */
    /**
     * Whether this is a fatal problem that marks an associated file as no
     * longer processable.
     * If `true`, marks associated file as no longer processable.
     * If `false`, necessitates a (potential) change.
     * The value can also be `null` or `undefined`, for things that might not
     * need changing.
     *
     * @type {boolean?}
     */
    this.fatal

    /**
     * Starting line of error.
     *
     * @type {number?}
     */
    this.line = position.start.line

    /**
     * Starting column of error.
     *
     * @type {number?}
     */
    this.column = position.start.column

    /**
     * Full range information, when available.
     * Has `start` and `end` fields, both set to an object with `line` and
     * `column`, set to `number?`.
     *
     * @type {Position?}
     */
    this.position = position

    /**
     * Namespace of warning (example: `'my-package'`).
     *
     * @type {string?}
     */
    this.source = parts[0]

    /**
     * Category of message (example: `'my-rule-name'`).
     *
     * @type {string?}
     */
    this.ruleId = parts[1]

    /**
     * Path of a file (used throughout the VFile ecosystem).
     *
     * @type {string?}
     */
    this.file

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string?}
     */
    this.actual

    /**
     * Suggest values that should be used instead of `actual`, one or more
     * values that are deemed as acceptable.
     *
     * @type {Array<string>?}
     */
    this.expected

    /**
     * Link to documentation for the message.
     *
     * @type {string?}
     */
    this.url

    /**
     * Long form description of the message (supported by `vfile-reporter`).
     *
     * @type {string?}
     */
    this.note
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = ''
VFileMessage.prototype.name = ''
VFileMessage.prototype.reason = ''
VFileMessage.prototype.message = ''
VFileMessage.prototype.stack = ''
VFileMessage.prototype.fatal = null
VFileMessage.prototype.column = null
VFileMessage.prototype.line = null
VFileMessage.prototype.source = null
VFileMessage.prototype.ruleId = null
VFileMessage.prototype.position = null

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/vfile/lib/minpath.browser.js
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const path = {basename, dirname, extname, join, sep: '/'}

/* eslint-disable max-depth, complexity */

/**
 * @param {string} path
 * @param {string} [ext]
 * @returns {string}
 */
function basename(path, ext) {
  if (ext !== undefined && typeof ext !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath(path)
  let start = 0
  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let seenNonSlash

  if (ext === undefined || ext.length === 0 || ext.length > path.length) {
    while (index--) {
      if (path.charCodeAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true
        end = index + 1
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (ext === path) {
    return ''
  }

  let firstNonSlashEnd = -1
  let extIndex = ext.length - 1

  while (index--) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true
        firstNonSlashEnd = index + 1
      }

      if (extIndex > -1) {
        // Try to match the explicit extension.
        if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extIndex = -1
          end = firstNonSlashEnd
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd
  } else if (end < 0) {
    end = path.length
  }

  return path.slice(start, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function dirname(path) {
  assertPath(path)

  if (path.length === 0) {
    return '.'
  }

  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let unmatchedSlash

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true
    }
  }

  return end < 0
    ? path.charCodeAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.charCodeAt(0) === 47 /* `/` */
    ? '//'
    : path.slice(0, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function extname(path) {
  assertPath(path)

  let index = path.length

  let end = -1
  let startPart = 0
  let startDot = -1
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0
  /** @type {boolean|undefined} */
  let unmatchedSlash

  while (index--) {
    const code = path.charCodeAt(index)

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true
      end = index + 1
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index
      } else if (preDotState !== 1) {
        preDotState = 1
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * @param {Array<string>} segments
 * @returns {string}
 */
function join(...segments) {
  let index = -1
  /** @type {string|undefined} */
  let joined

  while (++index < segments.length) {
    assertPath(segments[index])

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index]
    }
  }

  return joined === undefined ? '.' : normalize(joined)
}

/**
 * Note: `normalize` is not exposed as `path.normalize`, so some code is
 * manually removed from it.
 *
 * @param {string} path
 * @returns {string}
 */
function normalize(path) {
  assertPath(path)

  const absolute = path.charCodeAt(0) === 47 /* `/` */

  // Normalize the path according to POSIX rules.
  let value = normalizeString(path, !absolute)

  if (value.length === 0 && !absolute) {
    value = '.'
  }

  if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */) {
    value += '/'
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 * @param {boolean} allowAboveRoot
 * @returns {string}
 */
function normalizeString(path, allowAboveRoot) {
  let result = ''
  let lastSegmentLength = 0
  let lastSlash = -1
  let dots = 0
  let index = -1
  /** @type {number|undefined} */
  let code
  /** @type {number} */
  let lastSlashIndex

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.charCodeAt(index)
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47 /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) {
        // Empty.
      } else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.charCodeAt(result.length - 1) !== 46 /* `.` */ ||
          result.charCodeAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/')

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = ''
                lastSegmentLength = 0
              } else {
                result = result.slice(0, lastSlashIndex)
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/')
              }

              lastSlash = index
              dots = 0
              continue
            }
          } else if (result.length > 0) {
            result = ''
            lastSegmentLength = 0
            lastSlash = index
            dots = 0
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..'
          lastSegmentLength = 2
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index)
        } else {
          result = path.slice(lastSlash + 1, index)
        }

        lastSegmentLength = index - lastSlash - 1
      }

      lastSlash = index
      dots = 0
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++
    } else {
      dots = -1
    }
  }

  return result
}

/**
 * @param {string} path
 */
function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/vfile/lib/minproc.browser.js
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const proc = {cwd}

function cwd() {
  return '/'
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/vfile/lib/minurl.shared.js
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */

/**
 * @param {unknown} fileURLOrPath
 * @returns {fileURLOrPath is URL}
 */
// From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function isUrl(fileURLOrPath) {
  return (
    fileURLOrPath !== null &&
    typeof fileURLOrPath === 'object' &&
    // @ts-expect-error: indexable.
    fileURLOrPath.href &&
    // @ts-expect-error: indexable.
    fileURLOrPath.origin
  )
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/vfile/lib/minurl.browser.js
/// <reference lib="dom" />



// See: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js>

/**
 * @param {string|URL} path
 */
function urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path)
  } else if (!isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    )
    error.code = 'ERR_INVALID_ARG_TYPE'
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file')
    error.code = 'ERR_INVALID_URL_SCHEME'
    throw error
  }

  return getPathFromURLPosix(path)
}

/**
 * @param {URL} url
 */
function getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    )
    error.code = 'ERR_INVALID_FILE_URL_HOST'
    throw error
  }

  const pathname = url.pathname
  let index = -1

  while (++index < pathname.length) {
    if (
      pathname.charCodeAt(index) === 37 /* `%` */ &&
      pathname.charCodeAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.charCodeAt(index + 2)
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        )
        error.code = 'ERR_INVALID_FILE_URL_PATH'
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}



;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/vfile/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {Record<string, unknown> & {type: string, position?: Position|undefined}} NodeLike
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 *
 * @typedef {'ascii'|'utf8'|'utf-8'|'utf16le'|'ucs2'|'ucs-2'|'base64'|'base64url'|'latin1'|'binary'|'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *   This is a copy of the typing from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Value|Options|VFile|URL} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 * @property {Value} [value]
 * @property {string} [cwd]
 * @property {Array<string>} [history]
 * @property {string|URL} [path]
 * @property {string} [basename]
 * @property {string} [stem]
 * @property {string} [extname]
 * @property {string} [dirname]
 * @property {Data} [data]
 *
 * @typedef Map
 *   Raw source map, see:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 * @property {Array<string>} sources
 * @property {Array<string>} names
 * @property {string|undefined} [sourceRoot]
 * @property {Array<string>|undefined} [sourcesContent]
 * @property {string} mappings
 * @property {string} file
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration: a bunch of keys that will be shallow copied over to the new
 *   file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 * @typedef {<T = ReporterSettings>(files: Array<VFile>, options: T) => string} Reporter
 */







// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
const order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname']

class VFile {
  /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, it’s treated as `{value: options}`.
   * If `options` is a `URL`, it’s treated as `{path: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All fields in `options` are set on the newly created `VFile`.
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {Compatible} [value]
   */
  constructor(value) {
    /** @type {Options} */
    let options

    if (!value) {
      options = {}
    } else if (typeof value === 'string' || is_buffer(value)) {
      // @ts-expect-error Looks like a buffer.
      options = {value}
    } else if (isUrl(value)) {
      options = {path: value}
    } else {
      // @ts-expect-error Looks like file or options.
      options = value
    }

    /**
     * Place to store custom information (default: `{}`).
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     * @type {Data}
     */
    this.data = {}

    /**
     * List of messages associated with the file.
     * @type {Array<VFileMessage>}
     */
    this.messages = []

    /**
     * List of filepaths the file moved between.
     * The first is the original path and the last is the current path.
     * @type {Array<string>}
     */
    this.history = []

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     * @type {string}
     */
    this.cwd = proc.cwd()

    /* eslint-disable no-unused-expressions */
    /**
     * Raw value.
     * @type {Value}
     */
    this.value

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.

    /**
     * Whether a file was saved to disk.
     * This is used by vfile reporters.
     * @type {boolean}
     */
    this.stored

    /**
     * Sometimes files have a non-string, compiled, representation.
     * This can be stored in the `result` field.
     * One example is when turning markdown into React nodes.
     * This is used by unified to store non-string results.
     * @type {unknown}
     */
    this.result

    /**
     * Sometimes files have a source map associated with them.
     * This can be stored in the `map` field.
     * This should be a `Map` type, which is equivalent to the `RawSourceMap`
     * type from the `source-map` module.
     * @type {Map|undefined}
     */
    this.map
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1

    while (++index < order.length) {
      const prop = order[index]

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (prop in options && options[prop] !== undefined) {
        // @ts-expect-error: TS is confused by the different types for `history`.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop]
      }
    }

    /** @type {string} */
    let prop

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(prop)) this[prop] = options[prop]
    }
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   * @param {string|URL} path
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path)
    }

    assertNonEmpty(path, 'path')

    if (this.path !== path) {
      this.history.push(path)
    }
  }

  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(dirname) {
    lib_assertPath(this.basename, 'dirname')
    this.path = path.join(dirname || '', this.basename)
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename')
    assertPart(basename, 'basename')
    this.path = path.join(this.dirname || '', basename)
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(extname) {
    assertPart(extname, 'extname')
    lib_assertPath(this.dirname, 'extname')

    if (extname) {
      if (extname.charCodeAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = path.join(this.dirname, this.stem + (extname || ''))
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path === 'string'
      ? path.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem')
    assertPart(stem, 'stem')
    this.path = path.join(this.dirname || '', stem + (this.extname || ''))
  }

  /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8']
   *   When `value` is a `Buffer`, `encoding` is a character encoding to
   *   understand it as (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    return (this.value || '').toString(encoding)
  }

  /**
   * Constructs a new `VFileMessage`, where `fatal` is set to `false`, and
   * associates it with the file by adding it to `vfile.messages` and setting
   * `message.file` to the current filepath.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  message(reason, place, origin) {
    const message = new VFileMessage(reason, place, origin)

    if (this.path) {
      message.name = this.path + ':' + message.name
      message.file = this.path
    }

    message.fatal = false

    this.messages.push(message)

    return message
  }

  /**
   * Like `VFile#message()`, but associates an informational message where
   * `fatal` is set to `null`.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = null

    return message
  }

  /**
   * Like `VFile#message()`, but associates a fatal message where `fatal` is
   * set to `true`, and then immediately throws it.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {never}
   *   Message.
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = true

    throw message
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {void}
 */
function assertPart(part, name) {
  if (part && part.includes(path.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + path.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {asserts part is string}
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string|undefined} path
 * @param {string} name
 * @returns {asserts path is string}
 */
function lib_assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

;// CONCATENATED MODULE: ../../node_modules/bail/index.js
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

// EXTERNAL MODULE: ../../node_modules/extend/index.js
var extend = __webpack_require__(9385);
;// CONCATENATED MODULE: ../../node_modules/is-plain-obj/index.js
function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

;// CONCATENATED MODULE: ../../node_modules/trough/index.js
/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = []
  /** @type {Pipeline} */
  const pipeline = {run, use}

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1
    /** @type {Callback} */
    const callback = values.pop()

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values)

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex]
      let index = -1

      if (error) {
        callback(error)
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index]
        }
      }

      // Save the newly created `output` for the next call.
      values = output

      // Next or done.
      if (fn) {
        wrap(fn, next)(...output)
      } else {
        callback(null, ...output)
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware)
    return pipeline
  }
}

/**
 * Wrap `middleware`.
 * Can be sync or async; return a promise, receive a callback, or return new
 * values and errors.
 *
 * @param {Middleware} middleware
 * @param {Callback} callback
 */
function wrap(middleware, callback) {
  /** @type {boolean} */
  let called

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length
    /** @type {any} */
    let result

    if (fnExpectsCallback) {
      parameters.push(done)
    }

    try {
      result = middleware.apply(this, parameters)
    } catch (error) {
      const exception = /** @type {Error} */ (error)

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result instanceof Promise) {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  /**
   * Call `callback`, only once.
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true
      callback(error, ...output)
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value)
  }
}

;// CONCATENATED MODULE: ../../node_modules/unified/node_modules/vfile-message/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */



class vfile_message_VFileMessage extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string|Error|VFileMessage} reason
   *   Reason for message.
   *   Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place at which the message occurred in a file.
   * @param {string} [origin]
   *   Place in code the message originates from (example `'my-package:my-rule-name'`)
   */
  constructor(reason, place, origin) {
    /** @type {[string|null, string|null]} */
    const parts = [null, null]
    /** @type {Position} */
    let position = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: {line: null, column: null},
      // @ts-expect-error: "
      end: {line: null, column: null}
    }

    super()

    if (typeof place === 'string') {
      origin = place
      place = undefined
    }

    if (typeof origin === 'string') {
      const index = origin.indexOf(':')

      if (index === -1) {
        parts[1] = origin
      } else {
        parts[0] = origin.slice(0, index)
        parts[1] = origin.slice(index + 1)
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          // @ts-expect-error: looks like a position.
          position = place.position
        }
      }
      // Position.
      else if ('start' in place || 'end' in place) {
        // @ts-expect-error: looks like a position.
        position = place
      }
      // Point.
      else if ('line' in place || 'column' in place) {
        position.start = place
      }
    }

    // Fields from `Error`
    this.name = stringifyPosition(place) || '1:1'
    /** @type {string} */
    this.message = typeof reason === 'object' ? reason.message : reason
    /** @type {string} */
    this.stack = ''

    if (typeof reason === 'object' && reason.stack) {
      this.stack = reason.stack
    }

    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.reason = this.message

    /* eslint-disable no-unused-expressions */
    /**
     * Whether this is a fatal problem that marks an associated file as no
     * longer processable.
     * If `true`, marks associated file as no longer processable.
     * If `false`, necessitates a (potential) change.
     * The value can also be `null` or `undefined`, for things that might not
     * need changing.
     *
     * @type {boolean?}
     */
    this.fatal

    /**
     * Starting line of error.
     *
     * @type {number?}
     */
    this.line = position.start.line

    /**
     * Starting column of error.
     *
     * @type {number?}
     */
    this.column = position.start.column

    /**
     * Full range information, when available.
     * Has `start` and `end` fields, both set to an object with `line` and
     * `column`, set to `number?`.
     *
     * @type {Position?}
     */
    this.position = position

    /**
     * Namespace of warning (example: `'my-package'`).
     *
     * @type {string?}
     */
    this.source = parts[0]

    /**
     * Category of message (example: `'my-rule-name'`).
     *
     * @type {string?}
     */
    this.ruleId = parts[1]

    /**
     * Path of a file (used throughout the VFile ecosystem).
     *
     * @type {string?}
     */
    this.file

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string?}
     */
    this.actual

    /**
     * Suggest values that should be used instead of `actual`, one or more
     * values that are deemed as acceptable.
     *
     * @type {Array<string>?}
     */
    this.expected

    /**
     * Link to documentation for the message.
     *
     * @type {string?}
     */
    this.url

    /**
     * Long form description of the message (supported by `vfile-reporter`).
     *
     * @type {string?}
     */
    this.note
    /* eslint-enable no-unused-expressions */
  }
}

vfile_message_VFileMessage.prototype.file = ''
vfile_message_VFileMessage.prototype.name = ''
vfile_message_VFileMessage.prototype.reason = ''
vfile_message_VFileMessage.prototype.message = ''
vfile_message_VFileMessage.prototype.stack = ''
vfile_message_VFileMessage.prototype.fatal = null
vfile_message_VFileMessage.prototype.column = null
vfile_message_VFileMessage.prototype.line = null
vfile_message_VFileMessage.prototype.source = null
vfile_message_VFileMessage.prototype.ruleId = null
vfile_message_VFileMessage.prototype.position = null

;// CONCATENATED MODULE: ../../node_modules/unified/node_modules/vfile/lib/minpath.browser.js
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const minpath_browser_path = {basename: minpath_browser_basename, dirname: minpath_browser_dirname, extname: minpath_browser_extname, join: minpath_browser_join, sep: '/'}

/* eslint-disable max-depth, complexity */

/**
 * @param {string} path
 * @param {string} [ext]
 * @returns {string}
 */
function minpath_browser_basename(path, ext) {
  if (ext !== undefined && typeof ext !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  minpath_browser_assertPath(path)
  let start = 0
  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let seenNonSlash

  if (ext === undefined || ext.length === 0 || ext.length > path.length) {
    while (index--) {
      if (path.charCodeAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true
        end = index + 1
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (ext === path) {
    return ''
  }

  let firstNonSlashEnd = -1
  let extIndex = ext.length - 1

  while (index--) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true
        firstNonSlashEnd = index + 1
      }

      if (extIndex > -1) {
        // Try to match the explicit extension.
        if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extIndex = -1
          end = firstNonSlashEnd
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd
  } else if (end < 0) {
    end = path.length
  }

  return path.slice(start, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function minpath_browser_dirname(path) {
  minpath_browser_assertPath(path)

  if (path.length === 0) {
    return '.'
  }

  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let unmatchedSlash

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true
    }
  }

  return end < 0
    ? path.charCodeAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.charCodeAt(0) === 47 /* `/` */
    ? '//'
    : path.slice(0, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function minpath_browser_extname(path) {
  minpath_browser_assertPath(path)

  let index = path.length

  let end = -1
  let startPart = 0
  let startDot = -1
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0
  /** @type {boolean|undefined} */
  let unmatchedSlash

  while (index--) {
    const code = path.charCodeAt(index)

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true
      end = index + 1
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index
      } else if (preDotState !== 1) {
        preDotState = 1
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * @param {Array<string>} segments
 * @returns {string}
 */
function minpath_browser_join(...segments) {
  let index = -1
  /** @type {string|undefined} */
  let joined

  while (++index < segments.length) {
    minpath_browser_assertPath(segments[index])

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index]
    }
  }

  return joined === undefined ? '.' : minpath_browser_normalize(joined)
}

/**
 * Note: `normalize` is not exposed as `path.normalize`, so some code is
 * manually removed from it.
 *
 * @param {string} path
 * @returns {string}
 */
function minpath_browser_normalize(path) {
  minpath_browser_assertPath(path)

  const absolute = path.charCodeAt(0) === 47 /* `/` */

  // Normalize the path according to POSIX rules.
  let value = minpath_browser_normalizeString(path, !absolute)

  if (value.length === 0 && !absolute) {
    value = '.'
  }

  if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */) {
    value += '/'
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 * @param {boolean} allowAboveRoot
 * @returns {string}
 */
function minpath_browser_normalizeString(path, allowAboveRoot) {
  let result = ''
  let lastSegmentLength = 0
  let lastSlash = -1
  let dots = 0
  let index = -1
  /** @type {number|undefined} */
  let code
  /** @type {number} */
  let lastSlashIndex

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.charCodeAt(index)
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47 /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) {
        // Empty.
      } else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.charCodeAt(result.length - 1) !== 46 /* `.` */ ||
          result.charCodeAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/')

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = ''
                lastSegmentLength = 0
              } else {
                result = result.slice(0, lastSlashIndex)
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/')
              }

              lastSlash = index
              dots = 0
              continue
            }
          } else if (result.length > 0) {
            result = ''
            lastSegmentLength = 0
            lastSlash = index
            dots = 0
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..'
          lastSegmentLength = 2
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index)
        } else {
          result = path.slice(lastSlash + 1, index)
        }

        lastSegmentLength = index - lastSlash - 1
      }

      lastSlash = index
      dots = 0
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++
    } else {
      dots = -1
    }
  }

  return result
}

/**
 * @param {string} path
 */
function minpath_browser_assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

;// CONCATENATED MODULE: ../../node_modules/unified/node_modules/vfile/lib/minproc.browser.js
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const minproc_browser_proc = {cwd: minproc_browser_cwd}

function minproc_browser_cwd() {
  return '/'
}

;// CONCATENATED MODULE: ../../node_modules/unified/node_modules/vfile/lib/minurl.shared.js
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */

/**
 * @param {unknown} fileURLOrPath
 * @returns {fileURLOrPath is URL}
 */
// From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function minurl_shared_isUrl(fileURLOrPath) {
  return (
    fileURLOrPath !== null &&
    typeof fileURLOrPath === 'object' &&
    // @ts-expect-error: indexable.
    fileURLOrPath.href &&
    // @ts-expect-error: indexable.
    fileURLOrPath.origin
  )
}

;// CONCATENATED MODULE: ../../node_modules/unified/node_modules/vfile/lib/minurl.browser.js
/// <reference lib="dom" />



// See: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js>

/**
 * @param {string|URL} path
 */
function minurl_browser_urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path)
  } else if (!minurl_shared_isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    )
    error.code = 'ERR_INVALID_ARG_TYPE'
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file')
    error.code = 'ERR_INVALID_URL_SCHEME'
    throw error
  }

  return minurl_browser_getPathFromURLPosix(path)
}

/**
 * @param {URL} url
 */
function minurl_browser_getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    )
    error.code = 'ERR_INVALID_FILE_URL_HOST'
    throw error
  }

  const pathname = url.pathname
  let index = -1

  while (++index < pathname.length) {
    if (
      pathname.charCodeAt(index) === 37 /* `%` */ &&
      pathname.charCodeAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.charCodeAt(index + 2)
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        )
        error.code = 'ERR_INVALID_FILE_URL_PATH'
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}



;// CONCATENATED MODULE: ../../node_modules/unified/node_modules/vfile/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {Record<string, unknown> & {type: string, position?: Position|undefined}} NodeLike
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 *
 * @typedef {'ascii'|'utf8'|'utf-8'|'utf16le'|'ucs2'|'ucs-2'|'base64'|'base64url'|'latin1'|'binary'|'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *   This is a copy of the typing from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Value|Options|VFile|URL} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 * @property {Value} [value]
 * @property {string} [cwd]
 * @property {Array<string>} [history]
 * @property {string|URL} [path]
 * @property {string} [basename]
 * @property {string} [stem]
 * @property {string} [extname]
 * @property {string} [dirname]
 * @property {Data} [data]
 *
 * @typedef Map
 *   Raw source map, see:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 * @property {Array<string>} sources
 * @property {Array<string>} names
 * @property {string|undefined} [sourceRoot]
 * @property {Array<string>|undefined} [sourcesContent]
 * @property {string} mappings
 * @property {string} file
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration: a bunch of keys that will be shallow copied over to the new
 *   file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 * @typedef {<T = ReporterSettings>(files: Array<VFile>, options: T) => string} Reporter
 */







// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
const lib_order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname']

class lib_VFile {
  /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, it’s treated as `{value: options}`.
   * If `options` is a `URL`, it’s treated as `{path: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All fields in `options` are set on the newly created `VFile`.
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {Compatible} [value]
   */
  constructor(value) {
    /** @type {Options} */
    let options

    if (!value) {
      options = {}
    } else if (typeof value === 'string' || is_buffer(value)) {
      // @ts-expect-error Looks like a buffer.
      options = {value}
    } else if (minurl_shared_isUrl(value)) {
      options = {path: value}
    } else {
      // @ts-expect-error Looks like file or options.
      options = value
    }

    /**
     * Place to store custom information (default: `{}`).
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     * @type {Data}
     */
    this.data = {}

    /**
     * List of messages associated with the file.
     * @type {Array<VFileMessage>}
     */
    this.messages = []

    /**
     * List of filepaths the file moved between.
     * The first is the original path and the last is the current path.
     * @type {Array<string>}
     */
    this.history = []

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     * @type {string}
     */
    this.cwd = minproc_browser_proc.cwd()

    /* eslint-disable no-unused-expressions */
    /**
     * Raw value.
     * @type {Value}
     */
    this.value

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.

    /**
     * Whether a file was saved to disk.
     * This is used by vfile reporters.
     * @type {boolean}
     */
    this.stored

    /**
     * Sometimes files have a non-string, compiled, representation.
     * This can be stored in the `result` field.
     * One example is when turning markdown into React nodes.
     * This is used by unified to store non-string results.
     * @type {unknown}
     */
    this.result

    /**
     * Sometimes files have a source map associated with them.
     * This can be stored in the `map` field.
     * This should be a `Map` type, which is equivalent to the `RawSourceMap`
     * type from the `source-map` module.
     * @type {Map|undefined}
     */
    this.map
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1

    while (++index < lib_order.length) {
      const prop = lib_order[index]

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (prop in options && options[prop] !== undefined) {
        // @ts-expect-error: TS is confused by the different types for `history`.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop]
      }
    }

    /** @type {string} */
    let prop

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!lib_order.includes(prop)) this[prop] = options[prop]
    }
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   * @param {string|URL} path
   */
  set path(path) {
    if (minurl_shared_isUrl(path)) {
      path = minurl_browser_urlToPath(path)
    }

    lib_assertNonEmpty(path, 'path')

    if (this.path !== path) {
      this.history.push(path)
    }
  }

  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path === 'string' ? minpath_browser_path.dirname(this.path) : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(dirname) {
    vfile_lib_assertPath(this.basename, 'dirname')
    this.path = minpath_browser_path.join(dirname || '', this.basename)
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path === 'string' ? minpath_browser_path.basename(this.path) : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(basename) {
    lib_assertNonEmpty(basename, 'basename')
    lib_assertPart(basename, 'basename')
    this.path = minpath_browser_path.join(this.dirname || '', basename)
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path === 'string' ? minpath_browser_path.extname(this.path) : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(extname) {
    lib_assertPart(extname, 'extname')
    vfile_lib_assertPath(this.dirname, 'extname')

    if (extname) {
      if (extname.charCodeAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = minpath_browser_path.join(this.dirname, this.stem + (extname || ''))
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path === 'string'
      ? minpath_browser_path.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(stem) {
    lib_assertNonEmpty(stem, 'stem')
    lib_assertPart(stem, 'stem')
    this.path = minpath_browser_path.join(this.dirname || '', stem + (this.extname || ''))
  }

  /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8']
   *   When `value` is a `Buffer`, `encoding` is a character encoding to
   *   understand it as (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    return (this.value || '').toString(encoding)
  }

  /**
   * Constructs a new `VFileMessage`, where `fatal` is set to `false`, and
   * associates it with the file by adding it to `vfile.messages` and setting
   * `message.file` to the current filepath.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  message(reason, place, origin) {
    const message = new vfile_message_VFileMessage(reason, place, origin)

    if (this.path) {
      message.name = this.path + ':' + message.name
      message.file = this.path
    }

    message.fatal = false

    this.messages.push(message)

    return message
  }

  /**
   * Like `VFile#message()`, but associates an informational message where
   * `fatal` is set to `null`.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = null

    return message
  }

  /**
   * Like `VFile#message()`, but associates a fatal message where `fatal` is
   * set to `true`, and then immediately throws it.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {never}
   *   Message.
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = true

    throw message
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {void}
 */
function lib_assertPart(part, name) {
  if (part && part.includes(minpath_browser_path.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + minpath_browser_path.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {asserts part is string}
 */
function lib_assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string|undefined} path
 * @param {string} name
 * @returns {asserts path is string}
 */
function vfile_lib_assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

;// CONCATENATED MODULE: ../../node_modules/unified/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */








// Expose a frozen processor.
const unified = base().freeze()

const own = {}.hasOwnProperty

// Function to create the first processor.
/**
 * @returns {Processor}
 */
function base() {
  const transformers = trough()
  /** @type {Processor['attachers']} */
  const attachers = []
  /** @type {Record<string, unknown>} */
  let namespace = {}
  /** @type {boolean|undefined} */
  let frozen
  let freezeIndex = -1

  // Data management.
  // @ts-expect-error: overloads are handled.
  processor.data = data
  processor.Parser = undefined
  processor.Compiler = undefined

  // Lock.
  processor.freeze = freeze

  // Plugins.
  processor.attachers = attachers
  // @ts-expect-error: overloads are handled.
  processor.use = use

  // API.
  processor.parse = parse
  processor.stringify = stringify
  // @ts-expect-error: overloads are handled.
  processor.run = run
  processor.runSync = runSync
  // @ts-expect-error: overloads are handled.
  processor.process = process
  processor.processSync = processSync

  // Expose.
  return processor

  // Create a new processor based on the processor in the current scope.
  /** @type {Processor} */
  function processor() {
    const destination = base()
    let index = -1

    while (++index < attachers.length) {
      destination.use(...attachers[index])
    }

    destination.data(extend(true, {}, namespace))

    return destination
  }

  /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */
  function data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen)
        namespace[key] = value
        return processor
      }

      // Get `key`.
      return (own.call(namespace, key) && namespace[key]) || null
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', frozen)
      namespace = key
      return processor
    }

    // Get space.
    return namespace
  }

  /** @type {Processor['freeze']} */
  function freeze() {
    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      const [attacher, ...options] = attachers[freezeIndex]

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined
      }

      /** @type {Transformer|void} */
      const transformer = attacher.call(processor, ...options)

      if (typeof transformer === 'function') {
        transformers.use(transformer)
      }
    }

    frozen = true
    freezeIndex = Number.POSITIVE_INFINITY

    return processor
  }

  /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */
  function use(value, ...options) {
    /** @type {Record<string, unknown>|undefined} */
    let settings

    assertUnfrozen('use', frozen)

    if (value === null || value === undefined) {
      // Empty.
    } else if (typeof value === 'function') {
      addPlugin(value, ...options)
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = Object.assign(namespace.settings || {}, settings)
    }

    return processor

    /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value)
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...options] = value
          addPlugin(plugin, ...options)
        } else {
          addPreset(value)
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {void}
     */
    function addPreset(result) {
      addList(result.plugins)

      if (result.settings) {
        settings = Object.assign(settings || {}, result.settings)
      }
    }

    /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */
    function addList(plugins) {
      let index = -1

      if (plugins === null || plugins === undefined) {
        // Empty.
      } else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index]
          add(thing)
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */
    function addPlugin(plugin, value) {
      let index = -1
      /** @type {Processor['attachers'][number]|undefined} */
      let entry

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entry = attachers[index]
          break
        }
      }

      if (entry) {
        if (isPlainObject(entry[1]) && isPlainObject(value)) {
          value = extend(true, entry[1], value)
        }

        entry[1] = value
      } else {
        // @ts-expect-error: fine.
        attachers.push([...arguments])
      }
    }
  }

  /** @type {Processor['parse']} */
  function parse(doc) {
    processor.freeze()
    const file = vfile(doc)
    const Parser = processor.Parser
    assertParser('parse', Parser)

    if (newable(Parser, 'parse')) {
      // @ts-expect-error: `newable` checks this.
      return new Parser(String(file), file).parse()
    }

    // @ts-expect-error: `newable` checks this.
    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  /** @type {Processor['stringify']} */
  function stringify(node, doc) {
    processor.freeze()
    const file = vfile(doc)
    const Compiler = processor.Compiler
    assertCompiler('stringify', Compiler)
    assertNode(node)

    if (newable(Compiler, 'compile')) {
      // @ts-expect-error: `newable` checks this.
      return new Compiler(node, file).compile()
    }

    // @ts-expect-error: `newable` checks this.
    return Compiler(node, file) // eslint-disable-line new-cap
  }

  /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */
  function run(node, doc, callback) {
    assertNode(node)
    processor.freeze()

    if (!callback && typeof doc === 'function') {
      callback = doc
      doc = undefined
    }

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
      transformers.run(node, vfile(doc), done)

      /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */
      function done(error, tree, file) {
        tree = tree || node
        if (error) {
          reject(error)
        } else if (resolve) {
          resolve(tree)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, tree, file)
        }
      }
    }
  }

  /** @type {Processor['runSync']} */
  function runSync(node, file) {
    /** @type {Node|undefined} */
    let result
    /** @type {boolean|undefined} */
    let complete

    processor.run(node, file, done)

    assertDone('runSync', 'run', complete)

    // @ts-expect-error: we either bailed on an error or have a tree.
    return result

    /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */
    function done(error, tree) {
      bail(error)
      result = tree
      complete = true
    }
  }

  /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */
  function process(doc, callback) {
    processor.freeze()
    assertParser('process', processor.Parser)
    assertCompiler('process', processor.Compiler)

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      const file = vfile(doc)

      processor.run(processor.parse(file), file, (error, tree, file) => {
        if (error || !tree || !file) {
          done(error)
        } else {
          /** @type {unknown} */
          const result = processor.stringify(tree, file)

          if (result === undefined || result === null) {
            // Empty.
          } else if (looksLikeAVFileValue(result)) {
            file.value = result
          } else {
            file.result = result
          }

          done(error, file)
        }
      })

      /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */
      function done(error, file) {
        if (error || !file) {
          reject(error)
        } else if (resolve) {
          resolve(file)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, file)
        }
      }
    }
  }

  /** @type {Processor['processSync']} */
  function processSync(doc) {
    /** @type {boolean|undefined} */
    let complete

    processor.freeze()
    assertParser('processSync', processor.Parser)
    assertCompiler('processSync', processor.Compiler)

    const file = vfile(doc)

    processor.process(file, done)

    assertDone('processSync', 'process', complete)

    return file

    /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */
    function done(error) {
      complete = true
      bail(error)
    }
  }
}

/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */
function newable(value, name) {
  return (
    typeof value === 'function' &&
    // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype &&
    // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    (keys(value.prototype) || name in value.prototype)
  )
}

/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */
function keys(value) {
  /** @type {string} */
  let key

  for (key in value) {
    if (own.call(value, key)) {
      return true
    }
  }

  return false
}

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new lib_VFile(value)
}

/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */
function looksLikeAVFileValue(value) {
  return typeof value === 'string' || is_buffer(value)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-from-markdown/node_modules/mdast-util-to-string/index.js
/**
 * @typedef Options
 * @property {boolean} [includeImageAlt=true]
 */

/**
 * Get the text content of a node.
 * Prefer the node’s plain-text fields, otherwise serialize its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} node
 * @param {Options} [options]
 * @returns {string}
 */
function mdast_util_to_string_toString(node, options) {
  var {includeImageAlt = true} = options || {}
  return one(node, includeImageAlt)
}

/**
 * @param {unknown} node
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function one(node, includeImageAlt) {
  return (
    (node &&
      typeof node === 'object' &&
      // @ts-ignore looks like a literal.
      (node.value ||
        // @ts-ignore looks like an image.
        (includeImageAlt ? node.alt : '') ||
        // @ts-ignore looks like a parent.
        ('children' in node && mdast_util_to_string_all(node.children, includeImageAlt)) ||
        (Array.isArray(node) && mdast_util_to_string_all(node, includeImageAlt)))) ||
    ''
  )
}

/**
 * @param {Array.<unknown>} values
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function mdast_util_to_string_all(values, includeImageAlt) {
  /** @type {Array.<string>} */
  var result = []
  var index = -1

  while (++index < values.length) {
    result[index] = one(values[index], includeImageAlt)
  }

  return result.join('')
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-chunked/index.js
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {number} start
 * @param {number} remove
 * @param {T[]} items
 * @returns {void}
 */
function splice(list, start, remove, items) {
  const end = list.length
  let chunkStart = 0
  /** @type {unknown[]} */

  let parameters // Make start between zero and `end` (included).

  if (start < 0) {
    start = -start > end ? 0 : end + start
  } else {
    start = start > end ? end : start
  }

  remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.

  if (items.length < 10000) {
    parameters = Array.from(items)
    parameters.unshift(start, remove) // @ts-expect-error Hush, it’s fine.
    ;[].splice.apply(list, parameters)
  } else {
    // Delete `remove` items starting from `start`
    if (remove) [].splice.apply(list, [start, remove]) // Insert the items in chunks to not cause stack overflows.

    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000)
      parameters.unshift(start, 0) // @ts-expect-error Hush, it’s fine.
      ;[].splice.apply(list, parameters)
      chunkStart += 10000
      start += 10000
    }
  }
}
/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {T[]} items
 * @returns {T[]}
 */

function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items)
    return list
  }

  return items
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-combine-extensions/index.js
/**
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */



const micromark_util_combine_extensions_hasOwnProperty = {}.hasOwnProperty

/**
 * Combine several syntax extensions into one.
 *
 * @param {Extension[]} extensions List of syntax extensions.
 * @returns {NormalizedExtension} A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {}
  let index = -1

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index])
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all Extension to merge into.
 * @param {Extension} extension Extension to merge.
 * @returns {void}
 */
function syntaxExtension(all, extension) {
  /** @type {string} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {string} */
    let code

    for (code in right) {
      if (!micromark_util_combine_extensions_hasOwnProperty.call(left, code)) left[code] = []
      const value = right[code]
      constructs(
        // @ts-expect-error Looks like a list.
        left[code],
        Array.isArray(value) ? value : value ? [value] : []
      )
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {unknown[]} existing
 * @param {unknown[]} list
 * @returns {void}
 */
function constructs(existing, list) {
  let index = -1
  /** @type {unknown[]} */
  const before = []

  while (++index < list.length) {
    // @ts-expect-error Looks like an object.
    ;(list[index].add === 'after' ? existing : before).push(list[index])
  }

  splice(existing, 0, 0, before)
}

/**
 * Combine several HTML extensions into one.
 *
 * @param {HtmlExtension[]} htmlExtensions List of HTML extensions.
 * @returns {HtmlExtension} A single combined extension.
 */
function combineHtmlExtensions(htmlExtensions) {
  /** @type {HtmlExtension} */
  const handlers = {}
  let index = -1

  while (++index < htmlExtensions.length) {
    htmlExtension(handlers, htmlExtensions[index])
  }

  return handlers
}

/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all Extension to merge into.
 * @param {HtmlExtension} extension Extension to merge.
 * @returns {void}
 */
function htmlExtension(all, extension) {
  /** @type {string} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {string} */
    let type

    if (right) {
      for (type in right) {
        left[type] = right[type]
      }
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-character/lib/unicode-punctuation-regex.js
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
const unicodePunctuationRegex =
  /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/

;// CONCATENATED MODULE: ../../node_modules/micromark-util-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 */

const asciiAlpha = regexCheck(/[A-Za-z]/)
/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 */

const asciiDigit = regexCheck(/\d/)
/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 */

const asciiHexDigit = regexCheck(/[\dA-Fa-f]/)
/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 */

const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/)
/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 */

const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/)
/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 */

const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/)
/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  )
}
/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32)
}
/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEnding(code) {
  return code !== null && code < -2
}
/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32
}
/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */

const unicodeWhitespace = regexCheck(/\s/)
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */
// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.

const unicodePunctuation = regexCheck(unicodePunctuationRegex)
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => code is number}
 */

function regexCheck(regex) {
  return check
  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code Character code
   * @returns {code is number} Whether the character code matches the bound regex
   */

  function check(code) {
    return code !== null && regex.test(String.fromCharCode(code))
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-space/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {string} type
 * @param {number} [max=Infinity]
 * @returns {State}
 */

function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type)
      return prefix(code)
    }

    return ok(code)
  }
  /** @type {State} */

  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code)
      return prefix
    }

    effects.exit(type)
    return ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/content.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {InitialConstruct} */
const content = {
  tokenize: initializeContent
}
/** @type {Initializer} */

function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  )
  /** @type {Token} */

  let previous
  return contentStart
  /** @type {State} */

  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, contentStart, 'linePrefix')
  }
  /** @type {State} */

  function paragraphInitial(code) {
    effects.enter('paragraph')
    return lineStart(code)
  }
  /** @type {State} */

  function lineStart(code) {
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    })

    if (previous) {
      previous.next = token
    }

    previous = token
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      effects.exit('chunkText')
      effects.exit('paragraph')
      effects.consume(code)
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code)
      effects.exit('chunkText')
      return lineStart
    } // Data.

    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/document.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Point} Point
 */

/**
 * @typedef {Record<string, unknown>} StackState
 * @typedef {[Construct, StackState]} StackItem
 */



/** @type {InitialConstruct} */

const document_document = {
  tokenize: initializeDocument
}
/** @type {Construct} */

const containerConstruct = {
  tokenize: tokenizeContainer
}
/** @type {Initializer} */

function initializeDocument(effects) {
  const self = this
  /** @type {Array<StackItem>} */

  const stack = []
  let continued = 0
  /** @type {TokenizeContext|undefined} */

  let childFlow
  /** @type {Token|undefined} */

  let childToken
  /** @type {number} */

  let lineStartOffset
  return start
  /** @type {State} */

  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued]
      self.containerState = item[1]
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code)
    } // Done.

    return checkNewContainers(code)
  }
  /** @type {State} */

  function documentContinue(code) {
    continued++ // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.

    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined

      if (childFlow) {
        closeFlow()
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.

      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {Point|undefined} */

      let point // Find the flow chunk.

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          point = self.events[indexBeforeFlow][1].end
          break
        }
      }

      exitContainers(continued) // Fix positions.

      let index = indexBeforeExits

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ) // Discard the duplicate exits.

      self.events.length = index
      return checkNewContainers(code)
    }

    return start(code)
  }
  /** @type {State} */

  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code)
      } // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.

      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code)
      } // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.

      self.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      )
    } // Check if there is a new container.

    self.containerState = {}
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code)
  }
  /** @type {State} */

  function thereIsANewContainer(code) {
    if (childFlow) closeFlow()
    exitContainers(continued)
    return documentContinued(code)
  }
  /** @type {State} */

  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length
    lineStartOffset = self.now().offset
    return flowStart(code)
  }
  /** @type {State} */

  function documentContinued(code) {
    // Try new containers.
    self.containerState = {}
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code)
  }
  /** @type {State} */

  function containerContinue(code) {
    continued++
    stack.push([self.currentConstruct, self.containerState]) // Try another.

    return documentContinued(code)
  }
  /** @type {State} */

  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow()
      exitContainers(0)
      effects.consume(code)
      return
    }

    childFlow = childFlow || self.parser.flow(self.now())
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    })
    return flowContinue(code)
  }
  /** @type {State} */

  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit('chunkFlow'), true)
      exitContainers(0)
      effects.consume(code)
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code)
      writeToChild(effects.exit('chunkFlow')) // Get ready for the next line.

      continued = 0
      self.interrupt = undefined
      return start
    }

    effects.consume(code)
    return flowContinue
  }
  /**
   * @param {Token} token
   * @param {boolean} [eof]
   * @returns {void}
   */

  function writeToChild(token, eof) {
    const stream = self.sliceStream(token)
    if (eof) stream.push(null)
    token.previous = childToken
    if (childToken) childToken.next = token
    childToken = token
    childFlow.defineSkip(token.start)
    childFlow.write(stream) // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.

    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length

      while (index--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index][1].end || // …or ends after it.
            childFlow.events[index][1].end.offset > lineStartOffset)
        ) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return
        }
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.

      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {boolean|undefined} */

      let seen
      /** @type {Point|undefined} */

      let point // Find the previous chunk (the one before the lazy line).

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end
            break
          }

          seen = true
        }
      }

      exitContainers(continued) // Fix positions.

      index = indexBeforeExits

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ) // Discard the duplicate exits.

      self.events.length = index
    }
  }
  /**
   * @param {number} size
   * @returns {void}
   */

  function exitContainers(size) {
    let index = stack.length // Exit open containers.

    while (index-- > size) {
      const entry = stack[index]
      self.containerState = entry[1]
      entry[0].exit.call(self, effects)
    }

    stack.length = size
  }

  function closeFlow() {
    childFlow.write([null])
    childToken = undefined
    childFlow = undefined
    self.containerState._closeFlow = undefined
  }
}
/** @type {Tokenizer} */

function tokenizeContainer(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/blank-line.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeBlankLine(effects, ok, nok) {
  return factorySpace(effects, afterWhitespace, 'linePrefix')
  /** @type {State} */

  function afterWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-subtokenize/index.js
/**
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 */


/**
 * Tokenize subcontent.
 *
 * @param {Event[]} events
 * @returns {boolean}
 */
function subtokenize(events) {
  /** @type {Record<string, number>} */
  const jumps = {}
  let index = -1
  /** @type {Event} */

  let event
  /** @type {number|undefined} */

  let lineIndex
  /** @type {number} */

  let otherIndex
  /** @type {Event} */

  let otherEvent
  /** @type {Event[]} */

  let parameters
  /** @type {Event[]} */

  let subevents
  /** @type {boolean|undefined} */

  let more

  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index]
    }

    event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.

    if (
      index &&
      event[1].type === 'chunkFlow' &&
      events[index - 1][1].type === 'listItemPrefix'
    ) {
      subevents = event[1]._tokenizer.events
      otherIndex = 0

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'lineEndingBlank'
      ) {
        otherIndex += 2
      }

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'content'
      ) {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === 'content') {
            break
          }

          if (subevents[otherIndex][1].type === 'chunkText') {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true
            otherIndex++
          }
        }
      }
    } // Enter.

    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index))
        index = jumps[index]
        more = true
      }
    } // Exit.
    else if (event[1]._container) {
      otherIndex = index
      lineIndex = undefined

      while (otherIndex--) {
        otherEvent = events[otherIndex]

        if (
          otherEvent[1].type === 'lineEnding' ||
          otherEvent[1].type === 'lineEndingBlank'
        ) {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events[lineIndex][1].type = 'lineEndingBlank'
            }

            otherEvent[1].type = 'lineEnding'
            lineIndex = otherIndex
          }
        } else {
          break
        }
      }

      if (lineIndex) {
        // Fix position.
        event[1].end = Object.assign({}, events[lineIndex][1].start) // Switch container exit w/ line endings.

        parameters = events.slice(lineIndex, index)
        parameters.unshift(event)
        splice(events, lineIndex, index - lineIndex + 1, parameters)
      }
    }
  }

  return !more
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Event[]} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */

function subcontent(events, eventIndex) {
  const token = events[eventIndex][1]
  const context = events[eventIndex][2]
  let startPosition = eventIndex - 1
  /** @type {number[]} */

  const startPositions = []
  const tokenizer =
    token._tokenizer || context.parser[token.contentType](token.start)
  const childEvents = tokenizer.events
  /** @type {[number, number][]} */

  const jumps = []
  /** @type {Record<string, number>} */

  const gaps = {}
  /** @type {Chunk[]} */

  let stream
  /** @type {Token|undefined} */

  let previous
  let index = -1
  /** @type {Token|undefined} */

  let current = token
  let adjust = 0
  let start = 0
  const breaks = [start] // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.

  while (current) {
    // Find the position of the event for this token.
    while (events[++startPosition][1] !== current) {
      // Empty.
    }

    startPositions.push(startPosition)

    if (!current._tokenizer) {
      stream = context.sliceStream(current)

      if (!current.next) {
        stream.push(null)
      }

      if (previous) {
        tokenizer.defineSkip(current.start)
      }

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true
      }

      tokenizer.write(stream)

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined
      }
    } // Unravel the next token.

    previous = current
    current = current.next
  } // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.

  current = token

  while (++index < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index][0] === 'exit' &&
      childEvents[index - 1][0] === 'enter' &&
      childEvents[index][1].type === childEvents[index - 1][1].type &&
      childEvents[index][1].start.line !== childEvents[index][1].end.line
    ) {
      start = index + 1
      breaks.push(start) // Help GC.

      current._tokenizer = undefined
      current.previous = undefined
      current = current.next
    }
  } // Help GC.

  tokenizer.events = [] // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.

  if (current) {
    // Help GC.
    current._tokenizer = undefined
    current.previous = undefined
  } else {
    breaks.pop()
  } // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.

  index = breaks.length

  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1])
    const start = startPositions.pop()
    jumps.unshift([start, start + slice.length - 1])
    splice(events, start, 2, slice)
  }

  index = -1

  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1]
    adjust += jumps[index][1] - jumps[index][0] - 1
  }

  return gaps
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/content.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */




/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content_content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
}
/** @type {Construct} */

const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
}
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */

function resolveContent(events) {
  subtokenize(events)
  return events
}
/** @type {Tokenizer} */

function tokenizeContent(effects, ok) {
  /** @type {Token} */
  let previous
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('content')
    previous = effects.enter('chunkContent', {
      contentType: 'content'
    })
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      return contentEnd(code)
    }

    if (markdownLineEnding(code)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code)
    } // Data.

    effects.consume(code)
    return data
  }
  /** @type {State} */

  function contentEnd(code) {
    effects.exit('chunkContent')
    effects.exit('content')
    return ok(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    effects.consume(code)
    effects.exit('chunkContent')
    previous.next = effects.enter('chunkContent', {
      contentType: 'content',
      previous
    })
    previous = previous.next
    return data
  }
}
/** @type {Tokenizer} */

function tokenizeContinuation(effects, ok, nok) {
  const self = this
  return startLookahead
  /** @type {State} */

  function startLookahead(code) {
    effects.exit('chunkContent')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, prefixed, 'linePrefix')
  }
  /** @type {State} */

  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    const tail = self.events[self.events.length - 1]

    if (
      !self.parser.constructs.disable.null.includes('codeIndented') &&
      tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
    ) {
      return ok(code)
    }

    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/flow.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 */




/** @type {InitialConstruct} */
const flow = {
  tokenize: initializeFlow
}
/** @type {Initializer} */

function initializeFlow(effects) {
  const self = this
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content_content, afterConstruct)
        ),
        'linePrefix'
      )
    )
  )
  return initial
  /** @type {State} */

  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    self.currentConstruct = undefined
    return initial
  }
  /** @type {State} */

  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    self.currentConstruct = undefined
    return initial
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/text.js
/**
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */
const resolver = {
  resolveAll: createResolver()
}
const string = initializeFactory('string')
const text_text = initializeFactory('text')
/**
 * @param {'string'|'text'} field
 * @returns {InitialConstruct}
 */

function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === 'text' ? resolveAllLineSuffixes : undefined
    )
  }
  /** @type {Initializer} */

  function initializeText(effects) {
    const self = this
    const constructs = this.parser.constructs[field]
    const text = effects.attempt(constructs, start, notText)
    return start
    /** @type {State} */

    function start(code) {
      return atBreak(code) ? text(code) : notText(code)
    }
    /** @type {State} */

    function notText(code) {
      if (code === null) {
        effects.consume(code)
        return
      }

      effects.enter('data')
      effects.consume(code)
      return data
    }
    /** @type {State} */

    function data(code) {
      if (atBreak(code)) {
        effects.exit('data')
        return text(code)
      } // Data.

      effects.consume(code)
      return data
    }
    /**
     * @param {Code} code
     * @returns {boolean}
     */

    function atBreak(code) {
      if (code === null) {
        return true
      }

      const list = constructs[code]
      let index = -1

      if (list) {
        while (++index < list.length) {
          const item = list[index]

          if (!item.previous || item.previous.call(self, self.previous)) {
            return true
          }
        }
      }

      return false
    }
  }
}
/**
 * @param {Resolver} [extraResolver]
 * @returns {Resolver}
 */

function createResolver(extraResolver) {
  return resolveAllText
  /** @type {Resolver} */

  function resolveAllText(events, context) {
    let index = -1
    /** @type {number|undefined} */

    let enter // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.

    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index
          index++
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end
          events.splice(enter + 2, index - enter - 2)
          index = enter + 2
        }

        enter = undefined
      }
    }

    return extraResolver ? extraResolver(events, context) : events
  }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */

function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0 // Skip first.

  while (++eventIndex <= events.length) {
    if (
      (eventIndex === events.length ||
        events[eventIndex][1].type === 'lineEnding') &&
      events[eventIndex - 1][1].type === 'data'
    ) {
      const data = events[eventIndex - 1][1]
      const chunks = context.sliceStream(data)
      let index = chunks.length
      let bufferIndex = -1
      let size = 0
      /** @type {boolean|undefined} */

      let tabs

      while (index--) {
        const chunk = chunks[index]

        if (typeof chunk === 'string') {
          bufferIndex = chunk.length

          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++
            bufferIndex--
          }

          if (bufferIndex) break
          bufferIndex = -1
        } // Number
        else if (chunk === -2) {
          tabs = true
          size++
        } else if (chunk === -1) {
          // Empty
        } else {
          // Replacement character, exit.
          index++
          break
        }
      }

      if (size) {
        const token = {
          type:
            eventIndex === events.length || tabs || size < 2
              ? 'lineSuffix'
              : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index
              ? bufferIndex
              : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        }
        data.end = Object.assign({}, token.start)

        if (data.start.offset === data.end.offset) {
          Object.assign(data, token)
        } else {
          events.splice(
            eventIndex,
            0,
            ['enter', token, context],
            ['exit', token, context]
          )
          eventIndex += 2
        }
      }

      eventIndex++
    }
  }

  return events
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-resolve-all/index.js
/**
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {{resolveAll?: Resolver}[]} constructs
 * @param {Event[]} events
 * @param {TokenizeContext} context
 * @returns {Event[]}
 */
function resolveAll(constructs, events, context) {
  /** @type {Resolver[]} */
  const called = []
  let index = -1

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context)
      called.push(resolve)
    }
  }

  return events
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/create-tokenizer.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 */

/**
 * @typedef Info
 * @property {() => void} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */




/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 * @param {InitialConstruct} initialize
 * @param {Omit<Point, '_index'|'_bufferIndex'>} [from]
 * @returns {TokenizeContext}
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = Object.assign(
    from
      ? Object.assign({}, from)
      : {
          line: 1,
          column: 1,
          offset: 0
        },
    {
      _index: 0,
      _bufferIndex: -1
    }
  )
  /** @type {Record<string, number>} */

  const columnStart = {}
  /** @type {Array<Construct>} */

  const resolveAllConstructs = []
  /** @type {Array<Chunk>} */

  let chunks = []
  /** @type {Array<Token>} */

  let stack = []
  /** @type {boolean|undefined} */

  let consumed = true
  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */

  const effects = {
    consume,
    enter,
    exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  }
  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */

  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  }
  /**
   * The state function.
   *
   * @type {State|void}
   */

  let state = initialize.tokenize.call(context, effects)
  /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */

  let expectedCode

  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize)
  }

  return context
  /** @type {TokenizeContext['write']} */

  function write(slice) {
    chunks = push(chunks, slice)
    main() // Exit if we’re not done, resolve might change stuff.

    if (chunks[chunks.length - 1] !== null) {
      return []
    }

    addResult(initialize, 0) // Otherwise, resolve, and exit.

    context.events = resolveAll(resolveAllConstructs, context.events, context)
    return context.events
  } //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */

  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs)
  }
  /** @type {TokenizeContext['sliceStream']} */

  function sliceStream(token) {
    return sliceChunks(chunks, token)
  }
  /** @type {TokenizeContext['now']} */

  function now() {
    return Object.assign({}, point)
  }
  /** @type {TokenizeContext['defineSkip']} */

  function defineSkip(value) {
    columnStart[value.line] = value.column
    accountForPotentialSkip()
  } //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */

  function main() {
    /** @type {number} */
    let chunkIndex

    while (point._index < chunks.length) {
      const chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.

      if (typeof chunk === 'string') {
        chunkIndex = point._index

        if (point._bufferIndex < 0) {
          point._bufferIndex = 0
        }

        while (
          point._index === chunkIndex &&
          point._bufferIndex < chunk.length
        ) {
          go(chunk.charCodeAt(point._bufferIndex))
        }
      } else {
        go(chunk)
      }
    }
  }
  /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */

  function go(code) {
    consumed = undefined
    expectedCode = code
    state = state(code)
  }
  /** @type {Effects['consume']} */

  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++
      point.column = 1
      point.offset += code === -3 ? 2 : 1
      accountForPotentialSkip()
    } else if (code !== -1) {
      point.column++
      point.offset++
    } // Not in a string chunk.

    if (point._bufferIndex < 0) {
      point._index++
    } else {
      point._bufferIndex++ // At end of string chunk.
      // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
      // strings.

      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1
        point._index++
      }
    } // Expose the previous character.

    context.previous = code // Mark as consumed.

    consumed = true
  }
  /** @type {Effects['enter']} */

  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {}
    token.type = type
    token.start = now()
    context.events.push(['enter', token, context])
    stack.push(token)
    return token
  }
  /** @type {Effects['exit']} */

  function exit(type) {
    const token = stack.pop()
    token.end = now()
    context.events.push(['exit', token, context])
    return token
  }
  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from)
  }
  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulcheck(_, info) {
    info.restore()
  }
  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {Record<string, unknown>} [fields]
   */

  function constructFactory(onreturn, fields) {
    return hook
    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Construct|Array<Construct>|ConstructRecord} constructs
     * @param {State} returnState
     * @param {State} [bogusState]
     * @returns {State}
     */

    function hook(constructs, returnState, bogusState) {
      /** @type {Array<Construct>} */
      let listOfConstructs
      /** @type {number} */

      let constructIndex
      /** @type {Construct} */

      let currentConstruct
      /** @type {Info} */

      let info
      return Array.isArray(constructs)
        ? /* c8 ignore next 1 */
          handleListOfConstructs(constructs)
        : 'tokenize' in constructs // @ts-expect-error Looks like a construct.
        ? handleListOfConstructs([constructs])
        : handleMapOfConstructs(constructs)
      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */

      function handleMapOfConstructs(map) {
        return start
        /** @type {State} */

        function start(code) {
          const def = code !== null && map[code]
          const all = code !== null && map.null
          const list = [
            // To do: add more extension tests.

            /* c8 ignore next 2 */
            ...(Array.isArray(def) ? def : def ? [def] : []),
            ...(Array.isArray(all) ? all : all ? [all] : [])
          ]
          return handleListOfConstructs(list)(code)
        }
      }
      /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */

      function handleListOfConstructs(list) {
        listOfConstructs = list
        constructIndex = 0

        if (list.length === 0) {
          return bogusState
        }

        return handleConstruct(list[constructIndex])
      }
      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */

      function handleConstruct(construct) {
        return start
        /** @type {State} */

        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store()
          currentConstruct = construct

          if (!construct.partial) {
            context.currentConstruct = construct
          }

          if (
            construct.name &&
            context.parser.constructs.disable.null.includes(construct.name)
          ) {
            return nok(code)
          }

          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code)
        }
      }
      /** @type {State} */

      function ok(code) {
        consumed = true
        onreturn(currentConstruct, info)
        return returnState
      }
      /** @type {State} */

      function nok(code) {
        consumed = true
        info.restore()

        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex])
        }

        return bogusState
      }
    }
  }
  /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */

  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct)
    }

    if (construct.resolve) {
      splice(
        context.events,
        from,
        context.events.length - from,
        construct.resolve(context.events.slice(from), context)
      )
    }

    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context)
    }
  }
  /**
   * Store state.
   *
   * @returns {Info}
   */

  function store() {
    const startPoint = now()
    const startPrevious = context.previous
    const startCurrentConstruct = context.currentConstruct
    const startEventsIndex = context.events.length
    const startStack = Array.from(stack)
    return {
      restore,
      from: startEventsIndex
    }
    /**
     * Restore state.
     *
     * @returns {void}
     */

    function restore() {
      point = startPoint
      context.previous = startPrevious
      context.currentConstruct = startCurrentConstruct
      context.events.length = startEventsIndex
      stack = startStack
      accountForPotentialSkip()
    }
  }
  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */

  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line]
      point.offset += columnStart[point.line] - 1
    }
  }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'start'|'end'>} token
 * @returns {Array<Chunk>}
 */

function sliceChunks(chunks, token) {
  const startIndex = token.start._index
  const startBufferIndex = token.start._bufferIndex
  const endIndex = token.end._index
  const endBufferIndex = token.end._bufferIndex
  /** @type {Array<Chunk>} */

  let view

  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)]
  } else {
    view = chunks.slice(startIndex, endIndex)

    if (startBufferIndex > -1) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view[0] = view[0].slice(startBufferIndex)
    }

    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex))
    }
  }

  return view
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean} [expandTabs=false]
 * @returns {string}
 */

function serializeChunks(chunks, expandTabs) {
  let index = -1
  /** @type {Array<string>} */

  const result = []
  /** @type {boolean|undefined} */

  let atTab

  while (++index < chunks.length) {
    const chunk = chunks[index]
    /** @type {string} */

    let value

    if (typeof chunk === 'string') {
      value = chunk
    } else
      switch (chunk) {
        case -5: {
          value = '\r'
          break
        }

        case -4: {
          value = '\n'
          break
        }

        case -3: {
          value = '\r' + '\n'
          break
        }

        case -2: {
          value = expandTabs ? ' ' : '\t'
          break
        }

        case -1: {
          if (!expandTabs && atTab) continue
          value = ' '
          break
        }

        default: {
          // Currently only replacement character.
          value = String.fromCharCode(chunk)
        }
      }

    atTab = chunk === -2
    result.push(value)
  }

  return result.join('')
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/thematic-break.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const thematicBreak = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
}
/** @type {Tokenizer} */

function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('thematicBreak')
    marker = code
    return atBreak(code)
  }
  /** @type {State} */

  function atBreak(code) {
    if (code === marker) {
      effects.enter('thematicBreakSequence')
      return sequence(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, 'whitespace')(code)
    }

    if (size < 3 || (code !== null && !markdownLineEnding(code))) {
      return nok(code)
    }

    effects.exit('thematicBreak')
    return ok(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      size++
      return sequence
    }

    effects.exit('thematicBreakSequence')
    return atBreak(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/list.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @typedef {Record<string, unknown> & {marker: Code, type: string, size: number}} ListContainerState
 * @typedef {TokenizeContext & {containerState: ListContainerState}} TokenizeContextWithState
 */




/** @type {Construct} */

const list = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
}
/** @type {Construct} */

const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
}
/** @type {Construct} */

const indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListStart(effects, ok, nok) {
  const self = this
  const tail = self.events[self.events.length - 1]
  let initialSize =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    const kind =
      self.containerState.type ||
      (code === 42 || code === 43 || code === 45
        ? 'listUnordered'
        : 'listOrdered')

    if (
      kind === 'listUnordered'
        ? !self.containerState.marker || code === self.containerState.marker
        : asciiDigit(code)
    ) {
      if (!self.containerState.type) {
        self.containerState.type = kind
        effects.enter(kind, {
          _container: true
        })
      }

      if (kind === 'listUnordered') {
        effects.enter('listItemPrefix')
        return code === 42 || code === 45
          ? effects.check(thematicBreak, nok, atMarker)(code)
          : atMarker(code)
      }

      if (!self.interrupt || code === 49) {
        effects.enter('listItemPrefix')
        effects.enter('listItemValue')
        return inside(code)
      }
    }

    return nok(code)
  }
  /** @type {State} */

  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code)
      return inside
    }

    if (
      (!self.interrupt || size < 2) &&
      (self.containerState.marker
        ? code === self.containerState.marker
        : code === 41 || code === 46)
    ) {
      effects.exit('listItemValue')
      return atMarker(code)
    }

    return nok(code)
  }
  /**
   * @type {State}
   **/

  function atMarker(code) {
    effects.enter('listItemMarker')
    effects.consume(code)
    effects.exit('listItemMarker')
    self.containerState.marker = self.containerState.marker || code
    return effects.check(
      blankLine, // Can’t be empty when interrupting.
      self.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    )
  }
  /** @type {State} */

  function onBlank(code) {
    self.containerState.initialBlankLine = true
    initialSize++
    return endOfPrefix(code)
  }
  /** @type {State} */

  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace')
      effects.consume(code)
      effects.exit('listItemPrefixWhitespace')
      return endOfPrefix
    }

    return nok(code)
  }
  /** @type {State} */

  function endOfPrefix(code) {
    self.containerState.size =
      initialSize +
      self.sliceSerialize(effects.exit('listItemPrefix'), true).length
    return ok(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListContinuation(effects, ok, nok) {
  const self = this
  self.containerState._closeFlow = undefined
  return effects.check(blankLine, onBlank, notBlank)
  /** @type {State} */

  function onBlank(code) {
    self.containerState.furtherBlankLines =
      self.containerState.furtherBlankLines ||
      self.containerState.initialBlankLine // We have a blank line.
    // Still, try to consume at most the items size.

    return factorySpace(
      effects,
      ok,
      'listItemIndent',
      self.containerState.size + 1
    )(code)
  }
  /** @type {State} */

  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined
      self.containerState.initialBlankLine = undefined
      return notInCurrentItem(code)
    }

    self.containerState.furtherBlankLines = undefined
    self.containerState.initialBlankLine = undefined
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code)
  }
  /** @type {State} */

  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.

    self.interrupt = undefined
    return factorySpace(
      effects,
      effects.attempt(list, ok, nok),
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemIndent',
    self.containerState.size + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'listItemIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === self.containerState.size
      ? ok(code)
      : nok(code)
  }
}
/**
 * @type {Exiter}
 * @this {TokenizeContextWithState}
 */

function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type)
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemPrefixWhitespace',
    self.parser.constructs.disable.null.includes('codeIndented')
      ? undefined
      : 4 + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return !markdownSpace(code) &&
      tail &&
      tail[1].type === 'listItemPrefixWhitespace'
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/block-quote.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const blockQuote = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
}
/** @type {Tokenizer} */

function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    if (code === 62) {
      const state = self.containerState

      if (!state.open) {
        effects.enter('blockQuote', {
          _container: true
        })
        state.open = true
      }

      effects.enter('blockQuotePrefix')
      effects.enter('blockQuoteMarker')
      effects.consume(code)
      effects.exit('blockQuoteMarker')
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (markdownSpace(code)) {
      effects.enter('blockQuotePrefixWhitespace')
      effects.consume(code)
      effects.exit('blockQuotePrefixWhitespace')
      effects.exit('blockQuotePrefix')
      return ok
    }

    effects.exit('blockQuotePrefix')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(blockQuote, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}
/** @type {Exiter} */

function exit(effects) {
  effects.exit('blockQuote')
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-destination/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */


/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} literalType
 * @param {string} literalMarkerType
 * @param {string} rawType
 * @param {string} stringType
 * @param {number} [max=Infinity]
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryDestination(
  effects,
  ok,
  nok,
  type,
  literalType,
  literalMarkerType,
  rawType,
  stringType,
  max
) {
  const limit = max || Number.POSITIVE_INFINITY
  let balance = 0
  return start
  /** @type {State} */

  function start(code) {
    if (code === 60) {
      effects.enter(type)
      effects.enter(literalType)
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      return destinationEnclosedBefore
    }

    if (code === null || code === 41 || asciiControl(code)) {
      return nok(code)
    }

    effects.enter(type)
    effects.enter(rawType)
    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return destinationRaw(code)
  }
  /** @type {State} */

  function destinationEnclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      effects.exit(literalType)
      effects.exit(type)
      return ok
    }

    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationEnclosed(code) {
    if (code === 62) {
      effects.exit('chunkString')
      effects.exit(stringType)
      return destinationEnclosedBefore(code)
    }

    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code)
    }

    effects.consume(code)
    return code === 92 ? destinationEnclosedEscape : destinationEnclosed
  }
  /** @type {State} */

  function destinationEnclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code)
      return destinationEnclosed
    }

    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationRaw(code) {
    if (code === 40) {
      if (++balance > limit) return nok(code)
      effects.consume(code)
      return destinationRaw
    }

    if (code === 41) {
      if (!balance--) {
        effects.exit('chunkString')
        effects.exit(stringType)
        effects.exit(rawType)
        effects.exit(type)
        return ok(code)
      }

      effects.consume(code)
      return destinationRaw
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      if (balance) return nok(code)
      effects.exit('chunkString')
      effects.exit(stringType)
      effects.exit(rawType)
      effects.exit(type)
      return ok(code)
    }

    if (asciiControl(code)) return nok(code)
    effects.consume(code)
    return code === 92 ? destinationRawEscape : destinationRaw
  }
  /** @type {State} */

  function destinationRawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code)
      return destinationRaw
    }

    return destinationRaw(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-label/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').State} State
 */


/**
 * @this {TokenizeContext}
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this
  let size = 0
  /** @type {boolean} */

  let data
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    effects.enter(stringType)
    return atBreak
  }
  /** @type {State} */

  function atBreak(code) {
    if (
      code === null ||
      code === 91 ||
      (code === 93 && !data) ||
      /* To do: remove in the future once we’ve switched from
       * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
       * which doesn’t need this */

      /* Hidden footnotes hook */

      /* c8 ignore next 3 */
      (code === 94 &&
        !size &&
        '_hiddenFootnoteSupport' in self.parser.constructs) ||
      size > 999
    ) {
      return nok(code)
    }

    if (code === 93) {
      effects.exit(stringType)
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return atBreak
    }

    effects.enter('chunkString', {
      contentType: 'string'
    })
    return label(code)
  }
  /** @type {State} */

  function label(code) {
    if (
      code === null ||
      code === 91 ||
      code === 93 ||
      markdownLineEnding(code) ||
      size++ > 999
    ) {
      effects.exit('chunkString')
      return atBreak(code)
    }

    effects.consume(code)
    data = data || !markdownSpace(code)
    return code === 92 ? labelEscape : label
  }
  /** @type {State} */

  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return label
    }

    return label(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-title/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    marker = code === 40 ? 41 : code
    return atFirstTitleBreak
  }
  /** @type {State} */

  function atFirstTitleBreak(code) {
    if (code === marker) {
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    effects.enter(stringType)
    return atTitleBreak(code)
  }
  /** @type {State} */

  function atTitleBreak(code) {
    if (code === marker) {
      effects.exit(stringType)
      return atFirstTitleBreak(marker)
    }

    if (code === null) {
      return nok(code)
    } // Note: blank lines can’t exist in content.

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return factorySpace(effects, atTitleBreak, 'linePrefix')
    }

    effects.enter('chunkString', {
      contentType: 'string'
    })
    return title(code)
  }
  /** @type {State} */

  function title(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      return atTitleBreak(code)
    }

    effects.consume(code)
    return code === 92 ? titleEscape : title
  }
  /** @type {State} */

  function titleEscape(code) {
    if (code === marker || code === 92) {
      effects.consume(code)
      return title
    }

    return title(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-whitespace/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */



/**
 * @param {Effects} effects
 * @param {State} ok
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen
  return start
  /** @type {State} */

  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      seen = true
      return start
    }

    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        start,
        seen ? 'linePrefix' : 'lineSuffix'
      )(code)
    }

    return ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-normalize-identifier/index.js
/**
 * Normalize an identifier (such as used in definitions).
 *
 * @param {string} value
 * @returns {string}
 */
function normalizeIdentifier(value) {
  return (
    value // Collapse Markdown whitespace.
      .replace(/[\t\n\r ]+/g, ' ') // Trim.
      .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
      // counterpart is uppercased will result in a different uppercase
      // character.
      // Hence, to get that form, we perform both lower- and uppercase.
      // Upper case makes sure keys will not interact with default prototypal
      // methods: no method is uppercase.
      .toLowerCase()
      .toUpperCase()
  )
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/definition.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */








/** @type {Construct} */
const definition = {
  name: 'definition',
  tokenize: tokenizeDefinition
}
/** @type {Construct} */

const titleConstruct = {
  tokenize: tokenizeTitle,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeDefinition(effects, ok, nok) {
  const self = this
  /** @type {string} */

  let identifier
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('definition')
    return factoryLabel.call(
      self,
      effects,
      labelAfter,
      nok,
      'definitionLabel',
      'definitionLabelMarker',
      'definitionLabelString'
    )(code)
  }
  /** @type {State} */

  function labelAfter(code) {
    identifier = normalizeIdentifier(
      self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
    )

    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker') // Note: blank lines can’t exist in content.

      return factoryWhitespace(
        effects,
        factoryDestination(
          effects,
          effects.attempt(
            titleConstruct,
            factorySpace(effects, after, 'whitespace'),
            factorySpace(effects, after, 'whitespace')
          ),
          nok,
          'definitionDestination',
          'definitionDestinationLiteral',
          'definitionDestinationLiteralMarker',
          'definitionDestinationRaw',
          'definitionDestinationString'
        )
      )
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('definition')

      if (!self.parser.defined.includes(identifier)) {
        self.parser.defined.push(identifier)
      }

      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeTitle(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, before)(code)
      : nok(code)
  }
  /** @type {State} */

  function before(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factorySpace(effects, after, 'whitespace'),
        nok,
        'definitionTitle',
        'definitionTitleMarker',
        'definitionTitleString'
      )(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/code-indented.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
}
/** @type {Construct} */

const indentedContent = {
  tokenize: tokenizeIndentedContent,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeCodeIndented(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeIndented')
    return factorySpace(effects, afterStartPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterStartPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? afterPrefix(code)
      : nok(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(indentedContent, afterPrefix, after)(code)
    }

    effects.enter('codeFlowValue')
    return content(code)
  }
  /** @type {State} */

  function content(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return afterPrefix(code)
    }

    effects.consume(code)
    return content
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeIndented')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeIndentedContent(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return start
    }

    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? ok(code)
      : markdownLineEnding(code)
      ? start(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/heading-atx.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */




/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
}
/** @type {Resolver} */

function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2
  let contentStart = 3
  /** @type {Token} */

  let content
  /** @type {Token} */

  let text // Prefix whitespace, part of the opening.

  if (events[contentStart][1].type === 'whitespace') {
    contentStart += 2
  } // Suffix whitespace, part of the closing.

  if (
    contentEnd - 2 > contentStart &&
    events[contentEnd][1].type === 'whitespace'
  ) {
    contentEnd -= 2
  }

  if (
    events[contentEnd][1].type === 'atxHeadingSequence' &&
    (contentStart === contentEnd - 1 ||
      (contentEnd - 4 > contentStart &&
        events[contentEnd - 2][1].type === 'whitespace'))
  ) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4
  }

  if (contentEnd > contentStart) {
    content = {
      type: 'atxHeadingText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    }
    text = {
      type: 'chunkText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      // @ts-expect-error Constants are fine to assign.
      contentType: 'text'
    }
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ['enter', content, context],
      ['enter', text, context],
      ['exit', text, context],
      ['exit', content, context]
    ])
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHeadingAtx(effects, ok, nok) {
  const self = this
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('atxHeading')
    effects.enter('atxHeadingSequence')
    return fenceOpenInside(code)
  }
  /** @type {State} */

  function fenceOpenInside(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code)
      return fenceOpenInside
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingSequence')
      return self.interrupt ? ok(code) : headingBreak(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function headingBreak(code) {
    if (code === 35) {
      effects.enter('atxHeadingSequence')
      return sequence(code)
    }

    if (code === null || markdownLineEnding(code)) {
      effects.exit('atxHeading')
      return ok(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, headingBreak, 'whitespace')(code)
    }

    effects.enter('atxHeadingText')
    return data(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === 35) {
      effects.consume(code)
      return sequence
    }

    effects.exit('atxHeadingSequence')
    return headingBreak(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingText')
      return headingBreak(code)
    }

    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/setext-underline.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
}
/** @type {Resolver} */

function resolveToSetextUnderline(events, context) {
  let index = events.length
  /** @type {number|undefined} */

  let content
  /** @type {number|undefined} */

  let text
  /** @type {number|undefined} */

  let definition // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.

  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === 'content') {
        content = index
        break
      }

      if (events[index][1].type === 'paragraph') {
        text = index
      }
    } // Exit
    else {
      if (events[index][1].type === 'content') {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1)
      }

      if (!definition && events[index][1].type === 'definition') {
        definition = index
      }
    }
  }

  const heading = {
    type: 'setextHeading',
    start: Object.assign({}, events[text][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  } // Change the paragraph to setext heading text.

  events[text][1].type = 'setextHeadingText' // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.

  if (definition) {
    events.splice(text, 0, ['enter', heading, context])
    events.splice(definition + 1, 0, ['exit', events[content][1], context])
    events[content][1].end = Object.assign({}, events[definition][1].end)
  } else {
    events[content][1] = heading
  } // Add the heading exit at the end.

  events.push(['exit', heading, context])
  return events
}
/** @type {Tokenizer} */

function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {NonNullable<Code>} */

  let marker
  /** @type {boolean} */

  let paragraph // Find an opening.

  while (index--) {
    // Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (
      self.events[index][1].type !== 'lineEnding' &&
      self.events[index][1].type !== 'linePrefix' &&
      self.events[index][1].type !== 'content'
    ) {
      paragraph = self.events[index][1].type === 'paragraph'
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter('setextHeadingLine')
      effects.enter('setextHeadingLineSequence')
      marker = code
      return closingSequence(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function closingSequence(code) {
    if (code === marker) {
      effects.consume(code)
      return closingSequence
    }

    effects.exit('setextHeadingLineSequence')
    return factorySpace(effects, closingSequenceEnd, 'lineSuffix')(code)
  }
  /** @type {State} */

  function closingSequenceEnd(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('setextHeadingLine')
      return ok(code)
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-html-tag-name/index.js
/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result
 * in more relaxed rules (condition 6): because they are known blocks, the
 * HTML-like syntax doesn’t have to be strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
]

/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result in
 * HTML that can include lines w/o exiting, until a closing tag also in this
 * list is found (condition 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * Note that `textarea` was added in `CommonMark@0.30`.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea']

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/html-flow.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */

const htmlFlow = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
}
/** @type {Construct} */

const nextBlankConstruct = {
  tokenize: tokenizeNextBlank,
  partial: true
}
/** @type {Resolver} */

function resolveToHtmlFlow(events) {
  let index = events.length

  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') {
      break
    }
  }

  if (index > 1 && events[index - 2][1].type === 'linePrefix') {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.

    events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.

    events.splice(index - 2, 2)
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this
  /** @type {number} */

  let kind
  /** @type {boolean} */

  let startTag
  /** @type {string} */

  let buffer
  /** @type {number} */

  let index
  /** @type {Code} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlFlow')
    effects.enter('htmlFlowData')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationStart
    }

    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code)
      kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.

      return self.interrupt ? ok : continuationDeclarationInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      buffer = String.fromCharCode(code)
      startTag = true
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationStart(code) {
    if (code === 45) {
      effects.consume(code)
      kind = 2
      return commentOpenInside
    }

    if (code === 91) {
      effects.consume(code)
      kind = 5
      buffer = 'CDATA['
      index = 0
      return cdataOpenInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      kind = 4
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code)
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function cdataOpenInside(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code)
      return index === buffer.length
        ? self.interrupt
          ? ok
          : continuation
        : cdataOpenInside
    }

    return nok(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      buffer = String.fromCharCode(code)
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function tagName(code) {
    if (
      code === null ||
      code === 47 ||
      code === 62 ||
      markdownLineEndingOrSpace(code)
    ) {
      if (
        code !== 47 &&
        startTag &&
        htmlRawNames.includes(buffer.toLowerCase())
      ) {
        kind = 1
        return self.interrupt ? ok(code) : continuation(code)
      }

      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        kind = 6

        if (code === 47) {
          effects.consume(code)
          return basicSelfClosing
        }

        return self.interrupt ? ok(code) : continuation(code)
      }

      kind = 7 // Do not support complete HTML when interrupting

      return self.interrupt && !self.parser.lazy[self.now().line]
        ? nok(code)
        : startTag
        ? completeAttributeNameBefore(code)
        : completeClosingTagAfter(code)
    }

    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code)
      return self.interrupt ? ok : continuation
    }

    return nok(code)
  }
  /** @type {State} */

  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeClosingTagAfter
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code)
      return completeEnd
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return completeAttributeName
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameBefore
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return completeAttributeName
    }

    return completeAttributeNameAfter(code)
  }
  /** @type {State} */

  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return completeAttributeValueBefore
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameAfter
    }

    return completeAttributeNameBefore(code)
  }
  /** @type {State} */

  function completeAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return completeAttributeValueQuoted
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeValueBefore
    }

    marker = null
    return completeAttributeValueUnquoted(code)
  }
  /** @type {State} */

  function completeAttributeValueQuoted(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    if (code === marker) {
      effects.consume(code)
      return completeAttributeValueQuotedAfter
    }

    effects.consume(code)
    return completeAttributeValueQuoted
  }
  /** @type {State} */

  function completeAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      markdownLineEndingOrSpace(code)
    ) {
      return completeAttributeNameAfter(code)
    }

    effects.consume(code)
    return completeAttributeValueUnquoted
  }
  /** @type {State} */

  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code)
      return completeAfter
    }

    return nok(code)
  }
  /** @type {State} */

  function completeAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAfter
    }

    return code === null || markdownLineEnding(code)
      ? continuation(code)
      : nok(code)
  }
  /** @type {State} */

  function continuation(code) {
    if (code === 45 && kind === 2) {
      effects.consume(code)
      return continuationCommentInside
    }

    if (code === 60 && kind === 1) {
      effects.consume(code)
      return continuationRawTagOpen
    }

    if (code === 62 && kind === 4) {
      effects.consume(code)
      return continuationClose
    }

    if (code === 63 && kind === 3) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    if (code === 93 && kind === 5) {
      effects.consume(code)
      return continuationCharacterDataInside
    }

    if (markdownLineEnding(code) && (kind === 6 || kind === 7)) {
      return effects.check(
        nextBlankConstruct,
        continuationClose,
        continuationAtLineEnding
      )(code)
    }

    if (code === null || markdownLineEnding(code)) {
      return continuationAtLineEnding(code)
    }

    effects.consume(code)
    return continuation
  }
  /** @type {State} */

  function continuationAtLineEnding(code) {
    effects.exit('htmlFlowData')
    return htmlContinueStart(code)
  }
  /** @type {State} */

  function htmlContinueStart(code) {
    if (code === null) {
      return done(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        {
          tokenize: htmlLineEnd,
          partial: true
        },
        htmlContinueStart,
        done
      )(code)
    }

    effects.enter('htmlFlowData')
    return continuation(code)
  }
  /** @type {Tokenizer} */

  function htmlLineEnd(effects, ok, nok) {
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {State} */

  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code)
      buffer = ''
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawEndTag(code) {
    if (code === 62 && htmlRawNames.includes(buffer.toLowerCase())) {
      effects.consume(code)
      return continuationClose
    }

    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationCharacterDataInside(code) {
    if (code === 93) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code)
      return continuationClose
    } // More dashes.

    if (code === 45 && kind === 2) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData')
      return done(code)
    }

    effects.consume(code)
    return continuationClose
  }
  /** @type {State} */

  function done(code) {
    effects.exit('htmlFlow')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeNextBlank(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.exit('htmlFlowData')
    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    return effects.attempt(blankLine, ok, nok)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/code-fenced.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const codeFenced = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
}
/** @type {Tokenizer} */

function tokenizeCodeFenced(effects, ok, nok) {
  const self = this
  /** @type {Construct} */

  const closingFenceConstruct = {
    tokenize: tokenizeClosingFence,
    partial: true
  }
  /** @type {Construct} */

  const nonLazyLine = {
    tokenize: tokenizeNonLazyLine,
    partial: true
  }
  const tail = this.events[this.events.length - 1]
  const initialPrefix =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let sizeOpen = 0
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeFenced')
    effects.enter('codeFencedFence')
    effects.enter('codeFencedFenceSequence')
    marker = code
    return sequenceOpen(code)
  }
  /** @type {State} */

  function sequenceOpen(code) {
    if (code === marker) {
      effects.consume(code)
      sizeOpen++
      return sequenceOpen
    }

    effects.exit('codeFencedFenceSequence')
    return sizeOpen < 3
      ? nok(code)
      : factorySpace(effects, infoOpen, 'whitespace')(code)
  }
  /** @type {State} */

  function infoOpen(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceInfo')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return info(code)
  }
  /** @type {State} */

  function info(code) {
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceInfo')
      return factorySpace(effects, infoAfter, 'whitespace')(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code)
    return info
  }
  /** @type {State} */

  function infoAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceMeta')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return meta(code)
  }
  /** @type {State} */

  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceMeta')
      return openAfter(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code)
    return meta
  }
  /** @type {State} */

  function openAfter(code) {
    effects.exit('codeFencedFence')
    return self.interrupt ? ok(code) : contentStart(code)
  }
  /** @type {State} */

  function contentStart(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        nonLazyLine,
        effects.attempt(
          closingFenceConstruct,
          after,
          initialPrefix
            ? factorySpace(
                effects,
                contentStart,
                'linePrefix',
                initialPrefix + 1
              )
            : contentStart
        ),
        after
      )(code)
    }

    effects.enter('codeFlowValue')
    return contentContinue(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return contentStart(code)
    }

    effects.consume(code)
    return contentContinue
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeFenced')
    return ok(code)
  }
  /** @type {Tokenizer} */

  function tokenizeNonLazyLine(effects, ok, nok) {
    const self = this
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {Tokenizer} */

  function tokenizeClosingFence(effects, ok, nok) {
    let size = 0
    return factorySpace(
      effects,
      closingSequenceStart,
      'linePrefix',
      this.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
    /** @type {State} */

    function closingSequenceStart(code) {
      effects.enter('codeFencedFence')
      effects.enter('codeFencedFenceSequence')
      return closingSequence(code)
    }
    /** @type {State} */

    function closingSequence(code) {
      if (code === marker) {
        effects.consume(code)
        size++
        return closingSequence
      }

      if (size < sizeOpen) return nok(code)
      effects.exit('codeFencedFenceSequence')
      return factorySpace(effects, closingSequenceEnd, 'whitespace')(code)
    }
    /** @type {State} */

    function closingSequenceEnd(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit('codeFencedFence')
        return ok(code)
      }

      return nok(code)
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/decode-named-character-reference/index.dom.js
/// <reference lib="dom" />

/* eslint-env browser */

const index_dom_element = document.createElement('i')

/**
 * @param {string} value
 * @returns {string|false}
 */
function decodeNamedCharacterReference(value) {
  const characterReference = '&' + value + ';'
  index_dom_element.innerHTML = characterReference
  const char = index_dom_element.textContent

  // Some named character references do not require the closing semicolon
  // (`&not`, for instance), which leads to situations where parsing the assumed
  // named reference of `&notit;` will result in the string `¬it;`.
  // When we encounter a trailing semicolon after parsing, and the character
  // reference to decode was not a semicolon (`&semi;`), we can assume that the
  // matching was not complete.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  if (char.charCodeAt(char.length - 1) === 59 /* `;` */ && value !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the character reference was
  // not valid.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  return char === characterReference ? false : char
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/character-reference.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
}
/** @type {Tokenizer} */

function tokenizeCharacterReference(effects, ok, nok) {
  const self = this
  let size = 0
  /** @type {number} */

  let max
  /** @type {(code: Code) => code is number} */

  let test
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterReference')
    effects.enter('characterReferenceMarker')
    effects.consume(code)
    effects.exit('characterReferenceMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 35) {
      effects.enter('characterReferenceMarkerNumeric')
      effects.consume(code)
      effects.exit('characterReferenceMarkerNumeric')
      return numeric
    }

    effects.enter('characterReferenceValue')
    max = 31
    test = asciiAlphanumeric
    return value(code)
  }
  /** @type {State} */

  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter('characterReferenceMarkerHexadecimal')
      effects.consume(code)
      effects.exit('characterReferenceMarkerHexadecimal')
      effects.enter('characterReferenceValue')
      max = 6
      test = asciiHexDigit
      return value
    }

    effects.enter('characterReferenceValue')
    max = 7
    test = asciiDigit
    return value(code)
  }
  /** @type {State} */

  function value(code) {
    /** @type {Token} */
    let token

    if (code === 59 && size) {
      token = effects.exit('characterReferenceValue')

      if (
        test === asciiAlphanumeric &&
        !decodeNamedCharacterReference(self.sliceSerialize(token))
      ) {
        return nok(code)
      }

      effects.enter('characterReferenceMarker')
      effects.consume(code)
      effects.exit('characterReferenceMarker')
      effects.exit('characterReference')
      return ok
    }

    if (test(code) && size++ < max) {
      effects.consume(code)
      return value
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/character-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
}
/** @type {Tokenizer} */

function tokenizeCharacterEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    effects.exit('escapeMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiPunctuation(code)) {
      effects.enter('characterEscapeValue')
      effects.consume(code)
      effects.exit('characterEscapeValue')
      effects.exit('characterEscape')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/line-ending.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
}
/** @type {Tokenizer} */

function tokenizeLineEnding(effects, ok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, ok, 'linePrefix')
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/label-end.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */









/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
}
/** @type {Construct} */

const resourceConstruct = {
  tokenize: tokenizeResource
}
/** @type {Construct} */

const fullReferenceConstruct = {
  tokenize: tokenizeFullReference
}
/** @type {Construct} */

const collapsedReferenceConstruct = {
  tokenize: tokenizeCollapsedReference
}
/** @type {Resolver} */

function resolveAllLabelEnd(events) {
  let index = -1
  /** @type {Token} */

  let token

  while (++index < events.length) {
    token = events[index][1]

    if (
      token.type === 'labelImage' ||
      token.type === 'labelLink' ||
      token.type === 'labelEnd'
    ) {
      // Remove the marker.
      events.splice(index + 1, token.type === 'labelImage' ? 4 : 2)
      token.type = 'data'
      index++
    }
  }

  return events
}
/** @type {Resolver} */

function resolveToLabelEnd(events, context) {
  let index = events.length
  let offset = 0
  /** @type {Token} */

  let token
  /** @type {number|undefined} */

  let open
  /** @type {number|undefined} */

  let close
  /** @type {Event[]} */

  let media // Find an opening.

  while (index--) {
    token = events[index][1]

    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (
        token.type === 'link' ||
        (token.type === 'labelLink' && token._inactive)
      ) {
        break
      } // Mark other link openings as inactive, as we can’t have links in
      // links.

      if (events[index][0] === 'enter' && token.type === 'labelLink') {
        token._inactive = true
      }
    } else if (close) {
      if (
        events[index][0] === 'enter' &&
        (token.type === 'labelImage' || token.type === 'labelLink') &&
        !token._balanced
      ) {
        open = index

        if (token.type !== 'labelLink') {
          offset = 2
          break
        }
      }
    } else if (token.type === 'labelEnd') {
      close = index
    }
  }

  const group = {
    type: events[open][1].type === 'labelLink' ? 'link' : 'image',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }
  const label = {
    type: 'label',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  }
  const text = {
    type: 'labelText',
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  }
  media = [
    ['enter', group, context],
    ['enter', label, context]
  ] // Opening marker.

  media = push(media, events.slice(open + 1, open + offset + 3)) // Text open.

  media = push(media, [['enter', text, context]]) // Between.

  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset + 4, close - 3),
      context
    )
  ) // Text close, marker close, label close.

  media = push(media, [
    ['exit', text, context],
    events[close - 2],
    events[close - 1],
    ['exit', label, context]
  ]) // Reference, resource, or so.

  media = push(media, events.slice(close + 1)) // Media close.

  media = push(media, [['exit', group, context]])
  splice(events, open, events.length, media)
  return events
}
/** @type {Tokenizer} */

function tokenizeLabelEnd(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {Token} */

  let labelStart
  /** @type {boolean} */

  let defined // Find an opening.

  while (index--) {
    if (
      (self.events[index][1].type === 'labelImage' ||
        self.events[index][1].type === 'labelLink') &&
      !self.events[index][1]._balanced
    ) {
      labelStart = self.events[index][1]
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!labelStart) {
      return nok(code)
    } // It’s a balanced bracket, but contains a link.

    if (labelStart._inactive) return balanced(code)
    defined = self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize({
          start: labelStart.end,
          end: self.now()
        })
      )
    )
    effects.enter('labelEnd')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelEnd')
    return afterLabelEnd
  }
  /** @type {State} */

  function afterLabelEnd(code) {
    // Resource: `[asd](fgh)`.
    if (code === 40) {
      return effects.attempt(
        resourceConstruct,
        ok,
        defined ? ok : balanced
      )(code)
    } // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?

    if (code === 91) {
      return effects.attempt(
        fullReferenceConstruct,
        ok,
        defined
          ? effects.attempt(collapsedReferenceConstruct, ok, balanced)
          : balanced
      )(code)
    } // Shortcut reference: `[asd]`?

    return defined ? ok(code) : balanced(code)
  }
  /** @type {State} */

  function balanced(code) {
    labelStart._balanced = true
    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeResource(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('resource')
    effects.enter('resourceMarker')
    effects.consume(code)
    effects.exit('resourceMarker')
    return factoryWhitespace(effects, open)
  }
  /** @type {State} */

  function open(code) {
    if (code === 41) {
      return end(code)
    }

    return factoryDestination(
      effects,
      destinationAfter,
      nok,
      'resourceDestination',
      'resourceDestinationLiteral',
      'resourceDestinationLiteralMarker',
      'resourceDestinationRaw',
      'resourceDestinationString',
      32
    )(code)
  }
  /** @type {State} */

  function destinationAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, between)(code)
      : end(code)
  }
  /** @type {State} */

  function between(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factoryWhitespace(effects, end),
        nok,
        'resourceTitle',
        'resourceTitleMarker',
        'resourceTitleString'
      )(code)
    }

    return end(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 41) {
      effects.enter('resourceMarker')
      effects.consume(code)
      effects.exit('resourceMarker')
      effects.exit('resource')
      return ok
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeFullReference(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    return factoryLabel.call(
      self,
      effects,
      afterLabel,
      nok,
      'reference',
      'referenceMarker',
      'referenceString'
    )(code)
  }
  /** @type {State} */

  function afterLabel(code) {
    return self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
      )
    )
      ? ok(code)
      : nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeCollapsedReference(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('reference')
    effects.enter('referenceMarker')
    effects.consume(code)
    effects.exit('referenceMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 93) {
      effects.enter('referenceMarker')
      effects.consume(code)
      effects.exit('referenceMarker')
      effects.exit('reference')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/label-start-image.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */

const labelStartImage = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
}
/** @type {Tokenizer} */

function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelImage')
    effects.enter('labelImageMarker')
    effects.consume(code)
    effects.exit('labelImageMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 91) {
      effects.enter('labelMarker')
      effects.consume(code)
      effects.exit('labelMarker')
      effects.exit('labelImage')
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-classify-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */


/**
 * Classify whether a character code represents whitespace, punctuation, or
 * something else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * Note that eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 * @returns {number|undefined}
 */
function classifyCharacter(code) {
  if (
    code === null ||
    markdownLineEndingOrSpace(code) ||
    unicodeWhitespace(code)
  ) {
    return 1
  }

  if (unicodePunctuation(code)) {
    return 2
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/attention.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Point} Point
 */




/** @type {Construct} */
const attention = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
}
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */

function resolveAllAttention(events, context) {
  let index = -1
  /** @type {number} */

  let open
  /** @type {Token} */

  let group
  /** @type {Token} */

  let text
  /** @type {Token} */

  let openingSequence
  /** @type {Token} */

  let closingSequence
  /** @type {number} */

  let use
  /** @type {Event[]} */

  let nextEvents
  /** @type {number} */

  let offset // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.

  while (++index < events.length) {
    // Find a token that can close.
    if (
      events[index][0] === 'enter' &&
      events[index][1].type === 'attentionSequence' &&
      events[index][1]._close
    ) {
      open = index // Now walk back to find an opener.

      while (open--) {
        // Find a token that can open the closer.
        if (
          events[open][0] === 'exit' &&
          events[open][1].type === 'attentionSequence' &&
          events[open][1]._open && // If the markers are the same:
          context.sliceSerialize(events[open][1]).charCodeAt(0) ===
            context.sliceSerialize(events[index][1]).charCodeAt(0)
        ) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if (
            (events[open][1]._close || events[index][1]._open) &&
            (events[index][1].end.offset - events[index][1].start.offset) % 3 &&
            !(
              (events[open][1].end.offset -
                events[open][1].start.offset +
                events[index][1].end.offset -
                events[index][1].start.offset) %
              3
            )
          ) {
            continue
          } // Number of markers to use from the sequence.

          use =
            events[open][1].end.offset - events[open][1].start.offset > 1 &&
            events[index][1].end.offset - events[index][1].start.offset > 1
              ? 2
              : 1
          const start = Object.assign({}, events[open][1].end)
          const end = Object.assign({}, events[index][1].start)
          movePoint(start, -use)
          movePoint(end, use)
          openingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start,
            end: Object.assign({}, events[open][1].end)
          }
          closingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: Object.assign({}, events[index][1].start),
            end
          }
          text = {
            type: use > 1 ? 'strongText' : 'emphasisText',
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          }
          group = {
            type: use > 1 ? 'strong' : 'emphasis',
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          }
          events[open][1].end = Object.assign({}, openingSequence.start)
          events[index][1].start = Object.assign({}, closingSequence.end)
          nextEvents = [] // If there are more markers in the opening, add them before.

          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ['enter', events[open][1], context],
              ['exit', events[open][1], context]
            ])
          } // Opening.

          nextEvents = push(nextEvents, [
            ['enter', group, context],
            ['enter', openingSequence, context],
            ['exit', openingSequence, context],
            ['enter', text, context]
          ]) // Between.

          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index),
              context
            )
          ) // Closing.

          nextEvents = push(nextEvents, [
            ['exit', text, context],
            ['enter', closingSequence, context],
            ['exit', closingSequence, context],
            ['exit', group, context]
          ]) // If there are more markers in the closing, add them after.

          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2
            nextEvents = push(nextEvents, [
              ['enter', events[index][1], context],
              ['exit', events[index][1], context]
            ])
          } else {
            offset = 0
          }

          splice(events, open - 1, index - open + 3, nextEvents)
          index = open + nextEvents.length - offset - 2
          break
        }
      }
    }
  } // Remove remaining sequences.

  index = -1

  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data'
    }
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null
  const previous = this.previous
  const before = classifyCharacter(previous)
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('attentionSequence')
    marker = code
    return sequence(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      return sequence
    }

    const token = effects.exit('attentionSequence')
    const after = classifyCharacter(code)
    const open =
      !after || (after === 2 && before) || attentionMarkers.includes(code)
    const close =
      !before || (before === 2 && after) || attentionMarkers.includes(previous)
    token._open = Boolean(marker === 42 ? open : open && (before || !close))
    token._close = Boolean(marker === 42 ? close : close && (after || !open))
    return ok(code)
  }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */

function movePoint(point, offset) {
  point.column += offset
  point.offset += offset
  point._bufferIndex += offset
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/autolink.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
}
/** @type {Tokenizer} */

function tokenizeAutolink(effects, ok, nok) {
  let size = 1
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('autolink')
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.enter('autolinkProtocol')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return schemeOrEmailAtext
    }

    return asciiAtext(code) ? emailAtext(code) : nok(code)
  }
  /** @type {State} */

  function schemeOrEmailAtext(code) {
    return code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)
      ? schemeInsideOrEmailAtext(code)
      : emailAtext(code)
  }
  /** @type {State} */

  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code)
      return urlInside
    }

    if (
      (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) &&
      size++ < 32
    ) {
      effects.consume(code)
      return schemeInsideOrEmailAtext
    }

    return emailAtext(code)
  }
  /** @type {State} */

  function urlInside(code) {
    if (code === 62) {
      effects.exit('autolinkProtocol')
      return end(code)
    }

    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code)
    }

    effects.consume(code)
    return urlInside
  }
  /** @type {State} */

  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }

    if (asciiAtext(code)) {
      effects.consume(code)
      return emailAtext
    }

    return nok(code)
  }
  /** @type {State} */

  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code)
  }
  /** @type {State} */

  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }

    if (code === 62) {
      // Exit, then change the type.
      effects.exit('autolinkProtocol').type = 'autolinkEmail'
      return end(code)
    }

    return emailValue(code)
  }
  /** @type {State} */

  function emailValue(code) {
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      effects.consume(code)
      return code === 45 ? emailValue : emailLabel
    }

    return nok(code)
  }
  /** @type {State} */

  function end(code) {
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.exit('autolink')
    return ok
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/html-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
}
/** @type {Tokenizer} */

function tokenizeHtmlText(effects, ok, nok) {
  const self = this
  /** @type {NonNullable<Code>|undefined} */

  let marker
  /** @type {string} */

  let buffer
  /** @type {number} */

  let index
  /** @type {State} */

  let returnState
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlText')
    effects.enter('htmlTextData')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationOpen
    }

    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code)
      return instruction
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentOpen
    }

    if (code === 91) {
      effects.consume(code)
      buffer = 'CDATA['
      index = 0
      return cdataOpen
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      return declaration
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentStart
    }

    return nok(code)
  }
  /** @type {State} */

  function commentStart(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code)
      return commentStartDash
    }

    return comment(code)
  }
  /** @type {State} */

  function commentStartDash(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    return comment(code)
  }
  /** @type {State} */

  function comment(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code)
      return commentClose
    }

    if (markdownLineEnding(code)) {
      returnState = comment
      return atLineEnding(code)
    }

    effects.consume(code)
    return comment
  }
  /** @type {State} */

  function commentClose(code) {
    if (code === 45) {
      effects.consume(code)
      return end
    }

    return comment(code)
  }
  /** @type {State} */

  function cdataOpen(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code)
      return index === buffer.length ? cdata : cdataOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function cdata(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 93) {
      effects.consume(code)
      return cdataClose
    }

    if (markdownLineEnding(code)) {
      returnState = cdata
      return atLineEnding(code)
    }

    effects.consume(code)
    return cdata
  }
  /** @type {State} */

  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function cdataEnd(code) {
    if (code === 62) {
      return end(code)
    }

    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function declaration(code) {
    if (code === null || code === 62) {
      return end(code)
    }

    if (markdownLineEnding(code)) {
      returnState = declaration
      return atLineEnding(code)
    }

    effects.consume(code)
    return declaration
  }
  /** @type {State} */

  function instruction(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 63) {
      effects.consume(code)
      return instructionClose
    }

    if (markdownLineEnding(code)) {
      returnState = instruction
      return atLineEnding(code)
    }

    effects.consume(code)
    return instruction
  }
  /** @type {State} */

  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagClose
    }

    return nok(code)
  }
  /** @type {State} */

  function tagClose(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagClose
    }

    return tagCloseBetween(code)
  }
  /** @type {State} */

  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagCloseBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpen(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagOpen
    }

    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code)
      return end
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return tagOpenAttributeName
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpenAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return tagOpenAttributeName
    }

    return tagOpenAttributeNameAfter(code)
  }
  /** @type {State} */

  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeNameAfter
    }

    return tagOpenBetween(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return tagOpenAttributeValueQuoted
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }

    effects.consume(code)
    marker = undefined
    return tagOpenAttributeValueUnquoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code)
      return tagOpenAttributeValueQuotedAfter
    }

    if (code === null) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted
      return atLineEnding(code)
    }

    effects.consume(code)
    return tagOpenAttributeValueQuoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 62 || code === 47 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    effects.consume(code)
    return tagOpenAttributeValueUnquoted
  } // We can’t have blank lines in content, so no need to worry about empty
  // tokens.

  /** @type {State} */

  function atLineEnding(code) {
    effects.exit('htmlTextData')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(
      effects,
      afterPrefix,
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
  }
  /** @type {State} */

  function afterPrefix(code) {
    effects.enter('htmlTextData')
    return returnState(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 62) {
      effects.consume(code)
      effects.exit('htmlTextData')
      effects.exit('htmlText')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/label-start-link.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */

const labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
}
/** @type {Tokenizer} */

function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelLink')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelLink')
    return after
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook. */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/hard-break-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
}
/** @type {Tokenizer} */

function tokenizeHardBreakEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('hardBreakEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (markdownLineEnding(code)) {
      effects.exit('escapeMarker')
      effects.exit('hardBreakEscape')
      return ok(code)
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/code-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const codeText = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
}
/** @type {Resolver} */

function resolveCodeText(events) {
  let tailExitIndex = events.length - 4
  let headEnterIndex = 3
  /** @type {number} */

  let index
  /** @type {number|undefined} */

  let enter // If we start and end with an EOL or a space.

  if (
    (events[headEnterIndex][1].type === 'lineEnding' ||
      events[headEnterIndex][1].type === 'space') &&
    (events[tailExitIndex][1].type === 'lineEnding' ||
      events[tailExitIndex][1].type === 'space')
  ) {
    index = headEnterIndex // And we have data.

    while (++index < tailExitIndex) {
      if (events[index][1].type === 'codeTextData') {
        // Then we have padding.
        events[headEnterIndex][1].type = 'codeTextPadding'
        events[tailExitIndex][1].type = 'codeTextPadding'
        headEnterIndex += 2
        tailExitIndex -= 2
        break
      }
    }
  } // Merge adjacent spaces and data.

  index = headEnterIndex - 1
  tailExitIndex++

  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') {
        enter = index
      }
    } else if (
      index === tailExitIndex ||
      events[index][1].type === 'lineEnding'
    ) {
      events[enter][1].type = 'codeTextData'

      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end
        events.splice(enter + 2, index - enter - 2)
        tailExitIndex -= index - enter - 2
        index = enter + 2
      }

      enter = undefined
    }
  }

  return events
}
/** @type {Previous} */

function previous(code) {
  // If there is a previous code, there will always be a tail.
  return (
    code !== 96 ||
    this.events[this.events.length - 1][1].type === 'characterEscape'
  )
}
/** @type {Tokenizer} */

function tokenizeCodeText(effects, ok, nok) {
  const self = this
  let sizeOpen = 0
  /** @type {number} */

  let size
  /** @type {Token} */

  let token
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeText')
    effects.enter('codeTextSequence')
    return openingSequence(code)
  }
  /** @type {State} */

  function openingSequence(code) {
    if (code === 96) {
      effects.consume(code)
      sizeOpen++
      return openingSequence
    }

    effects.exit('codeTextSequence')
    return gap(code)
  }
  /** @type {State} */

  function gap(code) {
    // EOF.
    if (code === null) {
      return nok(code)
    } // Closing fence?
    // Could also be data.

    if (code === 96) {
      token = effects.enter('codeTextSequence')
      size = 0
      return closingSequence(code)
    } // Tabs don’t work, and virtual spaces don’t make sense.

    if (code === 32) {
      effects.enter('space')
      effects.consume(code)
      effects.exit('space')
      return gap
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return gap
    } // Data.

    effects.enter('codeTextData')
    return data(code)
  } // In code.

  /** @type {State} */

  function data(code) {
    if (
      code === null ||
      code === 32 ||
      code === 96 ||
      markdownLineEnding(code)
    ) {
      effects.exit('codeTextData')
      return gap(code)
    }

    effects.consume(code)
    return data
  } // Closing fence.

  /** @type {State} */

  function closingSequence(code) {
    // More.
    if (code === 96) {
      effects.consume(code)
      size++
      return closingSequence
    } // Done!

    if (size === sizeOpen) {
      effects.exit('codeTextSequence')
      effects.exit('codeText')
      return ok(code)
    } // More or less accents: mark as data.

    token.type = 'codeTextData'
    return data(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/constructs.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */


/** @type {Extension['document']} */

const constructs_document = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
}
/** @type {Extension['contentInitial']} */

const contentInitial = {
  [91]: definition
}
/** @type {Extension['flowInitial']} */

const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
}
/** @type {Extension['flow']} */

const constructs_flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
}
/** @type {Extension['string']} */

const constructs_string = {
  [38]: characterReference,
  [92]: characterEscape
}
/** @type {Extension['text']} */

const constructs_text = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
}
/** @type {Extension['insideSpan']} */

const insideSpan = {
  null: [attention, resolver]
}
/** @type {Extension['attentionMarkers']} */

const attentionMarkers = {
  null: [42, 95]
}
/** @type {Extension['disable']} */

const disable = {
  null: []
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/parse.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Create} Create
 */







/**
 * @param {ParseOptions} [options]
 * @returns {ParseContext}
 */

function parse(options = {}) {
  /** @type {FullNormalizedExtension} */
  // @ts-expect-error `defaultConstructs` is full, so the result will be too.
  const constructs = combineExtensions(
    // @ts-expect-error Same as above.
    [constructs_namespaceObject].concat(options.extensions || [])
  )
  /** @type {ParseContext} */

  const parser = {
    defined: [],
    lazy: {},
    constructs,
    content: create(content),
    document: create(document_document),
    flow: create(flow),
    string: create(string),
    text: create(text_text)
  }
  return parser
  /**
   * @param {InitialConstruct} initial
   */

  function create(initial) {
    return creator
    /** @type {Create} */

    function creator(from) {
      return createTokenizer(parser, initial, from)
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/preprocess.js
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding} [encoding]
 * @param {boolean} [end=false]
 * @returns {Array<Chunk>}
 */
const search = /[\0\t\n\r]/g
/**
 * @returns {Preprocessor}
 */

function preprocess() {
  let column = 1
  let buffer = ''
  /** @type {boolean|undefined} */

  let start = true
  /** @type {boolean|undefined} */

  let atCarriageReturn
  return preprocessor
  /** @type {Preprocessor} */

  function preprocessor(value, encoding, end) {
    /** @type {Array<Chunk>} */
    const chunks = []
    /** @type {RegExpMatchArray|null} */

    let match
    /** @type {number} */

    let next
    /** @type {number} */

    let startPosition
    /** @type {number} */

    let endPosition
    /** @type {Code} */

    let code // @ts-expect-error `Buffer` does allow an encoding.

    value = buffer + value.toString(encoding)
    startPosition = 0
    buffer = ''

    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++
      }

      start = undefined
    }

    while (startPosition < value.length) {
      search.lastIndex = startPosition
      match = search.exec(value)
      endPosition =
        match && match.index !== undefined ? match.index : value.length
      code = value.charCodeAt(endPosition)

      if (!match) {
        buffer = value.slice(startPosition)
        break
      }

      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3)
        atCarriageReturn = undefined
      } else {
        if (atCarriageReturn) {
          chunks.push(-5)
          atCarriageReturn = undefined
        }

        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition))
          column += endPosition - startPosition
        }

        switch (code) {
          case 0: {
            chunks.push(65533)
            column++
            break
          }

          case 9: {
            next = Math.ceil(column / 4) * 4
            chunks.push(-2)

            while (column++ < next) chunks.push(-1)

            break
          }

          case 10: {
            chunks.push(-4)
            column = 1
            break
          }

          default: {
            atCarriageReturn = true
            column = 1
          }
        }
      }

      startPosition = endPosition + 1
    }

    if (end) {
      if (atCarriageReturn) chunks.push(-5)
      if (buffer) chunks.push(buffer)
      chunks.push(null)
    }

    return chunks
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/postprocess.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @param {Array<Event>} events
 * @returns {Array<Event>}
 */

function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }

  return events
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-decode-numeric-character-reference/index.js
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base)

  if (
    // C0 except for HT, LF, FF, CR, space
    code < 9 ||
    code === 11 ||
    (code > 13 && code < 32) || // Control character (DEL) of the basic block and C1 controls.
    (code > 126 && code < 160) || // Lone high surrogates and low surrogates.
    (code > 55295 && code < 57344) || // Noncharacters.
    (code > 64975 && code < 65008) ||
    (code & 65535) === 65535 ||
    (code & 65535) === 65534 || // Out of range
    code > 1114111
  ) {
    return '\uFFFD'
  }

  return String.fromCharCode(code)
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-decode-string/index.js


const characterEscapeOrReference =
  /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi
/**
 * Utility to decode markdown strings (which occur in places such as fenced
 * code info strings, destinations, labels, and titles).
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 * @returns {string}
 */

function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode)
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */

function decode($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1
  } // Reference.

  const head = $2.charCodeAt(0)

  if (head === 35) {
    const head = $2.charCodeAt(1)
    const hex = head === 120 || head === 88
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10)
  }

  return decodeNamedCharacterReference($2) || $0
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-from-markdown/lib/index.js
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {Root|Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {UnistParent & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */

/**
 * @typedef _CompileDataFields
 * @property {boolean|undefined} expectingFirstListItemValue
 * @property {boolean|undefined} flowCodeInside
 * @property {boolean|undefined} setextHeadingSlurpLineEnding
 * @property {boolean|undefined} atHardBreak
 * @property {'collapsed'|'full'} referenceType
 * @property {boolean|undefined} inReference
 * @property {'characterReferenceMarkerHexadecimal'|'characterReferenceMarkerNumeric'} characterReferenceType
 *
 * @typedef {Record<string, unknown> & Partial<_CompileDataFields>} CompileData
 *
 * @typedef {(tree: Root) => Root|void} Transform
 * @typedef {(this: CompileContext, token: Token) => void} Handle
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 * @typedef {Record<string, Record<string, unknown>|Array<unknown>> & {canContainEols: Array<string>, transforms: Array<Transform>, enter: Handles, exit: Handles}} NormalizedExtension
 * @typedef {Partial<NormalizedExtension>} Extension
 *   An mdast extension changes how markdown tokens are turned into mdast.
 *
 * @typedef {(this: Omit<CompileContext, 'sliceSerialize'>, left: Token|undefined, right: Token) => void} OnEnterError
 * @typedef {(this: Omit<CompileContext, 'sliceSerialize'>, left: Token, right: Token) => void} OnExitError
 *
 * @typedef CompileContext
 *   mdast compiler context
 * @property {Array<Node | Fragment>} stack
 * @property {Array<[Token, OnEnterError|undefined]>} tokenStack
 * @property {(key: string, value?: unknown) => void} setData
 *   Set data into the key-value store.
 * @property {<K extends string>(key: K) => CompileData[K]} getData
 *   Get data from the key-value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<N extends Node>(this: CompileContext, node: N, token: Token, onError?: OnEnterError) => N} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {NormalizedExtension} config
 *   Configuration.
 *
 * @typedef {{mdastExtensions?: Array<Extension|Array<Extension>>}} FromMarkdownOptions
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 */









const lib_own = {}.hasOwnProperty
/**
 * @param value Markdown to parse (`string` or `Buffer`).
 * @param [encoding] Character encoding to understand `value` as when it’s a `Buffer` (`string`, default: `'utf8'`).
 * @param [options] Configuration
 */

const fromMarkdown =
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options) => Root) &
   *   ((value: Value, options?: Options) => Root)
   * )}
   */

  /**
   * @param {Value} value
   * @param {Encoding} [encoding]
   * @param {Options} [options]
   * @returns {Root}
   */
  function (value, encoding, options) {
    if (typeof encoding !== 'string') {
      options = encoding
      encoding = undefined
    }

    return compiler(options)(
      postprocess(
        parse(options).document().write(preprocess()(value, encoding, true))
      )
    )
  }
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options} [options]
 */

function compiler(options = {}) {
  /** @type {NormalizedExtension} */
  // @ts-expect-error: our base has all required fields, so the result will too.
  const config = configure(
    {
      transforms: [],
      canContainEols: [
        'emphasis',
        'fragment',
        'heading',
        'paragraph',
        'strong'
      ],
      enter: {
        autolink: opener(link),
        autolinkProtocol: onenterdata,
        autolinkEmail: onenterdata,
        atxHeading: opener(heading),
        blockQuote: opener(blockQuote),
        characterEscape: onenterdata,
        characterReference: onenterdata,
        codeFenced: opener(codeFlow),
        codeFencedFenceInfo: buffer,
        codeFencedFenceMeta: buffer,
        codeIndented: opener(codeFlow, buffer),
        codeText: opener(codeText, buffer),
        codeTextData: onenterdata,
        data: onenterdata,
        codeFlowValue: onenterdata,
        definition: opener(definition),
        definitionDestinationString: buffer,
        definitionLabelString: buffer,
        definitionTitleString: buffer,
        emphasis: opener(emphasis),
        hardBreakEscape: opener(hardBreak),
        hardBreakTrailing: opener(hardBreak),
        htmlFlow: opener(html, buffer),
        htmlFlowData: onenterdata,
        htmlText: opener(html, buffer),
        htmlTextData: onenterdata,
        image: opener(image),
        label: buffer,
        link: opener(link),
        listItem: opener(listItem),
        listItemValue: onenterlistitemvalue,
        listOrdered: opener(list, onenterlistordered),
        listUnordered: opener(list),
        paragraph: opener(paragraph),
        reference: onenterreference,
        referenceString: buffer,
        resourceDestinationString: buffer,
        resourceTitleString: buffer,
        setextHeading: opener(heading),
        strong: opener(strong),
        thematicBreak: opener(thematicBreak)
      },
      exit: {
        atxHeading: closer(),
        atxHeadingSequence: onexitatxheadingsequence,
        autolink: closer(),
        autolinkEmail: onexitautolinkemail,
        autolinkProtocol: onexitautolinkprotocol,
        blockQuote: closer(),
        characterEscapeValue: onexitdata,
        characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
        characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
        characterReferenceValue: onexitcharacterreferencevalue,
        codeFenced: closer(onexitcodefenced),
        codeFencedFence: onexitcodefencedfence,
        codeFencedFenceInfo: onexitcodefencedfenceinfo,
        codeFencedFenceMeta: onexitcodefencedfencemeta,
        codeFlowValue: onexitdata,
        codeIndented: closer(onexitcodeindented),
        codeText: closer(onexitcodetext),
        codeTextData: onexitdata,
        data: onexitdata,
        definition: closer(),
        definitionDestinationString: onexitdefinitiondestinationstring,
        definitionLabelString: onexitdefinitionlabelstring,
        definitionTitleString: onexitdefinitiontitlestring,
        emphasis: closer(),
        hardBreakEscape: closer(onexithardbreak),
        hardBreakTrailing: closer(onexithardbreak),
        htmlFlow: closer(onexithtmlflow),
        htmlFlowData: onexitdata,
        htmlText: closer(onexithtmltext),
        htmlTextData: onexitdata,
        image: closer(onexitimage),
        label: onexitlabel,
        labelText: onexitlabeltext,
        lineEnding: onexitlineending,
        link: closer(onexitlink),
        listItem: closer(),
        listOrdered: closer(),
        listUnordered: closer(),
        paragraph: closer(),
        referenceString: onexitreferencestring,
        resourceDestinationString: onexitresourcedestinationstring,
        resourceTitleString: onexitresourcetitlestring,
        resource: onexitresource,
        setextHeading: closer(onexitsetextheading),
        setextHeadingLineSequence: onexitsetextheadinglinesequence,
        setextHeadingText: onexitsetextheadingtext,
        strong: closer(),
        thematicBreak: closer()
      }
    },
    options.mdastExtensions || []
  )
  /** @type {CompileData} */

  const data = {}
  return compile
  /**
   * @param {Array<Event>} events
   * @returns {Root}
   */

  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    }
    /** @type {CompileContext['stack']} */

    const stack = [tree]
    /** @type {CompileContext['tokenStack']} */

    const tokenStack = []
    /** @type {Array<number>} */

    const listStack = []
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */

    const context = {
      stack,
      tokenStack,
      config,
      enter,
      exit,
      buffer,
      resume,
      setData,
      getData
    }
    let index = -1

    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (
        events[index][1].type === 'listOrdered' ||
        events[index][1].type === 'listUnordered'
      ) {
        if (events[index][0] === 'enter') {
          listStack.push(index)
        } else {
          const tail = listStack.pop()
          index = prepareList(events, tail, index)
        }
      }
    }

    index = -1

    while (++index < events.length) {
      const handler = config[events[index][0]]

      if (lib_own.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(
          Object.assign(
            {
              sliceSerialize: events[index][2].sliceSerialize
            },
            context
          ),
          events[index][1]
        )
      }
    }

    if (tokenStack.length > 0) {
      const tail = tokenStack[tokenStack.length - 1]
      const handler = tail[1] || defaultOnError
      handler.call(context, undefined, tail[0])
    } // Figure out `root` position.

    tree.position = {
      start: point(
        events.length > 0
          ? events[0][1].start
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      ),
      end: point(
        events.length > 0
          ? events[events.length - 2][1].end
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      )
    }
    index = -1

    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree
    }

    return tree
  }
  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */

  function prepareList(events, start, length) {
    let index = start - 1
    let containerBalance = -1
    let listSpread = false
    /** @type {Token|undefined} */

    let listItem
    /** @type {number|undefined} */

    let lineIndex
    /** @type {number|undefined} */

    let firstBlankLineIndex
    /** @type {boolean|undefined} */

    let atMarker

    while (++index <= length) {
      const event = events[index]

      if (
        event[1].type === 'listUnordered' ||
        event[1].type === 'listOrdered' ||
        event[1].type === 'blockQuote'
      ) {
        if (event[0] === 'enter') {
          containerBalance++
        } else {
          containerBalance--
        }

        atMarker = undefined
      } else if (event[1].type === 'lineEndingBlank') {
        if (event[0] === 'enter') {
          if (
            listItem &&
            !atMarker &&
            !containerBalance &&
            !firstBlankLineIndex
          ) {
            firstBlankLineIndex = index
          }

          atMarker = undefined
        }
      } else if (
        event[1].type === 'linePrefix' ||
        event[1].type === 'listItemValue' ||
        event[1].type === 'listItemMarker' ||
        event[1].type === 'listItemPrefix' ||
        event[1].type === 'listItemPrefixWhitespace'
      ) {
        // Empty.
      } else {
        atMarker = undefined
      }

      if (
        (!containerBalance &&
          event[0] === 'enter' &&
          event[1].type === 'listItemPrefix') ||
        (containerBalance === -1 &&
          event[0] === 'exit' &&
          (event[1].type === 'listUnordered' ||
            event[1].type === 'listOrdered'))
      ) {
        if (listItem) {
          let tailIndex = index
          lineIndex = undefined

          while (tailIndex--) {
            const tailEvent = events[tailIndex]

            if (
              tailEvent[1].type === 'lineEnding' ||
              tailEvent[1].type === 'lineEndingBlank'
            ) {
              if (tailEvent[0] === 'exit') continue

              if (lineIndex) {
                events[lineIndex][1].type = 'lineEndingBlank'
                listSpread = true
              }

              tailEvent[1].type = 'lineEnding'
              lineIndex = tailIndex
            } else if (
              tailEvent[1].type === 'linePrefix' ||
              tailEvent[1].type === 'blockQuotePrefix' ||
              tailEvent[1].type === 'blockQuotePrefixWhitespace' ||
              tailEvent[1].type === 'blockQuoteMarker' ||
              tailEvent[1].type === 'listItemIndent'
            ) {
              // Empty
            } else {
              break
            }
          }

          if (
            firstBlankLineIndex &&
            (!lineIndex || firstBlankLineIndex < lineIndex)
          ) {
            // @ts-expect-error Patched.
            listItem._spread = true
          } // Fix position.

          listItem.end = Object.assign(
            {},
            lineIndex ? events[lineIndex][1].start : event[1].end
          )
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]])
          index++
          length++
        } // Create a new list item.

        if (event[1].type === 'listItemPrefix') {
          listItem = {
            type: 'listItem',
            // @ts-expect-error Patched
            _spread: false,
            start: Object.assign({}, event[1].start)
          } // @ts-expect-error: `listItem` is most definitely defined, TS...

          events.splice(index, 0, ['enter', listItem, event[2]])
          index++
          length++
          firstBlankLineIndex = undefined
          atMarker = true
        }
      }
    } // @ts-expect-error Patched.

    events[start][1]._spread = listSpread
    return length
  }
  /**
   * @type {CompileContext['setData']}
   * @param [value]
   */

  function setData(key, value) {
    data[key] = value
  }
  /**
   * @type {CompileContext['getData']}
   * @template {string} K
   * @param {K} key
   * @returns {CompileData[K]}
   */

  function getData(key) {
    return data[key]
  }
  /**
   * @param {Point} d
   * @returns {Point}
   */

  function point(d) {
    return {
      line: d.line,
      column: d.column,
      offset: d.offset
    }
  }
  /**
   * @param {(token: Token) => Node} create
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function opener(create, and) {
    return open
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function open(token) {
      enter.call(this, create(token), token)
      if (and) and.call(this, token)
    }
  }
  /** @type {CompileContext['buffer']} */

  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    })
  }
  /**
   * @type {CompileContext['enter']}
   * @template {Node} N
   * @this {CompileContext}
   * @param {N} node
   * @param {Token} token
   * @param {OnEnterError} [errorHandler]
   * @returns {N}
   */

  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1]
    // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
    parent.children.push(node)
    this.stack.push(node)
    this.tokenStack.push([token, errorHandler]) // @ts-expect-error: `end` will be patched later.

    node.position = {
      start: point(token.start)
    }
    return node
  }
  /**
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function closer(and) {
    return close
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function close(token) {
      if (and) and.call(this, token)
      exit.call(this, token)
    }
  }
  /**
   * @type {CompileContext['exit']}
   * @this {CompileContext}
   * @param {Token} token
   * @param {OnExitError} [onExitError]
   * @returns {Node}
   */

  function exit(token, onExitError) {
    const node = this.stack.pop()
    const open = this.tokenStack.pop()

    if (!open) {
      throw new Error(
        'Cannot close `' +
          token.type +
          '` (' +
          stringifyPosition({
            start: token.start,
            end: token.end
          }) +
          '): it’s not open'
      )
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0])
      } else {
        const handler = open[1] || defaultOnError
        handler.call(this, token, open[0])
      }
    }

    node.position.end = point(token.end)
    return node
  }
  /**
   * @this {CompileContext}
   * @returns {string}
   */

  function resume() {
    return mdast_util_to_string_toString(this.stack.pop())
  } //
  // Handlers.
  //

  /** @type {Handle} */

  function onenterlistordered() {
    setData('expectingFirstListItemValue', true)
  }
  /** @type {Handle} */

  function onenterlistitemvalue(token) {
    if (getData('expectingFirstListItemValue')) {
      const ancestor =
        /** @type {List} */
        this.stack[this.stack.length - 2]
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10)
      setData('expectingFirstListItemValue')
    }
  }
  /** @type {Handle} */

  function onexitcodefencedfenceinfo() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.lang = data
  }
  /** @type {Handle} */

  function onexitcodefencedfencemeta() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.meta = data
  }
  /** @type {Handle} */

  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (getData('flowCodeInside')) return
    this.buffer()
    setData('flowCodeInside', true)
  }
  /** @type {Handle} */

  function onexitcodefenced() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '')
    setData('flowCodeInside')
  }
  /** @type {Handle} */

  function onexitcodeindented() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.value = data.replace(/(\r?\n|\r)$/g, '')
  }
  /** @type {Handle} */

  function onexitdefinitionlabelstring(token) {
    // Discard label, use the source content instead.
    const label = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
  }
  /** @type {Handle} */

  function onexitdefinitiontitlestring() {
    const data = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.title = data
  }
  /** @type {Handle} */

  function onexitdefinitiondestinationstring() {
    const data = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.url = data
  }
  /** @type {Handle} */

  function onexitatxheadingsequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1]

    if (!node.depth) {
      const depth = this.sliceSerialize(token).length
      node.depth = depth
    }
  }
  /** @type {Handle} */

  function onexitsetextheadingtext() {
    setData('setextHeadingSlurpLineEnding', true)
  }
  /** @type {Handle} */

  function onexitsetextheadinglinesequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1]
    node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2
  }
  /** @type {Handle} */

  function onexitsetextheading() {
    setData('setextHeadingSlurpLineEnding')
  }
  /** @type {Handle} */

  function onenterdata(token) {
    const parent =
      /** @type {Parent} */
      this.stack[this.stack.length - 1]
    /** @type {Node} */

    let tail = parent.children[parent.children.length - 1]

    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text() // @ts-expect-error: we’ll add `end` later.

      tail.position = {
        start: point(token.start)
      } // @ts-expect-error: Assume `parent` accepts `text`.

      parent.children.push(tail)
    }

    this.stack.push(tail)
  }
  /** @type {Handle} */

  function onexitdata(token) {
    const tail = this.stack.pop()
    tail.value += this.sliceSerialize(token)
    tail.position.end = point(token.end)
  }
  /** @type {Handle} */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1]

    // If we’re at a hard break, include the line ending in there.
    if (getData('atHardBreak')) {
      const tail = context.children[context.children.length - 1]
      tail.position.end = point(token.end)
      setData('atHardBreak')
      return
    }

    if (
      !getData('setextHeadingSlurpLineEnding') &&
      config.canContainEols.includes(context.type)
    ) {
      onenterdata.call(this, token)
      onexitdata.call(this, token)
    }
  }
  /** @type {Handle} */

  function onexithardbreak() {
    setData('atHardBreak', true)
  }
  /** @type {Handle} */

  function onexithtmlflow() {
    const data = this.resume()
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexithtmltext() {
    const data = this.resume()
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexitcodetext() {
    const data = this.resume()
    const node =
      /** @type {InlineCode} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexitlink() {
    const context =
      /** @type {Link & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference' // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut' // @ts-expect-error: mutate.

      delete context.url
      delete context.title
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier // @ts-expect-error: mutate.

      delete context.label
    }

    setData('referenceType')
  }
  /** @type {Handle} */

  function onexitimage() {
    const context =
      /** @type {Image & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference' // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut' // @ts-expect-error: mutate.

      delete context.url
      delete context.title
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier // @ts-expect-error: mutate.

      delete context.label
    }

    setData('referenceType')
  }
  /** @type {Handle} */

  function onexitlabeltext(token) {
    const ancestor =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 2]
    const string = this.sliceSerialize(token)
    ancestor.label = decodeString(string)
    ancestor.identifier = normalizeIdentifier(string).toLowerCase()
  }
  /** @type {Handle} */

  function onexitlabel() {
    const fragment =
      /** @type {Fragment} */
      this.stack[this.stack.length - 1]
    const value = this.resume()
    const node =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // Assume a reference.

    setData('inReference', true)

    if (node.type === 'link') {
      // @ts-expect-error: Assume static phrasing content.
      node.children = fragment.children
    } else {
      node.alt = value
    }
  }
  /** @type {Handle} */

  function onexitresourcedestinationstring() {
    const data = this.resume()
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1]
    node.url = data
  }
  /** @type {Handle} */

  function onexitresourcetitlestring() {
    const data = this.resume()
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1]
    node.title = data
  }
  /** @type {Handle} */

  function onexitresource() {
    setData('inReference')
  }
  /** @type {Handle} */

  function onenterreference() {
    setData('referenceType', 'collapsed')
  }
  /** @type {Handle} */

  function onexitreferencestring(token) {
    const label = this.resume()
    const node =
      /** @type {LinkReference|ImageReference} */
      this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
    setData('referenceType', 'full')
  }
  /** @type {Handle} */

  function onexitcharacterreferencemarker(token) {
    setData('characterReferenceType', token.type)
  }
  /** @type {Handle} */

  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token)
    const type = getData('characterReferenceType')
    /** @type {string} */

    let value

    if (type) {
      value = decodeNumericCharacterReference(
        data,
        type === 'characterReferenceMarkerNumeric' ? 10 : 16
      )
      setData('characterReferenceType')
    } else {
      // @ts-expect-error `decodeNamedCharacterReference` can return false for
      // invalid named character references, but everything we’ve tokenized is
      // valid.
      value = decodeNamedCharacterReference(data)
    }

    const tail = this.stack.pop()
    tail.value += value
    tail.position.end = point(token.end)
  }
  /** @type {Handle} */

  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token)
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1]
    node.url = this.sliceSerialize(token)
  }
  /** @type {Handle} */

  function onexitautolinkemail(token) {
    onexitdata.call(this, token)
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1]
    node.url = 'mailto:' + this.sliceSerialize(token)
  } //
  // Creaters.
  //

  /** @returns {Blockquote} */

  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    }
  }
  /** @returns {Code} */

  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    }
  }
  /** @returns {InlineCode} */

  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    }
  }
  /** @returns {Definition} */

  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    }
  }
  /** @returns {Emphasis} */

  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    }
  }
  /** @returns {Heading} */

  function heading() {
    // @ts-expect-error `depth` will be set later.
    return {
      type: 'heading',
      depth: undefined,
      children: []
    }
  }
  /** @returns {Break} */

  function hardBreak() {
    return {
      type: 'break'
    }
  }
  /** @returns {HTML} */

  function html() {
    return {
      type: 'html',
      value: ''
    }
  }
  /** @returns {Image} */

  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    }
  }
  /** @returns {Link} */

  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {List}
   */

  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      // @ts-expect-error Patched.
      spread: token._spread,
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {ListItem}
   */

  function listItem(token) {
    return {
      type: 'listItem',
      // @ts-expect-error Patched.
      spread: token._spread,
      checked: null,
      children: []
    }
  }
  /** @returns {Paragraph} */

  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    }
  }
  /** @returns {Strong} */

  function strong() {
    return {
      type: 'strong',
      children: []
    }
  }
  /** @returns {Text} */

  function text() {
    return {
      type: 'text',
      value: ''
    }
  }
  /** @returns {ThematicBreak} */

  function thematicBreak() {
    return {
      type: 'thematicBreak'
    }
  }
}
/**
 * @param {Extension} combined
 * @param {Array<Extension|Array<Extension>>} extensions
 * @returns {Extension}
 */

function configure(combined, extensions) {
  let index = -1

  while (++index < extensions.length) {
    const value = extensions[index]

    if (Array.isArray(value)) {
      configure(combined, value)
    } else {
      extension(combined, value)
    }
  }

  return combined
}
/**
 * @param {Extension} combined
 * @param {Extension} extension
 * @returns {void}
 */

function extension(combined, extension) {
  /** @type {string} */
  let key

  for (key in extension) {
    if (lib_own.call(extension, key)) {
      const list = key === 'canContainEols' || key === 'transforms'
      const maybe = lib_own.call(combined, key) ? combined[key] : undefined
      /* c8 ignore next */

      const left = maybe || (combined[key] = list ? [] : {})
      const right = extension[key]

      if (right) {
        if (list) {
          // @ts-expect-error: `left` is an array.
          combined[key] = [...left, ...right]
        } else {
          Object.assign(left, right)
        }
      }
    }
  }
}
/** @type {OnEnterError} */

function defaultOnError(left, right) {
  if (left) {
    throw new Error(
      'Cannot close `' +
        left.type +
        '` (' +
        stringifyPosition({
          start: left.start,
          end: left.end
        }) +
        '): a different token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is open'
    )
  } else {
    throw new Error(
      'Cannot close document, a token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is still open'
    )
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/remark-parse/lib/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */



/** @type {import('unified').Plugin<[Options?] | void[], string, Root>} */
function remarkParse(options) {
  /** @type {import('unified').ParserFunction<Root>} */
  const parser = (doc) => {
    // Assume options.
    const settings = /** @type {Options} */ (this.data('settings'))

    return fromMarkdown(
      doc,
      Object.assign({}, settings, options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data('micromarkExtensions') || [],
        mdastExtensions: this.data('fromMarkdownExtensions') || []
      })
    )
  }

  Object.assign(this, {Parser: parser})
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/remark-parse/index.js


/* harmony default export */ var remark_parse = (remarkParse);

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-builder/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist').Literal} Literal
 * @typedef {Object.<string, unknown>} Props
 * @typedef {Array.<Node>|string} ChildrenOrValue
 *
 * @typedef {(<T extends string, P extends Record<string, unknown>, C extends Node[]>(type: T, props: P, children: C) => {type: T, children: C} & P)} BuildParentWithProps
 * @typedef {(<T extends string, P extends Record<string, unknown>>(type: T, props: P, value: string) => {type: T, value: string} & P)} BuildLiteralWithProps
 * @typedef {(<T extends string, P extends Record<string, unknown>>(type: T, props: P) => {type: T} & P)} BuildVoidWithProps
 * @typedef {(<T extends string, C extends Node[]>(type: T, children: C) => {type: T, children: C})} BuildParent
 * @typedef {(<T extends string>(type: T, value: string) => {type: T, value: string})} BuildLiteral
 * @typedef {(<T extends string>(type: T) => {type: T})} BuildVoid
 */

var u = /**
 * @type {BuildVoid & BuildVoidWithProps & BuildLiteral & BuildLiteralWithProps & BuildParent & BuildParentWithProps}
 */ (
  /**
   * @param {string} type Type of node
   * @param {Props|ChildrenOrValue} [props] Additional properties for node (or `children` or `value`)
   * @param {ChildrenOrValue} [value] `children` or `value` of node
   * @returns {Node}
   */
  function (type, props, value) {
    /** @type {Node} */
    var node = {type: String(type)}

    if (
      (value === undefined || value === null) &&
      (typeof props === 'string' || Array.isArray(props))
    ) {
      value = props
    } else {
      Object.assign(node, props)
    }

    if (Array.isArray(value)) {
      node.children = value
    } else if (value !== undefined && value !== null) {
      node.value = String(value)
    }

    return node
  }
)

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-is/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {string} Type
 * @typedef {Object<string, unknown>} Props
 *
 * @typedef {null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>} Test
 */

/**
 * Check if a node passes a test
 *
 * @callback TestFunctionAnything
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean|void}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} X
 * @callback TestFunctionPredicate
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is X}
 */

/**
 * @callback AssertAnything
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} Y
 * @callback AssertPredicate
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is Y}
 */

const is =
  /**
   * Check if a node passes a test.
   * When a `parent` node is known the `index` of node should also be given.
   *
   * @type {(
   *   (<T extends Node>(node: unknown, test: T['type']|Partial<T>|TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|TestFunctionPredicate<T>>, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => node is T) &
   *   ((node?: unknown, test?: Test, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => boolean)
   * )}
   */
  (
    /**
     * Check if a node passes a test.
     * When a `parent` node is known the `index` of node should also be given.
     *
     * @param {unknown} [node] Node to check
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @param {number|null|undefined} [index] Position of `node` in `parent`
     * @param {Parent|null|undefined} [parent] Parent of `node`
     * @param {unknown} [context] Context object to invoke `test` with
     * @returns {boolean} Whether test passed and `node` is a `Node` (object with `type` set to non-empty `string`).
     */
    // eslint-disable-next-line max-params
    function is(node, test, index, parent, context) {
      const check = convert(test)

      if (
        index !== undefined &&
        index !== null &&
        (typeof index !== 'number' ||
          index < 0 ||
          index === Number.POSITIVE_INFINITY)
      ) {
        throw new Error('Expected positive finite index')
      }

      if (
        parent !== undefined &&
        parent !== null &&
        (!is(parent) || !parent.children)
      ) {
        throw new Error('Expected parent node')
      }

      if (
        (parent === undefined || parent === null) !==
        (index === undefined || index === null)
      ) {
        throw new Error('Expected both parent and index')
      }

      // @ts-expect-error Looks like a node.
      return node && node.type && typeof node.type === 'string'
        ? Boolean(check.call(context, node, index, parent))
        : false
    }
  )

const convert =
  /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * Generate an assertion from a check.
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  )
/**
 * @param {Array.<Type|Props|TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array.<AssertAnything>} */
  const checks = []
  let index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {unknown[]} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    let index = -1

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }

    return false
  }
}

/**
 * Utility to assert each property in `test` is represented in `node`, and each
 * values are strictly equal.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    let key

    for (key in check) {
      // @ts-expect-error: hush, it sure works as an index.
      if (node[key] !== check[key]) return false
    }

    return true
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 *
 * @param {Type} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {Array.<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(...parameters) {
    // @ts-expect-error: spreading is fine.
    return Boolean(check.call(this, ...parameters))
  }
}

// Utility to return true.
function ok() {
  return true
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-visit-parents/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-visit-parents/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types.js').Action} Action
 * @typedef {import('./complex-types.js').Index} Index
 * @typedef {import('./complex-types.js').ActionTuple} ActionTuple
 * @typedef {import('./complex-types.js').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */




/**
 * Continue traversing as normal
 */
const CONTINUE = true
/**
 * Do not traverse this node’s children
 */
const SKIP = 'skip'
/**
 * Stop traversing immediately
 */
const EXIT = false

/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param [reverse=false]
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor<Node>} visitor
     * @param {boolean} [reverse=false]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = convert(test)
      const step = reverse ? -1 : 1

      factory(tree, null, [])()

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {}
        /** @type {string|undefined} */
        let name

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents))

            if (result[0] === EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-visit/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */



/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        visitor = test
        test = null
      }

      visitParents(tree, test, overload, reverse)

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1]
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  )



;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-position/index.js
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {Record<string, unknown> & {type: string, position?: PositionLike|undefined}} NodeLike
 * @typedef {import('unist').Point} Point
 *
 * @typedef {Partial<Point>} PointLike
 *
 * @typedef PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 */

const pointStart = unist_util_position_point('start')
const pointEnd = unist_util_position_point('end')

/**
 * Get the positional info of `node`.
 *
 * @param {NodeLike|Node} [node]
 * @returns {Position}
 */
function unist_util_position_position(node) {
  return {start: pointStart(node), end: pointEnd(node)}
}

/**
 * Get the positional info of `node`.
 *
 * @param {'start'|'end'} type
 */
function unist_util_position_point(type) {
  return point

  /**
   * Get the positional info of `node`.
   *
   * @param {NodeLike|Node} [node]
   * @returns {Point}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {}

    return {
      line: point.line || null,
      column: point.column || null,
      offset: point.offset > -1 ? point.offset : null
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/unist-util-generated/index.js
/**
 * @typedef {Object} PointLike
 * @property {number} [line]
 * @property {number} [column]
 * @property {number} [offset]
 *
 * @typedef {Object} PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 *
 * @typedef {Object} NodeLike
 * @property {PositionLike} [position]
 */

/**
 * Check if `node` is *generated*.
 *
 * @param {NodeLike} [node]
 * @returns {boolean}
 */
function generated(node) {
  return (
    !node ||
    !node.position ||
    !node.position.start ||
    !node.position.start.line ||
    !node.position.start.column ||
    !node.position.end ||
    !node.position.end.line ||
    !node.position.end.column
  )
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/mdast-util-definitions/index.js
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 * @typedef {import('mdast').Definition} Definition
 */



const mdast_util_definitions_own = {}.hasOwnProperty

/**
 * Find definitions in `node`.
 * Uses CommonMark precedence, which means that earlier definitions are
 * preferred over duplicate later definitions.
 *
 * @param {Node} node
 */
function definitions(node) {
  /** @type {Record<string, Definition>} */
  const cache = Object.create(null)

  if (!node || !node.type) {
    throw new Error('mdast-util-definitions expected node')
  }

  visit(node, 'definition', (definition) => {
    const id = clean(definition.identifier)
    if (id && !mdast_util_definitions_own.call(cache, id)) {
      cache[id] = definition
    }
  })

  return definition

  /**
   * Get a node from the bound definition cache.
   *
   * @param {string} identifier
   * @returns {Definition|null}
   */
  function definition(identifier) {
    const id = clean(identifier)
    return id && mdast_util_definitions_own.call(cache, id) ? cache[id] : null
  }
}

/**
 * @param {string} [value]
 * @returns {string}
 */
function clean(value) {
  return String(value || '').toUpperCase()
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/traverse.js
/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('./index.js').H} H
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */



const traverse_own = {}.hasOwnProperty

/**
 * Transform an unknown node.
 * @type {Handler}
 * @param {MdastNode} node
 */
function unknown(h, node) {
  const data = node.data || {}

  if (
    'value' in node &&
    !(
      traverse_own.call(data, 'hName') ||
      traverse_own.call(data, 'hProperties') ||
      traverse_own.call(data, 'hChildren')
    )
  ) {
    return h.augment(node, u('text', node.value))
  }

  return h(node, 'div', traverse_all(h, node))
}

/**
 * @type {Handler}
 * @param {MdastNode} node
 */
function traverse_one(h, node, parent) {
  const type = node && node.type
  /** @type {Handler} */
  let fn

  // Fail on non-nodes.
  if (!type) {
    throw new Error('Expected node, got `' + node + '`')
  }

  if (traverse_own.call(h.handlers, type)) {
    fn = h.handlers[type]
  } else if (h.passThrough && h.passThrough.includes(type)) {
    fn = returnNode
  } else {
    fn = h.unknownHandler
  }

  return (typeof fn === 'function' ? fn : unknown)(h, node, parent)
}

/**
 * @type {Handler}
 * @param {MdastNode} node
 */
function returnNode(h, node) {
  // @ts-expect-error: Pass through custom node.
  return 'children' in node ? {...node, children: traverse_all(h, node)} : node
}

/**
 * @param {H} h
 * @param {MdastNode} parent
 */
function traverse_all(h, parent) {
  /** @type {Array<Content>} */
  const values = []

  if ('children' in parent) {
    const nodes = parent.children
    let index = -1

    while (++index < nodes.length) {
      const result = traverse_one(h, nodes[index], parent)

      if (result) {
        if (index && nodes[index - 1].type === 'break') {
          if (!Array.isArray(result) && result.type === 'text') {
            result.value = result.value.replace(/^\s+/, '')
          }

          if (!Array.isArray(result) && result.type === 'element') {
            const head = result.children[0]

            if (head && head.type === 'text') {
              head.value = head.value.replace(/^\s+/, '')
            }
          }
        }

        if (Array.isArray(result)) {
          values.push(...result)
        } else {
          values.push(result)
        }
      }
    }
  }

  return values
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-sanitize-uri/index.js



/**
 * Make a value safe for injection as a URL.
 *
 * This encodes unsafe characters with percent-encoding and skips already
 * encoded sequences (see `normalizeUri` below).
 * Further unsafe characters are encoded as character references (see
 * `micromark-util-encode`).
 *
 * Then, a regex of allowed protocols can be given, in which case the URL is
 * sanitized.
 * For example, `/^(https?|ircs?|mailto|xmpp)$/i` can be used for `a[href]`,
 * or `/^https?$/i` for `img[src]`.
 * If the URL includes an unknown protocol (one not matched by `protocol`, such
 * as a dangerous example, `javascript:`), the value is ignored.
 *
 * @param {string|undefined} url
 * @param {RegExp} [protocol]
 * @returns {string}
 */
function sanitizeUri(url, protocol) {
  const value = encode(normalizeUri(url || ''))

  if (!protocol) {
    return value
  }

  const colon = value.indexOf(':')
  const questionMark = value.indexOf('?')
  const numberSign = value.indexOf('#')
  const slash = value.indexOf('/')

  if (
    // If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))
  ) {
    return value
  }

  return ''
}
/**
 * Normalize a URL (such as used in definitions).
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 * @returns {string}
 */

function normalizeUri(value) {
  /** @type {Array<string>} */
  const result = []
  let index = -1
  let start = 0
  let skip = 0

  while (++index < value.length) {
    const code = value.charCodeAt(index)
    /** @type {string} */

    let replace = '' // A correct percent encoded value.

    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2
    } // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code)
      }
    } // Astral.
    else if (code > 55295 && code < 57344) {
      const next = value.charCodeAt(index + 1) // A correct surrogate pair.

      if (code < 56320 && next > 56319 && next < 57344) {
        replace = String.fromCharCode(code, next)
        skip = 1
      } // Lone surrogate.
      else {
        replace = '\uFFFD'
      }
    } // Unicode.
    else {
      replace = String.fromCharCode(code)
    }

    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace))
      start = index + skip + 1
      replace = ''
    }

    if (skip) {
      index += skip
      skip = 0
    }
  }

  return result.join('') + value.slice(start)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/wrap.js
/**
 * @typedef {import('./index.js').Content} Content
 */



/**
 * Wrap `nodes` with line feeds between each entry.
 * Optionally adds line feeds at the start and end.
 *
 * @param {Array<Content>} nodes
 * @param {boolean} [loose=false]
 * @returns {Array<Content>}
 */
function wrap_wrap(nodes, loose) {
  /** @type {Array<Content>} */
  const result = []
  let index = -1

  if (loose) {
    result.push(u('text', '\n'))
  }

  while (++index < nodes.length) {
    if (index) result.push(u('text', '\n'))
    result.push(nodes[index])
  }

  if (loose && nodes.length > 0) {
    result.push(u('text', '\n'))
  }

  return result
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/footer.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('./index.js').H} H
 */






/**
 * @param {H} h
 * @returns {Element|null}
 */
function footer(h) {
  let index = -1
  /** @type {Array<ElementContent>} */
  const listItems = []

  while (++index < h.footnoteOrder.length) {
    const def = h.footnoteById[h.footnoteOrder[index].toUpperCase()]

    if (!def) {
      continue
    }

    const content = traverse_all(h, def)
    const id = String(def.identifier)
    const safeId = normalizeUri(id.toLowerCase())
    let referenceIndex = 0
    /** @type {Array<ElementContent>} */
    const backReferences = []

    while (++referenceIndex <= h.footnoteCounts[id]) {
      /** @type {Element} */
      const backReference = {
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            h.clobberPrefix +
            'fnref-' +
            safeId +
            (referenceIndex > 1 ? '-' + referenceIndex : ''),
          dataFootnoteBackref: true,
          className: ['data-footnote-backref'],
          ariaLabel: h.footnoteBackLabel
        },
        children: [{type: 'text', value: '↩'}]
      }

      if (referenceIndex > 1) {
        backReference.children.push({
          type: 'element',
          tagName: 'sup',
          children: [{type: 'text', value: String(referenceIndex)}]
        })
      }

      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '})
      }

      backReferences.push(backReference)
    }

    const tail = content[content.length - 1]

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1]
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' '
      } else {
        tail.children.push({type: 'text', value: ' '})
      }

      tail.children.push(...backReferences)
    } else {
      content.push(...backReferences)
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: h.clobberPrefix + 'fn-' + safeId},
      children: wrap_wrap(content, true)
    }

    if (def.position) {
      listItem.position = def.position
    }

    listItems.push(listItem)
  }

  if (listItems.length === 0) {
    return null
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: h.footnoteLabelTagName,
        properties: {
          ...JSON.parse(JSON.stringify(h.footnoteLabelProperties)),
          id: 'footnote-label'
        },
        children: [u('text', h.footnoteLabel)]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: wrap_wrap(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {Blockquote} node
 */
function blockquote(h, node) {
  return h(node, 'blockquote', wrap_wrap(traverse_all(h, node), true))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Break} node
 * @returns {Array<Element|Text>}
 */
function hardBreak(h, node) {
  return [h(node, 'br'), u('text', '\n')]
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/code.js
/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Code} node
 */
function code(h, node) {
  const value = node.value ? node.value + '\n' : ''
  // To do: next major, use `node.lang` w/o regex, the splitting’s been going
  // on for years in remark now.
  const lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/)
  /** @type {Properties} */
  const props = {}

  if (lang) {
    props.className = ['language-' + lang]
  }

  const code = h(node, 'code', props, [u('text', value)])

  if (node.meta) {
    code.data = {meta: node.meta}
  }

  return h(node.position, 'pre', [code])
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/delete.js
/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Delete} node
 */
function strikethrough(h, node) {
  return h(node, 'del', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Emphasis} node
 */
function emphasis(h, node) {
  return h(node, 'em', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {FootnoteReference} node
 */
function footnoteReference(h, node) {
  const id = String(node.identifier)
  const safeId = normalizeUri(id.toLowerCase())
  const index = h.footnoteOrder.indexOf(id)
  /** @type {number} */
  let counter

  if (index === -1) {
    h.footnoteOrder.push(id)
    h.footnoteCounts[id] = 1
    counter = h.footnoteOrder.length
  } else {
    h.footnoteCounts[id]++
    counter = index + 1
  }

  const reuseCounter = h.footnoteCounts[id]

  return h(node, 'sup', [
    h(
      node.position,
      'a',
      {
        href: '#' + h.clobberPrefix + 'fn-' + safeId,
        id:
          h.clobberPrefix +
          'fnref-' +
          safeId +
          (reuseCounter > 1 ? '-' + reuseCounter : ''),
        dataFootnoteRef: true,
        ariaDescribedBy: 'footnote-label'
      },
      [u('text', String(counter))]
    )
  ])
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/footnote.js
/**
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../index.js').Handler} Handler
 *
 * @todo
 *   `footnote` (or “inline note”) are a pandoc footnotes feature (`^[a note]`)
 *   that does not exist in GFM.
 *   We still have support for it, so that things remain working with
 *   `micromark-extension-footnote` and `mdast-util-footnote`, but in the future
 *   we might be able to remove it?
 */



/**
 * @type {Handler}
 * @param {Footnote} node
 */
function footnote(h, node) {
  const footnoteById = h.footnoteById
  let no = 1

  while (no in footnoteById) no++

  const identifier = String(no)

  footnoteById[identifier] = {
    type: 'footnoteDefinition',
    identifier,
    children: [{type: 'paragraph', children: node.children}],
    position: node.position
  }

  return footnoteReference(h, {
    type: 'footnoteReference',
    identifier,
    position: node.position
  })
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/heading.js
/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Heading} node
 */
function heading(h, node) {
  return h(node, 'h' + node.depth, traverse_all(h, node))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/html.js
/**
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * Return either a `raw` node in dangerous mode, otherwise nothing.
 *
 * @type {Handler}
 * @param {HTML} node
 */
function html(h, node) {
  return h.dangerous ? h.augment(node, u('raw', node.value)) : null
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/revert.js
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */




/**
 * Return the content of a reference without definition as plain text.
 *
 * @type {Handler}
 * @param {ImageReference|LinkReference} node
 * @returns {Content|Array<Content>}
 */
function revert(h, node) {
  const subtype = node.referenceType
  let suffix = ']'

  if (subtype === 'collapsed') {
    suffix += '[]'
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']'
  }

  if (node.type === 'imageReference') {
    return u('text', '![' + node.alt + suffix)
  }

  const contents = traverse_all(h, node)
  const head = contents[0]

  if (head && head.type === 'text') {
    head.value = '[' + head.value
  } else {
    contents.unshift(u('text', '['))
  }

  const tail = contents[contents.length - 1]

  if (tail && tail.type === 'text') {
    tail.value += suffix
  } else {
    contents.push(u('text', suffix))
  }

  return contents
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {ImageReference} node
 */
function imageReference(h, node) {
  const def = h.definition(node.identifier)

  if (!def) {
    return revert(h, node)
  }

  /** @type {Properties} */
  const props = {src: normalizeUri(def.url || ''), alt: node.alt}

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title
  }

  return h(node, 'img', props)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/image.js
/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Image} node
 */
function image_image(h, node) {
  /** @type {Properties} */
  const props = {src: normalizeUri(node.url), alt: node.alt}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'img', props)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {InlineCode} node
 */
function inlineCode(h, node) {
  return h(node, 'code', [u('text', node.value.replace(/\r?\n|\r/g, ' '))])
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */





/**
 * @type {Handler}
 * @param {LinkReference} node
 */
function linkReference(h, node) {
  const def = h.definition(node.identifier)

  if (!def) {
    return revert(h, node)
  }

  /** @type {Properties} */
  const props = {href: normalizeUri(def.url || '')}

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title
  }

  return h(node, 'a', props, traverse_all(h, node))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/link.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {Link} node
 */
function link_link(h, node) {
  /** @type {Properties} */
  const props = {href: normalizeUri(node.url)}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'a', props, traverse_all(h, node))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/list-item.js
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */




/**
 * @type {Handler}
 * @param {ListItem} node
 * @param {List} parent
 */
function listItem(h, node, parent) {
  const result = traverse_all(h, node)
  const loose = parent ? listLoose(parent) : listItemLoose(node)
  /** @type {Properties} */
  const props = {}
  /** @type {Array<Content>} */
  const wrapped = []

  if (typeof node.checked === 'boolean') {
    /** @type {Element} */
    let paragraph

    if (
      result[0] &&
      result[0].type === 'element' &&
      result[0].tagName === 'p'
    ) {
      paragraph = result[0]
    } else {
      paragraph = h(null, 'p', [])
      result.unshift(paragraph)
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift(u('text', ' '))
    }

    paragraph.children.unshift(
      h(null, 'input', {
        type: 'checkbox',
        checked: node.checked,
        disabled: true
      })
    )

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    props.className = ['task-list-item']
  }

  let index = -1

  while (++index < result.length) {
    const child = result[index]

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      wrapped.push(u('text', '\n'))
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      wrapped.push(...child.children)
    } else {
      wrapped.push(child)
    }
  }

  const tail = result[result.length - 1]

  // Add a final eol.
  if (tail && (loose || !('tagName' in tail) || tail.tagName !== 'p')) {
    wrapped.push(u('text', '\n'))
  }

  return h(node, 'li', props, wrapped)
}

/**
 * @param {List} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = node.spread
  const children = node.children
  let index = -1

  while (!loose && ++index < children.length) {
    loose = listItemLoose(children[index])
  }

  return Boolean(loose)
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread

  return spread === undefined || spread === null
    ? node.children.length > 1
    : spread
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/list.js
/**
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {List} node
 * @returns {Element}
 */
function list_list(h, node) {
  /** @type {Properties} */
  const props = {}
  const name = node.ordered ? 'ol' : 'ul'
  const items = traverse_all(h, node)
  let index = -1

  if (typeof node.start === 'number' && node.start !== 1) {
    props.start = node.start
  }

  // Like GitHub, add a class for custom styling.
  while (++index < items.length) {
    const item = items[index]

    if (
      item.type === 'element' &&
      item.tagName === 'li' &&
      item.properties &&
      Array.isArray(item.properties.className) &&
      item.properties.className.includes('task-list-item')
    ) {
      props.className = ['contains-task-list']
      break
    }
  }

  return h(node, name, props, wrap_wrap(items, true))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Paragraph} node
 */
function paragraph(h, node) {
  return h(node, 'p', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/root.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../index.js').Handler} Handler
 */





/**
 * @type {Handler}
 * @param {Root} node
 */
function root(h, node) {
  // @ts-expect-error `root`s are also fine.
  return h.augment(node, u('root', wrap_wrap(traverse_all(h, node))))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/strong.js
/**
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Strong} node
 */
function strong(h, node) {
  return h(node, 'strong', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/table.js
/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */





/**
 * @type {Handler}
 * @param {Table} node
 */
function table(h, node) {
  const rows = node.children
  let index = -1
  const align = node.align || []
  /** @type {Array<Element>} */
  const result = []

  while (++index < rows.length) {
    const row = rows[index].children
    const name = index === 0 ? 'th' : 'td'
    /** @type {Array<Content>} */
    const out = []
    let cellIndex = -1
    const length = node.align ? align.length : row.length

    while (++cellIndex < length) {
      const cell = row[cellIndex]
      out.push(
        h(cell, name, {align: align[cellIndex]}, cell ? traverse_all(h, cell) : [])
      )
    }

    result[index] = h(rows[index], 'tr', wrap_wrap(out, true))
  }

  return h(
    node,
    'table',
    wrap_wrap(
      [h(result[0].position, 'thead', wrap_wrap([result[0]], true))].concat(
        result[1]
          ? h(
              {
                start: pointStart(result[1]),
                end: pointEnd(result[result.length - 1])
              },
              'tbody',
              wrap_wrap(result.slice(1), true)
            )
          : []
      ),
      true
    )
  )
}

;// CONCATENATED MODULE: ../../node_modules/trim-lines/index.js
const tab = 9 /* `\t` */
const space = 32 /* ` ` */

/**
 * Remove initial and final spaces and tabs at the line breaks in `value`.
 * Does not trim initial and final spaces and tabs of the value itself.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Trimmed value.
 */
function trimLines(value) {
  const source = String(value)
  const search = /\r?\n|\r/g
  let match = search.exec(source)
  let last = 0
  /** @type {Array<string>} */
  const lines = []

  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    )

    last = match.index + match[0].length
    match = search.exec(source)
  }

  lines.push(trimLine(source.slice(last), last > 0, false))

  return lines.join('')
}

/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */
function trimLine(value, start, end) {
  let startIndex = 0
  let endIndex = value.length

  if (start) {
    let code = value.codePointAt(startIndex)

    while (code === tab || code === space) {
      startIndex++
      code = value.codePointAt(startIndex)
    }
  }

  if (end) {
    let code = value.codePointAt(endIndex - 1)

    while (code === tab || code === space) {
      endIndex--
      code = value.codePointAt(endIndex - 1)
    }
  }

  return endIndex > startIndex ? value.slice(startIndex, endIndex) : ''
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/text.js
/**
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {Text} node
 */
function handlers_text_text(h, node) {
  return h.augment(node, u('text', trimLines(String(node.value))))
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
/**
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {ThematicBreak} [node]
 * @returns {Element}
 */
function thematic_break_thematicBreak(h, node) {
  return h(node, 'hr')
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/index.js























const handlers = {
  blockquote: blockquote,
  break: hardBreak,
  code: code,
  delete: strikethrough,
  emphasis: emphasis,
  footnoteReference: footnoteReference,
  footnote: footnote,
  heading: heading,
  html: html,
  imageReference: imageReference,
  image: image_image,
  inlineCode: inlineCode,
  linkReference: linkReference,
  link: link_link,
  listItem: listItem,
  list: list_list,
  paragraph: paragraph,
  root: root,
  strong: strong,
  table: table,
  text: handlers_text_text,
  thematicBreak: thematic_break_thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
}

// Return nothing for nodes that are ignored.
function ignore() {
  return null
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/index.js
/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('hast').Root|import('hast').Parent['children'][number]} HastNode
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} Content
 * @typedef {import('unist-util-position').PositionLike} PositionLike
 *
 * @typedef EmbeddedHastFields
 * @property {string} [hName]
 *   Defines the tag name of an element.
 * @property {Properties} [hProperties]
 *   Defines the properties of an element.
 * @property {Array<Content>} [hChildren]
 *   Defines the (hast) children of an element.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} Data
 *   unist data with embedded hast fields.
 *
 * @typedef {MdastNode & {data?: Data}} NodeWithData
 *   unist node with embedded hast data.
 *
 * @callback Handler
 *   Handle a node.
 * @param {H} h
 *   Handle context.
 * @param {any} node
 *   mdast node to handle.
 * @param {Parent|null} parent
 *   Parent of `node`.
 * @returns {Content|Array<Content>|null|undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 * @param {MdastNode|PositionLike|null|undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Properties} props
 *   Properties.
 * @param {Array<Content>?} [children]
 *   hast content.
 * @returns {Element}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 * @param {MdastNode|PositionLike|null|undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<Content>?} [children]
 *   hast content
 * @returns {Element}
 *   Compiled element.
 *
 * @typedef HFields
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {Properties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use to go back to a footnote call from the footnote section.
 * @property {(identifier: string) => Definition|null} definition
 *   Definition cache.
 * @property {Record<string, FootnoteDefinition>} footnoteById
 *   Footnote cache.
 * @property {Array<string>} footnoteOrder
 *   Order in which footnotes occur.
 * @property {Record<string, number>} footnoteCounts
 *   Counts the same footnote was used.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(left: NodeWithData|PositionLike|null|undefined, right: Content) => Content} augment
 *   Like `h` but lower-level and usable on non-elements.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [allowDangerousHtml=false]
 *   Whether to allow `html` nodes and inject them as `raw` HTML.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute to prevent it from *clobbering*.
 *   attributes.
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id=x></p>
 *   <script>alert(x)</script>
 *   ```
 *
 *   Elements by their ID are made available in browsers on the `window` object.
 *   Using a prefix prevents this from being a problem.
 * @property {string} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section.
 *   Affects screen reader users.
 *   Change it if you’re authoring in a different language.
 * @property {string} [footnoteLabelTagName='h2']
 *   HTML tag to use for the footnote label.
 *   Can be changed to match your document structure and play well with your choice of css.
 * @property {Properties} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label.
 *   A 'sr-only' class is added by default to hide this from sighted users.
 *   Change it to make the label visible, or add classes for other purposes.
 * @property {string} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call.
 *   Affects screen reader users.
 *   Change it if you’re authoring in a different language.
 * @property {Handlers} [handlers]
 *   Object mapping mdast nodes to functions handling them
 * @property {Array<string>} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast
 * @property {Handler} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Map of node types to handlers
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} H
 *   Handle context
 */










const mdast_util_to_hast_lib_own = {}.hasOwnProperty

/**
 * Turn mdast into hast.
 *
 * @param {MdastNode} tree
 *   mdast node.
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {H}
 *   `h` function.
 */
function factory(tree, options) {
  const settings = options || {}
  const dangerous = settings.allowDangerousHtml || false
  /** @type {Record<string, FootnoteDefinition>} */
  const footnoteById = {}

  h.dangerous = dangerous
  h.clobberPrefix =
    settings.clobberPrefix === undefined || settings.clobberPrefix === null
      ? 'user-content-'
      : settings.clobberPrefix
  h.footnoteLabel = settings.footnoteLabel || 'Footnotes'
  h.footnoteLabelTagName = settings.footnoteLabelTagName || 'h2'
  h.footnoteLabelProperties = settings.footnoteLabelProperties || {
    className: ['sr-only']
  }
  h.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content'
  h.definition = definitions(tree)
  h.footnoteById = footnoteById
  /** @type {Array<string>} */
  h.footnoteOrder = []
  /** @type {Record<string, number>} */
  h.footnoteCounts = {}
  h.augment = augment
  h.handlers = {...handlers, ...settings.handlers}
  h.unknownHandler = settings.unknownHandler
  h.passThrough = settings.passThrough

  visit(tree, 'footnoteDefinition', (definition) => {
    const id = String(definition.identifier).toUpperCase()

    // Mimick CM behavior of link definitions.
    // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
    if (!mdast_util_to_hast_lib_own.call(footnoteById, id)) {
      footnoteById[id] = definition
    }
  })

  // @ts-expect-error Hush, it’s fine!
  return h

  /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {(NodeWithData|PositionLike)?} left
   * @param {Content} right
   * @returns {Content}
   */
  function augment(left, right) {
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (left && 'data' in left && left.data) {
      /** @type {Data} */
      const data = left.data

      if (data.hName) {
        if (right.type !== 'element') {
          right = {
            type: 'element',
            tagName: '',
            properties: {},
            children: []
          }
        }

        right.tagName = data.hName
      }

      if (right.type === 'element' && data.hProperties) {
        right.properties = {...right.properties, ...data.hProperties}
      }

      if ('children' in right && right.children && data.hChildren) {
        right.children = data.hChildren
      }
    }

    if (left) {
      const ctx = 'type' in left ? left : {position: left}

      if (!generated(ctx)) {
        // @ts-expect-error: fine.
        right.position = {start: pointStart(ctx), end: pointEnd(ctx)}
      }
    }

    return right
  }

  /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */
  function h(node, tagName, props, children) {
    if (Array.isArray(props)) {
      children = props
      props = {}
    }

    // @ts-expect-error augmenting an element yields an element.
    return augment(node, {
      type: 'element',
      tagName,
      properties: props || {},
      children: children || []
    })
  }
}

/**
 * Transform `tree` (an mdast node) to a hast node.
 *
 * @param {MdastNode} tree mdast node
 * @param {Options} [options] Configuration
 * @returns {HastNode|null|undefined} hast node
 */
function toHast(tree, options) {
  const h = factory(tree, options)
  const node = traverse_one(h, tree, null)
  const foot = footer(h)

  if (foot) {
    // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push(u('text', '\n'), foot)
  }

  return Array.isArray(node) ? {type: 'root', children: node} : node
}



;// CONCATENATED MODULE: ../../node_modules/remark-rehype/lib/index.js
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */



// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(

/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */
const remarkRehype =
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  (
    function (destination, options) {
      return destination && 'run' in destination
        ? bridge(destination, options)
        : mutate(destination || options)
    }
  )

/* harmony default export */ var lib = (remarkRehype);

/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */
function bridge(destination, options) {
  return (node, file, next) => {
    destination.run(toHast(node, options), file, (error) => {
      next(error)
    })
  }
}

/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */
function mutate(options) {
  // @ts-expect-error: assume a corresponding node is returned by `toHast`.
  return (node) => toHast(node, options)
}

// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
Schema.prototype.property = {}
/** @type {Normal} */
Schema.prototype.normal = {}
/** @type {string|null} */
Schema.prototype.space = null

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new Schema(property, normal, space)
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function normalize_normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/info.js
class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
Info.prototype.space = null
Info.prototype.boolean = false
Info.prototype.booleanish = false
Info.prototype.overloadedBoolean = false
Info.prototype.number = false
Info.prototype.commaSeparated = false
Info.prototype.spaceSeparated = false
Info.prototype.commaOrSpaceSeparated = false
Info.prototype.mustUseProperty = false
Info.prototype.defined = false

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/types.js
let powers = 0

const types_boolean = increment()
const booleanish = increment()
const overloadedBoolean = increment()
const number = increment()
const spaceSeparated = increment()
const commaSeparated = increment()
const commaOrSpaceSeparated = increment()

function increment() {
  return 2 ** ++powers
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const checks = Object.keys(types_namespaceObject)

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index]
        mark(this, checks[index], (mask & types_namespaceObject[check]) === types_namespaceObject[check])
      }
    }
  }
}

DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const create_own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (create_own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[normalize_normalize(prop)] = prop
      normal[normalize_normalize(info.attribute)] = prop
    }
  }

  return new Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/xlink.js


const xlink = create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/xml.js


const xml = create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/xmlns.js



const xmlns = create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/aria.js



const aria = create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/html.js




const html_html = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: types_boolean,
    allowPaymentRequest: types_boolean,
    allowUserMedia: types_boolean,
    alt: null,
    as: null,
    async: types_boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: types_boolean,
    autoPlay: types_boolean,
    capture: types_boolean,
    charSet: null,
    checked: types_boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: types_boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: types_boolean,
    defer: types_boolean,
    dir: null,
    dirName: null,
    disabled: types_boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: types_boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: types_boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: types_boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: types_boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: types_boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: types_boolean,
    muted: types_boolean,
    name: null,
    nonce: null,
    noModule: types_boolean,
    noValidate: types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: types_boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: types_boolean,
    poster: null,
    preload: null,
    readOnly: types_boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: types_boolean,
    reversed: types_boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: types_boolean,
    seamless: types_boolean,
    selected: types_boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: types_boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: types_boolean, // `<frame>`
    noHref: types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: types_boolean,
    disableRemotePlayback: types_boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/svg.js




const svg = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const property_information_html = merge([xml, xlink, xmlns, aria, html_html], 'html')
const property_information_svg = merge([xml, xlink, xmlns, aria, svg], 'svg')

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/unist-util-is/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {string} Type
 * @typedef {Object<string, unknown>} Props
 *
 * @typedef {null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>} Test
 */

/**
 * Check if a node passes a test
 *
 * @callback TestFunctionAnything
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean|void}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} X
 * @callback TestFunctionPredicate
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is X}
 */

/**
 * @callback AssertAnything
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} Y
 * @callback AssertPredicate
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is Y}
 */

const unist_util_is_is =
  /**
   * Check if a node passes a test.
   * When a `parent` node is known the `index` of node should also be given.
   *
   * @type {(
   *   (<T extends Node>(node: unknown, test: T['type']|Partial<T>|TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|TestFunctionPredicate<T>>, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => node is T) &
   *   ((node?: unknown, test?: Test, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => boolean)
   * )}
   */
  (
    /**
     * Check if a node passes a test.
     * When a `parent` node is known the `index` of node should also be given.
     *
     * @param {unknown} [node] Node to check
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @param {number|null|undefined} [index] Position of `node` in `parent`
     * @param {Parent|null|undefined} [parent] Parent of `node`
     * @param {unknown} [context] Context object to invoke `test` with
     * @returns {boolean} Whether test passed and `node` is a `Node` (object with `type` set to non-empty `string`).
     */
    // eslint-disable-next-line max-params
    function is(node, test, index, parent, context) {
      const check = unist_util_is_convert(test)

      if (
        index !== undefined &&
        index !== null &&
        (typeof index !== 'number' ||
          index < 0 ||
          index === Number.POSITIVE_INFINITY)
      ) {
        throw new Error('Expected positive finite index')
      }

      if (
        parent !== undefined &&
        parent !== null &&
        (!is(parent) || !parent.children)
      ) {
        throw new Error('Expected parent node')
      }

      if (
        (parent === undefined || parent === null) !==
        (index === undefined || index === null)
      ) {
        throw new Error('Expected both parent and index')
      }

      // @ts-expect-error Looks like a node.
      return node && node.type && typeof node.type === 'string'
        ? Boolean(check.call(context, node, index, parent))
        : false
    }
  )

const unist_util_is_convert =
  /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * Generate an assertion from a check.
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return unist_util_is_ok
      }

      if (typeof test === 'string') {
        return unist_util_is_typeFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? unist_util_is_anyFactory(test) : unist_util_is_propsFactory(test)
      }

      if (typeof test === 'function') {
        return unist_util_is_castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  )
/**
 * @param {Array.<Type|Props|TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function unist_util_is_anyFactory(tests) {
  /** @type {Array.<AssertAnything>} */
  const checks = []
  let index = -1

  while (++index < tests.length) {
    checks[index] = unist_util_is_convert(tests[index])
  }

  return unist_util_is_castFactory(any)

  /**
   * @this {unknown}
   * @param {unknown[]} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    let index = -1

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }

    return false
  }
}

/**
 * Utility to assert each property in `test` is represented in `node`, and each
 * values are strictly equal.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function unist_util_is_propsFactory(check) {
  return unist_util_is_castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    let key

    for (key in check) {
      // @ts-expect-error: hush, it sure works as an index.
      if (node[key] !== check[key]) return false
    }

    return true
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 *
 * @param {Type} check
 * @returns {AssertAnything}
 */
function unist_util_is_typeFactory(check) {
  return unist_util_is_castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function unist_util_is_castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {Array.<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(...parameters) {
    // @ts-expect-error: spreading is fine.
    return Boolean(check.call(this, ...parameters))
  }
}

// Utility to return true.
function unist_util_is_ok() {
  return true
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/unist-util-visit-parents/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function color_browser_color(d) {
  return d
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/unist-util-visit-parents/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types.js').Action} Action
 * @typedef {import('./complex-types.js').Index} Index
 * @typedef {import('./complex-types.js').ActionTuple} ActionTuple
 * @typedef {import('./complex-types.js').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */




/**
 * Continue traversing as normal
 */
const unist_util_visit_parents_CONTINUE = true
/**
 * Do not traverse this node’s children
 */
const unist_util_visit_parents_SKIP = 'skip'
/**
 * Stop traversing immediately
 */
const unist_util_visit_parents_EXIT = false

/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param [reverse=false]
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const unist_util_visit_parents_visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor<Node>} visitor
     * @param {boolean} [reverse=false]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = unist_util_is_convert(test)
      const step = reverse ? -1 : 1

      factory(tree, null, [])()

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {}
        /** @type {string|undefined} */
        let name

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color_browser_color(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = unist_util_visit_parents_toResult(visitor(node, parents))

            if (result[0] === unist_util_visit_parents_EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== unist_util_visit_parents_SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === unist_util_visit_parents_EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function unist_util_visit_parents_toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [unist_util_visit_parents_CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/unist-util-visit/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */



/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const unist_util_visit_visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        visitor = test
        test = null
      }

      unist_util_visit_parents_visitParents(tree, test, overload, reverse)

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1]
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  )



;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/rehype-filter.js


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef Options
 * @property {Array<string>} [allowedElements]
 * @property {Array<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */

/**
 * @type {import('unified').Plugin<[Options], Root>}
 */
function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError(
      'Only one of `allowedElements` and `disallowedElements` should be defined'
    )
  }

  if (
    options.allowedElements ||
    options.disallowedElements ||
    options.allowElement
  ) {
    return (tree) => {
      unist_util_visit_visit(tree, 'element', (node, index, parent_) => {
        const parent = /** @type {Element|Root} */ (parent_)
        /** @type {boolean|undefined} */
        let remove

        if (options.allowedElements) {
          remove = !options.allowedElements.includes(node.tagName)
        } else if (options.disallowedElements) {
          remove = options.disallowedElements.includes(node.tagName)
        }

        if (!remove && options.allowElement && typeof index === 'number') {
          remove = !options.allowElement(node, index, parent)
        }

        if (remove && typeof index === 'number') {
          if (options.unwrapDisallowed && node.children) {
            parent.children.splice(index, 1, ...node.children)
          } else {
            parent.children.splice(index, 1)
          }

          return index
        }

        return undefined
      })
    }
  }
}

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(8570);
;// CONCATENATED MODULE: ../../node_modules/hast-util-whitespace/index.js
/**
 * @param {unknown} thing
 * @returns {boolean}
 */
function whitespace(thing) {
  /** @type {string} */
  var value =
    // @ts-ignore looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text'
      ? // @ts-ignore looks like a text.
        thing.value || ''
      : thing

  // HTML whitespace expression.
  // See <https://html.spec.whatwg.org/#space-character>.
  return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === ''
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const valid = /^data[-\w.:]+$/i
const dash = /-[a-z]/g
const cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find(schema, value) {
  const normal = normalize_normalize(value)
  let prop = value
  let Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/hast-to-react.js
/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */
const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/space-separated-tokens/index.js
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function space_separated_tokens_parse(value) {
  const input = String(value || '').trim()
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function stringify(values) {
  return values.join(' ').trim()
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/comma-separated-tokens/index.js
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */

/**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */

/**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function comma_separated_tokens_parse(value) {
  /** @type {Array<string>} */
  const tokens = []
  const input = String(value || '')
  let index = input.indexOf(',')
  let start = 0
  /** @type {boolean} */
  let end = false

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    const token = input.slice(start, index).trim()

    if (token || !end) {
      tokens.push(token)
    }

    start = index + 1
    index = input.indexOf(',', start)
  }

  return tokens
}

/**
 * Serialize an array of strings or numbers to comma-separated tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @param {Options} [options]
 *   Configuration for `stringify` (optional).
 * @returns {string}
 *   Comma-separated tokens.
 */
function comma_separated_tokens_stringify(values, options) {
  const settings = options || {}

  // Ensure the last empty entry is seen.
  const input = values[values.length - 1] === '' ? [...values, ''] : values

  return input
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

// EXTERNAL MODULE: ../../node_modules/react-markdown/node_modules/style-to-object/index.js
var style_to_object = __webpack_require__(6772);
;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/style-to-object/index.mjs


/* harmony default export */ var node_modules_style_to_object = (style_to_object);

;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/uri-transformer.js
const protocols = ['http', 'https', 'mailto', 'tel']

/**
 * @param {string} uri
 * @returns {string}
 */
function uriTransformer(uri) {
  const url = (uri || '').trim()
  const first = url.charAt(0)

  if (first === '#' || first === '/') {
    return url
  }

  const colon = url.indexOf(':')
  if (colon === -1) {
    return url
  }

  let index = -1

  while (++index < protocols.length) {
    const protocol = protocols[index]

    if (
      colon === protocol.length &&
      url.slice(0, protocol.length).toLowerCase() === protocol
    ) {
      return url
    }
  }

  index = url.indexOf('?')
  if (index !== -1 && colon > index) {
    return url
  }

  index = url.indexOf('#')
  if (index !== -1 && colon > index) {
    return url
  }

  // eslint-disable-next-line no-script-url
  return 'javascript:void(0)'
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/ast-to-react.js
/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */

/**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */










const ast_to_react_own = {}.hasOwnProperty

// The table-related elements that must not contain whitespace text according
// to React.
const tableElements = new Set(['table', 'thead', 'tbody', 'tfoot', 'tr'])

/**
 * @param {Context} context
 * @param {Element|Root} node
 */
function childrenToReact(context, node) {
  /** @type {Array<ReactNode>} */
  const children = []
  let childIndex = -1
  /** @type {Comment|Doctype|Element|Raw|Text} */
  let child

  while (++childIndex < node.children.length) {
    child = node.children[childIndex]

    if (child.type === 'element') {
      children.push(toReact(context, child, childIndex, node))
    } else if (child.type === 'text') {
      // Currently, a warning is triggered by react for *any* white space in
      // tables.
      // So we drop it.
      // See: <https://github.com/facebook/react/pull/7081>.
      // See: <https://github.com/facebook/react/pull/7515>.
      // See: <https://github.com/remarkjs/remark-react/issues/64>.
      // See: <https://github.com/remarkjs/react-markdown/issues/576>.
      if (
        node.type !== 'element' ||
        !tableElements.has(node.tagName) ||
        !whitespace(child)
      ) {
        children.push(child.value)
      }
    } else if (child.type === 'raw' && !context.options.skipHtml) {
      // Default behavior is to show (encoded) HTML.
      children.push(child.value)
    }
  }

  return children
}

/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */
function toReact(context, node, index, parent) {
  const options = context.options
  const transform =
    options.transformLinkUri === undefined
      ? uriTransformer
      : options.transformLinkUri
  const parentSchema = context.schema
  /** @type {ReactMarkdownNames} */
  // @ts-expect-error assume a known HTML/SVG element.
  const name = node.tagName
  /** @type {Record<string, unknown>} */
  const properties = {}
  let schema = parentSchema
  /** @type {string} */
  let property

  if (parentSchema.space === 'html' && name === 'svg') {
    schema = property_information_svg
    context.schema = schema
  }

  if (node.properties) {
    for (property in node.properties) {
      if (ast_to_react_own.call(node.properties, property)) {
        addProperty(properties, property, node.properties[property], context)
      }
    }
  }

  if (name === 'ol' || name === 'ul') {
    context.listDepth++
  }

  const children = childrenToReact(context, node)

  if (name === 'ol' || name === 'ul') {
    context.listDepth--
  }

  // Restore parent schema.
  context.schema = parentSchema

  // Nodes created by plugins do not have positional info, in which case we use
  // an object that matches the position interface.
  const position = node.position || {
    start: {line: null, column: null, offset: null},
    end: {line: null, column: null, offset: null}
  }
  const component =
    options.components && ast_to_react_own.call(options.components, name)
      ? options.components[name]
      : name
  const basic = typeof component === 'string' || component === react.Fragment

  if (!react_is.isValidElementType(component)) {
    throw new TypeError(
      `Component for name \`${name}\` not defined or is not renderable`
    )
  }

  properties.key = index

  if (name === 'a' && options.linkTarget) {
    properties.target =
      typeof options.linkTarget === 'function'
        ? options.linkTarget(
            String(properties.href || ''),
            node.children,
            typeof properties.title === 'string' ? properties.title : null
          )
        : options.linkTarget
  }

  if (name === 'a' && transform) {
    properties.href = transform(
      String(properties.href || ''),
      node.children,
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (
    !basic &&
    name === 'code' &&
    parent.type === 'element' &&
    parent.tagName !== 'pre'
  ) {
    properties.inline = true
  }

  if (
    !basic &&
    (name === 'h1' ||
      name === 'h2' ||
      name === 'h3' ||
      name === 'h4' ||
      name === 'h5' ||
      name === 'h6')
  ) {
    properties.level = Number.parseInt(name.charAt(1), 10)
  }

  if (name === 'img' && options.transformImageUri) {
    properties.src = options.transformImageUri(
      String(properties.src || ''),
      String(properties.alt || ''),
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (!basic && name === 'li' && parent.type === 'element') {
    const input = getInputElement(node)
    properties.checked =
      input && input.properties ? Boolean(input.properties.checked) : null
    properties.index = getElementsBeforeCount(parent, node)
    properties.ordered = parent.tagName === 'ol'
  }

  if (!basic && (name === 'ol' || name === 'ul')) {
    properties.ordered = name === 'ol'
    properties.depth = context.listDepth
  }

  if (name === 'td' || name === 'th') {
    if (properties.align) {
      if (!properties.style) properties.style = {}
      // @ts-expect-error assume `style` is an object
      properties.style.textAlign = properties.align
      delete properties.align
    }

    if (!basic) {
      properties.isHeader = name === 'th'
    }
  }

  if (!basic && name === 'tr' && parent.type === 'element') {
    properties.isHeader = Boolean(parent.tagName === 'thead')
  }

  // If `sourcePos` is given, pass source information (line/column info from markdown source).
  if (options.sourcePos) {
    properties['data-sourcepos'] = flattenPosition(position)
  }

  if (!basic && options.rawSourcePos) {
    properties.sourcePosition = node.position
  }

  // If `includeElementIndex` is given, pass node index info to components.
  if (!basic && options.includeElementIndex) {
    properties.index = getElementsBeforeCount(parent, node)
    properties.siblingCount = getElementsBeforeCount(parent)
  }

  if (!basic) {
    properties.node = node
  }

  // Ensure no React warnings are emitted for void elements w/ children.
  return children.length > 0
    ? react.createElement(component, properties, children)
    : react.createElement(component, properties)
}

/**
 * @param {Element|Root} node
 * @returns {Element?}
 */
function getInputElement(node) {
  let index = -1

  while (++index < node.children.length) {
    const child = node.children[index]

    if (child.type === 'element' && child.tagName === 'input') {
      return child
    }
  }

  return null
}

/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */
function getElementsBeforeCount(parent, node) {
  let index = -1
  let count = 0

  while (++index < parent.children.length) {
    if (parent.children[index] === node) break
    if (parent.children[index].type === 'element') count++
  }

  return count
}

/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */
function addProperty(props, prop, value, ctx) {
  const info = find(ctx.schema, prop)
  let result = value

  // Ignore nullish and `NaN` values.
  // eslint-disable-next-line no-self-compare
  if (result === null || result === undefined || result !== result) {
    return
  }

  // Accept `array`.
  // Most props are space-separated.
  if (Array.isArray(result)) {
    result = info.commaSeparated ? comma_separated_tokens_stringify(result) : stringify(result)
  }

  if (info.property === 'style' && typeof result === 'string') {
    result = parseStyle(result)
  }

  if (info.space && info.property) {
    props[
      ast_to_react_own.call(hastToReact, info.property)
        ? hastToReact[info.property]
        : info.property
    ] = result
  } else if (info.attribute) {
    props[info.attribute] = result
  }
}

/**
 * @param {string} value
 * @returns {Record<string, string>}
 */
function parseStyle(value) {
  /** @type {Record<string, string>} */
  const result = {}

  try {
    node_modules_style_to_object(value, iterator)
  } catch {
    // Silent.
  }

  return result

  /**
   * @param {string} name
   * @param {string} v
   */
  function iterator(name, v) {
    const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name
    result[k.replace(/-([a-z])/g, styleReplacer)] = v
  }
}

/**
 * @param {unknown} _
 * @param {string} $1
 */
function styleReplacer(_, $1) {
  return $1.toUpperCase()
}

/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */
function flattenPosition(pos) {
  return [
    pos.start.line,
    ':',
    pos.start.column,
    '-',
    pos.end.line,
    ':',
    pos.end.column
  ]
    .map(String)
    .join('')
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/react-markdown.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */











const react_markdown_own = {}.hasOwnProperty
const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md'

/** @type {Record<string, Deprecation>} */
const deprecated = {
  plugins: {to: 'remarkPlugins', id: 'change-plugins-to-remarkplugins'},
  renderers: {to: 'components', id: 'change-renderers-to-components'},
  astPlugins: {id: 'remove-buggy-html-in-markdown-parser'},
  allowDangerousHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  escapeHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  source: {to: 'children', id: 'change-source-to-children'},
  allowNode: {
    to: 'allowElement',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  allowedTypes: {
    to: 'allowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  disallowedTypes: {
    to: 'disallowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  includeNodeIndex: {
    to: 'includeElementIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  }
}

/**
 * React component to render markdown.
 *
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */
function ReactMarkdown(options) {
  for (const key in deprecated) {
    if (react_markdown_own.call(deprecated, key) && react_markdown_own.call(options, key)) {
      const deprecation = deprecated[key]
      console.warn(
        `[react-markdown] Warning: please ${
          deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'
        } \`${key}\` (see <${changelog}#${deprecation.id}> for more info)`
      )
      delete deprecated[key]
    }
  }

  const processor = unified()
    .use(remark_parse)
    .use(options.remarkPlugins || [])
    .use(lib, {
      ...options.remarkRehypeOptions,
      allowDangerousHtml: true
    })
    .use(options.rehypePlugins || [])
    .use(rehypeFilter, options)

  const file = new VFile()

  if (typeof options.children === 'string') {
    file.value = options.children
  } else if (options.children !== undefined && options.children !== null) {
    console.warn(
      `[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`
    )
  }

  const hastNode = processor.runSync(processor.parse(file), file)

  if (hastNode.type !== 'root') {
    throw new TypeError('Expected a `root` node')
  }

  /** @type {ReactElement} */
  let result = react.createElement(
    react.Fragment,
    {},
    childrenToReact({options, schema: property_information_html, listDepth: 0}, hastNode)
  )

  if (options.className) {
    result = react.createElement('div', {className: options.className}, result)
  }

  return result
}

ReactMarkdown.propTypes = {
  // Core options:
  children: prop_types.string,
  // Layout options:
  className: prop_types.string,
  // Filter options:
  allowElement: prop_types.func,
  allowedElements: prop_types.arrayOf(prop_types.string),
  disallowedElements: prop_types.arrayOf(prop_types.string),
  unwrapDisallowed: prop_types.bool,
  // Plugin options:
  remarkPlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: prop_types.bool,
  rawSourcePos: prop_types.bool,
  skipHtml: prop_types.bool,
  includeElementIndex: prop_types.bool,
  transformLinkUri: prop_types.oneOfType([prop_types.func, prop_types.bool]),
  linkTarget: prop_types.oneOfType([prop_types.func, prop_types.string]),
  transformImageUri: prop_types.func,
  components: prop_types.object
}


/***/ }),

/***/ 9381:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J$": function() { return /* binding */ dist_SWRConfig; },
  "ZP": function() { return /* binding */ useSWR; }
});

// UNUSED EXPORTS: mutate, preload, unstable_serialize, useSWRConfig

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(3100);
;// CONCATENATED MODULE: ../../node_modules/swr/_internal/dist/index.mjs


// Global state used to deduplicate requests and store listeners
const SWRGlobalState = new WeakMap();

const EMPTY_CACHE = {};
const INITIAL_CACHE = {};
const noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const UNDEFINED = /*#__NOINLINE__*/ noop();
const OBJECT = Object;
const isUndefined = (v)=>v === UNDEFINED;
const isFunction = (v)=>typeof v == 'function';
const mergeObjects = (a, b)=>({
        ...a,
        ...b
    });
const STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const isWindowDefined = typeof window != STR_UNDEFINED;
const isDocumentDefined = typeof document != STR_UNDEFINED;
const hasRequestAnimationFrame = ()=>isWindowDefined && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
const createCacheHelper = (cache, key)=>{
    const state = SWRGlobalState.get(cache);
    return [
        // Getter
        ()=>!isUndefined(key) && cache.get(key) || EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!isUndefined(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in INITIAL_CACHE)) {
                    INITIAL_CACHE[key] = prev;
                }
                state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!isUndefined(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in INITIAL_CACHE) return INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !isUndefined(key) && cache.get(key) || EMPTY_CACHE;
        }
    ];
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const table = new WeakMap();
// counter of the key
let counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const stableHash = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++){
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            const keys = OBJECT.keys(arg).sort();
            while(!isUndefined(index = keys.pop())){
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    } else {
        result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    }
    return result;
};

/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let online = true;
const isOnline = ()=>online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [onWindowEvent, offWindowEvent] = isWindowDefined && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    noop,
    noop
];
const isVisible = ()=>{
    const visibilityState = isDocumentDefined && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
const initFocus = (callback)=>{
    // focus revalidate
    if (isDocumentDefined) {
        document.addEventListener('visibilitychange', callback);
    }
    onWindowEvent('focus', callback);
    return ()=>{
        if (isDocumentDefined) {
            document.removeEventListener('visibilitychange', callback);
        }
        offWindowEvent('focus', callback);
    };
};
const initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return ()=>{
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
const preset = {
    isOnline,
    isVisible
};
const defaultConfigOptions = {
    initFocus,
    initReconnect
};

const IS_REACT_LEGACY = !react.useId;
const IS_SERVER = !isWindowDefined || 'Deno' in window;
// Polyfill requestAnimationFrame
const rAF = (f)=>hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const useIsomorphicLayoutEffect = IS_SERVER ? react.useEffect : react.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
const navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const slowConnection = !IS_SERVER && navigatorConnection && ([
    'slow-2g',
    '2g'
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData);

const dist_serialize = (key)=>{
    if (isFunction(key)) {
        try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : '';
    return [
        key,
        args
    ];
};

// Global timestamp.
let __timestamp = 0;
const getTimestamp = ()=>++__timestamp;

const FOCUS_EVENT = 0;
const RECONNECT_EVENT = 1;
const MUTATE_EVENT = 2;
const ERROR_REVALIDATE_EVENT = 3;

var constants = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: ERROR_REVALIDATE_EVENT,
  FOCUS_EVENT: FOCUS_EVENT,
  MUTATE_EVENT: MUTATE_EVENT,
  RECONNECT_EVENT: RECONNECT_EVENT
};

async function internalMutate(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = mergeObjects({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if (isFunction(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for(let keyIt = it.next(); !keyIt.done; keyIt = it.next()){
            const key = keyIt.value;
            if (// Skip the special useSWRInfinite and useSWRSubscription keys.
            !/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) {
                matchedKeys.push(key);
            }
        }
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = dist_serialize(_k);
        if (!key) return;
        const [get, set] = createCacheHelper(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH] = SWRGlobalState.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                if (revalidators && revalidators[0]) {
                    return revalidators[0](MUTATE_EVENT).then(()=>get().data);
                }
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) {
            // Revalidate and broadcast state.
            return startRevalidate();
        }
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = getTimestamp();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !isUndefined(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = isUndefined(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = isFunction(optimisticData) ? optimisticData(committedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if (isFunction(data)) {
            // `data` is a function, call it passing current cache value.
            try {
                data = data(committedData);
            } catch (err) {
                // If it throws an error synchronously, we shouldn't update the cache.
                error = err;
            }
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && isFunction(data.then)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if (isFunction(populateCache)) {
                    data = populateCache(data, committedData);
                }
                // Only update cached data if there's no error. Data can be `undefined` here.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = getTimestamp();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: UNDEFINED
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}

const revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators){
        if (revalidators[key][0]) revalidators[key][0](type);
    }
};
const initCache = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        const opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = internalMutate.bind(UNDEFINED, provider);
        let unmount = noop;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) {
                for (const fn of subs){
                    fn(value, prev);
                }
            }
        };
        const initProvider = ()=>{
            if (!SWRGlobalState.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                SWRGlobalState.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!IS_SERVER) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        SWRGlobalState.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        SWRGlobalState.get(provider)[4]
    ];
};

// error retry
const onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
const compare = (currentData, newData)=>stableHash(currentData) == stableHash(newData);
// Default cache provider
const [cache, mutate] = initCache(new Map());
// Default config
const defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare,
    isPaused: ()=>false,
    cache,
    mutate,
    fallback: {}
}, // use web preset by default
preset);

const mergeConfigs = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1 , fallback: f1  } = a;
        const { use: u2 , fallback: f2  } = b;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

const SWRConfigContext = (0,react.createContext)({});
const SWRConfig = (props)=>{
    const { value  } = props;
    const parentConfig = (0,react.useContext)(SWRConfigContext);
    const isFunctionalConfig = isFunction(value);
    const config = (0,react.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0,react.useMemo)(()=>isFunctionalConfig ? config : mergeConfigs(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0,react.useRef)(UNDEFINED);
    if (provider && !cacheContextRef.current) {
        cacheContextRef.current = initCache(provider(extendedConfig.cache || cache), config);
    }
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0,react.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

// @ts-expect-error
const enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__;
const use = enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const setupDevTools = ()=>{
    if (enableDevtools) {
        // @ts-expect-error
        window.__SWR_DEVTOOLS_REACT__ = react;
    }
};

const normalize = (args)=>{
    return isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};

const useSWRConfig = ()=>{
    return mergeObjects(defaultConfig, (0,react.useContext)(SWRConfigContext));
};

const preload = (key_, fetcher)=>{
    const [key, fnArg] = dist_serialize(key_);
    const [, , , PRELOAD] = SWRGlobalState.get(cache);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = dist_serialize(key_);
            const [, , , PRELOAD] = SWRGlobalState.get(cache);
            const req = PRELOAD[key];
            if (req) {
                delete PRELOAD[key];
                return req;
            }
            return fetcher_(...args);
        });
        return useSWRNext(key_, fetcher, config);
    };

const BUILT_IN_MIDDLEWARE = use.concat(middleware);

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const withArgs = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = useSWRConfig();
        // Normalize arguments.
        const [key, fn, _config] = normalize(args);
        // Merge configurations.
        const config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use  } = config;
        const middleware = (use || []).concat(BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;){
            next = middleware[i](next);
        }
        return next(key, fn || config.fetcher || null, config);
    };
};

/**
 * An implementation of state with dependency-tracking.
 */ const useStateWithDeps = (state)=>{
    const rerender = useState({})[1];
    const unmountedRef = useRef(false);
    const stateRef = useRef(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = useRef({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = useCallback((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if (IS_REACT_LEGACY) {
                rerender({});
            } else {
                React.startTransition(()=>rerender({}));
            }
        }
    }, // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    useIsomorphicLayoutEffect(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const subscribeCallback = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

// Create a custom hook with a middleware
const withMiddleware = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = normalize(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};

setupDevTools();



;// CONCATENATED MODULE: ../../node_modules/swr/core/dist/index.mjs





const WITH_DEDUPE = {
    dedupe: true
};
const useSWRHandler = (_key, fetcher, config)=>{
    const { cache , compare , suspense , fallbackData , revalidateOnMount , revalidateIfStale , refreshInterval , refreshWhenHidden , refreshWhenOffline , keepPreviousData  } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH] = SWRGlobalState.get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = dist_serialize(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0,react.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0,react.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0,react.useRef)(key);
    const fetcherRef = (0,react.useRef)(fetcher);
    const configRef = (0,react.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = createCacheHelper(cache, key);
    const stateDependencies = (0,react.useRef)({}).current;
    const fallback = isUndefined(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!isUndefined(prev[t])) {
                        return false;
                    }
                    if (!compare(returnedData, current[t])) {
                        return false;
                    }
                }
            } else {
                if (current[t] !== prev[t]) {
                    return false;
                }
            }
        }
        return true;
    };
    const getSnapshot = (0,react.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!isUndefined(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!isUndefined(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = mergeObjects(state);
            delete snapshot._k;
            if (!shouldStartRequest) {
                return snapshot;
            }
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0,shim.useSyncExternalStore)((0,react.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = isUndefined(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0,react.useRef)(data);
    const returnedData = keepPreviousData ? isUndefined(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !isUndefined(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return isUndefined(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return isUndefined(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = isUndefined(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = isUndefined(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0,react.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) {
            return false;
        }
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (IS_REACT_LEGACY) {
                return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            }
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) {
                delete FETCH[key];
            }
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if (isUndefined(getCache().data)) {
            initialState.isLoading = true;
        }
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && isUndefined(getCache().data)) {
                    setTimeout(()=>{
                        if (loading && callbackSafeguard()) {
                            getConfig().onLoadingSlow(key, config);
                        }
                    }, config.loadingTimeout);
                }
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    getTimestamp()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) {
                // If the request isn't interrupted, clean it up after the
                // deduplication interval.
                setTimeout(cleanupState, config.dedupingInterval);
            }
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Clear error.
            finalState.error = UNDEFINED;
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!isUndefined(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) {
                    getConfig().onSuccess(newData, key, config);
                }
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError  } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || isFunction(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) {
                            // If it's inactive, stop. It will auto-revalidate when
                            // refocusing or reconnecting.
                            // When retrying, deduplication is always enabled.
                            currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                                const revalidators = EVENT_REVALIDATORS[key];
                                if (revalidators && revalidators[0]) {
                                    revalidators[0](constants.ERROR_REVALIDATE_EVENT, _opts);
                                }
                            }, {
                                retryCount: (opts.retryCount || 0) + 1,
                                dedupe: true
                            });
                        }
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0,react.useCallback)(// Use callback to make sure `keyRef.current` returns latest result every time
    (...args)=>{
        return internalMutate(cache, keyRef.current, ...args);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // The logic for updating refs.
    useIsomorphicLayoutEffect(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!isUndefined(cachedData)) {
            laggyDataRef.current = cachedData;
        }
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == constants.FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == constants.RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            } else if (type == constants.MUTATE_EVENT) {
                return revalidate();
            } else if (type == constants.ERROR_REVALIDATE_EVENT) {
                return revalidate(opts);
            }
            return;
        };
        const unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation.
        if (shouldDoInitialRevalidation) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            } else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    useIsomorphicLayoutEffect(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = isFunction(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            } else {
                // Schedule the next interval to check again.
                next();
            }
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0,react.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!IS_REACT_LEGACY && IS_SERVER) {
            throw new Error('Fallback data is required when using suspense in SSR.');
        }
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const dist_SWRConfig = OBJECT.defineProperty(SWRConfig, 'defaultValue', {
    value: defaultConfig
});
const unstable_serialize = (key)=>serialize(key)[0];
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const useSWR = withArgs(useSWRHandler);

// useSWR




/***/ }),

/***/ 624:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ../../node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(1110);
;// CONCATENATED MODULE: ../../node_modules/zustand/esm/index.mjs





const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
function useStore(api, selector = api.getState, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getState,
    selector,
    equalityFn
  );
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ }),

/***/ 2532:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ shallow; }
/* harmony export */ });
/* unused harmony export default */
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size)
      return false;
    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) {
        return false;
      }
    }
    return true;
  }
  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size)
      return false;
    for (const value of objA) {
      if (!objB.has(value)) {
        return false;
      }
    }
    return true;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
var shallow$1 = (objA, objB) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { shallow } from 'zustand/shallow'`."
    );
  }
  return shallow(objA, objB);
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(1517), __webpack_exec__(6570), __webpack_exec__(5876); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);